
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jTg1q", function(module, exports) {
parcelRequire("evzEb");
module.exports = angular;

});
parcelRegister("evzEb", function(module, exports) {
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1) {
    "use strict";
    /* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/ var minErrConfig = {
        objectMaxDepth: 5,
        urlErrorParamsEnabled: true
    };
    /**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 *
 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
 *   generated error url is very long.
 *
 *   Default: true. When used without argument, it returns the current value.
 */ function errorHandlingConfig(config) {
        if (isObject(config)) {
            if (isDefined(config.objectMaxDepth)) minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
            if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
        } else return minErrConfig;
    }
    /**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */ function isValidObjectMaxDepth(maxDepth) {
        return isNumber(maxDepth) && maxDepth > 0;
    }
    /**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace'). Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */ function minErr(module, ErrorConstructor) {
        ErrorConstructor = ErrorConstructor || Error;
        var url = "https://errors.angularjs.org/1.8.3/";
        var regex = url.replace(".", "\\.") + "[\\s\\S]*";
        var errRegExp = new RegExp(regex, "g");
        return function() {
            var code = arguments[0], template = arguments[1], message = "[" + (module ? module + ":" : "") + code + "] ", templateArgs = sliceArgs(arguments, 2).map(function(arg) {
                return toDebugString(arg, minErrConfig.objectMaxDepth);
            }), paramPrefix, i;
            // A minErr message has two parts: the message itself and the url that contains the
            // encoded message.
            // The message's parameters can contain other error messages which also include error urls.
            // To prevent the messages from getting too long, we strip the error urls from the parameters.
            message += template.replace(/\{\d+\}/g, function(match) {
                var index = +match.slice(1, -1);
                if (index < templateArgs.length) return templateArgs[index].replace(errRegExp, "");
                return match;
            });
            message += "\n" + url + (module ? module + "/" : "") + code;
            if (minErrConfig.urlErrorParamsEnabled) for(i = 0, paramPrefix = "?"; i < templateArgs.length; i++, paramPrefix = "&")message += paramPrefix + "p" + i + "=" + encodeURIComponent(templateArgs[i]);
            return new ErrorConstructor(message);
        };
    }
    /* We need to tell ESLint what variables are being exported */ /* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,
  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/ ////////////////////////////////////
    /**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */ var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
    // The name of a form control's ValidityState property.
    // This is used so that it's possible for internal tests to create mock ValidityStates.
    var VALIDITY_STATE_PROPERTY = "validity";
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
 * @private
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */ var lowercase = function(string) {
        return isString(string) ? string.toLowerCase() : string;
    };
    /**
 * @private
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */ var uppercase = function(string) {
        return isString(string) ? string.toUpperCase() : string;
    };
    var msie, jqLite, jQuery, slice = [].slice, splice = [].splice, push = [].push, toString = Object.prototype.toString, getPrototypeOf = Object.getPrototypeOf, ngMinErr = minErr("ng"), /** @name angular */ angular = window1.angular || (window1.angular = {}), angularModule, uid = 0;
    // Support: IE 9-11 only
    /**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */ msie = window1.document.documentMode;
    /**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */ function isArrayLike(obj) {
        // `null`, `undefined` and `window` are not array-like
        if (obj == null || isWindow(obj)) return false;
        // arrays, strings and jQuery/jqLite objects are array like
        // * jqLite is either the jQuery or jqLite constructor function
        // * we have to check the existence of jqLite first as this method is called
        //   via the forEach method when constructing the jqLite object in the first place
        if (isArray(obj) || isString(obj) || jqLite && obj instanceof jqLite) return true;
        // Support: iOS 8.2 (not reproducible in simulator)
        // "length" in obj used to prevent JIT error (gh-11508)
        var length = "length" in Object(obj) && obj.length;
        // NodeList objects (with `item` method) and
        // other objects with suitable length characteristics are array-like
        return isNumber(length) && (length >= 0 && length - 1 in obj || typeof obj.item === "function");
    }
    /**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */ function forEach(obj, iterator, context) {
        var key, length;
        if (obj) {
            if (isFunction(obj)) {
                for(key in obj)if (key !== "prototype" && key !== "length" && key !== "name" && obj.hasOwnProperty(key)) iterator.call(context, obj[key], key, obj);
            } else if (isArray(obj) || isArrayLike(obj)) {
                var isPrimitive = typeof obj !== "object";
                for(key = 0, length = obj.length; key < length; key++)if (isPrimitive || key in obj) iterator.call(context, obj[key], key, obj);
            } else if (obj.forEach && obj.forEach !== forEach) obj.forEach(iterator, context, obj);
            else if (isBlankObject(obj)) // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for(key in obj)iterator.call(context, obj[key], key, obj);
            else if (typeof obj.hasOwnProperty === "function") {
                // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
                for(key in obj)if (obj.hasOwnProperty(key)) iterator.call(context, obj[key], key, obj);
            } else {
                // Slow path for objects which do not have a method `hasOwnProperty`
                for(key in obj)if (hasOwnProperty.call(obj, key)) iterator.call(context, obj[key], key, obj);
            }
        }
        return obj;
    }
    function forEachSorted(obj, iterator, context) {
        var keys = Object.keys(obj).sort();
        for(var i = 0; i < keys.length; i++)iterator.call(context, obj[keys[i]], keys[i]);
        return keys;
    }
    /**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */ function reverseParams(iteratorFn) {
        return function(value, key) {
            iteratorFn(key, value);
        };
    }
    /**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */ function nextUid() {
        return ++uid;
    }
    /**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */ function setHashKey(obj, h) {
        if (h) obj.$$hashKey = h;
        else delete obj.$$hashKey;
    }
    function baseExtend(dst, objs, deep) {
        var h = dst.$$hashKey;
        for(var i = 0, ii = objs.length; i < ii; ++i){
            var obj = objs[i];
            if (!isObject(obj) && !isFunction(obj)) continue;
            var keys = Object.keys(obj);
            for(var j = 0, jj = keys.length; j < jj; j++){
                var key = keys[j];
                var src = obj[key];
                if (deep && isObject(src)) {
                    if (isDate(src)) dst[key] = new Date(src.valueOf());
                    else if (isRegExp(src)) dst[key] = new RegExp(src);
                    else if (src.nodeName) dst[key] = src.cloneNode(true);
                    else if (isElement(src)) dst[key] = src.clone();
                    else if (key !== "__proto__") {
                        if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
                        baseExtend(dst[key], [
                            src
                        ], true);
                    }
                } else dst[key] = src;
            }
        }
        setHashKey(dst, h);
        return dst;
    }
    /**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */ function extend(dst) {
        return baseExtend(dst, slice.call(arguments, 1), false);
    }
    /**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest using another, similar library for all-purpose merging,
* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* `angular.merge` also does not support merging objects with circular references.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/ function merge(dst) {
        return baseExtend(dst, slice.call(arguments, 1), true);
    }
    function toInt(str) {
        return parseInt(str, 10);
    }
    var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
        // eslint-disable-next-line no-self-compare
        return num !== num;
    };
    function inherit(parent, extra) {
        return extend(Object.create(parent), extra);
    }
    /**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */ function noop() {}
    noop.$inject = [];
    /**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */ function identity($) {
        return $;
    }
    identity.$inject = [];
    function valueFn(value) {
        return function valueRef() {
            return value;
        };
    }
    function hasCustomToString(obj) {
        return isFunction(obj.toString) && obj.toString !== toString;
    }
    /**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */ function isUndefined(value) {
        return typeof value === "undefined";
    }
    /**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */ function isDefined(value) {
        return typeof value !== "undefined";
    }
    /**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */ function isObject(value) {
        // http://jsperf.com/isobject4
        return value !== null && typeof value === "object";
    }
    /**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */ function isBlankObject(value) {
        return value !== null && typeof value === "object" && !getPrototypeOf(value);
    }
    /**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */ function isString(value) {
        return typeof value === "string";
    }
    /**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */ function isNumber(value) {
        return typeof value === "number";
    }
    /**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */ function isDate(value) {
        return toString.call(value) === "[object Date]";
    }
    /**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */ function isArray(arr) {
        return Array.isArray(arr) || arr instanceof Array;
    }
    /**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */ function isError(value) {
        var tag = toString.call(value);
        switch(tag){
            case "[object Error]":
                return true;
            case "[object Exception]":
                return true;
            case "[object DOMException]":
                return true;
            default:
                return value instanceof Error;
        }
    }
    /**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */ function isFunction(value) {
        return typeof value === "function";
    }
    /**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */ function isRegExp(value) {
        return toString.call(value) === "[object RegExp]";
    }
    /**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */ function isWindow(obj) {
        return obj && obj.window === obj;
    }
    function isScope(obj) {
        return obj && obj.$evalAsync && obj.$watch;
    }
    function isFile(obj) {
        return toString.call(obj) === "[object File]";
    }
    function isFormData(obj) {
        return toString.call(obj) === "[object FormData]";
    }
    function isBlob(obj) {
        return toString.call(obj) === "[object Blob]";
    }
    function isBoolean(value) {
        return typeof value === "boolean";
    }
    function isPromiseLike(obj) {
        return obj && isFunction(obj.then);
    }
    var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
    function isTypedArray(value) {
        return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
    }
    function isArrayBuffer(obj) {
        return toString.call(obj) === "[object ArrayBuffer]";
    }
    var trim = function(value) {
        return isString(value) ? value.trim() : value;
    };
    // Copied from:
    // http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
    // Prereq: s is a string.
    var escapeForRegexp = function(s) {
        return s.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, "\\$1")// eslint-disable-next-line no-control-regex
        .replace(/\x08/g, "\\x08");
    };
    /**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */ function isElement(node) {
        return !!(node && (node.nodeName // We are a direct element.
         || node.prop && node.attr && node.find)); // We have an on and find method part of jQuery API.
    }
    /**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */ function makeMap(str) {
        var obj = {}, items = str.split(","), i;
        for(i = 0; i < items.length; i++)obj[items[i]] = true;
        return obj;
    }
    function nodeName_(element) {
        return lowercase(element.nodeName || element[0] && element[0].nodeName);
    }
    function includes(array, obj) {
        return Array.prototype.indexOf.call(array, obj) !== -1;
    }
    function arrayRemove(array, value) {
        var index = array.indexOf(value);
        if (index >= 0) array.splice(index, 1);
        return index;
    }
    /**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
 * function, and has several limitations (see below).
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 *
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * <div class="alert alert-warning">
 *   `angular.copy` does not check if destination and source are of the same type. It's the
 *   developer's responsibility to make sure they are compatible.
 * </div>
 *
 * @knownIssue
 * This is a non-exhaustive list of object types / features that are not handled correctly by
 * `angular.copy`. Note that since this functions is used by the change detection code, this
 * means binding or watching objects of these types (or that include these types) might not work
 * correctly.
 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
 *
 * @param {*} source The source that will be used to make a copy. Can be any type, including
 *     primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
 *     must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */ function copy(source, destination, maxDepth) {
        var stackSource = [];
        var stackDest = [];
        maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
        if (destination) {
            if (isTypedArray(destination) || isArrayBuffer(destination)) throw ngMinErr("cpta", "Can't copy! TypedArray destination cannot be mutated.");
            if (source === destination) throw ngMinErr("cpi", "Can't copy! Source and destination are identical.");
            // Empty the destination object
            if (isArray(destination)) destination.length = 0;
            else forEach(destination, function(value, key) {
                if (key !== "$$hashKey") delete destination[key];
            });
            stackSource.push(source);
            stackDest.push(destination);
            return copyRecurse(source, destination, maxDepth);
        }
        return copyElement(source, maxDepth);
        function copyRecurse(source, destination, maxDepth) {
            maxDepth--;
            if (maxDepth < 0) return "...";
            var h = destination.$$hashKey;
            var key;
            if (isArray(source)) for(var i = 0, ii = source.length; i < ii; i++)destination.push(copyElement(source[i], maxDepth));
            else if (isBlankObject(source)) // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for(key in source)destination[key] = copyElement(source[key], maxDepth);
            else if (source && typeof source.hasOwnProperty === "function") {
                // Slow path, which must rely on hasOwnProperty
                for(key in source)if (source.hasOwnProperty(key)) destination[key] = copyElement(source[key], maxDepth);
            } else {
                // Slowest path --- hasOwnProperty can't be called as a method
                for(key in source)if (hasOwnProperty.call(source, key)) destination[key] = copyElement(source[key], maxDepth);
            }
            setHashKey(destination, h);
            return destination;
        }
        function copyElement(source, maxDepth) {
            // Simple values
            if (!isObject(source)) return source;
            // Already copied values
            var index = stackSource.indexOf(source);
            if (index !== -1) return stackDest[index];
            if (isWindow(source) || isScope(source)) throw ngMinErr("cpws", "Can't copy! Making copies of Window or Scope instances is not supported.");
            var needsRecurse = false;
            var destination = copyType(source);
            if (destination === undefined) {
                destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
                needsRecurse = true;
            }
            stackSource.push(source);
            stackDest.push(destination);
            return needsRecurse ? copyRecurse(source, destination, maxDepth) : destination;
        }
        function copyType(source) {
            switch(toString.call(source)){
                case "[object Int8Array]":
                case "[object Int16Array]":
                case "[object Int32Array]":
                case "[object Float32Array]":
                case "[object Float64Array]":
                case "[object Uint8Array]":
                case "[object Uint8ClampedArray]":
                case "[object Uint16Array]":
                case "[object Uint32Array]":
                    return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
                case "[object ArrayBuffer]":
                    // Support: IE10
                    if (!source.slice) {
                        // If we're in this case we know the environment supports ArrayBuffer
                        /* eslint-disable no-undef */ var copied = new ArrayBuffer(source.byteLength);
                        new Uint8Array(copied).set(new Uint8Array(source));
                        /* eslint-enable */ return copied;
                    }
                    return source.slice(0);
                case "[object Boolean]":
                case "[object Number]":
                case "[object String]":
                case "[object Date]":
                    return new source.constructor(source.valueOf());
                case "[object RegExp]":
                    var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
                    re.lastIndex = source.lastIndex;
                    return re;
                case "[object Blob]":
                    return new source.constructor([
                        source
                    ], {
                        type: source.type
                    });
            }
            if (isFunction(source.cloneNode)) return source.cloneNode(true);
        }
    }
    // eslint-disable-next-line no-self-compare
    function simpleCompare(a, b) {
        return a === b || a !== a && b !== b;
    }
    /**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */ function equals(o1, o2) {
        if (o1 === o2) return true;
        if (o1 === null || o2 === null) return false;
        // eslint-disable-next-line no-self-compare
        if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
        var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
        if (t1 === t2 && t1 === "object") {
            if (isArray(o1)) {
                if (!isArray(o2)) return false;
                if ((length = o1.length) === o2.length) {
                    for(key = 0; key < length; key++){
                        if (!equals(o1[key], o2[key])) return false;
                    }
                    return true;
                }
            } else if (isDate(o1)) {
                if (!isDate(o2)) return false;
                return simpleCompare(o1.getTime(), o2.getTime());
            } else if (isRegExp(o1)) {
                if (!isRegExp(o2)) return false;
                return o1.toString() === o2.toString();
            } else {
                if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
                keySet = createMap();
                for(key in o1){
                    if (key.charAt(0) === "$" || isFunction(o1[key])) continue;
                    if (!equals(o1[key], o2[key])) return false;
                    keySet[key] = true;
                }
                for(key in o2){
                    if (!(key in keySet) && key.charAt(0) !== "$" && isDefined(o2[key]) && !isFunction(o2[key])) return false;
                }
                return true;
            }
        }
        return false;
    }
    var csp = function() {
        if (!isDefined(csp.rules)) {
            var ngCspElement = window1.document.querySelector("[ng-csp]") || window1.document.querySelector("[data-ng-csp]");
            if (ngCspElement) {
                var ngCspAttribute = ngCspElement.getAttribute("ng-csp") || ngCspElement.getAttribute("data-ng-csp");
                csp.rules = {
                    noUnsafeEval: !ngCspAttribute || ngCspAttribute.indexOf("no-unsafe-eval") !== -1,
                    noInlineStyle: !ngCspAttribute || ngCspAttribute.indexOf("no-inline-style") !== -1
                };
            } else csp.rules = {
                noUnsafeEval: noUnsafeEval(),
                noInlineStyle: false
            };
        }
        return csp.rules;
        function noUnsafeEval() {
            try {
                // eslint-disable-next-line no-new, no-new-func
                new Function("");
                return false;
            } catch (e) {
                return true;
            }
        }
    };
    /**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */ var jq = function() {
        if (isDefined(jq.name_)) return jq.name_;
        var el;
        var i, ii = ngAttrPrefixes.length, prefix, name;
        for(i = 0; i < ii; ++i){
            prefix = ngAttrPrefixes[i];
            el = window1.document.querySelector("[" + prefix.replace(":", "\\:") + "jq]");
            if (el) {
                name = el.getAttribute(prefix + "jq");
                break;
            }
        }
        return jq.name_ = name;
    };
    function concat(array1, array2, index) {
        return array1.concat(slice.call(array2, index));
    }
    function sliceArgs(args, startIndex) {
        return slice.call(args, startIndex || 0);
    }
    /**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */ function bind(self, fn) {
        var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
        if (isFunction(fn) && !(fn instanceof RegExp)) return curryArgs.length ? function() {
            return arguments.length ? fn.apply(self, concat(curryArgs, arguments, 0)) : fn.apply(self, curryArgs);
        } : function() {
            return arguments.length ? fn.apply(self, arguments) : fn.call(self);
        };
        else // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
        return fn;
    }
    function toJsonReplacer(key, value) {
        var val = value;
        if (typeof key === "string" && key.charAt(0) === "$" && key.charAt(1) === "$") val = undefined;
        else if (isWindow(value)) val = "$WINDOW";
        else if (value && window1.document === value) val = "$DOCUMENT";
        else if (isScope(value)) val = "$SCOPE";
        return val;
    }
    /**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */ function toJson(obj, pretty) {
        if (isUndefined(obj)) return undefined;
        if (!isNumber(pretty)) pretty = pretty ? 2 : null;
        return JSON.stringify(obj, toJsonReplacer, pretty);
    }
    /**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */ function fromJson(json) {
        return isString(json) ? JSON.parse(json) : json;
    }
    var ALL_COLONS = /:/g;
    function timezoneToOffset(timezone, fallback) {
        // Support: IE 9-11 only, Edge 13-15+
        // IE/Edge do not "understand" colon (`:`) in timezone
        timezone = timezone.replace(ALL_COLONS, "");
        var requestedTimezoneOffset = Date.parse("Jan 01, 1970 00:00:00 " + timezone) / 60000;
        return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
    }
    function addDateMinutes(date, minutes) {
        date = new Date(date.getTime());
        date.setMinutes(date.getMinutes() + minutes);
        return date;
    }
    function convertTimezoneToLocal(date, timezone, reverse) {
        reverse = reverse ? -1 : 1;
        var dateTimezoneOffset = date.getTimezoneOffset();
        var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
    }
    /**
 * @returns {string} Returns the string representation of the element.
 */ function startingTag(element) {
        element = jqLite(element).clone().empty();
        var elemHtml = jqLite("<div></div>").append(element).html();
        try {
            return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) : elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/, function(match, nodeName) {
                return "<" + lowercase(nodeName);
            });
        } catch (e) {
            return lowercase(elemHtml);
        }
    }
    /////////////////////////////////////////////////
    /**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */ function tryDecodeURIComponent(value) {
        try {
            return decodeURIComponent(value);
        } catch (e) {
        // Ignore any invalid uri component.
        }
    }
    /**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */ function parseKeyValue(/**string*/ keyValue) {
        var obj = {};
        forEach((keyValue || "").split("&"), function(keyValue) {
            var splitPoint, key, val;
            if (keyValue) {
                key = keyValue = keyValue.replace(/\+/g, "%20");
                splitPoint = keyValue.indexOf("=");
                if (splitPoint !== -1) {
                    key = keyValue.substring(0, splitPoint);
                    val = keyValue.substring(splitPoint + 1);
                }
                key = tryDecodeURIComponent(key);
                if (isDefined(key)) {
                    val = isDefined(val) ? tryDecodeURIComponent(val) : true;
                    if (!hasOwnProperty.call(obj, key)) obj[key] = val;
                    else if (isArray(obj[key])) obj[key].push(val);
                    else obj[key] = [
                        obj[key],
                        val
                    ];
                }
            }
        });
        return obj;
    }
    function toKeyValue(obj) {
        var parts = [];
        forEach(obj, function(value, key) {
            if (isArray(value)) forEach(value, function(arrayValue) {
                parts.push(encodeUriQuery(key, true) + (arrayValue === true ? "" : "=" + encodeUriQuery(arrayValue, true)));
            });
            else parts.push(encodeUriQuery(key, true) + (value === true ? "" : "=" + encodeUriQuery(value, true)));
        });
        return parts.length ? parts.join("&") : "";
    }
    /**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */ function encodeUriSegment(val) {
        return encodeUriQuery(val, true).replace(/%26/gi, "&").replace(/%3D/gi, "=").replace(/%2B/gi, "+");
    }
    /**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */ function encodeUriQuery(val, pctEncodeSpaces) {
        return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%3B/gi, ";").replace(/%20/g, pctEncodeSpaces ? "%20" : "+");
    }
    var ngAttrPrefixes = [
        "ng-",
        "data-ng-",
        "ng:",
        "x-ng-"
    ];
    function getNgAttribute(element, ngAttr) {
        var attr, i, ii = ngAttrPrefixes.length;
        for(i = 0; i < ii; ++i){
            attr = ngAttrPrefixes[i] + ngAttr;
            if (isString(attr = element.getAttribute(attr))) return attr;
        }
        return null;
    }
    function allowAutoBootstrap(document1) {
        var script = document1.currentScript;
        if (!script) // Support: IE 9-11 only
        // IE does not have `document.currentScript`
        return true;
        // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
        if (!(script instanceof window1.HTMLScriptElement || script instanceof window1.SVGScriptElement)) return false;
        var attributes = script.attributes;
        var srcs = [
            attributes.getNamedItem("src"),
            attributes.getNamedItem("href"),
            attributes.getNamedItem("xlink:href")
        ];
        return srcs.every(function(src) {
            if (!src) return true;
            if (!src.value) return false;
            var link = document1.createElement("a");
            link.href = src.value;
            if (document1.location.origin === link.origin) // Same-origin resources are always allowed, even for banned URL schemes.
            return true;
            // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
            // This is to prevent angular.js bundled with browser extensions from being used to bypass the
            // content security policy in web pages and other browser extensions.
            switch(link.protocol){
                case "http:":
                case "https:":
                case "ftp:":
                case "blob:":
                case "file:":
                case "data:":
                    return true;
                default:
                    return false;
            }
        });
    }
    // Cached as it has to run during loading so that document.currentScript is available.
    var isAutoBootstrapAllowed = allowAutoBootstrap(window1.document);
    /**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */ function angularInit(element, bootstrap) {
        var appElement, module, config = {};
        // The element `element` has priority over any other element.
        forEach(ngAttrPrefixes, function(prefix) {
            var name = prefix + "app";
            if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
                appElement = element;
                module = element.getAttribute(name);
            }
        });
        forEach(ngAttrPrefixes, function(prefix) {
            var name = prefix + "app";
            var candidate;
            if (!appElement && (candidate = element.querySelector("[" + name.replace(":", "\\:") + "]"))) {
                appElement = candidate;
                module = candidate.getAttribute(name);
            }
        });
        if (appElement) {
            if (!isAutoBootstrapAllowed) {
                window1.console.error("AngularJS: disabling automatic bootstrap. <script> protocol indicates an extension, document.location.href does not match.");
                return;
            }
            config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
            bootstrap(appElement, module ? [
                module
            ] : [], config);
        }
    }
    /**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */ function bootstrap(element, modules, config) {
        if (!isObject(config)) config = {};
        var defaultConfig = {
            strictDi: false
        };
        config = extend(defaultConfig, config);
        var doBootstrap = function() {
            element = jqLite(element);
            if (element.injector()) {
                var tag = element[0] === window1.document ? "document" : startingTag(element);
                // Encode angle brackets to prevent input from being sanitized to empty string #8683.
                throw ngMinErr("btstrpd", "App already bootstrapped with this element '{0}'", tag.replace(/</, "&lt;").replace(/>/, "&gt;"));
            }
            modules = modules || [];
            modules.unshift([
                "$provide",
                function($provide) {
                    $provide.value("$rootElement", element);
                }
            ]);
            if (config.debugInfoEnabled) // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
            modules.push([
                "$compileProvider",
                function($compileProvider) {
                    $compileProvider.debugInfoEnabled(true);
                }
            ]);
            modules.unshift("ng");
            var injector = createInjector(modules, config.strictDi);
            injector.invoke([
                "$rootScope",
                "$rootElement",
                "$compile",
                "$injector",
                function bootstrapApply(scope, element, compile, injector) {
                    scope.$apply(function() {
                        element.data("$injector", injector);
                        compile(element)(scope);
                    });
                }
            ]);
            return injector;
        };
        var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
        var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
        if (window1 && NG_ENABLE_DEBUG_INFO.test(window1.name)) {
            config.debugInfoEnabled = true;
            window1.name = window1.name.replace(NG_ENABLE_DEBUG_INFO, "");
        }
        if (window1 && !NG_DEFER_BOOTSTRAP.test(window1.name)) return doBootstrap();
        window1.name = window1.name.replace(NG_DEFER_BOOTSTRAP, "");
        angular.resumeBootstrap = function(extraModules) {
            forEach(extraModules, function(module) {
                modules.push(module);
            });
            return doBootstrap();
        };
        if (isFunction(angular.resumeDeferredBootstrap)) angular.resumeDeferredBootstrap();
    }
    /**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */ function reloadWithDebugInfo() {
        window1.name = "NG_ENABLE_DEBUG_INFO!" + window1.name;
        window1.location.reload();
    }
    /**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */ function getTestability(rootElement) {
        var injector = angular.element(rootElement).injector();
        if (!injector) throw ngMinErr("test", "no injector found for element argument to getTestability");
        return injector.get("$$testability");
    }
    var SNAKE_CASE_REGEXP = /[A-Z]/g;
    function snake_case(name, separator) {
        separator = separator || "_";
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
            return (pos ? separator : "") + letter.toLowerCase();
        });
    }
    var bindJQueryFired = false;
    function bindJQuery() {
        var originalCleanData;
        if (bindJQueryFired) return;
        // bind to jQuery if present;
        var jqName = jq();
        jQuery = isUndefined(jqName) ? window1.jQuery : !jqName ? undefined : window1[jqName]; // use jQuery specified by `ngJq`
        // Use jQuery if it exists with proper functionality, otherwise default to us.
        // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
        // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
        // versions. It will not work for sure with jQuery <1.7, though.
        if (jQuery && jQuery.fn.on) {
            jqLite = jQuery;
            extend(jQuery.fn, {
                scope: JQLitePrototype.scope,
                isolateScope: JQLitePrototype.isolateScope,
                controller: /** @type {?} */ JQLitePrototype.controller,
                injector: JQLitePrototype.injector,
                inheritedData: JQLitePrototype.inheritedData
            });
        } else jqLite = JQLite;
        // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
        // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
        // the $destroy event on all removed nodes.
        originalCleanData = jqLite.cleanData;
        jqLite.cleanData = function(elems) {
            var events;
            for(var i = 0, elem; (elem = elems[i]) != null; i++){
                events = (jqLite._data(elem) || {}).events;
                if (events && events.$destroy) jqLite(elem).triggerHandler("$destroy");
            }
            originalCleanData(elems);
        };
        angular.element = jqLite;
        // Prevent double-proxying.
        bindJQueryFired = true;
    }
    /**
 * @ngdoc function
 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
 * @module ng
 * @kind function
 *
 * @description
 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
 * your code for this change and remove your use of this function as soon as possible.

 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 */ function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
        JQLite.legacyXHTMLReplacement = true;
    }
    /**
 * throw error if the argument is falsy.
 */ function assertArg(arg, name, reason) {
        if (!arg) throw ngMinErr("areq", "Argument '{0}' is {1}", name || "?", reason || "required");
        return arg;
    }
    function assertArgFn(arg, name, acceptArrayAnnotation) {
        if (acceptArrayAnnotation && isArray(arg)) arg = arg[arg.length - 1];
        assertArg(isFunction(arg), name, "not a function, got " + (arg && typeof arg === "object" ? arg.constructor.name || "Object" : typeof arg));
        return arg;
    }
    /**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */ function assertNotHasOwnProperty(name, context) {
        if (name === "hasOwnProperty") throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);
    }
    /**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */ //TODO(misko): this function needs to be removed
    function getter(obj, path, bindFnToScope) {
        if (!path) return obj;
        var keys = path.split(".");
        var key;
        var lastInstance = obj;
        var len = keys.length;
        for(var i = 0; i < len; i++){
            key = keys[i];
            if (obj) obj = (lastInstance = obj)[key];
        }
        if (!bindFnToScope && isFunction(obj)) return bind(lastInstance, obj);
        return obj;
    }
    /**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */ function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;
        for(var i = 1; node !== endNode && (node = node.nextSibling); i++)if (blockNodes || nodes[i] !== node) {
            if (!blockNodes) blockNodes = jqLite(slice.call(nodes, 0, i));
            blockNodes.push(node);
        }
        return blockNodes || nodes;
    }
    /**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */ function createMap() {
        return Object.create(null);
    }
    function stringify(value) {
        if (value == null) return "";
        switch(typeof value){
            case "string":
                break;
            case "number":
                value = "" + value;
                break;
            default:
                if (hasCustomToString(value) && !isArray(value) && !isDate(value)) value = value.toString();
                else value = toJson(value);
        }
        return value;
    }
    var NODE_TYPE_ELEMENT = 1;
    var NODE_TYPE_ATTRIBUTE = 2;
    var NODE_TYPE_TEXT = 3;
    var NODE_TYPE_COMMENT = 8;
    var NODE_TYPE_DOCUMENT = 9;
    var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
    /**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */ function setupModuleLoader(window1) {
        var $injectorMinErr = minErr("$injector");
        var ngMinErr = minErr("ng");
        function ensure(obj, name, factory) {
            return obj[name] || (obj[name] = factory());
        }
        var angular = ensure(window1, "angular", Object);
        // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
        angular.$$minErr = angular.$$minErr || minErr;
        return ensure(angular, "module", function() {
            /** @type {Object.<string, angular.Module>} */ var modules = {};
            /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */ return function module(name, requires, configFn) {
                var info = {};
                var assertNotHasOwnProperty = function(name, context) {
                    if (name === "hasOwnProperty") throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);
                };
                assertNotHasOwnProperty(name, "module");
                if (requires && modules.hasOwnProperty(name)) modules[name] = null;
                return ensure(modules, name, function() {
                    if (!requires) throw $injectorMinErr("nomod", "Module '{0}' is not available! You either misspelled the module name or forgot to load it. If registering a module ensure that you specify the dependencies as the second argument.", name);
                    /** @type {!Array.<Array.<*>>} */ var invokeQueue = [];
                    /** @type {!Array.<Function>} */ var configBlocks = [];
                    /** @type {!Array.<Function>} */ var runBlocks = [];
                    var config = invokeLater("$injector", "invoke", "push", configBlocks);
                    /** @type {angular.Module} */ var moduleInstance = {
                        // Private state
                        _invokeQueue: invokeQueue,
                        _configBlocks: configBlocks,
                        _runBlocks: runBlocks,
                        /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */ info: function(value) {
                            if (isDefined(value)) {
                                if (!isObject(value)) throw ngMinErr("aobj", "Argument '{0}' must be an object", "value");
                                info = value;
                                return this;
                            }
                            return info;
                        },
                        /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */ requires: requires,
                        /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */ name: name,
                        /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */ provider: invokeLaterAndSetModuleName("$provide", "provider"),
                        /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */ factory: invokeLaterAndSetModuleName("$provide", "factory"),
                        /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */ service: invokeLaterAndSetModuleName("$provide", "service"),
                        /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */ value: invokeLater("$provide", "value"),
                        /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */ constant: invokeLater("$provide", "constant", "unshift"),
                        /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */ decorator: invokeLaterAndSetModuleName("$provide", "decorator", configBlocks),
                        /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */ animation: invokeLaterAndSetModuleName("$animateProvider", "register"),
                        /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */ filter: invokeLaterAndSetModuleName("$filterProvider", "register"),
                        /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */ controller: invokeLaterAndSetModuleName("$controllerProvider", "register"),
                        /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */ directive: invokeLaterAndSetModuleName("$compileProvider", "directive"),
                        /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
           *    or an object map of components where the keys are the names and the values are the component definition objects.
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */ component: invokeLaterAndSetModuleName("$compileProvider", "component"),
                        /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */ config: config,
                        /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */ run: function(block) {
                            runBlocks.push(block);
                            return this;
                        }
                    };
                    if (configFn) config(configFn);
                    return moduleInstance;
                    /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */ function invokeLater(provider, method, insertMethod, queue) {
                        if (!queue) queue = invokeQueue;
                        return function() {
                            queue[insertMethod || "push"]([
                                provider,
                                method,
                                arguments
                            ]);
                            return moduleInstance;
                        };
                    }
                    /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */ function invokeLaterAndSetModuleName(provider, method, queue) {
                        if (!queue) queue = invokeQueue;
                        return function(recipeName, factoryFunction) {
                            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
                            queue.push([
                                provider,
                                method,
                                arguments
                            ]);
                            return moduleInstance;
                        };
                    }
                });
            };
        });
    }
    /* global shallowCopy: true */ /**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */ function shallowCopy(src, dst) {
        if (isArray(src)) {
            dst = dst || [];
            for(var i = 0, ii = src.length; i < ii; i++)dst[i] = src[i];
        } else if (isObject(src)) {
            dst = dst || {};
            for(var key in src)if (!(key.charAt(0) === "$" && key.charAt(1) === "$")) dst[key] = src[key];
        }
        return dst || src;
    }
    /* exported toDebugString */ function serializeObject(obj, maxDepth) {
        var seen = [];
        // There is no direct way to stringify object until reaching a specific depth
        // and a very deep object can cause a performance issue, so we copy the object
        // based on this specific depth and then stringify it.
        if (isValidObjectMaxDepth(maxDepth)) // This file is also included in `angular-loader`, so `copy()` might not always be available in
        // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
        obj = angular.copy(obj, null, maxDepth);
        return JSON.stringify(obj, function(key, val) {
            val = toJsonReplacer(key, val);
            if (isObject(val)) {
                if (seen.indexOf(val) >= 0) return "...";
                seen.push(val);
            }
            return val;
        });
    }
    function toDebugString(obj, maxDepth) {
        if (typeof obj === "function") return obj.toString().replace(/ \{[\s\S]*$/, "");
        else if (isUndefined(obj)) return "undefined";
        else if (typeof obj !== "string") return serializeObject(obj, maxDepth);
        return obj;
    }
    /* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  hiddenInputBrowserCacheDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRefDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $$IntervalFactoryProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $$TaskTrackerFactoryProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/ /**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */ var version = {
        // These placeholder strings will be replaced by grunt's `build` task.
        // They need to be double- or single-quoted.
        full: "1.8.3",
        major: 1,
        minor: 8,
        dot: 3,
        codeName: "ultimate-farewell"
    };
    function publishExternalAPI(angular) {
        extend(angular, {
            "errorHandlingConfig": errorHandlingConfig,
            "bootstrap": bootstrap,
            "copy": copy,
            "extend": extend,
            "merge": merge,
            "equals": equals,
            "element": jqLite,
            "forEach": forEach,
            "injector": createInjector,
            "noop": noop,
            "bind": bind,
            "toJson": toJson,
            "fromJson": fromJson,
            "identity": identity,
            "isUndefined": isUndefined,
            "isDefined": isDefined,
            "isString": isString,
            "isFunction": isFunction,
            "isObject": isObject,
            "isNumber": isNumber,
            "isElement": isElement,
            "isArray": isArray,
            "version": version,
            "isDate": isDate,
            "callbacks": {
                $$counter: 0
            },
            "getTestability": getTestability,
            "reloadWithDebugInfo": reloadWithDebugInfo,
            "UNSAFE_restoreLegacyJqLiteXHTMLReplacement": UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
            "$$minErr": minErr,
            "$$csp": csp,
            "$$encodeUriSegment": encodeUriSegment,
            "$$encodeUriQuery": encodeUriQuery,
            "$$lowercase": lowercase,
            "$$stringify": stringify,
            "$$uppercase": uppercase
        });
        angularModule = setupModuleLoader(window1);
        angularModule("ng", [
            "ngLocale"
        ], [
            "$provide",
            function ngModule($provide) {
                // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
                $provide.provider({
                    $$sanitizeUri: $$SanitizeUriProvider
                });
                $provide.provider("$compile", $CompileProvider).directive({
                    a: htmlAnchorDirective,
                    input: inputDirective,
                    textarea: inputDirective,
                    form: formDirective,
                    script: scriptDirective,
                    select: selectDirective,
                    option: optionDirective,
                    ngBind: ngBindDirective,
                    ngBindHtml: ngBindHtmlDirective,
                    ngBindTemplate: ngBindTemplateDirective,
                    ngClass: ngClassDirective,
                    ngClassEven: ngClassEvenDirective,
                    ngClassOdd: ngClassOddDirective,
                    ngCloak: ngCloakDirective,
                    ngController: ngControllerDirective,
                    ngForm: ngFormDirective,
                    ngHide: ngHideDirective,
                    ngIf: ngIfDirective,
                    ngInclude: ngIncludeDirective,
                    ngInit: ngInitDirective,
                    ngNonBindable: ngNonBindableDirective,
                    ngPluralize: ngPluralizeDirective,
                    ngRef: ngRefDirective,
                    ngRepeat: ngRepeatDirective,
                    ngShow: ngShowDirective,
                    ngStyle: ngStyleDirective,
                    ngSwitch: ngSwitchDirective,
                    ngSwitchWhen: ngSwitchWhenDirective,
                    ngSwitchDefault: ngSwitchDefaultDirective,
                    ngOptions: ngOptionsDirective,
                    ngTransclude: ngTranscludeDirective,
                    ngModel: ngModelDirective,
                    ngList: ngListDirective,
                    ngChange: ngChangeDirective,
                    pattern: patternDirective,
                    ngPattern: patternDirective,
                    required: requiredDirective,
                    ngRequired: requiredDirective,
                    minlength: minlengthDirective,
                    ngMinlength: minlengthDirective,
                    maxlength: maxlengthDirective,
                    ngMaxlength: maxlengthDirective,
                    ngValue: ngValueDirective,
                    ngModelOptions: ngModelOptionsDirective
                }).directive({
                    ngInclude: ngIncludeFillContentDirective,
                    input: hiddenInputBrowserCacheDirective
                }).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);
                $provide.provider({
                    $anchorScroll: $AnchorScrollProvider,
                    $animate: $AnimateProvider,
                    $animateCss: $CoreAnimateCssProvider,
                    $$animateJs: $$CoreAnimateJsProvider,
                    $$animateQueue: $$CoreAnimateQueueProvider,
                    $$AnimateRunner: $$AnimateRunnerFactoryProvider,
                    $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
                    $browser: $BrowserProvider,
                    $cacheFactory: $CacheFactoryProvider,
                    $controller: $ControllerProvider,
                    $document: $DocumentProvider,
                    $$isDocumentHidden: $$IsDocumentHiddenProvider,
                    $exceptionHandler: $ExceptionHandlerProvider,
                    $filter: $FilterProvider,
                    $$forceReflow: $$ForceReflowProvider,
                    $interpolate: $InterpolateProvider,
                    $interval: $IntervalProvider,
                    $$intervalFactory: $$IntervalFactoryProvider,
                    $http: $HttpProvider,
                    $httpParamSerializer: $HttpParamSerializerProvider,
                    $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
                    $httpBackend: $HttpBackendProvider,
                    $xhrFactory: $xhrFactoryProvider,
                    $jsonpCallbacks: $jsonpCallbacksProvider,
                    $location: $LocationProvider,
                    $log: $LogProvider,
                    $parse: $ParseProvider,
                    $rootScope: $RootScopeProvider,
                    $q: $QProvider,
                    $$q: $$QProvider,
                    $sce: $SceProvider,
                    $sceDelegate: $SceDelegateProvider,
                    $sniffer: $SnifferProvider,
                    $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
                    $templateCache: $TemplateCacheProvider,
                    $templateRequest: $TemplateRequestProvider,
                    $$testability: $$TestabilityProvider,
                    $timeout: $TimeoutProvider,
                    $window: $WindowProvider,
                    $$rAF: $$RAFProvider,
                    $$jqLite: $$jqLiteProvider,
                    $$Map: $$MapProvider,
                    $$cookieReader: $$CookieReaderProvider
                });
            }
        ]).info({
            angularVersion: "1.8.3"
        });
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ /* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/ //////////////////////////////////
    //JQLite
    //////////////////////////////////
    /**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
 * ```js
 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
 * ```
 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */ JQLite.expando = "ng339";
    var jqCache = JQLite.cache = {}, jqId = 1;
    /*
 * !!! This is an undocumented "private" function !!!
 */ JQLite._data = function(node) {
        //jQuery always returns an object on cache miss
        return this.cache[node[this.expando]] || {};
    };
    function jqNextId() {
        return ++jqId;
    }
    var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
    var MS_HACK_REGEXP = /^-ms-/;
    var MOUSE_EVENT_MAP = {
        mouseleave: "mouseout",
        mouseenter: "mouseover"
    };
    var jqLiteMinErr = minErr("jqLite");
    /**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */ function cssKebabToCamel(name) {
        return kebabToCamel(name.replace(MS_HACK_REGEXP, "ms-"));
    }
    function fnCamelCaseReplace(all, letter) {
        return letter.toUpperCase();
    }
    /**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */ function kebabToCamel(name) {
        return name.replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
    }
    var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
    var HTML_REGEXP = /<|&#?\w+;/;
    var TAG_NAME_REGEXP = /<([\w:-]+)/;
    var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
    // Table parts need to be wrapped with `<table>` or they're
    // stripped to their contents when put in a div.
    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do, so we cannot shorten
    // this by omitting <tbody> or other required elements.
    var wrapMap = {
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <10 only
    // IE 9 requires an option wrapper & it needs to have the whole table structure
    // set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
    var wrapMapIE9 = {
        option: [
            1,
            '<select multiple="multiple">',
            "</select>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    for(var key in wrapMap){
        var wrapMapValueClosing = wrapMap[key];
        var wrapMapValue = wrapMapValueClosing.slice().reverse();
        wrapMapIE9[key] = [
            wrapMapValue.length,
            "<" + wrapMapValue.join("><") + ">",
            "</" + wrapMapValueClosing.join("></") + ">"
        ];
    }
    wrapMapIE9.optgroup = wrapMapIE9.option;
    function jqLiteIsTextNode(html) {
        return !HTML_REGEXP.test(html);
    }
    function jqLiteAcceptsData(node) {
        // The window object can accept data but has no nodeType
        // Otherwise we are only interested in elements (1) and documents (9)
        var nodeType = node.nodeType;
        return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
    }
    function jqLiteHasData(node) {
        for(var key in jqCache[node.ng339])return true;
        return false;
    }
    function jqLiteBuildFragment(html, context) {
        var tmp, tag, wrap, finalHtml, fragment = context.createDocumentFragment(), nodes = [], i;
        if (jqLiteIsTextNode(html)) // Convert non-html into a text node
        nodes.push(context.createTextNode(html));
        else {
            // Convert html into DOM nodes
            tmp = fragment.appendChild(context.createElement("div"));
            tag = (TAG_NAME_REGEXP.exec(html) || [
                "",
                ""
            ])[1].toLowerCase();
            finalHtml = JQLite.legacyXHTMLReplacement ? html.replace(XHTML_TAG_REGEXP, "<$1></$2>") : html;
            if (msie < 10) {
                wrap = wrapMapIE9[tag] || wrapMapIE9._default;
                tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
                // Descend through wrappers to the right content
                i = wrap[0];
                while(i--)tmp = tmp.firstChild;
            } else {
                wrap = wrapMap[tag] || [];
                // Create wrappers & descend into them
                i = wrap.length;
                while(--i > -1){
                    tmp.appendChild(window1.document.createElement(wrap[i]));
                    tmp = tmp.firstChild;
                }
                tmp.innerHTML = finalHtml;
            }
            nodes = concat(nodes, tmp.childNodes);
            tmp = fragment.firstChild;
            tmp.textContent = "";
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        fragment.innerHTML = ""; // Clear inner HTML
        forEach(nodes, function(node) {
            fragment.appendChild(node);
        });
        return fragment;
    }
    function jqLiteParseHTML(html, context) {
        context = context || window1.document;
        var parsed;
        if (parsed = SINGLE_TAG_REGEXP.exec(html)) return [
            context.createElement(parsed[1])
        ];
        if (parsed = jqLiteBuildFragment(html, context)) return parsed.childNodes;
        return [];
    }
    function jqLiteWrapNode(node, wrapper) {
        var parent = node.parentNode;
        if (parent) parent.replaceChild(wrapper, node);
        wrapper.appendChild(node);
    }
    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var jqLiteContains = window1.Node.prototype.contains || /** @this */ function(arg) {
        // eslint-disable-next-line no-bitwise
        return !!(this.compareDocumentPosition(arg) & 16);
    };
    /////////////////////////////////////////////
    function JQLite(element) {
        if (element instanceof JQLite) return element;
        var argIsString;
        if (isString(element)) {
            element = trim(element);
            argIsString = true;
        }
        if (!(this instanceof JQLite)) {
            if (argIsString && element.charAt(0) !== "<") throw jqLiteMinErr("nosel", "Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element");
            return new JQLite(element);
        }
        if (argIsString) jqLiteAddNodes(this, jqLiteParseHTML(element));
        else if (isFunction(element)) jqLiteReady(element);
        else jqLiteAddNodes(this, element);
    }
    function jqLiteClone(element) {
        return element.cloneNode(true);
    }
    function jqLiteDealoc(element, onlyDescendants) {
        if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([
            element
        ]);
        if (element.querySelectorAll) jqLite.cleanData(element.querySelectorAll("*"));
    }
    function isEmptyObject(obj) {
        var name;
        for(name in obj)return false;
        return true;
    }
    function removeIfEmptyData(element) {
        var expandoId = element.ng339;
        var expandoStore = expandoId && jqCache[expandoId];
        var events = expandoStore && expandoStore.events;
        var data = expandoStore && expandoStore.data;
        if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
            delete jqCache[expandoId];
            element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
        }
    }
    function jqLiteOff(element, type, fn, unsupported) {
        if (isDefined(unsupported)) throw jqLiteMinErr("offargs", "jqLite#off() does not support the `selector` argument");
        var expandoStore = jqLiteExpandoStore(element);
        var events = expandoStore && expandoStore.events;
        var handle = expandoStore && expandoStore.handle;
        if (!handle) return; //no listeners registered
        if (!type) for(type in events){
            if (type !== "$destroy") element.removeEventListener(type, handle);
            delete events[type];
        }
        else {
            var removeHandler = function(type) {
                var listenerFns = events[type];
                if (isDefined(fn)) arrayRemove(listenerFns || [], fn);
                if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
                    element.removeEventListener(type, handle);
                    delete events[type];
                }
            };
            forEach(type.split(" "), function(type) {
                removeHandler(type);
                if (MOUSE_EVENT_MAP[type]) removeHandler(MOUSE_EVENT_MAP[type]);
            });
        }
        removeIfEmptyData(element);
    }
    function jqLiteRemoveData(element, name) {
        var expandoId = element.ng339;
        var expandoStore = expandoId && jqCache[expandoId];
        if (expandoStore) {
            if (name) delete expandoStore.data[name];
            else expandoStore.data = {};
            removeIfEmptyData(element);
        }
    }
    function jqLiteExpandoStore(element, createIfNecessary) {
        var expandoId = element.ng339, expandoStore = expandoId && jqCache[expandoId];
        if (createIfNecessary && !expandoStore) {
            element.ng339 = expandoId = jqNextId();
            expandoStore = jqCache[expandoId] = {
                events: {},
                data: {},
                handle: undefined
            };
        }
        return expandoStore;
    }
    function jqLiteData(element, key, value) {
        if (jqLiteAcceptsData(element)) {
            var prop;
            var isSimpleSetter = isDefined(value);
            var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
            var massGetter = !key;
            var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
            var data = expandoStore && expandoStore.data;
            if (isSimpleSetter) data[kebabToCamel(key)] = value;
            else {
                if (massGetter) return data;
                else {
                    if (isSimpleGetter) // don't force creation of expandoStore if it doesn't exist yet
                    return data && data[kebabToCamel(key)];
                    else for(prop in key)data[kebabToCamel(prop)] = key[prop];
                }
            }
        }
    }
    function jqLiteHasClass(element, selector) {
        if (!element.getAttribute) return false;
        return (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").indexOf(" " + selector + " ") > -1;
    }
    function jqLiteRemoveClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
            var existingClasses = (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ");
            var newClasses = existingClasses;
            forEach(cssClasses.split(" "), function(cssClass) {
                cssClass = trim(cssClass);
                newClasses = newClasses.replace(" " + cssClass + " ", " ");
            });
            if (newClasses !== existingClasses) element.setAttribute("class", trim(newClasses));
        }
    }
    function jqLiteAddClass(element, cssClasses) {
        if (cssClasses && element.setAttribute) {
            var existingClasses = (" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ");
            var newClasses = existingClasses;
            forEach(cssClasses.split(" "), function(cssClass) {
                cssClass = trim(cssClass);
                if (newClasses.indexOf(" " + cssClass + " ") === -1) newClasses += cssClass + " ";
            });
            if (newClasses !== existingClasses) element.setAttribute("class", trim(newClasses));
        }
    }
    function jqLiteAddNodes(root, elements) {
        // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
        if (elements) {
            // if a Node (the most common case)
            if (elements.nodeType) root[root.length++] = elements;
            else {
                var length = elements.length;
                // if an Array or NodeList and not a Window
                if (typeof length === "number" && elements.window !== elements) {
                    if (length) for(var i = 0; i < length; i++)root[root.length++] = elements[i];
                } else root[root.length++] = elements;
            }
        }
    }
    function jqLiteController(element, name) {
        return jqLiteInheritedData(element, "$" + (name || "ngController") + "Controller");
    }
    function jqLiteInheritedData(element, name, value) {
        // if element is the document object work with the html element instead
        // this makes $(document).scope() possible
        if (element.nodeType === NODE_TYPE_DOCUMENT) element = element.documentElement;
        var names = isArray(name) ? name : [
            name
        ];
        while(element){
            for(var i = 0, ii = names.length; i < ii; i++){
                if (isDefined(value = jqLite.data(element, names[i]))) return value;
            }
            // If dealing with a document fragment node with a host element, and no parent, use the host
            // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
            // to lookup parent controllers.
            element = element.parentNode || element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host;
        }
    }
    function jqLiteEmpty(element) {
        jqLiteDealoc(element, true);
        while(element.firstChild)element.removeChild(element.firstChild);
    }
    function jqLiteRemove(element, keepData) {
        if (!keepData) jqLiteDealoc(element);
        var parent = element.parentNode;
        if (parent) parent.removeChild(element);
    }
    function jqLiteDocumentLoaded(action, win) {
        win = win || window1;
        if (win.document.readyState === "complete") // Force the action to be run async for consistent behavior
        // from the action's point of view
        // i.e. it will definitely not be in a $apply
        win.setTimeout(action);
        else // No need to unbind this handler as load is only ever called once
        jqLite(win).on("load", action);
    }
    function jqLiteReady(fn) {
        function trigger() {
            window1.document.removeEventListener("DOMContentLoaded", trigger);
            window1.removeEventListener("load", trigger);
            fn();
        }
        // check if document is already loaded
        if (window1.document.readyState === "complete") window1.setTimeout(fn);
        else {
            // We can not use jqLite since we are not done loading and jQuery could be loaded later.
            // Works for modern browsers and IE9
            window1.document.addEventListener("DOMContentLoaded", trigger);
            // Fallback to window.onload for others
            window1.addEventListener("load", trigger);
        }
    }
    //////////////////////////////////////////
    // Functions which are declared directly.
    //////////////////////////////////////////
    var JQLitePrototype = JQLite.prototype = {
        ready: jqLiteReady,
        toString: function() {
            var value = [];
            forEach(this, function(e) {
                value.push("" + e);
            });
            return "[" + value.join(", ") + "]";
        },
        eq: function(index) {
            return index >= 0 ? jqLite(this[index]) : jqLite(this[this.length + index]);
        },
        length: 0,
        push: push,
        sort: [].sort,
        splice: [].splice
    };
    //////////////////////////////////////////
    // Functions iterating getter/setters.
    // these functions return self on setter and
    // value on get.
    //////////////////////////////////////////
    var BOOLEAN_ATTR = {};
    forEach("multiple,selected,checked,disabled,readOnly,required,open".split(","), function(value) {
        BOOLEAN_ATTR[lowercase(value)] = value;
    });
    var BOOLEAN_ELEMENTS = {};
    forEach("input,select,option,textarea,button,form,details".split(","), function(value) {
        BOOLEAN_ELEMENTS[value] = true;
    });
    var ALIASED_ATTR = {
        "ngMinlength": "minlength",
        "ngMaxlength": "maxlength",
        "ngMin": "min",
        "ngMax": "max",
        "ngPattern": "pattern",
        "ngStep": "step"
    };
    function getBooleanAttrName(element, name) {
        // check dom last since we will most likely fail on name
        var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
        // booleanAttr is here twice to minimize DOM access
        return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
    }
    function getAliasedAttrName(name) {
        return ALIASED_ATTR[name];
    }
    forEach({
        data: jqLiteData,
        removeData: jqLiteRemoveData,
        hasData: jqLiteHasData,
        cleanData: function jqLiteCleanData(nodes) {
            for(var i = 0, ii = nodes.length; i < ii; i++){
                jqLiteRemoveData(nodes[i]);
                jqLiteOff(nodes[i]);
            }
        }
    }, function(fn, name) {
        JQLite[name] = fn;
    });
    forEach({
        data: jqLiteData,
        inheritedData: jqLiteInheritedData,
        scope: function(element) {
            // Can't use jqLiteData here directly so we stay compatible with jQuery!
            return jqLite.data(element, "$scope") || jqLiteInheritedData(element.parentNode || element, [
                "$isolateScope",
                "$scope"
            ]);
        },
        isolateScope: function(element) {
            // Can't use jqLiteData here directly so we stay compatible with jQuery!
            return jqLite.data(element, "$isolateScope") || jqLite.data(element, "$isolateScopeNoTemplate");
        },
        controller: jqLiteController,
        injector: function(element) {
            return jqLiteInheritedData(element, "$injector");
        },
        removeAttr: function(element, name) {
            element.removeAttribute(name);
        },
        hasClass: jqLiteHasClass,
        css: function(element, name, value) {
            name = cssKebabToCamel(name);
            if (isDefined(value)) element.style[name] = value;
            else return element.style[name];
        },
        attr: function(element, name, value) {
            var ret;
            var nodeType = element.nodeType;
            if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT || !element.getAttribute) return;
            var lowercasedName = lowercase(name);
            var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
            if (isDefined(value)) {
                // setter
                if (value === null || value === false && isBooleanAttr) element.removeAttribute(name);
                else element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
            } else {
                // getter
                ret = element.getAttribute(name);
                if (isBooleanAttr && ret !== null) ret = lowercasedName;
                // Normalize non-existing attributes to undefined (as jQuery).
                return ret === null ? undefined : ret;
            }
        },
        prop: function(element, name, value) {
            if (isDefined(value)) element[name] = value;
            else return element[name];
        },
        text: function() {
            getText.$dv = "";
            return getText;
            function getText(element, value) {
                if (isUndefined(value)) {
                    var nodeType = element.nodeType;
                    return nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT ? element.textContent : "";
                }
                element.textContent = value;
            }
        }(),
        val: function(element, value) {
            if (isUndefined(value)) {
                if (element.multiple && nodeName_(element) === "select") {
                    var result = [];
                    forEach(element.options, function(option) {
                        if (option.selected) result.push(option.value || option.text);
                    });
                    return result;
                }
                return element.value;
            }
            element.value = value;
        },
        html: function(element, value) {
            if (isUndefined(value)) return element.innerHTML;
            jqLiteDealoc(element, true);
            element.innerHTML = value;
        },
        empty: jqLiteEmpty
    }, function(fn, name) {
        /**
   * Properties: writes return selection, reads return first value
   */ JQLite.prototype[name] = function(arg1, arg2) {
            var i, key;
            var nodeCount = this.length;
            // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
            // in a way that survives minification.
            // jqLiteEmpty takes no arguments but is a setter.
            if (fn !== jqLiteEmpty && isUndefined(fn.length === 2 && fn !== jqLiteHasClass && fn !== jqLiteController ? arg1 : arg2)) {
                if (isObject(arg1)) {
                    // we are a write, but the object properties are the key/values
                    for(i = 0; i < nodeCount; i++){
                        if (fn === jqLiteData) // data() takes the whole object in jQuery
                        fn(this[i], arg1);
                        else for(key in arg1)fn(this[i], key, arg1[key]);
                    }
                    // return self for chaining
                    return this;
                } else {
                    // we are a read, so read the first child.
                    // TODO: do we still need this?
                    var value = fn.$dv;
                    // Only if we have $dv do we iterate over all, otherwise it is just the first element.
                    var jj = isUndefined(value) ? Math.min(nodeCount, 1) : nodeCount;
                    for(var j = 0; j < jj; j++){
                        var nodeValue = fn(this[j], arg1, arg2);
                        value = value ? value + nodeValue : nodeValue;
                    }
                    return value;
                }
            } else {
                // we are a write, so apply to all children
                for(i = 0; i < nodeCount; i++)fn(this[i], arg1, arg2);
                // return self for chaining
                return this;
            }
        };
    });
    function createEventHandler(element, events) {
        var eventHandler = function(event, type) {
            // jQuery specific api
            event.isDefaultPrevented = function() {
                return event.defaultPrevented;
            };
            var eventFns = events[type || event.type];
            var eventFnsLength = eventFns ? eventFns.length : 0;
            if (!eventFnsLength) return;
            if (isUndefined(event.immediatePropagationStopped)) {
                var originalStopImmediatePropagation = event.stopImmediatePropagation;
                event.stopImmediatePropagation = function() {
                    event.immediatePropagationStopped = true;
                    if (event.stopPropagation) event.stopPropagation();
                    if (originalStopImmediatePropagation) originalStopImmediatePropagation.call(event);
                };
            }
            event.isImmediatePropagationStopped = function() {
                return event.immediatePropagationStopped === true;
            };
            // Some events have special handlers that wrap the real handler
            var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
            // Copy event handlers in case event handlers array is modified during execution.
            if (eventFnsLength > 1) eventFns = shallowCopy(eventFns);
            for(var i = 0; i < eventFnsLength; i++)if (!event.isImmediatePropagationStopped()) handlerWrapper(element, event, eventFns[i]);
        };
        // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
        //       events on `element`
        eventHandler.elem = element;
        return eventHandler;
    }
    function defaultHandlerWrapper(element, event, handler) {
        handler.call(element, event);
    }
    function specialMouseHandlerWrapper(target, event, handler) {
        // Refer to jQuery's implementation of mouseenter & mouseleave
        // Read about mouseenter and mouseleave:
        // http://www.quirksmode.org/js/events_mouse.html#link8
        var related = event.relatedTarget;
        // For mousenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if (!related || related !== target && !jqLiteContains.call(target, related)) handler.call(target, event);
    }
    //////////////////////////////////////////
    // Functions iterating traversal.
    // These functions chain results into a single
    // selector.
    //////////////////////////////////////////
    forEach({
        removeData: jqLiteRemoveData,
        on: function jqLiteOn(element, type, fn, unsupported) {
            if (isDefined(unsupported)) throw jqLiteMinErr("onargs", "jqLite#on() does not support the `selector` or `eventData` parameters");
            // Do not add event handlers to non-elements because they will not be cleaned up.
            if (!jqLiteAcceptsData(element)) return;
            var expandoStore = jqLiteExpandoStore(element, true);
            var events = expandoStore.events;
            var handle = expandoStore.handle;
            if (!handle) handle = expandoStore.handle = createEventHandler(element, events);
            // http://jsperf.com/string-indexof-vs-split
            var types = type.indexOf(" ") >= 0 ? type.split(" ") : [
                type
            ];
            var i = types.length;
            var addHandler = function(type, specialHandlerWrapper, noEventListener) {
                var eventFns = events[type];
                if (!eventFns) {
                    eventFns = events[type] = [];
                    eventFns.specialHandlerWrapper = specialHandlerWrapper;
                    if (type !== "$destroy" && !noEventListener) element.addEventListener(type, handle);
                }
                eventFns.push(fn);
            };
            while(i--){
                type = types[i];
                if (MOUSE_EVENT_MAP[type]) {
                    addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
                    addHandler(type, undefined, true);
                } else addHandler(type);
            }
        },
        off: jqLiteOff,
        one: function(element, type, fn) {
            element = jqLite(element);
            //add the listener twice so that when it is called
            //you can remove the original function and still be
            //able to call element.off(ev, fn) normally
            element.on(type, function onFn() {
                element.off(type, fn);
                element.off(type, onFn);
            });
            element.on(type, fn);
        },
        replaceWith: function(element, replaceNode) {
            var index, parent = element.parentNode;
            jqLiteDealoc(element);
            forEach(new JQLite(replaceNode), function(node) {
                if (index) parent.insertBefore(node, index.nextSibling);
                else parent.replaceChild(node, element);
                index = node;
            });
        },
        children: function(element) {
            var children = [];
            forEach(element.childNodes, function(element) {
                if (element.nodeType === NODE_TYPE_ELEMENT) children.push(element);
            });
            return children;
        },
        contents: function(element) {
            return element.contentDocument || element.childNodes || [];
        },
        append: function(element, node) {
            var nodeType = element.nodeType;
            if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
            node = new JQLite(node);
            for(var i = 0, ii = node.length; i < ii; i++){
                var child = node[i];
                element.appendChild(child);
            }
        },
        prepend: function(element, node) {
            if (element.nodeType === NODE_TYPE_ELEMENT) {
                var index = element.firstChild;
                forEach(new JQLite(node), function(child) {
                    element.insertBefore(child, index);
                });
            }
        },
        wrap: function(element, wrapNode) {
            jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
        },
        remove: jqLiteRemove,
        detach: function(element) {
            jqLiteRemove(element, true);
        },
        after: function(element, newElement) {
            var index = element, parent = element.parentNode;
            if (parent) {
                newElement = new JQLite(newElement);
                for(var i = 0, ii = newElement.length; i < ii; i++){
                    var node = newElement[i];
                    parent.insertBefore(node, index.nextSibling);
                    index = node;
                }
            }
        },
        addClass: jqLiteAddClass,
        removeClass: jqLiteRemoveClass,
        toggleClass: function(element, selector, condition) {
            if (selector) forEach(selector.split(" "), function(className) {
                var classCondition = condition;
                if (isUndefined(classCondition)) classCondition = !jqLiteHasClass(element, className);
                (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
            });
        },
        parent: function(element) {
            var parent = element.parentNode;
            return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
        },
        next: function(element) {
            return element.nextElementSibling;
        },
        find: function(element, selector) {
            if (element.getElementsByTagName) return element.getElementsByTagName(selector);
            else return [];
        },
        clone: jqLiteClone,
        triggerHandler: function(element, event, extraParameters) {
            var dummyEvent, eventFnsCopy, handlerArgs;
            var eventName = event.type || event;
            var expandoStore = jqLiteExpandoStore(element);
            var events = expandoStore && expandoStore.events;
            var eventFns = events && events[eventName];
            if (eventFns) {
                // Create a dummy event to pass to the handlers
                dummyEvent = {
                    preventDefault: function() {
                        this.defaultPrevented = true;
                    },
                    isDefaultPrevented: function() {
                        return this.defaultPrevented === true;
                    },
                    stopImmediatePropagation: function() {
                        this.immediatePropagationStopped = true;
                    },
                    isImmediatePropagationStopped: function() {
                        return this.immediatePropagationStopped === true;
                    },
                    stopPropagation: noop,
                    type: eventName,
                    target: element
                };
                // If a custom event was provided then extend our dummy event with it
                if (event.type) dummyEvent = extend(dummyEvent, event);
                // Copy event handlers in case event handlers array is modified during execution.
                eventFnsCopy = shallowCopy(eventFns);
                handlerArgs = extraParameters ? [
                    dummyEvent
                ].concat(extraParameters) : [
                    dummyEvent
                ];
                forEach(eventFnsCopy, function(fn) {
                    if (!dummyEvent.isImmediatePropagationStopped()) fn.apply(element, handlerArgs);
                });
            }
        }
    }, function(fn, name) {
        /**
   * chaining functions
   */ JQLite.prototype[name] = function(arg1, arg2, arg3) {
            var value;
            for(var i = 0, ii = this.length; i < ii; i++)if (isUndefined(value)) {
                value = fn(this[i], arg1, arg2, arg3);
                if (isDefined(value)) // any function which returns a value needs to be wrapped
                value = jqLite(value);
            } else jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
            return isDefined(value) ? value : this;
        };
    });
    // bind legacy bind/unbind to on/off
    JQLite.prototype.bind = JQLite.prototype.on;
    JQLite.prototype.unbind = JQLite.prototype.off;
    // Provider for private $$jqLite service
    /** @this */ function $$jqLiteProvider() {
        this.$get = function $$jqLite() {
            return extend(JQLite, {
                hasClass: function(node, classes) {
                    if (node.attr) node = node[0];
                    return jqLiteHasClass(node, classes);
                },
                addClass: function(node, classes) {
                    if (node.attr) node = node[0];
                    return jqLiteAddClass(node, classes);
                },
                removeClass: function(node, classes) {
                    if (node.attr) node = node[0];
                    return jqLiteRemoveClass(node, classes);
                }
            });
        };
    }
    /**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */ function hashKey(obj, nextUidFn) {
        var key = obj && obj.$$hashKey;
        if (key) {
            if (typeof key === "function") key = obj.$$hashKey();
            return key;
        }
        var objType = typeof obj;
        if (objType === "function" || objType === "object" && obj !== null) key = obj.$$hashKey = objType + ":" + (nextUidFn || nextUid)();
        else key = objType + ":" + obj;
        return key;
    }
    // A minimal ES2015 Map implementation.
    // Should be bug/feature equivalent to the native implementations of supported browsers
    // (for the features required in Angular).
    // See https://kangax.github.io/compat-table/es6/#test-Map
    var nanKey = Object.create(null);
    function NgMapShim() {
        this._keys = [];
        this._values = [];
        this._lastKey = NaN;
        this._lastIndex = -1;
    }
    NgMapShim.prototype = {
        _idx: function(key) {
            if (key !== this._lastKey) {
                this._lastKey = key;
                this._lastIndex = this._keys.indexOf(key);
            }
            return this._lastIndex;
        },
        _transformKey: function(key) {
            return isNumberNaN(key) ? nanKey : key;
        },
        get: function(key) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            if (idx !== -1) return this._values[idx];
        },
        has: function(key) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            return idx !== -1;
        },
        set: function(key, value) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            if (idx === -1) idx = this._lastIndex = this._keys.length;
            this._keys[idx] = key;
            this._values[idx] = value;
        // Support: IE11
        // Do not `return this` to simulate the partial IE11 implementation
        },
        delete: function(key) {
            key = this._transformKey(key);
            var idx = this._idx(key);
            if (idx === -1) return false;
            this._keys.splice(idx, 1);
            this._values.splice(idx, 1);
            this._lastKey = NaN;
            this._lastIndex = -1;
            return true;
        }
    };
    // For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
    // are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
    // implementations get more stable, we can reconsider switching to `window.Map` (when available).
    var NgMap = NgMapShim;
    var $$MapProvider = [
        /** @this */ function() {
            this.$get = [
                function() {
                    return NgMap;
                }
            ];
        }
    ];
    /**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */ /**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */ var ARROW_ARG = /^([^(]+?)=>/;
    var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
    var FN_ARG_SPLIT = /,/;
    var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
    var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
    var $injectorMinErr = minErr("$injector");
    function stringifyFn(fn) {
        return Function.prototype.toString.call(fn);
    }
    function extractArgs(fn) {
        var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ""), args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
        return args;
    }
    function anonFn(fn) {
        // For anonymous functions, showing at the very least the function signature can help in
        // debugging.
        var args = extractArgs(fn);
        if (args) return "function(" + (args[1] || "").replace(/[\s\r\n]+/, " ") + ")";
        return "fn";
    }
    function annotate(fn, strictDi, name) {
        var $inject, argDecl, last;
        if (typeof fn === "function") {
            if (!($inject = fn.$inject)) {
                $inject = [];
                if (fn.length) {
                    if (strictDi) {
                        if (!isString(name) || !name) name = fn.name || anonFn(fn);
                        throw $injectorMinErr("strictdi", "{0} is not using explicit annotation and cannot be invoked in strict mode", name);
                    }
                    argDecl = extractArgs(fn);
                    forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
                        arg.replace(FN_ARG, function(all, underscore, name) {
                            $inject.push(name);
                        });
                    });
                }
                fn.$inject = $inject;
            }
        } else if (isArray(fn)) {
            last = fn.length - 1;
            assertArgFn(fn[last], "fn");
            $inject = fn.slice(0, last);
        } else assertArgFn(fn, "fn", true);
        return $inject;
    }
    ///////////////////////////////////////
    /**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */ /**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */ /**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */ /**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */ /**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */ /**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */ /**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */ /**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */ /**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */ /**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */ /**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */ function createInjector(modulesToLoad, strictDi) {
        strictDi = strictDi === true;
        var INSTANTIATING = {}, providerSuffix = "Provider", path = [], loadedModules = new NgMap(), providerCache = {
            $provide: {
                provider: supportObject(provider),
                factory: supportObject(factory),
                service: supportObject(service),
                value: supportObject(value),
                constant: supportObject(constant),
                decorator: decorator
            }
        }, providerInjector = providerCache.$injector = createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) path.push(caller);
            throw $injectorMinErr("unpr", "Unknown provider: {0}", path.join(" <- "));
        }), instanceCache = {}, protoInstanceInjector = createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
        }), instanceInjector = protoInstanceInjector;
        providerCache["$injector" + providerSuffix] = {
            $get: valueFn(protoInstanceInjector)
        };
        instanceInjector.modules = providerInjector.modules = createMap();
        var runBlocks = loadModules(modulesToLoad);
        instanceInjector = protoInstanceInjector.get("$injector");
        instanceInjector.strictDi = strictDi;
        forEach(runBlocks, function(fn) {
            if (fn) instanceInjector.invoke(fn);
        });
        instanceInjector.loadNewModules = function(mods) {
            forEach(loadModules(mods), function(fn) {
                if (fn) instanceInjector.invoke(fn);
            });
        };
        return instanceInjector;
        ////////////////////////////////////
        // $provider
        ////////////////////////////////////
        function supportObject(delegate) {
            return function(key, value) {
                if (isObject(key)) forEach(key, reverseParams(delegate));
                else return delegate(key, value);
            };
        }
        function provider(name, provider_) {
            assertNotHasOwnProperty(name, "service");
            if (isFunction(provider_) || isArray(provider_)) provider_ = providerInjector.instantiate(provider_);
            if (!provider_.$get) throw $injectorMinErr("pget", "Provider '{0}' must define $get factory method.", name);
            return providerCache[name + providerSuffix] = provider_;
        }
        function enforceReturnValue(name, factory) {
            return /** @this */ function enforcedReturnValue() {
                var result = instanceInjector.invoke(factory, this);
                if (isUndefined(result)) throw $injectorMinErr("undef", "Provider '{0}' must return a value from $get factory method.", name);
                return result;
            };
        }
        function factory(name, factoryFn, enforce) {
            return provider(name, {
                $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
            });
        }
        function service(name, constructor) {
            return factory(name, [
                "$injector",
                function($injector) {
                    return $injector.instantiate(constructor);
                }
            ]);
        }
        function value(name, val) {
            return factory(name, valueFn(val), false);
        }
        function constant(name, value) {
            assertNotHasOwnProperty(name, "constant");
            providerCache[name] = value;
            instanceCache[name] = value;
        }
        function decorator(serviceName, decorFn) {
            var origProvider = providerInjector.get(serviceName + providerSuffix), orig$get = origProvider.$get;
            origProvider.$get = function() {
                var origInstance = instanceInjector.invoke(orig$get, origProvider);
                return instanceInjector.invoke(decorFn, null, {
                    $delegate: origInstance
                });
            };
        }
        ////////////////////////////////////
        // Module Loading
        ////////////////////////////////////
        function loadModules(modulesToLoad) {
            assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), "modulesToLoad", "not an array");
            var runBlocks = [], moduleFn;
            forEach(modulesToLoad, function(module) {
                if (loadedModules.get(module)) return;
                loadedModules.set(module, true);
                function runInvokeQueue(queue) {
                    var i, ii;
                    for(i = 0, ii = queue.length; i < ii; i++){
                        var invokeArgs = queue[i], provider = providerInjector.get(invokeArgs[0]);
                        provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
                    }
                }
                try {
                    if (isString(module)) {
                        moduleFn = angularModule(module);
                        instanceInjector.modules[module] = moduleFn;
                        runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
                        runInvokeQueue(moduleFn._invokeQueue);
                        runInvokeQueue(moduleFn._configBlocks);
                    } else if (isFunction(module)) runBlocks.push(providerInjector.invoke(module));
                    else if (isArray(module)) runBlocks.push(providerInjector.invoke(module));
                    else assertArgFn(module, "module");
                } catch (e) {
                    if (isArray(module)) module = module[module.length - 1];
                    if (e.message && e.stack && e.stack.indexOf(e.message) === -1) // Safari & FF's stack traces don't contain error.message content
                    // unlike those of Chrome and IE
                    // So if stack doesn't contain message, we create a new string that contains both.
                    // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
                    // eslint-disable-next-line no-ex-assign
                    e = e.message + "\n" + e.stack;
                    throw $injectorMinErr("modulerr", "Failed to instantiate module {0} due to:\n{1}", module, e.stack || e.message || e);
                }
            });
            return runBlocks;
        }
        ////////////////////////////////////
        // internal Injector
        ////////////////////////////////////
        function createInternalInjector(cache, factory) {
            function getService(serviceName, caller) {
                if (cache.hasOwnProperty(serviceName)) {
                    if (cache[serviceName] === INSTANTIATING) throw $injectorMinErr("cdep", "Circular dependency found: {0}", serviceName + " <- " + path.join(" <- "));
                    return cache[serviceName];
                } else try {
                    path.unshift(serviceName);
                    cache[serviceName] = INSTANTIATING;
                    cache[serviceName] = factory(serviceName, caller);
                    return cache[serviceName];
                } catch (err) {
                    if (cache[serviceName] === INSTANTIATING) delete cache[serviceName];
                    throw err;
                } finally{
                    path.shift();
                }
            }
            function injectionArgs(fn, locals, serviceName) {
                var args = [], $inject = createInjector.$$annotate(fn, strictDi, serviceName);
                for(var i = 0, length = $inject.length; i < length; i++){
                    var key = $inject[i];
                    if (typeof key !== "string") throw $injectorMinErr("itkn", "Incorrect injection token! Expected service name as string, got {0}", key);
                    args.push(locals && locals.hasOwnProperty(key) ? locals[key] : getService(key, serviceName));
                }
                return args;
            }
            function isClass(func) {
                // Support: IE 9-11 only
                // IE 9-11 do not support classes and IE9 leaks with the code below.
                if (msie || typeof func !== "function") return false;
                var result = func.$$ngIsClass;
                if (!isBoolean(result)) result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
                return result;
            }
            function invoke(fn, self, locals, serviceName) {
                if (typeof locals === "string") {
                    serviceName = locals;
                    locals = null;
                }
                var args = injectionArgs(fn, locals, serviceName);
                if (isArray(fn)) fn = fn[fn.length - 1];
                if (!isClass(fn)) // http://jsperf.com/angularjs-invoke-apply-vs-switch
                // #5388
                return fn.apply(self, args);
                else {
                    args.unshift(null);
                    return new (Function.prototype.bind.apply(fn, args))();
                }
            }
            function instantiate(Type, locals, serviceName) {
                // Check if Type is annotated and use just the given function at n-1 as parameter
                // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
                var ctor = isArray(Type) ? Type[Type.length - 1] : Type;
                var args = injectionArgs(Type, locals, serviceName);
                // Empty object at position 0 is ignored for invocation with `new`, but required.
                args.unshift(null);
                return new (Function.prototype.bind.apply(ctor, args))();
            }
            return {
                invoke: invoke,
                instantiate: instantiate,
                get: getService,
                annotate: createInjector.$$annotate,
                has: function(name) {
                    return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
                }
            };
        }
    }
    createInjector.$$annotate = annotate;
    /**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */ function $AnchorScrollProvider() {
        var autoScrollingEnabled = true;
        /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */ this.disableAutoScrolling = function() {
            autoScrollingEnabled = false;
        };
        /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */ this.$get = [
            "$window",
            "$location",
            "$rootScope",
            function($window, $location, $rootScope) {
                var document1 = $window.document;
                // Helper function to get first anchor from a NodeList
                // (using `Array#some()` instead of `angular#forEach()` since it's more performant
                //  and working in all supported browsers.)
                function getFirstAnchor(list) {
                    var result = null;
                    Array.prototype.some.call(list, function(element) {
                        if (nodeName_(element) === "a") {
                            result = element;
                            return true;
                        }
                    });
                    return result;
                }
                function getYOffset() {
                    var offset = scroll.yOffset;
                    if (isFunction(offset)) offset = offset();
                    else if (isElement(offset)) {
                        var elem = offset[0];
                        var style = $window.getComputedStyle(elem);
                        if (style.position !== "fixed") offset = 0;
                        else offset = elem.getBoundingClientRect().bottom;
                    } else if (!isNumber(offset)) offset = 0;
                    return offset;
                }
                function scrollTo(elem) {
                    if (elem) {
                        elem.scrollIntoView();
                        var offset = getYOffset();
                        if (offset) {
                            // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
                            // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
                            // top of the viewport.
                            //
                            // IF the number of pixels from the top of `elem` to the end of the page's content is less
                            // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
                            // way down the page.
                            //
                            // This is often the case for elements near the bottom of the page.
                            //
                            // In such cases we do not need to scroll the whole `offset` up, just the difference between
                            // the top of the element and the offset, which is enough to align the top of `elem` at the
                            // desired position.
                            var elemTop = elem.getBoundingClientRect().top;
                            $window.scrollBy(0, elemTop - offset);
                        }
                    } else $window.scrollTo(0, 0);
                }
                function scroll(hash) {
                    // Allow numeric hashes
                    hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
                    var elm;
                    // empty hash, scroll to the top of the page
                    if (!hash) scrollTo(null);
                    else if (elm = document1.getElementById(hash)) scrollTo(elm);
                    else if (elm = getFirstAnchor(document1.getElementsByName(hash))) scrollTo(elm);
                    else if (hash === "top") scrollTo(null);
                }
                // does not scroll when user clicks on anchor link that is currently on
                // (no url change, no $location.hash() change), browser native does scroll
                if (autoScrollingEnabled) $rootScope.$watch(function autoScrollWatch() {
                    return $location.hash();
                }, function autoScrollWatchAction(newVal, oldVal) {
                    // skip the initial scroll if $location.hash is empty
                    if (newVal === oldVal && newVal === "") return;
                    jqLiteDocumentLoaded(function() {
                        $rootScope.$evalAsync(scroll);
                    });
                });
                return scroll;
            }
        ];
    }
    var $animateMinErr = minErr("$animate");
    var ELEMENT_NODE = 1;
    var NG_ANIMATE_CLASSNAME = "ng-animate";
    function mergeClasses(a, b) {
        if (!a && !b) return "";
        if (!a) return b;
        if (!b) return a;
        if (isArray(a)) a = a.join(" ");
        if (isArray(b)) b = b.join(" ");
        return a + " " + b;
    }
    function extractElementNode(element) {
        for(var i = 0; i < element.length; i++){
            var elm = element[i];
            if (elm.nodeType === ELEMENT_NODE) return elm;
        }
    }
    function splitClasses(classes) {
        if (isString(classes)) classes = classes.split(" ");
        // Use createMap() to prevent class assumptions involving property names in
        // Object.prototype
        var obj = createMap();
        forEach(classes, function(klass) {
            // sometimes the split leaves empty string values
            // incase extra spaces were applied to the options
            if (klass.length) obj[klass] = true;
        });
        return obj;
    }
    // if any other type of options value besides an Object value is
    // passed into the $animate.method() animation then this helper code
    // will be run which will ignore it. While this patch is not the
    // greatest solution to this, a lot of existing plugins depend on
    // $animate to either call the callback (< 1.2) or return a promise
    // that can be changed. This helper function ensures that the options
    // are wiped clean incase a callback function is provided.
    function prepareAnimateOptions(options) {
        return isObject(options) ? options : {};
    }
    var $$CoreAnimateJsProvider = /** @this */ function() {
        this.$get = noop;
    };
    // this is prefixed with Core since it conflicts with
    // the animateQueueProvider defined in ngAnimate/animateQueue.js
    var $$CoreAnimateQueueProvider = /** @this */ function() {
        var postDigestQueue = new NgMap();
        var postDigestElements = [];
        this.$get = [
            "$$AnimateRunner",
            "$rootScope",
            function($$AnimateRunner, $rootScope) {
                return {
                    enabled: noop,
                    on: noop,
                    off: noop,
                    pin: noop,
                    push: function(element, event, options, domOperation) {
                        if (domOperation) domOperation();
                        options = options || {};
                        if (options.from) element.css(options.from);
                        if (options.to) element.css(options.to);
                        if (options.addClass || options.removeClass) addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
                        var runner = new $$AnimateRunner();
                        // since there are no animations to run the runner needs to be
                        // notified that the animation call is complete.
                        runner.complete();
                        return runner;
                    }
                };
                function updateData(data, classes, value) {
                    var changed = false;
                    if (classes) {
                        classes = isString(classes) ? classes.split(" ") : isArray(classes) ? classes : [];
                        forEach(classes, function(className) {
                            if (className) {
                                changed = true;
                                data[className] = value;
                            }
                        });
                    }
                    return changed;
                }
                function handleCSSClassChanges() {
                    forEach(postDigestElements, function(element) {
                        var data = postDigestQueue.get(element);
                        if (data) {
                            var existing = splitClasses(element.attr("class"));
                            var toAdd = "";
                            var toRemove = "";
                            forEach(data, function(status, className) {
                                var hasClass = !!existing[className];
                                if (status !== hasClass) {
                                    if (status) toAdd += (toAdd.length ? " " : "") + className;
                                    else toRemove += (toRemove.length ? " " : "") + className;
                                }
                            });
                            forEach(element, function(elm) {
                                if (toAdd) jqLiteAddClass(elm, toAdd);
                                if (toRemove) jqLiteRemoveClass(elm, toRemove);
                            });
                            postDigestQueue.delete(element);
                        }
                    });
                    postDigestElements.length = 0;
                }
                function addRemoveClassesPostDigest(element, add, remove) {
                    var data = postDigestQueue.get(element) || {};
                    var classesAdded = updateData(data, add, true);
                    var classesRemoved = updateData(data, remove, false);
                    if (classesAdded || classesRemoved) {
                        postDigestQueue.set(element, data);
                        postDigestElements.push(element);
                        if (postDigestElements.length === 1) $rootScope.$$postDigest(handleCSSClassChanges);
                    }
                }
            }
        ];
    };
    /**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */ var $AnimateProvider = [
        "$provide",
        /** @this */ function($provide) {
            var provider = this;
            var classNameFilter = null;
            var customFilter = null;
            this.$$registeredAnimations = Object.create(null);
            /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */ this.register = function(name, factory) {
                if (name && name.charAt(0) !== ".") throw $animateMinErr("notcsel", "Expecting class selector starting with '.' got '{0}'.", name);
                var key = name + "-animation";
                provider.$$registeredAnimations[name.substr(1)] = key;
                $provide.factory(key, factory);
            };
            /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */ this.customFilter = function(filterFn) {
                if (arguments.length === 1) customFilter = isFunction(filterFn) ? filterFn : null;
                return customFilter;
            };
            /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */ this.classNameFilter = function(expression) {
                if (arguments.length === 1) {
                    classNameFilter = expression instanceof RegExp ? expression : null;
                    if (classNameFilter) {
                        var reservedRegex = new RegExp("[(\\s|\\/)]" + NG_ANIMATE_CLASSNAME + "[(\\s|\\/)]");
                        if (reservedRegex.test(classNameFilter.toString())) {
                            classNameFilter = null;
                            throw $animateMinErr("nongcls", '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
                        }
                    }
                }
                return classNameFilter;
            };
            this.$get = [
                "$$animateQueue",
                function($$animateQueue) {
                    function domInsert(element, parentElement, afterElement) {
                        // if for some reason the previous element was removed
                        // from the dom sometime before this code runs then let's
                        // just stick to using the parent element as the anchor
                        if (afterElement) {
                            var afterNode = extractElementNode(afterElement);
                            if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) afterElement = null;
                        }
                        if (afterElement) afterElement.after(element);
                        else parentElement.prepend(element);
                    }
                    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */ return {
                        // we don't call it directly since non-existant arguments may
                        // be interpreted as null within the sub enabled function
                        /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * <div class="alert alert-warning">
       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
       * However, there are two exceptions:
       *
       * <ul>
       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
       *   the `setClass` event, but if it either removes or adds classes,
       *   it will fire `animate` instead.</li>
       * </ul>
       *
       * </div>
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered.
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       * * `data` - an object with these properties:
       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
       *
       * Note that the callback does not trigger a scope digest. Wrap your call into a
       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
       */ on: $$animateQueue.on,
                        /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */ off: $$animateQueue.off,
                        /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */ pin: $$animateQueue.pin,
                        /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */ enabled: $$animateQueue.enabled,
                        /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation and applies the end state of the animation.
       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
       * adding the element to the DOM.
       *
       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
       *
       * @example
        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
          <file name="app.js">
            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
              templateUrl: 'template.html',
              controller: function($element, $animate) {
                this.runner = null;

                this.addClass = function() {
                  this.runner = $animate.addClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.removeClass = function() {
                  this.runner = $animate.removeClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.cancel = function() {
                  $animate.cancel(this.runner);
                };
              }
            });
          </file>
          <file name="template.html">
            <p>
              <button id="add" ng-click="$ctrl.addClass()">Add</button>
              <button ng-click="$ctrl.removeClass()">Remove</button>
              <br>
              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
              <br>
              <div id="target">CSS-Animated Text</div>
            </p>
          </file>
          <file name="index.html">
            <cancel-example></cancel-example>
          </file>
          <file name="style.css">
            .red-add, .red-remove {
              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
            }

            .red,
            .red-add.red-add-active {
              color: #FF0000;
              font-size: 40px;
            }

            .red-remove.red-remove-active {
              font-size: 10px;
              color: black;
            }

          </file>
        </example>
       */ cancel: function(runner) {
                            if (runner.cancel) runner.cancel();
                        },
                        /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ enter: function(element, parent, after, options) {
                            parent = parent && jqLite(parent);
                            after = after && jqLite(after);
                            parent = parent || after.parent();
                            domInsert(element, parent, after);
                            return $$animateQueue.push(element, "enter", prepareAnimateOptions(options));
                        },
                        /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ move: function(element, parent, after, options) {
                            parent = parent && jqLite(parent);
                            after = after && jqLite(after);
                            parent = parent || after.parent();
                            domInsert(element, parent, after);
                            return $$animateQueue.push(element, "move", prepareAnimateOptions(options));
                        },
                        /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ leave: function(element, options) {
                            return $$animateQueue.push(element, "leave", prepareAnimateOptions(options), function() {
                                element.remove();
                            });
                        },
                        /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} animationRunner the animation runner
       */ addClass: function(element, className, options) {
                            options = prepareAnimateOptions(options);
                            options.addClass = mergeClasses(options.addclass, className);
                            return $$animateQueue.push(element, "addClass", options);
                        },
                        /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ removeClass: function(element, className, options) {
                            options = prepareAnimateOptions(options);
                            options.removeClass = mergeClasses(options.removeClass, className);
                            return $$animateQueue.push(element, "removeClass", options);
                        },
                        /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ setClass: function(element, add, remove, options) {
                            options = prepareAnimateOptions(options);
                            options.addClass = mergeClasses(options.addClass, add);
                            options.removeClass = mergeClasses(options.removeClass, remove);
                            return $$animateQueue.push(element, "setClass", options);
                        },
                        /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */ animate: function(element, from, to, className, options) {
                            options = prepareAnimateOptions(options);
                            options.from = options.from ? extend(options.from, from) : from;
                            options.to = options.to ? extend(options.to, to) : to;
                            className = className || "ng-inline-animate";
                            options.tempClasses = mergeClasses(options.tempClasses, className);
                            return $$animateQueue.push(element, "animate", options);
                        }
                    };
                }
            ];
        }
    ];
    var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
        this.$get = [
            "$$rAF",
            function($$rAF) {
                var waitQueue = [];
                function waitForTick(fn) {
                    waitQueue.push(fn);
                    if (waitQueue.length > 1) return;
                    $$rAF(function() {
                        for(var i = 0; i < waitQueue.length; i++)waitQueue[i]();
                        waitQueue = [];
                    });
                }
                return function() {
                    var passed = false;
                    waitForTick(function() {
                        passed = true;
                    });
                    return function(callback) {
                        if (passed) callback();
                        else waitForTick(callback);
                    };
                };
            }
        ];
    };
    var $$AnimateRunnerFactoryProvider = /** @this */ function() {
        this.$get = [
            "$q",
            "$sniffer",
            "$$animateAsyncRun",
            "$$isDocumentHidden",
            "$timeout",
            function($q, $sniffer, $$animateAsyncRun, $$isDocumentHidden, $timeout) {
                var INITIAL_STATE = 0;
                var DONE_PENDING_STATE = 1;
                var DONE_COMPLETE_STATE = 2;
                AnimateRunner.chain = function(chain, callback) {
                    var index = 0;
                    next();
                    function next() {
                        if (index === chain.length) {
                            callback(true);
                            return;
                        }
                        chain[index](function(response) {
                            if (response === false) {
                                callback(false);
                                return;
                            }
                            index++;
                            next();
                        });
                    }
                };
                AnimateRunner.all = function(runners, callback) {
                    var count = 0;
                    var status = true;
                    forEach(runners, function(runner) {
                        runner.done(onProgress);
                    });
                    function onProgress(response) {
                        status = status && response;
                        if (++count === runners.length) callback(status);
                    }
                };
                function AnimateRunner(host) {
                    this.setHost(host);
                    var rafTick = $$animateAsyncRun();
                    var timeoutTick = function(fn) {
                        $timeout(fn, 0, false);
                    };
                    this._doneCallbacks = [];
                    this._tick = function(fn) {
                        if ($$isDocumentHidden()) timeoutTick(fn);
                        else rafTick(fn);
                    };
                    this._state = 0;
                }
                AnimateRunner.prototype = {
                    setHost: function(host) {
                        this.host = host || {};
                    },
                    done: function(fn) {
                        if (this._state === DONE_COMPLETE_STATE) fn();
                        else this._doneCallbacks.push(fn);
                    },
                    progress: noop,
                    getPromise: function() {
                        if (!this.promise) {
                            var self = this;
                            this.promise = $q(function(resolve, reject) {
                                self.done(function(status) {
                                    if (status === false) reject();
                                    else resolve();
                                });
                            });
                        }
                        return this.promise;
                    },
                    then: function(resolveHandler, rejectHandler) {
                        return this.getPromise().then(resolveHandler, rejectHandler);
                    },
                    "catch": function(handler) {
                        return this.getPromise()["catch"](handler);
                    },
                    "finally": function(handler) {
                        return this.getPromise()["finally"](handler);
                    },
                    pause: function() {
                        if (this.host.pause) this.host.pause();
                    },
                    resume: function() {
                        if (this.host.resume) this.host.resume();
                    },
                    end: function() {
                        if (this.host.end) this.host.end();
                        this._resolve(true);
                    },
                    cancel: function() {
                        if (this.host.cancel) this.host.cancel();
                        this._resolve(false);
                    },
                    complete: function(response) {
                        var self = this;
                        if (self._state === INITIAL_STATE) {
                            self._state = DONE_PENDING_STATE;
                            self._tick(function() {
                                self._resolve(response);
                            });
                        }
                    },
                    _resolve: function(response) {
                        if (this._state !== DONE_COMPLETE_STATE) {
                            forEach(this._doneCallbacks, function(fn) {
                                fn(response);
                            });
                            this._doneCallbacks.length = 0;
                            this._state = DONE_COMPLETE_STATE;
                        }
                    }
                };
                return AnimateRunner;
            }
        ];
    };
    /* exported $CoreAnimateCssProvider */ /**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */ var $CoreAnimateCssProvider = function() {
        this.$get = [
            "$$rAF",
            "$q",
            "$$AnimateRunner",
            function($$rAF, $q, $$AnimateRunner) {
                return function(element, initialOptions) {
                    // all of the animation functions should create
                    // a copy of the options data, however, if a
                    // parent service has already created a copy then
                    // we should stick to using that
                    var options = initialOptions || {};
                    if (!options.$$prepared) options = copy(options);
                    // there is no point in applying the styles since
                    // there is no animation that goes on at all in
                    // this version of $animateCss.
                    if (options.cleanupStyles) options.from = options.to = null;
                    if (options.from) {
                        element.css(options.from);
                        options.from = null;
                    }
                    var closed, runner = new $$AnimateRunner();
                    return {
                        start: run,
                        end: run
                    };
                    function run() {
                        $$rAF(function() {
                            applyAnimationContents();
                            if (!closed) runner.complete();
                            closed = true;
                        });
                        return runner;
                    }
                    function applyAnimationContents() {
                        if (options.addClass) {
                            element.addClass(options.addClass);
                            options.addClass = null;
                        }
                        if (options.removeClass) {
                            element.removeClass(options.removeClass);
                            options.removeClass = null;
                        }
                        if (options.to) {
                            element.css(options.to);
                            options.to = null;
                        }
                    }
                };
            }
        ];
    };
    /* global getHash: true, stripHash: false */ function getHash(url) {
        var index = url.indexOf("#");
        return index === -1 ? "" : url.substr(index);
    }
    function trimEmptyHash(url) {
        return url.replace(/#$/, "");
    }
    /**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */ /**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */ function Browser(window1, document1, $log, $sniffer, $$taskTrackerFactory) {
        var self = this, location = window1.location, history = window1.history, setTimeout = window1.setTimeout, clearTimeout = window1.clearTimeout, pendingDeferIds = {}, taskTracker = $$taskTrackerFactory($log);
        self.isMock = false;
        //////////////////////////////////////////////////////////////
        // Task-tracking API
        //////////////////////////////////////////////////////////////
        // TODO(vojta): remove this temporary api
        self.$$completeOutstandingRequest = taskTracker.completeTask;
        self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
        // TODO(vojta): prefix this method with $$ ?
        self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
        //////////////////////////////////////////////////////////////
        // URL API
        //////////////////////////////////////////////////////////////
        var cachedState, lastHistoryState, lastBrowserUrl = location.href, baseElement = document1.find("base"), pendingLocation = null, getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
            try {
                return history.state;
            } catch (e) {
            // MSIE can reportedly throw when there is no state (UNCONFIRMED).
            }
        };
        cacheState();
        /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of `location.href` (with a
   * trailing `#` stripped of if the hash is empty).
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
   * `location.href`/`location.replace` is used.
   * Returns its own instance to allow chaining.
   *
   * NOTE: this api is intended for use only by the `$location` service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state State object to use with `pushState`/`replaceState`
   */ self.url = function(url, replace, state) {
            // In modern browsers `history.state` is `null` by default; treating it separately
            // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
            // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
            if (isUndefined(state)) state = null;
            // Android Browser BFCache causes location, history reference to become stale.
            if (location !== window1.location) location = window1.location;
            if (history !== window1.history) history = window1.history;
            // setter
            if (url) {
                var sameState = lastHistoryState === state;
                // Normalize the inputted URL
                url = urlResolve(url).href;
                // Don't change anything if previous and current URLs and states match. This also prevents
                // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
                // See https://github.com/angular/angular.js/commit/ffb2701
                if (lastBrowserUrl === url && (!$sniffer.history || sameState)) return self;
                var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
                lastBrowserUrl = url;
                lastHistoryState = state;
                // Don't use history API if only the hash changed
                // due to a bug in IE10/IE11 which leads
                // to not firing a `hashchange` nor `popstate` event
                // in some cases (see #9143).
                if ($sniffer.history && (!sameBase || !sameState)) {
                    history[replace ? "replaceState" : "pushState"](state, "", url);
                    cacheState();
                } else {
                    if (!sameBase) pendingLocation = url;
                    if (replace) location.replace(url);
                    else if (!sameBase) location.href = url;
                    else location.hash = getHash(url);
                    if (location.href !== url) pendingLocation = url;
                }
                if (pendingLocation) pendingLocation = url;
                return self;
            // getter
            } else // - pendingLocation is needed as browsers don't allow to read out
            //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
            //   https://openradar.appspot.com/22186109).
            return trimEmptyHash(pendingLocation || location.href);
        };
        /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */ self.state = function() {
            return cachedState;
        };
        var urlChangeListeners = [], urlChangeInit = false;
        function cacheStateAndFireUrlChange() {
            pendingLocation = null;
            fireStateOrUrlChange();
        }
        // This variable should be used *only* inside the cacheState function.
        var lastCachedState = null;
        function cacheState() {
            // This should be the only place in $browser where `history.state` is read.
            cachedState = getCurrentState();
            cachedState = isUndefined(cachedState) ? null : cachedState;
            // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
            if (equals(cachedState, lastCachedState)) cachedState = lastCachedState;
            lastCachedState = cachedState;
            lastHistoryState = cachedState;
        }
        function fireStateOrUrlChange() {
            var prevLastHistoryState = lastHistoryState;
            cacheState();
            if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) return;
            lastBrowserUrl = self.url();
            lastHistoryState = cachedState;
            forEach(urlChangeListeners, function(listener) {
                listener(self.url(), cachedState);
            });
        }
        /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */ self.onUrlChange = function(callback) {
            // TODO(vojta): refactor to use node's syntax for events
            if (!urlChangeInit) {
                // We listen on both (hashchange/popstate) when available, as some browsers don't
                // fire popstate when user changes the address bar and don't fire hashchange when url
                // changed by push/replaceState
                // html5 history api - popstate event
                if ($sniffer.history) jqLite(window1).on("popstate", cacheStateAndFireUrlChange);
                // hashchange event
                jqLite(window1).on("hashchange", cacheStateAndFireUrlChange);
                urlChangeInit = true;
            }
            urlChangeListeners.push(callback);
            return callback;
        };
        /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */ self.$$applicationDestroyed = function() {
            jqLite(window1).off("hashchange popstate", cacheStateAndFireUrlChange);
        };
        /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */ self.$$checkUrlChange = fireStateOrUrlChange;
        //////////////////////////////////////////////////////////////
        // Misc API
        //////////////////////////////////////////////////////////////
        /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */ self.baseHref = function() {
            var href = baseElement.attr("href");
            return href ? href.replace(/^(https?:)?\/\/[^/]*/, "") : "";
        };
        /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */ self.defer = function(fn, delay, taskType) {
            var timeoutId;
            delay = delay || 0;
            taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
            taskTracker.incTaskCount(taskType);
            timeoutId = setTimeout(function() {
                delete pendingDeferIds[timeoutId];
                taskTracker.completeTask(fn, taskType);
            }, delay);
            pendingDeferIds[timeoutId] = taskType;
            return timeoutId;
        };
        /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */ self.defer.cancel = function(deferId) {
            if (pendingDeferIds.hasOwnProperty(deferId)) {
                var taskType = pendingDeferIds[deferId];
                delete pendingDeferIds[deferId];
                clearTimeout(deferId);
                taskTracker.completeTask(noop, taskType);
                return true;
            }
            return false;
        };
    }
    /** @this */ function $BrowserProvider() {
        this.$get = [
            "$window",
            "$log",
            "$sniffer",
            "$document",
            "$$taskTrackerFactory",
            function($window, $log, $sniffer, $document, $$taskTrackerFactory) {
                return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */ function $CacheFactoryProvider() {
        this.$get = function() {
            var caches = {};
            function cacheFactory(cacheId, options) {
                if (cacheId in caches) throw minErr("$cacheFactory")("iid", "CacheId '{0}' is already taken!", cacheId);
                var size = 0, stats = extend({}, options, {
                    id: cacheId
                }), data = createMap(), capacity = options && options.capacity || Number.MAX_VALUE, lruHash = createMap(), freshEnd = null, staleEnd = null;
                /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */ return caches[cacheId] = {
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */ put: function(key, value) {
                        if (isUndefined(value)) return;
                        if (capacity < Number.MAX_VALUE) {
                            var lruEntry = lruHash[key] || (lruHash[key] = {
                                key: key
                            });
                            refresh(lruEntry);
                        }
                        if (!(key in data)) size++;
                        data[key] = value;
                        if (size > capacity) this.remove(staleEnd.key);
                        return value;
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */ get: function(key) {
                        if (capacity < Number.MAX_VALUE) {
                            var lruEntry = lruHash[key];
                            if (!lruEntry) return;
                            refresh(lruEntry);
                        }
                        return data[key];
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */ remove: function(key) {
                        if (capacity < Number.MAX_VALUE) {
                            var lruEntry = lruHash[key];
                            if (!lruEntry) return;
                            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
                            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
                            link(lruEntry.n, lruEntry.p);
                            delete lruHash[key];
                        }
                        if (!(key in data)) return;
                        delete data[key];
                        size--;
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */ removeAll: function() {
                        data = createMap();
                        size = 0;
                        lruHash = createMap();
                        freshEnd = staleEnd = null;
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */ destroy: function() {
                        data = null;
                        stats = null;
                        lruHash = null;
                        delete caches[cacheId];
                    },
                    /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */ info: function() {
                        return extend({}, stats, {
                            size: size
                        });
                    }
                };
                /**
       * makes the `entry` the freshEnd of the LRU linked list
       */ function refresh(entry) {
                    if (entry !== freshEnd) {
                        if (!staleEnd) staleEnd = entry;
                        else if (staleEnd === entry) staleEnd = entry.n;
                        link(entry.n, entry.p);
                        link(entry, freshEnd);
                        freshEnd = entry;
                        freshEnd.n = null;
                    }
                }
                /**
       * bidirectionally links two entries of the LRU linked list
       */ function link(nextEntry, prevEntry) {
                    if (nextEntry !== prevEntry) {
                        if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
                        if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
                    }
                }
            }
            /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */ cacheFactory.info = function() {
                var info = {};
                forEach(caches, function(cache, cacheId) {
                    info[cacheId] = cache.info();
                });
                return info;
            };
            /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */ cacheFactory.get = function(cacheId) {
                return caches[cacheId];
            };
            return cacheFactory;
        };
    }
    /**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */ function $TemplateCacheProvider() {
        this.$get = [
            "$cacheFactory",
            function($cacheFactory) {
                return $cacheFactory("templates");
            }
        ];
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */ /**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance.)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
 *   isn't  optional and doesn't exist, an exception
 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
 *   to the local value, since it will be impossible to sync them back to the parent scope.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr`
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   It's also possible to watch the evaluated value shallowly with
 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
 * The marker must come after the mode and before the attribute name.
 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
 * This is useful to refine the interface directives provide.
 * One subtle difference between optional and non-optional happens **when the binding attribute is not
 * set**:
 * - the binding is optional: the property will not be defined
 * - the binding is not optional: the property is defined
 *
 * ```js
 *app.directive('testDir', function() {
    return {
      scope: {
        notoptional: '=',
        optional: '=?',
      },
      bindToController: true,
      controller: function() {
        this.$onInit = function() {
          console.log(this.hasOwnProperty('notoptional')) // true
          console.log(this.hasOwnProperty('optional')) // false
        }
      }
    }
  })
 *```
 *
 *
 * ##### Combining directives with different scope defintions
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that are defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // Configure new 'compile' directive by passing a directive
        // factory function. The factory function injects '$compile'.
        $compileProvider.directive('compile', function($compile) {
          // The directive factory creates a link function.
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                // Watch the 'compile' expression for changes.
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // When the 'compile' expression changes
                // assign it into the current DOM.
                element.html(value);

                // Compile the new DOM and link it to the current scope.
                // NOTE: we only compile '.childNodes' so that we
                // don't get into an infinite loop compiling ourselves.
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
 *        elements (e.g. SVG elements). See also the `directive.controller` property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to `$digest`, which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = angular.element('<p>{{total}}</p>');
 *     $compile(element)(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
 *   linking function:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>');
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       // Attach the clone to DOM document at the right place.
 *     });
 *
 *     // Now we have reference to the cloned DOM via `clonedElement`.
 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
 *     //       `clonedElement` passed to `cloneAttachFn`.
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */ /**
 * @ngdoc directive
 * @name ngProp
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-prop-propname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "propName"):
 *
 *
 * ```html
 * <ANY ng-prop-prop_name="expression">
 * </ANY>
 * ```
 *
 *
 * @description
 * The `ngProp` directive binds an expression to a DOM element property.
 * `ngProp` allows writing to arbitrary properties by including
 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
 * the `value` property.
 *
 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
 *
 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
 * custom elements.
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
 * example, and for binding HTML {@link ngBindHtml} should be used.
 *
 * ## Security
 *
 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
 * malicious code.
 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
 * This means vulnerable properties require their content to be "trusted", based on the
 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
 * this property are trusted as a `RESOURCE_URL`.
 *
 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
 *
 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
 *
 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
 *
 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
 *
 * ### HTML Sanitization
 *
 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
 * content.
 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
 * `innerHTML`.
 *
 * @example
 * ### Binding to different contexts
 *
 * <example name="ngProp" module="exampleNgProp">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         Binding to a property without security context:
 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerText</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... so that actually dangerous content cannot be executed:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Binding to innerHTML with ngSanitize
 *
 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', ['ngSanitize'])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         "Safe" content will be sanitized ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... as will dangerous content:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 */ /** @ngdoc directive
 * @name ngOn
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-on-eventname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "eventName"):
 *
 *
 * ```html
 * <ANY ng-on-event_name="expression">
 * </ANY>
 * ```
 *
 * @description
 * The `ngOn` directive adds an event listener to a DOM element via
 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
 * fired.
 * `ngOn` allows adding listeners for arbitrary events by including
 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
 * when the `drop` event is fired.
 *
 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
 * standards.
 *
 * Another use-case for `ngOn` is listening to
 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
 * fired by
 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `myEvent` must be written as `ng-on-my_event="expression"`.
 *
 * @example
 * ### Bind to built-in DOM events
 *
 * <example name="ngOn" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.clickCount = 0;
 *           this.mouseoverCount = 0;
 *
 *           this.loadingState = 0;
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
 *       <button
 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
 *       clickCount: {{$ctrl.clickCount}}<br>
 *       mouseover: {{$ctrl.mouseoverCount}}
 *
 *       <hr>
 *
 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
 *       <div ng-switch="$ctrl.loadingState">
 *         <span ng-switch-when="0">Image is loading</span>
 *         <span ng-switch-when="-1">Image load error</span>
 *         <span ng-switch-when="1">Image loaded successfully</span>
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Bind to custom DOM events
 *
 * <example name="ngOnCustom" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.eventLog = '';
 *
 *           this.listener = function($event) {
 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
 *           };
 *         }
 *       })
 *       .component('childComponent', {
 *         templateUrl: 'child.html',
 *         controller: function($element) {
 *           this.fireEvent = function() {
 *             var event = new CustomEvent('customtype', { detail: new Date()});
 *
 *             $element[0].dispatchEvent(event);
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
 *     <span>Event log: {{$ctrl.eventLog}}</span>
 *   </file>
 *   <file name="child.html">
      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 */ var $compileMinErr = minErr("$compile");
    function UNINITIALIZED_VALUE() {}
    var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
    /**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */ $CompileProvider.$inject = [
        "$provide",
        "$$sanitizeUriProvider"
    ];
    /** @this */ function $CompileProvider($provide, $$sanitizeUriProvider) {
        var hasDirectives = {}, Suffix = "Directive", COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/, CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/, ALL_OR_NOTHING_ATTRS = makeMap("ngSrc,ngSrcset,src,srcset"), REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
        // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
        // The assumption is that future DOM event attribute names will begin with
        // 'on' and be composed of only English letters.
        var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
        var bindingCache = createMap();
        function parseIsolateBindings(scope, directiveName, isController) {
            var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
            var bindings = createMap();
            forEach(scope, function(definition, scopeName) {
                definition = definition.trim();
                if (definition in bindingCache) {
                    bindings[scopeName] = bindingCache[definition];
                    return;
                }
                var match = definition.match(LOCAL_REGEXP);
                if (!match) throw $compileMinErr("iscp", "Invalid {3} for directive '{0}'. Definition: {... {1}: '{2}' ...}", directiveName, scopeName, definition, isController ? "controller bindings definition" : "isolate scope definition");
                bindings[scopeName] = {
                    mode: match[1][0],
                    collection: match[2] === "*",
                    optional: match[3] === "?",
                    attrName: match[4] || scopeName
                };
                if (match[4]) bindingCache[definition] = bindings[scopeName];
            });
            return bindings;
        }
        function parseDirectiveBindings(directive, directiveName) {
            var bindings = {
                isolateScope: null,
                bindToController: null
            };
            if (isObject(directive.scope)) {
                if (directive.bindToController === true) {
                    bindings.bindToController = parseIsolateBindings(directive.scope, directiveName, true);
                    bindings.isolateScope = {};
                } else bindings.isolateScope = parseIsolateBindings(directive.scope, directiveName, false);
            }
            if (isObject(directive.bindToController)) bindings.bindToController = parseIsolateBindings(directive.bindToController, directiveName, true);
            if (bindings.bindToController && !directive.controller) // There is no controller
            throw $compileMinErr("noctrl", "Cannot bind to controller without directive '{0}'s controller.", directiveName);
            return bindings;
        }
        function assertValidDirectiveName(name) {
            var letter = name.charAt(0);
            if (!letter || letter !== lowercase(letter)) throw $compileMinErr("baddir", "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
            if (name !== name.trim()) throw $compileMinErr("baddir", "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces", name);
        }
        function getDirectiveRequire(directive) {
            var require = directive.require || directive.controller && directive.name;
            if (!isArray(require) && isObject(require)) forEach(require, function(value, key) {
                var match = value.match(REQUIRE_PREFIX_REGEXP);
                var name = value.substring(match[0].length);
                if (!name) require[key] = match[0] + key;
            });
            return require;
        }
        function getDirectiveRestrict(restrict, name) {
            if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) throw $compileMinErr("badrestrict", "Restrict property '{0}' of directive '{1}' is invalid", restrict, name);
            return restrict || "EA";
        }
        /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
   *    are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */ this.directive = function registerDirective(name, directiveFactory) {
            assertArg(name, "name");
            assertNotHasOwnProperty(name, "directive");
            if (isString(name)) {
                assertValidDirectiveName(name);
                assertArg(directiveFactory, "directiveFactory");
                if (!hasDirectives.hasOwnProperty(name)) {
                    hasDirectives[name] = [];
                    $provide.factory(name + Suffix, [
                        "$injector",
                        "$exceptionHandler",
                        function($injector, $exceptionHandler) {
                            var directives = [];
                            forEach(hasDirectives[name], function(directiveFactory, index) {
                                try {
                                    var directive = $injector.invoke(directiveFactory);
                                    if (isFunction(directive)) directive = {
                                        compile: valueFn(directive)
                                    };
                                    else if (!directive.compile && directive.link) directive.compile = valueFn(directive.link);
                                    directive.priority = directive.priority || 0;
                                    directive.index = index;
                                    directive.name = directive.name || name;
                                    directive.require = getDirectiveRequire(directive);
                                    directive.restrict = getDirectiveRestrict(directive.restrict, name);
                                    directive.$$moduleName = directiveFactory.$$moduleName;
                                    directives.push(directive);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                            });
                            return directives;
                        }
                    ]);
                }
                hasDirectives[name].push(directiveFactory);
            } else forEach(name, reverseParams(registerDirective));
            return this;
        };
        /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */ this.component = function registerComponent(name, options) {
            if (!isString(name)) {
                forEach(name, reverseParams(bind(this, registerComponent)));
                return this;
            }
            var controller = options.controller || function() {};
            function factory($injector) {
                function makeInjectable(fn) {
                    if (isFunction(fn) || isArray(fn)) return /** @this */ function(tElement, tAttrs) {
                        return $injector.invoke(fn, this, {
                            $element: tElement,
                            $attrs: tAttrs
                        });
                    };
                    else return fn;
                }
                var template = !options.template && !options.templateUrl ? "" : options.template;
                var ddo = {
                    controller: controller,
                    controllerAs: identifierForController(options.controller) || options.controllerAs || "$ctrl",
                    template: makeInjectable(template),
                    templateUrl: makeInjectable(options.templateUrl),
                    transclude: options.transclude,
                    scope: {},
                    bindToController: options.bindings || {},
                    restrict: "E",
                    require: options.require
                };
                // Copy annotations (starting with $) over to the DDO
                forEach(options, function(val, key) {
                    if (key.charAt(0) === "$") ddo[key] = val;
                });
                return ddo;
            }
            // TODO(pete) remove the following `forEach` before we release 1.6.0
            // The component-router@0.2.0 looks for the annotations on the controller constructor
            // Nothing in AngularJS looks for annotations on the factory function but we can't remove
            // it from 1.5.x yet.
            // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
            // These could be used by libraries such as the new component router
            forEach(options, function(val, key) {
                if (key.charAt(0) === "$") {
                    factory[key] = val;
                    // Don't try to copy over annotations to named controller
                    if (isFunction(controller)) controller[key] = val;
                }
            });
            factory.$inject = [
                "$injector"
            ];
            return this.directive(name, factory);
        };
        /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.aHrefSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
                return this;
            } else return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
        };
        /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
   * aHrefSanitizationTrustedUrlList} instead.
   */ Object.defineProperty(this, "aHrefSanitizationWhitelist", {
            get: function() {
                return this.aHrefSanitizationTrustedUrlList;
            },
            set: function(value) {
                this.aHrefSanitizationTrustedUrlList = value;
            }
        });
        /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.imgSrcSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
                return this;
            } else return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
        };
        /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
   * imgSrcSanitizationTrustedUrlList} instead.
   */ Object.defineProperty(this, "imgSrcSanitizationWhitelist", {
            get: function() {
                return this.imgSrcSanitizationTrustedUrlList;
            },
            set: function(value) {
                this.imgSrcSanitizationTrustedUrlList = value;
            }
        });
        /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */ var debugInfoEnabled = true;
        this.debugInfoEnabled = function(enabled) {
            if (isDefined(enabled)) {
                debugInfoEnabled = enabled;
                return this;
            }
            return debugInfoEnabled;
        };
        /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
   * otherwise return the current strictComponentBindingsEnabled state.
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable / disable the strict component bindings check. If enabled, the
   * compiler will enforce that all scope / controller bindings of a
   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
   * that are not set as optional with `?`, must be provided when the directive is instantiated.
   * If not provided, the compiler will throw the
   * {@link error/$compile/missingattr $compile:missingattr error}.
   *
   * The default value is false.
   */ var strictComponentBindingsEnabled = false;
        this.strictComponentBindingsEnabled = function(enabled) {
            if (isDefined(enabled)) {
                strictComponentBindingsEnabled = enabled;
                return this;
            }
            return strictComponentBindingsEnabled;
        };
        var TTL = 10;
        /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */ this.onChangesTtl = function(value) {
            if (arguments.length) {
                TTL = value;
                return this;
            }
            return TTL;
        };
        var commentDirectivesEnabledConfig = true;
        /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */ this.commentDirectivesEnabled = function(value) {
            if (arguments.length) {
                commentDirectivesEnabledConfig = value;
                return this;
            }
            return commentDirectivesEnabledConfig;
        };
        var cssClassDirectivesEnabledConfig = true;
        /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */ this.cssClassDirectivesEnabled = function(value) {
            if (arguments.length) {
                cssClassDirectivesEnabledConfig = value;
                return this;
            }
            return cssClassDirectivesEnabledConfig;
        };
        /**
   * The security context of DOM Properties.
   * @private
   */ var PROP_CONTEXTS = createMap();
        /**
   * @ngdoc method
   * @name $compileProvider#addPropertySecurityContext
   * @description
   *
   * Defines the security context for DOM properties bound by ng-prop-*.
   *
   * @param {string} elementName The element name or '*' to match any element.
   * @param {string} propertyName The DOM property name.
   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
   * @returns {object} `this` for chaining
   */ this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
            var key = elementName.toLowerCase() + "|" + propertyName.toLowerCase();
            if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) throw $compileMinErr("ctxoverride", "Property context '{0}.{1}' already set to '{2}', cannot override to '{3}'.", elementName, propertyName, PROP_CONTEXTS[key], ctx);
            PROP_CONTEXTS[key] = ctx;
            return this;
        };
        /* Default property contexts.
   *
   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
   * Changing:
   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
   * - STYLE => CSS
   * - various URL => MEDIA_URL
   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
   */ (function registerNativePropertyContexts() {
            function registerContext(ctx, values) {
                forEach(values, function(v) {
                    PROP_CONTEXTS[v.toLowerCase()] = ctx;
                });
            }
            registerContext(SCE_CONTEXTS.HTML, [
                "iframe|srcdoc",
                "*|innerHTML",
                "*|outerHTML"
            ]);
            registerContext(SCE_CONTEXTS.CSS, [
                "*|style"
            ]);
            registerContext(SCE_CONTEXTS.URL, [
                "area|href",
                "area|ping",
                "a|href",
                "a|ping",
                "blockquote|cite",
                "body|background",
                "del|cite",
                "input|src",
                "ins|cite",
                "q|cite"
            ]);
            registerContext(SCE_CONTEXTS.MEDIA_URL, [
                "audio|src",
                "img|src",
                "img|srcset",
                "source|src",
                "source|srcset",
                "track|src",
                "video|src",
                "video|poster"
            ]);
            registerContext(SCE_CONTEXTS.RESOURCE_URL, [
                "*|formAction",
                "applet|code",
                "applet|codebase",
                "base|href",
                "embed|src",
                "frame|src",
                "form|action",
                "head|profile",
                "html|manifest",
                "iframe|src",
                "link|href",
                "media|src",
                "object|codebase",
                "object|data",
                "script|src"
            ]);
        })();
        this.$get = [
            "$injector",
            "$interpolate",
            "$exceptionHandler",
            "$templateRequest",
            "$parse",
            "$controller",
            "$rootScope",
            "$sce",
            "$animate",
            function($injector, $interpolate, $exceptionHandler, $templateRequest, $parse, $controller, $rootScope, $sce, $animate) {
                var SIMPLE_ATTR_NAME = /^\w/;
                var specialAttrHolder = window1.document.createElement("div");
                var commentDirectivesEnabled = commentDirectivesEnabledConfig;
                var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
                var onChangesTtl = TTL;
                // The onChanges hooks should all be run together in a single digest
                // When changes occur, the call to trigger their hooks will be added to this queue
                var onChangesQueue;
                // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
                function flushOnChangesQueue() {
                    try {
                        if (!--onChangesTtl) {
                            // We have hit the TTL limit so reset everything
                            onChangesQueue = undefined;
                            throw $compileMinErr("infchng", "{0} $onChanges() iterations reached. Aborting!\n", TTL);
                        }
                        // We must run this hook in an apply since the $$postDigest runs outside apply
                        $rootScope.$apply(function() {
                            for(var i = 0, ii = onChangesQueue.length; i < ii; ++i)try {
                                onChangesQueue[i]();
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                            // Reset the queue to trigger a new schedule next time there is a change
                            onChangesQueue = undefined;
                        });
                    } finally{
                        onChangesTtl++;
                    }
                }
                function sanitizeSrcset(value, invokeType) {
                    if (!value) return value;
                    if (!isString(value)) throw $compileMinErr("srcset", 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
                    // Such values are a bit too complex to handle automatically inside $sce.
                    // Instead, we sanitize each of the URIs individually, which works, even dynamically.
                    // It's not possible to work around this using `$sce.trustAsMediaUrl`.
                    // If you want to programmatically set explicitly trusted unsafe URLs, you should use
                    // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
                    // `ng-bind-html` directive.
                    var result = "";
                    // first check if there are spaces because it's not the same pattern
                    var trimmedSrcset = trim(value);
                    //                (   999x   ,|   999w   ,|   ,|,   )
                    var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
                    var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
                    // split srcset into tuple of uri and descriptor except for the last item
                    var rawUris = trimmedSrcset.split(pattern);
                    // for each tuples
                    var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
                    for(var i = 0; i < nbrUrisWith2parts; i++){
                        var innerIdx = i * 2;
                        // sanitize the uri
                        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
                        // add the descriptor
                        result += " " + trim(rawUris[innerIdx + 1]);
                    }
                    // split the last item into uri and descriptor
                    var lastTuple = trim(rawUris[i * 2]).split(/\s/);
                    // sanitize the last uri
                    result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
                    // and add the last descriptor if any
                    if (lastTuple.length === 2) result += " " + trim(lastTuple[1]);
                    return result;
                }
                function Attributes(element, attributesToCopy) {
                    if (attributesToCopy) {
                        var keys = Object.keys(attributesToCopy);
                        var i, l, key;
                        for(i = 0, l = keys.length; i < l; i++){
                            key = keys[i];
                            this[key] = attributesToCopy[key];
                        }
                    } else this.$attr = {};
                    this.$$element = element;
                }
                Attributes.prototype = {
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */ $normalize: directiveNormalize,
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */ $addClass: function(classVal) {
                        if (classVal && classVal.length > 0) $animate.addClass(this.$$element, classVal);
                    },
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */ $removeClass: function(classVal) {
                        if (classVal && classVal.length > 0) $animate.removeClass(this.$$element, classVal);
                    },
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */ $updateClass: function(newClasses, oldClasses) {
                        var toAdd = tokenDifference(newClasses, oldClasses);
                        if (toAdd && toAdd.length) $animate.addClass(this.$$element, toAdd);
                        var toRemove = tokenDifference(oldClasses, newClasses);
                        if (toRemove && toRemove.length) $animate.removeClass(this.$$element, toRemove);
                    },
                    /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */ $set: function(key, value, writeAttr, attrName) {
                        // TODO: decide whether or not to throw an error if "class"
                        // is set through this function since it may cause $updateClass to
                        // become unstable.
                        var node = this.$$element[0], booleanKey = getBooleanAttrName(node, key), aliasedKey = getAliasedAttrName(key), observer = key, nodeName;
                        if (booleanKey) {
                            this.$$element.prop(key, value);
                            attrName = booleanKey;
                        } else if (aliasedKey) {
                            this[aliasedKey] = value;
                            observer = aliasedKey;
                        }
                        this[key] = value;
                        // translate normalized key to actual key
                        if (attrName) this.$attr[key] = attrName;
                        else {
                            attrName = this.$attr[key];
                            if (!attrName) this.$attr[key] = attrName = snake_case(key, "-");
                        }
                        nodeName = nodeName_(this.$$element);
                        // Sanitize img[srcset] values.
                        if (nodeName === "img" && key === "srcset") this[key] = value = sanitizeSrcset(value, "$set('srcset', value)");
                        if (writeAttr !== false) {
                            if (value === null || isUndefined(value)) this.$$element.removeAttr(attrName);
                            else if (SIMPLE_ATTR_NAME.test(attrName)) {
                                // jQuery skips special boolean attrs treatment in XML nodes for
                                // historical reasons and hence AngularJS cannot freely call
                                // `.attr(attrName, false) with such attributes. To avoid issues
                                // in XHTML, call `removeAttr` in such cases instead.
                                // See https://github.com/jquery/jquery/issues/4249
                                if (booleanKey && value === false) this.$$element.removeAttr(attrName);
                                else this.$$element.attr(attrName, value);
                            } else setSpecialAttr(this.$$element[0], attrName, value);
                        }
                        // fire observers
                        var $$observers = this.$$observers;
                        if ($$observers) forEach($$observers[observer], function(fn) {
                            try {
                                fn(value);
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                        });
                    },
                    /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */ $observe: function(key, fn) {
                        var attrs = this, $$observers = attrs.$$observers || (attrs.$$observers = createMap()), listeners = $$observers[key] || ($$observers[key] = []);
                        listeners.push(fn);
                        $rootScope.$evalAsync(function() {
                            if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) // no one registered attribute interpolation function, so lets call it manually
                            fn(attrs[key]);
                        });
                        return function() {
                            arrayRemove(listeners, fn);
                        };
                    }
                };
                function setSpecialAttr(element, attrName, value) {
                    // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
                    // so we have to jump through some hoops to get such an attribute
                    // https://github.com/angular/angular.js/pull/13318
                    specialAttrHolder.innerHTML = "<span " + attrName + ">";
                    var attributes = specialAttrHolder.firstChild.attributes;
                    var attribute = attributes[0];
                    // We have to remove the attribute from its container element before we can add it to the destination element
                    attributes.removeNamedItem(attribute.name);
                    attribute.value = value;
                    element.attributes.setNamedItem(attribute);
                }
                function safeAddClass($element, className) {
                    try {
                        $element.addClass(className);
                    } catch (e) {
                    // ignore, since it means that we are trying to set class on
                    // SVG element, where class name is read-only.
                    }
                }
                var startSymbol = $interpolate.startSymbol(), endSymbol = $interpolate.endSymbol(), denormalizeTemplate = startSymbol === "{{" && endSymbol === "}}" ? identity : function denormalizeTemplate(template) {
                    return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
                }, NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
                var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
                compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
                    var bindings = $element.data("$binding") || [];
                    if (isArray(binding)) bindings = bindings.concat(binding);
                    else bindings.push(binding);
                    $element.data("$binding", bindings);
                } : noop;
                compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
                    safeAddClass($element, "ng-binding");
                } : noop;
                compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
                    var dataName = isolated ? noTemplate ? "$isolateScopeNoTemplate" : "$isolateScope" : "$scope";
                    $element.data(dataName, scope);
                } : noop;
                compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
                    safeAddClass($element, isolated ? "ng-isolate-scope" : "ng-scope");
                } : noop;
                compile.$$createComment = function(directiveName, comment) {
                    var content = "";
                    if (debugInfoEnabled) {
                        content = " " + (directiveName || "") + ": ";
                        if (comment) content += comment + " ";
                    }
                    return window1.document.createComment(content);
                };
                return compile;
                //================================
                function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
                    if (!($compileNodes instanceof jqLite)) // jquery always rewraps, whereas we need to preserve the original selector so that we can
                    // modify it.
                    $compileNodes = jqLite($compileNodes);
                    var compositeLinkFn = compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);
                    compile.$$addScopeClass($compileNodes);
                    var namespace = null;
                    return function publicLinkFn(scope, cloneConnectFn, options) {
                        if (!$compileNodes) throw $compileMinErr("multilink", "This element has already been linked.");
                        assertArg(scope, "scope");
                        if (previousCompileContext && previousCompileContext.needsNewScope) // A parent directive did a replace and a directive on this element asked
                        // for transclusion, which caused us to lose a layer of element on which
                        // we could hold the new transclusion scope, so we will create it manually
                        // here.
                        scope = scope.$parent.$new();
                        options = options || {};
                        var parentBoundTranscludeFn = options.parentBoundTranscludeFn, transcludeControllers = options.transcludeControllers, futureParentElement = options.futureParentElement;
                        // When `parentBoundTranscludeFn` is passed, it is a
                        // `controllersBoundTransclude` function (it was previously passed
                        // as `transclude` to directive.link) so we must unwrap it to get
                        // its `boundTranscludeFn`
                        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
                        if (!namespace) namespace = detectNamespaceForChildElements(futureParentElement);
                        var $linkNode;
                        if (namespace !== "html") // When using a directive with replace:true and templateUrl the $compileNodes
                        // (or a child element inside of them)
                        // might change, so we need to recreate the namespace adapted compileNodes
                        // for call to the link function.
                        // Note: This will already clone the nodes...
                        $linkNode = jqLite(wrapTemplate(namespace, jqLite("<div></div>").append($compileNodes).html()));
                        else if (cloneConnectFn) // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
                        // and sometimes changes the structure of the DOM.
                        $linkNode = JQLitePrototype.clone.call($compileNodes);
                        else $linkNode = $compileNodes;
                        if (transcludeControllers) for(var controllerName in transcludeControllers)$linkNode.data("$" + controllerName + "Controller", transcludeControllers[controllerName].instance);
                        compile.$$addScopeInfo($linkNode, scope);
                        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
                        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
                        if (!cloneConnectFn) $compileNodes = compositeLinkFn = null;
                        return $linkNode;
                    };
                }
                function detectNamespaceForChildElements(parentElement) {
                    // TODO: Make this detect MathML as well...
                    var node = parentElement && parentElement[0];
                    if (!node) return "html";
                    else return nodeName_(node) !== "foreignobject" && toString.call(node).match(/SVG/) ? "svg" : "html";
                }
                /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */ function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext) {
                    var linkFns = [], // `nodeList` can be either an element's `.childNodes` (live NodeList)
                    // or a jqLite/jQuery collection or an array
                    notLiveList = isArray(nodeList) || nodeList instanceof jqLite, attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
                    for(var i = 0; i < nodeList.length; i++){
                        attrs = new Attributes();
                        // Support: IE 11 only
                        // Workaround for #11781 and #14924
                        if (msie === 11) mergeConsecutiveTextNodes(nodeList, i, notLiveList);
                        // We must always refer to `nodeList[i]` hereafter,
                        // since the nodes can be replaced underneath us.
                        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined, ignoreDirective);
                        nodeLinkFn = directives.length ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext) : null;
                        if (nodeLinkFn && nodeLinkFn.scope) compile.$$addScopeClass(attrs.$$element);
                        childLinkFn = nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length ? null : compileNodes(childNodes, nodeLinkFn ? (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude : transcludeFn);
                        if (nodeLinkFn || childLinkFn) {
                            linkFns.push(i, nodeLinkFn, childLinkFn);
                            linkFnFound = true;
                            nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
                        }
                        //use the previous context only for the first element in the virtual group
                        previousCompileContext = null;
                    }
                    // return a linking function if we have found anything, null otherwise
                    return linkFnFound ? compositeLinkFn : null;
                    function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
                        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
                        var stableNodeList;
                        if (nodeLinkFnFound) {
                            // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
                            // offsets don't get screwed up
                            var nodeListLength = nodeList.length;
                            stableNodeList = new Array(nodeListLength);
                            // create a sparse array by only copying the elements which have a linkFn
                            for(i = 0; i < linkFns.length; i += 3){
                                idx = linkFns[i];
                                stableNodeList[idx] = nodeList[idx];
                            }
                        } else stableNodeList = nodeList;
                        for(i = 0, ii = linkFns.length; i < ii;){
                            node = stableNodeList[linkFns[i++]];
                            nodeLinkFn = linkFns[i++];
                            childLinkFn = linkFns[i++];
                            if (nodeLinkFn) {
                                if (nodeLinkFn.scope) {
                                    childScope = scope.$new();
                                    compile.$$addScopeInfo(jqLite(node), childScope);
                                } else childScope = scope;
                                if (nodeLinkFn.transcludeOnThisElement) childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
                                else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) childBoundTranscludeFn = parentBoundTranscludeFn;
                                else if (!parentBoundTranscludeFn && transcludeFn) childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
                                else childBoundTranscludeFn = null;
                                nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
                            } else if (childLinkFn) childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
                        }
                    }
                }
                function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
                    var node = nodeList[idx];
                    var parent = node.parentNode;
                    var sibling;
                    if (node.nodeType !== NODE_TYPE_TEXT) return;
                    while(true){
                        sibling = parent ? node.nextSibling : nodeList[idx + 1];
                        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) break;
                        node.nodeValue = node.nodeValue + sibling.nodeValue;
                        if (sibling.parentNode) sibling.parentNode.removeChild(sibling);
                        if (notLiveList && sibling === nodeList[idx + 1]) nodeList.splice(idx + 1, 1);
                    }
                }
                function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
                    function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
                        if (!transcludedScope) {
                            transcludedScope = scope.$new(false, containingScope);
                            transcludedScope.$$transcluded = true;
                        }
                        return transcludeFn(transcludedScope, cloneFn, {
                            parentBoundTranscludeFn: previousBoundTranscludeFn,
                            transcludeControllers: controllers,
                            futureParentElement: futureParentElement
                        });
                    }
                    // We need  to attach the transclusion slots onto the `boundTranscludeFn`
                    // so that they are available inside the `controllersBoundTransclude` function
                    var boundSlots = boundTranscludeFn.$$slots = createMap();
                    for(var slotName in transcludeFn.$$slots)if (transcludeFn.$$slots[slotName]) boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
                    else boundSlots[slotName] = null;
                    return boundTranscludeFn;
                }
                /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */ function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
                    var nodeType = node.nodeType, attrsMap = attrs.$attr, match, nodeName, className;
                    switch(nodeType){
                        case NODE_TYPE_ELEMENT:
                            /* Element */ nodeName = nodeName_(node);
                            // use the node name: <directive>
                            addDirective(directives, directiveNormalize(nodeName), "E", maxPriority, ignoreDirective);
                            // iterate over the attributes
                            for(var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes, j = 0, jj = nAttrs && nAttrs.length; j < jj; j++){
                                var attrStartName = false;
                                var attrEndName = false;
                                var isNgAttr = false, isNgProp = false, isNgEvent = false;
                                var multiElementMatch;
                                attr = nAttrs[j];
                                name = attr.name;
                                value = attr.value;
                                nName = directiveNormalize(name.toLowerCase());
                                // Support ng-attr-*, ng-prop-* and ng-on-*
                                if (ngPrefixMatch = nName.match(NG_PREFIX_BINDING)) {
                                    isNgAttr = ngPrefixMatch[1] === "Attr";
                                    isNgProp = ngPrefixMatch[1] === "Prop";
                                    isNgEvent = ngPrefixMatch[1] === "On";
                                    // Normalize the non-prefixed name
                                    name = name.replace(PREFIX_REGEXP, "").toLowerCase().substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
                                        return letter.toUpperCase();
                                    });
                                // Support *-start / *-end multi element directives
                                } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
                                    attrStartName = name;
                                    attrEndName = name.substr(0, name.length - 5) + "end";
                                    name = name.substr(0, name.length - 6);
                                }
                                if (isNgProp || isNgEvent) {
                                    attrs[nName] = value;
                                    attrsMap[nName] = attr.name;
                                    if (isNgProp) addPropertyDirective(node, directives, nName, name);
                                    else addEventDirective(directives, nName, name);
                                } else {
                                    // Update nName for cases where a prefix was removed
                                    // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
                                    nName = directiveNormalize(name.toLowerCase());
                                    attrsMap[nName] = name;
                                    if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                                        attrs[nName] = value;
                                        if (getBooleanAttrName(node, nName)) attrs[nName] = true; // presence means true
                                    }
                                    addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
                                    addDirective(directives, nName, "A", maxPriority, ignoreDirective, attrStartName, attrEndName);
                                }
                            }
                            if (nodeName === "input" && node.getAttribute("type") === "hidden") // Hidden input elements can have strange behaviour when navigating back to the page
                            // This tells the browser not to try to cache and reinstate previous values
                            node.setAttribute("autocomplete", "off");
                            // use class as directive
                            if (!cssClassDirectivesEnabled) break;
                            className = node.className;
                            if (isObject(className)) // Maybe SVGAnimatedString
                            className = className.animVal;
                            if (isString(className) && className !== "") while(match = CLASS_DIRECTIVE_REGEXP.exec(className)){
                                nName = directiveNormalize(match[2]);
                                if (addDirective(directives, nName, "C", maxPriority, ignoreDirective)) attrs[nName] = trim(match[3]);
                                className = className.substr(match.index + match[0].length);
                            }
                            break;
                        case NODE_TYPE_TEXT:
                            /* Text Node */ addTextInterpolateDirective(directives, node.nodeValue);
                            break;
                        case NODE_TYPE_COMMENT:
                            /* Comment */ if (!commentDirectivesEnabled) break;
                            collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
                            break;
                    }
                    directives.sort(byPriority);
                    return directives;
                }
                function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
                    // function created because of performance, try/catch disables
                    // the optimization of the whole function #14848
                    try {
                        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
                        if (match) {
                            var nName = directiveNormalize(match[1]);
                            if (addDirective(directives, nName, "M", maxPriority, ignoreDirective)) attrs[nName] = trim(match[2]);
                        }
                    } catch (e) {
                    // turns out that under some circumstances IE9 throws errors when one attempts to read
                    // comment's node value.
                    // Just ignore it and continue. (Can't seem to reproduce in test case.)
                    }
                }
                /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */ function groupScan(node, attrStart, attrEnd) {
                    var nodes = [];
                    var depth = 0;
                    if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) do {
                        if (!node) throw $compileMinErr("uterdir", "Unterminated attribute, found '{0}' but no matching '{1}' found.", attrStart, attrEnd);
                        if (node.nodeType === NODE_TYPE_ELEMENT) {
                            if (node.hasAttribute(attrStart)) depth++;
                            if (node.hasAttribute(attrEnd)) depth--;
                        }
                        nodes.push(node);
                        node = node.nextSibling;
                    }while (depth > 0);
                    else nodes.push(node);
                    return jqLite(nodes);
                }
                /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */ function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
                    return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
                        element = groupScan(element[0], attrStart, attrEnd);
                        return linkFn(scope, element, attrs, controllers, transcludeFn);
                    };
                }
                /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */ function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
                    var compiled;
                    if (eager) return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
                    return /** @this */ function lazyCompilation() {
                        if (!compiled) {
                            compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
                            // Null out all of these references in order to make them eligible for garbage collection
                            // since this is a potentially long lived closure
                            $compileNodes = transcludeFn = previousCompileContext = null;
                        }
                        return compiled.apply(this, arguments);
                    };
                }
                /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */ function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext) {
                    previousCompileContext = previousCompileContext || {};
                    var terminalPriority = -Number.MAX_VALUE, newScopeDirective = previousCompileContext.newScopeDirective, controllerDirectives = previousCompileContext.controllerDirectives, newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective, templateDirective = previousCompileContext.templateDirective, nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective, hasTranscludeDirective = false, hasTemplate = false, hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective, $compileNode = templateAttrs.$$element = jqLite(compileNode), directive, directiveName, $template, replaceDirective = originalReplaceDirective, childTranscludeFn = transcludeFn, linkFn, didScanForMultipleTransclusion = false, mightHaveMultipleTransclusionError = false, directiveValue;
                    // executes all directives on the current element
                    for(var i = 0, ii = directives.length; i < ii; i++){
                        directive = directives[i];
                        var attrStart = directive.$$start;
                        var attrEnd = directive.$$end;
                        // collect multiblock sections
                        if (attrStart) $compileNode = groupScan(compileNode, attrStart, attrEnd);
                        $template = undefined;
                        if (terminalPriority > directive.priority) break; // prevent further processing of directives
                        directiveValue = directive.scope;
                        if (directiveValue) {
                            // skip the check for directives with async templates, we'll check the derived sync
                            // directive when the template arrives
                            if (!directive.templateUrl) {
                                if (isObject(directiveValue)) {
                                    // This directive is trying to add an isolated scope.
                                    // Check that there is no scope of any kind already
                                    assertNoDuplicate("new/isolated scope", newIsolateScopeDirective || newScopeDirective, directive, $compileNode);
                                    newIsolateScopeDirective = directive;
                                } else // This directive is trying to add a child scope.
                                // Check that there is no isolated scope already
                                assertNoDuplicate("new/isolated scope", newIsolateScopeDirective, directive, $compileNode);
                            }
                            newScopeDirective = newScopeDirective || directive;
                        }
                        directiveName = directive.name;
                        // If we encounter a condition that can result in transclusion on the directive,
                        // then scan ahead in the remaining directives for others that may cause a multiple
                        // transclusion error to be thrown during the compilation process.  If a matching directive
                        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
                        // compile the `transclude` function rather than doing it lazily in order to throw
                        // exceptions at the correct time
                        if (!didScanForMultipleTransclusion && (directive.replace && (directive.templateUrl || directive.template) || directive.transclude && !directive.$$tlb)) {
                            var candidateDirective;
                            for(var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];)if (candidateDirective.transclude && !candidateDirective.$$tlb || candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template)) {
                                mightHaveMultipleTransclusionError = true;
                                break;
                            }
                            didScanForMultipleTransclusion = true;
                        }
                        if (!directive.templateUrl && directive.controller) {
                            controllerDirectives = controllerDirectives || createMap();
                            assertNoDuplicate("'" + directiveName + "' controller", controllerDirectives[directiveName], directive, $compileNode);
                            controllerDirectives[directiveName] = directive;
                        }
                        directiveValue = directive.transclude;
                        if (directiveValue) {
                            hasTranscludeDirective = true;
                            // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
                            // This option should only be used by directives that know how to safely handle element transclusion,
                            // where the transcluded nodes are added or replaced after linking.
                            if (!directive.$$tlb) {
                                assertNoDuplicate("transclusion", nonTlbTranscludeDirective, directive, $compileNode);
                                nonTlbTranscludeDirective = directive;
                            }
                            if (directiveValue === "element") {
                                hasElementTranscludeDirective = true;
                                terminalPriority = directive.priority;
                                $template = $compileNode;
                                $compileNode = templateAttrs.$$element = jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
                                compileNode = $compileNode[0];
                                replaceWith(jqCollection, sliceArgs($template), compileNode);
                                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {
                                    // Don't pass in:
                                    // - controllerDirectives - otherwise we'll create duplicates controllers
                                    // - newIsolateScopeDirective or templateDirective - combining templates with
                                    //   element transclusion doesn't make sense.
                                    //
                                    // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                    // on the same element more than once.
                                    nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                });
                            } else {
                                var slots = createMap();
                                if (!isObject(directiveValue)) $template = jqLite(jqLiteClone(compileNode)).contents();
                                else {
                                    // We have transclusion slots,
                                    // collect them up, compile them and store their transclusion functions
                                    $template = window1.document.createDocumentFragment();
                                    var slotMap = createMap();
                                    var filledSlots = createMap();
                                    // Parse the element selectors
                                    forEach(directiveValue, function(elementSelector, slotName) {
                                        // If an element selector starts with a ? then it is optional
                                        var optional = elementSelector.charAt(0) === "?";
                                        elementSelector = optional ? elementSelector.substring(1) : elementSelector;
                                        slotMap[elementSelector] = slotName;
                                        // We explicitly assign `null` since this implies that a slot was defined but not filled.
                                        // Later when calling boundTransclusion functions with a slot name we only error if the
                                        // slot is `undefined`
                                        slots[slotName] = null;
                                        // filledSlots contains `true` for all slots that are either optional or have been
                                        // filled. This is used to check that we have not missed any required slots
                                        filledSlots[slotName] = optional;
                                    });
                                    // Add the matching elements into their slot
                                    forEach($compileNode.contents(), function(node) {
                                        var slotName = slotMap[directiveNormalize(nodeName_(node))];
                                        if (slotName) {
                                            filledSlots[slotName] = true;
                                            slots[slotName] = slots[slotName] || window1.document.createDocumentFragment();
                                            slots[slotName].appendChild(node);
                                        } else $template.appendChild(node);
                                    });
                                    // Check for required slots that were not filled
                                    forEach(filledSlots, function(filled, slotName) {
                                        if (!filled) throw $compileMinErr("reqslot", "Required transclusion slot `{0}` was not filled.", slotName);
                                    });
                                    for(var slotName in slots)if (slots[slotName]) {
                                        // Only define a transclusion function if the slot was filled
                                        var slotCompileNodes = jqLite(slots[slotName].childNodes);
                                        slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                                    }
                                    $template = jqLite($template.childNodes);
                                }
                                $compileNode.empty(); // clear contents
                                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined, undefined, {
                                    needsNewScope: directive.$$isolateScope || directive.$$newScope
                                });
                                childTranscludeFn.$$slots = slots;
                            }
                        }
                        if (directive.template) {
                            hasTemplate = true;
                            assertNoDuplicate("template", templateDirective, directive, $compileNode);
                            templateDirective = directive;
                            directiveValue = isFunction(directive.template) ? directive.template($compileNode, templateAttrs) : directive.template;
                            directiveValue = denormalizeTemplate(directiveValue);
                            if (directive.replace) {
                                replaceDirective = directive;
                                if (jqLiteIsTextNode(directiveValue)) $template = [];
                                else $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
                                compileNode = $template[0];
                                if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) throw $compileMinErr("tplrt", "Template for directive '{0}' must have exactly one root element. {1}", directiveName, "");
                                replaceWith(jqCollection, $compileNode, compileNode);
                                var newTemplateAttrs = {
                                    $attr: {}
                                };
                                // combine directives from the original node and from the template:
                                // - take the array of directives for this element
                                // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
                                // - collect directives from the template and sort them by priority
                                // - combine directives as: processed + template + unprocessed
                                var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
                                var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
                                if (newIsolateScopeDirective || newScopeDirective) // The original directive caused the current element to be replaced but this element
                                // also needs to have a new scope, so we need to tell the template directives
                                // that they would need to get their scope from further up, if they require transclusion
                                markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
                                directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
                                mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
                                ii = directives.length;
                            } else $compileNode.html(directiveValue);
                        }
                        if (directive.templateUrl) {
                            hasTemplate = true;
                            assertNoDuplicate("template", templateDirective, directive, $compileNode);
                            templateDirective = directive;
                            if (directive.replace) replaceDirective = directive;
                            // eslint-disable-next-line no-func-assign
                            nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode, templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                                controllerDirectives: controllerDirectives,
                                newScopeDirective: newScopeDirective !== directive && newScopeDirective,
                                newIsolateScopeDirective: newIsolateScopeDirective,
                                templateDirective: templateDirective,
                                nonTlbTranscludeDirective: nonTlbTranscludeDirective
                            });
                            ii = directives.length;
                        } else if (directive.compile) try {
                            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
                            var context = directive.$$originalDirective || directive;
                            if (isFunction(linkFn)) addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
                            else if (linkFn) addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
                        } catch (e) {
                            $exceptionHandler(e, startingTag($compileNode));
                        }
                        if (directive.terminal) {
                            nodeLinkFn.terminal = true;
                            terminalPriority = Math.max(terminalPriority, directive.priority);
                        }
                    }
                    nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
                    nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
                    nodeLinkFn.templateOnThisElement = hasTemplate;
                    nodeLinkFn.transclude = childTranscludeFn;
                    previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
                    // might be normal or delayed nodeLinkFn depending on if templateUrl is present
                    return nodeLinkFn;
                    ////////////////////
                    function addLinkFns(pre, post, attrStart, attrEnd) {
                        if (pre) {
                            if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
                            pre.require = directive.require;
                            pre.directiveName = directiveName;
                            if (newIsolateScopeDirective === directive || directive.$$isolateScope) pre = cloneAndAnnotateFn(pre, {
                                isolateScope: true
                            });
                            preLinkFns.push(pre);
                        }
                        if (post) {
                            if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
                            post.require = directive.require;
                            post.directiveName = directiveName;
                            if (newIsolateScopeDirective === directive || directive.$$isolateScope) post = cloneAndAnnotateFn(post, {
                                isolateScope: true
                            });
                            postLinkFns.push(post);
                        }
                    }
                    function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
                        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element, attrs, scopeBindingInfo;
                        if (compileNode === linkNode) {
                            attrs = templateAttrs;
                            $element = templateAttrs.$$element;
                        } else {
                            $element = jqLite(linkNode);
                            attrs = new Attributes($element, templateAttrs);
                        }
                        controllerScope = scope;
                        if (newIsolateScopeDirective) isolateScope = scope.$new(true);
                        else if (newScopeDirective) controllerScope = scope.$parent;
                        if (boundTranscludeFn) {
                            // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
                            // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
                            transcludeFn = controllersBoundTransclude;
                            transcludeFn.$$boundTransclude = boundTranscludeFn;
                            // expose the slots on the `$transclude` function
                            transcludeFn.isSlotFilled = function(slotName) {
                                return !!boundTranscludeFn.$$slots[slotName];
                            };
                        }
                        if (controllerDirectives) elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
                        if (newIsolateScopeDirective) {
                            // Initialize isolate scope bindings for new isolate scope directive.
                            compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)));
                            compile.$$addScopeClass($element, true);
                            isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings;
                            scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope, isolateScope.$$isolateBindings, newIsolateScopeDirective);
                            if (scopeBindingInfo.removeWatches) isolateScope.$on("$destroy", scopeBindingInfo.removeWatches);
                        }
                        // Initialize bindToController bindings
                        for(var name in elementControllers){
                            var controllerDirective = controllerDirectives[name];
                            var controller = elementControllers[name];
                            var bindings = controllerDirective.$$bindings.bindToController;
                            controller.instance = controller();
                            $element.data("$" + controllerDirective.name + "Controller", controller.instance);
                            controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                        }
                        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
                        forEach(controllerDirectives, function(controllerDirective, name) {
                            var require = controllerDirective.require;
                            if (controllerDirective.bindToController && !isArray(require) && isObject(require)) extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
                        });
                        // Handle the init and destroy lifecycle hooks on all controllers that have them
                        forEach(elementControllers, function(controller) {
                            var controllerInstance = controller.instance;
                            if (isFunction(controllerInstance.$onChanges)) try {
                                controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                            if (isFunction(controllerInstance.$onInit)) try {
                                controllerInstance.$onInit();
                            } catch (e) {
                                $exceptionHandler(e);
                            }
                            if (isFunction(controllerInstance.$doCheck)) {
                                controllerScope.$watch(function() {
                                    controllerInstance.$doCheck();
                                });
                                controllerInstance.$doCheck();
                            }
                            if (isFunction(controllerInstance.$onDestroy)) controllerScope.$on("$destroy", function callOnDestroyHook() {
                                controllerInstance.$onDestroy();
                            });
                        });
                        // PRELINKING
                        for(i = 0, ii = preLinkFns.length; i < ii; i++){
                            linkFn = preLinkFns[i];
                            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
                        }
                        // RECURSION
                        // We only pass the isolate scope, if the isolate directive has a template,
                        // otherwise the child elements do not belong to the isolate directive.
                        var scopeToChild = scope;
                        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) scopeToChild = isolateScope;
                        if (childLinkFn) childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
                        // POSTLINKING
                        for(i = postLinkFns.length - 1; i >= 0; i--){
                            linkFn = postLinkFns[i];
                            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
                        }
                        // Trigger $postLink lifecycle hooks
                        forEach(elementControllers, function(controller) {
                            var controllerInstance = controller.instance;
                            if (isFunction(controllerInstance.$postLink)) controllerInstance.$postLink();
                        });
                        // This is the function that is injected as `$transclude`.
                        // Note: all arguments are optional!
                        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
                            var transcludeControllers;
                            // No scope passed in:
                            if (!isScope(scope)) {
                                slotName = futureParentElement;
                                futureParentElement = cloneAttachFn;
                                cloneAttachFn = scope;
                                scope = undefined;
                            }
                            if (hasElementTranscludeDirective) transcludeControllers = elementControllers;
                            if (!futureParentElement) futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
                            if (slotName) {
                                // slotTranscludeFn can be one of three things:
                                //  * a transclude function - a filled slot
                                //  * `null` - an optional slot that was not filled
                                //  * `undefined` - a slot that was not declared (i.e. invalid)
                                var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
                                if (slotTranscludeFn) return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                                else if (isUndefined(slotTranscludeFn)) throw $compileMinErr("noslot", 'No parent directive that requires a transclusion with slot name "{0}". Element: {1}', slotName, startingTag($element));
                            } else return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                        }
                    }
                }
                function getControllers(directiveName, require, $element, elementControllers) {
                    var value;
                    if (isString(require)) {
                        var match = require.match(REQUIRE_PREFIX_REGEXP);
                        var name = require.substring(match[0].length);
                        var inheritType = match[1] || match[3];
                        var optional = match[2] === "?";
                        //If only parents then start at the parent element
                        if (inheritType === "^^") $element = $element.parent();
                        else {
                            value = elementControllers && elementControllers[name];
                            value = value && value.instance;
                        }
                        if (!value) {
                            var dataName = "$" + name + "Controller";
                            if (inheritType === "^^" && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) // inheritedData() uses the documentElement when it finds the document, so we would
                            // require from the element itself.
                            value = null;
                            else value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
                        }
                        if (!value && !optional) throw $compileMinErr("ctreq", "Controller '{0}', required by directive '{1}', can't be found!", name, directiveName);
                    } else if (isArray(require)) {
                        value = [];
                        for(var i = 0, ii = require.length; i < ii; i++)value[i] = getControllers(directiveName, require[i], $element, elementControllers);
                    } else if (isObject(require)) {
                        value = {};
                        forEach(require, function(controller, property) {
                            value[property] = getControllers(directiveName, controller, $element, elementControllers);
                        });
                    }
                    return value || null;
                }
                function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
                    var elementControllers = createMap();
                    for(var controllerKey in controllerDirectives){
                        var directive = controllerDirectives[controllerKey];
                        var locals = {
                            $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
                            $element: $element,
                            $attrs: attrs,
                            $transclude: transcludeFn
                        };
                        var controller = directive.controller;
                        if (controller === "@") controller = attrs[directive.name];
                        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
                        // For directives with element transclusion the element is a comment.
                        // In this case .data will not attach any data.
                        // Instead, we save the controllers for the element in a local hash and attach to .data
                        // later, once we have the actual element.
                        elementControllers[directive.name] = controllerInstance;
                        $element.data("$" + directive.name + "Controller", controllerInstance.instance);
                    }
                    return elementControllers;
                }
                // Depending upon the context in which a directive finds itself it might need to have a new isolated
                // or child scope created. For instance:
                // * if the directive has been pulled into a template because another directive with a higher priority
                // asked for element transclusion
                // * if the directive itself asks for transclusion but it is at the root of a template and the original
                // element was replaced. See https://github.com/angular/angular.js/issues/12936
                function markDirectiveScope(directives, isolateScope, newScope) {
                    for(var j = 0, jj = directives.length; j < jj; j++)directives[j] = inherit(directives[j], {
                        $$isolateScope: isolateScope,
                        $$newScope: newScope
                    });
                }
                /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */ function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName) {
                    if (name === ignoreDirective) return null;
                    var match = null;
                    if (hasDirectives.hasOwnProperty(name)) for(var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++){
                        directive = directives[i];
                        if ((isUndefined(maxPriority) || maxPriority > directive.priority) && directive.restrict.indexOf(location) !== -1) {
                            if (startAttrName) directive = inherit(directive, {
                                $$start: startAttrName,
                                $$end: endAttrName
                            });
                            if (!directive.$$bindings) {
                                var bindings = directive.$$bindings = parseDirectiveBindings(directive, directive.name);
                                if (isObject(bindings.isolateScope)) directive.$$isolateBindings = bindings.isolateScope;
                            }
                            tDirectives.push(directive);
                            match = directive;
                        }
                    }
                    return match;
                }
                /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */ function directiveIsMultiElement(name) {
                    if (hasDirectives.hasOwnProperty(name)) for(var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++){
                        directive = directives[i];
                        if (directive.multiElement) return true;
                    }
                    return false;
                }
                /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */ function mergeTemplateAttributes(dst, src) {
                    var srcAttr = src.$attr, dstAttr = dst.$attr;
                    // reapply the old attributes to the new element
                    forEach(dst, function(value, key) {
                        if (key.charAt(0) !== "$") {
                            if (src[key] && src[key] !== value) {
                                if (value.length) value += (key === "style" ? ";" : " ") + src[key];
                                else value = src[key];
                            }
                            dst.$set(key, value, true, srcAttr[key]);
                        }
                    });
                    // copy the new attributes on the old attrs object
                    forEach(src, function(value, key) {
                        // Check if we already set this attribute in the loop above.
                        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
                        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
                        // have an attribute like "has-own-property" or "data-has-own-property", etc.
                        if (!dst.hasOwnProperty(key) && key.charAt(0) !== "$") {
                            dst[key] = value;
                            if (key !== "class" && key !== "style") dstAttr[key] = srcAttr[key];
                        }
                    });
                }
                function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
                    var linkQueue = [], afterTemplateNodeLinkFn, afterTemplateChildLinkFn, beforeTemplateCompileNode = $compileNode[0], origAsyncDirective = directives.shift(), derivedSyncDirective = inherit(origAsyncDirective, {
                        templateUrl: null,
                        transclude: null,
                        replace: null,
                        $$originalDirective: origAsyncDirective
                    }), templateUrl = isFunction(origAsyncDirective.templateUrl) ? origAsyncDirective.templateUrl($compileNode, tAttrs) : origAsyncDirective.templateUrl, templateNamespace = origAsyncDirective.templateNamespace;
                    $compileNode.empty();
                    $templateRequest(templateUrl).then(function(content) {
                        var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
                        content = denormalizeTemplate(content);
                        if (origAsyncDirective.replace) {
                            if (jqLiteIsTextNode(content)) $template = [];
                            else $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
                            compileNode = $template[0];
                            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) throw $compileMinErr("tplrt", "Template for directive '{0}' must have exactly one root element. {1}", origAsyncDirective.name, templateUrl);
                            tempTemplateAttrs = {
                                $attr: {}
                            };
                            replaceWith($rootElement, $compileNode, compileNode);
                            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
                            if (isObject(origAsyncDirective.scope)) // the original directive that caused the template to be loaded async required
                            // an isolate scope
                            markDirectiveScope(templateDirectives, true);
                            directives = templateDirectives.concat(directives);
                            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
                        } else {
                            compileNode = beforeTemplateCompileNode;
                            $compileNode.html(content);
                        }
                        directives.unshift(derivedSyncDirective);
                        afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);
                        forEach($rootElement, function(node, i) {
                            if (node === compileNode) $rootElement[i] = $compileNode[0];
                        });
                        afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
                        while(linkQueue.length){
                            var scope = linkQueue.shift(), beforeTemplateLinkNode = linkQueue.shift(), linkRootElement = linkQueue.shift(), boundTranscludeFn = linkQueue.shift(), linkNode = $compileNode[0];
                            if (scope.$$destroyed) continue;
                            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
                                var oldClasses = beforeTemplateLinkNode.className;
                                if (!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)) // it was cloned therefore we have to clone as well.
                                linkNode = jqLiteClone(compileNode);
                                replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
                                // Copy in CSS classes from original node
                                safeAddClass(jqLite(linkNode), oldClasses);
                            }
                            if (afterTemplateNodeLinkFn.transcludeOnThisElement) childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                            else childBoundTranscludeFn = boundTranscludeFn;
                            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);
                        }
                        linkQueue = null;
                    }).catch(function(error) {
                        if (isError(error)) $exceptionHandler(error);
                    });
                    return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
                        var childBoundTranscludeFn = boundTranscludeFn;
                        if (scope.$$destroyed) return;
                        if (linkQueue) linkQueue.push(scope, node, rootElement, childBoundTranscludeFn);
                        else {
                            if (afterTemplateNodeLinkFn.transcludeOnThisElement) childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
                        }
                    };
                }
                /**
     * Sorting function for bound directives.
     */ function byPriority(a, b) {
                    var diff = b.priority - a.priority;
                    if (diff !== 0) return diff;
                    if (a.name !== b.name) return a.name < b.name ? -1 : 1;
                    return a.index - b.index;
                }
                function assertNoDuplicate(what, previousDirective, directive, element) {
                    function wrapModuleNameIfDefined(moduleName) {
                        return moduleName ? " (module: " + moduleName + ")" : "";
                    }
                    if (previousDirective) throw $compileMinErr("multidir", "Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}", previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName), directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
                }
                function addTextInterpolateDirective(directives, text) {
                    var interpolateFn = $interpolate(text, true);
                    if (interpolateFn) directives.push({
                        priority: 0,
                        compile: function textInterpolateCompileFn(templateNode) {
                            var templateNodeParent = templateNode.parent(), hasCompileParent = !!templateNodeParent.length;
                            // When transcluding a template that has bindings in the root
                            // we don't have a parent and thus need to add the class during linking fn.
                            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
                            return function textInterpolateLinkFn(scope, node) {
                                var parent = node.parent();
                                if (!hasCompileParent) compile.$$addBindingClass(parent);
                                compile.$$addBindingInfo(parent, interpolateFn.expressions);
                                scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                                    node[0].nodeValue = value;
                                });
                            };
                        }
                    });
                }
                function wrapTemplate(type, template) {
                    type = lowercase(type || "html");
                    switch(type){
                        case "svg":
                        case "math":
                            var wrapper = window1.document.createElement("div");
                            wrapper.innerHTML = "<" + type + ">" + template + "</" + type + ">";
                            return wrapper.childNodes[0].childNodes;
                        default:
                            return template;
                    }
                }
                function getTrustedAttrContext(nodeName, attrNormalizedName) {
                    if (attrNormalizedName === "srcdoc") return $sce.HTML;
                    // All nodes with src attributes require a RESOURCE_URL value, except for
                    // img and various html5 media nodes, which require the MEDIA_URL context.
                    if (attrNormalizedName === "src" || attrNormalizedName === "ngSrc") {
                        if ([
                            "img",
                            "video",
                            "audio",
                            "source",
                            "track"
                        ].indexOf(nodeName) === -1) return $sce.RESOURCE_URL;
                        return $sce.MEDIA_URL;
                    } else if (attrNormalizedName === "xlinkHref") {
                        // Some xlink:href are okay, most aren't
                        if (nodeName === "image") return $sce.MEDIA_URL;
                        if (nodeName === "a") return $sce.URL;
                        return $sce.RESOURCE_URL;
                    } else if (// Formaction
                    nodeName === "form" && attrNormalizedName === "action" || // If relative URLs can go where they are not expected to, then
                    // all sorts of trust issues can arise.
                    nodeName === "base" && attrNormalizedName === "href" || // links can be stylesheets or imports, which can run script in the current origin
                    nodeName === "link" && attrNormalizedName === "href") return $sce.RESOURCE_URL;
                    else if (nodeName === "a" && (attrNormalizedName === "href" || attrNormalizedName === "ngHref")) return $sce.URL;
                }
                function getTrustedPropContext(nodeName, propNormalizedName) {
                    var prop = propNormalizedName.toLowerCase();
                    return PROP_CONTEXTS[nodeName + "|" + prop] || PROP_CONTEXTS["*|" + prop];
                }
                function sanitizeSrcsetPropertyValue(value) {
                    return sanitizeSrcset($sce.valueOf(value), "ng-prop-srcset");
                }
                function addPropertyDirective(node, directives, attrName, propName) {
                    if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) throw $compileMinErr("nodomevents", "Property bindings for HTML DOM event properties are disallowed");
                    var nodeName = nodeName_(node);
                    var trustedContext = getTrustedPropContext(nodeName, propName);
                    var sanitizer = identity;
                    // Sanitize img[srcset] + source[srcset] values.
                    if (propName === "srcset" && (nodeName === "img" || nodeName === "source")) sanitizer = sanitizeSrcsetPropertyValue;
                    else if (trustedContext) sanitizer = $sce.getTrusted.bind($sce, trustedContext);
                    directives.push({
                        priority: 100,
                        compile: function ngPropCompileFn(_, attr) {
                            var ngPropGetter = $parse(attr[attrName]);
                            var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
                                // Unwrap the value to compare the actual inner safe value, not the wrapper object.
                                return $sce.valueOf(val);
                            });
                            return {
                                pre: function ngPropPreLinkFn(scope, $element) {
                                    function applyPropValue() {
                                        var propValue = ngPropGetter(scope);
                                        $element[0][propName] = sanitizer(propValue);
                                    }
                                    applyPropValue();
                                    scope.$watch(ngPropWatch, applyPropValue);
                                }
                            };
                        }
                    });
                }
                function addEventDirective(directives, attrName, eventName) {
                    directives.push(createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/ false));
                }
                function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
                    var nodeName = nodeName_(node);
                    var trustedContext = getTrustedAttrContext(nodeName, name);
                    var mustHaveExpression = !isNgAttr;
                    var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
                    var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
                    // no interpolation found -> ignore
                    if (!interpolateFn) return;
                    if (name === "multiple" && nodeName === "select") throw $compileMinErr("selmulti", "Binding to the 'multiple' attribute is not supported. Element: {0}", startingTag(node));
                    if (EVENT_HANDLER_ATTR_REGEXP.test(name)) throw $compileMinErr("nodomevents", "Interpolations for HTML DOM event attributes are disallowed");
                    directives.push({
                        priority: 100,
                        compile: function() {
                            return {
                                pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                                    var $$observers = attr.$$observers || (attr.$$observers = createMap());
                                    // If the attribute has changed since last $interpolate()ed
                                    var newValue = attr[name];
                                    if (newValue !== value) {
                                        // we need to interpolate again since the attribute value has been updated
                                        // (e.g. by another directive's compile function)
                                        // ensure unset/empty values make interpolateFn falsy
                                        interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                                        value = newValue;
                                    }
                                    // if attribute was updated so that there is no interpolation going on we don't want to
                                    // register any observers
                                    if (!interpolateFn) return;
                                    // initialize attr object so that it's ready in case we need the value for isolate
                                    // scope initialization, otherwise the value would not be available from isolate
                                    // directive's linking fn during linking phase
                                    attr[name] = interpolateFn(scope);
                                    ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                                    (attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                                        //special case for class attribute addition + removal
                                        //so that class changes can tap into the animation
                                        //hooks provided by the $animate service. Be sure to
                                        //skip animations when the first digest occurs (when
                                        //both the new and the old values are the same) since
                                        //the CSS classes are the non-interpolated values
                                        if (name === "class" && newValue !== oldValue) attr.$updateClass(newValue, oldValue);
                                        else attr.$set(name, newValue);
                                    });
                                }
                            };
                        }
                    });
                }
                /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */ function replaceWith($rootElement, elementsToRemove, newNode) {
                    var firstElementToRemove = elementsToRemove[0], removeCount = elementsToRemove.length, parent = firstElementToRemove.parentNode, i, ii;
                    if ($rootElement) {
                        for(i = 0, ii = $rootElement.length; i < ii; i++)if ($rootElement[i] === firstElementToRemove) {
                            $rootElement[i++] = newNode;
                            for(var j = i, j2 = j + removeCount - 1, jj = $rootElement.length; j < jj; j++, j2++)if (j2 < jj) $rootElement[j] = $rootElement[j2];
                            else delete $rootElement[j];
                            $rootElement.length -= removeCount - 1;
                            // If the replaced element is also the jQuery .context then replace it
                            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
                            // http://api.jquery.com/context/
                            if ($rootElement.context === firstElementToRemove) $rootElement.context = newNode;
                            break;
                        }
                    }
                    if (parent) parent.replaceChild(newNode, firstElementToRemove);
                    // Append all the `elementsToRemove` to a fragment. This will...
                    // - remove them from the DOM
                    // - allow them to still be traversed with .nextSibling
                    // - allow a single fragment.qSA to fetch all elements being removed
                    var fragment = window1.document.createDocumentFragment();
                    for(i = 0; i < removeCount; i++)fragment.appendChild(elementsToRemove[i]);
                    if (jqLite.hasData(firstElementToRemove)) {
                        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
                        // data here because there's no public interface in jQuery to do that and copying over
                        // event listeners (which is the main use of private data) wouldn't work anyway.
                        jqLite.data(newNode, jqLite.data(firstElementToRemove));
                        // Remove $destroy event listeners from `firstElementToRemove`
                        jqLite(firstElementToRemove).off("$destroy");
                    }
                    // Cleanup any data/listeners on the elements and children.
                    // This includes invoking the $destroy event on any elements with listeners.
                    jqLite.cleanData(fragment.querySelectorAll("*"));
                    // Update the jqLite collection to only contain the `newNode`
                    for(i = 1; i < removeCount; i++)delete elementsToRemove[i];
                    elementsToRemove[0] = newNode;
                    elementsToRemove.length = 1;
                }
                function cloneAndAnnotateFn(fn, annotation) {
                    return extend(function() {
                        return fn.apply(null, arguments);
                    }, fn, annotation);
                }
                function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
                    try {
                        linkFn(scope, $element, attrs, controllers, transcludeFn);
                    } catch (e) {
                        $exceptionHandler(e, startingTag($element));
                    }
                }
                function strictBindingsCheck(attrName, directiveName) {
                    if (strictComponentBindingsEnabled) throw $compileMinErr("missingattr", "Attribute '{0}' of '{1}' is non-optional and must be set!", attrName, directiveName);
                }
                // Set up $watches for isolate scope and controller bindings.
                function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
                    var removeWatchCollection = [];
                    var initialChanges = {};
                    var changes;
                    forEach(bindings, function initializeBinding(definition, scopeName) {
                        var attrName = definition.attrName, optional = definition.optional, mode = definition.mode, lastValue, parentGet, parentSet, compare, removeWatch;
                        switch(mode){
                            case "@":
                                if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                                    strictBindingsCheck(attrName, directive.name);
                                    destination[scopeName] = attrs[attrName] = undefined;
                                }
                                removeWatch = attrs.$observe(attrName, function(value) {
                                    if (isString(value) || isBoolean(value)) {
                                        var oldValue = destination[scopeName];
                                        recordChanges(scopeName, value, oldValue);
                                        destination[scopeName] = value;
                                    }
                                });
                                attrs.$$observers[attrName].$$scope = scope;
                                lastValue = attrs[attrName];
                                if (isString(lastValue)) // If the attribute has been provided then we trigger an interpolation to ensure
                                // the value is there for use in the link fn
                                destination[scopeName] = $interpolate(lastValue)(scope);
                                else if (isBoolean(lastValue)) // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
                                // the value to boolean rather than a string, so we special case this situation
                                destination[scopeName] = lastValue;
                                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                                removeWatchCollection.push(removeWatch);
                                break;
                            case "=":
                                if (!hasOwnProperty.call(attrs, attrName)) {
                                    if (optional) break;
                                    strictBindingsCheck(attrName, directive.name);
                                    attrs[attrName] = undefined;
                                }
                                if (optional && !attrs[attrName]) break;
                                parentGet = $parse(attrs[attrName]);
                                if (parentGet.literal) compare = equals;
                                else compare = simpleCompare;
                                parentSet = parentGet.assign || function() {
                                    // reset the change, or we will throw this exception on every $digest
                                    lastValue = destination[scopeName] = parentGet(scope);
                                    throw $compileMinErr("nonassign", "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!", attrs[attrName], attrName, directive.name);
                                };
                                lastValue = destination[scopeName] = parentGet(scope);
                                var parentValueWatch = function parentValueWatch(parentValue) {
                                    if (!compare(parentValue, destination[scopeName])) {
                                        // we are out of sync and need to copy
                                        if (!compare(parentValue, lastValue)) // parent changed and it has precedence
                                        destination[scopeName] = parentValue;
                                        else // if the parent can be assigned then do so
                                        parentSet(scope, parentValue = destination[scopeName]);
                                    }
                                    lastValue = parentValue;
                                    return lastValue;
                                };
                                parentValueWatch.$stateful = true;
                                if (definition.collection) removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
                                else removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
                                removeWatchCollection.push(removeWatch);
                                break;
                            case "<":
                                if (!hasOwnProperty.call(attrs, attrName)) {
                                    if (optional) break;
                                    strictBindingsCheck(attrName, directive.name);
                                    attrs[attrName] = undefined;
                                }
                                if (optional && !attrs[attrName]) break;
                                parentGet = $parse(attrs[attrName]);
                                var isLiteral = parentGet.literal;
                                var initialValue = destination[scopeName] = parentGet(scope);
                                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                                removeWatch = scope[definition.collection ? "$watchCollection" : "$watch"](parentGet, function parentValueWatchAction(newValue, oldValue) {
                                    if (oldValue === newValue) {
                                        if (oldValue === initialValue || isLiteral && equals(oldValue, initialValue)) return;
                                        oldValue = initialValue;
                                    }
                                    recordChanges(scopeName, newValue, oldValue);
                                    destination[scopeName] = newValue;
                                });
                                removeWatchCollection.push(removeWatch);
                                break;
                            case "&":
                                if (!optional && !hasOwnProperty.call(attrs, attrName)) strictBindingsCheck(attrName, directive.name);
                                // Don't assign Object.prototype method to scope
                                parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
                                // Don't assign noop to destination if expression is not valid
                                if (parentGet === noop && optional) break;
                                destination[scopeName] = function(locals) {
                                    return parentGet(scope, locals);
                                };
                                break;
                        }
                    });
                    function recordChanges(key, currentValue, previousValue) {
                        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
                            // If we have not already scheduled the top level onChangesQueue handler then do so now
                            if (!onChangesQueue) {
                                scope.$$postDigest(flushOnChangesQueue);
                                onChangesQueue = [];
                            }
                            // If we have not already queued a trigger of onChanges for this controller then do so now
                            if (!changes) {
                                changes = {};
                                onChangesQueue.push(triggerOnChangesHook);
                            }
                            // If the has been a change on this property already then we need to reuse the previous value
                            if (changes[key]) previousValue = changes[key].previousValue;
                            // Store this change
                            changes[key] = new SimpleChange(previousValue, currentValue);
                        }
                    }
                    function triggerOnChangesHook() {
                        destination.$onChanges(changes);
                        // Now clear the changes so that we schedule onChanges when more changes arrive
                        changes = undefined;
                    }
                    return {
                        initialChanges: initialChanges,
                        removeWatches: removeWatchCollection.length && function removeWatches() {
                            for(var i = 0, ii = removeWatchCollection.length; i < ii; ++i)removeWatchCollection[i]();
                        }
                    };
                }
            }
        ];
    }
    function SimpleChange(previous, current) {
        this.previousValue = previous;
        this.currentValue = current;
    }
    SimpleChange.prototype.isFirstChange = function() {
        return this.previousValue === _UNINITIALIZED_VALUE;
    };
    var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
    var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
    /**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */ function directiveNormalize(name) {
        return name.replace(PREFIX_REGEXP, "").replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
            return offset ? letter.toUpperCase() : letter;
        });
    }
    /**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */ /**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */ /**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */ /**
 * Closure compiler type information
 */ function nodesetLinkingFn(/* angular.Scope */ scope, /* NodeList */ nodeList, /* Element */ rootElement, /* function(Function) */ boundTranscludeFn) {}
    function directiveLinkingFn(/* nodesetLinkingFn */ nodesetLinkingFn, /* angular.Scope */ scope, /* Node */ node, /* Element */ rootElement, /* function(Function) */ boundTranscludeFn) {}
    function tokenDifference(str1, str2) {
        var values = "", tokens1 = str1.split(/\s+/), tokens2 = str2.split(/\s+/);
        outer: for(var i = 0; i < tokens1.length; i++){
            var token = tokens1[i];
            for(var j = 0; j < tokens2.length; j++){
                if (token === tokens2[j]) continue outer;
            }
            values += (values.length > 0 ? " " : "") + token;
        }
        return values;
    }
    function removeComments(jqNodes) {
        jqNodes = jqLite(jqNodes);
        var i = jqNodes.length;
        if (i <= 1) return jqNodes;
        while(i--){
            var node = jqNodes[i];
            if (node.nodeType === NODE_TYPE_COMMENT || node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === "") splice.call(jqNodes, i, 1);
        }
        return jqNodes;
    }
    var $controllerMinErr = minErr("$controller");
    var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
    function identifierForController(controller, ident) {
        if (ident && isString(ident)) return ident;
        if (isString(controller)) {
            var match = CNTRL_REG.exec(controller);
            if (match) return match[3];
        }
    }
    /**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */ function $ControllerProvider() {
        var controllers = {};
        /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */ this.has = function(name) {
            return controllers.hasOwnProperty(name);
        };
        /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */ this.register = function(name, constructor) {
            assertNotHasOwnProperty(name, "controller");
            if (isObject(name)) extend(controllers, name);
            else controllers[name] = constructor;
        };
        this.$get = [
            "$injector",
            function($injector) {
                /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */ return function $controller(expression, locals, later, ident) {
                    // PRIVATE API:
                    //   param `later` --- indicates that the controller's constructor is invoked at a later time.
                    //                     If true, $controller will allocate the object with the correct
                    //                     prototype chain, but will not invoke the controller until a returned
                    //                     callback is invoked.
                    //   param `ident` --- An optional label which overrides the label parsed from the controller
                    //                     expression, if any.
                    var instance, match, constructor, identifier;
                    later = later === true;
                    if (ident && isString(ident)) identifier = ident;
                    if (isString(expression)) {
                        match = expression.match(CNTRL_REG);
                        if (!match) throw $controllerMinErr("ctrlfmt", "Badly formed controller string '{0}'. Must match `__name__ as __id__` or `__name__`.", expression);
                        constructor = match[1];
                        identifier = identifier || match[3];
                        expression = controllers.hasOwnProperty(constructor) ? controllers[constructor] : getter(locals.$scope, constructor, true);
                        if (!expression) throw $controllerMinErr("ctrlreg", "The controller with the name '{0}' is not registered.", constructor);
                        assertArgFn(expression, constructor, true);
                    }
                    if (later) {
                        // Instantiate controller later:
                        // This machinery is used to create an instance of the object before calling the
                        // controller's constructor itself.
                        //
                        // This allows properties to be added to the controller before the constructor is
                        // invoked. Primarily, this is used for isolate scope bindings in $compile.
                        //
                        // This feature is not intended for use by applications, and is thus not documented
                        // publicly.
                        // Object creation: http://jsperf.com/create-constructor/2
                        var controllerPrototype = (isArray(expression) ? expression[expression.length - 1] : expression).prototype;
                        instance = Object.create(controllerPrototype || null);
                        if (identifier) addIdentifier(locals, identifier, instance, constructor || expression.name);
                        return extend(function $controllerInit() {
                            var result = $injector.invoke(expression, instance, locals, constructor);
                            if (result !== instance && (isObject(result) || isFunction(result))) {
                                instance = result;
                                if (identifier) // If result changed, re-assign controllerAs value to scope.
                                addIdentifier(locals, identifier, instance, constructor || expression.name);
                            }
                            return instance;
                        }, {
                            instance: instance,
                            identifier: identifier
                        });
                    }
                    instance = $injector.instantiate(expression, locals, constructor);
                    if (identifier) addIdentifier(locals, identifier, instance, constructor || expression.name);
                    return instance;
                };
                function addIdentifier(locals, identifier, instance, name) {
                    if (!(locals && isObject(locals.$scope))) throw minErr("$controller")("noscp", "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.", name, identifier);
                    locals.$scope[identifier] = instance;
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */ function $DocumentProvider() {
        this.$get = [
            "$window",
            function(window1) {
                return jqLite(window1.document);
            }
        ];
    }
    /**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */ function $$IsDocumentHiddenProvider() {
        this.$get = [
            "$document",
            "$rootScope",
            function($document, $rootScope) {
                var doc = $document[0];
                var hidden = doc && doc.hidden;
                $document.on("visibilitychange", changeListener);
                $rootScope.$on("$destroy", function() {
                    $document.off("visibilitychange", changeListener);
                });
                function changeListener() {
                    hidden = doc.hidden;
                }
                return function() {
                    return hidden;
                };
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */ function $ExceptionHandlerProvider() {
        this.$get = [
            "$log",
            function($log) {
                return function(exception, cause) {
                    $log.error.apply($log, arguments);
                };
            }
        ];
    }
    var $$ForceReflowProvider = /** @this */ function() {
        this.$get = [
            "$document",
            function($document) {
                return function(domNode) {
                    //the line below will force the browser to perform a repaint so
                    //that all the animated elements within the animation frame will
                    //be properly updated and drawn on screen. This is required to
                    //ensure that the preparation animation is properly flushed so that
                    //the active state picks up from there. DO NOT REMOVE THIS LINE.
                    //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
                    //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
                    //WILL TAKE YEARS AWAY FROM YOUR LIFE.
                    if (domNode) {
                        if (!domNode.nodeType && domNode instanceof jqLite) domNode = domNode[0];
                    } else domNode = $document[0].body;
                    return domNode.offsetWidth + 1;
                };
            }
        ];
    };
    var APPLICATION_JSON = "application/json";
    var CONTENT_TYPE_APPLICATION_JSON = {
        "Content-Type": APPLICATION_JSON + ";charset=utf-8"
    };
    var JSON_START = /^\[|^\{(?!\{)/;
    var JSON_ENDS = {
        "[": /]$/,
        "{": /}$/
    };
    var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
    var $httpMinErr = minErr("$http");
    function serializeValue(v) {
        if (isObject(v)) return isDate(v) ? v.toISOString() : toJson(v);
        return v;
    }
    /** @this */ function $HttpParamSerializerProvider() {
        /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */ this.$get = function() {
            return function ngParamSerializer(params) {
                if (!params) return "";
                var parts = [];
                forEachSorted(params, function(value, key) {
                    if (value === null || isUndefined(value) || isFunction(value)) return;
                    if (isArray(value)) forEach(value, function(v) {
                        parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(serializeValue(v)));
                    });
                    else parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(serializeValue(value)));
                });
                return parts.join("&");
            };
        };
    }
    /** @this */ function $HttpParamSerializerJQLikeProvider() {
        /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */ this.$get = function() {
            return function jQueryLikeParamSerializer(params) {
                if (!params) return "";
                var parts = [];
                serialize(params, "", true);
                return parts.join("&");
                function serialize(toSerialize, prefix, topLevel) {
                    if (isArray(toSerialize)) forEach(toSerialize, function(value, index) {
                        serialize(value, prefix + "[" + (isObject(value) ? index : "") + "]");
                    });
                    else if (isObject(toSerialize) && !isDate(toSerialize)) forEachSorted(toSerialize, function(value, key) {
                        serialize(value, prefix + (topLevel ? "" : "[") + key + (topLevel ? "" : "]"));
                    });
                    else {
                        if (isFunction(toSerialize)) toSerialize = toSerialize();
                        parts.push(encodeUriQuery(prefix) + "=" + (toSerialize == null ? "" : encodeUriQuery(serializeValue(toSerialize))));
                    }
                }
            };
        };
    }
    function defaultHttpResponseTransform(data, headers) {
        if (isString(data)) {
            // Strip json vulnerability protection prefix and trim whitespace
            var tempData = data.replace(JSON_PROTECTION_PREFIX, "").trim();
            if (tempData) {
                var contentType = headers("Content-Type");
                var hasJsonContentType = contentType && contentType.indexOf(APPLICATION_JSON) === 0;
                if (hasJsonContentType || isJsonLike(tempData)) try {
                    data = fromJson(tempData);
                } catch (e) {
                    if (!hasJsonContentType) return data;
                    throw $httpMinErr("baddata", 'Data must be a valid JSON object. Received: "{0}". Parse error: "{1}"', data, e);
                }
            }
        }
        return data;
    }
    function isJsonLike(str) {
        var jsonStart = str.match(JSON_START);
        return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
    }
    /**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */ function parseHeaders(headers) {
        var parsed = createMap(), i;
        function fillInParsed(key, val) {
            if (key) parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
        if (isString(headers)) forEach(headers.split("\n"), function(line) {
            i = line.indexOf(":");
            fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
        });
        else if (isObject(headers)) forEach(headers, function(headerVal, headerKey) {
            fillInParsed(lowercase(headerKey), trim(headerVal));
        });
        return parsed;
    }
    /**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */ function headersGetter(headers) {
        var headersObj;
        return function(name) {
            if (!headersObj) headersObj = parseHeaders(headers);
            if (name) {
                var value = headersObj[lowercase(name)];
                if (value === undefined) value = null;
                return value;
            }
            return headersObj;
        };
    }
    /**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */ function transformData(data, headers, status, fns) {
        if (isFunction(fns)) return fns(data, headers, status);
        forEach(fns, function(fn) {
            data = fn(data, headers, status);
        });
        return data;
    }
    function isSuccess(status) {
        return 200 <= status && status < 300;
    }
    /**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */ function $HttpProvider() {
        /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */ var defaults = this.defaults = {
            // transform incoming response data
            transformResponse: [
                defaultHttpResponseTransform
            ],
            // transform outgoing request data
            transformRequest: [
                function(d) {
                    return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
                }
            ],
            // default headers
            headers: {
                common: {
                    "Accept": "application/json, text/plain, */*"
                },
                post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
                put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
                patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
            },
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            paramSerializer: "$httpParamSerializer",
            jsonpCallbackParam: "callback"
        };
        var useApplyAsync = false;
        /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */ this.useApplyAsync = function(value) {
            if (isDefined(value)) {
                useApplyAsync = !!value;
                return this;
            }
            return useApplyAsync;
        };
        /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */ var interceptorFactories = this.interceptors = [];
        /**
   * @ngdoc property
   * @name $httpProvider#xsrfTrustedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfTrustedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */ var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
        /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
   * instead.
   */ Object.defineProperty(this, "xsrfWhitelistedOrigins", {
            get: function() {
                return this.xsrfTrustedOrigins;
            },
            set: function(origins) {
                this.xsrfTrustedOrigins = origins;
            }
        });
        this.$get = [
            "$browser",
            "$httpBackend",
            "$$cookieReader",
            "$cacheFactory",
            "$rootScope",
            "$q",
            "$injector",
            "$sce",
            function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
                var defaultCache = $cacheFactory("$http");
                /**
     * Make sure that default param serializer is exposed as a function
     */ defaults.paramSerializer = isString(defaults.paramSerializer) ? $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
                /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */ var reversedInterceptors = [];
                forEach(interceptorFactories, function(interceptorFactory) {
                    reversedInterceptors.unshift(isString(interceptorFactory) ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
                });
                /**
     * A function to check request URLs against a list of allowed origins.
     */ var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
                /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can trust additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only trusted origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
      $sceDelegateProvider.trustedResourceUrlList([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */ function $http(requestConfig) {
                    if (!isObject(requestConfig)) throw minErr("$http")("badreq", "Http request configuration must be an object.  Received: {0}", requestConfig);
                    if (!isString($sce.valueOf(requestConfig.url))) throw minErr("$http")("badreq", "Http request configuration url must be a string or a $sce trusted object.  Received: {0}", requestConfig.url);
                    var config = extend({
                        method: "get",
                        transformRequest: defaults.transformRequest,
                        transformResponse: defaults.transformResponse,
                        paramSerializer: defaults.paramSerializer,
                        jsonpCallbackParam: defaults.jsonpCallbackParam
                    }, requestConfig);
                    config.headers = mergeHeaders(requestConfig);
                    config.method = uppercase(config.method);
                    config.paramSerializer = isString(config.paramSerializer) ? $injector.get(config.paramSerializer) : config.paramSerializer;
                    $browser.$$incOutstandingRequestCount("$http");
                    var requestInterceptors = [];
                    var responseInterceptors = [];
                    var promise = $q.resolve(config);
                    // apply interceptors
                    forEach(reversedInterceptors, function(interceptor) {
                        if (interceptor.request || interceptor.requestError) requestInterceptors.unshift(interceptor.request, interceptor.requestError);
                        if (interceptor.response || interceptor.responseError) responseInterceptors.push(interceptor.response, interceptor.responseError);
                    });
                    promise = chainInterceptors(promise, requestInterceptors);
                    promise = promise.then(serverRequest);
                    promise = chainInterceptors(promise, responseInterceptors);
                    promise = promise.finally(completeOutstandingRequest);
                    return promise;
                    function chainInterceptors(promise, interceptors) {
                        for(var i = 0, ii = interceptors.length; i < ii;){
                            var thenFn = interceptors[i++];
                            var rejectFn = interceptors[i++];
                            promise = promise.then(thenFn, rejectFn);
                        }
                        interceptors.length = 0;
                        return promise;
                    }
                    function completeOutstandingRequest() {
                        $browser.$$completeOutstandingRequest(noop, "$http");
                    }
                    function executeHeaderFns(headers, config) {
                        var headerContent, processedHeaders = {};
                        forEach(headers, function(headerFn, header) {
                            if (isFunction(headerFn)) {
                                headerContent = headerFn(config);
                                if (headerContent != null) processedHeaders[header] = headerContent;
                            } else processedHeaders[header] = headerFn;
                        });
                        return processedHeaders;
                    }
                    function mergeHeaders(config) {
                        var defHeaders = defaults.headers, reqHeaders = extend({}, config.headers), defHeaderName, lowercaseDefHeaderName, reqHeaderName;
                        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
                        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
                        defaultHeadersIteration: for(defHeaderName in defHeaders){
                            lowercaseDefHeaderName = lowercase(defHeaderName);
                            for(reqHeaderName in reqHeaders){
                                if (lowercase(reqHeaderName) === lowercaseDefHeaderName) continue defaultHeadersIteration;
                            }
                            reqHeaders[defHeaderName] = defHeaders[defHeaderName];
                        }
                        // execute if header value is a function for merged headers
                        return executeHeaderFns(reqHeaders, shallowCopy(config));
                    }
                    function serverRequest(config) {
                        var headers = config.headers;
                        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
                        // strip content-type if data is undefined
                        if (isUndefined(reqData)) forEach(headers, function(value, header) {
                            if (lowercase(header) === "content-type") delete headers[header];
                        });
                        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) config.withCredentials = defaults.withCredentials;
                        // send request
                        return sendReq(config, reqData).then(transformResponse, transformResponse);
                    }
                    function transformResponse(response) {
                        // make a copy since the response must be cacheable
                        var resp = extend({}, response);
                        resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
                        return isSuccess(response.status) ? resp : $q.reject(resp);
                    }
                }
                $http.pendingRequests = [];
                /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the trusted resource URL list via
     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ createShortMethods("get", "delete", "head", "jsonp");
                /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */ /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */ createShortMethodsWithData("post", "put", "patch");
                /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */ $http.defaults = defaults;
                return $http;
                function createShortMethods(names) {
                    forEach(arguments, function(name) {
                        $http[name] = function(url, config) {
                            return $http(extend({}, config || {}, {
                                method: name,
                                url: url
                            }));
                        };
                    });
                }
                function createShortMethodsWithData(name) {
                    forEach(arguments, function(name) {
                        $http[name] = function(url, data, config) {
                            return $http(extend({}, config || {}, {
                                method: name,
                                url: url,
                                data: data
                            }));
                        };
                    });
                }
                /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */ function sendReq(config, reqData) {
                    var deferred = $q.defer(), promise = deferred.promise, cache, cachedResp, reqHeaders = config.headers, isJsonp = lowercase(config.method) === "jsonp", url = config.url;
                    if (isJsonp) // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
                    // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
                    url = $sce.getTrustedResourceUrl(url);
                    else if (!isString(url)) // If it is not a string then the URL must be a $sce trusted object
                    url = $sce.valueOf(url);
                    url = buildUrl(url, config.paramSerializer(config.params));
                    if (isJsonp) // Check the url and add the JSONP callback placeholder
                    url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
                    $http.pendingRequests.push(config);
                    promise.then(removePendingReq, removePendingReq);
                    if ((config.cache || defaults.cache) && config.cache !== false && (config.method === "GET" || config.method === "JSONP")) cache = isObject(config.cache) ? config.cache : isObject(/** @type {?} */ defaults.cache) ? /** @type {?} */ defaults.cache : defaultCache;
                    if (cache) {
                        cachedResp = cache.get(url);
                        if (isDefined(cachedResp)) {
                            if (isPromiseLike(cachedResp)) // cached request has already been sent, but there is no response yet
                            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
                            else // serving from cache
                            if (isArray(cachedResp)) resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
                            else resolvePromise(cachedResp, 200, {}, "OK", "complete");
                        } else // put the promise for the non-transformed response into cache as a placeholder
                        cache.put(url, promise);
                    }
                    // if we won't have the response in cache, set the xsrf headers and
                    // send the request to the backend
                    if (isUndefined(cachedResp)) {
                        var xsrfValue = urlIsAllowedOrigin(config.url) ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName] : undefined;
                        if (xsrfValue) reqHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;
                        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType, createApplyHandlers(config.eventHandlers), createApplyHandlers(config.uploadEventHandlers));
                    }
                    return promise;
                    function createApplyHandlers(eventHandlers) {
                        if (eventHandlers) {
                            var applyHandlers = {};
                            forEach(eventHandlers, function(eventHandler, key) {
                                applyHandlers[key] = function(event) {
                                    if (useApplyAsync) $rootScope.$applyAsync(callEventHandler);
                                    else if ($rootScope.$$phase) callEventHandler();
                                    else $rootScope.$apply(callEventHandler);
                                    function callEventHandler() {
                                        eventHandler(event);
                                    }
                                };
                            });
                            return applyHandlers;
                        }
                    }
                    /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */ function done(status, response, headersString, statusText, xhrStatus) {
                        if (cache) {
                            if (isSuccess(status)) cache.put(url, [
                                status,
                                response,
                                parseHeaders(headersString),
                                statusText,
                                xhrStatus
                            ]);
                            else // remove promise from the cache
                            cache.remove(url);
                        }
                        function resolveHttpPromise() {
                            resolvePromise(response, status, headersString, statusText, xhrStatus);
                        }
                        if (useApplyAsync) $rootScope.$applyAsync(resolveHttpPromise);
                        else {
                            resolveHttpPromise();
                            if (!$rootScope.$$phase) $rootScope.$apply();
                        }
                    }
                    /**
       * Resolves the raw $http promise.
       */ function resolvePromise(response, status, headers, statusText, xhrStatus) {
                        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
                        status = status >= -1 ? status : 0;
                        (isSuccess(status) ? deferred.resolve : deferred.reject)({
                            data: response,
                            status: status,
                            headers: headersGetter(headers),
                            config: config,
                            statusText: statusText,
                            xhrStatus: xhrStatus
                        });
                    }
                    function resolvePromiseWithResult(result) {
                        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
                    }
                    function removePendingReq() {
                        var idx = $http.pendingRequests.indexOf(config);
                        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
                    }
                }
                function buildUrl(url, serializedParams) {
                    if (serializedParams.length > 0) url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
                    return url;
                }
                function sanitizeJsonpCallbackParam(url, cbKey) {
                    var parts = url.split("?");
                    if (parts.length > 2) // Throw if the url contains more than one `?` query indicator
                    throw $httpMinErr("badjsonp", 'Illegal use more than one "?", in url, "{1}"', url);
                    var params = parseKeyValue(parts[1]);
                    forEach(params, function(value, key) {
                        if (value === "JSON_CALLBACK") // Throw if the url already contains a reference to JSON_CALLBACK
                        throw $httpMinErr("badjsonp", 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
                        if (key === cbKey) // Throw if the callback param was already provided
                        throw $httpMinErr("badjsonp", 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
                    });
                    // Add in the JSON_CALLBACK callback param value
                    url += (url.indexOf("?") === -1 ? "?" : "&") + cbKey + "=JSON_CALLBACK";
                    return url;
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */ function $xhrFactoryProvider() {
        this.$get = function() {
            return function createXhr() {
                return new window1.XMLHttpRequest();
            };
        };
    }
    /**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */ function $HttpBackendProvider() {
        this.$get = [
            "$browser",
            "$jsonpCallbacks",
            "$document",
            "$xhrFactory",
            function($browser, $jsonpCallbacks, $document, $xhrFactory) {
                return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
            }
        ];
    }
    function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
        // TODO(vojta): fix the signature
        return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
            url = url || $browser.url();
            if (lowercase(method) === "jsonp") {
                var callbackPath = callbacks.createCallback(url);
                var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
                    // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
                    var response = status === 200 && callbacks.getResponse(callbackPath);
                    completeRequest(callback, status, response, "", text, "complete");
                    callbacks.removeCallback(callbackPath);
                });
            } else {
                var xhr = createXhr(method, url);
                var abortedByTimeout = false;
                xhr.open(method, url, true);
                forEach(headers, function(value, key) {
                    if (isDefined(value)) xhr.setRequestHeader(key, value);
                });
                xhr.onload = function requestLoaded() {
                    var statusText = xhr.statusText || "";
                    // responseText is the old-school way of retrieving response (supported by IE9)
                    // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
                    var response = "response" in xhr ? xhr.response : xhr.responseText;
                    // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                    var status = xhr.status === 1223 ? 204 : xhr.status;
                    // fix status code when it is 0 (0 status is undocumented).
                    // Occurs when accessing file resources or on Android 4.1 stock browser
                    // while retrieving files from application cache.
                    if (status === 0) status = response ? 200 : urlResolve(url).protocol === "file" ? 404 : 0;
                    completeRequest(callback, status, response, xhr.getAllResponseHeaders(), statusText, "complete");
                };
                var requestError = function() {
                    // The response is always empty
                    // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
                    completeRequest(callback, -1, null, null, "", "error");
                };
                var requestAborted = function() {
                    completeRequest(callback, -1, null, null, "", abortedByTimeout ? "timeout" : "abort");
                };
                var requestTimeout = function() {
                    // The response is always empty
                    // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
                    completeRequest(callback, -1, null, null, "", "timeout");
                };
                xhr.onerror = requestError;
                xhr.ontimeout = requestTimeout;
                xhr.onabort = requestAborted;
                forEach(eventHandlers, function(value, key) {
                    xhr.addEventListener(key, value);
                });
                forEach(uploadEventHandlers, function(value, key) {
                    xhr.upload.addEventListener(key, value);
                });
                if (withCredentials) xhr.withCredentials = true;
                if (responseType) try {
                    xhr.responseType = responseType;
                } catch (e) {
                    // WebKit added support for the json responseType value on 09/03/2013
                    // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
                    // known to throw when setting the value "json" as the response type. Other older
                    // browsers implementing the responseType
                    //
                    // The json response type can be ignored if not supported, because JSON payloads are
                    // parsed on the client-side regardless.
                    if (responseType !== "json") throw e;
                }
                xhr.send(isUndefined(post) ? null : post);
            }
            // Since we are using xhr.abort() when a request times out, we have to set a flag that
            // indicates to requestAborted if the request timed out or was aborted.
            //
            // http.timeout = numerical timeout   timeout
            // http.timeout = $timeout            timeout
            // http.timeout = promise             abort
            // xhr.abort()                        abort (The xhr object is normally inaccessible, but
            //                                    can be exposed with the xhrFactory)
            if (timeout > 0) var timeoutId = $browserDefer(function() {
                timeoutRequest("timeout");
            }, timeout);
            else if (isPromiseLike(timeout)) timeout.then(function() {
                timeoutRequest(isDefined(timeout.$$timeoutId) ? "timeout" : "abort");
            });
            function timeoutRequest(reason) {
                abortedByTimeout = reason === "timeout";
                if (jsonpDone) jsonpDone();
                if (xhr) xhr.abort();
            }
            function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
                // cancel timeout and subsequent timeout promise resolution
                if (isDefined(timeoutId)) $browserDefer.cancel(timeoutId);
                jsonpDone = xhr = null;
                callback(status, response, headersString, statusText, xhrStatus);
            }
        };
        function jsonpReq(url, callbackPath, done) {
            url = url.replace("JSON_CALLBACK", callbackPath);
            // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
            // - fetches local scripts via XHR and evals them
            // - adds and immediately removes script elements from the document
            var script = rawDocument.createElement("script"), callback = null;
            script.type = "text/javascript";
            script.src = url;
            script.async = true;
            callback = function(event) {
                script.removeEventListener("load", callback);
                script.removeEventListener("error", callback);
                rawDocument.body.removeChild(script);
                script = null;
                var status = -1;
                var text = "unknown";
                if (event) {
                    if (event.type === "load" && !callbacks.wasCalled(callbackPath)) event = {
                        type: "error"
                    };
                    text = event.type;
                    status = event.type === "error" ? 404 : 200;
                }
                if (done) done(status, text);
            };
            script.addEventListener("load", callback);
            script.addEventListener("error", callback);
            rawDocument.body.appendChild(script);
            return callback;
        }
    }
    var $interpolateMinErr = angular.$interpolateMinErr = minErr("$interpolate");
    $interpolateMinErr.throwNoconcat = function(text) {
        throw $interpolateMinErr("noconcat", "Error while interpolating: {0}\nStrict Contextual Escaping disallows interpolations that concatenate multiple expressions when a trusted value is required.  See http://docs.angularjs.org/api/ng.$sce", text);
    };
    $interpolateMinErr.interr = function(text, err) {
        return $interpolateMinErr("interr", "Can't interpolate: {0}\n{1}", text, err.toString());
    };
    /**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */ function $InterpolateProvider() {
        var startSymbol = "{{";
        var endSymbol = "}}";
        /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */ this.startSymbol = function(value) {
            if (value) {
                startSymbol = value;
                return this;
            }
            return startSymbol;
        };
        /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */ this.endSymbol = function(value) {
            if (value) {
                endSymbol = value;
                return this;
            }
            return endSymbol;
        };
        this.$get = [
            "$parse",
            "$exceptionHandler",
            "$sce",
            function($parse, $exceptionHandler, $sce) {
                var startSymbolLength = startSymbol.length, endSymbolLength = endSymbol.length, escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), "g"), escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), "g");
                function escape(ch) {
                    return "\\\\\\" + ch;
                }
                function unescapeText(text) {
                    return text.replace(escapedStartRegexp, startSymbol).replace(escapedEndRegexp, endSymbol);
                }
                // TODO: this is the same as the constantWatchDelegate in parse.js
                function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
                    var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
                        unwatch();
                        return constantInterp(scope);
                    }, listener, objectEquality);
                    return unwatch;
                }
                /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */ function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
                    var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
                    // Provide a quick exit and simplified result function for text with no interpolation
                    if (!text.length || text.indexOf(startSymbol) === -1) {
                        if (mustHaveExpression) return;
                        var unescapedText = unescapeText(text);
                        if (contextAllowsConcatenation) unescapedText = $sce.getTrusted(trustedContext, unescapedText);
                        var constantInterp = valueFn(unescapedText);
                        constantInterp.exp = text;
                        constantInterp.expressions = [];
                        constantInterp.$$watchDelegate = constantWatchDelegate;
                        return constantInterp;
                    }
                    allOrNothing = !!allOrNothing;
                    var startIndex, endIndex, index = 0, expressions = [], parseFns, textLength = text.length, exp, concat = [], expressionPositions = [], singleExpression;
                    while(index < textLength)if ((startIndex = text.indexOf(startSymbol, index)) !== -1 && (endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1) {
                        if (index !== startIndex) concat.push(unescapeText(text.substring(index, startIndex)));
                        exp = text.substring(startIndex + startSymbolLength, endIndex);
                        expressions.push(exp);
                        index = endIndex + endSymbolLength;
                        expressionPositions.push(concat.length);
                        concat.push(""); // Placeholder that will get replaced with the evaluated expression.
                    } else {
                        // we did not find an interpolation, so we have to add the remainder to the separators array
                        if (index !== textLength) concat.push(unescapeText(text.substring(index)));
                        break;
                    }
                    singleExpression = concat.length === 1 && expressionPositions.length === 1;
                    // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
                    // objects rather than simple strings
                    // (we don't modify the expression if the input consists of only a single trusted input)
                    var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
                    parseFns = expressions.map(function(exp) {
                        return $parse(exp, interceptor);
                    });
                    // Concatenating expressions makes it hard to reason about whether some combination of
                    // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
                    // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
                    // we ensure that the value that's used is assigned or constructed by some JS code somewhere
                    // that is more testable or make it obvious that you bound the value to some user controlled
                    // value.  This helps reduce the load when auditing for XSS issues.
                    // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
                    // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
                    // or on the overall concatenated string (losing trusted types used in the mix, by design).
                    // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
                    // only used in srcdoc attributes, this would not be very useful.
                    if (!mustHaveExpression || expressions.length) {
                        var compute = function(values) {
                            for(var i = 0, ii = expressions.length; i < ii; i++){
                                if (allOrNothing && isUndefined(values[i])) return;
                                concat[expressionPositions[i]] = values[i];
                            }
                            if (contextAllowsConcatenation) // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
                            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(""));
                            else if (trustedContext && concat.length > 1) // This context does not allow more than one part, e.g. expr + string or exp + exp.
                            $interpolateMinErr.throwNoconcat(text);
                            // In an unprivileged context or only one part: just concatenate and return.
                            return concat.join("");
                        };
                        return extend(function interpolationFn(context) {
                            var i = 0;
                            var ii = expressions.length;
                            var values = new Array(ii);
                            try {
                                for(; i < ii; i++)values[i] = parseFns[i](context);
                                return compute(values);
                            } catch (err) {
                                $exceptionHandler($interpolateMinErr.interr(text, err));
                            }
                        }, {
                            // all of these properties are undocumented for now
                            exp: text,
                            expressions: expressions,
                            $$watchDelegate: function(scope, listener) {
                                var lastValue;
                                return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
                                    var currValue = compute(values);
                                    listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                                    lastValue = currValue;
                                });
                            }
                        });
                    }
                    function parseStringifyInterceptor(value) {
                        try {
                            // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
                            // parts of a full URL. We don't care about losing the trustedness here.
                            // In non-concatenable contexts, where there is only one expression, this interceptor is
                            // not applied to the expression.
                            value = trustedContext && !contextAllowsConcatenation ? $sce.getTrusted(trustedContext, value) : $sce.valueOf(value);
                            return allOrNothing && !isDefined(value) ? value : stringify(value);
                        } catch (err) {
                            $exceptionHandler($interpolateMinErr.interr(text, err));
                        }
                    }
                }
                /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */ $interpolate.startSymbol = function() {
                    return startSymbol;
                };
                /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */ $interpolate.endSymbol = function() {
                    return endSymbol;
                };
                return $interpolate;
            }
        ];
    }
    var $intervalMinErr = minErr("$interval");
    /** @this */ function $IntervalProvider() {
        this.$get = [
            "$$intervalFactory",
            "$window",
            function($$intervalFactory, $window) {
                var intervals = {};
                var setIntervalFn = function(tick, delay, deferred) {
                    var id = $window.setInterval(tick, delay);
                    intervals[id] = deferred;
                    return id;
                };
                var clearIntervalFn = function(id) {
                    $window.clearInterval(id);
                    delete intervals[id];
                };
                /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */ var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
                /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */ interval.cancel = function(promise) {
                    if (!promise) return false;
                    if (!promise.hasOwnProperty("$$intervalId")) throw $intervalMinErr("badprom", "`$interval.cancel()` called with a promise that was not generated by `$interval()`.");
                    if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
                    var id = promise.$$intervalId;
                    var deferred = intervals[id];
                    // Interval cancels should not report an unhandled promise.
                    markQExceptionHandled(deferred.promise);
                    deferred.reject("canceled");
                    clearIntervalFn(id);
                    return true;
                };
                return interval;
            }
        ];
    }
    /** @this */ function $$IntervalFactoryProvider() {
        this.$get = [
            "$browser",
            "$q",
            "$$q",
            "$rootScope",
            function($browser, $q, $$q, $rootScope) {
                return function intervalFactory(setIntervalFn, clearIntervalFn) {
                    return function intervalFn(fn, delay, count, invokeApply) {
                        var hasParams = arguments.length > 4, args = hasParams ? sliceArgs(arguments, 4) : [], iteration = 0, skipApply = isDefined(invokeApply) && !invokeApply, deferred = (skipApply ? $$q : $q).defer(), promise = deferred.promise;
                        count = isDefined(count) ? count : 0;
                        function callback() {
                            if (!hasParams) fn(iteration);
                            else fn.apply(null, args);
                        }
                        function tick() {
                            if (skipApply) $browser.defer(callback);
                            else $rootScope.$evalAsync(callback);
                            deferred.notify(iteration++);
                            if (count > 0 && iteration >= count) {
                                deferred.resolve(iteration);
                                clearIntervalFn(promise.$$intervalId);
                            }
                            if (!skipApply) $rootScope.$apply();
                        }
                        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
                        return promise;
                    };
                };
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */ var $jsonpCallbacksProvider = /** @this */ function() {
        this.$get = function() {
            var callbacks = angular.callbacks;
            var callbackMap = {};
            function createCallback(callbackId) {
                var callback = function(data) {
                    callback.data = data;
                    callback.called = true;
                };
                callback.id = callbackId;
                return callback;
            }
            return {
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */ createCallback: function(url) {
                    var callbackId = "_" + (callbacks.$$counter++).toString(36);
                    var callbackPath = "angular.callbacks." + callbackId;
                    var callback = createCallback(callbackId);
                    callbackMap[callbackPath] = callbacks[callbackId] = callback;
                    return callbackPath;
                },
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */ wasCalled: function(callbackPath) {
                    return callbackMap[callbackPath].called;
                },
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */ getResponse: function(callbackPath) {
                    return callbackMap[callbackPath].data;
                },
                /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */ removeCallback: function(callbackPath) {
                    var callback = callbackMap[callbackPath];
                    delete callbacks[callback.id];
                    delete callbackMap[callbackPath];
                }
            };
        };
    };
    /**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */ /* global stripHash: true */ var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/, DEFAULT_PORTS = {
        "http": 80,
        "https": 443,
        "ftp": 21
    };
    var $locationMinErr = minErr("$location");
    /**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */ function encodePath(path) {
        var segments = path.split("/"), i = segments.length;
        while(i--)// decode forward slashes to prevent them from being double encoded
        segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, "/"));
        return segments.join("/");
    }
    function decodePath(path, html5Mode) {
        var segments = path.split("/"), i = segments.length;
        while(i--){
            segments[i] = decodeURIComponent(segments[i]);
            if (html5Mode) // encode forward slashes to prevent them from being mistaken for path separators
            segments[i] = segments[i].replace(/\//g, "%2F");
        }
        return segments.join("/");
    }
    function normalizePath(pathValue, searchValue, hashValue) {
        var search = toKeyValue(searchValue), hash = hashValue ? "#" + encodeUriSegment(hashValue) : "", path = encodePath(pathValue);
        return path + (search ? "?" + search : "") + hash;
    }
    function parseAbsoluteUrl(absoluteUrl, locationObj) {
        var parsedUrl = urlResolve(absoluteUrl);
        locationObj.$$protocol = parsedUrl.protocol;
        locationObj.$$host = parsedUrl.hostname;
        locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
    }
    var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
    function parseAppUrl(url, locationObj, html5Mode) {
        if (DOUBLE_SLASH_REGEX.test(url)) throw $locationMinErr("badpath", 'Invalid url "{0}".', url);
        var prefixed = url.charAt(0) !== "/";
        if (prefixed) url = "/" + url;
        var match = urlResolve(url);
        var path = prefixed && match.pathname.charAt(0) === "/" ? match.pathname.substring(1) : match.pathname;
        locationObj.$$path = decodePath(path, html5Mode);
        locationObj.$$search = parseKeyValue(match.search);
        locationObj.$$hash = decodeURIComponent(match.hash);
        // make sure path starts with '/';
        if (locationObj.$$path && locationObj.$$path.charAt(0) !== "/") locationObj.$$path = "/" + locationObj.$$path;
    }
    function startsWith(str, search) {
        return str.slice(0, search.length) === search;
    }
    /**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */ function stripBaseUrl(base, url) {
        if (startsWith(url, base)) return url.substr(base.length);
    }
    function stripHash(url) {
        var index = url.indexOf("#");
        return index === -1 ? url : url.substr(0, index);
    }
    function stripFile(url) {
        return url.substr(0, stripHash(url).lastIndexOf("/") + 1);
    }
    /* return the server only (scheme://host:port) */ function serverBase(url) {
        return url.substring(0, url.indexOf("/", url.indexOf("//") + 2));
    }
    /**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */ function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
        this.$$html5 = true;
        basePrefix = basePrefix || "";
        parseAbsoluteUrl(appBase, this);
        /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */ this.$$parse = function(url) {
            var pathUrl = stripBaseUrl(appBaseNoFile, url);
            if (!isString(pathUrl)) throw $locationMinErr("ipthprfx", 'Invalid url "{0}", missing path prefix "{1}".', url, appBaseNoFile);
            parseAppUrl(pathUrl, this, true);
            if (!this.$$path) this.$$path = "/";
            this.$$compose();
        };
        this.$$normalizeUrl = function(url) {
            return appBaseNoFile + url.substr(1); // first char is always '/'
        };
        this.$$parseLinkUrl = function(url, relHref) {
            if (relHref && relHref[0] === "#") {
                // special case for links to hash fragments:
                // keep the old url and only replace the hash fragment
                this.hash(relHref.slice(1));
                return true;
            }
            var appUrl, prevAppUrl;
            var rewrittenUrl;
            if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
                prevAppUrl = appUrl;
                if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) rewrittenUrl = appBaseNoFile + (stripBaseUrl("/", appUrl) || appUrl);
                else rewrittenUrl = appBase + prevAppUrl;
            } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) rewrittenUrl = appBaseNoFile + appUrl;
            else if (appBaseNoFile === url + "/") rewrittenUrl = appBaseNoFile;
            if (rewrittenUrl) this.$$parse(rewrittenUrl);
            return !!rewrittenUrl;
        };
    }
    /**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */ function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
        parseAbsoluteUrl(appBase, this);
        /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */ this.$$parse = function(url) {
            var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
            var withoutHashUrl;
            if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === "#") {
                // The rest of the URL starts with a hash so we have
                // got either a hashbang path or a plain hash fragment
                withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
                if (isUndefined(withoutHashUrl)) // There was no hashbang prefix so we just have a hash fragment
                withoutHashUrl = withoutBaseUrl;
            } else // There was no hashbang path nor hash fragment:
            // If we are in HTML5 mode we use what is left as the path;
            // Otherwise we ignore what is left
            if (this.$$html5) withoutHashUrl = withoutBaseUrl;
            else {
                withoutHashUrl = "";
                if (isUndefined(withoutBaseUrl)) {
                    appBase = url;
                    /** @type {?} */ this.replace();
                }
            }
            parseAppUrl(withoutHashUrl, this, false);
            this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
            this.$$compose();
            /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */ function removeWindowsDriveName(path, url, base) {
                /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */ var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
                var firstPathSegmentMatch;
                //Get the relative path from the input URL.
                if (startsWith(url, base)) url = url.replace(base, "");
                // The input URL intentionally contains a first path segment that ends with a colon.
                if (windowsFilePathExp.exec(url)) return path;
                firstPathSegmentMatch = windowsFilePathExp.exec(path);
                return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
            }
        };
        this.$$normalizeUrl = function(url) {
            return appBase + (url ? hashPrefix + url : "");
        };
        this.$$parseLinkUrl = function(url, relHref) {
            if (stripHash(appBase) === stripHash(url)) {
                this.$$parse(url);
                return true;
            }
            return false;
        };
    }
    /**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */ function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
        this.$$html5 = true;
        LocationHashbangUrl.apply(this, arguments);
        this.$$parseLinkUrl = function(url, relHref) {
            if (relHref && relHref[0] === "#") {
                // special case for links to hash fragments:
                // keep the old url and only replace the hash fragment
                this.hash(relHref.slice(1));
                return true;
            }
            var rewrittenUrl;
            var appUrl;
            if (appBase === stripHash(url)) rewrittenUrl = url;
            else if (appUrl = stripBaseUrl(appBaseNoFile, url)) rewrittenUrl = appBase + hashPrefix + appUrl;
            else if (appBaseNoFile === url + "/") rewrittenUrl = appBaseNoFile;
            if (rewrittenUrl) this.$$parse(rewrittenUrl);
            return !!rewrittenUrl;
        };
        this.$$normalizeUrl = function(url) {
            // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
            return appBase + hashPrefix + url;
        };
    }
    var locationPrototype = {
        /**
   * Ensure absolute URL is initialized.
   * @private
   */ $$absUrl: "",
        /**
   * Are we in html5 mode?
   * @private
   */ $$html5: false,
        /**
   * Has any change been replacing?
   * @private
   */ $$replace: false,
        /**
   * Compose url and update `url` and `absUrl` property
   * @private
   */ $$compose: function() {
            this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
            this.$$absUrl = this.$$normalizeUrl(this.$$url);
            this.$$urlUpdatedByLocation = true;
        },
        /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */ absUrl: locationGetter("$$absUrl"),
        /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */ url: function(url) {
            if (isUndefined(url)) return this.$$url;
            var match = PATH_MATCH.exec(url);
            if (match[1] || url === "") this.path(decodeURIComponent(match[1]));
            if (match[2] || match[1] || url === "") this.search(match[3] || "");
            this.hash(match[5] || "");
            return this;
        },
        /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */ protocol: locationGetter("$$protocol"),
        /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */ host: locationGetter("$$host"),
        /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */ port: locationGetter("$$port"),
        /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */ path: locationGetterSetter("$$path", function(path) {
            path = path !== null ? path.toString() : "";
            return path.charAt(0) === "/" ? path : "/" + path;
        }),
        /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */ search: function(search, paramValue) {
            switch(arguments.length){
                case 0:
                    return this.$$search;
                case 1:
                    if (isString(search) || isNumber(search)) {
                        search = search.toString();
                        this.$$search = parseKeyValue(search);
                    } else if (isObject(search)) {
                        search = copy(search, {});
                        // remove object undefined or null properties
                        forEach(search, function(value, key) {
                            if (value == null) delete search[key];
                        });
                        this.$$search = search;
                    } else throw $locationMinErr("isrcharg", "The first argument of the `$location#search()` call must be a string or an object.");
                    break;
                default:
                    if (isUndefined(paramValue) || paramValue === null) delete this.$$search[search];
                    else this.$$search[search] = paramValue;
            }
            this.$$compose();
            return this;
        },
        /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */ hash: locationGetterSetter("$$hash", function(hash) {
            return hash !== null ? hash.toString() : "";
        }),
        /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */ replace: function() {
            this.$$replace = true;
            return this;
        }
    };
    forEach([
        LocationHashbangInHtml5Url,
        LocationHashbangUrl,
        LocationHtml5Url
    ], function(Location) {
        Location.prototype = Object.create(locationPrototype);
        /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */ Location.prototype.state = function(state) {
            if (!arguments.length) return this.$$state;
            if (Location !== LocationHtml5Url || !this.$$html5) throw $locationMinErr("nostate", "History API state support is available only in HTML5 mode and only in browsers supporting HTML5 History API");
            // The user might modify `stateObject` after invoking `$location.state(stateObject)`
            // but we're changing the $$state reference to $browser.state() during the $digest
            // so the modification window is narrow.
            this.$$state = isUndefined(state) ? null : state;
            this.$$urlUpdatedByLocation = true;
            return this;
        };
    });
    function locationGetter(property) {
        return /** @this */ function() {
            return this[property];
        };
    }
    function locationGetterSetter(property, preprocess) {
        return /** @this */ function(value) {
            if (isUndefined(value)) return this[property];
            this[property] = preprocess(value);
            this.$$compose();
            return this;
        };
    }
    /**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */ /**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */ function $LocationProvider() {
        var hashPrefix = "!", html5Mode = {
            enabled: false,
            requireBase: true,
            rewriteLinks: true
        };
        /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */ this.hashPrefix = function(prefix) {
            if (isDefined(prefix)) {
                hashPrefix = prefix;
                return this;
            } else return hashPrefix;
        };
        /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */ this.html5Mode = function(mode) {
            if (isBoolean(mode)) {
                html5Mode.enabled = mode;
                return this;
            } else if (isObject(mode)) {
                if (isBoolean(mode.enabled)) html5Mode.enabled = mode.enabled;
                if (isBoolean(mode.requireBase)) html5Mode.requireBase = mode.requireBase;
                if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) html5Mode.rewriteLinks = mode.rewriteLinks;
                return this;
            } else return html5Mode;
        };
        /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */ /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */ this.$get = [
            "$rootScope",
            "$browser",
            "$sniffer",
            "$rootElement",
            "$window",
            function($rootScope, $browser, $sniffer, $rootElement, $window) {
                var $location, LocationMode, baseHref = $browser.baseHref(), initialUrl = $browser.url(), appBase;
                if (html5Mode.enabled) {
                    if (!baseHref && html5Mode.requireBase) throw $locationMinErr("nobase", "$location in HTML5 mode requires a <base> tag to be present!");
                    appBase = serverBase(initialUrl) + (baseHref || "/");
                    LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
                } else {
                    appBase = stripHash(initialUrl);
                    LocationMode = LocationHashbangUrl;
                }
                var appBaseNoFile = stripFile(appBase);
                $location = new LocationMode(appBase, appBaseNoFile, "#" + hashPrefix);
                $location.$$parseLinkUrl(initialUrl, initialUrl);
                $location.$$state = $browser.state();
                var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
                // Determine if two URLs are equal despite potentially having different encoding/normalizing
                //  such as $location.absUrl() vs $browser.url()
                // See https://github.com/angular/angular.js/issues/16592
                function urlsEqual(a, b) {
                    return a === b || urlResolve(a).href === urlResolve(b).href;
                }
                function setBrowserUrlWithFallback(url, replace, state) {
                    var oldUrl = $location.url();
                    var oldState = $location.$$state;
                    try {
                        $browser.url(url, replace, state);
                        // Make sure $location.state() returns referentially identical (not just deeply equal)
                        // state object; this makes possible quick checking if the state changed in the digest
                        // loop. Checking deep equality would be too expensive.
                        $location.$$state = $browser.state();
                    } catch (e) {
                        // Restore old values if pushState fails
                        $location.url(oldUrl);
                        $location.$$state = oldState;
                        throw e;
                    }
                }
                $rootElement.on("click", function(event) {
                    var rewriteLinks = html5Mode.rewriteLinks;
                    // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
                    // currently we open nice url link and redirect then
                    if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
                    var elm = jqLite(event.target);
                    // traverse the DOM up to find first A tag
                    while(nodeName_(elm[0]) !== "a"){
                        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
                        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
                    }
                    if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
                    var absHref = elm.prop("href");
                    // get the actual href attribute - see
                    // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
                    var relHref = elm.attr("href") || elm.attr("xlink:href");
                    if (isObject(absHref) && absHref.toString() === "[object SVGAnimatedString]") // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
                    // an animation.
                    absHref = urlResolve(absHref.animVal).href;
                    // Ignore when url is started with javascript: or mailto:
                    if (IGNORE_URI_REGEXP.test(absHref)) return;
                    if (absHref && !elm.attr("target") && !event.isDefaultPrevented()) {
                        if ($location.$$parseLinkUrl(absHref, relHref)) {
                            // We do a preventDefault for all urls that are part of the AngularJS application,
                            // in html5mode and also without, so that we are able to abort navigation without
                            // getting double entries in the location history.
                            event.preventDefault();
                            // update location manually
                            if ($location.absUrl() !== $browser.url()) $rootScope.$apply();
                        }
                    }
                });
                // rewrite hashbang url <> html5 url
                if ($location.absUrl() !== initialUrl) $browser.url($location.absUrl(), true);
                var initializing = true;
                // update $location when $browser url changes
                $browser.onUrlChange(function(newUrl, newState) {
                    if (!startsWith(newUrl, appBaseNoFile)) {
                        // If we are navigating outside of the app then force a reload
                        $window.location.href = newUrl;
                        return;
                    }
                    $rootScope.$evalAsync(function() {
                        var oldUrl = $location.absUrl();
                        var oldState = $location.$$state;
                        var defaultPrevented;
                        $location.$$parse(newUrl);
                        $location.$$state = newState;
                        defaultPrevented = $rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl, newState, oldState).defaultPrevented;
                        // if the location was changed by a `$locationChangeStart` handler then stop
                        // processing this location change
                        if ($location.absUrl() !== newUrl) return;
                        if (defaultPrevented) {
                            $location.$$parse(oldUrl);
                            $location.$$state = oldState;
                            setBrowserUrlWithFallback(oldUrl, false, oldState);
                        } else {
                            initializing = false;
                            afterLocationChange(oldUrl, oldState);
                        }
                    });
                    if (!$rootScope.$$phase) $rootScope.$digest();
                });
                // update browser
                $rootScope.$watch(function $locationWatch() {
                    if (initializing || $location.$$urlUpdatedByLocation) {
                        $location.$$urlUpdatedByLocation = false;
                        var oldUrl = $browser.url();
                        var newUrl = $location.absUrl();
                        var oldState = $browser.state();
                        var currentReplace = $location.$$replace;
                        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) || $location.$$html5 && $sniffer.history && oldState !== $location.$$state;
                        if (initializing || urlOrStateChanged) {
                            initializing = false;
                            $rootScope.$evalAsync(function() {
                                var newUrl = $location.absUrl();
                                var defaultPrevented = $rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl, $location.$$state, oldState).defaultPrevented;
                                // if the location was changed by a `$locationChangeStart` handler then stop
                                // processing this location change
                                if ($location.absUrl() !== newUrl) return;
                                if (defaultPrevented) {
                                    $location.$$parse(oldUrl);
                                    $location.$$state = oldState;
                                } else {
                                    if (urlOrStateChanged) setBrowserUrlWithFallback(newUrl, currentReplace, oldState === $location.$$state ? null : $location.$$state);
                                    afterLocationChange(oldUrl, oldState);
                                }
                            });
                        }
                    }
                    $location.$$replace = false;
                // we don't need to return anything because $evalAsync will make the digest loop dirty when
                // there is a change
                });
                return $location;
                function afterLocationChange(oldUrl, oldState) {
                    $rootScope.$broadcast("$locationChangeSuccess", $location.absUrl(), oldUrl, $location.$$state, oldState);
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */ /**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */ function $LogProvider() {
        var debug = true, self = this;
        /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */ this.debugEnabled = function(flag) {
            if (isDefined(flag)) {
                debug = flag;
                return this;
            } else return debug;
        };
        this.$get = [
            "$window",
            function($window) {
                // Support: IE 9-11, Edge 12-14+
                // IE/Edge display errors in such a way that it requires the user to click in 4 places
                // to see the stack trace. There is no way to feature-detect it so there's a chance
                // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
                // break apps. Other browsers display errors in a sensible way and some of them map stack
                // traces along source maps if available so it makes sense to let browsers display it
                // as they want.
                var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
                return {
                    /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */ log: consoleLog("log"),
                    /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */ info: consoleLog("info"),
                    /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */ warn: consoleLog("warn"),
                    /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */ error: consoleLog("error"),
                    /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */ debug: function() {
                        var fn = consoleLog("debug");
                        return function() {
                            if (debug) fn.apply(self, arguments);
                        };
                    }()
                };
                function formatError(arg) {
                    if (isError(arg)) {
                        if (arg.stack && formatStackTrace) arg = arg.message && arg.stack.indexOf(arg.message) === -1 ? "Error: " + arg.message + "\n" + arg.stack : arg.stack;
                        else if (arg.sourceURL) arg = arg.message + "\n" + arg.sourceURL + ":" + arg.line;
                    }
                    return arg;
                }
                function consoleLog(type) {
                    var console1 = $window.console || {}, logFn = console1[type] || console1.log || noop;
                    return function() {
                        var args = [];
                        forEach(arguments, function(arg) {
                            args.push(formatError(arg));
                        });
                        // Support: IE 9 only
                        // console methods don't inherit from Function.prototype in IE 9 so we can't
                        // call `logFn.apply(console, args)` directly.
                        return Function.prototype.apply.call(logFn, console1, args);
                    };
                }
            }
        ];
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ var $parseMinErr = minErr("$parse");
    var objectValueOf = {}.constructor.prototype.valueOf;
    // Sandboxing AngularJS Expressions
    // ------------------------------
    // AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
    // various means such as obtaining a reference to native JS functions like the Function constructor.
    //
    // As an example, consider the following AngularJS expression:
    //
    //   {}.toString.constructor('alert("evil JS code")')
    //
    // It is important to realize that if you create an expression from a string that contains user provided
    // content then it is possible that your application contains a security vulnerability to an XSS style attack.
    //
    // See https://docs.angularjs.org/guide/security
    function getStringValue(name) {
        // Property names must be strings. This means that non-string objects cannot be used
        // as keys in an object. Any non-string object, including a number, is typecasted
        // into a string via the toString method.
        // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
        //
        // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
        // to a string. It's not always possible. If `name` is an object and its `toString` method is
        // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
        //
        // TypeError: Cannot convert object to primitive value
        //
        // For performance reasons, we don't catch this error here and allow it to propagate up the call
        // stack. Note that you'll get the same error in JavaScript if you try to access a property using
        // such a 'broken' object as a key.
        return name + "";
    }
    var OPERATORS = createMap();
    forEach("+ - * / % === !== == != < > <= >= && || ! = |".split(" "), function(operator) {
        OPERATORS[operator] = true;
    });
    var ESCAPE = {
        "n": "\n",
        "f": "\f",
        "r": "\r",
        "t": "	",
        "v": "\v",
        "'": "'",
        '"': '"'
    };
    /////////////////////////////////////////
    /**
 * @constructor
 */ var Lexer = function Lexer(options) {
        this.options = options;
    };
    Lexer.prototype = {
        constructor: Lexer,
        lex: function(text) {
            this.text = text;
            this.index = 0;
            this.tokens = [];
            while(this.index < this.text.length){
                var ch = this.text.charAt(this.index);
                if (ch === '"' || ch === "'") this.readString(ch);
                else if (this.isNumber(ch) || ch === "." && this.isNumber(this.peek())) this.readNumber();
                else if (this.isIdentifierStart(this.peekMultichar())) this.readIdent();
                else if (this.is(ch, "(){}[].,;:?")) {
                    this.tokens.push({
                        index: this.index,
                        text: ch
                    });
                    this.index++;
                } else if (this.isWhitespace(ch)) this.index++;
                else {
                    var ch2 = ch + this.peek();
                    var ch3 = ch2 + this.peek(2);
                    var op1 = OPERATORS[ch];
                    var op2 = OPERATORS[ch2];
                    var op3 = OPERATORS[ch3];
                    if (op1 || op2 || op3) {
                        var token = op3 ? ch3 : op2 ? ch2 : ch;
                        this.tokens.push({
                            index: this.index,
                            text: token,
                            operator: true
                        });
                        this.index += token.length;
                    } else this.throwError("Unexpected next character ", this.index, this.index + 1);
                }
            }
            return this.tokens;
        },
        is: function(ch, chars) {
            return chars.indexOf(ch) !== -1;
        },
        peek: function(i) {
            var num = i || 1;
            return this.index + num < this.text.length ? this.text.charAt(this.index + num) : false;
        },
        isNumber: function(ch) {
            return "0" <= ch && ch <= "9" && typeof ch === "string";
        },
        isWhitespace: function(ch) {
            // IE treats non-breaking space as \u00A0
            return ch === " " || ch === "\r" || ch === "	" || ch === "\n" || ch === "\v" || ch === "\xa0";
        },
        isIdentifierStart: function(ch) {
            return this.options.isIdentifierStart ? this.options.isIdentifierStart(ch, this.codePointAt(ch)) : this.isValidIdentifierStart(ch);
        },
        isValidIdentifierStart: function(ch) {
            return "a" <= ch && ch <= "z" || "A" <= ch && ch <= "Z" || "_" === ch || ch === "$";
        },
        isIdentifierContinue: function(ch) {
            return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(ch, this.codePointAt(ch)) : this.isValidIdentifierContinue(ch);
        },
        isValidIdentifierContinue: function(ch, cp) {
            return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
        },
        codePointAt: function(ch) {
            if (ch.length === 1) return ch.charCodeAt(0);
            // eslint-disable-next-line no-bitwise
            return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
        },
        peekMultichar: function() {
            var ch = this.text.charAt(this.index);
            var peek = this.peek();
            if (!peek) return ch;
            var cp1 = ch.charCodeAt(0);
            var cp2 = peek.charCodeAt(0);
            if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) return ch + peek;
            return ch;
        },
        isExpOperator: function(ch) {
            return ch === "-" || ch === "+" || this.isNumber(ch);
        },
        throwError: function(error, start, end) {
            end = end || this.index;
            var colStr = isDefined(start) ? "s " + start + "-" + this.index + " [" + this.text.substring(start, end) + "]" : " " + end;
            throw $parseMinErr("lexerr", "Lexer Error: {0} at column{1} in expression [{2}].", error, colStr, this.text);
        },
        readNumber: function() {
            var number = "";
            var start = this.index;
            while(this.index < this.text.length){
                var ch = lowercase(this.text.charAt(this.index));
                if (ch === "." || this.isNumber(ch)) number += ch;
                else {
                    var peekCh = this.peek();
                    if (ch === "e" && this.isExpOperator(peekCh)) number += ch;
                    else if (this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) === "e") number += ch;
                    else if (this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) === "e") this.throwError("Invalid exponent");
                    else break;
                }
                this.index++;
            }
            this.tokens.push({
                index: start,
                text: number,
                constant: true,
                value: Number(number)
            });
        },
        readIdent: function() {
            var start = this.index;
            this.index += this.peekMultichar().length;
            while(this.index < this.text.length){
                var ch = this.peekMultichar();
                if (!this.isIdentifierContinue(ch)) break;
                this.index += ch.length;
            }
            this.tokens.push({
                index: start,
                text: this.text.slice(start, this.index),
                identifier: true
            });
        },
        readString: function(quote) {
            var start = this.index;
            this.index++;
            var string = "";
            var rawString = quote;
            var escape = false;
            while(this.index < this.text.length){
                var ch = this.text.charAt(this.index);
                rawString += ch;
                if (escape) {
                    if (ch === "u") {
                        var hex = this.text.substring(this.index + 1, this.index + 5);
                        if (!hex.match(/[\da-f]{4}/i)) this.throwError("Invalid unicode escape [\\u" + hex + "]");
                        this.index += 4;
                        string += String.fromCharCode(parseInt(hex, 16));
                    } else {
                        var rep = ESCAPE[ch];
                        string = string + (rep || ch);
                    }
                    escape = false;
                } else if (ch === "\\") escape = true;
                else if (ch === quote) {
                    this.index++;
                    this.tokens.push({
                        index: start,
                        text: rawString,
                        constant: true,
                        value: string
                    });
                    return;
                } else string += ch;
                this.index++;
            }
            this.throwError("Unterminated quote", start);
        }
    };
    var AST = function AST(lexer, options) {
        this.lexer = lexer;
        this.options = options;
    };
    AST.Program = "Program";
    AST.ExpressionStatement = "ExpressionStatement";
    AST.AssignmentExpression = "AssignmentExpression";
    AST.ConditionalExpression = "ConditionalExpression";
    AST.LogicalExpression = "LogicalExpression";
    AST.BinaryExpression = "BinaryExpression";
    AST.UnaryExpression = "UnaryExpression";
    AST.CallExpression = "CallExpression";
    AST.MemberExpression = "MemberExpression";
    AST.Identifier = "Identifier";
    AST.Literal = "Literal";
    AST.ArrayExpression = "ArrayExpression";
    AST.Property = "Property";
    AST.ObjectExpression = "ObjectExpression";
    AST.ThisExpression = "ThisExpression";
    AST.LocalsExpression = "LocalsExpression";
    // Internal use only
    AST.NGValueParameter = "NGValueParameter";
    AST.prototype = {
        ast: function(text) {
            this.text = text;
            this.tokens = this.lexer.lex(text);
            var value = this.program();
            if (this.tokens.length !== 0) this.throwError("is an unexpected token", this.tokens[0]);
            return value;
        },
        program: function() {
            var body = [];
            while(true){
                if (this.tokens.length > 0 && !this.peek("}", ")", ";", "]")) body.push(this.expressionStatement());
                if (!this.expect(";")) return {
                    type: AST.Program,
                    body: body
                };
            }
        },
        expressionStatement: function() {
            return {
                type: AST.ExpressionStatement,
                expression: this.filterChain()
            };
        },
        filterChain: function() {
            var left = this.expression();
            while(this.expect("|"))left = this.filter(left);
            return left;
        },
        expression: function() {
            return this.assignment();
        },
        assignment: function() {
            var result = this.ternary();
            if (this.expect("=")) {
                if (!isAssignable(result)) throw $parseMinErr("lval", "Trying to assign a value to a non l-value");
                result = {
                    type: AST.AssignmentExpression,
                    left: result,
                    right: this.assignment(),
                    operator: "="
                };
            }
            return result;
        },
        ternary: function() {
            var test = this.logicalOR();
            var alternate;
            var consequent;
            if (this.expect("?")) {
                alternate = this.expression();
                if (this.consume(":")) {
                    consequent = this.expression();
                    return {
                        type: AST.ConditionalExpression,
                        test: test,
                        alternate: alternate,
                        consequent: consequent
                    };
                }
            }
            return test;
        },
        logicalOR: function() {
            var left = this.logicalAND();
            while(this.expect("||"))left = {
                type: AST.LogicalExpression,
                operator: "||",
                left: left,
                right: this.logicalAND()
            };
            return left;
        },
        logicalAND: function() {
            var left = this.equality();
            while(this.expect("&&"))left = {
                type: AST.LogicalExpression,
                operator: "&&",
                left: left,
                right: this.equality()
            };
            return left;
        },
        equality: function() {
            var left = this.relational();
            var token;
            while(token = this.expect("==", "!=", "===", "!=="))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.relational()
            };
            return left;
        },
        relational: function() {
            var left = this.additive();
            var token;
            while(token = this.expect("<", ">", "<=", ">="))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.additive()
            };
            return left;
        },
        additive: function() {
            var left = this.multiplicative();
            var token;
            while(token = this.expect("+", "-"))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.multiplicative()
            };
            return left;
        },
        multiplicative: function() {
            var left = this.unary();
            var token;
            while(token = this.expect("*", "/", "%"))left = {
                type: AST.BinaryExpression,
                operator: token.text,
                left: left,
                right: this.unary()
            };
            return left;
        },
        unary: function() {
            var token;
            if (token = this.expect("+", "-", "!")) return {
                type: AST.UnaryExpression,
                operator: token.text,
                prefix: true,
                argument: this.unary()
            };
            else return this.primary();
        },
        primary: function() {
            var primary;
            if (this.expect("(")) {
                primary = this.filterChain();
                this.consume(")");
            } else if (this.expect("[")) primary = this.arrayDeclaration();
            else if (this.expect("{")) primary = this.object();
            else if (this.selfReferential.hasOwnProperty(this.peek().text)) primary = copy(this.selfReferential[this.consume().text]);
            else if (this.options.literals.hasOwnProperty(this.peek().text)) primary = {
                type: AST.Literal,
                value: this.options.literals[this.consume().text]
            };
            else if (this.peek().identifier) primary = this.identifier();
            else if (this.peek().constant) primary = this.constant();
            else this.throwError("not a primary expression", this.peek());
            var next;
            while(next = this.expect("(", "[", ".")){
                if (next.text === "(") {
                    primary = {
                        type: AST.CallExpression,
                        callee: primary,
                        arguments: this.parseArguments()
                    };
                    this.consume(")");
                } else if (next.text === "[") {
                    primary = {
                        type: AST.MemberExpression,
                        object: primary,
                        property: this.expression(),
                        computed: true
                    };
                    this.consume("]");
                } else if (next.text === ".") primary = {
                    type: AST.MemberExpression,
                    object: primary,
                    property: this.identifier(),
                    computed: false
                };
                else this.throwError("IMPOSSIBLE");
            }
            return primary;
        },
        filter: function(baseExpression) {
            var args = [
                baseExpression
            ];
            var result = {
                type: AST.CallExpression,
                callee: this.identifier(),
                arguments: args,
                filter: true
            };
            while(this.expect(":"))args.push(this.expression());
            return result;
        },
        parseArguments: function() {
            var args = [];
            if (this.peekToken().text !== ")") do args.push(this.filterChain());
            while (this.expect(","));
            return args;
        },
        identifier: function() {
            var token = this.consume();
            if (!token.identifier) this.throwError("is not a valid identifier", token);
            return {
                type: AST.Identifier,
                name: token.text
            };
        },
        constant: function() {
            // TODO check that it is a constant
            return {
                type: AST.Literal,
                value: this.consume().value
            };
        },
        arrayDeclaration: function() {
            var elements = [];
            if (this.peekToken().text !== "]") do {
                if (this.peek("]")) break;
                elements.push(this.expression());
            }while (this.expect(","));
            this.consume("]");
            return {
                type: AST.ArrayExpression,
                elements: elements
            };
        },
        object: function() {
            var properties = [], property;
            if (this.peekToken().text !== "}") do {
                if (this.peek("}")) break;
                property = {
                    type: AST.Property,
                    kind: "init"
                };
                if (this.peek().constant) {
                    property.key = this.constant();
                    property.computed = false;
                    this.consume(":");
                    property.value = this.expression();
                } else if (this.peek().identifier) {
                    property.key = this.identifier();
                    property.computed = false;
                    if (this.peek(":")) {
                        this.consume(":");
                        property.value = this.expression();
                    } else property.value = property.key;
                } else if (this.peek("[")) {
                    this.consume("[");
                    property.key = this.expression();
                    this.consume("]");
                    property.computed = true;
                    this.consume(":");
                    property.value = this.expression();
                } else this.throwError("invalid key", this.peek());
                properties.push(property);
            }while (this.expect(","));
            this.consume("}");
            return {
                type: AST.ObjectExpression,
                properties: properties
            };
        },
        throwError: function(msg, token) {
            throw $parseMinErr("syntax", "Syntax Error: Token '{0}' {1} at column {2} of the expression [{3}] starting at [{4}].", token.text, msg, token.index + 1, this.text, this.text.substring(token.index));
        },
        consume: function(e1) {
            if (this.tokens.length === 0) throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);
            var token = this.expect(e1);
            if (!token) this.throwError("is unexpected, expecting [" + e1 + "]", this.peek());
            return token;
        },
        peekToken: function() {
            if (this.tokens.length === 0) throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);
            return this.tokens[0];
        },
        peek: function(e1, e2, e3, e4) {
            return this.peekAhead(0, e1, e2, e3, e4);
        },
        peekAhead: function(i, e1, e2, e3, e4) {
            if (this.tokens.length > i) {
                var token = this.tokens[i];
                var t = token.text;
                if (t === e1 || t === e2 || t === e3 || t === e4 || !e1 && !e2 && !e3 && !e4) return token;
            }
            return false;
        },
        expect: function(e1, e2, e3, e4) {
            var token = this.peek(e1, e2, e3, e4);
            if (token) {
                this.tokens.shift();
                return token;
            }
            return false;
        },
        selfReferential: {
            "this": {
                type: AST.ThisExpression
            },
            "$locals": {
                type: AST.LocalsExpression
            }
        }
    };
    function ifDefined(v, d) {
        return typeof v !== "undefined" ? v : d;
    }
    function plusFn(l, r) {
        if (typeof l === "undefined") return r;
        if (typeof r === "undefined") return l;
        return l + r;
    }
    function isStateless($filter, filterName) {
        var fn = $filter(filterName);
        return !fn.$stateful;
    }
    var PURITY_ABSOLUTE = 1;
    var PURITY_RELATIVE = 2;
    // Detect nodes which could depend on non-shallow state of objects
    function isPure(node, parentIsPure) {
        switch(node.type){
            // Computed members might invoke a stateful toString()
            case AST.MemberExpression:
                if (node.computed) return false;
                break;
            // Unary always convert to primative
            case AST.UnaryExpression:
                return PURITY_ABSOLUTE;
            // The binary + operator can invoke a stateful toString().
            case AST.BinaryExpression:
                return node.operator !== "+" ? PURITY_ABSOLUTE : false;
            // Functions / filters probably read state from within objects
            case AST.CallExpression:
                return false;
        }
        return undefined === parentIsPure ? PURITY_RELATIVE : parentIsPure;
    }
    function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
        var allConstants;
        var argsToWatch;
        var isStatelessFilter;
        var astIsPure = ast.isPure = isPure(ast, parentIsPure);
        switch(ast.type){
            case AST.Program:
                allConstants = true;
                forEach(ast.body, function(expr) {
                    findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
                    allConstants = allConstants && expr.expression.constant;
                });
                ast.constant = allConstants;
                break;
            case AST.Literal:
                ast.constant = true;
                ast.toWatch = [];
                break;
            case AST.UnaryExpression:
                findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
                ast.constant = ast.argument.constant;
                ast.toWatch = ast.argument.toWatch;
                break;
            case AST.BinaryExpression:
                findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
                ast.constant = ast.left.constant && ast.right.constant;
                ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
                break;
            case AST.LogicalExpression:
                findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
                ast.constant = ast.left.constant && ast.right.constant;
                ast.toWatch = ast.constant ? [] : [
                    ast
                ];
                break;
            case AST.ConditionalExpression:
                findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
                ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
                ast.toWatch = ast.constant ? [] : [
                    ast
                ];
                break;
            case AST.Identifier:
                ast.constant = false;
                ast.toWatch = [
                    ast
                ];
                break;
            case AST.MemberExpression:
                findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
                if (ast.computed) findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
                ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
                ast.toWatch = ast.constant ? [] : [
                    ast
                ];
                break;
            case AST.CallExpression:
                isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
                allConstants = isStatelessFilter;
                argsToWatch = [];
                forEach(ast.arguments, function(expr) {
                    findConstantAndWatchExpressions(expr, $filter, astIsPure);
                    allConstants = allConstants && expr.constant;
                    argsToWatch.push.apply(argsToWatch, expr.toWatch);
                });
                ast.constant = allConstants;
                ast.toWatch = isStatelessFilter ? argsToWatch : [
                    ast
                ];
                break;
            case AST.AssignmentExpression:
                findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
                findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
                ast.constant = ast.left.constant && ast.right.constant;
                ast.toWatch = [
                    ast
                ];
                break;
            case AST.ArrayExpression:
                allConstants = true;
                argsToWatch = [];
                forEach(ast.elements, function(expr) {
                    findConstantAndWatchExpressions(expr, $filter, astIsPure);
                    allConstants = allConstants && expr.constant;
                    argsToWatch.push.apply(argsToWatch, expr.toWatch);
                });
                ast.constant = allConstants;
                ast.toWatch = argsToWatch;
                break;
            case AST.ObjectExpression:
                allConstants = true;
                argsToWatch = [];
                forEach(ast.properties, function(property) {
                    findConstantAndWatchExpressions(property.value, $filter, astIsPure);
                    allConstants = allConstants && property.value.constant;
                    argsToWatch.push.apply(argsToWatch, property.value.toWatch);
                    if (property.computed) {
                        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
                        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/ false);
                        allConstants = allConstants && property.key.constant;
                        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
                    }
                });
                ast.constant = allConstants;
                ast.toWatch = argsToWatch;
                break;
            case AST.ThisExpression:
                ast.constant = false;
                ast.toWatch = [];
                break;
            case AST.LocalsExpression:
                ast.constant = false;
                ast.toWatch = [];
                break;
        }
    }
    function getInputs(body) {
        if (body.length !== 1) return;
        var lastExpression = body[0].expression;
        var candidate = lastExpression.toWatch;
        if (candidate.length !== 1) return candidate;
        return candidate[0] !== lastExpression ? candidate : undefined;
    }
    function isAssignable(ast) {
        return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
    }
    function assignableAST(ast) {
        if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) return {
            type: AST.AssignmentExpression,
            left: ast.body[0].expression,
            right: {
                type: AST.NGValueParameter
            },
            operator: "="
        };
    }
    function isLiteral(ast) {
        return ast.body.length === 0 || ast.body.length === 1 && (ast.body[0].expression.type === AST.Literal || ast.body[0].expression.type === AST.ArrayExpression || ast.body[0].expression.type === AST.ObjectExpression);
    }
    function isConstant(ast) {
        return ast.constant;
    }
    function ASTCompiler($filter) {
        this.$filter = $filter;
    }
    ASTCompiler.prototype = {
        compile: function(ast) {
            var self = this;
            this.state = {
                nextId: 0,
                filters: {},
                fn: {
                    vars: [],
                    body: [],
                    own: {}
                },
                assign: {
                    vars: [],
                    body: [],
                    own: {}
                },
                inputs: []
            };
            findConstantAndWatchExpressions(ast, self.$filter);
            var extra = "";
            var assignable;
            this.stage = "assign";
            if (assignable = assignableAST(ast)) {
                this.state.computing = "assign";
                var result = this.nextId();
                this.recurse(assignable, result);
                this.return_(result);
                extra = "fn.assign=" + this.generateFunction("assign", "s,v,l");
            }
            var toWatch = getInputs(ast.body);
            self.stage = "inputs";
            forEach(toWatch, function(watch, key) {
                var fnKey = "fn" + key;
                self.state[fnKey] = {
                    vars: [],
                    body: [],
                    own: {}
                };
                self.state.computing = fnKey;
                var intoId = self.nextId();
                self.recurse(watch, intoId);
                self.return_(intoId);
                self.state.inputs.push({
                    name: fnKey,
                    isPure: watch.isPure
                });
                watch.watchId = key;
            });
            this.state.computing = "fn";
            this.stage = "main";
            this.recurse(ast);
            var fnString = // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
            // This is a workaround for this until we do a better job at only removing the prefix only when we should.
            '"' + this.USE + " " + this.STRICT + '";\n' + this.filterPrefix() + "var fn=" + this.generateFunction("fn", "s,l,a,i") + extra + this.watchFns() + "return fn;";
            // eslint-disable-next-line no-new-func
            var fn = new Function("$filter", "getStringValue", "ifDefined", "plus", fnString)(this.$filter, getStringValue, ifDefined, plusFn);
            this.state = this.stage = undefined;
            return fn;
        },
        USE: "use",
        STRICT: "strict",
        watchFns: function() {
            var result = [];
            var inputs = this.state.inputs;
            var self = this;
            forEach(inputs, function(input) {
                result.push("var " + input.name + "=" + self.generateFunction(input.name, "s"));
                if (input.isPure) result.push(input.name, ".isPure=" + JSON.stringify(input.isPure) + ";");
            });
            if (inputs.length) result.push("fn.inputs=[" + inputs.map(function(i) {
                return i.name;
            }).join(",") + "];");
            return result.join("");
        },
        generateFunction: function(name, params) {
            return "function(" + params + "){" + this.varsPrefix(name) + this.body(name) + "};";
        },
        filterPrefix: function() {
            var parts = [];
            var self = this;
            forEach(this.state.filters, function(id, filter) {
                parts.push(id + "=$filter(" + self.escape(filter) + ")");
            });
            if (parts.length) return "var " + parts.join(",") + ";";
            return "";
        },
        varsPrefix: function(section) {
            return this.state[section].vars.length ? "var " + this.state[section].vars.join(",") + ";" : "";
        },
        body: function(section) {
            return this.state[section].body.join("");
        },
        recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
            var left, right, self = this, args, expression, computed;
            recursionFn = recursionFn || noop;
            if (!skipWatchIdCheck && isDefined(ast.watchId)) {
                intoId = intoId || this.nextId();
                this.if_("i", this.lazyAssign(intoId, this.computedMember("i", ast.watchId)), this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true));
                return;
            }
            switch(ast.type){
                case AST.Program:
                    forEach(ast.body, function(expression, pos) {
                        self.recurse(expression.expression, undefined, undefined, function(expr) {
                            right = expr;
                        });
                        if (pos !== ast.body.length - 1) self.current().body.push(right, ";");
                        else self.return_(right);
                    });
                    break;
                case AST.Literal:
                    expression = this.escape(ast.value);
                    this.assign(intoId, expression);
                    recursionFn(intoId || expression);
                    break;
                case AST.UnaryExpression:
                    this.recurse(ast.argument, undefined, undefined, function(expr) {
                        right = expr;
                    });
                    expression = ast.operator + "(" + this.ifDefined(right, 0) + ")";
                    this.assign(intoId, expression);
                    recursionFn(expression);
                    break;
                case AST.BinaryExpression:
                    this.recurse(ast.left, undefined, undefined, function(expr) {
                        left = expr;
                    });
                    this.recurse(ast.right, undefined, undefined, function(expr) {
                        right = expr;
                    });
                    if (ast.operator === "+") expression = this.plus(left, right);
                    else if (ast.operator === "-") expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
                    else expression = "(" + left + ")" + ast.operator + "(" + right + ")";
                    this.assign(intoId, expression);
                    recursionFn(expression);
                    break;
                case AST.LogicalExpression:
                    intoId = intoId || this.nextId();
                    self.recurse(ast.left, intoId);
                    self.if_(ast.operator === "&&" ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
                    recursionFn(intoId);
                    break;
                case AST.ConditionalExpression:
                    intoId = intoId || this.nextId();
                    self.recurse(ast.test, intoId);
                    self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
                    recursionFn(intoId);
                    break;
                case AST.Identifier:
                    intoId = intoId || this.nextId();
                    if (nameId) {
                        nameId.context = self.stage === "inputs" ? "s" : this.assign(this.nextId(), this.getHasOwnProperty("l", ast.name) + "?l:s");
                        nameId.computed = false;
                        nameId.name = ast.name;
                    }
                    self.if_(self.stage === "inputs" || self.not(self.getHasOwnProperty("l", ast.name)), function() {
                        self.if_(self.stage === "inputs" || "s", function() {
                            if (create && create !== 1) self.if_(self.isNull(self.nonComputedMember("s", ast.name)), self.lazyAssign(self.nonComputedMember("s", ast.name), "{}"));
                            self.assign(intoId, self.nonComputedMember("s", ast.name));
                        });
                    }, intoId && self.lazyAssign(intoId, self.nonComputedMember("l", ast.name)));
                    recursionFn(intoId);
                    break;
                case AST.MemberExpression:
                    left = nameId && (nameId.context = this.nextId()) || this.nextId();
                    intoId = intoId || this.nextId();
                    self.recurse(ast.object, left, undefined, function() {
                        self.if_(self.notNull(left), function() {
                            if (ast.computed) {
                                right = self.nextId();
                                self.recurse(ast.property, right);
                                self.getStringValue(right);
                                if (create && create !== 1) self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), "{}"));
                                expression = self.computedMember(left, right);
                                self.assign(intoId, expression);
                                if (nameId) {
                                    nameId.computed = true;
                                    nameId.name = right;
                                }
                            } else {
                                if (create && create !== 1) self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), "{}"));
                                expression = self.nonComputedMember(left, ast.property.name);
                                self.assign(intoId, expression);
                                if (nameId) {
                                    nameId.computed = false;
                                    nameId.name = ast.property.name;
                                }
                            }
                        }, function() {
                            self.assign(intoId, "undefined");
                        });
                        recursionFn(intoId);
                    }, !!create);
                    break;
                case AST.CallExpression:
                    intoId = intoId || this.nextId();
                    if (ast.filter) {
                        right = self.filter(ast.callee.name);
                        args = [];
                        forEach(ast.arguments, function(expr) {
                            var argument = self.nextId();
                            self.recurse(expr, argument);
                            args.push(argument);
                        });
                        expression = right + "(" + args.join(",") + ")";
                        self.assign(intoId, expression);
                        recursionFn(intoId);
                    } else {
                        right = self.nextId();
                        left = {};
                        args = [];
                        self.recurse(ast.callee, right, left, function() {
                            self.if_(self.notNull(right), function() {
                                forEach(ast.arguments, function(expr) {
                                    self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                                        args.push(argument);
                                    });
                                });
                                if (left.name) expression = self.member(left.context, left.name, left.computed) + "(" + args.join(",") + ")";
                                else expression = right + "(" + args.join(",") + ")";
                                self.assign(intoId, expression);
                            }, function() {
                                self.assign(intoId, "undefined");
                            });
                            recursionFn(intoId);
                        });
                    }
                    break;
                case AST.AssignmentExpression:
                    right = this.nextId();
                    left = {};
                    this.recurse(ast.left, undefined, left, function() {
                        self.if_(self.notNull(left.context), function() {
                            self.recurse(ast.right, right);
                            expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
                            self.assign(intoId, expression);
                            recursionFn(intoId || expression);
                        });
                    }, 1);
                    break;
                case AST.ArrayExpression:
                    args = [];
                    forEach(ast.elements, function(expr) {
                        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                            args.push(argument);
                        });
                    });
                    expression = "[" + args.join(",") + "]";
                    this.assign(intoId, expression);
                    recursionFn(intoId || expression);
                    break;
                case AST.ObjectExpression:
                    args = [];
                    computed = false;
                    forEach(ast.properties, function(property) {
                        if (property.computed) computed = true;
                    });
                    if (computed) {
                        intoId = intoId || this.nextId();
                        this.assign(intoId, "{}");
                        forEach(ast.properties, function(property) {
                            if (property.computed) {
                                left = self.nextId();
                                self.recurse(property.key, left);
                            } else left = property.key.type === AST.Identifier ? property.key.name : "" + property.key.value;
                            right = self.nextId();
                            self.recurse(property.value, right);
                            self.assign(self.member(intoId, left, property.computed), right);
                        });
                    } else {
                        forEach(ast.properties, function(property) {
                            self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
                                args.push(self.escape(property.key.type === AST.Identifier ? property.key.name : "" + property.key.value) + ":" + expr);
                            });
                        });
                        expression = "{" + args.join(",") + "}";
                        this.assign(intoId, expression);
                    }
                    recursionFn(intoId || expression);
                    break;
                case AST.ThisExpression:
                    this.assign(intoId, "s");
                    recursionFn(intoId || "s");
                    break;
                case AST.LocalsExpression:
                    this.assign(intoId, "l");
                    recursionFn(intoId || "l");
                    break;
                case AST.NGValueParameter:
                    this.assign(intoId, "v");
                    recursionFn(intoId || "v");
                    break;
            }
        },
        getHasOwnProperty: function(element, property) {
            var key = element + "." + property;
            var own = this.current().own;
            if (!own.hasOwnProperty(key)) own[key] = this.nextId(false, element + "&&(" + this.escape(property) + " in " + element + ")");
            return own[key];
        },
        assign: function(id, value) {
            if (!id) return;
            this.current().body.push(id, "=", value, ";");
            return id;
        },
        filter: function(filterName) {
            if (!this.state.filters.hasOwnProperty(filterName)) this.state.filters[filterName] = this.nextId(true);
            return this.state.filters[filterName];
        },
        ifDefined: function(id, defaultValue) {
            return "ifDefined(" + id + "," + this.escape(defaultValue) + ")";
        },
        plus: function(left, right) {
            return "plus(" + left + "," + right + ")";
        },
        return_: function(id) {
            this.current().body.push("return ", id, ";");
        },
        if_: function(test, alternate, consequent) {
            if (test === true) alternate();
            else {
                var body = this.current().body;
                body.push("if(", test, "){");
                alternate();
                body.push("}");
                if (consequent) {
                    body.push("else{");
                    consequent();
                    body.push("}");
                }
            }
        },
        not: function(expression) {
            return "!(" + expression + ")";
        },
        isNull: function(expression) {
            return expression + "==null";
        },
        notNull: function(expression) {
            return expression + "!=null";
        },
        nonComputedMember: function(left, right) {
            var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
            var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
            if (SAFE_IDENTIFIER.test(right)) return left + "." + right;
            else return left + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
        },
        computedMember: function(left, right) {
            return left + "[" + right + "]";
        },
        member: function(left, right, computed) {
            if (computed) return this.computedMember(left, right);
            return this.nonComputedMember(left, right);
        },
        getStringValue: function(item) {
            this.assign(item, "getStringValue(" + item + ")");
        },
        lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
            var self = this;
            return function() {
                self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
            };
        },
        lazyAssign: function(id, value) {
            var self = this;
            return function() {
                self.assign(id, value);
            };
        },
        stringEscapeRegex: /[^ a-zA-Z0-9]/g,
        stringEscapeFn: function(c) {
            return "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
        },
        escape: function(value) {
            if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
            if (isNumber(value)) return value.toString();
            if (value === true) return "true";
            if (value === false) return "false";
            if (value === null) return "null";
            if (typeof value === "undefined") return "undefined";
            throw $parseMinErr("esc", "IMPOSSIBLE");
        },
        nextId: function(skip, init) {
            var id = "v" + this.state.nextId++;
            if (!skip) this.current().vars.push(id + (init ? "=" + init : ""));
            return id;
        },
        current: function() {
            return this.state[this.state.computing];
        }
    };
    function ASTInterpreter($filter) {
        this.$filter = $filter;
    }
    ASTInterpreter.prototype = {
        compile: function(ast) {
            var self = this;
            findConstantAndWatchExpressions(ast, self.$filter);
            var assignable;
            var assign;
            if (assignable = assignableAST(ast)) assign = this.recurse(assignable);
            var toWatch = getInputs(ast.body);
            var inputs;
            if (toWatch) {
                inputs = [];
                forEach(toWatch, function(watch, key) {
                    var input = self.recurse(watch);
                    input.isPure = watch.isPure;
                    watch.input = input;
                    inputs.push(input);
                    watch.watchId = key;
                });
            }
            var expressions = [];
            forEach(ast.body, function(expression) {
                expressions.push(self.recurse(expression.expression));
            });
            var fn = ast.body.length === 0 ? noop : ast.body.length === 1 ? expressions[0] : function(scope, locals) {
                var lastValue;
                forEach(expressions, function(exp) {
                    lastValue = exp(scope, locals);
                });
                return lastValue;
            };
            if (assign) fn.assign = function(scope, value, locals) {
                return assign(scope, locals, value);
            };
            if (inputs) fn.inputs = inputs;
            return fn;
        },
        recurse: function(ast, context, create) {
            var left, right, self = this, args;
            if (ast.input) return this.inputs(ast.input, ast.watchId);
            switch(ast.type){
                case AST.Literal:
                    return this.value(ast.value, context);
                case AST.UnaryExpression:
                    right = this.recurse(ast.argument);
                    return this["unary" + ast.operator](right, context);
                case AST.BinaryExpression:
                    left = this.recurse(ast.left);
                    right = this.recurse(ast.right);
                    return this["binary" + ast.operator](left, right, context);
                case AST.LogicalExpression:
                    left = this.recurse(ast.left);
                    right = this.recurse(ast.right);
                    return this["binary" + ast.operator](left, right, context);
                case AST.ConditionalExpression:
                    return this["ternary?:"](this.recurse(ast.test), this.recurse(ast.alternate), this.recurse(ast.consequent), context);
                case AST.Identifier:
                    return self.identifier(ast.name, context, create);
                case AST.MemberExpression:
                    left = this.recurse(ast.object, false, !!create);
                    if (!ast.computed) right = ast.property.name;
                    if (ast.computed) right = this.recurse(ast.property);
                    return ast.computed ? this.computedMember(left, right, context, create) : this.nonComputedMember(left, right, context, create);
                case AST.CallExpression:
                    args = [];
                    forEach(ast.arguments, function(expr) {
                        args.push(self.recurse(expr));
                    });
                    if (ast.filter) right = this.$filter(ast.callee.name);
                    if (!ast.filter) right = this.recurse(ast.callee, true);
                    return ast.filter ? function(scope, locals, assign, inputs) {
                        var values = [];
                        for(var i = 0; i < args.length; ++i)values.push(args[i](scope, locals, assign, inputs));
                        var value = right.apply(undefined, values, inputs);
                        return context ? {
                            context: undefined,
                            name: undefined,
                            value: value
                        } : value;
                    } : function(scope, locals, assign, inputs) {
                        var rhs = right(scope, locals, assign, inputs);
                        var value;
                        if (rhs.value != null) {
                            var values = [];
                            for(var i = 0; i < args.length; ++i)values.push(args[i](scope, locals, assign, inputs));
                            value = rhs.value.apply(rhs.context, values);
                        }
                        return context ? {
                            value: value
                        } : value;
                    };
                case AST.AssignmentExpression:
                    left = this.recurse(ast.left, true, 1);
                    right = this.recurse(ast.right);
                    return function(scope, locals, assign, inputs) {
                        var lhs = left(scope, locals, assign, inputs);
                        var rhs = right(scope, locals, assign, inputs);
                        lhs.context[lhs.name] = rhs;
                        return context ? {
                            value: rhs
                        } : rhs;
                    };
                case AST.ArrayExpression:
                    args = [];
                    forEach(ast.elements, function(expr) {
                        args.push(self.recurse(expr));
                    });
                    return function(scope, locals, assign, inputs) {
                        var value = [];
                        for(var i = 0; i < args.length; ++i)value.push(args[i](scope, locals, assign, inputs));
                        return context ? {
                            value: value
                        } : value;
                    };
                case AST.ObjectExpression:
                    args = [];
                    forEach(ast.properties, function(property) {
                        if (property.computed) args.push({
                            key: self.recurse(property.key),
                            computed: true,
                            value: self.recurse(property.value)
                        });
                        else args.push({
                            key: property.key.type === AST.Identifier ? property.key.name : "" + property.key.value,
                            computed: false,
                            value: self.recurse(property.value)
                        });
                    });
                    return function(scope, locals, assign, inputs) {
                        var value = {};
                        for(var i = 0; i < args.length; ++i)if (args[i].computed) value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
                        else value[args[i].key] = args[i].value(scope, locals, assign, inputs);
                        return context ? {
                            value: value
                        } : value;
                    };
                case AST.ThisExpression:
                    return function(scope) {
                        return context ? {
                            value: scope
                        } : scope;
                    };
                case AST.LocalsExpression:
                    return function(scope, locals) {
                        return context ? {
                            value: locals
                        } : locals;
                    };
                case AST.NGValueParameter:
                    return function(scope, locals, assign) {
                        return context ? {
                            value: assign
                        } : assign;
                    };
            }
        },
        "unary+": function(argument, context) {
            return function(scope, locals, assign, inputs) {
                var arg = argument(scope, locals, assign, inputs);
                if (isDefined(arg)) arg = +arg;
                else arg = 0;
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "unary-": function(argument, context) {
            return function(scope, locals, assign, inputs) {
                var arg = argument(scope, locals, assign, inputs);
                if (isDefined(arg)) arg = -arg;
                else arg = -0;
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "unary!": function(argument, context) {
            return function(scope, locals, assign, inputs) {
                var arg = !argument(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary+": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs = right(scope, locals, assign, inputs);
                var arg = plusFn(lhs, rhs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary-": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs = right(scope, locals, assign, inputs);
                var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary*": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary/": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary%": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary===": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary!==": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary==": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                // eslint-disable-next-line eqeqeq
                var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary!=": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                // eslint-disable-next-line eqeqeq
                var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary<": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary>": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary<=": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary>=": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary&&": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "binary||": function(left, right, context) {
            return function(scope, locals, assign, inputs) {
                var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        "ternary?:": function(test, alternate, consequent, context) {
            return function(scope, locals, assign, inputs) {
                var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
                return context ? {
                    value: arg
                } : arg;
            };
        },
        value: function(value, context) {
            return function() {
                return context ? {
                    context: undefined,
                    name: undefined,
                    value: value
                } : value;
            };
        },
        identifier: function(name, context, create) {
            return function(scope, locals, assign, inputs) {
                var base = locals && name in locals ? locals : scope;
                if (create && create !== 1 && base && base[name] == null) base[name] = {};
                var value = base ? base[name] : undefined;
                if (context) return {
                    context: base,
                    name: name,
                    value: value
                };
                else return value;
            };
        },
        computedMember: function(left, right, context, create) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                var rhs;
                var value;
                if (lhs != null) {
                    rhs = right(scope, locals, assign, inputs);
                    rhs = getStringValue(rhs);
                    if (create && create !== 1) {
                        if (lhs && !lhs[rhs]) lhs[rhs] = {};
                    }
                    value = lhs[rhs];
                }
                if (context) return {
                    context: lhs,
                    name: rhs,
                    value: value
                };
                else return value;
            };
        },
        nonComputedMember: function(left, right, context, create) {
            return function(scope, locals, assign, inputs) {
                var lhs = left(scope, locals, assign, inputs);
                if (create && create !== 1) {
                    if (lhs && lhs[right] == null) lhs[right] = {};
                }
                var value = lhs != null ? lhs[right] : undefined;
                if (context) return {
                    context: lhs,
                    name: right,
                    value: value
                };
                else return value;
            };
        },
        inputs: function(input, watchId) {
            return function(scope, value, locals, inputs) {
                if (inputs) return inputs[watchId];
                return input(scope, value, locals);
            };
        }
    };
    /**
 * @constructor
 */ function Parser(lexer, $filter, options) {
        this.ast = new AST(lexer, options);
        this.astCompiler = options.csp ? new ASTInterpreter($filter) : new ASTCompiler($filter);
    }
    Parser.prototype = {
        constructor: Parser,
        parse: function(text) {
            var ast = this.getAst(text);
            var fn = this.astCompiler.compile(ast.ast);
            fn.literal = isLiteral(ast.ast);
            fn.constant = isConstant(ast.ast);
            fn.oneTime = ast.oneTime;
            return fn;
        },
        getAst: function(exp) {
            var oneTime = false;
            exp = exp.trim();
            if (exp.charAt(0) === ":" && exp.charAt(1) === ":") {
                oneTime = true;
                exp = exp.substring(2);
            }
            return {
                ast: this.ast.ast(exp),
                oneTime: oneTime
            };
        }
    };
    function getValueOf(value) {
        return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
    }
    ///////////////////////////////////
    /**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */ /**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */ function $ParseProvider() {
        var cache = createMap();
        var literals = {
            "true": true,
            "false": false,
            "null": null,
            "undefined": undefined
        };
        var identStart, identContinue;
        /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/ this.addLiteral = function(literalName, literalValue) {
            literals[literalName] = literalValue;
        };
        /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */ this.setIdentifierFns = function(identifierStart, identifierContinue) {
            identStart = identifierStart;
            identContinue = identifierContinue;
            return this;
        };
        this.$get = [
            "$filter",
            function($filter) {
                var noUnsafeEval = csp().noUnsafeEval;
                var $parseOptions = {
                    csp: noUnsafeEval,
                    literals: copy(literals),
                    isIdentifierStart: isFunction(identStart) && identStart,
                    isIdentifierContinue: isFunction(identContinue) && identContinue
                };
                $parse.$$getAst = $$getAst;
                return $parse;
                function $parse(exp, interceptorFn) {
                    var parsedExpression, cacheKey;
                    switch(typeof exp){
                        case "string":
                            exp = exp.trim();
                            cacheKey = exp;
                            parsedExpression = cache[cacheKey];
                            if (!parsedExpression) {
                                var lexer = new Lexer($parseOptions);
                                var parser = new Parser(lexer, $filter, $parseOptions);
                                parsedExpression = parser.parse(exp);
                                cache[cacheKey] = addWatchDelegate(parsedExpression);
                            }
                            return addInterceptor(parsedExpression, interceptorFn);
                        case "function":
                            return addInterceptor(exp, interceptorFn);
                        default:
                            return addInterceptor(noop, interceptorFn);
                    }
                }
                function $$getAst(exp) {
                    var lexer = new Lexer($parseOptions);
                    var parser = new Parser(lexer, $filter, $parseOptions);
                    return parser.getAst(exp).ast;
                }
                function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
                    if (newValue == null || oldValueOfValue == null) return newValue === oldValueOfValue;
                    if (typeof newValue === "object") {
                        // attempt to convert the value to a primitive type
                        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
                        //             be cheaply dirty-checked
                        newValue = getValueOf(newValue);
                        if (typeof newValue === "object" && !compareObjectIdentity) // objects/arrays are not supported - deep-watching them would be too expensive
                        return false;
                    // fall-through to the primitive equality check
                    }
                    //Primitive or NaN
                    // eslint-disable-next-line no-self-compare
                    return newValue === oldValueOfValue || newValue !== newValue && oldValueOfValue !== oldValueOfValue;
                }
                function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
                    var inputExpressions = parsedExpression.inputs;
                    var lastResult;
                    if (inputExpressions.length === 1) {
                        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
                        inputExpressions = inputExpressions[0];
                        return scope.$watch(function expressionInputWatch(scope) {
                            var newInputValue = inputExpressions(scope);
                            if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
                                lastResult = parsedExpression(scope, undefined, undefined, [
                                    newInputValue
                                ]);
                                oldInputValueOf = newInputValue && getValueOf(newInputValue);
                            }
                            return lastResult;
                        }, listener, objectEquality, prettyPrintExpression);
                    }
                    var oldInputValueOfValues = [];
                    var oldInputValues = [];
                    for(var i = 0, ii = inputExpressions.length; i < ii; i++){
                        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
                        oldInputValues[i] = null;
                    }
                    return scope.$watch(function expressionInputsWatch(scope) {
                        var changed = false;
                        for(var i = 0, ii = inputExpressions.length; i < ii; i++){
                            var newInputValue = inputExpressions[i](scope);
                            if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
                                oldInputValues[i] = newInputValue;
                                oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
                            }
                        }
                        if (changed) lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
                        return lastResult;
                    }, listener, objectEquality, prettyPrintExpression);
                }
                function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
                    var isDone = parsedExpression.literal ? isAllDefined : isDefined;
                    var unwatch, lastValue;
                    var exp = parsedExpression.$$intercepted || parsedExpression;
                    var post = parsedExpression.$$interceptor || identity;
                    var useInputs = parsedExpression.inputs && !exp.inputs;
                    // Propagate the literal/inputs/constant attributes
                    // ... but not oneTime since we are handling it
                    oneTimeWatch.literal = parsedExpression.literal;
                    oneTimeWatch.constant = parsedExpression.constant;
                    oneTimeWatch.inputs = parsedExpression.inputs;
                    // Allow other delegates to run on this wrapped expression
                    addWatchDelegate(oneTimeWatch);
                    unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
                    return unwatch;
                    function unwatchIfDone() {
                        if (isDone(lastValue)) unwatch();
                    }
                    function oneTimeWatch(scope, locals, assign, inputs) {
                        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
                        if (isDone(lastValue)) scope.$$postDigest(unwatchIfDone);
                        return post(lastValue);
                    }
                }
                function isAllDefined(value) {
                    var allDefined = true;
                    forEach(value, function(val) {
                        if (!isDefined(val)) allDefined = false;
                    });
                    return allDefined;
                }
                function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
                    var unwatch = scope.$watch(function constantWatch(scope) {
                        unwatch();
                        return parsedExpression(scope);
                    }, listener, objectEquality);
                    return unwatch;
                }
                function addWatchDelegate(parsedExpression) {
                    if (parsedExpression.constant) parsedExpression.$$watchDelegate = constantWatchDelegate;
                    else if (parsedExpression.oneTime) parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
                    else if (parsedExpression.inputs) parsedExpression.$$watchDelegate = inputsWatchDelegate;
                    return parsedExpression;
                }
                function chainInterceptors(first, second) {
                    function chainedInterceptor(value) {
                        return second(first(value));
                    }
                    chainedInterceptor.$stateful = first.$stateful || second.$stateful;
                    chainedInterceptor.$$pure = first.$$pure && second.$$pure;
                    return chainedInterceptor;
                }
                function addInterceptor(parsedExpression, interceptorFn) {
                    if (!interceptorFn) return parsedExpression;
                    // Extract any existing interceptors out of the parsedExpression
                    // to ensure the original parsedExpression is always the $$intercepted
                    if (parsedExpression.$$interceptor) {
                        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
                        parsedExpression = parsedExpression.$$intercepted;
                    }
                    var useInputs = false;
                    var fn = function interceptedExpression(scope, locals, assign, inputs) {
                        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
                        return interceptorFn(value);
                    };
                    // Maintain references to the interceptor/intercepted
                    fn.$$intercepted = parsedExpression;
                    fn.$$interceptor = interceptorFn;
                    // Propagate the literal/oneTime/constant attributes
                    fn.literal = parsedExpression.literal;
                    fn.oneTime = parsedExpression.oneTime;
                    fn.constant = parsedExpression.constant;
                    // Treat the interceptor like filters.
                    // If it is not $stateful then only watch its inputs.
                    // If the expression itself has no inputs then use the full expression as an input.
                    if (!interceptorFn.$stateful) {
                        useInputs = !parsedExpression.inputs;
                        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [
                            parsedExpression
                        ];
                        if (!interceptorFn.$$pure) fn.inputs = fn.inputs.map(function(e) {
                            // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
                            // non-pure interceptor function.
                            if (e.isPure === PURITY_RELATIVE) return function depurifier(s) {
                                return e(s);
                            };
                            return e;
                        });
                    }
                    return addWatchDelegate(fn);
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */ /**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */ function $QProvider() {
        var errorOnUnhandledRejections = true;
        this.$get = [
            "$rootScope",
            "$exceptionHandler",
            function($rootScope, $exceptionHandler) {
                return qFactory(function(callback) {
                    $rootScope.$evalAsync(callback);
                }, $exceptionHandler, errorOnUnhandledRejections);
            }
        ];
        /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */ this.errorOnUnhandledRejections = function(value) {
            if (isDefined(value)) {
                errorOnUnhandledRejections = value;
                return this;
            } else return errorOnUnhandledRejections;
        };
    }
    /** @this */ function $$QProvider() {
        var errorOnUnhandledRejections = true;
        this.$get = [
            "$browser",
            "$exceptionHandler",
            function($browser, $exceptionHandler) {
                return qFactory(function(callback) {
                    $browser.defer(callback);
                }, $exceptionHandler, errorOnUnhandledRejections);
            }
        ];
        this.errorOnUnhandledRejections = function(value) {
            if (isDefined(value)) {
                errorOnUnhandledRejections = value;
                return this;
            } else return errorOnUnhandledRejections;
        };
    }
    /**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */ function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
        var $qMinErr = minErr("$q", TypeError);
        var queueSize = 0;
        var checkQueue = [];
        /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */ function defer() {
            return new Deferred();
        }
        function Deferred() {
            var promise = this.promise = new Promise();
            //Non prototype methods necessary to support unbound execution :/
            this.resolve = function(val) {
                resolvePromise(promise, val);
            };
            this.reject = function(reason) {
                rejectPromise(promise, reason);
            };
            this.notify = function(progress) {
                notifyPromise(promise, progress);
            };
        }
        function Promise() {
            this.$$state = {
                status: 0
            };
        }
        extend(Promise.prototype, {
            then: function(onFulfilled, onRejected, progressBack) {
                if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) return this;
                var result = new Promise();
                this.$$state.pending = this.$$state.pending || [];
                this.$$state.pending.push([
                    result,
                    onFulfilled,
                    onRejected,
                    progressBack
                ]);
                if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
                return result;
            },
            "catch": function(callback) {
                return this.then(null, callback);
            },
            "finally": function(callback, progressBack) {
                return this.then(function(value) {
                    return handleCallback(value, resolve, callback);
                }, function(error) {
                    return handleCallback(error, reject, callback);
                }, progressBack);
            }
        });
        function processQueue(state) {
            var fn, promise, pending;
            pending = state.pending;
            state.processScheduled = false;
            state.pending = undefined;
            try {
                for(var i = 0, ii = pending.length; i < ii; ++i){
                    markQStateExceptionHandled(state);
                    promise = pending[i][0];
                    fn = pending[i][state.status];
                    try {
                        if (isFunction(fn)) resolvePromise(promise, fn(state.value));
                        else if (state.status === 1) resolvePromise(promise, state.value);
                        else rejectPromise(promise, state.value);
                    } catch (e) {
                        rejectPromise(promise, e);
                        // This error is explicitly marked for being passed to the $exceptionHandler
                        if (e && e.$$passToExceptionHandler === true) exceptionHandler(e);
                    }
                }
            } finally{
                --queueSize;
                if (errorOnUnhandledRejections && queueSize === 0) nextTick(processChecks);
            }
        }
        function processChecks() {
            // eslint-disable-next-line no-unmodified-loop-condition
            while(!queueSize && checkQueue.length){
                var toCheck = checkQueue.shift();
                if (!isStateExceptionHandled(toCheck)) {
                    markQStateExceptionHandled(toCheck);
                    var errorMessage = "Possibly unhandled rejection: " + toDebugString(toCheck.value);
                    if (isError(toCheck.value)) exceptionHandler(toCheck.value, errorMessage);
                    else exceptionHandler(errorMessage);
                }
            }
        }
        function scheduleProcessQueue(state) {
            if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
                if (queueSize === 0 && checkQueue.length === 0) nextTick(processChecks);
                checkQueue.push(state);
            }
            if (state.processScheduled || !state.pending) return;
            state.processScheduled = true;
            ++queueSize;
            nextTick(function() {
                processQueue(state);
            });
        }
        function resolvePromise(promise, val) {
            if (promise.$$state.status) return;
            if (val === promise) $$reject(promise, $qMinErr("qcycle", "Expected promise to be resolved with value other than itself '{0}'", val));
            else $$resolve(promise, val);
        }
        function $$resolve(promise, val) {
            var then;
            var done = false;
            try {
                if (isObject(val) || isFunction(val)) then = val.then;
                if (isFunction(then)) {
                    promise.$$state.status = -1;
                    then.call(val, doResolve, doReject, doNotify);
                } else {
                    promise.$$state.value = val;
                    promise.$$state.status = 1;
                    scheduleProcessQueue(promise.$$state);
                }
            } catch (e) {
                doReject(e);
            }
            function doResolve(val) {
                if (done) return;
                done = true;
                $$resolve(promise, val);
            }
            function doReject(val) {
                if (done) return;
                done = true;
                $$reject(promise, val);
            }
            function doNotify(progress) {
                notifyPromise(promise, progress);
            }
        }
        function rejectPromise(promise, reason) {
            if (promise.$$state.status) return;
            $$reject(promise, reason);
        }
        function $$reject(promise, reason) {
            promise.$$state.value = reason;
            promise.$$state.status = 2;
            scheduleProcessQueue(promise.$$state);
        }
        function notifyPromise(promise, progress) {
            var callbacks = promise.$$state.pending;
            if (promise.$$state.status <= 0 && callbacks && callbacks.length) nextTick(function() {
                var callback, result;
                for(var i = 0, ii = callbacks.length; i < ii; i++){
                    result = callbacks[i][0];
                    callback = callbacks[i][3];
                    try {
                        notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
                    } catch (e) {
                        exceptionHandler(e);
                    }
                }
            });
        }
        /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */ function reject(reason) {
            var result = new Promise();
            rejectPromise(result, reason);
            return result;
        }
        function handleCallback(value, resolver, callback) {
            var callbackOutput = null;
            try {
                if (isFunction(callback)) callbackOutput = callback();
            } catch (e) {
                return reject(e);
            }
            if (isPromiseLike(callbackOutput)) return callbackOutput.then(function() {
                return resolver(value);
            }, reject);
            else return resolver(value);
        }
        /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */ function when(value, callback, errback, progressBack) {
            var result = new Promise();
            resolvePromise(result, value);
            return result.then(callback, errback, progressBack);
        }
        /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */ var resolve = when;
        /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */ function all(promises) {
            var result = new Promise(), counter = 0, results = isArray(promises) ? [] : {};
            forEach(promises, function(promise, key) {
                counter++;
                when(promise).then(function(value) {
                    results[key] = value;
                    if (!--counter) resolvePromise(result, results);
                }, function(reason) {
                    rejectPromise(result, reason);
                });
            });
            if (counter === 0) resolvePromise(result, results);
            return result;
        }
        /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */ function race(promises) {
            var deferred = defer();
            forEach(promises, function(promise) {
                when(promise).then(deferred.resolve, deferred.reject);
            });
            return deferred.promise;
        }
        function $Q(resolver) {
            if (!isFunction(resolver)) throw $qMinErr("norslvr", "Expected resolverFn, got '{0}'", resolver);
            var promise = new Promise();
            function resolveFn(value) {
                resolvePromise(promise, value);
            }
            function rejectFn(reason) {
                rejectPromise(promise, reason);
            }
            resolver(resolveFn, rejectFn);
            return promise;
        }
        // Let's make the instanceof operator work for promises, so that
        // `new $q(fn) instanceof $q` would evaluate to true.
        $Q.prototype = Promise.prototype;
        $Q.defer = defer;
        $Q.reject = reject;
        $Q.when = when;
        $Q.resolve = resolve;
        $Q.all = all;
        $Q.race = race;
        return $Q;
    }
    function isStateExceptionHandled(state) {
        return !!state.pur;
    }
    function markQStateExceptionHandled(state) {
        state.pur = true;
    }
    function markQExceptionHandled(q) {
        // Built-in `$q` promises will always have a `$$state` property. This check is to allow
        // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
        // (Currently, this is the only method that might be called with a promise, even if it is not
        // created by the built-in `$q`.)
        if (q.$$state) markQStateExceptionHandled(q.$$state);
    }
    /** @this */ function $$RAFProvider() {
        this.$get = [
            "$window",
            "$timeout",
            function($window, $timeout) {
                var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;
                var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
                var rafSupported = !!requestAnimationFrame;
                var raf = rafSupported ? function(fn) {
                    var id = requestAnimationFrame(fn);
                    return function() {
                        cancelAnimationFrame(id);
                    };
                } : function(fn) {
                    var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
                    return function() {
                        $timeout.cancel(timer);
                    };
                };
                raf.supported = rafSupported;
                return raf;
            }
        ];
    }
    /**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */ /**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */ /**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */ /**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */ function $RootScopeProvider() {
        var TTL = 10;
        var $rootScopeMinErr = minErr("$rootScope");
        var lastDirtyWatch = null;
        var applyAsyncId = null;
        this.digestTtl = function(value) {
            if (arguments.length) TTL = value;
            return TTL;
        };
        function createChildScopeClass(parent) {
            function ChildScope() {
                this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;
                this.$$listeners = {};
                this.$$listenerCount = {};
                this.$$watchersCount = 0;
                this.$id = nextUid();
                this.$$ChildScope = null;
                this.$$suspended = false;
            }
            ChildScope.prototype = parent;
            return ChildScope;
        }
        this.$get = [
            "$exceptionHandler",
            "$parse",
            "$browser",
            function($exceptionHandler, $parse, $browser) {
                function destroyChildScope($event) {
                    $event.currentScope.$$destroyed = true;
                }
                function cleanUpScope($scope) {
                    // Support: IE 9 only
                    if (msie === 9) {
                        // There is a memory leak in IE9 if all child scopes are not disconnected
                        // completely when a scope is destroyed. So this code will recurse up through
                        // all this scopes children
                        //
                        // See issue https://github.com/angular/angular.js/issues/10706
                        if ($scope.$$childHead) cleanUpScope($scope.$$childHead);
                        if ($scope.$$nextSibling) cleanUpScope($scope.$$nextSibling);
                    }
                    // The code below works around IE9 and V8's memory leaks
                    //
                    // See:
                    // - https://code.google.com/p/v8/issues/detail?id=2073#c26
                    // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
                    // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
                    $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead = $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
                }
                /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */ function Scope() {
                    this.$id = nextUid();
                    this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;
                    this.$root = this;
                    this.$$destroyed = false;
                    this.$$suspended = false;
                    this.$$listeners = {};
                    this.$$listenerCount = {};
                    this.$$watchersCount = 0;
                    this.$$isolateBindings = null;
                }
                /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */ /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */ /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */ Scope.prototype = {
                    constructor: Scope,
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */ $new: function(isolate, parent) {
                        var child;
                        parent = parent || this;
                        if (isolate) {
                            child = new Scope();
                            child.$root = this.$root;
                        } else {
                            // Only create a child scope class if somebody asks for one,
                            // but cache it to allow the VM to optimize lookups.
                            if (!this.$$ChildScope) this.$$ChildScope = createChildScopeClass(this);
                            child = new this.$$ChildScope();
                        }
                        child.$parent = parent;
                        child.$$prevSibling = parent.$$childTail;
                        if (parent.$$childHead) {
                            parent.$$childTail.$$nextSibling = child;
                            parent.$$childTail = child;
                        } else parent.$$childHead = parent.$$childTail = child;
                        // When the new scope is not isolated or we inherit from `this`, and
                        // the parent scope is destroyed, the property `$$destroyed` is inherited
                        // prototypically. In all other cases, this property needs to be set
                        // when the parent scope is destroyed.
                        // The listener needs to be added after the parent is set
                        if (isolate || parent !== this) child.$on("$destroy", destroyChildScope);
                        return child;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are (or contain)
       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */ $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
                        var get = $parse(watchExp);
                        var fn = isFunction(listener) ? listener : noop;
                        if (get.$$watchDelegate) return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
                        var scope = this, array = scope.$$watchers, watcher = {
                            fn: fn,
                            last: initWatchVal,
                            get: get,
                            exp: prettyPrintExpression || watchExp,
                            eq: !!objectEquality
                        };
                        lastDirtyWatch = null;
                        if (!array) {
                            array = scope.$$watchers = [];
                            array.$$digestWatchIndex = -1;
                        }
                        // we use unshift since we use a while loop in $digest for speed.
                        // the while loop reads in reverse order.
                        array.unshift(watcher);
                        array.$$digestWatchIndex++;
                        incrementWatchersCount(this, 1);
                        return function deregisterWatch() {
                            var index = arrayRemove(array, watcher);
                            if (index >= 0) {
                                incrementWatchersCount(scope, -1);
                                if (index < array.$$digestWatchIndex) array.$$digestWatchIndex--;
                            }
                            lastDirtyWatch = null;
                        };
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */ $watchGroup: function(watchExpressions, listener) {
                        var oldValues = new Array(watchExpressions.length);
                        var newValues = new Array(watchExpressions.length);
                        var deregisterFns = [];
                        var self = this;
                        var changeReactionScheduled = false;
                        var firstRun = true;
                        if (!watchExpressions.length) {
                            // No expressions means we call the listener ASAP
                            var shouldCall = true;
                            self.$evalAsync(function() {
                                if (shouldCall) listener(newValues, newValues, self);
                            });
                            return function deregisterWatchGroup() {
                                shouldCall = false;
                            };
                        }
                        if (watchExpressions.length === 1) // Special case size of one
                        return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
                            newValues[0] = value;
                            oldValues[0] = oldValue;
                            listener(newValues, value === oldValue ? newValues : oldValues, scope);
                        });
                        forEach(watchExpressions, function(expr, i) {
                            var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
                                newValues[i] = value;
                                if (!changeReactionScheduled) {
                                    changeReactionScheduled = true;
                                    self.$evalAsync(watchGroupAction);
                                }
                            });
                            deregisterFns.push(unwatchFn);
                        });
                        function watchGroupAction() {
                            changeReactionScheduled = false;
                            try {
                                if (firstRun) {
                                    firstRun = false;
                                    listener(newValues, newValues, self);
                                } else listener(newValues, oldValues, self);
                            } finally{
                                for(var i = 0; i < watchExpressions.length; i++)oldValues[i] = newValues[i];
                            }
                        }
                        return function deregisterWatchGroup() {
                            while(deregisterFns.length)deregisterFns.shift()();
                        };
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */ $watchCollection: function(obj, listener) {
                        // Mark the interceptor as
                        // ... $$pure when literal since the instance will change when any input changes
                        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
                        // ... $stateful when non-literal since we must read the state of the collection
                        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
                        var self = this;
                        // the current value, updated on each dirty-check run
                        var newValue;
                        // a shallow copy of the newValue from the last dirty-check run,
                        // updated to match newValue during dirty-check run
                        var oldValue;
                        // a shallow copy of the newValue from when the last change happened
                        var veryOldValue;
                        // only track veryOldValue if the listener is asking for it
                        var trackVeryOldValue = listener.length > 1;
                        var changeDetected = 0;
                        var changeDetector = $parse(obj, $watchCollectionInterceptor);
                        var internalArray = [];
                        var internalObject = {};
                        var initRun = true;
                        var oldLength = 0;
                        function $watchCollectionInterceptor(_value) {
                            newValue = _value;
                            var newLength, key, bothNaN, newItem, oldItem;
                            // If the new value is undefined, then return undefined as the watch may be a one-time watch
                            if (isUndefined(newValue)) return;
                            if (!isObject(newValue)) {
                                if (oldValue !== newValue) {
                                    oldValue = newValue;
                                    changeDetected++;
                                }
                            } else if (isArrayLike(newValue)) {
                                if (oldValue !== internalArray) {
                                    // we are transitioning from something which was not an array into array.
                                    oldValue = internalArray;
                                    oldLength = oldValue.length = 0;
                                    changeDetected++;
                                }
                                newLength = newValue.length;
                                if (oldLength !== newLength) {
                                    // if lengths do not match we need to trigger change notification
                                    changeDetected++;
                                    oldValue.length = oldLength = newLength;
                                }
                                // copy the items to oldValue and look for changes.
                                for(var i = 0; i < newLength; i++){
                                    oldItem = oldValue[i];
                                    newItem = newValue[i];
                                    // eslint-disable-next-line no-self-compare
                                    bothNaN = oldItem !== oldItem && newItem !== newItem;
                                    if (!bothNaN && oldItem !== newItem) {
                                        changeDetected++;
                                        oldValue[i] = newItem;
                                    }
                                }
                            } else {
                                if (oldValue !== internalObject) {
                                    // we are transitioning from something which was not an object into object.
                                    oldValue = internalObject = {};
                                    oldLength = 0;
                                    changeDetected++;
                                }
                                // copy the items to oldValue and look for changes.
                                newLength = 0;
                                for(key in newValue)if (hasOwnProperty.call(newValue, key)) {
                                    newLength++;
                                    newItem = newValue[key];
                                    oldItem = oldValue[key];
                                    if (key in oldValue) {
                                        // eslint-disable-next-line no-self-compare
                                        bothNaN = oldItem !== oldItem && newItem !== newItem;
                                        if (!bothNaN && oldItem !== newItem) {
                                            changeDetected++;
                                            oldValue[key] = newItem;
                                        }
                                    } else {
                                        oldLength++;
                                        oldValue[key] = newItem;
                                        changeDetected++;
                                    }
                                }
                                if (oldLength > newLength) {
                                    // we used to have more keys, need to find them and destroy them.
                                    changeDetected++;
                                    for(key in oldValue)if (!hasOwnProperty.call(newValue, key)) {
                                        oldLength--;
                                        delete oldValue[key];
                                    }
                                }
                            }
                            return changeDetected;
                        }
                        function $watchCollectionAction() {
                            if (initRun) {
                                initRun = false;
                                listener(newValue, newValue, self);
                            } else listener(newValue, veryOldValue, self);
                            // make a copy for the next time a collection is changed
                            if (trackVeryOldValue) {
                                if (!isObject(newValue)) //primitive
                                veryOldValue = newValue;
                                else if (isArrayLike(newValue)) {
                                    veryOldValue = new Array(newValue.length);
                                    for(var i = 0; i < newValue.length; i++)veryOldValue[i] = newValue[i];
                                } else {
                                    veryOldValue = {};
                                    for(var key in newValue)if (hasOwnProperty.call(newValue, key)) veryOldValue[key] = newValue[key];
                                }
                            }
                        }
                        return this.$watch(changeDetector, $watchCollectionAction);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */ $digest: function() {
                        var watch, value, last, fn, get, watchers, dirty, ttl = TTL, next, current, target = asyncQueue.length ? $rootScope : this, watchLog = [], logIdx, asyncTask;
                        beginPhase("$digest");
                        // Check for changes to browser url that happened in sync before the call to $digest
                        $browser.$$checkUrlChange();
                        if (this === $rootScope && applyAsyncId !== null) {
                            // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
                            // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
                            $browser.defer.cancel(applyAsyncId);
                            flushApplyAsync();
                        }
                        lastDirtyWatch = null;
                        do {
                            dirty = false;
                            current = target;
                            // It's safe for asyncQueuePosition to be a local variable here because this loop can't
                            // be reentered recursively. Calling $digest from a function passed to $evalAsync would
                            // lead to a '$digest already in progress' error.
                            for(var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++){
                                try {
                                    asyncTask = asyncQueue[asyncQueuePosition];
                                    fn = asyncTask.fn;
                                    fn(asyncTask.scope, asyncTask.locals);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                                lastDirtyWatch = null;
                            }
                            asyncQueue.length = 0;
                            traverseScopesLoop: do {
                                if (watchers = !current.$$suspended && current.$$watchers) {
                                    // process our watches
                                    watchers.$$digestWatchIndex = watchers.length;
                                    while(watchers.$$digestWatchIndex--)try {
                                        watch = watchers[watchers.$$digestWatchIndex];
                                        // Most common watches are on primitives, in which case we can short
                                        // circuit it with === operator, only when === fails do we use .equals
                                        if (watch) {
                                            get = watch.get;
                                            if ((value = get(current)) !== (last = watch.last) && !(watch.eq ? equals(value, last) : isNumberNaN(value) && isNumberNaN(last))) {
                                                dirty = true;
                                                lastDirtyWatch = watch;
                                                watch.last = watch.eq ? copy(value, null) : value;
                                                fn = watch.fn;
                                                fn(value, last === initWatchVal ? value : last, current);
                                                if (ttl < 5) {
                                                    logIdx = 4 - ttl;
                                                    if (!watchLog[logIdx]) watchLog[logIdx] = [];
                                                    watchLog[logIdx].push({
                                                        msg: isFunction(watch.exp) ? "fn: " + (watch.exp.name || watch.exp.toString()) : watch.exp,
                                                        newVal: value,
                                                        oldVal: last
                                                    });
                                                }
                                            } else if (watch === lastDirtyWatch) {
                                                // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                                                // have already been tested.
                                                dirty = false;
                                                break traverseScopesLoop;
                                            }
                                        }
                                    } catch (e) {
                                        $exceptionHandler(e);
                                    }
                                }
                                // Insanity Warning: scope depth-first traversal
                                // yes, this code is a bit crazy, but it works and we have tests to prove it!
                                // this piece should be kept in sync with the traversal in $broadcast
                                // (though it differs due to having the extra check for $$suspended and does not
                                // check $$listenerCount)
                                if (!(next = !current.$$suspended && current.$$watchersCount && current.$$childHead || current !== target && current.$$nextSibling)) while(current !== target && !(next = current.$$nextSibling))current = current.$parent;
                            }while (current = next);
                            // `break traverseScopesLoop;` takes us to here
                            if ((dirty || asyncQueue.length) && !ttl--) {
                                clearPhase();
                                throw $rootScopeMinErr("infdig", "{0} $digest() iterations reached. Aborting!\nWatchers fired in the last 5 iterations: {1}", TTL, watchLog);
                            }
                        }while (dirty || asyncQueue.length);
                        clearPhase();
                        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
                        while(postDigestQueuePosition < postDigestQueue.length)try {
                            postDigestQueue[postDigestQueuePosition++]();
                        } catch (e) {
                            $exceptionHandler(e);
                        }
                        postDigestQueue.length = postDigestQueuePosition = 0;
                        // Check for changes to browser url that happened during the $digest
                        // (for which no event is fired; e.g. via `history.pushState()`)
                        $browser.$$checkUrlChange();
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */ $suspend: function() {
                        this.$$suspended = true;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */ $isSuspended: function() {
                        return this.$$suspended;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */ $resume: function() {
                        this.$$suspended = false;
                    },
                    /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */ /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */ $destroy: function() {
                        // We can't destroy a scope that has been already destroyed.
                        if (this.$$destroyed) return;
                        var parent = this.$parent;
                        this.$broadcast("$destroy");
                        this.$$destroyed = true;
                        if (this === $rootScope) //Remove handlers attached to window when $rootScope is removed
                        $browser.$$applicationDestroyed();
                        incrementWatchersCount(this, -this.$$watchersCount);
                        for(var eventName in this.$$listenerCount)decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
                        // sever all the references to parent scopes (after this cleanup, the current scope should
                        // not be retained by any of our references and should be eligible for garbage collection)
                        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
                        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
                        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
                        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
                        // Disable listeners, watchers and apply/digest methods
                        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
                        this.$on = this.$watch = this.$watchGroup = function() {
                            return noop;
                        };
                        this.$$listeners = {};
                        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
                        this.$$nextSibling = null;
                        cleanUpScope(this);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */ $eval: function(expr, locals) {
                        return $parse(expr)(this, locals);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */ $evalAsync: function(expr, locals) {
                        // if we are outside of an $digest loop and this is the first time we are scheduling async
                        // task also schedule async auto-flush
                        if (!$rootScope.$$phase && !asyncQueue.length) $browser.defer(function() {
                            if (asyncQueue.length) $rootScope.$digest();
                        }, null, "$evalAsync");
                        asyncQueue.push({
                            scope: this,
                            fn: $parse(expr),
                            locals: locals
                        });
                    },
                    $$postDigest: function(fn) {
                        postDigestQueue.push(fn);
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */ $apply: function(expr) {
                        try {
                            beginPhase("$apply");
                            try {
                                return this.$eval(expr);
                            } finally{
                                clearPhase();
                            }
                        } catch (e) {
                            $exceptionHandler(e);
                        } finally{
                            try {
                                $rootScope.$digest();
                            } catch (e) {
                                $exceptionHandler(e);
                                // eslint-disable-next-line no-unsafe-finally
                                throw e;
                            }
                        }
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */ $applyAsync: function(expr) {
                        var scope = this;
                        if (expr) applyAsyncQueue.push($applyAsyncExpression);
                        expr = $parse(expr);
                        scheduleApplyAsync();
                        function $applyAsyncExpression() {
                            scope.$eval(expr);
                        }
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */ $on: function(name, listener) {
                        var namedListeners = this.$$listeners[name];
                        if (!namedListeners) this.$$listeners[name] = namedListeners = [];
                        namedListeners.push(listener);
                        var current = this;
                        do {
                            if (!current.$$listenerCount[name]) current.$$listenerCount[name] = 0;
                            current.$$listenerCount[name]++;
                        }while (current = current.$parent);
                        var self = this;
                        return function() {
                            var indexOfListener = namedListeners.indexOf(listener);
                            if (indexOfListener !== -1) {
                                // Use delete in the hope of the browser deallocating the memory for the array entry,
                                // while not shifting the array indexes of other listeners.
                                // See issue https://github.com/angular/angular.js/issues/16135
                                delete namedListeners[indexOfListener];
                                decrementListenerCount(self, 1, name);
                            }
                        };
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */ $emit: function(name, args) {
                        var empty = [], namedListeners, scope = this, stopPropagation = false, event = {
                            name: name,
                            targetScope: scope,
                            stopPropagation: function() {
                                stopPropagation = true;
                            },
                            preventDefault: function() {
                                event.defaultPrevented = true;
                            },
                            defaultPrevented: false
                        }, listenerArgs = concat([
                            event
                        ], arguments, 1), i, length;
                        do {
                            namedListeners = scope.$$listeners[name] || empty;
                            event.currentScope = scope;
                            for(i = 0, length = namedListeners.length; i < length; i++){
                                // if listeners were deregistered, defragment the array
                                if (!namedListeners[i]) {
                                    namedListeners.splice(i, 1);
                                    i--;
                                    length--;
                                    continue;
                                }
                                try {
                                    //allow all listeners attached to the current scope to run
                                    namedListeners[i].apply(null, listenerArgs);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                            }
                            //if any listener on the current scope stops propagation, prevent bubbling
                            if (stopPropagation) break;
                            //traverse upwards
                            scope = scope.$parent;
                        }while (scope);
                        event.currentScope = null;
                        return event;
                    },
                    /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */ $broadcast: function(name, args) {
                        var target = this, current = target, next = target, event = {
                            name: name,
                            targetScope: target,
                            preventDefault: function() {
                                event.defaultPrevented = true;
                            },
                            defaultPrevented: false
                        };
                        if (!target.$$listenerCount[name]) return event;
                        var listenerArgs = concat([
                            event
                        ], arguments, 1), listeners, i, length;
                        //down while you can, then up and next sibling or up and next sibling until back at root
                        while(current = next){
                            event.currentScope = current;
                            listeners = current.$$listeners[name] || [];
                            for(i = 0, length = listeners.length; i < length; i++){
                                // if listeners were deregistered, defragment the array
                                if (!listeners[i]) {
                                    listeners.splice(i, 1);
                                    i--;
                                    length--;
                                    continue;
                                }
                                try {
                                    listeners[i].apply(null, listenerArgs);
                                } catch (e) {
                                    $exceptionHandler(e);
                                }
                            }
                            // Insanity Warning: scope depth-first traversal
                            // yes, this code is a bit crazy, but it works and we have tests to prove it!
                            // this piece should be kept in sync with the traversal in $digest
                            // (though it differs due to having the extra check for $$listenerCount and
                            // does not check $$suspended)
                            if (!(next = current.$$listenerCount[name] && current.$$childHead || current !== target && current.$$nextSibling)) while(current !== target && !(next = current.$$nextSibling))current = current.$parent;
                        }
                        event.currentScope = null;
                        return event;
                    }
                };
                var $rootScope = new Scope();
                //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
                var asyncQueue = $rootScope.$$asyncQueue = [];
                var postDigestQueue = $rootScope.$$postDigestQueue = [];
                var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
                var postDigestQueuePosition = 0;
                return $rootScope;
                function beginPhase(phase) {
                    if ($rootScope.$$phase) throw $rootScopeMinErr("inprog", "{0} already in progress", $rootScope.$$phase);
                    $rootScope.$$phase = phase;
                }
                function clearPhase() {
                    $rootScope.$$phase = null;
                }
                function incrementWatchersCount(current, count) {
                    do current.$$watchersCount += count;
                    while (current = current.$parent);
                }
                function decrementListenerCount(current, count, name) {
                    do {
                        current.$$listenerCount[name] -= count;
                        if (current.$$listenerCount[name] === 0) delete current.$$listenerCount[name];
                    }while (current = current.$parent);
                }
                /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */ function initWatchVal() {}
                function flushApplyAsync() {
                    while(applyAsyncQueue.length)try {
                        applyAsyncQueue.shift()();
                    } catch (e) {
                        $exceptionHandler(e);
                    }
                    applyAsyncId = null;
                }
                function scheduleApplyAsync() {
                    if (applyAsyncId === null) applyAsyncId = $browser.defer(function() {
                        $rootScope.$apply(flushApplyAsync);
                    }, null, "$applyAsync");
                }
            }
        ];
    }
    /**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */ // the implementation is in angular.bootstrap
    /**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */ function $$SanitizeUriProvider() {
        var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/, imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
        /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
   *
   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
   *
   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.aHrefSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                aHrefSanitizationTrustedUrlList = regexp;
                return this;
            }
            return aHrefSanitizationTrustedUrlList;
        };
        /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
   *
   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
   * the potentially malicious URL.
   *
   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
   * unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */ this.imgSrcSanitizationTrustedUrlList = function(regexp) {
            if (isDefined(regexp)) {
                imgSrcSanitizationTrustedUrlList = regexp;
                return this;
            }
            return imgSrcSanitizationTrustedUrlList;
        };
        this.$get = function() {
            return function sanitizeUri(uri, isMediaUrl) {
                // if (!uri) return uri;
                var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
                var normalizedVal = urlResolve(uri && uri.trim()).href;
                if (normalizedVal !== "" && !normalizedVal.match(regex)) return "unsafe:" + normalizedVal;
                return uri;
            };
        };
    }
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ /* exported $SceProvider, $SceDelegateProvider */ var $sceMinErr = minErr("$sce");
    var SCE_CONTEXTS = {
        // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
        HTML: "html",
        // Style statements or stylesheets. Currently unused in AngularJS.
        CSS: "css",
        // An URL used in a context where it refers to the source of media, which are not expected to be run
        // as scripts, such as an image, audio, video, etc.
        MEDIA_URL: "mediaUrl",
        // An URL used in a context where it does not refer to a resource that loads code.
        // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
        URL: "url",
        // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
        // code. (e.g. ng-include, script src binding, templateUrl)
        // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
        RESOURCE_URL: "resourceUrl",
        // Script. Currently unused in AngularJS.
        JS: "js"
    };
    // Helper functions follow.
    var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
    function snakeToCamel(name) {
        return name.replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
    }
    function adjustMatcher(matcher) {
        if (matcher === "self") return matcher;
        else if (isString(matcher)) {
            // Strings match exactly except for 2 wildcards - '*' and '**'.
            // '*' matches any character except those from the set ':/.?&'.
            // '**' matches any character (like .* in a RegExp).
            // More than 2 *'s raises an error as it's ill defined.
            if (matcher.indexOf("***") > -1) throw $sceMinErr("iwcard", "Illegal sequence *** in string matcher.  String: {0}", matcher);
            matcher = escapeForRegexp(matcher).replace(/\\\*\\\*/g, ".*").replace(/\\\*/g, "[^:/.?&;]*");
            return new RegExp("^" + matcher + "$");
        } else if (isRegExp(matcher)) // The only other type of matcher allowed is a Regexp.
        // Match entire URL / disallow partial matches.
        // Flags are reset (i.e. no global, ignoreCase or multiline)
        return new RegExp("^" + matcher.source + "$");
        else throw $sceMinErr("imatcher", 'Matchers may only be "self", string patterns or RegExp objects');
    }
    function adjustMatchers(matchers) {
        var adjustedMatchers = [];
        if (isDefined(matchers)) forEach(matchers, function(matcher) {
            adjustedMatchers.push(adjustMatcher(matcher));
        });
        return adjustedMatchers;
    }
    /**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
 */ /**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and
 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.trustedResourceUrlList([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
 *    // here is blocked.
 *    $sceDelegateProvider.bannedResourceUrlList([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
 * of issues, like for instance attacker-controlled `ng-includes`.
 */ function $SceDelegateProvider() {
        this.SCE_CONTEXTS = SCE_CONTEXTS;
        // Resource URLs can also be trusted by policy.
        var trustedResourceUrlList = [
            "self"
        ], bannedResourceUrlList = [];
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#trustedResourceUrlList
   * @kind function
   *
   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
   *     further changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set trusted resource URL array.
   *
   * @description
   * Sets/Gets the list trusted of resource URLs.
   *
   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
   * allowing only same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
   * its origin with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */ this.trustedResourceUrlList = function(value) {
            if (arguments.length) trustedResourceUrlList = adjustMatchers(value);
            return trustedResourceUrlList;
        };
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
   * trustedResourceUrlList} instead.
   */ Object.defineProperty(this, "resourceUrlWhitelist", {
            get: function() {
                return this.trustedResourceUrlList;
            },
            set: function(value) {
                this.trustedResourceUrlList = value;
            }
        });
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#bannedResourceUrlList
   * @kind function
   *
   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
   *     the value provided. This must be an array or null. A snapshot of this array is used so
   *     further changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the `bannedResourceUrlList` is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
   *     the final say.
   *
   * @return {Array} The currently set `bannedResourceUrlList` array.
   *
   * @description
   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
   *
   * The **default value** when no trusted resource URL list has been explicitly set is the empty
   * array (i.e. there is no `bannedResourceUrlList`.)
   */ this.bannedResourceUrlList = function(value) {
            if (arguments.length) bannedResourceUrlList = adjustMatchers(value);
            return bannedResourceUrlList;
        };
        /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
   * bannedResourceUrlList} instead.
   */ Object.defineProperty(this, "resourceUrlBlacklist", {
            get: function() {
                return this.bannedResourceUrlList;
            },
            set: function(value) {
                this.bannedResourceUrlList = value;
            }
        });
        this.$get = [
            "$injector",
            "$$sanitizeUri",
            function($injector, $$sanitizeUri) {
                var htmlSanitizer = function htmlSanitizer(html) {
                    throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");
                };
                if ($injector.has("$sanitize")) htmlSanitizer = $injector.get("$sanitize");
                function matchUrl(matcher, parsedUrl) {
                    if (matcher === "self") return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
                    else // definitely a regex.  See adjustMatchers()
                    return !!matcher.exec(parsedUrl.href);
                }
                function isResourceUrlAllowedByPolicy(url) {
                    var parsedUrl = urlResolve(url.toString());
                    var i, n, allowed = false;
                    // Ensure that at least one item from the trusted resource URL list allows this url.
                    for(i = 0, n = trustedResourceUrlList.length; i < n; i++)if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
                        allowed = true;
                        break;
                    }
                    if (allowed) {
                        // Ensure that no item from the banned resource URL list has blocked this url.
                        for(i = 0, n = bannedResourceUrlList.length; i < n; i++)if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
                            allowed = false;
                            break;
                        }
                    }
                    return allowed;
                }
                function generateHolderType(Base) {
                    var holderType = function TrustedValueHolderType(trustedValue) {
                        this.$$unwrapTrustedValue = function() {
                            return trustedValue;
                        };
                    };
                    if (Base) holderType.prototype = new Base();
                    holderType.prototype.valueOf = function sceValueOf() {
                        return this.$$unwrapTrustedValue();
                    };
                    holderType.prototype.toString = function sceToString() {
                        return this.$$unwrapTrustedValue().toString();
                    };
                    return holderType;
                }
                var trustedValueHolderBase = generateHolderType(), byType = {};
                byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
                byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
                byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
                /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */ function trustAs(type, trustedValue) {
                    var Constructor = byType.hasOwnProperty(type) ? byType[type] : null;
                    if (!Constructor) throw $sceMinErr("icontext", "Attempted to trust a value in invalid context. Context: {0}; Value: {1}", type, trustedValue);
                    if (trustedValue === null || isUndefined(trustedValue) || trustedValue === "") return trustedValue;
                    // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
                    // mutable objects, we ensure here that the value passed in is actually a string.
                    if (typeof trustedValue !== "string") throw $sceMinErr("itype", "Attempted to trust a non-string value in a content requiring a string: Context: {0}", type);
                    return new Constructor(trustedValue);
                }
                /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */ function valueOf(maybeTrusted) {
                    if (maybeTrusted instanceof trustedValueHolderBase) return maybeTrusted.$$unwrapTrustedValue();
                    else return maybeTrusted;
                }
                /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Given an object and a security context in which to assign it, returns a value that's safe to
     * use in this context, which was represented by the parameter. To do so, this function either
     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
     * the context and sanitizer availablility.
     *
     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
     *
     * This function will throw if the safe type isn't appropriate for this context, or if the
     * value given cannot be accepted in the context (which might be caused by sanitization not
     * being available, or the value not being recognized as safe).
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */ function getTrusted(type, maybeTrusted) {
                    if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === "") return maybeTrusted;
                    var constructor = byType.hasOwnProperty(type) ? byType[type] : null;
                    // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
                    // as-is.
                    if (constructor && maybeTrusted instanceof constructor) return maybeTrusted.$$unwrapTrustedValue();
                    // If maybeTrusted is a trusted class instance but not of the correct trusted type
                    // then unwrap it and allow it to pass through to the rest of the checks
                    if (isFunction(maybeTrusted.$$unwrapTrustedValue)) maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
                    // If we get here, then we will either sanitize the value or throw an exception.
                    if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) // we attempt to sanitize non-resource URLs
                    return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
                    else if (type === SCE_CONTEXTS.RESOURCE_URL) {
                        if (isResourceUrlAllowedByPolicy(maybeTrusted)) return maybeTrusted;
                        else throw $sceMinErr("insecurl", "Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}", maybeTrusted.toString());
                    } else if (type === SCE_CONTEXTS.HTML) // htmlSanitizer throws its own error when no sanitizer is available.
                    return htmlSanitizer(maybeTrusted);
                    // Default error when the $sce service has no way to make the input safe.
                    throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");
                }
                return {
                    trustAs: trustAs,
                    getTrusted: getTrusted,
                    valueOf: valueOf
                };
            }
        ];
    }
    /**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */ /**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
 * HTML can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
 * when binding untrusted values to `$sce.HTML` context.
 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 *
 * <div class="alert alert-warning">
 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
 *
 * **As of 1.7.0, this is no longer the case.**
 *
 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
 * service evaluates the expressions.
 * </div>
 *
 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
 * functions aren't useful yet. This might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      for matching resource URL lists.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */ function $SceProvider() {
        var enabled = true;
        /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */ this.enabled = function(value) {
            if (arguments.length) enabled = !!value;
            return enabled;
        };
        /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */ this.$get = [
            "$parse",
            "$sceDelegate",
            function($parse, $sceDelegate) {
                // Support: IE 9-11 only
                // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
                // the "expression(javascript expression)" syntax which is insecure.
                if (enabled && msie < 8) throw $sceMinErr("iequirks", "Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks mode.  You can fix this by adding the text <!doctype html> to the top of your HTML document.  See http://docs.angularjs.org/api/ng.$sce for more information.");
                var sce = shallowCopy(SCE_CONTEXTS);
                /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */ sce.isEnabled = function() {
                    return enabled;
                };
                sce.trustAs = $sceDelegate.trustAs;
                sce.getTrusted = $sceDelegate.getTrusted;
                sce.valueOf = $sceDelegate.valueOf;
                if (!enabled) {
                    sce.trustAs = sce.getTrusted = function(type, value) {
                        return value;
                    };
                    sce.valueOf = identity;
                }
                /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ sce.parseAs = function sceParseAs(type, expr) {
                    var parsed = $parse(expr);
                    if (parsed.literal && parsed.constant) return parsed;
                    else return $parse(expr, function(value) {
                        return sce.getTrusted(type, value);
                    });
                };
                /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */ /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */ /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */ /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */ /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */ /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */ /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */ /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */ /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */ // Shorthand delegations.
                var parse = sce.parseAs, getTrusted = sce.getTrusted, trustAs = sce.trustAs;
                forEach(SCE_CONTEXTS, function(enumValue, name) {
                    var lName = lowercase(name);
                    sce[snakeToCamel("parse_as_" + lName)] = function(expr) {
                        return parse(enumValue, expr);
                    };
                    sce[snakeToCamel("get_trusted_" + lName)] = function(value) {
                        return getTrusted(enumValue, value);
                    };
                    sce[snakeToCamel("trust_as_" + lName)] = function(value) {
                        return trustAs(enumValue, value);
                    };
                });
                return sce;
            }
        ];
    }
    /* exported $SnifferProvider */ /**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */ function $SnifferProvider() {
        this.$get = [
            "$window",
            "$document",
            function($window, $document) {
                var eventSupport = {}, // Chrome Packaged Apps are not allowed to access `history.pushState`.
                // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
                // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
                // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
                // (see https://developer.chrome.com/apps/manifest/sandbox).
                // (NW.js apps have access to Chrome APIs, but do support `history`.)
                isNw = $window.nw && $window.nw.process, isChromePackagedApp = !isNw && $window.chrome && ($window.chrome.app && $window.chrome.app.runtime || !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id), hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState, android = toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]), boxee = /Boxee/i.test(($window.navigator || {}).userAgent), document1 = $document[0] || {}, bodyStyle = document1.body && document1.body.style, transitions = false, animations = false;
                if (bodyStyle) {
                    // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
                    // Mentioned browsers need a -webkit- prefix for transitions & animations.
                    transitions = !!("transition" in bodyStyle || "webkitTransition" in bodyStyle);
                    animations = !!("animation" in bodyStyle || "webkitAnimation" in bodyStyle);
                }
                return {
                    // Android has history.pushState, but it does not update location correctly
                    // so let's not use the history API at all.
                    // http://code.google.com/p/android/issues/detail?id=17471
                    // https://github.com/angular/angular.js/issues/904
                    // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
                    // so let's not use the history API also
                    // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
                    history: !!(hasHistoryPushState && !(android < 4) && !boxee),
                    hasEvent: function(event) {
                        // Support: IE 9-11 only
                        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
                        // it. In particular the event is not fired when backspace or delete key are pressed or
                        // when cut operation is performed.
                        // IE10+ implements 'input' event but it erroneously fires under various situations,
                        // e.g. when placeholder changes, or a form is focused.
                        if (event === "input" && msie) return false;
                        if (isUndefined(eventSupport[event])) {
                            var divElm = document1.createElement("div");
                            eventSupport[event] = "on" + event in divElm;
                        }
                        return eventSupport[event];
                    },
                    csp: csp(),
                    transitions: transitions,
                    animations: animations,
                    android: android
                };
            }
        ];
    }
    /**
 * ! This is a private undocumented service !
 *
 * @name $$taskTrackerFactory
 * @description
 * A function to create `TaskTracker` instances.
 *
 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
 * parties when all pending tasks (or tasks of a specific type) have been completed.
 *
 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
 *     execution.
 *
 * @this
 */ function $$TaskTrackerFactoryProvider() {
        this.$get = valueFn(function(log) {
            return new TaskTracker(log);
        });
    }
    function TaskTracker(log) {
        var self = this;
        var taskCounts = {};
        var taskCallbacks = [];
        var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = "$$all$$";
        var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = "$$default$$";
        /**
   * Execute the specified function and decrement the appropriate `taskCounts` counter.
   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
   *
   * @param {Function} fn - The function to execute.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
   */ self.completeTask = completeTask;
        /**
   * Increase the task count for the specified task type (or the default task type if non is
   * specified).
   *
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
   */ self.incTaskCount = incTaskCount;
        /**
   * Execute the specified callback when all pending tasks have been completed.
   *
   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
   * the tasks that will be waited for to a specific type, by passing a `taskType`.
   *
   * @param {function} callback - The function to call when there are no pending tasks.
   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
   */ self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
        function completeTask(fn, taskType) {
            taskType = taskType || DEFAULT_TASK_TYPE;
            try {
                fn();
            } finally{
                decTaskCount(taskType);
                var countForType = taskCounts[taskType];
                var countForAll = taskCounts[ALL_TASKS_TYPE];
                // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
                if (!countForAll || !countForType) {
                    var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
                    var nextCb;
                    while(nextCb = getNextCallback(taskType))try {
                        nextCb();
                    } catch (e) {
                        log.error(e);
                    }
                }
            }
        }
        function decTaskCount(taskType) {
            taskType = taskType || DEFAULT_TASK_TYPE;
            if (taskCounts[taskType]) {
                taskCounts[taskType]--;
                taskCounts[ALL_TASKS_TYPE]--;
            }
        }
        function getLastCallback() {
            var cbInfo = taskCallbacks.pop();
            return cbInfo && cbInfo.cb;
        }
        function getLastCallbackForType(taskType) {
            for(var i = taskCallbacks.length - 1; i >= 0; --i){
                var cbInfo = taskCallbacks[i];
                if (cbInfo.type === taskType) {
                    taskCallbacks.splice(i, 1);
                    return cbInfo.cb;
                }
            }
        }
        function incTaskCount(taskType) {
            taskType = taskType || DEFAULT_TASK_TYPE;
            taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
            taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
        }
        function notifyWhenNoPendingTasks(callback, taskType) {
            taskType = taskType || ALL_TASKS_TYPE;
            if (!taskCounts[taskType]) callback();
            else taskCallbacks.push({
                type: taskType,
                cb: callback
            });
        }
    }
    var $templateRequestMinErr = minErr("$templateRequest");
    /**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */ function $TemplateRequestProvider() {
        var httpOptions;
        /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */ this.httpOptions = function(val) {
            if (val) {
                httpOptions = val;
                return this;
            }
            return httpOptions;
        };
        /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */ this.$get = [
            "$exceptionHandler",
            "$templateCache",
            "$http",
            "$q",
            "$sce",
            function($exceptionHandler, $templateCache, $http, $q, $sce) {
                function handleRequestFn(tpl, ignoreRequestError) {
                    handleRequestFn.totalPendingRequests++;
                    // We consider the template cache holds only trusted templates, so
                    // there's no need to go through adding the template again to the trusted
                    // resources for keys that already are included in there. This also makes
                    // AngularJS accept any script directive, no matter its name. However, we
                    // still need to unwrap trusted types.
                    if (!isString(tpl) || isUndefined($templateCache.get(tpl))) tpl = $sce.getTrustedResourceUrl(tpl);
                    var transformResponse = $http.defaults && $http.defaults.transformResponse;
                    if (isArray(transformResponse)) transformResponse = transformResponse.filter(function(transformer) {
                        return transformer !== defaultHttpResponseTransform;
                    });
                    else if (transformResponse === defaultHttpResponseTransform) transformResponse = null;
                    return $http.get(tpl, extend({
                        cache: $templateCache,
                        transformResponse: transformResponse
                    }, httpOptions)).finally(function() {
                        handleRequestFn.totalPendingRequests--;
                    }).then(function(response) {
                        return $templateCache.put(tpl, response.data);
                    }, handleError);
                    function handleError(resp) {
                        if (!ignoreRequestError) {
                            resp = $templateRequestMinErr("tpload", "Failed to load template: {0} (HTTP status: {1} {2})", tpl, resp.status, resp.statusText);
                            $exceptionHandler(resp);
                        }
                        return $q.reject(resp);
                    }
                }
                handleRequestFn.totalPendingRequests = 0;
                return handleRequestFn;
            }
        ];
    }
    /** @this */ function $$TestabilityProvider() {
        this.$get = [
            "$rootScope",
            "$browser",
            "$location",
            function($rootScope, $browser, $location) {
                /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */ var testability = {};
                /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */ testability.findBindings = function(element, expression, opt_exactMatch) {
                    var bindings = element.getElementsByClassName("ng-binding");
                    var matches = [];
                    forEach(bindings, function(binding) {
                        var dataBinding = angular.element(binding).data("$binding");
                        if (dataBinding) forEach(dataBinding, function(bindingName) {
                            if (opt_exactMatch) {
                                var matcher = new RegExp("(^|\\s)" + escapeForRegexp(expression) + "(\\s|\\||$)");
                                if (matcher.test(bindingName)) matches.push(binding);
                            } else if (bindingName.indexOf(expression) !== -1) matches.push(binding);
                        });
                    });
                    return matches;
                };
                /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */ testability.findModels = function(element, expression, opt_exactMatch) {
                    var prefixes = [
                        "ng-",
                        "data-ng-",
                        "ng\\:"
                    ];
                    for(var p = 0; p < prefixes.length; ++p){
                        var attributeEquals = opt_exactMatch ? "=" : "*=";
                        var selector = "[" + prefixes[p] + "model" + attributeEquals + '"' + expression + '"]';
                        var elements = element.querySelectorAll(selector);
                        if (elements.length) return elements;
                    }
                };
                /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */ testability.getLocation = function() {
                    return $location.url();
                };
                /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */ testability.setLocation = function(url) {
                    if (url !== $location.url()) {
                        $location.url(url);
                        $rootScope.$digest();
                    }
                };
                /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when all pending tasks are completed.
     *
     * Types of tasks waited for include:
     * - Pending timeouts (via {@link $timeout}).
     * - Pending HTTP requests (via {@link $http}).
     * - In-progress route transitions (via {@link $route}).
     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
     *
     * @param {function} callback
     */ testability.whenStable = function(callback) {
                    $browser.notifyWhenNoOutstandingRequests(callback);
                };
                return testability;
            }
        ];
    }
    var $timeoutMinErr = minErr("$timeout");
    /** @this */ function $TimeoutProvider() {
        this.$get = [
            "$rootScope",
            "$browser",
            "$q",
            "$$q",
            "$exceptionHandler",
            function($rootScope, $browser, $q, $$q, $exceptionHandler) {
                var deferreds = {};
                /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */ function timeout(fn, delay, invokeApply) {
                    if (!isFunction(fn)) {
                        invokeApply = delay;
                        delay = fn;
                        fn = noop;
                    }
                    var args = sliceArgs(arguments, 3), skipApply = isDefined(invokeApply) && !invokeApply, deferred = (skipApply ? $$q : $q).defer(), promise = deferred.promise, timeoutId;
                    timeoutId = $browser.defer(function() {
                        try {
                            deferred.resolve(fn.apply(null, args));
                        } catch (e) {
                            deferred.reject(e);
                            $exceptionHandler(e);
                        } finally{
                            delete deferreds[promise.$$timeoutId];
                        }
                        if (!skipApply) $rootScope.$apply();
                    }, delay, "$timeout");
                    promise.$$timeoutId = timeoutId;
                    deferreds[timeoutId] = deferred;
                    return promise;
                }
                /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */ timeout.cancel = function(promise) {
                    if (!promise) return false;
                    if (!promise.hasOwnProperty("$$timeoutId")) throw $timeoutMinErr("badprom", "`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.");
                    if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
                    var id = promise.$$timeoutId;
                    var deferred = deferreds[id];
                    // Timeout cancels should not report an unhandled promise.
                    markQExceptionHandled(deferred.promise);
                    deferred.reject("canceled");
                    delete deferreds[id];
                    return $browser.defer.cancel(id);
                };
                return timeout;
            }
        ];
    }
    // NOTE:  The usage of window and document instead of $window and $document here is
    // deliberate.  This service depends on the specific behavior of anchor nodes created by the
    // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
    // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
    // doesn't know about mocked locations and resolves URLs to the real document - which is
    // exactly the behavior needed here.  There is little value is mocking these out for this
    // service.
    var urlParsingNode = window1.document.createElement("a");
    var originUrl = urlResolve(window1.location.href);
    var baseUrlParsingNode;
    urlParsingNode.href = "http://[::1]";
    // Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
    // IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
    // when parsed out of an anchor element.
    var ipv6InBrackets = urlParsingNode.hostname === "[::1]";
    /**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description                                                            |
 *   |---------------|------------------------------------------------------------------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol without the trailing colon                                |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol                                 |
 *   | hostname      | The hostname                                                           |
 *   | port          | The port, without ":"                                                  |
 *   | pathname      | The pathname, beginning with "/"                                       |
 *
 */ function urlResolve(url) {
        if (!isString(url)) return url;
        var href = url;
        // Support: IE 9-11 only
        if (msie) {
            // Normalize before parse.  Refer Implementation Notes on why this is
            // done in two steps on IE.
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        var hostname = urlParsingNode.hostname;
        if (!ipv6InBrackets && hostname.indexOf(":") > -1) hostname = "[" + hostname + "]";
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    /**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */ function urlIsSameOrigin(requestUrl) {
        return urlsAreSameOrigin(requestUrl, originUrl);
    }
    /**
 * Parse a request URL and determine whether it is same-origin as the current document base URL.
 *
 * Note: The base URL is usually the same as the document location (`location.href`) but can
 * be overriden by using the `<base>` tag.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the URL is same-origin as the document base URL.
 */ function urlIsSameOriginAsBaseUrl(requestUrl) {
        return urlsAreSameOrigin(requestUrl, getBaseUrl());
    }
    /**
 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */ function urlIsAllowedOriginFactory(trustedOriginUrls) {
        var parsedAllowedOriginUrls = [
            originUrl
        ].concat(trustedOriginUrls.map(urlResolve));
        /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of trusted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */ return function urlIsAllowedOrigin(requestUrl) {
            var parsedUrl = urlResolve(requestUrl);
            return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
        };
    }
    /**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */ function urlsAreSameOrigin(url1, url2) {
        url1 = urlResolve(url1);
        url2 = urlResolve(url2);
        return url1.protocol === url2.protocol && url1.host === url2.host;
    }
    /**
 * Returns the current document base URL.
 * @returns {string}
 */ function getBaseUrl() {
        if (window1.document.baseURI) return window1.document.baseURI;
        // `document.baseURI` is available everywhere except IE
        if (!baseUrlParsingNode) {
            baseUrlParsingNode = window1.document.createElement("a");
            baseUrlParsingNode.href = ".";
            // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
            // suitable here because we need to track changes to the base URL.
            baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
        }
        return baseUrlParsingNode.href;
    }
    /**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */ function $WindowProvider() {
        this.$get = valueFn(window1);
    }
    /**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */ function $$CookieReader($document) {
        var rawDocument = $document[0] || {};
        var lastCookies = {};
        var lastCookieString = "";
        function safeGetCookie(rawDocument) {
            try {
                return rawDocument.cookie || "";
            } catch (e) {
                return "";
            }
        }
        function safeDecodeURIComponent(str) {
            try {
                return decodeURIComponent(str);
            } catch (e) {
                return str;
            }
        }
        return function() {
            var cookieArray, cookie, i, index, name;
            var currentCookieString = safeGetCookie(rawDocument);
            if (currentCookieString !== lastCookieString) {
                lastCookieString = currentCookieString;
                cookieArray = lastCookieString.split("; ");
                lastCookies = {};
                for(i = 0; i < cookieArray.length; i++){
                    cookie = cookieArray[i];
                    index = cookie.indexOf("=");
                    if (index > 0) {
                        name = safeDecodeURIComponent(cookie.substring(0, index));
                        // the first value that is seen for a cookie is the most
                        // specific one.  values for the same cookie name that
                        // follow are for less specific paths.
                        if (isUndefined(lastCookies[name])) lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
                    }
                }
            }
            return lastCookies;
        };
    }
    $$CookieReader.$inject = [
        "$document"
    ];
    /** @this */ function $$CookieReaderProvider() {
        this.$get = $$CookieReader;
    }
    /* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */ /**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */ /**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */ $FilterProvider.$inject = [
        "$provide"
    ];
    /** @this */ function $FilterProvider($provide) {
        var suffix = "Filter";
        /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */ function register(name, factory) {
            if (isObject(name)) {
                var filters = {};
                forEach(name, function(filter, key) {
                    filters[key] = register(key, filter);
                });
                return filters;
            } else return $provide.factory(name + suffix, factory);
        }
        this.register = register;
        this.$get = [
            "$injector",
            function($injector) {
                return function(name) {
                    return $injector.get(name + suffix);
                };
            }
        ];
        ////////////////////////////////////////
        /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */ register("currency", currencyFilter);
        register("date", dateFilter);
        register("filter", filterFilter);
        register("json", jsonFilter);
        register("limitTo", limitToFilter);
        register("lowercase", lowercaseFilter);
        register("number", numberFilter);
        register("orderBy", orderByFilter);
        register("uppercase", uppercaseFilter);
    }
    /**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */ function filterFilter() {
        return function(array, expression, comparator, anyPropertyKey) {
            if (!isArrayLike(array)) {
                if (array == null) return array;
                else throw minErr("filter")("notarray", "Expected array but received: {0}", array);
            }
            anyPropertyKey = anyPropertyKey || "$";
            var expressionType = getTypeForFilter(expression);
            var predicateFn;
            var matchAgainstAnyProp;
            switch(expressionType){
                case "function":
                    predicateFn = expression;
                    break;
                case "boolean":
                case "null":
                case "number":
                case "string":
                    matchAgainstAnyProp = true;
                // falls through
                case "object":
                    predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
                    break;
                default:
                    return array;
            }
            return Array.prototype.filter.call(array, predicateFn);
        };
    }
    // Helper functions for `filterFilter`
    function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
        var shouldMatchPrimitives = isObject(expression) && anyPropertyKey in expression;
        var predicateFn;
        if (comparator === true) comparator = equals;
        else if (!isFunction(comparator)) comparator = function(actual, expected) {
            if (isUndefined(actual)) // No substring matching against `undefined`
            return false;
            if (actual === null || expected === null) // No substring matching against `null`; only match against `null`
            return actual === expected;
            if (isObject(expected) || isObject(actual) && !hasCustomToString(actual)) // Should not compare primitives against objects, unless they have custom `toString` method
            return false;
            actual = lowercase("" + actual);
            expected = lowercase("" + expected);
            return actual.indexOf(expected) !== -1;
        };
        predicateFn = function(item) {
            if (shouldMatchPrimitives && !isObject(item)) return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
            return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        };
        return predicateFn;
    }
    function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
        var actualType = getTypeForFilter(actual);
        var expectedType = getTypeForFilter(expected);
        if (expectedType === "string" && expected.charAt(0) === "!") return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
        else if (isArray(actual)) // In case `actual` is an array, consider it a match
        // if ANY of it's items matches `expected`
        return actual.some(function(item) {
            return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
        });
        switch(actualType){
            case "object":
                var key;
                if (matchAgainstAnyProp) {
                    for(key in actual){
                        // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
                        // See: https://github.com/angular/angular.js/issues/15644
                        if (key.charAt && key.charAt(0) !== "$" && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) return true;
                    }
                    return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
                } else if (expectedType === "object") {
                    for(key in expected){
                        var expectedVal = expected[key];
                        if (isFunction(expectedVal) || isUndefined(expectedVal)) continue;
                        var matchAnyProperty = key === anyPropertyKey;
                        var actualVal = matchAnyProperty ? actual : actual[key];
                        if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) return false;
                    }
                    return true;
                } else return comparator(actual, expected);
            case "function":
                return false;
            default:
                return comparator(actual, expected);
        }
    }
    // Used for easily differentiating between `null` and actual `object`
    function getTypeForFilter(val) {
        return val === null ? "null" : typeof val;
    }
    var MAX_DIGITS = 22;
    var DECIMAL_SEP = ".";
    var ZERO_CHAR = "0";
    /**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */ currencyFilter.$inject = [
        "$locale"
    ];
    function currencyFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function(amount, currencySymbol, fractionSize) {
            if (isUndefined(currencySymbol)) currencySymbol = formats.CURRENCY_SYM;
            if (isUndefined(fractionSize)) fractionSize = formats.PATTERNS[1].maxFrac;
            // If the currency symbol is empty, trim whitespace around the symbol
            var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
            // if null or undefined pass it through
            return amount == null ? amount : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).replace(currencySymbolRe, currencySymbol);
        };
    }
    /**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */ numberFilter.$inject = [
        "$locale"
    ];
    function numberFilter($locale) {
        var formats = $locale.NUMBER_FORMATS;
        return function(number, fractionSize) {
            // if null or undefined pass it through
            return number == null ? number : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
        };
    }
    /**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */ function parse(numStr) {
        var exponent = 0, digits, numberOfIntegerDigits;
        var i, j, zeros;
        // Decimal point?
        if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) numStr = numStr.replace(DECIMAL_SEP, "");
        // Exponential form?
        if ((i = numStr.search(/e/i)) > 0) {
            // Work out the exponent.
            if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
            numberOfIntegerDigits += +numStr.slice(i + 1);
            numStr = numStr.substring(0, i);
        } else if (numberOfIntegerDigits < 0) // There was no decimal point or exponent so it is an integer.
        numberOfIntegerDigits = numStr.length;
        // Count the number of leading zeros.
        for(i = 0; numStr.charAt(i) === ZERO_CHAR; i++);
        if (i === (zeros = numStr.length)) {
            // The digits are all zero.
            digits = [
                0
            ];
            numberOfIntegerDigits = 1;
        } else {
            // Count the number of trailing zeros
            zeros--;
            while(numStr.charAt(zeros) === ZERO_CHAR)zeros--;
            // Trailing zeros are insignificant so ignore them
            numberOfIntegerDigits -= i;
            digits = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(j = 0; i <= zeros; i++, j++)digits[j] = +numStr.charAt(i);
        }
        // If the number overflows the maximum allowed digits then use an exponent.
        if (numberOfIntegerDigits > MAX_DIGITS) {
            digits = digits.splice(0, MAX_DIGITS - 1);
            exponent = numberOfIntegerDigits - 1;
            numberOfIntegerDigits = 1;
        }
        return {
            d: digits,
            e: exponent,
            i: numberOfIntegerDigits
        };
    }
    /**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */ function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
        var digits = parsedNumber.d;
        var fractionLen = digits.length - parsedNumber.i;
        // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
        fractionSize = isUndefined(fractionSize) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
        // The index of the digit to where rounding is to occur
        var roundAt = fractionSize + parsedNumber.i;
        var digit = digits[roundAt];
        if (roundAt > 0) {
            // Drop fractional digits beyond `roundAt`
            digits.splice(Math.max(parsedNumber.i, roundAt));
            // Set non-fractional digits beyond `roundAt` to 0
            for(var j = roundAt; j < digits.length; j++)digits[j] = 0;
        } else {
            // We rounded to zero so reset the parsedNumber
            fractionLen = Math.max(0, fractionLen);
            parsedNumber.i = 1;
            digits.length = Math.max(1, roundAt = fractionSize + 1);
            digits[0] = 0;
            for(var i = 1; i < roundAt; i++)digits[i] = 0;
        }
        if (digit >= 5) {
            if (roundAt - 1 < 0) {
                for(var k = 0; k > roundAt; k--){
                    digits.unshift(0);
                    parsedNumber.i++;
                }
                digits.unshift(1);
                parsedNumber.i++;
            } else digits[roundAt - 1]++;
        }
        // Pad out with zeros to get the required fraction length
        for(; fractionLen < Math.max(0, fractionSize); fractionLen++)digits.push(0);
        // Do any carrying, e.g. a digit was rounded up to 10
        var carry = digits.reduceRight(function(carry, d, i, digits) {
            d = d + carry;
            digits[i] = d % 10;
            return Math.floor(d / 10);
        }, 0);
        if (carry) {
            digits.unshift(carry);
            parsedNumber.i++;
        }
    }
    /**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */ function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
        if (!(isString(number) || isNumber(number)) || isNaN(number)) return "";
        var isInfinity = !isFinite(number);
        var isZero = false;
        var numStr = Math.abs(number) + "", formattedText = "", parsedNumber;
        if (isInfinity) formattedText = "\u221E";
        else {
            parsedNumber = parse(numStr);
            roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
            var digits = parsedNumber.d;
            var integerLen = parsedNumber.i;
            var exponent = parsedNumber.e;
            var decimals = [];
            isZero = digits.reduce(function(isZero, d) {
                return isZero && !d;
            }, true);
            // pad zeros for small numbers
            while(integerLen < 0){
                digits.unshift(0);
                integerLen++;
            }
            // extract decimals digits
            if (integerLen > 0) decimals = digits.splice(integerLen, digits.length);
            else {
                decimals = digits;
                digits = [
                    0
                ];
            }
            // format the integer digits with grouping separators
            var groups = [];
            if (digits.length >= pattern.lgSize) groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(""));
            while(digits.length > pattern.gSize)groups.unshift(digits.splice(-pattern.gSize, digits.length).join(""));
            if (digits.length) groups.unshift(digits.join(""));
            formattedText = groups.join(groupSep);
            // append the decimal digits
            if (decimals.length) formattedText += decimalSep + decimals.join("");
            if (exponent) formattedText += "e+" + exponent;
        }
        if (number < 0 && !isZero) return pattern.negPre + formattedText + pattern.negSuf;
        else return pattern.posPre + formattedText + pattern.posSuf;
    }
    function padNumber(num, digits, trim, negWrap) {
        var neg = "";
        if (num < 0 || negWrap && num <= 0) {
            if (negWrap) num = -num + 1;
            else {
                num = -num;
                neg = "-";
            }
        }
        num = "" + num;
        while(num.length < digits)num = ZERO_CHAR + num;
        if (trim) num = num.substr(num.length - digits);
        return neg + num;
    }
    function dateGetter(name, size, offset, trim, negWrap) {
        offset = offset || 0;
        return function(date) {
            var value = date["get" + name]();
            if (offset > 0 || value > -offset) value += offset;
            if (value === 0 && offset === -12) value = 12;
            return padNumber(value, size, trim, negWrap);
        };
    }
    function dateStrGetter(name, shortForm, standAlone) {
        return function(date, formats) {
            var value = date["get" + name]();
            var propPrefix = (standAlone ? "STANDALONE" : "") + (shortForm ? "SHORT" : "");
            var get = uppercase(propPrefix + name);
            return formats[get][value];
        };
    }
    function timeZoneGetter(date, formats, offset) {
        var zone = -1 * offset;
        var paddedZone = zone >= 0 ? "+" : "";
        paddedZone += padNumber(Math[zone > 0 ? "floor" : "ceil"](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);
        return paddedZone;
    }
    function getFirstThursdayOfYear(year) {
        // 0 = index of January
        var dayOfWeekOnFirst = new Date(year, 0, 1).getDay();
        // 4 = index of Thursday (+1 to account for 1st = 5)
        // 11 = index of *next* Thursday (+1 account for 1st = 12)
        return new Date(year, 0, (dayOfWeekOnFirst <= 4 ? 5 : 12) - dayOfWeekOnFirst);
    }
    function getThursdayThisWeek(datetime) {
        return new Date(datetime.getFullYear(), datetime.getMonth(), // 4 = index of Thursday
        datetime.getDate() + (4 - datetime.getDay()));
    }
    function weekGetter(size) {
        return function(date) {
            var firstThurs = getFirstThursdayOfYear(date.getFullYear()), thisThurs = getThursdayThisWeek(date);
            var diff = +thisThurs - +firstThurs, result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
            return padNumber(result, size);
        };
    }
    function ampmGetter(date, formats) {
        return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
    }
    function eraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
    }
    function longEraGetter(date, formats) {
        return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
    }
    var DATE_FORMATS = {
        yyyy: dateGetter("FullYear", 4, 0, false, true),
        yy: dateGetter("FullYear", 2, 0, true, true),
        y: dateGetter("FullYear", 1, 0, false, true),
        MMMM: dateStrGetter("Month"),
        MMM: dateStrGetter("Month", true),
        MM: dateGetter("Month", 2, 1),
        M: dateGetter("Month", 1, 1),
        LLLL: dateStrGetter("Month", false, true),
        dd: dateGetter("Date", 2),
        d: dateGetter("Date", 1),
        HH: dateGetter("Hours", 2),
        H: dateGetter("Hours", 1),
        hh: dateGetter("Hours", 2, -12),
        h: dateGetter("Hours", 1, -12),
        mm: dateGetter("Minutes", 2),
        m: dateGetter("Minutes", 1),
        ss: dateGetter("Seconds", 2),
        s: dateGetter("Seconds", 1),
        // while ISO 8601 requires fractions to be prefixed with `.` or `,`
        // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
        sss: dateGetter("Milliseconds", 3),
        EEEE: dateStrGetter("Day"),
        EEE: dateStrGetter("Day", true),
        a: ampmGetter,
        Z: timeZoneGetter,
        ww: weekGetter(2),
        w: weekGetter(1),
        G: eraGetter,
        GG: eraGetter,
        GGG: eraGetter,
        GGGG: longEraGetter
    };
    var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/, NUMBER_STRING = /^-?\d+$/;
    /**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */ dateFilter.$inject = [
        "$locale"
    ];
    function dateFilter($locale) {
        var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
        // 1        2       3         4          5          6          7          8  9     10      11
        function jsonStringToDate(string) {
            var match;
            if (match = string.match(R_ISO8601_STR)) {
                var date = new Date(0), tzHour = 0, tzMin = 0, dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear, timeSetter = match[8] ? date.setUTCHours : date.setHours;
                if (match[9]) {
                    tzHour = toInt(match[9] + match[10]);
                    tzMin = toInt(match[9] + match[11]);
                }
                dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
                var h = toInt(match[4] || 0) - tzHour;
                var m = toInt(match[5] || 0) - tzMin;
                var s = toInt(match[6] || 0);
                var ms = Math.round(parseFloat("0." + (match[7] || 0)) * 1000);
                timeSetter.call(date, h, m, s, ms);
                return date;
            }
            return string;
        }
        return function(date, format, timezone) {
            var text = "", parts = [], fn, match;
            format = format || "mediumDate";
            format = $locale.DATETIME_FORMATS[format] || format;
            if (isString(date)) date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
            if (isNumber(date)) date = new Date(date);
            if (!isDate(date) || !isFinite(date.getTime())) return date;
            while(format){
                match = DATE_FORMATS_SPLIT.exec(format);
                if (match) {
                    parts = concat(parts, match, 1);
                    format = parts.pop();
                } else {
                    parts.push(format);
                    format = null;
                }
            }
            var dateTimezoneOffset = date.getTimezoneOffset();
            if (timezone) {
                dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
                date = convertTimezoneToLocal(date, timezone, true);
            }
            forEach(parts, function(value) {
                fn = DATE_FORMATS[value];
                text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset) : value === "''" ? "'" : value.replace(/(^'|'$)/g, "").replace(/''/g, "'");
            });
            return text;
        };
    }
    /**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */ function jsonFilter() {
        return function(object, spacing) {
            if (isUndefined(spacing)) spacing = 2;
            return toJson(object, spacing);
        };
    }
    /**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */ var lowercaseFilter = valueFn(lowercase);
    /**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */ var uppercaseFilter = valueFn(uppercase);
    /**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/ function limitToFilter() {
        return function(input, limit, begin) {
            if (Math.abs(Number(limit)) === Infinity) limit = Number(limit);
            else limit = toInt(limit);
            if (isNumberNaN(limit)) return input;
            if (isNumber(input)) input = input.toString();
            if (!isArrayLike(input)) return input;
            begin = !begin || isNaN(begin) ? 0 : toInt(begin);
            begin = begin < 0 ? Math.max(0, input.length + begin) : begin;
            if (limit >= 0) return sliceFn(input, begin, begin + limit);
            else {
                if (begin === 0) return sliceFn(input, limit, input.length);
                else return sliceFn(input, Math.max(0, begin + limit), begin);
            }
        };
    }
    function sliceFn(input, begin, end) {
        if (isString(input)) return input.slice(begin, end);
        return slice.call(input, begin, end);
    }
    /**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 *    **Note:** `null` values use `'null'` as their type.
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, sorts values of different types by type and puts
 * `undefined` and `null` values at the end of the sorted list.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types:
 *    - If one of the values is undefined, consider it "greater than" the other.
 *    - Else if one of the values is null, consider it "greater than" the other.
 *    - Else compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
 *           any other value (with undefined "greater than" null). This effectively means that `null`
 *           and `undefined` values end up at the end of a list sorted in ascending order.
 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */ orderByFilter.$inject = [
        "$parse"
    ];
    function orderByFilter($parse) {
        return function(array, sortPredicate, reverseOrder, compareFn) {
            if (array == null) return array;
            if (!isArrayLike(array)) throw minErr("orderBy")("notarray", "Expected array but received: {0}", array);
            if (!isArray(sortPredicate)) sortPredicate = [
                sortPredicate
            ];
            if (sortPredicate.length === 0) sortPredicate = [
                "+"
            ];
            var predicates = processPredicates(sortPredicate);
            var descending = reverseOrder ? -1 : 1;
            // Define the `compare()` function. Use a default comparator if none is specified.
            var compare = isFunction(compareFn) ? compareFn : defaultCompare;
            // The next three lines are a version of a Swartzian Transform idiom from Perl
            // (sometimes called the Decorate-Sort-Undecorate idiom)
            // See https://en.wikipedia.org/wiki/Schwartzian_transform
            var compareValues = Array.prototype.map.call(array, getComparisonObject);
            compareValues.sort(doComparison);
            array = compareValues.map(function(item) {
                return item.value;
            });
            return array;
            function getComparisonObject(value, index) {
                // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
                // This will be used to keep the sort stable when none of the input predicates can
                // distinguish between two elements.
                return {
                    value: value,
                    tieBreaker: {
                        value: index,
                        type: "number",
                        index: index
                    },
                    predicateValues: predicates.map(function(predicate) {
                        return getPredicateValue(predicate.get(value), index);
                    })
                };
            }
            function doComparison(v1, v2) {
                for(var i = 0, ii = predicates.length; i < ii; i++){
                    var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
                    if (result) return result * predicates[i].descending * descending;
                }
                return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
            }
        };
        function processPredicates(sortPredicates) {
            return sortPredicates.map(function(predicate) {
                var descending = 1, get = identity;
                if (isFunction(predicate)) get = predicate;
                else if (isString(predicate)) {
                    if (predicate.charAt(0) === "+" || predicate.charAt(0) === "-") {
                        descending = predicate.charAt(0) === "-" ? -1 : 1;
                        predicate = predicate.substring(1);
                    }
                    if (predicate !== "") {
                        get = $parse(predicate);
                        if (get.constant) {
                            var key = get();
                            get = function(value) {
                                return value[key];
                            };
                        }
                    }
                }
                return {
                    get: get,
                    descending: descending
                };
            });
        }
        function isPrimitive(value) {
            switch(typeof value){
                case "number":
                /* falls through */ case "boolean":
                /* falls through */ case "string":
                    return true;
                default:
                    return false;
            }
        }
        function objectValue(value) {
            // If `valueOf` is a valid function use that
            if (isFunction(value.valueOf)) {
                value = value.valueOf();
                if (isPrimitive(value)) return value;
            }
            // If `toString` is a valid function and not the one from `Object.prototype` use that
            if (hasCustomToString(value)) {
                value = value.toString();
                if (isPrimitive(value)) return value;
            }
            return value;
        }
        function getPredicateValue(value, index) {
            var type = typeof value;
            if (value === null) type = "null";
            else if (type === "object") value = objectValue(value);
            return {
                value: value,
                type: type,
                index: index
            };
        }
        function defaultCompare(v1, v2) {
            var result = 0;
            var type1 = v1.type;
            var type2 = v2.type;
            if (type1 === type2) {
                var value1 = v1.value;
                var value2 = v2.value;
                if (type1 === "string") {
                    // Compare strings case-insensitively
                    value1 = value1.toLowerCase();
                    value2 = value2.toLowerCase();
                } else if (type1 === "object") {
                    // For basic objects, use the position of the object
                    // in the collection instead of the value
                    if (isObject(value1)) value1 = v1.index;
                    if (isObject(value2)) value2 = v2.index;
                }
                if (value1 !== value2) result = value1 < value2 ? -1 : 1;
            } else result = type1 === "undefined" ? 1 : type2 === "undefined" ? -1 : type1 === "null" ? 1 : type2 === "null" ? -1 : type1 < type2 ? -1 : 1;
            return result;
        }
    }
    function ngDirective(directive) {
        if (isFunction(directive)) directive = {
            link: directive
        };
        directive.restrict = directive.restrict || "AC";
        return valueFn(directive);
    }
    /**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */ var htmlAnchorDirective = valueFn({
        restrict: "E",
        compile: function(element, attr) {
            if (!attr.href && !attr.xlinkHref) return function(scope, element) {
                // If the linked element is not an anchor tag anymore, do nothing
                if (element[0].nodeName.toLowerCase() !== "a") return;
                // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
                var href = toString.call(element.prop("href")) === "[object SVGAnimatedString]" ? "xlink:href" : "href";
                element.on("click", function(event) {
                    // if we have no href url, then don't navigate anywhere.
                    if (!element.attr(href)) event.preventDefault();
                });
            };
        }
    });
    /**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */ /**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */ /**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */ /**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */ /**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */ var ngAttributeAliasDirectives = {};
    // boolean attrs are evaluated
    forEach(BOOLEAN_ATTR, function(propName, attrName) {
        // binding to multiple is not supported
        if (propName === "multiple") return;
        function defaultLinkFn(scope, element, attr) {
            scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
                attr.$set(attrName, !!value);
            });
        }
        var normalized = directiveNormalize("ng-" + attrName);
        var linkFn = defaultLinkFn;
        if (propName === "checked") linkFn = function(scope, element, attr) {
            // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
            if (attr.ngModel !== attr[normalized]) defaultLinkFn(scope, element, attr);
        };
        ngAttributeAliasDirectives[normalized] = function() {
            return {
                restrict: "A",
                priority: 100,
                link: linkFn
            };
        };
    });
    // aliased input attrs are evaluated
    forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
        ngAttributeAliasDirectives[ngAttr] = function() {
            return {
                priority: 100,
                link: function(scope, element, attr) {
                    //special case ngPattern when a literal regular expression value
                    //is used as the expression (this way we don't have to watch anything).
                    if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) === "/") {
                        var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
                        if (match) {
                            attr.$set("ngPattern", new RegExp(match[1], match[2]));
                            return;
                        }
                    }
                    scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
                        attr.$set(ngAttr, value);
                    });
                }
            };
        };
    });
    // ng-src, ng-srcset, ng-href are interpolated
    forEach([
        "src",
        "srcset",
        "href"
    ], function(attrName) {
        var normalized = directiveNormalize("ng-" + attrName);
        ngAttributeAliasDirectives[normalized] = [
            "$sce",
            function($sce) {
                return {
                    priority: 99,
                    link: function(scope, element, attr) {
                        var propName = attrName, name = attrName;
                        if (attrName === "href" && toString.call(element.prop("href")) === "[object SVGAnimatedString]") {
                            name = "xlinkHref";
                            attr.$attr[name] = "xlink:href";
                            propName = null;
                        }
                        // We need to sanitize the url at least once, in case it is a constant
                        // non-interpolated attribute.
                        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
                        attr.$observe(normalized, function(value) {
                            if (!value) {
                                if (attrName === "href") attr.$set(name, null);
                                return;
                            }
                            attr.$set(name, value);
                            // Support: IE 9-11 only
                            // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
                            // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
                            // to set the property as well to achieve the desired effect.
                            // We use attr[attrName] value since $set might have sanitized the url.
                            if (msie && propName) element.prop(propName, attr[name]);
                        });
                    }
                };
            }
        ];
    });
    /* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */ var nullFormCtrl = {
        $addControl: noop,
        $getControls: valueFn([]),
        $$renameControl: nullFormRenameControl,
        $removeControl: noop,
        $setValidity: noop,
        $setDirty: noop,
        $setPristine: noop,
        $setSubmitted: noop,
        $$setSubmitted: noop
    }, PENDING_CLASS = "ng-pending", SUBMITTED_CLASS = "ng-submitted";
    function nullFormRenameControl(control, name) {
        control.$name = name;
    }
    /**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */ //asks for $scope to fool the BC controller module
    FormController.$inject = [
        "$element",
        "$attrs",
        "$scope",
        "$animate",
        "$interpolate"
    ];
    function FormController($element, $attrs, $scope, $animate, $interpolate) {
        this.$$controls = [];
        // init state
        this.$error = {};
        this.$$success = {};
        this.$pending = undefined;
        this.$name = $interpolate($attrs.name || $attrs.ngForm || "")($scope);
        this.$dirty = false;
        this.$pristine = true;
        this.$valid = true;
        this.$invalid = false;
        this.$submitted = false;
        this.$$parentForm = nullFormCtrl;
        this.$$element = $element;
        this.$$animate = $animate;
        setupValidity(this);
    }
    FormController.prototype = {
        /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */ $rollbackViewValue: function() {
            forEach(this.$$controls, function(control) {
                control.$rollbackViewValue();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */ $commitViewValue: function() {
            forEach(this.$$controls, function(control) {
                control.$commitViewValue();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */ $addControl: function(control) {
            // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
            // and not added to the scope.  Now we throw an error.
            assertNotHasOwnProperty(control.$name, "input");
            this.$$controls.push(control);
            if (control.$name) this[control.$name] = control;
            control.$$parentForm = this;
        },
        /**
   * @ngdoc method
   * @name form.FormController#$getControls
   * @returns {Array} the controls that are currently part of this form
   *
   * @description
   * This method returns a **shallow copy** of the controls that are currently part of this form.
   * The controls can be instances of {@link form.FormController `FormController`}
   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
   * If you need access to the controls of child-forms, you have to call `$getControls()`
   * recursively on them.
   * This can be used for example to iterate over all controls to validate them.
   *
   * The controls can be accessed normally, but adding to, or removing controls from the array has
   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
   * Likewise, adding a control to, or removing a control from the form is not reflected
   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
   * you need access to the controls.
   */ $getControls: function() {
            return shallowCopy(this.$$controls);
        },
        // Private API: rename a form control
        $$renameControl: function(control, newName) {
            var oldName = control.$name;
            if (this[oldName] === control) delete this[oldName];
            this[newName] = control;
            control.$name = newName;
        },
        /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */ $removeControl: function(control) {
            if (control.$name && this[control.$name] === control) delete this[control.$name];
            forEach(this.$pending, function(value, name) {
                // eslint-disable-next-line no-invalid-this
                this.$setValidity(name, null, control);
            }, this);
            forEach(this.$error, function(value, name) {
                // eslint-disable-next-line no-invalid-this
                this.$setValidity(name, null, control);
            }, this);
            forEach(this.$$success, function(value, name) {
                // eslint-disable-next-line no-invalid-this
                this.$setValidity(name, null, control);
            }, this);
            arrayRemove(this.$$controls, control);
            control.$$parentForm = nullFormCtrl;
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */ $setDirty: function() {
            this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
            this.$$animate.addClass(this.$$element, DIRTY_CLASS);
            this.$dirty = true;
            this.$pristine = false;
            this.$$parentForm.$setDirty();
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */ $setPristine: function() {
            this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + " " + SUBMITTED_CLASS);
            this.$dirty = false;
            this.$pristine = true;
            this.$submitted = false;
            forEach(this.$$controls, function(control) {
                control.$setPristine();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */ $setUntouched: function() {
            forEach(this.$$controls, function(control) {
                control.$setUntouched();
            });
        },
        /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
   * parent forms of the form.
   */ $setSubmitted: function() {
            var rootForm = this;
            while(rootForm.$$parentForm && rootForm.$$parentForm !== nullFormCtrl)rootForm = rootForm.$$parentForm;
            rootForm.$$setSubmitted();
        },
        $$setSubmitted: function() {
            this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
            this.$submitted = true;
            forEach(this.$$controls, function(control) {
                if (control.$$setSubmitted) control.$$setSubmitted();
            });
        }
    };
    /**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */ addSetValidityMethod({
        clazz: FormController,
        set: function(object, property, controller) {
            var list = object[property];
            if (!list) object[property] = [
                controller
            ];
            else {
                var index = list.indexOf(controller);
                if (index === -1) list.push(controller);
            }
        },
        unset: function(object, property, controller) {
            var list = object[property];
            if (!list) return;
            arrayRemove(list, controller);
            if (list.length === 0) delete object[property];
        }
    });
    /**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Helper directive that makes it possible to create control groups inside a
 * {@link ng.directive:form `form`} directive.
 * These "child forms" can be used, for example, to determine the validity of a sub-group of
 * controls.
 *
 * <div class="alert alert-danger">
 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
 * you cannot send data to the server with `ngForm`, or integrate it with
 * {@link ng.directive:ngSubmit `ngSubmit`}.
 * </div>
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
 *                              be published into the related scope, under this name.
 *
 */ /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */ var formDirectiveFactory = function(isNgForm) {
        return [
            "$timeout",
            "$parse",
            function($timeout, $parse) {
                var formDirective = {
                    name: "form",
                    restrict: isNgForm ? "EAC" : "E",
                    require: [
                        "form",
                        "^^?form"
                    ],
                    controller: FormController,
                    compile: function ngFormCompile(formElement, attr) {
                        // Setup initial state of the control
                        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
                        var nameAttr = attr.name ? "name" : isNgForm && attr.ngForm ? "ngForm" : false;
                        return {
                            pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
                                var controller = ctrls[0];
                                // if `action` attr is not present on the form, prevent the default action (submission)
                                if (!("action" in attr)) {
                                    // we can't use jq events because if a form is destroyed during submission the default
                                    // action is not prevented. see #1238
                                    //
                                    // IE 9 is not affected because it doesn't fire a submit event and try to do a full
                                    // page reload if the form was destroyed by submission of the form via a click handler
                                    // on a button in the form. Looks like an IE9 specific bug.
                                    var handleFormSubmission = function(event) {
                                        scope.$apply(function() {
                                            controller.$commitViewValue();
                                            controller.$setSubmitted();
                                        });
                                        event.preventDefault();
                                    };
                                    formElement[0].addEventListener("submit", handleFormSubmission);
                                    // unregister the preventDefault listener so that we don't not leak memory but in a
                                    // way that will achieve the prevention of the default action.
                                    formElement.on("$destroy", function() {
                                        $timeout(function() {
                                            formElement[0].removeEventListener("submit", handleFormSubmission);
                                        }, 0, false);
                                    });
                                }
                                var parentFormCtrl = ctrls[1] || controller.$$parentForm;
                                parentFormCtrl.$addControl(controller);
                                var setter = nameAttr ? getSetter(controller.$name) : noop;
                                if (nameAttr) {
                                    setter(scope, controller);
                                    attr.$observe(nameAttr, function(newValue) {
                                        if (controller.$name === newValue) return;
                                        setter(scope, undefined);
                                        controller.$$parentForm.$$renameControl(controller, newValue);
                                        setter = getSetter(controller.$name);
                                        setter(scope, controller);
                                    });
                                }
                                formElement.on("$destroy", function() {
                                    controller.$$parentForm.$removeControl(controller);
                                    setter(scope, undefined);
                                    extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
                                });
                            }
                        };
                    }
                };
                return formDirective;
                function getSetter(expression) {
                    if (expression === "") //create an assignable expression, so forms with an empty name can be renamed later
                    return $parse('this[""]').assign;
                    return $parse(expression).assign || noop;
                }
            }
        ];
    };
    var formDirective = formDirectiveFactory();
    var ngFormDirective = formDirectiveFactory(true);
    // helper methods
    function setupValidity(instance) {
        instance.$$classCache = {};
        instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
    }
    function addSetValidityMethod(context) {
        var clazz = context.clazz, set = context.set, unset = context.unset;
        clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
            if (isUndefined(state)) createAndSet(this, "$pending", validationErrorKey, controller);
            else unsetAndCleanup(this, "$pending", validationErrorKey, controller);
            if (!isBoolean(state)) {
                unset(this.$error, validationErrorKey, controller);
                unset(this.$$success, validationErrorKey, controller);
            } else if (state) {
                unset(this.$error, validationErrorKey, controller);
                set(this.$$success, validationErrorKey, controller);
            } else {
                set(this.$error, validationErrorKey, controller);
                unset(this.$$success, validationErrorKey, controller);
            }
            if (this.$pending) {
                cachedToggleClass(this, PENDING_CLASS, true);
                this.$valid = this.$invalid = undefined;
                toggleValidationCss(this, "", null);
            } else {
                cachedToggleClass(this, PENDING_CLASS, false);
                this.$valid = isObjectEmpty(this.$error);
                this.$invalid = !this.$valid;
                toggleValidationCss(this, "", this.$valid);
            }
            // re-read the state as the set/unset methods could have
            // combined state in this.$error[validationError] (used for forms),
            // where setting/unsetting only increments/decrements the value,
            // and does not replace it.
            var combinedState;
            if (this.$pending && this.$pending[validationErrorKey]) combinedState = undefined;
            else if (this.$error[validationErrorKey]) combinedState = false;
            else if (this.$$success[validationErrorKey]) combinedState = true;
            else combinedState = null;
            toggleValidationCss(this, validationErrorKey, combinedState);
            this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
        };
        function createAndSet(ctrl, name, value, controller) {
            if (!ctrl[name]) ctrl[name] = {};
            set(ctrl[name], value, controller);
        }
        function unsetAndCleanup(ctrl, name, value, controller) {
            if (ctrl[name]) unset(ctrl[name], value, controller);
            if (isObjectEmpty(ctrl[name])) ctrl[name] = undefined;
        }
        function cachedToggleClass(ctrl, className, switchValue) {
            if (switchValue && !ctrl.$$classCache[className]) {
                ctrl.$$animate.addClass(ctrl.$$element, className);
                ctrl.$$classCache[className] = true;
            } else if (!switchValue && ctrl.$$classCache[className]) {
                ctrl.$$animate.removeClass(ctrl.$$element, className);
                ctrl.$$classCache[className] = false;
            }
        }
        function toggleValidationCss(ctrl, validationErrorKey, isValid) {
            validationErrorKey = validationErrorKey ? "-" + snake_case(validationErrorKey, "-") : "";
            cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
            cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
        }
    }
    function isObjectEmpty(obj) {
        if (obj) for(var prop in obj){
            if (obj.hasOwnProperty(prop)) return false;
        }
        return true;
    }
    /* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/ // Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
    var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
    // See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
    // Note: We are being more lenient, because browsers are too.
    //   1. Scheme
    //   2. Slashes
    //   3. Username
    //   4. Password
    //   5. Hostname
    //   6. Port
    //   7. Path
    //   8. Query
    //   9. Fragment
    //                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
    var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
    // eslint-disable-next-line max-len
    var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
    var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
    var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
    var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
    var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
    var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
    var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
    var PARTIAL_VALIDATION_EVENTS = "keydown wheel mousedown";
    var PARTIAL_VALIDATION_TYPES = createMap();
    forEach("date,datetime-local,month,time,week".split(","), function(type) {
        PARTIAL_VALIDATION_TYPES[type] = true;
    });
    var inputType = {
        /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "text": textInputType,
        /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */ "date": createDateInputType("date", DATE_REGEXP, createDateParser(DATE_REGEXP, [
            "yyyy",
            "MM",
            "dd"
        ]), "yyyy-MM-dd"),
        /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * The format of the displayed time can be adjusted with the
    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
    * and `timeStripZeroSeconds`.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */ "datetime-local": createDateInputType("datetimelocal", DATETIMELOCAL_REGEXP, createDateParser(DATETIMELOCAL_REGEXP, [
            "yyyy",
            "MM",
            "dd",
            "HH",
            "mm",
            "ss",
            "sss"
        ]), "yyyy-MM-ddTHH:mm:ss.sss"),
        /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
   * this is the timezone of the browser.
   *
   * The format of the displayed time can be adjusted with the
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
   * and `timeStripZeroSeconds`.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */ "time": createDateInputType("time", TIME_REGEXP, createDateParser(TIME_REGEXP, [
            "HH",
            "mm",
            "ss",
            "sss"
        ]), "HH:mm:ss.sss"),
        /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */ "week": createDateInputType("week", WEEK_REGEXP, weekParser, "yyyy-Www"),
        /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */ "month": createDateInputType("month", MONTH_REGEXP, createDateParser(MONTH_REGEXP, [
            "yyyy",
            "MM"
        ]), "yyyy-MM"),
        /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   *
   *
   * @knownIssue
   *
   * ### HTML5 constraint validation and `allowInvalid`
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   * @knownIssue
   *
   * ### Large numbers and `step` validation
   *
   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
   * point for both implementations.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "number": numberInputType,
        /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "url": urlInputType,
        /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium, which may not fulfill your app's requirements.
   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
   * modify the built-in validators (see the {@link guide/forms Forms guide}).
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */ "email": emailInputType,
        /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */ "radio": radioInputType,
        /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                      to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */ "range": rangeInputType,
        /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */ "checkbox": checkboxInputType,
        "hidden": noop,
        "button": noop,
        "submit": noop,
        "reset": noop,
        "file": noop
    };
    function stringBasedInputType(ctrl) {
        ctrl.$formatters.push(function(value) {
            return ctrl.$isEmpty(value) ? value : value.toString();
        });
    }
    function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
    }
    function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        var type = lowercase(element[0].type);
        // In composition mode, users are still inputting intermediate text buffer,
        // hold the listener until composition is done.
        // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
        if (!$sniffer.android) {
            var composing = false;
            element.on("compositionstart", function() {
                composing = true;
            });
            // Support: IE9+
            element.on("compositionupdate", function(ev) {
                // End composition when ev.data is empty string on 'compositionupdate' event.
                // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
                // instead of 'compositionend'.
                if (isUndefined(ev.data) || ev.data === "") composing = false;
            });
            element.on("compositionend", function() {
                composing = false;
                listener();
            });
        }
        var timeout;
        var listener = function(ev) {
            if (timeout) {
                $browser.defer.cancel(timeout);
                timeout = null;
            }
            if (composing) return;
            var value = element.val(), event = ev && ev.type;
            // By default we will trim the value
            // If the attribute ng-trim exists we will avoid trimming
            // If input type is 'password', the value is never trimmed
            if (type !== "password" && (!attr.ngTrim || attr.ngTrim !== "false")) value = trim(value);
            // If a control is suffering from bad input (due to native validators), browsers discard its
            // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
            // control's value is the same empty value twice in a row.
            if (ctrl.$viewValue !== value || value === "" && ctrl.$$hasNativeValidators) ctrl.$setViewValue(value, event);
        };
        // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
        // input event on backspace, delete or cut
        if ($sniffer.hasEvent("input")) element.on("input", listener);
        else {
            var deferListener = function(ev, input, origValue) {
                if (!timeout) timeout = $browser.defer(function() {
                    timeout = null;
                    if (!input || input.value !== origValue) listener(ev);
                });
            };
            element.on("keydown", /** @this */ function(event) {
                var key = event.keyCode;
                // ignore
                //    command            modifiers                   arrows
                if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) return;
                deferListener(event, this, this.value);
            });
            // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
            if ($sniffer.hasEvent("paste")) element.on("paste cut drop", deferListener);
        }
        // if user paste into input using mouse on older browser
        // or form autocomplete on newer browser, we need "change" event to catch it
        element.on("change", listener);
        // Some native input types (date-family) have the ability to change validity without
        // firing any input/change events.
        // For these event types, when native validators are present and the browser supports the type,
        // check for validity changes on various DOM events.
        if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
            if (!timeout) {
                var validity = this[VALIDITY_STATE_PROPERTY];
                var origBadInput = validity.badInput;
                var origTypeMismatch = validity.typeMismatch;
                timeout = $browser.defer(function() {
                    timeout = null;
                    if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) listener(ev);
                });
            }
        });
        ctrl.$render = function() {
            // Workaround for Firefox validation #12102.
            var value = ctrl.$isEmpty(ctrl.$viewValue) ? "" : ctrl.$viewValue;
            if (element.val() !== value) element.val(value);
        };
    }
    function weekParser(isoWeek, existingDate) {
        if (isDate(isoWeek)) return isoWeek;
        if (isString(isoWeek)) {
            WEEK_REGEXP.lastIndex = 0;
            var parts = WEEK_REGEXP.exec(isoWeek);
            if (parts) {
                var year = +parts[1], week = +parts[2], hours = 0, minutes = 0, seconds = 0, milliseconds = 0, firstThurs = getFirstThursdayOfYear(year), addDays = (week - 1) * 7;
                if (existingDate) {
                    hours = existingDate.getHours();
                    minutes = existingDate.getMinutes();
                    seconds = existingDate.getSeconds();
                    milliseconds = existingDate.getMilliseconds();
                }
                return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
            }
        }
        return NaN;
    }
    function createDateParser(regexp, mapping) {
        return function(iso, previousDate) {
            var parts, map;
            if (isDate(iso)) return iso;
            if (isString(iso)) {
                // When a date is JSON'ified to wraps itself inside of an extra
                // set of double quotes. This makes the date parsing code unable
                // to match the date string and parse it as a date.
                if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') iso = iso.substring(1, iso.length - 1);
                if (ISO_DATE_REGEXP.test(iso)) return new Date(iso);
                regexp.lastIndex = 0;
                parts = regexp.exec(iso);
                if (parts) {
                    parts.shift();
                    if (previousDate) map = {
                        yyyy: previousDate.getFullYear(),
                        MM: previousDate.getMonth() + 1,
                        dd: previousDate.getDate(),
                        HH: previousDate.getHours(),
                        mm: previousDate.getMinutes(),
                        ss: previousDate.getSeconds(),
                        sss: previousDate.getMilliseconds() / 1000
                    };
                    else map = {
                        yyyy: 1970,
                        MM: 1,
                        dd: 1,
                        HH: 0,
                        mm: 0,
                        ss: 0,
                        sss: 0
                    };
                    forEach(parts, function(part, index) {
                        if (index < mapping.length) map[mapping[index]] = +part;
                    });
                    var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
                    if (map.yyyy < 100) // In the constructor, 2-digit years map to 1900-1999.
                    // Use `setFullYear()` to set the correct year.
                    date.setFullYear(map.yyyy);
                    return date;
                }
            }
            return NaN;
        };
    }
    function createDateInputType(type, regexp, parseDate, format) {
        return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
            badInputChecker(scope, element, attr, ctrl, type);
            baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
            var isTimeType = type === "time" || type === "datetimelocal";
            var previousDate;
            var previousTimezone;
            ctrl.$parsers.push(function(value) {
                if (ctrl.$isEmpty(value)) return null;
                if (regexp.test(value)) // Note: We cannot read ctrl.$modelValue, as there might be a different
                // parser/formatter in the processing chain so that the model
                // contains some different data format!
                return parseDateAndConvertTimeZoneToLocal(value, previousDate);
                ctrl.$$parserName = type;
                return undefined;
            });
            ctrl.$formatters.push(function(value) {
                if (value && !isDate(value)) throw ngModelMinErr("datefmt", "Expected `{0}` to be a date", value);
                if (isValidDate(value)) {
                    previousDate = value;
                    var timezone = ctrl.$options.getOption("timezone");
                    if (timezone) {
                        previousTimezone = timezone;
                        previousDate = convertTimezoneToLocal(previousDate, timezone, true);
                    }
                    return formatter(value, timezone);
                } else {
                    previousDate = null;
                    previousTimezone = null;
                    return "";
                }
            });
            if (isDefined(attr.min) || attr.ngMin) {
                var minVal = attr.min || $parse(attr.ngMin)(scope);
                var parsedMinVal = parseObservedDateValue(minVal);
                ctrl.$validators.min = function(value) {
                    return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
                };
                attr.$observe("min", function(val) {
                    if (val !== minVal) {
                        parsedMinVal = parseObservedDateValue(val);
                        minVal = val;
                        ctrl.$validate();
                    }
                });
            }
            if (isDefined(attr.max) || attr.ngMax) {
                var maxVal = attr.max || $parse(attr.ngMax)(scope);
                var parsedMaxVal = parseObservedDateValue(maxVal);
                ctrl.$validators.max = function(value) {
                    return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
                };
                attr.$observe("max", function(val) {
                    if (val !== maxVal) {
                        parsedMaxVal = parseObservedDateValue(val);
                        maxVal = val;
                        ctrl.$validate();
                    }
                });
            }
            function isValidDate(value) {
                // Invalid Date: getTime() returns NaN
                return value && !(value.getTime && value.getTime() !== value.getTime());
            }
            function parseObservedDateValue(val) {
                return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
            }
            function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
                var timezone = ctrl.$options.getOption("timezone");
                if (previousTimezone && previousTimezone !== timezone) // If the timezone has changed, adjust the previousDate to the default timezone
                // so that the new date is converted with the correct timezone offset
                previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
                var parsedDate = parseDate(value, previousDate);
                if (!isNaN(parsedDate) && timezone) parsedDate = convertTimezoneToLocal(parsedDate, timezone);
                return parsedDate;
            }
            function formatter(value, timezone) {
                var targetFormat = format;
                if (isTimeType && isString(ctrl.$options.getOption("timeSecondsFormat"))) targetFormat = format.replace("ss.sss", ctrl.$options.getOption("timeSecondsFormat")).replace(/:$/, "");
                var formatted = $filter("date")(value, targetFormat, timezone);
                if (isTimeType && ctrl.$options.getOption("timeStripZeroSeconds")) formatted = formatted.replace(/(?::00)?(?:\.000)?$/, "");
                return formatted;
            }
        };
    }
    function badInputChecker(scope, element, attr, ctrl, parserName) {
        var node = element[0];
        var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
        if (nativeValidation) ctrl.$parsers.push(function(value) {
            var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
            if (validity.badInput || validity.typeMismatch) {
                ctrl.$$parserName = parserName;
                return undefined;
            }
            return value;
        });
    }
    function numberFormatterParser(ctrl) {
        ctrl.$parsers.push(function(value) {
            if (ctrl.$isEmpty(value)) return null;
            if (NUMBER_REGEXP.test(value)) return parseFloat(value);
            ctrl.$$parserName = "number";
            return undefined;
        });
        ctrl.$formatters.push(function(value) {
            if (!ctrl.$isEmpty(value)) {
                if (!isNumber(value)) throw ngModelMinErr("numfmt", "Expected `{0}` to be a number", value);
                value = value.toString();
            }
            return value;
        });
    }
    function parseNumberAttrVal(val) {
        if (isDefined(val) && !isNumber(val)) val = parseFloat(val);
        return !isNumberNaN(val) ? val : undefined;
    }
    function isNumberInteger(num) {
        // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
        // (minus the assumption that `num` is a number)
        // eslint-disable-next-line no-bitwise
        return (num | 0) === num;
    }
    function countDecimals(num) {
        var numString = num.toString();
        var decimalSymbolIndex = numString.indexOf(".");
        if (decimalSymbolIndex === -1) {
            if (-1 < num && num < 1) {
                // It may be in the exponential notation format (`1e-X`)
                var match = /e-(\d+)$/.exec(numString);
                if (match) return Number(match[1]);
            }
            return 0;
        }
        return numString.length - decimalSymbolIndex - 1;
    }
    function isValidForStep(viewValue, stepBase, step) {
        // At this point `stepBase` and `step` are expected to be non-NaN values
        // and `viewValue` is expected to be a valid stringified number.
        var value = Number(viewValue);
        var isNonIntegerValue = !isNumberInteger(value);
        var isNonIntegerStepBase = !isNumberInteger(stepBase);
        var isNonIntegerStep = !isNumberInteger(step);
        // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
        // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
        if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
            var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
            var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
            var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
            var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
            var multiplier = Math.pow(10, decimalCount);
            value = value * multiplier;
            stepBase = stepBase * multiplier;
            step = step * multiplier;
            if (isNonIntegerValue) value = Math.round(value);
            if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
            if (isNonIntegerStep) step = Math.round(step);
        }
        return (value - stepBase) % step === 0;
    }
    function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
        badInputChecker(scope, element, attr, ctrl, "number");
        numberFormatterParser(ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        var parsedMinVal;
        if (isDefined(attr.min) || attr.ngMin) {
            var minVal = attr.min || $parse(attr.ngMin)(scope);
            parsedMinVal = parseNumberAttrVal(minVal);
            ctrl.$validators.min = function(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
            };
            attr.$observe("min", function(val) {
                if (val !== minVal) {
                    parsedMinVal = parseNumberAttrVal(val);
                    minVal = val;
                    // TODO(matsko): implement validateLater to reduce number of validations
                    ctrl.$validate();
                }
            });
        }
        if (isDefined(attr.max) || attr.ngMax) {
            var maxVal = attr.max || $parse(attr.ngMax)(scope);
            var parsedMaxVal = parseNumberAttrVal(maxVal);
            ctrl.$validators.max = function(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
            };
            attr.$observe("max", function(val) {
                if (val !== maxVal) {
                    parsedMaxVal = parseNumberAttrVal(val);
                    maxVal = val;
                    // TODO(matsko): implement validateLater to reduce number of validations
                    ctrl.$validate();
                }
            });
        }
        if (isDefined(attr.step) || attr.ngStep) {
            var stepVal = attr.step || $parse(attr.ngStep)(scope);
            var parsedStepVal = parseNumberAttrVal(stepVal);
            ctrl.$validators.step = function(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) || isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
            };
            attr.$observe("step", function(val) {
                // TODO(matsko): implement validateLater to reduce number of validations
                if (val !== stepVal) {
                    parsedStepVal = parseNumberAttrVal(val);
                    stepVal = val;
                    ctrl.$validate();
                }
            });
        }
    }
    function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        badInputChecker(scope, element, attr, ctrl, "range");
        numberFormatterParser(ctrl);
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        var supportsRange = ctrl.$$hasNativeValidators && element[0].type === "range", minVal = supportsRange ? 0 : undefined, maxVal = supportsRange ? 100 : undefined, stepVal = supportsRange ? 1 : undefined, validity = element[0].validity, hasMinAttr = isDefined(attr.min), hasMaxAttr = isDefined(attr.max), hasStepAttr = isDefined(attr.step);
        var originalRender = ctrl.$render;
        ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ? //Browsers that implement range will set these values automatically, but reading the adjusted values after
        //$render would cause the min / max validators to be applied with the wrong value
        function rangeRender() {
            originalRender();
            ctrl.$setViewValue(element.val());
        } : originalRender;
        if (hasMinAttr) {
            minVal = parseNumberAttrVal(attr.min);
            ctrl.$validators.min = supportsRange ? // Since all browsers set the input to a valid value, we don't need to check validity
            function noopMinValidator() {
                return true;
            } : // non-support browsers validate the min val
            function minValidator(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
            };
            setInitialValueAndObserver("min", minChange);
        }
        if (hasMaxAttr) {
            maxVal = parseNumberAttrVal(attr.max);
            ctrl.$validators.max = supportsRange ? // Since all browsers set the input to a valid value, we don't need to check validity
            function noopMaxValidator() {
                return true;
            } : // non-support browsers validate the max val
            function maxValidator(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
            };
            setInitialValueAndObserver("max", maxChange);
        }
        if (hasStepAttr) {
            stepVal = parseNumberAttrVal(attr.step);
            ctrl.$validators.step = supportsRange ? function nativeStepValidator() {
                // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
                // input element value to a valid value). It's possible that other browsers set the stepMismatch
                // validity error instead, so we can at least report an error in that case.
                return !validity.stepMismatch;
            } : // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
            function stepValidator(modelValue, viewValue) {
                return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
            };
            setInitialValueAndObserver("step", stepChange);
        }
        function setInitialValueAndObserver(htmlAttrName, changeFn) {
            // interpolated attributes set the attribute value only after a digest, but we need the
            // attribute value when the input is first rendered, so that the browser can adjust the
            // input value based on the min/max value
            element.attr(htmlAttrName, attr[htmlAttrName]);
            var oldVal = attr[htmlAttrName];
            attr.$observe(htmlAttrName, function wrappedObserver(val) {
                if (val !== oldVal) {
                    oldVal = val;
                    changeFn(val);
                }
            });
        }
        function minChange(val) {
            minVal = parseNumberAttrVal(val);
            // ignore changes before model is initialized
            if (isNumberNaN(ctrl.$modelValue)) return;
            if (supportsRange) {
                var elVal = element.val();
                // IE11 doesn't set the el val correctly if the minVal is greater than the element value
                if (minVal > elVal) {
                    elVal = minVal;
                    element.val(elVal);
                }
                ctrl.$setViewValue(elVal);
            } else // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
        }
        function maxChange(val) {
            maxVal = parseNumberAttrVal(val);
            // ignore changes before model is initialized
            if (isNumberNaN(ctrl.$modelValue)) return;
            if (supportsRange) {
                var elVal = element.val();
                // IE11 doesn't set the el val correctly if the maxVal is less than the element value
                if (maxVal < elVal) {
                    element.val(maxVal);
                    // IE11 and Chrome don't set the value to the minVal when max < min
                    elVal = maxVal < minVal ? minVal : maxVal;
                }
                ctrl.$setViewValue(elVal);
            } else // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
        }
        function stepChange(val) {
            stepVal = parseNumberAttrVal(val);
            // ignore changes before model is initialized
            if (isNumberNaN(ctrl.$modelValue)) return;
            // Some browsers don't adjust the input value correctly, but set the stepMismatch error
            if (!supportsRange) // TODO(matsko): implement validateLater to reduce number of validations
            ctrl.$validate();
            else if (ctrl.$viewValue !== element.val()) ctrl.$setViewValue(element.val());
        }
    }
    function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        // Note: no badInputChecker here by purpose as `url` is only a validation
        // in browsers, i.e. we can always read out input.value even if it is not valid!
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
        ctrl.$validators.url = function(modelValue, viewValue) {
            var value = modelValue || viewValue;
            return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
        };
    }
    function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
        // Note: no badInputChecker here by purpose as `url` is only a validation
        // in browsers, i.e. we can always read out input.value even if it is not valid!
        baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
        stringBasedInputType(ctrl);
        ctrl.$validators.email = function(modelValue, viewValue) {
            var value = modelValue || viewValue;
            return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
        };
    }
    function radioInputType(scope, element, attr, ctrl) {
        var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== "false";
        // make the name unique, if not defined
        if (isUndefined(attr.name)) element.attr("name", nextUid());
        var listener = function(ev) {
            var value;
            if (element[0].checked) {
                value = attr.value;
                if (doTrim) value = trim(value);
                ctrl.$setViewValue(value, ev && ev.type);
            }
        };
        element.on("change", listener);
        ctrl.$render = function() {
            var value = attr.value;
            if (doTrim) value = trim(value);
            element[0].checked = value === ctrl.$viewValue;
        };
        attr.$observe("value", ctrl.$render);
    }
    function parseConstantExpr($parse, context, name, expression, fallback) {
        var parseFn;
        if (isDefined(expression)) {
            parseFn = $parse(expression);
            if (!parseFn.constant) throw ngModelMinErr("constexpr", "Expected constant expression for `{0}`, but saw `{1}`.", name, expression);
            return parseFn(context);
        }
        return fallback;
    }
    function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
        var trueValue = parseConstantExpr($parse, scope, "ngTrueValue", attr.ngTrueValue, true);
        var falseValue = parseConstantExpr($parse, scope, "ngFalseValue", attr.ngFalseValue, false);
        var listener = function(ev) {
            ctrl.$setViewValue(element[0].checked, ev && ev.type);
        };
        element.on("change", listener);
        ctrl.$render = function() {
            element[0].checked = ctrl.$viewValue;
        };
        // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
        // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
        // it to a boolean.
        ctrl.$isEmpty = function(value) {
            return value === false;
        };
        ctrl.$formatters.push(function(value) {
            return equals(value, trueValue);
        });
        ctrl.$parsers.push(function(value) {
            return value ? trueValue : falseValue;
        });
    }
    /**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */ /**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */ var inputDirective = [
        "$browser",
        "$sniffer",
        "$filter",
        "$parse",
        function($browser, $sniffer, $filter, $parse) {
            return {
                restrict: "E",
                require: [
                    "?ngModel"
                ],
                link: {
                    pre: function(scope, element, attr, ctrls) {
                        if (ctrls[0]) (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer, $browser, $filter, $parse);
                    }
                }
            };
        }
    ];
    var hiddenInputBrowserCacheDirective = function() {
        var valueProperty = {
            configurable: true,
            enumerable: false,
            get: function() {
                return this.getAttribute("value") || "";
            },
            set: function(val) {
                this.setAttribute("value", val);
            }
        };
        return {
            restrict: "E",
            priority: 200,
            compile: function(_, attr) {
                if (lowercase(attr.type) !== "hidden") return;
                return {
                    pre: function(scope, element, attr, ctrls) {
                        var node = element[0];
                        // Support: Edge
                        // Moving the DOM around prevents autofillling
                        if (node.parentNode) node.parentNode.insertBefore(node, node.nextSibling);
                        // Support: FF, IE
                        // Avoiding direct assignment to .value prevents autofillling
                        if (Object.defineProperty) Object.defineProperty(node, "value", valueProperty);
                    }
                };
            }
        };
    };
    var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
    /**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */ var ngValueDirective = function() {
        /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */ function updateElementValue(element, attr, value) {
            // Support: IE9 only
            // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
            var propValue = isDefined(value) ? value : msie === 9 ? "" : null;
            element.prop("value", propValue);
            attr.$set("value", value);
        }
        return {
            restrict: "A",
            priority: 100,
            compile: function(tpl, tplAttr) {
                if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) return function ngValueConstantLink(scope, elm, attr) {
                    var value = scope.$eval(attr.ngValue);
                    updateElementValue(elm, attr, value);
                };
                else return function ngValueLink(scope, elm, attr) {
                    scope.$watch(attr.ngValue, function valueWatchAction(value) {
                        updateElementValue(elm, attr, value);
                    });
                };
            }
        };
    };
    /**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */ var ngBindDirective = [
        "$compile",
        function($compile) {
            return {
                restrict: "AC",
                compile: function ngBindCompile(templateElement) {
                    $compile.$$addBindingClass(templateElement);
                    return function ngBindLink(scope, element, attr) {
                        $compile.$$addBindingInfo(element, attr.ngBind);
                        element = element[0];
                        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
                            element.textContent = stringify(value);
                        });
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */ var ngBindTemplateDirective = [
        "$interpolate",
        "$compile",
        function($interpolate, $compile) {
            return {
                compile: function ngBindTemplateCompile(templateElement) {
                    $compile.$$addBindingClass(templateElement);
                    return function ngBindTemplateLink(scope, element, attr) {
                        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
                        $compile.$$addBindingInfo(element, interpolateFn.expressions);
                        element = element[0];
                        attr.$observe("ngBindTemplate", function(value) {
                            element.textContent = isUndefined(value) ? "" : value;
                        });
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */ var ngBindHtmlDirective = [
        "$sce",
        "$parse",
        "$compile",
        function($sce, $parse, $compile) {
            return {
                restrict: "A",
                compile: function ngBindHtmlCompile(tElement, tAttrs) {
                    var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
                    var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
                        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
                        return $sce.valueOf(val);
                    });
                    $compile.$$addBindingClass(tElement);
                    return function ngBindHtmlLink(scope, element, attr) {
                        $compile.$$addBindingInfo(element, attr.ngBindHtml);
                        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
                            // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
                            var value = ngBindHtmlGetter(scope);
                            element.html($sce.getTrustedHtml(value) || "");
                        });
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */ var ngChangeDirective = valueFn({
        restrict: "A",
        require: "ngModel",
        link: function(scope, element, attr, ctrl) {
            ctrl.$viewChangeListeners.push(function() {
                scope.$eval(attr.ngChange);
            });
        }
    });
    /* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/ function classDirective(name, selector) {
        name = "ngClass" + name;
        var indexWatchExpression;
        return [
            "$parse",
            function($parse) {
                return {
                    restrict: "AC",
                    link: function(scope, element, attr) {
                        var classCounts = element.data("$classCounts");
                        var oldModulo = true;
                        var oldClassString;
                        if (!classCounts) {
                            // Use createMap() to prevent class assumptions involving property
                            // names in Object.prototype
                            classCounts = createMap();
                            element.data("$classCounts", classCounts);
                        }
                        if (name !== "ngClass") {
                            if (!indexWatchExpression) indexWatchExpression = $parse("$index", function moduloTwo($index) {
                                // eslint-disable-next-line no-bitwise
                                return $index & 1;
                            });
                            scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
                        }
                        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
                        function addClasses(classString) {
                            classString = digestClassCounts(split(classString), 1);
                            attr.$addClass(classString);
                        }
                        function removeClasses(classString) {
                            classString = digestClassCounts(split(classString), -1);
                            attr.$removeClass(classString);
                        }
                        function updateClasses(oldClassString, newClassString) {
                            var oldClassArray = split(oldClassString);
                            var newClassArray = split(newClassString);
                            var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
                            var toAddArray = arrayDifference(newClassArray, oldClassArray);
                            var toRemoveString = digestClassCounts(toRemoveArray, -1);
                            var toAddString = digestClassCounts(toAddArray, 1);
                            attr.$addClass(toAddString);
                            attr.$removeClass(toRemoveString);
                        }
                        function digestClassCounts(classArray, count) {
                            var classesToUpdate = [];
                            forEach(classArray, function(className) {
                                if (count > 0 || classCounts[className]) {
                                    classCounts[className] = (classCounts[className] || 0) + count;
                                    if (classCounts[className] === +(count > 0)) classesToUpdate.push(className);
                                }
                            });
                            return classesToUpdate.join(" ");
                        }
                        function ngClassIndexWatchAction(newModulo) {
                            // This watch-action should run before the `ngClassWatchAction()`, thus it
                            // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
                            // `ngClassWatchAction()` will update the classes.
                            if (newModulo === selector) addClasses(oldClassString);
                            else removeClasses(oldClassString);
                            oldModulo = newModulo;
                        }
                        function ngClassWatchAction(newClassString) {
                            if (oldModulo === selector) updateClasses(oldClassString, newClassString);
                            oldClassString = newClassString;
                        }
                    }
                };
            }
        ];
        // Helpers
        function arrayDifference(tokens1, tokens2) {
            if (!tokens1 || !tokens1.length) return [];
            if (!tokens2 || !tokens2.length) return tokens1;
            var values = [];
            outer: for(var i = 0; i < tokens1.length; i++){
                var token = tokens1[i];
                for(var j = 0; j < tokens2.length; j++){
                    if (token === tokens2[j]) continue outer;
                }
                values.push(token);
            }
            return values;
        }
        function split(classString) {
            return classString && classString.split(" ");
        }
        function toClassString(classValue) {
            if (!classValue) return classValue;
            var classString = classValue;
            if (isArray(classValue)) classString = classValue.map(toClassString).join(" ");
            else if (isObject(classValue)) classString = Object.keys(classValue).filter(function(key) {
                return classValue[key];
            }).join(" ");
            else if (!isString(classValue)) classString = classValue + "";
            return classString;
        }
    }
    /**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */ var ngClassDirective = classDirective("", true);
    /**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */ var ngClassOddDirective = classDirective("Odd", 0);
    /**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */ var ngClassEvenDirective = classDirective("Even", 1);
    /**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */ var ngCloakDirective = ngDirective({
        compile: function(element, attr) {
            attr.$set("ngCloak", undefined);
            element.removeClass("ng-cloak");
        }
    });
    /**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */ var ngControllerDirective = [
        function() {
            return {
                restrict: "A",
                scope: true,
                controller: "@",
                priority: 500
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */ // `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
    // we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
    // fn that looks for the `ng-csp` attribute anywhere in the current doc.
    /**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */ /*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */ var ngEventDirectives = {};
    // For events that might fire synchronously during DOM manipulation
    // we need to execute their event handlers asynchronously using $evalAsync,
    // so that they are not executed in an inconsistent state.
    var forceAsyncEvents = {
        "blur": true,
        "focus": true
    };
    forEach("click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "), function(eventName) {
        var directiveName = directiveNormalize("ng-" + eventName);
        ngEventDirectives[directiveName] = [
            "$parse",
            "$rootScope",
            "$exceptionHandler",
            function($parse, $rootScope, $exceptionHandler) {
                return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
            }
        ];
    });
    function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
        return {
            restrict: "A",
            compile: function($element, attr) {
                // NOTE:
                // We expose the powerful `$event` object on the scope that provides access to the Window,
                // etc. This is OK, because expressions are not sandboxed any more (and the expression
                // sandbox was never meant to be a security feature anyway).
                var fn = $parse(attr[directiveName]);
                return function ngEventHandler(scope, element) {
                    element.on(eventName, function(event) {
                        var callback = function() {
                            fn(scope, {
                                $event: event
                            });
                        };
                        if (!$rootScope.$$phase) scope.$apply(callback);
                        else if (forceAsync) scope.$evalAsync(callback);
                        else try {
                            callback();
                        } catch (error) {
                            $exceptionHandler(error);
                        }
                    });
                };
            }
        };
    }
    /**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */ /**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */ /**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */ /**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */ var ngIfDirective = [
        "$animate",
        "$compile",
        function($animate, $compile) {
            return {
                multiElement: true,
                transclude: "element",
                priority: 600,
                terminal: true,
                restrict: "A",
                $$tlb: true,
                link: function($scope, $element, $attr, ctrl, $transclude) {
                    var block, childScope, previousElements;
                    $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
                        if (value) {
                            if (!childScope) $transclude(function(clone, newScope) {
                                childScope = newScope;
                                clone[clone.length++] = $compile.$$createComment("end ngIf", $attr.ngIf);
                                // Note: We only need the first/last node of the cloned nodes.
                                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                                // by a directive with templateUrl when its template arrives.
                                block = {
                                    clone: clone
                                };
                                $animate.enter(clone, $element.parent(), $element);
                            });
                        } else {
                            if (previousElements) {
                                previousElements.remove();
                                previousElements = null;
                            }
                            if (childScope) {
                                childScope.$destroy();
                                childScope = null;
                            }
                            if (block) {
                                previousElements = getBlockNodes(block.clone);
                                $animate.leave(previousElements).done(function(response) {
                                    if (response !== false) previousElements = null;
                                });
                                block = null;
                            }
                        }
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */ /**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */ /**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */ /**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */ var ngIncludeDirective = [
        "$templateRequest",
        "$anchorScroll",
        "$animate",
        function($templateRequest, $anchorScroll, $animate) {
            return {
                restrict: "ECA",
                priority: 400,
                terminal: true,
                transclude: "element",
                controller: angular.noop,
                compile: function(element, attr) {
                    var srcExp = attr.ngInclude || attr.src, onloadExp = attr.onload || "", autoScrollExp = attr.autoscroll;
                    return function(scope, $element, $attr, ctrl, $transclude) {
                        var changeCounter = 0, currentScope, previousElement, currentElement;
                        var cleanupLastIncludeContent = function() {
                            if (previousElement) {
                                previousElement.remove();
                                previousElement = null;
                            }
                            if (currentScope) {
                                currentScope.$destroy();
                                currentScope = null;
                            }
                            if (currentElement) {
                                $animate.leave(currentElement).done(function(response) {
                                    if (response !== false) previousElement = null;
                                });
                                previousElement = currentElement;
                                currentElement = null;
                            }
                        };
                        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
                            var afterAnimation = function(response) {
                                if (response !== false && isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) $anchorScroll();
                            };
                            var thisChangeId = ++changeCounter;
                            if (src) {
                                //set the 2nd param to true to ignore the template request error so that the inner
                                //contents and scope can be cleaned up.
                                $templateRequest(src, true).then(function(response) {
                                    if (scope.$$destroyed) return;
                                    if (thisChangeId !== changeCounter) return;
                                    var newScope = scope.$new();
                                    ctrl.template = response;
                                    // Note: This will also link all children of ng-include that were contained in the original
                                    // html. If that content contains controllers, ... they could pollute/change the scope.
                                    // However, using ng-include on an element with additional content does not make sense...
                                    // Note: We can't remove them in the cloneAttchFn of $transclude as that
                                    // function is called before linking the content, which would apply child
                                    // directives to non existing elements.
                                    var clone = $transclude(newScope, function(clone) {
                                        cleanupLastIncludeContent();
                                        $animate.enter(clone, null, $element).done(afterAnimation);
                                    });
                                    currentScope = newScope;
                                    currentElement = clone;
                                    currentScope.$emit("$includeContentLoaded", src);
                                    scope.$eval(onloadExp);
                                }, function() {
                                    if (scope.$$destroyed) return;
                                    if (thisChangeId === changeCounter) {
                                        cleanupLastIncludeContent();
                                        scope.$emit("$includeContentError", src);
                                    }
                                });
                                scope.$emit("$includeContentRequested", src);
                            } else {
                                cleanupLastIncludeContent();
                                ctrl.template = null;
                            }
                        });
                    };
                }
            };
        }
    ];
    // This directive is called during the $transclude call of the first `ngInclude` directive.
    // It will replace and compile the content of the element with the loaded template.
    // We need this directive so that the element content is already filled when
    // the link function of another directive on the same element as ngInclude
    // is called.
    var ngIncludeFillContentDirective = [
        "$compile",
        function($compile) {
            return {
                restrict: "ECA",
                priority: -400,
                require: "ngInclude",
                link: function(scope, $element, $attr, ctrl) {
                    if (toString.call($element[0]).match(/SVG/)) {
                        // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
                        // support innerHTML, so detect this here and try to generate the contents
                        // specially.
                        $element.empty();
                        $compile(jqLiteBuildFragment(ctrl.template, window1.document).childNodes)(scope, function namespaceAdaptedClone(clone) {
                            $element.append(clone);
                        }, {
                            futureParentElement: $element
                        });
                        return;
                    }
                    $element.html(ctrl.template);
                    $compile($element.contents())(scope);
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */ var ngInitDirective = ngDirective({
        priority: 450,
        compile: function() {
            return {
                pre: function(scope, element, attrs) {
                    scope.$eval(attrs.ngInit);
                }
            };
        }
    });
    /**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */ var ngListDirective = function() {
        return {
            restrict: "A",
            priority: 100,
            require: "ngModel",
            link: function(scope, element, attr, ctrl) {
                var ngList = attr.ngList || ", ";
                var trimValues = attr.ngTrim !== "false";
                var separator = trimValues ? trim(ngList) : ngList;
                var parse = function(viewValue) {
                    // If the viewValue is invalid (say required but empty) it will be `undefined`
                    if (isUndefined(viewValue)) return;
                    var list = [];
                    if (viewValue) forEach(viewValue.split(separator), function(value) {
                        if (value) list.push(trimValues ? trim(value) : value);
                    });
                    return list;
                };
                ctrl.$parsers.push(parse);
                ctrl.$formatters.push(function(value) {
                    if (isArray(value)) return value.join(ngList);
                    return undefined;
                });
                // Override the standard $isEmpty because an empty array means the input is empty.
                ctrl.$isEmpty = function(value) {
                    return !value || !value.length;
                };
            }
        };
    };
    /* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/ var VALID_CLASS = "ng-valid", INVALID_CLASS = "ng-invalid", PRISTINE_CLASS = "ng-pristine", DIRTY_CLASS = "ng-dirty", UNTOUCHED_CLASS = "ng-untouched", TOUCHED_CLASS = "ng-touched", EMPTY_CLASS = "ng-empty", NOT_EMPTY_CLASS = "ng-not-empty";
    var ngModelMinErr = minErr("ngModel");
    /**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */ NgModelController.$inject = [
        "$scope",
        "$exceptionHandler",
        "$attrs",
        "$element",
        "$parse",
        "$animate",
        "$timeout",
        "$q",
        "$interpolate"
    ];
    function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
        this.$viewValue = Number.NaN;
        this.$modelValue = Number.NaN;
        this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
        this.$validators = {};
        this.$asyncValidators = {};
        this.$parsers = [];
        this.$formatters = [];
        this.$viewChangeListeners = [];
        this.$untouched = true;
        this.$touched = false;
        this.$pristine = true;
        this.$dirty = false;
        this.$valid = true;
        this.$invalid = false;
        this.$error = {}; // keep invalid keys here
        this.$$success = {}; // keep valid keys here
        this.$pending = undefined; // keep pending keys here
        this.$name = $interpolate($attr.name || "", false)($scope);
        this.$$parentForm = nullFormCtrl;
        this.$options = defaultModelOptions;
        this.$$updateEvents = "";
        // Attach the correct context to the event handler function for updateOn
        this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
        this.$$parsedNgModel = $parse($attr.ngModel);
        this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
        this.$$ngModelGet = this.$$parsedNgModel;
        this.$$ngModelSet = this.$$parsedNgModelAssign;
        this.$$pendingDebounce = null;
        this.$$parserValid = undefined;
        this.$$parserName = "parse";
        this.$$currentValidationRunId = 0;
        this.$$scope = $scope;
        this.$$rootScope = $scope.$root;
        this.$$attr = $attr;
        this.$$element = $element;
        this.$$animate = $animate;
        this.$$timeout = $timeout;
        this.$$parse = $parse;
        this.$$q = $q;
        this.$$exceptionHandler = $exceptionHandler;
        setupValidity(this);
        setupModelWatcher(this);
    }
    NgModelController.prototype = {
        $$initGetterSetters: function() {
            if (this.$options.getOption("getterSetter")) {
                var invokeModelGetter = this.$$parse(this.$$attr.ngModel + "()"), invokeModelSetter = this.$$parse(this.$$attr.ngModel + "($$$p)");
                this.$$ngModelGet = function($scope) {
                    var modelValue = this.$$parsedNgModel($scope);
                    if (isFunction(modelValue)) modelValue = invokeModelGetter($scope);
                    return modelValue;
                };
                this.$$ngModelSet = function($scope, newValue) {
                    if (isFunction(this.$$parsedNgModel($scope))) invokeModelSetter($scope, {
                        $$$p: newValue
                    });
                    else this.$$parsedNgModelAssign($scope, newValue);
                };
            } else if (!this.$$parsedNgModel.assign) throw ngModelMinErr("nonassign", "Expression '{0}' is non-assignable. Element: {1}", this.$$attr.ngModel, startingTag(this.$$element));
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */ $render: noop,
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */ $isEmpty: function(value) {
            // eslint-disable-next-line no-self-compare
            return isUndefined(value) || value === "" || value === null || value !== value;
        },
        $$updateEmptyClasses: function(value) {
            if (this.$isEmpty(value)) {
                this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
                this.$$animate.addClass(this.$$element, EMPTY_CLASS);
            } else {
                this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
                this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
            }
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */ $setPristine: function() {
            this.$dirty = false;
            this.$pristine = true;
            this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
            this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */ $setDirty: function() {
            this.$dirty = true;
            this.$pristine = false;
            this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
            this.$$animate.addClass(this.$$element, DIRTY_CLASS);
            this.$$parentForm.$setDirty();
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */ $setUntouched: function() {
            this.$touched = false;
            this.$untouched = true;
            this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */ $setTouched: function() {
            this.$touched = true;
            this.$untouched = false;
            this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */ $rollbackViewValue: function() {
            this.$$timeout.cancel(this.$$pendingDebounce);
            this.$viewValue = this.$$lastCommittedViewValue;
            this.$render();
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */ $validate: function() {
            // ignore $validate before model is initialized
            if (isNumberNaN(this.$modelValue)) return;
            var viewValue = this.$$lastCommittedViewValue;
            // Note: we use the $$rawModelValue as $modelValue might have been
            // set to undefined during a view -> model update that found validation
            // errors. We can't parse the view here, since that could change
            // the model although neither viewValue nor the model on the scope changed
            var modelValue = this.$$rawModelValue;
            var prevValid = this.$valid;
            var prevModelValue = this.$modelValue;
            var allowInvalid = this.$options.getOption("allowInvalid");
            var that = this;
            this.$$runValidators(modelValue, viewValue, function(allValid) {
                // If there was no change in validity, don't update the model
                // This prevents changing an invalid modelValue to undefined
                if (!allowInvalid && prevValid !== allValid) {
                    // Note: Don't check this.$valid here, as we could have
                    // external validators (e.g. calculated on the server),
                    // that just call $setValidity and need the model value
                    // to calculate their validity.
                    that.$modelValue = allValid ? modelValue : undefined;
                    if (that.$modelValue !== prevModelValue) that.$$writeModelToScope();
                }
            });
        },
        $$runValidators: function(modelValue, viewValue, doneCallback) {
            this.$$currentValidationRunId++;
            var localValidationRunId = this.$$currentValidationRunId;
            var that = this;
            // check parser error
            if (!processParseErrors()) {
                validationDone(false);
                return;
            }
            if (!processSyncValidators()) {
                validationDone(false);
                return;
            }
            processAsyncValidators();
            function processParseErrors() {
                var errorKey = that.$$parserName;
                if (isUndefined(that.$$parserValid)) setValidity(errorKey, null);
                else {
                    if (!that.$$parserValid) {
                        forEach(that.$validators, function(v, name) {
                            setValidity(name, null);
                        });
                        forEach(that.$asyncValidators, function(v, name) {
                            setValidity(name, null);
                        });
                    }
                    // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
                    setValidity(errorKey, that.$$parserValid);
                    return that.$$parserValid;
                }
                return true;
            }
            function processSyncValidators() {
                var syncValidatorsValid = true;
                forEach(that.$validators, function(validator, name) {
                    var result = Boolean(validator(modelValue, viewValue));
                    syncValidatorsValid = syncValidatorsValid && result;
                    setValidity(name, result);
                });
                if (!syncValidatorsValid) {
                    forEach(that.$asyncValidators, function(v, name) {
                        setValidity(name, null);
                    });
                    return false;
                }
                return true;
            }
            function processAsyncValidators() {
                var validatorPromises = [];
                var allValid = true;
                forEach(that.$asyncValidators, function(validator, name) {
                    var promise = validator(modelValue, viewValue);
                    if (!isPromiseLike(promise)) throw ngModelMinErr("nopromise", "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
                    setValidity(name, undefined);
                    validatorPromises.push(promise.then(function() {
                        setValidity(name, true);
                    }, function() {
                        allValid = false;
                        setValidity(name, false);
                    }));
                });
                if (!validatorPromises.length) validationDone(true);
                else that.$$q.all(validatorPromises).then(function() {
                    validationDone(allValid);
                }, noop);
            }
            function setValidity(name, isValid) {
                if (localValidationRunId === that.$$currentValidationRunId) that.$setValidity(name, isValid);
            }
            function validationDone(allValid) {
                if (localValidationRunId === that.$$currentValidationRunId) doneCallback(allValid);
            }
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */ $commitViewValue: function() {
            var viewValue = this.$viewValue;
            this.$$timeout.cancel(this.$$pendingDebounce);
            // If the view value has not changed then we should just exit, except in the case where there is
            // a native validator on the element. In this case the validation state may have changed even though
            // the viewValue has stayed empty.
            if (this.$$lastCommittedViewValue === viewValue && (viewValue !== "" || !this.$$hasNativeValidators)) return;
            this.$$updateEmptyClasses(viewValue);
            this.$$lastCommittedViewValue = viewValue;
            // change to dirty
            if (this.$pristine) this.$setDirty();
            this.$$parseAndValidate();
        },
        $$parseAndValidate: function() {
            var viewValue = this.$$lastCommittedViewValue;
            var modelValue = viewValue;
            var that = this;
            this.$$parserValid = isUndefined(modelValue) ? undefined : true;
            // Reset any previous parse error
            this.$setValidity(this.$$parserName, null);
            this.$$parserName = "parse";
            if (this.$$parserValid) for(var i = 0; i < this.$parsers.length; i++){
                modelValue = this.$parsers[i](modelValue);
                if (isUndefined(modelValue)) {
                    this.$$parserValid = false;
                    break;
                }
            }
            if (isNumberNaN(this.$modelValue)) // this.$modelValue has not been touched yet...
            this.$modelValue = this.$$ngModelGet(this.$$scope);
            var prevModelValue = this.$modelValue;
            var allowInvalid = this.$options.getOption("allowInvalid");
            this.$$rawModelValue = modelValue;
            if (allowInvalid) {
                this.$modelValue = modelValue;
                writeToModelIfNeeded();
            }
            // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
            // This can happen if e.g. $setViewValue is called from inside a parser
            this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
                if (!allowInvalid) {
                    // Note: Don't check this.$valid here, as we could have
                    // external validators (e.g. calculated on the server),
                    // that just call $setValidity and need the model value
                    // to calculate their validity.
                    that.$modelValue = allValid ? modelValue : undefined;
                    writeToModelIfNeeded();
                }
            });
            function writeToModelIfNeeded() {
                if (that.$modelValue !== prevModelValue) that.$$writeModelToScope();
            }
        },
        $$writeModelToScope: function() {
            this.$$ngModelSet(this.$$scope, this.$modelValue);
            forEach(this.$viewChangeListeners, function(listener) {
                try {
                    listener();
                } catch (e) {
                    // eslint-disable-next-line no-invalid-this
                    this.$$exceptionHandler(e);
                }
            }, this);
        },
        /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */ $setViewValue: function(value, trigger) {
            this.$viewValue = value;
            if (this.$options.getOption("updateOnDefault")) this.$$debounceViewValueCommit(trigger);
        },
        $$debounceViewValueCommit: function(trigger) {
            var debounceDelay = this.$options.getOption("debounce");
            if (isNumber(debounceDelay[trigger])) debounceDelay = debounceDelay[trigger];
            else if (isNumber(debounceDelay["default"]) && this.$options.getOption("updateOn").indexOf(trigger) === -1) debounceDelay = debounceDelay["default"];
            else if (isNumber(debounceDelay["*"])) debounceDelay = debounceDelay["*"];
            this.$$timeout.cancel(this.$$pendingDebounce);
            var that = this;
            if (debounceDelay > 0) this.$$pendingDebounce = this.$$timeout(function() {
                that.$commitViewValue();
            }, debounceDelay);
            else if (this.$$rootScope.$$phase) this.$commitViewValue();
            else this.$$scope.$apply(function() {
                that.$commitViewValue();
            });
        },
        /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */ $overrideModelOptions: function(options) {
            this.$options = this.$options.createChild(options);
            this.$$setUpdateOnEvents();
        },
        /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */ $processModelValue: function() {
            var viewValue = this.$$format();
            if (this.$viewValue !== viewValue) {
                this.$$updateEmptyClasses(viewValue);
                this.$viewValue = this.$$lastCommittedViewValue = viewValue;
                this.$render();
                // It is possible that model and view value have been updated during render
                this.$$runValidators(this.$modelValue, this.$viewValue, noop);
            }
        },
        /**
   * This method is called internally to run the $formatters on the $modelValue
   */ $$format: function() {
            var formatters = this.$formatters, idx = formatters.length;
            var viewValue = this.$modelValue;
            while(idx--)viewValue = formatters[idx](viewValue);
            return viewValue;
        },
        /**
   * This method is called internally when the bound scope value changes.
   */ $$setModelValue: function(modelValue) {
            this.$modelValue = this.$$rawModelValue = modelValue;
            this.$$parserValid = undefined;
            this.$processModelValue();
        },
        $$setUpdateOnEvents: function() {
            if (this.$$updateEvents) this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
            this.$$updateEvents = this.$options.getOption("updateOn");
            if (this.$$updateEvents) this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
        },
        $$updateEventHandler: function(ev) {
            this.$$debounceViewValueCommit(ev && ev.type);
        }
    };
    function setupModelWatcher(ctrl) {
        // model -> value
        // Note: we cannot use a normal scope.$watch as we want to detect the following:
        // 1. scope value is 'a'
        // 2. user enters 'b'
        // 3. ng-change kicks in and reverts scope value to 'a'
        //    -> scope value did not change since the last digest as
        //       ng-change executes in apply phase
        // 4. view should be changed back to 'a'
        ctrl.$$scope.$watch(function ngModelWatch(scope) {
            var modelValue = ctrl.$$ngModelGet(scope);
            // if scope model value and ngModel value are out of sync
            // This cannot be moved to the action function, because it would not catch the
            // case where the model is changed in the ngChange function or the model setter
            if (modelValue !== ctrl.$modelValue && // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
            // eslint-disable-next-line no-self-compare
            (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)) ctrl.$$setModelValue(modelValue);
            return modelValue;
        });
    }
    /**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */ addSetValidityMethod({
        clazz: NgModelController,
        set: function(object, property) {
            object[property] = true;
        },
        unset: function(object, property) {
            delete object[property];
        }
    });
    /**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */ var ngModelDirective = [
        "$rootScope",
        function($rootScope) {
            return {
                restrict: "A",
                require: [
                    "ngModel",
                    "^?form",
                    "^?ngModelOptions"
                ],
                controller: NgModelController,
                // Prelink needs to run before any input directive
                // so that we can set the NgModelOptions in NgModelController
                // before anyone else uses it.
                priority: 1,
                compile: function ngModelCompile(element) {
                    // Setup initial state of the control
                    element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
                    return {
                        pre: function ngModelPreLink(scope, element, attr, ctrls) {
                            var modelCtrl = ctrls[0], formCtrl = ctrls[1] || modelCtrl.$$parentForm, optionsCtrl = ctrls[2];
                            if (optionsCtrl) modelCtrl.$options = optionsCtrl.$options;
                            modelCtrl.$$initGetterSetters();
                            // notify others, especially parent forms
                            formCtrl.$addControl(modelCtrl);
                            attr.$observe("name", function(newValue) {
                                if (modelCtrl.$name !== newValue) modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
                            });
                            scope.$on("$destroy", function() {
                                modelCtrl.$$parentForm.$removeControl(modelCtrl);
                            });
                        },
                        post: function ngModelPostLink(scope, element, attr, ctrls) {
                            var modelCtrl = ctrls[0];
                            modelCtrl.$$setUpdateOnEvents();
                            function setTouched() {
                                modelCtrl.$setTouched();
                            }
                            element.on("blur", function() {
                                if (modelCtrl.$touched) return;
                                if ($rootScope.$$phase) scope.$evalAsync(setTouched);
                                else scope.$apply(setTouched);
                            });
                        }
                    };
                }
            };
        }
    ];
    /* exported defaultModelOptions */ var defaultModelOptions;
    var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
    /**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */ function ModelOptions(options) {
        this.$$options = options;
    }
    ModelOptions.prototype = {
        /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */ getOption: function(name) {
            return this.$$options[name];
        },
        /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */ createChild: function(options) {
            var inheritAll = false;
            // make a shallow copy
            options = extend({}, options);
            // Inherit options from the parent if specified by the value `"$inherit"`
            forEach(options, /** @this */ function(option, key) {
                if (option === "$inherit") {
                    if (key === "*") inheritAll = true;
                    else {
                        options[key] = this.$$options[key];
                        // `updateOn` is special so we must also inherit the `updateOnDefault` option
                        if (key === "updateOn") options.updateOnDefault = this.$$options.updateOnDefault;
                    }
                } else if (key === "updateOn") {
                    // If the `updateOn` property contains the `default` event then we have to remove
                    // it from the event list and set the `updateOnDefault` flag.
                    options.updateOnDefault = false;
                    options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
                        options.updateOnDefault = true;
                        return " ";
                    }));
                }
            }, this);
            if (inheritAll) {
                // We have a property of the form: `"*": "$inherit"`
                delete options["*"];
                defaults(options, this.$$options);
            }
            // Finally add in any missing defaults
            defaults(options, defaultModelOptions.$$options);
            return new ModelOptions(options);
        }
    };
    defaultModelOptions = new ModelOptions({
        updateOn: "",
        updateOnDefault: true,
        debounce: 0,
        getterSetter: false,
        allowInvalid: false,
        timezone: null
    });
    /**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ### Default events, extra triggers, and catch-all debounce values
 *
 * This example shows the relationship between "default" update events and
 * additional `updateOn` triggers.
 *
 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
 * in `updateOn` is considered a "default" event, since different control types have different
 * default events.
 *
 * The control in this example updates by "default", "click", and "blur", with different `debounce`
 * values. You can see that "click" doesn't have an individual `debounce` value -
 * therefore it uses the `*` debounce value.
 *
 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
 * it is considered a "default" event and will update the
 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
 *
 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
 *
  <example name="ngModelOptions-advanced" module="optionsExample">
    <file name="index.html">
       <model-update-demo></model-update-demo>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .component('modelUpdateDemo', {
          templateUrl: 'template.html',
          controller: function() {
            this.name = 'Chinua';

            this.options = {
              updateOn: 'default blur click',
              debounce: {
                default: 2000,
                blur: 0,
                '*': 1000
              }
            };

            this.updateEvents = function() {
              var eventList = this.options.updateOn.split(' ');
              eventList.push('*');
              var events = {};

              for (var i = 0; i < eventList.length; i++) {
                events[eventList[i]] = this.options.debounce[eventList[i]];
              }

              this.events = events;
            };

            this.updateOptions = function() {
              var options = angular.extend(this.options, {
                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                debounce: this.events
              });

              this.form.input.$overrideModelOptions(options);
            };

            // Initialize the event form
            this.updateEvents();
          }
        });
    </file>
    <file name="template.html">
      <form name="$ctrl.form">
        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
      </form>
      Model: <tt>{{$ctrl.name}}</tt>
      <hr>
      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>

      <hr>
      <form ng-submit="$ctrl.updateOptions()">
        <b>updateOn</b><br>
        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">

        <table>
          <tr>
            <th>Option</th>
            <th>Debounce value</th>
          </tr>
          <tr ng-repeat="(key, value) in $ctrl.events">
            <td>{{key}}</td>
            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
          </tr>
        </table>

        <br>
        <input type="submit" value="Update options">
      </form>
    </file>
  </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 * See also the example for
 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
 * Default events, extra triggers, and catch-all debounce values}.
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Formatting the value of `time` and `datetime-local`
 *
 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
 * that is displayed in the control. Note that browsers may apply their own formatting
 * in the user interface.
 *
   <example name="ngModelOptions-time-format" module="timeExample">
     <file name="index.html">
       <time-example></time-example>
     </file>
     <file name="script.js">
        angular.module('timeExample', [])
          .component('timeExample', {
            templateUrl: 'timeExample.html',
            controller: function() {
              this.time = new Date(1970, 0, 1, 14, 57, 0);

              this.options = {
                timeSecondsFormat: 'ss',
                timeStripZeroSeconds: true
              };

              this.optionChange = function() {
                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                this.time = new Date(this.time);
              };
            }
          });
     </file>
     <file name="timeExample.html">
       <form name="$ctrl.timeForm">
         <strong>Default</strong>:
         <input type="time" ng-model="$ctrl.time" step="any" /><br>
         <strong>With options</strong>:
         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
         <br>

         Options:<br>
         <code>timeSecondsFormat</code>:
         <input
           type="text"
           ng-model="$ctrl.options.timeSecondsFormat"
           ng-change="$ctrl.optionChange()">
         <br>
         <code>timeStripZeroSeconds</code>:
         <input
           type="checkbox"
           ng-model="$ctrl.options.timeStripZeroSeconds"
           ng-change="$ctrl.optionChange()">
        </form>
      </file>
 *  </example>
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents.
 *
 * **General options**:
 *
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *     You can use the `*` key to specify a debounce value that applies to all events that are not
 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur mouseup',
 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *
 *
 *  **Input-type specific options**:
 *
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
 *     milliseconds. The option follows the format string of {@link date date filter}.
 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
 *     seconds and milliseconds.
 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
 *     part of the time string, and may show the value differently in the user interface.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
 *     after `timeSecondsFormat`.
 *     This option can be used to make the formatting consistent over different browsers, as some
 *     browsers with support for `time` will natively hide the milliseconds and
 *     seconds if they are zero, but others won't, and browsers that don't implement these input
 *     types will always show the full string.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 */ var ngModelOptionsDirective = function() {
        NgModelOptionsController.$inject = [
            "$attrs",
            "$scope"
        ];
        function NgModelOptionsController($attrs, $scope) {
            this.$$attrs = $attrs;
            this.$$scope = $scope;
        }
        NgModelOptionsController.prototype = {
            $onInit: function() {
                var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
                var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
                this.$options = parentOptions.createChild(modelOptionsDefinition);
            }
        };
        return {
            restrict: "A",
            // ngModelOptions needs to run before ngModel and input directives
            priority: 10,
            require: {
                parentCtrl: "?^^ngModelOptions"
            },
            bindToController: true,
            controller: NgModelOptionsController
        };
    };
    // shallow copy over values from `src` that are not already specified on `dst`
    function defaults(dst, src) {
        forEach(src, function(value, key) {
            if (!isDefined(dst[key])) dst[key] = value;
        });
    }
    /**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */ var ngNonBindableDirective = ngDirective({
        terminal: true,
        priority: 1000
    });
    /* exported ngOptionsDirective */ /* global jqLiteRemove */ var ngOptionsMinErr = minErr("ngOptions");
    /**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */ /* eslint-disable max-len */ //                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
    var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
    // 1: value expression (valueFn)
    // 2: label expression (displayFn)
    // 3: group by expression (groupByFn)
    // 4: disable when expression (disableWhenFn)
    // 5: array item variable name
    // 6: object item key variable name
    // 7: object item value variable name
    // 8: collection expression
    // 9: track by expression
    /* eslint-enable */ var ngOptionsDirective = [
        "$compile",
        "$document",
        "$parse",
        function($compile, $document, $parse) {
            function parseOptionsExpression(optionsExp, selectElement, scope) {
                var match = optionsExp.match(NG_OPTIONS_REGEXP);
                if (!match) throw ngOptionsMinErr("iexp", "Expected expression in form of '_select_ (as _label_)? for (_key_,)?_value_ in _collection_' but got '{0}'. Element: {1}", optionsExp, startingTag(selectElement));
                // Extract the parts from the ngOptions expression
                // The variable name for the value of the item in the collection
                var valueName = match[5] || match[7];
                // The variable name for the key of the item in the collection
                var keyName = match[6];
                // An expression that generates the viewValue for an option if there is a label expression
                var selectAs = / as /.test(match[0]) && match[1];
                // An expression that is used to track the id of each object in the options collection
                var trackBy = match[9];
                // An expression that generates the viewValue for an option if there is no label expression
                var valueFn = $parse(match[2] ? match[1] : valueName);
                var selectAsFn = selectAs && $parse(selectAs);
                var viewValueFn = selectAsFn || valueFn;
                var trackByFn = trackBy && $parse(trackBy);
                // Get the value by which we are going to track the option
                // if we have a trackFn then use that (passing scope and locals)
                // otherwise just hash the given viewValue
                var getTrackByValueFn = trackBy ? function(value, locals) {
                    return trackByFn(scope, locals);
                } : function getHashOfValue(value) {
                    return hashKey(value);
                };
                var getTrackByValue = function(value, key) {
                    return getTrackByValueFn(value, getLocals(value, key));
                };
                var displayFn = $parse(match[2] || match[1]);
                var groupByFn = $parse(match[3] || "");
                var disableWhenFn = $parse(match[4] || "");
                var valuesFn = $parse(match[8]);
                var locals = {};
                var getLocals = keyName ? function(value, key) {
                    locals[keyName] = key;
                    locals[valueName] = value;
                    return locals;
                } : function(value) {
                    locals[valueName] = value;
                    return locals;
                };
                function Option(selectValue, viewValue, label, group, disabled) {
                    this.selectValue = selectValue;
                    this.viewValue = viewValue;
                    this.label = label;
                    this.group = group;
                    this.disabled = disabled;
                }
                function getOptionValuesKeys(optionValues) {
                    var optionValuesKeys;
                    if (!keyName && isArrayLike(optionValues)) optionValuesKeys = optionValues;
                    else {
                        // if object, extract keys, in enumeration order, unsorted
                        optionValuesKeys = [];
                        for(var itemKey in optionValues)if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== "$") optionValuesKeys.push(itemKey);
                    }
                    return optionValuesKeys;
                }
                return {
                    trackBy: trackBy,
                    getTrackByValue: getTrackByValue,
                    getWatchables: $parse(valuesFn, function(optionValues) {
                        // Create a collection of things that we would like to watch (watchedArray)
                        // so that they can all be watched using a single $watchCollection
                        // that only runs the handler once if anything changes
                        var watchedArray = [];
                        optionValues = optionValues || [];
                        var optionValuesKeys = getOptionValuesKeys(optionValues);
                        var optionValuesLength = optionValuesKeys.length;
                        for(var index = 0; index < optionValuesLength; index++){
                            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
                            var value = optionValues[key];
                            var locals = getLocals(value, key);
                            var selectValue = getTrackByValueFn(value, locals);
                            watchedArray.push(selectValue);
                            // Only need to watch the displayFn if there is a specific label expression
                            if (match[2] || match[1]) {
                                var label = displayFn(scope, locals);
                                watchedArray.push(label);
                            }
                            // Only need to watch the disableWhenFn if there is a specific disable expression
                            if (match[4]) {
                                var disableWhen = disableWhenFn(scope, locals);
                                watchedArray.push(disableWhen);
                            }
                        }
                        return watchedArray;
                    }),
                    getOptions: function() {
                        var optionItems = [];
                        var selectValueMap = {};
                        // The option values were already computed in the `getWatchables` fn,
                        // which must have been called to trigger `getOptions`
                        var optionValues = valuesFn(scope) || [];
                        var optionValuesKeys = getOptionValuesKeys(optionValues);
                        var optionValuesLength = optionValuesKeys.length;
                        for(var index = 0; index < optionValuesLength; index++){
                            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
                            var value = optionValues[key];
                            var locals = getLocals(value, key);
                            var viewValue = viewValueFn(scope, locals);
                            var selectValue = getTrackByValueFn(viewValue, locals);
                            var label = displayFn(scope, locals);
                            var group = groupByFn(scope, locals);
                            var disabled = disableWhenFn(scope, locals);
                            var optionItem = new Option(selectValue, viewValue, label, group, disabled);
                            optionItems.push(optionItem);
                            selectValueMap[selectValue] = optionItem;
                        }
                        return {
                            items: optionItems,
                            selectValueMap: selectValueMap,
                            getOptionFromViewValue: function(value) {
                                return selectValueMap[getTrackByValue(value)];
                            },
                            getViewValueFromOption: function(option) {
                                // If the viewValue could be an object that may be mutated by the application,
                                // we need to make a copy and not return the reference to the value on the option.
                                return trackBy ? copy(option.viewValue) : option.viewValue;
                            }
                        };
                    }
                };
            }
            // Support: IE 9 only
            // We can't just jqLite('<option>') since jqLite is not smart enough
            // to create it in <select> and IE barfs otherwise.
            var optionTemplate = window1.document.createElement("option"), optGroupTemplate = window1.document.createElement("optgroup");
            function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
                var selectCtrl = ctrls[0];
                var ngModelCtrl = ctrls[1];
                var multiple = attr.multiple;
                // The emptyOption allows the application developer to provide their own custom "empty"
                // option when the viewValue does not match any of the option values.
                for(var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++)if (children[i].value === "") {
                    selectCtrl.hasEmptyOption = true;
                    selectCtrl.emptyOption = children.eq(i);
                    break;
                }
                // The empty option will be compiled and rendered before we first generate the options
                selectElement.empty();
                var providedEmptyOption = !!selectCtrl.emptyOption;
                var unknownOption = jqLite(optionTemplate.cloneNode(false));
                unknownOption.val("?");
                var options;
                var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
                // This stores the newly created options before they are appended to the select.
                // Since the contents are removed from the fragment when it is appended,
                // we only need to create it once.
                var listFragment = $document[0].createDocumentFragment();
                // Overwrite the implementation. ngOptions doesn't use hashes
                selectCtrl.generateUnknownOptionValue = function(val) {
                    return "?";
                };
                // Update the controller methods for multiple selectable options
                if (!multiple) {
                    selectCtrl.writeValue = function writeNgOptionsValue(value) {
                        // The options might not be defined yet when ngModel tries to render
                        if (!options) return;
                        var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
                        var option = options.getOptionFromViewValue(value);
                        // Make sure to remove the selected attribute from the previously selected option
                        // Otherwise, screen readers might get confused
                        if (selectedOption) selectedOption.removeAttribute("selected");
                        if (option) {
                            // Don't update the option when it is already selected.
                            // For example, the browser will select the first option by default. In that case,
                            // most properties are set automatically - except the `selected` attribute, which we
                            // set always
                            if (selectElement[0].value !== option.selectValue) {
                                selectCtrl.removeUnknownOption();
                                selectElement[0].value = option.selectValue;
                                option.element.selected = true;
                            }
                            option.element.setAttribute("selected", "selected");
                        } else selectCtrl.selectUnknownOrEmptyOption(value);
                    };
                    selectCtrl.readValue = function readNgOptionsValue() {
                        var selectedOption = options.selectValueMap[selectElement.val()];
                        if (selectedOption && !selectedOption.disabled) {
                            selectCtrl.unselectEmptyOption();
                            selectCtrl.removeUnknownOption();
                            return options.getViewValueFromOption(selectedOption);
                        }
                        return null;
                    };
                    // If we are using `track by` then we must watch the tracked value on the model
                    // since ngModel only watches for object identity change
                    // FIXME: When a user selects an option, this watch will fire needlessly
                    if (ngOptions.trackBy) scope.$watch(function() {
                        return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);
                    }, function() {
                        ngModelCtrl.$render();
                    });
                } else {
                    selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
                        // The options might not be defined yet when ngModel tries to render
                        if (!options) return;
                        // Only set `<option>.selected` if necessary, in order to prevent some browsers from
                        // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
                        var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
                        options.items.forEach(function(option) {
                            if (option.element.selected && !includes(selectedOptions, option)) option.element.selected = false;
                        });
                    };
                    selectCtrl.readValue = function readNgOptionsMultiple() {
                        var selectedValues = selectElement.val() || [], selections = [];
                        forEach(selectedValues, function(value) {
                            var option = options.selectValueMap[value];
                            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
                        });
                        return selections;
                    };
                    // If we are using `track by` then we must watch these tracked values on the model
                    // since ngModel only watches for object identity change
                    if (ngOptions.trackBy) scope.$watchCollection(function() {
                        if (isArray(ngModelCtrl.$viewValue)) return ngModelCtrl.$viewValue.map(function(value) {
                            return ngOptions.getTrackByValue(value);
                        });
                    }, function() {
                        ngModelCtrl.$render();
                    });
                }
                if (providedEmptyOption) {
                    // compile the element since there might be bindings in it
                    $compile(selectCtrl.emptyOption)(scope);
                    selectElement.prepend(selectCtrl.emptyOption);
                    if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
                        // This means the empty option has currently no actual DOM node, probably because
                        // it has been modified by a transclusion directive.
                        selectCtrl.hasEmptyOption = false;
                        // Redefine the registerOption function, which will catch
                        // options that are added by ngIf etc. (rendering of the node is async because of
                        // lazy transclusion)
                        selectCtrl.registerOption = function(optionScope, optionEl) {
                            if (optionEl.val() === "") {
                                selectCtrl.hasEmptyOption = true;
                                selectCtrl.emptyOption = optionEl;
                                selectCtrl.emptyOption.removeClass("ng-scope");
                                // This ensures the new empty option is selected if previously no option was selected
                                ngModelCtrl.$render();
                                optionEl.on("$destroy", function() {
                                    var needsRerender = selectCtrl.$isEmptyOptionSelected();
                                    selectCtrl.hasEmptyOption = false;
                                    selectCtrl.emptyOption = undefined;
                                    if (needsRerender) ngModelCtrl.$render();
                                });
                            }
                        };
                    } else // remove the class, which is added automatically because we recompile the element and it
                    // becomes the compilation root
                    selectCtrl.emptyOption.removeClass("ng-scope");
                }
                // We will re-render the option elements if the option values or labels change
                scope.$watchCollection(ngOptions.getWatchables, updateOptions);
                // ------------------------------------------------------------------ //
                function addOptionElement(option, parent) {
                    var optionElement = optionTemplate.cloneNode(false);
                    parent.appendChild(optionElement);
                    updateOptionElement(option, optionElement);
                }
                function getAndUpdateSelectedOption(viewValue) {
                    var option = options.getOptionFromViewValue(viewValue);
                    var element = option && option.element;
                    if (element && !element.selected) element.selected = true;
                    return option;
                }
                function updateOptionElement(option, element) {
                    option.element = element;
                    element.disabled = option.disabled;
                    // Support: IE 11 only, Edge 12-13 only
                    // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
                    // selects in certain circumstances when multiple selects are next to each other and display
                    // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
                    // See https://github.com/angular/angular.js/issues/11314 for more info.
                    // This is unfortunately untestable with unit / e2e tests
                    if (option.label !== element.label) {
                        element.label = option.label;
                        element.textContent = option.label;
                    }
                    element.value = option.selectValue;
                }
                function updateOptions() {
                    var previousValue = options && selectCtrl.readValue();
                    // We must remove all current options, but cannot simply set innerHTML = null
                    // since the providedEmptyOption might have an ngIf on it that inserts comments which we
                    // must preserve.
                    // Instead, iterate over the current option elements and remove them or their optgroup
                    // parents
                    if (options) for(var i = options.items.length - 1; i >= 0; i--){
                        var option = options.items[i];
                        if (isDefined(option.group)) jqLiteRemove(option.element.parentNode);
                        else jqLiteRemove(option.element);
                    }
                    options = ngOptions.getOptions();
                    var groupElementMap = {};
                    options.items.forEach(function addOption(option) {
                        var groupElement;
                        if (isDefined(option.group)) {
                            // This option is to live in a group
                            // See if we have already created this group
                            groupElement = groupElementMap[option.group];
                            if (!groupElement) {
                                groupElement = optGroupTemplate.cloneNode(false);
                                listFragment.appendChild(groupElement);
                                // Update the label on the group element
                                // "null" is special cased because of Safari
                                groupElement.label = option.group === null ? "null" : option.group;
                                // Store it for use later
                                groupElementMap[option.group] = groupElement;
                            }
                            addOptionElement(option, groupElement);
                        } else // This option is not in a group
                        addOptionElement(option, listFragment);
                    });
                    selectElement[0].appendChild(listFragment);
                    ngModelCtrl.$render();
                    // Check to see if the value has changed due to the update to the options
                    if (!ngModelCtrl.$isEmpty(previousValue)) {
                        var nextValue = selectCtrl.readValue();
                        var isNotPrimitive = ngOptions.trackBy || multiple;
                        if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
                            ngModelCtrl.$setViewValue(nextValue);
                            ngModelCtrl.$render();
                        }
                    }
                }
            }
            return {
                restrict: "A",
                terminal: true,
                require: [
                    "select",
                    "ngModel"
                ],
                link: {
                    pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
                        // Deactivate the SelectController.register method to prevent
                        // option directives from accidentally registering themselves
                        // (and unwanted $destroy handlers etc.)
                        ctrls[0].registerOption = noop;
                    },
                    post: ngOptionsPostLink
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */ var ngPluralizeDirective = [
        "$locale",
        "$interpolate",
        "$log",
        function($locale, $interpolate, $log) {
            var BRACE = /{}/g, IS_WHEN = /^when(Minus)?(.+)$/;
            return {
                link: function(scope, element, attr) {
                    var numberExp = attr.count, whenExp = attr.$attr.when && element.attr(attr.$attr.when), offset = attr.offset || 0, whens = scope.$eval(whenExp) || {}, whensExpFns = {}, startSymbol = $interpolate.startSymbol(), endSymbol = $interpolate.endSymbol(), braceReplacement = startSymbol + numberExp + "-" + offset + endSymbol, watchRemover = angular.noop, lastCount;
                    forEach(attr, function(expression, attributeName) {
                        var tmpMatch = IS_WHEN.exec(attributeName);
                        if (tmpMatch) {
                            var whenKey = (tmpMatch[1] ? "-" : "") + lowercase(tmpMatch[2]);
                            whens[whenKey] = element.attr(attr.$attr[attributeName]);
                        }
                    });
                    forEach(whens, function(expression, key) {
                        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
                    });
                    scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
                        var count = parseFloat(newVal);
                        var countIsNaN = isNumberNaN(count);
                        if (!countIsNaN && !(count in whens)) // If an explicit number rule such as 1, 2, 3... is defined, just use it.
                        // Otherwise, check it against pluralization rules in $locale service.
                        count = $locale.pluralCat(count - offset);
                        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
                        // In JS `NaN !== NaN`, so we have to explicitly check.
                        if (count !== lastCount && !(countIsNaN && isNumberNaN(lastCount))) {
                            watchRemover();
                            var whenExpFn = whensExpFns[count];
                            if (isUndefined(whenExpFn)) {
                                if (newVal != null) $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
                                watchRemover = noop;
                                updateElementText();
                            } else watchRemover = scope.$watch(whenExpFn, updateElementText);
                            lastCount = count;
                        }
                    });
                    function updateElementText(newText) {
                        element.text(newText || "");
                    }
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngRef
 * @restrict A
 *
 * @description
 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
 * element to the scope.
 *
 * If the element with `ngRef` is destroyed `null` is assigned to the property.
 *
 * Note that if you want to assign from a child into the parent scope, you must initialize the
 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
 * {@link ngRepeat}. See the second example below.
 *
 *
 * @element ANY
 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
 *                       controller or jqlite-wrapped DOM element will be bound.
 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
 *                            or the special string `$element`. If a name is provided, `ngRef` will
 *                            assign the matching controller. If `$element` is provided, the element
 *                            itself is assigned (even if a controller is available).
 *
 *
 * @example
 * ### Simple toggle
 * This example shows how the controller of the component toggle
 * is reused in the template through the scope to use its logic.
 * <example name="ng-ref-component" module="myApp">
 *   <file name="index.html">
 *     <my-toggle ng-ref="myToggle"></my-toggle>
 *     <button ng-click="myToggle.toggle()">Toggle</button>
 *     <div ng-show="myToggle.isOpen()">
 *       You are using a component in the same template to show it.
 *     </div>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myToggle', {
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should publish the toggle into the scope', function() {
 *        var toggle = element(by.buttonText('Toggle'));
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
 *        toggle.click();
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### ngRef inside scopes
 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
 * because the target property has not been initialized on the `myRoot` component controller.
 *
 * <example name="ng-ref-scopes" module="myApp">
 *   <file name="index.html">
 *     <my-root></my-root>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myRoot', {
 *       templateUrl: 'root.html',
 *       controller: function() {
 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
 *       }
 *     })
 *     .component('myToggle', {
 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
 *       transclude: true,
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     })
 *     .component('myWrapper', {
 *       transclude: true,
 *       template: '<strong>myWrapper</strong>' +
 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
 *     });
 *   </file>
 *   <file name="root.html">
 *     <strong>myRoot</strong>
 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     <div><em>wrappers assigned to root</em><br>
 *     <div ng-repeat="wrapper in $ctrl.wrappers">
 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
 *     </div>
 *
 *     <ul>
 *       <li ng-repeat="(index, value) in [1,2,3]">
 *         <strong>ngRepeat</strong>
 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
 *       </li>
 *     </ul>
 *
 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
 *       assigned to the child scope created by ngIf.
 *     </div>
 *     <div ng-if="true">
          <strong>ngIf</strong>
 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     </div>
 *   </file>
 *   <file name="styles.css">
 *     ul {
 *       list-style: none;
 *       padding-left: 0;
 *     }
 *
 *     li[ng-repeat] {
 *       background: lightgreen;
 *       padding: 8px;
 *       margin: 8px;
 *     }
 *
 *     [ng-if] {
 *       background: lightgrey;
 *       padding: 8px;
 *     }
 *
 *     my-root {
 *       background: lightgoldenrodyellow;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-wrapper {
 *       background: lightsalmon;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-toggle {
 *       background: lightblue;
 *       padding: 8px;
 *       display: block;
 *     }
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      var OuterToggle = function() {
 *        this.toggle = function() {
 *          element(by.buttonText('Outer Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
 *        };
 *      };
 *      var NgRepeatToggle = function(i) {
 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
 *        this.toggle = function() {
 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
 *        };
 *        this.isOpen = function() {
 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *      var NgRepeatToggles = function() {
 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
 *        this.forEach = function(fn) {
 *          toggles.forEach(fn);
 *        };
 *        this.isOuterOpen = function(i) {
 *          return toggles[i - 1].isOuterOpen();
 *        };
 *      };
 *      var NgIfToggle = function() {
 *        var parent = element(by.css('[ng-if]'));
 *        this.toggle = function() {
 *          element(by.buttonText('ngIf Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return by.binding('ngIfToggle.isOpen() | json').getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *
 *      it('should toggle the outer toggle', function() {
 *        var outerToggle = new OuterToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle all outer toggles', function() {
 *        var outerToggle = new OuterToggle();
 *        var repeatToggles = new NgRepeatToggles();
 *        var ifToggle = new NgIfToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle each repeat iteration separately', function() {
 *        var repeatToggles = new NgRepeatToggles();
 *
 *        repeatToggles.forEach(function(repeatToggle) {
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *          repeatToggle.toggle();
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        });
 *      });
 *   </file>
 * </example>
 *
 */ var ngRefMinErr = minErr("ngRef");
    var ngRefDirective = [
        "$parse",
        function($parse) {
            return {
                priority: -1,
                restrict: "A",
                compile: function(tElement, tAttrs) {
                    // Get the expected controller name, converts <data-some-thing> into "someThing"
                    var controllerName = directiveNormalize(nodeName_(tElement));
                    // Get the expression for value binding
                    var getter = $parse(tAttrs.ngRef);
                    var setter = getter.assign || function() {
                        throw ngRefMinErr("nonassign", 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
                    };
                    return function(scope, element, attrs) {
                        var refValue;
                        if (attrs.hasOwnProperty("ngRefRead")) {
                            if (attrs.ngRefRead === "$element") refValue = element;
                            else {
                                refValue = element.data("$" + attrs.ngRefRead + "Controller");
                                if (!refValue) throw ngRefMinErr("noctrl", 'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"', attrs.ngRefRead, tAttrs.ngRef);
                            }
                        } else refValue = element.data("$" + controllerName + "Controller");
                        refValue = refValue || element;
                        setter(scope, refValue);
                        // when the element is removed, remove it (nullify it)
                        element.on("$destroy", function() {
                            // only remove it if value has not changed,
                            // because animations (and other procedures) may duplicate elements
                            if (getter(scope) === refValue) setter(scope, null);
                        });
                    };
                }
            };
        }
    ];
    /* exported ngRepeatDirective */ /**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */ var ngRepeatDirective = [
        "$parse",
        "$animate",
        "$compile",
        function($parse, $animate, $compile) {
            var NG_REMOVED = "$$NG_REMOVED";
            var ngRepeatMinErr = minErr("ngRepeat");
            var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
                // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
                scope[valueIdentifier] = value;
                if (keyIdentifier) scope[keyIdentifier] = key;
                scope.$index = index;
                scope.$first = index === 0;
                scope.$last = index === arrayLength - 1;
                scope.$middle = !(scope.$first || scope.$last);
                // eslint-disable-next-line no-bitwise
                scope.$odd = !(scope.$even = (index & 1) === 0);
            };
            var getBlockStart = function(block) {
                return block.clone[0];
            };
            var getBlockEnd = function(block) {
                return block.clone[block.clone.length - 1];
            };
            var trackByIdArrayFn = function($scope, key, value) {
                return hashKey(value);
            };
            var trackByIdObjFn = function($scope, key) {
                return key;
            };
            return {
                restrict: "A",
                multiElement: true,
                transclude: "element",
                priority: 1000,
                terminal: true,
                $$tlb: true,
                compile: function ngRepeatCompile($element, $attr) {
                    var expression = $attr.ngRepeat;
                    var ngRepeatEndComment = $compile.$$createComment("end ngRepeat", expression);
                    var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
                    if (!match) throw ngRepeatMinErr("iexp", "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
                    var lhs = match[1];
                    var rhs = match[2];
                    var aliasAs = match[3];
                    var trackByExp = match[4];
                    match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
                    if (!match) throw ngRepeatMinErr("iidexp", "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.", lhs);
                    var valueIdentifier = match[3] || match[1];
                    var keyIdentifier = match[2];
                    if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) throw ngRepeatMinErr("badident", "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.", aliasAs);
                    var trackByIdExpFn;
                    if (trackByExp) {
                        var hashFnLocals = {
                            $id: hashKey
                        };
                        var trackByExpGetter = $parse(trackByExp);
                        trackByIdExpFn = function($scope, key, value, index) {
                            // assign key, value, and $index to the locals so that they can be used in hash functions
                            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
                            hashFnLocals[valueIdentifier] = value;
                            hashFnLocals.$index = index;
                            return trackByExpGetter($scope, hashFnLocals);
                        };
                    }
                    return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
                        // Store a list of elements from previous run. This is a hash where key is the item from the
                        // iterator, and the value is objects with following properties.
                        //   - scope: bound scope
                        //   - clone: previous element.
                        //   - index: position
                        //
                        // We are using no-proto object so that we don't need to guard against inherited props via
                        // hasOwnProperty.
                        var lastBlockMap = createMap();
                        //watch props
                        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
                            var index, length, previousNode = $element[0], // initialized to the comment node anchor
                            nextNode, // Same as lastBlockMap but it has the current state. It will become the
                            // lastBlockMap on the next iteration.
                            nextBlockMap = createMap(), collectionLength, key, value, trackById, trackByIdFn, collectionKeys, block, nextBlockOrder, elementsToRemove;
                            if (aliasAs) $scope[aliasAs] = collection;
                            if (isArrayLike(collection)) {
                                collectionKeys = collection;
                                trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
                            } else {
                                trackByIdFn = trackByIdExpFn || trackByIdObjFn;
                                // if object, extract keys, in enumeration order, unsorted
                                collectionKeys = [];
                                for(var itemKey in collection)if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== "$") collectionKeys.push(itemKey);
                            }
                            collectionLength = collectionKeys.length;
                            nextBlockOrder = new Array(collectionLength);
                            // locate existing items
                            for(index = 0; index < collectionLength; index++){
                                key = collection === collectionKeys ? index : collectionKeys[index];
                                value = collection[key];
                                trackById = trackByIdFn($scope, key, value, index);
                                if (lastBlockMap[trackById]) {
                                    // found previously seen block
                                    block = lastBlockMap[trackById];
                                    delete lastBlockMap[trackById];
                                    nextBlockMap[trackById] = block;
                                    nextBlockOrder[index] = block;
                                } else if (nextBlockMap[trackById]) {
                                    // if collision detected. restore lastBlockMap and throw an error
                                    forEach(nextBlockOrder, function(block) {
                                        if (block && block.scope) lastBlockMap[block.id] = block;
                                    });
                                    throw ngRepeatMinErr("dupes", "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}", expression, trackById, value);
                                } else {
                                    // new never before seen block
                                    nextBlockOrder[index] = {
                                        id: trackById,
                                        scope: undefined,
                                        clone: undefined
                                    };
                                    nextBlockMap[trackById] = true;
                                }
                            }
                            // Clear the value property from the hashFnLocals object to prevent a reference to the last value
                            // being leaked into the ngRepeatCompile function scope
                            if (hashFnLocals) hashFnLocals[valueIdentifier] = undefined;
                            // remove leftover items
                            for(var blockKey in lastBlockMap){
                                block = lastBlockMap[blockKey];
                                elementsToRemove = getBlockNodes(block.clone);
                                $animate.leave(elementsToRemove);
                                if (elementsToRemove[0].parentNode) // if the element was not removed yet because of pending animation, mark it as deleted
                                // so that we can ignore it later
                                for(index = 0, length = elementsToRemove.length; index < length; index++)elementsToRemove[index][NG_REMOVED] = true;
                                block.scope.$destroy();
                            }
                            // we are not using forEach for perf reasons (trying to avoid #call)
                            for(index = 0; index < collectionLength; index++){
                                key = collection === collectionKeys ? index : collectionKeys[index];
                                value = collection[key];
                                block = nextBlockOrder[index];
                                if (block.scope) {
                                    // if we have already seen this object, then we need to reuse the
                                    // associated scope/element
                                    nextNode = previousNode;
                                    // skip nodes that are already pending removal via leave animation
                                    do nextNode = nextNode.nextSibling;
                                    while (nextNode && nextNode[NG_REMOVED]);
                                    if (getBlockStart(block) !== nextNode) // existing item which got moved
                                    $animate.move(getBlockNodes(block.clone), null, previousNode);
                                    previousNode = getBlockEnd(block);
                                    updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                                } else // new item which we don't know about
                                $transclude(function ngRepeatTransclude(clone, scope) {
                                    block.scope = scope;
                                    // http://jsperf.com/clone-vs-createcomment
                                    var endNode = ngRepeatEndComment.cloneNode(false);
                                    clone[clone.length++] = endNode;
                                    $animate.enter(clone, null, previousNode);
                                    previousNode = endNode;
                                    // Note: We only need the first/last node of the cloned nodes.
                                    // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                                    // by a directive with templateUrl when its template arrives.
                                    block.clone = clone;
                                    nextBlockMap[block.id] = block;
                                    updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                                });
                            }
                            lastBlockMap = nextBlockMap;
                        });
                    };
                }
            };
        }
    ];
    var NG_HIDE_CLASS = "ng-hide";
    var NG_HIDE_IN_PROGRESS_CLASS = "ng-hide-animate";
    /**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */ var ngShowDirective = [
        "$animate",
        function($animate) {
            return {
                restrict: "A",
                multiElement: true,
                link: function(scope, element, attr) {
                    scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
                        // we're adding a temporary, animation-specific class for ng-hide since this way
                        // we can control when the element is actually displayed on screen without having
                        // to have a global/greedy CSS selector that breaks when other animations are run.
                        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
                        $animate[value ? "removeClass" : "addClass"](element, NG_HIDE_CLASS, {
                            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
                        });
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */ var ngHideDirective = [
        "$animate",
        function($animate) {
            return {
                restrict: "A",
                multiElement: true,
                link: function(scope, element, attr) {
                    scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
                        // The comment inside of the ngShowDirective explains why we add and
                        // remove a temporary class for the show/hide animation
                        $animate[value ? "addClass" : "removeClass"](element, NG_HIDE_CLASS, {
                            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
                        });
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
       });
     </file>
   </example>
 */ var ngStyleDirective = ngDirective(function(scope, element, attr) {
        scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
            if (oldStyles && newStyles !== oldStyles) forEach(oldStyles, function(val, style) {
                element.css(style, "");
            });
            if (newStyles) element.css(newStyles);
        });
    });
    /**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */ var ngSwitchDirective = [
        "$animate",
        "$compile",
        function($animate, $compile) {
            return {
                require: "ngSwitch",
                // asks for $scope to fool the BC controller module
                controller: [
                    "$scope",
                    function NgSwitchController() {
                        this.cases = {};
                    }
                ],
                link: function(scope, element, attr, ngSwitchController) {
                    var watchExpr = attr.ngSwitch || attr.on, selectedTranscludes = [], selectedElements = [], previousLeaveAnimations = [], selectedScopes = [];
                    var spliceFactory = function(array, index) {
                        return function(response) {
                            if (response !== false) array.splice(index, 1);
                        };
                    };
                    scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
                        var i, ii;
                        // Start with the last, in case the array is modified during the loop
                        while(previousLeaveAnimations.length)$animate.cancel(previousLeaveAnimations.pop());
                        for(i = 0, ii = selectedScopes.length; i < ii; ++i){
                            var selected = getBlockNodes(selectedElements[i].clone);
                            selectedScopes[i].$destroy();
                            var runner = previousLeaveAnimations[i] = $animate.leave(selected);
                            runner.done(spliceFactory(previousLeaveAnimations, i));
                        }
                        selectedElements.length = 0;
                        selectedScopes.length = 0;
                        if (selectedTranscludes = ngSwitchController.cases["!" + value] || ngSwitchController.cases["?"]) forEach(selectedTranscludes, function(selectedTransclude) {
                            selectedTransclude.transclude(function(caseElement, selectedScope) {
                                selectedScopes.push(selectedScope);
                                var anchor = selectedTransclude.element;
                                caseElement[caseElement.length++] = $compile.$$createComment("end ngSwitchWhen");
                                var block = {
                                    clone: caseElement
                                };
                                selectedElements.push(block);
                                $animate.enter(caseElement, anchor.parent(), anchor);
                            });
                        });
                    });
                }
            };
        }
    ];
    var ngSwitchWhenDirective = ngDirective({
        transclude: "element",
        priority: 1200,
        require: "^ngSwitch",
        multiElement: true,
        link: function(scope, element, attrs, ctrl, $transclude) {
            var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(// Filter duplicate cases
            function(element, index, array) {
                return array[index - 1] !== element;
            });
            forEach(cases, function(whenCase) {
                ctrl.cases["!" + whenCase] = ctrl.cases["!" + whenCase] || [];
                ctrl.cases["!" + whenCase].push({
                    transclude: $transclude,
                    element: element
                });
            });
        }
    });
    var ngSwitchDefaultDirective = ngDirective({
        transclude: "element",
        priority: 1200,
        require: "^ngSwitch",
        multiElement: true,
        link: function(scope, element, attr, ctrl, $transclude) {
            ctrl.cases["?"] = ctrl.cases["?"] || [];
            ctrl.cases["?"].push({
                transclude: $transclude,
                element: element
            });
        }
    });
    /**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */ var ngTranscludeMinErr = minErr("ngTransclude");
    var ngTranscludeDirective = [
        "$compile",
        function($compile) {
            return {
                restrict: "EAC",
                compile: function ngTranscludeCompile(tElement) {
                    // Remove and cache any original content to act as a fallback
                    var fallbackLinkFn = $compile(tElement.contents());
                    tElement.empty();
                    return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
                        if (!$transclude) throw ngTranscludeMinErr("orphan", "Illegal use of ngTransclude directive in the template! No parent directive that requires a transclusion found. Element: {0}", startingTag($element));
                        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
                        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) $attrs.ngTransclude = "";
                        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
                        // If the slot is required and no transclusion content is provided then this call will throw an error
                        $transclude(ngTranscludeCloneAttachFn, null, slotName);
                        // If the slot is optional and no transclusion content is provided then use the fallback content
                        if (slotName && !$transclude.isSlotFilled(slotName)) useFallbackContent();
                        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
                            if (clone.length && notWhitespace(clone)) $element.append(clone);
                            else {
                                useFallbackContent();
                                // There is nothing linked against the transcluded scope since no content was available,
                                // so it should be safe to clean up the generated scope.
                                transcludedScope.$destroy();
                            }
                        }
                        function useFallbackContent() {
                            // Since this is the fallback content rather than the transcluded content,
                            // we link against the scope of this directive rather than the transcluded scope
                            fallbackLinkFn($scope, function(clone) {
                                $element.append(clone);
                            });
                        }
                        function notWhitespace(nodes) {
                            for(var i = 0, ii = nodes.length; i < ii; i++){
                                var node = nodes[i];
                                if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) return true;
                            }
                        }
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */ var scriptDirective = [
        "$templateCache",
        function($templateCache) {
            return {
                restrict: "E",
                terminal: true,
                compile: function(element, attr) {
                    if (attr.type === "text/ng-template") {
                        var templateUrl = attr.id, text = element[0].text;
                        $templateCache.put(templateUrl, text);
                    }
                }
            };
        }
    ];
    /* exported selectDirective, optionDirective */ var noopNgModelController = {
        $setViewValue: noop,
        $render: noop
    };
    function setOptionSelectedStatus(optionEl, value) {
        optionEl.prop("selected", value);
        /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */ optionEl.attr("selected", value);
    }
    /**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */ var SelectController = [
        "$element",
        "$scope",
        /** @this */ function($element, $scope) {
            var self = this, optionsMap = new NgMap();
            self.selectValueMap = {}; // Keys are the hashed values, values the original values
            // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
            self.ngModelCtrl = noopNgModelController;
            self.multiple = false;
            // The "unknown" option is one that is prepended to the list if the viewValue
            // does not match any of the options. When it is rendered the value of the unknown
            // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
            //
            // Support: IE 9 only
            // We can't just jqLite('<option>') since jqLite is not smart enough
            // to create it in <select> and IE barfs otherwise.
            self.unknownOption = jqLite(window1.document.createElement("option"));
            // The empty option is an option with the value '' that the application developer can
            // provide inside the select. It is always selectable and indicates that a "null" selection has
            // been made by the user.
            // If the select has an empty option, and the model of the select is set to "undefined" or "null",
            // the empty option is selected.
            // If the model is set to a different unmatched value, the unknown option is rendered and
            // selected, i.e both are present, because a "null" selection and an unknown value are different.
            self.hasEmptyOption = false;
            self.emptyOption = undefined;
            self.renderUnknownOption = function(val) {
                var unknownVal = self.generateUnknownOptionValue(val);
                self.unknownOption.val(unknownVal);
                $element.prepend(self.unknownOption);
                setOptionSelectedStatus(self.unknownOption, true);
                $element.val(unknownVal);
            };
            self.updateUnknownOption = function(val) {
                var unknownVal = self.generateUnknownOptionValue(val);
                self.unknownOption.val(unknownVal);
                setOptionSelectedStatus(self.unknownOption, true);
                $element.val(unknownVal);
            };
            self.generateUnknownOptionValue = function(val) {
                return "? " + hashKey(val) + " ?";
            };
            self.removeUnknownOption = function() {
                if (self.unknownOption.parent()) self.unknownOption.remove();
            };
            self.selectEmptyOption = function() {
                if (self.emptyOption) {
                    $element.val("");
                    setOptionSelectedStatus(self.emptyOption, true);
                }
            };
            self.unselectEmptyOption = function() {
                if (self.hasEmptyOption) setOptionSelectedStatus(self.emptyOption, false);
            };
            $scope.$on("$destroy", function() {
                // disable unknown option so that we don't do work when the whole select is being destroyed
                self.renderUnknownOption = noop;
            });
            // Read the value of the select control, the implementation of this changes depending
            // upon whether the select can have multiple values and whether ngOptions is at work.
            self.readValue = function readSingleValue() {
                var val = $element.val();
                // ngValue added option values are stored in the selectValueMap, normal interpolations are not
                var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
                if (self.hasOption(realVal)) return realVal;
                return null;
            };
            // Write the value to the select control, the implementation of this changes depending
            // upon whether the select can have multiple values and whether ngOptions is at work.
            self.writeValue = function writeSingleValue(value) {
                // Make sure to remove the selected attribute from the previously selected option
                // Otherwise, screen readers might get confused
                var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
                if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
                if (self.hasOption(value)) {
                    self.removeUnknownOption();
                    var hashedVal = hashKey(value);
                    $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
                    // Set selected attribute and property on selected option for screen readers
                    var selectedOption = $element[0].options[$element[0].selectedIndex];
                    setOptionSelectedStatus(jqLite(selectedOption), true);
                } else self.selectUnknownOrEmptyOption(value);
            };
            // Tell the select control that an option, with the given value, has been added
            self.addOption = function(value, element) {
                // Skip comment nodes, as they only pollute the `optionsMap`
                if (element[0].nodeType === NODE_TYPE_COMMENT) return;
                assertNotHasOwnProperty(value, '"option value"');
                if (value === "") {
                    self.hasEmptyOption = true;
                    self.emptyOption = element;
                }
                var count = optionsMap.get(value) || 0;
                optionsMap.set(value, count + 1);
                // Only render at the end of a digest. This improves render performance when many options
                // are added during a digest and ensures all relevant options are correctly marked as selected
                scheduleRender();
            };
            // Tell the select control that an option, with the given value, has been removed
            self.removeOption = function(value) {
                var count = optionsMap.get(value);
                if (count) {
                    if (count === 1) {
                        optionsMap.delete(value);
                        if (value === "") {
                            self.hasEmptyOption = false;
                            self.emptyOption = undefined;
                        }
                    } else optionsMap.set(value, count - 1);
                }
            };
            // Check whether the select control has an option matching the given value
            self.hasOption = function(value) {
                return !!optionsMap.get(value);
            };
            /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */ self.$hasEmptyOption = function() {
                return self.hasEmptyOption;
            };
            /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */ self.$isUnknownOptionSelected = function() {
                // Presence of the unknown option means it is selected
                return $element[0].options[0] === self.unknownOption[0];
            };
            /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */ self.$isEmptyOptionSelected = function() {
                return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
            };
            self.selectUnknownOrEmptyOption = function(value) {
                if (value == null && self.emptyOption) {
                    self.removeUnknownOption();
                    self.selectEmptyOption();
                } else if (self.unknownOption.parent().length) self.updateUnknownOption(value);
                else self.renderUnknownOption(value);
            };
            var renderScheduled = false;
            function scheduleRender() {
                if (renderScheduled) return;
                renderScheduled = true;
                $scope.$$postDigest(function() {
                    renderScheduled = false;
                    self.ngModelCtrl.$render();
                });
            }
            var updateScheduled = false;
            function scheduleViewValueUpdate(renderAfter) {
                if (updateScheduled) return;
                updateScheduled = true;
                $scope.$$postDigest(function() {
                    if ($scope.$$destroyed) return;
                    updateScheduled = false;
                    self.ngModelCtrl.$setViewValue(self.readValue());
                    if (renderAfter) self.ngModelCtrl.$render();
                });
            }
            self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
                if (optionAttrs.$attr.ngValue) {
                    // The value attribute is set by ngValue
                    var oldVal, hashedVal;
                    optionAttrs.$observe("value", function valueAttributeObserveAction(newVal) {
                        var removal;
                        var previouslySelected = optionElement.prop("selected");
                        if (isDefined(hashedVal)) {
                            self.removeOption(oldVal);
                            delete self.selectValueMap[hashedVal];
                            removal = true;
                        }
                        hashedVal = hashKey(newVal);
                        oldVal = newVal;
                        self.selectValueMap[hashedVal] = newVal;
                        self.addOption(newVal, optionElement);
                        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
                        // from firing a second time. Other $observers on value will also get the result of the
                        // ngValue expression, not the hashed value
                        optionElement.attr("value", hashedVal);
                        if (removal && previouslySelected) scheduleViewValueUpdate();
                    });
                } else if (interpolateValueFn) // The value attribute is interpolated
                optionAttrs.$observe("value", function valueAttributeObserveAction(newVal) {
                    // This method is overwritten in ngOptions and has side-effects!
                    self.readValue();
                    var removal;
                    var previouslySelected = optionElement.prop("selected");
                    if (isDefined(oldVal)) {
                        self.removeOption(oldVal);
                        removal = true;
                    }
                    oldVal = newVal;
                    self.addOption(newVal, optionElement);
                    if (removal && previouslySelected) scheduleViewValueUpdate();
                });
                else if (interpolateTextFn) // The text content is interpolated
                optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
                    optionAttrs.$set("value", newVal);
                    var previouslySelected = optionElement.prop("selected");
                    if (oldVal !== newVal) self.removeOption(oldVal);
                    self.addOption(newVal, optionElement);
                    if (oldVal && previouslySelected) scheduleViewValueUpdate();
                });
                else // The value attribute is static
                self.addOption(optionAttrs.value, optionElement);
                optionAttrs.$observe("disabled", function(newVal) {
                    // Since model updates will also select disabled options (like ngOptions),
                    // we only have to handle options becoming disabled, not enabled
                    if (newVal === "true" || newVal && optionElement.prop("selected")) {
                        if (self.multiple) scheduleViewValueUpdate(true);
                        else {
                            self.ngModelCtrl.$setViewValue(null);
                            self.ngModelCtrl.$render();
                        }
                    }
                });
                optionElement.on("$destroy", function() {
                    var currentValue = self.readValue();
                    var removeValue = optionAttrs.value;
                    self.removeOption(removeValue);
                    scheduleRender();
                    if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 || currentValue === removeValue) // When multiple (selected) options are destroyed at the same time, we don't want
                    // to run a model update for each of them. Instead, run a single update in the $$postDigest
                    scheduleViewValueUpdate(true);
                });
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */ var selectDirective = function() {
        return {
            restrict: "E",
            require: [
                "select",
                "?ngModel"
            ],
            controller: SelectController,
            priority: 1,
            link: {
                pre: selectPreLink,
                post: selectPostLink
            }
        };
        function selectPreLink(scope, element, attr, ctrls) {
            var selectCtrl = ctrls[0];
            var ngModelCtrl = ctrls[1];
            // if ngModel is not defined, we don't need to do anything but set the registerOption
            // function to noop, so options don't get added internally
            if (!ngModelCtrl) {
                selectCtrl.registerOption = noop;
                return;
            }
            selectCtrl.ngModelCtrl = ngModelCtrl;
            // When the selected item(s) changes we delegate getting the value of the select control
            // to the `readValue` method, which can be changed if the select can have multiple
            // selected values or if the options are being generated by `ngOptions`
            element.on("change", function() {
                selectCtrl.removeUnknownOption();
                scope.$apply(function() {
                    ngModelCtrl.$setViewValue(selectCtrl.readValue());
                });
            });
            // If the select allows multiple values then we need to modify how we read and write
            // values from and to the control; also what it means for the value to be empty and
            // we have to add an extra watch since ngModel doesn't work well with arrays - it
            // doesn't trigger rendering if only an item in the array changes.
            if (attr.multiple) {
                selectCtrl.multiple = true;
                // Read value now needs to check each option to see if it is selected
                selectCtrl.readValue = function readMultipleValue() {
                    var array = [];
                    forEach(element.find("option"), function(option) {
                        if (option.selected && !option.disabled) {
                            var val = option.value;
                            array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
                        }
                    });
                    return array;
                };
                // Write value now needs to set the selected property of each matching option
                selectCtrl.writeValue = function writeMultipleValue(value) {
                    forEach(element.find("option"), function(option) {
                        var shouldBeSelected = !!value && (includes(value, option.value) || includes(value, selectCtrl.selectValueMap[option.value]));
                        var currentlySelected = option.selected;
                        // Support: IE 9-11 only, Edge 12-15+
                        // In IE and Edge adding options to the selection via shift+click/UP/DOWN
                        // will de-select already selected options if "selected" on those options was set
                        // more than once (i.e. when the options were already selected)
                        // So we only modify the selected property if necessary.
                        // Note: this behavior cannot be replicated via unit tests because it only shows in the
                        // actual user interface.
                        if (shouldBeSelected !== currentlySelected) setOptionSelectedStatus(jqLite(option), shouldBeSelected);
                    });
                };
                // we have to do it on each watch since ngModel watches reference, but
                // we need to work of an array, so we need to see if anything was inserted/removed
                var lastView, lastViewRef = NaN;
                scope.$watch(function selectMultipleWatch() {
                    if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
                        lastView = shallowCopy(ngModelCtrl.$viewValue);
                        ngModelCtrl.$render();
                    }
                    lastViewRef = ngModelCtrl.$viewValue;
                });
                // If we are a multiple select then value is now a collection
                // so the meaning of $isEmpty changes
                ngModelCtrl.$isEmpty = function(value) {
                    return !value || value.length === 0;
                };
            }
        }
        function selectPostLink(scope, element, attrs, ctrls) {
            // if ngModel is not defined, we don't need to do anything
            var ngModelCtrl = ctrls[1];
            if (!ngModelCtrl) return;
            var selectCtrl = ctrls[0];
            // We delegate rendering to the `writeValue` method, which can be changed
            // if the select can have multiple selected values or if the options are being
            // generated by `ngOptions`.
            // This must be done in the postLink fn to prevent $render to be called before
            // all nodes have been linked correctly.
            ngModelCtrl.$render = function() {
                selectCtrl.writeValue(ngModelCtrl.$viewValue);
            };
        }
    };
    // The option directive is purely designed to communicate the existence (or lack of)
    // of dynamically created (and destroyed) option elements to their containing select
    // directive via its controller.
    var optionDirective = [
        "$interpolate",
        function($interpolate) {
            return {
                restrict: "E",
                priority: 100,
                compile: function(element, attr) {
                    var interpolateValueFn, interpolateTextFn;
                    if (isDefined(attr.ngValue)) ;
                    else if (isDefined(attr.value)) // If the value attribute is defined, check if it contains an interpolation
                    interpolateValueFn = $interpolate(attr.value, true);
                    else {
                        // If the value attribute is not defined then we fall back to the
                        // text content of the option element, which may be interpolated
                        interpolateTextFn = $interpolate(element.text(), true);
                        if (!interpolateTextFn) attr.$set("value", element.text());
                    }
                    return function(scope, element, attr) {
                        // This is an optimization over using ^^ since we don't want to have to search
                        // all the way to the root of the DOM for every single option element
                        var selectCtrlName = "$selectController", parent = element.parent(), selectCtrl = parent.data(selectCtrlName) || parent.parent().data(selectCtrlName); // in case we are in optgroup
                        if (selectCtrl) selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */ var requiredDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
                    // For boolean attributes like required, presence means true
                    var value = attr.hasOwnProperty("required") || $parse(attr.ngRequired)(scope);
                    if (!attr.ngRequired) // force truthy in case we are on non input element
                    // (input elements do this automatically for boolean attributes like required)
                    attr.required = true;
                    ctrl.$validators.required = function(modelValue, viewValue) {
                        return !value || !ctrl.$isEmpty(viewValue);
                    };
                    attr.$observe("required", function(newVal) {
                        if (value !== newVal) {
                            value = newVal;
                            ctrl.$validate();
                        }
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */ var patternDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                compile: function(tElm, tAttr) {
                    var patternExp;
                    var parseFn;
                    if (tAttr.ngPattern) {
                        patternExp = tAttr.ngPattern;
                        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
                        // We get value of the attribute here, so we can compare the old and the new value
                        // in the observer to avoid unnecessary validations
                        if (tAttr.ngPattern.charAt(0) === "/" && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) parseFn = function() {
                            return tAttr.ngPattern;
                        };
                        else parseFn = $parse(tAttr.ngPattern);
                    }
                    return function(scope, elm, attr, ctrl) {
                        if (!ctrl) return;
                        var attrVal = attr.pattern;
                        if (attr.ngPattern) attrVal = parseFn(scope);
                        else patternExp = attr.pattern;
                        var regexp = parsePatternAttr(attrVal, patternExp, elm);
                        attr.$observe("pattern", function(newVal) {
                            var oldRegexp = regexp;
                            regexp = parsePatternAttr(newVal, patternExp, elm);
                            if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) ctrl.$validate();
                        });
                        ctrl.$validators.pattern = function(modelValue, viewValue) {
                            // HTML5 pattern constraint validates the input value, so we validate the viewValue
                            return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
                        };
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */ var maxlengthDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
                    var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
                    var maxlengthParsed = parseLength(maxlength);
                    attr.$observe("maxlength", function(value) {
                        if (maxlength !== value) {
                            maxlengthParsed = parseLength(value);
                            maxlength = value;
                            ctrl.$validate();
                        }
                    });
                    ctrl.$validators.maxlength = function(modelValue, viewValue) {
                        return maxlengthParsed < 0 || ctrl.$isEmpty(viewValue) || viewValue.length <= maxlengthParsed;
                    };
                }
            };
        }
    ];
    /**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */ var minlengthDirective = [
        "$parse",
        function($parse) {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
                    var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
                    var minlengthParsed = parseLength(minlength) || -1;
                    attr.$observe("minlength", function(value) {
                        if (minlength !== value) {
                            minlengthParsed = parseLength(value) || -1;
                            minlength = value;
                            ctrl.$validate();
                        }
                    });
                    ctrl.$validators.minlength = function(modelValue, viewValue) {
                        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
                    };
                }
            };
        }
    ];
    function parsePatternAttr(regex, patternExp, elm) {
        if (!regex) return undefined;
        if (isString(regex)) regex = new RegExp("^" + regex + "$");
        if (!regex.test) throw minErr("ngPattern")("noregexp", "Expected {0} to be a RegExp but was {1}. Element: {2}", patternExp, regex, startingTag(elm));
        return regex;
    }
    function parseLength(val) {
        var intVal = toInt(val);
        return isNumberNaN(intVal) ? -1 : intVal;
    }
    if (window1.angular.bootstrap) {
        // AngularJS is already loaded, so we can return here...
        if (window1.console) console.log("WARNING: Tried to load AngularJS more than once.");
        return;
    }
    // try to bind to jquery now so that one can write jqLite(fn)
    // but we will rebind on bootstrap again.
    bindJQuery();
    publishExternalAPI(angular);
    angular.module("ngLocale", [], [
        "$provide",
        function($provide) {
            var PLURAL_CATEGORY = {
                ZERO: "zero",
                ONE: "one",
                TWO: "two",
                FEW: "few",
                MANY: "many",
                OTHER: "other"
            };
            function getDecimals(n) {
                n = n + "";
                var i = n.indexOf(".");
                return i == -1 ? 0 : n.length - i - 1;
            }
            function getVF(n, opt_precision) {
                var v = opt_precision;
                if (undefined === v) v = Math.min(getDecimals(n), 3);
                var base = Math.pow(10, v);
                var f = (n * base | 0) % base;
                return {
                    v: v,
                    f: f
                };
            }
            $provide.value("$locale", {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "AM",
                        "PM"
                    ],
                    "DAY": [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    "ERANAMES": [
                        "Before Christ",
                        "Anno Domini"
                    ],
                    "ERAS": [
                        "BC",
                        "AD"
                    ],
                    "FIRSTDAYOFWEEK": 6,
                    "MONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "SHORTDAY": [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    "SHORTMONTH": [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    "STANDALONEMONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "WEEKENDRANGE": [
                        5,
                        6
                    ],
                    "fullDate": "EEEE, MMMM d, y",
                    "longDate": "MMMM d, y",
                    "medium": "MMM d, y h:mm:ss a",
                    "mediumDate": "MMM d, y",
                    "mediumTime": "h:mm:ss a",
                    "short": "M/d/yy h:mm a",
                    "shortDate": "M/d/yy",
                    "shortTime": "h:mm a"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "$",
                    "DECIMAL_SEP": ".",
                    "GROUP_SEP": ",",
                    "PATTERNS": [
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "maxFrac": 3,
                            "minFrac": 0,
                            "minInt": 1,
                            "negPre": "-",
                            "negSuf": "",
                            "posPre": "",
                            "posSuf": ""
                        },
                        {
                            "gSize": 3,
                            "lgSize": 3,
                            "maxFrac": 2,
                            "minFrac": 2,
                            "minInt": 1,
                            "negPre": "-\xa4",
                            "negSuf": "",
                            "posPre": "\xa4",
                            "posSuf": ""
                        }
                    ]
                },
                "id": "en-us",
                "localeID": "en_US",
                "pluralCat": function(n, opt_precision) {
                    var i = n | 0;
                    var vf = getVF(n, opt_precision);
                    if (i == 1 && vf.v == 0) return PLURAL_CATEGORY.ONE;
                    return PLURAL_CATEGORY.OTHER;
                }
            });
        }
    ]);
    jqLite(function() {
        angularInit(window1.document, bootstrap);
    });
})(window);
!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element("<style>").text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));

});


parcelRegister("a4E6K", function(module, exports) {
/**
  * x is a value between 0 and 1, indicating where in the animation you are.
  */ var duScrollDefaultEasing = function(x) {
    "use strict";
    if (x < 0.5) return Math.pow(x * 2, 2) / 2;
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
};
var duScroll = angular.module("duScroll", [
    "duScroll.scrollspy",
    "duScroll.smoothScroll",
    "duScroll.scrollContainer",
    "duScroll.spyContext",
    "duScroll.scrollHelpers"
])//Default animation duration for smoothScroll directive
.value("duScrollDuration", 350)//Scrollspy debounce interval, set to 0 to disable
.value("duScrollSpyWait", 100)//Scrollspy forced refresh interval, use if your content changes or reflows without scrolling.
//0 to disable
.value("duScrollSpyRefreshInterval", 0)//Wether or not multiple scrollspies can be active at once
.value("duScrollGreedy", false)//Default offset for smoothScroll directive
.value("duScrollOffset", 0)//Default easing function for scroll animation
.value("duScrollEasing", duScrollDefaultEasing)//Which events on the container (such as body) should cancel scroll animations
.value("duScrollCancelOnEvents", "scroll mousedown mousewheel touchmove keydown")//Whether or not to activate the last scrollspy, when page/container bottom is reached
.value("duScrollBottomSpy", false)//Active class name
.value("duScrollActiveClass", "active");
if (module && module.exports) module.exports = duScroll;
angular.module("duScroll.scrollHelpers", [
    "duScroll.requestAnimation"
]).run([
    "$window",
    "$q",
    "cancelAnimation",
    "requestAnimation",
    "duScrollEasing",
    "duScrollDuration",
    "duScrollOffset",
    "duScrollCancelOnEvents",
    function($window, $q, cancelAnimation, requestAnimation, duScrollEasing, duScrollDuration, duScrollOffset, duScrollCancelOnEvents) {
        "use strict";
        var proto = {};
        var isDocument = function(el) {
            return typeof HTMLDocument !== "undefined" && el instanceof HTMLDocument || el.nodeType && el.nodeType === el.DOCUMENT_NODE;
        };
        var isElement = function(el) {
            return typeof HTMLElement !== "undefined" && el instanceof HTMLElement || el.nodeType && el.nodeType === el.ELEMENT_NODE;
        };
        var unwrap = function(el) {
            return isElement(el) || isDocument(el) ? el : el[0];
        };
        proto.duScrollTo = function(left, top, duration, easing) {
            var aliasFn;
            if (angular.isElement(left)) aliasFn = this.duScrollToElement;
            else if (angular.isDefined(duration)) aliasFn = this.duScrollToAnimated;
            if (aliasFn) return aliasFn.apply(this, arguments);
            var el = unwrap(this);
            if (isDocument(el)) return $window.scrollTo(left, top);
            el.scrollLeft = left;
            el.scrollTop = top;
        };
        var scrollAnimation, deferred;
        proto.duScrollToAnimated = function(left, top, duration, easing) {
            if (duration && !easing) easing = duScrollEasing;
            var startLeft = this.duScrollLeft(), startTop = this.duScrollTop(), deltaLeft = Math.round(left - startLeft), deltaTop = Math.round(top - startTop);
            var startTime = null, progress = 0;
            var el = this;
            var cancelScrollAnimation = function($event) {
                if (!$event || progress && $event.which > 0) {
                    if (duScrollCancelOnEvents) el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
                    cancelAnimation(scrollAnimation);
                    deferred.reject();
                    scrollAnimation = null;
                }
            };
            if (scrollAnimation) cancelScrollAnimation();
            deferred = $q.defer();
            if (duration === 0 || !deltaLeft && !deltaTop) {
                if (duration === 0) el.duScrollTo(left, top);
                deferred.resolve();
                return deferred.promise;
            }
            var animationStep = function(timestamp) {
                if (startTime === null) startTime = timestamp;
                progress = timestamp - startTime;
                var percent = progress >= duration ? 1 : easing(progress / duration);
                el.scrollTo(startLeft + Math.ceil(deltaLeft * percent), startTop + Math.ceil(deltaTop * percent));
                if (percent < 1) scrollAnimation = requestAnimation(animationStep);
                else {
                    if (duScrollCancelOnEvents) el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
                    scrollAnimation = null;
                    deferred.resolve();
                }
            };
            //Fix random mobile safari bug when scrolling to top by hitting status bar
            el.duScrollTo(startLeft, startTop);
            if (duScrollCancelOnEvents) el.bind(duScrollCancelOnEvents, cancelScrollAnimation);
            scrollAnimation = requestAnimation(animationStep);
            return deferred.promise;
        };
        proto.duScrollToElement = function(target, offset, duration, easing) {
            var el = unwrap(this);
            if (!angular.isNumber(offset) || isNaN(offset)) offset = duScrollOffset;
            var top = this.duScrollTop() + unwrap(target).getBoundingClientRect().top - offset;
            if (isElement(el)) top -= el.getBoundingClientRect().top;
            return this.duScrollTo(0, top, duration, easing);
        };
        proto.duScrollLeft = function(value, duration, easing) {
            if (angular.isNumber(value)) return this.duScrollTo(value, this.duScrollTop(), duration, easing);
            var el = unwrap(this);
            if (isDocument(el)) return $window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft;
            return el.scrollLeft;
        };
        proto.duScrollTop = function(value, duration, easing) {
            if (angular.isNumber(value)) return this.duScrollTo(this.duScrollLeft(), value, duration, easing);
            var el = unwrap(this);
            if (isDocument(el)) return $window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
            return el.scrollTop;
        };
        proto.duScrollToElementAnimated = function(target, offset, duration, easing) {
            return this.duScrollToElement(target, offset, duration || duScrollDuration, easing);
        };
        proto.duScrollTopAnimated = function(top, duration, easing) {
            return this.duScrollTop(top, duration || duScrollDuration, easing);
        };
        proto.duScrollLeftAnimated = function(left, duration, easing) {
            return this.duScrollLeft(left, duration || duScrollDuration, easing);
        };
        angular.forEach(proto, function(fn, key) {
            angular.element.prototype[key] = fn;
            //Remove prefix if not already claimed by jQuery / ui.utils
            var unprefixed = key.replace(/^duScroll/, "scroll");
            if (angular.isUndefined(angular.element.prototype[unprefixed])) angular.element.prototype[unprefixed] = fn;
        });
    }
]);
//Adapted from https://gist.github.com/paulirish/1579671
angular.module("duScroll.polyfill", []).factory("polyfill", [
    "$window",
    function($window) {
        "use strict";
        var vendors = [
            "webkit",
            "moz",
            "o",
            "ms"
        ];
        return function(fnName, fallback) {
            if ($window[fnName]) return $window[fnName];
            var suffix = fnName.substr(0, 1).toUpperCase() + fnName.substr(1);
            for(var key, i = 0; i < vendors.length; i++){
                key = vendors[i] + suffix;
                if ($window[key]) return $window[key];
            }
            return fallback;
        };
    }
]);
angular.module("duScroll.requestAnimation", [
    "duScroll.polyfill"
]).factory("requestAnimation", [
    "polyfill",
    "$timeout",
    function(polyfill, $timeout) {
        "use strict";
        var lastTime = 0;
        var fallback = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = $timeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
        return polyfill("requestAnimationFrame", fallback);
    }
]).factory("cancelAnimation", [
    "polyfill",
    "$timeout",
    function(polyfill, $timeout) {
        "use strict";
        var fallback = function(promise) {
            $timeout.cancel(promise);
        };
        return polyfill("cancelAnimationFrame", fallback);
    }
]);
angular.module("duScroll.spyAPI", [
    "duScroll.scrollContainerAPI"
]).factory("spyAPI", [
    "$rootScope",
    "$timeout",
    "$interval",
    "$window",
    "$document",
    "scrollContainerAPI",
    "duScrollGreedy",
    "duScrollSpyWait",
    "duScrollSpyRefreshInterval",
    "duScrollBottomSpy",
    "duScrollActiveClass",
    function($rootScope, $timeout, $interval, $window, $document, scrollContainerAPI, duScrollGreedy, duScrollSpyWait, duScrollSpyRefreshInterval, duScrollBottomSpy, duScrollActiveClass) {
        "use strict";
        var createScrollHandler = function(context) {
            var timer = false, queued = false;
            var handler = function() {
                queued = false;
                var container = context.container, containerEl = container[0], containerOffset = 0, bottomReached;
                if (typeof HTMLElement !== "undefined" && containerEl instanceof HTMLElement || containerEl.nodeType && containerEl.nodeType === containerEl.ELEMENT_NODE) {
                    containerOffset = containerEl.getBoundingClientRect().top;
                    bottomReached = Math.round(containerEl.scrollTop + containerEl.clientHeight) >= containerEl.scrollHeight;
                } else {
                    var documentScrollHeight = $document[0].body.scrollHeight || $document[0].documentElement.scrollHeight; // documentElement for IE11
                    bottomReached = Math.round($window.pageYOffset + $window.innerHeight) >= documentScrollHeight;
                }
                var compareProperty = duScrollBottomSpy && bottomReached ? "bottom" : "top";
                var i, currentlyActive, toBeActive, spies, spy, pos;
                spies = context.spies;
                currentlyActive = context.currentlyActive;
                toBeActive = undefined;
                for(i = 0; i < spies.length; i++){
                    spy = spies[i];
                    pos = spy.getTargetPosition();
                    if (!pos || !spy.$element) continue;
                    if (duScrollBottomSpy && bottomReached || pos.top + spy.offset - containerOffset < 20 && (duScrollGreedy || pos.top * -1 + containerOffset) < pos.height) //Find the one closest the viewport top or the page bottom if it's reached
                    {
                        if (!toBeActive || toBeActive[compareProperty] < pos[compareProperty]) {
                            toBeActive = {
                                spy: spy
                            };
                            toBeActive[compareProperty] = pos[compareProperty];
                        }
                    }
                }
                if (toBeActive) toBeActive = toBeActive.spy;
                if (currentlyActive === toBeActive || duScrollGreedy && !toBeActive) return;
                if (currentlyActive && currentlyActive.$element) {
                    currentlyActive.$element.removeClass(duScrollActiveClass);
                    $rootScope.$broadcast("duScrollspy:becameInactive", currentlyActive.$element, angular.element(currentlyActive.getTargetElement()));
                }
                if (toBeActive) {
                    toBeActive.$element.addClass(duScrollActiveClass);
                    $rootScope.$broadcast("duScrollspy:becameActive", toBeActive.$element, angular.element(toBeActive.getTargetElement()));
                }
                context.currentlyActive = toBeActive;
            };
            if (!duScrollSpyWait) return handler;
            //Debounce for potential performance savings
            return function() {
                if (!timer) {
                    handler();
                    timer = $timeout(function() {
                        timer = false;
                        if (queued) handler();
                    }, duScrollSpyWait, false);
                } else queued = true;
            };
        };
        var contexts = {};
        var createContext = function($scope) {
            var id = $scope.$id;
            var context = {
                spies: []
            };
            context.handler = createScrollHandler(context);
            contexts[id] = context;
            $scope.$on("$destroy", function() {
                destroyContext($scope);
            });
            return id;
        };
        var destroyContext = function($scope) {
            var id = $scope.$id;
            var context = contexts[id], container = context.container;
            if (context.intervalPromise) $interval.cancel(context.intervalPromise);
            if (container) container.off("scroll", context.handler);
            delete contexts[id];
        };
        var defaultContextId = createContext($rootScope);
        var getContextForScope = function(scope) {
            if (contexts[scope.$id]) return contexts[scope.$id];
            if (scope.$parent) return getContextForScope(scope.$parent);
            return contexts[defaultContextId];
        };
        var getContextForSpy = function(spy) {
            var context, contextId, scope = spy.$scope;
            if (scope) return getContextForScope(scope);
            //No scope, most likely destroyed
            for(contextId in contexts){
                context = contexts[contextId];
                if (context.spies.indexOf(spy) !== -1) return context;
            }
        };
        var isElementInDocument = function(element) {
            while(element.parentNode){
                element = element.parentNode;
                if (element === document) return true;
            }
            return false;
        };
        var addSpy = function(spy) {
            var context = getContextForSpy(spy);
            if (!context) return;
            context.spies.push(spy);
            if (!context.container || !isElementInDocument(context.container)) {
                if (context.container) context.container.off("scroll", context.handler);
                context.container = scrollContainerAPI.getContainer(spy.$scope);
                if (duScrollSpyRefreshInterval && !context.intervalPromise) context.intervalPromise = $interval(context.handler, duScrollSpyRefreshInterval, 0, false);
                context.container.on("scroll", context.handler).triggerHandler("scroll");
            }
        };
        var removeSpy = function(spy) {
            var context = getContextForSpy(spy);
            if (spy === context.currentlyActive) {
                $rootScope.$broadcast("duScrollspy:becameInactive", context.currentlyActive.$element);
                context.currentlyActive = null;
            }
            var i = context.spies.indexOf(spy);
            if (i !== -1) context.spies.splice(i, 1);
            spy.$element = null;
        };
        return {
            addSpy: addSpy,
            removeSpy: removeSpy,
            createContext: createContext,
            destroyContext: destroyContext,
            getContextForScope: getContextForScope
        };
    }
]);
angular.module("duScroll.scrollContainerAPI", []).factory("scrollContainerAPI", [
    "$document",
    function($document) {
        "use strict";
        var containers = {};
        var setContainer = function(scope, element) {
            var id = scope.$id;
            containers[id] = element;
            return id;
        };
        var getContainerId = function(scope) {
            if (containers[scope.$id]) return scope.$id;
            if (scope.$parent) return getContainerId(scope.$parent);
            return;
        };
        var getContainer = function(scope) {
            var id = getContainerId(scope);
            return id ? containers[id] : $document;
        };
        var removeContainer = function(scope) {
            var id = getContainerId(scope);
            if (id) delete containers[id];
        };
        return {
            getContainerId: getContainerId,
            getContainer: getContainer,
            setContainer: setContainer,
            removeContainer: removeContainer
        };
    }
]);
angular.module("duScroll.smoothScroll", [
    "duScroll.scrollHelpers",
    "duScroll.scrollContainerAPI"
]).directive("duSmoothScroll", [
    "duScrollDuration",
    "duScrollOffset",
    "scrollContainerAPI",
    function(duScrollDuration, duScrollOffset, scrollContainerAPI) {
        "use strict";
        return {
            link: function($scope, $element, $attr) {
                $element.on("click", function(e) {
                    if ((!$attr.href || $attr.href.indexOf("#") === -1) && $attr.duSmoothScroll === "") return;
                    var id = $attr.href ? $attr.href.replace(/.*(?=#[^\s]+$)/, "").substring(1) : $attr.duSmoothScroll;
                    var target = document.getElementById(id) || document.getElementsByName(id)[0];
                    if (!target || !target.getBoundingClientRect) return;
                    if (e.stopPropagation) e.stopPropagation();
                    if (e.preventDefault) e.preventDefault();
                    var offset = $attr.offset ? parseInt($attr.offset, 10) : duScrollOffset;
                    var duration = $attr.duration ? parseInt($attr.duration, 10) : duScrollDuration;
                    var container = scrollContainerAPI.getContainer($scope);
                    container.duScrollToElement(angular.element(target), isNaN(offset) ? 0 : offset, isNaN(duration) ? 0 : duration);
                });
            }
        };
    }
]);
angular.module("duScroll.spyContext", [
    "duScroll.spyAPI"
]).directive("duSpyContext", [
    "spyAPI",
    function(spyAPI) {
        "use strict";
        return {
            restrict: "A",
            scope: true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    pre: function preLink($scope, iElement, iAttrs, controller) {
                        spyAPI.createContext($scope);
                    }
                };
            }
        };
    }
]);
angular.module("duScroll.scrollContainer", [
    "duScroll.scrollContainerAPI"
]).directive("duScrollContainer", [
    "scrollContainerAPI",
    function(scrollContainerAPI) {
        "use strict";
        return {
            restrict: "A",
            scope: true,
            compile: function compile(tElement, tAttrs, transclude) {
                return {
                    pre: function preLink($scope, iElement, iAttrs, controller) {
                        iAttrs.$observe("duScrollContainer", function(element) {
                            if (angular.isString(element)) element = document.getElementById(element);
                            element = angular.isElement(element) ? angular.element(element) : iElement;
                            scrollContainerAPI.setContainer($scope, element);
                            $scope.$on("$destroy", function() {
                                scrollContainerAPI.removeContainer($scope);
                            });
                        });
                    }
                };
            }
        };
    }
]);
angular.module("duScroll.scrollspy", [
    "duScroll.spyAPI"
]).directive("duScrollspy", [
    "spyAPI",
    "duScrollOffset",
    "$timeout",
    "$rootScope",
    function(spyAPI, duScrollOffset, $timeout, $rootScope) {
        "use strict";
        var Spy = function(targetElementOrId, $scope, $element, offset) {
            if (angular.isElement(targetElementOrId)) this.target = targetElementOrId;
            else if (angular.isString(targetElementOrId)) this.targetId = targetElementOrId;
            this.$scope = $scope;
            this.$element = $element;
            this.offset = offset;
        };
        Spy.prototype.getTargetElement = function() {
            if (!this.target && this.targetId) this.target = document.getElementById(this.targetId) || document.getElementsByName(this.targetId)[0];
            return this.target;
        };
        Spy.prototype.getTargetPosition = function() {
            var target = this.getTargetElement();
            if (target) return target.getBoundingClientRect();
        };
        Spy.prototype.flushTargetCache = function() {
            if (this.targetId) this.target = undefined;
        };
        return {
            link: function($scope, $element, $attr) {
                var href = $attr.ngHref || $attr.href;
                var targetId;
                if (href && href.indexOf("#") !== -1) targetId = href.replace(/.*(?=#[^\s]+$)/, "").substring(1);
                else if ($attr.duScrollspy) targetId = $attr.duScrollspy;
                else if ($attr.duSmoothScroll) targetId = $attr.duSmoothScroll;
                if (!targetId) return;
                // Run this in the next execution loop so that the scroll context has a chance
                // to initialize
                var timeoutPromise = $timeout(function() {
                    var spy = new Spy(targetId, $scope, $element, -($attr.offset ? parseInt($attr.offset, 10) : duScrollOffset));
                    spyAPI.addSpy(spy);
                    $scope.$on("$locationChangeSuccess", spy.flushTargetCache.bind(spy));
                    var deregisterOnStateChange = $rootScope.$on("$stateChangeSuccess", spy.flushTargetCache.bind(spy));
                    $scope.$on("$destroy", function() {
                        spyAPI.removeSpy(spy);
                        deregisterOnStateChange();
                    });
                }, 0, false);
                $scope.$on("$destroy", function() {
                    $timeout.cancel(timeoutPromise);
                });
            }
        };
    }
]);

});

parcelRegister("eVcdp", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("4plJH").then(()=>parcelRequire("hKcdE"));

});
parcelRegister("bkk7e", function(module, exports) {
"use strict";

function $83f12a89286afbd8$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("9e8oV")).resolve(id));
}
module.exports = $83f12a89286afbd8$var$load;

});


parcelRegister("7jFWT", function(module, exports) {

































module.exports = {
    "ar": ()=>(parcelRequire("7zcal")),
    "bg": ()=>(parcelRequire("jUpwk")),
    "ca": ()=>(parcelRequire("97oG9")),
    "cs": ()=>(parcelRequire("fJOHA")),
    "da": ()=>(parcelRequire("fTnhE")),
    "de": ()=>(parcelRequire("hNhSZ")),
    "el": ()=>(parcelRequire("Xuoge")),
    "en": ()=>(parcelRequire("cmfxZ")),
    "es": ()=>(parcelRequire("dWnSt")),
    "eu": ()=>(parcelRequire("i4bHs")),
    "fi": ()=>(parcelRequire("bmptj")),
    "fr": ()=>(parcelRequire("gD6lQ")),
    "hr": ()=>(parcelRequire("5P664")),
    "hu": ()=>(parcelRequire("cTSqw")),
    "id": ()=>(parcelRequire("2nYe4")),
    "it": ()=>(parcelRequire("iDlhQ")),
    "ja": ()=>(parcelRequire("hn1uD")),
    "ko": ()=>(parcelRequire("ipppg")),
    "nb": ()=>(parcelRequire("hhdVs")),
    "nl": ()=>(parcelRequire("aZM0u")),
    "pl": ()=>(parcelRequire("5V9QP")),
    "pt-BR": ()=>(parcelRequire("ifp91")),
    "pt": ()=>(parcelRequire("3qNOB")),
    "ro": ()=>(parcelRequire("a39aE")),
    "ru": ()=>(parcelRequire("dLRb4")),
    "si": ()=>(parcelRequire("a4R4f")),
    "sk": ()=>(parcelRequire("7WROp")),
    "sl": ()=>(parcelRequire("kN4kh")),
    "sv": ()=>(parcelRequire("7uU81")),
    "th": ()=>(parcelRequire("9M34a")),
    "tr": ()=>(parcelRequire("9WR0t")),
    "uk": ()=>(parcelRequire("bsOpT")),
    "zh": ()=>(parcelRequire("gwyCu"))
};

});
parcelRegister("7zcal", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("9pg4S").then(()=>parcelRequire("1G9Wv"));

});

parcelRegister("jUpwk", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("i8sLH").then(()=>parcelRequire("1kJ3j"));

});

parcelRegister("97oG9", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("1ipxr").then(()=>parcelRequire("hnZtc"));

});

parcelRegister("fJOHA", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("iT21j").then(()=>parcelRequire("ezvN0"));

});

parcelRegister("fTnhE", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("7X3wi").then(()=>parcelRequire("7PylX"));

});

parcelRegister("hNhSZ", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("cStjn").then(()=>parcelRequire("3whZF"));

});

parcelRegister("Xuoge", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("cTWIU").then(()=>parcelRequire("bUumf"));

});

parcelRegister("cmfxZ", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("6bx0z").then(()=>parcelRequire("5wuwC"));

});

parcelRegister("dWnSt", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("hTr57").then(()=>parcelRequire("lF5z9"));

});

parcelRegister("i4bHs", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("27Ech").then(()=>parcelRequire("2WouT"));

});

parcelRegister("bmptj", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("hDXSZ").then(()=>parcelRequire("02zuw"));

});

parcelRegister("gD6lQ", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("dNrkj").then(()=>parcelRequire("78z10"));

});

parcelRegister("5P664", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("fZ0EM").then(()=>parcelRequire("C7cJm"));

});

parcelRegister("cTSqw", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("kbY6K").then(()=>parcelRequire("4FCfX"));

});

parcelRegister("2nYe4", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("c7gRi").then(()=>parcelRequire("lt8qs"));

});

parcelRegister("iDlhQ", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("BXW6O").then(()=>parcelRequire("ckhrk"));

});

parcelRegister("hn1uD", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("RV3yF").then(()=>parcelRequire("gs6RM"));

});

parcelRegister("ipppg", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("eCrY2").then(()=>parcelRequire("6wAuO"));

});

parcelRegister("hhdVs", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("6mnY3").then(()=>parcelRequire("g97zt"));

});

parcelRegister("aZM0u", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("91wZ8").then(()=>parcelRequire("iXnpV"));

});

parcelRegister("5V9QP", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("iV3y6").then(()=>parcelRequire("lRi63"));

});

parcelRegister("ifp91", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("2bQsb").then(()=>parcelRequire("DmpkC"));

});

parcelRegister("3qNOB", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("fDnp1").then(()=>parcelRequire("eykA9"));

});

parcelRegister("a39aE", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("boHb3").then(()=>parcelRequire("5MQbF"));

});

parcelRegister("dLRb4", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("kUZi9").then(()=>parcelRequire("hZFJ9"));

});

parcelRegister("a4R4f", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("17IPA").then(()=>parcelRequire("grlng"));

});

parcelRegister("7WROp", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("ktR7K").then(()=>parcelRequire("lQoas"));

});

parcelRegister("kN4kh", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("3CKmt").then(()=>parcelRequire("4JpQ5"));

});

parcelRegister("7uU81", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("9aWvP").then(()=>parcelRequire("31ApE"));

});

parcelRegister("9M34a", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("8SKxs").then(()=>parcelRequire("45coW"));

});

parcelRegister("9WR0t", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("bV8Na").then(()=>parcelRequire("6VYWw"));

});

parcelRegister("bsOpT", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("bL4v8").then(()=>parcelRequire("irtOc"));

});

parcelRegister("gwyCu", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("4cq8S").then(()=>parcelRequire("iedZ6"));

});


parcelRegister("jrvpg", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("50VAo").then(()=>parcelRequire("fFVzp"));

});

parcelRegister("ltvF3", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $dL2V0 = parcelRequire("dL2V0");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === "number") super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $dL2V0.getWindow)();
    const document = (0, $dL2V0.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(" ")));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(" ");
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(" ");
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $dL2V0.getWindow)();
    const events = args[0].split(" ");
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
    }
    if (callback) dom.on("transitionstart", fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function width() {
    const window = (0, $dL2V0.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $dL2V0.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $dL2V0.getWindow)();
        const document = (0, $dL2V0.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function show() {
    const window = (0, $dL2V0.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function styles() {
    const window = (0, $dL2V0.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $dL2V0.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $dL2V0.getWindow)();
    const document = (0, $dL2V0.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === "undefined") return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $dL2V0.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $dL2V0.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $dL2V0.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $dL2V0.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = "resize scroll".split(" ");
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut("click");
const blur = shortcut("blur");
const focus = shortcut("focus");
const focusin = shortcut("focusin");
const focusout = shortcut("focusout");
const keyup = shortcut("keyup");
const keydown = shortcut("keydown");
const keypress = shortcut("keypress");
const submit = shortcut("submit");
const change = shortcut("change");
const mousedown = shortcut("mousedown");
const mousemove = shortcut("mousemove");
const mouseup = shortcut("mouseup");
const mouseenter = shortcut("mouseenter");
const mouseleave = shortcut("mouseleave");
const mouseout = shortcut("mouseout");
const mouseover = shortcut("mouseover");
const touchstart = shortcut("touchstart");
const touchend = shortcut("touchend");
const touchmove = shortcut("touchmove");
const resize = shortcut("resize");
const scroll = shortcut("scroll");
var $fa24dda75b739f89$export$2e2bcd8739ae039 = $;

});
parcelRegister("dL2V0", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $a041edb4f5102d8f$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $a041edb4f5102d8f$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $a041edb4f5102d8f$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $a041edb4f5102d8f$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($a041edb4f5102d8f$var$isObject(src[key]) && $a041edb4f5102d8f$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $a041edb4f5102d8f$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $a041edb4f5102d8f$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $a041edb4f5102d8f$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $a041edb4f5102d8f$export$8b58be045bf06082(doc, $a041edb4f5102d8f$export$3fdcb9b4d81368d8);
    return doc;
}
const $a041edb4f5102d8f$export$8582633f185c62bb = {
    document: $a041edb4f5102d8f$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $a041edb4f5102d8f$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $a041edb4f5102d8f$export$8b58be045bf06082(win, $a041edb4f5102d8f$export$8582633f185c62bb);
    return win;
}

});


parcelRegister("cwgwH", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return delay; });
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $fQGWn = parcelRequire("fQGWn");

var $fz7Gd = parcelRequire("fz7Gd");

var $2Dqpi = parcelRequire("2Dqpi");

var $4Wpcr = parcelRequire("4Wpcr");
function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = (0, $fQGWn.async);
    var absoluteDelay = (0, $fz7Gd.isDate)(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
var DelayOperator = /*@__PURE__*/ function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
var DelaySubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification((0, $4Wpcr.Notification).createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification((0, $4Wpcr.Notification).createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}((0, $2Dqpi.Subscriber));
var DelayMessage = /*@__PURE__*/ function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});
parcelRegister("iBNdU", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $d8c1dd6fea019bd1$export$a8ba968b8961cb8a; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $d8c1dd6fea019bd1$var$extendStatics = function(d, b) {
    $d8c1dd6fea019bd1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $d8c1dd6fea019bd1$var$extendStatics(d, b);
};
function $d8c1dd6fea019bd1$export$a8ba968b8961cb8a(d, b) {
    $d8c1dd6fea019bd1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d8c1dd6fea019bd1$export$18ce0697a983be9b = function() {
    $d8c1dd6fea019bd1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d8c1dd6fea019bd1$export$18ce0697a983be9b.apply(this, arguments);
};
function $d8c1dd6fea019bd1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d8c1dd6fea019bd1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d8c1dd6fea019bd1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d8c1dd6fea019bd1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d8c1dd6fea019bd1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d8c1dd6fea019bd1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $d8c1dd6fea019bd1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $d8c1dd6fea019bd1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $d8c1dd6fea019bd1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d8c1dd6fea019bd1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d8c1dd6fea019bd1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d8c1dd6fea019bd1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d8c1dd6fea019bd1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d8c1dd6fea019bd1$export$10c90e4f7922046c(v) {
    return this instanceof $d8c1dd6fea019bd1$export$10c90e4f7922046c ? (this.v = v, this) : new $d8c1dd6fea019bd1$export$10c90e4f7922046c(v);
}
function $d8c1dd6fea019bd1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d8c1dd6fea019bd1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d8c1dd6fea019bd1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d8c1dd6fea019bd1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $d8c1dd6fea019bd1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d8c1dd6fea019bd1$export$19a8beecd37a4c45 === "function" ? $d8c1dd6fea019bd1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d8c1dd6fea019bd1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $d8c1dd6fea019bd1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $d8c1dd6fea019bd1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d8c1dd6fea019bd1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $d8c1dd6fea019bd1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("fQGWn", function(module, exports) {

$parcel$export(module.exports, "async", function () { return $b89d056d5a88367a$export$12af436354f1a4f7; });
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ 
var $c8nQ0 = parcelRequire("c8nQ0");

var $kYlIh = parcelRequire("kYlIh");
var $b89d056d5a88367a$export$8d6b71a2b178fc32 = /*@__PURE__*/ new (0, $kYlIh.AsyncScheduler)((0, $c8nQ0.AsyncAction));
var $b89d056d5a88367a$export$12af436354f1a4f7 = $b89d056d5a88367a$export$8d6b71a2b178fc32;

});
parcelRegister("c8nQ0", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", function () { return $8d58b91a1aef9293$export$b5369ffd7cb2211b; });
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $gDL0O = parcelRequire("gDL0O");
var $8d58b91a1aef9293$export$b5369ffd7cb2211b = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, $gDL0O.Action));

});
parcelRegister("gDL0O", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $c1d4c17f22f75036$export$e19cd5f9376f8cee; });
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $iIdN6 = parcelRequire("iIdN6");
var $c1d4c17f22f75036$export$e19cd5f9376f8cee = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $iIdN6.Subscription));

});
parcelRegister("iIdN6", function(module, exports) {

$parcel$export(module.exports, "Subscription", function () { return $d9f708adbf75e4a5$export$f55210826850c514; });
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ 
var $lXN9m = parcelRequire("lXN9m");

var $kd9kt = parcelRequire("kd9kt");

var $lvTqi = parcelRequire("lvTqi");

var $3Ec1K = parcelRequire("3Ec1K");
var $d9f708adbf75e4a5$export$f55210826850c514 = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, $lvTqi.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, $3Ec1K.UnsubscriptionError) ? $d9f708adbf75e4a5$var$flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, $lXN9m.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, $kd9kt.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, $3Ec1K.UnsubscriptionError)) errors = errors.concat($d9f708adbf75e4a5$var$flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, $3Ec1K.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function $d9f708adbf75e4a5$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, $3Ec1K.UnsubscriptionError) ? err.errors : err);
    }, []);
}

});
parcelRegister("lXN9m", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $ffd53bcee594f8e6$export$43bee75e5e14138e; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $ffd53bcee594f8e6$export$43bee75e5e14138e = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

});

parcelRegister("kd9kt", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $eb6c4222a4936a38$export$a6cdc56e425d0d0a; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $eb6c4222a4936a38$export$a6cdc56e425d0d0a(x) {
    return x !== null && typeof x === "object";
}

});

parcelRegister("lvTqi", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $fa977c1e0decd983$export$f6e2535fb5126e54; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $fa977c1e0decd983$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}

});

parcelRegister("3Ec1K", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", function () { return $2a7e6fe209ac7bf5$export$c9648b76fd580c34; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $2a7e6fe209ac7bf5$var$UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var $2a7e6fe209ac7bf5$export$c9648b76fd580c34 = $2a7e6fe209ac7bf5$var$UnsubscriptionErrorImpl;

});




parcelRegister("kYlIh", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", function () { return $f44a410aa06ade1f$export$4114a3ec92faa3c6; });
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $d86QB = parcelRequire("d86QB");
var $f44a410aa06ade1f$export$4114a3ec92faa3c6 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $d86QB.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $d86QB.Scheduler));

});
parcelRegister("d86QB", function(module, exports) {

$parcel$export(module.exports, "Scheduler", function () { return $98f155733d1221a4$export$d3e54bb8584cda7c; });
var $98f155733d1221a4$export$d3e54bb8584cda7c = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

});



parcelRegister("fz7Gd", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $b55014f2bd932967$export$871608497c498473; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $b55014f2bd932967$export$871608497c498473(value) {
    return value instanceof Date && !isNaN(+value);
}

});

parcelRegister("2Dqpi", function(module, exports) {

$parcel$export(module.exports, "Subscriber", function () { return $1eb3b5316241ea16$export$60959659b2c22881; });
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $lvTqi = parcelRequire("lvTqi");

var $hc8yu = parcelRequire("hc8yu");

var $iIdN6 = parcelRequire("iIdN6");

var $67SG3 = parcelRequire("67SG3");

var $3Lgcu = parcelRequire("3Lgcu");

var $cvk2N = parcelRequire("cvk2N");
var $1eb3b5316241ea16$export$60959659b2c22881 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, $hc8yu.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, $hc8yu.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new $1eb3b5316241ea16$export$94eeb6a328cab6c7(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new $1eb3b5316241ea16$export$94eeb6a328cab6c7(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, $67SG3.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, $iIdN6.Subscription));
var $1eb3b5316241ea16$export$94eeb6a328cab6c7 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, $lvTqi.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, $hc8yu.empty)) {
                context = Object.create(observerOrNext);
                if ((0, $lvTqi.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, $cvk2N.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, $cvk2N.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, $cvk2N.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, $cvk2N.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($1eb3b5316241ea16$export$60959659b2c22881);

});
parcelRegister("hc8yu", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $c84a318c9aa1d404$export$6e22c362a0406a2c; });
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ 
var $3Lgcu = parcelRequire("3Lgcu");

var $cvk2N = parcelRequire("cvk2N");
var $c84a318c9aa1d404$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, $cvk2N.hostReportError)(err);
    },
    complete: function() {}
};

});
parcelRegister("3Lgcu", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $2bd253f1a74ecb18$export$e506a1d27d1eaa20; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $2bd253f1a74ecb18$var$_enable_super_gross_mode_that_will_cause_bad_things = false;
var $2bd253f1a74ecb18$export$e506a1d27d1eaa20 = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if ($2bd253f1a74ecb18$var$_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        $2bd253f1a74ecb18$var$_enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return $2bd253f1a74ecb18$var$_enable_super_gross_mode_that_will_cause_bad_things;
    }
};

});

parcelRegister("cvk2N", function(module, exports) {

$parcel$export(module.exports, "hostReportError", function () { return $91a7ed9d7322566e$export$ebb0f299889f975f; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $91a7ed9d7322566e$export$ebb0f299889f975f(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

});


parcelRegister("67SG3", function(module, exports) {

$parcel$export(module.exports, "rxSubscriber", function () { return $475dcf4c16171131$export$77f77496d7cade10; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $475dcf4c16171131$export$77f77496d7cade10 = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $475dcf4c16171131$export$4a2e07ff24d010f0 = $475dcf4c16171131$export$77f77496d7cade10;

});


parcelRegister("4Wpcr", function(module, exports) {

$parcel$export(module.exports, "Notification", function () { return $399020536a59a788$export$14834abbfce3b8cd; });
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ 
var $b42vV = parcelRequire("b42vV");

var $jkiWk = parcelRequire("jkiWk");

var $k5U9p = parcelRequire("k5U9p");
var $399020536a59a788$export$f59c804e350a7a80;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})($399020536a59a788$export$f59c804e350a7a80 || ($399020536a59a788$export$f59c804e350a7a80 = {}));
var $399020536a59a788$export$14834abbfce3b8cd = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, $jkiWk.of)(this.value);
            case "E":
                return (0, $k5U9p.throwError)(this.error);
            case "C":
                return (0, $b42vV.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

});
parcelRegister("b42vV", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $80e204a3a5716ea6$export$6e22c362a0406a2c; });
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");
var $80e204a3a5716ea6$export$ccb33e29d92c9a58 = /*@__PURE__*/ new (0, $eGy0D.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $80e204a3a5716ea6$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $80e204a3a5716ea6$var$emptyScheduled(scheduler) : $80e204a3a5716ea6$export$ccb33e29d92c9a58;
}
function $80e204a3a5716ea6$var$emptyScheduled(scheduler) {
    return new (0, $eGy0D.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});
parcelRegister("eGy0D", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $ab0f5e701d55a6ab$export$77cea355fa80b5f4; });
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ 
var $kNAZz = parcelRequire("kNAZz");

var $jJDsz = parcelRequire("jJDsz");

var $5LiuA = parcelRequire("5LiuA");

var $6sfen = parcelRequire("6sfen");

var $3Lgcu = parcelRequire("3Lgcu");
var $ab0f5e701d55a6ab$export$77cea355fa80b5f4 = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, $jJDsz.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, $3Lgcu.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, $kNAZz.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $ab0f5e701d55a6ab$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, $5LiuA.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, $6sfen.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $ab0f5e701d55a6ab$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $ab0f5e701d55a6ab$var$getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, $3Lgcu.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

});
parcelRegister("kNAZz", function(module, exports) {

$parcel$export(module.exports, "canReportError", function () { return $f245141598130b9c$export$f7d54ecb625129e3; });
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ 
var $2Dqpi = parcelRequire("2Dqpi");
function $f245141598130b9c$export$f7d54ecb625129e3(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, $2Dqpi.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

});

parcelRegister("jJDsz", function(module, exports) {

$parcel$export(module.exports, "toSubscriber", function () { return $e5e0d4329246fa23$export$2a12c2cebbfd1087; });
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ 
var $2Dqpi = parcelRequire("2Dqpi");

var $67SG3 = parcelRequire("67SG3");

var $hc8yu = parcelRequire("hc8yu");
function $e5e0d4329246fa23$export$2a12c2cebbfd1087(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, $2Dqpi.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, $67SG3.rxSubscriber]) return nextOrObserver[0, $67SG3.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, $2Dqpi.Subscriber)((0, $hc8yu.empty));
    return new (0, $2Dqpi.Subscriber)(nextOrObserver, error, complete);
}

});

parcelRegister("5LiuA", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return $431fafc021838e6a$export$5ab46cbf6120b33a; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $431fafc021838e6a$export$5ab46cbf6120b33a = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("6sfen", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", function () { return $4b312c28a5eb228c$export$71f88a61afaa14d7; });
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ 
var $dkdR0 = parcelRequire("dkdR0");
function $4b312c28a5eb228c$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $4b312c28a5eb228c$export$71f88a61afaa14d7(fns);
}
function $4b312c28a5eb228c$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $dkdR0.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("dkdR0", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $9b37e3bdbf2613ee$export$f0954fd7d5368655; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $9b37e3bdbf2613ee$export$f0954fd7d5368655(x) {
    return x;
}

});




parcelRegister("jkiWk", function(module, exports) {

$parcel$export(module.exports, "of", function () { return $e11e93a1c9a3040b$export$ba255e9e49e00608; });
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ 
var $891rE = parcelRequire("891rE");

var $83Fxp = parcelRequire("83Fxp");

var $jrHs1 = parcelRequire("jrHs1");
function $e11e93a1c9a3040b$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, $891rE.isScheduler)(scheduler)) {
        args.pop();
        return (0, $jrHs1.scheduleArray)(args, scheduler);
    } else return (0, $83Fxp.fromArray)(args);
}

});
parcelRegister("891rE", function(module, exports) {

$parcel$export(module.exports, "isScheduler", function () { return $5ee048eb836004ab$export$187e35932e88c15c; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $5ee048eb836004ab$export$187e35932e88c15c(value) {
    return value && typeof value.schedule === "function";
}

});

parcelRegister("83Fxp", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $5dded31314a15a41$export$571d59b505e6bb4e; });
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $ddp2K = parcelRequire("ddp2K");

var $jrHs1 = parcelRequire("jrHs1");
function $5dded31314a15a41$export$571d59b505e6bb4e(input, scheduler) {
    if (!scheduler) return new (0, $eGy0D.Observable)((0, $ddp2K.subscribeToArray)(input));
    else return (0, $jrHs1.scheduleArray)(input, scheduler);
}

});
parcelRegister("ddp2K", function(module, exports) {

$parcel$export(module.exports, "subscribeToArray", function () { return $99efea57d9b15379$export$ab22aa77f372e159; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $99efea57d9b15379$export$ab22aa77f372e159 = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

});

parcelRegister("jrHs1", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", function () { return $e2823e6061258234$export$b34673931371729a; });
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $iIdN6 = parcelRequire("iIdN6");
function $e2823e6061258234$export$b34673931371729a(input, scheduler) {
    return new (0, $eGy0D.Observable)(function(subscriber) {
        var sub = new (0, $iIdN6.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

});



parcelRegister("k5U9p", function(module, exports) {

$parcel$export(module.exports, "throwError", function () { return $ea0fd4a7b4b29dbc$export$8bf7aba4a9e09055; });
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");
function $ea0fd4a7b4b29dbc$export$8bf7aba4a9e09055(error, scheduler) {
    if (!scheduler) return new (0, $eGy0D.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, $eGy0D.Observable)(function(subscriber) {
        return scheduler.schedule($ea0fd4a7b4b29dbc$var$dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function $ea0fd4a7b4b29dbc$var$dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

});



parcelRegister("aMz5n", function(module, exports) {

var $bkk7e = parcelRequire("bkk7e");
module.exports = $bkk7e("XBfAl").then(()=>parcelRequire("79s7F"));

});

parcelRegister("lcQJb", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
$parcel$export(module.exports, "SteppedEase", function () { return SteppedEase; });
$parcel$export(module.exports, "TimelineMax", function () { return Timeline; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("1E71g", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("Ng9JZ", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $a9W8C = parcelRequire("a9W8C");

var $hyfas = parcelRequire("hyfas");

var $1mJBV = parcelRequire("1mJBV");

var $NHadK = parcelRequire("NHadK");
function $09411bfc16407e6e$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $09411bfc16407e6e$var$BigIntSupported = typeof BigInt !== "undefined";
var $09411bfc16407e6e$var$SymbolSupported = typeof Symbol !== "undefined";
var $09411bfc16407e6e$var$ObjectToString = $09411bfc16407e6e$var$uncurryThis(Object.prototype.toString);
var $09411bfc16407e6e$var$numberValue = $09411bfc16407e6e$var$uncurryThis(Number.prototype.valueOf);
var $09411bfc16407e6e$var$stringValue = $09411bfc16407e6e$var$uncurryThis(String.prototype.valueOf);
var $09411bfc16407e6e$var$booleanValue = $09411bfc16407e6e$var$uncurryThis(Boolean.prototype.valueOf);
if ($09411bfc16407e6e$var$BigIntSupported) var $09411bfc16407e6e$var$bigIntValue = $09411bfc16407e6e$var$uncurryThis(BigInt.prototype.valueOf);
if ($09411bfc16407e6e$var$SymbolSupported) var $09411bfc16407e6e$var$symbolValue = $09411bfc16407e6e$var$uncurryThis(Symbol.prototype.valueOf);
function $09411bfc16407e6e$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $a9W8C;
module.exports.isGeneratorFunction = $hyfas;
module.exports.isTypedArray = $NHadK;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $09411bfc16407e6e$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $09411bfc16407e6e$var$isPromise;
function $09411bfc16407e6e$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $NHadK(value) || $09411bfc16407e6e$var$isDataView(value);
}
module.exports.isArrayBufferView = $09411bfc16407e6e$var$isArrayBufferView;
function $09411bfc16407e6e$var$isUint8Array(value) {
    return $1mJBV(value) === "Uint8Array";
}
module.exports.isUint8Array = $09411bfc16407e6e$var$isUint8Array;
function $09411bfc16407e6e$var$isUint8ClampedArray(value) {
    return $1mJBV(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $09411bfc16407e6e$var$isUint8ClampedArray;
function $09411bfc16407e6e$var$isUint16Array(value) {
    return $1mJBV(value) === "Uint16Array";
}
module.exports.isUint16Array = $09411bfc16407e6e$var$isUint16Array;
function $09411bfc16407e6e$var$isUint32Array(value) {
    return $1mJBV(value) === "Uint32Array";
}
module.exports.isUint32Array = $09411bfc16407e6e$var$isUint32Array;
function $09411bfc16407e6e$var$isInt8Array(value) {
    return $1mJBV(value) === "Int8Array";
}
module.exports.isInt8Array = $09411bfc16407e6e$var$isInt8Array;
function $09411bfc16407e6e$var$isInt16Array(value) {
    return $1mJBV(value) === "Int16Array";
}
module.exports.isInt16Array = $09411bfc16407e6e$var$isInt16Array;
function $09411bfc16407e6e$var$isInt32Array(value) {
    return $1mJBV(value) === "Int32Array";
}
module.exports.isInt32Array = $09411bfc16407e6e$var$isInt32Array;
function $09411bfc16407e6e$var$isFloat32Array(value) {
    return $1mJBV(value) === "Float32Array";
}
module.exports.isFloat32Array = $09411bfc16407e6e$var$isFloat32Array;
function $09411bfc16407e6e$var$isFloat64Array(value) {
    return $1mJBV(value) === "Float64Array";
}
module.exports.isFloat64Array = $09411bfc16407e6e$var$isFloat64Array;
function $09411bfc16407e6e$var$isBigInt64Array(value) {
    return $1mJBV(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $09411bfc16407e6e$var$isBigInt64Array;
function $09411bfc16407e6e$var$isBigUint64Array(value) {
    return $1mJBV(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $09411bfc16407e6e$var$isBigUint64Array;
function $09411bfc16407e6e$var$isMapToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object Map]";
}
$09411bfc16407e6e$var$isMapToString.working = typeof Map !== "undefined" && $09411bfc16407e6e$var$isMapToString(new Map());
function $09411bfc16407e6e$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $09411bfc16407e6e$var$isMapToString.working ? $09411bfc16407e6e$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $09411bfc16407e6e$var$isMap;
function $09411bfc16407e6e$var$isSetToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object Set]";
}
$09411bfc16407e6e$var$isSetToString.working = typeof Set !== "undefined" && $09411bfc16407e6e$var$isSetToString(new Set());
function $09411bfc16407e6e$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $09411bfc16407e6e$var$isSetToString.working ? $09411bfc16407e6e$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $09411bfc16407e6e$var$isSet;
function $09411bfc16407e6e$var$isWeakMapToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object WeakMap]";
}
$09411bfc16407e6e$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $09411bfc16407e6e$var$isWeakMapToString(new WeakMap());
function $09411bfc16407e6e$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $09411bfc16407e6e$var$isWeakMapToString.working ? $09411bfc16407e6e$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $09411bfc16407e6e$var$isWeakMap;
function $09411bfc16407e6e$var$isWeakSetToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object WeakSet]";
}
$09411bfc16407e6e$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $09411bfc16407e6e$var$isWeakSetToString(new WeakSet());
function $09411bfc16407e6e$var$isWeakSet(value) {
    return $09411bfc16407e6e$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $09411bfc16407e6e$var$isWeakSet;
function $09411bfc16407e6e$var$isArrayBufferToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$09411bfc16407e6e$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $09411bfc16407e6e$var$isArrayBufferToString(new ArrayBuffer());
function $09411bfc16407e6e$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $09411bfc16407e6e$var$isArrayBufferToString.working ? $09411bfc16407e6e$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $09411bfc16407e6e$var$isArrayBuffer;
function $09411bfc16407e6e$var$isDataViewToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object DataView]";
}
$09411bfc16407e6e$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $09411bfc16407e6e$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $09411bfc16407e6e$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $09411bfc16407e6e$var$isDataViewToString.working ? $09411bfc16407e6e$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $09411bfc16407e6e$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $09411bfc16407e6e$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $09411bfc16407e6e$var$isSharedArrayBufferToString(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $09411bfc16407e6e$var$isSharedArrayBuffer(value) {
    if (typeof $09411bfc16407e6e$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $09411bfc16407e6e$var$isSharedArrayBufferToString.working === "undefined") $09411bfc16407e6e$var$isSharedArrayBufferToString.working = $09411bfc16407e6e$var$isSharedArrayBufferToString(new $09411bfc16407e6e$var$SharedArrayBufferCopy());
    return $09411bfc16407e6e$var$isSharedArrayBufferToString.working ? $09411bfc16407e6e$var$isSharedArrayBufferToString(value) : value instanceof $09411bfc16407e6e$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $09411bfc16407e6e$var$isSharedArrayBuffer;
function $09411bfc16407e6e$var$isAsyncFunction(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $09411bfc16407e6e$var$isAsyncFunction;
function $09411bfc16407e6e$var$isMapIterator(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $09411bfc16407e6e$var$isMapIterator;
function $09411bfc16407e6e$var$isSetIterator(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $09411bfc16407e6e$var$isSetIterator;
function $09411bfc16407e6e$var$isGeneratorObject(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $09411bfc16407e6e$var$isGeneratorObject;
function $09411bfc16407e6e$var$isWebAssemblyCompiledModule(value) {
    return $09411bfc16407e6e$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $09411bfc16407e6e$var$isWebAssemblyCompiledModule;
function $09411bfc16407e6e$var$isNumberObject(value) {
    return $09411bfc16407e6e$var$checkBoxedPrimitive(value, $09411bfc16407e6e$var$numberValue);
}
module.exports.isNumberObject = $09411bfc16407e6e$var$isNumberObject;
function $09411bfc16407e6e$var$isStringObject(value) {
    return $09411bfc16407e6e$var$checkBoxedPrimitive(value, $09411bfc16407e6e$var$stringValue);
}
module.exports.isStringObject = $09411bfc16407e6e$var$isStringObject;
function $09411bfc16407e6e$var$isBooleanObject(value) {
    return $09411bfc16407e6e$var$checkBoxedPrimitive(value, $09411bfc16407e6e$var$booleanValue);
}
module.exports.isBooleanObject = $09411bfc16407e6e$var$isBooleanObject;
function $09411bfc16407e6e$var$isBigIntObject(value) {
    return $09411bfc16407e6e$var$BigIntSupported && $09411bfc16407e6e$var$checkBoxedPrimitive(value, $09411bfc16407e6e$var$bigIntValue);
}
module.exports.isBigIntObject = $09411bfc16407e6e$var$isBigIntObject;
function $09411bfc16407e6e$var$isSymbolObject(value) {
    return $09411bfc16407e6e$var$SymbolSupported && $09411bfc16407e6e$var$checkBoxedPrimitive(value, $09411bfc16407e6e$var$symbolValue);
}
module.exports.isSymbolObject = $09411bfc16407e6e$var$isSymbolObject;
function $09411bfc16407e6e$var$isBoxedPrimitive(value) {
    return $09411bfc16407e6e$var$isNumberObject(value) || $09411bfc16407e6e$var$isStringObject(value) || $09411bfc16407e6e$var$isBooleanObject(value) || $09411bfc16407e6e$var$isBigIntObject(value) || $09411bfc16407e6e$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $09411bfc16407e6e$var$isBoxedPrimitive;
function $09411bfc16407e6e$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($09411bfc16407e6e$var$isArrayBuffer(value) || $09411bfc16407e6e$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $09411bfc16407e6e$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("a9W8C", function(module, exports) {
"use strict";

var $7657d7a3db045e18$var$hasToStringTag = (parcelRequire("ci493"))();

var $2rQHf = parcelRequire("2rQHf");
var $7657d7a3db045e18$var$$toString = $2rQHf("Object.prototype.toString");
var $7657d7a3db045e18$var$isStandardArguments = function isArguments(value) {
    if ($7657d7a3db045e18$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $7657d7a3db045e18$var$$toString(value) === "[object Arguments]";
};
var $7657d7a3db045e18$var$isLegacyArguments = function isArguments(value) {
    if ($7657d7a3db045e18$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $7657d7a3db045e18$var$$toString(value) !== "[object Array]" && $7657d7a3db045e18$var$$toString(value.callee) === "[object Function]";
};
var $7657d7a3db045e18$var$supportsStandardArguments = function() {
    return $7657d7a3db045e18$var$isStandardArguments(arguments);
}();
$7657d7a3db045e18$var$isStandardArguments.isLegacyArguments = $7657d7a3db045e18$var$isLegacyArguments; // for tests
module.exports = $7657d7a3db045e18$var$supportsStandardArguments ? $7657d7a3db045e18$var$isStandardArguments : $7657d7a3db045e18$var$isLegacyArguments;

});
parcelRegister("ci493", function(module, exports) {
"use strict";

var $3gGeZ = parcelRequire("3gGeZ");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $3gGeZ() && !!Symbol.toStringTag;
};

});
parcelRegister("3gGeZ", function(module, exports) {
"use strict";
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("2rQHf", function(module, exports) {
"use strict";

var $HprTF = parcelRequire("HprTF");

var $8WTax = parcelRequire("8WTax");
var $1c86fad516d98da7$var$$indexOf = $8WTax($HprTF("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $HprTF(name, !!allowMissing);
    if (typeof intrinsic === "function" && $1c86fad516d98da7$var$$indexOf(name, ".prototype.") > -1) return $8WTax(intrinsic);
    return intrinsic;
};

});
parcelRegister("HprTF", function(module, exports) {
"use strict";
var $0827c1e5fe971694$var$undefined1;

var $9ZtbR = parcelRequire("9ZtbR");

var $d9OSz = parcelRequire("d9OSz");

var $fcvSh = parcelRequire("fcvSh");

var $ctxJe = parcelRequire("ctxJe");

var $eZcnW = parcelRequire("eZcnW");

var $ERKqR = parcelRequire("ERKqR");

var $f1Dmt = parcelRequire("f1Dmt");
var $0827c1e5fe971694$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $0827c1e5fe971694$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $0827c1e5fe971694$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $0827c1e5fe971694$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($0827c1e5fe971694$var$$gOPD) try {
    $0827c1e5fe971694$var$$gOPD({}, "");
} catch (e) {
    $0827c1e5fe971694$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $0827c1e5fe971694$var$throwTypeError = function() {
    throw new $ERKqR();
};
var $0827c1e5fe971694$var$ThrowTypeError = $0827c1e5fe971694$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $0827c1e5fe971694$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $0827c1e5fe971694$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $0827c1e5fe971694$var$throwTypeError;
        }
    }
}() : $0827c1e5fe971694$var$throwTypeError;

var $0827c1e5fe971694$var$hasSymbols = (parcelRequire("fQTyX"))();

var $0827c1e5fe971694$var$hasProto = (parcelRequire("k5UlQ"))();
var $0827c1e5fe971694$var$getProto = Object.getPrototypeOf || ($0827c1e5fe971694$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $0827c1e5fe971694$var$needsEval = {};
var $0827c1e5fe971694$var$TypedArray = typeof Uint8Array === "undefined" || !$0827c1e5fe971694$var$getProto ? undefined : $0827c1e5fe971694$var$getProto(Uint8Array);
var $0827c1e5fe971694$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $0827c1e5fe971694$var$hasSymbols && $0827c1e5fe971694$var$getProto ? $0827c1e5fe971694$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $0827c1e5fe971694$var$needsEval,
    "%AsyncGenerator%": $0827c1e5fe971694$var$needsEval,
    "%AsyncGeneratorFunction%": $0827c1e5fe971694$var$needsEval,
    "%AsyncIteratorPrototype%": $0827c1e5fe971694$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $9ZtbR,
    "%eval%": eval,
    "%EvalError%": $d9OSz,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $0827c1e5fe971694$var$$Function,
    "%GeneratorFunction%": $0827c1e5fe971694$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $0827c1e5fe971694$var$hasSymbols && $0827c1e5fe971694$var$getProto ? $0827c1e5fe971694$var$getProto($0827c1e5fe971694$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$0827c1e5fe971694$var$hasSymbols || !$0827c1e5fe971694$var$getProto ? undefined : $0827c1e5fe971694$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $fcvSh,
    "%ReferenceError%": $ctxJe,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$0827c1e5fe971694$var$hasSymbols || !$0827c1e5fe971694$var$getProto ? undefined : $0827c1e5fe971694$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $0827c1e5fe971694$var$hasSymbols && $0827c1e5fe971694$var$getProto ? $0827c1e5fe971694$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $0827c1e5fe971694$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $eZcnW,
    "%ThrowTypeError%": $0827c1e5fe971694$var$ThrowTypeError,
    "%TypedArray%": $0827c1e5fe971694$var$TypedArray,
    "%TypeError%": $ERKqR,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $f1Dmt,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($0827c1e5fe971694$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $0827c1e5fe971694$var$errorProto = $0827c1e5fe971694$var$getProto($0827c1e5fe971694$var$getProto(e));
    $0827c1e5fe971694$var$INTRINSICS["%Error.prototype%"] = $0827c1e5fe971694$var$errorProto;
}
var $0827c1e5fe971694$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $0827c1e5fe971694$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $0827c1e5fe971694$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $0827c1e5fe971694$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $0827c1e5fe971694$var$getProto) value = $0827c1e5fe971694$var$getProto(gen.prototype);
    }
    $0827c1e5fe971694$var$INTRINSICS[name] = value;
    return value;
};
var $0827c1e5fe971694$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $6C6QM = parcelRequire("6C6QM");

var $9pJx8 = parcelRequire("9pJx8");
var $0827c1e5fe971694$var$$concat = $6C6QM.call(Function.call, Array.prototype.concat);
var $0827c1e5fe971694$var$$spliceApply = $6C6QM.call(Function.apply, Array.prototype.splice);
var $0827c1e5fe971694$var$$replace = $6C6QM.call(Function.call, String.prototype.replace);
var $0827c1e5fe971694$var$$strSlice = $6C6QM.call(Function.call, String.prototype.slice);
var $0827c1e5fe971694$var$$exec = $6C6QM.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $0827c1e5fe971694$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $0827c1e5fe971694$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $0827c1e5fe971694$var$stringToPath = function stringToPath(string) {
    var first = $0827c1e5fe971694$var$$strSlice(string, 0, 1);
    var last = $0827c1e5fe971694$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $eZcnW("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $eZcnW("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $0827c1e5fe971694$var$$replace(string, $0827c1e5fe971694$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $0827c1e5fe971694$var$$replace(subString, $0827c1e5fe971694$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $0827c1e5fe971694$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9pJx8($0827c1e5fe971694$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $0827c1e5fe971694$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($9pJx8($0827c1e5fe971694$var$INTRINSICS, intrinsicName)) {
        var value = $0827c1e5fe971694$var$INTRINSICS[intrinsicName];
        if (value === $0827c1e5fe971694$var$needsEval) value = $0827c1e5fe971694$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $ERKqR("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $eZcnW("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $ERKqR("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $ERKqR('"allowMissing" argument must be a boolean');
    if ($0827c1e5fe971694$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $eZcnW("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $0827c1e5fe971694$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $0827c1e5fe971694$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $0827c1e5fe971694$var$$spliceApply(parts, $0827c1e5fe971694$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $0827c1e5fe971694$var$$strSlice(part, 0, 1);
        var last = $0827c1e5fe971694$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $eZcnW("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($9pJx8($0827c1e5fe971694$var$INTRINSICS, intrinsicRealName)) value = $0827c1e5fe971694$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $ERKqR("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($0827c1e5fe971694$var$$gOPD && i + 1 >= parts.length) {
                var desc = $0827c1e5fe971694$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9pJx8(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $0827c1e5fe971694$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("9ZtbR", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("d9OSz", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("fcvSh", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("ctxJe", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("eZcnW", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("ERKqR", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("f1Dmt", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("fQTyX", function(module, exports) {
"use strict";
var $b8a6cff45950eeb7$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $3gGeZ = parcelRequire("3gGeZ");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b8a6cff45950eeb7$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $b8a6cff45950eeb7$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $3gGeZ();
};

});

parcelRegister("k5UlQ", function(module, exports) {
"use strict";
var $ea0ffc78af51b80f$var$test = {
    __proto__: null,
    foo: {}
};
// @ts-expect-error: TS errors on an inherited property for some reason
var $ea0ffc78af51b80f$var$result = {
    __proto__: $ea0ffc78af51b80f$var$test
}.foo === $ea0ffc78af51b80f$var$test.foo && !($ea0ffc78af51b80f$var$test instanceof Object);
/** @type {import('.')} */ module.exports = function hasProto() {
    return $ea0ffc78af51b80f$var$result;
};

});

parcelRegister("6C6QM", function(module, exports) {
"use strict";

var $ixMFJ = parcelRequire("ixMFJ");
module.exports = Function.prototype.bind || $ixMFJ;

});
parcelRegister("ixMFJ", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $d8011056f261e1da$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $d8011056f261e1da$var$toStr = Object.prototype.toString;
var $d8011056f261e1da$var$max = Math.max;
var $d8011056f261e1da$var$funcType = "[object Function]";
var $d8011056f261e1da$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $d8011056f261e1da$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $d8011056f261e1da$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $d8011056f261e1da$var$toStr.apply(target) !== $d8011056f261e1da$var$funcType) throw new TypeError($d8011056f261e1da$var$ERROR_MESSAGE + target);
    var args = $d8011056f261e1da$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $d8011056f261e1da$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $d8011056f261e1da$var$concatty(args, arguments));
    };
    var boundLength = $d8011056f261e1da$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $d8011056f261e1da$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pJx8", function(module, exports) {
"use strict";
var $6da9c4d3aa51eee6$var$call = Function.prototype.call;
var $6da9c4d3aa51eee6$var$$hasOwn = Object.prototype.hasOwnProperty;

var $6C6QM = parcelRequire("6C6QM");
/** @type {import('.')} */ module.exports = $6C6QM.call($6da9c4d3aa51eee6$var$call, $6da9c4d3aa51eee6$var$$hasOwn);

});


parcelRegister("8WTax", function(module, exports) {
"use strict";

var $7NJD9 = parcelRequire("7NJD9");

var $8E6zN = parcelRequire("8E6zN");

var $byT0s = parcelRequire("byT0s");

var $aKjOq = parcelRequire("aKjOq");
module.exports = function callBind(originalFunction) {
    var func = $byT0s(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $7NJD9(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($8E6zN) $8E6zN(module.exports, "apply", {
    value: $aKjOq
});
else module.exports.apply = $aKjOq;

});
parcelRegister("7NJD9", function(module, exports) {
"use strict";

var $HprTF = parcelRequire("HprTF");

var $9ocAS = parcelRequire("9ocAS");

var $5ae08143fbe61cda$var$hasDescriptors = (parcelRequire("cxbO1"))();

var $h8TR4 = parcelRequire("h8TR4");

var $ERKqR = parcelRequire("ERKqR");
var $5ae08143fbe61cda$var$$floor = $HprTF("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $ERKqR("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $5ae08143fbe61cda$var$$floor(length) !== length) throw new $ERKqR("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $h8TR4) {
        var desc = $h8TR4(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($5ae08143fbe61cda$var$hasDescriptors) $9ocAS(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $9ocAS(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("9ocAS", function(module, exports) {
"use strict";

var $8E6zN = parcelRequire("8E6zN");

var $eZcnW = parcelRequire("eZcnW");

var $ERKqR = parcelRequire("ERKqR");

var $h8TR4 = parcelRequire("h8TR4");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $ERKqR("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $ERKqR("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $ERKqR("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $ERKqR("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $ERKqR("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $ERKqR("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$h8TR4 && $h8TR4(obj, property);
    if ($8E6zN) $8E6zN(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $eZcnW("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("8E6zN", function(module, exports) {
"use strict";

var $HprTF = parcelRequire("HprTF");
/** @type {import('.')} */ var $64b72918c524dfdd$var$$defineProperty = $HprTF("%Object.defineProperty%", true) || false;
if ($64b72918c524dfdd$var$$defineProperty) try {
    $64b72918c524dfdd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $64b72918c524dfdd$var$$defineProperty = false;
}
module.exports = $64b72918c524dfdd$var$$defineProperty;

});

parcelRegister("h8TR4", function(module, exports) {
"use strict";

var $fhPkq = parcelRequire("fhPkq");
var $c7ae82a1f3c86d15$require$$gOPD = $fhPkq;
if ($c7ae82a1f3c86d15$require$$gOPD) try {
    $c7ae82a1f3c86d15$require$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $c7ae82a1f3c86d15$require$$gOPD = null;
}
module.exports = $c7ae82a1f3c86d15$require$$gOPD;

});
parcelRegister("fhPkq", function(module, exports) {
"use strict";
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});



parcelRegister("cxbO1", function(module, exports) {
"use strict";

var $8E6zN = parcelRequire("8E6zN");
var $9201b97be5be300e$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$8E6zN;
};
$9201b97be5be300e$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$8E6zN) return null;
    try {
        return $8E6zN([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9201b97be5be300e$var$hasPropertyDescriptors;

});


parcelRegister("byT0s", function(module, exports) {
"use strict";

var $6C6QM = parcelRequire("6C6QM");

var $ERKqR = parcelRequire("ERKqR");

var $qDnKN = parcelRequire("qDnKN");

var $7mrD5 = parcelRequire("7mrD5");
/** @type {import('.')} */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== "function") throw new $ERKqR("a function is required");
    return $7mrD5($6C6QM, $qDnKN, args);
};

});
parcelRegister("qDnKN", function(module, exports) {
"use strict";
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("7mrD5", function(module, exports) {
"use strict";

var $6C6QM = parcelRequire("6C6QM");

var $etfUz = parcelRequire("etfUz");

var $qDnKN = parcelRequire("qDnKN");

var $eFt3U = parcelRequire("eFt3U");
/** @type {import('./actualApply')} */ module.exports = $eFt3U || $6C6QM.call($qDnKN, $etfUz);

});
parcelRegister("etfUz", function(module, exports) {
"use strict";
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("eFt3U", function(module, exports) {
"use strict";
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect === "function" && Reflect.apply;

});



parcelRegister("aKjOq", function(module, exports) {
"use strict";

var $6C6QM = parcelRequire("6C6QM");

var $etfUz = parcelRequire("etfUz");

var $7mrD5 = parcelRequire("7mrD5");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $7mrD5($6C6QM, $etfUz, arguments);
};

});




parcelRegister("hyfas", function(module, exports) {
"use strict";
var $cc7160a53178fb53$var$toStr = Object.prototype.toString;
var $cc7160a53178fb53$var$fnToStr = Function.prototype.toString;
var $cc7160a53178fb53$var$isFnRegex = /^\s*(?:function)?\*/;

var $cc7160a53178fb53$var$hasToStringTag = (parcelRequire("ci493"))();
var $cc7160a53178fb53$var$getProto = Object.getPrototypeOf;
var $cc7160a53178fb53$var$getGeneratorFunc = function() {
    if (!$cc7160a53178fb53$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $cc7160a53178fb53$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($cc7160a53178fb53$var$isFnRegex.test($cc7160a53178fb53$var$fnToStr.call(fn))) return true;
    if (!$cc7160a53178fb53$var$hasToStringTag) {
        var str = $cc7160a53178fb53$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$cc7160a53178fb53$var$getProto) return false;
    if (typeof $cc7160a53178fb53$var$GeneratorFunction === "undefined") {
        var generatorFunc = $cc7160a53178fb53$var$getGeneratorFunc();
        $cc7160a53178fb53$var$GeneratorFunction = generatorFunc ? $cc7160a53178fb53$var$getProto(generatorFunc) : false;
    }
    return $cc7160a53178fb53$var$getProto(fn) === $cc7160a53178fb53$var$GeneratorFunction;
};

});

parcelRegister("1mJBV", function(module, exports) {
"use strict";

var $jDq2s = parcelRequire("jDq2s");

var $1o04F = parcelRequire("1o04F");

var $8WTax = parcelRequire("8WTax");

var $2rQHf = parcelRequire("2rQHf");

var $h8TR4 = parcelRequire("h8TR4");
/** @type {(O: object) => string} */ var $0feb39dd0210bb91$var$$toString = $2rQHf("Object.prototype.toString");

var $0feb39dd0210bb91$var$hasToStringTag = (parcelRequire("ci493"))();
var $0feb39dd0210bb91$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $0feb39dd0210bb91$var$typedArrays = $1o04F();
var $0feb39dd0210bb91$var$$slice = $2rQHf("String.prototype.slice");
var $0feb39dd0210bb91$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $0feb39dd0210bb91$var$$indexOf = $2rQHf("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $0feb39dd0210bb91$var$cache = {
    __proto__: null
};
if ($0feb39dd0210bb91$var$hasToStringTag && $h8TR4 && $0feb39dd0210bb91$var$getPrototypeOf) $jDq2s($0feb39dd0210bb91$var$typedArrays, function(typedArray) {
    var arr = new $0feb39dd0210bb91$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $0feb39dd0210bb91$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $h8TR4(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $0feb39dd0210bb91$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $h8TR4(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $0feb39dd0210bb91$var$cache["$" + typedArray] = $8WTax(descriptor.get);
    }
});
else $jDq2s($0feb39dd0210bb91$var$typedArrays, function(typedArray) {
    var arr = new $0feb39dd0210bb91$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $0feb39dd0210bb91$var$cache["$" + typedArray] = $8WTax(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $0feb39dd0210bb91$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $jDq2s(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $0feb39dd0210bb91$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $0feb39dd0210bb91$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $0feb39dd0210bb91$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $jDq2s(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $0feb39dd0210bb91$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $0feb39dd0210bb91$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$0feb39dd0210bb91$var$hasToStringTag) {
        /** @type {string} */ var tag = $0feb39dd0210bb91$var$$slice($0feb39dd0210bb91$var$$toString(value), 8, -1);
        if ($0feb39dd0210bb91$var$$indexOf($0feb39dd0210bb91$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $0feb39dd0210bb91$var$trySlices(value);
    }
    if (!$h8TR4) return null;
     // unknown engine
    return $0feb39dd0210bb91$var$tryTypedArrays(value);
};

});
parcelRegister("jDq2s", function(module, exports) {
"use strict";

var $fY6Nb = parcelRequire("fY6Nb");
var $e4b5db92539f3aac$var$toStr = Object.prototype.toString;
var $e4b5db92539f3aac$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e4b5db92539f3aac$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($e4b5db92539f3aac$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $e4b5db92539f3aac$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $e4b5db92539f3aac$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($e4b5db92539f3aac$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $e4b5db92539f3aac$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$fY6Nb(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($e4b5db92539f3aac$var$toStr.call(list) === "[object Array]") $e4b5db92539f3aac$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $e4b5db92539f3aac$var$forEachString(list, iterator, receiver);
    else $e4b5db92539f3aac$var$forEachObject(list, iterator, receiver);
};
module.exports = $e4b5db92539f3aac$var$forEach;

});
parcelRegister("fY6Nb", function(module, exports) {
"use strict";
var $ba01ba706b385595$var$fnToStr = Function.prototype.toString;
var $ba01ba706b385595$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $ba01ba706b385595$var$badArrayLike;
var $ba01ba706b385595$var$isCallableMarker;
if (typeof $ba01ba706b385595$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $ba01ba706b385595$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $ba01ba706b385595$var$isCallableMarker;
        }
    });
    $ba01ba706b385595$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $ba01ba706b385595$var$reflectApply(function() {
        throw 42;
    }, null, $ba01ba706b385595$var$badArrayLike);
} catch (_) {
    if (_ !== $ba01ba706b385595$var$isCallableMarker) $ba01ba706b385595$var$reflectApply = null;
}
else $ba01ba706b385595$var$reflectApply = null;
var $ba01ba706b385595$var$constructorRegex = /^\s*class\b/;
var $ba01ba706b385595$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $ba01ba706b385595$var$fnToStr.call(value);
        return $ba01ba706b385595$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $ba01ba706b385595$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($ba01ba706b385595$var$isES6ClassFn(value)) return false;
        $ba01ba706b385595$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $ba01ba706b385595$var$toStr = Object.prototype.toString;
var $ba01ba706b385595$var$objectClass = "[object Object]";
var $ba01ba706b385595$var$fnClass = "[object Function]";
var $ba01ba706b385595$var$genClass = "[object GeneratorFunction]";
var $ba01ba706b385595$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $ba01ba706b385595$var$ddaClass2 = "[object HTML document.all class]";
var $ba01ba706b385595$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $ba01ba706b385595$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $ba01ba706b385595$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $ba01ba706b385595$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $ba01ba706b385595$var$all = document.all;
    if ($ba01ba706b385595$var$toStr.call($ba01ba706b385595$var$all) === $ba01ba706b385595$var$toStr.call(document.all)) $ba01ba706b385595$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($ba01ba706b385595$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $ba01ba706b385595$var$toStr.call(value);
            return (str === $ba01ba706b385595$var$ddaClass || str === $ba01ba706b385595$var$ddaClass2 || str === $ba01ba706b385595$var$ddaClass3 // opera 12.16
             || str === $ba01ba706b385595$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $ba01ba706b385595$var$reflectApply ? function isCallable(value) {
    if ($ba01ba706b385595$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $ba01ba706b385595$var$reflectApply(value, null, $ba01ba706b385595$var$badArrayLike);
    } catch (e) {
        if (e !== $ba01ba706b385595$var$isCallableMarker) return false;
    }
    return !$ba01ba706b385595$var$isES6ClassFn(value) && $ba01ba706b385595$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($ba01ba706b385595$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($ba01ba706b385595$var$hasToStringTag) return $ba01ba706b385595$var$tryFunctionObject(value);
    if ($ba01ba706b385595$var$isES6ClassFn(value)) return false;
    var strClass = $ba01ba706b385595$var$toStr.call(value);
    if (strClass !== $ba01ba706b385595$var$fnClass && strClass !== $ba01ba706b385595$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $ba01ba706b385595$var$tryFunctionObject(value);
};

});


parcelRegister("1o04F", function(module, exports) {
"use strict";

var $7UVKM = parcelRequire("7UVKM");
var $102817143ccf5cd8$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $7UVKM.length; i++)if (typeof $102817143ccf5cd8$var$g[$7UVKM[i]] === "function") // @ts-expect-error
    out[out.length] = $7UVKM[i];
    return out;
};

});
parcelRegister("7UVKM", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("NHadK", function(module, exports) {
"use strict";

var $1mJBV = parcelRequire("1mJBV");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$1mJBV(value);
};

});


parcelRegister("hpoz2", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("13rFk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

(function() {
    "use strict";
    const o = window.location.origin;
    const env = "production";
    if (typeof $_CDN === "object") {
        $_CDN.env = env;
        if ($_CDN.language && $_CDN.language[env]) $_CONFIG.language = $_CDN.language[env];
        if (!window.$_DRAGON) console.error("Dragon.js not loading, please check this problem!");
        if (window.$_DRAGON?.language?.length) $_CONFIG.language = $_DRAGON.language;
        if (window.$_DRAGON?.requestInfo) $_CONFIG.requestInfo = $_DRAGON.requestInfo;
        if ($_CDN.licenseId) $_CONFIG.licenseId = $_CDN.licenseId;
        if ($_CDN.liveAgent) $_CONFIG.liveAgent = $_CDN.liveAgent;
        if ($_CDN.zendesk) $_CONFIG.zendesk = {
            ...$_CDN.zendesk,
            ...$_CONFIG.zendesk
        };
        if ($_CDN.freshChat) $_CONFIG.freshChat = $_CDN.freshChat;
        if ($_CDN.preChatFormConfig) $_CONFIG.preChatFormConfig = $_CDN.preChatFormConfig;
    }
})();


(function() {
    const redirectMessageData = {
        message: "pwaRedirect",
        configUrl: $_CDN.redirector || ""
    };
    function removePartytownSwIfExists() {
        const targetScope = `${window.location.origin}/libPartytown/`;
        navigator.serviceWorker.getRegistrations().then((registrations)=>{
            for (const registration of registrations)if (registration.scope === targetScope) registration.unregister().then().catch((error)=>error);
        });
    }
    function getQueryParams() {
        if (window.$_CONFIG.swProject) return `?project=${window.$_CONFIG.swProject}`;
        return "";
    }
    if ("serviceWorker" in navigator) {
        removePartytownSwIfExists();
        navigator.serviceWorker.register(`/base_sw.js${getQueryParams()}`).then(()=>navigator.serviceWorker.ready).then((swRegistration)=>{
            swRegistration.active.postMessage(redirectMessageData);
        });
    }
})();


(function() {
    "use strict";
    const $_CONFIG = window.$_CONFIG || {};
    const languages = window.$_CONFIG.language;
    const apiVersion = window.$_CONFIG.apiVersion || "v2";
    const storageLang = localStorage.getItem("lastLang");
    const addressLang = window.location.pathname.split("/")[1];
    if (addressLang.length === 2 && isAvailableLanguage(addressLang)) {
        setLangToStorage(addressLang);
        $_CONFIG.currentLang = addressLang;
        return;
    }
    if (isAvailableLanguage(storageLang)) {
        goTo(storageLang);
        return;
    }
    const browserLang = navigator.language.split("-")[0];
    if (isAvailableLanguage(browserLang)) {
        goTo(browserLang);
        return;
    }
    const fetchSysData = ()=>{
        let result;
        const request = new XMLHttpRequest();
        request.open("GET", `//${window.location.host}/en/api/${apiVersion}/system/info`, false); // `false` makes the request synchronous
        request.send(null);
        if (request.status === 200) result = JSON.parse(request.response).result;
        return result?.country?.code.toLowerCase();
    };
    const ipLang = fetchSysData();
    if (isAvailableLanguage(ipLang)) {
        goTo(ipLang);
        return;
    }
    const defaultLang = window.$_DRAGON.language[0];
    goTo(defaultLang);
    function setLangToStorage(lang) {
        if (storageLang !== lang) localStorage.setItem("lastLang", lang);
    }
    function getPathName() {
        const path = window.location.pathname.split("/");
        return addressLang.length === 2 && isAvailableLanguage(addressLang) ? path.slice(2).join("/") : path.slice(1).join("/");
    }
    function goTo(path) {
        setLangToStorage(path);
        window.location = path + "/" + getPathName() + window.location.search + window.location.hash;
    }
    function isAvailableLanguage(requestedLang) {
        return languages.includes(requestedLang) ? requestedLang : null;
    }
})();


(function() {
    if (typeof window.$_CONFIG.sentry === "object" && window.$_CONFIG.sentry.enabled === true && window.$_DRAGON.env === "production" && window.Sentry) {
        const dsn = window.$_CONFIG.sentry.dsn || `https://${window.$_CONFIG.sentry.key}@${window.location.hostname}/sentry/${window.$_CONFIG.sentry.id}`;
        const version = window.$_CONFIG.buildVersion || "0.0.1";
        Sentry.init({
            dsn: dsn,
            release: `${window.$_CONFIG.sentry.project}@${version}`,
            environment: location && location.hostname || "dev",
            integrations: [
                new Sentry.BrowserTracing()
            ],
            sampleRate: 1.0,
            tracesSampleRate: 0.2
        });
    }
})();


/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $lXN9m = parcelRequire("lXN9m");

var $lvTqi = parcelRequire("lvTqi");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
function $32594888be9d26d0$export$871de8747c9eaa88(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new $32594888be9d26d0$export$65d6be2d9a2ba8ee(project, thisArg));
    };
}
var $32594888be9d26d0$export$65d6be2d9a2ba8ee = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $32594888be9d26d0$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var $32594888be9d26d0$var$MapSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, $2Dqpi.Subscriber));


var $bf81f4e3d2f87f38$var$toString = /*@__PURE__*/ function() {
    return Object.prototype.toString;
}();
function $bf81f4e3d2f87f38$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $lvTqi.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $bf81f4e3d2f87f38$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $32594888be9d26d0$export$871de8747c9eaa88)(function(args) {
        return (0, $lXN9m.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, $eGy0D.Observable)(function(subscriber) {
        function handler(e) {
            if (arguments.length > 1) subscriber.next(Array.prototype.slice.call(arguments));
            else subscriber.next(e);
        }
        $bf81f4e3d2f87f38$var$setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function $bf81f4e3d2f87f38$var$setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if ($bf81f4e3d2f87f38$var$isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function() {
            return source_1.removeEventListener(eventName, handler, options);
        };
    } else if ($bf81f4e3d2f87f38$var$isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function() {
            return source_2.off(eventName, handler);
        };
    } else if ($bf81f4e3d2f87f38$var$isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function() {
            return source_3.removeListener(eventName, handler);
        };
    } else if (sourceObj && sourceObj.length) for(var i = 0, len = sourceObj.length; i < len; i++)$bf81f4e3d2f87f38$var$setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
    else throw new TypeError("Invalid event target");
    subscriber.add(unsubscribe);
}
function $bf81f4e3d2f87f38$var$isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === "function" && typeof sourceObj.removeListener === "function";
}
function $bf81f4e3d2f87f38$var$isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === "function" && typeof sourceObj.off === "function";
}
function $bf81f4e3d2f87f38$var$isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === "function" && typeof sourceObj.removeEventListener === "function";
}

/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $891rE = parcelRequire("891rE");
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ 
var $ddp2K = parcelRequire("ddp2K");
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ 
var $cvk2N = parcelRequire("cvk2N");
var $0420f01b7245b15b$export$3adcd774773826b8 = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $cvk2N.hostReportError));
        return subscriber;
    };
};


/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $feb176720b56827c$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $feb176720b56827c$export$6f58e2338da23f4d = /*@__PURE__*/ $feb176720b56827c$export$aa9956be4ae4fe8();
var $feb176720b56827c$export$9785f547d3164dac = $feb176720b56827c$export$6f58e2338da23f4d;


var $fa3e5a8fdc87247f$export$176678a6ee07b575 = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, $feb176720b56827c$export$6f58e2338da23f4d]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};


/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $5LiuA = parcelRequire("5LiuA");
var $274bf270c90c3a94$export$253b2a6a99e75857 = function(obj) {
    return function(subscriber) {
        var obs = obj[0, $5LiuA.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $d758fb2be28e0fd3$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $932f432e6b4be561$export$4369c812aac99591(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}



var $kd9kt = parcelRequire("kd9kt");


var $5LiuA = parcelRequire("5LiuA");
var $502e36bd22b657d8$export$45e4095b0ba1d337 = function(result) {
    if (!!result && typeof result[0, $5LiuA.observable] === "function") return (0, $274bf270c90c3a94$export$253b2a6a99e75857)(result);
    else if ((0, $d758fb2be28e0fd3$export$1e2f57719e155213)(result)) return (0, $ddp2K.subscribeToArray)(result);
    else if ((0, $932f432e6b4be561$export$4369c812aac99591)(result)) return (0, $0420f01b7245b15b$export$3adcd774773826b8)(result);
    else if (!!result && typeof result[0, $feb176720b56827c$export$6f58e2338da23f4d] === "function") return (0, $fa3e5a8fdc87247f$export$176678a6ee07b575)(result);
    else {
        var value = (0, $kd9kt.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};


/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $iIdN6 = parcelRequire("iIdN6");

var $5LiuA = parcelRequire("5LiuA");
function $9275685471288844$export$ed8bd553a12b6a30(input, scheduler) {
    return new (0, $eGy0D.Observable)(function(subscriber) {
        var sub = new (0, $iIdN6.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, $5LiuA.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}


/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $iIdN6 = parcelRequire("iIdN6");
function $90b193e4de270a81$export$fc9afd948577f0a8(input, scheduler) {
    return new (0, $eGy0D.Observable)(function(subscriber) {
        var sub = new (0, $iIdN6.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}



var $jrHs1 = parcelRequire("jrHs1");
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $iIdN6 = parcelRequire("iIdN6");

function $2ccbb2de38a0d876$export$2b75c58ab9b5b766(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $eGy0D.Observable)(function(subscriber) {
        var sub = new (0, $iIdN6.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, $feb176720b56827c$export$6f58e2338da23f4d]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}


/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $5LiuA = parcelRequire("5LiuA");
function $d77542283ccd3ca5$export$48c0cddbc99c45c2(input) {
    return input && typeof input[0, $5LiuA.observable] === "function";
}




/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ 
function $54fac05f2d243c06$export$9652023d9040757(input) {
    return input && typeof input[0, $feb176720b56827c$export$6f58e2338da23f4d] === "function";
}


function $30e61b56014a3c90$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $d77542283ccd3ca5$export$48c0cddbc99c45c2)(input)) return (0, $9275685471288844$export$ed8bd553a12b6a30)(input, scheduler);
        else if ((0, $932f432e6b4be561$export$4369c812aac99591)(input)) return (0, $90b193e4de270a81$export$fc9afd948577f0a8)(input, scheduler);
        else if ((0, $d758fb2be28e0fd3$export$1e2f57719e155213)(input)) return (0, $jrHs1.scheduleArray)(input, scheduler);
        else if ((0, $54fac05f2d243c06$export$9652023d9040757)(input) || typeof input === "string") return (0, $2ccbb2de38a0d876$export$2b75c58ab9b5b766)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}


function $c3f2ce8520f4fff9$export$6788812c4e6611e6(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, $eGy0D.Observable)) return input;
        return new (0, $eGy0D.Observable)((0, $502e36bd22b657d8$export$45e4095b0ba1d337)(input));
    } else return (0, $30e61b56014a3c90$export$49c44dfc2bb21d70)(input, scheduler);
}


/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");

var $eGy0D = parcelRequire("eGy0D");

var $f1a21b598f0f6aea$export$20b3446cf1c359c0 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, $2Dqpi.Subscriber));
var $f1a21b598f0f6aea$export$319f8c60b2d80b53 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, $2Dqpi.Subscriber));
var $f1a21b598f0f6aea$export$b73f91a09e7d5376 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, $2Dqpi.Subscriber));
var $f1a21b598f0f6aea$export$9643bd8e0cc0c90a = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, $2Dqpi.Subscriber));
function $f1a21b598f0f6aea$export$d34bac9c0f124cff(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, $eGy0D.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, $502e36bd22b657d8$export$45e4095b0ba1d337)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}


function $cba3fcc25343f285$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($cba3fcc25343f285$export$6b9f6c0d32c093f9(function(a, i) {
            return (0, $c3f2ce8520f4fff9$export$6788812c4e6611e6)(project(a, i)).pipe((0, $32594888be9d26d0$export$871de8747c9eaa88)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new $cba3fcc25343f285$export$397d304a18305ca8(project, concurrent));
    };
}
var $cba3fcc25343f285$export$397d304a18305ca8 = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $cba3fcc25343f285$export$c13a9be6692e882(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var $cba3fcc25343f285$export$c13a9be6692e882 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, $f1a21b598f0f6aea$export$20b3446cf1c359c0)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, $f1a21b598f0f6aea$export$d34bac9c0f124cff)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, $f1a21b598f0f6aea$export$b73f91a09e7d5376));
var $cba3fcc25343f285$export$5b8affa63fc6df16 = $cba3fcc25343f285$export$6b9f6c0d32c093f9;



var $dkdR0 = parcelRequire("dkdR0");
function $7f055eb9bd99aecf$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, $cba3fcc25343f285$export$6b9f6c0d32c093f9)((0, $dkdR0.identity), concurrent);
}



var $83Fxp = parcelRequire("83Fxp");
function $baeef3ef689dc439$export$4950aa0f605343fb() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, $891rE.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, $eGy0D.Observable)) return observables[0];
    return (0, $7f055eb9bd99aecf$export$18aef43295bbe906)(concurrent)((0, $83Fxp.fromArray)(observables, scheduler));
}


/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
function $0fcfe63c48d698bc$export$8916d2c8119541bb(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $0fcfe63c48d698bc$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var $0fcfe63c48d698bc$var$BufferCountOperator = /*@__PURE__*/ function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $0fcfe63c48d698bc$var$BufferCountSubscriber;
        else this.subscriberClass = $0fcfe63c48d698bc$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
var $0fcfe63c48d698bc$var$BufferCountSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}((0, $2Dqpi.Subscriber));
var $0fcfe63c48d698bc$var$BufferSkipCountSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}((0, $2Dqpi.Subscriber));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
function $312ba4d39eb49e75$export$3dea766d36a8935f(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $312ba4d39eb49e75$var$FilterOperator(predicate, thisArg));
    };
}
var $312ba4d39eb49e75$var$FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $312ba4d39eb49e75$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var $312ba4d39eb49e75$var$FilterSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, $2Dqpi.Subscriber));


(function() {
    "use strict";
    const event = new Event("tap", {
        bubbles: true
    });
    const touches = (0, $baeef3ef689dc439$export$4950aa0f605343fb)(...[
        "touchstart",
        "touchmove",
        "touchend"
    ].map((n)=>(0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(document, n))).pipe((0, $0fcfe63c48d698bc$export$8916d2c8119541bb)(2, 1));
    touches.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((i)=>i[0].type === "touchstart" && i[1].type === "touchend")).subscribe((x)=>x[1].target.dispatchEvent(event));
})();


var $5f87083257a9cadb$exports = {};
window.$_CONFIG = window.$_CONFIG || {};


var $61f9aac36134f7fb$exports = {};
(function() {
    window.$_GET = {};
    const urlParams = getUrlParams();
    const localStorageParams = JSON.parse(window.localStorage.getItem("params")) || {};
    const dateNow = new Date().toISOString();
    const additionalParams = {};
    if (urlParams.btag && urlParams.btag !== localStorageParams.btag || urlParams.affid && urlParams.affid !== localStorageParams.affid) additionalParams.btag_id_timestamp = dateNow;
    if (document.referrer) {
        const referrerURL = new URL(document.referrer);
        const hostname = referrerURL.hostname;
        if (hostname !== location.host) {
            additionalParams.referrer = document.referrer;
            additionalParams.referrer_timestamp = dateNow;
        }
    }
    window.localStorage.setItem("params", JSON.stringify(Object.assign({}, localStorageParams, urlParams, additionalParams)));
    function getUrlParams() {
        const queryString = window.location.search;
        const urlParams = Object.fromEntries(new URLSearchParams(queryString));
        window.$_GET = urlParams;
        return urlParams;
    }
})();


var $9d8c61bb1f07a7e4$exports = {};
(function() {
    "use strict";
    const authToken = window.$_GET.token || "";
    if (authToken.length >= 10) window.localStorage.setItem("token", authToken);
})();


var $3b7e29502627c9d3$exports = {};
var $6374297dabcafdc3$exports = {};
(function() {
    "use strict";
    if (!Array.prototype.last) // eslint-disable-next-line no-extend-native
    Array.prototype.last = function() {
        return this[this.length - 1];
    };
    if (!Array.prototype.toggle) // eslint-disable-next-line no-extend-native
    Array.prototype.toggle = function(item, state) {
        // наявність елемента в масиві
        const index = this.indexOf(item);
        switch(state){
            // якщо потрібно тільки додати
            case true:
                if (index === -1) this.push(item);
                break;
            // якщо потрібно тільки видалити
            case false:
                if (index !== -1) this.splice(index, 1);
                break;
            // якщо потрібно додати або видалити
            default:
                index === -1 ? this.push(item) : this.splice(index, 1);
                break;
        }
    };
    if (!Array.prototype.toObject) // eslint-disable-next-line no-extend-native
    Array.prototype.toObject = function(key) {
        const r = {};
        this.forEach((i, index)=>{
            r[i[key || Object.keys(i)[0]]] = i;
        });
        return r;
    };
})();


var $56c62c324234001a$exports = {};
(function() {
    "use strict";
    // eslint-disable-next-line no-extend-native
    Date.prototype.sToDHMS = function(ms) {
        let d = Math.floor(ms / 86400);
        ms -= 86400 * d;
        if (d < 10) d = "0" + d;
        let h = Math.floor(ms / 3600);
        ms -= 3600 * h;
        if (h < 10) h = "0" + h;
        let m = Math.floor(ms / 60);
        if (m < 10) m = "0" + m;
        let s = ms - 60 * m;
        if (s < 10) s = "0" + s;
        return [
            d + "",
            h + "",
            m + "",
            s + ""
        ];
    };
})();
(function() {
    "use strict";
    // eslint-disable-next-line no-extend-native
    Date.prototype.removeYears = function(y) {
        this.setFullYear(this.getFullYear() - (y || 0));
        return this;
    };
})();
(function() {
    "use strict";
    function pad(number) {
        if (number < 10) return "0" + number;
        return number;
    }
    // eslint-disable-next-line no-extend-native
    Date.prototype.toISODate = function() {
        return this.getUTCFullYear() + "-" + pad(this.getUTCMonth() + 1) + "-" + pad(this.getUTCDate());
    };
})();



var $a74a1af85a5bf9a4$exports = {};
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $eGy0D = parcelRequire("eGy0D");

var $2Dqpi = parcelRequire("2Dqpi");

var $iIdN6 = parcelRequire("iIdN6");
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $9562945f97ba487a$var$ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var $9562945f97ba487a$export$f708eee25634bc80 = $9562945f97ba487a$var$ObjectUnsubscribedErrorImpl;


/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $iIdN6 = parcelRequire("iIdN6");
var $1c7df2899dc9d4fc$export$b7a41f2bfb5c60c3 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, $iIdN6.Subscription));



var $67SG3 = parcelRequire("67SG3");
var $19fbb7818f827ed3$export$d2a63025e8078d0c = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, $2Dqpi.Subscriber));
var $19fbb7818f827ed3$export$b6bbab5a9b109038 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, $67SG3.rxSubscriber] = function() {
        return new $19fbb7818f827ed3$export$d2a63025e8078d0c(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $19fbb7818f827ed3$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, $iIdN6.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, $iIdN6.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, $1c7df2899dc9d4fc$export$b7a41f2bfb5c60c3)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $eGy0D.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $19fbb7818f827ed3$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $eGy0D.Observable));
var $19fbb7818f827ed3$export$155189cde295587d = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, $iIdN6.Subscription).EMPTY;
    };
    return AnonymousSubject;
}($19fbb7818f827ed3$export$b6bbab5a9b109038);



var $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $19fbb7818f827ed3$export$b6bbab5a9b109038));


(function() {
    window.deferredPrompt$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)({
        isEnabled: false
    });
    window.addEventListener("beforeinstallprompt", function(e) {
        e.preventDefault();
        window.deferredPrompt = e;
        window.deferredPrompt$.next({
            isEnabled: true
        });
    });
})();




$3b7e29502627c9d3$exports = {
    "Array": $6374297dabcafdc3$exports,
    "Date": $56c62c324234001a$exports,
    "auth": $9d8c61bb1f07a7e4$exports,
    "events": $a74a1af85a5bf9a4$exports,
    "get": $61f9aac36134f7fb$exports,
    "init": $5f87083257a9cadb$exports
};


(function() {
    "use strict";
    const device = new MobileDetect(window.navigator.userAgent, 600);
    $_CONFIG.device = {
        mobile: !!device.mobile(),
        type: device.tablet() ? "tablet" : device.phone() ? "phone" : null
    };
})();


(function() {
    "use strict";
    const externalAppKey = "mbapps"; // GET param string from mobile apps side
    const localParams = JSON.parse(window.localStorage.getItem("params"));
    const checkNavigator = navigator.userAgent;
    const webView = checkNavigator.match(/FBAV/i) || checkNavigator.match(/FBAN/i) || checkNavigator.match(/Instagram/i) || document.referrer.match(/\/\/t\.co/i) && checkNavigator.match(/iPhone|iPad|iPod|Android/i) || checkNavigator.match(/Android/i) && checkNavigator.includes("; wv") || checkNavigator.match(/Android/i) && !navigator.userAgentData && !checkNavigator.match(/Firefox/i) || localParams.var1 === externalAppKey;
    $_CONFIG.browser = {
        webView: !!webView
    };
})();


var $6382ac8304369ea6$exports = {};

var $jTg1q = parcelRequire("jTg1q");
var $54e9171f22947a74$exports = {};
/*!
 * angular-translate - v2.19.1 - 2024-01-21
 * 
 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function() {
        return factory();
    });
    else if (0, $54e9171f22947a74$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $54e9171f22947a74$exports = factory();
    else factory();
})($54e9171f22947a74$exports, function() {
    /**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */ runTranslate.$inject = [
        "$translate"
    ];
    $translate.$inject = [
        "$STORAGE_KEY",
        "$windowProvider",
        "$translateSanitizationProvider",
        "pascalprechtTranslateOverrider"
    ];
    $translateDefaultInterpolation.$inject = [
        "$interpolate",
        "$translateSanitization"
    ];
    translateDirective.$inject = [
        "$translate",
        "$interpolate",
        "$compile",
        "$parse",
        "$rootScope"
    ];
    translateAttrDirective.$inject = [
        "$translate",
        "$rootScope"
    ];
    translateCloakDirective.$inject = [
        "$translate",
        "$rootScope"
    ];
    translateFilterFactory.$inject = [
        "$parse",
        "$translate"
    ];
    $translationCache.$inject = [
        "$cacheFactory"
    ];
    angular.module("pascalprecht.translate", [
        "ng"
    ]).run(runTranslate);
    function runTranslate($translate) {
        "use strict";
        var key = $translate.storageKey(), storage = $translate.storage();
        var fallbackFromIncorrectStorageValue = function() {
            var preferred = $translate.preferredLanguage();
            if (angular.isString(preferred)) $translate.use(preferred);
            else storage.put(key, $translate.use());
        };
        fallbackFromIncorrectStorageValue.displayName = "fallbackFromIncorrectStorageValue";
        if (storage) {
            if (!storage.get(key)) fallbackFromIncorrectStorageValue();
            else $translate.use(storage.get(key))["catch"](fallbackFromIncorrectStorageValue);
        } else if (angular.isString($translate.preferredLanguage())) $translate.use($translate.preferredLanguage());
    }
    runTranslate.displayName = "runTranslate";
    /**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */ angular.module("pascalprecht.translate").provider("$translateSanitization", $translateSanitizationProvider);
    function $translateSanitizationProvider() {
        "use strict";
        var $sanitize, $sce, currentStrategy = null, hasConfiguredStrategy = false, hasShownNoStrategyConfiguredWarning = false, strategies;
        /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */ /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */ strategies = {
            sanitize: function(value, mode /*, context*/ ) {
                if (mode === "text") value = htmlSanitizeValue(value);
                return value;
            },
            escape: function(value, mode /*, context*/ ) {
                if (mode === "text") value = htmlEscapeValue(value);
                return value;
            },
            sanitizeParameters: function(value, mode /*, context*/ ) {
                if (mode === "params") value = mapInterpolationParameters(value, htmlSanitizeValue);
                return value;
            },
            escapeParameters: function(value, mode /*, context*/ ) {
                if (mode === "params") value = mapInterpolationParameters(value, htmlEscapeValue);
                return value;
            },
            sce: function(value, mode, context) {
                if (mode === "text") value = htmlTrustValue(value);
                else if (mode === "params") {
                    if (context !== "filter") // do html escape in filter context #1101
                    value = mapInterpolationParameters(value, htmlEscapeValue);
                }
                return value;
            },
            sceParameters: function(value, mode /*, context*/ ) {
                if (mode === "params") value = mapInterpolationParameters(value, htmlTrustValue);
                return value;
            }
        };
        // Support legacy strategy name 'escaped' for backwards compatibility.
        // TODO should be removed in 3.0
        strategies.escaped = strategies.escapeParameters;
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */ this.addStrategy = function(strategyName, strategyFunction) {
            strategies[strategyName] = strategyFunction;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */ this.removeStrategy = function(strategyName) {
            delete strategies[strategyName];
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */ this.useStrategy = function(strategy) {
            hasConfiguredStrategy = true;
            currentStrategy = strategy;
            return this;
        };
        /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */ this.$get = [
            "$injector",
            "$log",
            function($injector, $log) {
                var cachedStrategyMap = {};
                var applyStrategies = function(value, mode, context, selectedStrategies) {
                    angular.forEach(selectedStrategies, function(selectedStrategy) {
                        if (angular.isFunction(selectedStrategy)) value = selectedStrategy(value, mode, context);
                        else if (angular.isFunction(strategies[selectedStrategy])) value = strategies[selectedStrategy](value, mode, context);
                        else if (angular.isString(strategies[selectedStrategy])) {
                            if (!cachedStrategyMap[strategies[selectedStrategy]]) try {
                                cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
                            } catch (e) {
                                cachedStrategyMap[strategies[selectedStrategy]] = function() {};
                                throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '" + selectedStrategy + "'");
                            }
                            value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
                        } else throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '" + selectedStrategy + "'");
                    });
                    return value;
                };
                // TODO: should be removed in 3.0
                var showNoStrategyConfiguredWarning = function() {
                    if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
                        $log.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.");
                        hasShownNoStrategyConfiguredWarning = true;
                    }
                };
                if ($injector.has("$sanitize")) $sanitize = $injector.get("$sanitize");
                if ($injector.has("$sce")) $sce = $injector.get("$sce");
                return {
                    /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */ useStrategy: function(self) {
                        return function(strategy) {
                            self.useStrategy(strategy);
                        };
                    }(this),
                    /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */ sanitize: function(value, mode, strategy, context) {
                        if (!currentStrategy) showNoStrategyConfiguredWarning();
                        if (!strategy && strategy !== null) strategy = currentStrategy;
                        if (!strategy) return value;
                        if (!context) context = "service";
                        var selectedStrategies = angular.isArray(strategy) ? strategy : [
                            strategy
                        ];
                        return applyStrategies(value, mode, context, selectedStrategies);
                    }
                };
            }
        ];
        var htmlEscapeValue = function(value) {
            var element = angular.element("<div></div>");
            element.text(value); // not chainable, see #1044
            return element.html();
        };
        var htmlSanitizeValue = function(value) {
            if (!$sanitize) throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");
            return $sanitize(value);
        };
        var htmlTrustValue = function(value) {
            if (!$sce) throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sce service.");
            return $sce.trustAsHtml(value);
        };
        var mapInterpolationParameters = function(value, iteratee, stack) {
            if (angular.isDate(value)) return value;
            else if (angular.isObject(value)) {
                var result = angular.isArray(value) ? [] : {};
                if (!stack) stack = [];
                else {
                    if (stack.indexOf(value) > -1) throw new Error("pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object");
                }
                stack.push(value);
                angular.forEach(value, function(propertyValue, propertyKey) {
                    /* Skipping function properties. */ if (angular.isFunction(propertyValue)) return;
                    result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
                });
                stack.splice(-1, 1); // remove last
                return result;
            } else if (angular.isNumber(value)) return value;
            else if (value === true || value === false) return value;
            else if (!angular.isUndefined(value) && value !== null) return iteratee(value);
            else return value;
        };
    }
    /**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */ angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider", {}).provider("$translate", $translate);
    function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
        "use strict";
        var $translationTable = {}, $preferredLanguage, $availableLanguageKeys = [], $languageKeyAliases, $fallbackLanguage, $fallbackWasString, $uses, $nextLang, $storageFactory, $storageKey = $STORAGE_KEY, $storagePrefix, $missingTranslationHandlerFactory, $interpolationFactory, $interpolatorFactories = [], $loaderFactory, $cloakClassName = "translate-cloak", $loaderOptions, $notFoundIndicatorLeft, $notFoundIndicatorRight, $postCompilingEnabled = false, $forceAsyncReloadEnabled = false, $allowNamespaces = true, $nestedObjectDelimeter = ".", $isReady = false, $keepContent = false, loaderCache, directivePriority = 0, statefulFilter = true, postProcessFn, uniformLanguageTagResolver = "default", languageTagResolver = {
            "default": function(tag) {
                return (tag || "").split("-").join("_");
            },
            java: function(tag) {
                var temp = (tag || "").split("-").join("_");
                var parts = temp.split("_");
                return parts.length > 1 ? parts[0].toLowerCase() + "_" + parts[1].toUpperCase() : temp;
            },
            bcp47: function(tag) {
                var temp = (tag || "").split("_").join("-");
                var parts = temp.split("-");
                switch(parts.length){
                    case 1:
                        parts[0] = parts[0].toLowerCase();
                        break;
                    case 2:
                        parts[0] = parts[0].toLowerCase();
                        if (parts[1].length === 4) parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
                        else parts[1] = parts[1].toUpperCase();
                        break;
                    case 3:
                        parts[0] = parts[0].toLowerCase();
                        parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
                        parts[2] = parts[2].toUpperCase();
                        break;
                    default:
                        return temp;
                }
                return parts.join("-");
            },
            "iso639-1": function(tag) {
                var temp = (tag || "").split("_").join("-");
                var parts = temp.split("-");
                return parts[0].toLowerCase();
            }
        };
        var version = "2.19.1";
        // tries to determine the browsers language
        var getFirstBrowserLanguage = function() {
            // internal purpose only
            if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) return pascalprechtTranslateOverrider.getLocale();
            var nav = $windowProvider.$get().navigator, browserLanguagePropertyKeys = [
                "language",
                "browserLanguage",
                "systemLanguage",
                "userLanguage"
            ], i, language;
            // support for HTML 5.1 "navigator.languages"
            if (angular.isArray(nav.languages)) for(i = 0; i < nav.languages.length; i++){
                language = nav.languages[i];
                if (language && language.length) return language;
            }
            // support for other well known properties in browsers
            for(i = 0; i < browserLanguagePropertyKeys.length; i++){
                language = nav[browserLanguagePropertyKeys[i]];
                if (language && language.length) return language;
            }
            return null;
        };
        getFirstBrowserLanguage.displayName = "angular-translate/service: getFirstBrowserLanguage";
        // tries to determine the browsers locale
        var getLocale = function() {
            var locale = getFirstBrowserLanguage() || "";
            if (languageTagResolver[uniformLanguageTagResolver]) locale = languageTagResolver[uniformLanguageTagResolver](locale);
            return locale;
        };
        getLocale.displayName = "angular-translate/service: getLocale";
        /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */ var indexOf = function(array, searchElement) {
            for(var i = 0, len = array.length; i < len; i++){
                if (array[i] === searchElement) return i;
            }
            return -1;
        };
        /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */ var trim = function() {
            return this.toString().replace(/^\s+|\s+$/g, "");
        };
        /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */ var lowercase = function(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        };
        var negotiateLocale = function(preferred) {
            if (!preferred) return;
            var avail = [], locale = lowercase(preferred), i = 0, n = $availableLanguageKeys.length;
            for(; i < n; i++)avail.push(lowercase($availableLanguageKeys[i]));
            // Check for an exact match in our list of available keys
            i = indexOf(avail, locale);
            if (i > -1) return $availableLanguageKeys[i];
            if ($languageKeyAliases) {
                var alias;
                for(var langKeyAlias in $languageKeyAliases)if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
                    var hasWildcardKey = false;
                    var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) && lowercase(langKeyAlias) === lowercase(preferred);
                    if (langKeyAlias.slice(-1) === "*") hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
                    if (hasExactKey || hasWildcardKey) {
                        alias = $languageKeyAliases[langKeyAlias];
                        if (indexOf(avail, lowercase(alias)) > -1) return alias;
                    }
                }
            }
            // Check for a language code without region
            var parts = preferred.split("_");
            if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) return parts[0];
            // If everything fails, return undefined.
            return;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */ var translations = function(langKey, translationTable) {
            if (!langKey && !translationTable) return $translationTable;
            if (langKey && !translationTable) {
                if (angular.isString(langKey)) return $translationTable[langKey];
            } else {
                if (!angular.isObject($translationTable[langKey])) $translationTable[langKey] = {};
                angular.extend($translationTable[langKey], flatObject(translationTable));
            }
            return this;
        };
        this.translations = translations;
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */ this.cloakClassName = function(name) {
            if (!name) return $cloakClassName;
            $cloakClassName = name;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#allowNamespaces
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Let's you disable namespaces, if you don't need nested translation
   * object files. Disabling namespaces can improve performance.
   *
   * Default value is `true`. Namespaces are enabled by default.
   *
   * @param {boolean} namespacesEnabled - namespaces are enabled or not
   */ this.allowNamespaces = function(namespacesEnabled) {
            if (namespacesEnabled === undefined) return $allowNamespaces;
            $allowNamespaces = namespacesEnabled;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */ this.nestedObjectDelimeter = function(delimiter) {
            if (!delimiter) return $nestedObjectDelimeter;
            $nestedObjectDelimeter = delimiter;
            return this;
        };
        /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */ var flatObject = function(data, path, result, prevKey) {
            var key, keyWithPath, keyWithShortPath, val;
            if (!path) path = [];
            if (!result) result = {};
            if (!$allowNamespaces) return data;
            for(key in data){
                if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
                val = data[key];
                if (angular.isObject(val)) flatObject(val, path.concat(key), result, key);
                else {
                    keyWithPath = path.length ? "" + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key : key;
                    if (path.length && key === prevKey) {
                        // Create shortcut path (foo.bar == foo.bar.bar)
                        keyWithShortPath = "" + path.join($nestedObjectDelimeter);
                        // Link it to original path
                        result[keyWithShortPath] = "@:" + keyWithPath;
                    }
                    result[keyWithPath] = val;
                }
            }
            return result;
        };
        flatObject.displayName = "flatObject";
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */ this.addInterpolation = function(factory) {
            $interpolatorFactories.push(factory);
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */ this.useMessageFormatInterpolation = function() {
            return this.useInterpolation("$translateMessageFormatInterpolation");
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */ this.useInterpolation = function(factory) {
            $interpolationFactory = factory;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */ this.useSanitizeValueStrategy = function(value) {
            $translateSanitizationProvider.useStrategy(value);
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */ this.preferredLanguage = function(langKey) {
            if (langKey) {
                setupPreferredLanguage(langKey);
                return this;
            }
            return $preferredLanguage;
        };
        var setupPreferredLanguage = function(langKey) {
            if (langKey) $preferredLanguage = langKey;
            return $preferredLanguage;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */ this.translationNotFoundIndicator = function(indicator) {
            this.translationNotFoundIndicatorLeft(indicator);
            this.translationNotFoundIndicatorRight(indicator);
            return this;
        };
        /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */ this.translationNotFoundIndicatorLeft = function(indicator) {
            if (!indicator) return $notFoundIndicatorLeft;
            $notFoundIndicatorLeft = indicator;
            return this;
        };
        /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */ this.translationNotFoundIndicatorRight = function(indicator) {
            if (!indicator) return $notFoundIndicatorRight;
            $notFoundIndicatorRight = indicator;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */ this.fallbackLanguage = function(langKey) {
            fallbackStack(langKey);
            return this;
        };
        var fallbackStack = function(langKey) {
            if (langKey) {
                if (angular.isString(langKey)) {
                    $fallbackWasString = true;
                    $fallbackLanguage = [
                        langKey
                    ];
                } else if (angular.isArray(langKey)) {
                    $fallbackWasString = false;
                    $fallbackLanguage = langKey;
                }
                if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) $fallbackLanguage.push($preferredLanguage);
                return this;
            } else {
                if ($fallbackWasString) return $fallbackLanguage[0];
                else return $fallbackLanguage;
            }
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */ this.use = function(langKey) {
            if (langKey) {
                if (!$translationTable[langKey] && !$loaderFactory) // only throw an error, when not loading translation data asynchronously
                throw new Error("$translateProvider couldn't find translationTable for langKey: '" + langKey + "'");
                $uses = langKey;
                return this;
            }
            return $uses;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */ this.resolveClientLocale = function() {
            return getLocale();
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */ var storageKey = function(key) {
            if (!key) {
                if ($storagePrefix) return $storagePrefix + $storageKey;
                return $storageKey;
            }
            $storageKey = key;
            return this;
        };
        this.storageKey = storageKey;
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */ this.useUrlLoader = function(url, options) {
            return this.useLoader("$translateUrlLoader", angular.extend({
                url: url
            }, options));
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */ this.useStaticFilesLoader = function(options) {
            return this.useLoader("$translateStaticFilesLoader", options);
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */ this.useLoader = function(loaderFactory, options) {
            $loaderFactory = loaderFactory;
            $loaderOptions = options || {};
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */ this.useLocalStorage = function() {
            return this.useStorage("$translateLocalStorage");
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */ this.useCookieStorage = function() {
            return this.useStorage("$translateCookieStorage");
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */ this.useStorage = function(storageFactory) {
            $storageFactory = storageFactory;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */ this.storagePrefix = function(prefix) {
            if (!prefix) return prefix;
            $storagePrefix = prefix;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */ this.useMissingTranslationHandlerLog = function() {
            return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog");
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */ this.useMissingTranslationHandler = function(factory) {
            $missingTranslationHandlerFactory = factory;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */ this.usePostCompiling = function(value) {
            $postCompilingEnabled = !!value;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */ this.forceAsyncReload = function(value) {
            $forceAsyncReloadEnabled = !!value;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */ this.uniformLanguageTag = function(options) {
            if (!options) options = {};
            else if (angular.isString(options)) options = {
                standard: options
            };
            uniformLanguageTagResolver = options.standard;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */ this.determinePreferredLanguage = function(fn) {
            var locale = fn && angular.isFunction(fn) ? fn() : getLocale();
            if (!$availableLanguageKeys.length) $preferredLanguage = locale;
            else $preferredLanguage = negotiateLocale(locale) || locale;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */ this.registerAvailableLanguageKeys = function(languageKeys, aliases) {
            if (languageKeys) {
                $availableLanguageKeys = languageKeys;
                if (aliases) $languageKeyAliases = aliases;
                return this;
            }
            return $availableLanguageKeys;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */ this.useLoaderCache = function(cache) {
            if (cache === false) // disable cache
            loaderCache = undefined;
            else if (cache === true) // enable cache using AJS defaults
            loaderCache = true;
            else if (typeof cache === "undefined") // enable cache using default
            loaderCache = "$translationCache";
            else if (cache) // enable cache using given one (see $cacheFactory)
            loaderCache = cache;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */ this.directivePriority = function(priority) {
            if (priority === undefined) // getter
            return directivePriority;
            else {
                // setter with chaining
                directivePriority = priority;
                return this;
            }
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */ this.statefulFilter = function(state) {
            if (state === undefined) // getter
            return statefulFilter;
            else {
                // setter with chaining
                statefulFilter = state;
                return this;
            }
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */ this.postProcess = function(fn) {
            if (fn) postProcessFn = fn;
            else postProcessFn = undefined;
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */ this.keepContent = function(value) {
            $keepContent = !!value;
            return this;
        };
        /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */ this.$get = [
            "$log",
            "$injector",
            "$rootScope",
            "$q",
            function($log, $injector, $rootScope, $q) {
                var Storage, defaultInterpolator = $injector.get($interpolationFactory || "$translateDefaultInterpolation"), pendingLoader = false, interpolatorHashMap = {}, langPromises = {}, fallbackIndex, startFallbackIteration;
                var $translate = function(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
                    if (!$uses && $preferredLanguage) $uses = $preferredLanguage;
                    var uses = forceLanguage && forceLanguage !== $uses ? negotiateLocale(forceLanguage) || forceLanguage : $uses;
                    // Check forceLanguage is present
                    if (forceLanguage) loadTranslationsIfMissing(forceLanguage);
                    // Duck detection: If the first argument is an array, a bunch of translations was requested.
                    // The result is an object.
                    if (angular.isArray(translationId)) {
                        // Inspired by Q.allSettled by Kris Kowal
                        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
                        // This transforms all promises regardless resolved or rejected
                        var translateAll = function(translationIds) {
                            var results = {}; // storing the actual results
                            var promises = []; // promises to wait for
                            // Wraps the promise a) being always resolved and b) storing the link id->value
                            var translate = function(translationId) {
                                var deferred = $q.defer();
                                var regardless = function(value) {
                                    results[translationId] = value;
                                    deferred.resolve([
                                        translationId,
                                        value
                                    ]);
                                };
                                // we don't care whether the promise was resolved or rejected; just store the values
                                $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
                                return deferred.promise;
                            };
                            for(var i = 0, c = translationIds.length; i < c; i++)promises.push(translate(translationIds[i]));
                            // wait for all (including storing to results)
                            return $q.all(promises).then(function() {
                                // return the results
                                return results;
                            });
                        };
                        return translateAll(translationId);
                    }
                    var deferred = $q.defer();
                    // trim off any whitespace
                    if (translationId) translationId = trim.apply(translationId);
                    else throw new TypeError("translationId must be a not empty string");
                    var promiseToWaitFor = function() {
                        var promise = langPromises[uses] || langPromises[$preferredLanguage];
                        fallbackIndex = 0;
                        if ($storageFactory && !promise) {
                            // looks like there's no pending promise for $preferredLanguage or
                            // $uses. Maybe there's one pending for a language that comes from
                            // storage.
                            var langKey = Storage.get($storageKey);
                            promise = langPromises[langKey];
                            if ($fallbackLanguage && $fallbackLanguage.length) {
                                var index = indexOf($fallbackLanguage, langKey);
                                // maybe the language from storage is also defined as fallback language
                                // we increase the fallback language index to not search in that language
                                // as fallback, since it's probably the first used language
                                // in that case the index starts after the first element
                                fallbackIndex = index === 0 ? 1 : 0;
                                // but we can make sure to ALWAYS fallback to preferred language at least
                                if (indexOf($fallbackLanguage, $preferredLanguage) < 0) $fallbackLanguage.push($preferredLanguage);
                            }
                        }
                        return promise;
                    }();
                    if (!promiseToWaitFor) // no promise to wait for? okay. Then there's no loader registered
                    // nor is a one pending for language that comes from storage.
                    // We can just translate.
                    determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                    else {
                        var promiseResolved = function() {
                            // $uses may have changed while waiting
                            if (!forceLanguage) uses = $uses;
                            determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                        };
                        promiseResolved.displayName = "promiseResolved";
                        promiseToWaitFor["finally"](promiseResolved)["catch"](angular.noop); // we don't care about errors here, already handled
                    }
                    return deferred.promise;
                };
                /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */ var applyNotFoundIndicators = function(translationId) {
                    // applying notFoundIndicators
                    if ($notFoundIndicatorLeft) translationId = [
                        $notFoundIndicatorLeft,
                        translationId
                    ].join(" ");
                    if ($notFoundIndicatorRight) translationId = [
                        translationId,
                        $notFoundIndicatorRight
                    ].join(" ");
                    return translationId;
                };
                /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */ var useLanguage = function(key) {
                    $uses = key;
                    // make sure to store new language key before triggering success event
                    if ($storageFactory) Storage.put($translate.storageKey(), $uses);
                    $rootScope.$emit("$translateChangeSuccess", {
                        language: key
                    });
                    // inform default interpolator
                    defaultInterpolator.setLocale($uses);
                    var eachInterpolator = function(interpolator, id) {
                        interpolatorHashMap[id].setLocale($uses);
                    };
                    eachInterpolator.displayName = "eachInterpolatorLocaleSetter";
                    // inform all others too!
                    angular.forEach(interpolatorHashMap, eachInterpolator);
                    $rootScope.$emit("$translateChangeEnd", {
                        language: key
                    });
                };
                /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */ var loadAsync = function(key) {
                    if (!key) throw "No language key specified for loading.";
                    var deferred = $q.defer();
                    $rootScope.$emit("$translateLoadingStart", {
                        language: key
                    });
                    pendingLoader = true;
                    var cache = loaderCache;
                    if (typeof cache === "string") // getting on-demand instance of loader
                    cache = $injector.get(cache);
                    var loaderOptions = angular.extend({}, $loaderOptions, {
                        key: key,
                        $http: angular.extend({}, {
                            cache: cache
                        }, $loaderOptions.$http)
                    });
                    var onLoaderSuccess = function(data) {
                        var translationTable = {};
                        $rootScope.$emit("$translateLoadingSuccess", {
                            language: key
                        });
                        if (angular.isArray(data)) angular.forEach(data, function(table) {
                            angular.extend(translationTable, flatObject(table));
                        });
                        else angular.extend(translationTable, flatObject(data));
                        pendingLoader = false;
                        deferred.resolve({
                            key: key,
                            table: translationTable
                        });
                        $rootScope.$emit("$translateLoadingEnd", {
                            language: key
                        });
                    };
                    onLoaderSuccess.displayName = "onLoaderSuccess";
                    var onLoaderError = function(key) {
                        $rootScope.$emit("$translateLoadingError", {
                            language: key
                        });
                        deferred.reject(key);
                        $rootScope.$emit("$translateLoadingEnd", {
                            language: key
                        });
                    };
                    onLoaderError.displayName = "onLoaderError";
                    $injector.get($loaderFactory)(loaderOptions).then(onLoaderSuccess, onLoaderError);
                    return deferred.promise;
                };
                if ($storageFactory) {
                    Storage = $injector.get($storageFactory);
                    if (!Storage.get || !Storage.put) throw new Error("Couldn't use storage '" + $storageFactory + "', missing get() or put() method!");
                }
                // if we have additional interpolations that were added via
                // $translateProvider.addInterpolation(), we have to map'em
                if ($interpolatorFactories.length) {
                    var eachInterpolationFactory = function(interpolatorFactory) {
                        var interpolator = $injector.get(interpolatorFactory);
                        // setting initial locale for each interpolation service
                        interpolator.setLocale($preferredLanguage || $uses);
                        // make'em recognizable through id
                        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
                    };
                    eachInterpolationFactory.displayName = "interpolationFactoryAdder";
                    angular.forEach($interpolatorFactories, eachInterpolationFactory);
                }
                /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */ var getTranslationTable = function(langKey) {
                    var deferred = $q.defer();
                    if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) deferred.resolve($translationTable[langKey]);
                    else if (langPromises[langKey]) {
                        var onResolve = function(data) {
                            translations(data.key, data.table);
                            deferred.resolve(data.table);
                        };
                        onResolve.displayName = "translationTableResolver";
                        langPromises[langKey].then(onResolve, deferred.reject);
                    } else deferred.reject();
                    return deferred.promise;
                };
                /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */ var getFallbackTranslation = function(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                    var deferred = $q.defer();
                    var onResolve = function(translationTable) {
                        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
                            Interpolator.setLocale(langKey);
                            var translation = translationTable[translationId];
                            if (translation.substr(0, 2) === "@:") getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                            else {
                                var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, "service", sanitizeStrategy, translationId);
                                interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
                                deferred.resolve(interpolatedValue);
                            }
                            Interpolator.setLocale($uses);
                        } else deferred.reject();
                    };
                    onResolve.displayName = "fallbackTranslationResolver";
                    getTranslationTable(langKey).then(onResolve, deferred.reject);
                    return deferred.promise;
                };
                /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */ var getFallbackTranslationInstant = function(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                    var result, translationTable = $translationTable[langKey];
                    if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
                        Interpolator.setLocale(langKey);
                        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, "filter", sanitizeStrategy, translationId);
                        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
                        // workaround for TrustedValueHolderType
                        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
                            var result2 = result.$$unwrapTrustedValue();
                            if (result2.substr(0, 2) === "@:") return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
                        } else if (result.substr(0, 2) === "@:") return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
                        Interpolator.setLocale($uses);
                    }
                    return result;
                };
                /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */ var translateByHandler = function(translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
                    // If we have a handler factory - we might also call it here to determine if it provides
                    // a default text for a translationid that can't be found anywhere in our tables
                    if ($missingTranslationHandlerFactory) return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
                    else return translationId;
                };
                /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */ var resolveForFallbackLanguage = function(fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
                    var deferred = $q.defer();
                    if (fallbackLanguageIndex < $fallbackLanguage.length) {
                        var langKey = $fallbackLanguage[fallbackLanguageIndex];
                        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(function(data) {
                            deferred.resolve(data);
                        }, function() {
                            // Look in the next fallback language for a translation.
                            // It delays the resolving by passing another promise to resolve.
                            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                        });
                    } else // No translation found in any fallback language
                    // if a default translation text is set in the directive, then return this as a result
                    if (defaultTranslationText) deferred.resolve(defaultTranslationText);
                    else {
                        var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
                        // if no default translation is set and an error handler is defined, send it to the handler
                        // and then return the result if it isn't undefined
                        if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) deferred.resolve(missingTranslationHandlerTranslation);
                        else deferred.reject(applyNotFoundIndicators(translationId));
                    }
                    return deferred.promise;
                };
                /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */ var resolveForFallbackLanguageInstant = function(fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                    var result;
                    if (fallbackLanguageIndex < $fallbackLanguage.length) {
                        var langKey = $fallbackLanguage[fallbackLanguageIndex];
                        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
                        if (!result && result !== "") result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
                    }
                    return result;
                };
                /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */ var fallbackTranslation = function(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
                    // Start with the fallbackLanguage with index 0
                    return resolveForFallbackLanguage(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
                };
                /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */ var fallbackTranslationInstant = function(translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                    // Start with the fallbackLanguage with index 0
                    return resolveForFallbackLanguageInstant(startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy);
                };
                var determineTranslation = function(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
                    var deferred = $q.defer();
                    var table = uses ? $translationTable[uses] : $translationTable, Interpolator = interpolationId ? interpolatorHashMap[interpolationId] : defaultInterpolator;
                    // if the translation id exists, we can just interpolate it
                    if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
                        var translation = table[translationId];
                        // If using link, rerun $translate with linked translationId and return it
                        if (translation.substr(0, 2) === "@:") $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                        else {
                            //
                            var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, "service", sanitizeStrategy, translationId);
                            resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
                            deferred.resolve(resolvedTranslation);
                        }
                    } else {
                        var missingTranslationHandlerTranslation;
                        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
                        if ($missingTranslationHandlerFactory && !pendingLoader) missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
                        // since we couldn't translate the inital requested translation id,
                        // we try it now with one or more fallback languages, if fallback language(s) is
                        // configured.
                        if (uses && $fallbackLanguage && $fallbackLanguage.length) fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(function(translation) {
                            deferred.resolve(translation);
                        }, function(_translationId) {
                            deferred.reject(applyNotFoundIndicators(_translationId));
                        });
                        else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                            // looks like the requested translation id doesn't exists.
                            // Now, if there is a registered handler for missing translations and no
                            // asyncLoader is pending, we execute the handler
                            if (defaultTranslationText) deferred.resolve(defaultTranslationText);
                            else deferred.resolve(missingTranslationHandlerTranslation);
                        } else if (defaultTranslationText) deferred.resolve(defaultTranslationText);
                        else deferred.reject(applyNotFoundIndicators(translationId));
                    }
                    return deferred.promise;
                };
                var determineTranslationInstant = function(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
                    var result, table = uses ? $translationTable[uses] : $translationTable, Interpolator = defaultInterpolator;
                    // if the interpolation id exists use custom interpolator
                    if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) Interpolator = interpolatorHashMap[interpolationId];
                    // if the translation id exists, we can just interpolate it
                    if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
                        var translation = table[translationId];
                        // If using link, rerun $translate with linked translationId and return it
                        if (translation.substr(0, 2) === "@:") result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
                        else {
                            result = Interpolator.interpolate(translation, interpolateParams, "filter", sanitizeStrategy, translationId);
                            result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
                        }
                    } else {
                        var missingTranslationHandlerTranslation;
                        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
                        if ($missingTranslationHandlerFactory && !pendingLoader) missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
                        // since we couldn't translate the inital requested translation id,
                        // we try it now with one or more fallback languages, if fallback language(s) is
                        // configured.
                        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                            fallbackIndex = 0;
                            result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
                        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        result = missingTranslationHandlerTranslation;
                        else result = applyNotFoundIndicators(translationId);
                    }
                    return result;
                };
                var clearNextLangAndPromise = function(key) {
                    if ($nextLang === key) $nextLang = undefined;
                    langPromises[key] = undefined;
                };
                var applyPostProcessing = function(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
                    var fn = postProcessFn;
                    if (fn) {
                        if (typeof fn === "string") // getting on-demand instance
                        fn = $injector.get(fn);
                        if (fn) return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
                    }
                    return resolvedTranslation;
                };
                var loadTranslationsIfMissing = function(key) {
                    if (!$translationTable[key] && $loaderFactory && !langPromises[key]) langPromises[key] = loadAsync(key).then(function(translation) {
                        translations(translation.key, translation.table);
                        return translation;
                    });
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */ $translate.preferredLanguage = function(langKey) {
                    if (langKey) setupPreferredLanguage(langKey);
                    return $preferredLanguage;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */ $translate.cloakClassName = function() {
                    return $cloakClassName;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#allowNamespaces
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns if namespaces are enabled
     *
     * @return {boolean} allowNamespaces value
     */ $translate.allowNamespaces = function() {
                    return $allowNamespaces;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */ $translate.nestedObjectDelimeter = function() {
                    return $nestedObjectDelimeter;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */ $translate.fallbackLanguage = function(langKey) {
                    if (langKey !== undefined && langKey !== null) {
                        fallbackStack(langKey);
                        // as we might have an async loader initiated and a new translation language might have been defined
                        // we need to add the promise to the stack also. So - iterate.
                        if ($loaderFactory) {
                            if ($fallbackLanguage && $fallbackLanguage.length) {
                                for(var i = 0, len = $fallbackLanguage.length; i < len; i++)if (!langPromises[$fallbackLanguage[i]]) langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
                            }
                        }
                        $translate.use($translate.use());
                    }
                    if ($fallbackWasString) return $fallbackLanguage[0];
                    else return $fallbackLanguage;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */ $translate.useFallbackLanguage = function(langKey) {
                    if (langKey !== undefined && langKey !== null) {
                        if (!langKey) startFallbackIteration = 0;
                        else {
                            var langKeyPosition = indexOf($fallbackLanguage, langKey);
                            if (langKeyPosition > -1) startFallbackIteration = langKeyPosition;
                        }
                    }
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */ $translate.proposedLanguage = function() {
                    return $nextLang;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */ $translate.storage = function() {
                    return Storage;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */ $translate.negotiateLocale = negotiateLocale;
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */ $translate.use = function(key) {
                    if (!key) return $uses;
                    var deferred = $q.defer();
                    deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
                    $rootScope.$emit("$translateChangeStart", {
                        language: key
                    });
                    // Try to get the aliased language key
                    var aliasedKey = negotiateLocale(key);
                    // Ensure only registered language keys will be loaded
                    if ($availableLanguageKeys.length > 0 && !aliasedKey) return $q.reject(key);
                    if (aliasedKey) key = aliasedKey;
                    // if there isn't a translation table for the language we've requested,
                    // we load it asynchronously
                    $nextLang = key;
                    if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
                        langPromises[key] = loadAsync(key).then(function(translation) {
                            translations(translation.key, translation.table);
                            deferred.resolve(translation.key);
                            if ($nextLang === key) useLanguage(translation.key);
                            return translation;
                        }, function(key) {
                            $rootScope.$emit("$translateChangeError", {
                                language: key
                            });
                            deferred.reject(key);
                            $rootScope.$emit("$translateChangeEnd", {
                                language: key
                            });
                            return $q.reject(key);
                        });
                        langPromises[key]["finally"](function() {
                            clearNextLangAndPromise(key);
                        })["catch"](angular.noop); // we don't care about errors (clearing)
                    } else if (langPromises[key]) // we are already loading this asynchronously
                    // resolve our new deferred when the old langPromise is resolved
                    langPromises[key].then(function(translation) {
                        if ($nextLang === translation.key) useLanguage(translation.key);
                        deferred.resolve(translation.key);
                        return translation;
                    }, function(key) {
                        // find first available fallback language if that request has failed
                        if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
                        else return deferred.reject(key);
                    });
                    else {
                        deferred.resolve(key);
                        useLanguage(key);
                    }
                    return deferred.promise;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */ $translate.resolveClientLocale = function() {
                    return getLocale();
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */ $translate.storageKey = function() {
                    return storageKey();
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */ $translate.isPostCompilingEnabled = function() {
                    return $postCompilingEnabled;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */ $translate.isForceAsyncReloadEnabled = function() {
                    return $forceAsyncReloadEnabled;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */ $translate.isKeepContent = function() {
                    return $keepContent;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */ $translate.refresh = function(langKey) {
                    if (!$loaderFactory) throw new Error("Couldn't refresh translation table, no loader registered!");
                    $rootScope.$emit("$translateRefreshStart", {
                        language: langKey
                    });
                    var deferred = $q.defer(), updatedLanguages = {};
                    //private helper
                    function loadNewData(languageKey) {
                        var promise = loadAsync(languageKey);
                        //update the load promise cache for this language
                        langPromises[languageKey] = promise;
                        //register a data handler for the promise
                        promise.then(function(data) {
                            //clear the cache for this language
                            $translationTable[languageKey] = {};
                            //add the new data for this language
                            translations(languageKey, data.table);
                            //track that we updated this language
                            updatedLanguages[languageKey] = true;
                        }, //handle rejection to appease the $q validation
                        angular.noop);
                        return promise;
                    }
                    //set up post-processing
                    deferred.promise.then(function() {
                        for(var key in $translationTable){
                            if ($translationTable.hasOwnProperty(key)) //delete cache entries that were not updated
                            {
                                if (!(key in updatedLanguages)) delete $translationTable[key];
                            }
                        }
                        if ($uses) useLanguage($uses);
                    }, //handle rejection to appease the $q validation
                    angular.noop)["finally"](function() {
                        $rootScope.$emit("$translateRefreshEnd", {
                            language: langKey
                        });
                    });
                    if (!langKey) {
                        // if there's no language key specified we refresh ALL THE THINGS!
                        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
                        if ($uses && languagesToReload.indexOf($uses) === -1) languagesToReload.push($uses);
                        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
                    } else if ($translationTable[langKey]) //just refresh the specified language cache
                    loadNewData(langKey).then(deferred.resolve, deferred.reject);
                    else deferred.reject();
                    return deferred.promise;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */ $translate.instant = function(translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
                    // we don't want to re-negotiate $uses
                    var uses = forceLanguage && forceLanguage !== $uses ? negotiateLocale(forceLanguage) || forceLanguage : $uses;
                    // Detect undefined and null values to shorten the execution and prevent exceptions
                    if (translationId === null || angular.isUndefined(translationId)) return translationId;
                    // Check forceLanguage is present
                    if (forceLanguage) loadTranslationsIfMissing(forceLanguage);
                    // Duck detection: If the first argument is an array, a bunch of translations was requested.
                    // The result is an object.
                    if (angular.isArray(translationId)) {
                        var results = {};
                        for(var i = 0, c = translationId.length; i < c; i++)results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
                        return results;
                    }
                    // We discarded unacceptable values. So we just need to verify if translationId is empty String
                    if (angular.isString(translationId) && translationId.length < 1) return translationId;
                    // trim off any whitespace
                    if (translationId) translationId = trim.apply(translationId);
                    var result, possibleLangKeys = [];
                    if ($preferredLanguage) possibleLangKeys.push($preferredLanguage);
                    if (uses) possibleLangKeys.push(uses);
                    if ($fallbackLanguage && $fallbackLanguage.length) possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
                    for(var j = 0, d = possibleLangKeys.length; j < d; j++){
                        var possibleLangKey = possibleLangKeys[j];
                        if ($translationTable[possibleLangKey]) {
                            if (typeof $translationTable[possibleLangKey][translationId] !== "undefined") result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
                        }
                        if (typeof result !== "undefined") break;
                    }
                    if (!result && result !== "") {
                        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) result = applyNotFoundIndicators(translationId);
                        else {
                            // Return translation of default interpolator if not found anything.
                            result = defaultInterpolator.interpolate(translationId, interpolateParams, "filter", sanitizeStrategy);
                            // looks like the requested translation id doesn't exists.
                            // Now, if there is a registered handler for missing translations and no
                            // asyncLoader is pending, we execute the handler
                            var missingTranslationHandlerTranslation;
                            if ($missingTranslationHandlerFactory && !pendingLoader) missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
                            if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) result = missingTranslationHandlerTranslation;
                        }
                    }
                    return result;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */ $translate.versionInfo = function() {
                    return version;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */ $translate.loaderCache = function() {
                    return loaderCache;
                };
                // internal purpose only
                $translate.directivePriority = function() {
                    return directivePriority;
                };
                // internal purpose only
                $translate.statefulFilter = function() {
                    return statefulFilter;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */ $translate.isReady = function() {
                    return $isReady;
                };
                var $onReadyDeferred = $q.defer();
                $onReadyDeferred.promise.then(function() {
                    $isReady = true;
                });
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */ $translate.onReady = function(fn) {
                    var deferred = $q.defer();
                    if (angular.isFunction(fn)) deferred.promise.then(fn);
                    if ($isReady) deferred.resolve();
                    else $onReadyDeferred.promise.then(deferred.resolve);
                    return deferred.promise;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */ $translate.getAvailableLanguageKeys = function() {
                    if ($availableLanguageKeys.length > 0) return $availableLanguageKeys;
                    return null;
                };
                /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */ $translate.getTranslationTable = function(langKey) {
                    langKey = langKey || $translate.use();
                    if (langKey && $translationTable[langKey]) return angular.copy($translationTable[langKey]);
                    return null;
                };
                // Whenever $translateReady is being fired, this will ensure the state of $isReady
                var globalOnReadyListener = $rootScope.$on("$translateReady", function() {
                    $onReadyDeferred.resolve();
                    globalOnReadyListener(); // one time only
                    globalOnReadyListener = null;
                });
                var globalOnChangeListener = $rootScope.$on("$translateChangeEnd", function() {
                    $onReadyDeferred.resolve();
                    globalOnChangeListener(); // one time only
                    globalOnChangeListener = null;
                });
                if ($loaderFactory) {
                    // If at least one async loader is defined and there are no
                    // (default) translations available we should try to load them.
                    if (angular.equals($translationTable, {})) {
                        if ($translate.use()) $translate.use($translate.use());
                    }
                    // Also, if there are any fallback language registered, we start
                    // loading them asynchronously as soon as we can.
                    if ($fallbackLanguage && $fallbackLanguage.length) {
                        var processAsyncResult = function(translation) {
                            translations(translation.key, translation.table);
                            $rootScope.$emit("$translateChangeEnd", {
                                language: translation.key
                            });
                            return translation;
                        };
                        for(var i = 0, len = $fallbackLanguage.length; i < len; i++){
                            var fallbackLanguageId = $fallbackLanguage[i];
                            if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
                        }
                    }
                } else $rootScope.$emit("$translateReady", {
                    language: $translate.use()
                });
                return $translate;
            }
        ];
    }
    $translate.displayName = "displayName";
    /**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */ angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation", $translateDefaultInterpolation);
    function $translateDefaultInterpolation($interpolate, $translateSanitization) {
        "use strict";
        var $translateInterpolator = {}, $locale, $identifier = "default";
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */ $translateInterpolator.setLocale = function(locale) {
            $locale = locale;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */ $translateInterpolator.getInterpolationIdentifier = function() {
            return $identifier;
        };
        /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */ $translateInterpolator.useSanitizeValueStrategy = function(value) {
            $translateSanitization.useStrategy(value);
            return this;
        };
        /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */ $translateInterpolator.interpolate = function(value, interpolationParams, context, sanitizeStrategy, translationId) {
            interpolationParams = interpolationParams || {};
            interpolationParams = $translateSanitization.sanitize(interpolationParams, "params", sanitizeStrategy, context);
            var interpolatedText;
            if (angular.isNumber(value)) // numbers are safe
            interpolatedText = "" + value;
            else if (angular.isString(value)) {
                // strings must be interpolated (that's the job here)
                interpolatedText = $interpolate(value)(interpolationParams);
                interpolatedText = $translateSanitization.sanitize(interpolatedText, "text", sanitizeStrategy, context);
            } else // neither a number or a string, cant interpolate => empty string
            interpolatedText = "";
            return interpolatedText;
        };
        return $translateInterpolator;
    }
    $translateDefaultInterpolation.displayName = "$translateDefaultInterpolation";
    angular.module("pascalprecht.translate").constant("$STORAGE_KEY", "NG_TRANSLATE_LANG_KEY");
    angular.module("pascalprecht.translate")/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */ .directive("translate", translateDirective);
    function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
        "use strict";
        /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */ var trim = function() {
            return this.toString().replace(/^\s+|\s+$/g, "");
        };
        /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */ var lowercase = function(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        };
        return {
            restrict: "AE",
            scope: true,
            priority: $translate.directivePriority(),
            compile: function(tElement, tAttr) {
                var translateValuesExist = tAttr.translateValues ? tAttr.translateValues : undefined;
                var translateInterpolation = tAttr.translateInterpolation ? tAttr.translateInterpolation : undefined;
                var translateSanitizeStrategyExist = tAttr.translateSanitizeStrategy ? tAttr.translateSanitizeStrategy : undefined;
                var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
                var interpolateRegExp = "^(.*)(" + $interpolate.startSymbol() + ".*" + $interpolate.endSymbol() + ")(.*)", watcherRegExp = "^(.*)" + $interpolate.startSymbol() + "(.*)" + $interpolate.endSymbol() + "(.*)";
                return function linkFn(scope, iElement, iAttr) {
                    scope.interpolateParams = {};
                    scope.preText = "";
                    scope.postText = "";
                    scope.translateNamespace = getTranslateNamespace(scope);
                    var translationIds = {};
                    var initInterpolationParams = function(interpolateParams, iAttr, tAttr) {
                        // initial setup
                        if (iAttr.translateValues) angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
                        // initially fetch all attributes if existing and fill the params
                        if (translateValueExist) {
                            for(var attr in tAttr)if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === "translateValue" && attr !== "translateValues") {
                                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                                interpolateParams[attributeName] = tAttr[attr];
                            }
                        }
                    };
                    // Ensures any change of the attribute "translate" containing the id will
                    // be re-stored to the scope's "translationId".
                    // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
                    var observeElementTranslation = function(translationId) {
                        // Remove any old watcher
                        if (angular.isFunction(observeElementTranslation._unwatchOld)) {
                            observeElementTranslation._unwatchOld();
                            observeElementTranslation._unwatchOld = undefined;
                        }
                        if (angular.equals(translationId, "") || !angular.isDefined(translationId)) {
                            var iElementText = trim.apply(iElement.text()).replace(/\n/g, " ");
                            // Resolve translation id by inner html if required
                            var interpolateMatches = iElementText.match(interpolateRegExp);
                            // Interpolate translation id if required
                            if (angular.isArray(interpolateMatches)) {
                                scope.preText = interpolateMatches[1];
                                scope.postText = interpolateMatches[3];
                                translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
                                var watcherMatches = iElementText.match(watcherRegExp);
                                if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function(newValue) {
                                    translationIds.translate = newValue;
                                    updateTranslations();
                                });
                            } else // do not assigne the translation id if it is empty.
                            translationIds.translate = !iElementText ? undefined : iElementText;
                        } else translationIds.translate = translationId;
                        updateTranslations();
                    };
                    var observeAttributeTranslation = function(translateAttr) {
                        iAttr.$observe(translateAttr, function(translationId) {
                            translationIds[translateAttr] = translationId;
                            updateTranslations();
                        });
                    };
                    // initial setup with values
                    initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
                    var firstAttributeChangedEvent = true;
                    iAttr.$observe("translate", function(translationId) {
                        if (typeof translationId === "undefined") // case of element "<translate>xyz</translate>"
                        observeElementTranslation("");
                        else // case of regular attribute
                        if (translationId !== "" || !firstAttributeChangedEvent) {
                            translationIds.translate = translationId;
                            updateTranslations();
                        }
                        firstAttributeChangedEvent = false;
                    });
                    for(var translateAttr in iAttr)if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === "translateAttr" && translateAttr.length > 13) observeAttributeTranslation(translateAttr);
                    iAttr.$observe("translateDefault", function(value) {
                        scope.defaultText = value;
                        updateTranslations();
                    });
                    if (translateSanitizeStrategyExist) iAttr.$observe("translateSanitizeStrategy", function(value) {
                        scope.sanitizeStrategy = $parse(value)(scope.$parent);
                        updateTranslations();
                    });
                    if (translateValuesExist) iAttr.$observe("translateValues", function(interpolateParams) {
                        if (interpolateParams) scope.$parent.$watch(function() {
                            angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                        });
                    });
                    if (translateValueExist) {
                        var observeValueAttribute = function(attrName) {
                            iAttr.$observe(attrName, function(value) {
                                var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
                                scope.interpolateParams[attributeName] = value;
                            });
                        };
                        for(var attr in iAttr)if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === "translateValue" && attr !== "translateValues") observeValueAttribute(attr);
                    }
                    // Master update function
                    var updateTranslations = function() {
                        for(var key in translationIds)if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
                    };
                    // Put translation processing function outside loop
                    var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
                        if (translationId) {
                            // if translation id starts with '.' and translateNamespace given, prepend namespace
                            if (translateNamespace && translationId.charAt(0) === ".") translationId = translateNamespace + translationId;
                            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy).then(function(translation) {
                                applyTranslation(translation, scope, true, translateAttr);
                            }, function(translationId) {
                                applyTranslation(translationId, scope, false, translateAttr);
                            });
                        } else // as an empty string cannot be translated, we can solve this using successful=false
                        applyTranslation(translationId, scope, false, translateAttr);
                    };
                    var applyTranslation = function(value, scope, successful, translateAttr) {
                        if (!successful) {
                            if (typeof scope.defaultText !== "undefined") value = scope.defaultText;
                        }
                        if (translateAttr === "translate") {
                            // default translate into innerHTML
                            if (successful || !successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === "undefined") iElement.empty().append(scope.preText + value + scope.postText);
                            var globallyEnabled = $translate.isPostCompilingEnabled();
                            var locallyDefined = typeof tAttr.translateCompile !== "undefined";
                            var locallyEnabled = locallyDefined && tAttr.translateCompile !== "false";
                            if (globallyEnabled && !locallyDefined || locallyEnabled) $compile(iElement.contents())(scope);
                        } else {
                            // translate attribute
                            var attributeName = iAttr.$attr[translateAttr];
                            if (attributeName.substr(0, 5) === "data-") // ensure html5 data prefix is stripped
                            attributeName = attributeName.substr(5);
                            attributeName = attributeName.substr(15);
                            iElement.attr(attributeName, value);
                        }
                    };
                    if (translateValuesExist || translateValueExist || iAttr.translateDefault) scope.$watch("interpolateParams", updateTranslations, true);
                    // Replaced watcher on translateLanguage with event listener
                    scope.$on("translateLanguageChanged", updateTranslations);
                    // Ensures the text will be refreshed after the current language was changed
                    // w/ $translate.use(...)
                    var unbind = $rootScope.$on("$translateChangeSuccess", updateTranslations);
                    // ensure translation will be looked up at least one
                    if (iElement.text().length) {
                        if (iAttr.translate) observeElementTranslation(iAttr.translate);
                        else observeElementTranslation("");
                    } else if (iAttr.translate) // ensure attribute will be not skipped
                    observeElementTranslation(iAttr.translate);
                    updateTranslations();
                    scope.$on("$destroy", unbind);
                };
            }
        };
    }
    /**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */ function getTranslateNamespace(scope) {
        "use strict";
        if (scope.translateNamespace) return scope.translateNamespace;
        if (scope.$parent) return getTranslateNamespace(scope.$parent);
    }
    translateDirective.displayName = "translateDirective";
    angular.module("pascalprecht.translate")/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */ .directive("translateAttr", translateAttrDirective);
    function translateAttrDirective($translate, $rootScope) {
        "use strict";
        return {
            restrict: "A",
            priority: $translate.directivePriority(),
            link: function linkFn(scope, element, attr) {
                var translateAttr, translateValues, translateSanitizeStrategy, previousAttributes = {};
                // Main update translations function
                var updateTranslations = function() {
                    angular.forEach(translateAttr, function(translationId, attributeName) {
                        if (!translationId) return;
                        previousAttributes[attributeName] = true;
                        // if translation id starts with '.' and translateNamespace given, prepend namespace
                        if (scope.translateNamespace && translationId.charAt(0) === ".") translationId = scope.translateNamespace + translationId;
                        $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy).then(function(translation) {
                            element.attr(attributeName, translation);
                        }, function(translationId) {
                            element.attr(attributeName, translationId);
                        });
                    });
                    // Removing unused attributes that were previously used
                    angular.forEach(previousAttributes, function(flag, attributeName) {
                        if (!translateAttr[attributeName]) {
                            element.removeAttr(attributeName);
                            delete previousAttributes[attributeName];
                        }
                    });
                };
                // Watch for attribute changes
                watchAttribute(scope, attr.translateAttr, function(newValue) {
                    translateAttr = newValue;
                }, updateTranslations);
                // Watch for value changes
                watchAttribute(scope, attr.translateValues, function(newValue) {
                    translateValues = newValue;
                }, updateTranslations);
                // Watch for sanitize strategy changes
                watchAttribute(scope, attr.translateSanitizeStrategy, function(newValue) {
                    translateSanitizeStrategy = newValue;
                }, updateTranslations);
                if (attr.translateValues) scope.$watch(attr.translateValues, updateTranslations, true);
                // Replaced watcher on translateLanguage with event listener
                scope.$on("translateLanguageChanged", updateTranslations);
                // Ensures the text will be refreshed after the current language was changed
                // w/ $translate.use(...)
                var unbind = $rootScope.$on("$translateChangeSuccess", updateTranslations);
                updateTranslations();
                scope.$on("$destroy", unbind);
            }
        };
    }
    function watchAttribute(scope, attribute, valueCallback, changeCallback) {
        "use strict";
        if (!attribute) return;
        if (attribute.substr(0, 2) === "::") attribute = attribute.substr(2);
        else scope.$watch(attribute, function(newValue) {
            valueCallback(newValue);
            changeCallback();
        }, true);
        valueCallback(scope.$eval(attribute));
    }
    translateAttrDirective.displayName = "translateAttrDirective";
    angular.module("pascalprecht.translate")/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */ .directive("translateCloak", translateCloakDirective);
    function translateCloakDirective($translate, $rootScope) {
        "use strict";
        return {
            compile: function(tElement) {
                var applyCloak = function(element) {
                    element.addClass($translate.cloakClassName());
                }, removeCloak = function(element) {
                    element.removeClass($translate.cloakClassName());
                };
                applyCloak(tElement);
                return function linkFn(scope, iElement, iAttr) {
                    //Create bound functions that incorporate the active DOM element.
                    var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
                    if (iAttr.translateCloak && iAttr.translateCloak.length) {
                        // Register a watcher for the defined translation allowing a fine tuned cloak
                        iAttr.$observe("translateCloak", function(translationId) {
                            $translate(translationId).then(iRemoveCloak, iApplyCloak);
                        });
                        $rootScope.$on("$translateChangeSuccess", function() {
                            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
                        });
                    } else $translate.onReady(iRemoveCloak);
                };
            }
        };
    }
    translateCloakDirective.displayName = "translateCloakDirective";
    angular.module("pascalprecht.translate")/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */ .directive("translateNamespace", translateNamespaceDirective);
    function translateNamespaceDirective() {
        "use strict";
        return {
            restrict: "A",
            scope: true,
            compile: function() {
                return {
                    pre: function(scope, iElement, iAttrs) {
                        scope.translateNamespace = _getTranslateNamespace(scope);
                        if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === ".") scope.translateNamespace += iAttrs.translateNamespace;
                        else scope.translateNamespace = iAttrs.translateNamespace;
                    }
                };
            }
        };
    }
    /**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */ function _getTranslateNamespace(scope) {
        "use strict";
        if (scope.translateNamespace) return scope.translateNamespace;
        if (scope.$parent) return _getTranslateNamespace(scope.$parent);
    }
    translateNamespaceDirective.displayName = "translateNamespaceDirective";
    angular.module("pascalprecht.translate")/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */ .directive("translateLanguage", translateLanguageDirective);
    function translateLanguageDirective() {
        "use strict";
        return {
            restrict: "A",
            scope: true,
            compile: function() {
                return function linkFn(scope, iElement, iAttrs) {
                    iAttrs.$observe("translateLanguage", function(newTranslateLanguage) {
                        scope.translateLanguage = newTranslateLanguage;
                    });
                    scope.$watch("translateLanguage", function() {
                        scope.$broadcast("translateLanguageChanged");
                    });
                };
            }
        };
    }
    translateLanguageDirective.displayName = "translateLanguageDirective";
    angular.module("pascalprecht.translate")/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */ .filter("translate", translateFilterFactory);
    function translateFilterFactory($parse, $translate) {
        "use strict";
        var translateFilter = function(translationId, interpolateParams, interpolation, forceLanguage) {
            if (!angular.isObject(interpolateParams)) {
                var ctx = this || {
                    "__SCOPE_IS_NOT_AVAILABLE": "More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f"
                };
                interpolateParams = $parse(interpolateParams)(ctx);
            }
            return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
        };
        if ($translate.statefulFilter()) translateFilter.$stateful = true;
        return translateFilter;
    }
    translateFilterFactory.displayName = "translateFilterFactory";
    angular.module("pascalprecht.translate")/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */ .factory("$translationCache", $translationCache);
    function $translationCache($cacheFactory) {
        "use strict";
        return $cacheFactory("translations");
    }
    $translationCache.displayName = "$translationCache";
    return "pascalprecht.translate";
});


/**
 * Main entry point for angular 1.x build
 * @publicapi @module ng1
 */ /** */ 

/* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable @typescript-eslint/no-unused-vars */ /**
 * # Angular 1 types
 *
 * UI-Router core provides various Typescript types which you can use for code completion and validating parameter values, etc.
 * The customizations to the core types for Angular UI-Router are documented here.
 *
 * The optional [[$resolve]] service is also documented here.
 *
 * @preferred @publicapi @module ng1
 */ /** */ /** @publicapi @module ng1 */ /** */ 
var $jTg1q = parcelRequire("jTg1q");
/** @hidden */ var $c3628d2e76534866$var$ng_from_global = angular;
var $c3628d2e76534866$export$acc5bfffa76564ff = $jTg1q && $jTg1q.module ? $jTg1q : $c3628d2e76534866$var$ng_from_global;


var $94fdab24f501d252$exports = {};
$parcel$export($94fdab24f501d252$exports, "applyPairs", function () { return $abcc081e7f2a61c5$export$448afb43435ef71e; });
$parcel$export($94fdab24f501d252$exports, "createProxyFunctions", function () { return $abcc081e7f2a61c5$export$a6c115f931de9046; });
$parcel$export($94fdab24f501d252$exports, "extend", function () { return $abcc081e7f2a61c5$export$8b58be045bf06082; });
$parcel$export($94fdab24f501d252$exports, "filter", function () { return $abcc081e7f2a61c5$export$3dea766d36a8935f; });
$parcel$export($94fdab24f501d252$exports, "forEach", function () { return $abcc081e7f2a61c5$export$4b80e395e36b5a56; });
$parcel$export($94fdab24f501d252$exports, "identity", function () { return $abcc081e7f2a61c5$export$f0954fd7d5368655; });
$parcel$export($94fdab24f501d252$exports, "inArray", function () { return $abcc081e7f2a61c5$export$6632823c2c02cb2c; });
$parcel$export($94fdab24f501d252$exports, "isArray", function () { return $c4ca6daaad7210ad$export$43bee75e5e14138e; });
$parcel$export($94fdab24f501d252$exports, "isDefined", function () { return $c4ca6daaad7210ad$export$4e62c701997796c1; });
$parcel$export($94fdab24f501d252$exports, "isFunction", function () { return $c4ca6daaad7210ad$export$f6e2535fb5126e54; });
$parcel$export($94fdab24f501d252$exports, "isInjectable", function () { return $c4ca6daaad7210ad$export$b0148ad22588aea3; });
$parcel$export($94fdab24f501d252$exports, "isObject", function () { return $c4ca6daaad7210ad$export$a6cdc56e425d0d0a; });
$parcel$export($94fdab24f501d252$exports, "isString", function () { return $c4ca6daaad7210ad$export$844ec244b1367d54; });
$parcel$export($94fdab24f501d252$exports, "kebobString", function () { return $48612b14b235e6fd$export$7e12dc7ef150dc64; });
$parcel$export($94fdab24f501d252$exports, "noop", function () { return $abcc081e7f2a61c5$export$8793edee2d425525; });
$parcel$export($94fdab24f501d252$exports, "parse", function () { return $b94057b5b409b0b1$export$98e6a39c04603d36; });
$parcel$export($94fdab24f501d252$exports, "pick", function () { return $abcc081e7f2a61c5$export$357523c63a2253b9; });
$parcel$export($94fdab24f501d252$exports, "removeFrom", function () { return $abcc081e7f2a61c5$export$dde48e6299cbd897; });
$parcel$export($94fdab24f501d252$exports, "services", function () { return $e592c26318c32a9d$export$bce7a36871692cab; });
$parcel$export($94fdab24f501d252$exports, "tail", function () { return $abcc081e7f2a61c5$export$c01875f616615628; });
$parcel$export($94fdab24f501d252$exports, "trace", function () { return $42b3df7fa4bc82fe$export$357889f174732d38; });
$parcel$export($94fdab24f501d252$exports, "uniqR", function () { return $abcc081e7f2a61c5$export$530e60648218df63; });
$parcel$export($94fdab24f501d252$exports, "unnestR", function () { return $abcc081e7f2a61c5$export$55d90b6e41f02f0; });
$parcel$export($94fdab24f501d252$exports, "val", function () { return $b94057b5b409b0b1$export$b02c28252f48c6ac; });
$parcel$export($94fdab24f501d252$exports, "Resolvable", function () { return $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e; });
$parcel$export($94fdab24f501d252$exports, "ResolveContext", function () { return $3996106c44ea4b60$export$fa71f212be031d8f; });
$parcel$export($94fdab24f501d252$exports, "UIRouter", function () { return $5e4c6b2b8af047a3$export$34bda4031e17f347; });
$parcel$export($94fdab24f501d252$exports, "applyPairs", function () { return $db28f2a65e245603$exports.applyPairs; });
$parcel$export($94fdab24f501d252$exports, "BaseUrlRule", function () { return $db28f2a65e245603$exports.BaseUrlRule; });
$parcel$export($94fdab24f501d252$exports, "createProxyFunctions", function () { return $db28f2a65e245603$exports.createProxyFunctions; });
$parcel$export($94fdab24f501d252$exports, "extend", function () { return $db28f2a65e245603$exports.extend; });
$parcel$export($94fdab24f501d252$exports, "filter", function () { return $db28f2a65e245603$exports.filter; });
$parcel$export($94fdab24f501d252$exports, "forEach", function () { return $db28f2a65e245603$exports.forEach; });
$parcel$export($94fdab24f501d252$exports, "identity", function () { return $db28f2a65e245603$exports.identity; });
$parcel$export($94fdab24f501d252$exports, "inArray", function () { return $db28f2a65e245603$exports.inArray; });
$parcel$export($94fdab24f501d252$exports, "isArray", function () { return $db28f2a65e245603$exports.isArray; });
$parcel$export($94fdab24f501d252$exports, "isDefined", function () { return $db28f2a65e245603$exports.isDefined; });
$parcel$export($94fdab24f501d252$exports, "isFunction", function () { return $db28f2a65e245603$exports.isFunction; });
$parcel$export($94fdab24f501d252$exports, "isInjectable", function () { return $db28f2a65e245603$exports.isInjectable; });
$parcel$export($94fdab24f501d252$exports, "isObject", function () { return $db28f2a65e245603$exports.isObject; });
$parcel$export($94fdab24f501d252$exports, "isString", function () { return $db28f2a65e245603$exports.isString; });
$parcel$export($94fdab24f501d252$exports, "kebobString", function () { return $db28f2a65e245603$exports.kebobString; });
$parcel$export($94fdab24f501d252$exports, "noop", function () { return $db28f2a65e245603$exports.noop; });
$parcel$export($94fdab24f501d252$exports, "parse", function () { return $db28f2a65e245603$exports.parse; });
$parcel$export($94fdab24f501d252$exports, "pick", function () { return $db28f2a65e245603$exports.pick; });
$parcel$export($94fdab24f501d252$exports, "removeFrom", function () { return $db28f2a65e245603$exports.removeFrom; });
$parcel$export($94fdab24f501d252$exports, "Resolvable", function () { return $db28f2a65e245603$exports.Resolvable; });
$parcel$export($94fdab24f501d252$exports, "ResolveContext", function () { return $db28f2a65e245603$exports.ResolveContext; });
$parcel$export($94fdab24f501d252$exports, "services", function () { return $db28f2a65e245603$exports.services; });
$parcel$export($94fdab24f501d252$exports, "tail", function () { return $db28f2a65e245603$exports.tail; });
$parcel$export($94fdab24f501d252$exports, "trace", function () { return $db28f2a65e245603$exports.trace; });
$parcel$export($94fdab24f501d252$exports, "UIRouter", function () { return $db28f2a65e245603$exports.UIRouter; });
$parcel$export($94fdab24f501d252$exports, "uniqR", function () { return $db28f2a65e245603$exports.uniqR; });
$parcel$export($94fdab24f501d252$exports, "unnestR", function () { return $db28f2a65e245603$exports.unnestR; });
$parcel$export($94fdab24f501d252$exports, "val", function () { return $db28f2a65e245603$exports.val; });
$parcel$export($94fdab24f501d252$exports, "ViewService", function () { return $db28f2a65e245603$exports.ViewService; });
/**
 * Predicates
 *
 * These predicates return true/false based on the input.
 * Although these functions are exported, they are subject to change without notice.
 *
 * @packageDocumentation
 */ /**
 * Higher order functions
 *
 * These utility functions are exported, but are subject to change without notice.
 *
 * @packageDocumentation
 */ var $b94057b5b409b0b1$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
function $b94057b5b409b0b1$export$c3095a23b368d1f2(fn) {
    return function curried() {
        if (arguments.length >= fn.length) return fn.apply(this, arguments);
        var args = Array.prototype.slice.call(arguments);
        return curried.bind.apply(curried, $b94057b5b409b0b1$var$__spreadArrays([
            this
        ], args));
    };
}
function $b94057b5b409b0b1$export$f672e0b6f7222cd7() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start, result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}
function $b94057b5b409b0b1$export$a4627e546088548d() {
    var funcs = [];
    for(var _i = 0; _i < arguments.length; _i++)funcs[_i] = arguments[_i];
    return $b94057b5b409b0b1$export$f672e0b6f7222cd7.apply(null, [].slice.call(arguments).reverse());
}
var $b94057b5b409b0b1$export$977f3f6a9323c0f6 = function(name) {
    return function(obj) {
        return obj && obj[name];
    };
};
var $b94057b5b409b0b1$export$78c65ad39408e96e = $b94057b5b409b0b1$export$c3095a23b368d1f2(function(name, _val, obj) {
    return obj && obj[name] === _val;
});
var $b94057b5b409b0b1$export$98e6a39c04603d36 = function(name) {
    return $b94057b5b409b0b1$export$a4627e546088548d.apply(null, name.split(".").map($b94057b5b409b0b1$export$977f3f6a9323c0f6));
};
var $b94057b5b409b0b1$export$6003a5f097c73977 = function(fn) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return !fn.apply(null, args);
    };
};
function $b94057b5b409b0b1$export$21c0ac7fe1cef1b8(fn1, fn2) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return fn1.apply(null, args) && fn2.apply(null, args);
    };
}
function $b94057b5b409b0b1$export$252bb8b3bbdf6749(fn1, fn2) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return fn1.apply(null, args) || fn2.apply(null, args);
    };
}
var $b94057b5b409b0b1$export$84bf76cd7afc7469 = function(fn1) {
    return function(arr) {
        return arr.reduce(function(b, x) {
            return b && !!fn1(x);
        }, true);
    };
};
var $b94057b5b409b0b1$export$4154a199d7d90455 = function(fn1) {
    return function(arr) {
        return arr.reduce(function(b, x) {
            return b || !!fn1(x);
        }, false);
    };
};
var $b94057b5b409b0b1$export$226b3eccf92c9ed9 = function(ctor) {
    return function(obj) {
        return obj != null && obj.constructor === ctor || obj instanceof ctor;
    };
};
var $b94057b5b409b0b1$export$9663ddc1cf085b32 = function(value) {
    return function(other) {
        return value === other;
    };
};
var $b94057b5b409b0b1$export$b02c28252f48c6ac = function(v) {
    return function() {
        return v;
    };
};
function $b94057b5b409b0b1$export$468cda29b159ee5d(fnName, args) {
    return function(obj) {
        return obj[fnName].apply(obj, args);
    };
}
function $b94057b5b409b0b1$export$24f82734ea047e6f(struct) {
    return function(x) {
        for(var i = 0; i < struct.length; i++){
            if (struct[i][0](x)) return struct[i][1](x);
        }
    };
}


var $c4ca6daaad7210ad$var$toStr = Object.prototype.toString;
var $c4ca6daaad7210ad$var$tis = function(t) {
    return function(x) {
        return typeof x === t;
    };
};
var $c4ca6daaad7210ad$export$fce6876652108ab = $c4ca6daaad7210ad$var$tis("undefined");
var $c4ca6daaad7210ad$export$4e62c701997796c1 = (0, $b94057b5b409b0b1$export$6003a5f097c73977)($c4ca6daaad7210ad$export$fce6876652108ab);
var $c4ca6daaad7210ad$export$630801d484da15df = function(o) {
    return o === null;
};
var $c4ca6daaad7210ad$export$bedb7023a7733221 = (0, $b94057b5b409b0b1$export$252bb8b3bbdf6749)($c4ca6daaad7210ad$export$630801d484da15df, $c4ca6daaad7210ad$export$fce6876652108ab);
var $c4ca6daaad7210ad$export$f6e2535fb5126e54 = $c4ca6daaad7210ad$var$tis("function");
var $c4ca6daaad7210ad$export$7e4aa119212bc614 = $c4ca6daaad7210ad$var$tis("number");
var $c4ca6daaad7210ad$export$844ec244b1367d54 = $c4ca6daaad7210ad$var$tis("string");
var $c4ca6daaad7210ad$export$a6cdc56e425d0d0a = function(x) {
    return x !== null && typeof x === "object";
};
var $c4ca6daaad7210ad$export$43bee75e5e14138e = Array.isArray;
var $c4ca6daaad7210ad$export$871608497c498473 = function(x) {
    return $c4ca6daaad7210ad$var$toStr.call(x) === "[object Date]";
};
var $c4ca6daaad7210ad$export$49841c62b9eff15 = function(x) {
    return $c4ca6daaad7210ad$var$toStr.call(x) === "[object RegExp]";
};
function $c4ca6daaad7210ad$export$b0148ad22588aea3(val) {
    if ($c4ca6daaad7210ad$export$43bee75e5e14138e(val) && val.length) {
        var head = val.slice(0, -1), tail = val.slice(-1);
        return !(head.filter((0, $b94057b5b409b0b1$export$6003a5f097c73977)($c4ca6daaad7210ad$export$844ec244b1367d54)).length || tail.filter((0, $b94057b5b409b0b1$export$6003a5f097c73977)($c4ca6daaad7210ad$export$f6e2535fb5126e54)).length);
    }
    return $c4ca6daaad7210ad$export$f6e2535fb5126e54(val);
}
var $c4ca6daaad7210ad$export$4369c812aac99591 = (0, $b94057b5b409b0b1$export$21c0ac7fe1cef1b8)($c4ca6daaad7210ad$export$a6cdc56e425d0d0a, (0, $b94057b5b409b0b1$export$a4627e546088548d)((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("then"), $c4ca6daaad7210ad$export$f6e2535fb5126e54));



var $e592c26318c32a9d$var$noImpl = function(fnname) {
    return function() {
        throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
    };
};
var $e592c26318c32a9d$export$74518f5fb3a7c7a3 = function(service, methods) {
    return methods.reduce(function(acc, key) {
        return acc[key] = $e592c26318c32a9d$var$noImpl(service + "." + key + "()"), acc;
    }, {});
};
var $e592c26318c32a9d$export$bce7a36871692cab = {
    $q: undefined,
    $injector: undefined
};


var $abcc081e7f2a61c5$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $abcc081e7f2a61c5$export$e8e78c978b129247 = typeof self === "object" && self.self === self && self || typeof $parcel$global === "object" && $parcel$global.global === $parcel$global && $parcel$global || undefined;
var $abcc081e7f2a61c5$var$angular = $abcc081e7f2a61c5$export$e8e78c978b129247.angular || {};
var $abcc081e7f2a61c5$export$7ae2d2a8b28a8cb8 = $abcc081e7f2a61c5$var$angular.fromJson || JSON.parse.bind(JSON);
var $abcc081e7f2a61c5$export$d5b7a8bf56ee1fe2 = $abcc081e7f2a61c5$var$angular.toJson || JSON.stringify.bind(JSON);
var $abcc081e7f2a61c5$export$4b80e395e36b5a56 = $abcc081e7f2a61c5$var$angular.forEach || $abcc081e7f2a61c5$var$_forEach;
var $abcc081e7f2a61c5$export$8b58be045bf06082 = Object.assign || $abcc081e7f2a61c5$export$1cda9d8dbbcbd6b1;
var $abcc081e7f2a61c5$export$e9bab7fafb253603 = $abcc081e7f2a61c5$var$angular.equals || $abcc081e7f2a61c5$var$_equals;
function $abcc081e7f2a61c5$export$f0954fd7d5368655(x) {
    return x;
}
function $abcc081e7f2a61c5$export$8793edee2d425525() {}
function $abcc081e7f2a61c5$export$a6c115f931de9046(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) latebind = false;
    var bindFunction = function(fnName) {
        return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function(fnName) {
        return function lateRebindFunction() {
            target[fnName] = bindFunction(fnName);
            return target[fnName].apply(null, arguments);
        };
    };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function(acc, name) {
        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
        return acc;
    }, target);
}
var $abcc081e7f2a61c5$export$4dc9a6b0ae3dfd2a = function(parent, extra) {
    return $abcc081e7f2a61c5$export$8b58be045bf06082(Object.create(parent), extra);
};
var $abcc081e7f2a61c5$export$6632823c2c02cb2c = (0, $b94057b5b409b0b1$export$c3095a23b368d1f2)($abcc081e7f2a61c5$export$65a12f3c235fcc6f);
function $abcc081e7f2a61c5$export$65a12f3c235fcc6f(array, obj) {
    return array.indexOf(obj) !== -1;
}
var $abcc081e7f2a61c5$export$dde48e6299cbd897 = (0, $b94057b5b409b0b1$export$c3095a23b368d1f2)($abcc081e7f2a61c5$export$d171ca9f4c9d535d);
function $abcc081e7f2a61c5$export$d171ca9f4c9d535d(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0) array.splice(idx, 1);
    return array;
}
var $abcc081e7f2a61c5$export$699f57d9c335c35d = (0, $b94057b5b409b0b1$export$c3095a23b368d1f2)($abcc081e7f2a61c5$export$ab2cfa5b87609d8f);
function $abcc081e7f2a61c5$export$ab2cfa5b87609d8f(arr, val) {
    return arr.push(val), val;
}
var $abcc081e7f2a61c5$export$622ff73c0131ee2b = function(functions) {
    return functions.slice().forEach(function(fn) {
        typeof fn === "function" && fn();
        $abcc081e7f2a61c5$export$dde48e6299cbd897(functions, fn);
    });
};
function $abcc081e7f2a61c5$export$ebe90cb607ad99e(opts) {
    var defaultsList = [];
    for(var _i = 1; _i < arguments.length; _i++)defaultsList[_i - 1] = arguments[_i];
    var defaultVals = $abcc081e7f2a61c5$export$8b58be045bf06082.apply(void 0, $abcc081e7f2a61c5$var$__spreadArrays([
        {}
    ], defaultsList.reverse()));
    return $abcc081e7f2a61c5$export$8b58be045bf06082(defaultVals, $abcc081e7f2a61c5$export$357523c63a2253b9(opts || {}, Object.keys(defaultVals)));
}
var $abcc081e7f2a61c5$export$625f91792a536171 = function(memo, item) {
    return $abcc081e7f2a61c5$export$8b58be045bf06082(memo, item);
};
function $abcc081e7f2a61c5$export$dfc9e7b996f62d3d(first, second) {
    var path = [];
    // tslint:disable-next-line:forin
    for(var n in first.path){
        if (first.path[n] !== second.path[n]) break;
        path.push(first.path[n]);
    }
    return path;
}
function $abcc081e7f2a61c5$export$357523c63a2253b9(obj, propNames) {
    var objCopy = {};
    for(var _prop in obj)if (propNames.indexOf(_prop) !== -1) objCopy[_prop] = obj[_prop];
    return objCopy;
}
function $abcc081e7f2a61c5$export$30a06c8d3562193f(obj, propNames) {
    return Object.keys(obj).filter((0, $b94057b5b409b0b1$export$6003a5f097c73977)($abcc081e7f2a61c5$export$6632823c2c02cb2c(propNames))).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
}
function $abcc081e7f2a61c5$export$c44985b87d605eff(collection, propName) {
    return $abcc081e7f2a61c5$export$871de8747c9eaa88(collection, (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)(propName));
}
function $abcc081e7f2a61c5$export$3dea766d36a8935f(collection, callback) {
    var arr = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(collection), result = arr ? [] : {};
    var accept = arr ? function(x) {
        return result.push(x);
    } : function(x, key) {
        return result[key] = x;
    };
    $abcc081e7f2a61c5$export$4b80e395e36b5a56(collection, function(item, i) {
        if (callback(item, i)) accept(item, i);
    });
    return result;
}
function $abcc081e7f2a61c5$export$71aa6c912b956294(collection, callback) {
    var result;
    $abcc081e7f2a61c5$export$4b80e395e36b5a56(collection, function(item, i) {
        if (result) return;
        if (callback(item, i)) result = item;
    });
    return result;
}
var $abcc081e7f2a61c5$export$2910e2aad8eb2960 = $abcc081e7f2a61c5$export$871de8747c9eaa88;
function $abcc081e7f2a61c5$export$871de8747c9eaa88(collection, callback, target) {
    target = target || ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(collection) ? [] : {});
    $abcc081e7f2a61c5$export$4b80e395e36b5a56(collection, function(item, i) {
        return target[i] = callback(item, i);
    });
    return target;
}
var $abcc081e7f2a61c5$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $abcc081e7f2a61c5$export$d1a75794f55e0c66 = function(memo, elem) {
    return memo && elem;
};
var $abcc081e7f2a61c5$export$a28cc26332787380 = function(memo, elem) {
    return memo || elem;
};
var $abcc081e7f2a61c5$export$55d90b6e41f02f0 = function(memo, elem) {
    return memo.concat(elem);
};
var $abcc081e7f2a61c5$export$fe8babda20d2d313 = function(memo, elem) {
    return (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(elem) ? memo.concat(elem.reduce($abcc081e7f2a61c5$export$fe8babda20d2d313, [])) : $abcc081e7f2a61c5$export$44675e76d3156b3a(memo, elem);
};
function $abcc081e7f2a61c5$export$44675e76d3156b3a(arr, obj) {
    arr.push(obj);
    return arr;
}
var $abcc081e7f2a61c5$export$530e60648218df63 = function(acc, token) {
    return $abcc081e7f2a61c5$export$6632823c2c02cb2c(acc, token) ? acc : $abcc081e7f2a61c5$export$44675e76d3156b3a(acc, token);
};
var $abcc081e7f2a61c5$export$d41cf2556b2767f1 = function(arr) {
    return arr.reduce($abcc081e7f2a61c5$export$55d90b6e41f02f0, []);
};
var $abcc081e7f2a61c5$export$bffa455ba8c619a6 = function(arr) {
    return arr.reduce($abcc081e7f2a61c5$export$fe8babda20d2d313, []);
};
var $abcc081e7f2a61c5$export$f31d929251c75416 = $abcc081e7f2a61c5$export$471f926058ed234c;
var $abcc081e7f2a61c5$export$c3a6739137a8aa74 = $abcc081e7f2a61c5$export$471f926058ed234c;
function $abcc081e7f2a61c5$export$471f926058ed234c(predicateOrMap, errMsg) {
    if (errMsg === void 0) errMsg = "assert failure";
    return function(obj) {
        var result = predicateOrMap(obj);
        if (!result) throw new Error((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(errMsg) ? errMsg(obj) : errMsg);
        return result;
    };
}
var $abcc081e7f2a61c5$export$589748d90c221be3 = function(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
};
function $abcc081e7f2a61c5$export$ade9293c41c5aa01() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 0) return [];
    var maxArrayLen = args.reduce(function(min, arr) {
        return Math.min(arr.length, min);
    }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
    var result = [];
    var _loop_1 = function(i) {
        // This is a hot function
        // Unroll when there are 1-4 arguments
        switch(args.length){
            case 1:
                result.push([
                    args[0][i]
                ]);
                break;
            case 2:
                result.push([
                    args[0][i],
                    args[1][i]
                ]);
                break;
            case 3:
                result.push([
                    args[0][i],
                    args[1][i],
                    args[2][i]
                ]);
                break;
            case 4:
                result.push([
                    args[0][i],
                    args[1][i],
                    args[2][i],
                    args[3][i]
                ]);
                break;
            default:
                result.push(args.map(function(array) {
                    return array[i];
                }));
                break;
        }
    };
    for(var i = 0; i < maxArrayLen; i++)_loop_1(i);
    return result;
}
function $abcc081e7f2a61c5$export$448afb43435ef71e(memo, keyValTuple) {
    var key, value;
    if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(keyValTuple)) key = keyValTuple[0], value = keyValTuple[1];
    if (!(0, $c4ca6daaad7210ad$export$844ec244b1367d54)(key)) throw new Error("invalid parameters to applyPairs");
    memo[key] = value;
    return memo;
}
function $abcc081e7f2a61c5$export$c01875f616615628(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
}
function $abcc081e7f2a61c5$export$784d13d8ee351f07(src, dest) {
    if (dest) Object.keys(dest).forEach(function(key) {
        return delete dest[key];
    });
    if (!dest) dest = {};
    return $abcc081e7f2a61c5$export$8b58be045bf06082(dest, src);
}
/** Naive forEach implementation works with Objects or Arrays */ function $abcc081e7f2a61c5$var$_forEach(obj, cb, _this) {
    if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(obj)) return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function(key) {
        return cb(obj[key], key);
    });
}
function $abcc081e7f2a61c5$export$1cda9d8dbbcbd6b1(toObj) {
    for(var i = 1; i < arguments.length; i++){
        var obj = arguments[i];
        if (!obj) continue;
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; j++)toObj[keys[j]] = obj[keys[j]];
    }
    return toObj;
}
function $abcc081e7f2a61c5$var$_equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    var t1 = typeof o1, t2 = typeof o2;
    if (t1 !== t2 || t1 !== "object") return false;
    var tup = [
        o1,
        o2
    ];
    if ((0, $b94057b5b409b0b1$export$84bf76cd7afc7469)((0, $c4ca6daaad7210ad$export$43bee75e5e14138e))(tup)) return $abcc081e7f2a61c5$var$_arraysEq(o1, o2);
    if ((0, $b94057b5b409b0b1$export$84bf76cd7afc7469)((0, $c4ca6daaad7210ad$export$871608497c498473))(tup)) return o1.getTime() === o2.getTime();
    if ((0, $b94057b5b409b0b1$export$84bf76cd7afc7469)((0, $c4ca6daaad7210ad$export$49841c62b9eff15))(tup)) return o1.toString() === o2.toString();
    if ((0, $b94057b5b409b0b1$export$84bf76cd7afc7469)((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54))(tup)) return true; // meh
    var predicates = [
        (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54),
        (0, $c4ca6daaad7210ad$export$43bee75e5e14138e),
        (0, $c4ca6daaad7210ad$export$871608497c498473),
        (0, $c4ca6daaad7210ad$export$49841c62b9eff15)
    ];
    if (predicates.map((0, $b94057b5b409b0b1$export$4154a199d7d90455)).reduce(function(b, fn) {
        return b || !!fn(tup);
    }, false)) return false;
    var keys = {};
    // tslint:disable-next-line:forin
    for(var key in o1){
        if (!$abcc081e7f2a61c5$var$_equals(o1[key], o2[key])) return false;
        keys[key] = true;
    }
    for(var key in o2){
        if (!keys[key]) return false;
    }
    return true;
}
function $abcc081e7f2a61c5$var$_arraysEq(a1, a2) {
    if (a1.length !== a2.length) return false;
    return $abcc081e7f2a61c5$export$ade9293c41c5aa01(a1, a2).reduce(function(b, t) {
        return b && $abcc081e7f2a61c5$var$_equals(t[0], t[1]);
    }, true);
}
var $abcc081e7f2a61c5$export$a71bc6bca9930802 = function(promise) {
    return promise.catch(function(e) {
        return 0;
    }) && promise;
};
var $abcc081e7f2a61c5$export$799ed83fec19ce5d = function(error) {
    return $abcc081e7f2a61c5$export$a71bc6bca9930802((0, $e592c26318c32a9d$export$bce7a36871692cab).$q.reject(error));
};



/**
 * Matches state names using glob-like pattern strings.
 *
 * Globs can be used in specific APIs including:
 *
 * - [[StateService.is]]
 * - [[StateService.includes]]
 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
 *
 * A `Glob` string is a pattern which matches state names.
 * Nested state names are split into segments (separated by a dot) when processing.
 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
 *
 * Globs work according to the following rules:
 *
 * ### Exact match:
 *
 * The glob `'A.B'` matches the state named exactly `'A.B'`.
 *
 * | Glob        |Matches states named|Does not match state named|
 * |:------------|:--------------------|:---------------------|
 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
 *
 * ### Single star (`*`)
 *
 * A single star (`*`) is a wildcard that matches exactly one segment.
 *
 * | Glob        |Matches states named  |Does not match state named |
 * |:------------|:---------------------|:--------------------------|
 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
 *
 * ### Double star (`**`)
 *
 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
 *
 * | Glob        |Matches states named                           |Does not match state named         |
 * |:------------|:----------------------------------------------|:----------------------------------|
 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
 *
 * @packageDocumentation
 */ var $037d6cb562d64aaa$export$e1c4d8357a9b5598 = /** @class */ function() {
    function Glob(text) {
        this.text = text;
        this.glob = text.split(".");
        var regexpString = this.text.split(".").map(function(seg) {
            if (seg === "**") return "(?:|(?:\\.[^.]*)*)";
            if (seg === "*") return "\\.[^.]*";
            return "\\." + seg;
        }).join("");
        this.regexp = new RegExp("^" + regexpString + "$");
    }
    /** Returns true if the string has glob-like characters in it */ Glob.is = function(text) {
        return !!/[!,*]+/.exec(text);
    };
    /** Returns a glob from the string, or null if the string isn't Glob-like */ Glob.fromString = function(text) {
        return Glob.is(text) ? new Glob(text) : null;
    };
    Glob.prototype.matches = function(name) {
        return this.regexp.test("." + name);
    };
    return Glob;
}();





var $1ccfe5f6108c2c49$export$3dc07afe418952bc = /** @class */ function() {
    function Queue(_items, _limit) {
        if (_items === void 0) _items = [];
        if (_limit === void 0) _limit = null;
        this._items = _items;
        this._limit = _limit;
        this._evictListeners = [];
        this.onEvict = (0, $abcc081e7f2a61c5$export$699f57d9c335c35d)(this._evictListeners);
    }
    Queue.prototype.enqueue = function(item) {
        var items = this._items;
        items.push(item);
        if (this._limit && items.length > this._limit) this.evict();
        return item;
    };
    Queue.prototype.evict = function() {
        var item = this._items.shift();
        this._evictListeners.forEach(function(fn) {
            return fn(item);
        });
        return item;
    };
    Queue.prototype.dequeue = function() {
        if (this.size()) return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function() {
        var current = this._items;
        this._items = [];
        return current;
    };
    Queue.prototype.size = function() {
        return this._items.length;
    };
    Queue.prototype.remove = function(item) {
        var idx = this._items.indexOf(item);
        return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function() {
        return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function() {
        if (this.size()) return this._items[0];
    };
    return Queue;
}();


/**
 * Functions that manipulate strings
 *
 * Although these functions are exported, they are subject to change without notice.
 *
 * @packageDocumentation
 */ 



"use strict";
/** An enum for Transition Rejection reasons */ var $24ffb5fe12175fdd$export$59c5466e57555862;
(function(RejectType) {
    /**
     * A new transition superseded this one.
     *
     * While this transition was running, a new transition started.
     * This transition is cancelled because it was superseded by new transition.
     */ RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    /**
     * The transition was aborted
     *
     * The transition was aborted by a hook which returned `false`
     */ RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    /**
     * The transition was invalid
     *
     * The transition was never started because it was invalid
     */ RejectType[RejectType["INVALID"] = 4] = "INVALID";
    /**
     * The transition was ignored
     *
     * The transition was ignored because it would have no effect.
     *
     * Either:
     *
     * - The transition is targeting the current state and parameter values
     * - The transition is targeting the same state and parameter values as the currently running transition.
     */ RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    /**
     * The transition errored.
     *
     * This generally means a hook threw an error or returned a rejected promise
     */ RejectType[RejectType["ERROR"] = 6] = "ERROR";
})($24ffb5fe12175fdd$export$59c5466e57555862 || ($24ffb5fe12175fdd$export$59c5466e57555862 = {}));
/** @internal */ var $24ffb5fe12175fdd$var$id = 0;
var $24ffb5fe12175fdd$export$a40146100efc171b = /** @class */ function() {
    function Rejection(type, message, detail) {
        /** @internal */ this.$id = $24ffb5fe12175fdd$var$id++;
        this.type = type;
        this.message = message;
        this.detail = detail;
    }
    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */ Rejection.isRejectionPromise = function(obj) {
        return obj && typeof obj.then === "function" && (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)(Rejection)(obj._transitionRejection);
    };
    /** Returns a Rejection due to transition superseded */ Rejection.superseded = function(detail, options) {
        var message = "The transition has been superseded by a different transition";
        var rejection = new Rejection($24ffb5fe12175fdd$export$59c5466e57555862.SUPERSEDED, message, detail);
        if (options && options.redirected) rejection.redirected = true;
        return rejection;
    };
    /** Returns a Rejection due to redirected transition */ Rejection.redirected = function(detail) {
        return Rejection.superseded(detail, {
            redirected: true
        });
    };
    /** Returns a Rejection due to invalid transition */ Rejection.invalid = function(detail) {
        var message = "This transition is invalid";
        return new Rejection($24ffb5fe12175fdd$export$59c5466e57555862.INVALID, message, detail);
    };
    /** Returns a Rejection due to ignored transition */ Rejection.ignored = function(detail) {
        var message = "The transition was ignored";
        return new Rejection($24ffb5fe12175fdd$export$59c5466e57555862.IGNORED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */ Rejection.aborted = function(detail) {
        var message = "The transition has been aborted";
        return new Rejection($24ffb5fe12175fdd$export$59c5466e57555862.ABORTED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */ Rejection.errored = function(detail) {
        var message = "The transition errored";
        return new Rejection($24ffb5fe12175fdd$export$59c5466e57555862.ERROR, message, detail);
    };
    /**
     * Returns a Rejection
     *
     * Normalizes a value as a Rejection.
     * If the value is already a Rejection, returns it.
     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
     *
     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
     */ Rejection.normalize = function(detail) {
        return (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)(Rejection)(detail) ? detail : Rejection.errored(detail);
    };
    Rejection.prototype.toString = function() {
        var detailString = function(d) {
            return d && d.toString !== Object.prototype.toString ? d.toString() : (0, $48612b14b235e6fd$export$fac44ee5b035f737)(d);
        };
        var detail = detailString(this.detail);
        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function() {
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)((0, $abcc081e7f2a61c5$export$799ed83fec19ce5d)(this), {
            _transitionRejection: this
        });
    };
    return Rejection;
}();




function $48612b14b235e6fd$export$c9f461152c658a8b(max, str) {
    if (str.length <= max) return str;
    return str.substr(0, max - 3) + "...";
}
function $48612b14b235e6fd$export$e3f9b6bf3780ff6e(length, str) {
    while(str.length < length)str += " ";
    return str;
}
function $48612b14b235e6fd$export$7e12dc7ef150dc64(camelCase) {
    return camelCase.replace(/^([A-Z])/, function($1) {
        return $1.toLowerCase();
    }) // replace first char
    .replace(/([A-Z])/g, function($1) {
        return "-" + $1.toLowerCase();
    }); // replace rest
}
function $48612b14b235e6fd$export$3f4acdc58db5898f(fn) {
    var fnStr = $48612b14b235e6fd$export$4fb15e473756ce74(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn["name"] || "";
    if (fnName && toStr.match(/function \(/)) return "function " + fnName + toStr.substr(9);
    return toStr;
}
function $48612b14b235e6fd$export$4fb15e473756ce74(fn) {
    var _fn = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || "undefined";
}
function $48612b14b235e6fd$export$fac44ee5b035f737(o) {
    var seen = [];
    var isRejection = (0, $24ffb5fe12175fdd$export$a40146100efc171b).isRejectionPromise;
    var hasToString = function(obj) {
        return (0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(obj) && !(0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(obj) && obj.constructor !== Object && (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(obj.toString);
    };
    var stringifyPattern = (0, $b94057b5b409b0b1$export$24f82734ea047e6f)([
        [
            (0, $c4ca6daaad7210ad$export$fce6876652108ab),
            (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)("undefined")
        ],
        [
            (0, $c4ca6daaad7210ad$export$630801d484da15df),
            (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)("null")
        ],
        [
            (0, $c4ca6daaad7210ad$export$4369c812aac99591),
            (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)("[Promise]")
        ],
        [
            isRejection,
            function(x) {
                return x._transitionRejection.toString();
            }
        ],
        [
            hasToString,
            function(x) {
                return x.toString();
            }
        ],
        [
            (0, $c4ca6daaad7210ad$export$b0148ad22588aea3),
            $48612b14b235e6fd$export$3f4acdc58db5898f
        ],
        [
            (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(true),
            (0, $abcc081e7f2a61c5$export$f0954fd7d5368655)
        ]
    ]);
    function format(value) {
        if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(value)) {
            if (seen.indexOf(value) !== -1) return "[circular ref]";
            seen.push(value);
        }
        return stringifyPattern(value);
    }
    if ((0, $c4ca6daaad7210ad$export$fce6876652108ab)(o)) // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
    // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
    // manually stringifying it.
    return format(o);
    return JSON.stringify(o, function(key, value) {
        return format(value);
    }).replace(/\\"/g, '"');
}
var $48612b14b235e6fd$export$60ef89c14e7186dc = function(char) {
    return function(str) {
        if (!str) return [
            "",
            ""
        ];
        var idx = str.indexOf(char);
        if (idx === -1) return [
            str,
            ""
        ];
        return [
            str.substr(0, idx),
            str.substr(idx + 1)
        ];
    };
};
var $48612b14b235e6fd$export$f3afc21c8b33e2cf = new RegExp("^(?:[a-z]+:)?//[^/]+/");
var $48612b14b235e6fd$export$356e6f9ad5e3a83c = function(str) {
    return str.replace(/\/[^/]*$/, "");
};
var $48612b14b235e6fd$export$f5b5dbe6ba3ae848 = $48612b14b235e6fd$export$60ef89c14e7186dc("#");
var $48612b14b235e6fd$export$b5802ef2fc4ab811 = $48612b14b235e6fd$export$60ef89c14e7186dc("?");
var $48612b14b235e6fd$export$b2d224173f61ffe5 = $48612b14b235e6fd$export$60ef89c14e7186dc("=");
var $48612b14b235e6fd$export$17cc07cf24d37bb = function(str) {
    return str ? str.replace(/^#/, "") : "";
};
function $48612b14b235e6fd$export$3a01864721f131f2(delim) {
    var re = new RegExp("(" + delim + ")", "g");
    return function(str) {
        return str.split(re).filter((0, $abcc081e7f2a61c5$export$f0954fd7d5368655));
    };
}
function $48612b14b235e6fd$export$10a23ad7eecfc1d8(acc, x) {
    if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)((0, $abcc081e7f2a61c5$export$c01875f616615628)(acc)) && (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(x)) return acc.slice(0, -1).concat((0, $abcc081e7f2a61c5$export$c01875f616615628)(acc) + x);
    return (0, $abcc081e7f2a61c5$export$44675e76d3156b3a)(acc, x);
}


/**
 * # Transition tracing (debug)
 *
 * Enable transition tracing to print transition information to the console,
 * in order to help debug your application.
 * Tracing logs detailed information about each Transition to your console.
 *
 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
 *
 * ### ES6
 * ```js
 * import {trace} from "@uirouter/core";
 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
 * ```
 *
 * ### CJS
 * ```js
 * let trace = require("@uirouter/core").trace;
 * trace.enable("TRANSITION", "VIEWCONFIG");
 * ```
 *
 * ### Globals
 * ```js
 * let trace = window["@uirouter/core"].trace;
 * trace.enable(); // Trace everything (very verbose)
 * ```
 *
 * ### Angular 1:
 * ```js
 * app.run($trace => $trace.enable());
 * ```
 *
 * @packageDocumentation
 */ 


/**
 * workaround for missing console object in IE9 when dev tools haven't been opened o_O
 * @packageDocumentation
 */ /* tslint:disable:no-console */ 
var $32d2769bf48d6ac5$var$noopConsoleStub = {
    log: (0, $abcc081e7f2a61c5$export$8793edee2d425525),
    error: (0, $abcc081e7f2a61c5$export$8793edee2d425525),
    table: (0, $abcc081e7f2a61c5$export$8793edee2d425525)
};
function $32d2769bf48d6ac5$var$ie9Console(console1) {
    var bound = function(fn) {
        return Function.prototype.bind.call(fn, console1);
    };
    return {
        log: bound(console1.log),
        error: bound(console1.log),
        table: bound(console1.log)
    };
}
function $32d2769bf48d6ac5$var$fallbackConsole(console1) {
    var log = console1.log.bind(console1);
    var error = console1.error ? console1.error.bind(console1) : log;
    var table = console1.table ? console1.table.bind(console1) : log;
    return {
        log: log,
        error: error,
        table: table
    };
}
function $32d2769bf48d6ac5$var$getSafeConsole() {
    // @ts-ignore
    var isIE9 = typeof document !== "undefined" && document.documentMode && document.documentMode === 9;
    if (isIE9) return window && window.console ? $32d2769bf48d6ac5$var$ie9Console(window.console) : $32d2769bf48d6ac5$var$noopConsoleStub;
    else if (!console.table || !console.error) return $32d2769bf48d6ac5$var$fallbackConsole(console);
    else return console;
}
var $32d2769bf48d6ac5$export$e05ea0a0aaef622f = $32d2769bf48d6ac5$var$getSafeConsole();


function $42b3df7fa4bc82fe$var$uiViewString(uiview) {
    if (!uiview) return "ui-view (defunct)";
    var state = uiview.creationContext ? uiview.creationContext.name || "(root)" : "(none)";
    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
}
var $42b3df7fa4bc82fe$var$viewConfigString = function(viewConfig) {
    var view = viewConfig.viewDecl;
    var state = view.$context.name || "(root)";
    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
};
function $42b3df7fa4bc82fe$var$normalizedCat(input) {
    return (0, $c4ca6daaad7210ad$export$7e4aa119212bc614)(input) ? $42b3df7fa4bc82fe$export$3a8840c5b2ecf003[input] : $42b3df7fa4bc82fe$export$3a8840c5b2ecf003[$42b3df7fa4bc82fe$export$3a8840c5b2ecf003[input]];
}
/**
 * Trace categories Enum
 *
 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
 *
 * `trace.enable(Category.TRANSITION)`
 *
 * These can also be provided using a matching string, or position ordinal
 *
 * `trace.enable("TRANSITION")`
 *
 * `trace.enable(1)`
 */ var $42b3df7fa4bc82fe$export$3a8840c5b2ecf003;
(function(Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
})($42b3df7fa4bc82fe$export$3a8840c5b2ecf003 || ($42b3df7fa4bc82fe$export$3a8840c5b2ecf003 = {}));
var $42b3df7fa4bc82fe$var$_tid = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("$id");
var $42b3df7fa4bc82fe$var$_rid = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("router.$id");
var $42b3df7fa4bc82fe$var$transLbl = function(trans) {
    return "Transition #" + $42b3df7fa4bc82fe$var$_tid(trans) + "-" + $42b3df7fa4bc82fe$var$_rid(trans);
};
/**
 * Prints UI-Router Transition trace information to the console.
 */ var $42b3df7fa4bc82fe$export$78e1bea9036f120f = /** @class */ function() {
    /** @internal */ function Trace() {
        /** @internal */ this._enabled = {};
        this.approximateDigests = 0;
    }
    /** @internal */ Trace.prototype._set = function(enabled, categories) {
        var _this = this;
        if (!categories.length) categories = Object.keys($42b3df7fa4bc82fe$export$3a8840c5b2ecf003).map(function(k) {
            return parseInt(k, 10);
        }).filter(function(k) {
            return !isNaN(k);
        }).map(function(key) {
            return $42b3df7fa4bc82fe$export$3a8840c5b2ecf003[key];
        });
        categories.map($42b3df7fa4bc82fe$var$normalizedCat).forEach(function(category) {
            return _this._enabled[category] = enabled;
        });
    };
    Trace.prototype.enable = function() {
        var categories = [];
        for(var _i = 0; _i < arguments.length; _i++)categories[_i] = arguments[_i];
        this._set(true, categories);
    };
    Trace.prototype.disable = function() {
        var categories = [];
        for(var _i = 0; _i < arguments.length; _i++)categories[_i] = arguments[_i];
        this._set(false, categories);
    };
    /**
     * Retrieves the enabled stateus of a [[Category]]
     *
     * ```js
     * trace.enabled("VIEWCONFIG"); // true or false
     * ```
     *
     * @returns boolean true if the category is enabled
     */ Trace.prototype.enabled = function(category) {
        return !!this._enabled[$42b3df7fa4bc82fe$var$normalizedCat(category)];
    };
    /** @internal called by ui-router code */ Trace.prototype.traceTransitionStart = function(trans) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.TRANSITION)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ": Started  -> " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(trans));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceTransitionIgnored = function(trans) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.TRANSITION)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ": Ignored  <> " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(trans));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceHookInvocation = function(step, trans, options) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.HOOK)) return;
        var event = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("traceData.hookType")(options) || "internal", context = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("traceData.context.state.name")(options) || (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("traceData.context")(options) || "unknown", name = (0, $48612b14b235e6fd$export$3f4acdc58db5898f)(step.registeredHook.callback);
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + (0, $48612b14b235e6fd$export$c9f461152c658a8b)(200, name));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceHookResult = function(hookResult, trans, transitionOptions) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.HOOK)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ":   <- Hook returned: " + (0, $48612b14b235e6fd$export$c9f461152c658a8b)(200, (0, $48612b14b235e6fd$export$fac44ee5b035f737)(hookResult)));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceResolvePath = function(path, when, trans) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.RESOLVE)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
    };
    /** @internal called by ui-router code */ Trace.prototype.traceResolvableResolved = function(resolvable, trans) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.RESOLVE)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + (0, $48612b14b235e6fd$export$c9f461152c658a8b)(200, (0, $48612b14b235e6fd$export$fac44ee5b035f737)(resolvable.data)));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceError = function(reason, trans) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.TRANSITION)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ": <- Rejected " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(trans) + ", reason: " + reason);
    };
    /** @internal called by ui-router code */ Trace.prototype.traceSuccess = function(finalState, trans) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.TRANSITION)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log($42b3df7fa4bc82fe$var$transLbl(trans) + ": <- Success  " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(trans) + ", final state: " + finalState.name);
    };
    /** @internal called by ui-router code */ Trace.prototype.traceUIViewEvent = function(event, viewData, extra) {
        if (extra === void 0) extra = "";
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.UIVIEW)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log("ui-view: " + (0, $48612b14b235e6fd$export$e3f9b6bf3780ff6e)(30, event) + " " + $42b3df7fa4bc82fe$var$uiViewString(viewData) + extra);
    };
    /** @internal called by ui-router code */ Trace.prototype.traceUIViewConfigUpdated = function(viewData, context) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.UIVIEW)) return;
        this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
    };
    /** @internal called by ui-router code */ Trace.prototype.traceUIViewFill = function(viewData, html) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.UIVIEW)) return;
        this.traceUIViewEvent("Fill", viewData, " with: " + (0, $48612b14b235e6fd$export$c9f461152c658a8b)(200, html));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceViewSync = function(pairs) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.VIEWCONFIG)) return;
        var uivheader = "uiview component fqn";
        var cfgheader = "view config state (view name)";
        var mapping = pairs.map(function(_a) {
            var _b;
            var uiView = _a.uiView, viewConfig = _a.viewConfig;
            var uiv = uiView && uiView.fqn;
            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
        }).sort(function(a, b) {
            return (a[uivheader] || "").localeCompare(b[uivheader] || "");
        });
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).table(mapping);
    };
    /** @internal called by ui-router code */ Trace.prototype.traceViewServiceEvent = function(event, viewConfig) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.VIEWCONFIG)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log("VIEWCONFIG: " + event + " " + $42b3df7fa4bc82fe$var$viewConfigString(viewConfig));
    };
    /** @internal called by ui-router code */ Trace.prototype.traceViewServiceUIViewEvent = function(event, viewData) {
        if (!this.enabled($42b3df7fa4bc82fe$export$3a8840c5b2ecf003.VIEWCONFIG)) return;
        (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).log("VIEWCONFIG: " + event + " " + $42b3df7fa4bc82fe$var$uiViewString(viewData));
    };
    return Trace;
}();
/**
 * The [[Trace]] singleton
 *
 * #### Example:
 * ```js
 * import {trace} from "@uirouter/core";
 * trace.enable(1, 5);
 * ```
 */ var $42b3df7fa4bc82fe$export$357889f174732d38 = new $42b3df7fa4bc82fe$export$78e1bea9036f120f();




var $77c96e7df6985fdd$exports = {};
$parcel$export($77c96e7df6985fdd$exports, "DefType", function () { return $e3df413894675dea$export$aae266d0aede27d7; });
$parcel$export($77c96e7df6985fdd$exports, "Param", function () { return $e3df413894675dea$export$1ca45c9a47aec42c; });
$parcel$export($77c96e7df6985fdd$exports, "ParamTypes", function () { return $8b9194c340caefea$export$cec5485a2fbca8a3; });
/**
 * This module contains code for State Parameters.
 *
 * See [[ParamDeclaration]]
 *
 * @packageDocumentation @preferred
 */ var $9b052499e5dc43ed$exports = {};








/**
 * An internal class which implements [[ParamTypeDefinition]].
 *
 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
 * When a param type definition is registered, an instance of this class is created internally.
 *
 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
 *
 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
 *
 * #### Example:
 * ```js
 * var paramTypeDef = {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 *
 * var paramType = new ParamType(paramTypeDef);
 * ```
 */ var $40be00334535c523$export$426dc07f493a4c47 = /** @class */ function() {
    /**
     * @param def  A configuration object which contains the custom type definition.  The object's
     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
     * @returns a new ParamType object
     */ function ParamType(def) {
        /** @inheritdoc */ this.pattern = /.*/;
        /** @inheritdoc */ this.inherit = true;
        (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this, def);
    }
    // consider these four methods to be "abstract methods" that should be overridden
    /** @inheritdoc */ ParamType.prototype.is = function(val, key) {
        return true;
    };
    /** @inheritdoc */ ParamType.prototype.encode = function(val, key) {
        return val;
    };
    /** @inheritdoc */ ParamType.prototype.decode = function(val, key) {
        return val;
    };
    /** @inheritdoc */ ParamType.prototype.equals = function(a, b) {
        // tslint:disable-next-line:triple-equals
        return a == b;
    };
    ParamType.prototype.$subPattern = function() {
        var sub = this.pattern.toString();
        return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function() {
        return "{ParamType:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */ ParamType.prototype.$normalize = function(val) {
        return this.is(val) ? val : this.decode(val);
    };
    /**
     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
     * e.g.:
     * - urlmatcher pattern "/path?{queryParam[]:int}"
     * - url: "/path?queryParam=1&queryParam=2
     * - $stateParams.queryParam will be [1, 2]
     * if `mode` is "auto", then
     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
     */ ParamType.prototype.$asArray = function(mode, isSearch) {
        if (!mode) return this;
        if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
        return new $40be00334535c523$var$ArrayType(this, mode);
    };
    return ParamType;
}();
/** Wraps up a `ParamType` object to handle array values. */ function $40be00334535c523$var$ArrayType(type, mode) {
    var _this = this;
    // Wrap non-array value as array
    function arrayWrap(val) {
        return (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(val) ? val : (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(val) ? [
            val
        ] : [];
    }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
        switch(val.length){
            case 0:
                return undefined;
            case 1:
                return mode === "auto" ? val[0] : val;
            default:
                return val;
        }
    }
    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
        return function handleArray(val) {
            if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(val) && val.length === 0) return val;
            var arr = arrayWrap(val);
            var result = (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(arr, callback);
            return allTruthyMode === true ? (0, $abcc081e7f2a61c5$export$3dea766d36a8935f)(result, function(x) {
                return !x;
            }).length === 0 : arrayUnwrap(result);
        };
    }
    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
        return function handleArray(val1, val2) {
            var left = arrayWrap(val1), right = arrayWrap(val2);
            if (left.length !== right.length) return false;
            for(var i = 0; i < left.length; i++){
                if (!callback(left[i], right[i])) return false;
            }
            return true;
        };
    }
    [
        "encode",
        "decode",
        "equals",
        "$normalize"
    ].forEach(function(name) {
        var paramTypeFn = type[name].bind(type);
        var wrapperFn = name === "equals" ? arrayEqualsHandler : arrayHandler;
        _this[name] = wrapperFn(paramTypeFn);
    });
    (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this, {
        dynamic: type.dynamic,
        name: type.name,
        pattern: type.pattern,
        inherit: type.inherit,
        raw: type.raw,
        is: arrayHandler(type.is.bind(type), true),
        $arrayMode: mode
    });
}


var $e3df413894675dea$var$hasOwn = Object.prototype.hasOwnProperty;
var $e3df413894675dea$var$isShorthand = function(cfg) {
    return [
        "value",
        "type",
        "squash",
        "array",
        "dynamic"
    ].filter($e3df413894675dea$var$hasOwn.bind(cfg || {})).length === 0;
};
var $e3df413894675dea$export$aae266d0aede27d7;
(function(DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
})($e3df413894675dea$export$aae266d0aede27d7 || ($e3df413894675dea$export$aae266d0aede27d7 = {}));
function $e3df413894675dea$var$getParamDeclaration(paramName, location, state) {
    var noReloadOnSearch = state.reloadOnSearch === false && location === $e3df413894675dea$export$aae266d0aede27d7.SEARCH || undefined;
    var dynamic = (0, $abcc081e7f2a61c5$export$71aa6c912b956294)([
        state.dynamic,
        noReloadOnSearch
    ], (0, $c4ca6daaad7210ad$export$4e62c701997796c1));
    var defaultConfig = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(dynamic) ? {
        dynamic: dynamic
    } : {};
    var paramConfig = $e3df413894675dea$var$unwrapShorthand(state && state.params && state.params[paramName]);
    return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(defaultConfig, paramConfig);
}
function $e3df413894675dea$var$unwrapShorthand(cfg) {
    cfg = $e3df413894675dea$var$isShorthand(cfg) ? {
        value: cfg
    } : cfg;
    getStaticDefaultValue["__cacheable"] = true;
    function getStaticDefaultValue() {
        return cfg.value;
    }
    var $$fn = (0, $c4ca6daaad7210ad$export$b0148ad22588aea3)(cfg.value) ? cfg.value : getStaticDefaultValue;
    return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(cfg, {
        $$fn: $$fn
    });
}
function $e3df413894675dea$var$getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== "string") throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === "string" && paramTypes.type(cfg.type)) return paramTypes.type(cfg.type);
    if (urlType) return urlType;
    if (!cfg.type) {
        var type = location === $e3df413894675dea$export$aae266d0aede27d7.CONFIG ? "any" : location === $e3df413894675dea$export$aae266d0aede27d7.PATH ? "path" : location === $e3df413894675dea$export$aae266d0aede27d7.SEARCH ? "query" : "string";
        return paramTypes.type(type);
    }
    return cfg.type instanceof (0, $40be00334535c523$export$426dc07f493a4c47) ? cfg.type : paramTypes.type(cfg.type);
}
/** returns false, true, or the squash value to indicate the "default parameter url squash policy". */ function $e3df413894675dea$var$getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false) return false;
    if (!(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(squash) || squash == null) return defaultPolicy;
    if (squash === true || (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(squash)) return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
}
function $e3df413894675dea$var$getReplace(config, arrayMode, isOptional, squash) {
    var defaultPolicy = [
        {
            from: "",
            to: isOptional || arrayMode ? undefined : ""
        },
        {
            from: null,
            to: isOptional || arrayMode ? undefined : ""
        }
    ];
    var replace = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(config.replace) ? config.replace : [];
    if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(squash)) replace.push({
        from: squash,
        to: undefined
    });
    var configuredKeys = (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(replace, (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("from"));
    return (0, $abcc081e7f2a61c5$export$3dea766d36a8935f)(defaultPolicy, function(item) {
        return configuredKeys.indexOf(item.from) === -1;
    }).concat(replace);
}
var $e3df413894675dea$export$1ca45c9a47aec42c = /** @class */ function() {
    function Param(id, type, location, urlConfig, state) {
        var config = $e3df413894675dea$var$getParamDeclaration(id, location, state);
        type = $e3df413894675dea$var$getType(config, type, location, id, urlConfig.paramTypes);
        var arrayMode = getArrayMode();
        type = arrayMode ? type.$asArray(arrayMode, location === $e3df413894675dea$export$aae266d0aede27d7.SEARCH) : type;
        var isOptional = config.value !== undefined || location === $e3df413894675dea$export$aae266d0aede27d7.SEARCH;
        var dynamic = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.dynamic) ? !!config.dynamic : !!type.dynamic;
        var raw = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.raw) ? !!config.raw : !!type.raw;
        var squash = $e3df413894675dea$var$getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
        var replace = $e3df413894675dea$var$getReplace(config, arrayMode, isOptional, squash);
        var inherit = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.inherit) ? !!config.inherit : !!type.inherit;
        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
        function getArrayMode() {
            var arrayDefaults = {
                array: location === $e3df413894675dea$export$aae266d0aede27d7.SEARCH ? "auto" : false
            };
            var arrayParamNomenclature = id.match(/\[\]$/) ? {
                array: true
            } : {};
            return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(arrayDefaults, arrayParamNomenclature, config).array;
        }
        (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this, {
            id: id,
            type: type,
            location: location,
            isOptional: isOptional,
            dynamic: dynamic,
            raw: raw,
            squash: squash,
            replace: replace,
            inherit: inherit,
            array: arrayMode,
            config: config
        });
    }
    Param.values = function(params, values) {
        if (values === void 0) values = {};
        var paramValues = {};
        for(var _i = 0, params_1 = params; _i < params_1.length; _i++){
            var param = params_1[_i];
            paramValues[param.id] = param.value(values[param.id]);
        }
        return paramValues;
    };
    /**
     * Finds [[Param]] objects which have different param values
     *
     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
     *
     * @param params: The list of Param objects to filter
     * @param values1: The first set of parameter values
     * @param values2: the second set of parameter values
     *
     * @returns any Param objects whose values were different between values1 and values2
     */ Param.changed = function(params, values1, values2) {
        if (values1 === void 0) values1 = {};
        if (values2 === void 0) values2 = {};
        return params.filter(function(param) {
            return !param.type.equals(values1[param.id], values2[param.id]);
        });
    };
    /**
     * Checks if two param value objects are equal (for a set of [[Param]] objects)
     *
     * @param params The list of [[Param]] objects to check
     * @param values1 The first set of param values
     * @param values2 The second set of param values
     *
     * @returns true if the param values in values1 and values2 are equal
     */ Param.equals = function(params, values1, values2) {
        if (values1 === void 0) values1 = {};
        if (values2 === void 0) values2 = {};
        return Param.changed(params, values1, values2).length === 0;
    };
    /** Returns true if a the parameter values are valid, according to the Param definitions */ Param.validates = function(params, values) {
        if (values === void 0) values = {};
        return params.map(function(param) {
            return param.validates(values[param.id]);
        }).reduce((0, $abcc081e7f2a61c5$export$d1a75794f55e0c66), true);
    };
    Param.prototype.isDefaultValue = function(value) {
        return this.isOptional && this.type.equals(this.value(), value);
    };
    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */ Param.prototype.value = function(value) {
        var _this = this;
        /**
         * [Internal] Get the default value of a parameter, which may be an injectable function.
         */ var getDefaultValue = function() {
            if (_this._defaultValueCache) return _this._defaultValueCache.defaultValue;
            if (!(0, $e592c26318c32a9d$export$bce7a36871692cab).$injector) throw new Error("Injectable functions cannot be called at configuration time");
            var defaultValue = (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.invoke(_this.config.$$fn);
            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
            if (_this.config.$$fn["__cacheable"]) _this._defaultValueCache = {
                defaultValue: defaultValue
            };
            return defaultValue;
        };
        var replaceSpecialValues = function(val) {
            for(var _i = 0, _a = _this.replace; _i < _a.length; _i++){
                var tuple = _a[_i];
                if (tuple.from === val) return tuple.to;
            }
            return val;
        };
        value = replaceSpecialValues(value);
        return (0, $c4ca6daaad7210ad$export$fce6876652108ab)(value) ? getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function() {
        return this.location === $e3df413894675dea$export$aae266d0aede27d7.SEARCH;
    };
    Param.prototype.validates = function(value) {
        // There was no parameter value, but the param is optional
        if (((0, $c4ca6daaad7210ad$export$fce6876652108ab)(value) || value === null) && this.isOptional) return true;
        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
        var normalized = this.type.$normalize(value);
        if (!this.type.is(normalized)) return false;
        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
        var encoded = this.type.encode(normalized);
        return !((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function() {
        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    return Param;
}();







/**
 * A registry for parameter types.
 *
 * This registry manages the built-in (and custom) parameter types.
 *
 * The built-in parameter types are:
 *
 * - [[string]]
 * - [[path]]
 * - [[query]]
 * - [[hash]]
 * - [[int]]
 * - [[bool]]
 * - [[date]]
 * - [[json]]
 * - [[any]]
 *
 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
 *
 * ```js
 * router.urlService.config.type(customType)
 * ```
 */ var $8b9194c340caefea$export$cec5485a2fbca8a3 = /** @class */ function() {
    function ParamTypes() {
        this.enqueue = true;
        this.typeQueue = [];
        this.defaultTypes = (0, $abcc081e7f2a61c5$export$357523c63a2253b9)(ParamTypes.prototype, [
            "hash",
            "string",
            "query",
            "path",
            "int",
            "bool",
            "date",
            "json",
            "any"
        ]);
        // Register default types. Store them in the prototype of this.types.
        var makeType = function(definition, name) {
            return new (0, $40be00334535c523$export$426dc07f493a4c47)((0, $abcc081e7f2a61c5$export$8b58be045bf06082)({
                name: name
            }, definition));
        };
        this.types = (0, $abcc081e7f2a61c5$export$4dc9a6b0ae3dfd2a)((0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(this.defaultTypes, makeType), {});
    }
    ParamTypes.prototype.dispose = function() {
        this.types = {};
    };
    /**
     * Registers a parameter type
     *
     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
     */ ParamTypes.prototype.type = function(name, definition, definitionFn) {
        if (!(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(definition)) return this.types[name];
        if (this.types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
        this.types[name] = new (0, $40be00334535c523$export$426dc07f493a4c47)((0, $abcc081e7f2a61c5$export$8b58be045bf06082)({
            name: name
        }, definition));
        if (definitionFn) {
            this.typeQueue.push({
                name: name,
                def: definitionFn
            });
            if (!this.enqueue) this._flushTypeQueue();
        }
        return this;
    };
    ParamTypes.prototype._flushTypeQueue = function() {
        while(this.typeQueue.length){
            var type = this.typeQueue.shift();
            if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
            (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this.types[type.name], (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.invoke(type.def));
        }
    };
    return ParamTypes;
}();
function $8b9194c340caefea$var$initDefaultTypes() {
    var makeDefaultType = function(def) {
        var valToString = function(val) {
            return val != null ? val.toString() : val;
        };
        var defaultTypeBase = {
            encode: valToString,
            decode: valToString,
            is: (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)(String),
            pattern: /.*/,
            // tslint:disable-next-line:triple-equals
            equals: function(a, b) {
                return a == b;
            }
        };
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, defaultTypeBase, def);
    };
    // Default Parameter Type Definitions
    (0, $abcc081e7f2a61c5$export$8b58be045bf06082)($8b9194c340caefea$export$cec5485a2fbca8a3.prototype, {
        string: makeDefaultType({}),
        path: makeDefaultType({
            pattern: /[^/]*/
        }),
        query: makeDefaultType({}),
        hash: makeDefaultType({
            inherit: false
        }),
        int: makeDefaultType({
            decode: function(val) {
                return parseInt(val, 10);
            },
            is: function(val) {
                return !(0, $c4ca6daaad7210ad$export$bedb7023a7733221)(val) && this.decode(val.toString()) === val;
            },
            pattern: /-?\d+/
        }),
        bool: makeDefaultType({
            encode: function(val) {
                return val && 1 || 0;
            },
            decode: function(val) {
                return parseInt(val, 10) !== 0;
            },
            is: (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)(Boolean),
            pattern: /0|1/
        }),
        date: makeDefaultType({
            encode: function(val) {
                return !this.is(val) ? undefined : [
                    val.getFullYear(),
                    ("0" + (val.getMonth() + 1)).slice(-2),
                    ("0" + val.getDate()).slice(-2)
                ].join("-");
            },
            decode: function(val) {
                if (this.is(val)) return val;
                var match = this.capture.exec(val);
                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
            },
            is: function(val) {
                return val instanceof Date && !isNaN(val.valueOf());
            },
            equals: function(l, r) {
                return [
                    "getFullYear",
                    "getMonth",
                    "getDate"
                ].reduce(function(acc, fn) {
                    return acc && l[fn]() === r[fn]();
                }, true);
            },
            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
        }),
        json: makeDefaultType({
            encode: (0, $abcc081e7f2a61c5$export$d5b7a8bf56ee1fe2),
            decode: (0, $abcc081e7f2a61c5$export$7ae2d2a8b28a8cb8),
            is: (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)(Object),
            equals: (0, $abcc081e7f2a61c5$export$e9bab7fafb253603),
            pattern: /[^/]*/
        }),
        // does not encode/decode
        any: makeDefaultType({
            encode: (0, $abcc081e7f2a61c5$export$f0954fd7d5368655),
            decode: (0, $abcc081e7f2a61c5$export$f0954fd7d5368655),
            is: function() {
                return true;
            },
            equals: (0, $abcc081e7f2a61c5$export$e9bab7fafb253603)
        })
    });
}
$8b9194c340caefea$var$initDefaultTypes();



var $faa504ce7583dd9b$export$2efb2ee9027f89bc = /** @class */ function() {
    function StateParams(params) {
        if (params === void 0) params = {};
        (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this, params);
    }
    /**
     * Merges a set of parameters with all parameters inherited between the common parents of the
     * current state and a given destination state.
     *
     * @param {Object} newParams The set of parameters which will be composited with inherited params.
     * @param {Object} $current Internal definition of object representing the current state.
     * @param {Object} $to Internal definition of object representing state to transition to.
     */ StateParams.prototype.$inherit = function(newParams, $current, $to) {
        var parentParams;
        var parents = (0, $abcc081e7f2a61c5$export$dfc9e7b996f62d3d)($current, $to), inherited = {}, inheritList = [];
        for(var i in parents){
            if (!parents[i] || !parents[i].params) continue;
            parentParams = Object.keys(parents[i].params);
            if (!parentParams.length) continue;
            for(var j in parentParams){
                if (inheritList.indexOf(parentParams[j]) >= 0) continue;
                inheritList.push(parentParams[j]);
                inherited[parentParams[j]] = this[parentParams[j]];
            }
        }
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, inherited, newParams);
    };
    return StateParams;
}();



$parcel$exportWildcard($77c96e7df6985fdd$exports, $9b052499e5dc43ed$exports);





/**
 * A node in a [[TreeChanges]] path
 *
 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
 * Each PathNode corresponds to a state being entered, exited, or retained.
 * The stateful information includes parameter values and resolve data.
 */ var $5393b4248257e3d9$export$abca0bc337352069 = /** @class */ function() {
    function PathNode(stateOrNode) {
        if (stateOrNode instanceof PathNode) {
            var node = stateOrNode;
            this.state = node.state;
            this.paramSchema = node.paramSchema.slice();
            this.paramValues = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, node.paramValues);
            this.resolvables = node.resolvables.slice();
            this.views = node.views && node.views.slice();
        } else {
            var state = stateOrNode;
            this.state = state;
            this.paramSchema = state.parameters({
                inherit: false
            });
            this.paramValues = {};
            this.resolvables = state.resolvables.map(function(res) {
                return res.clone();
            });
        }
    }
    PathNode.prototype.clone = function() {
        return new PathNode(this);
    };
    /** Sets [[paramValues]] for the node, from the values of an object hash */ PathNode.prototype.applyRawParams = function(params) {
        var getParamVal = function(paramDef) {
            return [
                paramDef.id,
                paramDef.value(params[paramDef.id])
            ];
        };
        this.paramValues = this.paramSchema.reduce(function(memo, pDef) {
            return (0, $abcc081e7f2a61c5$export$448afb43435ef71e)(memo, getParamVal(pDef));
        }, {});
        return this;
    };
    /** Gets a specific [[Param]] metadata that belongs to the node */ PathNode.prototype.parameter = function(name) {
        return (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(this.paramSchema, (0, $b94057b5b409b0b1$export$78c65ad39408e96e)("id", name));
    };
    /**
     * @returns true if the state and parameter values for another PathNode are
     * equal to the state and param values for this PathNode
     */ PathNode.prototype.equals = function(node, paramsFn) {
        var diff = this.diff(node, paramsFn);
        return diff && diff.length === 0;
    };
    /**
     * Finds Params with different parameter values on another PathNode.
     *
     * Given another node (of the same state), finds the parameter values which differ.
     * Returns the [[Param]] (schema objects) whose parameter values differ.
     *
     * Given another node for a different state, returns `false`
     *
     * @param node The node to compare to
     * @param paramsFn A function that returns which parameters should be compared.
     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
     */ PathNode.prototype.diff = function(node, paramsFn) {
        if (this.state !== node.state) return false;
        var params = paramsFn ? paramsFn(this) : this.paramSchema;
        return (0, $e3df413894675dea$export$1ca45c9a47aec42c).changed(params, this.paramValues, node.paramValues);
    };
    /**
     * Returns a clone of the PathNode
     * @deprecated use instance method `node.clone()`
     */ PathNode.clone = function(node) {
        return node.clone();
    };
    return PathNode;
}();







/**
 * Encapsulate the target (destination) state/params/options of a [[Transition]].
 *
 * This class is frequently used to redirect a transition to a new destination.
 *
 * See:
 *
 * - [[HookResult]]
 * - [[TransitionHookFn]]
 * - [[TransitionService.onStart]]
 *
 * To create a `TargetState`, use [[StateService.target]].
 *
 * ---
 *
 * This class wraps:
 *
 * 1) an identifier for a state
 * 2) a set of parameters
 * 3) and transition options
 * 4) the registered state object (the [[StateDeclaration]])
 *
 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
 * The `TargetState` class normalizes those options.
 *
 * A `TargetState` may be valid (the state being targeted exists in the registry)
 * or invalid (the state being targeted is not registered).
 */ var $f6f45358c1dc8ea5$export$b47ab23ce83f86ac = /** @class */ function() {
    /**
     * The TargetState constructor
     *
     * Note: Do not construct a `TargetState` manually.
     * To create a `TargetState`, use the [[StateService.target]] factory method.
     *
     * @param _stateRegistry The StateRegistry to use to look up the _definition
     * @param _identifier An identifier for a state.
     *    Either a fully-qualified state name, or the object used to define the state.
     * @param _params Parameters for the target state
     * @param _options Transition options.
     *
     * @internal
     */ function TargetState(_stateRegistry, _identifier, _params, _options) {
        this._stateRegistry = _stateRegistry;
        this._identifier = _identifier;
        this._identifier = _identifier;
        this._params = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, _params || {});
        this._options = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, _options || {});
        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
    }
    /** The name of the state this object targets */ TargetState.prototype.name = function() {
        return this._definition && this._definition.name || this._identifier;
    };
    /** The identifier used when creating this TargetState */ TargetState.prototype.identifier = function() {
        return this._identifier;
    };
    /** The target parameter values */ TargetState.prototype.params = function() {
        return this._params;
    };
    /** The internal state object (if it was found) */ TargetState.prototype.$state = function() {
        return this._definition;
    };
    /** The internal state declaration (if it was found) */ TargetState.prototype.state = function() {
        return this._definition && this._definition.self;
    };
    /** The target options */ TargetState.prototype.options = function() {
        return this._options;
    };
    /** True if the target state was found */ TargetState.prototype.exists = function() {
        return !!(this._definition && this._definition.self);
    };
    /** True if the object is valid */ TargetState.prototype.valid = function() {
        return !this.error();
    };
    /** If the object is invalid, returns the reason why */ TargetState.prototype.error = function() {
        var base = this.options().relative;
        if (!this._definition && !!base) {
            var stateName = base.name ? base.name : base;
            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
        }
        if (!this._definition) return "No such state '" + this.name() + "'";
        if (!this._definition.self) return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function() {
        return "'" + this.name() + "'" + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(this.params());
    };
    /**
     * Returns a copy of this TargetState which targets a different state.
     * The new TargetState has the same parameter values and transition options.
     *
     * @param state The new state that should be targeted
     */ TargetState.prototype.withState = function(state) {
        return new TargetState(this._stateRegistry, state, this._params, this._options);
    };
    /**
     * Returns a copy of this TargetState, using the specified parameter values.
     *
     * @param params the new parameter values to use
     * @param replace When false (default) the new parameter values will be merged with the current values.
     *                When true the parameter values will be used instead of the current values.
     */ TargetState.prototype.withParams = function(params, replace) {
        if (replace === void 0) replace = false;
        var newParams = replace ? params : (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, this._params, params);
        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
    };
    /**
     * Returns a copy of this TargetState, using the specified Transition Options.
     *
     * @param options the new options to use
     * @param replace When false (default) the new options will be merged with the current options.
     *                When true the options will be used instead of the current options.
     */ TargetState.prototype.withOptions = function(options, replace) {
        if (replace === void 0) replace = false;
        var newOpts = replace ? options : (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, this._options, options);
        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
    };
    /** Returns true if the object has a state property that might be a state or state name */ TargetState.isDef = function(obj) {
        return obj && obj.state && ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(obj.state) || (0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(obj.state) && (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(obj.state.name));
    };
    return TargetState;
}();



/**
 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
 */ var $50d81baac9264b80$export$39d3fc700b385dc4 = /** @class */ function() {
    function PathUtils() {}
    /** Given a PathNode[], create an TargetState */ PathUtils.makeTargetState = function(registry, path) {
        var state = (0, $abcc081e7f2a61c5$export$c01875f616615628)(path).state;
        return new (0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac)(registry, state, path.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("paramValues")).reduce((0, $abcc081e7f2a61c5$export$625f91792a536171), {}), {});
    };
    PathUtils.buildPath = function(targetState) {
        var toParams = targetState.params();
        return targetState.$state().path.map(function(state) {
            return new (0, $5393b4248257e3d9$export$abca0bc337352069)(state).applyRawParams(toParams);
        });
    };
    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */ PathUtils.buildToPath = function(fromPath, targetState) {
        var toPath = PathUtils.buildPath(targetState);
        if (targetState.options().inherit) return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
        return toPath;
    };
    /**
     * Creates ViewConfig objects and adds to nodes.
     *
     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
     */ PathUtils.applyViewConfigs = function($view, path, states) {
        // Only apply the viewConfigs to the nodes for the given states
        path.filter(function(node) {
            return (0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(states, node.state);
        }).forEach(function(node) {
            var viewDecls = (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(node.state.views || {});
            var subPath = PathUtils.subPath(path, function(n) {
                return n === node;
            });
            var viewConfigs = viewDecls.map(function(view) {
                return $view.createViewConfig(subPath, view);
            });
            node.views = viewConfigs.reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
        });
    };
    /**
     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
     *
     * For a parameter in a node to be inherited from the from path:
     * - The toPath's node must have a matching node in the fromPath (by state).
     * - The parameter name must not be found in the toKeys parameter array.
     *
     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
     * it is not inherited from the fromPath.
     */ PathUtils.inheritParams = function(fromPath, toPath, toKeys) {
        if (toKeys === void 0) toKeys = [];
        function nodeParamVals(path, state) {
            var node = (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(path, (0, $b94057b5b409b0b1$export$78c65ad39408e96e)("state", state));
            return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, node && node.paramValues);
        }
        var noInherit = fromPath.map(function(node) {
            return node.paramSchema;
        }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).filter(function(param) {
            return !param.inherit;
        }).map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("id"));
        /**
         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
         */ function makeInheritedParamsNode(toNode) {
            // All param values for the node (may include default key/vals, when key was not found in toParams)
            var toParamVals = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, toNode && toNode.paramValues);
            // limited to only those keys found in toParams
            var incomingParamVals = (0, $abcc081e7f2a61c5$export$357523c63a2253b9)(toParamVals, toKeys);
            toParamVals = (0, $abcc081e7f2a61c5$export$30a06c8d3562193f)(toParamVals, toKeys);
            var fromParamVals = (0, $abcc081e7f2a61c5$export$30a06c8d3562193f)(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
            var ownParamVals = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(toParamVals, fromParamVals, incomingParamVals);
            return new (0, $5393b4248257e3d9$export$abca0bc337352069)(toNode.state).applyRawParams(ownParamVals);
        }
        // The param keys specified by the incoming toParams
        return toPath.map(makeInheritedParamsNode);
    };
    /**
     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
     */ PathUtils.treeChanges = function(fromPath, toPath, reloadState) {
        var max = Math.min(fromPath.length, toPath.length);
        var keep = 0;
        var nodesMatch = function(node1, node2) {
            return node1.equals(node2, PathUtils.nonDynamicParams);
        };
        while(keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep]))keep++;
        /** Given a retained node, return a new node which uses the to node's param values */ function applyToParams(retainedNode, idx) {
            var cloned = retainedNode.clone();
            cloned.paramValues = toPath[idx].paramValues;
            return cloned;
        }
        var from, retained, exiting, entering, to;
        from = fromPath;
        retained = from.slice(0, keep);
        exiting = from.slice(keep);
        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
        var retainedWithToParams = retained.map(applyToParams);
        entering = toPath.slice(keep);
        to = retainedWithToParams.concat(entering);
        return {
            from: from,
            to: to,
            retained: retained,
            retainedWithToParams: retainedWithToParams,
            exiting: exiting,
            entering: entering
        };
    };
    /**
     * Returns a new path which is: the subpath of the first path which matches the second path.
     *
     * The new path starts from root and contains any nodes that match the nodes in the second path.
     * It stops before the first non-matching node.
     *
     * Nodes are compared using their state property and their parameter values.
     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
     *
     * @param pathA the first path
     * @param pathB the second path
     * @param paramsFn a function which returns the parameters to consider when comparing
     *
     * @returns an array of PathNodes from the first path which match the nodes in the second path
     */ PathUtils.matching = function(pathA, pathB, paramsFn) {
        var done = false;
        var tuples = (0, $abcc081e7f2a61c5$export$ade9293c41c5aa01)(pathA, pathB);
        return tuples.reduce(function(matching, _a) {
            var nodeA = _a[0], nodeB = _a[1];
            done = done || !nodeA.equals(nodeB, paramsFn);
            return done ? matching : matching.concat(nodeA);
        }, []);
    };
    /**
     * Returns true if two paths are identical.
     *
     * @param pathA
     * @param pathB
     * @param paramsFn a function which returns the parameters to consider when comparing
     * @returns true if the the states and parameter values for both paths are identical
     */ PathUtils.equals = function(pathA, pathB, paramsFn) {
        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
    };
    /**
     * Return a subpath of a path, which stops at the first matching node
     *
     * Given an array of nodes, returns a subset of the array starting from the first node,
     * stopping when the first node matches the predicate.
     *
     * @param path a path of [[PathNode]]s
     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
     * @returns a subpath up to the matching node, or undefined if no match is found
     */ PathUtils.subPath = function(path, predicate) {
        var node = (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(path, predicate);
        var elementIdx = path.indexOf(node);
        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    PathUtils.nonDynamicParams = function(node) {
        return node.state.parameters({
            inherit: false
        }).filter(function(param) {
            return !param.dynamic;
        });
    };
    /** Gets the raw parameter values from a path */ PathUtils.paramValues = function(path) {
        return path.reduce(function(acc, node) {
            return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(acc, node.paramValues);
        }, {});
    };
    return PathUtils;
}();




var $243e00e1bb8fc5bc$export$225b64904616bbbb = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT"
    }
};







var $a8c7bb6ec3d477e6$export$a624f71ec41ec2e8 = {
    when: "LAZY",
    async: "WAIT"
};
/**
 * The basic building block for the resolve system.
 *
 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
 * and the unwrapped-when-complete (.data) result of the resolveFn.
 *
 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
 * resolveFn) and returns the resulting promise.
 *
 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
 * parameter to those fns.
 */ var $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e = /** @class */ function() {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
        this.resolved = false;
        this.promise = undefined;
        if (arg1 instanceof Resolvable) (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this, arg1);
        else if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(resolveFn)) {
            if ((0, $c4ca6daaad7210ad$export$bedb7023a7733221)(arg1)) throw new Error("new Resolvable(): token argument is required");
            if (!(0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(resolveFn)) throw new Error("new Resolvable(): resolveFn argument must be a function");
            this.token = arg1;
            this.policy = policy;
            this.resolveFn = resolveFn;
            this.deps = deps || [];
            this.data = data;
            this.resolved = data !== undefined;
            this.promise = this.resolved ? (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(this.data) : undefined;
        } else if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(arg1) && arg1.token && (arg1.hasOwnProperty("resolveFn") || arg1.hasOwnProperty("data"))) {
            var literal = arg1;
            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
        }
    }
    Resolvable.prototype.getPolicy = function(state) {
        var thisPolicy = this.policy || {};
        var statePolicy = state && state.resolvePolicy || {};
        return {
            when: thisPolicy.when || statePolicy.when || $a8c7bb6ec3d477e6$export$a624f71ec41ec2e8.when,
            async: thisPolicy.async || statePolicy.async || $a8c7bb6ec3d477e6$export$a624f71ec41ec2e8.async
        };
    };
    /**
     * Asynchronously resolve this Resolvable's data
     *
     * Given a ResolveContext that this Resolvable is found in:
     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
     * and update the Resolvable's state
     */ Resolvable.prototype.resolve = function(resolveContext, trans) {
        var _this = this;
        var $q = (0, $e592c26318c32a9d$export$bce7a36871692cab).$q;
        // Gets all dependencies from ResolveContext and wait for them to be resolved
        var getResolvableDependencies = function() {
            return $q.all(resolveContext.getDependencies(_this).map(function(resolvable) {
                return resolvable.get(resolveContext, trans);
            }));
        };
        // Invokes the resolve function passing the resolved dependencies as arguments
        var invokeResolveFn = function(resolvedDeps) {
            return _this.resolveFn.apply(null, resolvedDeps);
        };
        var node = resolveContext.findNode(this);
        var state = node && node.state;
        var asyncPolicy = this.getPolicy(state).async;
        var customAsyncPolicy = (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(asyncPolicy) ? asyncPolicy : (0, $abcc081e7f2a61c5$export$f0954fd7d5368655);
        // After the final value has been resolved, update the state of the Resolvable
        var applyResolvedValue = function(resolvedValue) {
            _this.data = resolvedValue;
            _this.resolved = true;
            _this.resolveFn = null;
            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceResolvableResolved(_this, trans);
            return _this.data;
        };
        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
        return this.promise = $q.when().then(getResolvableDependencies).then(invokeResolveFn).then(customAsyncPolicy).then(applyResolvedValue);
    };
    /**
     * Gets a promise for this Resolvable's data.
     *
     * Fetches the data and returns a promise.
     * Returns the existing promise if it has already been fetched once.
     */ Resolvable.prototype.get = function(resolveContext, trans) {
        return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function() {
        return "Resolvable(token: " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(this.token) + ", requires: [" + this.deps.map((0, $48612b14b235e6fd$export$fac44ee5b035f737)) + "])";
    };
    Resolvable.prototype.clone = function() {
        return new Resolvable(this);
    };
    Resolvable.fromData = function(token, data) {
        return new Resolvable(token, function() {
            return data;
        }, null, null, data);
    };
    return Resolvable;
}();











var $3996106c44ea4b60$var$whens = (0, $243e00e1bb8fc5bc$export$225b64904616bbbb).when;
var $3996106c44ea4b60$var$ALL_WHENS = [
    $3996106c44ea4b60$var$whens.EAGER,
    $3996106c44ea4b60$var$whens.LAZY
];
var $3996106c44ea4b60$var$EAGER_WHENS = [
    $3996106c44ea4b60$var$whens.EAGER
];
var $3996106c44ea4b60$export$de56f1697c5b03a2 = "Native Injector";
/**
 * Encapsulates Dependency Injection for a path of nodes
 *
 * UI-Router states are organized as a tree.
 * A nested state has a path of ancestors to the root of the tree.
 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
 *
 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
 */ var $3996106c44ea4b60$export$fa71f212be031d8f = /** @class */ function() {
    function ResolveContext(_path) {
        this._path = _path;
    }
    /** Gets all the tokens found in the resolve context, de-duplicated */ ResolveContext.prototype.getTokens = function() {
        return this._path.reduce(function(acc, node) {
            return acc.concat(node.resolvables.map(function(r) {
                return r.token;
            }));
        }, []).reduce((0, $abcc081e7f2a61c5$export$530e60648218df63), []);
    };
    /**
     * Gets the Resolvable that matches the token
     *
     * Gets the last Resolvable that matches the token in this context, or undefined.
     * Throws an error if it doesn't exist in the ResolveContext
     */ ResolveContext.prototype.getResolvable = function(token) {
        var matching = this._path.map(function(node) {
            return node.resolvables;
        }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).filter(function(r) {
            return r.token === token;
        });
        return (0, $abcc081e7f2a61c5$export$c01875f616615628)(matching);
    };
    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */ ResolveContext.prototype.getPolicy = function(resolvable) {
        var node = this.findNode(resolvable);
        return resolvable.getPolicy(node.state);
    };
    /**
     * Returns a ResolveContext that includes a portion of this one
     *
     * Given a state, this method creates a new ResolveContext from this one.
     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
     *
     * #### Why
     *
     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
     * This method is used to create a narrower context when injecting ancestor nodes.
     *
     * @example
     * `let ABCD = new ResolveContext([A, B, C, D]);`
     *
     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
     * However, `B` should only be able to access resolvables from `A`, `B`.
     *
     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
     * `let AB = ABCD.subcontext(a)`
     */ ResolveContext.prototype.subContext = function(state) {
        return new ResolveContext((0, $50d81baac9264b80$export$39d3fc700b385dc4).subPath(this._path, function(node) {
            return node.state === state;
        }));
    };
    /**
     * Adds Resolvables to the node that matches the state
     *
     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
     * The resolvable is added to the node matching the `state` parameter.
     *
     * These new resolvables are not automatically fetched.
     * The calling code should either fetch them, fetch something that depends on them,
     * or rely on [[resolvePath]] being called when some state is being entered.
     *
     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
     *
     * @param newResolvables the new Resolvables
     * @param state Used to find the node to put the resolvable on
     */ ResolveContext.prototype.addResolvables = function(newResolvables, state) {
        var node = (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(this._path, (0, $b94057b5b409b0b1$export$78c65ad39408e96e)("state", state));
        var keys = newResolvables.map(function(r) {
            return r.token;
        });
        node.resolvables = node.resolvables.filter(function(r) {
            return keys.indexOf(r.token) === -1;
        }).concat(newResolvables);
    };
    /**
     * Returns a promise for an array of resolved path Element promises
     *
     * @param when
     * @param trans
     * @returns {Promise<any>|any}
     */ ResolveContext.prototype.resolvePath = function(when, trans) {
        var _this = this;
        if (when === void 0) when = "LAZY";
        // This option determines which 'when' policy Resolvables we are about to fetch.
        var whenOption = (0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)($3996106c44ea4b60$var$ALL_WHENS, when) ? when : "LAZY";
        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
        var matchedWhens = whenOption === (0, $243e00e1bb8fc5bc$export$225b64904616bbbb).when.EAGER ? $3996106c44ea4b60$var$EAGER_WHENS : $3996106c44ea4b60$var$ALL_WHENS;
        // get the subpath to the state argument, if provided
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceResolvePath(this._path, when, trans);
        var matchesPolicy = function(acceptedVals, whenOrAsync) {
            return function(resolvable) {
                return (0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
            };
        };
        // Trigger all the (matching) Resolvables in the path
        // Reduce all the "WAIT" Resolvables into an array
        var promises = this._path.reduce(function(acc, node) {
            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, "when"));
            var nowait = nodeResolvables.filter(matchesPolicy([
                "NOWAIT"
            ], "async"));
            var wait = nodeResolvables.filter((0, $b94057b5b409b0b1$export$6003a5f097c73977)(matchesPolicy([
                "NOWAIT"
            ], "async")));
            // For the matching Resolvables, start their async fetch process.
            var subContext = _this.subContext(node.state);
            var getResult = function(r) {
                return r.get(subContext, trans)// Return a tuple that includes the Resolvable's token
                .then(function(value) {
                    return {
                        token: r.token,
                        value: value
                    };
                });
            };
            nowait.forEach(getResult);
            return acc.concat(wait.map(getResult));
        }, []);
        // Wait for all the "WAIT" resolvables
        return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.all(promises);
    };
    ResolveContext.prototype.injector = function() {
        return this._injector || (this._injector = new $3996106c44ea4b60$var$UIInjectorImpl(this));
    };
    ResolveContext.prototype.findNode = function(resolvable) {
        return (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(this._path, function(node) {
            return (0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(node.resolvables, resolvable);
        });
    };
    /**
     * Gets the async dependencies of a Resolvable
     *
     * Given a Resolvable, returns its dependencies as a Resolvable[]
     */ ResolveContext.prototype.getDependencies = function(resolvable) {
        var _this = this;
        var node = this.findNode(resolvable);
        // Find which other resolvables are "visible" to the `resolvable` argument
        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
        var subPath = (0, $50d81baac9264b80$export$39d3fc700b385dc4).subPath(this._path, function(x) {
            return x === node;
        }) || this._path;
        var availableResolvables = subPath.reduce(function(acc, _node) {
            return acc.concat(_node.resolvables);
        }, []) // all of subpath's resolvables
        .filter(function(res) {
            return res !== resolvable;
        }); // filter out the `resolvable` argument
        var getDependency = function(token) {
            var matching = availableResolvables.filter(function(r) {
                return r.token === token;
            });
            if (matching.length) return (0, $abcc081e7f2a61c5$export$c01875f616615628)(matching);
            var fromInjector = _this.injector().getNative(token);
            if ((0, $c4ca6daaad7210ad$export$fce6876652108ab)(fromInjector)) throw new Error("Could not find Dependency Injection token: " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(token));
            return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(token, function() {
                return fromInjector;
            }, [], fromInjector);
        };
        return resolvable.deps.map(getDependency);
    };
    return ResolveContext;
}();
/** @internal */ var $3996106c44ea4b60$var$UIInjectorImpl = /** @class */ function() {
    function UIInjectorImpl(context) {
        this.context = context;
        this.native = this.get($3996106c44ea4b60$export$de56f1697c5b03a2) || (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector;
    }
    UIInjectorImpl.prototype.get = function(token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) {
            if (this.context.getPolicy(resolvable).async === "NOWAIT") return resolvable.get(this.context);
            if (!resolvable.resolved) throw new Error("Resolvable async .get() not complete:" + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(resolvable.token));
            return resolvable.data;
        }
        return this.getNative(token);
    };
    UIInjectorImpl.prototype.getAsync = function(token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) return resolvable.get(this.context);
        return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(this.native.get(token));
    };
    UIInjectorImpl.prototype.getNative = function(token) {
        return this.native && this.native.get(token);
    };
    return UIInjectorImpl;
}();




var $43f58c35eb9265b0$exports = {};
$parcel$export($43f58c35eb9265b0$exports, "TargetState", function () { return $f6f45358c1dc8ea5$export$b47ab23ce83f86ac; });
/**
 * # The state subsystem
 *
 * This subsystem implements the ui-router state tree
 *
 * - The [[StateService]] has state-related service methods such as:
 *   - [[StateService.get]]: Get a registered [[StateDeclaration]] object
 *   - [[StateService.go]]: Transition from the current state to a new state
 *   - [[StateService.reload]]: Reload the current state
 *   - [[StateService.target]]: Get a [[TargetState]] (useful when redirecting from a Transition Hook)
 *   - [[StateService.onInvalid]]: Register a callback for when a transition to an invalid state is started
 *   - [[StateService.defaultErrorHandler]]: Register a global callback for when a transition errors
 * - The [[StateDeclaration]] interface defines the shape of a state declaration
 * - The [[StateRegistry]] contains all the registered states
 *   - States can be added/removed using the [[StateRegistry.register]] and [[StateRegistry.deregister]]
 *     - Note: Bootstrap state registration differs by front-end framework.
 *   - Get notified of state registration/deregistration using [[StateRegistry.onStatesChanged]].
 *
 * @packageDocumentation
 */ var $f1a9eaf39668eb0b$exports = {};








var $21e04a883100676a$var$parseUrl = function(url) {
    if (!(0, $c4ca6daaad7210ad$export$844ec244b1367d54)(url)) return false;
    var root = url.charAt(0) === "^";
    return {
        val: root ? url.substring(1) : url,
        root: root
    };
};
function $21e04a883100676a$var$nameBuilder(state) {
    return state.name;
}
function $21e04a883100676a$var$selfBuilder(state) {
    state.self.$$state = function() {
        return state;
    };
    return state.self;
}
function $21e04a883100676a$var$dataBuilder(state) {
    if (state.parent && state.parent.data) state.data = state.self.data = (0, $abcc081e7f2a61c5$export$4dc9a6b0ae3dfd2a)(state.parent.data, state.data);
    return state.data;
}
var $21e04a883100676a$var$getUrlBuilder = function($urlMatcherFactoryProvider, root) {
    return function urlBuilder(stateObject) {
        var stateDec = stateObject.self;
        // For future states, i.e., states whose name ends with `.**`,
        // match anything that starts with the url prefix
        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
            var newStateDec = {};
            (0, $abcc081e7f2a61c5$export$784d13d8ee351f07)(stateDec, newStateDec);
            newStateDec.url += "{remainder:any}"; // match any path (.*)
            stateDec = newStateDec;
        }
        var parent = stateObject.parent;
        var parsed = $21e04a883100676a$var$parseUrl(stateDec.url);
        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
            state: stateDec
        });
        if (!url) return null;
        if (!$urlMatcherFactoryProvider.isMatcher(url)) throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
        return parsed && parsed.root ? url : (parent && parent.navigable || root()).url.append(url);
    };
};
var $21e04a883100676a$var$getNavigableBuilder = function(isRoot) {
    return function navigableBuilder(state) {
        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
    };
};
var $21e04a883100676a$var$getParamsBuilder = function(paramFactory) {
    return function paramsBuilder(state) {
        var makeConfigParam = function(config, id) {
            return paramFactory.fromConfig(id, null, state.self);
        };
        var urlParams = state.url && state.url.parameters({
            inherit: false
        }) || [];
        var nonUrlParams = (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)((0, $abcc081e7f2a61c5$export$2910e2aad8eb2960)((0, $abcc081e7f2a61c5$export$30a06c8d3562193f)(state.params || {}, urlParams.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("id"))), makeConfigParam));
        return urlParams.concat(nonUrlParams).map(function(p) {
            return [
                p.id,
                p
            ];
        }).reduce((0, $abcc081e7f2a61c5$export$448afb43435ef71e), {});
    };
};
function $21e04a883100676a$var$pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : /*root*/ [
        state
    ];
}
function $21e04a883100676a$var$includesBuilder(state) {
    var includes = state.parent ? (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
}
function $21e04a883100676a$export$98ac581567bd7214(state) {
    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */ var objects2Tuples = function(resolveObj, resolvePolicies) {
        return Object.keys(resolveObj || {}).map(function(token) {
            return {
                token: token,
                val: resolveObj[token],
                deps: undefined,
                policy: resolvePolicies[token]
            };
        });
    };
    /** fetch DI annotations from a function or ng1-style array */ var annotate = function(fn) {
        var $injector = (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector;
        // ng1 doesn't have an $injector until runtime.
        // If the $injector doesn't exist, use "deferred" literal as a
        // marker indicating they should be annotated when runtime starts
        return fn["$inject"] || $injector && $injector.annotate(fn, $injector.strictDi) || "deferred";
    };
    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */ var isResolveLiteral = function(obj) {
        return !!(obj.token && obj.resolveFn);
    };
    /** true if the object looks like a provide literal, or a ng2 Provider */ var isLikeNg2Provider = function(obj) {
        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
    };
    /** true if the object looks like a tuple from obj2Tuples */ var isTupleFromObj = function(obj) {
        return !!(obj && obj.val && ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(obj.val) || (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(obj.val) || (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(obj.val)));
    };
    /** extracts the token from a Provider or provide literal */ var getToken = function(p) {
        return p.provide || p.token;
    };
    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
    var literal2Resolvable = (0, $b94057b5b409b0b1$export$24f82734ea047e6f)([
        [
            (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("resolveFn"),
            function(p) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(getToken(p), p.resolveFn, p.deps, p.policy);
            }
        ],
        [
            (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("useFactory"),
            function(p) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy);
            }
        ],
        [
            (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("useClass"),
            function(p) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(getToken(p), function() {
                    return new p.useClass();
                }, [], p.policy);
            }
        ],
        [
            (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("useValue"),
            function(p) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(getToken(p), function() {
                    return p.useValue;
                }, [], p.policy, p.useValue);
            }
        ],
        [
            (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("useExisting"),
            function(p) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(getToken(p), (0, $abcc081e7f2a61c5$export$f0954fd7d5368655), [
                    p.useExisting
                ], p.policy);
            }
        ]
    ]);
    // prettier-ignore
    var tuple2Resolvable = (0, $b94057b5b409b0b1$export$24f82734ea047e6f)([
        [
            (0, $b94057b5b409b0b1$export$a4627e546088548d)((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("val"), (0, $c4ca6daaad7210ad$export$844ec244b1367d54)),
            function(tuple) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(tuple.token, (0, $abcc081e7f2a61c5$export$f0954fd7d5368655), [
                    tuple.val
                ], tuple.policy);
            }
        ],
        [
            (0, $b94057b5b409b0b1$export$a4627e546088548d)((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("val"), (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)),
            function(tuple) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(tuple.token, (0, $abcc081e7f2a61c5$export$c01875f616615628)(tuple.val), tuple.val.slice(0, -1), tuple.policy);
            }
        ],
        [
            (0, $b94057b5b409b0b1$export$a4627e546088548d)((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("val"), (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)),
            function(tuple) {
                return new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(tuple.token, tuple.val, annotate(tuple.val), tuple.policy);
            }
        ]
    ]);
    // prettier-ignore
    var item2Resolvable = (0, $b94057b5b409b0b1$export$24f82734ea047e6f)([
        [
            (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)),
            function(r) {
                return r;
            }
        ],
        [
            isResolveLiteral,
            literal2Resolvable
        ],
        [
            isLikeNg2Provider,
            literal2Resolvable
        ],
        [
            isTupleFromObj,
            tuple2Resolvable
        ],
        [
            (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(true),
            function(obj) {
                throw new Error("Invalid resolve value: " + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(obj));
            }
        ]
    ]);
    // If resolveBlock is already an array, use it as-is.
    // Otherwise, assume it's an object and convert to an Array of tuples
    var decl = state.resolve;
    var items = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
}
/**
 * A internal global service
 *
 * StateBuilder is a factory for the internal [[StateObject]] objects.
 *
 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
 * [[StateObject]] object, which has an API and is used internally.
 *
 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
 * using the [[builder]] method.
 */ var $21e04a883100676a$export$b8bc7c796d447034 = /** @class */ function() {
    function StateBuilder(matcher, urlMatcherFactory) {
        this.matcher = matcher;
        var self = this;
        var root = function() {
            return matcher.find("");
        };
        var isRoot = function(state) {
            return state.name === "";
        };
        function parentBuilder(state) {
            if (isRoot(state)) return null;
            return matcher.find(self.parentName(state)) || root();
        }
        this.builders = {
            name: [
                $21e04a883100676a$var$nameBuilder
            ],
            self: [
                $21e04a883100676a$var$selfBuilder
            ],
            parent: [
                parentBuilder
            ],
            data: [
                $21e04a883100676a$var$dataBuilder
            ],
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: [
                $21e04a883100676a$var$getUrlBuilder(urlMatcherFactory, root)
            ],
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: [
                $21e04a883100676a$var$getNavigableBuilder(isRoot)
            ],
            params: [
                $21e04a883100676a$var$getParamsBuilder(urlMatcherFactory.paramFactory)
            ],
            // Each framework-specific ui-router implementation should define its own `views` builder
            // e.g., src/ng1/statebuilders/views.ts
            views: [],
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: [
                $21e04a883100676a$var$pathBuilder
            ],
            // Speed up $state.includes() as it's used a lot
            includes: [
                $21e04a883100676a$var$includesBuilder
            ],
            resolvables: [
                $21e04a883100676a$export$98ac581567bd7214
            ]
        };
    }
    StateBuilder.prototype.builder = function(name, fn) {
        var builders = this.builders;
        var array = builders[name] || [];
        // Backwards compat: if only one builder exists, return it, else return whole arary.
        if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(name) && !(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(fn)) return array.length > 1 ? array : array[0];
        if (!(0, $c4ca6daaad7210ad$export$844ec244b1367d54)(name) || !(0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(fn)) return;
        builders[name] = array;
        builders[name].push(fn);
        return function() {
            return builders[name].splice(builders[name].indexOf(fn, 1)) && null;
        };
    };
    /**
     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
     * properties and API built.
     *
     * @param state an uninitialized State object
     * @returns the built State object
     */ StateBuilder.prototype.build = function(state) {
        var _a = this, matcher = _a.matcher, builders = _a.builders;
        var parent = this.parentName(state);
        if (parent && !matcher.find(parent, undefined, false)) return null;
        for(var key in builders){
            if (!builders.hasOwnProperty(key)) continue;
            var chain = builders[key].reduce(function(parentFn, step) {
                return function(_state) {
                    return step(_state, parentFn);
                };
            }, (0, $abcc081e7f2a61c5$export$8793edee2d425525));
            state[key] = chain(state);
        }
        return state;
    };
    StateBuilder.prototype.parentName = function(state) {
        // name = 'foo.bar.baz.**'
        var name = state.name || "";
        // segments = ['foo', 'bar', 'baz', '.**']
        var segments = name.split(".");
        // segments = ['foo', 'bar', 'baz']
        var lastSegment = segments.pop();
        // segments = ['foo', 'bar'] (ignore .** segment for future states)
        if (lastSegment === "**") segments.pop();
        if (segments.length) {
            if (state.parent) throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
            // 'foo.bar'
            return segments.join(".");
        }
        if (!state.parent) return "";
        return (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function(state) {
        var name = state.name;
        if (name.indexOf(".") !== -1 || !state.parent) return name;
        var parentName = (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(state.parent) ? state.parent : state.parent.name;
        return parentName ? parentName + "." + name : name;
    };
    return StateBuilder;
}();






/**
 * Internal representation of a UI-Router state.
 *
 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
 *
 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
 *
 * This class prototypally inherits from the corresponding [[StateDeclaration]].
 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
 */ var $f1013b6b1a4d5acc$export$d02a9edeffca715 = /** @class */ function() {
    /** @deprecated use State.create() */ function StateObject(config) {
        return StateObject.create(config || {});
    }
    /**
     * Create a state object to put the private/internal implementation details onto.
     * The object's prototype chain looks like:
     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
     *
     * @param stateDecl the user-supplied State Declaration
     * @returns {StateObject} an internal State object
     */ StateObject.create = function(stateDecl) {
        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
        var state = (0, $abcc081e7f2a61c5$export$4dc9a6b0ae3dfd2a)((0, $abcc081e7f2a61c5$export$4dc9a6b0ae3dfd2a)(stateDecl, StateObject.prototype));
        stateDecl.$$state = function() {
            return state;
        };
        state.self = stateDecl;
        state.__stateObjectCache = {
            nameGlob: (0, $037d6cb562d64aaa$export$e1c4d8357a9b5598).fromString(state.name)
        };
        return state;
    };
    /**
     * Returns true if the provided parameter is the same state.
     *
     * Compares the identity of the state against the passed value, which is either an object
     * reference to the actual `State` instance, the original definition object passed to
     * `$stateProvider.state()`, or the fully-qualified name.
     *
     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
     * @returns Returns `true` if `ref` matches the current `State` instance.
     */ StateObject.prototype.is = function(ref) {
        return this === ref || this.self === ref || this.fqn() === ref;
    };
    /**
     * @deprecated this does not properly handle dot notation
     * @returns Returns a dot-separated name of the state.
     */ StateObject.prototype.fqn = function() {
        if (!this.parent || !(this.parent instanceof this.constructor)) return this.name;
        var name = this.parent.fqn();
        return name ? name + "." + this.name : this.name;
    };
    /**
     * Returns the root node of this state's tree.
     *
     * @returns The root of this state's tree.
     */ StateObject.prototype.root = function() {
        return this.parent && this.parent.root() || this;
    };
    /**
     * Gets the state's `Param` objects
     *
     * Gets the list of [[Param]] objects owned by the state.
     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
     *
     * @param opts options
     */ StateObject.prototype.parameters = function(opts) {
        opts = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(opts, {
            inherit: true,
            matchingKeys: null
        });
        var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
        return inherited.concat((0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(this.params)).filter(function(param) {
            return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id);
        });
    };
    /**
     * Returns a single [[Param]] that is owned by the state
     *
     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
     * @param id the name of the [[Param]] to return
     * @param opts options
     */ StateObject.prototype.parameter = function(id, opts) {
        if (opts === void 0) opts = {};
        return this.url && this.url.parameter(id, opts) || (0, $abcc081e7f2a61c5$export$71aa6c912b956294)((0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(this.params), (0, $b94057b5b409b0b1$export$78c65ad39408e96e)("id", id)) || opts.inherit && this.parent && this.parent.parameter(id);
    };
    StateObject.prototype.toString = function() {
        return this.fqn();
    };
    /** Predicate which returns true if the object is an class with @State() decorator */ StateObject.isStateClass = function(stateDecl) {
        return (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(stateDecl) && stateDecl["__uiRouterState"] === true;
    };
    /** Predicate which returns true if the object is a [[StateDeclaration]] object */ StateObject.isStateDeclaration = function(obj) {
        return (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(obj["$$state"]);
    };
    /** Predicate which returns true if the object is an internal [[StateObject]] object */ StateObject.isState = function(obj) {
        return (0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(obj["__stateObjectCache"]);
    };
    return StateObject;
}();





var $1a31a429934a096a$export$9228b007a9cc66de = /** @class */ function() {
    function StateMatcher(_states) {
        this._states = _states;
    }
    StateMatcher.prototype.isRelative = function(stateName) {
        stateName = stateName || "";
        return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
    };
    StateMatcher.prototype.find = function(stateOrName, base, matchGlob) {
        if (matchGlob === void 0) matchGlob = true;
        if (!stateOrName && stateOrName !== "") return undefined;
        var isStr = (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(stateOrName);
        var name = isStr ? stateOrName : stateOrName.name;
        if (this.isRelative(name)) name = this.resolvePath(name, base);
        var state = this._states[name];
        if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) return state;
        else if (isStr && matchGlob) {
            var _states = (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(this._states);
            var matches = _states.filter(function(_state) {
                return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name);
            });
            if (matches.length > 1) (0, $32d2769bf48d6ac5$export$e05ea0a0aaef622f).error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function(match) {
                return match.name;
            }));
            return matches[0];
        }
        return undefined;
    };
    StateMatcher.prototype.resolvePath = function(name, base) {
        if (!base) throw new Error("No reference point given for path '" + name + "'");
        var baseState = this.find(base);
        var splitName = name.split(".");
        var pathLength = splitName.length;
        var i = 0, current = baseState;
        for(; i < pathLength; i++){
            if (splitName[i] === "" && i === 0) {
                current = baseState;
                continue;
            }
            if (splitName[i] === "^") {
                if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
                current = current.parent;
                continue;
            }
            break;
        }
        var relName = splitName.slice(i).join(".");
        return current.name + (current.name && relName ? "." : "") + relName;
    };
    return StateMatcher;
}();




var $c010764f5b7f0090$export$f96237365eefbc86 = /** @class */ function() {
    function StateQueueManager(router, states, builder, listeners) {
        this.router = router;
        this.states = states;
        this.builder = builder;
        this.listeners = listeners;
        this.queue = [];
    }
    StateQueueManager.prototype.dispose = function() {
        this.queue = [];
    };
    StateQueueManager.prototype.register = function(stateDecl) {
        var queue = this.queue;
        var state = (0, $f1013b6b1a4d5acc$export$d02a9edeffca715).create(stateDecl);
        var name = state.name;
        if (!(0, $c4ca6daaad7210ad$export$844ec244b1367d54)(name)) throw new Error("State must have a valid name");
        if (this.states.hasOwnProperty(name) || (0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(queue.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("name")), name)) throw new Error("State '" + name + "' is already defined");
        queue.push(state);
        this.flush();
        return state;
    };
    StateQueueManager.prototype.flush = function() {
        var _this = this;
        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
        var registered = [], orphans = [], previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
        var getState = function(name) {
            return _this.states.hasOwnProperty(name) && _this.states[name];
        };
        var notifyListeners = function() {
            if (registered.length) _this.listeners.forEach(function(listener) {
                return listener("registered", registered.map(function(s) {
                    return s.self;
                }));
            });
        };
        while(queue.length > 0){
            var state = queue.shift();
            var name_1 = state.name;
            var result = builder.build(state);
            var orphanIdx = orphans.indexOf(state);
            if (result) {
                var existingState = getState(name_1);
                if (existingState && existingState.name === name_1) throw new Error("State '" + name_1 + "' is already defined");
                var existingFutureState = getState(name_1 + ".**");
                if (existingFutureState) // Remove future state of the same name
                this.router.stateRegistry.deregister(existingFutureState);
                states[name_1] = state;
                this.attachRoute(state);
                if (orphanIdx >= 0) orphans.splice(orphanIdx, 1);
                registered.push(state);
                continue;
            }
            var prev = previousQueueLength[name_1];
            previousQueueLength[name_1] = queue.length;
            if (orphanIdx >= 0 && prev === queue.length) {
                // Wait until two consecutive iterations where no additional states were dequeued successfully.
                // throw new Error(`Cannot register orphaned state '${name}'`);
                queue.push(state);
                notifyListeners();
                return states;
            } else if (orphanIdx < 0) orphans.push(state);
            queue.push(state);
        }
        notifyListeners();
        return states;
    };
    StateQueueManager.prototype.attachRoute = function(state) {
        if (state.abstract || !state.url) return;
        var rulesApi = this.router.urlService.rules;
        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
    };
    return StateQueueManager;
}();







/**
 * A registry for all of the application's [[StateDeclaration]]s
 *
 * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
 */ var $c4bb05b5c4e40fea$export$ec0497251a3e4668 = /** @class */ function() {
    /** @internal */ function StateRegistry(router) {
        this.router = router;
        this.states = {};
        /** @internal */ this.listeners = [];
        this.matcher = new (0, $1a31a429934a096a$export$9228b007a9cc66de)(this.states);
        this.builder = new (0, $21e04a883100676a$export$b8bc7c796d447034)(this.matcher, router.urlMatcherFactory);
        this.stateQueue = new (0, $c010764f5b7f0090$export$f96237365eefbc86)(router, this.states, this.builder, this.listeners);
        this._registerRoot();
    }
    /** @internal */ StateRegistry.prototype._registerRoot = function() {
        var rootStateDef = {
            name: "",
            url: "^",
            views: null,
            params: {
                "#": {
                    value: null,
                    type: "hash",
                    dynamic: true
                }
            },
            abstract: true
        };
        var _root = this._root = this.stateQueue.register(rootStateDef);
        _root.navigable = null;
    };
    /** @internal */ StateRegistry.prototype.dispose = function() {
        var _this = this;
        this.stateQueue.dispose();
        this.listeners = [];
        this.get().forEach(function(state) {
            return _this.get(state) && _this.deregister(state);
        });
    };
    /**
     * Listen for a State Registry events
     *
     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
     *
     * #### Example:
     * ```js
     * let allStates = registry.get();
     *
     * // Later, invoke deregisterFn() to remove the listener
     * let deregisterFn = registry.onStatesChanged((event, states) => {
     *   switch(event) {
     *     case: 'registered':
     *       states.forEach(state => allStates.push(state));
     *       break;
     *     case: 'deregistered':
     *       states.forEach(state => {
     *         let idx = allStates.indexOf(state);
     *         if (idx !== -1) allStates.splice(idx, 1);
     *       });
     *       break;
     *   }
     * });
     * ```
     *
     * @param listener a callback function invoked when the registered states changes.
     *        The function receives two parameters, `event` and `state`.
     *        See [[StateRegistryListener]]
     * @return a function that deregisters the listener
     */ StateRegistry.prototype.onStatesChanged = function(listener) {
        this.listeners.push(listener);
        return (function deregisterListener() {
            (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(this.listeners)(listener);
        }).bind(this);
    };
    /**
     * Gets the implicit root state
     *
     * Gets the root of the state tree.
     * The root state is implicitly created by UI-Router.
     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
     *
     * @return the root [[StateObject]]
     */ StateRegistry.prototype.root = function() {
        return this._root;
    };
    /**
     * Adds a state to the registry
     *
     * Registers a [[StateDeclaration]] or queues it for registration.
     *
     * Note: a state will be queued if the state's parent isn't yet registered.
     *
     * @param stateDefinition the definition of the state to register.
     * @returns the internal [[StateObject]] object.
     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
     *          If the state was only queued, then the object is not fully built.
     */ StateRegistry.prototype.register = function(stateDefinition) {
        return this.stateQueue.register(stateDefinition);
    };
    /** @internal */ StateRegistry.prototype._deregisterTree = function(state) {
        var _this = this;
        var all = this.get().map(function(s) {
            return s.$$state();
        });
        var getChildren = function(states) {
            var _children = all.filter(function(s) {
                return states.indexOf(s.parent) !== -1;
            });
            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
        };
        var children = getChildren([
            state
        ]);
        var deregistered = [
            state
        ].concat(children).reverse();
        deregistered.forEach(function(_state) {
            var rulesApi = _this.router.urlService.rules;
            // Remove URL rule
            rulesApi.rules().filter((0, $b94057b5b409b0b1$export$78c65ad39408e96e)("state", _state)).forEach(function(rule) {
                return rulesApi.removeRule(rule);
            });
            // Remove state from registry
            delete _this.states[_state.name];
        });
        return deregistered;
    };
    /**
     * Removes a state from the registry
     *
     * This removes a state from the registry.
     * If the state has children, they are are also removed from the registry.
     *
     * @param stateOrName the state's name or object representation
     * @returns {StateObject[]} a list of removed states
     */ StateRegistry.prototype.deregister = function(stateOrName) {
        var _state = this.get(stateOrName);
        if (!_state) throw new Error("Can't deregister state; not found: " + stateOrName);
        var deregisteredStates = this._deregisterTree(_state.$$state());
        this.listeners.forEach(function(listener) {
            return listener("deregistered", deregisteredStates.map(function(s) {
                return s.self;
            }));
        });
        return deregisteredStates;
    };
    StateRegistry.prototype.get = function(stateOrName, base) {
        var _this = this;
        if (arguments.length === 0) return Object.keys(this.states).map(function(name) {
            return _this.states[name].self;
        });
        var found = this.matcher.find(stateOrName, base);
        return found && found.self || null;
    };
    /**
     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
     * More than one BuilderFunction can be registered for a given property.
     *
     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
     *
     * @param property The name of the State property being registered for.
     * @param builderFunction The BuilderFunction which will be used to build the State property
     * @returns a function which deregisters the BuilderFunction
     */ StateRegistry.prototype.decorator = function(property, builderFunction) {
        return this.builder.builder(property, builderFunction);
    };
    return StateRegistry;
}();








var $f798ef43a419f893$export$9484030a489306a0;
(function(TransitionHookPhase) {
    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
})($f798ef43a419f893$export$9484030a489306a0 || ($f798ef43a419f893$export$9484030a489306a0 = {}));
var $f798ef43a419f893$export$6d115073a4f8edfb;
(function(TransitionHookScope) {
    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
})($f798ef43a419f893$export$6d115073a4f8edfb || ($f798ef43a419f893$export$6d115073a4f8edfb = {}));


















var $eab60650cc6e25be$var$defaultOptions = {
    current: (0, $abcc081e7f2a61c5$export$8793edee2d425525),
    transition: null,
    traceData: {},
    bind: null
};
var $eab60650cc6e25be$export$dcf30b2235353599 = /** @class */ function() {
    function TransitionHook(transition, stateContext, registeredHook, options) {
        var _this = this;
        this.transition = transition;
        this.stateContext = stateContext;
        this.registeredHook = registeredHook;
        this.options = options;
        this.isSuperseded = function() {
            return _this.type.hookPhase === (0, $f798ef43a419f893$export$9484030a489306a0).RUN && !_this.options.transition.isActive();
        };
        this.options = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(options, $eab60650cc6e25be$var$defaultOptions);
        this.type = registeredHook.eventType;
    }
    /**
     * Chains together an array of TransitionHooks.
     *
     * Given a list of [[TransitionHook]] objects, chains them together.
     * Each hook is invoked after the previous one completes.
     *
     * #### Example:
     * ```js
     * var hooks: TransitionHook[] = getHooks();
     * let promise: Promise<any> = TransitionHook.chain(hooks);
     *
     * promise.then(handleSuccess, handleError);
     * ```
     *
     * @param hooks the list of hooks to chain together
     * @param waitFor if provided, the chain is `.then()`'ed off this promise
     * @returns a `Promise` for sequentially invoking the hooks (in order)
     */ TransitionHook.chain = function(hooks, waitFor) {
        // Chain the next hook off the previous
        var createHookChainR = function(prev, nextHook) {
            return prev.then(function() {
                return nextHook.invokeHook();
            });
        };
        return hooks.reduce(createHookChainR, waitFor || (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when());
    };
    /**
     * Invokes all the provided TransitionHooks, in order.
     * Each hook's return value is checked.
     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
     * If no hook returns a promise, then all hooks are processed synchronously.
     *
     * @param hooks the list of TransitionHooks to invoke
     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
     *
     * @returns a promise for the async result, or the result of the callback
     */ TransitionHook.invokeHooks = function(hooks, doneCallback) {
        for(var idx = 0; idx < hooks.length; idx++){
            var hookResult = hooks[idx].invokeHook();
            if ((0, $c4ca6daaad7210ad$export$4369c812aac99591)(hookResult)) {
                var remainingHooks = hooks.slice(idx + 1);
                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
            }
        }
        return doneCallback();
    };
    /**
     * Run all TransitionHooks, ignoring their return value.
     */ TransitionHook.runAllHooks = function(hooks) {
        hooks.forEach(function(hook) {
            return hook.invokeHook();
        });
    };
    TransitionHook.prototype.logError = function(err) {
        this.transition.router.stateService.defaultErrorHandler()(err);
    };
    TransitionHook.prototype.invokeHook = function() {
        var _this = this;
        var hook = this.registeredHook;
        if (hook._deregistered) return;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent) return notCurrent;
        var options = this.options;
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceHookInvocation(this, this.transition, options);
        var invokeCallback = function() {
            return hook.callback.call(options.bind, _this.transition, _this.stateContext);
        };
        var normalizeErr = function(err) {
            return (0, $24ffb5fe12175fdd$export$a40146100efc171b).normalize(err).toPromise();
        };
        var handleError = function(err) {
            return hook.eventType.getErrorHandler(_this)(err);
        };
        var handleResult = function(result) {
            return hook.eventType.getResultHandler(_this)(result);
        };
        try {
            var result = invokeCallback();
            if (!this.type.synchronous && (0, $c4ca6daaad7210ad$export$4369c812aac99591)(result)) return result.catch(normalizeErr).then(handleResult, handleError);
            else return handleResult(result);
        } catch (err) {
            // If callback throws (synchronously)
            return handleError((0, $24ffb5fe12175fdd$export$a40146100efc171b).normalize(err));
        } finally{
            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) hook.deregister();
        }
    };
    /**
     * This method handles the return value of a Transition Hook.
     *
     * A hook can return false (cancel), a TargetState (redirect),
     * or a promise (which may later resolve to false or a redirect)
     *
     * This also handles "transition superseded" -- when a new transition
     * was started while the hook was still running
     */ TransitionHook.prototype.handleHookResult = function(result) {
        var _this = this;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent) return notCurrent;
        // Hook returned a promise
        if ((0, $c4ca6daaad7210ad$export$4369c812aac99591)(result)) // Wait for the promise, then reprocess with the resulting value
        return result.then(function(val) {
            return _this.handleHookResult(val);
        });
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceHookResult(result, this.transition, this.options);
        // Hook returned false
        if (result === false) // Abort this Transition
        return (0, $24ffb5fe12175fdd$export$a40146100efc171b).aborted("Hook aborted transition").toPromise();
        var isTargetState = (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac));
        // hook returned a TargetState
        if (isTargetState(result)) // Halt the current Transition and redirect (a new Transition) to the TargetState.
        return (0, $24ffb5fe12175fdd$export$a40146100efc171b).redirected(result).toPromise();
    };
    /**
     * Return a Rejection promise if the transition is no longer current due
     * to a stopped router (disposed), or a new transition has started and superseded this one.
     */ TransitionHook.prototype.getNotCurrentRejection = function() {
        var router = this.transition.router;
        // The router is stopped
        if (router._disposed) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
        if (this.transition._aborted) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).aborted().toPromise();
        // This transition is no longer current.
        // Another transition started while this hook was still running.
        if (this.isSuperseded()) // Abort this transition
        return (0, $24ffb5fe12175fdd$export$a40146100efc171b).superseded(this.options.current()).toPromise();
    };
    TransitionHook.prototype.toString = function() {
        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
        var event = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("traceData.hookType")(options) || "internal", context = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("traceData.context.state.name")(options) || (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("traceData.context")(options) || "unknown", name = (0, $48612b14b235e6fd$export$4fb15e473756ce74)(registeredHook.callback);
        return event + " context: " + context + ", " + (0, $48612b14b235e6fd$export$c9f461152c658a8b)(200, name);
    };
    /**
     * These GetResultHandler(s) are used by [[invokeHook]] below
     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
     */ TransitionHook.HANDLE_RESULT = function(hook) {
        return function(result) {
            return hook.handleHookResult(result);
        };
    };
    /**
     * If the result is a promise rejection, log it.
     * Otherwise, ignore the result.
     */ TransitionHook.LOG_REJECTED_RESULT = function(hook) {
        return function(result) {
            (0, $c4ca6daaad7210ad$export$4369c812aac99591)(result) && result.catch(function(err) {
                return hook.logError((0, $24ffb5fe12175fdd$export$a40146100efc171b).normalize(err));
            });
            return undefined;
        };
    };
    /**
     * These GetErrorHandler(s) are used by [[invokeHook]] below
     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
     */ TransitionHook.LOG_ERROR = function(hook) {
        return function(error) {
            return hook.logError(error);
        };
    };
    TransitionHook.REJECT_ERROR = function(hook) {
        return function(error) {
            return (0, $abcc081e7f2a61c5$export$799ed83fec19ce5d)(error);
        };
    };
    TransitionHook.THROW_ERROR = function(hook) {
        return function(error) {
            throw error;
        };
    };
    return TransitionHook;
}();




function $c94bf830ad00bcf1$export$2e67aeff1c21ead8(state, criterion, transition) {
    var toMatch = (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(criterion) ? [
        criterion
    ] : criterion;
    function matchGlobs(_state) {
        var globStrings = toMatch;
        for(var i = 0; i < globStrings.length; i++){
            var glob = new (0, $037d6cb562d64aaa$export$e1c4d8357a9b5598)(globStrings[i]);
            if (glob && glob.matches(_state.name) || !glob && globStrings[i] === _state.name) return true;
        }
        return false;
    }
    var matchFn = (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(toMatch) ? toMatch : matchGlobs;
    return !!matchFn(state, transition);
}
/**
 * The registration data for a registered transition hook
 */ var $c94bf830ad00bcf1$export$3f0ee07a6f399a1d = /** @class */ function() {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
        if (options === void 0) options = {};
        this.tranSvc = tranSvc;
        this.eventType = eventType;
        this.callback = callback;
        this.matchCriteria = matchCriteria;
        this.removeHookFromRegistry = removeHookFromRegistry;
        this.invokeCount = 0;
        this._deregistered = false;
        this.priority = options.priority || 0;
        this.bind = options.bind || null;
        this.invokeLimit = options.invokeLimit;
    }
    /**
     * Gets the matching [[PathNode]]s
     *
     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
     *
     * Returning `null` is significant to distinguish between the default
     * "match-all criterion value" of `true` compared to a `() => true` function,
     * when the nodes is an empty array.
     *
     * This is useful to allow a transition match criteria of `entering: true`
     * to still match a transition, even when `entering === []`.  Contrast that
     * with `entering: (state) => true` which only matches when a state is actually
     * being entered.
     */ RegisteredHook.prototype._matchingNodes = function(nodes, criterion, transition) {
        if (criterion === true) return nodes;
        var matching = nodes.filter(function(node) {
            return $c94bf830ad00bcf1$export$2e67aeff1c21ead8(node.state, criterion, transition);
        });
        return matching.length ? matching : null;
    };
    /**
     * Gets the default match criteria (all `true`)
     *
     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
     *
     * ```js
     * {
     *   to: true,
     *   from: true,
     *   entering: true,
     *   exiting: true,
     *   retained: true,
     * }
     */ RegisteredHook.prototype._getDefaultMatchCriteria = function() {
        return (0, $abcc081e7f2a61c5$export$2910e2aad8eb2960)(this.tranSvc._pluginapi._getPathTypes(), function() {
            return true;
        });
    };
    /**
     * Gets matching nodes as [[IMatchingNodes]]
     *
     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
     *
     * ```js
     * let matches: IMatchingNodes = {
     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
     * };
     * ```
     */ RegisteredHook.prototype._getMatchingNodes = function(treeChanges, transition) {
        var _this = this;
        var criteria = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this._getDefaultMatchCriteria(), this.matchCriteria);
        var paths = (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(this.tranSvc._pluginapi._getPathTypes());
        return paths.reduce(function(mn, pathtype) {
            // STATE scope criteria matches against every node in the path.
            // TRANSITION scope criteria matches against only the last node in the path
            var isStateHook = pathtype.scope === (0, $f798ef43a419f893$export$6d115073a4f8edfb).STATE;
            var path = treeChanges[pathtype.name] || [];
            var nodes = isStateHook ? path : [
                (0, $abcc081e7f2a61c5$export$c01875f616615628)(path)
            ];
            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
            return mn;
        }, {});
    };
    /**
     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
     *
     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
     */ RegisteredHook.prototype.matches = function(treeChanges, transition) {
        var matches = this._getMatchingNodes(treeChanges, transition);
        // Check if all the criteria matched the TreeChanges object
        var allMatched = (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(matches).every((0, $abcc081e7f2a61c5$export$f0954fd7d5368655));
        return allMatched ? matches : null;
    };
    RegisteredHook.prototype.deregister = function() {
        this.removeHookFromRegistry(this);
        this._deregistered = true;
    };
    return RegisteredHook;
}();
function $c94bf830ad00bcf1$export$2f7b310570bee07a(registry, transitionService, eventType) {
    // Create the object which holds the registered transition hooks.
    var _registeredHooks = registry._registeredHooks = registry._registeredHooks || {};
    var hooks = _registeredHooks[eventType.name] = [];
    var removeHookFn = (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(hooks);
    // Create hook registration function on the IHookRegistry for the event
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
        if (options === void 0) options = {};
        var registeredHook = new $c94bf830ad00bcf1$export$3f0ee07a6f399a1d(transitionService, eventType, callback, matchObject, removeHookFn, options);
        hooks.push(registeredHook);
        return registeredHook.deregister.bind(registeredHook);
    }
    return hookRegistrationFn;
}






/**
 * This class returns applicable TransitionHooks for a specific Transition instance.
 *
 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
 * determined by the type of hook)
 *
 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
 *
 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
 * in the Transition class, so we must also provide the Transition's _treeChanges)
 */ var $697b87b1b475b749$export$66db7f9bd4391feb = /** @class */ function() {
    function HookBuilder(transition) {
        this.transition = transition;
    }
    HookBuilder.prototype.buildHooksForPhase = function(phase) {
        var _this = this;
        var $transitions = this.transition.router.transitionService;
        return $transitions._pluginapi._getEvents(phase).map(function(type) {
            return _this.buildHooks(type);
        }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).filter((0, $abcc081e7f2a61c5$export$f0954fd7d5368655));
    };
    /**
     * Returns an array of newly built TransitionHook objects.
     *
     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
     * - For each of the [[PathNode]]s, creates a TransitionHook
     *
     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
     */ HookBuilder.prototype.buildHooks = function(hookType) {
        var transition = this.transition;
        var treeChanges = transition.treeChanges();
        // Find all the matching registered hooks for a given hook type
        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
        if (!matchingHooks) return [];
        var baseHookOptions = {
            transition: transition,
            current: transition.options().current
        };
        var makeTransitionHooks = function(hook) {
            // Fetch the Nodes that caused this hook to match.
            var matches = hook.matches(treeChanges, transition);
            // Select the PathNode[] that will be used as TransitionHook context objects
            var matchingNodes = matches[hookType.criteriaMatchPath.name];
            // Return an array of HookTuples
            return matchingNodes.map(function(node) {
                var _options = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({
                    bind: hook.bind,
                    traceData: {
                        hookType: hookType.name,
                        context: node
                    }
                }, baseHookOptions);
                var state = hookType.criteriaMatchPath.scope === (0, $f798ef43a419f893$export$6d115073a4f8edfb).STATE ? node.state.self : null;
                var transitionHook = new (0, $eab60650cc6e25be$export$dcf30b2235353599)(transition, state, hook, _options);
                return {
                    hook: hook,
                    node: node,
                    transitionHook: transitionHook
                };
            });
        };
        return matchingHooks.map(makeTransitionHooks).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).sort($697b87b1b475b749$var$tupleSort(hookType.reverseSort)).map(function(tuple) {
            return tuple.transitionHook;
        });
    };
    /**
     * Finds all RegisteredHooks from:
     * - The Transition object instance hook registry
     * - The TransitionService ($transitions) global hook registry
     *
     * which matched:
     * - the eventType
     * - the matchCriteria (to, from, exiting, retained, entering)
     *
     * @returns an array of matched [[RegisteredHook]]s
     */ HookBuilder.prototype.getMatchingHooks = function(hookType, treeChanges, transition) {
        var isCreate = hookType.hookPhase === (0, $f798ef43a419f893$export$9484030a489306a0).CREATE;
        // Instance and Global hook registries
        var $transitions = this.transition.router.transitionService;
        var registries = isCreate ? [
            $transitions
        ] : [
            this.transition,
            $transitions
        ];
        return registries.map(function(reg) {
            return reg.getHooks(hookType.name);
        }) // Get named hooks from registries
        .filter((0, $abcc081e7f2a61c5$export$f31d929251c75416)((0, $c4ca6daaad7210ad$export$43bee75e5e14138e), "broken event named: " + hookType.name)) // Sanity check
        .reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
        .filter(function(hook) {
            return hook.matches(treeChanges, transition);
        }); // Only those satisfying matchCriteria
    };
    return HookBuilder;
}();
/**
 * A factory for a sort function for HookTuples.
 *
 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
 * the EventHook priority.
 *
 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
 * @returns a tuple sort function
 */ function $697b87b1b475b749$var$tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) reverseDepthSort = false;
    return function nodeDepthThenPriority(l, r) {
        var factor = reverseDepthSort ? -1 : 1;
        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
}








/** @internal */ var $8acc89dbd49ceaf2$var$stateSelf = (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("self");
/**
 * Represents a transition between two states.
 *
 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
 *
 * This object contains all contextual information about the to/from states, parameters, resolves.
 * It has information about all states being entered and exited as a result of the transition.
 */ var $8acc89dbd49ceaf2$export$be58926105124dd4 = /** @class */ function() {
    /**
     * Creates a new Transition object.
     *
     * If the target state is not valid, an error is thrown.
     *
     * @internal
     *
     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
     *        encapsulates the "from state".
     * @param targetState The target state and parameters being transitioned to (also, the transition options)
     * @param router The [[UIRouter]] instance
     * @internal
     */ function Transition(fromPath, targetState, router) {
        var _this = this;
        /** @internal */ this._deferred = (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.defer();
        /**
         * This promise is resolved or rejected based on the outcome of the Transition.
         *
         * When the transition is successful, the promise is resolved
         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
         */ this.promise = this._deferred.promise;
        /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */ this._registeredHooks = {};
        /** @internal */ this._hookBuilder = new (0, $697b87b1b475b749$export$66db7f9bd4391feb)(this);
        /** Checks if this transition is currently active/running. */ this.isActive = function() {
            return _this.router.globals.transition === _this;
        };
        this.router = router;
        this._targetState = targetState;
        if (!targetState.valid()) throw new Error(targetState.error());
        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
        this._options = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({
            current: (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(this)
        }, targetState.options());
        this.$id = router.transitionService._transitionCount++;
        var toPath = (0, $50d81baac9264b80$export$39d3fc700b385dc4).buildToPath(fromPath, targetState);
        this._treeChanges = (0, $50d81baac9264b80$export$39d3fc700b385dc4).treeChanges(fromPath, toPath, this._options.reloadState);
        this.createTransitionHookRegFns();
        var onCreateHooks = this._hookBuilder.buildHooksForPhase((0, $f798ef43a419f893$export$9484030a489306a0).CREATE);
        (0, $eab60650cc6e25be$export$dcf30b2235353599).invokeHooks(onCreateHooks, function() {
            return null;
        });
        this.applyViewConfigs(router);
    }
    /** @internal */ Transition.prototype.onBefore = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onStart = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onExit = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onRetain = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onEnter = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onFinish = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onSuccess = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ Transition.prototype.onError = function(criteria, callback, options) {
        return;
    };
    /** @internal
     * Creates the transition-level hook registration functions
     * (which can then be used to register hooks)
     */ Transition.prototype.createTransitionHookRegFns = function() {
        var _this = this;
        this.router.transitionService._pluginapi._getEvents().filter(function(type) {
            return type.hookPhase !== (0, $f798ef43a419f893$export$9484030a489306a0).CREATE;
        }).forEach(function(type) {
            return (0, $c94bf830ad00bcf1$export$2f7b310570bee07a)(_this, _this.router.transitionService, type);
        });
    };
    /** @internal */ Transition.prototype.getHooks = function(hookName) {
        return this._registeredHooks[hookName];
    };
    Transition.prototype.applyViewConfigs = function(router) {
        var enteringStates = this._treeChanges.entering.map(function(node) {
            return node.state;
        });
        (0, $50d81baac9264b80$export$39d3fc700b385dc4).applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
    };
    /**
     * @internal
     * @returns the internal from [State] object
     */ Transition.prototype.$from = function() {
        return (0, $abcc081e7f2a61c5$export$c01875f616615628)(this._treeChanges.from).state;
    };
    /**
     * @internal
     * @returns the internal to [State] object
     */ Transition.prototype.$to = function() {
        return (0, $abcc081e7f2a61c5$export$c01875f616615628)(this._treeChanges.to).state;
    };
    /**
     * Returns the "from state"
     *
     * Returns the state that the transition is coming *from*.
     *
     * @returns The state declaration object for the Transition's ("from state").
     */ Transition.prototype.from = function() {
        return this.$from().self;
    };
    /**
     * Returns the "to state"
     *
     * Returns the state that the transition is going *to*.
     *
     * @returns The state declaration object for the Transition's target state ("to state").
     */ Transition.prototype.to = function() {
        return this.$to().self;
    };
    /**
     * Gets the Target State
     *
     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
     *
     * @returns the [[TargetState]] of this Transition
     */ Transition.prototype.targetState = function() {
        return this._targetState;
    };
    /**
     * Determines whether two transitions are equivalent.
     * @deprecated
     */ Transition.prototype.is = function(compare) {
        if (compare instanceof Transition) // TODO: Also compare parameters
        return this.is({
            to: compare.$to().name,
            from: compare.$from().name
        });
        return !(compare.to && !(0, $c94bf830ad00bcf1$export$2e67aeff1c21ead8)(this.$to(), compare.to, this) || compare.from && !(0, $c94bf830ad00bcf1$export$2e67aeff1c21ead8)(this.$from(), compare.from, this));
    };
    Transition.prototype.params = function(pathname) {
        if (pathname === void 0) pathname = "to";
        return Object.freeze(this._treeChanges[pathname].map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("paramValues")).reduce((0, $abcc081e7f2a61c5$export$625f91792a536171), {}));
    };
    Transition.prototype.paramsChanged = function() {
        var fromParams = this.params("from");
        var toParams = this.params("to");
        // All the parameters declared on both the "to" and "from" paths
        var allParamDescriptors = [].concat(this._treeChanges.to).concat(this._treeChanges.from).map(function(pathNode) {
            return pathNode.paramSchema;
        }).reduce((0, $abcc081e7f2a61c5$export$fe8babda20d2d313), []).reduce((0, $abcc081e7f2a61c5$export$530e60648218df63), []);
        var changedParamDescriptors = (0, $e3df413894675dea$export$1ca45c9a47aec42c).changed(allParamDescriptors, fromParams, toParams);
        return changedParamDescriptors.reduce(function(changedValues, descriptor) {
            changedValues[descriptor.id] = toParams[descriptor.id];
            return changedValues;
        }, {});
    };
    /**
     * Creates a [[UIInjector]] Dependency Injector
     *
     * Returns a Dependency Injector for the Transition's target state (to state).
     * The injector provides resolve values which the target state has access to.
     *
     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
     *
     * #### Example:
     * ```js
     * .onEnter({ entering: 'myState' }, trans => {
     *   var myResolveValue = trans.injector().get('myResolve');
     *   // Inject a global service from the global/native injector (if it exists)
     *   var MyService = trans.injector().get('MyService');
     * })
     * ```
     *
     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
     * You can use [[UIInjector.getAsync]] to get a promise for the data.
     * #### Example:
     * ```js
     * .onBefore({}, trans => {
     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
     *     return myResolveValue !== 'ABORT';
     *   });
     * });
     * ```
     *
     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
     * #### Example:
     * ```js
     * .onEnter({ to: 'foo.bar' }, trans => {
     *   // returns result of `foo` state's `myResolve` resolve
     *   // even though `foo.bar` also has a `myResolve` resolve
     *   var fooData = trans.injector('foo').get('myResolve');
     * });
     * ```
     *
     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
     * The resolve data from the `from` path will be returned.
     * #### Example:
     * ```js
     * .onExit({ exiting: 'foo.bar' }, trans => {
     *   // Gets the resolve value of `myResolve` from the state being exited
     *   var fooData = trans.injector(null, 'from').get('myResolve');
     * });
     * ```
     *
     *
     * @param state Limits the resolves provided to only the resolves the provided state has access to.
     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
     *
     * @returns a [[UIInjector]]
     */ Transition.prototype.injector = function(state, pathName) {
        if (pathName === void 0) pathName = "to";
        var path = this._treeChanges[pathName];
        if (state) path = (0, $50d81baac9264b80$export$39d3fc700b385dc4).subPath(path, function(node) {
            return node.state === state || node.state.name === state;
        });
        return new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(path).injector();
    };
    /**
     * Gets all available resolve tokens (keys)
     *
     * This method can be used in conjunction with [[injector]] to inspect the resolve values
     * available to the Transition.
     *
     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
     * in the Transition's [[TreeChanges.to]] path.
     *
     * #### Example:
     * This example logs all resolve values
     * ```js
     * let tokens = trans.getResolveTokens();
     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
     * ```
     *
     * #### Example:
     * This example creates promises for each resolve value.
     * This triggers fetches of resolves (if any have not yet been fetched).
     * When all promises have all settled, it logs the resolve values.
     * ```js
     * let tokens = trans.getResolveTokens();
     * let promise = tokens.map(token => trans.injector().getAsync(token));
     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
     * ```
     *
     * Note: Angular 1 users whould use `$q.all()`
     *
     * @param pathname resolve context's path name (e.g., `to` or `from`)
     *
     * @returns an array of resolve tokens (keys)
     */ Transition.prototype.getResolveTokens = function(pathname) {
        if (pathname === void 0) pathname = "to";
        return new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(this._treeChanges[pathname]).getTokens();
    };
    /**
     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
     *
     * Allows a transition hook to dynamically add a Resolvable to this Transition.
     *
     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
     *
     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
     * If no `state` is provided then the root state is used.
     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
     *
     * The `state` argument also scopes the resolved data.
     * The resolved data is available from the injector for that `state` and any children states.
     *
     * #### Example:
     * ```js
     * transitionService.onBefore({}, transition => {
     *   transition.addResolvable({
     *     token: 'myResolve',
     *     deps: ['MyService'],
     *     resolveFn: myService => myService.getData()
     *   });
     * });
     * ```
     *
     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
     */ Transition.prototype.addResolvable = function(resolvable, state) {
        if (state === void 0) state = "";
        resolvable = (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e))(resolvable) ? resolvable : new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)(resolvable);
        var stateName = typeof state === "string" ? state : state.name;
        var topath = this._treeChanges.to;
        var targetNode = (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(topath, function(node) {
            return node.state.name === stateName;
        });
        var resolveContext = new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(topath);
        resolveContext.addResolvables([
            resolvable
        ], targetNode.state);
    };
    /**
     * Gets the transition from which this transition was redirected.
     *
     * If the current transition is a redirect, this method returns the transition that was redirected.
     *
     * #### Example:
     * ```js
     * let transitionA = $state.go('A').transition
     * transitionA.onStart({}, () => $state.target('B'));
     * $transitions.onSuccess({ to: 'B' }, (trans) => {
     *   trans.to().name === 'B'; // true
     *   trans.redirectedFrom() === transitionA; // true
     * });
     * ```
     *
     * @returns The previous Transition, or null if this Transition is not the result of a redirection
     */ Transition.prototype.redirectedFrom = function() {
        return this._options.redirectedFrom || null;
    };
    /**
     * Gets the original transition in a redirect chain
     *
     * A transition might belong to a long chain of multiple redirects.
     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
     *
     * #### Example:
     * ```js
     * // states
     * registry.register({ name: 'A', redirectTo: 'B' });
     * registry.register({ name: 'B', redirectTo: 'C' });
     * registry.register({ name: 'C', redirectTo: 'D' });
     * registry.register({ name: 'D' });
     *
     * let transitionA = $state.go('A').transition
     *
     * $transitions.onSuccess({ to: 'D' }, (trans) => {
     *   trans.to().name === 'D'; // true
     *   trans.redirectedFrom().to().name === 'C'; // true
     *   trans.originalTransition() === transitionA; // true
     *   trans.originalTransition().to().name === 'A'; // true
     * });
     * ```
     *
     * @returns The original Transition that started a redirect chain
     */ Transition.prototype.originalTransition = function() {
        var rf = this.redirectedFrom();
        return rf && rf.originalTransition() || this;
    };
    /**
     * Get the transition options
     *
     * @returns the options for this Transition.
     */ Transition.prototype.options = function() {
        return this._options;
    };
    /**
     * Gets the states being entered.
     *
     * @returns an array of states that will be entered during this transition.
     */ Transition.prototype.entering = function() {
        return (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(this._treeChanges.entering, (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("state")).map($8acc89dbd49ceaf2$var$stateSelf);
    };
    /**
     * Gets the states being exited.
     *
     * @returns an array of states that will be exited during this transition.
     */ Transition.prototype.exiting = function() {
        return (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(this._treeChanges.exiting, (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("state")).map($8acc89dbd49ceaf2$var$stateSelf).reverse();
    };
    /**
     * Gets the states being retained.
     *
     * @returns an array of states that are already entered from a previous Transition, that will not be
     *    exited during this Transition
     */ Transition.prototype.retained = function() {
        return (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(this._treeChanges.retained, (0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("state")).map($8acc89dbd49ceaf2$var$stateSelf);
    };
    /**
     * Get the [[ViewConfig]]s associated with this Transition
     *
     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
     *
     * @param pathname the name of the path to fetch views for:
     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
     *
     * @returns a list of ViewConfig objects for the given path.
     */ Transition.prototype.views = function(pathname, state) {
        if (pathname === void 0) pathname = "entering";
        var path = this._treeChanges[pathname];
        path = !state ? path : path.filter((0, $b94057b5b409b0b1$export$78c65ad39408e96e)("state", state));
        return path.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("views")).filter((0, $abcc081e7f2a61c5$export$f0954fd7d5368655)).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
    };
    Transition.prototype.treeChanges = function(pathname) {
        return pathname ? this._treeChanges[pathname] : this._treeChanges;
    };
    /**
     * Creates a new transition that is a redirection of the current one.
     *
     * This transition can be returned from a [[TransitionService]] hook to
     * redirect a transition to a new state and/or set of parameters.
     *
     * @internal
     *
     * @returns Returns a new [[Transition]] instance.
     */ Transition.prototype.redirect = function(targetState) {
        var redirects = 1, trans = this;
        // tslint:disable-next-line:no-conditional-assignment
        while((trans = trans.redirectedFrom()) != null){
            if (++redirects > 20) throw new Error("Too many consecutive Transition redirects (20+)");
        }
        var redirectOpts = {
            redirectedFrom: this,
            source: "redirect"
        };
        // If the original transition was caused by URL sync, then use { location: 'replace' }
        // on the new transition (unless the target state explicitly specifies location: false).
        // This causes the original url to be replaced with the url for the redirect target
        // so the original url disappears from the browser history.
        if (this.options().source === "url" && targetState.options().location !== false) redirectOpts.location = "replace";
        var newOptions = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, this.options(), targetState.options(), redirectOpts);
        targetState = targetState.withOptions(newOptions, true);
        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
        var originalEnteringNodes = this._treeChanges.entering;
        var redirectEnteringNodes = newTransition._treeChanges.entering;
        // --- Re-use resolve data from original transition ---
        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
        // (because of the redirect), the resolves fetched by the original transition are still valid in the
        // redirected transition.
        //
        // This allows you to define a redirect on a parent state which depends on an async resolve value.
        // You can wait for the resolve, then redirect to a child state based on the result.
        // The redirected transition does not have to re-fetch the resolve.
        // ---------------------------------------------------------
        var nodeIsReloading = function(reloadState) {
            return function(node) {
                return reloadState && node.state.includes[reloadState.name];
            };
        };
        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
        var matchingEnteringNodes = (0, $50d81baac9264b80$export$39d3fc700b385dc4).matching(redirectEnteringNodes, originalEnteringNodes, (0, $50d81baac9264b80$export$39d3fc700b385dc4).nonDynamicParams).filter((0, $b94057b5b409b0b1$export$6003a5f097c73977)(nodeIsReloading(targetState.options().reloadState)));
        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
        matchingEnteringNodes.forEach(function(node, idx) {
            node.resolvables = originalEnteringNodes[idx].resolvables;
        });
        return newTransition;
    };
    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */ Transition.prototype._changedParams = function() {
        var tc = this._treeChanges;
        /** Return undefined if it's not a "dynamic" transition, for the following reasons */ // If user explicitly wants a reload
        if (this._options.reload) return undefined;
        // If any states are exiting or entering
        if (tc.exiting.length || tc.entering.length) return undefined;
        // If to/from path lengths differ
        if (tc.to.length !== tc.from.length) return undefined;
        // If the to/from paths are different
        var pathsDiffer = (0, $abcc081e7f2a61c5$export$ade9293c41c5aa01)(tc.to, tc.from).map(function(tuple) {
            return tuple[0].state !== tuple[1].state;
        }).reduce((0, $abcc081e7f2a61c5$export$a28cc26332787380), false);
        if (pathsDiffer) return undefined;
        // Find any parameter values that differ
        var nodeSchemas = tc.to.map(function(node) {
            return node.paramSchema;
        });
        var _a = [
            tc.to,
            tc.from
        ].map(function(path) {
            return path.map(function(x) {
                return x.paramValues;
            });
        }), toValues = _a[0], fromValues = _a[1];
        var tuples = (0, $abcc081e7f2a61c5$export$ade9293c41c5aa01)(nodeSchemas, toValues, fromValues);
        return tuples.map(function(_a) {
            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
            return (0, $e3df413894675dea$export$1ca45c9a47aec42c).changed(schema, toVals, fromVals);
        }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
    };
    /**
     * Returns true if the transition is dynamic.
     *
     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
     *
     * @returns true if the Transition is dynamic
     */ Transition.prototype.dynamic = function() {
        var changes = this._changedParams();
        return !changes ? false : changes.map(function(x) {
            return x.dynamic;
        }).reduce((0, $abcc081e7f2a61c5$export$a28cc26332787380), false);
    };
    /**
     * Returns true if the transition is ignored.
     *
     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
     *
     * @returns true if the Transition is ignored.
     */ Transition.prototype.ignored = function() {
        return !!this._ignoredReason();
    };
    /** @internal */ Transition.prototype._ignoredReason = function() {
        var pending = this.router.globals.transition;
        var reloadState = this._options.reloadState;
        var same = function(pathA, pathB) {
            if (pathA.length !== pathB.length) return false;
            var matching = (0, $50d81baac9264b80$export$39d3fc700b385dc4).matching(pathA, pathB);
            return pathA.length === matching.filter(function(node) {
                return !reloadState || !node.state.includes[reloadState.name];
            }).length;
        };
        var newTC = this.treeChanges();
        var pendTC = pending && pending.treeChanges();
        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting)) return "SameAsPending";
        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to)) return "SameAsCurrent";
    };
    /**
     * Runs the transition
     *
     * This method is generally called from the [[StateService.transitionTo]]
     *
     * @internal
     *
     * @returns a promise for a successful transition.
     */ Transition.prototype.run = function() {
        var _this = this;
        var runAllHooks = (0, $eab60650cc6e25be$export$dcf30b2235353599).runAllHooks;
        // Gets transition hooks array for the given phase
        var getHooksFor = function(phase) {
            return _this._hookBuilder.buildHooksForPhase(phase);
        };
        // When the chain is complete, then resolve or reject the deferred
        var transitionSuccess = function() {
            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceSuccess(_this.$to(), _this);
            _this.success = true;
            _this._deferred.resolve(_this.to());
            runAllHooks(getHooksFor((0, $f798ef43a419f893$export$9484030a489306a0).SUCCESS));
        };
        var transitionError = function(reason) {
            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceError(reason, _this);
            _this.success = false;
            _this._deferred.reject(reason);
            _this._error = reason;
            runAllHooks(getHooksFor((0, $f798ef43a419f893$export$9484030a489306a0).ERROR));
        };
        var runTransition = function() {
            // Wait to build the RUN hook chain until the BEFORE hooks are done
            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
            var allRunHooks = getHooksFor((0, $f798ef43a419f893$export$9484030a489306a0).RUN);
            var done = function() {
                return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(undefined);
            };
            return (0, $eab60650cc6e25be$export$dcf30b2235353599).invokeHooks(allRunHooks, done);
        };
        var startTransition = function() {
            var globals = _this.router.globals;
            globals.lastStartedTransitionId = _this.$id;
            globals.transition = _this;
            globals.transitionHistory.enqueue(_this);
            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceTransitionStart(_this);
            return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(undefined);
        };
        var allBeforeHooks = getHooksFor((0, $f798ef43a419f893$export$9484030a489306a0).BEFORE);
        (0, $eab60650cc6e25be$export$dcf30b2235353599).invokeHooks(allBeforeHooks, startTransition).then(runTransition).then(transitionSuccess, transitionError);
        return this.promise;
    };
    /**
     * Checks if the Transition is valid
     *
     * @returns true if the Transition is valid
     */ Transition.prototype.valid = function() {
        return !this.error() || this.success !== undefined;
    };
    /**
     * Aborts this transition
     *
     * Imperative API to abort a Transition.
     * This only applies to Transitions that are not yet complete.
     */ Transition.prototype.abort = function() {
        // Do not set flag if the transition is already complete
        if ((0, $c4ca6daaad7210ad$export$fce6876652108ab)(this.success)) this._aborted = true;
    };
    /**
     * The Transition error reason.
     *
     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
     *
     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
     */ Transition.prototype.error = function() {
        var state = this.$to();
        if (state.self.abstract) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).invalid("Cannot transition to abstract state '" + state.name + "'");
        var paramDefs = state.parameters();
        var values = this.params();
        var invalidParams = paramDefs.filter(function(param) {
            return !param.validates(values[param.id]);
        });
        if (invalidParams.length) {
            var invalidValues = invalidParams.map(function(param) {
                return "[" + param.id + ":" + (0, $48612b14b235e6fd$export$fac44ee5b035f737)(values[param.id]) + "]";
            }).join(", ");
            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
            return (0, $24ffb5fe12175fdd$export$a40146100efc171b).invalid(detail);
        }
        if (this.success === false) return this._error;
    };
    /**
     * A string representation of the Transition
     *
     * @returns A string representation of the Transition
     */ Transition.prototype.toString = function() {
        var fromStateOrName = this.from();
        var toStateOrName = this.to();
        var avoidEmptyHash = function(params) {
            return params["#"] !== null && params["#"] !== undefined ? params : (0, $abcc081e7f2a61c5$export$30a06c8d3562193f)(params, [
                "#"
            ]);
        };
        // (X) means the to state is invalid.
        var id = this.$id, from = (0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = (0, $48612b14b235e6fd$export$fac44ee5b035f737)(avoidEmptyHash(this._treeChanges.from.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("paramValues")).reduce((0, $abcc081e7f2a61c5$export$625f91792a536171), {}))), toValid = this.valid() ? "" : "(X) ", to = (0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = (0, $48612b14b235e6fd$export$fac44ee5b035f737)(avoidEmptyHash(this.params()));
        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
    };
    /** @internal */ Transition.diToken = Transition;
    return Transition;
}();











function $f8c80c317423f03a$var$quoteRegExp(str, param) {
    var surroundPattern = [
        "",
        ""
    ], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!param) return result;
    switch(param.squash){
        case false:
            surroundPattern = [
                "(",
                ")" + (param.isOptional ? "?" : "")
            ];
            break;
        case true:
            result = result.replace(/\/$/, "");
            surroundPattern = [
                "(?:/(",
                ")|/)?"
            ];
            break;
        default:
            surroundPattern = [
                "(" + param.squash + "|",
                ")?"
            ];
            break;
    }
    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
}
var $f8c80c317423f03a$var$memoizeTo = function(obj, _prop, fn) {
    return obj[_prop] = obj[_prop] || fn();
};
var $f8c80c317423f03a$var$splitOnSlash = (0, $48612b14b235e6fd$export$3a01864721f131f2)("/");
var $f8c80c317423f03a$var$defaultConfig = {
    state: {
        params: {}
    },
    strict: true,
    caseInsensitive: true,
    decodeParams: true
};
/**
 * Matches URLs against patterns.
 *
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL.
 *
 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
 * parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by [[UrlMatcher.exec]].
 *
 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
 * or colon placeholders (`/somePath/:param`).
 *
 * - *A parameter RegExp* may be defined for a param after a colon
 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
 * The regexp must match for the url to be matched.
 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
 *
 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
 *   See [[UrlMatcherFactory.type]] for more information.
 *
 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
 *   A catch-all * parameter value will contain the remainder of the URL.
 *
 * ---
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters).
 * A path parameter matches any number of characters other than '/'. For catch-all
 * placeholders the path parameter matches any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 */ var $f8c80c317423f03a$export$89107ed0938b0058 = /** @class */ function() {
    /**
     * @param pattern The pattern to compile into a matcher.
     * @param paramTypes The [[ParamTypes]] registry
     * @param paramFactory A [[ParamFactory]] object
     * @param config  A [[UrlMatcherCompileConfig]] configuration object
     */ function UrlMatcher(pattern, paramTypes, paramFactory, config) {
        var _this = this;
        /** @internal */ this._cache = {
            path: [
                this
            ]
        };
        /** @internal */ this._children = [];
        /** @internal */ this._params = [];
        /** @internal */ this._segments = [];
        /** @internal */ this._compiled = [];
        this.config = config = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(config, $f8c80c317423f03a$var$defaultConfig);
        this.pattern = pattern;
        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
        //   '*' name
        //   ':' name
        //   '{' name '}'
        //   '{' name ':' regexp '}'
        // The regular expression is somewhat complicated due to the need to allow curly braces
        // inside the regular expression. The placeholder regexp breaks down as follows:
        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
        //    [^{}\\]+                       - anything other than curly braces or backslash
        //    \\.                            - a backslash escape
        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
        var patterns = [];
        var last = 0;
        var matchArray;
        var checkParamErrors = function(id) {
            if (!UrlMatcher.nameValidator.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if ((0, $abcc081e7f2a61c5$export$71aa6c912b956294)(_this._params, (0, $b94057b5b409b0b1$export$78c65ad39408e96e)("id", id))) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
        };
        // Split into static segments separated by path parameter placeholders.
        // The number of segments is always 1 more than the number of parameters.
        var matchDetails = function(m, isSearch) {
            // IE[78] returns '' for unmatched groups instead of null
            var id = m[2] || m[3];
            var regexp = isSearch ? m[4] : m[4] || (m[1] === "*" ? "[\\s\\S]*" : null);
            var makeRegexpType = function(str) {
                return (0, $abcc081e7f2a61c5$export$4dc9a6b0ae3dfd2a)(paramTypes.type(isSearch ? "query" : "path"), {
                    pattern: new RegExp(str, _this.config.caseInsensitive ? "i" : undefined)
                });
            };
            return {
                id: id,
                regexp: regexp,
                segment: pattern.substring(last, m.index),
                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
            };
        };
        var details;
        var segment;
        // tslint:disable-next-line:no-conditional-assignment
        while(matchArray = placeholder.exec(pattern)){
            details = matchDetails(matchArray, false);
            if (details.segment.indexOf("?") >= 0) break; // we're into the search part
            checkParamErrors(details.id);
            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
            this._segments.push(details.segment);
            patterns.push([
                details.segment,
                (0, $abcc081e7f2a61c5$export$c01875f616615628)(this._params)
            ]);
            last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        // Find any search parameter names and remove them from the last segment
        var i = segment.indexOf("?");
        if (i >= 0) {
            var search = segment.substring(i);
            segment = segment.substring(0, i);
            if (search.length > 0) {
                last = 0;
                // tslint:disable-next-line:no-conditional-assignment
                while(matchArray = searchPlaceholder.exec(search)){
                    details = matchDetails(matchArray, true);
                    checkParamErrors(details.id);
                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
                    last = placeholder.lastIndex;
                // check if ?&
                }
            }
        }
        this._segments.push(segment);
        this._compiled = patterns.map(function(_pattern) {
            return $f8c80c317423f03a$var$quoteRegExp.apply(null, _pattern);
        }).concat($f8c80c317423f03a$var$quoteRegExp(segment));
    }
    /** @internal */ UrlMatcher.encodeDashes = function(str) {
        // Replace dashes with encoded "\-"
        return encodeURIComponent(str).replace(/-/g, function(c) {
            return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */ UrlMatcher.pathSegmentsAndParams = function(matcher) {
        var staticSegments = matcher._segments;
        var pathParams = matcher._params.filter(function(p) {
            return p.location === (0, $e3df413894675dea$export$aae266d0aede27d7).PATH;
        });
        return (0, $abcc081e7f2a61c5$export$ade9293c41c5aa01)(staticSegments, pathParams.concat(undefined)).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).filter(function(x) {
            return x !== "" && (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(x);
        });
    };
    /** @internal Given a matcher, return an array with the matcher's query params */ UrlMatcher.queryParams = function(matcher) {
        return matcher._params.filter(function(p) {
            return p.location === (0, $e3df413894675dea$export$aae266d0aede27d7).SEARCH;
        });
    };
    /**
     * Compare two UrlMatchers
     *
     * This comparison function converts a UrlMatcher into static and dynamic path segments.
     * Each static path segment is a static string between a path separator (slash character).
     * Each dynamic segment is a path parameter.
     *
     * The comparison function sorts static segments before dynamic ones.
     */ UrlMatcher.compare = function(a, b) {
        /**
         * Turn a UrlMatcher and all its parent matchers into an array
         * of slash literals '/', string literals, and Param objects
         *
         * This example matcher matches strings like "/foo/:param/tail":
         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
         *
         * Caches the result as `matcher._cache.segments`
         */ var segments = function(matcher) {
            return matcher._cache.segments = matcher._cache.segments || matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).reduce((0, $48612b14b235e6fd$export$10a23ad7eecfc1d8), []).map(function(x) {
                return (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(x) ? $f8c80c317423f03a$var$splitOnSlash(x) : x;
            }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
        };
        /**
         * Gets the sort weight for each segment of a UrlMatcher
         *
         * Caches the result as `matcher._cache.weights`
         */ var weights = function(matcher) {
            return matcher._cache.weights = matcher._cache.weights || segments(matcher).map(function(segment) {
                // Sort slashes first, then static strings, the Params
                if (segment === "/") return 1;
                if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(segment)) return 2;
                if (segment instanceof (0, $e3df413894675dea$export$1ca45c9a47aec42c)) return 3;
            });
        };
        /**
         * Pads shorter array in-place (mutates)
         */ var padArrays = function(l, r, padVal) {
            var len = Math.max(l.length, r.length);
            while(l.length < len)l.push(padVal);
            while(r.length < len)r.push(padVal);
        };
        var weightsA = weights(a), weightsB = weights(b);
        padArrays(weightsA, weightsB, 0);
        var _pairs = (0, $abcc081e7f2a61c5$export$ade9293c41c5aa01)(weightsA, weightsB);
        var cmp, i;
        for(i = 0; i < _pairs.length; i++){
            cmp = _pairs[i][0] - _pairs[i][1];
            if (cmp !== 0) return cmp;
        }
        return 0;
    };
    /**
     * Creates a new concatenated UrlMatcher
     *
     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
     *
     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
     */ UrlMatcher.prototype.append = function(url) {
        this._children.push(url);
        url._cache = {
            path: this._cache.path.concat(url),
            parent: this,
            pattern: null
        };
        return url;
    };
    /** @internal */ UrlMatcher.prototype.isRoot = function() {
        return this._cache.path[0] === this;
    };
    /** Returns the input pattern string */ UrlMatcher.prototype.toString = function() {
        return this.pattern;
    };
    UrlMatcher.prototype._getDecodedParamValue = function(value, param) {
        if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(value)) {
            if (this.config.decodeParams && !param.type.raw) {
                if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(value)) value = value.map(function(paramValue) {
                    return decodeURIComponent(paramValue);
                });
                else value = decodeURIComponent(value);
            }
            value = param.type.decode(value);
        }
        return param.value(value);
    };
    /**
     * Tests the specified url/path against this matcher.
     *
     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
     * parameter values.  Returns null if the path does not match.
     *
     * The returned object contains the values
     * of any search parameters that are mentioned in the pattern, but their value may be null if
     * they are not present in `search`. This means that search parameters are always treated
     * as optional.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
     *   x: '1', q: 'hello'
     * });
     * // returns { id: 'bob', q: 'hello', r: null }
     * ```
     *
     * @param path    The URL path to match, e.g. `$location.path()`.
     * @param search  URL search parameters, e.g. `$location.search()`.
     * @param hash    URL hash e.g. `$location.hash()`.
     * @param options
     *
     * @returns The captured parameter values.
     */ UrlMatcher.prototype.exec = function(path, search, hash, options) {
        var _this = this;
        if (search === void 0) search = {};
        if (options === void 0) options = {};
        var match = $f8c80c317423f03a$var$memoizeTo(this._cache, "pattern", function() {
            return new RegExp([
                "^",
                (0, $abcc081e7f2a61c5$export$d41cf2556b2767f1)(_this._cache.path.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("_compiled"))).join(""),
                _this.config.strict === false ? "/?" : "",
                "$"
            ].join(""), _this.config.caseInsensitive ? "i" : undefined);
        }).exec(path);
        if (!match) return null;
        // options = defaults(options, { isolate: false });
        var allParams = this.parameters(), pathParams = allParams.filter(function(param) {
            return !param.isSearch();
        }), searchParams = allParams.filter(function(param) {
            return param.isSearch();
        }), nPathSegments = this._cache.path.map(function(urlm) {
            return urlm._segments.length - 1;
        }).reduce(function(a, x) {
            return a + x;
        }), values = {};
        if (nPathSegments !== match.length - 1) throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
        function decodePathArray(paramVal) {
            var reverseString = function(str) {
                return str.split("").reverse().join("");
            };
            var unquoteDashes = function(str) {
                return str.replace(/\\-/g, "-");
            };
            var split = reverseString(paramVal).split(/-(?!\\)/);
            var allReversed = (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(split, reverseString);
            return (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(allReversed, unquoteDashes).reverse();
        }
        for(var i = 0; i < nPathSegments; i++){
            var param = pathParams[i];
            var value = match[i + 1];
            // if the param value matches a pre-replace pair, replace the value before decoding.
            for(var j = 0; j < param.replace.length; j++)if (param.replace[j].from === value) value = param.replace[j].to;
            if (value && param.array === true) value = decodePathArray(value);
            values[param.id] = this._getDecodedParamValue(value, param);
        }
        searchParams.forEach(function(param) {
            var value = search[param.id];
            for(var j = 0; j < param.replace.length; j++)if (param.replace[j].from === value) value = param.replace[j].to;
            values[param.id] = _this._getDecodedParamValue(value, param);
        });
        if (hash) values["#"] = hash;
        return values;
    };
    /**
     * @internal
     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
     *
     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
     *    pattern has no parameters, an empty array is returned.
     */ UrlMatcher.prototype.parameters = function(opts) {
        if (opts === void 0) opts = {};
        if (opts.inherit === false) return this._params;
        return (0, $abcc081e7f2a61c5$export$d41cf2556b2767f1)(this._cache.path.map(function(matcher) {
            return matcher._params;
        }));
    };
    /**
     * @internal
     * Returns a single parameter from this UrlMatcher by id
     *
     * @param id
     * @param opts
     * @returns {T|Param|any|boolean|UrlMatcher|null}
     */ UrlMatcher.prototype.parameter = function(id, opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var findParam = function() {
            for(var _i = 0, _a = _this._params; _i < _a.length; _i++){
                var param = _a[_i];
                if (param.id === id) return param;
            }
        };
        var parent = this._cache.parent;
        return findParam() || opts.inherit !== false && parent && parent.parameter(id, opts) || null;
    };
    /**
     * Validates the input parameter values against this UrlMatcher
     *
     * Checks an object hash of parameters to validate their correctness according to the parameter
     * types of this `UrlMatcher`.
     *
     * @param params The object hash of parameters to validate.
     * @returns Returns `true` if `params` validates, otherwise `false`.
     */ UrlMatcher.prototype.validates = function(params) {
        var validParamVal = function(param, val) {
            return !param || param.validates(val);
        };
        params = params || {};
        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
        var paramSchema = this.parameters().filter(function(paramDef) {
            return params.hasOwnProperty(paramDef.id);
        });
        return paramSchema.map(function(paramDef) {
            return validParamVal(paramDef, params[paramDef.id]);
        }).reduce((0, $abcc081e7f2a61c5$export$d1a75794f55e0c66), true);
    };
    /**
     * Given a set of parameter values, creates a URL from this UrlMatcher.
     *
     * Creates a URL that matches this pattern by substituting the specified values
     * for the path and search parameters.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
     * // returns '/user/bob?q=yes'
     * ```
     *
     * @param values  the values to substitute for the parameters in this pattern.
     * @returns the formatted URL (path and optionally search part).
     */ UrlMatcher.prototype.format = function(values) {
        if (values === void 0) values = {};
        // Build the full path of UrlMatchers (including all parent UrlMatchers)
        var urlMatchers = this._cache.path;
        // Extract all the static segments and Params (processed as ParamDetails)
        // into an ordered array
        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).map(function(x) {
            return (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(x) ? x : getDetails(x);
        });
        // Extract the query params into a separate array
        var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).map(getDetails);
        var isInvalid = function(param) {
            return param.isValid === false;
        };
        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) return null;
        /**
         * Given a Param, applies the parameter value, then returns detailed information about it
         */ function getDetails(param) {
            // Normalize to typed value
            var value = param.value(values[param.id]);
            var isValid = param.validates(value);
            var isDefaultValue = param.isDefaultValue(value);
            // Check if we're in squash mode for the parameter
            var squash = isDefaultValue ? param.squash : false;
            // Allow the Parameter's Type to encode the value
            var encoded = param.type.encode(value);
            return {
                param: param,
                value: value,
                isValid: isValid,
                isDefaultValue: isDefaultValue,
                squash: squash,
                encoded: encoded
            };
        }
        // Build up the path-portion from the list of static segments and parameters
        var pathString = pathSegmentsAndParams.reduce(function(acc, x) {
            // The element is a static segment (a raw string); just append it
            if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(x)) return acc + x;
            // Otherwise, it's a ParamDetails.
            var squash = x.squash, encoded = x.encoded, param = x.param;
            // If squash is === true, try to remove a slash from the path
            if (squash === true) return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
            // If squash is a string, use the string for the param value
            if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(squash)) return acc + squash;
            if (squash !== false) return acc; // ?
            if (encoded == null) return acc;
            // If this parameter value is an array, encode the value using encodeDashes
            if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(encoded)) return acc + (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(encoded, UrlMatcher.encodeDashes).join("-");
            // If the parameter type is "raw", then do not encodeURIComponent
            if (param.raw) return acc + encoded;
            // Encode the value
            return acc + encodeURIComponent(encoded);
        }, "");
        // Build the query string by applying parameter values (array or regular)
        // then mapping to key=value, then flattening and joining using "&"
        var queryString = queryParams.map(function(paramDetails) {
            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
            if (encoded == null || isDefaultValue && squash !== false) return;
            if (!(0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(encoded)) encoded = [
                encoded
            ];
            if (encoded.length === 0) return;
            if (!param.raw) encoded = (0, $abcc081e7f2a61c5$export$871de8747c9eaa88)(encoded, encodeURIComponent);
            return encoded.map(function(val) {
                return param.id + "=" + val;
            });
        }).filter((0, $abcc081e7f2a61c5$export$f0954fd7d5368655)).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).join("&");
        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
        return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
    };
    /** @internal */ UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
    return UrlMatcher;
}();



var $f8904b4480879991$var$__assign = undefined && undefined.__assign || function() {
    $f8904b4480879991$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8904b4480879991$var$__assign.apply(this, arguments);
};
var $f8904b4480879991$export$6f4a6a20aa7fb615 = /** @class */ function() {
    function ParamFactory(router) {
        this.router = router;
    }
    ParamFactory.prototype.fromConfig = function(id, type, state) {
        return new (0, $e3df413894675dea$export$1ca45c9a47aec42c)(id, type, (0, $e3df413894675dea$export$aae266d0aede27d7).CONFIG, this.router.urlService.config, state);
    };
    ParamFactory.prototype.fromPath = function(id, type, state) {
        return new (0, $e3df413894675dea$export$1ca45c9a47aec42c)(id, type, (0, $e3df413894675dea$export$aae266d0aede27d7).PATH, this.router.urlService.config, state);
    };
    ParamFactory.prototype.fromSearch = function(id, type, state) {
        return new (0, $e3df413894675dea$export$1ca45c9a47aec42c)(id, type, (0, $e3df413894675dea$export$aae266d0aede27d7).SEARCH, this.router.urlService.config, state);
    };
    return ParamFactory;
}();
/**
 * Factory for [[UrlMatcher]] instances.
 *
 * The factory is available to ng1 services as
 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
 */ var $f8904b4480879991$export$edd9e9bf3413d526 = /** @class */ function() {
    // TODO: move implementations to UrlConfig (urlService.config)
    function UrlMatcherFactory(/** @internal */ router) {
        var _this = this;
        this.router = router;
        /** Creates a new [[Param]] for a given location (DefType) */ this.paramFactory = new $f8904b4480879991$export$6f4a6a20aa7fb615(this.router);
        // TODO: Check if removal of this will break anything, then remove these
        this.UrlMatcher = (0, $f8c80c317423f03a$export$89107ed0938b0058);
        this.Param = (0, $e3df413894675dea$export$1ca45c9a47aec42c);
        /** @deprecated use [[UrlConfig.caseInsensitive]] */ this.caseInsensitive = function(value) {
            return _this.router.urlService.config.caseInsensitive(value);
        };
        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */ this.defaultSquashPolicy = function(value) {
            return _this.router.urlService.config.defaultSquashPolicy(value);
        };
        /** @deprecated use [[UrlConfig.strictMode]] */ this.strictMode = function(value) {
            return _this.router.urlService.config.strictMode(value);
        };
        /** @deprecated use [[UrlConfig.type]] */ this.type = function(name, definition, definitionFn) {
            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
        };
    }
    /**
     * Creates a [[UrlMatcher]] for the specified pattern.
     *
     * @param pattern  The URL pattern.
     * @param config  The config object hash.
     * @returns The UrlMatcher.
     */ UrlMatcherFactory.prototype.compile = function(pattern, config) {
        var urlConfig = this.router.urlService.config;
        // backward-compatible support for config.params -> config.state.params
        var params = config && !config.state && config.params;
        config = params ? $f8904b4480879991$var$__assign({
            state: {
                params: params
            }
        }, config) : config;
        var globalConfig = {
            strict: urlConfig._isStrictMode,
            caseInsensitive: urlConfig._isCaseInsensitive,
            decodeParams: urlConfig._decodeParams
        };
        return new (0, $f8c80c317423f03a$export$89107ed0938b0058)(pattern, urlConfig.paramTypes, this.paramFactory, (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(globalConfig, config));
    };
    /**
     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
     *
     * @param object  The object to perform the type check against.
     * @returns `true` if the object matches the `UrlMatcher` interface, by
     *          implementing all the same methods.
     */ UrlMatcherFactory.prototype.isMatcher = function(object) {
        // TODO: typeof?
        if (!(0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(object)) return false;
        var result = true;
        (0, $abcc081e7f2a61c5$export$4b80e395e36b5a56)((0, $f8c80c317423f03a$export$89107ed0938b0058).prototype, function(val, name) {
            if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(val)) result = result && (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(object[name]) && (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(object[name]);
        });
        return result;
    };
    /** @internal */ UrlMatcherFactory.prototype.$get = function() {
        var urlConfig = this.router.urlService.config;
        urlConfig.paramTypes.enqueue = false;
        urlConfig.paramTypes._flushTypeQueue();
        return this;
    };
    return UrlMatcherFactory;
}();








/**
 * Creates a [[UrlRule]]
 *
 * Creates a [[UrlRule]] from a:
 *
 * - `string`
 * - [[UrlMatcher]]
 * - `RegExp`
 * - [[StateObject]]
 */ var $12fa046c73b69b6a$export$d145ab8d1e9b50f9 = /** @class */ function() {
    function UrlRuleFactory(router) {
        this.router = router;
    }
    UrlRuleFactory.prototype.compile = function(str) {
        return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function(what, handler) {
        var _this = this;
        var isState = (0, $f1013b6b1a4d5acc$export$d02a9edeffca715).isState, isStateDeclaration = (0, $f1013b6b1a4d5acc$export$d02a9edeffca715).isStateDeclaration;
        var makeRule = (0, $b94057b5b409b0b1$export$24f82734ea047e6f)([
            [
                (0, $c4ca6daaad7210ad$export$844ec244b1367d54),
                function(_what) {
                    return makeRule(_this.compile(_what));
                }
            ],
            [
                (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $f8c80c317423f03a$export$89107ed0938b0058)),
                function(_what) {
                    return _this.fromUrlMatcher(_what, handler);
                }
            ],
            [
                (0, $b94057b5b409b0b1$export$252bb8b3bbdf6749)(isState, isStateDeclaration),
                function(_what) {
                    return _this.fromState(_what, _this.router);
                }
            ],
            [
                (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)(RegExp),
                function(_what) {
                    return _this.fromRegExp(_what, handler);
                }
            ],
            [
                (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54),
                function(_what) {
                    return new $12fa046c73b69b6a$export$9b375b0bfe49c581(_what, handler);
                }
            ]
        ]);
        var rule = makeRule(what);
        if (!rule) throw new Error("invalid 'what' in when()");
        return rule;
    };
    /**
     * A UrlRule which matches based on a UrlMatcher
     *
     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     *
     * ## Handler as UrlMatcher
     *
     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
     * The url is replaced with the result.
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var handler = $umf.compile("/home/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     */ UrlRuleFactory.prototype.fromUrlMatcher = function(urlMatcher, handler) {
        var _handler = handler;
        if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(handler)) handler = this.router.urlMatcherFactory.compile(handler);
        if ((0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $f8c80c317423f03a$export$89107ed0938b0058))(handler)) _handler = function(match) {
            return handler.format(match);
        };
        function matchUrlParamters(url) {
            var params = urlMatcher.exec(url.path, url.search, url.hash);
            return urlMatcher.validates(params) && params;
        }
        // Prioritize URLs, lowest to highest:
        // - Some optional URL parameters, but none matched
        // - No optional parameters in URL
        // - Some optional parameters, some matched
        // - Some optional parameters, all matched
        function matchPriority(params) {
            var optional = urlMatcher.parameters().filter(function(param) {
                return param.isOptional;
            });
            if (!optional.length) return 0.000001;
            var matched = optional.filter(function(param) {
                return params[param.id];
            });
            return matched.length / optional.length;
        }
        var details = {
            urlMatcher: urlMatcher,
            matchPriority: matchPriority,
            type: "URLMATCHER"
        };
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(new $12fa046c73b69b6a$export$9b375b0bfe49c581(matchUrlParamters, _handler), details);
    };
    /**
     * A UrlRule which matches a state by its url
     *
     * #### Example:
     * ```js
     * var rule = factory.fromState($state.get('foo'), router);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match);
     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
     * ```
     */ UrlRuleFactory.prototype.fromState = function(stateOrDecl, router) {
        var state = (0, $f1013b6b1a4d5acc$export$d02a9edeffca715).isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
        /**
         * Handles match by transitioning to matched state
         *
         * First checks if the router should start a new transition.
         * A new transition is not required if the current state's URL
         * and the new URL are already identical
         */ var handler = function(match) {
            var $state = router.stateService;
            var globals = router.globals;
            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) $state.transitionTo(state, match, {
                inherit: true,
                source: "url"
            });
        };
        var details = {
            state: state,
            type: "STATE"
        };
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(this.fromUrlMatcher(state.url, handler), details);
    };
    /**
     * A UrlRule which matches based on a regular expression
     *
     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - regexp match array (from `regexp`)
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     *
     * ## Handler as string
     *
     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
     * The string is first interpolated using `string.replace()` style pattern.
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     */ UrlRuleFactory.prototype.fromRegExp = function(regexp, handler) {
        if (regexp.global || regexp.sticky) throw new Error("Rule RegExp must not be global or sticky");
        /**
         * If handler is a string, the url will be replaced by the string.
         * If the string has any String.replace() style variables in it (like `$2`),
         * they will be replaced by the captures from [[match]]
         */ var redirectUrlTo = function(match) {
            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
            return handler.replace(/\$(\$|\d{1,2})/, function(m, what) {
                return match[what === "$" ? 0 : Number(what)];
            });
        };
        var _handler = (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(handler) ? redirectUrlTo : handler;
        var matchParamsFromRegexp = function(url) {
            return regexp.exec(url.path);
        };
        var details = {
            regexp: regexp,
            type: "REGEXP"
        };
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(new $12fa046c73b69b6a$export$9b375b0bfe49c581(matchParamsFromRegexp, _handler), details);
    };
    UrlRuleFactory.isUrlRule = function(obj) {
        return obj && [
            "type",
            "match",
            "handler"
        ].every(function(key) {
            return (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(obj[key]);
        });
    };
    return UrlRuleFactory;
}();
/**
 * A base rule which calls `match`
 *
 * The value from the `match` function is passed through to the `handler`.
 * @internal
 */ var $12fa046c73b69b6a$export$9b375b0bfe49c581 = /** @class */ function() {
    function BaseUrlRule(match, handler) {
        var _this = this;
        this.match = match;
        this.type = "RAW";
        this.matchPriority = function(match) {
            return 0 - _this.$id;
        };
        this.handler = handler || (0, $abcc081e7f2a61c5$export$f0954fd7d5368655);
    }
    return BaseUrlRule;
}();


function $2bb533e8e1ca30f6$var$appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === "/") return url;
    if (isHtml5) return (0, $48612b14b235e6fd$export$356e6f9ad5e3a83c)(baseHref) + url;
    if (absolute) return baseHref.slice(1) + url;
    return url;
}
/**
 * Updates URL and responds to URL changes
 *
 * ### Deprecation warning:
 * This class is now considered to be an internal API
 * Use the [[UrlService]] instead.
 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
 */ var $2bb533e8e1ca30f6$export$7a87032517a0a658 = /** @class */ function() {
    /** @internal */ function UrlRouter(/** @internal */ router) {
        var _this = this;
        this.router = router;
        // Delegate these calls to [[UrlService]]
        /** @deprecated use [[UrlService.sync]]*/ this.sync = function(evt) {
            return _this.router.urlService.sync(evt);
        };
        /** @deprecated use [[UrlService.listen]]*/ this.listen = function(enabled) {
            return _this.router.urlService.listen(enabled);
        };
        /** @deprecated use [[UrlService.deferIntercept]]*/ this.deferIntercept = function(defer) {
            return _this.router.urlService.deferIntercept(defer);
        };
        /** @deprecated use [[UrlService.match]]*/ this.match = function(urlParts) {
            return _this.router.urlService.match(urlParts);
        };
        // Delegate these calls to [[UrlRules]]
        /** @deprecated use [[UrlRules.initial]]*/ this.initial = function(handler) {
            return _this.router.urlService.rules.initial(handler);
        };
        /** @deprecated use [[UrlRules.otherwise]]*/ this.otherwise = function(handler) {
            return _this.router.urlService.rules.otherwise(handler);
        };
        /** @deprecated use [[UrlRules.removeRule]]*/ this.removeRule = function(rule) {
            return _this.router.urlService.rules.removeRule(rule);
        };
        /** @deprecated use [[UrlRules.rule]]*/ this.rule = function(rule) {
            return _this.router.urlService.rules.rule(rule);
        };
        /** @deprecated use [[UrlRules.rules]]*/ this.rules = function() {
            return _this.router.urlService.rules.rules();
        };
        /** @deprecated use [[UrlRules.sort]]*/ this.sort = function(compareFn) {
            return _this.router.urlService.rules.sort(compareFn);
        };
        /** @deprecated use [[UrlRules.when]]*/ this.when = function(matcher, handler, options) {
            return _this.router.urlService.rules.when(matcher, handler, options);
        };
        this.urlRuleFactory = new (0, $12fa046c73b69b6a$export$d145ab8d1e9b50f9)(router);
    }
    /** Internal API. */ UrlRouter.prototype.update = function(read) {
        var $url = this.router.locationService;
        if (read) {
            this.location = $url.url();
            return;
        }
        if ($url.url() === this.location) return;
        $url.url(this.location, true);
    };
    /**
     * Internal API.
     *
     * Pushes a new location to the browser history.
     *
     * @internal
     * @param urlMatcher
     * @param params
     * @param options
     */ UrlRouter.prototype.push = function(urlMatcher, params, options) {
        var replace = options && !!options.replace;
        this.router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    /**
     * Builds and returns a URL with interpolated parameters
     *
     * #### Example:
     * ```js
     * matcher = $umf.compile("/about/:person");
     * params = { person: "bob" };
     * $bob = $urlRouter.href(matcher, params);
     * // $bob == "/about/bob";
     * ```
     *
     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
     * @param params An object of parameter values to fill the matcher's required parameters.
     * @param options Options object. The options are:
     *
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
     */ UrlRouter.prototype.href = function(urlMatcher, params, options) {
        var url = urlMatcher.format(params);
        if (url == null) return null;
        options = options || {
            absolute: false
        };
        var cfg = this.router.urlService.config;
        var isHtml5 = cfg.html5Mode();
        if (!isHtml5 && url !== null) url = "#" + cfg.hashPrefix() + url;
        url = $2bb533e8e1ca30f6$var$appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
        if (!options.absolute || !url) return url;
        var slash = !isHtml5 && url ? "/" : "";
        var cfgPort = cfg.port();
        var port = cfgPort === 80 || cfgPort === 443 ? "" : ":" + cfgPort;
        return [
            cfg.protocol(),
            "://",
            cfg.host(),
            port,
            slash,
            url
        ].join("");
    };
    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
        /** @deprecated use [[UrlService.interceptDeferred]]*/ get: function() {
            return this.router.urlService.interceptDeferred;
        },
        enumerable: false,
        configurable: true
    });
    return UrlRouter;
}();







/**
 * The View service
 *
 * This service pairs existing `ui-view` components (which live in the DOM)
 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
 *
 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
 *   The views from exited states are deactivated via [[deactivateViewConfig]].
 *   (See: the [[registerActivateViews]] Transition Hook)
 *
 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
 *
 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
 * are configured with the matching [[ViewConfig]](s)
 *
 */ var $f6ae7a2c459ed9f6$export$e5cb1ae026d0fe73 = /** @class */ function() {
    /** @internal */ function ViewService(/** @internal */ router) {
        var _this = this;
        this.router = router;
        /** @internal */ this._uiViews = [];
        /** @internal */ this._viewConfigs = [];
        /** @internal */ this._viewConfigFactories = {};
        /** @internal */ this._listeners = [];
        /** @internal */ this._pluginapi = {
            _rootViewContext: this._rootViewContext.bind(this),
            _viewConfigFactory: this._viewConfigFactory.bind(this),
            _registeredUIView: function(id) {
                return (0, $abcc081e7f2a61c5$export$71aa6c912b956294)(_this._uiViews, function(view) {
                    return _this.router.$id + "." + view.id === id;
                });
            },
            _registeredUIViews: function() {
                return _this._uiViews;
            },
            _activeViewConfigs: function() {
                return _this._viewConfigs;
            },
            _onSync: function(listener) {
                _this._listeners.push(listener);
                return function() {
                    return (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(_this._listeners, listener);
                };
            }
        };
    }
    /**
     * Normalizes a view's name from a state.views configuration block.
     *
     * This should be used by a framework implementation to calculate the values for
     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
     *
     * @param context the context object (state declaration) that the view belongs to
     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
     *
     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
     */ ViewService.normalizeUIViewTarget = function(context, rawViewName) {
        if (rawViewName === void 0) rawViewName = "";
        // TODO: Validate incoming view name with a regexp to allow:
        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
        var viewAtContext = rawViewName.split("@");
        var uiViewName = viewAtContext[0] || "$default"; // default to unnamed view
        var uiViewContextAnchor = (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(viewAtContext[1]) ? viewAtContext[1] : "^"; // default to parent context
        // Handle relative view-name sugar syntax.
        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
        if (relativeViewNameSugar) {
            // Clobbers existing contextAnchor (rawViewName validation will fix this)
            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
        }
        if (uiViewName.charAt(0) === "!") {
            uiViewName = uiViewName.substr(1);
            uiViewContextAnchor = ""; // target absolutely from root
        }
        // handle parent relative targeting "^.^.^"
        var relativeMatch = /^(\^(?:\.\^)*)$/;
        if (relativeMatch.exec(uiViewContextAnchor)) {
            var anchorState = uiViewContextAnchor.split(".").reduce(function(anchor, x) {
                return anchor.parent;
            }, context);
            uiViewContextAnchor = anchorState.name;
        } else if (uiViewContextAnchor === ".") uiViewContextAnchor = context.name;
        return {
            uiViewName: uiViewName,
            uiViewContextAnchor: uiViewContextAnchor
        };
    };
    /** @internal */ ViewService.prototype._rootViewContext = function(context) {
        return this._rootContext = context || this._rootContext;
    };
    /** @internal */ ViewService.prototype._viewConfigFactory = function(viewType, factory) {
        this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function(path, decl) {
        var cfgFactory = this._viewConfigFactories[decl.$type];
        if (!cfgFactory) throw new Error("ViewService: No view config factory registered for type " + decl.$type);
        var cfgs = cfgFactory(path, decl);
        return (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(cfgs) ? cfgs : [
            cfgs
        ];
    };
    /**
     * Deactivates a ViewConfig.
     *
     * This function deactivates a `ViewConfig`.
     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
     *
     * @param viewConfig The ViewConfig view to deregister.
     */ ViewService.prototype.deactivateViewConfig = function(viewConfig) {
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceEvent("<- Removing", viewConfig);
        (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function(viewConfig) {
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceEvent("-> Registering", viewConfig);
        this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function() {
        var _this = this;
        var uiViewsByFqn = this._uiViews.map(function(uiv) {
            return [
                uiv.fqn,
                uiv
            ];
        }).reduce((0, $abcc081e7f2a61c5$export$448afb43435ef71e), {});
        // Return a weighted depth value for a uiView.
        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
        // plus the depth of the state that is populating the uiView
        function uiViewDepth(uiView) {
            var stateDepth = function(context) {
                return context && context.parent ? stateDepth(context.parent) + 1 : 1;
            };
            return uiView.fqn.split(".").length * 10000 + stateDepth(uiView.creationContext);
        }
        // Return the ViewConfig's context's depth in the context tree.
        function viewConfigDepth(config) {
            var context = config.viewDecl.$context, count = 0;
            while(++count && context.parent)context = context.parent;
            return count;
        }
        // Given a depth function, returns a compare function which can return either ascending or descending order
        var depthCompare = (0, $b94057b5b409b0b1$export$c3095a23b368d1f2)(function(depthFn, posNeg, left, right) {
            return posNeg * (depthFn(left) - depthFn(right));
        });
        var matchingConfigPair = function(uiView) {
            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
            if (matchingConfigs.length > 1) // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
            // Sort by depth and return the match from the deepest child
            // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
            matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
            return {
                uiView: uiView,
                viewConfig: matchingConfigs[0]
            };
        };
        var configureUIView = function(tuple) {
            // If a parent ui-view is reconfigured, it could destroy child ui-views.
            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
            if (_this._uiViews.indexOf(tuple.uiView) !== -1) tuple.uiView.configUpdated(tuple.viewConfig);
        };
        // Sort views by FQN and state depth. Process uiviews nearest the root first.
        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
        var matchedViewConfigs = uiViewTuples.map(function(tuple) {
            return tuple.viewConfig;
        });
        var unmatchedConfigTuples = this._viewConfigs.filter(function(config) {
            return !(0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(matchedViewConfigs, config);
        }).map(function(viewConfig) {
            return {
                uiView: undefined,
                viewConfig: viewConfig
            };
        });
        uiViewTuples.forEach(configureUIView);
        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
        this._listeners.forEach(function(cb) {
            return cb(allTuples);
        });
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewSync(allTuples);
    };
    /**
     * Registers a `ui-view` component
     *
     * When a `ui-view` component is created, it uses this method to register itself.
     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
     *
     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
     * and what the view's state context is.
     *
     * Note: There is no corresponding `deregisterUIView`.
     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
     *
     * @param uiView The metadata for a UIView
     * @return a de-registration function used when the view is destroyed.
     */ ViewService.prototype.registerUIView = function(uiView) {
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceUIViewEvent("-> Registering", uiView);
        var uiViews = this._uiViews;
        var fqnAndTypeMatches = function(uiv) {
            return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type;
        };
        if (uiViews.filter(fqnAndTypeMatches).length) (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
        uiViews.push(uiView);
        this.sync();
        return function() {
            var idx = uiViews.indexOf(uiView);
            if (idx === -1) {
                (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
                return;
            }
            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceUIViewEvent("<- Deregistering", uiView);
            (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(uiViews)(uiView);
        };
    };
    /**
     * Returns the list of views currently available on the page, by fully-qualified name.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */ ViewService.prototype.available = function() {
        return this._uiViews.map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("fqn"));
    };
    /**
     * Returns the list of views on the page containing loaded content.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */ ViewService.prototype.active = function() {
        return this._uiViews.filter((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("$config")).map((0, $b94057b5b409b0b1$export$977f3f6a9323c0f6)("name"));
    };
    /**
     * Given a ui-view and a ViewConfig, determines if they "match".
     *
     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
     *
     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
     *
     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
     *
     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
     * - the ui-view's name matches the ViewConfig's target name
     * - the ui-view's context matches the ViewConfig's anchor
     *
     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
     * - There exists a parent ui-view where:
     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
     *    - the parent ui-view's context matches the ViewConfig's anchor
     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
     *
     * Example:
     *
     * DOM:
     * <ui-view>                        <!-- created in the root context (name: "") -->
     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
     *       </ui-view>
     *     </ui-view>
     *   </ui-view>
     * </ui-view>
     *
     * uiViews: [
     *  { fqn: "$default",                  creationContext: { name: "" } },
     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
     * ]
     *
     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
     *
     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
     *
     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
     *   the tail of the ui-view's fqn "default.bar"
     *
     * @internal
     */ ViewService.matches = function(uiViewsByFqn, uiView) {
        return function(viewConfig) {
            // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
            if (uiView.$type !== viewConfig.viewDecl.$type) return false;
            // Split names apart from both viewConfig and uiView into segments
            var vc = viewConfig.viewDecl;
            var vcSegments = vc.$uiViewName.split(".");
            var uivSegments = uiView.fqn.split(".");
            // Check if the tails of the segment arrays match. ex, these arrays' tails match:
            // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
            if (!(0, $abcc081e7f2a61c5$export$e9bab7fafb253603)(vcSegments, uivSegments.slice(0 - vcSegments.length))) return false;
            // Now check if the fqn ending at the first segment of the viewConfig matches the context:
            // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
            var negOffset = 1 - vcSegments.length || undefined;
            var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
            var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
            return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
        };
    };
    return ViewService;
}();






/**
 * Global router state
 *
 * This is where we hold the global mutable state such as current state, current
 * params, current transition, etc.
 */ var $508859f5cddf2adc$export$64da63b9cd8aa371 = /** @class */ function() {
    function UIRouterGlobals() {
        /**
         * Current parameter values
         *
         * The parameter values from the latest successful transition
         */ this.params = new (0, $faa504ce7583dd9b$export$2efb2ee9027f89bc)();
        /** @internal */ this.lastStartedTransitionId = -1;
        /** @internal */ this.transitionHistory = new (0, $1ccfe5f6108c2c49$export$3dc07afe418952bc)([], 1);
        /** @internal */ this.successfulTransitions = new (0, $1ccfe5f6108c2c49$export$3dc07afe418952bc)([], 1);
    }
    UIRouterGlobals.prototype.dispose = function() {
        this.transitionHistory.clear();
        this.successfulTransitions.clear();
        this.transition = null;
    };
    return UIRouterGlobals;
}();









var $38257bccd642c860$var$prioritySort = function(a, b) {
    return (b.priority || 0) - (a.priority || 0);
};
var $38257bccd642c860$var$typeSort = function(a, b) {
    var weights = {
        STATE: 4,
        URLMATCHER: 4,
        REGEXP: 3,
        RAW: 2,
        OTHER: 1
    };
    return (weights[a.type] || 0) - (weights[b.type] || 0);
};
var $38257bccd642c860$var$urlMatcherSort = function(a, b) {
    return !a.urlMatcher || !b.urlMatcher ? 0 : (0, $f8c80c317423f03a$export$89107ed0938b0058).compare(a.urlMatcher, b.urlMatcher);
};
var $38257bccd642c860$var$idSort = function(a, b) {
    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
    var useMatchPriority = {
        STATE: true,
        URLMATCHER: true
    };
    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
};
/**
 * Default rule priority sorting function.
 *
 * Sorts rules by:
 *
 * - Explicit priority (set rule priority using [[UrlRules.when]])
 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
 * - Rule registration order (for rule types other than STATE and URLMATCHER)
 *   - Equally sorted State and UrlMatcher rules will each match the URL.
 *     Then, the *best* match is chosen based on how many parameter values were matched.
 */ var $38257bccd642c860$var$defaultRuleSortFn;
$38257bccd642c860$var$defaultRuleSortFn = function(a, b) {
    var cmp = $38257bccd642c860$var$prioritySort(a, b);
    if (cmp !== 0) return cmp;
    cmp = $38257bccd642c860$var$typeSort(a, b);
    if (cmp !== 0) return cmp;
    cmp = $38257bccd642c860$var$urlMatcherSort(a, b);
    if (cmp !== 0) return cmp;
    return $38257bccd642c860$var$idSort(a, b);
};
function $38257bccd642c860$var$getHandlerFn(handler) {
    if (!(0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(handler) && !(0, $c4ca6daaad7210ad$export$844ec244b1367d54)(handler) && !(0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac))(handler) && !(0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac).isDef(handler)) throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
    return (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(handler) ? handler : (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(handler);
}
/**
 * API for managing URL rules
 *
 * This API is used to create and manage URL rules.
 * URL rules are a mechanism to respond to specific URL patterns.
 *
 * The most commonly used methods are [[otherwise]] and [[when]].
 *
 * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
 */ var $38257bccd642c860$export$62d4dd8d4c104a6e = /** @class */ function() {
    /** @internal */ function UrlRules(/** @internal */ router) {
        this.router = router;
        /** @internal */ this._sortFn = $38257bccd642c860$var$defaultRuleSortFn;
        /** @internal */ this._rules = [];
        /** @internal */ this._id = 0;
        this.urlRuleFactory = new (0, $12fa046c73b69b6a$export$d145ab8d1e9b50f9)(router);
    }
    /** @internal */ UrlRules.prototype.dispose = function(router) {
        this._rules = [];
        delete this._otherwiseFn;
    };
    /**
     * Defines the initial state, path, or behavior to use when the app starts.
     *
     * This rule defines the initial/starting state for the application.
     *
     * This rule is triggered the first time the URL is checked (when the app initially loads).
     * The rule is triggered only when the url matches either `""` or `"/"`.
     *
     * Note: The rule is intended to be used when the root of the application is directly linked to.
     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
     * This allows 404-like behavior when an unknown URL is deep-linked.
     *
     * #### Example:
     * Start app at `home` state.
     * ```js
     * .initial({ state: 'home' });
     * ```
     *
     * #### Example:
     * Start app at `/home` (by url)
     * ```js
     * .initial('/home');
     * ```
     *
     * #### Example:
     * When no other url rule matches, go to `home` state
     * ```js
     * .initial((matchValue, url, router) => {
     *   console.log('initial state');
     *   return { state: 'home' };
     * })
     * ```
     *
     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
     */ UrlRules.prototype.initial = function(handler) {
        var handlerFn = $38257bccd642c860$var$getHandlerFn(handler);
        var matchFn = function(urlParts, router) {
            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
        };
        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
    };
    /**
     * Defines the state, url, or behavior to use when no other rule matches the URL.
     *
     * This rule is matched when *no other rule* matches.
     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
     *
     * - If `handler` a string, it is treated as a url redirect
     *
     * #### Example:
     * When no other url rule matches, redirect to `/index`
     * ```js
     * .otherwise('/index');
     * ```
     *
     * - If `handler` is an object with a `state` property, the state is activated.
     *
     * #### Example:
     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
     * ```js
     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
     * ```
     *
     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
     *   The function can perform actions, and/or return a value.
     *
     * #### Example:
     * When no other url rule matches, manually trigger a transition to the `home` state
     * ```js
     * .otherwise((matchValue, urlParts, router) => {
     *   router.stateService.go('home');
     * });
     * ```
     *
     * #### Example:
     * When no other url rule matches, go to `home` state
     * ```js
     * .otherwise((matchValue, urlParts, router) => {
     *   return { state: 'home' };
     * });
     * ```
     *
     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
     */ UrlRules.prototype.otherwise = function(handler) {
        var handlerFn = $38257bccd642c860$var$getHandlerFn(handler);
        this._otherwiseFn = this.urlRuleFactory.create((0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(true), handlerFn);
        this._sorted = false;
    };
    /**
     * Remove a rule previously registered
     *
     * @param rule the matcher rule that was previously registered using [[rule]]
     */ UrlRules.prototype.removeRule = function(rule) {
        (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(this._rules, rule);
    };
    /**
     * Manually adds a URL Rule.
     *
     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
     *
     * A rule should have a `match` function which returns truthy if the rule matched.
     * It should also have a `handler` function which is invoked if the rule is the best match.
     *
     * @return a function that deregisters the rule
     */ UrlRules.prototype.rule = function(rule) {
        var _this = this;
        if (!(0, $12fa046c73b69b6a$export$d145ab8d1e9b50f9).isUrlRule(rule)) throw new Error("invalid rule");
        rule.$id = this._id++;
        rule.priority = rule.priority || 0;
        this._rules.push(rule);
        this._sorted = false;
        return function() {
            return _this.removeRule(rule);
        };
    };
    /**
     * Gets all registered rules
     *
     * @returns an array of all the registered rules
     */ UrlRules.prototype.rules = function() {
        this.ensureSorted();
        return this._rules.concat(this._otherwiseFn ? [
            this._otherwiseFn
        ] : []);
    };
    /**
     * Defines URL Rule priorities
     *
     * More than one rule ([[UrlRule]]) might match a given URL.
     * This `compareFn` is used to sort the rules by priority.
     * Higher priority rules should sort earlier.
     *
     * The [[defaultRuleSortFn]] is used by default.
     *
     * You only need to call this function once.
     * The `compareFn` will be used to sort the rules as each is registered.
     *
     * If called without any parameter, it will re-sort the rules.
     *
     * ---
     *
     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
     * The `$id` is is the order in which the rule was registered.
     *
     * The sort function should use these data, or data found on a specific type
     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
     *
     * #### Example:
     * This compare function prioritizes rules by the order in which the rules were registered.
     * A rule registered earlier has higher priority.
     *
     * ```js
     * function compareFn(a, b) {
     *   return a.$id - b.$id;
     * }
     * ```
     *
     * @param compareFn a function that compares to [[UrlRule]] objects.
     *    The `compareFn` should abide by the `Array.sort` compare function rules.
     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
     *    Return a positive number if `b` should be higher priority.
     *    Return `0` if the rules are identical.
     *
     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
     *    for details.
     */ UrlRules.prototype.sort = function(compareFn) {
        var sorted = this.stableSort(this._rules, this._sortFn = compareFn || this._sortFn);
        // precompute _sortGroup values and apply to each rule
        var group = 0;
        for(var i = 0; i < sorted.length; i++){
            sorted[i]._group = group;
            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) group++;
        }
        this._rules = sorted;
        this._sorted = true;
    };
    /** @internal */ UrlRules.prototype.ensureSorted = function() {
        this._sorted || this.sort();
    };
    /** @internal */ UrlRules.prototype.stableSort = function(arr, compareFn) {
        var arrOfWrapper = arr.map(function(elem, idx) {
            return {
                elem: elem,
                idx: idx
            };
        });
        arrOfWrapper.sort(function(wrapperA, wrapperB) {
            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
        });
        return arrOfWrapper.map(function(wrapper) {
            return wrapper.elem;
        });
    };
    /**
     * Registers a `matcher` and `handler` for custom URLs handling.
     *
     * The `matcher` can be:
     *
     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
     * - a `string`: The string is compiled to a [[UrlMatcher]]
     * - a `RegExp`: The regexp is used to match the url.
     *
     * The `handler` can be:
     *
     * - a string: The url is redirected to the value of the string.
     * - a function: The url is redirected to the return value of the function.
     *
     * ---
     *
     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
     * string is interpolated with parameter values.
     *
     * #### Example:
     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
     * ```js
     * .when("/foo/:param1", "/bar/:param1")
     * ```
     *
     * ---
     *
     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
     * interpolated with capture groups from the RegExp.
     *
     * #### Example:
     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
     * ```js
     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
     * ```
     *
     * ---
     *
     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
     * The "matched value" differs based on the `matcher`.
     * For [[UrlMatcher]]s, it will be the matched state params.
     * For `RegExp`, it will be the match array from `regexp.exec()`.
     *
     * If the handler returns a string, the URL is redirected to the string.
     *
     * #### Example:
     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
     * ```js
     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
     * ```
     *
     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
     *
     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
     * @param handler The path to redirect to, or a function that returns the path.
     * @param options `{ priority: number }`
     *
     * @return the registered [[UrlRule]]
     */ UrlRules.prototype.when = function(matcher, handler, options) {
        var rule = this.urlRuleFactory.create(matcher, handler);
        if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(options && options.priority)) rule.priority = options.priority;
        this.rule(rule);
        return rule;
    };
    return UrlRules;
}();




/**
 * An API to customize the URL behavior and retrieve URL configuration
 *
 * This API is used to customize the behavior of the URL.
 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
 * and custom parameter encoding (custom [[type]]).
 *
 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
 * This information can be used to build absolute URLs, such as
 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
 *
 * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
 */ var $2c9997be3c0514f7$export$3bb2e944ec43b345 = /** @class */ function() {
    /** @internal */ function UrlConfig(/** @internal */ router) {
        var _this = this;
        this.router = router;
        /** @internal */ this.paramTypes = new (0, $8b9194c340caefea$export$cec5485a2fbca8a3)();
        /** @internal */ this._decodeParams = true;
        /** @internal */ this._isCaseInsensitive = false;
        /** @internal */ this._isStrictMode = true;
        /** @internal */ this._defaultSquashPolicy = false;
        /** @internal */ this.dispose = function() {
            return _this.paramTypes.dispose();
        };
        // Delegate these calls to the current LocationConfig implementation
        /**
         * Gets the base Href, e.g., `http://localhost/approot/`
         *
         * @return the application's base href
         */ this.baseHref = function() {
            return _this.router.locationConfig.baseHref();
        };
        /**
         * Gets or sets the hashPrefix
         *
         * This only applies when not running in [[html5Mode]] (pushstate mode)
         *
         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
         *
         * @return the hash prefix
         */ this.hashPrefix = function(newprefix) {
            return _this.router.locationConfig.hashPrefix(newprefix);
        };
        /**
         * Gets the host, e.g., `localhost`
         *
         * @return the protocol
         */ this.host = function() {
            return _this.router.locationConfig.host();
        };
        /**
         * Returns true when running in pushstate mode
         *
         * @return true when running in html5 mode (pushstate mode).
         */ this.html5Mode = function() {
            return _this.router.locationConfig.html5Mode();
        };
        /**
         * Gets the port, e.g., `80`
         *
         * @return the port number
         */ this.port = function() {
            return _this.router.locationConfig.port();
        };
        /**
         * Gets the protocol, e.g., `http`
         *
         * @return the protocol
         */ this.protocol = function() {
            return _this.router.locationConfig.protocol();
        };
    }
    /**
     * Defines whether URL matching should be case sensitive (the default behavior), or not.
     *
     * #### Example:
     * ```js
     * // Allow case insensitive url matches
     * urlService.config.caseInsensitive(true);
     * ```
     *
     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
     * @returns the current value of caseInsensitive
     */ UrlConfig.prototype.caseInsensitive = function(value) {
        return this._isCaseInsensitive = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(value) ? value : this._isCaseInsensitive;
    };
    /**
     * Sets the default behavior when generating or matching URLs with default parameter values.
     *
     * #### Example:
     * ```js
     * // Remove default parameter values from the url
     * urlService.config.defaultSquashPolicy(true);
     * ```
     *
     * @param value A string that defines the default parameter URL squashing behavior.
     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
     *      the parameter value from the URL and replace it with this string.
     * @returns the current value of defaultSquashPolicy
     */ UrlConfig.prototype.defaultSquashPolicy = function(value) {
        if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(value) && value !== true && value !== false && !(0, $c4ca6daaad7210ad$export$844ec244b1367d54)(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
        return this._defaultSquashPolicy = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(value) ? value : this._defaultSquashPolicy;
    };
    /**
     * Defines whether URLs should match trailing slashes, or not (the default behavior).
     *
     * #### Example:
     * ```js
     * // Allow optional trailing slashes
     * urlService.config.strictMode(false);
     * ```
     *
     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
     * @returns the current value of strictMode
     */ UrlConfig.prototype.strictMode = function(value) {
        return this._isStrictMode = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(value) ? value : this._isStrictMode;
    };
    /**
     * Creates and registers a custom [[ParamType]] object
     *
     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
     *
     * #### Note: Register custom types *before using them* in a state definition.
     *
     * #### Example:
     * ```js
     * // Encode object parameter as JSON string
     * urlService.config.type('myjson', {
     *   encode: (obj) => JSON.stringify(obj),
     *   decode: (str) => JSON.parse(str),
     *   is: (val) => typeof(val) === 'object',
     *   pattern: /[^/]+/,
     *   equals: (a, b) => _.isEqual(a, b),
     * });
     * ```
     *
     * See [[ParamTypeDefinition]] for more examples
     *
     * @param name The type name.
     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
     * @param definitionFn A function that is injected before the app runtime starts.
     *        The result of this function should be a [[ParamTypeDefinition]].
     *        The result is merged into the existing `definition`.
     *        See [[ParamType]] for information on the values accepted.
     *
     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
     */ UrlConfig.prototype.type = function(name, definition, definitionFn) {
        var type = this.paramTypes.type(name, definition, definitionFn);
        return !(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(definition) ? type : this;
    };
    return UrlConfig;
}();



/**
 * API for URL management
 */ var $d40daad0844b912b$export$f2c3b6749c5bbbef = /** @class */ function() {
    /** @internal */ function UrlService(/** @internal */ router) {
        var _this = this;
        this.router = router;
        /** @internal */ this.interceptDeferred = false;
        /**
         * The nested [[UrlRules]] API for managing URL rules and rewrites
         *
         * See: [[UrlRules]] for details
         */ this.rules = new (0, $38257bccd642c860$export$62d4dd8d4c104a6e)(this.router);
        /**
         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
         *
         * See: [[UrlConfig]] for details
         */ this.config = new (0, $2c9997be3c0514f7$export$3bb2e944ec43b345)(this.router);
        // Delegate these calls to the current LocationServices implementation
        /**
         * Gets the current url, or updates the url
         *
         * ### Getting the current URL
         *
         * When no arguments are passed, returns the current URL.
         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
         *
         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
         * have a base HREF prepended ([[PushStateLocationServices]]).
         *
         * The raw URL in the browser might be:
         *
         * ```
         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
         * ```
         *
         * or
         *
         * ```
         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
         * ```
         *
         * then this method returns:
         *
         * ```
         * /internal/path/123?param1=foo#anchor
         * ```
         *
         *
         * #### Example:
         * ```js
         * locationServices.url(); // "/some/path?query=value#anchor"
         * ```
         *
         * ### Updating the URL
         *
         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
         *
         * #### Example:
         * ```js
         * locationServices.url("/some/path?query=value#anchor", true);
         * ```
         *
         * @param newurl The new value for the URL.
         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
         *               It should not include the protocol, site, port, or base path of an absolute HREF.
         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
         *
         * @return the url (after potentially being processed)
         */ this.url = function(newurl, replace, state) {
            return _this.router.locationService.url(newurl, replace, state);
        };
        /**
         * Gets the path part of the current url
         *
         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
         *
         * @return the path portion of the url
         */ this.path = function() {
            return _this.router.locationService.path();
        };
        /**
         * Gets the search part of the current url as an object
         *
         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
         *
         * @return the search (query) portion of the url, as an object
         */ this.search = function() {
            return _this.router.locationService.search();
        };
        /**
         * Gets the hash part of the current url
         *
         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
         *
         * @return the hash (anchor) portion of the url
         */ this.hash = function() {
            return _this.router.locationService.hash();
        };
        /**
         * @internal
         *
         * Registers a low level url change handler
         *
         * Note: Because this is a low level handler, it's not recommended for general use.
         *
         * #### Example:
         * ```js
         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
         * ```
         *
         * @param callback a function that will be called when the url is changing
         * @return a function that de-registers the callback
         */ this.onChange = function(callback) {
            return _this.router.locationService.onChange(callback);
        };
    }
    /** @internal */ UrlService.prototype.dispose = function() {
        this.listen(false);
        this.rules.dispose();
    };
    /**
     * Gets the current URL parts
     *
     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
     */ UrlService.prototype.parts = function() {
        return {
            path: this.path(),
            search: this.search(),
            hash: this.hash()
        };
    };
    /**
     * Activates the best rule for the current URL
     *
     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
     * This method is called internally any time the URL has changed.
     *
     * This effectively activates the state (or redirect, etc) which matches the current URL.
     *
     * #### Example:
     * ```js
     * urlService.deferIntercept();
     *
     * fetch('/states.json').then(resp => resp.json()).then(data => {
     *   data.forEach(state => $stateRegistry.register(state));
     *   urlService.listen();
     *   // Find the matching URL and invoke the handler.
     *   urlService.sync();
     * });
     * ```
     */ UrlService.prototype.sync = function(evt) {
        if (evt && evt.defaultPrevented) return;
        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
        var url = {
            path: urlService.path(),
            search: urlService.search(),
            hash: urlService.hash()
        };
        var best = this.match(url);
        var applyResult = (0, $b94057b5b409b0b1$export$24f82734ea047e6f)([
            [
                (0, $c4ca6daaad7210ad$export$844ec244b1367d54),
                function(newurl) {
                    return urlService.url(newurl, true);
                }
            ],
            [
                (0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac).isDef,
                function(def) {
                    return stateService.go(def.state, def.params, def.options);
                }
            ],
            [
                (0, $b94057b5b409b0b1$export$226b3eccf92c9ed9)((0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac)),
                function(target) {
                    return stateService.go(target.state(), target.params(), target.options());
                }
            ]
        ]);
        applyResult(best && best.rule.handler(best.match, url, this.router));
    };
    /**
     * Starts or stops listening for URL changes
     *
     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
     *
     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
     *
     * #### Example:
     * ```js
     * urlService.deferIntercept();
     *
     * fetch('/states.json').then(resp => resp.json()).then(data => {
     *   data.forEach(state => $stateRegistry.register(state));
     *   // Start responding to URL changes
     *   urlService.listen();
     *   urlService.sync();
     * });
     * ```
     *
     * @param enabled `true` or `false` to start or stop listening to URL changes
     */ UrlService.prototype.listen = function(enabled) {
        var _this = this;
        if (enabled === false) {
            this._stopListeningFn && this._stopListeningFn();
            delete this._stopListeningFn;
        } else return this._stopListeningFn = this._stopListeningFn || this.router.urlService.onChange(function(evt) {
            return _this.sync(evt);
        });
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
     * urlService.deferIntercept();
     *
     * fetch('/states.json').then(resp => resp.json()).then(data => {
     *   data.forEach(state => $stateRegistry.register(state));
     *   urlService.listen();
     *   urlService.sync();
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */ UrlService.prototype.deferIntercept = function(defer) {
        if (defer === undefined) defer = true;
        this.interceptDeferred = defer;
    };
    /**
     * Matches a URL
     *
     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
     * Return the result as a [[MatchResult]].
     */ UrlService.prototype.match = function(url) {
        var _this = this;
        url = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({
            path: "",
            search: {},
            hash: ""
        }, url);
        var rules = this.rules.rules();
        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
        var checkRule = function(rule) {
            var match = rule.match(url, _this.router);
            return match && {
                match: match,
                rule: rule,
                weight: rule.matchPriority(match)
            };
        };
        // The rules are pre-sorted.
        // - Find the first matching rule.
        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
        // - Choose the rule with the highest match weight.
        var best;
        for(var i = 0; i < rules.length; i++){
            // Stop when there is a 'best' rule and the next rule sorts differently than it.
            if (best && best.rule._group !== rules[i]._group) break;
            var current = checkRule(rules[i]);
            // Pick the best MatchResult
            best = !best || current && current.weight > best.weight ? current : best;
        }
        return best;
    };
    return UrlService;
}();




/** @internal */ var $5e4c6b2b8af047a3$var$_routerInstance = 0;
/** @internal */ var $5e4c6b2b8af047a3$var$locSvcFns = [
    "url",
    "path",
    "search",
    "hash",
    "onChange"
];
/** @internal */ var $5e4c6b2b8af047a3$var$locCfgFns = [
    "port",
    "protocol",
    "host",
    "baseHref",
    "html5Mode",
    "hashPrefix"
];
/** @internal */ var $5e4c6b2b8af047a3$var$locationServiceStub = (0, $e592c26318c32a9d$export$74518f5fb3a7c7a3)("LocationServices", $5e4c6b2b8af047a3$var$locSvcFns);
/** @internal */ var $5e4c6b2b8af047a3$var$locationConfigStub = (0, $e592c26318c32a9d$export$74518f5fb3a7c7a3)("LocationConfig", $5e4c6b2b8af047a3$var$locCfgFns);
/**
 * An instance of UI-Router.
 *
 * This object contains references to service APIs which define your application's routing behavior.
 */ var $5e4c6b2b8af047a3$export$34bda4031e17f347 = /** @class */ function() {
    /**
     * Creates a new `UIRouter` object
     *
     * @param locationService a [[LocationServices]] implementation
     * @param locationConfig a [[LocationConfig]] implementation
     * @internal
     */ function UIRouter(locationService, locationConfig) {
        if (locationService === void 0) locationService = $5e4c6b2b8af047a3$var$locationServiceStub;
        if (locationConfig === void 0) locationConfig = $5e4c6b2b8af047a3$var$locationConfigStub;
        this.locationService = locationService;
        this.locationConfig = locationConfig;
        /** @internal */ this.$id = $5e4c6b2b8af047a3$var$_routerInstance++;
        /** @internal */ this._disposed = false;
        /** @internal */ this._disposables = [];
        /** Enable/disable tracing to the javascript console */ this.trace = (0, $42b3df7fa4bc82fe$export$357889f174732d38);
        /** Provides services related to ui-view synchronization */ this.viewService = new (0, $f6ae7a2c459ed9f6$export$e5cb1ae026d0fe73)(this);
        /** An object that contains global router state, such as the current state and params */ this.globals = new (0, $508859f5cddf2adc$export$64da63b9cd8aa371)();
        /** A service that exposes global Transition Hooks */ this.transitionService = new (0, $3b74c8299187ded2$export$6eee99dc7fe1596b)(this);
        /**
         * Deprecated for public use. Use [[urlService]] instead.
         * @deprecated Use [[urlService]] instead
         */ this.urlMatcherFactory = new (0, $f8904b4480879991$export$edd9e9bf3413d526)(this);
        /**
         * Deprecated for public use. Use [[urlService]] instead.
         * @deprecated Use [[urlService]] instead
         */ this.urlRouter = new (0, $2bb533e8e1ca30f6$export$7a87032517a0a658)(this);
        /** Provides services related to the URL */ this.urlService = new (0, $d40daad0844b912b$export$f2c3b6749c5bbbef)(this);
        /** Provides a registry for states, and related registration services */ this.stateRegistry = new (0, $c4bb05b5c4e40fea$export$ec0497251a3e4668)(this);
        /** Provides services related to states */ this.stateService = new (0, $f045abf62eb209bf$export$e0bc89b7602e62dc)(this);
        /** @internal plugin instances are registered here */ this._plugins = {};
        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
        this.globals.$current = this.stateRegistry.root();
        this.globals.current = this.globals.$current.self;
        this.disposable(this.globals);
        this.disposable(this.stateService);
        this.disposable(this.stateRegistry);
        this.disposable(this.transitionService);
        this.disposable(this.urlService);
        this.disposable(locationService);
        this.disposable(locationConfig);
    }
    /** Registers an object to be notified when the router is disposed */ UIRouter.prototype.disposable = function(disposable) {
        this._disposables.push(disposable);
    };
    /**
     * Disposes this router instance
     *
     * When called, clears resources retained by the router by calling `dispose(this)` on all
     * registered [[disposable]] objects.
     *
     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
     *
     * @internal
     * @param disposable (optional) the disposable to dispose
     */ UIRouter.prototype.dispose = function(disposable) {
        var _this = this;
        if (disposable && (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(disposable.dispose)) {
            disposable.dispose(this);
            return undefined;
        }
        this._disposed = true;
        this._disposables.slice().forEach(function(d) {
            try {
                typeof d.dispose === "function" && d.dispose(_this);
                (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(_this._disposables, d);
            } catch (ignored) {}
        });
    };
    /**
     * Adds a plugin to UI-Router
     *
     * This method adds a UI-Router Plugin.
     * A plugin can enhance or change UI-Router behavior using any public API.
     *
     * #### Example:
     * ```js
     * import { MyCoolPlugin } from "ui-router-cool-plugin";
     *
     * var plugin = router.addPlugin(MyCoolPlugin);
     * ```
     *
     * ### Plugin authoring
     *
     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
     *
     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
     * For example, it may configure router options or add a Transition Hook.
     *
     * The plugin can then be published as a separate module.
     *
     * #### Example:
     * ```js
     * export class MyAuthPlugin implements UIRouterPlugin {
     *   constructor(router: UIRouter, options: any) {
     *     this.name = "MyAuthPlugin";
     *     let $transitions = router.transitionService;
     *     let $state = router.stateService;
     *
     *     let authCriteria = {
     *       to: (state) => state.data && state.data.requiresAuth
     *     };
     *
     *     function authHook(transition: Transition) {
     *       let authService = transition.injector().get('AuthService');
     *       if (!authService.isAuthenticated()) {
     *         return $state.target('login');
     *       }
     *     }
     *
     *     $transitions.onStart(authCriteria, authHook);
     *   }
     * }
     * ```
     *
     * @param plugin one of:
     *        - a plugin class which implements [[UIRouterPlugin]]
     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
     * @param options options to pass to the plugin class/factory
     * @returns the registered plugin instance
     */ UIRouter.prototype.plugin = function(plugin, options) {
        if (options === void 0) options = {};
        var pluginInstance = new plugin(this, options);
        if (!pluginInstance.name) throw new Error("Required property `name` missing on plugin: " + pluginInstance);
        this._disposables.push(pluginInstance);
        return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function(pluginName) {
        return pluginName ? this._plugins[pluginName] : (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(this._plugins);
    };
    return UIRouter;
}();




function $72c8c7930d55e72b$var$addCoreResolvables(trans) {
    trans.addResolvable((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e).fromData((0, $5e4c6b2b8af047a3$export$34bda4031e17f347), trans.router), "");
    trans.addResolvable((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e).fromData((0, $8acc89dbd49ceaf2$export$be58926105124dd4), trans), "");
    trans.addResolvable((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e).fromData("$transition$", trans), "");
    trans.addResolvable((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e).fromData("$stateParams", trans.params()), "");
    trans.entering().forEach(function(state) {
        trans.addResolvable((0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e).fromData("$state$", state), state);
    });
}
var $72c8c7930d55e72b$export$5325cb13c8c5b478 = function(transitionService) {
    return transitionService.onCreate({}, $72c8c7930d55e72b$var$addCoreResolvables);
};
var $72c8c7930d55e72b$var$TRANSITION_TOKENS = [
    "$transition$",
    (0, $8acc89dbd49ceaf2$export$be58926105124dd4)
];
var $72c8c7930d55e72b$var$isTransition = (0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)($72c8c7930d55e72b$var$TRANSITION_TOKENS);
var $72c8c7930d55e72b$export$7295da56257b1d16 = function(trans) {
    var nodes = (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(trans.treeChanges()).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).reduce((0, $abcc081e7f2a61c5$export$530e60648218df63), []);
    // If the resolvable is a Transition, return a new resolvable with null data
    var replaceTransitionWithNull = function(r) {
        return $72c8c7930d55e72b$var$isTransition(r.token) ? (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e).fromData(r.token, null) : r;
    };
    nodes.forEach(function(node) {
        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
    });
};





/**
 * A [[TransitionHookFn]] that redirects to a different state or params
 *
 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
 *
 * See [[StateDeclaration.redirectTo]]
 */ var $54935156e41a19ff$var$redirectToHook = function(trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect) return;
    var $state = trans.router.stateService;
    function handleResult(result) {
        if (!result) return;
        if (result instanceof (0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac)) return result;
        if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(result)) return $state.target(result, trans.params(), trans.options());
        if (result["state"] || result["params"]) return $state.target(result["state"] || trans.to(), result["params"] || trans.params(), trans.options());
    }
    if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(redirect)) return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(redirect(trans)).then(handleResult);
    return handleResult(redirect);
};
var $54935156e41a19ff$export$16cd000d71d33513 = function(transitionService) {
    return transitionService.onStart({
        to: function(state) {
            return !!state.redirectTo;
        }
    }, $54935156e41a19ff$var$redirectToHook);
};


/**
 * A factory which creates an onEnter, onExit or onRetain transition hook function
 *
 * The returned function invokes the (for instance) state.onEnter hook when the
 * state is being entered.
 */ function $eac27098422b2d9b$var$makeEnterExitRetainHook(hookName) {
    return function(transition, state) {
        var _state = state.$$state();
        var hookFn = _state[hookName];
        return hookFn(transition, state);
    };
}
/**
 * The [[TransitionStateHookFn]] for onExit
 *
 * When the state is being exited, the state's .onExit function is invoked.
 *
 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
 *
 * See: [[IHookRegistry.onExit]]
 */ var $eac27098422b2d9b$var$onExitHook = $eac27098422b2d9b$var$makeEnterExitRetainHook("onExit");
var $eac27098422b2d9b$export$e1211a6292de4761 = function(transitionService) {
    return transitionService.onExit({
        exiting: function(state) {
            return !!state.onExit;
        }
    }, $eac27098422b2d9b$var$onExitHook);
};
/**
 * The [[TransitionStateHookFn]] for onRetain
 *
 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
 *
 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
 *
 * See: [[IHookRegistry.onRetain]]
 */ var $eac27098422b2d9b$var$onRetainHook = $eac27098422b2d9b$var$makeEnterExitRetainHook("onRetain");
var $eac27098422b2d9b$export$2248a8bbe78239d1 = function(transitionService) {
    return transitionService.onRetain({
        retained: function(state) {
            return !!state.onRetain;
        }
    }, $eac27098422b2d9b$var$onRetainHook);
};
/**
 * The [[TransitionStateHookFn]] for onEnter
 *
 * When the state is being entered, the state's .onEnter function is invoked.
 *
 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
 *
 * See: [[IHookRegistry.onEnter]]
 */ var $eac27098422b2d9b$var$onEnterHook = $eac27098422b2d9b$var$makeEnterExitRetainHook("onEnter");
var $eac27098422b2d9b$export$76c8b9e3873780ab = function(transitionService) {
    return transitionService.onEnter({
        entering: function(state) {
            return !!state.onEnter;
        }
    }, $eac27098422b2d9b$var$onEnterHook);
};





var $adfc34dbc9db5577$export$5115fbcaa3b1c13f = 1000;
/**
 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
 *
 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
 *
 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */ var $adfc34dbc9db5577$var$eagerResolvePath = function(trans) {
    return new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(trans.treeChanges().to).resolvePath("EAGER", trans).then((0, $abcc081e7f2a61c5$export$8793edee2d425525));
};
var $adfc34dbc9db5577$export$c69bdc12da9f0243 = function(transitionService) {
    return transitionService.onStart({}, $adfc34dbc9db5577$var$eagerResolvePath, {
        priority: $adfc34dbc9db5577$export$5115fbcaa3b1c13f
    });
};
/**
 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
 *
 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
 *
 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */ var $adfc34dbc9db5577$var$lazyResolveState = function(trans, state) {
    return new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(trans.treeChanges().to).subContext(state.$$state()).resolvePath("LAZY", trans).then((0, $abcc081e7f2a61c5$export$8793edee2d425525));
};
var $adfc34dbc9db5577$export$9ddfe10a09c10416 = function(transitionService) {
    return transitionService.onEnter({
        entering: (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(true)
    }, $adfc34dbc9db5577$var$lazyResolveState, {
        priority: $adfc34dbc9db5577$export$5115fbcaa3b1c13f
    });
};
/**
 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
 *
 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
 *
 * After all entering states have been entered, this hook resolves any remaining Resolvables.
 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
 *
 * See [[StateDeclaration.resolve]]
 */ var $adfc34dbc9db5577$var$resolveRemaining = function(trans) {
    return new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(trans.treeChanges().to).resolvePath("LAZY", trans).then((0, $abcc081e7f2a61c5$export$8793edee2d425525));
};
var $adfc34dbc9db5577$export$df2aed0d3b3c666a = function(transitionService) {
    return transitionService.onFinish({}, $adfc34dbc9db5577$var$resolveRemaining, {
        priority: $adfc34dbc9db5577$export$5115fbcaa3b1c13f
    });
};




/**
 * A [[TransitionHookFn]] which waits for the views to load
 *
 * Registered using `transitionService.onStart({}, loadEnteringViews);`
 *
 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
 * In angular 1, this includes loading the templates.
 */ var $0da6209f1707062a$var$loadEnteringViews = function(transition) {
    var $q = (0, $e592c26318c32a9d$export$bce7a36871692cab).$q;
    var enteringViews = transition.views("entering");
    if (!enteringViews.length) return;
    return $q.all(enteringViews.map(function(view) {
        return $q.when(view.load());
    })).then((0, $abcc081e7f2a61c5$export$8793edee2d425525));
};
var $0da6209f1707062a$export$72312f47ab7c3b38 = function(transitionService) {
    return transitionService.onFinish({}, $0da6209f1707062a$var$loadEnteringViews);
};
/**
 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
 *
 * Registered using `transitionService.onSuccess({}, activateViews);`
 *
 * After a transition is complete, this hook deactivates the old views from the previous state,
 * and activates the new views from the destination state.
 *
 * See [[ViewService]]
 */ var $0da6209f1707062a$var$activateViews = function(transition) {
    var enteringViews = transition.views("entering");
    var exitingViews = transition.views("exiting");
    if (!enteringViews.length && !exitingViews.length) return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function(vc) {
        return $view.deactivateViewConfig(vc);
    });
    enteringViews.forEach(function(vc) {
        return $view.activateViewConfig(vc);
    });
    $view.sync();
};
var $0da6209f1707062a$export$51837e87b3531b02 = function(transitionService) {
    return transitionService.onSuccess({}, $0da6209f1707062a$var$activateViews);
};



/**
 * A [[TransitionHookFn]] which updates global UI-Router state
 *
 * Registered using `transitionService.onBefore({}, updateGlobalState);`
 *
 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
 * After a successful [[Transition]], updates the global values of "the current state"
 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
 *
 * See also the deprecated properties:
 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
 */ var $6a077727c903dd09$var$updateGlobalState = function(trans) {
    var globals = trans.router.globals;
    var transitionSuccessful = function() {
        globals.successfulTransitions.enqueue(trans);
        globals.$current = trans.$to();
        globals.current = globals.$current.self;
        (0, $abcc081e7f2a61c5$export$784d13d8ee351f07)(trans.params(), globals.params);
    };
    var clearCurrentTransition = function() {
        // Do not clear globals.transition if a different transition has started in the meantime
        if (globals.transition === trans) globals.transition = null;
    };
    trans.onSuccess({}, transitionSuccessful, {
        priority: 10000
    });
    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
};
var $6a077727c903dd09$export$20c21f0434e7eee0 = function(transitionService) {
    return transitionService.onCreate({}, $6a077727c903dd09$var$updateGlobalState);
};


/**
 * A [[TransitionHookFn]] which updates the URL after a successful transition
 *
 * Registered using `transitionService.onSuccess({}, updateUrl);`
 */ var $b7be64b723b585b7$var$updateUrl = function(transition) {
    var options = transition.options();
    var $state = transition.router.stateService;
    var $urlRouter = transition.router.urlRouter;
    // Dont update the url in these situations:
    // The transition was triggered by a URL sync (options.source === 'url')
    // The user doesn't want the url to update (options.location === false)
    // The destination state, and all parents have no navigable url
    if (options.source !== "url" && options.location && $state.$current.navigable) {
        var urlOptions = {
            replace: options.location === "replace"
        };
        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
    }
    $urlRouter.update(true);
};
var $b7be64b723b585b7$export$c66f225e425a2590 = function(transitionService) {
    return transitionService.onSuccess({}, $b7be64b723b585b7$var$updateUrl, {
        priority: 9999
    });
};



/**
 * A [[TransitionHookFn]] that performs lazy loading
 *
 * When entering a state "abc" which has a `lazyLoad` function defined:
 * - Invoke the `lazyLoad` function (unless it is already in process)
 *   - Flag the hook function as "in process"
 *   - The function should return a promise (that resolves when lazy loading is complete)
 * - Wait for the promise to settle
 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
 *   - Flag the hook function as "not in process"
 * - If the hook was successful
 *   - Remove the `lazyLoad` function from the state declaration
 * - If all the hooks were successful
 *   - Retry the transition (by returning a TargetState)
 *
 * ```
 * .state('abc', {
 *   component: 'fooComponent',
 *   lazyLoad: () => import('./fooComponent')
 *   });
 * ```
 *
 * See [[StateDeclaration.lazyLoad]]
 */ var $60602b1583b6ca4f$var$lazyLoadHook = function(transition) {
    var router = transition.router;
    function retryTransition() {
        if (transition.originalTransition().options().source !== "url") {
            // The original transition was not triggered via url sync
            // The lazy state should be loaded now, so re-try the original transition
            var orig = transition.targetState();
            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        // The original transition was triggered via url sync
        // Run the URL rules and find the best match
        var $url = router.urlService;
        var result = $url.match($url.parts());
        var rule = result && result.rule;
        // If the best match is a state, redirect the transition (instead
        // of calling sync() which supersedes the current transition)
        if (rule && rule.type === "STATE") {
            var state = rule.state;
            var params = result.match;
            return router.stateService.target(state, params, transition.options());
        }
        // No matching state found, so let .sync() choose the best non-state match/otherwise
        router.urlService.sync();
    }
    var promises = transition.entering().filter(function(state) {
        return !!state.$$state().lazyLoad;
    }).map(function(state) {
        return $60602b1583b6ca4f$export$5b0a2f2e644c5813(transition, state);
    });
    return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.all(promises).then(retryTransition);
};
var $60602b1583b6ca4f$export$6f44b346010b9f10 = function(transitionService) {
    return transitionService.onBefore({
        entering: function(state) {
            return !!state.lazyLoad;
        }
    }, $60602b1583b6ca4f$var$lazyLoadHook);
};
function $60602b1583b6ca4f$export$5b0a2f2e644c5813(transition, state) {
    var lazyLoadFn = state.$$state().lazyLoad;
    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
    var promise = lazyLoadFn["_promise"];
    if (!promise) {
        var success = function(result) {
            delete state.lazyLoad;
            delete state.$$state().lazyLoad;
            delete lazyLoadFn["_promise"];
            return result;
        };
        var error = function(err) {
            delete lazyLoadFn["_promise"];
            return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.reject(err);
        };
        promise = lazyLoadFn["_promise"] = (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(lazyLoadFn(transition, state)).then(updateStateRegistry).then(success, error);
    }
    /** Register any lazy loaded state definitions */ function updateStateRegistry(result) {
        if (result && Array.isArray(result.states)) result.states.forEach(function(_state) {
            return transition.router.stateRegistry.register(_state);
        });
        return result;
    }
    return promise;
}



/**
 * This class defines a type of hook, such as `onBefore` or `onEnter`.
 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
 */ var $b75a9c025b96882c$export$2e42bdc5a69d3be4 = /** @class */ function() {
    /* tslint:disable:no-inferrable-types */ function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
        if (reverseSort === void 0) reverseSort = false;
        if (getResultHandler === void 0) getResultHandler = (0, $eab60650cc6e25be$export$dcf30b2235353599).HANDLE_RESULT;
        if (getErrorHandler === void 0) getErrorHandler = (0, $eab60650cc6e25be$export$dcf30b2235353599).REJECT_ERROR;
        if (synchronous === void 0) synchronous = false;
        this.name = name;
        this.hookPhase = hookPhase;
        this.hookOrder = hookOrder;
        this.criteriaMatchPath = criteriaMatchPath;
        this.reverseSort = reverseSort;
        this.getResultHandler = getResultHandler;
        this.getErrorHandler = getErrorHandler;
        this.synchronous = synchronous;
    }
    return TransitionEventType;
}();








/**
 * A [[TransitionHookFn]] that skips a transition if it should be ignored
 *
 * This hook is invoked at the end of the onBefore phase.
 *
 * If the transition should be ignored (because no parameter or states changed)
 * then the transition is ignored and not processed.
 */ function $7e1efc5fd2e5556d$var$ignoredHook(trans) {
    var ignoredReason = trans._ignoredReason();
    if (!ignoredReason) return;
    (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceTransitionIgnored(trans);
    var pending = trans.router.globals.transition;
    // The user clicked a link going back to the *current state* ('A')
    // However, there is also a pending transition in flight (to 'B')
    // Abort the transition to 'B' because the user now wants to be back at 'A'.
    if (ignoredReason === "SameAsCurrent" && pending) pending.abort();
    return (0, $24ffb5fe12175fdd$export$a40146100efc171b).ignored().toPromise();
}
var $7e1efc5fd2e5556d$export$ab4ee36d29289f4e = function(transitionService) {
    return transitionService.onBefore({}, $7e1efc5fd2e5556d$var$ignoredHook, {
        priority: -9999
    });
};


/**
 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
 *
 * This hook is invoked at the end of the onBefore phase.
 * If the transition is invalid (for example, param values do not validate)
 * then the transition is rejected.
 */ function $c586b7789964f540$var$invalidTransitionHook(trans) {
    if (!trans.valid()) throw new Error(trans.error().toString());
}
var $c586b7789964f540$export$f880a4a1e412d1f9 = function(transitionService) {
    return transitionService.onBefore({}, $c586b7789964f540$var$invalidTransitionHook, {
        priority: -10000
    });
};


var $3b74c8299187ded2$export$77c7b66ca0663b35 = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    supercede: true,
    custom: {},
    current: function() {
        return null;
    },
    source: "unknown"
};
/**
 * This class provides services related to Transitions.
 *
 * - Most importantly, it allows global Transition Hooks to be registered.
 * - It allows the default transition error handler to be set.
 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
 *
 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
 *
 * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
 */ var $3b74c8299187ded2$export$6eee99dc7fe1596b = /** @class */ function() {
    /** @internal */ function TransitionService(_router) {
        /** @internal */ this._transitionCount = 0;
        /** The transition hook types, such as `onEnter`, `onStart`, etc */ this._eventTypes = [];
        /** @internal The registered transition hooks */ this._registeredHooks = {};
        /** The  paths on a criteria object */ this._criteriaPaths = {};
        this._router = _router;
        this.$view = _router.viewService;
        this._deregisterHookFns = {};
        this._pluginapi = (0, $abcc081e7f2a61c5$export$a6c115f931de9046)((0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(this), {}, (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(this), [
            "_definePathType",
            "_defineEvent",
            "_getPathTypes",
            "_getEvents",
            "getHooks"
        ]);
        this._defineCorePaths();
        this._defineCoreEvents();
        this._registerCoreTransitionHooks();
        _router.globals.successfulTransitions.onEvict((0, $72c8c7930d55e72b$export$7295da56257b1d16));
    }
    /**
     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
     *
     * Registers a transition lifecycle hook, which is invoked during transition construction.
     *
     * This low level hook should only be used by plugins.
     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
     * The Sticky States plugin uses this hook to modify the treechanges.
     *
     * ### Lifecycle
     *
     * `onCreate` hooks are invoked *while a transition is being constructed*.
     *
     * ### Return value
     *
     * The hook's return value is ignored
     *
     * @internal
     * @param criteria defines which Transitions the Hook should be invoked for.
     * @param callback the hook function which will be invoked.
     * @param options the registration options
     * @returns a function which deregisters the hook.
     */ TransitionService.prototype.onCreate = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onBefore = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onStart = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onExit = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onRetain = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onEnter = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onFinish = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onSuccess = function(criteria, callback, options) {
        return;
    };
    /** @inheritdoc */ TransitionService.prototype.onError = function(criteria, callback, options) {
        return;
    };
    /**
     * dispose
     * @internal
     */ TransitionService.prototype.dispose = function(router) {
        (0, $abcc081e7f2a61c5$export$68c286be0e7e55b7)(this._registeredHooks).forEach(function(hooksArray) {
            return hooksArray.forEach(function(hook) {
                hook._deregistered = true;
                (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(hooksArray, hook);
            });
        });
    };
    /**
     * Creates a new [[Transition]] object
     *
     * This is a factory function for creating new Transition objects.
     * It is used internally by the [[StateService]] and should generally not be called by application code.
     *
     * @internal
     * @param fromPath the path to the current state (the from state)
     * @param targetState the target state (destination)
     * @returns a Transition
     */ TransitionService.prototype.create = function(fromPath, targetState) {
        return new (0, $8acc89dbd49ceaf2$export$be58926105124dd4)(fromPath, targetState, this._router);
    };
    /** @internal */ TransitionService.prototype._defineCoreEvents = function() {
        var Phase = (0, $f798ef43a419f893$export$9484030a489306a0);
        var TH = (0, $eab60650cc6e25be$export$dcf30b2235353599);
        var paths = this._criteriaPaths;
        var NORMAL_SORT = false, REVERSE_SORT = true;
        var SYNCHRONOUS = true;
        this._defineEvent("onCreate", Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
        this._defineEvent("onBefore", Phase.BEFORE, 0, paths.to);
        this._defineEvent("onStart", Phase.RUN, 0, paths.to);
        this._defineEvent("onExit", Phase.RUN, 100, paths.exiting, REVERSE_SORT);
        this._defineEvent("onRetain", Phase.RUN, 200, paths.retained);
        this._defineEvent("onEnter", Phase.RUN, 300, paths.entering);
        this._defineEvent("onFinish", Phase.RUN, 400, paths.to);
        this._defineEvent("onSuccess", Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
        this._defineEvent("onError", Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
    };
    /** @internal */ TransitionService.prototype._defineCorePaths = function() {
        var STATE = (0, $f798ef43a419f893$export$6d115073a4f8edfb).STATE, TRANSITION = (0, $f798ef43a419f893$export$6d115073a4f8edfb).TRANSITION;
        this._definePathType("to", TRANSITION);
        this._definePathType("from", TRANSITION);
        this._definePathType("exiting", STATE);
        this._definePathType("retained", STATE);
        this._definePathType("entering", STATE);
    };
    /** @internal */ TransitionService.prototype._defineEvent = function(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
        if (reverseSort === void 0) reverseSort = false;
        if (getResultHandler === void 0) getResultHandler = (0, $eab60650cc6e25be$export$dcf30b2235353599).HANDLE_RESULT;
        if (getErrorHandler === void 0) getErrorHandler = (0, $eab60650cc6e25be$export$dcf30b2235353599).REJECT_ERROR;
        if (synchronous === void 0) synchronous = false;
        var eventType = new (0, $b75a9c025b96882c$export$2e42bdc5a69d3be4)(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
        this._eventTypes.push(eventType);
        (0, $c94bf830ad00bcf1$export$2f7b310570bee07a)(this, this, eventType);
    };
    /** @internal */ TransitionService.prototype._getEvents = function(phase) {
        var transitionHookTypes = (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(phase) ? this._eventTypes.filter(function(type) {
            return type.hookPhase === phase;
        }) : this._eventTypes.slice();
        return transitionHookTypes.sort(function(l, r) {
            var cmpByPhase = l.hookPhase - r.hookPhase;
            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
        });
    };
    /**
     * Adds a Path to be used as a criterion against a TreeChanges path
     *
     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
     * Each state in the exiting path is checked against the criteria and returned as part of the match.
     *
     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
     *
     * @internal
     */ TransitionService.prototype._definePathType = function(name, hookScope) {
        this._criteriaPaths[name] = {
            name: name,
            scope: hookScope
        };
    };
    /** @internal */ // tslint:disable-next-line
    TransitionService.prototype._getPathTypes = function() {
        return this._criteriaPaths;
    };
    /** @internal */ TransitionService.prototype.getHooks = function(hookName) {
        return this._registeredHooks[hookName];
    };
    /** @internal */ TransitionService.prototype._registerCoreTransitionHooks = function() {
        var fns = this._deregisterHookFns;
        fns.addCoreResolves = (0, $72c8c7930d55e72b$export$5325cb13c8c5b478)(this);
        fns.ignored = (0, $7e1efc5fd2e5556d$export$ab4ee36d29289f4e)(this);
        fns.invalid = (0, $c586b7789964f540$export$f880a4a1e412d1f9)(this);
        // Wire up redirectTo hook
        fns.redirectTo = (0, $54935156e41a19ff$export$16cd000d71d33513)(this);
        // Wire up onExit/Retain/Enter state hooks
        fns.onExit = (0, $eac27098422b2d9b$export$e1211a6292de4761)(this);
        fns.onRetain = (0, $eac27098422b2d9b$export$2248a8bbe78239d1)(this);
        fns.onEnter = (0, $eac27098422b2d9b$export$76c8b9e3873780ab)(this);
        // Wire up Resolve hooks
        fns.eagerResolve = (0, $adfc34dbc9db5577$export$c69bdc12da9f0243)(this);
        fns.lazyResolve = (0, $adfc34dbc9db5577$export$9ddfe10a09c10416)(this);
        fns.resolveAll = (0, $adfc34dbc9db5577$export$df2aed0d3b3c666a)(this);
        // Wire up the View management hooks
        fns.loadViews = (0, $0da6209f1707062a$export$72312f47ab7c3b38)(this);
        fns.activateViews = (0, $0da6209f1707062a$export$51837e87b3531b02)(this);
        // Updates global state after a transition
        fns.updateGlobals = (0, $6a077727c903dd09$export$20c21f0434e7eee0)(this);
        // After globals.current is updated at priority: 10000
        fns.updateUrl = (0, $b7be64b723b585b7$export$c66f225e425a2590)(this);
        // Lazy load state trees
        fns.lazyLoad = (0, $60602b1583b6ca4f$export$6f44b346010b9f10)(this);
    };
    return TransitionService;
}();









/**
 * Provides services related to ui-router states.
 *
 * This API is located at `router.stateService` ([[UIRouter.stateService]])
 */ var $f045abf62eb209bf$export$e0bc89b7602e62dc = /** @class */ function() {
    /** @internal */ function StateService(/** @internal */ router) {
        this.router = router;
        /** @internal */ this.invalidCallbacks = [];
        /** @internal */ this._defaultErrorHandler = function $defaultErrorHandler($error$) {
            if ($error$ instanceof Error && $error$.stack) {
                console.error($error$);
                console.error($error$.stack);
            } else if ($error$ instanceof (0, $24ffb5fe12175fdd$export$a40146100efc171b)) {
                console.error($error$.toString());
                if ($error$.detail && $error$.detail.stack) console.error($error$.detail.stack);
            } else console.error($error$);
        };
        var getters = [
            "current",
            "$current",
            "params",
            "transition"
        ];
        var boundFns = Object.keys(StateService.prototype).filter((0, $b94057b5b409b0b1$export$6003a5f097c73977)((0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(getters)));
        (0, $abcc081e7f2a61c5$export$a6c115f931de9046)((0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(StateService.prototype), this, (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
        /**
         * The [[Transition]] currently in progress (or null)
         *
         * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
         */ get: function() {
            return this.router.globals.transition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
        /**
         * The latest successful state parameters
         *
         * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
         */ get: function() {
            return this.router.globals.params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
        /**
         * The current [[StateDeclaration]]
         *
         * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
         */ get: function() {
            return this.router.globals.current;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
        /**
         * The current [[StateObject]] (an internal API)
         *
         * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
         */ get: function() {
            return this.router.globals.$current;
        },
        enumerable: false,
        configurable: true
    });
    /** @internal */ StateService.prototype.dispose = function() {
        this.defaultErrorHandler((0, $abcc081e7f2a61c5$export$8793edee2d425525));
        this.invalidCallbacks = [];
    };
    /**
     * Handler for when [[transitionTo]] is called with an invalid state.
     *
     * Invokes the [[onInvalid]] callbacks, in natural order.
     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
     *
     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
     *
     * @internal
     */ StateService.prototype._handleInvalidTargetState = function(fromPath, toState) {
        var _this = this;
        var fromState = (0, $50d81baac9264b80$export$39d3fc700b385dc4).makeTargetState(this.router.stateRegistry, fromPath);
        var globals = this.router.globals;
        var latestThing = function() {
            return globals.transitionHistory.peekTail();
        };
        var latest = latestThing();
        var callbackQueue = new (0, $1ccfe5f6108c2c49$export$3dc07afe418952bc)(this.invalidCallbacks.slice());
        var injector = new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(fromPath).injector();
        var checkForRedirect = function(result) {
            if (!(result instanceof (0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac))) return;
            var target = result;
            // Recreate the TargetState, in case the state is now defined.
            target = _this.target(target.identifier(), target.params(), target.options());
            if (!target.valid()) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).invalid(target.error()).toPromise();
            if (latestThing() !== latest) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).superseded().toPromise();
            return _this.transitionTo(target.identifier(), target.params(), target.options());
        };
        function invokeNextCallback() {
            var nextCallback = callbackQueue.dequeue();
            if (nextCallback === undefined) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).invalid(toState.error()).toPromise();
            var callbackResult = (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(nextCallback(toState, fromState, injector));
            return callbackResult.then(checkForRedirect).then(function(result) {
                return result || invokeNextCallback();
            });
        }
        return invokeNextCallback();
    };
    /**
     * Registers an Invalid State handler
     *
     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
     * has been called with an invalid state reference parameter
     *
     * Example:
     * ```js
     * stateService.onInvalid(function(to, from, injector) {
     *   if (to.name() === 'foo') {
     *     let lazyLoader = injector.get('LazyLoadService');
     *     return lazyLoader.load('foo')
     *         .then(() => stateService.target('foo'));
     *   }
     * });
     * ```
     *
     * @param {function} callback invoked when the toState is invalid
     *   This function receives the (invalid) toState, the fromState, and an injector.
     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
     *   If one is returned, it is treated as a redirect.
     *
     * @returns a function which deregisters the callback
     */ StateService.prototype.onInvalid = function(callback) {
        this.invalidCallbacks.push(callback);
        return (function deregisterListener() {
            (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(this.invalidCallbacks)(callback);
        }).bind(this);
    };
    /**
     * Reloads the current state
     *
     * A method that force reloads the current state, or a partial state hierarchy.
     * All resolves are re-resolved, and components reinstantiated.
     *
     * #### Example:
     * ```js
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * ```
     *
     * Note: `reload()` is just an alias for:
     *
     * ```js
     * $state.transitionTo($state.current, $state.params, {
     *   reload: true, inherit: false
     * });
     * ```
     *
     * @param reloadState A state name or a state object.
     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
     *
     * #### Example:
     * ```js
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
     * //and current state is 'contacts.detail.item'
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * ```
     *
     * @returns A promise representing the state of the new transition. See [[StateService.go]]
     */ StateService.prototype.reload = function(reloadState) {
        return this.transitionTo(this.current, this.params, {
            reload: (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(reloadState) ? reloadState : true,
            inherit: false,
            notify: false
        });
    };
    /**
     * Transition to a different state and/or parameters
     *
     * Convenience method for transitioning to a new state.
     *
     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
     * inherit from the current parameter values (because of `inherit: true`).
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to Absolute state name, state object, or relative state path (relative to current state).
     *
     * Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to the parent state
     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
     *
     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
     *
     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
     *
     * @param options Transition options
     *
     * @returns {promise} A promise representing the state of the new transition.
     */ StateService.prototype.go = function(to, params, options) {
        var defautGoOpts = {
            relative: this.$current,
            inherit: true
        };
        var transOpts = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(options, defautGoOpts, (0, $3b74c8299187ded2$export$77c7b66ca0663b35));
        return this.transitionTo(to, params, transOpts);
    };
    /**
     * Creates a [[TargetState]]
     *
     * This is a factory method for creating a TargetState
     *
     * This may be returned from a Transition Hook to redirect a transition, for example.
     */ StateService.prototype.target = function(identifier, params, options) {
        if (options === void 0) options = {};
        // If we're reloading, find the state object to reload from
        if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(options.reload) && !options.reload.name) throw new Error("Invalid reload state object");
        var reg = this.router.stateRegistry;
        options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
        if (options.reload && !options.reloadState) throw new Error("No such reload state '" + ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(options.reload) ? options.reload : options.reload.name) + "'");
        return new (0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac)(this.router.stateRegistry, identifier, params, options);
    };
    /** @internal */ StateService.prototype.getCurrentPath = function() {
        var _this = this;
        var globals = this.router.globals;
        var latestSuccess = globals.successfulTransitions.peekTail();
        var rootPath = function() {
            return [
                new (0, $5393b4248257e3d9$export$abca0bc337352069)(_this.router.stateRegistry.root())
            ];
        };
        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    /**
     * Low-level method for transitioning to a new state.
     *
     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to State name or state object.
     * @param toParams A map of the parameters that will be sent to the state,
     *      will populate $stateParams.
     * @param options Transition options
     *
     * @returns A promise representing the state of the new transition. See [[go]]
     */ StateService.prototype.transitionTo = function(to, toParams, options) {
        var _this = this;
        if (toParams === void 0) toParams = {};
        if (options === void 0) options = {};
        var router = this.router;
        var globals = router.globals;
        options = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(options, (0, $3b74c8299187ded2$export$77c7b66ca0663b35));
        var getCurrent = function() {
            return globals.transition;
        };
        options = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(options, {
            current: getCurrent
        });
        var ref = this.target(to, toParams, options);
        var currentPath = this.getCurrentPath();
        if (!ref.exists()) return this._handleInvalidTargetState(currentPath, ref);
        if (!ref.valid()) return (0, $abcc081e7f2a61c5$export$799ed83fec19ce5d)(ref.error());
        if (options.supercede === false && getCurrent()) return (0, $24ffb5fe12175fdd$export$a40146100efc171b).ignored("Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.").toPromise();
        /**
         * Special handling for Ignored, Aborted, and Redirected transitions
         *
         * The semantics for the transition.run() promise and the StateService.transitionTo()
         * promise differ. For instance, the run() promise may be rejected because it was
         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
         */ var rejectedTransitionHandler = function(trans) {
            return function(error) {
                if (error instanceof (0, $24ffb5fe12175fdd$export$a40146100efc171b)) {
                    var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
                    if (error.type === (0, $24ffb5fe12175fdd$export$59c5466e57555862).IGNORED) {
                        isLatest && router.urlRouter.update();
                        // Consider ignored `Transition.run()` as a successful `transitionTo`
                        return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(globals.current);
                    }
                    var detail = error.detail;
                    if (error.type === (0, $24ffb5fe12175fdd$export$59c5466e57555862).SUPERSEDED && error.redirected && detail instanceof (0, $f6f45358c1dc8ea5$export$b47ab23ce83f86ac)) {
                        // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
                        // by returning the promise for the new (redirect) `Transition.run()`.
                        var redirect = trans.redirect(detail);
                        return redirect.run().catch(rejectedTransitionHandler(redirect));
                    }
                    if (error.type === (0, $24ffb5fe12175fdd$export$59c5466e57555862).ABORTED) {
                        isLatest && router.urlRouter.update();
                        return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.reject(error);
                    }
                }
                var errorHandler = _this.defaultErrorHandler();
                errorHandler(error);
                return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.reject(error);
            };
        };
        var transition = this.router.transitionService.create(currentPath, ref);
        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
        (0, $abcc081e7f2a61c5$export$a71bc6bca9930802)(transitionToPromise); // issue #2676
        // Return a promise for the transition, which also has the transition object on it.
        return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(transitionToPromise, {
            transition: transition
        });
    };
    /**
     * Checks if the current state *is* the provided state
     *
     * Similar to [[includes]] but only checks for the full state name.
     * If params is supplied then it will be tested for strict equality against the current
     * active params object, so all params must match with none missing and no extras.
     *
     * #### Example:
     * ```js
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     * ```
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * ```html
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * ```
     *
     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns Returns true if it is the state.
     */ StateService.prototype.is = function(stateOrName, params, options) {
        options = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(options, {
            relative: this.$current
        });
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(state)) return undefined;
        if (this.$current !== state) return false;
        if (!params) return true;
        var schema = state.parameters({
            inherit: true,
            matchingKeys: params
        });
        return (0, $e3df413894675dea$export$1ca45c9a47aec42c).equals(schema, (0, $e3df413894675dea$export$1ca45c9a47aec42c).values(schema, params), this.params);
    };
    /**
     * Checks if the current state *includes* the provided state
     *
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * #### Example when `$state.$current.name === 'contacts.details.item'`
     * ```js
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     * ```
     *
     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
     * ```js
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * ```
     *
     * @param stateOrName A partial name, relative name, glob pattern,
     *   or state object to be searched for within the current state name.
     * @param params A param object, e.g. `{sectionId: section.id}`,
     *   that you'd like to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */ StateService.prototype.includes = function(stateOrName, params, options) {
        options = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(options, {
            relative: this.$current
        });
        var glob = (0, $c4ca6daaad7210ad$export$844ec244b1367d54)(stateOrName) && (0, $037d6cb562d64aaa$export$e1c4d8357a9b5598).fromString(stateOrName);
        if (glob) {
            if (!glob.matches(this.$current.name)) return false;
            stateOrName = this.$current.name;
        }
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
        if (!(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(state)) return undefined;
        if (!(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(include[state.name])) return false;
        if (!params) return true;
        var schema = state.parameters({
            inherit: true,
            matchingKeys: params
        });
        return (0, $e3df413894675dea$export$1ca45c9a47aec42c).equals(schema, (0, $e3df413894675dea$export$1ca45c9a47aec42c).values(schema, params), this.params);
    };
    /**
     * Generates a URL for a state and parameters
     *
     * Returns the url for the given state populated with the given params.
     *
     * #### Example:
     * ```js
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * ```
     *
     * @param stateOrName The state name or state object you'd like to generate a url from.
     * @param params An object of parameter values to fill the state's required parameters.
     * @param options Options object. The options are:
     *
     * @returns {string} compiled state url
     */ StateService.prototype.href = function(stateOrName, params, options) {
        var defaultHrefOpts = {
            lossy: true,
            inherit: true,
            absolute: false,
            relative: this.$current
        };
        options = (0, $abcc081e7f2a61c5$export$ebe90cb607ad99e)(options, defaultHrefOpts);
        params = params || {};
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!(0, $c4ca6daaad7210ad$export$4e62c701997796c1)(state)) return null;
        if (options.inherit) params = this.params.$inherit(params, this.$current, state);
        var nav = state && options.lossy ? state.navigable : state;
        if (!nav || nav.url === undefined || nav.url === null) return null;
        return this.router.urlRouter.href(nav.url, params, {
            absolute: options.absolute
        });
    };
    /**
     * Sets or gets the default [[transitionTo]] error handler.
     *
     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
     * This includes errors caused by resolves and transition hooks.
     *
     * Note:
     * This handler does not receive certain Transition rejections.
     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
     *
     * The built-in default error handler logs the error to the console.
     *
     * You can provide your own custom handler.
     *
     * #### Example:
     * ```js
     * stateService.defaultErrorHandler(function() {
     *   // Do not log transitionTo errors
     * });
     * ```
     *
     * @param handler a global error handler function
     * @returns the current global error handler
     */ StateService.prototype.defaultErrorHandler = function(handler) {
        return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function(stateOrName, base) {
        var reg = this.router.stateRegistry;
        if (arguments.length === 0) return reg.get();
        return reg.get(stateOrName, base || this.$current);
    };
    /**
     * Lazy loads a state
     *
     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
     *
     * @param stateOrName the state that should be lazy loaded
     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
     * This noop transition is not actually run.
     *
     * @returns a promise to lazy load
     */ StateService.prototype.lazyLoad = function(stateOrName, transition) {
        var state = this.get(stateOrName);
        if (!state || !state.lazyLoad) throw new Error("Can not lazy load " + stateOrName);
        var currentPath = this.getCurrentPath();
        var target = (0, $50d81baac9264b80$export$39d3fc700b385dc4).makeTargetState(this.router.stateRegistry, currentPath);
        transition = transition || this.router.transitionService.create(currentPath, target);
        return (0, $60602b1583b6ca4f$export$5b0a2f2e644c5813)(transition, state);
    };
    return StateService;
}();



$parcel$exportWildcard($43f58c35eb9265b0$exports, $f1a9eaf39668eb0b$exports);


/**
 * # Transition subsystem
 *
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @packageDocumentation @preferred
 */ 









var $011a70e642c60e72$exports = {};
$parcel$export($011a70e642c60e72$exports, "BaseUrlRule", function () { return $12fa046c73b69b6a$export$9b375b0bfe49c581; });
var $b9412c1ba130bbe1$exports = {};









$parcel$exportWildcard($011a70e642c60e72$exports, $b9412c1ba130bbe1$exports);


var $2d281253f65d4091$exports = {};
$parcel$export($2d281253f65d4091$exports, "ViewService", function () { return $f6ae7a2c459ed9f6$export$e5cb1ae026d0fe73; });
var $444748d0c4f63f24$exports = {};



$parcel$exportWildcard($2d281253f65d4091$exports, $444748d0c4f63f24$exports);




/**
 * Naive, pure JS implementation of core ui-router services
 *
 * @packageDocumentation
 */ var $db28f2a65e245603$exports = {};



var $3007f2ac7ecc3e37$export$d00693a4067fd789 = {
    /** Normalizes a value as a promise */ when: function(val) {
        return new Promise(function(resolve, reject) {
            return resolve(val);
        });
    },
    /** Normalizes a value as a promise rejection */ reject: function(val) {
        return new Promise(function(resolve, reject) {
            reject(val);
        });
    },
    /** @returns a deferred object, which has `resolve` and `reject` functions */ defer: function() {
        var deferred = {};
        deferred.promise = new Promise(function(resolve, reject) {
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    },
    /** Like Promise.all(), but also supports object key/promise notation like $q */ all: function(promises) {
        if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(promises)) return Promise.all(promises);
        if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(promises)) {
            // Convert promises map to promises array.
            // When each promise resolves, map it to a tuple { key: key, val: val }
            var chain = Object.keys(promises).map(function(key) {
                return promises[key].then(function(val) {
                    return {
                        key: key,
                        val: val
                    };
                });
            });
            // Then wait for all promises to resolve, and convert them back to an object
            return $3007f2ac7ecc3e37$export$d00693a4067fd789.all(chain).then(function(values) {
                return values.reduce(function(acc, tuple) {
                    acc[tuple.key] = tuple.val;
                    return acc;
                }, {});
            });
        }
    }
};



// globally available injectables
var $d22e85377babd3af$var$globals = {};
var $d22e85377babd3af$var$STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
var $d22e85377babd3af$var$ARGUMENT_NAMES = /([^\s,]+)/g;
var $d22e85377babd3af$export$d81c24403f86774a = {
    /** Gets an object from DI based on a string token */ get: function(name) {
        return $d22e85377babd3af$var$globals[name];
    },
    /** Returns true if an object named `name` exists in global DI */ has: function(name) {
        return $d22e85377babd3af$export$d81c24403f86774a.get(name) != null;
    },
    /**
     * Injects a function
     *
     * @param fn the function to inject
     * @param context the function's `this` binding
     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
     */ invoke: function(fn, context, locals) {
        var all = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, $d22e85377babd3af$var$globals, locals || {});
        var params = $d22e85377babd3af$export$d81c24403f86774a.annotate(fn);
        var ensureExist = (0, $abcc081e7f2a61c5$export$f31d929251c75416)(function(key) {
            return all.hasOwnProperty(key);
        }, function(key) {
            return "DI can't find injectable: '" + key + "'";
        });
        var args = params.filter(ensureExist).map(function(x) {
            return all[x];
        });
        if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(fn)) return fn.apply(context, args);
        else return fn.slice(-1)[0].apply(context, args);
    },
    /**
     * Returns a function's dependencies
     *
     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
     * @return an array of `string`s
     */ annotate: function(fn) {
        if (!(0, $c4ca6daaad7210ad$export$b0148ad22588aea3)(fn)) throw new Error("Not an injectable function: " + fn);
        if (fn && fn.$inject) return fn.$inject;
        if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(fn)) return fn.slice(0, -1);
        var fnStr = fn.toString().replace($d22e85377babd3af$var$STRIP_COMMENTS, "");
        var result = fnStr.slice(fnStr.indexOf("(") + 1, fnStr.indexOf(")")).match($d22e85377babd3af$var$ARGUMENT_NAMES);
        return result || [];
    }
};




var $db8a9957ed0a7429$export$90e38f9fb20fed9b = function(accum, _a) {
    var key = _a[0], val = _a[1];
    if (!accum.hasOwnProperty(key)) accum[key] = val;
    else if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(accum[key])) accum[key].push(val);
    else accum[key] = [
        accum[key],
        val
    ];
    return accum;
};
var $db8a9957ed0a7429$export$ec161d740909e39d = function(queryString) {
    return queryString.split("&").filter((0, $abcc081e7f2a61c5$export$f0954fd7d5368655)).map((0, $48612b14b235e6fd$export$b2d224173f61ffe5)).reduce($db8a9957ed0a7429$export$90e38f9fb20fed9b, {});
};
function $db8a9957ed0a7429$export$7a5253c0f62e0150(url) {
    var orEmptyString = function(x) {
        return x || "";
    };
    var _a = (0, $48612b14b235e6fd$export$f5b5dbe6ba3ae848)(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
    var _b = (0, $48612b14b235e6fd$export$b5802ef2fc4ab811)(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
    return {
        path: path,
        search: search,
        hash: hash,
        url: url
    };
}
var $db8a9957ed0a7429$export$b5cd97dee32de81d = function(loc) {
    var path = loc.path();
    var searchObject = loc.search();
    var hash = loc.hash();
    var search = Object.keys(searchObject).map(function(key) {
        var param = searchObject[key];
        var vals = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(param) ? param : [
            param
        ];
        return vals.map(function(val) {
            return key + "=" + val;
        });
    }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).join("&");
    return path + (search ? "?" + search : "") + (hash ? "#" + hash : "");
};
function $db8a9957ed0a7429$export$56eddb68e128d8ec(name, isHtml5, serviceClass, configurationClass) {
    return function(uiRouter) {
        var service = uiRouter.locationService = new serviceClass(uiRouter);
        var configuration = uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5);
        function dispose(router) {
            router.dispose(service);
            router.dispose(configuration);
        }
        return {
            name: name,
            service: service,
            configuration: configuration,
            dispose: dispose
        };
    };
}


/** A base `LocationServices` */ var $4799049077f11d9b$export$aeb0e2b30207303e = /** @class */ function() {
    function BaseLocationServices(router, fireAfterUpdate) {
        var _this = this;
        this.fireAfterUpdate = fireAfterUpdate;
        this._listeners = [];
        this._listener = function(evt) {
            return _this._listeners.forEach(function(cb) {
                return cb(evt);
            });
        };
        this.hash = function() {
            return (0, $db8a9957ed0a7429$export$7a5253c0f62e0150)(_this._get()).hash;
        };
        this.path = function() {
            return (0, $db8a9957ed0a7429$export$7a5253c0f62e0150)(_this._get()).path;
        };
        this.search = function() {
            return (0, $db8a9957ed0a7429$export$ec161d740909e39d)((0, $db8a9957ed0a7429$export$7a5253c0f62e0150)(_this._get()).search);
        };
        this._location = (0, $abcc081e7f2a61c5$export$e8e78c978b129247).location;
        this._history = (0, $abcc081e7f2a61c5$export$e8e78c978b129247).history;
    }
    BaseLocationServices.prototype.url = function(url, replace) {
        if (replace === void 0) replace = true;
        if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(url) && url !== this._get()) {
            this._set(null, null, url, replace);
            if (this.fireAfterUpdate) this._listeners.forEach(function(cb) {
                return cb({
                    url: url
                });
            });
        }
        return (0, $db8a9957ed0a7429$export$b5cd97dee32de81d)(this);
    };
    BaseLocationServices.prototype.onChange = function(cb) {
        var _this = this;
        this._listeners.push(cb);
        return function() {
            return (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(_this._listeners, cb);
        };
    };
    BaseLocationServices.prototype.dispose = function(router) {
        (0, $abcc081e7f2a61c5$export$622ff73c0131ee2b)(this._listeners);
    };
    return BaseLocationServices;
}();




var $8adc09029a77e6e1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/** A `LocationServices` that uses the browser hash "#" to get/set the current location */ var $8adc09029a77e6e1$export$37a1b8eec6951538 = /** @class */ function(_super) {
    $8adc09029a77e6e1$var$__extends(HashLocationService, _super);
    function HashLocationService(router) {
        var _this = _super.call(this, router, false) || this;
        (0, $abcc081e7f2a61c5$export$e8e78c978b129247).addEventListener("hashchange", _this._listener, false);
        return _this;
    }
    HashLocationService.prototype._get = function() {
        return (0, $48612b14b235e6fd$export$17cc07cf24d37bb)(this._location.hash);
    };
    HashLocationService.prototype._set = function(state, title, url, replace) {
        this._location.hash = url;
    };
    HashLocationService.prototype.dispose = function(router) {
        _super.prototype.dispose.call(this, router);
        (0, $abcc081e7f2a61c5$export$e8e78c978b129247).removeEventListener("hashchange", this._listener);
    };
    return HashLocationService;
}((0, $4799049077f11d9b$export$aeb0e2b30207303e));



var $09c405d3b398a1af$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/** A `LocationServices` that gets/sets the current location from an in-memory object */ var $09c405d3b398a1af$export$cb035098c85dd4bf = /** @class */ function(_super) {
    $09c405d3b398a1af$var$__extends(MemoryLocationService, _super);
    function MemoryLocationService(router) {
        return _super.call(this, router, true) || this;
    }
    MemoryLocationService.prototype._get = function() {
        return this._url;
    };
    MemoryLocationService.prototype._set = function(state, title, url, replace) {
        this._url = url;
    };
    return MemoryLocationService;
}((0, $4799049077f11d9b$export$aeb0e2b30207303e));




var $c9f2318c2a1b5bb1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
 *
 * Uses `history.pushState` and `history.replaceState`
 */ var $c9f2318c2a1b5bb1$export$fff14ec88e12962b = /** @class */ function(_super) {
    $c9f2318c2a1b5bb1$var$__extends(PushStateLocationService, _super);
    function PushStateLocationService(router) {
        var _this = _super.call(this, router, true) || this;
        _this._config = router.urlService.config;
        (0, $abcc081e7f2a61c5$export$e8e78c978b129247).addEventListener("popstate", _this._listener, false);
        return _this;
    }
    /**
     * Gets the base prefix without:
     * - trailing slash
     * - trailing filename
     * - protocol and hostname
     *
     * If <base href='/base/'>, this returns '/base'.
     * If <base href='/foo/base/'>, this returns '/foo/base'.
     * If <base href='/base/index.html'>, this returns '/base'.
     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
     * If <base href='/base'>, this returns ''.
     * If <base href='http://localhost:8080'>, this returns ''.
     * If <base href='http://localhost:8080/'>, this returns ''.
     *
     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
     */ PushStateLocationService.prototype._getBasePrefix = function() {
        return (0, $48612b14b235e6fd$export$356e6f9ad5e3a83c)(this._config.baseHref());
    };
    PushStateLocationService.prototype._get = function() {
        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
        search = (0, $48612b14b235e6fd$export$b5802ef2fc4ab811)(search)[1]; // strip ? if found
        hash = (0, $48612b14b235e6fd$export$f5b5dbe6ba3ae848)(hash)[1]; // strip # if found
        var basePrefix = this._getBasePrefix();
        var exactBaseHrefMatch = pathname === this._config.baseHref();
        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
        pathname = exactBaseHrefMatch ? "/" : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
        return pathname + (search ? "?" + search : "") + (hash ? "#" + hash : "");
    };
    PushStateLocationService.prototype._set = function(state, title, url, replace) {
        var basePrefix = this._getBasePrefix();
        var slash = url && url[0] !== "/" ? "/" : "";
        var fullUrl = url === "" || url === "/" ? this._config.baseHref() : basePrefix + slash + url;
        if (replace) this._history.replaceState(state, title, fullUrl);
        else this._history.pushState(state, title, fullUrl);
    };
    PushStateLocationService.prototype.dispose = function(router) {
        _super.prototype.dispose.call(this, router);
        (0, $abcc081e7f2a61c5$export$e8e78c978b129247).removeEventListener("popstate", this._listener);
    };
    return PushStateLocationService;
}((0, $4799049077f11d9b$export$aeb0e2b30207303e));




/** A `LocationConfig` mock that gets/sets all config from an in-memory object */ var $ba5269217ab07c70$export$d216a674f3f25049 = /** @class */ function() {
    function MemoryLocationConfig() {
        var _this = this;
        this.dispose = (0, $abcc081e7f2a61c5$export$8793edee2d425525);
        this._baseHref = "";
        this._port = 80;
        this._protocol = "http";
        this._host = "localhost";
        this._hashPrefix = "";
        this.port = function() {
            return _this._port;
        };
        this.protocol = function() {
            return _this._protocol;
        };
        this.host = function() {
            return _this._host;
        };
        this.baseHref = function() {
            return _this._baseHref;
        };
        this.html5Mode = function() {
            return false;
        };
        this.hashPrefix = function(newval) {
            return (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(newval) ? _this._hashPrefix = newval : _this._hashPrefix;
        };
    }
    return MemoryLocationConfig;
}();



/** A `LocationConfig` that delegates to the browser's `location` object */ var $150f9937c297cf8a$export$7fd4834f4e56bbd6 = /** @class */ function() {
    function BrowserLocationConfig(router, _isHtml5) {
        if (_isHtml5 === void 0) _isHtml5 = false;
        this._isHtml5 = _isHtml5;
        this._baseHref = undefined;
        this._hashPrefix = "";
    }
    BrowserLocationConfig.prototype.port = function() {
        if (location.port) return Number(location.port);
        return this.protocol() === "https" ? 443 : 80;
    };
    BrowserLocationConfig.prototype.protocol = function() {
        return location.protocol.replace(/:/g, "");
    };
    BrowserLocationConfig.prototype.host = function() {
        return location.hostname;
    };
    BrowserLocationConfig.prototype.html5Mode = function() {
        return this._isHtml5;
    };
    BrowserLocationConfig.prototype.hashPrefix = function(newprefix) {
        return (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(newprefix) ? this._hashPrefix = newprefix : this._hashPrefix;
    };
    BrowserLocationConfig.prototype.baseHref = function(href) {
        if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(href)) this._baseHref = href;
        if ((0, $c4ca6daaad7210ad$export$fce6876652108ab)(this._baseHref)) this._baseHref = this.getBaseHref();
        return this._baseHref;
    };
    BrowserLocationConfig.prototype.getBaseHref = function() {
        var baseTag = document.getElementsByTagName("base")[0];
        if (baseTag && baseTag.href) return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, "");
        return this._isHtml5 ? "/" : location.pathname || "/";
    };
    BrowserLocationConfig.prototype.dispose = function() {};
    return BrowserLocationConfig;
}();












function $91dac9e04e471db2$export$995e38a46262dd1d(router) {
    (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector = (0, $d22e85377babd3af$export$d81c24403f86774a);
    (0, $e592c26318c32a9d$export$bce7a36871692cab).$q = (0, $3007f2ac7ecc3e37$export$d00693a4067fd789);
    return {
        name: "vanilla.services",
        $q: (0, $3007f2ac7ecc3e37$export$d00693a4067fd789),
        $injector: (0, $d22e85377babd3af$export$d81c24403f86774a),
        dispose: function() {
            return null;
        }
    };
}
var $91dac9e04e471db2$export$42d2f5f22fca08a3 = (0, $db8a9957ed0a7429$export$56eddb68e128d8ec)("vanilla.hashBangLocation", false, (0, $8adc09029a77e6e1$export$37a1b8eec6951538), (0, $150f9937c297cf8a$export$7fd4834f4e56bbd6));
var $91dac9e04e471db2$export$8fd795afd0118b73 = (0, $db8a9957ed0a7429$export$56eddb68e128d8ec)("vanilla.pushStateLocation", true, (0, $c9f2318c2a1b5bb1$export$fff14ec88e12962b), (0, $150f9937c297cf8a$export$7fd4834f4e56bbd6));
var $91dac9e04e471db2$export$ed5c21d1924c39ef = (0, $db8a9957ed0a7429$export$56eddb68e128d8ec)("vanilla.memoryLocation", false, (0, $09c405d3b398a1af$export$cb035098c85dd4bf), (0, $ba5269217ab07c70$export$d216a674f3f25049));






var $4a08003b2e121564$export$4d99b995c55b95f8 = /** @class */ function() {
    function UIRouterPluginBase() {}
    UIRouterPluginBase.prototype.dispose = function(router) {};
    return UIRouterPluginBase;
}();


$parcel$exportWildcard($94fdab24f501d252$exports, $77c96e7df6985fdd$exports);
$parcel$exportWildcard($94fdab24f501d252$exports, $43f58c35eb9265b0$exports);
$parcel$exportWildcard($94fdab24f501d252$exports, $011a70e642c60e72$exports);
$parcel$exportWildcard($94fdab24f501d252$exports, $2d281253f65d4091$exports);


/** @publicapi @module ng1 */ /** */ 
function $56e22b290c726e1d$export$b862df85173fd65b() {
    var templateFactory = null;
    return function(path, view) {
        templateFactory = templateFactory || (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.get("$templateFactory");
        return [
            new $56e22b290c726e1d$export$f3840ea642c0e3ec(path, view, templateFactory)
        ];
    };
}
/** @internalapi */ var $56e22b290c726e1d$var$hasAnyKey = function(keys, obj) {
    return keys.reduce(function(acc, key) {
        return acc || (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(obj[key]);
    }, false);
};
function $56e22b290c726e1d$export$9508ab704d443955(state) {
    // Do not process root state
    if (!state.parent) return {};
    var tplKeys = [
        "templateProvider",
        "templateUrl",
        "template",
        "notify",
        "async"
    ], ctrlKeys = [
        "controller",
        "controllerProvider",
        "controllerAs",
        "resolveAs"
    ], compKeys = [
        "component",
        "bindings",
        "componentProvider"
    ], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
    // Do not allow a state to have both state-level props and also a `views: {}` property.
    // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
    // However, the `$default` approach should not be mixed with a separate `views: ` block.
    if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(state.views) && $56e22b290c726e1d$var$hasAnyKey(allViewKeys, state)) throw new Error("State '" + state.name + "' has a 'views' object. " + 'It cannot also have "view properties" at the state level.  ' + "Move the following properties into a view (in the 'views' object): " + (" " + allViewKeys.filter(function(key) {
        return (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(state[key]);
    }).join(", ")));
    var views = {}, viewsObject = state.views || {
        $default: (0, $abcc081e7f2a61c5$export$357523c63a2253b9)(state, allViewKeys)
    };
    (0, $abcc081e7f2a61c5$export$4b80e395e36b5a56)(viewsObject, function(config, name) {
        // Account for views: { "": { template... } }
        name = name || "$default";
        // Account for views: { header: "headerComponent" }
        if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(config)) config = {
            component: config
        };
        // Make a shallow copy of the config object
        config = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, config);
        // Do not allow a view to mix props for component-style view with props for template/controller-style view
        if ($56e22b290c726e1d$var$hasAnyKey(compKeys, config) && $56e22b290c726e1d$var$hasAnyKey(nonCompKeys, config)) throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: '" + name + "@" + state.name + "'");
        config.resolveAs = config.resolveAs || "$resolve";
        config.$type = "ng1";
        config.$context = state;
        config.$name = name;
        var normalized = (0, $f6ae7a2c459ed9f6$export$e5cb1ae026d0fe73).normalizeUIViewTarget(config.$context, config.$name);
        config.$uiViewName = normalized.uiViewName;
        config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
        views[name] = config;
    });
    return views;
}
/** @hidden */ var $56e22b290c726e1d$var$id = 0;
/** @internalapi */ var $56e22b290c726e1d$export$f3840ea642c0e3ec = /** @class */ function() {
    function Ng1ViewConfig(path, viewDecl, factory) {
        var _this = this;
        this.path = path;
        this.viewDecl = viewDecl;
        this.factory = factory;
        this.$id = $56e22b290c726e1d$var$id++;
        this.loaded = false;
        this.getTemplate = function(uiView, context) {
            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
        };
    }
    Ng1ViewConfig.prototype.load = function() {
        var _this = this;
        var $q = (0, $e592c26318c32a9d$export$bce7a36871692cab).$q;
        var context = new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(this.path);
        var params = this.path.reduce(function(acc, node) {
            return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(acc, node.paramValues);
        }, {});
        var promises = {
            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
            controller: $q.when(this.getController(context))
        };
        return $q.all(promises).then(function(results) {
            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceViewServiceEvent("Loaded", _this);
            _this.controller = results.controller;
            (0, $abcc081e7f2a61c5$export$8b58be045bf06082)(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
            return _this;
        });
    };
    /**
     * Gets the controller for a view configuration.
     *
     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
     */ Ng1ViewConfig.prototype.getController = function(context) {
        var provider = this.viewDecl.controllerProvider;
        if (!(0, $c4ca6daaad7210ad$export$b0148ad22588aea3)(provider)) return this.viewDecl.controller;
        var deps = (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.annotate(provider);
        var providerFn = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(provider) ? (0, $abcc081e7f2a61c5$export$c01875f616615628)(provider) : provider;
        var resolvable = new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)("", providerFn, deps);
        return resolvable.get(context);
    };
    return Ng1ViewConfig;
}();


/** @publicapi @module view */ /** */ 

/**
 * Service which manages loading of templates from a ViewConfig.
 */ var $e9bbee89ed03e986$export$4eb8a7b8087cc6fe = /** @class */ function() {
    function TemplateFactory() {
        var _this = this;
        /** @hidden */ this._useHttp = (0, $c3628d2e76534866$export$acc5bfffa76564ff).version.minor < 3;
        /** @hidden */ this.$get = [
            "$http",
            "$templateCache",
            "$injector",
            function($http, $templateCache, $injector) {
                _this.$templateRequest = $injector.has && $injector.has("$templateRequest") && $injector.get("$templateRequest");
                _this.$http = $http;
                _this.$templateCache = $templateCache;
                return _this;
            }
        ];
    }
    /** @hidden */ TemplateFactory.prototype.useHttpService = function(value) {
        this._useHttp = value;
    };
    /**
     * Creates a template from a configuration object.
     *
     * @param config Configuration object for which to load a template.
     * The following properties are search in the specified order, and the first one
     * that is defined is used to create the template:
     *
     * @param params  Parameters to pass to the template function.
     * @param context The resolve context associated with the template's view
     *
     * @return {string|object}  The template html as a string, or a promise for
     * that string,or `null` if no template is configured.
     */ TemplateFactory.prototype.fromConfig = function(config, params, context) {
        var defaultTemplate = "<ui-view></ui-view>";
        var asTemplate = function(result) {
            return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(result).then(function(str) {
                return {
                    template: str
                };
            });
        };
        var asComponent = function(result) {
            return (0, $e592c26318c32a9d$export$bce7a36871692cab).$q.when(result).then(function(str) {
                return {
                    component: str
                };
            });
        };
        return (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.template) ? asTemplate(this.fromString(config.template, params)) : (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) : (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) : (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.component) ? asComponent(config.component) : (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) : asTemplate(defaultTemplate);
    };
    /**
     * Creates a template from a string or a function returning a string.
     *
     * @param template html template as a string or function that returns an html template as a string.
     * @param params Parameters to pass to the template function.
     *
     * @return {string|object} The template html as a string, or a promise for that
     * string.
     */ TemplateFactory.prototype.fromString = function(template, params) {
        return (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(template) ? template(params) : template;
    };
    /**
     * Loads a template from the a URL via `$http` and `$templateCache`.
     *
     * @param {string|Function} url url of the template to load, or a function
     * that returns a url.
     * @param {Object} params Parameters to pass to the url function.
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */ TemplateFactory.prototype.fromUrl = function(url, params) {
        if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(url)) url = url(params);
        if (url == null) return null;
        if (this._useHttp) return this.$http.get(url, {
            cache: this.$templateCache,
            headers: {
                Accept: "text/html"
            }
        }).then(function(response) {
            return response.data;
        });
        return this.$templateRequest(url);
    };
    /**
     * Creates a template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */ TemplateFactory.prototype.fromProvider = function(provider, params, context) {
        var deps = (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.annotate(provider);
        var providerFn = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(provider) ? (0, $abcc081e7f2a61c5$export$c01875f616615628)(provider) : provider;
        var resolvable = new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)("", providerFn, deps);
        return resolvable.get(context);
    };
    /**
     * Creates a component's template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */ TemplateFactory.prototype.fromComponentProvider = function(provider, params, context) {
        var deps = (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.annotate(provider);
        var providerFn = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(provider) ? (0, $abcc081e7f2a61c5$export$c01875f616615628)(provider) : provider;
        var resolvable = new (0, $a8c7bb6ec3d477e6$export$2e89fd61b0c5c49e)("", providerFn, deps);
        return resolvable.get(context);
    };
    /**
     * Creates a template from a component's name
     *
     * This implements route-to-component.
     * It works by retrieving the component (directive) metadata from the injector.
     * It analyses the component's bindings, then constructs a template that instantiates the component.
     * The template wires input and output bindings to resolves or from the parent component.
     *
     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
     * @param component {string} Component's name in camel case.
     * @param bindings An object defining the component's bindings: {foo: '<'}
     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */ TemplateFactory.prototype.makeComponentTemplate = function(uiView, context, component, bindings) {
        bindings = bindings || {};
        // Bind once prefix
        var prefix = (0, $c3628d2e76534866$export$acc5bfffa76564ff).version.minor >= 3 ? "::" : "";
        // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
        var kebob = function(camelCase) {
            var kebobed = (0, $48612b14b235e6fd$export$7e12dc7ef150dc64)(camelCase);
            return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
        };
        var attributeTpl = function(input) {
            var name = input.name, type = input.type;
            var attrName = kebob(name);
            // If the ui-view has an attribute which matches a binding on the routed component
            // then pass that attribute through to the routed component template.
            // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
            if (uiView.attr(attrName) && !bindings[name]) return attrName + "='" + uiView.attr(attrName) + "'";
            var resolveName = bindings[name] || name;
            // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
            // some-attr="{{ ::$resolve.someResolveName }}"
            if (type === "@") return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
            // Wire "&" callbacks to resolves that return a callback function
            // Get the result of the resolve (should be a function) and annotate it to get its arguments.
            // some-attr="$resolve.someResolveResultName(foo, bar)"
            if (type === "&") {
                var res = context.getResolvable(resolveName);
                var fn = res && res.data;
                var args = fn && (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.annotate(fn) || [];
                // account for array style injection, i.e., ['foo', function(foo) {}]
                var arrayIdxStr = (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(fn) ? "[" + (fn.length - 1) + "]" : "";
                return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(",") + ")'";
            }
            // some-attr="::$resolve.someResolveName"
            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
        };
        var attrs = $e9bbee89ed03e986$var$getComponentBindings(component).map(attributeTpl).join(" ");
        var kebobName = kebob(component);
        return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
    };
    return TemplateFactory;
}();
// Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
function $e9bbee89ed03e986$var$getComponentBindings(name) {
    var cmpDefs = (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.get(name + "Directive"); // could be multiple
    if (!cmpDefs || !cmpDefs.length) throw new Error("Unable to find component named '" + name + "'");
    return cmpDefs.map($e9bbee89ed03e986$var$getBindings).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
}
// Given a directive definition, find its object input attributes
// Use different properties, depending on the type of directive (component, bindToController, normal)
var $e9bbee89ed03e986$var$getBindings = function(def) {
    if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(def.bindToController)) return $e9bbee89ed03e986$var$scopeBindings(def.bindToController);
    return $e9bbee89ed03e986$var$scopeBindings(def.scope);
};
// for ng 1.2 style, process the scope: { input: "=foo" }
// for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
var $e9bbee89ed03e986$var$scopeBindings = function(bindingsObj) {
    return Object.keys(bindingsObj || {})// [ 'input', [ '=foo', '=', 'foo' ] ]
    .map(function(key) {
        return [
            key,
            /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])
        ];
    })// skip malformed values
    .filter(function(tuple) {
        return (0, $c4ca6daaad7210ad$export$4e62c701997796c1)(tuple) && (0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(tuple[1]);
    })// { name: ('foo' || 'input'), type: '=' }
    .map(function(tuple) {
        return {
            name: tuple[1][2] || tuple[0],
            type: tuple[1][1]
        };
    });
};


/** @publicapi @module ng1 */ /** */ 
/**
 * The Angular 1 `StateProvider`
 *
 * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */ var $013ce14ae1e1373d$export$e5cc2dfc1df151ff = /** @class */ function() {
    function StateProvider(stateRegistry, stateService) {
        this.stateRegistry = stateRegistry;
        this.stateService = stateService;
        (0, $abcc081e7f2a61c5$export$a6c115f931de9046)((0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(StateProvider.prototype), this, (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)(this));
    }
    /**
     * Decorates states when they are registered
     *
     * Allows you to extend (carefully) or override (at your own peril) the
     * `stateBuilder` object used internally by [[StateRegistry]].
     * This can be used to add custom functionality to ui-router,
     * for example inferring templateUrl based on the state name.
     *
     * When passing only a name, it returns the current (original or decorated) builder
     * function that matches `name`.
     *
     * The builder functions that can be decorated are listed below. Though not all
     * necessarily have a good use case for decoration, that is up to you to decide.
     *
     * In addition, users can attach custom decorators, which will generate new
     * properties within the state's internal definition. There is currently no clear
     * use-case for this beyond accessing internal states (i.e. $state.$current),
     * however, expect this to become increasingly relevant as we introduce additional
     * meta-programming features.
     *
     * **Warning**: Decorators should not be interdependent because the order of
     * execution of the builder functions in non-deterministic. Builder functions
     * should only be dependent on the state definition object and super function.
     *
     *
     * Existing builder functions and current return values:
     *
     * - **parent** `{object}` - returns the parent state object.
     * - **data** `{object}` - returns state data, including any inherited data that is not
     *   overridden by own values (if any).
     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
     *   or `null`.
     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
     *   navigable).
     * - **params** `{object}` - returns an array of state params that are ensured to
     *   be a super-set of parent's params.
     * - **views** `{object}` - returns a views object where each key is an absolute view
     *   name (i.e. "viewName@stateName") and each value is the config object
     *   (template, controller) for the view. Even when you don't use the views object
     *   explicitly on a state config, one is still created for you internally.
     *   So by decorating this builder function you have access to decorating template
     *   and controller properties.
     * - **ownParams** `{object}` - returns an array of params that belong to the state,
     *   not including any params defined by ancestor states.
     * - **path** `{string}` - returns the full path from the root down to this state.
     *   Needed for state activation.
     * - **includes** `{object}` - returns an object that includes every state that
     *   would pass a `$state.includes()` test.
     *
     * #### Example:
     * Override the internal 'views' builder with a function that takes the state
     * definition, and a reference to the internal function being overridden:
     * ```js
     * $stateProvider.decorator('views', function (state, parent) {
     *   let result = {},
     *       views = parent(state);
     *
     *   angular.forEach(views, function (config, name) {
     *     let autoName = (state.name + '.' + name).replace('.', '/');
     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
     *     result[name] = config;
     *   });
     *   return result;
     * });
     *
     * $stateProvider.state('home', {
     *   views: {
     *     'contact.list': { controller: 'ListController' },
     *     'contact.item': { controller: 'ItemController' }
     *   }
     * });
     * ```
     *
     *
     * ```js
     * // Auto-populates list and item views with /partials/home/contact/list.html,
     * // and /partials/home/contact/item.html, respectively.
     * $state.go('home');
     * ```
     *
     * @param {string} name The name of the builder function to decorate.
     * @param {object} func A function that is responsible for decorating the original
     * builder function. The function receives two parameters:
     *
     *   - `{object}` - state - The state config object.
     *   - `{object}` - super - The original builder function.
     *
     * @return {object} $stateProvider - $stateProvider instance
     */ StateProvider.prototype.decorator = function(name, func) {
        return this.stateRegistry.decorator(name, func) || this;
    };
    StateProvider.prototype.state = function(name, definition) {
        if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(name)) definition = name;
        else definition.name = name;
        this.stateRegistry.register(definition);
        return this;
    };
    /**
     * Registers an invalid state handler
     *
     * This is a passthrough to [[StateService.onInvalid]] for ng1.
     */ StateProvider.prototype.onInvalid = function(callback) {
        return this.stateService.onInvalid(callback);
    };
    return StateProvider;
}();


/** @publicapi @module ng1 */ /** */ 

var $a14af49b8cb538d4$export$4d008df77245ddf5 = function(hookName) {
    return function stateHookBuilder(stateObject) {
        var hook = stateObject[hookName];
        var pathname = hookName === "onExit" ? "from" : "to";
        function decoratedNg1Hook(trans, state) {
            var resolveContext = new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(trans.treeChanges(pathname));
            var subContext = resolveContext.subContext(state.$$state());
            var locals = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)((0, $7399b8d73510942f$export$379cba1caf1a83)(subContext), {
                $state$: state,
                $transition$: trans
            });
            return (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.invoke(hook, this, locals);
        }
        return hook ? decoratedNg1Hook : undefined;
    };
};


/** @publicapi @module ng1 */ /** */ 
/**
 * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
 * @internalapi
 */ var $6dcc6a8e1cde482d$export$c40f492c5c94daa = /** @class */ function() {
    function Ng1LocationServices($locationProvider) {
        // .onChange() registry
        this._urlListeners = [];
        this.$locationProvider = $locationProvider;
        var _lp = (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)($locationProvider);
        (0, $abcc081e7f2a61c5$export$a6c115f931de9046)(_lp, this, _lp, [
            "hashPrefix"
        ]);
    }
    /**
     * Applys ng1-specific path parameter encoding
     *
     * The Angular 1 `$location` service is a bit weird.
     * It doesn't allow slashes to be encoded/decoded bi-directionally.
     *
     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
     *
     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
     *
     * @param router
     */ Ng1LocationServices.monkeyPatchPathParameterType = function(router) {
        var pathType = router.urlMatcherFactory.type("path");
        pathType.encode = function(x) {
            return x != null ? x.toString().replace(/(~|\/)/g, function(m) {
                return ({
                    "~": "~~",
                    "/": "~2F"
                })[m];
            }) : x;
        };
        pathType.decode = function(x) {
            return x != null ? x.toString().replace(/(~~|~2F)/g, function(m) {
                return ({
                    "~~": "~",
                    "~2F": "/"
                })[m];
            }) : x;
        };
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    Ng1LocationServices.prototype.dispose = function() {};
    Ng1LocationServices.prototype.onChange = function(callback) {
        var _this = this;
        this._urlListeners.push(callback);
        return function() {
            return (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(_this._urlListeners)(callback);
        };
    };
    Ng1LocationServices.prototype.html5Mode = function() {
        var html5Mode = this.$locationProvider.html5Mode();
        html5Mode = (0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(html5Mode) ? html5Mode.enabled : html5Mode;
        return html5Mode && this.$sniffer.history;
    };
    Ng1LocationServices.prototype.baseHref = function() {
        return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
    };
    Ng1LocationServices.prototype.url = function(newUrl, replace, state) {
        if (replace === void 0) replace = false;
        if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(newUrl)) this.$location.url(newUrl);
        if (replace) this.$location.replace();
        if (state) this.$location.state(state);
        return this.$location.url();
    };
    Ng1LocationServices.prototype._runtimeServices = function($rootScope, $location, $sniffer, $browser, $window) {
        var _this = this;
        this.$location = $location;
        this.$sniffer = $sniffer;
        this.$browser = $browser;
        this.$window = $window;
        // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
        $rootScope.$on("$locationChangeSuccess", function(evt) {
            return _this._urlListeners.forEach(function(fn) {
                return fn(evt);
            });
        });
        var _loc = (0, $b94057b5b409b0b1$export$b02c28252f48c6ac)($location);
        // Bind these LocationService functions to $location
        (0, $abcc081e7f2a61c5$export$a6c115f931de9046)(_loc, this, _loc, [
            "replace",
            "path",
            "search",
            "hash"
        ]);
        // Bind these LocationConfig functions to $location
        (0, $abcc081e7f2a61c5$export$a6c115f931de9046)(_loc, this, _loc, [
            "port",
            "protocol",
            "host"
        ]);
    };
    return Ng1LocationServices;
}();


/** @publicapi @module url */ /** */ 
/**
 * Manages rules for client-side URL
 *
 * ### Deprecation warning:
 * This class is now considered to be an internal API
 * Use the [[UrlService]] instead.
 * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
 *
 * This class manages the router rules for what to do when the URL changes.
 *
 * This provider remains for backwards compatibility.
 *
 * @internalapi
 * @deprecated
 */ var $5e21cc494363ac2c$export$ffc0dd28386fd9cc = /** @class */ function() {
    /** @hidden */ function UrlRouterProvider(/** @hidden */ router) {
        this.router = router;
    }
    UrlRouterProvider.injectableHandler = function(router, handler) {
        return function(match) {
            return (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector.invoke(handler, null, {
                $match: match,
                $stateParams: router.globals.params
            });
        };
    };
    /** @hidden */ UrlRouterProvider.prototype.$get = function() {
        var urlService = this.router.urlService;
        this.router.urlRouter.update(true);
        if (!urlService.interceptDeferred) urlService.listen();
        return this.router.urlRouter;
    };
    /**
     * Registers a url handler function.
     *
     * Registers a low level url handler (a `rule`).
     * A rule detects specific URL patterns and returns a redirect, or performs some action.
     *
     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Here's an example of how you might allow case insensitive urls
     *   $urlRouterProvider.rule(function ($injector, $location) {
     *     var path = $location.path(),
     *         normalized = path.toLowerCase();
     *
     *     if (path !== normalized) {
     *       return normalized;
     *     }
     *   });
     * });
     * ```
     *
     * @param ruleFn
     * Handler function that takes `$injector` and `$location` services as arguments.
     * You can use them to detect a url and return a different url as a string.
     *
     * @return [[UrlRouterProvider]] (`this`)
     */ UrlRouterProvider.prototype.rule = function(ruleFn) {
        var _this = this;
        if (!(0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(ruleFn)) throw new Error("'rule' must be a function");
        var match = function() {
            return ruleFn((0, $e592c26318c32a9d$export$bce7a36871692cab).$injector, _this.router.locationService);
        };
        var rule = new (0, $12fa046c73b69b6a$export$9b375b0bfe49c581)(match, (0, $abcc081e7f2a61c5$export$f0954fd7d5368655));
        this.router.urlService.rules.rule(rule);
        return this;
    };
    /**
     * Defines the path or behavior to use when no url can be matched.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // if the path doesn't match any of the urls you configured
     *   // otherwise will take care of routing the user to the
     *   // specified url
     *   $urlRouterProvider.otherwise('/index');
     *
     *   // Example of using function rule as param
     *   $urlRouterProvider.otherwise(function ($injector, $location) {
     *     return '/a/valid/url';
     *   });
     * });
     * ```
     *
     * @param rule
     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
     *
     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
     */ UrlRouterProvider.prototype.otherwise = function(rule) {
        var _this = this;
        var urlRules = this.router.urlService.rules;
        if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(rule)) urlRules.otherwise(rule);
        else if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(rule)) urlRules.otherwise(function() {
            return rule((0, $e592c26318c32a9d$export$bce7a36871692cab).$injector, _this.router.locationService);
        });
        else throw new Error("'rule' must be a string or function");
        return this;
    };
    /**
     * Registers a handler for a given url matching.
     *
     * If the handler is a string, it is
     * treated as a redirect, and is interpolated according to the syntax of match
     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
     *
     * If the handler is a function, it is injectable.
     * It gets invoked if `$location` matches.
     * You have the option of inject the match object as `$match`.
     *
     * The handler can return
     *
     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
     *   will continue trying to find another one that matches.
     * - **string** which is treated as a redirect and passed to `$location.url()`
     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
     *     if ($state.$current.navigable !== state ||
     *         !equalForKeys($match, $stateParams) {
     *      $state.transitionTo(state, $match, false);
     *     }
     *   });
     * });
     * ```
     *
     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
     * @param handler The path (or function that returns a path) that you want to redirect your user to.
     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
     *
     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
     */ UrlRouterProvider.prototype.when = function(what, handler) {
        if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(handler) || (0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(handler)) handler = UrlRouterProvider.injectableHandler(this.router, handler);
        this.router.urlService.rules.when(what, handler);
        return this;
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Prevent $urlRouter from automatically intercepting URL changes;
     *   $urlRouterProvider.deferIntercept();
     * })
     *
     * app.run(function (MyService, $urlRouter, $http) {
     *   $http.get("/stuff").then(function(resp) {
     *     MyService.doStuff(resp.data);
     *     $urlRouter.listen();
     *     $urlRouter.sync();
     *   });
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */ UrlRouterProvider.prototype.deferIntercept = function(defer) {
        this.router.urlService.deferIntercept(defer);
    };
    return UrlRouterProvider;
}();


(0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.angular1", []);
var $7399b8d73510942f$var$mod_init = (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.init", [
    "ng"
]);
var $7399b8d73510942f$var$mod_util = (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.util", [
    "ui.router.init"
]);
var $7399b8d73510942f$var$mod_rtr = (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.router", [
    "ui.router.util"
]);
var $7399b8d73510942f$var$mod_state = (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.state", [
    "ui.router.router",
    "ui.router.util",
    "ui.router.angular1"
]);
var $7399b8d73510942f$var$mod_main = (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router", [
    "ui.router.init",
    "ui.router.state",
    "ui.router.angular1"
]);
var $7399b8d73510942f$var$mod_cmpt = (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.compat", [
    "ui.router"
]);
var $7399b8d73510942f$var$router = null;
$7399b8d73510942f$var$$uiRouterProvider.$inject = [
    "$locationProvider"
];
/** This angular 1 provider instantiates a Router and exposes its services via the angular injector */ function $7399b8d73510942f$var$$uiRouterProvider($locationProvider) {
    // Create a new instance of the Router when the $uiRouterProvider is initialized
    $7399b8d73510942f$var$router = this.router = new (0, $5e4c6b2b8af047a3$export$34bda4031e17f347)();
    $7399b8d73510942f$var$router.stateProvider = new (0, $013ce14ae1e1373d$export$e5cc2dfc1df151ff)($7399b8d73510942f$var$router.stateRegistry, $7399b8d73510942f$var$router.stateService);
    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
    $7399b8d73510942f$var$router.stateRegistry.decorator("views", (0, $56e22b290c726e1d$export$9508ab704d443955));
    $7399b8d73510942f$var$router.stateRegistry.decorator("onExit", (0, $a14af49b8cb538d4$export$4d008df77245ddf5)("onExit"));
    $7399b8d73510942f$var$router.stateRegistry.decorator("onRetain", (0, $a14af49b8cb538d4$export$4d008df77245ddf5)("onRetain"));
    $7399b8d73510942f$var$router.stateRegistry.decorator("onEnter", (0, $a14af49b8cb538d4$export$4d008df77245ddf5)("onEnter"));
    $7399b8d73510942f$var$router.viewService._pluginapi._viewConfigFactory("ng1", (0, $56e22b290c726e1d$export$b862df85173fd65b)());
    // Disable decoding of params by UrlMatcherFactory because $location already handles this
    $7399b8d73510942f$var$router.urlService.config._decodeParams = false;
    var ng1LocationService = $7399b8d73510942f$var$router.locationService = $7399b8d73510942f$var$router.locationConfig = new (0, $6dcc6a8e1cde482d$export$c40f492c5c94daa)($locationProvider);
    (0, $6dcc6a8e1cde482d$export$c40f492c5c94daa).monkeyPatchPathParameterType($7399b8d73510942f$var$router);
    // backwards compat: also expose router instance as $uiRouterProvider.router
    $7399b8d73510942f$var$router["router"] = $7399b8d73510942f$var$router;
    $7399b8d73510942f$var$router["$get"] = $get;
    $get.$inject = [
        "$location",
        "$browser",
        "$window",
        "$sniffer",
        "$rootScope",
        "$http",
        "$templateCache"
    ];
    function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
        ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
        delete $7399b8d73510942f$var$router["router"];
        delete $7399b8d73510942f$var$router["$get"];
        return $7399b8d73510942f$var$router;
    }
    return $7399b8d73510942f$var$router;
}
var $7399b8d73510942f$var$getProviderFor = function(serviceName) {
    return [
        "$uiRouterProvider",
        function($urp) {
            var service = $urp.router[serviceName];
            service["$get"] = function() {
                return service;
            };
            return service;
        }
    ];
};
// This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
$7399b8d73510942f$var$runBlock.$inject = [
    "$injector",
    "$q",
    "$uiRouter"
];
function $7399b8d73510942f$var$runBlock($injector, $q, $uiRouter) {
    (0, $e592c26318c32a9d$export$bce7a36871692cab).$injector = $injector;
    (0, $e592c26318c32a9d$export$bce7a36871692cab).$q = $q;
    // https://github.com/angular-ui/ui-router/issues/3678
    if (!Object.prototype.hasOwnProperty.call($injector, "strictDi")) try {
        $injector.invoke(function(checkStrictDi) {});
    } catch (error) {
        $injector.strictDi = !!/strict mode/.exec(error && error.toString());
    }
    // The $injector is now available.
    // Find any resolvables that had dependency annotation deferred
    $uiRouter.stateRegistry.get().map(function(x) {
        return x.$$state().resolvables;
    }).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []).filter(function(x) {
        return x.deps === "deferred";
    }).forEach(function(resolvable) {
        return resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi);
    });
}
// $urlRouter service and $urlRouterProvider
var $7399b8d73510942f$var$getUrlRouterProvider = function(uiRouter) {
    return uiRouter.urlRouterProvider = new (0, $5e21cc494363ac2c$export$ffc0dd28386fd9cc)(uiRouter);
};
// $state service and $stateProvider
// $urlRouter service and $urlRouterProvider
var $7399b8d73510942f$var$getStateProvider = function() {
    return (0, $abcc081e7f2a61c5$export$8b58be045bf06082)($7399b8d73510942f$var$router.stateProvider, {
        $get: function() {
            return $7399b8d73510942f$var$router.stateService;
        }
    });
};
$7399b8d73510942f$export$58e5b1607c6b5b16.$inject = [
    "$rootScope"
];
function $7399b8d73510942f$export$58e5b1607c6b5b16($rootScope) {
    $rootScope.$watch(function() {
        (0, $42b3df7fa4bc82fe$export$357889f174732d38).approximateDigests++;
    });
}
$7399b8d73510942f$var$mod_init.provider("$uiRouter", $7399b8d73510942f$var$$uiRouterProvider);
$7399b8d73510942f$var$mod_rtr.provider("$urlRouter", [
    "$uiRouterProvider",
    $7399b8d73510942f$var$getUrlRouterProvider
]);
$7399b8d73510942f$var$mod_util.provider("$urlService", $7399b8d73510942f$var$getProviderFor("urlService"));
$7399b8d73510942f$var$mod_util.provider("$urlMatcherFactory", [
    "$uiRouterProvider",
    function() {
        return $7399b8d73510942f$var$router.urlMatcherFactory;
    }
]);
$7399b8d73510942f$var$mod_util.provider("$templateFactory", function() {
    return new (0, $e9bbee89ed03e986$export$4eb8a7b8087cc6fe)();
});
$7399b8d73510942f$var$mod_state.provider("$stateRegistry", $7399b8d73510942f$var$getProviderFor("stateRegistry"));
$7399b8d73510942f$var$mod_state.provider("$uiRouterGlobals", $7399b8d73510942f$var$getProviderFor("globals"));
$7399b8d73510942f$var$mod_state.provider("$transitions", $7399b8d73510942f$var$getProviderFor("transitionService"));
$7399b8d73510942f$var$mod_state.provider("$state", [
    "$uiRouterProvider",
    $7399b8d73510942f$var$getStateProvider
]);
$7399b8d73510942f$var$mod_state.factory("$stateParams", [
    "$uiRouter",
    function($uiRouter) {
        return $uiRouter.globals.params;
    }
]);
$7399b8d73510942f$var$mod_main.factory("$view", function() {
    return $7399b8d73510942f$var$router.viewService;
});
$7399b8d73510942f$var$mod_main.service("$trace", function() {
    return 0, $42b3df7fa4bc82fe$export$357889f174732d38;
});
$7399b8d73510942f$var$mod_main.run($7399b8d73510942f$export$58e5b1607c6b5b16);
$7399b8d73510942f$var$mod_util.run([
    "$urlMatcherFactory",
    function($urlMatcherFactory) {}
]);
$7399b8d73510942f$var$mod_state.run([
    "$state",
    function($state) {}
]);
$7399b8d73510942f$var$mod_rtr.run([
    "$urlRouter",
    function($urlRouter) {}
]);
$7399b8d73510942f$var$mod_init.run($7399b8d73510942f$var$runBlock);
var $7399b8d73510942f$export$379cba1caf1a83 = function(ctx) {
    var tokens = ctx.getTokens().filter((0, $c4ca6daaad7210ad$export$844ec244b1367d54));
    var tuples = tokens.map(function(key) {
        var resolvable = ctx.getResolvable(key);
        var waitPolicy = ctx.getPolicy(resolvable).async;
        return [
            key,
            waitPolicy === "NOWAIT" ? resolvable.promise : resolvable.data
        ];
    });
    return tuples.reduce((0, $abcc081e7f2a61c5$export$448afb43435ef71e), {});
};





/**
 * The current (or pending) State Parameters
 *
 * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
 *
 * The values are not updated until *after* a `Transition` successfully completes.
 *
 * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
 *
 * ### Deprecation warning:
 *
 * The value injected for `$stateParams` is different depending on where it is injected.
 *
 * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
 * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
 *
 * Because of these confusing details, this service is deprecated.
 *
 * ### Instead of using the global `$stateParams` service object,
 * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
 *
 * ```js
 * MyService.$inject = ['$uiRouterGlobals'];
 * function MyService($uiRouterGlobals) {
 *   return {
 *     paramValues: function () {
 *       return $uiRouterGlobals.params;
 *     }
 *   }
 * }
 * ```
 *
 * ### Instead of using the per-transition `$stateParams` object,
 * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
 *
 * ```js
 * MyController.$inject = ['$transition$'];
 * function MyController($transition$) {
 *   var username = $transition$.params().username;
 *   // .. do something with username
 * }
 * ```
 *
 * ---
 *
 * This object can be injected into other services.
 *
 * #### Deprecated Example:
 * ```js
 * SomeService.$inject = ['$http', '$stateParams'];
 * function SomeService($http, $stateParams) {
 *   return {
 *     getUser: function() {
 *       return $http.get('/api/users/' + $stateParams.username);
 *     }
 *   }
 * };
 * angular.service('SomeService', SomeService);
 * ```
 * @deprecated
 */ var $ff77adb66a4c9c1e$var$$stateParams;
/**
 * Global UI-Router variables
 *
 * The router global state as a **Service Object** (injectable during runtime).
 *
 * This object contains globals such as the current state and current parameter values.
 */ var $ff77adb66a4c9c1e$var$$uiRouterGlobals;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Service Object** (injectable during runtime).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouterProvider]] for injection during angular config time.
 */ var $ff77adb66a4c9c1e$var$$uiRouter;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Provider Object** (injectable during config phase).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouter]] for injection during runtime.
 */ var $ff77adb66a4c9c1e$var$$uiRouterProvider;
/**
 * Transition debug/tracing
 *
 * The [[Trace]] singleton as a **Service Object** (injectable during runtime).
 *
 * Enables or disables Transition tracing which can help to debug issues.
 */ var $ff77adb66a4c9c1e$var$$trace;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitionsProvider]] for injection during the config phase.
 */ var $ff77adb66a4c9c1e$var$$transitions;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Provider Object** (injectable during config phase)
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitions]] for injection during runtime.
 */ var $ff77adb66a4c9c1e$var$$transitionsProvider;
/**
 * The current [[Transition]] object
 *
 * The current [[Transition]] object as a **Per-Transition Object** (injectable into Resolve, Hooks, Controllers)
 *
 * This object returns information about the current transition, including:
 *
 * - To/from states
 * - To/from parameters
 * - Transition options
 * - States being entered, exited, and retained
 * - Resolve data
 * - A Promise for the transition
 * - Any transition failure information
 * - An injector for both Service and Per-Transition Objects
 */ var $ff77adb66a4c9c1e$var$$transition$;
/**
 * The State Service
 *
 * The [[StateService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service used to manage and query information on registered states.
 * It exposes state related APIs including:
 *
 * - Start a [[Transition]]
 * - Imperatively lazy load states
 * - Check if a state is currently active
 * - Look up states by name
 * - Build URLs for a state+parameters
 * - Configure the global Transition error handler
 *
 * This angular service exposes the [[StateService]] singleton.
 */ var $ff77adb66a4c9c1e$var$$state;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistryProvider]] for injection during the config phase.
 */ var $ff77adb66a4c9c1e$var$$stateRegistry;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistry]] for injection during runtime.
 */ var $ff77adb66a4c9c1e$var$$stateRegistryProvider;
/**
 * The View Scroll provider
 *
 * The [[UIViewScrollProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[UIViewScrollProvider]] singleton and is
 * used to disable UI-Router's scroll behavior.
 */ var $ff77adb66a4c9c1e$var$$uiViewScrollProvider;
/**
 * The View Scroll function
 *
 * The View Scroll function as a **Service Object** (injectable during runtime).
 *
 * This is a function that scrolls an element into view.
 * The element is scrolled after a `$timeout` so the DOM has time to refresh.
 *
 * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
 * this can be enabled by calling [[UIViewScrollProvider.useAnchorScroll]].
 *
 * Note: this function is used by the [[directives.uiView]] when the `autoscroll` expression evaluates to true.
 */ var $ff77adb66a4c9c1e$var$$uiViewScroll;
/**
 * The StateProvider
 *
 * An angular1-only [[StateProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[StateProvider]] singleton.
 *
 * The `StateProvider` is primarily used to register states or add custom state decorators.
 *
 * ##### Note: This provider is a ng1 vestige.
 * It is a passthrough to [[$stateRegistry]] and [[$state]].
 */ var $ff77adb66a4c9c1e$var$$stateProvider;
/**
 * The URL Service Provider
 *
 * The [[UrlService]] singleton as a **Provider Object** (injectable during the angular config phase).
 *
 * A service used to configure and interact with the URL.
 * It has URL related APIs including:
 *
 * - register custom Parameter types `UrlService.config.type` ([[UrlConfigApi.type]])
 * - add URL rules: `UrlService.rules.when` ([[UrlRulesApi.when]])
 * - configure behavior when no url matches: `UrlService.rules.otherwise` ([[UrlRulesApi.otherwise]])
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during runtime as [[$urlService]].
 */ var $ff77adb66a4c9c1e$var$$urlServiceProvider;
/**
 * The URL Service
 *
 * The [[UrlService]] singleton as a **Service Object** (injectable during runtime).
 *
 * Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 *
 * Used to configure the URL.
 * It has URL related APIs including:
 *
 * - register custom Parameter types `UrlService.config.type` ([[UrlConfigApi.type]])
 * - add URL rules: `UrlService.rules.when` ([[UrlRulesApi.when]])
 * - configure behavior when no url matches: `UrlService.rules.otherwise` ([[UrlRulesApi.otherwise]])
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 */ var $ff77adb66a4c9c1e$var$$urlService;
/**
 * The URL Router Provider
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlServiceProvider]] instead.
 *
 * The [[UrlRouter]] singleton as a **Provider Object** (injectable during config time).
 *
 * #### Note: This object is also exposed as [[$urlRouter]] for injection during runtime.
 *
 * @deprecated
 */ var $ff77adb66a4c9c1e$var$$urlRouterProvider;
/**
 * The Url Router
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlService]] instead.
 *
 * The [[UrlRouter]] singleton as a **Service Object** (injectable during runtime).
 *
 * #### Note: This object is also exposed as [[$urlRouterProvider]] for injection during angular config time.
 *
 * @deprecated
 */ var $ff77adb66a4c9c1e$var$$urlRouter;
/**
 * The URL Matcher Factory
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlService]] instead.
 *
 * The [[UrlMatcherFactory]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactoryProvider]] for injection during angular config time.
 *
 * @deprecated
 */ var $ff77adb66a4c9c1e$var$$urlMatcherFactory;
/**
 * The URL Matcher Factory
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlService]] instead.
 *
 * The [[UrlMatcherFactory]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactory]] for injection during runtime.
 *
 * @deprecated
 */ var $ff77adb66a4c9c1e$var$$urlMatcherFactoryProvider;


/* eslint-disable @typescript-eslint/no-empty-interface */ /* eslint-disable prefer-const */ /**
 * # Angular 1 Directives
 *
 * These are the directives included in UI-Router for Angular 1.
 * These directives are used in templates to create viewports and link/navigate to states.
 *
 * @preferred @publicapi @module directives
 */ /** */ 

/** @hidden */ function $7be2d55eff199604$var$parseStateRef(ref) {
    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
    if (paramsOnly) ref = "(" + paramsOnly[1] + ")";
    var parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
    return {
        state: parsed[1] || null,
        paramExpr: parsed[3] || null
    };
}
/** @hidden */ function $7be2d55eff199604$var$stateContext(el) {
    var $uiView = el.parent().inheritedData("$uiView");
    var path = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("$cfg.path")($uiView);
    return path ? (0, $abcc081e7f2a61c5$export$c01875f616615628)(path).state.name : undefined;
}
/** @hidden */ function $7be2d55eff199604$var$processedDef($state, $element, def) {
    var uiState = def.uiState || $state.current.name;
    var uiStateOpts = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)($7be2d55eff199604$var$defaultOpts($element, $state), def.uiStateOpts || {});
    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
    return {
        uiState: uiState,
        uiStateParams: def.uiStateParams,
        uiStateOpts: uiStateOpts,
        href: href
    };
}
/** @hidden */ function $7be2d55eff199604$var$getTypeInfo(el) {
    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
    var isSvg = Object.prototype.toString.call(el.prop("href")) === "[object SVGAnimatedString]";
    var isForm = el[0].nodeName === "FORM";
    return {
        attr: isForm ? "action" : isSvg ? "xlink:href" : "href",
        isAnchor: el.prop("tagName").toUpperCase() === "A",
        clickable: !isForm
    };
}
/** @hidden */ function $7be2d55eff199604$var$clickHook(el, $state, $timeout, type, getDef) {
    return function(e) {
        var button = e.which || e.button, target = getDef();
        if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr("target"))) {
            // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
            var transition_1 = $timeout(function() {
                if (!el.attr("disabled")) $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
            });
            e.preventDefault();
            // if the state has no URL, ignore one preventDefault from the <a> directive.
            var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function() {
                if (ignorePreventDefaultCount_1-- <= 0) $timeout.cancel(transition_1);
            };
        }
    };
}
/** @hidden */ function $7be2d55eff199604$var$defaultOpts(el, $state) {
    return {
        relative: $7be2d55eff199604$var$stateContext(el) || $state.$current,
        inherit: true,
        source: "sref"
    };
}
/** @hidden */ function $7be2d55eff199604$var$bindEvents(element, scope, hookFn, uiStateOpts) {
    var events;
    if (uiStateOpts) events = uiStateOpts.events;
    if (!(0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(events)) events = [
        "click"
    ];
    var on = element.on ? "on" : "bind";
    for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
        var event_1 = events_1[_i];
        element[on](event_1, hookFn);
    }
    scope.$on("$destroy", function() {
        var off = element.off ? "off" : "unbind";
        for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
            var event_2 = events_2[_i];
            element[off](event_2, hookFn);
        }
    });
}
/**
 * `ui-sref`: A directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of the `ui-sref` is the name of the state to link to.
 *
 * #### Example:
 * This will activate the `home` state when the link is clicked.
 * ```html
 * <a ui-sref="home">Home</a>
 * ```
 *
 * ### Relative Links
 * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create a relative `ui-sref` which always targets the same destination.
 *
 * #### Example:
 * Both these links are relative to the parent state, even when a child state is currently active.
 * ```html
 * <a ui-sref=".child1">child 1 state</a>
 * <a ui-sref=".child2">child 2 state</a>
 * ```
 *
 * This link activates the parent state.
 * ```html
 * <a ui-sref="^">Return</a>
 * ```
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * #### Example:
 * Assuming the `users` state has a url of `/users/`
 * ```html
 * <a ui-sref="users" href="/users/">Users</a>
 * ```
 *
 * ### Parameter Values
 * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
 * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
 * The content inside the parentheses is an expression, evaluated to the parameter values.
 *
 * #### Example:
 * This example renders a list of links to users.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="user in users">
 *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
 * </li>
 * ```
 *
 * Note:
 * The parameter values expression is `$watch`ed for updates.
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 *
 * #### Example:
 * ```html
 * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Other DOM Events
 *
 * You can also customize which DOM events to respond to (instead of `click`) by
 * providing an `events` array in the `ui-sref-opts` attribute.
 *
 * #### Example:
 * ```html
 * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Examples
 * If you have the following template:
 *
 * ```html
 * <a ui-sref="home">Home</a>
 * <a ui-sref="about">About</a>
 * <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * ```
 *
 * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
 *
 * ```html
 * <a href="#/home" ui-sref="home">Home</a>
 * <a href="#/about" ui-sref="about">About</a>
 * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * ```
 *
 * ### Notes
 *
 * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-sref="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 *
 * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
 * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
 */ var $7be2d55eff199604$var$uiSrefDirective;
$7be2d55eff199604$var$uiSrefDirective = [
    "$uiRouter",
    "$timeout",
    function $StateRefDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: "A",
            require: [
                "?^uiSrefActive",
                "?^uiSrefActiveEq"
            ],
            link: function(scope, element, attrs, uiSrefActive) {
                var type = $7be2d55eff199604$var$getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var rawDef = {};
                var getDef = function() {
                    return $7be2d55eff199604$var$processedDef($state, element, rawDef);
                };
                var ref = $7be2d55eff199604$var$parseStateRef(attrs.uiSref);
                rawDef.uiState = ref.state;
                rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn) unlinkInfoFn();
                    if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null) attrs.$set(type.attr, def.href);
                }
                if (ref.paramExpr) {
                    scope.$watch(ref.paramExpr, function(val) {
                        rawDef.uiStateParams = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, val);
                        update();
                    }, true);
                    rawDef.uiStateParams = (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, scope.$eval(ref.paramExpr));
                }
                update();
                scope.$on("$destroy", $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on("$destroy", $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable) return;
                var hookFn = $7be2d55eff199604$var$clickHook(element, $state, $timeout, type, getDef);
                $7be2d55eff199604$var$bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
            }
        };
    }
];
/**
 * `ui-state`: A fully dynamic directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
 * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
 *
 * #### Example:
 * Create a list of links.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Relative Links
 * If the expression evaluates to a relative path, it is processed like [[uiSref]].
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create relative `ui-state` which always targets the same destination.
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * ### Parameter Values
 * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
 * Param values should be provided using the `ui-state-params` attribute.
 * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * This example renders a list of links with param values.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * ```html
 * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Other DOM Events
 *
 * You can also customize which DOM events to respond to (instead of `click`) by
 * providing an `events` array in the `ui-state-opts` attribute.
 *
 * #### Example:
 * ```html
 * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Notes
 *
 * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
 *   However, it might be simpler to use [[uiSref]] parameter-only links.
 *
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 * ```
 */ var $7be2d55eff199604$var$uiStateDirective;
$7be2d55eff199604$var$uiStateDirective = [
    "$uiRouter",
    "$timeout",
    function $StateRefDynamicDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: "A",
            require: [
                "?^uiSrefActive",
                "?^uiSrefActiveEq"
            ],
            link: function(scope, element, attrs, uiSrefActive) {
                var type = $7be2d55eff199604$var$getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function() {
                    return $7be2d55eff199604$var$processedDef($state, element, rawDef);
                };
                var inputAttrs = [
                    "uiState",
                    "uiStateParams",
                    "uiStateOpts"
                ];
                var watchDeregFns = inputAttrs.reduce(function(acc, attr) {
                    return acc[attr] = (0, $abcc081e7f2a61c5$export$8793edee2d425525), acc;
                }, {});
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn) unlinkInfoFn();
                    if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null) attrs.$set(type.attr, def.href);
                }
                inputAttrs.forEach(function(field) {
                    rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
                    attrs.$observe(field, function(expr) {
                        watchDeregFns[field]();
                        watchDeregFns[field] = scope.$watch(expr, function(newval) {
                            rawDef[field] = newval;
                            update();
                        }, true);
                    });
                });
                update();
                scope.$on("$destroy", $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on("$destroy", $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable) return;
                hookFn = $7be2d55eff199604$var$clickHook(element, $state, $timeout, type, getDef);
                $7be2d55eff199604$var$bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
            }
        };
    }
];
/**
 * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
 *
 * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
 * related directive's state is active (and remove them when it is inactive).
 *
 * The primary use-case is to highlight the active link in navigation menus,
 * distinguishing it from the inactive menu items.
 *
 * ### Linking to a `ui-sref` or `ui-state`
 * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
 * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
 *
 * ### Matching
 *
 * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
 * This is a "fuzzy match" which uses [[StateService.includes]].
 *
 * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
 * This is an "exact match" which uses [[StateService.is]].
 *
 * ### Parameter values
 * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
 * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
 *
 * #### Example:
 * ```html
 * <li ng-repeat="user in users" ui-sref-active="active">
 *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
 * </li>
 * ```
 *
 * ### Examples
 *
 * Given the following template:
 * #### Example:
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * When the app state is `app.user` (or any child state),
 * and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 *
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * ### Glob mode
 *
 * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
 * The objects keys represent active class names and values represent the respective state names/globs.
 * `ui-sref-active` will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * #### Example:
 * Given the following template, with "admin" being an abstract state:
 * ```html
 * <div ui-sref-active="{'active': 'admin.**'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * ```
 *
 * Arrays are also supported as values in the `ngClass`-like interface.
 * This allows multiple states to add `active` class.
 *
 * #### Example:
 * Given the following template, with "admin.roles" being the current state, the class will be added too:
 * ```html
 * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * ```
 *
 * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
 * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
 *
 * ### Notes:
 *
 * - The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
 */ var $7be2d55eff199604$var$uiSrefActiveDirective;
$7be2d55eff199604$var$uiSrefActiveDirective = [
    "$state",
    "$stateParams",
    "$interpolate",
    "$uiRouter",
    function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
        return {
            restrict: "A",
            controller: [
                "$scope",
                "$element",
                "$attrs",
                function($scope, $element, $attrs) {
                    var states = [];
                    var activeEqClass;
                    var uiSrefActive;
                    // There probably isn't much point in $observing this
                    // uiSrefActive and uiSrefActiveEq share the same directive object with some
                    // slight difference in logic routing
                    activeEqClass = $interpolate($attrs.uiSrefActiveEq || "", false)($scope);
                    try {
                        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
                    } catch (e) {
                    // Do nothing. uiSrefActive is not a valid expression.
                    // Fall back to using $interpolate below
                    }
                    uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || "", false)($scope);
                    setStatesFromDefinitionObject(uiSrefActive);
                    // Allow uiSref to communicate with uiSrefActive[Equals]
                    this.$$addStateInfo = function(newState, newParams) {
                        // we already got an explicit state provided by ui-sref-active, so we
                        // shadow the one that comes from ui-sref
                        if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(uiSrefActive) && states.length > 0) return;
                        var deregister = addState(newState, newParams, uiSrefActive);
                        update();
                        return deregister;
                    };
                    function updateAfterTransition(trans) {
                        trans.promise.then(update, (0, $abcc081e7f2a61c5$export$8793edee2d425525));
                    }
                    $scope.$on("$destroy", setupEventListeners());
                    if ($uiRouter.globals.transition) updateAfterTransition($uiRouter.globals.transition);
                    function setupEventListeners() {
                        var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
                        var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
                        var deregisterStateChangeSuccessListener = $scope.$on("$stateChangeSuccess", update);
                        return function cleanUp() {
                            deregisterStatesChangedListener();
                            deregisterOnStartListener();
                            deregisterStateChangeSuccessListener();
                        };
                    }
                    function handleStatesChanged() {
                        setStatesFromDefinitionObject(uiSrefActive);
                    }
                    function setStatesFromDefinitionObject(statesDefinition) {
                        if ((0, $c4ca6daaad7210ad$export$a6cdc56e425d0d0a)(statesDefinition)) {
                            states = [];
                            (0, $abcc081e7f2a61c5$export$4b80e395e36b5a56)(statesDefinition, function(stateOrName, activeClass) {
                                // Helper function to abstract adding state.
                                var addStateForClass = function(stateOrName, activeClass) {
                                    var ref = $7be2d55eff199604$var$parseStateRef(stateOrName);
                                    addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                                };
                                if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(stateOrName)) // If state is string, just add it.
                                addStateForClass(stateOrName, activeClass);
                                else if ((0, $c4ca6daaad7210ad$export$43bee75e5e14138e)(stateOrName)) // If state is an array, iterate over it and add each array item individually.
                                (0, $abcc081e7f2a61c5$export$4b80e395e36b5a56)(stateOrName, function(stateOrName) {
                                    addStateForClass(stateOrName, activeClass);
                                });
                            });
                        }
                    }
                    function addState(stateName, stateParams, activeClass) {
                        var state = $state.get(stateName, $7be2d55eff199604$var$stateContext($element));
                        var stateInfo = {
                            state: state || {
                                name: stateName
                            },
                            params: stateParams,
                            activeClass: activeClass
                        };
                        states.push(stateInfo);
                        return function removeState() {
                            (0, $abcc081e7f2a61c5$export$dde48e6299cbd897)(states)(stateInfo);
                        };
                    }
                    // Update route state
                    function update() {
                        var splitClasses = function(str) {
                            return str.split(/\s/).filter((0, $abcc081e7f2a61c5$export$f0954fd7d5368655));
                        };
                        var getClasses = function(stateList) {
                            return stateList.map(function(x) {
                                return x.activeClass;
                            }).map(splitClasses).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
                        };
                        var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce((0, $abcc081e7f2a61c5$export$530e60648218df63), []);
                        var fuzzyClasses = getClasses(states.filter(function(x) {
                            return $state.includes(x.state.name, x.params);
                        }));
                        var exactlyMatchesAny = !!states.filter(function(x) {
                            return $state.is(x.state.name, x.params);
                        }).length;
                        var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
                        var addClasses = fuzzyClasses.concat(exactClasses).reduce((0, $abcc081e7f2a61c5$export$530e60648218df63), []);
                        var removeClasses = allClasses.filter(function(cls) {
                            return !(0, $abcc081e7f2a61c5$export$6632823c2c02cb2c)(addClasses, cls);
                        });
                        $scope.$evalAsync(function() {
                            addClasses.forEach(function(className) {
                                return $element.addClass(className);
                            });
                            removeClasses.forEach(function(className) {
                                return $element.removeClass(className);
                            });
                        });
                    }
                    update();
                }
            ]
        };
    }
];
(0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.state").directive("uiSref", $7be2d55eff199604$var$uiSrefDirective).directive("uiSrefActive", $7be2d55eff199604$var$uiSrefActiveDirective).directive("uiSrefActiveEq", $7be2d55eff199604$var$uiSrefActiveDirective).directive("uiState", $7be2d55eff199604$var$uiStateDirective);


/** @publicapi @module ng1 */ /** */ 
/**
 * `isState` Filter: truthy if the current state is the parameter
 *
 * Translates to [[StateService.is]] `$state.is("stateName")`.
 *
 * #### Example:
 * ```html
 * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
 * ```
 */ $13db5fefd0a00d06$export$6b90fe74b2ad2a13.$inject = [
    "$state"
];
function $13db5fefd0a00d06$export$6b90fe74b2ad2a13($state) {
    var isFilter = function(state, params, options) {
        return $state.is(state, params, options);
    };
    isFilter.$stateful = true;
    return isFilter;
}
/**
 * `includedByState` Filter: truthy if the current state includes the parameter
 *
 * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
 *
 * #### Example:
 * ```html
 * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
 * ```
 */ $13db5fefd0a00d06$export$b3730b00a2755c83.$inject = [
    "$state"
];
function $13db5fefd0a00d06$export$b3730b00a2755c83($state) {
    var includesFilter = function(state, params, options) {
        return $state.includes(state, params, options);
    };
    includesFilter.$stateful = true;
    return includesFilter;
}
(0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.state").filter("isState", $13db5fefd0a00d06$export$6b90fe74b2ad2a13).filter("includedByState", $13db5fefd0a00d06$export$b3730b00a2755c83);


/** @publicapi @module directives */ /** */ 



var $70de60aae9c63e7e$export$849a5b940a53444a;
// eslint-disable-next-line prefer-const
$70de60aae9c63e7e$export$849a5b940a53444a = [
    "$view",
    "$animate",
    "$uiViewScroll",
    "$interpolate",
    "$q",
    function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
        function getRenderer() {
            return {
                enter: function(element, target, cb) {
                    if ((0, $c3628d2e76534866$export$acc5bfffa76564ff).version.minor > 2) $animate.enter(element, null, target).then(cb);
                    else $animate.enter(element, null, target, cb);
                },
                leave: function(element, cb) {
                    if ((0, $c3628d2e76534866$export$acc5bfffa76564ff).version.minor > 2) $animate.leave(element).then(cb);
                    else $animate.leave(element, cb);
                }
            };
        }
        function configsEqual(config1, config2) {
            return config1 === config2;
        }
        var rootData = {
            $cfg: {
                viewDecl: {
                    $context: $view._pluginapi._rootViewContext()
                }
            },
            $uiView: {}
        };
        var directive = {
            count: 0,
            restrict: "ECA",
            terminal: true,
            priority: 400,
            transclude: "element",
            compile: function(tElement, tAttrs, $transclude) {
                return function(scope, $element, attrs) {
                    var onloadExp = attrs["onload"] || "", autoScrollExp = attrs["autoscroll"], renderer = getRenderer(), inherited = $element.inheritedData("$uiView") || rootData, name = $interpolate(attrs["uiView"] || attrs["name"] || "")(scope) || "$default";
                    var previousEl, currentEl, currentScope, viewConfig;
                    var activeUIView = {
                        $type: "ng1",
                        id: directive.count++,
                        name: name,
                        fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
                        config: null,
                        configUpdated: configUpdatedCallback,
                        get creationContext () {
                            // The context in which this ui-view "tag" was created
                            var fromParentTagConfig = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("$cfg.viewDecl.$context")(inherited);
                            // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
                            // See https://github.com/angular-ui/ui-router/issues/3355
                            var fromParentTag = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("$uiView.creationContext")(inherited);
                            return fromParentTagConfig || fromParentTag;
                        }
                    };
                    (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewEvent("Linking", activeUIView);
                    function configUpdatedCallback(config) {
                        if (config && !(config instanceof (0, $56e22b290c726e1d$export$f3840ea642c0e3ec))) return;
                        if (configsEqual(viewConfig, config)) return;
                        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                        viewConfig = config;
                        updateView(config);
                    }
                    $element.data("$uiView", {
                        $uiView: activeUIView
                    });
                    updateView();
                    var unregister = $view.registerUIView(activeUIView);
                    scope.$on("$destroy", function() {
                        (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewEvent("Destroying/Unregistering", activeUIView);
                        unregister();
                    });
                    function cleanupLastView() {
                        if (previousEl) {
                            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewEvent("Removing (previous) el", previousEl.data("$uiView"));
                            previousEl.remove();
                            previousEl = null;
                        }
                        if (currentScope) {
                            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewEvent("Destroying scope", activeUIView);
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentEl) {
                            var _viewData_1 = currentEl.data("$uiViewAnim");
                            (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewEvent("Animate out", _viewData_1);
                            renderer.leave(currentEl, function() {
                                _viewData_1.$$animLeave.resolve();
                                previousEl = null;
                            });
                            previousEl = currentEl;
                            currentEl = null;
                        }
                    }
                    function updateView(config) {
                        var newScope = scope.$new();
                        var animEnter = $q.defer(), animLeave = $q.defer();
                        var $uiViewData = {
                            $cfg: config,
                            $uiView: activeUIView
                        };
                        var $uiViewAnim = {
                            $animEnter: animEnter.promise,
                            $animLeave: animLeave.promise,
                            $$animLeave: animLeave
                        };
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoading
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description
                         *
                         * Fired once the view **begins loading**, *before* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         * @param {string} viewName Name of the view.
                         */ newScope.$emit("$viewContentLoading", name);
                        var cloned = $transclude(newScope, function(clone) {
                            clone.data("$uiViewAnim", $uiViewAnim);
                            clone.data("$uiView", $uiViewData);
                            renderer.enter(clone, $element, function onUIViewEnter() {
                                animEnter.resolve();
                                if (currentScope) currentScope.$emit("$viewContentAnimationEnded");
                                if ((0, $c4ca6daaad7210ad$export$4e62c701997796c1)(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) $uiViewScroll(clone);
                            });
                            cleanupLastView();
                        });
                        currentEl = cloned;
                        currentScope = newScope;
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoaded
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description           *
                         * Fired once the view is **loaded**, *after* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         */ currentScope.$emit("$viewContentLoaded", config || viewConfig);
                        currentScope.$eval(onloadExp);
                    }
                };
            }
        };
        return directive;
    }
];
$70de60aae9c63e7e$var$$ViewDirectiveFill.$inject = [
    "$compile",
    "$controller",
    "$transitions",
    "$view",
    "$q"
];
/** @hidden */ function $70de60aae9c63e7e$var$$ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
    var getControllerAs = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("viewDecl.controllerAs");
    var getResolveAs = (0, $b94057b5b409b0b1$export$98e6a39c04603d36)("viewDecl.resolveAs");
    return {
        restrict: "ECA",
        priority: -400,
        compile: function(tElement) {
            var initial = tElement.html();
            tElement.empty();
            return function(scope, $element) {
                var data = $element.data("$uiView");
                if (!data) {
                    $element.html(initial);
                    $compile($element.contents())(scope);
                    return;
                }
                var cfg = data.$cfg || {
                    viewDecl: {},
                    getTemplate: (0, $abcc081e7f2a61c5$export$8793edee2d425525)
                };
                var resolveCtx = cfg.path && new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(cfg.path);
                $element.html(cfg.getTemplate($element, resolveCtx) || initial);
                (0, $42b3df7fa4bc82fe$export$357889f174732d38).traceUIViewFill(data.$uiView, $element.html());
                var link = $compile($element.contents());
                var controller = cfg.controller;
                var controllerAs = getControllerAs(cfg);
                var resolveAs = getResolveAs(cfg);
                var locals = resolveCtx && (0, $7399b8d73510942f$export$379cba1caf1a83)(resolveCtx);
                scope[resolveAs] = locals;
                if (controller) {
                    var controllerInstance = $controller(controller, (0, $abcc081e7f2a61c5$export$8b58be045bf06082)({}, locals, {
                        $scope: scope,
                        $element: $element
                    }));
                    if (controllerAs) {
                        scope[controllerAs] = controllerInstance;
                        scope[controllerAs][resolveAs] = locals;
                    }
                    // TODO: Use $view service as a central point for registering component-level hooks
                    // Then, when a component is created, tell the $view service, so it can invoke hooks
                    // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
                    // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
                    $element.data("$ngControllerController", controllerInstance);
                    $element.children().data("$ngControllerController", controllerInstance);
                    $70de60aae9c63e7e$var$registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
                }
                // Wait for the component to appear in the DOM
                if ((0, $c4ca6daaad7210ad$export$844ec244b1367d54)(cfg.component)) {
                    var kebobName = (0, $48612b14b235e6fd$export$7e12dc7ef150dc64)(cfg.component);
                    var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", "i");
                    var getComponentController = function() {
                        var directiveEl = [].slice.call($element[0].children).filter(function(el) {
                            return el && el.tagName && tagRegexp_1.exec(el.tagName);
                        });
                        return directiveEl && (0, $c3628d2e76534866$export$acc5bfffa76564ff).element(directiveEl).data("$" + cfg.component + "Controller");
                    };
                    var deregisterWatch_1 = scope.$watch(getComponentController, function(ctrlInstance) {
                        if (!ctrlInstance) return;
                        $70de60aae9c63e7e$var$registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
                        deregisterWatch_1();
                    });
                }
                link(scope);
            };
        }
    };
}
/** @hidden */ var $70de60aae9c63e7e$var$hasComponentImpl = typeof (0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router")["component"] === "function";
/** @hidden incrementing id */ var $70de60aae9c63e7e$var$_uiCanExitId = 0;
/** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */ function $70de60aae9c63e7e$var$registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
    // Call $onInit() ASAP
    if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(controllerInstance.$onInit) && !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && $70de60aae9c63e7e$var$hasComponentImpl)) controllerInstance.$onInit();
    var viewState = (0, $abcc081e7f2a61c5$export$c01875f616615628)(cfg.path).state.self;
    var hookOptions = {
        bind: controllerInstance
    };
    // Add component-level hook for onUiParamsChanged
    if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(controllerInstance.uiOnParamsChanged)) {
        var resolveContext = new (0, $3996106c44ea4b60$export$fa71f212be031d8f)(cfg.path);
        var viewCreationTrans_1 = resolveContext.getResolvable("$transition$").data;
        // Fire callback on any successful transition
        var paramsUpdated = function($transition$) {
            // Exit early if the $transition$ is the same as the view was created within.
            // Exit early if the $transition$ will exit the state the view is for.
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1) return;
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            var getNodeSchema = function(node) {
                return node.paramSchema;
            };
            var toSchema = $transition$.treeChanges("to").map(getNodeSchema).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
            var fromSchema = $transition$.treeChanges("from").map(getNodeSchema).reduce((0, $abcc081e7f2a61c5$export$55d90b6e41f02f0), []);
            // Find the to params that have different values than the from params
            var changedToParams = toSchema.filter(function(param) {
                var idx = fromSchema.indexOf(param);
                return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            // Only trigger callback if a to param has changed or is new
            if (changedToParams.length) {
                var changedKeys_1 = changedToParams.map(function(x) {
                    return x.id;
                });
                // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
                var newValues = (0, $abcc081e7f2a61c5$export$3dea766d36a8935f)(toParams, function(val, key) {
                    return changedKeys_1.indexOf(key) !== -1;
                });
                controllerInstance.uiOnParamsChanged(newValues, $transition$);
            }
        };
        $scope.$on("$destroy", $transitions.onSuccess({}, paramsUpdated, hookOptions));
    }
    // Add component-level hook for uiCanExit
    if ((0, $c4ca6daaad7210ad$export$f6e2535fb5126e54)(controllerInstance.uiCanExit)) {
        var id_1 = $70de60aae9c63e7e$var$_uiCanExitId++;
        var cacheProp_1 = "_uiCanExitIds";
        // Returns true if a redirect transition already answered truthy
        var prevTruthyAnswer_1 = function(trans) {
            return !!trans && (trans[cacheProp_1] && trans[cacheProp_1][id_1] === true || prevTruthyAnswer_1(trans.redirectedFrom()));
        };
        // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
        var wrappedHook = function(trans) {
            var promise;
            var ids = trans[cacheProp_1] = trans[cacheProp_1] || {};
            if (!prevTruthyAnswer_1(trans)) {
                promise = $q.when(controllerInstance.uiCanExit(trans));
                promise.then(function(val) {
                    return ids[id_1] = val !== false;
                });
            }
            return promise;
        };
        var criteria = {
            exiting: viewState.name
        };
        $scope.$on("$destroy", $transitions.onBefore(criteria, wrappedHook, hookOptions));
    }
}
(0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.state").directive("uiView", $70de60aae9c63e7e$export$849a5b940a53444a);
(0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.state").directive("uiView", $70de60aae9c63e7e$var$$ViewDirectiveFill);


/** @publicapi @module ng1 */ /** */ 
/** @hidden */ function $eef3338c50ceee38$var$$ViewScrollProvider() {
    var useAnchorScroll = false;
    this.useAnchorScroll = function() {
        useAnchorScroll = true;
    };
    this.$get = [
        "$anchorScroll",
        "$timeout",
        function($anchorScroll, $timeout) {
            if (useAnchorScroll) return $anchorScroll;
            return function($element) {
                return $timeout(function() {
                    $element[0].scrollIntoView();
                }, 0, false);
            };
        }
    ];
}
(0, $c3628d2e76534866$export$acc5bfffa76564ff).module("ui.router.state").provider("$uiViewScroll", $eef3338c50ceee38$var$$ViewScrollProvider);



var $36f054d1740c9636$export$2e2bcd8739ae039 = "ui.router";


var $4c5056defb87b67c$exports = {};

/**
 * State-based routing for AngularJS 1.x
 * @version v1.0.30
 * @link https://ui-router.github.io
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */ (function(global, factory) {
    factory($4c5056defb87b67c$exports, (parcelRequire("jTg1q")));
})($4c5056defb87b67c$exports, function(exports1, ng_from_import) {
    "use strict";
    /** @publicapi @module ng1 */ /** */ /** @hidden */ var ng_from_global = angular;
    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
    /**
     * # Legacy state events
     *
     * Polyfill implementation of the UI-Router 0.2.x state events.
     *
     * The 0.2.x state events are deprecated.  We recommend moving to Transition Hooks instead, as they
     * provide much more flexibility, support async, and provide the context (the Transition, etc) necessary
     * to implement meaningful application behaviors.
     *
     * To enable these state events, include the `stateEvents.js` file in your project, e.g.,
     * ```
     * <script src="stateEvents.js"></script>
     * ```
     * and also make sure you depend on the `ui.router.state.events` angular module, e.g.,
     * ```
     * angular.module("myApplication", ['ui.router', 'ui.router.state.events']
     * ```
     *
     * @publicapi @module ng1_state_events
     */ /** */ /**
     * An event broadcast on `$rootScope` when the state transition **begins**.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] instead
     *
     * You can use `event.preventDefault()`
     * to prevent the transition from happening and then the transition promise will be
     * rejected with a `'transition prevented'` value.
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]]
     *
     * #### Example:
     * ```js
     * $rootScope.$on('$stateChangeStart', function(event, transition) {
     *   event.preventDefault();
     *   // transitionTo() promise will be rejected with
     *   // a 'transition prevented' error
     * })
     * ```
     *
     * @event $stateChangeStart
     * @deprecated
     */ var $stateChangeStart;
    /**
     * An event broadcast on `$rootScope` if a transition is **cancelled**.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] instead
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]] that was cancelled
     *
     * @event $stateChangeCancel
     * @deprecated
     */ var $stateChangeCancel;
    /**
     * An event broadcast on `$rootScope` once the state transition is **complete**.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] and [[Transition.promise]], or [[Transition.onSuccess]]
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]] that just succeeded
     *
     * @event $stateChangeSuccess
     * @deprecated
     */ var $stateChangeSuccess;
    /**
     * An event broadcast on `$rootScope` when an **error occurs** during transition.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] and [[Transition.promise]], or [[Transition.onError]]
     *
     * It's important to note that if you
     * have any errors in your resolve functions (javascript errors, non-existent services, etc)
     * they will not throw traditionally. You must listen for this $stateChangeError event to
     * catch **ALL** errors.
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `error`: The reason the transition errored.
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]] that errored
     *
     * @event $stateChangeError
     * @deprecated
     */ var $stateChangeError;
    /**
     * An event broadcast on `$rootScope` when a requested state **cannot be found** using the provided state name.
     *
     * ### Deprecation warning: use [[StateService.onInvalid]] instead
     *
     * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
     * lazy-loading the unfound state). A `TargetState` object is passed to the listener handler,
     * you can see its properties in the example. You can use `event.preventDefault()` to abort the
     * transition and the promise returned from `transitionTo()` will be rejected with a
     * `'transition aborted'` error.
     *
     * Additional arguments to the event handler are provided:
     * - `unfoundState` Unfound State information. Contains: `to, toParams, options` properties.
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     *
     * #### Example:
     * ```js
     * // somewhere, assume lazy.state has not been defined
     * $state.go("lazy.state", { a: 1, b: 2 }, { inherit: false });
     *
     * // somewhere else
     * $scope.$on('$stateNotFound', function(event, transition) {
     * function(event, unfoundState, fromState, fromParams){
     *     console.log(unfoundState.to); // "lazy.state"
     *     console.log(unfoundState.toParams); // {a:1, b:2}
     *     console.log(unfoundState.options); // {inherit:false} + default options
     * });
     * ```
     *
     * @event $stateNotFound
     * @deprecated
     */ var $stateNotFound;
    (function() {
        var isFunction = ng.isFunction, isString = ng.isString;
        function applyPairs(memo, keyValTuple) {
            var key, value;
            if (Array.isArray(keyValTuple)) key = keyValTuple[0], value = keyValTuple[1];
            if (!isString(key)) throw new Error("invalid parameters to applyPairs");
            memo[key] = value;
            return memo;
        }
        function stateChangeStartHandler($transition$) {
            if (!$transition$.options().notify || !$transition$.valid() || $transition$.ignored()) return;
            var $injector = $transition$.injector();
            var $stateEvents = $injector.get("$stateEvents");
            var $rootScope = $injector.get("$rootScope");
            var $state = $injector.get("$state");
            var $urlRouter = $injector.get("$urlRouter");
            var enabledEvents = $stateEvents.provider.enabled();
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            if (enabledEvents.$stateChangeSuccess) {
                var startEvent = $rootScope.$broadcast("$stateChangeStart", $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
                if (startEvent.defaultPrevented) {
                    if (enabledEvents.$stateChangeCancel) $rootScope.$broadcast("$stateChangeCancel", $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
                    // Don't update and resync url if there's been a new transition started. see issue #2238, #600
                    if ($state.transition == null) $urlRouter.update();
                    return false;
                }
                // right after global state is updated
                var successOpts = {
                    priority: 9999
                };
                $transition$.onSuccess({}, function() {
                    $rootScope.$broadcast("$stateChangeSuccess", $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
                }, successOpts);
            }
            if (enabledEvents.$stateChangeError) $transition$.promise["catch"](function(error) {
                if (error && (error.type === 2 /* RejectType.SUPERSEDED */  || error.type === 3)) return;
                var evt = $rootScope.$broadcast("$stateChangeError", $transition$.to(), toParams, $transition$.from(), fromParams, error, $transition$.options(), $transition$);
                if (!evt.defaultPrevented) $urlRouter.update();
            });
        }
        stateNotFoundHandler.$inject = [
            "$to$",
            "$from$",
            "$state",
            "$rootScope",
            "$urlRouter"
        ];
        function stateNotFoundHandler($to$, $from$, injector) {
            var $state = injector.get("$state");
            var $rootScope = injector.get("$rootScope");
            var $urlRouter = injector.get("$urlRouter");
            var redirect = {
                to: $to$.identifier(),
                toParams: $to$.params(),
                options: $to$.options()
            };
            var e = $rootScope.$broadcast("$stateNotFound", redirect, $from$.state(), $from$.params());
            if (e.defaultPrevented || e.retry) $urlRouter.update();
            function redirectFn() {
                return $state.target(redirect.to, redirect.toParams, redirect.options);
            }
            if (e.defaultPrevented) return false;
            else if (e.retry || !!$state.get(redirect.to)) return e.retry && isFunction(e.retry.then) ? e.retry.then(redirectFn) : redirectFn();
        }
        $StateEventsProvider.$inject = [
            "$stateProvider"
        ];
        function $StateEventsProvider($stateProvider) {
            $StateEventsProvider.prototype.instance = this;
            var runtime = false;
            var allEvents = [
                "$stateChangeStart",
                "$stateNotFound",
                "$stateChangeSuccess",
                "$stateChangeError"
            ];
            var enabledStateEvents = allEvents.map(function(e) {
                return [
                    e,
                    true
                ];
            }).reduce(applyPairs, {});
            function assertNotRuntime() {
                if (runtime) throw new Error("Cannot enable events at runtime (use $stateEventsProvider");
            }
            /**
             * Enables the deprecated UI-Router 0.2.x State Events
             * [ '$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError' ]
             */ this.enable = function() {
                var events = [];
                for(var _i = 0; _i < arguments.length; _i++)events[_i] = arguments[_i];
                assertNotRuntime();
                if (!events || !events.length) events = allEvents;
                events.forEach(function(event) {
                    return enabledStateEvents[event] = true;
                });
            };
            /**
             * Disables the deprecated UI-Router 0.2.x State Events
             * [ '$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError' ]
             */ this.disable = function() {
                var events = [];
                for(var _i = 0; _i < arguments.length; _i++)events[_i] = arguments[_i];
                assertNotRuntime();
                if (!events || !events.length) events = allEvents;
                events.forEach(function(event) {
                    return delete enabledStateEvents[event];
                });
            };
            this.enabled = function() {
                return enabledStateEvents;
            };
            this.$get = $get;
            $get.$inject = [
                "$transitions"
            ];
            function $get($transitions) {
                runtime = true;
                if (enabledStateEvents["$stateNotFound"]) $stateProvider.onInvalid(stateNotFoundHandler);
                if (enabledStateEvents.$stateChangeStart) $transitions.onBefore({}, stateChangeStartHandler, {
                    priority: 1000
                });
                return {
                    provider: $StateEventsProvider.prototype.instance
                };
            }
        }
        ng.module("ui.router.state.events", [
            "ui.router.state"
        ]).provider("$stateEvents", $StateEventsProvider).run([
            "$stateEvents",
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function($stateEvents) {
            /* Invokes $get() */ }
        ]);
    })();
    exports1.$stateChangeCancel = $stateChangeCancel;
    exports1.$stateChangeError = $stateChangeError;
    exports1.$stateChangeStart = $stateChangeStart;
    exports1.$stateChangeSuccess = $stateChangeSuccess;
    exports1.$stateNotFound = $stateNotFound;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $65e0832449835e89$exports = {};
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1, angular) {
    "use strict";
    var ELEMENT_NODE = 1;
    var COMMENT_NODE = 8;
    var ADD_CLASS_SUFFIX = "-add";
    var REMOVE_CLASS_SUFFIX = "-remove";
    var EVENT_CLASS_PREFIX = "ng-";
    var ACTIVE_CLASS_SUFFIX = "-active";
    var PREPARE_CLASS_SUFFIX = "-prepare";
    var NG_ANIMATE_CLASSNAME = "ng-animate";
    var NG_ANIMATE_CHILDREN_DATA = "$$ngAnimateChildren";
    // Detect proper transitionend/animationend event names.
    var CSS_PREFIX = "", TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
    // If unprefixed events are not supported but webkit-prefixed are, use the latter.
    // Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
    // Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
    // but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
    // Register both events in case `window.onanimationend` is not supported because of that,
    // do the same for `transitionend` as Safari is likely to exhibit similar behavior.
    // Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
    // therefore there is no reason to test anymore for other vendor prefixes:
    // http://caniuse.com/#search=transition
    if (window1.ontransitionend === undefined && window1.onwebkittransitionend !== undefined) {
        CSS_PREFIX = "-webkit-";
        TRANSITION_PROP = "WebkitTransition";
        TRANSITIONEND_EVENT = "webkitTransitionEnd transitionend";
    } else {
        TRANSITION_PROP = "transition";
        TRANSITIONEND_EVENT = "transitionend";
    }
    if (window1.onanimationend === undefined && window1.onwebkitanimationend !== undefined) {
        CSS_PREFIX = "-webkit-";
        ANIMATION_PROP = "WebkitAnimation";
        ANIMATIONEND_EVENT = "webkitAnimationEnd animationend";
    } else {
        ANIMATION_PROP = "animation";
        ANIMATIONEND_EVENT = "animationend";
    }
    var DURATION_KEY = "Duration";
    var PROPERTY_KEY = "Property";
    var DELAY_KEY = "Delay";
    var TIMING_KEY = "TimingFunction";
    var ANIMATION_ITERATION_COUNT_KEY = "IterationCount";
    var ANIMATION_PLAYSTATE_KEY = "PlayState";
    var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
    var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
    var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
    var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
    var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
    var ngMinErr = angular.$$minErr("ng");
    function assertArg(arg, name, reason) {
        if (!arg) throw ngMinErr("areq", "Argument '{0}' is {1}", name || "?", reason || "required");
        return arg;
    }
    function mergeClasses(a, b) {
        if (!a && !b) return "";
        if (!a) return b;
        if (!b) return a;
        if (isArray(a)) a = a.join(" ");
        if (isArray(b)) b = b.join(" ");
        return a + " " + b;
    }
    function packageStyles(options) {
        var styles = {};
        if (options && (options.to || options.from)) {
            styles.to = options.to;
            styles.from = options.from;
        }
        return styles;
    }
    function pendClasses(classes, fix, isPrefix) {
        var className = "";
        classes = isArray(classes) ? classes : classes && isString(classes) && classes.length ? classes.split(/\s+/) : [];
        forEach(classes, function(klass, i) {
            if (klass && klass.length > 0) {
                className += i > 0 ? " " : "";
                className += isPrefix ? fix + klass : klass + fix;
            }
        });
        return className;
    }
    function removeFromArray(arr, val) {
        var index = arr.indexOf(val);
        if (val >= 0) arr.splice(index, 1);
    }
    function stripCommentsFromElement(element) {
        if (element instanceof jqLite) switch(element.length){
            case 0:
                return element;
            case 1:
                // there is no point of stripping anything if the element
                // is the only element within the jqLite wrapper.
                // (it's important that we retain the element instance.)
                if (element[0].nodeType === ELEMENT_NODE) return element;
                break;
            default:
                return jqLite(extractElementNode(element));
        }
        if (element.nodeType === ELEMENT_NODE) return jqLite(element);
    }
    function extractElementNode(element) {
        if (!element[0]) return element;
        for(var i = 0; i < element.length; i++){
            var elm = element[i];
            if (elm.nodeType === ELEMENT_NODE) return elm;
        }
    }
    function $$addClass($$jqLite, element, className) {
        forEach(element, function(elm) {
            $$jqLite.addClass(elm, className);
        });
    }
    function $$removeClass($$jqLite, element, className) {
        forEach(element, function(elm) {
            $$jqLite.removeClass(elm, className);
        });
    }
    function applyAnimationClassesFactory($$jqLite) {
        return function(element, options) {
            if (options.addClass) {
                $$addClass($$jqLite, element, options.addClass);
                options.addClass = null;
            }
            if (options.removeClass) {
                $$removeClass($$jqLite, element, options.removeClass);
                options.removeClass = null;
            }
        };
    }
    function prepareAnimationOptions(options) {
        options = options || {};
        if (!options.$$prepared) {
            var domOperation = options.domOperation || noop;
            options.domOperation = function() {
                options.$$domOperationFired = true;
                domOperation();
                domOperation = noop;
            };
            options.$$prepared = true;
        }
        return options;
    }
    function applyAnimationStyles(element, options) {
        applyAnimationFromStyles(element, options);
        applyAnimationToStyles(element, options);
    }
    function applyAnimationFromStyles(element, options) {
        if (options.from) {
            element.css(options.from);
            options.from = null;
        }
    }
    function applyAnimationToStyles(element, options) {
        if (options.to) {
            element.css(options.to);
            options.to = null;
        }
    }
    function mergeAnimationDetails(element, oldAnimation, newAnimation) {
        var target = oldAnimation.options || {};
        var newOptions = newAnimation.options || {};
        var toAdd = (target.addClass || "") + " " + (newOptions.addClass || "");
        var toRemove = (target.removeClass || "") + " " + (newOptions.removeClass || "");
        var classes = resolveElementClasses(element.attr("class"), toAdd, toRemove);
        if (newOptions.preparationClasses) {
            target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
            delete newOptions.preparationClasses;
        }
        // noop is basically when there is no callback; otherwise something has been set
        var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
        extend(target, newOptions);
        // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
        if (realDomOperation) target.domOperation = realDomOperation;
        if (classes.addClass) target.addClass = classes.addClass;
        else target.addClass = null;
        if (classes.removeClass) target.removeClass = classes.removeClass;
        else target.removeClass = null;
        oldAnimation.addClass = target.addClass;
        oldAnimation.removeClass = target.removeClass;
        return target;
    }
    function resolveElementClasses(existing, toAdd, toRemove) {
        var ADD_CLASS = 1;
        var REMOVE_CLASS = -1;
        var flags = {};
        existing = splitClassesToLookup(existing);
        toAdd = splitClassesToLookup(toAdd);
        forEach(toAdd, function(value, key) {
            flags[key] = ADD_CLASS;
        });
        toRemove = splitClassesToLookup(toRemove);
        forEach(toRemove, function(value, key) {
            flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
        });
        var classes = {
            addClass: "",
            removeClass: ""
        };
        forEach(flags, function(val, klass) {
            var prop, allow;
            if (val === ADD_CLASS) {
                prop = "addClass";
                allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
            } else if (val === REMOVE_CLASS) {
                prop = "removeClass";
                allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
            }
            if (allow) {
                if (classes[prop].length) classes[prop] += " ";
                classes[prop] += klass;
            }
        });
        function splitClassesToLookup(classes) {
            if (isString(classes)) classes = classes.split(" ");
            var obj = {};
            forEach(classes, function(klass) {
                // sometimes the split leaves empty string values
                // incase extra spaces were applied to the options
                if (klass.length) obj[klass] = true;
            });
            return obj;
        }
        return classes;
    }
    function getDomNode(element) {
        return element instanceof jqLite ? element[0] : element;
    }
    function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
        var classes = "";
        if (event) classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
        if (options.addClass) classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
        if (options.removeClass) classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
        if (classes.length) {
            options.preparationClasses = classes;
            element.addClass(classes);
        }
    }
    function clearGeneratedClasses(element, options) {
        if (options.preparationClasses) {
            element.removeClass(options.preparationClasses);
            options.preparationClasses = null;
        }
        if (options.activeClasses) {
            element.removeClass(options.activeClasses);
            options.activeClasses = null;
        }
    }
    function blockKeyframeAnimations(node, applyBlock) {
        var value = applyBlock ? "paused" : "";
        var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
        applyInlineStyle(node, [
            key,
            value
        ]);
        return [
            key,
            value
        ];
    }
    function applyInlineStyle(node, styleTuple) {
        var prop = styleTuple[0];
        var value = styleTuple[1];
        node.style[prop] = value;
    }
    function concatWithSpace(a, b) {
        if (!a) return b;
        if (!b) return a;
        return a + " " + b;
    }
    var helpers = {
        blockTransitions: function(node, duration) {
            // we use a negative delay value since it performs blocking
            // yet it doesn't kill any existing transitions running on the
            // same element which makes this safe for class-based animations
            var value = duration ? "-" + duration + "s" : "";
            applyInlineStyle(node, [
                TRANSITION_DELAY_PROP,
                value
            ]);
            return [
                TRANSITION_DELAY_PROP,
                value
            ];
        }
    };
    var $$rAFSchedulerFactory = [
        "$$rAF",
        function($$rAF) {
            var queue, cancelFn;
            function scheduler(tasks) {
                // we make a copy since RAFScheduler mutates the state
                // of the passed in array variable and this would be difficult
                // to track down on the outside code
                queue = queue.concat(tasks);
                nextTick();
            }
            queue = scheduler.queue = [];
            /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */ scheduler.waitUntilQuiet = function(fn) {
                if (cancelFn) cancelFn();
                cancelFn = $$rAF(function() {
                    cancelFn = null;
                    fn();
                    nextTick();
                });
            };
            return scheduler;
            function nextTick() {
                if (!queue.length) return;
                var items = queue.shift();
                for(var i = 0; i < items.length; i++)items[i]();
                if (!cancelFn) $$rAF(function() {
                    if (!cancelFn) nextTick();
                });
            }
        }
    ];
    /**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */ var $$AnimateChildrenDirective = [
        "$interpolate",
        function($interpolate) {
            return {
                link: function(scope, element, attrs) {
                    var val = attrs.ngAnimateChildren;
                    if (isString(val) && val.length === 0) element.data(NG_ANIMATE_CHILDREN_DATA, true);
                    else {
                        // Interpolate and set the value, so that it is available to
                        // animations that run right after compilation
                        setData($interpolate(val)(scope));
                        attrs.$observe("ngAnimateChildren", setData);
                    }
                    function setData(value) {
                        value = value === "on" || value === "true";
                        element.data(NG_ANIMATE_CHILDREN_DATA, value);
                    }
                }
            };
        }
    ];
    /* exported $AnimateCssProvider */ var ANIMATE_TIMER_KEY = "$$animateCss";
    /**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## General Use
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */ var ONE_SECOND = 1000;
    var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
    var CLOSING_TIME_BUFFER = 1.5;
    var DETECT_CSS_PROPERTIES = {
        transitionDuration: TRANSITION_DURATION_PROP,
        transitionDelay: TRANSITION_DELAY_PROP,
        transitionProperty: TRANSITION_PROP + PROPERTY_KEY,
        animationDuration: ANIMATION_DURATION_PROP,
        animationDelay: ANIMATION_DELAY_PROP,
        animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
    };
    var DETECT_STAGGER_CSS_PROPERTIES = {
        transitionDuration: TRANSITION_DURATION_PROP,
        transitionDelay: TRANSITION_DELAY_PROP,
        animationDuration: ANIMATION_DURATION_PROP,
        animationDelay: ANIMATION_DELAY_PROP
    };
    function getCssKeyframeDurationStyle(duration) {
        return [
            ANIMATION_DURATION_PROP,
            duration + "s"
        ];
    }
    function getCssDelayStyle(delay, isKeyframeAnimation) {
        var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
        return [
            prop,
            delay + "s"
        ];
    }
    function computeCssStyles($window, element, properties) {
        var styles = Object.create(null);
        var detectedStyles = $window.getComputedStyle(element) || {};
        forEach(properties, function(formalStyleName, actualStyleName) {
            var val = detectedStyles[formalStyleName];
            if (val) {
                var c = val.charAt(0);
                // only numerical-based values have a negative sign or digit as the first value
                if (c === "-" || c === "+" || c >= 0) val = parseMaxTime(val);
                // by setting this to null in the event that the delay is not set or is set directly as 0
                // then we can still allow for negative values to be used later on and not mistake this
                // value for being greater than any other negative value.
                if (val === 0) val = null;
                styles[actualStyleName] = val;
            }
        });
        return styles;
    }
    function parseMaxTime(str) {
        var maxValue = 0;
        var values = str.split(/\s*,\s*/);
        forEach(values, function(value) {
            // it's always safe to consider only second values and omit `ms` values since
            // getComputedStyle will always handle the conversion for us
            if (value.charAt(value.length - 1) === "s") value = value.substring(0, value.length - 1);
            value = parseFloat(value) || 0;
            maxValue = maxValue ? Math.max(value, maxValue) : value;
        });
        return maxValue;
    }
    function truthyTimingValue(val) {
        return val === 0 || val != null;
    }
    function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
        var style = TRANSITION_PROP;
        var value = duration + "s";
        if (applyOnlyDuration) style += DURATION_KEY;
        else value += " linear all";
        return [
            style,
            value
        ];
    }
    // we do not reassign an already present style value since
    // if we detect the style property value again we may be
    // detecting styles that were added via the `from` styles.
    // We make use of `isDefined` here since an empty string
    // or null value (which is what getPropertyValue will return
    // for a non-existing style) will still be marked as a valid
    // value for the style (a falsy value implies that the style
    // is to be removed at the end of the animation). If we had a simple
    // "OR" statement then it would not be enough to catch that.
    function registerRestorableStyles(backup, node, properties) {
        forEach(properties, function(prop) {
            backup[prop] = isDefined(backup[prop]) ? backup[prop] : node.style.getPropertyValue(prop);
        });
    }
    var $AnimateCssProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            this.$get = [
                "$window",
                "$$jqLite",
                "$$AnimateRunner",
                "$timeout",
                "$$animateCache",
                "$$forceReflow",
                "$sniffer",
                "$$rAFScheduler",
                "$$animateQueue",
                function($window, $$jqLite, $$AnimateRunner, $timeout, $$animateCache, $$forceReflow, $sniffer, $$rAFScheduler, $$animateQueue) {
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
                        var timings = $$animateCache.get(cacheKey);
                        if (!timings) {
                            timings = computeCssStyles($window, node, properties);
                            if (timings.animationIterationCount === "infinite") timings.animationIterationCount = 1;
                        }
                        // if a css animation has no duration we
                        // should mark that so that repeated addClass/removeClass calls are skipped
                        var hasDuration = allowNoDuration || timings.transitionDuration > 0 || timings.animationDuration > 0;
                        // we keep putting this in multiple times even though the value and the cacheKey are the same
                        // because we're keeping an internal tally of how many duplicate animations are detected.
                        $$animateCache.put(cacheKey, timings, hasDuration);
                        return timings;
                    }
                    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
                        var stagger;
                        var staggerCacheKey = "stagger-" + cacheKey;
                        // if we have one or more existing matches of matching elements
                        // containing the same parent + CSS styles (which is how cacheKey works)
                        // then staggering is possible
                        if ($$animateCache.count(cacheKey) > 0) {
                            stagger = $$animateCache.get(staggerCacheKey);
                            if (!stagger) {
                                var staggerClassName = pendClasses(className, "-stagger");
                                $$jqLite.addClass(node, staggerClassName);
                                stagger = computeCssStyles($window, node, properties);
                                // force the conversion of a null value to zero incase not set
                                stagger.animationDuration = Math.max(stagger.animationDuration, 0);
                                stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
                                $$jqLite.removeClass(node, staggerClassName);
                                $$animateCache.put(staggerCacheKey, stagger, true);
                            }
                        }
                        return stagger || {};
                    }
                    var rafWaitQueue = [];
                    function waitUntilQuiet(callback) {
                        rafWaitQueue.push(callback);
                        $$rAFScheduler.waitUntilQuiet(function() {
                            $$animateCache.flush();
                            // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
                            // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
                            var pageWidth = $$forceReflow();
                            // we use a for loop to ensure that if the queue is changed
                            // during this looping then it will consider new requests
                            for(var i = 0; i < rafWaitQueue.length; i++)rafWaitQueue[i](pageWidth);
                            rafWaitQueue.length = 0;
                        });
                    }
                    function computeTimings(node, className, cacheKey, allowNoDuration) {
                        var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
                        var aD = timings.animationDelay;
                        var tD = timings.transitionDelay;
                        timings.maxDelay = aD && tD ? Math.max(aD, tD) : aD || tD;
                        timings.maxDuration = Math.max(timings.animationDuration * timings.animationIterationCount, timings.transitionDuration);
                        return timings;
                    }
                    return function init(element, initialOptions) {
                        // all of the animation functions should create
                        // a copy of the options data, however, if a
                        // parent service has already created a copy then
                        // we should stick to using that
                        var options = initialOptions || {};
                        if (!options.$$prepared) options = prepareAnimationOptions(copy(options));
                        var restoreStyles = {};
                        var node = getDomNode(element);
                        if (!node || !node.parentNode || !$$animateQueue.enabled()) return closeAndReturnNoopAnimator();
                        var temporaryStyles = [];
                        var classes = element.attr("class");
                        var styles = packageStyles(options);
                        var animationClosed;
                        var animationPaused;
                        var animationCompleted;
                        var runner;
                        var runnerHost;
                        var maxDelay;
                        var maxDelayTime;
                        var maxDuration;
                        var maxDurationTime;
                        var startTime;
                        var events = [];
                        if (options.duration === 0 || !$sniffer.animations && !$sniffer.transitions) return closeAndReturnNoopAnimator();
                        var method = options.event && isArray(options.event) ? options.event.join(" ") : options.event;
                        var isStructural = method && options.structural;
                        var structuralClassName = "";
                        var addRemoveClassName = "";
                        if (isStructural) structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
                        else if (method) structuralClassName = method;
                        if (options.addClass) addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
                        if (options.removeClass) {
                            if (addRemoveClassName.length) addRemoveClassName += " ";
                            addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
                        }
                        // there may be a situation where a structural animation is combined together
                        // with CSS classes that need to resolve before the animation is computed.
                        // However this means that there is no explicit CSS code to block the animation
                        // from happening (by setting 0s none in the class name). If this is the case
                        // we need to apply the classes before the first rAF so we know to continue if
                        // there actually is a detected transition or keyframe animation
                        if (options.applyClassesEarly && addRemoveClassName.length) applyAnimationClasses(element, options);
                        var preparationClasses = [
                            structuralClassName,
                            addRemoveClassName
                        ].join(" ").trim();
                        var fullClassName = classes + " " + preparationClasses;
                        var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
                        var containsKeyframeAnimation = (options.keyframeStyle || "").length > 0;
                        // there is no way we can trigger an animation if no styles and
                        // no classes are being applied which would then trigger a transition,
                        // unless there a is raw keyframe value that is applied to the element.
                        if (!containsKeyframeAnimation && !hasToStyles && !preparationClasses) return closeAndReturnNoopAnimator();
                        var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
                        if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                            preparationClasses = null;
                            return closeAndReturnNoopAnimator();
                        }
                        if (options.stagger > 0) {
                            var staggerVal = parseFloat(options.stagger);
                            stagger = {
                                transitionDelay: staggerVal,
                                animationDelay: staggerVal,
                                transitionDuration: 0,
                                animationDuration: 0
                            };
                        } else stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
                        if (!options.$$skipPreparationClasses) $$jqLite.addClass(element, preparationClasses);
                        var applyOnlyDuration;
                        if (options.transitionStyle) {
                            var transitionStyle = [
                                TRANSITION_PROP,
                                options.transitionStyle
                            ];
                            applyInlineStyle(node, transitionStyle);
                            temporaryStyles.push(transitionStyle);
                        }
                        if (options.duration >= 0) {
                            applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
                            var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
                            // we set the duration so that it will be picked up by getComputedStyle later
                            applyInlineStyle(node, durationStyle);
                            temporaryStyles.push(durationStyle);
                        }
                        if (options.keyframeStyle) {
                            var keyframeStyle = [
                                ANIMATION_PROP,
                                options.keyframeStyle
                            ];
                            applyInlineStyle(node, keyframeStyle);
                            temporaryStyles.push(keyframeStyle);
                        }
                        var itemIndex = stagger ? options.staggerIndex >= 0 ? options.staggerIndex : $$animateCache.count(cacheKey) : 0;
                        var isFirst = itemIndex === 0;
                        // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
                        // without causing any combination of transitions to kick in. By adding a negative delay value
                        // it forces the setup class' transition to end immediately. We later then remove the negative
                        // transition delay to allow for the transition to naturally do it's thing. The beauty here is
                        // that if there is no transition defined then nothing will happen and this will also allow
                        // other transitions to be stacked on top of each other without any chopping them out.
                        if (isFirst && !options.skipBlocking) helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
                        var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
                        var relativeDelay = timings.maxDelay;
                        maxDelay = Math.max(relativeDelay, 0);
                        maxDuration = timings.maxDuration;
                        var flags = {};
                        flags.hasTransitions = timings.transitionDuration > 0;
                        flags.hasAnimations = timings.animationDuration > 0;
                        flags.hasTransitionAll = flags.hasTransitions && timings.transitionProperty === "all";
                        flags.applyTransitionDuration = hasToStyles && (flags.hasTransitions && !flags.hasTransitionAll || flags.hasAnimations && !flags.hasTransitions);
                        flags.applyAnimationDuration = options.duration && flags.hasAnimations;
                        flags.applyTransitionDelay = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
                        flags.applyAnimationDelay = truthyTimingValue(options.delay) && flags.hasAnimations;
                        flags.recalculateTimingStyles = addRemoveClassName.length > 0;
                        if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
                            maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
                            if (flags.applyTransitionDuration) {
                                flags.hasTransitions = true;
                                timings.transitionDuration = maxDuration;
                                applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
                                temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
                            }
                            if (flags.applyAnimationDuration) {
                                flags.hasAnimations = true;
                                timings.animationDuration = maxDuration;
                                temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
                            }
                        }
                        if (maxDuration === 0 && !flags.recalculateTimingStyles) return closeAndReturnNoopAnimator();
                        var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
                        if (options.delay != null) {
                            var delayStyle;
                            if (typeof options.delay !== "boolean") {
                                delayStyle = parseFloat(options.delay);
                                // number in options.delay means we have to recalculate the delay for the closing timeout
                                maxDelay = Math.max(delayStyle, 0);
                            }
                            if (flags.applyTransitionDelay) temporaryStyles.push(getCssDelayStyle(delayStyle));
                            if (flags.applyAnimationDelay) temporaryStyles.push(getCssDelayStyle(delayStyle, true));
                        }
                        // we need to recalculate the delay value since we used a pre-emptive negative
                        // delay value and the delay value is required for the final event checking. This
                        // property will ensure that this will happen after the RAF phase has passed.
                        if (options.duration == null && timings.transitionDuration > 0) flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
                        maxDelayTime = maxDelay * ONE_SECOND;
                        maxDurationTime = maxDuration * ONE_SECOND;
                        if (!options.skipBlocking) {
                            flags.blockTransition = timings.transitionDuration > 0;
                            flags.blockKeyframeAnimation = timings.animationDuration > 0 && stagger.animationDelay > 0 && stagger.animationDuration === 0;
                        }
                        if (options.from) {
                            if (options.cleanupStyles) registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
                            applyAnimationFromStyles(element, options);
                        }
                        if (flags.blockTransition || flags.blockKeyframeAnimation) applyBlocking(maxDuration);
                        else if (!options.skipBlocking) helpers.blockTransitions(node, false);
                        // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
                        return {
                            $$willAnimate: true,
                            end: endFn,
                            start: function() {
                                if (animationClosed) return;
                                runnerHost = {
                                    end: endFn,
                                    cancel: cancelFn,
                                    resume: null,
                                    pause: null
                                };
                                runner = new $$AnimateRunner(runnerHost);
                                waitUntilQuiet(start);
                                // we don't have access to pause/resume the animation
                                // since it hasn't run yet. AnimateRunner will therefore
                                // set noop functions for resume and pause and they will
                                // later be overridden once the animation is triggered
                                return runner;
                            }
                        };
                        function endFn() {
                            close();
                        }
                        function cancelFn() {
                            close(true);
                        }
                        function close(rejected) {
                            // if the promise has been called already then we shouldn't close
                            // the animation again
                            if (animationClosed || animationCompleted && animationPaused) return;
                            animationClosed = true;
                            animationPaused = false;
                            if (preparationClasses && !options.$$skipPreparationClasses) $$jqLite.removeClass(element, preparationClasses);
                            if (activeClasses) $$jqLite.removeClass(element, activeClasses);
                            blockKeyframeAnimations(node, false);
                            helpers.blockTransitions(node, false);
                            forEach(temporaryStyles, function(entry) {
                                // There is only one way to remove inline style properties entirely from elements.
                                // By using `removeProperty` this works, but we need to convert camel-cased CSS
                                // styles down to hyphenated values.
                                node.style[entry[0]] = "";
                            });
                            applyAnimationClasses(element, options);
                            applyAnimationStyles(element, options);
                            if (Object.keys(restoreStyles).length) forEach(restoreStyles, function(value, prop) {
                                if (value) node.style.setProperty(prop, value);
                                else node.style.removeProperty(prop);
                            });
                            // the reason why we have this option is to allow a synchronous closing callback
                            // that is fired as SOON as the animation ends (when the CSS is removed) or if
                            // the animation never takes off at all. A good example is a leave animation since
                            // the element must be removed just after the animation is over or else the element
                            // will appear on screen for one animation frame causing an overbearing flicker.
                            if (options.onDone) options.onDone();
                            if (events && events.length) // Remove the transitionend / animationend listener(s)
                            element.off(events.join(" "), onAnimationProgress);
                            //Cancel the fallback closing timeout and remove the timer data
                            var animationTimerData = element.data(ANIMATE_TIMER_KEY);
                            if (animationTimerData) {
                                $timeout.cancel(animationTimerData[0].timer);
                                element.removeData(ANIMATE_TIMER_KEY);
                            }
                            // if the preparation function fails then the promise is not setup
                            if (runner) runner.complete(!rejected);
                        }
                        function applyBlocking(duration) {
                            if (flags.blockTransition) helpers.blockTransitions(node, duration);
                            if (flags.blockKeyframeAnimation) blockKeyframeAnimations(node, !!duration);
                        }
                        function closeAndReturnNoopAnimator() {
                            runner = new $$AnimateRunner({
                                end: endFn,
                                cancel: cancelFn
                            });
                            // should flush the cache animation
                            waitUntilQuiet(noop);
                            close();
                            return {
                                $$willAnimate: false,
                                start: function() {
                                    return runner;
                                },
                                end: endFn
                            };
                        }
                        function onAnimationProgress(event) {
                            event.stopPropagation();
                            var ev = event.originalEvent || event;
                            if (ev.target !== node) // Since TransitionEvent / AnimationEvent bubble up,
                            // we have to ignore events by finished child animations
                            return;
                            // we now always use `Date.now()` due to the recent changes with
                            // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
                            var timeStamp = ev.$manualTimeStamp || Date.now();
                            /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */ var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
                            /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */ if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
                                // we set this flag to ensure that if the transition is paused then, when resumed,
                                // the animation will automatically close itself since transitions cannot be paused.
                                animationCompleted = true;
                                close();
                            }
                        }
                        function start() {
                            if (animationClosed) return;
                            if (!node.parentNode) {
                                close();
                                return;
                            }
                            // even though we only pause keyframe animations here the pause flag
                            // will still happen when transitions are used. Only the transition will
                            // not be paused since that is not possible. If the animation ends when
                            // paused then it will not complete until unpaused or cancelled.
                            var playPause = function(playAnimation) {
                                if (!animationCompleted) {
                                    animationPaused = !playAnimation;
                                    if (timings.animationDuration) {
                                        var value = blockKeyframeAnimations(node, animationPaused);
                                        if (animationPaused) temporaryStyles.push(value);
                                        else removeFromArray(temporaryStyles, value);
                                    }
                                } else if (animationPaused && playAnimation) {
                                    animationPaused = false;
                                    close();
                                }
                            };
                            // checking the stagger duration prevents an accidentally cascade of the CSS delay style
                            // being inherited from the parent. If the transition duration is zero then we can safely
                            // rely that the delay value is an intentional stagger delay style.
                            var maxStagger = itemIndex > 0 && (timings.transitionDuration && stagger.transitionDuration === 0 || timings.animationDuration && stagger.animationDuration === 0) && Math.max(stagger.animationDelay, stagger.transitionDelay);
                            if (maxStagger) $timeout(triggerAnimationStart, Math.floor(maxStagger * itemIndex * ONE_SECOND), false);
                            else triggerAnimationStart();
                            // this will decorate the existing promise runner with pause/resume methods
                            runnerHost.resume = function() {
                                playPause(true);
                            };
                            runnerHost.pause = function() {
                                playPause(false);
                            };
                            function triggerAnimationStart() {
                                // just incase a stagger animation kicks in when the animation
                                // itself was cancelled entirely
                                if (animationClosed) return;
                                applyBlocking(false);
                                forEach(temporaryStyles, function(entry) {
                                    var key = entry[0];
                                    var value = entry[1];
                                    node.style[key] = value;
                                });
                                applyAnimationClasses(element, options);
                                $$jqLite.addClass(element, activeClasses);
                                if (flags.recalculateTimingStyles) {
                                    fullClassName = node.getAttribute("class") + " " + preparationClasses;
                                    cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
                                    timings = computeTimings(node, fullClassName, cacheKey, false);
                                    relativeDelay = timings.maxDelay;
                                    maxDelay = Math.max(relativeDelay, 0);
                                    maxDuration = timings.maxDuration;
                                    if (maxDuration === 0) {
                                        close();
                                        return;
                                    }
                                    flags.hasTransitions = timings.transitionDuration > 0;
                                    flags.hasAnimations = timings.animationDuration > 0;
                                }
                                if (flags.applyAnimationDelay) {
                                    relativeDelay = typeof options.delay !== "boolean" && truthyTimingValue(options.delay) ? parseFloat(options.delay) : relativeDelay;
                                    maxDelay = Math.max(relativeDelay, 0);
                                    timings.animationDelay = relativeDelay;
                                    delayStyle = getCssDelayStyle(relativeDelay, true);
                                    temporaryStyles.push(delayStyle);
                                    node.style[delayStyle[0]] = delayStyle[1];
                                }
                                maxDelayTime = maxDelay * ONE_SECOND;
                                maxDurationTime = maxDuration * ONE_SECOND;
                                if (options.easing) {
                                    var easeProp, easeVal = options.easing;
                                    if (flags.hasTransitions) {
                                        easeProp = TRANSITION_PROP + TIMING_KEY;
                                        temporaryStyles.push([
                                            easeProp,
                                            easeVal
                                        ]);
                                        node.style[easeProp] = easeVal;
                                    }
                                    if (flags.hasAnimations) {
                                        easeProp = ANIMATION_PROP + TIMING_KEY;
                                        temporaryStyles.push([
                                            easeProp,
                                            easeVal
                                        ]);
                                        node.style[easeProp] = easeVal;
                                    }
                                }
                                if (timings.transitionDuration) events.push(TRANSITIONEND_EVENT);
                                if (timings.animationDuration) events.push(ANIMATIONEND_EVENT);
                                startTime = Date.now();
                                var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
                                var endTime = startTime + timerTime;
                                var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
                                var setupFallbackTimer = true;
                                if (animationsData.length) {
                                    var currentTimerData = animationsData[0];
                                    setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
                                    if (setupFallbackTimer) $timeout.cancel(currentTimerData.timer);
                                    else animationsData.push(close);
                                }
                                if (setupFallbackTimer) {
                                    var timer = $timeout(onAnimationExpired, timerTime, false);
                                    animationsData[0] = {
                                        timer: timer,
                                        expectedEndTime: endTime
                                    };
                                    animationsData.push(close);
                                    element.data(ANIMATE_TIMER_KEY, animationsData);
                                }
                                if (events.length) element.on(events.join(" "), onAnimationProgress);
                                if (options.to) {
                                    if (options.cleanupStyles) registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
                                    applyAnimationToStyles(element, options);
                                }
                            }
                            function onAnimationExpired() {
                                var animationsData = element.data(ANIMATE_TIMER_KEY);
                                // this will be false in the event that the element was
                                // removed from the DOM (via a leave animation or something
                                // similar)
                                if (animationsData) {
                                    for(var i = 1; i < animationsData.length; i++)animationsData[i]();
                                    element.removeData(ANIMATE_TIMER_KEY);
                                }
                            }
                        }
                    };
                }
            ];
        }
    ];
    var $$AnimateCssDriverProvider = [
        "$$animationProvider",
        /** @this */ function($$animationProvider) {
            $$animationProvider.drivers.push("$$animateCssDriver");
            var NG_ANIMATE_SHIM_CLASS_NAME = "ng-animate-shim";
            var NG_ANIMATE_ANCHOR_CLASS_NAME = "ng-anchor";
            var NG_OUT_ANCHOR_CLASS_NAME = "ng-anchor-out";
            var NG_IN_ANCHOR_CLASS_NAME = "ng-anchor-in";
            function isDocumentFragment(node) {
                return node.parentNode && node.parentNode.nodeType === 11;
            }
            this.$get = [
                "$animateCss",
                "$rootScope",
                "$$AnimateRunner",
                "$rootElement",
                "$sniffer",
                "$$jqLite",
                "$document",
                function($animateCss, $rootScope, $$AnimateRunner, $rootElement, $sniffer, $$jqLite, $document) {
                    // only browsers that support these properties can render animations
                    if (!$sniffer.animations && !$sniffer.transitions) return noop;
                    var bodyNode = $document[0].body;
                    var rootNode = getDomNode($rootElement);
                    var rootBodyElement = jqLite(// this is to avoid using something that exists outside of the body
                    // we also special case the doc fragment case because our unit test code
                    // appends the $rootElement to the body after the app has been bootstrapped
                    isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode);
                    return function initDriverFn(animationDetails) {
                        return animationDetails.from && animationDetails.to ? prepareFromToAnchorAnimation(animationDetails.from, animationDetails.to, animationDetails.classes, animationDetails.anchors) : prepareRegularAnimation(animationDetails);
                    };
                    function filterCssClasses(classes) {
                        //remove all the `ng-` stuff
                        return classes.replace(/\bng-\S+\b/g, "");
                    }
                    function getUniqueValues(a, b) {
                        if (isString(a)) a = a.split(" ");
                        if (isString(b)) b = b.split(" ");
                        return a.filter(function(val) {
                            return b.indexOf(val) === -1;
                        }).join(" ");
                    }
                    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
                        var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
                        var startingClasses = filterCssClasses(getClassVal(clone));
                        outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
                        inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
                        clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
                        rootBodyElement.append(clone);
                        var animatorIn, animatorOut = prepareOutAnimation();
                        // the user may not end up using the `out` animation and
                        // only making use of the `in` animation or vice-versa.
                        // In either case we should allow this and not assume the
                        // animation is over unless both animations are not used.
                        if (!animatorOut) {
                            animatorIn = prepareInAnimation();
                            if (!animatorIn) return end();
                        }
                        var startingAnimator = animatorOut || animatorIn;
                        return {
                            start: function() {
                                var runner;
                                var currentAnimation = startingAnimator.start();
                                currentAnimation.done(function() {
                                    currentAnimation = null;
                                    if (!animatorIn) {
                                        animatorIn = prepareInAnimation();
                                        if (animatorIn) {
                                            currentAnimation = animatorIn.start();
                                            currentAnimation.done(function() {
                                                currentAnimation = null;
                                                end();
                                                runner.complete();
                                            });
                                            return currentAnimation;
                                        }
                                    }
                                    // in the event that there is no `in` animation
                                    end();
                                    runner.complete();
                                });
                                runner = new $$AnimateRunner({
                                    end: endFn,
                                    cancel: endFn
                                });
                                return runner;
                                function endFn() {
                                    if (currentAnimation) currentAnimation.end();
                                }
                            }
                        };
                        function calculateAnchorStyles(anchor) {
                            var styles = {};
                            var coords = getDomNode(anchor).getBoundingClientRect();
                            // we iterate directly since safari messes up and doesn't return
                            // all the keys for the coords object when iterated
                            forEach([
                                "width",
                                "height",
                                "top",
                                "left"
                            ], function(key) {
                                var value = coords[key];
                                switch(key){
                                    case "top":
                                        value += bodyNode.scrollTop;
                                        break;
                                    case "left":
                                        value += bodyNode.scrollLeft;
                                        break;
                                }
                                styles[key] = Math.floor(value) + "px";
                            });
                            return styles;
                        }
                        function prepareOutAnimation() {
                            var animator = $animateCss(clone, {
                                addClass: NG_OUT_ANCHOR_CLASS_NAME,
                                delay: true,
                                from: calculateAnchorStyles(outAnchor)
                            });
                            // read the comment within `prepareRegularAnimation` to understand
                            // why this check is necessary
                            return animator.$$willAnimate ? animator : null;
                        }
                        function getClassVal(element) {
                            return element.attr("class") || "";
                        }
                        function prepareInAnimation() {
                            var endingClasses = filterCssClasses(getClassVal(inAnchor));
                            var toAdd = getUniqueValues(endingClasses, startingClasses);
                            var toRemove = getUniqueValues(startingClasses, endingClasses);
                            var animator = $animateCss(clone, {
                                to: calculateAnchorStyles(inAnchor),
                                addClass: NG_IN_ANCHOR_CLASS_NAME + " " + toAdd,
                                removeClass: NG_OUT_ANCHOR_CLASS_NAME + " " + toRemove,
                                delay: true
                            });
                            // read the comment within `prepareRegularAnimation` to understand
                            // why this check is necessary
                            return animator.$$willAnimate ? animator : null;
                        }
                        function end() {
                            clone.remove();
                            outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
                            inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
                        }
                    }
                    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
                        var fromAnimation = prepareRegularAnimation(from, noop);
                        var toAnimation = prepareRegularAnimation(to, noop);
                        var anchorAnimations = [];
                        forEach(anchors, function(anchor) {
                            var outElement = anchor["out"];
                            var inElement = anchor["in"];
                            var animator = prepareAnchoredAnimation(classes, outElement, inElement);
                            if (animator) anchorAnimations.push(animator);
                        });
                        // no point in doing anything when there are no elements to animate
                        if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
                        return {
                            start: function() {
                                var animationRunners = [];
                                if (fromAnimation) animationRunners.push(fromAnimation.start());
                                if (toAnimation) animationRunners.push(toAnimation.start());
                                forEach(anchorAnimations, function(animation) {
                                    animationRunners.push(animation.start());
                                });
                                var runner = new $$AnimateRunner({
                                    end: endFn,
                                    cancel: endFn // CSS-driven animations cannot be cancelled, only ended
                                });
                                $$AnimateRunner.all(animationRunners, function(status) {
                                    runner.complete(status);
                                });
                                return runner;
                                function endFn() {
                                    forEach(animationRunners, function(runner) {
                                        runner.end();
                                    });
                                }
                            }
                        };
                    }
                    function prepareRegularAnimation(animationDetails) {
                        var element = animationDetails.element;
                        var options = animationDetails.options || {};
                        if (animationDetails.structural) {
                            options.event = animationDetails.event;
                            options.structural = true;
                            options.applyClassesEarly = true;
                            // we special case the leave animation since we want to ensure that
                            // the element is removed as soon as the animation is over. Otherwise
                            // a flicker might appear or the element may not be removed at all
                            if (animationDetails.event === "leave") options.onDone = options.domOperation;
                        }
                        // We assign the preparationClasses as the actual animation event since
                        // the internals of $animateCss will just suffix the event token values
                        // with `-active` to trigger the animation.
                        if (options.preparationClasses) options.event = concatWithSpace(options.event, options.preparationClasses);
                        var animator = $animateCss(element, options);
                        // the driver lookup code inside of $$animation attempts to spawn a
                        // driver one by one until a driver returns a.$$willAnimate animator object.
                        // $animateCss will always return an object, however, it will pass in
                        // a flag as a hint as to whether an animation was detected or not
                        return animator.$$willAnimate ? animator : null;
                    }
                }
            ];
        }
    ];
    // TODO(matsko): use caching here to speed things up for detection
    // TODO(matsko): add documentation
    //  by the time...
    var $$AnimateJsProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            this.$get = [
                "$injector",
                "$$AnimateRunner",
                "$$jqLite",
                function($injector, $$AnimateRunner, $$jqLite) {
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    // $animateJs(element, 'enter');
                    return function(element, event, classes, options) {
                        var animationClosed = false;
                        // the `classes` argument is optional and if it is not used
                        // then the classes will be resolved from the element's className
                        // property as well as options.addClass/options.removeClass.
                        if (arguments.length === 3 && isObject(classes)) {
                            options = classes;
                            classes = null;
                        }
                        options = prepareAnimationOptions(options);
                        if (!classes) {
                            classes = element.attr("class") || "";
                            if (options.addClass) classes += " " + options.addClass;
                            if (options.removeClass) classes += " " + options.removeClass;
                        }
                        var classesToAdd = options.addClass;
                        var classesToRemove = options.removeClass;
                        // the lookupAnimations function returns a series of animation objects that are
                        // matched up with one or more of the CSS classes. These animation objects are
                        // defined via the module.animation factory function. If nothing is detected then
                        // we don't return anything which then makes $animation query the next driver.
                        var animations = lookupAnimations(classes);
                        var before, after;
                        if (animations.length) {
                            var afterFn, beforeFn;
                            if (event === "leave") {
                                beforeFn = "leave";
                                afterFn = "afterLeave"; // TODO(matsko): get rid of this
                            } else {
                                beforeFn = "before" + event.charAt(0).toUpperCase() + event.substr(1);
                                afterFn = event;
                            }
                            if (event !== "enter" && event !== "move") before = packageAnimations(element, event, options, animations, beforeFn);
                            after = packageAnimations(element, event, options, animations, afterFn);
                        }
                        // no matching animations
                        if (!before && !after) return;
                        function applyOptions() {
                            options.domOperation();
                            applyAnimationClasses(element, options);
                        }
                        function close() {
                            animationClosed = true;
                            applyOptions();
                            applyAnimationStyles(element, options);
                        }
                        var runner;
                        return {
                            $$willAnimate: true,
                            end: function() {
                                if (runner) runner.end();
                                else {
                                    close();
                                    runner = new $$AnimateRunner();
                                    runner.complete(true);
                                }
                                return runner;
                            },
                            start: function() {
                                if (runner) return runner;
                                runner = new $$AnimateRunner();
                                var closeActiveAnimations;
                                var chain = [];
                                if (before) chain.push(function(fn) {
                                    closeActiveAnimations = before(fn);
                                });
                                if (chain.length) chain.push(function(fn) {
                                    applyOptions();
                                    fn(true);
                                });
                                else applyOptions();
                                if (after) chain.push(function(fn) {
                                    closeActiveAnimations = after(fn);
                                });
                                runner.setHost({
                                    end: function() {
                                        endAnimations();
                                    },
                                    cancel: function() {
                                        endAnimations(true);
                                    }
                                });
                                $$AnimateRunner.chain(chain, onComplete);
                                return runner;
                                function onComplete(success) {
                                    close(success);
                                    runner.complete(success);
                                }
                                function endAnimations(cancelled) {
                                    if (!animationClosed) {
                                        (closeActiveAnimations || noop)(cancelled);
                                        onComplete(cancelled);
                                    }
                                }
                            }
                        };
                        function executeAnimationFn(fn, element, event, options, onDone) {
                            var args;
                            switch(event){
                                case "animate":
                                    args = [
                                        element,
                                        options.from,
                                        options.to,
                                        onDone
                                    ];
                                    break;
                                case "setClass":
                                    args = [
                                        element,
                                        classesToAdd,
                                        classesToRemove,
                                        onDone
                                    ];
                                    break;
                                case "addClass":
                                    args = [
                                        element,
                                        classesToAdd,
                                        onDone
                                    ];
                                    break;
                                case "removeClass":
                                    args = [
                                        element,
                                        classesToRemove,
                                        onDone
                                    ];
                                    break;
                                default:
                                    args = [
                                        element,
                                        onDone
                                    ];
                                    break;
                            }
                            args.push(options);
                            var value = fn.apply(fn, args);
                            if (value) {
                                if (isFunction(value.start)) value = value.start();
                                if (value instanceof $$AnimateRunner) value.done(onDone);
                                else if (isFunction(value)) // optional onEnd / onCancel callback
                                return value;
                            }
                            return noop;
                        }
                        function groupEventedAnimations(element, event, options, animations, fnName) {
                            var operations = [];
                            forEach(animations, function(ani) {
                                var animation = ani[fnName];
                                if (!animation) return;
                                // note that all of these animations will run in parallel
                                operations.push(function() {
                                    var runner;
                                    var endProgressCb;
                                    var resolved = false;
                                    var onAnimationComplete = function(rejected) {
                                        if (!resolved) {
                                            resolved = true;
                                            (endProgressCb || noop)(rejected);
                                            runner.complete(!rejected);
                                        }
                                    };
                                    runner = new $$AnimateRunner({
                                        end: function() {
                                            onAnimationComplete();
                                        },
                                        cancel: function() {
                                            onAnimationComplete(true);
                                        }
                                    });
                                    endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
                                        var cancelled = result === false;
                                        onAnimationComplete(cancelled);
                                    });
                                    return runner;
                                });
                            });
                            return operations;
                        }
                        function packageAnimations(element, event, options, animations, fnName) {
                            var operations = groupEventedAnimations(element, event, options, animations, fnName);
                            if (operations.length === 0) {
                                var a, b;
                                if (fnName === "beforeSetClass") {
                                    a = groupEventedAnimations(element, "removeClass", options, animations, "beforeRemoveClass");
                                    b = groupEventedAnimations(element, "addClass", options, animations, "beforeAddClass");
                                } else if (fnName === "setClass") {
                                    a = groupEventedAnimations(element, "removeClass", options, animations, "removeClass");
                                    b = groupEventedAnimations(element, "addClass", options, animations, "addClass");
                                }
                                if (a) operations = operations.concat(a);
                                if (b) operations = operations.concat(b);
                            }
                            if (operations.length === 0) return;
                            // TODO(matsko): add documentation
                            return function startAnimation(callback) {
                                var runners = [];
                                if (operations.length) forEach(operations, function(animateFn) {
                                    runners.push(animateFn());
                                });
                                if (runners.length) $$AnimateRunner.all(runners, callback);
                                else callback();
                                return function endFn(reject) {
                                    forEach(runners, function(runner) {
                                        if (reject) runner.cancel();
                                        else runner.end();
                                    });
                                };
                            };
                        }
                    };
                    function lookupAnimations(classes) {
                        classes = isArray(classes) ? classes : classes.split(" ");
                        var matches = [], flagMap = {};
                        for(var i = 0; i < classes.length; i++){
                            var klass = classes[i], animationFactory = $animateProvider.$$registeredAnimations[klass];
                            if (animationFactory && !flagMap[klass]) {
                                matches.push($injector.get(animationFactory));
                                flagMap[klass] = true;
                            }
                        }
                        return matches;
                    }
                }
            ];
        }
    ];
    var $$AnimateJsDriverProvider = [
        "$$animationProvider",
        /** @this */ function($$animationProvider) {
            $$animationProvider.drivers.push("$$animateJsDriver");
            this.$get = [
                "$$animateJs",
                "$$AnimateRunner",
                function($$animateJs, $$AnimateRunner) {
                    return function initDriverFn(animationDetails) {
                        if (animationDetails.from && animationDetails.to) {
                            var fromAnimation = prepareAnimation(animationDetails.from);
                            var toAnimation = prepareAnimation(animationDetails.to);
                            if (!fromAnimation && !toAnimation) return;
                            return {
                                start: function() {
                                    var animationRunners = [];
                                    if (fromAnimation) animationRunners.push(fromAnimation.start());
                                    if (toAnimation) animationRunners.push(toAnimation.start());
                                    $$AnimateRunner.all(animationRunners, done);
                                    var runner = new $$AnimateRunner({
                                        end: endFnFactory(),
                                        cancel: endFnFactory()
                                    });
                                    return runner;
                                    function endFnFactory() {
                                        return function() {
                                            forEach(animationRunners, function(runner) {
                                                // at this point we cannot cancel animations for groups just yet. 1.5+
                                                runner.end();
                                            });
                                        };
                                    }
                                    function done(status) {
                                        runner.complete(status);
                                    }
                                }
                            };
                        } else return prepareAnimation(animationDetails);
                    };
                    function prepareAnimation(animationDetails) {
                        // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
                        var element = animationDetails.element;
                        var event = animationDetails.event;
                        var options = animationDetails.options;
                        var classes = animationDetails.classes;
                        return $$animateJs(element, event, classes, options);
                    }
                }
            ];
        }
    ];
    var NG_ANIMATE_ATTR_NAME = "data-ng-animate";
    var NG_ANIMATE_PIN_DATA = "$ngAnimatePin";
    var $$AnimateQueueProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            var PRE_DIGEST_STATE = 1;
            var RUNNING_STATE = 2;
            var ONE_SPACE = " ";
            var rules = this.rules = {
                skip: [],
                cancel: [],
                join: []
            };
            function getEventData(options) {
                return {
                    addClass: options.addClass,
                    removeClass: options.removeClass,
                    from: options.from,
                    to: options.to
                };
            }
            function makeTruthyCssClassMap(classString) {
                if (!classString) return null;
                var keys = classString.split(ONE_SPACE);
                var map = Object.create(null);
                forEach(keys, function(key) {
                    map[key] = true;
                });
                return map;
            }
            function hasMatchingClasses(newClassString, currentClassString) {
                if (newClassString && currentClassString) {
                    var currentClassMap = makeTruthyCssClassMap(currentClassString);
                    return newClassString.split(ONE_SPACE).some(function(className) {
                        return currentClassMap[className];
                    });
                }
            }
            function isAllowed(ruleType, currentAnimation, previousAnimation) {
                return rules[ruleType].some(function(fn) {
                    return fn(currentAnimation, previousAnimation);
                });
            }
            function hasAnimationClasses(animation, and) {
                var a = (animation.addClass || "").length > 0;
                var b = (animation.removeClass || "").length > 0;
                return and ? a && b : a || b;
            }
            rules.join.push(function(newAnimation, currentAnimation) {
                // if the new animation is class-based then we can just tack that on
                return !newAnimation.structural && hasAnimationClasses(newAnimation);
            });
            rules.skip.push(function(newAnimation, currentAnimation) {
                // there is no need to animate anything if no classes are being added and
                // there is no structural animation that will be triggered
                return !newAnimation.structural && !hasAnimationClasses(newAnimation);
            });
            rules.skip.push(function(newAnimation, currentAnimation) {
                // why should we trigger a new structural animation if the element will
                // be removed from the DOM anyway?
                return currentAnimation.event === "leave" && newAnimation.structural;
            });
            rules.skip.push(function(newAnimation, currentAnimation) {
                // if there is an ongoing current animation then don't even bother running the class-based animation
                return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
            });
            rules.cancel.push(function(newAnimation, currentAnimation) {
                // there can never be two structural animations running at the same time
                return currentAnimation.structural && newAnimation.structural;
            });
            rules.cancel.push(function(newAnimation, currentAnimation) {
                // if the previous animation is already running, but the new animation will
                // be triggered, but the new animation is structural
                return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
            });
            rules.cancel.push(function(newAnimation, currentAnimation) {
                // cancel the animation if classes added / removed in both animation cancel each other out,
                // but only if the current animation isn't structural
                if (currentAnimation.structural) return false;
                var nA = newAnimation.addClass;
                var nR = newAnimation.removeClass;
                var cA = currentAnimation.addClass;
                var cR = currentAnimation.removeClass;
                // early detection to save the global CPU shortage :)
                if (isUndefined(nA) && isUndefined(nR) || isUndefined(cA) && isUndefined(cR)) return false;
                return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
            });
            this.$get = [
                "$$rAF",
                "$rootScope",
                "$rootElement",
                "$document",
                "$$Map",
                "$$animation",
                "$$AnimateRunner",
                "$templateRequest",
                "$$jqLite",
                "$$forceReflow",
                "$$isDocumentHidden",
                function($$rAF, $rootScope, $rootElement, $document, $$Map, $$animation, $$AnimateRunner, $templateRequest, $$jqLite, $$forceReflow, $$isDocumentHidden) {
                    var activeAnimationsLookup = new $$Map();
                    var disabledElementsLookup = new $$Map();
                    var animationsEnabled = null;
                    function removeFromDisabledElementsLookup(evt) {
                        disabledElementsLookup.delete(evt.target);
                    }
                    function postDigestTaskFactory() {
                        var postDigestCalled = false;
                        return function(fn) {
                            // we only issue a call to postDigest before
                            // it has first passed. This prevents any callbacks
                            // from not firing once the animation has completed
                            // since it will be out of the digest cycle.
                            if (postDigestCalled) fn();
                            else $rootScope.$$postDigest(function() {
                                postDigestCalled = true;
                                fn();
                            });
                        };
                    }
                    // Wait until all directive and route-related templates are downloaded and
                    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
                    // all of the remote templates being currently downloaded. If there are no
                    // templates currently downloading then the watcher will still fire anyway.
                    var deregisterWatch = $rootScope.$watch(function() {
                        return $templateRequest.totalPendingRequests === 0;
                    }, function(isEmpty) {
                        if (!isEmpty) return;
                        deregisterWatch();
                        // Now that all templates have been downloaded, $animate will wait until
                        // the post digest queue is empty before enabling animations. By having two
                        // calls to $postDigest calls we can ensure that the flag is enabled at the
                        // very end of the post digest queue. Since all of the animations in $animate
                        // use $postDigest, it's important that the code below executes at the end.
                        // This basically means that the page is fully downloaded and compiled before
                        // any animations are triggered.
                        $rootScope.$$postDigest(function() {
                            $rootScope.$$postDigest(function() {
                                // we check for null directly in the event that the application already called
                                // .enabled() with whatever arguments that it provided it with
                                if (animationsEnabled === null) animationsEnabled = true;
                            });
                        });
                    });
                    var callbackRegistry = Object.create(null);
                    // remember that the `customFilter`/`classNameFilter` are set during the
                    // provider/config stage therefore we can optimize here and setup helper functions
                    var customFilter = $animateProvider.customFilter();
                    var classNameFilter = $animateProvider.classNameFilter();
                    var returnTrue = function() {
                        return true;
                    };
                    var isAnimatableByFilter = customFilter || returnTrue;
                    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
                        var className = [
                            node.getAttribute("class"),
                            options.addClass,
                            options.removeClass
                        ].join(" ");
                        return classNameFilter.test(className);
                    };
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    function normalizeAnimationDetails(element, animation) {
                        return mergeAnimationDetails(element, animation, {});
                    }
                    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
                    var contains = window1.Node.prototype.contains || /** @this */ function(arg) {
                        // eslint-disable-next-line no-bitwise
                        return this === arg || !!(this.compareDocumentPosition(arg) & 16);
                    };
                    function findCallbacks(targetParentNode, targetNode, event) {
                        var matches = [];
                        var entries = callbackRegistry[event];
                        if (entries) forEach(entries, function(entry) {
                            if (contains.call(entry.node, targetNode)) matches.push(entry.callback);
                            else if (event === "leave" && contains.call(entry.node, targetParentNode)) matches.push(entry.callback);
                        });
                        return matches;
                    }
                    function filterFromRegistry(list, matchContainer, matchCallback) {
                        var containerNode = extractElementNode(matchContainer);
                        return list.filter(function(entry) {
                            var isMatch = entry.node === containerNode && (!matchCallback || entry.callback === matchCallback);
                            return !isMatch;
                        });
                    }
                    function cleanupEventListeners(phase, node) {
                        if (phase === "close" && !node.parentNode) // If the element is not attached to a parentNode, it has been removed by
                        // the domOperation, and we can safely remove the event callbacks
                        $animate.off(node);
                    }
                    var $animate = {
                        on: function(event, container, callback) {
                            var node = extractElementNode(container);
                            callbackRegistry[event] = callbackRegistry[event] || [];
                            callbackRegistry[event].push({
                                node: node,
                                callback: callback
                            });
                            // Remove the callback when the element is removed from the DOM
                            jqLite(container).on("$destroy", function() {
                                var animationDetails = activeAnimationsLookup.get(node);
                                if (!animationDetails) // If there's an animation ongoing, the callback calling code will remove
                                // the event listeners. If we'd remove here, the callbacks would be removed
                                // before the animation ends
                                $animate.off(event, container, callback);
                            });
                        },
                        off: function(event, container, callback) {
                            if (arguments.length === 1 && !isString(arguments[0])) {
                                container = arguments[0];
                                for(var eventType in callbackRegistry)callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
                                return;
                            }
                            var entries = callbackRegistry[event];
                            if (!entries) return;
                            callbackRegistry[event] = arguments.length === 1 ? null : filterFromRegistry(entries, container, callback);
                        },
                        pin: function(element, parentElement) {
                            assertArg(isElement(element), "element", "not an element");
                            assertArg(isElement(parentElement), "parentElement", "not an element");
                            element.data(NG_ANIMATE_PIN_DATA, parentElement);
                        },
                        push: function(element, event, options, domOperation) {
                            options = options || {};
                            options.domOperation = domOperation;
                            return queueAnimation(element, event, options);
                        },
                        // this method has four signatures:
                        //  () - global getter
                        //  (bool) - global setter
                        //  (element) - element getter
                        //  (element, bool) - element setter<F37>
                        enabled: function(element, bool) {
                            var argCount = arguments.length;
                            if (argCount === 0) // () - Global getter
                            bool = !!animationsEnabled;
                            else {
                                var hasElement = isElement(element);
                                if (!hasElement) // (bool) - Global setter
                                bool = animationsEnabled = !!element;
                                else {
                                    var node = getDomNode(element);
                                    if (argCount === 1) // (element) - Element getter
                                    bool = !disabledElementsLookup.get(node);
                                    else {
                                        // (element, bool) - Element setter
                                        if (!disabledElementsLookup.has(node)) // The element is added to the map for the first time.
                                        // Create a listener to remove it on `$destroy` (to avoid memory leak).
                                        jqLite(element).on("$destroy", removeFromDisabledElementsLookup);
                                        disabledElementsLookup.set(node, !bool);
                                    }
                                }
                            }
                            return bool;
                        }
                    };
                    return $animate;
                    function queueAnimation(originalElement, event, initialOptions) {
                        // we always make a copy of the options since
                        // there should never be any side effects on
                        // the input data when running `$animateCss`.
                        var options = copy(initialOptions);
                        var element = stripCommentsFromElement(originalElement);
                        var node = getDomNode(element);
                        var parentNode = node && node.parentNode;
                        options = prepareAnimationOptions(options);
                        // we create a fake runner with a working promise.
                        // These methods will become available after the digest has passed
                        var runner = new $$AnimateRunner();
                        // this is used to trigger callbacks in postDigest mode
                        var runInNextPostDigestOrNow = postDigestTaskFactory();
                        if (isArray(options.addClass)) options.addClass = options.addClass.join(" ");
                        if (options.addClass && !isString(options.addClass)) options.addClass = null;
                        if (isArray(options.removeClass)) options.removeClass = options.removeClass.join(" ");
                        if (options.removeClass && !isString(options.removeClass)) options.removeClass = null;
                        if (options.from && !isObject(options.from)) options.from = null;
                        if (options.to && !isObject(options.to)) options.to = null;
                        // If animations are hard-disabled for the whole application there is no need to continue.
                        // There are also situations where a directive issues an animation for a jqLite wrapper that
                        // contains only comment nodes. In this case, there is no way we can perform an animation.
                        if (!animationsEnabled || !node || !isAnimatableByFilter(node, event, initialOptions) || !isAnimatableClassName(node, options)) {
                            close();
                            return runner;
                        }
                        var isStructural = [
                            "enter",
                            "move",
                            "leave"
                        ].indexOf(event) >= 0;
                        var documentHidden = $$isDocumentHidden();
                        // This is a hard disable of all animations the element itself, therefore  there is no need to
                        // continue further past this point if not enabled
                        // Animations are also disabled if the document is currently hidden (page is not visible
                        // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
                        var skipAnimations = documentHidden || disabledElementsLookup.get(node);
                        var existingAnimation = !skipAnimations && activeAnimationsLookup.get(node) || {};
                        var hasExistingAnimation = !!existingAnimation.state;
                        // there is no point in traversing the same collection of parent ancestors if a followup
                        // animation will be run on the same element that already did all that checking work
                        if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) skipAnimations = !areAnimationsAllowed(node, parentNode, event);
                        if (skipAnimations) {
                            // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
                            if (documentHidden) notifyProgress(runner, event, "start", getEventData(options));
                            close();
                            if (documentHidden) notifyProgress(runner, event, "close", getEventData(options));
                            return runner;
                        }
                        if (isStructural) closeChildAnimations(node);
                        var newAnimation = {
                            structural: isStructural,
                            element: element,
                            event: event,
                            addClass: options.addClass,
                            removeClass: options.removeClass,
                            close: close,
                            options: options,
                            runner: runner
                        };
                        if (hasExistingAnimation) {
                            var skipAnimationFlag = isAllowed("skip", newAnimation, existingAnimation);
                            if (skipAnimationFlag) {
                                if (existingAnimation.state === RUNNING_STATE) {
                                    close();
                                    return runner;
                                } else {
                                    mergeAnimationDetails(element, existingAnimation, newAnimation);
                                    return existingAnimation.runner;
                                }
                            }
                            var cancelAnimationFlag = isAllowed("cancel", newAnimation, existingAnimation);
                            if (cancelAnimationFlag) {
                                if (existingAnimation.state === RUNNING_STATE) // this will end the animation right away and it is safe
                                // to do so since the animation is already running and the
                                // runner callback code will run in async
                                existingAnimation.runner.end();
                                else if (existingAnimation.structural) // this means that the animation is queued into a digest, but
                                // hasn't started yet. Therefore it is safe to run the close
                                // method which will call the runner methods in async.
                                existingAnimation.close();
                                else {
                                    // this will merge the new animation options into existing animation options
                                    mergeAnimationDetails(element, existingAnimation, newAnimation);
                                    return existingAnimation.runner;
                                }
                            } else {
                                // a joined animation means that this animation will take over the existing one
                                // so an example would involve a leave animation taking over an enter. Then when
                                // the postDigest kicks in the enter will be ignored.
                                var joinAnimationFlag = isAllowed("join", newAnimation, existingAnimation);
                                if (joinAnimationFlag) {
                                    if (existingAnimation.state === RUNNING_STATE) normalizeAnimationDetails(element, newAnimation);
                                    else {
                                        applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);
                                        event = newAnimation.event = existingAnimation.event;
                                        options = mergeAnimationDetails(element, existingAnimation, newAnimation);
                                        //we return the same runner since only the option values of this animation will
                                        //be fed into the `existingAnimation`.
                                        return existingAnimation.runner;
                                    }
                                }
                            }
                        } else // normalization in this case means that it removes redundant CSS classes that
                        // already exist (addClass) or do not exist (removeClass) on the element
                        normalizeAnimationDetails(element, newAnimation);
                        // when the options are merged and cleaned up we may end up not having to do
                        // an animation at all, therefore we should check this before issuing a post
                        // digest callback. Structural animations will always run no matter what.
                        var isValidAnimation = newAnimation.structural;
                        if (!isValidAnimation) // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
                        isValidAnimation = newAnimation.event === "animate" && Object.keys(newAnimation.options.to || {}).length > 0 || hasAnimationClasses(newAnimation);
                        if (!isValidAnimation) {
                            close();
                            clearElementAnimationState(node);
                            return runner;
                        }
                        // the counter keeps track of cancelled animations
                        var counter = (existingAnimation.counter || 0) + 1;
                        newAnimation.counter = counter;
                        markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
                        $rootScope.$$postDigest(function() {
                            // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
                            // happen if the animated element is a transcluded clone and also has a `templateUrl`
                            // directive on it. Therefore, we must recreate `element` in order to interact with the
                            // actual DOM nodes.
                            // Note: We still need to use the old `node` for certain things, such as looking up in
                            //       HashMaps where it was used as the key.
                            element = stripCommentsFromElement(originalElement);
                            var animationDetails = activeAnimationsLookup.get(node);
                            var animationCancelled = !animationDetails;
                            animationDetails = animationDetails || {};
                            // if addClass/removeClass is called before something like enter then the
                            // registered parent element may not be present. The code below will ensure
                            // that a final value for parent element is obtained
                            var parentElement = element.parent() || [];
                            // animate/structural/class-based animations all have requirements. Otherwise there
                            // is no point in performing an animation. The parent node must also be set.
                            var isValidAnimation = parentElement.length > 0 && (animationDetails.event === "animate" || animationDetails.structural || hasAnimationClasses(animationDetails));
                            // this means that the previous animation was cancelled
                            // even if the follow-up animation is the same event
                            if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
                                // if another animation did not take over then we need
                                // to make sure that the domOperation and options are
                                // handled accordingly
                                if (animationCancelled) {
                                    applyAnimationClasses(element, options);
                                    applyAnimationStyles(element, options);
                                }
                                // if the event changed from something like enter to leave then we do
                                // it, otherwise if it's the same then the end result will be the same too
                                if (animationCancelled || isStructural && animationDetails.event !== event) {
                                    options.domOperation();
                                    runner.end();
                                }
                                // in the event that the element animation was not cancelled or a follow-up animation
                                // isn't allowed to animate from here then we need to clear the state of the element
                                // so that any future animations won't read the expired animation data.
                                if (!isValidAnimation) clearElementAnimationState(node);
                                return;
                            }
                            // this combined multiple class to addClass / removeClass into a setClass event
                            // so long as a structural event did not take over the animation
                            event = !animationDetails.structural && hasAnimationClasses(animationDetails, true) ? "setClass" : animationDetails.event;
                            markElementAnimationState(node, RUNNING_STATE);
                            var realRunner = $$animation(element, event, animationDetails.options);
                            // this will update the runner's flow-control events based on
                            // the `realRunner` object.
                            runner.setHost(realRunner);
                            notifyProgress(runner, event, "start", getEventData(options));
                            realRunner.done(function(status) {
                                close(!status);
                                var animationDetails = activeAnimationsLookup.get(node);
                                if (animationDetails && animationDetails.counter === counter) clearElementAnimationState(node);
                                notifyProgress(runner, event, "close", getEventData(options));
                            });
                        });
                        return runner;
                        function notifyProgress(runner, event, phase, data) {
                            runInNextPostDigestOrNow(function() {
                                var callbacks = findCallbacks(parentNode, node, event);
                                if (callbacks.length) // do not optimize this call here to RAF because
                                // we don't know how heavy the callback code here will
                                // be and if this code is buffered then this can
                                // lead to a performance regression.
                                $$rAF(function() {
                                    forEach(callbacks, function(callback) {
                                        callback(element, phase, data);
                                    });
                                    cleanupEventListeners(phase, node);
                                });
                                else cleanupEventListeners(phase, node);
                            });
                            runner.progress(event, phase, data);
                        }
                        function close(reject) {
                            clearGeneratedClasses(element, options);
                            applyAnimationClasses(element, options);
                            applyAnimationStyles(element, options);
                            options.domOperation();
                            runner.complete(!reject);
                        }
                    }
                    function closeChildAnimations(node) {
                        var children = node.querySelectorAll("[" + NG_ANIMATE_ATTR_NAME + "]");
                        forEach(children, function(child) {
                            var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
                            var animationDetails = activeAnimationsLookup.get(child);
                            if (animationDetails) switch(state){
                                case RUNNING_STATE:
                                    animationDetails.runner.end();
                                /* falls through */ case PRE_DIGEST_STATE:
                                    activeAnimationsLookup.delete(child);
                                    break;
                            }
                        });
                    }
                    function clearElementAnimationState(node) {
                        node.removeAttribute(NG_ANIMATE_ATTR_NAME);
                        activeAnimationsLookup.delete(node);
                    }
                    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */ function areAnimationsAllowed(node, parentNode, event) {
                        var bodyNode = $document[0].body;
                        var rootNode = getDomNode($rootElement);
                        var bodyNodeDetected = node === bodyNode || node.nodeName === "HTML";
                        var rootNodeDetected = node === rootNode;
                        var parentAnimationDetected = false;
                        var elementDisabled = disabledElementsLookup.get(node);
                        var animateChildren;
                        var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
                        if (parentHost) parentNode = getDomNode(parentHost);
                        while(parentNode){
                            if (!rootNodeDetected) // AngularJS doesn't want to attempt to animate elements outside of the application
                            // therefore we need to ensure that the rootElement is an ancestor of the current element
                            rootNodeDetected = parentNode === rootNode;
                            if (parentNode.nodeType !== ELEMENT_NODE) break;
                            var details = activeAnimationsLookup.get(parentNode) || {};
                            // either an enter, leave or move animation will commence
                            // therefore we can't allow any animations to take place
                            // but if a parent animation is class-based then that's ok
                            if (!parentAnimationDetected) {
                                var parentNodeDisabled = disabledElementsLookup.get(parentNode);
                                if (parentNodeDisabled === true && elementDisabled !== false) {
                                    // disable animations if the user hasn't explicitly enabled animations on the
                                    // current element
                                    elementDisabled = true;
                                    break;
                                } else if (parentNodeDisabled === false) elementDisabled = false;
                                parentAnimationDetected = details.structural;
                            }
                            if (isUndefined(animateChildren) || animateChildren === true) {
                                var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
                                if (isDefined(value)) animateChildren = value;
                            }
                            // there is no need to continue traversing at this point
                            if (parentAnimationDetected && animateChildren === false) break;
                            if (!bodyNodeDetected) // we also need to ensure that the element is or will be a part of the body element
                            // otherwise it is pointless to even issue an animation to be rendered
                            bodyNodeDetected = parentNode === bodyNode;
                            if (bodyNodeDetected && rootNodeDetected) break;
                            if (!rootNodeDetected) {
                                // If `rootNode` is not detected, check if `parentNode` is pinned to another element
                                parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
                                if (parentHost) {
                                    // The pin target element becomes the next parent element
                                    parentNode = getDomNode(parentHost);
                                    continue;
                                }
                            }
                            parentNode = parentNode.parentNode;
                        }
                        var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
                        return allowAnimation && rootNodeDetected && bodyNodeDetected;
                    }
                    function markElementAnimationState(node, state, details) {
                        details = details || {};
                        details.state = state;
                        node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
                        var oldValue = activeAnimationsLookup.get(node);
                        var newValue = oldValue ? extend(oldValue, details) : details;
                        activeAnimationsLookup.set(node, newValue);
                    }
                }
            ];
        }
    ];
    /** @this */ var $$AnimateCacheProvider = function() {
        var KEY = "$$ngAnimateParentKey";
        var parentCounter = 0;
        var cache = Object.create(null);
        this.$get = [
            function() {
                return {
                    cacheKey: function(node, method, addClass, removeClass) {
                        var parentNode = node.parentNode;
                        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
                        var parts = [
                            parentID,
                            method,
                            node.getAttribute("class")
                        ];
                        if (addClass) parts.push(addClass);
                        if (removeClass) parts.push(removeClass);
                        return parts.join(" ");
                    },
                    containsCachedAnimationWithoutDuration: function(key) {
                        var entry = cache[key];
                        // nothing cached, so go ahead and animate
                        // otherwise it should be a valid animation
                        return entry && !entry.isValid || false;
                    },
                    flush: function() {
                        cache = Object.create(null);
                    },
                    count: function(key) {
                        var entry = cache[key];
                        return entry ? entry.total : 0;
                    },
                    get: function(key) {
                        var entry = cache[key];
                        return entry && entry.value;
                    },
                    put: function(key, value, isValid) {
                        if (!cache[key]) cache[key] = {
                            total: 1,
                            value: value,
                            isValid: isValid
                        };
                        else {
                            cache[key].total++;
                            cache[key].value = value;
                        }
                    }
                };
            }
        ];
    };
    /* exported $$AnimationProvider */ var $$AnimationProvider = [
        "$animateProvider",
        /** @this */ function($animateProvider) {
            var NG_ANIMATE_REF_ATTR = "ng-animate-ref";
            var drivers = this.drivers = [];
            var RUNNER_STORAGE_KEY = "$$animationRunner";
            var PREPARE_CLASSES_KEY = "$$animatePrepareClasses";
            function setRunner(element, runner) {
                element.data(RUNNER_STORAGE_KEY, runner);
            }
            function removeRunner(element) {
                element.removeData(RUNNER_STORAGE_KEY);
            }
            function getRunner(element) {
                return element.data(RUNNER_STORAGE_KEY);
            }
            this.$get = [
                "$$jqLite",
                "$rootScope",
                "$injector",
                "$$AnimateRunner",
                "$$Map",
                "$$rAFScheduler",
                "$$animateCache",
                function($$jqLite, $rootScope, $injector, $$AnimateRunner, $$Map, $$rAFScheduler, $$animateCache) {
                    var animationQueue = [];
                    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
                    function sortAnimations(animations) {
                        var tree = {
                            children: []
                        };
                        var i, lookup = new $$Map();
                        // this is done first beforehand so that the map
                        // is filled with a list of the elements that will be animated
                        for(i = 0; i < animations.length; i++){
                            var animation = animations[i];
                            lookup.set(animation.domNode, animations[i] = {
                                domNode: animation.domNode,
                                element: animation.element,
                                fn: animation.fn,
                                children: []
                            });
                        }
                        for(i = 0; i < animations.length; i++)processNode(animations[i]);
                        return flatten(tree);
                        function processNode(entry) {
                            if (entry.processed) return entry;
                            entry.processed = true;
                            var elementNode = entry.domNode;
                            var parentNode = elementNode.parentNode;
                            lookup.set(elementNode, entry);
                            var parentEntry;
                            while(parentNode){
                                parentEntry = lookup.get(parentNode);
                                if (parentEntry) {
                                    if (!parentEntry.processed) parentEntry = processNode(parentEntry);
                                    break;
                                }
                                parentNode = parentNode.parentNode;
                            }
                            (parentEntry || tree).children.push(entry);
                            return entry;
                        }
                        function flatten(tree) {
                            var result = [];
                            var queue = [];
                            var i;
                            for(i = 0; i < tree.children.length; i++)queue.push(tree.children[i]);
                            var remainingLevelEntries = queue.length;
                            var nextLevelEntries = 0;
                            var row = [];
                            for(i = 0; i < queue.length; i++){
                                var entry = queue[i];
                                if (remainingLevelEntries <= 0) {
                                    remainingLevelEntries = nextLevelEntries;
                                    nextLevelEntries = 0;
                                    result.push(row);
                                    row = [];
                                }
                                row.push(entry);
                                entry.children.forEach(function(childEntry) {
                                    nextLevelEntries++;
                                    queue.push(childEntry);
                                });
                                remainingLevelEntries--;
                            }
                            if (row.length) result.push(row);
                            return result;
                        }
                    }
                    // TODO(matsko): document the signature in a better way
                    return function(element, event, options) {
                        options = prepareAnimationOptions(options);
                        var isStructural = [
                            "enter",
                            "move",
                            "leave"
                        ].indexOf(event) >= 0;
                        // there is no animation at the current moment, however
                        // these runner methods will get later updated with the
                        // methods leading into the driver's end/cancel methods
                        // for now they just stop the animation from starting
                        var runner = new $$AnimateRunner({
                            end: function() {
                                close();
                            },
                            cancel: function() {
                                close(true);
                            }
                        });
                        if (!drivers.length) {
                            close();
                            return runner;
                        }
                        var classes = mergeClasses(element.attr("class"), mergeClasses(options.addClass, options.removeClass));
                        var tempClasses = options.tempClasses;
                        if (tempClasses) {
                            classes += " " + tempClasses;
                            options.tempClasses = null;
                        }
                        if (isStructural) element.data(PREPARE_CLASSES_KEY, "ng-" + event + PREPARE_CLASS_SUFFIX);
                        setRunner(element, runner);
                        animationQueue.push({
                            // this data is used by the postDigest code and passed into
                            // the driver step function
                            element: element,
                            classes: classes,
                            event: event,
                            structural: isStructural,
                            options: options,
                            beforeStart: beforeStart,
                            close: close
                        });
                        element.on("$destroy", handleDestroyedElement);
                        // we only want there to be one function called within the post digest
                        // block. This way we can group animations for all the animations that
                        // were apart of the same postDigest flush call.
                        if (animationQueue.length > 1) return runner;
                        $rootScope.$$postDigest(function() {
                            var animations = [];
                            forEach(animationQueue, function(entry) {
                                // the element was destroyed early on which removed the runner
                                // form its storage. This means we can't animate this element
                                // at all and it already has been closed due to destruction.
                                if (getRunner(entry.element)) animations.push(entry);
                                else entry.close();
                            });
                            // now any future animations will be in another postDigest
                            animationQueue.length = 0;
                            var groupedAnimations = groupAnimations(animations);
                            var toBeSortedAnimations = [];
                            forEach(groupedAnimations, function(animationEntry) {
                                var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
                                var extraClasses = options.addClass;
                                extraClasses = (extraClasses ? extraClasses + " " : "") + NG_ANIMATE_CLASSNAME;
                                var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);
                                toBeSortedAnimations.push({
                                    element: element,
                                    domNode: getDomNode(element),
                                    fn: function triggerAnimationStart() {
                                        var startAnimationFn, closeFn = animationEntry.close;
                                        // in the event that we've cached the animation status for this element
                                        // and it's in fact an invalid animation (something that has duration = 0)
                                        // then we should skip all the heavy work from here on
                                        if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                                            closeFn();
                                            return;
                                        }
                                        // it's important that we apply the `ng-animate` CSS class and the
                                        // temporary classes before we do any driver invoking since these
                                        // CSS classes may be required for proper CSS detection.
                                        animationEntry.beforeStart();
                                        // in the event that the element was removed before the digest runs or
                                        // during the RAF sequencing then we should not trigger the animation.
                                        var targetElement = animationEntry.anchors ? animationEntry.from.element || animationEntry.to.element : animationEntry.element;
                                        if (getRunner(targetElement)) {
                                            var operation = invokeFirstDriver(animationEntry);
                                            if (operation) startAnimationFn = operation.start;
                                        }
                                        if (!startAnimationFn) closeFn();
                                        else {
                                            var animationRunner = startAnimationFn();
                                            animationRunner.done(function(status) {
                                                closeFn(!status);
                                            });
                                            updateAnimationRunners(animationEntry, animationRunner);
                                        }
                                    }
                                });
                            });
                            // we need to sort each of the animations in order of parent to child
                            // relationships. This ensures that the child classes are applied at the
                            // right time.
                            var finalAnimations = sortAnimations(toBeSortedAnimations);
                            for(var i = 0; i < finalAnimations.length; i++){
                                var innerArray = finalAnimations[i];
                                for(var j = 0; j < innerArray.length; j++){
                                    var entry = innerArray[j];
                                    var element = entry.element;
                                    // the RAFScheduler code only uses functions
                                    finalAnimations[i][j] = entry.fn;
                                    // the first row of elements shouldn't have a prepare-class added to them
                                    // since the elements are at the top of the animation hierarchy and they
                                    // will be applied without a RAF having to pass...
                                    if (i === 0) {
                                        element.removeData(PREPARE_CLASSES_KEY);
                                        continue;
                                    }
                                    var prepareClassName = element.data(PREPARE_CLASSES_KEY);
                                    if (prepareClassName) $$jqLite.addClass(element, prepareClassName);
                                }
                            }
                            $$rAFScheduler(finalAnimations);
                        });
                        return runner;
                        // TODO(matsko): change to reference nodes
                        function getAnchorNodes(node) {
                            var SELECTOR = "[" + NG_ANIMATE_REF_ATTR + "]";
                            var items = node.hasAttribute(NG_ANIMATE_REF_ATTR) ? [
                                node
                            ] : node.querySelectorAll(SELECTOR);
                            var anchors = [];
                            forEach(items, function(node) {
                                var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
                                if (attr && attr.length) anchors.push(node);
                            });
                            return anchors;
                        }
                        function groupAnimations(animations) {
                            var preparedAnimations = [];
                            var refLookup = {};
                            forEach(animations, function(animation, index) {
                                var element = animation.element;
                                var node = getDomNode(element);
                                var event = animation.event;
                                var enterOrMove = [
                                    "enter",
                                    "move"
                                ].indexOf(event) >= 0;
                                var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
                                if (anchorNodes.length) {
                                    var direction = enterOrMove ? "to" : "from";
                                    forEach(anchorNodes, function(anchor) {
                                        var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
                                        refLookup[key] = refLookup[key] || {};
                                        refLookup[key][direction] = {
                                            animationID: index,
                                            element: jqLite(anchor)
                                        };
                                    });
                                } else preparedAnimations.push(animation);
                            });
                            var usedIndicesLookup = {};
                            var anchorGroups = {};
                            forEach(refLookup, function(operations, key) {
                                var from = operations.from;
                                var to = operations.to;
                                if (!from || !to) {
                                    // only one of these is set therefore we can't have an
                                    // anchor animation since all three pieces are required
                                    var index = from ? from.animationID : to.animationID;
                                    var indexKey = index.toString();
                                    if (!usedIndicesLookup[indexKey]) {
                                        usedIndicesLookup[indexKey] = true;
                                        preparedAnimations.push(animations[index]);
                                    }
                                    return;
                                }
                                var fromAnimation = animations[from.animationID];
                                var toAnimation = animations[to.animationID];
                                var lookupKey = from.animationID.toString();
                                if (!anchorGroups[lookupKey]) {
                                    var group = anchorGroups[lookupKey] = {
                                        structural: true,
                                        beforeStart: function() {
                                            fromAnimation.beforeStart();
                                            toAnimation.beforeStart();
                                        },
                                        close: function() {
                                            fromAnimation.close();
                                            toAnimation.close();
                                        },
                                        classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
                                        from: fromAnimation,
                                        to: toAnimation,
                                        anchors: [] // TODO(matsko): change to reference nodes
                                    };
                                    // the anchor animations require that the from and to elements both have at least
                                    // one shared CSS class which effectively marries the two elements together to use
                                    // the same animation driver and to properly sequence the anchor animation.
                                    if (group.classes.length) preparedAnimations.push(group);
                                    else {
                                        preparedAnimations.push(fromAnimation);
                                        preparedAnimations.push(toAnimation);
                                    }
                                }
                                anchorGroups[lookupKey].anchors.push({
                                    "out": from.element,
                                    "in": to.element
                                });
                            });
                            return preparedAnimations;
                        }
                        function cssClassesIntersection(a, b) {
                            a = a.split(" ");
                            b = b.split(" ");
                            var matches = [];
                            for(var i = 0; i < a.length; i++){
                                var aa = a[i];
                                if (aa.substring(0, 3) === "ng-") continue;
                                for(var j = 0; j < b.length; j++)if (aa === b[j]) {
                                    matches.push(aa);
                                    break;
                                }
                            }
                            return matches.join(" ");
                        }
                        function invokeFirstDriver(animationDetails) {
                            // we loop in reverse order since the more general drivers (like CSS and JS)
                            // may attempt more elements, but custom drivers are more particular
                            for(var i = drivers.length - 1; i >= 0; i--){
                                var driverName = drivers[i];
                                var factory = $injector.get(driverName);
                                var driver = factory(animationDetails);
                                if (driver) return driver;
                            }
                        }
                        function beforeStart() {
                            tempClasses = (tempClasses ? tempClasses + " " : "") + NG_ANIMATE_CLASSNAME;
                            $$jqLite.addClass(element, tempClasses);
                            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
                            if (prepareClassName) {
                                $$jqLite.removeClass(element, prepareClassName);
                                prepareClassName = null;
                            }
                        }
                        function updateAnimationRunners(animation, newRunner) {
                            if (animation.from && animation.to) {
                                update(animation.from.element);
                                update(animation.to.element);
                            } else update(animation.element);
                            function update(element) {
                                var runner = getRunner(element);
                                if (runner) runner.setHost(newRunner);
                            }
                        }
                        function handleDestroyedElement() {
                            var runner = getRunner(element);
                            if (runner && (event !== "leave" || !options.$$domOperationFired)) runner.end();
                        }
                        function close(rejected) {
                            element.off("$destroy", handleDestroyedElement);
                            removeRunner(element);
                            applyAnimationClasses(element, options);
                            applyAnimationStyles(element, options);
                            options.domOperation();
                            if (tempClasses) $$jqLite.removeClass(element, tempClasses);
                            runner.complete(!rejected);
                        }
                    };
                }
            ];
        }
    ];
    /**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */ var ngAnimateSwapDirective = [
        "$animate",
        function($animate) {
            return {
                restrict: "A",
                transclude: "element",
                terminal: true,
                priority: 550,
                // but after `ngIf` (at priority 600).
                link: function(scope, $element, attrs, ctrl, $transclude) {
                    var previousElement, previousScope;
                    scope.$watchCollection(attrs.ngAnimateSwap || attrs["for"], function(value) {
                        if (previousElement) $animate.leave(previousElement);
                        if (previousScope) {
                            previousScope.$destroy();
                            previousScope = null;
                        }
                        if (value || value === 0) $transclude(function(clone, childScope) {
                            previousElement = clone;
                            previousScope = childScope;
                            $animate.enter(clone, null, $element);
                        });
                    });
                }
            };
        }
    ];
    /**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
 *
 * ## Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                     | Supported Animations                                                      |
 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
 *
 * (More information can be found by visiting the documentation associated with each directive.)
 *
 * For a full breakdown of the steps involved during each animation event, refer to the
 * {@link ng.$animate `$animate` API docs}.
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 * ```
 *
 * ### Animating between value changes
 *
 * Sometimes you need to animate between different expression states, whose values
 * don't necessary need to be known or referenced in CSS styles.
 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
 *
 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
 * creates a new instance of the element (including any other/child directives it may have) and
 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
 * (e.g. for performance reasons, or when you wish to retain internal state on the original
 * element instance).
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that AngularJS
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
 */ var copy;
    var extend;
    var forEach;
    var isArray;
    var isDefined;
    var isElement;
    var isFunction;
    var isObject;
    var isString;
    var isUndefined;
    var jqLite;
    var noop;
    /**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */ angular.module("ngAnimate", [], function initAngularHelpers() {
        // Access helpers from AngularJS core.
        // Do it inside a `config` block to ensure `window.angular` is available.
        noop = angular.noop;
        copy = angular.copy;
        extend = angular.extend;
        jqLite = angular.element;
        forEach = angular.forEach;
        isArray = angular.isArray;
        isString = angular.isString;
        isObject = angular.isObject;
        isUndefined = angular.isUndefined;
        isDefined = angular.isDefined;
        isFunction = angular.isFunction;
        isElement = angular.isElement;
    }).info({
        angularVersion: "1.8.3"
    }).directive("ngAnimateSwap", ngAnimateSwapDirective).directive("ngAnimateChildren", $$AnimateChildrenDirective).factory("$$rAFScheduler", $$rAFSchedulerFactory).provider("$$animateQueue", $$AnimateQueueProvider).provider("$$animateCache", $$AnimateCacheProvider).provider("$$animation", $$AnimationProvider).provider("$animateCss", $AnimateCssProvider).provider("$$animateCssDriver", $$AnimateCssDriverProvider).provider("$$animateJs", $$AnimateJsProvider).provider("$$animateJsDriver", $$AnimateJsDriverProvider);
})(window, window.angular);


$65e0832449835e89$exports = "ngAnimate";


var $079c7b0c662415b3$exports = {};
parcelRequire("jTg1q");
parcelRequire("a4E6K");
$079c7b0c662415b3$exports = "duScroll";


(function(t) {
    "use strict";
    t.module("scrollSpyModule", []).directive("scrollSpy", [
        "$window",
        "$rootScope",
        "",
        function(e, n, r) {
            return {
                restrict: "A",
                link: function(r, i, a) {
                    var o = a.id + "-scrollSpy";
                    n[o] = new function() {
                        var t, r, i, o = this, s = !1, u = !1, l = !1, c = !1, f = document.documentElement, h = a.id || "unknown element", p = document.getElementById(h), d = !1;
                        this.determinePosition = function() {
                            if (s) {
                                var e = window.pageYOffset || f.scrollTop;
                                c || (e + t < i || e > i + r) && (c = !0, l = !1, n.$broadcast("elementScrolledOutOfView", h)), (e + t >= i + 1 * r && i > e || e >= i && d) && (u || (u = !0, n.$broadcast("elementFirstScrolledIntoView", h)), l || (l = !0, c = !1, n.$broadcast("elementScrolledIntoView", h)));
                            }
                        }, this.takeMeasurements = function() {
                            t = e.innerHeight, r = p.offsetHeight, i = p.offsetTop, t < r && (d = !0), s = !0, o.determinePosition();
                        };
                        var $ = setInterval(function() {
                            p.offsetHeight > 2 && (clearTimeout($), o.takeMeasurements());
                        }, 50);
                    }(), n.globalOnScrollFunctions || (n.globalOnScrollFunctions = []), n.globalOnScrollFunctions.push(n[o]), n.globalOnScroll || (n.globalOnScroll = function() {
                        t.forEach(n.globalOnScrollFunctions, function(t, e) {
                            t.determinePosition();
                        });
                    }, e.onscroll = n.globalOnScroll);
                }
            };
        }
    ]);
})(angular);


var $db006115d5fdcbb3$exports = {};
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1, angular) {
    "use strict";
    var forEach;
    var isArray;
    var isString;
    var jqLite;
    /**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
 *
 * ## Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritize messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, AngularJS may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
 * more about ngAnimate.
 *
 * ## Displaying a default message
 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
 * keys are matched by a defined message), then it will render a default message
 * using the {@link ngMessageDefault} directive.
 * Note that matched messages will always take precedence over unmatched messages. That means
 * the default message will not be displayed when another message is matched. This is also
 * true for `ng-messages-multiple`.
 *
 * ```html
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 *   <div ng-message-default>This field has an input error</div>
 * </div>
 * ```
 *

 */ angular.module("ngMessages", [], function initAngularHelpers() {
        // Access helpers from AngularJS core.
        // Do it inside a `config` block to ensure `window.angular` is available.
        forEach = angular.forEach;
        isArray = angular.isArray;
        isString = angular.isString;
        jqLite = angular.element;
    }).info({
        angularVersion: "1.8.3"
    })/**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
   * reusability and messages can also be overridden.
   *
   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
   * {@link ngMessageDefault} directive.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *         <div ng-message-default>This field has an input error</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */ .directive("ngMessages", [
        "$animate",
        function($animate) {
            var ACTIVE_CLASS = "ng-active";
            var INACTIVE_CLASS = "ng-inactive";
            return {
                require: "ngMessages",
                restrict: "AE",
                controller: [
                    "$element",
                    "$scope",
                    "$attrs",
                    function NgMessagesCtrl($element, $scope, $attrs) {
                        var ctrl = this;
                        var latestKey = 0;
                        var nextAttachId = 0;
                        this.getAttachId = function getAttachId() {
                            return nextAttachId++;
                        };
                        var messages = this.messages = {};
                        var renderLater, cachedCollection;
                        this.render = function(collection) {
                            collection = collection || {};
                            renderLater = false;
                            cachedCollection = collection;
                            // this is true if the attribute is empty or if the attribute value is truthy
                            var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) || isAttrTruthy($scope, $attrs.multiple);
                            var unmatchedMessages = [];
                            var matchedKeys = {};
                            var truthyKeys = 0;
                            var messageItem = ctrl.head;
                            var messageFound = false;
                            var totalMessages = 0;
                            // we use != instead of !== to allow for both undefined and null values
                            while(messageItem != null){
                                totalMessages++;
                                var messageCtrl = messageItem.message;
                                var messageUsed = false;
                                if (!messageFound) forEach(collection, function(value, key) {
                                    if (truthy(value) && !messageUsed) {
                                        truthyKeys++;
                                        if (messageCtrl.test(key)) {
                                            // this is to prevent the same error name from showing up twice
                                            if (matchedKeys[key]) return;
                                            matchedKeys[key] = true;
                                            messageUsed = true;
                                            messageCtrl.attach();
                                        }
                                    }
                                });
                                if (messageUsed) // unless we want to display multiple messages then we should
                                // set a flag here to avoid displaying the next message in the list
                                messageFound = !multiple;
                                else unmatchedMessages.push(messageCtrl);
                                messageItem = messageItem.next;
                            }
                            forEach(unmatchedMessages, function(messageCtrl) {
                                messageCtrl.detach();
                            });
                            var messageMatched = unmatchedMessages.length !== totalMessages;
                            var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;
                            if (attachDefault) ctrl.default.attach();
                            else if (ctrl.default) ctrl.default.detach();
                            if (messageMatched || attachDefault) $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
                            else $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
                        };
                        $scope.$watchCollection($attrs.ngMessages || $attrs["for"], ctrl.render);
                        this.reRender = function() {
                            if (!renderLater) {
                                renderLater = true;
                                $scope.$evalAsync(function() {
                                    if (renderLater && cachedCollection) ctrl.render(cachedCollection);
                                });
                            }
                        };
                        this.register = function(comment, messageCtrl, isDefault) {
                            if (isDefault) ctrl.default = messageCtrl;
                            else {
                                var nextKey = latestKey.toString();
                                messages[nextKey] = {
                                    message: messageCtrl
                                };
                                insertMessageNode($element[0], comment, nextKey);
                                comment.$$ngMessageNode = nextKey;
                                latestKey++;
                            }
                            ctrl.reRender();
                        };
                        this.deregister = function(comment, isDefault) {
                            if (isDefault) delete ctrl.default;
                            else {
                                var key = comment.$$ngMessageNode;
                                delete comment.$$ngMessageNode;
                                removeMessageNode($element[0], comment, key);
                                delete messages[key];
                            }
                            ctrl.reRender();
                        };
                        function findPreviousMessage(parent, comment) {
                            var prevNode = comment;
                            var parentLookup = [];
                            while(prevNode && prevNode !== parent){
                                var prevKey = prevNode.$$ngMessageNode;
                                if (prevKey && prevKey.length) return messages[prevKey];
                                // dive deeper into the DOM and examine its children for any ngMessage
                                // comments that may be in an element that appears deeper in the list
                                if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
                                    parentLookup.push(prevNode);
                                    prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
                                } else if (prevNode.previousSibling) prevNode = prevNode.previousSibling;
                                else {
                                    prevNode = prevNode.parentNode;
                                    parentLookup.push(prevNode);
                                }
                            }
                        }
                        function insertMessageNode(parent, comment, key) {
                            var messageNode = messages[key];
                            if (!ctrl.head) ctrl.head = messageNode;
                            else {
                                var match = findPreviousMessage(parent, comment);
                                if (match) {
                                    messageNode.next = match.next;
                                    match.next = messageNode;
                                } else {
                                    messageNode.next = ctrl.head;
                                    ctrl.head = messageNode;
                                }
                            }
                        }
                        function removeMessageNode(parent, comment, key) {
                            var messageNode = messages[key];
                            // This message node may have already been removed by a call to deregister()
                            if (!messageNode) return;
                            var match = findPreviousMessage(parent, comment);
                            if (match) match.next = messageNode.next;
                            else ctrl.head = messageNode.next;
                        }
                    }
                ]
            };
            function isAttrTruthy(scope, attr) {
                return isString(attr) && attr.length === 0 || //empty attribute
                truthy(scope.$eval(attr));
            }
            function truthy(val) {
                return isString(val) ? val.length : !!val;
            }
        }
    ])/**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */ .directive("ngMessagesInclude", [
        "$templateRequest",
        "$document",
        "$compile",
        function($templateRequest, $document, $compile) {
            return {
                restrict: "AE",
                require: "^^ngMessages",
                link: function($scope, element, attrs) {
                    var src = attrs.ngMessagesInclude || attrs.src;
                    $templateRequest(src).then(function(html) {
                        if ($scope.$$destroyed) return;
                        if (isString(html) && !html.trim()) // Empty template - nothing to compile
                        replaceElementWithMarker(element, src);
                        else // Non-empty template - compile and link
                        $compile(html)($scope, function(contents) {
                            element.after(contents);
                            replaceElementWithMarker(element, src);
                        });
                    });
                }
            };
            // Helpers
            function replaceElementWithMarker(element, src) {
                // A comment marker is placed for debugging purposes
                var comment = $compile.$$createComment ? $compile.$$createComment("ngMessagesInclude", src) : $document[0].createComment(" ngMessagesInclude: " + src + " ");
                var marker = jqLite(comment);
                element.after(marker);
                // Don't pollute the DOM anymore by keeping an empty directive element
                element.remove();
            }
        }
    ])/**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   * @priority 1
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */ .directive("ngMessage", ngMessageDirectiveFactory())/**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
   * value, it accepts an expression to be evaluated for the message key.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */ .directive("ngMessageExp", ngMessageDirectiveFactory())/**
   * @ngdoc directive
   * @name ngMessageDefault
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
   * {@link directive:ngMessages}, when none of provided messages matches.
   *
   * More information about using `ngMessageDefault` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   *
  */ .directive("ngMessageDefault", ngMessageDirectiveFactory(true));
    function ngMessageDirectiveFactory(isDefault) {
        return [
            "$animate",
            function($animate) {
                return {
                    restrict: "AE",
                    transclude: "element",
                    priority: 1,
                    terminal: true,
                    require: "^^ngMessages",
                    link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
                        var commentNode, records, staticExp, dynamicExp;
                        if (!isDefault) {
                            commentNode = element[0];
                            staticExp = attrs.ngMessage || attrs.when;
                            dynamicExp = attrs.ngMessageExp || attrs.whenExp;
                            var assignRecords = function(items) {
                                records = items ? isArray(items) ? items : items.split(/[\s,]+/) : null;
                                ngMessagesCtrl.reRender();
                            };
                            if (dynamicExp) {
                                assignRecords(scope.$eval(dynamicExp));
                                scope.$watchCollection(dynamicExp, assignRecords);
                            } else assignRecords(staticExp);
                        }
                        var currentElement, messageCtrl;
                        ngMessagesCtrl.register(commentNode, messageCtrl = {
                            test: function(name) {
                                return contains(records, name);
                            },
                            attach: function() {
                                if (!currentElement) $transclude(function(elm, newScope) {
                                    $animate.enter(elm, null, element);
                                    currentElement = elm;
                                    // Each time we attach this node to a message we get a new id that we can match
                                    // when we are destroying the node later.
                                    var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
                                    // in the event that the element or a parent element is destroyed
                                    // by another structural directive then it's time
                                    // to deregister the message from the controller
                                    currentElement.on("$destroy", function() {
                                        // If the message element was removed via a call to `detach` then `currentElement` will be null
                                        // So this handler only handles cases where something else removed the message element.
                                        if (currentElement && currentElement.$$attachId === $$attachId) {
                                            ngMessagesCtrl.deregister(commentNode, isDefault);
                                            messageCtrl.detach();
                                        }
                                        newScope.$destroy();
                                    });
                                });
                            },
                            detach: function() {
                                if (currentElement) {
                                    var elm = currentElement;
                                    currentElement = null;
                                    $animate.leave(elm);
                                }
                            }
                        }, isDefault);
                        // We need to ensure that this directive deregisters itself when it no longer exists
                        // Normally this is done when the attached element is destroyed; but if this directive
                        // gets removed before we attach the message to the DOM there is nothing to watch
                        // in which case we must deregister when the containing scope is destroyed.
                        scope.$on("$destroy", function() {
                            ngMessagesCtrl.deregister(commentNode, isDefault);
                        });
                    }
                };
            }
        ];
        function contains(collection, key) {
            if (collection) return isArray(collection) ? collection.indexOf(key) >= 0 : collection.hasOwnProperty(key);
        }
    }
})(window, window.angular);


$db006115d5fdcbb3$exports = "ngMessages";


var $614c5a4167641890$exports = {};
//https://github.com/angular/angular.js/pull/10732
parcelRequire("jTg1q");
/*!
 * angular-ui-mask
 * https://github.com/angular-ui/ui-mask
 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
 * License: MIT
 */ (function() {
    "use strict";
    /*
 Attaches input mask onto input element
 */ angular.module("ui.mask", []).value("uiMaskConfig", {
        maskDefinitions: {
            "9": /\d/,
            "A": /[a-zA-Z]/,
            "*": /[a-zA-Z0-9]/
        },
        clearOnBlur: true,
        clearOnBlurPlaceholder: false,
        escChar: "\\",
        eventsToHandle: [
            "input",
            "keyup",
            "click",
            "focus"
        ],
        addDefaultPlaceholder: true,
        allowInvalidValue: false
    }).provider("uiMask.Config", function() {
        var options = {};
        this.maskDefinitions = function(maskDefinitions) {
            return options.maskDefinitions = maskDefinitions;
        };
        this.clearOnBlur = function(clearOnBlur) {
            return options.clearOnBlur = clearOnBlur;
        };
        this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
            return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
        };
        this.eventsToHandle = function(eventsToHandle) {
            return options.eventsToHandle = eventsToHandle;
        };
        this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
            return options.addDefaultPlaceholder = addDefaultPlaceholder;
        };
        this.allowInvalidValue = function(allowInvalidValue) {
            return options.allowInvalidValue = allowInvalidValue;
        };
        this.$get = [
            "uiMaskConfig",
            function(uiMaskConfig) {
                var tempOptions = uiMaskConfig;
                for(var prop in options)if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) angular.extend(tempOptions[prop], options[prop]);
                else tempOptions[prop] = options[prop];
                return tempOptions;
            }
        ];
    }).directive("uiMask", [
        "uiMask.Config",
        function(maskConfig) {
            function isFocused(elem) {
                return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
            }
            return {
                priority: 100,
                require: "ngModel",
                restrict: "A",
                compile: function uiMaskCompilingFunction() {
                    var options = angular.copy(maskConfig);
                    return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
                        var maskProcessed = false, eventsBound = false, maskCaretMap, maskPatterns, maskPlaceholder, maskComponents, // Minimum required length of the value to be considered valid
                        minRequiredLength, value, valueMasked, isValid, // Vars for initializing/uninitializing
                        originalPlaceholder = iAttrs.placeholder, originalMaxlength = iAttrs.maxlength, // Vars used exclusively in eventHandler()
                        oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength, // Used for communicating if a backspace operation should be allowed between
                        // keydownHandler and eventHandler
                        preventBackspace;
                        var originalIsEmpty = controller.$isEmpty;
                        controller.$isEmpty = function(value) {
                            if (maskProcessed) return originalIsEmpty(unmaskValue(value || ""));
                            else return originalIsEmpty(value);
                        };
                        function initialize(maskAttr) {
                            if (!angular.isDefined(maskAttr)) return uninitialize();
                            processRawMask(maskAttr);
                            if (!maskProcessed) return uninitialize();
                            initializeElement();
                            bindEventListeners();
                            return true;
                        }
                        function initPlaceholder(placeholderAttr) {
                            if (!placeholderAttr) return;
                            maskPlaceholder = placeholderAttr;
                            // If the mask is processed, then we need to update the value
                            // but don't set the value if there is nothing entered into the element
                            // and there is a placeholder attribute on the element because that
                            // will only set the value as the blank maskPlaceholder
                            // and override the placeholder on the element
                            if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) iElement.val(maskValue(unmaskValue(iElement.val())));
                        }
                        function initPlaceholderChar() {
                            return initialize(iAttrs.uiMask);
                        }
                        var modelViewValue = false;
                        iAttrs.$observe("modelViewValue", function(val) {
                            if (val === "true") modelViewValue = true;
                        });
                        iAttrs.$observe("allowInvalidValue", function(val) {
                            linkOptions.allowInvalidValue = val === "" ? true : !!val;
                            formatter(controller.$modelValue);
                        });
                        function formatter(fromModelValue) {
                            if (!maskProcessed) return fromModelValue;
                            value = unmaskValue(fromModelValue || "");
                            isValid = validateValue(value);
                            controller.$setValidity("mask", isValid);
                            if (!value.length) return undefined;
                            if (isValid || linkOptions.allowInvalidValue) return maskValue(value);
                            else return undefined;
                        }
                        function parser(fromViewValue) {
                            if (!maskProcessed) return fromViewValue;
                            value = unmaskValue(fromViewValue || "");
                            isValid = validateValue(value);
                            // We have to set viewValue manually as the reformatting of the input
                            // value performed by eventHandler() doesn't happen until after
                            // this parser is called, which causes what the user sees in the input
                            // to be out-of-sync with what the controller's $viewValue is set to.
                            controller.$viewValue = value.length ? maskValue(value) : "";
                            controller.$setValidity("mask", isValid);
                            if (isValid || linkOptions.allowInvalidValue) return modelViewValue ? controller.$viewValue : value;
                        }
                        var linkOptions = {};
                        if (iAttrs.uiOptions) {
                            linkOptions = scope.$eval("[" + iAttrs.uiOptions + "]");
                            if (angular.isObject(linkOptions[0])) // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
                            linkOptions = function(original, current) {
                                for(var i in original)if (Object.prototype.hasOwnProperty.call(original, i)) {
                                    if (current[i] === undefined) current[i] = angular.copy(original[i]);
                                    else if (angular.isObject(current[i]) && !angular.isArray(current[i])) current[i] = angular.extend({}, original[i], current[i]);
                                }
                                return current;
                            }(options, linkOptions[0]);
                            else linkOptions = options; //gotta be a better way to do this..
                        } else linkOptions = options;
                        iAttrs.$observe("uiMask", initialize);
                        if (angular.isDefined(iAttrs.uiMaskPlaceholder)) iAttrs.$observe("uiMaskPlaceholder", initPlaceholder);
                        else iAttrs.$observe("placeholder", initPlaceholder);
                        if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) iAttrs.$observe("uiMaskPlaceholderChar", initPlaceholderChar);
                        controller.$formatters.unshift(formatter);
                        controller.$parsers.unshift(parser);
                        function uninitialize() {
                            maskProcessed = false;
                            unbindEventListeners();
                            if (angular.isDefined(originalPlaceholder)) iElement.attr("placeholder", originalPlaceholder);
                            else iElement.removeAttr("placeholder");
                            if (angular.isDefined(originalMaxlength)) iElement.attr("maxlength", originalMaxlength);
                            else iElement.removeAttr("maxlength");
                            iElement.val(controller.$modelValue);
                            controller.$viewValue = controller.$modelValue;
                            return false;
                        }
                        function initializeElement() {
                            value = oldValueUnmasked = unmaskValue(controller.$modelValue || "");
                            valueMasked = oldValue = maskValue(value);
                            isValid = validateValue(value);
                            if (iAttrs.maxlength) iElement.attr("maxlength", maskCaretMap[maskCaretMap.length - 1] * 2);
                            if (!originalPlaceholder && linkOptions.addDefaultPlaceholder) iElement.attr("placeholder", maskPlaceholder);
                            var viewValue = controller.$modelValue;
                            var idx = controller.$formatters.length;
                            while(idx--)viewValue = controller.$formatters[idx](viewValue);
                            controller.$viewValue = viewValue || "";
                            controller.$render();
                        // Not using $setViewValue so we don't clobber the model value and dirty the form
                        // without any kind of user interaction.
                        }
                        function bindEventListeners() {
                            if (eventsBound) return;
                            iElement.bind("blur", blurHandler);
                            iElement.bind("mousedown mouseup", mouseDownUpHandler);
                            iElement.bind("keydown", keydownHandler);
                            iElement.bind(linkOptions.eventsToHandle.join(" "), eventHandler);
                            eventsBound = true;
                        }
                        function unbindEventListeners() {
                            if (!eventsBound) return;
                            iElement.unbind("blur", blurHandler);
                            iElement.unbind("mousedown", mouseDownUpHandler);
                            iElement.unbind("mouseup", mouseDownUpHandler);
                            iElement.unbind("keydown", keydownHandler);
                            iElement.unbind("input", eventHandler);
                            iElement.unbind("keyup", eventHandler);
                            iElement.unbind("click", eventHandler);
                            iElement.unbind("focus", eventHandler);
                            eventsBound = false;
                        }
                        function validateValue(value) {
                            // Zero-length value validity is ngRequired's determination
                            return value.length ? value.length >= minRequiredLength : true;
                        }
                        function unmaskValue(value) {
                            var valueUnmasked = "", input = iElement[0], maskPatternsCopy = maskPatterns.slice(), selectionStart = oldCaretPosition, selectionEnd = selectionStart + getSelectionLength(input), valueOffset, valueDelta, tempValue = "";
                            // Preprocess by stripping mask components from value
                            value = value.toString();
                            valueOffset = 0;
                            valueDelta = value.length - maskPlaceholder.length;
                            angular.forEach(maskComponents, function(component) {
                                var position = component.position;
                                //Only try and replace the component if the component position is not within the selected range
                                //If component was in selected range then it was removed with the user input so no need to try and remove that component
                                if (!(position >= selectionStart && position < selectionEnd)) {
                                    if (position >= selectionStart) position += valueDelta;
                                    if (value.substring(position, position + component.value.length) === component.value) {
                                        tempValue += value.slice(valueOffset, position); // + value.slice(position + component.value.length);
                                        valueOffset = position + component.value.length;
                                    }
                                }
                            });
                            value = tempValue + value.slice(valueOffset);
                            angular.forEach(value.split(""), function(chr) {
                                if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
                                    valueUnmasked += chr;
                                    maskPatternsCopy.shift();
                                }
                            });
                            return valueUnmasked;
                        }
                        function maskValue(unmaskedValue) {
                            var valueMasked = "", maskCaretMapCopy = maskCaretMap.slice();
                            angular.forEach(maskPlaceholder.split(""), function(chr, i) {
                                if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
                                    valueMasked += unmaskedValue.charAt(0) || "_";
                                    unmaskedValue = unmaskedValue.substr(1);
                                    maskCaretMapCopy.shift();
                                } else valueMasked += chr;
                            });
                            return valueMasked;
                        }
                        function getPlaceholderChar(i) {
                            var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder, defaultPlaceholderChar;
                            if (angular.isDefined(placeholder) && placeholder[i]) return placeholder[i];
                            else {
                                defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : "_";
                                return defaultPlaceholderChar.toLowerCase() === "space" ? " " : defaultPlaceholderChar[0];
                            }
                        }
                        // Generate array of mask components that will be stripped from a masked value
                        // before processing to prevent mask components from being added to the unmasked value.
                        // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
                        function getMaskComponents() {
                            var maskPlaceholderChars = maskPlaceholder.split(""), maskPlaceholderCopy, components;
                            //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
                            if (maskCaretMap && !isNaN(maskCaretMap[0])) //Instead of trying to manipulate the RegEx based on the placeholder characters
                            //we can simply replace the placeholder characters based on the already built
                            //maskCaretMap to underscores and leave the original working RegEx to get the proper
                            //mask components
                            angular.forEach(maskCaretMap, function(value) {
                                maskPlaceholderChars[value] = "_";
                            });
                            maskPlaceholderCopy = maskPlaceholderChars.join("");
                            components = maskPlaceholderCopy.replace(/[_]+/g, "_").split("_");
                            components = components.filter(function(s) {
                                return s !== "";
                            });
                            // need a string search offset in cases where the mask contains multiple identical components
                            // E.g., a mask of 99.99.99-999.99
                            var offset = 0;
                            return components.map(function(c) {
                                var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
                                offset = componentPosition + 1;
                                return {
                                    value: c,
                                    position: componentPosition
                                };
                            });
                        }
                        function processRawMask(mask) {
                            var characterCount = 0;
                            maskCaretMap = [];
                            maskPatterns = [];
                            maskPlaceholder = "";
                            if (angular.isString(mask)) {
                                minRequiredLength = 0;
                                var isOptional = false, numberOfOptionalCharacters = 0, splitMask = mask.split("");
                                var inEscape = false;
                                angular.forEach(splitMask, function(chr, i) {
                                    if (inEscape) {
                                        inEscape = false;
                                        maskPlaceholder += chr;
                                        characterCount++;
                                    } else if (linkOptions.escChar === chr) inEscape = true;
                                    else if (linkOptions.maskDefinitions[chr]) {
                                        maskCaretMap.push(characterCount);
                                        maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
                                        maskPatterns.push(linkOptions.maskDefinitions[chr]);
                                        characterCount++;
                                        if (!isOptional) minRequiredLength++;
                                        isOptional = false;
                                    } else if (chr === "?") {
                                        isOptional = true;
                                        numberOfOptionalCharacters++;
                                    } else {
                                        maskPlaceholder += chr;
                                        characterCount++;
                                    }
                                });
                            }
                            // Caret position immediately following last position is valid.
                            maskCaretMap.push(maskCaretMap.slice().pop() + 1);
                            maskComponents = getMaskComponents();
                            maskProcessed = maskCaretMap.length > 1 ? true : false;
                        }
                        var prevValue = iElement.val();
                        function blurHandler() {
                            if (linkOptions.clearOnBlur || linkOptions.clearOnBlurPlaceholder && value.length === 0 && iAttrs.placeholder) {
                                oldCaretPosition = 0;
                                oldSelectionLength = 0;
                                if (!isValid || value.length === 0) {
                                    valueMasked = "";
                                    iElement.val("");
                                    scope.$apply(function() {
                                        //only $setViewValue when not $pristine to avoid changing $pristine state.
                                        if (!controller.$pristine) controller.$setViewValue("");
                                    });
                                }
                            }
                            //Check for different value and trigger change.
                            //Check for different value and trigger change.
                            if (value !== prevValue) {
                                // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
                                // and then blurring out.
                                // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
                                // when it should be empty
                                var currentVal = iElement.val();
                                var isTemporarilyEmpty = value === "" && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === "space";
                                if (isTemporarilyEmpty) iElement.val("");
                                triggerChangeEvent(iElement[0]);
                                if (isTemporarilyEmpty) iElement.val(currentVal);
                            }
                            prevValue = value;
                        }
                        function triggerChangeEvent(element) {
                            var change;
                            if (angular.isFunction(window.Event) && !element.fireEvent) {
                                // modern browsers and Edge
                                change = new Event("change", {
                                    view: window,
                                    bubbles: true,
                                    cancelable: false
                                });
                                element.dispatchEvent(change);
                            } else if ("createEvent" in document) {
                                // older browsers
                                change = document.createEvent("HTMLEvents");
                                change.initEvent("change", false, true);
                                element.dispatchEvent(change);
                            } else if (element.fireEvent) // IE <= 11
                            element.fireEvent("onchange");
                        }
                        function mouseDownUpHandler(e) {
                            if (e.type === "mousedown") iElement.bind("mouseout", mouseoutHandler);
                            else iElement.unbind("mouseout", mouseoutHandler);
                        }
                        iElement.bind("mousedown mouseup", mouseDownUpHandler);
                        function mouseoutHandler() {
                            /*jshint validthis: true */ oldSelectionLength = getSelectionLength(this);
                            iElement.unbind("mouseout", mouseoutHandler);
                        }
                        function keydownHandler(e) {
                            /*jshint validthis: true */ var isKeyBackspace = e.which === 8, caretPos = getCaretPosition(this) - 1 || 0, isCtrlZ = e.which === 90 && e.ctrlKey; //ctrl+z pressed
                            if (isKeyBackspace) {
                                while(caretPos >= 0){
                                    if (isValidCaretPosition(caretPos)) {
                                        //re-adjust the caret position.
                                        //Increment to account for the initial decrement to simulate post change caret position
                                        setCaretPosition(this, caretPos + 1);
                                        break;
                                    }
                                    caretPos--;
                                }
                                preventBackspace = caretPos === -1;
                            }
                            if (isCtrlZ) {
                                // prevent IE bug - value should be returned to initial state
                                iElement.val("");
                                e.preventDefault();
                            }
                        }
                        function eventHandler(e) {
                            /*jshint validthis: true */ e = e || {};
                            // Allows more efficient minification
                            var eventWhich = e.which, eventType = e.type;
                            // Prevent shift and ctrl from mucking with old values
                            if (eventWhich === 16 || eventWhich === 91) return;
                            var val = iElement.val(), valOld = oldValue, valMasked, valAltered = false, valUnmasked = unmaskValue(val), valUnmaskedOld = oldValueUnmasked, caretPos = getCaretPosition(this) || 0, caretPosOld = oldCaretPosition || 0, caretPosDelta = caretPos - caretPosOld, caretPosMin = maskCaretMap[0], caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(), selectionLenOld = oldSelectionLength || 0, isSelected = getSelectionLength(this) > 0, wasSelected = selectionLenOld > 0, // Case: Typing a character to overwrite a selection
                            isAddition = val.length > valOld.length || selectionLenOld && val.length > valOld.length - selectionLenOld, // Case: Delete and backspace behave identically on a selection
                            isDeletion = val.length < valOld.length || selectionLenOld && val.length === valOld.length - selectionLenOld, isSelection = eventWhich >= 37 && eventWhich <= 40 && e.shiftKey, isKeyLeftArrow = eventWhich === 37, // Necessary due to "input" event not providing a key code
                            isKeyBackspace = eventWhich === 8 || eventType !== "keyup" && isDeletion && caretPosDelta === -1, isKeyDelete = eventWhich === 46 || eventType !== "keyup" && isDeletion && caretPosDelta === 0 && !wasSelected, // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
                            // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
                            // non-mask character. Also applied to click since users are (arguably) more likely to backspace
                            // a character when clicking within a filled input.
                            caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === "click") && caretPos > caretPosMin;
                            oldSelectionLength = getSelectionLength(this);
                            // These events don't require any action
                            if (isSelection || isSelected && (eventType === "click" || eventType === "keyup" || eventType === "focus")) return;
                            if (isKeyBackspace && preventBackspace) {
                                iElement.val(maskPlaceholder);
                                // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
                                // This keeps the $viewValue updated and correct.
                                scope.$apply(function() {
                                    controller.$setViewValue(""); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
                                });
                                setCaretPosition(this, caretPosOld);
                                return;
                            }
                            // Value Handling
                            // ==============
                            // User attempted to delete but raw value was unaffected--correct this grievous offense
                            if (eventType === "input" && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
                                while(isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos))caretPos--;
                                while(isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1)caretPos++;
                                var charIndex = maskCaretMap.indexOf(caretPos);
                                // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
                                valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
                                // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
                                if (valUnmasked !== valUnmaskedOld) valAltered = true;
                            }
                            // Update values
                            valMasked = maskValue(valUnmasked);
                            oldValue = valMasked;
                            oldValueUnmasked = valUnmasked;
                            //additional check to fix the problem where the viewValue is out of sync with the value of the element.
                            //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
                            if (!valAltered && val.length > valMasked.length) valAltered = true;
                            iElement.val(valMasked);
                            //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
                            //actually doing anything.  Meaning, things like pristine and touched will be set.
                            if (valAltered) scope.$apply(function() {
                                controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
                            });
                            // Caret Repositioning
                            // ===================
                            // Ensure that typing always places caret ahead of typed character in cases where the first char of
                            // the input is a mask char and the caret is placed at the 0 position.
                            if (isAddition && caretPos <= caretPosMin) caretPos = caretPosMin + 1;
                            if (caretBumpBack) caretPos--;
                            // Make sure caret is within min and max position limits
                            caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
                            // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
                            while(!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax)caretPos += caretBumpBack ? -1 : 1;
                            if (caretBumpBack && caretPos < caretPosMax || isAddition && !isValidCaretPosition(caretPosOld)) caretPos++;
                            oldCaretPosition = caretPos;
                            setCaretPosition(this, caretPos);
                        }
                        function isValidCaretPosition(pos) {
                            return maskCaretMap.indexOf(pos) > -1;
                        }
                        function getCaretPosition(input) {
                            if (!input) return 0;
                            if (input.selectionStart !== undefined) return input.selectionStart;
                            else if (document.selection) {
                                if (isFocused(iElement[0])) {
                                    // Curse you IE
                                    input.focus();
                                    var selection = document.selection.createRange();
                                    selection.moveStart("character", input.value ? -input.value.length : 0);
                                    return selection.text.length;
                                }
                            }
                            return 0;
                        }
                        function setCaretPosition(input, pos) {
                            if (!input) return 0;
                            if (input.offsetWidth === 0 || input.offsetHeight === 0) return; // Input's hidden
                            if (input.setSelectionRange) {
                                if (isFocused(iElement[0])) {
                                    input.focus();
                                    input.setSelectionRange(pos, pos);
                                }
                            } else if (input.createTextRange) {
                                // Curse you IE
                                var range = input.createTextRange();
                                range.collapse(true);
                                range.moveEnd("character", pos);
                                range.moveStart("character", pos);
                                range.select();
                            }
                        }
                        function getSelectionLength(input) {
                            if (!input) return 0;
                            if (input.selectionStart !== undefined) return input.selectionEnd - input.selectionStart;
                            if (window.getSelection) return window.getSelection().toString().length;
                            if (document.selection) return document.selection.createRange().text.length;
                            return 0;
                        }
                        // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
                        if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement /*, fromIndex */ ) {
                            if (this === null) throw new TypeError();
                            var t = Object(this);
                            var len = t.length >>> 0;
                            if (len === 0) return -1;
                            var n = 0;
                            if (arguments.length > 1) {
                                n = Number(arguments[1]);
                                if (n !== n) n = 0;
                                else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
                            }
                            if (n >= len) return -1;
                            var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
                            for(; k < len; k++){
                                if (k in t && t[k] === searchElement) return k;
                            }
                            return -1;
                        };
                    };
                }
            };
        }
    ]);
})();


$614c5a4167641890$exports = "ui.mask";


var $843539283adf9310$exports = {};
/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.10
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */ (function(angular1, window1) {
    "use strict";
    var regModules = [
        "ng",
        "oc.lazyLoad"
    ], regInvokes = {}, regConfigs = [], modulesToLoad = [], // modules to load from angular.module or other sources
    realModules = [], // real modules called from angular.module
    recordDeclarations = [], broadcast = angular1.noop, runBlocks = {}, justLoaded = [];
    var ocLazyLoad = angular1.module("oc.lazyLoad", [
        "ng"
    ]);
    ocLazyLoad.provider("$ocLazyLoad", [
        "$controllerProvider",
        "$provide",
        "$compileProvider",
        "$filterProvider",
        "$injector",
        "$animateProvider",
        function($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
            var modules = {}, providers = {
                $controllerProvider: $controllerProvider,
                $compileProvider: $compileProvider,
                $filterProvider: $filterProvider,
                $provide: $provide,
                $injector: $injector,
                $animateProvider: $animateProvider
            }, debug = false, events = false, moduleCache = [], modulePromises = {};
            moduleCache.push = function(value) {
                if (this.indexOf(value) === -1) Array.prototype.push.apply(this, arguments);
            };
            this.config = function(config) {
                // If we want to define modules configs
                if (angular1.isDefined(config.modules)) {
                    if (angular1.isArray(config.modules)) angular1.forEach(config.modules, function(moduleConfig) {
                        modules[moduleConfig.name] = moduleConfig;
                    });
                    else modules[config.modules.name] = config.modules;
                }
                if (angular1.isDefined(config.debug)) debug = config.debug;
                if (angular1.isDefined(config.events)) events = config.events;
            };
            /**
         * Get the list of existing registered modules
         * @param element
         */ this._init = function _init(element) {
                // this is probably useless now because we override angular.bootstrap
                if (modulesToLoad.length === 0) {
                    var elements = [
                        element
                    ], names = [
                        "ng:app",
                        "ng-app",
                        "x-ng-app",
                        "data-ng-app"
                    ], NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/, append = function append(elm) {
                        return elm && elements.push(elm);
                    };
                    angular1.forEach(names, function(name) {
                        names[name] = true;
                        append(document.getElementById(name));
                        name = name.replace(":", "\\:");
                        if (typeof element[0] !== "undefined" && element[0].querySelectorAll) {
                            angular1.forEach(element[0].querySelectorAll("." + name), append);
                            angular1.forEach(element[0].querySelectorAll("." + name + "\\:"), append);
                            angular1.forEach(element[0].querySelectorAll("[" + name + "]"), append);
                        }
                    });
                    angular1.forEach(elements, function(elm) {
                        if (modulesToLoad.length === 0) {
                            var className = " " + element.className + " ";
                            var match = NG_APP_CLASS_REGEXP.exec(className);
                            if (match) modulesToLoad.push((match[2] || "").replace(/\s+/g, ","));
                            else angular1.forEach(elm.attributes, function(attr) {
                                if (modulesToLoad.length === 0 && names[attr.name]) modulesToLoad.push(attr.value);
                            });
                        }
                    });
                }
                if (modulesToLoad.length === 0 && !((window1.jasmine || window1.mocha) && angular1.isDefined(angular1.mock))) console.error("No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.");
                var addReg = function addReg(moduleName) {
                    if (regModules.indexOf(moduleName) === -1) {
                        // register existing modules
                        regModules.push(moduleName);
                        var mainModule = angular1.module(moduleName);
                        // register existing components (directives, services, ...)
                        _invokeQueue(null, mainModule._invokeQueue, moduleName);
                        _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+
                        angular1.forEach(mainModule.requires, addReg);
                    }
                };
                angular1.forEach(modulesToLoad, function(moduleName) {
                    addReg(moduleName);
                });
                modulesToLoad = []; // reset for next bootstrap
                recordDeclarations.pop(); // wait for the next lazy load
            };
            /**
         * Like JSON.stringify but that doesn't throw on circular references
         * @param obj
         */ var stringify = function stringify(obj) {
                try {
                    return JSON.stringify(obj);
                } catch (e) {
                    var cache = [];
                    return JSON.stringify(obj, function(key, value) {
                        if (angular1.isObject(value) && value !== null) {
                            if (cache.indexOf(value) !== -1) // Circular reference found, discard key
                            return;
                            // Store value in our collection
                            cache.push(value);
                        }
                        return value;
                    });
                }
            };
            var hashCode = function hashCode(str) {
                var hash = 0, i, chr, len;
                if (str.length == 0) return hash;
                for(i = 0, len = str.length; i < len; i++){
                    chr = str.charCodeAt(i);
                    hash = (hash << 5) - hash + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return hash;
            };
            function _register(providers, registerModules, params) {
                if (registerModules) {
                    var k, moduleName, moduleFn, tempRunBlocks = [];
                    for(k = registerModules.length - 1; k >= 0; k--){
                        moduleName = registerModules[k];
                        if (!angular1.isString(moduleName)) moduleName = getModuleName(moduleName);
                        if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) continue;
                        // new if not registered
                        var newModule = regModules.indexOf(moduleName) === -1;
                        moduleFn = ngModuleFct(moduleName);
                        if (newModule) {
                            regModules.push(moduleName);
                            _register(providers, moduleFn.requires, params);
                        }
                        if (moduleFn._runBlocks.length > 0) {
                            // new run blocks detected! Replace the old ones (if existing)
                            runBlocks[moduleName] = [];
                            while(moduleFn._runBlocks.length > 0)runBlocks[moduleName].push(moduleFn._runBlocks.shift());
                        }
                        if (angular1.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
                        _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
                        _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
                        broadcast(newModule ? "ocLazyLoad.moduleLoaded" : "ocLazyLoad.moduleReloaded", moduleName);
                        registerModules.pop();
                        justLoaded.push(moduleName);
                    }
                    // execute the run blocks at the end
                    var instanceInjector = providers.getInstanceInjector();
                    angular1.forEach(tempRunBlocks, function(fn) {
                        instanceInjector.invoke(fn);
                    });
                }
            }
            function _registerInvokeList(args, moduleName) {
                var invokeList = args[2][0], type = args[1], newInvoke = false;
                if (angular1.isUndefined(regInvokes[moduleName])) regInvokes[moduleName] = {};
                if (angular1.isUndefined(regInvokes[moduleName][type])) regInvokes[moduleName][type] = {};
                var onInvoke = function onInvoke(invokeName, invoke) {
                    if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) regInvokes[moduleName][type][invokeName] = [];
                    if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
                        newInvoke = true;
                        regInvokes[moduleName][type][invokeName].push(invoke);
                        broadcast("ocLazyLoad.componentLoaded", [
                            moduleName,
                            type,
                            invokeName
                        ]);
                    }
                };
                function checkHashes(potentialNew, invokes) {
                    var isNew = true, newHash;
                    if (invokes.length) {
                        newHash = signature(potentialNew);
                        angular1.forEach(invokes, function(invoke) {
                            isNew = isNew && signature(invoke) !== newHash;
                        });
                    }
                    return isNew;
                }
                function signature(data) {
                    if (angular1.isArray(data)) // arrays are objects, we need to test for it first
                    return hashCode(data.toString());
                    else if (angular1.isObject(data)) // constants & values for example
                    return hashCode(stringify(data));
                    else {
                        if (angular1.isDefined(data) && data !== null) return hashCode(data.toString());
                        else // null & undefined constants
                        return data;
                    }
                }
                if (angular1.isString(invokeList)) onInvoke(invokeList, args[2][1]);
                else if (angular1.isObject(invokeList)) angular1.forEach(invokeList, function(invoke, key) {
                    if (angular1.isString(invoke)) // decorators for example
                    onInvoke(invoke, invokeList[1]);
                    else // components registered as object lists {"componentName": function() {}}
                    onInvoke(key, invoke);
                });
                else return false;
                return newInvoke;
            }
            function _invokeQueue(providers, queue, moduleName, reconfig) {
                if (!queue) return;
                var i, len, args, provider;
                for(i = 0, len = queue.length; i < len; i++){
                    args = queue[i];
                    if (angular1.isArray(args)) {
                        if (providers !== null) {
                            if (providers.hasOwnProperty(args[0])) provider = providers[args[0]];
                            else throw new Error("unsupported provider " + args[0]);
                        }
                        var isNew = _registerInvokeList(args, moduleName);
                        if (args[1] !== "invoke") {
                            if (isNew && angular1.isDefined(provider)) provider[args[1]].apply(provider, args[2]);
                        } else {
                            // config block
                            var callInvoke = function callInvoke(fct) {
                                var invoked = regConfigs.indexOf(moduleName + "-" + fct);
                                if (invoked === -1 || reconfig) {
                                    if (invoked === -1) regConfigs.push(moduleName + "-" + fct);
                                    if (angular1.isDefined(provider)) provider[args[1]].apply(provider, args[2]);
                                }
                            };
                            if (angular1.isFunction(args[2][0])) callInvoke(args[2][0]);
                            else if (angular1.isArray(args[2][0])) {
                                for(var j = 0, jlen = args[2][0].length; j < jlen; j++)if (angular1.isFunction(args[2][0][j])) callInvoke(args[2][0][j]);
                            }
                        }
                    }
                }
            }
            function getModuleName(module1) {
                var moduleName = null;
                if (angular1.isString(module1)) moduleName = module1;
                else if (angular1.isObject(module1) && module1.hasOwnProperty("name") && angular1.isString(module1.name)) moduleName = module1.name;
                return moduleName;
            }
            function moduleExists(moduleName) {
                if (!angular1.isString(moduleName)) return false;
                try {
                    return ngModuleFct(moduleName);
                } catch (e) {
                    if (/No module/.test(e) || e.message.indexOf("$injector:nomod") > -1) return false;
                }
            }
            this.$get = [
                "$log",
                "$rootElement",
                "$rootScope",
                "$cacheFactory",
                "$q",
                function($log, $rootElement, $rootScope, $cacheFactory, $q) {
                    var instanceInjector, filesCache = $cacheFactory("ocLazyLoad");
                    if (!debug) {
                        $log = {};
                        $log["error"] = angular1.noop;
                        $log["warn"] = angular1.noop;
                        $log["info"] = angular1.noop;
                    }
                    // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
                    providers.getInstanceInjector = function() {
                        return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data("$injector") || angular1.injector();
                    };
                    broadcast = function broadcast(eventName, params) {
                        if (events) $rootScope.$broadcast(eventName, params);
                        if (debug) $log.info(eventName, params);
                    };
                    function reject(e) {
                        var deferred = $q.defer();
                        $log.error(e.message);
                        deferred.reject(e);
                        return deferred.promise;
                    }
                    return {
                        _broadcast: broadcast,
                        _$log: $log,
                        /**
                 * Returns the files cache used by the loaders to store the files currently loading
                 * @returns {*}
                 */ _getFilesCache: function getFilesCache() {
                            return filesCache;
                        },
                        /**
                 * Let the service know that it should monitor angular.module because files are loading
                 * @param watch boolean
                 */ toggleWatch: function toggleWatch(watch) {
                            if (watch) recordDeclarations.push(true);
                            else recordDeclarations.pop();
                        },
                        /**
                 * Let you get a module config object
                 * @param moduleName String the name of the module
                 * @returns {*}
                 */ getModuleConfig: function getModuleConfig(moduleName) {
                            if (!angular1.isString(moduleName)) throw new Error("You need to give the name of the module to get");
                            if (!modules[moduleName]) return null;
                            return angular1.copy(modules[moduleName]);
                        },
                        /**
                 * Let you define a module config object
                 * @param moduleConfig Object the module config object
                 * @returns {*}
                 */ setModuleConfig: function setModuleConfig(moduleConfig) {
                            if (!angular1.isObject(moduleConfig)) throw new Error("You need to give the module config object to set");
                            modules[moduleConfig.name] = moduleConfig;
                            return moduleConfig;
                        },
                        /**
                 * Returns the list of loaded modules
                 * @returns {string[]}
                 */ getModules: function getModules() {
                            return regModules;
                        },
                        /**
                 * Let you check if a module has been loaded into Angular or not
                 * @param modulesNames String/Object a module name, or a list of module names
                 * @returns {boolean}
                 */ isLoaded: function isLoaded(modulesNames) {
                            var moduleLoaded = function moduleLoaded(module1) {
                                var isLoaded = regModules.indexOf(module1) > -1;
                                if (!isLoaded) isLoaded = !!moduleExists(module1);
                                return isLoaded;
                            };
                            if (angular1.isString(modulesNames)) modulesNames = [
                                modulesNames
                            ];
                            if (angular1.isArray(modulesNames)) {
                                var i, len;
                                for(i = 0, len = modulesNames.length; i < len; i++){
                                    if (!moduleLoaded(modulesNames[i])) return false;
                                }
                                return true;
                            } else throw new Error("You need to define the module(s) name(s)");
                        },
                        /**
                 * Given a module, return its name
                 * @param module
                 * @returns {String}
                 */ _getModuleName: getModuleName,
                        /**
                 * Returns a module if it exists
                 * @param moduleName
                 * @returns {module}
                 */ _getModule: function getModule(moduleName) {
                            try {
                                return ngModuleFct(moduleName);
                            } catch (e) {
                                // this error message really suxx
                                if (/No module/.test(e) || e.message.indexOf("$injector:nomod") > -1) e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
                                throw e;
                            }
                        },
                        /**
                 * Check if a module exists and returns it if it does
                 * @param moduleName
                 * @returns {boolean}
                 */ moduleExists: moduleExists,
                        /**
                 * Load the dependencies, and might try to load new files depending on the config
                 * @param moduleName (String or Array of Strings)
                 * @param localParams
                 * @returns {*}
                 * @private
                 */ _loadDependencies: function _loadDependencies(moduleName, localParams) {
                            var loadedModule, requires, diff, promisesList = [], self = this;
                            moduleName = self._getModuleName(moduleName);
                            if (moduleName === null) return $q.when();
                            else {
                                try {
                                    loadedModule = self._getModule(moduleName);
                                } catch (e) {
                                    return reject(e);
                                }
                                // get unloaded requires
                                requires = self.getRequires(loadedModule);
                            }
                            angular1.forEach(requires, function(requireEntry) {
                                // If no configuration is provided, try and find one from a previous load.
                                // If there isn't one, bail and let the normal flow run
                                if (angular1.isString(requireEntry)) {
                                    var config = self.getModuleConfig(requireEntry);
                                    if (config === null) {
                                        moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
                                        return;
                                    }
                                    requireEntry = config;
                                    // ignore the name because it's probably not a real module name
                                    config.name = undefined;
                                }
                                // Check if this dependency has been loaded previously
                                if (self.moduleExists(requireEntry.name)) {
                                    // compare against the already loaded module to see if the new definition adds any new files
                                    diff = requireEntry.files.filter(function(n) {
                                        return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
                                    });
                                    // If the module was redefined, advise via the console
                                    if (diff.length !== 0) self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
                                    // Push everything to the file loader, it will weed out the duplicates.
                                    if (angular1.isDefined(self.filesLoader)) // if a files loader is defined
                                    promisesList.push(self.filesLoader(requireEntry, localParams).then(function() {
                                        return self._loadDependencies(requireEntry);
                                    }));
                                    else return reject(new Error("Error: New dependencies need to be loaded from external files (" + requireEntry.files + "), but no loader has been defined."));
                                    return;
                                } else if (angular1.isArray(requireEntry)) {
                                    var files = [];
                                    angular1.forEach(requireEntry, function(entry) {
                                        // let's check if the entry is a file name or a config name
                                        var config = self.getModuleConfig(entry);
                                        if (config === null) files.push(entry);
                                        else if (config.files) files = files.concat(config.files);
                                    });
                                    if (files.length > 0) requireEntry = {
                                        files: files
                                    };
                                } else if (angular1.isObject(requireEntry)) {
                                    if (requireEntry.hasOwnProperty("name") && requireEntry["name"]) {
                                        // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
                                        self.setModuleConfig(requireEntry);
                                        moduleCache.push(requireEntry["name"]);
                                    }
                                }
                                // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
                                if (angular1.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
                                    if (angular1.isDefined(self.filesLoader)) // if a files loader is defined
                                    promisesList.push(self.filesLoader(requireEntry, localParams).then(function() {
                                        return self._loadDependencies(requireEntry);
                                    }));
                                    else return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + "), but no loader has been defined."));
                                }
                            });
                            // Create a wrapper promise to watch the promise list and resolve it once everything is done.
                            return $q.all(promisesList);
                        },
                        /**
                 * Inject new modules into Angular
                 * @param moduleName
                 * @param localParams
                 * @param real
                 */ inject: function inject(moduleName) {
                            var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                            var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
                            var self = this, deferred = $q.defer();
                            if (angular1.isDefined(moduleName) && moduleName !== null) {
                                if (angular1.isArray(moduleName)) {
                                    var promisesList = [];
                                    angular1.forEach(moduleName, function(module1) {
                                        promisesList.push(self.inject(module1, localParams, real));
                                    });
                                    return $q.all(promisesList);
                                } else self._addToLoadList(self._getModuleName(moduleName), true, real);
                            }
                            if (modulesToLoad.length > 0) {
                                var res = modulesToLoad.slice(); // clean copy
                                var loadNext = function loadNext(moduleName) {
                                    moduleCache.push(moduleName);
                                    modulePromises[moduleName] = deferred.promise;
                                    self._loadDependencies(moduleName, localParams).then(function success() {
                                        try {
                                            justLoaded = [];
                                            _register(providers, moduleCache, localParams);
                                        } catch (e) {
                                            self._$log.error(e.message);
                                            deferred.reject(e);
                                            return;
                                        }
                                        if (modulesToLoad.length > 0) loadNext(modulesToLoad.shift()); // load the next in list
                                        else deferred.resolve(res); // everything has been loaded, resolve
                                    }, function error(err) {
                                        deferred.reject(err);
                                    });
                                };
                                // load the first in list
                                loadNext(modulesToLoad.shift());
                            } else if (localParams && localParams.name && modulePromises[localParams.name]) return modulePromises[localParams.name];
                            else deferred.resolve();
                            return deferred.promise;
                        },
                        /**
                 * Get the list of required modules/services/... for this module
                 * @param module
                 * @returns {Array}
                 */ getRequires: function getRequires(module1) {
                            var requires = [];
                            angular1.forEach(module1.requires, function(requireModule) {
                                if (regModules.indexOf(requireModule) === -1) requires.push(requireModule);
                            });
                            return requires;
                        },
                        /**
                 * Invoke the new modules & component by their providers
                 * @param providers
                 * @param queue
                 * @param moduleName
                 * @param reconfig
                 * @private
                 */ _invokeQueue: _invokeQueue,
                        /**
                 * Check if a module has been invoked and registers it if not
                 * @param args
                 * @param moduleName
                 * @returns {boolean} is new
                 */ _registerInvokeList: _registerInvokeList,
                        /**
                 * Register a new module and loads it, executing the run/config blocks if needed
                 * @param providers
                 * @param registerModules
                 * @param params
                 * @private
                 */ _register: _register,
                        /**
                 * Add a module name to the list of modules that will be loaded in the next inject
                 * @param name
                 * @param force
                 * @private
                 */ _addToLoadList: _addToLoadList,
                        /**
                 * Unregister modules (you shouldn't have to use this)
                 * @param modules
                 */ _unregister: function _unregister(modules) {
                            if (angular1.isDefined(modules)) {
                                if (angular1.isArray(modules)) angular1.forEach(modules, function(module1) {
                                    regInvokes[module1] = undefined;
                                });
                            }
                        }
                    };
                }
            ];
            // Let's get the list of loaded modules & components
            this._init(angular1.element(window1.document));
        }
    ]);
    var bootstrapFct = angular1.bootstrap;
    angular1.bootstrap = function(element, modules, config) {
        // Clean state from previous bootstrap
        regModules = [
            "ng",
            "oc.lazyLoad"
        ];
        regInvokes = {};
        regConfigs = [];
        modulesToLoad = [];
        realModules = [];
        recordDeclarations = [];
        broadcast = angular1.noop;
        runBlocks = {};
        justLoaded = [];
        // we use slice to make a clean copy
        angular1.forEach(modules.slice(), function(module1) {
            _addToLoadList(module1, true, true);
        });
        return bootstrapFct(element, modules, config);
    };
    var _addToLoadList = function _addToLoadList(name, force, real) {
        if ((recordDeclarations.length > 0 || force) && angular1.isString(name) && modulesToLoad.indexOf(name) === -1) {
            modulesToLoad.push(name);
            if (real) realModules.push(name);
        }
    };
    var ngModuleFct = angular1.module;
    angular1.module = function(name, requires, configFn) {
        _addToLoadList(name, false, true);
        return ngModuleFct(name, requires, configFn);
    };
    // CommonJS package manager support:
    if ($843539283adf9310$exports === $843539283adf9310$exports) $843539283adf9310$exports = "oc.lazyLoad";
})(angular, window);
(function(angular1) {
    "use strict";
    angular1.module("oc.lazyLoad").directive("ocLazyLoad", [
        "$ocLazyLoad",
        "$compile",
        "$animate",
        "$parse",
        "$timeout",
        function($ocLazyLoad, $compile, $animate, $parse, $timeout) {
            return {
                restrict: "A",
                terminal: true,
                priority: 1000,
                compile: function compile(element, attrs) {
                    // we store the content and remove it before compilation
                    var content = element[0].innerHTML;
                    element.html("");
                    return function($scope, $element, $attr) {
                        var model = $parse($attr.ocLazyLoad);
                        $scope.$watch(function() {
                            return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
                        }, function(moduleName) {
                            if (angular1.isDefined(moduleName)) $ocLazyLoad.load(moduleName).then(function() {
                                // Attach element contents to DOM and then compile them.
                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
                                // of the compiled contents when attaching to the parent DOM.
                                $animate.enter(content, $element);
                                // get the new content & compile it
                                $compile($element.contents())($scope);
                            });
                        }, true);
                    };
                }
            };
        }
    ]);
})(angular);
(function(angular1) {
    "use strict";
    angular1.module("oc.lazyLoad").config([
        "$provide",
        function($provide) {
            $provide.decorator("$ocLazyLoad", [
                "$delegate",
                "$q",
                "$window",
                "$interval",
                function($delegate, $q, $window, $interval) {
                    var uaCssChecked = false, useCssLoadPatch = false, anchor = $window.document.getElementsByTagName("head")[0] || $window.document.getElementsByTagName("body")[0];
                    /**
             * Load a js/css file
             * @param type
             * @param path
             * @param params
             * @returns promise
             */ $delegate.buildElement = function buildElement(type, path, params) {
                        var deferred = $q.defer(), el, loaded, filesCache = $delegate._getFilesCache(), cacheBuster = function cacheBuster(url) {
                            var dc = new Date().getTime();
                            if (url.indexOf("?") >= 0) {
                                if (url.substring(0, url.length - 1) === "&") return url + "_dc=" + dc;
                                return url + "&_dc=" + dc;
                            } else return url + "?_dc=" + dc;
                        };
                        // Store the promise early so the file load can be detected by other parallel lazy loads
                        // (ie: multiple routes on one page) a 'true' value isn't sufficient
                        // as it causes false positive load results.
                        if (angular1.isUndefined(filesCache.get(path))) filesCache.put(path, deferred.promise);
                        // Switch in case more content types are added later
                        switch(type){
                            case "css":
                                el = $window.document.createElement("link");
                                el.type = "text/css";
                                el.rel = "stylesheet";
                                el.href = params.cache === false ? cacheBuster(path) : path;
                                break;
                            case "js":
                                el = $window.document.createElement("script");
                                el.src = params.cache === false ? cacheBuster(path) : path;
                                break;
                            default:
                                filesCache.remove(path);
                                deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
                                break;
                        }
                        el.onload = el["onreadystatechange"] = function(e) {
                            if (el["readyState"] && !/^c|loade/.test(el["readyState"]) || loaded) return;
                            el.onload = el["onreadystatechange"] = null;
                            loaded = 1;
                            $delegate._broadcast("ocLazyLoad.fileLoaded", path);
                            deferred.resolve(el);
                        };
                        el.onerror = function() {
                            filesCache.remove(path);
                            deferred.reject(new Error("Unable to load " + path));
                        };
                        el.async = params.serie ? 0 : 1;
                        var insertBeforeElem = anchor.lastChild;
                        if (params.insertBefore) {
                            var element = angular1.element(angular1.isDefined(window.jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
                            if (element && element.length > 0) insertBeforeElem = element[0];
                        }
                        insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);
                        /*
                 The event load or readystatechange doesn't fire in:
                 - PhantomJS 1.9 (headless webkit browser)
                 - iOS < 6       (default mobile browser)
                 - Android < 4.4 (default mobile browser)
                 - Safari < 6    (desktop browser)
                 */ if (type == "css") {
                            if (!uaCssChecked) {
                                var ua = $window.navigator.userAgent.toLowerCase();
                                if (ua.indexOf("phantomjs/1.9") > -1) // PhantomJS ~1.9
                                useCssLoadPatch = true;
                                else if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
                                    // iOS < 6
                                    var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                                    var iOSVersion = parseFloat([
                                        parseInt(v[1], 10),
                                        parseInt(v[2], 10),
                                        parseInt(v[3] || 0, 10)
                                    ].join("."));
                                    useCssLoadPatch = iOSVersion < 6;
                                } else if (ua.indexOf("android") > -1) {
                                    // Android < 4.4
                                    var androidVersion = parseFloat(ua.slice(ua.indexOf("android") + 8));
                                    useCssLoadPatch = androidVersion < 4.4;
                                } else if (ua.indexOf("safari") > -1) {
                                    // Safari < 6
                                    var versionMatch = ua.match(/version\/([\.\d]+)/i);
                                    useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
                                }
                            }
                            if (useCssLoadPatch) {
                                var tries = 1000; // * 20 = 20000 miliseconds
                                var interval = $interval(function() {
                                    try {
                                        el.sheet.cssRules;
                                        $interval.cancel(interval);
                                        el.onload();
                                    } catch (e) {
                                        if (--tries <= 0) el.onerror();
                                    }
                                }, 20);
                            }
                        }
                        return deferred.promise;
                    };
                    return $delegate;
                }
            ]);
        }
    ]);
})(angular);
(function(angular1) {
    "use strict";
    angular1.module("oc.lazyLoad").config([
        "$provide",
        function($provide) {
            $provide.decorator("$ocLazyLoad", [
                "$delegate",
                "$q",
                function($delegate, $q) {
                    /**
             * The function that loads new files
             * @param config
             * @param params
             * @returns {*}
             */ $delegate.filesLoader = function filesLoader(config) {
                        var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                        var cssFiles = [], templatesFiles = [], jsFiles = [], promises = [], cachePromise = null, filesCache = $delegate._getFilesCache();
                        $delegate.toggleWatch(true); // start watching angular.module calls
                        angular1.extend(params, config);
                        var pushFile = function pushFile(path) {
                            var file_type = null, m;
                            if (angular1.isObject(path)) {
                                file_type = path.type;
                                path = path.path;
                            }
                            cachePromise = filesCache.get(path);
                            if (angular1.isUndefined(cachePromise) || params.cache === false) {
                                // always check for requirejs syntax just in case
                                if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
                                    // Detect file type using preceding type declaration (ala requireJS)
                                    file_type = m[1];
                                    path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
                                }
                                if (!file_type) {
                                    if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) // Detect file type via file extension
                                    file_type = m[1];
                                    else if (!$delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") && $delegate.jsLoader.hasOwnProperty("requirejs")) // requirejs
                                    file_type = "js";
                                    else {
                                        $delegate._$log.error("File type could not be determined. " + path);
                                        return;
                                    }
                                }
                                if ((file_type === "css" || file_type === "less") && cssFiles.indexOf(path) === -1) cssFiles.push(path);
                                else if ((file_type === "html" || file_type === "htm") && templatesFiles.indexOf(path) === -1) templatesFiles.push(path);
                                else if (file_type === "js" || jsFiles.indexOf(path) === -1) jsFiles.push(path);
                                else $delegate._$log.error("File type is not valid. " + path);
                            } else if (cachePromise) promises.push(cachePromise);
                        };
                        if (params.serie) pushFile(params.files.shift());
                        else angular1.forEach(params.files, function(path) {
                            pushFile(path);
                        });
                        if (cssFiles.length > 0) {
                            var cssDeferred = $q.defer();
                            $delegate.cssLoader(cssFiles, function(err) {
                                if (angular1.isDefined(err) && $delegate.cssLoader.hasOwnProperty("ocLazyLoadLoader")) {
                                    $delegate._$log.error(err);
                                    cssDeferred.reject(err);
                                } else cssDeferred.resolve();
                            }, params);
                            promises.push(cssDeferred.promise);
                        }
                        if (templatesFiles.length > 0) {
                            var templatesDeferred = $q.defer();
                            $delegate.templatesLoader(templatesFiles, function(err) {
                                if (angular1.isDefined(err) && $delegate.templatesLoader.hasOwnProperty("ocLazyLoadLoader")) {
                                    $delegate._$log.error(err);
                                    templatesDeferred.reject(err);
                                } else templatesDeferred.resolve();
                            }, params);
                            promises.push(templatesDeferred.promise);
                        }
                        if (jsFiles.length > 0) {
                            var jsDeferred = $q.defer();
                            $delegate.jsLoader(jsFiles, function(err) {
                                if (angular1.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
                                    $delegate._$log.error(err);
                                    jsDeferred.reject(err);
                                } else jsDeferred.resolve();
                            }, params);
                            promises.push(jsDeferred.promise);
                        }
                        if (promises.length === 0) {
                            var deferred = $q.defer(), err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
                            $delegate._$log.error(err);
                            deferred.reject(err);
                            return deferred.promise;
                        } else if (params.serie && params.files.length > 0) return $q.all(promises).then(function() {
                            return $delegate.filesLoader(config, params);
                        });
                        else return $q.all(promises)["finally"](function(res) {
                            $delegate.toggleWatch(false); // stop watching angular.module calls
                            return res;
                        });
                    };
                    /**
             * Load a module or a list of modules into Angular
             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
             * @param params Object optional parameters
             * @returns promise
             */ $delegate.load = function(originalModule) {
                        var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                        var self = this, config = null, deferredList = [], deferred = $q.defer(), errText;
                        // clean copy
                        var module1 = angular1.copy(originalModule);
                        var params = angular1.copy(originalParams);
                        // If module is an array, break it down
                        if (angular1.isArray(module1)) {
                            // Resubmit each entry as a single module
                            angular1.forEach(module1, function(m) {
                                deferredList.push(self.load(m, params));
                            });
                            // Resolve the promise once everything has loaded
                            $q.all(deferredList).then(function(res) {
                                deferred.resolve(res);
                            }, function(err) {
                                deferred.reject(err);
                            });
                            return deferred.promise;
                        }
                        // Get or Set a configuration depending on what was passed in
                        if (angular1.isString(module1)) {
                            config = self.getModuleConfig(module1);
                            if (!config) config = {
                                files: [
                                    module1
                                ]
                            };
                        } else if (angular1.isObject(module1)) {
                            // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
                            if (angular1.isDefined(module1.path) && angular1.isDefined(module1.type)) config = {
                                files: [
                                    module1
                                ]
                            };
                            else config = self.setModuleConfig(module1);
                        }
                        if (config === null) {
                            var moduleName = self._getModuleName(module1);
                            errText = 'Module "' + (moduleName || "unknown") + '" is not configured, cannot load.';
                            $delegate._$log.error(errText);
                            deferred.reject(new Error(errText));
                            return deferred.promise;
                        } else // deprecated
                        if (angular1.isDefined(config.template)) {
                            if (angular1.isUndefined(config.files)) config.files = [];
                            if (angular1.isString(config.template)) config.files.push(config.template);
                            else if (angular1.isArray(config.template)) config.files.concat(config.template);
                        }
                        var localParams = angular1.extend({}, params, config);
                        // if someone used an external loader and called the load function with just the module name
                        if (angular1.isUndefined(config.files) && angular1.isDefined(config.name) && $delegate.moduleExists(config.name)) return $delegate.inject(config.name, localParams, true);
                        $delegate.filesLoader(config, localParams).then(function() {
                            $delegate.inject(null, localParams).then(function(res) {
                                deferred.resolve(res);
                            }, function(err) {
                                deferred.reject(err);
                            });
                        }, function(err) {
                            deferred.reject(err);
                        });
                        return deferred.promise;
                    };
                    // return the patched service
                    return $delegate;
                }
            ]);
        }
    ]);
})(angular);
(function(angular1) {
    "use strict";
    angular1.module("oc.lazyLoad").config([
        "$provide",
        function($provide) {
            $provide.decorator("$ocLazyLoad", [
                "$delegate",
                "$q",
                function($delegate, $q) {
                    /**
             * cssLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite cssLoader and it will probably not use promises :(
             */ $delegate.cssLoader = function(paths, callback, params) {
                        var promises = [];
                        angular1.forEach(paths, function(path) {
                            promises.push($delegate.buildElement("css", path, params));
                        });
                        $q.all(promises).then(function() {
                            callback();
                        }, function(err) {
                            callback(err);
                        });
                    };
                    $delegate.cssLoader.ocLazyLoadLoader = true;
                    return $delegate;
                }
            ]);
        }
    ]);
})(angular);
(function(angular1) {
    "use strict";
    angular1.module("oc.lazyLoad").config([
        "$provide",
        function($provide) {
            $provide.decorator("$ocLazyLoad", [
                "$delegate",
                "$q",
                function($delegate, $q) {
                    /**
             * jsLoader function
             * @type Function
             * @param paths array list of js files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite jsLoader and it will probably not use promises :(
             */ $delegate.jsLoader = function(paths, callback, params) {
                        var promises = [];
                        angular1.forEach(paths, function(path) {
                            promises.push($delegate.buildElement("js", path, params));
                        });
                        $q.all(promises).then(function() {
                            callback();
                        }, function(err) {
                            callback(err);
                        });
                    };
                    $delegate.jsLoader.ocLazyLoadLoader = true;
                    return $delegate;
                }
            ]);
        }
    ]);
})(angular);
(function(angular1) {
    "use strict";
    angular1.module("oc.lazyLoad").config([
        "$provide",
        function($provide) {
            $provide.decorator("$ocLazyLoad", [
                "$delegate",
                "$templateCache",
                "$q",
                "$http",
                function($delegate, $templateCache, $q, $http) {
                    /**
             * templatesLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters for $http
             * because the user can overwrite templatesLoader and it will probably not use promises :(
             */ $delegate.templatesLoader = function(paths, callback, params) {
                        var promises = [], filesCache = $delegate._getFilesCache();
                        angular1.forEach(paths, function(url) {
                            var deferred = $q.defer();
                            promises.push(deferred.promise);
                            $http.get(url, params).then(function(response) {
                                var data = response.data;
                                if (angular1.isString(data) && data.length > 0) angular1.forEach(angular1.element(data), function(node) {
                                    if (node.nodeName === "SCRIPT" && node.type === "text/ng-template") $templateCache.put(node.id, node.innerHTML);
                                });
                                if (angular1.isUndefined(filesCache.get(url))) filesCache.put(url, true);
                                deferred.resolve();
                            })["catch"](function(response) {
                                deferred.reject(new Error('Unable to load template file "' + url + '": ' + response.data));
                            });
                        });
                        return $q.all(promises).then(function() {
                            callback();
                        }, function(err) {
                            callback(err);
                        });
                    };
                    $delegate.templatesLoader.ocLazyLoadLoader = true;
                    return $delegate;
                }
            ]);
        }
    ]);
})(angular);
// Array.indexOf polyfill for IE8
if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement, fromIndex) {
    var k;
    // 1. Let O be the result of calling ToObject passing
    //    the this value as the argument.
    if (this == null) throw new TypeError('"this" is null or not defined');
    var O = Object(this);
    // 2. Let lenValue be the result of calling the Get
    //    internal method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;
    // 4. If len is 0, return -1.
    if (len === 0) return -1;
    // 5. If argument fromIndex was passed let n be
    //    ToInteger(fromIndex); else let n be 0.
    var n = +fromIndex || 0;
    if (Math.abs(n) === Infinity) n = 0;
    // 6. If n >= len, return -1.
    if (n >= len) return -1;
    // 7. If n >= 0, then Let k be n.
    // 8. Else, n<0, Let k be len - abs(n).
    //    If k is less than 0, then let k be 0.
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
    // 9. Repeat, while k < len
    while(k < len){
        // a. Let Pk be ToString(k).
        //   This is implicit for LHS operands of the in operator
        // b. Let kPresent be the result of calling the
        //    HasProperty internal method of O with argument Pk.
        //   This step can be combined with c
        // c. If kPresent is true, then
        //    i.  Let elementK be the result of calling the Get
        //        internal method of O with the argument ToString(k).
        //   ii.  Let same be the result of applying the
        //        Strict Equality Comparison Algorithm to
        //        searchElement and elementK.
        //  iii.  If same is true, return k.
        if (k in O && O[k] === searchElement) return k;
        k++;
    }
    return -1;
};


var $8c6bf35b0cf83994$exports = {};
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */ (function(window1, angular) {
    "use strict";
    /**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 * See {@link ngCookies.$cookies `$cookies`} for usage.
 */ angular.module("ngCookies", [
        "ng"
    ]).info({
        angularVersion: "1.8.3"
    })./**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */ provider("$cookies", [
        /** @this */ function $CookiesProvider() {
            /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/ var defaults = this.defaults = {};
            function calcOptions(options) {
                return options ? angular.extend({}, defaults, options) : defaults;
            }
            /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */ this.$get = [
                "$$cookieReader",
                "$$cookieWriter",
                function($$cookieReader, $$cookieWriter) {
                    return {
                        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */ get: function(key) {
                            return $$cookieReader()[key];
                        },
                        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */ getObject: function(key) {
                            var value = this.get(key);
                            return value ? angular.fromJson(value) : value;
                        },
                        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */ getAll: function() {
                            return $$cookieReader();
                        },
                        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */ put: function(key, value, options) {
                            $$cookieWriter(key, value, calcOptions(options));
                        },
                        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */ putObject: function(key, value, options) {
                            this.put(key, angular.toJson(value), options);
                        },
                        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */ remove: function(key, options) {
                            $$cookieWriter(key, undefined, calcOptions(options));
                        }
                    };
                }
            ];
        }
    ]);
    /**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */ function $$CookieWriter($document, $log, $browser) {
        var cookiePath = $browser.baseHref();
        var rawDocument = $document[0];
        function buildCookieString(name, value, options) {
            var path, expires;
            options = options || {};
            expires = options.expires;
            path = angular.isDefined(options.path) ? options.path : cookiePath;
            if (angular.isUndefined(value)) {
                expires = "Thu, 01 Jan 1970 00:00:00 GMT";
                value = "";
            }
            if (angular.isString(expires)) expires = new Date(expires);
            var str = encodeURIComponent(name) + "=" + encodeURIComponent(value);
            str += path ? ";path=" + path : "";
            str += options.domain ? ";domain=" + options.domain : "";
            str += expires ? ";expires=" + expires.toUTCString() : "";
            str += options.secure ? ";secure" : "";
            str += options.samesite ? ";samesite=" + options.samesite : "";
            // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
            // - 300 cookies
            // - 20 cookies per unique domain
            // - 4096 bytes per cookie
            var cookieLength = str.length + 1;
            if (cookieLength > 4096) $log.warn("Cookie '" + name + "' possibly not set or overflowed because it was too large (" + cookieLength + " > 4096 bytes)!");
            return str;
        }
        return function(name, value, options) {
            rawDocument.cookie = buildCookieString(name, value, options);
        };
    }
    $$CookieWriter.$inject = [
        "$document",
        "$log",
        "$browser"
    ];
    angular.module("ngCookies").provider("$$cookieWriter", /** @this */ function $$CookieWriterProvider() {
        this.$get = $$CookieWriter;
    });
})(window, window.angular);


$8c6bf35b0cf83994$exports = "ngCookies";


(function() {
    window.app = function() {
        const dependency = [
            "ui.router",
            "ui.router.state.events",
            "pascalprecht.translate",
            "ngAnimate",
            "duScroll",
            "templates",
            "scrollSpyModule",
            "ngMessages",
            "ui.mask",
            "oc.lazyLoad",
            "ngCookies"
        ].filter((item)=>{
            let result = false;
            try {
                const t = (0, (/*@__PURE__*/$parcel$interopDefault($jTg1q))).module(item);
                result = true;
            } catch (e) {
            //
            }
            return result;
        });
        const app = (0, (/*@__PURE__*/$parcel$interopDefault($jTg1q))).module("app", dependency);
        window.Controller = app.controller;
        return app;
    }();
})();


var $0d10d209fcabfa38$exports = {};
var $0c3f2a050bef79b1$exports = {};
const $a878ea5cd2565d1f$var$build = Date.now();
var $a878ea5cd2565d1f$export$2e2bcd8739ae039 = $a878ea5cd2565d1f$var$build;


(function() {
    "use strict";
    const isProduction = $_CONFIG.production || true;
    const config = {
        apiUrl: isProduction && !$_CONFIG.mobileApp ? "" : $_CONFIG.domain,
        cdn: $_CONFIG.cdn || "/joxi",
        domain: $_CONFIG.domain || "",
        siteDomain: window.location.origin || "",
        mobileSiteDomain: $_CONFIG.mobileSiteDomain,
        siteName: $_CONFIG.siteName || "",
        build: (0, $a878ea5cd2565d1f$export$2e2bcd8739ae039),
        buildVersion: $_VERSION.version,
        mobile: $_CONFIG.mobile,
        locale: $_CONFIG.locale || "",
        languages: $_CONFIG.language || [
            "en"
        ],
        liveAgent: {},
        chat: "liveAgent",
        freshChat: $_CONFIG.freshChat || {},
        preChatFormConfig: $_CONFIG.preChatFormConfig,
        currentLang: $_CONFIG.currentLang,
        alternates: $_DICT.alternates || {},
        sessionStatus: null,
        userActivated: null,
        device: $_CONFIG.device,
        browser: $_CONFIG.browser,
        apiVersion: $_CONFIG.apiVersion || "v2",
        currency: $_CONFIG.currency || window.$_DICT.currency || [
            {
                key: "EUR",
                name: "",
                icon: "\u20AC"
            }
        ],
        mobileApp: $_CONFIG.mobileApp || false,
        mobileConfig: $_CONFIG.mobileConfig || {},
        production: isProduction,
        product: $_CONFIG.product || "casino",
        mid: $_CONFIG.mid || "",
        aliases: $_CONFIG.aliases || window.$_ALIAS || {},
        links: $_CONFIG.links || {},
        licenseId: $_CONFIG.licenseId || "",
        redirectToNotFound: $_CONFIG.redirectToNotFound || false,
        regily: $_CONFIG.regily || {},
        sentry: $_CONFIG.sentry || {},
        jurisdiction: $_CONFIG.jurisdiction || "curacao",
        jurisdictions: $_CONFIG.jurisdictions || {
            de: "germany",
            sw: "sweden"
        },
        project: $_CONFIG.project || "",
        projectType: $_CONFIG.projectType,
        state: {
            isEntercash: false
        },
        sport: {
            fixedBottom: $_CONFIG.sportFixedBottom || 55,
            fixedTop: $_CONFIG.sportFixedTop,
            banners: $_CONFIG.banners || {},
            callbackUrl: $_CONFIG.sportBannerCallbackUrl || $_CONFIG.mobileSiteDomain,
            initializationParams: $_CONFIG.sportInitializationParams || {},
            insufficientbalancecallback: $_CONFIG.sportInsufficientBalanceCallback,
            hasSport: $_CONFIG.sport
        },
        sportVersion: $_CONFIG.sportVersion || 1,
        altenar: {
            widget: {
                integration: $_CONFIG.sportId || ""
            }
        },
        pwa: false,
        ios: Boolean(navigator.userAgent.match(/ipad|iphone/i)),
        slider: typeof $_CONFIG.slider === "object" ? $_CONFIG.slider : {},
        googleAnalytics: $_CONFIG.googleAnalytics && $_CONFIG.googleAnalytics.appId ? $_CONFIG.googleAnalytics : {},
        hotjar: $_CONFIG.hotjar ? $_CONFIG.hotjar : {},
        feature: $_CONFIG.feature || {},
        isPayNPlayRegistrationAvailable: $_CONFIG.isPayNPlayRegistrationAvailable || true,
        sportBanners: $_CONFIG.sportBanners || null,
        ignoreErrorCodes: $_CONFIG.ignoreErrorCodes || [],
        pgw: $_CONFIG.pgw,
        insertCdnScripts: true,
        freshDeskId: "",
        scripts: [],
        gsap3Plugins: [],
        wsScript: "socket/socket.io.js",
        customScripts: [],
        useSvgSprite: $_CONFIG.useSvgSprite || true,
        paynplay: $_CONFIG.paynplay || undefined,
        cdnOnfidoFiles: {
            js: `https://unpkg.com/onfido-sdk-ui@12.2.0/dist/onfido.min.js`,
            style: `https://unpkg.com/onfido-sdk-ui@12.2.0/dist/style.css`
        }
    };
    let _system_info = {};
    function getLACreds(type) {
        const key = $_CONFIG.liveAgent[config.currentLang] ? config.currentLang : "default";
        return $_CONFIG.liveAgent[key][type];
    }
    Object.defineProperty(config, "system_info", {
        set (value) {
            _system_info = value;
        },
        get () {
            return Object.assign({}, {
                platform_version: "2"
            }, _system_info);
        }
    });
    Object.defineProperty(config.liveAgent, "sid", {
        set (value) {},
        get () {
            return getLACreds("sid");
        }
    });
    Object.defineProperty(config.liveAgent, "bid", {
        set (value) {},
        get () {
            return getLACreds("bid");
        }
    });
    const cdnFeature = window.$_CDN?.feature || {};
    let localStorageFeature = null;
    try {
        localStorageFeature = JSON.parse(window.localStorage.getItem("feature-flags"));
    } catch  {
    /* empty */ }
    config.feature = localStorageFeature ? localStorageFeature : cdnFeature;
    const apiUrl = window.localStorage.getItem("api-url") || "";
    if (apiUrl.length) config.apiUrl = apiUrl;
    config.router = $_CONFIG.router.length ? $_CONFIG.router : window.$_ROUTER || [];
    app.constant("config", Object.assign(config, $_CONFIG));
})();


var $fbeeeb6f4e874f4c$exports = {};
var $a5f17b190db1cbdc$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("user$", controller);
})();




(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("bonus$", controller);
})();



(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("system$", controller);
})();






(function() {
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        return {
            get login () {
                return $window.localStorage.getItem("rememberedLogin") || null;
            },
            set login (value){
                localStorage.setItem("rememberedLogin", value);
            },
            get name () {
                return $window.localStorage.getItem("rememberedName") || null;
            },
            set name (value){
                localStorage.setItem("rememberedName", value);
            },
            get surname () {
                return $window.localStorage.getItem("rememberedSurname") || null;
            },
            set surname (value){
                localStorage.setItem("rememberedSurname", value);
            },
            get avatar () {
                return $window.localStorage.getItem("rememberedAvatar") || null;
            },
            set avatar (value){
                localStorage.setItem("rememberedAvatar", value);
            },
            get accountId () {
                return $window.localStorage.getItem("accountId") || null;
            },
            set accountId (value){
                localStorage.setItem("accountId", value);
            }
        };
    }
    app.factory("remembered", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "user$",
        "config",
        "bonus$",
        "system$",
        "remembered"
    ];
    function controller(_user$, _config, _bonus$, _system$, _remembered) {
        const model = {};
        Object.defineProperty(model, "profile", {
            set (data) {
                _remembered.login = data.login;
                _remembered.accountId = data.account_id;
                _remembered.name = data.profile.name;
                _remembered.surname = data.profile.surname;
                if (data.profile && data.profile.avatar) _remembered.avatar = data.profile.avatar;
            },
            get () {
                return {
                    login: _remembered.login,
                    profile: {
                        name: _remembered.name,
                        surname: _remembered.surname,
                        avatar: _remembered.avatar
                    }
                };
            }
        });
        return model;
    }
    app.factory("model", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            set (key, value) {
                localStorage.setItem(key, value);
            },
            get (key) {
                return localStorage.getItem(key);
            },
            remove (key) {
                localStorage.removeItem(key);
            },
            setObject (key, value) {
                this.set(key, JSON.stringify(value));
            },
            getObject (key) {
                return JSON.parse(this.get(key));
            },
            setMapObject (key, data) {
                const mappedObject = new Map(Object.entries(data));
                this.setObject(key, Object.fromEntries(mappedObject));
            },
            getAffiliateData () {
                const data = this.getObject("params");
                delete data.login;
                return data || {};
            }
        };
    }
    app.factory("localStorage", controller);
})();


const $39b6f6ba7f252888$export$852308bbdd8fa6f1 = "sentry";
class $39b6f6ba7f252888$var$Sentry {
    static $inject = [
        "$window"
    ];
    constructor($window){
        this.$window = $window;
    }
    sendMessage(message, data) {
        this.$window.Sentry?.captureMessage(message, data);
    }
    sendException(message, data) {
        this.$window.Sentry?.captureException(new Error(message), data);
    }
}
app.factory($39b6f6ba7f252888$export$852308bbdd8fa6f1, $39b6f6ba7f252888$var$Sentry);


(function() {
    "use strict";
    controller.$inject = [
        "user$",
        "config",
        "bonus$",
        "system$",
        "model",
        "localStorage",
        "$window",
        "sentry"
    ];
    function controller(_user$, _config, _bonus$, _system$, _model, _localStorage, $window, sentry) {
        let _profile = _model.profile;
        let _bonus = [];
        let _token = _localStorage.get("token") || null;
        let _status = null;
        let _activeBonus = {};
        let _casinoBonus = [];
        let _sportBonus = [];
        const _limits = {
            time: false,
            deposit: false,
            loose: false,
            wager: false,
            session: false
        };
        let _balance = {};
        const user = {};
        $window.addEventListener("beforeunload", ()=>{
            _localStorage.set("token", _token);
        });
        Object.defineProperty(user, "status", {
            set (value) {
                let statusChanged = false;
                if (!_status && value === true) _system$.next({
                    action: "login"
                });
                if (_status === true && value === false) _system$.next({
                    action: "logout"
                });
                if (_status !== value) statusChanged = true;
                _status = value;
                if (statusChanged) _system$.next({
                    action: "statusChanged"
                });
                _config.sessionStatus = value;
            },
            get () {
                return _status;
            }
        });
        user.status = _token === null ? false : null;
        Object.defineProperty(user, "sessionToken", {
            set (token) {
                _token = token;
                _localStorage.set("token", _token);
            },
            get () {
                if (_token && !_localStorage.get("token")) sentry.sendMessage("missed-token", {
                    level: "info",
                    tags: {
                        event: "missed-token",
                        account_id: user.profile.account_id
                    }
                });
                return _token;
            }
        });
        Object.defineProperty(user, "limits", {
            set (data) {
                if (data.login_time && data.login_time.day && data.login_time.day.amount) _limits.time = true;
                if (data.login_time && data.login_time.week && data.login_time.week.amount) _limits.time = true;
                if (data.login_time && data.login_time.month && data.login_time.month.amount) _limits.time = true;
            },
            get () {
                return _limits;
            }
        });
        Object.defineProperty(user, "profile", {
            set (data) {
                if (data.login) {
                    data.diffUserAndServerTime = Date.now() - data.server_time_ts; // diff betwen time of user and time of server(in ms)
                    _profile = data;
                    user.status = true;
                    user.sessionToken = data.sessionToken ?? btoa(data.prefix + data.login.toUpperCase() + ":" + data.session_id);
                    user.limits = data.limits || {};
                    _model.profile = data;
                } else {
                    _profile = _model.profile;
                    user.status = false;
                    user.sessionToken = null;
                    user.balance = {};
                }
                _user$.next(user);
            },
            get () {
                return _profile;
            }
        });
        Object.defineProperty(user, "activeBonus", {
            set (data) {
                _activeBonus = data || {};
            },
            get () {
                return _activeBonus;
            }
        });
        Object.defineProperty(user, "casinoBonus", {
            set (data) {
                _casinoBonus = data || [];
            },
            get () {
                return _casinoBonus;
            }
        });
        Object.defineProperty(user, "sportBonus", {
            set (data) {
                _sportBonus = data || [];
            },
            get () {
                return _sportBonus;
            }
        });
        Object.defineProperty(user, "bonus", {
            set (data) {
                user.activeBonus = {};
                user.casinoBonus = [];
                user.sportBonus = [];
                _bonus = data.filter(// TODO this is kostbllb
                // we dont do bonus filter now
                // we will rewrite it in Q4
                (bonus)=>!bonus.is_promo_bonus || !bonus.is_retention_bonus || !!bonus.retention_bonus_rules_fulfilled);
                if (_bonus.length) {
                    user.activeBonus = _bonus.find((bonus)=>bonus.status === "active");
                    user.casinoBonus = _bonus.filter((bonus)=>bonus.type === "casino" || bonus.type === "freespin");
                    user.sportBonus = _bonus.filter((bonus)=>bonus.type === "sport");
                }
                _user$.next(user);
                _bonus$.next(data);
            },
            get () {
                return _bonus;
            }
        });
        Object.defineProperty(user, "balance", {
            set (data) {
                _balance = data;
            },
            get () {
                return _balance;
            }
        });
        return user;
    }
    app.factory("user", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "user",
        "$q"
    ];
    function controller(_user, $q) {
        return {
            request: function(config) {
                if (config.meta && config.meta.type === "api") switch(_user.sessionToken){
                    case "":
                        break;
                    case "null":
                        break;
                    default:
                        if (_user.sessionToken && _user.sessionToken.length >= 10) config.headers.Authorization = "Basic " + _user.sessionToken;
                        break;
                }
                return config;
            },
            response: function(response) {
                return response;
            }
        };
    }
    app.factory("auth", controller);
})();


var $06f6775189394665$exports = {};
(function() {
    "use strict";
    app.factory("bb", controller);
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        const qaLsParams = $window.localStorage.getItem("qa-params") || "";
        const qaConfig = {};
        let flag = false;
        qaLsParams.replace(/\s/g, "").split(",").forEach((item)=>{
            const param = item.split("=");
            qaConfig[param[0]] = param[1];
            flag = true;
        });
        return {
            request (config) {
                if (config.meta?.type === "api" && config.method === "POST" && flag) config.data.qa = qaConfig;
                return config;
            },
            response (response) {
                return response;
            }
        };
    }
})();


var $9ccfbfcd5da5fb56$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "user",
        "$q"
    ];
    function controller(_user, $q) {
        let csrf_token = "";
        return {
            request: function(config) {
                if (config.meta && config.meta.type === "api") switch(config.method){
                    case "POST":
                    case "PUT":
                    case "DELETE":
                    case "PATCH":
                        config.headers["csrf-token"] = `${csrf_token}`;
                        break;
                    default:
                        break;
                }
                return config;
            },
            response: function(response) {
                const headers = response.headers();
                if (headers["csrf-token"] && headers["csrf-token"].length >= 5) csrf_token = headers["csrf-token"];
                return response;
            },
            responseError (rejection) {
                return $q.reject(rejection);
            }
        };
    }
    app.factory("csrf", controller);
})();


var $ca259a57c55132c0$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        return {
            request (config) {
                if (config.meta && config.meta.type === "api") config.headers["X-Device-Type"] = _config.device.mobile ? "mobile" : "desktop";
                return config;
            }
        };
    }
    app.factory("device", controller);
})();


var $f6a3422ed0430582$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "config",
        "$injector",
        "$q"
    ];
    function controller(_config, $injector, $q) {
        return {
            responseError (rejection) {
                if (rejection.status === 451) $injector.get("$state").go("errors.451");
                return $q.reject(rejection);
            }
        };
    }
    app.factory("errors", controller);
})();


var $978e1aa6c9c68fdc$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        return {
            request (config) {
                if (_config.mobileConfig.mobile && config.meta && config.meta.type === "api") config.headers["x-app-version"] = _config.mobileConfig.version;
                return config;
            }
        };
    }
    app.factory("headers", controller);
})();


var $abb672346b7d4788$exports = {};
(function() {
    app.factory("seon", controller);
    function controller() {
        const seon_session = {};
        const uuid = crypto?.randomUUID?.() || uuidv4();
        seon.config({
            session_id: uuid
        });
        seon.getBase64Session((encodedPayload)=>{
            seon_session.session_id = uuid;
            seon_session.session = encodedPayload;
        });
        function uuidv4() {
            return crypto.getRandomValues ? "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (val)=>(val ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> val / 4).toString(16)) : null;
        }
        return {
            request (config) {
                if (config.meta?.type === "api" && config.method === "POST" && uuid) config.data.seon_session = seon_session;
                return config;
            },
            response (response) {
                return response;
            }
        };
    }
})();


var $2100cea9a87b2ac9$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("splash$", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "splash$",
        "$q",
        "$interval"
    ];
    function controller(_splash$, $q, $interval) {
        let _count = 0;
        let _done = false;
        let i = 0;
        const watcher = $interval(()=>{
            if (_count === 0 && _done === false) {
                i++;
                if (i >= 6) {
                    _done = true;
                    _splash$.next("loaded");
                    $interval.cancel(watcher);
                }
            }
        }, 50);
        return {
            request (config) {
                _count++;
                return config;
            },
            response (response) {
                _count--;
                return response;
            },
            responseError (response) {
                _count--;
                return $q.reject(response);
            }
        };
    }
    app.factory("splash", controller);
})();


$fbeeeb6f4e874f4c$exports = {
    "auth": $a5f17b190db1cbdc$exports,
    "bb": $06f6775189394665$exports,
    "csrf": $9ccfbfcd5da5fb56$exports,
    "device": $ca259a57c55132c0$exports,
    "errors": $f6a3422ed0430582$exports,
    "headers": $978e1aa6c9c68fdc$exports,
    "seon": $abb672346b7d4788$exports,
    "splash": $2100cea9a87b2ac9$exports
};


var $a3636b0244c4438e$exports = {};
(function(t, e) {
    "function" == typeof define && define.amd ? define([], function() {
        return e();
    }) : $a3636b0244c4438e$exports = e();
})(0, function() {
    function t() {
        "use strict";
        function t(t, e) {
            this.name = t, this.isActive = !0, this.tables = {}, this.priority = e || 0;
        }
        function e(t) {
            return Object.prototype.hasOwnProperty.call(a, t);
        }
        function n(t) {
            return angular.isString(t) && "" !== t;
        }
        function r(t) {
            if (!n(t)) throw new TypeError("Invalid type of a first argument, a non-empty string expected.");
            return e(t) && a[t].isActive;
        }
        function i() {
            var t = [];
            for(var e in a)a[e].isActive && t.push(a[e]);
            return t.sort(function(t, e) {
                return t.priority - e.priority;
            }), t;
        }
        t.prototype.parseUrl = function(t, e) {
            return angular.isFunction(t) ? t(this.name, e) : t.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, e);
        }, t.prototype.getTable = function(t, e, n, r, i, a) {
            if (this.tables[t]) return e.when(this.tables[t]);
            var o = this;
            return n(angular.extend({
                method: "GET",
                url: this.parseUrl(i, t)
            }, r)).then(function(e) {
                return o.tables[t] = e.data, e.data;
            }, function(n) {
                return a ? a(o.name, t, n).then(function(e) {
                    return o.tables[t] = e, e;
                }, function() {
                    return e.reject(o.name);
                }) : e.reject(o.name);
            });
        };
        var a = {};
        this.addPart = function(r, i) {
            if (!n(r)) throw new TypeError("Couldn't add part, part name has to be a string!");
            return e(r) || (a[r] = new t(r, i)), a[r].isActive = !0, this;
        }, this.setPart = function(r, i, o) {
            if (!n(r)) throw new TypeError("Couldn't set part.`lang` parameter has to be a string!");
            if (!n(i)) throw new TypeError("Couldn't set part.`part` parameter has to be a string!");
            if ("object" != typeof o || null === o) throw new TypeError("Couldn't set part. `table` parameter has to be an object!");
            return e(i) || (a[i] = new t(i), a[i].isActive = !1), a[i].tables[r] = o, this;
        }, this.deletePart = function(t) {
            if (!n(t)) throw new TypeError("Couldn't delete part, first arg has to be string.");
            return e(t) && (a[t].isActive = !1), this;
        }, this.isPartAvailable = r, this.$get = [
            "$rootScope",
            "$injector",
            "$q",
            "$http",
            function(o, s, u, l) {
                var c = function(t) {
                    if (!n(t.key)) throw new TypeError("Unable to load data, a key is not a non-empty string.");
                    if (!n(t.urlTemplate) && !angular.isFunction(t.urlTemplate)) throw new TypeError("Unable to load data, a urlTemplate is not a non-empty string or not a function.");
                    var e = t.loadFailureHandler;
                    if (void 0 !== e) {
                        if (!angular.isString(e)) throw new Error("Unable to load data, a loadFailureHandler is not a string.");
                        e = s.get(e);
                    }
                    var r = [], a = i();
                    return angular.forEach(a, function(n) {
                        r.push(n.getTable(t.key, u, l, t.$http, t.urlTemplate, e)), n.urlTemplate = t.urlTemplate;
                    }), u.all(r).then(function() {
                        var e = {};
                        return a = i(), angular.forEach(a, function(n) {
                            !function t(e, n) {
                                for(var r in n)n[r] && n[r].constructor && n[r].constructor === Object ? (e[r] = e[r] || {}, t(e[r], n[r])) : e[r] = n[r];
                                return e;
                            }(e, n.tables[t.key]);
                        }), e;
                    }, function() {
                        return u.reject(t.key);
                    });
                };
                return c.addPart = function(r, i) {
                    if (!n(r)) throw new TypeError("Couldn't add part, first arg has to be a string");
                    return e(r) ? a[r].isActive || (a[r].isActive = !0, o.$emit("$translatePartialLoaderStructureChanged", r)) : (a[r] = new t(r, i), o.$emit("$translatePartialLoaderStructureChanged", r)), c;
                }, c.deletePart = function(t, r) {
                    if (!n(t)) throw new TypeError("Couldn't delete part, first arg has to be string");
                    if (void 0 === r) r = !1;
                    else if ("boolean" != typeof r) throw new TypeError("Invalid type of a second argument, a boolean expected.");
                    if (e(t)) {
                        var i = a[t].isActive;
                        if (r) {
                            var u = s.get("$translate").loaderCache();
                            "string" == typeof u && (u = s.get(u)), "object" == typeof u && angular.forEach(a[t].tables, function(e, n) {
                                u.remove(a[t].parseUrl(a[t].urlTemplate, n));
                            }), delete a[t];
                        } else a[t].isActive = !1;
                        i && o.$emit("$translatePartialLoaderStructureChanged", t);
                    }
                    return c;
                }, c.isPartLoaded = function(t, e) {
                    return angular.isDefined(a[t]) && angular.isDefined(a[t].tables[e]);
                }, c.getRegisteredParts = function() {
                    var t = [];
                    return angular.forEach(a, function(e) {
                        e.isActive && t.push(e.name);
                    }), t;
                }, c.isPartAvailable = r, c;
            }
        ];
    }
    return angular.module("pascalprecht.translate").provider("$translatePartialLoader", t), t.displayName = "$translatePartialLoader", "pascalprecht.translate";
});


(function() {
    app.config(controller);
    controller.$inject = [
        "$locationProvider",
        "$translateProvider",
        "$stateProvider",
        "$urlRouterProvider",
        "$sceProvider",
        "$httpProvider",
        "$translatePartialLoaderProvider",
        "config"
    ];
    function controller($locationProvider, $translateProvider, $stateProvider, $urlRouterProvider, $sceProvider, $httpProvider, $translatePartialLoaderProvider, _config) {
        if (!_config.mobileApp) $locationProvider.html5Mode({
            enabled: true
        });
        else $locationProvider.hashPrefix("");
        $urlRouterProvider.otherwise(`/${_config.currentLang}/404`);
        const scrollToTop = [
            "$q",
            "$document",
            ($q, $document)=>{
                const defer = $q.defer();
                $document.scrollTopAnimated(0, 400).then(()=>{
                    defer.resolve({});
                });
                return defer.promise;
            }
        ];
        const resolve_private = [
            "$q",
            "$state",
            function($q, $state) {
                const defer = $q.defer();
                const interval = 50;
                const watcher = setInterval(()=>{
                    if (_config.sessionStatus !== null) {
                        switch(_config.sessionStatus){
                            case true:
                                defer.resolve({});
                                break;
                            case false:
                                if ($state.current.name.length) defer.reject({
                                    code: 400,
                                    reason: "Unauthorized"
                                });
                                else defer.reject({
                                    code: 401,
                                    reason: "Unauthorized"
                                });
                                break;
                        }
                        clearInterval(watcher);
                    }
                }, interval);
                return defer.promise;
            }
        ];
        const get_system_info = [
            "$q",
            function($q) {
                const defer = $q.defer();
                const interval = 50;
                const watcher = setInterval(()=>{
                    if (_config.system_info) {
                        defer.resolve({});
                        clearInterval(watcher);
                    }
                }, interval);
                return defer.promise;
            }
        ];
        const only_unauth = [
            "$q",
            function($q) {
                const defer = $q.defer();
                const interval = 50;
                const watcher = setInterval(()=>{
                    if (_config.sessionStatus !== null) {
                        switch(_config.sessionStatus){
                            case true:
                                defer.reject({
                                    code: 500,
                                    reason: "Authorized"
                                });
                                break;
                            case false:
                                defer.resolve(true);
                                break;
                        }
                        clearInterval(watcher);
                    }
                }, interval);
                return defer.promise;
            }
        ];
        // // redirect
        const redirectIfMobile = [
            "$q",
            function($q) {
                const defer = $q.defer();
                const code = 310;
                defer.reject({
                    code: code,
                    reason: "mobile redirect"
                });
                return defer.promise;
            }
        ];
        const mobileLaunch = [
            "$q",
            function($q) {
                const defer = $q.defer();
                let code = _config.mobileApp ? 307 : 308;
                if (_config.jurisdiction === "spain") code = 309;
                defer.reject({
                    code: code,
                    reason: "mobile launch"
                });
                return defer.promise;
            }
        ];
        const updateCheck = [
            "$q",
            "system",
            function($q, _system) {
                const defer = $q.defer();
                // eslint-disable-next-line angular/window-service
                if (window.$_CONFIG.updateDialogIsShown === true) defer.resolve({});
                else _system.mobile.updateCheck().then((answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.resolve(answer);
                });
                return defer.promise;
            }
        ];
        const authResolver = [
            "$q",
            function($q) {
                const defer = $q.defer();
                const interval = 50;
                const watcher = setInterval(function() {
                    if (_config.sessionStatus === true || _config.sessionStatus === false) {
                        clearInterval(watcher);
                        defer.resolve();
                    }
                }, interval);
                return defer.promise;
            }
        ];
        const rootRouteConfig = {
            abstract: true,
            url: "/{lang:(?:" + _config.languages.join("|") + ")}?activation&restore&lindaanchor",
            resolve: {
                auth: authResolver,
                system_info: get_system_info
            },
            template: "<ui-view></ui-view>",
            params: {
                activation: undefined,
                restore: undefined,
                lindaanchor: undefined
            }
        };
        if (_config.mobileConfig.mobile) rootRouteConfig.resolve.actuality = updateCheck;
        $stateProvider.state("app", rootRouteConfig).state("update", {
            abstract: true,
            template: "<ui-view></ui-view>"
        }).state("errors", {
            url: "/errors",
            template: "<ui-view></ui-view>"
        });
        _config.router.forEach(function(route) {
            const name = route.name;
            delete route.name;
            route.resolve = route.resolve || {};
            if (route.private === true) route.resolve.private = resolve_private;
            if (route.onlyUnauth === true) route.resolve.onlyUnauth = only_unauth;
            if (route.scrollToTop === true) route.resolve.scrollToTop = scrollToTop;
            if (route.gamePage === true && (_config.device.mobile === true || _config.mobileApp === true)) {
                if (route.params && route.params.redirectIfMobile && route.params.redirectIfMobile.length > 0) route.resolve.redirectIfMobile = redirectIfMobile;
                else route.resolve.launch = mobileLaunch;
            }
            $stateProvider.state(name, route);
        });
        if (_config.mobileConfig.mobile) $httpProvider.interceptors.push("errors");
        $httpProvider.interceptors.push("splash");
        $httpProvider.interceptors.push("auth");
        $httpProvider.interceptors.push("headers");
        $httpProvider.interceptors.push("device");
        $httpProvider.interceptors.push("bb");
        $httpProvider.interceptors.push("seon");
        $sceProvider.enabled(false);
        $translatePartialLoaderProvider.addPart("main");
        const translationCategory = _config.project ? `?category=${_config.project}` : ``;
        const urlTemplate = _config.locale === "" ? _config.apiUrl + `/{lang}/api/${_config.apiVersion}/lang/translation${translationCategory}` : _config.locale;
        $translateProvider.useLoader("$translatePartialLoader", {
            urlTemplate: urlTemplate
        });
    }
})();


var $1910f7081cd4965b$exports = {};
(function() {
    app.getTU = function(name) {
        return $_TEMPLATES[name] || "";
    };
    app.getCC = function(mc, wc) {
        return $_CONFIG.mobileApp ? mc : wc;
    };
})();


var $92d53d37ef55f11c$exports = {};
/* eslint-disable angular/on-watch */ 



(function() {
    "use strict";
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        const api = {
            version: "v1",
            avatarList: "/avatar/list",
            trustlyInit: "/ident/init",
            trustlyAuth: "/ident/auth",
            trustlyStatus: "/ident/status",
            trustlyData: "/ident/data",
            bankInit: "/ident/init",
            bankAuth: "/ident/auth",
            bankLookup: "/ident/lookup",
            fulfillmentInfo: "/ident/user_info",
            userLogin: "/account/login",
            userLogout: "/account/logout",
            userInfo: "/account/info",
            userPing: "/account/ping",
            userEdit: "/account/update",
            userRegister: "/account/register",
            userRestore: "/account/restore",
            userChangePass: "/account/change_password",
            userBonus: "/account/bonus",
            userAvBonus: "/account/available_bonus",
            userChangeLimit: "/account/limits",
            userRemoveLimit: "/account/remove_limit",
            sessionLength: "/account/session_limit",
            userExclusion: "/account/exclusion",
            userClosure: "/account/close",
            userWin: "/account/last_win",
            userMultiLimits: "/account/multi_limits",
            userTermsChanged: "/account/accept_terms_and_conditions",
            userRefreshSession: "/account/refresh_session",
            userUpdateRequiredFields: "/account/update_required_fields",
            userUpdateOptionalFields: "/account/update_optional_fields",
            userBalanceDetails: "/account/balance_details",
            userSymplifyHash: "/account/symplify_hash",
            userTwoFactor: "/account/two_factor_auth",
            userTwoFactorEnable: "/account/two_factor_auth/code",
            userTwoFactorDisable: "/account/two_factor_auth/disable",
            userDocumentList: "/account/document_list",
            userYearReport: "/account/year_report",
            userNewlyBonuses: "/account/newly_assigned_bonuses",
            userSetMask: "/account/set_mask",
            userDKCoolingOff: "/account/cool_off_limit",
            userDKRealitySettings: "/account/reality_check",
            userSVRealitySettings: "/account/reality_check",
            userSVTokenRestore: "/account/restore_sv_token",
            userQuestions: "/secret_question/list",
            achievements: "/achievement/list",
            achievementItem: "/achievement/item",
            achievementTake: "/achievement/take",
            achievementInProgress: "/achievement/in_progress",
            achievementLastEarned: "/achievement/last_earned",
            achievementListProductCollections: "/achievement/list_product_collections",
            collectionList: "/collection/list",
            collectionHall: "/collection/hall",
            categoryList: "/category/list",
            shopItems: "/shop/list",
            shopBuy: "/shop/buy",
            subscriptionList: "/subscription/list",
            subscriptionChange: "/subscription/unsubscribe",
            jackpotLatest: "/jackpot/latest",
            userRestorePassword: "/account/change_password_by_token",
            userRecoveryLogin: "/account/recovery_login",
            userBonusActivate: "/account/bonus_activate",
            userResetBonus: "/account/bonus_reset",
            userActivateMail: "/account/activate",
            userResendActivationCode: "/account/reactivate",
            userPasswordReset: "/account/reset_password",
            validateUserData: "/account/validate_user_data",
            infoblock: "/infoblock/",
            infoblockReward: "/infoblock/reward",
            infoblockWin: "/infoblock/win",
            bannerList: "/banner/list",
            maskCollectionList: "/mask_collection/list",
            maskCollectionItem: "/mask_collection/list",
            maskCollectionGrab: "/mask_collection/grab",
            maskCollectionBuy: "/mask_collection/buy",
            gameItem: "/game/item/",
            gameList: "/game/list",
            gameLaunch: "/game/launch",
            gameWinners: "/game/winners",
            gameCheck: "/game/check",
            gameRecentlyPlayed: "/account/last_game",
            gameToggleFav: "/favorites/toggle",
            gameSearch: "/game/search",
            gameCloseSession: "/game/close_game_session",
            sportLaunch: "/sport/launch",
            sportFeed: "/game-events-feed/feed",
            sportCheck: "/sport/check",
            lottoLaunch: "/lotto/launch",
            promoList: "/promo/list",
            promoItem: "/promo/item",
            luckyWinnerDaily: "/lucky-winner/daily",
            promocodeActivate: "/promocode/activate",
            holidayList: "/holidays/list",
            holidayProgress: "/promo/progress",
            holidayPromoStart: "/promo/start_level",
            holidayPromoComplete: "/promo/complete_level",
            optInSubscription: "/opt-in/subscription",
            partners: "/partner/list",
            icons: "/icon/list",
            seoItem: "/seo/item",
            pageItem: "/page/item/",
            pageList: "/page/list",
            pSystemCollection: "/paysystem/available",
            pSystemIcons: "/paysystem/icons",
            pSystemList: "/paysystem/list",
            pHistory: "/payment/history",
            pDeposit: "/payment/deposit",
            pWithdraw: "/payment/withdraw",
            pWCancel: "/payment/withdrawcancel",
            pPromoCode: "/payment/promocode",
            checkPayment: "/payment/status",
            pExchange: "/payment/loyalty_exchange",
            pInterac: "/payment/interac_details",
            pLastDevcodeDep: "/payment/quick_deposit",
            historyPaysystems: "/history/paysystems",
            pgwInit: "/payment/init_widget",
            pAuth: "/payment/auth",
            menuList: "/menu/list",
            providerList: "/brand/list",
            countryList: "/geo/countries",
            tournamentList: "/tournament/list",
            tournamentItem: "/tournament/item/",
            fastTournamentList: "/tournament/fast_list",
            fastTournamentHistory: "/tournament/fast_history",
            fastTournamentSubscribe: "/tournament/fast_subscribe",
            fastTournamentGetLeaderboard: "/tournament/fast_leaderboard/",
            dataCarPromo: "/tournament/tournament_promo_state",
            leaderBoardCarPromo: "/tournament/tournament_promo_leaderboard",
            systemMirrors: "/system/mirrors",
            systemInfo: "/system/info",
            nationalityList: "/nationality/list",
            professionList: "/profession/list",
            historyBet: "/history/bet",
            historyBetGame: "/history/game",
            historyBalanceFlow: "/history/balance_flow",
            history: "/history/",
            historyLastDep: "/history/payment_last",
            articleItem: "/article/item",
            vipList: "/level/list",
            christmas: "/christmas/list",
            christmasCards: "/christmas/game_cards",
            christmasGameResult: "/christmas/result",
            easterDaysList: "/easter/list",
            easterGameStart: "/easter/start",
            easterEggFound: "/easter/finish",
            halloweenWheel: "/wof/gifts",
            halloweenCalendar: "/wof/days",
            halloweenSpin: "/wof/spin",
            worldCupCalendar: "/promo/cup",
            sportTeam: "/collection/team",
            sportSquad: "/collection/squad",
            sportCard: "/collection/card",
            gameLevel: "/levels/game_levels",
            dashboard: "/dashboard/list",
            // todo add real link
            abandonedRegistration: "/abandoned-registration",
            collectRegistrationAnalytics: "/account/analitics",
            // Shooting
            shootingGifts: "/shooting/gifts",
            shootingShoot: "/shooting/shot",
            termsItem: "/terms/item",
            // ===================== MOBILE APP =====================
            currentVersion: "/system/mobile_version",
            // ===================== SWEDEN =========================
            // ===================== PORTUGAL =========================
            ptGameSessionInfo: "/game/last_session_summary",
            ptUserExclusion: "/account/exclusion",
            ptUserCancelLimit: "/account/cancel_limits",
            additionalFields: "/account/additional_fields/schema",
            playgroundsList: "/playground/list",
            playgroundsBuy: "/playground/buy",
            playgroundsAssignCityReward: "/playground/assign_city_reward",
            wallOfWins: "/wall_of_wins/list",
            // ===================== Notifications center =====================>
            notificationsSettings: "/notification-center/notification_settings",
            notificationsList: "/notification-center/notification",
            // zendesk to back
            infoToZendesk: "/account/send_additional_info_to_zendesk",
            // mga limits
            mgaDepositLimit: "/account/mga_limits_deposit",
            mgaSessionLimit: "/account/mga_limits_session",
            mgaLossesLimit: "/account/mga_limits_losses",
            mgaSessionLimitContinue: "/account/mga_limits_session_continue",
            mgaSelfExclusion: "/account/mga_limits_self_exclude",
            mgaClosure: "/account/mga_limits_closure",
            mgaWagerLimit: "/account/mga_limits_wager",
            // ===================== Document verification service =====================>
            documentVerificationUploadOptions: "/verification-documents/upload-options",
            documentVerificationUploadFile: "/verification-documents/upload_file",
            documentVerificationUploadDone: "/verification-documents/upload-done",
            documentVerificationRequestedDocumentsList: "/verification-documents/requested-documents-list",
            documentVerificationUploadedDocuments: "/verification-documents/uploaded-documents",
            // survey
            surveyList: "/survey/list",
            // v3
            documentVerificationDocuments: "/verification/documents",
            extendedTournamentItem: "/tournament-extended/item/",
            extendedTournamentList: "/tournament-extended/list",
            // balance flow v3
            balanceFlow: "/balances/history",
            balanceFlowFilters: "/balances/history/filters",
            balanceFlowItem: "/balances/history/action",
            // balance flow v2
            balanceFlowV2: "/history/list",
            balanceFlowFiltersV2: "/history/filters",
            balanceFlowItemV2: "/history/item",
            paymentDetails: "/payment/transaction_details",
            balanceHistory: "/history/balance_history",
            balanceHistoryFilters: "/history/balance_history_filters",
            // ====== Romanian Limits ====== //
            accountLimitsList: "/account/limit/list",
            accountLimitDeposit: "/account/limit/deposit",
            accountLimitLosses: "/account/limit/losses",
            // ====== Otp verification ====== //
            otpSmsVerify: "/otp/sms_verify_send",
            otpVerifyCode: "/otp/verify_code",
            // ====== Entity info with brand feature flags, like: FunId ====== //
            entityInfo: "/entity/info",
            footer: "/footer/item",
            footerVerify: "/footer/verify",
            affiliateInfo: "/affiliate/info"
        };
        api.ask = function(alias) {
            return `${_config.apiUrl}/${_config.currentLang}/api/${_config.apiVersion}${api[alias]}`;
        };
        return api;
    }
    app.factory("api", controller);
})();



(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("notification$", controller);
})();



(function() {
    "use strict";
    controller.$inject = [
        "$http",
        "api",
        "$q",
        "notification$",
        "system$",
        "$window",
        "$httpParamSerializer"
    ];
    function controller($http, _api, $q, _notification$, _system$, $window, $httpParamSerializer) {
        function parseMessages(arr) {
            if (typeof arr !== "undefined") arr.forEach((item)=>{
                _notification$.next(item);
            });
        }
        function sessionDead(response) {
            if (response.status === 403 || response.status === 401) _system$.next({
                action: "forced logout"
            });
        }
        function removeEmptyParams(params) {
            const result = {};
            Object.entries(params).map(([key, value])=>{
                if (value) result[key] = value;
            });
            return result;
        }
        function Cache(name) {
            this.prefix = name;
            this.get = (url)=>{
                let r = {};
                try {
                    r = JSON.parse($window.localStorage.getItem(`${this.prefix}-${url}`));
                } catch (e) {
                //
                }
                return r;
            };
            this.set = (url, data)=>{
            // -$window.localStorage.setItem( `${this.prefix}-${url}`, JSON.stringify( data ) );
            };
        }
        const cache = new Cache("linda-cache-v1");
        return {
            get (alias, config) {
                const defer = $q.defer();
                const url = typeof alias === "object" ? `${_api.ask(alias.name)}${alias.param}` : _api.ask(alias);
                if (config.meta) {
                    // api as request type by default
                    if (config.meta.type === undefined) config.meta.type = "api";
                    if (config.meta.absenceEmptyParams) config.params = removeEmptyParams(config.params);
                    // get from inapp cache if configured
                    if (config.meta.cache === true && config.meta.bullshit === true) {
                        const answer = cache.get(`${url}?${$httpParamSerializer(config.params)}`);
                        if (answer) defer.resolve(answer);
                    }
                }
                $http.get(url, config).then((answer)=>{
                    cache.set(`${answer.config.url}?${$httpParamSerializer(answer.config.params)}`, {
                        data: answer.data
                    });
                    parseMessages(answer.data?.messages);
                    defer.resolve(answer);
                }, (answer)=>{
                    sessionDead(answer);
                    parseMessages(answer.data?.messages);
                    defer.reject(answer);
                });
                return defer.promise;
            },
            post (alias, data, config) {
                const defer = $q.defer();
                const url = typeof alias === "object" ? `${_api.ask(alias.name)}/${alias.param}` : _api.ask(alias);
                if (config.meta && config.meta.type === undefined) config.meta.type = "api";
                $http.post(url, data, config).then((answer)=>{
                    parseMessages(answer.data?.messages);
                    defer.resolve(answer);
                }, (answer)=>{
                    sessionDead(answer);
                    parseMessages(answer.data?.messages);
                    defer.reject(answer);
                });
                return defer.promise;
            },
            put (alias, data, config) {
                const defer = $q.defer();
                const url = _api.ask(alias);
                if (config.meta && config.meta.type === undefined) config.meta.type = "api";
                $http.put(url, data, config).then((answer)=>{
                    parseMessages(answer.data?.messages);
                    defer.resolve(answer);
                }, (answer)=>{
                    sessionDead(answer);
                    parseMessages(answer.data?.messages);
                    defer.reject(answer);
                });
                return defer.promise;
            },
            delete (alias, config) {
                const defer = $q.defer();
                const url = _api.ask(alias);
                const headers = {
                    "Content-Type": "application/json"
                };
                if (config.meta && config.meta.type === undefined) config.meta.type = "api";
                if (config.data) config.headers = headers;
                $http.delete(url, config).then((answer)=>{
                    parseMessages(answer.data?.messages);
                    defer.resolve(answer);
                }, (answer)=>{
                    sessionDead(answer);
                    parseMessages(answer.data?.messages);
                    defer.reject(answer);
                });
                return defer.promise;
            },
            getData (alias, params, cache) {
                const defer = $q.defer();
                const config = {
                    cache: cache || false,
                    meta: {
                        type: "api",
                        alias: alias
                    },
                    params: params
                };
                this.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            postData (alias, params, data, cache) {
                const defer = $q.defer();
                const config = {
                    cache: cache || false,
                    meta: {
                        type: "api",
                        alias: alias
                    },
                    params: params
                };
                this.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("http", controller);
})();




var $jTg1q = parcelRequire("jTg1q");


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        const body = document.querySelector("body");
        return (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(body, "keyup");
    }
    app.factory("keyup$", controller);
})();



(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("contentBuffer$", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "contentBuffer$"
    ];
    function controller(_contentBuffer$) {
        const bucket = {
            popup: null,
            modal: null
        };
        return {
            write (name, content) {
                bucket[name] = content;
                _contentBuffer$.next({
                    name: name,
                    content: content
                });
            },
            clear (name) {
                bucket[name] = null;
            },
            read (name) {
                return bucket[name] || null;
            }
        };
    }
    app.factory("contentBuffer", controller);
})();





(function() {
    "use strict";
    function parseEventParams(category, action, label) {
        if (!category || !action) return {};
        if (label && angular.isString(label) && [
            "click_button",
            "no_label"
        ].includes(label.toLowerCase())) label = undefined;
        else if (label && typeof label === "object") label = undefined;
        return {
            Category: category,
            Action: action,
            Label: label
        };
    }
    class Analytics {
        /* eslint-disable */ /**
     * @param {Function} engine - actual analytics sender
     * @param {string} label - label to create a namespace within a single application
     * */ /* eslint-enable */ constructor(global, _user$){
            if (!global) return;
            this.global = global;
            this.actionType = "send";
            this.userId = null;
            _user$.subscribe((user)=>{
                this.userId = user.status ? user.profile.account_id : null;
            });
        }
        send(...details) {
            if (!this.global) return;
            try {
                this.sendToDataLayer({
                    ...parseEventParams(...details),
                    event: "autoEvent",
                    userId: this.userId
                });
            } catch (e) {
                if (window.Sentry) window.Sentry.captureException(e);
            }
        }
        sendToDataLayer(event) {
            if (!this.global) return;
            this.global.dataLayer?.push(event);
        }
    }
    AnalyticsFactory.$inject = [
        "config",
        "$window",
        "user$"
    ];
    // eslint-disable-next-line valid-jsdoc
    /** @return {Analytics} */ function AnalyticsFactory(appConfig, globalObject, _user$) {
        // const isAvailable = typeof globalObject.ga === "function";
        const isConfigured = appConfig.googleAnalytics && appConfig.googleAnalytics.appId;
        if (!globalObject || !isConfigured) return new Analytics();
        if (!globalObject.dataLayer) globalObject.dataLayer = [];
        // const { appId, trackAs = "analyticsTracker" } = appConfig.googleAnalytics;
        return new Analytics(globalObject, _user$);
    }
    app.factory("analytics", AnalyticsFactory);
})();


(function() {
    "use strict";
    app.factory("analyticsEvents", controller);
    function controller() {
        return {
            registrationSuccess: "registration_form_success",
            registrationFail: "registration_form_failure",
            registrationComplete: "registration_form_completed",
            loginSuccess: "login_form_success",
            loginFail: "login_form_failure",
            zimplerAuthSuccess: "zimpler_authorization_success",
            zimplerAuthFail: "zimpler_authorization_failure",
            bankidAuthSuccess: "bankid_authorization_success",
            bankidAuthFail: "bankid_authorization_failure",
            registerPopup: "Register_Popup",
            createAccountButton: "ClickCreateAccountButton",
            popupOpen: "Popup_Open",
            popupClose: "Popup_Close",
            modalOpen: "Modal_Open",
            balanceFTD: "balance_ftd",
            balanceDeposit: "balance_deposit",
            recoveryFormSuccess: "recovery_form_success",
            recoveryFormFail: "recovery_form_failure",
            recoveryRequestSuccess: "recovery_request_success",
            recoveryRequestFail: "recovery_request_failure",
            gameLaunchSuccess: "Game_Launch_Success",
            gameLaunchFail: "Game_Launch_Failure",
            SwMirrorRedirect: "swMirror_redirect"
        };
    }
})();


(function() {
    "use strict";
    app.factory("modal", controller);
    controller.$inject = [
        "$q",
        "$templateCache",
        "contentBuffer",
        "analytics",
        "analyticsEvents"
    ];
    function controller($q, $templateCache, _contentBuffer, analytics, _analyticsEvents) {
        let _answer = null;
        let _defer = {};
        let _name = "";
        const modal = {};
        const _h = document.querySelector("html");
        modal.open = function(name, data) {
            const d = data || {};
            _name = name;
            _defer = $q.defer();
            _contentBuffer.write("modal", JSON.parse(JSON.stringify(d)) || null);
            if (!$templateCache.get(modal.template)) {
                console.warn(`no such modal template: ${_name}`);
                _name = "";
                _defer.reject();
            } else {
                document.activeElement?.blur();
                _h.classList.add("linda-has-modal");
            }
            analytics.send(_analyticsEvents.modalOpen, name, "No_Label", {
                nonInteraction: true
            });
            return _defer.promise;
        };
        Object.defineProperty(modal, "current", {
            set (val) {},
            get () {
                return _name;
            }
        });
        Object.defineProperty(modal, "template", {
            set (val) {},
            get () {
                return _name === "" ? "" : `/${_name}-modal.html`;
            }
        });
        Object.defineProperty(modal, "answer", {
            set (val) {
                let data = {};
                if (typeof val === "object") {
                    data = val.data;
                    val = val.answer;
                }
                _answer = val;
                switch(val){
                    case true:
                        _defer.resolve(data);
                        break;
                    case false:
                        _defer.reject(data);
                        break;
                    default:
                        _defer.reject(data);
                        break;
                }
                //                _contentBuffer.clear( 'modal' );
                _name = "";
                _h.classList.remove("linda-has-modal");
            },
            get () {
                return _answer;
            }
        });
        return modal;
    }
})();





(function() {
    "use strict";
    controller.$inject = [
        "$templateCache",
        "keyup$",
        "$timeout",
        "contentBuffer",
        "modal",
        "analytics",
        "analyticsEvents"
    ];
    function controller($templateCache, _keyup$, $timeout, _contentBuffer, _modal, analytics, _analyticsEvents) {
        const _b = document.querySelector("body");
        const _h = document.querySelector("html");
        let _current = null;
        const popup = {
            changed () {},
            set current (value){
                if (value !== null) {
                    const template = `/${value}-popup.html`;
                    if ($templateCache.get(template)) $timeout(()=>{
                        _current = value;
                        _h.classList.add("linda-has-popup");
                        _b.style.overflow = "hidden";
                        _h.style.overflow = "hidden";
                    });
                    else console.warn(`no such popup template: ${template}`);
                } else $timeout(()=>{
                    _current = null;
                    _h.classList.remove("linda-has-popup");
                    _b.style.overflow = "";
                    _h.style.overflow = "";
                });
            },
            get current () {
                return _current === null ? "" : `/${_current}-popup.html`;
            },
            cb: null
        };
        popup.open = function(data) {
            const content = data.content || {};
            _contentBuffer.write("popup", JSON.parse(JSON.stringify(content)) || null);
            popup.cb = typeof data.cb === "function" ? data.cb : null;
            popup.current = data.name;
            analytics.send(_analyticsEvents.popupOpen, data.name, "No_Label", {
                nonInteraction: true
            });
        };
        popup.close = function() {
            _contentBuffer.clear("popup");
            popup.current = null;
        };
        popup.has = function(name) {
            const template = `/${name}-popup.html`;
            return $templateCache.get(template);
        };
        _keyup$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((e)=>e.keyCode === 27)).subscribe((data)=>{
            if (_modal.template === "") $timeout(()=>{
                popup.close();
            });
        });
        return popup;
    }
    app.factory("popup", controller);
})();




/**
 *
 *
 *
 *
 */ (function() {
    "use strict";
    controller.$inject = [
        "$document",
        "config",
        "$state",
        "popup",
        "remembered"
    ];
    function controller($document, _config, $state, _popup, _remembered) {
        const readyToRedirectAfterAuth$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        return {
            readyToRedirectAfterAuth$: readyToRedirectAfterAuth$,
            previous: {
                name: null,
                params: null
            },
            history: [],
            get (alias) {
                return _config.aliases[alias] ? _config.aliases[alias] : null;
            },
            goback () {
                const self = this;
                self.history.pop();
                $state.go(self.history[self.history.length - 1], self.previous.params);
            },
            goToAuthorization () {
                const authAlias = _remembered.login ? "login" : "registration";
                this.goto(authAlias);
            },
            goto (alias, params) {
                const aliasData = structuredClone(_config.aliases[alias]);
                if (!aliasData) {
                    console.error(`!Alias ${alias}`);
                    return;
                }
                if (aliasData.name === "bankid") {
                    const bankIdElement = $document[0].querySelector("bsc-auth-bank-id");
                    bankIdElement.openDialog();
                    return;
                }
                if (!aliasData.page) {
                    const popupContent = Object.assign({}, aliasData.content, params);
                    _popup.open({
                        name: aliasData.name,
                        content: popupContent
                    });
                    return;
                }
                aliasData.params = params || aliasData.params || null;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($jTg1q))).isObject(aliasData.params) && !aliasData.params.lang) aliasData.params.lang = _config.currentLang;
                _popup.close();
                $state.go(aliasData.name, aliasData.params);
            }
        };
    }
    app.factory("state", controller);
})();





(function() {
    /** A fallback implementation if BeaconAPI isn't available*/ class HttpFallback {
        constructor(http){
            this.http = http;
        }
        /**
     * @param {string | Object} alias
     * @param {Object} payload
     * @return {Promise} */ send(alias, payload) {
            return this.http.post(alias, payload, {
                meta: {
                    alias: alias
                }
            });
        }
    }
    /** BeaconAPI a lightweight api to log useful data.
   * It doesn't wait for a response so  api calls could be scheduled even if browser tab is closed;
   * https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
   * */ class BeaconAPI {
        constructor(api, sendBeacon){
            this.api = api;
            this.sendBeacon = sendBeacon;
        }
        /**
     * @param {string | Object} alias
     * @param {Object} payload
     * @return {Object} */ send(alias, payload) {
            const url = typeof alias === "object" ? `${this.api.ask(alias.name)}${alias.param}` : this.api.ask(alias);
            const body = this.toFormData(payload);
            return this.sendBeacon(url, body);
        }
        /**
     * @param {Object} body
     * @return {FormData}  */ toFormData(body) {
            const pairs = Object.entries(body || {});
            return pairs.reduce((formData, [key, value])=>{
                formData.append(key, value);
                return formData;
            }, new FormData());
        }
    }
    beaconAPIController.$inject = [
        "http",
        "$window",
        "api"
    ];
    function beaconAPIController(http, globalWindow, api) {
        if (angular.isFunction(globalWindow.navigator.sendBeacon)) return new BeaconAPI(api, (...args)=>globalWindow.navigator.sendBeacon(...args));
        return new HttpFallback(http);
    }
    app.factory("beaconAPI", beaconAPIController);
})();





(function() {
    "use strict";
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        return {
            update (rules) {
                if (!rules || !rules.version) return false;
                const currentVersion = parseInt(_config.mobileConfig.version.replace(/\./g, "")) || 0;
                const newVersion = parseInt(rules.version.replace(/\./g, "")) || 0;
                const isUpdate = newVersion > currentVersion;
                return isUpdate;
            }
        };
    }
    app.factory("version", controller);
})();




(function() {
    "use strict";
    app.factory("trustly.config", controller);
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        const config = typeof _config.paynplay === "object" ? _config.paynplay : {
            curacao: {
                fi: {
                    enabled: true,
                    min: 20,
                    max: 10000,
                    default: 100,
                    range: [
                        50,
                        100,
                        250
                    ],
                    currency: "EUR",
                    locale: "fi_FI"
                }
            },
            malta: {
                fi: {
                    enabled: true,
                    min: 20,
                    max: 10000,
                    default: 100,
                    range: [
                        50,
                        100,
                        250
                    ],
                    currency: "EUR",
                    locale: "fi_FI"
                }
            },
            sweden: {
                enabled: true,
                min: 100,
                max: 50000,
                default: 500,
                range: [
                    1000,
                    2000,
                    5000
                ],
                currency: "SEK",
                locale: "sv_SE"
            }
        };
        let result;
        switch(_config.jurisdiction){
            case "sweden":
                result = config.sweden;
                break;
            case "curacao":
            case "malta":
                result = config[_config.jurisdiction]?.[_config.currentLang] || {
                    enabled: false
                };
                break;
            case "germany":
                result = config.germany ? config.germany[_config.currentLang] : {
                    enabled: false
                };
                break;
            default:
                result = {
                    enabled: false
                };
                break;
        }
        return result;
    }
})();


/**
 *
 *
 *          countries()
 *
 *
 */ (function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "$state",
        "version",
        "config",
        "trustly.config",
        "$http",
        "localStorage",
        "$window"
    ];
    function controller(_http, $q, $state, _version, _config, _trustly_config, $http, _localStorage, $window) {
        return {
            mode: {
                paynplay: _trustly_config.enabled
            },
            systemInfo: {},
            info () {
                const defer = $q.defer();
                const alias = "systemInfo";
                const config = {
                    params: {},
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                const testDate = $window.localStorage.getItem("test-date") || "";
                if (testDate.length) config.params.today = testDate;
                _http.get(alias, config).then(({ data: data })=>{
                    this.systemInfo = data.result;
                    defer.resolve(data);
                }).catch((error)=>defer.reject(error));
                return defer.promise;
            },
            getSystemInfo () {
                if (Object.keys(this.systemInfo).length === 0) return this.info().then((info)=>{
                    return info.result;
                });
                return new Promise((resolve)=>resolve(this.systemInfo));
            },
            questions () {
                const defer = $q.defer();
                const alias = "userQuestions";
                const config = {
                    params: {},
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            mobile: {
                currentVersion () {
                    const defer = $q.defer();
                    const alias = "currentVersion";
                    const config = {
                        params: {},
                        cache: true,
                        meta: {
                            type: "api",
                            alias: alias
                        }
                    };
                    _http.get(alias, config).then((answer)=>{
                        defer.resolve(answer.data);
                    }, (answer)=>{
                        defer.reject(answer.data);
                    });
                    return defer.promise;
                },
                updateCheck () {
                    const defer = $q.defer();
                    const alias = "currentVersion"; // todo: need new method
                    const config = {
                        params: {
                        },
                        cache: true,
                        meta: {
                            type: "api",
                            alias: alias
                        }
                    };
                    _http.get(alias, config).then((answer)=>{
                        if (_version.update(answer.data.result[_config.mobileConfig.platform])) $state.go("update.home", {
                            params: answer.data.result[_config.mobileConfig.platform]
                        });
                        else defer.resolve(answer.data);
                    }, (answer)=>{
                        defer.reject(answer.data);
                    });
                    return defer.promise;
                }
            },
            countries () {
                const defer = $q.defer();
                const alias = "countryList";
                const affiliateParams = _localStorage.getAffiliateData();
                const config = {
                    params: {
                        limit: 1000,
                        ...affiliateParams
                    },
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then(function(answer) {
                    defer.resolve(answer.data);
                }, function(answer) {
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            avatars () {
                const defer = $q.defer();
                const alias = "avatarList";
                const config = {
                    params: {
                        limit: 1000
                    },
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then(function(answer) {
                    defer.resolve(answer.data);
                }, function(answer) {
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            json (options) {
                const defer = $q.defer();
                $http.get(options.url).then((answer)=>{
                    defer.resolve(answer.data);
                }).catch((error)=>{
                    defer.reject(error);
                });
                return defer.promise;
            },
            nationality () {
                const defer = $q.defer();
                const alias = "nationalityList";
                const config = {
                    params: {
                        limit: 1000
                    },
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            professions () {
                const defer = $q.defer();
                const alias = "professionList";
                const config = {
                    params: {
                        limit: 1000
                    },
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            document_list (options) {
                const defer = $q.defer();
                const alias = "userDocumentList";
                const config = {
                    params: {
                        limit: 1000,
                        ...options
                    },
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("system", controller);
})();


class $c11b0e31861c182a$export$46c0f1055fa48b27 {
    constructor(){
        if (!$_CDN.recaptcha?.sdk) throw new Error("GoogleCaptcha sdk is required.");
        if (!$_CDN.recaptcha?.key) throw new Error("GoogleCaptcha key is required.");
        this.sdk = $_CDN.recaptcha?.sdk;
        this.key = $_CDN.recaptcha?.key;
    }
    addStyles() {
        const styleElement = document.createElement("style");
        styleElement.innerHTML = ".grecaptcha-badge{ visibility: hidden;}";
        document.body.append(styleElement);
    }
    addScriptInDom(url) {
        const scriptRecaptcha = document.createElement("script");
        scriptRecaptcha.src = url;
        document.body.appendChild(scriptRecaptcha);
        this.addStyles();
    }
    init() {
        this.addScriptInDom(`${this.sdk}?render=${this.key}`);
    }
    execute(action = "noAction") {
        if (window.grecaptcha) return new Promise((resolve, reject)=>{
            return window.grecaptcha.ready(()=>{
                window.grecaptcha.execute(this.key, {
                    action: action
                }).then((token)=>{
                    resolve({
                        "g-recaptcha-response": token
                    });
                }).catch(reject);
            });
        });
    }
}


class $80dff33dfa03b5c9$export$42121f75c18d6c38 {
    constructor(){
        if (!$_CDN.cfRecaptcha?.key) throw new Error("CloudflareCaptcha key is required.");
        if (!$_CDN.cfRecaptcha?.sdk) throw new Error("CloudflareCaptcha sdk is required.");
        this.key = $_CDN.cfRecaptcha?.key;
        this.url = $_CDN.cfRecaptcha?.sdk;
    }
    captchaExecuted = false;
    elementId = "cf-captcha";
    addTurnstileElement() {
        const container = document.createElement("div");
        container.id = this.elementId;
        container.style.position = "absolute";
        container.style.left = "-9999px";
        container.style.display = "none";
        document.body.append(container);
    }
    addScriptInDom(url) {
        const scriptRecaptcha = document.createElement("script");
        scriptRecaptcha.src = url;
        document.head.appendChild(scriptRecaptcha);
        this.addTurnstileElement();
    }
    init() {
        this.addScriptInDom(this.url);
    }
    execute(action = "noAction") {
        if (window.turnstile) return new Promise((resolve)=>{
            if (this.captchaExecuted) turnstile.reset();
            turnstile.execute(`#${this.elementId}`, {
                sitekey: `${this.key}`,
                action: action,
                appearance: "interaction-only",
                "response-field": false,
                retry: "never",
                "refresh-expired": "never",
                callback: (token)=>{
                    this.captchaExecuted = true;
                    resolve({
                        "captcha-response": token
                    });
                }
            });
        });
    }
}


const $08bd8e19389d82c1$var$serviceName = "captcha";
class $08bd8e19389d82c1$var$Captcha {
    static $inject = [
        "system"
    ];
    constructor(system){
        this.system = system;
    }
    defaultCaptcha = "cloudflare";
    captchaFallbackToken = "fallbackToken";
    init() {
        this.system.getSystemInfo().then((info)=>{
            if (!info.captcha_strategies || info.captcha_strategies.length === 0) {
                this.type = "google";
                return this.create("google");
            }
            if (info.captcha_strategies.length > 1) {
                this.type = this.defaultCaptcha;
                return this.create(this.defaultCaptcha);
            }
            this.type = info.captcha_strategies[0];
            return this.create(info.captcha_strategies[0]);
        });
    }
    create(captcha) {
        if (captcha === "cloudflare") this.captcha = new (0, $80dff33dfa03b5c9$export$42121f75c18d6c38)();
        if (captcha === "google") this.captcha = new (0, $c11b0e31861c182a$export$46c0f1055fa48b27)();
        this.captcha.init();
    }
    sendFallbackToken() {
        return new Promise((resolve, reject)=>{
            if (this.type === "google") return resolve({
                "g-captcha-token": this.captchaFallbackToken
            });
            if (this.type === "cloudflare") return resolve({
                "captcha-token": this.captchaFallbackToken
            });
        });
    }
    execute(action) {
        if (this.captcha) return this.captcha.execute(action);
        return this.sendFallbackToken();
    }
}
app.factory($08bd8e19389d82c1$var$serviceName, $08bd8e19389d82c1$var$Captcha);




(function() {
    class HotjarHeatmap {
        /**
     * @param {Function} engine - heatmap engine
     * */ constructor(engine){
            this.engine = engine;
        }
        /** heatmap data collection
     * @param {string} event - an event that triggers heatmap collection
     * */ trigger(event) {
            this.engine("trigger", event);
        }
        /** hotjar analytics
     * @param {string} type - type 'event' or 'identify'
     * @param {string|number} value - value string 'event value' or number 'id'
     * */ sendEvent(type, value) {
            this.engine(type, value);
        }
    }
    heatmapController.$inject = [
        "config"
    ];
    // eslint-disable-next-line valid-jsdoc
    /** @return {HotjarHeatmap} */ function heatmapController(appConfig) {
        if (!(appConfig.hotjar && appConfig.hotjar.customHeatMapEnabled)) return new HotjarHeatmap(()=>{});
        const engine = (...args)=>{
            try {
                return hj(...args);
            } catch (e) {
            //
            }
        };
        return new HotjarHeatmap(engine);
    }
    app.factory("heatmap", heatmapController);
})();




(function() {
    "use strict";
    controller.$inject = [
        "user",
        "http",
        "$q",
        "config",
        "state",
        "popup",
        "beaconAPI",
        "analytics",
        "captcha",
        "analyticsEvents",
        "heatmap",
        "localStorage",
        "sentry",
        "$cookies",
        "$window"
    ];
    function controller(_user, _http, $q, _config, _state, _popup, beaconAPI, analytics, _captcha, _analyticsEvents, _heatmap, _localStorage, sentry, $cookies, $window) {
        const getAdFormCookieID = ()=>$window.Adform?.["_uid"];
        return {
            register (credentials) {
                const defer = $q.defer();
                const alias = "userRegister";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const ls = _localStorage.getAffiliateData();
                const data = Object.assign({}, ls, credentials);
                data.product = _config.product;
                const fbpValue = $cookies.get("_fbp");
                if (fbpValue) data.fbp = fbpValue;
                const adformcookieid = getAdFormCookieID();
                if (adformcookieid) data.adformcookieid = adformcookieid;
                _captcha.execute("register").then((recaptchaToken)=>{
                    Object.assign(data, recaptchaToken);
                }).catch((error)=>error).finally(()=>{
                    _http.post(alias, data, config).then((answer)=>{
                        analytics.send(_analyticsEvents.registrationSuccess, "success", answer.data.result.login);
                        _user.profile = answer.data.result;
                        _heatmap.sendEvent("event", "register");
                        _heatmap.sendEvent("identify", _user.profile.account_id);
                        defer.resolve(answer.data);
                    }, (answer)=>{
                        analytics.send(_analyticsEvents.registrationFail, answer.data.messages[0].code?.toString(), "Not_Login");
                        defer.reject(answer.data);
                    });
                });
                return defer.promise;
            },
            login (data) {
                const defer = $q.defer();
                const alias = "userLogin";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const adformcookieid = getAdFormCookieID();
                if (adformcookieid) data.adformcookieid = adformcookieid;
                _captcha.execute("login").then((recaptchaToken)=>{
                    Object.assign(data, recaptchaToken);
                }).catch((error)=>error).finally(()=>{
                    _http.post(alias, data, config).then((answer)=>{
                        _user.profile = answer.data.result;
                        analytics.send(_analyticsEvents.loginSuccess, "success", data.login);
                        _heatmap.sendEvent("event", "login");
                        _heatmap.sendEvent("identify", _user.profile.account_id);
                        defer.resolve(answer.data);
                        const sentryData = {
                            level: "info",
                            tags: {
                                event: "login",
                                type: "success",
                                account_id: _user.profile.account_id
                            }
                        };
                        sentry.sendMessage("login success", sentryData);
                    }, (answer)=>{
                        analytics.send(_analyticsEvents.loginFail, answer.data.messages[0].code?.toString(), "Not_Login");
                        sentry.sendException("login fail", {
                            tags: {
                                event: "login",
                                type: "error",
                                status: answer.status
                            },
                            extra: {
                                // eslint-disable-next-line angular/json-functions
                                message: JSON.stringify(answer.data.messages[0])
                            }
                        });
                        defer.reject(answer.data);
                    });
                });
                return defer.promise;
            },
            logout (isFrontEndSideLogout) {
                const defer = $q.defer();
                const alias = "userLogout";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                if (isFrontEndSideLogout === true) {
                    sentry.sendMessage("logout success", {
                        level: "info",
                        tags: {
                            event: "logout",
                            type: "success",
                            side: "frontend",
                            account_id: _user.profile.account_id
                        }
                    });
                    finishSession();
                    defer.resolve();
                } else _http.get(alias, config).then(()=>{
                    finishSession();
                    defer.resolve();
                    sentry.sendMessage("logout success", {
                        level: "info",
                        tags: {
                            event: "logout",
                            type: "success",
                            side: "backend"
                        }
                    });
                }).catch((error)=>{
                    sentry.sendException("logout fail", {
                        tags: {
                            event: "logout",
                            type: "error"
                        },
                        extra: {
                            // eslint-disable-next-line angular/json-functions
                            message: JSON.stringify(error.data.messages[0])
                        }
                    });
                    defer.reject();
                });
                function finishSession() {
                    _user.profile = {};
                    _localStorage.remove("accountId");
                    _popup.close();
                    _state.goto("home");
                }
                return defer.promise;
            },
            info (options) {
                const defer = $q.defer();
                const alias = "userInfo";
                const config = {
                    params: options,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve();
                }, (answer)=>{
                    _user.profile = {};
                    defer.reject();
                });
                return defer.promise;
            },
            changePassword (data) {
                const defer = $q.defer();
                const alias = "userChangePass";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            update (data) {
                const defer = $q.defer();
                const alias = "userEdit";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            restore (data) {
                const defer = $q.defer();
                const alias = "userRestore";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    analytics.send(_analyticsEvents.recoveryRequestSuccess, "success");
                    defer.resolve();
                }, (answer)=>{
                    analytics.send(_analyticsEvents.recoveryRequestFail, answer.data.messages[0].code?.toString());
                    defer.reject();
                });
                return defer.promise;
            },
            activationCode (data) {
                const defer = $q.defer();
                const alias = "userResendActivationCode";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            activate (data) {
                const defer = $q.defer();
                const alias = "userActivateMail";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            restorationChangePassword (data) {
                const defer = $q.defer();
                const alias = "userRestorePassword";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            autobonuses (options) {
                const defer = $q.defer();
                const alias = "userAvBonus";
                const config = {
                    params: options,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            limits (data) {
                const defer = $q.defer();
                const alias = "userChangeLimit";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            removeLimit (data) {
                const defer = $q.defer();
                const alias = "userRemoveLimit";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            cancelLimit (data) {
                const defer = $q.defer();
                const alias = "userChangeLimit";
                const config = {
                    meta: {
                        alias: alias
                    },
                    data: data
                };
                _http.delete(alias, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            sessionLength (data) {
                const defer = $q.defer();
                const alias = "sessionLength";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            exclude (data) {
                const defer = $q.defer();
                const alias = "userExclusion";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                switch(data.action){
                    case "BLOCK":
                        data = {
                            action: data.action,
                            expires: data.expires
                        };
                        break;
                    case "EXCLUDE":
                        data = {
                            action: data.action,
                            exclude: data.exclude
                        };
                        break;
                    default:
                        break;
                }
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = {};
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            close (data) {
                const defer = $q.defer();
                const alias = "userClosure";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then(// FET-3702
                // answer => { _user.profile = {}; defer.resolve( answer ) },
                (answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            win (data) {
                const defer = $q.defer();
                const alias = "userWin";
                const config = {
                    params: data,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            svTokenRestore (data) {
                const defer = $q.defer();
                const alias = "userSVTokenRestore";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            svRealitySettings (data) {
                const defer = $q.defer();
                const alias = "userSVRealitySettings";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            changeMask (data) {
                const defer = $q.defer();
                const alias = "userSetMask";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            multiLimits (data) {
                const defer = $q.defer();
                const alias = "userMultiLimits";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            lastDeposit (data) {
                const defer = $q.defer();
                const alias = "historyLastDep";
                const config = {
                    params: data,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            acceptNewTerms (data) {
                const defer = $q.defer();
                const alias = "userTermsChanged";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            refreshSession (data) {
                const defer = $q.defer();
                const alias = "userRefreshSession";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            recoveryLogin (data) {
                const defer = $q.defer();
                const alias = "userRecoveryLogin";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve();
                }, (answer)=>{
                    defer.reject();
                });
                return defer.promise;
            },
            missedFields (data) {
                const defer = $q.defer();
                const alias = "userUpdateRequiredFields";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer.data);
                    if (_user.profile?.sessions_info?.is_first_session === true && _user.profile?.profile?.is_profile_complete === true) analytics.send(_analyticsEvents.registrationComplete, "success", answer.data.result.login);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            updateOptionalFields (data) {
                const defer = $q.defer();
                const alias = "userUpdateOptionalFields";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.put(alias, {
                    update: data
                }, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            yearReport () {
                const defer = $q.defer();
                const alias = "userYearReport";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            /** Check if it is possible to store user input
       * @param {object} data - user credentials to check
       * @param {string} [data.phone] - phone
       * @param {string} [data.login] - login
       * @param {string} [data.email] - email
       * @return {Promise}
       * */ validateUserData (data) {
                const defer = $q.defer();
                const alias = "validateUserData";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _captcha.execute("validate").then((recaptchaToken)=>{
                    Object.assign(data, recaptchaToken);
                }).catch((error)=>error).finally(()=>{
                    _http.post(alias, data, config).then(({ data: data })=>{
                        defer.resolve(data);
                    }, ({ data: data })=>{
                        defer.reject(data);
                    });
                });
                return defer.promise;
            },
            /** Sends user data to track abandoned registrations
       * @param {object} data
       * @param {string} data.language
       * @param {string} data.email
       * @return {void}
       * */ collectRegistrationAnalytics (data) {
                const alias = "collectRegistrationAnalytics";
                beaconAPI.send(alias, data);
            },
            balanceDetails () {
                const defer = $q.defer();
                const alias = "userBalanceDetails";
                const config = {
                    cache: false,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then(({ data: data })=>defer.resolve(data)).catch(({ data: data })=>defer.reject(data));
                return defer.promise;
            }
        };
    }
    app.factory("account", controller);
})();








(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        let sessions = {};
        const add = (session)=>{
            const newSessionsDictionary = {
                ...sessions,
                [session.id]: session
            };
            sessions = newSessionsDictionary;
            return newSessionsDictionary;
        };
        const remove = (sessionId)=>{
            const sessionToRemove = sessions[sessionId];
            if (sessionToRemove) {
                const newSessionsDictionary = {
                    ...sessions
                };
                delete newSessionsDictionary[sessionId];
                sessions = newSessionsDictionary;
            }
            return sessionToRemove;
        };
        return {
            add: add,
            remove: remove
        };
    }
    app.factory("sessions", controller);
})();








(function() {
    controller.$inject = [
        "system",
        "system$",
        "$q",
        "$timeout"
    ];
    function controller(_system, _system$, $q, $timeout) {
        return {
            version () {
                const defer = $q.defer();
                if (Object.keys(_system.systemInfo).length) {
                    const version = getVersion(_system.systemInfo.platform_version);
                    $timeout(()=>{
                        defer.resolve(version);
                    });
                    return defer.promise;
                }
                _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "systemInfo")).subscribe(({ data: data })=>{
                    const version = getVersion(data.platform_version);
                    defer.resolve(version);
                });
                function getVersion(version) {
                    return version === "3" ? 3 : 2;
                }
                return defer.promise;
            }
        };
    }
    app.factory("platform", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "$window",
        "user",
        "popup",
        "sessions",
        "analytics",
        "analyticsEvents",
        "system",
        "platform"
    ];
    function controller(_http, $q, $window, _user, _popup, _sessions, _analytics, _analyticsEvents, _system, _platform) {
        return {
            favourite: {
                toggle (name) {
                    const games = ($window.localStorage.getItem("fav") || "").split(",");
                    let index = games.indexOf(name);
                    index < 0 ? games.push(name) : games.splice(index, 1);
                    const result = games.filter((item)=>{
                        return item !== "";
                    });
                    index = games.indexOf(name);
                    $window.localStorage.setItem("fav", result.join(","));
                    return index >= 0;
                },
                check (name) {
                    const games = ($window.localStorage.getItem("fav") || "").split(",");
                    return games.indexOf(name) >= 0;
                },
                collection () {
                    return ($window.localStorage.getItem("fav") || "").split(",");
                }
            },
            collection (options, cache) {
                const defer = $q.defer();
                const alias = "gameList";
                const config = {
                    params: options,
                    cache: options.random !== true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                if (typeof cache === "boolean") config.cache = cache;
                _platform.version().then((version)=>{
                    if (config.params.brand === "ela" && version === 2) config.params.brand += ",claw";
                    getGames();
                });
                function getGames() {
                    _http.get(alias, config).then((answer)=>{
                        const r = answer.data;
                        if (config.params.brand === "ela,claw") {
                            const _result = [];
                            r.result.forEach((e)=>{
                                if (e.brand_code === "ela" || e.brand_alias === "ela") _result.push(e);
                            });
                            r.result.forEach((e)=>{
                                if (e.brand_code === "claw" || e.brand_alias === "claw") _result.push(e);
                            });
                            r.result = _result;
                        }
                        defer.resolve(r);
                    }, (answer)=>{
                        defer.reject(answer.data);
                    });
                }
                return defer.promise;
            },
            recentlyPlayed (options) {
                const defer = $q.defer();
                const alias = "gameRecentlyPlayed";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            item (options) {
                const alias = {
                    name: "gameItem",
                    param: options.name
                };
                return _http.getData(alias, {}, options.cache);
            },
            launch (options) {
                const defer = $q.defer();
                const alias = "gameLaunch";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then(({ data: data })=>{
                    if (options.mode === "real") {
                        const id = data.result.session_id;
                        const alias = options.code;
                        const launchTime = Date.now();
                        _sessions.add({
                            id: id,
                            alias: alias,
                            launchTime: launchTime
                        });
                    }
                    defer.resolve(data);
                    const url = data.result.url && !/^\//.test(data.result.url) ? data.result.url : location.href;
                    const { host: host } = new URL(url);
                    _analytics.send(_analyticsEvents.gameLaunchSuccess, `${options.mode}:${options.code}:${data.system}`, host, {
                        nonInteraction: true
                    });
                }).catch(({ data: data })=>{
                    defer.reject(data);
                    _analytics.send(_analyticsEvents.gameLaunchFail, `${options.mode}:${options.code}`, data?.messages[0]?.code || "UNKNOWN_ERROR", {
                        nonInteraction: true
                    });
                });
                return defer.promise;
            },
            /**
       *
       * @param {Object} options
       * @param {string} options.game_session_id
       * @return {Promise}
       */ closeGameSession (options) {
                const defer = $q.defer();
                const alias = "gameCloseSession";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, options, config).then(({ data: data })=>{
                    _sessions.remove(options.game_session_id);
                    defer.resolve(data);
                }).catch(({ data: data })=>{
                    defer.reject(data);
                });
                return defer.promise;
            },
            mobileLaunch (options) {
                const self = this;
                if (options.mode === "real" && _user.status === false) _popup.open({
                    name: "login",
                    cb () {
                        self.launch(options).then((answer)=>{
                            $window.location = answer.result.url;
                        });
                    }
                });
                else self.launch(options).then((answer)=>{
                    $window.location = answer.result.url;
                });
            },
            check (options) {
                const defer = $q.defer();
                const alias = "gameCheck";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, options, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            toggleFavourites (options) {
                const defer = $q.defer();
                const alias = "gameToggleFav";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, options, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            // pt only
            gameSessionInfo (data) {
                const defer = $q.defer();
                const alias = "ptGameSessionInfo";
                const config = {
                    params: data,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            search (data) {
                const defer = $q.defer();
                const alias = "gameSearch";
                const config = {
                    params: data,
                    meta: {
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("game", controller);
})();





(function() {
    "use strict";
    ctrl.$inject = [
        "config",
        "$timeout"
    ];
    function ctrl(_config, $timeout) {
        function clear() {
            this.ref = undefined;
            this.onCloseCb = undefined;
            this.onLoadCb = undefined;
        }
        function onCloseDecoration(event) {
            if (angular.isFunction(this.onCloseCb)) this.onCloseCb(event);
            clear.call(this);
        }
        function onLoadDecoration(event) {
            if (angular.isFunction(this.onLoadCb)) this.onLoadCb(event);
        }
        const AppBrowser = {
            ref: undefined,
            open (url) {
                this.ref = cordova.ThemeableBrowser.open(url, "_blank", _config.mobileConfig.inAppBrowserConfig);
                this.ref.addEventListener("exit", onCloseDecoration.bind(this));
                this.ref.addEventListener("loadstart", onLoadDecoration.bind(this));
                return this;
            },
            close (time) {
                if (angular.isNumber(time) && !_config.production) $timeout(()=>{
                    this.ref.close();
                }, time);
                else this.ref.close();
            },
            onExit (cb) {
                this.onCloseCb = cb;
                return this;
            },
            onLoad (cb) {
                this.onLoadCb = cb;
                return this;
            }
        };
        Object.defineProperty(AppBrowser, "location", {
            set: function(url) {
                if (angular.isString(url)) this.ref.executeScript({
                    code: `document.location = "${url}"`
                });
            }
        });
        return AppBrowser;
    }
    app.factory("appBrowser", ctrl);
})();


(function() {
    "use strict";
    controller.$inject = [
        "game",
        "appBrowser"
    ];
    function controller(_game, _appBrowser) {
        return {
            launch (options) {
                let firstPreloader = true;
                const browser = _appBrowser.onExit(()=>{}).onLoad(loadstart).open("preloader.html");
                function loadstart(event) {
                    if (event.url.indexOf("preloader.html") + 1 && !firstPreloader) browser.close();
                    if (event.url.indexOf("preloader.html") + 1 && firstPreloader) {
                        firstPreloader = false;
                        _game.launch(options).then((answer)=>{
                            browser.location = answer.result.url;
                        }, (answer)=>{
                            browser.close();
                        });
                    }
                }
            }
        };
    }
    app.factory("gameMobileApp", controller);
})();



(function() {
    app.run(controller);
    controller.$inject = [
        "$rootScope",
        "user$",
        "user",
        "account",
        "notification$",
        "$timeout",
        "config",
        "popup",
        "$state",
        "game",
        "state",
        "gameMobileApp",
        "system"
    ];
    function controller($rootScope, _user$, _user, _account, _notification$, $timeout, _config, _popup, $state, _game, _state, _gameMobileApp, _system) {
        if (_config.mobileApp) FastClick.attach(document.body);
        if (_user.sessionToken && _user.sessionToken.length >= 10) _account.info({
            nocache: true
        });
        else _user.profile = {};
        _system.info().then((answer)=>{
            _config.system_info = answer.result;
        }).catch((error)=>{
            console.error(error);
        }).finally(()=>{});
        $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
            switch(error.detail.code){
                case 307:
                    // Start game on app
                    _gameMobileApp.launch({
                        code: toParams.name,
                        mode: toParams.mode
                    });
                    break;
                case 308:
                    // TODO діч
                    _game.mobileLaunch({
                        code: toParams.name,
                        mode: toParams.mode
                    });
                    break;
                case 309:
                    $state.go("app.root.mobile-game", toParams);
                    break;
                case 310:
                    $state.go(toParams.redirectIfMobile, toParams);
                    break;
                // Private page with asking for authorization
                case 400:
                    if (_config.jurisdiction === "sweden" || _config.currentLang === "fi" && _config.isPayNPlayRegistrationAvailable) {
                        _state.goto("paynplay");
                        return;
                    }
                    _popup.open({
                        name: _user.profile.login ? "login" : "registration",
                        cb () {
                            $state.go(toState.name, toParams);
                        }
                    });
                    break;
                // Private page with redirect to homepage and asking for authorization
                case 401:
                    const state = _state.get("home");
                    if (state !== null) $state.go(state.name, {
                        lang: _config.currentLang
                    }).then(()=>{
                        if (_config.jurisdiction === "sweden" || _config.currentLang === "fi" && _config.isPayNPlayRegistrationAvailable) {
                            _state.goto("paynplay");
                            return;
                        }
                        _popup.open({
                            name: _user.profile.login ? "login" : "registration",
                            cb () {
                                $state.go(toState.name, toParams);
                            }
                        });
                    });
                    break;
                case 402:
                    break;
                // Пользователь авторизован, страница доступна только для неавторизованных (форма регистрации, авторизации...)
                case 500:
                    _state.goto("home");
                    break;
            }
        });
        $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            _state.previous.name = fromState.name;
            _state.previous.params = fromParams;
            _state.history.push(toState.name);
        });
    }
})();



$0d10d209fcabfa38$exports = {
    "app.config": $0c3f2a050bef79b1$exports,
    "app.prot": $1910f7081cd4965b$exports,
    "app.run": $92d53d37ef55f11c$exports,
    "casinoApp": $6382ac8304369ea6$exports
};


// - For working with altenar proxy scripts needed to add in nginx config:
// - https://wiki.gosystem.io/display/MD/B2C+Altenar+proxifying+scripts+for+selected+localizations
(function() {
    "use strict";
    if (!$_CONFIG.sport) return;
    const ALTANAR_HOST = {
        PROXY: "",
        SDK: {
            PROD: "sb2integration-altenar2.biahosted.com",
            DEV: "sb2integration-altenar2-stage.biahosted.com"
        },
        WIDGET: {
            PROD: "sb2wsdk-altenar2.biahosted.com",
            DEV: "sb2wsdk-altenar2-stage.biahosted.com"
        }
    };
    let proxySportScripts = false;
    let countryCode = "";
    const isDevEnv = checkIfDevEnv();
    getSystemCountryCode().then(({ result: result })=>{
        countryCode = result.country.code.toUpperCase();
        ALTANAR_HOST.PROXY = result.sportProxyHostname;
        init();
    }).catch(()=>{});
    async function getSystemCountryCode() {
        const apiDomain = window.location.host;
        const currentLang = window.location.pathname.split("/")[1] || "en";
        const response = await fetch(`//${apiDomain}/${currentLang}/api/v2/system/info`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>response.json()).catch(()=>{});
        return response;
    }
    function init() {
        if (ALTANAR_HOST.PROXY) setProxy();
        const sportSDK = setSportSDK();
        const widgetSDK = setWidgetSDK();
        appendAltenarWidgetScript(widgetSDK);
        appendSportsdk(sportSDK);
    }
    function checkIfDevEnv() {
        const envs = [
            ".m0l0",
            ".local",
            "vesto.xyz",
            "stage.",
            "dev."
        ];
        const { host: host } = window.location;
        return window.$_DRAGON?.env === "stage" ? true : !!envs.find((mask)=>host.includes(mask));
    }
    function setProxy() {
        const countriesToProxy = window.$_DICT?.sportProxying?.countries || [];
        proxySportScripts = countriesToProxy.includes(countryCode);
        if (!proxySportScripts) return;
        [
            "altenarOrigins",
            "altenarOrigin",
            "altenarPath"
        ].forEach((item)=>altenarProxify(item));
    }
    function altenarProxify(name) {
        Object.defineProperty(window, name, {
            get: function() {
                return window[`_${name}`];
            },
            set: function(data) {
                if (typeof data === "object") {
                    const origins = {};
                    Object.entries(data).map((item)=>{
                        if (!item[0].includes("betradar") && item[1].includes("http")) {
                            const value = item[1].replace("https://", "");
                            origins[item[0]] = `//${ALTANAR_HOST.PROXY}/altenarScripts/` + value;
                            return;
                        }
                        origins[item[0]] = item[1];
                    });
                    window[`_${name}`] = origins;
                    return;
                }
                window[`_${name}`] = `//${ALTANAR_HOST.PROXY}/altenarScripts/` + data.replace(/https:\/\/|\/\//gi, "");
            }
        });
    }
    function setWidgetSDK() {
        const proxyWidgetSDK = `//${ALTANAR_HOST.PROXY}/widgetsdk/altenarWSDK.js`;
        const prodCdnWidgetSDK = `//${ALTANAR_HOST.WIDGET.PROD}/altenarWSDK.js`;
        const devCdnWidgetSDK = `//${ALTANAR_HOST.WIDGET.DEV}/altenarWSDK.js`;
        if (isDevEnv) return devCdnWidgetSDK;
        return proxySportScripts ? proxyWidgetSDK : prodCdnWidgetSDK;
    }
    function setSportSDK() {
        const defaultSportId = $_CONFIG.sportId || "sport_id_is_not_configured";
        const localSportId = $_CDN.sportConfig?.localizationIds?.[countryCode];
        const sportId = localSportId || defaultSportId;
        const proxySportSDK = `//${ALTANAR_HOST.PROXY}/sportsdk/api/Integration/${sportId}`;
        const prodCdnSportSDK = `//${ALTANAR_HOST.SDK.PROD}/api/Integration/${sportId}`;
        const devCdnSportSDK = `//${ALTANAR_HOST.SDK.DEV}/api/Integration/${sportId}`;
        if (isDevEnv) return devCdnSportSDK;
        return proxySportScripts ? proxySportSDK : prodCdnSportSDK;
    }
    function appendAltenarWidgetScript(widgetSDK) {
        window.AltenarWidgetScriptLoaded = false;
        const element = document.createElement("script");
        element.src = `${widgetSDK}?build=${$_CONFIG.build}`;
        element.async = false;
        element.onload = ()=>{
            window.AltenarWidgetScriptLoaded = true;
        };
        document.head.appendChild(element);
    }
    function appendSportsdk(sportSDK) {
        const element = document.createElement("script");
        element.src = `${sportSDK}?build=${$_CONFIG.build}`;
        element.async = false;
        element.onload = ()=>{};
        document.head.appendChild(element);
    }
})();


(function(windowObject) {
    windowObject.Controller = function(type, controller, bindings) {
        if (typeof controller !== "function") controller = function() {};
        if (typeof bindings === "undefined") bindings = {};
        windowObject.tools.batman[type] = {
            bindings: bindings,
            controller: controller
        };
    };
    windowObject.Batman = function(name, type) {
        const app = windowObject.app;
        app.component(name, {
            ...windowObject.tools.batman[type],
            template: app.getTU(name)
        });
    };
    windowObject.tools = {
        batman: {}
    };
})(window);


var $9c47b7f8d294b493$exports = {};
var $40afb9433e9742a5$exports = {};
(function() {
    "use strict";
    app.filter("daysFromHours", controller);
    controller.$inject = [
        "$translate"
    ];
    function controller($translate) {
        return (input, daysKey, hoursKey)=>{
            const days = Math.floor(input / 24);
            const hours = input - days * 24;
            let str = "";
            if (days) str += `${days}${$translate.instant(daysKey || "g.days.short")} `;
            if (hours) str += `${hours}${$translate.instant(hoursKey || "g.hours.short")}`;
            return str;
        };
    }
})();


var $e7865ed3f40faf9b$exports = {};
/**
 * The format is expected to be: DD.MM.YYYY
 * The sequence can be different
 * The separator can be anything
 * The year can be two or four characters long
 */ app.filter("formatDate", function() {
    return function(date, neededDateFormat, sourceDateFormat) {
        if (!date) return;
        neededDateFormat = neededDateFormat || "DD.MM.YYYY";
        sourceDateFormat = sourceDateFormat || "DD-MM-YYYY";
        const result = getStrFromDate(getDateFromStrByMask(date, sourceDateFormat), neededDateFormat);
        return result || date;
        function getDateFromStrByMask(str, mask) {
            const year = getSubstrByMask(str, mask, "Y");
            const month = getSubstrByMask(str, mask, "M");
            const day = getSubstrByMask(str, mask, "D");
            const date = new Date(`${new Date(`01-01-${year}`).getFullYear()}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
            const isDateValid = !isNaN(date.getTime()) && Number(day) === date.getDate();
            return isDateValid ? date : null;
        }
        function getStrFromDate(date, format) {
            if (!date) return null;
            const year = String(date.getFullYear());
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const YLocations = getSubstrLocations(format, "Y");
            const MLocations = getSubstrLocations(format, "M");
            const DLocations = getSubstrLocations(format, "D");
            const replaceSubstr = (str, iStart, iEnd, newSubstr)=>str.replace(str.substring(iStart, iEnd + 1), newSubstr);
            let result = format;
            result = replaceSubstr(result, YLocations[0], YLocations[YLocations.length - 1], YLocations.length === 4 ? year : year.slice(-2));
            result = replaceSubstr(result, MLocations[0], MLocations[MLocations.length - 1], month);
            result = replaceSubstr(result, DLocations[0], DLocations[DLocations.length - 1], day);
            return result;
        }
        function getSubstrByMask(str, fullMask, characterMask) {
            let result = "";
            getSubstrLocations(fullMask, characterMask).forEach((i)=>result += str[i]);
            return result;
        }
        function getSubstrLocations(str, substr) {
            const result = [];
            let i = -1;
            while((i = str.indexOf(substr, i + 1)) >= 0)result.push(i);
            return result;
        }
    };
});


var $522244109ceca068$exports = {};
(function() {
    "use strict";
    app.filter("getDomainName", controller);
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        return ()=>{
            const domain = $window.location.hostname.replace("www.", "").split(".");
            return domain[0] === "m" ? domain[1] : domain[0];
        };
    }
})();


var $5abaee58582e2d11$exports = {};

(function() {
    "use strict";
    app.filter("icon", func);
    func.$inject = [
        "config"
    ];
    function func(_config) {
        return function(string) {
            let sign = string + "";
            _config.currency.forEach(function(item) {
                if (string) {
                    if (string.toUpperCase() === item.key) {
                        if (item.icon) sign = item.icon;
                    }
                }
            });
            return sign;
        };
    }
})();


var $b10d61f27e2dd999$exports = {};
(function() {
    "use strict";
    // eslint-disable-next-line no-extend-native
    Array.prototype.last = function() {
        return this[this.length - 1];
    };
    const formats = [
        "jpg",
        "png",
        "jpeg"
    ];
    app.filter("imageProxy", function() {
        return function(url, params) {
            if (!url) return null;
            const urlArray = url.split(".");
            if (formats.find((format)=>format === urlArray.last())) return url + "?" + new URLSearchParams(params);
            return url;
        };
    });
})();


var $4bf325c0c5a12a65$exports = {};
(function() {
    "use strict";
    app.filter("intlNumberFormat", function() {
        return function(stringAmount, country = "de-DE") {
            if (stringAmount === undefined) return;
            return new Intl.NumberFormat(country.toLowerCase()).format(parseFloat(stringAmount).toFixed(2));
        };
    });
})();


var $28fc96fcc99e98b5$exports = {};
(function() {
    "use strict";
    function controller() {
        return (input)=>Math.floor(input);
    }
    app.filter("mathFloor", controller);
})();


var $69a851c08cbac159$exports = {};
app.filter("sum", function() {
    return function(string) {
        return string ? (string + "").replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ") : string;
    };
});


var $3a83ec344c2e0512$exports = {};
(function() {
    "use strict";
    app.filter("timerange", controller);
    controller.$inject = [];
    function controller() {
        const dateObj = new Date();
        return function(string, delimeter) {
            const array = dateObj.sToDHMS(string);
            return delimeter ? array.join(delimeter) : array;
        };
    }
})();


$9c47b7f8d294b493$exports = {
    "daysFromHours": $40afb9433e9742a5$exports,
    "formatDate": $e7865ed3f40faf9b$exports,
    "getDomainName": $522244109ceca068$exports,
    "icon": $5abaee58582e2d11$exports,
    "imageProxy": $b10d61f27e2dd999$exports,
    "intlNumberFormat": $4bf325c0c5a12a65$exports,
    "mathFloor": $28fc96fcc99e98b5$exports,
    "sum": $69a851c08cbac159$exports,
    "timerange": $3a83ec344c2e0512$exports
};


var $35648d3d0b082142$exports = {};
var $f82420f89b7814d8$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http"
    ];
    function controller($q, _http) {
        const o = {
            object: {},
            list: list,
            collectionHall: collectionHall
        };
        function collectionHall() {
            const defer = $q.defer();
            const alias = "collectionHall";
            const config = {
                cache: true,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then((answer)=>{
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        function list(options) {
            const defer = $q.defer();
            const alias = "collectionList";
            const config = {
                params: options,
                cache: true,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then((answer)=>{
                o.object = answer.data.result.toObject("alias");
                o.object.list = answer.data.result;
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        return o;
    }
    app.factory("collection", controller);
})();



(function() {
    "use strict";
    controller.$inject = [
        "$state",
        "$q",
        "collection",
        "state"
    ];
    function controller($state, $q, _collection, _state) {
        const defer = $q.defer();
        function isValidRoute(collection) {
            return collection ? defer.resolve() : defer.reject(_state.goto("notFound"));
        }
        function collection() {
            const { category: category, collection: collection } = $state.transition.params() || {};
            return _collection.collectionHall().then((answer)=>{
                const collectionByAlis = answer.result.toObject("alias");
                const currentCollection = collectionByAlis[collection];
                if (category) return isValidRoute(currentCollection.categories.toObject("name")[category]);
                return isValidRoute(currentCollection);
            }).catch(()=>{
                _state.goto("notFound");
            });
        }
        return {
            collection: collection
        };
    }
    app.factory("casinoResolver", controller);
})();


var $0b820d763f71b389$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "user",
        "localStorage"
    ];
    function controller(_http, $q, _user, _localStorage) {
        let _result = [];
        const o = {
            list: list,
            item: item,
            subscription: subscription,
            get result () {
                if (_user.status) return _result.filter((i)=>i.avatar === _user.profile.profile.avatar || !i.avatar);
                return _result;
            },
            get object () {
                const result = this.result;
                return Object.assign(result.toObject("name"), {
                    total_count: result.length
                });
            }
        };
        function list(options) {
            const defer = $q.defer();
            const alias = "promoList";
            const affiliateParams = _localStorage.getAffiliateData();
            const params = !_user.status ? {
                ...affiliateParams,
                ...options
            } : options;
            const config = {
                params: params,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then((answer)=>{
                _result = answer.data.result;
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        function item(options) {
            const defer = $q.defer();
            const alias = "promoItem";
            const config = {
                params: options,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then((answer)=>{
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        function subscription(data) {
            const defer = $q.defer();
            const alias = "optInSubscription";
            const config = {
                cache: true,
                meta: {
                    cache: true,
                    type: "api",
                    alias: alias
                }
            };
            _http.put(alias, data, config).then((answer)=>{
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        return o;
    }
    app.factory("promo", controller);
})();




const $0b820d763f71b389$var$factoryName = "promoItemResolver";
class $0b820d763f71b389$var$Resolver {
    static $inject = [
        "$state",
        "promo",
        "config",
        "state"
    ];
    constructor($state, promo, config, state){
        this.promo = promo;
        this.state = state;
        this.$state = $state;
        this.config = config;
    }
    gotoNotFound() {
        this.state.goto("notFound", {});
    }
    resolve() {
        const { name: name } = this.$state.transition.params() || "";
        return this.promo.item({
            name: name
        }).then(({ result: result })=>result).catch(()=>this.gotoNotFound());
    }
}
app.factory($0b820d763f71b389$var$factoryName, $0b820d763f71b389$var$Resolver);


var $4c98188a0f716b7c$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "notification$"
    ];
    function controller(_http, $q, _notification$) {
        return {
            item (options) {
                const alias = {
                    name: "tournamentItem",
                    param: options.name
                };
                return _http.getData(alias, options.params, options.cache);
            },
            list (options) {
                const defer = $q.defer();
                const alias = "tournamentList";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            fastTournamentList (options) {
                const defer = $q.defer();
                const alias = "fastTournamentList";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            fastTournamentHistory (options) {
                const defer = $q.defer();
                const alias = "fastTournamentHistory";
                const config = {
                    params: options,
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            fastTournamentSubscribe (tournamentEventId) {
                const defer = $q.defer();
                const alias = "fastTournamentSubscribe";
                const data = {
                    tournamentEventId: tournamentEventId
                };
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            fastTournamentGetLeaderboard (tournamentEventId, options) {
                const defer = $q.defer();
                const alias = {
                    name: "fastTournamentGetLeaderboard",
                    param: tournamentEventId
                };
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            leagueClaimReward (data) {
                const defer = $q.defer();
                const alias = "leagueClaimReward";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("tournament", controller);
})();




const $4c98188a0f716b7c$var$factoryName = "tournamentItemResolver";
class $4c98188a0f716b7c$var$Resolver {
    static $inject = [
        "$state",
        "tournament",
        "config",
        "state"
    ];
    constructor($state, tournament, config, state){
        this.tournament = tournament;
        this.state = state;
        this.$state = $state;
        this.config = config;
    }
    gotoNotFound() {
        this.state.goto("notFound", {});
    }
    resolve() {
        const { name: name } = this.$state.transition.params() || "";
        return this.tournament.item({
            name: name
        }).then(({ result: result })=>result).catch(()=>this.gotoNotFound());
    }
}
app.factory($4c98188a0f716b7c$var$factoryName, $4c98188a0f716b7c$var$Resolver);


var $ad3859acca7b496f$exports = {};

const $d196280a5a075f9a$export$8e19b64b871ab6a1 = "extendedTournamentApi";
class $d196280a5a075f9a$var$Api {
    static $inject = [
        "$q",
        "http"
    ];
    constructor($q, http){
        this.$q = $q;
        this.http = http;
    }
    getList(params = {}) {
        return new Promise((resolve)=>resolve(this.http.getData("extendedTournamentList", params)));
    }
    getItem(options, params) {
        return new Promise((resolve)=>resolve(this.http.getData({
                name: "extendedTournamentItem",
                param: options.alias
            }, params)));
    }
}
app.factory("extendedTournamentApi", $d196280a5a075f9a$var$Api);


const $fab29144493f4b62$export$1427e8989928e51a = "extendedTournament";
class $fab29144493f4b62$var$Tournament {
    static $inject = [
        "extendedTournamentApi"
    ];
    constructor(extendedTournamentApi){
        this.extendedTournamentApi = extendedTournamentApi;
    }
    getSortedList(options) {
        return this.extendedTournamentApi.getList(options).then(({ result: result })=>{
            this.sortList(result);
        });
    }
    sortList(tournamentList) {
        this.casino = {};
        this.sport = {};
        tournamentList.forEach((item)=>{
            const category = item.ledger_type.toLowerCase();
            const tournamentStatus = item.status.toLowerCase();
            if (!this[category]?.[tournamentStatus]) {
                this[category][tournamentStatus] = [
                    item
                ];
                return;
            }
            this[category][tournamentStatus].push(item);
        });
    }
    getItem(options, params) {
        return this.extendedTournamentApi.getItem(options, params);
    }
}
app.factory("extendedTournament", $fab29144493f4b62$var$Tournament);



(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "extendedTournament",
        "state"
    ];
    function controller($q, extendedTournament, state) {
        const defer = $q.defer();
        function isValidRoute(tournament) {
            return tournament ? defer.resolve() : defer.reject(state.goto("notFound"));
        }
        function collection(params) {
            extendedTournament.getItem({
                alias: params.name
            }, {
                tournament_event_guid: params.guid
            }).then((item)=>{
                isValidRoute(item.result);
            }).catch((err)=>{
                state.goto("notFound");
            });
        }
        return {
            collection: collection
        };
    }
    app.factory("tournamentResolver", controller);
})();


$35648d3d0b082142$exports = {
    "casino-resolver": $f82420f89b7814d8$exports,
    "promo-item-resolver": $0b820d763f71b389$exports,
    "tournament-item-resolver": $4c98188a0f716b7c$exports,
    "tournament-resolver": $ad3859acca7b496f$exports
};


var $12b6ac258f73d8ce$exports = {};
var $ee374290a956332e$exports = {};
(function() {
    "use strict";
    app.directive("alfPaymentSliderWidget", [
        "$timeout",
        ($timeout)=>{
            function link(scope, elem, attrs) {
                scope.alfPaymentSliderWidget = {
                    range: scope.system.rules.range,
                    default: scope.system.rules.default,
                    sliderToSum (value) {
                        const self = this;
                        let sum;
                        if (value <= 10) sum = (self.range[1] - self.range[0]) / 100 * (10 * (value - 0)) + self.range[0];
                        else if (value <= 30) sum = (self.range[2] - self.range[1]) / 100 * (5 * (value - 10)) + self.range[1];
                        else if (value <= 50) sum = (self.range[3] - self.range[2]) / 100 * (5 * (value - 30)) + self.range[2];
                        else if (value <= 70) sum = (self.range[4] - self.range[3]) / 100 * (5 * (value - 50)) + self.range[3];
                        else if (value <= 90) sum = (self.range[5] - self.range[4]) / 100 * (5 * (value - 70)) + self.range[4];
                        else sum = (self.range[6] - self.range[5]) / 100 * (10 * (value - 90)) + self.range[5];
                        return Math.round(sum);
                    },
                    sumToSlider (sum) {
                        let sliderPosition;
                        const self = this;
                        self.range.some((item, index)=>{
                            if (sum <= item) {
                                switch(index){
                                    case 1:
                                        sliderPosition = 0.1 * (100 / (self.range[1] - self.range[0]) * (sum - self.range[0])) + 0;
                                        break;
                                    case 2:
                                        sliderPosition = 0.2 * (100 / (self.range[2] - self.range[1]) * (sum - self.range[1])) + 10;
                                        break;
                                    case 3:
                                        sliderPosition = 0.2 * (100 / (self.range[3] - self.range[2]) * (sum - self.range[2])) + 30;
                                        break;
                                    case 4:
                                        sliderPosition = 0.2 * (100 / (self.range[4] - self.range[3]) * (sum - self.range[3])) + 50;
                                        break;
                                    case 5:
                                        sliderPosition = 0.2 * (100 / (self.range[5] - self.range[4]) * (sum - self.range[4])) + 70;
                                        break;
                                    case 6:
                                        sliderPosition = 0.1 * (100 / (self.range[6] - self.range[5]) * (sum - self.range[5])) + 90;
                                        break;
                                    default:
                                        sliderPosition = 50;
                                        break;
                                }
                                return true;
                            }
                        });
                        return sliderPosition;
                    },
                    renewSliderPosition (sum) {
                        const self = this;
                        const newPosition = self.sumToSlider(sum);
                        $(elem).slider("value", newPosition);
                    }
                };
                const sliderPosition = scope.alfPaymentSliderWidget.sumToSlider(scope.alfPaymentSliderWidget.default);
                scope.formData.amount = scope.alfPaymentSliderWidget.sliderToSum(sliderPosition);
                const config = {
                    animate: true,
                    orientation: "horizontal",
                    range: "min",
                    max: 100,
                    step: 0.1,
                    value: sliderPosition,
                    slide (e, ui) {
                        $timeout(()=>{
                            scope.formData.amount = scope.alfPaymentSliderWidget.sliderToSum(ui.value);
                        });
                    }
                };
                $(elem).slider(config);
            }
            return {
                restrict: "A",
                link: link
            };
        }
    ]);
})();


var $069341933141e879$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "sliderRange"
    };
    // TODO: 'DRAFT:', directive.name
    function controller() {
        function link(scope, element, attrs) {
            const color = scope.color;
            const range = scope.range;
            const initialValue = scope.value;
            const inputRange = document.getElementById("input-range");
            const inputEnter = document.getElementById("input-enter");
            const sliderBar = document.getElementById("slider-bar");
            const interval = 100 / (range.length - 1);
            const intervalStepValueMap = {};
            const setSliderBarBg = (position)=>{
                sliderBar.style.background = `linear-gradient(to right, ${color} 0, ${color} ${position}%, rgba(255,255,255,0) ${position}%, rgba(255,255,255,0) 100%)`;
            };
            const definePosition = (val)=>{
                let prevPoint = 0;
                range.forEach((item, idx, arr)=>{
                    if (val - item >= 0) prevPoint = idx;
                    intervalStepValueMap[idx] = (arr[idx + 1] - item) / interval;
                });
                const currentIntervalStepValue = intervalStepValueMap[prevPoint];
                const stepsInCurrentInterval = (val - range[prevPoint]) / currentIntervalStepValue;
                inputRange.value = prevPoint * interval + stepsInCurrentInterval;
                return inputRange.value;
            };
            const defineVal = (position)=>{
                const prevPoint = Math.floor(position / interval);
                const currentIntervalStepValue = intervalStepValueMap[prevPoint] || range[range.length - 1];
                const stepsInCurrentInterval = position - interval * prevPoint;
                return Math.round(range[prevPoint] + stepsInCurrentInterval * currentIntervalStepValue);
            };
            // -ACTIONS ON SLIDER LOAD--start
            const initialPosition = definePosition(initialValue);
            setSliderBarBg(initialPosition);
            // -ACTIONS ON SLIDER LOAD--end
            // -WATCHING DATA--start
            inputRange.addEventListener("input", (e)=>{
                setSliderBarBg(e.target.value);
                scope.$apply(()=>{
                    scope.value = defineVal(e.target.value);
                });
            });
            inputEnter.addEventListener("input", (e)=>{
                const position = definePosition(e.target.value);
                setSliderBarBg(position);
                scope.$apply(()=>{
                    scope.value = parseInt(e.target.value);
                });
            });
        // -WATCHING DATA--end
        }
        return {
            restrict: "A",
            scope: {
                value: "=",
                range: "<",
                color: "@"
            },
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $583eb390ab7b68b7$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "scroll");
    }
    app.factory("scroll$", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "updateClassOnScrollTo"
    };
    // TODO: 'DRAFT:', directive.name
    controller.$inject = [
        "scroll$"
    ];
    function controller(_scroll$) {
        function link(scope, elem, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            const element = elem[0];
            let configBreakline = 0;
            let destElement = {};
            let destElementPositionY = 0;
            let isUnderBreakline = false;
            const actionOptions = {
                add: ()=>{
                    if (isUnderBreakline) return element.classList.add(config.class);
                },
                remove: ()=>{
                    if (isUnderBreakline) return element.classList.remove(config.class);
                },
                toggle: ()=>isUnderBreakline ? element.classList.add(config.class) : element.classList.remove(config.class)
            };
            _scroll$.debounceTime(100).subscribe(()=>{
                const breaklineOptions = {
                    viewportBottom: window.innerHeight,
                    documentBottom: document.documentElement.offsetHeight - window.innerHeight
                };
                try {
                    destElement = document.querySelector(config.breakline);
                    destElementPositionY = Math.ceil(destElement.getBoundingClientRect().top) + Math.ceil(window.scrollY) - window.innerHeight;
                } catch  {
                    destElement = null;
                    destElementPositionY = null;
                }
                configBreakline = breaklineOptions[config.breakline] || destElementPositionY || Number(config.breakline);
                isUnderBreakline = Math.ceil(window.scrollY) >= configBreakline;
                if (!(config.action in actionOptions) || !configBreakline) {
                    console.warn("unacceptable config field value in 'update-class-on-scroll-to' directive");
                    return;
                }
                return actionOptions[config.action]();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e5f75d38db5e0096$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        return {
            setData (data) {
                const defer = $q.defer();
                const alias = "abandonedRegistration";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("abandonedRegistration", controller);
})();


(function() {
    "use strict";
    // this directive used for watching all inputs in the form and send formData to backabd after blur event
    const directive = {
        name: "abandonedRegistration"
    };
    controller.$inject = [
        "abandonedRegistration"
    ];
    function controller(_abandonedRegistration) {
        function link(scope, element, attrs) {
            // remove submit, button, checkbox, radio types from HTMLFormControlsCollection of current form
            const elementsForListen = [].filter.call(element[0].elements, (item)=>![
                    "submit",
                    "button",
                    "checkbox",
                    "radio"
                ].includes(item.type));
            function sendData() {
                _abandonedRegistration.setData(scope.formData);
            }
            for (const item of elementsForListen)item.addEventListener("blur", sendData, false);
            scope.$on("$destroy", ()=>{
                for (const item of elementsForListen)item.removeEventListener("blur", sendData, false);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $4ed95bd5f89c38d1$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$rootScope"
    ];
    function controller($rootScope) {
        const $stateChangeSuccess = "$stateChangeSuccess";
        const $stateChangeStart = "$stateChangeStart";
        const scopeEvents = {
            [$stateChangeSuccess]: new Event($stateChangeSuccess),
            [$stateChangeStart]: new Event($stateChangeStart)
        };
        const create = (event, target)=>{
            if (Object.keys(scopeEvents).includes(event)) // eslint-disable-next-line angular/on-watch
            $rootScope.$on(event, ()=>{
                target.dispatchEvent(scopeEvents[event]);
            });
        };
        return {
            create: create
        };
    }
    app.factory("event", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "addClassOnEvent"
    };
    controller.$inject = [
        "event",
        "$timeout"
    ];
    function controller(_event, $timeout) {
        function link($scope, $element, $attrs) {
            const { event: event, selector: selector, delay: delay, class: classNames, stopPropagation: stopPropagation } = $scope.$eval($attrs[directive.name]);
            $element.on(event || "click", (e)=>{
                if (stopPropagation === true) e.stopPropagation();
                const targetElements = selector ? document.querySelectorAll(selector) : [
                    $element[0]
                ];
                const classNamesAsArray = classNames?.split(" ") || [];
                targetElements.forEach((targetElement)=>{
                    targetElement.classList.add(...classNamesAsArray);
                });
                if (delay) $timeout(()=>{
                    targetElements.forEach((targetElement)=>{
                        targetElement.classList.remove(...classNamesAsArray);
                    });
                }, delay);
            });
            _event.create(event, $element[0]);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $b31fdfe7a39ae0cd$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "user$",
        "user"
    ];
    function controller(_user$, _user) {
        function link(scope, element, attrs) {
            const className = attrs.addClassOnLogin;
            function setClass(status) {
                element.removeClass(className);
                if (status) element.addClass(className);
            }
            setClass(_user.status);
            _user$.subscribe((data)=>{
                setClass(_user.status);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("addClassOnLogin", controller);
})();


var $cd9e1becc6b76759$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "airDatepicker"
    };
    controller.$inject = [
        "$filter",
        "$parse",
        "config"
    ];
    function controller($filter, $parse, _config) {
        const link = ($scope, $element, $attrs, $ctrl)=>{
            const params = $scope.$eval($attrs[directive.name]);
            const defaultOptions = {
                single: {
                    toggleSelected: false
                },
                range: {
                    multipleDatesSeparator: " - ",
                    range: true
                }
            };
            let airDatepicker = null;
            let datepickerLanguage = null;
            const airDatepickerLoad = Promise.all([
                (parcelRequire("eVcdp")),
                chooseLang(_config.currentLang)
            ]);
            airDatepickerLoad.then(([{ default: AirDatepicker }, language])=>{
                datepickerLanguage = language.default;
                airDatepicker = new AirDatepicker($element[0], Object.assign({
                    locale: datepickerLanguage,
                    autoClose: true,
                    dateFormat: "dd.MM.yyyy",
                    onSelect: function({ date: date }) {
                        $scope.$apply(function() {
                            if (angular.isArray(date)) {
                                const fromValueSetter = $parse(params.fromValue).assign;
                                const toValueSetter = $parse(params.toValue).assign;
                                fromValueSetter($scope, $filter("date")(date[0], "yyyy-MM-dd"));
                                toValueSetter($scope, $filter("date")(date[1], "yyyy-MM-dd"));
                                return;
                            }
                            $ctrl.$setViewValue($filter("date")(date, "yyyy-MM-dd"));
                        });
                    }
                }, params.type ? defaultOptions[params.type] : defaultOptions.single, params?.datepickerOptions));
            });
            async function chooseLang(lang) {
                try {
                    const { [lang]: langImportFunction } = await (parcelRequire("7jFWT"));
                    if (langImportFunction) return langImportFunction();
                    return await (parcelRequire("cmfxZ"));
                } catch (error) {
                    console.error(error);
                }
            }
            $ctrl.$formatters.push((value)=>{
                return $filter("date")(value, "dd.MM.yyyy");
            });
            $scope.$on("$destroy", ()=>{
                airDatepicker.destroy();
            });
        };
        return {
            require: "ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $287b6bf1200c4bdd$exports = {};


(function() {
    "use strict";
    app.factory("seo", controller);
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        return {
            item (params) {
                const defer = $q.defer();
                const alias = "seoItem";
                const config = {
                    params: params,
                    cache: true,
                    meta: {
                        cache: true,
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer);
                });
                return defer.promise;
            },
            meta$: new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)()
        };
    }
})();



(function() {
    "use strict";
    const directive = {
        name: "animateTitleLeave"
    };
    controller.$inject = [
        "$translate",
        "seo"
    ];
    function controller($translate, _seo) {
        async function link(scope, element, attrs) {
            let listener;
            let interval = null;
            let originalTitle = document.title;
            const { titleKey: titleKey = "" } = scope.$eval(attrs[directive.name]) || {};
            const titleEmoji = await $translate(titleKey);
            const inactiveTitle = titleEmoji.replace(/(&\#\d+\S)/g, replaceEmoji);
            const inactiveTitleArr = inactiveTitle.split("/");
            function replaceEmoji(match, offset, string) {
                return String.fromCodePoint(match.replace(/[^\d;]/g, ""));
            }
            function changeTitle() {
                if (!document.hidden) {
                    clearInterval(interval);
                    document.title = originalTitle;
                    return;
                }
                let index = 0;
                interval = setInterval(()=>{
                    document.title = inactiveTitleArr[index];
                    if (++index === inactiveTitleArr.length) index = 0;
                }, 300);
            }
            _seo.meta$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((data)=>data.event === "title updated")).subscribe((data)=>{
                originalTitle = data.title || "";
                if (!listener) listener = addListener();
            });
            function addListener() {
                return document.addEventListener("visibilitychange", changeTitle);
            }
            if (originalTitle) listener = addListener();
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $1a46add3d6212c6e$exports = {};

(function() {
    "use strict";
    // this directive used for watching all inputs in the form and send formData to backabd after blur event
    const directive = {
        name: "bindAnalyticsClick"
    };
    controller.$inject = [
        "analytics"
    ];
    function controller(analytics) {
        function link(scope, element, attrs) {
            scope.track = analytics.send.bind(analytics);
            scope.$parent.track = analytics.send.bind(analytics);
            element[0].onclick = ()=>{
                const params = scope.$parent.$eval(attrs[directive.name]) || {};
                analytics.send(...params);
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $69a4e072499dfde4$exports = {};

(function() {
    "use strict";
    // this directive used for watching all inputs in the form and send formData to backabd after blur event
    const directive = {
        name: "bindAnalytics"
    };
    controller.$inject = [
        "analytics"
    ];
    function controller(analytics) {
        function link(scope, element, attrs) {
            scope.track = analytics.send.bind(analytics);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $4608c723439f4a51$exports = {};
(function() {
    "use strict";
    app.directive("bindHtmlCompile", [
        "$compile",
        function($compile) {
            return {
                restrict: "A",
                link: function(scope, element, attrs) {
                    scope.$watch(function() {
                        return scope.$eval(attrs.bindHtmlCompile);
                    }, function(value) {
                        let compileScope = scope;
                        element.html(value && value.toString());
                        if (attrs.bindHtmlScope) compileScope = scope.$eval(attrs.bindHtmlScope);
                        $compile(element.contents())(compileScope);
                    });
                }
            };
        }
    ]);
})();


var $aada78c8e2f5a9aa$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "system"
    ];
    function controller(_system) {
        const defaultState = {
            tab: "deposit",
            step: "payments",
            set: setValue,
            get showCryptoTab () {
                return _system.systemInfo.cashbox?.buy_crypto_enabled || false;
            }
        };
        const currentState$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)(defaultState);
        const getValue = ()=>currentState$.getValue();
        const reset = ()=>currentState$.next(defaultState);
        function setValue(nextState) {
            const prevState = getValue();
            if (!nextState.tab || nextState.tab === prevState.tab) {
                currentState$.next({
                    ...prevState,
                    ...nextState
                });
                return;
            }
            currentState$.next({
                ...defaultState,
                ...nextState
            });
        }
        return {
            currentState$: currentState$,
            setValue: setValue,
            getValue: getValue,
            reset: reset
        };
    }
    app.factory("cashboxState", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "cashboxState"
    };
    factory.$inject = [
        "cashboxState"
    ];
    function factory(_cashboxState) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            const variable = config.name || "cashboxState";
            const additionalData = config.data || null;
            if (additionalData) _cashboxState.setValue(additionalData);
            scope[variable] = _cashboxState.getValue();
            const subscription = _cashboxState.currentState$.subscribe((newState)=>{
                const fieldsToChange = Object.keys(newState);
                fieldsToChange.forEach((field)=>{
                    if (scope.hasOwnProperty(field)) scope[field] = newState[field];
                });
                scope[variable] = newState;
            });
            scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $4ff38f2ad0010e6e$exports = {};

(function() {
    "use strict";
    app.directive("chatOpen", controller);
    controller.$inject = [
        "system$"
    ];
    function controller(_system$) {
        function link(scope, element, attrs) {
            element.on("click", _system$.next.bind(_system$, {
                action: "open chat"
            }));
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $bbc2176d196fb846$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http",
        "localStorage"
    ];
    function controller($q, _http, _localStorage) {
        return {
            banking (options) {
                const defer = $q.defer();
                const alias = "pSystemCollection";
                const ls = _localStorage.getAffiliateData();
                options = Object.assign({}, ls, options);
                const config = {
                    params: options,
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            collection (options) {
                const defer = $q.defer();
                const alias = "pSystemList";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("paysystem", controller);
})();



(function() {
    const paymentsWithoutAmount = [
        "siru_fi",
        "cbc_bitcoin_channel",
        "siru_se",
        "siru_no"
    ];
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        return {
            hasAmount (system) {
                return !paymentsWithoutAmount.includes(system);
            },
            auth (options) {
                const defer = $q.defer();
                const alias = "pAuth";
                const data = options;
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            deposit (options) {
                const defer = $q.defer();
                const alias = "pDeposit";
                const data = options;
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            withdraw (options) {
                const defer = $q.defer();
                const alias = "pWithdraw";
                const data = options;
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            check (options) {
                const defer = $q.defer();
                const alias = "checkPayment";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            details (options) {
                const defer = $q.defer();
                const alias = "paymentDetails";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            // using only for interac
            getDetails (options) {
                const defer = $q.defer();
                const alias = "pInterac";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            promoCode (data) {
                const defer = $q.defer();
                const alias = "pPromoCode";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then(function(answer) {
                    defer.resolve(answer.result);
                }, function(answer) {
                    defer.reject(answer.message);
                });
                return defer.promise;
            },
            lastDep (options) {
                const defer = $q.defer();
                const alias = "historyLastDep";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            makeLastDevcodeDep (data) {
                const defer = $q.defer();
                const alias = "pLastDevcodeDep";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data.message);
                });
                return defer.promise;
            },
            makeForm (path, params, el) {
                document.querySelector("#depositForm")?.remove();
                const form = document.createElement("form");
                form.setAttribute("method", "POST");
                form.setAttribute("action", path);
                form.setAttribute("id", "depositForm");
                form.setAttribute("target", "depositWindow");
                for(const key in params)if (params.hasOwnProperty(key)) {
                    const hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", params[key]);
                    form.appendChild(hiddenField);
                }
                el.append(form);
                form.submit();
            }
        };
    }
    app.factory("payment", controller);
})();




(function() {
    "use strict";
    app.directive("checkLastDeposit", controller);
    controller.$inject = [
        "paysystem",
        "payment",
        "popup",
        "contentBuffer"
    ];
    function controller(_paysystem, _payment, _popup, _contentBuffer) {
        let lastDepFlag = false;
        function link(scope, element, attrs) {
            if (_contentBuffer.read("popup").paySystem) return;
            const tabNameFromAttr = scope.$eval(attrs.checkLastDeposit) || "deposit";
            scope.preloader = true;
            scope.deposit = null;
            const depositList = _paysystem.collection({
                type: "deposit"
            }).then((depositList)=>depositList.result);
            const depositLast = _payment.lastDep().then((depositLast)=>depositLast.result);
            Promise.all([
                depositList,
                depositLast
            ]).then((depositArray)=>{
                depositArray[0].find((item)=>{
                    const paymentSystem = depositArray[1].payment_system || depositArray[1].paysystem;
                    if (item.name === paymentSystem.name) {
                        scope.deposit = Object.assign({}, {
                            ...item
                        }, {
                            amount: depositArray[1].amount
                        });
                        if (!lastDepFlag) {
                            _popup.open({
                                name: "cashbox",
                                content: {
                                    tab: `${tabNameFromAttr}`,
                                    paySystem: {
                                        ...scope.deposit
                                    }
                                }
                            });
                            lastDepFlag = true;
                        }
                    }
                });
            }).catch(()=>{}).finally(()=>{
                scope.preloader = false;
            });
            scope.$on("$destroy", ()=>{
                lastDepFlag = false;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $98beaaa46a60a064$exports = {};

(function() {
    "use strict";
    app.directive("checkPendingWithdrawals", controller);
    controller.$inject = [
        "user"
    ];
    function controller(_user) {
        function link(scope) {
            scope.checkPendingWithdrawals = !!_user.profile.pending_withdrawals;
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $097cffeb2a61b359$exports = {};


(function() {
    closeRegistrationTrackerController.$inject = [
        "account",
        "$scope",
        "config",
        "$window"
    ];
    function closeRegistrationTrackerController(account, scope, appConfig, globalWindow) {
        this.sendData = function() {
            const email = scope.closedRegistrationTracker && scope.closedRegistrationTracker.email ? scope.closedRegistrationTracker.email : "";
            if (appConfig.currentLang && email && /[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,5}/.test(email)) account.collectRegistrationAnalytics({
                email: email,
                language: appConfig.currentLang
            });
        };
        this.listenTabClose = function() {
            globalWindow.addEventListener("beforeunload", this.sendData);
        };
        this.destroyTabCloseListener = function() {
            globalWindow.removeEventListener("beforeunload", this.sendData);
        };
    }
    app.directive("closedRegistrationTracker", function() {
        return {
            restrict: "A",
            scope: {
                closedRegistrationTracker: "<"
            },
            controller: closeRegistrationTrackerController,
            link: function(scope, element, attrs, controller) {
                controller.listenTabClose();
                element.on("click", controller.sendData);
                scope.$on("$destroy", ()=>{
                    controller.destroyTabCloseListener();
                    element.off("click", controller.sendData);
                });
            }
        };
    });
})();


var $8d7293feb760b040$exports = {};
// https://github.com/catdad/canvas-confetti
(function() {
    "use strict";
    const directive = {
        name: "confetti"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const script = document.createElement("script");
            script.src = `https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js`;
            document.head.appendChild(script);
            script.onload = function() {
                const config = scope.$eval(attrs.settings);
                confetti(config);
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c8645de37dddcfd6$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("cookie$", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "cookie$"
    ];
    function controller(cookie$) {
        const link = function link(scope, element, attrs) {
            element.on("click", function() {
                cookie$.next({
                    event: "banner_open"
                });
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("cookieSettings", controller);
})();


var $a73fde242d0fe37c$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "copyToClipboard"
    };
    controller.$inject = [
        "config",
        "$window"
    ];
    function controller(_config, $window) {
        const link = (scope, element, attrs)=>{
            attrs.$observe(directive.name, (value)=>{
                if (!value) return false;
                element.on("click", ()=>{
                    const textArea = document.createElement("textArea");
                    textArea.value = value;
                    document.body.appendChild(textArea);
                    if (_config.ios) {
                        textArea.readOnly = true;
                        textArea.contentEditable = true;
                        const range = document.createRange();
                        range.selectNodeContents(textArea);
                        const selection = $window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(range);
                        textArea.setSelectionRange(0, 999999);
                    } else textArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textArea);
                });
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e5c64a3583476805$exports = {};
// https://mymth.github.io/vanillajs-datepicker/#/
(function() {
    "use strict";
    const directive = {
        name: "datepickerBirthday"
    };
    function controller() {
        function link($scope, $element, $attrs, $ngModelCtrl) {
            const element = $element[0];
            const defaultFormat = "yyyy-mm-dd";
            const { modelFormat: modelFormat = defaultFormat, viewFormat: viewFormat = defaultFormat, minAge: minAge = 18 } = $scope.$eval($attrs[directive.name]) || {};
            const updateModel = (modelValue)=>$scope.$apply(()=>$ngModelCtrl.$setViewValue(modelValue));
            const datepickerOptions = {
                autohide: true,
                format: viewFormat,
                minDate: new Date().setFullYear(new Date().getFullYear() - 100),
                maxDate: new Date().setFullYear(new Date().getFullYear() - minAge),
                startView: 2
            };
            const datepickerInstance = new Datepicker(element, datepickerOptions);
            element.addEventListener("changeDate", ()=>{
                const formattedPickedDate = datepickerInstance.getDate(modelFormat);
                updateModel(formattedPickedDate);
            });
            $scope.$on("$destroy", ()=>{
                datepickerInstance.destroy();
            });
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel",
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $4da3c54cb1f3e547$exports = {};


app.directive("datepicker", function() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function(scope, elem, attrs, ngModelCtrl) {
            Promise.resolve((parcelRequire("1E71g"))).then(($)=>{
                // eslint-disable-next-line angular/window-service
                window.jQuery = $;
                (parcelRequire("jrvpg")).then(()=>{
                    const updateModel = function(dateText) {
                        scope.$apply(function() {
                            ngModelCtrl.$setViewValue(dateText);
                        });
                    };
                    const datepickerBody = attrs.datepickerBody || ".datepicker-body";
                    const options = {
                        onClose: function() {
                            elem.removeClass("datepicker-open");
                        },
                        dateFormat: "yy-mm-dd",
                        onSelect: function(dateText) {
                            updateModel(dateText);
                        },
                        beforeShow: function(textbox, instance) {
                            elem.addClass("datepicker-open");
                            $(elem).parent().find(datepickerBody).append($("#ui-datepicker-div"));
                        },
                        changeMonth: true,
                        changeYear: true,
                        yearRange: attrs.yearRange || "-100:-18",
                        defaultDate: attrs.defaultDate || "1998-01-01"
                    };
                    if (attrs.minDate) options.minDate = attrs.minDate;
                    $(elem).datepicker(options);
                });
            });
        }
    };
});


var $db7228365b7a3b5d$exports = {};
(function() {
    "use strict";
    app.directive("embedSrc", controller);
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            let current = element;
            scope.$watch(()=>attrs.embedSrc, ()=>{
                const clone = element.clone().attr("src", attrs.embedSrc);
                current.replaceWith(clone);
                current = clone;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $e393e147de7f6882$exports = {};
class $d89b93dab3f25f34$var$Entity {
    static $inject = [
        "$q",
        "http"
    ];
    constructor($q, http){
        this.$q = $q;
        this.http = http;
    }
    getFeatureFlags() {
        return this.http.getData("entityInfo", {}, true).then(({ result: result })=>{
            return result?.options?.feature_flags || {};
        });
    }
    getAuthStrategy() {
        return this.http.getData("entityInfo", {}, true).then(({ result: result })=>{
            return result?.options?.auth_strategy;
        });
    }
}
// eslint-disable-next-line angular/no-service-method
app.service("entity", $d89b93dab3f25f34$var$Entity);


class $e393e147de7f6882$var$GetAuthStrategy {
    static $inject = [
        "entity"
    ];
    constructor(entity){
        this.entity = entity;
    }
    link(scope, element, attrs, ctrl) {
        const defaultAuthStrategy = "zimpler";
        this.entity.getAuthStrategy().then((answer)=>{
            scope.authStrategy = answer || defaultAuthStrategy;
        }).catch(()=>{
            scope.authStrategy = defaultAuthStrategy;
        });
    }
}
app.directive("getAuthStrategy", ()=>{
    return {
        restrict: "A",
        controller: $e393e147de7f6882$var$GetAuthStrategy,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope, element, attrs, ctrl);
        }
    };
});


var $016d57c1d6e3b4ff$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http"
    ];
    function controller($q, _http) {
        const o = {
            object: {},
            list: list
        };
        function list(options) {
            const defer = $q.defer();
            const alias = "categoryList";
            const config = {
                params: options,
                cache: true,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then((answer)=>{
                o.object = answer.data.result.toObject("name");
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        return o;
    }
    app.factory("category", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "getCategoriesToScope"
    };
    factory.$inject = [
        "category"
    ];
    function factory(_category) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "categories";
            scope[variable] = {};
            _category.list({
                count: 1000
            }).then((a)=>{
                scope[variable].__proto__ = _category.object;
            }).catch((e)=>{});
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $74ed929c7d9152c5$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "getCollectionGamehallToScope"
    };
    factory.$inject = [
        "collection"
    ];
    function factory(_collection) {
        function link(scope) {
            scope.collectionGameHall = [];
            _collection.collectionHall().then((a)=>{
                scope.collectionGameHall = a.result;
                scope.GameHallByAlias = a.result.toObject("alias");
            }).catch((e)=>{});
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $39419d7b9fdb12b2$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "getCollectionsToScope"
    };
    factory.$inject = [
        "collection"
    ];
    function factory(_collection) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "collections";
            scope[variable] = {};
            _collection.list().then((a)=>{
                scope[variable].__proto__ = _collection.object;
            }).catch((e)=>{});
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $ef18857d9f56b14b$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        function link(scope, element, attrs) {
            const variable = attrs.getConfigToScope || "config";
            scope[variable] = {};
            scope[variable].__proto__ = _config;
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("getConfigToScope", controller);
})();


var $e1e36c07c4bba367$exports = {};





(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("countryLayout$", controller);
})();



(function() {
    "use strict";
    app.factory("countryLayout", controller);
    controller.$inject = [
        "config",
        "system",
        "user",
        "system$",
        "countryLayout$"
    ];
    function controller(_config, _system, _user, _system$, _countryLayout$) {
        const countryConfig = {};
        const setValueInConfig = (code, layout)=>{
            countryConfig[layout.type] = layout.countries.includes(code.toLowerCase());
        };
        const updateConfig = (layouts)=>{
            if (!_user.status) {
                _system.info().then(({ result: result })=>{
                    layouts.forEach((layout)=>{
                        setValueInConfig(result.country.code, layout);
                    });
                });
                return;
            }
            layouts.forEach((layout)=>{
                setValueInConfig(_user.profile.country, layout);
            });
            _countryLayout$.next(countryConfig);
        };
        const init = ()=>{
            if (typeof $_LAYOUT_FIRST !== "object") return;
            updateConfig($_LAYOUT_FIRST);
            _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
                updateConfig($_LAYOUT_FIRST);
            });
        };
        return {
            init: init,
            countryConfig: countryConfig
        };
    }
})();



(function() {
    "use strict";
    const directive = {
        name: "getCountryLayoutToScope"
    };
    controller.$inject = [
        "countryLayout",
        "countryLayout$"
    ];
    function controller(_countryLayout, _countryLayout$) {
        function link($scope, element, attrs) {
            const variable = attrs[directive.name] || "countryLayout";
            $scope[variable] = _countryLayout.countryConfig;
            const subscription = _countryLayout$.subscribe((data)=>{
                $scope[variable] = data;
            });
            $scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $facf5638d8813c26$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "getCurrentTimeToScope"
    };
    controller.$inject = [
        "$interval"
    ];
    function controller($interval) {
        function link(scope, element, attrs) {
            const variable = attrs.getCurrentTimeToScope && attrs.getCurrentTimeToScope !== "get-current-time-to-scope" ? attrs.getCurrentTimeToScope : "currentTime";
            scope[variable] = new Date().getTime();
            $interval(()=>{
                scope[variable] = new Date().getTime();
            }, 1000);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $74fd07703a575aec$exports = {};




const $74fd07703a575aec$var$directiveName = "getFooterDataToScope";
class $74fd07703a575aec$var$FooterManagement {
    static $inject = [
        "http",
        "system$",
        "captcha"
    ];
    constructor(http, system$, captcha){
        this.http = http;
        this.system$ = system$;
        this.captcha = captcha;
    }
    getDataToScope(scope) {
        this.http.getData("footer").then(({ result: result })=>{
            scope.text = result.text;
            scope.hiddenText = result.hiddenText;
            scope.iconCollection = result.icons;
        }).catch((error)=>{
            console.warn(error);
        });
    }
    link(scope) {
        this.getDataToScope(scope);
        let recaptchaToken = null;
        let needVerification = true;
        scope.validateUser = ()=>{
            if (needVerification) {
                needVerification = false;
                this.captcha.execute("footerVerify").then((response)=>{
                    recaptchaToken = response;
                }).catch((error)=>error).finally((data)=>{
                    if (recaptchaToken) this.http.postData("footerVerify", {}, recaptchaToken, true).then(()=>{
                        scope.isVerified = true;
                    });
                });
            }
        };
        this.subscription = this.system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
            this.getDataToScope(scope);
        });
        this.$onDestroy = ()=>{
            this.subscription.unsubscribe();
        };
    }
}
app.directive($74fd07703a575aec$var$directiveName, ()=>{
    return {
        restrict: "A",
        controller: $74fd07703a575aec$var$FooterManagement,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope);
        }
    };
});


var $202e3767bd7995ae$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "contentBuffer",
        "contentBuffer$"
    ];
    function controller(_contentBuffer, _contentBuffer$) {
        function link(scope, element, attrs) {
            const variable = attrs.getModalContentToScope || "config";
            scope[variable] = _contentBuffer.read("modal");
            _contentBuffer$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((data)=>data.name === "modal")).subscribe((data)=>{
                scope[variable] = _contentBuffer.read("modal");
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("getModalContentToScope", controller);
})();


var $ee4da7aa598a998c$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "contentBuffer",
        "contentBuffer$"
    ];
    function controller(_contentBuffer, _contentBuffer$) {
        function link(scope, element, attrs) {
            const variable = attrs.getPopupContentToScope || "config";
            scope[variable] = _contentBuffer.read("popup");
            _contentBuffer$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((data)=>data.name === "popup")).subscribe((data)=>{
                scope[variable] = _contentBuffer.read("popup");
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("getPopupContentToScope", controller);
})();


var $d9779ff4707ea63c$exports = {};







(function() {
    "use strict";
    controller.$inject = [
        "http",
        "user",
        "state",
        "remembered",
        "system$"
    ];
    function controller(_http, _user, _state, _remembered, _system$) {
        let isInitialized = false;
        const maxCount = 100;
        const games$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)([]);
        const removeGame = (game)=>{
            games$.next(games$.getValue().filter(({ id: id })=>id !== game.id));
        };
        const addGame = (game)=>{
            games$.next([
                ...games$.getValue(),
                game
            ]);
        };
        const toggle = (game)=>{
            const options = {
                id: game.id
            };
            const alias = "gameToggleFav";
            const config = {
                cache: false,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            if (!_user.status) {
                const rememberedLogin = _remembered.login;
                if (!rememberedLogin) return _state.goto("registration");
                return _state.goto("login");
            }
            game.favorites ? removeGame(game) : addGame(game);
            _http.post(alias, options, config).catch(()=>{
                game.favorites ? addGame(game) : removeGame(game);
            });
        };
        const requestGames = ()=>{
            isInitialized = true;
            const alias = "gameList";
            const config = {
                params: {
                    favorites: true,
                    count: maxCount
                },
                cache: false,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then(({ data: { result: result } })=>games$.next(result)).catch(({ data: data })=>console.error(data));
        };
        const collection = (count)=>{
            if ((!isInitialized || count > maxCount) && _user.status) requestGames();
            if (count > maxCount) count = maxCount;
            return games$.pipe((0, $32594888be9d26d0$export$871de8747c9eaa88)((games)=>games.slice(0, count ?? maxCount)));
        };
        const shouldSetFavorite = (games, game)=>{
            if (!game.id) return;
            return games.some(({ id: id })=>id === game.id) && !game.favorites;
        };
        const shouldRemoveFavorite = (games, game)=>{
            if (!game.id) return;
            return !games.some(({ id: id })=>id === game.id) && game.favorites;
        };
        _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((event)=>event.action === "logout")).subscribe(()=>{
            isInitialized = false;
            games$.next([]);
        });
        return {
            collection: collection,
            toggle: toggle,
            shouldSetFavorite: shouldSetFavorite,
            shouldRemoveFavorite: shouldRemoveFavorite
        };
    }
    app.factory("favorites", controller);
})();





/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $c8nQ0 = parcelRequire("c8nQ0");
var $ff0a212897d61208$export$fec474e58f10935f = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, $c8nQ0.AsyncAction));


/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $kYlIh = parcelRequire("kYlIh");
var $532a4029a9eba1bd$export$6a0c75a6abc7ad50 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, $kYlIh.AsyncScheduler));


var $af0588c9fb53af5f$export$69a3263547af8af8 = /*@__PURE__*/ new (0, $532a4029a9eba1bd$export$6a0c75a6abc7ad50)((0, $ff0a212897d61208$export$fec474e58f10935f));
var $af0588c9fb53af5f$export$4f7fa46ff53e516f = $af0588c9fb53af5f$export$69a3263547af8af8;



var $iIdN6 = parcelRequire("iIdN6");
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");

var $4Wpcr = parcelRequire("4Wpcr");
function $e8cab0ec995870d6$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $e8cab0ec995870d6$export$b8e2e9b883c1952(scheduler, delay));
    };
}
var $e8cab0ec995870d6$export$b8e2e9b883c1952 = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e8cab0ec995870d6$export$2ccc19882708a0(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var $e8cab0ec995870d6$export$2ccc19882708a0 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $e8cab0ec995870d6$export$6358f3d000008d47(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, $4Wpcr.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, $4Wpcr.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, $4Wpcr.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, $2Dqpi.Subscriber));
var $e8cab0ec995870d6$export$6358f3d000008d47 = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();




var $c904b59ef7f02b4e$export$915d2682b0aa0991 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        } else _this.next = _this.nextTimeWindow;
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function(value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function(value) {
        if (!this.isStopped) {
            this._events.push(new $c904b59ef7f02b4e$var$ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) throw new (0, $9562945f97ba487a$export$f708eee25634bc80)();
        else if (this.isStopped || this.hasError) subscription = (0, $iIdN6.Subscription).EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new (0, $1c7df2899dc9d4fc$export$b7a41f2bfb5c60c3)(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new (0, $e8cab0ec995870d6$export$2ccc19882708a0)(subscriber, scheduler));
        if (_infiniteTimeWindow) for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i]);
        else for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || (0, $af0588c9fb53af5f$export$4f7fa46ff53e516f)).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}((0, $19fbb7818f827ed3$export$b6bbab5a9b109038));
var $c904b59ef7f02b4e$var$ReplayEvent = /*@__PURE__*/ function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();


/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");



function $47f686d3d2a0734e$export$d70d492cd31004c0(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe($47f686d3d2a0734e$export$d70d492cd31004c0(function(a, i) {
            return (0, $c3f2ce8520f4fff9$export$6788812c4e6611e6)(project(a, i)).pipe((0, $32594888be9d26d0$export$871de8747c9eaa88)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new $47f686d3d2a0734e$var$ExhaustMapOperator(project));
    };
}
var $47f686d3d2a0734e$var$ExhaustMapOperator = /*@__PURE__*/ function() {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $47f686d3d2a0734e$var$ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}();
var $47f686d3d2a0734e$var$ExhaustMapSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    ExhaustMapSubscriber.prototype.tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result);
    };
    ExhaustMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscriber = new (0, $f1a21b598f0f6aea$export$20b3446cf1c359c0)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, $f1a21b598f0f6aea$export$d34bac9c0f124cff)(result, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    ExhaustMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return ExhaustMapSubscriber;
}((0, $f1a21b598f0f6aea$export$b73f91a09e7d5376));


(function() {
    controller.$inject = [
        "game",
        "user",
        "system$"
    ];
    function controller(_game, _user, _system$) {
        const count = 1;
        let hasGame = false;
        const recentlyPlayed$ = new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)();
        const requestGame$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        requestGame$.pipe((0, $47f686d3d2a0734e$export$d70d492cd31004c0)(()=>requestGame()), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ total_count: total_count })=>total_count > 0)).subscribe(()=>{
            hasGame = true;
            recentlyPlayed$.next(hasGame);
        });
        const requestGame = ()=>{
            return _game.recentlyPlayed({
                count: count
            });
        };
        const checkRecentlyPlayed = ()=>{
            if (!_user.status) {
                hasGame = false;
                recentlyPlayed$.next(hasGame);
                return;
            }
            if (_user.status && !hasGame) requestGame$.next();
        };
        _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((event)=>event.action === "statusChanged")).subscribe(()=>{
            checkRecentlyPlayed();
        });
        return {
            recentlyPlayed$: recentlyPlayed$,
            checkRecentlyPlayed: checkRecentlyPlayed
        };
    }
    app.factory("recentlyPlayed", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "getPrivateCategories"
    };
    factory.$inject = [
        "favorites",
        "recentlyPlayed"
    ];
    function factory(_favorites, _recentlyPlayed) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "privateCategories";
            scope[variable] = {
                favourites: false,
                recentlyPlayed: false
            };
            const favSubscription = _favorites.collection().subscribe((games)=>{
                scope[variable].favourites = games.length > 0;
            });
            const recentlyPlayedSubscription = _recentlyPlayed.recentlyPlayed$.subscribe((hasGame)=>{
                scope[variable].recentlyPlayed = hasGame;
            });
            _recentlyPlayed.checkRecentlyPlayed();
            scope.$on("$destroy", ()=>{
                recentlyPlayedSubscription.unsubscribe();
                favSubscription.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $7f8b9bfe79d38f32$exports = {};

const $9d18efb070476883$export$474e813eadd47813 = {
    "result": [
        {
            "promo_start_date": 1683234000000,
            "active_date": 1688158800000,
            "close_date": 1690750800000,
            "template": "summer-promotion",
            "menu_item_name": "summer",
            "menu_item_image": null,
            "title": "Summer Calendar",
            "texts": [
                "Summer Calendar",
                "Different Offer Every Day! Up to \u20AC300 in Bonuses!",
                "Get Bonus"
            ],
            "images": [],
            "colors": [],
            "events": [
                {
                    "id": "2002",
                    "type": "casino",
                    "date": 1688158800000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!\nGet a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<holidayListWithSpoertp><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</holidayListWithSpoertp>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2005",
                    "type": "casino",
                    "date": 1688245200000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 04.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; The offer gives you up to 100 Free Spins when you wager a total of 700 EUR on Spinomenal.</p>\n<p><span>3.</span>&nbsp; The minimum wagering requirement to qualify for 20 Free Spins is 100 EUR. An additional 300 EUR wagering will reward a further 30 free spins. Wagering another 300 EUR will reward the final 50 free spins.</p>\n<p><span>4.</span>&nbsp; The Free Spins will be credited on Easter Gifts</p>\n<p><span>5.</span>&nbsp;As soon as the minimum qualifying wagering requirement is met, the free spins will be credited in the player's account. As soon as the 2 additional wagering requirements are met to gain the other additional free spins, the free spins will be credited in the player's account.</p>\n<p><span>6.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>7.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>8.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>9.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>10.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>11.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR until all necessary wagering requirements are met.</p>\n<p><span>12.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>13.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>14.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>15.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>16.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Play Now",
                        "url": "spinomenal"
                    },
                    "public_button": {
                        "text": "Play Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2008",
                    "type": "casino",
                    "date": 1688331600000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "03.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 04.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; The offer gives you up to 100 Free Spins when you wager a total of 700 EUR on Spinomenal.</p>\n<p><span>3.</span>&nbsp; The minimum wagering requirement to qualify for 20 Free Spins is 100 EUR. An additional 300 EUR wagering will reward a further 30 free spins. Wagering another 300 EUR will reward the final 50 free spins.</p>\n<p><span>4.</span>&nbsp; The Free Spins will be credited on Easter Gifts</p>\n<p><span>5.</span>&nbsp;As soon as the minimum qualifying wagering requirement is met, the free spins will be credited in the player's account. As soon as the 2 additional wagering requirements are met to gain the other additional free spins, the free spins will be credited in the player's account.</p>\n<p><span>6.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>7.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>8.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>9.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>10.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>11.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR until all necessary wagering requirements are met.</p>\n<p><span>12.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>13.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>14.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>15.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>16.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Play Now",
                        "url": "spinomenal"
                    },
                    "public_button": {
                        "text": "Play Now",
                        "url": " registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2011",
                    "type": "casino",
                    "date": 1688418000000,
                    "status": 0,
                    "title": [
                        "\u20AC10 Live Casino Bonus"
                    ],
                    "terms": [
                        "Enjoy Evolution GameShows - if the wager is successful, you get a \u20AC10 in-game bonus!"
                    ],
                    "info": [
                        "Min turnover: \u20AC250",
                        "\u20AC10",
                        "-",
                        "04.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp; This offer is available only once per player on 05.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp;Players can get a 10 EUR / 45 PLN / 100 NOK/ 15 AUD / 60 BRL / 15 CAD/ 11 CHF/ 8,500 CLP / 46,000 COP/ 250 CZK / 3,000 HUF/ 162,500 IDR/ 800 INR/ 1,300 JPY / 210 MXN / 4,750 NGN / 20 NZD / 50 PEN / 15 SGD / 200 TRY / 10 USD/ 160 ZAR/ 45 MYR/ 560 PHP / 235,000 VND / 13,500 KRW / 100 DKK / 50 RON / 380 THB on selected Gameshows.</p>\n<p><span>3.</span>&nbsp;Gameplay via any device (desktop, mobile, tablet) qualifies for this promotion.</p>\n<p><span>4.</span>&nbsp;Only real money counts towards this promotion.</p>\n<p><span>5.</span>&nbsp;The promotional tables are: Crazy Time, Monopoly Big Baller, Monopoly Live, Dream Catcher, Crazy Coin Flip by Evolution.</p>\n<p><span>6.</span>&nbsp;To take part of this promotion player need to wager 250 EUR on the selected games powered by Evolution. </p>\n<p><span>7.</span>&nbsp;Players can benefit from a total of Reward Games voucher per day during the promotional period.</p>\n<p><span>8.</span>&nbsp;Once a player completes the in-game objective, the player gets the message with the reward he/she has received.</p>\n<p><span>9.</span>&nbsp;Reward Games voucher will expire after 10 days.</p>\n<p><span>10.</span>&nbsp;To use their Reward Games, players would need to go to the Evolution Lobby, click the Gift icon and select the table on which they have unlocked the Reward Games (i.e. on the games in the list shown above) to start using them.</p>\n<p><span>11.</span>&nbsp;Players can either use the Reward Games in full as one 10 EUR / 45 PLN / 100 NOK/ 15 AUD / 60 BRL / 15 CAD/ 11 CHF/ 8,500 CLP / 46,000 COP/ 250 CZK / 3.000 HUF/ 162,500 IDR/ 800 INR/ 1,300 JPY / 210 MXN / 4,750 NGN / 20 NZD / 50 PEN / 15 SGD / 200 TRY / 10 USD/ 160 ZAR/ 45 MYR/ 560 PHP / 235,000 VND / 13,500 KRW / 100 DKK / 50 RON / 380 THB bet, or they can make multiple smaller bets for more rounds (when possible).</p>\n<p><span>12.</span>&nbsp;After the player has used their Reward Game, the amount won is added to the Reward Game\u2019s \u2018winnings\u2019 balance. Once they have used all the Reward Game funds, the accumulated winnings are immediately paid out as cash.</p>\n<p><span>13.</span>&nbsp;Reward Games can be used from mobile/desktop.</p>\n<p><span>14.</span>&nbsp;Reward Game funds cannot be combined with real funds.</p>\n<p><span>15.</span>&nbsp;A player can exit the Reward Games play at any time and return back later on to continue where they left off.</p>\n<p><span>16.</span>&nbsp;Winnings from reward games can be a maximum of 10x the original voucher value.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Play Now",
                        "url": "evolution"
                    },
                    "public_button": {
                        "text": "Play Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2014",
                    "type": "casino",
                    "date": 1688504400000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!\nGet a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2017",
                    "type": "casino",
                    "date": 1688590800000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "\u20AC300 + 50 Free Spins",
                        "\u20AC300 + 50 Free Spins",
                        "\u20AC300 + 50 Free Spins",
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2020",
                    "type": "casino",
                    "date": 1688677200000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2023",
                    "type": "casino",
                    "date": 1688763600000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "08.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2024",
                    "type": "casino",
                    "date": 1688850000000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "09.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2026",
                    "type": "casino",
                    "date": 1688936400000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2029",
                    "type": "casino",
                    "date": 1689022800000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2032",
                    "type": "casino",
                    "date": 1689109200000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Get a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2035",
                    "type": "casino",
                    "date": 1689195600000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2038",
                    "type": "casino",
                    "date": 1689282000000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Get a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2041",
                    "type": "casino",
                    "date": 1689368400000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2044",
                    "type": "casino",
                    "date": 1689454800000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Get a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://alfcasino.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                }
            ]
        },
        {
            "promo_start_date": 1683234000000,
            "active_date": 1688158800000,
            "close_date": 1690750800000,
            "template": "summer-promotion",
            "menu_item_name": "summer",
            "menu_item_image": null,
            "title": "Summer Calendar",
            "texts": [
                "Summer Calendar test",
                "Different Offer Every Day! Up to \u20AC300 in Bonuses! test",
                "Get Bonus test"
            ],
            "images": [],
            "colors": [],
            "events": []
        }
    ],
    "messages": []
};
const $9d18efb070476883$export$c217093b307b720d = {
    "result": [
        {
            "promo_start_date": 1683234000000,
            "active_date": 1688158800000,
            "close_date": 1690750800000,
            "template": "summer-promotion",
            "menu_item_name": "summer",
            "menu_item_image": null,
            "title": "Summer Calendar",
            "texts": [
                "Summer Calendar test",
                "Different Offer Every Day! Up to \u20AC300 in Bonuses! test",
                "Get Bonus test"
            ],
            "images": [],
            "colors": [],
            "events": [
                {
                    "id": "2002",
                    "type": "sport",
                    "date": 1688158800000,
                    "status": 0,
                    "title": [
                        "Summertime Madness"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2005",
                    "type": "sport",
                    "date": 1688245200000,
                    "status": 0,
                    "title": [
                        "Risk-Free Sunday"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2008",
                    "type": "sport",
                    "date": 1688331600000,
                    "status": 0,
                    "title": [
                        "Wimbledon Sparks up!"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "03.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2011",
                    "type": "sport",
                    "date": 1688418000000,
                    "status": 0,
                    "title": [
                        "Wimbledon Early Payout"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2014",
                    "type": "sport",
                    "date": 1688504400000,
                    "status": 0,
                    "title": [
                        "Enhanced specials for Wimbledon"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2017",
                    "type": "sport",
                    "date": 1688590800000,
                    "status": 0,
                    "title": [
                        "Wimbledon Accumulator Boost"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "",
                        "",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2020",
                    "type": "sport",
                    "date": 1688677200000,
                    "status": 0,
                    "title": [
                        "Boosted Odds for Wimbledon"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "07.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2023",
                    "type": "sport",
                    "date": 1688763600000,
                    "status": 0,
                    "title": [
                        "Risk-Free Wimbledon"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "08.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2024",
                    "type": "sport",
                    "date": 1688850000000,
                    "status": 0,
                    "title": [
                        "Wimbledon Early Payout"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "09.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2026",
                    "type": "sport",
                    "date": 1688936400000,
                    "status": 0,
                    "title": [
                        "Wimbledon Accumulator Boost"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "10.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2029",
                    "type": "sport",
                    "date": 1689022800000,
                    "status": 0,
                    "title": [
                        "Risk-Free Wimbledon"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "11.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2032",
                    "type": "sport",
                    "date": 1689109200000,
                    "status": 0,
                    "title": [
                        "Enhanced specials for Wimbledon"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "12.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2035",
                    "type": "sport",
                    "date": 1689195600000,
                    "status": 0,
                    "title": [
                        "Wimbledon Early Payout"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "13.07.2023"
                    ],
                    "images": [],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2038",
                    "type": "sport",
                    "date": 1689282000000,
                    "status": 0,
                    "title": [
                        "Risk-Free Wimbledon"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "14.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2041",
                    "type": "sport",
                    "date": 1689368400000,
                    "status": 0,
                    "title": [
                        "Wimbledon Sparks up!"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "15.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2044",
                    "type": "sport",
                    "date": 1689454800000,
                    "status": 0,
                    "title": [
                        "Special Boosted odds"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "16.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2047",
                    "type": "sport",
                    "date": 1689541200000,
                    "status": 0,
                    "title": [
                        "Summertime madness"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "17.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2050",
                    "type": "sport",
                    "date": 1689627600000,
                    "status": 0,
                    "title": [
                        "Risk-Free"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "18.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2053",
                    "type": "sport",
                    "date": 1689714000000,
                    "status": 0,
                    "title": [
                        "(Friendly games) bet&get offer"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "18.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2056",
                    "type": "sport",
                    "date": 1689800400000,
                    "status": 0,
                    "title": [
                        "FIFA Women's World Cup"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "20.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2059",
                    "type": "sport",
                    "date": 1689886800000,
                    "status": 0,
                    "title": [
                        "Early Payout"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "21.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2062",
                    "type": "sport",
                    "date": 1689973200000,
                    "status": 0,
                    "title": [
                        "Summertime madness"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "22.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2065",
                    "type": "sport",
                    "date": 1690059600000,
                    "status": 0,
                    "title": [
                        "Risk-Free Bet builder:"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "23.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2068",
                    "type": "sport",
                    "date": 1690146000000,
                    "status": 0,
                    "title": [
                        "Enhanced specials for FIFA Women's World Cup"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "24.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2071",
                    "type": "sport",
                    "date": 1690232400000,
                    "status": 0,
                    "title": [
                        "Goal Galore"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "25.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2074",
                    "type": "sport",
                    "date": 1690318800000,
                    "status": 0,
                    "title": [
                        "FIFA Women's World Cup"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "26.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2077",
                    "type": "sport",
                    "date": 1690405200000,
                    "status": 0,
                    "title": [
                        "Accumulator boost"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "27.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2080",
                    "type": "sport",
                    "date": 1690491600000,
                    "status": 0,
                    "title": [
                        "Summertime madness"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "28.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1sport-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2083",
                    "type": "sport",
                    "date": 1690578000000,
                    "status": 0,
                    "title": [
                        "Enhanced odds for correct score on FIFA Women's World Cup matches of the day"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "29.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2086",
                    "type": "sport",
                    "date": 1690664400000,
                    "status": 0,
                    "title": [
                        "Accumulator boost"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "30.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2089",
                    "type": "sport",
                    "date": 1690750800000,
                    "status": 0,
                    "title": [
                        "Early Payout"
                    ],
                    "terms": [
                        "Hot Summer - hot offers! Place \u0430t least \u20AC20 live/pre-match bet and get \u20AC10 as a Free Bet!"
                    ],
                    "info": [
                        "Min.bet: \u20AC0.5 / \u20AC20",
                        "-",
                        "-",
                        "31.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685355422700_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This promotion is available to all registered users on our website, who are eligible to receive bonuses.</p>\n<p><span>2.</span>&nbsp;This offer is valid from 03.04.2023 00:00 CET until 03.04.2023 23:59 CET and may be terminated at any time at the administration's discretion.</p>\n<p><span>3.</span>&nbsp;Happy upcoming Easter! The spring is in the air and the hunt is on. In our case - for the egg-ceptional offers and bonuses we've prepared for you.</p>\n<p><span>4.</span>&nbsp;Stay tuned for even more amazing offers here each day till April 12th.</p>\n<p><span>5.</span>&nbsp;To start with \u2014 you are welcome to open our \"Boosted Odds\" section and try out the selections available.</p>\n<p><span>6.</span>&nbsp;Please take a note that max stake allowed for those special markets is 20 EUR / 90 PLN / 200 NOK / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 92,000 COP / 500 CZK / 6.000 HUF / 325,000 IDR / 1,600 INR / 2,600 JPY / 420 MXN / 9,500 NGN / 40 NZD / 100 PEN / 30 SGD / 400 TRY / 20 USD / 320 ZAR / 90 MYR / 1,120 PHP / 470,000 VND / 27,000 KRW / 200 DKK / 100 RON / 760 THB.</p>\n<p><span>7.</span>&nbsp;General Terms and Conditions apply to this offer.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "public_button": {
                        "text": "Bet Now",
                        "url": "sport"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                }
            ]
        },
        {
            "promo_start_date": 1683234000000,
            "active_date": 1688158800000,
            "close_date": 1690750800000,
            "template": "summer-promotion",
            "menu_item_name": "summer",
            "menu_item_image": null,
            "title": "Summer Calendar",
            "texts": [
                "Summer Calendar",
                "Different Offer Every Day! Up to \u20AC300 in Bonuses!",
                "Get Bonus"
            ],
            "images": [],
            "colors": [],
            "events": [
                {
                    "id": "2002",
                    "type": "casino",
                    "date": 1688158800000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!\nGet a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2005",
                    "type": "casino",
                    "date": 1688245200000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 04.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; The offer gives you up to 100 Free Spins when you wager a total of 700 EUR on Spinomenal.</p>\n<p><span>3.</span>&nbsp; The minimum wagering requirement to qualify for 20 Free Spins is 100 EUR. An additional 300 EUR wagering will reward a further 30 free spins. Wagering another 300 EUR will reward the final 50 free spins.</p>\n<p><span>4.</span>&nbsp; The Free Spins will be credited on Easter Gifts</p>\n<p><span>5.</span>&nbsp;As soon as the minimum qualifying wagering requirement is met, the free spins will be credited in the player's account. As soon as the 2 additional wagering requirements are met to gain the other additional free spins, the free spins will be credited in the player's account.</p>\n<p><span>6.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>7.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>8.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>9.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>10.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>11.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR until all necessary wagering requirements are met.</p>\n<p><span>12.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>13.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>14.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>15.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>16.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Play Now",
                        "url": "spinomenal"
                    },
                    "public_button": {
                        "text": "Play Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2008",
                    "type": "casino",
                    "date": 1688331600000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "03.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 04.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; The offer gives you up to 100 Free Spins when you wager a total of 700 EUR on Spinomenal.</p>\n<p><span>3.</span>&nbsp; The minimum wagering requirement to qualify for 20 Free Spins is 100 EUR. An additional 300 EUR wagering will reward a further 30 free spins. Wagering another 300 EUR will reward the final 50 free spins.</p>\n<p><span>4.</span>&nbsp; The Free Spins will be credited on Easter Gifts</p>\n<p><span>5.</span>&nbsp;As soon as the minimum qualifying wagering requirement is met, the free spins will be credited in the player's account. As soon as the 2 additional wagering requirements are met to gain the other additional free spins, the free spins will be credited in the player's account.</p>\n<p><span>6.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>7.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>8.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>9.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>10.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>11.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR until all necessary wagering requirements are met.</p>\n<p><span>12.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>13.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>14.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>15.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>16.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Play Now",
                        "url": "spinomenal"
                    },
                    "public_button": {
                        "text": "Play Now",
                        "url": " registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2011",
                    "type": "casino",
                    "date": 1688418000000,
                    "status": 0,
                    "title": [
                        "\u20AC10 Live Casino Bonus"
                    ],
                    "terms": [
                        "Enjoy Evolution GameShows - if the wager is successful, you get a \u20AC10 in-game bonus!"
                    ],
                    "info": [
                        "Min turnover: \u20AC250",
                        "\u20AC10",
                        "-",
                        "04.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp; This offer is available only once per player on 05.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp;Players can get a 10 EUR / 45 PLN / 100 NOK/ 15 AUD / 60 BRL / 15 CAD/ 11 CHF/ 8,500 CLP / 46,000 COP/ 250 CZK / 3,000 HUF/ 162,500 IDR/ 800 INR/ 1,300 JPY / 210 MXN / 4,750 NGN / 20 NZD / 50 PEN / 15 SGD / 200 TRY / 10 USD/ 160 ZAR/ 45 MYR/ 560 PHP / 235,000 VND / 13,500 KRW / 100 DKK / 50 RON / 380 THB on selected Gameshows.</p>\n<p><span>3.</span>&nbsp;Gameplay via any device (desktop, mobile, tablet) qualifies for this promotion.</p>\n<p><span>4.</span>&nbsp;Only real money counts towards this promotion.</p>\n<p><span>5.</span>&nbsp;The promotional tables are: Crazy Time, Monopoly Big Baller, Monopoly Live, Dream Catcher, Crazy Coin Flip by Evolution.</p>\n<p><span>6.</span>&nbsp;To take part of this promotion player need to wager 250 EUR on the selected games powered by Evolution. </p>\n<p><span>7.</span>&nbsp;Players can benefit from a total of Reward Games voucher per day during the promotional period.</p>\n<p><span>8.</span>&nbsp;Once a player completes the in-game objective, the player gets the message with the reward he/she has received.</p>\n<p><span>9.</span>&nbsp;Reward Games voucher will expire after 10 days.</p>\n<p><span>10.</span>&nbsp;To use their Reward Games, players would need to go to the Evolution Lobby, click the Gift icon and select the table on which they have unlocked the Reward Games (i.e. on the games in the list shown above) to start using them.</p>\n<p><span>11.</span>&nbsp;Players can either use the Reward Games in full as one 10 EUR / 45 PLN / 100 NOK/ 15 AUD / 60 BRL / 15 CAD/ 11 CHF/ 8,500 CLP / 46,000 COP/ 250 CZK / 3.000 HUF/ 162,500 IDR/ 800 INR/ 1,300 JPY / 210 MXN / 4,750 NGN / 20 NZD / 50 PEN / 15 SGD / 200 TRY / 10 USD/ 160 ZAR/ 45 MYR/ 560 PHP / 235,000 VND / 13,500 KRW / 100 DKK / 50 RON / 380 THB bet, or they can make multiple smaller bets for more rounds (when possible).</p>\n<p><span>12.</span>&nbsp;After the player has used their Reward Game, the amount won is added to the Reward Game\u2019s \u2018winnings\u2019 balance. Once they have used all the Reward Game funds, the accumulated winnings are immediately paid out as cash.</p>\n<p><span>13.</span>&nbsp;Reward Games can be used from mobile/desktop.</p>\n<p><span>14.</span>&nbsp;Reward Game funds cannot be combined with real funds.</p>\n<p><span>15.</span>&nbsp;A player can exit the Reward Games play at any time and return back later on to continue where they left off.</p>\n<p><span>16.</span>&nbsp;Winnings from reward games can be a maximum of 10x the original voucher value.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Play Now",
                        "url": "evolution"
                    },
                    "public_button": {
                        "text": "Play Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2014",
                    "type": "casino",
                    "date": 1688504400000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!\nGet a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2017",
                    "type": "casino",
                    "date": 1688590800000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "\u20AC300 + 50 Free Spins",
                        "\u20AC300 + 50 Free Spins",
                        "\u20AC300 + 50 Free Spins",
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2020",
                    "type": "casino",
                    "date": 1688677200000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2023",
                    "type": "casino",
                    "date": 1688763600000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "08.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2024",
                    "type": "casino",
                    "date": 1688850000000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "09.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2026",
                    "type": "casino",
                    "date": 1688936400000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2029",
                    "type": "casino",
                    "date": 1689022800000,
                    "status": 0,
                    "title": [
                        "100 Free Spins Up For Grabs"
                    ],
                    "terms": [
                        "Play on Spinomenal games and win 20, 50 or 100 Free Spins on Easter Gifts!"
                    ],
                    "info": [
                        "Min turnover: \u20AC100 / \u20AC400 / \u20AC700",
                        "20/50/100 FS",
                        "40x",
                        "02.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2032",
                    "type": "casino",
                    "date": 1689109200000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Get a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2035",
                    "type": "casino",
                    "date": 1689195600000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1casino-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2038",
                    "type": "casino",
                    "date": 1689282000000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Get a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "Min. deposit: \u20AC20 / \u20AC50"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2041",
                    "type": "casino",
                    "date": 1689368400000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Kickstart your Easter celebrations with this amazing offer!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                },
                {
                    "id": "2044",
                    "type": "casino",
                    "date": 1689454800000,
                    "status": 0,
                    "title": [
                        "\u20AC300 + 50 Free Spins"
                    ],
                    "terms": [
                        "Get a 60% reload bonus up to \u20AC300 + 50 Free Spins on The Walking Dead today!"
                    ],
                    "info": [
                        "Min. deposit: \u20AC20 / \u20AC50",
                        "\u20AC300 + 50 FS",
                        "30x / 40x (for the FS)",
                        "01.07.2023"
                    ],
                    "images": [
                        "https://nomini.com/dimg/calendar/1685354589290_property-1fs-1min.png"
                    ],
                    "game_name": "",
                    "terms_and_conditions": "<p><span>1.</span>&nbsp;This offer is available only once per player on 03.04.2023 from 00:00 until 23:59 UTC.</p>\n<p><span>2.</span>&nbsp; Deposits made with Neteller or Skrill do not qualify for this promotion.</p>\n<p><span>3.</span>&nbsp; The minimum deposit to qualify for the Deposit Bonus will be 20 EUR / 200 NOK / 90 PLN / 30 AUD / 120 BRL / 30 CAD / 22 CHF / 17,000 CLP / 500 CZK / 6.000 HUF / 1,600 INR / 420 MXN / 40 NZD / 100 PEN / 760 THB / 320 TRY / 20 USD. The minimum deposit to get the additional 50 extra free spins will be 50 EUR / 225 PLN / 500 NOK / 75 AUD / 300 BRL / 75 CAD / 55.0 CHF / 42,500 CLP / 1,250 CZK / 15.000 HUF / 4,000 INR / 1,050 MXN / 23,750 NGN / 100 NZD / 250 PEN / 1,900 THB / 800 TRY / 50 USD.</p>\n<p><span>4.</span>&nbsp; The offer gives you a 60% deposit bonus up to a maximum bonus of 300 EUR / 1,350 PLN / 3000 NOK / 450 AUD / 1,800 BRL / 450 CAD / 330 CHF / 255,000 CLP / 7,500 CZK / 90.000 HUF / 24,000 INR / 6,300 MXN / 142,500 NGN / 600 NZD / 1,500 PEN / 11,400 THB / 4,800 TRY / 300 USD plus 50 Free Spins.</p>\n<p><span>5.</span>&nbsp;The game on which the Free Spins will be credited are displayed in the Daily Offer's box.</p>\n<p><span>6.</span>&nbsp; As soon as the qualifying daily deposit is made, the deposit bonus will be credited in the player's account.</p>\n<p><span>7.</span>&nbsp; If it is not credited automatically, you need to contact us via Live Chat or via e-mail before any bets are made using the qualifying deposit.</p>\n<p><span>8.</span>&nbsp; The wagering requirements on the Deposit Bonus at our Website are 30 times the initial amount of the deposit and bonus received.</p>\n<p><span>9.</span>&nbsp; The Free Spins will be available in \"My Bonuses\" section and will need to be activated after the Deposit Bonus is used, if the Free Spins are activated while there is any amount in the Bonus Balance, the whole Bonus Balance will be voided.</p>\n<p><span>10.</span>&nbsp; The Free Spins will need to be used within 24 hours after being activated.</p>\n<p><span>11.</span>&nbsp;The winnings from the Free spins will be credited in the form a bonus which needs to be wagered 40x times before being withdrawable.</p>\n<p><span>12.</span>&nbsp;The release requirements of each bonus need to be completed within 10 days of the activation of the bonus otherwise the bonus amount and the winnings from it will be voided.</p>\n<p><span>13.</span>&nbsp;The maximum bet allowed while playing with bonus money is&nbsp;5 EUR / 2,000 HUF / 50 NOK / 20 PLN / 400 INR / 10 NZD / 5 CAD / 5 USD / 40 BRL until all necessary wagering requirements are met.</p>\n<p><span>14.</span>&nbsp;There are games contributing differently than the regular Game type. For the game list and for complete Casino Bonus Terms, please visit section 7 of General Terms and conditions.</p>\n<p><span>15.</span>&nbsp;A withdrawal request before claiming the bonus or after the bonus is activated will void the bonus eligibility.</p>\n<p><span>16.</span>&nbsp;A player may cancel an active bonus at any time from the Profile section or by contacting our Support team. By canceling the bonus, the whole amount in the Casino Bonus balance will be voided.</p>\n<p><span>17.</span>&nbsp;This bonus can\u2019t be combined with other bonuses (promotions) at the same time. If you activate another bonus or claim bonus spins while having an active bonus, the current active bonus and any corresponding winnings will be automatically removed.</p>\n<p><span>18.</span>&nbsp;General Terms and Conditions apply to this promotion.</p>",
                    "visible_state": "all",
                    "private_button": {
                        "text": "Claim Now",
                        "url": "deposit"
                    },
                    "public_button": {
                        "text": "Claim Now",
                        "url": "registration"
                    },
                    "game": {
                        "alias": "",
                        "awardsCoords": []
                    }
                }
            ]
        }
    ],
    "messages": []
};


const $b2343a5af81c254c$export$96185cb7d280492c = "holidayApiService";
const $b2343a5af81c254c$var$listCasino = (0, $9d18efb070476883$export$474e813eadd47813);
// const listSport = holidayListJsonSport
// const bonusData = progreessData;
class $b2343a5af81c254c$var$holidayApi {
    static $inject = [
        "$q",
        "http"
    ];
    constructor($q, http){
        this.$q = $q;
        this.http = http;
    }
    list(params = {}) {
        const alias = "holidayList";
        const defer = this.$q.defer();
        const config = {
            params: params,
            meta: {
                type: "api",
                alias: alias
            }
        };
        this.http.get(alias, config).then(({ data: data })=>{
            defer.resolve(data);
        }).catch(()=>{
            defer.reject();
        }).finally(()=>{});
        return defer.promise;
    }
    progress(params = {}) {
        const alias = "holidayProgress";
        const defer = this.$q.defer();
        const config = {
            params: params,
            meta: {
                type: "api",
                alias: alias
            }
        };
        this.http.get(alias, config).then(({ data: data })=>{
            defer.resolve(data);
        }).catch(()=>{
            defer.reject();
        }).finally(()=>{});
        return defer.promise;
    }
    complete(data = {}) {
        const alias = "holidayPromoComplete";
        const defer = this.$q.defer();
        const config = {
            meta: {
                alias: alias
            }
        };
        this.http.post(alias, data, config).then((data)=>{
            defer.resolve(data);
        }).catch((error)=>{
            defer.reject(error);
        }).finally(()=>{});
        return defer.promise;
    }
    start(data = {}) {
        const alias = "holidayPromoStart";
        const defer = this.$q.defer();
        const config = {
            meta: {
                alias: alias
            }
        };
        this.http.post(alias, data, config).then((data)=>{
            defer.resolve(data);
        }).catch((error)=>{
            defer.reject(error);
        }).finally(()=>{});
        return defer.promise;
    }
}
app.factory($b2343a5af81c254c$export$96185cb7d280492c, $b2343a5af81c254c$var$holidayApi);


(function() {
    "use strict";
    const directive = {
        name: "getPromoLinksToScope"
    };
    controller.$inject = [
        "holidayApiService"
    ];
    function controller(_holidayApiService) {
        const holidayCollection = [];
        function link($scope) {
            $scope.holidayCollection = holidayCollection;
            _holidayApiService.list().then((data)=>{
                $scope.holidayCollection = data.result;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $5f2e5ad68336bd29$exports = {};



(function() {
    // .ui(get-promos-to-scope="promos" get-promos-to-scope-as-array="true" get-promos-to-scope-category="welcome_bonus")
    "use strict";
    const directive = {
        name: "getPromosToScope",
        category: "getPromosToScopeCategory",
        asArray: "getPromosToScopeAsArray"
    };
    factory.$inject = [
        "promo",
        "system$"
    ];
    function factory(_promo, _system$) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "promos";
            const asArray = attrs[directive.asArray] === "true";
            const category = attrs[directive.category] || null;
            const options = {};
            scope[variable] = asArray ? [] : {};
            if (category) options.category = category;
            _promo.list(options).then((a)=>setPromos()).catch((e)=>{});
            const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "statusChanged")).subscribe(()=>{
                setPromos();
            });
            scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
            function setPromos() {
                if (asArray) scope[variable] = _promo.result;
                else scope[variable].__proto__ = _promo.object;
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $1614fb6cfdbc045d$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        const o = {
            object: {},
            collection: collection
        };
        function collection(options) {
            const defer = $q.defer();
            const alias = "providerList";
            const config = {
                params: options || {},
                cache: false,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            config.params.count = options && options.count ? options.count : 1000;
            _http.get(alias, config).then((answer)=>{
                o.object = answer.data.result.toObject("name");
                o.object.list = answer.data.result;
                o.object.total_count = answer.data.result.length;
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        return o;
    }
    app.factory("brand", controller);
})();




(function() {
    "use strict";
    const directive = {
        name: "getProvidersToScope"
    };
    factory.$inject = [
        "brand",
        "system$"
    ];
    function factory(_brand, _system$) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "providers";
            const nameOrderingKey = attrs.orderBy || "name";
            const countOrderingKey = "total_count";
            const ascByNameClass = "linda-brands-ordered-by-name-asc";
            const descByNameClass = "linda-brands-ordered-by-name-desc";
            const ascByCountClass = "linda-brands-ordered-by-count-asc";
            const descByCountClass = "linda-brands-ordered-by-count-desc";
            let orderByNameBtn;
            let orderByCountBtn;
            scope[variable] = {};
            scope.brandsOrdering = [
                "",
                ""
            ];
            function getCollection() {
                _brand.collection().then((a)=>{
                    scope[variable].__proto__ = _brand["object"];
                }).catch((e)=>{});
            }
            getCollection();
            scope.orderByName = ({ currentTarget: currentTarget })=>{
                if (!orderByNameBtn) orderByNameBtn = currentTarget;
                if (!isSortedByName() || isSortedByName() && isReverseByName()) firstOrderingByName();
                else secondOrderingByName();
            };
            scope.orderByCount = ({ currentTarget: currentTarget })=>{
                if (!orderByCountBtn) orderByCountBtn = currentTarget;
                if (!isSortedByCount() || isSortedByCount() && !isReversedByCount()) firstOrderingByCount();
                else secondOrderingByCount();
            };
            const isSortedByName = ()=>scope.brandsOrdering[0].includes(nameOrderingKey);
            const isReverseByName = ()=>scope.brandsOrdering[0].includes("-");
            const isSortedByCount = ()=>scope.brandsOrdering[0].includes(countOrderingKey);
            const isReversedByCount = ()=>scope.brandsOrdering[0].includes("-");
            const firstOrderingByName = ()=>{
                scope.brandsOrdering = [
                    nameOrderingKey,
                    countOrderingKey
                ];
                if (orderByCountBtn) {
                    orderByCountBtn.classList.remove(ascByCountClass);
                    orderByCountBtn.classList.remove(descByCountClass);
                }
                orderByNameBtn.classList.remove(descByNameClass);
                orderByNameBtn.classList.add(ascByNameClass);
            };
            const secondOrderingByName = ()=>{
                scope.brandsOrdering[0] = `-${nameOrderingKey}`;
                orderByNameBtn.classList.remove(ascByNameClass);
                orderByNameBtn.classList.add(descByNameClass);
            };
            const firstOrderingByCount = ()=>{
                scope.brandsOrdering = [
                    `-${countOrderingKey}`,
                    nameOrderingKey
                ];
                if (orderByNameBtn) {
                    orderByNameBtn.classList.remove(ascByNameClass);
                    orderByNameBtn.classList.remove(descByNameClass);
                }
                orderByCountBtn.classList.remove(ascByCountClass);
                orderByCountBtn.classList.add(descByCountClass);
            };
            const secondOrderingByCount = ()=>{
                scope.brandsOrdering = [
                    countOrderingKey,
                    nameOrderingKey
                ];
                orderByCountBtn.classList.remove(descByCountClass);
                orderByCountBtn.classList.add(ascByCountClass);
            };
            const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
                getCollection();
            });
            this.$onDestroy = ()=>{
                subscription.unsubscribe();
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $a745dc103aad9a4f$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        let _teamList;
        let _activeTeamList;
        let _completedTeamList;
        return {
            object: {
                set list (data){
                    _teamList = data || [];
                    _activeTeamList = [];
                    _completedTeamList = [];
                    _teamList.forEach((i)=>{
                        switch(i.status){
                            case "active":
                                _activeTeamList.push(i);
                                break;
                            case "completed":
                                _completedTeamList.push(i);
                        }
                    });
                    _activeTeamList.sort((team1, team2)=>team2.progress.current - team1.progress.current);
                },
                get list () {
                    return _teamList;
                },
                get active () {
                    return _activeTeamList;
                },
                get completed () {
                    return _completedTeamList;
                }
            },
            list (options) {
                const defer = $q.defer();
                const alias = "sportTeam";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    this.object.list = answer.data.result;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            item (options) {
                const defer = $q.defer();
                const alias = "sportTeam";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("team", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "getSportTeamsToScope"
    };
    factory.$inject = [
        "team"
    ];
    function factory(_team) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "teams";
            scope[variable] = {};
            const config = {};
            config.order = "status_progress_desc";
            function getData(options) {
                _team.list(options).then((a)=>{
                    scope[variable].__proto__ = _team.object;
                }).catch((e)=>{});
            }
            getData(config);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $72474d6fd5187fb1$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$state",
        "$transitions"
    ];
    function controller($state, $transitions) {
        function link(scope, element, attrs) {
            const variable = attrs.getStateParamsToScope || "stateParams";
            scope[variable] = {};
            scope[variable].__proto__ = $state.transition ? $state.transition.params() : $state.params;
            $transitions.onSuccess({}, function(transition) {
                scope[variable].__proto__ = $state.transition ? $state.transition.params() : $state.params;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("getStateParamsToScope", controller);
})();


var $59f3b65a122cb739$exports = {};

const $59f3b65a122cb739$var$directiveName = "getSystemInfoToScope";
class $59f3b65a122cb739$var$FeatureFlag {
    static $inject = [
        "system"
    ];
    constructor(system){
        this.system = system;
    }
    link(scope, element, attrs, ctrl) {
        this.system.getSystemInfo().then((info)=>{
            scope.systemInfo = info;
        });
    }
}
app.directive($59f3b65a122cb739$var$directiveName, ()=>{
    return {
        restrict: "A",
        controller: $59f3b65a122cb739$var$FeatureFlag,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope, element, attrs, ctrl);
        }
    };
});


var $91cf6047614c42a7$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const variable = attrs.getTimestampToScope || "timestamp";
            scope[variable] = Date.now();
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("getTimestampToScope", controller);
})();


var $b2ed200f69c38eea$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "user$",
        "user",
        "$timeout"
    ];
    function controller(_user$, _user, $timeout) {
        function link(scope, element, attrs) {
            const variable = attrs.getUserToScope && attrs.getUserToScope !== "get-user-to-scope" ? attrs.getUserToScope : "user";
            scope.selectValue = function(val1, val2) {
                if (_user.status === true) return val1;
                else if (_user.status === false) return val2;
                return null;
            };
            scope[variable] = _user;
            _user$.subscribe((data)=>{
                $timeout(()=>{
                    scope[variable] = data;
                }, 0);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("getUserToScope", controller);
})();


var $eb14e8d89795906b$exports = {};

/**
 *
 *
 *
 *
 *
 */ (function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        const vip = {
            object: {},
            collection: collection
        };
        function collection() {
            const defer = $q.defer();
            const alias = "vipList";
            const config = {
                params: {
                    limit: 1000
                },
                cache: false,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then(function(answer) {
                vip.object = answer.data.result.toObject("level");
                vip.object.total_count = answer.data.result.length;
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
        return vip;
    }
    app.factory("vip", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "getVipsToScope"
    };
    factory.$inject = [
        "vip"
    ];
    function factory(_vip) {
        function link(scope, element, attrs) {
            const variable = attrs[directive.name] || "vips";
            scope[variable] = {};
            _vip.collection().then(({ result: result })=>{
                scope[variable] = result;
            }).catch((e)=>{});
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $44be825fff304b6e$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "goBack"
    };
    controller.$inject = [
        "state",
        "config",
        "$state",
        "$rootScope"
    ];
    function controller(_state, _config, $state, $rootScope) {
        const link = (scope, element, attrs)=>{
            // - TODO: Need to refactoring full directive. Has trouble with history api, when run game from playtech, maybe more providers.
            let curentPage = $state.current;
            let isBackEvent = false;
            const backEvent = $rootScope.$on("$stateChangeSuccess", ()=>{
                if (isBackEvent) return;
                isBackEvent = false;
                curentPage = $state.current;
            });
            if (_config.device.mobile) element.bind("tap", go);
            else element.bind("click", go);
            function go() {
                if (_state.history.length > 1) {
                    isBackEvent = true;
                    _state.goback();
                } else _state.goto("home");
            }
            $scope.$on("$destroy", ()=>{
                backEvent();
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $6864a9b1432b9735$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$transitions"
    ];
    function controller($transitions) {
        let activeTab = "";
        const tabOpened$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)(activeTab);
        function getActiveTab() {
            return activeTab;
        }
        function setActiveTab(tabName) {
            activeTab = tabName;
            tabOpened$.next(activeTab);
        }
        function resetActiveTab() {
            activeTab = "";
            tabOpened$.next(activeTab);
        }
        $transitions.onSuccess({}, function(transition) {
            if (transition.from() !== transition.to()) resetActiveTab();
        });
        return {
            tabOpened$: tabOpened$,
            getActiveTab: getActiveTab,
            setActiveTab: setActiveTab,
            resetActiveTab: resetActiveTab
        };
    }
    app.factory("gamePageShop", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "handleGamePageShopTab"
    };
    controller.$inject = [
        "gamePageShop"
    ];
    function controller(_gamePageShop) {
        function link(scope) {
            scope.activeTab = "";
            const activeTabSubscription = _gamePageShop.tabOpened$.subscribe((tabName)=>{
                scope.activeTab = tabName;
            });
            scope.openShopTabByName = (tabName)=>{
                _gamePageShop.setActiveTab(tabName);
            };
            scope.resetShopTab = ()=>{
                _gamePageShop.resetShopTab();
            };
            this.$onDestroy = ()=>{
                activeTabSubscription?.unsubscribe();
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $9ce6a344bcf72385$exports = {};
(function() {
    "use strict";
    app.directive("hideAfterNy", controller);
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {}
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $a616d9c86b441786$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "hideByCountryCode"
    };
    factory.$inject = [
        "system",
        "user",
        "system$"
    ];
    function factory(_system, _user, _system$) {
        function link(scope, element, attrs) {
            const listOfLanguages = scope.$eval(attrs[directive.name]);
            let userCountryCode = null;
            function addTargetNode(userCountryCode) {
                if (listOfLanguages.indexOf(userCountryCode) === -1) {
                    element[0].style.display = "block";
                    return;
                }
                element[0].style.display = "none";
            }
            function showByCountryCode() {
                if (!_user.status) _system.info().then(({ result: result })=>{
                    userCountryCode = result.country.code.toLowerCase();
                    addTargetNode(userCountryCode);
                });
                if (_user.status) {
                    userCountryCode = _user.profile.country.toLowerCase();
                    addTargetNode(userCountryCode);
                }
            }
            showByCountryCode();
            _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "statusChanged")).subscribe(()=>{
                showByCountryCode();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $d7ac363481b0dbf4$exports = {};





(function() {
    "use strict";
    const directive = {
        name: "hideElementIf"
    };
    controller.$inject = [
        "config",
        "user",
        "system$",
        "system"
    ];
    function controller(_config, _user, _system$, _system) {
        function link(scope, element, attrs) {
            const params = scope.$eval(attrs[directive.name]) || {};
            const langs = params.langs?.map((lang)=>lang.toLowerCase()) || [];
            const countries = params.countries?.map((country)=>country.toLowerCase()) || [];
            const { currentLang: currentLang } = _config;
            let subscription;
            const hideElement = ()=>element[0].style.display = "none";
            const showElement = ()=>element[0].style.display = "";
            if (langs.includes(currentLang)) {
                hideElement();
                return;
            }
            if (countries.length) {
                hideByCountries();
                subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "statusChanged")).subscribe(()=>{
                    hideByCountries();
                });
            }
            function hideByCountries() {
                if (_user.status) {
                    const userCountryCode = _user.profile.country.toLowerCase();
                    countries.includes(userCountryCode) ? hideElement() : showElement();
                    return;
                }
                _system.info().then(({ result: result })=>{
                    const userCountryCode = result.country.code.toLowerCase();
                    countries.includes(userCountryCode) ? hideElement() : showElement();
                }).catch(()=>{});
            }
            scope.$on("$destroy", ()=>subscription?.unsubscribe());
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e8a963452f1ad9c8$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "hideForSw"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const lang = scope.$eval(attrs[directive.name]);
            if (lang === "sv" && new Date().getFullYear() === 2019) element.parentNode.removeChild(element);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $d0b6efdd022ae07a$exports = {};
(function() {
    "use strict";
    app.directive("historyGoBack", controller);
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            element.on("click", function() {});
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $3e3ead8c721b1b7a$exports = {};







const $c6b04907c7330b77$export$99f4e48c85aeea15 = "holidayPromo";
class $c6b04907c7330b77$var$HolidayPromo {
    static $inject = [
        "promo",
        "system$",
        "user",
        "$timeout",
        "popup"
    ];
    constructor(promo, system$, user, $timeout, popup){
        this.promo = promo;
        this.system$ = system$;
        this.user = user;
        this.$timeout = $timeout;
        this.popup = popup;
    }
    promoRequest = null;
    promos = [];
    init() {
        const config = {
            category: "season_promo"
        };
        this.getPromoList(config).then(()=>{
            this.initWelcomePopup();
        });
    }
    convertToIsoString(date) {
        if (!date) return;
        const yourDate = new Date(date);
        return yourDate.toISOString().split("T")[0];
    }
    triggerPopup(previousLogin, currentDate) {
        if (previousLogin === currentDate) return;
        this.$timeout(()=>{
            this.popup.open({
                name: "holiday-welcome",
                content: this.promos
            });
        }, 1000);
    }
    getPromoList(params) {
        if (this.promoRequest) return this.promoRequest;
        this.promoRequest = this.promo.list(params).then((data)=>{
            if (!data.result.length) return this.promos;
            this.promos = [
                ...data.result
            ];
            return this.promos;
        });
        return this.promoRequest;
    }
    initWelcomePopup() {
        this.system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
            const currentDate = +new Date();
            const previousLoginDate = this.user.profile.sessions_info.previous_ts * 1000 || null;
            if (this.promos.length) this.triggerPopup(this.convertToIsoString(previousLoginDate), this.convertToIsoString(currentDate));
        });
    }
}
app.factory($c6b04907c7330b77$export$99f4e48c85aeea15, $c6b04907c7330b77$var$HolidayPromo);


const $6bcae377764e127b$export$9ea238830f146faf = "transcludeResolverEvents";
class $6bcae377764e127b$var$Events {
    static $inject = [
        "$q",
        "tournament",
        "game",
        "promo",
        "holidayPromo"
    ];
    constructor($q, tournament, game, promo, holidayPromo){
        this.$q = $q;
        this.game = game;
        this.tournament = tournament;
        this.promo = promo;
        this.holidayPromo = holidayPromo;
    }
    checkOnExist(config) {
        const { alias: alias, params: params } = config;
        Object.assign(params, {
            cache: true
        });
        switch(alias){
            case "promo":
                return this.promo.item(params);
            case "seasonPromoList":
                return this.holidayPromo.getPromoList(params);
            case "tournament":
                return this.tournament.item(params);
            case "game":
                return this.game.item(params);
            case "tournamentActive":
                return (()=>{
                    const defer = this.$q.defer();
                    this.tournament.item(params).then((data)=>{
                        if (data.result.status === 1) defer.resolve(data);
                        else defer.reject(data);
                    }).catch(()=>{
                        defer.reject();
                    });
                    return defer.promise;
                })();
        }
    }
}
app.factory($6bcae377764e127b$export$9ea238830f146faf, $6bcae377764e127b$var$Events);


const $2b84677472c1497f$export$d50c3b1acb95fc71 = "transcludeResolver";
class $2b84677472c1497f$var$Resolver {
    static $inject = [
        "transcludeResolverEvents"
    ];
    constructor(transcludeResolverEvents){
        this.transcludeResolverEvents = transcludeResolverEvents;
    }
    get(config) {
        return this.transcludeResolverEvents.checkOnExist(config);
    }
}
app.factory($2b84677472c1497f$export$d50c3b1acb95fc71, $2b84677472c1497f$var$Resolver);




(function() {
    "use strict";
    const directive = {
        name: "holidayLink"
    };
    controller.$inject = [
        "user",
        "state",
        "transcludeResolver"
    ];
    function controller(_user, _state, _transcludeResolver) {
        function link(scope, element, attrs, ctrl, transclude) {
            const config = {
                alias: "seasonPromoList",
                params: {
                    category: "season_promo"
                }
            };
            const promoAlias = scope.holidayLink;
            scope.holidayPromo = {};
            _transcludeResolver.get(config).then((data)=>{
                if (promoAlias && data.some((promo)=>promo.alias === promoAlias)) {
                    transclude(scope, (clone)=>{
                        Array.from(clone).forEach((node)=>{
                            element[0].appendChild(node);
                        });
                    });
                    element[0].onclick = ()=>{
                        return _state.goto(promoAlias);
                    };
                    scope.holidayPromo = data.find((promo)=>promo.alias === promoAlias);
                }
            });
        }
        return {
            restrict: "A",
            scope: {
                holidayLink: "@"
            },
            link: link,
            transclude: true
        };
    }
    app.directive(directive.name, controller);
})();


var $58fdc27caa1b1e1f$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "horizontalScrollElement"
    };
    controller.$inject = [
        "$window",
        "$timeout"
    ];
    function controller($window, $timeout) {
        const link = (scope, element, attrs)=>{
            const container = element[0];
            $timeout(()=>{
                const config = scope.$eval(attrs[directive.name]);
                const child = container.querySelector(config.class);
                const padding = config.padding || 10;
                let position = null;
                if (config.scrollTo === "left") position = child.offsetLeft - container.offsetLeft + container.scrollLeft - padding;
                else position = child.offsetLeft - $window.innerWidth / 2 + child.offsetWidth / 2;
                container.scrollLeft = position;
            }, 200);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c800f4284869593c$exports = {};



(function() {
    "use strict";
    app.directive("hrefIfAuth", controller);
    controller.$inject = [
        "popup",
        "user$",
        "user",
        "$state"
    ];
    function controller(_popup, _user$, _user, $state) {
        function parseStateRef(ref, current) {
            const preparsed = ref.match(/^\s*({[^}]*})\s*$/);
            if (preparsed) ref = current + "(" + preparsed[1] + ")";
            const parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
            if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
            return {
                state: parsed[1],
                paramExpr: parsed[3] || null
            };
        }
        function link(scope, element, attrs) {
            const variable = parseStateRef(attrs.hrefIfAuth);
            if (!_user.status) element[0].href = $state.href(variable.state, scope.$eval(variable.paramExpr));
            else element[0].href = "";
            _user$.subscribe(()=>{
                if (!_user.status) element[0].href = $state.href(variable.state, scope.$eval(variable.paramExpr));
                else element[0].href = "";
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $caf189ab56df6534$exports = {};
(function() {
    "use strict";
    function controller() {
        function link(scope, element) {
            const el = element[0];
            el.onscroll = function() {
                if (el.scrollTop + el.clientHeight + 10 >= el.scrollHeight && !(scope.lastPage || scope.preloader) && el.scrollHeight > el.offsetHeight) scope.nextPage();
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    controller.$inject = [];
    app.directive("infiniteScroll", controller);
})();


var $d23171d920019eb3$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "inputAutoWidth"
    };
    controller.$inject = [
        "event"
    ];
    function controller() {
        function link(scope, element, attrs, ctrl) {
            const shadowEl = document.createElement("span");
            shadowEl.style.cssText = `
                display: inline;
                width: auto;
                height: 0;
                padding: 0;
                border: 0;
                margin: 0;
                overflow: hidden;
                position: absolute;
                font: ${getComputedStyle(element[0], null).font};
                letter-spacing: ${getComputedStyle(element[0], null).letterSpacing}`;
            document.body.appendChild(shadowEl);
            ctrl.$parsers.push((value)=>{
                setSize(value);
                return value;
            });
            ctrl.$formatters.push((value)=>{
                setSize(value);
                return value;
            });
            scope.$on("$destroy", ()=>{
                shadowEl.remove();
            });
            function setSize(value) {
                if (value) {
                    shadowEl.innerText = value.toString() + "|";
                    element[0].style.cssText = `width: ${shadowEl.offsetWidth}px;`;
                }
            }
        }
        return {
            require: "ngModel",
            link: link,
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $3d635f34e430847e$exports = {};
(function() {
    "use strict";
    app.directive("inputFilterCreditcard", function() {
        return {
            require: "ngModel",
            link (scope, element, attrs, ctrl) {
                const buffer = [];
                element.bind(" keydown", (e)=>{
                    let key = e.key.replace(/[^0-9\.]+/g, "").toString();
                    if (key !== "") {
                        if (buffer.length >= 4 && buffer.length <= 11) key = "X";
                        if (buffer.length === 4 || buffer.length === 9 || buffer.length === 14) buffer.push(" ");
                        if (buffer.length <= 15) buffer.push(key);
                    }
                });
                ctrl.$parsers.unshift((inputValue)=>{
                    const res = [];
                    inputValue = inputValue.replace(/[^0-9\.]+/g, "").toString();
                    return inputValue;
                });
                ctrl.$formatters.unshift((val)=>{
                    return val;
                });
            }
        };
    });
})();


var $442e42fa9f565b64$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        return {
            isEnabled$: $window.deferredPrompt$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((a)=>a.isEnabled)),
            answer$: $window.deferredPrompt$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((a)=>a.answer)),
            isEnabled: Boolean($window.deferredPrompt),
            open () {
                $window.deferredPrompt.prompt();
                $window.deferredPrompt.userChoice.then((choiceResult)=>{
                    if (choiceResult.outcome === "accepted") {
                        $window.deferredPrompt = null;
                        $window.deferredPrompt$.next({
                            answer: true
                        });
                    } else $window.deferredPrompt$.next({
                        answer: false
                    });
                });
            }
        };
    }
    // eslint-disable-next-line angular/no-service-method
    app.service("deferredPrompt", controller);
})();


/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $8d9b73017d0ca1d2$var$ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var $8d9b73017d0ca1d2$export$630691c4a0cd4093 = $8d9b73017d0ca1d2$var$ArgumentOutOfRangeErrorImpl;



var $b42vV = parcelRequire("b42vV");
function $94b8433012a062db$export$b7df5d561049483a(count) {
    return function(source) {
        if (count === 0) return (0, $b42vV.empty)();
        else return source.lift(new $94b8433012a062db$var$TakeOperator(count));
    };
}
var $94b8433012a062db$var$TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, $8d9b73017d0ca1d2$export$630691c4a0cd4093);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $94b8433012a062db$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var $94b8433012a062db$var$TakeSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, $2Dqpi.Subscriber));


(function() {
    "use strict";
    const directive = {
        name: "installAppBox"
    };
    controller.$inject = [
        "deferredPrompt"
    ];
    function controller(_deferredPrompt) {
        function compile() {
            return function($scope, $element, $attrs, $ctrl, $transclude) {
                if (_deferredPrompt.isEnabled) run();
                else {
                    const sEnabled = _deferredPrompt.isEnabled$.pipe((0, $94b8433012a062db$export$b7df5d561049483a)(1)).subscribe(()=>{
                        run();
                    });
                    $scope.$on("$destroy", ()=>{
                        sEnabled.unsubscribe();
                    });
                }
                function run() {
                    $transclude($scope.$new(true), (clone, scope)=>{
                        scope.install = ()=>{
                            _deferredPrompt.open();
                        };
                        $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
                    });
                    const sAnswer = _deferredPrompt.answer$.subscribe(()=>{
                        removeBox();
                    });
                    $scope.$on("$destroy", ()=>{
                        sAnswer.unsubscribe();
                    });
                    function removeBox() {
                        $element[0].parentNode.removeChild($element[0].nextSibling);
                        $element[0].parentNode.removeChild($element[0]);
                    }
                }
            };
        }
        return {
            restrict: "A",
            transclude: "element",
            compile: compile
        };
    }
    app.directive(directive.name, controller);
})();


var $fc1c31481a195ae3$exports = {};
(function() {
    "use strict";
    function controller() {
        function link(scope, element, attrs) {
            attrs.$observe("lazyBg", (data)=>{
                const conf = scope.$eval(data);
                if (conf && conf.src) {
                    let img = document.createElement("img");
                    img.src = conf.src;
                    img.onload = ()=>{
                        element.addClass(conf.class).css("background-image", "url(" + conf.src + ")");
                        img.remove();
                        img = null;
                    };
                    img.onerror = ()=>{
                        if (conf.errorClass) element.addClass(conf.errorClass);
                        img.remove();
                        img = null;
                    };
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lazyBg", controller);
    controller.$inject = [];
})();


var $171d36da17077eed$exports = {};

/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

function $14a4cad30b3540d6$export$ac8dfd3a7ad06e80(notifier) {
    return function(source) {
        return source.lift(new $14a4cad30b3540d6$var$TakeUntilOperator(notifier));
    };
}
var $14a4cad30b3540d6$var$TakeUntilOperator = /*@__PURE__*/ function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        var takeUntilSubscriber = new $14a4cad30b3540d6$var$TakeUntilSubscriber(subscriber);
        var notifierSubscription = (0, $f1a21b598f0f6aea$export$d34bac9c0f124cff)(this.notifier, new (0, $f1a21b598f0f6aea$export$20b3446cf1c359c0)(takeUntilSubscriber));
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}();
var $14a4cad30b3540d6$var$TakeUntilSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function() {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {};
    return TakeUntilSubscriber;
}((0, $f1a21b598f0f6aea$export$b73f91a09e7d5376));








const $cdd3c5dbab5f2ef4$export$b659c9dc16acb7c5 = "bonusApi";
class $cdd3c5dbab5f2ef4$var$Api {
    static $inject = [
        "http",
        "user"
    ];
    constructor(http, _user){
        this.http = http;
        this.user = _user;
    }
    getList() {
        return this.http.getData("userBonus").then((answer)=>{
            this.user.bonus = answer.result;
            return answer.result;
        }).catch((e)=>e);
    }
    cancel(bonusId) {
        return this.http.postData("userResetBonus", null, {
            bonus_id: bonusId
        }).then((answer)=>{
            this.user.profile = answer.result;
            return this.getList();
        });
    }
    activate(bonusId) {
        return this.http.postData("userBonusActivate", null, {
            bonus_id: bonusId
        }).then((answer)=>{
            this.user.profile = answer.result;
            return this.getList();
        });
    }
}
app.factory($cdd3c5dbab5f2ef4$export$b659c9dc16acb7c5, $cdd3c5dbab5f2ef4$var$Api);



const $209df0ea6af12aa8$export$d8292cf1798a0554 = "bonus";
class $209df0ea6af12aa8$var$Bonus {
    static $inject = [
        "bonusApi",
        "modal",
        "user",
        "state",
        "popup"
    ];
    constructor(_bonusApi, _modal, _user, _state, _popup){
        this.user = _user;
        this.modal = _modal;
        this.state = _state;
        this.popup = _popup;
        this.bonusApi = _bonusApi;
    }
    list() {
        return this.bonusApi.getList();
    }
    runActivation(bonus, alias) {
        return this.bonusApi.activate(bonus.bonus_id).then(()=>{
            return this.resolveByBonusType(bonus.type, alias);
        });
    }
    activate(bonus, alias) {
        if (this.isLockedRetentionBonus(bonus)) return this.modal.open("bonus-activation-rules", bonus);
        if (this.user.activeBonus.bonus_id) return this.modal.open("bonus-activation", bonus).then(()=>{
            return this.runActivation(bonus, alias);
        }).catch((e)=>e);
        return this.runActivation(bonus, alias);
    }
    cancel(bonus) {
        if (bonus.status === "active") return this.modal.open("bonus-cancellation").then(()=>{
            return this.bonusApi.cancel(bonus.bonus_id);
        });
        return this.bonusApi.cancel(bonus.bonus_id);
    }
    resolveByBonusType(bonusType, aliasOnActivate) {
        if (bonusType === "freespin") this.state.goto("realGame", {
            name: aliasOnActivate
        });
        aliasOnActivate ? this.state.goto(aliasOnActivate) : this.popup.close();
    }
    isLockedRetentionBonus(bonus) {
        return bonus.is_retention_bonus && !bonus.retention_bonus_rules_fulfilled;
    }
}
app.factory($209df0ea6af12aa8$export$d8292cf1798a0554, $209df0ea6af12aa8$var$Bonus);








(function() {
    "use strict";
    controller.$inject = [
        "bonus",
        "user",
        "modal",
        "state",
        "$state",
        "account",
        "popup",
        "game",
        "$window"
    ];
    function controller(_bonus, _user, _modal, _state, $state, _account, _popup, _game, $window) {
        function activate(bonus_id) {
            this.preloader = true;
            _bonus.activate({
                bonus_id: bonus_id
            }).then((answer)=>{
                if (this.bonus.type === "freespin") {
                    const location = _state.get("realGame");
                    $state.go(location.name, {
                        name: this.bonus.game.alias
                    });
                }
                // todo зробити розумніше
                _popup.close();
                this.preloader = false;
            }, (answer)=>{
                this.preloader = false;
            });
        }
        function cancel(bonus_id) {
            this.preloader = true;
            _bonus.cancel({
                bonus_id: bonus_id
            }).then((answer)=>{
                this.preloader = false;
            }, (answer)=>{
                this.preloader = false;
            });
        }
        const bonus = {
            activate (id) {
                if (_user.activeBonus.bonus_id) _modal.open("bonus-activation").then((answer)=>{
                    activate.apply(this, [
                        id
                    ]);
                }, (answer)=>{});
                else activate.apply(this, [
                    id
                ]);
            },
            cancel (id) {
                if (angular.isObject(this.bonus) && this.bonus.status === "active") _modal.open("bonus-cancellation").then((answer)=>{
                    cancel.apply(this, [
                        id
                    ]);
                }, (answer)=>{});
                else cancel.apply(this, [
                    id
                ]);
            }
        };
        const freespin = {
            activate: bonus.activate,
            cancel: bonus.cancel
        };
        const sportbonus = {
            activate: bonus.activate,
            cancel: bonus.cancel
        };
        const account = {
            refresh () {
                this.preloader = true;
                _account.info({
                    nocache: true
                }).then((answer)=>{
                    this.preloader = false;
                }, (answer)=>{
                    this.preloader = false;
                });
            }
        };
        const form = {
            setTouched (form) {
                angular.forEach(form.$error, (type)=>{
                    angular.forEach(type, (field)=>{
                        field.$setTouched();
                    });
                });
            },
            validator (cb) {
                return function(frm) {
                    if (frm.$valid) {
                        if (angular.isFunction(cb)) cb(frm);
                    } else form.setTouched(frm);
                };
            }
        };
        const game = {
            collection (options, cb) {
                this.preloader = true;
                _game.collection(options).then((answer)=>{
                    this.collection = answer.result;
                    if (angular.isFunction(cb)) cb(answer.result);
                    this.preloader = false;
                }, (answer)=>{
                    this.preloader = false;
                });
            }
        };
        const dom = {
            isElementInViewport (el) {
                const rect = el.getBoundingClientRect();
                return rect.top >= 0 && rect.left >= 0 && rect.bottom <= ($window.innerHeight || document.documentElement.clientHeight) && rect.right <= ($window.innerWidth || document.documentElement.clientWidth);
            },
            addScript (url, onload) {
                if (url.length) {
                    const element = document.createElement("script");
                    element.src = url;
                    element.async = true;
                    if (angular.isFunction(onload)) element.onload = onload;
                    document.head.appendChild(element);
                }
            }
        };
        return {
            bonus: bonus,
            freespin: freespin,
            sportbonus: sportbonus,
            account: account,
            form: form,
            game: game,
            dom: dom
        };
    }
    app.factory("helper", controller);
})();



const $b8946ef494694dd4$export$1bdc757ecae3ab9f = "regionalIcon";
class $b8946ef494694dd4$var$RegionalIcon {
    static $inject = [
        "$window",
        "config",
        "helper",
        "splash$"
    ];
    constructor($window, config, helper, splash$){
        this.$window = $window;
        this.config = config;
        this.helper = helper;
        this.splash$ = splash$;
        this.destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        this.$onDestroy = ()=>{
            this.destroy$.next();
            this.destroy$.unsubscribe();
        };
    }
    init(element, license) {
        const licenseCodeUppercase = license?.code.toUpperCase();
        element[0].setAttribute("id", `${license?.code}-${license?.id}`);
        element[0].setAttribute(`data-${license?.code}-seal-id`, `${license?.id}`);
        element[0].setAttribute(`data-${license?.code}-image-size`, `128`);
        element[0].setAttribute(`data-${license?.code}-image-type`, `basic-small`);
        if (typeof this.$window[licenseCodeUppercase] !== "undefined") this.$window[licenseCodeUppercase].init();
        this.splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message === "loaded"), (0, $94b8433012a062db$export$b7df5d561049483a)(1), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(this.destroy$)).subscribe(async ()=>{
            this.helper.dom.addScript(`https://${license?.id}.${license?.cdnPath}`, ()=>{
                this.$window[licenseCodeUppercase].init();
            });
        });
    }
}
app.factory($b8946ef494694dd4$export$1bdc757ecae3ab9f, $b8946ef494694dd4$var$RegionalIcon);


const $171d36da17077eed$var$directive = {
    name: "licenseIcon"
};
(function() {
    "use strict";
    app.directive($171d36da17077eed$var$directive.name, [
        "regionalIcon",
        function(_regionalIcon) {
            function link(scope, element) {
                const license = $_CDN.licenseConfig;
                license.name;
                _regionalIcon.init(element, license);
            }
            return {
                restrict: "A",
                link: link
            };
        }
    ]);
})();


var $4588544d7f5a22ea$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "lindaScrollTop"
    };
    controller.$inject = [
        "$document",
        "$state",
        "$window",
        "$timeout"
    ];
    function controller($document, $state, $window, $timeout) {
        function link(scope, element, attrs) {
            const scrollClass = attrs[directive.name] ? `.${attrs[directive.name]}` : null;
            const targetScrollElement = scrollClass ? document.querySelector(scrollClass) : window;
            function scrollFunction() {
                if (angular.isFunction($window.scroll)) {
                    targetScrollElement?.scroll({
                        top: 0,
                        behavior: "smooth"
                    });
                    return;
                }
                $timeout(function() {
                    const targetAngularElement = scrollClass ? angular.element(targetScrollElement) : $document;
                    targetAngularElement?.duScrollTopAnimated(0, 400);
                }, 0);
            }
            scope.$on("$stateChangeSuccess", function() {
                if (!$state.params?.disableScrollTop) scrollFunction();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $f497280be981cc1e$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "account",
        "state",
        "popup"
    ];
    function controller(_account, _state, _popup) {
        const mobileLink = (scope, element, attrs)=>{
            element.on("click", function() {
                _account.logout();
                _state.goto("home");
            });
        };
        const webLink = (scope, element, attrs)=>{
            element.on("click", function() {
                this.classList.add("linda-has-preloader");
                _account.logout().then((a)=>{
                    _popup.close();
                    _state.goto("home");
                }).catch((e)=>{}).finally(()=>{
                    this.classList.remove("linda-has-preloader");
                });
            });
        };
        return {
            restrict: "A",
            link: app.getCC(mobileLink, webLink)
        };
    }
    app.directive("logout", controller);
})();


var $000ca5312d3d72dc$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$window"
    ];
    app.factory("lottie", controller);
    function controller($window) {
        return $window.lottie;
    }
})();


(function() {
    const directive = {
        name: "lottieAnimation"
    };
    controller.$inject = [
        "config",
        "lottie"
    ];
    function controller(_config, _lottie) {
        const link = (scope, element, attrs, ngModel)=>{
            const id = element.attr("id");
            const path = _config.cdn + attrs[directive.name];
            if (!id) throw new Error("ID attr required to animate element");
            _lottie.loadAnimation({
                container: element[0],
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: path
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $117120d909282e7e$exports = {};
(function() {
    "use strict";
    luckyWinnerController.$inject = [
        "promoLuckyWinner"
    ];
    function luckyWinnerController(luckyApi) {
        function link(scope, element, attrs) {
            const namespace = attrs.luckyWinnerToScope || "luckyWinner";
            scope[namespace] = {
                isLoaded: false,
                login: "",
                payout: {
                    current: 0,
                    next: 0,
                    max: 0,
                    currency: ""
                },
                isTaken: false
            };
            luckyApi.getLast(1).then((payload)=>{
                if (!(angular.isArray(payload.result) && payload.result.length)) return;
                const [winner] = payload.result;
                const next = parseInt(winner.payout_rule.daily, 10) + parseInt(winner.amount, 10);
                const max = parseInt(winner.payout_rule.max);
                scope[namespace] = {
                    ...scope[namespace],
                    login: winner.login,
                    payout: {
                        current: parseInt(winner.amount, 10),
                        next: next > max ? max : next,
                        max: max,
                        daily: parseInt(winner.payout_rule.daily),
                        currency: winner.currency
                    },
                    isTaken: winner.status === "taken",
                    isLoaded: true
                };
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("luckyWinnerToScope", luckyWinnerController);
})();


var $745dc07eb0fc8a8b$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        const depositObj = {
            mask: Number,
            min: 0,
            max: 999999999,
            scale: 0,
            signed: false
        };
        const startsWithZero = (value)=>value?.toString().startsWith("0");
        const hasInvalidSymbols = (value)=>isNaN(+value);
        return {
            init ($element, ngModel) {
                const element = $element[0];
                const inputMask = new IMask(element, depositObj);
                inputMask.on("accept", ()=>{
                    const valueToSet = inputMask.unmaskedValue.length ? inputMask.typedValue : null;
                    ngModel.$setViewValue(valueToSet);
                });
                ngModel.$formatters.push((modelValue)=>{
                    if (modelValue) inputMask.typedValue = parseInt(modelValue);
                    return inputMask.typedValue;
                });
                ngModel.$parsers.push(()=>{
                    return inputMask.typedValue;
                });
                return inputMask;
            },
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.min = (modelValue, viewValue)=>{
                    const params = scope?.system?.rules;
                    if (angular.isDefined(params)) {
                        const value = modelValue || viewValue;
                        const minValue = params.range[0];
                        if ((hasInvalidSymbols(value) || !value) && !startsWithZero(value)) return true;
                        if (startsWithZero(value)) return false;
                        return +value >= minValue;
                    }
                    return true;
                };
                ngModel.$validators.max = (modelValue, viewValue)=>{
                    const params = scope?.system?.rules;
                    if (angular.isDefined(params)) {
                        const value = modelValue || viewValue;
                        const maxValue = params.range[params.range.length - 1];
                        return hasInvalidSymbols(value) || !value || startsWithZero(value) ? true : +value <= maxValue;
                    }
                    return true;
                };
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !((hasInvalidSymbols(value) || !value) && !startsWithZero(value));
                };
            },
            validator (instance) {
                return instance.masked.isComplete;
            }
        };
    }
    app.factory("depositAmount", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "user"
    ];
    function controller(_user) {
        const withdrawObj = {
            mask: Number,
            min: 0,
            max: 999999999,
            scale: 2,
            radix: ".",
            signed: false
        };
        const startsWithZero = (value)=>value?.toString().startsWith("0");
        const hasInvalidSymbols = (value)=>isNaN(+value);
        return {
            init ($element, ngModel) {
                const element = $element[0];
                const inputMask = new IMask(element, withdrawObj);
                inputMask.on("accept", ()=>{
                    const valueToSet = inputMask.unmaskedValue.length ? inputMask.typedValue : null;
                    ngModel.$setViewValue(valueToSet);
                });
                ngModel.$formatters.push((modelValue)=>{
                    if (modelValue) inputMask.typedValue = modelValue;
                    return inputMask.typedValue;
                });
                ngModel.$parsers.push(()=>{
                    return inputMask.typedValue;
                });
                return inputMask;
            },
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.min = (modelValue, viewValue)=>{
                    const params = scope?.system?.rules;
                    if (angular.isDefined(params)) {
                        const value = modelValue || viewValue;
                        const minValue = params.range[0];
                        if ((hasInvalidSymbols(value) || !value) && !startsWithZero(value)) return true;
                        if (startsWithZero(value)) return false;
                        return +value >= minValue;
                    }
                    return true;
                };
                ngModel.$validators.max = (modelValue, viewValue)=>{
                    const params = scope?.system?.rules;
                    if (!angular.isDefined(params)) return true;
                    const userRealBalance = _user.profile.balance;
                    const value = modelValue || viewValue;
                    const minValue = params.range[0];
                    const maxValue = params.range[params.range.length - 1];
                    if (hasInvalidSymbols(value) || !value || startsWithZero(value)) return true;
                    const isWithinRange = value >= minValue && value <= maxValue;
                    if (value > maxValue) {
                        scope.maxWithdrawAmount = maxValue;
                        return false;
                    }
                    if (isWithinRange && value > userRealBalance && userRealBalance !== 0) {
                        scope.maxWithdrawAmount = userRealBalance;
                        return false;
                    }
                    if (isWithinRange && userRealBalance === 0) {
                        scope.maxWithdrawAmount = 0;
                        return false;
                    }
                    return true;
                };
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !((hasInvalidSymbols(value) || !value) && !startsWithZero(value));
                };
            },
            validator (instance) {
                return instance.masked.isComplete;
            }
        };
    }
    app.factory("withdrawAmount", controller);
})();



(function() {
    controller.$inject = [
        "user"
    ];
    function controller(_user) {
        const config = {
            mask: Number,
            min: 0,
            max: 9999999,
            scale: 0,
            signed: false
        };
        return {
            init ($element, ngModel) {
                const element = $element[0];
                const inputMask = new IMask(element, config);
                inputMask.on("accept", ()=>{
                    ngModel.$setViewValue(inputMask.typedValue);
                });
                ngModel.$formatters.push((modelValue)=>{
                    if (modelValue) inputMask.typedValue = modelValue;
                    return inputMask.typedValue;
                });
                ngModel.$parsers.push(()=>{
                    return inputMask.typedValue;
                });
                return inputMask;
            },
            customValidators (scope, element, attrs, ngModel) {
                const params = {
                    min: 100,
                    max: 9999999
                };
                if (angular.isDefined(params)) {
                    ngModel.$validators.amount = (modelValue, viewValue)=>{
                        const value = modelValue || viewValue;
                        return value.toString().length ? value <= _user.profile.loyalty : true;
                    };
                    ngModel.$validators.min = (modelValue, viewValue)=>{
                        const value = modelValue || viewValue;
                        return value.toString().length ? value >= params.min : true;
                    };
                    ngModel.$validators.max = (modelValue, viewValue)=>{
                        const value = modelValue || viewValue;
                        return value.toString().length ? value <= params.max : true;
                    };
                }
            },
            validator (instance) {
                return instance.masked.isComplete;
            }
        };
    }
    app.factory("lpAmount", controller);
})();


(function() {
    controller.$inject = [
        "depositAmount",
        "withdrawAmount",
        "lpAmount"
    ];
    function controller(_depositAmount, _withdrawAmount, _lpAmount) {
        const link = (scope, element, attrs, ngModel)=>{
            attrs.$set("type", "text");
            const type = attrs.maskAs || null;
            const mask = {};
            switch(type){
                case "depositAmount":
                    mask.type = type;
                    mask.init = _depositAmount.init;
                    mask.validator = _depositAmount.validator;
                    mask.customValidators = _depositAmount.customValidators;
                    break;
                case "withdrawAmount":
                    mask.type = type;
                    mask.init = _withdrawAmount.init;
                    mask.validator = _withdrawAmount.validator;
                    mask.customValidators = _withdrawAmount.customValidators;
                    break;
                case "lpAmount":
                    mask.type = type;
                    mask.init = _lpAmount.init;
                    mask.validator = _lpAmount.validator;
                    mask.customValidators = _lpAmount.customValidators;
                    break;
                default:
                    mask.type = null;
                    break;
            }
            if (mask.type) {
                mask.instance = mask.init(element, ngModel);
                if (angular.isFunction(mask.customValidators)) mask.customValidators(scope, element, attrs, ngModel);
                ngModel.$validators[mask.type] = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? mask.validator(mask.instance) : true;
                };
            }
        };
        return {
            restrict: "A",
            require: "?ngModel",
            link: link
        };
    }
    app.directive("maskAs", controller);
})();


var $c9f19e4fffff0985$exports = {};
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $632604eb9fd75aac$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[167]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:22|44|7[27]|87|9[69])[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-689]|8[1-69]|9[1-578])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $03641f6f3ef8cc44$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $632604eb9fd75aac$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $73c70792af8d3ac2$var$objectConstructor = {}.constructor;
function $73c70792af8d3ac2$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $73c70792af8d3ac2$var$objectConstructor;
}


function $1a298d77808b53aa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1a298d77808b53aa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1a298d77808b53aa$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1a298d77808b53aa$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1a298d77808b53aa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1a298d77808b53aa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a298d77808b53aa$var$_slicedToArray(arr, i) {
    return $1a298d77808b53aa$var$_arrayWithHoles(arr) || $1a298d77808b53aa$var$_iterableToArrayLimit(arr, i) || $1a298d77808b53aa$var$_unsupportedIterableToArray(arr, i) || $1a298d77808b53aa$var$_nonIterableRest();
}
function $1a298d77808b53aa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a298d77808b53aa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1a298d77808b53aa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1a298d77808b53aa$var$_arrayLikeToArray(o, minLen);
}
function $1a298d77808b53aa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1a298d77808b53aa$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1a298d77808b53aa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1a298d77808b53aa$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $1a298d77808b53aa$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $1a298d77808b53aa$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $73c70792af8d3ac2$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $a17379b9bcf38d51$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $a17379b9bcf38d51$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $a17379b9bcf38d51$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $a17379b9bcf38d51$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $a17379b9bcf38d51$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $a17379b9bcf38d51$var$SLASHES = "\uFF0F/";
var $a17379b9bcf38d51$var$DOTS = "\uFF0E.";
var $a17379b9bcf38d51$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $a17379b9bcf38d51$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $a17379b9bcf38d51$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $a17379b9bcf38d51$export$7f01587e28f9194 = "".concat($a17379b9bcf38d51$var$DASHES).concat($a17379b9bcf38d51$var$SLASHES).concat($a17379b9bcf38d51$var$DOTS).concat($a17379b9bcf38d51$export$20542845033f576e).concat($a17379b9bcf38d51$var$BRACKETS).concat($a17379b9bcf38d51$var$TILDES);
var $a17379b9bcf38d51$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $f3ff1a89a48c9896$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f3ff1a89a48c9896$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f3ff1a89a48c9896$var$_typeof(obj);
}
function $f3ff1a89a48c9896$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f3ff1a89a48c9896$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f3ff1a89a48c9896$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f3ff1a89a48c9896$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f3ff1a89a48c9896$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f3ff1a89a48c9896$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f3ff1a89a48c9896$var$_setPrototypeOf(subClass, superClass);
}
function $f3ff1a89a48c9896$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f3ff1a89a48c9896$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f3ff1a89a48c9896$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f3ff1a89a48c9896$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f3ff1a89a48c9896$var$_possibleConstructorReturn(this, result);
    };
}
function $f3ff1a89a48c9896$var$_possibleConstructorReturn(self, call) {
    if (call && ($f3ff1a89a48c9896$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f3ff1a89a48c9896$var$_assertThisInitialized(self);
}
function $f3ff1a89a48c9896$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f3ff1a89a48c9896$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $f3ff1a89a48c9896$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$f3ff1a89a48c9896$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $f3ff1a89a48c9896$var$_construct(Class, arguments, $f3ff1a89a48c9896$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $f3ff1a89a48c9896$var$_setPrototypeOf(Wrapper, Class);
    };
    return $f3ff1a89a48c9896$var$_wrapNativeSuper(Class);
}
function $f3ff1a89a48c9896$var$_construct(Parent, args, Class) {
    if ($f3ff1a89a48c9896$var$_isNativeReflectConstruct()) $f3ff1a89a48c9896$var$_construct = Reflect.construct;
    else $f3ff1a89a48c9896$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $f3ff1a89a48c9896$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $f3ff1a89a48c9896$var$_construct.apply(null, arguments);
}
function $f3ff1a89a48c9896$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f3ff1a89a48c9896$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $f3ff1a89a48c9896$var$_setPrototypeOf(o, p) {
    $f3ff1a89a48c9896$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f3ff1a89a48c9896$var$_setPrototypeOf(o, p);
}
function $f3ff1a89a48c9896$var$_getPrototypeOf(o) {
    $f3ff1a89a48c9896$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3ff1a89a48c9896$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $f3ff1a89a48c9896$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $f3ff1a89a48c9896$var$_inherits(ParseError, _Error);
    var _super = $f3ff1a89a48c9896$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $f3ff1a89a48c9896$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($f3ff1a89a48c9896$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $f3ff1a89a48c9896$var$_createClass(ParseError);
}(/*#__PURE__*/ $f3ff1a89a48c9896$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $fe1a71b557d1f28d$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $16b4566deecbd4ee$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $16b4566deecbd4ee$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $16b4566deecbd4ee$var$_typeof(obj);
}
function $16b4566deecbd4ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $16b4566deecbd4ee$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $16b4566deecbd4ee$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $16b4566deecbd4ee$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $16b4566deecbd4ee$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $16b4566deecbd4ee$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $16b4566deecbd4ee$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $16b4566deecbd4ee$var$V4 = "1.7.35";
var $16b4566deecbd4ee$var$DEFAULT_EXT_PREFIX = " ext. ";
var $16b4566deecbd4ee$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $16b4566deecbd4ee$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $16b4566deecbd4ee$var$_classCallCheck(this, Metadata);
        $16b4566deecbd4ee$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $16b4566deecbd4ee$var$setVersion.call(this, metadata);
    }
    $16b4566deecbd4ee$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $16b4566deecbd4ee$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $16b4566deecbd4ee$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $16b4566deecbd4ee$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $16b4566deecbd4ee$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $16b4566deecbd4ee$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $16b4566deecbd4ee$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $16b4566deecbd4ee$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $16b4566deecbd4ee$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $16b4566deecbd4ee$var$getType(this.types(), _type2)) return new $16b4566deecbd4ee$var$Type($16b4566deecbd4ee$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $16b4566deecbd4ee$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $16b4566deecbd4ee$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $16b4566deecbd4ee$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $16b4566deecbd4ee$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $16b4566deecbd4ee$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$16b4566deecbd4ee$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $16b4566deecbd4ee$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $16b4566deecbd4ee$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $16b4566deecbd4ee$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $16b4566deecbd4ee$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $16b4566deecbd4ee$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $16b4566deecbd4ee$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $73c70792af8d3ac2$export$2e2bcd8739ae039)(metadata) || !(0, $73c70792af8d3ac2$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $73c70792af8d3ac2$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $16b4566deecbd4ee$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $16b4566deecbd4ee$var$typeOf = function typeOf(_) {
    return $16b4566deecbd4ee$var$_typeof(_);
};
function $16b4566deecbd4ee$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $16b4566deecbd4ee$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $16b4566deecbd4ee$var$DEFAULT_EXT_PREFIX;
}
function $16b4566deecbd4ee$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $16b4566deecbd4ee$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $16b4566deecbd4ee$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $16b4566deecbd4ee$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $fe1a71b557d1f28d$export$2e2bcd8739ae039)(version, $16b4566deecbd4ee$var$V3) === -1) this.v2 = true;
        else if ((0, $fe1a71b557d1f28d$export$2e2bcd8739ae039)(version, $16b4566deecbd4ee$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $f43182096930ad9e$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $f43182096930ad9e$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $a17379b9bcf38d51$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $f43182096930ad9e$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $f43182096930ad9e$var$RFC3966_EXTN_PREFIX + $f43182096930ad9e$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $f43182096930ad9e$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $f43182096930ad9e$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $f43182096930ad9e$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $f43182096930ad9e$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $f43182096930ad9e$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $dd1cbeee82768628$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]{" + (0, $a17379b9bcf38d51$export$cd8355bcbe13154) + "}"; //
var $dd1cbeee82768628$export$a77dd7471651eee = "[" + (0, $a17379b9bcf38d51$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $a17379b9bcf38d51$export$7f01587e28f9194) + "]*" + "[" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $a17379b9bcf38d51$export$7f01587e28f9194) + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $dd1cbeee82768628$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $a17379b9bcf38d51$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $a17379b9bcf38d51$export$7f01587e28f9194) + "]*" + "[" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $dd1cbeee82768628$export$a2d12a04749c087d = $dd1cbeee82768628$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $f43182096930ad9e$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $dd1cbeee82768628$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $dd1cbeee82768628$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $dd1cbeee82768628$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $dd1cbeee82768628$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $a17379b9bcf38d51$export$cd8355bcbe13154) && $dd1cbeee82768628$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $dd1cbeee82768628$export$4c3f76c95c05197c(number) {
    return $dd1cbeee82768628$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $966bf88b3744136e$var$EXTN_PATTERN = new RegExp("(?:" + (0, $f43182096930ad9e$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $966bf88b3744136e$export$2e2bcd8739ae039(number) {
    var start = number.search($966bf88b3744136e$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($966bf88b3744136e$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $5f93e677b6636bb9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5f93e677b6636bb9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5f93e677b6636bb9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5f93e677b6636bb9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5f93e677b6636bb9$var$_arrayLikeToArray(o, minLen);
}
function $5f93e677b6636bb9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5f93e677b6636bb9$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $5f93e677b6636bb9$export$1d16fddea1437169(character) {
    return $5f93e677b6636bb9$export$2848f3d68c08fe69[character];
}
function $5f93e677b6636bb9$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $5f93e677b6636bb9$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $5f93e677b6636bb9$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $ff541052da43a126$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ff541052da43a126$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff541052da43a126$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ff541052da43a126$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ff541052da43a126$var$_arrayLikeToArray(o, minLen);
}
function $ff541052da43a126$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ff541052da43a126$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $ff541052da43a126$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $ff541052da43a126$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $ff541052da43a126$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $5f93e677b6636bb9$export$1d16fddea1437169)(character);
}




function $55f5e993dcdd1e73$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $55f5e993dcdd1e73$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $55f5e993dcdd1e73$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $55f5e993dcdd1e73$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $55f5e993dcdd1e73$var$_arrayLikeToArray(o, minLen);
}
function $55f5e993dcdd1e73$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $55f5e993dcdd1e73$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $55f5e993dcdd1e73$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $4241a6dac735dd7e$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $4241a6dac735dd7e$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $4241a6dac735dd7e$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $4241a6dac735dd7e$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $55f5e993dcdd1e73$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $32be24dbe1c47cef$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $32be24dbe1c47cef$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $32be24dbe1c47cef$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $4241a6dac735dd7e$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $961f660848915baf$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $335dfad191dd54e8$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $335dfad191dd54e8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $335dfad191dd54e8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $335dfad191dd54e8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $335dfad191dd54e8$var$_arrayLikeToArray(o, minLen);
}
function $335dfad191dd54e8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $335dfad191dd54e8$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $335dfad191dd54e8$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($335dfad191dd54e8$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($335dfad191dd54e8$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $335dfad191dd54e8$var$_createForOfIteratorHelperLoose($335dfad191dd54e8$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($335dfad191dd54e8$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $335dfad191dd54e8$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $5ebfff060aa5fdcb$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $335dfad191dd54e8$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $02c768cf03f6e667$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $02c768cf03f6e667$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $02c768cf03f6e667$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $fd14510c628f4911$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $a17379b9bcf38d51$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $56763d192c8fe61a$export$4f32ad1c51a7a6be = /(\$\d)/;
function $56763d192c8fe61a$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($56763d192c8fe61a$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $fd14510c628f4911$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $0a9020986952b3b5$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $0a9020986952b3b5$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($0a9020986952b3b5$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $d10bf095dffb3170$var$_slicedToArray(arr, i) {
    return $d10bf095dffb3170$var$_arrayWithHoles(arr) || $d10bf095dffb3170$var$_iterableToArrayLimit(arr, i) || $d10bf095dffb3170$var$_unsupportedIterableToArray(arr, i) || $d10bf095dffb3170$var$_nonIterableRest();
}
function $d10bf095dffb3170$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d10bf095dffb3170$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d10bf095dffb3170$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d10bf095dffb3170$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d10bf095dffb3170$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d10bf095dffb3170$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d10bf095dffb3170$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d10bf095dffb3170$var$_arrayLikeToArray(o, minLen);
}
function $d10bf095dffb3170$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d10bf095dffb3170$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $d10bf095dffb3170$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $d10bf095dffb3170$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $dd1cbeee82768628$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $d10bf095dffb3170$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $7cc904601206bc4a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7cc904601206bc4a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7cc904601206bc4a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7cc904601206bc4a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7cc904601206bc4a$var$_arrayLikeToArray(o, minLen);
}
function $7cc904601206bc4a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7cc904601206bc4a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7cc904601206bc4a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7cc904601206bc4a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7cc904601206bc4a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7cc904601206bc4a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7cc904601206bc4a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $7cc904601206bc4a$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $7cc904601206bc4a$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $7cc904601206bc4a$var$_objectSpread($7cc904601206bc4a$var$_objectSpread({}, $7cc904601206bc4a$var$DEFAULT_OPTIONS), options);
    else options = $7cc904601206bc4a$var$DEFAULT_OPTIONS;
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $7cc904601206bc4a$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $7cc904601206bc4a$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $7cc904601206bc4a$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $7cc904601206bc4a$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $d10bf095dffb3170$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $7cc904601206bc4a$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $7cc904601206bc4a$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $7cc904601206bc4a$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $7cc904601206bc4a$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $56763d192c8fe61a$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $7cc904601206bc4a$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $7cc904601206bc4a$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $7cc904601206bc4a$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $7cc904601206bc4a$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $16b4566deecbd4ee$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $7cc904601206bc4a$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $0a9020986952b3b5$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($7cc904601206bc4a$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $a9be8d769109e386$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a9be8d769109e386$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a9be8d769109e386$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a9be8d769109e386$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a9be8d769109e386$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a9be8d769109e386$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a9be8d769109e386$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a9be8d769109e386$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a9be8d769109e386$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a9be8d769109e386$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a9be8d769109e386$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $a9be8d769109e386$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $a9be8d769109e386$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $a9be8d769109e386$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $a9be8d769109e386$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $a9be8d769109e386$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $02c768cf03f6e667$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $32be24dbe1c47cef$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $5ebfff060aa5fdcb$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $335dfad191dd54e8$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $7cc904601206bc4a$export$2e2bcd8739ae039)(this, _format, options ? $a9be8d769109e386$var$_objectSpread($a9be8d769109e386$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $a9be8d769109e386$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $a9be8d769109e386$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($a9be8d769109e386$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($a9be8d769109e386$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $7bd7962442e564bf$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "])");
function $7bd7962442e564bf$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($7bd7962442e564bf$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $6efda04e9f6fad13$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $017c7bb6c5efbfc3$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $6efda04e9f6fad13$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$017c7bb6c5efbfc3$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$017c7bb6c5efbfc3$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $017c7bb6c5efbfc3$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $017c7bb6c5efbfc3$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $4241a6dac735dd7e$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $8424dd08dc3256a7$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $16b4566deecbd4ee$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $017c7bb6c5efbfc3$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $017c7bb6c5efbfc3$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $961f660848915baf$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $4241a6dac735dd7e$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $905520c22cdd27fa$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $7bd7962442e564bf$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $8424dd08dc3256a7$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $a17379b9bcf38d51$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $a1b2e957c604f1d0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a1b2e957c604f1d0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a1b2e957c604f1d0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a1b2e957c604f1d0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a1b2e957c604f1d0$var$_arrayLikeToArray(o, minLen);
}
function $a1b2e957c604f1d0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a1b2e957c604f1d0$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata);
    var matchingCountries = [];
    for(var _iterator = $a1b2e957c604f1d0$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $335dfad191dd54e8$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}


var $ee9145a6e471673a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $ee9145a6e471673a$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($ee9145a6e471673a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $a1b2e957c604f1d0$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $528027f923f3bf21$export$1ddc7eed78155f68 = "+";
var $528027f923f3bf21$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $528027f923f3bf21$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]" + "|" + $528027f923f3bf21$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $528027f923f3bf21$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $528027f923f3bf21$export$1ddc7eed78155f68 + $528027f923f3bf21$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]" + $528027f923f3bf21$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $528027f923f3bf21$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($528027f923f3bf21$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $528027f923f3bf21$var$ALPHANUM_ = (0, $a17379b9bcf38d51$export$852d1d4a47329634);
var $528027f923f3bf21$var$RFC3966_DOMAINLABEL_ = "[" + $528027f923f3bf21$var$ALPHANUM_ + "]+((\\-)*[" + $528027f923f3bf21$var$ALPHANUM_ + "])*";
var $528027f923f3bf21$var$VALID_ALPHA_ = "a-zA-Z";
var $528027f923f3bf21$var$RFC3966_TOPLABEL_ = "[" + $528027f923f3bf21$var$VALID_ALPHA_ + "]+((\\-)*[" + $528027f923f3bf21$var$ALPHANUM_ + "])*";
var $528027f923f3bf21$var$RFC3966_DOMAINNAME_ = "^(" + $528027f923f3bf21$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $528027f923f3bf21$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $528027f923f3bf21$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($528027f923f3bf21$var$RFC3966_DOMAINNAME_, "g");
var $528027f923f3bf21$export$70d485ce3f6de783 = "tel:";
var $528027f923f3bf21$export$f6d5879d582c3a27 = ";phone-context=";
var $528027f923f3bf21$export$9e356e12edb00a81 = ";isub=";
function $528027f923f3bf21$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($528027f923f3bf21$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $528027f923f3bf21$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $528027f923f3bf21$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $528027f923f3bf21$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $528027f923f3bf21$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $bba019a74ec721aa$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $528027f923f3bf21$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $528027f923f3bf21$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $528027f923f3bf21$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $528027f923f3bf21$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $528027f923f3bf21$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $528027f923f3bf21$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $528027f923f3bf21$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $eb655f0ce66f8730$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $eb655f0ce66f8730$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $a17379b9bcf38d51$export$207c99ccf3902df8) + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $eb655f0ce66f8730$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $a17379b9bcf38d51$export$852d1d4a47329634) + "#" + "]+$");
var $eb655f0ce66f8730$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $eb655f0ce66f8730$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $16b4566deecbd4ee$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $eb655f0ce66f8730$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $eb655f0ce66f8730$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $a17379b9bcf38d51$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $a17379b9bcf38d51$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $a9be8d769109e386$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $961f660848915baf$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $eb655f0ce66f8730$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $32be24dbe1c47cef$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $eb655f0ce66f8730$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $eb655f0ce66f8730$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($eb655f0ce66f8730$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($eb655f0ce66f8730$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $eb655f0ce66f8730$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $bba019a74ec721aa$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $eb655f0ce66f8730$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $dd1cbeee82768628$export$2e2bcd8739ae039)(number)) {
        if ((0, $dd1cbeee82768628$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $966bf88b3744136e$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $eb655f0ce66f8730$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $eb655f0ce66f8730$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $905520c22cdd27fa$export$2e2bcd8739ae039)((0, $ff541052da43a126$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($eb655f0ce66f8730$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $16b4566deecbd4ee$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $017c7bb6c5efbfc3$export$2e2bcd8739ae039)((0, $ff541052da43a126$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $ee9145a6e471673a$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $49f1b1a9f24315c2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $49f1b1a9f24315c2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $49f1b1a9f24315c2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $49f1b1a9f24315c2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $49f1b1a9f24315c2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $49f1b1a9f24315c2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $49f1b1a9f24315c2$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $eb655f0ce66f8730$export$2e2bcd8739ae039)(text, $49f1b1a9f24315c2$var$_objectSpread($49f1b1a9f24315c2$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $ceaa0fd5c7db2fde$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ceaa0fd5c7db2fde$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ceaa0fd5c7db2fde$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ceaa0fd5c7db2fde$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ceaa0fd5c7db2fde$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ceaa0fd5c7db2fde$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ceaa0fd5c7db2fde$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $16b4566deecbd4ee$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $ceaa0fd5c7db2fde$var$_objectSpread($ceaa0fd5c7db2fde$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $49f1b1a9f24315c2$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $f3ff1a89a48c9896$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $ba11c069758aae0b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba11c069758aae0b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ba11c069758aae0b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ba11c069758aae0b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ba11c069758aae0b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ba11c069758aae0b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ba11c069758aae0b$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $1a298d77808b53aa$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $ba11c069758aae0b$var$_objectSpread($ba11c069758aae0b$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $ceaa0fd5c7db2fde$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $299ca06d6965fd15$export$992e2df24bec72ba() {
    return (0, $03641f6f3ef8cc44$export$2e2bcd8739ae039)((0, $ba11c069758aae0b$export$2e2bcd8739ae039), arguments);
}


(function() {
    const directive = {
        name: "maskPhoneV2"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs, ngModel)=>{
            attrs.$set("type", "tel");
            ngModel.$validators["phone"] = (modelValue, viewValue)=>{
                const value = modelValue || viewValue;
                return value ? (0, $299ca06d6965fd15$export$992e2df24bec72ba)(value, scope.formData.country) : false;
            };
            ngModel.$validate();
        };
        return {
            restrict: "A",
            require: "?ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $196a3e27a352fe5d$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "$http"
    ];
    app.factory("phoneMask", controller);
    function controller($q, $http) {
        return {
            list () {
                const defer = $q.defer();
                const alias = "phoneMaskList";
                $http.get("/joxi/js/boot/data/phone-mask.json").then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
})();


(function() {
    const directive = {
        name: "maskPhone"
    };
    controller.$inject = [
        "phoneMask"
    ];
    function controller(_phoneMask) {
        const link = (scope, element, attrs, ngModel)=>{
            _phoneMask.list().then((phoneMasks)=>{
                run(phoneMasks);
            }).catch((answer)=>{}).finally(()=>{});
            function run(phoneMasks) {
                phoneMasks.sort((a, b)=>{
                    if (a.length < b.length || a.additional) return -1;
                    return 1;
                });
                let oldPrefix = "";
                let maskIndex = phoneMasks.length - 1;
                const inputMask = new IMask(element[0], {
                    mask: phoneMasks,
                    dispatch: function(appended, dynamicMasked) {
                        const number = (dynamicMasked.value + appended).replace(/\D/g, "");
                        const index = dynamicMasked.compiledMasks.findIndex((m)=>{
                            let a = true;
                            if (m.additional) a = number.indexOf(m.additional.str) === m.additional.pos;
                            return number.indexOf(m.startWith) === 0 && number.length <= m.length && a;
                        });
                        maskIndex = index !== -1 ? index : maskIndex;
                        return dynamicMasked.compiledMasks[maskIndex];
                    }
                });
                inputMask.on("accept", ()=>{
                    ngModel.$setViewValue(parseInt(inputMask.unmaskedValue, 10) || "");
                });
                attrs.$set("type", "tel");
                setPrefix(attrs[directive.name]);
                attrs.$observe(directive.name, (value)=>{
                    setPrefix(value);
                });
                ngModel.$formatters.push((modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    if (value) inputMask.unmaskedValue = value;
                    return inputMask.value;
                });
                const isBankId = attrs.maskPhone === "bankid";
                ngModel.$parsers.push((modelValue, viewValue)=>{
                    if (isBankId) {
                        const cleanedValue = inputMask.value.replace(/[^0-9]/g, "");
                        return `+${cleanedValue}`;
                    }
                    return inputMask.unmaskedValue;
                });
                ngModel.$validators["phone"] = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? inputMask.masked.isComplete : true;
                };
                ngModel.$validate();
                function setPrefix(value) {
                    const newPrefix = value.replace(/\-|\+/g, "");
                    if (!inputMask.unmaskedValue || inputMask.unmaskedValue === oldPrefix) inputMask.unmaskedValue = newPrefix;
                    oldPrefix = newPrefix;
                }
            }
        };
        return {
            restrict: "A",
            require: "?ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $2cb8b345aa8252bb$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "maskPtPostcode"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs, ngModel)=>{
            const inputMask = new IMask(element[0], {
                mask: "0000-000",
                lazy: false,
                placeholderChar: "X"
            });
            inputMask.on("accept", ()=>{
                ngModel.$setViewValue(parseInt(inputMask.unmaskedValue, 10) || "");
            });
            ngModel.$formatters.push((modelValue)=>{
                if (!modelValue) return "";
                inputMask.value = modelValue;
                return modelValue;
            });
            ngModel.$parsers.push(()=>{
                return inputMask.value;
            });
            ngModel.$validators["postcode"] = (modelValue)=>{
                return !modelValue || inputMask.masked.isComplete;
            };
        };
        return {
            restrict: "A",
            require: "?ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $67a279c11f157498$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "$http"
    ];
    app.factory("zipcodeMask", controller);
    function controller($q, $http) {
        return {
            list () {
                const defer = $q.defer();
                $http.get("/joxi/js/boot/data/zipcode-mask.json").then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
})();


(function() {
    const directive = {
        name: "maskZipcode"
    };
    controller.$inject = [
        "zipcodeMask"
    ];
    function controller(_zipcodeMask) {
        let zipcodeMasks = [];
        const link = (scope, element, attrs, ngModel)=>{
            const inputMask = new IMask(element[0], {
                mask: /./
            });
            inputMask.on("accept", ()=>ngModel.$setViewValue(inputMask.value || ""));
            ngModel.$parsers.push((value)=>value);
            ngModel.$formatters.push((modelValue)=>{
                if (!modelValue) return "";
                inputMask.value = modelValue;
                return modelValue;
            });
            function getZipInfo() {
                return _zipcodeMask.list().then((answer)=>{
                    zipcodeMasks = answer;
                }).catch(()=>{}).finally(()=>{});
            }
            function addValidator(country) {
                if (!country) return;
                const defaultCountryMask = {
                    mask: /^[a-zA-Z0-9-]+$/,
                    length: 100
                };
                const countryMask = zipcodeMasks.find((mask)=>mask.country === country) || defaultCountryMask;
                element[0].maxLength = countryMask.length;
                inputMask.updateOptions({
                    mask: countryMask.mask
                });
            }
            function init() {
                if (zipcodeMasks.length) {
                    addValidator(scope.formData.country);
                    return;
                }
                getZipInfo().then(()=>{
                    addValidator(scope.formData.country);
                });
            }
            init();
            scope.$watch("formData.country", (newVal)=>{
                if (zipcodeMasks.length) addValidator(newVal);
            });
            scope.$onDestroy = ()=>{
                inputMask.destroy();
            };
        };
        return {
            restrict: "A",
            require: "?ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3ab59b29bbb13f6d$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "nativeDatepicker"
    };
    controller.$inject = [
        "$filter",
        "birthdayDatepicker"
    ];
    function controller($filter, _birthdayDatepicker) {
        const link = ($scope, $element, $attrs, $ctrl)=>{
            const params = $scope.$eval($attrs[directive.name]) || {};
            $ctrl.$parsers.push((value)=>{
                return $filter("date")(value, "yyyy-MM-dd");
            });
            $ctrl.$formatters.push((value)=>{
                return new Date(value);
            });
            if (params.setDefaultFormData) {
                const targetElement = $element[0];
                const focusListener = ()=>$scope.formData.birthday = $element.val() || _birthdayDatepicker.maxDateValue;
                targetElement.addEventListener("focus", focusListener);
                $scope.$on("$destroy", ()=>targetElement.removeEventListener("focus", focusListener));
            }
        };
        return {
            require: "ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $095e63c3373c04a0$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "onSuccess"
    };
    controller.$inject = [
        "$state",
        "popup",
        "state",
        "$window"
    ];
    function controller($state, _popup, _state, $window) {
        const link = (scope, element, attrs, formCtrl)=>{
            let action = {
                none: null
            };
            attrs.$observe(directive.name, (value)=>{
                action = scope.$eval(value);
                if (typeof action.params !== "object") action.params = {};
            });
            formCtrl.$onSuccessful = function() {
                // TODO: modal
                switch(Object.keys(action)[0]){
                    case "state":
                        _popup.close();
                        $state.go(action.state, action.params);
                        break;
                    case "popup":
                        _popup.open({
                            name: action.popup,
                            content: action.params
                        });
                        break;
                    case "popup-close":
                        _popup.close();
                        break;
                    case "alias":
                        _popup.close();
                        _state.goto(action.alias);
                        break;
                    case "location":
                        $window.location = `${action.location}?${jQuery.param(action.params)}`;
                        break;
                    case "open":
                        $window.open(`${action.open}`);
                        break;
                    default:
                        break;
                }
            };
        };
        return {
            require: "form",
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $7eb72df80797b874$exports = {};
var $106258fa070913ba$exports = {};
(function(f) {
    var g;
    $106258fa070913ba$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    // Generated by CoffeeScript 1.12.2
                    (function() {
                        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                            return performance.now();
                        };
                        else if (typeof process !== "undefined" && process !== null && process.hrtime) {
                            module1.exports = function() {
                                return (getNanoSeconds() - nodeLoadTime) / 1e6;
                            };
                            hrtime = process.hrtime;
                            getNanoSeconds = function() {
                                var hr;
                                hr = hrtime();
                                return hr[0] * 1e9 + hr[1];
                            };
                            moduleLoadTime = getNanoSeconds();
                            upTime = process.uptime() * 1e9;
                            nodeLoadTime = moduleLoadTime - upTime;
                        } else if (Date.now) {
                            module1.exports = function() {
                                return Date.now() - loadTime;
                            };
                            loadTime = Date.now();
                        } else {
                            module1.exports = function() {
                                return new Date().getTime() - loadTime;
                            };
                            loadTime = new Date().getTime();
                        }
                    }).call(this);
                }).call(this, require1("_process"));
            },
            {
                "_process": 3
            }
        ],
        3: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                (function(global1) {
                    var now = require1("performance-now"), root = typeof window === "undefined" ? global1 : window, vendors = [
                        "moz",
                        "webkit"
                    ], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
                    for(var i = 0; !raf && i < vendors.length; i++){
                        raf = root[vendors[i] + "Request" + suffix];
                        caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
                    }
                    // Some versions of FF have rAF but not cAF
                    if (!raf || !caf) {
                        var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                        raf = function(callback) {
                            if (queue.length === 0) {
                                var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                                last = next + _now;
                                setTimeout(function() {
                                    var cp = queue.slice(0);
                                    // Clear queue here to prevent
                                    // callbacks from appending listeners
                                    // to the current frame's queue
                                    queue.length = 0;
                                    for(var i = 0; i < cp.length; i++){
                                        if (!cp[i].cancelled) try {
                                            cp[i].callback(last);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw e;
                                            }, 0);
                                        }
                                    }
                                }, Math.round(next));
                            }
                            queue.push({
                                handle: ++id,
                                callback: callback,
                                cancelled: false
                            });
                            return id;
                        };
                        caf = function(handle) {
                            for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                        };
                    }
                    module1.exports = function(fn) {
                        // Wrap in a new function to prevent
                        // `cancel` potentially being assigned
                        // to the native rAF function
                        return raf.call(root, fn);
                    };
                    module1.exports.cancel = function() {
                        caf.apply(root, arguments);
                    };
                    module1.exports.polyfill = function() {
                        root.requestAnimationFrame = raf;
                        root.cancelAnimationFrame = caf;
                    };
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "performance-now": 2
            }
        ],
        5: [
            function(require1, module1, exports) {
                "use strict";
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
* Parallax.js
* @author Matthew Wagerfield - @wagerfield, René Roth - mail@reneroth.org
* @description Creates a parallax effect between an array of layers,
*              driving the motion from the gyroscope output of a smartdevice.
*              If no gyroscope is available, the cursor position is used.
*/ var rqAnFr = require1("raf");
                var objectAssign = require1("object-assign");
                var helpers = {
                    propertyCache: {},
                    vendors: [
                        null,
                        [
                            "-webkit-",
                            "webkit"
                        ],
                        [
                            "-moz-",
                            "Moz"
                        ],
                        [
                            "-o-",
                            "O"
                        ],
                        [
                            "-ms-",
                            "ms"
                        ]
                    ],
                    clamp: function clamp(value, min, max) {
                        return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
                    },
                    data: function data(element, name) {
                        return helpers.deserialize(element.getAttribute("data-" + name));
                    },
                    deserialize: function deserialize(value) {
                        if (value === "true") return true;
                        else if (value === "false") return false;
                        else if (value === "null") return null;
                        else if (!isNaN(parseFloat(value)) && isFinite(value)) return parseFloat(value);
                        else return value;
                    },
                    camelCase: function camelCase(value) {
                        return value.replace(/-+(.)?/g, function(match, character) {
                            return character ? character.toUpperCase() : "";
                        });
                    },
                    accelerate: function accelerate(element) {
                        helpers.css(element, "transform", "translate3d(0,0,0) rotate(0.0001deg)");
                        helpers.css(element, "transform-style", "preserve-3d");
                        helpers.css(element, "backface-visibility", "hidden");
                    },
                    transformSupport: function transformSupport(value) {
                        var element = document.createElement("div"), propertySupport = false, propertyValue = null, featureSupport = false, cssProperty = null, jsProperty = null;
                        for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) {
                                cssProperty = helpers.vendors[i][0] + "transform";
                                jsProperty = helpers.vendors[i][1] + "Transform";
                            } else {
                                cssProperty = "transform";
                                jsProperty = "transform";
                            }
                            if (element.style[jsProperty] !== undefined) {
                                propertySupport = true;
                                break;
                            }
                        }
                        switch(value){
                            case "2D":
                                featureSupport = propertySupport;
                                break;
                            case "3D":
                                if (propertySupport) {
                                    var body = document.body || document.createElement("body"), documentElement = document.documentElement, documentOverflow = documentElement.style.overflow, isCreatedBody = false;
                                    if (!document.body) {
                                        isCreatedBody = true;
                                        documentElement.style.overflow = "hidden";
                                        documentElement.appendChild(body);
                                        body.style.overflow = "hidden";
                                        body.style.background = "";
                                    }
                                    body.appendChild(element);
                                    element.style[jsProperty] = "translate3d(1px,1px,1px)";
                                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
                                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== "none";
                                    documentElement.style.overflow = documentOverflow;
                                    body.removeChild(element);
                                    if (isCreatedBody) {
                                        body.removeAttribute("style");
                                        body.parentNode.removeChild(body);
                                    }
                                }
                                break;
                        }
                        return featureSupport;
                    },
                    css: function css(element, property, value) {
                        var jsProperty = helpers.propertyCache[property];
                        if (!jsProperty) for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) jsProperty = helpers.camelCase(helpers.vendors[i][1] + "-" + property);
                            else jsProperty = property;
                            if (element.style[jsProperty] !== undefined) {
                                helpers.propertyCache[property] = jsProperty;
                                break;
                            }
                        }
                        element.style[jsProperty] = value;
                    }
                };
                var MAGIC_NUMBER = 30, DEFAULTS = {
                    relativeInput: false,
                    clipRelativeInput: false,
                    inputElement: null,
                    hoverOnly: false,
                    calibrationThreshold: 100,
                    calibrationDelay: 500,
                    supportDelay: 500,
                    calibrateX: false,
                    calibrateY: true,
                    invertX: true,
                    invertY: true,
                    limitX: false,
                    limitY: false,
                    scalarX: 10.0,
                    scalarY: 10.0,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5,
                    pointerEvents: false,
                    precision: 1,
                    onReady: null,
                    selector: null
                };
                var Parallax = function() {
                    function Parallax(element, options) {
                        _classCallCheck(this, Parallax);
                        this.element = element;
                        var data = {
                            calibrateX: helpers.data(this.element, "calibrate-x"),
                            calibrateY: helpers.data(this.element, "calibrate-y"),
                            invertX: helpers.data(this.element, "invert-x"),
                            invertY: helpers.data(this.element, "invert-y"),
                            limitX: helpers.data(this.element, "limit-x"),
                            limitY: helpers.data(this.element, "limit-y"),
                            scalarX: helpers.data(this.element, "scalar-x"),
                            scalarY: helpers.data(this.element, "scalar-y"),
                            frictionX: helpers.data(this.element, "friction-x"),
                            frictionY: helpers.data(this.element, "friction-y"),
                            originX: helpers.data(this.element, "origin-x"),
                            originY: helpers.data(this.element, "origin-y"),
                            pointerEvents: helpers.data(this.element, "pointer-events"),
                            precision: helpers.data(this.element, "precision"),
                            relativeInput: helpers.data(this.element, "relative-input"),
                            clipRelativeInput: helpers.data(this.element, "clip-relative-input"),
                            hoverOnly: helpers.data(this.element, "hover-only"),
                            inputElement: document.querySelector(helpers.data(this.element, "input-element")),
                            selector: helpers.data(this.element, "selector")
                        };
                        for(var key in data)if (data[key] === null) delete data[key];
                        objectAssign(this, DEFAULTS, data, options);
                        if (!this.inputElement) this.inputElement = this.element;
                        this.calibrationTimer = null;
                        this.calibrationFlag = true;
                        this.enabled = false;
                        this.depthsX = [];
                        this.depthsY = [];
                        this.raf = null;
                        this.bounds = null;
                        this.elementPositionX = 0;
                        this.elementPositionY = 0;
                        this.elementWidth = 0;
                        this.elementHeight = 0;
                        this.elementCenterX = 0;
                        this.elementCenterY = 0;
                        this.elementRangeX = 0;
                        this.elementRangeY = 0;
                        this.calibrationX = 0;
                        this.calibrationY = 0;
                        this.inputX = 0;
                        this.inputY = 0;
                        this.motionX = 0;
                        this.motionY = 0;
                        this.velocityX = 0;
                        this.velocityY = 0;
                        this.onMouseMove = this.onMouseMove.bind(this);
                        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
                        this.onDeviceMotion = this.onDeviceMotion.bind(this);
                        this.onOrientationTimer = this.onOrientationTimer.bind(this);
                        this.onMotionTimer = this.onMotionTimer.bind(this);
                        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
                        this.onAnimationFrame = this.onAnimationFrame.bind(this);
                        this.onWindowResize = this.onWindowResize.bind(this);
                        this.windowWidth = null;
                        this.windowHeight = null;
                        this.windowCenterX = null;
                        this.windowCenterY = null;
                        this.windowRadiusX = null;
                        this.windowRadiusY = null;
                        this.portrait = false;
                        this.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
                        this.motionSupport = !!window.DeviceMotionEvent && !this.desktop;
                        this.orientationSupport = !!window.DeviceOrientationEvent && !this.desktop;
                        this.orientationStatus = 0;
                        this.motionStatus = 0;
                        this.initialise();
                    }
                    _createClass(Parallax, [
                        {
                            key: "initialise",
                            value: function initialise() {
                                if (this.transform2DSupport === undefined) {
                                    this.transform2DSupport = helpers.transformSupport("2D");
                                    this.transform3DSupport = helpers.transformSupport("3D");
                                }
                                // Configure Context Styles
                                if (this.transform3DSupport) helpers.accelerate(this.element);
                                var style = window.getComputedStyle(this.element);
                                if (style.getPropertyValue("position") === "static") this.element.style.position = "relative";
                                // Pointer events
                                if (!this.pointerEvents) this.element.style.pointerEvents = "none";
                                // Setup
                                this.updateLayers();
                                this.updateDimensions();
                                this.enable();
                                this.queueCalibration(this.calibrationDelay);
                            }
                        },
                        {
                            key: "doReadyCallback",
                            value: function doReadyCallback() {
                                if (this.onReady) this.onReady();
                            }
                        },
                        {
                            key: "updateLayers",
                            value: function updateLayers() {
                                if (this.selector) this.layers = this.element.querySelectorAll(this.selector);
                                else this.layers = this.element.children;
                                if (!this.layers.length) console.warn("ParallaxJS: Your scene does not have any layers.");
                                this.depthsX = [];
                                this.depthsY = [];
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index];
                                    if (this.transform3DSupport) helpers.accelerate(layer);
                                    layer.style.position = index ? "absolute" : "relative";
                                    layer.style.display = "block";
                                    layer.style.left = 0;
                                    layer.style.top = 0;
                                    var depth = helpers.data(layer, "depth") || 0;
                                    this.depthsX.push(helpers.data(layer, "depth-x") || depth);
                                    this.depthsY.push(helpers.data(layer, "depth-y") || depth);
                                }
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions() {
                                this.windowWidth = window.innerWidth;
                                this.windowHeight = window.innerHeight;
                                this.windowCenterX = this.windowWidth * this.originX;
                                this.windowCenterY = this.windowHeight * this.originY;
                                this.windowRadiusX = Math.max(this.windowCenterX, this.windowWidth - this.windowCenterX);
                                this.windowRadiusY = Math.max(this.windowCenterY, this.windowHeight - this.windowCenterY);
                            }
                        },
                        {
                            key: "updateBounds",
                            value: function updateBounds() {
                                this.bounds = this.inputElement.getBoundingClientRect();
                                this.elementPositionX = this.bounds.left;
                                this.elementPositionY = this.bounds.top;
                                this.elementWidth = this.bounds.width;
                                this.elementHeight = this.bounds.height;
                                this.elementCenterX = this.elementWidth * this.originX;
                                this.elementCenterY = this.elementHeight * this.originY;
                                this.elementRangeX = Math.max(this.elementCenterX, this.elementWidth - this.elementCenterX);
                                this.elementRangeY = Math.max(this.elementCenterY, this.elementHeight - this.elementCenterY);
                            }
                        },
                        {
                            key: "queueCalibration",
                            value: function queueCalibration(delay) {
                                clearTimeout(this.calibrationTimer);
                                this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
                            }
                        },
                        {
                            key: "enable",
                            value: function enable() {
                                if (this.enabled) return;
                                this.enabled = true;
                                if (this.orientationSupport) {
                                    this.portrait = false;
                                    window.addEventListener("deviceorientation", this.onDeviceOrientation);
                                    this.detectionTimer = setTimeout(this.onOrientationTimer, this.supportDelay);
                                } else if (this.motionSupport) {
                                    this.portrait = false;
                                    window.addEventListener("devicemotion", this.onDeviceMotion);
                                    this.detectionTimer = setTimeout(this.onMotionTimer, this.supportDelay);
                                } else {
                                    this.calibrationX = 0;
                                    this.calibrationY = 0;
                                    this.portrait = false;
                                    window.addEventListener("mousemove", this.onMouseMove);
                                    this.doReadyCallback();
                                }
                                window.addEventListener("resize", this.onWindowResize);
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "disable",
                            value: function disable() {
                                if (!this.enabled) return;
                                this.enabled = false;
                                if (this.orientationSupport) window.removeEventListener("deviceorientation", this.onDeviceOrientation);
                                else if (this.motionSupport) window.removeEventListener("devicemotion", this.onDeviceMotion);
                                else window.removeEventListener("mousemove", this.onMouseMove);
                                window.removeEventListener("resize", this.onWindowResize);
                                rqAnFr.cancel(this.raf);
                            }
                        },
                        {
                            key: "calibrate",
                            value: function calibrate(x, y) {
                                this.calibrateX = x === undefined ? this.calibrateX : x;
                                this.calibrateY = y === undefined ? this.calibrateY : y;
                            }
                        },
                        {
                            key: "invert",
                            value: function invert(x, y) {
                                this.invertX = x === undefined ? this.invertX : x;
                                this.invertY = y === undefined ? this.invertY : y;
                            }
                        },
                        {
                            key: "friction",
                            value: function friction(x, y) {
                                this.frictionX = x === undefined ? this.frictionX : x;
                                this.frictionY = y === undefined ? this.frictionY : y;
                            }
                        },
                        {
                            key: "scalar",
                            value: function scalar(x, y) {
                                this.scalarX = x === undefined ? this.scalarX : x;
                                this.scalarY = y === undefined ? this.scalarY : y;
                            }
                        },
                        {
                            key: "limit",
                            value: function limit(x, y) {
                                this.limitX = x === undefined ? this.limitX : x;
                                this.limitY = y === undefined ? this.limitY : y;
                            }
                        },
                        {
                            key: "origin",
                            value: function origin(x, y) {
                                this.originX = x === undefined ? this.originX : x;
                                this.originY = y === undefined ? this.originY : y;
                            }
                        },
                        {
                            key: "setInputElement",
                            value: function setInputElement(element) {
                                this.inputElement = element;
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "setPosition",
                            value: function setPosition(element, x, y) {
                                x = x.toFixed(this.precision) + "px";
                                y = y.toFixed(this.precision) + "px";
                                if (this.transform3DSupport) helpers.css(element, "transform", "translate3d(" + x + "," + y + ",0)");
                                else if (this.transform2DSupport) helpers.css(element, "transform", "translate(" + x + "," + y + ")");
                                else {
                                    element.style.left = x;
                                    element.style.top = y;
                                }
                            }
                        },
                        {
                            key: "onOrientationTimer",
                            value: function onOrientationTimer() {
                                if (this.orientationSupport && this.orientationStatus === 0) {
                                    this.disable();
                                    this.orientationSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onMotionTimer",
                            value: function onMotionTimer() {
                                if (this.motionSupport && this.motionStatus === 0) {
                                    this.disable();
                                    this.motionSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onCalibrationTimer",
                            value: function onCalibrationTimer() {
                                this.calibrationFlag = true;
                            }
                        },
                        {
                            key: "onWindowResize",
                            value: function onWindowResize() {
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "onAnimationFrame",
                            value: function onAnimationFrame() {
                                this.updateBounds();
                                var calibratedInputX = this.inputX - this.calibrationX, calibratedInputY = this.inputY - this.calibrationY;
                                if (Math.abs(calibratedInputX) > this.calibrationThreshold || Math.abs(calibratedInputY) > this.calibrationThreshold) this.queueCalibration(0);
                                if (this.portrait) {
                                    this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
                                    this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
                                } else {
                                    this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
                                    this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
                                }
                                this.motionX *= this.elementWidth * (this.scalarX / 100);
                                this.motionY *= this.elementHeight * (this.scalarY / 100);
                                if (!isNaN(parseFloat(this.limitX))) this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
                                if (!isNaN(parseFloat(this.limitY))) this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
                                this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
                                this.velocityY += (this.motionY - this.velocityY) * this.frictionY;
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index], depthX = this.depthsX[index], depthY = this.depthsY[index], xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)), yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1));
                                    this.setPosition(layer, xOffset, yOffset);
                                }
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "rotate",
                            value: function rotate(beta, gamma) {
                                // Extract Rotation
                                var x = (beta || 0) / MAGIC_NUMBER, //  -90 :: 90
                                y = (gamma || 0) / MAGIC_NUMBER; // -180 :: 180
                                // Detect Orientation Change
                                var portrait = this.windowHeight > this.windowWidth;
                                if (this.portrait !== portrait) {
                                    this.portrait = portrait;
                                    this.calibrationFlag = true;
                                }
                                if (this.calibrationFlag) {
                                    this.calibrationFlag = false;
                                    this.calibrationX = x;
                                    this.calibrationY = y;
                                }
                                this.inputX = x;
                                this.inputY = y;
                            }
                        },
                        {
                            key: "onDeviceOrientation",
                            value: function onDeviceOrientation(event) {
                                var beta = event.beta;
                                var gamma = event.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.orientationStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onDeviceMotion",
                            value: function onDeviceMotion(event) {
                                var beta = event.rotationRate.beta;
                                var gamma = event.rotationRate.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.motionStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onMouseMove",
                            value: function onMouseMove(event) {
                                var clientX = event.clientX, clientY = event.clientY;
                                // reset input to center if hoverOnly is set and we're not hovering the element
                                if (this.hoverOnly && (clientX < this.elementPositionX || clientX > this.elementPositionX + this.elementWidth || clientY < this.elementPositionY || clientY > this.elementPositionY + this.elementHeight)) {
                                    this.inputX = 0;
                                    this.inputY = 0;
                                    return;
                                }
                                if (this.relativeInput) {
                                    // Clip mouse coordinates inside element bounds.
                                    if (this.clipRelativeInput) {
                                        clientX = Math.max(clientX, this.elementPositionX);
                                        clientX = Math.min(clientX, this.elementPositionX + this.elementWidth);
                                        clientY = Math.max(clientY, this.elementPositionY);
                                        clientY = Math.min(clientY, this.elementPositionY + this.elementHeight);
                                    }
                                    // Calculate input relative to the element.
                                    if (this.elementRangeX && this.elementRangeY) {
                                        this.inputX = (clientX - this.elementPositionX - this.elementCenterX) / this.elementRangeX;
                                        this.inputY = (clientY - this.elementPositionY - this.elementCenterY) / this.elementRangeY;
                                    }
                                } else // Calculate input relative to the window.
                                if (this.windowRadiusX && this.windowRadiusY) {
                                    this.inputX = (clientX - this.windowCenterX) / this.windowRadiusX;
                                    this.inputY = (clientY - this.windowCenterY) / this.windowRadiusY;
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.disable();
                                clearTimeout(this.calibrationTimer);
                                clearTimeout(this.detectionTimer);
                                this.element.removeAttribute("style");
                                for(var index = 0; index < this.layers.length; index++)this.layers[index].removeAttribute("style");
                                delete this.element;
                                delete this.layers;
                            }
                        },
                        {
                            key: "version",
                            value: function version() {
                                return "3.1.0";
                            }
                        }
                    ]);
                    return Parallax;
                }();
                module1.exports = Parallax;
            },
            {
                "object-assign": 1,
                "raf": 4
            }
        ]
    }, {}, [
        5
    ])(5);
});


(function() {
    "use strict";
    const directive = {
        name: "parallax"
    };
    app.directive(directive.name, controller);
    controller.$inject = [
        "$interval"
    ];
    function controller($interval) {
        function link(scope, element, attrs) {
            let i = 0;
            const interval = 50;
            const max = 2000 / interval;
            const watcher = $interval(()=>{
                const status = typeof (0, (/*@__PURE__*/$parcel$interopDefault($106258fa070913ba$exports))) !== "undefined";
                i++;
                const params = scope.$eval(attrs[directive.name]) || {};
                if (status) {
                    const parallaxInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($106258fa070913ba$exports)))(element[0], params);
                    $interval.cancel(watcher);
                }
                if (i >= max) clearInterval(watcher);
            }, interval);
        /*
            const parallaxInstance = new Parallax( element[0], {
                relativeInput: true
            } );
*/ }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $b16095068d0d61c2$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "passwordValidate"
    };
    controller.$inject = [
        "user"
    ];
    function controller(_user) {
        function link(scope, element, attrs, ctrl) {
            let login = "";
            let password = "";
            let watcher = function() {};
            const loginField = attrs[directive.name];
            if (loginField && loginField !== "password-validate") watcher = scope.$watch(loginField, (newVal)=>{
                login = newVal;
                scope.formData.password = password;
                ctrl.$setValidity("login", login ? password !== login : true);
            });
            else login = _user.profile.login;
            ctrl.$validators.login = (modelValue, viewValue)=>{
                password = modelValue || viewValue;
                return !login || password?.toLowerCase() !== login?.toLowerCase();
            };
            scope.$on("$destroy", watcher);
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel"
        };
    }
    app.directive(directive.name, controller);
})();


var $1c7d9c31d902ddb8$exports = {};
(function() {
    const passwordVerify = "passwordVerify";
    app.directive(passwordVerify, ()=>({
            require: "ngModel",
            link (scope, element, attrs, retypeControl) {
                const passwordNgModel = attrs[passwordVerify];
                // eslint-disable-next-line angular/no-private-call
                const passwordControl = retypeControl.$$parentForm.$$controls.find(// eslint-disable-next-line angular/no-private-call
                ({ $$attr: { ngModel: ngModel } })=>ngModel === passwordNgModel);
                if (!passwordControl) return;
                const setPasswordVerifyValidity = ()=>{
                    const passwordValue = passwordControl.$modelValue;
                    const retypeValue = retypeControl.$modelValue;
                    if (passwordValue && retypeValue && passwordValue !== retypeValue) return retypeControl.$setValidity(passwordVerify, false);
                    retypeControl.$setValidity(passwordVerify, true);
                };
                scope.$watch(passwordNgModel, setPasswordVerifyValidity);
                retypeControl.$viewChangeListeners.push(setPasswordVerifyValidity);
            }
        }));
})();


var $74518b9d13358209$exports = {};
const $f307333096501ec7$export$fe14ba9da00614a8 = "soundPlayer";
class $f307333096501ec7$var$Sound {
    soundsArray = [];
    muted = false;
    createTrack(track) {
        return new Audio(track);
    }
    playTrack(track) {
        if (!this.muted) {
            if (!this[track]) {
                this[track] = this.createTrack(track);
                this.soundsArray.push(this[track]);
            }
            this.stopTrack(this[track]);
            this[track].play();
        }
    }
    stopTrack(track) {
        track.pause();
        track.currentTime = 0;
    }
    stopAllTracks() {
        this.soundsArray.forEach((item, i)=>{
            this.stopTrack(item);
        });
    }
    toggleSoundMute() {
        this.muted = !this.muted;
        this.soundsArray.forEach((item, i)=>{
            item.muted = this.muted;
        });
    }
}
app.factory($f307333096501ec7$export$fe14ba9da00614a8, $f307333096501ec7$var$Sound);


(function() {
    "use strict";
    const directive = {
        name: "playTrackOnClick"
    };
    controller.$inject = [
        "soundPlayer"
    ];
    function controller(soundPlayer) {
        function link(scope, element, attrs) {
            const track = scope.$eval(attrs[directive.name]);
            element.on("click", function() {
                soundPlayer.playTrack(track.name);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $1a4b9b279edc392b$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "popup",
        "analytics",
        "analyticsEvents"
    ];
    function controller(_popup, _analytics, _analyticsEvents) {
        function link(scope, element, attrs) {
            element.on("click", function() {
                _analytics.send(_analyticsEvents.popupClose, _popup.current.replace(/(\/|\.html$)/g, ""), "Click_Button", {
                    nonInteraction: true
                });
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("popupClose", controller);
})();


var $a835cc78a32127f4$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "popup",
        "contentBuffer",
        "user"
    ];
    function controller(_popup, _contentBuffer, _user) {
        function link(scope, element, attrs) {
            element.on("click", function() {
                const popupValue = scope.$eval(attrs.popupOpen) || {
                    name: attrs.popupOpen
                };
                if (popupValue.private === true && !_user.status) {
                    _popup.open({
                        name: "login",
                        cb () {
                            _popup.open(popupValue);
                        }
                    });
                    return;
                }
                _popup.open(popupValue);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("popupOpen", controller);
})();


var $b710ba50696cd6e8$exports = {};







(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("promo$", controller);
})();



(function() {
    "use strict";
    const directive = {
        name: "promoButton"
    };
    controller.$inject = [
        "$translate",
        "$window",
        "user",
        "promo",
        "state",
        "config",
        "system$",
        "modal",
        "promo$"
    ];
    function controller($translate, $window, _user, _promo, _state, _config, _system$, _modal, _promo$) {
        const link = (scope, element, attrs)=>{
            $translate.onReady(()=>{
                let subscription = null;
                let { promo: promo, defaultKey: defaultKey, defaultAction: defaultAction } = scope.$eval(attrs[directive.name]);
                let requiredActionsData = transformArrayInHashTable(promo.requiredActions) || {};
                promo.hasOptIn = promo.requiredActions?.some((action)=>action.type === "OPT_IN");
                promo.isOptIn = promo.requiredActions?.some((action)=>action.type === "OPT_IN" && action.isActionDone);
                function setRequestOptions(isOptedIn) {
                    return {
                        targetId: promo.targetId,
                        isOptedIn: isOptedIn,
                        type: promo.subType,
                        language: _config.currentLang
                    };
                }
                function updatePromoData(data) {
                    requiredActionsData.OPT_IN.isActionDone = data.result.isOptedIn;
                    promo.isOptIn = data.result.isOptedIn;
                    scope.button = getButton();
                }
                const subscribeOnPromotion = function() {
                    scope.isPromoButtonDisabled = true;
                    const optInRequestOptions = setRequestOptions(true);
                    _promo.subscription(optInRequestOptions).then((data)=>{
                        updatePromoData(data);
                        _promo$.next(true);
                        scope.isPromoButtonDisabled = false;
                    });
                };
                scope.optOut = function() {
                    const optOutRequestOptions = setRequestOptions(false);
                    _modal.open("promotion-optout", promo).then(()=>{
                        _promo.subscription(optOutRequestOptions).then((data)=>{
                            updatePromoData(data);
                            _promo$.next(true);
                        });
                    }).catch((error)=>{
                        console.error(error);
                    });
                };
                function getButton() {
                    let buttonKey = defaultKey;
                    let buttonAction = null;
                    if (_user.status) {
                        // 1 step - isOptIn
                        if (requiredActionsData?.OPT_IN && !requiredActionsData?.OPT_IN.isActionDone) {
                            buttonKey = `promo.action.${requiredActionsData.OPT_IN.type}`;
                            buttonAction = subscribeOnPromotion;
                            return configureButton(buttonKey, buttonAction);
                        }
                        // 2 step - other actions in requiredActions[]
                        const requiredAction = promo.requiredActions?.find((item)=>item.type !== "OPT_IN" && !item.isActionDone);
                        if (requiredAction) {
                            buttonKey = `promo.action.${requiredAction.type}`;
                            buttonAction = function() {
                                _state.goto(requiredAction.type.toLowerCase());
                            };
                            return configureButton(buttonKey, buttonAction);
                        }
                        // todo change this code
                        // 2.5 step - hardcode for successful deposit
                        if (requiredActionsData?.DEPOSIT && requiredActionsData?.DEPOSIT.isActionDone) {
                            buttonKey = `promo.action.deposit`;
                            buttonAction = function() {
                                _state.goto("deposit");
                            };
                            return configureButton(buttonKey, buttonAction);
                        }
                        // 3 step - value from CMS
                        if (promo.private_button?.url) {
                            buttonKey = `promo.action.${promo.private_button.url}`;
                            buttonAction = function() {
                                _state.goto(promo.private_button.url);
                            };
                            return configureButton(buttonKey, buttonAction);
                        }
                        // 4 step - default value
                        buttonAction = function() {
                            _state.goto(defaultAction);
                        };
                        return configureButton(defaultKey, buttonAction);
                    }
                    if (requiredActionsData?.OPT_IN) buttonKey = `promo.action.${requiredActionsData.OPT_IN.type}`;
                    buttonAction = function() {
                        _state.goToAuthorization();
                    };
                    return configureButton(buttonKey, buttonAction);
                }
                scope.button = getButton();
                const isQueryParamExist = new URLSearchParams($window.location.search).get("opt-in");
                if (isQueryParamExist && !_user.status) _state.goto("login");
                function isOptInByExternalLink() {
                    return isQueryParamExist && _user.status && promo.subType && !promo.isOptIn;
                }
                scope.$watch("promo", (newValue)=>{
                    if (newValue) {
                        promo = newValue;
                        promo.hasOptIn = promo.requiredActions?.some((action)=>action.type === "OPT_IN");
                        promo.isOptIn = promo.requiredActions?.some((action)=>action.type === "OPT_IN" && action.isActionDone);
                        requiredActionsData = transformArrayInHashTable(promo.requiredActions);
                        if (isOptInByExternalLink()) {
                            subscribeOnPromotion();
                            return;
                        }
                        scope.button = getButton();
                    }
                });
                function configureButton(key, action) {
                    return {
                        text: $translate.instant(key),
                        action: action
                    };
                }
                function transformArrayInHashTable(array) {
                    return array?.reduce((acc, obj)=>{
                        acc[obj.type] = obj;
                        return acc;
                    }, {});
                }
                subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
                    scope.button = getButton();
                });
                scope.$on("$destroy", ()=>{
                    subscription.unsubscribe();
                });
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $f0a42041f1463b34$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "regilyAvatarToReward"
    };
    rewardMapperController.$inject = [
        "$scope",
        "system"
    ];
    function rewardMapperController($scope, systemAPI) {
        /** @type {Promise<Avatar[]>}*/ const avatars = systemAPI.avatars().then(({ result: result })=>result, ()=>[]);
        $scope.$watch("avatar", function(avatar) {
            if (!(avatar && avatar.id)) return;
            avatars.then((collection)=>{
                const order = collection.findIndex(({ id: id })=>id === avatar.id);
                $scope.rewardCreated({
                    selection: createReward(avatar, order, $scope.descriptionFromLevels)
                });
            });
        });
        /**
     * @param {Avatar} avatar
     * @param {number} order
     * @param {number[]} extractDescriptionFrom
     * @return {SelectedReward}
     * */ function createReward(avatar, order, extractDescriptionFrom) {
            let defaultRewardDescription = "";
            if (angular.isArray(extractDescriptionFrom)) defaultRewardDescription = extractDescriptionFrom.reduce((phrases, levelIndex)=>{
                return avatar.levels[levelIndex] ? [
                    ...phrases,
                    avatar.levels[levelIndex].description
                ] : phrases;
            }, []).join(" ");
            return {
                overviewBackground: order + 1,
                overviewRewardConfig: {
                    defaultRewardTitle: avatar.levels[3].description,
                    defaultRewardDescription: defaultRewardDescription
                }
            };
        }
    }
    app.directive(directive.name, function() {
        return {
            restrict: "A",
            controller: rewardMapperController,
            scope: {
                avatar: "=",
                descriptionFromLevels: "<",
                rewardCreated: "&"
            }
        };
    });
})();


var $ebf1e07e92c693c0$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "click");
    }
    app.factory("click$", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "click$"
    ];
    function controller(_click$) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs.removeClassOnClickoutside);
            _click$.subscribe(function(e) {
                angular.element(document.querySelectorAll(config.selector)).removeClass(config.class);
            });
            element.bind("click", (e)=>{
                e.stopPropagation();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("removeClassOnClickoutside", controller);
})();


var $07738c7478f945c1$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "removeClassOnEvent"
    };
    controller.$inject = [
        "event"
    ];
    function controller(_event) {
        function link(scope, element, attrs) {
            const { event: event, class: classNames, selector: selector } = scope.$eval(attrs[directive.name]);
            element.on(event || "click", ()=>{
                const targetElements = selector ? document.querySelectorAll(selector) : [
                    element[0]
                ];
                const classNamesAsArray = classNames?.trim().split(" ") || [];
                targetElements.forEach((targetElement)=>{
                    targetElement.classList.remove(...classNamesAsArray);
                });
            });
            _event.create(event, element[0]);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $063f389ce378a4b6$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "removeIfPwa"
    };
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            const pwaPopupClosed = $window.localStorage.getItem("pwaPopupClosed");
            const pwaApp = localStorage.getItem("pwa");
            $scope.close = ()=>{
                $element[0].nextElementSibling.remove();
                $window.localStorage.setItem("pwaPopupClosed", "true");
            };
            if (!pwaPopupClosed && !pwaApp) $transclude($scope, (clone)=>{
                $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
            });
        }
        return {
            restrict: "A",
            link: link,
            transclude: true
        };
    }
    app.directive(directive.name, controller);
})();


var $372ddc23dfe6ec29$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollElementToCenterOnStateChange"
    };
    controller.$inject = [
        "$window",
        "$timeout"
    ];
    function controller($window, $timeout) {
        const link = (scope, element, attrs)=>{
            const container = element[0];
            const config = scope.$eval(attrs[directive.name]) || {};
            const init = ()=>{
                $timeout(()=>{
                    const child = container.querySelector(config.element) || container.querySelector(config.stub);
                    if (!child) return;
                    if (child.scrollIntoView) {
                        const scrollIntoViewOptions = config.scrollIntoViewOptions || {
                            inline: "center",
                            block: "end"
                        };
                        child.scrollIntoView(scrollIntoViewOptions);
                    }
                    const position = child.offsetLeft - $window.innerWidth / 2 + child.offsetWidth / 2;
                    container.scrollLeft = position;
                }, 200);
            };
            scope.$on("$stateChangeSuccess", ()=>{
                init();
            });
            init();
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e1a19055f33721cc$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollLeftAfterRepeat"
    };
    controller.$inject = [];
    function controller($timeout) {
        function link(scope, element, attrs) {
            const c = scope.$eval(attrs[directive.name]);
            if (scope.$last) {
                const parent = element.parent()[0];
                $timeout(()=>{
                    parent.scrollLeft = parent.querySelector(c.selector).offsetLeft - c.offset;
                }, 0);
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3056ac1c94038955$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollToCurrentDate"
    };
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link(scope, element) {
            const scrollToCurrentDate = $timeout(()=>{
                element[0].querySelector(".today").scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
                clearTimeout(scrollToCurrentDate);
            }, 2000);
        }
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $71ce799c63e44667$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollToTopOnClick"
    };
    controller.$inject = [
        "$document"
    ];
    function controller($document) {
        function link(scope, element, attrs) {
            const params = scope.$eval(attrs[directive.name]);
            const selector = params.selector;
            const isAnimated = angular.isUndefined(params.isAnimated) ? true : params.isAnimated;
            element.on("click", ()=>{
                const targetAngularElement = selector ? angular.element($document[0].querySelector(selector)) : $document;
                if (isAnimated) targetAngularElement?.duScrollTopAnimated(0, 400);
                else targetAngularElement?.scrollTop(0);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $11fc5223f3036465$exports = {};
(function() {
    controller.$inject = [
        "$document"
    ];
    function controller($document) {
        function link() {
            $document.scrollTopAnimated(0, 400);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("scrollToTop", controller);
})();


var $35d6b1524785e60e$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "scrollWhenHold"
    };
    let $;
    controller.$inject = [
        "splash$",
        "$timeout",
        "$window"
    ];
    function controller(_splash$, $timeout, $window) {
        function link(scope, element, attrs) {
            // Params:
            // el - String, selector of scrollable element
            // direction - String, can be: top | right | bottom | left
            // speed - Integer, pixels per seconds, instead offset, default 800 px/s
            // easing - String, default 'linear', can be 'swing' or 'linear'
            const params = {};
            const options = {};
            function checkEndScroll() {
                const el = $(config.el)[0];
                let x = false;
                if (config.direction === "top") x = el.scrollTop === 0;
                if (config.direction === "right") x = Math.floor(el.scrollWidth - el.clientWidth - el.scrollLeft) === 0;
                if (config.direction === "bottom") x = Math.floor(el.scrollHeight - el.clientHeight - el.scrollTop) === 0;
                if (config.direction === "left") x = el.scrollLeft === 0;
                if (x) element.addClass("is-disable");
                else element.removeClass("is-disable");
            }
            const config = scope.$eval(attrs[directive.name]);
            $window.onload = ()=>{
                const observer = new MutationObserver(()=>{
                    checkEndScroll();
                });
                observer.observe(document.querySelector(config.el), {
                    childList: true
                });
            };
            Promise.resolve((parcelRequire("1E71g"))).then((jQuery)=>{
                $ = jQuery;
                if (config.direction && config.el) {
                    element.on("mousedown touchstart", (e)=>{
                        const el = $(config.el)[0];
                        const speed = config.speed || 800;
                        if (config.direction === "top") {
                            params.scrollTop = 0;
                            options.duration = el.scrollTop / speed;
                        }
                        if (config.direction === "right") {
                            params.scrollLeft = el.scrollWidth - el.clientWidth || 10000;
                            options.duration = (el.scrollWidth - el.scrollLeft - el.clientWidth) / speed;
                        }
                        if (config.direction === "bottom") {
                            params.scrollTop = el.scrollHeight - el.clientHeight || 10000;
                            options.duration = (el.scrollHeight - el.scrollTop - el.clientHeight) / speed;
                        }
                        if (config.direction === "left") {
                            params.scrollLeft = 0;
                            options.duration = el.scrollLeft / speed;
                        }
                        options.duration *= 1000;
                        options.easing = config.easing || "linear";
                        $(config.el).animate(params, options);
                    });
                    element.on("mouseup touchend", (e)=>{
                        $(config.el).stop(true);
                    });
                    $timeout(()=>{
                        checkEndScroll();
                        let debounceId = null;
                        $(config.el).scroll((e)=>{
                            clearTimeout(debounceId);
                            debounceId = $timeout(()=>{
                                checkEndScroll();
                            }, 200);
                        });
                    }, 0);
                    const subscription = _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded")).subscribe((i)=>{
                        checkEndScroll();
                    });
                    scope.$on("$destroy", ()=>{
                        subscription.unsubscribe();
                    });
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c0ade08cd0b7b788$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$compile"
    ];
    function controller($compile) {
        return {
            restrict: "E",
            link (scope, element, attrs, ctrl, transclude) {
                const expression = scope.$eval(attrs.expression);
                const template = Boolean(expression) ? attrs.template1 : attrs.template2;
                element.replaceWith($compile(template)(scope));
            }
        };
    }
    app.directive("selectTemplateGivenExpression", controller);
})();


var $dc14a7ad70ee7772$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$compile"
    ];
    function controller($compile) {
        function link(scope, element, attrs, ctrl, transclude) {
            const template = $compile(attrs.template1)(scope);
            element.replaceWith(template);
        }
        function compile(templateElement, templateAttrs) {}
        function template(elem, attr) {
            return $compile(attr.template1)({});
        }
        return {
            restrict: "E",
            link: link
        };
    }
    app.directive("selectTemplateGivenUserStatus", controller);
})();


var $37ad02763d62eb66$exports = {};

(function() {
    "use strict";
    app.factory("article", controller);
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        return {
            item (options) {
                const defer = $q.defer();
                const alias = "articleItem";
                const config = {
                    params: options,
                    cache: true,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
})();


(function() {
    "use strict";
    const directive = {
        name: "seoText"
    };
    controller.$inject = [
        "$location",
        "article"
    ];
    function controller($location, _article) {
        function compile() {
            return function($scope, $element, $attrs, $ctrl, $transclude) {
                let block;
                let listener = null;
                function clearName() {
                    return $location.path().substring(4).replace(/\//g, "__") || "home";
                }
                function checkIfNotEmpty(text) {
                    const value = text.replace(/(?:^(?:&nbsp;)+)|(?:(?:&nbsp;)+$)/g, "").trim();
                    if (value.length) return true;
                    return false;
                }
                function getArticle() {
                    if (block) {
                        block.remove();
                        block = null;
                    }
                    _article.item({
                        name: clearName()
                    }).then((a)=>{
                        if (a.result.text && checkIfNotEmpty(a.result.text)) $transclude($scope.$new(true), (clone, scope)=>{
                            block = clone[0];
                            scope.article = a.result;
                            $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
                        });
                    }).catch((e)=>{}).finally(()=>{
                        if (!listener) listener = $scope.$on("$locationChangeSuccess", ()=>{
                            getArticle();
                        });
                    });
                }
                getArticle();
            };
        }
        return {
            restrict: "A",
            transclude: "element",
            compile: compile
        };
    }
    app.directive(directive.name, controller);
})();


var $8e0730bdd5203a47$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "contentBuffer",
        "$timeout"
    ];
    function controller(_contentBuffer, $timeout) {
        function link(scope, element, attrs) {
            const variable = attrs.setPopupContentTo;
            _contentBuffer.write("popup", variable);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("setPopupContentTo", controller);
})();


var $ddea9459b213518b$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "showByCountryCode"
    };
    factory.$inject = [
        "system",
        "user",
        "system$"
    ];
    function factory(_system, _user, _system$) {
        function link(scope, element, attrs) {
            const listOfLanguages = scope.$eval(attrs[directive.name]);
            let userCountryCode = null;
            function addTargetNode(userCountryCode) {
                if (listOfLanguages.indexOf(userCountryCode) !== -1) {
                    element[0].style.display = "block";
                    return;
                }
                element[0].style.display = "none";
            }
            function showByCountryCode() {
                if (!_user.status) _system.info().then(({ result: result })=>{
                    userCountryCode = result.country.code.toLowerCase();
                    addTargetNode(userCountryCode);
                });
                if (_user.status) {
                    userCountryCode = _user.profile.country.toLowerCase();
                    addTargetNode(userCountryCode);
                }
            }
            showByCountryCode();
            _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "statusChanged")).subscribe(()=>{
                showByCountryCode();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $35bb9cfa18f2c9e2$exports = {};





(function() {
    "use strict";
    const directive = {
        name: "showElementIf"
    };
    controller.$inject = [
        "config",
        "user",
        "system$",
        "system"
    ];
    function controller(_config, _user, _system$, _system) {
        function link(scope, element, attrs) {
            const params = scope.$eval(attrs[directive.name]) || {};
            const langs = params.langs?.map((lang)=>lang.toLowerCase()) || [];
            const countries = params.countries?.map((country)=>country.toLowerCase()) || [];
            const { currentLang: currentLang } = _config;
            let subscription;
            const hideElement = ()=>element[0].style.display = "none";
            const showElement = ()=>element[0].style.display = "";
            if (langs.includes(currentLang)) {
                showElement();
                return;
            }
            hideElement();
            if (countries.length) {
                showByCountries();
                subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "statusChanged")).subscribe(()=>{
                    showByCountries();
                });
            }
            function showByCountries() {
                if (_user.status) {
                    const userCountryCode = _user.profile.country.toLowerCase();
                    countries.includes(userCountryCode) ? showElement() : hideElement();
                    return;
                }
                _system.info().then(({ result: result })=>{
                    const userCountryCode = result.country.code.toLowerCase();
                    countries.includes(userCountryCode) ? showElement() : hideElement();
                }).catch(()=>{});
            }
            scope.$on("$destroy", ()=>subscription?.unsubscribe());
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e86ee157d0a2a3b6$exports = {};

const $e86ee157d0a2a3b6$var$showElementOnSuccess = "showElementOnSuccess";
class $e86ee157d0a2a3b6$var$VisibleElementOnSuccess {
    static $inject = [
        "transcludeResolver"
    ];
    constructor(transcludeResolver){
        this.transcludeResolver = transcludeResolver;
    }
    link(scope, element, attrs, ctrl, transclude) {
        scope.successResponse = false;
        scope.preloader = true;
        const config = scope.$eval(attrs[$e86ee157d0a2a3b6$var$showElementOnSuccess]);
        this.transcludeResolver.get(config).then((answer)=>{
            transclude(scope, (clone)=>{
                element[0].parentNode.insertBefore(clone[0], element[0].nextSibling);
            });
            scope.successResponse = true;
        }).catch((error)=>{
            console.warn(error);
        }).finally(()=>{
            scope.preloader = false;
        });
    }
}
app.directive($e86ee157d0a2a3b6$var$showElementOnSuccess, ()=>{
    return {
        restrict: "A",
        controller: $e86ee157d0a2a3b6$var$VisibleElementOnSuccess,
        transclude: "element",
        link: function(scope, element, attrs, ctrl, transclude) {
            ctrl.link(scope, element, attrs, ctrl, transclude);
        }
    };
});


var $42f85131ca229a8c$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "showGameLinkByLocation"
    };
    controller.$inject = [
        "game"
    ];
    function controller(_game) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            const gameName = $attrs[directive.name] || "";
            _game.item({
                name: gameName
            }).then((gameItem)=>{
                if (gameItem.result) $transclude($scope, (clone)=>{
                    $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
                });
            }).catch((error)=>{}).finally(()=>{});
        }
        return {
            restrict: "A",
            link: link,
            transclude: "element"
        };
    }
    app.directive(directive.name, controller);
})();


var $e6cfa5488ca558b9$exports = {};
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $bdd8805cee4a5602$export$270182061f11fa81 {
    array = new Array();
    add(value) {
        let contains = this.contains(value);
        this.array[value | 0] = value | 0;
        return !contains;
    }
    contains(value) {
        return this.array[value | 0] != undefined;
    }
    remove(value) {
        this.array[value | 0] = undefined;
    }
    clear() {
        this.array.length = 0;
    }
}
class $bdd8805cee4a5602$export$1a41fd2ab8394c46 {
    entries = {};
    size = 0;
    add(value) {
        let contains = this.entries[value];
        this.entries[value] = true;
        if (!contains) {
            this.size++;
            return true;
        }
        return false;
    }
    addAll(values) {
        let oldSize = this.size;
        for(var i = 0, n = values.length; i < n; i++)this.add(values[i]);
        return oldSize != this.size;
    }
    contains(value) {
        return this.entries[value];
    }
    clear() {
        this.entries = {};
        this.size = 0;
    }
}
class $bdd8805cee4a5602$export$892596cec99bc70e {
    r;
    g;
    b;
    a;
    static WHITE = new $bdd8805cee4a5602$export$892596cec99bc70e(1, 1, 1, 1);
    static RED = new $bdd8805cee4a5602$export$892596cec99bc70e(1, 0, 0, 1);
    static GREEN = new $bdd8805cee4a5602$export$892596cec99bc70e(0, 1, 0, 1);
    static BLUE = new $bdd8805cee4a5602$export$892596cec99bc70e(0, 0, 1, 1);
    static MAGENTA = new $bdd8805cee4a5602$export$892596cec99bc70e(1, 0, 1, 1);
    constructor(r = 0, g = 0, b = 0, a = 0){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    set(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this.clamp();
    }
    setFromColor(c) {
        this.r = c.r;
        this.g = c.g;
        this.b = c.b;
        this.a = c.a;
        return this;
    }
    setFromString(hex) {
        hex = hex.charAt(0) == "#" ? hex.substr(1) : hex;
        this.r = parseInt(hex.substr(0, 2), 16) / 255;
        this.g = parseInt(hex.substr(2, 2), 16) / 255;
        this.b = parseInt(hex.substr(4, 2), 16) / 255;
        this.a = hex.length != 8 ? 1 : parseInt(hex.substr(6, 2), 16) / 255;
        return this;
    }
    add(r, g, b, a) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.a += a;
        return this.clamp();
    }
    clamp() {
        if (this.r < 0) this.r = 0;
        else if (this.r > 1) this.r = 1;
        if (this.g < 0) this.g = 0;
        else if (this.g > 1) this.g = 1;
        if (this.b < 0) this.b = 0;
        else if (this.b > 1) this.b = 1;
        if (this.a < 0) this.a = 0;
        else if (this.a > 1) this.a = 1;
        return this;
    }
    static rgba8888ToColor(color, value) {
        color.r = ((value & 0xff000000) >>> 24) / 255;
        color.g = ((value & 0x00ff0000) >>> 16) / 255;
        color.b = ((value & 0x0000ff00) >>> 8) / 255;
        color.a = (value & 0x000000ff) / 255;
    }
    static rgb888ToColor(color, value) {
        color.r = ((value & 0x00ff0000) >>> 16) / 255;
        color.g = ((value & 0x0000ff00) >>> 8) / 255;
        color.b = (value & 0x000000ff) / 255;
    }
    toRgb888() {
        const hex = (x)=>("0" + (x * 255).toString(16)).slice(-2);
        return Number("0x" + hex(this.r) + hex(this.g) + hex(this.b));
    }
    static fromString(hex) {
        return new $bdd8805cee4a5602$export$892596cec99bc70e().setFromString(hex);
    }
}
class $bdd8805cee4a5602$export$6a7ef315a0d1ef07 {
    static PI = 3.1415927;
    static PI2 = $bdd8805cee4a5602$export$6a7ef315a0d1ef07.PI * 2;
    static invPI2 = 1 / $bdd8805cee4a5602$export$6a7ef315a0d1ef07.PI2;
    static radiansToDegrees = 180 / $bdd8805cee4a5602$export$6a7ef315a0d1ef07.PI;
    static radDeg = $bdd8805cee4a5602$export$6a7ef315a0d1ef07.radiansToDegrees;
    static degreesToRadians = $bdd8805cee4a5602$export$6a7ef315a0d1ef07.PI / 180;
    static degRad = $bdd8805cee4a5602$export$6a7ef315a0d1ef07.degreesToRadians;
    static clamp(value, min, max) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
    }
    static cosDeg(degrees) {
        return Math.cos(degrees * $bdd8805cee4a5602$export$6a7ef315a0d1ef07.degRad);
    }
    static sinDeg(degrees) {
        return Math.sin(degrees * $bdd8805cee4a5602$export$6a7ef315a0d1ef07.degRad);
    }
    static atan2Deg(y, x) {
        return Math.atan2(y, x) * $bdd8805cee4a5602$export$6a7ef315a0d1ef07.degRad;
    }
    static signum(value) {
        return value > 0 ? 1 : value < 0 ? -1 : 0;
    }
    static toInt(x) {
        return x > 0 ? Math.floor(x) : Math.ceil(x);
    }
    static cbrt(x) {
        let y = Math.pow(Math.abs(x), 1 / 3);
        return x < 0 ? -y : y;
    }
    static randomTriangular(min, max) {
        return $bdd8805cee4a5602$export$6a7ef315a0d1ef07.randomTriangularWith(min, max, (min + max) * 0.5);
    }
    static randomTriangularWith(min, max, mode) {
        let u = Math.random();
        let d = max - min;
        if (u <= (mode - min) / d) return min + Math.sqrt(u * d * (mode - min));
        return max - Math.sqrt((1 - u) * d * (max - mode));
    }
    static isPowerOfTwo(value) {
        return value && (value & value - 1) === 0;
    }
}
class $bdd8805cee4a5602$export$b0cc4f9860136880 {
    apply(start, end, a) {
        return start + (end - start) * this.applyInternal(a);
    }
}
class $bdd8805cee4a5602$export$ce28d653ec559ee extends $bdd8805cee4a5602$export$b0cc4f9860136880 {
    power = 2;
    constructor(power){
        super();
        this.power = power;
    }
    applyInternal(a) {
        if (a <= 0.5) return Math.pow(a * 2, this.power) / 2;
        return Math.pow((a - 1) * 2, this.power) / (this.power % 2 == 0 ? -2 : 2) + 1;
    }
}
class $bdd8805cee4a5602$export$4834f341f53dca5c extends $bdd8805cee4a5602$export$ce28d653ec559ee {
    constructor(power){
        super(power);
    }
    applyInternal(a) {
        return Math.pow(a - 1, this.power) * (this.power % 2 == 0 ? -1 : 1) + 1;
    }
}
class $bdd8805cee4a5602$export$d2ca453b913dcdea {
    static SUPPORTS_TYPED_ARRAYS = typeof Float32Array !== "undefined";
    static arrayCopy(source, sourceStart, dest, destStart, numElements) {
        for(let i = sourceStart, j = destStart; i < sourceStart + numElements; i++, j++)dest[j] = source[i];
    }
    static arrayFill(array, fromIndex, toIndex, value) {
        for(let i = fromIndex; i < toIndex; i++)array[i] = value;
    }
    static setArraySize(array, size, value = 0) {
        let oldSize = array.length;
        if (oldSize == size) return array;
        array.length = size;
        if (oldSize < size) for(let i = oldSize; i < size; i++)array[i] = value;
        return array;
    }
    static ensureArrayCapacity(array, size, value = 0) {
        if (array.length >= size) return array;
        return $bdd8805cee4a5602$export$d2ca453b913dcdea.setArraySize(array, size, value);
    }
    static newArray(size, defaultValue) {
        let array = new Array(size);
        for(let i = 0; i < size; i++)array[i] = defaultValue;
        return array;
    }
    static newFloatArray(size) {
        if ($bdd8805cee4a5602$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS) return new Float32Array(size);
        else {
            let array = new Array(size);
            for(let i = 0; i < array.length; i++)array[i] = 0;
            return array;
        }
    }
    static newShortArray(size) {
        if ($bdd8805cee4a5602$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS) return new Int16Array(size);
        else {
            let array = new Array(size);
            for(let i = 0; i < array.length; i++)array[i] = 0;
            return array;
        }
    }
    static toFloatArray(array) {
        return $bdd8805cee4a5602$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS ? new Float32Array(array) : array;
    }
    static toSinglePrecision(value) {
        return $bdd8805cee4a5602$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS ? Math.fround(value) : value;
    }
    // This function is used to fix WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
    static webkit602BugfixHelper(alpha, blend) {}
    static contains(array, element, identity = true) {
        for(var i = 0; i < array.length; i++)if (array[i] == element) return true;
        return false;
    }
    static enumValue(type, name) {
        return type[name[0].toUpperCase() + name.slice(1)];
    }
}
class $bdd8805cee4a5602$export$d19db7c5e7bdee05 {
    static logBones(skeleton) {
        for(let i = 0; i < skeleton.bones.length; i++){
            let bone = skeleton.bones[i];
            console.log(bone.data.name + ", " + bone.a + ", " + bone.b + ", " + bone.c + ", " + bone.d + ", " + bone.worldX + ", " + bone.worldY);
        }
    }
}
class $bdd8805cee4a5602$export$14963ee5c8637e11 {
    items = new Array();
    instantiator;
    constructor(instantiator){
        this.instantiator = instantiator;
    }
    obtain() {
        return this.items.length > 0 ? this.items.pop() : this.instantiator();
    }
    free(item) {
        if (item.reset) item.reset();
        this.items.push(item);
    }
    freeAll(items) {
        for(let i = 0; i < items.length; i++)this.free(items[i]);
    }
    clear() {
        this.items.length = 0;
    }
}
class $bdd8805cee4a5602$export$c977b3e384af9ae1 {
    x;
    y;
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    length() {
        let x = this.x;
        let y = this.y;
        return Math.sqrt(x * x + y * y);
    }
    normalize() {
        let len = this.length();
        if (len != 0) {
            this.x /= len;
            this.y /= len;
        }
        return this;
    }
}
class $bdd8805cee4a5602$export$ab19517904b64359 {
    maxDelta = 0.064;
    framesPerSecond = 0;
    delta = 0;
    totalTime = 0;
    lastTime = Date.now() / 1000;
    frameCount = 0;
    frameTime = 0;
    update() {
        let now = Date.now() / 1000;
        this.delta = now - this.lastTime;
        this.frameTime += this.delta;
        this.totalTime += this.delta;
        if (this.delta > this.maxDelta) this.delta = this.maxDelta;
        this.lastTime = now;
        this.frameCount++;
        if (this.frameTime > 1) {
            this.framesPerSecond = this.frameCount / this.frameTime;
            this.frameTime = 0;
            this.frameCount = 0;
        }
    }
}
class $bdd8805cee4a5602$export$a88e0a4e9fe51345 {
    values;
    addedValues = 0;
    lastValue = 0;
    mean = 0;
    dirty = true;
    constructor(windowSize = 32){
        this.values = new Array(windowSize);
    }
    hasEnoughData() {
        return this.addedValues >= this.values.length;
    }
    addValue(value) {
        if (this.addedValues < this.values.length) this.addedValues++;
        this.values[this.lastValue++] = value;
        if (this.lastValue > this.values.length - 1) this.lastValue = 0;
        this.dirty = true;
    }
    getMean() {
        if (this.hasEnoughData()) {
            if (this.dirty) {
                let mean = 0;
                for(let i = 0; i < this.values.length; i++)mean += this.values[i];
                this.mean = mean / this.values.length;
                this.dirty = false;
            }
            return this.mean;
        }
        return 0;
    }
}


class $6828f80d5a50ba40$export$71e4db985cfcf9e3 {
    name;
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
}
class $6828f80d5a50ba40$export$66d3a0c3be55e044 extends $6828f80d5a50ba40$export$71e4db985cfcf9e3 {
    static nextID = 0;
    /** The unique ID for this attachment. */ id = $6828f80d5a50ba40$export$66d3a0c3be55e044.nextID++;
    /** The bones which affect the {@link #getVertices()}. The array entries are, for each vertex, the number of bones affecting
     * the vertex followed by that many bone indices, which is the index of the bone in {@link Skeleton#bones}. Will be null
     * if this attachment has no weights. */ bones = null;
    /** The vertex positions in the bone's coordinate system. For a non-weighted attachment, the values are `x,y`
     * entries for each vertex. For a weighted attachment, the values are `x,y,weight` entries for each bone affecting
     * each vertex. */ vertices = [];
    /** The maximum number of world vertex values that can be output by
     * {@link #computeWorldVertices()} using the `count` parameter. */ worldVerticesLength = 0;
    /** Timelines for the timeline attachment are also applied to this attachment.
     * May be null if no attachment-specific timelines should be applied. */ timelineAttachment = this;
    constructor(name){
        super(name);
    }
    /** Transforms the attachment's local {@link #vertices} to world coordinates. If the slot's {@link Slot#deform} is
     * not empty, it is used to deform the vertices.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide.
     * @param start The index of the first {@link #vertices} value to transform. Each vertex has 2 values, x and y.
     * @param count The number of world vertex values to output. Must be <= {@link #worldVerticesLength} - `start`.
     * @param worldVertices The output world vertices. Must have a length >= `offset` + `count` *
     *           `stride` / 2.
     * @param offset The `worldVertices` index to begin writing values.
     * @param stride The number of `worldVertices` entries between the value pairs written. */ computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        count = offset + (count >> 1) * stride;
        let skeleton = slot.bone.skeleton;
        let deformArray = slot.deform;
        let vertices = this.vertices;
        let bones = this.bones;
        if (!bones) {
            if (deformArray.length > 0) vertices = deformArray;
            let bone = slot.bone;
            let x = bone.worldX;
            let y = bone.worldY;
            let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
            for(let v = start, w = offset; w < count; v += 2, w += stride){
                let vx = vertices[v], vy = vertices[v + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0, skip = 0;
        for(let i = 0; i < start; i += 2){
            let n = bones[v];
            v += n + 1;
            skip += n;
        }
        let skeletonBones = skeleton.bones;
        if (deformArray.length == 0) for(let w = offset, b = skip * 3; w < count; w += stride){
            let wx = 0, wy = 0;
            let n = bones[v++];
            n += v;
            for(; v < n; v++, b += 3){
                let bone = skeletonBones[bones[v]];
                let vx = vertices[b], vy = vertices[b + 1], weight = vertices[b + 2];
                wx += (vx * bone.a + vy * bone.b + bone.worldX) * weight;
                wy += (vx * bone.c + vy * bone.d + bone.worldY) * weight;
            }
            worldVertices[w] = wx;
            worldVertices[w + 1] = wy;
        }
        else {
            let deform = deformArray;
            for(let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride){
                let wx = 0, wy = 0;
                let n = bones[v++];
                n += v;
                for(; v < n; v++, b += 3, f += 2){
                    let bone = skeletonBones[bones[v]];
                    let vx = vertices[b] + deform[f], vy = vertices[b + 1] + deform[f + 1], weight = vertices[b + 2];
                    wx += (vx * bone.a + vy * bone.b + bone.worldX) * weight;
                    wy += (vx * bone.c + vy * bone.d + bone.worldY) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
    /** Does not copy id (generated) or name (set on construction). **/ copyTo(attachment) {
        if (this.bones) {
            attachment.bones = new Array(this.bones.length);
            (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
        } else attachment.bones = null;
        if (this.vertices) {
            attachment.vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(this.vertices.length);
            (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
        }
        attachment.worldVerticesLength = this.worldVerticesLength;
        attachment.timelineAttachment = this.timelineAttachment;
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $50aa82091c41d06e$export$edde1bcb1b2b310e {
    static _nextID = 0;
    id = $50aa82091c41d06e$export$edde1bcb1b2b310e.nextID();
    regions;
    start = 0;
    digits = 0;
    /** The index of the region to show for the setup pose. */ setupIndex = 0;
    constructor(count){
        this.regions = new Array(count);
    }
    copy() {
        let copy = new $50aa82091c41d06e$export$edde1bcb1b2b310e(this.regions.length);
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.regions, 0, copy.regions, 0, this.regions.length);
        copy.start = this.start;
        copy.digits = this.digits;
        copy.setupIndex = this.setupIndex;
        return copy;
    }
    apply(slot, attachment) {
        let index = slot.sequenceIndex;
        if (index == -1) index = this.setupIndex;
        if (index >= this.regions.length) index = this.regions.length - 1;
        let region = this.regions[index];
        if (attachment.region != region) {
            attachment.region = region;
            attachment.updateRegion();
        }
    }
    getPath(basePath, index) {
        let result = basePath;
        let frame = (this.start + index).toString();
        for(let i = this.digits - frame.length; i > 0; i--)result += "0";
        result += frame;
        return result;
    }
    static nextID() {
        return $50aa82091c41d06e$export$edde1bcb1b2b310e._nextID++;
    }
}
var $50aa82091c41d06e$export$2d839466c6120eb9;
(function(SequenceMode) {
    SequenceMode[SequenceMode["hold"] = 0] = "hold";
    SequenceMode[SequenceMode["once"] = 1] = "once";
    SequenceMode[SequenceMode["loop"] = 2] = "loop";
    SequenceMode[SequenceMode["pingpong"] = 3] = "pingpong";
    SequenceMode[SequenceMode["onceReverse"] = 4] = "onceReverse";
    SequenceMode[SequenceMode["loopReverse"] = 5] = "loopReverse";
    SequenceMode[SequenceMode["pingpongReverse"] = 6] = "pingpongReverse";
})($50aa82091c41d06e$export$2d839466c6120eb9 || ($50aa82091c41d06e$export$2d839466c6120eb9 = {}));
const $50aa82091c41d06e$export$3d518da8d966a9f5 = [
    $50aa82091c41d06e$export$2d839466c6120eb9.hold,
    $50aa82091c41d06e$export$2d839466c6120eb9.once,
    $50aa82091c41d06e$export$2d839466c6120eb9.loop,
    $50aa82091c41d06e$export$2d839466c6120eb9.pingpong,
    $50aa82091c41d06e$export$2d839466c6120eb9.onceReverse,
    $50aa82091c41d06e$export$2d839466c6120eb9.loopReverse,
    $50aa82091c41d06e$export$2d839466c6120eb9.pingpongReverse
];


class $bbeb79d5adec7b97$export$c35d437ae5945fcd {
    /** The animation's name, which is unique across all animations in the skeleton. */ name;
    timelines = [];
    timelineIds = new (0, $bdd8805cee4a5602$export$1a41fd2ab8394c46)();
    /** The duration of the animation in seconds, which is the highest time of all keys in the timeline. */ duration;
    constructor(name, timelines, duration){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
        this.setTimelines(timelines);
        this.duration = duration;
    }
    setTimelines(timelines) {
        if (!timelines) throw new Error("timelines cannot be null.");
        this.timelines = timelines;
        this.timelineIds.clear();
        for(var i = 0; i < timelines.length; i++)this.timelineIds.addAll(timelines[i].getPropertyIds());
    }
    hasTimeline(ids) {
        for(let i = 0; i < ids.length; i++)if (this.timelineIds.contains(ids[i])) return true;
        return false;
    }
    /** Applies all the animation's timelines to the specified skeleton.
     *
     * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}.
     * @param loop If true, the animation repeats after {@link #getDuration()}.
     * @param events May be null to ignore fired events. */ apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (loop && this.duration != 0) {
            time %= this.duration;
            if (lastTime > 0) lastTime %= this.duration;
        }
        let timelines = this.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
}
var $bbeb79d5adec7b97$export$ccab779a50275a35;
(function(MixBlend) {
    /** Transitions from the setup value to the timeline value (the current value is not used). Before the first key, the setup
     * value is set. */ MixBlend[MixBlend["setup"] = 0] = "setup";
    /** Transitions from the current value to the timeline value. Before the first key, transitions from the current value to
     * the setup value. Timelines which perform instant transitions, such as {@link DrawOrderTimeline} or
     * {@link AttachmentTimeline}, use the setup value before the first key.
     *
     * `first` is intended for the first animations applied, not for animations layered on top of those. */ MixBlend[MixBlend["first"] = 1] = "first";
    /** Transitions from the current value to the timeline value. No change is made before the first key (the current value is
     * kept until the first key).
     *
     * `replace` is intended for animations layered on top of others, not for the first animations applied. */ MixBlend[MixBlend["replace"] = 2] = "replace";
    /** Transitions from the current value to the current value plus the timeline value. No change is made before the first key
     * (the current value is kept until the first key).
     *
     * `add` is intended for animations layered on top of others, not for the first animations applied. Properties
     * keyed by additive animations must be set manually or by another animation before applying the additive animations, else
     * the property values will increase continually. */ MixBlend[MixBlend["add"] = 3] = "add";
})($bbeb79d5adec7b97$export$ccab779a50275a35 || ($bbeb79d5adec7b97$export$ccab779a50275a35 = {}));
var $bbeb79d5adec7b97$export$52fc338c0bb328ba;
(function(MixDirection) {
    MixDirection[MixDirection["mixIn"] = 0] = "mixIn";
    MixDirection[MixDirection["mixOut"] = 1] = "mixOut";
})($bbeb79d5adec7b97$export$52fc338c0bb328ba || ($bbeb79d5adec7b97$export$52fc338c0bb328ba = {}));
const $bbeb79d5adec7b97$var$Property = {
    rotate: 0,
    x: 1,
    y: 2,
    scaleX: 3,
    scaleY: 4,
    shearX: 5,
    shearY: 6,
    inherit: 7,
    rgb: 8,
    alpha: 9,
    rgb2: 10,
    attachment: 11,
    deform: 12,
    event: 13,
    drawOrder: 14,
    ikConstraint: 15,
    transformConstraint: 16,
    pathConstraintPosition: 17,
    pathConstraintSpacing: 18,
    pathConstraintMix: 19,
    physicsConstraintInertia: 20,
    physicsConstraintStrength: 21,
    physicsConstraintDamping: 22,
    physicsConstraintMass: 23,
    physicsConstraintWind: 24,
    physicsConstraintGravity: 25,
    physicsConstraintMix: 26,
    physicsConstraintReset: 27,
    sequence: 28
};
class $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    propertyIds;
    frames;
    constructor(frameCount, propertyIds){
        this.propertyIds = propertyIds;
        this.frames = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(frameCount * this.getFrameEntries());
    }
    getPropertyIds() {
        return this.propertyIds;
    }
    getFrameEntries() {
        return 1;
    }
    getFrameCount() {
        return this.frames.length / this.getFrameEntries();
    }
    getDuration() {
        return this.frames[this.frames.length - this.getFrameEntries()];
    }
    static search1(frames, time) {
        let n = frames.length;
        for(let i = 1; i < n; i++)if (frames[i] > time) return i - 1;
        return n - 1;
    }
    static search(frames, time, step) {
        let n = frames.length;
        for(let i = step; i < n; i += step)if (frames[i] > time) return i - step;
        return n - step;
    }
}
class $bbeb79d5adec7b97$export$4094e7414845f78f extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    curves;
    constructor(frameCount, bezierCount, propertyIds){
        super(frameCount, propertyIds);
        this.curves = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(frameCount + bezierCount * 18 /*BEZIER_SIZE*/ );
        this.curves[frameCount - 1] = 1 /*STEPPED*/ ;
    }
    /** Sets the specified key frame to linear interpolation. */ setLinear(frame) {
        this.curves[frame] = 0 /*LINEAR*/ ;
    }
    /** Sets the specified key frame to stepped interpolation. */ setStepped(frame) {
        this.curves[frame] = 1 /*STEPPED*/ ;
    }
    /** Shrinks the storage for Bezier curves, for use when <code>bezierCount</code> (specified in the constructor) was larger
     * than the actual number of Bezier curves. */ shrink(bezierCount) {
        let size = this.getFrameCount() + bezierCount * 18 /*BEZIER_SIZE*/ ;
        if (this.curves.length > size) {
            let newCurves = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(size);
            (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.curves, 0, newCurves, 0, size);
            this.curves = newCurves;
        }
    }
    /** Stores the segments for the specified Bezier curve. For timelines that modify multiple values, there may be more than
     * one curve per frame.
     * @param bezier The ordinal of this Bezier curve for this timeline, between 0 and <code>bezierCount - 1</code> (specified
     *           in the constructor), inclusive.
     * @param frame Between 0 and <code>frameCount - 1</code>, inclusive.
     * @param value The index of the value for this frame that this curve is used for.
     * @param time1 The time for the first key.
     * @param value1 The value for the first key.
     * @param cx1 The time for the first Bezier handle.
     * @param cy1 The value for the first Bezier handle.
     * @param cx2 The time of the second Bezier handle.
     * @param cy2 The value for the second Bezier handle.
     * @param time2 The time for the second key.
     * @param value2 The value for the second key. */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        let curves = this.curves;
        let i = this.getFrameCount() + bezier * 18 /*BEZIER_SIZE*/ ;
        if (value == 0) curves[frame] = 2 /*BEZIER*/  + i;
        let tmpx = (time1 - cx1 * 2 + cx2) * 0.03, tmpy = (value1 - cy1 * 2 + cy2) * 0.03;
        let dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006, dddy = ((cy1 - cy2) * 3 - value1 + value2) * 0.006;
        let ddx = tmpx * 2 + dddx, ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667, dy = (cy1 - value1) * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx, y = value1 + dy;
        for(let n = i + 18 /*BEZIER_SIZE*/ ; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    /** Returns the Bezier interpolated value for the specified time.
     * @param frameIndex The index into {@link #getFrames()} for the values of the frame before <code>time</code>.
     * @param valueOffset The offset from <code>frameIndex</code> to the value this curve is used for.
     * @param i The index of the Bezier segments. See {@link #getCurveType(int)}. */ getBezierValue(time, frameIndex, valueOffset, i) {
        let curves = this.curves;
        if (curves[i] > time) {
            let x = this.frames[frameIndex], y = this.frames[frameIndex + valueOffset];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        let n = i + 18 /*BEZIER_SIZE*/ ;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            let x = curves[i - 2], y = curves[i - 1];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        frameIndex += this.getFrameEntries();
        let x = curves[n - 2], y = curves[n - 1];
        return y + (time - x) / (this.frames[frameIndex] - x) * (this.frames[frameIndex + valueOffset] - y);
    }
}
class $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, propertyId){
        super(frameCount, bezierCount, [
            propertyId
        ]);
    }
    getFrameEntries() {
        return 2 /*ENTRIES*/ ;
    }
    /** Sets the time and value for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, value) {
        frame <<= 1;
        this.frames[frame] = time;
        this.frames[frame + 1 /*VALUE*/ ] = value;
    }
    /** Returns the interpolated value for the specified time. */ getCurveValue(time) {
        let frames = this.frames;
        let i = frames.length - 2;
        for(let ii = 2; ii <= i; ii += 2)if (frames[ii] > time) {
            i = ii - 2;
            break;
        }
        let curveType = this.curves[i >> 1];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i], value = frames[i + 1 /*VALUE*/ ];
                return value + (time - before) / (frames[i + 2 /*ENTRIES*/ ] - before) * (frames[i + 2 /*ENTRIES*/  + 1 /*VALUE*/ ] - value);
            case 1 /*STEPPED*/ :
                return frames[i + 1 /*VALUE*/ ];
        }
        return this.getBezierValue(time, i, 1 /*VALUE*/ , curveType - 2 /*BEZIER*/ );
    }
    getRelativeValue(time, alpha, blend, current, setup) {
        if (time < this.frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    return setup;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        let value = this.getCurveValue(time);
        switch(blend){
            case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                return setup + value * alpha;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
            case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                value += setup - current;
        }
        return current + value * alpha;
    }
    getAbsoluteValue(time, alpha, blend, current, setup) {
        if (time < this.frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    return setup;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        let value = this.getCurveValue(time);
        if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) return setup + (value - setup) * alpha;
        return current + (value - current) * alpha;
    }
    getAbsoluteValue2(time, alpha, blend, current, setup, value) {
        if (time < this.frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    return setup;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) return setup + (value - setup) * alpha;
        return current + (value - current) * alpha;
    }
    getScaleValue(time, alpha, blend, direction, current, setup) {
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    return setup;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    return current + (setup - current) * alpha;
            }
            return current;
        }
        let value = this.getCurveValue(time) * setup;
        if (alpha == 1) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.add) return current + value - setup;
            return value;
        }
        // Mixing out uses sign of setup or current pose, else use sign of key.
        if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) switch(blend){
            case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                return setup + (Math.abs(value) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(setup) - setup) * alpha;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
            case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                return current + (Math.abs(value) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(current) - current) * alpha;
        }
        else {
            let s = 0;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    s = Math.abs(setup) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(value);
                    return s + (value - s) * alpha;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                    s = Math.abs(current) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(value);
                    return s + (value - s) * alpha;
            }
        }
        return current + (value - setup) * alpha;
    }
}
class $bbeb79d5adec7b97$export$d380b930c0f765ae extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    /** @param bezierCount The maximum number of Bezier curves. See {@link #shrink(int)}.
     * @param propertyIds Unique identifiers for the properties the timeline modifies. */ constructor(frameCount, bezierCount, propertyId1, propertyId2){
        super(frameCount, bezierCount, [
            propertyId1,
            propertyId2
        ]);
    }
    getFrameEntries() {
        return 3 /*ENTRIES*/ ;
    }
    /** Sets the time and values for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, value1, value2) {
        frame *= 3 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*VALUE1*/ ] = value1;
        this.frames[frame + 2 /*VALUE2*/ ] = value2;
    }
}
class $bbeb79d5adec7b97$export$b7ecb8f68b3e130b extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.rotate + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.rotation = this.getRelativeValue(time, alpha, blend, bone.rotation, bone.data.rotation);
    }
}
class $bbeb79d5adec7b97$export$eb93bf27829ae703 extends $bbeb79d5adec7b97$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.x + "|" + boneIndex, $bbeb79d5adec7b97$var$Property.y + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    bone.x = bone.data.x;
                    bone.y = bone.data.y;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    bone.x += (bone.data.x - bone.x) * alpha;
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let x = 0, y = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        switch(blend){
            case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                bone.x = bone.data.x + x * alpha;
                bone.y = bone.data.y + y * alpha;
                break;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
            case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.add:
                bone.x += x * alpha;
                bone.y += y * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$cf49491eb4394eca extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.x + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.x = this.getRelativeValue(time, alpha, blend, bone.x, bone.data.x);
    }
}
class $bbeb79d5adec7b97$export$6540b7ba297d3e41 extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.y + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.y = this.getRelativeValue(time, alpha, blend, bone.y, bone.data.y);
    }
}
class $bbeb79d5adec7b97$export$be544e22f6ad7737 extends $bbeb79d5adec7b97$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.scaleX + "|" + boneIndex, $bbeb79d5adec7b97$var$Property.scaleY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    bone.scaleX = bone.data.scaleX;
                    bone.scaleY = bone.data.scaleY;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let x, y;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        x *= bone.data.scaleX;
        y *= bone.data.scaleY;
        if (alpha == 1) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.add) {
                bone.scaleX += x - bone.data.scaleX;
                bone.scaleY += y - bone.data.scaleY;
            } else {
                bone.scaleX = x;
                bone.scaleY = y;
            }
        } else {
            let bx = 0, by = 0;
            if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    bx = bone.data.scaleX;
                    by = bone.data.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.data.scaleY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                    bx = Math.abs(bone.scaleX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.scaleY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
        }
    }
}
class $bbeb79d5adec7b97$export$407a9cf4df59ebda extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.scaleX + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.scaleX = this.getScaleValue(time, alpha, blend, direction, bone.scaleX, bone.data.scaleX);
    }
}
class $bbeb79d5adec7b97$export$cc13ceba88ef3794 extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.scaleY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.scaleY = this.getScaleValue(time, alpha, blend, direction, bone.scaleY, bone.data.scaleY);
    }
}
class $bbeb79d5adec7b97$export$4da82436a1a0d773 extends $bbeb79d5adec7b97$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.shearX + "|" + boneIndex, $bbeb79d5adec7b97$var$Property.shearY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    bone.shearX = bone.data.shearX;
                    bone.shearY = bone.data.shearY;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let x = 0, y = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        switch(blend){
            case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                bone.shearX = bone.data.shearX + x * alpha;
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
            case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.add:
                bone.shearX += x * alpha;
                bone.shearY += y * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$2392b1c4c21acaf8 extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.shearX + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.shearX = this.getRelativeValue(time, alpha, blend, bone.shearX, bone.data.shearX);
    }
}
class $bbeb79d5adec7b97$export$f65148e1d95352fd extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.shearY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (bone.active) bone.shearY = this.getRelativeValue(time, alpha, blend, bone.shearY, bone.data.shearY);
    }
}
class $bbeb79d5adec7b97$export$7582beb1c1258b21 extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    boneIndex = 0;
    constructor(frameCount, boneIndex){
        super(frameCount, [
            $bbeb79d5adec7b97$var$Property.inherit + "|" + boneIndex
        ]);
        this.boneIndex = boneIndex;
    }
    getFrameEntries() {
        return 2 /*ENTRIES*/ ;
    }
    /** Sets the transform mode for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, inherit) {
        frame *= 2 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*INHERIT*/ ] = inherit;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) bone.inherit = bone.data.inherit;
            return;
        }
        let frames = this.frames;
        if (time < frames[0]) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup || blend == $bbeb79d5adec7b97$export$ccab779a50275a35.first) bone.inherit = bone.data.inherit;
            return;
        }
        bone.inherit = this.frames[$bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 2 /*ENTRIES*/ ) + 1 /*INHERIT*/ ];
    }
}
class $bbeb79d5adec7b97$export$84cf3a3e225bcbdc extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.rgb + "|" + slotIndex,
            $bbeb79d5adec7b97$var$Property.alpha + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 5 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b, a) {
        frame *= 5 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*A*/ ] = a;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let color = slot.color;
        if (time < frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    color.setFromColor(setup);
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 5 /*ENTRIES*/ );
        let curveType = this.curves[i / 5 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                let t = (time - before) / (frames[i + 5 /*ENTRIES*/ ] - before);
                r += (frames[i + 5 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 5 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 5 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                a += (frames[i + 5 /*ENTRIES*/  + 4 /*A*/ ] - a) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                a = this.getBezierValue(time, i, 4 /*A*/ , curveType + 54 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) color.set(r, g, b, a);
        else {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) color.setFromColor(slot.data.color);
            color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
        }
    }
}
class $bbeb79d5adec7b97$export$e179fb669ddccfa9 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.rgb + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 4 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b) {
        frame <<= 2;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let color = slot.color;
        if (time < frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    color.r = setup.r;
                    color.g = setup.g;
                    color.b = setup.b;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    color.r += (setup.r - color.r) * alpha;
                    color.g += (setup.g - color.g) * alpha;
                    color.b += (setup.b - color.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 4 /*ENTRIES*/ );
        let curveType = this.curves[i >> 2];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                let t = (time - before) / (frames[i + 4 /*ENTRIES*/ ] - before);
                r += (frames[i + 4 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 4 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 4 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            color.r = r;
            color.g = g;
            color.b = b;
        } else {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) {
                let setup = slot.data.color;
                color.r = setup.r;
                color.g = setup.g;
                color.b = setup.b;
            }
            color.r += (r - color.r) * alpha;
            color.g += (g - color.g) * alpha;
            color.b += (b - color.b) * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$2211be7c5ccde97b extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.alpha + "|" + slotIndex);
        this.slotIndex = slotIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let color = slot.color;
        if (time < this.frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    color.a = setup.a;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    color.a += (setup.a - color.a) * alpha;
            }
            return;
        }
        let a = this.getCurveValue(time);
        if (alpha == 1) color.a = a;
        else {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) color.a = slot.data.color.a;
            color.a += (a - color.a) * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$6fc6620d97c53689 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.rgb + "|" + slotIndex,
            $bbeb79d5adec7b97$var$Property.alpha + "|" + slotIndex,
            $bbeb79d5adec7b97$var$Property.rgb2 + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 8 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, a, r2, g2, b2) {
        frame <<= 3;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*A*/ ] = a;
        this.frames[frame + 5 /*R2*/ ] = r2;
        this.frames[frame + 6 /*G2*/ ] = g2;
        this.frames[frame + 7 /*B2*/ ] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let light = slot.color, dark = slot.darkColor;
        if (time < frames[0]) {
            let setupLight = slot.data.color, setupDark = slot.data.darkColor;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    light.setFromColor(setupLight);
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 8 /*ENTRIES*/ );
        let curveType = this.curves[i >> 3];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                r2 = frames[i + 5 /*R2*/ ];
                g2 = frames[i + 6 /*G2*/ ];
                b2 = frames[i + 7 /*B2*/ ];
                let t = (time - before) / (frames[i + 8 /*ENTRIES*/ ] - before);
                r += (frames[i + 8 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 8 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 8 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                a += (frames[i + 8 /*ENTRIES*/  + 4 /*A*/ ] - a) * t;
                r2 += (frames[i + 8 /*ENTRIES*/  + 5 /*R2*/ ] - r2) * t;
                g2 += (frames[i + 8 /*ENTRIES*/  + 6 /*G2*/ ] - g2) * t;
                b2 += (frames[i + 8 /*ENTRIES*/  + 7 /*B2*/ ] - b2) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                r2 = frames[i + 5 /*R2*/ ];
                g2 = frames[i + 6 /*G2*/ ];
                b2 = frames[i + 7 /*B2*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                a = this.getBezierValue(time, i, 4 /*A*/ , curveType + 54 - 2 /*BEZIER*/ );
                r2 = this.getBezierValue(time, i, 5 /*R2*/ , curveType + 72 - 2 /*BEZIER*/ );
                g2 = this.getBezierValue(time, i, 6 /*G2*/ , curveType + 90 - 2 /*BEZIER*/ );
                b2 = this.getBezierValue(time, i, 7 /*B2*/ , curveType + 108 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            light.set(r, g, b, a);
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) {
                light.setFromColor(slot.data.color);
                let setupDark = slot.data.darkColor;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$a12960afd309a230 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.rgb + "|" + slotIndex,
            $bbeb79d5adec7b97$var$Property.rgb2 + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 7 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, r2, g2, b2) {
        frame *= 7 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*R2*/ ] = r2;
        this.frames[frame + 5 /*G2*/ ] = g2;
        this.frames[frame + 6 /*B2*/ ] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let light = slot.color, dark = slot.darkColor;
        if (time < frames[0]) {
            let setupLight = slot.data.color, setupDark = slot.data.darkColor;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    light.r = setupLight.r;
                    light.g = setupLight.g;
                    light.b = setupLight.b;
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    light.r += (setupLight.r - light.r) * alpha;
                    light.g += (setupLight.g - light.g) * alpha;
                    light.b += (setupLight.b - light.b) * alpha;
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 7 /*ENTRIES*/ );
        let curveType = this.curves[i / 7 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                r2 = frames[i + 4 /*R2*/ ];
                g2 = frames[i + 5 /*G2*/ ];
                b2 = frames[i + 6 /*B2*/ ];
                let t = (time - before) / (frames[i + 7 /*ENTRIES*/ ] - before);
                r += (frames[i + 7 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 7 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 7 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                r2 += (frames[i + 7 /*ENTRIES*/  + 4 /*R2*/ ] - r2) * t;
                g2 += (frames[i + 7 /*ENTRIES*/  + 5 /*G2*/ ] - g2) * t;
                b2 += (frames[i + 7 /*ENTRIES*/  + 6 /*B2*/ ] - b2) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                r2 = frames[i + 4 /*R2*/ ];
                g2 = frames[i + 5 /*G2*/ ];
                b2 = frames[i + 6 /*B2*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                r2 = this.getBezierValue(time, i, 4 /*R2*/ , curveType + 54 - 2 /*BEZIER*/ );
                g2 = this.getBezierValue(time, i, 5 /*G2*/ , curveType + 72 - 2 /*BEZIER*/ );
                b2 = this.getBezierValue(time, i, 6 /*B2*/ , curveType + 90 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            light.r = r;
            light.g = g;
            light.b = b;
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) {
                let setupLight = slot.data.color, setupDark = slot.data.darkColor;
                light.r = setupLight.r;
                light.g = setupLight.g;
                light.b = setupLight.b;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.r += (r - light.r) * alpha;
            light.g += (g - light.g) * alpha;
            light.b += (b - light.b) * alpha;
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    slotIndex = 0;
    /** The attachment name for each key frame. May contain null values to clear the attachment. */ attachmentNames;
    constructor(frameCount, slotIndex){
        super(frameCount, [
            $bbeb79d5adec7b97$var$Property.attachment + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
        this.attachmentNames = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the attachment name for the specified key frame. */ setFrame(frame, time, attachmentName) {
        this.frames[frame] = time;
        this.attachmentNames[frame] = attachmentName;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup || blend == $bbeb79d5adec7b97$export$ccab779a50275a35.first) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        this.setAttachment(skeleton, slot, this.attachmentNames[$bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search1(this.frames, time)]);
    }
    setAttachment(skeleton, slot, attachmentName) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
}
class $bbeb79d5adec7b97$export$6968d40e5689ad6b extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    slotIndex = 0;
    /** The attachment that will be deformed. */ attachment;
    /** The vertices for each key frame. */ vertices;
    constructor(frameCount, bezierCount, slotIndex, attachment){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.deform + "|" + slotIndex + "|" + attachment.id
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
        this.vertices = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the vertices for the specified key frame.
     * @param vertices Vertex positions for an unweighted VertexAttachment, or deform offsets if it has weights. */ setFrame(frame, time, vertices) {
        this.frames[frame] = time;
        this.vertices[frame] = vertices;
    }
    /** @param value1 Ignored (0 is used for a deform timeline).
     * @param value2 Ignored (1 is used for a deform timeline). */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        let curves = this.curves;
        let i = this.getFrameCount() + bezier * 18 /*BEZIER_SIZE*/ ;
        if (value == 0) curves[frame] = 2 /*BEZIER*/  + i;
        let tmpx = (time1 - cx1 * 2 + cx2) * 0.03, tmpy = cy2 * 0.03 - cy1 * 0.06;
        let dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006, dddy = (cy1 - cy2 + 0.33333333) * 0.018;
        let ddx = tmpx * 2 + dddx, ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667, dy = cy1 * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx, y = dy;
        for(let n = i + 18 /*BEZIER_SIZE*/ ; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    getCurvePercent(time, frame) {
        let curves = this.curves;
        let i = curves[frame];
        switch(i){
            case 0 /*LINEAR*/ :
                let x = this.frames[frame];
                return (time - x) / (this.frames[frame + this.getFrameEntries()] - x);
            case 1 /*STEPPED*/ :
                return 0;
        }
        i -= 2 /*BEZIER*/ ;
        if (curves[i] > time) {
            let x = this.frames[frame];
            return curves[i + 1] * (time - x) / (curves[i] - x);
        }
        let n = i + 18 /*BEZIER_SIZE*/ ;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            let x = curves[i - 2], y = curves[i - 1];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        let x1 = curves[n - 2], y = curves[n - 1];
        return y + (1 - y) * (time - x1) / (this.frames[frame + this.getFrameEntries()] - x1);
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let slotAttachment = slot.getAttachment();
        if (!slotAttachment) return;
        if (!(slotAttachment instanceof (0, $6828f80d5a50ba40$export$66d3a0c3be55e044)) || slotAttachment.timelineAttachment != this.attachment) return;
        let deform = slot.deform;
        if (deform.length == 0) blend = $bbeb79d5adec7b97$export$ccab779a50275a35.setup;
        let vertices = this.vertices;
        let vertexCount = vertices[0].length;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    deform.length = 0;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    if (alpha == 1) {
                        deform.length = 0;
                        return;
                    }
                    deform.length = vertexCount;
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions.
                        let setupVertices = vertexAttachment.vertices;
                        for(var i = 0; i < vertexCount; i++)deform[i] += (setupVertices[i] - deform[i]) * alpha;
                    } else {
                        // Weighted deform offsets.
                        alpha = 1 - alpha;
                        for(var i = 0; i < vertexCount; i++)deform[i] *= alpha;
                    }
            }
            return;
        }
        deform.length = vertexCount;
        if (time >= frames[frames.length - 1]) {
            let lastVertices = vertices[frames.length - 1];
            if (alpha == 1) {
                if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.add) {
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] - setupVertices[i];
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i];
                } else (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(lastVertices, 0, deform, 0, vertexCount);
            } else switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    {
                        let vertexAttachment = slotAttachment;
                        if (!vertexAttachment.bones) {
                            // Unweighted vertex positions, with alpha.
                            let setupVertices = vertexAttachment.vertices;
                            for(let i = 0; i < vertexCount; i++){
                                let setup = setupVertices[i];
                                deform[i] = setup + (lastVertices[i] - setup) * alpha;
                            }
                        } else // Weighted deform offsets, with alpha.
                        for(let i = 0; i < vertexCount; i++)deform[i] = lastVertices[i] * alpha;
                        break;
                    }
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                    for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - deform[i]) * alpha;
                    break;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.add:
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - setupVertices[i]) * alpha;
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] * alpha;
            }
            return;
        }
        // Interpolate between the previous frame and the current frame.
        let frame = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search1(frames, time);
        let percent = this.getCurvePercent(time, frame);
        let prevVertices = vertices[frame];
        let nextVertices = vertices[frame + 1];
        if (alpha == 1) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.add) {
                let vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    // Unweighted vertex positions, with alpha.
                    let setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] += prev + (nextVertices[i] - prev) * percent - setupVertices[i];
                    }
                } else // Weighted deform offsets, with alpha.
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += prev + (nextVertices[i] - prev) * percent;
                }
            } else for(let i = 0; i < vertexCount; i++){
                let prev = prevVertices[i];
                deform[i] = prev + (nextVertices[i] - prev) * percent;
            }
        } else switch(blend){
            case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                {
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++){
                            let prev = prevVertices[i], setup = setupVertices[i];
                            deform[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
                        }
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
                    }
                    break;
                }
            case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
            case $bbeb79d5adec7b97$export$ccab779a50275a35.replace:
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent - deform[i]) * alpha;
                }
                break;
            case $bbeb79d5adec7b97$export$ccab779a50275a35.add:
                let vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    // Unweighted vertex positions, with alpha.
                    let setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] += (prev + (nextVertices[i] - prev) * percent - setupVertices[i]) * alpha;
                    }
                } else // Weighted deform offsets, with alpha.
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent) * alpha;
                }
        }
    }
}
class $bbeb79d5adec7b97$export$4f4bca996c586084 extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        "" + $bbeb79d5adec7b97$var$Property.event
    ];
    /** The event for each key frame. */ events;
    constructor(frameCount){
        super(frameCount, $bbeb79d5adec7b97$export$4f4bca996c586084.propertyIds);
        this.events = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the event for the specified key frame. */ setFrame(frame, event) {
        this.frames[frame] = event.time;
        this.events[frame] = event;
    }
    /** Fires events for frames > `lastTime` and <= `time`. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (!firedEvents) return;
        let frames = this.frames;
        let frameCount = this.frames.length;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frameCount - 1]) return;
        if (time < frames[0]) return;
        let i = 0;
        if (lastTime < frames[0]) i = 0;
        else {
            i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search1(frames, lastTime) + 1;
            let frameTime = frames[i];
            while(i > 0){
                if (frames[i - 1] != frameTime) break;
                i--;
            }
        }
        for(; i < frameCount && time >= frames[i]; i++)firedEvents.push(this.events[i]);
    }
}
class $bbeb79d5adec7b97$export$ece1f7c41d051e83 extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        "" + $bbeb79d5adec7b97$var$Property.drawOrder
    ];
    /** The draw order for each key frame. See {@link #setFrame(int, float, int[])}. */ drawOrders;
    constructor(frameCount){
        super(frameCount, $bbeb79d5adec7b97$export$ece1f7c41d051e83.propertyIds);
        this.drawOrders = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the draw order for the specified key frame.
     * @param drawOrder For each slot in {@link Skeleton#slots}, the index of the new draw order. May be null to use setup pose
     *           draw order. */ setFrame(frame, time, drawOrder) {
        this.frames[frame] = time;
        this.drawOrders[frame] = drawOrder;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup || blend == $bbeb79d5adec7b97$export$ccab779a50275a35.first) (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        let idx = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search1(this.frames, time);
        let drawOrderToSetupIndex = this.drawOrders[idx];
        if (!drawOrderToSetupIndex) (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
        else {
            let drawOrder = skeleton.drawOrder;
            let slots = skeleton.slots;
            for(let i = 0, n = drawOrderToSetupIndex.length; i < n; i++)drawOrder[i] = slots[drawOrderToSetupIndex[i]];
        }
    }
}
class $bbeb79d5adec7b97$export$73d125cd89dead44 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    /** The index of the IK constraint in {@link Skeleton#getIkConstraints()} that will be changed when this timeline is applied */ constraintIndex = 0;
    constructor(frameCount, bezierCount, ikConstraintIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.ikConstraint + "|" + ikConstraintIndex
        ]);
        this.constraintIndex = ikConstraintIndex;
    }
    getFrameEntries() {
        return 6 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, mix, softness, bend direction, compress, and stretch for the specified key frame. */ setFrame(frame, time, mix, softness, bendDirection, compress, stretch) {
        frame *= 6 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*MIX*/ ] = mix;
        this.frames[frame + 2 /*SOFTNESS*/ ] = softness;
        this.frames[frame + 3 /*BEND_DIRECTION*/ ] = bendDirection;
        this.frames[frame + 4 /*COMPRESS*/ ] = compress ? 1 : 0;
        this.frames[frame + 5 /*STRETCH*/ ] = stretch ? 1 : 0;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.ikConstraints[this.constraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    constraint.mix = constraint.data.mix;
                    constraint.softness = constraint.data.softness;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                    constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
            }
            return;
        }
        let mix = 0, softness = 0;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 6 /*ENTRIES*/ );
        let curveType = this.curves[i / 6 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                mix = frames[i + 1 /*MIX*/ ];
                softness = frames[i + 2 /*SOFTNESS*/ ];
                let t = (time - before) / (frames[i + 6 /*ENTRIES*/ ] - before);
                mix += (frames[i + 6 /*ENTRIES*/  + 1 /*MIX*/ ] - mix) * t;
                softness += (frames[i + 6 /*ENTRIES*/  + 2 /*SOFTNESS*/ ] - softness) * t;
                break;
            case 1 /*STEPPED*/ :
                mix = frames[i + 1 /*MIX*/ ];
                softness = frames[i + 2 /*SOFTNESS*/ ];
                break;
            default:
                mix = this.getBezierValue(time, i, 1 /*MIX*/ , curveType - 2 /*BEZIER*/ );
                softness = this.getBezierValue(time, i, 2 /*SOFTNESS*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) {
            constraint.mix = constraint.data.mix + (mix - constraint.data.mix) * alpha;
            constraint.softness = constraint.data.softness + (softness - constraint.data.softness) * alpha;
            if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) {
                constraint.bendDirection = constraint.data.bendDirection;
                constraint.compress = constraint.data.compress;
                constraint.stretch = constraint.data.stretch;
            } else {
                constraint.bendDirection = frames[i + 3 /*BEND_DIRECTION*/ ];
                constraint.compress = frames[i + 4 /*COMPRESS*/ ] != 0;
                constraint.stretch = frames[i + 5 /*STRETCH*/ ] != 0;
            }
        } else {
            constraint.mix += (mix - constraint.mix) * alpha;
            constraint.softness += (softness - constraint.softness) * alpha;
            if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixIn) {
                constraint.bendDirection = frames[i + 3 /*BEND_DIRECTION*/ ];
                constraint.compress = frames[i + 4 /*COMPRESS*/ ] != 0;
                constraint.stretch = frames[i + 5 /*STRETCH*/ ] != 0;
            }
        }
    }
}
class $bbeb79d5adec7b97$export$a7a393c2ad815ac7 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    /** The index of the transform constraint slot in {@link Skeleton#transformConstraints} that will be changed. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, transformConstraintIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.transformConstraint + "|" + transformConstraintIndex
        ]);
        this.constraintIndex = transformConstraintIndex;
    }
    getFrameEntries() {
        return 7 /*ENTRIES*/ ;
    }
    /** The time in seconds, rotate mix, translate mix, scale mix, and shear mix for the specified key frame. */ setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY) {
        let frames = this.frames;
        frame *= 7 /*ENTRIES*/ ;
        frames[frame] = time;
        frames[frame + 1 /*ROTATE*/ ] = mixRotate;
        frames[frame + 2 /*X*/ ] = mixX;
        frames[frame + 3 /*Y*/ ] = mixY;
        frames[frame + 4 /*SCALEX*/ ] = mixScaleX;
        frames[frame + 5 /*SCALEY*/ ] = mixScaleY;
        frames[frame + 6 /*SHEARY*/ ] = mixShearY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.transformConstraints[this.constraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            let data = constraint.data;
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    constraint.mixRotate = data.mixRotate;
                    constraint.mixX = data.mixX;
                    constraint.mixY = data.mixY;
                    constraint.mixScaleX = data.mixScaleX;
                    constraint.mixScaleY = data.mixScaleY;
                    constraint.mixShearY = data.mixShearY;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    constraint.mixRotate += (data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (data.mixY - constraint.mixY) * alpha;
                    constraint.mixScaleX += (data.mixScaleX - constraint.mixScaleX) * alpha;
                    constraint.mixScaleY += (data.mixScaleY - constraint.mixScaleY) * alpha;
                    constraint.mixShearY += (data.mixShearY - constraint.mixShearY) * alpha;
            }
            return;
        }
        let rotate, x, y, scaleX, scaleY, shearY;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 7 /*ENTRIES*/ );
        let curveType = this.curves[i / 7 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                scaleX = frames[i + 4 /*SCALEX*/ ];
                scaleY = frames[i + 5 /*SCALEY*/ ];
                shearY = frames[i + 6 /*SHEARY*/ ];
                let t = (time - before) / (frames[i + 7 /*ENTRIES*/ ] - before);
                rotate += (frames[i + 7 /*ENTRIES*/  + 1 /*ROTATE*/ ] - rotate) * t;
                x += (frames[i + 7 /*ENTRIES*/  + 2 /*X*/ ] - x) * t;
                y += (frames[i + 7 /*ENTRIES*/  + 3 /*Y*/ ] - y) * t;
                scaleX += (frames[i + 7 /*ENTRIES*/  + 4 /*SCALEX*/ ] - scaleX) * t;
                scaleY += (frames[i + 7 /*ENTRIES*/  + 5 /*SCALEY*/ ] - scaleY) * t;
                shearY += (frames[i + 7 /*ENTRIES*/  + 6 /*SHEARY*/ ] - shearY) * t;
                break;
            case 1 /*STEPPED*/ :
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                scaleX = frames[i + 4 /*SCALEX*/ ];
                scaleY = frames[i + 5 /*SCALEY*/ ];
                shearY = frames[i + 6 /*SHEARY*/ ];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1 /*ROTATE*/ , curveType - 2 /*BEZIER*/ );
                x = this.getBezierValue(time, i, 2 /*X*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 3 /*Y*/ , curveType + 36 - 2 /*BEZIER*/ );
                scaleX = this.getBezierValue(time, i, 4 /*SCALEX*/ , curveType + 54 - 2 /*BEZIER*/ );
                scaleY = this.getBezierValue(time, i, 5 /*SCALEY*/ , curveType + 72 - 2 /*BEZIER*/ );
                shearY = this.getBezierValue(time, i, 6 /*SHEARY*/ , curveType + 90 - 2 /*BEZIER*/ );
        }
        if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) {
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
            constraint.mixScaleX = data.mixScaleX + (scaleX - data.mixScaleX) * alpha;
            constraint.mixScaleY = data.mixScaleY + (scaleY - data.mixScaleY) * alpha;
            constraint.mixShearY = data.mixShearY + (shearY - data.mixShearY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
            constraint.mixScaleX += (scaleX - constraint.mixScaleX) * alpha;
            constraint.mixScaleY += (scaleY - constraint.mixScaleY) * alpha;
            constraint.mixShearY += (shearY - constraint.mixShearY) * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$7ce7e67fd9cc52ed extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    /** The index of the path constraint in {@link Skeleton#getPathConstraints()} that will be changed when this timeline is
     * applied. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.pathConstraintPosition + "|" + pathConstraintIndex);
        this.constraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.constraintIndex];
        if (constraint.active) constraint.position = this.getAbsoluteValue(time, alpha, blend, constraint.position, constraint.data.position);
    }
}
class $bbeb79d5adec7b97$export$17ee50c08a07e62b extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    /** The index of the path constraint in {@link Skeleton#getPathConstraints()} that will be changed when this timeline is
     * applied. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, $bbeb79d5adec7b97$var$Property.pathConstraintSpacing + "|" + pathConstraintIndex);
        this.constraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.constraintIndex];
        if (constraint.active) constraint.spacing = this.getAbsoluteValue(time, alpha, blend, constraint.spacing, constraint.data.spacing);
    }
}
class $bbeb79d5adec7b97$export$ea67b41755485038 extends $bbeb79d5adec7b97$export$4094e7414845f78f {
    /** The index of the path constraint in {@link Skeleton#getPathConstraints()} that will be changed when this timeline is
     * applied. */ constraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, [
            $bbeb79d5adec7b97$var$Property.pathConstraintMix + "|" + pathConstraintIndex
        ]);
        this.constraintIndex = pathConstraintIndex;
    }
    getFrameEntries() {
        return 4 /*ENTRIES*/ ;
    }
    setFrame(frame, time, mixRotate, mixX, mixY) {
        let frames = this.frames;
        frame <<= 2;
        frames[frame] = time;
        frames[frame + 1 /*ROTATE*/ ] = mixRotate;
        frames[frame + 2 /*X*/ ] = mixX;
        frames[frame + 3 /*Y*/ ] = mixY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.constraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $bbeb79d5adec7b97$export$ccab779a50275a35.setup:
                    constraint.mixRotate = constraint.data.mixRotate;
                    constraint.mixX = constraint.data.mixX;
                    constraint.mixY = constraint.data.mixY;
                    return;
                case $bbeb79d5adec7b97$export$ccab779a50275a35.first:
                    constraint.mixRotate += (constraint.data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (constraint.data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (constraint.data.mixY - constraint.mixY) * alpha;
            }
            return;
        }
        let rotate, x, y;
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, 4 /*ENTRIES*/ );
        let curveType = this.curves[i >> 2];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                let t = (time - before) / (frames[i + 4 /*ENTRIES*/ ] - before);
                rotate += (frames[i + 4 /*ENTRIES*/  + 1 /*ROTATE*/ ] - rotate) * t;
                x += (frames[i + 4 /*ENTRIES*/  + 2 /*X*/ ] - x) * t;
                y += (frames[i + 4 /*ENTRIES*/  + 3 /*Y*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1 /*ROTATE*/ , curveType - 2 /*BEZIER*/ );
                x = this.getBezierValue(time, i, 2 /*X*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 3 /*Y*/ , curveType + 36 - 2 /*BEZIER*/ );
        }
        if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) {
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
        }
    }
}
class $bbeb79d5adec7b97$export$292849cf7640fcfe extends $bbeb79d5adec7b97$export$ea4b0b6c1bc191c5 {
    /** The index of the physics constraint in {@link Skeleton#getPhysicsConstraints()} that will be changed when this timeline
     * is applied, or -1 if all physics constraints in the skeleton will be changed. */ constraintIndex = 0;
    /** @param physicsConstraintIndex -1 for all physics constraints in the skeleton. */ constructor(frameCount, bezierCount, physicsConstraintIndex, property){
        super(frameCount, bezierCount, property + "|" + physicsConstraintIndex);
        this.constraintIndex = physicsConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint;
        if (this.constraintIndex == -1) {
            const value = time >= this.frames[0] ? this.getCurveValue(time) : 0;
            for (const constraint of skeleton.physicsConstraints)if (constraint.active && this.global(constraint.data)) this.set(constraint, this.getAbsoluteValue2(time, alpha, blend, this.get(constraint), this.setup(constraint), value));
        } else {
            constraint = skeleton.physicsConstraints[this.constraintIndex];
            if (constraint.active) this.set(constraint, this.getAbsoluteValue(time, alpha, blend, this.get(constraint), this.setup(constraint)));
        }
    }
}
class $bbeb79d5adec7b97$export$8d7d2ed36692a76a extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintInertia);
    }
    setup(constraint) {
        return constraint.data.inertia;
    }
    get(constraint) {
        return constraint.inertia;
    }
    set(constraint, value) {
        constraint.inertia = value;
    }
    global(constraint) {
        return constraint.inertiaGlobal;
    }
}
class $bbeb79d5adec7b97$export$92ee7da35e84339e extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintStrength);
    }
    setup(constraint) {
        return constraint.data.strength;
    }
    get(constraint) {
        return constraint.strength;
    }
    set(constraint, value) {
        constraint.strength = value;
    }
    global(constraint) {
        return constraint.strengthGlobal;
    }
}
class $bbeb79d5adec7b97$export$cd77a164f9089126 extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintDamping);
    }
    setup(constraint) {
        return constraint.data.damping;
    }
    get(constraint) {
        return constraint.damping;
    }
    set(constraint, value) {
        constraint.damping = value;
    }
    global(constraint) {
        return constraint.dampingGlobal;
    }
}
class $bbeb79d5adec7b97$export$cc37bc88e0605a66 extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintMass);
    }
    setup(constraint) {
        return 1 / constraint.data.massInverse;
    }
    get(constraint) {
        return 1 / constraint.massInverse;
    }
    set(constraint, value) {
        constraint.massInverse = 1 / value;
    }
    global(constraint) {
        return constraint.massGlobal;
    }
}
class $bbeb79d5adec7b97$export$3e123ca078024d61 extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintWind);
    }
    setup(constraint) {
        return constraint.data.wind;
    }
    get(constraint) {
        return constraint.wind;
    }
    set(constraint, value) {
        constraint.wind = value;
    }
    global(constraint) {
        return constraint.windGlobal;
    }
}
class $bbeb79d5adec7b97$export$f321d2d075d42a88 extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintGravity);
    }
    setup(constraint) {
        return constraint.data.gravity;
    }
    get(constraint) {
        return constraint.gravity;
    }
    set(constraint, value) {
        constraint.gravity = value;
    }
    global(constraint) {
        return constraint.gravityGlobal;
    }
}
class $bbeb79d5adec7b97$export$e3ce1f2c0b6ae580 extends $bbeb79d5adec7b97$export$292849cf7640fcfe {
    constructor(frameCount, bezierCount, physicsConstraintIndex){
        super(frameCount, bezierCount, physicsConstraintIndex, $bbeb79d5adec7b97$var$Property.physicsConstraintMix);
    }
    setup(constraint) {
        return constraint.data.mix;
    }
    get(constraint) {
        return constraint.mix;
    }
    set(constraint, value) {
        constraint.mix = value;
    }
    global(constraint) {
        return constraint.mixGlobal;
    }
}
class $bbeb79d5adec7b97$export$956f20308bfd17e0 extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        $bbeb79d5adec7b97$var$Property.physicsConstraintReset.toString()
    ];
    /** The index of the physics constraint in {@link Skeleton#getPhysicsConstraints()} that will be reset when this timeline is
    * applied, or -1 if all physics constraints in the skeleton will be reset. */ constraintIndex;
    /** @param physicsConstraintIndex -1 for all physics constraints in the skeleton. */ constructor(frameCount, physicsConstraintIndex){
        super(frameCount, $bbeb79d5adec7b97$export$956f20308bfd17e0.propertyIds);
        this.constraintIndex = physicsConstraintIndex;
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive. */ setFrame(frame, time) {
        this.frames[frame] = time;
    }
    /** Resets the physics constraint when frames > <code>lastTime</code> and <= <code>time</code>. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint;
        if (this.constraintIndex != -1) {
            constraint = skeleton.physicsConstraints[this.constraintIndex];
            if (!constraint.active) return;
        }
        const frames = this.frames;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, [], alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frames.length - 1]) return;
        if (time < frames[0]) return;
        if (lastTime < frames[0] || time >= frames[$bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search1(frames, lastTime) + 1]) {
            if (constraint != null) constraint.reset();
            else {
                for (const constraint of skeleton.physicsConstraints)if (constraint.active) constraint.reset();
            }
        }
    }
}
class $bbeb79d5adec7b97$export$2687f324e8496672 extends $bbeb79d5adec7b97$export$e6a97ba2cae5bb94 {
    static ENTRIES = 3;
    static MODE = 1;
    static DELAY = 2;
    slotIndex;
    attachment;
    constructor(frameCount, slotIndex, attachment){
        super(frameCount, [
            $bbeb79d5adec7b97$var$Property.sequence + "|" + slotIndex + "|" + attachment.sequence.id
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
    }
    getFrameEntries() {
        return $bbeb79d5adec7b97$export$2687f324e8496672.ENTRIES;
    }
    getSlotIndex() {
        return this.slotIndex;
    }
    getAttachment() {
        return this.attachment;
    }
    /** Sets the time, mode, index, and frame time for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time Seconds between frames. */ setFrame(frame, time, mode, index, delay) {
        let frames = this.frames;
        frame *= $bbeb79d5adec7b97$export$2687f324e8496672.ENTRIES;
        frames[frame] = time;
        frames[frame + $bbeb79d5adec7b97$export$2687f324e8496672.MODE] = mode | index << 4;
        frames[frame + $bbeb79d5adec7b97$export$2687f324e8496672.DELAY] = delay;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let slotAttachment = slot.attachment;
        let attachment = this.attachment;
        if (slotAttachment != attachment) {
            if (!(slotAttachment instanceof (0, $6828f80d5a50ba40$export$66d3a0c3be55e044)) || slotAttachment.timelineAttachment != attachment) return;
        }
        if (direction == $bbeb79d5adec7b97$export$52fc338c0bb328ba.mixOut) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup) slot.sequenceIndex = -1;
            return;
        }
        let frames = this.frames;
        if (time < frames[0]) {
            if (blend == $bbeb79d5adec7b97$export$ccab779a50275a35.setup || blend == $bbeb79d5adec7b97$export$ccab779a50275a35.first) slot.sequenceIndex = -1;
            return;
        }
        let i = $bbeb79d5adec7b97$export$e6a97ba2cae5bb94.search(frames, time, $bbeb79d5adec7b97$export$2687f324e8496672.ENTRIES);
        let before = frames[i];
        let modeAndIndex = frames[i + $bbeb79d5adec7b97$export$2687f324e8496672.MODE];
        let delay = frames[i + $bbeb79d5adec7b97$export$2687f324e8496672.DELAY];
        if (!this.attachment.sequence) return;
        let index = modeAndIndex >> 4, count = this.attachment.sequence.regions.length;
        let mode = (0, $50aa82091c41d06e$export$3d518da8d966a9f5)[modeAndIndex & 0xf];
        if (mode != (0, $50aa82091c41d06e$export$2d839466c6120eb9).hold) {
            index += (time - before) / delay + 0.00001 | 0;
            switch(mode){
                case (0, $50aa82091c41d06e$export$2d839466c6120eb9).once:
                    index = Math.min(count - 1, index);
                    break;
                case (0, $50aa82091c41d06e$export$2d839466c6120eb9).loop:
                    index %= count;
                    break;
                case (0, $50aa82091c41d06e$export$2d839466c6120eb9).pingpong:
                    {
                        let n = (count << 1) - 2;
                        index = n == 0 ? 0 : index % n;
                        if (index >= count) index = n - index;
                        break;
                    }
                case (0, $50aa82091c41d06e$export$2d839466c6120eb9).onceReverse:
                    index = Math.max(count - 1 - index, 0);
                    break;
                case (0, $50aa82091c41d06e$export$2d839466c6120eb9).loopReverse:
                    index = count - 1 - index % count;
                    break;
                case (0, $50aa82091c41d06e$export$2d839466c6120eb9).pingpongReverse:
                    {
                        let n = (count << 1) - 2;
                        index = n == 0 ? 0 : (index + count - 1) % n;
                        if (index >= count) index = n - index;
                    }
            }
        }
        slot.sequenceIndex = index;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $dcb477122a241e28$export$d0f7a26c90cc1562 {
    static _emptyAnimation = new (0, $bbeb79d5adec7b97$export$c35d437ae5945fcd)("<empty>", [], 0);
    static emptyAnimation() {
        return $dcb477122a241e28$export$d0f7a26c90cc1562._emptyAnimation;
    }
    /** The AnimationStateData to look up mix durations. */ data;
    /** The list of tracks that currently have animations, which may contain null entries. */ tracks = new Array();
    /** Multiplier for the delta time when the animation state is updated, causing time for all animations and mixes to play slower
     * or faster. Defaults to 1.
     *
     * See TrackEntry {@link TrackEntry#timeScale} for affecting a single animation. */ timeScale = 1;
    unkeyedState = 0;
    events = new Array();
    listeners = new Array();
    queue = new $dcb477122a241e28$export$2fc6338444a158e6(this);
    propertyIDs = new (0, $bdd8805cee4a5602$export$1a41fd2ab8394c46)();
    animationsChanged = false;
    trackEntryPool = new (0, $bdd8805cee4a5602$export$14963ee5c8637e11)(()=>new $dcb477122a241e28$export$6fd48f25bc0ee658());
    constructor(data){
        this.data = data;
    }
    /** Increments each track entry {@link TrackEntry#trackTime()}, setting queued animations as current if needed. */ update(delta) {
        delta *= this.timeScale;
        let tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let current = tracks[i];
            if (!current) continue;
            current.animationLast = current.nextAnimationLast;
            current.trackLast = current.nextTrackLast;
            let currentDelta = delta * current.timeScale;
            if (current.delay > 0) {
                current.delay -= currentDelta;
                if (current.delay > 0) continue;
                currentDelta = -current.delay;
                current.delay = 0;
            }
            let next = current.next;
            if (next) {
                // When the next entry's delay is passed, change to the next entry, preserving leftover time.
                let nextTime = current.trackLast - next.delay;
                if (nextTime >= 0) {
                    next.delay = 0;
                    next.trackTime += current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                    current.trackTime += currentDelta;
                    this.setCurrent(i, next, true);
                    while(next.mixingFrom){
                        next.mixTime += delta;
                        next = next.mixingFrom;
                    }
                    continue;
                }
            } else if (current.trackLast >= current.trackEnd && !current.mixingFrom) {
                tracks[i] = null;
                this.queue.end(current);
                this.clearNext(current);
                continue;
            }
            if (current.mixingFrom && this.updateMixingFrom(current, delta)) {
                // End mixing from entries once all have completed.
                let from = current.mixingFrom;
                current.mixingFrom = null;
                if (from) from.mixingTo = null;
                while(from){
                    this.queue.end(from);
                    from = from.mixingFrom;
                }
            }
            current.trackTime += currentDelta;
        }
        this.queue.drain();
    }
    /** Returns true when all mixing from entries are complete. */ updateMixingFrom(to, delta) {
        let from = to.mixingFrom;
        if (!from) return true;
        let finished = this.updateMixingFrom(from, delta);
        from.animationLast = from.nextAnimationLast;
        from.trackLast = from.nextTrackLast;
        // Require mixTime > 0 to ensure the mixing from entry was applied at least once.
        if (to.mixTime > 0 && to.mixTime >= to.mixDuration) {
            // Require totalAlpha == 0 to ensure mixing is complete, unless mixDuration == 0 (the transition is a single frame).
            if (from.totalAlpha == 0 || to.mixDuration == 0) {
                to.mixingFrom = from.mixingFrom;
                if (from.mixingFrom) from.mixingFrom.mixingTo = to;
                to.interruptAlpha = from.interruptAlpha;
                this.queue.end(from);
            }
            return finished;
        }
        from.trackTime += delta * from.timeScale;
        to.mixTime += delta;
        return false;
    }
    /** Poses the skeleton using the track entry animations. There are no side effects other than invoking listeners, so the
     * animation state can be applied to multiple skeletons to pose them identically.
     * @returns True if any animations were applied. */ apply(skeleton) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (this.animationsChanged) this._animationsChanged();
        let events = this.events;
        let tracks = this.tracks;
        let applied = false;
        for(let i = 0, n = tracks.length; i < n; i++){
            let current = tracks[i];
            if (!current || current.delay > 0) continue;
            applied = true;
            let blend = i == 0 ? (0, $bbeb79d5adec7b97$export$ccab779a50275a35).first : current.mixBlend;
            // Apply mixing from entries first.
            let alpha = current.alpha;
            if (current.mixingFrom) alpha *= this.applyMixingFrom(current, skeleton, blend);
            else if (current.trackTime >= current.trackEnd && !current.next) alpha = 0;
            let attachments = alpha >= current.alphaAttachmentThreshold;
            // Apply current entry.
            let animationLast = current.animationLast, animationTime = current.getAnimationTime(), applyTime = animationTime;
            let applyEvents = events;
            if (current.reverse) {
                applyTime = current.animation.duration - applyTime;
                applyEvents = null;
            }
            let timelines = current.animation.timelines;
            let timelineCount = timelines.length;
            if (i == 0 && alpha == 1 || blend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).add) {
                if (i == 0) attachments = true;
                for(let ii = 0; ii < timelineCount; ii++){
                    // Fixes issue #302 on IOS9 where mix, blend sometimes became undefined and caused assets
                    // to sometimes stop rendering when using color correction, as their RGBA values become NaN.
                    // (https://github.com/pixijs/pixi-spine/issues/302)
                    (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                    var timeline = timelines[ii];
                    if (timeline instanceof (0, $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, attachments);
                    else timeline.apply(skeleton, animationLast, applyTime, applyEvents, alpha, blend, (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixIn);
                }
            } else {
                let timelineMode = current.timelineMode;
                let shortestRotation = current.shortestRotation;
                let firstFrame = !shortestRotation && current.timelinesRotation.length != timelineCount << 1;
                if (firstFrame) current.timelinesRotation.length = timelineCount << 1;
                for(let ii = 0; ii < timelineCount; ii++){
                    let timeline = timelines[ii];
                    let timelineBlend = timelineMode[ii] == $dcb477122a241e28$export$89027c4cc247cc19 ? blend : (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup;
                    if (!shortestRotation && timeline instanceof (0, $bbeb79d5adec7b97$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, current.timelinesRotation, ii << 1, firstFrame);
                    else if (timeline instanceof (0, $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, attachments);
                    else {
                        // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
                        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                        timeline.apply(skeleton, animationLast, applyTime, applyEvents, alpha, timelineBlend, (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixIn);
                    }
                }
            }
            this.queueEvents(current, animationTime);
            events.length = 0;
            current.nextAnimationLast = animationTime;
            current.nextTrackLast = current.trackTime;
        }
        // Set slots attachments to the setup pose, if needed. This occurs if an animation that is mixing out sets attachments so
        // subsequent timelines see any deform, but the subsequent timelines don't set an attachment (eg they are also mixing out or
        // the time is before the first key).
        var setupState = this.unkeyedState + $dcb477122a241e28$export$be88f4235204622a;
        var slots = skeleton.slots;
        for(var i = 0, n = skeleton.slots.length; i < n; i++){
            var slot = slots[i];
            if (slot.attachmentState == setupState) {
                var attachmentName = slot.data.attachmentName;
                slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
            }
        }
        this.unkeyedState += 2; // Increasing after each use avoids the need to reset attachmentState for every slot.
        this.queue.drain();
        return applied;
    }
    applyMixingFrom(to, skeleton, blend) {
        let from = to.mixingFrom;
        if (from.mixingFrom) this.applyMixingFrom(from, skeleton, blend);
        let mix = 0;
        if (to.mixDuration == 0) {
            mix = 1;
            if (blend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).first) blend = (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup;
        } else {
            mix = to.mixTime / to.mixDuration;
            if (mix > 1) mix = 1;
            if (blend != (0, $bbeb79d5adec7b97$export$ccab779a50275a35).first) blend = from.mixBlend;
        }
        let attachments = mix < from.mixAttachmentThreshold, drawOrder = mix < from.mixDrawOrderThreshold;
        let timelines = from.animation.timelines;
        let timelineCount = timelines.length;
        let alphaHold = from.alpha * to.interruptAlpha, alphaMix = alphaHold * (1 - mix);
        let animationLast = from.animationLast, animationTime = from.getAnimationTime(), applyTime = animationTime;
        let events = null;
        if (from.reverse) applyTime = from.animation.duration - applyTime;
        else if (mix < from.eventThreshold) events = this.events;
        if (blend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).add) for(let i = 0; i < timelineCount; i++)timelines[i].apply(skeleton, animationLast, applyTime, events, alphaMix, blend, (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixOut);
        else {
            let timelineMode = from.timelineMode;
            let timelineHoldMix = from.timelineHoldMix;
            let shortestRotation = from.shortestRotation;
            let firstFrame = !shortestRotation && from.timelinesRotation.length != timelineCount << 1;
            if (firstFrame) from.timelinesRotation.length = timelineCount << 1;
            from.totalAlpha = 0;
            for(let i = 0; i < timelineCount; i++){
                let timeline = timelines[i];
                let direction = (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixOut;
                let timelineBlend;
                let alpha = 0;
                switch(timelineMode[i]){
                    case $dcb477122a241e28$export$89027c4cc247cc19:
                        if (!drawOrder && timeline instanceof (0, $bbeb79d5adec7b97$export$ece1f7c41d051e83)) continue;
                        timelineBlend = blend;
                        alpha = alphaMix;
                        break;
                    case $dcb477122a241e28$export$9f55c59c79ce7630:
                        timelineBlend = (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup;
                        alpha = alphaMix;
                        break;
                    case $dcb477122a241e28$export$61db7ea55ff2bc4f:
                        timelineBlend = blend;
                        alpha = alphaHold;
                        break;
                    case $dcb477122a241e28$export$83263fba6795a4f7:
                        timelineBlend = (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup;
                        alpha = alphaHold;
                        break;
                    default:
                        timelineBlend = (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup;
                        let holdMix = timelineHoldMix[i];
                        alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                        break;
                }
                from.totalAlpha += alpha;
                if (!shortestRotation && timeline instanceof (0, $bbeb79d5adec7b97$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, from.timelinesRotation, i << 1, firstFrame);
                else if (timeline instanceof (0, $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, timelineBlend, attachments && alpha >= from.alphaAttachmentThreshold);
                else {
                    // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
                    (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                    if (drawOrder && timeline instanceof (0, $bbeb79d5adec7b97$export$ece1f7c41d051e83) && timelineBlend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup) direction = (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixIn;
                    timeline.apply(skeleton, animationLast, applyTime, events, alpha, timelineBlend, direction);
                }
            }
        }
        if (to.mixDuration > 0) this.queueEvents(from, animationTime);
        this.events.length = 0;
        from.nextAnimationLast = animationTime;
        from.nextTrackLast = from.trackTime;
        return mix;
    }
    applyAttachmentTimeline(timeline, skeleton, time, blend, attachments) {
        var slot = skeleton.slots[timeline.slotIndex];
        if (!slot.bone.active) return;
        if (time < timeline.frames[0]) {
            if (blend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup || blend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).first) this.setAttachment(skeleton, slot, slot.data.attachmentName, attachments);
        } else this.setAttachment(skeleton, slot, timeline.attachmentNames[(0, $bbeb79d5adec7b97$export$e6a97ba2cae5bb94).search1(timeline.frames, time)], attachments);
        // If an attachment wasn't set (ie before the first frame or attachments is false), set the setup attachment later.
        if (slot.attachmentState <= this.unkeyedState) slot.attachmentState = this.unkeyedState + $dcb477122a241e28$export$be88f4235204622a;
    }
    setAttachment(skeleton, slot, attachmentName, attachments) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
        if (attachments) slot.attachmentState = this.unkeyedState + $dcb477122a241e28$export$eed19b551669af14;
    }
    applyRotateTimeline(timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
        if (firstFrame) timelinesRotation[i] = 0;
        if (alpha == 1) {
            timeline.apply(skeleton, 0, time, null, 1, blend, (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixIn);
            return;
        }
        let bone = skeleton.bones[timeline.boneIndex];
        if (!bone.active) return;
        let frames = timeline.frames;
        let r1 = 0, r2 = 0;
        if (time < frames[0]) switch(blend){
            case (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation;
            default:
                return;
            case (0, $bbeb79d5adec7b97$export$ccab779a50275a35).first:
                r1 = bone.rotation;
                r2 = bone.data.rotation;
        }
        else {
            r1 = blend == (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup ? bone.data.rotation : bone.rotation;
            r2 = bone.data.rotation + timeline.getCurveValue(time);
        }
        // Mix between rotations using the direction of the shortest route on the first frame while detecting crosses.
        let total = 0, diff = r2 - r1;
        diff -= Math.ceil(diff / 360 - 0.5) * 360;
        if (diff == 0) total = timelinesRotation[i];
        else {
            let lastTotal = 0, lastDiff = 0;
            if (firstFrame) {
                lastTotal = 0;
                lastDiff = diff;
            } else {
                lastTotal = timelinesRotation[i];
                lastDiff = timelinesRotation[i + 1];
            }
            let loops = lastTotal - lastTotal % 360;
            total = diff + loops;
            let current = diff >= 0, dir = lastTotal >= 0;
            if (Math.abs(lastDiff) <= 90 && (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(lastDiff) != (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(diff)) {
                if (Math.abs(lastTotal - loops) > 180) {
                    total += 360 * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(lastTotal);
                    dir = current;
                } else if (loops != 0) total -= 360 * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(lastTotal);
                else dir = current;
            }
            if (dir != current) total += 360 * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(lastTotal);
            timelinesRotation[i] = total;
        }
        timelinesRotation[i + 1] = diff;
        bone.rotation = r1 + total * alpha;
    }
    queueEvents(entry, animationTime) {
        let animationStart = entry.animationStart, animationEnd = entry.animationEnd;
        let duration = animationEnd - animationStart;
        let trackLastWrapped = entry.trackLast % duration;
        // Queue events before complete.
        let events = this.events;
        let i = 0, n = events.length;
        for(; i < n; i++){
            let event = events[i];
            if (event.time < trackLastWrapped) break;
            if (event.time > animationEnd) continue; // Discard events outside animation start/end.
            this.queue.event(entry, event);
        }
        // Queue complete if completed a loop iteration or the animation.
        let complete = false;
        if (entry.loop) {
            if (duration == 0) complete = true;
            else {
                const cycles = Math.floor(entry.trackTime / duration);
                complete = cycles > 0 && cycles > Math.floor(entry.trackLast / duration);
            }
        } else complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
        if (complete) this.queue.complete(entry);
        // Queue events after complete.
        for(; i < n; i++){
            let event = events[i];
            if (event.time < animationStart) continue; // Discard events outside animation start/end.
            this.queue.event(entry, event);
        }
    }
    /** Removes all animations from all tracks, leaving skeletons in their current pose.
     *
     * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
     * rather than leaving them in their current pose. */ clearTracks() {
        let oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++)this.clearTrack(i);
        this.tracks.length = 0;
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    /** Removes all animations from the track, leaving skeletons in their current pose.
     *
     * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
     * rather than leaving them in their current pose. */ clearTrack(trackIndex) {
        if (trackIndex >= this.tracks.length) return;
        let current = this.tracks[trackIndex];
        if (!current) return;
        this.queue.end(current);
        this.clearNext(current);
        let entry = current;
        while(true){
            let from = entry.mixingFrom;
            if (!from) break;
            this.queue.end(from);
            entry.mixingFrom = null;
            entry.mixingTo = null;
            entry = from;
        }
        this.tracks[current.trackIndex] = null;
        this.queue.drain();
    }
    setCurrent(index, current, interrupt) {
        let from = this.expandToIndex(index);
        this.tracks[index] = current;
        current.previous = null;
        if (from) {
            if (interrupt) this.queue.interrupt(from);
            current.mixingFrom = from;
            from.mixingTo = current;
            current.mixTime = 0;
            // Store the interrupted mix percentage.
            if (from.mixingFrom && from.mixDuration > 0) current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
            from.timelinesRotation.length = 0; // Reset rotation for mixing out, in case entry was mixed in.
        }
        this.queue.start(current);
    }
    /** Sets an animation by name.
      *
      * See {@link #setAnimationWith()}. */ setAnimation(trackIndex, animationName, loop = false) {
        let animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error("Animation not found: " + animationName);
        return this.setAnimationWith(trackIndex, animation, loop);
    }
    /** Sets the current animation for a track, discarding any queued animations. If the formerly current track entry was never
     * applied to a skeleton, it is replaced (not mixed from).
     * @param loop If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     *           duration. In either case {@link TrackEntry#trackEnd} determines when the track is cleared.
     * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ setAnimationWith(trackIndex, animation, loop = false) {
        if (!animation) throw new Error("animation cannot be null.");
        let interrupt = true;
        let current = this.expandToIndex(trackIndex);
        if (current) {
            if (current.nextTrackLast == -1) {
                // Don't mix from an entry that was never applied.
                this.tracks[trackIndex] = current.mixingFrom;
                this.queue.interrupt(current);
                this.queue.end(current);
                this.clearNext(current);
                current = current.mixingFrom;
                interrupt = false;
            } else this.clearNext(current);
        }
        let entry = this.trackEntry(trackIndex, animation, loop, current);
        this.setCurrent(trackIndex, entry, interrupt);
        this.queue.drain();
        return entry;
    }
    /** Queues an animation by name.
     *
     * See {@link #addAnimationWith()}. */ addAnimation(trackIndex, animationName, loop = false, delay = 0) {
        let animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error("Animation not found: " + animationName);
        return this.addAnimationWith(trackIndex, animation, loop, delay);
    }
    /** Adds an animation to be played after the current or last queued animation for a track. If the track is empty, it is
     * equivalent to calling {@link #setAnimationWith()}.
     * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
     *           minus any mix duration (from the {@link AnimationStateData}) plus the specified `delay` (ie the mix
     *           ends at (`delay` = 0) or before (`delay` < 0) the previous track entry duration). If the
     *           previous entry is looping, its next loop completion is used instead of its duration.
     * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ addAnimationWith(trackIndex, animation, loop = false, delay = 0) {
        if (!animation) throw new Error("animation cannot be null.");
        let last = this.expandToIndex(trackIndex);
        if (last) while(last.next)last = last.next;
        let entry = this.trackEntry(trackIndex, animation, loop, last);
        if (!last) {
            this.setCurrent(trackIndex, entry, true);
            this.queue.drain();
        } else {
            last.next = entry;
            entry.previous = last;
            if (delay <= 0) delay += last.getTrackComplete() - entry.mixDuration;
        }
        entry.delay = delay;
        return entry;
    }
    /** Sets an empty animation for a track, discarding any queued animations, and sets the track entry's
     * {@link TrackEntry#mixduration}. An empty animation has no timelines and serves as a placeholder for mixing in or out.
     *
     * Mixing out is done by setting an empty animation with a mix duration using either {@link #setEmptyAnimation()},
     * {@link #setEmptyAnimations()}, or {@link #addEmptyAnimation()}. Mixing to an empty animation causes
     * the previous animation to be applied less and less over the mix duration. Properties keyed in the previous animation
     * transition to the value from lower tracks or to the setup pose value if no lower tracks key the property. A mix duration of
     * 0 still mixes out over one frame.
     *
     * Mixing in is done by first setting an empty animation, then adding an animation using
     * {@link #addAnimation()} and on the returned track entry, set the
     * {@link TrackEntry#setMixDuration()}. Mixing from an empty animation causes the new animation to be applied more and
     * more over the mix duration. Properties keyed in the new animation transition from the value from lower tracks or from the
     * setup pose value if no lower tracks key the property to the value keyed in the new animation. */ setEmptyAnimation(trackIndex, mixDuration = 0) {
        let entry = this.setAnimationWith(trackIndex, $dcb477122a241e28$export$d0f7a26c90cc1562.emptyAnimation(), false);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Adds an empty animation to be played after the current or last queued animation for a track, and sets the track entry's
     * {@link TrackEntry#mixDuration}. If the track is empty, it is equivalent to calling
     * {@link #setEmptyAnimation()}.
     *
     * See {@link #setEmptyAnimation()}.
     * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
     *           minus any mix duration plus the specified `delay` (ie the mix ends at (`delay` = 0) or
     *           before (`delay` < 0) the previous track entry duration). If the previous entry is looping, its next
     *           loop completion is used instead of its duration.
     * @return A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ addEmptyAnimation(trackIndex, mixDuration = 0, delay = 0) {
        let entry = this.addAnimationWith(trackIndex, $dcb477122a241e28$export$d0f7a26c90cc1562.emptyAnimation(), false, delay);
        if (delay <= 0) entry.delay += entry.mixDuration - mixDuration;
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Sets an empty animation for every track, discarding any queued animations, and mixes to it over the specified mix
      * duration. */ setEmptyAnimations(mixDuration = 0) {
        let oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++){
            let current = this.tracks[i];
            if (current) this.setEmptyAnimation(current.trackIndex, mixDuration);
        }
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    expandToIndex(index) {
        if (index < this.tracks.length) return this.tracks[index];
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).ensureArrayCapacity(this.tracks, index + 1, null);
        this.tracks.length = index + 1;
        return null;
    }
    /** @param last May be null. */ trackEntry(trackIndex, animation, loop, last) {
        let entry = this.trackEntryPool.obtain();
        entry.reset();
        entry.trackIndex = trackIndex;
        entry.animation = animation;
        entry.loop = loop;
        entry.holdPrevious = false;
        entry.reverse = false;
        entry.shortestRotation = false;
        entry.eventThreshold = 0;
        entry.alphaAttachmentThreshold = 0;
        entry.mixAttachmentThreshold = 0;
        entry.mixDrawOrderThreshold = 0;
        entry.animationStart = 0;
        entry.animationEnd = animation.duration;
        entry.animationLast = -1;
        entry.nextAnimationLast = -1;
        entry.delay = 0;
        entry.trackTime = 0;
        entry.trackLast = -1;
        entry.nextTrackLast = -1;
        entry.trackEnd = Number.MAX_VALUE;
        entry.timeScale = 1;
        entry.alpha = 1;
        entry.mixTime = 0;
        entry.mixDuration = !last ? 0 : this.data.getMix(last.animation, animation);
        entry.interruptAlpha = 1;
        entry.totalAlpha = 0;
        entry.mixBlend = (0, $bbeb79d5adec7b97$export$ccab779a50275a35).replace;
        return entry;
    }
    /** Removes the {@link TrackEntry#getNext() next entry} and all entries after it for the specified entry. */ clearNext(entry) {
        let next = entry.next;
        while(next){
            this.queue.dispose(next);
            next = next.next;
        }
        entry.next = null;
    }
    _animationsChanged() {
        this.animationsChanged = false;
        this.propertyIDs.clear();
        let tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let entry = tracks[i];
            if (!entry) continue;
            while(entry.mixingFrom)entry = entry.mixingFrom;
            do {
                if (!entry.mixingTo || entry.mixBlend != (0, $bbeb79d5adec7b97$export$ccab779a50275a35).add) this.computeHold(entry);
                entry = entry.mixingTo;
            }while (entry);
        }
    }
    computeHold(entry) {
        let to = entry.mixingTo;
        let timelines = entry.animation.timelines;
        let timelinesCount = entry.animation.timelines.length;
        let timelineMode = entry.timelineMode;
        timelineMode.length = timelinesCount;
        let timelineHoldMix = entry.timelineHoldMix;
        timelineHoldMix.length = 0;
        let propertyIDs = this.propertyIDs;
        if (to && to.holdPrevious) {
            for(let i = 0; i < timelinesCount; i++)timelineMode[i] = propertyIDs.addAll(timelines[i].getPropertyIds()) ? $dcb477122a241e28$export$83263fba6795a4f7 : $dcb477122a241e28$export$61db7ea55ff2bc4f;
            return;
        }
        outer: for(let i = 0; i < timelinesCount; i++){
            let timeline = timelines[i];
            let ids = timeline.getPropertyIds();
            if (!propertyIDs.addAll(ids)) timelineMode[i] = $dcb477122a241e28$export$89027c4cc247cc19;
            else if (!to || timeline instanceof (0, $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d) || timeline instanceof (0, $bbeb79d5adec7b97$export$ece1f7c41d051e83) || timeline instanceof (0, $bbeb79d5adec7b97$export$4f4bca996c586084) || !to.animation.hasTimeline(ids)) timelineMode[i] = $dcb477122a241e28$export$9f55c59c79ce7630;
            else {
                for(let next = to.mixingTo; next; next = next.mixingTo){
                    if (next.animation.hasTimeline(ids)) continue;
                    if (entry.mixDuration > 0) {
                        timelineMode[i] = $dcb477122a241e28$export$68479a2ca54edfe5;
                        timelineHoldMix[i] = next;
                        continue outer;
                    }
                    break;
                }
                timelineMode[i] = $dcb477122a241e28$export$83263fba6795a4f7;
            }
        }
    }
    /** Returns the track entry for the animation currently playing on the track, or null if no animation is currently playing. */ getCurrent(trackIndex) {
        if (trackIndex >= this.tracks.length) return null;
        return this.tracks[trackIndex];
    }
    /** Adds a listener to receive events for all track entries. */ addListener(listener) {
        if (!listener) throw new Error("listener cannot be null.");
        this.listeners.push(listener);
    }
    /** Removes the listener added with {@link #addListener()}. */ removeListener(listener) {
        let index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
    }
    /** Removes all listeners added with {@link #addListener()}. */ clearListeners() {
        this.listeners.length = 0;
    }
    /** Discards all listener notifications that have not yet been delivered. This can be useful to call from an
     * {@link AnimationStateListener} when it is known that further notifications that may have been already queued for delivery
     * are not wanted because new animations are being set. */ clearListenerNotifications() {
        this.queue.clear();
    }
}
class $dcb477122a241e28$export$6fd48f25bc0ee658 {
    /** The animation to apply for this track entry. */ animation = null;
    previous = null;
    /** The animation queued to start after this animation, or null. `next` makes up a linked list. */ next = null;
    /** The track entry for the previous animation when mixing from the previous animation to this animation, or null if no
     * mixing is currently occuring. When mixing from multiple animations, `mixingFrom` makes up a linked list. */ mixingFrom = null;
    /** The track entry for the next animation when mixing from this animation to the next animation, or null if no mixing is
     * currently occuring. When mixing to multiple animations, `mixingTo` makes up a linked list. */ mixingTo = null;
    /** The listener for events generated by this track entry, or null.
     *
     * A track entry returned from {@link AnimationState#setAnimation()} is already the current animation
     * for the track, so the track entry listener {@link AnimationStateListener#start()} will not be called. */ listener = null;
    /** The index of the track where this track entry is either current or queued.
     *
     * See {@link AnimationState#getCurrent()}. */ trackIndex = 0;
    /** If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     * duration. */ loop = false;
    /** If true, when mixing from the previous animation to this animation, the previous animation is applied as normal instead
     * of being mixed out.
     *
     * When mixing between animations that key the same property, if a lower track also keys that property then the value will
     * briefly dip toward the lower track value during the mix. This happens because the first animation mixes from 100% to 0%
     * while the second animation mixes from 0% to 100%. Setting `holdPrevious` to true applies the first animation
     * at 100% during the mix so the lower track value is overwritten. Such dipping does not occur on the lowest track which
     * keys the property, only when a higher track also keys the property.
     *
     * Snapping will occur if `holdPrevious` is true and this animation does not key all the same properties as the
     * previous animation. */ holdPrevious = false;
    reverse = false;
    shortestRotation = false;
    /** When the mix percentage ({@link #mixTime} / {@link #mixDuration}) is less than the
     * `eventThreshold`, event timelines are applied while this animation is being mixed out. Defaults to 0, so event
     * timelines are not applied while this animation is being mixed out. */ eventThreshold = 0;
    /** When the mix percentage ({@link #mixtime} / {@link #mixDuration}) is less than the
     * `attachmentThreshold`, attachment timelines are applied while this animation is being mixed out. Defaults to
     * 0, so attachment timelines are not applied while this animation is being mixed out. */ mixAttachmentThreshold = 0;
    /** When {@link #getAlpha()} is greater than <code>alphaAttachmentThreshold</code>, attachment timelines are applied.
     * Defaults to 0, so attachment timelines are always applied. */ alphaAttachmentThreshold = 0;
    /** When the mix percentage ({@link #getMixTime()} / {@link #getMixDuration()}) is less than the
     * <code>mixDrawOrderThreshold</code>, draw order timelines are applied while this animation is being mixed out. Defaults to
     * 0, so draw order timelines are not applied while this animation is being mixed out. */ mixDrawOrderThreshold = 0;
    /** Seconds when this animation starts, both initially and after looping. Defaults to 0.
     *
     * When changing the `animationStart` time, it often makes sense to set {@link #animationLast} to the same
     * value to prevent timeline keys before the start time from triggering. */ animationStart = 0;
    /** Seconds for the last frame of this animation. Non-looping animations won't play past this time. Looping animations will
     * loop back to {@link #animationStart} at this time. Defaults to the animation {@link Animation#duration}. */ animationEnd = 0;
    /** The time in seconds this animation was last applied. Some timelines use this for one-time triggers. Eg, when this
     * animation is applied, event timelines will fire all events between the `animationLast` time (exclusive) and
     * `animationTime` (inclusive). Defaults to -1 to ensure triggers on frame 0 happen the first time this animation
     * is applied. */ animationLast = 0;
    nextAnimationLast = 0;
    /** Seconds to postpone playing the animation. When this track entry is the current track entry, `delay`
     * postpones incrementing the {@link #trackTime}. When this track entry is queued, `delay` is the time from
     * the start of the previous animation to when this track entry will become the current track entry (ie when the previous
     * track entry {@link TrackEntry#trackTime} >= this track entry's `delay`).
     *
     * {@link #timeScale} affects the delay. */ delay = 0;
    /** Current time in seconds this track entry has been the current track entry. The track time determines
     * {@link #animationTime}. The track time can be set to start the animation at a time other than 0, without affecting
     * looping. */ trackTime = 0;
    trackLast = 0;
    nextTrackLast = 0;
    /** The track time in seconds when this animation will be removed from the track. Defaults to the highest possible float
     * value, meaning the animation will be applied until a new animation is set or the track is cleared. If the track end time
     * is reached, no other animations are queued for playback, and mixing from any previous animations is complete, then the
     * properties keyed by the animation are set to the setup pose and the track is cleared.
     *
     * It may be desired to use {@link AnimationState#addEmptyAnimation()} rather than have the animation
     * abruptly cease being applied. */ trackEnd = 0;
    /** Multiplier for the delta time when this track entry is updated, causing time for this animation to pass slower or
     * faster. Defaults to 1.
     *
     * {@link #mixTime} is not affected by track entry time scale, so {@link #mixDuration} may need to be adjusted to
     * match the animation speed.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, assuming time scale to be 1. If
     * the time scale is not 1, the delay may need to be adjusted.
     *
     * See AnimationState {@link AnimationState#timeScale} for affecting all animations. */ timeScale = 0;
    /** Values < 1 mix this animation with the skeleton's current pose (usually the pose resulting from lower tracks). Defaults
     * to 1, which overwrites the skeleton's current pose with this animation.
     *
     * Typically track 0 is used to completely pose the skeleton, then alpha is used on higher tracks. It doesn't make sense to
     * use alpha on track 0 if the skeleton pose is from the last frame render. */ alpha = 0;
    /** Seconds from 0 to the {@link #getMixDuration()} when mixing from the previous animation to this animation. May be
     * slightly more than `mixDuration` when the mix is complete. */ mixTime = 0;
    /** Seconds for mixing from the previous animation to this animation. Defaults to the value provided by AnimationStateData
     * {@link AnimationStateData#getMix()} based on the animation before this animation (if any).
     *
     * A mix duration of 0 still mixes out over one frame to provide the track entry being mixed out a chance to revert the
     * properties it was animating.
     *
     * The `mixDuration` can be set manually rather than use the value from
     * {@link AnimationStateData#getMix()}. In that case, the `mixDuration` can be set for a new
     * track entry only before {@link AnimationState#update(float)} is first called.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, not a mix duration set
     * afterward. */ _mixDuration = 0;
    interruptAlpha = 0;
    totalAlpha = 0;
    get mixDuration() {
        return this._mixDuration;
    }
    set mixDuration(mixDuration) {
        this._mixDuration = mixDuration;
    }
    setMixDurationWithDelay(mixDuration, delay) {
        this._mixDuration = mixDuration;
        if (this.previous != null && delay <= 0) delay += this.previous.getTrackComplete() - mixDuration;
        this.delay = delay;
    }
    /** Controls how properties keyed in the animation are mixed with lower tracks. Defaults to {@link MixBlend#replace}, which
     * replaces the values from the lower tracks with the animation values. {@link MixBlend#add} adds the animation values to
     * the values from the lower tracks.
     *
     * The `mixBlend` can be set for a new track entry only before {@link AnimationState#apply()} is first
     * called. */ mixBlend = (0, $bbeb79d5adec7b97$export$ccab779a50275a35).replace;
    timelineMode = new Array();
    timelineHoldMix = new Array();
    timelinesRotation = new Array();
    reset() {
        this.next = null;
        this.previous = null;
        this.mixingFrom = null;
        this.mixingTo = null;
        this.animation = null;
        this.listener = null;
        this.timelineMode.length = 0;
        this.timelineHoldMix.length = 0;
        this.timelinesRotation.length = 0;
    }
    /** Uses {@link #trackTime} to compute the `animationTime`, which is between {@link #animationStart}
     * and {@link #animationEnd}. When the `trackTime` is 0, the `animationTime` is equal to the
     * `animationStart` time. */ getAnimationTime() {
        if (this.loop) {
            let duration = this.animationEnd - this.animationStart;
            if (duration == 0) return this.animationStart;
            return this.trackTime % duration + this.animationStart;
        }
        return Math.min(this.trackTime + this.animationStart, this.animationEnd);
    }
    setAnimationLast(animationLast) {
        this.animationLast = animationLast;
        this.nextAnimationLast = animationLast;
    }
    /** Returns true if at least one loop has been completed.
     *
     * See {@link AnimationStateListener#complete()}. */ isComplete() {
        return this.trackTime >= this.animationEnd - this.animationStart;
    }
    /** Resets the rotation directions for mixing this entry's rotate timelines. This can be useful to avoid bones rotating the
     * long way around when using {@link #alpha} and starting animations on other tracks.
     *
     * Mixing with {@link MixBlend#replace} involves finding a rotation between two others, which has two possible solutions:
     * the short way or the long way around. The two rotations likely change over time, so which direction is the short or long
     * way also changes. If the short way was always chosen, bones would flip to the other side when that direction became the
     * long way. TrackEntry chooses the short way the first time it is applied and remembers that direction. */ resetRotationDirections() {
        this.timelinesRotation.length = 0;
    }
    getTrackComplete() {
        let duration = this.animationEnd - this.animationStart;
        if (duration != 0) {
            if (this.loop) return duration * (1 + (this.trackTime / duration | 0)); // Completion of next loop.
            if (this.trackTime < duration) return duration; // Before duration.
        }
        return this.trackTime; // Next update.
    }
    /** Returns true if this track entry has been applied at least once.
     * <p>
     * See {@link AnimationState#apply(Skeleton)}. */ wasApplied() {
        return this.nextTrackLast != -1;
    }
    /** Returns true if there is a {@link #getNext()} track entry and it will become the current track entry during the next
     * {@link AnimationState#update(float)}. */ isNextReady() {
        return this.next != null && this.nextTrackLast - this.next.delay >= 0;
    }
}
class $dcb477122a241e28$export$2fc6338444a158e6 {
    objects = [];
    drainDisabled = false;
    animState;
    constructor(animState){
        this.animState = animState;
    }
    start(entry) {
        this.objects.push($dcb477122a241e28$export$3d7865934588d77e.start);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    interrupt(entry) {
        this.objects.push($dcb477122a241e28$export$3d7865934588d77e.interrupt);
        this.objects.push(entry);
    }
    end(entry) {
        this.objects.push($dcb477122a241e28$export$3d7865934588d77e.end);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    dispose(entry) {
        this.objects.push($dcb477122a241e28$export$3d7865934588d77e.dispose);
        this.objects.push(entry);
    }
    complete(entry) {
        this.objects.push($dcb477122a241e28$export$3d7865934588d77e.complete);
        this.objects.push(entry);
    }
    event(entry, event) {
        this.objects.push($dcb477122a241e28$export$3d7865934588d77e.event);
        this.objects.push(entry);
        this.objects.push(event);
    }
    drain() {
        if (this.drainDisabled) return;
        this.drainDisabled = true;
        let objects = this.objects;
        let listeners = this.animState.listeners;
        for(let i = 0; i < objects.length; i += 2){
            let type = objects[i];
            let entry = objects[i + 1];
            switch(type){
                case $dcb477122a241e28$export$3d7865934588d77e.start:
                    if (entry.listener && entry.listener.start) entry.listener.start(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.start) listener.start(entry);
                    }
                    break;
                case $dcb477122a241e28$export$3d7865934588d77e.interrupt:
                    if (entry.listener && entry.listener.interrupt) entry.listener.interrupt(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.interrupt) listener.interrupt(entry);
                    }
                    break;
                case $dcb477122a241e28$export$3d7865934588d77e.end:
                    if (entry.listener && entry.listener.end) entry.listener.end(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.end) listener.end(entry);
                    }
                // Fall through.
                case $dcb477122a241e28$export$3d7865934588d77e.dispose:
                    if (entry.listener && entry.listener.dispose) entry.listener.dispose(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.dispose) listener.dispose(entry);
                    }
                    this.animState.trackEntryPool.free(entry);
                    break;
                case $dcb477122a241e28$export$3d7865934588d77e.complete:
                    if (entry.listener && entry.listener.complete) entry.listener.complete(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.complete) listener.complete(entry);
                    }
                    break;
                case $dcb477122a241e28$export$3d7865934588d77e.event:
                    let event = objects[i++ + 2];
                    if (entry.listener && entry.listener.event) entry.listener.event(entry, event);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.event) listener.event(entry, event);
                    }
                    break;
            }
        }
        this.clear();
        this.drainDisabled = false;
    }
    clear() {
        this.objects.length = 0;
    }
}
var $dcb477122a241e28$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["start"] = 0] = "start";
    EventType[EventType["interrupt"] = 1] = "interrupt";
    EventType[EventType["end"] = 2] = "end";
    EventType[EventType["dispose"] = 3] = "dispose";
    EventType[EventType["complete"] = 4] = "complete";
    EventType[EventType["event"] = 5] = "event";
})($dcb477122a241e28$export$3d7865934588d77e || ($dcb477122a241e28$export$3d7865934588d77e = {}));
class $dcb477122a241e28$export$31af0cf42be5a74d {
    start(entry) {}
    interrupt(entry) {}
    end(entry) {}
    dispose(entry) {}
    complete(entry) {}
    event(entry, event) {}
}
const $dcb477122a241e28$export$89027c4cc247cc19 = 0;
const $dcb477122a241e28$export$9f55c59c79ce7630 = 1;
const $dcb477122a241e28$export$61db7ea55ff2bc4f = 2;
const $dcb477122a241e28$export$83263fba6795a4f7 = 3;
const $dcb477122a241e28$export$68479a2ca54edfe5 = 4;
const $dcb477122a241e28$export$be88f4235204622a = 1;
const $dcb477122a241e28$export$eed19b551669af14 = 2;


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores mix (crossfade) durations to be applied when {@link AnimationState} animations are changed. */ class $b530cc1d06ee361f$export$90d7167cc0605975 {
    /** The SkeletonData to look up animations when they are specified by name. */ skeletonData;
    animationToMixTime = {};
    /** The mix duration to use when no mix duration has been defined between two animations. */ defaultMix = 0;
    constructor(skeletonData){
        if (!skeletonData) throw new Error("skeletonData cannot be null.");
        this.skeletonData = skeletonData;
    }
    /** Sets a mix duration by animation name.
     *
     * See {@link #setMixWith()}. */ setMix(fromName, toName, duration) {
        let from = this.skeletonData.findAnimation(fromName);
        if (!from) throw new Error("Animation not found: " + fromName);
        let to = this.skeletonData.findAnimation(toName);
        if (!to) throw new Error("Animation not found: " + toName);
        this.setMixWith(from, to, duration);
    }
    /** Sets the mix duration when changing from the specified animation to the other.
     *
     * See {@link TrackEntry#mixDuration}. */ setMixWith(from, to, duration) {
        if (!from) throw new Error("from cannot be null.");
        if (!to) throw new Error("to cannot be null.");
        let key = from.name + "." + to.name;
        this.animationToMixTime[key] = duration;
    }
    /** Returns the mix duration to use when changing from the specified animation to the other, or the {@link #defaultMix} if
      * no mix duration has been set. */ getMix(from, to) {
        let key = from.name + "." + to.name;
        let value = this.animationToMixTime[key];
        return value === undefined ? this.defaultMix : value;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $fbef049ae3c3cd60$export$9538c439c6b85ad2 extends (0, $6828f80d5a50ba40$export$66d3a0c3be55e044) {
    color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $fbef049ae3c3cd60$export$9538c439c6b85ad2(this.name);
        this.copyTo(copy);
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $ee64e63dbd5e17c9$export$838805e22b9b55f1 extends (0, $6828f80d5a50ba40$export$66d3a0c3be55e044) {
    /** Clipping is performed between the clipping polygon's slot and the end slot. Returns null if clipping is done until the end of
     * the skeleton's rendering. */ endSlot = null;
    // Nonessential.
    /** The color of the clipping polygon as it was in Spine. Available only when nonessential data was exported. Clipping polygons
     * are not usually rendered at runtime. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.2275, 0.2275, 0.8078, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $ee64e63dbd5e17c9$export$838805e22b9b55f1(this.name);
        this.copyTo(copy);
        copy.endSlot = this.endSlot;
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $0ec5a873c6b98cd8$export$5431306cf43de24a {
    _image;
    constructor(image){
        this._image = image;
    }
    getImage() {
        return this._image;
    }
}
var $0ec5a873c6b98cd8$export$f389c48fc54053be;
(function(TextureFilter) {
    TextureFilter[TextureFilter["Nearest"] = 9728] = "Nearest";
    TextureFilter[TextureFilter["Linear"] = 9729] = "Linear";
    TextureFilter[TextureFilter["MipMap"] = 9987] = "MipMap";
    TextureFilter[TextureFilter["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
    TextureFilter[TextureFilter["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
    TextureFilter[TextureFilter["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
    TextureFilter[TextureFilter["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear"; // WebGLRenderingContext.LINEAR_MIPMAP_LINEAR
})($0ec5a873c6b98cd8$export$f389c48fc54053be || ($0ec5a873c6b98cd8$export$f389c48fc54053be = {}));
var $0ec5a873c6b98cd8$export$522a1d31bfb74ba3;
(function(TextureWrap) {
    TextureWrap[TextureWrap["MirroredRepeat"] = 33648] = "MirroredRepeat";
    TextureWrap[TextureWrap["ClampToEdge"] = 33071] = "ClampToEdge";
    TextureWrap[TextureWrap["Repeat"] = 10497] = "Repeat"; // WebGLRenderingContext.REPEAT
})($0ec5a873c6b98cd8$export$522a1d31bfb74ba3 || ($0ec5a873c6b98cd8$export$522a1d31bfb74ba3 = {}));
class $0ec5a873c6b98cd8$export$e7d46317c6b644d1 {
    texture;
    u = 0;
    v = 0;
    u2 = 0;
    v2 = 0;
    width = 0;
    height = 0;
    degrees = 0;
    offsetX = 0;
    offsetY = 0;
    originalWidth = 0;
    originalHeight = 0;
}
class $0ec5a873c6b98cd8$export$b3652565e6818133 extends $0ec5a873c6b98cd8$export$5431306cf43de24a {
    setFilters(minFilter, magFilter) {}
    setWraps(uWrap, vWrap) {}
    dispose() {}
}



class $d78fcde22e89ce53$export$1ffc3159823e6649 {
    pages = new Array();
    regions = new Array();
    constructor(atlasText){
        let reader = new $d78fcde22e89ce53$var$TextureAtlasReader(atlasText);
        let entry = new Array(4);
        let pageFields = {};
        pageFields["size"] = (page)=>{
            page.width = parseInt(entry[1]);
            page.height = parseInt(entry[2]);
        };
        pageFields["format"] = ()=>{
        // page.format = Format[tuple[0]]; we don't need format in WebGL
        };
        pageFields["filter"] = (page)=>{
            page.minFilter = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $0ec5a873c6b98cd8$export$f389c48fc54053be), entry[1]);
            page.magFilter = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $0ec5a873c6b98cd8$export$f389c48fc54053be), entry[2]);
        };
        pageFields["repeat"] = (page)=>{
            if (entry[1].indexOf("x") != -1) page.uWrap = (0, $0ec5a873c6b98cd8$export$522a1d31bfb74ba3).Repeat;
            if (entry[1].indexOf("y") != -1) page.vWrap = (0, $0ec5a873c6b98cd8$export$522a1d31bfb74ba3).Repeat;
        };
        pageFields["pma"] = (page)=>{
            page.pma = entry[1] == "true";
        };
        var regionFields = {};
        regionFields["xy"] = (region)=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
        };
        regionFields["size"] = (region)=>{
            region.width = parseInt(entry[1]);
            region.height = parseInt(entry[2]);
        };
        regionFields["bounds"] = (region)=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
            region.width = parseInt(entry[3]);
            region.height = parseInt(entry[4]);
        };
        regionFields["offset"] = (region)=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
        };
        regionFields["orig"] = (region)=>{
            region.originalWidth = parseInt(entry[1]);
            region.originalHeight = parseInt(entry[2]);
        };
        regionFields["offsets"] = (region)=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
            region.originalWidth = parseInt(entry[3]);
            region.originalHeight = parseInt(entry[4]);
        };
        regionFields["rotate"] = (region)=>{
            let value = entry[1];
            if (value == "true") region.degrees = 90;
            else if (value != "false") region.degrees = parseInt(value);
        };
        regionFields["index"] = (region)=>{
            region.index = parseInt(entry[1]);
        };
        let line = reader.readLine();
        // Ignore empty lines before first entry.
        while(line && line.trim().length == 0)line = reader.readLine();
        // Header entries.
        while(true){
            if (!line || line.trim().length == 0) break;
            if (reader.readEntry(entry, line) == 0) break; // Silently ignore all header fields.
            line = reader.readLine();
        }
        // Page and region entries.
        let page = null;
        let names = null;
        let values = null;
        while(true){
            if (line === null) break;
            if (line.trim().length == 0) {
                page = null;
                line = reader.readLine();
            } else if (!page) {
                page = new $d78fcde22e89ce53$export$1a5db136de4137c2(line.trim());
                while(true){
                    if (reader.readEntry(entry, line = reader.readLine()) == 0) break;
                    let field = pageFields[entry[0]];
                    if (field) field(page);
                }
                this.pages.push(page);
            } else {
                let region = new $d78fcde22e89ce53$export$6c0770e21c633916(page, line);
                while(true){
                    let count = reader.readEntry(entry, line = reader.readLine());
                    if (count == 0) break;
                    let field = regionFields[entry[0]];
                    if (field) field(region);
                    else {
                        if (!names) names = [];
                        if (!values) values = [];
                        names.push(entry[0]);
                        let entryValues = [];
                        for(let i = 0; i < count; i++)entryValues.push(parseInt(entry[i + 1]));
                        values.push(entryValues);
                    }
                }
                if (region.originalWidth == 0 && region.originalHeight == 0) {
                    region.originalWidth = region.width;
                    region.originalHeight = region.height;
                }
                if (names && names.length > 0 && values && values.length > 0) {
                    region.names = names;
                    region.values = values;
                    names = null;
                    values = null;
                }
                region.u = region.x / page.width;
                region.v = region.y / page.height;
                if (region.degrees == 90) {
                    region.u2 = (region.x + region.height) / page.width;
                    region.v2 = (region.y + region.width) / page.height;
                } else {
                    region.u2 = (region.x + region.width) / page.width;
                    region.v2 = (region.y + region.height) / page.height;
                }
                this.regions.push(region);
            }
        }
    }
    findRegion(name) {
        for(let i = 0; i < this.regions.length; i++){
            if (this.regions[i].name == name) return this.regions[i];
        }
        return null;
    }
    setTextures(assetManager, pathPrefix = "") {
        for (let page of this.pages)page.setTexture(assetManager.get(pathPrefix + page.name));
    }
    dispose() {
        for(let i = 0; i < this.pages.length; i++)this.pages[i].texture?.dispose();
    }
}
class $d78fcde22e89ce53$var$TextureAtlasReader {
    lines;
    index = 0;
    constructor(text){
        this.lines = text.split(/\r\n|\r|\n/);
    }
    readLine() {
        if (this.index >= this.lines.length) return null;
        return this.lines[this.index++];
    }
    readEntry(entry, line) {
        if (!line) return 0;
        line = line.trim();
        if (line.length == 0) return 0;
        let colon = line.indexOf(":");
        if (colon == -1) return 0;
        entry[0] = line.substr(0, colon).trim();
        for(let i = 1, lastMatch = colon + 1;; i++){
            let comma = line.indexOf(",", lastMatch);
            if (comma == -1) {
                entry[i] = line.substr(lastMatch).trim();
                return i;
            }
            entry[i] = line.substr(lastMatch, comma - lastMatch).trim();
            lastMatch = comma + 1;
            if (i == 4) return 4;
        }
    }
}
class $d78fcde22e89ce53$export$1a5db136de4137c2 {
    name;
    minFilter = (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Nearest;
    magFilter = (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Nearest;
    uWrap = (0, $0ec5a873c6b98cd8$export$522a1d31bfb74ba3).ClampToEdge;
    vWrap = (0, $0ec5a873c6b98cd8$export$522a1d31bfb74ba3).ClampToEdge;
    texture = null;
    width = 0;
    height = 0;
    pma = false;
    regions = new Array();
    constructor(name){
        this.name = name;
    }
    setTexture(texture) {
        this.texture = texture;
        texture.setFilters(this.minFilter, this.magFilter);
        texture.setWraps(this.uWrap, this.vWrap);
        for (let region of this.regions)region.texture = texture;
    }
}
class $d78fcde22e89ce53$export$6c0770e21c633916 extends (0, $0ec5a873c6b98cd8$export$e7d46317c6b644d1) {
    page;
    name;
    x = 0;
    y = 0;
    offsetX = 0;
    offsetY = 0;
    originalWidth = 0;
    originalHeight = 0;
    index = 0;
    degrees = 0;
    names = null;
    values = null;
    constructor(page, name){
        super();
        this.page = page;
        this.name = name;
        page.regions.push(this);
    }
}




class $06d16b10b33d165a$export$3f1c1692adfcf3e2 extends (0, $6828f80d5a50ba40$export$66d3a0c3be55e044) {
    region = null;
    /** The name of the texture region for this attachment. */ path;
    /** The UV pair for each vertex, normalized within the texture region. */ regionUVs = [];
    /** The UV pair for each vertex, normalized within the entire texture.
     *
     * See {@link #updateUVs}. */ uvs = [];
    /** Triplets of vertex indices which describe the mesh's triangulation. */ triangles = [];
    /** The color to tint the mesh. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    /** The width of the mesh's image. Available only when nonessential data was exported. */ width = 0;
    /** The height of the mesh's image. Available only when nonessential data was exported. */ height = 0;
    /** The number of entries at the beginning of {@link #vertices} that make up the mesh hull. */ hullLength = 0;
    /** Vertex index pairs describing edges for controling triangulation. Mesh triangles will never cross edges. Only available if
     * nonessential data was exported. Triangulation is not performed at runtime. */ edges = [];
    parentMesh = null;
    sequence = null;
    tempColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0, 0, 0, 0);
    constructor(name, path){
        super(name);
        this.path = path;
    }
    /** Calculates {@link #uvs} using the {@link #regionUVs} and region. Must be called if the region, the region's properties, or
     * the {@link #regionUVs} are changed. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        let regionUVs = this.regionUVs;
        if (!this.uvs || this.uvs.length != regionUVs.length) this.uvs = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(regionUVs.length);
        let uvs = this.uvs;
        let n = this.uvs.length;
        let u = this.region.u, v = this.region.v, width = 0, height = 0;
        if (this.region instanceof (0, $d78fcde22e89ce53$export$6c0770e21c633916)) {
            let region = this.region, page = region.page;
            let textureWidth = page.width, textureHeight = page.height;
            switch(region.degrees){
                case 90:
                    u -= (region.originalHeight - region.offsetY - region.height) / textureWidth;
                    v -= (region.originalWidth - region.offsetX - region.width) / textureHeight;
                    width = region.originalHeight / textureWidth;
                    height = region.originalWidth / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + regionUVs[i + 1] * width;
                        uvs[i + 1] = v + (1 - regionUVs[i]) * height;
                    }
                    return;
                case 180:
                    u -= (region.originalWidth - region.offsetX - region.width) / textureWidth;
                    v -= region.offsetY / textureHeight;
                    width = region.originalWidth / textureWidth;
                    height = region.originalHeight / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + (1 - regionUVs[i]) * width;
                        uvs[i + 1] = v + (1 - regionUVs[i + 1]) * height;
                    }
                    return;
                case 270:
                    u -= region.offsetY / textureWidth;
                    v -= region.offsetX / textureHeight;
                    width = region.originalHeight / textureWidth;
                    height = region.originalWidth / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + (1 - regionUVs[i + 1]) * width;
                        uvs[i + 1] = v + regionUVs[i] * height;
                    }
                    return;
            }
            u -= region.offsetX / textureWidth;
            v -= (region.originalHeight - region.offsetY - region.height) / textureHeight;
            width = region.originalWidth / textureWidth;
            height = region.originalHeight / textureHeight;
        } else if (!this.region) {
            u = v = 0;
            width = height = 1;
        } else {
            width = this.region.u2 - u;
            height = this.region.v2 - v;
        }
        for(let i = 0; i < n; i += 2){
            uvs[i] = u + regionUVs[i] * width;
            uvs[i + 1] = v + regionUVs[i + 1] * height;
        }
    }
    /** The parent mesh if this is a linked mesh, else null. A linked mesh shares the {@link #bones}, {@link #vertices},
     * {@link #regionUVs}, {@link #triangles}, {@link #hullLength}, {@link #edges}, {@link #width}, and {@link #height} with the
     * parent mesh, but may have a different {@link #name} or {@link #path} (and therefore a different texture). */ getParentMesh() {
        return this.parentMesh;
    }
    /** @param parentMesh May be null. */ setParentMesh(parentMesh) {
        this.parentMesh = parentMesh;
        if (parentMesh) {
            this.bones = parentMesh.bones;
            this.vertices = parentMesh.vertices;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
            this.regionUVs = parentMesh.regionUVs;
            this.triangles = parentMesh.triangles;
            this.hullLength = parentMesh.hullLength;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
        }
    }
    copy() {
        if (this.parentMesh) return this.newLinkedMesh();
        let copy = new $06d16b10b33d165a$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        this.copyTo(copy);
        copy.regionUVs = new Array(this.regionUVs.length);
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.regionUVs, 0, copy.regionUVs, 0, this.regionUVs.length);
        copy.uvs = new Array(this.uvs.length);
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.uvs, 0, copy.uvs, 0, this.uvs.length);
        copy.triangles = new Array(this.triangles.length);
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.triangles, 0, copy.triangles, 0, this.triangles.length);
        copy.hullLength = this.hullLength;
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        // Nonessential.
        if (this.edges) {
            copy.edges = new Array(this.edges.length);
            (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.edges, 0, copy.edges, 0, this.edges.length);
        }
        copy.width = this.width;
        copy.height = this.height;
        return copy;
    }
    computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        super.computeWorldVertices(slot, start, count, worldVertices, offset, stride);
    }
    /** Returns a new mesh with the {@link #parentMesh} set to this mesh's parent mesh, if any, else to this mesh. **/ newLinkedMesh() {
        let copy = new $06d16b10b33d165a$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        copy.timelineAttachment = this.timelineAttachment;
        copy.setParentMesh(this.parentMesh ? this.parentMesh : this);
        if (copy.region != null) copy.updateRegion();
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $a01103cd4726e79d$export$d285e3ec07b32800 extends (0, $6828f80d5a50ba40$export$66d3a0c3be55e044) {
    /** The lengths along the path in the setup pose from the start of the path to the end of each Bezier curve. */ lengths = [];
    /** If true, the start and end knots are connected. */ closed = false;
    /** If true, additional calculations are performed to make calculating positions along the path more accurate. If false, fewer
     * calculations are performed but calculating positions along the path is less accurate. */ constantSpeed = false;
    /** The color of the path as it was in Spine. Available only when nonessential data was exported. Paths are not usually
     * rendered at runtime. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $a01103cd4726e79d$export$d285e3ec07b32800(this.name);
        this.copyTo(copy);
        copy.lengths = new Array(this.lengths.length);
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);
        copy.closed = closed;
        copy.constantSpeed = this.constantSpeed;
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $7a958dd3474c5a1d$export$1b528cde44a6ab5 extends (0, $6828f80d5a50ba40$export$66d3a0c3be55e044) {
    x = 0;
    y = 0;
    rotation = 0;
    /** The color of the point attachment as it was in Spine. Available only when nonessential data was exported. Point attachments
     * are not usually rendered at runtime. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.38, 0.94, 0, 1);
    constructor(name){
        super(name);
    }
    computeWorldPosition(bone, point) {
        point.x = this.x * bone.a + this.y * bone.b + bone.worldX;
        point.y = this.x * bone.c + this.y * bone.d + bone.worldY;
        return point;
    }
    computeWorldRotation(bone) {
        const r = this.rotation * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad, cos = Math.cos(r), sin = Math.sin(r);
        const x = cos * bone.a + sin * bone.b;
        const y = cos * bone.c + sin * bone.d;
        return (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).atan2Deg(y, x);
    }
    copy() {
        let copy = new $7a958dd3474c5a1d$export$1b528cde44a6ab5(this.name);
        copy.x = this.x;
        copy.y = this.y;
        copy.rotation = this.rotation;
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $679f9e8a376fdb80$export$d0fc51466fa6d530 extends (0, $6828f80d5a50ba40$export$71e4db985cfcf9e3) {
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local scaleX. */ scaleX = 1;
    /** The local scaleY. */ scaleY = 1;
    /** The local rotation. */ rotation = 0;
    /** The width of the region attachment in Spine. */ width = 0;
    /** The height of the region attachment in Spine. */ height = 0;
    /** The color to tint the region attachment. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    /** The name of the texture region for this attachment. */ path;
    region = null;
    sequence = null;
    /** For each of the 4 vertices, a pair of <code>x,y</code> values that is the local position of the vertex.
     *
     * See {@link #updateOffset()}. */ offset = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(8);
    uvs = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(8);
    tempColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    constructor(name, path){
        super(name);
        this.path = path;
    }
    /** Calculates the {@link #offset} using the region settings. Must be called after changing region settings. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        let region = this.region;
        let uvs = this.uvs;
        if (region == null) {
            uvs[0] = 0;
            uvs[1] = 0;
            uvs[2] = 0;
            uvs[3] = 1;
            uvs[4] = 1;
            uvs[5] = 1;
            uvs[6] = 1;
            uvs[7] = 0;
            return;
        }
        let regionScaleX = this.width / this.region.originalWidth * this.scaleX;
        let regionScaleY = this.height / this.region.originalHeight * this.scaleY;
        let localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
        let localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
        let localX2 = localX + this.region.width * regionScaleX;
        let localY2 = localY + this.region.height * regionScaleY;
        let radians = this.rotation * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        let cos = Math.cos(radians);
        let sin = Math.sin(radians);
        let x = this.x, y = this.y;
        let localXCos = localX * cos + x;
        let localXSin = localX * sin;
        let localYCos = localY * cos + y;
        let localYSin = localY * sin;
        let localX2Cos = localX2 * cos + x;
        let localX2Sin = localX2 * sin;
        let localY2Cos = localY2 * cos + y;
        let localY2Sin = localY2 * sin;
        let offset = this.offset;
        offset[0] = localXCos - localYSin;
        offset[1] = localYCos + localXSin;
        offset[2] = localXCos - localY2Sin;
        offset[3] = localY2Cos + localXSin;
        offset[4] = localX2Cos - localY2Sin;
        offset[5] = localY2Cos + localX2Sin;
        offset[6] = localX2Cos - localYSin;
        offset[7] = localYCos + localX2Sin;
        if (region.degrees == 90) {
            uvs[0] = region.u2;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v2;
            uvs[4] = region.u;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v;
        } else {
            uvs[0] = region.u;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v;
            uvs[4] = region.u2;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v2;
        }
    }
    /** Transforms the attachment's four vertices to world coordinates. If the attachment has a {@link #sequence}, the region may
     * be changed.
     * <p>
     * See <a href="http://esotericsoftware.com/spine-runtime-skeletons#World-transforms">World transforms</a> in the Spine
     * Runtimes Guide.
     * @param worldVertices The output world vertices. Must have a length >= <code>offset</code> + 8.
     * @param offset The <code>worldVertices</code> index to begin writing values.
     * @param stride The number of <code>worldVertices</code> entries between the value pairs written. */ computeWorldVertices(slot, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        let bone = slot.bone;
        let vertexOffset = this.offset;
        let x = bone.worldX, y = bone.worldY;
        let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
        let offsetX = 0, offsetY = 0;
        offsetX = vertexOffset[0];
        offsetY = vertexOffset[1];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // br
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[2];
        offsetY = vertexOffset[3];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // bl
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[4];
        offsetY = vertexOffset[5];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // ul
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[6];
        offsetY = vertexOffset[7];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // ur
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
    copy() {
        let copy = new $679f9e8a376fdb80$export$d0fc51466fa6d530(this.name, this.path);
        copy.region = this.region;
        copy.x = this.x;
        copy.y = this.y;
        copy.scaleX = this.scaleX;
        copy.scaleY = this.scaleY;
        copy.rotation = this.rotation;
        copy.width = this.width;
        copy.height = this.height;
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.uvs, 0, copy.uvs, 0, 8);
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(this.offset, 0, copy.offset, 0, 8);
        copy.color.setFromColor(this.color);
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        return copy;
    }
    static X1 = 0;
    static Y1 = 1;
    static C1R = 2;
    static C1G = 3;
    static C1B = 4;
    static C1A = 5;
    static U1 = 6;
    static V1 = 7;
    static X2 = 8;
    static Y2 = 9;
    static C2R = 10;
    static C2G = 11;
    static C2B = 12;
    static C2A = 13;
    static U2 = 14;
    static V2 = 15;
    static X3 = 16;
    static Y3 = 17;
    static C3R = 18;
    static C3G = 19;
    static C3B = 20;
    static C3A = 21;
    static U3 = 22;
    static V3 = 23;
    static X4 = 24;
    static Y4 = 25;
    static C4R = 26;
    static C4G = 27;
    static C4B = 28;
    static C4A = 29;
    static U4 = 30;
    static V4 = 31;
}


class $d71b67a3201597e7$export$2ff9add835475d95 {
    atlas;
    constructor(atlas){
        this.atlas = atlas;
    }
    loadSequence(name, basePath, sequence) {
        let regions = sequence.regions;
        for(let i = 0, n = regions.length; i < n; i++){
            let path = sequence.getPath(basePath, i);
            let region = this.atlas.findRegion(path);
            if (region == null) throw new Error("Region not found in atlas: " + path + " (sequence: " + name + ")");
            regions[i] = region;
        }
    }
    newRegionAttachment(skin, name, path, sequence) {
        let attachment = new (0, $679f9e8a376fdb80$export$d0fc51466fa6d530)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            let region = this.atlas.findRegion(path);
            if (!region) throw new Error("Region not found in atlas: " + path + " (region attachment: " + name + ")");
            attachment.region = region;
        }
        return attachment;
    }
    newMeshAttachment(skin, name, path, sequence) {
        let attachment = new (0, $06d16b10b33d165a$export$3f1c1692adfcf3e2)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            let region = this.atlas.findRegion(path);
            if (!region) throw new Error("Region not found in atlas: " + path + " (mesh attachment: " + name + ")");
            attachment.region = region;
        }
        return attachment;
    }
    newBoundingBoxAttachment(skin, name) {
        return new (0, $fbef049ae3c3cd60$export$9538c439c6b85ad2)(name);
    }
    newPathAttachment(skin, name) {
        return new (0, $a01103cd4726e79d$export$d285e3ec07b32800)(name);
    }
    newPointAttachment(skin, name) {
        return new (0, $7a958dd3474c5a1d$export$1b528cde44a6ab5)(name);
    }
    newClippingAttachment(skin, name) {
        return new (0, $ee64e63dbd5e17c9$export$838805e22b9b55f1)(name);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $9299f15fee0c3520$export$7d85d96cf093e12f {
    /** The index of the bone in {@link Skeleton#getBones()}. */ index = 0;
    /** The name of the bone, which is unique across all bones in the skeleton. */ name;
    /** @returns May be null. */ parent = null;
    /** The bone's length. */ length = 0;
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local rotation in degrees, counter clockwise. */ rotation = 0;
    /** The local scaleX. */ scaleX = 1;
    /** The local scaleY. */ scaleY = 1;
    /** The local shearX. */ shearX = 0;
    /** The local shearX. */ shearY = 0;
    /** The transform mode for how parent world transforms affect this bone. */ inherit = $9299f15fee0c3520$export$90bfc659784fb526.Normal;
    /** When true, {@link Skeleton#updateWorldTransform()} only updates this bone if the {@link Skeleton#skin} contains this
      * bone.
      * @see Skin#bones */ skinRequired = false;
    /** The color of the bone as it was in Spine. Available only when nonessential data was exported. Bones are not usually
     * rendered at runtime. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    /** The bone icon as it was in Spine, or null if nonessential data was not exported. */ icon;
    /** False if the bone was hidden in Spine and nonessential data was exported. Does not affect runtime rendering. */ visible = false;
    constructor(index, name, parent){
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        this.index = index;
        this.name = name;
        this.parent = parent;
    }
}
var $9299f15fee0c3520$export$90bfc659784fb526;
(function(Inherit) {
    Inherit[Inherit["Normal"] = 0] = "Normal";
    Inherit[Inherit["OnlyTranslation"] = 1] = "OnlyTranslation";
    Inherit[Inherit["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
    Inherit[Inherit["NoScale"] = 3] = "NoScale";
    Inherit[Inherit["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
})($9299f15fee0c3520$export$90bfc659784fb526 || ($9299f15fee0c3520$export$90bfc659784fb526 = {}));



class $11d84caa84dff789$export$b127726e56765aa4 {
    /** The bone's setup pose data. */ data;
    /** The skeleton this bone belongs to. */ skeleton;
    /** The parent bone, or null if this is the root bone. */ parent = null;
    /** The immediate children of this bone. */ children = new Array();
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local rotation in degrees, counter clockwise. */ rotation = 0;
    /** The local scaleX. */ scaleX = 0;
    /** The local scaleY. */ scaleY = 0;
    /** The local shearX. */ shearX = 0;
    /** The local shearY. */ shearY = 0;
    /** The applied local x translation. */ ax = 0;
    /** The applied local y translation. */ ay = 0;
    /** The applied local rotation in degrees, counter clockwise. */ arotation = 0;
    /** The applied local scaleX. */ ascaleX = 0;
    /** The applied local scaleY. */ ascaleY = 0;
    /** The applied local shearX. */ ashearX = 0;
    /** The applied local shearY. */ ashearY = 0;
    /** Part of the world transform matrix for the X axis. If changed, {@link #updateAppliedTransform()} should be called. */ a = 0;
    /** Part of the world transform matrix for the Y axis. If changed, {@link #updateAppliedTransform()} should be called. */ b = 0;
    /** Part of the world transform matrix for the X axis. If changed, {@link #updateAppliedTransform()} should be called. */ c = 0;
    /** Part of the world transform matrix for the Y axis. If changed, {@link #updateAppliedTransform()} should be called. */ d = 0;
    /** The world X position. If changed, {@link #updateAppliedTransform()} should be called. */ worldY = 0;
    /** The world Y position. If changed, {@link #updateAppliedTransform()} should be called. */ worldX = 0;
    inherit = (0, $9299f15fee0c3520$export$90bfc659784fb526).Normal;
    sorted = false;
    active = false;
    /** @param parent May be null. */ constructor(data, skeleton, parent){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.skeleton = skeleton;
        this.parent = parent;
        this.setToSetupPose();
    }
    /** Returns false when the bone has not been computed because {@link BoneData#skinRequired} is true and the
      * {@link Skeleton#skin active skin} does not {@link Skin#bones contain} this bone. */ isActive() {
        return this.active;
    }
    /** Computes the world transform using the parent bone and this bone's local applied transform. */ update(physics) {
        this.updateWorldTransformWith(this.ax, this.ay, this.arotation, this.ascaleX, this.ascaleY, this.ashearX, this.ashearY);
    }
    /** Computes the world transform using the parent bone and this bone's local transform.
     *
     * See {@link #updateWorldTransformWith()}. */ updateWorldTransform() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and the specified local transform. The applied transform is set to the
     * specified local transform. Child bones are not updated.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide. */ updateWorldTransformWith(x, y, rotation, scaleX, scaleY, shearX, shearY) {
        this.ax = x;
        this.ay = y;
        this.arotation = rotation;
        this.ascaleX = scaleX;
        this.ascaleY = scaleY;
        this.ashearX = shearX;
        this.ashearY = shearY;
        let parent = this.parent;
        if (!parent) {
            let skeleton = this.skeleton;
            const sx = skeleton.scaleX, sy = skeleton.scaleY;
            const rx = (rotation + shearX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
            const ry = (rotation + 90 + shearY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
            this.a = Math.cos(rx) * scaleX * sx;
            this.b = Math.cos(ry) * scaleY * sx;
            this.c = Math.sin(rx) * scaleX * sy;
            this.d = Math.sin(ry) * scaleY * sy;
            this.worldX = x * sx + skeleton.x;
            this.worldY = y * sy + skeleton.y;
            return;
        }
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        this.worldX = pa * x + pb * y + parent.worldX;
        this.worldY = pc * x + pd * y + parent.worldY;
        switch(this.inherit){
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).Normal:
                {
                    const rx = (rotation + shearX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const ry = (rotation + 90 + shearY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const la = Math.cos(rx) * scaleX;
                    const lb = Math.cos(ry) * scaleY;
                    const lc = Math.sin(rx) * scaleX;
                    const ld = Math.sin(ry) * scaleY;
                    this.a = pa * la + pb * lc;
                    this.b = pa * lb + pb * ld;
                    this.c = pc * la + pd * lc;
                    this.d = pc * lb + pd * ld;
                    return;
                }
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).OnlyTranslation:
                {
                    const rx = (rotation + shearX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const ry = (rotation + 90 + shearY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    this.a = Math.cos(rx) * scaleX;
                    this.b = Math.cos(ry) * scaleY;
                    this.c = Math.sin(rx) * scaleX;
                    this.d = Math.sin(ry) * scaleY;
                    break;
                }
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoRotationOrReflection:
                {
                    let sx = 1 / this.skeleton.scaleX, sy = 1 / this.skeleton.scaleY;
                    pa *= sx;
                    pc *= sy;
                    let s = pa * pa + pc * pc;
                    let prx = 0;
                    if (s > 0.0001) {
                        s = Math.abs(pa * pd * sy - pb * sx * pc) / s;
                        pb = pc * s;
                        pd = pa * s;
                        prx = Math.atan2(pc, pa) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
                    } else {
                        pa = 0;
                        pc = 0;
                        prx = 90 - Math.atan2(pd, pb) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
                    }
                    const rx = (rotation + shearX - prx) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const ry = (rotation + shearY - prx + 90) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const la = Math.cos(rx) * scaleX;
                    const lb = Math.cos(ry) * scaleY;
                    const lc = Math.sin(rx) * scaleX;
                    const ld = Math.sin(ry) * scaleY;
                    this.a = pa * la - pb * lc;
                    this.b = pa * lb - pb * ld;
                    this.c = pc * la + pd * lc;
                    this.d = pc * lb + pd * ld;
                    break;
                }
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScale:
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScaleOrReflection:
                {
                    rotation *= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const cos = Math.cos(rotation), sin = Math.sin(rotation);
                    let za = (pa * cos + pb * sin) / this.skeleton.scaleX;
                    let zc = (pc * cos + pd * sin) / this.skeleton.scaleY;
                    let s = Math.sqrt(za * za + zc * zc);
                    if (s > 0.00001) s = 1 / s;
                    za *= s;
                    zc *= s;
                    s = Math.sqrt(za * za + zc * zc);
                    if (this.inherit == (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScale && pa * pd - pb * pc < 0 != (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    rotation = Math.PI / 2 + Math.atan2(zc, za);
                    const zb = Math.cos(rotation) * s;
                    const zd = Math.sin(rotation) * s;
                    shearX *= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    shearY = (90 + shearY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
                    const la = Math.cos(shearX) * scaleX;
                    const lb = Math.cos(shearY) * scaleY;
                    const lc = Math.sin(shearX) * scaleX;
                    const ld = Math.sin(shearY) * scaleY;
                    this.a = za * la + zb * lc;
                    this.b = za * lb + zb * ld;
                    this.c = zc * la + zd * lc;
                    this.d = zc * lb + zd * ld;
                    break;
                }
        }
        this.a *= this.skeleton.scaleX;
        this.b *= this.skeleton.scaleX;
        this.c *= this.skeleton.scaleY;
        this.d *= this.skeleton.scaleY;
    }
    /** Sets this bone's local transform to the setup pose. */ setToSetupPose() {
        let data = this.data;
        this.x = data.x;
        this.y = data.y;
        this.rotation = data.rotation;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.shearX = data.shearX;
        this.shearY = data.shearY;
        this.inherit = data.inherit;
    }
    /** Computes the applied transform values from the world transform.
     *
     * If the world transform is modified (by a constraint, {@link #rotateWorld(float)}, etc) then this method should be called so
     * the applied transform matches the world transform. The applied transform may be needed by other code (eg to apply other
     * constraints).
     *
     * Some information is ambiguous in the world transform, such as -1,-1 scale versus 180 rotation. The applied transform after
     * calling this method is equivalent to the local transform used to compute the world transform, but may not be identical. */ updateAppliedTransform() {
        let parent = this.parent;
        if (!parent) {
            this.ax = this.worldX - this.skeleton.x;
            this.ay = this.worldY - this.skeleton.y;
            this.arotation = Math.atan2(this.c, this.a) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
            this.ascaleX = Math.sqrt(this.a * this.a + this.c * this.c);
            this.ascaleY = Math.sqrt(this.b * this.b + this.d * this.d);
            this.ashearX = 0;
            this.ashearY = Math.atan2(this.a * this.b + this.c * this.d, this.a * this.d - this.b * this.c) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
            return;
        }
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        let pid = 1 / (pa * pd - pb * pc);
        let ia = pd * pid, ib = pb * pid, ic = pc * pid, id = pa * pid;
        let dx = this.worldX - parent.worldX, dy = this.worldY - parent.worldY;
        this.ax = dx * ia - dy * ib;
        this.ay = dy * id - dx * ic;
        let ra, rb, rc, rd;
        if (this.inherit == (0, $9299f15fee0c3520$export$90bfc659784fb526).OnlyTranslation) {
            ra = this.a;
            rb = this.b;
            rc = this.c;
            rd = this.d;
        } else {
            switch(this.inherit){
                case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoRotationOrReflection:
                    {
                        let s = Math.abs(pa * pd - pb * pc) / (pa * pa + pc * pc);
                        pb = -pc * this.skeleton.scaleX * s / this.skeleton.scaleY;
                        pd = pa * this.skeleton.scaleY * s / this.skeleton.scaleX;
                        pid = 1 / (pa * pd - pb * pc);
                        ia = pd * pid;
                        ib = pb * pid;
                        break;
                    }
                case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScale:
                case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScaleOrReflection:
                    let cos = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).cosDeg(this.rotation), sin = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).sinDeg(this.rotation);
                    pa = (pa * cos + pb * sin) / this.skeleton.scaleX;
                    pc = (pc * cos + pd * sin) / this.skeleton.scaleY;
                    let s = Math.sqrt(pa * pa + pc * pc);
                    if (s > 0.00001) s = 1 / s;
                    pa *= s;
                    pc *= s;
                    s = Math.sqrt(pa * pa + pc * pc);
                    if (this.inherit == (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScale && pid < 0 != (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    let r = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI / 2 + Math.atan2(pc, pa);
                    pb = Math.cos(r) * s;
                    pd = Math.sin(r) * s;
                    pid = 1 / (pa * pd - pb * pc);
                    ia = pd * pid;
                    ib = pb * pid;
                    ic = pc * pid;
                    id = pa * pid;
            }
            ra = ia * this.a - ib * this.c;
            rb = ia * this.b - ib * this.d;
            rc = id * this.c - ic * this.a;
            rd = id * this.d - ic * this.b;
        }
        this.ashearX = 0;
        this.ascaleX = Math.sqrt(ra * ra + rc * rc);
        if (this.ascaleX > 0.0001) {
            let det = ra * rd - rb * rc;
            this.ascaleY = det / this.ascaleX;
            this.ashearY = -Math.atan2(ra * rb + rc * rd, det) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
            this.arotation = Math.atan2(rc, ra) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
        } else {
            this.ascaleX = 0;
            this.ascaleY = Math.sqrt(rb * rb + rd * rd);
            this.ashearY = 0;
            this.arotation = 90 - Math.atan2(rd, rb) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
        }
    }
    /** The world rotation for the X axis, calculated using {@link #a} and {@link #c}. */ getWorldRotationX() {
        return Math.atan2(this.c, this.a) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
    }
    /** The world rotation for the Y axis, calculated using {@link #b} and {@link #d}. */ getWorldRotationY() {
        return Math.atan2(this.d, this.b) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
    }
    /** The magnitude (always positive) of the world scale X, calculated using {@link #a} and {@link #c}. */ getWorldScaleX() {
        return Math.sqrt(this.a * this.a + this.c * this.c);
    }
    /** The magnitude (always positive) of the world scale Y, calculated using {@link #b} and {@link #d}. */ getWorldScaleY() {
        return Math.sqrt(this.b * this.b + this.d * this.d);
    }
    /** Transforms a point from world coordinates to the bone's local coordinates. */ worldToLocal(world) {
        let invDet = 1 / (this.a * this.d - this.b * this.c);
        let x = world.x - this.worldX, y = world.y - this.worldY;
        world.x = x * this.d * invDet - y * this.b * invDet;
        world.y = y * this.a * invDet - x * this.c * invDet;
        return world;
    }
    /** Transforms a point from the bone's local coordinates to world coordinates. */ localToWorld(local) {
        let x = local.x, y = local.y;
        local.x = x * this.a + y * this.b + this.worldX;
        local.y = x * this.c + y * this.d + this.worldY;
        return local;
    }
    /** Transforms a point from world coordinates to the parent bone's local coordinates. */ worldToParent(world) {
        if (world == null) throw new Error("world cannot be null.");
        return this.parent == null ? world : this.parent.worldToLocal(world);
    }
    /** Transforms a point from the parent bone's coordinates to world coordinates. */ parentToWorld(world) {
        if (world == null) throw new Error("world cannot be null.");
        return this.parent == null ? world : this.parent.localToWorld(world);
    }
    /** Transforms a world rotation to a local rotation. */ worldToLocalRotation(worldRotation) {
        let sin = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).sinDeg(worldRotation), cos = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).cosDeg(worldRotation);
        return Math.atan2(this.a * sin - this.c * cos, this.d * cos - this.b * sin) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg + this.rotation - this.shearX;
    }
    /** Transforms a local rotation to a world rotation. */ localToWorldRotation(localRotation) {
        localRotation -= this.rotation - this.shearX;
        let sin = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).sinDeg(localRotation), cos = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).cosDeg(localRotation);
        return Math.atan2(cos * this.c + sin * this.d, cos * this.a + sin * this.b) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
    }
    /** Rotates the world transform the specified amount.
     * <p>
     * After changes are made to the world transform, {@link #updateAppliedTransform()} should be called and
     * {@link #update(Physics)} will need to be called on any child bones, recursively. */ rotateWorld(degrees) {
        degrees *= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        const sin = Math.sin(degrees), cos = Math.cos(degrees);
        const ra = this.a, rb = this.b;
        this.a = cos * ra - sin * this.c;
        this.b = cos * rb - sin * this.d;
        this.c = sin * ra + cos * this.c;
        this.d = sin * rb + cos * this.d;
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** The base class for all constraint datas. */ class $191911922628b8b6$export$b826e1ab3af63566 {
    name;
    order;
    skinRequired;
    constructor(name, order, skinRequired){
        this.name = name;
        this.order = order;
        this.skinRequired = skinRequired;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $fbef37d12788a5d6$export$d187693bfb349728 {
    pathPrefix = "";
    textureLoader;
    downloader;
    assets = {};
    errors = {};
    toLoad = 0;
    loaded = 0;
    constructor(textureLoader, pathPrefix = "", downloader = new $fbef37d12788a5d6$export$ef06e7620d37c296()){
        this.textureLoader = textureLoader;
        this.pathPrefix = pathPrefix;
        this.downloader = downloader;
    }
    start(path) {
        this.toLoad++;
        return this.pathPrefix + path;
    }
    success(callback, path, asset) {
        this.toLoad--;
        this.loaded++;
        this.assets[path] = asset;
        if (callback) callback(path, asset);
    }
    error(callback, path, message) {
        this.toLoad--;
        this.loaded++;
        this.errors[path] = message;
        if (callback) callback(path, message);
    }
    loadAll() {
        let promise = new Promise((resolve, reject)=>{
            let check = ()=>{
                if (this.isLoadingComplete()) {
                    if (this.hasErrors()) reject(this.errors);
                    else resolve(this);
                    return;
                }
                requestAnimationFrame(check);
            };
            requestAnimationFrame(check);
        });
        return promise;
    }
    setRawDataURI(path, data) {
        this.downloader.rawDataUris[this.pathPrefix + path] = data;
    }
    loadBinary(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadBinary(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load binary ${path}: status ${status}, ${responseText}`);
        });
    }
    loadText(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadText(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load text ${path}: status ${status}, ${responseText}`);
        });
    }
    loadJson(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadJson(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load JSON ${path}: status ${status}, ${responseText}`);
        });
    }
    loadTexture(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        let isBrowser = !!(typeof window !== "undefined" && typeof navigator !== "undefined" && window.document);
        let isWebWorker = !isBrowser; // && typeof importScripts !== 'undefined';
        if (isWebWorker) fetch(path, {
            mode: "cors"
        }).then((response)=>{
            if (response.ok) return response.blob();
            this.error(error, path, `Couldn't load image: ${path}`);
            return null;
        }).then((blob)=>{
            return blob ? createImageBitmap(blob, {
                premultiplyAlpha: "none",
                colorSpaceConversion: "none"
            }) : null;
        }).then((bitmap)=>{
            if (bitmap) this.success(success, path, this.textureLoader(bitmap));
        });
        else {
            let image = new Image();
            image.crossOrigin = "anonymous";
            image.onload = ()=>{
                this.success(success, path, this.textureLoader(image));
            };
            image.onerror = ()=>{
                this.error(error, path, `Couldn't load image: ${path}`);
            };
            if (this.downloader.rawDataUris[path]) path = this.downloader.rawDataUris[path];
            image.src = path;
        }
    }
    loadTextureAtlas(path, success = ()=>{}, error = ()=>{}, fileAlias) {
        let index = path.lastIndexOf("/");
        let parent = index >= 0 ? path.substring(0, index + 1) : "";
        path = this.start(path);
        this.downloader.downloadText(path, (atlasText)=>{
            try {
                let atlas = new (0, $d78fcde22e89ce53$export$1ffc3159823e6649)(atlasText);
                let toLoad = atlas.pages.length, abort = false;
                for (let page of atlas.pages)this.loadTexture(!fileAlias ? parent + page.name : fileAlias[page.name], (imagePath, texture)=>{
                    if (!abort) {
                        page.setTexture(texture);
                        if (--toLoad == 0) this.success(success, path, atlas);
                    }
                }, (imagePath, message)=>{
                    if (!abort) this.error(error, path, `Couldn't load texture atlas ${path} page image: ${imagePath}`);
                    abort = true;
                });
            } catch (e) {
                this.error(error, path, `Couldn't parse texture atlas ${path}: ${e.message}`);
            }
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load texture atlas ${path}: status ${status}, ${responseText}`);
        });
    }
    get(path) {
        return this.assets[this.pathPrefix + path];
    }
    require(path) {
        path = this.pathPrefix + path;
        let asset = this.assets[path];
        if (asset) return asset;
        let error = this.errors[path];
        throw Error("Asset not found: " + path + (error ? "\n" + error : ""));
    }
    remove(path) {
        path = this.pathPrefix + path;
        let asset = this.assets[path];
        if (asset.dispose) asset.dispose();
        delete this.assets[path];
        return asset;
    }
    removeAll() {
        for(let key in this.assets){
            let asset = this.assets[key];
            if (asset.dispose) asset.dispose();
        }
        this.assets = {};
    }
    isLoadingComplete() {
        return this.toLoad == 0;
    }
    getToLoad() {
        return this.toLoad;
    }
    getLoaded() {
        return this.loaded;
    }
    dispose() {
        this.removeAll();
    }
    hasErrors() {
        return Object.keys(this.errors).length > 0;
    }
    getErrors() {
        return this.errors;
    }
}
class $fbef37d12788a5d6$export$ef06e7620d37c296 {
    callbacks = {};
    rawDataUris = {};
    dataUriToString(dataUri) {
        if (!dataUri.startsWith("data:")) throw new Error("Not a data URI.");
        let base64Idx = dataUri.indexOf("base64,");
        if (base64Idx != -1) {
            base64Idx += 7;
            return atob(dataUri.substr(base64Idx));
        } else return dataUri.substr(dataUri.indexOf(",") + 1);
    }
    base64ToUint8Array(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for(var i = 0; i < len; i++)bytes[i] = binary_string.charCodeAt(i);
        return bytes;
    }
    dataUriToUint8Array(dataUri) {
        if (!dataUri.startsWith("data:")) throw new Error("Not a data URI.");
        let base64Idx = dataUri.indexOf("base64,");
        if (base64Idx == -1) throw new Error("Not a binary data URI.");
        base64Idx += 7;
        return this.base64ToUint8Array(dataUri.substr(base64Idx));
    }
    downloadText(url, success, error) {
        if (this.start(url, success, error)) return;
        if (this.rawDataUris[url]) {
            try {
                let dataUri = this.rawDataUris[url];
                this.finish(url, 200, this.dataUriToString(dataUri));
            } catch (e) {
                this.finish(url, 400, JSON.stringify(e));
            }
            return;
        }
        let request = new XMLHttpRequest();
        request.overrideMimeType("text/html");
        request.open("GET", url, true);
        let done = ()=>{
            this.finish(url, request.status, request.responseText);
        };
        request.onload = done;
        request.onerror = done;
        request.send();
    }
    downloadJson(url, success, error) {
        this.downloadText(url, (data)=>{
            success(JSON.parse(data));
        }, error);
    }
    downloadBinary(url, success, error) {
        if (this.start(url, success, error)) return;
        if (this.rawDataUris[url]) {
            try {
                let dataUri = this.rawDataUris[url];
                this.finish(url, 200, this.dataUriToUint8Array(dataUri));
            } catch (e) {
                this.finish(url, 400, JSON.stringify(e));
            }
            return;
        }
        let request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        let onerror = ()=>{
            this.finish(url, request.status, request.response);
        };
        request.onload = ()=>{
            if (request.status == 200 || request.status == 0) this.finish(url, 200, new Uint8Array(request.response));
            else onerror();
        };
        request.onerror = onerror;
        request.send();
    }
    start(url, success, error) {
        let callbacks = this.callbacks[url];
        try {
            if (callbacks) return true;
            this.callbacks[url] = callbacks = [];
        } finally{
            callbacks.push(success, error);
        }
    }
    finish(url, status, data) {
        let callbacks = this.callbacks[url];
        delete this.callbacks[url];
        let args = status == 200 || status == 0 ? [
            data
        ] : [
            status,
            data
        ];
        for(let i = args.length - 1, n = callbacks.length; i < n; i += 2)callbacks[i].apply(null, args);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the current pose values for an {@link Event}.
 *
 * See Timeline {@link Timeline#apply()},
 * AnimationStateListener {@link AnimationStateListener#event()}, and
 * [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */ class $38575b550a322281$export$d61e24a684f9e51 {
    data;
    intValue = 0;
    floatValue = 0;
    stringValue = null;
    time = 0;
    volume = 0;
    balance = 0;
    constructor(time, data){
        if (!data) throw new Error("data cannot be null.");
        this.time = time;
        this.data = data;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the setup pose values for an {@link Event}.
 *
 * See [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */ class $8ced6bc62a0114c6$export$a5cf049e34c3d11e {
    name;
    intValue = 0;
    floatValue = 0;
    stringValue = null;
    audioPath = null;
    volume = 0;
    balance = 0;
    constructor(name){
        this.name = name;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $7f29795da1138367$export$3c158c80ff28c177 {
    /** The IK constraint's setup pose data. */ data;
    /** The bones that will be modified by this IK constraint. */ bones;
    /** The bone that is the IK target. */ target;
    /** Controls the bend direction of the IK bones, either 1 or -1. */ bendDirection = 0;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ stretch = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ mix = 1;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ softness = 0;
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}`);
            this.bones.push(bone);
        }
        let target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find bone ${data.target.name}`);
        this.target = target;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
    }
    isActive() {
        return this.active;
    }
    setToSetupPose() {
        const data = this.data;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
    }
    update(physics) {
        if (this.mix == 0) return;
        let target = this.target;
        let bones = this.bones;
        switch(bones.length){
            case 1:
                this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                break;
            case 2:
                this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.data.uniform, this.softness, this.mix);
                break;
        }
    }
    /** Applies 1 bone IK. The target is specified in the world coordinate system. */ apply1(bone, targetX, targetY, compress, stretch, uniform, alpha) {
        let p = bone.parent;
        if (!p) throw new Error("IK bone must have parent.");
        let pa = p.a, pb = p.b, pc = p.c, pd = p.d;
        let rotationIK = -bone.ashearX - bone.arotation, tx = 0, ty = 0;
        switch(bone.inherit){
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).OnlyTranslation:
                tx = (targetX - bone.worldX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(bone.skeleton.scaleX);
                ty = (targetY - bone.worldY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).signum(bone.skeleton.scaleY);
                break;
            case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoRotationOrReflection:
                let s = Math.abs(pa * pd - pb * pc) / Math.max(0.0001, pa * pa + pc * pc);
                let sa = pa / bone.skeleton.scaleX;
                let sc = pc / bone.skeleton.scaleY;
                pb = -sc * s * bone.skeleton.scaleX;
                pd = sa * s * bone.skeleton.scaleY;
                rotationIK += Math.atan2(sc, sa) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
            // Fall through
            default:
                let x = targetX - p.worldX, y = targetY - p.worldY;
                let d = pa * pd - pb * pc;
                if (Math.abs(d) <= 0.0001) {
                    tx = 0;
                    ty = 0;
                } else {
                    tx = (x * pd - y * pb) / d - bone.ax;
                    ty = (y * pa - x * pc) / d - bone.ay;
                }
        }
        rotationIK += Math.atan2(ty, tx) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg;
        if (bone.ascaleX < 0) rotationIK += 180;
        if (rotationIK > 180) rotationIK -= 360;
        else if (rotationIK < -180) rotationIK += 360;
        let sx = bone.ascaleX, sy = bone.ascaleY;
        if (compress || stretch) {
            switch(bone.inherit){
                case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScale:
                case (0, $9299f15fee0c3520$export$90bfc659784fb526).NoScaleOrReflection:
                    tx = targetX - bone.worldX;
                    ty = targetY - bone.worldY;
            }
            const b = bone.data.length * sx;
            if (b > 0.0001) {
                const dd = tx * tx + ty * ty;
                if (compress && dd < b * b || stretch && dd > b * b) {
                    const s = (Math.sqrt(dd) / b - 1) * alpha + 1;
                    sx *= s;
                    if (uniform) sy *= s;
                }
            }
        }
        bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
    }
    /** Applies 2 bone IK. The target is specified in the world coordinate system.
     * @param child A direct descendant of the parent bone. */ apply2(parent, child, targetX, targetY, bendDir, stretch, uniform, softness, alpha) {
        if (parent.inherit != (0, $9299f15fee0c3520$export$90bfc659784fb526).Normal || child.inherit != (0, $9299f15fee0c3520$export$90bfc659784fb526).Normal) return;
        let px = parent.ax, py = parent.ay, psx = parent.ascaleX, psy = parent.ascaleY, sx = psx, sy = psy, csx = child.ascaleX;
        let os1 = 0, os2 = 0, s2 = 0;
        if (psx < 0) {
            psx = -psx;
            os1 = 180;
            s2 = -1;
        } else {
            os1 = 0;
            s2 = 1;
        }
        if (psy < 0) {
            psy = -psy;
            s2 = -s2;
        }
        if (csx < 0) {
            csx = -csx;
            os2 = 180;
        } else os2 = 0;
        let cx = child.ax, cy = 0, cwx = 0, cwy = 0, a = parent.a, b = parent.b, c = parent.c, d = parent.d;
        let u = Math.abs(psx - psy) <= 0.0001;
        if (!u || stretch) {
            cy = 0;
            cwx = a * cx + parent.worldX;
            cwy = c * cx + parent.worldY;
        } else {
            cy = child.ay;
            cwx = a * cx + b * cy + parent.worldX;
            cwy = c * cx + d * cy + parent.worldY;
        }
        let pp = parent.parent;
        if (!pp) throw new Error("IK parent must itself have a parent.");
        a = pp.a;
        b = pp.b;
        c = pp.c;
        d = pp.d;
        let id = a * d - b * c, x = cwx - pp.worldX, y = cwy - pp.worldY;
        id = Math.abs(id) <= 0.0001 ? 0 : 1 / id;
        let dx = (x * d - y * b) * id - px, dy = (y * a - x * c) * id - py;
        let l1 = Math.sqrt(dx * dx + dy * dy), l2 = child.data.length * csx, a1, a2;
        if (l1 < 0.0001) {
            this.apply1(parent, targetX, targetY, false, stretch, false, alpha);
            child.updateWorldTransformWith(cx, cy, 0, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
            return;
        }
        x = targetX - pp.worldX;
        y = targetY - pp.worldY;
        let tx = (x * d - y * b) * id - px, ty = (y * a - x * c) * id - py;
        let dd = tx * tx + ty * ty;
        if (softness != 0) {
            softness *= psx * (csx + 1) * 0.5;
            let td = Math.sqrt(dd), sd = td - l1 - l2 * psx + softness;
            if (sd > 0) {
                let p = Math.min(1, sd / (softness * 2)) - 1;
                p = (sd - softness * (1 - p * p)) / td;
                tx -= p * tx;
                ty -= p * ty;
                dd = tx * tx + ty * ty;
            }
        }
        outer: if (u) {
            l2 *= psx;
            let cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
            if (cos < -1) {
                cos = -1;
                a2 = Math.PI * bendDir;
            } else if (cos > 1) {
                cos = 1;
                a2 = 0;
                if (stretch) {
                    a = (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
                    sx *= a;
                    if (uniform) sy *= a;
                }
            } else a2 = Math.acos(cos) * bendDir;
            a = l1 + l2 * cos;
            b = l2 * Math.sin(a2);
            a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
        } else {
            a = psx * l2;
            b = psy * l2;
            let aa = a * a, bb = b * b, ta = Math.atan2(ty, tx);
            c = bb * l1 * l1 + aa * dd - aa * bb;
            let c1 = -2 * bb * l1, c2 = bb - aa;
            d = c1 * c1 - 4 * c2 * c;
            if (d >= 0) {
                let q = Math.sqrt(d);
                if (c1 < 0) q = -q;
                q = -(c1 + q) * 0.5;
                let r0 = q / c2, r1 = c / q;
                let r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                r0 = dd - r * r;
                if (r0 >= 0) {
                    y = Math.sqrt(r0) * bendDir;
                    a1 = ta - Math.atan2(y, r);
                    a2 = Math.atan2(y / psy, (r - l1) / psx);
                    break outer;
                }
            }
            let minAngle = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI, minX = l1 - a, minDist = minX * minX, minY = 0;
            let maxAngle = 0, maxX = l1 + a, maxDist = maxX * maxX, maxY = 0;
            c = -a * l1 / (aa - bb);
            if (c >= -1 && c <= 1) {
                c = Math.acos(c);
                x = a * Math.cos(c) + l1;
                y = b * Math.sin(c);
                d = x * x + y * y;
                if (d < minDist) {
                    minAngle = c;
                    minDist = d;
                    minX = x;
                    minY = y;
                }
                if (d > maxDist) {
                    maxAngle = c;
                    maxDist = d;
                    maxX = x;
                    maxY = y;
                }
            }
            if (dd <= (minDist + maxDist) * 0.5) {
                a1 = ta - Math.atan2(minY * bendDir, minX);
                a2 = minAngle * bendDir;
            } else {
                a1 = ta - Math.atan2(maxY * bendDir, maxX);
                a2 = maxAngle * bendDir;
            }
        }
        let os = Math.atan2(cy, cx) * s2;
        let rotation = parent.arotation;
        a1 = (a1 - os) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg + os1 - rotation;
        if (a1 > 180) a1 -= 360;
        else if (a1 < -180) a1 += 360;
        parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, sy, 0, 0);
        rotation = child.arotation;
        a2 = ((a2 + os) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).radDeg - child.ashearX) * s2 + os2 - rotation;
        if (a2 > 180) a2 -= 360;
        else if (a2 < -180) a2 += 360;
        child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $3262faf56c73da02$export$adcb08b651fc712e extends (0, $191911922628b8b6$export$b826e1ab3af63566) {
    /** The bones that are constrained by this IK constraint. */ bones = new Array();
    /** The bone that is the IK target. */ _target = null;
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
    /** Controls the bend direction of the IK bones, either 1 or -1. */ bendDirection = 0;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ stretch = false;
    /** When true, only a single bone is being constrained, and {@link #getCompress()} or {@link #getStretch()} is used, the bone
     * is scaled on both the X and Y axes. */ uniform = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ mix = 0;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ softness = 0;
    constructor(name){
        super(name, 0, false);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $df278a6379229a7a$export$d2629ab80d5dd5ba extends (0, $191911922628b8b6$export$b826e1ab3af63566) {
    /** The bones that will be modified by this path constraint. */ bones = new Array();
    /** The slot whose path attachment will be used to constrained the bones. */ _target = null;
    set target(slotData) {
        this._target = slotData;
    }
    get target() {
        if (!this._target) throw new Error("SlotData not set.");
        else return this._target;
    }
    /** The mode for positioning the first bone on the path. */ positionMode = $df278a6379229a7a$export$34d637c671e1e906.Fixed;
    /** The mode for positioning the bones after the first bone on the path. */ spacingMode = $df278a6379229a7a$export$34ce760ad2b0be4b.Fixed;
    /** The mode for adjusting the rotation of the bones. */ rotateMode = $df278a6379229a7a$export$a2a23846581ac82c.Chain;
    /** An offset added to the constrained bone rotation. */ offsetRotation = 0;
    /** The position along the path. */ position = 0;
    /** The spacing between bones. */ spacing = 0;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    constructor(name){
        super(name, 0, false);
    }
}
var $df278a6379229a7a$export$34d637c671e1e906;
(function(PositionMode) {
    PositionMode[PositionMode["Fixed"] = 0] = "Fixed";
    PositionMode[PositionMode["Percent"] = 1] = "Percent";
})($df278a6379229a7a$export$34d637c671e1e906 || ($df278a6379229a7a$export$34d637c671e1e906 = {}));
var $df278a6379229a7a$export$34ce760ad2b0be4b;
(function(SpacingMode) {
    SpacingMode[SpacingMode["Length"] = 0] = "Length";
    SpacingMode[SpacingMode["Fixed"] = 1] = "Fixed";
    SpacingMode[SpacingMode["Percent"] = 2] = "Percent";
    SpacingMode[SpacingMode["Proportional"] = 3] = "Proportional";
})($df278a6379229a7a$export$34ce760ad2b0be4b || ($df278a6379229a7a$export$34ce760ad2b0be4b = {}));
var $df278a6379229a7a$export$a2a23846581ac82c;
(function(RotateMode) {
    RotateMode[RotateMode["Tangent"] = 0] = "Tangent";
    RotateMode[RotateMode["Chain"] = 1] = "Chain";
    RotateMode[RotateMode["ChainScale"] = 2] = "ChainScale";
})($df278a6379229a7a$export$a2a23846581ac82c || ($df278a6379229a7a$export$a2a23846581ac82c = {}));



class $39e6475bde8cfeed$export$cb4f92fb0c018828 {
    static NONE = -1;
    static BEFORE = -2;
    static AFTER = -3;
    static epsilon = 0.00001;
    /** The path constraint's setup pose data. */ data;
    /** The bones that will be modified by this path constraint. */ bones;
    /** The slot whose path attachment will be used to constrained the bones. */ target;
    /** The position along the path. */ position = 0;
    /** The spacing between bones. */ spacing = 0;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    spaces = new Array();
    positions = new Array();
    world = new Array();
    curves = new Array();
    lengths = new Array();
    segments = new Array();
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0, n = data.bones.length; i < n; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        let target = skeleton.findSlot(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}`);
        this.target = target;
        this.position = data.position;
        this.spacing = data.spacing;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
    }
    isActive() {
        return this.active;
    }
    setToSetupPose() {
        const data = this.data;
        this.position = data.position;
        this.spacing = data.spacing;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
    }
    update(physics) {
        let attachment = this.target.getAttachment();
        if (!(attachment instanceof (0, $a01103cd4726e79d$export$d285e3ec07b32800))) return;
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY;
        if (mixRotate == 0 && mixX == 0 && mixY == 0) return;
        let data = this.data;
        let tangents = data.rotateMode == (0, $df278a6379229a7a$export$a2a23846581ac82c).Tangent, scale = data.rotateMode == (0, $df278a6379229a7a$export$a2a23846581ac82c).ChainScale;
        let bones = this.bones;
        let boneCount = bones.length, spacesCount = tangents ? boneCount : boneCount + 1;
        let spaces = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.spaces, spacesCount), lengths = scale ? this.lengths = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.lengths, boneCount) : [];
        let spacing = this.spacing;
        switch(data.spacingMode){
            case (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Percent:
                if (scale) for(let i = 0, n = spacesCount - 1; i < n; i++){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    let x = setupLength * bone.a, y = setupLength * bone.c;
                    lengths[i] = Math.sqrt(x * x + y * y);
                }
                (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayFill(spaces, 1, spacesCount, spacing);
                break;
            case (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Proportional:
                let sum = 0;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $39e6475bde8cfeed$export$cb4f92fb0c018828.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        let length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = length;
                        sum += length;
                    }
                }
                if (sum > 0) {
                    sum = spacesCount / sum * spacing;
                    for(let i = 1; i < spacesCount; i++)spaces[i] *= sum;
                }
                break;
            default:
                let lengthSpacing = data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Length;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $39e6475bde8cfeed$export$cb4f92fb0c018828.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        let length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length / setupLength;
                    }
                }
        }
        let positions = this.computeWorldPositions(attachment, spacesCount, tangents);
        let boneX = positions[0], boneY = positions[1], offsetRotation = data.offsetRotation;
        let tip = false;
        if (offsetRotation == 0) tip = data.rotateMode == (0, $df278a6379229a7a$export$a2a23846581ac82c).Chain;
        else {
            tip = false;
            let p = this.target.bone;
            offsetRotation *= p.a * p.d - p.b * p.c > 0 ? (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad : -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        }
        for(let i = 0, p = 3; i < boneCount; i++, p += 3){
            let bone = bones[i];
            bone.worldX += (boneX - bone.worldX) * mixX;
            bone.worldY += (boneY - bone.worldY) * mixY;
            let x = positions[p], y = positions[p + 1], dx = x - boneX, dy = y - boneY;
            if (scale) {
                let length = lengths[i];
                if (length != 0) {
                    let s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * mixRotate + 1;
                    bone.a *= s;
                    bone.c *= s;
                }
            }
            boneX = x;
            boneY = y;
            if (mixRotate > 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d, r = 0, cos = 0, sin = 0;
                if (tangents) r = positions[p - 1];
                else if (spaces[i + 1] == 0) r = positions[p + 2];
                else r = Math.atan2(dy, dx);
                r -= Math.atan2(c, a);
                if (tip) {
                    cos = Math.cos(r);
                    sin = Math.sin(r);
                    let length = bone.data.length;
                    boneX += (length * (cos * a - sin * c) - dx) * mixRotate;
                    boneY += (length * (sin * a + cos * c) - dy) * mixRotate;
                } else r += offsetRotation;
                if (r > (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r -= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r += (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                cos = Math.cos(r);
                sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            bone.updateAppliedTransform();
        }
    }
    computeWorldPositions(path, spacesCount, tangents) {
        let target = this.target;
        let position = this.position;
        let spaces = this.spaces, out = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.positions, spacesCount * 3 + 2), world = this.world;
        let closed = path.closed;
        let verticesLength = path.worldVerticesLength, curveCount = verticesLength / 6, prevCurve = $39e6475bde8cfeed$export$cb4f92fb0c018828.NONE;
        if (!path.constantSpeed) {
            let lengths = path.lengths;
            curveCount -= closed ? 1 : 2;
            let pathLength = lengths[curveCount];
            if (this.data.positionMode == (0, $df278a6379229a7a$export$34d637c671e1e906).Percent) position *= pathLength;
            let multiplier;
            switch(this.data.spacingMode){
                case (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Percent:
                    multiplier = pathLength;
                    break;
                case (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Proportional:
                    multiplier = pathLength / spacesCount;
                    break;
                default:
                    multiplier = 1;
            }
            world = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.world, 8);
            for(let i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3){
                let space = spaces[i] * multiplier;
                position += space;
                let p = position;
                if (closed) {
                    p %= pathLength;
                    if (p < 0) p += pathLength;
                    curve = 0;
                } else if (p < 0) {
                    if (prevCurve != $39e6475bde8cfeed$export$cb4f92fb0c018828.BEFORE) {
                        prevCurve = $39e6475bde8cfeed$export$cb4f92fb0c018828.BEFORE;
                        path.computeWorldVertices(target, 2, 4, world, 0, 2);
                    }
                    this.addBeforePosition(p, world, 0, out, o);
                    continue;
                } else if (p > pathLength) {
                    if (prevCurve != $39e6475bde8cfeed$export$cb4f92fb0c018828.AFTER) {
                        prevCurve = $39e6475bde8cfeed$export$cb4f92fb0c018828.AFTER;
                        path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                    }
                    this.addAfterPosition(p - pathLength, world, 0, out, o);
                    continue;
                }
                // Determine curve containing position.
                for(;; curve++){
                    let length = lengths[curve];
                    if (p > length) continue;
                    if (curve == 0) p /= length;
                    else {
                        let prev = lengths[curve - 1];
                        p = (p - prev) / (length - prev);
                    }
                    break;
                }
                if (curve != prevCurve) {
                    prevCurve = curve;
                    if (closed && curve == curveCount) {
                        path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                        path.computeWorldVertices(target, 0, 4, world, 4, 2);
                    } else path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                }
                this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || i > 0 && space == 0);
            }
            return out;
        }
        // World vertices.
        if (closed) {
            verticesLength += 2;
            world = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
            path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
            world[verticesLength - 2] = world[0];
            world[verticesLength - 1] = world[1];
        } else {
            curveCount--;
            verticesLength -= 4;
            world = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
        }
        // Curve lengths.
        let curves = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.curves, curveCount);
        let pathLength = 0;
        let x1 = world[0], y1 = world[1], cx1 = 0, cy1 = 0, cx2 = 0, cy2 = 0, x2 = 0, y2 = 0;
        let tmpx = 0, tmpy = 0, dddfx = 0, dddfy = 0, ddfx = 0, ddfy = 0, dfx = 0, dfy = 0;
        for(let i = 0, w = 2; i < curveCount; i++, w += 6){
            cx1 = world[w];
            cy1 = world[w + 1];
            cx2 = world[w + 2];
            cy2 = world[w + 3];
            x2 = world[w + 4];
            y2 = world[w + 5];
            tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
            tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
            dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
            dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
            ddfx = tmpx * 2 + dddfx;
            ddfy = tmpy * 2 + dddfy;
            dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
            dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx + dddfx;
            dfy += ddfy + dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            curves[i] = pathLength;
            x1 = x2;
            y1 = y2;
        }
        if (this.data.positionMode == (0, $df278a6379229a7a$export$34d637c671e1e906).Percent) position *= pathLength;
        let multiplier;
        switch(this.data.spacingMode){
            case (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Percent:
                multiplier = pathLength;
                break;
            case (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Proportional:
                multiplier = pathLength / spacesCount;
                break;
            default:
                multiplier = 1;
        }
        let segments = this.segments;
        let curveLength = 0;
        for(let i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3){
            let space = spaces[i] * multiplier;
            position += space;
            let p = position;
            if (closed) {
                p %= pathLength;
                if (p < 0) p += pathLength;
                curve = 0;
            } else if (p < 0) {
                this.addBeforePosition(p, world, 0, out, o);
                continue;
            } else if (p > pathLength) {
                this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                continue;
            }
            // Determine curve containing position.
            for(;; curve++){
                let length = curves[curve];
                if (p > length) continue;
                if (curve == 0) p /= length;
                else {
                    let prev = curves[curve - 1];
                    p = (p - prev) / (length - prev);
                }
                break;
            }
            // Curve segment lengths.
            if (curve != prevCurve) {
                prevCurve = curve;
                let ii = curve * 6;
                x1 = world[ii];
                y1 = world[ii + 1];
                cx1 = world[ii + 2];
                cy1 = world[ii + 3];
                cx2 = world[ii + 4];
                cy2 = world[ii + 5];
                x2 = world[ii + 6];
                y2 = world[ii + 7];
                tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.006;
                dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.006;
                ddfx = tmpx * 2 + dddfx;
                ddfy = tmpy * 2 + dddfy;
                dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                segments[0] = curveLength;
                for(ii = 1; ii < 8; ii++){
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    segments[ii] = curveLength;
                }
                dfx += ddfx;
                dfy += ddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[8] = curveLength;
                dfx += ddfx + dddfx;
                dfy += ddfy + dddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[9] = curveLength;
                segment = 0;
            }
            // Weight by segment length.
            p *= curveLength;
            for(;; segment++){
                let length = segments[segment];
                if (p > length) continue;
                if (segment == 0) p /= length;
                else {
                    let prev = segments[segment - 1];
                    p = segment + (p - prev) / (length - prev);
                }
                break;
            }
            this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || i > 0 && space == 0);
        }
        return out;
    }
    addBeforePosition(p, temp, i, out, o) {
        let x1 = temp[i], y1 = temp[i + 1], dx = temp[i + 2] - x1, dy = temp[i + 3] - y1, r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addAfterPosition(p, temp, i, out, o) {
        let x1 = temp[i + 2], y1 = temp[i + 3], dx = x1 - temp[i], dy = y1 - temp[i + 1], r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addCurvePosition(p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
        if (p == 0 || isNaN(p)) {
            out[o] = x1;
            out[o + 1] = y1;
            out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            return;
        }
        let tt = p * p, ttt = tt * p, u = 1 - p, uu = u * u, uuu = uu * u;
        let ut = u * p, ut3 = ut * 3, uut3 = u * ut3, utt3 = ut3 * p;
        let x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt, y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
        out[o] = x;
        out[o + 1] = y;
        if (tangents) {
            if (p < 0.001) out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            else out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
        }
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 






/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $7d57644d9b80fcef$export$5a60d3a36c7d9b56 {
    data;
    _bone = null;
    /** The bone constrained by this physics constraint. */ set bone(bone) {
        this._bone = bone;
    }
    get bone() {
        if (!this._bone) throw new Error("Bone not set.");
        else return this._bone;
    }
    inertia = 0;
    strength = 0;
    damping = 0;
    massInverse = 0;
    wind = 0;
    gravity = 0;
    mix = 0;
    _reset = true;
    ux = 0;
    uy = 0;
    cx = 0;
    cy = 0;
    tx = 0;
    ty = 0;
    xOffset = 0;
    xVelocity = 0;
    yOffset = 0;
    yVelocity = 0;
    rotateOffset = 0;
    rotateVelocity = 0;
    scaleOffset = 0;
    scaleVelocity = 0;
    active = false;
    skeleton;
    remaining = 0;
    lastTime = 0;
    constructor(data, skeleton){
        this.data = data;
        this.skeleton = skeleton;
        this.bone = skeleton.bones[data.bone.index];
        this.inertia = data.inertia;
        this.strength = data.strength;
        this.damping = data.damping;
        this.massInverse = data.massInverse;
        this.wind = data.wind;
        this.gravity = data.gravity;
        this.mix = data.mix;
    }
    reset() {
        this.remaining = 0;
        this.lastTime = this.skeleton.time;
        this._reset = true;
        this.xOffset = 0;
        this.xVelocity = 0;
        this.yOffset = 0;
        this.yVelocity = 0;
        this.rotateOffset = 0;
        this.rotateVelocity = 0;
        this.scaleOffset = 0;
        this.scaleVelocity = 0;
    }
    setToSetupPose() {
        const data = this.data;
        this.inertia = data.inertia;
        this.strength = data.strength;
        this.damping = data.damping;
        this.massInverse = data.massInverse;
        this.wind = data.wind;
        this.gravity = data.gravity;
        this.mix = data.mix;
    }
    isActive() {
        return this.active;
    }
    /** Applies the constraint to the constrained bones. */ update(physics) {
        const mix = this.mix;
        if (mix == 0) return;
        const x = this.data.x > 0, y = this.data.y > 0, rotateOrShearX = this.data.rotate > 0 || this.data.shearX > 0, scaleX = this.data.scaleX > 0;
        const bone = this.bone;
        const l = bone.data.length;
        switch(physics){
            case (0, $e4c808b89cce1537$export$2f09efa5b67124a7).none:
                return;
            case (0, $e4c808b89cce1537$export$2f09efa5b67124a7).reset:
                this.reset();
            // Fall through.
            case (0, $e4c808b89cce1537$export$2f09efa5b67124a7).update:
                const skeleton = this.skeleton;
                const delta = Math.max(this.skeleton.time - this.lastTime, 0);
                this.remaining += delta;
                this.lastTime = skeleton.time;
                const bx = bone.worldX, by = bone.worldY;
                if (this._reset) {
                    this._reset = false;
                    this.ux = bx;
                    this.uy = by;
                } else {
                    let a = this.remaining, i = this.inertia, t = this.data.step, f = this.skeleton.data.referenceScale, d = -1;
                    let qx = this.data.limit * delta, qy = qx * Math.abs(skeleton.scaleY);
                    qx *= Math.abs(skeleton.scaleX);
                    if (x || y) {
                        if (x) {
                            const u = (this.ux - bx) * i;
                            this.xOffset += u > qx ? qx : u < -qx ? -qx : u;
                            this.ux = bx;
                        }
                        if (y) {
                            const u = (this.uy - by) * i;
                            this.yOffset += u > qy ? qy : u < -qy ? -qy : u;
                            this.uy = by;
                        }
                        if (a >= t) {
                            d = Math.pow(this.damping, 60 * t);
                            const m = this.massInverse * t, e = this.strength, w = this.wind * f, g = ((0, $e4c808b89cce1537$export$8f31e4c4a37b8e9c).yDown ? -this.gravity : this.gravity) * f;
                            do {
                                if (x) {
                                    this.xVelocity += (w - this.xOffset * e) * m;
                                    this.xOffset += this.xVelocity * t;
                                    this.xVelocity *= d;
                                }
                                if (y) {
                                    this.yVelocity -= (g + this.yOffset * e) * m;
                                    this.yOffset += this.yVelocity * t;
                                    this.yVelocity *= d;
                                }
                                a -= t;
                            }while (a >= t);
                        }
                        if (x) bone.worldX += this.xOffset * mix * this.data.x;
                        if (y) bone.worldY += this.yOffset * mix * this.data.y;
                    }
                    if (rotateOrShearX || scaleX) {
                        let ca = Math.atan2(bone.c, bone.a), c = 0, s = 0, mr = 0;
                        let dx = this.cx - bone.worldX, dy = this.cy - bone.worldY;
                        if (dx > qx) dx = qx;
                        else if (dx < -qx) dx = -qx;
                        if (dy > qy) dy = qy;
                        else if (dy < -qy) dy = -qy;
                        if (rotateOrShearX) {
                            mr = (this.data.rotate + this.data.shearX) * mix;
                            let r = Math.atan2(dy + this.ty, dx + this.tx) - ca - this.rotateOffset * mr;
                            this.rotateOffset += (r - Math.ceil(r * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).invPI2 - 0.5) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2) * i;
                            r = this.rotateOffset * mr + ca;
                            c = Math.cos(r);
                            s = Math.sin(r);
                            if (scaleX) {
                                r = l * bone.getWorldScaleX();
                                if (r > 0) this.scaleOffset += (dx * c + dy * s) * i / r;
                            }
                        } else {
                            c = Math.cos(ca);
                            s = Math.sin(ca);
                            const r = l * bone.getWorldScaleX();
                            if (r > 0) this.scaleOffset += (dx * c + dy * s) * i / r;
                        }
                        a = this.remaining;
                        if (a >= t) {
                            if (d == -1) d = Math.pow(this.damping, 60 * t);
                            const m = this.massInverse * t, e = this.strength, w = this.wind, g = (0, $e4c808b89cce1537$export$8f31e4c4a37b8e9c).yDown ? -this.gravity : this.gravity, h = l / f;
                            while(true){
                                a -= t;
                                if (scaleX) {
                                    this.scaleVelocity += (w * c - g * s - this.scaleOffset * e) * m;
                                    this.scaleOffset += this.scaleVelocity * t;
                                    this.scaleVelocity *= d;
                                }
                                if (rotateOrShearX) {
                                    this.rotateVelocity -= ((w * s + g * c) * h + this.rotateOffset * e) * m;
                                    this.rotateOffset += this.rotateVelocity * t;
                                    this.rotateVelocity *= d;
                                    if (a < t) break;
                                    const r = this.rotateOffset * mr + ca;
                                    c = Math.cos(r);
                                    s = Math.sin(r);
                                } else if (a < t) break;
                            }
                        }
                    }
                    this.remaining = a;
                }
                this.cx = bone.worldX;
                this.cy = bone.worldY;
                break;
            case (0, $e4c808b89cce1537$export$2f09efa5b67124a7).pose:
                if (x) bone.worldX += this.xOffset * mix * this.data.x;
                if (y) bone.worldY += this.yOffset * mix * this.data.y;
        }
        if (rotateOrShearX) {
            let o = this.rotateOffset * mix, s = 0, c = 0, a = 0;
            if (this.data.shearX > 0) {
                let r = 0;
                if (this.data.rotate > 0) {
                    r = o * this.data.rotate;
                    s = Math.sin(r);
                    c = Math.cos(r);
                    a = bone.b;
                    bone.b = c * a - s * bone.d;
                    bone.d = s * a + c * bone.d;
                }
                r += o * this.data.shearX;
                s = Math.sin(r);
                c = Math.cos(r);
                a = bone.a;
                bone.a = c * a - s * bone.c;
                bone.c = s * a + c * bone.c;
            } else {
                o *= this.data.rotate;
                s = Math.sin(o);
                c = Math.cos(o);
                a = bone.a;
                bone.a = c * a - s * bone.c;
                bone.c = s * a + c * bone.c;
                a = bone.b;
                bone.b = c * a - s * bone.d;
                bone.d = s * a + c * bone.d;
            }
        }
        if (scaleX) {
            const s = 1 + this.scaleOffset * mix * this.data.scaleX;
            bone.a *= s;
            bone.c *= s;
        }
        if (physics != (0, $e4c808b89cce1537$export$2f09efa5b67124a7).pose) {
            this.tx = l * bone.a;
            this.ty = l * bone.c;
        }
        bone.updateAppliedTransform();
    }
    /** Translates the physics constraint so next {@link #update(Physics)} forces are applied as if the bone moved an additional
     * amount in world space. */ translate(x, y) {
        this.ux -= x;
        this.uy -= y;
        this.cx -= x;
        this.cy -= y;
    }
    /** Rotates the physics constraint so next {@link #update(Physics)} forces are applied as if the bone rotated around the
     * specified point in world space. */ rotate(x, y, degrees) {
        const r = degrees * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad, cos = Math.cos(r), sin = Math.sin(r);
        const dx = this.cx - x, dy = this.cy - y;
        this.translate(dx * cos - dy * sin - dx, dx * sin + dy * cos - dy);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $528dd099ebc2132b$export$8c6ed5c666ac1360 {
    /** The slot's setup pose data. */ data;
    /** The bone this slot belongs to. */ bone;
    /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ color;
    /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ darkColor = null;
    attachment = null;
    attachmentState = 0;
    /** The index of the texture region to display when the slot's attachment has a {@link Sequence}. -1 represents the
     * {@link Sequence#getSetupIndex()}. */ sequenceIndex = -1;
    /** Values to deform the slot's attachment. For an unweighted mesh, the entries are local positions for each vertex. For a
     * weighted mesh, the entries are an offset for each vertex which will be added to the mesh's local vertex positions.
     *
     * See {@link VertexAttachment#computeWorldVertices()} and {@link DeformTimeline}. */ deform = new Array();
    constructor(data, bone){
        if (!data) throw new Error("data cannot be null.");
        if (!bone) throw new Error("bone cannot be null.");
        this.data = data;
        this.bone = bone;
        this.color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
        this.darkColor = !data.darkColor ? null : new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
        this.setToSetupPose();
    }
    /** The skeleton this slot belongs to. */ getSkeleton() {
        return this.bone.skeleton;
    }
    /** The current attachment for the slot, or null if the slot has no attachment. */ getAttachment() {
        return this.attachment;
    }
    /** Sets the slot's attachment and, if the attachment changed, resets {@link #sequenceIndex} and clears the {@link #deform}.
     * The deform is not cleared if the old attachment has the same {@link VertexAttachment#getTimelineAttachment()} as the
     * specified attachment. */ setAttachment(attachment) {
        if (this.attachment == attachment) return;
        if (!(attachment instanceof (0, $6828f80d5a50ba40$export$66d3a0c3be55e044)) || !(this.attachment instanceof (0, $6828f80d5a50ba40$export$66d3a0c3be55e044)) || attachment.timelineAttachment != this.attachment.timelineAttachment) this.deform.length = 0;
        this.attachment = attachment;
        this.sequenceIndex = -1;
    }
    /** Sets this slot to the setup pose. */ setToSetupPose() {
        this.color.setFromColor(this.data.color);
        if (this.darkColor) this.darkColor.setFromColor(this.data.darkColor);
        if (!this.data.attachmentName) this.attachment = null;
        else {
            this.attachment = null;
            this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
        }
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $c793a58c6b8a7439$export$a2d8268faabf5c52 {
    /** The transform constraint's setup pose data. */ data;
    /** The bones that will be modified by this transform constraint. */ bones;
    /** The target bone whose world transform will be copied to the constrained bones. */ target;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    mixScaleX = 0;
    mixScaleY = 0;
    mixShearY = 0;
    temp = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        let target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}.`);
        this.target = target;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
        this.mixScaleX = data.mixScaleX;
        this.mixScaleY = data.mixScaleY;
        this.mixShearY = data.mixShearY;
    }
    isActive() {
        return this.active;
    }
    setToSetupPose() {
        const data = this.data;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
        this.mixScaleX = data.mixScaleX;
        this.mixScaleY = data.mixScaleY;
        this.mixShearY = data.mixShearY;
    }
    update(physics) {
        if (this.mixRotate == 0 && this.mixX == 0 && this.mixY == 0 && this.mixScaleX == 0 && this.mixScaleY == 0 && this.mixShearY == 0) return;
        if (this.data.local) {
            if (this.data.relative) this.applyRelativeLocal();
            else this.applyAbsoluteLocal();
        } else if (this.data.relative) this.applyRelativeWorld();
        else this.applyAbsoluteWorld();
    }
    applyAbsoluteWorld() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let translate = mixX != 0 || mixY != 0;
        let target = this.target;
        let ta = target.a, tb = target.b, tc = target.c, td = target.d;
        let degRadReflect = ta * td - tb * tc > 0 ? (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad : -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        let offsetRotation = this.data.offsetRotation * degRadReflect;
        let offsetShearY = this.data.offsetShearY * degRadReflect;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (mixRotate != 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
                let r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                if (r > (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r -= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r += (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                let cos = Math.cos(r), sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            if (translate) {
                let temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                bone.worldX += (temp.x - bone.worldX) * mixX;
                bone.worldY += (temp.y - bone.worldY) * mixY;
            }
            if (mixScaleX != 0) {
                let s = Math.sqrt(bone.a * bone.a + bone.c * bone.c);
                if (s != 0) s = (s + (Math.sqrt(ta * ta + tc * tc) - s + this.data.offsetScaleX) * mixScaleX) / s;
                bone.a *= s;
                bone.c *= s;
            }
            if (mixScaleY != 0) {
                let s = Math.sqrt(bone.b * bone.b + bone.d * bone.d);
                if (s != 0) s = (s + (Math.sqrt(tb * tb + td * td) - s + this.data.offsetScaleY) * mixScaleY) / s;
                bone.b *= s;
                bone.d *= s;
            }
            if (mixShearY > 0) {
                let b = bone.b, d = bone.d;
                let by = Math.atan2(d, b);
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(bone.c, bone.a));
                if (r > (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r -= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r += (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                r = by + (r + offsetShearY) * mixShearY;
                let s = Math.sqrt(b * b + d * d);
                bone.b = Math.cos(r) * s;
                bone.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyRelativeWorld() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let translate = mixX != 0 || mixY != 0;
        let target = this.target;
        let ta = target.a, tb = target.b, tc = target.c, td = target.d;
        let degRadReflect = ta * td - tb * tc > 0 ? (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad : -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        let offsetRotation = this.data.offsetRotation * degRadReflect, offsetShearY = this.data.offsetShearY * degRadReflect;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (mixRotate != 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
                let r = Math.atan2(tc, ta) + offsetRotation;
                if (r > (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r -= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r += (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                let cos = Math.cos(r), sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            if (translate) {
                let temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                bone.worldX += temp.x * mixX;
                bone.worldY += temp.y * mixY;
            }
            if (mixScaleX != 0) {
                let s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * mixScaleX + 1;
                bone.a *= s;
                bone.c *= s;
            }
            if (mixScaleY != 0) {
                let s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * mixScaleY + 1;
                bone.b *= s;
                bone.d *= s;
            }
            if (mixShearY > 0) {
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                if (r > (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r -= (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI) r += (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI2;
                let b = bone.b, d = bone.d;
                r = Math.atan2(d, b) + (r - (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI / 2 + offsetShearY) * mixShearY;
                let s = Math.sqrt(b * b + d * d);
                bone.b = Math.cos(r) * s;
                bone.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyAbsoluteLocal() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let target = this.target;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            let rotation = bone.arotation;
            if (mixRotate != 0) rotation += (target.arotation - rotation + this.data.offsetRotation) * mixRotate;
            let x = bone.ax, y = bone.ay;
            x += (target.ax - x + this.data.offsetX) * mixX;
            y += (target.ay - y + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX, scaleY = bone.ascaleY;
            if (mixScaleX != 0 && scaleX != 0) scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * mixScaleX) / scaleX;
            if (mixScaleY != 0 && scaleY != 0) scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * mixScaleY) / scaleY;
            let shearY = bone.ashearY;
            if (mixShearY != 0) shearY += (target.ashearY - shearY + this.data.offsetShearY) * mixShearY;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    applyRelativeLocal() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let target = this.target;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            let rotation = bone.arotation + (target.arotation + this.data.offsetRotation) * mixRotate;
            let x = bone.ax + (target.ax + this.data.offsetX) * mixX;
            let y = bone.ay + (target.ay + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX * ((target.ascaleX - 1 + this.data.offsetScaleX) * mixScaleX + 1);
            let scaleY = bone.ascaleY * ((target.ascaleY - 1 + this.data.offsetScaleY) * mixScaleY + 1);
            let shearY = bone.ashearY + (target.ashearY + this.data.offsetShearY) * mixShearY;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
}



class $e4c808b89cce1537$export$8f31e4c4a37b8e9c {
    static quadTriangles = [
        0,
        1,
        2,
        2,
        3,
        0
    ];
    static yDown = false;
    /** The skeleton's setup pose data. */ data;
    /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ bones;
    /** The skeleton's slots in the setup pose draw order. */ slots;
    /** The skeleton's slots in the order they should be drawn. The returned array may be modified to change the draw order. */ drawOrder;
    /** The skeleton's IK constraints. */ ikConstraints;
    /** The skeleton's transform constraints. */ transformConstraints;
    /** The skeleton's path constraints. */ pathConstraints;
    /** The skeleton's physics constraints. */ physicsConstraints;
    /** The list of bones and constraints, sorted in the order they should be updated, as computed by {@link #updateCache()}. */ _updateCache = new Array();
    /** The skeleton's current skin. May be null. */ skin = null;
    /** The color to tint all the skeleton's attachments. */ color;
    /** Scales the entire skeleton on the X axis. This affects all bones, even if the bone's transform mode disallows scale
      * inheritance. */ scaleX = 1;
    /** Scales the entire skeleton on the Y axis. This affects all bones, even if the bone's transform mode disallows scale
      * inheritance. */ _scaleY = 1;
    get scaleY() {
        return $e4c808b89cce1537$export$8f31e4c4a37b8e9c.yDown ? -this._scaleY : this._scaleY;
    }
    set scaleY(scaleY) {
        this._scaleY = scaleY;
    }
    /** Sets the skeleton X position, which is added to the root bone worldX position. */ x = 0;
    /** Sets the skeleton Y position, which is added to the root bone worldY position. */ y = 0;
    /** Returns the skeleton's time. This is used for time-based manipulations, such as {@link PhysicsConstraint}.
     * <p>
     * See {@link #update(float)}. */ time = 0;
    constructor(data){
        if (!data) throw new Error("data cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let boneData = data.bones[i];
            let bone;
            if (!boneData.parent) bone = new (0, $11d84caa84dff789$export$b127726e56765aa4)(boneData, this, null);
            else {
                let parent = this.bones[boneData.parent.index];
                bone = new (0, $11d84caa84dff789$export$b127726e56765aa4)(boneData, this, parent);
                parent.children.push(bone);
            }
            this.bones.push(bone);
        }
        this.slots = new Array();
        this.drawOrder = new Array();
        for(let i = 0; i < data.slots.length; i++){
            let slotData = data.slots[i];
            let bone = this.bones[slotData.boneData.index];
            let slot = new (0, $528dd099ebc2132b$export$8c6ed5c666ac1360)(slotData, bone);
            this.slots.push(slot);
            this.drawOrder.push(slot);
        }
        this.ikConstraints = new Array();
        for(let i = 0; i < data.ikConstraints.length; i++){
            let ikConstraintData = data.ikConstraints[i];
            this.ikConstraints.push(new (0, $7f29795da1138367$export$3c158c80ff28c177)(ikConstraintData, this));
        }
        this.transformConstraints = new Array();
        for(let i = 0; i < data.transformConstraints.length; i++){
            let transformConstraintData = data.transformConstraints[i];
            this.transformConstraints.push(new (0, $c793a58c6b8a7439$export$a2d8268faabf5c52)(transformConstraintData, this));
        }
        this.pathConstraints = new Array();
        for(let i = 0; i < data.pathConstraints.length; i++){
            let pathConstraintData = data.pathConstraints[i];
            this.pathConstraints.push(new (0, $39e6475bde8cfeed$export$cb4f92fb0c018828)(pathConstraintData, this));
        }
        this.physicsConstraints = new Array();
        for(let i = 0; i < data.physicsConstraints.length; i++){
            let physicsConstraintData = data.physicsConstraints[i];
            this.physicsConstraints.push(new (0, $7d57644d9b80fcef$export$5a60d3a36c7d9b56)(physicsConstraintData, this));
        }
        this.color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
        this.updateCache();
    }
    /** Caches information about bones and constraints. Must be called if the {@link #getSkin()} is modified or if bones,
     * constraints, or weighted path attachments are added or removed. */ updateCache() {
        let updateCache = this._updateCache;
        updateCache.length = 0;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.sorted = bone.data.skinRequired;
            bone.active = !bone.sorted;
        }
        if (this.skin) {
            let skinBones = this.skin.bones;
            for(let i = 0, n = this.skin.bones.length; i < n; i++){
                let bone = this.bones[skinBones[i].index];
                do {
                    bone.sorted = false;
                    bone.active = true;
                    bone = bone.parent;
                }while (bone);
            }
        }
        // IK first, lowest hierarchy depth first.
        let ikConstraints = this.ikConstraints;
        let transformConstraints = this.transformConstraints;
        let pathConstraints = this.pathConstraints;
        let physicsConstraints = this.physicsConstraints;
        let ikCount = ikConstraints.length, transformCount = transformConstraints.length, pathCount = pathConstraints.length, physicsCount = this.physicsConstraints.length;
        let constraintCount = ikCount + transformCount + pathCount + physicsCount;
        outer: for(let i = 0; i < constraintCount; i++){
            for(let ii = 0; ii < ikCount; ii++){
                let constraint = ikConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortIkConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < transformCount; ii++){
                let constraint = transformConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortTransformConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < pathCount; ii++){
                let constraint = pathConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPathConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < physicsCount; ii++){
                const constraint = physicsConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPhysicsConstraint(constraint);
                    continue outer;
                }
            }
        }
        for(let i = 0, n = bones.length; i < n; i++)this.sortBone(bones[i]);
    }
    sortIkConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        let target = constraint.target;
        this.sortBone(target);
        let constrained = constraint.bones;
        let parent = constrained[0];
        this.sortBone(parent);
        if (constrained.length == 1) {
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
        } else {
            let child = constrained[constrained.length - 1];
            this.sortBone(child);
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
            child.sorted = true;
        }
    }
    sortPathConstraint(constraint) {
        constraint.active = constraint.target.bone.isActive() && (!constraint.data.skinRequired || this.skin && (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        let slot = constraint.target;
        let slotIndex = slot.data.index;
        let slotBone = slot.bone;
        if (this.skin) this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
        if (this.data.defaultSkin && this.data.defaultSkin != this.skin) this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
        for(let i = 0, n = this.data.skins.length; i < n; i++)this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
        let attachment = slot.getAttachment();
        if (attachment instanceof (0, $a01103cd4726e79d$export$d285e3ec07b32800)) this.sortPathConstraintAttachmentWith(attachment, slotBone);
        let constrained = constraint.bones;
        let boneCount = constrained.length;
        for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortTransformConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(constraint.target);
        let constrained = constraint.bones;
        let boneCount = constrained.length;
        if (constraint.data.local) for(let i = 0; i < boneCount; i++){
            let child = constrained[i];
            this.sortBone(child.parent);
            this.sortBone(child);
        }
        else for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortPathConstraintAttachment(skin, slotIndex, slotBone) {
        let attachments = skin.attachments[slotIndex];
        if (!attachments) return;
        for(let key in attachments)this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
    }
    sortPathConstraintAttachmentWith(attachment, slotBone) {
        if (!(attachment instanceof (0, $a01103cd4726e79d$export$d285e3ec07b32800))) return;
        let pathBones = attachment.bones;
        if (!pathBones) this.sortBone(slotBone);
        else {
            let bones = this.bones;
            for(let i = 0, n = pathBones.length; i < n;){
                let nn = pathBones[i++];
                nn += i;
                while(i < nn)this.sortBone(bones[pathBones[i++]]);
            }
        }
    }
    sortPhysicsConstraint(constraint) {
        const bone = constraint.bone;
        constraint.active = bone.active && (!constraint.data.skinRequired || this.skin != null && (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(bone);
        this._updateCache.push(constraint);
        this.sortReset(bone.children);
        bone.sorted = true;
    }
    sortBone(bone) {
        if (!bone) return;
        if (bone.sorted) return;
        let parent = bone.parent;
        if (parent) this.sortBone(parent);
        bone.sorted = true;
        this._updateCache.push(bone);
    }
    sortReset(bones) {
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (!bone.active) continue;
            if (bone.sorted) this.sortReset(bone.children);
            bone.sorted = false;
        }
    }
    /** Updates the world transform for each bone and applies all constraints.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide. */ updateWorldTransform(physics) {
        if (physics === undefined || physics === null) throw new Error("physics is undefined");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
        }
        let updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++)updateCache[i].update(physics);
    }
    updateWorldTransformWith(physics, parent) {
        // Apply the parent bone transform to the root bone. The root bone always inherits scale, rotation and reflection.
        let rootBone = this.getRootBone();
        if (!rootBone) throw new Error("Root bone must not be null.");
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        rootBone.worldX = pa * this.x + pb * this.y + parent.worldX;
        rootBone.worldY = pc * this.x + pd * this.y + parent.worldY;
        const rx = (rootBone.rotation + rootBone.shearX) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        const ry = (rootBone.rotation + 90 + rootBone.shearY) * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).degRad;
        const la = Math.cos(rx) * rootBone.scaleX;
        const lb = Math.cos(ry) * rootBone.scaleY;
        const lc = Math.sin(rx) * rootBone.scaleX;
        const ld = Math.sin(ry) * rootBone.scaleY;
        rootBone.a = (pa * la + pb * lc) * this.scaleX;
        rootBone.b = (pa * lb + pb * ld) * this.scaleX;
        rootBone.c = (pc * la + pd * lc) * this.scaleY;
        rootBone.d = (pc * lb + pd * ld) * this.scaleY;
        // Update everything except root bone.
        let updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++){
            let updatable = updateCache[i];
            if (updatable != rootBone) updatable.update(physics);
        }
    }
    /** Sets the bones, constraints, and slots to their setup pose values. */ setToSetupPose() {
        this.setBonesToSetupPose();
        this.setSlotsToSetupPose();
    }
    /** Sets the bones and constraints to their setup pose values. */ setBonesToSetupPose() {
        for (const bone of this.bones)bone.setToSetupPose();
        for (const constraint of this.ikConstraints)constraint.setToSetupPose();
        for (const constraint of this.transformConstraints)constraint.setToSetupPose();
        for (const constraint of this.pathConstraints)constraint.setToSetupPose();
        for (const constraint of this.physicsConstraints)constraint.setToSetupPose();
    }
    /** Sets the slots and draw order to their setup pose values. */ setSlotsToSetupPose() {
        let slots = this.slots;
        (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
        for(let i = 0, n = slots.length; i < n; i++)slots[i].setToSetupPose();
    }
    /** @returns May return null. */ getRootBone() {
        if (this.bones.length == 0) return null;
        return this.bones[0];
    }
    /** @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (bone.data.name == boneName) return bone;
        }
        return null;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
     * repeatedly.
     * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.data.name == slotName) return slot;
        }
        return null;
    }
    /** Sets a skin by name.
     *
     * See {@link #setSkin()}. */ setSkinByName(skinName) {
        let skin = this.data.findSkin(skinName);
        if (!skin) throw new Error("Skin not found: " + skinName);
        this.setSkin(skin);
    }
    /** Sets the skin used to look up attachments before looking in the {@link SkeletonData#defaultSkin default skin}. If the
     * skin is changed, {@link #updateCache()} is called.
     *
     * Attachments from the new skin are attached if the corresponding attachment from the old skin was attached. If there was no
     * old skin, each slot's setup mode attachment is attached from the new skin.
     *
     * After changing the skin, the visible attachments can be reset to those attached in the setup pose by calling
     * {@link #setSlotsToSetupPose()}. Also, often {@link AnimationState#apply()} is called before the next time the
     * skeleton is rendered to allow any attachment keys in the current animation(s) to hide or show attachments from the new skin.
     * @param newSkin May be null. */ setSkin(newSkin) {
        if (newSkin == this.skin) return;
        if (newSkin) {
            if (this.skin) newSkin.attachAll(this, this.skin);
            else {
                let slots = this.slots;
                for(let i = 0, n = slots.length; i < n; i++){
                    let slot = slots[i];
                    let name = slot.data.attachmentName;
                    if (name) {
                        let attachment = newSkin.getAttachment(i, name);
                        if (attachment) slot.setAttachment(attachment);
                    }
                }
            }
        }
        this.skin = newSkin;
        this.updateCache();
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot name and attachment
     * name.
     *
     * See {@link #getAttachment()}.
     * @returns May be null. */ getAttachmentByName(slotName, attachmentName) {
        let slot = this.data.findSlot(slotName);
        if (!slot) throw new Error(`Can't find slot with name ${slotName}`);
        return this.getAttachment(slot.index, attachmentName);
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot index and
     * attachment name. First the skin is checked and if the attachment was not found, the default skin is checked.
     *
     * See [Runtime skins](http://esotericsoftware.com/spine-runtime-skins) in the Spine Runtimes Guide.
     * @returns May be null. */ getAttachment(slotIndex, attachmentName) {
        if (!attachmentName) throw new Error("attachmentName cannot be null.");
        if (this.skin) {
            let attachment = this.skin.getAttachment(slotIndex, attachmentName);
            if (attachment) return attachment;
        }
        if (this.data.defaultSkin) return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
        return null;
    }
    /** A convenience method to set an attachment by finding the slot with {@link #findSlot()}, finding the attachment with
     * {@link #getAttachment()}, then setting the slot's {@link Slot#attachment}.
     * @param attachmentName May be null to clear the slot's attachment. */ setAttachment(slotName, attachmentName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.data.name == slotName) {
                let attachment = null;
                if (attachmentName) {
                    attachment = this.getAttachment(i, attachmentName);
                    if (!attachment) throw new Error("Attachment not found: " + attachmentName + ", for slot: " + slotName);
                }
                slot.setAttachment(attachment);
                return;
            }
        }
        throw new Error("Slot not found: " + slotName);
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
     * than to call it repeatedly.
     * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        return this.ikConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
     * this method than to call it repeatedly.
     * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        return this.transformConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
     * than to call it repeatedly.
     * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        return this.pathConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Finds a physics constraint by comparing each physics constraint's name. It is more efficient to cache the results of this
     * method than to call it repeatedly. */ findPhysicsConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        return this.physicsConstraints.find((constraint)=>constraint.data.name == constraintName) ?? null;
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose as `{ x: number, y: number, width: number, height: number }`.
     * Note that this method will create temporary objects which can add to garbage collection pressure. Use `getBounds()` if garbage collection is a concern. */ getBoundsRect() {
        let offset = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
        let size = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
        this.getBounds(offset, size);
        return {
            x: offset.x,
            y: offset.y,
            width: size.x,
            height: size.y
        };
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose.
     * @param offset An output value, the distance from the skeleton origin to the bottom left corner of the AABB.
     * @param size An output value, the width and height of the AABB.
     * @param temp Working memory to temporarily store attachments' computed world vertices.
     * @param clipper {@link SkeletonClipping} to use. If <code>null</code>, no clipping is applied. */ getBounds(offset, size, temp = new Array(2), clipper = null) {
        if (!offset) throw new Error("offset cannot be null.");
        if (!size) throw new Error("size cannot be null.");
        let drawOrder = this.drawOrder;
        let minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            let slot = drawOrder[i];
            if (!slot.bone.active) continue;
            let verticesLength = 0;
            let vertices = null;
            let triangles = null;
            let attachment = slot.getAttachment();
            if (attachment instanceof (0, $679f9e8a376fdb80$export$d0fc51466fa6d530)) {
                verticesLength = 8;
                vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                attachment.computeWorldVertices(slot, vertices, 0, 2);
                triangles = $e4c808b89cce1537$export$8f31e4c4a37b8e9c.quadTriangles;
            } else if (attachment instanceof (0, $06d16b10b33d165a$export$3f1c1692adfcf3e2)) {
                let mesh = attachment;
                verticesLength = mesh.worldVerticesLength;
                vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
                triangles = mesh.triangles;
            } else if (attachment instanceof (0, $ee64e63dbd5e17c9$export$838805e22b9b55f1) && clipper != null) {
                clipper.clipStart(slot, attachment);
                continue;
            }
            if (vertices && triangles) {
                if (clipper != null && clipper.isClipping()) {
                    clipper.clipTriangles(vertices, triangles, triangles.length);
                    vertices = clipper.clippedVertices;
                    verticesLength = clipper.clippedVertices.length;
                }
                for(let ii = 0, nn = vertices.length; ii < nn; ii += 2){
                    let x = vertices[ii], y = vertices[ii + 1];
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            if (clipper != null) clipper.clipEndWithSlot(slot);
        }
        if (clipper != null) clipper.clipEnd();
        offset.set(minX, minY);
        size.set(maxX - minX, maxY - minY);
    }
    /** Increments the skeleton's {@link #time}. */ update(delta) {
        this.time += delta;
    }
    physicsTranslate(x, y) {
        const physicsConstraints = this.physicsConstraints;
        for(let i = 0, n = physicsConstraints.length; i < n; i++)physicsConstraints[i].translate(x, y);
    }
    /** Calls {@link PhysicsConstraint#rotate(float, float, float)} for each physics constraint. */ physicsRotate(x, y, degrees) {
        const physicsConstraints = this.physicsConstraints;
        for(let i = 0, n = physicsConstraints.length; i < n; i++)physicsConstraints[i].rotate(x, y, degrees);
    }
}
var $e4c808b89cce1537$export$2f09efa5b67124a7;
(function(Physics) {
    /** Physics are not updated or applied. */ Physics[Physics["none"] = 0] = "none";
    /** Physics are reset to the current pose. */ Physics[Physics["reset"] = 1] = "reset";
    /** Physics are updated and the pose from physics is applied. */ Physics[Physics["update"] = 2] = "update";
    /** Physics are not updated but the pose from physics is applied. */ Physics[Physics["pose"] = 3] = "pose";
})($e4c808b89cce1537$export$2f09efa5b67124a7 || ($e4c808b89cce1537$export$2f09efa5b67124a7 = {}));


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 






/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $4152a57e560df614$export$e7a93b7124cc91bd extends (0, $191911922628b8b6$export$b826e1ab3af63566) {
    _bone = null;
    /** The bone constrained by this physics constraint. */ set bone(boneData) {
        this._bone = boneData;
    }
    get bone() {
        if (!this._bone) throw new Error("BoneData not set.");
        else return this._bone;
    }
    x = 0;
    y = 0;
    rotate = 0;
    scaleX = 0;
    shearX = 0;
    limit = 0;
    step = 0;
    inertia = 0;
    strength = 0;
    damping = 0;
    massInverse = 0;
    wind = 0;
    gravity = 0;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained poses. */ mix = 0;
    inertiaGlobal = false;
    strengthGlobal = false;
    dampingGlobal = false;
    massGlobal = false;
    windGlobal = false;
    gravityGlobal = false;
    mixGlobal = false;
    constructor(name){
        super(name, 0, false);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the setup pose and all of the stateless data for a skeleton.
 *
 * See [Data objects](http://esotericsoftware.com/spine-runtime-architecture#Data-objects) in the Spine Runtimes
 * Guide. */ class $2dd6505fb1e9bdd3$export$e8f362f163550575 {
    /** The skeleton's name, which by default is the name of the skeleton data file, if possible. May be null. */ name = null;
    /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ bones = new Array();
    /** The skeleton's slots in the setup pose draw order. */ slots = new Array();
    skins = new Array();
    /** The skeleton's default skin. By default this skin contains all attachments that were not in a skin in Spine.
     *
     * See {@link Skeleton#getAttachmentByName()}.
     * May be null. */ defaultSkin = null;
    /** The skeleton's events. */ events = new Array();
    /** The skeleton's animations. */ animations = new Array();
    /** The skeleton's IK constraints. */ ikConstraints = new Array();
    /** The skeleton's transform constraints. */ transformConstraints = new Array();
    /** The skeleton's path constraints. */ pathConstraints = new Array();
    /** The skeleton's physics constraints. */ physicsConstraints = new Array();
    /** The X coordinate of the skeleton's axis aligned bounding box in the setup pose. */ x = 0;
    /** The Y coordinate of the skeleton's axis aligned bounding box in the setup pose. */ y = 0;
    /** The width of the skeleton's axis aligned bounding box in the setup pose. */ width = 0;
    /** The height of the skeleton's axis aligned bounding box in the setup pose. */ height = 0;
    /** Baseline scale factor for applying distance-dependent effects on non-scalable properties, such as angle or scale. Default
     * is 100. */ referenceScale = 100;
    /** The Spine version used to export the skeleton data, or null. */ version = null;
    /** The skeleton data hash. This value will change if any of the skeleton data has changed. May be null. */ hash = null;
    // Nonessential
    /** The dopesheet FPS in Spine. Available only when nonessential data was exported. */ fps = 0;
    /** The path to the images directory as defined in Spine. Available only when nonessential data was exported. May be null. */ imagesPath = null;
    /** The path to the audio directory as defined in Spine. Available only when nonessential data was exported. May be null. */ audioPath = null;
    /** Finds a bone by comparing each bone's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (bone.name == boneName) return bone;
        }
        return null;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.name == slotName) return slot;
        }
        return null;
    }
    /** Finds a skin by comparing each skin's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findSkin(skinName) {
        if (!skinName) throw new Error("skinName cannot be null.");
        let skins = this.skins;
        for(let i = 0, n = skins.length; i < n; i++){
            let skin = skins[i];
            if (skin.name == skinName) return skin;
        }
        return null;
    }
    /** Finds an event by comparing each events's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findEvent(eventDataName) {
        if (!eventDataName) throw new Error("eventDataName cannot be null.");
        let events = this.events;
        for(let i = 0, n = events.length; i < n; i++){
            let event = events[i];
            if (event.name == eventDataName) return event;
        }
        return null;
    }
    /** Finds an animation by comparing each animation's name. It is more efficient to cache the results of this method than to
     * call it multiple times.
     * @returns May be null. */ findAnimation(animationName) {
        if (!animationName) throw new Error("animationName cannot be null.");
        let animations = this.animations;
        for(let i = 0, n = animations.length; i < n; i++){
            let animation = animations[i];
            if (animation.name == animationName) return animation;
        }
        return null;
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
     * this method than to call it multiple times.
     * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a physics constraint by comparing each physics constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findPhysicsConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const physicsConstraints = this.physicsConstraints;
        for(let i = 0, n = physicsConstraints.length; i < n; i++){
            const constraint = physicsConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $3ad0356d70bdb0e1$export$18ca51770a196b7d {
    slotIndex;
    name;
    attachment;
    constructor(slotIndex = 0, name, attachment){
        this.slotIndex = slotIndex;
        this.name = name;
        this.attachment = attachment;
    }
}
class $3ad0356d70bdb0e1$export$b8e0f93a76772233 {
    /** The skin's name, which is unique across all skins in the skeleton. */ name;
    attachments = new Array();
    bones = Array();
    constraints = new Array();
    /** The color of the skin as it was in Spine, or a default color if nonessential data was not exported. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.99607843, 0.61960787, 0.30980393, 1);
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
    /** Adds an attachment to the skin for the specified slot index and name. */ setAttachment(slotIndex, name, attachment) {
        if (!attachment) throw new Error("attachment cannot be null.");
        let attachments = this.attachments;
        if (slotIndex >= attachments.length) attachments.length = slotIndex + 1;
        if (!attachments[slotIndex]) attachments[slotIndex] = {};
        attachments[slotIndex][name] = attachment;
    }
    /** Adds all attachments, bones, and constraints from the specified skin to this skin. */ addSkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            let bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            let constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        let attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            var attachment = attachments[i];
            this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
        }
    }
    /** Adds all bones and constraints and copies of all attachments from the specified skin to this skin. Mesh attachments are not
     * copied, instead a new linked mesh is created. The attachment copies can be modified without affecting the originals. */ copySkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            let bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            let constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        let attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            var attachment = attachments[i];
            if (!attachment.attachment) continue;
            if (attachment.attachment instanceof (0, $06d16b10b33d165a$export$3f1c1692adfcf3e2)) {
                attachment.attachment = attachment.attachment.newLinkedMesh();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            } else {
                attachment.attachment = attachment.attachment.copy();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            }
        }
    }
    /** Returns the attachment for the specified slot index and name, or null. */ getAttachment(slotIndex, name) {
        let dictionary = this.attachments[slotIndex];
        return dictionary ? dictionary[name] : null;
    }
    /** Removes the attachment in the skin for the specified slot index and name, if any. */ removeAttachment(slotIndex, name) {
        let dictionary = this.attachments[slotIndex];
        if (dictionary) delete dictionary[name];
    }
    /** Returns all attachments in this skin. */ getAttachments() {
        let entries = new Array();
        for(var i = 0; i < this.attachments.length; i++){
            let slotAttachments = this.attachments[i];
            if (slotAttachments) for(let name in slotAttachments){
                let attachment = slotAttachments[name];
                if (attachment) entries.push(new $3ad0356d70bdb0e1$export$18ca51770a196b7d(i, name, attachment));
            }
        }
        return entries;
    }
    /** Returns all attachments in this skin for the specified slot index. */ getAttachmentsForSlot(slotIndex, attachments) {
        let slotAttachments = this.attachments[slotIndex];
        if (slotAttachments) for(let name in slotAttachments){
            let attachment = slotAttachments[name];
            if (attachment) attachments.push(new $3ad0356d70bdb0e1$export$18ca51770a196b7d(slotIndex, name, attachment));
        }
    }
    /** Clears all attachments, bones, and constraints. */ clear() {
        this.attachments.length = 0;
        this.bones.length = 0;
        this.constraints.length = 0;
    }
    /** Attach each attachment in this skin if the corresponding attachment in the old skin is currently attached. */ attachAll(skeleton, oldSkin) {
        let slotIndex = 0;
        for(let i = 0; i < skeleton.slots.length; i++){
            let slot = skeleton.slots[i];
            let slotAttachment = slot.getAttachment();
            if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                let dictionary = oldSkin.attachments[slotIndex];
                for(let key in dictionary){
                    let skinAttachment = dictionary[key];
                    if (slotAttachment == skinAttachment) {
                        let attachment = this.getAttachment(slotIndex, key);
                        if (attachment) slot.setAttachment(attachment);
                        break;
                    }
                }
            }
            slotIndex++;
        }
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $929b01edaa7ea960$export$a4cce1bf50208679 {
    /** The index of the slot in {@link Skeleton#getSlots()}. */ index = 0;
    /** The name of the slot, which is unique across all slots in the skeleton. */ name;
    /** The bone this slot belongs to. */ boneData;
    /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ darkColor = null;
    /** The name of the attachment that is visible for this slot in the setup pose, or null if no attachment is visible. */ attachmentName = null;
    /** The blend mode for drawing the slot's attachment. */ blendMode = $929b01edaa7ea960$export$c9b8fe72ac71821.Normal;
    /** False if the slot was hidden in Spine and nonessential data was exported. Does not affect runtime rendering. */ visible = true;
    constructor(index, name, boneData){
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        if (!boneData) throw new Error("boneData cannot be null.");
        this.index = index;
        this.name = name;
        this.boneData = boneData;
    }
}
var $929b01edaa7ea960$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode[BlendMode["Normal"] = 0] = "Normal";
    BlendMode[BlendMode["Additive"] = 1] = "Additive";
    BlendMode[BlendMode["Multiply"] = 2] = "Multiply";
    BlendMode[BlendMode["Screen"] = 3] = "Screen";
})($929b01edaa7ea960$export$c9b8fe72ac71821 || ($929b01edaa7ea960$export$c9b8fe72ac71821 = {}));


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $2ec81b1116e2dd23$export$823fbc29771afdb5 extends (0, $191911922628b8b6$export$b826e1ab3af63566) {
    /** The bones that will be modified by this transform constraint. */ bones = new Array();
    /** The target bone whose world transform will be copied to the constrained bones. */ _target = null;
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    mixScaleX = 0;
    mixScaleY = 0;
    mixShearY = 0;
    /** An offset added to the constrained bone rotation. */ offsetRotation = 0;
    /** An offset added to the constrained bone X translation. */ offsetX = 0;
    /** An offset added to the constrained bone Y translation. */ offsetY = 0;
    /** An offset added to the constrained bone scaleX. */ offsetScaleX = 0;
    /** An offset added to the constrained bone scaleY. */ offsetScaleY = 0;
    /** An offset added to the constrained bone shearY. */ offsetShearY = 0;
    relative = false;
    local = false;
    constructor(name){
        super(name, 0, false);
    }
}



class $41d6f0e7ee5e1c25$export$a7f7eaf4e9fce9ef {
    /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ scale = 1;
    attachmentLoader;
    linkedMeshes = new Array();
    constructor(attachmentLoader){
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(binary) {
        let scale = this.scale;
        let skeletonData = new (0, $2dd6505fb1e9bdd3$export$e8f362f163550575)();
        skeletonData.name = ""; // BOZO
        let input = new $41d6f0e7ee5e1c25$export$c8e921ea3330f774(binary);
        let lowHash = input.readInt32();
        let highHash = input.readInt32();
        skeletonData.hash = highHash == 0 && lowHash == 0 ? null : highHash.toString(16) + lowHash.toString(16);
        skeletonData.version = input.readString();
        skeletonData.x = input.readFloat();
        skeletonData.y = input.readFloat();
        skeletonData.width = input.readFloat();
        skeletonData.height = input.readFloat();
        skeletonData.referenceScale = input.readFloat() * scale;
        let nonessential = input.readBoolean();
        if (nonessential) {
            skeletonData.fps = input.readFloat();
            skeletonData.imagesPath = input.readString();
            skeletonData.audioPath = input.readString();
        }
        let n = 0;
        // Strings.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let str = input.readString();
            if (!str) throw new Error("String in string table must not be null.");
            input.strings.push(str);
        }
        // Bones.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Bone name must not be null.");
            let parent = i == 0 ? null : skeletonData.bones[input.readInt(true)];
            let data = new (0, $9299f15fee0c3520$export$7d85d96cf093e12f)(i, name, parent);
            data.rotation = input.readFloat();
            data.x = input.readFloat() * scale;
            data.y = input.readFloat() * scale;
            data.scaleX = input.readFloat();
            data.scaleY = input.readFloat();
            data.shearX = input.readFloat();
            data.shearY = input.readFloat();
            data.length = input.readFloat() * scale;
            data.inherit = input.readByte();
            data.skinRequired = input.readBoolean();
            if (nonessential) {
                (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
                data.icon = input.readString() ?? undefined;
                data.visible = input.readBoolean();
            }
            skeletonData.bones.push(data);
        }
        // Slots.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let slotName = input.readString();
            if (!slotName) throw new Error("Slot name must not be null.");
            let boneData = skeletonData.bones[input.readInt(true)];
            let data = new (0, $929b01edaa7ea960$export$a4cce1bf50208679)(i, slotName, boneData);
            (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            let darkColor = input.readInt32();
            if (darkColor != -1) (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgb888ToColor(data.darkColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(), darkColor);
            data.attachmentName = input.readStringRef();
            data.blendMode = input.readInt(true);
            if (nonessential) data.visible = input.readBoolean();
            skeletonData.slots.push(data);
        }
        // IK constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("IK constraint data name must not be null.");
            let data = new (0, $3262faf56c73da02$export$adcb08b651fc712e)(name);
            data.order = input.readInt(true);
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            let flags = input.readByte();
            data.skinRequired = (flags & 1) != 0;
            data.bendDirection = (flags & 2) != 0 ? 1 : -1;
            data.compress = (flags & 4) != 0;
            data.stretch = (flags & 8) != 0;
            data.uniform = (flags & 16) != 0;
            if ((flags & 32) != 0) data.mix = (flags & 64) != 0 ? input.readFloat() : 1;
            if ((flags & 128) != 0) data.softness = input.readFloat() * scale;
            skeletonData.ikConstraints.push(data);
        }
        // Transform constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Transform constraint data name must not be null.");
            let data = new (0, $2ec81b1116e2dd23$export$823fbc29771afdb5)(name);
            data.order = input.readInt(true);
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            let flags = input.readByte();
            data.skinRequired = (flags & 1) != 0;
            data.local = (flags & 2) != 0;
            data.relative = (flags & 4) != 0;
            if ((flags & 8) != 0) data.offsetRotation = input.readFloat();
            if ((flags & 16) != 0) data.offsetX = input.readFloat() * scale;
            if ((flags & 32) != 0) data.offsetY = input.readFloat() * scale;
            if ((flags & 64) != 0) data.offsetScaleX = input.readFloat();
            if ((flags & 128) != 0) data.offsetScaleY = input.readFloat();
            flags = input.readByte();
            if ((flags & 1) != 0) data.offsetShearY = input.readFloat();
            if ((flags & 2) != 0) data.mixRotate = input.readFloat();
            if ((flags & 4) != 0) data.mixX = input.readFloat();
            if ((flags & 8) != 0) data.mixY = input.readFloat();
            if ((flags & 16) != 0) data.mixScaleX = input.readFloat();
            if ((flags & 32) != 0) data.mixScaleY = input.readFloat();
            if ((flags & 64) != 0) data.mixShearY = input.readFloat();
            skeletonData.transformConstraints.push(data);
        }
        // Path constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Path constraint data name must not be null.");
            let data = new (0, $df278a6379229a7a$export$d2629ab80d5dd5ba)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.slots[input.readInt(true)];
            const flags = input.readByte();
            data.positionMode = flags & 1;
            data.spacingMode = flags >> 1 & 3;
            data.rotateMode = flags >> 3 & 3;
            if ((flags & 128) != 0) data.offsetRotation = input.readFloat();
            data.position = input.readFloat();
            if (data.positionMode == (0, $df278a6379229a7a$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = input.readFloat();
            if (data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.mixRotate = input.readFloat();
            data.mixX = input.readFloat();
            data.mixY = input.readFloat();
            skeletonData.pathConstraints.push(data);
        }
        // Physics constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const name = input.readString();
            if (!name) throw new Error("Physics constraint data name must not be null.");
            const data = new (0, $4152a57e560df614$export$e7a93b7124cc91bd)(name);
            data.order = input.readInt(true);
            data.bone = skeletonData.bones[input.readInt(true)];
            let flags = input.readByte();
            data.skinRequired = (flags & 1) != 0;
            if ((flags & 2) != 0) data.x = input.readFloat();
            if ((flags & 4) != 0) data.y = input.readFloat();
            if ((flags & 8) != 0) data.rotate = input.readFloat();
            if ((flags & 16) != 0) data.scaleX = input.readFloat();
            if ((flags & 32) != 0) data.shearX = input.readFloat();
            data.limit = ((flags & 64) != 0 ? input.readFloat() : 5000) * scale;
            data.step = 1 / input.readUnsignedByte();
            data.inertia = input.readFloat();
            data.strength = input.readFloat();
            data.damping = input.readFloat();
            data.massInverse = (flags & 128) != 0 ? input.readFloat() : 1;
            data.wind = input.readFloat();
            data.gravity = input.readFloat();
            flags = input.readByte();
            if ((flags & 1) != 0) data.inertiaGlobal = true;
            if ((flags & 2) != 0) data.strengthGlobal = true;
            if ((flags & 4) != 0) data.dampingGlobal = true;
            if ((flags & 8) != 0) data.massGlobal = true;
            if ((flags & 16) != 0) data.windGlobal = true;
            if ((flags & 32) != 0) data.gravityGlobal = true;
            if ((flags & 64) != 0) data.mixGlobal = true;
            data.mix = (flags & 128) != 0 ? input.readFloat() : 1;
            skeletonData.physicsConstraints.push(data);
        }
        // Default skin.
        let defaultSkin = this.readSkin(input, skeletonData, true, nonessential);
        if (defaultSkin) {
            skeletonData.defaultSkin = defaultSkin;
            skeletonData.skins.push(defaultSkin);
        }
        // Skins.
        {
            let i = skeletonData.skins.length;
            (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(skeletonData.skins, n = i + input.readInt(true));
            for(; i < n; i++){
                let skin = this.readSkin(input, skeletonData, false, nonessential);
                if (!skin) throw new Error("readSkin() should not have returned null.");
                skeletonData.skins[i] = skin;
            }
        }
        // Linked meshes.
        n = this.linkedMeshes.length;
        for(let i = 0; i < n; i++){
            let linkedMesh = this.linkedMeshes[i];
            const skin = skeletonData.skins[linkedMesh.skinIndex];
            if (!linkedMesh.parent) throw new Error("Linked mesh parent must not be null");
            let parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
            if (linkedMesh.mesh.region != null) linkedMesh.mesh.updateRegion();
        }
        this.linkedMeshes.length = 0;
        // Events.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let eventName = input.readString();
            if (!eventName) throw new Error("Event data name must not be null");
            let data = new (0, $8ced6bc62a0114c6$export$a5cf049e34c3d11e)(eventName);
            data.intValue = input.readInt(false);
            data.floatValue = input.readFloat();
            data.stringValue = input.readString();
            data.audioPath = input.readString();
            if (data.audioPath) {
                data.volume = input.readFloat();
                data.balance = input.readFloat();
            }
            skeletonData.events.push(data);
        }
        // Animations.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let animationName = input.readString();
            if (!animationName) throw new Error("Animatio name must not be null.");
            skeletonData.animations.push(this.readAnimation(input, animationName, skeletonData));
        }
        return skeletonData;
    }
    readSkin(input, skeletonData, defaultSkin, nonessential) {
        let skin = null;
        let slotCount = 0;
        if (defaultSkin) {
            slotCount = input.readInt(true);
            if (slotCount == 0) return null;
            skin = new (0, $3ad0356d70bdb0e1$export$b8e0f93a76772233)("default");
        } else {
            let skinName = input.readString();
            if (!skinName) throw new Error("Skin name must not be null.");
            skin = new (0, $3ad0356d70bdb0e1$export$b8e0f93a76772233)(skinName);
            if (nonessential) (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(skin.color, input.readInt32());
            skin.bones.length = input.readInt(true);
            for(let i = 0, n = skin.bones.length; i < n; i++)skin.bones[i] = skeletonData.bones[input.readInt(true)];
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.ikConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.transformConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.pathConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.physicsConstraints[input.readInt(true)]);
            slotCount = input.readInt(true);
        }
        for(let i = 0; i < slotCount; i++){
            let slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let name = input.readStringRef();
                if (!name) throw new Error("Attachment name must not be null");
                let attachment = this.readAttachment(input, skeletonData, skin, slotIndex, name, nonessential);
                if (attachment) skin.setAttachment(slotIndex, name, attachment);
            }
        }
        return skin;
    }
    readAttachment(input, skeletonData, skin, slotIndex, attachmentName, nonessential) {
        let scale = this.scale;
        let flags = input.readByte();
        const name = (flags & 8) != 0 ? input.readStringRef() : attachmentName;
        if (!name) throw new Error("Attachment name must not be null");
        switch(flags & 7){
            case $41d6f0e7ee5e1c25$var$AttachmentType.Region:
                {
                    let path = (flags & 16) != 0 ? input.readStringRef() : null;
                    const color = (flags & 32) != 0 ? input.readInt32() : 0xffffffff;
                    const sequence = (flags & 64) != 0 ? this.readSequence(input) : null;
                    let rotation = (flags & 128) != 0 ? input.readFloat() : 0;
                    let x = input.readFloat();
                    let y = input.readFloat();
                    let scaleX = input.readFloat();
                    let scaleY = input.readFloat();
                    let width = input.readFloat();
                    let height = input.readFloat();
                    if (!path) path = name;
                    let region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = x * scale;
                    region.y = y * scale;
                    region.scaleX = scaleX;
                    region.scaleY = scaleY;
                    region.rotation = rotation;
                    region.width = width * scale;
                    region.height = height * scale;
                    (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(region.color, color);
                    region.sequence = sequence;
                    if (sequence == null) region.updateRegion();
                    return region;
                }
            case $41d6f0e7ee5e1c25$var$AttachmentType.BoundingBox:
                {
                    let vertices = this.readVertices(input, (flags & 16) != 0);
                    let color = nonessential ? input.readInt32() : 0;
                    let box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    box.worldVerticesLength = vertices.length;
                    box.vertices = vertices.vertices;
                    box.bones = vertices.bones;
                    if (nonessential) (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(box.color, color);
                    return box;
                }
            case $41d6f0e7ee5e1c25$var$AttachmentType.Mesh:
                {
                    let path = (flags & 16) != 0 ? input.readStringRef() : name;
                    const color = (flags & 32) != 0 ? input.readInt32() : 0xffffffff;
                    const sequence = (flags & 64) != 0 ? this.readSequence(input) : null;
                    const hullLength = input.readInt(true);
                    const vertices = this.readVertices(input, (flags & 128) != 0);
                    const uvs = this.readFloatArray(input, vertices.length, 1);
                    const triangles = this.readShortArray(input, (vertices.length - hullLength - 2) * 3);
                    let edges = [];
                    let width = 0, height = 0;
                    if (nonessential) {
                        edges = this.readShortArray(input, input.readInt(true));
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (!path) path = name;
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.bones = vertices.bones;
                    mesh.vertices = vertices.vertices;
                    mesh.worldVerticesLength = vertices.length;
                    mesh.triangles = triangles;
                    mesh.regionUVs = uvs;
                    if (sequence == null) mesh.updateRegion();
                    mesh.hullLength = hullLength << 1;
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.edges = edges;
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    return mesh;
                }
            case $41d6f0e7ee5e1c25$var$AttachmentType.LinkedMesh:
                {
                    const path = (flags & 16) != 0 ? input.readStringRef() : name;
                    if (path == null) throw new Error("Path of linked mesh must not be null");
                    const color = (flags & 32) != 0 ? input.readInt32() : 0xffffffff;
                    const sequence = (flags & 64) != 0 ? this.readSequence(input) : null;
                    const inheritTimelines = (flags & 128) != 0;
                    const skinIndex = input.readInt(true);
                    const parent = input.readStringRef();
                    let width = 0, height = 0;
                    if (nonessential) {
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    this.linkedMeshes.push(new $41d6f0e7ee5e1c25$var$LinkedMesh(mesh, skinIndex, slotIndex, parent, inheritTimelines));
                    return mesh;
                }
            case $41d6f0e7ee5e1c25$var$AttachmentType.Path:
                {
                    const closed = (flags & 16) != 0;
                    const constantSpeed = (flags & 32) != 0;
                    const vertices = this.readVertices(input, (flags & 64) != 0);
                    const lengths = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newArray(vertices.length / 6, 0);
                    for(let i = 0, n = lengths.length; i < n; i++)lengths[i] = input.readFloat() * scale;
                    const color = nonessential ? input.readInt32() : 0;
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = closed;
                    path.constantSpeed = constantSpeed;
                    path.worldVerticesLength = vertices.length;
                    path.vertices = vertices.vertices;
                    path.bones = vertices.bones;
                    path.lengths = lengths;
                    if (nonessential) (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(path.color, color);
                    return path;
                }
            case $41d6f0e7ee5e1c25$var$AttachmentType.Point:
                {
                    const rotation = input.readFloat();
                    const x = input.readFloat();
                    const y = input.readFloat();
                    const color = nonessential ? input.readInt32() : 0;
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = x * scale;
                    point.y = y * scale;
                    point.rotation = rotation;
                    if (nonessential) (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(point.color, color);
                    return point;
                }
            case $41d6f0e7ee5e1c25$var$AttachmentType.Clipping:
                {
                    const endSlotIndex = input.readInt(true);
                    const vertices = this.readVertices(input, (flags & 16) != 0);
                    let color = nonessential ? input.readInt32() : 0;
                    let clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    clip.endSlot = skeletonData.slots[endSlotIndex];
                    clip.worldVerticesLength = vertices.length;
                    clip.vertices = vertices.vertices;
                    clip.bones = vertices.bones;
                    if (nonessential) (0, $bdd8805cee4a5602$export$892596cec99bc70e).rgba8888ToColor(clip.color, color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(input) {
        let sequence = new (0, $50aa82091c41d06e$export$edde1bcb1b2b310e)(input.readInt(true));
        sequence.start = input.readInt(true);
        sequence.digits = input.readInt(true);
        sequence.setupIndex = input.readInt(true);
        return sequence;
    }
    readVertices(input, weighted) {
        const scale = this.scale;
        const vertexCount = input.readInt(true);
        const vertices = new $41d6f0e7ee5e1c25$var$Vertices();
        vertices.length = vertexCount << 1;
        if (!weighted) {
            vertices.vertices = this.readFloatArray(input, vertices.length, scale);
            return vertices;
        }
        let weights = new Array();
        let bonesArray = new Array();
        for(let i = 0; i < vertexCount; i++){
            let boneCount = input.readInt(true);
            bonesArray.push(boneCount);
            for(let ii = 0; ii < boneCount; ii++){
                bonesArray.push(input.readInt(true));
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat());
            }
        }
        vertices.vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).toFloatArray(weights);
        vertices.bones = bonesArray;
        return vertices;
    }
    readFloatArray(input, n, scale) {
        let array = new Array(n);
        if (scale == 1) for(let i = 0; i < n; i++)array[i] = input.readFloat();
        else for(let i = 0; i < n; i++)array[i] = input.readFloat() * scale;
        return array;
    }
    readShortArray(input, n) {
        let array = new Array(n);
        for(let i = 0; i < n; i++)array[i] = input.readInt(true);
        return array;
    }
    readAnimation(input, name, skeletonData) {
        input.readInt(true); // Number of timelines.
        let timelines = new Array();
        let scale = this.scale;
        // Slot timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let timelineType = input.readByte();
                let frameCount = input.readInt(true);
                let frameLast = frameCount - 1;
                switch(timelineType){
                    case $41d6f0e7ee5e1c25$var$SLOT_ATTACHMENT:
                        {
                            let timeline = new (0, $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d)(frameCount, slotIndex);
                            for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat(), input.readStringRef());
                            timelines.push(timeline);
                            break;
                        }
                    case $41d6f0e7ee5e1c25$var$SLOT_RGBA:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $bbeb79d5adec7b97$export$84cf3a3e225bcbdc)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let a = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let r2 = input.readUnsignedByte() / 255.0;
                                let g2 = input.readUnsignedByte() / 255.0;
                                let b2 = input.readUnsignedByte() / 255.0;
                                let a2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, a2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                                a = a2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $41d6f0e7ee5e1c25$var$SLOT_RGB:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $bbeb79d5adec7b97$export$e179fb669ddccfa9)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let r2 = input.readUnsignedByte() / 255.0;
                                let g2 = input.readUnsignedByte() / 255.0;
                                let b2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $41d6f0e7ee5e1c25$var$SLOT_RGBA2:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $bbeb79d5adec7b97$export$6fc6620d97c53689)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let a = input.readUnsignedByte() / 255.0;
                            let r2 = input.readUnsignedByte() / 255.0;
                            let g2 = input.readUnsignedByte() / 255.0;
                            let b2 = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a, r2, g2, b2);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let nr = input.readUnsignedByte() / 255.0;
                                let ng = input.readUnsignedByte() / 255.0;
                                let nb = input.readUnsignedByte() / 255.0;
                                let na = input.readUnsignedByte() / 255.0;
                                let nr2 = input.readUnsignedByte() / 255.0;
                                let ng2 = input.readUnsignedByte() / 255.0;
                                let nb2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, na, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, r2, nr2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, g2, ng2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 6, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                a = na;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $41d6f0e7ee5e1c25$var$SLOT_RGB2:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $bbeb79d5adec7b97$export$a12960afd309a230)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let r2 = input.readUnsignedByte() / 255.0;
                            let g2 = input.readUnsignedByte() / 255.0;
                            let b2 = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, r2, g2, b2);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let nr = input.readUnsignedByte() / 255.0;
                                let ng = input.readUnsignedByte() / 255.0;
                                let nb = input.readUnsignedByte() / 255.0;
                                let nr2 = input.readUnsignedByte() / 255.0;
                                let ng2 = input.readUnsignedByte() / 255.0;
                                let nb2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, r2, nr2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, g2, ng2, 1);
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $41d6f0e7ee5e1c25$var$SLOT_ALPHA:
                        {
                            let timeline = new (0, $bbeb79d5adec7b97$export$2211be7c5ccde97b)(frameCount, input.readInt(true), slotIndex);
                            let time = input.readFloat(), a = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, a);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let a2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, a, a2, 1);
                                }
                                time = time2;
                                a = a2;
                            }
                            timelines.push(timeline);
                        }
                }
            }
        }
        // Bone timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let boneIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let type = input.readByte(), frameCount = input.readInt(true);
                if (type == $41d6f0e7ee5e1c25$var$BONE_INHERIT) {
                    let timeline = new (0, $bbeb79d5adec7b97$export$7582beb1c1258b21)(frameCount, boneIndex);
                    for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat(), input.readByte());
                    timelines.push(timeline);
                    continue;
                }
                let bezierCount = input.readInt(true);
                switch(type){
                    case $41d6f0e7ee5e1c25$var$BONE_ROTATE:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$b7ecb8f68b3e130b)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_TRANSLATE:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline2(input, new (0, $bbeb79d5adec7b97$export$eb93bf27829ae703)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_TRANSLATEX:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$cf49491eb4394eca)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_TRANSLATEY:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$6540b7ba297d3e41)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_SCALE:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline2(input, new (0, $bbeb79d5adec7b97$export$be544e22f6ad7737)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_SCALEX:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$407a9cf4df59ebda)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_SCALEY:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$cc13ceba88ef3794)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_SHEAR:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline2(input, new (0, $bbeb79d5adec7b97$export$4da82436a1a0d773)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_SHEARX:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$2392b1c4c21acaf8)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$BONE_SHEARY:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$f65148e1d95352fd)(frameCount, bezierCount, boneIndex), 1));
                }
            }
        }
        // IK constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true), frameCount = input.readInt(true), frameLast = frameCount - 1;
            let timeline = new (0, $bbeb79d5adec7b97$export$73d125cd89dead44)(frameCount, input.readInt(true), index);
            let flags = input.readByte();
            let time = input.readFloat(), mix = (flags & 1) != 0 ? (flags & 2) != 0 ? input.readFloat() : 1 : 0;
            let softness = (flags & 4) != 0 ? input.readFloat() * scale : 0;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, (flags & 8) != 0 ? 1 : -1, (flags & 16) != 0, (flags & 32) != 0);
                if (frame == frameLast) break;
                flags = input.readByte();
                const time2 = input.readFloat(), mix2 = (flags & 1) != 0 ? (flags & 2) != 0 ? input.readFloat() : 1 : 0;
                const softness2 = (flags & 4) != 0 ? input.readFloat() * scale : 0;
                if ((flags & 64) != 0) timeline.setStepped(frame);
                else if ((flags & 128) != 0) {
                    $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mix, mix2, 1);
                    $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
            }
            timelines.push(timeline);
        }
        // Transform constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true), frameCount = input.readInt(true), frameLast = frameCount - 1;
            let timeline = new (0, $bbeb79d5adec7b97$export$a7a393c2ad815ac7)(frameCount, input.readInt(true), index);
            let time = input.readFloat(), mixRotate = input.readFloat(), mixX = input.readFloat(), mixY = input.readFloat(), mixScaleX = input.readFloat(), mixScaleY = input.readFloat(), mixShearY = input.readFloat();
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                if (frame == frameLast) break;
                let time2 = input.readFloat(), mixRotate2 = input.readFloat(), mixX2 = input.readFloat(), mixY2 = input.readFloat(), mixScaleX2 = input.readFloat(), mixScaleY2 = input.readFloat(), mixShearY2 = input.readFloat();
                switch(input.readByte()){
                    case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                        timeline.setStepped(frame);
                        break;
                    case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                        $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixShearY = mixShearY2;
            }
            timelines.push(timeline);
        }
        // Path constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true);
            let data = skeletonData.pathConstraints[index];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const type = input.readByte(), frameCount = input.readInt(true), bezierCount = input.readInt(true);
                switch(type){
                    case $41d6f0e7ee5e1c25$var$PATH_POSITION:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$7ce7e67fd9cc52ed)(frameCount, bezierCount, index), data.positionMode == (0, $df278a6379229a7a$export$34d637c671e1e906).Fixed ? scale : 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PATH_SPACING:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$17ee50c08a07e62b)(frameCount, bezierCount, index), data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Fixed ? scale : 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PATH_MIX:
                        let timeline = new (0, $bbeb79d5adec7b97$export$ea67b41755485038)(frameCount, bezierCount, index);
                        let time = input.readFloat(), mixRotate = input.readFloat(), mixX = input.readFloat(), mixY = input.readFloat();
                        for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
                            timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                            if (frame == frameLast) break;
                            let time2 = input.readFloat(), mixRotate2 = input.readFloat(), mixX2 = input.readFloat(), mixY2 = input.readFloat();
                            switch(input.readByte()){
                                case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                    timeline.setStepped(frame);
                                    break;
                                case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                    $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                                    $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                                    $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                            }
                            time = time2;
                            mixRotate = mixRotate2;
                            mixX = mixX2;
                            mixY = mixY2;
                        }
                        timelines.push(timeline);
                }
            }
        }
        // Physics timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true) - 1;
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const type = input.readByte(), frameCount = input.readInt(true);
                if (type == $41d6f0e7ee5e1c25$var$PHYSICS_RESET) {
                    const timeline = new (0, $bbeb79d5adec7b97$export$956f20308bfd17e0)(frameCount, index);
                    for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat());
                    timelines.push(timeline);
                    continue;
                }
                const bezierCount = input.readInt(true);
                switch(type){
                    case $41d6f0e7ee5e1c25$var$PHYSICS_INERTIA:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$8d7d2ed36692a76a)(frameCount, bezierCount, index), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PHYSICS_STRENGTH:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$92ee7da35e84339e)(frameCount, bezierCount, index), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PHYSICS_DAMPING:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$cd77a164f9089126)(frameCount, bezierCount, index), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PHYSICS_MASS:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$cc37bc88e0605a66)(frameCount, bezierCount, index), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PHYSICS_WIND:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$3e123ca078024d61)(frameCount, bezierCount, index), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PHYSICS_GRAVITY:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$f321d2d075d42a88)(frameCount, bezierCount, index), 1));
                        break;
                    case $41d6f0e7ee5e1c25$var$PHYSICS_MIX:
                        timelines.push($41d6f0e7ee5e1c25$var$readTimeline1(input, new (0, $bbeb79d5adec7b97$export$e3ce1f2c0b6ae580)(frameCount, bezierCount, index), 1));
                }
            }
        }
        // Deform timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let skin = skeletonData.skins[input.readInt(true)];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let slotIndex = input.readInt(true);
                for(let iii = 0, nnn = input.readInt(true); iii < nnn; iii++){
                    let attachmentName = input.readStringRef();
                    if (!attachmentName) throw new Error("attachmentName must not be null.");
                    let attachment = skin.getAttachment(slotIndex, attachmentName);
                    let timelineType = input.readByte();
                    let frameCount = input.readInt(true);
                    let frameLast = frameCount - 1;
                    switch(timelineType){
                        case $41d6f0e7ee5e1c25$var$ATTACHMENT_DEFORM:
                            {
                                let vertexAttachment = attachment;
                                let weighted = vertexAttachment.bones;
                                let vertices = vertexAttachment.vertices;
                                let deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                                let bezierCount = input.readInt(true);
                                let timeline = new (0, $bbeb79d5adec7b97$export$6968d40e5689ad6b)(frameCount, bezierCount, slotIndex, vertexAttachment);
                                let time = input.readFloat();
                                for(let frame = 0, bezier = 0;; frame++){
                                    let deform;
                                    let end = input.readInt(true);
                                    if (end == 0) deform = weighted ? (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                                    else {
                                        deform = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(deformLength);
                                        let start = input.readInt(true);
                                        end += start;
                                        if (scale == 1) for(let v = start; v < end; v++)deform[v] = input.readFloat();
                                        else for(let v = start; v < end; v++)deform[v] = input.readFloat() * scale;
                                        if (!weighted) for(let v = 0, vn = deform.length; v < vn; v++)deform[v] += vertices[v];
                                    }
                                    timeline.setFrame(frame, time, deform);
                                    if (frame == frameLast) break;
                                    let time2 = input.readFloat();
                                    switch(input.readByte()){
                                        case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                                            timeline.setStepped(frame);
                                            break;
                                        case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                                            $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, 0, 1, 1);
                                    }
                                    time = time2;
                                }
                                timelines.push(timeline);
                                break;
                            }
                        case $41d6f0e7ee5e1c25$var$ATTACHMENT_SEQUENCE:
                            {
                                let timeline = new (0, $bbeb79d5adec7b97$export$2687f324e8496672)(frameCount, slotIndex, attachment);
                                for(let frame = 0; frame < frameCount; frame++){
                                    let time = input.readFloat();
                                    let modeAndIndex = input.readInt32();
                                    timeline.setFrame(frame, time, (0, $50aa82091c41d06e$export$3d518da8d966a9f5)[modeAndIndex & 0xf], modeAndIndex >> 4, input.readFloat());
                                }
                                timelines.push(timeline);
                                break;
                            }
                    }
                }
            }
        }
        // Draw order timeline.
        let drawOrderCount = input.readInt(true);
        if (drawOrderCount > 0) {
            let timeline = new (0, $bbeb79d5adec7b97$export$ece1f7c41d051e83)(drawOrderCount);
            let slotCount = skeletonData.slots.length;
            for(let i = 0; i < drawOrderCount; i++){
                let time = input.readFloat();
                let offsetCount = input.readInt(true);
                let drawOrder = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newArray(slotCount, 0);
                for(let ii = slotCount - 1; ii >= 0; ii--)drawOrder[ii] = -1;
                let unchanged = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newArray(slotCount - offsetCount, 0);
                let originalIndex = 0, unchangedIndex = 0;
                for(let ii = 0; ii < offsetCount; ii++){
                    let slotIndex = input.readInt(true);
                    // Collect unchanged items.
                    while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                    // Set changed items.
                    drawOrder[originalIndex + input.readInt(true)] = originalIndex++;
                }
                // Collect remaining unchanged items.
                while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                // Fill in unchanged items.
                for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                timeline.setFrame(i, time, drawOrder);
            }
            timelines.push(timeline);
        }
        // Event timeline.
        let eventCount = input.readInt(true);
        if (eventCount > 0) {
            let timeline = new (0, $bbeb79d5adec7b97$export$4f4bca996c586084)(eventCount);
            for(let i = 0; i < eventCount; i++){
                let time = input.readFloat();
                let eventData = skeletonData.events[input.readInt(true)];
                let event = new (0, $38575b550a322281$export$d61e24a684f9e51)(time, eventData);
                event.intValue = input.readInt(false);
                event.floatValue = input.readFloat();
                event.stringValue = input.readString();
                if (event.stringValue == null) event.stringValue = eventData.stringValue;
                if (event.data.audioPath) {
                    event.volume = input.readFloat();
                    event.balance = input.readFloat();
                }
                timeline.setFrame(i, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        return new (0, $bbeb79d5adec7b97$export$c35d437ae5945fcd)(name, timelines, duration);
    }
}
class $41d6f0e7ee5e1c25$export$c8e921ea3330f774 {
    strings;
    index;
    buffer;
    constructor(data, strings = new Array(), index = 0, buffer = new DataView(data instanceof ArrayBuffer ? data : data.buffer)){
        this.strings = strings;
        this.index = index;
        this.buffer = buffer;
    }
    readByte() {
        return this.buffer.getInt8(this.index++);
    }
    readUnsignedByte() {
        return this.buffer.getUint8(this.index++);
    }
    readShort() {
        let value = this.buffer.getInt16(this.index);
        this.index += 2;
        return value;
    }
    readInt32() {
        let value = this.buffer.getInt32(this.index);
        this.index += 4;
        return value;
    }
    readInt(optimizePositive) {
        let b = this.readByte();
        let result = b & 0x7F;
        if ((b & 0x80) != 0) {
            b = this.readByte();
            result |= (b & 0x7F) << 7;
            if ((b & 0x80) != 0) {
                b = this.readByte();
                result |= (b & 0x7F) << 14;
                if ((b & 0x80) != 0) {
                    b = this.readByte();
                    result |= (b & 0x7F) << 21;
                    if ((b & 0x80) != 0) {
                        b = this.readByte();
                        result |= (b & 0x7F) << 28;
                    }
                }
            }
        }
        return optimizePositive ? result : result >>> 1 ^ -(result & 1);
    }
    readStringRef() {
        let index = this.readInt(true);
        return index == 0 ? null : this.strings[index - 1];
    }
    readString() {
        let byteCount = this.readInt(true);
        switch(byteCount){
            case 0:
                return null;
            case 1:
                return "";
        }
        byteCount--;
        let chars = "";
        let charCount = 0;
        for(let i = 0; i < byteCount;){
            let b = this.readUnsignedByte();
            switch(b >> 4){
                case 12:
                case 13:
                    chars += String.fromCharCode((b & 0x1F) << 6 | this.readByte() & 0x3F);
                    i += 2;
                    break;
                case 14:
                    chars += String.fromCharCode((b & 0x0F) << 12 | (this.readByte() & 0x3F) << 6 | this.readByte() & 0x3F);
                    i += 3;
                    break;
                default:
                    chars += String.fromCharCode(b);
                    i++;
            }
        }
        return chars;
    }
    readFloat() {
        let value = this.buffer.getFloat32(this.index);
        this.index += 4;
        return value;
    }
    readBoolean() {
        return this.readByte() != 0;
    }
}
class $41d6f0e7ee5e1c25$var$LinkedMesh {
    parent;
    skinIndex;
    slotIndex;
    mesh;
    inheritTimeline;
    constructor(mesh, skinIndex, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skinIndex = skinIndex;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
class $41d6f0e7ee5e1c25$var$Vertices {
    bones;
    vertices;
    length;
    constructor(bones = null, vertices = null, length = 0){
        this.bones = bones;
        this.vertices = vertices;
        this.length = length;
    }
}
var $41d6f0e7ee5e1c25$var$AttachmentType;
(function(AttachmentType) {
    AttachmentType[AttachmentType["Region"] = 0] = "Region";
    AttachmentType[AttachmentType["BoundingBox"] = 1] = "BoundingBox";
    AttachmentType[AttachmentType["Mesh"] = 2] = "Mesh";
    AttachmentType[AttachmentType["LinkedMesh"] = 3] = "LinkedMesh";
    AttachmentType[AttachmentType["Path"] = 4] = "Path";
    AttachmentType[AttachmentType["Point"] = 5] = "Point";
    AttachmentType[AttachmentType["Clipping"] = 6] = "Clipping";
})($41d6f0e7ee5e1c25$var$AttachmentType || ($41d6f0e7ee5e1c25$var$AttachmentType = {}));
function $41d6f0e7ee5e1c25$var$readTimeline1(input, timeline, scale) {
    let time = input.readFloat(), value = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value);
        if (frame == frameLast) break;
        let time2 = input.readFloat(), value2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value, value2, scale);
        }
        time = time2;
        value = value2;
    }
    return timeline;
}
function $41d6f0e7ee5e1c25$var$readTimeline2(input, timeline, scale) {
    let time = input.readFloat(), value1 = input.readFloat() * scale, value2 = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        if (frame == frameLast) break;
        let time2 = input.readFloat(), nvalue1 = input.readFloat() * scale, nvalue2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $41d6f0e7ee5e1c25$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $41d6f0e7ee5e1c25$var$CURVE_BEZIER:
                $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value1, nvalue1, scale);
                $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
    }
    return timeline;
}
function $41d6f0e7ee5e1c25$var$setBezier(input, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    timeline.setBezier(bezier, frame, value, time1, value1, input.readFloat(), input.readFloat() * scale, input.readFloat(), input.readFloat() * scale, time2, value2);
}
const $41d6f0e7ee5e1c25$var$BONE_ROTATE = 0;
const $41d6f0e7ee5e1c25$var$BONE_TRANSLATE = 1;
const $41d6f0e7ee5e1c25$var$BONE_TRANSLATEX = 2;
const $41d6f0e7ee5e1c25$var$BONE_TRANSLATEY = 3;
const $41d6f0e7ee5e1c25$var$BONE_SCALE = 4;
const $41d6f0e7ee5e1c25$var$BONE_SCALEX = 5;
const $41d6f0e7ee5e1c25$var$BONE_SCALEY = 6;
const $41d6f0e7ee5e1c25$var$BONE_SHEAR = 7;
const $41d6f0e7ee5e1c25$var$BONE_SHEARX = 8;
const $41d6f0e7ee5e1c25$var$BONE_SHEARY = 9;
const $41d6f0e7ee5e1c25$var$BONE_INHERIT = 10;
const $41d6f0e7ee5e1c25$var$SLOT_ATTACHMENT = 0;
const $41d6f0e7ee5e1c25$var$SLOT_RGBA = 1;
const $41d6f0e7ee5e1c25$var$SLOT_RGB = 2;
const $41d6f0e7ee5e1c25$var$SLOT_RGBA2 = 3;
const $41d6f0e7ee5e1c25$var$SLOT_RGB2 = 4;
const $41d6f0e7ee5e1c25$var$SLOT_ALPHA = 5;
const $41d6f0e7ee5e1c25$var$ATTACHMENT_DEFORM = 0;
const $41d6f0e7ee5e1c25$var$ATTACHMENT_SEQUENCE = 1;
const $41d6f0e7ee5e1c25$var$PATH_POSITION = 0;
const $41d6f0e7ee5e1c25$var$PATH_SPACING = 1;
const $41d6f0e7ee5e1c25$var$PATH_MIX = 2;
const $41d6f0e7ee5e1c25$var$PHYSICS_INERTIA = 0;
const $41d6f0e7ee5e1c25$var$PHYSICS_STRENGTH = 1;
const $41d6f0e7ee5e1c25$var$PHYSICS_DAMPING = 2;
const $41d6f0e7ee5e1c25$var$PHYSICS_MASS = 4;
const $41d6f0e7ee5e1c25$var$PHYSICS_WIND = 5;
const $41d6f0e7ee5e1c25$var$PHYSICS_GRAVITY = 6;
const $41d6f0e7ee5e1c25$var$PHYSICS_MIX = 7;
const $41d6f0e7ee5e1c25$var$PHYSICS_RESET = 8;
const $41d6f0e7ee5e1c25$var$CURVE_LINEAR = 0;
const $41d6f0e7ee5e1c25$var$CURVE_STEPPED = 1;
const $41d6f0e7ee5e1c25$var$CURVE_BEZIER = 2;


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $2314eb20fe3b2503$export$119f1746fc062f5e {
    /** The left edge of the axis aligned bounding box. */ minX = 0;
    /** The bottom edge of the axis aligned bounding box. */ minY = 0;
    /** The right edge of the axis aligned bounding box. */ maxX = 0;
    /** The top edge of the axis aligned bounding box. */ maxY = 0;
    /** The visible bounding boxes. */ boundingBoxes = new Array();
    /** The world vertices for the bounding box polygons. */ polygons = new Array();
    polygonPool = new (0, $bdd8805cee4a5602$export$14963ee5c8637e11)(()=>{
        return (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(16);
    });
    /** Clears any previous polygons, finds all visible bounding box attachments, and computes the world vertices for each bounding
     * box's polygon.
     * @param updateAabb If true, the axis aligned bounding box containing all the polygons is computed. If false, the
     *           SkeletonBounds AABB methods will always return true. */ update(skeleton, updateAabb) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        let boundingBoxes = this.boundingBoxes;
        let polygons = this.polygons;
        let polygonPool = this.polygonPool;
        let slots = skeleton.slots;
        let slotCount = slots.length;
        boundingBoxes.length = 0;
        polygonPool.freeAll(polygons);
        polygons.length = 0;
        for(let i = 0; i < slotCount; i++){
            let slot = slots[i];
            if (!slot.bone.active) continue;
            let attachment = slot.getAttachment();
            if (attachment instanceof (0, $fbef049ae3c3cd60$export$9538c439c6b85ad2)) {
                let boundingBox = attachment;
                boundingBoxes.push(boundingBox);
                let polygon = polygonPool.obtain();
                if (polygon.length != boundingBox.worldVerticesLength) polygon = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(boundingBox.worldVerticesLength);
                polygons.push(polygon);
                boundingBox.computeWorldVertices(slot, 0, boundingBox.worldVerticesLength, polygon, 0, 2);
            }
        }
        if (updateAabb) this.aabbCompute();
        else {
            this.minX = Number.POSITIVE_INFINITY;
            this.minY = Number.POSITIVE_INFINITY;
            this.maxX = Number.NEGATIVE_INFINITY;
            this.maxY = Number.NEGATIVE_INFINITY;
        }
    }
    aabbCompute() {
        let minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++){
            let polygon = polygons[i];
            let vertices = polygon;
            for(let ii = 0, nn = polygon.length; ii < nn; ii += 2){
                let x = vertices[ii];
                let y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /** Returns true if the axis aligned bounding box contains the point. */ aabbContainsPoint(x, y) {
        return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
    }
    /** Returns true if the axis aligned bounding box intersects the line segment. */ aabbIntersectsSegment(x1, y1, x2, y2) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        if (x1 <= minX && x2 <= minX || y1 <= minY && y2 <= minY || x1 >= maxX && x2 >= maxX || y1 >= maxY && y2 >= maxY) return false;
        let m = (y2 - y1) / (x2 - x1);
        let y = m * (minX - x1) + y1;
        if (y > minY && y < maxY) return true;
        y = m * (maxX - x1) + y1;
        if (y > minY && y < maxY) return true;
        let x = (minY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        x = (maxY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        return false;
    }
    /** Returns true if the axis aligned bounding box intersects the axis aligned bounding box of the specified bounds. */ aabbIntersectsSkeleton(bounds) {
        return this.minX < bounds.maxX && this.maxX > bounds.minX && this.minY < bounds.maxY && this.maxY > bounds.minY;
    }
    /** Returns the first bounding box attachment that contains the point, or null. When doing many checks, it is usually more
     * efficient to only call this method if {@link #aabbContainsPoint(float, float)} returns true. */ containsPoint(x, y) {
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++)if (this.containsPointPolygon(polygons[i], x, y)) return this.boundingBoxes[i];
        return null;
    }
    /** Returns true if the polygon contains the point. */ containsPointPolygon(polygon, x, y) {
        let vertices = polygon;
        let nn = polygon.length;
        let prevIndex = nn - 2;
        let inside = false;
        for(let ii = 0; ii < nn; ii += 2){
            let vertexY = vertices[ii + 1];
            let prevY = vertices[prevIndex + 1];
            if (vertexY < y && prevY >= y || prevY < y && vertexY >= y) {
                let vertexX = vertices[ii];
                if (vertexX + (y - vertexY) / (prevY - vertexY) * (vertices[prevIndex] - vertexX) < x) inside = !inside;
            }
            prevIndex = ii;
        }
        return inside;
    }
    /** Returns the first bounding box attachment that contains any part of the line segment, or null. When doing many checks, it
     * is usually more efficient to only call this method if {@link #aabbIntersectsSegment()} returns
     * true. */ intersectsSegment(x1, y1, x2, y2) {
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++)if (this.intersectsSegmentPolygon(polygons[i], x1, y1, x2, y2)) return this.boundingBoxes[i];
        return null;
    }
    /** Returns true if the polygon contains any part of the line segment. */ intersectsSegmentPolygon(polygon, x1, y1, x2, y2) {
        let vertices = polygon;
        let nn = polygon.length;
        let width12 = x1 - x2, height12 = y1 - y2;
        let det1 = x1 * y2 - y1 * x2;
        let x3 = vertices[nn - 2], y3 = vertices[nn - 1];
        for(let ii = 0; ii < nn; ii += 2){
            let x4 = vertices[ii], y4 = vertices[ii + 1];
            let det2 = x3 * y4 - y3 * x4;
            let width34 = x3 - x4, height34 = y3 - y4;
            let det3 = width12 * height34 - height12 * width34;
            let x = (det1 * width34 - width12 * det2) / det3;
            if ((x >= x3 && x <= x4 || x >= x4 && x <= x3) && (x >= x1 && x <= x2 || x >= x2 && x <= x1)) {
                let y = (det1 * height34 - height12 * det2) / det3;
                if ((y >= y3 && y <= y4 || y >= y4 && y <= y3) && (y >= y1 && y <= y2 || y >= y2 && y <= y1)) return true;
            }
            x3 = x4;
            y3 = y4;
        }
        return false;
    }
    /** Returns the polygon for the specified bounding box, or null. */ getPolygon(boundingBox) {
        if (!boundingBox) throw new Error("boundingBox cannot be null.");
        let index = this.boundingBoxes.indexOf(boundingBox);
        return index == -1 ? null : this.polygons[index];
    }
    /** The width of the axis aligned bounding box. */ getWidth() {
        return this.maxX - this.minX;
    }
    /** The height of the axis aligned bounding box. */ getHeight() {
        return this.maxY - this.minY;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $8bdeed2aaa83b562$export$2af2b14d1e1cb475 {
    convexPolygons = new Array();
    convexPolygonsIndices = new Array();
    indicesArray = new Array();
    isConcaveArray = new Array();
    triangles = new Array();
    polygonPool = new (0, $bdd8805cee4a5602$export$14963ee5c8637e11)(()=>{
        return new Array();
    });
    polygonIndicesPool = new (0, $bdd8805cee4a5602$export$14963ee5c8637e11)(()=>{
        return new Array();
    });
    triangulate(verticesArray) {
        let vertices = verticesArray;
        let vertexCount = verticesArray.length >> 1;
        let indices = this.indicesArray;
        indices.length = 0;
        for(let i = 0; i < vertexCount; i++)indices[i] = i;
        let isConcave = this.isConcaveArray;
        isConcave.length = 0;
        for(let i = 0, n = vertexCount; i < n; ++i)isConcave[i] = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.isConcave(i, vertexCount, vertices, indices);
        let triangles = this.triangles;
        triangles.length = 0;
        while(vertexCount > 3){
            // Find ear tip.
            let previous = vertexCount - 1, i = 0, next = 1;
            while(true){
                outer: if (!isConcave[i]) {
                    let p1 = indices[previous] << 1, p2 = indices[i] << 1, p3 = indices[next] << 1;
                    let p1x = vertices[p1], p1y = vertices[p1 + 1];
                    let p2x = vertices[p2], p2y = vertices[p2 + 1];
                    let p3x = vertices[p3], p3y = vertices[p3 + 1];
                    for(let ii = (next + 1) % vertexCount; ii != previous; ii = (ii + 1) % vertexCount){
                        if (!isConcave[ii]) continue;
                        let v = indices[ii] << 1;
                        let vx = vertices[v], vy = vertices[v + 1];
                        if ($8bdeed2aaa83b562$export$2af2b14d1e1cb475.positiveArea(p3x, p3y, p1x, p1y, vx, vy)) {
                            if ($8bdeed2aaa83b562$export$2af2b14d1e1cb475.positiveArea(p1x, p1y, p2x, p2y, vx, vy)) {
                                if ($8bdeed2aaa83b562$export$2af2b14d1e1cb475.positiveArea(p2x, p2y, p3x, p3y, vx, vy)) break outer;
                            }
                        }
                    }
                    break;
                }
                if (next == 0) {
                    do {
                        if (!isConcave[i]) break;
                        i--;
                    }while (i > 0);
                    break;
                }
                previous = i;
                i = next;
                next = (next + 1) % vertexCount;
            }
            // Cut ear tip.
            triangles.push(indices[(vertexCount + i - 1) % vertexCount]);
            triangles.push(indices[i]);
            triangles.push(indices[(i + 1) % vertexCount]);
            indices.splice(i, 1);
            isConcave.splice(i, 1);
            vertexCount--;
            let previousIndex = (vertexCount + i - 1) % vertexCount;
            let nextIndex = i == vertexCount ? 0 : i;
            isConcave[previousIndex] = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.isConcave(previousIndex, vertexCount, vertices, indices);
            isConcave[nextIndex] = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.isConcave(nextIndex, vertexCount, vertices, indices);
        }
        if (vertexCount == 3) {
            triangles.push(indices[2]);
            triangles.push(indices[0]);
            triangles.push(indices[1]);
        }
        return triangles;
    }
    decompose(verticesArray, triangles) {
        let vertices = verticesArray;
        let convexPolygons = this.convexPolygons;
        this.polygonPool.freeAll(convexPolygons);
        convexPolygons.length = 0;
        let convexPolygonsIndices = this.convexPolygonsIndices;
        this.polygonIndicesPool.freeAll(convexPolygonsIndices);
        convexPolygonsIndices.length = 0;
        let polygonIndices = this.polygonIndicesPool.obtain();
        polygonIndices.length = 0;
        let polygon = this.polygonPool.obtain();
        polygon.length = 0;
        // Merge subsequent triangles if they form a triangle fan.
        let fanBaseIndex = -1, lastWinding = 0;
        for(let i = 0, n = triangles.length; i < n; i += 3){
            let t1 = triangles[i] << 1, t2 = triangles[i + 1] << 1, t3 = triangles[i + 2] << 1;
            let x1 = vertices[t1], y1 = vertices[t1 + 1];
            let x2 = vertices[t2], y2 = vertices[t2 + 1];
            let x3 = vertices[t3], y3 = vertices[t3 + 1];
            // If the base of the last triangle is the same as this triangle, check if they form a convex polygon (triangle fan).
            let merged = false;
            if (fanBaseIndex == t1) {
                let o = polygon.length - 4;
                let winding1 = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.winding(polygon[o], polygon[o + 1], polygon[o + 2], polygon[o + 3], x3, y3);
                let winding2 = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.winding(x3, y3, polygon[0], polygon[1], polygon[2], polygon[3]);
                if (winding1 == lastWinding && winding2 == lastWinding) {
                    polygon.push(x3);
                    polygon.push(y3);
                    polygonIndices.push(t3);
                    merged = true;
                }
            }
            // Otherwise make this triangle the new base.
            if (!merged) {
                if (polygon.length > 0) {
                    convexPolygons.push(polygon);
                    convexPolygonsIndices.push(polygonIndices);
                } else {
                    this.polygonPool.free(polygon);
                    this.polygonIndicesPool.free(polygonIndices);
                }
                polygon = this.polygonPool.obtain();
                polygon.length = 0;
                polygon.push(x1);
                polygon.push(y1);
                polygon.push(x2);
                polygon.push(y2);
                polygon.push(x3);
                polygon.push(y3);
                polygonIndices = this.polygonIndicesPool.obtain();
                polygonIndices.length = 0;
                polygonIndices.push(t1);
                polygonIndices.push(t2);
                polygonIndices.push(t3);
                lastWinding = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.winding(x1, y1, x2, y2, x3, y3);
                fanBaseIndex = t1;
            }
        }
        if (polygon.length > 0) {
            convexPolygons.push(polygon);
            convexPolygonsIndices.push(polygonIndices);
        }
        // Go through the list of polygons and try to merge the remaining triangles with the found triangle fans.
        for(let i = 0, n = convexPolygons.length; i < n; i++){
            polygonIndices = convexPolygonsIndices[i];
            if (polygonIndices.length == 0) continue;
            let firstIndex = polygonIndices[0];
            let lastIndex = polygonIndices[polygonIndices.length - 1];
            polygon = convexPolygons[i];
            let o = polygon.length - 4;
            let prevPrevX = polygon[o], prevPrevY = polygon[o + 1];
            let prevX = polygon[o + 2], prevY = polygon[o + 3];
            let firstX = polygon[0], firstY = polygon[1];
            let secondX = polygon[2], secondY = polygon[3];
            let winding = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.winding(prevPrevX, prevPrevY, prevX, prevY, firstX, firstY);
            for(let ii = 0; ii < n; ii++){
                if (ii == i) continue;
                let otherIndices = convexPolygonsIndices[ii];
                if (otherIndices.length != 3) continue;
                let otherFirstIndex = otherIndices[0];
                let otherSecondIndex = otherIndices[1];
                let otherLastIndex = otherIndices[2];
                let otherPoly = convexPolygons[ii];
                let x3 = otherPoly[otherPoly.length - 2], y3 = otherPoly[otherPoly.length - 1];
                if (otherFirstIndex != firstIndex || otherSecondIndex != lastIndex) continue;
                let winding1 = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.winding(prevPrevX, prevPrevY, prevX, prevY, x3, y3);
                let winding2 = $8bdeed2aaa83b562$export$2af2b14d1e1cb475.winding(x3, y3, firstX, firstY, secondX, secondY);
                if (winding1 == winding && winding2 == winding) {
                    otherPoly.length = 0;
                    otherIndices.length = 0;
                    polygon.push(x3);
                    polygon.push(y3);
                    polygonIndices.push(otherLastIndex);
                    prevPrevX = prevX;
                    prevPrevY = prevY;
                    prevX = x3;
                    prevY = y3;
                    ii = 0;
                }
            }
        }
        // Remove empty polygons that resulted from the merge step above.
        for(let i = convexPolygons.length - 1; i >= 0; i--){
            polygon = convexPolygons[i];
            if (polygon.length == 0) {
                convexPolygons.splice(i, 1);
                this.polygonPool.free(polygon);
                polygonIndices = convexPolygonsIndices[i];
                convexPolygonsIndices.splice(i, 1);
                this.polygonIndicesPool.free(polygonIndices);
            }
        }
        return convexPolygons;
    }
    static isConcave(index, vertexCount, vertices, indices) {
        let previous = indices[(vertexCount + index - 1) % vertexCount] << 1;
        let current = indices[index] << 1;
        let next = indices[(index + 1) % vertexCount] << 1;
        return !this.positiveArea(vertices[previous], vertices[previous + 1], vertices[current], vertices[current + 1], vertices[next], vertices[next + 1]);
    }
    static positiveArea(p1x, p1y, p2x, p2y, p3x, p3y) {
        return p1x * (p3y - p2y) + p2x * (p1y - p3y) + p3x * (p2y - p1y) >= 0;
    }
    static winding(p1x, p1y, p2x, p2y, p3x, p3y) {
        let px = p2x - p1x, py = p2y - p1y;
        return p3x * py - p3y * px + px * p1y - p1x * py >= 0 ? 1 : -1;
    }
}



class $1db6b0f82e0ea91c$export$40b4063afbb1b315 {
    triangulator = new (0, $8bdeed2aaa83b562$export$2af2b14d1e1cb475)();
    clippingPolygon = new Array();
    clipOutput = new Array();
    clippedVertices = new Array();
    clippedUVs = new Array();
    clippedTriangles = new Array();
    scratch = new Array();
    clipAttachment = null;
    clippingPolygons = null;
    clipStart(slot, clip) {
        if (this.clipAttachment) return 0;
        this.clipAttachment = clip;
        let n = clip.worldVerticesLength;
        let vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.clippingPolygon, n);
        clip.computeWorldVertices(slot, 0, n, vertices, 0, 2);
        let clippingPolygon = this.clippingPolygon;
        $1db6b0f82e0ea91c$export$40b4063afbb1b315.makeClockwise(clippingPolygon);
        let clippingPolygons = this.clippingPolygons = this.triangulator.decompose(clippingPolygon, this.triangulator.triangulate(clippingPolygon));
        for(let i = 0, n = clippingPolygons.length; i < n; i++){
            let polygon = clippingPolygons[i];
            $1db6b0f82e0ea91c$export$40b4063afbb1b315.makeClockwise(polygon);
            polygon.push(polygon[0]);
            polygon.push(polygon[1]);
        }
        return clippingPolygons.length;
    }
    clipEndWithSlot(slot) {
        if (this.clipAttachment && this.clipAttachment.endSlot == slot.data) this.clipEnd();
    }
    clipEnd() {
        if (!this.clipAttachment) return;
        this.clipAttachment = null;
        this.clippingPolygons = null;
        this.clippedVertices.length = 0;
        this.clippedTriangles.length = 0;
        this.clippingPolygon.length = 0;
    }
    isClipping() {
        return this.clipAttachment != null;
    }
    clipTriangles(vertices, verticesLengthOrTriangles, trianglesOrTrianglesLength, trianglesLengthOrUvs, uvsOrLight, lightOrDark, darkOrTwoColor, twoColorParam) {
        // Determine which overload is being used
        let triangles;
        let trianglesLength;
        let uvs;
        let light;
        let dark;
        let twoColor;
        if (typeof verticesLengthOrTriangles === "number") {
            triangles = trianglesOrTrianglesLength;
            trianglesLength = trianglesLengthOrUvs;
            uvs = uvsOrLight;
            light = lightOrDark;
            dark = darkOrTwoColor;
            twoColor = twoColorParam;
        } else {
            triangles = verticesLengthOrTriangles;
            trianglesLength = trianglesOrTrianglesLength;
            uvs = trianglesLengthOrUvs;
            light = uvsOrLight;
            dark = lightOrDark;
            twoColor = darkOrTwoColor;
        }
        if (uvs && light && dark && typeof twoColor === "boolean") this.clipTrianglesRender(vertices, triangles, trianglesLength, uvs, light, dark, twoColor);
        else this.clipTrianglesNoRender(vertices, triangles, trianglesLength);
    }
    clipTrianglesNoRender(vertices, triangles, trianglesLength) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let index = 0;
        clippedVertices.length = 0;
        clippedTriangles.length = 0;
        for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + clipOutputCount * 2);
                    for(let ii = 0; ii < clipOutputLength; ii += 2, s += 2){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++, s += 3){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + 6);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = x2;
                    clippedVerticesItems[s + 3] = y2;
                    clippedVerticesItems[s + 4] = x3;
                    clippedVerticesItems[s + 5] = y3;
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    break;
                }
            }
        }
    }
    clipTrianglesRender(vertices, triangles, trianglesLength, uvs, light, dark, twoColor) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let vertexSize = twoColor ? 12 : 8;
        let index = 0;
        clippedVertices.length = 0;
        clippedTriangles.length = 0;
        for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            let u1 = uvs[vertexOffset], v1 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            let u2 = uvs[vertexOffset], v2 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            let u3 = uvs[vertexOffset], v3 = uvs[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let d0 = y2 - y3, d1 = x3 - x2, d2 = x1 - x3, d4 = y3 - y1;
                    let d = 1 / (d0 * d2 + d1 * (y1 - y3));
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + clipOutputCount * vertexSize);
                    for(let ii = 0; ii < clipOutputLength; ii += 2, s += vertexSize){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                        clippedVerticesItems[s + 2] = light.r;
                        clippedVerticesItems[s + 3] = light.g;
                        clippedVerticesItems[s + 4] = light.b;
                        clippedVerticesItems[s + 5] = light.a;
                        let c0 = x - x3, c1 = y - y3;
                        let a = (d0 * c0 + d1 * c1) * d;
                        let b = (d4 * c0 + d2 * c1) * d;
                        let c = 1 - a - b;
                        clippedVerticesItems[s + 6] = u1 * a + u2 * b + u3 * c;
                        clippedVerticesItems[s + 7] = v1 * a + v2 * b + v3 * c;
                        if (twoColor) {
                            clippedVerticesItems[s + 8] = dark.r;
                            clippedVerticesItems[s + 9] = dark.g;
                            clippedVerticesItems[s + 10] = dark.b;
                            clippedVerticesItems[s + 11] = dark.a;
                        }
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++, s += 3){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + 3 * vertexSize);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = light.r;
                    clippedVerticesItems[s + 3] = light.g;
                    clippedVerticesItems[s + 4] = light.b;
                    clippedVerticesItems[s + 5] = light.a;
                    if (!twoColor) {
                        clippedVerticesItems[s + 6] = u1;
                        clippedVerticesItems[s + 7] = v1;
                        clippedVerticesItems[s + 8] = x2;
                        clippedVerticesItems[s + 9] = y2;
                        clippedVerticesItems[s + 10] = light.r;
                        clippedVerticesItems[s + 11] = light.g;
                        clippedVerticesItems[s + 12] = light.b;
                        clippedVerticesItems[s + 13] = light.a;
                        clippedVerticesItems[s + 14] = u2;
                        clippedVerticesItems[s + 15] = v2;
                        clippedVerticesItems[s + 16] = x3;
                        clippedVerticesItems[s + 17] = y3;
                        clippedVerticesItems[s + 18] = light.r;
                        clippedVerticesItems[s + 19] = light.g;
                        clippedVerticesItems[s + 20] = light.b;
                        clippedVerticesItems[s + 21] = light.a;
                        clippedVerticesItems[s + 22] = u3;
                        clippedVerticesItems[s + 23] = v3;
                    } else {
                        clippedVerticesItems[s + 6] = u1;
                        clippedVerticesItems[s + 7] = v1;
                        clippedVerticesItems[s + 8] = dark.r;
                        clippedVerticesItems[s + 9] = dark.g;
                        clippedVerticesItems[s + 10] = dark.b;
                        clippedVerticesItems[s + 11] = dark.a;
                        clippedVerticesItems[s + 12] = x2;
                        clippedVerticesItems[s + 13] = y2;
                        clippedVerticesItems[s + 14] = light.r;
                        clippedVerticesItems[s + 15] = light.g;
                        clippedVerticesItems[s + 16] = light.b;
                        clippedVerticesItems[s + 17] = light.a;
                        clippedVerticesItems[s + 18] = u2;
                        clippedVerticesItems[s + 19] = v2;
                        clippedVerticesItems[s + 20] = dark.r;
                        clippedVerticesItems[s + 21] = dark.g;
                        clippedVerticesItems[s + 22] = dark.b;
                        clippedVerticesItems[s + 23] = dark.a;
                        clippedVerticesItems[s + 24] = x3;
                        clippedVerticesItems[s + 25] = y3;
                        clippedVerticesItems[s + 26] = light.r;
                        clippedVerticesItems[s + 27] = light.g;
                        clippedVerticesItems[s + 28] = light.b;
                        clippedVerticesItems[s + 29] = light.a;
                        clippedVerticesItems[s + 30] = u3;
                        clippedVerticesItems[s + 31] = v3;
                        clippedVerticesItems[s + 32] = dark.r;
                        clippedVerticesItems[s + 33] = dark.g;
                        clippedVerticesItems[s + 34] = dark.b;
                        clippedVerticesItems[s + 35] = dark.a;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    break;
                }
            }
        }
    }
    clipTrianglesUnpacked(vertices, triangles, trianglesLength, uvs) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices, clippedUVs = this.clippedUVs;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let index = 0;
        clippedVertices.length = 0;
        clippedUVs.length = 0;
        clippedTriangles.length = 0;
        for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            let u1 = uvs[vertexOffset], v1 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            let u2 = uvs[vertexOffset], v2 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            let u3 = uvs[vertexOffset], v3 = uvs[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let d0 = y2 - y3, d1 = x3 - x2, d2 = x1 - x3, d4 = y3 - y1;
                    let d = 1 / (d0 * d2 + d1 * (y1 - y3));
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + clipOutputCount * 2);
                    let clippedUVsItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedUVs, s + clipOutputCount * 2);
                    for(let ii = 0; ii < clipOutputLength; ii += 2, s += 2){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                        let c0 = x - x3, c1 = y - y3;
                        let a = (d0 * c0 + d1 * c1) * d;
                        let b = (d4 * c0 + d2 * c1) * d;
                        let c = 1 - a - b;
                        clippedUVsItems[s] = u1 * a + u2 * b + u3 * c;
                        clippedUVsItems[s + 1] = v1 * a + v2 * b + v3 * c;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++, s += 3){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + 6);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = x2;
                    clippedVerticesItems[s + 3] = y2;
                    clippedVerticesItems[s + 4] = x3;
                    clippedVerticesItems[s + 5] = y3;
                    let clippedUVSItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedUVs, s + 6);
                    clippedUVSItems[s] = u1;
                    clippedUVSItems[s + 1] = v1;
                    clippedUVSItems[s + 2] = u2;
                    clippedUVSItems[s + 3] = v2;
                    clippedUVSItems[s + 4] = u3;
                    clippedUVSItems[s + 5] = v3;
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    break;
                }
            }
        }
    }
    /** Clips the input triangle against the convex, clockwise clipping area. If the triangle lies entirely within the clipping
     * area, false is returned. The clipping area must duplicate the first vertex at the end of the vertices list. */ clip(x1, y1, x2, y2, x3, y3, clippingArea, output) {
        let originalOutput = output;
        let clipped = false;
        // Avoid copy at the end.
        let input;
        if (clippingArea.length % 4 >= 2) {
            input = output;
            output = this.scratch;
        } else input = this.scratch;
        input.length = 0;
        input.push(x1);
        input.push(y1);
        input.push(x2);
        input.push(y2);
        input.push(x3);
        input.push(y3);
        input.push(x1);
        input.push(y1);
        output.length = 0;
        let clippingVerticesLast = clippingArea.length - 4;
        let clippingVertices = clippingArea;
        for(let i = 0;; i += 2){
            let edgeX = clippingVertices[i], edgeY = clippingVertices[i + 1];
            let ex = edgeX - clippingVertices[i + 2], ey = edgeY - clippingVertices[i + 3];
            let outputStart = output.length;
            let inputVertices = input;
            for(let ii = 0, nn = input.length - 2; ii < nn;){
                let inputX = inputVertices[ii], inputY = inputVertices[ii + 1];
                ii += 2;
                let inputX2 = inputVertices[ii], inputY2 = inputVertices[ii + 1];
                let s2 = ey * (edgeX - inputX2) > ex * (edgeY - inputY2);
                let s1 = ey * (edgeX - inputX) - ex * (edgeY - inputY);
                if (s1 > 0) {
                    if (s2) {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                    // v1 inside, v2 outside
                    let ix = inputX2 - inputX, iy = inputY2 - inputY, t = s1 / (ix * ey - iy * ex);
                    if (t >= 0 && t <= 1) {
                        output.push(inputX + ix * t);
                        output.push(inputY + iy * t);
                    } else {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                } else if (s2) {
                    let ix = inputX2 - inputX, iy = inputY2 - inputY, t = s1 / (ix * ey - iy * ex);
                    if (t >= 0 && t <= 1) {
                        output.push(inputX + ix * t);
                        output.push(inputY + iy * t);
                        output.push(inputX2);
                        output.push(inputY2);
                    } else {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                }
                clipped = true;
            }
            if (outputStart == output.length) {
                originalOutput.length = 0;
                return true;
            }
            output.push(output[0]);
            output.push(output[1]);
            if (i == clippingVerticesLast) break;
            let temp = output;
            output = input;
            output.length = 0;
            input = temp;
        }
        if (originalOutput != output) {
            originalOutput.length = 0;
            for(let i = 0, n = output.length - 2; i < n; i++)originalOutput[i] = output[i];
        } else originalOutput.length = originalOutput.length - 2;
        return clipped;
    }
    static makeClockwise(polygon) {
        let vertices = polygon;
        let verticeslength = polygon.length;
        let area = vertices[verticeslength - 2] * vertices[1] - vertices[0] * vertices[verticeslength - 1], p1x = 0, p1y = 0, p2x = 0, p2y = 0;
        for(let i = 0, n = verticeslength - 3; i < n; i += 2){
            p1x = vertices[i];
            p1y = vertices[i + 1];
            p2x = vertices[i + 2];
            p2y = vertices[i + 3];
            area += p1x * p2y - p2x * p1y;
        }
        if (area < 0) return;
        for(let i = 0, lastX = verticeslength - 2, n = verticeslength >> 1; i < n; i += 2){
            let x = vertices[i], y = vertices[i + 1];
            let other = lastX - i;
            vertices[i] = vertices[other];
            vertices[i + 1] = vertices[other + 1];
            vertices[other] = x;
            vertices[other + 1] = y;
        }
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 












class $409c2b412287ac3b$export$8913b5e618c6d2f3 {
    attachmentLoader;
    /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ scale = 1;
    linkedMeshes = new Array();
    constructor(attachmentLoader){
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(json) {
        let scale = this.scale;
        let skeletonData = new (0, $2dd6505fb1e9bdd3$export$e8f362f163550575)();
        let root = typeof json === "string" ? JSON.parse(json) : json;
        // Skeleton
        let skeletonMap = root.skeleton;
        if (skeletonMap) {
            skeletonData.hash = skeletonMap.hash;
            skeletonData.version = skeletonMap.spine;
            skeletonData.x = skeletonMap.x;
            skeletonData.y = skeletonMap.y;
            skeletonData.width = skeletonMap.width;
            skeletonData.height = skeletonMap.height;
            skeletonData.referenceScale = $409c2b412287ac3b$var$getValue(skeletonMap, "referenceScale", 100) * scale;
            skeletonData.fps = skeletonMap.fps;
            skeletonData.imagesPath = skeletonMap.images ?? null;
            skeletonData.audioPath = skeletonMap.audio ?? null;
        }
        // Bones
        if (root.bones) for(let i = 0; i < root.bones.length; i++){
            let boneMap = root.bones[i];
            let parent = null;
            let parentName = $409c2b412287ac3b$var$getValue(boneMap, "parent", null);
            if (parentName) parent = skeletonData.findBone(parentName);
            let data = new (0, $9299f15fee0c3520$export$7d85d96cf093e12f)(skeletonData.bones.length, boneMap.name, parent);
            data.length = $409c2b412287ac3b$var$getValue(boneMap, "length", 0) * scale;
            data.x = $409c2b412287ac3b$var$getValue(boneMap, "x", 0) * scale;
            data.y = $409c2b412287ac3b$var$getValue(boneMap, "y", 0) * scale;
            data.rotation = $409c2b412287ac3b$var$getValue(boneMap, "rotation", 0);
            data.scaleX = $409c2b412287ac3b$var$getValue(boneMap, "scaleX", 1);
            data.scaleY = $409c2b412287ac3b$var$getValue(boneMap, "scaleY", 1);
            data.shearX = $409c2b412287ac3b$var$getValue(boneMap, "shearX", 0);
            data.shearY = $409c2b412287ac3b$var$getValue(boneMap, "shearY", 0);
            data.inherit = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $9299f15fee0c3520$export$90bfc659784fb526), $409c2b412287ac3b$var$getValue(boneMap, "inherit", "Normal"));
            data.skinRequired = $409c2b412287ac3b$var$getValue(boneMap, "skin", false);
            let color = $409c2b412287ac3b$var$getValue(boneMap, "color", null);
            if (color) data.color.setFromString(color);
            skeletonData.bones.push(data);
        }
        // Slots.
        if (root.slots) for(let i = 0; i < root.slots.length; i++){
            let slotMap = root.slots[i];
            let slotName = slotMap.name;
            let boneData = skeletonData.findBone(slotMap.bone);
            if (!boneData) throw new Error(`Couldn't find bone ${slotMap.bone} for slot ${slotName}`);
            let data = new (0, $929b01edaa7ea960$export$a4cce1bf50208679)(skeletonData.slots.length, slotName, boneData);
            let color = $409c2b412287ac3b$var$getValue(slotMap, "color", null);
            if (color) data.color.setFromString(color);
            let dark = $409c2b412287ac3b$var$getValue(slotMap, "dark", null);
            if (dark) data.darkColor = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(dark);
            data.attachmentName = $409c2b412287ac3b$var$getValue(slotMap, "attachment", null);
            data.blendMode = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $929b01edaa7ea960$export$c9b8fe72ac71821), $409c2b412287ac3b$var$getValue(slotMap, "blend", "normal"));
            data.visible = $409c2b412287ac3b$var$getValue(slotMap, "visible", true);
            skeletonData.slots.push(data);
        }
        // IK constraints
        if (root.ik) for(let i = 0; i < root.ik.length; i++){
            let constraintMap = root.ik[i];
            let data = new (0, $3262faf56c73da02$export$adcb08b651fc712e)(constraintMap.name);
            data.order = $409c2b412287ac3b$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $409c2b412287ac3b$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let bone = skeletonData.findBone(constraintMap.bones[ii]);
                if (!bone) throw new Error(`Couldn't find bone ${constraintMap.bones[ii]} for IK constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let target = skeletonData.findBone(constraintMap.target);
            if (!target) throw new Error(`Couldn't find target bone ${constraintMap.target} for IK constraint ${constraintMap.name}.`);
            data.target = target;
            data.mix = $409c2b412287ac3b$var$getValue(constraintMap, "mix", 1);
            data.softness = $409c2b412287ac3b$var$getValue(constraintMap, "softness", 0) * scale;
            data.bendDirection = $409c2b412287ac3b$var$getValue(constraintMap, "bendPositive", true) ? 1 : -1;
            data.compress = $409c2b412287ac3b$var$getValue(constraintMap, "compress", false);
            data.stretch = $409c2b412287ac3b$var$getValue(constraintMap, "stretch", false);
            data.uniform = $409c2b412287ac3b$var$getValue(constraintMap, "uniform", false);
            skeletonData.ikConstraints.push(data);
        }
        // Transform constraints.
        if (root.transform) for(let i = 0; i < root.transform.length; i++){
            let constraintMap = root.transform[i];
            let data = new (0, $2ec81b1116e2dd23$export$823fbc29771afdb5)(constraintMap.name);
            data.order = $409c2b412287ac3b$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $409c2b412287ac3b$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let boneName = constraintMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for transform constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let targetName = constraintMap.target;
            let target = skeletonData.findBone(targetName);
            if (!target) throw new Error(`Couldn't find target bone ${targetName} for transform constraint ${constraintMap.name}.`);
            data.target = target;
            data.local = $409c2b412287ac3b$var$getValue(constraintMap, "local", false);
            data.relative = $409c2b412287ac3b$var$getValue(constraintMap, "relative", false);
            data.offsetRotation = $409c2b412287ac3b$var$getValue(constraintMap, "rotation", 0);
            data.offsetX = $409c2b412287ac3b$var$getValue(constraintMap, "x", 0) * scale;
            data.offsetY = $409c2b412287ac3b$var$getValue(constraintMap, "y", 0) * scale;
            data.offsetScaleX = $409c2b412287ac3b$var$getValue(constraintMap, "scaleX", 0);
            data.offsetScaleY = $409c2b412287ac3b$var$getValue(constraintMap, "scaleY", 0);
            data.offsetShearY = $409c2b412287ac3b$var$getValue(constraintMap, "shearY", 0);
            data.mixRotate = $409c2b412287ac3b$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $409c2b412287ac3b$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $409c2b412287ac3b$var$getValue(constraintMap, "mixY", data.mixX);
            data.mixScaleX = $409c2b412287ac3b$var$getValue(constraintMap, "mixScaleX", 1);
            data.mixScaleY = $409c2b412287ac3b$var$getValue(constraintMap, "mixScaleY", data.mixScaleX);
            data.mixShearY = $409c2b412287ac3b$var$getValue(constraintMap, "mixShearY", 1);
            skeletonData.transformConstraints.push(data);
        }
        // Path constraints.
        if (root.path) for(let i = 0; i < root.path.length; i++){
            let constraintMap = root.path[i];
            let data = new (0, $df278a6379229a7a$export$d2629ab80d5dd5ba)(constraintMap.name);
            data.order = $409c2b412287ac3b$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $409c2b412287ac3b$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let boneName = constraintMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for path constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let targetName = constraintMap.target;
            let target = skeletonData.findSlot(targetName);
            if (!target) throw new Error(`Couldn't find target slot ${targetName} for path constraint ${constraintMap.name}.`);
            data.target = target;
            data.positionMode = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $df278a6379229a7a$export$34d637c671e1e906), $409c2b412287ac3b$var$getValue(constraintMap, "positionMode", "Percent"));
            data.spacingMode = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $df278a6379229a7a$export$34ce760ad2b0be4b), $409c2b412287ac3b$var$getValue(constraintMap, "spacingMode", "Length"));
            data.rotateMode = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $df278a6379229a7a$export$a2a23846581ac82c), $409c2b412287ac3b$var$getValue(constraintMap, "rotateMode", "Tangent"));
            data.offsetRotation = $409c2b412287ac3b$var$getValue(constraintMap, "rotation", 0);
            data.position = $409c2b412287ac3b$var$getValue(constraintMap, "position", 0);
            if (data.positionMode == (0, $df278a6379229a7a$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = $409c2b412287ac3b$var$getValue(constraintMap, "spacing", 0);
            if (data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.mixRotate = $409c2b412287ac3b$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $409c2b412287ac3b$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $409c2b412287ac3b$var$getValue(constraintMap, "mixY", data.mixX);
            skeletonData.pathConstraints.push(data);
        }
        // Physics constraints.
        if (root.physics) for(let i = 0; i < root.physics.length; i++){
            const constraintMap = root.physics[i];
            const data = new (0, $4152a57e560df614$export$e7a93b7124cc91bd)(constraintMap.name);
            data.order = $409c2b412287ac3b$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $409c2b412287ac3b$var$getValue(constraintMap, "skin", false);
            const boneName = constraintMap.bone;
            const bone = skeletonData.findBone(boneName);
            if (bone == null) throw new Error("Physics bone not found: " + boneName);
            data.bone = bone;
            data.x = $409c2b412287ac3b$var$getValue(constraintMap, "x", 0);
            data.y = $409c2b412287ac3b$var$getValue(constraintMap, "y", 0);
            data.rotate = $409c2b412287ac3b$var$getValue(constraintMap, "rotate", 0);
            data.scaleX = $409c2b412287ac3b$var$getValue(constraintMap, "scaleX", 0);
            data.shearX = $409c2b412287ac3b$var$getValue(constraintMap, "shearX", 0);
            data.limit = $409c2b412287ac3b$var$getValue(constraintMap, "limit", 5000) * scale;
            data.step = 1 / $409c2b412287ac3b$var$getValue(constraintMap, "fps", 60);
            data.inertia = $409c2b412287ac3b$var$getValue(constraintMap, "inertia", 1);
            data.strength = $409c2b412287ac3b$var$getValue(constraintMap, "strength", 100);
            data.damping = $409c2b412287ac3b$var$getValue(constraintMap, "damping", 1);
            data.massInverse = 1 / $409c2b412287ac3b$var$getValue(constraintMap, "mass", 1);
            data.wind = $409c2b412287ac3b$var$getValue(constraintMap, "wind", 0);
            data.gravity = $409c2b412287ac3b$var$getValue(constraintMap, "gravity", 0);
            data.mix = $409c2b412287ac3b$var$getValue(constraintMap, "mix", 1);
            data.inertiaGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "inertiaGlobal", false);
            data.strengthGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "strengthGlobal", false);
            data.dampingGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "dampingGlobal", false);
            data.massGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "massGlobal", false);
            data.windGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "windGlobal", false);
            data.gravityGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "gravityGlobal", false);
            data.mixGlobal = $409c2b412287ac3b$var$getValue(constraintMap, "mixGlobal", false);
            skeletonData.physicsConstraints.push(data);
        }
        // Skins.
        if (root.skins) for(let i = 0; i < root.skins.length; i++){
            let skinMap = root.skins[i];
            let skin = new (0, $3ad0356d70bdb0e1$export$b8e0f93a76772233)(skinMap.name);
            if (skinMap.bones) for(let ii = 0; ii < skinMap.bones.length; ii++){
                let boneName = skinMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for skin ${skinMap.name}.`);
                skin.bones.push(bone);
            }
            if (skinMap.ik) for(let ii = 0; ii < skinMap.ik.length; ii++){
                let constraintName = skinMap.ik[ii];
                let constraint = skeletonData.findIkConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find IK constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.transform) for(let ii = 0; ii < skinMap.transform.length; ii++){
                let constraintName = skinMap.transform[ii];
                let constraint = skeletonData.findTransformConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find transform constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.path) for(let ii = 0; ii < skinMap.path.length; ii++){
                let constraintName = skinMap.path[ii];
                let constraint = skeletonData.findPathConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find path constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.physics) for(let ii = 0; ii < skinMap.physics.length; ii++){
                let constraintName = skinMap.physics[ii];
                let constraint = skeletonData.findPhysicsConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find physics constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            for(let slotName in skinMap.attachments){
                let slot = skeletonData.findSlot(slotName);
                if (!slot) throw new Error(`Couldn't find slot ${slotName} for skin ${skinMap.name}.`);
                let slotMap = skinMap.attachments[slotName];
                for(let entryName in slotMap){
                    let attachment = this.readAttachment(slotMap[entryName], skin, slot.index, entryName, skeletonData);
                    if (attachment) skin.setAttachment(slot.index, entryName, attachment);
                }
            }
            skeletonData.skins.push(skin);
            if (skin.name == "default") skeletonData.defaultSkin = skin;
        }
        // Linked meshes.
        for(let i = 0, n = this.linkedMeshes.length; i < n; i++){
            let linkedMesh = this.linkedMeshes[i];
            let skin = !linkedMesh.skin ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (!skin) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            let parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
            if (linkedMesh.mesh.region != null) linkedMesh.mesh.updateRegion();
        }
        this.linkedMeshes.length = 0;
        // Events.
        if (root.events) for(let eventName in root.events){
            let eventMap = root.events[eventName];
            let data = new (0, $8ced6bc62a0114c6$export$a5cf049e34c3d11e)(eventName);
            data.intValue = $409c2b412287ac3b$var$getValue(eventMap, "int", 0);
            data.floatValue = $409c2b412287ac3b$var$getValue(eventMap, "float", 0);
            data.stringValue = $409c2b412287ac3b$var$getValue(eventMap, "string", "");
            data.audioPath = $409c2b412287ac3b$var$getValue(eventMap, "audio", null);
            if (data.audioPath) {
                data.volume = $409c2b412287ac3b$var$getValue(eventMap, "volume", 1);
                data.balance = $409c2b412287ac3b$var$getValue(eventMap, "balance", 0);
            }
            skeletonData.events.push(data);
        }
        // Animations.
        if (root.animations) for(let animationName in root.animations){
            let animationMap = root.animations[animationName];
            this.readAnimation(animationMap, animationName, skeletonData);
        }
        return skeletonData;
    }
    readAttachment(map, skin, slotIndex, name, skeletonData) {
        let scale = this.scale;
        name = $409c2b412287ac3b$var$getValue(map, "name", name);
        switch($409c2b412287ac3b$var$getValue(map, "type", "region")){
            case "region":
                {
                    let path = $409c2b412287ac3b$var$getValue(map, "path", name);
                    let sequence = this.readSequence($409c2b412287ac3b$var$getValue(map, "sequence", null));
                    let region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = $409c2b412287ac3b$var$getValue(map, "x", 0) * scale;
                    region.y = $409c2b412287ac3b$var$getValue(map, "y", 0) * scale;
                    region.scaleX = $409c2b412287ac3b$var$getValue(map, "scaleX", 1);
                    region.scaleY = $409c2b412287ac3b$var$getValue(map, "scaleY", 1);
                    region.rotation = $409c2b412287ac3b$var$getValue(map, "rotation", 0);
                    region.width = map.width * scale;
                    region.height = map.height * scale;
                    region.sequence = sequence;
                    let color = $409c2b412287ac3b$var$getValue(map, "color", null);
                    if (color) region.color.setFromString(color);
                    if (region.region != null) region.updateRegion();
                    return region;
                }
            case "boundingbox":
                {
                    let box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    this.readVertices(map, box, map.vertexCount << 1);
                    let color = $409c2b412287ac3b$var$getValue(map, "color", null);
                    if (color) box.color.setFromString(color);
                    return box;
                }
            case "mesh":
            case "linkedmesh":
                {
                    let path = $409c2b412287ac3b$var$getValue(map, "path", name);
                    let sequence = this.readSequence($409c2b412287ac3b$var$getValue(map, "sequence", null));
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    let color = $409c2b412287ac3b$var$getValue(map, "color", null);
                    if (color) mesh.color.setFromString(color);
                    mesh.width = $409c2b412287ac3b$var$getValue(map, "width", 0) * scale;
                    mesh.height = $409c2b412287ac3b$var$getValue(map, "height", 0) * scale;
                    mesh.sequence = sequence;
                    let parent = $409c2b412287ac3b$var$getValue(map, "parent", null);
                    if (parent) {
                        this.linkedMeshes.push(new $409c2b412287ac3b$var$LinkedMesh(mesh, $409c2b412287ac3b$var$getValue(map, "skin", null), slotIndex, parent, $409c2b412287ac3b$var$getValue(map, "timelines", true)));
                        return mesh;
                    }
                    let uvs = map.uvs;
                    this.readVertices(map, mesh, uvs.length);
                    mesh.triangles = map.triangles;
                    mesh.regionUVs = uvs;
                    if (mesh.region != null) mesh.updateRegion();
                    mesh.edges = $409c2b412287ac3b$var$getValue(map, "edges", null);
                    mesh.hullLength = $409c2b412287ac3b$var$getValue(map, "hull", 0) * 2;
                    return mesh;
                }
            case "path":
                {
                    let path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = $409c2b412287ac3b$var$getValue(map, "closed", false);
                    path.constantSpeed = $409c2b412287ac3b$var$getValue(map, "constantSpeed", true);
                    let vertexCount = map.vertexCount;
                    this.readVertices(map, path, vertexCount << 1);
                    let lengths = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0; i < map.lengths.length; i++)lengths[i] = map.lengths[i] * scale;
                    path.lengths = lengths;
                    let color = $409c2b412287ac3b$var$getValue(map, "color", null);
                    if (color) path.color.setFromString(color);
                    return path;
                }
            case "point":
                {
                    let point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = $409c2b412287ac3b$var$getValue(map, "x", 0) * scale;
                    point.y = $409c2b412287ac3b$var$getValue(map, "y", 0) * scale;
                    point.rotation = $409c2b412287ac3b$var$getValue(map, "rotation", 0);
                    let color = $409c2b412287ac3b$var$getValue(map, "color", null);
                    if (color) point.color.setFromString(color);
                    return point;
                }
            case "clipping":
                {
                    let clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    let end = $409c2b412287ac3b$var$getValue(map, "end", null);
                    if (end) clip.endSlot = skeletonData.findSlot(end);
                    let vertexCount = map.vertexCount;
                    this.readVertices(map, clip, vertexCount << 1);
                    let color = $409c2b412287ac3b$var$getValue(map, "color", null);
                    if (color) clip.color.setFromString(color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(map) {
        if (map == null) return null;
        let sequence = new (0, $50aa82091c41d06e$export$edde1bcb1b2b310e)($409c2b412287ac3b$var$getValue(map, "count", 0));
        sequence.start = $409c2b412287ac3b$var$getValue(map, "start", 1);
        sequence.digits = $409c2b412287ac3b$var$getValue(map, "digits", 0);
        sequence.setupIndex = $409c2b412287ac3b$var$getValue(map, "setup", 0);
        return sequence;
    }
    readVertices(map, attachment, verticesLength) {
        let scale = this.scale;
        attachment.worldVerticesLength = verticesLength;
        let vertices = map.vertices;
        if (verticesLength == vertices.length) {
            let scaledVertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).toFloatArray(vertices);
            if (scale != 1) for(let i = 0, n = vertices.length; i < n; i++)scaledVertices[i] *= scale;
            attachment.vertices = scaledVertices;
            return;
        }
        let weights = new Array();
        let bones = new Array();
        for(let i = 0, n = vertices.length; i < n;){
            let boneCount = vertices[i++];
            bones.push(boneCount);
            for(let nn = i + boneCount * 4; i < nn; i += 4){
                bones.push(vertices[i]);
                weights.push(vertices[i + 1] * scale);
                weights.push(vertices[i + 2] * scale);
                weights.push(vertices[i + 3]);
            }
        }
        attachment.bones = bones;
        attachment.vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).toFloatArray(weights);
    }
    readAnimation(map, name, skeletonData) {
        let scale = this.scale;
        let timelines = new Array();
        // Slot timelines.
        if (map.slots) for(let slotName in map.slots){
            let slotMap = map.slots[slotName];
            let slot = skeletonData.findSlot(slotName);
            if (!slot) throw new Error("Slot not found: " + slotName);
            let slotIndex = slot.index;
            for(let timelineName in slotMap){
                let timelineMap = slotMap[timelineName];
                if (!timelineMap) continue;
                let frames = timelineMap.length;
                if (timelineName == "attachment") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$7f2bfc5bd27cb43d)(frames, slotIndex);
                    for(let frame = 0; frame < frames; frame++){
                        let keyMap = timelineMap[frame];
                        timeline.setFrame(frame, $409c2b412287ac3b$var$getValue(keyMap, "time", 0), $409c2b412287ac3b$var$getValue(keyMap, "name", null));
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgba") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$84cf3a3e225bcbdc)(frames, frames << 2, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                    let color = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(nextMap.color);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$e179fb669ddccfa9)(frames, frames * 3, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                    let color = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(nextMap.color);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "alpha") timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, new (0, $bbeb79d5adec7b97$export$2211be7c5ccde97b)(frames, frames, slotIndex), 0, 1));
                else if (timelineName == "rgba2") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$6fc6620d97c53689)(frames, frames * 7, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                    let color = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(keyMap.light);
                    let color2 = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a, color2.r, color2.g, color2.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(nextMap.light);
                        let newColor2 = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(nextMap.dark);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.r, newColor2.r, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.g, newColor2.g, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 6, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb2") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$a12960afd309a230)(frames, frames * 6, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                    let color = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(keyMap.light);
                    let color2 = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color2.r, color2.g, color2.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(nextMap.light);
                        let newColor2 = (0, $bdd8805cee4a5602$export$892596cec99bc70e).fromString(nextMap.dark);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color2.r, newColor2.r, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.g, newColor2.g, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        // Bone timelines.
        if (map.bones) for(let boneName in map.bones){
            let boneMap = map.bones[boneName];
            let bone = skeletonData.findBone(boneName);
            if (!bone) throw new Error("Bone not found: " + boneName);
            let boneIndex = bone.index;
            for(let timelineName in boneMap){
                let timelineMap = boneMap[timelineName];
                let frames = timelineMap.length;
                if (frames == 0) continue;
                if (timelineName === "rotate") timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, new (0, $bbeb79d5adec7b97$export$b7ecb8f68b3e130b)(frames, frames, boneIndex), 0, 1));
                else if (timelineName === "translate") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$eb93bf27829ae703)(frames, frames << 1, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline2(timelineMap, timeline, "x", "y", 0, scale));
                } else if (timelineName === "translatex") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$cf49491eb4394eca)(frames, frames, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "translatey") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$6540b7ba297d3e41)(frames, frames, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "scale") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$be544e22f6ad7737)(frames, frames << 1, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline2(timelineMap, timeline, "x", "y", 1, 1));
                } else if (timelineName === "scalex") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$407a9cf4df59ebda)(frames, frames, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "scaley") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$cc13ceba88ef3794)(frames, frames, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "shear") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$4da82436a1a0d773)(frames, frames << 1, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline2(timelineMap, timeline, "x", "y", 0, 1));
                } else if (timelineName === "shearx") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$2392b1c4c21acaf8)(frames, frames, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, 1));
                } else if (timelineName === "sheary") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$f65148e1d95352fd)(frames, frames, boneIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, 1));
                } else if (timelineName === "inherit") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$7582beb1c1258b21)(frames, bone.index);
                    for(let frame = 0; frame < timelineMap.length; frame++){
                        let aFrame = timelineMap[frame];
                        timeline.setFrame(frame, $409c2b412287ac3b$var$getValue(aFrame, "time", 0), (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).enumValue((0, $9299f15fee0c3520$export$90bfc659784fb526), $409c2b412287ac3b$var$getValue(aFrame, "inherit", "Normal")));
                    }
                    timelines.push(timeline);
                }
            }
        }
        // IK constraint timelines.
        if (map.ik) for(let constraintName in map.ik){
            let constraintMap = map.ik[constraintName];
            let keyMap = constraintMap[0];
            if (!keyMap) continue;
            let constraint = skeletonData.findIkConstraint(constraintName);
            if (!constraint) throw new Error("IK Constraint not found: " + constraintName);
            let constraintIndex = skeletonData.ikConstraints.indexOf(constraint);
            let timeline = new (0, $bbeb79d5adec7b97$export$73d125cd89dead44)(constraintMap.length, constraintMap.length << 1, constraintIndex);
            let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
            let mix = $409c2b412287ac3b$var$getValue(keyMap, "mix", 1);
            let softness = $409c2b412287ac3b$var$getValue(keyMap, "softness", 0) * scale;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, $409c2b412287ac3b$var$getValue(keyMap, "bendPositive", true) ? 1 : -1, $409c2b412287ac3b$var$getValue(keyMap, "compress", false), $409c2b412287ac3b$var$getValue(keyMap, "stretch", false));
                let nextMap = constraintMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                let mix2 = $409c2b412287ac3b$var$getValue(nextMap, "mix", 1);
                let softness2 = $409c2b412287ac3b$var$getValue(nextMap, "softness", 0) * scale;
                let curve = keyMap.curve;
                if (curve) {
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mix, mix2, 1);
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        // Transform constraint timelines.
        if (map.transform) for(let constraintName in map.transform){
            let timelineMap = map.transform[constraintName];
            let keyMap = timelineMap[0];
            if (!keyMap) continue;
            let constraint = skeletonData.findTransformConstraint(constraintName);
            if (!constraint) throw new Error("Transform constraint not found: " + constraintName);
            let constraintIndex = skeletonData.transformConstraints.indexOf(constraint);
            let timeline = new (0, $bbeb79d5adec7b97$export$a7a393c2ad815ac7)(timelineMap.length, timelineMap.length * 6, constraintIndex);
            let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
            let mixRotate = $409c2b412287ac3b$var$getValue(keyMap, "mixRotate", 1);
            let mixX = $409c2b412287ac3b$var$getValue(keyMap, "mixX", 1);
            let mixY = $409c2b412287ac3b$var$getValue(keyMap, "mixY", mixX);
            let mixScaleX = $409c2b412287ac3b$var$getValue(keyMap, "mixScaleX", 1);
            let mixScaleY = $409c2b412287ac3b$var$getValue(keyMap, "mixScaleY", mixScaleX);
            let mixShearY = $409c2b412287ac3b$var$getValue(keyMap, "mixShearY", 1);
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                let nextMap = timelineMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                let mixRotate2 = $409c2b412287ac3b$var$getValue(nextMap, "mixRotate", 1);
                let mixX2 = $409c2b412287ac3b$var$getValue(nextMap, "mixX", 1);
                let mixY2 = $409c2b412287ac3b$var$getValue(nextMap, "mixY", mixX2);
                let mixScaleX2 = $409c2b412287ac3b$var$getValue(nextMap, "mixScaleX", 1);
                let mixScaleY2 = $409c2b412287ac3b$var$getValue(nextMap, "mixScaleY", mixScaleX2);
                let mixShearY2 = $409c2b412287ac3b$var$getValue(nextMap, "mixShearY", 1);
                let curve = keyMap.curve;
                if (curve) {
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                    bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixScaleX = mixScaleX2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        // Path constraint timelines.
        if (map.path) for(let constraintName in map.path){
            let constraintMap = map.path[constraintName];
            let constraint = skeletonData.findPathConstraint(constraintName);
            if (!constraint) throw new Error("Path constraint not found: " + constraintName);
            let constraintIndex = skeletonData.pathConstraints.indexOf(constraint);
            for(let timelineName in constraintMap){
                let timelineMap = constraintMap[timelineName];
                let keyMap = timelineMap[0];
                if (!keyMap) continue;
                let frames = timelineMap.length;
                if (timelineName === "position") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$7ce7e67fd9cc52ed)(frames, frames, constraintIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, constraint.positionMode == (0, $df278a6379229a7a$export$34d637c671e1e906).Fixed ? scale : 1));
                } else if (timelineName === "spacing") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$17ee50c08a07e62b)(frames, frames, constraintIndex);
                    timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, constraint.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Length || constraint.spacingMode == (0, $df278a6379229a7a$export$34ce760ad2b0be4b).Fixed ? scale : 1));
                } else if (timelineName === "mix") {
                    let timeline = new (0, $bbeb79d5adec7b97$export$ea67b41755485038)(frames, frames * 3, constraintIndex);
                    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                    let mixRotate = $409c2b412287ac3b$var$getValue(keyMap, "mixRotate", 1);
                    let mixX = $409c2b412287ac3b$var$getValue(keyMap, "mixX", 1);
                    let mixY = $409c2b412287ac3b$var$getValue(keyMap, "mixY", mixX);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                        let mixRotate2 = $409c2b412287ac3b$var$getValue(nextMap, "mixRotate", 1);
                        let mixX2 = $409c2b412287ac3b$var$getValue(nextMap, "mixX", 1);
                        let mixY2 = $409c2b412287ac3b$var$getValue(nextMap, "mixY", mixX2);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                        }
                        time = time2;
                        mixRotate = mixRotate2;
                        mixX = mixX2;
                        mixY = mixY2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        // Physics constraint timelines.
        if (map.physics) for(let constraintName in map.physics){
            let constraintMap = map.physics[constraintName];
            let constraintIndex = -1;
            if (constraintName.length > 0) {
                let constraint = skeletonData.findPhysicsConstraint(constraintName);
                if (!constraint) throw new Error("Physics constraint not found: " + constraintName);
                constraintIndex = skeletonData.physicsConstraints.indexOf(constraint);
            }
            for(let timelineName in constraintMap){
                let timelineMap = constraintMap[timelineName];
                let keyMap = timelineMap[0];
                if (!keyMap) continue;
                let frames = timelineMap.length;
                if (timelineName == "reset") {
                    const timeline = new (0, $bbeb79d5adec7b97$export$956f20308bfd17e0)(frames, constraintIndex);
                    for(let frame = 0; keyMap != null; keyMap = timelineMap[frame + 1], frame++)timeline.setFrame(frame, $409c2b412287ac3b$var$getValue(keyMap, "time", 0));
                    timelines.push(timeline);
                    continue;
                }
                let timeline;
                if (timelineName == "inertia") timeline = new (0, $bbeb79d5adec7b97$export$8d7d2ed36692a76a)(frames, frames, constraintIndex);
                else if (timelineName == "strength") timeline = new (0, $bbeb79d5adec7b97$export$92ee7da35e84339e)(frames, frames, constraintIndex);
                else if (timelineName == "damping") timeline = new (0, $bbeb79d5adec7b97$export$cd77a164f9089126)(frames, frames, constraintIndex);
                else if (timelineName == "mass") timeline = new (0, $bbeb79d5adec7b97$export$cc37bc88e0605a66)(frames, frames, constraintIndex);
                else if (timelineName == "wind") timeline = new (0, $bbeb79d5adec7b97$export$3e123ca078024d61)(frames, frames, constraintIndex);
                else if (timelineName == "gravity") timeline = new (0, $bbeb79d5adec7b97$export$f321d2d075d42a88)(frames, frames, constraintIndex);
                else if (timelineName == "mix") timeline = new (0, $bbeb79d5adec7b97$export$e3ce1f2c0b6ae580)(frames, frames, constraintIndex);
                else continue;
                timelines.push($409c2b412287ac3b$var$readTimeline1(timelineMap, timeline, 0, 1));
            }
        }
        // Attachment timelines.
        if (map.attachments) for(let attachmentsName in map.attachments){
            let attachmentsMap = map.attachments[attachmentsName];
            let skin = skeletonData.findSkin(attachmentsName);
            if (!skin) throw new Error("Skin not found: " + attachmentsName);
            for(let slotMapName in attachmentsMap){
                let slotMap = attachmentsMap[slotMapName];
                let slot = skeletonData.findSlot(slotMapName);
                if (!slot) throw new Error("Slot not found: " + slotMapName);
                let slotIndex = slot.index;
                for(let attachmentMapName in slotMap){
                    let attachmentMap = slotMap[attachmentMapName];
                    let attachment = skin.getAttachment(slotIndex, attachmentMapName);
                    for(let timelineMapName in attachmentMap){
                        let timelineMap = attachmentMap[timelineMapName];
                        let keyMap = timelineMap[0];
                        if (!keyMap) continue;
                        if (timelineMapName == "deform") {
                            let weighted = attachment.bones;
                            let vertices = attachment.vertices;
                            let deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                            let timeline = new (0, $bbeb79d5adec7b97$export$6968d40e5689ad6b)(timelineMap.length, timelineMap.length, slotIndex, attachment);
                            let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                            for(let frame = 0, bezier = 0;; frame++){
                                let deform;
                                let verticesValue = $409c2b412287ac3b$var$getValue(keyMap, "vertices", null);
                                if (!verticesValue) deform = weighted ? (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                                else {
                                    deform = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(deformLength);
                                    let start = $409c2b412287ac3b$var$getValue(keyMap, "offset", 0);
                                    (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                                    if (scale != 1) for(let i = start, n = i + verticesValue.length; i < n; i++)deform[i] *= scale;
                                    if (!weighted) for(let i = 0; i < deformLength; i++)deform[i] += vertices[i];
                                }
                                timeline.setFrame(frame, time, deform);
                                let nextMap = timelineMap[frame + 1];
                                if (!nextMap) {
                                    timeline.shrink(bezier);
                                    break;
                                }
                                let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
                                let curve = keyMap.curve;
                                if (curve) bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, 0, 1, 1);
                                time = time2;
                                keyMap = nextMap;
                            }
                            timelines.push(timeline);
                        } else if (timelineMapName == "sequence") {
                            let timeline = new (0, $bbeb79d5adec7b97$export$2687f324e8496672)(timelineMap.length, slotIndex, attachment);
                            let lastDelay = 0;
                            for(let frame = 0; frame < timelineMap.length; frame++){
                                let delay = $409c2b412287ac3b$var$getValue(keyMap, "delay", lastDelay);
                                let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
                                let mode = (0, $50aa82091c41d06e$export$2d839466c6120eb9)[$409c2b412287ac3b$var$getValue(keyMap, "mode", "hold")];
                                let index = $409c2b412287ac3b$var$getValue(keyMap, "index", 0);
                                timeline.setFrame(frame, time, mode, index, delay);
                                lastDelay = delay;
                                keyMap = timelineMap[frame + 1];
                            }
                            timelines.push(timeline);
                        }
                    }
                }
            }
        }
        // Draw order timelines.
        if (map.drawOrder) {
            let timeline = new (0, $bbeb79d5adec7b97$export$ece1f7c41d051e83)(map.drawOrder.length);
            let slotCount = skeletonData.slots.length;
            let frame = 0;
            for(let i = 0; i < map.drawOrder.length; i++, frame++){
                let drawOrderMap = map.drawOrder[i];
                let drawOrder = null;
                let offsets = $409c2b412287ac3b$var$getValue(drawOrderMap, "offsets", null);
                if (offsets) {
                    drawOrder = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newArray(slotCount, -1);
                    let unchanged = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newArray(slotCount - offsets.length, 0);
                    let originalIndex = 0, unchangedIndex = 0;
                    for(let ii = 0; ii < offsets.length; ii++){
                        let offsetMap = offsets[ii];
                        let slot = skeletonData.findSlot(offsetMap.slot);
                        if (!slot) throw new Error("Slot not found: " + slot);
                        let slotIndex = slot.index;
                        // Collect unchanged items.
                        while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                        // Set changed items.
                        drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                    }
                    // Collect remaining unchanged items.
                    while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                    // Fill in unchanged items.
                    for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                }
                timeline.setFrame(frame, $409c2b412287ac3b$var$getValue(drawOrderMap, "time", 0), drawOrder);
            }
            timelines.push(timeline);
        }
        // Event timelines.
        if (map.events) {
            let timeline = new (0, $bbeb79d5adec7b97$export$4f4bca996c586084)(map.events.length);
            let frame = 0;
            for(let i = 0; i < map.events.length; i++, frame++){
                let eventMap = map.events[i];
                let eventData = skeletonData.findEvent(eventMap.name);
                if (!eventData) throw new Error("Event not found: " + eventMap.name);
                let event = new (0, $38575b550a322281$export$d61e24a684f9e51)((0, $bdd8805cee4a5602$export$d2ca453b913dcdea).toSinglePrecision($409c2b412287ac3b$var$getValue(eventMap, "time", 0)), eventData);
                event.intValue = $409c2b412287ac3b$var$getValue(eventMap, "int", eventData.intValue);
                event.floatValue = $409c2b412287ac3b$var$getValue(eventMap, "float", eventData.floatValue);
                event.stringValue = $409c2b412287ac3b$var$getValue(eventMap, "string", eventData.stringValue);
                if (event.data.audioPath) {
                    event.volume = $409c2b412287ac3b$var$getValue(eventMap, "volume", 1);
                    event.balance = $409c2b412287ac3b$var$getValue(eventMap, "balance", 0);
                }
                timeline.setFrame(frame, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        skeletonData.animations.push(new (0, $bbeb79d5adec7b97$export$c35d437ae5945fcd)(name, timelines, duration));
    }
}
class $409c2b412287ac3b$var$LinkedMesh {
    parent;
    skin;
    slotIndex;
    mesh;
    inheritTimeline;
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
function $409c2b412287ac3b$var$readTimeline1(keys, timeline, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
    let value = $409c2b412287ac3b$var$getValue(keyMap, "value", defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value);
        let nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
        let value2 = $409c2b412287ac3b$var$getValue(nextMap, "value", defaultValue) * scale;
        if (keyMap.curve) bezier = $409c2b412287ac3b$var$readCurve(keyMap.curve, timeline, bezier, frame, 0, time, time2, value, value2, scale);
        time = time2;
        value = value2;
        keyMap = nextMap;
    }
}
function $409c2b412287ac3b$var$readTimeline2(keys, timeline, name1, name2, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $409c2b412287ac3b$var$getValue(keyMap, "time", 0);
    let value1 = $409c2b412287ac3b$var$getValue(keyMap, name1, defaultValue) * scale;
    let value2 = $409c2b412287ac3b$var$getValue(keyMap, name2, defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        let nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        let time2 = $409c2b412287ac3b$var$getValue(nextMap, "time", 0);
        let nvalue1 = $409c2b412287ac3b$var$getValue(nextMap, name1, defaultValue) * scale;
        let nvalue2 = $409c2b412287ac3b$var$getValue(nextMap, name2, defaultValue) * scale;
        let curve = keyMap.curve;
        if (curve) {
            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, value1, nvalue1, scale);
            bezier = $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
        keyMap = nextMap;
    }
}
function $409c2b412287ac3b$var$readCurve(curve, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    if (curve == "stepped") {
        timeline.setStepped(frame);
        return bezier;
    }
    let i = value << 2;
    let cx1 = curve[i];
    let cy1 = curve[i + 1] * scale;
    let cx2 = curve[i + 2];
    let cy2 = curve[i + 3] * scale;
    timeline.setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2);
    return bezier + 1;
}
function $409c2b412287ac3b$var$getValue(map, property, defaultValue) {
    return map[property] !== undefined ? map[property] : defaultValue;
}










/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ (()=>{
    if (typeof Math.fround === "undefined") Math.fround = function(array) {
        return function(x) {
            return array[0] = x, array[0];
        };
    }(new Float32Array(1));
})();



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 









/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $2a889ef389866093$export$a4d6d43057cae2ac {
    canvas;
    gl;
    restorables = new Array();
    constructor(canvasOrContext, contextConfig = {
        alpha: "true"
    }){
        if (!(canvasOrContext instanceof WebGLRenderingContext || typeof WebGL2RenderingContext !== "undefined" && canvasOrContext instanceof WebGL2RenderingContext)) {
            let canvas = canvasOrContext;
            this.gl = canvas.getContext("webgl2", contextConfig) || canvas.getContext("webgl", contextConfig);
            this.canvas = canvas;
            canvas.addEventListener("webglcontextlost", (e)=>{
                let event = e;
                if (e) e.preventDefault();
            });
            canvas.addEventListener("webglcontextrestored", (e)=>{
                for(let i = 0, n = this.restorables.length; i < n; i++)this.restorables[i].restore();
            });
        } else {
            this.gl = canvasOrContext;
            this.canvas = this.gl.canvas;
        }
    }
    addRestorable(restorable) {
        this.restorables.push(restorable);
    }
    removeRestorable(restorable) {
        let index = this.restorables.indexOf(restorable);
        if (index > -1) this.restorables.splice(index, 1);
    }
}


class $d873b6ddc694ab51$export$6c73c2a4561c07a2 extends (0, $0ec5a873c6b98cd8$export$5431306cf43de24a) {
    context;
    texture = null;
    boundUnit = 0;
    useMipMaps = false;
    static DISABLE_UNPACK_PREMULTIPLIED_ALPHA_WEBGL = false;
    constructor(context, image, useMipMaps = false){
        super(image);
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
        this.useMipMaps = useMipMaps;
        this.restore();
        this.context.addRestorable(this);
    }
    setFilters(minFilter, magFilter) {
        let gl = this.context.gl;
        this.bind();
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, $d873b6ddc694ab51$export$6c73c2a4561c07a2.validateMagFilter(magFilter));
        this.useMipMaps = $d873b6ddc694ab51$export$6c73c2a4561c07a2.usesMipMaps(minFilter);
        if (this.useMipMaps) gl.generateMipmap(gl.TEXTURE_2D);
    }
    static validateMagFilter(magFilter) {
        switch(magFilter){
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapLinearLinear:
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapLinearNearest:
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapNearestLinear:
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapNearestNearest:
                return (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Linear;
            default:
                return magFilter;
        }
    }
    static usesMipMaps(filter) {
        switch(filter){
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapLinearLinear:
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapLinearNearest:
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapNearestLinear:
            case (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapNearestNearest:
                return true;
            default:
                return false;
        }
    }
    setWraps(uWrap, vWrap) {
        let gl = this.context.gl;
        this.bind();
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, uWrap);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, vWrap);
    }
    update(useMipMaps) {
        let gl = this.context.gl;
        if (!this.texture) this.texture = this.context.gl.createTexture();
        this.bind();
        if ($d873b6ddc694ab51$export$6c73c2a4561c07a2.DISABLE_UNPACK_PREMULTIPLIED_ALPHA_WEBGL) gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this._image);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, useMipMaps ? gl.LINEAR_MIPMAP_LINEAR : gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        if (useMipMaps) gl.generateMipmap(gl.TEXTURE_2D);
    }
    restore() {
        this.texture = null;
        this.update(this.useMipMaps);
    }
    bind(unit = 0) {
        let gl = this.context.gl;
        this.boundUnit = unit;
        gl.activeTexture(gl.TEXTURE0 + unit);
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
    }
    unbind() {
        let gl = this.context.gl;
        gl.activeTexture(gl.TEXTURE0 + this.boundUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    dispose() {
        this.context.removeRestorable(this);
        let gl = this.context.gl;
        gl.deleteTexture(this.texture);
    }
}


class $4cefb0dc2e03d3d3$export$85f9686224250ac3 extends (0, $fbef37d12788a5d6$export$d187693bfb349728) {
    constructor(context, pathPrefix = "", downloader = new (0, $fbef37d12788a5d6$export$ef06e7620d37c296)()){
        super((image)=>{
            return new (0, $d873b6ddc694ab51$export$6c73c2a4561c07a2)(context, image);
        }, pathPrefix, downloader);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $98b7726a3a3f3658$export$64b5c384219d3699 {
    x = 0;
    y = 0;
    z = 0;
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    setFrom(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    set(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    scale(s) {
        this.x *= s;
        this.y *= s;
        this.z *= s;
        return this;
    }
    normalize() {
        let len = this.length();
        if (len == 0) return this;
        len = 1 / len;
        this.x *= len;
        this.y *= len;
        this.z *= len;
        return this;
    }
    cross(v) {
        return this.set(this.y * v.z - this.z * v.y, this.z * v.x - this.x * v.z, this.x * v.y - this.y * v.x);
    }
    multiply(matrix) {
        let l_mat = matrix.values;
        return this.set(this.x * l_mat[0, $8516767b4f173a63$export$b06a2a6195c06efc] + this.y * l_mat[0, $8516767b4f173a63$export$5ae52f682687d620] + this.z * l_mat[0, $8516767b4f173a63$export$91e90b05312755fb] + l_mat[0, $8516767b4f173a63$export$99d2679d75e60dc2], this.x * l_mat[0, $8516767b4f173a63$export$585a161a9f77f349] + this.y * l_mat[0, $8516767b4f173a63$export$f2a5a7bac7258e1] + this.z * l_mat[0, $8516767b4f173a63$export$b9223c25c7ef9657] + l_mat[0, $8516767b4f173a63$export$92c05cfba9c4af26], this.x * l_mat[0, $8516767b4f173a63$export$f962d36842749298] + this.y * l_mat[0, $8516767b4f173a63$export$82895316122b6751] + this.z * l_mat[0, $8516767b4f173a63$export$4bbf13e387a5a72d] + l_mat[0, $8516767b4f173a63$export$5ef568f270a37e28]);
    }
    project(matrix) {
        let l_mat = matrix.values;
        let l_w = 1 / (this.x * l_mat[0, $8516767b4f173a63$export$bc0cebc6a0427364] + this.y * l_mat[0, $8516767b4f173a63$export$dc2c5fe5c845d994] + this.z * l_mat[0, $8516767b4f173a63$export$f6ad99760c0e8d51] + l_mat[0, $8516767b4f173a63$export$ab9ff870dfff35f]);
        return this.set((this.x * l_mat[0, $8516767b4f173a63$export$b06a2a6195c06efc] + this.y * l_mat[0, $8516767b4f173a63$export$5ae52f682687d620] + this.z * l_mat[0, $8516767b4f173a63$export$91e90b05312755fb] + l_mat[0, $8516767b4f173a63$export$99d2679d75e60dc2]) * l_w, (this.x * l_mat[0, $8516767b4f173a63$export$585a161a9f77f349] + this.y * l_mat[0, $8516767b4f173a63$export$f2a5a7bac7258e1] + this.z * l_mat[0, $8516767b4f173a63$export$b9223c25c7ef9657] + l_mat[0, $8516767b4f173a63$export$92c05cfba9c4af26]) * l_w, (this.x * l_mat[0, $8516767b4f173a63$export$f962d36842749298] + this.y * l_mat[0, $8516767b4f173a63$export$82895316122b6751] + this.z * l_mat[0, $8516767b4f173a63$export$4bbf13e387a5a72d] + l_mat[0, $8516767b4f173a63$export$5ef568f270a37e28]) * l_w);
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    distance(v) {
        let a = v.x - this.x;
        let b = v.y - this.y;
        let c = v.z - this.z;
        return Math.sqrt(a * a + b * b + c * c);
    }
}


const $8516767b4f173a63$export$b06a2a6195c06efc = 0;
const $8516767b4f173a63$export$5ae52f682687d620 = 4;
const $8516767b4f173a63$export$91e90b05312755fb = 8;
const $8516767b4f173a63$export$99d2679d75e60dc2 = 12;
const $8516767b4f173a63$export$585a161a9f77f349 = 1;
const $8516767b4f173a63$export$f2a5a7bac7258e1 = 5;
const $8516767b4f173a63$export$b9223c25c7ef9657 = 9;
const $8516767b4f173a63$export$92c05cfba9c4af26 = 13;
const $8516767b4f173a63$export$f962d36842749298 = 2;
const $8516767b4f173a63$export$82895316122b6751 = 6;
const $8516767b4f173a63$export$4bbf13e387a5a72d = 10;
const $8516767b4f173a63$export$5ef568f270a37e28 = 14;
const $8516767b4f173a63$export$bc0cebc6a0427364 = 3;
const $8516767b4f173a63$export$dc2c5fe5c845d994 = 7;
const $8516767b4f173a63$export$f6ad99760c0e8d51 = 11;
const $8516767b4f173a63$export$ab9ff870dfff35f = 15;
class $8516767b4f173a63$export$2ae72fc923e5eb5 {
    temp = new Float32Array(16);
    values = new Float32Array(16);
    static xAxis = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)();
    static yAxis = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)();
    static zAxis = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)();
    static tmpMatrix = new $8516767b4f173a63$export$2ae72fc923e5eb5();
    constructor(){
        let v = this.values;
        v[$8516767b4f173a63$export$b06a2a6195c06efc] = 1;
        v[$8516767b4f173a63$export$f2a5a7bac7258e1] = 1;
        v[$8516767b4f173a63$export$4bbf13e387a5a72d] = 1;
        v[$8516767b4f173a63$export$ab9ff870dfff35f] = 1;
    }
    set(values) {
        this.values.set(values);
        return this;
    }
    transpose() {
        let t = this.temp;
        let v = this.values;
        t[$8516767b4f173a63$export$b06a2a6195c06efc] = v[$8516767b4f173a63$export$b06a2a6195c06efc];
        t[$8516767b4f173a63$export$5ae52f682687d620] = v[$8516767b4f173a63$export$585a161a9f77f349];
        t[$8516767b4f173a63$export$91e90b05312755fb] = v[$8516767b4f173a63$export$f962d36842749298];
        t[$8516767b4f173a63$export$99d2679d75e60dc2] = v[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$585a161a9f77f349] = v[$8516767b4f173a63$export$5ae52f682687d620];
        t[$8516767b4f173a63$export$f2a5a7bac7258e1] = v[$8516767b4f173a63$export$f2a5a7bac7258e1];
        t[$8516767b4f173a63$export$b9223c25c7ef9657] = v[$8516767b4f173a63$export$82895316122b6751];
        t[$8516767b4f173a63$export$92c05cfba9c4af26] = v[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$f962d36842749298] = v[$8516767b4f173a63$export$91e90b05312755fb];
        t[$8516767b4f173a63$export$82895316122b6751] = v[$8516767b4f173a63$export$b9223c25c7ef9657];
        t[$8516767b4f173a63$export$4bbf13e387a5a72d] = v[$8516767b4f173a63$export$4bbf13e387a5a72d];
        t[$8516767b4f173a63$export$5ef568f270a37e28] = v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$bc0cebc6a0427364] = v[$8516767b4f173a63$export$99d2679d75e60dc2];
        t[$8516767b4f173a63$export$dc2c5fe5c845d994] = v[$8516767b4f173a63$export$92c05cfba9c4af26];
        t[$8516767b4f173a63$export$f6ad99760c0e8d51] = v[$8516767b4f173a63$export$5ef568f270a37e28];
        t[$8516767b4f173a63$export$ab9ff870dfff35f] = v[$8516767b4f173a63$export$ab9ff870dfff35f];
        return this.set(t);
    }
    identity() {
        let v = this.values;
        v[$8516767b4f173a63$export$b06a2a6195c06efc] = 1;
        v[$8516767b4f173a63$export$5ae52f682687d620] = 0;
        v[$8516767b4f173a63$export$91e90b05312755fb] = 0;
        v[$8516767b4f173a63$export$99d2679d75e60dc2] = 0;
        v[$8516767b4f173a63$export$585a161a9f77f349] = 0;
        v[$8516767b4f173a63$export$f2a5a7bac7258e1] = 1;
        v[$8516767b4f173a63$export$b9223c25c7ef9657] = 0;
        v[$8516767b4f173a63$export$92c05cfba9c4af26] = 0;
        v[$8516767b4f173a63$export$f962d36842749298] = 0;
        v[$8516767b4f173a63$export$82895316122b6751] = 0;
        v[$8516767b4f173a63$export$4bbf13e387a5a72d] = 1;
        v[$8516767b4f173a63$export$5ef568f270a37e28] = 0;
        v[$8516767b4f173a63$export$bc0cebc6a0427364] = 0;
        v[$8516767b4f173a63$export$dc2c5fe5c845d994] = 0;
        v[$8516767b4f173a63$export$f6ad99760c0e8d51] = 0;
        v[$8516767b4f173a63$export$ab9ff870dfff35f] = 1;
        return this;
    }
    invert() {
        let v = this.values;
        let t = this.temp;
        let l_det = v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$92c05cfba9c4af26] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$92c05cfba9c4af26] - v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        if (l_det == 0) throw new Error("non-invertible matrix");
        let inv_det = 1.0 / l_det;
        t[$8516767b4f173a63$export$b06a2a6195c06efc] = v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$5ae52f682687d620] = v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$91e90b05312755fb] = v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$99d2679d75e60dc2] = v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$82895316122b6751] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$82895316122b6751] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28];
        t[$8516767b4f173a63$export$585a161a9f77f349] = v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$f2a5a7bac7258e1] = v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$bc0cebc6a0427364] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$b9223c25c7ef9657] = v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$92c05cfba9c4af26] = v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f962d36842749298] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$f962d36842749298] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28];
        t[$8516767b4f173a63$export$f962d36842749298] = v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$bc0cebc6a0427364] + v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$82895316122b6751] = v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$4bbf13e387a5a72d] = v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$bc0cebc6a0427364] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$5ef568f270a37e28] = v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f962d36842749298] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f962d36842749298] - v[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$82895316122b6751] + v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$5ef568f270a37e28];
        t[$8516767b4f173a63$export$bc0cebc6a0427364] = v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$dc2c5fe5c845d994] = v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$bc0cebc6a0427364] + v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$f6ad99760c0e8d51] = v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$bc0cebc6a0427364] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] + v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$ab9ff870dfff35f] = v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$f962d36842749298] - v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f962d36842749298] + v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$82895316122b6751] - v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d];
        v[$8516767b4f173a63$export$b06a2a6195c06efc] = t[$8516767b4f173a63$export$b06a2a6195c06efc] * inv_det;
        v[$8516767b4f173a63$export$5ae52f682687d620] = t[$8516767b4f173a63$export$5ae52f682687d620] * inv_det;
        v[$8516767b4f173a63$export$91e90b05312755fb] = t[$8516767b4f173a63$export$91e90b05312755fb] * inv_det;
        v[$8516767b4f173a63$export$99d2679d75e60dc2] = t[$8516767b4f173a63$export$99d2679d75e60dc2] * inv_det;
        v[$8516767b4f173a63$export$585a161a9f77f349] = t[$8516767b4f173a63$export$585a161a9f77f349] * inv_det;
        v[$8516767b4f173a63$export$f2a5a7bac7258e1] = t[$8516767b4f173a63$export$f2a5a7bac7258e1] * inv_det;
        v[$8516767b4f173a63$export$b9223c25c7ef9657] = t[$8516767b4f173a63$export$b9223c25c7ef9657] * inv_det;
        v[$8516767b4f173a63$export$92c05cfba9c4af26] = t[$8516767b4f173a63$export$92c05cfba9c4af26] * inv_det;
        v[$8516767b4f173a63$export$f962d36842749298] = t[$8516767b4f173a63$export$f962d36842749298] * inv_det;
        v[$8516767b4f173a63$export$82895316122b6751] = t[$8516767b4f173a63$export$82895316122b6751] * inv_det;
        v[$8516767b4f173a63$export$4bbf13e387a5a72d] = t[$8516767b4f173a63$export$4bbf13e387a5a72d] * inv_det;
        v[$8516767b4f173a63$export$5ef568f270a37e28] = t[$8516767b4f173a63$export$5ef568f270a37e28] * inv_det;
        v[$8516767b4f173a63$export$bc0cebc6a0427364] = t[$8516767b4f173a63$export$bc0cebc6a0427364] * inv_det;
        v[$8516767b4f173a63$export$dc2c5fe5c845d994] = t[$8516767b4f173a63$export$dc2c5fe5c845d994] * inv_det;
        v[$8516767b4f173a63$export$f6ad99760c0e8d51] = t[$8516767b4f173a63$export$f6ad99760c0e8d51] * inv_det;
        v[$8516767b4f173a63$export$ab9ff870dfff35f] = t[$8516767b4f173a63$export$ab9ff870dfff35f] * inv_det;
        return this;
    }
    determinant() {
        let v = this.values;
        return v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$99d2679d75e60dc2] - v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$92c05cfba9c4af26] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$92c05cfba9c4af26] - v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$5ef568f270a37e28] - v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$ab9ff870dfff35f] - v[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f] + v[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
    }
    translate(x, y, z) {
        let v = this.values;
        v[$8516767b4f173a63$export$99d2679d75e60dc2] += x;
        v[$8516767b4f173a63$export$92c05cfba9c4af26] += y;
        v[$8516767b4f173a63$export$5ef568f270a37e28] += z;
        return this;
    }
    copy() {
        return new $8516767b4f173a63$export$2ae72fc923e5eb5().set(this.values);
    }
    projection(near, far, fovy, aspectRatio) {
        this.identity();
        let l_fd = 1.0 / Math.tan(fovy * (Math.PI / 180) / 2.0);
        let l_a1 = (far + near) / (near - far);
        let l_a2 = 2 * far * near / (near - far);
        let v = this.values;
        v[$8516767b4f173a63$export$b06a2a6195c06efc] = l_fd / aspectRatio;
        v[$8516767b4f173a63$export$585a161a9f77f349] = 0;
        v[$8516767b4f173a63$export$f962d36842749298] = 0;
        v[$8516767b4f173a63$export$bc0cebc6a0427364] = 0;
        v[$8516767b4f173a63$export$5ae52f682687d620] = 0;
        v[$8516767b4f173a63$export$f2a5a7bac7258e1] = l_fd;
        v[$8516767b4f173a63$export$82895316122b6751] = 0;
        v[$8516767b4f173a63$export$dc2c5fe5c845d994] = 0;
        v[$8516767b4f173a63$export$91e90b05312755fb] = 0;
        v[$8516767b4f173a63$export$b9223c25c7ef9657] = 0;
        v[$8516767b4f173a63$export$4bbf13e387a5a72d] = l_a1;
        v[$8516767b4f173a63$export$f6ad99760c0e8d51] = -1;
        v[$8516767b4f173a63$export$99d2679d75e60dc2] = 0;
        v[$8516767b4f173a63$export$92c05cfba9c4af26] = 0;
        v[$8516767b4f173a63$export$5ef568f270a37e28] = l_a2;
        v[$8516767b4f173a63$export$ab9ff870dfff35f] = 0;
        return this;
    }
    ortho2d(x, y, width, height) {
        return this.ortho(x, x + width, y, y + height, 0, 1);
    }
    ortho(left, right, bottom, top, near, far) {
        this.identity();
        let x_orth = 2 / (right - left);
        let y_orth = 2 / (top - bottom);
        let z_orth = -2 / (far - near);
        let tx = -(right + left) / (right - left);
        let ty = -(top + bottom) / (top - bottom);
        let tz = -(far + near) / (far - near);
        let v = this.values;
        v[$8516767b4f173a63$export$b06a2a6195c06efc] = x_orth;
        v[$8516767b4f173a63$export$585a161a9f77f349] = 0;
        v[$8516767b4f173a63$export$f962d36842749298] = 0;
        v[$8516767b4f173a63$export$bc0cebc6a0427364] = 0;
        v[$8516767b4f173a63$export$5ae52f682687d620] = 0;
        v[$8516767b4f173a63$export$f2a5a7bac7258e1] = y_orth;
        v[$8516767b4f173a63$export$82895316122b6751] = 0;
        v[$8516767b4f173a63$export$dc2c5fe5c845d994] = 0;
        v[$8516767b4f173a63$export$91e90b05312755fb] = 0;
        v[$8516767b4f173a63$export$b9223c25c7ef9657] = 0;
        v[$8516767b4f173a63$export$4bbf13e387a5a72d] = z_orth;
        v[$8516767b4f173a63$export$f6ad99760c0e8d51] = 0;
        v[$8516767b4f173a63$export$99d2679d75e60dc2] = tx;
        v[$8516767b4f173a63$export$92c05cfba9c4af26] = ty;
        v[$8516767b4f173a63$export$5ef568f270a37e28] = tz;
        v[$8516767b4f173a63$export$ab9ff870dfff35f] = 1;
        return this;
    }
    multiply(matrix) {
        let t = this.temp;
        let v = this.values;
        let m = matrix.values;
        t[$8516767b4f173a63$export$b06a2a6195c06efc] = v[$8516767b4f173a63$export$b06a2a6195c06efc] * m[$8516767b4f173a63$export$b06a2a6195c06efc] + v[$8516767b4f173a63$export$5ae52f682687d620] * m[$8516767b4f173a63$export$585a161a9f77f349] + v[$8516767b4f173a63$export$91e90b05312755fb] * m[$8516767b4f173a63$export$f962d36842749298] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * m[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$5ae52f682687d620] = v[$8516767b4f173a63$export$b06a2a6195c06efc] * m[$8516767b4f173a63$export$5ae52f682687d620] + v[$8516767b4f173a63$export$5ae52f682687d620] * m[$8516767b4f173a63$export$f2a5a7bac7258e1] + v[$8516767b4f173a63$export$91e90b05312755fb] * m[$8516767b4f173a63$export$82895316122b6751] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * m[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$91e90b05312755fb] = v[$8516767b4f173a63$export$b06a2a6195c06efc] * m[$8516767b4f173a63$export$91e90b05312755fb] + v[$8516767b4f173a63$export$5ae52f682687d620] * m[$8516767b4f173a63$export$b9223c25c7ef9657] + v[$8516767b4f173a63$export$91e90b05312755fb] * m[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * m[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$99d2679d75e60dc2] = v[$8516767b4f173a63$export$b06a2a6195c06efc] * m[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$5ae52f682687d620] * m[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$91e90b05312755fb] * m[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$99d2679d75e60dc2] * m[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$585a161a9f77f349] = v[$8516767b4f173a63$export$585a161a9f77f349] * m[$8516767b4f173a63$export$b06a2a6195c06efc] + v[$8516767b4f173a63$export$f2a5a7bac7258e1] * m[$8516767b4f173a63$export$585a161a9f77f349] + v[$8516767b4f173a63$export$b9223c25c7ef9657] * m[$8516767b4f173a63$export$f962d36842749298] + v[$8516767b4f173a63$export$92c05cfba9c4af26] * m[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$f2a5a7bac7258e1] = v[$8516767b4f173a63$export$585a161a9f77f349] * m[$8516767b4f173a63$export$5ae52f682687d620] + v[$8516767b4f173a63$export$f2a5a7bac7258e1] * m[$8516767b4f173a63$export$f2a5a7bac7258e1] + v[$8516767b4f173a63$export$b9223c25c7ef9657] * m[$8516767b4f173a63$export$82895316122b6751] + v[$8516767b4f173a63$export$92c05cfba9c4af26] * m[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$b9223c25c7ef9657] = v[$8516767b4f173a63$export$585a161a9f77f349] * m[$8516767b4f173a63$export$91e90b05312755fb] + v[$8516767b4f173a63$export$f2a5a7bac7258e1] * m[$8516767b4f173a63$export$b9223c25c7ef9657] + v[$8516767b4f173a63$export$b9223c25c7ef9657] * m[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$92c05cfba9c4af26] * m[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$92c05cfba9c4af26] = v[$8516767b4f173a63$export$585a161a9f77f349] * m[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$f2a5a7bac7258e1] * m[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$b9223c25c7ef9657] * m[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$92c05cfba9c4af26] * m[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$f962d36842749298] = v[$8516767b4f173a63$export$f962d36842749298] * m[$8516767b4f173a63$export$b06a2a6195c06efc] + v[$8516767b4f173a63$export$82895316122b6751] * m[$8516767b4f173a63$export$585a161a9f77f349] + v[$8516767b4f173a63$export$4bbf13e387a5a72d] * m[$8516767b4f173a63$export$f962d36842749298] + v[$8516767b4f173a63$export$5ef568f270a37e28] * m[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$82895316122b6751] = v[$8516767b4f173a63$export$f962d36842749298] * m[$8516767b4f173a63$export$5ae52f682687d620] + v[$8516767b4f173a63$export$82895316122b6751] * m[$8516767b4f173a63$export$f2a5a7bac7258e1] + v[$8516767b4f173a63$export$4bbf13e387a5a72d] * m[$8516767b4f173a63$export$82895316122b6751] + v[$8516767b4f173a63$export$5ef568f270a37e28] * m[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$4bbf13e387a5a72d] = v[$8516767b4f173a63$export$f962d36842749298] * m[$8516767b4f173a63$export$91e90b05312755fb] + v[$8516767b4f173a63$export$82895316122b6751] * m[$8516767b4f173a63$export$b9223c25c7ef9657] + v[$8516767b4f173a63$export$4bbf13e387a5a72d] * m[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$5ef568f270a37e28] * m[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$5ef568f270a37e28] = v[$8516767b4f173a63$export$f962d36842749298] * m[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$82895316122b6751] * m[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$4bbf13e387a5a72d] * m[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$5ef568f270a37e28] * m[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$bc0cebc6a0427364] = v[$8516767b4f173a63$export$bc0cebc6a0427364] * m[$8516767b4f173a63$export$b06a2a6195c06efc] + v[$8516767b4f173a63$export$dc2c5fe5c845d994] * m[$8516767b4f173a63$export$585a161a9f77f349] + v[$8516767b4f173a63$export$f6ad99760c0e8d51] * m[$8516767b4f173a63$export$f962d36842749298] + v[$8516767b4f173a63$export$ab9ff870dfff35f] * m[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$dc2c5fe5c845d994] = v[$8516767b4f173a63$export$bc0cebc6a0427364] * m[$8516767b4f173a63$export$5ae52f682687d620] + v[$8516767b4f173a63$export$dc2c5fe5c845d994] * m[$8516767b4f173a63$export$f2a5a7bac7258e1] + v[$8516767b4f173a63$export$f6ad99760c0e8d51] * m[$8516767b4f173a63$export$82895316122b6751] + v[$8516767b4f173a63$export$ab9ff870dfff35f] * m[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$f6ad99760c0e8d51] = v[$8516767b4f173a63$export$bc0cebc6a0427364] * m[$8516767b4f173a63$export$91e90b05312755fb] + v[$8516767b4f173a63$export$dc2c5fe5c845d994] * m[$8516767b4f173a63$export$b9223c25c7ef9657] + v[$8516767b4f173a63$export$f6ad99760c0e8d51] * m[$8516767b4f173a63$export$4bbf13e387a5a72d] + v[$8516767b4f173a63$export$ab9ff870dfff35f] * m[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$ab9ff870dfff35f] = v[$8516767b4f173a63$export$bc0cebc6a0427364] * m[$8516767b4f173a63$export$99d2679d75e60dc2] + v[$8516767b4f173a63$export$dc2c5fe5c845d994] * m[$8516767b4f173a63$export$92c05cfba9c4af26] + v[$8516767b4f173a63$export$f6ad99760c0e8d51] * m[$8516767b4f173a63$export$5ef568f270a37e28] + v[$8516767b4f173a63$export$ab9ff870dfff35f] * m[$8516767b4f173a63$export$ab9ff870dfff35f];
        return this.set(this.temp);
    }
    multiplyLeft(matrix) {
        let t = this.temp;
        let v = this.values;
        let m = matrix.values;
        t[$8516767b4f173a63$export$b06a2a6195c06efc] = m[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$b06a2a6195c06efc] + m[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$585a161a9f77f349] + m[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$f962d36842749298] + m[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$5ae52f682687d620] = m[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$5ae52f682687d620] + m[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] + m[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$82895316122b6751] + m[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$91e90b05312755fb] = m[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$91e90b05312755fb] + m[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$b9223c25c7ef9657] + m[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + m[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$99d2679d75e60dc2] = m[$8516767b4f173a63$export$b06a2a6195c06efc] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + m[$8516767b4f173a63$export$5ae52f682687d620] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + m[$8516767b4f173a63$export$91e90b05312755fb] * v[$8516767b4f173a63$export$5ef568f270a37e28] + m[$8516767b4f173a63$export$99d2679d75e60dc2] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$585a161a9f77f349] = m[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$b06a2a6195c06efc] + m[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$585a161a9f77f349] + m[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$f962d36842749298] + m[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$f2a5a7bac7258e1] = m[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$5ae52f682687d620] + m[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] + m[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$82895316122b6751] + m[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$b9223c25c7ef9657] = m[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$91e90b05312755fb] + m[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$b9223c25c7ef9657] + m[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + m[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$92c05cfba9c4af26] = m[$8516767b4f173a63$export$585a161a9f77f349] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + m[$8516767b4f173a63$export$f2a5a7bac7258e1] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + m[$8516767b4f173a63$export$b9223c25c7ef9657] * v[$8516767b4f173a63$export$5ef568f270a37e28] + m[$8516767b4f173a63$export$92c05cfba9c4af26] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$f962d36842749298] = m[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$b06a2a6195c06efc] + m[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$585a161a9f77f349] + m[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$f962d36842749298] + m[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$82895316122b6751] = m[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$5ae52f682687d620] + m[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] + m[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$82895316122b6751] + m[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$4bbf13e387a5a72d] = m[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$91e90b05312755fb] + m[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$b9223c25c7ef9657] + m[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + m[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$5ef568f270a37e28] = m[$8516767b4f173a63$export$f962d36842749298] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + m[$8516767b4f173a63$export$82895316122b6751] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + m[$8516767b4f173a63$export$4bbf13e387a5a72d] * v[$8516767b4f173a63$export$5ef568f270a37e28] + m[$8516767b4f173a63$export$5ef568f270a37e28] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        t[$8516767b4f173a63$export$bc0cebc6a0427364] = m[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$b06a2a6195c06efc] + m[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$585a161a9f77f349] + m[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$f962d36842749298] + m[$8516767b4f173a63$export$ab9ff870dfff35f] * v[$8516767b4f173a63$export$bc0cebc6a0427364];
        t[$8516767b4f173a63$export$dc2c5fe5c845d994] = m[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$5ae52f682687d620] + m[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$f2a5a7bac7258e1] + m[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$82895316122b6751] + m[$8516767b4f173a63$export$ab9ff870dfff35f] * v[$8516767b4f173a63$export$dc2c5fe5c845d994];
        t[$8516767b4f173a63$export$f6ad99760c0e8d51] = m[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$91e90b05312755fb] + m[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$b9223c25c7ef9657] + m[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$4bbf13e387a5a72d] + m[$8516767b4f173a63$export$ab9ff870dfff35f] * v[$8516767b4f173a63$export$f6ad99760c0e8d51];
        t[$8516767b4f173a63$export$ab9ff870dfff35f] = m[$8516767b4f173a63$export$bc0cebc6a0427364] * v[$8516767b4f173a63$export$99d2679d75e60dc2] + m[$8516767b4f173a63$export$dc2c5fe5c845d994] * v[$8516767b4f173a63$export$92c05cfba9c4af26] + m[$8516767b4f173a63$export$f6ad99760c0e8d51] * v[$8516767b4f173a63$export$5ef568f270a37e28] + m[$8516767b4f173a63$export$ab9ff870dfff35f] * v[$8516767b4f173a63$export$ab9ff870dfff35f];
        return this.set(this.temp);
    }
    lookAt(position, direction, up) {
        let xAxis = $8516767b4f173a63$export$2ae72fc923e5eb5.xAxis, yAxis = $8516767b4f173a63$export$2ae72fc923e5eb5.yAxis, zAxis = $8516767b4f173a63$export$2ae72fc923e5eb5.zAxis;
        zAxis.setFrom(direction).normalize();
        xAxis.setFrom(direction).normalize();
        xAxis.cross(up).normalize();
        yAxis.setFrom(xAxis).cross(zAxis).normalize();
        this.identity();
        let val = this.values;
        val[$8516767b4f173a63$export$b06a2a6195c06efc] = xAxis.x;
        val[$8516767b4f173a63$export$5ae52f682687d620] = xAxis.y;
        val[$8516767b4f173a63$export$91e90b05312755fb] = xAxis.z;
        val[$8516767b4f173a63$export$585a161a9f77f349] = yAxis.x;
        val[$8516767b4f173a63$export$f2a5a7bac7258e1] = yAxis.y;
        val[$8516767b4f173a63$export$b9223c25c7ef9657] = yAxis.z;
        val[$8516767b4f173a63$export$f962d36842749298] = -zAxis.x;
        val[$8516767b4f173a63$export$82895316122b6751] = -zAxis.y;
        val[$8516767b4f173a63$export$4bbf13e387a5a72d] = -zAxis.z;
        $8516767b4f173a63$export$2ae72fc923e5eb5.tmpMatrix.identity();
        $8516767b4f173a63$export$2ae72fc923e5eb5.tmpMatrix.values[$8516767b4f173a63$export$99d2679d75e60dc2] = -position.x;
        $8516767b4f173a63$export$2ae72fc923e5eb5.tmpMatrix.values[$8516767b4f173a63$export$92c05cfba9c4af26] = -position.y;
        $8516767b4f173a63$export$2ae72fc923e5eb5.tmpMatrix.values[$8516767b4f173a63$export$5ef568f270a37e28] = -position.z;
        this.multiply($8516767b4f173a63$export$2ae72fc923e5eb5.tmpMatrix);
        return this;
    }
}



class $d46010cbc21da9ce$export$b58af824322cf043 {
    position = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(0, 0, 0);
    direction = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(0, 0, -1);
    up = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(0, 1, 0);
    near = 0;
    far = 100;
    zoom = 1;
    viewportWidth = 0;
    viewportHeight = 0;
    projectionView = new (0, $8516767b4f173a63$export$2ae72fc923e5eb5)();
    inverseProjectionView = new (0, $8516767b4f173a63$export$2ae72fc923e5eb5)();
    projection = new (0, $8516767b4f173a63$export$2ae72fc923e5eb5)();
    view = new (0, $8516767b4f173a63$export$2ae72fc923e5eb5)();
    constructor(viewportWidth, viewportHeight){
        this.viewportWidth = viewportWidth;
        this.viewportHeight = viewportHeight;
        this.update();
    }
    update() {
        let projection = this.projection;
        let view = this.view;
        let projectionView = this.projectionView;
        let inverseProjectionView = this.inverseProjectionView;
        let zoom = this.zoom, viewportWidth = this.viewportWidth, viewportHeight = this.viewportHeight;
        projection.ortho(zoom * (-viewportWidth / 2), zoom * (viewportWidth / 2), zoom * (-viewportHeight / 2), zoom * (viewportHeight / 2), this.near, this.far);
        view.lookAt(this.position, this.direction, this.up);
        projectionView.set(projection.values);
        projectionView.multiply(view);
        inverseProjectionView.set(projectionView.values).invert();
    }
    screenToWorld(screenCoords, screenWidth, screenHeight) {
        let x = screenCoords.x, y = screenHeight - screenCoords.y - 1;
        screenCoords.x = 2 * x / screenWidth - 1;
        screenCoords.y = 2 * y / screenHeight - 1;
        screenCoords.z = 2 * screenCoords.z - 1;
        screenCoords.project(this.inverseProjectionView);
        return screenCoords;
    }
    worldToScreen(worldCoords, screenWidth, screenHeight) {
        worldCoords.project(this.projectionView);
        worldCoords.x = screenWidth * (worldCoords.x + 1) / 2;
        worldCoords.y = screenHeight * (worldCoords.y + 1) / 2;
        worldCoords.z = (worldCoords.z + 1) / 2;
        return worldCoords;
    }
    setViewport(viewportWidth, viewportHeight) {
        this.viewportWidth = viewportWidth;
        this.viewportHeight = viewportHeight;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $c2bf87b18acde811$export$f5b8910cec6cf069 {
    element;
    mouseX = 0;
    mouseY = 0;
    buttonDown = false;
    touch0 = null;
    touch1 = null;
    initialPinchDistance = 0;
    listeners = new Array();
    eventListeners = [];
    constructor(element){
        this.element = element;
        this.setupCallbacks(element);
    }
    setupCallbacks(element) {
        let mouseDown = (ev)=>{
            if (ev instanceof MouseEvent) {
                let rect = element.getBoundingClientRect();
                this.mouseX = ev.clientX - rect.left;
                this.mouseY = ev.clientY - rect.top;
                this.buttonDown = true;
                this.listeners.map((listener)=>{
                    if (listener.down) listener.down(this.mouseX, this.mouseY);
                });
                document.addEventListener("mousemove", mouseMove);
                document.addEventListener("mouseup", mouseUp);
            }
        };
        let mouseMove = (ev)=>{
            if (ev instanceof MouseEvent) {
                let rect = element.getBoundingClientRect();
                this.mouseX = ev.clientX - rect.left;
                this.mouseY = ev.clientY - rect.top;
                this.listeners.map((listener)=>{
                    if (this.buttonDown) {
                        if (listener.dragged) listener.dragged(this.mouseX, this.mouseY);
                    } else if (listener.moved) listener.moved(this.mouseX, this.mouseY);
                });
            }
        };
        let mouseUp = (ev)=>{
            if (ev instanceof MouseEvent) {
                let rect = element.getBoundingClientRect();
                this.mouseX = ev.clientX - rect.left;
                this.mouseY = ev.clientY - rect.top;
                this.buttonDown = false;
                this.listeners.map((listener)=>{
                    if (listener.up) listener.up(this.mouseX, this.mouseY);
                });
                document.removeEventListener("mousemove", mouseMove);
                document.removeEventListener("mouseup", mouseUp);
            }
        };
        let mouseWheel = (e)=>{
            e.preventDefault();
            let deltaY = e.deltaY;
            if (e.deltaMode == WheelEvent.DOM_DELTA_LINE) deltaY *= 8;
            if (e.deltaMode == WheelEvent.DOM_DELTA_PAGE) deltaY *= 24;
            this.listeners.map((listener)=>{
                if (listener.wheel) listener.wheel(e.deltaY);
            });
        };
        element.addEventListener("mousedown", mouseDown, true);
        element.addEventListener("mousemove", mouseMove, true);
        element.addEventListener("mouseup", mouseUp, true);
        element.addEventListener("wheel", mouseWheel, true);
        element.addEventListener("touchstart", (ev)=>{
            if (!this.touch0 || !this.touch1) {
                var touches = ev.changedTouches;
                let nativeTouch = touches.item(0);
                if (!nativeTouch) return;
                let rect = element.getBoundingClientRect();
                let x = nativeTouch.clientX - rect.left;
                let y = nativeTouch.clientY - rect.top;
                let touch = new $c2bf87b18acde811$export$746b04bbf92762fd(nativeTouch.identifier, x, y);
                this.mouseX = x;
                this.mouseY = y;
                this.buttonDown = true;
                if (!this.touch0) {
                    this.touch0 = touch;
                    this.listeners.map((listener)=>{
                        if (listener.down) listener.down(touch.x, touch.y);
                    });
                } else if (!this.touch1) {
                    this.touch1 = touch;
                    let dx = this.touch1.x - this.touch0.x;
                    let dy = this.touch1.x - this.touch0.x;
                    this.initialPinchDistance = Math.sqrt(dx * dx + dy * dy);
                    this.listeners.map((listener)=>{
                        if (listener.zoom) listener.zoom(this.initialPinchDistance, this.initialPinchDistance);
                    });
                }
            }
            ev.preventDefault();
        }, false);
        element.addEventListener("touchmove", (ev)=>{
            if (this.touch0) {
                var touches = ev.changedTouches;
                let rect = element.getBoundingClientRect();
                for(var i = 0; i < touches.length; i++){
                    var nativeTouch = touches[i];
                    let x = nativeTouch.clientX - rect.left;
                    let y = nativeTouch.clientY - rect.top;
                    if (this.touch0.identifier === nativeTouch.identifier) {
                        this.touch0.x = this.mouseX = x;
                        this.touch0.y = this.mouseY = y;
                        this.listeners.map((listener)=>{
                            if (listener.dragged) listener.dragged(x, y);
                        });
                    }
                    if (this.touch1 && this.touch1.identifier === nativeTouch.identifier) {
                        this.touch1.x = this.mouseX = x;
                        this.touch1.y = this.mouseY = y;
                    }
                }
                if (this.touch0 && this.touch1) {
                    let dx = this.touch1.x - this.touch0.x;
                    let dy = this.touch1.x - this.touch0.x;
                    let distance = Math.sqrt(dx * dx + dy * dy);
                    this.listeners.map((listener)=>{
                        if (listener.zoom) listener.zoom(this.initialPinchDistance, distance);
                    });
                }
            }
            ev.preventDefault();
        }, false);
        let touchEnd = (ev)=>{
            if (this.touch0) {
                var touches = ev.changedTouches;
                let rect = element.getBoundingClientRect();
                for(var i = 0; i < touches.length; i++){
                    var nativeTouch = touches[i];
                    let x = nativeTouch.clientX - rect.left;
                    let y = nativeTouch.clientY - rect.top;
                    if (this.touch0.identifier === nativeTouch.identifier) {
                        this.touch0 = null;
                        this.mouseX = x;
                        this.mouseY = y;
                        this.listeners.map((listener)=>{
                            if (listener.up) listener.up(x, y);
                        });
                        if (!this.touch1) {
                            this.buttonDown = false;
                            break;
                        } else {
                            this.touch0 = this.touch1;
                            this.touch1 = null;
                            this.mouseX = this.touch0.x;
                            this.mouseX = this.touch0.x;
                            this.buttonDown = true;
                            this.listeners.map((listener)=>{
                                if (listener.down) listener.down(this.touch0.x, this.touch0.y);
                            });
                        }
                    }
                    if (this.touch1 && this.touch1.identifier) this.touch1 = null;
                }
            }
            ev.preventDefault();
        };
        element.addEventListener("touchend", touchEnd, false);
        element.addEventListener("touchcancel", touchEnd);
    }
    addListener(listener) {
        this.listeners.push(listener);
    }
    removeListener(listener) {
        let idx = this.listeners.indexOf(listener);
        if (idx > -1) this.listeners.splice(idx, 1);
    }
}
class $c2bf87b18acde811$export$746b04bbf92762fd {
    identifier;
    x;
    y;
    constructor(identifier, x, y){
        this.identifier = identifier;
        this.x = x;
        this.y = y;
    }
}



class $e9268f169686a6f3$export$d53514a691eb5346 {
    canvas;
    camera;
    constructor(canvas, camera){
        this.canvas = canvas;
        this.camera = camera;
        let cameraX = 0, cameraY = 0, cameraZoom = 0;
        let mouseX = 0, mouseY = 0;
        let lastX = 0, lastY = 0;
        let initialZoom = 0;
        new (0, $c2bf87b18acde811$export$f5b8910cec6cf069)(canvas).addListener({
            down: (x, y)=>{
                cameraX = camera.position.x;
                cameraY = camera.position.y;
                mouseX = lastX = x;
                mouseY = lastY = y;
                initialZoom = camera.zoom;
            },
            dragged: (x, y)=>{
                let deltaX = x - mouseX;
                let deltaY = y - mouseY;
                let originWorld = camera.screenToWorld(new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(0, 0), canvas.clientWidth, canvas.clientHeight);
                let deltaWorld = camera.screenToWorld(new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(deltaX, deltaY), canvas.clientWidth, canvas.clientHeight).sub(originWorld);
                camera.position.set(cameraX - deltaWorld.x, cameraY - deltaWorld.y, 0);
                camera.update();
                lastX = x;
                lastY = y;
            },
            wheel: (delta)=>{
                let zoomAmount = delta / 200 * camera.zoom;
                let newZoom = camera.zoom + zoomAmount;
                if (newZoom > 0) {
                    let x = 0, y = 0;
                    if (delta < 0) {
                        x = lastX;
                        y = lastY;
                    } else {
                        let viewCenter = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(canvas.clientWidth / 2 + 15, canvas.clientHeight / 2);
                        let mouseToCenterX = lastX - viewCenter.x;
                        let mouseToCenterY = canvas.clientHeight - 1 - lastY - viewCenter.y;
                        x = viewCenter.x - mouseToCenterX;
                        y = canvas.clientHeight - 1 - viewCenter.y + mouseToCenterY;
                    }
                    let oldDistance = camera.screenToWorld(new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(x, y), canvas.clientWidth, canvas.clientHeight);
                    camera.zoom = newZoom;
                    camera.update();
                    let newDistance = camera.screenToWorld(new (0, $98b7726a3a3f3658$export$64b5c384219d3699)(x, y), canvas.clientWidth, canvas.clientHeight);
                    camera.position.add(oldDistance.sub(newDistance));
                    camera.update();
                }
            },
            zoom: (initialDistance, distance)=>{
                let newZoom = initialDistance / distance;
                camera.zoom = initialZoom * newZoom;
            },
            up: (x, y)=>{
                lastX = x;
                lastY = y;
            },
            moved: (x, y)=>{
                lastX = x;
                lastY = y;
            }
        });
    }
}




/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $f5e32484888a4c49$export$462bb059fed9d9e5 {
    vertexShader;
    fragmentShader;
    static MVP_MATRIX = "u_projTrans";
    static POSITION = "a_position";
    static COLOR = "a_color";
    static COLOR2 = "a_color2";
    static TEXCOORDS = "a_texCoords";
    static SAMPLER = "u_texture";
    context;
    vs = null;
    vsSource;
    fs = null;
    fsSource;
    program = null;
    tmp2x2 = new Float32Array(4);
    tmp3x3 = new Float32Array(9);
    tmp4x4 = new Float32Array(16);
    getProgram() {
        return this.program;
    }
    getVertexShader() {
        return this.vertexShader;
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    getVertexShaderSource() {
        return this.vsSource;
    }
    getFragmentSource() {
        return this.fsSource;
    }
    constructor(context, vertexShader, fragmentShader){
        this.vertexShader = vertexShader;
        this.fragmentShader = fragmentShader;
        this.vsSource = vertexShader;
        this.fsSource = fragmentShader;
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
        this.context.addRestorable(this);
        this.compile();
    }
    compile() {
        let gl = this.context.gl;
        try {
            this.vs = this.compileShader(gl.VERTEX_SHADER, this.vertexShader);
            if (!this.vs) throw new Error("Couldn't compile vertex shader.");
            this.fs = this.compileShader(gl.FRAGMENT_SHADER, this.fragmentShader);
            if (!this.fs) throw new Error("Couldn#t compile fragment shader.");
            this.program = this.compileProgram(this.vs, this.fs);
        } catch (e) {
            this.dispose();
            throw e;
        }
    }
    compileShader(type, source) {
        let gl = this.context.gl;
        let shader = gl.createShader(type);
        if (!shader) throw new Error("Couldn't create shader.");
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            let error = "Couldn't compile shader: " + gl.getShaderInfoLog(shader);
            gl.deleteShader(shader);
            if (!gl.isContextLost()) throw new Error(error);
        }
        return shader;
    }
    compileProgram(vs, fs) {
        let gl = this.context.gl;
        let program = gl.createProgram();
        if (!program) throw new Error("Couldn't compile program.");
        gl.attachShader(program, vs);
        gl.attachShader(program, fs);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            let error = "Couldn't compile shader program: " + gl.getProgramInfoLog(program);
            gl.deleteProgram(program);
            if (!gl.isContextLost()) throw new Error(error);
        }
        return program;
    }
    restore() {
        this.compile();
    }
    bind() {
        this.context.gl.useProgram(this.program);
    }
    unbind() {
        this.context.gl.useProgram(null);
    }
    setUniformi(uniform, value) {
        this.context.gl.uniform1i(this.getUniformLocation(uniform), value);
    }
    setUniformf(uniform, value) {
        this.context.gl.uniform1f(this.getUniformLocation(uniform), value);
    }
    setUniform2f(uniform, value, value2) {
        this.context.gl.uniform2f(this.getUniformLocation(uniform), value, value2);
    }
    setUniform3f(uniform, value, value2, value3) {
        this.context.gl.uniform3f(this.getUniformLocation(uniform), value, value2, value3);
    }
    setUniform4f(uniform, value, value2, value3, value4) {
        this.context.gl.uniform4f(this.getUniformLocation(uniform), value, value2, value3, value4);
    }
    setUniform2x2f(uniform, value) {
        let gl = this.context.gl;
        this.tmp2x2.set(value);
        gl.uniformMatrix2fv(this.getUniformLocation(uniform), false, this.tmp2x2);
    }
    setUniform3x3f(uniform, value) {
        let gl = this.context.gl;
        this.tmp3x3.set(value);
        gl.uniformMatrix3fv(this.getUniformLocation(uniform), false, this.tmp3x3);
    }
    setUniform4x4f(uniform, value) {
        let gl = this.context.gl;
        this.tmp4x4.set(value);
        gl.uniformMatrix4fv(this.getUniformLocation(uniform), false, this.tmp4x4);
    }
    getUniformLocation(uniform) {
        let gl = this.context.gl;
        if (!this.program) throw new Error("Shader not compiled.");
        let location = gl.getUniformLocation(this.program, uniform);
        if (!location && !gl.isContextLost()) throw new Error(`Couldn't find location for uniform ${uniform}`);
        return location;
    }
    getAttributeLocation(attribute) {
        let gl = this.context.gl;
        if (!this.program) throw new Error("Shader not compiled.");
        let location = gl.getAttribLocation(this.program, attribute);
        if (location == -1 && !gl.isContextLost()) throw new Error(`Couldn't find location for attribute ${attribute}`);
        return location;
    }
    dispose() {
        this.context.removeRestorable(this);
        let gl = this.context.gl;
        if (this.vs) {
            gl.deleteShader(this.vs);
            this.vs = null;
        }
        if (this.fs) {
            gl.deleteShader(this.fs);
            this.fs = null;
        }
        if (this.program) {
            gl.deleteProgram(this.program);
            this.program = null;
        }
    }
    static newColoredTextured(context) {
        let vs = `
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.POSITION};
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR};
attribute vec2 ${$f5e32484888a4c49$export$462bb059fed9d9e5.TEXCOORDS};
uniform mat4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.MVP_MATRIX};
varying vec4 v_color;
varying vec2 v_texCoords;

void main () {
	v_color = ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR};
	v_texCoords = ${$f5e32484888a4c49$export$462bb059fed9d9e5.TEXCOORDS};
	gl_Position = ${$f5e32484888a4c49$export$462bb059fed9d9e5.MVP_MATRIX} * ${$f5e32484888a4c49$export$462bb059fed9d9e5.POSITION};
}
`;
        let fs = `
#ifdef GL_ES
	#define LOWP lowp
	precision mediump float;
#else
	#define LOWP
#endif
varying LOWP vec4 v_color;
varying vec2 v_texCoords;
uniform sampler2D u_texture;

void main () {
	gl_FragColor = v_color * texture2D(u_texture, v_texCoords);
}
`;
        return new $f5e32484888a4c49$export$462bb059fed9d9e5(context, vs, fs);
    }
    static newTwoColoredTextured(context) {
        let vs = `
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.POSITION};
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR};
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR2};
attribute vec2 ${$f5e32484888a4c49$export$462bb059fed9d9e5.TEXCOORDS};
uniform mat4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.MVP_MATRIX};
varying vec4 v_light;
varying vec4 v_dark;
varying vec2 v_texCoords;

void main () {
	v_light = ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR};
	v_dark = ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR2};
	v_texCoords = ${$f5e32484888a4c49$export$462bb059fed9d9e5.TEXCOORDS};
	gl_Position = ${$f5e32484888a4c49$export$462bb059fed9d9e5.MVP_MATRIX} * ${$f5e32484888a4c49$export$462bb059fed9d9e5.POSITION};
}
`;
        let fs = `
#ifdef GL_ES
	#define LOWP lowp
	precision mediump float;
#else
	#define LOWP
#endif
varying LOWP vec4 v_light;
varying LOWP vec4 v_dark;
varying vec2 v_texCoords;
uniform sampler2D u_texture;

void main () {
	vec4 texColor = texture2D(u_texture, v_texCoords);
	gl_FragColor.a = texColor.a * v_light.a;
	gl_FragColor.rgb = ((texColor.a - 1.0) * v_dark.a + 1.0 - texColor.rgb) * v_dark.rgb + texColor.rgb * v_light.rgb;
}
`;
        return new $f5e32484888a4c49$export$462bb059fed9d9e5(context, vs, fs);
    }
    static newColored(context) {
        let vs = `
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.POSITION};
attribute vec4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR};
uniform mat4 ${$f5e32484888a4c49$export$462bb059fed9d9e5.MVP_MATRIX};
varying vec4 v_color;

void main () {
	v_color = ${$f5e32484888a4c49$export$462bb059fed9d9e5.COLOR};
	gl_Position = ${$f5e32484888a4c49$export$462bb059fed9d9e5.MVP_MATRIX} * ${$f5e32484888a4c49$export$462bb059fed9d9e5.POSITION};
}
`;
        let fs = `
#ifdef GL_ES
	#define LOWP lowp
	precision mediump float;
#else
	#define LOWP
#endif
varying LOWP vec4 v_color;

void main () {
	gl_FragColor = v_color;
}
`;
        return new $f5e32484888a4c49$export$462bb059fed9d9e5(context, vs, fs);
    }
}



class $c5d38e924ba9edea$export$e176487c05830cc5 {
    attributes;
    context;
    vertices;
    verticesBuffer = null;
    verticesLength = 0;
    dirtyVertices = false;
    indices;
    indicesBuffer = null;
    indicesLength = 0;
    dirtyIndices = false;
    elementsPerVertex = 0;
    getAttributes() {
        return this.attributes;
    }
    maxVertices() {
        return this.vertices.length / this.elementsPerVertex;
    }
    numVertices() {
        return this.verticesLength / this.elementsPerVertex;
    }
    setVerticesLength(length) {
        this.dirtyVertices = true;
        this.verticesLength = length;
    }
    getVertices() {
        return this.vertices;
    }
    maxIndices() {
        return this.indices.length;
    }
    numIndices() {
        return this.indicesLength;
    }
    setIndicesLength(length) {
        this.dirtyIndices = true;
        this.indicesLength = length;
    }
    getIndices() {
        return this.indices;
    }
    getVertexSizeInFloats() {
        let size = 0;
        for(var i = 0; i < this.attributes.length; i++){
            let attribute = this.attributes[i];
            size += attribute.numElements;
        }
        return size;
    }
    constructor(context, attributes, maxVertices, maxIndices){
        this.attributes = attributes;
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
        this.elementsPerVertex = 0;
        for(let i = 0; i < attributes.length; i++)this.elementsPerVertex += attributes[i].numElements;
        this.vertices = new Float32Array(maxVertices * this.elementsPerVertex);
        this.indices = new Uint16Array(maxIndices);
        this.context.addRestorable(this);
    }
    setVertices(vertices) {
        this.dirtyVertices = true;
        if (vertices.length > this.vertices.length) throw Error("Mesh can't store more than " + this.maxVertices() + " vertices");
        this.vertices.set(vertices, 0);
        this.verticesLength = vertices.length;
    }
    setIndices(indices) {
        this.dirtyIndices = true;
        if (indices.length > this.indices.length) throw Error("Mesh can't store more than " + this.maxIndices() + " indices");
        this.indices.set(indices, 0);
        this.indicesLength = indices.length;
    }
    draw(shader, primitiveType) {
        this.drawWithOffset(shader, primitiveType, 0, this.indicesLength > 0 ? this.indicesLength : this.verticesLength / this.elementsPerVertex);
    }
    drawWithOffset(shader, primitiveType, offset, count) {
        let gl = this.context.gl;
        if (this.dirtyVertices || this.dirtyIndices) this.update();
        this.bind(shader);
        if (this.indicesLength > 0) gl.drawElements(primitiveType, count, gl.UNSIGNED_SHORT, offset * 2);
        else gl.drawArrays(primitiveType, offset, count);
        this.unbind(shader);
    }
    bind(shader) {
        let gl = this.context.gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, this.verticesBuffer);
        let offset = 0;
        for(let i = 0; i < this.attributes.length; i++){
            let attrib = this.attributes[i];
            let location = shader.getAttributeLocation(attrib.name);
            gl.enableVertexAttribArray(location);
            gl.vertexAttribPointer(location, attrib.numElements, gl.FLOAT, false, this.elementsPerVertex * 4, offset * 4);
            offset += attrib.numElements;
        }
        if (this.indicesLength > 0) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
    }
    unbind(shader) {
        let gl = this.context.gl;
        for(let i = 0; i < this.attributes.length; i++){
            let attrib = this.attributes[i];
            let location = shader.getAttributeLocation(attrib.name);
            gl.disableVertexAttribArray(location);
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        if (this.indicesLength > 0) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    update() {
        let gl = this.context.gl;
        if (this.dirtyVertices) {
            if (!this.verticesBuffer) this.verticesBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, this.verticesBuffer);
            gl.bufferData(gl.ARRAY_BUFFER, this.vertices.subarray(0, this.verticesLength), gl.DYNAMIC_DRAW);
            this.dirtyVertices = false;
        }
        if (this.dirtyIndices) {
            if (!this.indicesBuffer) this.indicesBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices.subarray(0, this.indicesLength), gl.DYNAMIC_DRAW);
            this.dirtyIndices = false;
        }
    }
    restore() {
        this.verticesBuffer = null;
        this.indicesBuffer = null;
        this.update();
    }
    dispose() {
        this.context.removeRestorable(this);
        let gl = this.context.gl;
        gl.deleteBuffer(this.verticesBuffer);
        gl.deleteBuffer(this.indicesBuffer);
    }
}
class $c5d38e924ba9edea$export$142149153d9e5406 {
    name;
    type;
    numElements;
    constructor(name, type, numElements){
        this.name = name;
        this.type = type;
        this.numElements = numElements;
    }
}
class $c5d38e924ba9edea$export$6b406d6c1228e26d extends $c5d38e924ba9edea$export$142149153d9e5406 {
    constructor(){
        super((0, $f5e32484888a4c49$export$462bb059fed9d9e5).POSITION, $c5d38e924ba9edea$export$29e4de6ed653892c.Float, 2);
    }
}
class $c5d38e924ba9edea$export$440ae2b34cdfe21 extends $c5d38e924ba9edea$export$142149153d9e5406 {
    constructor(){
        super((0, $f5e32484888a4c49$export$462bb059fed9d9e5).POSITION, $c5d38e924ba9edea$export$29e4de6ed653892c.Float, 3);
    }
}
class $c5d38e924ba9edea$export$6c4bbe20c7b280cf extends $c5d38e924ba9edea$export$142149153d9e5406 {
    constructor(unit = 0){
        super((0, $f5e32484888a4c49$export$462bb059fed9d9e5).TEXCOORDS + (unit == 0 ? "" : unit), $c5d38e924ba9edea$export$29e4de6ed653892c.Float, 2);
    }
}
class $c5d38e924ba9edea$export$47e44c5f8d8a60a1 extends $c5d38e924ba9edea$export$142149153d9e5406 {
    constructor(){
        super((0, $f5e32484888a4c49$export$462bb059fed9d9e5).COLOR, $c5d38e924ba9edea$export$29e4de6ed653892c.Float, 4);
    }
}
class $c5d38e924ba9edea$export$78d25687df716e3e extends $c5d38e924ba9edea$export$142149153d9e5406 {
    constructor(){
        super((0, $f5e32484888a4c49$export$462bb059fed9d9e5).COLOR2, $c5d38e924ba9edea$export$29e4de6ed653892c.Float, 4);
    }
}
var $c5d38e924ba9edea$export$29e4de6ed653892c;
(function(VertexAttributeType) {
    VertexAttributeType[VertexAttributeType["Float"] = 0] = "Float";
})($c5d38e924ba9edea$export$29e4de6ed653892c || ($c5d38e924ba9edea$export$29e4de6ed653892c = {}));



const $2334c103a683d8ec$var$GL_ONE = 1;
const $2334c103a683d8ec$var$GL_ONE_MINUS_SRC_COLOR = 0x0301;
const $2334c103a683d8ec$var$GL_SRC_ALPHA = 0x0302;
const $2334c103a683d8ec$var$GL_ONE_MINUS_SRC_ALPHA = 0x0303;
const $2334c103a683d8ec$var$GL_ONE_MINUS_DST_ALPHA = 0x0305;
const $2334c103a683d8ec$var$GL_DST_COLOR = 0x0306;
class $2334c103a683d8ec$export$d398217aafc5a694 {
    static disableCulling = false;
    context;
    drawCalls = 0;
    static globalDrawCalls = 0;
    isDrawing = false;
    mesh;
    shader = null;
    lastTexture = null;
    verticesLength = 0;
    indicesLength = 0;
    srcColorBlend;
    srcAlphaBlend;
    dstBlend;
    cullWasEnabled = false;
    constructor(context, twoColorTint = true, maxVertices = 10920){
        if (maxVertices > 10920) throw new Error("Can't have more than 10920 triangles per batch: " + maxVertices);
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
        let attributes = twoColorTint ? [
            new (0, $c5d38e924ba9edea$export$6b406d6c1228e26d)(),
            new (0, $c5d38e924ba9edea$export$47e44c5f8d8a60a1)(),
            new (0, $c5d38e924ba9edea$export$6c4bbe20c7b280cf)(),
            new (0, $c5d38e924ba9edea$export$78d25687df716e3e)()
        ] : [
            new (0, $c5d38e924ba9edea$export$6b406d6c1228e26d)(),
            new (0, $c5d38e924ba9edea$export$47e44c5f8d8a60a1)(),
            new (0, $c5d38e924ba9edea$export$6c4bbe20c7b280cf)()
        ];
        this.mesh = new (0, $c5d38e924ba9edea$export$e176487c05830cc5)(context, attributes, maxVertices, maxVertices * 3);
        let gl = this.context.gl;
        this.srcColorBlend = gl.SRC_ALPHA;
        this.srcAlphaBlend = gl.ONE;
        this.dstBlend = gl.ONE_MINUS_SRC_ALPHA;
    }
    begin(shader) {
        if (this.isDrawing) throw new Error("PolygonBatch is already drawing. Call PolygonBatch.end() before calling PolygonBatch.begin()");
        this.drawCalls = 0;
        this.shader = shader;
        this.lastTexture = null;
        this.isDrawing = true;
        let gl = this.context.gl;
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(this.srcColorBlend, this.dstBlend, this.srcAlphaBlend, this.dstBlend);
        if ($2334c103a683d8ec$export$d398217aafc5a694.disableCulling) {
            this.cullWasEnabled = gl.isEnabled(gl.CULL_FACE);
            if (this.cullWasEnabled) gl.disable(gl.CULL_FACE);
        }
    }
    static blendModesGL = [
        {
            srcRgb: $2334c103a683d8ec$var$GL_SRC_ALPHA,
            srcRgbPma: $2334c103a683d8ec$var$GL_ONE,
            dstRgb: $2334c103a683d8ec$var$GL_ONE_MINUS_SRC_ALPHA,
            srcAlpha: $2334c103a683d8ec$var$GL_ONE
        },
        {
            srcRgb: $2334c103a683d8ec$var$GL_SRC_ALPHA,
            srcRgbPma: $2334c103a683d8ec$var$GL_ONE,
            dstRgb: $2334c103a683d8ec$var$GL_ONE,
            srcAlpha: $2334c103a683d8ec$var$GL_ONE
        },
        {
            srcRgb: $2334c103a683d8ec$var$GL_DST_COLOR,
            srcRgbPma: $2334c103a683d8ec$var$GL_DST_COLOR,
            dstRgb: $2334c103a683d8ec$var$GL_ONE_MINUS_SRC_ALPHA,
            srcAlpha: $2334c103a683d8ec$var$GL_ONE
        },
        {
            srcRgb: $2334c103a683d8ec$var$GL_ONE,
            srcRgbPma: $2334c103a683d8ec$var$GL_ONE,
            dstRgb: $2334c103a683d8ec$var$GL_ONE_MINUS_SRC_COLOR,
            srcAlpha: $2334c103a683d8ec$var$GL_ONE
        }
    ];
    setBlendMode(blendMode, premultipliedAlpha) {
        const blendModeGL = $2334c103a683d8ec$export$d398217aafc5a694.blendModesGL[blendMode];
        const srcColorBlend = premultipliedAlpha ? blendModeGL.srcRgbPma : blendModeGL.srcRgb;
        const srcAlphaBlend = blendModeGL.srcAlpha;
        const dstBlend = blendModeGL.dstRgb;
        if (this.srcColorBlend == srcColorBlend && this.srcAlphaBlend == srcAlphaBlend && this.dstBlend == dstBlend) return;
        this.srcColorBlend = srcColorBlend;
        this.srcAlphaBlend = srcAlphaBlend;
        this.dstBlend = dstBlend;
        if (this.isDrawing) this.flush();
        let gl = this.context.gl;
        gl.blendFuncSeparate(srcColorBlend, dstBlend, srcAlphaBlend, dstBlend);
    }
    draw(texture, vertices, indices) {
        if (texture != this.lastTexture) {
            this.flush();
            this.lastTexture = texture;
        } else if (this.verticesLength + vertices.length > this.mesh.getVertices().length || this.indicesLength + indices.length > this.mesh.getIndices().length) this.flush();
        let indexStart = this.mesh.numVertices();
        this.mesh.getVertices().set(vertices, this.verticesLength);
        this.verticesLength += vertices.length;
        this.mesh.setVerticesLength(this.verticesLength);
        let indicesArray = this.mesh.getIndices();
        for(let i = this.indicesLength, j = 0; j < indices.length; i++, j++)indicesArray[i] = indices[j] + indexStart;
        this.indicesLength += indices.length;
        this.mesh.setIndicesLength(this.indicesLength);
    }
    flush() {
        if (this.verticesLength == 0) return;
        if (!this.lastTexture) throw new Error("No texture set.");
        if (!this.shader) throw new Error("No shader set.");
        this.lastTexture.bind();
        this.mesh.draw(this.shader, this.context.gl.TRIANGLES);
        this.verticesLength = 0;
        this.indicesLength = 0;
        this.mesh.setVerticesLength(0);
        this.mesh.setIndicesLength(0);
        this.drawCalls++;
        $2334c103a683d8ec$export$d398217aafc5a694.globalDrawCalls++;
    }
    end() {
        if (!this.isDrawing) throw new Error("PolygonBatch is not drawing. Call PolygonBatch.begin() before calling PolygonBatch.end()");
        if (this.verticesLength > 0 || this.indicesLength > 0) this.flush();
        this.shader = null;
        this.lastTexture = null;
        this.isDrawing = false;
        let gl = this.context.gl;
        gl.disable(gl.BLEND);
        if ($2334c103a683d8ec$export$d398217aafc5a694.disableCulling) {
            if (this.cullWasEnabled) gl.enable(gl.CULL_FACE);
        }
    }
    getDrawCalls() {
        return this.drawCalls;
    }
    static getAndResetGlobalDrawCalls() {
        let result = $2334c103a683d8ec$export$d398217aafc5a694.globalDrawCalls;
        $2334c103a683d8ec$export$d398217aafc5a694.globalDrawCalls = 0;
        return result;
    }
    dispose() {
        this.mesh.dispose();
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 


class $21af4212917a02d7$export$8304e6ea0c546270 {
    context;
    isDrawing = false;
    mesh;
    shapeType = $21af4212917a02d7$export$fc850f719b5599d5.Filled;
    color = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
    shader = null;
    vertexIndex = 0;
    tmp = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
    srcColorBlend;
    srcAlphaBlend;
    dstBlend;
    constructor(context, maxVertices = 10920){
        if (maxVertices > 10920) throw new Error("Can't have more than 10920 triangles per batch: " + maxVertices);
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
        this.mesh = new (0, $c5d38e924ba9edea$export$e176487c05830cc5)(context, [
            new (0, $c5d38e924ba9edea$export$6b406d6c1228e26d)(),
            new (0, $c5d38e924ba9edea$export$47e44c5f8d8a60a1)()
        ], maxVertices, 0);
        let gl = this.context.gl;
        this.srcColorBlend = gl.SRC_ALPHA;
        this.srcAlphaBlend = gl.ONE;
        this.dstBlend = gl.ONE_MINUS_SRC_ALPHA;
    }
    begin(shader) {
        if (this.isDrawing) throw new Error("ShapeRenderer.begin() has already been called");
        this.shader = shader;
        this.vertexIndex = 0;
        this.isDrawing = true;
        let gl = this.context.gl;
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(this.srcColorBlend, this.dstBlend, this.srcAlphaBlend, this.dstBlend);
    }
    setBlendMode(srcColorBlend, srcAlphaBlend, dstBlend) {
        this.srcColorBlend = srcColorBlend;
        this.srcAlphaBlend = srcAlphaBlend;
        this.dstBlend = dstBlend;
        if (this.isDrawing) {
            this.flush();
            let gl = this.context.gl;
            gl.blendFuncSeparate(srcColorBlend, dstBlend, srcAlphaBlend, dstBlend);
        }
    }
    setColor(color) {
        this.color.setFromColor(color);
    }
    setColorWith(r, g, b, a) {
        this.color.set(r, g, b, a);
    }
    point(x, y, color) {
        this.check($21af4212917a02d7$export$fc850f719b5599d5.Point, 1);
        if (!color) color = this.color;
        this.vertex(x, y, color);
    }
    line(x, y, x2, y2, color) {
        this.check($21af4212917a02d7$export$fc850f719b5599d5.Line, 2);
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        if (!color) color = this.color;
        this.vertex(x, y, color);
        this.vertex(x2, y2, color);
    }
    triangle(filled, x, y, x2, y2, x3, y3, color, color2, color3) {
        this.check(filled ? $21af4212917a02d7$export$fc850f719b5599d5.Filled : $21af4212917a02d7$export$fc850f719b5599d5.Line, 3);
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        if (!color) color = this.color;
        if (!color2) color2 = this.color;
        if (!color3) color3 = this.color;
        if (filled) {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x3, y3, color3);
        } else {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x2, y2, color);
            this.vertex(x3, y3, color2);
            this.vertex(x3, y3, color);
            this.vertex(x, y, color2);
        }
    }
    quad(filled, x, y, x2, y2, x3, y3, x4, y4, color, color2, color3, color4) {
        this.check(filled ? $21af4212917a02d7$export$fc850f719b5599d5.Filled : $21af4212917a02d7$export$fc850f719b5599d5.Line, 3);
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        if (!color) color = this.color;
        if (!color2) color2 = this.color;
        if (!color3) color3 = this.color;
        if (!color4) color4 = this.color;
        if (filled) {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x3, y3, color3);
            this.vertex(x3, y3, color3);
            this.vertex(x4, y4, color4);
            this.vertex(x, y, color);
        } else {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x2, y2, color2);
            this.vertex(x3, y3, color3);
            this.vertex(x3, y3, color3);
            this.vertex(x4, y4, color4);
            this.vertex(x4, y4, color4);
            this.vertex(x, y, color);
        }
    }
    rect(filled, x, y, width, height, color) {
        this.quad(filled, x, y, x + width, y, x + width, y + height, x, y + height, color, color, color, color);
    }
    rectLine(filled, x1, y1, x2, y2, width, color) {
        this.check(filled ? $21af4212917a02d7$export$fc850f719b5599d5.Filled : $21af4212917a02d7$export$fc850f719b5599d5.Line, 8);
        if (!color) color = this.color;
        let t = this.tmp.set(y2 - y1, x1 - x2);
        t.normalize();
        width *= 0.5;
        let tx = t.x * width;
        let ty = t.y * width;
        if (!filled) {
            this.vertex(x1 + tx, y1 + ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x2 - tx, y2 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x1 + tx, y1 + ty, color);
            this.vertex(x2 - tx, y2 - ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
        } else {
            this.vertex(x1 + tx, y1 + ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x2 - tx, y2 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
        }
    }
    x(x, y, size) {
        this.line(x - size, y - size, x + size, y + size);
        this.line(x - size, y + size, x + size, y - size);
    }
    polygon(polygonVertices, offset, count, color) {
        if (count < 3) throw new Error("Polygon must contain at least 3 vertices");
        this.check($21af4212917a02d7$export$fc850f719b5599d5.Line, count * 2);
        if (!color) color = this.color;
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        offset <<= 1;
        count <<= 1;
        let firstX = polygonVertices[offset];
        let firstY = polygonVertices[offset + 1];
        let last = offset + count;
        for(let i = offset, n = offset + count - 2; i < n; i += 2){
            let x1 = polygonVertices[i];
            let y1 = polygonVertices[i + 1];
            let x2 = 0;
            let y2 = 0;
            if (i + 2 >= last) {
                x2 = firstX;
                y2 = firstY;
            } else {
                x2 = polygonVertices[i + 2];
                y2 = polygonVertices[i + 3];
            }
            this.vertex(x1, y1, color);
            this.vertex(x2, y2, color);
        }
    }
    circle(filled, x, y, radius, color, segments = 0) {
        if (segments == 0) segments = Math.max(1, 6 * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).cbrt(radius) | 0);
        if (segments <= 0) throw new Error("segments must be > 0.");
        if (!color) color = this.color;
        let angle = 2 * (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).PI / segments;
        let cos = Math.cos(angle);
        let sin = Math.sin(angle);
        let cx = radius, cy = 0;
        if (!filled) {
            this.check($21af4212917a02d7$export$fc850f719b5599d5.Line, segments * 2 + 2);
            for(let i = 0; i < segments; i++){
                this.vertex(x + cx, y + cy, color);
                let temp = cx;
                cx = cos * cx - sin * cy;
                cy = sin * temp + cos * cy;
                this.vertex(x + cx, y + cy, color);
            }
            // Ensure the last segment is identical to the first.
            this.vertex(x + cx, y + cy, color);
        } else {
            this.check($21af4212917a02d7$export$fc850f719b5599d5.Filled, segments * 3 + 3);
            segments--;
            for(let i = 0; i < segments; i++){
                this.vertex(x, y, color);
                this.vertex(x + cx, y + cy, color);
                let temp = cx;
                cx = cos * cx - sin * cy;
                cy = sin * temp + cos * cy;
                this.vertex(x + cx, y + cy, color);
            }
            // Ensure the last segment is identical to the first.
            this.vertex(x, y, color);
            this.vertex(x + cx, y + cy, color);
        }
        let temp = cx;
        cx = radius;
        cy = 0;
        this.vertex(x + cx, y + cy, color);
    }
    curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, segments, color) {
        this.check($21af4212917a02d7$export$fc850f719b5599d5.Line, segments * 2 + 2);
        if (!color) color = this.color;
        // Algorithm from: http://www.antigrain.com/research/bezier_interpolation/index.html#PAGE_BEZIER_INTERPOLATION
        let subdiv_step = 1 / segments;
        let subdiv_step2 = subdiv_step * subdiv_step;
        let subdiv_step3 = subdiv_step * subdiv_step * subdiv_step;
        let pre1 = 3 * subdiv_step;
        let pre2 = 3 * subdiv_step2;
        let pre4 = 6 * subdiv_step2;
        let pre5 = 6 * subdiv_step3;
        let tmp1x = x1 - cx1 * 2 + cx2;
        let tmp1y = y1 - cy1 * 2 + cy2;
        let tmp2x = (cx1 - cx2) * 3 - x1 + x2;
        let tmp2y = (cy1 - cy2) * 3 - y1 + y2;
        let fx = x1;
        let fy = y1;
        let dfx = (cx1 - x1) * pre1 + tmp1x * pre2 + tmp2x * subdiv_step3;
        let dfy = (cy1 - y1) * pre1 + tmp1y * pre2 + tmp2y * subdiv_step3;
        let ddfx = tmp1x * pre4 + tmp2x * pre5;
        let ddfy = tmp1y * pre4 + tmp2y * pre5;
        let dddfx = tmp2x * pre5;
        let dddfy = tmp2y * pre5;
        while(segments-- > 0){
            this.vertex(fx, fy, color);
            fx += dfx;
            fy += dfy;
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            this.vertex(fx, fy, color);
        }
        this.vertex(fx, fy, color);
        this.vertex(x2, y2, color);
    }
    vertex(x, y, color) {
        let idx = this.vertexIndex;
        let vertices = this.mesh.getVertices();
        vertices[idx++] = x;
        vertices[idx++] = y;
        vertices[idx++] = color.r;
        vertices[idx++] = color.g;
        vertices[idx++] = color.b;
        vertices[idx++] = color.a;
        this.vertexIndex = idx;
    }
    end() {
        if (!this.isDrawing) throw new Error("ShapeRenderer.begin() has not been called");
        this.flush();
        let gl = this.context.gl;
        gl.disable(gl.BLEND);
        this.isDrawing = false;
    }
    flush() {
        if (this.vertexIndex == 0) return;
        if (!this.shader) throw new Error("No shader set.");
        this.mesh.setVerticesLength(this.vertexIndex);
        this.mesh.draw(this.shader, this.shapeType);
        this.vertexIndex = 0;
    }
    check(shapeType, numVertices) {
        if (!this.isDrawing) throw new Error("ShapeRenderer.begin() has not been called");
        if (this.shapeType == shapeType) {
            if (this.mesh.maxVertices() - this.mesh.numVertices() < numVertices) this.flush();
            else return;
        } else {
            this.flush();
            this.shapeType = shapeType;
        }
    }
    dispose() {
        this.mesh.dispose();
    }
}
var $21af4212917a02d7$export$fc850f719b5599d5;
(function(ShapeType) {
    ShapeType[ShapeType["Point"] = 0] = "Point";
    ShapeType[ShapeType["Line"] = 1] = "Line";
    ShapeType[ShapeType["Filled"] = 4] = "Filled";
})($21af4212917a02d7$export$fc850f719b5599d5 || ($21af4212917a02d7$export$fc850f719b5599d5 = {}));


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $4ae009adbf50eea3$export$ce694abc08778c7a {
    boneLineColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 0, 0, 1);
    boneOriginColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0, 1, 0, 1);
    attachmentLineColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0, 0, 1, 0.5);
    triangleLineColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 0.64, 0, 0.5);
    pathColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)().setFromString("FF7F00");
    clipColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.8, 0, 0, 2);
    aabbColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0, 1, 0, 0.5);
    drawBones = true;
    drawRegionAttachments = true;
    drawBoundingBoxes = true;
    drawMeshHull = true;
    drawMeshTriangles = true;
    drawPaths = true;
    drawSkeletonXY = false;
    drawClipping = true;
    premultipliedAlpha = false;
    scale = 1;
    boneWidth = 2;
    context;
    bounds = new (0, $2314eb20fe3b2503$export$119f1746fc062f5e)();
    temp = new Array();
    vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(2048);
    static LIGHT_GRAY = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(192 / 255, 192 / 255, 192 / 255, 1);
    static GREEN = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0, 1, 0, 1);
    constructor(context){
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
    }
    draw(shapes, skeleton, ignoredBones) {
        let skeletonX = skeleton.x;
        let skeletonY = skeleton.y;
        let gl = this.context.gl;
        let srcFunc = this.premultipliedAlpha ? gl.ONE : gl.SRC_ALPHA;
        shapes.setBlendMode(srcFunc, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        let bones = skeleton.bones;
        if (this.drawBones) {
            shapes.setColor(this.boneLineColor);
            for(let i = 0, n = bones.length; i < n; i++){
                let bone = bones[i];
                if (ignoredBones && ignoredBones.indexOf(bone.data.name) > -1) continue;
                if (!bone.parent) continue;
                let x = bone.data.length * bone.a + bone.worldX;
                let y = bone.data.length * bone.c + bone.worldY;
                shapes.rectLine(true, bone.worldX, bone.worldY, x, y, this.boneWidth * this.scale);
            }
            if (this.drawSkeletonXY) shapes.x(skeletonX, skeletonY, 4 * this.scale);
        }
        if (this.drawRegionAttachments) {
            shapes.setColor(this.attachmentLineColor);
            let slots = skeleton.slots;
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                let attachment = slot.getAttachment();
                if (attachment instanceof (0, $679f9e8a376fdb80$export$d0fc51466fa6d530)) {
                    let regionAttachment = attachment;
                    let vertices = this.vertices;
                    regionAttachment.computeWorldVertices(slot, vertices, 0, 2);
                    shapes.line(vertices[0], vertices[1], vertices[2], vertices[3]);
                    shapes.line(vertices[2], vertices[3], vertices[4], vertices[5]);
                    shapes.line(vertices[4], vertices[5], vertices[6], vertices[7]);
                    shapes.line(vertices[6], vertices[7], vertices[0], vertices[1]);
                }
            }
        }
        if (this.drawMeshHull || this.drawMeshTriangles) {
            let slots = skeleton.slots;
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                if (!slot.bone.active) continue;
                let attachment = slot.getAttachment();
                if (!(attachment instanceof (0, $06d16b10b33d165a$export$3f1c1692adfcf3e2))) continue;
                let mesh = attachment;
                let vertices = this.vertices;
                mesh.computeWorldVertices(slot, 0, mesh.worldVerticesLength, vertices, 0, 2);
                let triangles = mesh.triangles;
                let hullLength = mesh.hullLength;
                if (this.drawMeshTriangles) {
                    shapes.setColor(this.triangleLineColor);
                    for(let ii = 0, nn = triangles.length; ii < nn; ii += 3){
                        let v1 = triangles[ii] * 2, v2 = triangles[ii + 1] * 2, v3 = triangles[ii + 2] * 2;
                        shapes.triangle(false, vertices[v1], vertices[v1 + 1], vertices[v2], vertices[v2 + 1], vertices[v3], vertices[v3 + 1] //
                        );
                    }
                }
                if (this.drawMeshHull && hullLength > 0) {
                    shapes.setColor(this.attachmentLineColor);
                    hullLength = (hullLength >> 1) * 2;
                    let lastX = vertices[hullLength - 2], lastY = vertices[hullLength - 1];
                    for(let ii = 0, nn = hullLength; ii < nn; ii += 2){
                        let x = vertices[ii], y = vertices[ii + 1];
                        shapes.line(x, y, lastX, lastY);
                        lastX = x;
                        lastY = y;
                    }
                }
            }
        }
        if (this.drawBoundingBoxes) {
            let bounds = this.bounds;
            bounds.update(skeleton, true);
            shapes.setColor(this.aabbColor);
            shapes.rect(false, bounds.minX, bounds.minY, bounds.getWidth(), bounds.getHeight());
            let polygons = bounds.polygons;
            let boxes = bounds.boundingBoxes;
            for(let i = 0, n = polygons.length; i < n; i++){
                let polygon = polygons[i];
                shapes.setColor(boxes[i].color);
                shapes.polygon(polygon, 0, polygon.length);
            }
        }
        if (this.drawPaths) {
            let slots = skeleton.slots;
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                if (!slot.bone.active) continue;
                let attachment = slot.getAttachment();
                if (!(attachment instanceof (0, $a01103cd4726e79d$export$d285e3ec07b32800))) continue;
                let path = attachment;
                let nn = path.worldVerticesLength;
                let world = this.temp = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.temp, nn, 0);
                path.computeWorldVertices(slot, 0, nn, world, 0, 2);
                let color = this.pathColor;
                let x1 = world[2], y1 = world[3], x2 = 0, y2 = 0;
                if (path.closed) {
                    shapes.setColor(color);
                    let cx1 = world[0], cy1 = world[1], cx2 = world[nn - 2], cy2 = world[nn - 1];
                    x2 = world[nn - 4];
                    y2 = world[nn - 3];
                    shapes.curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, 32);
                    shapes.setColor($4ae009adbf50eea3$export$ce694abc08778c7a.LIGHT_GRAY);
                    shapes.line(x1, y1, cx1, cy1);
                    shapes.line(x2, y2, cx2, cy2);
                }
                nn -= 4;
                for(let ii = 4; ii < nn; ii += 6){
                    let cx1 = world[ii], cy1 = world[ii + 1], cx2 = world[ii + 2], cy2 = world[ii + 3];
                    x2 = world[ii + 4];
                    y2 = world[ii + 5];
                    shapes.setColor(color);
                    shapes.curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, 32);
                    shapes.setColor($4ae009adbf50eea3$export$ce694abc08778c7a.LIGHT_GRAY);
                    shapes.line(x1, y1, cx1, cy1);
                    shapes.line(x2, y2, cx2, cy2);
                    x1 = x2;
                    y1 = y2;
                }
            }
        }
        if (this.drawBones) {
            shapes.setColor(this.boneOriginColor);
            for(let i = 0, n = bones.length; i < n; i++){
                let bone = bones[i];
                if (ignoredBones && ignoredBones.indexOf(bone.data.name) > -1) continue;
                shapes.circle(true, bone.worldX, bone.worldY, 3 * this.scale, this.boneOriginColor, 8);
            }
        }
        if (this.drawClipping) {
            let slots = skeleton.slots;
            shapes.setColor(this.clipColor);
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                if (!slot.bone.active) continue;
                let attachment = slot.getAttachment();
                if (!(attachment instanceof (0, $ee64e63dbd5e17c9$export$838805e22b9b55f1))) continue;
                let clip = attachment;
                let nn = clip.worldVerticesLength;
                let world = this.temp = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).setArraySize(this.temp, nn, 0);
                clip.computeWorldVertices(slot, 0, nn, world, 0, 2);
                for(let i = 0, n = world.length; i < n; i += 2){
                    let x = world[i];
                    let y = world[i + 1];
                    let x2 = world[(i + 2) % world.length];
                    let y2 = world[(i + 3) % world.length];
                    shapes.line(x, y, x2, y2);
                }
            }
        }
    }
    dispose() {}
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $f38c80db37e7c93b$var$Renderable {
    vertices;
    numVertices;
    numFloats;
    constructor(vertices, numVertices, numFloats){
        this.vertices = vertices;
        this.numVertices = numVertices;
        this.numFloats = numFloats;
    }
}
class $f38c80db37e7c93b$export$383ab220c2c9987a {
    static QUAD_TRIANGLES = [
        0,
        1,
        2,
        2,
        3,
        0
    ];
    premultipliedAlpha = false;
    tempColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    tempColor2 = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    vertices;
    vertexSize = 8;
    twoColorTint = false;
    renderable = new $f38c80db37e7c93b$var$Renderable([], 0, 0);
    clipper = new (0, $1db6b0f82e0ea91c$export$40b4063afbb1b315)();
    temp = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
    temp2 = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
    temp3 = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    temp4 = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    constructor(context, twoColorTint = true){
        this.twoColorTint = twoColorTint;
        if (twoColorTint) this.vertexSize += 4;
        this.vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(this.vertexSize * 1024);
    }
    draw(batcher, skeleton, slotRangeStart = -1, slotRangeEnd = -1, transformer = null) {
        let clipper = this.clipper;
        let premultipliedAlpha = this.premultipliedAlpha;
        let twoColorTint = this.twoColorTint;
        let blendMode = null;
        let renderable = this.renderable;
        let uvs;
        let triangles;
        let drawOrder = skeleton.drawOrder;
        let attachmentColor;
        let skeletonColor = skeleton.color;
        let vertexSize = twoColorTint ? 12 : 8;
        let inRange = false;
        if (slotRangeStart == -1) inRange = true;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            let clippedVertexSize = clipper.isClipping() ? 2 : vertexSize;
            let slot = drawOrder[i];
            if (!slot.bone.active) {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (slotRangeStart >= 0 && slotRangeStart == slot.data.index) inRange = true;
            if (!inRange) {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (slotRangeEnd >= 0 && slotRangeEnd == slot.data.index) inRange = false;
            let attachment = slot.getAttachment();
            let texture;
            if (attachment instanceof (0, $679f9e8a376fdb80$export$d0fc51466fa6d530)) {
                let region = attachment;
                renderable.vertices = this.vertices;
                renderable.numVertices = 4;
                renderable.numFloats = clippedVertexSize << 2;
                region.computeWorldVertices(slot, renderable.vertices, 0, clippedVertexSize);
                triangles = $f38c80db37e7c93b$export$383ab220c2c9987a.QUAD_TRIANGLES;
                uvs = region.uvs;
                texture = region.region.texture;
                attachmentColor = region.color;
            } else if (attachment instanceof (0, $06d16b10b33d165a$export$3f1c1692adfcf3e2)) {
                let mesh = attachment;
                renderable.vertices = this.vertices;
                renderable.numVertices = mesh.worldVerticesLength >> 1;
                renderable.numFloats = renderable.numVertices * clippedVertexSize;
                if (renderable.numFloats > renderable.vertices.length) renderable.vertices = this.vertices = (0, $bdd8805cee4a5602$export$d2ca453b913dcdea).newFloatArray(renderable.numFloats);
                mesh.computeWorldVertices(slot, 0, mesh.worldVerticesLength, renderable.vertices, 0, clippedVertexSize);
                triangles = mesh.triangles;
                texture = mesh.region.texture;
                uvs = mesh.uvs;
                attachmentColor = mesh.color;
            } else if (attachment instanceof (0, $ee64e63dbd5e17c9$export$838805e22b9b55f1)) {
                let clip = attachment;
                clipper.clipStart(slot, clip);
                continue;
            } else {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (texture) {
                let slotColor = slot.color;
                let finalColor = this.tempColor;
                finalColor.r = skeletonColor.r * slotColor.r * attachmentColor.r;
                finalColor.g = skeletonColor.g * slotColor.g * attachmentColor.g;
                finalColor.b = skeletonColor.b * slotColor.b * attachmentColor.b;
                finalColor.a = skeletonColor.a * slotColor.a * attachmentColor.a;
                if (premultipliedAlpha) {
                    finalColor.r *= finalColor.a;
                    finalColor.g *= finalColor.a;
                    finalColor.b *= finalColor.a;
                }
                let darkColor = this.tempColor2;
                if (!slot.darkColor) darkColor.set(0, 0, 0, 1.0);
                else {
                    if (premultipliedAlpha) {
                        darkColor.r = slot.darkColor.r * finalColor.a;
                        darkColor.g = slot.darkColor.g * finalColor.a;
                        darkColor.b = slot.darkColor.b * finalColor.a;
                    } else darkColor.setFromColor(slot.darkColor);
                    darkColor.a = premultipliedAlpha ? 1.0 : 0.0;
                }
                let slotBlendMode = slot.data.blendMode;
                if (slotBlendMode != blendMode) {
                    blendMode = slotBlendMode;
                    batcher.setBlendMode(blendMode, premultipliedAlpha);
                }
                if (clipper.isClipping()) {
                    clipper.clipTriangles(renderable.vertices, triangles, triangles.length, uvs, finalColor, darkColor, twoColorTint);
                    let clippedVertices = new Float32Array(clipper.clippedVertices);
                    let clippedTriangles = clipper.clippedTriangles;
                    if (transformer) transformer(clippedVertices, clippedVertices.length, vertexSize);
                    batcher.draw(texture, clippedVertices, clippedTriangles);
                } else {
                    let verts = renderable.vertices;
                    if (!twoColorTint) for(let v = 2, u = 0, n = renderable.numFloats; v < n; v += vertexSize, u += 2){
                        verts[v] = finalColor.r;
                        verts[v + 1] = finalColor.g;
                        verts[v + 2] = finalColor.b;
                        verts[v + 3] = finalColor.a;
                        verts[v + 4] = uvs[u];
                        verts[v + 5] = uvs[u + 1];
                    }
                    else for(let v = 2, u = 0, n = renderable.numFloats; v < n; v += vertexSize, u += 2){
                        verts[v] = finalColor.r;
                        verts[v + 1] = finalColor.g;
                        verts[v + 2] = finalColor.b;
                        verts[v + 3] = finalColor.a;
                        verts[v + 4] = uvs[u];
                        verts[v + 5] = uvs[u + 1];
                        verts[v + 6] = darkColor.r;
                        verts[v + 7] = darkColor.g;
                        verts[v + 8] = darkColor.b;
                        verts[v + 9] = darkColor.a;
                    }
                    let view = renderable.vertices.subarray(0, renderable.numFloats);
                    if (transformer) transformer(renderable.vertices, renderable.numFloats, vertexSize);
                    batcher.draw(texture, view, triangles);
                }
            }
            clipper.clipEndWithSlot(slot);
        }
        clipper.clipEnd();
    }
    /** Returns the {@link SkeletonClipping} used by this renderer for use with e.g. {@link Skeleton.getBounds} **/ getSkeletonClipping() {
        return this.clipper;
    }
}



const $417d40cfd7073eb0$var$quad = [
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0
];
const $417d40cfd7073eb0$var$QUAD_TRIANGLES = [
    0,
    1,
    2,
    2,
    3,
    0
];
const $417d40cfd7073eb0$var$WHITE = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
class $417d40cfd7073eb0$export$d172b6b77f76007c {
    context;
    canvas;
    camera;
    batcher;
    twoColorTint = false;
    batcherShader;
    shapes;
    shapesShader;
    activeRenderer = null;
    skeletonRenderer;
    skeletonDebugRenderer;
    constructor(canvas, context, twoColorTint = true){
        this.canvas = canvas;
        this.context = context instanceof (0, $2a889ef389866093$export$a4d6d43057cae2ac) ? context : new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(context);
        this.twoColorTint = twoColorTint;
        this.camera = new (0, $d46010cbc21da9ce$export$b58af824322cf043)(canvas.width, canvas.height);
        this.batcherShader = twoColorTint ? (0, $f5e32484888a4c49$export$462bb059fed9d9e5).newTwoColoredTextured(this.context) : (0, $f5e32484888a4c49$export$462bb059fed9d9e5).newColoredTextured(this.context);
        this.batcher = new (0, $2334c103a683d8ec$export$d398217aafc5a694)(this.context, twoColorTint);
        this.shapesShader = (0, $f5e32484888a4c49$export$462bb059fed9d9e5).newColored(this.context);
        this.shapes = new (0, $21af4212917a02d7$export$8304e6ea0c546270)(this.context);
        this.skeletonRenderer = new (0, $f38c80db37e7c93b$export$383ab220c2c9987a)(this.context, twoColorTint);
        this.skeletonDebugRenderer = new (0, $4ae009adbf50eea3$export$ce694abc08778c7a)(this.context);
    }
    dispose() {
        this.batcher.dispose();
        this.batcherShader.dispose();
        this.shapes.dispose();
        this.shapesShader.dispose();
        this.skeletonDebugRenderer.dispose();
    }
    begin() {
        this.camera.update();
        this.enableRenderer(this.batcher);
    }
    drawSkeleton(skeleton, premultipliedAlpha = false, slotRangeStart = -1, slotRangeEnd = -1, transform = null) {
        this.enableRenderer(this.batcher);
        this.skeletonRenderer.premultipliedAlpha = premultipliedAlpha;
        this.skeletonRenderer.draw(this.batcher, skeleton, slotRangeStart, slotRangeEnd, transform);
    }
    drawSkeletonDebug(skeleton, premultipliedAlpha = false, ignoredBones) {
        this.enableRenderer(this.shapes);
        this.skeletonDebugRenderer.premultipliedAlpha = premultipliedAlpha;
        this.skeletonDebugRenderer.draw(this.shapes, skeleton, ignoredBones);
    }
    drawTexture(texture, x, y, width, height, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $417d40cfd7073eb0$var$WHITE;
        var i = 0;
        $417d40cfd7073eb0$var$quad[i++] = x;
        $417d40cfd7073eb0$var$quad[i++] = y;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x + width;
        $417d40cfd7073eb0$var$quad[i++] = y;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x + width;
        $417d40cfd7073eb0$var$quad[i++] = y + height;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x;
        $417d40cfd7073eb0$var$quad[i++] = y + height;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i] = 0;
        }
        this.batcher.draw(texture, $417d40cfd7073eb0$var$quad, $417d40cfd7073eb0$var$QUAD_TRIANGLES);
    }
    drawTextureUV(texture, x, y, width, height, u, v, u2, v2, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $417d40cfd7073eb0$var$WHITE;
        var i = 0;
        $417d40cfd7073eb0$var$quad[i++] = x;
        $417d40cfd7073eb0$var$quad[i++] = y;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = u;
        $417d40cfd7073eb0$var$quad[i++] = v;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x + width;
        $417d40cfd7073eb0$var$quad[i++] = y;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = u2;
        $417d40cfd7073eb0$var$quad[i++] = v;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x + width;
        $417d40cfd7073eb0$var$quad[i++] = y + height;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = u2;
        $417d40cfd7073eb0$var$quad[i++] = v2;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x;
        $417d40cfd7073eb0$var$quad[i++] = y + height;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = u;
        $417d40cfd7073eb0$var$quad[i++] = v2;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i] = 0;
        }
        this.batcher.draw(texture, $417d40cfd7073eb0$var$quad, $417d40cfd7073eb0$var$QUAD_TRIANGLES);
    }
    drawTextureRotated(texture, x, y, width, height, pivotX, pivotY, angle, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $417d40cfd7073eb0$var$WHITE;
        // bottom left and top right corner points relative to origin
        let worldOriginX = x + pivotX;
        let worldOriginY = y + pivotY;
        let fx = -pivotX;
        let fy = -pivotY;
        let fx2 = width - pivotX;
        let fy2 = height - pivotY;
        // construct corner points, start from top left and go counter clockwise
        let p1x = fx;
        let p1y = fy;
        let p2x = fx;
        let p2y = fy2;
        let p3x = fx2;
        let p3y = fy2;
        let p4x = fx2;
        let p4y = fy;
        let x1 = 0;
        let y1 = 0;
        let x2 = 0;
        let y2 = 0;
        let x3 = 0;
        let y3 = 0;
        let x4 = 0;
        let y4 = 0;
        // rotate
        if (angle != 0) {
            let cos = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).cosDeg(angle);
            let sin = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).sinDeg(angle);
            x1 = cos * p1x - sin * p1y;
            y1 = sin * p1x + cos * p1y;
            x4 = cos * p2x - sin * p2y;
            y4 = sin * p2x + cos * p2y;
            x3 = cos * p3x - sin * p3y;
            y3 = sin * p3x + cos * p3y;
            x2 = x3 + (x1 - x4);
            y2 = y3 + (y1 - y4);
        } else {
            x1 = p1x;
            y1 = p1y;
            x4 = p2x;
            y4 = p2y;
            x3 = p3x;
            y3 = p3y;
            x2 = p4x;
            y2 = p4y;
        }
        x1 += worldOriginX;
        y1 += worldOriginY;
        x2 += worldOriginX;
        y2 += worldOriginY;
        x3 += worldOriginX;
        y3 += worldOriginY;
        x4 += worldOriginX;
        y4 += worldOriginY;
        var i = 0;
        $417d40cfd7073eb0$var$quad[i++] = x1;
        $417d40cfd7073eb0$var$quad[i++] = y1;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x2;
        $417d40cfd7073eb0$var$quad[i++] = y2;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x3;
        $417d40cfd7073eb0$var$quad[i++] = y3;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 1;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x4;
        $417d40cfd7073eb0$var$quad[i++] = y4;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        $417d40cfd7073eb0$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i] = 0;
        }
        this.batcher.draw(texture, $417d40cfd7073eb0$var$quad, $417d40cfd7073eb0$var$QUAD_TRIANGLES);
    }
    drawRegion(region, x, y, width, height, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $417d40cfd7073eb0$var$WHITE;
        var i = 0;
        $417d40cfd7073eb0$var$quad[i++] = x;
        $417d40cfd7073eb0$var$quad[i++] = y;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = region.u;
        $417d40cfd7073eb0$var$quad[i++] = region.v2;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x + width;
        $417d40cfd7073eb0$var$quad[i++] = y;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = region.u2;
        $417d40cfd7073eb0$var$quad[i++] = region.v2;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x + width;
        $417d40cfd7073eb0$var$quad[i++] = y + height;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = region.u2;
        $417d40cfd7073eb0$var$quad[i++] = region.v;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
        }
        $417d40cfd7073eb0$var$quad[i++] = x;
        $417d40cfd7073eb0$var$quad[i++] = y + height;
        $417d40cfd7073eb0$var$quad[i++] = color.r;
        $417d40cfd7073eb0$var$quad[i++] = color.g;
        $417d40cfd7073eb0$var$quad[i++] = color.b;
        $417d40cfd7073eb0$var$quad[i++] = color.a;
        $417d40cfd7073eb0$var$quad[i++] = region.u;
        $417d40cfd7073eb0$var$quad[i++] = region.v;
        if (this.twoColorTint) {
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i++] = 0;
            $417d40cfd7073eb0$var$quad[i] = 0;
        }
        this.batcher.draw(region.page.texture, $417d40cfd7073eb0$var$quad, $417d40cfd7073eb0$var$QUAD_TRIANGLES);
    }
    line(x, y, x2, y2, color, color2) {
        this.enableRenderer(this.shapes);
        this.shapes.line(x, y, x2, y2, color);
    }
    triangle(filled, x, y, x2, y2, x3, y3, color, color2, color3) {
        this.enableRenderer(this.shapes);
        this.shapes.triangle(filled, x, y, x2, y2, x3, y3, color, color2, color3);
    }
    quad(filled, x, y, x2, y2, x3, y3, x4, y4, color, color2, color3, color4) {
        this.enableRenderer(this.shapes);
        this.shapes.quad(filled, x, y, x2, y2, x3, y3, x4, y4, color, color2, color3, color4);
    }
    rect(filled, x, y, width, height, color) {
        this.enableRenderer(this.shapes);
        this.shapes.rect(filled, x, y, width, height, color);
    }
    rectLine(filled, x1, y1, x2, y2, width, color) {
        this.enableRenderer(this.shapes);
        this.shapes.rectLine(filled, x1, y1, x2, y2, width, color);
    }
    polygon(polygonVertices, offset, count, color) {
        this.enableRenderer(this.shapes);
        this.shapes.polygon(polygonVertices, offset, count, color);
    }
    circle(filled, x, y, radius, color, segments = 0) {
        this.enableRenderer(this.shapes);
        this.shapes.circle(filled, x, y, radius, color, segments);
    }
    curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, segments, color) {
        this.enableRenderer(this.shapes);
        this.shapes.curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, segments, color);
    }
    end() {
        if (this.activeRenderer === this.batcher) this.batcher.end();
        else if (this.activeRenderer === this.shapes) this.shapes.end();
        this.activeRenderer = null;
    }
    resize(resizeMode) {
        let canvas = this.canvas;
        var dpr = window.devicePixelRatio || 1;
        var w = Math.round(canvas.clientWidth * dpr);
        var h = Math.round(canvas.clientHeight * dpr);
        if (canvas.width != w || canvas.height != h) {
            canvas.width = w;
            canvas.height = h;
        }
        this.context.gl.viewport(0, 0, canvas.width, canvas.height);
        // Nothing to do for stretch, we simply apply the viewport size of the camera.
        if (resizeMode === $417d40cfd7073eb0$export$5d6d136f0a4d9153.Expand) this.camera.setViewport(w, h);
        else if (resizeMode === $417d40cfd7073eb0$export$5d6d136f0a4d9153.Fit) {
            let sourceWidth = canvas.width, sourceHeight = canvas.height;
            let targetWidth = this.camera.viewportWidth, targetHeight = this.camera.viewportHeight;
            let targetRatio = targetHeight / targetWidth;
            let sourceRatio = sourceHeight / sourceWidth;
            let scale = targetRatio < sourceRatio ? targetWidth / sourceWidth : targetHeight / sourceHeight;
            this.camera.setViewport(sourceWidth * scale, sourceHeight * scale);
        }
        this.camera.update();
    }
    enableRenderer(renderer) {
        if (this.activeRenderer === renderer) return;
        this.end();
        if (renderer instanceof (0, $2334c103a683d8ec$export$d398217aafc5a694)) {
            this.batcherShader.bind();
            this.batcherShader.setUniform4x4f((0, $f5e32484888a4c49$export$462bb059fed9d9e5).MVP_MATRIX, this.camera.projectionView.values);
            this.batcherShader.setUniformi("u_texture", 0);
            this.batcher.begin(this.batcherShader);
            this.activeRenderer = this.batcher;
        } else if (renderer instanceof (0, $21af4212917a02d7$export$8304e6ea0c546270)) {
            this.shapesShader.bind();
            this.shapesShader.setUniform4x4f((0, $f5e32484888a4c49$export$462bb059fed9d9e5).MVP_MATRIX, this.camera.projectionView.values);
            this.shapes.begin(this.shapesShader);
            this.activeRenderer = this.shapes;
        } else this.activeRenderer = this.skeletonDebugRenderer;
    }
}
var $417d40cfd7073eb0$export$5d6d136f0a4d9153;
(function(ResizeMode) {
    ResizeMode[ResizeMode["Stretch"] = 0] = "Stretch";
    ResizeMode[ResizeMode["Expand"] = 1] = "Expand";
    ResizeMode[ResizeMode["Fit"] = 2] = "Fit";
})($417d40cfd7073eb0$export$5d6d136f0a4d9153 || ($417d40cfd7073eb0$export$5d6d136f0a4d9153 = {}));


let $6acd4ecd70a142ae$var$spinnerImage;
let $6acd4ecd70a142ae$var$logoImage;
let $6acd4ecd70a142ae$var$loaded = 0;
const $6acd4ecd70a142ae$var$FADE_IN = 1, $6acd4ecd70a142ae$var$FADE_OUT = 1;
const $6acd4ecd70a142ae$var$logoWidth = 165, $6acd4ecd70a142ae$var$logoHeight = 108, $6acd4ecd70a142ae$var$spinnerSize = 163;
class $6acd4ecd70a142ae$export$e2b0760399e6dece {
    renderer;
    logo = null;
    spinner = null;
    angle = 0;
    fadeOut = 0;
    fadeIn = 0;
    timeKeeper = new (0, $bdd8805cee4a5602$export$ab19517904b64359)();
    backgroundColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.135, 0.135, 0.135, 1);
    tempColor = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    constructor(renderer){
        this.renderer = renderer;
        this.timeKeeper.maxDelta = 9;
        if (!$6acd4ecd70a142ae$var$logoImage) {
            let isSafari = navigator.userAgent.indexOf("Safari") > -1; // Thank you Apple Inc.
            let onload = ()=>$6acd4ecd70a142ae$var$loaded++;
            $6acd4ecd70a142ae$var$logoImage = new Image();
            $6acd4ecd70a142ae$var$logoImage.src = $6acd4ecd70a142ae$var$SPINE_LOGO_DATA;
            if (!isSafari) $6acd4ecd70a142ae$var$logoImage.crossOrigin = "anonymous";
            $6acd4ecd70a142ae$var$logoImage.onload = onload;
            $6acd4ecd70a142ae$var$spinnerImage = new Image();
            $6acd4ecd70a142ae$var$spinnerImage.src = $6acd4ecd70a142ae$var$SPINNER_DATA;
            if (!isSafari) $6acd4ecd70a142ae$var$spinnerImage.crossOrigin = "anonymous";
            $6acd4ecd70a142ae$var$spinnerImage.onload = onload;
        }
    }
    dispose() {
        this.logo?.dispose();
        this.spinner?.dispose();
    }
    draw(complete = false) {
        if ($6acd4ecd70a142ae$var$loaded < 2 || complete && this.fadeOut > $6acd4ecd70a142ae$var$FADE_OUT) return;
        this.timeKeeper.update();
        let a = Math.abs(Math.sin(this.timeKeeper.totalTime + 0.25));
        this.angle -= this.timeKeeper.delta * 200 * (1 + 1.5 * Math.pow(a, 5));
        let tempColor = this.tempColor;
        let renderer = this.renderer;
        let canvas = renderer.canvas;
        let gl = renderer.context.gl;
        renderer.resize((0, $417d40cfd7073eb0$export$5d6d136f0a4d9153).Expand);
        renderer.camera.position.set(canvas.width / 2, canvas.height / 2, 0);
        renderer.batcher.setBlendMode((0, $929b01edaa7ea960$export$c9b8fe72ac71821).Normal, true);
        if (complete) {
            this.fadeOut += this.timeKeeper.delta * (this.timeKeeper.totalTime < 1 ? 2 : 1);
            if (this.fadeOut > $6acd4ecd70a142ae$var$FADE_OUT) return;
            tempColor.setFromColor(this.backgroundColor);
            a = 1 - this.fadeOut / $6acd4ecd70a142ae$var$FADE_OUT;
            a = 1 - (a - 1) * (a - 1);
            tempColor.a *= a;
            if (tempColor.a > 0) {
                renderer.camera.zoom = 1;
                renderer.begin();
                renderer.quad(true, 0, 0, canvas.width, 0, canvas.width, canvas.height, 0, canvas.height, tempColor, tempColor, tempColor, tempColor);
                renderer.end();
            }
        } else {
            this.fadeIn += this.timeKeeper.delta;
            if (this.backgroundColor.a > 0) {
                gl.clearColor(this.backgroundColor.r, this.backgroundColor.g, this.backgroundColor.b, this.backgroundColor.a);
                gl.clear(gl.COLOR_BUFFER_BIT);
            }
            a = 1;
        }
        a *= Math.min(this.fadeIn / $6acd4ecd70a142ae$var$FADE_IN, 1);
        tempColor.set(a, a, a, a);
        if (!this.logo) {
            this.logo = new (0, $d873b6ddc694ab51$export$6c73c2a4561c07a2)(renderer.context, $6acd4ecd70a142ae$var$logoImage);
            this.spinner = new (0, $d873b6ddc694ab51$export$6c73c2a4561c07a2)(renderer.context, $6acd4ecd70a142ae$var$spinnerImage);
        }
        renderer.camera.zoom = Math.max(1, $6acd4ecd70a142ae$var$spinnerSize / canvas.height);
        renderer.begin();
        renderer.drawTexture(this.logo, (canvas.width - $6acd4ecd70a142ae$var$logoWidth) / 2, (canvas.height - $6acd4ecd70a142ae$var$logoHeight) / 2, $6acd4ecd70a142ae$var$logoWidth, $6acd4ecd70a142ae$var$logoHeight, tempColor);
        if (this.spinner) renderer.drawTextureRotated(this.spinner, (canvas.width - $6acd4ecd70a142ae$var$spinnerSize) / 2, (canvas.height - $6acd4ecd70a142ae$var$spinnerSize) / 2, $6acd4ecd70a142ae$var$spinnerSize, $6acd4ecd70a142ae$var$spinnerSize, $6acd4ecd70a142ae$var$spinnerSize / 2, $6acd4ecd70a142ae$var$spinnerSize / 2, this.angle, tempColor);
        renderer.end();
    }
}
let $6acd4ecd70a142ae$var$SPINNER_DATA = "data:image/png;base64,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";
let $6acd4ecd70a142ae$var$SPINE_LOGO_DATA = "data:image/png;base64,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";










/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $de2c991205f4c44e$export$2985f0cbdc74acab {
    config;
    context;
    /** Tracks the current time, delta, and other time related statistics. */ time = new (0, $bdd8805cee4a5602$export$ab19517904b64359)();
    /** The HTML canvas to render to. */ htmlCanvas;
    /** The WebGL rendering context. */ gl;
    /** The scene renderer for easy drawing of skeletons, shapes, and images. */ renderer;
    /** The asset manager to load assets with. */ assetManager;
    /** The input processor used to listen to mouse, touch, and keyboard events. */ input;
    disposed = false;
    /** Constructs a new spine canvas, rendering to the provided HTML canvas. */ constructor(canvas, config){
        this.config = config;
        if (!config.pathPrefix) config.pathPrefix = "";
        if (!config.app) config.app = {
            loadAssets: ()=>{},
            initialize: ()=>{},
            update: ()=>{},
            render: ()=>{},
            error: ()=>{},
            dispose: ()=>{}
        };
        if (!config.webglConfig) config.webglConfig = {
            alpha: true
        };
        this.htmlCanvas = canvas;
        this.context = new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(canvas, config.webglConfig);
        this.renderer = new (0, $417d40cfd7073eb0$export$d172b6b77f76007c)(canvas, this.context);
        this.gl = this.context.gl;
        this.assetManager = new (0, $4cefb0dc2e03d3d3$export$85f9686224250ac3)(this.context, config.pathPrefix);
        this.input = new (0, $c2bf87b18acde811$export$f5b8910cec6cf069)(canvas);
        if (config.app.loadAssets) config.app.loadAssets(this);
        let loop = ()=>{
            if (this.disposed) return;
            requestAnimationFrame(loop);
            this.time.update();
            if (config.app.update) config.app.update(this, this.time.delta);
            if (config.app.render) config.app.render(this);
        };
        let waitForAssets = ()=>{
            if (this.disposed) return;
            if (this.assetManager.isLoadingComplete()) {
                if (this.assetManager.hasErrors()) {
                    if (config.app.error) config.app.error(this, this.assetManager.getErrors());
                } else {
                    if (config.app.initialize) config.app.initialize(this);
                    loop();
                }
                return;
            }
            requestAnimationFrame(waitForAssets);
        };
        requestAnimationFrame(waitForAssets);
    }
    /** Clears the canvas with the given color. The color values are given in the range [0,1]. */ clear(r, g, b, a) {
        this.gl.clearColor(r, g, b, a);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT);
    }
    /** Disposes the app, so the update() and render() functions are no longer called. Calls the dispose() callback.*/ dispose() {
        if (this.config.app.dispose) this.config.app.dispose(this);
        this.disposed = true;
    }
}







class $a786c5fc22eecf2a$export$a928bbadb775ec2a {
    config;
    parent;
    dom;
    canvas = null;
    context = null;
    sceneRenderer = null;
    loadingScreen = null;
    assetManager = null;
    bg = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    bgFullscreen = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)();
    playerControls = null;
    timelineSlider = null;
    playButton = null;
    skinButton = null;
    animationButton = null;
    playTime = 0;
    selectedBones = [];
    cancelId = 0;
    popup = null;
    /* True if the player is unable to load or render the skeleton. */ error = false;
    /* The player's skeleton. Null until loading is complete (access after config.success). */ skeleton = null;
    /* The animation state controlling the skeleton. Null until loading is complete (access after config.success). */ animationState = null;
    paused = true;
    speed = 1;
    time = new (0, $bdd8805cee4a5602$export$ab19517904b64359)();
    stopRequestAnimationFrame = false;
    disposed = false;
    viewport = {};
    currentViewport = {};
    previousViewport = {};
    viewportTransitionStart = 0;
    eventListeners = [];
    constructor(parent, config){
        this.config = config;
        let parentDom = typeof parent === "string" ? document.getElementById(parent) : parent;
        if (parentDom == null) throw new Error("SpinePlayer parent not found: " + parent);
        this.parent = parentDom;
        if (config.showControls === void 0) config.showControls = true;
        let controls = config.showControls ? /*html*/ `
<div class="spine-player-controls spine-player-popup-parent spine-player-controls-hidden">
<div class="spine-player-timeline"></div>
<div class="spine-player-buttons">
<button class="spine-player-button spine-player-button-icon-pause"></button>
<div class="spine-player-button-spacer"></div>
<button class="spine-player-button spine-player-button-icon-speed"></button>
<button class="spine-player-button spine-player-button-icon-animations"></button>
<button class="spine-player-button spine-player-button-icon-skins"></button>
<button class="spine-player-button spine-player-button-icon-settings"></button>
<button class="spine-player-button spine-player-button-icon-fullscreen"></button>
<img class="spine-player-button-icon-spine-logo" src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20104%2031.16%22%3E%3Cpath%20d%3D%22M104%2012.68a1.31%201.31%200%200%201-.37%201%201.28%201.28%200%200%201-.85.31H91.57a10.51%2010.51%200%200%200%20.29%202.55%204.92%204.92%200%200%200%201%202%204.27%204.27%200%200%200%201.64%201.26%206.89%206.89%200%200%200%202.6.44%2010.66%2010.66%200%200%200%202.17-.2%2012.81%2012.81%200%200%200%201.64-.44q.69-.25%201.14-.44a1.87%201.87%200%200%201%20.68-.2.44.44%200%200%201%20.27.04.43.43%200%200%201%20.16.2%201.38%201.38%200%200%201%20.09.37%204.89%204.89%200%200%201%200%20.58%204.14%204.14%200%200%201%200%20.43v.32a.83.83%200%200%201-.09.26%201.1%201.1%200%200%201-.17.22%202.77%202.77%200%200%201-.61.34%208.94%208.94%200%200%201-1.32.46%2018.54%2018.54%200%200%201-1.88.41%2013.78%2013.78%200%200%201-2.28.18%2010.55%2010.55%200%200%201-3.68-.59%206.82%206.82%200%200%201-2.66-1.74%207.44%207.44%200%200%201-1.63-2.89%2013.48%2013.48%200%200%201-.55-4%2012.76%2012.76%200%200%201%20.57-3.94%208.35%208.35%200%200%201%201.64-3%207.15%207.15%200%200%201%202.58-1.87%208.47%208.47%200%200%201%203.39-.65%208.19%208.19%200%200%201%203.41.64%206.46%206.46%200%200%201%202.32%201.73%207%207%200%200%201%201.3%202.54%2011.17%2011.17%200%200%201%20.43%203.13zm-3.14-.93a5.69%205.69%200%200%200-1.09-3.86%204.17%204.17%200%200%200-3.42-1.4%204.52%204.52%200%200%200-2%20.44%204.41%204.41%200%200%200-1.47%201.15A5.29%205.29%200%200%200%2092%209.75a7%207%200%200%200-.36%202zM80.68%2021.94a.42.42%200%200%201-.08.26.59.59%200%200%201-.25.18%201.74%201.74%200%200%201-.47.11%206.31%206.31%200%200%201-.76%200%206.5%206.5%200%200%201-.78%200%201.74%201.74%200%200%201-.47-.11.59.59%200%200%201-.25-.18.42.42%200%200%201-.08-.26V12a9.8%209.8%200%200%200-.23-2.35%204.86%204.86%200%200%200-.66-1.53%202.88%202.88%200%200%200-1.13-1%203.57%203.57%200%200%200-1.6-.34%204%204%200%200%200-2.35.83A12.71%2012.71%200%200%200%2069.11%2010v11.9a.42.42%200%200%201-.08.26.59.59%200%200%201-.25.18%201.74%201.74%200%200%201-.47.11%206.51%206.51%200%200%201-.78%200%206.31%206.31%200%200%201-.76%200%201.88%201.88%200%200%201-.48-.11.52.52%200%200%201-.25-.18.46.46%200%200%201-.07-.26v-17a.53.53%200%200%201%20.03-.21.5.5%200%200%201%20.23-.19%201.28%201.28%200%200%201%20.44-.11%208.53%208.53%200%200%201%201.39%200%201.12%201.12%200%200%201%20.43.11.6.6%200%200%201%20.22.19.47.47%200%200%201%20.07.26V7.2a10.46%2010.46%200%200%201%202.87-2.36%206.17%206.17%200%200%201%202.88-.75%206.41%206.41%200%200%201%202.87.58%205.16%205.16%200%200%201%201.88%201.54%206.15%206.15%200%200%201%201%202.26%2013.46%2013.46%200%200%201%20.31%203.11z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20d%3D%22M43.35%202.86c.09%202.6%201.89%204%205.48%204.61%203%20.48%205.79.24%206.69-2.37%201.75-5.09-2.4-3.82-6-4.39s-6.31-2.03-6.17%202.15zm1.08%2010.69c.33%201.94%202.14%203.06%204.91%203s4.84-1.16%205.13-3.25c.53-3.88-2.53-2.38-5.3-2.3s-5.4-1.26-4.74%202.55zM48%2022.44c.55%201.45%202.06%202.06%204.1%201.63s3.45-1.11%203.33-2.76c-.21-3.06-2.22-2.1-4.26-1.66S47%2019.6%2048%2022.44zm1.78%206.78c.16%201.22%201.22%202%202.88%201.93s2.92-.67%203.13-2c.4-2.43-1.46-1.53-3.12-1.51s-3.17-.82-2.89%201.58z%22%20fill%3D%22%23ff4000%22%2F%3E%3Cpath%20d%3D%22M35.28%2013.16a15.33%2015.33%200%200%201-.48%204%208.75%208.75%200%200%201-1.42%203%206.35%206.35%200%200%201-2.32%201.91%207.14%207.14%200%200%201-3.16.67%206.1%206.1%200%200%201-1.4-.15%205.34%205.34%200%200%201-1.26-.47%207.29%207.29%200%200%201-1.24-.81q-.61-.49-1.29-1.15v8.51a.47.47%200%200%201-.08.26.56.56%200%200%201-.25.19%201.74%201.74%200%200%201-.47.11%206.47%206.47%200%200%201-.78%200%206.26%206.26%200%200%201-.76%200%201.89%201.89%200%200%201-.48-.11.49.49%200%200%201-.25-.19.51.51%200%200%201-.07-.26V4.91a.57.57%200%200%201%20.06-.27.46.46%200%200%201%20.23-.18%201.47%201.47%200%200%201%20.44-.1%207.41%207.41%200%200%201%201.3%200%201.45%201.45%200%200%201%20.43.1.52.52%200%200%201%20.24.18.51.51%200%200%201%20.07.27V7.2a18.06%2018.06%200%200%201%201.49-1.38%209%209%200%200%201%201.45-1%206.82%206.82%200%200%201%201.49-.59%207.09%207.09%200%200%201%204.78.52%206%206%200%200%201%202.13%202%208.79%208.79%200%200%201%201.2%202.9%2015.72%2015.72%200%200%201%20.4%203.51zm-3.28.36a15.64%2015.64%200%200%200-.2-2.53%207.32%207.32%200%200%200-.69-2.17%204.06%204.06%200%200%200-1.3-1.51%203.49%203.49%200%200%200-2-.57%204.1%204.1%200%200%200-1.2.18%204.92%204.92%200%200%200-1.2.57%208.54%208.54%200%200%200-1.28%201A15.77%2015.77%200%200%200%2022.76%2010v6.77a13.53%2013.53%200%200%200%202.46%202.4%204.12%204.12%200%200%200%202.44.83%203.56%203.56%200%200%200%202-.57A4.28%204.28%200%200%200%2031%2018a7.58%207.58%200%200%200%20.77-2.12%2011.43%2011.43%200%200%200%20.23-2.36zM12%2017.3a5.39%205.39%200%200%201-.48%202.33%204.73%204.73%200%200%201-1.37%201.72%206.19%206.19%200%200%201-2.12%201.06%209.62%209.62%200%200%201-2.71.36%2010.38%2010.38%200%200%201-3.21-.5A7.63%207.63%200%200%201%201%2021.82a3.25%203.25%200%200%201-.66-.43%201.09%201.09%200%200%201-.3-.53%203.59%203.59%200%200%201-.04-.93%204.06%204.06%200%200%201%200-.61%202%202%200%200%201%20.09-.4.42.42%200%200%201%20.16-.22.43.43%200%200%201%20.24-.07%201.35%201.35%200%200%201%20.61.26q.41.26%201%20.56a9.22%209.22%200%200%200%201.41.55%206.25%206.25%200%200%200%201.87.26%205.62%205.62%200%200%200%201.44-.17%203.48%203.48%200%200%200%201.12-.5%202.23%202.23%200%200%200%20.73-.84%202.68%202.68%200%200%200%20.26-1.21%202%202%200%200%200-.37-1.21%203.55%203.55%200%200%200-1-.87%208.09%208.09%200%200%200-1.36-.66l-1.56-.61a16%2016%200%200%201-1.57-.73%206%206%200%200%201-1.37-1%204.52%204.52%200%200%201-1-1.4%204.69%204.69%200%200%201-.37-2%204.88%204.88%200%200%201%20.39-1.87%204.46%204.46%200%200%201%201.16-1.61%205.83%205.83%200%200%201%201.94-1.11A8.06%208.06%200%200%201%206.53%204a8.28%208.28%200%200%201%201.36.11%209.36%209.36%200%200%201%201.23.28%205.92%205.92%200%200%201%20.94.37%204.09%204.09%200%200%201%20.59.35%201%201%200%200%201%20.26.26.83.83%200%200%201%20.09.26%201.32%201.32%200%200%200%20.06.35%203.87%203.87%200%200%201%200%20.51%204.76%204.76%200%200%201%200%20.56%201.39%201.39%200%200%201-.09.39.5.5%200%200%201-.16.22.35.35%200%200%201-.21.07%201%201%200%200%201-.49-.21%207%207%200%200%200-.83-.44%209.26%209.26%200%200%200-1.2-.44%205.49%205.49%200%200%200-1.58-.16%204.93%204.93%200%200%200-1.4.18%202.69%202.69%200%200%200-1%20.51%202.16%202.16%200%200%200-.59.83%202.43%202.43%200%200%200-.2%201%202%202%200%200%200%20.38%201.24%203.6%203.6%200%200%200%201%20.88%208.25%208.25%200%200%200%201.38.68l1.58.62q.8.32%201.59.72a6%206%200%200%201%201.39%201%204.37%204.37%200%200%201%201%201.36%204.46%204.46%200%200%201%20.37%201.8z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E">
</div></div>` : "";
        this.parent.appendChild(this.dom = $a786c5fc22eecf2a$var$createElement(/*html*/ `<div class="spine-player" style="position:relative;height:100%"><canvas class="spine-player-canvas" style="display:block;width:100%;height:100%"></canvas>${controls}</div>`));
        try {
            this.validateConfig(config);
        } catch (e) {
            this.showError(e.message, e);
        }
        this.initialize();
        // Register a global resize handler to redraw, avoiding flicker.
        this.addEventListener(window, "resize", ()=>this.drawFrame(false));
        // Start the rendering loop.
        requestAnimationFrame(()=>this.drawFrame());
    }
    dispose() {
        this.sceneRenderer?.dispose();
        this.loadingScreen?.dispose();
        this.assetManager?.dispose();
        for(var i = 0; i < this.eventListeners.length; i++){
            var eventListener = this.eventListeners[i];
            eventListener.target.removeEventListener(eventListener.event, eventListener.func);
        }
        this.parent.removeChild(this.dom);
        this.disposed = true;
    }
    addEventListener(target, event, func) {
        this.eventListeners.push({
            target: target,
            event: event,
            func: func
        });
        target.addEventListener(event, func);
    }
    validateConfig(config) {
        if (!config) throw new Error("A configuration object must be passed to to new SpinePlayer().");
        if (config.skelUrl) config.skeleton = config.skelUrl;
        if (!config.skeleton && !config.jsonUrl && !config.binaryUrl) throw new Error("A URL must be specified for the skeleton JSON or binary file.");
        if (!config.scale) config.scale = 1;
        if (!config.atlas && !config.atlasUrl) throw new Error("A URL must be specified for the atlas file.");
        if (config.jsonUrl && !config.skeleton) config.skeleton = config.jsonUrl;
        if (config.binaryUrl && !config.skeleton) config.skeleton = config.binaryUrl;
        if (config.atlasUrl && !config.atlas) config.atlas = config.atlasUrl;
        if (!config.backgroundColor) config.backgroundColor = config.alpha ? "00000000" : "000000";
        if (!config.fullScreenBackgroundColor) config.fullScreenBackgroundColor = config.backgroundColor;
        if (config.backgroundImage && !config.backgroundImage.url) config.backgroundImage = undefined;
        if (config.premultipliedAlpha === void 0) config.premultipliedAlpha = true;
        if (config.preserveDrawingBuffer === void 0) config.preserveDrawingBuffer = false;
        if (config.mipmaps === void 0) config.mipmaps = true;
        if (!config.debug) config.debug = {
            bones: false,
            clipping: false,
            bounds: false,
            hulls: false,
            meshes: false,
            paths: false,
            points: false,
            regions: false
        };
        if (config.animations && config.animation && config.animations.indexOf(config.animation) < 0) throw new Error("Animation '" + config.animation + "' is not in the config animation list: " + $a786c5fc22eecf2a$var$toString(config.animations));
        if (config.skins && config.skin && config.skins.indexOf(config.skin) < 0) throw new Error("Default skin '" + config.skin + "' is not in the config skins list: " + $a786c5fc22eecf2a$var$toString(config.skins));
        if (!config.viewport) config.viewport = {};
        if (!config.viewport.animations) config.viewport.animations = {};
        if (config.viewport.debugRender === void 0) config.viewport.debugRender = false;
        if (config.viewport.transitionTime === void 0) config.viewport.transitionTime = 0.25;
        if (!config.controlBones) config.controlBones = [];
        if (config.showLoading === void 0) config.showLoading = true;
        if (config.defaultMix === void 0) config.defaultMix = 0.25;
    }
    initialize() {
        let config = this.config;
        let dom = this.dom;
        if (!config.alpha) {
            let hex = config.backgroundColor;
            this.dom.style.backgroundColor = (hex.charAt(0) == "#" ? hex : "#" + hex).substr(0, 7);
        }
        try {
            // Setup the OpenGL context.
            this.canvas = $a786c5fc22eecf2a$var$findWithClass(dom, "spine-player-canvas");
            this.context = new (0, $2a889ef389866093$export$a4d6d43057cae2ac)(this.canvas, {
                alpha: config.alpha,
                preserveDrawingBuffer: config.preserveDrawingBuffer
            });
            // Setup the scene renderer and loading screen.
            this.sceneRenderer = new (0, $417d40cfd7073eb0$export$d172b6b77f76007c)(this.canvas, this.context, true);
            if (config.showLoading) this.loadingScreen = new (0, $6acd4ecd70a142ae$export$e2b0760399e6dece)(this.sceneRenderer);
        } catch (e) {
            this.showError("Sorry, your browser does not support WebG, or you have disabled WebGL in your browser settings.\nPlease use the latest version of Firefox, Chrome, Edge, or Safari.", e);
            return null;
        }
        // Load the assets.
        this.assetManager = new (0, $4cefb0dc2e03d3d3$export$85f9686224250ac3)(this.context, "", config.downloader);
        if (config.rawDataURIs) for(let path in config.rawDataURIs)this.assetManager.setRawDataURI(path, config.rawDataURIs[path]);
        if (config.skeleton.endsWith(".json")) this.assetManager.loadJson(config.skeleton);
        else this.assetManager.loadBinary(config.skeleton);
        this.assetManager.loadTextureAtlas(config.atlas);
        if (config.backgroundImage) this.assetManager.loadTexture(config.backgroundImage.url);
        // Setup the UI elements.
        this.bg.setFromString(config.backgroundColor);
        this.bgFullscreen.setFromString(config.fullScreenBackgroundColor);
        if (config.showControls) {
            this.playerControls = dom.children[1];
            let controls = this.playerControls.children;
            let timeline = controls[0];
            let buttons = controls[1].children;
            this.playButton = buttons[0];
            let speedButton = buttons[2];
            this.animationButton = buttons[3];
            this.skinButton = buttons[4];
            let settingsButton = buttons[5];
            let fullscreenButton = buttons[6];
            let logoButton = buttons[7];
            this.timelineSlider = new $a786c5fc22eecf2a$var$Slider();
            timeline.appendChild(this.timelineSlider.create());
            this.timelineSlider.change = (percentage)=>{
                this.pause();
                let animationDuration = this.animationState.getCurrent(0).animation.duration;
                let time = animationDuration * percentage;
                this.animationState.update(time - this.playTime);
                this.animationState.apply(this.skeleton);
                this.skeleton.update(time - this.playTime);
                this.skeleton.updateWorldTransform((0, $e4c808b89cce1537$export$2f09efa5b67124a7).update);
                this.playTime = time;
            };
            this.playButton.onclick = ()=>this.paused ? this.play() : this.pause();
            speedButton.onclick = ()=>this.showSpeedDialog(speedButton);
            this.animationButton.onclick = ()=>this.showAnimationsDialog(this.animationButton);
            this.skinButton.onclick = ()=>this.showSkinsDialog(this.skinButton);
            settingsButton.onclick = ()=>this.showSettingsDialog(settingsButton);
            let oldWidth = this.canvas.clientWidth, oldHeight = this.canvas.clientHeight;
            let oldStyleWidth = this.canvas.style.width, oldStyleHeight = this.canvas.style.height;
            let isFullscreen = false;
            fullscreenButton.onclick = ()=>{
                let fullscreenChanged = ()=>{
                    isFullscreen = !isFullscreen;
                    if (!isFullscreen) {
                        this.canvas.style.width = oldWidth + "px";
                        this.canvas.style.height = oldHeight + "px";
                        this.drawFrame(false);
                        // Got to reset the style to whatever the user set after the next layouting.
                        requestAnimationFrame(()=>{
                            this.canvas.style.width = oldStyleWidth;
                            this.canvas.style.height = oldStyleHeight;
                        });
                    }
                };
                let player = dom;
                player.onfullscreenchange = fullscreenChanged;
                player.onwebkitfullscreenchange = fullscreenChanged;
                let doc = document;
                if (doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement) {
                    if (doc.exitFullscreen) doc.exitFullscreen();
                    else if (doc.mozCancelFullScreen) doc.mozCancelFullScreen();
                    else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
                    else if (doc.msExitFullscreen) doc.msExitFullscreen();
                } else {
                    oldWidth = this.canvas.clientWidth;
                    oldHeight = this.canvas.clientHeight;
                    oldStyleWidth = this.canvas.style.width;
                    oldStyleHeight = this.canvas.style.height;
                    if (player.requestFullscreen) player.requestFullscreen();
                    else if (player.webkitRequestFullScreen) player.webkitRequestFullScreen();
                    else if (player.mozRequestFullScreen) player.mozRequestFullScreen();
                    else if (player.msRequestFullscreen) player.msRequestFullscreen();
                }
            };
            logoButton.onclick = ()=>window.open("http://esotericsoftware.com");
        }
        return dom;
    }
    loadSkeleton() {
        if (this.error) return;
        if (this.assetManager.hasErrors()) this.showError("Error: Assets could not be loaded.\n" + $a786c5fc22eecf2a$var$toString(this.assetManager.getErrors()));
        let config = this.config;
        // Configure filtering, don't use mipmaps in WebGL1 if the atlas page is non-POT
        let atlas = this.assetManager.require(config.atlas);
        let gl = this.context.gl, anisotropic = gl.getExtension("EXT_texture_filter_anisotropic");
        let isWebGL1 = gl.getParameter(gl.VERSION).indexOf("WebGL 1.0") != -1;
        for (let page of atlas.pages){
            let minFilter = page.minFilter;
            var useMipMaps = config.mipmaps;
            var isPOT = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).isPowerOfTwo(page.width) && (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).isPowerOfTwo(page.height);
            if (isWebGL1 && !isPOT) useMipMaps = false;
            if (useMipMaps) {
                if (anisotropic) {
                    gl.texParameterf(gl.TEXTURE_2D, anisotropic.TEXTURE_MAX_ANISOTROPY_EXT, 8);
                    minFilter = (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).MipMapLinearLinear;
                } else minFilter = (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Linear; // Don't use mipmaps without anisotropic.
                page.texture.setFilters(minFilter, (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Nearest);
            }
            if (minFilter != (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Nearest && minFilter != (0, $0ec5a873c6b98cd8$export$f389c48fc54053be).Linear) page.texture.update(true);
        }
        // Load skeleton data.
        let skeletonData;
        try {
            let loader, data, attachmentLoader = new (0, $d71b67a3201597e7$export$2ff9add835475d95)(atlas);
            if (config.skeleton.endsWith(".json")) {
                data = this.assetManager.remove(config.skeleton);
                if (!data) throw new Error("Empty JSON data.");
                if (config.jsonField) {
                    data = data[config.jsonField];
                    if (!data) throw new Error("JSON field does not exist: " + config.jsonField);
                }
                loader = new (0, $409c2b412287ac3b$export$8913b5e618c6d2f3)(attachmentLoader);
            } else {
                data = this.assetManager.remove(config.skeleton);
                loader = new (0, $41d6f0e7ee5e1c25$export$a7f7eaf4e9fce9ef)(attachmentLoader);
            }
            loader.scale = config.scale;
            skeletonData = loader.readSkeletonData(data);
        } catch (e) {
            this.showError(`Error: Could not load skeleton data.\n${e.message}`, e);
            return;
        }
        this.skeleton = new (0, $e4c808b89cce1537$export$8f31e4c4a37b8e9c)(skeletonData);
        let stateData = new (0, $b530cc1d06ee361f$export$90d7167cc0605975)(skeletonData);
        stateData.defaultMix = config.defaultMix;
        this.animationState = new (0, $dcb477122a241e28$export$d0f7a26c90cc1562)(stateData);
        // Check if all control bones are in the skeleton
        config.controlBones.forEach((bone)=>{
            if (!skeletonData.findBone(bone)) this.showError(`Error: Control bone does not exist in skeleton: ${bone}`);
        });
        // Setup skin.
        if (!config.skin && skeletonData.skins.length) config.skin = skeletonData.skins[0].name;
        if (config.skins && config.skin.length) config.skins.forEach((skin)=>{
            if (!this.skeleton.data.findSkin(skin)) this.showError(`Error: Skin in config list does not exist in skeleton: ${skin}`);
        });
        if (config.skin) {
            if (!this.skeleton.data.findSkin(config.skin)) this.showError(`Error: Skin does not exist in skeleton: ${config.skin}`);
            this.skeleton.setSkinByName(config.skin);
            this.skeleton.setSlotsToSetupPose();
        }
        // Check if all animations given a viewport exist.
        Object.getOwnPropertyNames(config.viewport.animations).forEach((animation)=>{
            if (!skeletonData.findAnimation(animation)) this.showError(`Error: Animation for which a viewport was specified does not exist in skeleton: ${animation}`);
        });
        // Setup the animations after the viewport, so default bounds don't get messed up.
        if (config.animations && config.animations.length) {
            config.animations.forEach((animation)=>{
                if (!this.skeleton.data.findAnimation(animation)) this.showError(`Error: Animation in config list does not exist in skeleton: ${animation}`);
            });
            if (!config.animation) config.animation = config.animations[0];
        }
        if (config.animation && !skeletonData.findAnimation(config.animation)) this.showError(`Error: Animation does not exist in skeleton: ${config.animation}`);
        // Setup input processing and control bones.
        this.setupInput();
        if (config.showControls) {
            // Hide skin and animation if there's only the default skin / no animation
            if (skeletonData.skins.length == 1 || config.skins && config.skins.length == 1) this.skinButton.classList.add("spine-player-hidden");
            if (skeletonData.animations.length == 1 || config.animations && config.animations.length == 1) this.animationButton.classList.add("spine-player-hidden");
        }
        if (config.success) config.success(this);
        let entry = this.animationState.getCurrent(0);
        if (!entry) {
            if (config.animation) {
                entry = this.setAnimation(config.animation);
                this.play();
            } else {
                entry = this.animationState.setEmptyAnimation(0);
                entry.trackEnd = 100000000;
                this.skeleton.updateWorldTransform((0, $e4c808b89cce1537$export$2f09efa5b67124a7).update);
                this.setViewport(entry.animation);
                this.pause();
            }
        } else if (!this.currentViewport) {
            this.setViewport(entry.animation);
            this.play();
        }
    }
    setupInput() {
        let config = this.config;
        let controlBones = config.controlBones;
        if (!controlBones.length && !config.showControls) return;
        let selectedBones = this.selectedBones = new Array(controlBones.length);
        let canvas = this.canvas;
        let target = null;
        let offset = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
        let coords = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)();
        let mouse = new (0, $98b7726a3a3f3658$export$64b5c384219d3699)();
        let position = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
        let skeleton = this.skeleton;
        let renderer = this.sceneRenderer;
        let closest = function(x, y) {
            mouse.set(x, canvas.clientHeight - y, 0);
            offset.x = offset.y = 0;
            let bestDistance = 24, index = 0;
            let best = null;
            for(let i = 0; i < controlBones.length; i++){
                selectedBones[i] = null;
                let bone = skeleton.findBone(controlBones[i]);
                if (!bone) continue;
                let distance = renderer.camera.worldToScreen(coords.set(bone.worldX, bone.worldY, 0), canvas.clientWidth, canvas.clientHeight).distance(mouse);
                if (distance < bestDistance) {
                    bestDistance = distance;
                    best = bone;
                    index = i;
                    offset.x = coords.x - mouse.x;
                    offset.y = coords.y - mouse.y;
                }
            }
            if (best) selectedBones[index] = best;
            return best;
        };
        new (0, $c2bf87b18acde811$export$f5b8910cec6cf069)(canvas).addListener({
            down: (x, y)=>{
                target = closest(x, y);
            },
            up: ()=>{
                if (target) target = null;
                else if (config.showControls) this.paused ? this.play() : this.pause();
            },
            dragged: (x, y)=>{
                if (target) {
                    x = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).clamp(x + offset.x, 0, canvas.clientWidth);
                    y = (0, $bdd8805cee4a5602$export$6a7ef315a0d1ef07).clamp(y - offset.y, 0, canvas.clientHeight);
                    renderer.camera.screenToWorld(coords.set(x, y, 0), canvas.clientWidth, canvas.clientHeight);
                    if (target.parent) {
                        target.parent.worldToLocal(position.set(coords.x - skeleton.x, coords.y - skeleton.y));
                        target.x = position.x;
                        target.y = position.y;
                    } else {
                        target.x = coords.x - skeleton.x;
                        target.y = coords.y - skeleton.y;
                    }
                }
            },
            moved: (x, y)=>closest(x, y)
        });
        if (config.showControls) {
            // For manual hover to work, we need to disable hidding controls if the mouse/touch entered the clickable area of a child of the controls.
            // For this we need to register a mouse handler on the document and see if we are within the canvas area.
            this.addEventListener(document, "mousemove", (ev)=>{
                if (ev instanceof MouseEvent) handleHover(ev.clientX, ev.clientY);
            });
            this.addEventListener(document, "touchmove", (ev)=>{
                if (ev instanceof TouchEvent) {
                    let touches = ev.changedTouches;
                    if (touches.length) {
                        let touch = touches[0];
                        handleHover(touch.clientX, touch.clientY);
                    }
                }
            });
            let overlap = (mouseX, mouseY, rect)=>{
                let x = mouseX - rect.left, y = mouseY - rect.top;
                return x >= 0 && x <= rect.width && y >= 0 && y <= rect.height;
            };
            let mouseOverControls = true, mouseOverCanvas = false;
            let handleHover = (mouseX, mouseY)=>{
                let popup = $a786c5fc22eecf2a$var$findWithClass(this.dom, "spine-player-popup");
                mouseOverControls = overlap(mouseX, mouseY, this.playerControls.getBoundingClientRect());
                mouseOverCanvas = overlap(mouseX, mouseY, canvas.getBoundingClientRect());
                clearTimeout(this.cancelId);
                let hide = !popup && !mouseOverControls && !mouseOverCanvas && !this.paused;
                if (hide) this.playerControls.classList.add("spine-player-controls-hidden");
                else this.playerControls.classList.remove("spine-player-controls-hidden");
                if (!mouseOverControls && !popup && !this.paused) this.cancelId = setTimeout(()=>{
                    if (!this.paused) this.playerControls.classList.add("spine-player-controls-hidden");
                }, 1000);
            };
        }
    }
    play() {
        this.paused = false;
        let config = this.config;
        if (config.showControls) {
            this.cancelId = setTimeout(()=>{
                if (!this.paused) this.playerControls.classList.add("spine-player-controls-hidden");
            }, 1000);
            this.playButton.classList.remove("spine-player-button-icon-play");
            this.playButton.classList.add("spine-player-button-icon-pause");
            // If no config animation, set one when first clicked.
            if (!config.animation) {
                if (config.animations && config.animations.length) config.animation = config.animations[0];
                else if (this.skeleton.data.animations.length) config.animation = this.skeleton.data.animations[0].name;
                if (config.animation) this.setAnimation(config.animation);
            }
        }
    }
    pause() {
        this.paused = true;
        if (this.config.showControls) {
            this.playerControls.classList.remove("spine-player-controls-hidden");
            clearTimeout(this.cancelId);
            this.playButton.classList.remove("spine-player-button-icon-pause");
            this.playButton.classList.add("spine-player-button-icon-play");
        }
    }
    /* Sets a new animation and viewport on track 0. */ setAnimation(animation, loop = true) {
        animation = this.setViewport(animation);
        return this.animationState.setAnimationWith(0, animation, loop);
    }
    /* Adds a new animation and viewport on track 0. */ addAnimation(animation, loop = true, delay = 0) {
        animation = this.setViewport(animation);
        return this.animationState.addAnimationWith(0, animation, loop, delay);
    }
    /* Sets the viewport for the specified animation. */ setViewport(animation) {
        if (typeof animation == "string") {
            let foundAnimation = this.skeleton.data.findAnimation(animation);
            if (!foundAnimation) throw new Error("Animation not found: " + animation);
            animation = foundAnimation;
        }
        this.previousViewport = this.currentViewport;
        // Determine the base viewport.
        let globalViewport = this.config.viewport;
        let viewport = this.currentViewport = {
            padLeft: globalViewport.padLeft !== void 0 ? globalViewport.padLeft : "10%",
            padRight: globalViewport.padRight !== void 0 ? globalViewport.padRight : "10%",
            padTop: globalViewport.padTop !== void 0 ? globalViewport.padTop : "10%",
            padBottom: globalViewport.padBottom !== void 0 ? globalViewport.padBottom : "10%"
        };
        if (globalViewport.x !== void 0 && globalViewport.y !== void 0 && globalViewport.width && globalViewport.height) {
            viewport.x = globalViewport.x;
            viewport.y = globalViewport.y;
            viewport.width = globalViewport.width;
            viewport.height = globalViewport.height;
        } else this.calculateAnimationViewport(animation, viewport);
        // Override with the animation specific viewport for the final result.
        let userAnimViewport = this.config.viewport.animations[animation.name];
        if (userAnimViewport) {
            if (userAnimViewport.x !== void 0 && userAnimViewport.y !== void 0 && userAnimViewport.width && userAnimViewport.height) {
                viewport.x = userAnimViewport.x;
                viewport.y = userAnimViewport.y;
                viewport.width = userAnimViewport.width;
                viewport.height = userAnimViewport.height;
            }
            if (userAnimViewport.padLeft !== void 0) viewport.padLeft = userAnimViewport.padLeft;
            if (userAnimViewport.padRight !== void 0) viewport.padRight = userAnimViewport.padRight;
            if (userAnimViewport.padTop !== void 0) viewport.padTop = userAnimViewport.padTop;
            if (userAnimViewport.padBottom !== void 0) viewport.padBottom = userAnimViewport.padBottom;
        }
        // Translate percentage padding to world units.
        viewport.padLeft = this.percentageToWorldUnit(viewport.width, viewport.padLeft);
        viewport.padRight = this.percentageToWorldUnit(viewport.width, viewport.padRight);
        viewport.padBottom = this.percentageToWorldUnit(viewport.height, viewport.padBottom);
        viewport.padTop = this.percentageToWorldUnit(viewport.height, viewport.padTop);
        this.viewportTransitionStart = performance.now();
        return animation;
    }
    percentageToWorldUnit(size, percentageOrAbsolute) {
        if (typeof percentageOrAbsolute === "string") return size * parseFloat(percentageOrAbsolute.substr(0, percentageOrAbsolute.length - 1)) / 100;
        return percentageOrAbsolute;
    }
    calculateAnimationViewport(animation, viewport) {
        this.skeleton.setToSetupPose();
        let steps = 100, stepTime = animation.duration ? animation.duration / steps : 0, time = 0;
        let minX = 100000000, maxX = -100000000, minY = 100000000, maxY = -100000000;
        let offset = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)(), size = new (0, $bdd8805cee4a5602$export$c977b3e384af9ae1)();
        const tempArray = new Array(2);
        for(let i = 0; i < steps; i++, time += stepTime){
            animation.apply(this.skeleton, time, time, false, [], 1, (0, $bbeb79d5adec7b97$export$ccab779a50275a35).setup, (0, $bbeb79d5adec7b97$export$52fc338c0bb328ba).mixIn);
            this.skeleton.updateWorldTransform((0, $e4c808b89cce1537$export$2f09efa5b67124a7).update);
            this.skeleton.getBounds(offset, size, tempArray, this.sceneRenderer.skeletonRenderer.getSkeletonClipping());
            if (!isNaN(offset.x) && !isNaN(offset.y) && !isNaN(size.x) && !isNaN(size.y)) {
                minX = Math.min(offset.x, minX);
                maxX = Math.max(offset.x + size.x, maxX);
                minY = Math.min(offset.y, minY);
                maxY = Math.max(offset.y + size.y, maxY);
            } else this.showError("Animation bounds are invalid: " + animation.name);
        }
        viewport.x = minX;
        viewport.y = minY;
        viewport.width = maxX - minX;
        viewport.height = maxY - minY;
    }
    drawFrame(requestNextFrame = true) {
        try {
            if (this.error) return;
            if (this.disposed) return;
            if (requestNextFrame && !this.stopRequestAnimationFrame) requestAnimationFrame(()=>this.drawFrame());
            let doc = document;
            let isFullscreen = doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement;
            let bg = isFullscreen ? this.bgFullscreen : this.bg;
            this.time.update();
            let delta = this.time.delta;
            // Load the skeleton if the assets are ready.
            let loading = !this.assetManager.isLoadingComplete();
            if (!this.skeleton && !loading) this.loadSkeleton();
            let skeleton = this.skeleton;
            let config = this.config;
            if (skeleton) {
                // Resize the canvas.
                let renderer = this.sceneRenderer;
                renderer.resize((0, $417d40cfd7073eb0$export$5d6d136f0a4d9153).Expand);
                let playDelta = this.paused ? 0 : delta * this.speed;
                if (config.frame) config.frame(this, playDelta);
                // Update animation time and pose the skeleton.
                if (!this.paused) {
                    skeleton.update(playDelta);
                    this.animationState.update(playDelta);
                    this.animationState.apply(skeleton);
                    if (config.updateWorldTransform) config.updateWorldTransform(this, playDelta);
                    else skeleton.updateWorldTransform((0, $e4c808b89cce1537$export$2f09efa5b67124a7).update);
                    if (config.showControls) {
                        this.playTime += playDelta;
                        let entry = this.animationState.getCurrent(0);
                        if (entry) {
                            let duration = entry.animation.duration;
                            while(this.playTime >= duration && duration != 0)this.playTime -= duration;
                            this.playTime = Math.max(0, Math.min(this.playTime, duration));
                            this.timelineSlider.setValue(this.playTime / duration);
                        }
                    }
                }
                // Determine the viewport.
                let viewport = this.viewport;
                viewport.x = this.currentViewport.x - this.currentViewport.padLeft;
                viewport.y = this.currentViewport.y - this.currentViewport.padBottom;
                viewport.width = this.currentViewport.width + this.currentViewport.padLeft + this.currentViewport.padRight;
                viewport.height = this.currentViewport.height + this.currentViewport.padBottom + this.currentViewport.padTop;
                if (this.previousViewport) {
                    let transitionAlpha = (performance.now() - this.viewportTransitionStart) / 1000 / config.viewport.transitionTime;
                    if (transitionAlpha < 1) {
                        let x = this.previousViewport.x - this.previousViewport.padLeft;
                        let y = this.previousViewport.y - this.previousViewport.padBottom;
                        let width = this.previousViewport.width + this.previousViewport.padLeft + this.previousViewport.padRight;
                        let height = this.previousViewport.height + this.previousViewport.padBottom + this.previousViewport.padTop;
                        viewport.x = x + (viewport.x - x) * transitionAlpha;
                        viewport.y = y + (viewport.y - y) * transitionAlpha;
                        viewport.width = width + (viewport.width - width) * transitionAlpha;
                        viewport.height = height + (viewport.height - height) * transitionAlpha;
                    }
                }
                renderer.camera.zoom = this.canvas.height / this.canvas.width > viewport.height / viewport.width ? viewport.width / this.canvas.width : viewport.height / this.canvas.height;
                renderer.camera.position.x = viewport.x + viewport.width / 2;
                renderer.camera.position.y = viewport.y + viewport.height / 2;
                // Clear the screen.
                let gl = this.context.gl;
                gl.clearColor(bg.r, bg.g, bg.b, bg.a);
                gl.clear(gl.COLOR_BUFFER_BIT);
                if (config.update) config.update(this, playDelta);
                renderer.begin();
                // Draw the background image.
                let bgImage = config.backgroundImage;
                if (bgImage) {
                    let texture = this.assetManager.require(bgImage.url);
                    if (bgImage.x !== void 0 && bgImage.y !== void 0 && bgImage.width && bgImage.height) renderer.drawTexture(texture, bgImage.x, bgImage.y, bgImage.width, bgImage.height);
                    else renderer.drawTexture(texture, viewport.x, viewport.y, viewport.width, viewport.height);
                }
                // Draw the skeleton and debug output.
                renderer.drawSkeleton(skeleton, config.premultipliedAlpha);
                if (Number(renderer.skeletonDebugRenderer.drawBones = config.debug.bones ?? false) + Number(renderer.skeletonDebugRenderer.drawBoundingBoxes = config.debug.bounds ?? false) + Number(renderer.skeletonDebugRenderer.drawClipping = config.debug.clipping ?? false) + Number(renderer.skeletonDebugRenderer.drawMeshHull = config.debug.hulls ?? false) + Number(renderer.skeletonDebugRenderer.drawPaths = config.debug.paths ?? false) + Number(renderer.skeletonDebugRenderer.drawRegionAttachments = config.debug.regions ?? false) + Number(renderer.skeletonDebugRenderer.drawMeshTriangles = config.debug.meshes ?? false) > 0) renderer.drawSkeletonDebug(skeleton, config.premultipliedAlpha);
                // Draw the control bones.
                let controlBones = config.controlBones;
                if (controlBones.length) {
                    let selectedBones = this.selectedBones;
                    gl.lineWidth(2);
                    for(let i = 0; i < controlBones.length; i++){
                        let bone = skeleton.findBone(controlBones[i]);
                        if (!bone) continue;
                        let colorInner = selectedBones[i] ? $a786c5fc22eecf2a$var$BONE_INNER_OVER : $a786c5fc22eecf2a$var$BONE_INNER;
                        let colorOuter = selectedBones[i] ? $a786c5fc22eecf2a$var$BONE_OUTER_OVER : $a786c5fc22eecf2a$var$BONE_OUTER;
                        renderer.circle(true, skeleton.x + bone.worldX, skeleton.y + bone.worldY, 20, colorInner);
                        renderer.circle(false, skeleton.x + bone.worldX, skeleton.y + bone.worldY, 20, colorOuter);
                    }
                }
                // Draw the viewport bounds.
                if (config.viewport.debugRender) {
                    gl.lineWidth(1);
                    renderer.rect(false, this.currentViewport.x, this.currentViewport.y, this.currentViewport.width, this.currentViewport.height, (0, $bdd8805cee4a5602$export$892596cec99bc70e).GREEN);
                    renderer.rect(false, viewport.x, viewport.y, viewport.width, viewport.height, (0, $bdd8805cee4a5602$export$892596cec99bc70e).RED);
                }
                renderer.end();
                if (config.draw) config.draw(this, playDelta);
            }
            // Draw the loading screen.
            if (config.showLoading) {
                this.loadingScreen.backgroundColor.setFromColor(bg);
                this.loadingScreen.draw(!loading);
            }
            if (loading && config.loading) config.loading(this, delta);
        } catch (e) {
            this.showError(`Error: Unable to render skeleton.\n${e.message}`, e);
        }
    }
    startRendering() {
        this.stopRequestAnimationFrame = false;
        requestAnimationFrame(()=>this.drawFrame());
    }
    stopRendering() {
        this.stopRequestAnimationFrame = true;
    }
    hidePopup(id) {
        return this.popup != null && this.popup.hide(id);
    }
    showSpeedDialog(speedButton) {
        let id = "speed";
        if (this.hidePopup(id)) return;
        let popup = new $a786c5fc22eecf2a$var$Popup(id, speedButton, this, this.playerControls, /*html*/ `
<div class="spine-player-popup-title">Speed</div>
<hr>
<div class="spine-player-row" style="align-items:center;padding:8px">
<div class="spine-player-column">
	<div class="spine-player-speed-slider" style="margin-bottom:4px"></div>
	<div class="spine-player-row" style="justify-content:space-between"><div>0.1x</div><div>1x</div><div>2x</div></div>
</div>
</div>`);
        let slider = new $a786c5fc22eecf2a$var$Slider(2, 0.1, true);
        $a786c5fc22eecf2a$var$findWithClass(popup.dom, "spine-player-speed-slider").appendChild(slider.create());
        slider.setValue(this.speed / 2);
        slider.change = (percentage)=>this.speed = percentage * 2;
        popup.show();
    }
    showAnimationsDialog(animationsButton) {
        let id = "animations";
        if (this.hidePopup(id)) return;
        if (!this.skeleton || !this.skeleton.data.animations.length) return;
        let popup = new $a786c5fc22eecf2a$var$Popup(id, animationsButton, this, this.playerControls, /*html*/ `<div class="spine-player-popup-title">Animations</div><hr><ul class="spine-player-list"></ul>`);
        let rows = $a786c5fc22eecf2a$var$findWithClass(popup.dom, "spine-player-list");
        this.skeleton.data.animations.forEach((animation)=>{
            // Skip animations not whitelisted if a whitelist was given.
            if (this.config.animations && this.config.animations.indexOf(animation.name) < 0) return;
            let row = $a786c5fc22eecf2a$var$createElement(/*html*/ `<li class="spine-player-list-item selectable"><div class="selectable-circle"></div><div class="selectable-text"></div></li>`);
            if (animation.name == this.config.animation) row.classList.add("selected");
            $a786c5fc22eecf2a$var$findWithClass(row, "selectable-text").innerText = animation.name;
            rows.appendChild(row);
            row.onclick = ()=>{
                $a786c5fc22eecf2a$var$removeClass(rows.children, "selected");
                row.classList.add("selected");
                this.config.animation = animation.name;
                this.playTime = 0;
                this.setAnimation(animation.name);
                this.play();
            };
        });
        popup.show();
    }
    showSkinsDialog(skinButton) {
        let id = "skins";
        if (this.hidePopup(id)) return;
        if (!this.skeleton || !this.skeleton.data.animations.length) return;
        let popup = new $a786c5fc22eecf2a$var$Popup(id, skinButton, this, this.playerControls, /*html*/ `<div class="spine-player-popup-title">Skins</div><hr><ul class="spine-player-list"></ul>`);
        let rows = $a786c5fc22eecf2a$var$findWithClass(popup.dom, "spine-player-list");
        this.skeleton.data.skins.forEach((skin)=>{
            // Skip skins not whitelisted if a whitelist was given.
            if (this.config.skins && this.config.skins.indexOf(skin.name) < 0) return;
            let row = $a786c5fc22eecf2a$var$createElement(/*html*/ `<li class="spine-player-list-item selectable"><div class="selectable-circle"></div><div class="selectable-text"></div></li>`);
            if (skin.name == this.config.skin) row.classList.add("selected");
            $a786c5fc22eecf2a$var$findWithClass(row, "selectable-text").innerText = skin.name;
            rows.appendChild(row);
            row.onclick = ()=>{
                $a786c5fc22eecf2a$var$removeClass(rows.children, "selected");
                row.classList.add("selected");
                this.config.skin = skin.name;
                this.skeleton.setSkinByName(this.config.skin);
                this.skeleton.setSlotsToSetupPose();
            };
        });
        popup.show();
    }
    showSettingsDialog(settingsButton) {
        let id = "settings";
        if (this.hidePopup(id)) return;
        if (!this.skeleton || !this.skeleton.data.animations.length) return;
        let popup = new $a786c5fc22eecf2a$var$Popup(id, settingsButton, this, this.playerControls, /*html*/ `<div class="spine-player-popup-title">Debug</div><hr><ul class="spine-player-list"></li>`);
        let rows = $a786c5fc22eecf2a$var$findWithClass(popup.dom, "spine-player-list");
        let makeItem = (label, name)=>{
            let row = $a786c5fc22eecf2a$var$createElement(/*html*/ `<li class="spine-player-list-item"></li>`);
            let s = new $a786c5fc22eecf2a$var$Switch(label);
            row.appendChild(s.create());
            let debug = this.config.debug;
            s.setEnabled(debug[name]);
            s.change = (value)=>debug[name] = value;
            rows.appendChild(row);
        };
        makeItem("Bones", "bones");
        makeItem("Regions", "regions");
        makeItem("Meshes", "meshes");
        makeItem("Bounds", "bounds");
        makeItem("Paths", "paths");
        makeItem("Clipping", "clipping");
        makeItem("Points", "points");
        makeItem("Hulls", "hulls");
        popup.show();
    }
    showError(message, error) {
        if (this.error) {
            if (error) throw error; // Don't lose error if showError throws, is caught, and showError is called again.
        } else {
            this.error = true;
            this.dom.appendChild($a786c5fc22eecf2a$var$createElement(/*html*/ `<div class="spine-player-error" style="background:#000;color:#fff;position:absolute;top:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:auto;z-index:999">` + message.replace("\n", "<br><br>") + `</div>`));
            if (this.config.error) this.config.error(this, message);
            throw error ? error : new Error(message);
        }
    }
}
class $a786c5fc22eecf2a$var$Popup {
    id;
    button;
    player;
    dom;
    className;
    windowClickListener;
    constructor(id, button, player, parent, htmlContent){
        this.id = id;
        this.button = button;
        this.player = player;
        this.dom = $a786c5fc22eecf2a$var$createElement(/*html*/ `<div class="spine-player-popup spine-player-hidden"></div>`);
        this.dom.innerHTML = htmlContent;
        parent.appendChild(this.dom);
        this.className = "spine-player-button-icon-" + id + "-selected";
    }
    dispose() {}
    hide(id) {
        this.dom.remove();
        this.button.classList.remove(this.className);
        if (this.id == id) {
            this.player.popup = null;
            return true;
        }
        return false;
    }
    show() {
        this.player.popup = this;
        this.button.classList.add(this.className);
        this.dom.classList.remove("spine-player-hidden");
        // Make sure the popup isn't bigger than the player.
        let dismissed = false;
        let resize = ()=>{
            if (!dismissed) requestAnimationFrame(resize);
            let playerDom = this.player.dom;
            let bottomOffset = Math.abs(playerDom.getBoundingClientRect().bottom - playerDom.getBoundingClientRect().bottom);
            let rightOffset = Math.abs(playerDom.getBoundingClientRect().right - playerDom.getBoundingClientRect().right);
            this.dom.style.maxHeight = playerDom.clientHeight - bottomOffset - rightOffset + "px";
        };
        requestAnimationFrame(resize);
        // Dismiss when clicking somewhere outside the popup.
        let justClicked = true;
        let windowClickListener = (event)=>{
            if (justClicked || this.player.popup != this) {
                justClicked = false;
                return;
            }
            if (!this.dom.contains(event.target)) {
                this.dom.remove();
                window.removeEventListener("click", windowClickListener);
                this.button.classList.remove(this.className);
                this.player.popup = null;
                dismissed = true;
            }
        };
        this.player.addEventListener(window, "click", windowClickListener);
    }
}
class $a786c5fc22eecf2a$var$Switch {
    text;
    switch = null;
    enabled = false;
    change = ()=>{};
    constructor(text){
        this.text = text;
    }
    create() {
        this.switch = $a786c5fc22eecf2a$var$createElement(/*html*/ `
<div class="spine-player-switch">
	<span class="spine-player-switch-text">${this.text}</span>
	<div class="spine-player-switch-knob-area">
		<div class="spine-player-switch-knob"></div>
	</div>
</div>`);
        this.switch.addEventListener("click", ()=>{
            this.setEnabled(!this.enabled);
            if (this.change) this.change(this.enabled);
        });
        return this.switch;
    }
    setEnabled(enabled) {
        if (enabled) this.switch?.classList.add("active");
        else this.switch?.classList.remove("active");
        this.enabled = enabled;
    }
    isEnabled() {
        return this.enabled;
    }
}
class $a786c5fc22eecf2a$var$Slider {
    snaps;
    snapPercentage;
    big;
    slider = null;
    value = null;
    knob = null;
    change = ()=>{};
    constructor(snaps = 0, snapPercentage = 0.1, big = false){
        this.snaps = snaps;
        this.snapPercentage = snapPercentage;
        this.big = big;
    }
    create() {
        this.slider = $a786c5fc22eecf2a$var$createElement(/*html*/ `
<div class="spine-player-slider ${this.big ? "big" : ""}">
	<div class="spine-player-slider-value"></div>
	<!--<div class="spine-player-slider-knob"></div>-->
</div>`);
        this.value = $a786c5fc22eecf2a$var$findWithClass(this.slider, "spine-player-slider-value");
        // this.knob = findWithClass(this.slider, "spine-player-slider-knob");
        this.setValue(0);
        let dragging = false;
        new (0, $c2bf87b18acde811$export$f5b8910cec6cf069)(this.slider).addListener({
            down: (x, y)=>{
                dragging = true;
                this.value?.classList.add("hovering");
            },
            up: (x, y)=>{
                dragging = false;
                if (this.change) this.change(this.setValue(x / this.slider.clientWidth));
                this.value?.classList.remove("hovering");
            },
            moved: (x, y)=>{
                if (dragging && this.change) this.change(this.setValue(x / this.slider.clientWidth));
            },
            dragged: (x, y)=>{
                if (this.change) this.change(this.setValue(x / this.slider.clientWidth));
            }
        });
        return this.slider;
    }
    setValue(percentage) {
        percentage = Math.max(0, Math.min(1, percentage));
        if (this.snaps) {
            let snap = 1 / this.snaps;
            let modulo = percentage % snap;
            // floor
            if (modulo < snap * this.snapPercentage) percentage = percentage - modulo;
            else if (modulo > snap - snap * this.snapPercentage) percentage = percentage - modulo + snap;
            percentage = Math.max(0, Math.min(1, percentage));
        }
        this.value.style.width = "" + percentage * 100 + "%";
        // this.knob.style.left = "" + (-8 + percentage * this.slider.clientWidth) + "px";
        return percentage;
    }
}
function $a786c5fc22eecf2a$var$findWithClass(element, className) {
    return element.getElementsByClassName(className)[0];
}
function $a786c5fc22eecf2a$var$createElement(html) {
    let div = document.createElement("div");
    div.innerHTML = html;
    return div.children[0];
}
function $a786c5fc22eecf2a$var$removeClass(elements, clazz) {
    for(let i = 0; i < elements.length; i++)elements[i].classList.remove(clazz);
}
function $a786c5fc22eecf2a$var$toString(object) {
    return JSON.stringify(object).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&#34;").replace(/'/g, "&#39;");
}
const $a786c5fc22eecf2a$var$BONE_INNER_OVER = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.478, 0, 0, 0.25);
const $a786c5fc22eecf2a$var$BONE_OUTER_OVER = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 1, 1, 1);
const $a786c5fc22eecf2a$var$BONE_INNER = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(0.478, 0, 0, 0.5);
const $a786c5fc22eecf2a$var$BONE_OUTER = new (0, $bdd8805cee4a5602$export$892596cec99bc70e)(1, 0, 0, 0.8);


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ function $a15f2931a69c2f0a$var$loadScript(url) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = url;
        script.onload = ()=>resolve();
        script.onerror = ()=>reject(new Error(`Script load error for ${url}`));
        document.head.appendChild(script);
    });
}
function $a15f2931a69c2f0a$var$loadCss(url) {
    return new Promise((resolve, reject)=>{
        const link = document.createElement("link");
        link.href = url;
        link.rel = "stylesheet";
        link.onload = ()=>resolve();
        link.onerror = ()=>reject(new Error(`CSS load error for ${url}`));
        document.head.appendChild(link);
    });
}
class $a15f2931a69c2f0a$export$9bc7861a36bb98f5 {
    parent;
    static DEFAULT_CODE = `
<script src="https://esotericsoftware.com/files/spine-player/4.1/spine-player.js"></script>
<link rel="stylesheet" href="https://esotericsoftware.com/files/spine-player/4.1/spine-player.css">

<div id="player-container" style="width: 100vw; height: 100vh;"></div>

<script>
new spine.SpinePlayer("player-container", {
	jsonUrl: "https://esotericsoftware.com/files/examples/4.1/spineboy/export/spineboy-pro.json",
	atlasUrl: "https://esotericsoftware.com/files/examples/4.1/spineboy/export/spineboy-pma.atlas"
});
</script>
		`.trim();
    prefix = `<html>
<head>
<style>
body { margin: 0px; }
</style>
</head>
<body>`.trim();
    postfix = `</body>`;
    code;
    player;
    constructor(parent){
        this.parent = parent;
        this.load();
    }
    async load() {
        await Promise.all([
            $a15f2931a69c2f0a$var$loadScript("https://www.unpkg.com/codemirror@5.51.0/lib/codemirror.js"),
            $a15f2931a69c2f0a$var$loadCss("https://www.unpkg.com/codemirror@5.51.0/lib/codemirror.css")
        ]);
        this.render(this.parent);
    }
    render(parent) {
        let dom = /*html*/ `
				<div style="display: flex; flex-direction: column; width: 100%; height: 100%;">
					<div style="width: 100%; height: 50%"></div>
					<iframe style="width: 100%; height: 50%; outline: none; border: none;"></iframe>
				</div>
			`;
        parent.innerHTML = dom;
        let codeElement = parent.children[0].children[0];
        this.player = parent.children[0].children[1];
        requestAnimationFrame(()=>{
            this.code = CodeMirror(codeElement, {
                lineNumbers: true,
                tabSize: 3,
                indentUnit: 3,
                indentWithTabs: true,
                scrollBarStyle: "native",
                mode: "htmlmixed",
                theme: "monokai"
            });
            this.code.on("change", ()=>{
                this.startPlayer();
            });
            codeElement.children[0].style.height = "100%";
            this.setCode($a15f2931a69c2f0a$export$9bc7861a36bb98f5.DEFAULT_CODE);
        });
    }
    setPreAndPostfix(prefix, postfix) {
        this.prefix = prefix;
        this.postfix = postfix;
        this.startPlayer();
    }
    setCode(code) {
        this.code.setValue(code);
        this.startPlayer();
    }
    timerId = 0;
    startPlayer() {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(()=>{
            let code = this.code.getDoc().getValue();
            code = this.prefix + code + this.postfix;
            code = window.btoa(code);
            this.player.src = "";
            this.player.src = "data:text/html;base64," + code;
        }, 500);
    }
}






(function() {
    const directive = {
        name: "spinePlayer"
    };
    const TRANSPARENT_COLOR = "#00000000";
    factory.$inject = [
        "$timeout"
    ];
    function factory($timeout) {
        function link(scope, element, attrs) {
            const params = scope.$eval(attrs[directive.name]);
            const containerElement = element[0];
            const callabcks = {
                onComplete: ()=>{},
                onSuccess: ()=>{}
            };
            const config = {
                jsonUrl: params.jsonUrl,
                atlasUrl: params.atlasUrl,
                preserveDrawingBuffer: params?.preserveDrawingBuffer || true,
                showControls: params?.showControls || false,
                premultipliedAlpha: params?.premultipliedAlpha || false,
                backgroundColor: params?.backgroundColor || TRANSPARENT_COLOR,
                alpha: params?.alpha || true,
                showLoading: params?.showLoading || false,
                success: (player)=>{
                    const { onComplete: onComplete, onSuccess: onSuccess } = callabcks;
                    if (params?.animationName) {
                        player.addAnimation(params.animationName, params?.loop);
                        if (params?.skipFirstFrame && !params?.autoplay) {
                            player.play();
                            $timeout(()=>{
                                player.pause();
                            });
                        }
                        if (params?.autoplay) player.play();
                    }
                    if (onComplete && angular.isFunction(onComplete)) player.animationState.addListener({
                        complete: onComplete
                    });
                    if (onSuccess && angular.isFunction(onSuccess)) onSuccess(player);
                },
                error: ()=>{}
            };
            const player = new (0, $a786c5fc22eecf2a$export$a928bbadb775ec2a)(containerElement, config);
            scope.$on("$destroy", function() {
                player.dispose();
                player.stopRendering();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $48b438f272df27eb$exports = {};
/**
 * Swiper 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */ /* eslint no-param-reassign: "off" */ 
var $dL2V0 = parcelRequire("dL2V0");

var $ltvF3 = parcelRequire("ltvF3");
const $ecd99c1cdbdf7520$var$Methods = {
    addClass: $ltvF3.addClass,
    removeClass: $ltvF3.removeClass,
    hasClass: $ltvF3.hasClass,
    toggleClass: $ltvF3.toggleClass,
    attr: $ltvF3.attr,
    removeAttr: $ltvF3.removeAttr,
    transform: $ltvF3.transform,
    transition: $ltvF3.transition,
    on: $ltvF3.on,
    off: $ltvF3.off,
    trigger: $ltvF3.trigger,
    transitionEnd: $ltvF3.transitionEnd,
    outerWidth: $ltvF3.outerWidth,
    outerHeight: $ltvF3.outerHeight,
    styles: $ltvF3.styles,
    offset: $ltvF3.offset,
    css: $ltvF3.css,
    each: $ltvF3.each,
    html: $ltvF3.html,
    text: $ltvF3.text,
    is: $ltvF3.is,
    index: $ltvF3.index,
    eq: $ltvF3.eq,
    append: $ltvF3.append,
    prepend: $ltvF3.prepend,
    next: $ltvF3.next,
    nextAll: $ltvF3.nextAll,
    prev: $ltvF3.prev,
    prevAll: $ltvF3.prevAll,
    parent: $ltvF3.parent,
    parents: $ltvF3.parents,
    closest: $ltvF3.closest,
    find: $ltvF3.find,
    children: $ltvF3.children,
    filter: $ltvF3.filter,
    remove: $ltvF3.remove
};
Object.keys($ecd99c1cdbdf7520$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $ltvF3.$).fn, methodName, {
        value: $ecd99c1cdbdf7520$var$Methods[methodName],
        writable: true
    });
});
var $ecd99c1cdbdf7520$export$2e2bcd8739ae039 = (0, $ltvF3.$);



var $dL2V0 = parcelRequire("dL2V0");
function $acb6eaa85a573617$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $acb6eaa85a573617$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $acb6eaa85a573617$export$461939dd4422153() {
    return Date.now();
}
function $acb6eaa85a573617$export$3735103072e4a80(el) {
    const window1 = (0, $dL2V0.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $acb6eaa85a573617$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $dL2V0.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $acb6eaa85a573617$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $acb6eaa85a573617$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $acb6eaa85a573617$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $acb6eaa85a573617$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$acb6eaa85a573617$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($acb6eaa85a573617$export$a6cdc56e425d0d0a(to[nextKey]) && $acb6eaa85a573617$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $acb6eaa85a573617$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$acb6eaa85a573617$export$a6cdc56e425d0d0a(to[nextKey]) && $acb6eaa85a573617$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $acb6eaa85a573617$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $acb6eaa85a573617$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $acb6eaa85a573617$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $dL2V0.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $dL2V0 = parcelRequire("dL2V0");
let $68613c34bbc01cc7$var$support;
function $68613c34bbc01cc7$var$calcSupport() {
    const window = (0, $dL2V0.getWindow)();
    const document = (0, $dL2V0.getDocument)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $68613c34bbc01cc7$export$d61c7b85ff180578() {
    if (!$68613c34bbc01cc7$var$support) $68613c34bbc01cc7$var$support = $68613c34bbc01cc7$var$calcSupport();
    return $68613c34bbc01cc7$var$support;
}



var $dL2V0 = parcelRequire("dL2V0");

let $1d275d65e8c80e95$var$deviceCached;
function $1d275d65e8c80e95$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $68613c34bbc01cc7$export$d61c7b85ff180578)();
    const window = (0, $dL2V0.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel"; // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $1d275d65e8c80e95$export$30c823bc834d6ab4(overrides = {}) {
    if (!$1d275d65e8c80e95$var$deviceCached) $1d275d65e8c80e95$var$deviceCached = $1d275d65e8c80e95$var$calcDevice(overrides);
    return $1d275d65e8c80e95$var$deviceCached;
}



var $dL2V0 = parcelRequire("dL2V0");
let $120fb606b5839901$var$browser;
function $120fb606b5839901$var$calcBrowser() {
    const window = (0, $dL2V0.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $120fb606b5839901$export$89e15fc796a4a429() {
    if (!$120fb606b5839901$var$browser) $120fb606b5839901$var$browser = $120fb606b5839901$var$calcBrowser();
    return $120fb606b5839901$var$browser;
}



var $dL2V0 = parcelRequire("dL2V0");
function $9bf2dee6e7a3ced5$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $dL2V0.getWindow)();
    let observer = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            const { width: width, height: height } = swiper;
            let newWidth = width;
            let newHeight = height;
            entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                if (target && target !== swiper.el) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) resizeHandler();
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}



var $dL2V0 = parcelRequire("dL2V0");
function $e500715bd067e077$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $dL2V0.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}


/* eslint-disable no-underscore-dangle */ var $6ea34b887619a3c7$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $4960c8ff6e498f6c$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $b1d9020a3af49001$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $acb6eaa85a573617$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, $acb6eaa85a573617$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $acb6eaa85a573617$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $acb6eaa85a573617$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
}


function $c1b88a96b32f5127$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", `${newHeight}px`);
}


function $4979b341b252806e$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $96aa9b5f9066a491$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $07ade6fe203b1671$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}


function $2da33cef5c3bb0ea$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $abec4982b371966a$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}



function $d3bce40ac9ab2831$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $cc9729cd3caaf5e6$export$2e2bcd8739ae039 = {
    updateSize: $4960c8ff6e498f6c$export$2e2bcd8739ae039,
    updateSlides: $b1d9020a3af49001$export$2e2bcd8739ae039,
    updateAutoHeight: $c1b88a96b32f5127$export$2e2bcd8739ae039,
    updateSlidesOffset: $4979b341b252806e$export$2e2bcd8739ae039,
    updateSlidesProgress: $96aa9b5f9066a491$export$2e2bcd8739ae039,
    updateProgress: $07ade6fe203b1671$export$2e2bcd8739ae039,
    updateSlidesClasses: $2da33cef5c3bb0ea$export$2e2bcd8739ae039,
    updateActiveIndex: $abec4982b371966a$export$2e2bcd8739ae039,
    updateClickedSlide: $d3bce40ac9ab2831$export$2e2bcd8739ae039
};



function $19f8a301123be89c$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $acb6eaa85a573617$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $257789c1fd98f78a$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}


function $34ea750850063a87$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $6256b68bde682529$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $9cccfd03b7a139a7$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $acb6eaa85a573617$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $e7e89a1169ce83e0$export$2e2bcd8739ae039 = {
    getTranslate: $19f8a301123be89c$export$2e2bcd8739ae039,
    setTranslate: $257789c1fd98f78a$export$2e2bcd8739ae039,
    minTranslate: $34ea750850063a87$export$2e2bcd8739ae039,
    maxTranslate: $6256b68bde682529$export$2e2bcd8739ae039,
    translateTo: $9cccfd03b7a139a7$export$2e2bcd8739ae039
};


function $342651cb63615af3$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}


function $52b566c1385ba726$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $55b928bfb536a002$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $52b566c1385ba726$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}



function $96d2bffb3e8c5d57$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $52b566c1385ba726$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}


var $f2423c3d78922700$export$2e2bcd8739ae039 = {
    setTransition: $342651cb63615af3$export$2e2bcd8739ae039,
    transitionStart: $55b928bfb536a002$export$2e2bcd8739ae039,
    transitionEnd: $96d2bffb3e8c5d57$export$2e2bcd8739ae039
};



function $3d0f0a5863528425$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== "number" && typeof index !== "string") throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    const translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $acb6eaa85a573617$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $5faca29628b66541$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $ffdc86f4434c21e9$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $4b504d054ca9ed96$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) return swiper.slideTo(swiper.slides.length - 1, speed, runCallbacks, internal);
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $d4a8339a182b942c$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $5225cf54c766329c$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $dc507c3326d30cfa$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $10056f6b4c930fab$export$2e2bcd8739ae039 = {
    slideTo: $3d0f0a5863528425$export$2e2bcd8739ae039,
    slideToLoop: $5faca29628b66541$export$2e2bcd8739ae039,
    slideNext: $ffdc86f4434c21e9$export$2e2bcd8739ae039,
    slidePrev: $4b504d054ca9ed96$export$2e2bcd8739ae039,
    slideReset: $d4a8339a182b942c$export$2e2bcd8739ae039,
    slideToClosest: $5225cf54c766329c$export$2e2bcd8739ae039,
    slideToClickedSlide: $dc507c3326d30cfa$export$2e2bcd8739ae039
};



var $dL2V0 = parcelRequire("dL2V0");

function $4b21862d49162f8d$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $dL2V0.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(document.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $f87d3eb57c2d1127$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}


function $2080a1e516435e4d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
}


var $f8b88d1ce87d97b8$export$2e2bcd8739ae039 = {
    loopCreate: $4b21862d49162f8d$export$2e2bcd8739ae039,
    loopFix: $f87d3eb57c2d1127$export$2e2bcd8739ae039,
    loopDestroy: $2080a1e516435e4d$export$2e2bcd8739ae039
};


function $9e5fcbf79551b8c7$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
    el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
    el.style.cursor = moving ? "grabbing" : "grab";
}


function $4f6c418cca1e9e5d$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}


var $5eedf1408e85f593$export$2e2bcd8739ae039 = {
    setGrabCursor: $9e5fcbf79551b8c7$export$2e2bcd8739ae039,
    unsetGrabCursor: $4f6c418cca1e9e5d$export$2e2bcd8739ae039
};



var $dL2V0 = parcelRequire("dL2V0");

var $dL2V0 = parcelRequire("dL2V0");


function $d79c004d47bbcde9$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $dL2V0.getDocument)() || el === (0, $dL2V0.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $d79c004d47bbcde9$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $dL2V0.getDocument)();
    const window = (0, $dL2V0.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(event.path[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $d79c004d47bbcde9$var$closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $acb6eaa85a573617$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit("touchStart", e);
}



var $dL2V0 = parcelRequire("dL2V0");


function $0488469a1043cdc5$export$2e2bcd8739ae039(event) {
    const document = (0, $dL2V0.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $acb6eaa85a573617$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $2c5f42de72029456$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $acb6eaa85a573617$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $acb6eaa85a573617$export$461939dd4422153)();
    (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $a295635baeced12c$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $8b5ff7d68fad057f$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $fa5b4fcc83bb08f2$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}


let $ddbd3e13298e6ce6$var$dummyEventAttached = false;
function $ddbd3e13298e6ce6$var$dummyEventListener() {}
const $ddbd3e13298e6ce6$var$events = (swiper, method)=>{
    const document = (0, $dL2V0.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $a295635baeced12c$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]("observerUpdate", (0, $a295635baeced12c$export$2e2bcd8739ae039), true);
};
function $ddbd3e13298e6ce6$var$attachEvents() {
    const swiper = this;
    const document = (0, $dL2V0.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $d79c004d47bbcde9$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $0488469a1043cdc5$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $2c5f42de72029456$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $fa5b4fcc83bb08f2$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $8b5ff7d68fad057f$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$ddbd3e13298e6ce6$var$dummyEventAttached) {
        document.addEventListener("touchstart", $ddbd3e13298e6ce6$var$dummyEventListener);
        $ddbd3e13298e6ce6$var$dummyEventAttached = true;
    }
    $ddbd3e13298e6ce6$var$events(swiper, "on");
}
function $ddbd3e13298e6ce6$var$detachEvents() {
    const swiper = this;
    $ddbd3e13298e6ce6$var$events(swiper, "off");
}
var $ddbd3e13298e6ce6$export$2e2bcd8739ae039 = {
    attachEvents: $ddbd3e13298e6ce6$var$attachEvents,
    detachEvents: $ddbd3e13298e6ce6$var$detachEvents
};



const $dd9bc911b91b180f$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $dd9bc911b91b180f$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $dd9bc911b91b180f$var$isGridEnabled(swiper, params);
    const isMultiRow = $dd9bc911b91b180f$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $acb6eaa85a573617$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}



var $dL2V0 = parcelRequire("dL2V0");
function $cf68f082988bd267$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $dL2V0.getWindow)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}


var $e4eaa0384e99a829$export$2e2bcd8739ae039 = {
    setBreakpoint: $dd9bc911b91b180f$export$2e2bcd8739ae039,
    getBreakpoint: $cf68f082988bd267$export$2e2bcd8739ae039
};


function $ffdb728bf348b9a7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $ffdb728bf348b9a7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $ffdb728bf348b9a7$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(" "));
    swiper.emitContainerClasses();
}


function $2f2c23e7364319cb$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}


var $8588896c5c4ff314$export$2e2bcd8739ae039 = {
    addClasses: $ffdb728bf348b9a7$export$2e2bcd8739ae039,
    removeClasses: $2f2c23e7364319cb$export$2e2bcd8739ae039
};



var $dL2V0 = parcelRequire("dL2V0");

function $59fa622397d3e607$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $dL2V0.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $3636ef14a1252af0$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}


var $addbc97419623e25$export$2e2bcd8739ae039 = {
    loadImage: $59fa622397d3e607$export$2e2bcd8739ae039,
    preloadImages: $3636ef14a1252af0$export$2e2bcd8739ae039
};


function $402d7e3b462c054f$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $402d7e3b462c054f$export$2e2bcd8739ae039 = {
    checkOverflow: $402d7e3b462c054f$var$checkOverflow
};


var $5dc008af363fc19b$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $eb7dd467a9c78b97$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $acb6eaa85a573617$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $acb6eaa85a573617$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $acb6eaa85a573617$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $de7cfcfd95248198$var$prototypes = {
    eventsEmitter: $6ea34b887619a3c7$export$2e2bcd8739ae039,
    update: $cc9729cd3caaf5e6$export$2e2bcd8739ae039,
    translate: $e7e89a1169ce83e0$export$2e2bcd8739ae039,
    transition: $f2423c3d78922700$export$2e2bcd8739ae039,
    slide: $10056f6b4c930fab$export$2e2bcd8739ae039,
    loop: $f8b88d1ce87d97b8$export$2e2bcd8739ae039,
    grabCursor: $5eedf1408e85f593$export$2e2bcd8739ae039,
    events: $ddbd3e13298e6ce6$export$2e2bcd8739ae039,
    breakpoints: $e4eaa0384e99a829$export$2e2bcd8739ae039,
    checkOverflow: $402d7e3b462c054f$export$2e2bcd8739ae039,
    classes: $8588896c5c4ff314$export$2e2bcd8739ae039,
    images: $addbc97419623e25$export$2e2bcd8739ae039
};
const $de7cfcfd95248198$var$extendedDefaults = {};
class $de7cfcfd95248198$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $acb6eaa85a573617$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $acb6eaa85a573617$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $de7cfcfd95248198$var$Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $68613c34bbc01cc7$export$d61c7b85ff180578)();
        swiper.device = (0, $1d275d65e8c80e95$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $120fb606b5839901$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $eb7dd467a9c78b97$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $acb6eaa85a573617$export$8b58be045bf06082)({}, (0, $5dc008af363fc19b$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $acb6eaa85a573617$export$8b58be045bf06082)({}, swiperParams, $de7cfcfd95248198$var$extendedDefaults, params);
        swiper.originalParams = (0, $acb6eaa85a573617$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $acb6eaa85a573617$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                const desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $acb6eaa85a573617$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $dL2V0.getDocument)();
            const wrapper = document.createElement("div");
            $wrapperEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $acb6eaa85a573617$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $acb6eaa85a573617$export$8b58be045bf06082)($de7cfcfd95248198$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $de7cfcfd95248198$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $5dc008af363fc19b$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$de7cfcfd95248198$var$Swiper.prototype.__modules__) $de7cfcfd95248198$var$Swiper.prototype.__modules__ = [];
        const modules = $de7cfcfd95248198$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$de7cfcfd95248198$var$Swiper.installModule(m));
            return $de7cfcfd95248198$var$Swiper;
        }
        $de7cfcfd95248198$var$Swiper.installModule(module);
        return $de7cfcfd95248198$var$Swiper;
    }
}
Object.keys($de7cfcfd95248198$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($de7cfcfd95248198$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $de7cfcfd95248198$var$Swiper.prototype[protoMethod] = $de7cfcfd95248198$var$prototypes[prototypeGroup][protoMethod];
    });
});
$de7cfcfd95248198$var$Swiper.use([
    (0, $9bf2dee6e7a3ced5$export$2e2bcd8739ae039),
    (0, $e500715bd067e077$export$2e2bcd8739ae039)
]);
var $de7cfcfd95248198$export$2e2bcd8739ae039 = $de7cfcfd95248198$var$Swiper;




function $10fbe0b04b3bce52$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $acb6eaa85a573617$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $dL2V0 = parcelRequire("dL2V0");

function $c0c8cc77e55c7860$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $dL2V0.getDocument)();
    const window = (0, $dL2V0.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $dL2V0 = parcelRequire("dL2V0");


function $782632e30f99aa0e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $dL2V0.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $acb6eaa85a573617$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $acb6eaa85a573617$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $acb6eaa85a573617$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $acb6eaa85a573617$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $acb6eaa85a573617$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $dL2V0 = parcelRequire("dL2V0");
function $e205b0e5be79c34b$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $dL2V0.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $b723515ca194cde4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $e205b0e5be79c34b$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on("init", ()=>{
        init();
        update();
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    Object.assign(swiper.navigation, {
        update: update,
        init: init,
        destroy: destroy
    });
}



function $a5be3d151b50f288$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}



function $394b66db83df7b0e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(" "));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $a5be3d151b50f288$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $a5be3d151b50f288$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $a5be3d151b50f288$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $a5be3d151b50f288$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $e205b0e5be79c34b$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(params.modifierClass + swiper.params.direction);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $a5be3d151b50f288$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(params.modifierClass + swiper.params.direction);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $a5be3d151b50f288$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on("init", ()=>{
        init();
        render();
        update();
    });
    on("activeIndexChange", ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el.length > 0 && !(0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    Object.assign(swiper.pagination, {
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $dL2V0 = parcelRequire("dL2V0");



function $729f766bf1fc54c9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $dL2V0.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag"
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $e205b0e5be79c34b$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        disableDraggable();
    }
    on("init", ()=>{
        init();
        updateSize();
        setTranslate();
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    Object.assign(swiper.scrollbar, {
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $053d83ca27b9cdf4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((parallaxEl)=>{
            const $parallaxEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $dL2V0 = parcelRequire("dL2V0");


function $8b0dbb62d6364d94$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $dL2V0.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $acb6eaa85a573617$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $acb6eaa85a573617$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $dL2V0 = parcelRequire("dL2V0");

function $fa3cd3c9de52cbe9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr("data-background");
            const src = $imageEl.attr("data-src");
            const srcset = $imageEl.attr("data-srcset");
            const sizes = $imageEl.attr("data-sizes");
            const $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", `url("${background}")`);
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each((sourceEl)=>{
                        const $source = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slideEl).attr("data-swiper-slide-index");
            return (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slideEl).attr("data-swiper-slide-index") : (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = slidesPerView;
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + slidesPerView; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $dL2V0.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $06986f9b182c4e3d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $5a092bd143f31c6c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group"
        }
    });
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    }
    function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    }
    function addElRole($el, role) {
        $el.attr("role", role);
    }
    function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    }
    function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    }
    function addElLabel($el, label) {
        $el.attr("aria-label", label);
    }
    function addElId($el, id) {
        $el.attr("id", id);
    }
    function addElLive($el, live) {
        $el.attr("aria-live", live);
    }
    function disableEl($el) {
        $el.attr("aria-disabled", true);
    }
    function enableEl($el) {
        $el.attr("aria-disabled", false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $a5be3d151b50f288$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    function init() {
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = $wrapperEl.attr("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        addElRole((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        }); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, $a5be3d151b50f288$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, $a5be3d151b50f288$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
        updateNavigation();
    });
    on("toEdge", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("fromEdge", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $dL2V0 = parcelRequire("dL2V0");
function $51d325bd23bc42ab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides"
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $dL2V0.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $dL2V0.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, swiper.paths.value, false);
    };
    const init = ()=>{
        const window = (0, $dL2V0.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $dL2V0.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $dL2V0 = parcelRequire("dL2V0");

function $701b31637175c265$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $dL2V0.getDocument)();
    const window = (0, $dL2V0.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || "");
            emit("hashSet");
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(window).on("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(window).off("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $dL2V0 = parcelRequire("dL2V0");

function $63db88a56e8531d5$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $acb6eaa85a573617$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $dL2V0.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else pause();
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    }
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $dL2V0.getDocument)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $dL2V0.getDocument)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $61490fadc5931067$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $acb6eaa85a573617$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        } // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", ()=>{
        if (!swiper.thumbs.swiper) return;
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        if (swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $a47bdf8806c3a0e5$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $acb6eaa85a573617$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $acb6eaa85a573617$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $acb6eaa85a573617$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $28480f90fb0690d4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && `${spaceBetween}px` : "");
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $336cce6223e4febd$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $1fe02b100b3d1fbc$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $f37561bb0ee99b19$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $8643b555435bfae4$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $17f5ae2b7bffffd0$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $a62b90b849dae969$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $336cce6223e4febd$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $1fe02b100b3d1fbc$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $f37561bb0ee99b19$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $8643b555435bfae4$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $17f5ae2b7bffffd0$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $334e2b44d2edd89e$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
}


function $086163003cdebc48$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}


function $e385b81a5a53034e$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $6ffeed49b66f6b83$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $086163003cdebc48$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $e385b81a5a53034e$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $334e2b44d2edd89e$export$2e2bcd8739ae039)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $a191c83599a30c9b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) {
                // Set shadows
                let shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"}"></div>`);
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}"></div>`);
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
            "transform-origin": `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, $334e2b44d2edd89e$export$2e2bcd8739ae039)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $ec7a5e7e2da723e6$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $ecd99c1cdbdf7520$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $ec813dd7c1a43117$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) {
                // Set shadows
                let shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) shadowBefore = (0, $ec7a5e7e2da723e6$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
                if (shadowAfter.length === 0) shadowAfter = (0, $ec7a5e7e2da723e6$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $086163003cdebc48$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, $e385b81a5a53034e$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $334e2b44d2edd89e$export$2e2bcd8739ae039)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $14e45311dc0e484b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $086163003cdebc48$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $ec7a5e7e2da723e6$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $ec7a5e7e2da723e6$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, $334e2b44d2edd89e$export$2e2bcd8739ae039)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $de470245508ee8ba$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $ec7a5e7e2da723e6$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $086163003cdebc48$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $e385b81a5a53034e$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $334e2b44d2edd89e$export$2e2bcd8739ae039)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $19b6cbe8264b25ee$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -2 * progress;
            let tXAdd = 8 - Math.abs(progress) * 0.75;
            const isSwipeToNext = (i === activeIndex || i === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (i === activeIndex || i === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${rotate}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, $ec7a5e7e2da723e6$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $086163003cdebc48$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $e385b81a5a53034e$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $334e2b44d2edd89e$export$2e2bcd8739ae039)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





(function() {
    const directive = {
        name: "swiperSlider"
    };
    controller.$inject = [
        "config",
        "$compile"
    ];
    function controller(_config, $compile) {
        function link(scope, element, attrs) {
            if (!angular.isFunction((0, $de7cfcfd95248198$export$2e2bcd8739ae039))) return;
            const o = scope.$eval(attrs[directive.name]);
            const config = _config.slider[o.config] || {};
            const instanceKey = o.instance || "swiper";
            const collectionKey = o.collectionKey || "collection";
            const slideClone = element[0].querySelector(".swiper-slide").cloneNode(true);
            const slidesWrapper = element[0].querySelector(".swiper-wrapper");
            scope.$watchCollection(collectionKey, (collection)=>{
                if (collection && collection.length) renewSlider(collection);
            });
            function renewSlider(collection) {
                if (scope[instanceKey]) destroySlider();
                buildSlider(collection);
            }
            function buildSlider(collection) {
                repeatSlides(collection);
                scope[instanceKey] = initSwiper(collection);
            }
            function initSwiper(collection) {
                const instance = new (0, $de7cfcfd95248198$export$2e2bcd8739ae039)(element[0], {
                    ...config,
                    modules: [
                        (0, $b723515ca194cde4$export$2e2bcd8739ae039)
                    ],
                    on: {
                        init: bindCollectionToSlides(collection)
                    }
                });
                return instance;
            }
            function bindCollectionToSlides(collection) {
                return function(swiper) {
                    swiper.slides.forEach((slideNode, index)=>{
                        const indexFromCollection = slideNode.dataset.swiperSlideIndex ?? index;
                        const slideScope = scope.$new();
                        slideScope.slide = collection[indexFromCollection];
                        $compile(slideNode)(slideScope);
                    });
                };
            }
            function repeatSlides(collection) {
                const repeatedSlides = document.createDocumentFragment();
                collection.forEach(()=>{
                    repeatedSlides.appendChild(slideClone.cloneNode(true));
                });
                slidesWrapper.replaceChildren(repeatedSlides);
            }
            function destroySlider() {
                scope[instanceKey].destroy();
                scope[instanceKey] = null;
            }
            scope.$on("$destroy", destroySlider);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $d1ea8e6e3c71b8d4$exports = {};

// (terms-modal-open="{ terms: item.terms }")
// (terms-modal-open="{ alias: 'cards' }")
(function() {
    const name = "termsModalOpen";
    controller.$inject = [
        "modal",
        "$timeout"
    ];
    function controller(_modal, $timeout) {
        function link(scope, element, attrs) {
            element.on("click", ()=>{
                $timeout(()=>{
                    _modal.open("terms", scope.$eval(attrs[name])).catch(()=>{});
                });
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $0b16549f473868b2$exports = {};
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $fQGWn = parcelRequire("fQGWn");
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ 
var $lXN9m = parcelRequire("lXN9m");
function $96a47e5a00ef2017$export$e90fb89750dba83f(val) {
    return !(0, $lXN9m.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}



var $891rE = parcelRequire("891rE");
function $5b03110dcb3da999$export$9dc4ecf953986f04(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    var period = -1;
    if ((0, $96a47e5a00ef2017$export$e90fb89750dba83f)(periodOrScheduler)) period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    else if ((0, $891rE.isScheduler)(periodOrScheduler)) scheduler = periodOrScheduler;
    if (!(0, $891rE.isScheduler)(scheduler)) scheduler = (0, $fQGWn.async);
    return new (0, $eGy0D.Observable)(function(subscriber) {
        var due = (0, $96a47e5a00ef2017$export$e90fb89750dba83f)(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule($5b03110dcb3da999$var$dispatch, due, {
            index: 0,
            period: period,
            subscriber: subscriber
        });
    });
}
function $5b03110dcb3da999$var$dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) return;
    else if (period === -1) return subscriber.complete();
    state.index = index + 1;
    this.schedule(state, period);
}


(function() {
    // usage: someTag(time-passed={{TIMESTAMP}}) {{timePassed}}
    // TIMESTAMP - timestamp, from which count up will go
    // timePassed - variable, where displayed time
    "use strict";
    const directive = {
        name: "timePassed"
    };
    factory.$inject = [];
    function factory() {
        function link(scope, element, attrs) {
            let timeFrom = Number(attrs[directive.name]) || new Date().getTime();
            const timer$ = (0, $5b03110dcb3da999$export$9dc4ecf953986f04)(0, 1000).subscribe((val)=>{
                const now = new Date().getTime();
                const duration = now - timeFrom;
                const hours = Math.floor(duration / 3600000);
                const minutes = Math.floor(duration / 60000 - hours * 60);
                const seconds = Math.floor(duration / 1000 - hours * 3600 - minutes * 60);
                const result = `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
                scope[directive.name] = result;
                scope.$apply();
            });
            attrs.$observe(`${directive.name}`, (newVal)=>{
                if (newVal) timeFrom = Number(attrs[directive.name]);
            });
            scope.$on("$destroy", ()=>{
                timer$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $e185481e0b3929fb$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "titleSwitcher"
    };
    controller.$inject = [
        "$translate",
        "$timeout"
    ];
    function controller($translate, $timeout) {
        async function link(scope, element, attrs) {
            scope.interval = null;
            const title = document.querySelector("title");
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    originalTitle = originalTitle || document.title;
                    observer.disconnect();
                });
            });
            const config = {
                childList: true
            };
            const { delimeter: delimeter = "/", inactiveTitleKey: inactiveTitleKey = "", fallbackTitle: fallbackTitle = "", loop: loop = false, delay: delay = 500 } = scope.$eval(attrs[directive.name]) || {};
            const changeTitle = ()=>{
                if (document.hidden && inactiveTitle) {
                    if (loop) {
                        const inactiveTitleArr = inactiveTitle.split(delimeter);
                        let index = 0;
                        scope.interval = $timeout(()=>{
                            document.title = inactiveTitleArr[index];
                            if (++index === inactiveTitleArr.length) index = 0;
                        }, 300);
                    } else document.title = inactiveTitle;
                } else {
                    clearInterval(scope.interval);
                    document.title = originalTitle;
                }
            };
            const changeCodesToEmoji = (str)=>{
                const emojiDict = {
                    ":face_with_cowboy_hat:": "\uD83E\uDD20",
                    ":bank:": "\uD83C\uDFE6",
                    ":firecracker:": "\uD83E\uDDE8",
                    ":moneybag:": "\uD83D\uDCB0",
                    ":slot_machine:": "\uD83C\uDFB0",
                    ":rocket:": "\uD83D\uDE80",
                    ":soccer:\uFE0F": "\u26BD",
                    ":softball:": "\uD83E\uDD4E"
                };
                // eslint-disable-next-line guard-for-in
                for(const e in emojiDict)str = str.replaceAll(e, emojiDict[e]);
                return str;
            };
            let originalTitle = document.querySelector("title").innerText || document.title;
            const inactiveTitle = changeCodesToEmoji(inactiveTitleKey ? await $translate(inactiveTitleKey) : fallbackTitle || originalTitle);
            document.addEventListener("visibilitychange", changeTitle);
            observer.observe(title, config);
            scope.$on("$destroy", ()=>{
                document.removeEventListener("visibilitychange", changeTitle);
                observer?.disconnect();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $5126ec3d65dc9f70$exports = {};
(function() {
    "use strict";
    // toggle-class-at-elements="{ selector: 'section h2', class:'is-open', event: 'click' trigger: true}"
    // You can add config to parent: ng-init="toggleClassAtElementsConfig = {...}".
    // This directive adds event on selected elements and toggle class on them.
    // All fields are optional BUT if don`t pass selector nothing will work.
    // selector - selector of elements                                                   default - ''
    // class - toggle class                                                              default - 'active'
    // event - toggle event                                                              default - 'click'
    // trigger - trigger of deleting class from other elements(boolean)                  default - false
    // scroll - put 'true' if you want autoscroll to target element(boolean)             default - false
    // scrollIntoViewOptions - options for scrollIntoView(see documentation on MDN)
    const directive = {
        name: "toggleClassAtElements"
    };
    function controller() {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]) || scope[`${directive.name}Config`] || {};
            const selector = config.selector ? `${config.selector}` : "";
            const elems = selector ? [
                ...element[0].querySelectorAll(selector)
            ] : [];
            const configEvent = config.event || "click";
            const className = config.class ? `${config.class}` : "active";
            const trigger = config.trigger || false;
            const enabledAutoScroll = config.scroll || false;
            const scrollIntoViewOptions = config.scrollIntoViewOptions || {
                behavior: "smooth"
            };
            const action = (event)=>{
                const active = elems.find((el)=>el.classList.contains(`${className}`));
                const target = event.currentTarget;
                if (trigger && active && active !== target) active.classList.remove(className);
                target.classList.toggle(className);
                if (enabledAutoScroll) target.scrollIntoView(scrollIntoViewOptions);
            };
            elems.forEach((el)=>el.addEventListener(configEvent, (event)=>action(event)));
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $31631ad572cd66dd$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "toggleClassOnEvent"
    };
    controller.$inject = [
        "event"
    ];
    function controller(_event) {
        function link(scope, element, attrs) {
            const { event: event, selector: selector, class: classNames } = scope.$eval(attrs[directive.name]);
            element.on(event || "click", ()=>{
                const targetElements = selector ? document.querySelectorAll(selector) : [
                    element[0]
                ];
                const classNamesAsArray = classNames?.split(" ") || [];
                targetElements.forEach((targetElement)=>{
                    classNamesAsArray.forEach((className)=>{
                        targetElement.classList.toggle(className);
                    });
                });
            });
            _event.create(event, element[0]);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $5ef575360582cf8a$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "toggleClassOnScroll"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            const el = document.querySelector(config.selector) || element[0];
            const top = config.top || 0;
            const left = config.left || 0;
            const target = document.querySelector(config.wrapperSelector) || window;
            const scrollStream = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(target, "scroll");
            const subscribtion = scrollStream.subscribe(()=>{
                let wrapperOffset;
                if (left) {
                    wrapperOffset = target.scrollLeft || target.pageXOffset;
                    el.classList.toggle(config.class, wrapperOffset > left);
                } else if (top) {
                    wrapperOffset = target.scrollTop || target.pageYOffset;
                    el.classList.toggle(config.class, wrapperOffset > top);
                }
            });
            scope.$on("$destroy", ()=>{
                subscribtion.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c5f411f5987c30f8$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("itemStatus$", controller);
})();



(function() {
    "use strict";
    controller.$inject = [
        "itemStatus$"
    ];
    function controller(_itemStatus$) {
        function link(scope, element, attrs) {
            const { event: event, group: group, class: className } = scope.$eval(attrs.toggleGroupClassOnEvent);
            const subscription = _itemStatus$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((name)=>name === group)).subscribe(()=>element.removeClass(className));
            element.on(event, ()=>{
                _itemStatus$.next(group);
                element.addClass(className);
            });
            scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("toggleGroupClassOnEvent", controller);
})();


var $2113b38cf902561c$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "toggleLoginFormMode"
    };
    function controller() {
        function link(scope, element, attrs) {
            scope.mode = scope.$eval(attrs[directive.name]);
            element.on("click", ()=>{
                if (scope.mode === "login") {
                    scope.mode = "email";
                    return;
                }
                scope.mode = "login";
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $de3cd069c9b50b43$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            check (value) {
                return typeof IBAN === "object" ? IBAN.isValid(value) : true;
            }
        };
    }
    app.factory("iban", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        const opt = {
            min: 2,
            max: 15
        };
        return {
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.min = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length >= opt.min : true;
                };
                ngModel.$validators.max = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= opt.max : true;
                };
            }
        };
    }
    app.factory("postcode", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        const opt = {
            min: 9
        };
        return {
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.min = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length >= opt.min : false;
                };
                ngModel.$validators.number = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.match(new RegExp("[\\d]+")) : false;
                };
                ngModel.$validators.up = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.match(new RegExp("[A-Z]+")) : false;
                };
                ngModel.$validators.low = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.match(new RegExp("[a-z]+")) : false;
                };
            }
        };
    }
    app.factory("password", controller);
})();


(function() {
    function controller() {
        const cpfLength = 11;
        const cpfPattern = new RegExp("^[0-9]+$");
        return {
            check (value) {
                return cpfPattern.test(value) && value.length === cpfLength;
            }
        };
    }
    app.factory("cpf", controller);
})();


(function() {
    function controller() {
        const addressCAPattern = new RegExp("^((?!po box).)*$");
        return {
            check (value) {
                return addressCAPattern.test(value.toLowerCase());
            }
        };
    }
    app.factory("addressCA", controller);
})();




/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");

var $fQGWn = parcelRequire("fQGWn");
function $969807fecf2e057f$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $fQGWn.async);
    return function(source) {
        return source.lift(new $969807fecf2e057f$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
var $969807fecf2e057f$var$DebounceTimeOperator = /*@__PURE__*/ function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $969807fecf2e057f$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
var $969807fecf2e057f$var$DebounceTimeSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($969807fecf2e057f$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}((0, $2Dqpi.Subscriber));
function $969807fecf2e057f$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}


(function() {
    controller.$inject = [
        "account",
        "$q"
    ];
    function controller(_account, $q) {
        const stream$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const minLength = 6;
        const maxLength = 15;
        stream$.pipe((0, $969807fecf2e057f$export$7843a4469d64c07e)(400)).subscribe(({ options: options, defer: defer })=>{
            _account.validateUserData(options).then(()=>{
                defer.resolve();
            }).catch((err)=>{
                defer.reject(err);
            });
        });
        return {
            asyncCheckPhone (value) {
                const lastSymbolValue = /\d$/.test(value);
                if (lastSymbolValue && value.length >= minLength && value.length <= maxLength) {
                    const defer = $q.defer();
                    stream$.next({
                        options: {
                            phone: value
                        },
                        defer: defer
                    });
                    return defer.promise;
                }
                const defer = $q.defer();
                defer.reject();
                return defer.promise;
            },
            asyncCheckLogin (value) {
                const defer = $q.defer();
                stream$.next({
                    options: {
                        login: value
                    },
                    defer: defer
                });
                return defer.promise;
            }
        };
    }
    app.factory("accountValidator", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !!value;
                };
                ngModel.$validators.minlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    const filteredValue = value?.trim();
                    return filteredValue ? filteredValue.length >= 2 : true;
                };
                ngModel.$validators.maxlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= 50 : true;
                };
                ngModel.$validators.pattern = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /^[a-zA-ZÀ-ÖØ-öø-ſȀ-ȳḀ-Ợ\s]+$/.test(value) : false;
                };
            }
        };
    }
    app.factory("name", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !!value;
                };
                ngModel.$validators.minlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    const filteredValue = value?.trim();
                    return filteredValue ? filteredValue.length >= 2 : true;
                };
                ngModel.$validators.maxlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= 50 : true;
                };
                ngModel.$validators.pattern = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /^[a-zA-ZÀ-ÖØ-öø-ſȀ-ȳḀ-Ợ\s]+$/.test(value) : true;
                };
            }
        };
    }
    app.factory("surname", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !!value;
                };
                ngModel.$validators.minlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    const filteredValue = value?.trim();
                    return filteredValue ? filteredValue.length >= 2 : true;
                };
                ngModel.$validators.maxlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= 50 : true;
                };
                ngModel.$validators.pattern = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /^[a-zA-ZÀ-ÖØ-öø-ſȀ-ȳḀ-Ợ\s]+$/.test(value) : true;
                };
            }
        };
    }
    app.factory("city", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            customValidators (scope, element, attrs, ngModel, ngModelCtrl) {
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !!value;
                };
                ngModel.$validators.minlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    const filteredValue = value?.trim();
                    return filteredValue ? filteredValue.length >= 2 : true;
                };
                ngModel.$validators.maxlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= 120 : true;
                };
                ngModel.$validators.pattern = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /^[a-zA-ZÀ-ÖØ-öø-ſȀ-ȳḀ-Ợ0-9\s]+$/.test(value) : true;
                };
                ngModel.$validators.letter = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /[a-zA-ZÀ-ÖØ-öø-ſȀ-ȳḀ-Ợ]/.test(value) : true;
                };
            }
        };
    }
    app.factory("address", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            customValidators (scope, element, attrs, ngModel) {
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !!value;
                };
                ngModel.$validators.minlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    const filteredValue = value?.trim();
                    return filteredValue ? filteredValue.length >= 2 : true;
                };
                ngModel.$validators.maxlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= 50 : true;
                };
                ngModel.$validators.pattern = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /^[a-zA-ZÀ-ÖØ-öø-ſȀ-ȳḀ-Ợ0-9\-\s]+$/.test(value) : true;
                };
            }
        };
    }
    app.factory("zipcode", controller);
})();


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            customValidators (scope, element, attrs, ngModel, ngModelCtrl) {
                ngModel.$validators.required = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return !!value;
                };
                ngModel.$validators.maxlength = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? value.length <= 100 : true;
                };
                ngModel.$validators.pattern = (modelValue, viewValue)=>{
                    const value = modelValue || viewValue;
                    return value ? /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9-]{2,})+$/.test(value) : false;
                };
            }
        };
    }
    app.factory("email", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "validateAs"
    };
    controller.$inject = [
        "iban",
        "postcode",
        "password",
        "cpf",
        "addressCA",
        "accountValidator",
        "name",
        "surname",
        "city",
        "address",
        "zipcode",
        "email"
    ];
    function controller(_iban, _postcode, _password, _cpf, _addressCA, _accountValidator, _name, _surname, _city, _address, _zipcode, _email) {
        const link = (scope, element, attrs, ngModel)=>{
            const type = attrs[directive.name] || null;
            const validator = {};
            const asyncValidator = {};
            switch(type){
                case "iban":
                    validator.type = "iban";
                    validator.method = _iban.check;
                    break;
                case "cpf":
                    validator.type = "cpf";
                    validator.method = _cpf.check;
                    break;
                case "postcode":
                    validator.customValidators = _postcode.customValidators;
                    break;
                case "password":
                    validator.customValidators = _password.customValidators;
                    break;
                case "addressCA":
                    validator.type = "addressCA";
                    validator.method = _addressCA.check;
                    break;
                case "phone":
                    phoneFormatter();
                    asyncValidator.type = "phone";
                    asyncValidator.method = _accountValidator.asyncCheckPhone;
                    break;
                case "login":
                    asyncValidator.type = "login";
                    asyncValidator.method = _accountValidator.asyncCheckLogin;
                    break;
                case "name":
                    validator.customValidators = _name.customValidators;
                    break;
                case "surname":
                    validator.customValidators = _surname.customValidators;
                    break;
                case "city":
                    validator.customValidators = _city.customValidators;
                    break;
                case "address":
                    validator.customValidators = _address.customValidators;
                    break;
                // name this type zipcode as there is a type postcode, for not to change anything on brands
                case "zipcode":
                    validator.customValidators = _zipcode.customValidators;
                    break;
                case "email":
                    validator.customValidators = _email.customValidators;
                    break;
                default:
                    validator.type = null;
                    break;
            }
            if (angular.isFunction(validator.customValidators)) validator.customValidators(scope, element, attrs, ngModel);
            if (validator.type) ngModel.$validators[validator.type] = (modelValue, viewValue)=>{
                const value = modelValue || viewValue;
                return value ? validator.method(value) : true;
            };
            if (asyncValidator.type) ngModel.$asyncValidators[asyncValidator.type] = (modelValue, viewValue)=>{
                const value = modelValue || viewValue;
                return value ? asyncValidator.method(value) : true;
            };
            function phoneFormatter() {
                element.on("input", ()=>{
                    const newValue = `+${element.val().replace(/[^0-9]/g, "")}`;
                    ngModel.$setViewValue(newValue);
                    ngModel.$render();
                    ngModel.$validate();
                });
            }
        };
        return {
            restrict: "A",
            require: "?ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3d40794d82a01328$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "validateCpr"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs, ctrl)=>{
            const format = "DDMMYY";
            const formatWithDash = (value)=>{
                const stringVal = `${value}`;
                const formatted = `${stringVal.substr(0, format.length)}-${stringVal.substr(format.length, stringVal.length)}`;
                return formatted;
            };
            const validator = (value)=>{
                // expected that value has format DDMMYY...
                const formattedDateStr = value.substr(0, format.length);
                const day = formattedDateStr.substr(0, 2);
                const month = formattedDateStr.substr(2, 2);
                const year = `20${formattedDateStr.substr(4, 2)}`;
                const date = new Date(`${year}-${month}-${day}`);
                return !isNaN(date.getTime()) && Number(day) === date.getDate();
            };
            ctrl.$validators.validateCpr = function(modelValue, viewValue) {
                const value = modelValue || viewValue;
                return value ? validator(value) : false;
            };
            ctrl.$parsers.push(function(modelValue, viewValue) {
                const value = modelValue || viewValue;
                return value ? formatWithDash(value) : value;
            });
        };
        return {
            restrict: "A",
            require: "ngModel",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $46d59094d6909ce6$exports = {};


var $cwgwH = parcelRequire("cwgwH");/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");



function $c3c92ab8ce276e43$export$9f6ea8e48bc26eab(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($c3c92ab8ce276e43$export$9f6ea8e48bc26eab(function(a, i) {
            return (0, $c3f2ce8520f4fff9$export$6788812c4e6611e6)(project(a, i)).pipe((0, $32594888be9d26d0$export$871de8747c9eaa88)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new $c3c92ab8ce276e43$var$SwitchMapOperator(project));
    };
}
var $c3c92ab8ce276e43$var$SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c3c92ab8ce276e43$var$SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var $c3c92ab8ce276e43$var$SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, $f1a21b598f0f6aea$export$20b3446cf1c359c0)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, $f1a21b598f0f6aea$export$d34bac9c0f124cff)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, $f1a21b598f0f6aea$export$b73f91a09e7d5376));

/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $efc1b9fc0f5a126c$export$8793edee2d425525() {}



var $lvTqi = parcelRequire("lvTqi");
function $92a424c49fb9c529$export$3f23594af5f37336(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $92a424c49fb9c529$var$DoOperator(nextOrObserver, error, complete));
    };
}
var $92a424c49fb9c529$var$DoOperator = /*@__PURE__*/ function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $92a424c49fb9c529$var$TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
var $92a424c49fb9c529$var$TapSubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
        _this._tapError = (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
        _this._tapComplete = (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
        _this._tapError = error || (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
        _this._tapComplete = complete || (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
        if ((0, $lvTqi.isFunction)(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        } else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
            _this._tapError = observerOrNext.error || (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
            _this._tapComplete = observerOrNext.complete || (0, $efc1b9fc0f5a126c$export$8793edee2d425525);
        }
        return _this;
    }
    TapSubscriber.prototype._next = function(value) {
        try {
            this._tapNext.call(this._context, value);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function(err) {
        try {
            this._tapError.call(this._context, err);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function() {
        try {
            this._tapComplete.call(this._context);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}((0, $2Dqpi.Subscriber));


(function() {
    "use strict";
    const directive = {
        name: "wazambaQuickDepositBehavior"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            let isChanged = false;
            const config = scope.$eval(attrs[directive.name]);
            let isHovered = false;
            const mouseenter$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(element, "mouseenter");
            const mouseleave$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(element, "mouseleave");
            const click$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(element, "click");
            const clickOutside$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "click");
            mouseenter$.pipe((0, $92a424c49fb9c529$export$3f23594af5f37336)(()=>{
                isHovered = true;
            }), (0, $cwgwH.delay)(400), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(()=>isHovered)).subscribe((e)=>{
                element.addClass(config.class);
            });
            mouseleave$.pipe((0, $92a424c49fb9c529$export$3f23594af5f37336)(()=>{
                isHovered = false;
            }), (0, $cwgwH.delay)(600)).subscribe((e)=>{
                if (!isChanged) element.removeClass(config.class);
            });
            click$.pipe((0, $92a424c49fb9c529$export$3f23594af5f37336)((e)=>{
                isChanged = true;
                e.stopPropagation();
            }), (0, $c3c92ab8ce276e43$export$9f6ea8e48bc26eab)((e)=>clickOutside$)).subscribe((e)=>{
                isChanged = false;
                element.removeClass(config.class);
            });
            scope.$on("$destroy", function() {
                mouseenter$.unsubscribe();
                mouseleave$.unsubscribe();
                click$.unsubscribe();
                clickOutside$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $2dd69f6d55921652$exports = {};





(function() {
    "use strict";
    app.directive("body", controller);
    const className = {
        user: "linda-has-user",
        pnp: "pay-n-play",
        rememberedLogin: "linda-has-remembered-login",
        rtlLang: "rtl-lang"
    };
    controller.$inject = [
        "user",
        "user$",
        "$compile",
        "trustly.config",
        "config",
        "remembered",
        "$window"
    ];
    function controller(_user, _user$, $compile, _trustly_config, _config, _remembered, $window) {
        function link(scope, element, attrs) {
            if (!$window.localStorage.getItem("gdpr-cookies")) element.append($compile("<linda-gdpr-cookies />")(scope));
            _user$.subscribe((m)=>{
                element.toggleClass(className.user, _user.status);
                if (_user.status) element.addClass(className.rememberedLogin);
            });
            element.toggleClass(className.pnp, _trustly_config.enabled);
            element.toggleClass(className.rememberedLogin, Boolean(_remembered.login));
            element.toggleClass(className.rtlLang, _config.currentLang === "ar");
        }
        return {
            restrict: "E",
            link: link
        };
    }
})();


var $8efba2c706f7d602$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs, formCtrl)=>{
            formCtrl.$successful = false;
            formCtrl.$setSuccessful = function() {
                this.$successful = true;
                if (angular.isFunction(this.$onSuccessful)) this.$onSuccessful();
            };
        };
        return {
            require: "form",
            restrict: "E",
            link: link
        };
    }
    app.directive("form", controller);
})();


var $d1d39a0fbdabb8fc$exports = {};

(function() {
    "use strict";
    app.directive("head", controller);
    controller.$inject = [
        "config",
        "$timeout"
    ];
    function controller(_config, $timeout) {
        function link(scope, element, attrs) {
            $timeout(()=>{
                _config.customScripts.forEach((item)=>{
                    const element = document.createElement("script");
                    element.src = `${item}?build=${_config.build}`;
                    element.async = false;
                    document.head.appendChild(element);
                });
            }, 1000);
        }
        return {
            restrict: "E",
            // scope: true,
            link: link
        };
    }
})();


var $7ec4303e422991d0$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs.settings);
            function slickStart($) {
                const slickness = $(element);
                $timeout(()=>{
                    scope.formData.avatar = `${config.initialSlide}` || "0";
                    slickness.slick(config);
                    slickness.css("visibility", "visible");
                    slickness.on("beforeChange", (event, slick, currentSlide, nextSlide)=>{
                        $timeout(()=>{
                            scope.$apply(()=>{
                                scope.formData.avatar = `${nextSlide}`;
                            });
                        });
                    });
                });
            }
            Promise.all([
                Promise.resolve((parcelRequire("1E71g"))),
                (parcelRequire("aMz5n"))
            ]).then(([$])=>{
                slickStart($);
            });
        }
        return {
            restrict: "E",
            link: link
        };
    }
    app.directive("lindaAvatarSlick", controller);
})();


var $1f90e455e4375a58$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("promoListUpdated$", controller);
})();




(function() {
    controller.$inject = [
        "$timeout",
        "promoListUpdated$",
        "$window"
    ];
    function controller($timeout, _promoListUpdated$, $window) {
        function link(scope, element, attrs) {
            let subscription = null;
            let promoListUpdateSubscription = null;
            const config = scope.$eval(attrs.settings);
            const onBeforeChange = scope.$eval(attrs.onBeforeChange);
            const sliderState = attrs["sliderState"] === "slider-state" ? "sliderState" : attrs["sliderState"];
            function startSlick($) {
                const slickness = $(element);
                let iAmSender = false;
                promoListUpdateSubscription = _promoListUpdated$.subscribe(()=>{
                    slickness.slick("refresh");
                });
                if (typeof $window.select$ !== "undefined") {
                    select$.next(config.initialSlide || 0);
                    subscription = $window.select$.subscribe((index)=>{
                        if (iAmSender) iAmSender = false;
                        else slickness.slick("slickGoTo", index);
                    });
                }
                $timeout(()=>{
                    if (sliderState && !scope[sliderState]) scope[sliderState] = {
                        currentSlide: config.initialSlide || 0
                    };
                    slickness.slick(config);
                    slickness.css("visibility", "visible");
                    slickness.on("beforeChange", (event, slick, currentSlide, nextSlide)=>{
                        $timeout(()=>{
                            scope.$apply(()=>{
                                if (angular.isFunction(onBeforeChange)) onBeforeChange(event, slick, currentSlide, nextSlide);
                                if (sliderState) {
                                    scope[sliderState].currentSlide = currentSlide;
                                    scope[sliderState].beforeChange = {
                                        currentSlide: currentSlide,
                                        nextSlide: nextSlide
                                    };
                                }
                                if (typeof $window.select$ !== "undefined") {
                                    iAmSender = true;
                                    select$.next(nextSlide);
                                }
                            });
                        });
                    });
                    slickness.on("afterChange", (event, slick, currentSlide)=>{
                        $timeout(()=>{
                            scope.$apply(()=>{
                                if (sliderState) {
                                    const prevSlide = scope[sliderState].beforeChange.currentSlide;
                                    scope[sliderState].currentSlide = currentSlide;
                                    scope[sliderState].afterChange = {
                                        currentSlide: currentSlide,
                                        prevSlide: prevSlide
                                    };
                                }
                            });
                        });
                    });
                    scope.$parent["lindaSlick"] = {
                        slickGoTo (index) {
                            slickness.slick("slickGoTo", index);
                        },
                        get currentSlide () {
                            return slickness.slick("slickCurrentSlide") || 0;
                        }
                    };
                });
            }
            Promise.all([
                Promise.resolve((parcelRequire("1E71g"))),
                (parcelRequire("aMz5n"))
            ]).then(([$])=>{
                startSlick($);
            });
            scope.$on("$destroy", ()=>{
                subscription?.unsubscribe();
                promoListUpdateSubscription.unsubscribe();
            });
        }
        return {
            restrict: "E",
            link: link
        };
    }
    app.directive("lindaSlick", controller);
})();


var $b54b4712f1118475$exports = {};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bb98585ab5fb39f$var$kt = globalThis, $8bb98585ab5fb39f$var$de = $8bb98585ab5fb39f$var$kt.ShadowRoot && ($8bb98585ab5fb39f$var$kt.ShadyCSS === void 0 || $8bb98585ab5fb39f$var$kt.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $8bb98585ab5fb39f$var$le = Symbol(), $8bb98585ab5fb39f$var$ve = /* @__PURE__ */ new WeakMap();
class $8bb98585ab5fb39f$var$qe {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $8bb98585ab5fb39f$var$le) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this._strings = e;
    }
    // This is a getter so that it's lazy. In practice, this means stylesheets
    // are not created until the first element instance is made.
    get styleSheet() {
        let t = this._styleSheet;
        const e = this._strings;
        if ($8bb98585ab5fb39f$var$de && t === void 0) {
            const n = e !== void 0 && e.length === 1;
            n && (t = $8bb98585ab5fb39f$var$ve.get(e)), t === void 0 && ((this._styleSheet = t = new CSSStyleSheet()).replaceSync(this.cssText), n && $8bb98585ab5fb39f$var$ve.set(e, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $8bb98585ab5fb39f$var$yi = (i)=>{
    if (i._$cssResult$ === !0) return i.cssText;
    if (typeof i == "number") return i;
    throw new Error(`Value passed to 'css' function must be a 'css' function result: ${i}. Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.`);
}, $8bb98585ab5fb39f$var$_i = (i)=>new $8bb98585ab5fb39f$var$qe(typeof i == "string" ? i : String(i), void 0, $8bb98585ab5fb39f$var$le), $8bb98585ab5fb39f$var$Bt = (i, ...t)=>{
    const e = i.length === 1 ? i[0] : t.reduce((n, r, o)=>n + $8bb98585ab5fb39f$var$yi(r) + i[o + 1], i[0]);
    return new $8bb98585ab5fb39f$var$qe(e, i, $8bb98585ab5fb39f$var$le);
}, $8bb98585ab5fb39f$var$wi = (i, t)=>{
    if ($8bb98585ab5fb39f$var$de) i.adoptedStyleSheets = t.map((e)=>e instanceof CSSStyleSheet ? e : e.styleSheet);
    else for (const e of t){
        const n = document.createElement("style"), r = $8bb98585ab5fb39f$var$kt.litNonce;
        r !== void 0 && n.setAttribute("nonce", r), n.textContent = e.cssText, i.appendChild(n);
    }
}, $8bb98585ab5fb39f$var$vi = (i)=>{
    let t = "";
    for (const e of i.cssRules)t += e.cssText;
    return $8bb98585ab5fb39f$var$_i(t);
}, $8bb98585ab5fb39f$var$Ee = $8bb98585ab5fb39f$var$de ? (i)=>i : (i)=>i instanceof CSSStyleSheet ? $8bb98585ab5fb39f$var$vi(i) : i;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $8bb98585ab5fb39f$var$Ei, defineProperty: $8bb98585ab5fb39f$var$Ci, getOwnPropertyDescriptor: $8bb98585ab5fb39f$var$Ce, getOwnPropertyNames: $8bb98585ab5fb39f$var$ki, getOwnPropertySymbols: $8bb98585ab5fb39f$var$Si, getPrototypeOf: $8bb98585ab5fb39f$var$ke } = Object, $8bb98585ab5fb39f$var$B = globalThis;
let $8bb98585ab5fb39f$var$U;
const $8bb98585ab5fb39f$var$Se = $8bb98585ab5fb39f$var$B.trustedTypes, $8bb98585ab5fb39f$var$Pi = $8bb98585ab5fb39f$var$Se ? $8bb98585ab5fb39f$var$Se.emptyScript : "", $8bb98585ab5fb39f$var$St = $8bb98585ab5fb39f$var$B.reactiveElementPolyfillSupportDevMode;
var $8bb98585ab5fb39f$var$ze;
{
    const i = $8bb98585ab5fb39f$var$B.litIssuedWarnings ?? ($8bb98585ab5fb39f$var$B.litIssuedWarnings = /* @__PURE__ */ new Set());
    $8bb98585ab5fb39f$var$U = (t, e)=>{
        e += ` See https://lit.dev/msg/${t} for more information.`, i.has(e) || (console.warn(e), i.add(e));
    }, $8bb98585ab5fb39f$var$U("dev-mode", "Lit is in dev mode. Not recommended for production!"), ($8bb98585ab5fb39f$var$ze = $8bb98585ab5fb39f$var$B.ShadyDOM) != null && $8bb98585ab5fb39f$var$ze.inUse && $8bb98585ab5fb39f$var$St === void 0 && $8bb98585ab5fb39f$var$U("polyfill-support-missing", "Shadow DOM is being polyfilled via `ShadyDOM` but the `polyfill-support` module has not been loaded.");
}const $8bb98585ab5fb39f$var$qt = (i)=>{
    $8bb98585ab5fb39f$var$B.emitLitDebugLogEvents && $8bb98585ab5fb39f$var$B.dispatchEvent(new CustomEvent("lit-debug", {
        detail: i
    }));
}, $8bb98585ab5fb39f$var$et = (i, t)=>i, $8bb98585ab5fb39f$var$$t = {
    toAttribute (i, t) {
        switch(t){
            case Boolean:
                i = i ? $8bb98585ab5fb39f$var$Pi : null;
                break;
            case Object:
            case Array:
                i = i == null ? i : JSON.stringify(i);
                break;
        }
        return i;
    },
    fromAttribute (i, t) {
        let e = i;
        switch(t){
            case Boolean:
                e = i !== null;
                break;
            case Number:
                e = i === null ? null : Number(i);
                break;
            case Object:
            case Array:
                try {
                    e = JSON.parse(i);
                } catch  {
                    e = null;
                }
                break;
        }
        return e;
    }
}, $8bb98585ab5fb39f$var$ce = (i, t)=>!$8bb98585ab5fb39f$var$Ei(i, t), $8bb98585ab5fb39f$var$Pe = {
    attribute: !0,
    type: String,
    converter: $8bb98585ab5fb39f$var$$t,
    reflect: !1,
    hasChanged: $8bb98585ab5fb39f$var$ce
};
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata"));
$8bb98585ab5fb39f$var$B.litPropertyMetadata ?? ($8bb98585ab5fb39f$var$B.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class $8bb98585ab5fb39f$var$q extends HTMLElement {
    /**
   * Adds an initializer function to the class that is called during instance
   * construction.
   *
   * This is useful for code that runs against a `ReactiveElement`
   * subclass, such as a decorator, that needs to do work for each
   * instance, such as setting up a `ReactiveController`.
   *
   * ```ts
   * const myDecorator = (target: typeof ReactiveElement, key: string) => {
   *   target.addInitializer((instance: ReactiveElement) => {
   *     // This is run during construction of the element
   *     new MyController(instance);
   *   });
   * }
   * ```
   *
   * Decorating a field will then cause each instance to run an initializer
   * that adds a controller:
   *
   * ```ts
   * class MyElement extends LitElement {
   *   @myDecorator foo;
   * }
   * ```
   *
   * Initializers are stored per-constructor. Adding an initializer to a
   * subclass does not add it to a superclass. Since initializers are run in
   * constructors, initializers will run in order of the class hierarchy,
   * starting with superclasses and progressing to the instance's class.
   *
   * @nocollapse
   */ static addInitializer(t) {
        this.__prepare(), (this._initializers ?? (this._initializers = [])).push(t);
    }
    /**
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */ static get observedAttributes() {
        return this.finalize(), this.__attributeToPropertyMap && [
            ...this.__attributeToPropertyMap.keys()
        ];
    }
    /**
   * Creates a property accessor on the element prototype if one does not exist
   * and stores a {@linkcode PropertyDeclaration} for the property with the
   * given options. The property setter calls the property's `hasChanged`
   * property option or uses a strict identity check to determine whether or not
   * to request an update.
   *
   * This method may be overridden to customize properties; however,
   * when doing so, it's important to call `super.createProperty` to ensure
   * the property is setup correctly. This method calls
   * `getPropertyDescriptor` internally to get a descriptor to install.
   * To customize what properties do when they are get or set, override
   * `getPropertyDescriptor`. To customize the options for a property,
   * implement `createProperty` like this:
   *
   * ```ts
   * static createProperty(name, options) {
   *   options = Object.assign(options, {myOption: true});
   *   super.createProperty(name, options);
   * }
   * ```
   *
   * @nocollapse
   * @category properties
   */ static createProperty(t, e = $8bb98585ab5fb39f$var$Pe) {
        if (e.state && (e.attribute = !1), this.__prepare(), this.elementProperties.set(t, e), !e.noAccessor) {
            const n = // Use Symbol.for in dev mode to make it easier to maintain state
            // when doing HMR.
            Symbol.for(`${String(t)} (@property() cache)`), r = this.getPropertyDescriptor(t, n, e);
            r !== void 0 && $8bb98585ab5fb39f$var$Ci(this.prototype, t, r);
        }
    }
    /**
   * Returns a property descriptor to be defined on the given named property.
   * If no descriptor is returned, the property will not become an accessor.
   * For example,
   *
   * ```ts
   * class MyElement extends LitElement {
   *   static getPropertyDescriptor(name, key, options) {
   *     const defaultDescriptor =
   *         super.getPropertyDescriptor(name, key, options);
   *     const setter = defaultDescriptor.set;
   *     return {
   *       get: defaultDescriptor.get,
   *       set(value) {
   *         setter.call(this, value);
   *         // custom action.
   *       },
   *       configurable: true,
   *       enumerable: true
   *     }
   *   }
   * }
   * ```
   *
   * @nocollapse
   * @category properties
   */ static getPropertyDescriptor(t, e, n) {
        const { get: r, set: o } = $8bb98585ab5fb39f$var$Ce(this.prototype, t) ?? {
            get () {
                return this[e];
            },
            set (s) {
                this[e] = s;
            }
        };
        if (r == null) {
            if ("value" in ($8bb98585ab5fb39f$var$Ce(this.prototype, t) ?? {})) throw new Error(`Field ${JSON.stringify(String(t))} on ${this.name} was declared as a reactive property but it's actually declared as a value on the prototype. Usually this is due to using @property or @state on a method.`);
            $8bb98585ab5fb39f$var$U("reactive-property-without-getter", `Field ${JSON.stringify(String(t))} on ${this.name} was declared as a reactive property but it does not have a getter. This will be an error in a future version of Lit.`);
        }
        return {
            get () {
                return r == null ? void 0 : r.call(this);
            },
            set (s) {
                const d = r == null ? void 0 : r.call(this);
                o.call(this, s), this.requestUpdate(t, d, n);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    /**
   * Returns the property options associated with the given property.
   * These options are defined with a `PropertyDeclaration` via the `properties`
   * object or the `@property` decorator and are registered in
   * `createProperty(...)`.
   *
   * Note, this method should be considered "final" and not overridden. To
   * customize the options for a given property, override
   * {@linkcode createProperty}.
   *
   * @nocollapse
   * @final
   * @category properties
   */ static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $8bb98585ab5fb39f$var$Pe;
    }
    /**
   * Initializes static own properties of the class used in bookkeeping
   * for element properties, initializers, etc.
   *
   * Can be called multiple times by code that needs to ensure these
   * properties exist before using them.
   *
   * This method ensures the superclass is finalized so that inherited
   * property metadata can be copied down.
   * @nocollapse
   */ static __prepare() {
        if (this.hasOwnProperty($8bb98585ab5fb39f$var$et("elementProperties"))) return;
        const t = $8bb98585ab5fb39f$var$ke(this);
        t.finalize(), t._initializers !== void 0 && (this._initializers = [
            ...t._initializers
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    /**
   * Finishes setting up the class so that it's ready to be registered
   * as a custom element and instantiated.
   *
   * This method is called by the ReactiveElement.observedAttributes getter.
   * If you override the observedAttributes getter, you must either call
   * super.observedAttributes to trigger finalization, or call finalize()
   * yourself.
   *
   * @nocollapse
   */ static finalize() {
        if (this.hasOwnProperty($8bb98585ab5fb39f$var$et("finalized"))) return;
        if (this.finalized = !0, this.__prepare(), this.hasOwnProperty($8bb98585ab5fb39f$var$et("properties"))) {
            const e = this.properties, n = [
                ...$8bb98585ab5fb39f$var$ki(e),
                ...$8bb98585ab5fb39f$var$Si(e)
            ];
            for (const r of n)this.createProperty(r, e[r]);
        }
        const t = this[Symbol.metadata];
        if (t !== null) {
            const e = litPropertyMetadata.get(t);
            if (e !== void 0) for (const [n, r] of e)this.elementProperties.set(n, r);
        }
        this.__attributeToPropertyMap = /* @__PURE__ */ new Map();
        for (const [e, n] of this.elementProperties){
            const r = this.__attributeNameForProperty(e, n);
            r !== void 0 && this.__attributeToPropertyMap.set(r, e);
        }
        this.elementStyles = this.finalizeStyles(this.styles), this.hasOwnProperty("createProperty") && $8bb98585ab5fb39f$var$U("no-override-create-property", "Overriding ReactiveElement.createProperty() is deprecated. The override will not be called with standard decorators"), this.hasOwnProperty("getPropertyDescriptor") && $8bb98585ab5fb39f$var$U("no-override-get-property-descriptor", "Overriding ReactiveElement.getPropertyDescriptor() is deprecated. The override will not be called with standard decorators");
    }
    /**
   * Takes the styles the user supplied via the `static styles` property and
   * returns the array of styles to apply to the element.
   * Override this method to integrate into a style management system.
   *
   * Styles are deduplicated preserving the _last_ instance in the list. This
   * is a performance optimization to avoid duplicated styles that can occur
   * especially when composing via subclassing. The last item is kept to try
   * to preserve the cascade order with the assumption that it's most important
   * that last added styles override previous styles.
   *
   * @nocollapse
   * @category styles
   */ static finalizeStyles(t) {
        const e = [];
        if (Array.isArray(t)) {
            const n = new Set(t.flat(1 / 0).reverse());
            for (const r of n)e.unshift($8bb98585ab5fb39f$var$Ee(r));
        } else t !== void 0 && e.push($8bb98585ab5fb39f$var$Ee(t));
        return e;
    }
    /**
   * Returns the property name for the given attribute `name`.
   * @nocollapse
   */ static __attributeNameForProperty(t, e) {
        const n = e.attribute;
        return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this.__instanceProperties = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this.__reflectingProperty = null, this.__initialize();
    }
    /**
   * Internal only override point for customizing work done when elements
   * are constructed.
   */ __initialize() {
        var t;
        this.__updatePromise = new Promise((e)=>this.enableUpdating = e), this._$changedProperties = /* @__PURE__ */ new Map(), this.__saveInstanceProperties(), this.requestUpdate(), (t = this.constructor._initializers) == null || t.forEach((e)=>e(this));
    }
    /**
   * Registers a `ReactiveController` to participate in the element's reactive
   * update cycle. The element automatically calls into any registered
   * controllers during its lifecycle callbacks.
   *
   * If the element is connected when `addController()` is called, the
   * controller's `hostConnected()` callback will be immediately called.
   * @category controllers
   */ addController(t) {
        var e;
        (this.__controllers ?? (this.__controllers = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((e = t.hostConnected) == null || e.call(t));
    }
    /**
   * Removes a `ReactiveController` from the element.
   * @category controllers
   */ removeController(t) {
        var e;
        (e = this.__controllers) == null || e.delete(t);
    }
    /**
   * Fixes any properties set on the instance before upgrade time.
   * Otherwise these would shadow the accessor and break these properties.
   * The properties are stored in a Map which is played back after the
   * constructor runs. Note, on very old versions of Safari (<=9) or Chrome
   * (<=41), properties created for native platform properties like (`id` or
   * `name`) may not have default values set in the element constructor. On
   * these browsers native properties appear on instances and therefore their
   * default value will overwrite any element default (e.g. if the element sets
   * this.id = 'id' in the constructor, the 'id' will become '' since this is
   * the native platform default).
   */ __saveInstanceProperties() {
        const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
        for (const n of e.keys())this.hasOwnProperty(n) && (t.set(n, this[n]), delete this[n]);
        t.size > 0 && (this.__instanceProperties = t);
    }
    /**
   * Returns the node into which the element should render and by default
   * creates and returns an open shadowRoot. Implement to customize where the
   * element's DOM is rendered. For example, to render into the element's
   * childNodes, return `this`.
   *
   * @return Returns a node into which to render.
   * @category rendering
   */ createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return $8bb98585ab5fb39f$var$wi(t, this.constructor.elementStyles), t;
    }
    /**
   * On first connection, creates the element's renderRoot, sets up
   * element styling, and enables updating.
   * @category lifecycle
   */ connectedCallback() {
        var t;
        this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this.__controllers) == null || t.forEach((e)=>{
            var n;
            return (n = e.hostConnected) == null ? void 0 : n.call(e);
        });
    }
    /**
   * Note, this method should be considered final and not overridden. It is
   * overridden on the element instance with a function that triggers the first
   * update.
   * @category updates
   */ enableUpdating(t) {}
    /**
   * Allows for `super.disconnectedCallback()` in extensions while
   * reserving the possibility of making non-breaking feature additions
   * when disconnecting at some point in the future.
   * @category lifecycle
   */ disconnectedCallback() {
        var t;
        (t = this.__controllers) == null || t.forEach((e)=>{
            var n;
            return (n = e.hostDisconnected) == null ? void 0 : n.call(e);
        });
    }
    /**
   * Synchronizes property values when attributes change.
   *
   * Specifically, when an attribute is set, the corresponding property is set.
   * You should rarely need to implement this callback. If this method is
   * overridden, `super.attributeChangedCallback(name, _old, value)` must be
   * called.
   *
   * See [using the lifecycle callbacks](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#using_the_lifecycle_callbacks)
   * on MDN for more information about the `attributeChangedCallback`.
   * @category attributes
   */ attributeChangedCallback(t, e, n) {
        this._$attributeToProperty(t, n);
    }
    __propertyToAttribute(t, e) {
        var s;
        const r = this.constructor.elementProperties.get(t), o = this.constructor.__attributeNameForProperty(t, r);
        if (o !== void 0 && r.reflect === !0) {
            const a = (((s = r.converter) == null ? void 0 : s.toAttribute) !== void 0 ? r.converter : $8bb98585ab5fb39f$var$$t).toAttribute(e, r.type);
            this.constructor.enabledWarnings.includes("migration") && a === void 0 && $8bb98585ab5fb39f$var$U("undefined-attribute-value", `The attribute value for the ${t} property is undefined on element ${this.localName}. The attribute will be removed, but in the previous version of \`ReactiveElement\`, the attribute would not have changed.`), this.__reflectingProperty = t, a == null ? this.removeAttribute(o) : this.setAttribute(o, a), this.__reflectingProperty = null;
        }
    }
    /** @internal */ _$attributeToProperty(t, e) {
        var o;
        const n = this.constructor, r = n.__attributeToPropertyMap.get(t);
        if (r !== void 0 && this.__reflectingProperty !== r) {
            const s = n.getPropertyOptions(r), d = typeof s.converter == "function" ? {
                fromAttribute: s.converter
            } : ((o = s.converter) == null ? void 0 : o.fromAttribute) !== void 0 ? s.converter : $8bb98585ab5fb39f$var$$t;
            this.__reflectingProperty = r, this[r] = d.fromAttribute(e, s.type), this.__reflectingProperty = null;
        }
    }
    /**
   * Requests an update which is processed asynchronously. This should be called
   * when an element should update based on some state not triggered by setting
   * a reactive property. In this case, pass no arguments. It should also be
   * called when manually implementing a property setter. In this case, pass the
   * property `name` and `oldValue` to ensure that any configured property
   * options are honored.
   *
   * @param name name of requesting property
   * @param oldValue old value of requesting property
   * @param options property options to use instead of the previously
   *     configured options
   * @category updates
   */ requestUpdate(t, e, n) {
        if (t !== void 0) {
            t instanceof Event && $8bb98585ab5fb39f$var$U("", "The requestUpdate() method was called with an Event as the property name. This is probably a mistake caused by binding this.requestUpdate as an event listener. Instead bind a function that will call it with no arguments: () => this.requestUpdate()"), n ?? (n = this.constructor.getPropertyOptions(t));
            const r = n.hasChanged ?? $8bb98585ab5fb39f$var$ce, o = this[t];
            if (r(o, e)) this._$changeProperty(t, e, n);
            else return;
        }
        this.isUpdatePending === !1 && (this.__updatePromise = this.__enqueueUpdate());
    }
    /**
   * @internal
   */ _$changeProperty(t, e, n) {
        this._$changedProperties.has(t) || this._$changedProperties.set(t, e), n.reflect === !0 && this.__reflectingProperty !== t && (this.__reflectingProperties ?? (this.__reflectingProperties = /* @__PURE__ */ new Set())).add(t);
    }
    /**
   * Sets up the element to asynchronously update.
   */ async __enqueueUpdate() {
        this.isUpdatePending = !0;
        try {
            await this.__updatePromise;
        } catch (e) {
            Promise.reject(e);
        }
        const t = this.scheduleUpdate();
        return t != null && await t, !this.isUpdatePending;
    }
    /**
   * Schedules an element update. You can override this method to change the
   * timing of updates by returning a Promise. The update will await the
   * returned Promise, and you should resolve the Promise to allow the update
   * to proceed. If this method is overridden, `super.scheduleUpdate()`
   * must be called.
   *
   * For instance, to schedule updates to occur just before the next frame:
   *
   * ```ts
   * override protected async scheduleUpdate(): Promise<unknown> {
   *   await new Promise((resolve) => requestAnimationFrame(() => resolve()));
   *   super.scheduleUpdate();
   * }
   * ```
   * @category updates
   */ scheduleUpdate() {
        const t = this.performUpdate();
        return this.constructor.enabledWarnings.includes("async-perform-update") && typeof (t == null ? void 0 : t.then) == "function" && $8bb98585ab5fb39f$var$U("async-perform-update", `Element ${this.localName} returned a Promise from performUpdate(). This behavior is deprecated and will be removed in a future version of ReactiveElement.`), t;
    }
    /**
   * Performs an element update. Note, if an exception is thrown during the
   * update, `firstUpdated` and `updated` will not be called.
   *
   * Call `performUpdate()` to immediately process a pending update. This should
   * generally not be needed, but it can be done in rare cases when you need to
   * update synchronously.
   *
   * @category updates
   */ performUpdate() {
        var n;
        if (!this.isUpdatePending) return;
        if ($8bb98585ab5fb39f$var$qt == null || $8bb98585ab5fb39f$var$qt({
            kind: "update"
        }), !this.hasUpdated) {
            this.renderRoot ?? (this.renderRoot = this.createRenderRoot());
            {
                const s = [
                    ...this.constructor.elementProperties.keys()
                ].filter((d)=>this.hasOwnProperty(d) && d in $8bb98585ab5fb39f$var$ke(this));
                if (s.length) throw new Error(`The following properties on element ${this.localName} will not trigger updates as expected because they are set using class fields: ${s.join(", ")}. Native class fields and some compiled output will overwrite accessors used for detecting changes. See https://lit.dev/msg/class-field-shadowing for more information.`);
            }
            if (this.__instanceProperties) {
                for (const [o, s] of this.__instanceProperties)this[o] = s;
                this.__instanceProperties = void 0;
            }
            const r = this.constructor.elementProperties;
            if (r.size > 0) for (const [o, s] of r)s.wrapped === !0 && !this._$changedProperties.has(o) && this[o] !== void 0 && this._$changeProperty(o, this[o], s);
        }
        let t = !1;
        const e = this._$changedProperties;
        try {
            t = this.shouldUpdate(e), t ? (this.willUpdate(e), (n = this.__controllers) == null || n.forEach((r)=>{
                var o;
                return (o = r.hostUpdate) == null ? void 0 : o.call(r);
            }), this.update(e)) : this.__markUpdated();
        } catch (r) {
            throw t = !1, this.__markUpdated(), r;
        }
        t && this._$didUpdate(e);
    }
    /**
   * Invoked before `update()` to compute values needed during the update.
   *
   * Implement `willUpdate` to compute property values that depend on other
   * properties and are used in the rest of the update process.
   *
   * ```ts
   * willUpdate(changedProperties) {
   *   // only need to check changed properties for an expensive computation.
   *   if (changedProperties.has('firstName') || changedProperties.has('lastName')) {
   *     this.sha = computeSHA(`${this.firstName} ${this.lastName}`);
   *   }
   * }
   *
   * render() {
   *   return html`SHA: ${this.sha}`;
   * }
   * ```
   *
   * @category updates
   */ willUpdate(t) {}
    // Note, this is an override point for polyfill-support.
    // @internal
    _$didUpdate(t) {
        var e;
        (e = this.__controllers) == null || e.forEach((n)=>{
            var r;
            return (r = n.hostUpdated) == null ? void 0 : r.call(n);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t), this.isUpdatePending && this.constructor.enabledWarnings.includes("change-in-update") && $8bb98585ab5fb39f$var$U("change-in-update", `Element ${this.localName} scheduled an update (generally because a property was set) after an update completed, causing a new update to be scheduled. This is inefficient and should be avoided unless the next update can only be scheduled as a side effect of the previous update.`);
    }
    __markUpdated() {
        this._$changedProperties = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
    }
    /**
   * Returns a Promise that resolves when the element has completed updating.
   * The Promise value is a boolean that is `true` if the element completed the
   * update without triggering another update. The Promise result is `false` if
   * a property was set inside `updated()`. If the Promise is rejected, an
   * exception was thrown during the update.
   *
   * To await additional asynchronous work, override the `getUpdateComplete`
   * method. For example, it is sometimes useful to await a rendered element
   * before fulfilling this Promise. To do this, first await
   * `super.getUpdateComplete()`, then any subsequent state.
   *
   * @return A promise of a boolean that resolves to true if the update completed
   *     without triggering another update.
   * @category updates
   */ get updateComplete() {
        return this.getUpdateComplete();
    }
    /**
   * Override point for the `updateComplete` promise.
   *
   * It is not safe to override the `updateComplete` getter directly due to a
   * limitation in TypeScript which means it is not possible to call a
   * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
   * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
   * This method should be overridden instead. For example:
   *
   * ```ts
   * class MyElement extends LitElement {
   *   override async getUpdateComplete() {
   *     const result = await super.getUpdateComplete();
   *     await this._myChild.updateComplete;
   *     return result;
   *   }
   * }
   * ```
   *
   * @return A promise of a boolean that resolves to true if the update completed
   *     without triggering another update.
   * @category updates
   */ getUpdateComplete() {
        return this.__updatePromise;
    }
    /**
   * Controls whether or not `update()` should be called when the element requests
   * an update. By default, this method always returns `true`, but this can be
   * customized to control when to update.
   *
   * @param _changedProperties Map of changed properties with old values
   * @category updates
   */ shouldUpdate(t) {
        return !0;
    }
    /**
   * Updates the element. This method reflects property values to attributes.
   * It can be overridden to render and keep updated element DOM.
   * Setting properties inside this method will *not* trigger
   * another update.
   *
   * @param _changedProperties Map of changed properties with old values
   * @category updates
   */ update(t) {
        this.__reflectingProperties && (this.__reflectingProperties = this.__reflectingProperties.forEach((e)=>this.__propertyToAttribute(e, this[e]))), this.__markUpdated();
    }
    /**
   * Invoked whenever the element is updated. Implement to perform
   * post-updating tasks via DOM APIs, for example, focusing an element.
   *
   * Setting properties inside this method will trigger the element to update
   * again after this update cycle completes.
   *
   * @param _changedProperties Map of changed properties with old values
   * @category updates
   */ updated(t) {}
    /**
   * Invoked when the element is first updated. Implement to perform one time
   * work on the element after update.
   *
   * ```ts
   * firstUpdated() {
   *   this.renderRoot.getElementById('my-text-area').focus();
   * }
   * ```
   *
   * Setting properties inside this method will trigger the element to update
   * again after this update cycle completes.
   *
   * @param _changedProperties Map of changed properties with old values
   * @category updates
   */ firstUpdated(t) {}
}
$8bb98585ab5fb39f$var$q.elementStyles = [];
$8bb98585ab5fb39f$var$q.shadowRootOptions = {
    mode: "open"
};
$8bb98585ab5fb39f$var$q[$8bb98585ab5fb39f$var$et("elementProperties")] = /* @__PURE__ */ new Map();
$8bb98585ab5fb39f$var$q[$8bb98585ab5fb39f$var$et("finalized")] = /* @__PURE__ */ new Map();
$8bb98585ab5fb39f$var$St == null || $8bb98585ab5fb39f$var$St({
    ReactiveElement: $8bb98585ab5fb39f$var$q
});
{
    $8bb98585ab5fb39f$var$q.enabledWarnings = [
        "change-in-update",
        "async-perform-update"
    ];
    const i = function(t) {
        t.hasOwnProperty($8bb98585ab5fb39f$var$et("enabledWarnings")) || (t.enabledWarnings = t.enabledWarnings.slice());
    };
    $8bb98585ab5fb39f$var$q.enableWarning = function(t) {
        i(this), this.enabledWarnings.includes(t) || this.enabledWarnings.push(t);
    }, $8bb98585ab5fb39f$var$q.disableWarning = function(t) {
        i(this);
        const e = this.enabledWarnings.indexOf(t);
        e >= 0 && this.enabledWarnings.splice(e, 1);
    };
}($8bb98585ab5fb39f$var$B.reactiveElementVersions ?? ($8bb98585ab5fb39f$var$B.reactiveElementVersions = [])).push("2.0.4");
$8bb98585ab5fb39f$var$B.reactiveElementVersions.length > 1 && $8bb98585ab5fb39f$var$U("multiple-versions", "Multiple versions of Lit loaded. Loading multiple versions is not recommended.");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bb98585ab5fb39f$var$M = globalThis, $8bb98585ab5fb39f$var$v = (i)=>{
    $8bb98585ab5fb39f$var$M.emitLitDebugLogEvents && $8bb98585ab5fb39f$var$M.dispatchEvent(new CustomEvent("lit-debug", {
        detail: i
    }));
};
let $8bb98585ab5fb39f$var$$i = 0, $8bb98585ab5fb39f$var$ft;
$8bb98585ab5fb39f$var$M.litIssuedWarnings ?? ($8bb98585ab5fb39f$var$M.litIssuedWarnings = /* @__PURE__ */ new Set()), $8bb98585ab5fb39f$var$ft = (i, t)=>{
    t += i ? ` See https://lit.dev/msg/${i} for more information.` : "", $8bb98585ab5fb39f$var$M.litIssuedWarnings.has(t) || (console.warn(t), $8bb98585ab5fb39f$var$M.litIssuedWarnings.add(t));
}, $8bb98585ab5fb39f$var$ft("dev-mode", "Lit is in dev mode. Not recommended for production!");
var $8bb98585ab5fb39f$var$De, $8bb98585ab5fb39f$var$Ve;
const $8bb98585ab5fb39f$var$L = ($8bb98585ab5fb39f$var$De = $8bb98585ab5fb39f$var$M.ShadyDOM) != null && $8bb98585ab5fb39f$var$De.inUse && (($8bb98585ab5fb39f$var$Ve = $8bb98585ab5fb39f$var$M.ShadyDOM) == null ? void 0 : $8bb98585ab5fb39f$var$Ve.noPatch) === !0 ? $8bb98585ab5fb39f$var$M.ShadyDOM.wrap : (i)=>i, $8bb98585ab5fb39f$var$xt = $8bb98585ab5fb39f$var$M.trustedTypes, $8bb98585ab5fb39f$var$$e = $8bb98585ab5fb39f$var$xt ? $8bb98585ab5fb39f$var$xt.createPolicy("lit-html", {
    createHTML: (i)=>i
}) : void 0, $8bb98585ab5fb39f$var$xi = (i)=>i, $8bb98585ab5fb39f$var$It = (i, t, e)=>$8bb98585ab5fb39f$var$xi, $8bb98585ab5fb39f$var$Ti = (i)=>{
    if ($8bb98585ab5fb39f$var$Z !== $8bb98585ab5fb39f$var$It) throw new Error("Attempted to overwrite existing lit-html security policy. setSanitizeDOMValueFactory should be called at most once.");
    $8bb98585ab5fb39f$var$Z = i;
}, $8bb98585ab5fb39f$var$Ai = ()=>{
    $8bb98585ab5fb39f$var$Z = $8bb98585ab5fb39f$var$It;
}, $8bb98585ab5fb39f$var$ee = (i, t, e)=>$8bb98585ab5fb39f$var$Z(i, t, e), $8bb98585ab5fb39f$var$je = "$lit$", $8bb98585ab5fb39f$var$F = `lit$${Math.random().toFixed(9).slice(2)}$`, $8bb98585ab5fb39f$var$He = "?" + $8bb98585ab5fb39f$var$F, $8bb98585ab5fb39f$var$Ni = `<${$8bb98585ab5fb39f$var$He}>`, $8bb98585ab5fb39f$var$G = document, $8bb98585ab5fb39f$var$gt = ()=>$8bb98585ab5fb39f$var$G.createComment(""), $8bb98585ab5fb39f$var$pt = (i)=>i === null || typeof i != "object" && typeof i != "function", $8bb98585ab5fb39f$var$ue = Array.isArray, $8bb98585ab5fb39f$var$Mi = (i)=>$8bb98585ab5fb39f$var$ue(i) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (i == null ? void 0 : i[Symbol.iterator]) == "function", $8bb98585ab5fb39f$var$jt = `[ 	
\f\r]`, $8bb98585ab5fb39f$var$Bi = `[^ 	
\f\r"'\`<>=]`, $8bb98585ab5fb39f$var$Ii = `[^\\s"'>=/]`, $8bb98585ab5fb39f$var$ct = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $8bb98585ab5fb39f$var$xe = 1, $8bb98585ab5fb39f$var$Ht = 2, $8bb98585ab5fb39f$var$Ri = 3, $8bb98585ab5fb39f$var$Te = /-->/g, $8bb98585ab5fb39f$var$Ae = />/g, $8bb98585ab5fb39f$var$K = new RegExp(`>|${$8bb98585ab5fb39f$var$jt}(?:(${$8bb98585ab5fb39f$var$Ii}+)(${$8bb98585ab5fb39f$var$jt}*=${$8bb98585ab5fb39f$var$jt}*(?:${$8bb98585ab5fb39f$var$Bi}|("|')|))|$)`, "g"), $8bb98585ab5fb39f$var$Li = 0, $8bb98585ab5fb39f$var$Ne = 1, $8bb98585ab5fb39f$var$Ui = 2, $8bb98585ab5fb39f$var$Me = 3, $8bb98585ab5fb39f$var$Wt = /'/g, $8bb98585ab5fb39f$var$Jt = /"/g, $8bb98585ab5fb39f$var$We = /^(?:script|style|textarea|title)$/i, $8bb98585ab5fb39f$var$Oi = 1, $8bb98585ab5fb39f$var$Tt = 2, $8bb98585ab5fb39f$var$ie = 3, $8bb98585ab5fb39f$var$he = 1, $8bb98585ab5fb39f$var$At = 2, $8bb98585ab5fb39f$var$zi = 3, $8bb98585ab5fb39f$var$Di = 4, $8bb98585ab5fb39f$var$Vi = 5, $8bb98585ab5fb39f$var$fe = 6, $8bb98585ab5fb39f$var$Fi = 7, $8bb98585ab5fb39f$var$Je = (i)=>(t, ...e)=>(t.some((n)=>n === void 0) && console.warn(`Some template strings are undefined.
This is probably caused by illegal octal escape sequences.`), e.some((n)=>n == null ? void 0 : n._$litStatic$) && $8bb98585ab5fb39f$var$ft("", `Static values 'literal' or 'unsafeStatic' cannot be used as values to non-static templates.
Please use the static 'html' tag function. See https://lit.dev/docs/templates/expressions/#static-expressions`), {
            // This property needs to remain unminified.
            _$litType$: i,
            strings: t,
            values: e
        }), $8bb98585ab5fb39f$var$z = $8bb98585ab5fb39f$var$Je($8bb98585ab5fb39f$var$Oi), $8bb98585ab5fb39f$var$Rt = $8bb98585ab5fb39f$var$Je($8bb98585ab5fb39f$var$Tt), $8bb98585ab5fb39f$var$Q = Symbol.for("lit-noChange"), $8bb98585ab5fb39f$var$P = Symbol.for("lit-nothing"), $8bb98585ab5fb39f$var$Be = /* @__PURE__ */ new WeakMap(), $8bb98585ab5fb39f$var$Y = $8bb98585ab5fb39f$var$G.createTreeWalker($8bb98585ab5fb39f$var$G, 129);
let $8bb98585ab5fb39f$var$Z = $8bb98585ab5fb39f$var$It;
function $8bb98585ab5fb39f$var$Ke(i, t) {
    if (!$8bb98585ab5fb39f$var$ue(i) || !i.hasOwnProperty("raw")) {
        let e = "invalid template strings array";
        throw e = `
          Internal Error: expected template strings to be an array
          with a 'raw' field. Faking a template strings array by
          calling html or svg like an ordinary function is effectively
          the same as calling unsafeHtml and can lead to major security
          issues, e.g. opening your code up to XSS attacks.
          If you're using the html or svg tagged template functions normally
          and still seeing this error, please file a bug at
          https://github.com/lit/lit/issues/new?template=bug_report.md
          and include information about your build tooling, if any.
        `.trim().replace(/\n */g, `
`), new Error(e);
    }
    return $8bb98585ab5fb39f$var$$e !== void 0 ? $8bb98585ab5fb39f$var$$e.createHTML(t) : t;
}
const $8bb98585ab5fb39f$var$qi = (i, t)=>{
    const e = i.length - 1, n = [];
    let r = t === $8bb98585ab5fb39f$var$Tt ? "<svg>" : t === $8bb98585ab5fb39f$var$ie ? "<math>" : "", o, s = $8bb98585ab5fb39f$var$ct;
    for(let a = 0; a < e; a++){
        const l = i[a];
        let c = -1, f, h = 0, u;
        for(; h < l.length && (s.lastIndex = h, u = s.exec(l), u !== null);)if (h = s.lastIndex, s === $8bb98585ab5fb39f$var$ct) {
            if (u[$8bb98585ab5fb39f$var$xe] === "!--") s = $8bb98585ab5fb39f$var$Te;
            else if (u[$8bb98585ab5fb39f$var$xe] !== void 0) s = $8bb98585ab5fb39f$var$Ae;
            else if (u[$8bb98585ab5fb39f$var$Ht] !== void 0) $8bb98585ab5fb39f$var$We.test(u[$8bb98585ab5fb39f$var$Ht]) && (o = new RegExp(`</${u[$8bb98585ab5fb39f$var$Ht]}`, "g")), s = $8bb98585ab5fb39f$var$K;
            else if (u[$8bb98585ab5fb39f$var$Ri] !== void 0) throw new Error("Bindings in tag names are not supported. Please use static templates instead. See https://lit.dev/docs/templates/expressions/#static-expressions");
        } else s === $8bb98585ab5fb39f$var$K ? u[$8bb98585ab5fb39f$var$Li] === ">" ? (s = o ?? $8bb98585ab5fb39f$var$ct, c = -1) : u[$8bb98585ab5fb39f$var$Ne] === void 0 ? c = -2 : (c = s.lastIndex - u[$8bb98585ab5fb39f$var$Ui].length, f = u[$8bb98585ab5fb39f$var$Ne], s = u[$8bb98585ab5fb39f$var$Me] === void 0 ? $8bb98585ab5fb39f$var$K : u[$8bb98585ab5fb39f$var$Me] === '"' ? $8bb98585ab5fb39f$var$Jt : $8bb98585ab5fb39f$var$Wt) : s === $8bb98585ab5fb39f$var$Jt || s === $8bb98585ab5fb39f$var$Wt ? s = $8bb98585ab5fb39f$var$K : s === $8bb98585ab5fb39f$var$Te || s === $8bb98585ab5fb39f$var$Ae ? s = $8bb98585ab5fb39f$var$ct : (s = $8bb98585ab5fb39f$var$K, o = void 0);
        console.assert(c === -1 || s === $8bb98585ab5fb39f$var$K || s === $8bb98585ab5fb39f$var$Wt || s === $8bb98585ab5fb39f$var$Jt, "unexpected parse state B");
        const m = s === $8bb98585ab5fb39f$var$K && i[a + 1].startsWith("/>") ? " " : "";
        r += s === $8bb98585ab5fb39f$var$ct ? l + $8bb98585ab5fb39f$var$Ni : c >= 0 ? (n.push(f), l.slice(0, c) + $8bb98585ab5fb39f$var$je + l.slice(c) + $8bb98585ab5fb39f$var$F + m) : l + $8bb98585ab5fb39f$var$F + (c === -2 ? a : m);
    }
    const d = r + (i[e] || "<?>") + (t === $8bb98585ab5fb39f$var$Tt ? "</svg>" : t === $8bb98585ab5fb39f$var$ie ? "</math>" : "");
    return [
        $8bb98585ab5fb39f$var$Ke(i, d),
        n
    ];
};
class $8bb98585ab5fb39f$var$mt {
    constructor({ strings: t, ["_$litType$"]: e }, n){
        this.parts = [];
        let r, o = 0, s = 0;
        const d = t.length - 1, a = this.parts, [l, c] = $8bb98585ab5fb39f$var$qi(t, e);
        if (this.el = $8bb98585ab5fb39f$var$mt.createElement(l, n), $8bb98585ab5fb39f$var$Y.currentNode = this.el.content, e === $8bb98585ab5fb39f$var$Tt || e === $8bb98585ab5fb39f$var$ie) {
            const f = this.el.content.firstChild;
            f.replaceWith(...f.childNodes);
        }
        for(; (r = $8bb98585ab5fb39f$var$Y.nextNode()) !== null && a.length < d;){
            if (r.nodeType === 1) {
                {
                    const f = r.localName;
                    if (/^(?:textarea|template)$/i.test(f) && r.innerHTML.includes($8bb98585ab5fb39f$var$F)) {
                        const h = `Expressions are not supported inside \`${f}\` elements. See https://lit.dev/msg/expression-in-${f} for more information.`;
                        if (f === "template") throw new Error(h);
                        $8bb98585ab5fb39f$var$ft("", h);
                    }
                }
                if (r.hasAttributes()) for (const f of r.getAttributeNames())if (f.endsWith($8bb98585ab5fb39f$var$je)) {
                    const h = c[s++], m = r.getAttribute(f).split($8bb98585ab5fb39f$var$F), y = /([.?@])?(.*)/.exec(h);
                    a.push({
                        type: $8bb98585ab5fb39f$var$he,
                        index: o,
                        name: y[2],
                        strings: m,
                        ctor: y[1] === "." ? $8bb98585ab5fb39f$var$Hi : y[1] === "?" ? $8bb98585ab5fb39f$var$Wi : y[1] === "@" ? $8bb98585ab5fb39f$var$Ji : $8bb98585ab5fb39f$var$Lt
                    }), r.removeAttribute(f);
                } else f.startsWith($8bb98585ab5fb39f$var$F) && (a.push({
                    type: $8bb98585ab5fb39f$var$fe,
                    index: o
                }), r.removeAttribute(f));
                if ($8bb98585ab5fb39f$var$We.test(r.tagName)) {
                    const f = r.textContent.split($8bb98585ab5fb39f$var$F), h = f.length - 1;
                    if (h > 0) {
                        r.textContent = $8bb98585ab5fb39f$var$xt ? $8bb98585ab5fb39f$var$xt.emptyScript : "";
                        for(let u = 0; u < h; u++)r.append(f[u], $8bb98585ab5fb39f$var$gt()), $8bb98585ab5fb39f$var$Y.nextNode(), a.push({
                            type: $8bb98585ab5fb39f$var$At,
                            index: ++o
                        });
                        r.append(f[h], $8bb98585ab5fb39f$var$gt());
                    }
                }
            } else if (r.nodeType === 8) {
                if (r.data === $8bb98585ab5fb39f$var$He) a.push({
                    type: $8bb98585ab5fb39f$var$At,
                    index: o
                });
                else {
                    let h = -1;
                    for(; (h = r.data.indexOf($8bb98585ab5fb39f$var$F, h + 1)) !== -1;)a.push({
                        type: $8bb98585ab5fb39f$var$Fi,
                        index: o
                    }), h += $8bb98585ab5fb39f$var$F.length - 1;
                }
            }
            o++;
        }
        if (c.length !== s) throw new Error('Detected duplicate attribute bindings. This occurs if your template has duplicate attributes on an element tag. For example "<input ?disabled=${true} ?disabled=${false}>" contains a duplicate "disabled" attribute. The error was detected in the following template: \n`' + t.join("${...}") + "`");
        $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "template prep",
            template: this,
            clonableTemplate: this.el,
            parts: this.parts,
            strings: t
        });
    }
    // Overridden via `litHtmlPolyfillSupport` to provide platform support.
    /** @nocollapse */ static createElement(t, e) {
        const n = $8bb98585ab5fb39f$var$G.createElement("template");
        return n.innerHTML = t, n;
    }
}
function $8bb98585ab5fb39f$var$it(i, t, e = i, n) {
    var s, d;
    if (t === $8bb98585ab5fb39f$var$Q) return t;
    let r = n !== void 0 ? (s = e.__directives) == null ? void 0 : s[n] : e.__directive;
    const o = $8bb98585ab5fb39f$var$pt(t) ? void 0 : // This property needs to remain unminified.
    t._$litDirective$;
    return (r == null ? void 0 : r.constructor) !== o && ((d = r == null ? void 0 : r._$notifyDirectiveConnectionChanged) == null || d.call(r, !1), o === void 0 ? r = void 0 : (r = new o(i), r._$initialize(i, e, n)), n !== void 0 ? (e.__directives ?? (e.__directives = []))[n] = r : e.__directive = r), r !== void 0 && (t = $8bb98585ab5fb39f$var$it(i, r._$resolve(i, t.values), r, n)), t;
}
class $8bb98585ab5fb39f$var$ji {
    constructor(t, e){
        this._$parts = [], this._$disconnectableChildren = void 0, this._$template = t, this._$parent = e;
    }
    // Called by ChildPart parentNode getter
    get parentNode() {
        return this._$parent.parentNode;
    }
    // See comment in Disconnectable interface for why this is a getter
    get _$isConnected() {
        return this._$parent._$isConnected;
    }
    // This method is separate from the constructor because we need to return a
    // DocumentFragment and we don't want to hold onto it with an instance field.
    _clone(t) {
        const { el: { content: e }, parts: n } = this._$template, r = ((t == null ? void 0 : t.creationScope) ?? $8bb98585ab5fb39f$var$G).importNode(e, !0);
        $8bb98585ab5fb39f$var$Y.currentNode = r;
        let o = $8bb98585ab5fb39f$var$Y.nextNode(), s = 0, d = 0, a = n[0];
        for(; a !== void 0;){
            if (s === a.index) {
                let l;
                a.type === $8bb98585ab5fb39f$var$At ? l = new $8bb98585ab5fb39f$var$yt(o, o.nextSibling, this, t) : a.type === $8bb98585ab5fb39f$var$he ? l = new a.ctor(o, a.name, a.strings, this, t) : a.type === $8bb98585ab5fb39f$var$fe && (l = new $8bb98585ab5fb39f$var$Ki(o, this, t)), this._$parts.push(l), a = n[++d];
            }
            s !== (a == null ? void 0 : a.index) && (o = $8bb98585ab5fb39f$var$Y.nextNode(), s++);
        }
        return $8bb98585ab5fb39f$var$Y.currentNode = $8bb98585ab5fb39f$var$G, r;
    }
    _update(t) {
        let e = 0;
        for (const n of this._$parts)n !== void 0 && ($8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "set part",
            part: n,
            value: t[e],
            valueIndex: e,
            values: t,
            templateInstance: this
        }), n.strings !== void 0 ? (n._$setValue(t, n, e), e += n.strings.length - 2) : n._$setValue(t[e])), e++;
    }
}
class $8bb98585ab5fb39f$var$yt {
    // See comment in Disconnectable interface for why this is a getter
    get _$isConnected() {
        var t;
        return ((t = this._$parent) == null ? void 0 : t._$isConnected) ?? this.__isConnected;
    }
    constructor(t, e, n, r){
        this.type = $8bb98585ab5fb39f$var$At, this._$committedValue = $8bb98585ab5fb39f$var$P, this._$disconnectableChildren = void 0, this._$startNode = t, this._$endNode = e, this._$parent = n, this.options = r, this.__isConnected = (r == null ? void 0 : r.isConnected) ?? !0, this._textSanitizer = void 0;
    }
    /**
   * The parent node into which the part renders its content.
   *
   * A ChildPart's content consists of a range of adjacent child nodes of
   * `.parentNode`, possibly bordered by 'marker nodes' (`.startNode` and
   * `.endNode`).
   *
   * - If both `.startNode` and `.endNode` are non-null, then the part's content
   * consists of all siblings between `.startNode` and `.endNode`, exclusively.
   *
   * - If `.startNode` is non-null but `.endNode` is null, then the part's
   * content consists of all siblings following `.startNode`, up to and
   * including the last child of `.parentNode`. If `.endNode` is non-null, then
   * `.startNode` will always be non-null.
   *
   * - If both `.endNode` and `.startNode` are null, then the part's content
   * consists of all child nodes of `.parentNode`.
   */ get parentNode() {
        let t = $8bb98585ab5fb39f$var$L(this._$startNode).parentNode;
        const e = this._$parent;
        return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
    }
    /**
   * The part's leading marker node, if any. See `.parentNode` for more
   * information.
   */ get startNode() {
        return this._$startNode;
    }
    /**
   * The part's trailing marker node, if any. See `.parentNode` for more
   * information.
   */ get endNode() {
        return this._$endNode;
    }
    _$setValue(t, e = this) {
        var n;
        if (this.parentNode === null) throw new Error("This `ChildPart` has no `parentNode` and therefore cannot accept a value. This likely means the element containing the part was manipulated in an unsupported way outside of Lit's control such that the part's marker nodes were ejected from DOM. For example, setting the element's `innerHTML` or `textContent` can do this.");
        if (t = $8bb98585ab5fb39f$var$it(this, t, e), $8bb98585ab5fb39f$var$pt(t)) t === $8bb98585ab5fb39f$var$P || t == null || t === "" ? (this._$committedValue !== $8bb98585ab5fb39f$var$P && ($8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "commit nothing to child",
            start: this._$startNode,
            end: this._$endNode,
            parent: this._$parent,
            options: this.options
        }), this._$clear()), this._$committedValue = $8bb98585ab5fb39f$var$P) : t !== this._$committedValue && t !== $8bb98585ab5fb39f$var$Q && this._commitText(t);
        else if (t._$litType$ !== void 0) this._commitTemplateResult(t);
        else if (t.nodeType !== void 0) {
            if (((n = this.options) == null ? void 0 : n.host) === t) {
                this._commitText("[probable mistake: rendered a template's host in itself (commonly caused by writing ${this} in a template]"), console.warn("Attempted to render the template host", t, "inside itself. This is almost always a mistake, and in dev mode ", "we render some warning text. In production however, we'll ", "render it, which will usually result in an error, and sometimes ", "in the element disappearing from the DOM.");
                return;
            }
            this._commitNode(t);
        } else $8bb98585ab5fb39f$var$Mi(t) ? this._commitIterable(t) : this._commitText(t);
    }
    _insert(t) {
        return $8bb98585ab5fb39f$var$L($8bb98585ab5fb39f$var$L(this._$startNode).parentNode).insertBefore(t, this._$endNode);
    }
    _commitNode(t) {
        var e;
        if (this._$committedValue !== t) {
            if (this._$clear(), $8bb98585ab5fb39f$var$Z !== $8bb98585ab5fb39f$var$It) {
                const n = (e = this._$startNode.parentNode) == null ? void 0 : e.nodeName;
                if (n === "STYLE" || n === "SCRIPT") {
                    let r = "Forbidden";
                    throw n === "STYLE" ? r = "Lit does not support binding inside style nodes. This is a security risk, as style injection attacks can exfiltrate data and spoof UIs. Consider instead using css`...` literals to compose styles, and do dynamic styling with css custom properties, ::parts, <slot>s, and by mutating the DOM rather than stylesheets." : r = "Lit does not support binding inside script nodes. This is a security risk, as it could allow arbitrary code execution.", new Error(r);
                }
            }
            $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
                kind: "commit node",
                start: this._$startNode,
                parent: this._$parent,
                value: t,
                options: this.options
            }), this._$committedValue = this._insert(t);
        }
    }
    _commitText(t) {
        if (this._$committedValue !== $8bb98585ab5fb39f$var$P && $8bb98585ab5fb39f$var$pt(this._$committedValue)) {
            const e = $8bb98585ab5fb39f$var$L(this._$startNode).nextSibling;
            this._textSanitizer === void 0 && (this._textSanitizer = $8bb98585ab5fb39f$var$ee(e, "data", "property")), t = this._textSanitizer(t), $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
                kind: "commit text",
                node: e,
                value: t,
                options: this.options
            }), e.data = t;
        } else {
            const e = $8bb98585ab5fb39f$var$G.createTextNode("");
            this._commitNode(e), this._textSanitizer === void 0 && (this._textSanitizer = $8bb98585ab5fb39f$var$ee(e, "data", "property")), t = this._textSanitizer(t), $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
                kind: "commit text",
                node: e,
                value: t,
                options: this.options
            }), e.data = t;
        }
        this._$committedValue = t;
    }
    _commitTemplateResult(t) {
        var o;
        const { values: e, ["_$litType$"]: n } = t, r = typeof n == "number" ? this._$getTemplate(t) : (n.el === void 0 && (n.el = $8bb98585ab5fb39f$var$mt.createElement($8bb98585ab5fb39f$var$Ke(n.h, n.h[0]), this.options)), n);
        if (((o = this._$committedValue) == null ? void 0 : o._$template) === r) $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "template updating",
            template: r,
            instance: this._$committedValue,
            parts: this._$committedValue._$parts,
            options: this.options,
            values: e
        }), this._$committedValue._update(e);
        else {
            const s = new $8bb98585ab5fb39f$var$ji(r, this), d = s._clone(this.options);
            $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
                kind: "template instantiated",
                template: r,
                instance: s,
                parts: s._$parts,
                options: this.options,
                fragment: d,
                values: e
            }), s._update(e), $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
                kind: "template instantiated and updated",
                template: r,
                instance: s,
                parts: s._$parts,
                options: this.options,
                fragment: d,
                values: e
            }), this._commitNode(d), this._$committedValue = s;
        }
    }
    // Overridden via `litHtmlPolyfillSupport` to provide platform support.
    /** @internal */ _$getTemplate(t) {
        let e = $8bb98585ab5fb39f$var$Be.get(t.strings);
        return e === void 0 && $8bb98585ab5fb39f$var$Be.set(t.strings, e = new $8bb98585ab5fb39f$var$mt(t)), e;
    }
    _commitIterable(t) {
        $8bb98585ab5fb39f$var$ue(this._$committedValue) || (this._$committedValue = [], this._$clear());
        const e = this._$committedValue;
        let n = 0, r;
        for (const o of t)n === e.length ? e.push(r = new $8bb98585ab5fb39f$var$yt(this._insert($8bb98585ab5fb39f$var$gt()), this._insert($8bb98585ab5fb39f$var$gt()), this, this.options)) : r = e[n], r._$setValue(o), n++;
        n < e.length && (this._$clear(r && $8bb98585ab5fb39f$var$L(r._$endNode).nextSibling, n), e.length = n);
    }
    /**
   * Removes the nodes contained within this Part from the DOM.
   *
   * @param start Start node to clear from, for clearing a subset of the part's
   *     DOM (used when truncating iterables)
   * @param from  When `start` is specified, the index within the iterable from
   *     which ChildParts are being removed, used for disconnecting directives in
   *     those Parts.
   *
   * @internal
   */ _$clear(t = $8bb98585ab5fb39f$var$L(this._$startNode).nextSibling, e) {
        var n;
        for((n = this._$notifyConnectionChanged) == null || n.call(this, !1, !0, e); t && t !== this._$endNode;){
            const r = $8bb98585ab5fb39f$var$L(t).nextSibling;
            $8bb98585ab5fb39f$var$L(t).remove(), t = r;
        }
    }
    /**
   * Implementation of RootPart's `isConnected`. Note that this method
   * should only be called on `RootPart`s (the `ChildPart` returned from a
   * top-level `render()` call). It has no effect on non-root ChildParts.
   * @param isConnected Whether to set
   * @internal
   */ setConnected(t) {
        var e;
        if (this._$parent === void 0) this.__isConnected = t, (e = this._$notifyConnectionChanged) == null || e.call(this, t);
        else throw new Error("part.setConnected() may only be called on a RootPart returned from render().");
    }
}
class $8bb98585ab5fb39f$var$Lt {
    get tagName() {
        return this.element.tagName;
    }
    // See comment in Disconnectable interface for why this is a getter
    get _$isConnected() {
        return this._$parent._$isConnected;
    }
    constructor(t, e, n, r, o){
        this.type = $8bb98585ab5fb39f$var$he, this._$committedValue = $8bb98585ab5fb39f$var$P, this._$disconnectableChildren = void 0, this.element = t, this.name = e, this._$parent = r, this.options = o, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$committedValue = new Array(n.length - 1).fill(new String()), this.strings = n) : this._$committedValue = $8bb98585ab5fb39f$var$P, this._sanitizer = void 0;
    }
    /**
   * Sets the value of this part by resolving the value from possibly multiple
   * values and static strings and committing it to the DOM.
   * If this part is single-valued, `this._strings` will be undefined, and the
   * method will be called with a single value argument. If this part is
   * multi-value, `this._strings` will be defined, and the method is called
   * with the value array of the part's owning TemplateInstance, and an offset
   * into the value array from which the values should be read.
   * This method is overloaded this way to eliminate short-lived array slices
   * of the template instance values, and allow a fast-path for single-valued
   * parts.
   *
   * @param value The part value, or an array of values for multi-valued parts
   * @param valueIndex the index to start reading values from. `undefined` for
   *   single-valued parts
   * @param noCommit causes the part to not commit its value to the DOM. Used
   *   in hydration to prime attribute parts with their first-rendered value,
   *   but not set the attribute, and in SSR to no-op the DOM operation and
   *   capture the value for serialization.
   *
   * @internal
   */ _$setValue(t, e = this, n, r) {
        const o = this.strings;
        let s = !1;
        if (o === void 0) t = $8bb98585ab5fb39f$var$it(this, t, e, 0), s = !$8bb98585ab5fb39f$var$pt(t) || t !== this._$committedValue && t !== $8bb98585ab5fb39f$var$Q, s && (this._$committedValue = t);
        else {
            const d = t;
            t = o[0];
            let a, l;
            for(a = 0; a < o.length - 1; a++)l = $8bb98585ab5fb39f$var$it(this, d[n + a], e, a), l === $8bb98585ab5fb39f$var$Q && (l = this._$committedValue[a]), s || (s = !$8bb98585ab5fb39f$var$pt(l) || l !== this._$committedValue[a]), l === $8bb98585ab5fb39f$var$P ? t = $8bb98585ab5fb39f$var$P : t !== $8bb98585ab5fb39f$var$P && (t += (l ?? "") + o[a + 1]), this._$committedValue[a] = l;
        }
        s && !r && this._commitValue(t);
    }
    /** @internal */ _commitValue(t) {
        t === $8bb98585ab5fb39f$var$P ? $8bb98585ab5fb39f$var$L(this.element).removeAttribute(this.name) : (this._sanitizer === void 0 && (this._sanitizer = $8bb98585ab5fb39f$var$Z(this.element, this.name, "attribute")), t = this._sanitizer(t ?? ""), $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "commit attribute",
            element: this.element,
            name: this.name,
            value: t,
            options: this.options
        }), $8bb98585ab5fb39f$var$L(this.element).setAttribute(this.name, t ?? ""));
    }
}
class $8bb98585ab5fb39f$var$Hi extends $8bb98585ab5fb39f$var$Lt {
    constructor(){
        super(...arguments), this.type = $8bb98585ab5fb39f$var$zi;
    }
    /** @internal */ _commitValue(t) {
        this._sanitizer === void 0 && (this._sanitizer = $8bb98585ab5fb39f$var$Z(this.element, this.name, "property")), t = this._sanitizer(t), $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "commit property",
            element: this.element,
            name: this.name,
            value: t,
            options: this.options
        }), this.element[this.name] = t === $8bb98585ab5fb39f$var$P ? void 0 : t;
    }
}
class $8bb98585ab5fb39f$var$Wi extends $8bb98585ab5fb39f$var$Lt {
    constructor(){
        super(...arguments), this.type = $8bb98585ab5fb39f$var$Di;
    }
    /** @internal */ _commitValue(t) {
        $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "commit boolean attribute",
            element: this.element,
            name: this.name,
            value: !!(t && t !== $8bb98585ab5fb39f$var$P),
            options: this.options
        }), $8bb98585ab5fb39f$var$L(this.element).toggleAttribute(this.name, !!t && t !== $8bb98585ab5fb39f$var$P);
    }
}
class $8bb98585ab5fb39f$var$Ji extends $8bb98585ab5fb39f$var$Lt {
    constructor(t, e, n, r, o){
        if (super(t, e, n, r, o), this.type = $8bb98585ab5fb39f$var$Vi, this.strings !== void 0) throw new Error(`A \`<${t.localName}>\` has a \`@${e}=...\` listener with invalid content. Event listeners in templates must have exactly one expression and no surrounding text.`);
    }
    // EventPart does not use the base _$setValue/_resolveValue implementation
    // since the dirty checking is more complex
    /** @internal */ _$setValue(t, e = this) {
        if (t = $8bb98585ab5fb39f$var$it(this, t, e, 0) ?? $8bb98585ab5fb39f$var$P, t === $8bb98585ab5fb39f$var$Q) return;
        const n = this._$committedValue, r = t === $8bb98585ab5fb39f$var$P && n !== $8bb98585ab5fb39f$var$P || t.capture !== n.capture || t.once !== n.once || t.passive !== n.passive, o = t !== $8bb98585ab5fb39f$var$P && (n === $8bb98585ab5fb39f$var$P || r);
        $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "commit event listener",
            element: this.element,
            name: this.name,
            value: t,
            options: this.options,
            removeListener: r,
            addListener: o,
            oldListener: n
        }), r && this.element.removeEventListener(this.name, this, n), o && this.element.addEventListener(this.name, this, t), this._$committedValue = t;
    }
    handleEvent(t) {
        var e;
        typeof this._$committedValue == "function" ? this._$committedValue.call(((e = this.options) == null ? void 0 : e.host) ?? this.element, t) : this._$committedValue.handleEvent(t);
    }
}
class $8bb98585ab5fb39f$var$Ki {
    constructor(t, e, n){
        this.element = t, this.type = $8bb98585ab5fb39f$var$fe, this._$disconnectableChildren = void 0, this._$parent = e, this.options = n;
    }
    // See comment in Disconnectable interface for why this is a getter
    get _$isConnected() {
        return this._$parent._$isConnected;
    }
    _$setValue(t) {
        $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
            kind: "commit to element binding",
            element: this.element,
            value: t,
            options: this.options
        }), $8bb98585ab5fb39f$var$it(this, t);
    }
}
const $8bb98585ab5fb39f$var$Kt = $8bb98585ab5fb39f$var$M.litHtmlPolyfillSupportDevMode;
$8bb98585ab5fb39f$var$Kt == null || $8bb98585ab5fb39f$var$Kt($8bb98585ab5fb39f$var$mt, $8bb98585ab5fb39f$var$yt);
($8bb98585ab5fb39f$var$M.litHtmlVersions ?? ($8bb98585ab5fb39f$var$M.litHtmlVersions = [])).push("3.2.0");
$8bb98585ab5fb39f$var$M.litHtmlVersions.length > 1 && $8bb98585ab5fb39f$var$ft("multiple-versions", "Multiple versions of Lit loaded. Loading multiple versions is not recommended.");
const $8bb98585ab5fb39f$var$Pt = (i, t, e)=>{
    if (t == null) throw new TypeError(`The container to render into may not be ${t}`);
    const n = $8bb98585ab5fb39f$var$$i++, r = (e == null ? void 0 : e.renderBefore) ?? t;
    let o = r._$litPart$;
    if ($8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
        kind: "begin render",
        id: n,
        value: i,
        container: t,
        options: e,
        part: o
    }), o === void 0) {
        const s = (e == null ? void 0 : e.renderBefore) ?? null;
        r._$litPart$ = o = new $8bb98585ab5fb39f$var$yt(t.insertBefore($8bb98585ab5fb39f$var$gt(), s), s, void 0, e ?? {});
    }
    return o._$setValue(i), $8bb98585ab5fb39f$var$v && $8bb98585ab5fb39f$var$v({
        kind: "end render",
        id: n,
        value: i,
        container: t,
        options: e,
        part: o
    }), o;
};
$8bb98585ab5fb39f$var$Pt.setSanitizer = $8bb98585ab5fb39f$var$Ti, $8bb98585ab5fb39f$var$Pt.createSanitizer = $8bb98585ab5fb39f$var$ee, $8bb98585ab5fb39f$var$Pt._testOnlyClearSanitizerFactoryDoNotCallOrElse = $8bb98585ab5fb39f$var$Ai;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bb98585ab5fb39f$var$Yi = (i, t)=>i;
let $8bb98585ab5fb39f$var$Ye;
{
    const i = globalThis.litIssuedWarnings ?? (globalThis.litIssuedWarnings = /* @__PURE__ */ new Set());
    $8bb98585ab5fb39f$var$Ye = (t, e)=>{
        e += ` See https://lit.dev/msg/${t} for more information.`, i.has(e) || (console.warn(e), i.add(e));
    };
}class $8bb98585ab5fb39f$var$W extends $8bb98585ab5fb39f$var$q {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.__childPart = void 0;
    }
    /**
   * @category rendering
   */ createRenderRoot() {
        var e;
        const t = super.createRenderRoot();
        return (e = this.renderOptions).renderBefore ?? (e.renderBefore = t.firstChild), t;
    }
    /**
   * Updates the element. This method reflects property values to attributes
   * and calls `render` to render DOM via lit-html. Setting properties inside
   * this method will *not* trigger another update.
   * @param changedProperties Map of changed properties with old values
   * @category updates
   */ update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.__childPart = $8bb98585ab5fb39f$var$Pt(e, this.renderRoot, this.renderOptions);
    }
    /**
   * Invoked when the component is added to the document's DOM.
   *
   * In `connectedCallback()` you should setup tasks that should only occur when
   * the element is connected to the document. The most common of these is
   * adding event listeners to nodes external to the element, like a keydown
   * event handler added to the window.
   *
   * ```ts
   * connectedCallback() {
   *   super.connectedCallback();
   *   addEventListener('keydown', this._handleKeydown);
   * }
   * ```
   *
   * Typically, anything done in `connectedCallback()` should be undone when the
   * element is disconnected, in `disconnectedCallback()`.
   *
   * @category lifecycle
   */ connectedCallback() {
        var t;
        super.connectedCallback(), (t = this.__childPart) == null || t.setConnected(!0);
    }
    /**
   * Invoked when the component is removed from the document's DOM.
   *
   * This callback is the main signal to the element that it may no longer be
   * used. `disconnectedCallback()` should ensure that nothing is holding a
   * reference to the element (such as event listeners added to nodes external
   * to the element), so that it is free to be garbage collected.
   *
   * ```ts
   * disconnectedCallback() {
   *   super.disconnectedCallback();
   *   window.removeEventListener('keydown', this._handleKeydown);
   * }
   * ```
   *
   * An element may be re-connected after being disconnected.
   *
   * @category lifecycle
   */ disconnectedCallback() {
        var t;
        super.disconnectedCallback(), (t = this.__childPart) == null || t.setConnected(!1);
    }
    /**
   * Invoked on each update to perform rendering tasks. This method may return
   * any value renderable by lit-html's `ChildPart` - typically a
   * `TemplateResult`. Setting properties inside this method will *not* trigger
   * the element to update.
   * @category rendering
   */ render() {
        return $8bb98585ab5fb39f$var$Q;
    }
}
$8bb98585ab5fb39f$var$W._$litElement$ = !0;
$8bb98585ab5fb39f$var$W[$8bb98585ab5fb39f$var$Yi("finalized")] = !0;
var $8bb98585ab5fb39f$var$Fe;
($8bb98585ab5fb39f$var$Fe = globalThis.litElementHydrateSupport) == null || $8bb98585ab5fb39f$var$Fe.call(globalThis, {
    LitElement: $8bb98585ab5fb39f$var$W
});
const $8bb98585ab5fb39f$var$Yt = globalThis.litElementPolyfillSupportDevMode;
$8bb98585ab5fb39f$var$Yt == null || $8bb98585ab5fb39f$var$Yt({
    LitElement: $8bb98585ab5fb39f$var$W
});
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
globalThis.litElementVersions.length > 1 && $8bb98585ab5fb39f$var$Ye("multiple-versions", "Multiple versions of Lit loaded. Loading multiple versions is not recommended.");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bb98585ab5fb39f$var$Ut = (i)=>(t, e)=>{
        e !== void 0 ? e.addInitializer(()=>{
            customElements.define(i, t);
        }) : customElements.define(i, t);
    };
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $8bb98585ab5fb39f$var$Ge;
{
    const i = globalThis.litIssuedWarnings ?? (globalThis.litIssuedWarnings = /* @__PURE__ */ new Set());
    $8bb98585ab5fb39f$var$Ge = (t, e)=>{
        e += ` See https://lit.dev/msg/${t} for more information.`, i.has(e) || (console.warn(e), i.add(e));
    };
}const $8bb98585ab5fb39f$var$Gi = (i, t, e)=>{
    const n = t.hasOwnProperty(e);
    return t.constructor.createProperty(e, n ? {
        ...i,
        wrapped: !0
    } : i), n ? Object.getOwnPropertyDescriptor(t, e) : void 0;
}, $8bb98585ab5fb39f$var$Qi = {
    attribute: !0,
    type: String,
    converter: $8bb98585ab5fb39f$var$$t,
    reflect: !1,
    hasChanged: $8bb98585ab5fb39f$var$ce
}, $8bb98585ab5fb39f$var$Zi = (i = $8bb98585ab5fb39f$var$Qi, t, e)=>{
    const { kind: n, metadata: r } = e;
    r == null && $8bb98585ab5fb39f$var$Ge("missing-class-metadata", `The class ${t} is missing decorator metadata. This could mean that you're using a compiler that supports decorators but doesn't support decorator metadata, such as TypeScript 5.1. Please update your compiler.`);
    let o = globalThis.litPropertyMetadata.get(r);
    if (o === void 0 && globalThis.litPropertyMetadata.set(r, o = /* @__PURE__ */ new Map()), o.set(e.name, i), n === "accessor") {
        const { name: s } = e;
        return {
            set (d) {
                const a = t.get.call(this);
                t.set.call(this, d), this.requestUpdate(s, a, i);
            },
            init (d) {
                return d !== void 0 && this._$changeProperty(s, void 0, i), d;
            }
        };
    } else if (n === "setter") {
        const { name: s } = e;
        return function(d) {
            const a = this[s];
            t.call(this, d), this.requestUpdate(s, a, i);
        };
    }
    throw new Error(`Unsupported decorator location: ${n}`);
};
function $8bb98585ab5fb39f$var$_(i) {
    return (t, e)=>typeof e == "object" ? $8bb98585ab5fb39f$var$Zi(i, t, e) : $8bb98585ab5fb39f$var$Gi(i, t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8bb98585ab5fb39f$var$dt(i) {
    return $8bb98585ab5fb39f$var$_({
        ...i,
        // Add both `state` and `attribute` because we found a third party
        // controller that is keying off of PropertyOptions.state to determine
        // whether a field is a private internal property or not.
        state: !0,
        attribute: !1
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bb98585ab5fb39f$var$Xi = (i, t, e)=>(e.configurable = !0, e.enumerable = !0, // is applied via lazy loading some Angular code.
    Reflect.decorate && typeof t != "object" && Object.defineProperty(i, t, e), e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $8bb98585ab5fb39f$var$Qe;
{
    const i = globalThis.litIssuedWarnings ?? (globalThis.litIssuedWarnings = /* @__PURE__ */ new Set());
    $8bb98585ab5fb39f$var$Qe = (t, e)=>{
        e += t ? ` See https://lit.dev/msg/${t} for more information.` : "", i.has(e) || (console.warn(e), i.add(e));
    };
}function $8bb98585ab5fb39f$var$Ze(i, t) {
    return (e, n, r)=>{
        const o = (s)=>{
            var a;
            const d = ((a = s.renderRoot) == null ? void 0 : a.querySelector(i)) ?? null;
            if (d === null && t && !s.hasUpdated) {
                const l = typeof n == "object" ? n.name : n;
                $8bb98585ab5fb39f$var$Qe("", `@query'd field ${JSON.stringify(String(l))} with the 'cache' flag set for selector '${i}' has been accessed before the first update and returned null. This is expected if the renderRoot tree has not been provided beforehand (e.g. via Declarative Shadow DOM). Therefore the value hasn't been cached.`);
            }
            return d;
        };
        return $8bb98585ab5fb39f$var$Xi(e, n, {
            get () {
                return o(this);
            }
        });
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bb98585ab5fb39f$var$tn = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $8bb98585ab5fb39f$var$en = (i)=>(...t)=>({
            // This property needs to remain unminified.
            _$litDirective$: i,
            values: t
        });
class $8bb98585ab5fb39f$var$nn {
    constructor(t){}
    // See comment in Disconnectable interface for why this is a getter
    get _$isConnected() {
        return this._$parent._$isConnected;
    }
    /** @internal */ _$initialize(t, e, n) {
        this.__part = t, this._$parent = e, this.__attributeIndex = n;
    }
    /** @internal */ _$resolve(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $8bb98585ab5fb39f$var$rn extends $8bb98585ab5fb39f$var$nn {
    constructor(t){
        var e;
        if (super(t), t.type !== $8bb98585ab5fb39f$var$tn.ATTRIBUTE || t.name !== "class" || ((e = t.strings) == null ? void 0 : e.length) > 2) throw new Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((e)=>t[e]).join(" ") + " ";
    }
    update(t, [e]) {
        var r, o;
        if (this._previousClasses === void 0) {
            this._previousClasses = /* @__PURE__ */ new Set(), t.strings !== void 0 && (this._staticClasses = new Set(t.strings.join(" ").split(/\s/).filter((s)=>s !== "")));
            for(const s in e)e[s] && !((r = this._staticClasses) != null && r.has(s)) && this._previousClasses.add(s);
            return this.render(e);
        }
        const n = t.element.classList;
        for (const s of this._previousClasses)s in e || (n.remove(s), this._previousClasses.delete(s));
        for(const s in e){
            const d = !!e[s];
            d !== this._previousClasses.has(s) && !((o = this._staticClasses) != null && o.has(s)) && (d ? (n.add(s), this._previousClasses.add(s)) : (n.remove(s), this._previousClasses.delete(s)));
        }
        return $8bb98585ab5fb39f$var$Q;
    }
}
const $8bb98585ab5fb39f$var$Xe = $8bb98585ab5fb39f$var$en($8bb98585ab5fb39f$var$rn), $8bb98585ab5fb39f$export$a460168851755bfd = "close", $8bb98585ab5fb39f$var$on = $8bb98585ab5fb39f$var$Rt`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M19.645 4.367a1.209 1.209 0 0 0-1.711 0L12 10.29 6.066 4.355a1.208 1.208 0 0 0-1.711 0 1.208 1.208 0 0 0 0 1.711L10.289 12l-5.934 5.934a1.209 1.209 0 0 0 0 1.711 1.209 1.209 0 0 0 1.711 0L12 13.711l5.934 5.934a1.209 1.209 0 0 0 1.711 0 1.209 1.209 0 0 0 0-1.711L13.711 12l5.934-5.934a1.216 1.216 0 0 0 0-1.699Z"/>
  </svg>
`, $8bb98585ab5fb39f$var$sn = $8bb98585ab5fb39f$var$Bt`
    :host {
        --default-dialog-overlay: rgba(0, 0, 0, 0.8);
        --default-dialog-z-index: 1000;
        --default-dialog-width: 400px;
        --default-dialog-height: 430px;
        --default-dialog-bg: #ffffff;
        --default-dialog-header-color: #0B522E;
        --default-dialog-header-height: 52px;
        --default-dialog-header-logo-width: 144px;
        --default-dialog-header-logo-height: 30px;
        --default-dialog-header-logo-margin: auto;
        --default-dialog-header-close-fill: #e7e7e7;
        --default-dialog-header-close-width: 24px;
        --default-dialog-header-close-height: 24px;
        --default-dialog-header-close-top: 14px;
        --default-dialog-header-close-right: 24px;
        --default-dialog-header-close-transition: fill 0.2s ease-in-out;
        --default-dialog-header-close-hover-transform: none;
        --default-dialog-header-close-hover-fill: #ffffff;
        --default-dialog-background: #ffffff;
        --default-dialog-padding: 20px 32px;
        --default-dialog-content-margin: 0 0 24px;
    }
    .wrapper {
        display: flex;
        position: fixed;
        justify-content: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: scroll;
        z-index: var(--dialog-z-index, var(--default-dialog-z-index));
        background: var(--dialog-overlay, var(--default-dialog-overlay));
    }
    .dialog {
        width: var(--dialog-width, var(--default-dialog-width));
        display: flex;
        flex-direction: column;
        margin: auto 0;
        background-color: var(--dialog-bg, var(--default-dialog-bg));
    }
    .header {
        min-height: var(--dialog-header-height, var(--default-dialog-header-height));
        background-color: var(--dialog-header-color, var(--default-dialog-header-color));
        display: flex;
        justify-content: center;
        align-content: center;
        position: relative;
    }
    .header-logo {
        width: var(--dialog-header-logo-width, var(--default-dialog-header-logo-width));
        height: var(--dialog-header-logo-height, var(--default-dialog-header-logo-height));
        margin: var(--dialog-header-logo-margin, var(--default-dialog-header-logo-margin));
    }
    .close {
        position: absolute;
        cursor: pointer;
        width: var( --dialog-header-close-width, var( --default-dialog-header-close-width));
        height: var(--dialog-header-close-height, var(--default-dialog-header-close-height));
        top: var(--dialog-header-close-top, var(--default-dialog-header-close-top));
        right: var(--dialog-header-close-right, var(--default-dialog-header-close-right));
    }
    .close svg {
        fill: var(--dialog-header-close-fill, var(--default-dialog-header-close-fill));
        transition: var(--dialog-header-close-transition, var(--default-dialog-header-close-transition));
    }
    .close:hover svg {
        transform: var(--dialog-header-close-hover-transform, var(--default-dialog-header-close-hover-transform));
        fill: var(--dialog-header-close-hover-fill, var(--default-dialog-header-close-hover-fill));
    }
    .main {
        min-height: var(--dialog-height, var(--default-dialog-height));
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-grow: 1;
        text-align: center;
        padding: var(--dialog-padding, var(--default-dialog-padding));
        background-color: var(--dialog-background, var(--default-dialog-background));
    }
    .wrap {
        display: flex;
        flex-grow: 1;
    }
    .content {
        margin: var(--dialog-content-margin, var(--default-dialog-content-margin));
    }
    @media (max-width: 540px) {
        .wrapper {
            background-color: #ffffff;
        }
        .dialog {
            width: 100%;
            height: 100%;
            justify-content: space-between;
        }
    }
    @media (max-width: 1024px) and (orientation: landscape) {
        .wrapper {
            padding: 10px 0;
        }
    }
`, $8bb98585ab5fb39f$var$ge = $8bb98585ab5fb39f$var$Bt`
    @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300..900&display=swap');
    
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Rubik', sans-serif;
    }
    button {
        cursor: pointer;
        border: none;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
    }
    a {
        text-decoration: none;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
    }
`, $8bb98585ab5fb39f$export$eac3055710931ba4 = {
    ShowRegistration: "showregistration",
    SuccessLogin: "successlogin",
    DialogOpen: "dialogopen",
    DialogClosed: "dialogclosed",
    AuthFailed: "authfailed",
    SomethingWentWrong: "somethingwentwrong",
    InvalidParams: "invalidparams",
    UnknownError: "unknownerror",
    AccountNotFound: "accountnotfound",
    AccountFrozen: "accountfrozen",
    IdentNotFound: "identnotfound",
    NeedFieldsFill: "needfieldsfill",
    BankIdUnavailable: "bankidunavailable",
    NetworkError: "networkerror",
    AuthError: "autherror"
}, $8bb98585ab5fb39f$export$d73ee8ef04f5226a = (i, t)=>(t == null ? void 0 : t[i]) || i, $8bb98585ab5fb39f$export$aff8451eb9856edd = {
    400: $8bb98585ab5fb39f$export$eac3055710931ba4.InvalidParams,
    500: $8bb98585ab5fb39f$export$eac3055710931ba4.UnknownError,
    5002: $8bb98585ab5fb39f$export$eac3055710931ba4.AccountNotFound,
    5051: $8bb98585ab5fb39f$export$eac3055710931ba4.ShowRegistration,
    // doesn't show an error, but registration flow instead
    5053: $8bb98585ab5fb39f$export$eac3055710931ba4.IdentNotFound,
    5054: $8bb98585ab5fb39f$export$eac3055710931ba4.NeedFieldsFill,
    5073: $8bb98585ab5fb39f$export$eac3055710931ba4.AccountFrozen,
    6363: $8bb98585ab5fb39f$export$eac3055710931ba4.BankIdUnavailable
}, $8bb98585ab5fb39f$export$50bd195c3026f49d = {
    [$8bb98585ab5fb39f$export$eac3055710931ba4.InvalidParams]: 400,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.UnknownError]: 500,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.NetworkError]: -1,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.AccountNotFound]: 5002,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.ShowRegistration]: 5051,
    // doesn't show an error, but registration flow instead
    [$8bb98585ab5fb39f$export$eac3055710931ba4.IdentNotFound]: 5053,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.NeedFieldsFill]: 5054,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.AccountFrozen]: 5073,
    [$8bb98585ab5fb39f$export$eac3055710931ba4.BankIdUnavailable]: 6363
}, $8bb98585ab5fb39f$export$5f369ca6979c8db0 = {
    [-1]: {
        title: "auth_bankid.error.bad_request.400",
        text: "auth_bankid.body_error_sign_in"
    },
    400: {
        title: "auth_bankid.error.bad_request.400",
        text: "auth_bankid.error.invalid_params"
    },
    500: {
        title: "auth_bankid.error.internal_error.500",
        text: "auth_bankid.error.unknown_error"
    },
    5002: {
        title: "auth_bankid.error.account_not_found.5002",
        text: "auth_bankid.error.account_not_found"
    },
    5053: {
        title: "auth_bankid.error.ident_not_found.5053",
        text: "auth_bankid.error.ident_not_found"
    },
    5054: {
        title: "auth_bankid.error.ident_not_found.5054",
        text: "auth_bankid.error.ident_not_found"
    },
    5073: {
        title: "auth_bankid.error.account_frozen.5073",
        text: "auth_bankid.error.account_frozen"
    },
    6363: {
        title: "auth_bankid.error.internal_error.500",
        text: "auth_bankid.error.unknown_error"
    }
}, $8bb98585ab5fb39f$var$dn = "en", $8bb98585ab5fb39f$var$ln = /^\/(?<lang>[a-z]{2,2})\//, $8bb98585ab5fb39f$export$5803c3c1cacc7a03 = ()=>{
    var i, t, e;
    return ((e = (t = (i = window.location.pathname) == null ? void 0 : i.match($8bb98585ab5fb39f$var$ln)) == null ? void 0 : t.groups) == null ? void 0 : e.lang) || $8bb98585ab5fb39f$var$dn;
};
class $8bb98585ab5fb39f$export$2cf64874b731abec extends Error {
}
const $8bb98585ab5fb39f$export$6446a186d09e379e = ()=>window.navigator.userAgent.match(/CriOS/i) || window.chrome && !window.opr, $8bb98585ab5fb39f$export$52e477023a1a39bb = ()=>$8bb98585ab5fb39f$export$6446a186d09e379e() ? "googlechrome://" : "null", $8bb98585ab5fb39f$export$d0a8044dce8ff2fc = ()=>/android|iPad|iPhone|iPod/i.test(navigator.userAgent);
var $8bb98585ab5fb39f$var$un = Object.defineProperty, $8bb98585ab5fb39f$var$hn = Object.getOwnPropertyDescriptor, $8bb98585ab5fb39f$var$_t = (i, t, e, n)=>{
    for(var r = n > 1 ? void 0 : n ? $8bb98585ab5fb39f$var$hn(t, e) : t, o = i.length - 1, s; o >= 0; o--)(s = i[o]) && (r = (n ? s(t, e, r) : s(r)) || r);
    return n && r && $8bb98585ab5fb39f$var$un(t, e, r), r;
};
let $8bb98585ab5fb39f$export$3ddf2d174ce01153 = class extends $8bb98585ab5fb39f$var$W {
    constructor(){
        super(...arguments), this.logoUrl = "";
    }
    i(i) {
        return $8bb98585ab5fb39f$export$d73ee8ef04f5226a(i, this.translations);
    }
    render() {
        const i = this.dialog.config.closeButton !== !1 && $8bb98585ab5fb39f$var$z`
            <div class="close" @click="${this.dialog.close.bind(this, {
            closeEventName: $8bb98585ab5fb39f$export$a460168851755bfd
        })}">
                ${$8bb98585ab5fb39f$var$on}
            </div>
        `;
        return $8bb98585ab5fb39f$var$z`
            <div 
                class="${$8bb98585ab5fb39f$var$Xe({
            wrapper: !0,
            [this.dialog.config.class || ""]: !0
        })}"
                @click="${this.onBackdropClick.bind(this)}"
            >
                <div class="dialog">
                  <div class="header">
                    <img class="header-logo" src="${this.logoUrl}" alt="">
                    ${i}
                  </div>
                  <div class="main">
                    <div class="wrap">${this.dialog.config.body}</div>
                  </div>
                </div>
            </div>`;
    }
    onBackdropClick(i) {
        i.target === i.currentTarget && this.backdropclose && this.dialog.close({
            closeEventName: $8bb98585ab5fb39f$export$a460168851755bfd
        });
    }
};
$8bb98585ab5fb39f$export$3ddf2d174ce01153.styles = [
    $8bb98585ab5fb39f$var$ge,
    $8bb98585ab5fb39f$var$sn
];
$8bb98585ab5fb39f$var$_t([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$3ddf2d174ce01153.prototype, "dialog", 2);
$8bb98585ab5fb39f$var$_t([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$3ddf2d174ce01153.prototype, "logoUrl", 2);
$8bb98585ab5fb39f$var$_t([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$3ddf2d174ce01153.prototype, "translations", 2);
$8bb98585ab5fb39f$var$_t([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$3ddf2d174ce01153.prototype, "backdropclose", 2);
$8bb98585ab5fb39f$export$3ddf2d174ce01153 = $8bb98585ab5fb39f$var$_t([
    $8bb98585ab5fb39f$var$Ut("bsc-dialog")
], $8bb98585ab5fb39f$export$3ddf2d174ce01153);
var $8bb98585ab5fb39f$var$fn = Object.defineProperty, $8bb98585ab5fb39f$var$gn = Object.getOwnPropertyDescriptor, $8bb98585ab5fb39f$var$wt = (i, t, e, n)=>{
    for(var r = n > 1 ? void 0 : n ? $8bb98585ab5fb39f$var$gn(t, e) : t, o = i.length - 1, s; o >= 0; o--)(s = i[o]) && (r = (n ? s(t, e, r) : s(r)) || r);
    return n && r && $8bb98585ab5fb39f$var$fn(t, e, r), r;
};
let $8bb98585ab5fb39f$export$6aea35d848d72744 = class extends $8bb98585ab5fb39f$var$W {
    constructor(){
        super(...arguments), this.dialogs = {}, this.logoUrl = "", this.handleEscape = (i)=>{
            const t = i || window.event, e = t.keyCode === 27;
            ("key" in t && [
                "Escape",
                "Esc"
            ].includes(t.key) || e) && this.closeTop();
        };
    }
    connectedCallback() {
        super.connectedCallback(), window.addEventListener("keydown", this.handleEscape);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), window.removeEventListener("keydown", this.handleEscape);
    }
    render() {
        const i = Object.getOwnPropertySymbols(this.dialogs).map((t)=>$8bb98585ab5fb39f$var$z`
                <bsc-dialog 
                    .dialog="${this.dialogs[t]}"
                    logoUrl="${this.logoUrl}"
                    translations="${JSON.stringify(this.translations)}"
                    backdropclose="${this.backdropclose}"
                ></bsc-dialog>`);
        return $8bb98585ab5fb39f$var$z`
            <slot></slot>
            ${i}
        `;
    }
    openDialog(i) {
        const t = Symbol("dialog");
        let e;
        const n = new Promise((r)=>{
            e = (o)=>{
                const { [t]: s, ...d } = this.dialogs;
                s.isOpen = !1, this.dialogs = d, r(o);
            };
        });
        return this.dialogs = {
            ...this.dialogs,
            [t]: {
                id: t,
                isOpen: !0,
                config: i,
                closed: n,
                close: e
            }
        }, this.dialogs[t];
    }
    closeAll() {
        Object.getOwnPropertySymbols(this.dialogs).forEach((i)=>this.dialogs[i].close());
    }
    closeTop() {
        const i = Object.getOwnPropertySymbols(this.dialogs);
        if (i != null && i.length) {
            const t = i[i.length - 1];
            this.dialogs[t].close({
                closeEventName: $8bb98585ab5fb39f$export$a460168851755bfd
            });
        }
    }
};
$8bb98585ab5fb39f$var$wt([
    $8bb98585ab5fb39f$var$dt()
], $8bb98585ab5fb39f$export$6aea35d848d72744.prototype, "dialogs", 2);
$8bb98585ab5fb39f$var$wt([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$6aea35d848d72744.prototype, "logoUrl", 2);
$8bb98585ab5fb39f$var$wt([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$6aea35d848d72744.prototype, "backdropclose", 2);
$8bb98585ab5fb39f$var$wt([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$6aea35d848d72744.prototype, "translations", 2);
$8bb98585ab5fb39f$export$6aea35d848d72744 = $8bb98585ab5fb39f$var$wt([
    $8bb98585ab5fb39f$var$Ut("bsc-dialogs")
], $8bb98585ab5fb39f$export$6aea35d848d72744);
const $8bb98585ab5fb39f$var$pn = $8bb98585ab5fb39f$var$Bt`
    :host {
        --default-bankid-call-button-bg: #FC8D0A;
        --default-bankid-call-button-bg-hover: #f26702;
        --default-bankid-call-button-height: 42px;
        --default-bankid-call-button-height-mobile: 36px;
        --default-bankid-call-button-padding: 0 16px;
        --default-bankid-call-button-radius: 5px;
        --default-bankid-call-button-radius-hover: 5px;
        --default-bankid-call-button-border: none;
        --default-bankid-call-button-border-hover: none;
        --default-bankid-call-button-transition: background-color .2s ease-in-out;
        --default-bankid-call-button-font-size: 16px;
        --default-bankid-call-button-font-size-mobile: 14px;
        --default-bankid-call-button-font-weight: 500;
        --default-bankid-call-button-color: #ffffff;
    }

    .bankid-btn {
        background-color: var(--bankid-call-button-bg, var(--default-bankid-call-button-bg));
        min-height: var(--bankid-call-button-height, var(--default-bankid-call-button-height));
        display: flex;
        justify-content: center;
        align-items: center;
        padding: var(--bankid-call-button-padding, var(--default-bankid-call-button-padding));
        border-radius: var(--bankid-call-button-radius, var(--default-bankid-call-button-radius));
        transition: var(--bankid-call-button-transition, var(--default-bankid-call-button-transition));
        font-size: var(--bankid-call-button-font-size, var(--default-bankid-call-button-font-size));
        font-weight: var(--bankid-call-button-font-weight, var(--default-bankid-call-button-font-weight));
        color: var(--bankid-call-button-color, var(--default-bankid-call-button-color));
        border: var(--bankid-call-button-border, var(--default-bankid-call-button-border));
    }

    .bankid-btn:hover {
        background-color: var(--bankid-call-button-bg-hover, var(--default-bankid-call-button-bg-hover));
        border-radius: var(--bankid-call-button-radius-hover, var(--default-bankid-call-button-radius-hover));
        border: var(--bankid-call-button-border-hover, var(--default-bankid-call-button-border-hover));
    }
    @media (max-width: 540px) {
        .bankid-btn {
            min-height: var(--bankid-call-button-height-mobile, var(--default-bankid-call-button-height-mobile));
            font-size: var(--bankid-call-button-font-size-mobile, var(--default-bankid-call-button-font-size-mobile));
        }
    }
`;
var $8bb98585ab5fb39f$var$mn = Object.defineProperty, $8bb98585ab5fb39f$var$bn = Object.getOwnPropertyDescriptor, $8bb98585ab5fb39f$var$A = (i, t, e, n)=>{
    for(var r = n > 1 ? void 0 : n ? $8bb98585ab5fb39f$var$bn(t, e) : t, o = i.length - 1, s; o >= 0; o--)(s = i[o]) && (r = (n ? s(t, e, r) : s(r)) || r);
    return n && r && $8bb98585ab5fb39f$var$mn(t, e, r), r;
};
let $8bb98585ab5fb39f$export$b7bae08695fc5a79 = class extends $8bb98585ab5fb39f$var$W {
    constructor(){
        super(...arguments), this.redirect = $8bb98585ab5fb39f$export$52e477023a1a39bb(), this.platform = "v2", this.api = `/${$8bb98585ab5fb39f$export$5803c3c1cacc7a03()}/api/v2`, this.qrbackground = "#0000", this.qrcolor = "#000", this.maxstatusrequests = 300, this.authclosetimeout = 0;
    }
    i(i) {
        return $8bb98585ab5fb39f$export$d73ee8ef04f5226a(i, this.translations);
    }
    getUrl(i) {
        return i.replace(/\/$/, "");
    }
    render() {
        return $8bb98585ab5fb39f$var$z`
            <div>
                <button class="bankid-btn" @click="${this.openDialog}">
                    ${this.i("auth_bankid.signin_btn")}
                </button>

                <bsc-dialogs 
                    id="dialogs"
                    logoUrl="${this.logoUrl}"
                    translations="${JSON.stringify(this.translations)}"
                    backdropclose="${this.backdropclose}"
                ></bsc-dialogs>
            </div>
        `;
    }
    openDialog() {
        const i = this.dialogs.openDialog({
            body: $8bb98585ab5fb39f$var$z`
                <bsc-auth-bank-id-content 
                    redirect="${this.redirect}" 
                    api="${this.api}"
                    translations="${this.translations && JSON.stringify(this.translations)}"
                    affiliate="${this.affiliate && JSON.stringify(this.affiliate)}"
                    amount="${this.amount}"
                    currency="${this.currency}"
                    locale="${this.locale}"
                    qa="${this.qa && JSON.stringify(this.qa)}"
                    adformcookieid="${this.adformcookieid}"
                    maxstatusrequests="${this.maxstatusrequests}"
                    qrbackground="${this.qrbackground}"
                    qrcolor="${this.qrcolor}"
                    @showregistration="${()=>this.closeDialog(i, $8bb98585ab5fb39f$export$eac3055710931ba4.ShowRegistration)}"
                    @successlogin="${()=>this.closeDialog(i, $8bb98585ab5fb39f$export$eac3055710931ba4.SuccessLogin)}"
                ></bsc-auth-bank-id-content>`
        });
        i.closed.then(()=>{
            this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.DialogClosed);
        }), this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.DialogOpen, {
            dialog: i
        });
    }
    closeAll() {
        this.dialogs.closeAll();
    }
    closeDialog(i, t) {
        this.authclosetimeout ? setTimeout(()=>i.close({
                closeEventName: t
            }), Number(this.authclosetimeout)) : i.close({
            closeEventName: t
        });
    }
    sendEvent(i, t) {
        this.dispatchEvent(new CustomEvent(i, {
            detail: t || {
                name: i
            },
            bubbles: !0,
            composed: !0
        }));
    }
};
$8bb98585ab5fb39f$export$b7bae08695fc5a79.styles = [
    $8bb98585ab5fb39f$var$ge,
    $8bb98585ab5fb39f$var$pn
];
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$Ze("#dialogs")
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "dialogs", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "translations", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "redirect", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "platform", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "api", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "logoUrl", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "backdropclose", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "affiliate", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "amount", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "currency", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "locale", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "qa", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "qrbackground", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "qrcolor", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "adformcookieid", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "maxstatusrequests", 2);
$8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$b7bae08695fc5a79.prototype, "authclosetimeout", 2);
$8bb98585ab5fb39f$export$b7bae08695fc5a79 = $8bb98585ab5fb39f$var$A([
    $8bb98585ab5fb39f$var$Ut("bsc-auth-bank-id")
], $8bb98585ab5fb39f$export$b7bae08695fc5a79);
var $8bb98585ab5fb39f$var$yn = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, $8bb98585ab5fb39f$var$ii = {}, $8bb98585ab5fb39f$var$I = {};
let $8bb98585ab5fb39f$var$me;
const $8bb98585ab5fb39f$var$_n = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$8bb98585ab5fb39f$var$I.getSymbolSize = function(t) {
    if (!t) throw new Error('"version" cannot be null or undefined');
    if (t < 1 || t > 40) throw new Error('"version" should be in range from 1 to 40');
    return t * 4 + 17;
};
$8bb98585ab5fb39f$var$I.getSymbolTotalCodewords = function(t) {
    return $8bb98585ab5fb39f$var$_n[t];
};
$8bb98585ab5fb39f$var$I.getBCHDigit = function(i) {
    let t = 0;
    for(; i !== 0;)t++, i >>>= 1;
    return t;
};
$8bb98585ab5fb39f$var$I.setToSJISFunction = function(t) {
    if (typeof t != "function") throw new Error('"toSJISFunc" is not a valid function.');
    $8bb98585ab5fb39f$var$me = t;
};
$8bb98585ab5fb39f$var$I.isKanjiModeEnabled = function() {
    return typeof $8bb98585ab5fb39f$var$me < "u";
};
$8bb98585ab5fb39f$var$I.toSJIS = function(t) {
    return $8bb98585ab5fb39f$var$me(t);
};
var $8bb98585ab5fb39f$var$Ot = {};
(function(i) {
    i.L = {
        bit: 1
    }, i.M = {
        bit: 0
    }, i.Q = {
        bit: 3
    }, i.H = {
        bit: 2
    };
    function t(e) {
        if (typeof e != "string") throw new Error("Param is not a string");
        switch(e.toLowerCase()){
            case "l":
            case "low":
                return i.L;
            case "m":
            case "medium":
                return i.M;
            case "q":
            case "quartile":
                return i.Q;
            case "h":
            case "high":
                return i.H;
            default:
                throw new Error("Unknown EC Level: " + e);
        }
    }
    i.isValid = function(n) {
        return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
    }, i.from = function(n, r) {
        if (i.isValid(n)) return n;
        try {
            return t(n);
        } catch  {
            return r;
        }
    };
})($8bb98585ab5fb39f$var$Ot);
function $8bb98585ab5fb39f$var$ni() {
    this.buffer = [], this.length = 0;
}
$8bb98585ab5fb39f$var$ni.prototype = {
    get: function(i) {
        const t = Math.floor(i / 8);
        return (this.buffer[t] >>> 7 - i % 8 & 1) === 1;
    },
    put: function(i, t) {
        for(let e = 0; e < t; e++)this.putBit((i >>> t - e - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(i) {
        const t = Math.floor(this.length / 8);
        this.buffer.length <= t && this.buffer.push(0), i && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
    }
};
var $8bb98585ab5fb39f$var$wn = $8bb98585ab5fb39f$var$ni;
function $8bb98585ab5fb39f$var$vt(i) {
    if (!i || i < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = i, this.data = new Uint8Array(i * i), this.reservedBit = new Uint8Array(i * i);
}
$8bb98585ab5fb39f$var$vt.prototype.set = function(i, t, e, n) {
    const r = i * this.size + t;
    this.data[r] = e, n && (this.reservedBit[r] = !0);
};
$8bb98585ab5fb39f$var$vt.prototype.get = function(i, t) {
    return this.data[i * this.size + t];
};
$8bb98585ab5fb39f$var$vt.prototype.xor = function(i, t, e) {
    this.data[i * this.size + t] ^= e;
};
$8bb98585ab5fb39f$var$vt.prototype.isReserved = function(i, t) {
    return this.reservedBit[i * this.size + t];
};
var $8bb98585ab5fb39f$var$vn = $8bb98585ab5fb39f$var$vt, $8bb98585ab5fb39f$var$ri = {};
(function(i) {
    const t = $8bb98585ab5fb39f$var$I.getSymbolSize;
    i.getRowColCoords = function(n) {
        if (n === 1) return [];
        const r = Math.floor(n / 7) + 2, o = t(n), s = o === 145 ? 26 : Math.ceil((o - 13) / (2 * r - 2)) * 2, d = [
            o - 7
        ];
        for(let a = 1; a < r - 1; a++)d[a] = d[a - 1] - s;
        return d.push(6), d.reverse();
    }, i.getPositions = function(n) {
        const r = [], o = i.getRowColCoords(n), s = o.length;
        for(let d = 0; d < s; d++)for(let a = 0; a < s; a++)d === 0 && a === 0 || // top-left
        d === 0 && a === s - 1 || // bottom-left
        d === s - 1 && a === 0 || r.push([
            o[d],
            o[a]
        ]);
        return r;
    };
})($8bb98585ab5fb39f$var$ri);
var $8bb98585ab5fb39f$var$oi = {};
const $8bb98585ab5fb39f$var$En = $8bb98585ab5fb39f$var$I.getSymbolSize, $8bb98585ab5fb39f$var$Le = 7;
$8bb98585ab5fb39f$var$oi.getPositions = function(t) {
    const e = $8bb98585ab5fb39f$var$En(t);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            e - $8bb98585ab5fb39f$var$Le,
            0
        ],
        // bottom-left
        [
            0,
            e - $8bb98585ab5fb39f$var$Le
        ]
    ];
};
var $8bb98585ab5fb39f$var$si = {};
(function(i) {
    i.Patterns = {
        PATTERN000: 0,
        PATTERN001: 1,
        PATTERN010: 2,
        PATTERN011: 3,
        PATTERN100: 4,
        PATTERN101: 5,
        PATTERN110: 6,
        PATTERN111: 7
    };
    const t = {
        N1: 3,
        N2: 3,
        N3: 40,
        N4: 10
    };
    i.isValid = function(r) {
        return r != null && r !== "" && !isNaN(r) && r >= 0 && r <= 7;
    }, i.from = function(r) {
        return i.isValid(r) ? parseInt(r, 10) : void 0;
    }, i.getPenaltyN1 = function(r) {
        const o = r.size;
        let s = 0, d = 0, a = 0, l = null, c = null;
        for(let f = 0; f < o; f++){
            d = a = 0, l = c = null;
            for(let h = 0; h < o; h++){
                let u = r.get(f, h);
                u === l ? d++ : (d >= 5 && (s += t.N1 + (d - 5)), l = u, d = 1), u = r.get(h, f), u === c ? a++ : (a >= 5 && (s += t.N1 + (a - 5)), c = u, a = 1);
            }
            d >= 5 && (s += t.N1 + (d - 5)), a >= 5 && (s += t.N1 + (a - 5));
        }
        return s;
    }, i.getPenaltyN2 = function(r) {
        const o = r.size;
        let s = 0;
        for(let d = 0; d < o - 1; d++)for(let a = 0; a < o - 1; a++){
            const l = r.get(d, a) + r.get(d, a + 1) + r.get(d + 1, a) + r.get(d + 1, a + 1);
            (l === 4 || l === 0) && s++;
        }
        return s * t.N2;
    }, i.getPenaltyN3 = function(r) {
        const o = r.size;
        let s = 0, d = 0, a = 0;
        for(let l = 0; l < o; l++){
            d = a = 0;
            for(let c = 0; c < o; c++)d = d << 1 & 2047 | r.get(l, c), c >= 10 && (d === 1488 || d === 93) && s++, a = a << 1 & 2047 | r.get(c, l), c >= 10 && (a === 1488 || a === 93) && s++;
        }
        return s * t.N3;
    }, i.getPenaltyN4 = function(r) {
        let o = 0;
        const s = r.data.length;
        for(let a = 0; a < s; a++)o += r.data[a];
        return Math.abs(Math.ceil(o * 100 / s / 5) - 10) * t.N4;
    };
    function e(n, r, o) {
        switch(n){
            case i.Patterns.PATTERN000:
                return (r + o) % 2 === 0;
            case i.Patterns.PATTERN001:
                return r % 2 === 0;
            case i.Patterns.PATTERN010:
                return o % 3 === 0;
            case i.Patterns.PATTERN011:
                return (r + o) % 3 === 0;
            case i.Patterns.PATTERN100:
                return (Math.floor(r / 2) + Math.floor(o / 3)) % 2 === 0;
            case i.Patterns.PATTERN101:
                return r * o % 2 + r * o % 3 === 0;
            case i.Patterns.PATTERN110:
                return (r * o % 2 + r * o % 3) % 2 === 0;
            case i.Patterns.PATTERN111:
                return (r * o % 3 + (r + o) % 2) % 2 === 0;
            default:
                throw new Error("bad maskPattern:" + n);
        }
    }
    i.applyMask = function(r, o) {
        const s = o.size;
        for(let d = 0; d < s; d++)for(let a = 0; a < s; a++)o.isReserved(a, d) || o.xor(a, d, e(r, a, d));
    }, i.getBestMask = function(r, o) {
        const s = Object.keys(i.Patterns).length;
        let d = 0, a = 1 / 0;
        for(let l = 0; l < s; l++){
            o(l), i.applyMask(l, r);
            const c = i.getPenaltyN1(r) + i.getPenaltyN2(r) + i.getPenaltyN3(r) + i.getPenaltyN4(r);
            i.applyMask(l, r), c < a && (a = c, d = l);
        }
        return d;
    };
})($8bb98585ab5fb39f$var$si);
var $8bb98585ab5fb39f$var$zt = {};
const $8bb98585ab5fb39f$var$H = $8bb98585ab5fb39f$var$Ot, $8bb98585ab5fb39f$var$Et = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
], $8bb98585ab5fb39f$var$Ct = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$8bb98585ab5fb39f$var$zt.getBlocksCount = function(t, e) {
    switch(e){
        case $8bb98585ab5fb39f$var$H.L:
            return $8bb98585ab5fb39f$var$Et[(t - 1) * 4 + 0];
        case $8bb98585ab5fb39f$var$H.M:
            return $8bb98585ab5fb39f$var$Et[(t - 1) * 4 + 1];
        case $8bb98585ab5fb39f$var$H.Q:
            return $8bb98585ab5fb39f$var$Et[(t - 1) * 4 + 2];
        case $8bb98585ab5fb39f$var$H.H:
            return $8bb98585ab5fb39f$var$Et[(t - 1) * 4 + 3];
        default:
            return;
    }
};
$8bb98585ab5fb39f$var$zt.getTotalCodewordsCount = function(t, e) {
    switch(e){
        case $8bb98585ab5fb39f$var$H.L:
            return $8bb98585ab5fb39f$var$Ct[(t - 1) * 4 + 0];
        case $8bb98585ab5fb39f$var$H.M:
            return $8bb98585ab5fb39f$var$Ct[(t - 1) * 4 + 1];
        case $8bb98585ab5fb39f$var$H.Q:
            return $8bb98585ab5fb39f$var$Ct[(t - 1) * 4 + 2];
        case $8bb98585ab5fb39f$var$H.H:
            return $8bb98585ab5fb39f$var$Ct[(t - 1) * 4 + 3];
        default:
            return;
    }
};
var $8bb98585ab5fb39f$var$ai = {}, $8bb98585ab5fb39f$var$Dt = {};
const $8bb98585ab5fb39f$var$ht = new Uint8Array(512), $8bb98585ab5fb39f$var$Nt = new Uint8Array(256);
(function() {
    let t = 1;
    for(let e = 0; e < 255; e++)$8bb98585ab5fb39f$var$ht[e] = t, $8bb98585ab5fb39f$var$Nt[t] = e, t <<= 1, t & 256 && (t ^= 285);
    for(let e = 255; e < 512; e++)$8bb98585ab5fb39f$var$ht[e] = $8bb98585ab5fb39f$var$ht[e - 255];
})();
$8bb98585ab5fb39f$var$Dt.log = function(t) {
    if (t < 1) throw new Error("log(" + t + ")");
    return $8bb98585ab5fb39f$var$Nt[t];
};
$8bb98585ab5fb39f$var$Dt.exp = function(t) {
    return $8bb98585ab5fb39f$var$ht[t];
};
$8bb98585ab5fb39f$var$Dt.mul = function(t, e) {
    return t === 0 || e === 0 ? 0 : $8bb98585ab5fb39f$var$ht[$8bb98585ab5fb39f$var$Nt[t] + $8bb98585ab5fb39f$var$Nt[e]];
};
(function(i) {
    const t = $8bb98585ab5fb39f$var$Dt;
    i.mul = function(n, r) {
        const o = new Uint8Array(n.length + r.length - 1);
        for(let s = 0; s < n.length; s++)for(let d = 0; d < r.length; d++)o[s + d] ^= t.mul(n[s], r[d]);
        return o;
    }, i.mod = function(n, r) {
        let o = new Uint8Array(n);
        for(; o.length - r.length >= 0;){
            const s = o[0];
            for(let a = 0; a < r.length; a++)o[a] ^= t.mul(r[a], s);
            let d = 0;
            for(; d < o.length && o[d] === 0;)d++;
            o = o.slice(d);
        }
        return o;
    }, i.generateECPolynomial = function(n) {
        let r = new Uint8Array([
            1
        ]);
        for(let o = 0; o < n; o++)r = i.mul(r, new Uint8Array([
            1,
            t.exp(o)
        ]));
        return r;
    };
})($8bb98585ab5fb39f$var$ai);
const $8bb98585ab5fb39f$var$di = $8bb98585ab5fb39f$var$ai;
function $8bb98585ab5fb39f$var$be(i) {
    this.genPoly = void 0, this.degree = i, this.degree && this.initialize(this.degree);
}
$8bb98585ab5fb39f$var$be.prototype.initialize = function(t) {
    this.degree = t, this.genPoly = $8bb98585ab5fb39f$var$di.generateECPolynomial(this.degree);
};
$8bb98585ab5fb39f$var$be.prototype.encode = function(t) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    const e = new Uint8Array(t.length + this.degree);
    e.set(t);
    const n = $8bb98585ab5fb39f$var$di.mod(e, this.genPoly), r = this.degree - n.length;
    if (r > 0) {
        const o = new Uint8Array(this.degree);
        return o.set(n, r), o;
    }
    return n;
};
var $8bb98585ab5fb39f$var$Cn = $8bb98585ab5fb39f$var$be, $8bb98585ab5fb39f$var$li = {}, $8bb98585ab5fb39f$var$J = {}, $8bb98585ab5fb39f$var$ye = {};
$8bb98585ab5fb39f$var$ye.isValid = function(t) {
    return !isNaN(t) && t >= 1 && t <= 40;
};
var $8bb98585ab5fb39f$var$D = {};
const $8bb98585ab5fb39f$var$ci = "[0-9]+", $8bb98585ab5fb39f$var$kn = "[A-Z $%*+\\-./:]+";
let $8bb98585ab5fb39f$var$bt = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$8bb98585ab5fb39f$var$bt = $8bb98585ab5fb39f$var$bt.replace(/u/g, "\\u");
const $8bb98585ab5fb39f$var$Sn = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $8bb98585ab5fb39f$var$bt + `)(?:.|[\r
]))+`;
$8bb98585ab5fb39f$var$D.KANJI = new RegExp($8bb98585ab5fb39f$var$bt, "g");
$8bb98585ab5fb39f$var$D.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$8bb98585ab5fb39f$var$D.BYTE = new RegExp($8bb98585ab5fb39f$var$Sn, "g");
$8bb98585ab5fb39f$var$D.NUMERIC = new RegExp($8bb98585ab5fb39f$var$ci, "g");
$8bb98585ab5fb39f$var$D.ALPHANUMERIC = new RegExp($8bb98585ab5fb39f$var$kn, "g");
const $8bb98585ab5fb39f$var$Pn = new RegExp("^" + $8bb98585ab5fb39f$var$bt + "$"), $8bb98585ab5fb39f$var$$n = new RegExp("^" + $8bb98585ab5fb39f$var$ci + "$"), $8bb98585ab5fb39f$var$xn = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$8bb98585ab5fb39f$var$D.testKanji = function(t) {
    return $8bb98585ab5fb39f$var$Pn.test(t);
};
$8bb98585ab5fb39f$var$D.testNumeric = function(t) {
    return $8bb98585ab5fb39f$var$$n.test(t);
};
$8bb98585ab5fb39f$var$D.testAlphanumeric = function(t) {
    return $8bb98585ab5fb39f$var$xn.test(t);
};
(function(i) {
    const t = $8bb98585ab5fb39f$var$ye, e = $8bb98585ab5fb39f$var$D;
    i.NUMERIC = {
        id: "Numeric",
        bit: 1,
        ccBits: [
            10,
            12,
            14
        ]
    }, i.ALPHANUMERIC = {
        id: "Alphanumeric",
        bit: 2,
        ccBits: [
            9,
            11,
            13
        ]
    }, i.BYTE = {
        id: "Byte",
        bit: 4,
        ccBits: [
            8,
            16,
            16
        ]
    }, i.KANJI = {
        id: "Kanji",
        bit: 8,
        ccBits: [
            8,
            10,
            12
        ]
    }, i.MIXED = {
        bit: -1
    }, i.getCharCountIndicator = function(o, s) {
        if (!o.ccBits) throw new Error("Invalid mode: " + o);
        if (!t.isValid(s)) throw new Error("Invalid version: " + s);
        return s >= 1 && s < 10 ? o.ccBits[0] : s < 27 ? o.ccBits[1] : o.ccBits[2];
    }, i.getBestModeForData = function(o) {
        return e.testNumeric(o) ? i.NUMERIC : e.testAlphanumeric(o) ? i.ALPHANUMERIC : e.testKanji(o) ? i.KANJI : i.BYTE;
    }, i.toString = function(o) {
        if (o && o.id) return o.id;
        throw new Error("Invalid mode");
    }, i.isValid = function(o) {
        return o && o.bit && o.ccBits;
    };
    function n(r) {
        if (typeof r != "string") throw new Error("Param is not a string");
        switch(r.toLowerCase()){
            case "numeric":
                return i.NUMERIC;
            case "alphanumeric":
                return i.ALPHANUMERIC;
            case "kanji":
                return i.KANJI;
            case "byte":
                return i.BYTE;
            default:
                throw new Error("Unknown mode: " + r);
        }
    }
    i.from = function(o, s) {
        if (i.isValid(o)) return o;
        try {
            return n(o);
        } catch  {
            return s;
        }
    };
})($8bb98585ab5fb39f$var$J);
(function(i) {
    const t = $8bb98585ab5fb39f$var$I, e = $8bb98585ab5fb39f$var$zt, n = $8bb98585ab5fb39f$var$Ot, r = $8bb98585ab5fb39f$var$J, o = $8bb98585ab5fb39f$var$ye, s = 7973, d = t.getBCHDigit(s);
    function a(h, u, m) {
        for(let y = 1; y <= 40; y++)if (u <= i.getCapacity(y, m, h)) return y;
    }
    function l(h, u) {
        return r.getCharCountIndicator(h, u) + 4;
    }
    function c(h, u) {
        let m = 0;
        return h.forEach(function(y) {
            const N = l(y.mode, u);
            m += N + y.getBitsLength();
        }), m;
    }
    function f(h, u) {
        for(let m = 1; m <= 40; m++)if (c(h, m) <= i.getCapacity(m, u, r.MIXED)) return m;
    }
    i.from = function(u, m) {
        return o.isValid(u) ? parseInt(u, 10) : m;
    }, i.getCapacity = function(u, m, y) {
        if (!o.isValid(u)) throw new Error("Invalid QR Code version");
        typeof y > "u" && (y = r.BYTE);
        const N = t.getSymbolTotalCodewords(u), b = e.getTotalCodewordsCount(u, m), w = (N - b) * 8;
        if (y === r.MIXED) return w;
        const p = w - l(y, u);
        switch(y){
            case r.NUMERIC:
                return Math.floor(p / 10 * 3);
            case r.ALPHANUMERIC:
                return Math.floor(p / 11 * 2);
            case r.KANJI:
                return Math.floor(p / 13);
            case r.BYTE:
            default:
                return Math.floor(p / 8);
        }
    }, i.getBestVersionForData = function(u, m) {
        let y;
        const N = n.from(m, n.M);
        if (Array.isArray(u)) {
            if (u.length > 1) return f(u, N);
            if (u.length === 0) return 1;
            y = u[0];
        } else y = u;
        return a(y.mode, y.getLength(), N);
    }, i.getEncodedBits = function(u) {
        if (!o.isValid(u) || u < 7) throw new Error("Invalid QR Code version");
        let m = u << 12;
        for(; t.getBCHDigit(m) - d >= 0;)m ^= s << t.getBCHDigit(m) - d;
        return u << 12 | m;
    };
})($8bb98585ab5fb39f$var$li);
var $8bb98585ab5fb39f$var$ui = {};
const $8bb98585ab5fb39f$var$re = $8bb98585ab5fb39f$var$I, $8bb98585ab5fb39f$var$hi = 1335, $8bb98585ab5fb39f$var$Tn = 21522, $8bb98585ab5fb39f$var$Ue = $8bb98585ab5fb39f$var$re.getBCHDigit($8bb98585ab5fb39f$var$hi);
$8bb98585ab5fb39f$var$ui.getEncodedBits = function(t, e) {
    const n = t.bit << 3 | e;
    let r = n << 10;
    for(; $8bb98585ab5fb39f$var$re.getBCHDigit(r) - $8bb98585ab5fb39f$var$Ue >= 0;)r ^= $8bb98585ab5fb39f$var$hi << $8bb98585ab5fb39f$var$re.getBCHDigit(r) - $8bb98585ab5fb39f$var$Ue;
    return (n << 10 | r) ^ $8bb98585ab5fb39f$var$Tn;
};
var $8bb98585ab5fb39f$var$fi = {};
const $8bb98585ab5fb39f$var$An = $8bb98585ab5fb39f$var$J;
function $8bb98585ab5fb39f$var$rt(i) {
    this.mode = $8bb98585ab5fb39f$var$An.NUMERIC, this.data = i.toString();
}
$8bb98585ab5fb39f$var$rt.getBitsLength = function(t) {
    return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
$8bb98585ab5fb39f$var$rt.prototype.getLength = function() {
    return this.data.length;
};
$8bb98585ab5fb39f$var$rt.prototype.getBitsLength = function() {
    return $8bb98585ab5fb39f$var$rt.getBitsLength(this.data.length);
};
$8bb98585ab5fb39f$var$rt.prototype.write = function(t) {
    let e, n, r;
    for(e = 0; e + 3 <= this.data.length; e += 3)n = this.data.substr(e, 3), r = parseInt(n, 10), t.put(r, 10);
    const o = this.data.length - e;
    o > 0 && (n = this.data.substr(e), r = parseInt(n, 10), t.put(r, o * 3 + 1));
};
var $8bb98585ab5fb39f$var$Nn = $8bb98585ab5fb39f$var$rt;
const $8bb98585ab5fb39f$var$Mn = $8bb98585ab5fb39f$var$J, $8bb98585ab5fb39f$var$Gt = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $8bb98585ab5fb39f$var$ot(i) {
    this.mode = $8bb98585ab5fb39f$var$Mn.ALPHANUMERIC, this.data = i;
}
$8bb98585ab5fb39f$var$ot.getBitsLength = function(t) {
    return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
$8bb98585ab5fb39f$var$ot.prototype.getLength = function() {
    return this.data.length;
};
$8bb98585ab5fb39f$var$ot.prototype.getBitsLength = function() {
    return $8bb98585ab5fb39f$var$ot.getBitsLength(this.data.length);
};
$8bb98585ab5fb39f$var$ot.prototype.write = function(t) {
    let e;
    for(e = 0; e + 2 <= this.data.length; e += 2){
        let n = $8bb98585ab5fb39f$var$Gt.indexOf(this.data[e]) * 45;
        n += $8bb98585ab5fb39f$var$Gt.indexOf(this.data[e + 1]), t.put(n, 11);
    }
    this.data.length % 2 && t.put($8bb98585ab5fb39f$var$Gt.indexOf(this.data[e]), 6);
};
var $8bb98585ab5fb39f$var$Bn = $8bb98585ab5fb39f$var$ot;
const $8bb98585ab5fb39f$var$In = $8bb98585ab5fb39f$var$J;
function $8bb98585ab5fb39f$var$st(i) {
    this.mode = $8bb98585ab5fb39f$var$In.BYTE, typeof i == "string" ? this.data = new TextEncoder().encode(i) : this.data = new Uint8Array(i);
}
$8bb98585ab5fb39f$var$st.getBitsLength = function(t) {
    return t * 8;
};
$8bb98585ab5fb39f$var$st.prototype.getLength = function() {
    return this.data.length;
};
$8bb98585ab5fb39f$var$st.prototype.getBitsLength = function() {
    return $8bb98585ab5fb39f$var$st.getBitsLength(this.data.length);
};
$8bb98585ab5fb39f$var$st.prototype.write = function(i) {
    for(let t = 0, e = this.data.length; t < e; t++)i.put(this.data[t], 8);
};
var $8bb98585ab5fb39f$var$Rn = $8bb98585ab5fb39f$var$st;
const $8bb98585ab5fb39f$var$Ln = $8bb98585ab5fb39f$var$J, $8bb98585ab5fb39f$var$Un = $8bb98585ab5fb39f$var$I;
function $8bb98585ab5fb39f$var$at(i) {
    this.mode = $8bb98585ab5fb39f$var$Ln.KANJI, this.data = i;
}
$8bb98585ab5fb39f$var$at.getBitsLength = function(t) {
    return t * 13;
};
$8bb98585ab5fb39f$var$at.prototype.getLength = function() {
    return this.data.length;
};
$8bb98585ab5fb39f$var$at.prototype.getBitsLength = function() {
    return $8bb98585ab5fb39f$var$at.getBitsLength(this.data.length);
};
$8bb98585ab5fb39f$var$at.prototype.write = function(i) {
    let t;
    for(t = 0; t < this.data.length; t++){
        let e = $8bb98585ab5fb39f$var$Un.toSJIS(this.data[t]);
        if (e >= 33088 && e <= 40956) e -= 33088;
        else if (e >= 57408 && e <= 60351) e -= 49472;
        else throw new Error("Invalid SJIS character: " + this.data[t] + `
Make sure your charset is UTF-8`);
        e = (e >>> 8 & 255) * 192 + (e & 255), i.put(e, 13);
    }
};
var $8bb98585ab5fb39f$var$On = $8bb98585ab5fb39f$var$at, $8bb98585ab5fb39f$var$gi = {
    exports: {}
};
(function(i) {
    var t = {
        single_source_shortest_paths: function(e, n, r) {
            var o = {}, s = {};
            s[n] = 0;
            var d = t.PriorityQueue.make();
            d.push(n, 0);
            for(var a, l, c, f, h, u, m, y, N; !d.empty();){
                a = d.pop(), l = a.value, f = a.cost, h = e[l] || {};
                for(c in h)h.hasOwnProperty(c) && (u = h[c], m = f + u, y = s[c], N = typeof s[c] > "u", (N || y > m) && (s[c] = m, d.push(c, m), o[c] = l));
            }
            if (typeof r < "u" && typeof s[r] > "u") {
                var b = [
                    "Could not find a path from ",
                    n,
                    " to ",
                    r,
                    "."
                ].join("");
                throw new Error(b);
            }
            return o;
        },
        extract_shortest_path_from_predecessor_list: function(e, n) {
            for(var r = [], o = n; o;)r.push(o), e[o], o = e[o];
            return r.reverse(), r;
        },
        find_path: function(e, n, r) {
            var o = t.single_source_shortest_paths(e, n, r);
            return t.extract_shortest_path_from_predecessor_list(o, r);
        },
        /**
     * A very naive priority queue implementation.
     */ PriorityQueue: {
            make: function(e) {
                var n = t.PriorityQueue, r = {}, o;
                e = e || {};
                for(o in n)n.hasOwnProperty(o) && (r[o] = n[o]);
                return r.queue = [], r.sorter = e.sorter || n.default_sorter, r;
            },
            default_sorter: function(e, n) {
                return e.cost - n.cost;
            },
            /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */ push: function(e, n) {
                var r = {
                    value: e,
                    cost: n
                };
                this.queue.push(r), this.queue.sort(this.sorter);
            },
            /**
       * Return the highest priority element in the queue.
       */ pop: function() {
                return this.queue.shift();
            },
            empty: function() {
                return this.queue.length === 0;
            }
        }
    };
    i.exports = t;
})($8bb98585ab5fb39f$var$gi);
var $8bb98585ab5fb39f$var$zn = $8bb98585ab5fb39f$var$gi.exports;
(function(i) {
    const t = $8bb98585ab5fb39f$var$J, e = $8bb98585ab5fb39f$var$Nn, n = $8bb98585ab5fb39f$var$Bn, r = $8bb98585ab5fb39f$var$Rn, o = $8bb98585ab5fb39f$var$On, s = $8bb98585ab5fb39f$var$D, d = $8bb98585ab5fb39f$var$I, a = $8bb98585ab5fb39f$var$zn;
    function l(b) {
        return unescape(encodeURIComponent(b)).length;
    }
    function c(b, w, p) {
        const g = [];
        let C;
        for(; (C = b.exec(p)) !== null;)g.push({
            data: C[0],
            index: C.index,
            mode: w,
            length: C[0].length
        });
        return g;
    }
    function f(b) {
        const w = c(s.NUMERIC, t.NUMERIC, b), p = c(s.ALPHANUMERIC, t.ALPHANUMERIC, b);
        let g, C;
        return d.isKanjiModeEnabled() ? (g = c(s.BYTE, t.BYTE, b), C = c(s.KANJI, t.KANJI, b)) : (g = c(s.BYTE_KANJI, t.BYTE, b), C = []), w.concat(p, g, C).sort(function(T, R) {
            return T.index - R.index;
        }).map(function(T) {
            return {
                data: T.data,
                mode: T.mode,
                length: T.length
            };
        });
    }
    function h(b, w) {
        switch(w){
            case t.NUMERIC:
                return e.getBitsLength(b);
            case t.ALPHANUMERIC:
                return n.getBitsLength(b);
            case t.KANJI:
                return o.getBitsLength(b);
            case t.BYTE:
                return r.getBitsLength(b);
        }
    }
    function u(b) {
        return b.reduce(function(w, p) {
            const g = w.length - 1 >= 0 ? w[w.length - 1] : null;
            return g && g.mode === p.mode ? (w[w.length - 1].data += p.data, w) : (w.push(p), w);
        }, []);
    }
    function m(b) {
        const w = [];
        for(let p = 0; p < b.length; p++){
            const g = b[p];
            switch(g.mode){
                case t.NUMERIC:
                    w.push([
                        g,
                        {
                            data: g.data,
                            mode: t.ALPHANUMERIC,
                            length: g.length
                        },
                        {
                            data: g.data,
                            mode: t.BYTE,
                            length: g.length
                        }
                    ]);
                    break;
                case t.ALPHANUMERIC:
                    w.push([
                        g,
                        {
                            data: g.data,
                            mode: t.BYTE,
                            length: g.length
                        }
                    ]);
                    break;
                case t.KANJI:
                    w.push([
                        g,
                        {
                            data: g.data,
                            mode: t.BYTE,
                            length: l(g.data)
                        }
                    ]);
                    break;
                case t.BYTE:
                    w.push([
                        {
                            data: g.data,
                            mode: t.BYTE,
                            length: l(g.data)
                        }
                    ]);
            }
        }
        return w;
    }
    function y(b, w) {
        const p = {}, g = {
            start: {}
        };
        let C = [
            "start"
        ];
        for(let k = 0; k < b.length; k++){
            const T = b[k], R = [];
            for(let j = 0; j < T.length; j++){
                const O = T[j], lt = "" + k + j;
                R.push(lt), p[lt] = {
                    node: O,
                    lastCount: 0
                }, g[lt] = {};
                for(let Ft = 0; Ft < C.length; Ft++){
                    const V = C[Ft];
                    p[V] && p[V].node.mode === O.mode ? (g[V][lt] = h(p[V].lastCount + O.length, O.mode) - h(p[V].lastCount, O.mode), p[V].lastCount += O.length) : (p[V] && (p[V].lastCount = O.length), g[V][lt] = h(O.length, O.mode) + 4 + t.getCharCountIndicator(O.mode, w));
                }
            }
            C = R;
        }
        for(let k = 0; k < C.length; k++)g[C[k]].end = 0;
        return {
            map: g,
            table: p
        };
    }
    function N(b, w) {
        let p;
        const g = t.getBestModeForData(b);
        if (p = t.from(w, g), p !== t.BYTE && p.bit < g.bit) throw new Error('"' + b + '" cannot be encoded with mode ' + t.toString(p) + `.
 Suggested mode is: ` + t.toString(g));
        switch(p === t.KANJI && !d.isKanjiModeEnabled() && (p = t.BYTE), p){
            case t.NUMERIC:
                return new e(b);
            case t.ALPHANUMERIC:
                return new n(b);
            case t.KANJI:
                return new o(b);
            case t.BYTE:
                return new r(b);
        }
    }
    i.fromArray = function(w) {
        return w.reduce(function(p, g) {
            return typeof g == "string" ? p.push(N(g, null)) : g.data && p.push(N(g.data, g.mode)), p;
        }, []);
    }, i.fromString = function(w, p) {
        const g = f(w, d.isKanjiModeEnabled()), C = m(g), k = y(C, p), T = a.find_path(k.map, "start", "end"), R = [];
        for(let j = 1; j < T.length - 1; j++)R.push(k.table[T[j]].node);
        return i.fromArray(u(R));
    }, i.rawSplit = function(w) {
        return i.fromArray(f(w, d.isKanjiModeEnabled()));
    };
})($8bb98585ab5fb39f$var$fi);
const $8bb98585ab5fb39f$var$Vt = $8bb98585ab5fb39f$var$I, $8bb98585ab5fb39f$var$Qt = $8bb98585ab5fb39f$var$Ot, $8bb98585ab5fb39f$var$Dn = $8bb98585ab5fb39f$var$wn, $8bb98585ab5fb39f$var$Vn = $8bb98585ab5fb39f$var$vn, $8bb98585ab5fb39f$var$Fn = $8bb98585ab5fb39f$var$ri, $8bb98585ab5fb39f$var$qn = $8bb98585ab5fb39f$var$oi, $8bb98585ab5fb39f$var$oe = $8bb98585ab5fb39f$var$si, $8bb98585ab5fb39f$var$se = $8bb98585ab5fb39f$var$zt, $8bb98585ab5fb39f$var$jn = $8bb98585ab5fb39f$var$Cn, $8bb98585ab5fb39f$var$Mt = $8bb98585ab5fb39f$var$li, $8bb98585ab5fb39f$var$Hn = $8bb98585ab5fb39f$var$ui, $8bb98585ab5fb39f$var$Wn = $8bb98585ab5fb39f$var$J, $8bb98585ab5fb39f$var$Zt = $8bb98585ab5fb39f$var$fi;
function $8bb98585ab5fb39f$var$Jn(i, t) {
    const e = i.size, n = $8bb98585ab5fb39f$var$qn.getPositions(t);
    for(let r = 0; r < n.length; r++){
        const o = n[r][0], s = n[r][1];
        for(let d = -1; d <= 7; d++)if (!(o + d <= -1 || e <= o + d)) for(let a = -1; a <= 7; a++)s + a <= -1 || e <= s + a || (d >= 0 && d <= 6 && (a === 0 || a === 6) || a >= 0 && a <= 6 && (d === 0 || d === 6) || d >= 2 && d <= 4 && a >= 2 && a <= 4 ? i.set(o + d, s + a, !0, !0) : i.set(o + d, s + a, !1, !0));
    }
}
function $8bb98585ab5fb39f$var$Kn(i) {
    const t = i.size;
    for(let e = 8; e < t - 8; e++){
        const n = e % 2 === 0;
        i.set(e, 6, n, !0), i.set(6, e, n, !0);
    }
}
function $8bb98585ab5fb39f$var$Yn(i, t) {
    const e = $8bb98585ab5fb39f$var$Fn.getPositions(t);
    for(let n = 0; n < e.length; n++){
        const r = e[n][0], o = e[n][1];
        for(let s = -2; s <= 2; s++)for(let d = -2; d <= 2; d++)s === -2 || s === 2 || d === -2 || d === 2 || s === 0 && d === 0 ? i.set(r + s, o + d, !0, !0) : i.set(r + s, o + d, !1, !0);
    }
}
function $8bb98585ab5fb39f$var$Gn(i, t) {
    const e = i.size, n = $8bb98585ab5fb39f$var$Mt.getEncodedBits(t);
    let r, o, s;
    for(let d = 0; d < 18; d++)r = Math.floor(d / 3), o = d % 3 + e - 8 - 3, s = (n >> d & 1) === 1, i.set(r, o, s, !0), i.set(o, r, s, !0);
}
function $8bb98585ab5fb39f$var$Xt(i, t, e) {
    const n = i.size, r = $8bb98585ab5fb39f$var$Hn.getEncodedBits(t, e);
    let o, s;
    for(o = 0; o < 15; o++)s = (r >> o & 1) === 1, o < 6 ? i.set(o, 8, s, !0) : o < 8 ? i.set(o + 1, 8, s, !0) : i.set(n - 15 + o, 8, s, !0), o < 8 ? i.set(8, n - o - 1, s, !0) : o < 9 ? i.set(8, 15 - o - 1 + 1, s, !0) : i.set(8, 15 - o - 1, s, !0);
    i.set(n - 8, 8, 1, !0);
}
function $8bb98585ab5fb39f$var$Qn(i, t) {
    const e = i.size;
    let n = -1, r = e - 1, o = 7, s = 0;
    for(let d = e - 1; d > 0; d -= 2)for(d === 6 && d--;;){
        for(let a = 0; a < 2; a++)if (!i.isReserved(r, d - a)) {
            let l = !1;
            s < t.length && (l = (t[s] >>> o & 1) === 1), i.set(r, d - a, l), o--, o === -1 && (s++, o = 7);
        }
        if (r += n, r < 0 || e <= r) {
            r -= n, n = -n;
            break;
        }
    }
}
function $8bb98585ab5fb39f$var$Zn(i, t, e) {
    const n = new $8bb98585ab5fb39f$var$Dn();
    e.forEach(function(a) {
        n.put(a.mode.bit, 4), n.put(a.getLength(), $8bb98585ab5fb39f$var$Wn.getCharCountIndicator(a.mode, i)), a.write(n);
    });
    const r = $8bb98585ab5fb39f$var$Vt.getSymbolTotalCodewords(i), o = $8bb98585ab5fb39f$var$se.getTotalCodewordsCount(i, t), s = (r - o) * 8;
    for(n.getLengthInBits() + 4 <= s && n.put(0, 4); n.getLengthInBits() % 8 !== 0;)n.putBit(0);
    const d = (s - n.getLengthInBits()) / 8;
    for(let a = 0; a < d; a++)n.put(a % 2 ? 17 : 236, 8);
    return $8bb98585ab5fb39f$var$Xn(n, i, t);
}
function $8bb98585ab5fb39f$var$Xn(i, t, e) {
    const n = $8bb98585ab5fb39f$var$Vt.getSymbolTotalCodewords(t), r = $8bb98585ab5fb39f$var$se.getTotalCodewordsCount(t, e), o = n - r, s = $8bb98585ab5fb39f$var$se.getBlocksCount(t, e), d = n % s, a = s - d, l = Math.floor(n / s), c = Math.floor(o / s), f = c + 1, h = l - c, u = new $8bb98585ab5fb39f$var$jn(h);
    let m = 0;
    const y = new Array(s), N = new Array(s);
    let b = 0;
    const w = new Uint8Array(i.buffer);
    for(let T = 0; T < s; T++){
        const R = T < a ? c : f;
        y[T] = w.slice(m, m + R), N[T] = u.encode(y[T]), m += R, b = Math.max(b, R);
    }
    const p = new Uint8Array(n);
    let g = 0, C, k;
    for(C = 0; C < b; C++)for(k = 0; k < s; k++)C < y[k].length && (p[g++] = y[k][C]);
    for(C = 0; C < h; C++)for(k = 0; k < s; k++)p[g++] = N[k][C];
    return p;
}
function $8bb98585ab5fb39f$var$tr(i, t, e, n) {
    let r;
    if (Array.isArray(i)) r = $8bb98585ab5fb39f$var$Zt.fromArray(i);
    else if (typeof i == "string") {
        let l = t;
        if (!l) {
            const c = $8bb98585ab5fb39f$var$Zt.rawSplit(i);
            l = $8bb98585ab5fb39f$var$Mt.getBestVersionForData(c, e);
        }
        r = $8bb98585ab5fb39f$var$Zt.fromString(i, l || 40);
    } else throw new Error("Invalid data");
    const o = $8bb98585ab5fb39f$var$Mt.getBestVersionForData(r, e);
    if (!o) throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!t) t = o;
    else if (t < o) throw new Error(`
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + o + `.
`);
    const s = $8bb98585ab5fb39f$var$Zn(t, e, r), d = $8bb98585ab5fb39f$var$Vt.getSymbolSize(t), a = new $8bb98585ab5fb39f$var$Vn(d);
    return $8bb98585ab5fb39f$var$Jn(a, t), $8bb98585ab5fb39f$var$Kn(a), $8bb98585ab5fb39f$var$Yn(a, t), $8bb98585ab5fb39f$var$Xt(a, e, 0), t >= 7 && $8bb98585ab5fb39f$var$Gn(a, t), $8bb98585ab5fb39f$var$Qn(a, s), isNaN(n) && (n = $8bb98585ab5fb39f$var$oe.getBestMask(a, $8bb98585ab5fb39f$var$Xt.bind(null, a, e))), $8bb98585ab5fb39f$var$oe.applyMask(n, a), $8bb98585ab5fb39f$var$Xt(a, e, n), {
        modules: a,
        version: t,
        errorCorrectionLevel: e,
        maskPattern: n,
        segments: r
    };
}
$8bb98585ab5fb39f$var$ii.create = function(t, e) {
    if (typeof t > "u" || t === "") throw new Error("No input text");
    let n = $8bb98585ab5fb39f$var$Qt.M, r, o;
    return typeof e < "u" && (n = $8bb98585ab5fb39f$var$Qt.from(e.errorCorrectionLevel, $8bb98585ab5fb39f$var$Qt.M), r = $8bb98585ab5fb39f$var$Mt.from(e.version), o = $8bb98585ab5fb39f$var$oe.from(e.maskPattern), e.toSJISFunc && $8bb98585ab5fb39f$var$Vt.setToSJISFunction(e.toSJISFunc)), $8bb98585ab5fb39f$var$tr(t, r, n, o);
};
var $8bb98585ab5fb39f$var$pi = {}, $8bb98585ab5fb39f$var$_e = {};
(function(i) {
    function t(e) {
        if (typeof e == "number" && (e = e.toString()), typeof e != "string") throw new Error("Color should be defined as hex string");
        let n = e.slice().replace("#", "").split("");
        if (n.length < 3 || n.length === 5 || n.length > 8) throw new Error("Invalid hex color: " + e);
        (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(o) {
            return [
                o,
                o
            ];
        }))), n.length === 6 && n.push("F", "F");
        const r = parseInt(n.join(""), 16);
        return {
            r: r >> 24 & 255,
            g: r >> 16 & 255,
            b: r >> 8 & 255,
            a: r & 255,
            hex: "#" + n.slice(0, 6).join("")
        };
    }
    i.getOptions = function(n) {
        n || (n = {}), n.color || (n.color = {});
        const r = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, o = n.width && n.width >= 21 ? n.width : void 0, s = n.scale || 4;
        return {
            width: o,
            scale: o ? 4 : s,
            margin: r,
            color: {
                dark: t(n.color.dark || "#000000ff"),
                light: t(n.color.light || "#ffffffff")
            },
            type: n.type,
            rendererOpts: n.rendererOpts || {}
        };
    }, i.getScale = function(n, r) {
        return r.width && r.width >= n + r.margin * 2 ? r.width / (n + r.margin * 2) : r.scale;
    }, i.getImageWidth = function(n, r) {
        const o = i.getScale(n, r);
        return Math.floor((n + r.margin * 2) * o);
    }, i.qrToImageData = function(n, r, o) {
        const s = r.modules.size, d = r.modules.data, a = i.getScale(s, o), l = Math.floor((s + o.margin * 2) * a), c = o.margin * a, f = [
            o.color.light,
            o.color.dark
        ];
        for(let h = 0; h < l; h++)for(let u = 0; u < l; u++){
            let m = (h * l + u) * 4, y = o.color.light;
            if (h >= c && u >= c && h < l - c && u < l - c) {
                const N = Math.floor((h - c) / a), b = Math.floor((u - c) / a);
                y = f[d[N * s + b] ? 1 : 0];
            }
            n[m++] = y.r, n[m++] = y.g, n[m++] = y.b, n[m] = y.a;
        }
    };
})($8bb98585ab5fb39f$var$_e);
(function(i) {
    const t = $8bb98585ab5fb39f$var$_e;
    function e(r, o, s) {
        r.clearRect(0, 0, o.width, o.height), o.style || (o.style = {}), o.height = s, o.width = s, o.style.height = s + "px", o.style.width = s + "px";
    }
    function n() {
        try {
            return document.createElement("canvas");
        } catch  {
            throw new Error("You need to specify a canvas element");
        }
    }
    i.render = function(o, s, d) {
        let a = d, l = s;
        typeof a > "u" && (!s || !s.getContext) && (a = s, s = void 0), s || (l = n()), a = t.getOptions(a);
        const c = t.getImageWidth(o.modules.size, a), f = l.getContext("2d"), h = f.createImageData(c, c);
        return t.qrToImageData(h.data, o, a), e(f, l, c), f.putImageData(h, 0, 0), l;
    }, i.renderToDataURL = function(o, s, d) {
        let a = d;
        typeof a > "u" && (!s || !s.getContext) && (a = s, s = void 0), a || (a = {});
        const l = i.render(o, s, a), c = a.type || "image/png", f = a.rendererOpts || {};
        return l.toDataURL(c, f.quality);
    };
})($8bb98585ab5fb39f$var$pi);
var $8bb98585ab5fb39f$var$mi = {};
const $8bb98585ab5fb39f$var$er = $8bb98585ab5fb39f$var$_e;
function $8bb98585ab5fb39f$var$Oe(i, t) {
    const e = i.a / 255, n = t + '="' + i.hex + '"';
    return e < 1 ? n + " " + t + '-opacity="' + e.toFixed(2).slice(1) + '"' : n;
}
function $8bb98585ab5fb39f$var$te(i, t, e) {
    let n = i + t;
    return typeof e < "u" && (n += " " + e), n;
}
function $8bb98585ab5fb39f$var$ir(i, t, e) {
    let n = "", r = 0, o = !1, s = 0;
    for(let d = 0; d < i.length; d++){
        const a = Math.floor(d % t), l = Math.floor(d / t);
        !a && !o && (o = !0), i[d] ? (s++, d > 0 && a > 0 && i[d - 1] || (n += o ? $8bb98585ab5fb39f$var$te("M", a + e, 0.5 + l + e) : $8bb98585ab5fb39f$var$te("m", r, 0), r = 0, o = !1), a + 1 < t && i[d + 1] || (n += $8bb98585ab5fb39f$var$te("h", s), s = 0)) : r++;
    }
    return n;
}
$8bb98585ab5fb39f$var$mi.render = function(t, e, n) {
    const r = $8bb98585ab5fb39f$var$er.getOptions(e), o = t.modules.size, s = t.modules.data, d = o + r.margin * 2, a = r.color.light.a ? "<path " + $8bb98585ab5fb39f$var$Oe(r.color.light, "fill") + ' d="M0 0h' + d + "v" + d + 'H0z"/>' : "", l = "<path " + $8bb98585ab5fb39f$var$Oe(r.color.dark, "stroke") + ' d="' + $8bb98585ab5fb39f$var$ir(s, o, r.margin) + '"/>', c = 'viewBox="0 0 ' + d + " " + d + '"', h = '<svg xmlns="http://www.w3.org/2000/svg" ' + (r.width ? 'width="' + r.width + '" height="' + r.width + '" ' : "") + c + ' shape-rendering="crispEdges">' + a + l + `</svg>
`;
    return typeof n == "function" && n(null, h), h;
};
const $8bb98585ab5fb39f$var$nr = $8bb98585ab5fb39f$var$yn, $8bb98585ab5fb39f$var$ae = $8bb98585ab5fb39f$var$ii, $8bb98585ab5fb39f$var$bi = $8bb98585ab5fb39f$var$pi, $8bb98585ab5fb39f$var$rr = $8bb98585ab5fb39f$var$mi;
function $8bb98585ab5fb39f$var$we(i, t, e, n, r) {
    const o = [].slice.call(arguments, 1), s = o.length, d = typeof o[s - 1] == "function";
    if (!d && !$8bb98585ab5fb39f$var$nr()) throw new Error("Callback required as last argument");
    if (d) {
        if (s < 2) throw new Error("Too few arguments provided");
        s === 2 ? (r = e, e = t, t = n = void 0) : s === 3 && (t.getContext && typeof r > "u" ? (r = n, n = void 0) : (r = n, n = e, e = t, t = void 0));
    } else {
        if (s < 1) throw new Error("Too few arguments provided");
        return s === 1 ? (e = t, t = n = void 0) : s === 2 && !t.getContext && (n = e, e = t, t = void 0), new Promise(function(a, l) {
            try {
                const c = $8bb98585ab5fb39f$var$ae.create(e, n);
                a(i(c, t, n));
            } catch (c) {
                l(c);
            }
        });
    }
    try {
        const a = $8bb98585ab5fb39f$var$ae.create(e, n);
        r(null, i(a, t, n));
    } catch (a) {
        r(a);
    }
}
$8bb98585ab5fb39f$var$ae.create;
var $8bb98585ab5fb39f$var$or = $8bb98585ab5fb39f$var$we.bind(null, $8bb98585ab5fb39f$var$bi.render);
$8bb98585ab5fb39f$var$we.bind(null, $8bb98585ab5fb39f$var$bi.renderToDataURL);
$8bb98585ab5fb39f$var$we.bind(null, function(i, t, e) {
    return $8bb98585ab5fb39f$var$rr.render(i, e);
});
const $8bb98585ab5fb39f$var$sr = $8bb98585ab5fb39f$var$Rt`
  <svg class="preloader-icon" width="38" height="37" viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0085 0.166504H21.0827V10.6203C20.4178 10.445 19.7197 10.3517 18.9998 10.3517C18.3129 10.3517 17.6458 10.4367 17.0085 10.5967V0.166504ZM14.8895 11.4628L7.66711 4.24051L4.78632 7.1213L11.9969 14.3319C12.7027 13.1486 13.6999 12.1592 14.8895 11.4628ZM11.0305 16.794H0.666504V20.8681H11.2012C10.9739 20.1186 10.8517 19.3235 10.8517 18.4998C10.8517 17.9147 10.9133 17.3441 11.0305 16.794ZM12.1069 22.847L4.78624 30.1677L7.66703 33.0485L15.074 25.6416C13.8645 24.9753 12.8424 24.0108 12.1069 22.847ZM17.0085 26.4029V36.8331H21.0827V26.3792C20.4178 26.5546 19.7197 26.6479 18.9998 26.6479C18.3129 26.6479 17.6458 26.563 17.0085 26.4029ZM23.1678 25.5027L30.7136 33.0485L33.5943 30.1677L26.0367 22.6101C25.3405 23.7998 24.3511 24.7969 23.1678 25.5027ZM26.7984 20.8681H37.3331V16.794H26.9691C27.0862 17.3441 27.1479 17.9147 27.1479 18.4998C27.1479 19.3235 27.0257 20.1186 26.7984 20.8681ZM26.1416 14.574L33.5943 7.1213L30.7134 4.24051L23.347 11.6069C24.5108 12.3424 25.4753 13.3645 26.1416 14.574Z" fill="#01B93C"/>
  </svg>
`, $8bb98585ab5fb39f$var$ar = $8bb98585ab5fb39f$var$Rt`
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 1.46927L13.335 3.20167L13.3721 3.20459C11.9834 1.55307 9.91034 0.5 7.57023 0.5C3.3829 0.5 0 3.85744 0 8.00073C0 12.1428 3.39947 15.5 7.58596 15.5C10.8269 15.5 13.5962 13.4868 14.6773 10.6536L11.8955 9.50384C11.2682 11.259 9.57406 12.519 7.58973 12.519C5.06974 12.519 3.02377 10.4919 3.02377 8.00073C3.02377 5.5075 5.07142 3.47932 7.59099 3.47932C9.09942 3.47932 10.4351 4.20888 11.2684 5.32762L9.44743 7.01353L15 7.01103V1.46927Z" fill="white"/>
  </svg>
`, $8bb98585ab5fb39f$var$dr = $8bb98585ab5fb39f$var$Rt`
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75955 0.0308444C6.91657 -0.0102815 7.08327 -0.0102815 7.2403 0.0308444L13.3653 1.63077C13.741 1.72896 14 2.04289 14 2.40008V9.21445C14 11.224 12.8223 13.0796 10.9139 14.0766L7.43402 15.8945C7.16511 16.0352 6.83492 16.0352 6.56598 15.8945L3.08612 14.0766C1.17772 13.0795 0 11.2241 0 9.21445V2.40008C0 2.04289 0.258973 1.72894 0.63472 1.63077L6.75955 0.0308444ZM11.1079 6.18723C11.4016 5.86544 11.3676 5.37634 11.0319 5.09478C10.6962 4.81323 10.1859 4.84583 9.89215 5.16761L6.62491 8.74674L4.80357 7.38889C4.45146 7.12639 3.944 7.18719 3.67014 7.5247C3.39627 7.8622 3.45971 8.3486 3.81182 8.61111L6.2349 10.4176C6.5727 10.6694 7.05681 10.625 7.33862 10.3163L11.1079 6.18723Z" fill="#089726"/>
  </svg>
`, $8bb98585ab5fb39f$var$lr = $8bb98585ab5fb39f$var$Bt`
    :host {
        --default-dialog-title-size: 24px;
        --default-dialog-title-weight: 500;
        --default-dialog-title-color: #2E3233;
        --default-dialog-title-margin: 0 0 12px;
        --default-description-text-color: #686B6C;
        --default-description-text-size: 16px;
        --default-divider-width: 224px;
        --default-divider-margin: 0 auto 24px;
        --default-divider-bg: #E7E7E7;
        --default-divider-text-color: #686B6C;
        --default-divider-text-size: 12px;
        --default-divider-text-padding: 0 10px;
        --default-divider-text-bg: #ffffff;
        --default-btn-height: 56px;
        --default-btn-bg: #01B93C;
        --default-btn-bg-hover: #82b435;
        --default-btn-color: #ffffff;
        --default-btn-size: 22px;
        --default-btn-weight: 500;
        --default-btn-padding: 0 24px;
        --default-btn-border: none;
        --default-btn-transform: none;
        --default-btn-box-shadow: none;
        --default-btn-hover-box-shadow: none;
        --default-btn-radius: 5px;
        --default-btn-radius-hover: 5px;
        --default-btn-border: none;
        --default-btn-border-hover: none;
        --default-dialog-secure-text-color: #3e3e3e;
        --default-dialog-secure-text-size: 14px;
        --default-qrcode-blur-image: url("/joxi/bank-id/blur-qr.png");
        --default-bankid-failed-text-color: #686B6C;
        --default-bankid-failed-text-size: 12px;
        --default-bankid-failed-text-margin: 0 0 2px;
        --default-bankid-failed-icon-background: #01B93C;
        --default-bankid-failed-icon-background-hover: #82b435;
        --default-bankid-failed-icon-border: none;
        --default-bankid-failed-icon-border-hover: none;
        --default-bankid-failed-icon-radius: 4px;
        --default-bankid-failed-icon-radius-hover: 4px;
        --default-bankid-failed-icon-width: 48px;
        --default-bankid-failed-icon-height: 48px;
        --default-bankid-button-logo-margin: 4px 14px 0 0;
        --default-bankid-button-logo-height: 24px;
        --default-dialog-title-text-transform: none;
        --default-dialog-title-font-style: none;

        width: 100%;
    }
    .title {
        font-size: var(--dialog-title-size, var(--default-dialog-title-size));
        font-weight: var(--dialog-title-weight, var(--default-dialog-title-weight));
        color: var(--dialog-title-color, var(--default-dialog-title-color));
        margin: var(--dialog-title-margin, var(--default-dialog-title-margin));
        font-style: var(--dialog-title-font-style, var(--default-dialog-title-font-style));
        text-transform: var(--dialog-title-text-transform, var(--default-dialog-title-text-transform));
    }
    .text {
        color: var(--description-text-color, var(--default-description-text-color));
        font-size: var(--description-text-size, var(--default-description-text-size));
        line-height: 140%;
    }
    .divider {
        max-width: var(--divider-width, var(--default-divider-width));
        width: 100%;
        position: relative;
        margin: var(--divider-margin, var(--default-divider-margin));
    }
    .divider:before, .divider:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: var(--divider-bg, var(--default-divider-bg));
        top: 60%;
        left: 0;
        z-index: 1;
    }
    .divider-text {
        position: relative;
        z-index: 2;
        font-size: var(--divider-text-size, var(--default-divider-text-size));
        color: var(--divider-text-color, var(--default-divider-text-color));
        padding: var(--divider-text-padding, var(--default-divider-text-padding));
        background-color: var(--divider-text-bg, var(--default-divider-text-bg));
    }
    .btn-primary {
        min-height: var(--btn-height, var(--default-btn-height));
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--btn-bg, var(--default-btn-bg));
        margin: 0 auto;
        color: var(--btn-color, var(--default-btn-color));
        font-size: var(--btn-size, var(--default-btn-size));
        font-weight: var(--btn-weight, var(--default-btn-weight));
        padding: var(--btn-padding, var(--default-btn-padding));
        border: var(--btn-border, var(--default-btn-border));
        transform: var(--btn-transform, var(--default-btn-transform));
        box-shadow: var(--btn-box-shadow, var(--default-btn-box-shadow));
        border-radius: var(--btn-radius, var(--default-btn-radius));
        border: var(--btn-border, var(--default-btn-border));
    }
    .btn-primary:hover {
        background-color: var(--btn-bg-hover, var(--default-btn-bg-hover));
        border: var(--btn-border-hover, var(--default-btn-border-hover));
        border-radius: var(--btn-radius-hover, var(--default-btn-radius-hover));
        box-shadow: var(--btn-hover-box-shadow, var(--default-btn-hover-box-shadow));
    }
    .preloader-icon {
        margin: 12px auto 0;
        animation: rotatePreloader 3s linear infinite;
    }
    .qrCode {
        position: relative;
        margin: 12px auto 8px;
    }
    .qrCode.isFailed canvas {
        filter: blur(5px);
        opacity: 0.4;
    }
    .qrCode.isFailed .failed {
        display: flex;
    }
    .failed {
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 180px;
        position: absolute;
        top: calc(50% - 34px);
    }
    .failed-text {
        font-size: var(--bankid-failed-text-size, var(--default-bankid-failed-text-size));
        line-height: 140%;
        color: var(--bankid-failed-text-color, var(--default-bankid-failed-text-color));
        margin-bottom: var(--bankid-failed-text-margin, var(--default-bankid-failed-text-margin));
    }
    .failed-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: var(--bankid-failed-icon-width, var(--default-bankid-failed-icon-width));
        height: var(--bankid-failed-icon-height, var(--default-bankid-failed-icon-height));
        background-color: var(--bankid-failed-icon-background, var(--default-bankid-failed-icon-background));
        border-radius: var(--bankid-failed-icon-radius, var(--default-bankid-failed-icon-radius));
        cursor: pointer;
        border: var(--bankid-failed-icon-border, var(--default-bankid-failed-icon-border));
    }
    .failed-icon:hover {
        background-color: var(--bankid-failed-icon-background-hover, var(--default-bankid-failed-icon-background-hover));
        border: var(--bankid-failed-icon-border-hover, var(--default-bankid-failed-icon-border-hover));
        border-radius: var(--bankid-failed-icon-radius-hover, var(--default-bankid-failed-icon-radius-hover));
    }
    .content {
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        height: 100%;
    }
    .middle {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
    }
    .secure {
        display: flex;
        width: 100%;
        max-width: 224px;
        margin: 28px auto 0;
    }
    .secure-icon {
        width: 14px;
        height: 16px;
        margin-right: 8px;
        margin-top: 2px;
    }
    .secure-texts {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
    }
    .secure-text {
        font-size: var(--dialog-secure-text-size, var(--default-dialog-secure-text-size));
        color: var(--dialog-secure-text-color, var(--default-dialog-secure-text-color));
        line-height: 140%;
    }
    .secure-text.fw500 {
        font-weight: 500;
    }
    @keyframes rotatePreloader {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;
class $8bb98585ab5fb39f$var$cr {
    constructor(t){
        this.api = t;
    }
    init(t) {
        return this.fetch(`${this.api}/ident/init`, {
            method: "POST",
            body: JSON.stringify(t)
        });
    }
    status(t) {
        const e = new URLSearchParams(t).toString();
        return this.fetch(`${this.api}/ident/status?${e}`, {
            method: "GET"
        });
    }
    auth(t) {
        return this.fetch(`${this.api}/ident/auth`, {
            method: "POST",
            body: JSON.stringify(t)
        });
    }
    fetch(t, e) {
        if (e != null && e.method && !e.headers && [
            "POST",
            "PUT"
        ].includes(e.method)) {
            const n = new Headers();
            n.append("Content-Type", "application/json"), e.headers = n;
        }
        return fetch(t, e).then(async (n)=>({
                status: n.status,
                ...await n.json()
            }));
    }
}
var $8bb98585ab5fb39f$var$ur = Object.defineProperty, $8bb98585ab5fb39f$var$hr = Object.getOwnPropertyDescriptor, $8bb98585ab5fb39f$var$x = (i, t, e, n)=>{
    for(var r = n > 1 ? void 0 : n ? $8bb98585ab5fb39f$var$hr(t, e) : t, o = i.length - 1, s; o >= 0; o--)(s = i[o]) && (r = (n ? s(t, e, r) : s(r)) || r);
    return n && r && $8bb98585ab5fb39f$var$ur(t, e, r), r;
};
let $8bb98585ab5fb39f$export$d5af2e21b8bae06f = class extends $8bb98585ab5fb39f$var$W {
    constructor(){
        super(...arguments), this.qrcode = "", this.orderId = "", this.autoStartToken = "", this.isAuthExpired = !1, this.redirect = $8bb98585ab5fb39f$export$52e477023a1a39bb(), this.api = `/${$8bb98585ab5fb39f$export$5803c3c1cacc7a03()}/api/v2`, this.qrbackground = "#0000", this.qrcolor = "#000", this.maxstatusrequests = 300, this.isDestroyed = !1;
    }
    i(i) {
        return $8bb98585ab5fb39f$export$d73ee8ef04f5226a(i, this.translations);
    }
    firstUpdated() {
        this.apiService = new $8bb98585ab5fb39f$var$cr(this.api), this.initAuth();
    }
    disconnectedCallback() {
        this.isDestroyed = !0, super.disconnectedCallback();
    }
    updated() {
        this.canvas && this.qrcode && $8bb98585ab5fb39f$var$or(this.canvas, this.qrcode, {
            width: 180,
            color: {
                light: this.qrbackground,
                dark: this.qrcolor
            }
        });
    }
    render() {
        const i = $8bb98585ab5fb39f$var$z`
          <div class="${$8bb98585ab5fb39f$var$Xe({
            qrCode: !0,
            isFailed: this.error || this.isAuthExpired
        })}">
              <canvas class="canvas" id="auth-bank-id-canvas"></canvas>
              <div class="failed">
                  <p class="failed-text">${this.i("auth_bankid.status_loading__reload_qr")}</p>
                  <button @click="${this.initAuth}" class="failed-icon">
                      ${$8bb98585ab5fb39f$var$ar}
                  </button>
              </div>
          </div>
        `, t = $8bb98585ab5fb39f$export$d0a8044dce8ff2fc() ? "https://app.bankid.com/?" : "bankid:///?", e = $8bb98585ab5fb39f$export$d0a8044dce8ff2fc() ? "_blank" : $8bb98585ab5fb39f$var$P, n = $8bb98585ab5fb39f$export$5f369ca6979c8db0[Number(this.error)], r = "auth_bankid.subtitle_sign_in", o = "auth_bankid.body_sign_in";
        return !this.qrcode && !this.isAuthExpired && !this.error ? $8bb98585ab5fb39f$var$z`
                <div class="content">
                    <div class="middle">
                        <h2 class="title">${this.i("auth_bankid.status_loading_qr")}</h2>
                        ${$8bb98585ab5fb39f$var$sr}
                    </div>
                    ${this.getSecureFooter()}
                </div>
            ` : $8bb98585ab5fb39f$var$z`
            <div class="content">
                <div class="middle">
                    <h2 class="title">${this.i((n == null ? void 0 : n.title) || r)}</h2>
                    <p class="text">${this.i((n == null ? void 0 : n.text) || o)}</p>
                    ${i}
                    <div class="divider">
                        <span class="divider-text">${this.i("auth_bankid.or")}</span>
                    </div>
                    <a href="${t}${this.getQueryParams()}" class="btn-primary" target="${e}">
                        ${this.i("auth_bankid.button_sign_in")}
                    </a>
                </div>
                ${this.getSecureFooter()}
            </div>
        `;
    }
    getSecureFooter() {
        return $8bb98585ab5fb39f$var$z`
            <div class="secure">
                <div class="secure-icon">${$8bb98585ab5fb39f$var$dr}</div>
                <div class="secure-texts">
                    <p class="secure-text fw500">${this.i("auth_bankid.secure_1")}</p>
                    <p class="secure-text">${this.i("auth_bankid.secure_2")}</p>
                </div>
            </div>`;
    }
    initAuth() {
        this.isAuthExpired = !1, this.error = void 0, this.qrcode = "";
        const i = {
            amount: 0,
            currency: "SEK",
            locale: "sv_SE"
        };
        this.initPromise = this.apiService.init({
            ...this.getAffiliate(),
            paymethod: "bankid",
            amount: Number(this.amount) || i.amount,
            currency: this.currency || i.currency,
            locale: this.locale || i.locale
        }).then((t)=>this.verifiedAuth(t)).catch((t)=>{
            t && !(t instanceof $8bb98585ab5fb39f$export$2cf64874b731abec) && (this.error = $8bb98585ab5fb39f$export$50bd195c3026f49d[$8bb98585ab5fb39f$export$eac3055710931ba4.NetworkError], this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.NetworkError, {
                order_id: void 0
            })), this.qrcode = $8bb98585ab5fb39f$export$eac3055710931ba4.UnknownError;
        });
    }
    verifiedAuth(i) {
        var r;
        if (this.errorCodeHandler((r = i == null ? void 0 : i.result) == null ? void 0 : r.order_id, i)) return Promise.reject(new $8bb98585ab5fb39f$export$2cf64874b731abec("Init error"));
        const t = i.result;
        this.qrcode = t.qrCode, this.autoStartToken = t.autoStartToken;
        const e = t.order_id, n = "bankid";
        return this.status({
            order_id: e,
            paymethod: n
        }).then(()=>this.apiService.auth({
                ...this.getAffiliate(),
                ...t,
                order_id: t.order_id,
                paymethod: n
            })).then((o)=>this.errorCodeHandler(t == null ? void 0 : t.order_id, o) ? Promise.reject(new $8bb98585ab5fb39f$export$2cf64874b731abec("Auth error")) : o.result ? this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.SuccessLogin, o.result) : Promise.reject("Unknown auth status"));
    }
    async status(i) {
        var n, r, o;
        let t, e = 0;
        for(; ((n = t == null ? void 0 : t.result) == null ? void 0 : n.status) !== "complete";){
            if (((r = t == null ? void 0 : t.result) == null ? void 0 : r.status) === "failed") return this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.AuthFailed), this.isAuthExpired = !0, Promise.reject(new $8bb98585ab5fb39f$export$2cf64874b731abec("Auth failed error"));
            if (this.errorCodeHandler(i.order_id, t)) return Promise.reject(new $8bb98585ab5fb39f$export$2cf64874b731abec("Status error"));
            if (e++, e > Number(this.maxstatusrequests)) return Promise.reject("Max status requests reached");
            if (await this.wait(1e3), this.isDestroyed) return Promise.reject(new $8bb98585ab5fb39f$export$2cf64874b731abec("`auth-bank-id-content` was destroyed"));
            t = await this.apiService.status(i), this.qrcode = (o = t == null ? void 0 : t.result) == null ? void 0 : o.qrCode;
        }
        return t;
    }
    sendEvent(i, t) {
        this.dispatchEvent(new CustomEvent(i, {
            detail: t || {
                name: i
            },
            bubbles: !0,
            composed: !0
        }));
    }
    errorCodeHandler(i, t) {
        if (!t) return !1;
        const e = t.messages || [];
        e.length && this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.AuthError, e);
        for (const r of e){
            const o = r.code;
            if (o === $8bb98585ab5fb39f$export$50bd195c3026f49d[$8bb98585ab5fb39f$export$eac3055710931ba4.ShowRegistration]) return this.sendEvent($8bb98585ab5fb39f$export$eac3055710931ba4.ShowRegistration, {
                order_id: i,
                profile: r.data.person,
                is_registration_bonuses_shown: r.data.is_registration_bonuses_shown
            }), !0;
            if ($8bb98585ab5fb39f$export$aff8451eb9856edd[o]) return this.error = r.code, this.sendEvent($8bb98585ab5fb39f$export$aff8451eb9856edd[r.code], {
                order_id: i
            }), !0;
        }
        let n = t.status;
        return n > 400 && !$8bb98585ab5fb39f$export$aff8451eb9856edd[n] && (n = 500), $8bb98585ab5fb39f$export$aff8451eb9856edd[n] ? (this.error = n, this.sendEvent($8bb98585ab5fb39f$export$aff8451eb9856edd[n], {
            order_id: i
        }), !0) : !1;
    }
    wait(i) {
        return new Promise((t)=>setTimeout(t, i));
    }
    getQueryParams() {
        const i = {
            autostarttoken: this.autoStartToken,
            redirect: this.redirect
        };
        return new URLSearchParams(i).toString();
    }
    getAffiliate() {
        var t;
        const i = this.affiliate || {};
        return {
            ...i,
            // @ts-ignore
            affiliate: ((t = this.affiliate) == null ? void 0 : t.affiliate) || {},
            qa: this.qa || i.qa || {},
            adformcookieid: this.adformcookieid || i.adformcookieid
        };
    }
};
$8bb98585ab5fb39f$export$d5af2e21b8bae06f.styles = [
    $8bb98585ab5fb39f$var$ge,
    $8bb98585ab5fb39f$var$lr
];
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$dt()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "qrcode", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$dt()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "orderId", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$dt()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "autoStartToken", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$dt()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "isAuthExpired", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$dt()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "error", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "redirect", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "api", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "affiliate", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "amount", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "currency", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "locale", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "qa", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "qrbackground", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "qrcolor", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "adformcookieid", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_()
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "maxstatusrequests", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$_({
        type: Object
    })
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "translations", 2);
$8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$Ze("#auth-bank-id-canvas")
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f.prototype, "canvas", 2);
$8bb98585ab5fb39f$export$d5af2e21b8bae06f = $8bb98585ab5fb39f$var$x([
    $8bb98585ab5fb39f$var$Ut("bsc-auth-bank-id-content")
], $8bb98585ab5fb39f$export$d5af2e21b8bae06f);








const $c30c65d0e349ff31$export$150b732325d14d04 = "translations";
class $c30c65d0e349ff31$var$TranslationsService {
    static $inject = [
        "$translate",
        "config"
    ];
    constructor($translate, config){
        this.$translate = $translate;
        this.config = config;
    }
    getTranslationsByPrefix(prefix) {
        return this.getAllTranslations(this.config.currentLang).then((translations)=>{
            return Object.fromEntries(Object.entries(translations).filter(([key, value])=>key.startsWith(prefix)));
        });
    }
    getAllTranslations(lang) {
        return this.$translate.use(lang).then(()=>{
            return this.$translate.getTranslationTable();
        }).catch((error)=>{
            console.error("Error while getting translations:", error);
        });
    }
}
app.factory($c30c65d0e349ff31$export$150b732325d14d04, $c30c65d0e349ff31$var$TranslationsService);


(function() {
    "use strict";
    app.factory("bankid.config", controller);
    controller.$inject = [];
    function controller() {
        // bankid works only with sweden
        return {
            enabled: true,
            min: 100,
            max: 5000,
            default: 0,
            range: [
                1000,
                2000,
                5000
            ],
            currency: "SEK",
            locale: "sv_SE",
            errorCodes: [
                2205,
                2281
            ]
        };
    }
})();




(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)(1);
    }
    app.factory("bankidBtn", controller);
})();



/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $891rE = parcelRequire("891rE");

var $lXN9m = parcelRequire("lXN9m");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
var $1f0366c2e18b58ad$export$e5fdd83ec9152026 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}((0, $2Dqpi.Subscriber));


/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
var $f97d2f4f8ff7fd7c$export$6cd922279ed50d2b = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}((0, $2Dqpi.Subscriber));




var $eGy0D = parcelRequire("eGy0D");
function $206b0469fe14350a$export$d0604af3321cfb1b(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) innerSubscriber = new (0, $f97d2f4f8ff7fd7c$export$6cd922279ed50d2b)(outerSubscriber, outerValue, outerIndex);
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, $eGy0D.Observable)) return result.subscribe(innerSubscriber);
    return (0, $502e36bd22b657d8$export$45e4095b0ba1d337)(result)(innerSubscriber);
}



var $83Fxp = parcelRequire("83Fxp");
var $913d9ff860ca23ca$var$NONE = {};
function $913d9ff860ca23ca$export$77fa7d86f5204e8a() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = undefined;
    var scheduler = undefined;
    if ((0, $891rE.isScheduler)(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === "function") resultSelector = observables.pop();
    if (observables.length === 1 && (0, $lXN9m.isArray)(observables[0])) observables = observables[0];
    return (0, $83Fxp.fromArray)(observables, scheduler).lift(new $913d9ff860ca23ca$export$f252ced05c51d8e7(resultSelector));
}
var $913d9ff860ca23ca$export$f252ced05c51d8e7 = /*@__PURE__*/ function() {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $913d9ff860ca23ca$export$b847d1ba97f572c0(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}();
var $913d9ff860ca23ca$export$b847d1ba97f572c0 = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($913d9ff860ca23ca$var$NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add((0, $206b0469fe14350a$export$d0604af3321cfb1b)(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $913d9ff860ca23ca$var$NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) this._tryResultSelector(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function(values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}((0, $1f0366c2e18b58ad$export$e5fdd83ec9152026));



class $b54b4712f1118475$var$AuthBankidDirective {
    static $inject = [
        "$document",
        "$translate",
        "$cookies",
        "modal",
        "popup",
        "user",
        "notification$",
        "state",
        "translations",
        "bankid.config",
        "config",
        "bankidBtn",
        "localStorage"
    ];
    constructor($document, $translate, $cookies, modal, popup, user, notification$, state, translations, bankid_config, config, bankidBtn$, localStorage){
        this.$document = $document;
        this.$translate = $translate;
        this.$cookies = $cookies;
        this.modal = modal;
        this.popup = popup;
        this.user = user;
        this.notification$ = notification$;
        this.state = state;
        this.translations = translations;
        this.bankid_config = bankid_config;
        this.config = config;
        this.bankidBtn$ = bankidBtn$;
        this.localStorage = localStorage;
    }
    link($scope, element) {
        const translationsPrefix = "auth_bankid.";
        const htmlDocument = this.$document[0];
        const bankIdElement = element[0];
        const translations$ = new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)(1);
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const affiliateParams = JSON.parse(this.localStorage.get("params") || "{}");
        const fbpValue = this.$cookies.get("_fbp");
        if (fbpValue) affiliateParams.affiliate = {
            ...affiliateParams.affiliate,
            fbp: fbpValue
        };
        const openErrorModal = (errors)=>{
            const error = errors?.filter((data)=>this.bankid_config.errorCodes.includes(data.code));
            if (!error.length) return;
            bankIdElement.closeAll();
            this.modal.open("error", {
                code: error[0].code
            });
        };
        $scope.locale = this.config.currentLang === "en" ? "en_SE" : this.bankid_config.locale;
        (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)([
            this.bankidBtn$,
            translations$
        ]).pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe(()=>{
            bankIdElement.openDialog();
        });
        this.translations.getTranslationsByPrefix(translationsPrefix).then((translations)=>{
            bankIdElement.setAttribute("translations", JSON.stringify(translations));
            bankIdElement.setAttribute("affiliate", JSON.stringify(affiliateParams));
            translations$.next(translations);
        });
        htmlDocument.addEventListener("dialogopen", ()=>{
            htmlDocument.documentElement.classList.add("bsc-has-popup");
        });
        htmlDocument.addEventListener("dialogclosed", ()=>{
            htmlDocument.documentElement.classList.remove("bsc-has-popup");
            this.popup.close();
        });
        htmlDocument.addEventListener("successlogin", ({ detail: detail })=>{
            this.user.profile = detail;
            this.notification$.next({
                type: "success",
                code: 0,
                text: this.$translate.instant("login_successful")
            });
        });
        htmlDocument.addEventListener("showregistration", ({ detail: detail })=>{
            this.modal.open("bankid-registration", {
                profile: detail.profile,
                is_registration_bonuses_shown: detail.is_registration_bonuses_shown,
                token: detail.order_id
            }).then(()=>{
                this.state.goto("home");
            });
        });
        htmlDocument.addEventListener("autherror", ({ detail: detail })=>{
            openErrorModal(detail);
        });
        $scope.$on("$destroy", ()=>{
            translations$.unsubscribe();
            destroy$.unsubscribe();
        });
    }
}
app.directive("authBankid", ()=>{
    return {
        restrict: "A",
        controller: $b54b4712f1118475$var$AuthBankidDirective,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope, element, attrs, ctrl);
        }
    };
});


var $ff6a01f25bb09edb$exports = {};



class $ff6a01f25bb09edb$var$PopupBankidDirective {
    static $inject = [
        "$document",
        "translations",
        "config",
        "bankidBtn"
    ];
    constructor($document, translations, config, bankidBtn$){
        this.$document = $document;
        this.translations = translations;
        this.config = config;
        this.bankidBtn$ = bankidBtn$;
    }
    link() {
        this.bankidBtn$.next(true);
    }
}
app.directive("popupBankid", ()=>{
    return {
        restrict: "A",
        controller: $ff6a01f25bb09edb$var$PopupBankidDirective,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope, element, attrs, ctrl);
        }
    };
});


var $0c3d179d5bec3a4d$exports = {};



(function() {
    "use strict";
    app.factory("banner", controller);
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        return {
            collection (options) {
                const defer = $q.defer();
                const alias = "bannerList";
                const config = {
                    cache: false,
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
})();






(function() {
    "use strict";
    const directive = {
        name: "bonusCrabInit"
    };
    controller.$inject = [
        "$state",
        "config",
        "state",
        "banner",
        "game",
        "popup",
        "user",
        "account"
    ];
    function controller($state, _config, _state, _banner, _game, _popup, _user, _account) {
        const link = (scope, element)=>{
            if (_config.feature?.crab_sdk?.visible === false) {
                _state.goto("home");
                return;
            }
            scope.preloader = true;
            let crab = null;
            let p1 = Promise.resolve(true);
            if (typeof Crab === "undefined") {
                const script = document.createElement("script");
                script.src = `/joxi/js/crab/sdk/launch.v1.js?t=${Date.now()}`;
                document.body.appendChild(script);
                p1 = new Promise((resolve)=>{
                    script.onload = ()=>resolve(true);
                });
            }
            const p2 = _banner.collection({
                out: "images,text",
                place: "cash_crab"
            });
            const p3 = _game.launch({
                code: "cash-crab",
                mode: "real"
            });
            Promise.all([
                p1,
                p2,
                p3
            ]).then((values)=>{
                scope.preloader = false;
                const launch = values[2].result;
                const prizes = mapPrizes(values[1].result);
                const launch_options = Object.assign({
                    view: "game",
                    brand: _config.siteName,
                    locale: _config.currentLang,
                    prizes: prizes,
                    brandProfile: _user.profile,
                    brandFeature: _config.feature,
                    onClickTerms: ()=>{
                        const url = $state.href(_state.get("terms").name);
                        window.open(url, "_blank");
                    },
                    onClickLoseBtn: ()=>{
                        _state.goto("home");
                    },
                    onClickBetModeBtn: ()=>{
                        _state.goto("cash_crab");
                    },
                    onClickDepositBtn: ()=>{
                        _popup.open({
                            name: "cashbox"
                        });
                    },
                    onRoundEnd: ()=>{
                        _account.info({
                            nocache: true
                        });
                    }
                }, launch.launch_options);
                crab = new Crab(element[0], launch_options);
            });
            function mapPrizes(p) {
                return p.map((p)=>({
                        alias: p.text[0],
                        image: `${_config.apiUrl}${p.images.list[0]}`,
                        name: p.text[1],
                        amount: p.text[2],
                        description: p.text[3],
                        buttonText: p.text[4],
                        onClick: ()=>{
                            _state.goto(p.text[5]);
                        }
                    }));
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e1b3955f64bb09e5$exports = {};









(function() {
    "use strict";
    const directive = {
        name: "clawGameField"
    };
    controller.$inject = [
        "$state",
        "system$",
        "config",
        "state",
        "banner",
        "game",
        "popup",
        "user",
        "account",
        "analytics",
        "$window"
    ];
    function controller($state, _system$, _config, _state, _banner, _game, _popup, _user, _account, _analytics, $window) {
        const link = (scope, element)=>{
            let crab = {
                destroy: ()=>{}
            };
            init();
            function init() {
                crab.destroy();
                scope.preloader = true;
                scope.clawGame = {
                    title: ""
                };
                const PROMISE_LIST = [];
                const game_code = $state.params.name || "cash_crab";
                let GAME_MODE = null;
                switch(game_code){
                    case "cash-crab":
                        GAME_MODE = "bonus";
                        scope.clawGame.title = "Bonus crab";
                        break;
                    case "oktoberfest":
                        GAME_MODE = "cash";
                        scope.clawGame.title = "Oktoberfest";
                        break;
                    default:
                        GAME_MODE = "cash";
                        scope.clawGame.title = "Cash crab";
                        break;
                }
                let PROMISE_SDK = Promise.resolve(true);
                PROMISE_LIST[0] = PROMISE_SDK;
                if (typeof CrabLoader === "undefined") {
                    const script = document.createElement("script");
                    script.src = `/joxi/js/crab/sdk/launch.v2.js?t=${Date.now()}`;
                    document.body.appendChild(script);
                    PROMISE_SDK = new Promise((resolve)=>{
                        script.onload = ()=>resolve(true);
                    });
                }
                const PROMISE_LAUNCH = _game.launch({
                    code: game_code,
                    mode: "real"
                });
                PROMISE_LIST[1] = PROMISE_LAUNCH;
                if (GAME_MODE === "bonus") {
                    const PROMISE_BANNERS = _banner.collection({
                        out: "images,text",
                        place: "cash_crab"
                    });
                    PROMISE_LIST[2] = PROMISE_BANNERS;
                }
                // PROMISE_LIST === [sdk, launch, banners(opt)]
                Promise.all(PROMISE_LIST).then((RESPONSE)=>{
                    scope.preloader = false;
                    const launch = RESPONSE[1].result;
                    const prizes = GAME_MODE === "bonus" ? mapPrizes(RESPONSE[2].result) : [];
                    const GENERAL_LAUNCH_OPTIONS = {
                        brand: _config.siteName,
                        locale: _config.currentLang,
                        brandProfile: _user.profile,
                        brandFeature: _config.feature,
                        destroyOnLocationChange: false,
                        onClickTerms: ()=>{
                            const url = $state.href(_state.get("terms").name);
                            $window.open(url, "_blank");
                        },
                        onClickDepositBtn: ()=>{
                            _popup.open({
                                name: "cashbox"
                            });
                        },
                        goToGame: (gameCode = "cash_crab")=>{
                            _state.goto("claw", {
                                name: gameCode
                            });
                        }
                    };
                    const BONUS_LAUNCH_OPTIONS = GAME_MODE === "bonus" ? {
                        prizes: prizes,
                        onRoundEnd: ()=>{
                            _account.info({
                                nocache: true
                            });
                        },
                        onClickLoseBtn: ()=>{
                            _state.goto("home");
                        },
                        onClickBetModeBtn: ()=>{
                            _state.goto("claw", {
                                name: "cash_crab"
                            });
                        }
                    } : {};
                    const CASH_LAUNCH_OPTIONS = GAME_MODE === "cash" ? {
                        mode: "MONEY"
                    } : {};
                    const launch_options = Object.assign(GENERAL_LAUNCH_OPTIONS, CASH_LAUNCH_OPTIONS, BONUS_LAUNCH_OPTIONS, launch.launch_options);
                    // eslint-disable-next-line new-cap
                    $window.CrabLoader({
                        name: "game",
                        version: "1.0.0"
                    }).then((Crab)=>{
                        crab = new Crab(element[0], launch_options);
                        crab.on("deposit", ()=>{
                            _state.goto("deposit");
                        });
                        crab.on("gameProvider", (data)=>{
                            _state.goto("gameProvider", {
                                name: data.providerAlias
                            });
                        });
                        crab.on("gamePage", (data)=>{
                            _state.goto("realGame", {
                                name: data.gameAlias
                            });
                        });
                        crab.on("promotion", ()=>{
                            _state.goto("promotions");
                        });
                        crab.on("bonuses", ()=>{
                            _state.goto("bonuses");
                        });
                        crab.on("support", ()=>{
                            _system$.next({
                                action: "open chat"
                            });
                        });
                        crab.on("sportbook", ()=>{
                            _state.goto("sport");
                        });
                        crab.on("analytics", ({ category: category, action: action, label: label })=>{
                            _analytics.send(category, action, label);
                        });
                    });
                });
                function mapPrizes(p) {
                    return p.map((p)=>({
                            alias: p.text[0],
                            image: `${_config.apiUrl}${p.images.list[0]}`,
                            name: p.text[1],
                            amount: p.text[2],
                            description: p.text[3],
                            buttonText: p.text[4],
                            onClick: ()=>{
                                _state.goto(p.text[5]);
                            }
                        }));
                }
            }
            scope.$on("$destroy", ()=>{
                crab.destroy();
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $df145c56574b995d$exports = {};


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("ws$", controller);
})();



(function() {
    "use strict";
    app.factory("wsEvents", controller);
    function controller() {
        return {
            balanceUpdate: "balance_update",
            balanceDetails: "balance_details",
            bonusIssue: "bonus_issue",
            logout: "logout",
            bonusActivated: "bonus_activated",
            promocode: "promocode",
            newLogin: "new_login",
            newRegistration: "new_registration",
            newWin: "new_win",
            newWinList: "new_win_list",
            newBonus: "new_bonus",
            achieve: "achieve",
            achieveComplete: "achieve_complete",
            message: "message",
            messageOtimove: "message_optimove",
            deposit: "deposit",
            notificationCenter: "notification_center",
            coolOffGameInActivated: "cool_off_game_in_activated",
            coolOffGameInDeactivated: "cool_off_game_in_deactivated",
            closeGameSession: "close_game_session",
            fastTournamentUpdateLeaderboard: "fast_tournament_update_leaderboard",
            leagueRewardWinners: "league_reward",
            cashierStatus: "cashier_status",
            newBonusCrabAttempts: "new_bonus_crab_attempts",
            promoExtraBonus: "promo_extra_bonus",
            balanceThresholdReached: "balance_threshold_reached",
            surveyUpdated: "survey_updated"
        };
    }
})();








(function() {
    "use strict";
    const directive = {
        name: "crabPopup"
    };
    const dict = $_DICT || {
        claw_games: []
    };
    const claw_games = dict.claw_games;
    controller.$inject = [
        "config",
        "ws$",
        "account",
        "wsEvents",
        "popup",
        "user",
        "state",
        "system$",
        "$rootScope"
    ];
    function controller(_config, _ws$, _account, _wsEvents, _popup, _user, _state, _system$, $rootScope) {
        const link = (scope, element)=>{
            const subscriptions = [];
            // eslint-disable-next-line angular/on-watch
            $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams, error) {
                if (!toState.name.includes("claw_games")) {
                    if (toParams.mode && toParams.name && claw_games.includes(toParams.name)) {
                        event.preventDefault();
                        // toParams.mode = null;
                        _state.goto("claw", {
                            name: toParams.name
                        });
                    }
                }
            });
            if (typeof CrabLoader === "undefined") {
                const script = document.createElement("script");
                script.src = `/joxi/js/crab/sdk/launch.v2.js?t=${Date.now()}`;
                document.body.appendChild(script);
                script.onload = ()=>{
                    run();
                };
            } else run();
            let crab = {
                destroy: ()=>{}
            };
            function run() {
                const appName = `popup${_config.device.mobile ? "-m" : ""}-${_config.siteName}`;
                // eslint-disable-next-line angular/window-service,new-cap
                window.CrabLoader({
                    name: appName,
                    version: "1.0.0"
                }).then((Crab)=>{
                    crab = new Crab(null, {
                        locale: _config.currentLang,
                        brandProfile: _user.profile,
                        brandFeature: _config.feature,
                        destroyOnLocationChange: false,
                        beforePopupOpen () {
                            _popup.close();
                        },
                        toHome () {
                            _state.goto("home");
                        },
                        toBonusCrab () {
                            _state.goto("claw", {
                                name: "cash-crab"
                            });
                        },
                        toCashCrab () {
                            _state.goto("claw", {
                                name: "cash_crab"
                            });
                        },
                        toDeposit () {
                            _state.goto("deposit");
                        },
                        toTerms () {
                            _state.goto("terms");
                        },
                        async updateProfile () {
                            await _account.info({
                                nocache: true
                            });
                            return _user.profile;
                        }
                    });
                    subscribe();
                });
            }
            function subscribe() {
                subscriptions[0] = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "login")).subscribe((m)=>{
                    crab.updateParams({
                        brandProfile: _user.profile
                    });
                });
                const achieve$ = _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.achieve), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ data: data })=>data.achieve?.category === "cash_crab"));
                const newBonusCrabAttempts$ = _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.newBonusCrabAttempts));
                subscriptions[1] = (0, $baeef3ef689dc439$export$4950aa0f605343fb)(achieve$, newBonusCrabAttempts$).subscribe(()=>{
                    crab.callEvent("newAttempt");
                    _account.info({
                        nocache: true
                    }).then(()=>{
                        crab.updateParams({
                            brandProfile: _user.profile
                        });
                    }).catch(()=>{}).finally(()=>{});
                });
            }
            scope.$on("$destroy", ()=>{
                crab.destroy();
                subscriptions.forEach((s)=>s.unsubscribe());
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $ea81ebe3c803cc11$exports = {};




/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $abe94a30762377a2$var$EmptyErrorImpl = /*@__PURE__*/ function() {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = "no elements in sequence";
        this.name = "EmptyError";
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
}();
var $abe94a30762377a2$export$78f6d1b1dbcda304 = $abe94a30762377a2$var$EmptyErrorImpl;




/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");

var $2Dqpi = parcelRequire("2Dqpi");
function $6368e901962b13b0$export$e4ca6d7b7a6dcf9b(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $6368e901962b13b0$var$DefaultIfEmptyOperator(defaultValue));
    };
}
var $6368e901962b13b0$var$DefaultIfEmptyOperator = /*@__PURE__*/ function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6368e901962b13b0$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
var $6368e901962b13b0$var$DefaultIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}((0, $2Dqpi.Subscriber));


/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */ 
var $iBNdU = parcelRequire("iBNdU");


var $2Dqpi = parcelRequire("2Dqpi");
function $8cd79e480f534279$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8cd79e480f534279$var$defaultErrorFactory;
    return function(source) {
        return source.lift(new $8cd79e480f534279$var$ThrowIfEmptyOperator(errorFactory));
    };
}
var $8cd79e480f534279$var$ThrowIfEmptyOperator = /*@__PURE__*/ function() {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8cd79e480f534279$var$ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}();
var $8cd79e480f534279$var$ThrowIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    $iBNdU.__extends(ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function(value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function() {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            } catch (e) {
                err = e;
            }
            this.destination.error(err);
        } else return this.destination.complete();
    };
    return ThrowIfEmptySubscriber;
}((0, $2Dqpi.Subscriber));
function $8cd79e480f534279$var$defaultErrorFactory() {
    return new (0, $abe94a30762377a2$export$78f6d1b1dbcda304)();
}



var $dkdR0 = parcelRequire("dkdR0");
function $cb278db83bf89940$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $dkdR0.identity), (0, $94b8433012a062db$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $6368e901962b13b0$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8cd79e480f534279$export$c8ea5e9f84346833)(function() {
            return new (0, $abe94a30762377a2$export$78f6d1b1dbcda304)();
        }));
    };
}


(function() {
    "use strict";
    const directive = {
        name: "crabSportWidget"
    };
    controller.$inject = [
        "user$",
        "game",
        "user",
        "config",
        "$window"
    ];
    function controller(_user$, _game, _user, _config, $window) {
        const link = (scope, element)=>{
            const postData = {
                crabOptionsReady: false,
                launch_options: {
                    brand: _config.siteName,
                    locale: _config.currentLang,
                    brandFeature: _config.feature
                }
            };
            let subscription = null;
            if (_user.status === true) run();
            else subscription = _user$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((data)=>data.status === true), (0, $cb278db83bf89940$export$43128fadae87b74a)()).subscribe(()=>{
                run();
            });
            function run() {
                _game.launch({
                    code: "cash-crab",
                    mode: "real"
                }).then((data)=>{
                    postData.crabOptionsReady = true;
                    Object.assign(postData.launch_options, data.result.launch_options);
                    $window.addEventListener("message", handleMessage, true);
                }).catch(()=>{}).finally(()=>{});
            }
            function handleMessage(e) {
                if (e.data?.crab?.ready === true && postData.crabOptionsReady === true) e.source.postMessage(postData, "*");
            }
            scope.$on("$destroy", ()=>{
                $window.removeEventListener("message", handleMessage, true);
                if (subscription) subscription.unsubscribe();
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e2f63d07e4517ad3$exports = {};
(function() {
    const directive = {
        name: "dvsDragAndDrop"
    };
    function controller() {
        function link(scope, element, attrs) {
            element.bind("dragover dragenter", processDragOverOrEnter);
            element.bind("dragend dragleave", endDragOver);
            element.bind("drop", dropHandler);
            function dropHandler(angularEvent) {
                const event = angularEvent.originalEvent || angularEvent;
                const files = event.dataTransfer.files;
                event.preventDefault();
                element.removeClass("dragging error");
                if (scope.$parent.files.length >= 5) return false;
                if (files.length > 5) return false;
                if (scope.$parent.files.length + files.length > 5) return false;
                scope.$parent.addFiles(files);
            }
            function processDragOverOrEnter(angularEvent) {
                const event = angularEvent.originalEvent || angularEvent;
                if (event) event.preventDefault();
                const files = event.dataTransfer.items;
                event.dataTransfer.effectAllowed = "copy";
                element.addClass("dragging");
                if (scope.$parent.files.length + files.length > 5) element.addClass("error");
                return false;
            }
            function endDragOver() {
                element.removeClass("dragging error");
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $bd7256ce561e9689$exports = {};
(function() {
    const directive = {
        name: "dvsFileUpload"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element) {
            const inputElement = angular.element('<input type="file" ng-model="files" hidden multiple />');
            element.append(inputElement);
            inputElement.bind("change", function() {
                scope.$emit("updateFile", this.files);
                this.value = "";
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $8c6041f7c0fd3bd0$exports = {};







const $526cf57ef4f5f5f2$export$fff88358b39e5742 = "kreditzAnalytics";
class $526cf57ef4f5f5f2$var$KreditzAnalytics {
    static $inject = [
        "analytics",
        "user"
    ];
    constructor(analytics, _user){
        this.analytics = analytics;
        this.user = _user;
    }
    addEventData(data) {
        this.analytics.sendToDataLayer({
            ...data,
            visitor_id: this.user.profile.account_id.toString(),
            eventTimestamp: Date.now().toString(),
            eventDate: new Date().toISOString()
        });
    }
    onOpenButtonClicked() {
        this.addEventData({
            eventType: "manual",
            event: "kycUploadDocumentsOpenButton"
        });
    }
    onFrameOpened() {
        this.addEventData({
            eventType: "auto",
            event: "kycUploadDocumentsFrameOpened"
        });
    }
    onCloseButtonClicked() {
        this.addEventData({
            eventType: "manual",
            event: "kycUploadDocumentsCloseButton"
        });
    }
    onUploadDocumentsFinished() {
        this.addEventData({
            eventType: "auto",
            event: "kycUploadDocumentsFinished"
        });
    }
}
app.service($526cf57ef4f5f5f2$export$fff88358b39e5742, $526cf57ef4f5f5f2$var$KreditzAnalytics);





(function() {
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("verificationInfo$", controller);
})();
(function() {
    controller.$inject = [
        "http",
        "$q",
        "user",
        "user$",
        "popup",
        "verificationInfo$",
        "notification$",
        "$translate",
        "kreditzAnalytics"
    ];
    function controller(_http, $q, _user, _user$, _popup, _verificationInfo$, _notification$, $translate, kreditzAnalytics) {
        let verificationStatus = _user.profile.verificationStatus;
        const preloader$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)(false);
        const documentList$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const kreditzEventType = {
            completed: "User flow completed",
            authError: "server error"
        };
        _user$.subscribe((user)=>{
            if (user.profile.verificationStatus !== verificationStatus) {
                verificationStatus = user.profile.verificationStatus;
                _verificationInfo$.next({
                    action: "verificationStatusUpdated"
                });
            }
        });
        return {
            preloader$: preloader$,
            documentList$: documentList$,
            getDocuments: {
                list () {
                    return this.getData("documentVerificationRequestedDocumentsList");
                },
                collection () {
                    return this.getData("documentVerificationDocuments");
                },
                getData (alias) {
                    const defer = $q.defer();
                    const config = {
                        meta: {
                            alias: alias
                        }
                    };
                    _http.get(alias, config).then((answer)=>{
                        defer.resolve(answer.data);
                    }, (answer)=>{
                        defer.reject(answer.data);
                    });
                    return defer.promise;
                }
            },
            setDocuments: {
                upload: {
                    options (requestedDocumentId) {
                        const data = {
                            requestedDocumentId: requestedDocumentId
                        };
                        return this.setData("documentVerificationUploadOptions", data);
                    },
                    file (files, documentsId) {
                        const data = files;
                        return this.setData("documentVerificationUploadFile", data, documentsId);
                    },
                    done (data) {
                        return this.setData("documentVerificationUploadDone", data);
                    },
                    setData (alias, data, documentsId) {
                        const defer = $q.defer();
                        if (documentsId) {
                            alias = {
                                name: alias,
                                param: documentsId
                            };
                            const formData = new FormData();
                            for(let i = 0; i < data.length; i++)if (Object.keys(data[i].errors).length === 0) formData.append(data[i].name, data[i]);
                            data = formData;
                        }
                        const config = {
                            meta: {
                                alias: alias
                            }
                        };
                        if (documentsId) config.headers = {
                            "Content-Type": undefined
                        };
                        _http.post(alias, data, config).then((answer)=>{
                            defer.resolve(answer.data);
                        }, (answer)=>{
                            defer.reject(answer.data);
                        }).catch((error)=>{
                            defer.reject(error);
                        });
                        return defer.promise;
                    }
                }
            },
            updateDocumentList () {
                this.getDocuments.list().then((answer)=>{
                    documentList$.next(answer.result);
                });
            },
            selectVerificationFlow (providerParams) {
                switch(providerParams.verificationProvider){
                    case "ONFIDO":
                        this.uploadDocument(providerParams);
                        break;
                    case "BACK_OFFICE":
                        this.openProviderPopup(providerParams);
                        break;
                    case "KREDITZ":
                        kreditzAnalytics.onOpenButtonClicked();
                        this.openProviderPopup(providerParams);
                        break;
                }
            },
            uploadDocument (providerParams) {
                preloader$.next({
                    message: "onfidoPreloader",
                    preloader: true
                });
                this.setDocuments.upload.options(providerParams.requestedDocumentId || providerParams.id).then(({ result: result })=>{
                    this.openProviderPopup({
                        result: result,
                        verificationProvider: providerParams.verificationProvider
                    });
                    preloader$.next({
                        message: "onfidoPreloader",
                        preloader: false
                    });
                });
            },
            openProviderPopup (providerParams) {
                this.documentData = providerParams;
                const popupConfig = {
                    name: "document-verification",
                    content: providerParams
                };
                _popup.open(popupConfig);
                if (providerParams.verificationProvider === "KREDITZ") kreditzAnalytics.onFrameOpened();
            },
            handleEventByStatus (event) {
                switch(event.status){
                    case "success":
                        this.handleSuccessEvent(event);
                        break;
                    case "error":
                        this.handleErrorEvent(event);
                        break;
                    default:
                        break;
                }
            },
            handleSuccessEvent (event) {
                if (event.message === kreditzEventType.completed) this.onUserFlowCompleted();
            },
            handleErrorEvent (event) {
                if (event.message === kreditzEventType.authError) _notification$.next({
                    type: "error",
                    code: 0,
                    text: $translate.instant("kreditz.notification.auth.error.message")
                });
            },
            onUserFlowCompleted () {
                this.setDocuments.upload.done(this.documentData).then(()=>{
                    kreditzAnalytics.onUploadDocumentsFinished();
                    this.updateDocumentList();
                    _notification$.next({
                        type: "success",
                        code: 0,
                        text: $translate.instant("kreditz.notification.success.message")
                    });
                });
                _popup.close();
            }
        };
    }
    app.factory("documentVerification", controller);
})();




(function() {
    "use strict";
    const directive = {
        name: "dvsNotificationNotVerified"
    };
    controller.$inject = [
        "user",
        "system$",
        "verificationInfo$",
        "$window"
    ];
    function controller(_user, _system$, _verificationInfo$, $window) {
        function link($scope, $element) {
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            function changeVerificationStatus() {
                const verificationStatus = _user.profile.verificationStatus;
                const verificationStatusGroups = _user.profile.groups;
                $scope.isVerificationBlocked = false;
                if (verificationStatus === "REQUIRES_VERIFICATION") {
                    if (verificationStatusGroups.length) $scope.isVerificationBlocked = true;
                    $window.localStorage.setItem("show-verification-bar", "true");
                    $element[0].classList.add("is-verification-changed");
                } else $element[0].classList.remove("is-verification-changed");
            }
            changeVerificationStatus();
            _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
                changeVerificationStatus();
            });
            _verificationInfo$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "verificationStatusUpdated")).subscribe(()=>{
                changeVerificationStatus();
            });
            $scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $92a6e8ee14f09cad$exports = {};





(function() {
    "use strict";
    const directive = {
        name: "dvsNotificationVerified"
    };
    controller.$inject = [
        "user",
        "system$",
        "verificationInfo$",
        "$window"
    ];
    function controller(_user, _system$, _verificationInfo$, $window) {
        function link($scope, $element) {
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            function changeVerificationStatus() {
                if (_user.profile.verificationStatus === "VERIFIED" && $window.localStorage.getItem("show-verification-bar")) {
                    $element[0].classList.add("is-verification-changed");
                    return;
                }
                $element[0].classList.remove("is-verification-changed");
            }
            $scope.verificationClose = ()=>{
                $window.localStorage.removeItem("show-verification-bar");
                $element[0].classList.remove("is-verification-changed");
                angular.element(document.querySelector(".page-verification-alert")).remove();
            };
            changeVerificationStatus();
            _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
                changeVerificationStatus();
            });
            _verificationInfo$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "verificationStatusUpdated")).subscribe(()=>{
                changeVerificationStatus();
            });
            $scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $672b73eb402b53bf$exports = {};



(function() {
    const directive = {
        name: "lindaDocumentVerificationOnfido"
    };
    // eslint-disable-next-line angular/window-service
    window.onfidoLoaded = undefined;
    controller.$inject = [
        "config",
        "user",
        "verificationInfo$"
    ];
    function controller(_config, _user, _verificationInfo$) {
        const onfidoSDK = _config.cdnOnfidoFiles.js;
        const onfidoStyle = _config.cdnOnfidoFiles.style;
        let callOnfido;
        let onfidoOut;
        const addScriptElement = (script)=>{
            const element = document.createElement("script");
            element.src = `${script}?build=${_config.build}`;
            element.async = false;
            element.onload = ()=>{
                onfidoLoaded = true;
                callOnfido();
            };
            document.head.appendChild(element);
        };
        const addStyleElement = (style)=>{
            const head = document.getElementsByTagName("HEAD")[0];
            const element = document.createElement("link");
            element.rel = "stylesheet";
            element.type = "text/css";
            element.href = `${style}?build=${_config.build}`;
            element.onload = ()=>{};
            head.appendChild(element);
        };
        addScriptElement(onfidoSDK);
        addStyleElement(onfidoStyle);
        function link(scope, element, attrs) {
            if (!_user.status) return;
            scope.preloader = true;
            const config = scope.$eval(attrs[directive.name]);
            callOnfido = ()=>{
                config.onComplete = (data)=>{
                    const verificationInfo = {
                        providerData: data,
                        requestedDocumentId: config.requestedDocumentId
                    };
                    _verificationInfo$.next({
                        event: "onfidoResult",
                        data: verificationInfo
                    });
                };
                config.language = $_DICT.onfido?.langReplacements?.[_config.currentLang] || "en_US";
                onfidoOut = Onfido.init(config);
                scope.preloader = false;
            };
            if (onfidoLoaded) callOnfido();
            scope.$on("$destroy", ()=>{
                onfidoOut.tearDown();
                onfidoOut = null;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $879157994aa2632a$exports = {};

(function() {
    "use strict";
    const g0 = "gringos";
    const c0 = "$_CONFIG";
    const d0 = "directive";
    const slideID = 0;
    function createHero(params) {
        const heroName = params.p;
        return [
            "resize$",
            function(_resize$) {
                return {
                    restrict: "C",
                    link (scope, element, attrs) {
                        const app1 = new PIXI.Application({
                            transparent: true,
                            resizeTo: element[0]
                        });
                        let subscription;
                        let subscription1;
                        let hero;
                        let selected = false;
                        element[0].appendChild(app1.view);
                        app1.loader.add(heroName, `img/assets/${heroName}.json`).load(onAssetsLoaded);
                        app1.stage.interactive = true;
                        function onAssetsLoaded(loader, res) {
                            hero = new PIXI.spine.Spine(res[heroName].spineData);
                            hero.x = app1.screen.width / 2;
                            hero.y = app1.screen.height;
                            setSize(window.innerWidth);
                            hero.state.setAnimation(0, "shadow", true);
                            app1.stage.addChild(hero);
                            subscription = _resize$.subscribe((e)=>{
                                setSize(e.target.innerWidth);
                            });
                            select(slideID);
                            subscription1 = select$.subscribe((id)=>{
                                select(id);
                            });
                            function select(id) {
                                const h = window[c0][g0][id];
                                if (h.n === params.n) {
                                    selected = true;
                                    hero.state.setAnimation(0, "stand", true);
                                } else {
                                    if (selected === true) hero.state.setAnimation(0, "shadow", true);
                                    selected = false;
                                }
                            }
                        }
                        function setSize(width) {
                            if (width >= 1920) hero.scale.set(1);
                            else if (width >= 1680 && width < 1920) hero.scale.set(0.85);
                            else if (width >= 1440 && width < 1680) hero.scale.set(0.77);
                            else if (width >= 1024 && width < 1440) hero.scale.set(0.59);
                        }
                        scope.$on("$destroy", ()=>{
                            subscription.unsubscribe();
                            subscription1.unsubscribe();
                        });
                    }
                };
            }
        ];
    }
    const h0 = window[c0][g0] || [];
    if (h0.length) window.select$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    h0.forEach((i)=>{
        app[d0](i.dn, createHero(i));
    });
})();


var $58b51f6c526c2c18$exports = {};

class $58b51f6c526c2c18$var$ShowIfFunidDirective {
    static $inject = [
        "entity"
    ];
    constructor(entity){
        this.entity = entity;
    }
    link(scope, element, attrs, ctrl, transclude) {
        this.entity.getFeatureFlags().then(({ funid: funid })=>{
            if (funid) transclude(scope, (clone)=>{
                element[0].parentNode.insertBefore(clone[0], element[0].nextSibling);
            });
        });
    }
}
app.directive("showIfFunid", ()=>{
    return {
        restrict: "A",
        controller: $58b51f6c526c2c18$var$ShowIfFunidDirective,
        transclude: "element",
        link: function(scope, element, attrs, ctrl, transclude) {
            ctrl.link(scope, element, attrs, ctrl, transclude);
        }
    };
});


var $0b76e74d51fbfc26$exports = {};
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $dea356723133262e$export$3545e07a80636437 = "152";
const $dea356723133262e$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $dea356723133262e$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $dea356723133262e$export$3237e1f2c1ea1f44 = 0;
const $dea356723133262e$export$b9a7b4fc5cb15f9b = 1;
const $dea356723133262e$export$b8058bcc7037d3f3 = 2;
const $dea356723133262e$export$f24be24dcddeac0d = 3;
const $dea356723133262e$export$346307dbae2b7447 = 0;
const $dea356723133262e$export$5813f879eee7cd88 = 1;
const $dea356723133262e$export$a47c4b43a1be34f0 = 2;
const $dea356723133262e$export$896ae1ade6c829c4 = 3;
const $dea356723133262e$export$2ede184fc2998901 = 0;
const $dea356723133262e$export$d9f0486e75b5ace = 1;
const $dea356723133262e$export$3b296b6f144d5b03 = 2;
const $dea356723133262e$export$211211c00f97204d = 2; // r149
const $dea356723133262e$export$63b8d6b580fc65ba = 0;
const $dea356723133262e$export$5b29a26d96ee6af0 = 1;
const $dea356723133262e$export$777d8f9551c2216b = 2;
const $dea356723133262e$export$cdfa06f868e2e467 = 3;
const $dea356723133262e$export$4138e1c684b46a20 = 4;
const $dea356723133262e$export$eda4864c68df1fa2 = 5;
const $dea356723133262e$export$20183a0484ce21a0 = 100;
const $dea356723133262e$export$73e0df5177988548 = 101;
const $dea356723133262e$export$28e582859cbec660 = 102;
const $dea356723133262e$export$c8c1508da8d0600c = 103;
const $dea356723133262e$export$99948c02fb51055f = 104;
const $dea356723133262e$export$2110f05edf778d3d = 200;
const $dea356723133262e$export$8805bad65e24940e = 201;
const $dea356723133262e$export$7fbe15b28d28cf52 = 202;
const $dea356723133262e$export$947829af9f2c17f6 = 203;
const $dea356723133262e$export$d5773124e86cf28c = 204;
const $dea356723133262e$export$11d468cc7f19e971 = 205;
const $dea356723133262e$export$a78aed1ca2a87192 = 206;
const $dea356723133262e$export$5d0fe17fd8773bac = 207;
const $dea356723133262e$export$ef5f2dd8ffac5574 = 208;
const $dea356723133262e$export$56b85b2686ab16 = 209;
const $dea356723133262e$export$c05e2a1fc8609506 = 210;
const $dea356723133262e$export$69025ce147cee220 = 0;
const $dea356723133262e$export$7182eb52ea3b3f04 = 1;
const $dea356723133262e$export$eedccec66ab7ebe = 2;
const $dea356723133262e$export$296f78a0b892f81a = 3;
const $dea356723133262e$export$a60d398fc7b7590e = 4;
const $dea356723133262e$export$7d7234c1240a1fc4 = 5;
const $dea356723133262e$export$c5e2c52991f30937 = 6;
const $dea356723133262e$export$2f843afa843d8916 = 7;
const $dea356723133262e$export$e50ac29801f1774d = 0;
const $dea356723133262e$export$9f9d94f963c85479 = 1;
const $dea356723133262e$export$e641dc52bc3494aa = 2;
const $dea356723133262e$export$9fcb6b4294603b2 = 0;
const $dea356723133262e$export$98f52c2a46c598ca = 1;
const $dea356723133262e$export$74b25e54b3bcd548 = 2;
const $dea356723133262e$export$932b3dd283d4a366 = 3;
const $dea356723133262e$export$a0d98fe6d7e4af64 = 4;
const $dea356723133262e$export$2c7b09c1e9abfb5e = 5;
const $dea356723133262e$export$1beec6768cbb3d2d = 300;
const $dea356723133262e$export$8759762a6477f2c4 = 301;
const $dea356723133262e$export$dc59f8aed047f61d = 302;
const $dea356723133262e$export$d64030b316d3b087 = 303;
const $dea356723133262e$export$ee99d97d46898098 = 304;
const $dea356723133262e$export$dbf3e70ff37af79 = 306;
const $dea356723133262e$export$533346c8e8dac0f5 = 1000;
const $dea356723133262e$export$9d9334239a5a5e06 = 1001;
const $dea356723133262e$export$c7e7c00b14f51a4f = 1002;
const $dea356723133262e$export$727aa5ec3fe39bf0 = 1003;
const $dea356723133262e$export$d129e38cf6feaa8c = 1004;
const $dea356723133262e$export$14a4936464a36496 = 1004;
const $dea356723133262e$export$d2327c1afe5bfdf2 = 1005;
const $dea356723133262e$export$cbc5b7f5647595d8 = 1005;
const $dea356723133262e$export$8a72f490b25c56c8 = 1006;
const $dea356723133262e$export$19a719f377145a13 = 1007;
const $dea356723133262e$export$dbe96bee3fe9dbf0 = 1007;
const $dea356723133262e$export$5d8599b6a933fb1b = 1008;
const $dea356723133262e$export$90d80f1e3506775f = 1008;
const $dea356723133262e$export$2e8ce08d3f6f5e10 = 1009;
const $dea356723133262e$export$545fce0311a9796a = 1010;
const $dea356723133262e$export$88572337f312435f = 1011;
const $dea356723133262e$export$c63dc51868b06a9d = 1012;
const $dea356723133262e$export$5c612977753abe2 = 1013;
const $dea356723133262e$export$c3c7fc4518ebba96 = 1014;
const $dea356723133262e$export$f6d331659b644596 = 1015;
const $dea356723133262e$export$2697304443f382bc = 1016;
const $dea356723133262e$export$b3969b01faf587f2 = 1017;
const $dea356723133262e$export$18886f8ae33e90de = 1018;
const $dea356723133262e$export$6c8ea339bfab1301 = 1020;
const $dea356723133262e$export$988473390501ed4b = 1021;
const $dea356723133262e$export$3f8bb04b555a363c = 1023;
const $dea356723133262e$export$cc09ccbf6d1ed449 = 1024;
const $dea356723133262e$export$9053a81c4a69c289 = 1025;
const $dea356723133262e$export$c1b6b5136be58045 = 1026;
const $dea356723133262e$export$1e113ac2d0905829 = 1027;
const $dea356723133262e$export$4e041a7967d15c4b = 1028;
const $dea356723133262e$export$aa92e870a709d190 = 1029;
const $dea356723133262e$export$6cdf0b461c7ce8a0 = 1030;
const $dea356723133262e$export$1ba1c45f9f77d4d7 = 1031;
const $dea356723133262e$export$c200e7d26f592f21 = 1033;
const $dea356723133262e$export$21d1799c6d552fc0 = 33776;
const $dea356723133262e$export$afa304c3e981b668 = 33777;
const $dea356723133262e$export$d2a1a68024a3e56c = 33778;
const $dea356723133262e$export$9a79c424327dacf9 = 33779;
const $dea356723133262e$export$19ada9bbb1af3573 = 35840;
const $dea356723133262e$export$d0f0355bb3d948e4 = 35841;
const $dea356723133262e$export$b82296714358084c = 35842;
const $dea356723133262e$export$b71692456c47b6c3 = 35843;
const $dea356723133262e$export$6ab91af2d757aee7 = 36196;
const $dea356723133262e$export$7800993ef8106a6a = 37492;
const $dea356723133262e$export$23ed8300a860e7d8 = 37496;
const $dea356723133262e$export$dc5570b4a2b92d48 = 37808;
const $dea356723133262e$export$68880cd325f8b2fb = 37809;
const $dea356723133262e$export$7d2c0be323373d95 = 37810;
const $dea356723133262e$export$22b52da301fc3a3e = 37811;
const $dea356723133262e$export$c009e2cb4a66485e = 37812;
const $dea356723133262e$export$118fff5afa255b63 = 37813;
const $dea356723133262e$export$120713c829ae0667 = 37814;
const $dea356723133262e$export$c79eeabbf53313e9 = 37815;
const $dea356723133262e$export$443cf6567cdd6424 = 37816;
const $dea356723133262e$export$6573984fc9840780 = 37817;
const $dea356723133262e$export$e7aee563f30091de = 37818;
const $dea356723133262e$export$2eb8634622ddeab7 = 37819;
const $dea356723133262e$export$202b1ce7b5d25742 = 37820;
const $dea356723133262e$export$18ab77abd087e467 = 37821;
const $dea356723133262e$export$ce40b115e188bc81 = 36492;
const $dea356723133262e$export$b1688df4c4c21670 = 36283;
const $dea356723133262e$export$fc15e5d8261eed58 = 36284;
const $dea356723133262e$export$d220f6ade8463a0f = 36285;
const $dea356723133262e$export$768646d09dc1b6ef = 36286;
const $dea356723133262e$export$d62fdc9d1b1cccad = 2200;
const $dea356723133262e$export$dfaf4422ce096e29 = 2201;
const $dea356723133262e$export$f8f6f2041b78e210 = 2202;
const $dea356723133262e$export$995b32462a65e855 = 2300;
const $dea356723133262e$export$30fac1aace31cf4d = 2301;
const $dea356723133262e$export$198b11ff4c72bb30 = 2302;
const $dea356723133262e$export$7f795934b84ab523 = 2400;
const $dea356723133262e$export$24a4ccb5099273b5 = 2401;
const $dea356723133262e$export$8e8c3ecdcd8e1fee = 2402;
const $dea356723133262e$export$bcfbbdcf8de7f8cd = 2500;
const $dea356723133262e$export$d875e029ef558d3 = 2501;
const $dea356723133262e$export$4c28c87c2dc84758 = 0;
const $dea356723133262e$export$b23a071aa286eb29 = 1;
const $dea356723133262e$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $dea356723133262e$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $dea356723133262e$export$f32388edbb32674 = 3001;
const $dea356723133262e$export$deeb383078690b50 = 3200;
const $dea356723133262e$export$8f910f4c4f73df11 = 3201;
const $dea356723133262e$export$2852a58ebdac27b8 = 0;
const $dea356723133262e$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $dea356723133262e$export$bfcb490c2dd3db51 = "";
const $dea356723133262e$export$561f394b24edfcaa = "srgb";
const $dea356723133262e$export$42429b3acfb233a4 = "srgb-linear";
const $dea356723133262e$export$626af19ae879bdf6 = "display-p3";
const $dea356723133262e$export$69433f11f42d5527 = 0;
const $dea356723133262e$export$9f542ae4b5baca34 = 7680;
const $dea356723133262e$export$8a4f28336ef203d3 = 7681;
const $dea356723133262e$export$2928c0231297c036 = 7682;
const $dea356723133262e$export$c0e9611c8a15f9a8 = 7683;
const $dea356723133262e$export$9c2c08927385dcc4 = 34055;
const $dea356723133262e$export$7c74ea00fa1315e6 = 34056;
const $dea356723133262e$export$22e2e5726612443 = 5386;
const $dea356723133262e$export$1343870698229224 = 512;
const $dea356723133262e$export$8e1d8ed281997fa6 = 513;
const $dea356723133262e$export$55648a1cde8329a7 = 514;
const $dea356723133262e$export$2dff107857e6aca2 = 515;
const $dea356723133262e$export$6f93765ab2f451a2 = 516;
const $dea356723133262e$export$6f3fb2d2440f2b76 = 517;
const $dea356723133262e$export$4119cf7b4c98fd5a = 518;
const $dea356723133262e$export$14cf96713ddd97a8 = 519;
const $dea356723133262e$export$763e8360f4d7f77d = 35044;
const $dea356723133262e$export$8505d14ac8546ca = 35048;
const $dea356723133262e$export$721e63549e51d81e = 35040;
const $dea356723133262e$export$415731dc4f48e299 = 35045;
const $dea356723133262e$export$9e809946455f13bc = 35049;
const $dea356723133262e$export$2ed9499a35b5f832 = 35041;
const $dea356723133262e$export$32ab2503ea19469a = 35046;
const $dea356723133262e$export$ab4022c2c3f86315 = 35050;
const $dea356723133262e$export$ba7f1db36a76a970 = 35042;
const $dea356723133262e$export$43600cc67fabd9f = "100";
const $dea356723133262e$export$f63012db5506e7dd = "300 es";
const $dea356723133262e$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $dea356723133262e$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $dea356723133262e$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $dea356723133262e$var$_seed = 1234567;
const $dea356723133262e$var$DEG2RAD = Math.PI / 180;
const $dea356723133262e$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $dea356723133262e$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $dea356723133262e$var$_lut[d0 & 0xff] + $dea356723133262e$var$_lut[d0 >> 8 & 0xff] + $dea356723133262e$var$_lut[d0 >> 16 & 0xff] + $dea356723133262e$var$_lut[d0 >> 24 & 0xff] + "-" + $dea356723133262e$var$_lut[d1 & 0xff] + $dea356723133262e$var$_lut[d1 >> 8 & 0xff] + "-" + $dea356723133262e$var$_lut[d1 >> 16 & 0x0f | 0x40] + $dea356723133262e$var$_lut[d1 >> 24 & 0xff] + "-" + $dea356723133262e$var$_lut[d2 & 0x3f | 0x80] + $dea356723133262e$var$_lut[d2 >> 8 & 0xff] + "-" + $dea356723133262e$var$_lut[d2 >> 16 & 0xff] + $dea356723133262e$var$_lut[d2 >> 24 & 0xff] + $dea356723133262e$var$_lut[d3 & 0xff] + $dea356723133262e$var$_lut[d3 >> 8 & 0xff] + $dea356723133262e$var$_lut[d3 >> 16 & 0xff] + $dea356723133262e$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $dea356723133262e$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $dea356723133262e$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $dea356723133262e$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $dea356723133262e$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $dea356723133262e$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $dea356723133262e$var$damp(x, y, lambda, dt) {
    return $dea356723133262e$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $dea356723133262e$var$pingpong(x, length = 1) {
    return length - Math.abs($dea356723133262e$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $dea356723133262e$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $dea356723133262e$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $dea356723133262e$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $dea356723133262e$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $dea356723133262e$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $dea356723133262e$var$seededRandom(s) {
    if (s !== undefined) $dea356723133262e$var$_seed = s;
    // Mulberry32 generator
    let t = $dea356723133262e$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $dea356723133262e$var$degToRad(degrees) {
    return degrees * $dea356723133262e$var$DEG2RAD;
}
function $dea356723133262e$var$radToDeg(radians) {
    return radians * $dea356723133262e$var$RAD2DEG;
}
function $dea356723133262e$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $dea356723133262e$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $dea356723133262e$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $dea356723133262e$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $dea356723133262e$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $dea356723133262e$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $dea356723133262e$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $dea356723133262e$var$DEG2RAD,
    RAD2DEG: $dea356723133262e$var$RAD2DEG,
    generateUUID: $dea356723133262e$var$generateUUID,
    clamp: $dea356723133262e$var$clamp,
    euclideanModulo: $dea356723133262e$var$euclideanModulo,
    mapLinear: $dea356723133262e$var$mapLinear,
    inverseLerp: $dea356723133262e$var$inverseLerp,
    lerp: $dea356723133262e$var$lerp,
    damp: $dea356723133262e$var$damp,
    pingpong: $dea356723133262e$var$pingpong,
    smoothstep: $dea356723133262e$var$smoothstep,
    smootherstep: $dea356723133262e$var$smootherstep,
    randInt: $dea356723133262e$var$randInt,
    randFloat: $dea356723133262e$var$randFloat,
    randFloatSpread: $dea356723133262e$var$randFloatSpread,
    seededRandom: $dea356723133262e$var$seededRandom,
    degToRad: $dea356723133262e$var$degToRad,
    radToDeg: $dea356723133262e$var$radToDeg,
    isPowerOfTwo: $dea356723133262e$var$isPowerOfTwo,
    ceilPowerOfTwo: $dea356723133262e$var$ceilPowerOfTwo,
    floorPowerOfTwo: $dea356723133262e$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $dea356723133262e$var$setQuaternionFromProperEuler,
    normalize: $dea356723133262e$var$normalize,
    denormalize: $dea356723133262e$var$denormalize
};
class $dea356723133262e$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $dea356723133262e$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($dea356723133262e$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $dea356723133262e$export$8ff26dafa08918 {
    constructor(){
        $dea356723133262e$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($dea356723133262e$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($dea356723133262e$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($dea356723133262e$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $dea356723133262e$var$_m3 = /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918();
function $dea356723133262e$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $dea356723133262e$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $dea356723133262e$var$getTypedArray(type, buffer) {
    return new $dea356723133262e$var$TYPED_ARRAYS[type](buffer);
}
function $dea356723133262e$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $dea356723133262e$var$_cache = {};
function $dea356723133262e$var$warnOnce(message) {
    if (message in $dea356723133262e$var$_cache) return;
    $dea356723133262e$var$_cache[message] = true;
    console.warn(message);
}
function $dea356723133262e$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $dea356723133262e$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $dea356723133262e$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $dea356723133262e$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $dea356723133262e$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($dea356723133262e$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $dea356723133262e$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($dea356723133262e$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $dea356723133262e$var$TO_LINEAR = {
    [$dea356723133262e$export$42429b3acfb233a4]: (color)=>color,
    [$dea356723133262e$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$dea356723133262e$export$626af19ae879bdf6]: $dea356723133262e$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $dea356723133262e$var$FROM_LINEAR = {
    [$dea356723133262e$export$42429b3acfb233a4]: (color)=>color,
    [$dea356723133262e$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$dea356723133262e$export$626af19ae879bdf6]: $dea356723133262e$var$LinearSRGBToDisplayP3
};
const $dea356723133262e$export$5e6fd513f44698c = {
    enabled: true,
    get legacyMode () {
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $dea356723133262e$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $dea356723133262e$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $dea356723133262e$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $dea356723133262e$var$_canvas;
class $dea356723133262e$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($dea356723133262e$var$_canvas === undefined) $dea356723133262e$var$_canvas = $dea356723133262e$var$createElementNS("canvas");
            $dea356723133262e$var$_canvas.width = image.width;
            $dea356723133262e$var$_canvas.height = image.height;
            const context = $dea356723133262e$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $dea356723133262e$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $dea356723133262e$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $dea356723133262e$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($dea356723133262e$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $dea356723133262e$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
class $dea356723133262e$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        this.uuid = $dea356723133262e$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($dea356723133262e$var$serializeImage(data[i].image));
                else url.push($dea356723133262e$var$serializeImage(data[i]));
            } else // texture
            url = $dea356723133262e$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $dea356723133262e$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $dea356723133262e$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $dea356723133262e$var$textureId = 0;
class $dea356723133262e$export$5431306cf43de24a extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(image = $dea356723133262e$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $dea356723133262e$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $dea356723133262e$export$9d9334239a5a5e06, wrapT = $dea356723133262e$export$9d9334239a5a5e06, magFilter = $dea356723133262e$export$8a72f490b25c56c8, minFilter = $dea356723133262e$export$5d8599b6a933fb1b, format = $dea356723133262e$export$3f8bb04b555a363c, type = $dea356723133262e$export$2e8ce08d3f6f5e10, anisotropy = $dea356723133262e$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $dea356723133262e$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $dea356723133262e$var$textureId++
        });
        this.uuid = $dea356723133262e$var$generateUUID();
        this.name = "";
        this.source = new $dea356723133262e$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $dea356723133262e$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.center = new $dea356723133262e$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $dea356723133262e$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === "string") this.colorSpace = colorSpace1;
        else {
            $dea356723133262e$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
            this.colorSpace = colorSpace1 === $dea356723133262e$export$f32388edbb32674 ? $dea356723133262e$export$561f394b24edfcaa : $dea356723133262e$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $dea356723133262e$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $dea356723133262e$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $dea356723133262e$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $dea356723133262e$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $dea356723133262e$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $dea356723133262e$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $dea356723133262e$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $dea356723133262e$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        return this.colorSpace === $dea356723133262e$export$561f394b24edfcaa ? $dea356723133262e$export$f32388edbb32674 : $dea356723133262e$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $dea356723133262e$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        this.colorSpace = encoding === $dea356723133262e$export$f32388edbb32674 ? $dea356723133262e$export$561f394b24edfcaa : $dea356723133262e$export$bfcb490c2dd3db51;
    }
}
$dea356723133262e$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$dea356723133262e$export$5431306cf43de24a.DEFAULT_MAPPING = $dea356723133262e$export$1beec6768cbb3d2d;
$dea356723133262e$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $dea356723133262e$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $dea356723133262e$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $dea356723133262e$export$3c052beb2e51e23f extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $dea356723133262e$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $dea356723133262e$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $dea356723133262e$var$warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $dea356723133262e$export$f32388edbb32674 ? $dea356723133262e$export$561f394b24edfcaa : $dea356723133262e$export$bfcb490c2dd3db51;
        }
        this.texture = new $dea356723133262e$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $dea356723133262e$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $dea356723133262e$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $dea356723133262e$export$dfac6c8e811406a3 extends $dea356723133262e$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $dea356723133262e$export$727aa5ec3fe39bf0;
        this.minFilter = $dea356723133262e$export$727aa5ec3fe39bf0;
        this.wrapR = $dea356723133262e$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $dea356723133262e$export$c77a02c11ed180c7 extends $dea356723133262e$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $dea356723133262e$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $dea356723133262e$export$d7a3086320f856db extends $dea356723133262e$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $dea356723133262e$export$727aa5ec3fe39bf0;
        this.minFilter = $dea356723133262e$export$727aa5ec3fe39bf0;
        this.wrapR = $dea356723133262e$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $dea356723133262e$export$7ee06591009639df extends $dea356723133262e$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $dea356723133262e$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $dea356723133262e$export$bd934554fb721730 extends $dea356723133262e$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $dea356723133262e$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($dea356723133262e$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $dea356723133262e$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $dea356723133262e$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($dea356723133262e$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($dea356723133262e$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $dea356723133262e$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($dea356723133262e$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($dea356723133262e$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($dea356723133262e$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $dea356723133262e$var$_vector$b = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_quaternion$4 = /*@__PURE__*/ new $dea356723133262e$export$23d6a54f0bbc85a3();
class $dea356723133262e$export$6f7d5a9418ab2aa3 {
    constructor(min = new $dea356723133262e$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $dea356723133262e$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($dea356723133262e$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($dea356723133262e$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $dea356723133262e$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $dea356723133262e$var$_box$3.copy(object.boundingBox);
            $dea356723133262e$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($dea356723133262e$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $dea356723133262e$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($dea356723133262e$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $dea356723133262e$var$_box$3.copy(geometry.boundingBox);
                    $dea356723133262e$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($dea356723133262e$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $dea356723133262e$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $dea356723133262e$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($dea356723133262e$var$_center);
        $dea356723133262e$var$_extents.subVectors(this.max, $dea356723133262e$var$_center);
        // translate triangle to aabb origin
        $dea356723133262e$var$_v0$2.subVectors(triangle.a, $dea356723133262e$var$_center);
        $dea356723133262e$var$_v1$7.subVectors(triangle.b, $dea356723133262e$var$_center);
        $dea356723133262e$var$_v2$4.subVectors(triangle.c, $dea356723133262e$var$_center);
        // compute edge vectors for triangle
        $dea356723133262e$var$_f0.subVectors($dea356723133262e$var$_v1$7, $dea356723133262e$var$_v0$2);
        $dea356723133262e$var$_f1.subVectors($dea356723133262e$var$_v2$4, $dea356723133262e$var$_v1$7);
        $dea356723133262e$var$_f2.subVectors($dea356723133262e$var$_v0$2, $dea356723133262e$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$dea356723133262e$var$_f0.z,
            $dea356723133262e$var$_f0.y,
            0,
            -$dea356723133262e$var$_f1.z,
            $dea356723133262e$var$_f1.y,
            0,
            -$dea356723133262e$var$_f2.z,
            $dea356723133262e$var$_f2.y,
            $dea356723133262e$var$_f0.z,
            0,
            -$dea356723133262e$var$_f0.x,
            $dea356723133262e$var$_f1.z,
            0,
            -$dea356723133262e$var$_f1.x,
            $dea356723133262e$var$_f2.z,
            0,
            -$dea356723133262e$var$_f2.x,
            -$dea356723133262e$var$_f0.y,
            $dea356723133262e$var$_f0.x,
            0,
            -$dea356723133262e$var$_f1.y,
            $dea356723133262e$var$_f1.x,
            0,
            -$dea356723133262e$var$_f2.y,
            $dea356723133262e$var$_f2.x,
            0
        ];
        if (!$dea356723133262e$var$satForAxes(axes, $dea356723133262e$var$_v0$2, $dea356723133262e$var$_v1$7, $dea356723133262e$var$_v2$4, $dea356723133262e$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$dea356723133262e$var$satForAxes(axes, $dea356723133262e$var$_v0$2, $dea356723133262e$var$_v1$7, $dea356723133262e$var$_v2$4, $dea356723133262e$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $dea356723133262e$var$_triangleNormal.crossVectors($dea356723133262e$var$_f0, $dea356723133262e$var$_f1);
        axes = [
            $dea356723133262e$var$_triangleNormal.x,
            $dea356723133262e$var$_triangleNormal.y,
            $dea356723133262e$var$_triangleNormal.z
        ];
        return $dea356723133262e$var$satForAxes(axes, $dea356723133262e$var$_v0$2, $dea356723133262e$var$_v1$7, $dea356723133262e$var$_v2$4, $dea356723133262e$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $dea356723133262e$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($dea356723133262e$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $dea356723133262e$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $dea356723133262e$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $dea356723133262e$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $dea356723133262e$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $dea356723133262e$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $dea356723133262e$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $dea356723133262e$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $dea356723133262e$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($dea356723133262e$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $dea356723133262e$var$_points = [
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699()
];
const $dea356723133262e$var$_vector$a = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_box$3 = /*@__PURE__*/ new $dea356723133262e$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $dea356723133262e$var$_v0$2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v1$7 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v2$4 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
// triangle edge vectors
const $dea356723133262e$var$_f0 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_f1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_f2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_center = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_extents = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_triangleNormal = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_testAxis = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
function $dea356723133262e$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $dea356723133262e$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($dea356723133262e$var$_testAxis.x) + extents.y * Math.abs($dea356723133262e$var$_testAxis.y) + extents.z * Math.abs($dea356723133262e$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($dea356723133262e$var$_testAxis);
        const p1 = v1.dot($dea356723133262e$var$_testAxis);
        const p2 = v2.dot($dea356723133262e$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $dea356723133262e$var$_box$2 = /*@__PURE__*/ new $dea356723133262e$export$6f7d5a9418ab2aa3();
const $dea356723133262e$var$_v1$6 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v2$3 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$805e8b72413ccaba {
    constructor(center = new $dea356723133262e$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $dea356723133262e$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $dea356723133262e$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $dea356723133262e$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($dea356723133262e$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $dea356723133262e$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($dea356723133262e$var$_v1$6.copy(sphere.center).add($dea356723133262e$var$_v2$3));
            this.expandByPoint($dea356723133262e$var$_v1$6.copy(sphere.center).sub($dea356723133262e$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $dea356723133262e$var$_vector$9 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_segCenter = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_segDir = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_diff = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_edge1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_edge2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_normal$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$a186db52eed6d40e {
    constructor(origin = new $dea356723133262e$export$64b5c384219d3699(), direction = new $dea356723133262e$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $dea356723133262e$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $dea356723133262e$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $dea356723133262e$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $dea356723133262e$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $dea356723133262e$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $dea356723133262e$var$_segDir.copy(v1).sub(v0).normalize();
        $dea356723133262e$var$_diff.copy(this.origin).sub($dea356723133262e$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($dea356723133262e$var$_segDir);
        const b0 = $dea356723133262e$var$_diff.dot(this.direction);
        const b1 = -$dea356723133262e$var$_diff.dot($dea356723133262e$var$_segDir);
        const c = $dea356723133262e$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($dea356723133262e$var$_segCenter).addScaledVector($dea356723133262e$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $dea356723133262e$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $dea356723133262e$var$_vector$9.dot(this.direction);
        const d2 = $dea356723133262e$var$_vector$9.dot($dea356723133262e$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $dea356723133262e$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $dea356723133262e$var$_edge1.subVectors(b, a);
        $dea356723133262e$var$_edge2.subVectors(c, a);
        $dea356723133262e$var$_normal$1.crossVectors($dea356723133262e$var$_edge1, $dea356723133262e$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($dea356723133262e$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $dea356723133262e$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($dea356723133262e$var$_edge2.crossVectors($dea356723133262e$var$_diff, $dea356723133262e$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($dea356723133262e$var$_edge1.cross($dea356723133262e$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $dea356723133262e$var$_diff.dot($dea356723133262e$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $dea356723133262e$export$2ae72fc923e5eb5 {
    constructor(){
        $dea356723133262e$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $dea356723133262e$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $dea356723133262e$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $dea356723133262e$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $dea356723133262e$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($dea356723133262e$var$_zero, q, $dea356723133262e$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $dea356723133262e$var$_z.subVectors(eye, target);
        if ($dea356723133262e$var$_z.lengthSq() === 0) // eye and target are in the same position
        $dea356723133262e$var$_z.z = 1;
        $dea356723133262e$var$_z.normalize();
        $dea356723133262e$var$_x.crossVectors(up, $dea356723133262e$var$_z);
        if ($dea356723133262e$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $dea356723133262e$var$_z.x += 0.0001;
            else $dea356723133262e$var$_z.z += 0.0001;
            $dea356723133262e$var$_z.normalize();
            $dea356723133262e$var$_x.crossVectors(up, $dea356723133262e$var$_z);
        }
        $dea356723133262e$var$_x.normalize();
        $dea356723133262e$var$_y.crossVectors($dea356723133262e$var$_z, $dea356723133262e$var$_x);
        te[0] = $dea356723133262e$var$_x.x;
        te[4] = $dea356723133262e$var$_y.x;
        te[8] = $dea356723133262e$var$_z.x;
        te[1] = $dea356723133262e$var$_x.y;
        te[5] = $dea356723133262e$var$_y.y;
        te[9] = $dea356723133262e$var$_z.y;
        te[2] = $dea356723133262e$var$_x.z;
        te[6] = $dea356723133262e$var$_y.z;
        te[10] = $dea356723133262e$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $dea356723133262e$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $dea356723133262e$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $dea356723133262e$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $dea356723133262e$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $dea356723133262e$var$_m1$2.elements[0] *= invSX;
        $dea356723133262e$var$_m1$2.elements[1] *= invSX;
        $dea356723133262e$var$_m1$2.elements[2] *= invSX;
        $dea356723133262e$var$_m1$2.elements[4] *= invSY;
        $dea356723133262e$var$_m1$2.elements[5] *= invSY;
        $dea356723133262e$var$_m1$2.elements[6] *= invSY;
        $dea356723133262e$var$_m1$2.elements[8] *= invSZ;
        $dea356723133262e$var$_m1$2.elements[9] *= invSZ;
        $dea356723133262e$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($dea356723133262e$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $dea356723133262e$var$_v1$5 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_m1$2 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_zero = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(0, 0, 0);
const $dea356723133262e$var$_one = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(1, 1, 1);
const $dea356723133262e$var$_x = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_y = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_z = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_matrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_quaternion$3 = /*@__PURE__*/ new $dea356723133262e$export$23d6a54f0bbc85a3();
class $dea356723133262e$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $dea356723133262e$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($dea356723133262e$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$dea356723133262e$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($dea356723133262e$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$dea356723133262e$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($dea356723133262e$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$dea356723133262e$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $dea356723133262e$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($dea356723133262e$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $dea356723133262e$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($dea356723133262e$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$dea356723133262e$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $dea356723133262e$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $dea356723133262e$var$_object3DId = 0;
const $dea356723133262e$var$_v1$4 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_q1 = /*@__PURE__*/ new $dea356723133262e$export$23d6a54f0bbc85a3();
const $dea356723133262e$var$_m1$1 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_target = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_position$3 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_scale$2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_quaternion$2 = /*@__PURE__*/ new $dea356723133262e$export$23d6a54f0bbc85a3();
const $dea356723133262e$var$_xAxis = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(1, 0, 0);
const $dea356723133262e$var$_yAxis = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(0, 1, 0);
const $dea356723133262e$var$_zAxis = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(0, 0, 1);
const $dea356723133262e$var$_addedEvent = {
    type: "added"
};
const $dea356723133262e$var$_removedEvent = {
    type: "removed"
};
class $dea356723133262e$export$e4dd07dff30cc924 extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $dea356723133262e$var$_object3DId++
        });
        this.uuid = $dea356723133262e$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $dea356723133262e$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $dea356723133262e$export$64b5c384219d3699();
        const rotation = new $dea356723133262e$export$d93cc409a0768c5f();
        const quaternion = new $dea356723133262e$export$23d6a54f0bbc85a3();
        const scale = new $dea356723133262e$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $dea356723133262e$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $dea356723133262e$export$8ff26dafa08918()
            }
        });
        this.matrix = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.matrixWorld = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $dea356723133262e$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $dea356723133262e$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $dea356723133262e$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $dea356723133262e$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($dea356723133262e$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $dea356723133262e$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($dea356723133262e$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($dea356723133262e$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($dea356723133262e$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($dea356723133262e$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $dea356723133262e$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($dea356723133262e$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($dea356723133262e$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($dea356723133262e$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($dea356723133262e$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($dea356723133262e$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $dea356723133262e$var$_target.copy(x);
        else $dea356723133262e$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $dea356723133262e$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $dea356723133262e$var$_m1$1.lookAt($dea356723133262e$var$_position$3, $dea356723133262e$var$_target, this.up);
        else $dea356723133262e$var$_m1$1.lookAt($dea356723133262e$var$_target, $dea356723133262e$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($dea356723133262e$var$_m1$1);
        if (parent) {
            $dea356723133262e$var$_m1$1.extractRotation(parent.matrixWorld);
            $dea356723133262e$var$_q1.setFromRotationMatrix($dea356723133262e$var$_m1$1);
            this.quaternion.premultiply($dea356723133262e$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($dea356723133262e$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($dea356723133262e$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($dea356723133262e$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $dea356723133262e$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $dea356723133262e$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($dea356723133262e$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($dea356723133262e$var$_position$3, target, $dea356723133262e$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($dea356723133262e$var$_position$3, $dea356723133262e$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$dea356723133262e$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(0, 1, 0);
$dea356723133262e$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$dea356723133262e$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $dea356723133262e$var$_v0$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v1$3 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v2$2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v3$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vab = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vac = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vbc = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vap = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vbp = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vcp = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
let $dea356723133262e$var$warnedGetUV = false;
class $dea356723133262e$export$5a465592bfe74b48 {
    constructor(a = new $dea356723133262e$export$64b5c384219d3699(), b = new $dea356723133262e$export$64b5c384219d3699(), c = new $dea356723133262e$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $dea356723133262e$var$_v0$1.subVectors(a, b);
        target.cross($dea356723133262e$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $dea356723133262e$var$_v0$1.subVectors(c, a);
        $dea356723133262e$var$_v1$3.subVectors(b, a);
        $dea356723133262e$var$_v2$2.subVectors(point, a);
        const dot00 = $dea356723133262e$var$_v0$1.dot($dea356723133262e$var$_v0$1);
        const dot01 = $dea356723133262e$var$_v0$1.dot($dea356723133262e$var$_v1$3);
        const dot02 = $dea356723133262e$var$_v0$1.dot($dea356723133262e$var$_v2$2);
        const dot11 = $dea356723133262e$var$_v1$3.dot($dea356723133262e$var$_v1$3);
        const dot12 = $dea356723133262e$var$_v1$3.dot($dea356723133262e$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $dea356723133262e$var$_v3$1);
        return $dea356723133262e$var$_v3$1.x >= 0 && $dea356723133262e$var$_v3$1.y >= 0 && $dea356723133262e$var$_v3$1.x + $dea356723133262e$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($dea356723133262e$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $dea356723133262e$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $dea356723133262e$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $dea356723133262e$var$_v3$1.x);
        target.addScaledVector(v2, $dea356723133262e$var$_v3$1.y);
        target.addScaledVector(v3, $dea356723133262e$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $dea356723133262e$var$_v0$1.subVectors(c, b);
        $dea356723133262e$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $dea356723133262e$var$_v0$1.cross($dea356723133262e$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $dea356723133262e$var$_v0$1.subVectors(this.c, this.b);
        $dea356723133262e$var$_v1$3.subVectors(this.a, this.b);
        return $dea356723133262e$var$_v0$1.cross($dea356723133262e$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $dea356723133262e$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $dea356723133262e$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($dea356723133262e$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $dea356723133262e$var$warnedGetUV = true;
        }
        return $dea356723133262e$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $dea356723133262e$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $dea356723133262e$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $dea356723133262e$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $dea356723133262e$var$_vab.subVectors(b, a);
        $dea356723133262e$var$_vac.subVectors(c, a);
        $dea356723133262e$var$_vap.subVectors(p, a);
        const d1 = $dea356723133262e$var$_vab.dot($dea356723133262e$var$_vap);
        const d2 = $dea356723133262e$var$_vac.dot($dea356723133262e$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $dea356723133262e$var$_vbp.subVectors(p, b);
        const d3 = $dea356723133262e$var$_vab.dot($dea356723133262e$var$_vbp);
        const d4 = $dea356723133262e$var$_vac.dot($dea356723133262e$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($dea356723133262e$var$_vab, v);
        }
        $dea356723133262e$var$_vcp.subVectors(p, c);
        const d5 = $dea356723133262e$var$_vab.dot($dea356723133262e$var$_vcp);
        const d6 = $dea356723133262e$var$_vac.dot($dea356723133262e$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($dea356723133262e$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $dea356723133262e$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($dea356723133262e$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($dea356723133262e$var$_vab, v).addScaledVector($dea356723133262e$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $dea356723133262e$var$materialId = 0;
class $dea356723133262e$export$a2d8b23205c25948 extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $dea356723133262e$var$materialId++
        });
        this.uuid = $dea356723133262e$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $dea356723133262e$export$5b29a26d96ee6af0;
        this.side = $dea356723133262e$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $dea356723133262e$export$d5773124e86cf28c;
        this.blendDst = $dea356723133262e$export$11d468cc7f19e971;
        this.blendEquation = $dea356723133262e$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $dea356723133262e$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $dea356723133262e$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $dea356723133262e$export$9f542ae4b5baca34;
        this.stencilZFail = $dea356723133262e$export$9f542ae4b5baca34;
        this.stencilZPass = $dea356723133262e$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $dea356723133262e$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $dea356723133262e$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $dea356723133262e$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $dea356723133262e$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $dea356723133262e$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $dea356723133262e$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $dea356723133262e$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === "number") this.setHex(value);
        else if (typeof value === "string") this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $dea356723133262e$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $dea356723133262e$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $dea356723133262e$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $dea356723133262e$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $dea356723133262e$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $dea356723133262e$var$euclideanModulo(h, 1);
        s = $dea356723133262e$var$clamp(s, 0, 1);
        l = $dea356723133262e$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $dea356723133262e$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $dea356723133262e$var$hue2rgb(q, p, h);
            this.b = $dea356723133262e$var$hue2rgb(q, p, h - 1 / 3);
        }
        $dea356723133262e$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $dea356723133262e$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $dea356723133262e$export$561f394b24edfcaa) {
        // color keywords
        const hex = $dea356723133262e$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $dea356723133262e$var$SRGBToLinear(color.r);
        this.g = $dea356723133262e$var$SRGBToLinear(color.g);
        this.b = $dea356723133262e$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $dea356723133262e$var$LinearToSRGB(color.r);
        this.g = $dea356723133262e$var$LinearToSRGB(color.g);
        this.b = $dea356723133262e$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $dea356723133262e$export$561f394b24edfcaa) {
        $dea356723133262e$export$5e6fd513f44698c.fromWorkingColorSpace($dea356723133262e$var$_color.copy(this), colorSpace1);
        return Math.round($dea356723133262e$var$clamp($dea356723133262e$var$_color.r * 255, 0, 255)) * 65536 + Math.round($dea356723133262e$var$clamp($dea356723133262e$var$_color.g * 255, 0, 255)) * 256 + Math.round($dea356723133262e$var$clamp($dea356723133262e$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $dea356723133262e$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $dea356723133262e$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $dea356723133262e$export$5e6fd513f44698c.fromWorkingColorSpace($dea356723133262e$var$_color.copy(this), colorSpace1);
        const r = $dea356723133262e$var$_color.r, g = $dea356723133262e$var$_color.g, b = $dea356723133262e$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $dea356723133262e$export$5e6fd513f44698c.workingColorSpace) {
        $dea356723133262e$export$5e6fd513f44698c.fromWorkingColorSpace($dea356723133262e$var$_color.copy(this), colorSpace1);
        target.r = $dea356723133262e$var$_color.r;
        target.g = $dea356723133262e$var$_color.g;
        target.b = $dea356723133262e$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $dea356723133262e$export$561f394b24edfcaa) {
        $dea356723133262e$export$5e6fd513f44698c.fromWorkingColorSpace($dea356723133262e$var$_color.copy(this), colorSpace1);
        const r = $dea356723133262e$var$_color.r, g = $dea356723133262e$var$_color.g, b = $dea356723133262e$var$_color.b;
        if (colorSpace1 !== $dea356723133262e$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($dea356723133262e$var$_hslA);
        $dea356723133262e$var$_hslA.h += h;
        $dea356723133262e$var$_hslA.s += s;
        $dea356723133262e$var$_hslA.l += l;
        this.setHSL($dea356723133262e$var$_hslA.h, $dea356723133262e$var$_hslA.s, $dea356723133262e$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($dea356723133262e$var$_hslA);
        color.getHSL($dea356723133262e$var$_hslB);
        const h = $dea356723133262e$var$lerp($dea356723133262e$var$_hslA.h, $dea356723133262e$var$_hslB.h, alpha);
        const s = $dea356723133262e$var$lerp($dea356723133262e$var$_hslA.s, $dea356723133262e$var$_hslB.s, alpha);
        const l = $dea356723133262e$var$lerp($dea356723133262e$var$_hslA.l, $dea356723133262e$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $dea356723133262e$var$_color = /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e();
$dea356723133262e$export$892596cec99bc70e.NAMES = $dea356723133262e$var$_colorKeywords;
class $dea356723133262e$export$55cbcc9b622fe1f5 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $dea356723133262e$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $dea356723133262e$var$_tables = /*@__PURE__*/ $dea356723133262e$var$_generateTables();
function $dea356723133262e$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $dea356723133262e$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $dea356723133262e$var$clamp(val, -65504, 65504);
    $dea356723133262e$var$_tables.floatView[0] = val;
    const f = $dea356723133262e$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $dea356723133262e$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $dea356723133262e$var$_tables.shiftTable[e]);
}
// float16 to float32
function $dea356723133262e$var$fromHalfFloat(val) {
    const m = val >> 10;
    $dea356723133262e$var$_tables.uint32View[0] = $dea356723133262e$var$_tables.mantissaTable[$dea356723133262e$var$_tables.offsetTable[m] + (val & 0x3ff)] + $dea356723133262e$var$_tables.exponentTable[m];
    return $dea356723133262e$var$_tables.floatView[0];
}
const $dea356723133262e$export$11ce8b759162cc80 = {
    toHalfFloat: $dea356723133262e$var$toHalfFloat,
    fromHalfFloat: $dea356723133262e$var$fromHalfFloat
};
const $dea356723133262e$var$_vector$8 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vector2$1 = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
class $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $dea356723133262e$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector2$1.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $dea356723133262e$var$_vector2$1.x, $dea356723133262e$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector$8.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$8.x, $dea356723133262e$var$_vector$8.y, $dea356723133262e$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector$8.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$8.x, $dea356723133262e$var$_vector$8.y, $dea356723133262e$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector$8.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$8.x, $dea356723133262e$var$_vector$8.y, $dea356723133262e$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector$8.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$8.x, $dea356723133262e$var$_vector$8.y, $dea356723133262e$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $dea356723133262e$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $dea356723133262e$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $dea356723133262e$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $dea356723133262e$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $dea356723133262e$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $dea356723133262e$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $dea356723133262e$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $dea356723133262e$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
            z = $dea356723133262e$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
            z = $dea356723133262e$var$normalize(z, this.array);
            w = $dea356723133262e$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $dea356723133262e$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
}
//
class $dea356723133262e$export$f9ff2d6a20248cbf extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$cacc90cf35d11cdd extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$baaa85a1a812c157 extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$2b755a102ccdcefe extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$640a853f68025f2e extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$46b369aed2968a0a extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$7eb8c9fa25cd5bd6 extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$dbd3698c64958d69 extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $dea356723133262e$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $dea356723133262e$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $dea356723133262e$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $dea356723133262e$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $dea356723133262e$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $dea356723133262e$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $dea356723133262e$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $dea356723133262e$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $dea356723133262e$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $dea356723133262e$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $dea356723133262e$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $dea356723133262e$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $dea356723133262e$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $dea356723133262e$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $dea356723133262e$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $dea356723133262e$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
        }
        this.array[index + 0] = $dea356723133262e$var$toHalfFloat(x);
        this.array[index + 1] = $dea356723133262e$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
            z = $dea356723133262e$var$normalize(z, this.array);
        }
        this.array[index + 0] = $dea356723133262e$var$toHalfFloat(x);
        this.array[index + 1] = $dea356723133262e$var$toHalfFloat(y);
        this.array[index + 2] = $dea356723133262e$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
            z = $dea356723133262e$var$normalize(z, this.array);
            w = $dea356723133262e$var$normalize(w, this.array);
        }
        this.array[index + 0] = $dea356723133262e$var$toHalfFloat(x);
        this.array[index + 1] = $dea356723133262e$var$toHalfFloat(y);
        this.array[index + 2] = $dea356723133262e$var$toHalfFloat(z);
        this.array[index + 3] = $dea356723133262e$var$toHalfFloat(w);
        return this;
    }
}
class $dea356723133262e$export$cbe7a62641830ebd extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $dea356723133262e$export$9e0ade74842adbb8 extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $dea356723133262e$var$_id$1 = 0;
const $dea356723133262e$var$_m1 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_obj = /*@__PURE__*/ new $dea356723133262e$export$e4dd07dff30cc924();
const $dea356723133262e$var$_offset = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_box$1 = /*@__PURE__*/ new $dea356723133262e$export$6f7d5a9418ab2aa3();
const $dea356723133262e$var$_boxMorphTargets = /*@__PURE__*/ new $dea356723133262e$export$6f7d5a9418ab2aa3();
const $dea356723133262e$var$_vector$7 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$b7be63a67df8959 extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $dea356723133262e$var$_id$1++
        });
        this.uuid = $dea356723133262e$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($dea356723133262e$var$arrayNeedsUint32(index) ? $dea356723133262e$export$7eb8c9fa25cd5bd6 : $dea356723133262e$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $dea356723133262e$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $dea356723133262e$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($dea356723133262e$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $dea356723133262e$var$_m1.makeRotationX(angle);
        this.applyMatrix4($dea356723133262e$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $dea356723133262e$var$_m1.makeRotationY(angle);
        this.applyMatrix4($dea356723133262e$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $dea356723133262e$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($dea356723133262e$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $dea356723133262e$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($dea356723133262e$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $dea356723133262e$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($dea356723133262e$var$_m1);
        return this;
    }
    lookAt(vector) {
        $dea356723133262e$var$_obj.lookAt(vector);
        $dea356723133262e$var$_obj.updateMatrix();
        this.applyMatrix4($dea356723133262e$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($dea356723133262e$var$_offset).negate();
        this.translate($dea356723133262e$var$_offset.x, $dea356723133262e$var$_offset.y, $dea356723133262e$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $dea356723133262e$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $dea356723133262e$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $dea356723133262e$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $dea356723133262e$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $dea356723133262e$var$_vector$7.addVectors(this.boundingBox.min, $dea356723133262e$var$_box$1.min);
                    this.boundingBox.expandByPoint($dea356723133262e$var$_vector$7);
                    $dea356723133262e$var$_vector$7.addVectors(this.boundingBox.max, $dea356723133262e$var$_box$1.max);
                    this.boundingBox.expandByPoint($dea356723133262e$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($dea356723133262e$var$_box$1.min);
                    this.boundingBox.expandByPoint($dea356723133262e$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $dea356723133262e$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $dea356723133262e$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $dea356723133262e$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $dea356723133262e$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $dea356723133262e$var$_vector$7.addVectors($dea356723133262e$var$_box$1.min, $dea356723133262e$var$_boxMorphTargets.min);
                    $dea356723133262e$var$_box$1.expandByPoint($dea356723133262e$var$_vector$7);
                    $dea356723133262e$var$_vector$7.addVectors($dea356723133262e$var$_box$1.max, $dea356723133262e$var$_boxMorphTargets.max);
                    $dea356723133262e$var$_box$1.expandByPoint($dea356723133262e$var$_vector$7);
                } else {
                    $dea356723133262e$var$_box$1.expandByPoint($dea356723133262e$var$_boxMorphTargets.min);
                    $dea356723133262e$var$_box$1.expandByPoint($dea356723133262e$var$_boxMorphTargets.max);
                }
            }
            $dea356723133262e$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $dea356723133262e$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($dea356723133262e$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $dea356723133262e$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $dea356723133262e$var$_offset.fromBufferAttribute(position, j);
                        $dea356723133262e$var$_vector$7.add($dea356723133262e$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($dea356723133262e$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $dea356723133262e$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $dea356723133262e$export$64b5c384219d3699();
            tan2[i] = new $dea356723133262e$export$64b5c384219d3699();
        }
        const vA = new $dea356723133262e$export$64b5c384219d3699(), vB = new $dea356723133262e$export$64b5c384219d3699(), vC = new $dea356723133262e$export$64b5c384219d3699(), uvA = new $dea356723133262e$export$c977b3e384af9ae1(), uvB = new $dea356723133262e$export$c977b3e384af9ae1(), uvC = new $dea356723133262e$export$c977b3e384af9ae1(), sdir = new $dea356723133262e$export$64b5c384219d3699(), tdir = new $dea356723133262e$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $dea356723133262e$export$64b5c384219d3699(), tmp2 = new $dea356723133262e$export$64b5c384219d3699();
        const n = new $dea356723133262e$export$64b5c384219d3699(), n2 = new $dea356723133262e$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $dea356723133262e$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $dea356723133262e$export$64b5c384219d3699(), pB = new $dea356723133262e$export$64b5c384219d3699(), pC = new $dea356723133262e$export$64b5c384219d3699();
            const nA = new $dea356723133262e$export$64b5c384219d3699(), nB = new $dea356723133262e$export$64b5c384219d3699(), nC = new $dea356723133262e$export$64b5c384219d3699();
            const cb = new $dea356723133262e$export$64b5c384219d3699(), ab = new $dea356723133262e$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge() {
        console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeGeometries() instead.");
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $dea356723133262e$var$_vector$7.fromBufferAttribute(normals, i);
            $dea356723133262e$var$_vector$7.normalize();
            normals.setXYZ(i, $dea356723133262e$var$_vector$7.x, $dea356723133262e$var$_vector$7.y, $dea356723133262e$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $dea356723133262e$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $dea356723133262e$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
const $dea356723133262e$var$_inverseMatrix$2 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_ray$2 = /*@__PURE__*/ new $dea356723133262e$export$a186db52eed6d40e();
const $dea356723133262e$var$_sphere$4 = /*@__PURE__*/ new $dea356723133262e$export$805e8b72413ccaba();
const $dea356723133262e$var$_sphereHitAt = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vA$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vB$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vC$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_tempA = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_morphA = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_uvA$1 = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_uvB$1 = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_uvC$1 = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_normalA = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_normalB = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_normalC = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_intersectionPoint = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_intersectionPointWorld = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$e176487c05830cc5 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(geometry = new $dea356723133262e$export$b7be63a67df8959(), material = new $dea356723133262e$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $dea356723133262e$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $dea356723133262e$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $dea356723133262e$var$_morphA.addScaledVector($dea356723133262e$var$_tempA, influence);
                else $dea356723133262e$var$_morphA.addScaledVector($dea356723133262e$var$_tempA.sub(target), influence);
            }
            target.add($dea356723133262e$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $dea356723133262e$var$_sphere$4.copy(geometry.boundingSphere);
        $dea356723133262e$var$_sphere$4.applyMatrix4(matrixWorld);
        $dea356723133262e$var$_ray$2.copy(raycaster.ray).recast(raycaster.near);
        if ($dea356723133262e$var$_sphere$4.containsPoint($dea356723133262e$var$_ray$2.origin) === false) {
            if ($dea356723133262e$var$_ray$2.intersectSphere($dea356723133262e$var$_sphere$4, $dea356723133262e$var$_sphereHitAt) === null) return;
            if ($dea356723133262e$var$_ray$2.origin.distanceToSquared($dea356723133262e$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        //
        $dea356723133262e$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $dea356723133262e$var$_ray$2.copy(raycaster.ray).applyMatrix4($dea356723133262e$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($dea356723133262e$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        this._computeIntersections(raycaster, intersects);
    }
    _computeIntersections(raycaster, intersects) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $dea356723133262e$var$checkGeometryIntersection(this, groupMaterial, raycaster, $dea356723133262e$var$_ray$2, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $dea356723133262e$var$checkGeometryIntersection(this, material, raycaster, $dea356723133262e$var$_ray$2, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $dea356723133262e$var$checkGeometryIntersection(this, groupMaterial, raycaster, $dea356723133262e$var$_ray$2, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $dea356723133262e$var$checkGeometryIntersection(this, material, raycaster, $dea356723133262e$var$_ray$2, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $dea356723133262e$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $dea356723133262e$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $dea356723133262e$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $dea356723133262e$var$_intersectionPointWorld.copy(point);
    $dea356723133262e$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($dea356723133262e$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $dea356723133262e$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $dea356723133262e$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $dea356723133262e$var$_vA$1);
    object.getVertexPosition(b, $dea356723133262e$var$_vB$1);
    object.getVertexPosition(c, $dea356723133262e$var$_vC$1);
    const intersection = $dea356723133262e$var$checkIntersection(object, material, raycaster, ray, $dea356723133262e$var$_vA$1, $dea356723133262e$var$_vB$1, $dea356723133262e$var$_vC$1, $dea356723133262e$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $dea356723133262e$var$_uvA$1.fromBufferAttribute(uv, a);
            $dea356723133262e$var$_uvB$1.fromBufferAttribute(uv, b);
            $dea356723133262e$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $dea356723133262e$export$5a465592bfe74b48.getInterpolation($dea356723133262e$var$_intersectionPoint, $dea356723133262e$var$_vA$1, $dea356723133262e$var$_vB$1, $dea356723133262e$var$_vC$1, $dea356723133262e$var$_uvA$1, $dea356723133262e$var$_uvB$1, $dea356723133262e$var$_uvC$1, new $dea356723133262e$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $dea356723133262e$var$_uvA$1.fromBufferAttribute(uv1, a);
            $dea356723133262e$var$_uvB$1.fromBufferAttribute(uv1, b);
            $dea356723133262e$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $dea356723133262e$export$5a465592bfe74b48.getInterpolation($dea356723133262e$var$_intersectionPoint, $dea356723133262e$var$_vA$1, $dea356723133262e$var$_vB$1, $dea356723133262e$var$_vC$1, $dea356723133262e$var$_uvA$1, $dea356723133262e$var$_uvB$1, $dea356723133262e$var$_uvC$1, new $dea356723133262e$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // Backwards compatibility
        }
        if (normal) {
            $dea356723133262e$var$_normalA.fromBufferAttribute(normal, a);
            $dea356723133262e$var$_normalB.fromBufferAttribute(normal, b);
            $dea356723133262e$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $dea356723133262e$export$5a465592bfe74b48.getInterpolation($dea356723133262e$var$_intersectionPoint, $dea356723133262e$var$_vA$1, $dea356723133262e$var$_vB$1, $dea356723133262e$var$_vC$1, $dea356723133262e$var$_normalA, $dea356723133262e$var$_normalB, $dea356723133262e$var$_normalC, new $dea356723133262e$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $dea356723133262e$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $dea356723133262e$export$5a465592bfe74b48.getNormal($dea356723133262e$var$_vA$1, $dea356723133262e$var$_vB$1, $dea356723133262e$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $dea356723133262e$export$33e43285f7406bd5 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $dea356723133262e$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $dea356723133262e$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $dea356723133262e$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $dea356723133262e$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $dea356723133262e$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $dea356723133262e$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $dea356723133262e$export$42429b3acfb233a4;
}
// Legacy
const $dea356723133262e$export$d8ecdf8615bfea69 = {
    clone: $dea356723133262e$var$cloneUniforms,
    merge: $dea356723133262e$var$mergeUniforms
};
var $dea356723133262e$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $dea356723133262e$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $dea356723133262e$export$83c7d75d550a8b0d extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $dea356723133262e$var$default_vertex;
        this.fragmentShader = $dea356723133262e$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $dea356723133262e$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $dea356723133262e$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $dea356723133262e$export$79f141de891a5fed extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $dea356723133262e$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $dea356723133262e$export$74e4ae24825f68d7 extends $dea356723133262e$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $dea356723133262e$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($dea356723133262e$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $dea356723133262e$var$RAD2DEG * 2 * Math.atan(Math.tan($dea356723133262e$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($dea356723133262e$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $dea356723133262e$var$fov = -90; // negative fov is not an error
const $dea356723133262e$var$aspect = 1;
class $dea356723133262e$export$d0cdd0bd804995de extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        const cameraPX = new $dea356723133262e$export$74e4ae24825f68d7($dea356723133262e$var$fov, $dea356723133262e$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, 1, 0);
        cameraPX.lookAt(1, 0, 0);
        this.add(cameraPX);
        const cameraNX = new $dea356723133262e$export$74e4ae24825f68d7($dea356723133262e$var$fov, $dea356723133262e$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, 1, 0);
        cameraNX.lookAt(-1, 0, 0);
        this.add(cameraNX);
        const cameraPY = new $dea356723133262e$export$74e4ae24825f68d7($dea356723133262e$var$fov, $dea356723133262e$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, -1);
        cameraPY.lookAt(0, 1, 0);
        this.add(cameraPY);
        const cameraNY = new $dea356723133262e$export$74e4ae24825f68d7($dea356723133262e$var$fov, $dea356723133262e$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, 1);
        cameraNY.lookAt(0, -1, 0);
        this.add(cameraNY);
        const cameraPZ = new $dea356723133262e$export$74e4ae24825f68d7($dea356723133262e$var$fov, $dea356723133262e$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, 1, 0);
        cameraPZ.lookAt(0, 0, 1);
        this.add(cameraPZ);
        const cameraNZ = new $dea356723133262e$export$74e4ae24825f68d7($dea356723133262e$var$fov, $dea356723133262e$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, 1, 0);
        cameraNZ.lookAt(0, 0, -1);
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $dea356723133262e$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $dea356723133262e$export$ee2e5a18258a4049 extends $dea356723133262e$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $dea356723133262e$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $dea356723133262e$export$ac386671d651941e extends $dea356723133262e$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $dea356723133262e$var$warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $dea356723133262e$export$f32388edbb32674 ? $dea356723133262e$export$561f394b24edfcaa : $dea356723133262e$export$bfcb490c2dd3db51;
        }
        this.texture = new $dea356723133262e$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $dea356723133262e$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $dea356723133262e$export$33e43285f7406bd5(5, 5, 5);
        const material = new $dea356723133262e$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $dea356723133262e$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $dea356723133262e$export$d9f0486e75b5ace,
            blending: $dea356723133262e$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $dea356723133262e$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $dea356723133262e$export$5d8599b6a933fb1b) texture.minFilter = $dea356723133262e$export$8a72f490b25c56c8;
        const camera = new $dea356723133262e$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $dea356723133262e$var$_vector1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vector2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_normalMatrix = /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918();
class $dea356723133262e$export$7ff5ac152ef991b0 {
    constructor(normal = new $dea356723133262e$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $dea356723133262e$var$_vector1.subVectors(c, b).cross($dea356723133262e$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($dea356723133262e$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $dea356723133262e$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($dea356723133262e$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $dea356723133262e$var$_sphere$3 = /*@__PURE__*/ new $dea356723133262e$export$805e8b72413ccaba();
const $dea356723133262e$var$_vector$6 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$35efe6f4c85463d2 {
    constructor(p0 = new $dea356723133262e$export$7ff5ac152ef991b0(), p1 = new $dea356723133262e$export$7ff5ac152ef991b0(), p2 = new $dea356723133262e$export$7ff5ac152ef991b0(), p3 = new $dea356723133262e$export$7ff5ac152ef991b0(), p4 = new $dea356723133262e$export$7ff5ac152ef991b0(), p5 = new $dea356723133262e$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $dea356723133262e$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $dea356723133262e$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($dea356723133262e$var$_sphere$3);
    }
    intersectsSprite(sprite) {
        $dea356723133262e$var$_sphere$3.center.set(0, 0, 0);
        $dea356723133262e$var$_sphere$3.radius = 0.7071067811865476;
        $dea356723133262e$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($dea356723133262e$var$_sphere$3);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $dea356723133262e$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $dea356723133262e$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $dea356723133262e$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($dea356723133262e$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $dea356723133262e$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $dea356723133262e$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $dea356723133262e$export$967d831af31f69ce extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $dea356723133262e$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $dea356723133262e$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $dea356723133262e$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $dea356723133262e$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $dea356723133262e$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $dea356723133262e$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $dea356723133262e$var$begin_vertex = "vec3 transformed = vec3( position );";
var $dea356723133262e$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $dea356723133262e$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $dea356723133262e$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			 return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float R21 = R12;\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $dea356723133262e$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = dFdx( surf_pos.xyz );\n		vec3 vSigmaY = dFdy( surf_pos.xyz );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $dea356723133262e$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $dea356723133262e$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $dea356723133262e$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $dea356723133262e$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $dea356723133262e$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $dea356723133262e$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $dea356723133262e$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $dea356723133262e$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $dea356723133262e$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $dea356723133262e$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $dea356723133262e$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $dea356723133262e$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $dea356723133262e$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $dea356723133262e$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $dea356723133262e$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $dea356723133262e$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $dea356723133262e$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $dea356723133262e$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $dea356723133262e$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $dea356723133262e$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $dea356723133262e$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $dea356723133262e$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $dea356723133262e$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $dea356723133262e$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $dea356723133262e$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $dea356723133262e$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $dea356723133262e$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $dea356723133262e$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $dea356723133262e$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $dea356723133262e$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $dea356723133262e$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $dea356723133262e$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $dea356723133262e$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var $dea356723133262e$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $dea356723133262e$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $dea356723133262e$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $dea356723133262e$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $dea356723133262e$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif";
var $dea356723133262e$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $dea356723133262e$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometry.viewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $dea356723133262e$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $dea356723133262e$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $dea356723133262e$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $dea356723133262e$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $dea356723133262e$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $dea356723133262e$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $dea356723133262e$var$map_fragment = "#ifdef USE_MAP\n	diffuseColor *= texture2D( map, vMapUv );\n#endif";
var $dea356723133262e$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $dea356723133262e$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $dea356723133262e$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $dea356723133262e$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $dea356723133262e$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $dea356723133262e$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $dea356723133262e$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $dea356723133262e$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $dea356723133262e$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $dea356723133262e$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#ifdef USE_NORMALMAP_TANGENTSPACE\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $dea356723133262e$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $dea356723133262e$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $dea356723133262e$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $dea356723133262e$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $dea356723133262e$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $dea356723133262e$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $dea356723133262e$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $dea356723133262e$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $dea356723133262e$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $dea356723133262e$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $dea356723133262e$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $dea356723133262e$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $dea356723133262e$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $dea356723133262e$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $dea356723133262e$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $dea356723133262e$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $dea356723133262e$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $dea356723133262e$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $dea356723133262e$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $dea356723133262e$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $dea356723133262e$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $dea356723133262e$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $dea356723133262e$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $dea356723133262e$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $dea356723133262e$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $dea356723133262e$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $dea356723133262e$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $dea356723133262e$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $dea356723133262e$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $dea356723133262e$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );\n#endif";
var $dea356723133262e$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var $dea356723133262e$var$uv_pars_fragment = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $dea356723133262e$var$uv_pars_vertex = "#ifdef USE_UV\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $dea356723133262e$var$uv_vertex = "#ifdef USE_UV\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $dea356723133262e$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $dea356723133262e$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $dea356723133262e$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $dea356723133262e$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $dea356723133262e$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $dea356723133262e$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $dea356723133262e$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $dea356723133262e$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $dea356723133262e$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $dea356723133262e$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $dea356723133262e$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $dea356723133262e$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $dea356723133262e$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const $dea356723133262e$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $dea356723133262e$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $dea356723133262e$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $dea356723133262e$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $dea356723133262e$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $dea356723133262e$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $dea356723133262e$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $dea356723133262e$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $dea356723133262e$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $dea356723133262e$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $dea356723133262e$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $dea356723133262e$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $dea356723133262e$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $dea356723133262e$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $dea356723133262e$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const $dea356723133262e$export$955f9f2e84c43c8b = {
    alphamap_fragment: $dea356723133262e$var$alphamap_fragment,
    alphamap_pars_fragment: $dea356723133262e$var$alphamap_pars_fragment,
    alphatest_fragment: $dea356723133262e$var$alphatest_fragment,
    alphatest_pars_fragment: $dea356723133262e$var$alphatest_pars_fragment,
    aomap_fragment: $dea356723133262e$var$aomap_fragment,
    aomap_pars_fragment: $dea356723133262e$var$aomap_pars_fragment,
    begin_vertex: $dea356723133262e$var$begin_vertex,
    beginnormal_vertex: $dea356723133262e$var$beginnormal_vertex,
    bsdfs: $dea356723133262e$var$bsdfs,
    iridescence_fragment: $dea356723133262e$var$iridescence_fragment,
    bumpmap_pars_fragment: $dea356723133262e$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $dea356723133262e$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $dea356723133262e$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $dea356723133262e$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $dea356723133262e$var$clipping_planes_vertex,
    color_fragment: $dea356723133262e$var$color_fragment,
    color_pars_fragment: $dea356723133262e$var$color_pars_fragment,
    color_pars_vertex: $dea356723133262e$var$color_pars_vertex,
    color_vertex: $dea356723133262e$var$color_vertex,
    common: $dea356723133262e$var$common,
    cube_uv_reflection_fragment: $dea356723133262e$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $dea356723133262e$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $dea356723133262e$var$displacementmap_pars_vertex,
    displacementmap_vertex: $dea356723133262e$var$displacementmap_vertex,
    emissivemap_fragment: $dea356723133262e$var$emissivemap_fragment,
    emissivemap_pars_fragment: $dea356723133262e$var$emissivemap_pars_fragment,
    encodings_fragment: $dea356723133262e$var$encodings_fragment,
    encodings_pars_fragment: $dea356723133262e$var$encodings_pars_fragment,
    envmap_fragment: $dea356723133262e$var$envmap_fragment,
    envmap_common_pars_fragment: $dea356723133262e$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $dea356723133262e$var$envmap_pars_fragment,
    envmap_pars_vertex: $dea356723133262e$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $dea356723133262e$var$envmap_physical_pars_fragment,
    envmap_vertex: $dea356723133262e$var$envmap_vertex,
    fog_vertex: $dea356723133262e$var$fog_vertex,
    fog_pars_vertex: $dea356723133262e$var$fog_pars_vertex,
    fog_fragment: $dea356723133262e$var$fog_fragment,
    fog_pars_fragment: $dea356723133262e$var$fog_pars_fragment,
    gradientmap_pars_fragment: $dea356723133262e$var$gradientmap_pars_fragment,
    lightmap_fragment: $dea356723133262e$var$lightmap_fragment,
    lightmap_pars_fragment: $dea356723133262e$var$lightmap_pars_fragment,
    lights_lambert_fragment: $dea356723133262e$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $dea356723133262e$var$lights_lambert_pars_fragment,
    lights_pars_begin: $dea356723133262e$var$lights_pars_begin,
    lights_toon_fragment: $dea356723133262e$var$lights_toon_fragment,
    lights_toon_pars_fragment: $dea356723133262e$var$lights_toon_pars_fragment,
    lights_phong_fragment: $dea356723133262e$var$lights_phong_fragment,
    lights_phong_pars_fragment: $dea356723133262e$var$lights_phong_pars_fragment,
    lights_physical_fragment: $dea356723133262e$var$lights_physical_fragment,
    lights_physical_pars_fragment: $dea356723133262e$var$lights_physical_pars_fragment,
    lights_fragment_begin: $dea356723133262e$var$lights_fragment_begin,
    lights_fragment_maps: $dea356723133262e$var$lights_fragment_maps,
    lights_fragment_end: $dea356723133262e$var$lights_fragment_end,
    logdepthbuf_fragment: $dea356723133262e$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $dea356723133262e$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $dea356723133262e$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $dea356723133262e$var$logdepthbuf_vertex,
    map_fragment: $dea356723133262e$var$map_fragment,
    map_pars_fragment: $dea356723133262e$var$map_pars_fragment,
    map_particle_fragment: $dea356723133262e$var$map_particle_fragment,
    map_particle_pars_fragment: $dea356723133262e$var$map_particle_pars_fragment,
    metalnessmap_fragment: $dea356723133262e$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $dea356723133262e$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $dea356723133262e$var$morphcolor_vertex,
    morphnormal_vertex: $dea356723133262e$var$morphnormal_vertex,
    morphtarget_pars_vertex: $dea356723133262e$var$morphtarget_pars_vertex,
    morphtarget_vertex: $dea356723133262e$var$morphtarget_vertex,
    normal_fragment_begin: $dea356723133262e$var$normal_fragment_begin,
    normal_fragment_maps: $dea356723133262e$var$normal_fragment_maps,
    normal_pars_fragment: $dea356723133262e$var$normal_pars_fragment,
    normal_pars_vertex: $dea356723133262e$var$normal_pars_vertex,
    normal_vertex: $dea356723133262e$var$normal_vertex,
    normalmap_pars_fragment: $dea356723133262e$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $dea356723133262e$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $dea356723133262e$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $dea356723133262e$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $dea356723133262e$var$iridescence_pars_fragment,
    output_fragment: $dea356723133262e$var$output_fragment,
    packing: $dea356723133262e$var$packing,
    premultiplied_alpha_fragment: $dea356723133262e$var$premultiplied_alpha_fragment,
    project_vertex: $dea356723133262e$var$project_vertex,
    dithering_fragment: $dea356723133262e$var$dithering_fragment,
    dithering_pars_fragment: $dea356723133262e$var$dithering_pars_fragment,
    roughnessmap_fragment: $dea356723133262e$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $dea356723133262e$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $dea356723133262e$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $dea356723133262e$var$shadowmap_pars_vertex,
    shadowmap_vertex: $dea356723133262e$var$shadowmap_vertex,
    shadowmask_pars_fragment: $dea356723133262e$var$shadowmask_pars_fragment,
    skinbase_vertex: $dea356723133262e$var$skinbase_vertex,
    skinning_pars_vertex: $dea356723133262e$var$skinning_pars_vertex,
    skinning_vertex: $dea356723133262e$var$skinning_vertex,
    skinnormal_vertex: $dea356723133262e$var$skinnormal_vertex,
    specularmap_fragment: $dea356723133262e$var$specularmap_fragment,
    specularmap_pars_fragment: $dea356723133262e$var$specularmap_pars_fragment,
    tonemapping_fragment: $dea356723133262e$var$tonemapping_fragment,
    tonemapping_pars_fragment: $dea356723133262e$var$tonemapping_pars_fragment,
    transmission_fragment: $dea356723133262e$var$transmission_fragment,
    transmission_pars_fragment: $dea356723133262e$var$transmission_pars_fragment,
    uv_pars_fragment: $dea356723133262e$var$uv_pars_fragment,
    uv_pars_vertex: $dea356723133262e$var$uv_pars_vertex,
    uv_vertex: $dea356723133262e$var$uv_vertex,
    worldpos_vertex: $dea356723133262e$var$worldpos_vertex,
    background_vert: $dea356723133262e$var$vertex$h,
    background_frag: $dea356723133262e$var$fragment$h,
    backgroundCube_vert: $dea356723133262e$var$vertex$g,
    backgroundCube_frag: $dea356723133262e$var$fragment$g,
    cube_vert: $dea356723133262e$var$vertex$f,
    cube_frag: $dea356723133262e$var$fragment$f,
    depth_vert: $dea356723133262e$var$vertex$e,
    depth_frag: $dea356723133262e$var$fragment$e,
    distanceRGBA_vert: $dea356723133262e$var$vertex$d,
    distanceRGBA_frag: $dea356723133262e$var$fragment$d,
    equirect_vert: $dea356723133262e$var$vertex$c,
    equirect_frag: $dea356723133262e$var$fragment$c,
    linedashed_vert: $dea356723133262e$var$vertex$b,
    linedashed_frag: $dea356723133262e$var$fragment$b,
    meshbasic_vert: $dea356723133262e$var$vertex$a,
    meshbasic_frag: $dea356723133262e$var$fragment$a,
    meshlambert_vert: $dea356723133262e$var$vertex$9,
    meshlambert_frag: $dea356723133262e$var$fragment$9,
    meshmatcap_vert: $dea356723133262e$var$vertex$8,
    meshmatcap_frag: $dea356723133262e$var$fragment$8,
    meshnormal_vert: $dea356723133262e$var$vertex$7,
    meshnormal_frag: $dea356723133262e$var$fragment$7,
    meshphong_vert: $dea356723133262e$var$vertex$6,
    meshphong_frag: $dea356723133262e$var$fragment$6,
    meshphysical_vert: $dea356723133262e$var$vertex$5,
    meshphysical_frag: $dea356723133262e$var$fragment$5,
    meshtoon_vert: $dea356723133262e$var$vertex$4,
    meshtoon_frag: $dea356723133262e$var$fragment$4,
    points_vert: $dea356723133262e$var$vertex$3,
    points_frag: $dea356723133262e$var$fragment$3,
    shadow_vert: $dea356723133262e$var$vertex$2,
    shadow_frag: $dea356723133262e$var$fragment$2,
    sprite_vert: $dea356723133262e$var$vertex$1,
    sprite_frag: $dea356723133262e$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $dea356723133262e$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    }
};
const $dea356723133262e$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.specularmap,
            $dea356723133262e$export$6643083551874bf5.envmap,
            $dea356723133262e$export$6643083551874bf5.aomap,
            $dea356723133262e$export$6643083551874bf5.lightmap,
            $dea356723133262e$export$6643083551874bf5.fog
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.specularmap,
            $dea356723133262e$export$6643083551874bf5.envmap,
            $dea356723133262e$export$6643083551874bf5.aomap,
            $dea356723133262e$export$6643083551874bf5.lightmap,
            $dea356723133262e$export$6643083551874bf5.emissivemap,
            $dea356723133262e$export$6643083551874bf5.bumpmap,
            $dea356723133262e$export$6643083551874bf5.normalmap,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            $dea356723133262e$export$6643083551874bf5.fog,
            $dea356723133262e$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.specularmap,
            $dea356723133262e$export$6643083551874bf5.envmap,
            $dea356723133262e$export$6643083551874bf5.aomap,
            $dea356723133262e$export$6643083551874bf5.lightmap,
            $dea356723133262e$export$6643083551874bf5.emissivemap,
            $dea356723133262e$export$6643083551874bf5.bumpmap,
            $dea356723133262e$export$6643083551874bf5.normalmap,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            $dea356723133262e$export$6643083551874bf5.fog,
            $dea356723133262e$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.envmap,
            $dea356723133262e$export$6643083551874bf5.aomap,
            $dea356723133262e$export$6643083551874bf5.lightmap,
            $dea356723133262e$export$6643083551874bf5.emissivemap,
            $dea356723133262e$export$6643083551874bf5.bumpmap,
            $dea356723133262e$export$6643083551874bf5.normalmap,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            $dea356723133262e$export$6643083551874bf5.roughnessmap,
            $dea356723133262e$export$6643083551874bf5.metalnessmap,
            $dea356723133262e$export$6643083551874bf5.fog,
            $dea356723133262e$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.aomap,
            $dea356723133262e$export$6643083551874bf5.lightmap,
            $dea356723133262e$export$6643083551874bf5.emissivemap,
            $dea356723133262e$export$6643083551874bf5.bumpmap,
            $dea356723133262e$export$6643083551874bf5.normalmap,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            $dea356723133262e$export$6643083551874bf5.gradientmap,
            $dea356723133262e$export$6643083551874bf5.fog,
            $dea356723133262e$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.bumpmap,
            $dea356723133262e$export$6643083551874bf5.normalmap,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            $dea356723133262e$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.points,
            $dea356723133262e$export$6643083551874bf5.fog
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.bumpmap,
            $dea356723133262e$export$6643083551874bf5.normalmap,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.sprite,
            $dea356723133262e$export$6643083551874bf5.fog
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.common,
            $dea356723133262e$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
            $dea356723133262e$export$6643083551874bf5.lights,
            $dea356723133262e$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.shadow_frag
    }
};
$dea356723133262e$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $dea356723133262e$var$mergeUniforms([
        $dea356723133262e$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $dea356723133262e$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $dea356723133262e$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $dea356723133262e$export$955f9f2e84c43c8b.meshphysical_frag
};
const $dea356723133262e$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $dea356723133262e$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $dea356723133262e$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const xr = renderer.xr;
        const environmentBlendMode = xr.getEnvironmentBlendMode();
        switch(environmentBlendMode){
            case "opaque":
                forceClear = true;
                break;
            case "additive":
                state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
                forceClear = true;
                break;
            case "alpha-blend":
                state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
                forceClear = true;
                break;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $dea356723133262e$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $dea356723133262e$export$e176487c05830cc5(new $dea356723133262e$export$33e43285f7406bd5(1, 1, 1), new $dea356723133262e$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $dea356723133262e$var$cloneUniforms($dea356723133262e$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $dea356723133262e$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $dea356723133262e$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $dea356723133262e$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.colorSpace === $dea356723133262e$export$561f394b24edfcaa ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $dea356723133262e$export$e176487c05830cc5(new $dea356723133262e$export$967d831af31f69ce(2, 2), new $dea356723133262e$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $dea356723133262e$var$cloneUniforms($dea356723133262e$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $dea356723133262e$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $dea356723133262e$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $dea356723133262e$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.colorSpace === $dea356723133262e$export$561f394b24edfcaa ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($dea356723133262e$var$_rgb, $dea356723133262e$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($dea356723133262e$var$_rgb.r, $dea356723133262e$var$_rgb.g, $dea356723133262e$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $dea356723133262e$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $dea356723133262e$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $dea356723133262e$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl.constructor.name === "WebGL2RenderingContext";
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $dea356723133262e$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $dea356723133262e$export$7ff5ac152ef991b0(), viewNormalMatrix = new $dea356723133262e$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $dea356723133262e$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $dea356723133262e$export$d64030b316d3b087) texture.mapping = $dea356723133262e$export$8759762a6477f2c4;
        else if (mapping === $dea356723133262e$export$ee99d97d46898098) texture.mapping = $dea356723133262e$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $dea356723133262e$export$d64030b316d3b087 || mapping === $dea356723133262e$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $dea356723133262e$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $dea356723133262e$export$9ebf355ee4ed261b extends $dea356723133262e$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $dea356723133262e$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $dea356723133262e$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $dea356723133262e$var$MAX_SAMPLES = 20;
const $dea356723133262e$var$_flatCamera = /*@__PURE__*/ new $dea356723133262e$export$9ebf355ee4ed261b();
const $dea356723133262e$var$_clearColor = /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e();
let $dea356723133262e$var$_oldTarget = null;
// Golden Ratio
const $dea356723133262e$var$PHI = (1 + Math.sqrt(5)) / 2;
const $dea356723133262e$var$INV_PHI = 1 / $dea356723133262e$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $dea356723133262e$var$_axisDirections = [
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(0, $dea356723133262e$var$PHI, $dea356723133262e$var$INV_PHI),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(0, $dea356723133262e$var$PHI, -$dea356723133262e$var$INV_PHI),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699($dea356723133262e$var$INV_PHI, 0, $dea356723133262e$var$PHI),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(-$dea356723133262e$var$INV_PHI, 0, $dea356723133262e$var$PHI),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699($dea356723133262e$var$PHI, $dea356723133262e$var$INV_PHI, 0),
    /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699(-$dea356723133262e$var$PHI, $dea356723133262e$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $dea356723133262e$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $dea356723133262e$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $dea356723133262e$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $dea356723133262e$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($dea356723133262e$var$_oldTarget);
        outputTarget.scissorTest = false;
        $dea356723133262e$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $dea356723133262e$export$8759762a6477f2c4 || texture.mapping === $dea356723133262e$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $dea356723133262e$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $dea356723133262e$export$8a72f490b25c56c8,
            minFilter: $dea356723133262e$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $dea356723133262e$export$2697304443f382bc,
            format: $dea356723133262e$export$3f8bb04b555a363c,
            colorSpace: $dea356723133262e$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $dea356723133262e$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $dea356723133262e$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $dea356723133262e$var$_createPlanes(_lodMax));
            this._blurMaterial = $dea356723133262e$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $dea356723133262e$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $dea356723133262e$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $dea356723133262e$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($dea356723133262e$var$_clearColor);
        renderer.toneMapping = $dea356723133262e$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $dea356723133262e$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $dea356723133262e$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $dea356723133262e$export$e176487c05830cc5(new $dea356723133262e$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($dea356723133262e$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $dea356723133262e$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $dea356723133262e$export$8759762a6477f2c4 || texture.mapping === $dea356723133262e$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $dea356723133262e$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $dea356723133262e$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $dea356723133262e$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $dea356723133262e$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $dea356723133262e$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $dea356723133262e$var$_axisDirections[(i - 1) % $dea356723133262e$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $dea356723133262e$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $dea356723133262e$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $dea356723133262e$var$MAX_SAMPLES;
        if (samples > $dea356723133262e$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$dea356723133262e$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $dea356723133262e$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $dea356723133262e$var$LOD_MIN ? lodOut - _lodMax + $dea356723133262e$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $dea356723133262e$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $dea356723133262e$var$_flatCamera);
    }
}
function $dea356723133262e$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $dea356723133262e$var$LOD_MIN + 1 + $dea356723133262e$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $dea356723133262e$var$LOD_MIN) sigma = $dea356723133262e$var$EXTRA_LOD_SIGMA[i - lodMax + $dea356723133262e$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $dea356723133262e$export$b7be63a67df8959();
        planes.setAttribute("position", new $dea356723133262e$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $dea356723133262e$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $dea356723133262e$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $dea356723133262e$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $dea356723133262e$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $dea356723133262e$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $dea356723133262e$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $dea356723133262e$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $dea356723133262e$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($dea356723133262e$var$MAX_SAMPLES);
    const poleAxis = new $dea356723133262e$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $dea356723133262e$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $dea356723133262e$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $dea356723133262e$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $dea356723133262e$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $dea356723133262e$var$_getEquirectMaterial() {
    return new $dea356723133262e$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $dea356723133262e$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $dea356723133262e$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $dea356723133262e$var$_getCubemapMaterial() {
    return new $dea356723133262e$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $dea356723133262e$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $dea356723133262e$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $dea356723133262e$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $dea356723133262e$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $dea356723133262e$export$d64030b316d3b087 || mapping === $dea356723133262e$export$ee99d97d46898098;
            const isCubeMap = mapping === $dea356723133262e$export$8759762a6477f2c4 || mapping === $dea356723133262e$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $dea356723133262e$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $dea356723133262e$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $dea356723133262e$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $dea356723133262e$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($dea356723133262e$var$arrayNeedsUint32(indices) ? $dea356723133262e$export$7eb8c9fa25cd5bd6 : $dea356723133262e$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $dea356723133262e$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $dea356723133262e$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $dea356723133262e$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $dea356723133262e$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $dea356723133262e$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $dea356723133262e$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $dea356723133262e$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $dea356723133262e$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $dea356723133262e$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($dea356723133262e$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($dea356723133262e$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $dea356723133262e$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $dea356723133262e$var$emptyTexture = /*@__PURE__*/ new $dea356723133262e$export$5431306cf43de24a();
const $dea356723133262e$var$emptyArrayTexture = /*@__PURE__*/ new $dea356723133262e$export$dfac6c8e811406a3();
const $dea356723133262e$var$empty3dTexture = /*@__PURE__*/ new $dea356723133262e$export$d7a3086320f856db();
const $dea356723133262e$var$emptyCubeTexture = /*@__PURE__*/ new $dea356723133262e$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $dea356723133262e$var$arrayCacheF32 = [];
const $dea356723133262e$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $dea356723133262e$var$mat4array = new Float32Array(16);
const $dea356723133262e$var$mat3array = new Float32Array(9);
const $dea356723133262e$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $dea356723133262e$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $dea356723133262e$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $dea356723133262e$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $dea356723133262e$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $dea356723133262e$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $dea356723133262e$var$allocTexUnits(textures, n) {
    let r = $dea356723133262e$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $dea356723133262e$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $dea356723133262e$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $dea356723133262e$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
function $dea356723133262e$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
function $dea356723133262e$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $dea356723133262e$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $dea356723133262e$var$copyArray(cache, v);
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, elements)) return;
        $dea356723133262e$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $dea356723133262e$var$mat2array);
        $dea356723133262e$var$copyArray(cache, elements);
    }
}
function $dea356723133262e$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $dea356723133262e$var$copyArray(cache, v);
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, elements)) return;
        $dea356723133262e$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $dea356723133262e$var$mat3array);
        $dea356723133262e$var$copyArray(cache, elements);
    }
}
function $dea356723133262e$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $dea356723133262e$var$copyArray(cache, v);
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, elements)) return;
        $dea356723133262e$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $dea356723133262e$var$mat4array);
        $dea356723133262e$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $dea356723133262e$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $dea356723133262e$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
function $dea356723133262e$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
function $dea356723133262e$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $dea356723133262e$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $dea356723133262e$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
function $dea356723133262e$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
function $dea356723133262e$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($dea356723133262e$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $dea356723133262e$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $dea356723133262e$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $dea356723133262e$var$emptyTexture, unit);
}
function $dea356723133262e$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $dea356723133262e$var$empty3dTexture, unit);
}
function $dea356723133262e$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $dea356723133262e$var$emptyCubeTexture, unit);
}
function $dea356723133262e$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $dea356723133262e$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $dea356723133262e$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $dea356723133262e$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $dea356723133262e$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $dea356723133262e$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $dea356723133262e$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $dea356723133262e$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $dea356723133262e$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $dea356723133262e$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $dea356723133262e$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $dea356723133262e$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $dea356723133262e$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $dea356723133262e$var$setValueV4i; // _VEC4
        case 0x1405:
            return $dea356723133262e$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $dea356723133262e$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $dea356723133262e$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $dea356723133262e$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $dea356723133262e$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $dea356723133262e$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $dea356723133262e$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $dea356723133262e$var$setValueT2DArray1;
    }
}
// Array of scalars
function $dea356723133262e$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $dea356723133262e$var$setValueV2fArray(gl, v) {
    const data = $dea356723133262e$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $dea356723133262e$var$setValueV3fArray(gl, v) {
    const data = $dea356723133262e$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $dea356723133262e$var$setValueV4fArray(gl, v) {
    const data = $dea356723133262e$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $dea356723133262e$var$setValueM2Array(gl, v) {
    const data = $dea356723133262e$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $dea356723133262e$var$setValueM3Array(gl, v) {
    const data = $dea356723133262e$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $dea356723133262e$var$setValueM4Array(gl, v) {
    const data = $dea356723133262e$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $dea356723133262e$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $dea356723133262e$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $dea356723133262e$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $dea356723133262e$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $dea356723133262e$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $dea356723133262e$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $dea356723133262e$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $dea356723133262e$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $dea356723133262e$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $dea356723133262e$var$allocTexUnits(textures, n);
    if (!$dea356723133262e$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $dea356723133262e$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $dea356723133262e$var$emptyTexture, units[i]);
}
function $dea356723133262e$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $dea356723133262e$var$allocTexUnits(textures, n);
    if (!$dea356723133262e$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $dea356723133262e$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $dea356723133262e$var$empty3dTexture, units[i]);
}
function $dea356723133262e$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $dea356723133262e$var$allocTexUnits(textures, n);
    if (!$dea356723133262e$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $dea356723133262e$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $dea356723133262e$var$emptyCubeTexture, units[i]);
}
function $dea356723133262e$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $dea356723133262e$var$allocTexUnits(textures, n);
    if (!$dea356723133262e$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $dea356723133262e$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $dea356723133262e$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $dea356723133262e$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $dea356723133262e$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $dea356723133262e$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $dea356723133262e$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $dea356723133262e$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $dea356723133262e$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $dea356723133262e$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $dea356723133262e$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $dea356723133262e$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $dea356723133262e$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $dea356723133262e$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $dea356723133262e$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $dea356723133262e$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $dea356723133262e$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $dea356723133262e$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $dea356723133262e$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $dea356723133262e$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $dea356723133262e$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $dea356723133262e$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $dea356723133262e$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $dea356723133262e$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $dea356723133262e$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $dea356723133262e$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $dea356723133262e$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $dea356723133262e$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $dea356723133262e$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $dea356723133262e$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $dea356723133262e$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $dea356723133262e$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $dea356723133262e$var$RePathPart.exec(path), matchEnd = $dea356723133262e$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $dea356723133262e$var$addUniform(container, subscript === undefined ? new $dea356723133262e$var$SingleUniform(id, activeInfo, addr) : new $dea356723133262e$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $dea356723133262e$var$StructuredUniform(id);
                $dea356723133262e$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $dea356723133262e$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $dea356723133262e$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $dea356723133262e$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $dea356723133262e$var$programIdCount = 0;
function $dea356723133262e$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $dea356723133262e$var$getEncodingComponents(colorSpace1) {
    switch(colorSpace1){
        case $dea356723133262e$export$42429b3acfb233a4:
            return [
                "Linear",
                "( value )"
            ];
        case $dea356723133262e$export$561f394b24edfcaa:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $dea356723133262e$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $dea356723133262e$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $dea356723133262e$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $dea356723133262e$var$getEncodingComponents(colorSpace1);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $dea356723133262e$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $dea356723133262e$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $dea356723133262e$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $dea356723133262e$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $dea356723133262e$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $dea356723133262e$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $dea356723133262e$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($dea356723133262e$var$filterEmptyLine).join("\n");
}
function $dea356723133262e$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $dea356723133262e$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $dea356723133262e$var$filterEmptyLine(string) {
    return string !== "";
}
function $dea356723133262e$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $dea356723133262e$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $dea356723133262e$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $dea356723133262e$var$resolveIncludes(string) {
    return string.replace($dea356723133262e$var$includePattern, $dea356723133262e$var$includeReplacer);
}
function $dea356723133262e$var$includeReplacer(match, include) {
    const string = $dea356723133262e$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error("Can not resolve #include <" + include + ">");
    return $dea356723133262e$var$resolveIncludes(string);
}
// Unroll Loops
const $dea356723133262e$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $dea356723133262e$var$unrollLoops(string) {
    return string.replace($dea356723133262e$var$unrollLoopPattern, $dea356723133262e$var$loopReplacer);
}
function $dea356723133262e$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $dea356723133262e$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $dea356723133262e$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $dea356723133262e$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $dea356723133262e$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $dea356723133262e$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $dea356723133262e$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $dea356723133262e$export$8759762a6477f2c4:
        case $dea356723133262e$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $dea356723133262e$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $dea356723133262e$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $dea356723133262e$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $dea356723133262e$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $dea356723133262e$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $dea356723133262e$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $dea356723133262e$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $dea356723133262e$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $dea356723133262e$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $dea356723133262e$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $dea356723133262e$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $dea356723133262e$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $dea356723133262e$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $dea356723133262e$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $dea356723133262e$var$generateExtensions(parameters);
    const customDefines = $dea356723133262e$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($dea356723133262e$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($dea356723133262e$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $dea356723133262e$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($dea356723133262e$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $dea356723133262e$var$generatePrecision(parameters),
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $dea356723133262e$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $dea356723133262e$export$9fcb6b4294603b2 ? $dea356723133262e$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $dea356723133262e$export$9fcb6b4294603b2 ? $dea356723133262e$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $dea356723133262e$export$955f9f2e84c43c8b["encodings_pars_fragment"],
            $dea356723133262e$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($dea356723133262e$var$filterEmptyLine).join("\n");
    }
    vertexShader = $dea356723133262e$var$resolveIncludes(vertexShader);
    vertexShader = $dea356723133262e$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $dea356723133262e$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $dea356723133262e$var$resolveIncludes(fragmentShader);
    fragmentShader = $dea356723133262e$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $dea356723133262e$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $dea356723133262e$var$unrollLoops(vertexShader);
    fragmentShader = $dea356723133262e$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $dea356723133262e$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $dea356723133262e$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $dea356723133262e$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $dea356723133262e$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $dea356723133262e$var$getShaderErrors(gl, glVertexShader, "vertex");
                const fragmentErrors = $dea356723133262e$var$getShaderErrors(gl, glFragmentShader, "fragment");
                console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
            }
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $dea356723133262e$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $dea356723133262e$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $dea356723133262e$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $dea356723133262e$var$_id = 0;
class $dea356723133262e$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $dea356723133262e$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $dea356723133262e$var$WebGLShaderStage {
    constructor(code){
        this.id = $dea356723133262e$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $dea356723133262e$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $dea356723133262e$export$89312ce47c0ca777();
    const _customShaders = new $dea356723133262e$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        if (value === 1) return "uv1";
        if (value === 2) return "uv2";
        if (value === 3) return "uv3";
        return "uv";
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $dea356723133262e$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $dea356723133262e$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $dea356723133262e$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $dea356723133262e$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $dea356723133262e$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $dea356723133262e$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: HAS_NORMALMAP && !!geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $dea356723133262e$export$9fcb6b4294603b2,
            useLegacyLights: renderer.useLegacyLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $dea356723133262e$export$3b296b6f144d5b03,
            flipSided: material.side === $dea356723133262e$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $dea356723133262e$export$bee4a7d47f8f5014[shaderID];
            uniforms = $dea356723133262e$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $dea356723133262e$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $dea356723133262e$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $dea356723133262e$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $dea356723133262e$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $dea356723133262e$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $dea356723133262e$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $dea356723133262e$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $dea356723133262e$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $dea356723133262e$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $dea356723133262e$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $dea356723133262e$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $dea356723133262e$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $dea356723133262e$export$64b5c384219d3699(),
                        color: new $dea356723133262e$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $dea356723133262e$export$64b5c384219d3699(),
                        direction: new $dea356723133262e$export$64b5c384219d3699(),
                        color: new $dea356723133262e$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $dea356723133262e$export$64b5c384219d3699(),
                        color: new $dea356723133262e$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $dea356723133262e$export$64b5c384219d3699(),
                        skyColor: new $dea356723133262e$export$892596cec99bc70e(),
                        groundColor: new $dea356723133262e$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $dea356723133262e$export$892596cec99bc70e(),
                        position: new $dea356723133262e$export$64b5c384219d3699(),
                        halfWidth: new $dea356723133262e$export$64b5c384219d3699(),
                        halfHeight: new $dea356723133262e$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $dea356723133262e$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $dea356723133262e$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $dea356723133262e$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $dea356723133262e$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $dea356723133262e$var$nextVersion = 0;
function $dea356723133262e$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $dea356723133262e$var$WebGLLights(extensions, capabilities) {
    const cache = new $dea356723133262e$var$UniformsCache();
    const shadowCache = $dea356723133262e$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $dea356723133262e$export$64b5c384219d3699());
    const vector3 = new $dea356723133262e$export$64b5c384219d3699();
    const matrix4 = new $dea356723133262e$export$2ae72fc923e5eb5();
    const matrix42 = new $dea356723133262e$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($dea356723133262e$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $dea356723133262e$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $dea356723133262e$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $dea356723133262e$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $dea356723133262e$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $dea356723133262e$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $dea356723133262e$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $dea356723133262e$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $dea356723133262e$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $dea356723133262e$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $dea356723133262e$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $dea356723133262e$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $dea356723133262e$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $dea356723133262e$export$2698c22ec13825db extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $dea356723133262e$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $dea356723133262e$export$33e187ed002f2a19 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $dea356723133262e$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $dea356723133262e$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $dea356723133262e$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $dea356723133262e$export$35efe6f4c85463d2();
    const _shadowMapSize = new $dea356723133262e$export$c977b3e384af9ae1(), _viewportSize = new $dea356723133262e$export$c977b3e384af9ae1(), _viewport = new $dea356723133262e$export$fa7daccca11cdbe3(), _depthMaterial = new $dea356723133262e$export$2698c22ec13825db({
        depthPacking: $dea356723133262e$export$8f910f4c4f73df11
    }), _distanceMaterial = new $dea356723133262e$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$dea356723133262e$export$2ede184fc2998901]: $dea356723133262e$export$d9f0486e75b5ace,
        [$dea356723133262e$export$d9f0486e75b5ace]: $dea356723133262e$export$2ede184fc2998901,
        [$dea356723133262e$export$3b296b6f144d5b03]: $dea356723133262e$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $dea356723133262e$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $dea356723133262e$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $dea356723133262e$var$vertex,
        fragmentShader: $dea356723133262e$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $dea356723133262e$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $dea356723133262e$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $dea356723133262e$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $dea356723133262e$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($dea356723133262e$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $dea356723133262e$export$896ae1ade6c829c4 && this.type === $dea356723133262e$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $dea356723133262e$export$896ae1ade6c829c4 && this.type !== $dea356723133262e$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $dea356723133262e$export$896ae1ade6c829c4 ? {
                    minFilter: $dea356723133262e$export$727aa5ec3fe39bf0,
                    magFilter: $dea356723133262e$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $dea356723133262e$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $dea356723133262e$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $dea356723133262e$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $dea356723133262e$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $dea356723133262e$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $dea356723133262e$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $dea356723133262e$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $dea356723133262e$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $dea356723133262e$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $dea356723133262e$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $dea356723133262e$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $dea356723133262e$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $dea356723133262e$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $dea356723133262e$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $dea356723133262e$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $dea356723133262e$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $dea356723133262e$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $dea356723133262e$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($dea356723133262e$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($dea356723133262e$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($dea356723133262e$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$dea356723133262e$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$dea356723133262e$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$dea356723133262e$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$dea356723133262e$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$dea356723133262e$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$dea356723133262e$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$dea356723133262e$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$dea356723133262e$export$2110f05edf778d3d]: gl.ZERO,
        [$dea356723133262e$export$8805bad65e24940e]: gl.ONE,
        [$dea356723133262e$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$dea356723133262e$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$dea356723133262e$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$dea356723133262e$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$dea356723133262e$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$dea356723133262e$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$dea356723133262e$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$dea356723133262e$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$dea356723133262e$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $dea356723133262e$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $dea356723133262e$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $dea356723133262e$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $dea356723133262e$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $dea356723133262e$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $dea356723133262e$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $dea356723133262e$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $dea356723133262e$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $dea356723133262e$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $dea356723133262e$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $dea356723133262e$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $dea356723133262e$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $dea356723133262e$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $dea356723133262e$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $dea356723133262e$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $dea356723133262e$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $dea356723133262e$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($dea356723133262e$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $dea356723133262e$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $dea356723133262e$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $dea356723133262e$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $dea356723133262e$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $dea356723133262e$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $dea356723133262e$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $dea356723133262e$var$isPowerOfTwo(image.width) && $dea356723133262e$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $dea356723133262e$export$9d9334239a5a5e06 || texture.wrapT !== $dea356723133262e$export$9d9334239a5a5e06 || texture.minFilter !== $dea356723133262e$export$727aa5ec3fe39bf0 && texture.minFilter !== $dea356723133262e$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $dea356723133262e$export$727aa5ec3fe39bf0 && texture.minFilter !== $dea356723133262e$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = colorSpace1 === $dea356723133262e$export$561f394b24edfcaa && forceLinearTransfer === false ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $dea356723133262e$export$727aa5ec3fe39bf0 && texture.minFilter !== $dea356723133262e$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $dea356723133262e$export$727aa5ec3fe39bf0 || f === $dea356723133262e$export$d129e38cf6feaa8c || f === $dea356723133262e$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$dea356723133262e$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$dea356723133262e$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$dea356723133262e$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$dea356723133262e$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$dea356723133262e$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$dea356723133262e$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$dea356723133262e$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$dea356723133262e$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$dea356723133262e$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $dea356723133262e$export$9d9334239a5a5e06 || texture.wrapT !== $dea356723133262e$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $dea356723133262e$export$727aa5ec3fe39bf0 && texture.minFilter !== $dea356723133262e$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.magFilter === $dea356723133262e$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $dea356723133262e$export$d2327c1afe5bfdf2 && texture.minFilter !== $dea356723133262e$export$5d8599b6a933fb1b) return;
            if (texture.type === $dea356723133262e$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $dea356723133262e$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $dea356723133262e$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $dea356723133262e$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $dea356723133262e$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $dea356723133262e$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $dea356723133262e$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $dea356723133262e$export$c63dc51868b06a9d && texture.type !== $dea356723133262e$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $dea356723133262e$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $dea356723133262e$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $dea356723133262e$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $dea356723133262e$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $dea356723133262e$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $dea356723133262e$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $dea356723133262e$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $dea356723133262e$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $dea356723133262e$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $dea356723133262e$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $dea356723133262e$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.format === $dea356723133262e$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $dea356723133262e$export$42429b3acfb233a4 && colorSpace1 !== $dea356723133262e$export$bfcb490c2dd3db51) {
            // sRGB
            if (colorSpace1 === $dea356723133262e$export$561f394b24edfcaa) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $dea356723133262e$export$3f8bb04b555a363c) {
                        texture.format = $dea356723133262e$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $dea356723133262e$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $dea356723133262e$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $dea356723133262e$export$3f8bb04b555a363c || type !== $dea356723133262e$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $dea356723133262e$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $dea356723133262e$export$bfcb490c2dd3db51) {
        let extension;
        if (p === $dea356723133262e$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $dea356723133262e$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $dea356723133262e$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $dea356723133262e$export$545fce0311a9796a) return gl.BYTE;
        if (p === $dea356723133262e$export$88572337f312435f) return gl.SHORT;
        if (p === $dea356723133262e$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $dea356723133262e$export$5c612977753abe2) return gl.INT;
        if (p === $dea356723133262e$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $dea356723133262e$export$f6d331659b644596) return gl.FLOAT;
        if (p === $dea356723133262e$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $dea356723133262e$export$988473390501ed4b) return gl.ALPHA;
        if (p === $dea356723133262e$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $dea356723133262e$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $dea356723133262e$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $dea356723133262e$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $dea356723133262e$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $dea356723133262e$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $dea356723133262e$export$4e041a7967d15c4b) return gl.RED;
        if (p === $dea356723133262e$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $dea356723133262e$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $dea356723133262e$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $dea356723133262e$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $dea356723133262e$export$21d1799c6d552fc0 || p === $dea356723133262e$export$afa304c3e981b668 || p === $dea356723133262e$export$d2a1a68024a3e56c || p === $dea356723133262e$export$9a79c424327dacf9) {
            if (colorSpace1 === $dea356723133262e$export$561f394b24edfcaa) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $dea356723133262e$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $dea356723133262e$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $dea356723133262e$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $dea356723133262e$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $dea356723133262e$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $dea356723133262e$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $dea356723133262e$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $dea356723133262e$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $dea356723133262e$export$19ada9bbb1af3573 || p === $dea356723133262e$export$d0f0355bb3d948e4 || p === $dea356723133262e$export$b82296714358084c || p === $dea356723133262e$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $dea356723133262e$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $dea356723133262e$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $dea356723133262e$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $dea356723133262e$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $dea356723133262e$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $dea356723133262e$export$7800993ef8106a6a || p === $dea356723133262e$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $dea356723133262e$export$7800993ef8106a6a) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $dea356723133262e$export$23ed8300a860e7d8) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $dea356723133262e$export$dc5570b4a2b92d48 || p === $dea356723133262e$export$68880cd325f8b2fb || p === $dea356723133262e$export$7d2c0be323373d95 || p === $dea356723133262e$export$22b52da301fc3a3e || p === $dea356723133262e$export$c009e2cb4a66485e || p === $dea356723133262e$export$118fff5afa255b63 || p === $dea356723133262e$export$120713c829ae0667 || p === $dea356723133262e$export$c79eeabbf53313e9 || p === $dea356723133262e$export$443cf6567cdd6424 || p === $dea356723133262e$export$6573984fc9840780 || p === $dea356723133262e$export$e7aee563f30091de || p === $dea356723133262e$export$2eb8634622ddeab7 || p === $dea356723133262e$export$202b1ce7b5d25742 || p === $dea356723133262e$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $dea356723133262e$export$dc5570b4a2b92d48) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $dea356723133262e$export$68880cd325f8b2fb) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $dea356723133262e$export$7d2c0be323373d95) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $dea356723133262e$export$22b52da301fc3a3e) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $dea356723133262e$export$c009e2cb4a66485e) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $dea356723133262e$export$118fff5afa255b63) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $dea356723133262e$export$120713c829ae0667) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $dea356723133262e$export$c79eeabbf53313e9) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $dea356723133262e$export$443cf6567cdd6424) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $dea356723133262e$export$6573984fc9840780) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $dea356723133262e$export$e7aee563f30091de) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $dea356723133262e$export$2eb8634622ddeab7) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $dea356723133262e$export$202b1ce7b5d25742) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $dea356723133262e$export$18ab77abd087e467) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $dea356723133262e$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $dea356723133262e$export$ce40b115e188bc81) return colorSpace1 === $dea356723133262e$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === $dea356723133262e$export$b1688df4c4c21670 || p === $dea356723133262e$export$fc15e5d8261eed58 || p === $dea356723133262e$export$d220f6ade8463a0f || p === $dea356723133262e$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $dea356723133262e$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $dea356723133262e$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $dea356723133262e$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $dea356723133262e$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $dea356723133262e$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $dea356723133262e$export$56b937d9e5581166 extends $dea356723133262e$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $dea356723133262e$export$eb2fcfdbd7ba97d4 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $dea356723133262e$var$_moveEvent = {
    type: "move"
};
class $dea356723133262e$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $dea356723133262e$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $dea356723133262e$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $dea356723133262e$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $dea356723133262e$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $dea356723133262e$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $dea356723133262e$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $dea356723133262e$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($dea356723133262e$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $dea356723133262e$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $dea356723133262e$export$fc830aa069cc8c2f extends $dea356723133262e$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $dea356723133262e$export$c1b6b5136be58045;
        if (format !== $dea356723133262e$export$c1b6b5136be58045 && format !== $dea356723133262e$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $dea356723133262e$export$c1b6b5136be58045) type = $dea356723133262e$export$c3c7fc4518ebba96;
        if (type === undefined && format === $dea356723133262e$export$1e113ac2d0905829) type = $dea356723133262e$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $dea356723133262e$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $dea356723133262e$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
class $dea356723133262e$var$WebXRManager extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const planes = new Set();
        const planesLastChangedTimes = new Map();
        //
        const cameraL = new $dea356723133262e$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $dea356723133262e$export$fa7daccca11cdbe3();
        const cameraR = new $dea356723133262e$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $dea356723133262e$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $dea356723133262e$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $dea356723133262e$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $dea356723133262e$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $dea356723133262e$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $dea356723133262e$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $dea356723133262e$export$3f8bb04b555a363c,
                        type: $dea356723133262e$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $dea356723133262e$export$1e113ac2d0905829 : $dea356723133262e$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $dea356723133262e$export$6c8ea339bfab1301 : $dea356723133262e$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $dea356723133262e$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $dea356723133262e$export$3f8bb04b555a363c,
                        type: $dea356723133262e$export$2e8ce08d3f6f5e10,
                        depthTexture: new $dea356723133262e$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $dea356723133262e$export$64b5c384219d3699();
        const cameraRPos = new $dea356723133262e$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraVR, parent);
        };
        function updateUserCamera(camera, cameraVR, parent) {
            if (parent === null) camera.matrix.copy(cameraVR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraVR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraVR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraVR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $dea356723133262e$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.getPlanes = function() {
            return planes;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $dea356723133262e$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $dea356723133262e$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraVR.matrix.copy(camera.matrix);
                        cameraVR.matrix.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
                    }
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) {
                scope.dispatchEvent({
                    type: "planesdetected",
                    data: frame.detectedPlanes
                });
                let planesToRemove = null;
                for (const plane of planes)if (!frame.detectedPlanes.has(plane)) {
                    if (planesToRemove === null) planesToRemove = [];
                    planesToRemove.push(plane);
                }
                if (planesToRemove !== null) for (const plane of planesToRemove){
                    planes.delete(plane);
                    planesLastChangedTimes.delete(plane);
                    scope.dispatchEvent({
                        type: "planeremoved",
                        data: plane
                    });
                }
                for (const plane of frame.detectedPlanes)if (!planes.has(plane)) {
                    planes.add(plane);
                    planesLastChangedTimes.set(plane, frame.lastChangedTime);
                    scope.dispatchEvent({
                        type: "planeadded",
                        data: plane
                    });
                } else {
                    const lastKnownTime = planesLastChangedTimes.get(plane);
                    if (plane.lastChangedTime > lastKnownTime) {
                        planesLastChangedTimes.set(plane, plane.lastChangedTime);
                        scope.dispatchEvent({
                            type: "planechanged",
                            data: plane
                        });
                    }
                }
            }
            xrFrame = null;
        }
        const animation = new $dea356723133262e$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $dea356723133262e$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $dea356723133262e$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $dea356723133262e$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $dea356723133262e$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $dea356723133262e$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $dea356723133262e$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === "number") {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number") cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === "number") {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number") {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $dea356723133262e$var$createCanvasElement() {
    const canvas = $dea356723133262e$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
class $dea356723133262e$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $dea356723133262e$var$createCanvasElement(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputColorSpace = $dea356723133262e$export$561f394b24edfcaa;
        // physical lights
        this.useLegacyLights = true;
        // tone mapping
        this.toneMapping = $dea356723133262e$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $dea356723133262e$export$fa7daccca11cdbe3();
        const _currentScissor = new $dea356723133262e$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $dea356723133262e$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $dea356723133262e$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $dea356723133262e$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $dea356723133262e$export$2ae72fc923e5eb5();
        const _vector3 = new $dea356723133262e$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$dea356723133262e$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    "webgl2",
                    "webgl",
                    "experimental-webgl"
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    "rangeMin": 1,
                    "rangeMax": 1,
                    "precision": 1
                };
            };
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $dea356723133262e$var$WebGLExtensions(_gl);
            capabilities = new $dea356723133262e$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $dea356723133262e$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $dea356723133262e$var$WebGLState(_gl, extensions, capabilities);
            info = new $dea356723133262e$var$WebGLInfo(_gl);
            properties = new $dea356723133262e$var$WebGLProperties();
            textures = new $dea356723133262e$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $dea356723133262e$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $dea356723133262e$var$WebGLCubeUVMaps(_this);
            attributes = new $dea356723133262e$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $dea356723133262e$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $dea356723133262e$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $dea356723133262e$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $dea356723133262e$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $dea356723133262e$var$WebGLClipping(properties);
            programCache = new $dea356723133262e$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $dea356723133262e$var$WebGLMaterials(_this, properties);
            renderLists = new $dea356723133262e$var$WebGLRenderLists();
            renderStates = new $dea356723133262e$var$WebGLRenderStates(extensions, capabilities);
            background = new $dea356723133262e$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $dea356723133262e$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $dea356723133262e$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $dea356723133262e$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $dea356723133262e$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $dea356723133262e$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) bits |= _gl.COLOR_BUFFER_BIT;
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $dea356723133262e$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $dea356723133262e$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $dea356723133262e$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $dea356723133262e$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this.useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $dea356723133262e$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this.useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        if (object.isSkinnedMesh) // update skeleton only once in a frame
                        {
                            if (object.skeleton.frame !== info.render.frame) {
                                object.skeleton.update();
                                object.skeleton.frame = info.render.frame;
                            }
                        }
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                            _vector3.copy(geometry.boundingSphere.center).applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            if (_transmissionRenderTarget === null) {
                const isWebGL2 = capabilities.isWebGL2;
                _transmissionRenderTarget = new $dea356723133262e$export$3c052beb2e51e23f(1024, 1024, {
                    generateMipmaps: true,
                    type: extensions.has("EXT_color_buffer_half_float") ? $dea356723133262e$export$2697304443f382bc : $dea356723133262e$export$2e8ce08d3f6f5e10,
                    minFilter: $dea356723133262e$export$5d8599b6a933fb1b,
                    samples: isWebGL2 && antialias === true ? 4 : 0
                });
            // debug
            /*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/ }
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $dea356723133262e$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $dea356723133262e$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $dea356723133262e$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $dea356723133262e$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $dea356723133262e$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $dea356723133262e$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $dea356723133262e$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $dea356723133262e$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $dea356723133262e$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            const toneMapping = material.toneMapped ? _this.toneMapping : $dea356723133262e$export$9fcb6b4294603b2;
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
                // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                    const uCamPos = p_uniforms.map.cameraPosition;
                    if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                    } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $dea356723133262e$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $dea356723133262e$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                        console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $dea356723133262e$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $dea356723133262e$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                    if (textureType !== $dea356723133262e$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $dea356723133262e$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get physicallyCorrectLights() {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        return this.outputColorSpace === $dea356723133262e$export$561f394b24edfcaa ? $dea356723133262e$export$f32388edbb32674 : $dea356723133262e$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        this.outputColorSpace = encoding === $dea356723133262e$export$f32388edbb32674 ? $dea356723133262e$export$561f394b24edfcaa : $dea356723133262e$export$42429b3acfb233a4;
    }
}
class $dea356723133262e$export$a2f65229194348f9 extends $dea356723133262e$export$f6cc00ef28d7cf97 {
}
$dea356723133262e$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $dea356723133262e$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $dea356723133262e$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $dea356723133262e$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $dea356723133262e$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $dea356723133262e$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $dea356723133262e$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $dea356723133262e$export$38af1803e3442a7f extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
    get autoUpdate() {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        return this.matrixWorldAutoUpdate;
    }
    set autoUpdate(value) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.");
        this.matrixWorldAutoUpdate = value;
    }
}
class $dea356723133262e$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $dea356723133262e$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $dea356723133262e$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $dea356723133262e$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $dea356723133262e$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $dea356723133262e$var$_vector$5 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $dea356723133262e$var$_vector$5.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$5.x, $dea356723133262e$var$_vector$5.y, $dea356723133262e$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector$5.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$5.x, $dea356723133262e$var$_vector$5.y, $dea356723133262e$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $dea356723133262e$var$_vector$5.fromBufferAttribute(this, i);
            $dea356723133262e$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $dea356723133262e$var$_vector$5.x, $dea356723133262e$var$_vector$5.y, $dea356723133262e$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $dea356723133262e$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $dea356723133262e$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $dea356723133262e$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $dea356723133262e$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $dea356723133262e$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $dea356723133262e$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $dea356723133262e$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $dea356723133262e$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
            z = $dea356723133262e$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $dea356723133262e$var$normalize(x, this.array);
            y = $dea356723133262e$var$normalize(y, this.array);
            z = $dea356723133262e$var$normalize(z, this.array);
            w = $dea356723133262e$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $dea356723133262e$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $dea356723133262e$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $dea356723133262e$export$5ec7dd1c6994bf8e extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $dea356723133262e$var$_geometry;
const $dea356723133262e$var$_intersectPoint = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_worldScale = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_mvPosition = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_alignedPosition = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_rotatedPosition = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_viewWorldMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_vA = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vB = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_vC = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_uvA = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_uvB = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
const $dea356723133262e$var$_uvC = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
class $dea356723133262e$export$3075603db8e6204c extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($dea356723133262e$var$_geometry === undefined) {
            $dea356723133262e$var$_geometry = new $dea356723133262e$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $dea356723133262e$export$3d5cd879f108f53f(float32Array, 5);
            $dea356723133262e$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $dea356723133262e$var$_geometry.setAttribute("position", new $dea356723133262e$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $dea356723133262e$var$_geometry.setAttribute("uv", new $dea356723133262e$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $dea356723133262e$var$_geometry;
        this.material = material !== undefined ? material : new $dea356723133262e$export$5ec7dd1c6994bf8e();
        this.center = new $dea356723133262e$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $dea356723133262e$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $dea356723133262e$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $dea356723133262e$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $dea356723133262e$var$_worldScale.multiplyScalar(-$dea356723133262e$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $dea356723133262e$var$transformVertex($dea356723133262e$var$_vA.set(-0.5, -0.5, 0), $dea356723133262e$var$_mvPosition, center, $dea356723133262e$var$_worldScale, sin, cos);
        $dea356723133262e$var$transformVertex($dea356723133262e$var$_vB.set(0.5, -0.5, 0), $dea356723133262e$var$_mvPosition, center, $dea356723133262e$var$_worldScale, sin, cos);
        $dea356723133262e$var$transformVertex($dea356723133262e$var$_vC.set(0.5, 0.5, 0), $dea356723133262e$var$_mvPosition, center, $dea356723133262e$var$_worldScale, sin, cos);
        $dea356723133262e$var$_uvA.set(0, 0);
        $dea356723133262e$var$_uvB.set(1, 0);
        $dea356723133262e$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($dea356723133262e$var$_vA, $dea356723133262e$var$_vB, $dea356723133262e$var$_vC, false, $dea356723133262e$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $dea356723133262e$var$transformVertex($dea356723133262e$var$_vB.set(-0.5, 0.5, 0), $dea356723133262e$var$_mvPosition, center, $dea356723133262e$var$_worldScale, sin, cos);
            $dea356723133262e$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($dea356723133262e$var$_vA, $dea356723133262e$var$_vC, $dea356723133262e$var$_vB, false, $dea356723133262e$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($dea356723133262e$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $dea356723133262e$var$_intersectPoint.clone(),
            uv: $dea356723133262e$export$5a465592bfe74b48.getInterpolation($dea356723133262e$var$_intersectPoint, $dea356723133262e$var$_vA, $dea356723133262e$var$_vB, $dea356723133262e$var$_vC, $dea356723133262e$var$_uvA, $dea356723133262e$var$_uvB, $dea356723133262e$var$_uvC, new $dea356723133262e$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $dea356723133262e$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $dea356723133262e$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $dea356723133262e$var$_rotatedPosition.x = cos * $dea356723133262e$var$_alignedPosition.x - sin * $dea356723133262e$var$_alignedPosition.y;
        $dea356723133262e$var$_rotatedPosition.y = sin * $dea356723133262e$var$_alignedPosition.x + cos * $dea356723133262e$var$_alignedPosition.y;
    } else $dea356723133262e$var$_rotatedPosition.copy($dea356723133262e$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $dea356723133262e$var$_rotatedPosition.x;
    vertexPosition.y += $dea356723133262e$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($dea356723133262e$var$_viewWorldMatrix);
}
const $dea356723133262e$var$_v1$2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v2$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$112e7237be0c5f30 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $dea356723133262e$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($dea356723133262e$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $dea356723133262e$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $dea356723133262e$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $dea356723133262e$var$_v1$2.distanceTo($dea356723133262e$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $dea356723133262e$var$_basePosition = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_skinIndex = /*@__PURE__*/ new $dea356723133262e$export$fa7daccca11cdbe3();
const $dea356723133262e$var$_skinWeight = /*@__PURE__*/ new $dea356723133262e$export$fa7daccca11cdbe3();
const $dea356723133262e$var$_vector3 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_matrix4 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_vertex = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$b303577035157ecf extends $dea356723133262e$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $dea356723133262e$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $dea356723133262e$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $dea356723133262e$var$_vertex);
            this.boundingBox.expandByPoint($dea356723133262e$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $dea356723133262e$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $dea356723133262e$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $dea356723133262e$var$_vertex);
            this.boundingSphere.expandByPoint($dea356723133262e$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    // raycast( raycaster, intersects ) {
    // 	if ( this.boundingSphere === null ) this.computeBoundingSphere();
    // 	_sphere.copy( this.boundingSphere );
    // 	_sphere.applyMatrix4( this.matrixWorld );
    // 	if ( raycaster.ray.intersectsSphere( _sphere ) === false ) return;
    // 	this._computeIntersections( raycaster, intersects );
    // }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $dea356723133262e$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $dea356723133262e$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $dea356723133262e$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $dea356723133262e$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $dea356723133262e$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $dea356723133262e$var$_skinIndex.getComponent(i);
                $dea356723133262e$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($dea356723133262e$var$_vector3.copy($dea356723133262e$var$_basePosition).applyMatrix4($dea356723133262e$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.");
        return this.applyBoneTransform(index, vector);
    }
}
class $dea356723133262e$export$b127726e56765aa4 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $dea356723133262e$export$b691f601014eabe1 extends $dea356723133262e$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $dea356723133262e$export$727aa5ec3fe39bf0, minFilter = $dea356723133262e$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $dea356723133262e$var$_offsetMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_identityMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
class $dea356723133262e$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $dea356723133262e$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $dea356723133262e$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $dea356723133262e$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $dea356723133262e$var$_identityMatrix;
            $dea356723133262e$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $dea356723133262e$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $dea356723133262e$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $dea356723133262e$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $dea356723133262e$export$b691f601014eabe1(boneMatrices, size, size, $dea356723133262e$export$3f8bb04b555a363c, $dea356723133262e$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $dea356723133262e$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $dea356723133262e$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $dea356723133262e$export$32ea87a8b54d744a extends $dea356723133262e$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $dea356723133262e$var$_instanceLocalMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_instanceWorldMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_instanceIntersects = [];
const $dea356723133262e$var$_box3 = /*@__PURE__*/ new $dea356723133262e$export$6f7d5a9418ab2aa3();
const $dea356723133262e$var$_identity = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_mesh = /*@__PURE__*/ new $dea356723133262e$export$e176487c05830cc5();
const $dea356723133262e$var$_sphere$2 = /*@__PURE__*/ new $dea356723133262e$export$805e8b72413ccaba();
class $dea356723133262e$export$f3c979c331175ad7 extends $dea356723133262e$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $dea356723133262e$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $dea356723133262e$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $dea356723133262e$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $dea356723133262e$var$_instanceLocalMatrix);
            $dea356723133262e$var$_box3.copy(geometry.boundingBox).applyMatrix4($dea356723133262e$var$_instanceLocalMatrix);
            this.boundingBox.union($dea356723133262e$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $dea356723133262e$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $dea356723133262e$var$_instanceLocalMatrix);
            $dea356723133262e$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($dea356723133262e$var$_instanceLocalMatrix);
            this.boundingSphere.union($dea356723133262e$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $dea356723133262e$var$_mesh.geometry = this.geometry;
        $dea356723133262e$var$_mesh.material = this.material;
        if ($dea356723133262e$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $dea356723133262e$var$_sphere$2.copy(this.boundingSphere);
        $dea356723133262e$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($dea356723133262e$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $dea356723133262e$var$_instanceLocalMatrix);
            $dea356723133262e$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $dea356723133262e$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $dea356723133262e$var$_mesh.matrixWorld = $dea356723133262e$var$_instanceWorldMatrix;
            $dea356723133262e$var$_mesh.raycast(raycaster, $dea356723133262e$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $dea356723133262e$var$_instanceIntersects.length; i < l; i++){
                const intersect = $dea356723133262e$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $dea356723133262e$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $dea356723133262e$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $dea356723133262e$export$fbaaa33907730a0c extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $dea356723133262e$var$_start$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_end$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_inverseMatrix$1 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_ray$1 = /*@__PURE__*/ new $dea356723133262e$export$a186db52eed6d40e();
const $dea356723133262e$var$_sphere$1 = /*@__PURE__*/ new $dea356723133262e$export$805e8b72413ccaba();
class $dea356723133262e$export$17d680238e50603e extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(geometry = new $dea356723133262e$export$b7be63a67df8959(), material = new $dea356723133262e$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $dea356723133262e$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $dea356723133262e$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $dea356723133262e$var$_start$1.distanceTo($dea356723133262e$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $dea356723133262e$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $dea356723133262e$var$_sphere$1.copy(geometry.boundingSphere);
        $dea356723133262e$var$_sphere$1.applyMatrix4(matrixWorld);
        $dea356723133262e$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($dea356723133262e$var$_sphere$1) === false) return;
        //
        $dea356723133262e$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $dea356723133262e$var$_ray$1.copy(raycaster.ray).applyMatrix4($dea356723133262e$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $dea356723133262e$export$64b5c384219d3699();
        const vEnd = new $dea356723133262e$export$64b5c384219d3699();
        const interSegment = new $dea356723133262e$export$64b5c384219d3699();
        const interRay = new $dea356723133262e$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $dea356723133262e$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $dea356723133262e$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $dea356723133262e$var$_start = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_end = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$ff1ed10fedfdd604 extends $dea356723133262e$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $dea356723133262e$var$_start.fromBufferAttribute(positionAttribute, i);
                $dea356723133262e$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $dea356723133262e$var$_start.distanceTo($dea356723133262e$var$_end);
            }
            geometry.setAttribute("lineDistance", new $dea356723133262e$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $dea356723133262e$export$f85a24d745e4f17d extends $dea356723133262e$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $dea356723133262e$export$a178c45366ce5d6b extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $dea356723133262e$var$_inverseMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_ray = /*@__PURE__*/ new $dea356723133262e$export$a186db52eed6d40e();
const $dea356723133262e$var$_sphere = /*@__PURE__*/ new $dea356723133262e$export$805e8b72413ccaba();
const $dea356723133262e$var$_position$2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$1c787534cb11aa3e extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(geometry = new $dea356723133262e$export$b7be63a67df8959(), material = new $dea356723133262e$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $dea356723133262e$var$_sphere.copy(geometry.boundingSphere);
        $dea356723133262e$var$_sphere.applyMatrix4(matrixWorld);
        $dea356723133262e$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($dea356723133262e$var$_sphere) === false) return;
        //
        $dea356723133262e$var$_inverseMatrix.copy(matrixWorld).invert();
        $dea356723133262e$var$_ray.copy(raycaster.ray).applyMatrix4($dea356723133262e$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $dea356723133262e$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $dea356723133262e$var$testPoint($dea356723133262e$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $dea356723133262e$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $dea356723133262e$var$testPoint($dea356723133262e$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $dea356723133262e$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $dea356723133262e$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $dea356723133262e$export$64b5c384219d3699();
        $dea356723133262e$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $dea356723133262e$export$6e09d1edf8d5a25c extends $dea356723133262e$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $dea356723133262e$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $dea356723133262e$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $dea356723133262e$export$9270d786f73ce6fe extends $dea356723133262e$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.format = format;
        this.magFilter = $dea356723133262e$export$727aa5ec3fe39bf0;
        this.minFilter = $dea356723133262e$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $dea356723133262e$export$3466bac9141a5cc4 extends $dea356723133262e$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $dea356723133262e$export$5fe6b8e34b274fcb extends $dea356723133262e$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $dea356723133262e$export$9d9334239a5a5e06;
    }
}
class $dea356723133262e$export$f7189e49152d1c13 extends $dea356723133262e$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $dea356723133262e$export$c977b3e384af9ae1() : new $dea356723133262e$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $dea356723133262e$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $dea356723133262e$export$64b5c384219d3699();
        const mat = new $dea356723133262e$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $dea356723133262e$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $dea356723133262e$export$64b5c384219d3699();
        binormals[0] = new $dea356723133262e$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($dea356723133262e$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($dea356723133262e$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $dea356723133262e$export$3f87a931616cde04 extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $dea356723133262e$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $dea356723133262e$export$b1eedc9aab6300e8 extends $dea356723133262e$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $dea356723133262e$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $dea356723133262e$var$tmp = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$px = /*@__PURE__*/ new $dea356723133262e$var$CubicPoly();
const $dea356723133262e$var$py = /*@__PURE__*/ new $dea356723133262e$var$CubicPoly();
const $dea356723133262e$var$pz = /*@__PURE__*/ new $dea356723133262e$var$CubicPoly();
class $dea356723133262e$export$b9146b27c24b744c extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $dea356723133262e$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $dea356723133262e$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $dea356723133262e$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $dea356723133262e$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $dea356723133262e$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $dea356723133262e$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $dea356723133262e$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $dea356723133262e$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $dea356723133262e$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $dea356723133262e$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($dea356723133262e$var$px.calc(weight), $dea356723133262e$var$py.calc(weight), $dea356723133262e$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $dea356723133262e$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $dea356723133262e$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $dea356723133262e$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $dea356723133262e$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $dea356723133262e$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $dea356723133262e$var$QuadraticBezier(t, p0, p1, p2) {
    return $dea356723133262e$var$QuadraticBezierP0(t, p0) + $dea356723133262e$var$QuadraticBezierP1(t, p1) + $dea356723133262e$var$QuadraticBezierP2(t, p2);
}
//
function $dea356723133262e$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $dea356723133262e$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $dea356723133262e$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $dea356723133262e$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $dea356723133262e$var$CubicBezier(t, p0, p1, p2, p3) {
    return $dea356723133262e$var$CubicBezierP0(t, p0) + $dea356723133262e$var$CubicBezierP1(t, p1) + $dea356723133262e$var$CubicBezierP2(t, p2) + $dea356723133262e$var$CubicBezierP3(t, p3);
}
class $dea356723133262e$export$e36650d36468bb39 extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $dea356723133262e$export$c977b3e384af9ae1(), v1 = new $dea356723133262e$export$c977b3e384af9ae1(), v2 = new $dea356723133262e$export$c977b3e384af9ae1(), v3 = new $dea356723133262e$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($dea356723133262e$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $dea356723133262e$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $dea356723133262e$export$13d5f1c9525f246c extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $dea356723133262e$export$64b5c384219d3699(), v1 = new $dea356723133262e$export$64b5c384219d3699(), v2 = new $dea356723133262e$export$64b5c384219d3699(), v3 = new $dea356723133262e$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($dea356723133262e$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $dea356723133262e$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $dea356723133262e$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $dea356723133262e$export$ab2e07e76531a47e extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $dea356723133262e$export$c977b3e384af9ae1(), v2 = new $dea356723133262e$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $dea356723133262e$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $dea356723133262e$export$1fdfd9d9cf487600 extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $dea356723133262e$export$64b5c384219d3699(), v2 = new $dea356723133262e$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $dea356723133262e$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $dea356723133262e$export$5938c4ee491a43ad extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $dea356723133262e$export$c977b3e384af9ae1(), v1 = new $dea356723133262e$export$c977b3e384af9ae1(), v2 = new $dea356723133262e$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($dea356723133262e$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $dea356723133262e$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $dea356723133262e$export$bf3f4c7e459f90fc extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $dea356723133262e$export$64b5c384219d3699(), v1 = new $dea356723133262e$export$64b5c384219d3699(), v2 = new $dea356723133262e$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($dea356723133262e$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $dea356723133262e$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $dea356723133262e$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $dea356723133262e$export$d3bdd77da77afc1b extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
    getPoint(t, optionalTarget = new $dea356723133262e$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($dea356723133262e$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $dea356723133262e$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $dea356723133262e$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $dea356723133262e$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $dea356723133262e$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $dea356723133262e$export$b9146b27c24b744c,
    CubicBezierCurve: $dea356723133262e$export$e36650d36468bb39,
    CubicBezierCurve3: $dea356723133262e$export$13d5f1c9525f246c,
    EllipseCurve: $dea356723133262e$export$3f87a931616cde04,
    LineCurve: $dea356723133262e$export$ab2e07e76531a47e,
    LineCurve3: $dea356723133262e$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $dea356723133262e$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $dea356723133262e$export$bf3f4c7e459f90fc,
    SplineCurve: $dea356723133262e$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $dea356723133262e$export$4aaf9b66af1bbf2c extends $dea356723133262e$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $dea356723133262e$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $dea356723133262e$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $dea356723133262e$export$4b2950bdac9b6ee9 extends $dea356723133262e$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $dea356723133262e$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $dea356723133262e$export$ab2e07e76531a47e(this.currentPoint.clone(), new $dea356723133262e$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $dea356723133262e$export$5938c4ee491a43ad(this.currentPoint.clone(), new $dea356723133262e$export$c977b3e384af9ae1(aCPx, aCPy), new $dea356723133262e$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $dea356723133262e$export$e36650d36468bb39(this.currentPoint.clone(), new $dea356723133262e$export$c977b3e384af9ae1(aCP1x, aCP1y), new $dea356723133262e$export$c977b3e384af9ae1(aCP2x, aCP2y), new $dea356723133262e$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $dea356723133262e$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $dea356723133262e$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $dea356723133262e$export$6d839803fcd1882c extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(points = [
        new $dea356723133262e$export$c977b3e384af9ae1(0, -0.5),
        new $dea356723133262e$export$c977b3e384af9ae1(0.5, 0),
        new $dea356723133262e$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $dea356723133262e$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const uv = new $dea356723133262e$export$c977b3e384af9ae1();
        const normal = new $dea356723133262e$export$64b5c384219d3699();
        const curNormal = new $dea356723133262e$export$64b5c384219d3699();
        const prevNormal = new $dea356723133262e$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $dea356723133262e$export$41680e8551036033 extends $dea356723133262e$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $dea356723133262e$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $dea356723133262e$export$d5c0e8d607467193 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const uv = new $dea356723133262e$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $dea356723133262e$export$68f745719dbe5198 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $dea356723133262e$export$64b5c384219d3699();
            const vertex = new $dea356723133262e$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $dea356723133262e$export$c977b3e384af9ae1();
            const vertex = new $dea356723133262e$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $dea356723133262e$export$a7a48974f285c9b3 extends $dea356723133262e$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $dea356723133262e$export$60e57a7d3f20ff65 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $dea356723133262e$export$64b5c384219d3699();
            const b = new $dea356723133262e$export$64b5c384219d3699();
            const c = new $dea356723133262e$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $dea356723133262e$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $dea356723133262e$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $dea356723133262e$export$64b5c384219d3699();
            const b = new $dea356723133262e$export$64b5c384219d3699();
            const c = new $dea356723133262e$export$64b5c384219d3699();
            const centroid = new $dea356723133262e$export$64b5c384219d3699();
            const uvA = new $dea356723133262e$export$c977b3e384af9ae1();
            const uvB = new $dea356723133262e$export$c977b3e384af9ae1();
            const uvC = new $dea356723133262e$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $dea356723133262e$export$c0babfeb8708fc9c extends $dea356723133262e$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $dea356723133262e$var$_v0 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v1$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_normal = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_triangle = /*@__PURE__*/ new $dea356723133262e$export$5a465592bfe74b48();
class $dea356723133262e$export$4730b1542707547f extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($dea356723133262e$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $dea356723133262e$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $dea356723133262e$var$_triangle.getNormal($dea356723133262e$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $dea356723133262e$var$_triangle[vertKeys[j]];
                    const v1 = $dea356723133262e$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($dea356723133262e$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $dea356723133262e$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $dea356723133262e$var$_v0.fromBufferAttribute(positionAttr, index0);
                $dea356723133262e$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($dea356723133262e$var$_v0.x, $dea356723133262e$var$_v0.y, $dea356723133262e$var$_v0.z);
                vertices.push($dea356723133262e$var$_v1$1.x, $dea356723133262e$var$_v1$1.y, $dea356723133262e$var$_v1$1.z);
            }
            this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $dea356723133262e$export$6428a7f2611ef1fa extends $dea356723133262e$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $dea356723133262e$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $dea356723133262e$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $dea356723133262e$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $dea356723133262e$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $dea356723133262e$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $dea356723133262e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $dea356723133262e$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $dea356723133262e$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $dea356723133262e$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $dea356723133262e$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $dea356723133262e$var$equals(last, last.next)) {
        $dea356723133262e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $dea356723133262e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($dea356723133262e$var$equals(p, p.next) || $dea356723133262e$var$area(p.prev, p, p.next) === 0)) {
            $dea356723133262e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $dea356723133262e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $dea356723133262e$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $dea356723133262e$var$isEarHashed(ear, minX, minY, invSize) : $dea356723133262e$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $dea356723133262e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $dea356723133262e$var$earcutLinked($dea356723133262e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $dea356723133262e$var$cureLocalIntersections($dea356723133262e$var$filterPoints(ear), triangles, dim);
                $dea356723133262e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $dea356723133262e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $dea356723133262e$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($dea356723133262e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $dea356723133262e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $dea356723133262e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $dea356723133262e$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($dea356723133262e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $dea356723133262e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $dea356723133262e$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $dea356723133262e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $dea356723133262e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $dea356723133262e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $dea356723133262e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $dea356723133262e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $dea356723133262e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $dea356723133262e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $dea356723133262e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $dea356723133262e$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$dea356723133262e$var$equals(a, b) && $dea356723133262e$var$intersects(a, p, p.next, b) && $dea356723133262e$var$locallyInside(a, b) && $dea356723133262e$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $dea356723133262e$var$removeNode(p);
            $dea356723133262e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $dea356723133262e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $dea356723133262e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $dea356723133262e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $dea356723133262e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $dea356723133262e$var$filterPoints(a, a.next);
                c = $dea356723133262e$var$filterPoints(c, c.next);
                // run earcut on each half
                $dea356723133262e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $dea356723133262e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $dea356723133262e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $dea356723133262e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($dea356723133262e$var$getLeftmost(list));
    }
    queue.sort($dea356723133262e$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $dea356723133262e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $dea356723133262e$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $dea356723133262e$var$eliminateHole(hole, outerNode) {
    const bridge = $dea356723133262e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $dea356723133262e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $dea356723133262e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $dea356723133262e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $dea356723133262e$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $dea356723133262e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($dea356723133262e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $dea356723133262e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $dea356723133262e$var$sectorContainsSector(m, p) {
    return $dea356723133262e$var$area(m.prev, m, p.prev) < 0 && $dea356723133262e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $dea356723133262e$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $dea356723133262e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $dea356723133262e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $dea356723133262e$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $dea356723133262e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $dea356723133262e$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $dea356723133262e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $dea356723133262e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$dea356723133262e$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($dea356723133262e$var$locallyInside(a, b) && $dea356723133262e$var$locallyInside(b, a) && $dea356723133262e$var$middleInside(a, b) && // locally visible
    ($dea356723133262e$var$area(a.prev, a, b.prev) || $dea356723133262e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $dea356723133262e$var$equals(a, b) && $dea356723133262e$var$area(a.prev, a, a.next) > 0 && $dea356723133262e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $dea356723133262e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $dea356723133262e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $dea356723133262e$var$intersects(p1, q1, p2, q2) {
    const o1 = $dea356723133262e$var$sign($dea356723133262e$var$area(p1, q1, p2));
    const o2 = $dea356723133262e$var$sign($dea356723133262e$var$area(p1, q1, q2));
    const o3 = $dea356723133262e$var$sign($dea356723133262e$var$area(p2, q2, p1));
    const o4 = $dea356723133262e$var$sign($dea356723133262e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $dea356723133262e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $dea356723133262e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $dea356723133262e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $dea356723133262e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $dea356723133262e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $dea356723133262e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $dea356723133262e$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $dea356723133262e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $dea356723133262e$var$locallyInside(a, b) {
    return $dea356723133262e$var$area(a.prev, a, a.next) < 0 ? $dea356723133262e$var$area(a, b, a.next) >= 0 && $dea356723133262e$var$area(a, a.prev, b) >= 0 : $dea356723133262e$var$area(a, b, a.prev) < 0 || $dea356723133262e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $dea356723133262e$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $dea356723133262e$var$splitPolygon(a, b) {
    const a2 = new $dea356723133262e$var$Node(a.i, a.x, a.y), b2 = new $dea356723133262e$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $dea356723133262e$var$insertNode(i, x, y, last) {
    const p = new $dea356723133262e$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $dea356723133262e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $dea356723133262e$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $dea356723133262e$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $dea356723133262e$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $dea356723133262e$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $dea356723133262e$var$removeDupEndPts(contour);
        $dea356723133262e$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($dea356723133262e$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $dea356723133262e$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $dea356723133262e$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $dea356723133262e$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $dea356723133262e$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $dea356723133262e$export$598697a1efa63ca7 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(shapes = new $dea356723133262e$export$6428a7f2611ef1fa([
        new $dea356723133262e$export$c977b3e384af9ae1(0.5, 0.5),
        new $dea356723133262e$export$c977b3e384af9ae1(-0.5, 0.5),
        new $dea356723133262e$export$c977b3e384af9ae1(-0.5, -0.5),
        new $dea356723133262e$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $dea356723133262e$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $dea356723133262e$export$64b5c384219d3699();
                normal = new $dea356723133262e$export$64b5c384219d3699();
                position2 = new $dea356723133262e$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$dea356723133262e$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($dea356723133262e$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $dea356723133262e$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $dea356723133262e$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $dea356723133262e$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $dea356723133262e$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $dea356723133262e$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $dea356723133262e$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $dea356723133262e$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $dea356723133262e$export$c977b3e384af9ae1(a_x, a_y),
            new $dea356723133262e$export$c977b3e384af9ae1(b_x, b_y),
            new $dea356723133262e$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $dea356723133262e$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $dea356723133262e$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $dea356723133262e$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $dea356723133262e$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $dea356723133262e$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $dea356723133262e$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $dea356723133262e$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $dea356723133262e$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $dea356723133262e$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $dea356723133262e$export$9567cc828c9535da extends $dea356723133262e$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $dea356723133262e$export$1954e2b809fe361e extends $dea356723133262e$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $dea356723133262e$export$68cb731f50f614af extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const uv = new $dea356723133262e$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $dea356723133262e$export$57a29a1c803e9065 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(shapes = new $dea356723133262e$export$6428a7f2611ef1fa([
        new $dea356723133262e$export$c977b3e384af9ae1(0, 0.5),
        new $dea356723133262e$export$c977b3e384af9ae1(-0.5, -0.5),
        new $dea356723133262e$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($dea356723133262e$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($dea356723133262e$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $dea356723133262e$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $dea356723133262e$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $dea356723133262e$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $dea356723133262e$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $dea356723133262e$export$1b417fc3b307a251 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const normal = new $dea356723133262e$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $dea356723133262e$export$fb3f7adc68bd6e02 extends $dea356723133262e$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $dea356723133262e$export$a2312a2a1fa56495 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $dea356723133262e$export$64b5c384219d3699();
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const normal = new $dea356723133262e$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $dea356723133262e$export$77e9bfadfb9ab8c8 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const normal = new $dea356723133262e$export$64b5c384219d3699();
        const P1 = new $dea356723133262e$export$64b5c384219d3699();
        const P2 = new $dea356723133262e$export$64b5c384219d3699();
        const B = new $dea356723133262e$export$64b5c384219d3699();
        const T = new $dea356723133262e$export$64b5c384219d3699();
        const N = new $dea356723133262e$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $dea356723133262e$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $dea356723133262e$export$7897d9d48904490c extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(path = new $dea356723133262e$export$bf3f4c7e459f90fc(new $dea356723133262e$export$64b5c384219d3699(-1, -1, 0), new $dea356723133262e$export$64b5c384219d3699(-1, 1, 0), new $dea356723133262e$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $dea356723133262e$export$64b5c384219d3699();
        const normal = new $dea356723133262e$export$64b5c384219d3699();
        const uv = new $dea356723133262e$export$c977b3e384af9ae1();
        let P = new $dea356723133262e$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $dea356723133262e$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $dea356723133262e$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $dea356723133262e$export$7897d9d48904490c(new $dea356723133262e$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $dea356723133262e$export$4b739da06d24892b extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $dea356723133262e$export$64b5c384219d3699();
            const end = new $dea356723133262e$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($dea356723133262e$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($dea356723133262e$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $dea356723133262e$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $dea356723133262e$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $dea356723133262e$export$33e43285f7406bd5,
    CapsuleGeometry: $dea356723133262e$export$41680e8551036033,
    CircleGeometry: $dea356723133262e$export$d5c0e8d607467193,
    ConeGeometry: $dea356723133262e$export$a7a48974f285c9b3,
    CylinderGeometry: $dea356723133262e$export$68f745719dbe5198,
    DodecahedronGeometry: $dea356723133262e$export$c0babfeb8708fc9c,
    EdgesGeometry: $dea356723133262e$export$4730b1542707547f,
    ExtrudeGeometry: $dea356723133262e$export$598697a1efa63ca7,
    IcosahedronGeometry: $dea356723133262e$export$9567cc828c9535da,
    LatheGeometry: $dea356723133262e$export$6d839803fcd1882c,
    OctahedronGeometry: $dea356723133262e$export$1954e2b809fe361e,
    PlaneGeometry: $dea356723133262e$export$967d831af31f69ce,
    PolyhedronGeometry: $dea356723133262e$export$60e57a7d3f20ff65,
    RingGeometry: $dea356723133262e$export$68cb731f50f614af,
    ShapeGeometry: $dea356723133262e$export$57a29a1c803e9065,
    SphereGeometry: $dea356723133262e$export$1b417fc3b307a251,
    TetrahedronGeometry: $dea356723133262e$export$fb3f7adc68bd6e02,
    TorusGeometry: $dea356723133262e$export$a2312a2a1fa56495,
    TorusKnotGeometry: $dea356723133262e$export$77e9bfadfb9ab8c8,
    TubeGeometry: $dea356723133262e$export$7897d9d48904490c,
    WireframeGeometry: $dea356723133262e$export$4b739da06d24892b
});
class $dea356723133262e$export$e8564da406055a3 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $dea356723133262e$export$21c421a2e1df9d22 extends $dea356723133262e$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $dea356723133262e$export$f2980790215acccd extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $dea356723133262e$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $dea356723133262e$export$2852a58ebdac27b8;
        this.normalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $dea356723133262e$export$28d04986c4269c9f extends $dea356723133262e$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $dea356723133262e$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $dea356723133262e$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $dea356723133262e$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $dea356723133262e$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $dea356723133262e$export$24c72f71cbaf0678 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $dea356723133262e$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $dea356723133262e$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $dea356723133262e$export$2852a58ebdac27b8;
        this.normalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $dea356723133262e$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $dea356723133262e$export$df893cf97e765622 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $dea356723133262e$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $dea356723133262e$export$2852a58ebdac27b8;
        this.normalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $dea356723133262e$export$bfe8c0a091f41ae7 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $dea356723133262e$export$2852a58ebdac27b8;
        this.normalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $dea356723133262e$export$5023a9a8114806b8 extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $dea356723133262e$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $dea356723133262e$export$2852a58ebdac27b8;
        this.normalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $dea356723133262e$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $dea356723133262e$export$6f5fef6235ec12ee extends $dea356723133262e$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $dea356723133262e$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $dea356723133262e$export$2852a58ebdac27b8;
        this.normalScale = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $dea356723133262e$export$327886a3efaeaebe extends $dea356723133262e$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $dea356723133262e$var$arraySlice(array, from, to) {
    if ($dea356723133262e$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $dea356723133262e$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $dea356723133262e$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $dea356723133262e$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $dea356723133262e$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $dea356723133262e$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $dea356723133262e$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $dea356723133262e$var$convertArray(times, track.times.constructor);
        track.values = $dea356723133262e$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $dea356723133262e$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $dea356723133262e$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $dea356723133262e$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $dea356723133262e$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $dea356723133262e$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $dea356723133262e$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $dea356723133262e$export$d875e029ef558d3;
    return targetClip;
}
const $dea356723133262e$export$7ee8caa573e71ad1 = {
    arraySlice: $dea356723133262e$var$arraySlice,
    convertArray: $dea356723133262e$var$convertArray,
    isTypedArray: $dea356723133262e$var$isTypedArray,
    getKeyframeOrder: $dea356723133262e$var$getKeyframeOrder,
    sortedArray: $dea356723133262e$var$sortedArray,
    flattenJSON: $dea356723133262e$var$flattenJSON,
    subclip: $dea356723133262e$var$subclip,
    makeClipAdditive: $dea356723133262e$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $dea356723133262e$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $dea356723133262e$export$3646682e7a3959 extends $dea356723133262e$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $dea356723133262e$export$7f795934b84ab523,
            endingEnd: $dea356723133262e$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $dea356723133262e$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $dea356723133262e$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $dea356723133262e$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $dea356723133262e$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $dea356723133262e$export$a8e6009059f51e1a extends $dea356723133262e$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $dea356723133262e$export$fb9758ef7ef8d5cc extends $dea356723133262e$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $dea356723133262e$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $dea356723133262e$var$convertArray(times, this.TimeBufferType);
        this.values = $dea356723133262e$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $dea356723133262e$var$convertArray(track.times, Array),
                "values": $dea356723133262e$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $dea356723133262e$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $dea356723133262e$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $dea356723133262e$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $dea356723133262e$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $dea356723133262e$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $dea356723133262e$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $dea356723133262e$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $dea356723133262e$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $dea356723133262e$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $dea356723133262e$var$arraySlice(times, from, to);
            this.values = $dea356723133262e$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($dea356723133262e$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $dea356723133262e$var$arraySlice(this.times), values = $dea356723133262e$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $dea356723133262e$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $dea356723133262e$var$arraySlice(times, 0, writeIndex);
            this.values = $dea356723133262e$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $dea356723133262e$var$arraySlice(this.times, 0);
        const values = $dea356723133262e$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$dea356723133262e$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$dea356723133262e$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$dea356723133262e$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $dea356723133262e$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $dea356723133262e$export$d3a344b98cf0b775 extends $dea356723133262e$export$b0e479f45b7006d6 {
}
$dea356723133262e$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$dea356723133262e$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$dea356723133262e$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $dea356723133262e$export$995b32462a65e855;
$dea356723133262e$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$dea356723133262e$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $dea356723133262e$export$83444c5d885347d8 extends $dea356723133262e$export$b0e479f45b7006d6 {
}
$dea356723133262e$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $dea356723133262e$export$d45f0d1a4d9a9314 extends $dea356723133262e$export$b0e479f45b7006d6 {
}
$dea356723133262e$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $dea356723133262e$export$2db1cfb7923d931e extends $dea356723133262e$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$dea356723133262e$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $dea356723133262e$export$b8043f12b5aafbd7 extends $dea356723133262e$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $dea356723133262e$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$dea356723133262e$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$dea356723133262e$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $dea356723133262e$export$30fac1aace31cf4d;
$dea356723133262e$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $dea356723133262e$export$6ce41d4f3a8df9cd extends $dea356723133262e$export$b0e479f45b7006d6 {
}
$dea356723133262e$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$dea356723133262e$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$dea356723133262e$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $dea356723133262e$export$995b32462a65e855;
$dea356723133262e$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$dea356723133262e$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $dea356723133262e$export$5ce2dcb4cc9f2bff extends $dea356723133262e$export$b0e479f45b7006d6 {
}
$dea356723133262e$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $dea356723133262e$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $dea356723133262e$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $dea356723133262e$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($dea356723133262e$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($dea356723133262e$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $dea356723133262e$var$getKeyframeOrder(times);
            times = $dea356723133262e$var$sortedArray(times, 1, order);
            values = $dea356723133262e$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $dea356723133262e$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $dea356723133262e$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $dea356723133262e$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($dea356723133262e$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($dea356723133262e$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($dea356723133262e$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $dea356723133262e$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $dea356723133262e$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $dea356723133262e$export$5ce2dcb4cc9f2bff;
        case "color":
            return $dea356723133262e$export$83444c5d885347d8;
        case "quaternion":
            return $dea356723133262e$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $dea356723133262e$export$d3a344b98cf0b775;
        case "string":
            return $dea356723133262e$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $dea356723133262e$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $dea356723133262e$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $dea356723133262e$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $dea356723133262e$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $dea356723133262e$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $dea356723133262e$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $dea356723133262e$export$99cc795e99919eed();
class $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $dea356723133262e$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $dea356723133262e$var$loading = {};
class $dea356723133262e$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $dea356723133262e$export$98435a25b5cf7b2b extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $dea356723133262e$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($dea356723133262e$var$loading[url] !== undefined) {
            $dea356723133262e$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $dea356723133262e$var$loading[url] = [];
        $dea356723133262e$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $dea356723133262e$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("Content-Length") || response.headers.get("X-File-Size");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $dea356723133262e$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $dea356723133262e$export$94affb487e701bf2.add(url, data);
            const callbacks = $dea356723133262e$var$loading[url];
            delete $dea356723133262e$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $dea356723133262e$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $dea356723133262e$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $dea356723133262e$export$29711c7e14f61db extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $dea356723133262e$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $dea356723133262e$export$bd73ce947a280350 extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $dea356723133262e$export$3466bac9141a5cc4();
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $dea356723133262e$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $dea356723133262e$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $dea356723133262e$export$8905ce1c7a2464a1 extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $dea356723133262e$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $dea356723133262e$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $dea356723133262e$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $dea356723133262e$export$2ec114afc2cf6308 extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $dea356723133262e$export$ee2e5a18258a4049();
        const loader = new $dea356723133262e$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $dea356723133262e$export$792d8a18f2c55855 extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $dea356723133262e$export$b691f601014eabe1();
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $dea356723133262e$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $dea356723133262e$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $dea356723133262e$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $dea356723133262e$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $dea356723133262e$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $dea356723133262e$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $dea356723133262e$export$fd1bfc71f64c538c extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $dea356723133262e$export$5431306cf43de24a();
        const loader = new $dea356723133262e$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $dea356723133262e$export$6ecadb6ed240d696 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $dea356723133262e$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $dea356723133262e$export$8d474f55edbb9624 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($dea356723133262e$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $dea356723133262e$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $dea356723133262e$var$_projScreenMatrix$1 = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_lightPositionWorld$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_lookTarget$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $dea356723133262e$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $dea356723133262e$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $dea356723133262e$export$35efe6f4c85463d2();
        this._frameExtents = new $dea356723133262e$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $dea356723133262e$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $dea356723133262e$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($dea356723133262e$var$_lightPositionWorld$1);
        $dea356723133262e$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($dea356723133262e$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $dea356723133262e$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($dea356723133262e$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($dea356723133262e$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $dea356723133262e$var$SpotLightShadow extends $dea356723133262e$var$LightShadow {
    constructor(){
        super(new $dea356723133262e$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $dea356723133262e$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $dea356723133262e$export$81495cbb73897362 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($dea356723133262e$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $dea356723133262e$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $dea356723133262e$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $dea356723133262e$var$_projScreenMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_lightPositionWorld = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_lookTarget = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$var$PointLightShadow extends $dea356723133262e$var$LightShadow {
    constructor(){
        super(new $dea356723133262e$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $dea356723133262e$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $dea356723133262e$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $dea356723133262e$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $dea356723133262e$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $dea356723133262e$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $dea356723133262e$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $dea356723133262e$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $dea356723133262e$export$64b5c384219d3699(1, 0, 0),
            new $dea356723133262e$export$64b5c384219d3699(-1, 0, 0),
            new $dea356723133262e$export$64b5c384219d3699(0, 0, 1),
            new $dea356723133262e$export$64b5c384219d3699(0, 0, -1),
            new $dea356723133262e$export$64b5c384219d3699(0, 1, 0),
            new $dea356723133262e$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $dea356723133262e$export$64b5c384219d3699(0, 1, 0),
            new $dea356723133262e$export$64b5c384219d3699(0, 1, 0),
            new $dea356723133262e$export$64b5c384219d3699(0, 1, 0),
            new $dea356723133262e$export$64b5c384219d3699(0, 1, 0),
            new $dea356723133262e$export$64b5c384219d3699(0, 0, 1),
            new $dea356723133262e$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $dea356723133262e$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($dea356723133262e$var$_lightPositionWorld);
        $dea356723133262e$var$_lookTarget.copy(camera.position);
        $dea356723133262e$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($dea356723133262e$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$dea356723133262e$var$_lightPositionWorld.x, -$dea356723133262e$var$_lightPositionWorld.y, -$dea356723133262e$var$_lightPositionWorld.z);
        $dea356723133262e$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($dea356723133262e$var$_projScreenMatrix);
    }
}
class $dea356723133262e$export$4c9c1cb3f0b6f455 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $dea356723133262e$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $dea356723133262e$var$DirectionalLightShadow extends $dea356723133262e$var$LightShadow {
    constructor(){
        super(new $dea356723133262e$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $dea356723133262e$export$3fea33cc9972c868 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($dea356723133262e$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $dea356723133262e$export$e4dd07dff30cc924();
        this.shadow = new $dea356723133262e$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $dea356723133262e$export$af279bfef9ec2c96 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $dea356723133262e$export$61db2d908bbd2429 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $dea356723133262e$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $dea356723133262e$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $dea356723133262e$export$e7ef036e309b38d2 extends $dea356723133262e$export$6ecadb6ed240d696 {
    constructor(sh = new $dea356723133262e$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $dea356723133262e$export$3bd6d323353dcf96 extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $dea356723133262e$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $dea356723133262e$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $dea356723133262e$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $dea356723133262e$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $dea356723133262e$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $dea356723133262e$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $dea356723133262e$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $dea356723133262e$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $dea356723133262e$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $dea356723133262e$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $dea356723133262e$export$e8564da406055a3,
            SpriteMaterial: $dea356723133262e$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $dea356723133262e$export$21c421a2e1df9d22,
            ShaderMaterial: $dea356723133262e$export$83c7d75d550a8b0d,
            PointsMaterial: $dea356723133262e$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $dea356723133262e$export$28d04986c4269c9f,
            MeshStandardMaterial: $dea356723133262e$export$f2980790215acccd,
            MeshPhongMaterial: $dea356723133262e$export$24c72f71cbaf0678,
            MeshToonMaterial: $dea356723133262e$export$df893cf97e765622,
            MeshNormalMaterial: $dea356723133262e$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $dea356723133262e$export$5023a9a8114806b8,
            MeshDepthMaterial: $dea356723133262e$export$2698c22ec13825db,
            MeshDistanceMaterial: $dea356723133262e$export$33e187ed002f2a19,
            MeshBasicMaterial: $dea356723133262e$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $dea356723133262e$export$6f5fef6235ec12ee,
            LineDashedMaterial: $dea356723133262e$export$327886a3efaeaebe,
            LineBasicMaterial: $dea356723133262e$export$fbaaa33907730a0c,
            Material: $dea356723133262e$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $dea356723133262e$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $dea356723133262e$export$231f009cbe414146 extends $dea356723133262e$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $dea356723133262e$export$dc275bb96327833a extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $dea356723133262e$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $dea356723133262e$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $dea356723133262e$export$231f009cbe414146() : new $dea356723133262e$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $dea356723133262e$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $dea356723133262e$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $dea356723133262e$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $dea356723133262e$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $dea356723133262e$export$32ea87a8b54d744a : $dea356723133262e$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $dea356723133262e$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $dea356723133262e$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $dea356723133262e$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $dea356723133262e$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $dea356723133262e$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $dea356723133262e$export$40110c8505c5ad19 extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $dea356723133262e$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $dea356723133262e$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $dea356723133262e$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $dea356723133262e$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $dea356723133262e$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $dea356723133262e$var$Geometries) geometry = $dea356723133262e$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $dea356723133262e$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $dea356723133262e$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $dea356723133262e$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $dea356723133262e$export$99cc795e99919eed(onLoad);
            loader = new $dea356723133262e$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $dea356723133262e$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $dea356723133262e$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $dea356723133262e$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $dea356723133262e$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $dea356723133262e$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $dea356723133262e$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $dea356723133262e$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $dea356723133262e$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $dea356723133262e$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $dea356723133262e$export$b691f601014eabe1();
                else texture = new $dea356723133262e$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $dea356723133262e$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $dea356723133262e$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $dea356723133262e$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $dea356723133262e$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $dea356723133262e$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $dea356723133262e$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $dea356723133262e$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $dea356723133262e$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $dea356723133262e$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case "PerspectiveCamera":
                object = new $dea356723133262e$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $dea356723133262e$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $dea356723133262e$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $dea356723133262e$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $dea356723133262e$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $dea356723133262e$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $dea356723133262e$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $dea356723133262e$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $dea356723133262e$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $dea356723133262e$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $dea356723133262e$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $dea356723133262e$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $dea356723133262e$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $dea356723133262e$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $dea356723133262e$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $dea356723133262e$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $dea356723133262e$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $dea356723133262e$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $dea356723133262e$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $dea356723133262e$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $dea356723133262e$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $dea356723133262e$export$b127726e56765aa4();
                break;
            default:
                object = new $dea356723133262e$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $dea356723133262e$var$TEXTURE_MAPPING = {
    UVMapping: $dea356723133262e$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $dea356723133262e$export$8759762a6477f2c4,
    CubeRefractionMapping: $dea356723133262e$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $dea356723133262e$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $dea356723133262e$export$ee99d97d46898098,
    CubeUVReflectionMapping: $dea356723133262e$export$dbf3e70ff37af79
};
const $dea356723133262e$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $dea356723133262e$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $dea356723133262e$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $dea356723133262e$export$c7e7c00b14f51a4f
};
const $dea356723133262e$var$TEXTURE_FILTER = {
    NearestFilter: $dea356723133262e$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $dea356723133262e$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $dea356723133262e$export$d2327c1afe5bfdf2,
    LinearFilter: $dea356723133262e$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $dea356723133262e$export$19a719f377145a13,
    LinearMipmapLinearFilter: $dea356723133262e$export$5d8599b6a933fb1b
};
class $dea356723133262e$export$52286b55c4a9b51f extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $dea356723133262e$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $dea356723133262e$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $dea356723133262e$var$_context;
class $dea356723133262e$export$fcbc63750ec2a81f {
    static getContext() {
        if ($dea356723133262e$var$_context === undefined) $dea356723133262e$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $dea356723133262e$var$_context;
    }
    static setContext(value) {
        $dea356723133262e$var$_context = value;
    }
}
class $dea356723133262e$export$d8d5fccfbf47714e extends $dea356723133262e$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $dea356723133262e$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $dea356723133262e$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
class $dea356723133262e$export$2f22dadc8bc42820 extends $dea356723133262e$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $dea356723133262e$export$892596cec99bc70e().set(skyColor);
        const color2 = new $dea356723133262e$export$892596cec99bc70e().set(groundColor);
        const sky = new $dea356723133262e$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $dea356723133262e$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $dea356723133262e$export$afe310a21c86023d extends $dea356723133262e$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $dea356723133262e$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $dea356723133262e$var$_eyeRight = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_eyeLeft = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_projectionMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
class $dea356723133262e$export$bc7f73a1065bee0c {
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $dea356723133262e$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $dea356723133262e$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $dea356723133262e$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($dea356723133262e$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $dea356723133262e$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $dea356723133262e$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $dea356723133262e$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $dea356723133262e$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($dea356723133262e$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $dea356723133262e$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $dea356723133262e$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($dea356723133262e$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($dea356723133262e$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($dea356723133262e$var$_eyeRight);
    }
}
class $dea356723133262e$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $dea356723133262e$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $dea356723133262e$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $dea356723133262e$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $dea356723133262e$var$_position$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_quaternion$1 = /*@__PURE__*/ new $dea356723133262e$export$23d6a54f0bbc85a3();
const $dea356723133262e$var$_scale$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_orientation$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$8a1b810c6fde8951 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $dea356723133262e$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $dea356723133262e$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($dea356723133262e$var$_position$1, $dea356723133262e$var$_quaternion$1, $dea356723133262e$var$_scale$1);
        $dea356723133262e$var$_orientation$1.set(0, 0, -1).applyQuaternion($dea356723133262e$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($dea356723133262e$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($dea356723133262e$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($dea356723133262e$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($dea356723133262e$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($dea356723133262e$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($dea356723133262e$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($dea356723133262e$var$_position$1.x, $dea356723133262e$var$_position$1.y, $dea356723133262e$var$_position$1.z);
            listener.setOrientation($dea356723133262e$var$_orientation$1.x, $dea356723133262e$var$_orientation$1.y, $dea356723133262e$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $dea356723133262e$export$153755f98d9861de extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $dea356723133262e$var$_position = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_quaternion = /*@__PURE__*/ new $dea356723133262e$export$23d6a54f0bbc85a3();
const $dea356723133262e$var$_scale = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_orientation = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$4b3e397ef1832507 extends $dea356723133262e$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($dea356723133262e$var$_position, $dea356723133262e$var$_quaternion, $dea356723133262e$var$_scale);
        $dea356723133262e$var$_orientation.set(0, 0, 1).applyQuaternion($dea356723133262e$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($dea356723133262e$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($dea356723133262e$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($dea356723133262e$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($dea356723133262e$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($dea356723133262e$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($dea356723133262e$var$_orientation.z, endTime);
        } else {
            panner.setPosition($dea356723133262e$var$_position.x, $dea356723133262e$var$_position.y, $dea356723133262e$var$_position.z);
            panner.setOrientation($dea356723133262e$var$_orientation.x, $dea356723133262e$var$_orientation.y, $dea356723133262e$var$_orientation.z);
        }
    }
}
class $dea356723133262e$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $dea356723133262e$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $dea356723133262e$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $dea356723133262e$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $dea356723133262e$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $dea356723133262e$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $dea356723133262e$var$_reservedRe = new RegExp("[" + $dea356723133262e$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $dea356723133262e$var$_wordChar = "[^" + $dea356723133262e$var$_RESERVED_CHARS_RE + "]";
const $dea356723133262e$var$_wordCharOrDot = "[^" + $dea356723133262e$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $dea356723133262e$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $dea356723133262e$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $dea356723133262e$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $dea356723133262e$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $dea356723133262e$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $dea356723133262e$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $dea356723133262e$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $dea356723133262e$var$_wordChar);
const $dea356723133262e$var$_trackRe = new RegExp("^" + $dea356723133262e$var$_directoryRe + $dea356723133262e$var$_nodeRe + $dea356723133262e$var$_objectRe + $dea356723133262e$var$_propertyRe + "$");
const $dea356723133262e$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $dea356723133262e$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $dea356723133262e$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $dea356723133262e$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $dea356723133262e$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $dea356723133262e$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $dea356723133262e$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $dea356723133262e$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($dea356723133262e$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $dea356723133262e$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($dea356723133262e$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $dea356723133262e$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$dea356723133262e$export$7bf70fcf9f891893.Composite = $dea356723133262e$var$Composite;
$dea356723133262e$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$dea356723133262e$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$dea356723133262e$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $dea356723133262e$export$7bf70fcf9f891893.prototype._getValue_direct,
    $dea356723133262e$export$7bf70fcf9f891893.prototype._getValue_array,
    $dea356723133262e$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $dea356723133262e$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$dea356723133262e$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_direct,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_array,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $dea356723133262e$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $dea356723133262e$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $dea356723133262e$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $dea356723133262e$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $dea356723133262e$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $dea356723133262e$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $dea356723133262e$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $dea356723133262e$export$7f795934b84ab523,
            endingEnd: $dea356723133262e$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $dea356723133262e$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $dea356723133262e$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $dea356723133262e$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $dea356723133262e$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $dea356723133262e$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $dea356723133262e$export$24a4ccb5099273b5;
            settings.endingEnd = $dea356723133262e$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $dea356723133262e$export$24a4ccb5099273b5 : $dea356723133262e$export$7f795934b84ab523;
            else settings.endingStart = $dea356723133262e$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $dea356723133262e$export$24a4ccb5099273b5 : $dea356723133262e$export$7f795934b84ab523;
            else settings.endingEnd = $dea356723133262e$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $dea356723133262e$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $dea356723133262e$export$fbd77e5aefaa0102 extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $dea356723133262e$export$dfe0af1ca1acb78a($dea356723133262e$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $dea356723133262e$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $dea356723133262e$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $dea356723133262e$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $dea356723133262e$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $dea356723133262e$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $dea356723133262e$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $dea356723133262e$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $dea356723133262e$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $dea356723133262e$var$id = 0;
class $dea356723133262e$export$c412d5ffe1f79209 extends $dea356723133262e$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $dea356723133262e$var$id++
        });
        this.name = "";
        this.usage = $dea356723133262e$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $dea356723133262e$export$25ec0e1af1389358 extends $dea356723133262e$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $dea356723133262e$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $dea356723133262e$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $dea356723133262e$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $dea356723133262e$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $dea356723133262e$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($dea356723133262e$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$dea356723133262e$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($dea356723133262e$var$ascSort);
        return intersects;
    }
}
function $dea356723133262e$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $dea356723133262e$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$dea356723133262e$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $dea356723133262e$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($dea356723133262e$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $dea356723133262e$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $dea356723133262e$var$_vector$4 = /*@__PURE__*/ new $dea356723133262e$export$c977b3e384af9ae1();
class $dea356723133262e$export$60f553fa130f08b0 {
    constructor(min = new $dea356723133262e$export$c977b3e384af9ae1(Infinity, Infinity), max = new $dea356723133262e$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $dea356723133262e$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $dea356723133262e$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $dea356723133262e$var$_startP = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_startEnd = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$e0ba6359f1954fd3 {
    constructor(start = new $dea356723133262e$export$64b5c384219d3699(), end = new $dea356723133262e$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $dea356723133262e$var$_startP.subVectors(point, this.start);
        $dea356723133262e$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $dea356723133262e$var$_startEnd.dot($dea356723133262e$var$_startEnd);
        const startEnd_startP = $dea356723133262e$var$_startEnd.dot($dea356723133262e$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $dea356723133262e$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $dea356723133262e$var$_vector$3 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$4b14638ffdd81e68 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(positions, 3));
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $dea356723133262e$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $dea356723133262e$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($dea356723133262e$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $dea356723133262e$var$_vector$2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_boneMatrix = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
const $dea356723133262e$var$_matrixWorldInv = /*@__PURE__*/ new $dea356723133262e$export$2ae72fc923e5eb5();
class $dea356723133262e$export$5277df3c9e732259 extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $dea356723133262e$var$getBoneList(object);
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $dea356723133262e$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $dea356723133262e$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $dea356723133262e$export$cbe7a62641830ebd(colors, 3));
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $dea356723133262e$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $dea356723133262e$var$_boneMatrix.multiplyMatrices($dea356723133262e$var$_matrixWorldInv, bone.matrixWorld);
                $dea356723133262e$var$_vector$2.setFromMatrixPosition($dea356723133262e$var$_boneMatrix);
                position.setXYZ(j, $dea356723133262e$var$_vector$2.x, $dea356723133262e$var$_vector$2.y, $dea356723133262e$var$_vector$2.z);
                $dea356723133262e$var$_boneMatrix.multiplyMatrices($dea356723133262e$var$_matrixWorldInv, bone.parent.matrixWorld);
                $dea356723133262e$var$_vector$2.setFromMatrixPosition($dea356723133262e$var$_boneMatrix);
                position.setXYZ(j + 1, $dea356723133262e$var$_vector$2.x, $dea356723133262e$var$_vector$2.y, $dea356723133262e$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $dea356723133262e$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $dea356723133262e$var$getBoneList(object.children[i]));
    return boneList;
}
class $dea356723133262e$export$9a9291685b9e4023 extends $dea356723133262e$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $dea356723133262e$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $dea356723133262e$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $dea356723133262e$var$_vector$1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_color1 = /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e();
const $dea356723133262e$var$_color2 = /*@__PURE__*/ new $dea356723133262e$export$892596cec99bc70e();
class $dea356723133262e$export$8dca15f13f4f8172 extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $dea356723133262e$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $dea356723133262e$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $dea356723133262e$export$8dea267bd6bde117(colors, 3));
        this.add(new $dea356723133262e$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $dea356723133262e$var$_color1.copy(this.light.color);
            $dea356723133262e$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $dea356723133262e$var$_color1 : $dea356723133262e$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($dea356723133262e$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $dea356723133262e$export$3875d39926561055 extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $dea356723133262e$export$892596cec99bc70e(color1);
        color2 = new $dea356723133262e$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $dea356723133262e$export$cbe7a62641830ebd(colors, 3));
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $dea356723133262e$export$361430a10f533cd3 extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $dea356723133262e$export$892596cec99bc70e(color1);
        color2 = new $dea356723133262e$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $dea356723133262e$export$cbe7a62641830ebd(colors, 3));
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $dea356723133262e$var$_v1 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v2 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_v3 = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
class $dea356723133262e$export$f8e434dc14203e7d extends $dea356723133262e$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $dea356723133262e$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $dea356723133262e$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $dea356723133262e$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $dea356723133262e$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $dea356723133262e$var$_v3.subVectors($dea356723133262e$var$_v2, $dea356723133262e$var$_v1);
        this.lightPlane.lookAt($dea356723133262e$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($dea356723133262e$var$_v2);
        this.targetLine.scale.z = $dea356723133262e$var$_v3.length();
    }
}
const $dea356723133262e$var$_vector = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
const $dea356723133262e$var$_camera = /*@__PURE__*/ new $dea356723133262e$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $dea356723133262e$export$ed8e93f853cd795 extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $dea356723133262e$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $dea356723133262e$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $dea356723133262e$export$892596cec99bc70e(0xff0000);
        const colorUp = new $dea356723133262e$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $dea356723133262e$export$892596cec99bc70e(0xffffff);
        const colorCross = new $dea356723133262e$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $dea356723133262e$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $dea356723133262e$var$setPoint("c", pointMap, geometry, $dea356723133262e$var$_camera, 0, 0, -1);
        $dea356723133262e$var$setPoint("t", pointMap, geometry, $dea356723133262e$var$_camera, 0, 0, 1);
        // near
        $dea356723133262e$var$setPoint("n1", pointMap, geometry, $dea356723133262e$var$_camera, -w, -h, -1);
        $dea356723133262e$var$setPoint("n2", pointMap, geometry, $dea356723133262e$var$_camera, w, -h, -1);
        $dea356723133262e$var$setPoint("n3", pointMap, geometry, $dea356723133262e$var$_camera, -w, h, -1);
        $dea356723133262e$var$setPoint("n4", pointMap, geometry, $dea356723133262e$var$_camera, w, h, -1);
        // far
        $dea356723133262e$var$setPoint("f1", pointMap, geometry, $dea356723133262e$var$_camera, -w, -h, 1);
        $dea356723133262e$var$setPoint("f2", pointMap, geometry, $dea356723133262e$var$_camera, w, -h, 1);
        $dea356723133262e$var$setPoint("f3", pointMap, geometry, $dea356723133262e$var$_camera, -w, h, 1);
        $dea356723133262e$var$setPoint("f4", pointMap, geometry, $dea356723133262e$var$_camera, w, h, 1);
        // up
        $dea356723133262e$var$setPoint("u1", pointMap, geometry, $dea356723133262e$var$_camera, w * 0.7, h * 1.1, -1);
        $dea356723133262e$var$setPoint("u2", pointMap, geometry, $dea356723133262e$var$_camera, -w * 0.7, h * 1.1, -1);
        $dea356723133262e$var$setPoint("u3", pointMap, geometry, $dea356723133262e$var$_camera, 0, h * 2, -1);
        // cross
        $dea356723133262e$var$setPoint("cf1", pointMap, geometry, $dea356723133262e$var$_camera, -w, 0, 1);
        $dea356723133262e$var$setPoint("cf2", pointMap, geometry, $dea356723133262e$var$_camera, w, 0, 1);
        $dea356723133262e$var$setPoint("cf3", pointMap, geometry, $dea356723133262e$var$_camera, 0, -h, 1);
        $dea356723133262e$var$setPoint("cf4", pointMap, geometry, $dea356723133262e$var$_camera, 0, h, 1);
        $dea356723133262e$var$setPoint("cn1", pointMap, geometry, $dea356723133262e$var$_camera, -w, 0, -1);
        $dea356723133262e$var$setPoint("cn2", pointMap, geometry, $dea356723133262e$var$_camera, w, 0, -1);
        $dea356723133262e$var$setPoint("cn3", pointMap, geometry, $dea356723133262e$var$_camera, 0, -h, -1);
        $dea356723133262e$var$setPoint("cn4", pointMap, geometry, $dea356723133262e$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $dea356723133262e$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $dea356723133262e$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $dea356723133262e$var$_vector.x, $dea356723133262e$var$_vector.y, $dea356723133262e$var$_vector.z);
    }
}
const $dea356723133262e$var$_box = /*@__PURE__*/ new $dea356723133262e$export$6f7d5a9418ab2aa3();
class $dea356723133262e$export$38a664cc862a6a9d extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setIndex(new $dea356723133262e$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $dea356723133262e$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $dea356723133262e$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $dea356723133262e$var$_box.setFromObject(this.object);
        if ($dea356723133262e$var$_box.isEmpty()) return;
        const min = $dea356723133262e$var$_box.min;
        const max = $dea356723133262e$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $dea356723133262e$export$ce39f4bb96c9a290 extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setIndex(new $dea356723133262e$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $dea356723133262e$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $dea356723133262e$export$a34fe8156c66e5d7 extends $dea356723133262e$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $dea356723133262e$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $dea356723133262e$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $dea356723133262e$export$e176487c05830cc5(geometry2, new $dea356723133262e$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $dea356723133262e$var$_axis = /*@__PURE__*/ new $dea356723133262e$export$64b5c384219d3699();
let $dea356723133262e$var$_lineGeometry, $dea356723133262e$var$_coneGeometry;
class $dea356723133262e$export$a3008e7bd8d2cbe7 extends $dea356723133262e$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $dea356723133262e$export$64b5c384219d3699(0, 0, 1), origin = new $dea356723133262e$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($dea356723133262e$var$_lineGeometry === undefined) {
            $dea356723133262e$var$_lineGeometry = new $dea356723133262e$export$b7be63a67df8959();
            $dea356723133262e$var$_lineGeometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $dea356723133262e$var$_coneGeometry = new $dea356723133262e$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $dea356723133262e$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $dea356723133262e$export$17d680238e50603e($dea356723133262e$var$_lineGeometry, new $dea356723133262e$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $dea356723133262e$export$e176487c05830cc5($dea356723133262e$var$_coneGeometry, new $dea356723133262e$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $dea356723133262e$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($dea356723133262e$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $dea356723133262e$export$6c8303f35b8578fd extends $dea356723133262e$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $dea356723133262e$export$b7be63a67df8959();
        geometry.setAttribute("position", new $dea356723133262e$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $dea356723133262e$export$cbe7a62641830ebd(colors, 3));
        const material = new $dea356723133262e$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $dea356723133262e$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $dea356723133262e$export$148534a3c727230b {
    constructor(){
        this.type = "ShapePath";
        this.color = new $dea356723133262e$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $dea356723133262e$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $dea356723133262e$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $dea356723133262e$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $dea356723133262e$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $dea356723133262e$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $dea356723133262e$export$ab3456a079aa7d80 extends $dea356723133262e$export$33e43285f7406bd5 {
    constructor(width, height, depth, widthSegments, heightSegments, depthSegments){
        console.warn("THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.");
        super(width, height, depth, widthSegments, heightSegments, depthSegments);
    }
}
class $dea356723133262e$export$f036d76f832848a extends $dea356723133262e$export$41680e8551036033 {
    constructor(radius, length, capSegments, radialSegments){
        console.warn("THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.");
        super(radius, length, capSegments, radialSegments);
    }
}
class $dea356723133262e$export$3f74fe60decf7462 extends $dea356723133262e$export$d5c0e8d607467193 {
    constructor(radius, segments, thetaStart, thetaLength){
        console.warn("THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.");
        super(radius, segments, thetaStart, thetaLength);
    }
}
class $dea356723133262e$export$59d971120dc8b6e7 extends $dea356723133262e$export$a7a48974f285c9b3 {
    constructor(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.");
        super(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $dea356723133262e$export$d4345c83207d7c68 extends $dea356723133262e$export$68f745719dbe5198 {
    constructor(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn("THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.");
        super(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
class $dea356723133262e$export$37cd4e52cce48c4c extends $dea356723133262e$export$c0babfeb8708fc9c {
    constructor(radius, detail){
        console.warn("THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.");
        super(radius, detail);
    }
}
class $dea356723133262e$export$91836d01b9f75a58 extends $dea356723133262e$export$598697a1efa63ca7 {
    constructor(shapes, options){
        console.warn("THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.");
        super(shapes, options);
    }
}
class $dea356723133262e$export$731fd4feef063ea2 extends $dea356723133262e$export$9567cc828c9535da {
    constructor(radius, detail){
        console.warn("THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.");
        super(radius, detail);
    }
}
class $dea356723133262e$export$dc3e1273c1dd9240 extends $dea356723133262e$export$6d839803fcd1882c {
    constructor(points, segments, phiStart, phiLength){
        console.warn("THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.");
        super(points, segments, phiStart, phiLength);
    }
}
class $dea356723133262e$export$8e05fc91596f4752 extends $dea356723133262e$export$1954e2b809fe361e {
    constructor(radius, detail){
        console.warn("THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.");
        super(radius, detail);
    }
}
class $dea356723133262e$export$e789a11a194ca4e0 extends $dea356723133262e$export$967d831af31f69ce {
    constructor(width, height, widthSegments, heightSegments){
        console.warn("THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.");
        super(width, height, widthSegments, heightSegments);
    }
}
class $dea356723133262e$export$38789b531813345c extends $dea356723133262e$export$60e57a7d3f20ff65 {
    constructor(vertices, indices, radius, detail){
        console.warn("THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.");
        super(vertices, indices, radius, detail);
    }
}
class $dea356723133262e$export$ee8b85b34b7d9cad extends $dea356723133262e$export$68cb731f50f614af {
    constructor(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength){
        console.warn("THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.");
        super(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
    }
}
class $dea356723133262e$export$233afc324766bed8 extends $dea356723133262e$export$57a29a1c803e9065 {
    constructor(shapes, curveSegments){
        console.warn("THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.");
        super(shapes, curveSegments);
    }
}
class $dea356723133262e$export$d5d06a966fec4192 extends $dea356723133262e$export$1b417fc3b307a251 {
    constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength){
        console.warn("THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.");
        super(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
    }
}
class $dea356723133262e$export$369e08f62a796c65 extends $dea356723133262e$export$fb3f7adc68bd6e02 {
    constructor(radius, detail){
        console.warn("THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.");
        super(radius, detail);
    }
}
class $dea356723133262e$export$19d55f905fa4f2cb extends $dea356723133262e$export$a2312a2a1fa56495 {
    constructor(radius, tube, radialSegments, tubularSegments, arc){
        console.warn("THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.");
        super(radius, tube, radialSegments, tubularSegments, arc);
    }
}
class $dea356723133262e$export$2b32466f4274fe5c extends $dea356723133262e$export$77e9bfadfb9ab8c8 {
    constructor(radius, tube, tubularSegments, radialSegments, p, q){
        console.warn("THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.");
        super(radius, tube, tubularSegments, radialSegments, p, q);
    }
}
class $dea356723133262e$export$d97a193ce44e691b extends $dea356723133262e$export$7897d9d48904490c {
    constructor(path, tubularSegments, radius, radialSegments, closed){
        console.warn("THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.");
        super(path, tubularSegments, radius, radialSegments, closed);
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $dea356723133262e$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $dea356723133262e$export$3545e07a80636437;
}



// OrbitControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $d56bb5ed7dee50b9$var$_changeEvent = {
    type: "change"
};
const $d56bb5ed7dee50b9$var$_startEvent = {
    type: "start"
};
const $d56bb5ed7dee50b9$var$_endEvent = {
    type: "end"
};
class $d56bb5ed7dee50b9$export$8ff7788029dfdf52 extends (0, $dea356723133262e$export$ec8b666c5fe2c75a) {
    constructor(object, domElement){
        super();
        this.object = object;
        this.domElement = domElement;
        this.domElement.style.touchAction = "none"; // disable touch scroll
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $dea356723133262e$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: "ArrowLeft",
            UP: "ArrowUp",
            RIGHT: "ArrowRight",
            BOTTOM: "ArrowDown"
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $dea356723133262e$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $dea356723133262e$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $dea356723133262e$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $dea356723133262e$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $dea356723133262e$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        //
        // public methods
        //
        this.getPolarAngle = function() {
            return spherical.phi;
        };
        this.getAzimuthalAngle = function() {
            return spherical.theta;
        };
        this.getDistance = function() {
            return this.object.position.distanceTo(this.target);
        };
        this.listenToKeyEvents = function(domElement) {
            domElement.addEventListener("keydown", onKeyDown);
            this._domElementKeyEvents = domElement;
        };
        this.stopListenToKeyEvents = function() {
            this._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
            this._domElementKeyEvents = null;
        };
        this.saveState = function() {
            scope.target0.copy(scope.target);
            scope.position0.copy(scope.object.position);
            scope.zoom0 = scope.object.zoom;
        };
        this.reset = function() {
            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.zoom = scope.zoom0;
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent($d56bb5ed7dee50b9$var$_changeEvent);
            scope.update();
            state = STATE.NONE;
        };
        // this method is exposed, but perhaps it would be better if we can make it private...
        this.update = function() {
            const offset = new (0, $dea356723133262e$export$64b5c384219d3699)();
            // so camera.up is the orbit axis
            const quat = new (0, $dea356723133262e$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $dea356723133262e$export$64b5c384219d3699)(0, 1, 0));
            const quatInverse = quat.clone().invert();
            const lastPosition = new (0, $dea356723133262e$export$64b5c384219d3699)();
            const lastQuaternion = new (0, $dea356723133262e$export$23d6a54f0bbc85a3)();
            const twoPI = 2 * Math.PI;
            return function update() {
                const position = scope.object.position;
                offset.copy(position).sub(scope.target);
                // rotate offset to "y-axis-is-up" space
                offset.applyQuaternion(quat);
                // angle from z-axis around y-axis
                spherical.setFromVector3(offset);
                if (scope.autoRotate && state === STATE.NONE) rotateLeft(getAutoRotationAngle());
                if (scope.enableDamping) {
                    spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                    spherical.phi += sphericalDelta.phi * scope.dampingFactor;
                } else {
                    spherical.theta += sphericalDelta.theta;
                    spherical.phi += sphericalDelta.phi;
                }
                // restrict theta to be between desired limits
                let min = scope.minAzimuthAngle;
                let max = scope.maxAzimuthAngle;
                if (isFinite(min) && isFinite(max)) {
                    if (min < -Math.PI) min += twoPI;
                    else if (min > Math.PI) min -= twoPI;
                    if (max < -Math.PI) max += twoPI;
                    else if (max > Math.PI) max -= twoPI;
                    if (min <= max) spherical.theta = Math.max(min, Math.min(max, spherical.theta));
                    else spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
                }
                // restrict phi to be between desired limits
                spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
                spherical.makeSafe();
                spherical.radius *= scale;
                // restrict radius to be between desired limits
                spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));
                // move target to panned location
                if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
                else scope.target.add(panOffset);
                offset.setFromSpherical(spherical);
                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);
                position.copy(scope.target).add(offset);
                scope.object.lookAt(scope.target);
                if (scope.enableDamping === true) {
                    sphericalDelta.theta *= 1 - scope.dampingFactor;
                    sphericalDelta.phi *= 1 - scope.dampingFactor;
                    panOffset.multiplyScalar(1 - scope.dampingFactor);
                } else {
                    sphericalDelta.set(0, 0, 0);
                    panOffset.set(0, 0, 0);
                }
                scale = 1;
                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8
                if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                    scope.dispatchEvent($d56bb5ed7dee50b9$var$_changeEvent);
                    lastPosition.copy(scope.object.position);
                    lastQuaternion.copy(scope.object.quaternion);
                    zoomChanged = false;
                    return true;
                }
                return false;
            };
        }();
        this.dispose = function() {
            scope.domElement.removeEventListener("contextmenu", onContextMenu);
            scope.domElement.removeEventListener("pointerdown", onPointerDown);
            scope.domElement.removeEventListener("pointercancel", onPointerUp);
            scope.domElement.removeEventListener("wheel", onMouseWheel);
            scope.domElement.removeEventListener("pointermove", onPointerMove);
            scope.domElement.removeEventListener("pointerup", onPointerUp);
            if (scope._domElementKeyEvents !== null) {
                scope._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
                scope._domElementKeyEvents = null;
            }
        //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
        };
        //
        // internals
        //
        const scope = this;
        const STATE = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };
        let state = STATE.NONE;
        const EPS = 0.000001;
        // current position in spherical coordinates
        const spherical = new (0, $dea356723133262e$export$d712cd887b4a00f7)();
        const sphericalDelta = new (0, $dea356723133262e$export$d712cd887b4a00f7)();
        let scale = 1;
        const panOffset = new (0, $dea356723133262e$export$64b5c384219d3699)();
        let zoomChanged = false;
        const rotateStart = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const rotateEnd = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const rotateDelta = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const panStart = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const panEnd = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const panDelta = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const dollyStart = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const dollyEnd = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const dollyDelta = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
        const pointers = [];
        const pointerPositions = {};
        function getAutoRotationAngle() {
            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
        }
        function getZoomScale() {
            return Math.pow(0.95, scope.zoomSpeed);
        }
        function rotateLeft(angle) {
            sphericalDelta.theta -= angle;
        }
        function rotateUp(angle) {
            sphericalDelta.phi -= angle;
        }
        const panLeft = function() {
            const v = new (0, $dea356723133262e$export$64b5c384219d3699)();
            return function panLeft(distance, objectMatrix) {
                v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
                v.multiplyScalar(-distance);
                panOffset.add(v);
            };
        }();
        const panUp = function() {
            const v = new (0, $dea356723133262e$export$64b5c384219d3699)();
            return function panUp(distance, objectMatrix) {
                if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
                else {
                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.object.up, v);
                }
                v.multiplyScalar(distance);
                panOffset.add(v);
            };
        }();
        // deltaX and deltaY are in pixels; right and down are positive
        const pan = function() {
            const offset = new (0, $dea356723133262e$export$64b5c384219d3699)();
            return function pan(deltaX, deltaY) {
                const element = scope.domElement;
                if (scope.object.isPerspectiveCamera) {
                    // perspective
                    const position = scope.object.position;
                    offset.copy(position).sub(scope.target);
                    let targetDistance = offset.length();
                    // half of the fov is center to top of screen
                    targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
                    // we use only clientHeight here so aspect ratio does not distort speed
                    panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                    panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
                } else if (scope.object.isOrthographicCamera) {
                    // orthographic
                    panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                    panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
                } else {
                    // camera neither orthographic nor perspective
                    console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
                    scope.enablePan = false;
                }
            };
        }();
        function dollyOut(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale /= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        function dollyIn(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale *= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
                scope.enableZoom = false;
            }
        }
        //
        // event callbacks - update the object state
        //
        function handleMouseDownRotate(event) {
            rotateStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownDolly(event) {
            dollyStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownPan(event) {
            panStart.set(event.clientX, event.clientY);
        }
        function handleMouseMoveRotate(event) {
            rotateEnd.set(event.clientX, event.clientY);
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
            scope.update();
        }
        function handleMouseMoveDolly(event) {
            dollyEnd.set(event.clientX, event.clientY);
            dollyDelta.subVectors(dollyEnd, dollyStart);
            if (dollyDelta.y > 0) dollyOut(getZoomScale());
            else if (dollyDelta.y < 0) dollyIn(getZoomScale());
            dollyStart.copy(dollyEnd);
            scope.update();
        }
        function handleMouseMovePan(event) {
            panEnd.set(event.clientX, event.clientY);
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
            scope.update();
        }
        function handleMouseWheel(event) {
            if (event.deltaY < 0) dollyIn(getZoomScale());
            else if (event.deltaY > 0) dollyOut(getZoomScale());
            scope.update();
        }
        function handleKeyDown(event) {
            let needsUpdate = false;
            switch(event.code){
                case scope.keys.UP:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) rotateUp(2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
                    else pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.BOTTOM:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) rotateUp(-2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
                    else pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.LEFT:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) rotateLeft(2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
                    else pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
                case scope.keys.RIGHT:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) rotateLeft(-2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
                    else pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
            }
            if (needsUpdate) {
                // prevent the browser from scrolling on cursor keys
                event.preventDefault();
                scope.update();
            }
        }
        function handleTouchStartRotate() {
            if (pointers.length === 1) rotateStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                const x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                const y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                rotateStart.set(x, y);
            }
        }
        function handleTouchStartPan() {
            if (pointers.length === 1) panStart.set(pointers[0].pageX, pointers[0].pageY);
            else {
                const x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
                const y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
                panStart.set(x, y);
            }
        }
        function handleTouchStartDolly() {
            const dx = pointers[0].pageX - pointers[1].pageX;
            const dy = pointers[0].pageY - pointers[1].pageY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyStart.set(0, distance);
        }
        function handleTouchStartDollyPan() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enablePan) handleTouchStartPan();
        }
        function handleTouchStartDollyRotate() {
            if (scope.enableZoom) handleTouchStartDolly();
            if (scope.enableRotate) handleTouchStartRotate();
        }
        function handleTouchMoveRotate(event) {
            if (pointers.length == 1) rotateEnd.set(event.pageX, event.pageY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.pageX + position.x);
                const y = 0.5 * (event.pageY + position.y);
                rotateEnd.set(x, y);
            }
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
        }
        function handleTouchMovePan(event) {
            if (pointers.length === 1) panEnd.set(event.pageX, event.pageY);
            else {
                const position = getSecondPointerPosition(event);
                const x = 0.5 * (event.pageX + position.x);
                const y = 0.5 * (event.pageY + position.y);
                panEnd.set(x, y);
            }
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
        }
        function handleTouchMoveDolly(event) {
            const position = getSecondPointerPosition(event);
            const dx = event.pageX - position.x;
            const dy = event.pageY - position.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyEnd.set(0, distance);
            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
            dollyOut(dollyDelta.y);
            dollyStart.copy(dollyEnd);
        }
        function handleTouchMoveDollyPan(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enablePan) handleTouchMovePan(event);
        }
        function handleTouchMoveDollyRotate(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enableRotate) handleTouchMoveRotate(event);
        }
        //
        // event handlers - FSM: listen for events and reset state
        //
        function onPointerDown(event) {
            if (scope.enabled === false) return;
            if (pointers.length === 0) {
                scope.domElement.setPointerCapture(event.pointerId);
                scope.domElement.addEventListener("pointermove", onPointerMove);
                scope.domElement.addEventListener("pointerup", onPointerUp);
            }
            //
            addPointer(event);
            if (event.pointerType === "touch") onTouchStart(event);
            else onMouseDown(event);
        }
        function onPointerMove(event) {
            if (scope.enabled === false) return;
            if (event.pointerType === "touch") onTouchMove(event);
            else onMouseMove(event);
        }
        function onPointerUp(event) {
            removePointer(event);
            if (pointers.length === 0) {
                scope.domElement.releasePointerCapture(event.pointerId);
                scope.domElement.removeEventListener("pointermove", onPointerMove);
                scope.domElement.removeEventListener("pointerup", onPointerUp);
            }
            scope.dispatchEvent($d56bb5ed7dee50b9$var$_endEvent);
            state = STATE.NONE;
        }
        function onMouseDown(event) {
            let mouseAction;
            switch(event.button){
                case 0:
                    mouseAction = scope.mouseButtons.LEFT;
                    break;
                case 1:
                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;
                case 2:
                    mouseAction = scope.mouseButtons.RIGHT;
                    break;
                default:
                    mouseAction = -1;
            }
            switch(mouseAction){
                case (0, $dea356723133262e$export$7177b3e430c2d7ca).DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseDownDolly(event);
                    state = STATE.DOLLY;
                    break;
                case (0, $dea356723133262e$export$7177b3e430c2d7ca).ROTATE:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    } else {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    }
                    break;
                case (0, $dea356723133262e$export$7177b3e430c2d7ca).PAN:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    } else {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($d56bb5ed7dee50b9$var$_startEvent);
        }
        function onMouseMove(event) {
            switch(state){
                case STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleMouseMoveRotate(event);
                    break;
                case STATE.DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseMoveDolly(event);
                    break;
                case STATE.PAN:
                    if (scope.enablePan === false) return;
                    handleMouseMovePan(event);
                    break;
            }
        }
        function onMouseWheel(event) {
            if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) return;
            event.preventDefault();
            scope.dispatchEvent($d56bb5ed7dee50b9$var$_startEvent);
            handleMouseWheel(event);
            scope.dispatchEvent($d56bb5ed7dee50b9$var$_endEvent);
        }
        function onKeyDown(event) {
            if (scope.enabled === false || scope.enablePan === false) return;
            handleKeyDown(event);
        }
        function onTouchStart(event) {
            trackPointer(event);
            switch(pointers.length){
                case 1:
                    switch(scope.touches.ONE){
                        case (0, $dea356723133262e$export$d46bd3ead7cc759b).ROTATE:
                            if (scope.enableRotate === false) return;
                            handleTouchStartRotate();
                            state = STATE.TOUCH_ROTATE;
                            break;
                        case (0, $dea356723133262e$export$d46bd3ead7cc759b).PAN:
                            if (scope.enablePan === false) return;
                            handleTouchStartPan();
                            state = STATE.TOUCH_PAN;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                case 2:
                    switch(scope.touches.TWO){
                        case (0, $dea356723133262e$export$d46bd3ead7cc759b).DOLLY_PAN:
                            if (scope.enableZoom === false && scope.enablePan === false) return;
                            handleTouchStartDollyPan();
                            state = STATE.TOUCH_DOLLY_PAN;
                            break;
                        case (0, $dea356723133262e$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                            if (scope.enableZoom === false && scope.enableRotate === false) return;
                            handleTouchStartDollyRotate();
                            state = STATE.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($d56bb5ed7dee50b9$var$_startEvent);
        }
        function onTouchMove(event) {
            trackPointer(event);
            switch(state){
                case STATE.TOUCH_ROTATE:
                    if (scope.enableRotate === false) return;
                    handleTouchMoveRotate(event);
                    scope.update();
                    break;
                case STATE.TOUCH_PAN:
                    if (scope.enablePan === false) return;
                    handleTouchMovePan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_PAN:
                    if (scope.enableZoom === false && scope.enablePan === false) return;
                    handleTouchMoveDollyPan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_ROTATE:
                    if (scope.enableZoom === false && scope.enableRotate === false) return;
                    handleTouchMoveDollyRotate(event);
                    scope.update();
                    break;
                default:
                    state = STATE.NONE;
            }
        }
        function onContextMenu(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
        }
        function addPointer(event) {
            pointers.push(event);
        }
        function removePointer(event) {
            delete pointerPositions[event.pointerId];
            for(let i = 0; i < pointers.length; i++)if (pointers[i].pointerId == event.pointerId) {
                pointers.splice(i, 1);
                return;
            }
        }
        function trackPointer(event) {
            let position = pointerPositions[event.pointerId];
            if (position === undefined) {
                position = new (0, $dea356723133262e$export$c977b3e384af9ae1)();
                pointerPositions[event.pointerId] = position;
            }
            position.set(event.pageX, event.pageY);
        }
        function getSecondPointerPosition(event) {
            const pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
            return pointerPositions[pointer.pointerId];
        }
        //
        scope.domElement.addEventListener("contextmenu", onContextMenu);
        scope.domElement.addEventListener("pointerdown", onPointerDown);
        scope.domElement.addEventListener("pointercancel", onPointerUp);
        scope.domElement.addEventListener("wheel", onMouseWheel, {
            passive: false
        });
        // force an update at start
        this.update();
    }
}




function $a628a0d08e641a81$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
    if (!geometry.hasAttribute("position") || !geometry.hasAttribute("normal") || !geometry.hasAttribute("uv")) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute("tangent", new (0, $dea356723133262e$export$8dea267bd6bde117)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $a628a0d08e641a81$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $dea356723133262e$export$b7be63a67df8959)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $a628a0d08e641a81$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $a628a0d08e641a81$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $a628a0d08e641a81$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.");
            return null;
        }
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attribute.array.length;
    }
    const array = new TypedArray(arrayLength);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        array.set(attributes[i].array, offset);
        offset += attributes[i].array.length;
    }
    return new (0, $dea356723133262e$export$8dea267bd6bde117)(array, itemSize, normalized);
}
function $a628a0d08e641a81$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $a628a0d08e641a81$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $dea356723133262e$export$32ea87a8b54d744a)().copy(attribute);
    return new (0, $dea356723133262e$export$8dea267bd6bde117)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $a628a0d08e641a81$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $dea356723133262e$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $dea356723133262e$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $a628a0d08e641a81$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $dea356723133262e$export$32ea87a8b54d744a)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $dea356723133262e$export$8dea267bd6bde117)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $a628a0d08e641a81$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $a628a0d08e641a81$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $a628a0d08e641a81$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */ function $a628a0d08e641a81$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $a628a0d08e641a81$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new (0, $dea356723133262e$export$8dea267bd6bde117)(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) tmpMorphAttributes[name] = new (0, $dea356723133262e$export$8dea267bd6bde117)(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newarray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new (0, $dea356723133262e$export$8dea267bd6bde117)(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new (0, $dea356723133262e$export$8dea267bd6bde117)(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $a628a0d08e641a81$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $dea356723133262e$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $dea356723133262e$export$f0d8293634f88842) || drawMode === (0, $dea356723133262e$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $dea356723133262e$export$f0d8293634f88842)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $a628a0d08e641a81$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _vB = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _vC = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _tempA = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _tempB = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _tempC = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _morphA = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _morphB = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const _morphC = new (0, $dea356723133262e$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $dea356723133262e$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $dea356723133262e$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $a628a0d08e641a81$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.");
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute("position");
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
// Creates a new, non-indexed geometry with smooth normals everywhere except faces that meet at
// an angle greater than the crease angle.
function $a628a0d08e641a81$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vertors
    const verts = [
        new (0, $dea356723133262e$export$64b5c384219d3699)(),
        new (0, $dea356723133262e$export$64b5c384219d3699)(),
        new (0, $dea356723133262e$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const tempVec2 = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const tempNorm = new (0, $dea356723133262e$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $dea356723133262e$export$64b5c384219d3699)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.toNonIndexed();
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $dea356723133262e$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $dea356723133262e$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}
function $a628a0d08e641a81$export$728c051ccdf8a702(geometries, useGroups = false) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferGeometries() has been renamed to mergeGeometries()."); // @deprecated, r151
    return $a628a0d08e641a81$export$f06f69b3bf41d25c(geometries, useGroups);
}
function $a628a0d08e641a81$export$c4eef4c1c9d34ea9(attributes) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferAttributes() has been renamed to mergeAttributes()."); // @deprecated, r151
    return $a628a0d08e641a81$export$9f98db6234c4bd78(attributes);
}


class $119b3fcaa751bd22$export$aa93f11e7884f0f4 extends (0, $dea356723133262e$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $119b3fcaa751bd22$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") resourcePath = this.path;
        else resourcePath = (0, $dea356723133262e$export$b5d2dc08d867e41a).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $dea356723133262e$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_BINARY_GLTF] = new $119b3fcaa751bd22$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $119b3fcaa751bd22$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $119b3fcaa751bd22$var$GLTFMaterialsUnlitExtension();
                    break;
                case $119b3fcaa751bd22$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $119b3fcaa751bd22$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $119b3fcaa751bd22$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $119b3fcaa751bd22$var$GLTFTextureTransformExtension();
                    break;
                case $119b3fcaa751bd22$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $119b3fcaa751bd22$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $119b3fcaa751bd22$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $119b3fcaa751bd22$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $119b3fcaa751bd22$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $dea356723133262e$export$892596cec99bc70e)(0xffffff);
        if (lightDef.color !== undefined) color.fromArray(lightDef.color);
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $dea356723133262e$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $dea356723133262e$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $dea356723133262e$export$81495cbb73897362)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $119b3fcaa751bd22$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $119b3fcaa751bd22$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $dea356723133262e$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $dea356723133262e$export$892596cec99bc70e)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $dea356723133262e$export$561f394b24edfcaa)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $119b3fcaa751bd22$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $119b3fcaa751bd22$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $dea356723133262e$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $119b3fcaa751bd22$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $119b3fcaa751bd22$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $dea356723133262e$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) materialParams.sheenColor.fromArray(extension.sheenColorFactor);
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, (0, $dea356723133262e$export$561f394b24edfcaa)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $119b3fcaa751bd22$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $119b3fcaa751bd22$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $dea356723133262e$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $119b3fcaa751bd22$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $119b3fcaa751bd22$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $dea356723133262e$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $dea356723133262e$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, (0, $dea356723133262e$export$561f394b24edfcaa)));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $119b3fcaa751bd22$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $119b3fcaa751bd22$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $119b3fcaa751bd22$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $119b3fcaa751bd22$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $119b3fcaa751bd22$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $dea356723133262e$export$2ae72fc923e5eb5)();
                const p = new (0, $dea356723133262e$export$64b5c384219d3699)();
                const q = new (0, $dea356723133262e$export$23d6a54f0bbc85a3)();
                const s = new (0, $dea356723133262e$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $dea356723133262e$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes)if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                // Just in case
                (0, $dea356723133262e$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $119b3fcaa751bd22$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $119b3fcaa751bd22$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2.0) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $119b3fcaa751bd22$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $119b3fcaa751bd22$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $119b3fcaa751bd22$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $119b3fcaa751bd22$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $119b3fcaa751bd22$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $119b3fcaa751bd22$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $119b3fcaa751bd22$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $119b3fcaa751bd22$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $119b3fcaa751bd22$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $119b3fcaa751bd22$var$GLTFCubicSplineInterpolant extends (0, $dea356723133262e$export$b558baee9c0f72d3) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $119b3fcaa751bd22$var$_q = new (0, $dea356723133262e$export$23d6a54f0bbc85a3)();
class $119b3fcaa751bd22$var$GLTFCubicSplineQuaternionInterpolant extends $119b3fcaa751bd22$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $119b3fcaa751bd22$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $119b3fcaa751bd22$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $119b3fcaa751bd22$var$WEBGL_FILTERS = {
    9728: (0, $dea356723133262e$export$727aa5ec3fe39bf0),
    9729: (0, $dea356723133262e$export$8a72f490b25c56c8),
    9984: (0, $dea356723133262e$export$d129e38cf6feaa8c),
    9985: (0, $dea356723133262e$export$19a719f377145a13),
    9986: (0, $dea356723133262e$export$d2327c1afe5bfdf2),
    9987: (0, $dea356723133262e$export$5d8599b6a933fb1b)
};
const $119b3fcaa751bd22$var$WEBGL_WRAPPINGS = {
    33071: (0, $dea356723133262e$export$9d9334239a5a5e06),
    33648: (0, $dea356723133262e$export$c7e7c00b14f51a4f),
    10497: (0, $dea356723133262e$export$533346c8e8dac0f5)
};
const $119b3fcaa751bd22$var$WEBGL_TYPE_SIZES = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
};
const $119b3fcaa751bd22$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $119b3fcaa751bd22$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $119b3fcaa751bd22$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $dea356723133262e$export$30fac1aace31cf4d),
    STEP: (0, $dea356723133262e$export$995b32462a65e855)
};
const $119b3fcaa751bd22$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $119b3fcaa751bd22$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === undefined) cache["DefaultMaterial"] = new (0, $dea356723133262e$export$f2980790215acccd)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $dea356723133262e$export$2ede184fc2998901)
    });
    return cache["DefaultMaterial"];
}
function $119b3fcaa751bd22$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $119b3fcaa751bd22$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $119b3fcaa751bd22$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $119b3fcaa751bd22$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $119b3fcaa751bd22$var$createPrimitiveKey(primitiveDef) {
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    let geometryKey;
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $119b3fcaa751bd22$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $119b3fcaa751bd22$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    return geometryKey;
}
function $119b3fcaa751bd22$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $119b3fcaa751bd22$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $119b3fcaa751bd22$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $119b3fcaa751bd22$var$_identityMatrix = new (0, $dea356723133262e$export$2ae72fc923e5eb5)();
/* GLTF PARSER */ class $119b3fcaa751bd22$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $119b3fcaa751bd22$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $dea356723133262e$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $dea356723133262e$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $dea356723133262e$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $119b3fcaa751bd22$var$addUnknownExtensionsToUserData(extensions, result, json);
            $119b3fcaa751bd22$var$assignExtrasToUserData(result, json);
            Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $dea356723133262e$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $119b3fcaa751bd22$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $dea356723133262e$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $119b3fcaa751bd22$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $dea356723133262e$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $dea356723133262e$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $dea356723133262e$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $119b3fcaa751bd22$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $dea356723133262e$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $119b3fcaa751bd22$var$WEBGL_FILTERS[sampler.magFilter] || (0, $dea356723133262e$export$8a72f490b25c56c8);
            texture.minFilter = $119b3fcaa751bd22$var$WEBGL_FILTERS[sampler.minFilter] || (0, $dea356723133262e$export$5d8599b6a933fb1b);
            texture.wrapS = $119b3fcaa751bd22$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $dea356723133262e$export$533346c8e8dac0f5);
            texture.wrapT = $119b3fcaa751bd22$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $dea356723133262e$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $dea356723133262e$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $dea356723133262e$export$b5d2dc08d867e41a).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $119b3fcaa751bd22$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $dea356723133262e$export$a178c45366ce5d6b)();
                (0, $dea356723133262e$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $dea356723133262e$export$fbaaa33907730a0c)();
                (0, $dea356723133262e$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $dea356723133262e$export$f2980790215acccd;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $dea356723133262e$export$892596cec99bc70e)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $dea356723133262e$export$561f394b24edfcaa)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $dea356723133262e$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $119b3fcaa751bd22$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $119b3fcaa751bd22$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $119b3fcaa751bd22$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $dea356723133262e$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $dea356723133262e$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $dea356723133262e$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $dea356723133262e$export$55cbcc9b622fe1f5)) materialParams.emissive = new (0, $dea356723133262e$export$892596cec99bc70e)().fromArray(materialDef.emissiveFactor);
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $dea356723133262e$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, (0, $dea356723133262e$export$561f394b24edfcaa)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $119b3fcaa751bd22$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $119b3fcaa751bd22$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $dea356723133262e$export$7bf70fcf9f891893).sanitizeNodeName(originalName || "");
        let name = sanitizedName;
        for(let i = 1; this.nodeNamesUsed[name]; ++i)name = sanitizedName + "_" + i;
        this.nodeNamesUsed[name] = true;
        return name;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $119b3fcaa751bd22$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $119b3fcaa751bd22$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$119b3fcaa751bd22$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $119b3fcaa751bd22$var$addPrimitiveAttributes(new (0, $dea356723133262e$export$b7be63a67df8959)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $119b3fcaa751bd22$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $dea356723133262e$export$b303577035157ecf)(geometry, material) : new (0, $dea356723133262e$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $a628a0d08e641a81$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $dea356723133262e$export$b23a071aa286eb29));
                    else if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $a628a0d08e641a81$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $dea356723133262e$export$f0d8293634f88842));
                } else if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $dea356723133262e$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $dea356723133262e$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $dea356723133262e$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $119b3fcaa751bd22$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $dea356723133262e$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $119b3fcaa751bd22$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $119b3fcaa751bd22$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $119b3fcaa751bd22$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) return meshes[0];
            const group = new (0, $dea356723133262e$export$eb2fcfdbd7ba97d4)();
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $dea356723133262e$export$74e4ae24825f68d7)((0, $dea356723133262e$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $dea356723133262e$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $119b3fcaa751bd22$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $dea356723133262e$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $dea356723133262e$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                node.updateMatrix();
                let TypedKeyframeTrack;
                switch($119b3fcaa751bd22$var$PATH_PROPERTIES[target.path]){
                    case $119b3fcaa751bd22$var$PATH_PROPERTIES.weights:
                        TypedKeyframeTrack = (0, $dea356723133262e$export$d45f0d1a4d9a9314);
                        break;
                    case $119b3fcaa751bd22$var$PATH_PROPERTIES.rotation:
                        TypedKeyframeTrack = (0, $dea356723133262e$export$b8043f12b5aafbd7);
                        break;
                    case $119b3fcaa751bd22$var$PATH_PROPERTIES.position:
                    case $119b3fcaa751bd22$var$PATH_PROPERTIES.scale:
                    default:
                        TypedKeyframeTrack = (0, $dea356723133262e$export$5ce2dcb4cc9f2bff);
                        break;
                }
                const targetName = node.name ? node.name : node.uuid;
                const interpolation = sampler.interpolation !== undefined ? $119b3fcaa751bd22$var$INTERPOLATION[sampler.interpolation] : (0, $dea356723133262e$export$30fac1aace31cf4d);
                const targetNames = [];
                if ($119b3fcaa751bd22$var$PATH_PROPERTIES[target.path] === $119b3fcaa751bd22$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
                    if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
                });
                else targetNames.push(targetName);
                let outputArray = outputAccessor.array;
                if (outputAccessor.normalized) {
                    const scale = $119b3fcaa751bd22$var$getNormalizedComponentScale(outputArray.constructor);
                    const scaled = new Float32Array(outputArray.length);
                    for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
                    outputArray = scaled;
                }
                for(let j = 0, jl = targetNames.length; j < jl; j++){
                    const track = new TypedKeyframeTrack(targetNames[j] + "." + $119b3fcaa751bd22$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
                    // Override interpolation with custom factory method.
                    if (sampler.interpolation === "CUBICSPLINE") {
                        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
                            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
                            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
                            // must be divided by three to get the interpolant's sampleSize argument.
                            const interpolantType = this instanceof (0, $dea356723133262e$export$b8043f12b5aafbd7) ? $119b3fcaa751bd22$var$GLTFCubicSplineQuaternionInterpolant : $119b3fcaa751bd22$var$GLTFCubicSplineInterpolant;
                            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
                        };
                        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
                        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
                    }
                    tracks.push(track);
                }
            }
            return new (0, $dea356723133262e$export$d942c706bf23829c)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $119b3fcaa751bd22$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $dea356723133262e$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $dea356723133262e$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $dea356723133262e$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $119b3fcaa751bd22$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $119b3fcaa751bd22$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $dea356723133262e$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $dea356723133262e$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $119b3fcaa751bd22$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $119b3fcaa751bd22$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $dea356723133262e$export$a2d8b23205c25948) || key instanceof (0, $dea356723133262e$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $119b3fcaa751bd22$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $dea356723133262e$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $dea356723133262e$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $dea356723133262e$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $119b3fcaa751bd22$var$getNormalizedComponentScale($119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $dea356723133262e$export$64b5c384219d3699)();
        const vector = new (0, $dea356723133262e$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $119b3fcaa751bd22$var$getNormalizedComponentScale($119b3fcaa751bd22$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $dea356723133262e$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $119b3fcaa751bd22$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $119b3fcaa751bd22$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    $119b3fcaa751bd22$var$assignExtrasToUserData(geometry, primitiveDef);
    $119b3fcaa751bd22$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $119b3fcaa751bd22$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}



var $lcQJb = parcelRequire("lcQJb");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $lcQJb = parcelRequire("lcQJb");
var $01a3cc7740e85d32$var$_win, $01a3cc7740e85d32$var$_doc, $01a3cc7740e85d32$var$_docElement, $01a3cc7740e85d32$var$_pluginInitted, $01a3cc7740e85d32$var$_tempDiv, $01a3cc7740e85d32$var$_tempDivStyler, $01a3cc7740e85d32$var$_recentSetterPlugin, $01a3cc7740e85d32$var$_reverting, $01a3cc7740e85d32$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $01a3cc7740e85d32$var$_transformProps = {}, $01a3cc7740e85d32$var$_RAD2DEG = 180 / Math.PI, $01a3cc7740e85d32$var$_DEG2RAD = Math.PI / 180, $01a3cc7740e85d32$var$_atan2 = Math.atan2, $01a3cc7740e85d32$var$_bigNum = 1e8, $01a3cc7740e85d32$var$_capsExp = /([A-Z])/g, $01a3cc7740e85d32$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $01a3cc7740e85d32$var$_complexExp = /[\s,\(]\S/, $01a3cc7740e85d32$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $01a3cc7740e85d32$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $01a3cc7740e85d32$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $01a3cc7740e85d32$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$01a3cc7740e85d32$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $01a3cc7740e85d32$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $01a3cc7740e85d32$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $01a3cc7740e85d32$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $01a3cc7740e85d32$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $01a3cc7740e85d32$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $01a3cc7740e85d32$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $01a3cc7740e85d32$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $01a3cc7740e85d32$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $01a3cc7740e85d32$var$_transformProp = "transform", $01a3cc7740e85d32$var$_transformOriginProp = $01a3cc7740e85d32$var$_transformProp + "Origin", $01a3cc7740e85d32$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $01a3cc7740e85d32$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $01a3cc7740e85d32$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $01a3cc7740e85d32$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $01a3cc7740e85d32$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $01a3cc7740e85d32$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $01a3cc7740e85d32$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($01a3cc7740e85d32$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($01a3cc7740e85d32$var$_transformOriginProp, isNotCSS, "");
        }
        property = $01a3cc7740e85d32$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $01a3cc7740e85d32$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $01a3cc7740e85d32$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($01a3cc7740e85d32$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $01a3cc7740e85d32$var$_reverting();
        if ((!i || !i.isStart) && !style[$01a3cc7740e85d32$var$_transformProp]) {
            $01a3cc7740e85d32$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$01a3cc7740e85d32$var$_transformOriginProp]) {
                style[$01a3cc7740e85d32$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $01a3cc7740e85d32$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $01a3cc7740e85d32$var$_revertStyle,
        save: $01a3cc7740e85d32$var$_saveStyle
    };
    target._gsap || (0, $lcQJb.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $01a3cc7740e85d32$var$_supports3D, $01a3cc7740e85d32$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $01a3cc7740e85d32$var$_doc.createElementNS ? $01a3cc7740e85d32$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $01a3cc7740e85d32$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $01a3cc7740e85d32$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $01a3cc7740e85d32$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($01a3cc7740e85d32$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $01a3cc7740e85d32$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $01a3cc7740e85d32$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $01a3cc7740e85d32$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $01a3cc7740e85d32$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($01a3cc7740e85d32$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $01a3cc7740e85d32$var$_prefixes[i] : "") + property;
}, $01a3cc7740e85d32$var$_initCore = function _initCore() {
    if ($01a3cc7740e85d32$var$_windowExists() && window.document) {
        $01a3cc7740e85d32$var$_win = window;
        $01a3cc7740e85d32$var$_doc = $01a3cc7740e85d32$var$_win.document;
        $01a3cc7740e85d32$var$_docElement = $01a3cc7740e85d32$var$_doc.documentElement;
        $01a3cc7740e85d32$var$_tempDiv = $01a3cc7740e85d32$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $01a3cc7740e85d32$var$_tempDivStyler = $01a3cc7740e85d32$export$a232bb0480ae674a("div");
        $01a3cc7740e85d32$var$_transformProp = $01a3cc7740e85d32$export$8cbef5dd49a09c8b($01a3cc7740e85d32$var$_transformProp);
        $01a3cc7740e85d32$var$_transformOriginProp = $01a3cc7740e85d32$var$_transformProp + "Origin";
        $01a3cc7740e85d32$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $01a3cc7740e85d32$var$_supports3D = !!$01a3cc7740e85d32$export$8cbef5dd49a09c8b("perspective");
        $01a3cc7740e85d32$var$_reverting = (0, $lcQJb.gsap).core.reverting;
        $01a3cc7740e85d32$var$_pluginInitted = 1;
    }
}, $01a3cc7740e85d32$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $01a3cc7740e85d32$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $01a3cc7740e85d32$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $01a3cc7740e85d32$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $01a3cc7740e85d32$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $01a3cc7740e85d32$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $01a3cc7740e85d32$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $01a3cc7740e85d32$var$_getBBoxHack || (bounds = $01a3cc7740e85d32$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$01a3cc7740e85d32$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$01a3cc7740e85d32$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $01a3cc7740e85d32$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $01a3cc7740e85d32$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$01a3cc7740e85d32$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $01a3cc7740e85d32$var$_transformProps && property !== $01a3cc7740e85d32$var$_transformOriginProp) property = $01a3cc7740e85d32$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($01a3cc7740e85d32$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $01a3cc7740e85d32$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $lcQJb.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $01a3cc7740e85d32$var$_renderNonTweeningValueOnlyAtEnd : $01a3cc7740e85d32$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $01a3cc7740e85d32$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $01a3cc7740e85d32$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$01a3cc7740e85d32$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $01a3cc7740e85d32$var$_tempDiv.style, horizontal = $01a3cc7740e85d32$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $01a3cc7740e85d32$var$_nonConvertibleUnits[unit] || $01a3cc7740e85d32$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $01a3cc7740e85d32$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($01a3cc7740e85d32$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $lcQJb._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $01a3cc7740e85d32$var$_doc || !parent.appendChild) parent = $01a3cc7740e85d32$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $lcQJb._ticker).time && !cache.uncache) return (0, $lcQJb._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $01a3cc7740e85d32$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$01a3cc7740e85d32$var$_nonStandardLayouts[$01a3cc7740e85d32$var$_getComputedProperty(parent, "display")] && (style.position = $01a3cc7740e85d32$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($01a3cc7740e85d32$var$_tempDiv);
            px = $01a3cc7740e85d32$var$_tempDiv[measureProperty];
            parent.removeChild($01a3cc7740e85d32$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $lcQJb._getCache)(parent);
            cache.time = (0, $lcQJb._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $lcQJb._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $01a3cc7740e85d32$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $01a3cc7740e85d32$var$_pluginInitted || $01a3cc7740e85d32$var$_initCore();
    if (property in $01a3cc7740e85d32$var$_propertyAliases && property !== "transform") {
        property = $01a3cc7740e85d32$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($01a3cc7740e85d32$var$_transformProps[property] && property !== "transform") {
        value = $01a3cc7740e85d32$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $01a3cc7740e85d32$var$_firstTwoOnly($01a3cc7740e85d32$var$_getComputedProperty(target, $01a3cc7740e85d32$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $01a3cc7740e85d32$var$_specialProps[property] && $01a3cc7740e85d32$var$_specialProps[property](target, property, unit) || $01a3cc7740e85d32$var$_getComputedProperty(target, property) || (0, $lcQJb._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $01a3cc7740e85d32$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $01a3cc7740e85d32$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $01a3cc7740e85d32$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $01a3cc7740e85d32$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $01a3cc7740e85d32$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $lcQJb.PropTween)(this._pt, target.style, prop, 0, 1, (0, $lcQJb._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $01a3cc7740e85d32$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $01a3cc7740e85d32$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $lcQJb._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $lcQJb._numWithUnitExp)) || [];
    endValues = end.match((0, $lcQJb._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $lcQJb._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $lcQJb._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $lcQJb._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $lcQJb._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $01a3cc7740e85d32$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $01a3cc7740e85d32$var$_renderNonTweeningValueOnlyAtEnd : $01a3cc7740e85d32$var$_renderNonTweeningValue;
    (0, $lcQJb._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $01a3cc7740e85d32$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $01a3cc7740e85d32$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $01a3cc7740e85d32$var$_keywordToPercent[x] || x;
    split[1] = $01a3cc7740e85d32$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $01a3cc7740e85d32$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($01a3cc7740e85d32$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $01a3cc7740e85d32$var$_transformOriginProp : $01a3cc7740e85d32$var$_transformProp;
                }
                $01a3cc7740e85d32$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $01a3cc7740e85d32$var$_removeProperty(target, $01a3cc7740e85d32$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $01a3cc7740e85d32$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $01a3cc7740e85d32$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$01a3cc7740e85d32$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $lcQJb.PropTween)(plugin._pt, target, property, 0, 0, $01a3cc7740e85d32$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $01a3cc7740e85d32$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $01a3cc7740e85d32$var$_rotationalProperties = {}, $01a3cc7740e85d32$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $01a3cc7740e85d32$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $01a3cc7740e85d32$var$_getComputedProperty(target, $01a3cc7740e85d32$var$_transformProp);
    return $01a3cc7740e85d32$var$_isNullTransform(matrixString) ? $01a3cc7740e85d32$var$_identity2DMatrix : matrixString.substr(7).match((0, $lcQJb._numExp)).map((0, $lcQJb._round));
}, $01a3cc7740e85d32$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $lcQJb._getCache)(target), style = target.style, matrix = $01a3cc7740e85d32$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $01a3cc7740e85d32$var$_identity2DMatrix : matrix;
    } else if (matrix === $01a3cc7740e85d32$var$_identity2DMatrix && !target.offsetParent && target !== $01a3cc7740e85d32$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $01a3cc7740e85d32$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $01a3cc7740e85d32$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $01a3cc7740e85d32$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $01a3cc7740e85d32$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $01a3cc7740e85d32$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $01a3cc7740e85d32$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $01a3cc7740e85d32$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $01a3cc7740e85d32$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$01a3cc7740e85d32$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $01a3cc7740e85d32$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $01a3cc7740e85d32$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $01a3cc7740e85d32$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $01a3cc7740e85d32$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $01a3cc7740e85d32$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $lcQJb.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $01a3cc7740e85d32$var$_getComputedProperty(target, $01a3cc7740e85d32$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $01a3cc7740e85d32$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$01a3cc7740e85d32$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$01a3cc7740e85d32$var$_transformProp] !== "none" ? cs[$01a3cc7740e85d32$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $01a3cc7740e85d32$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $01a3cc7740e85d32$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $01a3cc7740e85d32$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $01a3cc7740e85d32$var$_atan2(b, a) * $01a3cc7740e85d32$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $01a3cc7740e85d32$var$_atan2(c, d) * $01a3cc7740e85d32$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $01a3cc7740e85d32$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $01a3cc7740e85d32$var$_atan2(a32, a33);
            rotationX = angle * $01a3cc7740e85d32$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $01a3cc7740e85d32$var$_atan2(-c, a33);
            rotationY = angle * $01a3cc7740e85d32$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $01a3cc7740e85d32$var$_atan2(b, a);
            rotation = angle * $01a3cc7740e85d32$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $lcQJb._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $lcQJb._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $01a3cc7740e85d32$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $01a3cc7740e85d32$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$01a3cc7740e85d32$var$_isNullTransform($01a3cc7740e85d32$var$_getComputedProperty(target, $01a3cc7740e85d32$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $lcQJb._round)(scaleX);
    cache.scaleY = (0, $lcQJb._round)(scaleY);
    cache.rotation = (0, $lcQJb._round)(rotation) + deg;
    cache.rotationX = (0, $lcQJb._round)(rotationX) + deg;
    cache.rotationY = (0, $lcQJb._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$01a3cc7740e85d32$var$_transformOriginProp] = $01a3cc7740e85d32$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $lcQJb._config).force3D;
    cache.renderTransform = cache.svg ? $01a3cc7740e85d32$var$_renderSVGTransforms : $01a3cc7740e85d32$var$_supports3D ? $01a3cc7740e85d32$var$_renderCSSTransforms : $01a3cc7740e85d32$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $01a3cc7740e85d32$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$01a3cc7740e85d32$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $lcQJb.getUnit)(start);
    return (0, $lcQJb._round)(parseFloat(start) + parseFloat($01a3cc7740e85d32$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $01a3cc7740e85d32$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $01a3cc7740e85d32$var$_renderCSSTransforms(ratio, cache);
}, $01a3cc7740e85d32$var$_zeroDeg = "0deg", $01a3cc7740e85d32$var$_zeroPx = "0px", $01a3cc7740e85d32$var$_endParenthesis = ") ", $01a3cc7740e85d32$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $01a3cc7740e85d32$var$_zeroDeg || rotationY !== $01a3cc7740e85d32$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $01a3cc7740e85d32$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $01a3cc7740e85d32$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $01a3cc7740e85d32$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $01a3cc7740e85d32$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $01a3cc7740e85d32$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $01a3cc7740e85d32$var$_zeroPx) transforms += "perspective(" + transformPerspective + $01a3cc7740e85d32$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $01a3cc7740e85d32$var$_zeroPx || y !== $01a3cc7740e85d32$var$_zeroPx || z !== $01a3cc7740e85d32$var$_zeroPx) transforms += z !== $01a3cc7740e85d32$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $01a3cc7740e85d32$var$_endParenthesis;
    if (rotation !== $01a3cc7740e85d32$var$_zeroDeg) transforms += "rotate(" + rotation + $01a3cc7740e85d32$var$_endParenthesis;
    if (rotationY !== $01a3cc7740e85d32$var$_zeroDeg) transforms += "rotateY(" + rotationY + $01a3cc7740e85d32$var$_endParenthesis;
    if (rotationX !== $01a3cc7740e85d32$var$_zeroDeg) transforms += "rotateX(" + rotationX + $01a3cc7740e85d32$var$_endParenthesis;
    if (skewX !== $01a3cc7740e85d32$var$_zeroDeg || skewY !== $01a3cc7740e85d32$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $01a3cc7740e85d32$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $01a3cc7740e85d32$var$_endParenthesis;
    target.style[$01a3cc7740e85d32$var$_transformProp] = transforms || "translate(0, 0)";
}, $01a3cc7740e85d32$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $01a3cc7740e85d32$var$_DEG2RAD;
        skewX *= $01a3cc7740e85d32$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $01a3cc7740e85d32$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $lcQJb._round)(a11);
        a21 = (0, $lcQJb._round)(a21);
        a12 = (0, $lcQJb._round)(a12);
        a22 = (0, $lcQJb._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $01a3cc7740e85d32$var$_convertToUnit(target, "x", x, "px");
        ty = $01a3cc7740e85d32$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $lcQJb._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $lcQJb._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $lcQJb._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $lcQJb._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$01a3cc7740e85d32$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $01a3cc7740e85d32$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $lcQJb._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $01a3cc7740e85d32$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $01a3cc7740e85d32$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $01a3cc7740e85d32$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $lcQJb.PropTween)(plugin._pt, target, property, startNum, change, $01a3cc7740e85d32$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $01a3cc7740e85d32$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $01a3cc7740e85d32$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $01a3cc7740e85d32$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$01a3cc7740e85d32$var$_transformProp] = transforms;
        endCache = $01a3cc7740e85d32$var$_parseTransform(target, 1);
        $01a3cc7740e85d32$var$_removeProperty(target, $01a3cc7740e85d32$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$01a3cc7740e85d32$var$_transformProp];
        style[$01a3cc7740e85d32$var$_transformProp] = transforms;
        endCache = $01a3cc7740e85d32$var$_parseTransform(target, 1);
        style[$01a3cc7740e85d32$var$_transformProp] = startValue;
    }
    for(p in $01a3cc7740e85d32$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $lcQJb.getUnit)(startValue);
            endUnit = (0, $lcQJb.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $01a3cc7740e85d32$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $lcQJb.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $01a3cc7740e85d32$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $01a3cc7740e85d32$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $lcQJb._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $01a3cc7740e85d32$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $01a3cc7740e85d32$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $01a3cc7740e85d32$export$855822f522f18eef = {
    name: "css",
    register: $01a3cc7740e85d32$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $01a3cc7740e85d32$var$_pluginInitted || $01a3cc7740e85d32$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $01a3cc7740e85d32$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $lcQJb._plugins)[p] && (0, $lcQJb._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $01a3cc7740e85d32$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $lcQJb._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $lcQJb._colorExp).lastIndex = 0;
                if (!(0, $lcQJb._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $lcQJb.getUnit)(startValue);
                    endUnit = (0, $lcQJb.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $01a3cc7740e85d32$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $lcQJb._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $lcQJb._replaceRandom)(startValue));
                    (0, $lcQJb.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $lcQJb._config).units[p] || (0, $lcQJb.getUnit)($01a3cc7740e85d32$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $01a3cc7740e85d32$var$_get(target, p)); // can't work with relative values
                } else startValue = $01a3cc7740e85d32$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $01a3cc7740e85d32$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $01a3cc7740e85d32$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $01a3cc7740e85d32$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $01a3cc7740e85d32$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $01a3cc7740e85d32$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $01a3cc7740e85d32$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $lcQJb.PropTween)(this._pt, style, $01a3cc7740e85d32$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $lcQJb.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $lcQJb._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $01a3cc7740e85d32$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($01a3cc7740e85d32$var$_transformOriginProp, 0, style[$01a3cc7740e85d32$var$_transformOriginProp]);
                        endValue = $01a3cc7740e85d32$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $01a3cc7740e85d32$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $01a3cc7740e85d32$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $01a3cc7740e85d32$var$_addNonTweeningPT(this, style, p, $01a3cc7740e85d32$var$_firstTwoOnly(startValue), $01a3cc7740e85d32$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $01a3cc7740e85d32$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $01a3cc7740e85d32$var$_rotationalProperties) {
                        $01a3cc7740e85d32$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $lcQJb._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $01a3cc7740e85d32$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $01a3cc7740e85d32$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $01a3cc7740e85d32$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$01a3cc7740e85d32$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $lcQJb.getUnit)(endValue) || (p in (0, $lcQJb._config).units ? (0, $lcQJb._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $01a3cc7740e85d32$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $lcQJb.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $lcQJb._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $01a3cc7740e85d32$var$_renderRoundedCSSProp : $01a3cc7740e85d32$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $01a3cc7740e85d32$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $lcQJb._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $01a3cc7740e85d32$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $lcQJb._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$01a3cc7740e85d32$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $01a3cc7740e85d32$var$_get,
    aliases: $01a3cc7740e85d32$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $01a3cc7740e85d32$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $01a3cc7740e85d32$var$_transformProps && property !== $01a3cc7740e85d32$var$_transformOriginProp && (target._gsap.x || $01a3cc7740e85d32$var$_get(target, "x")) ? plugin && $01a3cc7740e85d32$var$_recentSetterPlugin === plugin ? property === "scale" ? $01a3cc7740e85d32$var$_setterScale : $01a3cc7740e85d32$var$_setterTransform : ($01a3cc7740e85d32$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $01a3cc7740e85d32$var$_setterScaleWithRender : $01a3cc7740e85d32$var$_setterTransformWithRender) : target.style && !(0, $lcQJb._isUndefined)(target.style[property]) ? $01a3cc7740e85d32$var$_setterCSSStyle : ~property.indexOf("-") ? $01a3cc7740e85d32$var$_setterCSSProp : (0, $lcQJb._getSetter)(target, property);
    },
    core: {
        _removeProperty: $01a3cc7740e85d32$var$_removeProperty,
        _getMatrix: $01a3cc7740e85d32$var$_getMatrix
    }
};
(0, $lcQJb.gsap).utils.checkPrefix = $01a3cc7740e85d32$export$8cbef5dd49a09c8b;
(0, $lcQJb.gsap).core.getStyleSaver = $01a3cc7740e85d32$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $lcQJb._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $01a3cc7740e85d32$var$_transformProps[name] = 1;
    });
    (0, $lcQJb._forEachName)(rotation, function(name) {
        (0, $lcQJb._config).units[name] = "deg";
        $01a3cc7740e85d32$var$_rotationalProperties[name] = 1;
    });
    $01a3cc7740e85d32$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $lcQJb._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $01a3cc7740e85d32$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $lcQJb._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $lcQJb._config).units[name] = "px";
});
(0, $lcQJb.gsap).registerPlugin($01a3cc7740e85d32$export$855822f522f18eef);


var $50c26a34528ecf35$export$99ee26438460406a = (0, $lcQJb.gsap).registerPlugin((0, $01a3cc7740e85d32$export$855822f522f18eef)) || (0, $lcQJb.gsap), // to protect from tree shaking
$50c26a34528ecf35$export$7b23975ad686bf91 = $50c26a34528ecf35$export$99ee26438460406a.core.Tween;


const $92dac20c890c76b1$var$linkToSummer = "joxi/summer-promo/sound";
const $92dac20c890c76b1$export$5244a89f9e090d3e = {
    missClick: `${$92dac20c890c76b1$var$linkToSummer}/click_miss.mp3`,
    collectCoin: `${$92dac20c890c76b1$var$linkToSummer}/coin_click.mp3`,
    coinAnimation: `${$92dac20c890c76b1$var$linkToSummer}/coin_flying.mp3`,
    allCollected: `${$92dac20c890c76b1$var$linkToSummer}/all_coin.mp3`,
    gameStart: `${$92dac20c890c76b1$var$linkToSummer}/start_game.mp3`,
    gameBackground: `${$92dac20c890c76b1$var$linkToSummer}/background.mp3`,
    summerListOnload: `${$92dac20c890c76b1$var$linkToSummer}/start_map.mp3`,
    summerListBtns: `${$92dac20c890c76b1$var$linkToSummer}/purple_button.mp3`,
    summerListScroll: `${$92dac20c890c76b1$var$linkToSummer}/scroll_islands.mp3`,
    summerListPlay: `${$92dac20c890c76b1$var$linkToSummer}/green-button.mp3`
};



(function() {
    app.directive("summerHolidayScene", controller);
    controller.$inject = [
        "soundPlayer",
        "config"
    ];
    function controller(soundPlayer, _config) {
        function link(scope, element, attrs) {
            scope.summerLoader = false;
            const env = _config.production ? "" : _config.domain;
            const modelHighlightUrl = env + "/joxi/summer-promo/arrow.glb";
            const coinModelUrl = env + "/joxi/summer-promo/coin.glb";
            const renderer = new $dea356723133262e$export$f6cc00ef28d7cf97({
                antialias: true,
                alpha: true
            });
            const raycaster = new $dea356723133262e$export$8b7aaceff00bd2f();
            const mouse = new $dea356723133262e$export$c977b3e384af9ae1();
            const canvasId = "summerCanvas";
            const scene = new $dea356723133262e$export$38af1803e3442a7f();
            const camera = new $dea356723133262e$export$74e4ae24825f68d7(45, window.innerWidth / window.innerHeight, 0.1, 1000);
            const controls = new (0, $d56bb5ed7dee50b9$export$8ff7788029dfdf52)(camera, renderer.domElement);
            const dirLight = new $dea356723133262e$export$3fea33cc9972c868(0xffffff, 1);
            const gltfLoader = new (0, $119b3fcaa751bd22$export$aa93f11e7884f0f4)();
            const gameTime = 60000;
            const timeClickCoin = 3000;
            const timeCoinRemove = 500;
            let arrOfMesh = [];
            controls.enablePan = false;
            (0, $50c26a34528ecf35$export$99ee26438460406a).to(camera.position, {
                y: 11,
                x: 20,
                z: 20,
                duration: 3
            });
            (0, $50c26a34528ecf35$export$99ee26438460406a).fromTo(camera.rotation, {
                y: 0
            }, {
                y: 0.73,
                duration: 3
            });
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(element[0].clientWidth, element[0].clientHeight);
            renderer.outputEncoding = $dea356723133262e$export$f32388edbb32674;
            renderer.domElement.id = canvasId;
            element[0].appendChild(renderer.domElement);
            renderer.setClearColor(0x000000, 0);
            camera.position.set(600, 300, 600);
            scene.add(new $dea356723133262e$export$8d474f55edbb9624(0xffffff, 0x000000, 0.4));
            dirLight.position.set(300, 150, 300);
            scene.add(dirLight);
            scope.timer = 0;
            controls.target.set(0, 1, 0);
            controls.update();
            controls.minDistance = 15;
            controls.maxDistance = 60;
            controls.minPolarAngle = 0.4;
            controls.maxPolarAngle = 1.6;
            controls.minAzimuthAngle = Math.PI / 100;
            controls.maxAzimuthAngle = Math.PI / 2;
            const arrowModels = [];
            const coinModels = [];
            let showArrowAnimation;
            const randomArrowIndex = (arrayLength)=>{
                return Math.floor(Math.random() * arrayLength);
            };
            const arrowAnimation = (arrow)=>{
                (0, $50c26a34528ecf35$export$99ee26438460406a).to(arrow.position, {
                    z: 2,
                    duration: 1,
                    repeat: -1,
                    yoyo: true
                });
            };
            const animateRandomArrow = (arrayOfArrows)=>{
                const arrayRandomIndex = randomArrowIndex(arrayOfArrows.length);
                const randomArrowObject = arrayOfArrows[arrayRandomIndex];
                randomArrowObject.visible = true;
                arrowAnimation(randomArrowObject);
            };
            const buildClickableMesh = (copyScene)=>{
                const geometry = new $dea356723133262e$export$1b417fc3b307a251(1.5, 1.5, 1.5);
                const material = new $dea356723133262e$export$55cbcc9b622fe1f5({
                    transparent: true,
                    opacity: 0
                });
                const mesh = new $dea356723133262e$export$e176487c05830cc5(geometry, material);
                mesh.callback = objectClickHandler;
                mesh.userData.parent = copyScene;
                mesh.position.set(...copyScene.position);
                scene.add(mesh);
                arrOfMesh.push(mesh);
            };
            if (scope?.todayBonus && scope?.todayBonus.dayStatus === "today") {
                const coordinatesOfCoins = scope?.todayBonus?.coordinates;
                const cityModelUrl = env + `/joxi/summer-promo/towns/${scope?.todayBonus.name}.glb`;
                scope.summerLoader = true;
                gltfLoader.load(cityModelUrl, function(gltf) {
                    scope.summerLoader = false;
                    const model = gltf.scene;
                    scene.add(model);
                    animate();
                    scope.timer = gameTime;
                    soundPlayer.playTrack((0, $92dac20c890c76b1$export$5244a89f9e090d3e).gameStart);
                    soundPlayer.playTrack((0, $92dac20c890c76b1$export$5244a89f9e090d3e).gameBackground);
                    soundPlayer[(0, $92dac20c890c76b1$export$5244a89f9e090d3e).gameBackground].loop = true;
                    soundPlayer[(0, $92dac20c890c76b1$export$5244a89f9e090d3e).gameBackground].volume = 0.4;
                    model.traverse(function(node) {
                        if (node.isMesh) {
                            node.geometry.dispose();
                            node.material.dispose();
                        }
                    });
                }, undefined, function(e) {
                    console.error(e);
                });
                gltfLoader.load(coinModelUrl, function(gltf) {
                    const modelCoin = gltf.scene;
                    modelCoin.rotation.x = -Math.PI / 2;
                    coordinatesOfCoins.forEach((item, i)=>{
                        const coinModel = modelCoin.clone();
                        coinModels.push(coinModel);
                        coinModel.position.set(item[0], item[1], item[2]);
                        scene.add(coinModel);
                        buildClickableMesh(coinModel);
                    });
                    modelCoin.traverse(function(node) {
                        if (node.isMesh) {
                            node.geometry.dispose();
                            node.material.dispose();
                        }
                    });
                    scope.isSummerTimerFinish = function() {
                        gltfLoader.load(modelHighlightUrl, function(gltf) {
                            const modelHighlight = gltf.scene;
                            modelHighlight.name = "highlight";
                            modelHighlight.scale.set(0.15, 0.15, 0.15);
                            modelHighlight.rotation.x = Math.PI / 2;
                            modelHighlight.position.set(0, 0, 1);
                            coinModels.forEach((coinModel)=>{
                                const arrow = modelHighlight.clone();
                                arrow.visible = false;
                                arrowModels.push(arrow);
                                coinModel.add(arrow);
                            });
                            animateRandomArrow(arrowModels);
                            modelHighlight.traverse(function(node) {
                                if (node.isMesh) {
                                    node.geometry.dispose();
                                    node.material.dispose();
                                }
                            });
                        }, undefined, function(error) {
                            console.error(error);
                        });
                    };
                }, undefined, function(error) {
                    console.error(error);
                });
            }
            function objectClickHandler(obj) {
                soundPlayer.playTrack((0, $92dac20c890c76b1$export$5244a89f9e090d3e).collectCoin);
                if (soundPlayer[(0, $92dac20c890c76b1$export$5244a89f9e090d3e).collectCoin]) soundPlayer[(0, $92dac20c890c76b1$export$5244a89f9e090d3e).collectCoin].playbackRate = 0.5;
                soundPlayer.playTrack((0, $92dac20c890c76b1$export$5244a89f9e090d3e).coinAnimation);
                const parent = obj.userData.parent;
                const highlight = parent.getObjectByName("highlight");
                parent.remove(highlight);
                arrOfMesh = arrOfMesh.filter((e, i)=>{
                    if (e !== obj) return e;
                    coinModels.splice(i, 1);
                    const arrow = arrowModels.splice(i, 1);
                    showArrowAnimation = arrow[0]?.visible ? null : true;
                });
                setTimeout(()=>{
                    scene.remove(parent);
                }, timeCoinRemove);
                if (arrOfMesh.length > 0) return window.postMessage("coinTaken");
                window.postMessage("gameFinished");
                soundPlayer.playTrack((0, $92dac20c890c76b1$export$5244a89f9e090d3e).allCollected);
            }
            function onWindowResize() {
                renderer.setPixelRatio(window.devicePixelRatio);
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();
                renderer.setSize(window.innerWidth, window.innerHeight);
            }
            function detectX(event) {
                const rect = element[0].getBoundingClientRect();
                return (event.clientX - rect.left) / rect.width * 2 - 1;
            }
            function detectY(event) {
                const rect = element[0].getBoundingClientRect();
                return -((event.clientY - rect.top) / rect.height) * 2 + 1;
            }
            let isClickBlock = false;
            function onDocumentMouseDown(event) {
                event.preventDefault();
                mouse.x = detectX(event);
                mouse.y = detectY(event);
                if (scope.step || isClickBlock) return;
                raycaster.setFromCamera(mouse, camera);
                const intersects = raycaster.intersectObjects(arrOfMesh);
                if (intersects.length) {
                    intersects[0].object.callback(intersects[0].object);
                    if (arrowModels.length && !showArrowAnimation) setTimeout(()=>{
                        animateRandomArrow(arrowModels);
                    }, 2000);
                }
                if (!intersects.length) soundPlayer.playTrack((0, $92dac20c890c76b1$export$5244a89f9e090d3e).missClick);
                isClickBlock = true;
                setTimeout(function() {
                    isClickBlock = false;
                }, timeClickCoin);
            }
            function onDocumentMouseMove(event) {
                event.preventDefault();
                mouse.x = detectX(event);
                mouse.y = detectY(event);
                raycaster.setFromCamera(mouse, camera);
                const intersects = raycaster.intersectObjects(arrOfMesh, true);
                const canvas = document.getElementById(canvasId);
                if (intersects.length) canvas.style.cursor = "pointer";
                else canvas.style.cursor = "default";
            }
            let animationFrameId;
            function animate() {
                animationFrameId = requestAnimationFrame(animate);
                renderer.render(scene, camera);
            }
            const canvas = document.getElementById(canvasId);
            canvas.addEventListener("pointerdown", onDocumentMouseDown, false);
            canvas.addEventListener("mousemove", onDocumentMouseMove, false);
            window.addEventListener("resize", onWindowResize, false);
            scope.$on("$destroy", ()=>{
                cancelAnimationFrame(animationFrameId);
                while(scene.children.length > 0){
                    const child = scene.children[0];
                    scene.remove(child);
                    child.dispose?.();
                }
                renderer.renderLists.dispose();
                renderer.dispose();
                canvas.removeEventListener("pointerdown", onDocumentMouseDown, false);
                canvas.removeEventListener("mousemove", onDocumentMouseMove, false);
                window.removeEventListener("resize", onWindowResize, false);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $405354a9ba4378b3$exports = {};

(function() {
    controller.$inject = [
        "$q",
        "http"
    ];
    app.factory("worldCup", controller);
    function controller($q, _http) {
        return {
            getCollection () {
                const defer = $q.defer();
                const alias = "worldCupCalendar";
                const config = {
                    params: {},
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
})();


(function() {
    "use strict";
    const directive = {
        name: "worldCupCalendar"
    };
    controller.$inject = [
        "worldCup"
    ];
    function controller(_worldCup) {
        function link($scope) {
            $scope.preloader = false;
            $scope.worldCupCollection = {
                rounds: []
            };
            const holidayType = "casino";
            let roundsCollection = {};
            let bonusCollection = {};
            function getData() {
                $scope.preloader = true;
                _worldCup.getCollection().then((answer)=>{
                    roundsCollection = answer.result;
                    roundsCollection.forEach((round)=>{
                        $scope.worldCupCollection.rounds.push({
                            groups: round.groups
                        });
                    });
                    getHolidays();
                });
            }
            function getHolidays() {
                if ($scope.holiday?.events?.[holidayType]?.length) {
                    bonusCollection = $scope.holiday;
                    createBonusStructure();
                } else $scope.$watch("holiday", (holiday)=>{
                    if (holiday?.events?.[holidayType]?.length) {
                        bonusCollection = holiday;
                        createBonusStructure();
                    }
                });
            }
            function createBonusStructure() {
                roundsCollection.forEach(function(round, index) {
                    const eventsCalendar = {};
                    const bonusesOfRound = [];
                    const groupsPoints = {};
                    round.events.forEach(function(event) {
                        const worldCupBonus = bonusCollection.events.casino.find(({ id: id })=>id === event.calendar_id);
                        if (!eventsCalendar.hasOwnProperty(worldCupBonus.id)) eventsCalendar[worldCupBonus.id] = {
                            ...worldCupBonus,
                            sportEvents: []
                        };
                        if (event.teams[0].score < 0) event.restDay = true;
                        eventsCalendar[worldCupBonus.id].sportEvents.push(event);
                        event.teams.forEach(function(team) {
                            if (!groupsPoints.hasOwnProperty(team.long_name)) groupsPoints[team.long_name] = 0;
                            groupsPoints[team.long_name] += Number(team.points);
                        });
                    });
                    for(const property in eventsCalendar)bonusesOfRound.push(eventsCalendar[property]);
                    $scope.worldCupCollection.rounds[index].bonus = bonusesOfRound;
                    $scope.worldCupCollection.rounds[index].groups.forEach((group)=>group.teams.forEach(function(team) {
                            team.totalPoints = groupsPoints[team.long_name] || 0;
                        }));
                    sortTeamsInGroups(index);
                    setDate(index);
                    setRoundStatus(index);
                    setRoundName(round, index);
                });
            }
            function setDate(index) {
                $scope.worldCupCollection.rounds[index].bonus.forEach(function(bonus) {
                    const date = new Date(bonus.date);
                    bonus.day = date.getDay();
                    bonus.month = date.getMonth();
                });
            }
            function setRoundStatus(index) {
                $scope.worldCupCollection.rounds[index].bonus.forEach(function(bonus) {
                    if (bonus.dayStatus === "today") $scope.worldCupCollection.rounds[index].status = "active";
                });
            }
            function setRoundName(round, index) {
                $scope.worldCupCollection.rounds[index].name = round.name;
            }
            function sortTeamsInGroups(index) {
                $scope.worldCupCollection.rounds[index].groups.forEach((group)=>group.teams.sort(function(prev, next) {
                        return next.totalPoints - prev.totalPoints;
                    }));
            }
            getData();
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $5654e8f1cca9aca4$exports = {};
(function() {
    "use strict";
    app.directive("worldCupVideo", controller);
    function controller() {
        function link($scope) {
            $scope.screenWidth = window.innerWidth;
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $519861a844070f1e$exports = {};



/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */ /** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */ 
var $jkiWk = parcelRequire("jkiWk");
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */ 
function $68f310d28b87cd4a$export$b314777ae20abca9() {
    return (0, $7f055eb9bd99aecf$export$18aef43295bbe906)(1);
}


function $c420691080d3a4be$export$ee1b3e54f0441b22() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return (0, $68f310d28b87cd4a$export$b314777ae20abca9)()((0, $jkiWk.of).apply(void 0, observables));
}



var $891rE = parcelRequire("891rE");
function $749718fcf90c147c$export$a4fe86229b0e9bdd() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    var scheduler = array[array.length - 1];
    if ((0, $891rE.isScheduler)(scheduler)) {
        array.pop();
        return function(source) {
            return (0, $c420691080d3a4be$export$ee1b3e54f0441b22)(array, source, scheduler);
        };
    } else return function(source) {
        return (0, $c420691080d3a4be$export$ee1b3e54f0441b22)(array, source);
    };
}




const $b823a6a26fa76a60$var$service = {
    name: "kickertechScriptLoaderService"
};
class $b823a6a26fa76a60$var$KickertechScriptLoaderService {
    static $inject = [
        "helper"
    ];
    constructor(helper){
        this.helper = helper;
    }
    isLoadingSubject$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)(null);
    isLoading$ = this.isLoadingSubject$.asObservable();
    init(src) {
        if (this.isLoadingSubject$.getValue() !== null) return;
        this.isLoadingSubject$.next(true);
        this.helper.dom.addScript(src, ()=>{
            this.isLoadingSubject$.next(false);
        });
    }
}
app.service($b823a6a26fa76a60$var$service.name, $b823a6a26fa76a60$var$KickertechScriptLoaderService);


const $43f974fa0f80b42c$var$service = {
    name: "kickertechWidgetRendererService"
};
class $43f974fa0f80b42c$var$KickertechWidgetRendererService {
    static $inject = [
        "$window"
    ];
    constructor($window){
        this.$window = $window;
    }
    render({ type: type, target: target, params: params, onLoad: onLoad }) {
        const widget = this.$window.document.createElement(type);
        for(const key in params)if (params.hasOwnProperty(key)) widget.setAttribute(key, params[key]);
        target.appendChild(widget);
        onLoad();
    }
}
app.service($43f974fa0f80b42c$var$service.name, $43f974fa0f80b42c$var$KickertechWidgetRendererService);




(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        const events$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        return {
            events$: events$,
            launch: launch
        };
        function launch(options) {
            const defer = $q.defer();
            const alias = "sportLaunch";
            const config = {
                params: options,
                cache: false,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then((answer)=>{
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        }
    }
    app.factory("eeSport", controller);
})();



const $f2ab41b6138fa71f$var$service = {
    name: "kickertechWidgetService"
};
class $f2ab41b6138fa71f$var$KickertechWidgetService {
    static $inject = [
        "system$",
        "eeSport",
        "kickertechScriptLoaderService",
        "kickertechWidgetRendererService"
    ];
    constructor(system$, eeSport, kickertechScriptLoaderService, kickertechWidgetRendererService){
        this.system$ = system$;
        this.eeSport = eeSport;
        this.kickertechScriptLoaderService = kickertechScriptLoaderService;
        this.kickertechWidgetRendererService = kickertechWidgetRendererService;
        this.init();
    }
    kickertechLaunchCode = "sport-tglab";
    kickertechBroadcastChannelName = "KTSBChannel";
    userStatusChangedAction = "statusChanged";
    kickertechOptionsSubject$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)(null);
    receivedEventsSubject$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    broadcastChannel = new BroadcastChannel(this.kickertechBroadcastChannelName);
    kickertechOptions$ = this.kickertechOptionsSubject$.asObservable();
    receivedEvents$ = this.receivedEventsSubject$.asObservable();
    init() {
        this.initKickertechOptions();
        this.initScript();
        this.interceptReceivedMessages();
    }
    initKickertechOptions() {
        this.system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === this.userStatusChangedAction), (0, $749718fcf90c147c$export$a4fe86229b0e9bdd)(null)).subscribe(()=>{
            this.eeSport.launch({
                code: this.kickertechLaunchCode
            }).then((response)=>this.kickertechOptionsSubject$.next(response.result.launch_options)).catch((error)=>console.error(error));
        });
    }
    initScript() {
        this.kickertechOptions$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(Boolean), (0, $94b8433012a062db$export$b7df5d561049483a)(1)).subscribe(({ host: host })=>this.kickertechScriptLoaderService.init(host));
    }
    initWidget({ type: type, target: target, params: params, onLoad: onLoad }) {
        return (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)([
            this.kickertechScriptLoaderService.isLoading$,
            this.kickertechOptions$
        ]).pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(([isScriptLoading, kickertechOptions])=>isScriptLoading === false && kickertechOptions), (0, $94b8433012a062db$export$b7df5d561049483a)(1), (0, $32594888be9d26d0$export$871de8747c9eaa88)(([, { host: host, token: token, ...defaultParams }])=>defaultParams)).subscribe((defaultParams)=>this.kickertechWidgetRendererService.render({
                type: type,
                target: target,
                params: {
                    ...defaultParams,
                    ...params
                },
                onLoad: onLoad
            }));
    }
    interceptReceivedMessages() {
        this.broadcastChannel.onmessage = ({ data: data })=>{
            this.receivedEventsSubject$.next(data);
            if (data.SBLoaded) this.kickertechOptionsSubject$.pipe().subscribe(({ token: token })=>token ? this.logIn(token) : this.logOut());
        };
    }
    sendEvent(event) {
        this.broadcastChannel.postMessage(event);
    }
    renderByPath(path) {
        this.sendEvent({
            renderByPath: {
                path: path
            }
        });
    }
    reloadSB() {
        this.sendEvent({
            reloadSB: true
        });
    }
    initSB() {
        this.sendEvent({
            initSB: true
        });
    }
    destroySB() {
        this.sendEvent({
            destroySB: true
        });
    }
    pageSwitch(page) {
        this.sendEvent({
            pageSwitch: {
                page: page
            }
        });
    }
    toggleSearch(action) {
        this.sendEvent({
            toggleSearch: {
                action: action
            }
        });
    }
    toggleBettingHistory(action) {
        this.sendEvent({
            toggleBettingHistory: {
                action: action
            }
        });
    }
    toggleLeftMenu(action) {
        this.sendEvent({
            toggleLeftMenu: {
                action: action
            }
        });
    }
    switchLanguage(language) {
        this.sendEvent({
            switchLanguage: {
                language: language
            }
        });
    }
    logIn(token) {
        this.sendEvent({
            logIn: {
                token: token
            }
        });
    }
    logOut() {
        this.sendEvent({
            logOut: true
        });
    }
    addSelections(selections) {
        this.sendEvent({
            addSelections: {
                selections: selections
            }
        });
    }
    translatePath(path, language) {
        this.sendEvent({
            path: path,
            language: language
        });
    }
}
app.service($f2ab41b6138fa71f$var$service.name, $f2ab41b6138fa71f$var$KickertechWidgetService);




const $519861a844070f1e$var$directive = {
    name: "kickertechWidget"
};
class $519861a844070f1e$var$KickertechWidgetDirective {
    static $inject = [
        "$location",
        "$transitions",
        "state",
        "config",
        "kickertechWidgetService"
    ];
    constructor($location, $transitions, state, config, kickertechWidgetService){
        this.$location = $location;
        this.$transitions = $transitions;
        this.state = state;
        this.config = config;
        this.kickertechWidgetService = kickertechWidgetService;
    }
    static types = Object.freeze({
        sportsbook: "kt-sb-main",
        virtualSport: "external-sb-ssp"
    });
    link(scope, element, attrs) {
        scope.preloader = true;
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const params = scope.$eval(attrs[$519861a844070f1e$var$directive.name]);
        const generateKickertechParams = (params)=>{
            const baseParams = {
                live_path: `${this.config.currentLang}/${params?.live || "live"}`,
                pre_path: `${this.config.currentLang}/${params?.prelive || "sport"}`,
                ssp_path: `${this.config.currentLang}/${params?.virtual || "virtual"}`,
                initializible: true
            };
            return params?.pageId ? {
                ...baseParams,
                page_id: params.pageId
            } : baseParams;
        };
        let routerListenerUnsubscribe = null;
        const urlProcessing = ()=>{
            this.kickertechWidgetService.renderByPath(this.$location.path());
            if (routerListenerUnsubscribe) return;
            routerListenerUnsubscribe = this.$transitions.onSuccess({}, (transition)=>transition.options().relative !== null && this.kickertechWidgetService.renderByPath(this.$location.path()));
        };
        this.kickertechWidgetService.initWidget({
            type: $519861a844070f1e$var$KickertechWidgetDirective.types[params.type],
            target: element[0],
            params: generateKickertechParams(params),
            onLoad: ()=>this.kickertechWidgetService.initSB()
        });
        this.kickertechWidgetService.receivedEvents$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((event)=>{
            if (event.SBLoaded) {
                scope.$evalAsync(()=>scope.preloader = false);
                urlProcessing();
            }
            if (event.depositClickEvent) this.state.goto("deposit");
            if (event.loginClickEvent) this.state.goToAuthorization();
        });
        scope.$on("$destroy", ()=>{
            routerListenerUnsubscribe?.();
            routerListenerUnsubscribe = null;
            this.kickertechWidgetService.destroySB();
            destroy$.next();
            destroy$.unsubscribe();
        });
    }
}
app.directive($519861a844070f1e$var$directive.name, ()=>{
    return {
        restrict: "A",
        controller: $519861a844070f1e$var$KickertechWidgetDirective,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope, element, attrs, ctrl);
        }
    };
});


var $6a6f0d85ba55a69e$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "user",
        "account"
    ];
    function controller(_user, _account) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            if (_user.profile.activated_by_email === false) $transclude($scope, (clone, scope)=>{
                scope.preloader = false;
                $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
                scope.resend = ()=>{
                    scope.preloader = true;
                    _account.activationCode({}).then(()=>{}).catch(()=>{}).finally(()=>scope.preloader = false);
                };
            });
        }
        return {
            restrict: "A",
            transclude: "element",
            link: link
        };
    }
    app.directive("mgaUnverifiedEmailWidget", controller);
})();


var $06daa3eea4eb7cae$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "bodyScrollLock"
    };
    controller.$inject = [
        "$timeout",
        "$state"
    ];
    function controller($timeout, $state) {
        const link = (scope, element, attrs)=>{
            const selectors = attrs[directive.name];
            lock();
            scope.$on("$stateChangeStart", function() {
                unlock();
            });
            scope.$on("$stateChangeSuccess", function() {
                lock();
            });
            function lock() {
                $timeout(()=>{
                    const targetList = document.querySelectorAll(selectors);
                    for(let i = 0; i < targetList.length; i++)bodyScrollLock.disableBodyScroll(targetList[i]);
                }, 0);
            }
            function unlock() {
                bodyScrollLock.clearAllBodyScrollLocks();
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3f9067b6ff1e813c$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "callNumber"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs)=>{
            const number = attrs[directive.name];
            element.on("tap", ()=>location.href = `tel: ${number}`);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $e142046d94bb2946$exports = {};

var $1E71g = parcelRequire("1E71g");
(function() {
    "use strict";
    const directive = {
        name: "hideAfterScroll"
    };
    controller.$inject = [
        "$state"
    ];
    function controller($state) {
        const link = (scope, element, attrs)=>{
            const el = (0, (/*@__PURE__*/$parcel$interopDefault($1E71g)))(element);
            const options = scope.$eval(attrs[directive.name]);
            const elements = (0, (/*@__PURE__*/$parcel$interopDefault($1E71g)))(options.elements.join(","));
            const className = options.className || "is-hidden";
            const height = options.minHeight || 48;
            let currentPosition = 0;
            let startPosition = 0;
            let scrollUp = false;
            let touchStart = false;
            let touchEnd = false;
            let isScrolling = undefined;
            scope.$on("$stateChangeStart", function() {
                show();
            });
            el.scroll(function(e) {
                // eslint-disable-next-line angular/window-service
                window.clearTimeout(isScrolling);
                // eslint-disable-next-line angular/timeout-service
                isScrolling = setTimeout(function() {
                    scrollWork();
                    resetParams();
                }, 100);
                scrollWork();
            });
            el.on("touchstart", function() {
                resetParams();
                touchStart = true;
            });
            el.on("touchend", function() {
                touchEnd = true;
            });
            function resetParams() {
                // eslint-disable-next-line angular/window-service
                window.clearTimeout(isScrolling);
                currentPosition = 0;
                startPosition = 0;
                scrollUp = false;
                touchEnd = false;
                touchStart = false;
            }
            function hide() {
                elements.addClass(className);
            }
            function show() {
                elements.removeClass(className);
            }
            function scrollWork() {
                currentPosition = el.scrollTop();
                scrollUp = currentPosition < startPosition;
                if (!startPosition || scrollUp != currentPosition < startPosition) startPosition = currentPosition;
                if (currentPosition > startPosition + 10 || currentPosition < startPosition - 10) {
                    if (currentPosition >= height && !scrollUp) hide();
                    if (currentPosition < height || scrollUp && !touchStart) show();
                    if (scrollUp && touchStart && touchEnd) show();
                    if (currentPosition + element[0].clientHeight === element[0].scrollHeight) show();
                }
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $9d5c9770613e620e$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "keepScrollPosition"
    };
    controller.$inject = [
        "$timeout",
        "$state"
    ];
    function controller($timeout, $state) {
        const scrollPosCache = {};
        const link = (scope, element, attrs)=>{
            scope.$on("$stateChangeStart", function() {
                if ($state.$current) {
                    const el = element[0].querySelector(attrs[directive.name]);
                    if (el) scrollPosCache[$state.current.name] = [
                        el.scrollLeft,
                        el.scrollTop
                    ];
                }
            });
            scope.$on("$stateChangeSuccess", function() {
                const prevScrollPos = scrollPosCache[$state.current.name] || [
                    0,
                    0
                ];
                $timeout(function() {
                    const el = element[0].querySelector(attrs[directive.name]);
                    if (el) el.scrollTo(prevScrollPos[0], prevScrollPos[1]);
                }, 0);
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $4b90dcbe7e394086$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "modal"
    ];
    function controller(_modal) {
        function link(scope, element, attrs) {
            element.on("tap", ()=>_modal.answer = false);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaModalRejectOnTap", controller);
})();


var $950cb124780dba31$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "modal"
    ];
    function controller(_modal) {
        function link(scope, element, attrs) {
            element.on("tap", ()=>_modal.answer = true);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaModalResolveOnTap", controller);
})();


var $ea98f828d5832528$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "mDatepicker"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs, ctrl)=>{
            const params = scope.$eval(attrs[directive.name]) || {};
            const dateLimitation = {
                min: attrs.min ? new Date(attrs.min) : null,
                max: attrs.max ? new Date(attrs.max) : null
            };
            if (params.minAge) {
                dateLimitation.max = new Date().removeYears(params.minAge);
                element[0].setAttribute("max", dateLimitation.max.toISODate());
            }
            if (params.maxAge) {
                dateLimitation.min = new Date().removeYears(params.maxAge);
                element[0].setAttribute("min", dateLimitation.min.toISODate());
            }
            ctrl.$parsers.push((d)=>{
                const userBirthdayAsDate = new Date(d);
                if (dateLimitation.max && userBirthdayAsDate > dateLimitation.max || dateLimitation.min && userBirthdayAsDate < dateLimitation.min) {
                    ctrl.$setViewValue("", false);
                    return null;
                }
                return element[0].value;
            });
            ctrl.$formatters.push((d)=>new Date(d));
        };
        return {
            require: "ngModel",
            link: link,
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $14982d092b27f226$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "ngDbtap"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs)=>{
            let firstTap = false;
            let firstTapDate = null;
            element.on("touchend", function(e) {
                firstTap === false ? firstTapAction() : secondTapAction();
            });
            element.on("touchstart", function(e) {
                element.addClass("ng-tap--start");
            });
            element.on("touchend", function(e) {
                element.removeClass("ng-tap--start");
            });
            function firstTapAction() {
                firstTap = true;
                firstTapDate = Date.now();
            }
            function secondTapAction() {
                if (Date.now() - firstTapDate < 500) doubleTapAction();
                firstTap = false;
                firstTapDate = null;
            }
            function doubleTapAction() {
                scope.$apply(attrs[directive.name], element);
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c2315f22e8d44237$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "ngTap"
    };
    controller.$inject = [
        "$state"
    ];
    function controller($state) {
        const link = (scope, element, attrs)=>{
            const atStart = element[0].hasAttribute("ng-tap-start");
            const isState = attrs[directive.name + "State"];
            const ngTapActive = attrs[directive.name + "Active"];
            if (isState && ngTapActive) {
                const params = scope.$eval(attrs[directive.name + "State"]);
                const stateName = attrs[directive.name];
                if ($state.$current.self.name === stateName && $state.params.name === params.name) element.addClass(ngTapActive);
                else element.removeClass(ngTapActive);
            }
            let tapping = false;
            const doIt = ()=>{
                if (isState) {
                    let params = scope.$eval(attrs[directive.name + "State"]);
                    if (typeof params !== "object") params = {};
                    $state.go(attrs[directive.name], params);
                } else scope.$apply(attrs[directive.name], element);
                document.querySelector("[ng-tap-active]")?.classList.remove("active");
                element.addClass("active");
            };
            element.on("touchstart", function(e) {
                tapping = true;
                element.addClass("ng-tap--start");
                if (atStart && attrs[directive.name]) doIt();
            });
            element.on("touchmove", function(e) {
                element.addClass("ng-tap--move");
                tapping = false;
            });
            element.on("touchend", function(e) {
                element.removeClass("ng-tap--start");
                element.removeClass("ng-tap--move");
                if (!atStart && tapping && attrs[directive.name] && attrs[directive.name] != "ng-tap") doIt();
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $818861ded64d6b91$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "popupCloseTap"
    };
    controller.$inject = [
        "popup"
    ];
    function controller(_popup) {
        function link(scope, element, attrs) {
            let tapping = false;
            element.on("touchstart", function(e) {
                tapping = true;
            });
            element.on("touchmove", function(e) {
                tapping = false;
            });
            element.on("touchend", function() {
                if (!tapping) return false;
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $ca4a9d69699b0940$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "popupOpenTap"
    };
    controller.$inject = [
        "popup",
        "contentBuffer",
        "user"
    ];
    function controller(_popup, _contentBuffer, _user) {
        function link(scope, element, attrs) {
            element.on("tap", ()=>{
                const attrsValue = scope.$eval(attrs[directive.name]);
                const config = typeof attrsValue === "object" ? attrsValue : {
                    name: attrs[directive.name]
                };
                if (config.private === true) {
                    if (_user.status) _popup.open(config);
                    else _popup.open({
                        name: "login",
                        cb () {
                            _popup.open(config);
                        }
                    });
                } else _popup.open(config);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $052054912d1f0b14$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollBox"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs)=>{
            element[0].setAttribute("style", "overflow-y: scroll; -webkit-overflow-scrolling: touch;");
            if (typeof bodyScrollLock === "object") {
                bodyScrollLock.disableBodyScroll(element[0]);
                scope.$on("$destroy", ()=>{
                    bodyScrollLock.enableBodyScroll(element[0]);
                });
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $343a0479bc58e0ca$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollIntoViewOnEvent"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            const scrollToElementName = document.querySelector(config.element);
            const scrollIntoViewOptions = config.scrollIntoViewOptions || {
                behavior: "smooth"
            };
            const event = config.event || "click";
            if (!scrollToElementName) return;
            element.on(event, ()=>scrollToElementName.scrollIntoView(scrollIntoViewOptions));
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $6c306433b40b3cb8$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollToTopOnTap"
    };
    controller.$inject = [
        "$document"
    ];
    function controller($document) {
        function link(scope, element, attrs) {
            element.on("tap", ()=>{
                const targetElement = $document[0].querySelector(attrs[directive.name]);
                if (targetElement) targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $dbf947fd2745e4ab$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "smoothScrollTap"
    };
    controller.$inject = [
        "$document"
    ];
    function controller($document) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            element.on("tap", ()=>{
                const pageElement = $document[0].querySelector(config.page);
                const toElement = $document[0].querySelector(config.to);
                if (toElement && pageElement) pageElement.scrollTo({
                    top: toElement.getBoundingClientRect().top + pageElement.scrollTop,
                    behavior: "smooth"
                });
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $70b8ca6836f8c73c$exports = {};
(function() {
    "use strict";
    const directiveName = "swipeSidebar";
    app.directive(directiveName, controller);
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const options = scope.$eval(attrs[directiveName]);
            const menuElement = angular.element(options.el);
            const limits = {
                max: options.limit[1],
                min: options.limit[0]
            };
            const className = "has-open-" + (limits.max > 0 ? "left" : "right") + "-sidebar";
            const tapPosition = {
                start: 0,
                end: 0
            };
            let distance = 0;
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
                tapPosition.start = e.changedTouches[0].pageX;
                menuElement.css("transition", "none");
            });
            element.bind("touchmove", function(e) {
                tapping = false;
                tapPosition.end = e.changedTouches[0].pageX;
                distance = tapPosition.start - tapPosition.end;
                distance = Math.min(distance, limits.max);
                distance = Math.max(distance, limits.min);
                menuElement.css("transform", "translateX(" + (limits.max > 0 ? limits.max - distance : limits.min - distance) + "px)");
                element.css("opacity", tapPosition.end / tapPosition.start);
                e.preventDefault();
            });
            element.bind("touchend", function(e) {
                tapPosition.end = e.changedTouches[0].pageX;
                menuElement.removeAttr("style");
                const isClosed = limits.max > 0 ? distance > limits.max * 0.4 : distance < limits.min * 0.4;
                if (isClosed || tapping) menuElement.removeClass(className);
                else menuElement.addClass(className);
                menuElement.css("transform", "");
                element.css("opacity", "1");
                e.preventDefault();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $475624eb5a8ad1a8$exports = {};
(function() {
    "use strict";
    const directiveName = "swipeToCloseNotification";
    app.directive(directiveName, controller);
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link(scope, element, attrs) {
            const tapPosition = {
                start: 0,
                end: 0
            };
            let distance = 0;
            let transition = "none";
            const limits = {
                max: 100,
                min: -20
            };
            let checked = false;
            element.bind("touchstart", function(e) {
                checked = false;
                tapPosition.start = e.changedTouches[0].pageY;
                transition = element.css("transition");
                element.css("transition", "none");
            });
            element.bind("touchmove", function(e) {
                if (!checked) {
                    tapPosition.end = e.changedTouches[0].pageY;
                    distance = tapPosition.start - tapPosition.end;
                    distance = Math.min(distance, limits.max);
                    distance = Math.max(distance, limits.min);
                    element.css("transform", "translateY(" + -1 * distance + "px)");
                    element.css("opacity", 1 - (distance > 0 ? distance / 200 : 0));
                    if (tapPosition.end <= 0) removeNotification();
                }
                e.preventDefault();
            });
            element.bind("touchend", function(e) {
                if (!checked) {
                    element.css("transition", transition);
                    removeNotification();
                }
                e.preventDefault();
            });
            function removeNotification() {
                checked = true;
                if (distance > limits.max * 0.5) {
                    element.css("opacity", 0);
                    $timeout(()=>{
                        element.remove();
                    }, 300);
                    scope.$apply(attrs[directiveName], element);
                } else {
                    element.css("transform", "");
                    element.css("opacity", "1");
                }
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $a3da565add4f3309$exports = {};
parcelRequire("jTg1q");
(function() {
    "use strict";
    const directive = {
        name: "allHrefTargetSystem"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs)=>{
            setTimeout(function() {
                let tapping = false;
                const elementAngular = angular.element(element);
                elementAngular.find("a[href]").on("touchstart", function(e) {
                    tapping = true;
                });
                elementAngular.find("a[href]").on("touchmove", function(e) {
                    tapping = false;
                });
                elementAngular.find("a[href]").on("touchend", function(e) {
                    e.preventDefault();
                    if (tapping) {
                        const href = this.getAttribute("href");
                        window.open(href, "_system");
                    }
                });
                elementAngular.find("a[href]").on("click", function(e) {
                    e.preventDefault();
                });
            }, 0);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $977e1624b78d4da2$exports = {};
(function() {
    "use strict";
    const directiveName = "closeMenuSwipe";
    app.directive(directiveName, controller);
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const menuElement = angular.element(attrs[directiveName]);
            const limits = {
                max: menuElement.outerWidth(),
                min: 0
            };
            const tapPosition = {
                start: 0,
                end: 0
            };
            let tapping = false;
            let distance = 0;
            let transition = "none";
            element.bind("touchstart", function(e) {
                tapping = true;
                tapPosition.start = e.changedTouches[0].pageX;
                transition = menuElement.css("transition");
                menuElement.css("transition", "none");
            });
            element.bind("touchmove", function(e) {
                tapping = false;
                tapPosition.end = e.changedTouches[0].pageX;
                distance = tapPosition.start - tapPosition.end;
                distance = Math.min(distance, limits.max);
                distance = Math.max(distance, limits.min);
                menuElement.css("transform", "translateX(" + (limits.max - distance) + "px)");
                element.css("opacity", tapPosition.end / tapPosition.start);
                e.preventDefault();
            });
            element.bind("touchend", function(e) {
                tapPosition.end = e.changedTouches[0].pageX;
                menuElement.css("transition", transition);
                if (distance > limits.max * 0.4 || tapping) menuElement.removeClass("menu-open");
                else menuElement.addClass("menu-open");
                menuElement.css("transform", "");
                element.css("opacity", "1");
                e.preventDefault();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $2a6cf7468f53070d$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "deferredRender"
    };
    controller.$inject = [
        "$timeout",
        "$compile"
    ];
    function controller($timeout, $compile) {
        const link = (scope, element, attrs)=>{
            const skeleton = angular.element(attrs[directive.name]);
            scope.isRendered = false;
            $timeout(function() {
                scope.$apply(function() {
                    scope.isRendered = true;
                });
                skeleton.remove();
            }, 0);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $f16a3353868a2fec$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "gameItem"
    };
    controller.$inject = [
        "$compile"
    ];
    function controller($compile) {
        const link = (scope, element, attrs)=>{
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                if (tapping) {
                    $document[0].querySelector(".game-item__buttons-hit-box").remove();
                    const game = scope.$eval(attrs[directive.name]);
                    const el = angular.element('<div class="game-item__buttons-hit-box"></div>');
                    let content = '<button class="g-button g-button_game g-button_green" translate="Play" ng-tap="app.root.mobilegame" ng-tap-state="{name: game.alias, mode: \'real\'}"></button>';
                    if (game.demo) content += '<button class="g-button g-button_demo g-button_transparent" translate="Demo" ng-tap="app.root.mobilegame" ng-tap-state="{name: game.alias,mode: \'demo\'}"></button>';
                    el.html(content);
                    $compile(el)(scope);
                    element.append(el);
                }
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $09b49d2130a2c8eb$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollTo"
    };
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        const link = (scope, element, attrs)=>{
            const padding = 10;
            const container = element[0];
            $timeout(()=>{
                const child = container.querySelector(attrs[directive.name]);
                if (child) {
                    const childOffsetLeft = child.offsetLeft;
                    const containerOffsetLeft = container.offsetLeft;
                    const containerScrollLeft = container.scrollLeft;
                    const position = childOffsetLeft - containerOffsetLeft + containerScrollLeft - padding;
                    container.scrollLeft = position;
                }
            }, 200);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $5bd78082ed6c37a4$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "virtualScroll"
    };
    controller.$inject = [
        "$state",
        "popup",
        "state",
        "$compile"
    ];
    function controller($state, _popup, _state, $compile) {
        let container = [];
        let height = 0;
        const items = [];
        let options = {};
        let size = 100;
        const cols = 2;
        const bench = 10;
        let scrollTop = 0;
        const ve = {
            start: 0,
            end: 0
        };
        const link = (scope, element, attrs)=>{
            scope.limit = [
                0,
                99999
            ];
            options = scope.$eval(attrs[directive.name]);
            container = options.container ? $document[0].querySelector(options.container) : element[0];
            container[0].onscroll = (e)=>doIt(e, scope);
            container[0].ontouchstart = (e)=>doIt(e, scope);
            container[0].ontouchmove = (e)=>doIt(e, scope);
            container[0].ontouchend = (e)=>doIt(e, scope);
            container[0].ontouchcancel = (e)=>doIt(e, scope);
        };
        const doIt = function(e, scope) {
            if (!items.length) size = 122;
            if (!height) height = container.outerHeight();
            const top = container.scrollTop();
            const bottom = top + height;
            let start = Math.round(top / size) * cols - bench;
            if (start < 0) start = 0;
            const end = start + Math.round(height / size * cols) + bench * 2 + 1;
            // let end = Math.round( ( top + bench * size )/size - 1 ) * cols - 1;
            const direction = scrollTop > top ? "up" : "down";
            scrollTop = top;
            const currentStart = Math.round(top / size) * cols;
            const currentEnd = Math.round(bottom / size) * cols;
            const ifDown = currentEnd >= ve.end && direction === "down";
            const ifUp = currentStart < ve.start + bench / 2 + 1 && ve.start > 0 && direction === "up";
            if (ifDown || ifUp) {
                ve.start = start;
                ve.end = end;
                scope.$apply(function() {
                    scope.limit = [
                        start,
                        end
                    ];
                });
                $(".game-box__container").css("paddingTop", ve.start / cols * size + "px");
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $f5c868146101466e$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "callNumber"
    };
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        const link = (scope, element, attrs)=>{
            const number = attrs[directive.name];
            const bypassAppChooser = true;
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchstart", function(e) {
                if (tapping) {
                    if (!cordova || cordova.platformId === "browser") {
                        location.href = "tel:" + number;
                        return;
                    }
                    if ($window.plugins && $window.plugins.CallNumber) $window.plugins.CallNumber.callNumber(()=>{}, ()=>{}, number, bypassAppChooser);
                }
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $a333a9e778a432a5$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "deeplinking"
    };
    controller.$inject = [
        "$state",
        "popup",
        "state",
        "$interval"
    ];
    function controller($state, _popup, _state, $interval) {
        const link = (scope, element, attrs)=>{
            $interval(()=>{
                let url = localStorage.getItem("url");
                if (url) {
                    url = url.split("/");
                    const type = url[2];
                    const name = url[3];
                    const params = toObject(url[4]);
                    switch(type){
                        case "state":
                            _popup.close();
                            $state.go(name, params);
                            break;
                        case "popup":
                            _popup.open({
                                name: name,
                                content: params
                            });
                            break;
                        case "alias":
                            _popup.close();
                            _state.goto(name);
                            break;
                        default:
                            break;
                    }
                    localStorage.removeItem("url");
                }
            }, 1000);
        };
        const toObject = function(str) {
            if (!str) return {};
            const rows = str.split("&");
            const r = {};
            rows.map((s)=>r[s.split("=")[0]] = s.split("=")[1]);
            return r;
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3f74d600f795e84d$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "demoOpen"
    };
    controller.$inject = [
        "modal",
        "game"
    ];
    function controller(_modal, _game) {
        const link = (scope, element, attrs)=>{
            let tapping = false;
            const what = attrs[directive.name];
            const doIt = ()=>{
                if (what === "modal") _modal.open("error", {
                    code: 2205
                });
                if (what === "notification") _game.launch({
                    code: "street_magic",
                    mode: "real"
                }).then((answer)=>{}, (answer)=>{});
            };
            element.bind("touchstart", function(e) {
                tapping = true;
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                if (tapping) doIt();
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $4dab1a20a5e47319$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "config",
        "$window"
    ];
    function controller($q, _config, $window) {
        $window.FirebasePlugin = $window.FirebasePlugin || {};
        return {
            onNotificationOpen (onSuccess, onError) {
                $window.FirebasePlugin.onNotificationOpen(function(notification) {
                    if (angular.isFunction(onSuccess)) onSuccess(notification);
                }, function(error) {
                    if (angular.isFunction(onError)) onError(error);
                });
            },
            getToken () {
                const defer = $q.defer();
                $window.FirebasePlugin.getToken(function(token) {
                    defer.resolve(token);
                }, function(error) {
                    defer.reject(error);
                });
                return defer.promise;
            },
            onTokenRefresh () {
                const defer = $q.defer();
                $window.FirebasePlugin.onTokenRefresh(function(token) {
                    defer.resolve(token);
                }, function(error) {
                    defer.reject(error);
                });
                return defer.promise;
            },
            grantPermission () {
                if (_config.mobileConfig.platform === "ios") $window.FirebasePlugin.grantPermission();
            },
            hasPermission () {
                const defer = $q.defer();
                if (angular.isFunction($window.FirebasePlugin.hasPermission)) $window.FirebasePlugin.hasPermission(function(data) {
                    defer.resolve(data.isEnabled);
                });
                else defer.resolve(false);
                return defer.promise;
            },
            setBadgeNumber (number) {
                $window.FirebasePlugin.setBadgeNumber(number);
            },
            getBadgeNumber () {
                const defer = $q.defer();
                $window.FirebasePlugin.getBadgeNumber(function(number) {
                    defer.resolve(number);
                });
                return defer.promise;
            },
            subscribe (topic) {
                $window.FirebasePlugin.subscribe(topic);
            },
            unsubscribe (topic) {
                $window.FirebasePlugin.unsubscribe(topic);
            },
            unregister () {
                $window.FirebasePlugin.unregister();
            },
            logEvent (name, values) {
                $window.FirebasePlugin.logEvent(name, values);
            },
            setScreenName (screen) {
                $window.FirebasePlugin.setScreenName(screen);
            },
            setUserId (id) {
                $window.FirebasePlugin.setUserId(id);
            },
            setUserProperty (name, value) {
                $window.FirebasePlugin.setUserProperty(name, value);
            }
        };
    }
    app.factory("firebasePlugin", controller);
})();





(function() {
    "use strict";
    const directive = {
        name: "firebaseNotifications"
    };
    controller.$inject = [
        "firebasePlugin",
        "$state",
        "popup",
        "state",
        "config"
    ];
    function controller(_firebasePlugin, $state, _popup, _statem, _config) {
        const link = (scope, element, attrs)=>{
            _firebasePlugin.hasPermission().then((answer)=>{
                _firebasePlugin.grantPermission();
            });
            _firebasePlugin.onNotificationOpen((data)=>{
                const params = JSON.parse(data.params);
                switch(data.type){
                    case "state":
                        if (!data.tap) break;
                        _popup.close();
                        $state.go(data.state, params);
                        break;
                    case "popup":
                        if (!data.tap) break;
                        _popup.open({
                            name: data.popup,
                            content: params
                        });
                        break;
                    case "alias":
                        if (!data.tap) break;
                        _popup.close();
                        _state.goto(data.alias);
                        break;
                    default:
                        break;
                }
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $15e9f13ca91f8cd7$exports = {};

var $1E71g = parcelRequire("1E71g");
(function() {
    "use strict";
    const directive = {
        name: "hideAfterScroll"
    };
    controller.$inject = [
        "$window",
        "$timeout"
    ];
    function controller($window, $timeout) {
        const link = (scope, element, attrs)=>{
            const el = (0, (/*@__PURE__*/$parcel$interopDefault($1E71g)))(element);
            const options = scope.$eval(attrs[directive.name]);
            const elements = (0, (/*@__PURE__*/$parcel$interopDefault($1E71g)))(options.elements.join(","));
            const className = options.className || "is-hidden";
            const height = options.minHeight || 48;
            let currentPosition = 0;
            let startPosition = 0;
            let scrollUp = false;
            let touchStart = false;
            let touchEnd = false;
            let isScrolling = undefined;
            el.scroll(function(e) {
                $timeout.cancel(isScrolling);
                isScrolling = $timeout(function() {
                    scrollWork();
                    resetParams();
                }, 100);
                scrollWork();
            });
            el.on("touchstart", function() {
                resetParams();
                touchStart = true;
            });
            el.on("touchend", function() {
                touchEnd = true;
            });
            function resetParams() {
                $timeout.cancel(isScrolling);
                currentPosition = 0;
                startPosition = 0;
                scrollUp = false;
                touchEnd = false;
                touchStart = false;
            }
            function hide() {
                elements.addClass(className);
            }
            function show() {
                elements.removeClass(className);
            }
            function scrollWork() {
                currentPosition = el.scrollTop();
                scrollUp = currentPosition < startPosition;
                if (!startPosition || scrollUp != currentPosition < startPosition) startPosition = currentPosition;
                if (currentPosition > startPosition + 10 || currentPosition < startPosition - 10) {
                    if (currentPosition >= height && !scrollUp) hide();
                    if (currentPosition < height || scrollUp && !touchStart) show();
                    if (scrollUp && touchStart && touchEnd) show();
                }
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $fd3784881c055884$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "keepScrollPosition"
    };
    controller.$inject = [
        "$timeout",
        "$state"
    ];
    function controller($timeout, $state) {
        const scrollPosCache = {};
        const link = (scope, element, attrs)=>{
            scope.$on("$stateChangeStart", function() {
                if ($state.$current) {
                    const el = element[0].querySelector(attrs[directive.name]);
                    if (el) scrollPosCache[$state.current.name] = [
                        el.scrollLeft,
                        el.scrollTop
                    ];
                }
            });
            scope.$on("$stateChangeSuccess", function() {
                const prevScrollPos = scrollPosCache[$state.current.name] || [
                    0,
                    0
                ];
                $timeout(function() {
                    const el = element[0].querySelector(attrs[directive.name]);
                    if (el) el.scrollTo(prevScrollPos[0], prevScrollPos[1]);
                }, 0);
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $77681803be7b08d6$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "modal"
    ];
    function controller(_modal) {
        function link(scope, element, attrs) {
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
                element.addClass("ng-tap--start");
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                element.removeClass("ng-tap--start");
                if (tapping) _modal.answer = false;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaModalRejectOnTouch", controller);
})();


var $8d93c12b80d21e31$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "modal"
    ];
    function controller(_modal) {
        function link(scope, element, attrs) {
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
                element.addClass("ng-tap--start");
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                element.removeClass("ng-tap--start");
                if (tapping) _modal.answer = true;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaModalResolveOnTouch", controller);
})();


var $0c4895e9c49dbba6$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "mDatepicker"
    };
    controller.$inject = [
        "$state",
        "$window"
    ];
    function controller($state, $window) {
        const link = (scope, element, attrs)=>{
            const config = scope.$eval(attrs[directive.name]);
            let defaultDate = scope.$eval(attrs.ngModel);
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                if (tapping && $window.datePicker) $window.datePicker.show({
                    date: defaultDate ? new Date(defaultDate) : new Date(),
                    mode: config.mode || "date",
                    minDate: config.minDate === "today" ? new Date() : new Date(config.minDate),
                    maxDate: config.maxDate === "today" ? new Date() : new Date(config.maxDate),
                    androidTheme: device.manufacturer === "samsung" ? $window.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT : $window.datePicker.ANDROID_THEMES.THEME_HOLO_LIGHT
                }, (date)=>{
                    if (date) {
                        const newDate = formatDate(date);
                        element[0].value = newDate;
                        defaultDate = newDate;
                        if (angular.isFunction(config.onChange)) config.onChange();
                    }
                });
            });
            function formatDate(date) {
                const d = new Date(date);
                let month = "" + (d.getMonth() + 1);
                let day = "" + d.getDate();
                const year = d.getFullYear();
                if (month.length < 2) month = "0" + month;
                if (day.length < 2) day = "0" + day;
                return [
                    year,
                    month,
                    day
                ].join("-");
            }
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $876d9fa6215fa255$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$q"
    ];
    function controller($q) {
        return {
            selection () {
                TapticEngine.selection();
            },
            notification (type = "error") {
                TapticEngine.notification({
                    type: type
                });
            },
            impact (style = "heavy") {
                TapticEngine.impact({
                    style: style
                });
            }
        };
    }
    app.factory("tapticEngine", controller);
})();


(function() {
    "use strict";
    const directive = {
        name: "mHref"
    };
    controller.$inject = [
        "$state",
        "tapticEngine",
        "$window"
    ];
    function controller($state, _tapticEngine, $window) {
        const link = (scope, element, attrs)=>{
            const href = attrs[directive.name];
            const target = attrs["target"] || "_system";
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                if (tapping) $window.open(href, target);
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $68f07315900c2273$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "ngTapBack"
    };
    controller.$inject = [
        "state",
        "$window"
    ];
    function controller(_state, $window) {
        const link = (scope, element, attrs)=>{
            let tapping = false;
            element.bind("touchstart", function(e) {
                tapping = true;
            });
            element.bind("touchstart", function(e) {
                tapping = false;
            });
            element.bind("touchstart", function(e) {
                if (tapping) {
                    if ($window.history.length >= 3) $window.history.back();
                    else _state.goto("home");
                }
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $bf03771ee256095f$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "offline"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs)=>{
            document.addEventListener("offline", function() {
                element.css("display", "block");
            }, false);
            document.addEventListener("online", function() {
                element.css("display", "none");
            }, false);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $1429dc81afb8a1a6$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "openChatMobile"
    };
    controller.$inject = [
        "user",
        "$window",
        "$timeout"
    ];
    function controller(_user, $window) {
        const link = (scope, element, attrs)=>{
            let tapping = false;
            const src = $_CDN.liveAgent?.sdk;
            const doIt = ()=>{
                (function(d, src, c) {
                    const t = d.scripts[d.scripts.length - 1];
                    const s = d.createElement("script");
                    s.id = "la_x2s6df8d";
                    s.async = true;
                    s.src = src;
                    s.onload = s.onreadystatechange = function() {
                        const rs = this.readyState;
                        if (rs && rs != "complete" && rs != "loaded") return;
                        c(this);
                    };
                    t.parentElement.insertBefore(s, t.nextSibling);
                })(document, src, function(e) {
                    if (_user.status) {
                        const email = _user.profile.email_guid || _user.profile.email;
                        LiveAgent.setUserDetails(email, _user.profile.profile.name, _user.profile.profile.surname, _user.profile.phone);
                        LiveAgent.addTicketField("Username", _user.profile.login);
                    }
                    const chatButton = LiveAgent.createButton("24d327d2", e);
                    const intrvl = $timeout(()=>{
                        if (chatButton.form) {
                            $window.open(chatButton.form.url, "_system");
                            clearInterval(intrvl);
                        }
                    }, 10);
                });
            };
            element.bind("touchstart", function(e) {
                tapping = true;
                element.addClass("ng-tap--start");
            });
            element.bind("touchmove", function(e) {
                tapping = false;
            });
            element.bind("touchend", function(e) {
                element.removeClass("ng-tap--start");
                if (tapping) doIt();
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $dcb99e22bc146d83$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "scrollElementToCenter"
    };
    controller.$inject = [
        "$window",
        "$timeout"
    ];
    function controller($window, $timeout) {
        const link = (scope, element, attrs)=>{
            const padding = 10;
            const container = element[0];
            $timeout(()=>{
                const child = container.querySelector(attrs[directive.name]);
                if (!child) return;
                if (child.scrollIntoView) child.scrollIntoView({
                    inline: "center",
                    block: "end"
                });
                const position = child.offsetLeft - $window.innerWidth / 2 + child.offsetWidth / 2;
                container.scrollLeft = position;
            }, 200);
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $9448746ec200b340$exports = {};


(function() {
    "use strict";
    app.directive("splashscreen", controller);
    controller.$inject = [
        "splash$"
    ];
    function controller(_splash$) {
        function link(scope, element, attrs) {
            _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded")).subscribe((m)=>{
                if (navigator.splashscreen) navigator.splashscreen.hide();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $24d5312853c183e8$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "statusbar"
    };
    controller.$inject = [
        "config",
        "$window"
    ];
    function controller(_config, $window) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            const device = getDevice();
            setTheme(config[device]);
            function getDevice() {
                if (_config.mobileConfig.platform === "ios") return $window.innerWidth === 375 && $window.innerHeight === 768 ? "iPhoneX" : "ios";
                if (_config.mobileConfig.platform === "android") return "android";
            }
            function setTheme(options) {
                if (options.style === "light") {
                    StatusBar.styleDefault(); // black font
                    StatusBar.backgroundColorByHexString(options.bg || "#ffffff");
                }
                if (options.style === "dark") {
                    StatusBar.styleLightContent(); // white font
                    StatusBar.backgroundColorByHexString(options.bg || "#000000");
                }
            }
        }
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $24a6de7011b48f88$exports = {};
(function() {
    "use strict";
    const directiveName = "swipeToCloseNotification";
    app.directive(directiveName, controller);
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link(scope, element, attrs) {
            const tapPosition = {
                start: 0,
                end: 0
            };
            let distance = 0;
            let transition = "none";
            const limits = {
                max: 100,
                min: -20
            };
            let checked = false;
            element.bind("touchstart", function(e) {
                checked = false;
                tapPosition.start = e.changedTouches[0].pageY;
                transition = element.css("transition");
                element.css("transition", "none");
            });
            element.bind("touchmove", function(e) {
                if (!checked) {
                    tapPosition.end = e.changedTouches[0].pageY;
                    distance = tapPosition.start - tapPosition.end;
                    distance = Math.min(distance, limits.max);
                    distance = Math.max(distance, limits.min);
                    element.css("transform", "translateY(" + -1 * distance + "px)");
                    element.css("opacity", 1 - (distance > 0 ? distance / 200 : 0));
                    if (tapPosition.end <= 0) removeNotification();
                }
                e.preventDefault();
            });
            element.bind("touchend", function(e) {
                if (!checked) {
                    element.css("transition", transition);
                    removeNotification();
                }
                e.preventDefault();
            });
            function removeNotification() {
                checked = true;
                if (distance > limits.max * 0.5) {
                    element.css("opacity", 0);
                    $timeout(()=>{
                        element.remove();
                    }, 300);
                    scope.$apply(attrs[directiveName], element);
                } else {
                    element.css("transform", "");
                    element.css("opacity", "1");
                }
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $68e1fa00d8b3d19c$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "linda3dSlider"
    };
    controller.$inject = [];
    function controller() {
        const link = (scope, element, attrs)=>{
            $(element).children().addClass("slide-item");
            const showcase = $(element);
            const config = scope.$eval(attrs[directive.name]);
            const o = {
                onRendered (carousel) {
                // carousel.nearestItem().element.style.opacity = '1'
                },
                onAnimationFinished (e) {},
                onLoaded () {
                    showcase.css("visibility", "visible");
                    showcase.css("display", "none");
                    showcase.fadeIn(1500);
                    setTimeout(()=>{
                        showcase.data("carousel").go(5);
                    }, 100);
                },
                buttonLeft: $(config.buttonLeft || ".next"),
                buttonRight: $(config.buttonRight || ".prev")
            };
            const params = Object.assign({}, config, o);
            const c = showcase.Cloud9Carousel(params);
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $1848486a777d162b$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            const localStorageName = "achievments-tooltip";
            const agree = ()=>{
                $window.localStorage.setItem(localStorageName, "true");
                $element[0].parentNode.remove();
            };
            if (!$window.localStorage.getItem(localStorageName)) $transclude($scope.$new(true), (clone, scope)=>{
                scope.agree = agree;
                $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
            });
        }
        return {
            restrict: "E",
            transclude: "element",
            link: link
        };
    }
    app.directive("lindaAchievementTooltip", controller);
})();


var $6b83590efc3f116e$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "lindaAvatarSlider"
    };
    factory.$inject = [
        "system"
    ];
    function factory(_system) {
        function compile() {
            return function($scope, $element, $attrs, $ctrl, $transclude) {
                Promise.all([
                    Promise.resolve((parcelRequire("1E71g"))),
                    (parcelRequire("aMz5n"))
                ]).then(([$])=>{
                    const slickBox = $($element[0].parentNode);
                    const config = Object.assign({
                        initialSlide: 0
                    }, $scope.$eval($attrs.sliderConfig));
                    const update = (list, index)=>{
                        $scope.avatarObject = list[index] || {};
                        $scope.ngModel = $scope.avatarObject.alias || "";
                    };
                    _system.avatars().then((a)=>{
                        const list = a.result;
                        if (list.length) {
                            for(let i = 0; i <= list.length - 1; i++)$transclude($scope.$new(true), (clone, scope)=>{
                                scope.index = i;
                                scope.slide = list[i];
                                slickBox.append(clone[0]);
                            });
                            if ($scope.ngModel) {
                                const index = list.findIndex((i)=>i.alias === $scope.ngModel);
                                if (index !== -1) config.initialSlide = index;
                            }
                            update(list, config.initialSlide);
                            slickBox.slick(config);
                            slickBox.on("beforeChange", (event, slick, currentSlide, nextSlide)=>{
                                $scope.$apply(()=>{
                                    update(list, nextSlide);
                                });
                            });
                        }
                    }).catch((e)=>{}).finally(()=>{});
                });
            };
        }
        return {
            restrict: "A",
            transclude: "element",
            compile: compile,
            scope: {
                ngModel: "=",
                avatarObject: "=?"
            }
        };
    }
    app.directive(directive.name, factory);
})();


var $916446add65716f4$exports = {};

(function() {
    "use strict";
    app.directive("lindaChangeBonusStatus", controller);
    controller.$inject = [
        "bonus",
        "$rootScope"
    ];
    function controller(_bonus, $rootScope) {
        function link(scope, element, attrs) {
            scope.lindaChangeBonusStatus = {
                setStatus (options) {
                    // options = { bonus_id: id, status: 'active' || 'canceled' }
                    scope.preloader = true;
                    _bonus.status(options).then((answer)=>{
                        $rootScope.$broadcast("renew_bonus_list");
                        scope.preloader = false;
                    }, (answer)=>{
                        scope.preloader = false;
                    });
                }
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $46f48ade3f0927b8$exports = {};
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */ 
var $eGy0D = parcelRequire("eGy0D");

var $fQGWn = parcelRequire("fQGWn");

function $ea071fc4c7f61f15$export$3174cdbf0a0cbc84(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, $fQGWn.async);
    if (!(0, $96a47e5a00ef2017$export$e90fb89750dba83f)(period) || period < 0) period = 0;
    if (!scheduler || typeof scheduler.schedule !== "function") scheduler = (0, $fQGWn.async);
    return new (0, $eGy0D.Observable)(function(subscriber) {
        subscriber.add(scheduler.schedule($ea071fc4c7f61f15$var$dispatch, period, {
            subscriber: subscriber,
            counter: 0,
            period: period
        }));
        return subscriber;
    });
}
function $ea071fc4c7f61f15$var$dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({
        subscriber: subscriber,
        counter: counter + 1,
        period: period
    }, period);
}


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return (0, $ea071fc4c7f61f15$export$3174cdbf0a0cbc84)(1000);
    }
    app.factory("timer$", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "timer$",
        "$filter"
    ];
    function controller(_timer$, $filter) {
        const link = (scope, element, attrs)=>{
            const format = "HH:mm:ss";
            const timer = 0;
            element[0].innerHTML = $filter("date")(new Date(), format);
            _timer$.subscribe((item)=>{
                element[0].innerHTML = $filter("date")(new Date(), format);
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaClock", controller);
})();


var $ad8df05a0e6f921d$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "lindaCountUp"
    };
    controller.$inject = [
        "helper"
    ];
    function controller(_helper) {
        function link(scope, element, attrs) {
            const options = {
                useEasing: true,
                useGrouping: true,
                separator: " ",
                decimal: "."
            };
            const cancel = attrs.$observe(directive.name, (val)=>{
                if (val > 0) {
                    cancel();
                    const demo = new CountUp(element[0], 10000000, val, 0, 2.5, options);
                    const interval = setInterval(()=>{
                        if (_helper.dom.isElementInViewport(element[0])) {
                            clearInterval(interval);
                            if (!demo.error) demo.start();
                        }
                    }, 100);
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $f3c9e17013328909$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "lindaFirstViewChange"
    };
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs.lindaFirstViewChange);
            const elementID = config.id;
            function changeItemStatus(elementID, itemStatus) {
                const obj = JSON.parse(localStorage.getItem("first-view")) || {};
                obj[elementID] = itemStatus;
                $window.localStorage.setItem("first-view", JSON.stringify(obj));
            }
            const firstViewLayer = document.querySelector(`[linda-first-view*='${config.id}']`);
            element.on("click", ()=>{
                if (config.action === "show") {
                    firstViewLayer.classList.add("linda-shown");
                    changeItemStatus(elementID, false);
                } else if (config.action === "hide") {
                    firstViewLayer.classList.remove("linda-shown");
                    changeItemStatus(elementID, true);
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $959d9cda110a6e53$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "lindaFirstView"
    };
    controller.$inject = [
        "$window"
    ];
    function controller($window) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs.lindaFirstView);
            const firstViewStorage = {
                [config.id]: true
            };
            const parsedValue = JSON.parse($window.localStorage.getItem("first-view"));
            if (parsedValue === null || parsedValue[config.id] === false) {
                element[0].classList.add("linda-shown");
                $window.localStorage.setItem("first-view", JSON.stringify(firstViewStorage));
            } else {
                const result = Object.assign(parsedValue, firstViewStorage);
                $window.localStorage.setItem("first-view", JSON.stringify(result));
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $aaa130b3dd03e8ba$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "lindaFullscreen"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const selector = attrs[directive.name];
            element.on("click", function() {
                const isInFullScreen = document.fullscreenElement && document.fullscreenElement !== null || document.webkitFullscreenElement && document.webkitFullscreenElement !== null || document.mozFullScreenElement && document.mozFullScreenElement !== null || document.msFullscreenElement && document.msFullscreenElement !== null;
                const e = document.querySelector(selector);
                const docElm = document;
                if (!isInFullScreen) {
                    if ("requestFullscreen" in e) e.requestFullscreen();
                    else if ("webkitRequestFullscreen" in e) e.webkitRequestFullscreen();
                    else if ("mozRequestFullScreen" in e) e.mozRequestFullScreen();
                    else if ("msRequestFullscreen" in e) e.msRequestFullscreen();
                } else {
                    if (docElm.exitFullscreen) docElm.exitFullscreen();
                    else if (docElm.webkitExitFullscreen) docElm.webkitExitFullscreen();
                    else if (docElm.mozCancelFullScreen) docElm.mozCancelFullScreen();
                    else if (docElm.msExitFullscreen) docElm.msExitFullscreen();
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $4994de40debc289e$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "lindaGotoLang"
    };
    controller.$inject = [
        "$location",
        "config"
    ];
    function controller($location, _config) {
        const link = (scope, element, attrs)=>{
            const linkElement = element[0];
            const error = {
                wrongElement: "Incorrectly selected tag for linda-goto-lang. Must be a tag - a",
                emptyLangParam: ""
            };
            if (linkElement.localName !== "a") {
                alert(error.wrongElement);
                return;
            }
            const langTo = scope.$eval(attrs[directive.name]);
            function setHref(lng) {
                const regStr = new RegExp(`^\/${_config.currentLang}\/`);
                const url = $location.url().replace(regStr, `/${lng}/`);
                linkElement.setAttribute("href", url);
            }
            setHref(langTo);
            linkElement.setAttribute("target", "_self");
            if (langTo === _config.currentLang) linkElement.classList.add("active");
            scope.$on("$stateChangeSuccess", (event, toState, toParams, fromState, fromParams)=>{
                setHref(langTo);
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $cf684c30e97c9185$exports = {};





(function() {
    "use strict";
    const directive = {
        name: "lindaGoto"
    };
    controller.$inject = [
        "$location",
        "$state",
        "state",
        "config",
        "system$",
        "user",
        "remembered"
    ];
    function controller($location, $state, _state, _config, _system$, _user, _remembered) {
        const link = (scope, element, attrs)=>{
            let subscription;
            element.on("click", ()=>{
                let stateParams;
                try {
                    stateParams = scope.$eval(attrs[directive.name]) || attrs[directive.name];
                } catch (error) {
                    stateParams = transformAlias(attrs[directive.name]);
                }
                function transformAlias(aliasData) {
                    const aliasPart = aliasData.split(",");
                    if (aliasPart.length > 1 && aliasPart[0] === "realGame") return {
                        alias: aliasPart[0],
                        params: {
                            name: aliasPart[1]
                        }
                    };
                    return aliasPart[0];
                }
                const alias = typeof stateParams === "object" ? stateParams.alias : stateParams;
                const aliasInConfig = _config.aliases?.[alias];
                const params = {
                    ...aliasInConfig?.params,
                    ...stateParams?.params
                };
                const goTo = (name = alias)=>params ? _state.goto(name, params) : _state.goto(name);
                const goToAuthorization = ()=>{
                    const authAlias = _remembered.login ? "login" : "registration";
                    goTo(authAlias);
                };
                if (alias[0] === "/") {
                    $location.path(stateParams);
                    scope.$apply();
                    return;
                }
                if (alias.search("https://") === 0) {
                    $window.open(stateParams);
                    return;
                }
                if (alias === "chat") {
                    _system$.next({
                        action: "open chat"
                    });
                    return;
                }
                if (alias === "authorization") {
                    goToAuthorization();
                    return;
                }
                if (!_user.status && aliasInConfig?.private) {
                    goToAuthorization();
                    subscription = _state.readyToRedirectAfterAuth$.subscribe(goTo);
                    return;
                }
                goTo();
                scope.$apply();
            });
            scope.$on("$destroy", ()=>{
                subscription?.unsubscribe();
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $002c369a62474240$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "lindaIsFavourite"
    };
    controller.$inject = [
        "game",
        "system$"
    ];
    function controller(_game, _system$) {
        function link(scope, element, attrs) {
            let alias;
            const className = attrs[`${directive.name}ClassName`] || "linda-is-favourite";
            const stopObserving = attrs.$observe(directive.name, (newGame)=>{
                if (newGame) {
                    alias = newGame;
                    element.toggleClass(className, _game.favourite.check(alias));
                    _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "renew favourite")).subscribe((m)=>{
                        element.toggleClass(className, _game.favourite.check(alias));
                    });
                    stopObserving();
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $aa012e3c01863cd8$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "modal"
    ];
    function controller(_modal) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _modal.answer = false;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaModalRejectOnClick", controller);
})();


var $84a1c725b993fb78$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "modal"
    ];
    function controller(_modal) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _modal.answer = true;
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaModalResolveOnClick", controller);
})();


var $0fa9303bdcd93ff6$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "lindaOdometer"
    };
    controller.$inject = [
        "helper"
    ];
    function controller(_helper) {
        function link(scope, element, attrs) {
            const od = new Odometer({
                el: element[0],
                value: 1000000,
                theme: "default",
                duration: 5000,
                format: "( ddd).dd",
                selector: ".odometer"
            });
            const cancel = attrs.$observe(directive.name, (val)=>{
                if (val > 0) {
                    cancel();
                    const interval = setInterval(()=>{
                        if (_helper.dom.isElementInViewport(element[0])) {
                            clearInterval(interval);
                            od.update(val);
                        }
                    }, 100);
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $943c2ea53a4bf905$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return {
            restrict: "A",
            link: function(scope, el, attr) {
                const selector = attr["lindaPasswordTypeToggle"];
                const elementToggle = document.querySelector(selector);
                el.on("click", function() {
                    elementToggle.setAttribute("type", elementToggle.getAttribute("type") === "password" ? "text" : "password");
                    el.toggleClass("toggle-type");
                });
            }
        };
    }
    app.directive("lindaPasswordTypeToggle", controller);
})();


var $bb7e32c3167a6dcb$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "account"
    ];
    const className = "linda-has-preloader";
    function controller(_account) {
        function link(scope, element) {
            const setClass = (force)=>element[0].classList.toggle(className, force);
            element.on("click", ()=>{
                setClass(true);
                _account.info({
                    nocache: true
                }).catch(()=>{}).finally(()=>setClass(false));
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaProfileRefreshOnClick", controller);
})();


var $70c41ddbc4e3e91c$exports = {};

(function() {
    "use strict";
    app.factory("promo.config", controller);
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        const config = {
            //            halloween : {  startDate: '2019-10-25', endDate: '2019-10-31'  },
            halloween_shop: {
                startDate: "2019-10-25",
                endDate: "2019-11-15"
            },
            christmas: {
                startDate: "2020-12-01",
                endDate: "2020-12-31"
            }
        };
        const promo = {};
        Object.keys(config).forEach((promoName)=>{
            if (_config.system_info.date > config[promoName].startDate && _config.system_info.date < config[promoName].endDate) promo[promoName] = config[promoName];
        });
        return promo;
    }
})();


(function() {
    "use strict";
    const directive = {
        name: "lindaPromoNotification"
    };
    factory.$inject = [
        "$window",
        "promo.config"
    ];
    function factory($window, _promo_config) {
        function compile() {
            return function($scope, $element, $attrs, $ctrl, $transclude) {
                $scope.closePromoNotification = closePromoNotification;
                const promoName = $attrs[directive.name];
                const nflags = ($window.localStorage.getItem("promo-notification-flag") || "").split(",");
                if (_promo_config[promoName] && nflags.indexOf(promoName) < 0) $transclude($scope.$new(true), (clone, scope)=>{
                    scope.closePromoNotification = closePromoNotification;
                    $element[0].parentNode.insertBefore(clone[0], $element[0].nextSibling);
                });
                function closePromoNotification() {
                    if (nflags.indexOf(promoName) < 0) {
                        nflags.push(promoName);
                        $window.localStorage.setItem("promo-notification-flag", nflags.join(","));
                        $element[0].parentNode.removeChild($element[0].nextSibling);
                        $element[0].parentNode.removeChild($element[0]);
                    }
                }
            };
        }
        return {
            restrict: "A",
            transclude: "element",
            compile: compile
        };
    }
    app.directive(directive.name, factory);
})();


var $6d09a84a464aced5$exports = {};






(function() {
    "use strict";
    // TODO: needs refactoring. urgent;
    const directive = {
        name: "lindaPromoSlider"
    };
    factory.$inject = [
        "promo",
        "system$",
        "user"
    ];
    function factory(_promo, _system$, _user) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            function startSlickSlide($) {
                const slickBox = $($element[0].parentNode);
                const config = Object.assign({
                    initialSlide: 0
                }, $scope.$eval($attrs.sliderConfig));
                let list = [];
                _promo.list().then((a)=>{
                    list = a.result;
                    for(let i = 0; i <= list.length - 1; i++)$transclude($scope.$new(true), (clone, scope)=>{
                        scope.index = i;
                        scope.slide = list[i];
                        slickBox.append(clone[0]);
                    });
                    slickBox.slick(config);
                    const hashRegex = /^\#s-(\d+)$/;
                    const pageIndex = hashRegex.exec(location.hash)[1];
                    if (pageIndex) slickBox.slick("slickGoTo", pageIndex, true);
                    slickBox.on("reInit", function() {
                        $(".slick-current").prev().addClass("slick-previous");
                        $(".slick-current").next().addClass("slick-next");
                    });
                    slickBox.on("beforeChange swipe", function() {
                        $(".slick-slide").removeClass("slick-previous slick-next");
                        $(".slick-current").prev().addClass("slick-previous");
                        $(".slick-current").next().addClass("slick-next");
                    });
                    filter();
                    const subscription = _system$.pipe(filter((m)=>m.action === "statusChanged")).subscribe(()=>{
                        filter();
                    });
                    $scope.$on("$destroy", ()=>{
                        subscription.unsubscribe();
                    });
                }).catch((e)=>{}).finally(()=>{});
                const filter = ()=>{
                    const o = _promo.object;
                    slickBox.slick("slickUnfilter");
                    slickBox.slick("slickFilter", (i)=>o.hasOwnProperty(list[i].name));
                };
            }
            Promise.all([
                Promise.resolve((parcelRequire("1E71g"))),
                (parcelRequire("aMz5n"))
            ]).then(([$])=>{
                startSlickSlide($);
            });
        }
        return {
            restrict: "A",
            transclude: "element",
            link: link,
            scope: {}
        };
    }
    app.directive(directive.name, factory);
})();


var $688a6caac1c32429$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "lindaPwa"
    };
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        function link(scope, element, attrs) {
            if (localStorage.getItem("pwa") || location.search.indexOf("standalone") + 1) {
                _config.pwa = true;
                element[0].classList.add("linda-pwa");
                localStorage.setItem("pwa", "true");
            }
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $45763bae63837845$exports = {};
(function() {
    "use strict";
    class RenderTemplateObserver {
        #intersectionObserver = null;
        #subscriptions = new Map();
        #config = {
            rootMargin: "300px"
        };
        constructor(){
            this.#intersectionObserver = new IntersectionObserver(this.#intersectionCallBack.bind(this), this.#config);
        }
        subscribe(element, callBack) {
            this.#subscriptions.set(element, callBack);
            this.#intersectionObserver.observe(element);
            return this.#unsubscribe.bind(this, element);
        }
        #unsubscribe(element) {
            this.#intersectionObserver.unobserve(element);
            this.#subscriptions.delete(element);
        }
        #intersectionCallBack(entries) {
            entries.forEach(({ isIntersecting: isIntersecting, target: target })=>{
                if (isIntersecting) this.#callCallBack(target);
            });
        }
        #callCallBack(element) {
            const callBack = this.#subscriptions.get(element);
            if (callBack) callBack();
        }
    }
    function RenderTemplateObserverFactory() {
        return new RenderTemplateObserver();
    }
    app.factory("renderTemplateObserver", RenderTemplateObserverFactory);
})();


(function() {
    renderTemplateDirective.$inject = [
        "renderTemplateObserver"
    ];
    function renderTemplateDirective(renderTemplateObserver) {
        function compile() {
            return ($scope, $element, $attrs, $controller, $transclude)=>{
                const element = $element[0];
                const transcludeContent = ()=>{
                    $transclude(($clone)=>{
                        element.parentNode.insertBefore($clone[0], element.nextSibling);
                    });
                };
                const unsubscribe = renderTemplateObserver.subscribe(element, ()=>{
                    transcludeContent();
                    unsubscribe();
                    element.remove();
                });
                $scope.$on("$destroy", unsubscribe);
            };
        }
        return {
            compile: compile,
            restrict: "E",
            transclude: true
        };
    }
    app.directive("lindaRenderTemplate", renderTemplateDirective);
})();


var $316be90a0807f611$exports = {};

(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "resize");
    }
    app.factory("resize$", controller);
})();


(function() {
    "use strict";
    app.directive("lindaSaveBlockRatio", controller);
    controller.$inject = [
        "resize$",
        "$window"
    ];
    function controller(_resize$, $window) {
        function link(scope, element, attrs) {
            scope.saveRatio = {};
            const dX = parseInt(attrs.deltax) || 0;
            const dY = parseInt(attrs.deltay) || 0;
            const elem = element[0];
            let ratio = 16 / 9;
            const watcher = setInterval(()=>{
                if (attrs.lindaSaveBlockRatio) {
                    const ratioAttr = attrs.lindaSaveBlockRatio.split(":");
                    ratio = ratioAttr[0] * 1 / (ratioAttr[1] * 1);
                    resize();
                    clearInterval(watcher);
                }
            }, 100);
            function resize() {
                const docWidth = $window.innerWidth + dX;
                const docHeight = $window.innerHeight + dY;
                const docRatio = docWidth / docHeight;
                let w;
                let h;
                if (docRatio < ratio) {
                    w = docWidth;
                    h = Math.round(docWidth / ratio);
                } else if (docRatio > ratio) {
                    w = Math.round(docHeight * ratio);
                    h = docHeight;
                } else {
                    w = docWidth;
                    h = docHeight;
                }
                elem.style.width = w + "px";
                elem.style.height = h + "px";
                scope.saveRatio.width = w;
                scope.saveRatio.height = h;
                scope.$apply();
            }
            _resize$.subscribe(resize);
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $f67e78ac799a7f5d$exports = {};



class $80d1b37a000f5f27$var$TitleService {
    static $inject = [
        "$document"
    ];
    constructor($document){
        this.$document = $document[0];
        this.titleRef = this.$document.head.querySelector("title");
        this.targetNode = this.$document.querySelector('meta[charset="UTF-8"]') || this.$document.querySelector('meta[charset="utf-8"]');
        if (this.titleRef === null) this.create();
    }
    create() {
        this.titleRef = this.$document.createElement("title");
        return this.targetNode.after(this.titleRef);
    }
    update(title) {
        if (angular.isString(title)) this.titleRef.textContent = title;
    }
}
app.service("titleService", $80d1b37a000f5f27$var$TitleService);


class $ba42599e0d738a2d$var$DescriptionService {
    static $inject = [
        "$document"
    ];
    constructor($document){
        this.$document = $document[0];
        this.descriptionRef = this.$document.head.querySelector('meta[name="description"]');
        this.targetNode = this.$document.querySelector("title");
        if (this.descriptionRef === null) this.create();
    }
    create() {
        this.descriptionRef = this.$document.createElement("meta");
        this.descriptionRef.setAttribute("name", "description");
        return this.targetNode.after(this.descriptionRef);
    }
    update(description) {
        if (angular.isString(description)) this.descriptionRef.setAttribute("content", description);
    }
}
app.service("descriptionService", $ba42599e0d738a2d$var$DescriptionService);


class $100b2f152ced824c$var$KeywordsService {
    static $inject = [
        "$document"
    ];
    constructor($document){
        this.$document = $document[0];
        this.keywordsRef = this.$document.head.querySelector('meta[name="keywords"]');
        this.targetNode = this.$document.querySelector('meta[name="description"]');
        if (this.keywordsRef === null) this.create();
    }
    create() {
        this.keywordsRef = this.$document.createElement("meta");
        this.keywordsRef.setAttribute("name", "keywords");
        return this.targetNode.after(this.keywordsRef);
    }
    update(keywords) {
        if (angular.isString(keywords)) this.keywordsRef.setAttribute("content", keywords);
    }
}
app.service("keywordsService", $100b2f152ced824c$var$KeywordsService);


class $c6fee24d35e78203$var$OgTitleService {
    static $inject = [
        "$document"
    ];
    constructor($document){
        this.$document = $document[0];
        this.titleRef = this.$document.head.querySelector('meta[property="og:title"]');
        this.targetNode = this.$document.querySelector('meta[property="og:type"]');
        if (this.titleRef === null) this.create();
    }
    create() {
        this.titleRef = this.$document.createElement("meta");
        this.titleRef.setAttribute("property", "og:title");
        return this.targetNode.after(this.titleRef);
    }
    update(title) {
        if (angular.isString(title)) this.titleRef.setAttribute("content", title);
    }
}
app.service("ogTitleService", $c6fee24d35e78203$var$OgTitleService);


class $598923494fd2a1bc$var$OgDescriptionService {
    static $inject = [
        "$document"
    ];
    constructor($document){
        this.$document = $document[0];
        this.descriptionRef = this.$document.head.querySelector('meta[property="og:description"]');
        this.targetNode = this.$document.querySelector('meta[property="og:title"]');
        if (this.descriptionRef === null) this.create();
    }
    create() {
        this.descriptionRef = this.$document.createElement("meta");
        this.descriptionRef.setAttribute("property", "og:description");
        return this.targetNode.after(this.descriptionRef);
    }
    update(description) {
        if (angular.isString(description)) this.descriptionRef.setAttribute("content", description);
    }
}
app.service("ogDescriptionService", $598923494fd2a1bc$var$OgDescriptionService);




class $7dd25e3b95244050$var$HrefLangService {
    static $inject = [
        "$document",
        "config"
    ];
    constructor($document, config){
        this.$document = $document[0];
        this.config = config;
    }
    check(language) {
        if (this.config.alternates.hasOwnProperty(language)) return this.config.alternates[language].hreflang;
        return language;
    }
    render() {
        const html = this.$document.documentElement;
        html.setAttribute("lang", this.check(this.config.currentLang));
    }
}
app.service("hrefLangService", $7dd25e3b95244050$var$HrefLangService);


class $7f560208ec17eddd$var$AlternateService {
    static $inject = [
        "$document",
        "$location",
        "config",
        "hrefLangService"
    ];
    constructor($document, $location, config, hrefLangService){
        this.$document = $document[0];
        this.$location = $location;
        this.config = config;
        this.hrefLangService = hrefLangService;
        this.languages = config.languages;
        this.targetNode = this.$document.querySelector('meta[name="keywords"]');
    }
    alternateLinks = {};
    update() {
        this.languages.forEach((language)=>{
            const href = this.$location.absUrl().replace(`/${this.config.currentLang}/`, `/${language}/`);
            if (this.alternateLinks.hasOwnProperty(language)) {
                this.alternateLinks[language].setAttribute("href", href);
                return;
            }
            const hreflang = this.hrefLangService.check(language);
            const alternateLink = this.$document.createElement("link");
            alternateLink.setAttribute("rel", "alternate");
            alternateLink.setAttribute("hreflang", hreflang);
            alternateLink.setAttribute("href", href);
            this.alternateLinks[language] = this.$document.head.insertBefore(alternateLink, this.targetNode);
        });
    }
}
app.service("alternateService", $7f560208ec17eddd$var$AlternateService);



class $f0e71642e471ef70$var$OgUrlService {
    static $inject = [
        "$document",
        "$location"
    ];
    constructor($document, $location){
        this.$document = $document[0];
        this.$location = $location;
        this.ogUrlRef = this.$document.head.querySelector('meta[property="og:url"]');
        this.targetNode = this.$document.querySelector('meta[property="og:description"]');
        if (this.ogUrlRef === null) this.create();
    }
    create() {
        this.ogUrlRef = this.$document.createElement("meta");
        this.ogUrlRef.setAttribute("property", "og:url");
        return this.targetNode.after(this.ogUrlRef);
    }
    update() {
        this.ogUrlRef.setAttribute("content", `${$_CDN.canonical}${this.$location.path()}`);
    }
}
app.service("ogUrlService", $f0e71642e471ef70$var$OgUrlService);


class $cce773d6c82b52d1$var$TwitterSiteService {
    static $inject = [
        "$document",
        "$location"
    ];
    constructor($document, $location){
        this.$document = $document[0];
        this.$location = $location;
        this.twitterSiteRef = this.$document.head.querySelector('meta[name="twitter:site"]');
        this.targetNode = this.$document.querySelector('meta[property="og:url"]');
        if (this.twitterSiteRef === null) this.create();
    }
    create() {
        this.twitterSiteRef = this.$document.createElement("meta");
        this.twitterSiteRef.setAttribute("name", "twitter:site");
        return this.targetNode.after(this.twitterSiteRef);
    }
    update() {
        this.twitterSiteRef.setAttribute("content", `${this.$location.absUrl()}`);
    }
}
app.service("twitterSiteService", $cce773d6c82b52d1$var$TwitterSiteService);


class $5a42f41c791e3d5a$var$MetaCharsetService {
    static $inject = [
        "$document",
        "$location"
    ];
    constructor($document, $location){
        this.$document = $document[0];
        this.$location = $location;
        this.charsetRef = this.$document.querySelector('meta[charset="UTF-8"]') || this.$document.querySelector('meta[charset="utf-8"]');
        if (this.charsetRef === null) this.create();
    }
    create() {
        this.charsetRef = this.$document.createElement("meta");
        this.charsetRef.setAttribute("charset", "UTF-8");
        return this.$document.head.insertBefore(this.charsetRef, this.$document.head.firstElementChild);
    }
}
app.service("metaCharsetService", $5a42f41c791e3d5a$var$MetaCharsetService);


class $e0d9947ca53d2655$var$LinkedDataService {
    static $inject = [
        "$document",
        "$location"
    ];
    constructor($document, $location){
        this.$document = $document[0];
        this.$location = $location;
        this.targetNode = this.$document.querySelector('meta[name="keywords"]');
    }
    init() {
        let linkedDataNode = this.$document.head.querySelector('script[type="application/ld+json"]');
        if (linkedDataNode === null) {
            linkedDataNode = this.$document.createElement("script");
            linkedDataNode.setAttribute("type", "application/ld+json");
            this.targetNode.after(linkedDataNode);
        }
        return linkedDataNode;
    }
    update(linkedData) {
        const linkedDataScript = this.init();
        if (Object.keys(linkedData).length === 0) {
            if (linkedDataScript.parentNode) linkedDataScript.parentNode.removeChild(linkedDataScript);
            return;
        }
        linkedDataScript.innerHTML = angular.toJson(linkedData);
    }
}
app.service("linkedDataService", $e0d9947ca53d2655$var$LinkedDataService);


class $d2e44b53493705c8$var$SeoRanking {
    static $inject = [
        "$state"
    ];
    constructor($state){
        this.$state = $state;
    }
    check() {
        const route = this.$state.current.name.split(".");
        const state = [];
        let needsSEO = true;
        route.forEach((i)=>{
            state.push(i);
            const routerPart = this.$state.get(state.join("."));
            if (routerPart && routerPart.private) needsSEO = false;
        });
        return needsSEO;
    }
}
app.service("seoRanking", $d2e44b53493705c8$var$SeoRanking);


class $e56f6fc1104a5af0$var$RobotsService {
    static $inject = [
        "$document",
        "seoRanking"
    ];
    constructor($document, seoRanking){
        this.$document = $document[0];
        this.seoRanking = seoRanking;
        this.targetNode = this.$document.querySelector('meta[name="description"]');
    }
    init() {
        let robotsNode = this.$document.head.querySelector('meta[name="robots"]');
        if (robotsNode === null) {
            robotsNode = this.$document.createElement("meta");
            robotsNode.setAttribute("name", "robots");
        }
        const robotsInstructions = Object.keys($_GET).length > 0 ? "NOINDEX, FOLLOW" : "INDEX, FOLLOW";
        robotsNode.setAttribute("content", robotsInstructions);
        return robotsNode;
    }
    update() {
        const isPageRanged = this.seoRanking.check();
        const robots = this.init();
        if (!isPageRanged) {
            if (robots.parentNode) robots.parentNode.removeChild(robots);
            return;
        }
        this.targetNode.after(robots);
    }
}
app.service("robotsService", $e56f6fc1104a5af0$var$RobotsService);



class $ea3cd86189a691eb$var$CanonicalService {
    static $inject = [
        "$document",
        "$location",
        "seoRanking"
    ];
    constructor($document, $location, seoRanking){
        this.$document = $document[0];
        this.$location = $location;
        this.seoRanking = seoRanking;
        this.targetNode = this.$document.querySelector('meta[name="description"]');
    }
    init() {
        let canonicalNode = this.$document.head.querySelector('link[rel="canonical"]');
        if (canonicalNode === null) {
            canonicalNode = this.$document.createElement("link");
            canonicalNode.setAttribute("rel", "canonical");
        }
        canonicalNode.setAttribute("href", `${$_CDN.canonical}${this.$location.path()}`);
        return canonicalNode;
    }
    update() {
        const isPageRanged = this.seoRanking.check();
        const canonical = this.init();
        if (!isPageRanged) {
            if (canonical.parentNode) canonical.parentNode.removeChild(canonical);
            return;
        }
        this.targetNode.after(canonical);
    }
}
app.service("canonicalService", $ea3cd86189a691eb$var$CanonicalService);


class $f67e78ac799a7f5d$var$LindaSeoDirective {
    static $inject = [
        "seo",
        "config",
        "$location",
        "$state",
        "$transitions",
        "state",
        "titleService",
        "descriptionService",
        "keywordsService",
        "ogTitleService",
        "ogDescriptionService",
        "alternateService",
        "hrefLangService",
        "ogUrlService",
        "twitterSiteService",
        "metaCharsetService",
        "linkedDataService",
        "robotsService",
        "canonicalService"
    ];
    constructor(seo, config, $location, $state, $transitions, state, titleService, descriptionService, keywordsService, ogTitleService, ogDescriptionService, alternateService, hrefLangService, ogUrlService, twitterSiteService, metaCharsetService, linkedDataService, robotsService, canonicalService){
        this.seo = seo;
        this.config = config;
        this.$location = $location;
        this.$state = $state;
        this.$transitions = $transitions;
        this.state = state;
        this.titleService = titleService;
        this.descriptionService = descriptionService;
        this.keywordsService = keywordsService;
        this.ogTitleService = ogTitleService;
        this.ogDescriptionService = ogDescriptionService;
        this.alternateService = alternateService;
        this.hrefLangService = hrefLangService;
        this.ogUrlService = ogUrlService;
        this.twitterSiteService = twitterSiteService;
        this.metaCharsetService = metaCharsetService;
        this.linkedDataService = linkedDataService;
        this.robotsService = robotsService;
        this.canonicalService = canonicalService;
    }
    link(scope) {
        this.hrefLangService.render();
        const clearName = ()=>{
            return this.$location.path().substring(4).replace(/\//g, "__") || "home";
        };
        this.$transitions.onSuccess({}, ()=>{
            this.robotsService.update();
            this.canonicalService.update();
            this.alternateService.update();
            this.ogUrlService.update();
            this.twitterSiteService.update();
            this.seo.item({
                id: clearName()
            }).then(({ result: result })=>{
                const { title: title, description: description, keywords: keywords, jsonLd: jsonLd } = result;
                this.seo.meta$.next({
                    event: "title updated",
                    title: title
                });
                this.titleService.update(title);
                this.descriptionService.update(description);
                this.keywordsService.update(keywords);
                this.ogTitleService.update(title);
                this.ogDescriptionService.update(description);
                this.linkedDataService.update(jsonLd);
            }).catch((error)=>{
                if (this.config.redirectToNotFound === true && error.status === 404) this.state.goto("notFound");
            });
        });
    }
}
app.directive("lindaSeo", ()=>{
    return {
        restrict: "A",
        controller: $f67e78ac799a7f5d$var$LindaSeoDirective,
        link: function(scope, element, attrs, ctrl) {
            ctrl.link(scope);
        }
    };
});


var $bfa30e46d0dc3574$exports = {};


(function() {
    "use strict";
    app.directive("lindaSplash", controller);
    controller.$inject = [
        "splash$"
    ];
    function controller(_splash$) {
        function link(scope, element) {
            const subscription = _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded")).subscribe(()=>{
                element.addClass("loaded");
            });
            scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
})();


var $ce84d27d5c55cd19$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "user"
    ];
    function controller(_http, $q, _user) {
        const betslipUpdate$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        return {
            launch (options) {
                const defer = $q.defer();
                const alias = "sportLaunch";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            feed (options) {
                const defer = $q.defer();
                const alias = "sportFeed";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            check (options) {
                const defer = $q.defer();
                const alias = "sportCheck";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, options, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            betslipUpdate$: betslipUpdate$
        };
    }
    app.factory("sport", controller);
})();












(function() {
    "use strict";
    controller.$inject = [
        "banner",
        "config",
        "state",
        "analytics",
        "$window"
    ];
    function controller(_banner, _config, _state, _analytics, $window) {
        return {
            altenarFromConfig () {
                const places = [];
                const pages = new Map();
                $window.addEventListener("message", ({ data: { fromSportBanner: fromSportBanner } })=>{
                    if (!fromSportBanner) return;
                    const { alias: alias, param: param, analytics: analytics } = fromSportBanner;
                    if (analytics) _analytics.send(...analytics);
                    _state.goto(alias, param);
                });
                return new Promise((resolve, reject)=>{
                    const result = {};
                    const configBanners = _config?.sportBanners ? _config.sportBanners : {
                        bottomRight: {
                            place: "inframe_banner1"
                        }
                    };
                    const createItem = (item)=>{
                        if (configBanners[item]?.options) {
                            const { height: height = null, width: width = null, target: target = null, ratio: ratio = null, devices: devices = null } = configBanners[item].options;
                            return Object.assign({}, height && {
                                height: height
                            }, width && {
                                width: width
                            }, target && {
                                target: target
                            }, ratio && {
                                ratio: ratio
                            }, devices && {
                                devices: devices
                            });
                        }
                        return;
                    };
                    const getAllBannersFromPlace = (places)=>{
                        const promises = places.map((el, index)=>{
                            if (configBanners[el]?.options && configBanners[el]?.options?.pages) pages.set(index, [
                                ...configBanners[el].options.pages
                            ]);
                            return _banner.collection({
                                place: configBanners[el].place
                            });
                        });
                        const dataFromPromises = Promise.all(promises).then((data)=>{
                            data.forEach((bannerFromPlace, index)=>{
                                if (bannerFromPlace.result.length) bannerFromPlace.result.forEach((banner)=>{
                                    if (pages.get(index)) {
                                        pages.get(index).forEach((page)=>{
                                            result[page][places[index]].push({
                                                url: banner.images.big,
                                                link: banner.url,
                                                ...createItem(places[index])
                                            });
                                        });
                                        return;
                                    }
                                    result[places[index]].push({
                                        url: banner.images.big,
                                        link: banner.url,
                                        ...createItem(places[index])
                                    });
                                });
                            });
                            return result;
                        }).catch((error)=>{
                            reject(error);
                        });
                        dataFromPromises.then(()=>resolve(dataFromPromises));
                    };
                    const configureItemWithOptions = (item, el)=>{
                        if (item.options?.pages) item.options.pages.forEach((page)=>{
                            if (!result?.[page]) result[page] = {};
                            if (!result[page]?.[el]) result[page][el] = [];
                        });
                        if (item?.iframe) {
                            if (item.options?.pages) {
                                for(let i = 0; i < item.options.pages.length; i++)result[item.options.pages[i]][el].push({
                                    url: item.iframe + "?lang=" + _config.currentLang,
                                    ...createItem(el)
                                });
                                return;
                            }
                            if (!result?.[el]) result[el] = [];
                            result[el].push({
                                url: item.iframe + "?lang=" + _config.currentLang,
                                ...createItem(el)
                            });
                        }
                        if (item?.place) places.push(el);
                    };
                    const configureItemWithoutOptions = (item, el)=>{
                        if (!result?.[el]) result[el] = [];
                        if (item?.iframe) {
                            result[el].push({
                                url: item.iframe + "?lang=" + _config.currentLang
                            });
                            return;
                        }
                        if (item?.place) places.push(el);
                    };
                    Object.keys(configBanners).forEach((el)=>{
                        if (configBanners[el]?.options) {
                            configureItemWithOptions(configBanners[el], el);
                            return;
                        }
                        configureItemWithoutOptions(configBanners[el], el);
                    });
                    getAllBannersFromPlace(places);
                });
            }
        };
    }
    app.factory("sportBannerConfig", controller);
})();





// let BIA = {};
(function() {
    "use strict";
    const name = "lindaSportField";
    const hash = "BIAcc";
    let request = null;
    let session_id = null;
    let subscription = null;
    controller.$inject = [
        "$state",
        "sport",
        "config",
        "popup",
        "user$",
        "system$",
        "timer$",
        "state",
        "banner",
        "sportBannerConfig",
        "system",
        "$window"
    ];
    function controller($state, _sport, _config, _popup, _user$, _system$, _timer$, _state, _banner, _sportBannerConfig, _system, $window) {
        function link(scope, element, attrs) {
            const scrollElement = document.querySelector("[scroll-element]");
            const _scrollElement$ = scrollElement ? (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(scrollElement, "scroll") : new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            scope.preloader = false;
            let options = {};
            let BIA = {};
            attrs.$set("id", hash);
            action($state.params);
            scope.$on("$stateChangeSuccess", ()=>{
                action($state.params);
            });
            function action(val) {
                element.addClass("loading");
                const params = Object.assign({}, val);
                delete params.lang;
                if (!angular.isFunction(BIA.setParam)) init(params);
                else change(params);
            }
            function change(pm) {
                for(const pr in pm)if (pm.hasOwnProperty(pr)) BIA.setParam(pr, pm[pr], true);
                BIA.setParam("page", pm.page);
            }
            async function init(pm) {
                scope.preloader = true;
                const systemInfo = await _system.info();
                const sport = await _sport.launch({
                    code: "sport"
                });
                let banners;
                _sportBannerConfig.altenarFromConfig().then((data)=>{
                    banners = data;
                }).catch((err)=>console.error(err)).finally(()=>{
                    scope.preloader = false;
                    final();
                });
                session_id = sport.result.session_id;
                const final = ()=>{
                    options = Object.assign({}, sport.result.launch_options, {
                        mobile: _config.device.mobile,
                        // intervalDelay: 0,
                        fixedBottom: _config.sport.fixedBottom,
                        fixedTop: _config.sport.fixedTop,
                        showLoginBoxCallback: showLoginBoxCallback,
                        insufficientbalancecallback: insufficientbalancecallback,
                        statechangeCallback: statechangeCallback,
                        betslipoddscountchangecallback: betslipoddscountchangecallback,
                        loadCallback: loadCallback,
                        isHashMode: $state.params?.isHashMode || false,
                        banners: banners
                    }, _config.sport.initializationParams, pm);
                    if (systemInfo?.result?.country.code === "CA") options.oddstype = "american";
                    if ($window.AltenarBetslipOddIds) {
                        options.betslipOddIds = [];
                        options.betslipOddIds.push(...$window.AltenarBetslipOddIds);
                    }
                    $window.AltenarBetslipOddIds = undefined;
                    const ident = setInterval(()=>{
                        if (typeof BetinactionAPI === "function") {
                            BIA = new BetinactionAPI(`#${hash}`, options);
                            clearInterval(ident);
                        }
                        if (typeof AltenarSportsbook === "function") {
                            BIA = new AltenarSportsbook(`#${hash}`, options);
                            clearInterval(ident);
                        }
                    }, 20);
                };
            }
            _sport.betslipUpdate$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((id)=>BIA.setParam("betslipoddids", id));
            if (_config.jurisdiction === "sweden" && !subscription) subscription = _timer$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $0fcfe63c48d698bc$export$8916d2c8119541bb)(10)).subscribe(()=>{
                if (!request) {
                    request = true;
                    _sport.check({
                        session_id: session_id,
                        code: "sport"
                    }).then(()=>{}).catch((e)=>{
                        if (e.messages[0].code === 2806) {
                            _state.goto("home");
                            subscription.unsubscribe();
                        }
                    }).finally(()=>request = false);
                }
            });
            _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "login")).subscribe(()=>{
                _sport.launch({
                    code: "sport"
                }).then((a)=>{
                    options = a.result.launch_options;
                    BIA.setParam("token", options.token);
                }).catch((err)=>console.error(err));
            });
            _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "logout")).subscribe(()=>BIA.setParam("token", ""));
            _scrollElement$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe(()=>BIA.setParam("fixedBottom", _config.sport.fixedBottom));
            function showLoginBoxCallback() {
                _popup.open({
                    name: "login"
                });
            }
            function insufficientbalancecallback() {
                if (!_config.sport.insufficientbalancecallback) return;
                _popup.open({
                    name: "sport-low-balance"
                });
            }
            function scrollToTop() {
                Array.prototype.find.call(document.querySelectorAll("*"), ({ scrollTop: scrollTop })=>scrollTop > 0)?.scroll(0, 0);
            }
            function statechangeCallback(state) {
                const params = Object.assign({}, {
                    sportids: null,
                    catids: null,
                    champids: null,
                    tabs: null,
                    eventid: null,
                    raceid: null
                }, state);
                params.name = params.page;
                if (params.name === "betslip") scrollToTop();
                delete params.page;
                $state.go(".", params, {
                    notify: false
                });
            }
            function loadCallback() {
                element.removeClass("loading");
            }
            const betslipoddscountchangecallback = (oddIds)=>{
                if ($window.altenarWSDK?.set) {
                    $window.altenarWSDK.set({
                        oddIds: oddIds,
                        clearBetSlip: true
                    });
                    return;
                }
            };
            scope.$on("$destroy", ()=>{
                BIA.destroy();
                destroy$.next();
                destroy$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $cc6a1ba779007f7a$exports = {};







(function() {
    "use strict";
    const name = "lindaSportRace";
    controller.$inject = [
        "$state",
        "sport",
        "config",
        "system$",
        "user",
        "state"
    ];
    function controller($state, _sport, _config, system$, _user, _state) {
        function link($scope, $element) {
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const message$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "message");
            $scope.preloader = false;
            init();
            message$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.origin === "https://bet-j.com" || message.origin === "https://latrobet28.com")).subscribe((message)=>{
                let horseAlias = message.data;
                const urlPrefix = "URL:";
                if (horseAlias.startsWith(urlPrefix)) horseAlias = horseAlias.split(":")[1];
                if (message.data) _state.goto(horseAlias);
            });
            function init() {
                launchFrame();
                if (!_user.status) system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((event)=>event.action === "statusChanged")).subscribe(launchFrame);
            }
            function launchFrame() {
                getLaunchCode().then(appendFrame).catch(()=>{
                    $scope.preloader = false;
                });
            }
            function getLaunchCode() {
                return new Promise((resolve, reject)=>{
                    $scope.preloader = true;
                    const body = {
                        code: "sport-latrobet"
                    };
                    _sport.launch(body).then(({ result: result })=>{
                        resolve(result);
                    }).catch((err)=>reject(err));
                });
            }
            function appendFrame(settings) {
                const frame = document.createElement("iframe");
                const horseCategory = $state.params.category;
                const url = new URL(settings.url);
                const horseRacingRedirects = {
                    horseRacing: "/Home/raceMenu?sportId=9001",
                    harness: "/Home/raceMenu?sportId=9002",
                    greyhound: "/Home/raceMenu?sportId=9003",
                    nextToJump: "/Home/NextToJump?sportId=9004"
                };
                url.searchParams.append("redirect", horseRacingRedirects[horseCategory]);
                frame.classList.add("linda-racing-frame");
                frame.src = url.href;
                frame.style.border = "0";
                frame.onload = ()=>{
                    $scope.$evalAsync(()=>$scope.preloader = false);
                };
                frame.onerror = ()=>{
                    $scope.$evalAsync(()=>$scope.preloader = false);
                };
                if (_config.device.mobile) {
                    frame.style.height = settings.mobile && settings.mobile.height || "100%";
                    frame.style.width = settings.mobile && settings.mobile.width || "100%";
                } else {
                    frame.style.height = settings.desktop && settings.desktop.height || "100%";
                    frame.style.width = settings.desktop && settings.desktop.width || "100%";
                }
                $element[0].innerHTML = "";
                $element.append(frame);
                return frame;
            }
            $scope.$on("$destroy", ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $fc63954ea994e4d7$exports = {};



(function() {
    "use strict";
    app.factory("altenar.config", controller);
    controller.$inject = [];
    function controller() {
        return Object.assign({}, {
            widget: {},
            version: "3"
        }, $_ALTENARCONFIG);
    }
})();



(function() {
    "use strict";
    const name = "lindaSportWidgetV3";
    // - TODO change this shit code Altenar widget versioning const version
    const versionWhenAltenarRanamedSkinNameFieldToIntegration = 0.014; // if version 0.14, example: if 0.14.0332 paste 0.0140332
    // !!! AltenarWidget initialization REMOVE all classes and id from element
    //
    // Use example
    // linda-sport-widget-v3="{
    //      type: 'WTabbedEventsByType',                          https://sb2wsdk-altenar2-stage.biahosted.com/docs/index.html?path=/docs/widgets-wtabbedeventsbytype--live-now
    //      topEventsType: 'liveNow',                             - Type of displayed events: "liveNow", "highlights", "upcoming"
    //      eventCount: 3,                                        - Number of displayed events: number
    //      scrollerControls: 2,                                  - 0 - side arrows are displayed, 1 - side arrows are not displayed, 2 - side arrows are displayed automatically
    //      pathToLogosDirectory: 'https://url.com/directory'     - path to directory with sport event logos
    // }"
    controller.$inject = [
        "state",
        "config",
        "altenar.config",
        "sport",
        "$state",
        "system",
        "$window"
    ];
    function controller(_state, _config, _altenar_config, _sport, $state, _system, $window) {
        const currentLang = $state.params.lang;
        const altenarConfig = _config.altenar || {
            widget: {
                integration: "sportaza"
            }
        };
        // - TODO change this shit code Altenar widget versioning
        const parseVersionFloat = (versionString)=>{
            const versionArray = ("" + versionString).replace(/[^0-9.]/g, "").split(".");
            let sum = 0;
            for(let i = 0; i < versionArray.length; ++i)sum += Number(versionArray[i]) / Math.pow(10, i * 3);
            return sum;
        };
        const setIntegrationParam = ()=>{
            const defaultIntegrationParam = altenarConfig.widget?.integration;
            const countryCode = _system.systemInfo.country.code.toUpperCase();
            const localIntegrationParam = $_CDN?.sportConfig?.localizationIds?.[countryCode];
            return localIntegrationParam || defaultIntegrationParam;
        };
        const ident = setInterval(()=>{
            if ($window.AltenarWidgetScriptLoaded === true) {
                let objectInitialization = {};
                const { langReplacements: langReplacements } = $window.$_DICT.sportWidget;
                const integration = setIntegrationParam();
                const countryCode = _system.systemInfo.country.code.toUpperCase();
                parseVersionFloat($window.altenarWSDKVersion) < versionWhenAltenarRanamedSkinNameFieldToIntegration ? objectInitialization = {
                    skinName: integration
                } : objectInitialization = {
                    integration: integration
                };
                objectInitialization.culture = langReplacements[currentLang] || "en-GB";
                if (countryCode === "CA") objectInitialization.oddsFormat = 2;
                $window.altenarWSDK.init(objectInitialization);
                clearInterval(ident);
            }
        }, 20);
        const link = (scope, element, attrs)=>{
            let instance = {
                remove () {}
            };
            const widgetOptions = scope.$eval(attrs.lindaSportWidgetV3);
            let props = {};
            function onEventSelect(event) {
                _state.goto("sport", {
                    sportids: event.sportId,
                    champids: event.champId,
                    eventid: event.id
                });
            }
            const getOddsFromStorage = ()=>{
                const items = JSON.parse(localStorage.getItem(`WSDK_american_betSelections`));
                return items.state.oddIds;
            };
            function onOddSelect(event) {
                $window.AltenarBetslipOddIds = getOddsFromStorage();
                _sport.betslipUpdate$.next($window.AltenarBetslipOddIds);
                _state.goto("sport", {
                    champids: event.champId,
                    eventid: event.eventId
                });
            }
            switch(widgetOptions.type){
                case "WTopEventsCarousel":
                    props = {
                        eventCount: widgetOptions.eventCount || 7,
                        scrollerControls: widgetOptions.scrollerControls ?? 2,
                        sportId: widgetOptions.sportId || 0,
                        onEventSelect: onEventSelect,
                        onOddSelect: onOddSelect,
                        variants: {
                            OddBox: 2
                        },
                        competitorLogoURL: widgetOptions.pathToLogosDirectory ? `${widgetOptions.pathToLogosDirectory}{0}.png` : `${_config.apiUrl}/dimg/altenar_logo/{0}.png`
                    };
                    break;
                case "WLiveStreaming":
                    props = {
                        onOddSelect: onOddSelect
                    };
                    break;
                case "WBannerBetReservation":
                    break;
                case "WEventCard":
                    break;
                case "WTabbedEventsByType":
                default:
                    props = {
                        topEventsType: widgetOptions.topEventsType || "liveNow",
                        eventCount: widgetOptions.eventCount || 7,
                        sportId: widgetOptions.sportId || 0,
                        onEventSelect: onEventSelect,
                        onOddSelect: onOddSelect,
                        variants: {
                            EventList: 1
                        }
                    };
                    break;
            }
            function buildConfig() {
                const config = {
                    widget: widgetOptions.type || "WTabbedEventsByType",
                    props: props,
                    container: element[0]
                };
                switch(widgetOptions.type){
                    case "WTopEventsCarousel":
                        if (_altenar_config.widget.carousel) config.tokens = _altenar_config.widget.carousel;
                        break;
                    case "WLiveStreaming":
                        if (_altenar_config.widget.streaming) config.tokens = _altenar_config.widget.streaming;
                        break;
                    default:
                        if (_altenar_config.widget.tokens) config.tokens = _altenar_config.widget.tokens[widgetOptions.topEventsType];
                }
                return config;
            }
            const ident = setInterval(()=>{
                if ($window.AltenarWidgetScriptLoaded === true) {
                    const config = buildConfig();
                    instance = $window.WTEC = $window.altenarWSDK.addWidget(config);
                    clearInterval(ident);
                }
            }, 20);
            scope.$on("$destroy", ()=>{
                if (instance) instance.remove();
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $739f7bef2df58b9e$exports = {};

(function() {
    "use strict";
    const name = "lindaSportWidget";
    // !!! AltenarWidget initialization REMOVE all classes and id from element
    //
    // Use example
    // linda-sport-widget="{
    //      type: 'WLivenow',    - optional option; type: string; values: WLivenow, WHighlights, WUpcoming; default: 'WLivenow'
    //      maxTabs: 3          - optional option; type:number; default: 3
    // }"
    controller.$inject = [
        "state"
    ];
    function controller(_state) {
        const link = (scope, element, attrs)=>{
            let AW = {};
            const options = scope.$eval(attrs.lindaSportWidget);
            const hash = `sportWidget${options.type}${Date.now()}`;
            attrs.$set("id", hash);
            const ident = setInterval(()=>{
                if (angular.isFunction(AltenarWidget)) {
                    const params = {
                        widget: options.type || "WLivenow",
                        maxTabs: options.maxTabs || 3,
                        eventclickcallback: (eventid)=>{
                            _state.goto("sportEvent", {
                                eventid: eventid
                            });
                        }
                    };
                    AW = new AltenarWidget(`#${hash}`, params);
                    clearInterval(ident);
                }
            }, 20);
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $6073874ab5760ae1$exports = {};
(function() {
    const directive = {
        name: "lindaSwiper"
    };
    controller.$inject = [
        "$q"
    ];
    function controller($q) {
        const defered = $q.defer();
        const script = document.createElement("script");
        const target = document.scripts[document.scripts.length - 1];
        const src = "https://unpkg.com/swiper@7.4.1/swiper-bundle.min.js";
        script.async = true;
        script.src = src;
        script.onload = onload;
        target.parentElement.insertBefore(script, target.nextSibling);
        function onload() {
            defered.resolve();
        }
        const link = (scope, element, attrs)=>{
            const givenConfig = scope.$eval(attrs[directive.name]) || {};
            const name = scope.$eval(attrs["name"]) || "swiper";
            const defaultConfig = {};
            const config = Object.assign(defaultConfig, givenConfig);
            defered.promise.then((a)=>{
                scope[name] = new Swiper(element[0], config);
            }).catch((e)=>{});
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $23db80bbe0584822$exports = {};








(function() {
    "use strict";
    const name = "lindaTglabSportField";
    const id = "sb_rooter";
    controller.$inject = [
        "eeSport",
        "helper",
        "$location",
        "state",
        "$window",
        "system$",
        "$transitions",
        "config"
    ];
    function controller(_eeSport, helper, $location, state, $window, _system$, $transitions, _config) {
        const tglabCode = "sport-tglab";
        $window.__SB_INIT__ = {
            config: {}
        };
        function link($scope, $element, $attrs) {
            $scope.preloader = true;
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const config = $scope.$eval($attrs[name]);
            const livePath = `/${config.live}` || "/live";
            const prelivePath = `/${config.prelive}` || "/sport";
            $element[0].setAttribute("id", id);
            _eeSport.launch({
                code: tglabCode
            }).then((answer)=>{
                const { host: host, ...options } = answer.result.launch_options;
                $window.__SB_INIT__.config = Object.assign({}, {
                    jquery: true,
                    live_path: `${_config.currentLang}${livePath}`,
                    pre_path: `${_config.currentLang}${prelivePath}`
                }, options);
                helper.dom.addScript(host);
                $window.betSlipLoaded = ()=>{
                    $window.ExternalBetSlipLogin = ()=>{
                        state.goToAuthorization();
                    };
                    $window.ExternalDepositClick = ()=>{
                        state.goto("deposit");
                    };
                    $transitions.onSuccess({}, function(transition) {
                        const optionsTarget = transition.options().relative;
                        if (optionsTarget !== null) $window.externalSBReload();
                    });
                };
            }).catch((err)=>{
                console.error(err);
            }).finally(()=>$scope.preloader = false);
            _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "login")).subscribe(()=>{
                _eeSport.launch({
                    code: tglabCode
                }).then((answer)=>{
                    const { token: token } = answer.result.launch_options;
                    $window.__SB_INIT__.config.token = token;
                    $window.betSlipLoginOnSuccess();
                }).catch((e)=>console.error(e));
            });
            $scope.$on("$destroy", ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link,
            bindings: "<"
        };
    }
    app.directive(name, controller);
})();


var $6ffaa96fe94b6c99$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "timer$",
        "$filter"
    ];
    function controller(_timer$, $filter) {
        const link = (scope, element, attrs)=>{
            const format = "HH:mm:ss";
            let timer = 0;
            element[0].innerHTML = $filter("date")(new Date(0, 0, 0).setSeconds(timer), format);
            _timer$.subscribe((item)=>{
                element[0].innerHTML = $filter("date")(new Date(0, 0, 0).setSeconds(timer++), format);
            });
            const stopObserving = attrs.$observe("lindaTimer", (newVal)=>{
                timer = newVal || 0;
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaTimer", controller);
})();


var $1d6117884ce4e457$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "lindaToggleFavourite"
    };
    controller.$inject = [
        "game",
        "system$"
    ];
    function controller(_game, _system$) {
        const className = "f_active";
        function link(scope, element, attrs) {
            let game;
            attrs.$observe(directive.name, (newName)=>{
                game = newName;
                element.toggleClass(className, _game.favourite.check(game));
            });
            element.on("click", (e)=>{
                element.toggleClass(className, _game.favourite.toggle(game));
                _system$.next({
                    action: "renew favourite"
                });
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c74f48ffa9903e97$exports = {};



(function() {
    "use strict";
    const name = "lindaTranslate";
    controller.$inject = [
        "$compile",
        "$translate",
        "contentBuffer",
        "user",
        "config"
    ];
    function controller($compile, $translate, _contentBuffer, _user, _config) {
        function link(scope, element, attrs) {
            const { profile: profile, balance: balance, bonus: bonus, currency: currency, login: login } = _user.profile;
            const bucket = {
                user: {
                    profile: profile,
                    balance: balance,
                    bonus: bonus,
                    currency: currency,
                    login: login,
                    activeBonus: _user.activeBonus
                },
                data: _contentBuffer.read("modal") ? _contentBuffer.read("modal").data : _contentBuffer.read("popup") ? _contentBuffer.read("popup").data : null,
                links: _config.links,
                scope: scope
            };
            attrs.$observe(name, (key)=>{
                $translate(key, bucket).then((template)=>{
                    element.html(template);
                    $compile(element.contents())(scope);
                }, (key)=>{});
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $98d21a092ffd696c$exports = {};
(function() {
    "use strict";
    controller.$inject = [
        "$state",
        "$stateParams"
    ];
    function controller($state, $stateParams) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs.lindaUiSrefInclude);
            function toggleClass(c) {
                const s = c.state.replace(/ /g, "").split(",");
                if (s.filter((i)=>$state.includes(i)).length) element.addClass(c.class);
                else element.removeClass(c.class);
            }
            toggleClass(config);
            scope.$on("$stateChangeSuccess", ()=>{
                toggleClass(config);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive("lindaUiSrefInclude", controller);
})();


var $a7ad5b81c232c1cf$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "lindaValidateBirthdayFormat"
    };
    app.directive(directive.name, controller);
    function controller() {
        function link(scope, element, attrs, ctrl) {
            const getIsoFormat = (value)=>{
                // return value in YYYY-MM-DD format
                if (!value) return;
                const splittedDate = value.split("-");
                // check if value has DD-MM-YYYY format
                if (!isNaN(new Date(`${splittedDate[1]}-${splittedDate[0]}-${splittedDate[2]}`).getTime())) return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
                // else use MM-DD-YYYY format
                return `${splittedDate[2]}-${splittedDate[0]}-${splittedDate[1]}`;
            };
            const validator = (value)=>{
                // value format is YYYY-MM-DD
                if (isNaN(new Date(value).getTime())) return false;
                if (new Date(value).getUTCDate() !== Number(value.split("-")[2])) return false;
                const userAgeInMs = new Date().getTime() - new Date(value).getTime();
                const userAge = Math.floor(userAgeInMs / 31557600000);
                return userAge >= 18 && userAge <= 100;
            };
            ctrl.$validators.over18 = function(modelValue, viewValue) {
                const value = modelValue || viewValue;
                return validator(value);
            };
            ctrl.$parsers.push(function(modelValue, viewValue) {
                const value = modelValue || viewValue;
                return getIsoFormat(value);
            });
            ctrl.$formatters.push((value)=>{
                if (value) {
                    const splittedDate = value.split("-");
                    if (splittedDate[0].length === 4) return splittedDate.reverse().join("-");
                    return value;
                }
                return;
            });
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel"
        };
    }
})();


var $8165a00fed31e915$exports = {};
(function() {
    "use strict";
    app.directive("lindaValidateBirthday", controller);
    function controller() {
        function link(scope, element, attrs, ctrl) {
            ctrl.$parsers.push((value)=>validator(value));
            function validator(value) {
                const minAge = 18;
                const maxAge = 100;
                const birthdayTimestamp = Date.parse(value);
                const currentDateTimestamp = new Date().getTime();
                const userAgeTimestamp = currentDateTimestamp - birthdayTimestamp; /* вік юзера в мілісекундах */ 
                const userAge = Math.floor(userAgeTimestamp / 3153.6e7); /* мілісекунди перевести в роки */ 
                const conditions = [
                    userAge >= minAge && userAge <= maxAge || !value
                ];
                ctrl.$setValidity("over18", conditions[0]);
                return conditions.every((i)=>i === true) ? value : undefined;
            }
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel"
        };
    }
})();


var $337ca68454f7477c$exports = {};





(function() {
    "use strict";
    const directive = {
        name: "lindaVision"
    };
    controller.$inject = [
        "user$",
        "user",
        "system$",
        "config"
    ];
    function controller(_user$, _user, _system$, _config) {
        function link(scope, element, attrs) {
            if (typeof vision !== "object") return;
            vision.setLang(_config.currentLang);
            _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "systemInfo")).subscribe((m)=>{
                vision.setSession(m.data);
            });
            _user$.subscribe((user)=>{
                vision.setUser(_user);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $a3c3ccfebe819ead$exports = {};







(function() {
    controller.$inject = [
        "$q",
        "http"
    ];
    function controller($q, _http) {
        return {
            sendInfoMessage (options) {
                const defer = $q.defer();
                const alias = "infoToZendesk";
                const data = {
                    options: options
                };
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("zendesk", controller);
})();


(function() {
    const name = "lindaZendesk";
    controller.$inject = [
        "system$",
        "user",
        "splash$",
        "config",
        "zendesk",
        "$window"
    ];
    function controller(_system$, _user, _splash$, _config, _zendesk, $window) {
        const chatActivation$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const openChatEvent$ = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "open chat"));
        (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)(chatActivation$, openChatEvent$).subscribe(([openChatCb])=>openChatCb());
        let chatIsOpen = false;
        const link = ()=>{
            function activateChat() {
                sendWidgetMeta();
                zE.activate();
                chatIsOpen = true;
                identify(_user);
                if (_user.status) _zendesk.sendInfoMessage();
            }
            const scriptZendesk = document.createElement("script");
            scriptZendesk.id = "ze-snippet";
            scriptZendesk.src = `${$_CDN.zendesk.sdk}?key=${$_CDN.zendesk.key}`;
            const target = document.scripts[document.scripts.length - 1];
            target.parentElement.insertBefore(scriptZendesk, target.nextSibling);
            const config = {
                userName: _user.status ? _user.profile.login : null,
                userIsVip: false,
                userLanguage: $_DICT.zendesk?.langReplacements?.[_config.currentLang] || _config.currentLang
            };
            let chatTags;
            scriptZendesk.onload = ()=>{
                initZendeskChat(config.userLanguage, config.userName, config.userIsVip);
            };
            function identify({ profile: profile, status: status }) {
                if (!status) return;
                zE("webWidget", "identify", {
                    name: `${profile.profile.name} ${profile.profile.surname}`,
                    email: profile.email
                });
            }
            function initZendeskChat(userLanguage = "en", userName, userIsVip) {
                const code = $_CDN.zendesk.code;
                const license = $_CDN.zendesk.license;
                const brand = $_CDN.zendesk.brand;
                const theme = $_CDN.zendesk.theme;
                const analytics = $_CDN.zendesk.analytics ? $_CDN.zendesk.analytics : false;
                let userId = userName ? `${_user.profile.prefix}${userName}` : userName;
                let userVipLabel = _user.profile.level_v2_label;
                const department = getDepartment();
                const webWidgetSettings = {
                    webWidget: {
                        color: {
                            theme: theme
                        },
                        chat: {
                            departments: {
                                select: department,
                                enabled: []
                            }
                        }
                    },
                    analytics: analytics
                };
                chatTags = [
                    userLanguage,
                    license,
                    brand,
                    code
                ];
                if (userId) chatTags.push(userId);
                if (userId && userVipLabel) chatTags.push(userVipLabel);
                if (userId && userIsVip) chatTags.push("vip");
                zE("webWidget", "hide");
                $window.zESettings = webWidgetSettings;
                zE("webWidget:on", "chat:connected", function() {
                    const availableDepartments = [];
                    zE("webWidget", "updateSettings", {
                        webWidget: {
                            chat: {
                                departments: {
                                    select: department,
                                    enabled: availableDepartments
                                }
                            }
                        }
                    });
                    webWidgetSettings.webWidget.chat.enabled = availableDepartments;
                    chatActivation$.next(activateChat);
                });
                function getDepartment() {
                    const language = userLanguage || "en";
                    return `${license} ${userIsVip ? `+ VIP ` : ""}+ ${language.toUpperCase()}`;
                }
                _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
                    if (chatIsOpen) _zendesk.sendInfoMessage();
                    userId = `${_user.profile.prefix}${userName}`;
                    userVipLabel = _user.profile.level_v2_label;
                    userIsVip = false;
                    if (userIsVip) chatTags.push("vip");
                    if (userVipLabel) {
                        zE("webWidget", "chat:addTags", [
                            userId,
                            userVipLabel
                        ]);
                        return;
                    }
                    zE("webWidget", "chat:addTags", [
                        userId
                    ]);
                });
                _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "logout")).subscribe(()=>{
                    zE("webWidget", "hide");
                    zE("webWidget", "clear");
                    chatIsOpen = false;
                });
            }
            function sendWidgetMeta() {
                zE("webWidget", "setLocale", config.userLanguage);
                zE("webWidget", "chat:addTags", [
                    chatTags
                ]);
            }
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $adb5a242abf5b958$exports = {};
// https://mymth.github.io/vanillajs-datepicker/#/
(function() {
    const directive = {
        name: "balanceFlowDatepicker"
    };
    function controller() {
        function link($scope, $element, $attrs, $ngModelCtrl) {
            const element = $element[0];
            const defaultFormat = "yyyy-mm-dd";
            const { modelFormat: modelFormat = defaultFormat, viewFormat: viewFormat = defaultFormat } = $scope.$eval($attrs[directive.name]) || {};
            let changeFromModel = false;
            const updateModel = (modelValue)=>{
                $scope.$apply(()=>$ngModelCtrl.$setViewValue(modelValue));
            };
            const datepickerOptions = {
                autohide: true,
                format: viewFormat
            };
            const datepickerInstance = new Datepicker(element, datepickerOptions);
            element.addEventListener("changeDate", ()=>{
                if (changeFromModel) return changeFromModel = false;
                const formattedPickedDate = datepickerInstance.getDate(modelFormat);
                updateModel(formattedPickedDate);
            });
            $scope.$on("$destroy", ()=>{
                datepickerInstance.destroy();
            });
            $ngModelCtrl.$parsers.push((value)=>{
                return value.toISOString();
            });
            $ngModelCtrl.$formatters.push((value)=>{
                if (value) {
                    const result = new Date(value);
                    changeFromModel = true;
                    datepickerInstance.setDate(result);
                    return result;
                }
                return null;
            });
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel",
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $e037e70aa6e15025$exports = {};
(function() {
    const directive = {
        name: "balanceHistoryDateFormatter"
    };
    function controller() {
        function link(scope, element, attrs, ctrl) {
            ctrl.$parsers.push((value)=>{
                return value.toISOString();
            });
            ctrl.$formatters.push((value)=>{
                if (value) {
                    const result = new Date(value);
                    return result;
                }
                return null;
            });
        }
        return {
            require: "ngModel",
            link: link,
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $1d1aca9a85516903$exports = {};


(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("history$", controller);
})();



(function() {
    "use strict";
    function getUrlStringService() {
        return function getUrlString(params, keys = [], isArray = false) {
            const url = Object.keys(params).map((key)=>{
                const val = params[key];
                if ("[object Object]" === Object.prototype.toString.call(val) || angular.isArray(val)) {
                    if (angular.isArray(params)) keys.push("");
                    else keys.push(key);
                    return getUrlString(val, keys, angular.isArray(val));
                }
                let tKey = key;
                if (keys.length > 0) {
                    const tKeys = isArray ? keys : [
                        ...keys,
                        key
                    ];
                    tKey = tKeys.reduce((str, val)=>{
                        return "" === str ? val : `${str}[${val}]`;
                    }, "");
                }
                if (isArray) return `${tKey}[]=${val}`;
                return `${tKey}=${val}`;
            }).join("&");
            keys.pop();
            return url;
        };
    }
    app.factory("getUrlString", getUrlStringService);
})();


(function() {
    "use strict";
    const getYesterday = ()=>{
        const now = new Date();
        now.setDate(now.getDate() - 1);
        return now;
    };
    controller.$inject = [
        "$q",
        "http",
        "$httpParamSerializer",
        "getUrlString"
    ];
    function controller($q, _http, $httpParamSerializer, getUrlString) {
        return {
            getFormattedYesterday () {
                const yesterday = getYesterday();
                const year = yesterday.getFullYear();
                const month = yesterday.getMonth() + 1;
                const day = yesterday.getDate();
                return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
            },
            getFormattedToday () {
                return new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2);
            },
            filterData: {},
            getFilter () {
                const defer = $q.defer();
                this.filterData = {
                    type: [
                        {
                            name: "spin",
                            maxDays: 1
                        },
                        {
                            name: "deposit",
                            maxDays: 0
                        },
                        {
                            name: "withdraw",
                            maxDays: 0
                        },
                        {
                            name: "bonus_deposit",
                            maxDays: 0
                        },
                        {
                            name: "bonus_withdraw",
                            maxDays: 0
                        },
                        {
                            name: "bonus_release",
                            maxDays: 0
                        },
                        {
                            name: "cancel_withdraw",
                            maxDays: 0
                        }
                    ],
                    status: [
                        {
                            name: "deposit_pending",
                            type: "deposit"
                        },
                        {
                            name: "deposit_complete",
                            type: "deposit"
                        },
                        {
                            name: "deposit_cancel",
                            type: "deposit"
                        },
                        {
                            name: "deposit_decline",
                            type: "deposit"
                        },
                        {
                            name: "deposit_error",
                            type: "deposit"
                        },
                        {
                            name: "withdraw_pending",
                            type: "withdraw"
                        },
                        {
                            name: "withdraw_complete",
                            type: "withdraw"
                        },
                        {
                            name: "withdraw_cancel",
                            type: "withdraw"
                        },
                        {
                            name: "withdraw_decline",
                            type: "withdraw"
                        },
                        {
                            name: "withdraw_error",
                            type: "withdraw"
                        },
                        {
                            name: "bonus_deposit_pending",
                            type: "bonus_deposit"
                        },
                        {
                            name: "bonus_deposit_complete",
                            type: "bonus_deposit"
                        },
                        {
                            name: "bonus_deposit_cancel",
                            type: "bonus_deposit"
                        },
                        {
                            name: "bonus_deposit_decline",
                            type: "bonus_deposit"
                        },
                        {
                            name: "bonus_deposit_error",
                            type: "bonus_deposit"
                        },
                        {
                            name: "bonus_withdraw_pending",
                            type: "bonus_withdraw"
                        },
                        {
                            name: "bonus_withdraw_complete",
                            type: "bonus_withdraw"
                        },
                        {
                            name: "bonus_withdraw_cancel",
                            type: "bonus_withdraw"
                        },
                        {
                            name: "bonus_withdraw_decline",
                            type: "bonus_withdraw"
                        },
                        {
                            name: "bonus_withdraw_error",
                            type: "bonus_withdraw"
                        },
                        {
                            name: "bonus_release_pending",
                            type: "bonus_release"
                        },
                        {
                            name: "bonus_release_complete",
                            type: "bonus_release"
                        },
                        {
                            name: "bonus_release_cancel",
                            type: "bonus_release"
                        },
                        {
                            name: "bonus_release_decline",
                            type: "bonus_release"
                        },
                        {
                            name: "bonus_release_error",
                            type: "bonus_release"
                        },
                        {
                            name: "cancel_withdraw_pending",
                            type: "cancel_withdraw"
                        },
                        {
                            name: "cancel_withdraw_complete",
                            type: "cancel_withdraw"
                        },
                        {
                            name: "cancel_withdraw_cancel",
                            type: "cancel_withdraw"
                        },
                        {
                            name: "cancel_withdraw_decline",
                            type: "cancel_withdraw"
                        },
                        {
                            name: "cancel_withdraw_error",
                            type: "cancel_withdraw"
                        }
                    ]
                };
                defer.resolve({
                    result: this.filterData
                });
                return defer.promise;
            /*
                const defer = $q.defer(),
                    alias = 'historyFilter', //todo add api alias
                    config = {
                        params: {},
                        cache: true,
                        meta: {
                            type: 'api',
                            alias
                        }
                    };

                _http.get( alias, config ).then(
                    answer => { defer.resolve( answer.data ) },
                    answer => { defer.reject( answer.data ) }
                );

                return defer.promise;
                */ },
            balanceFlow (options) {
                const statuses = options.status.length ? "&" + getUrlString({
                    status: options.status
                }) : "";
                const types = options.type.length ? "&" + getUrlString({
                    type: options.type
                }) : "";
                delete options.type;
                delete options.status;
                const date = $httpParamSerializer(options);
                const url = `?${date}${statuses}${types}`;
                const defer = $q.defer();
                const alias = {
                    name: "historyBalanceFlow",
                    param: url
                };
                // 'historyBalanceFlow',
                const config = {
                    // params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject();
                });
                return defer.promise;
            },
            collection (options) {
                options.params.count = 1000;
                const defer = $q.defer();
                const alias = {
                    name: "history",
                    param: options.endpoint
                };
                const config = {
                    params: options.params,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then(function(answer) {
                    defer.resolve(answer.data);
                }, function(answer) {
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("history", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http",
        "history$",
        "history"
    ];
    function controller($q, _http, _history$, _history) {
        return {
            maxDays: 1,
            updateMaxDays () {
                if (this.selectedTypes.length) {
                    const filteredType = _history.filterData.type.filter((i)=>this.selectedTypes.includes(i.name));
                    this.maxDays = filteredType[0].maxDays;
                    filteredType.forEach((i)=>{
                        if (0 < i.maxDays && i.maxDays < this.maxDays) this.maxDays = i.maxDays;
                    });
                } else this.maxDays = 1;
                _history$.next({
                    action: "maxDays"
                });
            },
            selectedTypes: [],
            updateTypes (typeName, actionFlag) {
                this.selectedTypes.toggle(typeName, actionFlag);
                this.updateMaxDays();
                _history$.next({
                    type: typeName
                });
            }
        };
    }
    app.factory("historyBalanceFlow", controller);
})();





// https://mymth.github.io/vanillajs-datepicker/#/
(function() {
    "use strict";
    const directive = {
        name: "lindaBalanceFlowPeriodFilterDatepicker"
    };
    controller.$inject = [
        "historyBalanceFlow",
        "history$",
        "$timeout"
    ];
    function controller(_historyBalanceFlow, _history$, $timeout) {
        const singleInputHTML = `
      <div class='balance-filter-inputs'>
        <div class='balance-filter-inputs__input-wrp'>
          <input type='text' size='9' readonly name='start' class='balance-filter-inputs__input'>
        </div>
      </div>
    `;
        const doubleInputHTML = `
      <div class='balance-filter-inputs'>
        <div class='balance-filter-inputs__input-wrp'>
          <input type='text' size='9' readonly name='start' class='balance-filter-inputs__input'>
        </div>
        <span class='balance-filter-inputs__divider'>\u{2014}</span>
        <div class='balance-filter-inputs__input-wrp'>
          <input type='text' size='9' readonly name='end' class='balance-filter-inputs__input'>
        </div>
      </div>
    `;
        const datepickerOptions = {
            minDate: new Date().setFullYear(new Date().getFullYear() - 5),
            maxDate: "today",
            format: "dd.mm.yyyy",
            autohide: true,
            maxView: 0
        };
        function link($scope, $element) {
            const element = $element[0];
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            let datepickerInstance = null;
            let currentMaxDays = _historyBalanceFlow.maxDays;
            const isSingleDate = ()=>currentMaxDays === 1;
            const updateModel = ()=>{
                let from;
                let to;
                if (isSingleDate()) {
                    from = datepickerInstance.getDate().toISOString();
                    to = from;
                } else {
                    from = datepickerInstance.getDates()[0].toISOString();
                    to = datepickerInstance.getDates()[1].toISOString();
                }
                $timeout(()=>{
                    $scope.ngModel.from = from;
                    $scope.ngModel.to = to;
                });
            };
            const initSingleDatepicker = ()=>{
                element.innerHTML = singleInputHTML;
                const datepickerElement = element.querySelector("input");
                datepickerInstance = new Datepicker(datepickerElement, datepickerOptions);
                datepickerInstance.setDate("today");
                datepickerElement.addEventListener("changeDate", updateModel);
            };
            const initRangeDatepicker = ()=>{
                element.innerHTML = doubleInputHTML;
                datepickerInstance = new DateRangePicker(element, datepickerOptions);
                datepickerInstance.setDates("today", "today");
                datepickerInstance.inputs.forEach((input)=>{
                    input.addEventListener("changeDate", updateModel);
                });
            };
            const destroyDatepicker = ()=>{
                datepickerInstance.destroy();
            };
            const initDatepicker = ()=>{
                if (isSingleDate()) {
                    initSingleDatepicker();
                    return;
                }
                initRangeDatepicker();
            };
            const reinitDatepicker = ()=>{
                destroyDatepicker();
                initDatepicker();
            };
            const onInit = ()=>{
                initDatepicker();
                _history$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "maxDays")).subscribe((incomeMaxDays)=>{
                    if (incomeMaxDays !== currentMaxDays) {
                        currentMaxDays = incomeMaxDays;
                        reinitDatepicker();
                    }
                });
            };
            onInit();
            $scope.$on("$destroy", ()=>{
                destroyDatepicker();
                destroy$.next();
                destroy$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel",
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $959cdcf5a16e68e5$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "lindaBalanceFlowPeriodFilterJquery"
    };
    controller.$inject = [
        "$compile",
        "historyBalanceFlow",
        "history$",
        "$timeout"
    ];
    function controller($compile, _historyBalanceFlow, _history$, $timeout) {
        function link(scope, element, attrs) {
            const version = "v11.1.13";
            const cdn = "/joxi";
            const url = `${cdn}/js/${version}/jquery.js`;
            const script = document.createElement("script");
            script.src = url;
            script.onload = ()=>{
                const changeRange = ()=>{
                    const action = _historyBalanceFlow.maxDays !== 1 ? "add" : "remove";
                    element[0].classList[action]("linda-has-range");
                };
                const options = scope.$eval(attrs[directive.name]) || {};
                const jqEl = $(element);
                const init = ()=>{
                    jqEl.dateRangePicker(Object.assign(options, {
                        showDropdowns: true,
                        container: jqEl,
                        singleDate: _historyBalanceFlow.maxDays === 1,
                        singleMonth: _historyBalanceFlow.maxDays === 1,
                        maxDays: _historyBalanceFlow.maxDays
                    })).bind("datepicker-change", (event, obj)=>{
                        $timeout(()=>{
                            scope.ngModel.from = obj.value.split("/")[0];
                            scope.ngModel.to = obj.value.split("/")[1];
                        });
                    });
                };
                const destroy = ()=>{
                    jqEl.data("dateRangePicker").clear();
                    jqEl.data("dateRangePicker").destroy();
                };
                const subscribtion = _history$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((i)=>i.action === "maxDays")).subscribe(()=>{
                    destroy();
                    init();
                    changeRange();
                });
                init();
                changeRange();
                scope.$on("$destroy", ()=>subscribtion.unsubscribe());
            };
            document.head.appendChild(script);
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel",
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $ed7e51d3ec96e627$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "$compile",
        "historyBalanceFlow",
        "history$"
    ];
    function controller($compile, _historyBalanceFlow, _history$) {
        function link(scope, element, attrs) {
            const div = document.createElement("div");
            let isSingleDay = false;
            const setEndDate = (endDate)=>scope.formData.date.to = endDate;
            const checkIfSingleDay = ()=>!!_historyBalanceFlow.maxDays;
            const changeRange = ()=>{
                isSingleDay = checkIfSingleDay();
                if (!isSingleDay) {
                    div.classList.add("linda-has-range");
                    return;
                }
                setEndDate(scope.formData.date.from);
                div.classList.remove("linda-has-range");
            };
            div.innerHTML = `
                <div class='table-filter__date'>
                    <input type='date' ng-model='${attrs["ngModel"]}.from' m-datepicker />
                </div>
                <div class='table-filter__date'>
                    <input type='date' ng-model='${attrs["ngModel"]}.to' m-datepicker />
                </div>`;
            $compile(div)(scope);
            element.append(div);
            changeRange();
            _history$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((i)=>i.action === "maxDays")).subscribe(()=>{
                if (isSingleDay === checkIfSingleDay()) return;
                setEndDate(new Date());
                changeRange();
            });
            scope.$watch("formData.date.from", (newVal)=>{
                if (isSingleDay) setEndDate(scope.formData.date.from);
            });
        }
        return {
            restrict: "A",
            link: link,
            require: "ngModel"
        };
    }
    app.directive("lindaBalanceFlowPeriodFilterNative", controller);
})();


var $1eaba65df8d9040a$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "lindaBalanceFlowStatusFilter"
    };
    factory.$inject = [
        "history",
        "history$",
        "historyBalanceFlow"
    ];
    function factory(_history, _history$, _historyBalanceFlow) {
        // function compile( tElement, tAttr ){
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            let previousNode = $element[0];
            if (!$scope.ngModel) $scope.ngModel = [];
            _history.getFilter().then((a)=>{
                const statuses = a.result.status;
                let previousType = "";
                for(let i = 0; i <= statuses.length - 1; i++)$transclude($scope.$new(true), ($clone, scope)=>{
                    scope.index = i;
                    scope.status = statuses[i];
                    const clone = $clone[0];
                    const hash = Date.now().toString(36);
                    const checkbox = clone.querySelector('input[type="checkbox"]');
                    const label = clone.querySelector("label");
                    checkbox.setAttribute("value", `${statuses[i].name}`);
                    checkbox.setAttribute("id", `${hash}${i}`);
                    checkbox.checked = $scope.ngModel.includes(statuses[i].name);
                    label.setAttribute("for", `${hash}${i}`);
                    checkbox.addEventListener("change", (e)=>{
                        $scope.$apply(()=>{
                            $scope.ngModel.toggle(e.target.value, e.target.checked);
                        });
                    });
                    $ctrl.$formatters.push((modelValue)=>{
                        checkbox.checked = modelValue.includes(checkbox.value);
                        return modelValue;
                    });
                    previousNode.after(clone);
                    if (_historyBalanceFlow.selectedTypes.includes(statuses[i].type)) clone.classList.add("linda-is-active");
                    if (previousType !== statuses[i].type) {
                        clone.classList.add("linda-first-in-group");
                        previousType = statuses[i].type;
                        if (i >= 1) {
                            const emptyElement = document.createElement("div");
                            emptyElement.classList.add("linda-empty-element");
                            previousNode.after(emptyElement);
                        }
                    }
                    previousNode = clone;
                    const subscribtion = _history$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((i)=>i.type === scope.status.type)).subscribe(()=>{
                        clone.classList.toggle("linda-is-active");
                    });
                    scope.$on("$destroy", ()=>subscribtion.unsubscribe());
                });
            }).catch((e)=>{}).finally(()=>{});
        }
        // }
        return {
            require: "ngModel",
            restrict: "A",
            transclude: "element",
            link: link,
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, factory);
})();


var $106761e92824daeb$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "lindaBalanceFlowTypeFilter"
    };
    factory.$inject = [
        "history",
        "historyBalanceFlow"
    ];
    function factory(_history, _historyBalanceFlow) {
        // function compile( tElement, tAttr ){
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            let previousElement = $element[0];
            if (!$scope.ngModel) $scope.ngModel = [];
            _historyBalanceFlow.selectedTypes = $scope.ngModel;
            _history.getFilter().then((a)=>{
                const types = a.result.type;
                for(let i = 0; i <= types.length - 1; i++)$transclude($scope.$new(true), ($cloneElement, scope)=>{
                    const cloneElement = $cloneElement[0];
                    scope.index = i;
                    scope.type = types[i];
                    const hash = Date.now().toString(36);
                    const checkbox = cloneElement.querySelector('input[type="checkbox"]');
                    const label = cloneElement.querySelector("label");
                    checkbox.setAttribute("value", `${types[i].name}`);
                    checkbox.setAttribute("id", `${hash}${i}`);
                    checkbox.checked = $scope.ngModel.includes(types[i].name);
                    label.setAttribute("for", `${hash}${i}`);
                    checkbox.addEventListener("change", (e)=>{
                        $scope.$apply(()=>{
                            $scope.ngModel.toggle(e.target.value, e.target.checked);
                            _historyBalanceFlow.updateTypes(e.target.value, e.target.checked);
                        });
                    });
                    $ctrl.$formatters.push((modelValue)=>{
                        if (modelValue.includes(checkbox.value) !== checkbox.checked) {
                            checkbox.checked = !checkbox.checked;
                            _historyBalanceFlow.updateTypes(checkbox.value, checkbox.checked);
                        }
                        return modelValue;
                    });
                    previousElement.after(cloneElement);
                    previousElement = cloneElement;
                });
            }).catch((e)=>{}).finally(()=>{});
        }
        // }
        return {
            require: "ngModel",
            restrict: "A",
            transclude: "element",
            link: link,
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, factory);
})();


var $bf33801e62a54beb$exports = {};






(function() {
    "use strict";
    const name = "lindaChatra";
    controller.$inject = [
        "system$",
        "user",
        "$location",
        "splash$",
        "config"
    ];
    function controller(_system$, _user, $location, _splash$, _config) {
        const chatActivation$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const openChatEvent$ = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "open chat"));
        (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)([
            chatActivation$,
            openChatEvent$
        ]).subscribe(([openChatCb])=>openChatCb());
        const link = (scope)=>{
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const w = window;
            const c = "Chatra";
            w.ChatraID = "xvrmYctCwKNdZq8Rk";
            w[c] = w[c] || function() {
                // eslint-disable-next-line prefer-rest-params
                (w[c].q = w[c].q || []).push(arguments);
            };
            const script = document.createElement("script");
            const target = document.scripts[document.scripts.length - 1];
            const src = "https://call.chatra.io/chatra.js";
            script.async = true;
            script.src = src;
            target.parentElement.insertBefore(script, target.nextSibling);
            script.onload = onload;
            function activateChat() {
                // eslint-disable-next-line new-cap
                Chatra("openChat", true);
            }
            _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded"), (0, $94b8433012a062db$export$b7df5d561049483a)(1), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((i)=>{
                chatActivation$.next(activateChat);
            });
            scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            };
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $f72a69be664af257$exports = {};





(function() {
    "use strict";
    const name = "lindaFreshchat";
    controller.$inject = [
        "system$",
        "splash$",
        "config",
        "$window"
    ];
    function controller(_system$, _splash$, _config, $window) {
        const chatActivation$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const openChatEvent$ = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "open chat"));
        (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)([
            chatActivation$,
            openChatEvent$
        ]).subscribe(([openChatCb])=>openChatCb());
        const link = ()=>{
            const config = _config.freshChat || {};
            function initiateCall() {
                initialize(document, "Freshdesk Messaging-js-sdk");
            }
            function initialize(i, t) {
                let e;
                i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.eu.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e));
            }
            function initFreshChat() {
                $window.fcWidget.init({
                    ...config
                });
                chatActivation$.next(openChat);
            }
            function openChat() {
                $window.fcWidget.open();
            }
            const subscription = _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded")).subscribe(()=>{
                initiateCall();
                subscription.unsubscribe();
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $b7682229a472689f$exports = {};






(function() {
    "use strict";
    const name = "lindaLiveAgent";
    controller.$inject = [
        "system$",
        "user",
        "$location",
        "splash$",
        "config"
    ];
    function controller(_system$, _user, $location, _splash$, _config) {
        const link = (scope, element, attrs)=>{
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const config = scope.$eval(attrs[name]) || _config.liveAgent;
            const script = document.createElement("script");
            const target = document.scripts[document.scripts.length - 1];
            const src = $_CDN.liveAgent?.sdk;
            let subscription;
            script.id = config.sid;
            script.async = true;
            script.src = src;
            script.onload = onload;
            _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded"), (0, $94b8433012a062db$export$b7df5d561049483a)(1), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((i)=>{
                target.parentElement.insertBefore(script, target.nextSibling);
            });
            function onload() {
                if (_user.status) setProfileData(_user.profile);
                else _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe((message)=>{
                    setProfileData(_user.profile);
                });
                const container = document.createElement("div");
                element[0].appendChild(container);
                const button = LiveAgent.createButton(config.bid, container);
                button.onOnline = function() {
                    _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "open chat")).subscribe((message)=>{
                        button.onClick();
                    // Fixes multiple open on wazamba but breaks rabona
                    // button.chat.startChat(button.chat.url + '&cwt=onlineform_mobile')
                    });
                    if ($location.hash() === "chat") {
                        $location.hash("");
                        button.onClick();
                    // button.chat.startChat(button.chat.url + '&cwt=onlineform_mobile')
                    }
                };
            }
            function setProfileData(user) {
                const email = user.email_guid || user.email;
                LiveAgent.setUserDetails(email, user.profile.name, user.profile.surname, user.phone);
                LiveAgent.addTicketField("Username", `${user.login}`);
            }
            scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            };
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $ea371353156702f1$exports = {};


(function() {
    "use strict";
    const name = "lindaLivechatinc";
    controller.$inject = [
        "system$",
        "user",
        "$location",
        "splash$",
        "config",
        "$window",
        "$timeout"
    ];
    function controller(_system$, _user, $location, _splash$, _config, $window, $timeout) {
        // window.__lc = window.__lc || {};
        // window.__lc.license = 13199751;
        // (function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
        const link = (scope, element, attrs)=>{
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const config = scope.$eval(attrs[name]) || _config.liveAgent;
            function onload() {
                if (_user.status) setProfileData(_user.profile);
                else _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe((message)=>{
                    setProfileData(_user.profile);
                });
                _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "open chat")).subscribe((message)=>{
                    open();
                });
                if ($location.hash() === "chat") {
                    $location.hash("");
                    open();
                }
            }
            function open() {
                $window.LiveChatWidget.call("maximize");
            }
            function close() {
                $window.LiveChatWidget.call("minimize");
                $timeout(()=>$window.LiveChatWidget.call("hide"), 300);
            }
            _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded"), (0, $94b8433012a062db$export$b7df5d561049483a)(1), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((i)=>{
                $window.LiveChatWidget.on("visibility_changed", ({ visibility: visibility })=>{
                    if ("minimized" === visibility) close();
                });
                $window.LiveChatWidget.on("ready", ()=>{
                    onload();
                });
            });
            function setProfileData(user) {
                const email = user.email_guid || user.email;
                // window.LiveChatWidget.call('set_customer_name', user.profile.name);
                $window.LiveChatWidget.call("set_customer_email", email);
            }
            scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
            };
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(name, controller);
})();


var $4232c0228152df97$exports = {};



(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("trustly$", controller);
})();






(function() {
    "use strict";
    app.factory("paynplay", controller);
    controller.$inject = [
        "http",
        "$q",
        "user",
        "trustly$",
        "trustly.config",
        "analytics",
        "analyticsEvents",
        "heatmap",
        "$cookies",
        "$window"
    ];
    function controller(_http, $q, _user, _trustly$, _trustly_config, analytics, _analyticsEvents, _heatmap, $cookies, $window) {
        const adformcookieid = $window.Adform?.["_uid"];
        function requestParams(params) {
            const ls = JSON.parse($window.localStorage.getItem("params") || "{}");
            ls.paymethod = "trustly";
            ls.currency = _trustly_config.currency;
            ls.affiliate = {};
            ls.locale = _trustly_config.locale;
            ls.amount = api.data.amount;
            if (api.data.order_id) ls.order_id = api.data.order_id;
            return Object.assign({}, ls, params);
        }
        function reset() {
            api.data.flow = null;
            api.data.amount = _trustly_config.default;
            api.data.step = 0;
            api.data.order_id = null;
        }
        let _step = 0;
        let _flow = null; // 'fast_deposit' - default || 'resume_play' - optional
        const api = {
            data: {
                order_id: null,
                amount: _trustly_config.default,
                reset: reset
            },
            init (params) {
                const defer = $q.defer();
                const alias = "trustlyInit";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const data = requestParams(params);
                if (adformcookieid) data.adformcookieid = adformcookieid;
                const fbpValue = $cookies.get("_fbp");
                if (fbpValue && data.affiliate) data.affiliate.fbp = fbpValue;
                _http.post(alias, data, config).then((answer)=>{
                    this.data.order_id = answer.data.result.order_id || null;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            auth (params) {
                const defer = $q.defer();
                const alias = "trustlyAuth";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const data = requestParams(params);
                if (adformcookieid) data.adformcookieid = adformcookieid;
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    let event;
                    event = _user.profile?.sessions_info?.is_first_session ? _analyticsEvents.registrationSuccess : _analyticsEvents.loginSuccess;
                    analytics.send(event, "success", answer.data.result.login);
                    _heatmap.sendEvent("event", "register");
                    _heatmap.sendEvent("identify", _user.profile.account_id);
                    defer.resolve(answer.data);
                }, (answer)=>{
                    analytics.send(_analyticsEvents.registrationFail, answer.data.messages[0].code?.toString(), "Not_Login");
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            checkStatus (options) {
                const defer = $q.defer();
                const alias = "trustlyStatus";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            updateProfile (data) {
                const defer = $q.defer();
                const alias = "trustlyData";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            getFulfillmentInfo () {
                const defer = $q.defer();
                const alias = "fulfillmentInfo";
                const config = {
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            sendFulfillmentInfo (data) {
                const defer = $q.defer();
                const alias = "fulfillmentInfo";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
        Object.defineProperty(api.data, "step", {
            get () {
                return _step;
            },
            set (value) {
                _step = value;
                _trustly$.next({
                    action: "step",
                    data: value
                });
            }
        });
        Object.defineProperty(api.data, "flow", {
            get () {
                return _flow || "fast_deposit";
            },
            set (value) {
                _flow = value;
            }
        });
        return api;
    }
})();







(function() {
    "use strict";
    const directive = {
        name: "lindaTrustlyBFrame"
    };
    factory.$inject = [
        "paynplay",
        "modal",
        "trustly$",
        "state",
        "$timeout",
        "$window"
    ];
    function factory(_paynplay, _modal, _trustly$, _state, $timeout, $window) {
        const link = async (scope, element, attrs)=>{
            scope.preloader = true;
            element[0].src = "/preloader.html";
            let order_id;
            let auth_request = false;
            let interval$;
            let isCheckStatusRequestEnded = true;
            function success() {
                _state.goto("home");
            }
            async function auth(options) {
                auth_request = true;
                try {
                    await _paynplay.auth(options);
                    success();
                } catch (e) {
                    switch(e.messages[0].code){
                        case 5054:
                            $timeout(async ()=>{
                                await _modal.open("trustly-registration", {
                                    profile: e.messages[0].data.profile,
                                    is_registration_bonuses_shown: e.messages[0].data.is_registration_bonuses_shown,
                                    token: order_id
                                });
                                success();
                            }, 0);
                            break;
                        case 2106:
                            $timeout(async ()=>{
                                await _modal.open("trustly-b-create-login", {
                                    profile: e.messages[0].data.profile,
                                    token: order_id
                                });
                                success();
                            }, 0);
                            break;
                    }
                } finally{
                    $window.onmessage = null;
                }
            }
            async function checkStatus() {
                isCheckStatusRequestEnded = false;
                try {
                    const statusData = await _paynplay.checkStatus({
                        order_id: _paynplay.data.order_id,
                        paymethod: "trustly"
                    });
                    switch(statusData.status){
                        case "waiting_input":
                            statusData.token = _paynplay.data.order_id;
                            $timeout(async ()=>{
                                await _modal.open("trustly-b-registration", statusData);
                            }, 0);
                        case "verified":
                            interval$.unsubscribe();
                            break;
                    }
                } catch  {
                    interval$.unsubscribe();
                } finally{
                    isCheckStatusRequestEnded = true;
                }
            }
            function startIntervalForCheckingStatus() {
                interval$ = (0, $ea071fc4c7f61f15$export$3174cdbf0a0cbc84)(1000).pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(()=>isCheckStatusRequestEnded)).subscribe(()=>{
                    checkStatus();
                });
            }
            $window.onmessage = (m)=>{
                if (m.origin === "https://checkout.trustly.com") {
                    const data = JSON.parse(m.data);
                    if (data.method === "OPEN_APP") location.assign(data.appURL);
                }
                switch(m.data){
                    case "preloader:success":
                        if (!auth_request) auth({
                            order_id: order_id
                        });
                        break;
                    case "preloader:fail":
                        _trustly$.next({
                            action: "step",
                            data: 0
                        });
                        break;
                    default:
                        break;
                }
            };
            try {
                const frameData = await _paynplay.init();
                order_id = frameData.result.order_id;
                element[0].sandbox = "allow-forms allow-scripts allow-same-origin";
                element[0].src = frameData.result.url;
                startIntervalForCheckingStatus();
            } finally{
                scope.preloader = false;
            }
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $7fae8f6e5ab3e27c$exports = {};




// add to linda-app
/*
          _modal.open( 'trustly-registration', {
              profile:{
                  name:'Ulpu',
                  surname:'Koskela',
                  city:'Mustasaari',
                  postcode:'65610',
                  address:'Karkkimalantie 82',
                  gender:'F',
                  birthday:'1970-09-20',
                  email:'',
                  phone:''
              }
          } );
  */ (function() {
    "use strict";
    const directive = {
        name: "lindaTrustlyFrame"
    };
    const analyticsPlace = "trustly";
    factory.$inject = [
        "paynplay",
        "modal",
        "trustly$",
        "state",
        "$window"
    ];
    function factory(_paynplay, _modal, _trustly$, _state, $window) {
        const link = (scope, element, attrs)=>{
            scope.preloader = true;
            element[0].src = "/preloader.html";
            let order_id;
            let auth_request = false;
            function success() {
                _state.goto("home");
            }
            $window.onmessage = (m)=>{
                if (m.origin === "https://checkout.trustly.com") {
                    const data = JSON.parse(m.data);
                    if (data.method === "OPEN_APP") location.assign(data.appURL);
                }
                switch(m.data){
                    case "preloader:success":
                        if (!auth_request) {
                            auth_request = true;
                            _paynplay.auth({
                                order_id: order_id
                            }).then((a)=>{
                                success();
                            /* The very first successful response (after iframe was closed and 'success' event was sent)
                   * means that the user was identified and has been registered already.
                   * */ }).catch((e)=>{
                                if (e.messages[0].code === 5054) _modal.open("trustly-registration", {
                                    profile: e.messages[0].data.profile,
                                    is_registration_bonuses_shown: e.messages[0].data.is_registration_bonuses_shown,
                                    token: order_id
                                }).then(()=>{
                                    success();
                                }).catch(()=>{}).finally(()=>{});
                            }).finally(()=>{
                                $window.onmessage = null;
                            });
                        }
                        break;
                    case "preloader:fail":
                        _trustly$.next({
                            action: "step",
                            data: 0
                        });
                        break;
                    default:
                        break;
                }
            };
            _paynplay.init().then((a)=>{
                order_id = a.result.order_id;
                element[0].sandbox = "allow-forms allow-scripts allow-same-origin allow-popups";
                element[0].src = a.result.url;
            }).catch((e)=>{}).finally(()=>{
                scope.preloader = false;
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $223181bf76416d6e$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "paynplayFastDepositButton"
    };
    factory.$inject = [
        "system",
        "state",
        "popup"
    ];
    function factory(_system, _state, _popup) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _state.goto("paynplay");
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $e467078415f117c7$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "paynplayResumePlayButton"
    };
    factory.$inject = [
        "system",
        "state",
        "paynplay",
        "popup"
    ];
    function factory(_system, _state, _paynplay, _popup) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _paynplay.data.flow = "resume_play";
                _paynplay.data.amount = 0;
                _paynplay.data.step = 1;
                _state.goto("paynplay");
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $ddf3b4bea7c2a90f$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "removeElementIfNotPaynplay"
    };
    factory.$inject = [
        "system"
    ];
    function factory(_system) {
        function link(scope, element, attrs) {
            if (!_system.mode.paynplay) element[0].parentNode.removeChild(element[0]);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $0f6702b465fea39d$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "removeElementIfPaynplay"
    };
    factory.$inject = [
        "system"
    ];
    function factory(_system) {
        function link(scope, element, attrs) {
            if (_system.mode.paynplay) element[0].parentNode.removeChild(element[0]);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $04c4eb96f5a8ece5$exports = {};




(function() {
    "use strict";
    app.factory("zignsec.config", controller);
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        const config = typeof _config.paynplay === "object" ? _config.paynplay : {
            curacao: {
                fi: {
                    enabled: true,
                    min: 20,
                    max: 10000,
                    default: 100,
                    range: [
                        50,
                        100,
                        250
                    ],
                    currency: "EUR",
                    locale: "fi_FI"
                }
            },
            malta: {
                fi: {
                    enabled: true,
                    min: 20,
                    max: 10000,
                    default: 100,
                    range: [
                        50,
                        100,
                        250
                    ],
                    currency: "EUR",
                    locale: "fi_FI",
                    paymethod: "zignsec_finland"
                }
            },
            sweden: {
                enabled: true,
                min: 100,
                max: 5000,
                default: 500,
                range: [
                    1000,
                    2000,
                    5000
                ],
                currency: "SEK",
                locale: "sv_SE"
            },
            denmark: {
                enabled: true,
                default: 500,
                currency: "DKK",
                locale: "da_DK"
            }
        };
        let result;
        switch(_config.jurisdiction){
            case "sweden":
            case "denmark":
                result = config[_config.jurisdiction];
                break;
            case "curacao":
            case "malta":
                result = config[_config.jurisdiction]?.[_config.currentLang] || {
                    enabled: false
                };
                break;
            default:
                result = {
                    enabled: false
                };
                break;
        }
        return result;
    }
})();


(function() {
    "use strict";
    app.factory("zignsec.paynplay", controller);
    controller.$inject = [
        "http",
        "$q",
        "user",
        "trustly$",
        "zignsec.config",
        "$cookies",
        "$window"
    ];
    function controller(_http, $q, _user, _trustly$, _zignsec_config, $cookies, $window) {
        const adformcookieid = $window.Adform?.["_uid"];
        function requestParams(params) {
            const ls = angular.fromJson($window.localStorage.getItem("params") || "{}");
            ls.paymethod = _zignsec_config.paymethod || "zignsec";
            ls.currency = _zignsec_config.currency;
            ls.affiliate = {};
            ls.locale = _zignsec_config.locale;
            ls.amount = api.data.amount;
            ls.personId = api.data.personId;
            if (api.data.order_id) ls.order_id = api.data.order_id;
            return Object.assign({}, ls, params);
        }
        function reset() {
            api.data.flow = null;
            api.data.amount = _zignsec_config.default;
            api.data.personId = "";
            api.data.step = 0;
            api.data.order_id = null;
        }
        let _step = 0;
        let _flow = null; // 'fast_deposit' - default || 'resume_play' - optional
        const api = {
            data: {
                order_id: null,
                amount: _zignsec_config.default,
                personId: "",
                reset: reset
            },
            init (params) {
                const defer = $q.defer();
                const alias = "trustlyInit";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const data = requestParams(params);
                if (adformcookieid) data.adformcookieid = adformcookieid;
                const fbpValue = $cookies.get("_fbp");
                if (fbpValue && data.affiliate) data.affiliate.fbp = fbpValue;
                Object.assign(api.data, data);
                _http.post(alias, data, config).then((answer)=>{
                    this.data.order_id = answer.data.result.order_id || null;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            auth (params) {
                const defer = $q.defer();
                const alias = "trustlyAuth";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const data = requestParams(params);
                if (adformcookieid) data.adformcookieid = adformcookieid;
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            checkStatus (options) {
                const defer = $q.defer();
                const alias = "trustlyStatus";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            updateProfile (data) {
                const defer = $q.defer();
                const alias = "trustlyData";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
        Object.defineProperty(api.data, "step", {
            get () {
                return _step;
            },
            set (value) {
                _step = value;
                _trustly$.next({
                    action: "step",
                    data: value
                });
            }
        });
        Object.defineProperty(api.data, "flow", {
            get () {
                return _flow || "fast_deposit";
            },
            set (value) {
                _flow = value;
            }
        });
        return o;
    }
})();








(function() {
    "use strict";
    const directive = {
        name: "lindaZignsecFrame"
    };
    factory.$inject = [
        "zignsec.paynplay",
        "modal",
        "trustly$",
        "state",
        "$timeout",
        "config",
        "$window"
    ];
    function factory(_paynplay, _modal, _trustly$, _state, $timeout, _config, $window) {
        const link = async (scope, element, attrs)=>{
            scope.preloader = true;
            element[0].src = "/preloader.html";
            let order_id;
            let auth_request = false;
            let interval$;
            let isCheckStatusRequestEnded = true;
            function success() {
                _state.goto("home");
            }
            function auth(options) {
                auth_request = true;
                _paynplay.auth(options).then(()=>{
                    success();
                }).catch((e)=>{
                    if (e.messages[0]?.code === 5054) $timeout(()=>{
                        _modal.open("zignsec-registration", {
                            profile: e.messages[0].data.profile,
                            is_registration_bonuses_shown: e.messages[0].data.is_registration_bonuses_shown,
                            token: order_id
                        }).then(()=>{
                            success();
                        }).catch(()=>{}).finally(()=>{});
                    }, 0);
                });
            }
            function checkStatus() {
                const params = {
                    order_id: _paynplay.data.order_id,
                    paymethod: _paynplay.data.paymethod || "zignsec"
                };
                isCheckStatusRequestEnded = false;
                _paynplay.checkStatus(params).then((statusData)=>{
                    if (statusData.status === "verified") {
                        statusData.token = _paynplay.data.order_id;
                        auth(params);
                        interval$.unsubscribe();
                    }
                }).catch(()=>{
                    interval$.unsubscribe();
                }).finally(()=>{
                    isCheckStatusRequestEnded = true;
                });
            }
            function startIntervalForCheckingStatus() {
                interval$ = (0, $ea071fc4c7f61f15$export$3174cdbf0a0cbc84)(1000).pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(()=>isCheckStatusRequestEnded)).subscribe(()=>{
                    checkStatus();
                });
            }
            $window.addEventListener("message", goToFinalStepAfterFrameSuccess);
            function goToFinalStepAfterFrameSuccess(m) {
                switch(m.data){
                    case "preloader:success":
                        if (!auth_request) {
                            startIntervalForCheckingStatus();
                            $window.removeEventListener("message", goToFinalStepAfterFrameSuccess);
                        }
                        break;
                    case "preloader:fail":
                        _trustly$.next({
                            action: "step",
                            data: 0
                        });
                        $window.removeEventListener("message", goToFinalStepAfterFrameSuccess);
                        break;
                    default:
                        break;
                }
            }
            try {
                const frameData = await _paynplay.init(scope.zignsecParams);
                if (_config?.jurisdiction === "denmark" && _paynplay.data.paymethod === "zignsec-mitid" || _paynplay.data.paymethod === "zignsec_finland") {
                    localStorage.setItem("cpr", frameData.result.order_id);
                    $window.open(frameData.result.url, "_self");
                }
                order_id = frameData.result.order_id;
                element[0].sandbox = "allow-forms allow-scripts allow-same-origin allow-top-navigation";
                element[0].src = frameData.result.url;
            } finally{
                scope.preloader = false;
            }
            scope.$onDestroy = ()=>{
                interval$?.unsubscribe();
                $window.removeEventListener("message", goToFinalStepAfterFrameSuccess);
            };
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $17c42c11687d5827$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "zignsecFastDepositButton"
    };
    factory.$inject = [
        "state",
        "popup"
    ];
    function factory(_state, _popup) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _state.goto("paynplay");
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $df9e4d37d15a320c$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "zignsecResumePlayButton"
    };
    factory.$inject = [
        "state",
        "zignsec.paynplay",
        "popup"
    ];
    function factory(_state, _zignsec_paynplay, _popup) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _zignsec_paynplay.data.flow = "resume_play";
                _zignsec_paynplay.data.amount = 0;
                _zignsec_paynplay.data.step = 0;
                _state.goto("paynplay");
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $2297f2f7693e533a$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "lindaZimplerFrame"
    };
    const analyticsPlace = "zimpler";
    factory.$inject = [
        "zimpler.paynplay",
        "config",
        "modal",
        "trustly$",
        "state",
        "$window"
    ];
    function factory(_paynplay, _config, _modal, _trustly$, _state, $window) {
        const link = (scope, element, attrs, $ctrl, $transclude)=>{
            scope.preloader = true;
            let order_id;
            let auth_request = false;
            function redirectToHomepage() {
                _state.goto("home");
            }
            function redirectToCashbox() {
                _state.goto("deposit");
            }
            $window.onmessage = (m)=>{
                switch(m.data){
                    case "preloader:success":
                        if (!auth_request) {
                            auth_request = true;
                            _paynplay.auth({
                                order_id: order_id
                            }).then((a)=>{
                                redirectToHomepage();
                            /* The very first successful response (after iframe was closed and 'success' event was sent)
                   * means that the user was identified and has been registered already.
                   * */ }).catch((e)=>{
                                if (e.messages[0].code === 5054) _modal.open("trustly-registration", {
                                    profile: e.messages[0].data.profile,
                                    is_registration_bonuses_shown: e.messages[0].data.is_registration_bonuses_shown,
                                    token: order_id
                                }).then(()=>{
                                    _config.jurisdiction === "malta" ? redirectToCashbox() : redirectToHomepage();
                                }).catch(()=>{});
                            }).finally(()=>{
                                $window.onmessage = null;
                            });
                        }
                        break;
                    case "preloader:fail":
                        _trustly$.next({
                            action: "step",
                            data: _paynplay.isDefaultJurisdiction ? -1 : 0
                        });
                        break;
                    default:
                        break;
                }
            };
            _paynplay.init().then((a)=>{
                order_id = a.result.order_id;
                if (a.result.url) $transclude(scope, (clone)=>{
                    clone[0].sandbox = "allow-forms allow-scripts allow-same-origin allow-popups";
                    clone[0].src = a.result.url;
                    element[0].parentNode.insertBefore(clone[0], element[0].nextSibling);
                });
            }).catch((e)=>{}).finally(()=>{
                scope.preloader = false;
            });
        };
        return {
            restrict: "A",
            transclude: "element",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $a8854cbce345a5f4$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "zimplerFastDepositButton"
    };
    factory.$inject = [
        "system",
        "state",
        "popup"
    ];
    function factory(_system, _state, _popup) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _state.goto("paynplay");
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $18cab59a550e0125$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "zimplerResumePlayButton"
    };
    factory.$inject = [
        "system",
        "state",
        "zimpler.paynplay",
        "popup"
    ];
    function factory(_system, _state, _zimpler_paynplay, _popup) {
        function link(scope, element, attrs) {
            element.on("click", (e)=>{
                _zimpler_paynplay.data.flow = "resume_play";
                _zimpler_paynplay.data.amount = 0;
                _zimpler_paynplay.data.step = 1;
                _state.goto("paynplay");
                _popup.close();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, factory);
})();


var $67c5015bca47c924$exports = {};

(function() {
    controller.$inject = [
        "$q",
        "http"
    ];
    app.factory("additionalFields", controller);
    function controller($q, _http) {
        return {
            getList (options) {
                const defer = $q.defer();
                const alias = "additionalFields";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then(({ data: data })=>{
                    defer.resolve(data);
                }).catch(({ data: data })=>{
                    defer.reject(data);
                });
                return defer.promise;
            }
        };
    }
})();


(function() {
    "use strict";
    const directive = {
        name: "registrationAdditionalFields"
    };
    controller.$inject = [
        "additionalFields"
    ];
    function controller(_additionalFields) {
        function link($scope, element, attrs) {
            $scope.additionalFields = {};
            const fieldNames = $scope.$eval(attrs[directive.name]);
            const fieldDependencies = {};
            const initialFields = {};
            function getData() {
                return _additionalFields.getList(fieldNames).then(({ result: { additionalFields: additionalFields } })=>{
                    additionalFields.forEach((field)=>initialFields[field.fieldName] = field.values);
                });
            }
            function formBaseData() {
                for (const [key, value] of Object.entries(initialFields))value.forEach(({ title: title, restriction: restriction })=>{
                    if (!fieldDependencies.hasOwnProperty(key) && restriction) {
                        fieldDependencies[key] = [
                            ...new Set(Object.keys(restriction))
                        ];
                        return;
                    }
                    if (!restriction) $scope.additionalFields[key] = value;
                });
            }
            function filterDependencies() {
                const filteredFields = {};
                for (const [key, value] of Object.entries(fieldDependencies)){
                    initialFields[key].forEach((item)=>{
                        value.forEach((data)=>{
                            if (!filteredFields.hasOwnProperty(item.restriction[data])) filteredFields[item.restriction[data]] = [];
                            filteredFields[item.restriction[data]].push(item);
                        });
                    });
                    initialFields[key] = filteredFields;
                }
            }
            function addWatchers() {
                for (const [key, value] of Object.entries(fieldDependencies))value.forEach((item)=>{
                    watchSelect(item, key);
                });
            }
            function watchSelect(dependence, dependent) {
                $scope.$watch("formData.additionalFields." + dependence, function(newVal) {
                    $scope.additionalFields[dependent] = [];
                    if (newVal) $scope.additionalFields[dependent] = initialFields[dependent][newVal];
                });
            }
            getData().then(()=>{
                formBaseData();
                filterDependencies();
                addWatchers();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $c8d90f546d95afb0$exports = {};





(function() {
    "use strict";
    controller.$inject = [
        "config",
        "$timeout",
        "promo",
        "system",
        "contentBuffer",
        "$window"
    ];
    function controller(_config, $timeout, _promo, _system, _contentBuffer, $window) {
        const $_REGISTRATION = $window.$_REGISTRATION || {};
        const sliders = {};
        const events$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const eventTypes = {
            initPromotionsSlider: "init-promotions-slider",
            initAvatarsSlider: "init-avatars-slider"
        };
        function bindSliders(firstSliderName, secondSliderName) {
            const firstSlider = sliders[firstSliderName];
            const secondSlider = sliders[secondSliderName];
            $timeout(()=>{
                firstSlider.controller.control = secondSlider;
                secondSlider.controller.control = firstSlider;
            });
        }
        function registerSlider(name1, slider) {
            sliders[name1] = slider;
        }
        function unregisterSlider(name1) {
            delete sliders[name1];
        }
        function prepareCurrencyList(list) {
            return list.map((i)=>{
                return {
                    key: i.code,
                    name: name,
                    icon: i.symbol
                };
            });
        }
        function getFakeFormData() {
            return {
                login: "lo" + Date.now(),
                email: "email" + Date.now() + "@yopmail.com",
                password: "qweQWE123",
                retype: "qweQWE123",
                accept: true,
                gdpr_data: true,
                gdpr_marketing: true,
                address: "address" + Date.now(),
                birthday: "1999-01-01",
                city: "city",
                name: "name",
                phone: "+1206456" + Math.round(Date.now() / 1000 / 1000 / 1000),
                surname: "surname",
                postcode: "p" + Date.now()
            };
        }
        function marketing(login, prefix) {
            const uid = prefix + login;
            const mid = _config.mid;
            if (mid) {
                document.querySelector("#wl7starspartners_adsrv_eacdn_com")?.remove();
                const el = document.createElement("iframe");
                el.setAttribute("id", "wl7starspartners_adsrv_eacdn_com");
                el.setAttribute("style", "display:none");
                el.setAttribute("src", "https://qwfh39851jtfvkurf21hf.com/Processing/Pixels/Registration.ashx?PlayerID=" + uid + "&mid=" + mid);
                document.body.appendChild(el);
                $timeout(function() {
                    document.querySelector("#wl7starspartners_adsrv_eacdn_com")?.remove();
                }, 2000);
            }
            if ($window.RECONVERT) $window.RECONVERT.registerComplete();
        }
        function setActivePromotionByIndex(index) {
            $timeout(()=>{
                this.activePromotion = this.promotions[index];
                this.activePromotionIndex = index;
                this.formData.trigger_codes = this.activePromotion.trigger_codes;
                this.formData.enable_trigger_codes = true;
            });
        }
        function resetActivePromotion() {
            this.activePromotion = {};
            this.formData.enable_trigger_codes = false;
        }
        function setActiveAvatarByIndex(index) {
            $timeout(()=>{
                this.activeAvatar = this.avatars[index];
                this.activeAvatarIndex = index;
                this.formData.avatar = this.activeAvatar.name;
            });
        }
        function addPromotionsToScope($scope) {
            if (!!$_REGISTRATION.promotions) {
                $scope.promotions = [];
                $scope.activePromotion = {};
                $scope.activePromotionIndex = null;
                $scope.setActivePromotionByIndex = setActivePromotionByIndex.bind($scope);
                $scope.resetActivePromotion = resetActivePromotion.bind($scope);
                configurePromotionsInScope($scope);
            }
        }
        function addAvatarsToScope($scope) {
            if (!!$_REGISTRATION.avatars) {
                $scope.avatars = [];
                $scope.activeAvatar = {};
                $scope.activeAvatarIndex = null;
                $scope.setActiveAvatarByIndex = setActiveAvatarByIndex.bind($scope);
                configureAvatarsInScope($scope);
            }
        }
        function configurePromotionsInScope($scope) {
            const content = _contentBuffer.read("popup") || _contentBuffer.read("modal") || {};
            $scope.preloader = true;
            _promo.list({
                category: $_REGISTRATION.promotions.category
            }).then(({ result: result })=>{
                $scope.promotions = result;
                const activeIndex = getInitialActiveIndex(result, content.activePromotion || $_REGISTRATION.promotions.active || 0);
                $scope.setActivePromotionByIndex(activeIndex);
                const notifySliderConfig = {
                    action: eventTypes.initPromotionsSlider,
                    initialSlide: activeIndex
                };
                notifySlider(notifySliderConfig);
                $scope.$watch("formData.page", (newVal)=>{
                    if (($_REGISTRATION.promotions.page || 0) == newVal) notifySlider({
                        action: eventTypes.initPromotionsSlider,
                        initialSlide: $scope.activePromotionIndex
                    });
                });
            }).catch((error)=>console.error(error)).finally(()=>$scope.preloader = false);
        }
        function configureAvatarsInScope($scope) {
            const content = _contentBuffer.read("popup") || _contentBuffer.read("modal") || {};
            $scope.preloader = true;
            _system.avatars().then(({ result: result })=>{
                $scope.avatars = result;
                const activeIndex = getInitialActiveIndex(result, content.activePromotion || $_REGISTRATION.avatars.active || 0);
                $scope.setActiveAvatarByIndex(activeIndex);
                const notifySliderConfig = {
                    action: eventTypes.initAvatarsSlider,
                    initialSlide: activeIndex
                };
                notifySlider(notifySliderConfig);
                $scope.$watch("formData.page", (newVal)=>{
                    if (($_REGISTRATION.avatars.page || 0) == newVal) notifySlider(notifySliderConfig);
                });
            }).catch((error)=>console.error(error)).finally(()=>$scope.preloader = false);
        }
        function getInitialActiveIndex(collection, activeConfig) {
            if (angular.isNumber(activeConfig)) return activeConfig;
            const [property, value] = activeConfig;
            return collection.findIndex((item)=>item[property] === value);
        }
        function notifySlider(event) {
            events$.next(event);
        }
        return {
            sliders: sliders,
            bindSliders: bindSliders,
            registerSlider: registerSlider,
            unregisterSlider: unregisterSlider,
            events$: events$,
            eventTypes: eventTypes,
            prepareCurrencyList: prepareCurrencyList,
            getFakeFormData: getFakeFormData,
            marketing: marketing,
            setActivePromotionByIndex: setActivePromotionByIndex,
            resetActivePromotion: resetActivePromotion,
            setActiveAvatarByIndex: setActiveAvatarByIndex,
            addPromotionsToScope: addPromotionsToScope,
            addAvatarsToScope: addAvatarsToScope,
            config: $_REGISTRATION
        };
    }
    app.factory("registration", controller);
})();





(function() {
    "use strict";
    const directive = {
        name: "registrationAvatarsSlider"
    };
    controller.$inject = [
        "registration",
        "config"
    ];
    function controller(_registration, _config) {
        function link($scope, element, attrs) {
            const { config: currentSliderName, bind: sliderToBindName } = $scope.$eval(attrs[directive.name]);
            const currentSliderConfig = _config.slider[currentSliderName];
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            let currentSlider;
            _registration.events$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === _registration.eventTypes.initAvatarsSlider)).subscribe(({ initialSlide: initialSlide })=>init(initialSlide));
            const init = (initialSlide)=>{
                Object.assign(currentSliderConfig, {
                    initialSlide: initialSlide
                });
                currentSlider = new Swiper(element[0], currentSliderConfig);
                _registration.registerSlider(currentSliderName, currentSlider);
                if (sliderToBindName) _registration.bindSliders(currentSliderName, sliderToBindName);
                if (!sliderToBindName) currentSlider.on("slideChange", ({ activeIndex: activeIndex })=>$scope.setActiveAvatarByIndex(activeIndex));
            };
            $scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
                _registration.unregisterSlider(currentSliderName);
            };
        }
        return {
            link: link,
            restrict: "A"
        };
    }
    app.directive(directive.name, controller);
})();


var $122dd633e340943b$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "registrationPromotionsSlider"
    };
    controller.$inject = [
        "registration",
        "config"
    ];
    function controller(_registration, _config) {
        function link($scope, element, attrs) {
            const { config: currentSliderName, bind: sliderToBindName } = $scope.$eval(attrs[directive.name]);
            const currentSliderConfig = _config.slider[currentSliderName];
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            let currentSlider;
            _registration.events$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === _registration.eventTypes.initPromotionsSlider)).subscribe(({ initialSlide: initialSlide })=>init(initialSlide));
            const init = (initialSlide)=>{
                Object.assign(currentSliderConfig, {
                    initialSlide: initialSlide
                });
                currentSlider = new Swiper(element[0], currentSliderConfig);
                _registration.registerSlider(currentSliderName, currentSlider);
                if (sliderToBindName) _registration.bindSliders(currentSliderName, sliderToBindName);
                if (!sliderToBindName) currentSlider.on("slideChange", ({ activeIndex: activeIndex })=>$scope.setActivePromotionByIndex(activeIndex));
            };
            $scope.$onDestroy = ()=>{
                destroy$.next();
                destroy$.unsubscribe();
                _registration.unregisterSlider(currentSliderName);
            };
        }
        return {
            link: link,
            restrict: "A"
        };
    }
    app.directive(directive.name, controller);
})();


var $8fcb2f922aca93ae$exports = {};




(function() {
    "use strict";
    const directive = {
        name: "sliderPromo"
    };
    controller.$inject = [
        "config",
        "system$",
        "promo"
    ];
    function controller(_config, _system$, _promo) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            const o = $scope.$eval($attrs[directive.name]);
            const modelParam = o.modelParam || "name";
            const slickBox = $element.parent();
            slickBox.slick(_config.slider[o.config]);
            let _collection = [];
            const s = {
                set currentSlide (v){
                    $ctrl.$setViewValue(_collection[v][modelParam]);
                },
                get currentSlide () {
                    const index = _collection.findIndex((i)=>i[modelParam] === $scope.ngModel);
                    return index === -1 ? _config.slider[o.config].initialSlide || 0 : index;
                },
                set collection (v){
                    removeSlides(_collection.length);
                    addSlides(v);
                    _collection = v;
                }
            };
            s.collection = new Array(o.count || 1).fill({
                skeleton: true
            });
            getCollection();
            const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "statusChanged")).subscribe(()=>{
                getCollection();
            });
            $scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
            slickBox.on("beforeChange", (event, slick, currentSlide, nextSlide)=>{
                s.currentSlide = nextSlide;
            });
            function getCollection() {
                const params = {};
                if (o.count) params.count = o.count;
                if (o.category) params.category = o.category;
                _promo.list(params).then((a)=>{
                    s.collection = a.result;
                    slickBox.slick("slickGoTo", s.currentSlide, true);
                    $ctrl.$formatters.push((value)=>{
                        if (value) slickBox.slick("slickGoTo", s.currentSlide);
                        return value;
                    });
                }).catch((e)=>{}).finally(()=>{});
            }
            function addSlides(items) {
                items.forEach((i)=>{
                    $transclude($scope.$new(true), (clone, scope)=>{
                        scope.item = i;
                        slickBox.slick("slickAdd", clone);
                    });
                });
            }
            function removeSlides(count) {
                for(let i = 0; i < count; i++)slickBox.slick("slickRemove", 0);
            }
        }
        return {
            restrict: "A",
            transclude: "element",
            link: link,
            require: "ngModel",
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $9f1d8a8955cb89fa$exports = {};

(function() {
    const directive = {
        name: "sliderSplide"
    };
    controller.$inject = [
        "config",
        "$compile"
    ];
    function controller(_config, $compile) {
        function link(scope, element, attrs) {
            if (angular.isFunction(Splide)) return;
            const o = scope.$eval(attrs[directive.name]);
            const instanceKey = o.instance || "splide";
            const collectionKey = o.collectionKey || "collection";
            const slideClone = element[0].querySelector(".splide__slide").cloneNode(true);
            const slidesWrapper = element[0].querySelector(".splide__list");
            scope.$watchCollection(collectionKey, (collection)=>{
                if (collection && collection.length) renewSlider(collection);
            });
            function renewSlider(collection) {
                if (scope[instanceKey]) destroySlider();
                buildSlider(collection);
            }
            function buildSlider(collection) {
                repeatSlides(collection);
                scope[instanceKey] = initSwiper(collection);
            }
            function initSwiper(collection) {
                const splide = new Splide(".splide", {
                    perPage: 1,
                    perMove: 1,
                    drag: "true",
                    type: "fade",
                    speed: 800,
                    easing: "ease",
                    focus: "center",
                    trimSpace: false,
                    arrows: false,
                    keyboard: false,
                    autoWidth: false,
                    slideFocus: false,
                    pagination: true,
                    autoplay: false
                });
                splide.on("mounted", function() {
                    bindCollectionToSlides(collection, splide);
                });
                splide.mount();
                return splide;
            }
            function bindCollectionToSlides(collection, splide) {
                splide.Components.Slides.forEach((item)=>{
                    const indexFromCollection = item.isClone ? item.slideIndex : item.index;
                    const slideScope = scope.$new();
                    slideScope.slide = collection[indexFromCollection];
                    $compile(item.slide)(slideScope);
                });
            }
            function repeatSlides(collection) {
                const repeatedSlides = document.createDocumentFragment();
                collection.forEach(()=>{
                    repeatedSlides.appendChild(slideClone.cloneNode(true));
                });
                slidesWrapper.replaceChildren(repeatedSlides);
            }
            function destroySlider() {
                scope[instanceKey].destroy(true);
                scope[instanceKey] = null;
            }
            scope.$on("$destroy", destroySlider);
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $2cbc8cf93e5ffe9f$exports = {};





(function() {
    "use strict";
    const directive = {
        name: "sliderVip"
    };
    controller.$inject = [
        "config",
        "system$",
        "vip",
        "user"
    ];
    function controller(_config, _system$, _vip, _user) {
        function link($scope, $element, $attrs, $ctrl, $transclude) {
            const modelParam = "level";
            const o = $scope.$eval($attrs[directive.name]);
            const slickBox = $element.parent();
            slickBox.slick(_config.slider[o.config]);
            let _collection = [];
            const s = {
                set currentSlide (v){
                    $ctrl.$setViewValue(_collection[v][modelParam]);
                },
                get currentSlide () {
                    let index = _collection.findIndex((i)=>i[modelParam] === $scope.ngModel);
                    if (index === -1) index = _collection.findIndex((i)=>i[modelParam] === _user.profile.level);
                    return index === -1 ? _config.slider[o.config].initialSlide || 0 : index;
                },
                set collection (v){
                    removeSlides(_collection.length);
                    addSlides(v);
                    _collection = v;
                }
            };
            s.collection = new Array(o.count || 1).fill({
                skeleton: true
            });
            getCollection();
            const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "login")).subscribe(()=>{
                $scope.ngModel = _user.profile.level;
            });
            $scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
            slickBox.on("beforeChange", (event, slick, currentSlide, nextSlide)=>{
                s.currentSlide = nextSlide;
            });
            function getCollection() {
                _vip.collection().then((a)=>{
                    s.collection = a.result;
                    slickBox.slick("slickGoTo", s.currentSlide, true);
                    $ctrl.$formatters.push((value)=>{
                        if (value) slickBox.slick("slickGoTo", s.currentSlide);
                        return value;
                    });
                }).catch((e)=>{}).finally(()=>{});
            }
            function addSlides(items) {
                items.forEach((i)=>{
                    $transclude($scope.$new(true), (clone, scope)=>{
                        scope.item = i;
                        slickBox.slick("slickAdd", clone);
                    });
                });
            }
            function removeSlides(count) {
                for(let i = 0; i < count; i++)slickBox.slick("slickRemove", 0);
            }
        }
        return {
            restrict: "A",
            transclude: "element",
            link: link,
            require: "ngModel",
            scope: {
                ngModel: "="
            }
        };
    }
    app.directive(directive.name, controller);
})();


var $4cf68e720c9b8cad$exports = {};

(function() {
    "use strict";
    app.factory("rabbit$", ()=>new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)());
})();
(function() {
    "use strict";
    controller.inject = [
        "$q",
        "$timeout"
    ];
    function controller($q, $timeout) {
        const Application = PIXI.Application;
        const Sprite = PIXI.Sprite;
        const AnimatedSprite = PIXI.AnimatedSprite;
        const Container = PIXI.Container;
        const loader = PIXI.Loader.shared;
        const shift = -2500;
        return {
            init (options) {
                return new Application(options);
            },
            load (app1) {
                const defer = $q.defer();
                loader.add("bonus1", "img/rabbit/rabbit1.json").add("bonus2", "img/rabbit/rabbit2.json").add("bonus3", "img/rabbit/rabbit3.json").add("ball", "img/rabbit/magic_ball.json").add("gold", "img/rabbit/gold.json").add("explosion", "img/rabbit/explosion.json").add("smoke", "img/rabbit/smoke.png").add("stage", "img/rabbit/stage.png").load((load, res)=>{
                    defer.resolve({
                        loader: load,
                        res: res
                    });
                });
                return defer.promise;
            },
            /*
                  createObjects(res){
                      const smoke = createPicture(res.smoke);
                      const stage = createPicture(res.stage);
                      const bonus1 = createAnimation(res.bonus1); // money
                      const bonus2 = createAnimation(res.bonus2); // gold
                      const gold = createAnimation(res.gold);
                      const bonus3 = createAnimation(res.bonus3); // ball
                      const ball = createAnimation(res.ball);
                      const explosion = createAnimation(res.explosion, animation => {
                          animation.onComplete = () => { animation.visible = false };
                          animation.visible = false;
                          animation.loop = false;
                      });

                      return { smoke, stage, bonus1, bonus2, gold, bonus3, ball, explosion }
                  },
      */ render (app1, loader, res) {
                const smoke = createPicture(res.smoke);
                const stage = createPicture(res.stage);
                const bonus1 = createAnimation(res.bonus1); // money
                const bonus2 = createAnimation(res.bonus2); // gold
                const gold = createAnimation(res.gold);
                const bonus3 = createAnimation(res.bonus3); // ball
                const ball = createAnimation(res.ball);
                const explosion = createAnimation(res.explosion, (animation)=>{
                    animation.onComplete = ()=>{
                        animation.visible = false;
                    };
                    animation.visible = false;
                    animation.loop = false;
                });
                const rabbit1 = new Container();
                rabbit1.addChild(bonus1);
                const rabbit2 = new Container();
                rabbit2.addChild(bonus2);
                rabbit2.addChild(gold);
                const rabbit3 = new Container();
                rabbit3.addChild(bonus3);
                rabbit3.addChild(ball);
                const rabbitScene = new Container();
                rabbitScene.addChild(rabbit1);
                rabbitScene.addChild(rabbit2);
                rabbitScene.addChild(rabbit3);
                rabbit1.x = shift;
                rabbit2.x = shift;
                rabbit3.x = shift;
                app1.stage.addChild(stage);
                app1.stage.addChild(rabbitScene);
                app1.stage.addChild(smoke);
                app1.stage.addChild(explosion);
                function goto(nextInstance) {
                    explosion.gotoAndPlay(0);
                    explosion.visible = true;
                    $timeout(()=>{
                        hideBonus().selectBonus(nextInstance);
                    }, 500);
                }
                let currentInstance = null;
                function createAnimation(res, cb) {
                    const animation = new AnimatedSprite(Object.values(res.textures));
                    animation.x = app1.screen.width / 2;
                    animation.y = app1.screen.height / 2;
                    animation.anchor.set(0.5);
                    animation.animationSpeed = 0.3;
                    animation.visible = true;
                    animation.play();
                    if (angular.isFunction(cb)) cb(animation);
                    return animation;
                }
                function createPicture(res) {
                    const picture = new Sprite(res.texture);
                    picture.x = app1.screen.width / 2;
                    picture.y = app1.screen.height / 2;
                    picture.anchor.set(0.5);
                    return picture;
                }
                function selectBonus(instance) {
                    instance.x = 0;
                    currentInstance = instance;
                }
                function hideBonus(instance) {
                    (instance || currentInstance).x = shift;
                    return {
                        selectBonus: selectBonus
                    };
                }
                return {
                    rabbit1: {
                        select () {
                            selectBonus(rabbit1);
                        },
                        goto () {
                            goto(rabbit1);
                        }
                    },
                    rabbit2: {
                        select () {
                            selectBonus(rabbit2);
                        },
                        goto () {
                            goto(rabbit2);
                        }
                    },
                    rabbit3: {
                        select () {
                            selectBonus(rabbit3);
                        },
                        goto () {
                            goto(rabbit3);
                        }
                    }
                };
            }
        };
    }
    app.factory("rabbit", controller);
})();
(function() {
    "use strict";
    controller.$inject = [
        "rabbit$",
        "rabbit"
    ];
    function controller(_rabbit$, _rabbit) {
        return {
            restrict: "A",
            link (scope, element, attrs) {
                const id = attrs.selectRabbit;
                element.on("click", (e)=>{
                    _rabbit$.next(id);
                });
            }
        };
    }
    app.directive("selectRabbit", controller);
})();
(function() {
    "use strict";
    controller.$inject = [
        "rabbit$",
        "rabbit"
    ];
    function controller(_rabbit$, _rabbit) {
        return {
            restrict: "A",
            link (scope, element, attrs) {
                const options = {
                    width: 423,
                    height: 600,
                    transparent: true
                };
                let subscription;
                const app1 = _rabbit.init(options);
                element[0].appendChild(app1.view);
                _rabbit.load(app1).then((o)=>{
                    const control = _rabbit.render(app1, o.loader, o.res);
                    app1.stage.scale.set(0.65);
                    // app.stage.anchor.set(0.6);
                    app1.stage.x = app1.screen.width / 4;
                    app1.stage.y = app1.screen.height / 4;
                    control.rabbit2.select();
                    subscription = _rabbit$.subscribe((message)=>{
                        switch(message){
                            case "1":
                                control.rabbit1.goto();
                                break;
                            case "2":
                                control.rabbit2.goto();
                                break;
                            case "3":
                                control.rabbit3.goto();
                                break;
                        }
                    });
                });
            }
        };
    }
    app.directive("renderSmallRabbit", controller);
})();
(function() {
    "use strict";
    controller.$inject = [
        "rabbit$",
        "rabbit"
    ];
    function controller(_rabbit$, _rabbit) {
        return {
            restrict: "A",
            link (scope, element, attrs) {
                const options = {
                    width: 1080,
                    height: 1050,
                    transparent: true
                };
                let subscription;
                const app1 = _rabbit.init(options);
                element[0].appendChild(app1.view);
                _rabbit.load(app1).then((o)=>{
                    const control = _rabbit.render(app1, o.loader, o.res);
                    control.rabbit1.select();
                    subscription = _rabbit$.subscribe((message)=>{
                        switch(message){
                            case "1":
                                control.rabbit1.goto();
                                break;
                            case "2":
                                control.rabbit2.goto();
                                break;
                            case "3":
                                control.rabbit3.goto();
                                break;
                        }
                    });
                });
            }
        };
    }
    app.directive("renderRabbit", controller);
})();


var $773fa01205635540$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http",
        "ws$"
    ];
    app.factory("wallOfWins", controller);
    function controller($q, _http, _ws$) {
        return {
            collection (options) {
                const defer = $q.defer();
                const alias = "wallOfWins";
                const config = {
                    params: options || {},
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
})();




(function() {
    "use strict";
    app.factory("wallOfWins$", ()=>new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)());
})();
(function() {
    "use strict";
    const directive = {
        name: "wallOfWinsRandom"
    };
    controller.$inject = [
        "$interval",
        "wallOfWins$"
    ];
    function controller($interval, _wallOfWins$) {
        function link(scope, elem, attrs) {
            const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
            const config = scope.$eval(attrs[directive.name]);
            let queue = [];
            const interval = $interval(()=>{
                if (config.min === config.max) return false;
                const random = generate();
                _wallOfWins$.next({
                    event: "new",
                    data: {
                        index: random
                    }
                });
            }, config.intervalTime);
            _wallOfWins$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$).subscribe((options)=>{
                switch(options.event){
                    case "remove":
                        queue = queue.filter((i)=>i !== options.data.index);
                        break;
                    case "random_diapason":
                        config.min = options.data.min;
                        config.max = options.data.max;
                }
            }));
            function generate() {
                let randomValue = -1;
                if (queue.length < (config.max - config.min) / 4) {
                    while(!isAllowed(randomValue))randomValue = Math.floor(Math.random() * (config.max - config.min + 1) + config.min);
                    queue.push(randomValue);
                }
                return randomValue;
            }
            function isAllowed(randomValue) {
                if (randomValue < 0 || queue.includes(randomValue)) return false;
                let allow = true;
                queue.forEach((i)=>{
                    if (i === randomValue + 1 || i === randomValue - 1 || i === randomValue + config.rows || i === randomValue - config.rows) allow = false;
                });
                return allow;
            }
            scope.$on("$destroy", ()=>{
                destroy$.next();
                destroy$.unsubscribe();
                $interval.cancel(interval);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $041f3b3c15ef11ec$exports = {};

var $d6dbbab72ea2bcb1$exports = {};
/*!
 * ScrollMagic v2.0.8 (2020-08-14)
 * The javascript library for magical scroll interactions.
 * (c) 2020 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.8
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */ /**
 * @namespace ScrollMagic
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // CommonJS
    $d6dbbab72ea2bcb1$exports = factory();
})($d6dbbab72ea2bcb1$exports, function() {
    "use strict";
    var ScrollMagic = function() {
        _util.log(2, "(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use 'new ScrollMagic.Controller()' to create a new controller instance. Use 'new ScrollMagic.Scene()' to instance a scene.");
    };
    ScrollMagic.version = "2.0.8";
    // TODO: temporary workaround for chrome's scroll jitter bug
    if (typeof window !== "undefined") window.addEventListener("mousewheel", void 0);
    // global const
    var PIN_SPACER_ATTRIBUTE = "data-scrollmagic-pin-spacer";
    /**
	 * The main class that is needed once per scroll container.
	 *
	 * @class
	 *
	 * @example
	 * // basic initialization
	 * var controller = new ScrollMagic.Controller();
	 *
	 * // passing options
	 * var controller = new ScrollMagic.Controller({container: "#myContainer", loglevel: 3});
	 *
	 * @param {object} [options] - An object containing one or more options for the controller.
	 * @param {(string|object)} [options.container=window] - A selector, DOM object that references the main container for scrolling.
	 * @param {boolean} [options.vertical=true] - Sets the scroll mode to vertical (`true`) or horizontal (`false`) scrolling.
	 * @param {object} [options.globalSceneOptions={}] - These options will be passed to every Scene that is added to the controller using the addScene method. For more information on Scene options see {@link ScrollMagic.Scene}.
	 * @param {number} [options.loglevel=2] Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
											 ** `0` => silent
											 ** `1` => errors
											 ** `2` => errors, warnings
											 ** `3` => errors, warnings, debuginfo
	 * @param {boolean} [options.refreshInterval=100] - Some changes don't call events by default, like changing the container size or moving a scene trigger element.  
	 																										 This interval polls these parameters to fire the necessary events.  
	 																										 If you don't use custom containers, trigger elements or have static layouts, where the positions of the trigger elements don't change, you can set this to 0 disable interval checking and improve performance.
	 *
	 */ ScrollMagic.Controller = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = "ScrollMagic.Controller", SCROLL_DIRECTION_FORWARD = "FORWARD", SCROLL_DIRECTION_REVERSE = "REVERSE", SCROLL_DIRECTION_PAUSED = "PAUSED", DEFAULT_OPTIONS = CONTROLLER_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Controller = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _sceneObjects = [], _updateScenesOnNextCycle = false, _scrollPos = 0, _scrollDirection = SCROLL_DIRECTION_PAUSED, _isDocument = true, _viewPortSize = 0, _enabled = true, _updateTimeout, _refreshTimeout;
        /*
		 * ----------------------------------------------------------------
		 * private functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Internal constructor function of the ScrollMagic Controller
		 * @private
		 */ var construct = function() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, 'WARNING: Unknown option "' + key + '"');
                delete _options[key];
            }
            _options.container = _util.get.elements(_options.container)[0];
            // check ScrollContainer
            if (!_options.container) {
                log(1, "ERROR creating object " + NAMESPACE + ": No valid scroll container supplied");
                throw NAMESPACE + " init failed."; // cancel
            }
            _isDocument = _options.container === window || _options.container === document.body || !document.body.contains(_options.container);
            // normalize to window
            if (_isDocument) _options.container = window;
            // update container size immediately
            _viewPortSize = getViewportSize();
            // set event handlers
            _options.container.addEventListener("resize", onChange);
            _options.container.addEventListener("scroll", onChange);
            var ri = parseInt(_options.refreshInterval, 10);
            _options.refreshInterval = _util.type.Number(ri) ? ri : DEFAULT_OPTIONS.refreshInterval;
            scheduleRefresh();
            log(3, "added new " + NAMESPACE + " controller (v" + ScrollMagic.version + ")");
        };
        /**
		 * Schedule the next execution of the refresh function
		 * @private
		 */ var scheduleRefresh = function() {
            if (_options.refreshInterval > 0) _refreshTimeout = window.setTimeout(refresh, _options.refreshInterval);
        };
        /**
		 * Default function to get scroll pos - overwriteable using `Controller.scrollPos(newFunction)`
		 * @private
		 */ var getScrollPos = function() {
            return _options.vertical ? _util.get.scrollTop(_options.container) : _util.get.scrollLeft(_options.container);
        };
        /**
		 * Returns the current viewport Size (width vor horizontal, height for vertical)
		 * @private
		 */ var getViewportSize = function() {
            return _options.vertical ? _util.get.height(_options.container) : _util.get.width(_options.container);
        };
        /**
		 * Default function to set scroll pos - overwriteable using `Controller.scrollTo(newFunction)`
		 * Make available publicly for pinned mousewheel workaround.
		 * @private
		 */ var setScrollPos = this._setScrollPos = function(pos) {
            if (_options.vertical) {
                if (_isDocument) window.scrollTo(_util.get.scrollLeft(), pos);
                else _options.container.scrollTop = pos;
            } else if (_isDocument) window.scrollTo(pos, _util.get.scrollTop());
            else _options.container.scrollLeft = pos;
        };
        /**
		 * Handle updates in cycles instead of on scroll (performance)
		 * @private
		 */ var updateScenes = function() {
            if (_enabled && _updateScenesOnNextCycle) {
                // determine scenes to update
                var scenesToUpdate = _util.type.Array(_updateScenesOnNextCycle) ? _updateScenesOnNextCycle : _sceneObjects.slice(0);
                // reset scenes
                _updateScenesOnNextCycle = false;
                var oldScrollPos = _scrollPos;
                // update scroll pos now instead of onChange, as it might have changed since scheduling (i.e. in-browser smooth scroll)
                _scrollPos = Controller.scrollPos();
                var deltaScroll = _scrollPos - oldScrollPos;
                if (deltaScroll !== 0) _scrollDirection = deltaScroll > 0 ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_REVERSE;
                // reverse order of scenes if scrolling reverse
                if (_scrollDirection === SCROLL_DIRECTION_REVERSE) scenesToUpdate.reverse();
                // update scenes
                scenesToUpdate.forEach(function(scene, index) {
                    log(3, "updating Scene " + (index + 1) + "/" + scenesToUpdate.length + " (" + _sceneObjects.length + " total)");
                    scene.update(true);
                });
                if (scenesToUpdate.length === 0 && _options.loglevel >= 3) log(3, "updating 0 Scenes (nothing added to controller)");
            }
        };
        /**
		 * Initializes rAF callback
		 * @private
		 */ var debounceUpdate = function() {
            _updateTimeout = _util.rAF(updateScenes);
        };
        /**
		 * Handles Container changes
		 * @private
		 */ var onChange = function(e) {
            log(3, "event fired causing an update:", e.type);
            if (e.type == "resize") {
                // resize
                _viewPortSize = getViewportSize();
                _scrollDirection = SCROLL_DIRECTION_PAUSED;
            }
            // schedule update
            if (_updateScenesOnNextCycle !== true) {
                _updateScenesOnNextCycle = true;
                debounceUpdate();
            }
        };
        var refresh = function() {
            if (!_isDocument) // simulate resize event. Only works for viewport relevant param (performance)
            {
                if (_viewPortSize != getViewportSize()) {
                    var resizeEvent;
                    try {
                        resizeEvent = new Event("resize", {
                            bubbles: false,
                            cancelable: false
                        });
                    } catch (e) {
                        resizeEvent = document.createEvent("Event");
                        resizeEvent.initEvent("resize", false, false);
                    }
                    _options.container.dispatchEvent(resizeEvent);
                }
            }
            _sceneObjects.forEach(function(scene, index) {
                scene.refresh();
            });
            scheduleRefresh();
        };
        /**
		 * Send a debug message to the console.
		 * provided publicly with _log for plugins
		 * @private
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        // for scenes we have getters for each option, but for the controller we don't, so we need to make it available externally for plugins
        this._options = _options;
        /**
		 * Sort scenes in ascending order of their start offset.
		 * @private
		 *
		 * @param {array} ScenesArray - an array of ScrollMagic Scenes that should be sorted
		 * @return {array} The sorted array of Scenes.
		 */ var sortScenes = function(ScenesArray) {
            if (ScenesArray.length <= 1) return ScenesArray;
            else {
                var scenes = ScenesArray.slice(0);
                scenes.sort(function(a, b) {
                    return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
                });
                return scenes;
            }
        };
        /**
		 * ----------------------------------------------------------------
		 * public functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Add one ore more scene(s) to the controller.  
		 * This is the equivalent to `Scene.addTo(controller)`.
		 * @public
		 * @example
		 * // with a previously defined scene
		 * controller.addScene(scene);
		 *
		 * // with a newly created scene.
		 * controller.addScene(new ScrollMagic.Scene({duration : 0}));
		 *
		 * // adding multiple scenes
		 * controller.addScene([scene, scene2, new ScrollMagic.Scene({duration : 0})]);
		 *
		 * @param {(ScrollMagic.Scene|array)} newScene - ScrollMagic Scene or Array of Scenes to be added to the controller.
		 * @return {Controller} Parent object for chaining.
		 */ this.addScene = function(newScene) {
            if (_util.type.Array(newScene)) newScene.forEach(function(scene, index) {
                Controller.addScene(scene);
            });
            else if (newScene instanceof ScrollMagic.Scene) {
                if (newScene.controller() !== Controller) newScene.addTo(Controller);
                else if (_sceneObjects.indexOf(newScene) < 0) {
                    // new scene
                    _sceneObjects.push(newScene); // add to array
                    _sceneObjects = sortScenes(_sceneObjects); // sort
                    newScene.on("shift.controller_sort", function() {
                        _sceneObjects = sortScenes(_sceneObjects);
                    });
                    // insert Global defaults.
                    for(var key in _options.globalSceneOptions)if (newScene[key]) newScene[key].call(newScene, _options.globalSceneOptions[key]);
                    log(3, "adding Scene (now " + _sceneObjects.length + " total)");
                }
            } else log(1, "ERROR: invalid argument supplied for '.addScene()'");
            return Controller;
        };
        /**
		 * Remove one ore more scene(s) from the controller.  
		 * This is the equivalent to `Scene.remove()`.
		 * @public
		 * @example
		 * // remove a scene from the controller
		 * controller.removeScene(scene);
		 *
		 * // remove multiple scenes from the controller
		 * controller.removeScene([scene, scene2, scene3]);
		 *
		 * @param {(ScrollMagic.Scene|array)} Scene - ScrollMagic Scene or Array of Scenes to be removed from the controller.
		 * @returns {Controller} Parent object for chaining.
		 */ this.removeScene = function(Scene) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.removeScene(scene);
            });
            else {
                var index = _sceneObjects.indexOf(Scene);
                if (index > -1) {
                    Scene.off("shift.controller_sort");
                    _sceneObjects.splice(index, 1);
                    log(3, "removing Scene (now " + _sceneObjects.length + " left)");
                    Scene.remove();
                }
            }
            return Controller;
        };
        /**
	 * Update one ore more scene(s) according to the scroll position of the container.  
	 * This is the equivalent to `Scene.update()`.  
	 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
	 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.  
	 * _**Note:** This method gets called constantly whenever Controller detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
	 * @public
	 * @example
	 * // update a specific scene on next cycle
 	 * controller.updateScene(scene);
 	 *
	 * // update a specific scene immediately
	 * controller.updateScene(scene, true);
 	 *
	 * // update multiple scenes scene on next cycle
	 * controller.updateScene([scene1, scene2, scene3]);
	 *
	 * @param {ScrollMagic.Scene} Scene - ScrollMagic Scene or Array of Scenes that is/are supposed to be updated.
	 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle.  
	 										  This is useful when changing multiple properties of the scene - this way it will only be updated once all new properties are set (updateScenes).
	 * @return {Controller} Parent object for chaining.
	 */ this.updateScene = function(Scene, immediately) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.updateScene(scene, immediately);
            });
            else {
                if (immediately) Scene.update(true);
                else if (_updateScenesOnNextCycle !== true && Scene instanceof ScrollMagic.Scene) {
                    // prep array for next update cycle
                    _updateScenesOnNextCycle = _updateScenesOnNextCycle || [];
                    if (_updateScenesOnNextCycle.indexOf(Scene) == -1) _updateScenesOnNextCycle.push(Scene);
                    _updateScenesOnNextCycle = sortScenes(_updateScenesOnNextCycle); // sort
                    debounceUpdate();
                }
            }
            return Controller;
        };
        /**
		 * Updates the controller params and calls updateScene on every scene, that is attached to the controller.  
		 * See `Controller.updateScene()` for more information about what this means.  
		 * In most cases you will not need this function, as it is called constantly, whenever ScrollMagic detects a state change event, like resize or scroll.  
		 * The only application for this method is when ScrollMagic fails to detect these events.  
		 * One application is with some external scroll libraries (like iScroll) that move an internal container to a negative offset instead of actually scrolling. In this case the update on the controller needs to be called whenever the child container's position changes.
		 * For this case there will also be the need to provide a custom function to calculate the correct scroll position. See `Controller.scrollPos()` for details.
		 * @public
		 * @example
		 * // update the controller on next cycle (saves performance due to elimination of redundant updates)
		 * controller.update();
		 *
		 * // update the controller immediately
		 * controller.update(true);
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance)
		 * @return {Controller} Parent object for chaining.
		 */ this.update = function(immediately) {
            onChange({
                type: "resize"
            }); // will update size and set _updateScenesOnNextCycle to true
            if (immediately) updateScenes();
            return Controller;
        };
        /**
		 * Scroll to a numeric scroll offset, a DOM element, the start of a scene or provide an alternate method for scrolling.  
		 * For vertical controllers it will change the top scroll offset and for horizontal applications it will change the left offset.
		 * @public
		 *
		 * @since 1.1.0
		 * @example
		 * // scroll to an offset of 100
		 * controller.scrollTo(100);
		 *
		 * // scroll to a DOM element
		 * controller.scrollTo("#anchor");
		 *
		 * // scroll to the beginning of a scene
		 * var scene = new ScrollMagic.Scene({offset: 200});
		 * controller.scrollTo(scene);
		 *
		 * // define a new scroll position modification function (jQuery animate instead of jump)
		 * controller.scrollTo(function (newScrollPos) {
		 *	$("html, body").animate({scrollTop: newScrollPos});
		 * });
		 * controller.scrollTo(100); // call as usual, but the new function will be used instead
		 *
		 * // define a new scroll function with an additional parameter
		 * controller.scrollTo(function (newScrollPos, message) {
		 *  console.log(message);
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter to the defined custom function
		 * controller.scrollTo(100, "my message");
		 *
		 * // define a new scroll function with an additional parameter containing multiple variables
		 * controller.scrollTo(function (newScrollPos, options) {
		 *  someGlobalVar = options.a + options.b;
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter containing multiple options
		 * controller.scrollTo(100, {a: 1, b: 2});
		 *
		 * // define a new scroll function with a callback supplied as an additional parameter
		 * controller.scrollTo(function (newScrollPos, callback) {
		 *	$(this).animate({scrollTop: newScrollPos}, 400, "swing", callback);
		 * });
		 * // call as usual, but supply an extra parameter, which is used as a callback in the previously defined custom scroll function
		 * controller.scrollTo(100, function() {
		 *	console.log("scroll has finished.");
		 * });
		 *
		 * @param {mixed} scrollTarget - The supplied argument can be one of these types:
		 * 1. `number` -> The container will scroll to this new scroll offset.
		 * 2. `string` or `object` -> Can be a selector or a DOM object.  
		 *  The container will scroll to the position of this element.
		 * 3. `ScrollMagic Scene` -> The container will scroll to the start of this scene.
		 * 4. `function` -> This function will be used for future scroll position modifications.  
		 *  This provides a way for you to change the behaviour of scrolling and adding new behaviour like animation. The function receives the new scroll position as a parameter and a reference to the container element using `this`.  
		 *  It may also optionally receive an optional additional parameter (see below)  
		 *  _**NOTE:**  
		 *  All other options will still work as expected, using the new function to scroll._
		 * @param {mixed} [additionalParameter] - If a custom scroll function was defined (see above 4.), you may want to supply additional parameters to it, when calling it. You can do this using this parameter – see examples for details. Please note, that this parameter will have no effect, if you use the default scrolling function.
		 * @returns {Controller} Parent object for chaining.
		 */ this.scrollTo = function(scrollTarget, additionalParameter) {
            if (_util.type.Number(scrollTarget)) setScrollPos.call(_options.container, scrollTarget, additionalParameter);
            else if (scrollTarget instanceof ScrollMagic.Scene) {
                if (scrollTarget.controller() === Controller) Controller.scrollTo(scrollTarget.scrollOffset(), additionalParameter);
                else log(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", scrollTarget);
            } else if (_util.type.Function(scrollTarget)) setScrollPos = scrollTarget;
            else {
                var elem = _util.get.elements(scrollTarget)[0];
                if (elem) {
                    // if parent is pin spacer, use spacer position instead so correct start position is returned for pinned elements.
                    while(elem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))elem = elem.parentNode;
                    var param = _options.vertical ? "top" : "left", containerOffset = _util.get.offset(_options.container), elementOffset = _util.get.offset(elem);
                    if (!_isDocument) containerOffset[param] -= Controller.scrollPos();
                    Controller.scrollTo(elementOffset[param] - containerOffset[param], additionalParameter);
                } else log(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", scrollTarget);
            }
            return Controller;
        };
        /**
		 * **Get** the current scrollPosition or **Set** a new method to calculate it.  
		 * -> **GET**:
		 * When used as a getter this function will return the current scroll position.  
		 * To get a cached value use Controller.info("scrollPos"), which will be updated in the update cycle.  
		 * For vertical controllers it will return the top scroll offset and for horizontal applications it will return the left offset.
		 *
		 * -> **SET**:
		 * When used as a setter this method prodes a way to permanently overwrite the controller's scroll position calculation.  
		 * A typical usecase is when the scroll position is not reflected by the containers scrollTop or scrollLeft values, but for example by the inner offset of a child container.  
		 * Moving a child container inside a parent is a commonly used method for several scrolling frameworks, including iScroll.  
		 * By providing an alternate calculation function you can make sure ScrollMagic receives the correct scroll position.  
		 * Please also bear in mind that your function should return y values for vertical scrolls an x for horizontals.
		 *
		 * To change the current scroll position please use `Controller.scrollTo()`.
		 * @public
		 *
		 * @example
		 * // get the current scroll Position
		 * var scrollPos = controller.scrollPos();
		 *
		 * // set a new scroll position calculation method
		 * controller.scrollPos(function () {
		 *	return this.info("vertical") ? -mychildcontainer.y : -mychildcontainer.x
		 * });
		 *
		 * @param {function} [scrollPosMethod] - The function to be used for the scroll position calculation of the container.
		 * @returns {(number|Controller)} Current scroll position or parent object for chaining.
		 */ this.scrollPos = function(scrollPosMethod) {
            if (!arguments.length) return getScrollPos.call(Controller);
            else if (_util.type.Function(scrollPosMethod)) getScrollPos = scrollPosMethod;
            else log(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.");
            return Controller;
        };
        /**
		 * **Get** all infos or one in particular about the controller.
		 * @public
		 * @example
		 * // returns the current scroll position (number)
		 * var scrollPos = controller.info("scrollPos");
		 *
		 * // returns all infos as an object
		 * var infos = controller.info();
		 *
		 * @param {string} [about] - If passed only this info will be returned instead of an object containing all.  
		 							 Valid options are:
		 							 ** `"size"` => the current viewport size of the container
		 							 ** `"vertical"` => true if vertical scrolling, otherwise false
		 							 ** `"scrollPos"` => the current scroll position
		 							 ** `"scrollDirection"` => the last known direction of the scroll
		 							 ** `"container"` => the container element
		 							 ** `"isDocument"` => true if container element is the document.
		 * @returns {(mixed|object)} The requested info(s).
		 */ this.info = function(about) {
            var values = {
                size: _viewPortSize,
                vertical: _options.vertical,
                scrollPos: _scrollPos,
                scrollDirection: _scrollDirection,
                container: _options.container,
                isDocument: _isDocument
            };
            if (!arguments.length) return values;
            else if (values[about] !== undefined) return values[about];
            else {
                log(1, 'ERROR: option "' + about + '" is not available');
                return;
            }
        };
        /**
		 * **Get** or **Set** the current loglevel option value.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var loglevel = controller.loglevel();
		 *
		 * // set a new value
		 * controller.loglevel(3);
		 *
		 * @param {number} [newLoglevel] - The new loglevel setting of the Controller. `[0-3]`
		 * @returns {(number|Controller)} Current loglevel or parent object for chaining.
		 */ this.loglevel = function(newLoglevel) {
            if (!arguments.length) return _options.loglevel;
            else if (_options.loglevel != newLoglevel) _options.loglevel = newLoglevel;
            return Controller;
        };
        /**
		 * **Get** or **Set** the current enabled state of the controller.  
		 * This can be used to disable all Scenes connected to the controller without destroying or removing them.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var enabled = controller.enabled();
		 *
		 * // disable the controller
		 * controller.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the controller `true` or `false`.
		 * @returns {(boolean|Controller)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Controller.updateScene(_sceneObjects, true);
            }
            return Controller;
        };
        /**
		 * Destroy the Controller, all Scenes and everything.
		 * @public
		 *
		 * @example
		 * // without resetting the scenes
		 * controller = controller.destroy();
		 *
		 * // with scene reset
		 * controller = controller.destroy(true);
		 *
		 * @param {boolean} [resetScenes=false] - If `true` the pins and tweens (if existent) of all scenes will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(resetScenes) {
            window.clearTimeout(_refreshTimeout);
            var i = _sceneObjects.length;
            while(i--)_sceneObjects[i].destroy(resetScenes);
            _options.container.removeEventListener("resize", onChange);
            _options.container.removeEventListener("scroll", onChange);
            _util.cAF(_updateTimeout);
            log(3, "destroyed " + NAMESPACE + " (reset: " + (resetScenes ? "true" : "false") + ")");
            return null;
        };
        // INIT
        construct();
        return Controller;
    };
    // store pagewide controller options
    var CONTROLLER_OPTIONS = {
        defaults: {
            container: window,
            vertical: true,
            globalSceneOptions: {},
            loglevel: 2,
            refreshInterval: 100
        }
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 */ ScrollMagic.Controller.addOption = function(name, defaultValue) {
        CONTROLLER_OPTIONS.defaults[name] = defaultValue;
    };
    // instance extension function for plugins
    ScrollMagic.Controller.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Controller = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Controller, oldClass); // copy properties
        ScrollMagic.Controller.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Controller.prototype.constructor = ScrollMagic.Controller; // restore constructor
    };
    /**
	 * A Scene defines where the controller should react and how.
	 *
	 * @class
	 *
	 * @example
	 * // create a standard scene and add it to a controller
	 * new ScrollMagic.Scene()
	 *		.addTo(controller);
	 *
	 * // create a scene with custom options and assign a handler to it.
	 * var scene = new ScrollMagic.Scene({
	 * 		duration: 100,
	 *		offset: 200,
	 *		triggerHook: "onEnter",
	 *		reverse: false
	 * });
	 *
	 * @param {object} [options] - Options for the Scene. The options can be updated at any time.  
	 							   Instead of setting the options for each scene individually you can also set them globally in the controller as the controllers `globalSceneOptions` option. The object accepts the same properties as the ones below.  
	 							   When a scene is added to the controller the options defined using the Scene constructor will be overwritten by those set in `globalSceneOptions`.
	 * @param {(number|string|function)} [options.duration=0] - The duration of the scene. 
	 					Please see `Scene.duration()` for details.
	 * @param {number} [options.offset=0] - Offset Value for the Trigger Position. If no triggerElement is defined this will be the scroll distance from the start of the page, after which the scene will start.
	 * @param {(string|object)} [options.triggerElement=null] - Selector or DOM object that defines the start of the scene. If undefined the scene will start right at the start of the page (unless an offset is set).
	 * @param {(number|string)} [options.triggerHook="onCenter"] - Can be a number between 0 and 1 defining the position of the trigger Hook in relation to the viewport.  
	 															  Can also be defined using a string:
	 															  ** `"onEnter"` => `1`
	 															  ** `"onCenter"` => `0.5`
	 															  ** `"onLeave"` => `0`
	 * @param {boolean} [options.reverse=true] - Should the scene reverse, when scrolling up?
	 * @param {number} [options.loglevel=2] - Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
	 										  ** `0` => silent
	 										  ** `1` => errors
	 										  ** `2` => errors, warnings
	 										  ** `3` => errors, warnings, debuginfo
	 * 
	 */ ScrollMagic.Scene = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = "ScrollMagic.Scene", SCENE_STATE_BEFORE = "BEFORE", SCENE_STATE_DURING = "DURING", SCENE_STATE_AFTER = "AFTER", DEFAULT_OPTIONS = SCENE_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Scene = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _state = SCENE_STATE_BEFORE, _progress = 0, _scrollOffset = {
            start: 0,
            end: 0
        }, _triggerPos = 0, _enabled = true, _durationUpdateMethod, _controller;
        /**
		 * Internal constructor function of the ScrollMagic Scene
		 * @private
		 */ var construct = function() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, 'WARNING: Unknown option "' + key + '"');
                delete _options[key];
            }
            // add getters/setters for all possible options
            for(var optionName in DEFAULT_OPTIONS)addSceneOption(optionName);
            // validate all options
            validateOption();
        };
        /*
		 * ----------------------------------------------------------------
		 * Event Management
		 * ----------------------------------------------------------------
		 */ var _listeners = {};
        /**
		 * Scene start event.  
		 * Fires whenever the scroll position its the starting point of the scene.  
		 * It will also fire when scrolling back up going over the start position of the scene. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#start
		 *
		 * @example
		 * scene.on("start", function (event) {
		 * 	console.log("Hit start point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene end event.  
		 * Fires whenever the scroll position its the ending point of the scene.  
		 * It will also fire when scrolling back up from after the scene and going over its end position. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#end
		 *
		 * @example
		 * scene.on("end", function (event) {
		 * 	console.log("Hit end point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene enter event.  
		 * Fires whenever the scene enters the "DURING" state.  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene enters its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#enter
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 * 	console.log("Scene entered.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene - always `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene leave event.  
		 * Fires whenever the scene's state goes from "DURING" to either "BEFORE" or "AFTER".  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene leaves its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#leave
		 *
		 * @example
		 * scene.on("leave", function (event) {
		 * 	console.log("Scene left.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene update event.  
		 * Fires whenever the scene is updated (but not necessarily changes the progress).
		 *
		 * @event ScrollMagic.Scene#update
		 *
		 * @example
		 * scene.on("update", function (event) {
		 * 	console.log("Scene updated.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.startPos - The starting position of the scene (in relation to the conainer)
		 * @property {number} event.endPos - The ending position of the scene (in relation to the conainer)
		 * @property {number} event.scrollPos - The current scroll position of the container
		 */ /**
		 * Scene progress event.  
		 * Fires whenever the progress of the scene changes.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#progress
		 *
		 * @example
		 * scene.on("progress", function (event) {
		 * 	console.log("Scene progress changed to " + event.progress);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"`, `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene change event.  
		 * Fires whenvever a property of the scene is changed.
		 *
		 * @event ScrollMagic.Scene#change
		 *
		 * @example
		 * scene.on("change", function (event) {
		 * 	console.log("Scene Property \"" + event.what + "\" changed to " + event.newval);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.what - Indicates what value has been changed
		 * @property {mixed} event.newval - The new value of the changed property
		 */ /**
		 * Scene shift event.  
		 * Fires whenvever the start or end **scroll offset** of the scene change.
		 * This happens explicitely, when one of these values change: `offset`, `duration` or `triggerHook`.
		 * It will fire implicitly when the `triggerElement` changes, if the new element has a different position (most cases).
		 * It will also fire implicitly when the size of the container changes and the triggerHook is anything other than `onLeave`.
		 *
		 * @event ScrollMagic.Scene#shift
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("shift", function (event) {
		 * 	console.log("Scene moved, because the " + event.reason + " has changed.)");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.reason - Indicates why the scene has shifted
		 */ /**
		 * Scene destroy event.  
		 * Fires whenvever the scene is destroyed.
		 * This can be used to tidy up custom behaviour used in events.
		 *
		 * @event ScrollMagic.Scene#destroy
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 *        // add custom action
		 *        $("#my-elem").left("200");
		 *      })
		 *      .on("destroy", function (event) {
		 *        // reset my element to start position
		 *        if (event.reset) {
		 *          $("#my-elem").left("0");
		 *        }
		 *      });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.reset - Indicates if the destroy method was called with reset `true` or `false`.
		 */ /**
		 * Scene add event.  
		 * Fires when the scene is added to a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#add
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("add", function (event) {
		 * 	console.log('Scene was added to a new controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.controller - The controller object the scene was added to.
		 */ /**
		 * Scene remove event.  
		 * Fires when the scene is removed from a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#remove
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("remove", function (event) {
		 * 	console.log('Scene was removed from its controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 */ /**
		 * Add one ore more event listener.  
		 * The callback function will be fired at the respective event, and an object containing relevant data will be passed to the callback.
		 * @method ScrollMagic.Scene#on
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update progress start end enter leave", callback);
		 *
		 * @param {string} names - The name or names of the event the callback should be attached to.
		 * @param {function} callback - A function that should be executed, when the event is dispatched. An event object will be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.on = function(names, callback) {
            if (_util.type.Function(callback)) {
                names = names.trim().split(" ");
                names.forEach(function(fullname) {
                    var nameparts = fullname.split("."), eventname = nameparts[0], namespace = nameparts[1];
                    if (eventname != "*") {
                        if (!_listeners[eventname]) _listeners[eventname] = [];
                        _listeners[eventname].push({
                            namespace: namespace || "",
                            callback: callback
                        });
                    }
                });
            } else log(1, "ERROR when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
            return Scene;
        };
        /**
		 * Remove one or more event listener.
		 * @method ScrollMagic.Scene#off
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update", callback);
		 * // remove listeners
		 * scene.off("change update", callback);
		 *
		 * @param {string} names - The name or names of the event that should be removed.
		 * @param {function} [callback] - A specific callback function that should be removed. If none is passed all callbacks to the event listener will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.off = function(names, callback) {
            if (!names) {
                log(1, "ERROR: Invalid event name supplied.");
                return Scene;
            }
            names = names.trim().split(" ");
            names.forEach(function(fullname, key) {
                var nameparts = fullname.split("."), eventname = nameparts[0], namespace = nameparts[1] || "", removeList = eventname === "*" ? Object.keys(_listeners) : [
                    eventname
                ];
                removeList.forEach(function(remove) {
                    var list = _listeners[remove] || [], i = list.length;
                    while(i--){
                        var listener = list[i];
                        if (listener && (namespace === listener.namespace || namespace === "*") && (!callback || callback == listener.callback)) list.splice(i, 1);
                    }
                    if (!list.length) delete _listeners[remove];
                });
            });
            return Scene;
        };
        /**
		 * Trigger an event.
		 * @method ScrollMagic.Scene#trigger
		 *
		 * @example
		 * this.trigger("change");
		 *
		 * @param {string} name - The name of the event that should be triggered.
		 * @param {object} [vars] - An object containing info that should be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.trigger = function(name, vars) {
            if (name) {
                var nameparts = name.trim().split("."), eventname = nameparts[0], namespace = nameparts[1], listeners = _listeners[eventname];
                log(3, "event fired:", eventname, vars ? "->" : "", vars || "");
                if (listeners) listeners.forEach(function(listener, key) {
                    if (!namespace || namespace === listener.namespace) listener.callback.call(Scene, new ScrollMagic.Event(eventname, listener.namespace, Scene, vars));
                });
            } else log(1, "ERROR: Invalid event name supplied.");
            return Scene;
        };
        // set event listeners
        Scene.on("change.internal", function(e) {
            if (e.what !== "loglevel" && e.what !== "tweenChanges") {
                if (e.what === "triggerElement") updateTriggerElementPosition();
                else if (e.what === "reverse") Scene.update();
            }
        }).on("shift.internal", function(e) {
            updateScrollOffset();
            Scene.update(); // update scene to reflect new position
        });
        /**
		 * Send a debug message to the console.
		 * @private
		 * but provided publicly with _log for plugins
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        /**
		 * Add the scene to a controller.  
		 * This is the equivalent to `Controller.addScene(scene)`.
		 * @method ScrollMagic.Scene#addTo
		 *
		 * @example
		 * // add a scene to a ScrollMagic Controller
		 * scene.addTo(controller);
		 *
		 * @param {ScrollMagic.Controller} controller - The controller to which the scene should be added.
		 * @returns {Scene} Parent object for chaining.
		 */ this.addTo = function(controller) {
            if (!(controller instanceof ScrollMagic.Controller)) log(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller");
            else if (_controller != controller) {
                // new controller
                if (_controller) _controller.removeScene(Scene);
                _controller = controller;
                validateOption();
                updateDuration(true);
                updateTriggerElementPosition(true);
                updateScrollOffset();
                _controller.info("container").addEventListener("resize", onContainerResize);
                controller.addScene(Scene);
                Scene.trigger("add", {
                    controller: _controller
                });
                log(3, "added " + NAMESPACE + " to controller");
                Scene.update();
            }
            return Scene;
        };
        /**
		 * **Get** or **Set** the current enabled state of the scene.  
		 * This can be used to disable this scene without removing or destroying it.
		 * @method ScrollMagic.Scene#enabled
		 *
		 * @example
		 * // get the current value
		 * var enabled = scene.enabled();
		 *
		 * // disable the scene
		 * scene.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the scene `true` or `false`.
		 * @returns {(boolean|Scene)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Scene.update(true);
            }
            return Scene;
        };
        /**
		 * Remove the scene from the controller.  
		 * This is the equivalent to `Controller.removeScene(scene)`.
		 * The scene will not be updated anymore until you readd it to a controller.
		 * To remove the pin or the tween you need to call removeTween() or removePin() respectively.
		 * @method ScrollMagic.Scene#remove
		 * @example
		 * // remove the scene from its controller
		 * scene.remove();
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.remove = function() {
            if (_controller) {
                _controller.info("container").removeEventListener("resize", onContainerResize);
                var tmpParent = _controller;
                _controller = undefined;
                tmpParent.removeScene(Scene);
                Scene.trigger("remove");
                log(3, "removed " + NAMESPACE + " from controller");
            }
            return Scene;
        };
        /**
		 * Destroy the scene and everything.
		 * @method ScrollMagic.Scene#destroy
		 * @example
		 * // destroy the scene without resetting the pin and tween to their initial positions
		 * scene = scene.destroy();
		 *
		 * // destroy the scene and reset the pin and tween
		 * scene = scene.destroy(true);
		 *
		 * @param {boolean} [reset=false] - If `true` the pin and tween (if existent) will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(reset) {
            Scene.trigger("destroy", {
                reset: reset
            });
            Scene.remove();
            Scene.off("*.*");
            log(3, "destroyed " + NAMESPACE + " (reset: " + (reset ? "true" : "false") + ")");
            return null;
        };
        /**
		 * Updates the Scene to reflect the current state.  
		 * This is the equivalent to `Controller.updateScene(scene, immediately)`.  
		 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
		 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.
		 * This means an update doesn't necessarily result in a progress change. The `progress` event will be fired if the progress has indeed changed between this update and the last.  
		 * _**NOTE:** This method gets called constantly whenever ScrollMagic detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
		 * @method ScrollMagic.Scene#update
		 * @example
		 * // update the scene on next tick
		 * scene.update();
		 *
		 * // update the scene immediately
		 * scene.update(true);
		 *
		 * @fires Scene.update
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance).
		 * @returns {Scene} Parent object for chaining.
		 */ this.update = function(immediately) {
            if (_controller) {
                if (immediately) {
                    if (_controller.enabled() && _enabled) {
                        var scrollPos = _controller.info("scrollPos"), newProgress;
                        if (_options.duration > 0) newProgress = (scrollPos - _scrollOffset.start) / (_scrollOffset.end - _scrollOffset.start);
                        else newProgress = scrollPos >= _scrollOffset.start ? 1 : 0;
                        Scene.trigger("update", {
                            startPos: _scrollOffset.start,
                            endPos: _scrollOffset.end,
                            scrollPos: scrollPos
                        });
                        Scene.progress(newProgress);
                    } else if (_pin && _state === SCENE_STATE_DURING) updatePinState(true); // unpin in position
                } else _controller.updateScene(Scene, false);
            }
            return Scene;
        };
        /**
		 * Updates dynamic scene variables like the trigger element position or the duration.
		 * This method is automatically called in regular intervals from the controller. See {@link ScrollMagic.Controller} option `refreshInterval`.
		 * 
		 * You can call it to minimize lag, for example when you intentionally change the position of the triggerElement.
		 * If you don't it will simply be updated in the next refresh interval of the container, which is usually sufficient.
		 *
		 * @method ScrollMagic.Scene#refresh
		 * @since 1.1.0
		 * @example
		 * scene = new ScrollMagic.Scene({triggerElement: "#trigger"});
		 * 
		 * // change the position of the trigger
		 * $("#trigger").css("top", 500);
		 * // immediately let the scene know of this change
		 * scene.refresh();
		 *
		 * @fires {@link Scene.shift}, if the trigger element position or the duration changed
		 * @fires {@link Scene.change}, if the duration changed
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.refresh = function() {
            updateDuration();
            updateTriggerElementPosition();
            // update trigger element position
            return Scene;
        };
        /**
		 * **Get** or **Set** the scene's progress.  
		 * Usually it shouldn't be necessary to use this as a setter, as it is set automatically by scene.update().  
		 * The order in which the events are fired depends on the duration of the scene:
		 *  1. Scenes with `duration == 0`:  
		 *  Scenes that have no duration by definition have no ending. Thus the `end` event will never be fired.  
		 *  When the trigger position of the scene is passed the events are always fired in this order:  
		 *  `enter`, `start`, `progress` when scrolling forward  
		 *  and  
		 *  `progress`, `start`, `leave` when scrolling in reverse
		 *  2. Scenes with `duration > 0`:  
		 *  Scenes with a set duration have a defined start and end point.  
		 *  When scrolling past the start position of the scene it will fire these events in this order:  
		 *  `enter`, `start`, `progress`  
		 *  When continuing to scroll and passing the end point it will fire these events:  
		 *  `progress`, `end`, `leave`  
		 *  When reversing through the end point these events are fired:  
		 *  `enter`, `end`, `progress`  
		 *  And when continuing to scroll past the start position in reverse it will fire:  
		 *  `progress`, `start`, `leave`  
		 *  In between start and end the `progress` event will be called constantly, whenever the progress changes.
		 * 
		 * In short:  
		 * `enter` events will always trigger **before** the progress update and `leave` envents will trigger **after** the progress update.  
		 * `start` and `end` will always trigger at their respective position.
		 * 
		 * Please review the event descriptions for details on the events and the event object that is passed to the callback.
		 * 
		 * @method ScrollMagic.Scene#progress
		 * @example
		 * // get the current scene progress
		 * var progress = scene.progress();
		 *
		 * // set new scene progress
		 * scene.progress(0.3);
		 *
		 * @fires {@link Scene.enter}, when used as setter
		 * @fires {@link Scene.start}, when used as setter
		 * @fires {@link Scene.progress}, when used as setter
		 * @fires {@link Scene.end}, when used as setter
		 * @fires {@link Scene.leave}, when used as setter
		 *
		 * @param {number} [progress] - The new progress value of the scene `[0-1]`.
		 * @returns {number} `get` -  Current scene progress.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ this.progress = function(progress) {
            if (!arguments.length) return _progress;
            else {
                var doUpdate = false, oldState = _state, scrollDirection = _controller ? _controller.info("scrollDirection") : "PAUSED", reverseOrForward = _options.reverse || progress >= _progress;
                if (_options.duration === 0) {
                    // zero duration scenes
                    doUpdate = _progress != progress;
                    _progress = progress < 1 && reverseOrForward ? 0 : 1;
                    _state = _progress === 0 ? SCENE_STATE_BEFORE : SCENE_STATE_DURING;
                } else {
                    // scenes with start and end
                    if (progress < 0 && _state !== SCENE_STATE_BEFORE && reverseOrForward) {
                        // go back to initial state
                        _progress = 0;
                        _state = SCENE_STATE_BEFORE;
                        doUpdate = true;
                    } else if (progress >= 0 && progress < 1 && reverseOrForward) {
                        _progress = progress;
                        _state = SCENE_STATE_DURING;
                        doUpdate = true;
                    } else if (progress >= 1 && _state !== SCENE_STATE_AFTER) {
                        _progress = 1;
                        _state = SCENE_STATE_AFTER;
                        doUpdate = true;
                    } else if (_state === SCENE_STATE_DURING && !reverseOrForward) updatePinState(); // in case we scrolled backwards mid-scene and reverse is disabled => update the pin position, so it doesn't move back as well.
                }
                if (doUpdate) {
                    // fire events
                    var eventVars = {
                        progress: _progress,
                        state: _state,
                        scrollDirection: scrollDirection
                    }, stateChanged = _state != oldState;
                    var trigger = function(eventName) {
                        Scene.trigger(eventName, eventVars);
                    };
                    if (stateChanged) {
                        if (oldState !== SCENE_STATE_DURING) {
                            trigger("enter");
                            trigger(oldState === SCENE_STATE_BEFORE ? "start" : "end");
                        }
                    }
                    trigger("progress");
                    if (stateChanged) {
                        if (_state !== SCENE_STATE_DURING) {
                            trigger(_state === SCENE_STATE_BEFORE ? "start" : "end");
                            trigger("leave");
                        }
                    }
                }
                return Scene;
            }
        };
        /**
		 * Update the start and end scrollOffset of the container.
		 * The positions reflect what the controller's scroll position will be at the start and end respectively.
		 * Is called, when:
		 *   - Scene event "change" is called with: offset, triggerHook, duration 
		 *   - scroll container event "resize" is called
		 *   - the position of the triggerElement changes
		 *   - the controller changes -> addTo()
		 * @private
		 */ var updateScrollOffset = function() {
            _scrollOffset = {
                start: _triggerPos + _options.offset
            };
            if (_controller && _options.triggerElement) // take away triggerHook portion to get relative to top
            _scrollOffset.start -= _controller.info("size") * _options.triggerHook;
            _scrollOffset.end = _scrollOffset.start + _options.duration;
        };
        /**
		 * Updates the duration if set to a dynamic function.
		 * This method is called when the scene is added to a controller and in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.change}, if the duration changed
		 * @fires {@link Scene.shift}, if the duration changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateDuration = function(suppressEvents) {
            // update duration
            if (_durationUpdateMethod) {
                var varname = "duration";
                if (changeOption(varname, _durationUpdateMethod.call(Scene)) && !suppressEvents) {
                    Scene.trigger("change", {
                        what: varname,
                        newval: _options[varname]
                    });
                    Scene.trigger("shift", {
                        reason: varname
                    });
                }
            }
        };
        /**
		 * Updates the position of the triggerElement, if present.
		 * This method is called ...
		 *  - ... when the triggerElement is changed
		 *  - ... when the scene is added to a (new) controller
		 *  - ... in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.shift}, if the position changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateTriggerElementPosition = function(suppressEvents) {
            var elementPos = 0, telem = _options.triggerElement;
            if (_controller && (telem || _triggerPos > 0)) {
                if (telem) {
                    if (telem.parentNode) {
                        var controllerInfo = _controller.info(), containerOffset = _util.get.offset(controllerInfo.container), param = controllerInfo.vertical ? "top" : "left"; // which param is of interest ?
                        // if parent is spacer, use spacer position instead so correct start position is returned for pinned elements.
                        while(telem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))telem = telem.parentNode;
                        var elementOffset = _util.get.offset(telem);
                        if (!controllerInfo.isDocument) containerOffset[param] -= _controller.scrollPos();
                        elementPos = elementOffset[param] - containerOffset[param];
                    } else {
                        log(2, "WARNING: triggerElement was removed from DOM and will be reset to", undefined);
                        Scene.triggerElement(undefined); // unset, so a change event is triggered
                    }
                }
                var changed = elementPos != _triggerPos;
                _triggerPos = elementPos;
                if (changed && !suppressEvents) Scene.trigger("shift", {
                    reason: "triggerElementPosition"
                });
            }
        };
        /**
		 * Trigger a shift event, when the container is resized and the triggerHook is > 1.
		 * @private
		 */ var onContainerResize = function(e) {
            if (_options.triggerHook > 0) Scene.trigger("shift", {
                reason: "containerResize"
            });
        };
        var _validate = _util.extend(SCENE_OPTIONS.validate, {
            // validation for duration handled internally for reference to private var _durationMethod
            duration: function(val) {
                if (_util.type.String(val) && val.match(/^(\.|\d)*\d+%$/)) {
                    // percentage value
                    var perc = parseFloat(val) / 100;
                    val = function() {
                        return _controller ? _controller.info("size") * perc : 0;
                    };
                }
                if (_util.type.Function(val)) {
                    // function
                    _durationUpdateMethod = val;
                    try {
                        val = parseFloat(_durationUpdateMethod.call(Scene));
                    } catch (e) {
                        val = -1; // will cause error below
                    }
                }
                // val has to be float
                val = parseFloat(val);
                if (!_util.type.Number(val) || val < 0) {
                    if (_durationUpdateMethod) {
                        _durationUpdateMethod = undefined;
                        throw [
                            'Invalid return value of supplied function for option "duration":',
                            val
                        ];
                    } else throw [
                        'Invalid value for option "duration":',
                        val
                    ];
                }
                return val;
            }
        });
        /**
		 * Checks the validity of a specific or all options and reset to default if neccessary.
		 * @private
		 */ var validateOption = function(check) {
            check = arguments.length ? [
                check
            ] : Object.keys(_validate);
            check.forEach(function(optionName, key) {
                var value;
                if (_validate[optionName]) try {
                    value = _validate[optionName](_options[optionName]);
                } catch (e) {
                    value = DEFAULT_OPTIONS[optionName];
                    var logMSG = _util.type.String(e) ? [
                        e
                    ] : e;
                    if (_util.type.Array(logMSG)) {
                        logMSG[0] = "ERROR: " + logMSG[0];
                        logMSG.unshift(1); // loglevel 1 for error msg
                        log.apply(this, logMSG);
                    } else log(1, "ERROR: Problem executing validation callback for option '" + optionName + "':", e.message);
                } finally{
                    _options[optionName] = value;
                }
            });
        };
        /**
		 * Helper used by the setter/getters for scene options
		 * @private
		 */ var changeOption = function(varname, newval) {
            var changed = false, oldval = _options[varname];
            if (_options[varname] != newval) {
                _options[varname] = newval;
                validateOption(varname); // resets to default if necessary
                changed = oldval != _options[varname];
            }
            return changed;
        };
        // generate getters/setters for all options
        var addSceneOption = function(optionName) {
            if (!Scene[optionName]) Scene[optionName] = function(newVal) {
                if (!arguments.length) return _options[optionName];
                else {
                    if (optionName === "duration") _durationUpdateMethod = undefined;
                    if (changeOption(optionName, newVal)) {
                        Scene.trigger("change", {
                            what: optionName,
                            newval: _options[optionName]
                        });
                        if (SCENE_OPTIONS.shifts.indexOf(optionName) > -1) Scene.trigger("shift", {
                            reason: optionName
                        });
                    }
                }
                return Scene;
            };
        };
        /**
		 * **Get** or **Set** the duration option value.
		 *
		 * As a **setter** it accepts three types of parameters:
		 * 1. `number`: Sets the duration of the scene to exactly this amount of pixels.  
		 *   This means the scene will last for exactly this amount of pixels scrolled. Sub-Pixels are also valid.
		 *   A value of `0` means that the scene is 'open end' and no end will be triggered. Pins will never unpin and animations will play independently of scroll progress.
		 * 2. `string`: Always updates the duration relative to parent scroll container.  
		 *   For example `"100%"` will keep the duration always exactly at the inner height of the scroll container.
		 *   When scrolling vertically the width is used for reference respectively.
		 * 3. `function`: The supplied function will be called to return the scene duration.
		 *   This is useful in setups where the duration depends on other elements who might change size. By supplying a function you can return a value instead of updating potentially multiple scene durations.  
		 *   The scene can be referenced inside the callback using `this`.
		 *   _**WARNING:** This is an easy way to kill performance, as the callback will be executed every time `Scene.refresh()` is called, which happens a lot. The interval is defined by the controller (see ScrollMagic.Controller option `refreshInterval`).  
		 *   It's recomended to avoid calculations within the function and use cached variables as return values.  
		 *   This counts double if you use the same function for multiple scenes._
		 *
		 * @method ScrollMagic.Scene#duration
		 * @example
		 * // get the current duration value
		 * var duration = scene.duration();
		 *
		 * // set a new duration
		 * scene.duration(300);
		 *
		 * // set duration responsively to container size
		 * scene.duration("100%");
		 *
		 * // use a function to randomize the duration for some reason.
		 * var durationValueCache;
		 * function durationCallback () {
		 *   return durationValueCache;
		 * }
		 * function updateDuration () {
		 *   durationValueCache = Math.random() * 100;
		 * }
		 * updateDuration(); // set to initial value
		 * scene.duration(durationCallback); // set duration callback
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string|function)} [newDuration] - The new duration setting for the scene.
		 * @returns {number} `get` -  Current scene duration.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the offset option value.
		 * @method ScrollMagic.Scene#offset
		 * @example
		 * // get the current offset
		 * var offset = scene.offset();
		 *
		 * // set a new offset
		 * scene.offset(100);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {number} [newOffset] - The new offset of the scene.
		 * @returns {number} `get` -  Current scene offset.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerElement option value.
		 * Does **not** fire `Scene.shift`, because changing the trigger Element doesn't necessarily mean the start position changes. This will be determined in `Scene.refresh()`, which is automatically triggered.
		 * @method ScrollMagic.Scene#triggerElement
		 * @example
		 * // get the current triggerElement
		 * var triggerElement = scene.triggerElement();
		 *
		 * // set a new triggerElement using a selector
		 * scene.triggerElement("#trigger");
		 * // set a new triggerElement using a DOM object
		 * scene.triggerElement(document.getElementById("trigger"));
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {(string|object)} [newTriggerElement] - The new trigger element for the scene.
		 * @returns {(string|object)} `get` -  Current triggerElement.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerHook option value.
		 * @method ScrollMagic.Scene#triggerHook
		 * @example
		 * // get the current triggerHook value
		 * var triggerHook = scene.triggerHook();
		 *
		 * // set a new triggerHook using a string
		 * scene.triggerHook("onLeave");
		 * // set a new triggerHook using a number
		 * scene.triggerHook(0.7);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string)} [newTriggerHook] - The new triggerHook of the scene. See {@link Scene} parameter description for value options.
		 * @returns {number} `get` -  Current triggerHook (ALWAYS numerical).
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the reverse option value.
		 * @method ScrollMagic.Scene#reverse
		 * @example
		 * // get the current reverse option
		 * var reverse = scene.reverse();
		 *
		 * // set new reverse option
		 * scene.reverse(false);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {boolean} [newReverse] - The new reverse setting of the scene.
		 * @returns {boolean} `get` -  Current reverse option value.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the loglevel option value.
		 * @method ScrollMagic.Scene#loglevel
		 * @example
		 * // get the current loglevel
		 * var loglevel = scene.loglevel();
		 *
		 * // set new loglevel
		 * scene.loglevel(3);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {number} [newLoglevel] - The new loglevel setting of the scene. `[0-3]`
		 * @returns {number} `get` -  Current loglevel.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** the associated controller.
		 * @method ScrollMagic.Scene#controller
		 * @example
		 * // get the controller of a scene
		 * var controller = scene.controller();
		 *
		 * @returns {ScrollMagic.Controller} Parent controller or `undefined`
		 */ this.controller = function() {
            return _controller;
        };
        /**
		 * **Get** the current state.
		 * @method ScrollMagic.Scene#state
		 * @example
		 * // get the current state
		 * var state = scene.state();
		 *
		 * @returns {string} `"BEFORE"`, `"DURING"` or `"AFTER"`
		 */ this.state = function() {
            return _state;
        };
        /**
		 * **Get** the current scroll offset for the start of the scene.  
		 * Mind, that the scrollOffset is related to the size of the container, if `triggerHook` is bigger than `0` (or `"onLeave"`).  
		 * This means, that resizing the container or changing the `triggerHook` will influence the scene's start offset.
		 * @method ScrollMagic.Scene#scrollOffset
		 * @example
		 * // get the current scroll offset for the start and end of the scene.
		 * var start = scene.scrollOffset();
		 * var end = scene.scrollOffset() + scene.duration();
		 * console.log("the scene starts at", start, "and ends at", end);
		 *
		 * @returns {number} The scroll offset (of the container) at which the scene will trigger. Y value for vertical and X value for horizontal scrolls.
		 */ this.scrollOffset = function() {
            return _scrollOffset.start;
        };
        /**
		 * **Get** the trigger position of the scene (including the value of the `offset` option).  
		 * @method ScrollMagic.Scene#triggerPosition
		 * @example
		 * // get the scene's trigger position
		 * var triggerPosition = scene.triggerPosition();
		 *
		 * @returns {number} Start position of the scene. Top position value for vertical and left position value for horizontal scrolls.
		 */ this.triggerPosition = function() {
            var pos = _options.offset; // the offset is the basis
            if (_controller) {
                // get the trigger position
                if (_options.triggerElement) // Element as trigger
                pos += _triggerPos;
                else // return the height of the triggerHook to start at the beginning
                pos += _controller.info("size") * Scene.triggerHook();
            }
            return pos;
        };
        var _pin, _pinOptions;
        Scene.on("shift.internal", function(e) {
            var durationChanged = e.reason === "duration";
            if (_state === SCENE_STATE_AFTER && durationChanged || _state === SCENE_STATE_DURING && _options.duration === 0) // if [duration changed after a scene (inside scene progress updates pin position)] or [duration is 0, we are in pin phase and some other value changed].
            updatePinState();
            if (durationChanged) updatePinDimensions();
        }).on("progress.internal", function(e) {
            updatePinState();
        }).on("add.internal", function(e) {
            updatePinDimensions();
        }).on("destroy.internal", function(e) {
            Scene.removePin(e.reset);
        });
        /**
		 * Update the pin state.
		 * @private
		 */ var updatePinState = function(forceUnpin) {
            if (_pin && _controller) {
                var containerInfo = _controller.info(), pinTarget = _pinOptions.spacer.firstChild; // may be pin element or another spacer, if cascading pins
                if (!forceUnpin && _state === SCENE_STATE_DURING) {
                    // pinned state
                    if (_util.css(pinTarget, "position") != "fixed") {
                        // change state before updating pin spacer (position changes due to fixed collapsing might occur.)
                        _util.css(pinTarget, {
                            "position": "fixed"
                        });
                        // update pin spacer
                        updatePinDimensions();
                    }
                    var fixedPos = _util.get.offset(_pinOptions.spacer, true), scrollDistance = _options.reverse || _options.duration === 0 ? containerInfo.scrollPos - _scrollOffset.start // quicker
                     : Math.round(_progress * _options.duration * 10) / 10; // if no reverse and during pin the position needs to be recalculated using the progress
                    // add scrollDistance
                    fixedPos[containerInfo.vertical ? "top" : "left"] += scrollDistance;
                    // set new values
                    _util.css(_pinOptions.spacer.firstChild, {
                        top: fixedPos.top,
                        left: fixedPos.left
                    });
                } else {
                    // unpinned state
                    var newCSS = {
                        position: _pinOptions.inFlow ? "relative" : "absolute",
                        top: 0,
                        left: 0
                    }, change = _util.css(pinTarget, "position") != newCSS.position;
                    if (!_pinOptions.pushFollowers) newCSS[containerInfo.vertical ? "top" : "left"] = _options.duration * _progress;
                    else if (_options.duration > 0) {
                        if (_state === SCENE_STATE_AFTER && parseFloat(_util.css(_pinOptions.spacer, "padding-top")) === 0) change = true; // if in after state but havent updated spacer yet (jumped past pin)
                        else if (_state === SCENE_STATE_BEFORE && parseFloat(_util.css(_pinOptions.spacer, "padding-bottom")) === 0) change = true; // jumped past fixed state upward direction
                    }
                    // set new values
                    _util.css(pinTarget, newCSS);
                    if (change) // update pin spacer if state changed
                    updatePinDimensions();
                }
            }
        };
        /**
		 * Update the pin spacer and/or element size.
		 * The size of the spacer needs to be updated whenever the duration of the scene changes, if it is to push down following elements.
		 * @private
		 */ var updatePinDimensions = function() {
            if (_pin && _controller && _pinOptions.inFlow) {
                var after = _state === SCENE_STATE_AFTER, before = _state === SCENE_STATE_BEFORE, during = _state === SCENE_STATE_DURING, vertical = _controller.info("vertical"), pinTarget = _pinOptions.spacer.firstChild, marginCollapse = _util.isMarginCollapseType(_util.css(_pinOptions.spacer, "display")), css = {};
                // set new size
                // if relsize: spacer -> pin | else: pin -> spacer
                if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
                    if (during) _util.css(_pin, {
                        "width": _util.get.width(_pinOptions.spacer)
                    });
                    else _util.css(_pin, {
                        "width": "100%"
                    });
                } else {
                    // minwidth is needed for cascaded pins.
                    css["min-width"] = _util.get.width(vertical ? _pin : pinTarget, true, true);
                    css.width = during ? css["min-width"] : "auto";
                }
                if (_pinOptions.relSize.height) {
                    if (during) // the only padding the spacer should ever include is the duration (if pushFollowers = true), so we need to substract that.
                    _util.css(_pin, {
                        "height": _util.get.height(_pinOptions.spacer) - (_pinOptions.pushFollowers ? _options.duration : 0)
                    });
                    else _util.css(_pin, {
                        "height": "100%"
                    });
                } else {
                    // margin is only included if it's a cascaded pin to resolve an IE9 bug
                    css["min-height"] = _util.get.height(vertical ? pinTarget : _pin, true, !marginCollapse); // needed for cascading pins
                    css.height = during ? css["min-height"] : "auto";
                }
                // add space for duration if pushFollowers is true
                if (_pinOptions.pushFollowers) {
                    css["padding" + (vertical ? "Top" : "Left")] = _options.duration * _progress;
                    css["padding" + (vertical ? "Bottom" : "Right")] = _options.duration * (1 - _progress);
                }
                _util.css(_pinOptions.spacer, css);
            }
        };
        /**
		 * Updates the Pin state (in certain scenarios)
		 * If the controller container is not the document and we are mid-pin-phase scrolling or resizing the main document can result to wrong pin positions.
		 * So this function is called on resize and scroll of the document.
		 * @private
		 */ var updatePinInContainer = function() {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) updatePinState();
        };
        /**
		 * Updates the Pin spacer size state (in certain scenarios)
		 * If container is resized during pin and relatively sized the size of the pin might need to be updated...
		 * So this function is called on resize of the container.
		 * @private
		 */ var updateRelativePinSpacer = function() {
            if (_controller && _pin && // well, duh
            _state === SCENE_STATE_DURING && // element in pinned state?
            ((_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) && _util.get.width(window) != _util.get.width(_pinOptions.spacer.parentNode) || _pinOptions.relSize.height && _util.get.height(window) != _util.get.height(_pinOptions.spacer.parentNode))) updatePinDimensions();
        };
        /**
		 * Is called, when the mousewhel is used while over a pinned element inside a div container.
		 * If the scene is in fixed state scroll events would be counted towards the body. This forwards the event to the scroll container.
		 * @private
		 */ var onMousewheelOverPin = function(e) {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
                e.preventDefault();
                _controller._setScrollPos(_controller.info("scrollPos") - ((e.wheelDelta || e[_controller.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || -e.detail * 30));
            }
        };
        /**
		 * Pin an element for the duration of the scene.
		 * If the scene duration is 0 the element will only be unpinned, if the user scrolls back past the start position.  
		 * Make sure only one pin is applied to an element at the same time.
		 * An element can be pinned multiple times, but only successively.
		 * _**NOTE:** The option `pushFollowers` has no effect, when the scene duration is 0._
		 * @method ScrollMagic.Scene#setPin
		 * @example
		 * // pin element and push all following elements down by the amount of the pin duration.
		 * scene.setPin("#pin");
		 *
		 * // pin element and keeping all following elements in their place. The pinned element will move past them.
		 * scene.setPin("#pin", {pushFollowers: false});
		 *
		 * @param {(string|object)} element - A Selector targeting an element or a DOM object that is supposed to be pinned.
		 * @param {object} [settings] - settings for the pin
		 * @param {boolean} [settings.pushFollowers=true] - If `true` following elements will be "pushed" down for the duration of the pin, if `false` the pinned element will just scroll past them.  
		 												   Ignored, when duration is `0`.
		 * @param {string} [settings.spacerClass="scrollmagic-pin-spacer"] - Classname of the pin spacer element, which is used to replace the element.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setPin = function(element, settings) {
            var defaultSettings = {
                pushFollowers: true,
                spacerClass: "scrollmagic-pin-spacer"
            };
            var pushFollowersActivelySet = settings && settings.hasOwnProperty("pushFollowers");
            settings = _util.extend({}, defaultSettings, settings);
            // validate Element
            element = _util.get.elements(element)[0];
            if (!element) {
                log(1, "ERROR calling method 'setPin()': Invalid pin element supplied.");
                return Scene; // cancel
            } else if (_util.css(element, "position") === "fixed") {
                log(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.");
                return Scene; // cancel
            }
            if (_pin) {
                if (_pin === element) // same pin we already have -> do nothing
                return Scene; // cancel
                else // kill old pin
                Scene.removePin();
            }
            _pin = element;
            var parentDisplay = _pin.parentNode.style.display, boundsParams = [
                "top",
                "left",
                "bottom",
                "right",
                "margin",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom"
            ];
            _pin.parentNode.style.display = "none"; // hack start to force css to return stylesheet values instead of calculated px values.
            var inFlow = _util.css(_pin, "position") != "absolute", pinCSS = _util.css(_pin, boundsParams.concat([
                "display"
            ])), sizeCSS = _util.css(_pin, [
                "width",
                "height"
            ]);
            _pin.parentNode.style.display = parentDisplay; // hack end.
            if (!inFlow && settings.pushFollowers) {
                log(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.");
                settings.pushFollowers = false;
            }
            window.setTimeout(function() {
                if (_pin && _options.duration === 0 && pushFollowersActivelySet && settings.pushFollowers) log(2, "WARNING: pushFollowers =", true, "has no effect, when scene duration is 0.");
            }, 0);
            // create spacer and insert
            var spacer = _pin.parentNode.insertBefore(document.createElement("div"), _pin), spacerCSS = _util.extend(pinCSS, {
                position: inFlow ? "relative" : "absolute",
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box"
            });
            if (!inFlow) _util.extend(spacerCSS, _util.css(_pin, [
                "width",
                "height"
            ]));
            _util.css(spacer, spacerCSS);
            spacer.setAttribute(PIN_SPACER_ATTRIBUTE, "");
            _util.addClass(spacer, settings.spacerClass);
            // set the pin Options
            _pinOptions = {
                spacer: spacer,
                relSize: {
                    width: sizeCSS.width.slice(-1) === "%",
                    height: sizeCSS.height.slice(-1) === "%",
                    autoFullWidth: sizeCSS.width === "auto" && inFlow && _util.isMarginCollapseType(pinCSS.display)
                },
                pushFollowers: settings.pushFollowers,
                inFlow: inFlow
            };
            if (!_pin.___origStyle) {
                _pin.___origStyle = {};
                var pinInlineCSS = _pin.style, copyStyles = boundsParams.concat([
                    "width",
                    "height",
                    "position",
                    "boxSizing",
                    "mozBoxSizing",
                    "webkitBoxSizing"
                ]);
                copyStyles.forEach(function(val) {
                    _pin.___origStyle[val] = pinInlineCSS[val] || "";
                });
            }
            // if relative size, transfer it to spacer and make pin calculate it...
            if (_pinOptions.relSize.width) _util.css(spacer, {
                width: sizeCSS.width
            });
            if (_pinOptions.relSize.height) _util.css(spacer, {
                height: sizeCSS.height
            });
            // now place the pin element inside the spacer	
            spacer.appendChild(_pin);
            // and set new css
            _util.css(_pin, {
                position: inFlow ? "relative" : "absolute",
                margin: "auto",
                top: "auto",
                left: "auto",
                bottom: "auto",
                right: "auto"
            });
            if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) _util.css(_pin, {
                boxSizing: "border-box",
                mozBoxSizing: "border-box",
                webkitBoxSizing: "border-box"
            });
            // add listener to document to update pin position in case controller is not the document.
            window.addEventListener("scroll", updatePinInContainer);
            window.addEventListener("resize", updatePinInContainer);
            window.addEventListener("resize", updateRelativePinSpacer);
            // add mousewheel listener to catch scrolls over fixed elements
            _pin.addEventListener("mousewheel", onMousewheelOverPin);
            _pin.addEventListener("DOMMouseScroll", onMousewheelOverPin);
            log(3, "added pin");
            // finally update the pin to init
            updatePinState();
            return Scene;
        };
        /**
		 * Remove the pin from the scene.
		 * @method ScrollMagic.Scene#removePin
		 * @example
		 * // remove the pin from the scene without resetting it (the spacer is not removed)
		 * scene.removePin();
		 *
		 * // remove the pin from the scene and reset the pin element to its initial position (spacer is removed)
		 * scene.removePin(true);
		 *
		 * @param {boolean} [reset=false] - If `false` the spacer will not be removed and the element's position will not be reset.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removePin = function(reset) {
            if (_pin) {
                if (_state === SCENE_STATE_DURING) updatePinState(true); // force unpin at position
                if (reset || !_controller) {
                    var pinTarget = _pinOptions.spacer.firstChild; // usually the pin element, but may be another spacer (cascaded pins)...
                    if (pinTarget.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        var style = _pinOptions.spacer.style, values = [
                            "margin",
                            "marginLeft",
                            "marginRight",
                            "marginTop",
                            "marginBottom"
                        ], margins = {};
                        values.forEach(function(val) {
                            margins[val] = style[val] || "";
                        });
                        _util.css(pinTarget, margins);
                    }
                    _pinOptions.spacer.parentNode.insertBefore(pinTarget, _pinOptions.spacer);
                    _pinOptions.spacer.parentNode.removeChild(_pinOptions.spacer);
                    if (!_pin.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        // TODO: only correctly set for first pin (when cascading) - how to fix?
                        _util.css(_pin, _pin.___origStyle);
                        delete _pin.___origStyle;
                    }
                }
                window.removeEventListener("scroll", updatePinInContainer);
                window.removeEventListener("resize", updatePinInContainer);
                window.removeEventListener("resize", updateRelativePinSpacer);
                _pin.removeEventListener("mousewheel", onMousewheelOverPin);
                _pin.removeEventListener("DOMMouseScroll", onMousewheelOverPin);
                _pin = undefined;
                log(3, "removed pin (reset: " + (reset ? "true" : "false") + ")");
            }
            return Scene;
        };
        var _cssClasses, _cssClassElems = [];
        Scene.on("destroy.internal", function(e) {
            Scene.removeClassToggle(e.reset);
        });
        /**
		 * Define a css class modification while the scene is active.  
		 * When the scene triggers the classes will be added to the supplied element and removed, when the scene is over.
		 * If the scene duration is 0 the classes will only be removed if the user scrolls back past the start position.
		 * @method ScrollMagic.Scene#setClassToggle
		 * @example
		 * // add the class 'myclass' to the element with the id 'my-elem' for the duration of the scene
		 * scene.setClassToggle("#my-elem", "myclass");
		 *
		 * // add multiple classes to multiple elements defined by the selector '.classChange'
		 * scene.setClassToggle(".classChange", "class1 class2 class3");
		 *
		 * @param {(string|object)} element - A Selector targeting one or more elements or a DOM object that is supposed to be modified.
		 * @param {string} classes - One or more Classnames (separated by space) that should be added to the element during the scene.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setClassToggle = function(element, classes) {
            var elems = _util.get.elements(element);
            if (elems.length === 0 || !_util.type.String(classes)) {
                log(1, "ERROR calling method 'setClassToggle()': Invalid " + (elems.length === 0 ? "element" : "classes") + " supplied.");
                return Scene;
            }
            if (_cssClassElems.length > 0) // remove old ones
            Scene.removeClassToggle();
            _cssClasses = classes;
            _cssClassElems = elems;
            Scene.on("enter.internal_class leave.internal_class", function(e) {
                var toggle = e.type === "enter" ? _util.addClass : _util.removeClass;
                _cssClassElems.forEach(function(elem, key) {
                    toggle(elem, _cssClasses);
                });
            });
            return Scene;
        };
        /**
		 * Remove the class binding from the scene.
		 * @method ScrollMagic.Scene#removeClassToggle
		 * @example
		 * // remove class binding from the scene without reset
		 * scene.removeClassToggle();
		 *
		 * // remove class binding and remove the changes it caused
		 * scene.removeClassToggle(true);
		 *
		 * @param {boolean} [reset=false] - If `false` and the classes are currently active, they will remain on the element. If `true` they will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removeClassToggle = function(reset) {
            if (reset) _cssClassElems.forEach(function(elem, key) {
                _util.removeClass(elem, _cssClasses);
            });
            Scene.off("start.internal_class end.internal_class");
            _cssClasses = undefined;
            _cssClassElems = [];
            return Scene;
        };
        // INIT
        construct();
        return Scene;
    };
    // store pagewide scene options
    var SCENE_OPTIONS = {
        defaults: {
            duration: 0,
            offset: 0,
            triggerElement: undefined,
            triggerHook: 0.5,
            reverse: true,
            loglevel: 2
        },
        validate: {
            offset: function(val) {
                val = parseFloat(val);
                if (!_util.type.Number(val)) throw [
                    'Invalid value for option "offset":',
                    val
                ];
                return val;
            },
            triggerElement: function(val) {
                val = val || undefined;
                if (val) {
                    var elem = _util.get.elements(val)[0];
                    if (elem && elem.parentNode) val = elem;
                    else throw [
                        'Element defined in option "triggerElement" was not found:',
                        val
                    ];
                }
                return val;
            },
            triggerHook: function(val) {
                var translate = {
                    "onCenter": 0.5,
                    "onEnter": 1,
                    "onLeave": 0
                };
                if (_util.type.Number(val)) val = Math.max(0, Math.min(parseFloat(val), 1)); //  make sure its betweeen 0 and 1
                else if (val in translate) val = translate[val];
                else throw [
                    'Invalid value for option "triggerHook": ',
                    val
                ];
                return val;
            },
            reverse: function(val) {
                return !!val; // force boolean
            },
            loglevel: function(val) {
                val = parseInt(val);
                if (!_util.type.Number(val) || val < 0 || val > 3) throw [
                    'Invalid value for option "loglevel":',
                    val
                ];
                return val;
            }
        },
        shifts: [
            "duration",
            "offset",
            "triggerHook"
        ]
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 * TODO: DOC (private for dev)
	 */ ScrollMagic.Scene.addOption = function(name, defaultValue, validationCallback, shifts) {
        if (!(name in SCENE_OPTIONS.defaults)) {
            SCENE_OPTIONS.defaults[name] = defaultValue;
            SCENE_OPTIONS.validate[name] = validationCallback;
            if (shifts) SCENE_OPTIONS.shifts.push(name);
        } else ScrollMagic._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + name + "', because it already exists.");
    };
    // instance extension function for plugins
    // TODO: DOC (private for dev)
    ScrollMagic.Scene.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Scene = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Scene, oldClass); // copy properties
        ScrollMagic.Scene.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Scene.prototype.constructor = ScrollMagic.Scene; // restore constructor
    };
    /**
	 * TODO: DOCS (private for dev)
	 * @class
	 * @private
	 */ ScrollMagic.Event = function(type, namespace, target, vars) {
        vars = vars || {};
        for(var key in vars)this[key] = vars[key];
        this.type = type;
        this.target = this.currentTarget = target;
        this.namespace = namespace || "";
        this.timeStamp = this.timestamp = Date.now();
        return this;
    };
    /*
	 * TODO: DOCS (private for dev)
	 */ var _util = ScrollMagic._util = function(window1) {
        var U = {}, i;
        /**
		 * ------------------------------
		 * internal helpers
		 * ------------------------------
		 */ // parse float and fall back to 0.
        var floatval = function(number) {
            return parseFloat(number) || 0;
        };
        // get current style IE safe (otherwise IE would return calculated values for 'auto')
        var _getComputedStyle = function(elem) {
            return elem.currentStyle ? elem.currentStyle : window1.getComputedStyle(elem);
        };
        // get element dimension (width or height)
        var _dimension = function(which, elem, outer, includeMargin) {
            elem = elem === document ? window1 : elem;
            if (elem === window1) includeMargin = false;
            else if (!_type.DomElement(elem)) return 0;
            which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
            var dimension = (outer ? elem["offset" + which] || elem["outer" + which] : elem["client" + which] || elem["inner" + which]) || 0;
            if (outer && includeMargin) {
                var style = _getComputedStyle(elem);
                dimension += which === "Height" ? floatval(style.marginTop) + floatval(style.marginBottom) : floatval(style.marginLeft) + floatval(style.marginRight);
            }
            return dimension;
        };
        // converts 'margin-top' into 'marginTop'
        var _camelCase = function(str) {
            return str.replace(/^[^a-z]+([a-z])/g, "$1").replace(/-([a-z])/g, function(g) {
                return g[1].toUpperCase();
            });
        };
        /**
		 * ------------------------------
		 * external helpers
		 * ------------------------------
		 */ // extend obj – same as jQuery.extend({}, objA, objB)
        U.extend = function(obj) {
            obj = obj || {};
            for(i = 1; i < arguments.length; i++){
                if (!arguments[i]) continue;
                for(var key in arguments[i])if (arguments[i].hasOwnProperty(key)) obj[key] = arguments[i][key];
            }
            return obj;
        };
        // check if a css display type results in margin-collapse or not
        U.isMarginCollapseType = function(str) {
            return [
                "block",
                "flex",
                "list-item",
                "table",
                "-webkit-box"
            ].indexOf(str) > -1;
        };
        // implementation of requestAnimationFrame
        // based on https://gist.github.com/paulirish/1579671
        var lastTime = 0, vendors = [
            "ms",
            "moz",
            "webkit",
            "o"
        ];
        var _requestAnimationFrame = window1.requestAnimationFrame;
        var _cancelAnimationFrame = window1.cancelAnimationFrame;
        // try vendor prefixes if the above doesn't work
        for(i = 0; !_requestAnimationFrame && i < vendors.length; ++i){
            _requestAnimationFrame = window1[vendors[i] + "RequestAnimationFrame"];
            _cancelAnimationFrame = window1[vendors[i] + "CancelAnimationFrame"] || window1[vendors[i] + "CancelRequestAnimationFrame"];
        }
        // fallbacks
        if (!_requestAnimationFrame) _requestAnimationFrame = function(callback) {
            var currTime = new Date().getTime(), timeToCall = Math.max(0, 16 - (currTime - lastTime)), id = window1.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
        if (!_cancelAnimationFrame) _cancelAnimationFrame = function(id) {
            window1.clearTimeout(id);
        };
        U.rAF = _requestAnimationFrame.bind(window1);
        U.cAF = _cancelAnimationFrame.bind(window1);
        var loglevels = [
            "error",
            "warn",
            "log"
        ], console = window1.console || {};
        console.log = console.log || function() {}; // no console log, well - do nothing then...
        // make sure methods for all levels exist.
        for(i = 0; i < loglevels.length; i++){
            var method = loglevels[i];
            if (!console[method]) console[method] = console.log; // prefer .log over nothing
        }
        U.log = function(loglevel) {
            if (loglevel > loglevels.length || loglevel <= 0) loglevel = loglevels.length;
            var now = new Date(), time = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2) + ":" + ("00" + now.getMilliseconds()).slice(-3), method = loglevels[loglevel - 1], args = Array.prototype.splice.call(arguments, 1), func = Function.prototype.bind.call(console[method], console);
            args.unshift(time);
            func.apply(console, args);
        };
        /**
		 * ------------------------------
		 * type testing
		 * ------------------------------
		 */ var _type = U.type = function(v) {
            return Object.prototype.toString.call(v).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
        };
        _type.String = function(v) {
            return _type(v) === "string";
        };
        _type.Function = function(v) {
            return _type(v) === "function";
        };
        _type.Array = function(v) {
            return Array.isArray(v);
        };
        _type.Number = function(v) {
            return !_type.Array(v) && v - parseFloat(v) + 1 >= 0;
        };
        _type.DomElement = function(o) {
            return typeof HTMLElement === "object" || typeof HTMLElement === "function" ? o instanceof HTMLElement || o instanceof SVGElement : o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
        };
        /**
		 * ------------------------------
		 * DOM Element info
		 * ------------------------------
		 */ // always returns a list of matching DOM elements, from a selector, a DOM element or an list of elements or even an array of selectors
        var _get = U.get = {};
        _get.elements = function(selector) {
            var arr = [];
            if (_type.String(selector)) try {
                selector = document.querySelectorAll(selector);
            } catch (e) {
                return arr;
            }
            if (_type(selector) === "nodelist" || _type.Array(selector) || selector instanceof NodeList) for(var i = 0, ref = arr.length = selector.length; i < ref; i++){
                var elem = selector[i];
                arr[i] = _type.DomElement(elem) ? elem : _get.elements(elem); // if not an element, try to resolve recursively
            }
            else if (_type.DomElement(selector) || selector === document || selector === window1) arr = [
                selector
            ]; // only the element
            return arr;
        };
        // get scroll top value
        _get.scrollTop = function(elem) {
            return elem && typeof elem.scrollTop === "number" ? elem.scrollTop : window1.pageYOffset || 0;
        };
        // get scroll left value
        _get.scrollLeft = function(elem) {
            return elem && typeof elem.scrollLeft === "number" ? elem.scrollLeft : window1.pageXOffset || 0;
        };
        // get element height
        _get.width = function(elem, outer, includeMargin) {
            return _dimension("width", elem, outer, includeMargin);
        };
        // get element width
        _get.height = function(elem, outer, includeMargin) {
            return _dimension("height", elem, outer, includeMargin);
        };
        // get element position (optionally relative to viewport)
        _get.offset = function(elem, relativeToViewport) {
            var offset = {
                top: 0,
                left: 0
            };
            if (elem && elem.getBoundingClientRect) {
                var rect = elem.getBoundingClientRect();
                offset.top = rect.top;
                offset.left = rect.left;
                if (!relativeToViewport) {
                    offset.top += _get.scrollTop();
                    offset.left += _get.scrollLeft();
                }
            }
            return offset;
        };
        /**
		 * ------------------------------
		 * DOM Element manipulation
		 * ------------------------------
		 */ U.addClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.add(classname);
                else elem.className += " " + classname;
            }
        };
        U.removeClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.remove(classname);
                else elem.className = elem.className.replace(new RegExp("(^|\\b)" + classname.split(" ").join("|") + "(\\b|$)", "gi"), " ");
            }
        };
        // if options is string -> returns css value
        // if options is array -> returns object with css value pairs
        // if options is object -> set new css values
        U.css = function(elem, options) {
            if (_type.String(options)) return _getComputedStyle(elem)[_camelCase(options)];
            else if (_type.Array(options)) {
                var obj = {}, style = _getComputedStyle(elem);
                options.forEach(function(option, key) {
                    obj[option] = style[_camelCase(option)];
                });
                return obj;
            } else for(var option in options){
                var val = options[option];
                if (val == parseFloat(val)) val += "px";
                elem.style[_camelCase(option)] = val;
            }
        };
        return U;
    }(window || {});
    ScrollMagic.Scene.prototype.addIndicators = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js");
        return this;
    };
    ScrollMagic.Scene.prototype.removeIndicators = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js");
        return this;
    };
    ScrollMagic.Scene.prototype.setTween = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js");
        return this;
    };
    ScrollMagic.Scene.prototype.removeTween = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js");
        return this;
    };
    ScrollMagic.Scene.prototype.setVelocity = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js");
        return this;
    };
    ScrollMagic.Scene.prototype.removeVelocity = function() {
        ScrollMagic._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js");
        return this;
    };
    return ScrollMagic;
});


/*!
 * ScrollToPlugin 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $867ff06115902906$var$gsap, $867ff06115902906$var$_coreInitted, $867ff06115902906$var$_window, $867ff06115902906$var$_docEl, $867ff06115902906$var$_body, $867ff06115902906$var$_toArray, $867ff06115902906$var$_config, $867ff06115902906$var$ScrollTrigger, $867ff06115902906$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $867ff06115902906$var$_getGSAP = function _getGSAP() {
    return $867ff06115902906$var$gsap || $867ff06115902906$var$_windowExists() && ($867ff06115902906$var$gsap = window.gsap) && $867ff06115902906$var$gsap.registerPlugin && $867ff06115902906$var$gsap;
}, $867ff06115902906$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $867ff06115902906$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $867ff06115902906$var$_max = function _max(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return element === $867ff06115902906$var$_window || element === $867ff06115902906$var$_docEl || element === $867ff06115902906$var$_body ? Math.max($867ff06115902906$var$_docEl[scroll], $867ff06115902906$var$_body[scroll]) - ($867ff06115902906$var$_window["inner" + dim] || $867ff06115902906$var$_docEl[client] || $867ff06115902906$var$_body[client]) : element[scroll] - element["offset" + dim];
}, $867ff06115902906$var$_buildGetter = function _buildGetter(e, axis) {
    //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
    var p = "scroll" + (axis === "x" ? "Left" : "Top");
    if (e === $867ff06115902906$var$_window) {
        if (e.pageXOffset != null) p = "page" + axis.toUpperCase() + "Offset";
        else e = $867ff06115902906$var$_docEl[p] != null ? $867ff06115902906$var$_docEl : $867ff06115902906$var$_body;
    }
    return function() {
        return e[p];
    };
}, $867ff06115902906$var$_clean = function _clean(value, index, target, targets) {
    $867ff06115902906$var$_isFunction(value) && (value = value(index, target, targets));
    if (typeof value !== "object") return $867ff06115902906$var$_isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
        x: value,
        y: value
    } : {
        y: value
    }; //if we don't receive an object as the parameter, assume the user intends "y".
    else if (value.nodeType) return {
        y: value,
        x: value
    };
    else {
        var result = {}, p;
        for(p in value)result[p] = p !== "onAutoKill" && $867ff06115902906$var$_isFunction(value[p]) ? value[p](index, target, targets) : value[p];
        return result;
    }
}, $867ff06115902906$var$_getOffset = function _getOffset(element, container) {
    element = $867ff06115902906$var$_toArray(element)[0];
    if (!element || !element.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
        x: 0,
        y: 0
    };
    var rect = element.getBoundingClientRect(), isRoot = !container || container === $867ff06115902906$var$_window || container === $867ff06115902906$var$_body, cRect = isRoot ? {
        top: $867ff06115902906$var$_docEl.clientTop - ($867ff06115902906$var$_window.pageYOffset || $867ff06115902906$var$_docEl.scrollTop || $867ff06115902906$var$_body.scrollTop || 0),
        left: $867ff06115902906$var$_docEl.clientLeft - ($867ff06115902906$var$_window.pageXOffset || $867ff06115902906$var$_docEl.scrollLeft || $867ff06115902906$var$_body.scrollLeft || 0)
    } : container.getBoundingClientRect(), offsets = {
        x: rect.left - cRect.left,
        y: rect.top - cRect.top
    };
    if (!isRoot && container) {
        //only add the current scroll position if it's not the window/body.
        offsets.x += $867ff06115902906$var$_buildGetter(container, "x")();
        offsets.y += $867ff06115902906$var$_buildGetter(container, "y")();
    }
    return offsets;
}, $867ff06115902906$var$_parseVal = function _parseVal(value, target, axis, currentVal, offset) {
    return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : $867ff06115902906$var$_isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? $867ff06115902906$var$_max(target, axis) - offset : Math.min($867ff06115902906$var$_max(target, axis), $867ff06115902906$var$_getOffset(value, target)[axis] - offset);
}, $867ff06115902906$var$_initCore = function _initCore() {
    $867ff06115902906$var$gsap = $867ff06115902906$var$_getGSAP();
    if ($867ff06115902906$var$_windowExists() && $867ff06115902906$var$gsap && typeof document !== "undefined" && document.body) {
        $867ff06115902906$var$_window = window;
        $867ff06115902906$var$_body = document.body;
        $867ff06115902906$var$_docEl = document.documentElement;
        $867ff06115902906$var$_toArray = $867ff06115902906$var$gsap.utils.toArray;
        $867ff06115902906$var$gsap.config({
            autoKillThreshold: 7
        });
        $867ff06115902906$var$_config = $867ff06115902906$var$gsap.config();
        $867ff06115902906$var$_coreInitted = 1;
    }
};
var $867ff06115902906$export$6953cc323644330b = {
    version: "3.12.5",
    name: "scrollTo",
    rawVars: 1,
    register: function register(core) {
        $867ff06115902906$var$gsap = core;
        $867ff06115902906$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $867ff06115902906$var$_coreInitted || $867ff06115902906$var$_initCore();
        var data = this, snapType = $867ff06115902906$var$gsap.getProperty(target, "scrollSnapType");
        data.isWin = target === $867ff06115902906$var$_window;
        data.target = target;
        data.tween = tween;
        value = $867ff06115902906$var$_clean(value, index, target, targets);
        data.vars = value;
        data.autoKill = !!value.autoKill;
        data.getX = $867ff06115902906$var$_buildGetter(target, "x");
        data.getY = $867ff06115902906$var$_buildGetter(target, "y");
        data.x = data.xPrev = data.getX();
        data.y = data.yPrev = data.getY();
        $867ff06115902906$var$ScrollTrigger || ($867ff06115902906$var$ScrollTrigger = $867ff06115902906$var$gsap.core.globals().ScrollTrigger);
        $867ff06115902906$var$gsap.getProperty(target, "scrollBehavior") === "smooth" && $867ff06115902906$var$gsap.set(target, {
            scrollBehavior: "auto"
        });
        if (snapType && snapType !== "none") {
            // disable scroll snapping to avoid strange behavior
            data.snap = 1;
            data.snapInline = target.style.scrollSnapType;
            target.style.scrollSnapType = "none";
        }
        if (value.x != null) {
            data.add(data, "x", data.x, $867ff06115902906$var$_parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
            data._props.push("scrollTo_x");
        } else data.skipX = 1;
        if (value.y != null) {
            data.add(data, "y", data.y, $867ff06115902906$var$_parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
            data._props.push("scrollTo_y");
        } else data.skipY = 1;
    },
    render: function render(ratio, data) {
        var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        x = isWin || !data.skipX ? data.getX() : xPrev;
        y = isWin || !data.skipY ? data.getY() : yPrev;
        yDif = y - yPrev;
        xDif = x - xPrev;
        threshold = $867ff06115902906$var$_config.autoKillThreshold;
        if (data.x < 0) //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
        data.x = 0;
        if (data.y < 0) data.y = 0;
        if (autoKill) {
            //note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
            if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < $867ff06115902906$var$_max(target, "x")) data.skipX = 1; //if the user scrolls separately, we should stop tweening!
            if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < $867ff06115902906$var$_max(target, "y")) data.skipY = 1; //if the user scrolls separately, we should stop tweening!
            if (data.skipX && data.skipY) {
                tween.kill();
                data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
            }
        }
        if (isWin) $867ff06115902906$var$_window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
        else {
            data.skipY || (target.scrollTop = data.y);
            data.skipX || (target.scrollLeft = data.x);
        }
        if (snap && (ratio === 1 || ratio === 0)) {
            y = target.scrollTop;
            x = target.scrollLeft;
            snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
            target.scrollTop = y + 1; // bug in Safari causes the element to totally reset its scroll position when scroll-snap-type changes, so we need to set it to a slightly different value and then back again to work around this bug.
            target.scrollLeft = x + 1;
            target.scrollTop = y;
            target.scrollLeft = x;
        }
        data.xPrev = data.x;
        data.yPrev = data.y;
        $867ff06115902906$var$ScrollTrigger && $867ff06115902906$var$ScrollTrigger.update();
    },
    kill: function kill(property) {
        var both = property === "scrollTo", i = this._props.indexOf(property);
        if (both || property === "scrollTo_x") this.skipX = 1;
        if (both || property === "scrollTo_y") this.skipY = 1;
        i > -1 && this._props.splice(i, 1);
        return !this._props.length;
    }
};
$867ff06115902906$export$6953cc323644330b.max = $867ff06115902906$var$_max;
$867ff06115902906$export$6953cc323644330b.getOffset = $867ff06115902906$var$_getOffset;
$867ff06115902906$export$6953cc323644330b.buildGetter = $867ff06115902906$var$_buildGetter;
$867ff06115902906$var$_getGSAP() && $867ff06115902906$var$gsap.registerPlugin($867ff06115902906$export$6953cc323644330b);






(function() {
    // example to use
    // wall-of-wins="{width: 102, height: 152, gap: 12, rows: 4, speed: 10, mincount: 95}"
    // wall-of-wins-random="{min: 0, max: 0, intervalTime: 500, rows: 4}"
    const directive = {
        name: "wallOfWins"
    };
    controller.$inject = [
        "wallOfWins$",
        "wallOfWins",
        "ws$"
    ];
    function controller(_wallOfWins$, _wallOfWins, _ws$) {
        function compile() {
            return function(scope, element, attrs, ctrl, $transclude) {
                const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
                const itemParams = scope.$eval(attrs[directive.name]);
                const Nodes = {};
                const Timeline = (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                    repeat: -1,
                    paused: false
                });
                Timeline.add("items", 0);
                /* SCROLL CONTROL*/ let ScrollController = new (0, (/*@__PURE__*/$parcel$interopDefault($d6dbbab72ea2bcb1$exports))).Controller({});
                (0, $50c26a34528ecf35$export$99ee26438460406a).registerPlugin((0, $867ff06115902906$export$6953cc323644330b));
                const sceneTop = new (0, (/*@__PURE__*/$parcel$interopDefault($d6dbbab72ea2bcb1$exports))).Scene({
                    triggerHook: 0,
                    triggerElement: element[0]
                }).addTo(ScrollController);
                const sceneBottom = new (0, (/*@__PURE__*/$parcel$interopDefault($d6dbbab72ea2bcb1$exports))).Scene({
                    triggerHook: 1,
                    triggerElement: element[0]
                }).addTo(ScrollController);
                sceneBottom.on("start", function(event) {
                    if (event.scrollDirection === "FORWARD") Timeline.play();
                    if (event.scrollDirection === "REVERSE") Timeline.pause();
                });
                sceneTop.on("end", function(event) {
                    if (event.scrollDirection === "FORWARD") Timeline.pause();
                    if (event.scrollDirection === "REVERSE") Timeline.play();
                });
                /* SCROLL CONTROL*/ let CountOnScreen = 0;
                let collection = [];
                let lastIndex = 0;
                const viewportWidth = document.documentElement.offsetWidth;
                _wallOfWins.collection({
                    mincount: itemParams.mincount
                }).then((answer)=>{
                    collection = (answer.result || []).splice(0, itemParams.mincount);
                    run();
                });
                function run() {
                    CountOnScreen = (Math.ceil(viewportWidth / (itemParams.width + itemParams.gap)) + 1) * itemParams.rows;
                    addMore(CountOnScreen);
                    _wallOfWins$.next({
                        event: "random_diapason",
                        data: {
                            min: 0,
                            max: CountOnScreen
                        }
                    });
                }
                function addMore(count, newItem = false) {
                    const startIndex = lastIndex;
                    const endIndex = lastIndex + count;
                    for(let i = startIndex; i <= endIndex; i++)addNext(newItem);
                    Timeline.play();
                }
                function getRandomIndex(max) {
                    return Math.floor(Math.random() * max);
                }
                function addNext(newItem = false) {
                    $transclude(scope.$new(true), (clone, scope)=>{
                        scope.index = lastIndex;
                        scope.item = collection.length > lastIndex ? collection[lastIndex] : newItem ? collection[collection.length - 1] : collection[getRandomIndex(collection.length - 1)];
                        Nodes[lastIndex] = clone[0];
                    });
                    element[0].appendChild(Nodes[lastIndex]);
                    setItemPosition(lastIndex);
                    addAnimation(lastIndex);
                    lastIndex++;
                }
                function setItemPosition(index) {
                    const top = index % itemParams.rows * (itemParams.height + itemParams.gap);
                    const left = Math.floor(index / itemParams.rows) * (itemParams.width + itemParams.gap);
                    const way = left + itemParams.width + itemParams.gap;
                    (0, $50c26a34528ecf35$export$99ee26438460406a).set(Nodes[index], {
                        x: left,
                        y: top
                    });
                    const gsapObject = {
                        x: -itemParams.width - itemParams.gap,
                        duration: way / itemParams.speed,
                        ease: "none",
                        onComplete: ()=>{
                            removeItem(index);
                        }
                    };
                    if (index === collection.length - 1) gsapObject.modifiers = {
                        x: (0, $50c26a34528ecf35$export$99ee26438460406a).utils.unitize(function(x) {
                            if (lastIndex === index + 1 && x <= viewportWidth - itemParams.width - itemParams.gap) Timeline.pause();
                            return x;
                        })
                    };
                    Nodes[index].tween = (0, $50c26a34528ecf35$export$99ee26438460406a).to(Nodes[index], gsapObject);
                    Timeline.add(Nodes[index].tween, "items");
                }
                function addAnimation(index) {
                    Nodes[index].tweenActive = (0, $50c26a34528ecf35$export$99ee26438460406a).to(Nodes[index], {
                        scale: 1.3,
                        duration: 0.3,
                        yoyo: true,
                        repeat: 1,
                        repeatDelay: 1,
                        paused: true,
                        ease: Circ.easeInOut,
                        onStart () {
                            Nodes[index].classList.add("is-active");
                        },
                        onComplete () {
                            if (Nodes[index]) Nodes[index].classList.remove("is-active");
                            _wallOfWins$.next({
                                event: "remove",
                                data: {
                                    index: index
                                }
                            });
                        }
                    });
                }
                function removeItem(index) {
                    Timeline.remove(Nodes[index].tween);
                    Nodes[index].remove();
                    delete Nodes[index];
                    addNext();
                    _wallOfWins$.next({
                        event: "random_diapason",
                        data: {
                            min: index + 1,
                            max: index + 1 + CountOnScreen
                        }
                    });
                }
                _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "new_win_list"), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((message)=>{
                    // const newData = (message.data ? message.data : []).splice( 0, itemParams.rows );
                    const newData = message.data || [];
                    const indexes = collection.reduce((indexesArray, currentElement, currentIndex)=>{
                        if (currentElement?.game?.alias === newData[0]?.game?.alias) return [
                            ...indexesArray,
                            currentIndex
                        ];
                        return indexesArray;
                    }, []);
                    if (indexes.length) {
                        indexes.forEach((index)=>Object.assign(collection[index], newData[0]));
                        // eslint-disable-next-line guard-for-in
                        for(const key in Nodes)newData.forEach((nd)=>{
                            let found = false;
                            if (Nodes[key]?.href?.endsWith(`/${nd?.game.alias}`) && !found) {
                                found = !found;
                                Nodes[key]?.tweenActive.play(0);
                            }
                        });
                    } else {
                        if (collection.length === 100) collection.splice(0, newData.length);
                        collection = collection.concat(newData);
                        addMore(newData.length, true);
                    }
                });
                _wallOfWins$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((o)=>o.event === "new"), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((o)=>Nodes[o.data.index]), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((o)=>{
                    Nodes[o.data.index].tweenActive.play(0);
                });
                scope.$on("$destroy", ()=>{
                    destroy$.next();
                    destroy$.unsubscribe();
                    Timeline.kill();
                    ScrollController.destroy(true);
                    ScrollController = null;
                });
            };
        }
        return {
            restrict: "A",
            transclude: true,
            compile: compile
        };
    }
    app.directive(directive.name, controller);
})();


$12b6ac258f73d8ce$exports = {
    "_alf-payment-slider-widget": $ee374290a956332e$exports,
    "_slider-range": $069341933141e879$exports,
    "_update-class-on-scroll-to": $583eb390ab7b68b7$exports,
    "abandoned-registration": $e5f75d38db5e0096$exports,
    "add-class-on-event": $4ed95bd5f89c38d1$exports,
    "add-class-on-login": $b31fdfe7a39ae0cd$exports,
    "air-datepicker": $cd9e1becc6b76759$exports,
    "animate-title-leave": $287b6bf1200c4bdd$exports,
    "bind-analytics-click": $1a46add3d6212c6e$exports,
    "bind-analytics": $69a4e072499dfde4$exports,
    "bind-html-compile": $4608c723439f4a51$exports,
    "cashbox-state": $aada78c8e2f5a9aa$exports,
    "chat-open": $4ff38f2ad0010e6e$exports,
    "check-last-deposit": $bbc2176d196fb846$exports,
    "check-pending-withdrawals": $98beaaa46a60a064$exports,
    "closed-registration-tracker": $097cffeb2a61b359$exports,
    "confetti": $8d7293feb760b040$exports,
    "cookie-settings": $c8645de37dddcfd6$exports,
    "copy-to-clipboard": $a73fde242d0fe37c$exports,
    "datepicker-birthday": $e5c64a3583476805$exports,
    "datepicker": $4da3c54cb1f3e547$exports,
    "embed-src": $db7228365b7a3b5d$exports,
    "get-auth-strategy": $e393e147de7f6882$exports,
    "get-categories-to-scope": $016d57c1d6e3b4ff$exports,
    "get-collection-gamehall-to-scope": $74ed929c7d9152c5$exports,
    "get-collections-to-scope": $39419d7b9fdb12b2$exports,
    "get-config-to-scope": $ef18857d9f56b14b$exports,
    "get-country-layout-to-scope": $e1e36c07c4bba367$exports,
    "get-current-time-to-scope": $facf5638d8813c26$exports,
    "get-footer-data-to-scope": $74fd07703a575aec$exports,
    "get-modal-content-to-scope": $202e3767bd7995ae$exports,
    "get-popup-content-to-scope": $ee4da7aa598a998c$exports,
    "get-private-categories": $d9779ff4707ea63c$exports,
    "get-promo-links-to-scope": $7f8b9bfe79d38f32$exports,
    "get-promos-to-scope": $5f2e5ad68336bd29$exports,
    "get-providers-to-scope": $1614fb6cfdbc045d$exports,
    "get-sport-teams-to-scope": $a745dc103aad9a4f$exports,
    "get-state-params-to-scope": $72474d6fd5187fb1$exports,
    "get-system-info-to-scope": $59f3b65a122cb739$exports,
    "get-timestamp-to-scope": $91cf6047614c42a7$exports,
    "get-user-to-scope": $b2ed200f69c38eea$exports,
    "get-vips-to-scope": $eb14e8d89795906b$exports,
    "go-back": $44be825fff304b6e$exports,
    "handle-game-page-shop-tab": $6864a9b1432b9735$exports,
    "hide-after-ny": $9ce6a344bcf72385$exports,
    "hide-by-country-code": $a616d9c86b441786$exports,
    "hide-element-if": $d7ac363481b0dbf4$exports,
    "hide-for-sw": $e8a963452f1ad9c8$exports,
    "history-go-back": $d0b6efdd022ae07a$exports,
    "holiday-link": $3e3ead8c721b1b7a$exports,
    "horizontal-scroll-element": $58fdc27caa1b1e1f$exports,
    "href-if-auth": $c800f4284869593c$exports,
    "infinite-scroll": $caf189ab56df6534$exports,
    "input-auto-width": $d23171d920019eb3$exports,
    "input-filter-creditcard": $3d635f34e430847e$exports,
    "install-app-box": $442e42fa9f565b64$exports,
    "lazy-bg": $fc1c31481a195ae3$exports,
    "license-icon": $171d36da17077eed$exports,
    "linda-scroll-top": $4588544d7f5a22ea$exports,
    "logout": $f497280be981cc1e$exports,
    "lottie-animation": $000ca5312d3d72dc$exports,
    "lucky-winner-to-scope": $117120d909282e7e$exports,
    "mask-as": $745dc07eb0fc8a8b$exports,
    "mask-phone-v2": $c9f19e4fffff0985$exports,
    "mask-phone": $196a3e27a352fe5d$exports,
    "mask-pt-postcode": $2cb8b345aa8252bb$exports,
    "mask-zipcode": $67a279c11f157498$exports,
    "native-datepicker": $3ab59b29bbb13f6d$exports,
    "on-success": $095e63c3373c04a0$exports,
    "parallax": $7eb72df80797b874$exports,
    "password-validate": $b16095068d0d61c2$exports,
    "password-verify": $1c7d9c31d902ddb8$exports,
    "play-track-on-click": $74518b9d13358209$exports,
    "popup-close": $1a4b9b279edc392b$exports,
    "popup-open": $a835cc78a32127f4$exports,
    "promo-button": $b710ba50696cd6e8$exports,
    "regily-avatar-to-reward": $f0a42041f1463b34$exports,
    "remove-class-on-clickoutside": $ebf1e07e92c693c0$exports,
    "remove-class-on-event": $07738c7478f945c1$exports,
    "remove-if-pwa": $063f389ce378a4b6$exports,
    "scroll-element-to-center-on-state-change": $372ddc23dfe6ec29$exports,
    "scroll-left-after-repeat": $e1a19055f33721cc$exports,
    "scroll-to-current-date": $3056ac1c94038955$exports,
    "scroll-to-top-on-click": $71ce799c63e44667$exports,
    "scroll-to-top": $11fc5223f3036465$exports,
    "scroll-when-hold": $35d6b1524785e60e$exports,
    "select-template-given-expression": $c0ade08cd0b7b788$exports,
    "select-template-given-user-status": $dc14a7ad70ee7772$exports,
    "seo-text": $37ad02763d62eb66$exports,
    "set-popup-content-to": $8e0730bdd5203a47$exports,
    "show-by-counrty-code": $ddea9459b213518b$exports,
    "show-element-if": $35bb9cfa18f2c9e2$exports,
    "show-element-on-success": $e86ee157d0a2a3b6$exports,
    "show-game-link-by-location": $42f85131ca229a8c$exports,
    "spine-player": $e6cfa5488ca558b9$exports,
    "swiper-slider": $48b438f272df27eb$exports,
    "terms-modal-open": $d1ea8e6e3c71b8d4$exports,
    "time-passed": $0b16549f473868b2$exports,
    "title-switcher": $e185481e0b3929fb$exports,
    "toggle-class-at-elemetns": $5126ec3d65dc9f70$exports,
    "toggle-class-on-event": $31631ad572cd66dd$exports,
    "toggle-class-on-scroll": $5ef575360582cf8a$exports,
    "toggle-group-class-on-event": $c5f411f5987c30f8$exports,
    "toggle-login-form-mode": $2113b38cf902561c$exports,
    "validate-as": $de3cd069c9b50b43$exports,
    "validate-cpr": $3d40794d82a01328$exports,
    "wazamba-quick-deposit-behavior": $46d59094d6909ce6$exports,
    "E": {
        "body": $2dd69f6d55921652$exports,
        "form": $8efba2c706f7d602$exports,
        "head": $d1d39a0fbdabb8fc$exports,
        "linda-avatar-slick": $7ec4303e422991d0$exports,
        "linda-slick": $1f90e455e4375a58$exports
    },
    "bankid": {
        "auth-bankid": $b54b4712f1118475$exports,
        "popup-bankid": $ff6a01f25bb09edb$exports
    },
    "crab": {
        "_bonus-crab-init": $0c3d179d5bec3a4d$exports,
        "claw-game-field": $e1b3955f64bb09e5$exports,
        "crab-popup": $df145c56574b995d$exports,
        "crab-sport-widget": $ea81ebe3c803cc11$exports
    },
    "dvs": {
        "dvs-drag-and-drop": $e2f63d07e4517ad3$exports,
        "dvs-file-upload": $bd7256ce561e9689$exports,
        "dvs-notification-not-verified": $8c6041f7c0fd3bd0$exports,
        "dvs-notification-verified": $92a6e8ee14f09cad$exports,
        "linda-document-verification-onfido": $672b73eb402b53bf$exports
    },
    "gringos": {
        "g": $879157994aa2632a$exports
    },
    "funid": {
        "show-if-funid": $58b51f6c526c2c18$exports
    },
    "holidays": {
        "_summer-holiday-scene": $0b76e74d51fbfc26$exports,
        "_world-cup-calendar": $405354a9ba4378b3$exports,
        "_world-cup-video": $5654e8f1cca9aca4$exports
    },
    "kickertech-widgets": {
        "kickertech-widget.directive": $519861a844070f1e$exports
    },
    "mga": {
        "mga-unverified-email-widget": $6a6f0d85ba55a69e$exports
    },
    "mobile": {
        "body-scroll-lock": $06daa3eea4eb7cae$exports,
        "call-number": $3f9067b6ff1e813c$exports,
        "hide-after-scroll": $e142046d94bb2946$exports,
        "keep-scroll-position": $9d5c9770613e620e$exports,
        "linda-modal-reject-on-tap": $4b90dcbe7e394086$exports,
        "linda-modal-resolve-on-tap": $950cb124780dba31$exports,
        "m-datepicker": $ea98f828d5832528$exports,
        "ng-dbtap": $14982d092b27f226$exports,
        "ng-tap": $c2315f22e8d44237$exports,
        "popup-close-tap": $818861ded64d6b91$exports,
        "popup-open-tap": $ca4a9d69699b0940$exports,
        "scroll-box": $052054912d1f0b14$exports,
        "scroll-into-view-on-event": $343a0479bc58e0ca$exports,
        "scroll-to-top-on-tap": $6c306433b40b3cb8$exports,
        "smooth-scroll-tap": $dbf947fd2745e4ab$exports,
        "swipe-sidebar": $70b8ca6836f8c73c$exports,
        "swipe-to-close-notification": $475624eb5a8ad1a8$exports
    },
    "mobile-app": {
        "_all-href-target-system": $a3da565add4f3309$exports,
        "_close-menu-swipe": $977e1624b78d4da2$exports,
        "_deferred-render": $2a6cf7468f53070d$exports,
        "_game-item": $f16a3353868a2fec$exports,
        "_scroll-to": $09b49d2130a2c8eb$exports,
        "_virtual-scroll": $5bd78082ed6c37a4$exports,
        "call-number": $f5c868146101466e$exports,
        "deeplinking": $a333a9e778a432a5$exports,
        "demo-open": $3f74d600f795e84d$exports,
        "firebase-notifications": $4dab1a20a5e47319$exports,
        "hide-after-scroll": $15e9f13ca91f8cd7$exports,
        "keep-scroll-position": $fd3784881c055884$exports,
        "linda-modal-reject-on-touch": $77681803be7b08d6$exports,
        "linda-modal-resolve-on-touch": $8d93c12b80d21e31$exports,
        "m-datepicker": $0c4895e9c49dbba6$exports,
        "m-href": $876d9fa6215fa255$exports,
        "ng-tap-back": $68f07315900c2273$exports,
        "offline": $bf03771ee256095f$exports,
        "open-chat-mobile": $1429dc81afb8a1a6$exports,
        "scroll-element-to-center": $dcb99e22bc146d83$exports,
        "splashscreen": $9448746ec200b340$exports,
        "statusbar": $24d5312853c183e8$exports,
        "swipe-to-close-notification": $24a6de7011b48f88$exports
    },
    "linda": {
        "_linda-3d-slider": $68e1fa00d8b3d19c$exports,
        "linda-achievement-tooltip": $1848486a777d162b$exports,
        "linda-avatar-slider": $6b83590efc3f116e$exports,
        "linda-change-bonus-status": $916446add65716f4$exports,
        "linda-clock": $46f48ade3f0927b8$exports,
        "linda-count-up": $ad8df05a0e6f921d$exports,
        "linda-first-view-change": $f3c9e17013328909$exports,
        "linda-first-view": $959d9cda110a6e53$exports,
        "linda-fullscreen": $aaa130b3dd03e8ba$exports,
        "linda-goto-lang": $4994de40debc289e$exports,
        "linda-goto": $cf684c30e97c9185$exports,
        "linda-is-favourite": $002c369a62474240$exports,
        "linda-modal-reject-on-click": $aa012e3c01863cd8$exports,
        "linda-modal-resolve-on-click": $84a1c725b993fb78$exports,
        "linda-odometer": $0fa9303bdcd93ff6$exports,
        "linda-password-type-toggle": $943c2ea53a4bf905$exports,
        "linda-profile-refresh-on-click": $bb7e32c3167a6dcb$exports,
        "linda-promo-notification": $70c41ddbc4e3e91c$exports,
        "linda-promo-slider": $6d09a84a464aced5$exports,
        "linda-pwa": $688a6caac1c32429$exports,
        "linda-render-template": $45763bae63837845$exports,
        "linda-save-block-ratio": $316be90a0807f611$exports,
        "linda-seo": $f67e78ac799a7f5d$exports,
        "linda-splash": $bfa30e46d0dc3574$exports,
        "linda-sport-field": $ce84d27d5c55cd19$exports,
        "linda-sport-race": $cc6a1ba779007f7a$exports,
        "linda-sport-widget-v3": $fc63954ea994e4d7$exports,
        "linda-sport-widget": $739f7bef2df58b9e$exports,
        "linda-swiper": $6073874ab5760ae1$exports,
        "linda-tglab-sport-field": $23db80bbe0584822$exports,
        "linda-timer": $6ffaa96fe94b6c99$exports,
        "linda-toggle-favourite": $1d6117884ce4e457$exports,
        "linda-translate": $c74f48ffa9903e97$exports,
        "linda-ui-sref-include": $98d21a092ffd696c$exports,
        "linda-validate-birthday-format": $a7ad5b81c232c1cf$exports,
        "linda-validate-birthday": $8165a00fed31e915$exports,
        "linda-vision": $337ca68454f7477c$exports,
        "linda-zendesk": $a3c3ccfebe819ead$exports,
        "balance-flow": {
            "balance-flow-datepicker": $adb5a242abf5b958$exports,
            "balance-history-date-formatter": $e037e70aa6e15025$exports,
            "linda-balance-flow-period-filter-datepicker": $1d1aca9a85516903$exports,
            "linda-balance-flow-period-filter-jquery": $959cdcf5a16e68e5$exports,
            "linda-balance-flow-period-filter-native": $ed7e51d3ec96e627$exports,
            "linda-balance-flow-status-filter": $1eaba65df8d9040a$exports,
            "linda-balance-flow-type-filter": $106761e92824daeb$exports
        },
        "chat": {
            "linda-chatra": $bf33801e62a54beb$exports,
            "linda-freshchat": $f72a69be664af257$exports,
            "linda-live-agent": $b7682229a472689f$exports,
            "linda-livechatinc": $ea371353156702f1$exports
        },
        "trustly": {
            "linda-trustly-b-frame": $4232c0228152df97$exports,
            "linda-trustly-frame": $7fae8f6e5ab3e27c$exports,
            "paynplay-fast-deposit-button": $223181bf76416d6e$exports,
            "paynplay-resume-play-button": $e467078415f117c7$exports,
            "remove-element-if-not-paynplay": $ddf3b4bea7c2a90f$exports,
            "remove-element-if-paynplay": $0f6702b465fea39d$exports
        },
        "zignsec": {
            "linda-zignsec-frame": $04c4eb96f5a8ece5$exports,
            "zignsec-fast-deposit-button": $17c42c11687d5827$exports,
            "zignsec-resume-play-button": $df9e4d37d15a320c$exports
        },
        "zimpler": {
            "linda-zimpler-frame": $2297f2f7693e533a$exports,
            "zimpler-fast-deposit-button": $a8854cbce345a5f4$exports,
            "zimpler-resume-play-button": $18cab59a550e0125$exports
        }
    },
    "registration": {
        "registration-additional-fields": $67c5015bca47c924$exports,
        "registration-avatars-slider": $c8d90f546d95afb0$exports,
        "registration-promotions-slider": $122dd633e340943b$exports
    },
    "slider": {
        "slider-promo": $8fcb2f922aca93ae$exports,
        "slider-splide": $9f1d8a8955cb89fa$exports,
        "slider-vip": $2cbc8cf93e5ffe9f$exports
    },
    "test": {
        "rabbit": $4cf68e720c9b8cad$exports
    },
    "wall-of-wins": {
        "wall-of-wins-random": $773fa01205635540$exports,
        "wall-of-wins": $041f3b3c15ef11ec$exports
    }
};




var $ed8b332b2f25dd95$exports = {};
var $1f8a6a28f0c2f559$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "addFocusOnClick"
    };
    controller.$inject = [
        "state",
        "config",
        "$state"
    ];
    function controller(state, _config, $state) {
        const link = (scope, element, attrs)=>{
            const el = document.querySelectorAll(".focus-input");
            for(let i = 0; i < el.length; i++)el[i].addEventListener("click", ()=>{
                let inputEl = el[i].querySelector("input[name=promocode]");
                inputEl.focus();
            });
        };
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3e2c755f6683823d$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "getSocialLinks"
    };
    controller.$inject = [
        "user$",
        "user"
    ];
    function controller(_user$, _user) {
        function link(scope, element, attrs) {
            const parametr = scope.$eval(attrs[directive.name]);
            const getConfig = ()=>{
                scope.socials = $_CDN.socialLinks[_user?.status ? _user?.profile?.country : parametr.system?.code] || $_CDN.socialLinks["GLOBAL"];
            };
            getConfig();
            _user$.subscribe(()=>{
                getConfig();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $3f1dce246c0dc670$exports = {};


var $cwgwH = parcelRequire("cwgwH");
(function() {
    "use strict";
    const directive = {
        name: "quickDepositMouseAction"
    };
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link(scope, element, attrs) {
            const config = scope.$eval(attrs[directive.name]);
            const mouseenterDelay = config.mouseenterDelay || 400;
            const mouseleaveDelay = config.mouseleaveDelay || 600;
            const hideAnimationDelay = config.hideAnimationDelay || 200;
            const mouseenter$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(element, "mouseenter");
            const mouseleave$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(element, "mouseleave");
            const click$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(element, "click");
            const clickOutside$ = (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "click");
            let isChanged = false;
            let isHovered = false;
            function hideElemntWithDelay() {
                element.removeClass(config.class);
                element.addClass(config.removeClass);
                $timeout(()=>{
                    element.removeClass(config.removeClass);
                }, hideAnimationDelay);
            }
            mouseenter$.pipe((0, $92a424c49fb9c529$export$3f23594af5f37336)(()=>{
                isHovered = true;
            }), (0, $cwgwH.delay)(mouseenterDelay), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(()=>isHovered)).subscribe((e)=>{
                element.addClass(config.class);
            });
            mouseleave$.pipe((0, $92a424c49fb9c529$export$3f23594af5f37336)(()=>{
                isHovered = false;
            }), (0, $cwgwH.delay)(mouseleaveDelay)).subscribe((e)=>{
                if (!isChanged) hideElemntWithDelay();
            });
            click$.pipe((0, $92a424c49fb9c529$export$3f23594af5f37336)((e)=>{
                isChanged = true;
                e.stopPropagation();
            }), (0, $c3c92ab8ce276e43$export$9f6ea8e48bc26eab)((e)=>clickOutside$)).subscribe((e)=>{
                isChanged = false;
                hideElemntWithDelay();
            });
            scope.$on("$destroy", function() {
                mouseenter$.unsubscribe();
                mouseleave$.unsubscribe();
                click$.unsubscribe();
                clickOutside$.unsubscribe();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $d8f66dac3409b6e8$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "rabonaCopyToClipboard"
    };
    controller.$inject = [
        "config",
        "$timeout",
        "$document",
        "$window"
    ];
    function controller(_config, $timeout, $document, $window) {
        const link = (scope, element, attrs)=>{
            scope.copiedStatus = false;
            attrs.$observe(directive.name, (value)=>{
                if (!value) return false;
                element.on("click", ()=>{
                    const textArea = $document[0].createElement("textArea");
                    textArea.value = value;
                    $document[0].body.appendChild(textArea);
                    if (_config.ios) {
                        textArea.readOnly = true;
                        textArea.contentEditable = true;
                        const range = $document[0].createRange();
                        range.selectNodeContents(textArea);
                        const selection = $window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(range);
                        textArea.setSelectionRange(0, 999999);
                    } else textArea.select();
                    $document[0].execCommand("copy");
                    $document[0].body.removeChild(textArea);
                    scope.copiedStatus = true;
                    $timeout(()=>{
                        scope.copiedStatus = false;
                    }, 5000);
                });
            });
        };
        return {
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $1626dee33726edc3$exports = {};
(function() {
    app.filter("rabonaLinebreaks", function() {
        return function(text) {
            if (text) return text.replaceAll("\\n", "\n");
        };
    });
})();


var $d391c311dec0151e$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "rabonaRegistrationPromocode"
    };
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link($scope, element) {
            $scope.promocodeLabelFlag = false;
            $scope.setStatusPromocode = (status = false, type, event)=>{
                $scope.promocodeLabelFlag = status;
                switch(type){
                    case "bonus":
                        $scope.formData.code = "";
                        $scope.hasPromocode = false;
                        break;
                    case "without":
                        $scope.formData.code = "";
                        $scope.activePromotion = "";
                        $timeout(()=>{
                            $scope.formData.enable_trigger_codes = true;
                            $scope.formData.trigger_codes = "no_bonus";
                        });
                        $scope.hasPromocode = false;
                        break;
                    case "promocode":
                        $scope.activePromotion = "";
                        $scope.formData.enable_trigger_codes = false;
                        $scope.hasPromocode = true;
                        break;
                    default:
                        break;
                }
            };
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $471c630e79f53f15$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "rabonaScrollTo"
    };
    controller.$inject = [
        "$document",
        "$timeout"
    ];
    function controller($document, $timeout) {
        function link(scope, element, attrs) {
            const el = scope.$eval(attrs[directive.name]);
            element.on("click", ()=>{
                const targetElement = $document[0].querySelector(el);
                if (targetElement) $timeout(()=>{
                    targetElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                });
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $52859280a7c2b631$exports = {};

(function() {
    "use strict";
    const directive = {
        name: "rabonaSplitPhone"
    };
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        function link(scope, element) {
            scope.phoneCode = scope.countries[0].prefix;
            scope.userPhone = "";
            const userPhoneInput = element[0];
            onInit();
            function onInit() {
                const preselectedCountry = scope.countries.find(({ code: code })=>code === _config.system_info.country.code);
                preSelectPhoneCode(preselectedCountry);
            }
            function preSelectPhoneCode(country) {
                if (!country) return;
                scope.phoneCode = country.prefix;
            }
            userPhoneInput.addEventListener("blur", ()=>{
                if (scope.userPhone.length > 0) scope.regFour.phone.$setTouched();
            });
            scope.$watchGroup([
                "phoneCode",
                "userPhone"
            ], (newVal)=>{
                scope.formData.phone = `${scope.phoneCode}${scope.userPhone}`;
                scope.userPhone = newVal[1] ? scope.userPhone.replace(/[^0-9]/g, "") : "";
            });
            scope.$watch("country", (newCountry)=>preSelectPhoneCode(newCountry));
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $4c6be43a03846ce0$exports = {};
(function() {
    "use strict";
    const directive = {
        name: "rabonaTrackPhoneError"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const inputConfig = scope.$eval(attrs[directive.name]);
            element.bind("blur", ()=>{
                if (!scope.regFour[inputConfig.name].$valid) scope.track("Register_Popup", "Phone_Fail", `Error ${inputConfig.error}`, {
                    nonInteraction: true
                });
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $aeb895a9e1f41e28$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "scrollWhenHoldWithRtl"
    };
    let $;
    controller.$inject = [
        "splash$",
        "$timeout"
    ];
    function controller(_splash$, $timeout) {
        function link(scope, element, attrs) {
            // Params:
            // el - String, selector of scrollable element
            // direction - String, can be: top | right | bottom | left
            // speed - Integer, pixels per seconds, instead offset, default 800 px/s
            // easing - String, default 'linear', can be 'swing' or 'linear'
            const params = {};
            const options = {};
            const rtl = window.$_CONFIG.currentLang === "ar";
            function checkEndScroll() {
                const el = $(config.el)[0];
                let x = false;
                if (config.direction === "top") x = el.scrollTop === 0;
                if (config.direction === "right") x = !rtl ? Math.floor(el.scrollWidth - el.clientWidth - el.scrollLeft) === 0 : Math.floor(el.scrollWidth - el.clientWidth + el.scrollLeft) === 0;
                if (config.direction === "bottom") x = Math.floor(el.scrollHeight - el.clientHeight - el.scrollTop) === 0;
                if (config.direction === "left") x = el.scrollLeft === 0;
                if (x) element.addClass("is-disable");
                else element.removeClass("is-disable");
            }
            const config = scope.$eval(attrs[directive.name]);
            window.onload = ()=>{
                const observer = new MutationObserver(()=>{
                    checkEndScroll();
                });
                observer.observe(document.querySelector(config.el), {
                    childList: true
                });
            };
            Promise.resolve((parcelRequire("1E71g"))).then((jQuery)=>{
                $ = jQuery;
                if (config.direction && config.el) {
                    element.on("mousedown touchstart", (e)=>{
                        const el = $(config.el)[0];
                        const speed = config.speed || 800;
                        if (config.direction === "top") {
                            params.scrollTop = 0;
                            options.duration = el.scrollTop / speed;
                        }
                        if (config.direction === "right") {
                            params.scrollLeft = !rtl ? el.scrollWidth - el.clientWidth || 10000 : -(el.scrollWidth - el.clientWidth || 10000);
                            options.duration = (el.scrollWidth - el.scrollLeft - el.clientWidth) / speed;
                        }
                        if (config.direction === "bottom") {
                            params.scrollTop = el.scrollHeight - el.clientHeight || 10000;
                            options.duration = (el.scrollHeight - el.scrollTop - el.clientHeight) / speed;
                        }
                        if (config.direction === "left") {
                            params.scrollLeft = 0;
                            options.duration = !rtl ? el.scrollLeft / speed : -el.scrollLeft / speed;
                        }
                        options.duration *= 1000;
                        options.easing = config.easing || "linear";
                        $(config.el).animate(params, options);
                    });
                    element.on("mouseup touchend", (e)=>{
                        $(config.el).stop(true);
                    });
                    $timeout(()=>{
                        checkEndScroll();
                        let debounceId = null;
                        $(config.el).scroll((e)=>{
                            clearTimeout(debounceId);
                            debounceId = $timeout(()=>{
                                checkEndScroll();
                            }, 200);
                        });
                    }, 0);
                    const subscription = _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded")).subscribe((i)=>{
                        checkEndScroll();
                    });
                    scope.$on("$destroy", ()=>{
                        subscription.unsubscribe();
                    });
                }
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $b2ff4046d1abc0f0$exports = {};


(function() {
    "use strict";
    const directive = {
        name: "slickRtl"
    };
    controller.$inject = [
        "$timeout"
    ];
    function controller($timeout) {
        function link(scope, element, attrs) {
            const curLang = window.$_CONFIG.currentLang;
            Promise.all([
                Promise.resolve((parcelRequire("1E71g"))),
                (parcelRequire("aMz5n"))
            ]).then(([$])=>{
                $timeout(()=>{
                    $(element).slick("slickSetOption", "rtl", curLang === "ar");
                    if (curLang === "ar") $(element).addClass("slick-rtl");
                }, 100);
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $a44681b3679238ea$exports = {};


(function() {
    "use strict";
    app.factory("page", pageCtrl);
    pageCtrl.$inject = [
        "api",
        "http",
        "$q"
    ];
    function pageCtrl(_api, _http, $q) {
        return {
            item (options) {
                const defer = $q.defer();
                const alias = {
                    name: "pageItem",
                    param: options.name
                };
                const config = {
                    cache: true,
                    meta: {
                        cache: true,
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            collection () {}
        };
    }
})();


(function() {
    "use strict";
    const directive = {
        name: "socialLinks"
    };
    controller.$inject = [
        "page",
        "$sce"
    ];
    function controller(_page, $sce) {
        function link(scope, element) {
            scope.socials = "";
            _page.item({
                name: "social-network-list"
            }).then((answer)=>{
                scope.socials = $sce.trustAsHtml(answer.result.content);
            }).catch(()=>{}).finally(()=>{});
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $03e1e4d1284fc365$exports = {};


/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $d20327f4150f02ae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d20327f4150f02ae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d20327f4150f02ae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d20327f4150f02ae$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $d20327f4150f02ae$var$gsap, $d20327f4150f02ae$var$_coreInitted, $d20327f4150f02ae$var$_clamp, $d20327f4150f02ae$var$_win, $d20327f4150f02ae$var$_doc, $d20327f4150f02ae$var$_docEl, $d20327f4150f02ae$var$_body, $d20327f4150f02ae$var$_isTouch, $d20327f4150f02ae$var$_pointerType, $d20327f4150f02ae$var$ScrollTrigger, $d20327f4150f02ae$var$_root, $d20327f4150f02ae$var$_normalizer, $d20327f4150f02ae$var$_eventTypes, $d20327f4150f02ae$var$_context, $d20327f4150f02ae$var$_getGSAP = function _getGSAP() {
    return $d20327f4150f02ae$var$gsap || typeof window !== "undefined" && ($d20327f4150f02ae$var$gsap = window.gsap) && $d20327f4150f02ae$var$gsap.registerPlugin && $d20327f4150f02ae$var$gsap;
}, $d20327f4150f02ae$var$_startup = 1, $d20327f4150f02ae$var$_observers = [], $d20327f4150f02ae$export$3cd1cee43d19b683 = [], $d20327f4150f02ae$export$d8e56d510a804d0a = [], $d20327f4150f02ae$var$_getTime = Date.now, $d20327f4150f02ae$var$_bridge = function _bridge(name, value) {
    return value;
}, $d20327f4150f02ae$var$_integrate = function _integrate() {
    var core = $d20327f4150f02ae$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $d20327f4150f02ae$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $d20327f4150f02ae$export$d8e56d510a804d0a);
    $d20327f4150f02ae$export$3cd1cee43d19b683 = scrollers;
    $d20327f4150f02ae$export$d8e56d510a804d0a = proxies;
    $d20327f4150f02ae$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $d20327f4150f02ae$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$d20327f4150f02ae$export$d8e56d510a804d0a.indexOf(element) && $d20327f4150f02ae$export$d8e56d510a804d0a[$d20327f4150f02ae$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $d20327f4150f02ae$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$d20327f4150f02ae$var$_root.indexOf(el);
}, $d20327f4150f02ae$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $d20327f4150f02ae$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $d20327f4150f02ae$var$_scrollLeft = "scrollLeft", $d20327f4150f02ae$var$_scrollTop = "scrollTop", $d20327f4150f02ae$var$_onScroll = function _onScroll() {
    return $d20327f4150f02ae$var$_normalizer && $d20327f4150f02ae$var$_normalizer.isPressed || $d20327f4150f02ae$export$3cd1cee43d19b683.cache++;
}, $d20327f4150f02ae$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $d20327f4150f02ae$var$_startup && ($d20327f4150f02ae$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $d20327f4150f02ae$var$_normalizer && $d20327f4150f02ae$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($d20327f4150f02ae$var$_normalizer && $d20327f4150f02ae$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $d20327f4150f02ae$export$3cd1cee43d19b683.cache;
            isNormalizing && $d20327f4150f02ae$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $d20327f4150f02ae$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $d20327f4150f02ae$var$_bridge("ref")) {
            cachingFunc.cacheID = $d20327f4150f02ae$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $d20327f4150f02ae$export$b2cabb342cb0ebe1 = {
    s: $d20327f4150f02ae$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $d20327f4150f02ae$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $d20327f4150f02ae$var$_win.scrollTo(value, $d20327f4150f02ae$export$8e40fc98ff518e9d.sc()) : $d20327f4150f02ae$var$_win.pageXOffset || $d20327f4150f02ae$var$_doc[$d20327f4150f02ae$var$_scrollLeft] || $d20327f4150f02ae$var$_docEl[$d20327f4150f02ae$var$_scrollLeft] || $d20327f4150f02ae$var$_body[$d20327f4150f02ae$var$_scrollLeft] || 0;
    })
}, $d20327f4150f02ae$export$8e40fc98ff518e9d = {
    s: $d20327f4150f02ae$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $d20327f4150f02ae$export$b2cabb342cb0ebe1,
    sc: $d20327f4150f02ae$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $d20327f4150f02ae$var$_win.scrollTo($d20327f4150f02ae$export$b2cabb342cb0ebe1.sc(), value) : $d20327f4150f02ae$var$_win.pageYOffset || $d20327f4150f02ae$var$_doc[$d20327f4150f02ae$var$_scrollTop] || $d20327f4150f02ae$var$_docEl[$d20327f4150f02ae$var$_scrollTop] || $d20327f4150f02ae$var$_body[$d20327f4150f02ae$var$_scrollTop] || 0;
    })
}, $d20327f4150f02ae$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $d20327f4150f02ae$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $d20327f4150f02ae$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $d20327f4150f02ae$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $d20327f4150f02ae$export$4330f3a92e5d2e94(element) && (element = $d20327f4150f02ae$var$_doc.scrollingElement || $d20327f4150f02ae$var$_docEl);
    var i = $d20327f4150f02ae$export$3cd1cee43d19b683.indexOf(element), offset = sc === $d20327f4150f02ae$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $d20327f4150f02ae$export$3cd1cee43d19b683.push(element) - 1);
    $d20327f4150f02ae$export$3cd1cee43d19b683[i + offset] || $d20327f4150f02ae$var$_addListener(element, "scroll", $d20327f4150f02ae$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $d20327f4150f02ae$export$3cd1cee43d19b683[i + offset], func = prev || ($d20327f4150f02ae$export$3cd1cee43d19b683[i + offset] = $d20327f4150f02ae$var$_scrollCacheFunc($d20327f4150f02ae$export$6078f1ef08b38af9(element, s), true) || ($d20327f4150f02ae$export$4330f3a92e5d2e94(element) ? sc : $d20327f4150f02ae$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $d20327f4150f02ae$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $d20327f4150f02ae$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $d20327f4150f02ae$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $d20327f4150f02ae$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $d20327f4150f02ae$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $d20327f4150f02ae$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $d20327f4150f02ae$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $d20327f4150f02ae$var$_setScrollTrigger = function _setScrollTrigger() {
    $d20327f4150f02ae$var$ScrollTrigger = $d20327f4150f02ae$var$gsap.core.globals().ScrollTrigger;
    $d20327f4150f02ae$var$ScrollTrigger && $d20327f4150f02ae$var$ScrollTrigger.core && $d20327f4150f02ae$var$_integrate();
}, $d20327f4150f02ae$var$_initCore = function _initCore(core) {
    $d20327f4150f02ae$var$gsap = core || $d20327f4150f02ae$var$_getGSAP();
    if (!$d20327f4150f02ae$var$_coreInitted && $d20327f4150f02ae$var$gsap && typeof document !== "undefined" && document.body) {
        $d20327f4150f02ae$var$_win = window;
        $d20327f4150f02ae$var$_doc = document;
        $d20327f4150f02ae$var$_docEl = $d20327f4150f02ae$var$_doc.documentElement;
        $d20327f4150f02ae$var$_body = $d20327f4150f02ae$var$_doc.body;
        $d20327f4150f02ae$var$_root = [
            $d20327f4150f02ae$var$_win,
            $d20327f4150f02ae$var$_doc,
            $d20327f4150f02ae$var$_docEl,
            $d20327f4150f02ae$var$_body
        ];
        $d20327f4150f02ae$var$_clamp = $d20327f4150f02ae$var$gsap.utils.clamp;
        $d20327f4150f02ae$var$_context = $d20327f4150f02ae$var$gsap.core.context || function() {};
        $d20327f4150f02ae$var$_pointerType = "onpointerenter" in $d20327f4150f02ae$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $d20327f4150f02ae$var$_isTouch = $d20327f4150f02ae$export$c1cbdee04e18ea8b.isTouch = $d20327f4150f02ae$var$_win.matchMedia && $d20327f4150f02ae$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $d20327f4150f02ae$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $d20327f4150f02ae$var$_eventTypes = $d20327f4150f02ae$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $d20327f4150f02ae$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $d20327f4150f02ae$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $d20327f4150f02ae$var$_startup = 0;
        }, 500);
        $d20327f4150f02ae$var$_setScrollTrigger();
        $d20327f4150f02ae$var$_coreInitted = 1;
    }
    return $d20327f4150f02ae$var$_coreInitted;
};
$d20327f4150f02ae$export$b2cabb342cb0ebe1.op = $d20327f4150f02ae$export$8e40fc98ff518e9d;
$d20327f4150f02ae$export$3cd1cee43d19b683.cache = 0;
var $d20327f4150f02ae$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $d20327f4150f02ae$var$_coreInitted || $d20327f4150f02ae$var$_initCore($d20327f4150f02ae$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $d20327f4150f02ae$var$ScrollTrigger || $d20327f4150f02ae$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $d20327f4150f02ae$export$937374fea3f88711(target) || $d20327f4150f02ae$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $d20327f4150f02ae$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($d20327f4150f02ae$var$_win.getComputedStyle($d20327f4150f02ae$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault, scrollFuncX = $d20327f4150f02ae$export$8665aac53dad5647(target, $d20327f4150f02ae$export$b2cabb342cb0ebe1), scrollFuncY = $d20327f4150f02ae$export$8665aac53dad5647(target, $d20327f4150f02ae$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $d20327f4150f02ae$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $d20327f4150f02ae$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $d20327f4150f02ae$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $d20327f4150f02ae$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $d20327f4150f02ae$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $d20327f4150f02ae$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $d20327f4150f02ae$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $d20327f4150f02ae$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $d20327f4150f02ae$var$_addListener(isNormalizer ? target : ownerDoc, $d20327f4150f02ae$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $d20327f4150f02ae$var$_removeListener(isNormalizer ? target : ownerDoc, $d20327f4150f02ae$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $d20327f4150f02ae$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $d20327f4150f02ae$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($d20327f4150f02ae$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $d20327f4150f02ae$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $d20327f4150f02ae$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $d20327f4150f02ae$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $d20327f4150f02ae$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $d20327f4150f02ae$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $d20327f4150f02ae$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $d20327f4150f02ae$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $d20327f4150f02ae$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $d20327f4150f02ae$var$_addListener(isViewport ? ownerDoc : target, "scroll", $d20327f4150f02ae$var$_onScroll);
                type.indexOf("scroll") >= 0 && $d20327f4150f02ae$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $d20327f4150f02ae$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $d20327f4150f02ae$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $d20327f4150f02ae$var$_addListener(target, $d20327f4150f02ae$var$_eventTypes[0], _onPress, passive, capture);
                    $d20327f4150f02ae$var$_addListener(ownerDoc, $d20327f4150f02ae$var$_eventTypes[2], _onRelease);
                    $d20327f4150f02ae$var$_addListener(ownerDoc, $d20327f4150f02ae$var$_eventTypes[3], _onRelease);
                    allowClicks && $d20327f4150f02ae$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $d20327f4150f02ae$var$_addListener(target, "click", _onClick);
                    onGestureStart && $d20327f4150f02ae$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $d20327f4150f02ae$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $d20327f4150f02ae$var$_addListener(target, $d20327f4150f02ae$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $d20327f4150f02ae$var$_addListener(target, $d20327f4150f02ae$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $d20327f4150f02ae$var$_addListener(target, $d20327f4150f02ae$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $d20327f4150f02ae$var$_observers.filter(function(o) {
                    return o !== self && $d20327f4150f02ae$export$4330f3a92e5d2e94(o.target);
                }).length || $d20327f4150f02ae$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $d20327f4150f02ae$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $d20327f4150f02ae$var$_removeListener(isNormalizer ? target : ownerDoc, $d20327f4150f02ae$var$_eventTypes[1], _onDrag, true);
                }
                $d20327f4150f02ae$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $d20327f4150f02ae$var$_removeListener(target, "wheel", _onWheel, capture);
                $d20327f4150f02ae$var$_removeListener(target, $d20327f4150f02ae$var$_eventTypes[0], _onPress, capture);
                $d20327f4150f02ae$var$_removeListener(ownerDoc, $d20327f4150f02ae$var$_eventTypes[2], _onRelease);
                $d20327f4150f02ae$var$_removeListener(ownerDoc, $d20327f4150f02ae$var$_eventTypes[3], _onRelease);
                $d20327f4150f02ae$var$_removeListener(target, "click", clickCapture, true);
                $d20327f4150f02ae$var$_removeListener(target, "click", _onClick);
                $d20327f4150f02ae$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $d20327f4150f02ae$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $d20327f4150f02ae$var$_removeListener(target, $d20327f4150f02ae$var$_pointerType + "enter", _onHover);
                $d20327f4150f02ae$var$_removeListener(target, $d20327f4150f02ae$var$_pointerType + "leave", _onHoverEnd);
                $d20327f4150f02ae$var$_removeListener(target, $d20327f4150f02ae$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $d20327f4150f02ae$var$_observers.indexOf(self);
            i >= 0 && $d20327f4150f02ae$var$_observers.splice(i, 1);
            $d20327f4150f02ae$var$_normalizer === self && ($d20327f4150f02ae$var$_normalizer = 0);
        };
        $d20327f4150f02ae$var$_observers.push(self);
        isNormalizer && $d20327f4150f02ae$export$4330f3a92e5d2e94(target) && ($d20327f4150f02ae$var$_normalizer = self);
        self.enable(event);
    };
    $d20327f4150f02ae$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$d20327f4150f02ae$export$c1cbdee04e18ea8b.version = "3.12.5";
$d20327f4150f02ae$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $d20327f4150f02ae$export$c1cbdee04e18ea8b(vars);
};
$d20327f4150f02ae$export$c1cbdee04e18ea8b.register = $d20327f4150f02ae$var$_initCore;
$d20327f4150f02ae$export$c1cbdee04e18ea8b.getAll = function() {
    return $d20327f4150f02ae$var$_observers.slice();
};
$d20327f4150f02ae$export$c1cbdee04e18ea8b.getById = function(id) {
    return $d20327f4150f02ae$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$d20327f4150f02ae$var$_getGSAP() && $d20327f4150f02ae$var$gsap.registerPlugin($d20327f4150f02ae$export$c1cbdee04e18ea8b);


var $070919eaf9d22dcf$var$gsap, $070919eaf9d22dcf$var$_coreInitted, $070919eaf9d22dcf$var$_win, $070919eaf9d22dcf$var$_doc, $070919eaf9d22dcf$var$_docEl, $070919eaf9d22dcf$var$_body, $070919eaf9d22dcf$var$_root, $070919eaf9d22dcf$var$_resizeDelay, $070919eaf9d22dcf$var$_toArray, $070919eaf9d22dcf$var$_clamp, $070919eaf9d22dcf$var$_time2, $070919eaf9d22dcf$var$_syncInterval, $070919eaf9d22dcf$var$_refreshing, $070919eaf9d22dcf$var$_pointerIsDown, $070919eaf9d22dcf$var$_transformProp, $070919eaf9d22dcf$var$_i, $070919eaf9d22dcf$var$_prevWidth, $070919eaf9d22dcf$var$_prevHeight, $070919eaf9d22dcf$var$_autoRefresh, $070919eaf9d22dcf$var$_sort, $070919eaf9d22dcf$var$_suppressOverwrites, $070919eaf9d22dcf$var$_ignoreResize, $070919eaf9d22dcf$var$_normalizer, $070919eaf9d22dcf$var$_ignoreMobileResize, $070919eaf9d22dcf$var$_baseScreenHeight, $070919eaf9d22dcf$var$_baseScreenWidth, $070919eaf9d22dcf$var$_fixIOSBug, $070919eaf9d22dcf$var$_context, $070919eaf9d22dcf$var$_scrollRestoration, $070919eaf9d22dcf$var$_div100vh, $070919eaf9d22dcf$var$_100vh, $070919eaf9d22dcf$var$_isReverted, $070919eaf9d22dcf$var$_clampingMax, $070919eaf9d22dcf$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$070919eaf9d22dcf$var$_startup = 1, $070919eaf9d22dcf$var$_getTime = Date.now, $070919eaf9d22dcf$var$_time1 = $070919eaf9d22dcf$var$_getTime(), $070919eaf9d22dcf$var$_lastScrollTime = 0, $070919eaf9d22dcf$var$_enabled = 0, $070919eaf9d22dcf$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $070919eaf9d22dcf$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $070919eaf9d22dcf$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$070919eaf9d22dcf$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $070919eaf9d22dcf$var$_rafBugFix = function _rafBugFix() {
    return $070919eaf9d22dcf$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$070919eaf9d22dcf$var$_pointerDownHandler = function _pointerDownHandler() {
    return $070919eaf9d22dcf$var$_pointerIsDown = 1;
}, $070919eaf9d22dcf$var$_pointerUpHandler = function _pointerUpHandler() {
    return $070919eaf9d22dcf$var$_pointerIsDown = 0;
}, $070919eaf9d22dcf$var$_passThrough = function _passThrough(v) {
    return v;
}, $070919eaf9d22dcf$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $070919eaf9d22dcf$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $070919eaf9d22dcf$var$_getGSAP = function _getGSAP() {
    return $070919eaf9d22dcf$var$gsap || $070919eaf9d22dcf$var$_windowExists() && ($070919eaf9d22dcf$var$gsap = window.gsap) && $070919eaf9d22dcf$var$gsap.registerPlugin && $070919eaf9d22dcf$var$gsap;
}, $070919eaf9d22dcf$var$_isViewport = function _isViewport(e) {
    return !!~$070919eaf9d22dcf$var$_root.indexOf(e);
}, $070919eaf9d22dcf$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $070919eaf9d22dcf$var$_100vh : $070919eaf9d22dcf$var$_win["inner" + dimensionProperty]) || $070919eaf9d22dcf$var$_docEl["client" + dimensionProperty] || $070919eaf9d22dcf$var$_body["client" + dimensionProperty];
}, $070919eaf9d22dcf$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $d20327f4150f02ae$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($070919eaf9d22dcf$var$_isViewport(element) ? function() {
        $070919eaf9d22dcf$var$_winOffsets.width = $070919eaf9d22dcf$var$_win.innerWidth;
        $070919eaf9d22dcf$var$_winOffsets.height = $070919eaf9d22dcf$var$_100vh;
        return $070919eaf9d22dcf$var$_winOffsets;
    } : function() {
        return $070919eaf9d22dcf$var$_getBounds(element);
    });
}, $070919eaf9d22dcf$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $d20327f4150f02ae$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $070919eaf9d22dcf$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $070919eaf9d22dcf$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $d20327f4150f02ae$export$d8e56d510a804d0a).indexOf(element) ? $070919eaf9d22dcf$var$_getBoundsFunc(element) : function() {
        return $070919eaf9d22dcf$var$_winOffsets;
    };
}, $070919eaf9d22dcf$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $d20327f4150f02ae$export$6078f1ef08b38af9)(element, s)) ? a() - $070919eaf9d22dcf$var$_getBoundsFunc(element)()[d] : $070919eaf9d22dcf$var$_isViewport(element) ? ($070919eaf9d22dcf$var$_docEl[s] || $070919eaf9d22dcf$var$_body[s]) - $070919eaf9d22dcf$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $070919eaf9d22dcf$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $070919eaf9d22dcf$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($070919eaf9d22dcf$var$_autoRefresh[i + 1])) && func($070919eaf9d22dcf$var$_autoRefresh[i], $070919eaf9d22dcf$var$_autoRefresh[i + 1], $070919eaf9d22dcf$var$_autoRefresh[i + 2]);
}, $070919eaf9d22dcf$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $070919eaf9d22dcf$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $070919eaf9d22dcf$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $070919eaf9d22dcf$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $070919eaf9d22dcf$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $070919eaf9d22dcf$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $070919eaf9d22dcf$var$_abs = Math.abs, $070919eaf9d22dcf$var$_left = "left", $070919eaf9d22dcf$var$_top = "top", $070919eaf9d22dcf$var$_right = "right", $070919eaf9d22dcf$var$_bottom = "bottom", $070919eaf9d22dcf$var$_width = "width", $070919eaf9d22dcf$var$_height = "height", $070919eaf9d22dcf$var$_Right = "Right", $070919eaf9d22dcf$var$_Left = "Left", $070919eaf9d22dcf$var$_Top = "Top", $070919eaf9d22dcf$var$_Bottom = "Bottom", $070919eaf9d22dcf$var$_padding = "padding", $070919eaf9d22dcf$var$_margin = "margin", $070919eaf9d22dcf$var$_Width = "Width", $070919eaf9d22dcf$var$_Height = "Height", $070919eaf9d22dcf$var$_px = "px", $070919eaf9d22dcf$var$_getComputedStyle = function _getComputedStyle(element) {
    return $070919eaf9d22dcf$var$_win.getComputedStyle(element);
}, $070919eaf9d22dcf$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $070919eaf9d22dcf$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $070919eaf9d22dcf$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $070919eaf9d22dcf$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $070919eaf9d22dcf$var$_getComputedStyle(element)[$070919eaf9d22dcf$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $070919eaf9d22dcf$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $070919eaf9d22dcf$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $070919eaf9d22dcf$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $070919eaf9d22dcf$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $070919eaf9d22dcf$var$gsap.utils.snap($070919eaf9d22dcf$var$_getLabelRatioArray(animation), value);
    };
}, $070919eaf9d22dcf$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $070919eaf9d22dcf$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $070919eaf9d22dcf$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $070919eaf9d22dcf$var$_snapDirectional($070919eaf9d22dcf$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $070919eaf9d22dcf$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $070919eaf9d22dcf$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $070919eaf9d22dcf$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $070919eaf9d22dcf$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $070919eaf9d22dcf$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $070919eaf9d22dcf$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $070919eaf9d22dcf$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $070919eaf9d22dcf$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($070919eaf9d22dcf$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $070919eaf9d22dcf$var$_keywords ? $070919eaf9d22dcf$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $070919eaf9d22dcf$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $070919eaf9d22dcf$var$_doc.createElement("div"), useFixedPosition = $070919eaf9d22dcf$var$_isViewport(container) || (0, $d20327f4150f02ae$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $070919eaf9d22dcf$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $d20327f4150f02ae$export$8e40fc98ff518e9d) ? $070919eaf9d22dcf$var$_right : $070919eaf9d22dcf$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $070919eaf9d22dcf$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $070919eaf9d22dcf$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $070919eaf9d22dcf$var$_Width] = 1;
    vars["border" + oppositeSide + $070919eaf9d22dcf$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $070919eaf9d22dcf$var$gsap.set(marker, vars);
}, $070919eaf9d22dcf$var$_triggers = [], $070919eaf9d22dcf$var$_ids = {}, $070919eaf9d22dcf$var$_rafID, $070919eaf9d22dcf$var$_sync = function _sync() {
    return $070919eaf9d22dcf$var$_getTime() - $070919eaf9d22dcf$var$_lastScrollTime > 34 && ($070919eaf9d22dcf$var$_rafID || ($070919eaf9d22dcf$var$_rafID = requestAnimationFrame($070919eaf9d22dcf$var$_updateAll)));
}, $070919eaf9d22dcf$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$070919eaf9d22dcf$var$_normalizer || !$070919eaf9d22dcf$var$_normalizer.isPressed || $070919eaf9d22dcf$var$_normalizer.startX > $070919eaf9d22dcf$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache++;
        if ($070919eaf9d22dcf$var$_normalizer) $070919eaf9d22dcf$var$_rafID || ($070919eaf9d22dcf$var$_rafID = requestAnimationFrame($070919eaf9d22dcf$var$_updateAll));
        else $070919eaf9d22dcf$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $070919eaf9d22dcf$var$_lastScrollTime || $070919eaf9d22dcf$var$_dispatch("scrollStart");
        $070919eaf9d22dcf$var$_lastScrollTime = $070919eaf9d22dcf$var$_getTime();
    }
}, $070919eaf9d22dcf$var$_setBaseDimensions = function _setBaseDimensions() {
    $070919eaf9d22dcf$var$_baseScreenWidth = $070919eaf9d22dcf$var$_win.innerWidth;
    $070919eaf9d22dcf$var$_baseScreenHeight = $070919eaf9d22dcf$var$_win.innerHeight;
}, $070919eaf9d22dcf$var$_onResize = function _onResize() {
    (0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache++;
    !$070919eaf9d22dcf$var$_refreshing && !$070919eaf9d22dcf$var$_ignoreResize && !$070919eaf9d22dcf$var$_doc.fullscreenElement && !$070919eaf9d22dcf$var$_doc.webkitFullscreenElement && (!$070919eaf9d22dcf$var$_ignoreMobileResize || $070919eaf9d22dcf$var$_baseScreenWidth !== $070919eaf9d22dcf$var$_win.innerWidth || Math.abs($070919eaf9d22dcf$var$_win.innerHeight - $070919eaf9d22dcf$var$_baseScreenHeight) > $070919eaf9d22dcf$var$_win.innerHeight * 0.25) && $070919eaf9d22dcf$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$070919eaf9d22dcf$var$_listeners = {}, $070919eaf9d22dcf$var$_emptyArray = [], $070919eaf9d22dcf$var$_softRefresh = function _softRefresh() {
    return $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$export$875bcbe48555930, "scrollEnd", _softRefresh) || $070919eaf9d22dcf$var$_refreshAll(true);
}, $070919eaf9d22dcf$var$_dispatch = function _dispatch(type) {
    return $070919eaf9d22dcf$var$_listeners[type] && $070919eaf9d22dcf$var$_listeners[type].map(function(f) {
        return f();
    }) || $070919eaf9d22dcf$var$_emptyArray;
}, $070919eaf9d22dcf$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$070919eaf9d22dcf$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $070919eaf9d22dcf$var$_savedStyles.length; i += 5)if (!media || $070919eaf9d22dcf$var$_savedStyles[i + 4] && $070919eaf9d22dcf$var$_savedStyles[i + 4].query === media) {
        $070919eaf9d22dcf$var$_savedStyles[i].style.cssText = $070919eaf9d22dcf$var$_savedStyles[i + 1];
        $070919eaf9d22dcf$var$_savedStyles[i].getBBox && $070919eaf9d22dcf$var$_savedStyles[i].setAttribute("transform", $070919eaf9d22dcf$var$_savedStyles[i + 2] || "");
        $070919eaf9d22dcf$var$_savedStyles[i + 3].uncache = 1;
    }
}, $070919eaf9d22dcf$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($070919eaf9d22dcf$var$_i = 0; $070919eaf9d22dcf$var$_i < $070919eaf9d22dcf$var$_triggers.length; $070919eaf9d22dcf$var$_i++){
        trigger = $070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $070919eaf9d22dcf$var$_isReverted = true;
    media && $070919eaf9d22dcf$var$_revertRecorded(media);
    media || $070919eaf9d22dcf$var$_dispatch("revert");
}, $070919eaf9d22dcf$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache++;
    (force || !$070919eaf9d22dcf$var$_refreshingAll) && (0, $d20327f4150f02ae$export$3cd1cee43d19b683).forEach(function(obj) {
        return $070919eaf9d22dcf$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $070919eaf9d22dcf$var$_isString(scrollRestoration) && ($070919eaf9d22dcf$var$_win.history.scrollRestoration = $070919eaf9d22dcf$var$_scrollRestoration = scrollRestoration);
}, $070919eaf9d22dcf$var$_refreshingAll, $070919eaf9d22dcf$var$_refreshID = 0, $070919eaf9d22dcf$var$_queueRefreshID, $070919eaf9d22dcf$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($070919eaf9d22dcf$var$_queueRefreshID !== $070919eaf9d22dcf$var$_refreshID) {
        var id = $070919eaf9d22dcf$var$_queueRefreshID = $070919eaf9d22dcf$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $070919eaf9d22dcf$var$_refreshID && $070919eaf9d22dcf$var$_refreshAll(true);
        });
    }
}, $070919eaf9d22dcf$var$_refresh100vh = function _refresh100vh() {
    $070919eaf9d22dcf$var$_body.appendChild($070919eaf9d22dcf$var$_div100vh);
    $070919eaf9d22dcf$var$_100vh = !$070919eaf9d22dcf$var$_normalizer && $070919eaf9d22dcf$var$_div100vh.offsetHeight || $070919eaf9d22dcf$var$_win.innerHeight;
    $070919eaf9d22dcf$var$_body.removeChild($070919eaf9d22dcf$var$_div100vh);
}, $070919eaf9d22dcf$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $070919eaf9d22dcf$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $070919eaf9d22dcf$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($070919eaf9d22dcf$var$_lastScrollTime && !force && !$070919eaf9d22dcf$var$_isReverted) {
        $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$export$875bcbe48555930, "scrollEnd", $070919eaf9d22dcf$var$_softRefresh);
        return;
    }
    $070919eaf9d22dcf$var$_refresh100vh();
    $070919eaf9d22dcf$var$_refreshingAll = $070919eaf9d22dcf$export$875bcbe48555930.isRefreshing = true;
    (0, $d20327f4150f02ae$export$3cd1cee43d19b683).forEach(function(obj) {
        return $070919eaf9d22dcf$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $070919eaf9d22dcf$var$_dispatch("refreshInit");
    $070919eaf9d22dcf$var$_sort && $070919eaf9d22dcf$export$875bcbe48555930.sort();
    skipRevert || $070919eaf9d22dcf$var$_revertAll();
    (0, $d20327f4150f02ae$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($070919eaf9d22dcf$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $070919eaf9d22dcf$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $070919eaf9d22dcf$var$_isReverted = false;
    $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $070919eaf9d22dcf$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $070919eaf9d22dcf$var$_hideAllMarkers(true);
    $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $070919eaf9d22dcf$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $070919eaf9d22dcf$var$_hideAllMarkers(false);
    $070919eaf9d22dcf$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $d20327f4150f02ae$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($070919eaf9d22dcf$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $070919eaf9d22dcf$var$_clearScrollMemory($070919eaf9d22dcf$var$_scrollRestoration, 1);
    $070919eaf9d22dcf$var$_resizeDelay.pause();
    $070919eaf9d22dcf$var$_refreshID++;
    $070919eaf9d22dcf$var$_refreshingAll = 2;
    $070919eaf9d22dcf$var$_updateAll(2);
    $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
        return $070919eaf9d22dcf$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $070919eaf9d22dcf$var$_refreshingAll = $070919eaf9d22dcf$export$875bcbe48555930.isRefreshing = false;
    $070919eaf9d22dcf$var$_dispatch("refresh");
}, $070919eaf9d22dcf$var$_lastScroll = 0, $070919eaf9d22dcf$var$_direction = 1, $070919eaf9d22dcf$var$_primary, $070919eaf9d22dcf$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$070919eaf9d22dcf$var$_refreshingAll && !$070919eaf9d22dcf$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $070919eaf9d22dcf$export$875bcbe48555930.isUpdating = true;
        $070919eaf9d22dcf$var$_primary && $070919eaf9d22dcf$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $070919eaf9d22dcf$var$_triggers.length, time = $070919eaf9d22dcf$var$_getTime(), recordVelocity = time - $070919eaf9d22dcf$var$_time1 >= 50, scroll = l && $070919eaf9d22dcf$var$_triggers[0].scroll();
        $070919eaf9d22dcf$var$_direction = $070919eaf9d22dcf$var$_lastScroll > scroll ? -1 : 1;
        $070919eaf9d22dcf$var$_refreshingAll || ($070919eaf9d22dcf$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($070919eaf9d22dcf$var$_lastScrollTime && !$070919eaf9d22dcf$var$_pointerIsDown && time - $070919eaf9d22dcf$var$_lastScrollTime > 200) {
                $070919eaf9d22dcf$var$_lastScrollTime = 0;
                $070919eaf9d22dcf$var$_dispatch("scrollEnd");
            }
            $070919eaf9d22dcf$var$_time2 = $070919eaf9d22dcf$var$_time1;
            $070919eaf9d22dcf$var$_time1 = time;
        }
        if ($070919eaf9d22dcf$var$_direction < 0) {
            $070919eaf9d22dcf$var$_i = l;
            while($070919eaf9d22dcf$var$_i-- > 0)$070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_i] && $070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_i].update(0, recordVelocity);
            $070919eaf9d22dcf$var$_direction = 1;
        } else for($070919eaf9d22dcf$var$_i = 0; $070919eaf9d22dcf$var$_i < l; $070919eaf9d22dcf$var$_i++)$070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_i] && $070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_i].update(0, recordVelocity);
        $070919eaf9d22dcf$export$875bcbe48555930.isUpdating = false;
    }
    $070919eaf9d22dcf$var$_rafID = 0;
}, $070919eaf9d22dcf$var$_propNamesToCopy = [
    $070919eaf9d22dcf$var$_left,
    $070919eaf9d22dcf$var$_top,
    $070919eaf9d22dcf$var$_bottom,
    $070919eaf9d22dcf$var$_right,
    $070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Bottom,
    $070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Right,
    $070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Top,
    $070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $070919eaf9d22dcf$var$_stateProps = $070919eaf9d22dcf$var$_propNamesToCopy.concat([
    $070919eaf9d22dcf$var$_width,
    $070919eaf9d22dcf$var$_height,
    "boxSizing",
    "max" + $070919eaf9d22dcf$var$_Width,
    "max" + $070919eaf9d22dcf$var$_Height,
    "position",
    $070919eaf9d22dcf$var$_margin,
    $070919eaf9d22dcf$var$_padding,
    $070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Top,
    $070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Right,
    $070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Bottom,
    $070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Left
]), $070919eaf9d22dcf$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $070919eaf9d22dcf$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $070919eaf9d22dcf$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $070919eaf9d22dcf$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $070919eaf9d22dcf$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $070919eaf9d22dcf$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$070919eaf9d22dcf$var$_bottom] = pinStyle[$070919eaf9d22dcf$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$070919eaf9d22dcf$var$_width] = $070919eaf9d22dcf$var$_getSize(pin, (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1)) + $070919eaf9d22dcf$var$_px;
        spacerStyle[$070919eaf9d22dcf$var$_height] = $070919eaf9d22dcf$var$_getSize(pin, (0, $d20327f4150f02ae$export$8e40fc98ff518e9d)) + $070919eaf9d22dcf$var$_px;
        spacerStyle[$070919eaf9d22dcf$var$_padding] = pinStyle[$070919eaf9d22dcf$var$_margin] = pinStyle[$070919eaf9d22dcf$var$_top] = pinStyle[$070919eaf9d22dcf$var$_left] = "0";
        $070919eaf9d22dcf$var$_setState(spacerState);
        pinStyle[$070919eaf9d22dcf$var$_width] = pinStyle["max" + $070919eaf9d22dcf$var$_Width] = cs[$070919eaf9d22dcf$var$_width];
        pinStyle[$070919eaf9d22dcf$var$_height] = pinStyle["max" + $070919eaf9d22dcf$var$_Height] = cs[$070919eaf9d22dcf$var$_height];
        pinStyle[$070919eaf9d22dcf$var$_padding] = cs[$070919eaf9d22dcf$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $070919eaf9d22dcf$var$_capsExp = /([A-Z])/g, $070919eaf9d22dcf$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $070919eaf9d22dcf$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($070919eaf9d22dcf$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $070919eaf9d22dcf$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $070919eaf9d22dcf$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($070919eaf9d22dcf$var$_stateProps[i], style[$070919eaf9d22dcf$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $070919eaf9d22dcf$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $070919eaf9d22dcf$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$070919eaf9d22dcf$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $070919eaf9d22dcf$var$_isFunction(value) && (value = value(self));
    if ($070919eaf9d22dcf$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $070919eaf9d22dcf$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$070919eaf9d22dcf$var$_isNumber(value)) {
        $070919eaf9d22dcf$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $d20327f4150f02ae$export$937374fea3f88711)(trigger, self) || $070919eaf9d22dcf$var$_body;
        bounds = $070919eaf9d22dcf$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $070919eaf9d22dcf$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $070919eaf9d22dcf$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $070919eaf9d22dcf$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $070919eaf9d22dcf$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $070919eaf9d22dcf$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $070919eaf9d22dcf$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $070919eaf9d22dcf$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $070919eaf9d22dcf$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($070919eaf9d22dcf$var$_body[p1], $070919eaf9d22dcf$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $070919eaf9d22dcf$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $070919eaf9d22dcf$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $070919eaf9d22dcf$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $070919eaf9d22dcf$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $070919eaf9d22dcf$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $070919eaf9d22dcf$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $070919eaf9d22dcf$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $070919eaf9d22dcf$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$070919eaf9d22dcf$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $070919eaf9d22dcf$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $070919eaf9d22dcf$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $070919eaf9d22dcf$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $070919eaf9d22dcf$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$070919eaf9d22dcf$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $d20327f4150f02ae$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $070919eaf9d22dcf$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache++;
            getTween.tween && $070919eaf9d22dcf$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $070919eaf9d22dcf$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $070919eaf9d22dcf$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $070919eaf9d22dcf$export$875bcbe48555930.isTouch && $070919eaf9d22dcf$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $070919eaf9d22dcf$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $070919eaf9d22dcf$var$_coreInitted || ScrollTrigger.register($070919eaf9d22dcf$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $070919eaf9d22dcf$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$070919eaf9d22dcf$var$_enabled) {
            this.update = this.refresh = this.kill = $070919eaf9d22dcf$var$_passThrough;
            return;
        }
        vars = $070919eaf9d22dcf$var$_setDefaults($070919eaf9d22dcf$var$_isString(vars) || $070919eaf9d22dcf$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $070919eaf9d22dcf$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1) : (0, $d20327f4150f02ae$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $d20327f4150f02ae$export$937374fea3f88711)(vars.scroller || $070919eaf9d22dcf$var$_win), scrollerCache = $070919eaf9d22dcf$var$gsap.core.getCache(scroller), isViewport = $070919eaf9d22dcf$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $d20327f4150f02ae$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $070919eaf9d22dcf$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($070919eaf9d22dcf$var$_getComputedStyle(scroller)["border" + direction.p2 + $070919eaf9d22dcf$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $070919eaf9d22dcf$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $070919eaf9d22dcf$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $d20327f4150f02ae$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $070919eaf9d22dcf$var$_sort = 1;
            vars.refreshPriority === -9999 && ($070919eaf9d22dcf$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $070919eaf9d22dcf$var$_getTweenCreator(scroller, (0, $d20327f4150f02ae$export$8e40fc98ff518e9d)),
            left: $070919eaf9d22dcf$var$_getTweenCreator(scroller, (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $070919eaf9d22dcf$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $070919eaf9d22dcf$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$070919eaf9d22dcf$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $070919eaf9d22dcf$var$_body.style && $070919eaf9d22dcf$var$gsap.set(isViewport ? [
                $070919eaf9d22dcf$var$_body,
                $070919eaf9d22dcf$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $d20327f4150f02ae$export$3cd1cee43d19b683).forEach(function(o) {
                return $070919eaf9d22dcf$var$_isFunction(o) && o.target === (isViewport ? $070919eaf9d22dcf$var$_doc.scrollingElement || $070919eaf9d22dcf$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $070919eaf9d22dcf$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $070919eaf9d22dcf$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $070919eaf9d22dcf$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $070919eaf9d22dcf$var$_snapDirectional(snap.snapTo)(value, $070919eaf9d22dcf$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $070919eaf9d22dcf$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $070919eaf9d22dcf$var$_isObject(snapDurClamp) ? $070919eaf9d22dcf$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $070919eaf9d22dcf$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $070919eaf9d22dcf$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $070919eaf9d22dcf$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$070919eaf9d22dcf$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($070919eaf9d22dcf$var$_getTime() - $070919eaf9d22dcf$var$_time2) * 1000 || 0, change1 = $070919eaf9d22dcf$var$gsap.utils.clamp(-progress, 1 - progress, $070919eaf9d22dcf$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $070919eaf9d22dcf$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.round(start + endValue * change);
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $070919eaf9d22dcf$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($070919eaf9d22dcf$var$_abs(Math.max($070919eaf9d22dcf$var$_abs(naturalEnd - totalProgress), $070919eaf9d22dcf$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $070919eaf9d22dcf$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($070919eaf9d22dcf$var$_ids[id] = self);
        trigger = self.trigger = (0, $d20327f4150f02ae$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $d20327f4150f02ae$export$937374fea3f88711)(pin);
        $070919eaf9d22dcf$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $070919eaf9d22dcf$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $070919eaf9d22dcf$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $070919eaf9d22dcf$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $070919eaf9d22dcf$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $d20327f4150f02ae$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $070919eaf9d22dcf$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $070919eaf9d22dcf$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $070919eaf9d22dcf$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $070919eaf9d22dcf$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $070919eaf9d22dcf$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $070919eaf9d22dcf$var$gsap.getProperty(pin);
            pinSetter = $070919eaf9d22dcf$var$gsap.quickSetter(pin, direction.a, $070919eaf9d22dcf$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $070919eaf9d22dcf$var$_swapPinIn(pin, spacer, cs);
            pinState = $070919eaf9d22dcf$var$_getState(pin);
        }
        if (markers) {
            markerVars = $070919eaf9d22dcf$var$_isObject(markers) ? $070919eaf9d22dcf$var$_setDefaults(markers, $070919eaf9d22dcf$var$_markerDefaults) : $070919eaf9d22dcf$var$_markerDefaults;
            markerStartTrigger = $070919eaf9d22dcf$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $070919eaf9d22dcf$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $d20327f4150f02ae$export$937374fea3f88711)((0, $d20327f4150f02ae$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $070919eaf9d22dcf$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $070919eaf9d22dcf$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $070919eaf9d22dcf$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $070919eaf9d22dcf$var$_px));
            if (!useFixedPosition && !((0, $d20327f4150f02ae$export$d8e56d510a804d0a).length && (0, $d20327f4150f02ae$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $070919eaf9d22dcf$var$_makePositionable(isViewport ? $070919eaf9d22dcf$var$_body : scroller);
                $070919eaf9d22dcf$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $070919eaf9d22dcf$var$gsap.quickSetter(markerStartTrigger, direction.a, $070919eaf9d22dcf$var$_px);
                markerEndSetter = $070919eaf9d22dcf$var$gsap.quickSetter(markerEndTrigger, direction.a, $070919eaf9d22dcf$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $070919eaf9d22dcf$var$_triggers[$070919eaf9d22dcf$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $070919eaf9d22dcf$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $070919eaf9d22dcf$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $070919eaf9d22dcf$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $070919eaf9d22dcf$var$_swapPinIn(pin, spacer, $070919eaf9d22dcf$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $070919eaf9d22dcf$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($070919eaf9d22dcf$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $070919eaf9d22dcf$var$_lastScrollTime) {
                $070919eaf9d22dcf$var$_addListener(ScrollTrigger, "scrollEnd", $070919eaf9d22dcf$var$_softRefresh);
                return;
            }
            !$070919eaf9d22dcf$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $070919eaf9d22dcf$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $070919eaf9d22dcf$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $070919eaf9d22dcf$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $070919eaf9d22dcf$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $d20327f4150f02ae$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $070919eaf9d22dcf$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $070919eaf9d22dcf$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $070919eaf9d22dcf$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $070919eaf9d22dcf$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $070919eaf9d22dcf$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($070919eaf9d22dcf$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $070919eaf9d22dcf$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $070919eaf9d22dcf$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $070919eaf9d22dcf$var$_parseClamp(parsedStart, "start", self);
            start = $070919eaf9d22dcf$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $070919eaf9d22dcf$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($070919eaf9d22dcf$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($070919eaf9d22dcf$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $070919eaf9d22dcf$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $070919eaf9d22dcf$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $070919eaf9d22dcf$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $070919eaf9d22dcf$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $070919eaf9d22dcf$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $070919eaf9d22dcf$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$070919eaf9d22dcf$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $070919eaf9d22dcf$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $070919eaf9d22dcf$var$gsap.utils.clamp(0, 1, $070919eaf9d22dcf$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $070919eaf9d22dcf$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($070919eaf9d22dcf$var$_clampingMax && self.end >= $070919eaf9d22dcf$var$_maxScroll(scroller, direction))) {
                cs = $070919eaf9d22dcf$var$_getComputedStyle(pin);
                isVertical = direction === (0, $d20327f4150f02ae$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $070919eaf9d22dcf$var$_doc.scrollingElement || $070919eaf9d22dcf$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $070919eaf9d22dcf$var$_getComputedStyle($070919eaf9d22dcf$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $070919eaf9d22dcf$var$_swapPinIn(pin, spacer, cs);
                pinState = $070919eaf9d22dcf$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $070919eaf9d22dcf$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $d20327f4150f02ae$export$8665aac53dad5647)(scroller, isVertical ? (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1) : (0, $d20327f4150f02ae$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $070919eaf9d22dcf$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $070919eaf9d22dcf$var$_padding ? $070919eaf9d22dcf$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $070919eaf9d22dcf$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $070919eaf9d22dcf$var$_px);
                    }
                    $070919eaf9d22dcf$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $070919eaf9d22dcf$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $070919eaf9d22dcf$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $070919eaf9d22dcf$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $070919eaf9d22dcf$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$070919eaf9d22dcf$var$_width] = override["max" + $070919eaf9d22dcf$var$_Width] = Math.ceil(bounds.width) + $070919eaf9d22dcf$var$_px;
                    override[$070919eaf9d22dcf$var$_height] = override["max" + $070919eaf9d22dcf$var$_Height] = Math.ceil(bounds.height) + $070919eaf9d22dcf$var$_px;
                    override[$070919eaf9d22dcf$var$_margin] = override[$070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Top] = override[$070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Right] = override[$070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Bottom] = override[$070919eaf9d22dcf$var$_margin + $070919eaf9d22dcf$var$_Left] = "0";
                    override[$070919eaf9d22dcf$var$_padding] = cs[$070919eaf9d22dcf$var$_padding];
                    override[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Top] = cs[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Top];
                    override[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Right] = cs[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Right];
                    override[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Bottom] = cs[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Bottom];
                    override[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Left] = cs[$070919eaf9d22dcf$var$_padding + $070919eaf9d22dcf$var$_Left];
                    pinActiveState = $070919eaf9d22dcf$var$_copyState(pinOriginalState, override, pinReparent);
                    $070919eaf9d22dcf$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $070919eaf9d22dcf$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $070919eaf9d22dcf$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $070919eaf9d22dcf$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $070919eaf9d22dcf$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$070919eaf9d22dcf$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $070919eaf9d22dcf$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $070919eaf9d22dcf$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $070919eaf9d22dcf$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $070919eaf9d22dcf$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $070919eaf9d22dcf$var$gsap.getProperty(markerEndTrigger, direction.p);
                $070919eaf9d22dcf$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $070919eaf9d22dcf$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $070919eaf9d22dcf$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $070919eaf9d22dcf$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$070919eaf9d22dcf$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$070919eaf9d22dcf$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($070919eaf9d22dcf$var$_getTime() - $070919eaf9d22dcf$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $070919eaf9d22dcf$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $070919eaf9d22dcf$var$_endAnimation(animation, animation.reversed()) : isToggle || $070919eaf9d22dcf$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $070919eaf9d22dcf$var$_triggers.indexOf(self), a = self.direction > 0 ? $070919eaf9d22dcf$var$_triggers.slice(0, i).reverse() : $070919eaf9d22dcf$var$_triggers.slice(i + 1);
            return ($070919eaf9d22dcf$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $070919eaf9d22dcf$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$070919eaf9d22dcf$var$_refreshing && !$070919eaf9d22dcf$var$_startup && $070919eaf9d22dcf$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($070919eaf9d22dcf$var$_getTime() - $070919eaf9d22dcf$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($070919eaf9d22dcf$var$_getTime() - $070919eaf9d22dcf$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$070919eaf9d22dcf$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($070919eaf9d22dcf$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$070919eaf9d22dcf$var$_refreshing && !$070919eaf9d22dcf$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($070919eaf9d22dcf$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($070919eaf9d22dcf$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $070919eaf9d22dcf$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $070919eaf9d22dcf$var$_getBounds(pin, true), _offset = scroll - start;
                                $070919eaf9d22dcf$var$_reparent(pin, $070919eaf9d22dcf$var$_body, bounds.top + (direction === (0, $d20327f4150f02ae$export$8e40fc98ff518e9d) ? _offset : 0) + $070919eaf9d22dcf$var$_px, bounds.left + (direction === (0, $d20327f4150f02ae$export$8e40fc98ff518e9d) ? 0 : _offset) + $070919eaf9d22dcf$var$_px);
                            } else $070919eaf9d22dcf$var$_reparent(pin, spacer);
                        }
                        $070919eaf9d22dcf$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$070919eaf9d22dcf$var$_refreshing && !$070919eaf9d22dcf$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$070919eaf9d22dcf$var$_limitCallbacks)) && $070919eaf9d22dcf$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$070919eaf9d22dcf$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$070919eaf9d22dcf$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $070919eaf9d22dcf$var$_callback(self, onToggle);
                        callbacks[toggleState] && $070919eaf9d22dcf$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $070919eaf9d22dcf$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($070919eaf9d22dcf$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $070919eaf9d22dcf$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $070919eaf9d22dcf$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$070919eaf9d22dcf$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $070919eaf9d22dcf$var$_addListener(scroller, "resize", $070919eaf9d22dcf$var$_onResize);
                isViewport || $070919eaf9d22dcf$var$_addListener(scroller, "scroll", $070919eaf9d22dcf$var$_onScroll);
                onRefreshInit && $070919eaf9d22dcf$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $070919eaf9d22dcf$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $070919eaf9d22dcf$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $070919eaf9d22dcf$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $070919eaf9d22dcf$var$_px;
                $070919eaf9d22dcf$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $070919eaf9d22dcf$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $070919eaf9d22dcf$var$_triggers.length;
                    while(i--){
                        if ($070919eaf9d22dcf$var$_triggers[i].scroller === scroller && $070919eaf9d22dcf$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $070919eaf9d22dcf$var$_removeListener(scroller, "resize", $070919eaf9d22dcf$var$_onResize);
                    isViewport || $070919eaf9d22dcf$var$_removeListener(scroller, "scroll", $070919eaf9d22dcf$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $070919eaf9d22dcf$var$_ids[id];
            var i = $070919eaf9d22dcf$var$_triggers.indexOf(self);
            i >= 0 && $070919eaf9d22dcf$var$_triggers.splice(i, 1);
            i === $070919eaf9d22dcf$var$_i && $070919eaf9d22dcf$var$_direction > 0 && $070919eaf9d22dcf$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $070919eaf9d22dcf$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $070919eaf9d22dcf$var$_primary === self && ($070919eaf9d22dcf$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $070919eaf9d22dcf$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $070919eaf9d22dcf$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $070919eaf9d22dcf$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$070919eaf9d22dcf$var$_coreInitted) {
            $070919eaf9d22dcf$var$gsap = core || $070919eaf9d22dcf$var$_getGSAP();
            $070919eaf9d22dcf$var$_windowExists() && window.document && ScrollTrigger.enable();
            $070919eaf9d22dcf$var$_coreInitted = $070919eaf9d22dcf$var$_enabled;
        }
        return $070919eaf9d22dcf$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$070919eaf9d22dcf$var$_defaults[p] = config[p];
        return $070919eaf9d22dcf$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $070919eaf9d22dcf$var$_enabled = 0;
        $070919eaf9d22dcf$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$var$_win, "wheel", $070919eaf9d22dcf$var$_onScroll);
        $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$var$_doc, "scroll", $070919eaf9d22dcf$var$_onScroll);
        clearInterval($070919eaf9d22dcf$var$_syncInterval);
        $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$var$_doc, "touchcancel", $070919eaf9d22dcf$var$_passThrough);
        $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$var$_body, "touchstart", $070919eaf9d22dcf$var$_passThrough);
        $070919eaf9d22dcf$var$_multiListener($070919eaf9d22dcf$var$_removeListener, $070919eaf9d22dcf$var$_doc, "pointerdown,touchstart,mousedown", $070919eaf9d22dcf$var$_pointerDownHandler);
        $070919eaf9d22dcf$var$_multiListener($070919eaf9d22dcf$var$_removeListener, $070919eaf9d22dcf$var$_doc, "pointerup,touchend,mouseup", $070919eaf9d22dcf$var$_pointerUpHandler);
        $070919eaf9d22dcf$var$_resizeDelay.kill();
        $070919eaf9d22dcf$var$_iterateAutoRefresh($070919eaf9d22dcf$var$_removeListener);
        for(var i = 0; i < (0, $d20327f4150f02ae$export$3cd1cee43d19b683).length; i += 3){
            $070919eaf9d22dcf$var$_wheelListener($070919eaf9d22dcf$var$_removeListener, (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i], (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i + 1]);
            $070919eaf9d22dcf$var$_wheelListener($070919eaf9d22dcf$var$_removeListener, (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i], (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $070919eaf9d22dcf$var$_win = window;
        $070919eaf9d22dcf$var$_doc = document;
        $070919eaf9d22dcf$var$_docEl = $070919eaf9d22dcf$var$_doc.documentElement;
        $070919eaf9d22dcf$var$_body = $070919eaf9d22dcf$var$_doc.body;
        if ($070919eaf9d22dcf$var$gsap) {
            $070919eaf9d22dcf$var$_toArray = $070919eaf9d22dcf$var$gsap.utils.toArray;
            $070919eaf9d22dcf$var$_clamp = $070919eaf9d22dcf$var$gsap.utils.clamp;
            $070919eaf9d22dcf$var$_context = $070919eaf9d22dcf$var$gsap.core.context || $070919eaf9d22dcf$var$_passThrough;
            $070919eaf9d22dcf$var$_suppressOverwrites = $070919eaf9d22dcf$var$gsap.core.suppressOverwrites || $070919eaf9d22dcf$var$_passThrough;
            $070919eaf9d22dcf$var$_scrollRestoration = $070919eaf9d22dcf$var$_win.history.scrollRestoration || "auto";
            $070919eaf9d22dcf$var$_lastScroll = $070919eaf9d22dcf$var$_win.pageYOffset;
            $070919eaf9d22dcf$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($070919eaf9d22dcf$var$_body) {
                $070919eaf9d22dcf$var$_enabled = 1;
                $070919eaf9d22dcf$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $070919eaf9d22dcf$var$_div100vh.style.height = "100vh";
                $070919eaf9d22dcf$var$_div100vh.style.position = "absolute";
                $070919eaf9d22dcf$var$_refresh100vh();
                $070919eaf9d22dcf$var$_rafBugFix();
                (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).register($070919eaf9d22dcf$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).isTouch;
                $070919eaf9d22dcf$var$_fixIOSBug = (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $070919eaf9d22dcf$var$_ignoreMobileResize = (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).isTouch === 1;
                $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$var$_win, "wheel", $070919eaf9d22dcf$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $070919eaf9d22dcf$var$_root = [
                    $070919eaf9d22dcf$var$_win,
                    $070919eaf9d22dcf$var$_doc,
                    $070919eaf9d22dcf$var$_docEl,
                    $070919eaf9d22dcf$var$_body
                ];
                if ($070919eaf9d22dcf$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $070919eaf9d22dcf$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $070919eaf9d22dcf$var$gsap.addEventListener("matchMediaInit", function() {
                        return $070919eaf9d22dcf$var$_revertAll();
                    });
                    $070919eaf9d22dcf$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $070919eaf9d22dcf$var$_revertRecorded();
                    });
                    $070919eaf9d22dcf$var$gsap.addEventListener("matchMedia", function() {
                        $070919eaf9d22dcf$var$_refreshAll(0, 1);
                        $070919eaf9d22dcf$var$_dispatch("matchMedia");
                    });
                    $070919eaf9d22dcf$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $070919eaf9d22dcf$var$_setBaseDimensions();
                        return $070919eaf9d22dcf$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $070919eaf9d22dcf$var$_setBaseDimensions();
                $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$var$_doc, "scroll", $070919eaf9d22dcf$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $070919eaf9d22dcf$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $070919eaf9d22dcf$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $070919eaf9d22dcf$var$_getBounds($070919eaf9d22dcf$var$_body);
                (0, $d20327f4150f02ae$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $d20327f4150f02ae$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $070919eaf9d22dcf$var$_syncInterval = setInterval($070919eaf9d22dcf$var$_sync, 250);
                $070919eaf9d22dcf$var$gsap.delayedCall(0.5, function() {
                    return $070919eaf9d22dcf$var$_startup = 0;
                });
                $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$var$_doc, "touchcancel", $070919eaf9d22dcf$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$var$_body, "touchstart", $070919eaf9d22dcf$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $070919eaf9d22dcf$var$_multiListener($070919eaf9d22dcf$var$_addListener, $070919eaf9d22dcf$var$_doc, "pointerdown,touchstart,mousedown", $070919eaf9d22dcf$var$_pointerDownHandler);
                $070919eaf9d22dcf$var$_multiListener($070919eaf9d22dcf$var$_addListener, $070919eaf9d22dcf$var$_doc, "pointerup,touchend,mouseup", $070919eaf9d22dcf$var$_pointerUpHandler);
                $070919eaf9d22dcf$var$_transformProp = $070919eaf9d22dcf$var$gsap.utils.checkPrefix("transform");
                $070919eaf9d22dcf$var$_stateProps.push($070919eaf9d22dcf$var$_transformProp);
                $070919eaf9d22dcf$var$_coreInitted = $070919eaf9d22dcf$var$_getTime();
                $070919eaf9d22dcf$var$_resizeDelay = $070919eaf9d22dcf$var$gsap.delayedCall(0.2, $070919eaf9d22dcf$var$_refreshAll).pause();
                $070919eaf9d22dcf$var$_autoRefresh = [
                    $070919eaf9d22dcf$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $070919eaf9d22dcf$var$_win.innerWidth, h = $070919eaf9d22dcf$var$_win.innerHeight;
                        if ($070919eaf9d22dcf$var$_doc.hidden) {
                            $070919eaf9d22dcf$var$_prevWidth = w;
                            $070919eaf9d22dcf$var$_prevHeight = h;
                        } else if ($070919eaf9d22dcf$var$_prevWidth !== w || $070919eaf9d22dcf$var$_prevHeight !== h) $070919eaf9d22dcf$var$_onResize();
                    },
                    $070919eaf9d22dcf$var$_doc,
                    "DOMContentLoaded",
                    $070919eaf9d22dcf$var$_refreshAll,
                    $070919eaf9d22dcf$var$_win,
                    "load",
                    $070919eaf9d22dcf$var$_refreshAll,
                    $070919eaf9d22dcf$var$_win,
                    "resize",
                    $070919eaf9d22dcf$var$_onResize
                ];
                $070919eaf9d22dcf$var$_iterateAutoRefresh($070919eaf9d22dcf$var$_addListener);
                $070919eaf9d22dcf$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $d20327f4150f02ae$export$3cd1cee43d19b683).length; i += 3){
                    $070919eaf9d22dcf$var$_wheelListener($070919eaf9d22dcf$var$_removeListener, (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i], (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i + 1]);
                    $070919eaf9d22dcf$var$_wheelListener($070919eaf9d22dcf$var$_removeListener, (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i], (0, $d20327f4150f02ae$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($070919eaf9d22dcf$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($070919eaf9d22dcf$var$_syncInterval) || ($070919eaf9d22dcf$var$_syncInterval = ms) && setInterval($070919eaf9d22dcf$var$_sync, ms);
        "ignoreMobileResize" in vars && ($070919eaf9d22dcf$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $070919eaf9d22dcf$var$_iterateAutoRefresh($070919eaf9d22dcf$var$_removeListener) || $070919eaf9d22dcf$var$_iterateAutoRefresh($070919eaf9d22dcf$var$_addListener, vars.autoRefreshEvents || "none");
            $070919eaf9d22dcf$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $d20327f4150f02ae$export$937374fea3f88711)(target), i = (0, $d20327f4150f02ae$export$3cd1cee43d19b683).indexOf(t), isViewport = $070919eaf9d22dcf$var$_isViewport(t);
        if (~i) (0, $d20327f4150f02ae$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $d20327f4150f02ae$export$d8e56d510a804d0a).unshift($070919eaf9d22dcf$var$_win, vars, $070919eaf9d22dcf$var$_body, vars, $070919eaf9d22dcf$var$_docEl, vars) : (0, $d20327f4150f02ae$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $070919eaf9d22dcf$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($070919eaf9d22dcf$var$_isString(element) ? (0, $d20327f4150f02ae$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $070919eaf9d22dcf$var$_width : $070919eaf9d22dcf$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $070919eaf9d22dcf$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $070919eaf9d22dcf$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $070919eaf9d22dcf$var$_isString(element) && (element = (0, $d20327f4150f02ae$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $070919eaf9d22dcf$var$_width : $070919eaf9d22dcf$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $070919eaf9d22dcf$var$_keywords ? $070919eaf9d22dcf$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $070919eaf9d22dcf$var$_win.innerWidth : (bounds.top + offset) / $070919eaf9d22dcf$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $070919eaf9d22dcf$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $070919eaf9d22dcf$var$_listeners.killAll || [];
            $070919eaf9d22dcf$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$070919eaf9d22dcf$export$875bcbe48555930.version = "3.12.5";
$070919eaf9d22dcf$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $070919eaf9d22dcf$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $070919eaf9d22dcf$var$_savedStyles.indexOf(target);
            i >= 0 && $070919eaf9d22dcf$var$_savedStyles.splice(i, 5);
            $070919eaf9d22dcf$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $070919eaf9d22dcf$var$gsap.core.getCache(target), $070919eaf9d22dcf$var$_context());
        }
    }) : $070919eaf9d22dcf$var$_savedStyles;
};
$070919eaf9d22dcf$export$875bcbe48555930.revert = function(soft, media) {
    return $070919eaf9d22dcf$var$_revertAll(!soft, media);
};
$070919eaf9d22dcf$export$875bcbe48555930.create = function(vars, animation) {
    return new $070919eaf9d22dcf$export$875bcbe48555930(vars, animation);
};
$070919eaf9d22dcf$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $070919eaf9d22dcf$var$_onResize() : ($070919eaf9d22dcf$var$_coreInitted || $070919eaf9d22dcf$export$875bcbe48555930.register()) && $070919eaf9d22dcf$var$_refreshAll(true);
};
$070919eaf9d22dcf$export$875bcbe48555930.update = function(force) {
    return ++(0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache && $070919eaf9d22dcf$var$_updateAll(force === true ? 2 : 0);
};
$070919eaf9d22dcf$export$875bcbe48555930.clearScrollMemory = $070919eaf9d22dcf$var$_clearScrollMemory;
$070919eaf9d22dcf$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $070919eaf9d22dcf$var$_maxScroll(element, horizontal ? (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1) : (0, $d20327f4150f02ae$export$8e40fc98ff518e9d));
};
$070919eaf9d22dcf$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $d20327f4150f02ae$export$8665aac53dad5647)((0, $d20327f4150f02ae$export$937374fea3f88711)(element), horizontal ? (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1) : (0, $d20327f4150f02ae$export$8e40fc98ff518e9d));
};
$070919eaf9d22dcf$export$875bcbe48555930.getById = function(id) {
    return $070919eaf9d22dcf$var$_ids[id];
};
$070919eaf9d22dcf$export$875bcbe48555930.getAll = function() {
    return $070919eaf9d22dcf$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$070919eaf9d22dcf$export$875bcbe48555930.isScrolling = function() {
    return !!$070919eaf9d22dcf$var$_lastScrollTime;
};
$070919eaf9d22dcf$export$875bcbe48555930.snapDirectional = $070919eaf9d22dcf$var$_snapDirectional;
$070919eaf9d22dcf$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $070919eaf9d22dcf$var$_listeners[type] || ($070919eaf9d22dcf$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$070919eaf9d22dcf$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $070919eaf9d22dcf$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$070919eaf9d22dcf$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $070919eaf9d22dcf$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $070919eaf9d22dcf$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($070919eaf9d22dcf$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $070919eaf9d22dcf$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($070919eaf9d22dcf$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $070919eaf9d22dcf$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $070919eaf9d22dcf$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $070919eaf9d22dcf$var$_docEl && _allowNativePanning($070919eaf9d22dcf$var$_body, direction);
}, $070919eaf9d22dcf$var$_overflow = {
    auto: 1,
    scroll: 1
}, $070919eaf9d22dcf$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $070919eaf9d22dcf$var$gsap.core.getCache(node), time = $070919eaf9d22dcf$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $070919eaf9d22dcf$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($070919eaf9d22dcf$var$_overflow[(cs = $070919eaf9d22dcf$var$_getComputedStyle(node)).overflowY] || $070919eaf9d22dcf$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$070919eaf9d22dcf$var$_isViewport(node) && ($070919eaf9d22dcf$var$_overflow[(cs = $070919eaf9d22dcf$var$_getComputedStyle(node)).overflowY] || $070919eaf9d22dcf$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$070919eaf9d22dcf$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $070919eaf9d22dcf$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$var$_doc, (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).eventTypes[0], $070919eaf9d22dcf$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$var$_doc, (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).eventTypes[0], $070919eaf9d22dcf$var$_captureInputs, true);
        }
    });
}, $070919eaf9d22dcf$var$_inputExp = /(input|label|select|textarea)/i, $070919eaf9d22dcf$var$_inputIsFocused, $070919eaf9d22dcf$var$_captureInputs = function _captureInputs(e) {
    var isInput = $070919eaf9d22dcf$var$_inputExp.test(e.target.tagName);
    if (isInput || $070919eaf9d22dcf$var$_inputIsFocused) {
        e._gsapAllow = true;
        $070919eaf9d22dcf$var$_inputIsFocused = isInput;
    }
}, $070919eaf9d22dcf$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $070919eaf9d22dcf$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $d20327f4150f02ae$export$937374fea3f88711)(vars.target) || $070919eaf9d22dcf$var$_docEl, smoother = $070919eaf9d22dcf$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $070919eaf9d22dcf$var$_fixIOSBug && (vars.content && (0, $d20327f4150f02ae$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $d20327f4150f02ae$export$8665aac53dad5647)(target, (0, $d20327f4150f02ae$export$8e40fc98ff518e9d)), scrollFuncX = (0, $d20327f4150f02ae$export$8665aac53dad5647)(target, (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $d20327f4150f02ae$export$c1cbdee04e18ea8b).isTouch && $070919eaf9d22dcf$var$_win.visualViewport ? $070919eaf9d22dcf$var$_win.visualViewport.scale * $070919eaf9d22dcf$var$_win.visualViewport.width : $070919eaf9d22dcf$var$_win.outerWidth) / $070919eaf9d22dcf$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $070919eaf9d22dcf$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $070919eaf9d22dcf$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $070919eaf9d22dcf$var$_passThrough, scrollClampY = $070919eaf9d22dcf$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $070919eaf9d22dcf$var$_maxScroll(target, (0, $d20327f4150f02ae$export$8e40fc98ff518e9d));
        scrollClampY = $070919eaf9d22dcf$var$_clamp($070919eaf9d22dcf$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $070919eaf9d22dcf$var$_clamp(0, $070919eaf9d22dcf$var$_maxScroll(target, (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1))));
        lastRefreshID = $070919eaf9d22dcf$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $070919eaf9d22dcf$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $070919eaf9d22dcf$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $070919eaf9d22dcf$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache;
                $070919eaf9d22dcf$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $070919eaf9d22dcf$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $070919eaf9d22dcf$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $070919eaf9d22dcf$var$_round(($070919eaf9d22dcf$var$_win.visualViewport && $070919eaf9d22dcf$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $070919eaf9d22dcf$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $070919eaf9d22dcf$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $d20327f4150f02ae$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $070919eaf9d22dcf$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $070919eaf9d22dcf$var$_maxScroll(target, (0, $d20327f4150f02ae$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $070919eaf9d22dcf$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $070919eaf9d22dcf$var$_maxScroll(target, (0, $d20327f4150f02ae$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($070919eaf9d22dcf$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $070919eaf9d22dcf$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($070919eaf9d22dcf$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $070919eaf9d22dcf$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $070919eaf9d22dcf$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $070919eaf9d22dcf$var$_updateAll();
    };
    vars.onEnable = function() {
        $070919eaf9d22dcf$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $070919eaf9d22dcf$export$875bcbe48555930.addEventListener("refresh", onResize);
        $070919eaf9d22dcf$var$_addListener($070919eaf9d22dcf$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $070919eaf9d22dcf$var$_allowNativePanning(target, true);
        $070919eaf9d22dcf$var$_removeListener($070919eaf9d22dcf$var$_win, "resize", onResize);
        $070919eaf9d22dcf$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $070919eaf9d22dcf$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $070919eaf9d22dcf$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $070919eaf9d22dcf$var$_fixIOSBug && $070919eaf9d22dcf$var$gsap.ticker.add($070919eaf9d22dcf$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $070919eaf9d22dcf$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $070919eaf9d22dcf$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $070919eaf9d22dcf$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$070919eaf9d22dcf$export$875bcbe48555930.sort = function(func) {
    return $070919eaf9d22dcf$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$070919eaf9d22dcf$export$875bcbe48555930.observe = function(vars) {
    return new (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b)(vars);
};
$070919eaf9d22dcf$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $070919eaf9d22dcf$var$_normalizer;
    if (vars === true && $070919eaf9d22dcf$var$_normalizer) return $070919eaf9d22dcf$var$_normalizer.enable();
    if (vars === false) {
        $070919eaf9d22dcf$var$_normalizer && $070919eaf9d22dcf$var$_normalizer.kill();
        $070919eaf9d22dcf$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $d20327f4150f02ae$export$c1cbdee04e18ea8b) ? vars : $070919eaf9d22dcf$var$_getScrollNormalizer(vars);
    $070919eaf9d22dcf$var$_normalizer && $070919eaf9d22dcf$var$_normalizer.target === normalizer.target && $070919eaf9d22dcf$var$_normalizer.kill();
    $070919eaf9d22dcf$var$_isViewport(normalizer.target) && ($070919eaf9d22dcf$var$_normalizer = normalizer);
    return normalizer;
};
$070919eaf9d22dcf$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $d20327f4150f02ae$export$5de019f4480f0f8d),
    _inputObserver: $070919eaf9d22dcf$var$_inputObserver,
    _scrollers: (0, $d20327f4150f02ae$export$3cd1cee43d19b683),
    _proxies: (0, $d20327f4150f02ae$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $070919eaf9d22dcf$var$_lastScrollTime || $070919eaf9d22dcf$var$_dispatch("scrollStart");
            $070919eaf9d22dcf$var$_lastScrollTime = $070919eaf9d22dcf$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $070919eaf9d22dcf$var$_refreshing;
        }
    }
};
$070919eaf9d22dcf$var$_getGSAP() && $070919eaf9d22dcf$var$gsap.registerPlugin($070919eaf9d22dcf$export$875bcbe48555930);




(function() {
    "use strict";
    const directive = {
        name: "bnrAnimation"
    };
    controller.$inject = [
        "splash$",
        "$document"
    ];
    function controller(_splash$, $document) {
        function link(scope, element, attrs) {
            (0, $50c26a34528ecf35$export$99ee26438460406a).config({
                nullTargetWarn: false,
                trialWarn: false
            });
            (0, $50c26a34528ecf35$export$99ee26438460406a).registerPlugin((0, $867ff06115902906$export$6953cc323644330b), (0, $070919eaf9d22dcf$export$875bcbe48555930));
            const content = element[0].querySelector(".entrance-bnr__content");
            const img = element[0].querySelector(".entrance-bnr__img");
            const card = element[0].querySelector(".entrance-bnr-card");
            const scrollMove = ()=>{
                const triggerParams = {
                    trigger: ".entrance-bnr-wrapper",
                    start: "bottom 700",
                    end: "+=500",
                    scrub: true
                };
                (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                    scrollTrigger: triggerParams
                }).to(content, {
                    y: "-20%",
                    opacity: "0",
                    duration: 1,
                    stagger: 0
                });
                (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                    scrollTrigger: triggerParams
                }).to(img, {
                    y: "-20%",
                    opacity: "0",
                    duration: 1,
                    stagger: 0
                });
                (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                    scrollTrigger: triggerParams
                }).to(card, {
                    y: "-20%",
                    opacity: "0",
                    duration: 1,
                    stagger: 0
                });
            };
            const bnrStart = (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                paused: true
            }).from(content, {
                x: "-60px",
                opacity: 0,
                duration: 0.2,
                stagger: 0.2
            }).from(img, {
                x: "100%",
                y: "-62%",
                opacity: 0,
                duration: 0.3,
                stagger: "-=0"
            }).from(card, {
                scale: "0.6",
                opacity: "0",
                onComplete: scrollMove,
                duration: 0.3,
                stagger: "-=0"
            });
            if ($document[0].body.classList.contains("loaded")) bnrStart.play();
            else _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded")).subscribe((m)=>{
                bnrStart.play();
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $531d761b979cc6a8$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "menuAnimation"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            const bg = element[0].querySelector(".entrance-menu__bg-wrap");
            const label = element[0].querySelector(".entrance-menu__label-text");
            const offer = element[0].querySelector(".entrance-menu__title");
            (0, $50c26a34528ecf35$export$99ee26438460406a).registerPlugin((0, $867ff06115902906$export$6953cc323644330b), (0, $070919eaf9d22dcf$export$875bcbe48555930));
            (0, $50c26a34528ecf35$export$99ee26438460406a).defaults({
                overwrite: false
            });
            (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                scrollTrigger: {
                    trigger: ".entrance-menu",
                    end: "+=700",
                    scrub: true
                }
            }).from(bg, {
                duration: 1,
                y: 200,
                opacity: 0
            });
            (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                scrollTrigger: {
                    trigger: ".entrance-menu",
                    start: "top 500",
                    end: "+=1",
                    scrub: true
                }
            }).fromTo(label, {
                x: "100%",
                autoAlpha: 0
            }, {
                duration: 1,
                x: 0,
                y: 0,
                autoAlpha: 1
            });
            (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                scrollTrigger: {
                    trigger: offer,
                    start: "top bottom",
                    end: "+=300",
                    scrub: true
                }
            }).from(offer, {
                y: "10%",
                opacity: 0
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


var $d9e113c202555c16$exports = {};



(function() {
    "use strict";
    const directive = {
        name: "promoAnimation"
    };
    controller.$inject = [];
    function controller() {
        function link(scope, element, attrs) {
            (0, $50c26a34528ecf35$export$99ee26438460406a).registerPlugin((0, $867ff06115902906$export$6953cc323644330b), (0, $070919eaf9d22dcf$export$875bcbe48555930));
            (0, $50c26a34528ecf35$export$99ee26438460406a).defaults({
                overwrite: false
            });
            (0, $50c26a34528ecf35$export$99ee26438460406a).timeline({
                scrollTrigger: {
                    trigger: element[0],
                    end: "+=" + element[0].offsetHeight,
                    scrub: true
                }
            }).from(element[0], {
                y: 100,
                opacity: 0
            });
        }
        return {
            restrict: "A",
            link: link
        };
    }
    app.directive(directive.name, controller);
})();


$ed8b332b2f25dd95$exports = {
    "add-focus- \u200Eon-click.js": $1f8a6a28f0c2f559$exports,
    "get-social-links.js": $3e2c755f6683823d$exports,
    "quick-deposit-mouse-action.js": $3f1dce246c0dc670$exports,
    "rabona-copy-to-clipboard.js": $d8f66dac3409b6e8$exports,
    "rabona-linebreaks.js": $1626dee33726edc3$exports,
    "rabona-registration-promocode.js": $d391c311dec0151e$exports,
    "rabona-scroll-to.js": $471c630e79f53f15$exports,
    "rabona-split-phone.js": $52859280a7c2b631$exports,
    "rabona-track-phone-error.js": $4c6be43a03846ce0$exports,
    "scroll-when-hold-with-rtl.js": $aeb895a9e1f41e28$exports,
    "slick-rtl.js": $b2ff4046d1abc0f0$exports,
    "social-links.js": $a44681b3679238ea$exports,
    "animation": {
        "bnr-animation.js": $03e1e4d1284fc365$exports,
        "menu-animation.js": $531d761b979cc6a8$exports,
        "promo-animation.js": $d9e113c202555c16$exports
    }
};


var $e1a1a2d58c77d7fd$exports = {};
var $f9a54d4d4cacf51e$exports = {};






(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        const authBufferData$ = new (0, $a2cdd0ee28149076$export$cc3d42e6b2b9cf8b)(null);
        return {
            preSavedData () {
                return {
                    set: (data)=>{
                        authBufferData$.next(data);
                    },
                    get: ()=>{
                        let lastValue;
                        authBufferData$.subscribe((data)=>{
                            lastValue = data;
                        });
                        return lastValue;
                    }
                };
            }
        };
    }
    app.factory("authWithDeposit", controller);
})();


(function() {
    "use strict";
    const component = {
        name: "authWithDepositInitForm"
    };
    controller.$inject = [
        "$scope",
        "registration",
        "system",
        "helper",
        "popup",
        "remembered",
        "authWithDeposit"
    ];
    function controller($scope, _registration, _system, _helper, _popup, _remembered, _authWithDeposit) {
        $scope.preloader = false;
        $scope.currencyList = [];
        const vm = this;
        $scope.formData = {
            amount: 0
        };
        $scope.rememberedLogin = !!_remembered.login;
        const accountPreSaveData = _authWithDeposit.preSavedData();
        vm.$onInit = ()=>{
            prepareCurrencies();
        };
        const prepareCurrencies = ()=>{
            $scope.preloader = true;
            _system.countries().then((answer)=>{
                const countries = answer.result;
                $scope.country = countries.filter((item)=>item.code === answer.default)[0] || {};
                $scope.currencyList = _registration.prepareCurrencyList($scope.country.currency) || [];
                $scope.formData.currency = $scope.currencyList[0].key;
                const val = $scope.country.currency[0].defaultDepositAmount;
                $scope.formData.amount = val;
                $scope.$watch("formData.currency", (newValue)=>{
                    const foundCurrency = $scope.country.currency.find((item)=>item.code === newValue);
                    if (foundCurrency) $scope.formData.amount = foundCurrency.defaultDepositAmount;
                });
            }).catch((error)=>console.error(error)).finally(()=>$scope.preloader = false);
        };
        $scope.submit = _helper.form.validator((form)=>{
            $scope.preloader = true;
            accountPreSaveData.set({
                ...accountPreSaveData.get(),
                ...$scope.formData,
                country: $scope.country.code
            });
            _popup.open({
                name: "auth-with-deposit"
            });
        });
        vm.$onDestroy = ()=>{
            accountPreSaveData.set(null);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$e1a1a2d58c77d7fd$exports = {
    "auth-with-deposit": $f9a54d4d4cacf51e$exports
};


var $ce47f921590e13e5$exports = {};
var $5437e2c6bece07ae$exports = {};







(function() {
    controller.$inject = [
        "config",
        "system$",
        "payment",
        "$window",
        "$interval"
    ];
    function controller(_config, _system$, _payment, $window, $interval) {
        let paymentWindow = {};
        return {
            prepared (login = null) {
                if (paymentWindow?.closed === false) return paymentWindow.focus();
                const width = 800;
                const height = 500;
                const left = ($window.innerWidth - width) / 2;
                const top = ($window.innerHeight - height) / 2;
                function messageHandler({ data: data }) {
                    if (data === "close") {
                        paymentWindow.close();
                        paymentWindow = {};
                        return;
                    }
                    if (data === "open-chat") {
                        paymentWindow.close();
                        paymentWindow = {};
                        _system$.next({
                            action: "open chat"
                        });
                        return;
                    }
                }
                $window.onmessage = messageHandler;
                // eslint-disable-next-line angular/interval-service
                const checker = setInterval(()=>{
                    if (paymentWindow.closed) {
                        paymentWindow = {};
                        clearInterval(checker);
                    }
                }, 100);
                paymentWindow = _config.browser.webView ? $window : $window.open(`/preloader.html?login=${login}`, "depositLogin", `height=${height},width=${width},left=${left},top=${top}`);
                return paymentWindow;
            },
            open (login, paymentData, preparedWindow) {
                preparedWindow.focus();
                _payment.deposit({
                    amount: paymentData.amount,
                    paysystem_id: paymentData.paysystem.id,
                    paymethod: paymentData.paysystem.rules.system
                }).then(({ result: { url: url, post: post, method: method } })=>{
                    preparedWindow.document.location = url;
                }).catch((error)=>{
                    preparedWindow.document.location = "/" + _config.currentLang + `/payment/fail?login=${login}`;
                });
            }
        };
    }
    app.factory("paymentWindow", controller);
})();


(function() {
    "use strict";
    const component = {
        name: "authWithDepositLogin"
    };
    controller.$inject = [
        "$scope",
        "$timeout",
        "account",
        "helper",
        "popup",
        "localStorage",
        "authWithDeposit",
        "paymentWindow"
    ];
    function controller($scope, $timeout, _account, _helper, _popup, _localStorage, _authWithDeposit, _paymentWindow) {
        $scope.rememberedLogin = _localStorage.get("rememberedLogin") || false;
        $scope.rememberedAvatar = _localStorage.get("rememberedAvatar") || "";
        $scope.rememberedName = _localStorage.get("rememberedName") || "";
        $scope.preloader = false;
        $scope.credentials = {
            login: $scope.rememberedLogin === false ? undefined : $scope.rememberedLogin
        };
        $scope.resetLoginCredentials = ()=>($scope.credentials.login = "", $scope.rememberedLogin = false);
        const parentScope = $scope.$parent.$parent;
        $scope.backToPayments = ()=>{
            parentScope.paysystemStep = true;
            parentScope.hideLogin = true;
        };
        $scope.switchToRegistration = ()=>{
            parentScope.registrationStep = true;
            parentScope.loginStep = false;
            parentScope.hasRememberedUser = false;
        };
        const login = (form)=>{
            $scope.preloader = true;
            const preSavedData = _authWithDeposit.preSavedData().get();
            let preparedWindow = {};
            const checkIfCanOpenPayment = ()=>{
                const { max_amount: max_amount, min_amount: min_amount, fields: fields } = preSavedData.paysystem;
                const { amount: amount } = preSavedData;
                return !(max_amount < amount || min_amount > amount || fields.length > 0);
            };
            const checkIfValidCurrencyAndCountry = ({ currency: currency, country: country })=>{
                return preSavedData.currency === currency && preSavedData.country === country;
            };
            if (checkIfCanOpenPayment()) {
                preparedWindow = _paymentWindow.prepared();
                const currentWindow = window;
                currentWindow.focus();
            }
            _account.login($scope.credentials).then((answer)=>{
                _popup.close();
                if (!checkIfValidCurrencyAndCountry(answer.result)) {
                    _popup.open({
                        name: "cashbox",
                        content: {
                            loginWarning: true
                        }
                    });
                    preparedWindow.close();
                    return;
                }
                if (!checkIfCanOpenPayment()) {
                    _popup.open({
                        name: "cashbox",
                        content: {
                            tab: "deposit",
                            step: "form",
                            paySystem: preSavedData.paysystem,
                            amount: preSavedData.amount
                        }
                    });
                    preparedWindow.close();
                    return;
                }
                _paymentWindow.open($scope.credentials.login, preSavedData, preparedWindow);
            }).catch((error)=>{
                preparedWindow.close();
                console.error(error);
            }).finally(()=>{
                $timeout(()=>{
                    $scope.preloader = false;
                }, 0);
            });
        };
        $scope.submit = _helper.form.validator(login);
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$ce47f921590e13e5$exports = {
    "auth-with-deposit": $5437e2c6bece07ae$exports
};


var $04bb152fab83c9d6$exports = {};
var $7500cc30e3198d77$exports = {};


(function() {
    "use strict";
    const component = {
        name: "authWithDepositPaysystems"
    };
    controller.$inject = [
        "$scope",
        "paysystem",
        "authWithDeposit"
    ];
    function controller($scope, _paysystem, _authWithDeposit) {
        const vm = this;
        const authBufferData = _authWithDeposit.preSavedData();
        $scope.paymentList = [];
        vm.$onInit = ()=>{
            $scope.preloader = true;
            const config = {
                currency: authBufferData.get().currency,
                country: authBufferData.get().country,
                type: "deposit"
            };
            _paysystem.banking(config).then((answer)=>{
                $scope.paymentList = answer.result.map((item)=>Object.assign(item, {
                        purpose: config.type
                    }));
            }).catch((error)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        $scope.choosePaysystem = (paysystem)=>{
            authBufferData.set({
                ...authBufferData.get(),
                paysystem: paysystem
            });
            const parentScope = $scope.$parent;
            parentScope.paysystemStep = false;
            if (!!parentScope.hasRememberedUser) {
                parentScope.hideLogin = false;
                return parentScope.loginStep = true;
            }
            parentScope.registrationStep = true;
            parentScope.hideRegistartion = false;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$04bb152fab83c9d6$exports = {
    "auth-with-deposit": $7500cc30e3198d77$exports
};


var $6a95a7be9527c364$exports = {};
var $e281b33d228baa06$exports = {};



(function() {
    "use strict";
    const component = {
        name: "authWithDepositPopup"
    };
    controller.$inject = [
        "$scope",
        "contentBuffer",
        "remembered",
        "authWithDeposit"
    ];
    function controller($scope, _contentBuffer, _remembered, _authWithDeposit) {
        const vm = this;
        const content = _contentBuffer.read("popup");
        const preSavedData = _authWithDeposit.preSavedData();
        $scope.hasRememberedUser = !!_remembered.login;
        $scope.depositInfo = preSavedData.get();
        $scope.paysystemStep = true;
        $scope.registrationStep = false;
        $scope.loginStep = false;
        $scope.$watch("paysystemStep", (newVal, oldVal)=>{
            $scope.depositInfo = preSavedData.get();
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$6a95a7be9527c364$exports = {
    "auth-with-deposit": $e281b33d228baa06$exports
};


var $c70bb027dc847ee4$exports = {};
var $aa4c08263bec0ca8$exports = {};









(function() {
    "use strict";
    const component = {
        name: "authWithDepositRegistration"
    };
    controller.$inject = [
        "$scope",
        "account",
        "registration",
        "system",
        "helper",
        "config",
        "modal",
        "popup",
        "authWithDeposit",
        "paymentWindow",
        "$timeout"
    ];
    function controller($scope, _account, _registration, _system, _helper, _config, _modal, _popup, _authWithDeposit, _paymentWindow, $timeout) {
        const vm = this;
        const shouldFetchCountries = _registration.config.countries;
        const cred = {};
        const preSavedData = _authWithDeposit.preSavedData().get();
        let countryOrCurrencyChanged = false;
        let formHasOwnRetype = false;
        $scope.preloader = false;
        $scope.page = 0;
        $scope.currencyList = [];
        $scope.countries = [];
        $scope.country = {};
        $scope.firstSubmit = true;
        $scope.backToPayments = ()=>{
            const parentScope = $scope.$parent.$parent;
            parentScope.paysystemStep = true;
            parentScope.hideRegistartion = true;
        };
        $scope.switchToLogin = ()=>{
            const parentScope = $scope.$parent.$parent;
            parentScope.registrationStep = false;
            parentScope.loginStep = true;
            parentScope.hasRememberedUser = true;
        };
        $scope.formData = {
            currency: preSavedData.currency,
            country: preSavedData.country,
            gender: "M",
            accept: false,
            gdpr_data: false,
            gdpr_marketing: false,
            enable_trigger_codes: preSavedData.enable_trigger_codes,
            phone: ""
        };
        vm.$onInit = ()=>{
            _registration.addAvatarsToScope($scope);
            if (shouldFetchCountries !== false) prepareCountriesAndCurrencies();
            if (!_config.production) Object.assign($scope.formData, _registration.getFakeFormData());
        };
        $scope.nextPage = _helper.form.validator(()=>{
            if (shouldAskGDPR()) askGDPR();
            Object.assign(cred, $scope.formData);
            $scope.page++;
        });
        const prepareCountriesAndCurrencies = ()=>{
            $scope.preloader = true;
            _system.countries().then((answer)=>{
                watchCountryToSetCurrenciesAndPhone();
                $scope.countries = answer.result;
                if (!$scope.formData.country) $scope.formData.country = answer.default;
            }).catch((error)=>console.error(error)).finally(()=>$scope.preloader = false);
        };
        const askGDPR = ()=>{
            $scope.firstSubmit = false;
            _modal.open("gdpr-registration").then(()=>$scope.formData.gdpr_marketing = true).catch(()=>{});
        };
        const setRetype = ()=>{
            if (!$scope.formData.hasOwnProperty("retype")) {
                $scope.formData.retype = $scope.formData.password;
                return;
            }
            formHasOwnRetype = true;
        };
        const clearRetype = ()=>{
            if (!formHasOwnRetype) delete $scope.formData.retype;
        };
        $scope.lastPage = _helper.form.validator((form)=>{
            $scope.preloader = true;
            let preparedWindow = {};
            setRetype();
            const checkIfCanOpenPayment = ()=>{
                const { max_amount: max_amount, min_amount: min_amount, fields: fields } = preSavedData.paysystem;
                const { amount: amount } = preSavedData;
                return !(max_amount < amount || min_amount > amount || fields.length > 0);
            };
            if (checkIfCanOpenPayment() && !countryOrCurrencyChanged) {
                preparedWindow = _paymentWindow.prepared();
                const currentWindow = window;
                currentWindow.focus();
            }
            const preSavedDataPromo = _authWithDeposit.preSavedData().get();
            if (preSavedDataPromo.avatar) $scope.formData.avatar = preSavedDataPromo.avatar;
            Object.assign(cred, $scope.formData);
            if (preSavedDataPromo.enable_trigger_codes) {
                cred.trigger_codes = preSavedDataPromo.trigger_codes;
                (delete cred.code) && preSavedDataPromo.code;
            }
            if (preSavedDataPromo.code) cred.code = preSavedDataPromo.code;
            if (!preSavedDataPromo.enable_trigger_codes && cred.trigger_codes) delete cred.trigger_codes;
            delete cred.enable_trigger_codes;
            if (!preSavedDataPromo.code) delete cred.code;
            if (cred.country !== preSavedData.country || cred.currency !== preSavedData.currency) countryOrCurrencyChanged = true;
            _account.register(cred).then(({ result: { login: login, prefix: prefix } })=>{
                $timeout(()=>{
                    form.$setSuccessful();
                });
                if (countryOrCurrencyChanged) {
                    _popup.open({
                        name: "cashbox",
                        content: {
                            warning: true
                        }
                    });
                    preparedWindow.close();
                    return;
                }
                const preSavedPaysystem = _authWithDeposit.preSavedData().get();
                if (!checkIfCanOpenPayment()) {
                    _popup.open({
                        name: "cashbox",
                        content: {
                            tab: "deposit",
                            step: "form",
                            paySystem: preSavedPaysystem.paysystem,
                            amount: preSavedPaysystem.amount
                        }
                    });
                    preparedWindow.close();
                    return;
                }
                _paymentWindow.open(login, preSavedPaysystem, preparedWindow);
                _popup.close();
            }).catch(()=>{
                preparedWindow.close();
                $scope.page = 1;
                clearRetype();
            }).finally(()=>$scope.preloader = false);
        });
        const watchCountryToSetCurrenciesAndPhone = ()=>{
            $scope.$watch("formData.country", (newVal)=>{
                $scope.country = $scope.countries.filter((item)=>item.code === newVal)[0] || {};
                $scope.currencyList = _registration.prepareCurrencyList($scope.country.currency) || [];
                const userCurrency = $scope.currencyList.find((currency)=>currency.key === preSavedData.currency);
                $scope.formData.currency = userCurrency?.key || $scope.currencyList[0].key;
                if ($scope.formData.phone.length <= 6) $scope.formData.phone = `+${parseInt($scope.country.prefix.replace(/\-/g, ""), 10)}`;
            });
        };
        const shouldAskGDPR = ()=>{
            const GDPRPage = _registration.config.GDPRPage || 1;
            return $scope.firstSubmit === true && $scope.formData.gdpr_marketing === false && GDPRPage === $scope.page;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$c70bb027dc847ee4$exports = {
    "auth-with-deposit": $aa4c08263bec0ca8$exports
};


var $c276cfcbd9b01aa0$exports = {};
var $4accb8d913a19173$exports = {};


(function() {
    "use strict";
    const component = {
        name: "authWithDepositRegistrationBonus"
    };
    controller.$inject = [
        "$scope",
        "registration",
        "$timeout",
        "authWithDeposit"
    ];
    function controller($scope, _registration, $timeout, _authWithDeposit) {
        const vm = this;
        $scope.preloader = false;
        $scope.hasPromocode = false;
        $scope.promocodeLabelFlag = false;
        $scope.formData = {};
        let defaultAvatar;
        const accountPreSaveData = _authWithDeposit.preSavedData();
        vm.$onInit = ()=>{
            _registration.addPromotionsToScope($scope);
            const form = accountPreSaveData.get();
            if (form) {
                if (form.enable_trigger_codes) {
                    $timeout(()=>{
                        $scope.choosePromotion("bonus", form.activePromotionIndex);
                    });
                    return;
                }
                if (!form.enable_trigger_codes && form.code) {
                    $scope.choosePromotion("promo");
                    $scope.formData.code = form.code;
                    $scope.promocodeLabelFlag = true;
                    return;
                }
                if (form.enable_trigger_codes === false && !form.code) {
                    $timeout(()=>{
                        $scope.choosePromotion("without");
                    }, 1);
                    return;
                }
                $scope.choosePromotion("bonus", 0);
            }
        };
        const saveData = (index)=>{
            if ($scope.promotions.length && $scope.promotions[index]?.avatar) $scope.formData.avatar = $scope.promotions[index].avatar;
            if (angular.isUndefined(index) && defaultAvatar) $scope.formData.avatar = defaultAvatar;
            const oldPreSavedData = accountPreSaveData.get();
            accountPreSaveData.set({
                ...oldPreSavedData,
                ...$scope.formData,
                activePromotionIndex: $scope.activePromotionIndex
            });
        };
        $scope.choosePromotion = (type, index)=>{
            switch(type){
                case "bonus":
                    $scope.setActivePromotionByIndex(index);
                    $scope.activePromotionIndex = index;
                    $scope.formData.code = null;
                    $scope.hasPromocode = false;
                    $scope.promocodeLabelFlag = false;
                    $timeout(()=>saveData(index), 0);
                    break;
                case "promo":
                    $scope.hasPromocode = true;
                    $scope.formData.enable_trigger_codes = false;
                    $scope.activePromotion = "";
                    $timeout(()=>saveData(), 0);
                    break;
                case "without":
                    $scope.formData.code = null;
                    $scope.hasPromocode = false;
                    $scope.formData.enable_trigger_codes = false;
                    $scope.activePromotionIndex = null;
                    $scope.activePromotion = "";
                    $scope.promocodeLabelFlag = false;
                    $timeout(()=>saveData(), 0);
                    break;
                default:
                    break;
            }
        };
        vm.$onChanges = ()=>{
            if (this.promoCode) {
                $scope.promocodeLabelFlag = true;
                $scope.formData.code = this.promoCode;
                $scope.choosePromotion("promo");
            }
            if (this.bonusIndex) $scope.choosePromotion("bonus", this.promoCode);
            if (this.defaultAvatar) defaultAvatar = this.defaultAvatar;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            bonusIndex: "<",
            promoCode: "<",
            defaultAvatar: "<"
        }
    });
})();


$c276cfcbd9b01aa0$exports = {
    "auth-with-deposit": $4accb8d913a19173$exports
};


var $1a0c5e5933d4797f$exports = {};
var $881cc372ba4955c7$exports = {};






(function() {
    app.factory("achievement", controller);
    controller.$inject = [
        "http",
        "$q",
        "user",
        "ws$",
        "wsEvents",
        "account"
    ];
    function controller(_http, $q, _user, _ws$, _wsEvents, _account) {
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.achieve)).subscribe(()=>{
            _account.info();
        });
        return {
            take (data) {
                const defer = $q.defer();
                const alias = "achievementTake";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            lastEarned (options) {
                const defer = $q.defer();
                const alias = "achievementLastEarned";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((a)=>{
                    defer.resolve(a.data);
                }, (a)=>{
                    defer.reject(a.data);
                });
                return defer.promise;
            },
            inProgress (options) {
                const defer = $q.defer();
                const alias = "achievementInProgress";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((a)=>{
                    defer.resolve(a.data);
                }, (a)=>{
                    defer.reject(a.data);
                });
                return defer.promise;
            },
            item (params) {
                const defer = $q.defer();
                const alias = "achievementItem";
                const config = {
                    params: params,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then(({ data: data })=>defer.resolve(data)).catch(({ data: data })=>defer.reject(data));
                return defer.promise;
            },
            list (options) {
                const defer = $q.defer();
                const alias = "achievements";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((a)=>{
                    defer.resolve(a.data);
                }, (a)=>{
                    defer.reject(a.data);
                });
                return defer.promise;
            }
        };
    }
})();



(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("achievement$", controller);
})();




(function() {
    controller.$inject = [
        "$scope",
        "achievement",
        "achievement$",
        "system$"
    ];
    function controller($scope, _achievement, _achievement$, _system$) {
        $scope.collection = [];
        $scope.preloader = false;
        $scope.isHideShowMore = false;
        let achievementsCollection;
        let method = "list";
        let page = 1;
        const options = {
            count: undefined
        };
        $scope.showMore = ()=>{
            if (!$scope.isHideShowMore) {
                page += 1;
                getCollection(options.category).then((data)=>{
                    $scope.collection = $scope.collection.concat(data.result);
                    $scope.isHideShowMore = $scope.collection.length >= data.total_count;
                }).catch(()=>{});
            }
        };
        const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>getCollection(options.category).then((data)=>{
                $scope.collection = data.result;
                page = 1;
                $scope.isHideShowMore = $scope.collection.length >= data.total_count;
            }).catch(()=>{}));
        function getCollection(category) {
            if (achievementsCollection) {
                $scope.collection = achievementsCollection;
                return;
            }
            $scope.preloader = true;
            options.page = page;
            options.category = category;
            return _achievement[method](options).then((data)=>{
                const types = options.type.split(",").filter((i)=>i !== "") || [];
                if (types.length) {
                    const result = data.result.filter((item)=>types.includes(item.type));
                    return Object.assign(data, {
                        result: result
                    });
                }
                return data;
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        _achievement$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.action === "take")).subscribe((item)=>{
            if ($scope.collection.find((a)=>a.id === item.achievement.id)) getCollection(options.category).then((data)=>{
                $scope.collection = data.result;
                page = 1;
                $scope.isHideShowMore = $scope.collection.length >= data.total_count;
            }).catch(()=>{});
        });
        this.$onChanges = ()=>{
            options.count = this.count || 25;
            options.sort = this.sort || "";
            options.order = this.order || "";
            options.status = this.status || "";
            options.type = this.type || "";
            options.content_category = this.contentCategory || "";
            achievementsCollection = this.item;
            switch(this.category){
                case "lastEarned":
                    method = "lastEarned";
                    break;
                case "inProgress":
                    method = "inProgress";
                    break;
                default:
                    options.category = this.category;
                    break;
            }
            $scope.$on("$destroy", ()=>{
                subscription.unsubscribe();
            });
            getCollection(options.category).then((data)=>{
                $scope.collection = data.result;
                page = 1;
                $scope.isHideShowMore = $scope.collection.length >= data.total_count;
            }).catch(()=>{});
        };
    }
    new Controller("achievementBox", controller, {
        item: "<",
        category: "<",
        contentCategory: "<",
        count: "<",
        sort: "<",
        order: "<",
        status: "<",
        type: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanAchievementBox${i}`, "achievementBox");
    });
})();


$1a0c5e5933d4797f$exports = {
    "batman": {
        "achievement-box": $881cc372ba4955c7$exports
    }
};


var $d95b5d73d9c1c4e6$exports = {};
$d95b5d73d9c1c4e6$exports = {};


var $96b5453a53536767$exports = {};
$96b5453a53536767$exports = {};


var $15d8f3c132229417$exports = {};
$15d8f3c132229417$exports = {};


var $9655a1b4750aeba2$exports = {};
$9655a1b4750aeba2$exports = {};


var $d94eaee66bcf05d1$exports = {};
$d94eaee66bcf05d1$exports = {};


var $38bfad1a7f84e4ed$exports = {};
var $dec62fa80a686d2a$exports = {};



(function() {
    controller.$inject = [
        "$scope",
        "$timeout",
        "achievement",
        "achievement$",
        "popup"
    ];
    function controller($scope, $timeout, _achievement, _achievement$, _popup) {
        $scope.preloader = false;
        $scope.achievement = {};
        // GET - /achievement/item {id, alias}
        // GET - /achievement/list {category, page, count, etc...}
        // POST - /achievement/take {id, alias}
        $scope.take = ()=>{
            $scope.preloader = true;
            const id = $scope.achievement.id;
            _achievement.take({
                id: id
            }).then((a)=>{
                _achievement$.next({
                    action: "take",
                    achievement: $scope.achievement
                });
            }, (a)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        this.$onChanges = ()=>{
            $scope.achievement = this.item;
        };
    }
    new Controller("achievementItem", controller, {
        item: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanAchievementItem${i}`, "achievementItem");
    });
})();


$38bfad1a7f84e4ed$exports = {
    "batman": {
        "achievement-item": $dec62fa80a686d2a$exports
    }
};


var $524d28f5b4a0e57a$exports = {};
$524d28f5b4a0e57a$exports = {};


var $3215e62e691d3234$exports = {};
var $149f3f59c2bb9e39$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "paysystem"
    ];
    function controller($scope, _paysystem) {
        $scope.collection = [];
        $scope.type = "";
        this.$onChanges = ()=>{
            const config = {};
            if (this.type) {
                config.type = this.type;
                $scope.type = this.type;
            }
            if (this.currency) config.currency = this.currency;
            if (this.country) config.country = this.country;
            if (this.category && config.type === "deposit") config.payment_category = this.category;
            if (config.country && !config.currency) return;
            $scope.preloader = true;
            _paysystem.banking(config).then((a)=>{
                $scope.collection = a.result.map((item)=>Object.assign(item, {
                        purpose: config.type
                    }));
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
    }
    new Controller("bankingBox", controller, {
        type: "<",
        currency: "<",
        country: "<",
        category: "<"
    });
})();
(function() {
    "use strict";
    new Batman("batmanBankingBox1", "bankingBox");
})();
(function() {
    "use strict";
    new Batman("batmanBankingBox2", "bankingBox");
})();
(function() {
    "use strict";
    new Batman("batmanBankingBox3", "bankingBox");
})();


$3215e62e691d3234$exports = {
    "batman": {
        "banking-box": $149f3f59c2bb9e39$exports
    }
};


var $1f4d94175f2adc9c$exports = {};
var $29b9775ff916ba14$exports = {};





(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "system",
        "user$",
        "user",
        "system$"
    ];
    function controller($scope, _system, _user$, _user, _system$) {
        let subscription = null;
        $scope.preloader = false;
        $scope.withdrawType = "withdraw";
        $scope.depositType = "deposit";
        $scope.cryptoType = "crypto";
        $scope.country = null;
        $scope.currency = null;
        $scope.type = $scope.depositType;
        $scope.countries = [];
        $scope.currencies = [];
        this.$onInit = ()=>{
            getCountries();
        };
        function setCountryAndCurrency(countryCode, currencyKey) {
            $scope.country = _user.profile.country || countryCode;
            $scope.currency = _user.profile.currency || currencyKey;
        }
        const prepareCurrencyList = (list)=>list.map(({ code: key, name: name, symbol: icon })=>({
                    key: key,
                    name: name,
                    icon: icon
                }));
        function getCountries() {
            $scope.preloader = true;
            _system.countries().then((answer)=>{
                $scope.countries = answer.result;
                $scope.currencies = prepareCurrencyList(answer.result[0].currency);
                setCountryAndCurrency(answer.default, $scope.currencies[0].key);
            }).catch(()=>{}).finally(()=>$scope.preloader = false);
        }
        $scope.$watch("country", (newVal)=>{
            $scope.countries.filter((item)=>{
                if (item.code === newVal) {
                    $scope.currencies = prepareCurrencyList(item.currency);
                    $scope.currency = _user.profile.currency || $scope.currencies[0].key;
                }
            });
        });
        subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
            setCountryAndCurrency();
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    new Controller("bankingPage", controller);
})();
(function() {
    "use strict";
    new Batman("batmanBankingPage1", "bankingPage");
})();
(function() {
    "use strict";
    new Batman("batmanBankingPage2", "bankingPage");
})();
(function() {
    "use strict";
    new Batman("batmanBankingPage3", "bankingPage");
})();


$1f4d94175f2adc9c$exports = {
    "batman": {
        "banking-page": $29b9775ff916ba14$exports
    }
};


var $010303a95701c806$exports = {};
var $b4f2a025c90841ac$exports = {};




(function() {
    controller.$inject = [
        "$scope",
        "banner",
        "system$",
        "user"
    ];
    function controller($scope, _banner, _system$, _user) {
        $scope.preloader = false;
        $scope.banner = {};
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        let params = {};
        function getBanner(options) {
            $scope.preloader = true;
            _banner.collection(options).then((answer)=>{
                $scope.banner = answer.result?.[0] || {};
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onInit = ()=>{
            params = {
                category: "banner",
                place: this.place,
                out: this.out || ""
            };
            getBanner(params);
            _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "statusChanged")).subscribe(()=>{
                params.auth = _user.status;
                getBanner(params);
            });
        };
        this.$onDestroy = ()=>{
            destroy$.next();
            destroy$.unsubscribe();
        };
    }
    new Controller("banner", controller, {
        place: "<",
        out: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19
    ].forEach((i)=>{
        new Batman(`batmanBanner${i}`, "banner");
    });
})();


$010303a95701c806$exports = {
    "batman": {
        "banner": $b4f2a025c90841ac$exports
    }
};


var $dfb8756b44ea75b1$exports = {};
$dfb8756b44ea75b1$exports = {};


var $ddffb745fa6b3699$exports = {};
$ddffb745fa6b3699$exports = {};


var $171cea5aa13f9e68$exports = {};
$171cea5aa13f9e68$exports = {};


var $e9bf0f0337a9dfcb$exports = {};
$e9bf0f0337a9dfcb$exports = {};


var $4c186b27abd6a423$exports = {};
$4c186b27abd6a423$exports = {};


var $ec0e197cd197544e$exports = {};
$ec0e197cd197544e$exports = {};


var $add6a4337e502c6b$exports = {};
$add6a4337e502c6b$exports = {};


var $b226179899444932$exports = {};
$b226179899444932$exports = {};


var $3d8e1bee9a877bad$exports = {};
$3d8e1bee9a877bad$exports = {};


var $0da55b8e1676b6f6$exports = {};
$0da55b8e1676b6f6$exports = {};


var $1ecaad0ea422a7ef$exports = {};
$1ecaad0ea422a7ef$exports = {};


var $611c8ca126ce46b9$exports = {};
$611c8ca126ce46b9$exports = {};


var $9bfcc7407cc57c01$exports = {};
$9bfcc7407cc57c01$exports = {};


var $83028df528d7a3f4$exports = {};
$83028df528d7a3f4$exports = {};


var $7170155eaaeec616$exports = {};
$7170155eaaeec616$exports = {};


var $402d6b38423ed3e0$exports = {};
$402d6b38423ed3e0$exports = {};


var $65fbabfae40fe087$exports = {};
var $9d46a52a005eb9af$exports = {};

(function() {
    controller.$inject = [
        "$scope",
        "popup",
        "state",
        "bonus"
    ];
    function controller($scope, _popup, _state, _bonus) {
        $scope.bonus = {};
        $scope.successAlias = "";
        $scope.preloader = false;
        $scope.activate = ()=>{
            if (angular.isNumber($scope.bonus.bonus_id)) {
                $scope.preloader = true;
                _bonus.activate($scope.bonus, $scope.successAlias).finally(()=>{
                    $scope.preloader = false;
                });
            }
        };
        $scope.cancel = ()=>{
            if (angular.isNumber($scope.bonus.bonus_id)) {
                $scope.preloader = true;
                _bonus.cancel($scope.bonus).finally(()=>{
                    $scope.preloader = false;
                });
            }
        };
        this.$onChanges = ()=>{
            $scope.bonus = this.bonus;
            $scope.successAlias = this.successAlias;
        };
    }
    new Controller("bonusMoneyItem", controller, {
        bonus: "<",
        successAlias: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanBonusMoneyItem${i}`, "bonusMoneyItem");
    });
})();


$65fbabfae40fe087$exports = {
    "batman": {
        "bonus-money-item": $9d46a52a005eb9af$exports
    }
};


var $293fa0937509c7c3$exports = {};
$293fa0937509c7c3$exports = {};


var $04a60abcb8b7cb40$exports = {};
$04a60abcb8b7cb40$exports = {};


var $7c94a420ab83f408$exports = {};
var $317ef2a92e28a497$exports = {};

(function() {
    controller.$inject = [
        "$scope",
        "bonus"
    ];
    function controller($scope, _bonus) {
        $scope.bonus = {};
        $scope.preloader = false;
        $scope.activate = ()=>{
            if (angular.isNumber($scope.bonus.bonus_id)) {
                $scope.preloader = true;
                _bonus.activate($scope.bonus, $scope.bonus?.game?.alias).finally(()=>{
                    $scope.preloader = false;
                });
            }
        };
        $scope.cancel = ()=>{
            if (angular.isNumber($scope.bonus.bonus_id)) {
                $scope.preloader = true;
                _bonus.cancel($scope.bonus).finally(()=>{
                    $scope.preloader = false;
                });
            }
        };
        this.$onChanges = ()=>{
            $scope.bonus = this.bonus;
        };
    }
    new Controller("bonusSpinItem", controller, {
        bonus: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanBonusSpinItem${i}`, "bonusSpinItem");
    });
})();


$7c94a420ab83f408$exports = {
    "batman": {
        "bonus-spin-item": $317ef2a92e28a497$exports
    }
};


var $295fb684f4ad23d6$exports = {};
$295fb684f4ad23d6$exports = {};


var $638ca3300cc7c21c$exports = {};
$638ca3300cc7c21c$exports = {};


var $ec765a92c3ce9024$exports = {};
var $96cf6dabc2633436$exports = {};

(function() {
    controller.$inject = [
        "$scope",
        "bonus"
    ];
    function controller($scope, _bonus) {
        $scope.bonus = {};
        $scope.successAlias = "";
        $scope.preloader = false;
        $scope.activate = ()=>{
            if (angular.isNumber($scope.bonus.bonus_id)) {
                $scope.preloader = true;
                _bonus.activate($scope.bonus, $scope.successAlias).finally(()=>{
                    $scope.preloader = false;
                });
            }
        };
        $scope.cancel = ()=>{
            if (angular.isNumber($scope.bonus.bonus_id)) {
                $scope.preloader = true;
                _bonus.cancel($scope.bonus).finally(()=>{
                    $scope.preloader = false;
                });
            }
        };
        this.$onChanges = ()=>{
            $scope.bonus = this.bonus;
            $scope.successAlias = this.successAlias;
        };
    }
    new Controller("bonusSportItem", controller, {
        bonus: "<",
        successAlias: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanBonusSportItem${i}`, "bonusSportItem");
    });
})();


$ec765a92c3ce9024$exports = {
    "batman": {
        "bonus-sport-item": $96cf6dabc2633436$exports
    }
};


var $99477d978190c069$exports = {};
$99477d978190c069$exports = {};


var $66022079e6594822$exports = {};
$66022079e6594822$exports = {};


var $b56f233c59fd4e22$exports = {};
var $1275cd0c22a0808b$exports = {};
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanCashCrabPopup${i}`, "cashCrabPopup");
    });
})();


$b56f233c59fd4e22$exports = {
    "batman": {
        "batman-cash-crab-popup": $1275cd0c22a0808b$exports
    }
};


var $5cddc3572d428512$exports = {};
$5cddc3572d428512$exports = {};


var $5bcce460af35ccaf$exports = {};
$5bcce460af35ccaf$exports = {};


var $466cd102a404b1b7$exports = {};
$466cd102a404b1b7$exports = {};


var $e152514f520ad2aa$exports = {};
$e152514f520ad2aa$exports = {};


var $1496d0ea9282411e$exports = {};
$1496d0ea9282411e$exports = {};


var $38c2f420d680e36c$exports = {};
$38c2f420d680e36c$exports = {};


var $43f95ea16fca5782$exports = {};
var $ca560ff3a2cebde2$exports = {};

var $jTg1q = parcelRequire("jTg1q");






(function() {
    "use strict";
    function makeForm(path, params, el) {
        document.getElementById("depositForm")?.remove();
        const form = $document.createElement("form");
        form.setAttribute("method", "POST");
        form.setAttribute("action", path);
        form.setAttribute("id", "depositForm");
        form.setAttribute("target", "depositWindow");
        for(const key in params)if (params.hasOwnProperty(key)) {
            const hiddenField = $document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);
            form.appendChild(hiddenField);
        }
        el.append(form);
        form.submit();
    }
    controller.$inject = [
        "$scope",
        "payment",
        "$element",
        "user",
        "config",
        "helper",
        "system$",
        "modal",
        "$window",
        "$interval"
    ];
    function controller($scope, _payment, $element, _user, _config, _helper, _system$, _modal, $window, $interval) {
        let wnd = {};
        $scope.preloader = false;
        $scope.system = {};
        $scope.formData = {
            amount: 0,
            paymethod: "",
            paysystem_id: "",
            place: ""
        };
        $scope.checkPendingWithdrawals = false;
        $scope.showCryptoPreloader = false;
        $scope.showMinMaxWarning = false;
        const isAmountInRange = (amount, minAmount, maxAmount)=>{
            return minAmount <= amount && amount <= maxAmount;
        };
        this.$onChanges = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($jTg1q))).isObject(this.system) && this.system.name) {
                this.system.rules.showAmount = !this.system.hide_amount;
                $scope.formData.amount = this.system.amount || this.system.rules.default;
                $scope.system = this.system;
                $scope.formData.place = this.place || "cashbox";
                $scope.formData.paymethod = this.system.rules.system;
                $scope.formData.paysystem_id = this.system.id;
                if (this.quick) $scope.formData.tryQuick = true;
                if (this.amount && !isAmountInRange(this.amount, this.system.min_amount, this.system.max_amount)) $scope.showMinMaxWarning = true;
            }
        };
        function close(message) {
            if (message.data === "close") {
                wnd.close();
                wnd = {};
                $scope.showCryptoPreloader = false;
            }
            if (message.data === "open-chat") {
                wnd.close();
                wnd = {};
                _system$.next({
                    action: "open chat"
                });
            }
        }
        $window.onmessage = close;
        function submitForm() {
            $scope.showCryptoPreloader = true;
            if (wnd.focus) {
                if (wnd.closed) {
                    wnd = {};
                    return;
                }
                wnd.focus();
            }
            const w = 800;
            const h = 500;
            const l = ($window.innerWidth - w) / 2;
            const t = ($window.innerHeight - h) / 2;
            const checker = $interval(()=>{
                if (wnd.closed) {
                    wnd = {};
                    $interval.cancel(checker);
                    $scope.showCryptoPreloader = false;
                }
            }, 100);
            wnd = _config.browser.webView ? $window : $window.open(`/preloader.html?login=${_user.profile.login}`, "depositWindow", `height=${h},width=${w},left=${l},top=${t}`);
            $scope.preloader = true;
            _payment.deposit($scope.formData).then((answer)=>{
                $scope.preloader = false;
                if (answer.result.method.toLowerCase() === "post") makeForm(answer.result.url, answer.result.post, $element);
                else wnd.document.location = answer.result.url;
            }).catch(()=>{
                $scope.preloader = false;
                wnd.document.location = "/" + _config.currentLang + `/payment/fail?login=${_user.profile.login}`;
            }).finally(()=>{});
        }
        $scope.submit = _helper.form.validator(()=>{
            if ($scope.checkPendingWithdrawals) {
                _modal.open("cancel-pending-withdrawals").then(()=>{
                    submitForm();
                }).catch(()=>{}).finally(()=>{});
                return;
            }
            submitForm();
        });
    }
    new Controller("cashboxDepositForm", controller, {
        system: "<",
        place: "<",
        quick: "<",
        amount: "<"
    });
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanCashboxDepositForm${i}`, "cashboxDepositForm");
    });
})();


$43f95ea16fca5782$exports = {
    "batman": {
        "cashbox": $ca560ff3a2cebde2$exports
    }
};


var $7f8965bc7497aabc$exports = {};
$7f8965bc7497aabc$exports = {};


var $b879d7231cf8fd03$exports = {};
var $f0546a1aab4e6e84$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "paysystem",
        "$timeout"
    ];
    function controller($scope, _paysystem, $timeout) {
        $scope.preloader = true;
        $scope.collection = [];
        $scope.selected = undefined;
        $scope.selectedId = 0;
        $scope.changing = false;
        let category;
        this.$onInit = ()=>{
            category = this.category || "standard";
            _paysystem.collection({
                type: "deposit",
                payment_category: category
            }).then((answer)=>{
                $scope.collection = answer.result;
                $scope.selected = $scope.collection[0];
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        $scope.setSelected = (selected)=>$scope.selected = selected;
        $scope.$watch("selected", (newVal)=>{
            $scope.changing = true;
            $timeout(()=>{
                $scope.changing = false;
            }, 0);
        });
    }
    new Controller("cashboxDeposit", controller, {
        category: "<"
    });
})();
[
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9
].forEach((i)=>{
    new Batman(`batmanCashboxDeposit${i}`, "cashboxDeposit");
});


$b879d7231cf8fd03$exports = {
    "batman": {
        "cashbox": $f0546a1aab4e6e84$exports
    }
};


var $68edd593aa95b82c$exports = {};
$68edd593aa95b82c$exports = {};


var $59a6e9a713c8b1cd$exports = {};
var $17585bdfe3f1a271$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http"
    ];
    function controller($q, _http) {
        const cancelWithdrawal$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        return {
            cancelWithdrawal$: cancelWithdrawal$,
            cancel (options) {
                const defer = $q.defer();
                const alias = "pWCancel";
                const data = options;
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("withdraw", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "$rootScope",
        "$scope",
        "history",
        "withdraw"
    ];
    function controller($rootScope, $scope, _history, _withdraw) {
        $scope.preloader = false;
        $scope.collection = [];
        $scope.filter = {
            type: "withdraw",
            status: "pending"
        };
        $scope.cancel = (id)=>{
            $scope.preloader = true;
            _withdraw.cancel({
                alias: id
            }).then(()=>{
                $scope.collection = $scope.collection.filter((item)=>{
                    return item.id !== id;
                });
                _withdraw.cancelWithdrawal$.next();
            }).catch(()=>{}).finally(()=>$scope.preloader = false);
        };
        $scope.renew = ()=>{
            const opt = {
                params: $scope.filter,
                endpoint: "payment"
            };
            $scope.preloader = true;
            _history.collection(opt).then(({ result: result })=>{
                $scope.collection = result;
            }).catch(()=>{}).finally(()=>$scope.preloader = false);
        };
        $scope.renew();
        const withdrawEvent = $rootScope.$on("withdraw-new", $scope.renew);
        $scope.$on("$destroy", withdrawEvent);
    }
    new Controller("cashboxWithdrawCancel", controller);
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanCashboxWithdrawCancel${i}`, "cashboxWithdrawCancel");
    });
})();


$59a6e9a713c8b1cd$exports = {
    "batman": {
        "batman-cashbox-withdraw-cancel": $17585bdfe3f1a271$exports
    }
};


var $406074ffc28780c3$exports = {};
$406074ffc28780c3$exports = {};


var $7e8b94b9d5843139$exports = {};
var $df7f1f15a4a077bf$exports = {};
(function() {
    controller.$inject = [
        "$scope",
        "$interval"
    ];
    function controller($scope, $interval) {
        let time = 0;
        let cb;
        let timer;
        $scope.time = time;
        const setTimer = ()=>{
            $interval.cancel(timer);
            timer = $interval(()=>{
                if (time <= 0) {
                    $interval.cancel(timer);
                    if (angular.isFunction(cb)) cb();
                    return;
                }
                time--;
                $scope.time = time;
            }, 1000);
        };
        this.$onChanges = ()=>{
            cb = this.callback;
            time = Math.round(this.start / 1000);
            if (time && time > 0) setTimer();
        };
        this.$onDestroy = ()=>{
            if (timer) $interval.cancel(timer);
        };
    }
    new Controller("countdown", controller, {
        start: "<",
        callback: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanCountdown${i}`, "countdown");
    });
})();


$7e8b94b9d5843139$exports = {
    "batman": {
        "countdown": $df7f1f15a4a077bf$exports
    }
};


var $60f93985f0a2c9f7$exports = {};
$60f93985f0a2c9f7$exports = {};


var $cb29f2a796d99a6e$exports = {};
var $b345862e17c65b82$exports = {};

(function() {
    "use strict";
    const baseClassName = "batman-game-favourites";
    const emptyClassName = `${baseClassName}--empty`; // клас з'являється на блоці, коли немає елементів у collection
    controller.$inject = [
        "$scope",
        "favorites",
        "$element"
    ];
    function controller($scope, _favorites, $element) {
        $scope.collection = [];
        let count = 100;
        let subscription;
        function getCollection() {
            subscription?.unsubscribe();
            subscription = _favorites.collection(count).subscribe((games)=>{
                $element[0].classList.toggle(emptyClassName, games.length === 0);
                $scope.collection = games;
                $scope.total_count = games.length;
            });
        }
        this.$onChanges = ()=>{
            if (this.count !== count) {
                count = this.count || 100;
                getCollection();
            }
        };
        this.$onDestroy = ()=>{
            subscription?.unsubscribe();
        };
    }
    new Controller("gameBoxFavourites", controller, {
        count: "<"
    });
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanGameBoxFavourites${i}`, "gameBoxFavourites");
    });
})();


$cb29f2a796d99a6e$exports = {
    "batman": {
        "game-box-favourites": $b345862e17c65b82$exports
    }
};


var $5d6536e3a3fcfa04$exports = {};
$5d6536e3a3fcfa04$exports = {};


var $0fcc2151be61f5d2$exports = {};
var $269c409a5989048f$exports = {};





(function() {
    controller.$inject = [
        "$scope",
        "$element",
        "game",
        "scroll$",
        "resize$",
        "system$"
    ];
    function controller($scope, $element, _game, _scroll$, _resize$, _system$) {
        $scope.collection = [];
        $scope.preloader = false;
        $scope.content = {};
        $scope.category = null;
        $scope.provider = null;
        $scope.lastPage = false;
        $scope.infiniteScroll = false;
        $scope.total_count = 0;
        let page = 0;
        let loading = false;
        const config = {};
        let skeletonCollection = [];
        let startIndex = 0;
        const defaultGameObject = {
            skeleton: true
        };
        let intersectionObserver = null;
        let answerTimeStamp = null;
        function getCollection(options) {
            if (!loading) {
                loading = true;
                page++;
                options.page = page;
                $scope.preloader = true;
                startIndex = $scope.collection.length;
                $scope.collection = $scope.collection.concat(skeletonCollection);
                _game.collection(options, false).then((answer)=>{
                    $scope.collection.splice(startIndex, skeletonCollection.length, ...answer.result);
                    $scope.lastPage = answer.page >= answer.total_pages;
                    $scope.preloader = false;
                    loading = false;
                    $scope.total_count = answer.total_count;
                    answerTimeStamp = Date.now();
                }).then(()=>{
                    if ($scope.infiniteScroll && !intersectionObserver) observeIntersection();
                    if (skeletonCollection.length > $scope.total_count - $scope.collection.length) skeletonCollection.length = $scope.total_count - $scope.collection.length;
                    if ($scope.lastPage) unobserveIntersection();
                }).catch(()=>{
                    $scope.collection = [];
                    $scope.total_count = 0;
                }).finally(()=>{
                    $scope.preloader = false;
                    loading = false;
                });
            }
        }
        function unobserveIntersection() {
            intersectionObserver?.disconnect();
        }
        function observeIntersection() {
            let element;
            try {
                element = $element[0].querySelector($scope.infiniteScroll);
                if (!element) throw new Error();
            } catch (e) {
                return;
            }
            const callBack = ([entry])=>{
                if (entry.isIntersecting) {
                    const delta = Date.now() - answerTimeStamp;
                    if (delta > 500) getCollection(config);
                }
            };
            intersectionObserver = new IntersectionObserver(callBack);
            intersectionObserver.observe(element);
        }
        this.$onDestroy = ()=>{
            unobserveIntersection();
        };
        this.$onChanges = function() {
            page = 0;
            $scope.collection = [];
            $scope.total_count = 0;
            if (this.skeleton) {
                skeletonCollection = [];
                skeletonCollection.length = this.count || 1;
                skeletonCollection.fill(defaultGameObject, 0, this.count || 1);
            }
            $scope.content = this.content;
            $scope.category = this.category;
            $scope.provider = this.provider;
            $scope.infiniteScroll = this.infiniteScroll || null;
            config.category = this.category;
            config.count = this.count;
            config.brand = this.provider;
            config.out = this.fields;
            config.random = this.random;
            config.tournament = this.tournament;
            getCollection(config);
        };
        $scope.nextPage = function() {
            getCollection(config);
        };
        const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
            getCollection(config);
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    const bindings = {
        category: "<",
        count: "<",
        content: "<",
        provider: "<",
        fields: "<",
        tournament: "<",
        random: "<",
        infiniteScroll: "<",
        skeleton: "<"
    };
    new Controller("gameBox", controller, bindings);
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
    ].forEach((i)=>{
        new Batman(`batmanGameBox${i}`, "gameBox");
    });
})();


$0fcc2151be61f5d2$exports = {
    "batman": {
        "game-box": $269c409a5989048f$exports
    }
};


var $351a07a629858368$exports = {};
$351a07a629858368$exports = {};


var $59be750a5fee6deb$exports = {};
var $f4f0f61078020942$exports = {};
(function() {
    controller.$inject = [
        "$scope",
        "$state"
    ];
    function controller($scope, $state) {
        $scope.name = null;
        this.$onInit = ()=>{
            $scope.name = $state.params.name;
        };
    }
    new Controller("gameHall", controller, {});
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanGameHall${i}`, "gameHall");
    });
})();


$59be750a5fee6deb$exports = {
    "batman": {
        "game-hall": $f4f0f61078020942$exports
    }
};


var $41b6097641d091a1$exports = {};
$41b6097641d091a1$exports = {};


var $29b3fcc86bd39dfb$exports = {};
$29b3fcc86bd39dfb$exports = {};


var $d822dd6f80c3184b$exports = {};
var $e30f77109e66e4a4$exports = {};




(function() {
    const classLib = {
        demo: "linda-has-demo",
        label: "linda-has-label",
        skeleton: "linda-has-skeleton"
    };
    controller.$inject = [
        "$scope",
        "$element",
        "favorites",
        "user",
        "state",
        "system$"
    ];
    function controller($scope, $element, _favorites, _user, _state, _system$) {
        let subscription;
        $scope.game = {};
        $scope.preloader = false;
        $scope.content = "";
        $scope.toggleFavourites = ()=>{
            _favorites.toggle($scope.game);
            _system$.next({
                action: "renew favourite"
            });
        };
        this.$onInit = ()=>{
            subscription = _favorites.collection().subscribe((games)=>{
                if (_favorites.shouldSetFavorite(games, $scope.game)) $scope.game.favorites = true;
                if (_favorites.shouldRemoveFavorite(games, $scope.game)) $scope.game.favorites = false;
            });
        };
        this.$onChanges = function() {
            $scope.content = this.content || "";
            if (this.game) {
                $scope.game = this.game;
                $element[0].classList.toggle(classLib.skeleton, Boolean(this.game.skeleton));
                if (this.game.demo) $element[0].classList.add(classLib.demo);
                if (this.game.label && this.game.label.length) $element[0].classList.add(classLib.label);
            }
        };
        this.$onDestroy = ()=>{
            subscription?.unsubscribe();
        };
    }
    const bindings = {
        game: "<",
        content: "<"
    };
    new Controller("gameItem", controller, bindings);
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanGameItem${i}`, "gameItem");
    });
})();


$d822dd6f80c3184b$exports = {
    "batman": {
        "game-item": $e30f77109e66e4a4$exports
    }
};


var $fef8d730b600022e$exports = {};
$fef8d730b600022e$exports = {};


var $5663e91094a238a7$exports = {};
var $6e17e63f9ecd27e0$exports = {};



(function() {
    controller.$inject = [
        "http",
        "$q",
        "localStorage",
        "$window"
    ];
    app.factory("holiday", controller);
    function controller(_http, $q, _localStorage, $window) {
        let isInitializied = false;
        let activePromos = [];
        const currentDate = getCurrentDate();
        let takenTodayBonus = null;
        const selectedBonus$ = new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)();
        function getCurrentDate() {
            const testDate = $window.localStorage.getItem("test-date") || ""; // yyyy-mm-dd
            return testDate ? +new Date(testDate) : +new Date();
        }
        function isBonusTaken(bonusId, type) {
            return (_localStorage.getObject("holidayBonus")?.[bonusId] === type) ?? false;
        }
        function request(params = {}) {
            const alias = "holidayList";
            const defer = $q.defer();
            const config = {
                params: params,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            _http.get(alias, config).then(({ data: data })=>{
                isInitializied = true;
                // activePromos = data.result.filter((p) => checkIfPromoIsActive(p.promo_start_date, p.close_date));
                activePromos = data.result;
                activePromos = activePromos.map((i)=>groupEvents(i));
                if (activePromos.length) {
                    defer.resolve(activePromos);
                    return;
                }
                if (!data.result.length) _localStorage.remove("holidayBonus");
                defer.reject(data);
            }).catch(()=>{
                defer.reject();
            }).finally(()=>{});
            return defer.promise;
        }
        function setEventDayStatus({ date: date }) {
            const dayInMs = 86400000;
            if (currentDate >= date) {
                if (currentDate - date < dayInMs) return "today";
                if (currentDate - date < 2 * dayInMs) return "yesterday";
                return "previous";
            }
            if (currentDate < date) {
                if (date - currentDate <= dayInMs) return "next";
                return "future";
            }
        }
        function groupEvents(data) {
            const result = data;
            let lastDay = 0;
            result.events = result.events.reduce((collection, event)=>{
                const { type: type } = event;
                if (!collection[type]) collection[type] = [];
                event.dayStatus = setEventDayStatus(event);
                event.isTaken = isBonusTaken(event.id, event.type);
                collection[type].push(event);
                if (event.date > lastDay) lastDay = event.date;
                if (event.isTaken && event.dayStatus === "today") takenTodayBonus = event;
                return collection;
            }, {});
            result.takenTodayBonus = takenTodayBonus;
            result.last_day = lastDay;
            return result;
        }
        const getItem = (item)=>{
            if (isInitializied) return new Promise((resolve, reject)=>{
                const promo = activePromos.find((promoItem)=>promoItem.template === item);
                if (promo) resolve(promo);
                else reject(new Error("No template promotion found"));
            });
            return new Promise((resolve, reject)=>{
                request().then((data)=>{
                    const promo = data.find((promotion)=>promotion.template === item);
                    if (promo) resolve(promo);
                    else reject(new Error("No template promotion found"));
                }).catch((error)=>{
                    reject(error);
                });
            });
        };
        const list = ()=>{
            if (isInitializied) return new Promise((resolve)=>resolve(activePromos));
            return request();
        };
        const saveTakenBonus = (bonusIdentifier, type)=>{
            const bonusList = _localStorage.getObject("holidayBonus") || {};
            bonusList[bonusIdentifier] = type;
            _localStorage.setMapObject("holidayBonus", bonusList);
            isInitializied = false;
            const bonus = activePromos[0].events[type].toObject("id")[bonusIdentifier];
            bonus.isTaken = true;
            selectedBonus$.next(bonus);
        };
        return {
            list: list,
            getItem: getItem,
            getCurrentDate: getCurrentDate,
            saveTakenBonus: saveTakenBonus,
            selectedBonus$: selectedBonus$
        };
    }
})();



(function() {
    controller.$inject = [
        "$scope",
        "holiday",
        "state",
        "$state",
        "config",
        "$document"
    ];
    function controller($scope, _holiday, _state, $state, _config, $document) {
        const currentDate = _holiday.getCurrentDate();
        $scope.preloader = false;
        $scope.holiday = {};
        $scope.currentType = _config.projectType ?? "casino";
        $scope.holidayStatus = "";
        $scope.bonusTypes = [];
        $scope.currentIndex = null;
        $scope.timer = null;
        $scope.selectedBonus = null;
        const classOnBody = "is-easter";
        const classOnBodyIsAnim = "is-anim";
        const dayInMs = 86400000;
        const promoAlias = $state.params.name;
        // let promoAlias = 'world-cup';
        const subscription = _holiday.selectedBonus$.subscribe((bonus)=>{
            $scope.selectedBonus = bonus;
        });
        this.$onInit = function() {
            $scope.preloader = true;
            $document.body.classList.add(classOnBody);
            _holiday.getItem(promoAlias).then((result)=>{
                $scope.holiday = result;
                $scope.bonusTypes = Object.keys($scope.holiday.events);
                $scope.selectedBonus = result.takenTodayBonus;
                $scope.holidayStatus = setHolidayStatus();
                setDataIfTodayBonusExists();
            }).catch(()=>{
            // _state.goto('home');
            }).finally(()=>{
                $scope.preloader = false;
            });
        };
        // todo fix it, can't be reusable
        this.$onDestroy = function() {
            $document.body.classList.remove(classOnBody, classOnBodyIsAnim);
            subscription.unsubscribe();
        };
        function setHolidayStatus() {
            const start = $scope.holiday.active_date;
            const end = $scope.holiday.last_day + dayInMs;
            if (currentDate < start) return "soon";
            if (currentDate >= end) return "over";
            return "progress";
        }
        function setDataIfTodayBonusExists() {
            $scope.holiday.events[$scope.currentType].forEach((bonus, index)=>{
                if (bonus.dayStatus !== "today") return;
                $scope.currentIndex = index;
                $scope.timer = bonus.date + dayInMs - currentDate;
            });
        }
        $scope.setCurrentType = (type)=>$scope.currentType = type;
        $scope.setSelectedBonus = (bonus)=>$scope.selectedBonus = bonus;
        $scope.unsetSelectedBonus = ()=>$scope.selectedBonus = null;
        $scope.takeBonus = (id, type)=>{
            _holiday.saveTakenBonus(id, type);
            $scope.selectedBonus = $scope.holiday.events[type].toObject("id")[id];
            $document.body.classList.add(classOnBodyIsAnim);
        };
    }
    new Controller("holidaysCalendar", controller, {});
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanHolidaysCalendar${i}`, "holidaysCalendar");
    });
})();


$5663e91094a238a7$exports = {
    "batman": {
        "batman-holidays": $6e17e63f9ecd27e0$exports
    }
};


var $9b022edc347c67e2$exports = {};
var $37915090161ea7b1$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        return {
            collection (options) {
                const defer = $q.defer();
                const alias = "icons";
                const config = {
                    params: options,
                    cache: true,
                    meta: {
                        cache: true,
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("icon", controller);
})();


(function() {
    controller.$inject = [
        "$scope",
        "icon"
    ];
    function controller($scope, _icon) {
        $scope.collection = [];
        $scope.preloader = false;
        function getCollection(o) {
            $scope.preloader = true;
            _icon.collection(o).then((a)=>{
                $scope.collection = a.result;
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = ()=>{
            const config = {};
            config.category = this.category;
            config.count = this.count || 25;
            getCollection(config);
        };
    }
    new Controller("iconBox", controller, {
        category: "<",
        count: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanIconBox${i}`, "iconBox");
    });
})();


$9b022edc347c67e2$exports = {
    "batman": {
        "icon-box": $37915090161ea7b1$exports
    }
};


var $4ecc47bb4aebbefd$exports = {};
$4ecc47bb4aebbefd$exports = {};


var $82791d6b6208b356$exports = {};
$82791d6b6208b356$exports = {};


var $f2d5aebb40e78eae$exports = {};
var $aeec26c86b95cc9e$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "$state",
        "page",
        "$sce"
    ];
    function controller($scope, $state, _page, $sce) {
        $scope.page = "";
        $scope.preloader = false;
        function getInfoPage(name) {
            $scope.preloader = true;
            _page.item({
                name: name
            }).then((answer)=>{
                $scope.page = $sce.trustAsHtml(answer.result.content);
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = function() {
            const name = this.name || $state.params.name || "";
            if (name !== "") getInfoPage(name);
        };
    }
    new Controller("infoPage", controller, {
        name: "<"
    });
})();
[
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9
].forEach((i)=>{
    new Batman(`batmanInfoPage${i}`, "infoPage");
});


$f2d5aebb40e78eae$exports = {
    "batman": {
        "info-page": $aeec26c86b95cc9e$exports
    }
};


var $b11991822375af6b$exports = {};
var $2e253a484386f30e$exports = {};
(function() {
    new Controller("modalWrapper");
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanModalWrapper${i}`, "modalWrapper");
    });
})();


$b11991822375af6b$exports = {
    "batman": {
        "modal-wrapper": $2e253a484386f30e$exports
    }
};


var $20e98d2a19a54412$exports = {};
$20e98d2a19a54412$exports = {};


var $6a113327baab3778$exports = {};
$6a113327baab3778$exports = {};


var $75492f3d25fc86aa$exports = {};
$75492f3d25fc86aa$exports = {};


var $77afc43ccb8a2170$exports = {};
var $4c574ee1970e1b5f$exports = {};
(function() {
    new Controller("popupWrapper");
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ].forEach((i)=>{
        new Batman(`batmanPopupWrapper${i}`, "popupWrapper");
    });
})();


$77afc43ccb8a2170$exports = {
    "batman": {
        "popup-wrapper": $4c574ee1970e1b5f$exports
    }
};


var $af97348fa7ae5611$exports = {};
$af97348fa7ae5611$exports = {};


var $a235e5d6f87aa90b$exports = {};
$a235e5d6f87aa90b$exports = {};


var $5f361e5f96e8ca56$exports = {};
$5f361e5f96e8ca56$exports = {};


var $1f7894f467d5e6ff$exports = {};
$1f7894f467d5e6ff$exports = {};


var $7ee9c57dd8875914$exports = {};
$7ee9c57dd8875914$exports = {};


var $4f0f7734965d0002$exports = {};
$4f0f7734965d0002$exports = {};


var $6d6b58f6e0667fc3$exports = {};
$6d6b58f6e0667fc3$exports = {};


var $6c8d80d88e74e89a$exports = {};
$6c8d80d88e74e89a$exports = {};


var $104533c459150155$exports = {};
$104533c459150155$exports = {};


var $b482d7f12d4c54e6$exports = {};
$b482d7f12d4c54e6$exports = {};


var $f2e292866c684686$exports = {};
$f2e292866c684686$exports = {};


var $f09ab08f3910240a$exports = {};
var $04529f8fb3463c41$exports = {};






(function() {
    controller.$inject = [
        "$scope",
        "promo",
        "system$",
        "platform",
        "ws$",
        "wsEvents"
    ];
    function controller($scope, _promo, _system$, _platform, _ws$, _wsEvents) {
        $scope.promo = {};
        function getPromoItem(params) {
            $scope.preloader = true;
            _promo.item(params).then(({ result: result })=>{
                $scope.promo = result;
                _platform.version().then((version)=>{
                    if (version === 2) $scope.promo.bonusSteps = removeNoActionAlias(result.bonusSteps);
                    if (version === 3) $scope.promo.bonus_steps = removeNoActionAlias(result.bonus_steps);
                });
                getOptInData(result);
            }).finally(()=>{
                $scope.preloader = false;
            });
        }
        const getOptInData = (promo)=>{
            $scope.isDepositDone = promo.requiredActions?.some((item)=>item.type === "DEPOSIT" && item.isActionDone);
            const requiredAction = promo.requiredActions?.find((item)=>item.type !== "OPT_IN" && !item.isActionDone);
            if (requiredAction) {
                $scope.startDate = requiredAction.startDate || null;
                $scope.timerCounter = new Date(requiredAction.startDate).getTime() - Date.now();
                $scope.isPromoStartSoon = new Date(requiredAction.startDate) >= Date.now();
            }
        };
        const removeNoActionAlias = (steps)=>steps.map((step)=>{
                if (step.alias !== "no_action") return step;
                return {
                    ...step,
                    alias: null
                };
            });
        const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
            if (this.item?.requiredActions) getPromoItem({
                name: this.item.name
            });
        });
        const wsPromoSubscription = _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.bonusIssue)).subscribe(()=>{
            if (this.name && this.name.length) getPromoItem({
                name: this.name
            });
        });
        this.$onDestroy = ()=>{
            wsPromoSubscription.unsubscribe();
            subscription.unsubscribe();
        };
        this.$onChanges = ()=>{
            if (this.name && this.name.length) {
                getPromoItem({
                    name: this.name
                });
                return;
            }
            $scope.promo = this.item || {};
        };
    }
    new Controller("promoItem", controller, {
        item: "<",
        name: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanPromoItem${i}`, "promoItem");
    });
})();


$f09ab08f3910240a$exports = {
    "batman": {
        "promo-item": $04529f8fb3463c41$exports
    }
};


var $6fd578c1da9d16f9$exports = {};
$6fd578c1da9d16f9$exports = {};


var $250b2581bc4898f4$exports = {};
$250b2581bc4898f4$exports = {};


var $780a5304db1b3a32$exports = {};
$780a5304db1b3a32$exports = {};


var $eacfc8afb1ee6d7e$exports = {};
$eacfc8afb1ee6d7e$exports = {};


var $882de181b5ab8c94$exports = {};
var $ed053a871dd5823d$exports = {};








(function() {
    controller.$inject = [
        "$scope",
        "promo",
        "system$",
        "promo$",
        "promoListUpdated$",
        "ws$",
        "wsEvents"
    ];
    function controller($scope, _promo, _system$, _promo$, _promoListUpdated$, _ws$, _wsEvents) {
        $scope.collection = [];
        const options = {};
        function getPromo() {
            $scope.preloader = true;
            _promo.list(options).then((answer)=>{
                $scope.collection = answer.result;
            }).finally(()=>{
                $scope.preloader = false;
                _promoListUpdated$.next();
            });
        }
        this.$onChanges = function() {
            $scope.preloader = true;
            if (this.category && this.category.length) options.category = this.category;
            if (this.codes && this.codes.length) options.trigger_codes = this.codes;
            if (this.count) options.count = this.count;
            if (this.status) options.status = this.status;
            getPromo();
        };
        const subscription = (0, $baeef3ef689dc439$export$4950aa0f605343fb)(_promo$, _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")), _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.bonusIssue))).subscribe(()=>{
            getPromo();
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    new Controller("promoList", controller, {
        category: "<",
        count: "<",
        codes: "<",
        status: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanPromoList${i}`, "promoList");
    });
})();


$882de181b5ab8c94$exports = {
    "batman": {
        "promo-list": $ed053a871dd5823d$exports
    }
};


var $be32fd67708d1f51$exports = {};
$be32fd67708d1f51$exports = {};


var $0974df8795a1e7d2$exports = {};
$0974df8795a1e7d2$exports = {};


var $25e6dccf2616f315$exports = {};
$25e6dccf2616f315$exports = {};


var $3a5927edb06befc3$exports = {};
$3a5927edb06befc3$exports = {};


var $db75f2a4aa31c0e3$exports = {};
$db75f2a4aa31c0e3$exports = {};


var $c7678ad49142c36f$exports = {};
$c7678ad49142c36f$exports = {};


var $29511dd8add12289$exports = {};
$29511dd8add12289$exports = {};


var $2f9f7cae98e08b18$exports = {};
var $35a0d362a94d2a57$exports = {};

(function() {
    controller.$inject = [
        "$scope",
        "game"
    ];
    function controller($scope, _game) {
        $scope.collection = [];
        $scope.total_count = 0;
        $scope.preloader = false;
        this.$onChanges = ()=>{
            $scope.preloader = true;
            const count = this.count || 24;
            _game.recentlyPlayed({
                count: count
            }).then((a)=>{
                const excludedCollectionsByAlias = [
                    "sport",
                    "sport-latrobet"
                ];
                $scope.collection = a.result.filter((item)=>!excludedCollectionsByAlias.includes(item.alias));
                $scope.total_count = a.total_count;
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
    }
    new Controller("recentlyPlayedList", controller, {
        count: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanRecentlyPlayedList${i}`, "recentlyPlayedList");
    });
})();


$2f9f7cae98e08b18$exports = {
    "batman": {
        "recently-played-list": $35a0d362a94d2a57$exports
    }
};


var $819d42b20c55e497$exports = {};
$819d42b20c55e497$exports = {};


var $a32f9e28b26b68d8$exports = {};
$a32f9e28b26b68d8$exports = {};


var $91d28261bb6bd04d$exports = {};
var $ba45b44963f4bb24$exports = {};








(function() {
    "use strict";
    app.factory("birthdayDatepicker", controller);
    function controller() {
        const calculateAdultAge = (age)=>{
            const timestampAdultAge = new Date().setFullYear(new Date().getFullYear() - age);
            return new Date(timestampAdultAge);
        };
        const minDateValue = "1900-01-01";
        const maxDateValue = calculateAdultAge(18).toISOString().split("T")[0];
        return {
            minDateValue: minDateValue,
            maxDateValue: maxDateValue
        };
    }
})();


(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "registration",
        "system",
        "config",
        "helper",
        "modal",
        "account",
        "state",
        "popup",
        "birthdayDatepicker",
        "$timeout"
    ];
    function controller($scope, _registration, _system, _config, _helper, _modal, _account, _state, _popup, _birthdayDatepicker, $timeout) {
        const vm = this;
        const shouldFetchCountries = _registration.config.countries;
        const cred = {};
        let formHasOwnRetype = false;
        $scope.preloader = false;
        $scope.page = 0;
        $scope.currencyList = [];
        $scope.countries = [];
        $scope.country = {};
        $scope.firstSubmit = true;
        $scope.formData = {
            currency: "",
            country: "",
            gender: "M",
            accept: false,
            gdpr_data: false,
            gdpr_marketing: false,
            enable_trigger_codes: true,
            phone: ""
        };
        $scope.datepickerOptions = {
            minDate: _birthdayDatepicker.minDateValue,
            maxDate: _birthdayDatepicker.maxDateValue
        };
        vm.$onInit = ()=>{
            _registration.addPromotionsToScope($scope);
            _registration.addAvatarsToScope($scope);
            if (shouldFetchCountries !== false) prepareCountriesAndCurrencies();
            if (!_config.production) Object.assign($scope.formData, _registration.getFakeFormData());
            if (typeof $_GET.email !== "undefined") $scope.formData.email = $_GET.email;
        };
        $scope.nextPage = _helper.form.validator(()=>{
            if (shouldAskGDPR()) askGDPR();
            Object.assign(cred, $scope.formData);
            $scope.page++;
        });
        $scope.lastPage = _helper.form.validator((form)=>{
            $scope.preloader = true;
            setRetype();
            Object.assign(cred, $scope.formData);
            if (cred.enable_trigger_codes !== true) delete cred.trigger_codes;
            delete cred.enable_trigger_codes;
            _account.register(cred).then(({ result: { login: login, prefix: prefix } })=>{
                if (login) _registration.marketing(login, prefix);
                _state.readyToRedirectAfterAuth$.next();
                if (angular.isFunction(_popup.cb)) {
                    _popup.cb();
                    _popup.cb = null;
                }
                $timeout(()=>{
                    form.$setSuccessful();
                });
            }).catch(()=>{
                $scope.page = 1;
                clearRetype();
            }).finally(()=>$scope.preloader = false);
        });
        const askGDPR = ()=>{
            $scope.firstSubmit = false;
            _modal.open("gdpr-registration").then(()=>$scope.formData.gdpr_marketing = true).catch(()=>{});
        };
        const setRetype = ()=>{
            if (!$scope.formData.hasOwnProperty("retype")) {
                $scope.formData.retype = $scope.formData.password;
                return;
            }
            formHasOwnRetype = true;
        };
        const clearRetype = ()=>{
            if (!formHasOwnRetype) delete $scope.formData.retype;
        };
        const prepareCountriesAndCurrencies = ()=>{
            $scope.preloader = true;
            _system.countries().then((answer)=>{
                watchCountryToSetCurrenciesAndPhone();
                $scope.countries = answer.result;
                if (!$scope.formData.country) $scope.formData.country = answer.default;
            }).catch((error)=>console.error(error)).finally(()=>$scope.preloader = false);
        };
        const watchCountryToSetCurrenciesAndPhone = ()=>{
            $scope.$watch("formData.country", (newVal)=>{
                $scope.country = $scope.countries.filter((item)=>item.code === newVal)[0] || {};
                $scope.currencyList = _registration.prepareCurrencyList($scope.country.currency) || [];
                $scope.formData.currency = $scope.currencyList[0].key;
                if ($scope.formData.phone.length <= 6) $scope.formData.phone = `+${parseInt($scope.country.prefix.replace(/\-/g, ""), 10)}`;
            });
        };
        const shouldAskGDPR = ()=>{
            const GDPRPage = _registration.config.GDPRPage || 1;
            return $scope.firstSubmit === true && $scope.formData.gdpr_marketing === false && GDPRPage === $scope.page;
        };
    }
    new Controller("batman-registration", controller, {});
})();
(function() {
    "use strict";
    new Batman("batmanRegistration1", "batman-registration");
})();


$91d28261bb6bd04d$exports = {
    "batman": {
        "registration": $ba45b44963f4bb24$exports
    }
};


var $a7b647a6af2c9427$exports = {};
var $812713c7e2a4c0a8$exports = {};



(function() {
    controller.$inject = [
        "$scope",
        "banner",
        "$timeout",
        "system$"
    ];
    function controller($scope, _banner, $timeout, _system$) {
        $scope.collection = [];
        $scope.preloader = false;
        $scope.transition = false;
        let subscription1;
        let subscription2;
        const o = {};
        this.$onInit = ()=>{
            o.category = "slider";
            o.place = this.place;
            getCollection(o);
            subscription1 = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "login")).subscribe((m)=>{
                o.auth = true;
                getCollection(o);
            });
            subscription2 = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.action === "logout")).subscribe((m)=>{
                o.auth = false;
                getCollection(o);
            });
        };
        this.$onDestroy = ()=>{
            subscription1.unsubscribe();
            subscription2.unsubscribe();
        };
        $scope.getCurrent = (event, slick, currentSlide, nextSlide)=>{
            $scope.current = nextSlide;
            $scope.transition = true;
            $timeout(()=>{
                $scope.transition = false;
            }, 600);
        };
        function getCollection(c) {
            $scope.current = 0;
            $scope.loaded = false;
            $scope.preloader = true;
            _banner.collection(c).then((answer)=>{
                $scope.collection = answer.result;
                $scope.loaded = true;
                $scope.preloader = false;
            }, (answer)=>{
                $scope.preloader = false;
            });
        }
    }
    new Controller("slider", controller, {
        place: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSlider${i}`, "slider");
    });
})();


$a7b647a6af2c9427$exports = {
    "batman": {
        "slider": $812713c7e2a4c0a8$exports
    }
};


var $3c684673e4941080$exports = {};
$3c684673e4941080$exports = {};


var $c2bf028d55972de5$exports = {};
var $647cf2c4ef611268$exports = {};



(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("sportCards$", controller);
})();


(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "sportCards$"
    ];
    function controller(_http, $q, _sportCards$) {
        const card = {
            list (options) {
                const defer = $q.defer();
                const alias = "sportCard";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            open (options) {
                const defer = $q.defer();
                const alias = "sportCard";
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, options, config).then((answer)=>{
                    _sportCards$.next({
                        target: "card",
                        event: "open",
                        data: answer.data.result
                    });
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
        return card;
    }
    app.factory("card", controller);
})();






(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "user",
        "card",
        "popup",
        "modal",
        "state",
        "remembered"
    ];
    function controller($scope, _user, _card, _popup, _modal, _state, _remembered) {
        $scope.preloader = false;
        $scope.card = {};
        $scope.open = function() {
            let team = {};
            if (!_user.status) {
                const rememberedLogin = _remembered.login;
                if (!rememberedLogin) return _state.goto("registration");
                return _state.goto("login");
            }
            if (_user.profile.coins >= $scope.card.price) _modal.open("sport-card-open", $scope.card).then(()=>{
                $scope.preloader = true;
                _card.open({
                    alias: $scope.card.alias
                }).then((a)=>{
                    $scope.card.status = a?.card?.status || "open";
                    team = a.result.find((item)=>item.alias === $scope.card.team.alias);
                    if (team.progress.general === 100 || team.progress.current === 0) {
                        _popup.open({
                            name: "sport-cards-complete-team",
                            content: team
                        });
                        return;
                    }
                    if (a.card.rewards && a.card.rewards.length) _popup.open({
                        name: "autobonus-action",
                        content: a.card.rewards[0].bonuses
                    });
                }).catch((e)=>{}).finally(()=>{
                    $scope.preloader = false;
                });
            }).catch(()=>{});
            else _popup.open({
                name: _user.profile.coins === 0 ? "sport-cards-no-points-already" : "sport-cards-points-missing",
                content: $scope.card
            });
        };
        this.$onChanges = function() {
            $scope.card = this.card;
        };
    }
    const bindings = {
        card: "<"
    };
    new Controller("sportCardItem", controller, bindings);
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSportCardItem${i}`, "sportCardItem");
    });
})();


$c2bf028d55972de5$exports = {
    "batman": {
        "sport-card-item": $647cf2c4ef611268$exports
    }
};


var $c7f94387ea1860d0$exports = {};
var $87204c2c78f52760$exports = {};


(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "card",
        "sportCards$"
    ];
    function controller($scope, _card, _sportCards$) {
        $scope.collection = [];
        $scope.preloader = false;
        $scope.category = "";
        let subscription;
        function getCard(options) {
            $scope.preloader = true;
            _card.list(options).then((a)=>{
                $scope.collection = a.result;
                $scope.card = options.alias ? a.result[0] : null;
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = function() {
            const config = {};
            $scope.category = this.category;
            config.team = this.team;
            config.squad = this.squad;
            config.alias = this.alias;
            config.category = this.category;
            config.type = this.type;
            config.status = this.status;
            getCard(config);
        };
    }
    const bindings = {
        team: "<",
        squad: "<",
        alias: "<",
        category: "<",
        type: "<",
        status: "<"
    };
    new Controller("sportCardList", controller, bindings);
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSportCardList${i}`, "sportCardList");
    });
})();


$c7f94387ea1860d0$exports = {
    "batman": {
        "sport-card-list": $87204c2c78f52760$exports
    }
};


var $f6b3130752fd89e3$exports = {};
var $2a446ba9b2d78f44$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        const squad = {
            list (options) {
                const defer = $q.defer();
                const alias = "sportSquad";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
        return squad;
    }
    app.factory("squad", controller);
})();




(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "squad",
        "sportCards$"
    ];
    function controller($scope, _squad, _sportCards$) {
        $scope.collection = [];
        $scope.preloader = false;
        let subscription;
        function getSquad(options) {
            $scope.preloader = true;
            _squad.list(options).then((a)=>{
                $scope.collection = a.result;
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = function() {
            const config = {};
            config.team = this.team;
            if (config.team) getSquad(config);
            subscription = _sportCards$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.target === "card" && m.event === "open")).subscribe((m)=>{
                if (config.team) getSquad(config);
            });
        };
        this.$onDestroy = function() {
            subscription.unsubscribe();
        };
    }
    const bindings = {
        team: "<"
    };
    new Controller("sportSquadList", controller, bindings);
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSportSquadList${i}`, "sportSquadList");
    });
})();


$f6b3130752fd89e3$exports = {
    "batman": {
        "sport-squad-list": $2a446ba9b2d78f44$exports
    }
};


var $488d739d8aa9a086$exports = {};
var $9437988f3c1a4c91$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "team",
        "sportCards$"
    ];
    function controller($scope, _team, _sportCards$) {
        $scope.team = {};
        $scope.preloader = false;
        let subscription;
        function getTeam(options) {
            $scope.preloader = true;
            _team.item(options).then((a)=>{
                $scope.team = a.result[0];
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = function() {
            const config = {};
            config.alias = this.alias;
            if (this.alias) getTeam(config);
            else if (this.team) $scope.team = this.team;
        // todo add functional for stars
        // $scope.stars = $scope.team.current === 100 ? $scope.team.progress.squads.current : $scope.team.progress.squads.current - 1;
        };
        this.$onInit = function() {
            subscription = _sportCards$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.target === "card" && m.event === "open")).subscribe((m)=>{
                $scope.team = m.data.find((team)=>$scope.team.alias === team.alias);
            });
        };
        this.$onDestroy = function() {
            subscription.unsubscribe();
        };
    }
    const bindings = {
        alias: "<",
        team: "<"
    };
    new Controller("sportTeamItem", controller, bindings);
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSportTeamItem${i}`, "sportTeamItem");
    });
})();


$488d739d8aa9a086$exports = {
    "batman": {
        "sport-team-item": $9437988f3c1a4c91$exports
    }
};


var $ceb68ce7865ba3e2$exports = {};
$ceb68ce7865ba3e2$exports = {};


var $e2cd69c261d4ee78$exports = {};
var $31e6752126894e30$exports = {};




(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "team",
        "sportCards$",
        "system$"
    ];
    function controller($scope, _team, _sportCards$, _system$) {
        $scope.collection = [];
        $scope.preloader = false;
        $scope.category = "";
        let subscription;
        let authorizationSubscription;
        function getTeam(options) {
            $scope.preloader = true;
            _team.list(options).then(({ result: result })=>{
                const sortedByOrder = result.sort((a, b)=>a.team_order - b.team_order);
                const sortedByProgress = sortedByOrder.sort((item1, item2)=>item2.progress.general - item1.progress.general);
                $scope.collection = sortedByProgress;
                if (options.alias) $scope.team = result[0];
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = function() {
            const config = {};
            $scope.category = this.category;
            config.category = this.category;
            config.order = this.orderby;
            config.status = this.status;
            getTeam(config);
            subscription = _sportCards$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m.target === "card" && m.event === "open")).subscribe((m)=>{
                $scope.collection = m.data;
            });
            authorizationSubscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe((message)=>{
                getTeam(config);
            });
        };
        this.$onDestroy = function() {
            subscription.unsubscribe();
            authorizationSubscription.unsubscribe();
        };
    }
    const bindings = {
        category: "<",
        orderby: "<",
        status: "<"
    };
    new Controller("sportTeamList", controller, bindings);
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSportTeamList${i}`, "sportTeamList");
    });
})();


$e2cd69c261d4ee78$exports = {
    "batman": {
        "sport-team-list": $31e6752126894e30$exports
    }
};


var $43a468c58f2684e0$exports = {};
var $76a2a7f60470e45c$exports = {};



(function() {
    controller.$inject = [
        "$scope",
        "tournament",
        "$state",
        "system$"
    ];
    function controller($scope, _tournament, $state, _system$) {
        const tournamentName = $state.params.name;
        $scope.tournament = {
            name: tournamentName
        };
        const config = {
            name: this.name,
            params: {
                max_members: this.members
            }
        };
        function getTournamentItem(params) {
            $scope.preloader = true;
            _tournament.item(params).then(({ result: result })=>{
                $scope.tournament = result;
            }).catch(()=>{}).finally(()=>{
                $scope.$evalAsync(()=>$scope.preloader = false);
            });
        }
        this.$onChanges = ()=>{
            config.params.max_members = this.members;
            config.name = this.name;
            if (this.name?.length) getTournamentItem(config);
            else $scope.tournament = this.item || {};
        };
        const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "statusChanged")).subscribe(()=>{
            getTournamentItem(config);
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    new Controller("tournamentItem", controller, {
        item: "<",
        name: "<",
        members: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanTournamentItem${i}`, "tournamentItem");
    });
})();


$43a468c58f2684e0$exports = {
    "batman": {
        "tournament-item": $76a2a7f60470e45c$exports
    }
};


var $dfbd87ec18a21590$exports = {};
$dfbd87ec18a21590$exports = {};


var $24e4457676f34526$exports = {};
$24e4457676f34526$exports = {};


var $e4e6c6bd3ea8291d$exports = {};
$e4e6c6bd3ea8291d$exports = {};


var $7c0b0ec616f4d3a2$exports = {};
$7c0b0ec616f4d3a2$exports = {};


var $c5b1754f4f544222$exports = {};
$c5b1754f4f544222$exports = {};


var $ab62a27380b1ba24$exports = {};
$ab62a27380b1ba24$exports = {};


var $7ad2639591ef993c$exports = {};
$7ad2639591ef993c$exports = {};


var $c9f48ebaf4546407$exports = {};
var $d3e4bf6d0fd4f9d5$exports = {};

(function() {
    controller.$inject = [
        "$scope",
        "tournament"
    ];
    function controller($scope, _tournament) {
        $scope.collection = [];
        $scope.casinoTournaments = [];
        $scope.futureCollection = [];
        $scope.activeCollection = [];
        $scope.pastCollection = [];
        this.$onChanges = function() {
            $scope.preloader = true;
            const options = {};
            if (this.category && this.category.length) options.category = this.category;
            options.showPlayersInfo = this.players;
            options.max_members = this.competitors;
            _tournament.list(options).then((answer)=>{
                $scope.collection = answer.result;
                $scope.casinoTournaments = answer.result.filter((tournament)=>tournament.sport != true);
                $scope.futureCollection = answer.result.filter((tournament)=>tournament.status === 0 && tournament.sport != true);
                $scope.activeCollection = answer.result.filter((tournament)=>tournament.status === 1 && tournament.sport != true);
                $scope.pastCollection = answer.result.filter((tournament)=>tournament.status === 2 && tournament.sport != true);
                // - add this scopes in https://jira.gosystem.io/browse/GREAT-9100
                $scope.activeSportCollection = answer.result.filter((tournament)=>tournament.status === 1 && tournament.sport == true);
                $scope.pastSportCollection = answer.result.filter((tournament)=>tournament.status === 2 && tournament.sport == true);
            }).finally(()=>{
                $scope.preloader = false;
            });
        };
    }
    new Controller("tournamentList", controller, {
        category: "<",
        players: "<",
        competitors: "<"
    });
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanTournamentList${i}`, "tournamentList");
    });
})();


$c9f48ebaf4546407$exports = {
    "batman": {
        "tournament-list": $d3e4bf6d0fd4f9d5$exports
    }
};


var $cea64af1d25320f7$exports = {};
$cea64af1d25320f7$exports = {};


var $4369998fb658afa4$exports = {};
var $e332cefd1c28b74f$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {}
    new Controller("uiWrapper", controller, {});
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanUiWrapper${i}`, "uiWrapper");
    });
})();


$4369998fb658afa4$exports = {
    "batman": {
        "ui-wrapper": $e332cefd1c28b74f$exports
    }
};


var $d0bb70554030eefa$exports = {};
var $49a9eb5968472552$exports = {};
(function() {
    "use strict";
    controller.$inject = [];
    function controller() {}
    new Controller("viewLayer", controller);
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanViewLayer${i}`, "viewLayer");
    });
})();


$d0bb70554030eefa$exports = {
    "batman": {
        "view-layer": $49a9eb5968472552$exports
    }
};


var $44612b99d3d44062$exports = {};
$44612b99d3d44062$exports = {};


var $003ff5e5a19b3af4$exports = {};
$003ff5e5a19b3af4$exports = {};


var $5737f1f5cc92934c$exports = {};
$5737f1f5cc92934c$exports = {};


var $26e1fcd842520c10$exports = {};
$26e1fcd842520c10$exports = {};


var $a9892fafc7037d63$exports = {};
$a9892fafc7037d63$exports = {};


var $6a7c0b522164c38d$exports = {};
$6a7c0b522164c38d$exports = {};


var $eb0267263213a4f6$exports = {};
$eb0267263213a4f6$exports = {};


var $1e445e9c827f3ed6$exports = {};
var $be9f17af7c333a1c$exports = {};


class $be9f17af7c333a1c$var$WithdrawalItem {
    static $inject = [
        "$scope",
        "withdraw",
        "popup"
    ];
    constructor($scope, withdraw, popup){
        $scope.preloader = false;
        this.$onChanges = ()=>{
            $scope.item = this.item;
        };
        $scope.cancel = (id)=>{
            $scope.preloader = true;
            withdraw.cancel({
                alias: id
            }).finally(()=>{
                $scope.preloader = false;
                popup.close();
            });
        };
    }
}
new Controller("container", $be9f17af7c333a1c$var$WithdrawalItem, {
    item: "<"
});
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanWithdrawalItem${i}`, "container");
    });
})();


$1e445e9c827f3ed6$exports = {
    "batman": {
        "batman-withdrawal-item": $be9f17af7c333a1c$exports
    }
};


var $fc8240083fedf15b$exports = {};
var $c7a1ae00a6d60adc$exports = {};





(function() {
    "use strict";
    app.factory("zimpler.config", controller);
    controller.$inject = [
        "config"
    ];
    function controller(_config) {
        const config = typeof _config.paynplay === "object" ? _config.paynplay : {
            curacao: {
                fi: {
                    enabled: true,
                    min: 20,
                    max: 10000,
                    default: 100,
                    range: [
                        50,
                        100,
                        250
                    ],
                    currency: "EUR",
                    locale: "fi_FI"
                }
            },
            malta: {
                fi: {
                    enabled: true,
                    min: 20,
                    max: 10000,
                    default: 100,
                    range: [
                        50,
                        100,
                        250
                    ],
                    currency: "EUR",
                    locale: "fi_FI"
                }
            },
            sweden: {
                enabled: true,
                min: 100,
                max: 5000,
                default: 0,
                range: [
                    1000,
                    2000,
                    5000
                ],
                currency: "SEK",
                locale: "sv_SE"
            }
        };
        let result;
        switch(_config.jurisdiction){
            case "sweden":
                result = config.sweden;
                break;
            case "curacao":
            case "malta":
                result = config[_config.jurisdiction]?.[_config.currentLang] || {
                    enabled: false
                };
                break;
            default:
                result = {
                    enabled: false
                };
                break;
        }
        return result;
    }
})();




(function() {
    "use strict";
    app.factory("zimpler.paynplay", controller);
    controller.$inject = [
        "http",
        "$q",
        "user",
        "trustly$",
        "config",
        "zimpler.config",
        "analytics",
        "analyticsEvents",
        "$cookies",
        "$window"
    ];
    function controller(_http, $q, _user, _trustly$, _config, _zimpler_config, analytics, _analyticsEvents, $cookies, $window) {
        const defaultJurisdictions = [
            "curacao",
            "malta"
        ];
        const isDefaultJurisdiction = defaultJurisdictions.includes(_config.jurisdiction);
        const adformcookieid = $window.Adform?.["_uid"];
        function requestParams(params) {
            const ls = angular.fromJson($window.localStorage.getItem("params") || "{}");
            ls.paymethod = "zimpler";
            ls.currency = _zimpler_config.currency;
            ls.affiliate = {};
            ls.locale = _zimpler_config.locale;
            ls.amount = api.data.amount;
            if (api.data.order_id) ls.order_id = api.data.order_id;
            return Object.assign({}, ls, params);
        }
        function reset() {
            api.data.flow = null;
            api.data.amount = isDefaultJurisdiction ? 0 : _zimpler_config.default;
            api.data.step = isDefaultJurisdiction ? 1 : 0;
            api.data.order_id = null;
        }
        let _step = isDefaultJurisdiction ? 1 : 0;
        let _flow = null; // 'fast_deposit' - default || 'resume_play' - optional
        const api = {
            isDefaultJurisdiction: isDefaultJurisdiction,
            data: {
                order_id: null,
                amount: isDefaultJurisdiction ? 0 : _zimpler_config.default,
                reset: reset
            },
            init (params) {
                const defer = $q.defer();
                const alias = "trustlyInit";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const data = requestParams(params);
                if (adformcookieid) data.adformcookieid = adformcookieid;
                const fbpValue = $cookies.get("_fbp");
                if (fbpValue && data.affiliate) data.affiliate.fbp = fbpValue;
                _http.post(alias, data, config).then((answer)=>{
                    this.data.order_id = answer.data.result.order_id || null;
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            auth (params) {
                const defer = $q.defer();
                const alias = "trustlyAuth";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                const data = requestParams(params);
                if (adformcookieid) data.adformcookieid = adformcookieid;
                _http.post(alias, data, config).then((answer)=>{
                    _user.profile = answer.data.result;
                    analytics.send(_analyticsEvents.zimplerAuthSuccess, "success", answer.data.result.login);
                    defer.resolve(answer.data);
                }, (answer)=>{
                    analytics.send(_analyticsEvents.zimplerAuthFail, answer.data.messages[0].code?.toString(), "Not_Login");
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            checkStatus (options) {
                const defer = $q.defer();
                const alias = "trustlyStatus";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            updateProfile (data) {
                const defer = $q.defer();
                const alias = "trustlyData";
                const config = {
                    meta: {
                        alias: alias
                    }
                };
                _http.post(alias, data, config).then((answer)=>{
                    defer.resolve(answer.data.result);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
        Object.defineProperty(api.data, "step", {
            get () {
                return _step;
            },
            set (value) {
                _step = value;
                _trustly$.next({
                    action: "step",
                    data: value
                });
            }
        });
        Object.defineProperty(api.data, "flow", {
            get () {
                return _flow || "fast_deposit";
            },
            set (value) {
                _flow = value;
            }
        });
        return api;
    }
})();








(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "zimpler.paynplay",
        "config",
        "user",
        "state",
        "helper",
        "trustly$",
        "$timeout",
        "zimpler.config"
    ];
    function controller($scope, _zimpler_paynplay, _config, _user, _state, _helper, _trustly$, $timeout, _zimpler_config) {
        $scope.amount = _zimpler_paynplay.data.amount;
        $scope.paysystem = _zimpler_config;
        $scope.submit = _helper.form.validator((form)=>{
            if ($scope.amount > 0) {
                _zimpler_paynplay.data.amount = $scope.amount;
                _zimpler_paynplay.data.step = 1;
                _state.goto("paynplay");
            }
        });
    }
    new Controller("zimplerPaynplayWidget", controller, {});
})();
(function() {
    "use strict";
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanZimplerPaynplayWidget${i}`, "zimplerPaynplayWidget");
    });
})();


$fc8240083fedf15b$exports = {
    "linda": {
        "zimpler": $c7a1ae00a6d60adc$exports
    }
};


var $8df8fcb5d8aa65f6$exports = {};
var $816697039c78be43$exports = {};




const $b65d43f70974848a$export$9dc5a09c11e07ba3 = "cupService";
class $b65d43f70974848a$var$Cup {
    static $inject = [
        "achievement"
    ];
    constructor(achievement){
        this.achievement = achievement;
    }
    markPoint = 0;
    progressCup = 0;
    currentItem$ = new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)();
    getImage(imgUrl) {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.src = imgUrl;
            img.onload = ()=>{
                resolve(img);
            };
            img.onerror = ()=>{
                reject(img);
            };
        });
    }
    getCurrentIndex(arr) {
        let prevStatus = 0;
        const lastIndexInArr = arr.length - 1;
        this.currentIndex = 0;
        this.prevPointsAmount = 0;
        if (arr[lastIndexInArr].status === 3) {
            this.currentIndex = lastIndexInArr;
            if (lastIndexInArr !== 0) this.prevPointsAmount = arr[lastIndexInArr - 1].progress[1];
            return;
        }
        arr.forEach((item, index)=>{
            if (item.status === 1 && prevStatus === 3) {
                this.currentIndex = index;
                this.prevPointsAmount = index - 1 >= 0 ? arr[index - 1].progress[1] : 0;
            }
            prevStatus = item.status;
        });
    }
    getAchievement(data) {
        this.config = data;
        return this.achievement.list(data).then(({ result: result })=>{
            const lastAchieve = result.slice(-1);
            this.getCurrentIndex(result);
            this.currentItem = Object.assign(result[this.currentIndex], {
                prevPointsAmount: this.prevPointsAmount
            });
            this.calcProgressAndMarks(result.length, lastAchieve);
            this.currentItem$.next({
                item: this.currentItem
            });
            return result;
        });
    }
    calcProgressAndMarks(achievementAmount) {
        this.markPoint = 1 / achievementAmount;
        const minHeightForAnimation = 0.0000001;
        const startPosition = this.markPoint * this.currentIndex;
        const progressOnCurrentMarkPoint = this.markPoint * ((this.currentItem.progress[0] - this.currentItem.prevPointsAmount) / (this.currentItem.progress[1] - this.currentItem.prevPointsAmount));
        this.progressCup = startPosition + progressOnCurrentMarkPoint + minHeightForAnimation;
    }
    takeAchieve(id) {
        return this.achievement.take(id).then((data)=>{
            this.getAchievement(this.config);
            return data;
        });
    }
    buildMarks(pointsList) {
        pointsList.forEach((el, index)=>{
            const position = this.markPoint * (index + 1) * 100;
            el.style.bottom = `${position}%`;
        });
    }
}
// eslint-disable-next-line angular/no-service-method
app.service($b65d43f70974848a$export$9dc5a09c11e07ba3, $b65d43f70974848a$var$Cup);


const $816697039c78be43$var$componentName = "cupProgress";
class $816697039c78be43$var$Cup {
    static $inject = [
        "$scope",
        "cupService"
    ];
    constructor($scope, cupService){
        $scope.preloader = false;
        $scope.progress = 0;
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        $scope.take = (item)=>{
            $scope.preloader = true;
            cupService.takeAchieve({
                id: item.id
            }).catch((error)=>error).finally(()=>{
                $scope.preloader = false;
            });
        };
        cupService.currentItem$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe(({ item: item })=>{
            $scope.item = item;
            $scope.progress = (item.progress[0] - item.prevPointsAmount) / (item.progress[1] - item.prevPointsAmount) * 100;
            $scope.isComplete = item.progress[1] - item.progress[0] === 0;
        });
        $scope.$onDestroy = ()=>{
            destroy$.next();
            destroy$.unsubscribe();
        };
    }
}
app.component($816697039c78be43$var$componentName, {
    controller: $816697039c78be43$var$Cup,
    template: app.getTU($816697039c78be43$var$componentName)
});


$8df8fcb5d8aa65f6$exports = {
    "cup": $816697039c78be43$exports
};


var $aab34a2e6441591f$exports = {};
var $b14159bafff43645$exports = {};


var $lcQJb = parcelRequire("lcQJb");

const $b14159bafff43645$var$componentName = "cupWithDynamicAchieve";
class $b14159bafff43645$var$Cup {
    static $inject = [
        "$scope",
        "$document",
        "$q",
        "config",
        "cupService",
        "$window",
        "$timeout"
    ];
    constructor($scope, $document, $q, config, cupService, $window, $timeout){
        $scope.preloader = true;
        $scope.collection = [];
        const cupGlassImage = `${config.cdn}/${config.siteName}/cup-page/cup_glass_cut.png`;
        const cupGoldImage = `${config.cdn}/${config.siteName}/cup-page/cup_gold_cut.png`;
        const cupGoldImagePromise = cupService.getImage(cupGoldImage);
        const cupGlassImagePromise = cupService.getImage(cupGlassImage);
        const achievementsPromise = cupService.getAchievement({
            category: "cup",
            count: this.count,
            order: ""
        });
        const cupWrap = $document[0].querySelector(".cup__wrap");
        const cupBack = cupWrap.querySelector(".cup__back");
        const cupFront = cupWrap.querySelector(".cup__front-img");
        const cupProgress = cupWrap.querySelector(".cup__front");
        const progress = cupWrap.querySelector(".cup-progress");
        const progressLine = cupWrap.querySelector(".cup-progress__line");
        const progressDuration = 1;
        const cupConfig = {
            height: "100%",
            ease: (0, $lcQJb.SteppedEase).config(100)
        };
        const twistDuration = 1;
        const twistSegment = 1000;
        const twistConfig = {
            reversed: true,
            backgroundPosition: "-10800px",
            ease: (0, $lcQJb.SteppedEase).config(30)
        };
        const progressTimeLine = new (0, $lcQJb.TimelineMax)({
            paused: true
        });
        const mainProgress = (0, $50c26a34528ecf35$export$7b23975ad686bf91).to(progress, progressDuration, cupConfig);
        const progressCupProgress = (0, $50c26a34528ecf35$export$7b23975ad686bf91).to(cupProgress, progressDuration, cupConfig);
        const progressLineProgress = (0, $50c26a34528ecf35$export$7b23975ad686bf91).to(progressLine, progressDuration, cupConfig);
        progressTimeLine.add(mainProgress, 0);
        progressTimeLine.add(progressCupProgress, 0);
        progressTimeLine.add(progressLineProgress, 0);
        const twistTimeLine = new (0, $lcQJb.TimelineMax)({
            paused: true
        });
        const twistBackTween = (0, $50c26a34528ecf35$export$7b23975ad686bf91).to(cupBack, twistDuration, twistConfig);
        const twistFrontTween = (0, $50c26a34528ecf35$export$7b23975ad686bf91).to(cupFront, twistDuration, twistConfig);
        twistTimeLine.add(twistBackTween, 0);
        twistTimeLine.add(twistFrontTween, 0);
        const twistCup = (element)=>{
            const deltaX = (element.view.innerWidth - twistSegment) * 0.5;
            const mousePosition = (element.pageX - deltaX) / twistSegment;
            if (0 < mousePosition && mousePosition <= 1) twistTimeLine.progress(mousePosition);
        };
        $q.all([
            achievementsPromise,
            cupGoldImagePromise,
            cupGlassImagePromise
        ]).then((answer)=>{
            $scope.collection = answer[0];
            $scope.mainGoal = answer[0].reduce((acc, item)=>acc + item.prize, 0);
            $scope.mainAchievement = $scope.collection.slice(-1)[0];
            cupWrap.classList.add("linda-img-loaded");
            progressTimeLine.addLabel("progressCurrent", cupService.progressCup);
            progressTimeLine.addPause("progressCurrent");
            progressTimeLine.play(0);
            $timeout(()=>{
                cupService.buildMarks($document[0].querySelectorAll(".cup-mark"));
            }, 0);
        }).catch((error)=>console.warn(error)).finally(()=>{
            $scope.preloader = false;
        });
        this.$onInit = ()=>$window.addEventListener("mousemove", twistCup);
        this.$onDestroy = ()=>$window.removeEventListener("mousemove", twistCup);
    }
}
app.component($b14159bafff43645$var$componentName, {
    controller: $b14159bafff43645$var$Cup,
    binding: {
        count: "<"
    },
    template: app.getTU($b14159bafff43645$var$componentName)
});


$aab34a2e6441591f$exports = {
    "cup": $b14159bafff43645$exports
};


var $290503861428cbd0$exports = {};
var $419e084450e2b559$exports = {};



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $92b5ef3161639fdf$var$extendStatics = function(d, b) {
    $92b5ef3161639fdf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $92b5ef3161639fdf$var$extendStatics(d, b);
};
function $92b5ef3161639fdf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $92b5ef3161639fdf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $92b5ef3161639fdf$export$18ce0697a983be9b = function() {
    $92b5ef3161639fdf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $92b5ef3161639fdf$export$18ce0697a983be9b.apply(this, arguments);
};
function $92b5ef3161639fdf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $92b5ef3161639fdf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $92b5ef3161639fdf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $92b5ef3161639fdf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $92b5ef3161639fdf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $92b5ef3161639fdf$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $92b5ef3161639fdf$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $92b5ef3161639fdf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $92b5ef3161639fdf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $92b5ef3161639fdf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $92b5ef3161639fdf$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $92b5ef3161639fdf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $92b5ef3161639fdf$export$45d3717a4c69092e(o, m, p);
}
function $92b5ef3161639fdf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $92b5ef3161639fdf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $92b5ef3161639fdf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($92b5ef3161639fdf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $92b5ef3161639fdf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $92b5ef3161639fdf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $92b5ef3161639fdf$export$10c90e4f7922046c(v) {
    return this instanceof $92b5ef3161639fdf$export$10c90e4f7922046c ? (this.v = v, this) : new $92b5ef3161639fdf$export$10c90e4f7922046c(v);
}
function $92b5ef3161639fdf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $92b5ef3161639fdf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $92b5ef3161639fdf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $92b5ef3161639fdf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $92b5ef3161639fdf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $92b5ef3161639fdf$export$19a8beecd37a4c45 === "function" ? $92b5ef3161639fdf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $92b5ef3161639fdf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $92b5ef3161639fdf$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $92b5ef3161639fdf$var$ownKeys = function(o) {
    $92b5ef3161639fdf$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $92b5ef3161639fdf$var$ownKeys(o);
};
function $92b5ef3161639fdf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $92b5ef3161639fdf$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $92b5ef3161639fdf$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $92b5ef3161639fdf$var$__setModuleDefault(result, mod);
    return result;
}
function $92b5ef3161639fdf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $92b5ef3161639fdf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $92b5ef3161639fdf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $92b5ef3161639fdf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $92b5ef3161639fdf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $92b5ef3161639fdf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $92b5ef3161639fdf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $92b5ef3161639fdf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $92b5ef3161639fdf$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $92b5ef3161639fdf$export$2e2bcd8739ae039 = {
    __extends: $92b5ef3161639fdf$export$a8ba968b8961cb8a,
    __assign: $92b5ef3161639fdf$export$18ce0697a983be9b,
    __rest: $92b5ef3161639fdf$export$3c9a16f847548506,
    __decorate: $92b5ef3161639fdf$export$29e00dfd3077644b,
    __param: $92b5ef3161639fdf$export$d5ad3fd78186038f,
    __esDecorate: $92b5ef3161639fdf$export$3a84e1ae4e97e9b0,
    __runInitializers: $92b5ef3161639fdf$export$d831c04e792af3d,
    __propKey: $92b5ef3161639fdf$export$6a2a36740a146cb8,
    __setFunctionName: $92b5ef3161639fdf$export$d1a06452d3489bc7,
    __metadata: $92b5ef3161639fdf$export$f1db080c865becb9,
    __awaiter: $92b5ef3161639fdf$export$1050f835b63b671e,
    __generator: $92b5ef3161639fdf$export$67ebef60e6f28a6,
    __createBinding: $92b5ef3161639fdf$export$45d3717a4c69092e,
    __exportStar: $92b5ef3161639fdf$export$f33643c0debef087,
    __values: $92b5ef3161639fdf$export$19a8beecd37a4c45,
    __read: $92b5ef3161639fdf$export$8d051b38c9118094,
    __spread: $92b5ef3161639fdf$export$afc72e2116322959,
    __spreadArrays: $92b5ef3161639fdf$export$6388937ca91ccae8,
    __spreadArray: $92b5ef3161639fdf$export$1216008129fb82ed,
    __await: $92b5ef3161639fdf$export$10c90e4f7922046c,
    __asyncGenerator: $92b5ef3161639fdf$export$e427f37a30a4de9b,
    __asyncDelegator: $92b5ef3161639fdf$export$bbd80228419bb833,
    __asyncValues: $92b5ef3161639fdf$export$e3b29a3d6162315f,
    __makeTemplateObject: $92b5ef3161639fdf$export$4fb47efe1390b86f,
    __importStar: $92b5ef3161639fdf$export$c21735bcef00d192,
    __importDefault: $92b5ef3161639fdf$export$da59b14a69baef04,
    __classPrivateFieldGet: $92b5ef3161639fdf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $92b5ef3161639fdf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $92b5ef3161639fdf$export$81fdc39f203e4e04,
    __addDisposableResource: $92b5ef3161639fdf$export$88ac25d8e944e405,
    __disposeResources: $92b5ef3161639fdf$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $92b5ef3161639fdf$export$889dfb5d17574b0b
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $aec04e6b6c76c595$export$850a745f54aa50d7 extends Event {
    constructor(s, t, e){
        super("context-request", {
            bubbles: !0,
            composed: !0
        }), this.context = s, this.callback = t, this.subscribe = e ?? !1;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1e7ce0890e6d6280$export$fd42f52fd3ae1109(n) {
    return n;
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $81c2b80c2693f391$export$a7c73072b1a182ae {
    constructor(t, s, i, h){
        if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (t, s)=>{
            this.unsubscribe && (this.unsubscribe !== s && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = t, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(t, s)), this.unsubscribe = s;
        }, this.host = t, void 0 !== s.context) {
            const t = s;
            this.context = t.context, this.callback = t.callback, this.subscribe = t.subscribe ?? !1;
        } else this.context = s, this.callback = i, this.subscribe = h ?? !1;
        this.host.addController(this);
    }
    hostConnected() {
        this.dispatchRequest();
    }
    hostDisconnected() {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
    }
    dispatchRequest() {
        this.host.dispatchEvent(new (0, $aec04e6b6c76c595$export$850a745f54aa50d7)(this.context, this.t, this.subscribe));
    }
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $f66b62487769a5e9$export$b2bf9da44ce3a51c {
    get value() {
        return this.o;
    }
    set value(s) {
        this.setValue(s);
    }
    setValue(s, t = !1) {
        const i = t || !Object.is(s, this.o);
        this.o = s, i && this.updateObservers();
    }
    constructor(s){
        this.subscriptions = new Map, this.updateObservers = ()=>{
            for (const [s, { disposer: t }] of this.subscriptions)s(this.o, t);
        }, void 0 !== s && (this.value = s);
    }
    addCallback(s, t, i) {
        if (!i) return void s(this.value);
        this.subscriptions.has(s) || this.subscriptions.set(s, {
            disposer: ()=>{
                this.subscriptions.delete(s);
            },
            consumerHost: t
        });
        const { disposer: h } = this.subscriptions.get(s);
        s(this.value, h);
    }
    clearCallbacks() {
        this.subscriptions.clear();
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $58bf5c2898404609$export$78572d749d164a6c extends Event {
    constructor(t){
        super("context-provider", {
            bubbles: !0,
            composed: !0
        }), this.context = t;
    }
}
class $58bf5c2898404609$export$9f27bc3417b4524d extends (0, $f66b62487769a5e9$export$b2bf9da44ce3a51c) {
    constructor(s, e, i){
        super(void 0 !== e.context ? e.initialValue : i), this.onContextRequest = (t)=>{
            const s = t.composedPath()[0];
            t.context === this.context && s !== this.host && (t.stopPropagation(), this.addCallback(t.callback, s, t.subscribe));
        }, this.onProviderRequest = (s)=>{
            const e = s.composedPath()[0];
            if (s.context !== this.context || e === this.host) return;
            const i = new Set;
            for (const [s, { consumerHost: e }] of this.subscriptions)i.has(s) || (i.add(s), e.dispatchEvent(new (0, $aec04e6b6c76c595$export$850a745f54aa50d7)(this.context, s, !0)));
            s.stopPropagation();
        }, this.host = s, void 0 !== e.context ? this.context = e.context : this.context = e, this.attachListeners(), this.host.addController?.(this);
    }
    attachListeners() {
        this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
    }
    hostConnected() {
        this.host.dispatchEvent(new $58bf5c2898404609$export$78572d749d164a6c(this.context));
    }
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $3250f013292a4786$export$a375903047a16407 {
    constructor(){
        this.pendingContextRequests = new Map, this.onContextProvider = (t)=>{
            const s = this.pendingContextRequests.get(t.context);
            if (void 0 === s) return;
            this.pendingContextRequests.delete(t.context);
            const { requests: o } = s;
            for (const { elementRef: s, callbackRef: n } of o){
                const o = s.deref(), c = n.deref();
                void 0 === o || void 0 === c || o.dispatchEvent(new (0, $aec04e6b6c76c595$export$850a745f54aa50d7)(t.context, c, !0));
            }
        }, this.onContextRequest = (e)=>{
            if (!0 !== e.subscribe) return;
            const t = e.composedPath()[0], s = e.callback;
            let o = this.pendingContextRequests.get(e.context);
            void 0 === o && this.pendingContextRequests.set(e.context, o = {
                callbacks: new WeakMap,
                requests: []
            });
            let n = o.callbacks.get(t);
            void 0 === n && o.callbacks.set(t, n = new WeakSet), n.has(s) || (n.add(s), o.requests.push({
                elementRef: new WeakRef(t),
                callbackRef: new WeakRef(s)
            }));
        };
    }
    attach(e) {
        e.addEventListener("context-request", this.onContextRequest), e.addEventListener("context-provider", this.onContextProvider);
    }
    detach(e) {
        e.removeEventListener("context-request", this.onContextRequest), e.removeEventListener("context-provider", this.onContextProvider);
    }
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $42872b8bf3f7039a$export$abe1e183e22e10ad({ context: e }) {
    return (n, r)=>{
        const i = new WeakMap;
        if ("object" == typeof r) return r.addInitializer(function() {
            i.set(this, new (0, $58bf5c2898404609$export$9f27bc3417b4524d)(this, {
                context: e
            }));
        }), {
            get () {
                return n.get.call(this);
            },
            set (t) {
                return i.get(this)?.setValue(t), n.set.call(this, t);
            },
            init (t) {
                return i.get(this)?.setValue(t), t;
            }
        };
        {
            n.constructor.addInitializer((n)=>{
                i.set(n, new (0, $58bf5c2898404609$export$9f27bc3417b4524d)(n, {
                    context: e
                }));
            });
            const o = Object.getOwnPropertyDescriptor(n, r);
            let s;
            if (void 0 === o) {
                const t = new WeakMap;
                s = {
                    get () {
                        return t.get(this);
                    },
                    set (e) {
                        i.get(this).setValue(e), t.set(this, e);
                    },
                    configurable: !0,
                    enumerable: !0
                };
            } else {
                const t = o.set;
                s = {
                    ...o,
                    set (e) {
                        i.get(this).setValue(e), t?.call(this, e);
                    }
                };
            }
            return void Object.defineProperty(n, r, s);
        }
    };
}



/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c6c3beae6ff56b37$export$e11e6a155c5c4d9d({ context: c, subscribe: e }) {
    return (o, n)=>{
        "object" == typeof n ? n.addInitializer(function() {
            new (0, $81c2b80c2693f391$export$a7c73072b1a182ae)(this, {
                context: c,
                callback: (t)=>{
                    o.set.call(this, t);
                },
                subscribe: e
            });
        }) : o.constructor.addInitializer((o)=>{
            new (0, $81c2b80c2693f391$export$a7c73072b1a182ae)(o, {
                context: c,
                callback: (t)=>{
                    o[n] = t;
                },
                subscribe: e
            });
        });
    };
}




/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cf848438daf93422$var$t = globalThis, $cf848438daf93422$export$b4d10f6001c083c2 = $cf848438daf93422$var$t.ShadowRoot && (void 0 === $cf848438daf93422$var$t.ShadyCSS || $cf848438daf93422$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $cf848438daf93422$var$s = Symbol(), $cf848438daf93422$var$o = new WeakMap;
class $cf848438daf93422$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $cf848438daf93422$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($cf848438daf93422$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $cf848438daf93422$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $cf848438daf93422$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $cf848438daf93422$export$8d80f9cac07cdb3 = (t)=>new $cf848438daf93422$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $cf848438daf93422$var$s), $cf848438daf93422$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $cf848438daf93422$export$505d1e8739bad805(o, t, $cf848438daf93422$var$s);
}, $cf848438daf93422$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($cf848438daf93422$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $cf848438daf93422$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $cf848438daf93422$export$ee69dfd951e24778 = $cf848438daf93422$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $cf848438daf93422$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $e4b86d4640103ab8$var$i, defineProperty: $e4b86d4640103ab8$var$e, getOwnPropertyDescriptor: $e4b86d4640103ab8$var$r, getOwnPropertyNames: $e4b86d4640103ab8$var$h, getOwnPropertySymbols: $e4b86d4640103ab8$var$o, getPrototypeOf: $e4b86d4640103ab8$var$n } = Object, $e4b86d4640103ab8$var$a = globalThis, $e4b86d4640103ab8$var$c = $e4b86d4640103ab8$var$a.trustedTypes, $e4b86d4640103ab8$var$l = $e4b86d4640103ab8$var$c ? $e4b86d4640103ab8$var$c.emptyScript : "", $e4b86d4640103ab8$var$p = $e4b86d4640103ab8$var$a.reactiveElementPolyfillSupport, $e4b86d4640103ab8$var$d = (t, s)=>t, $e4b86d4640103ab8$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $e4b86d4640103ab8$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $e4b86d4640103ab8$export$53a6892c50694894 = (t, s)=>!$e4b86d4640103ab8$var$i(t, s), $e4b86d4640103ab8$var$y = {
    attribute: !0,
    type: String,
    converter: $e4b86d4640103ab8$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $e4b86d4640103ab8$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $e4b86d4640103ab8$var$a.litPropertyMetadata ??= new WeakMap;
class $e4b86d4640103ab8$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $e4b86d4640103ab8$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $e4b86d4640103ab8$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $e4b86d4640103ab8$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $e4b86d4640103ab8$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($e4b86d4640103ab8$var$d("elementProperties"))) return;
        const t = $e4b86d4640103ab8$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($e4b86d4640103ab8$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($e4b86d4640103ab8$var$d("properties"))) {
            const t = this.properties, s = [
                ...$e4b86d4640103ab8$var$h(t),
                ...$e4b86d4640103ab8$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $cf848438daf93422$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $cf848438daf93422$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $cf848438daf93422$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $e4b86d4640103ab8$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $e4b86d4640103ab8$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $e4b86d4640103ab8$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$e4b86d4640103ab8$export$c7c07a37856565d.elementStyles = [], $e4b86d4640103ab8$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $e4b86d4640103ab8$export$c7c07a37856565d[$e4b86d4640103ab8$var$d("elementProperties")] = new Map, $e4b86d4640103ab8$export$c7c07a37856565d[$e4b86d4640103ab8$var$d("finalized")] = new Map, $e4b86d4640103ab8$var$p?.({
    ReactiveElement: $e4b86d4640103ab8$export$c7c07a37856565d
}), ($e4b86d4640103ab8$var$a.reactiveElementVersions ??= []).push("2.0.4");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15085907dd60083a$var$t = globalThis, $15085907dd60083a$var$i = $15085907dd60083a$var$t.trustedTypes, $15085907dd60083a$var$s = $15085907dd60083a$var$i ? $15085907dd60083a$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $15085907dd60083a$var$e = "$lit$", $15085907dd60083a$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $15085907dd60083a$var$o = "?" + $15085907dd60083a$var$h, $15085907dd60083a$var$n = `<${$15085907dd60083a$var$o}>`, $15085907dd60083a$var$r = document, $15085907dd60083a$var$l = ()=>$15085907dd60083a$var$r.createComment(""), $15085907dd60083a$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $15085907dd60083a$var$a = Array.isArray, $15085907dd60083a$var$u = (t)=>$15085907dd60083a$var$a(t) || "function" == typeof t?.[Symbol.iterator], $15085907dd60083a$var$d = "[ 	\n\f\r]", $15085907dd60083a$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $15085907dd60083a$var$v = /-->/g, $15085907dd60083a$var$_ = />/g, $15085907dd60083a$var$m = RegExp(`>|${$15085907dd60083a$var$d}(?:([^\\s"'>=/]+)(${$15085907dd60083a$var$d}*=${$15085907dd60083a$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $15085907dd60083a$var$p = /'/g, $15085907dd60083a$var$g = /"/g, $15085907dd60083a$var$$ = /^(?:script|style|textarea|title)$/i, $15085907dd60083a$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $15085907dd60083a$export$c0bb0b647f701bb5 = $15085907dd60083a$var$y(1), $15085907dd60083a$export$7ed1367e7fa1ad68 = $15085907dd60083a$var$y(2), $15085907dd60083a$export$47d5b44d225be5b4 = $15085907dd60083a$var$y(3), $15085907dd60083a$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $15085907dd60083a$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $15085907dd60083a$var$A = new WeakMap, $15085907dd60083a$var$C = $15085907dd60083a$var$r.createTreeWalker($15085907dd60083a$var$r, 129);
function $15085907dd60083a$var$P(t, i) {
    if (!$15085907dd60083a$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $15085907dd60083a$var$s ? $15085907dd60083a$var$s.createHTML(i) : i;
}
const $15085907dd60083a$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $15085907dd60083a$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $15085907dd60083a$var$f ? "!--" === u[1] ? c = $15085907dd60083a$var$v : void 0 !== u[1] ? c = $15085907dd60083a$var$_ : void 0 !== u[2] ? ($15085907dd60083a$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $15085907dd60083a$var$m) : void 0 !== u[3] && (c = $15085907dd60083a$var$m) : c === $15085907dd60083a$var$m ? ">" === u[0] ? (c = r ?? $15085907dd60083a$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $15085907dd60083a$var$m : '"' === u[3] ? $15085907dd60083a$var$g : $15085907dd60083a$var$p) : c === $15085907dd60083a$var$g || c === $15085907dd60083a$var$p ? c = $15085907dd60083a$var$m : c === $15085907dd60083a$var$v || c === $15085907dd60083a$var$_ ? c = $15085907dd60083a$var$f : (c = $15085907dd60083a$var$m, r = void 0);
        const x = c === $15085907dd60083a$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $15085907dd60083a$var$f ? s + $15085907dd60083a$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $15085907dd60083a$var$e + s.slice(d) + $15085907dd60083a$var$h + x) : s + $15085907dd60083a$var$h + (-2 === d ? i : x);
    }
    return [
        $15085907dd60083a$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $15085907dd60083a$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $15085907dd60083a$var$V(t, s);
        if (this.el = $15085907dd60083a$var$N.createElement(f, n), $15085907dd60083a$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $15085907dd60083a$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($15085907dd60083a$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($15085907dd60083a$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $15085907dd60083a$var$H : "?" === e[1] ? $15085907dd60083a$var$I : "@" === e[1] ? $15085907dd60083a$var$L : $15085907dd60083a$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($15085907dd60083a$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($15085907dd60083a$var$$.test(r.tagName)) {
                    const t = r.textContent.split($15085907dd60083a$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $15085907dd60083a$var$i ? $15085907dd60083a$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $15085907dd60083a$var$l()), $15085907dd60083a$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $15085907dd60083a$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $15085907dd60083a$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($15085907dd60083a$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $15085907dd60083a$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $15085907dd60083a$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $15085907dd60083a$var$S(t, i, s = t, e) {
    if (i === $15085907dd60083a$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $15085907dd60083a$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $15085907dd60083a$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $15085907dd60083a$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $15085907dd60083a$var$r).importNode(i, !0);
        $15085907dd60083a$var$C.currentNode = e;
        let h = $15085907dd60083a$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $15085907dd60083a$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $15085907dd60083a$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $15085907dd60083a$var$C.nextNode(), o++);
        }
        return $15085907dd60083a$var$C.currentNode = $15085907dd60083a$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $15085907dd60083a$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $15085907dd60083a$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $15085907dd60083a$var$S(this, t, i), $15085907dd60083a$var$c(t) ? t === $15085907dd60083a$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $15085907dd60083a$export$45b790e32b2810ee && this._$AR(), this._$AH = $15085907dd60083a$export$45b790e32b2810ee) : t !== this._$AH && t !== $15085907dd60083a$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $15085907dd60083a$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $15085907dd60083a$export$45b790e32b2810ee && $15085907dd60083a$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($15085907dd60083a$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $15085907dd60083a$var$N.createElement($15085907dd60083a$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $15085907dd60083a$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $15085907dd60083a$var$A.get(t.strings);
        return void 0 === i && $15085907dd60083a$var$A.set(t.strings, i = new $15085907dd60083a$var$N(t)), i;
    }
    k(t) {
        $15085907dd60083a$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $15085907dd60083a$var$R(this.O($15085907dd60083a$var$l()), this.O($15085907dd60083a$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $15085907dd60083a$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $15085907dd60083a$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $15085907dd60083a$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $15085907dd60083a$var$S(this, t, i, 0), o = !$15085907dd60083a$var$c(t) || t !== this._$AH && t !== $15085907dd60083a$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $15085907dd60083a$var$S(this, e[s + n], i, n), r === $15085907dd60083a$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$15085907dd60083a$var$c(r) || r !== this._$AH[n], r === $15085907dd60083a$export$45b790e32b2810ee ? t = $15085907dd60083a$export$45b790e32b2810ee : t !== $15085907dd60083a$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $15085907dd60083a$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $15085907dd60083a$var$H extends $15085907dd60083a$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $15085907dd60083a$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $15085907dd60083a$var$I extends $15085907dd60083a$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $15085907dd60083a$export$45b790e32b2810ee);
    }
}
class $15085907dd60083a$var$L extends $15085907dd60083a$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $15085907dd60083a$var$S(this, t, i, 0) ?? $15085907dd60083a$export$45b790e32b2810ee) === $15085907dd60083a$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $15085907dd60083a$export$45b790e32b2810ee && s !== $15085907dd60083a$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $15085907dd60083a$export$45b790e32b2810ee && (s === $15085907dd60083a$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $15085907dd60083a$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $15085907dd60083a$var$S(this, t);
    }
}
const $15085907dd60083a$export$8613d1ca9052b22e = {
    M: $15085907dd60083a$var$e,
    P: $15085907dd60083a$var$h,
    A: $15085907dd60083a$var$o,
    C: 1,
    L: $15085907dd60083a$var$V,
    R: $15085907dd60083a$var$M,
    D: $15085907dd60083a$var$u,
    V: $15085907dd60083a$var$S,
    I: $15085907dd60083a$var$R,
    H: $15085907dd60083a$var$k,
    N: $15085907dd60083a$var$I,
    U: $15085907dd60083a$var$L,
    B: $15085907dd60083a$var$H,
    F: $15085907dd60083a$var$z
}, $15085907dd60083a$var$j = $15085907dd60083a$var$t.litHtmlPolyfillSupport;
$15085907dd60083a$var$j?.($15085907dd60083a$var$N, $15085907dd60083a$var$R), ($15085907dd60083a$var$t.litHtmlVersions ??= []).push("3.2.1");
const $15085907dd60083a$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $15085907dd60083a$var$R(i.insertBefore($15085907dd60083a$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $23a6037be2405355$export$3f2f9f5909897157 extends (0, $e4b86d4640103ab8$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const s = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $15085907dd60083a$export$b3890eb0ae9dca99)(s, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $15085907dd60083a$export$9c068ae9cc5db4e8;
    }
}
$23a6037be2405355$export$3f2f9f5909897157._$litElement$ = !0, $23a6037be2405355$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $23a6037be2405355$export$3f2f9f5909897157
});
const $23a6037be2405355$var$i = globalThis.litElementPolyfillSupport;
$23a6037be2405355$var$i?.({
    LitElement: $23a6037be2405355$export$3f2f9f5909897157
});
const $23a6037be2405355$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e604bbf82b74567$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $887f7aa45b30e788$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6e0e0f5559cb846e$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $e4b86d4640103ab8$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $e4b86d4640103ab8$export$53a6892c50694894)
}, $6e0e0f5559cb846e$export$8d623b1670eb40f4 = (t = $6e0e0f5559cb846e$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $6e0e0f5559cb846e$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $6e0e0f5559cb846e$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6d01d14c9cac29de$export$ca000e230c0caa3e(r) {
    return (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3cea02b23362a4ee$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $68ee97ae0469729c$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5cd9237fa003a3a1$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $68ee97ae0469729c$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $68ee97ae0469729c$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $75db05283255479d$var$e;
function $75db05283255479d$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $68ee97ae0469729c$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($75db05283255479d$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ec516e9dde468e7a$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $68ee97ae0469729c$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $73afb0f2386993e6$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $68ee97ae0469729c$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $608d951ae8f7ed41$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $68ee97ae0469729c$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




// src/components/spinner/spinner.styles.ts

var $421fcd489d4fd2e2$export$6a9ed4d91972acb3 = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`;


// src/translations/en.ts
const $590c5519b5ebe868$var$connectedElements = new Set();
const $590c5519b5ebe868$var$translations = new Map();
let $590c5519b5ebe868$var$fallback;
let $590c5519b5ebe868$var$documentDirection = "ltr";
let $590c5519b5ebe868$var$documentLanguage = "en";
const $590c5519b5ebe868$var$isClient = typeof MutationObserver !== "undefined" && typeof document !== "undefined" && typeof document.documentElement !== "undefined";
if ($590c5519b5ebe868$var$isClient) {
    const documentElementObserver = new MutationObserver($590c5519b5ebe868$export$722fbec263ad908a);
    $590c5519b5ebe868$var$documentDirection = document.documentElement.dir || "ltr";
    $590c5519b5ebe868$var$documentLanguage = document.documentElement.lang || navigator.language;
    documentElementObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [
            "dir",
            "lang"
        ]
    });
}
function $590c5519b5ebe868$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($590c5519b5ebe868$var$translations.has(code)) $590c5519b5ebe868$var$translations.set(code, Object.assign(Object.assign({}, $590c5519b5ebe868$var$translations.get(code)), t));
        else $590c5519b5ebe868$var$translations.set(code, t);
        if (!$590c5519b5ebe868$var$fallback) $590c5519b5ebe868$var$fallback = t;
    });
    $590c5519b5ebe868$export$722fbec263ad908a();
}
function $590c5519b5ebe868$export$722fbec263ad908a() {
    if ($590c5519b5ebe868$var$isClient) {
        $590c5519b5ebe868$var$documentDirection = document.documentElement.dir || "ltr";
        $590c5519b5ebe868$var$documentLanguage = document.documentElement.lang || navigator.language;
    }
    [
        ...$590c5519b5ebe868$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === "function") el.requestUpdate();
    });
}
class $590c5519b5ebe868$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $590c5519b5ebe868$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $590c5519b5ebe868$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $590c5519b5ebe868$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $590c5519b5ebe868$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang.replace(/_/g, "-"));
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        const primary = $590c5519b5ebe868$var$translations.get(`${language}-${region}`);
        const secondary = $590c5519b5ebe868$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $590c5519b5ebe868$var$fallback && $590c5519b5ebe868$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($590c5519b5ebe868$var$fallback && $590c5519b5ebe868$var$fallback[key]) term = $590c5519b5ebe868$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === "function") return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? "" : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $073c410a1763b05a$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format"
};
(0, $590c5519b5ebe868$export$2332cb3ce32cc839)($073c410a1763b05a$var$translation);
var $073c410a1763b05a$export$802b895dc4aecf21 = $073c410a1763b05a$var$translation;



var $ee8bab24ffe7842c$export$b1a2fed5bb41b893 = class extends (0, $590c5519b5ebe868$export$b1a2fed5bb41b893) {
};
(0, $590c5519b5ebe868$export$2332cb3ce32cc839)((0, $073c410a1763b05a$export$802b895dc4aecf21));


// src/styles/component.styles.ts

var $addc8cb295a9e492$export$e1ac0a3ec62d1269 = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;


var $404f90d4544da778$var$__defProp = Object.defineProperty;
var $404f90d4544da778$var$__defProps = Object.defineProperties;
var $404f90d4544da778$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $404f90d4544da778$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $404f90d4544da778$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $404f90d4544da778$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $404f90d4544da778$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $404f90d4544da778$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $404f90d4544da778$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $404f90d4544da778$var$__defNormalProp = (obj, key, value)=>key in obj ? $404f90d4544da778$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $404f90d4544da778$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($404f90d4544da778$var$__hasOwnProp.call(b, prop)) $404f90d4544da778$var$__defNormalProp(a, prop, b[prop]);
    if ($404f90d4544da778$var$__getOwnPropSymbols) {
        for (var prop of $404f90d4544da778$var$__getOwnPropSymbols(b))if ($404f90d4544da778$var$__propIsEnum.call(b, prop)) $404f90d4544da778$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $404f90d4544da778$export$f4da8f157c1253f7 = (a, b)=>$404f90d4544da778$var$__defProps(a, $404f90d4544da778$var$__getOwnPropDescs(b));
var $404f90d4544da778$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $404f90d4544da778$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $404f90d4544da778$var$__defProp(target, key, result);
    return result;
};
var $404f90d4544da778$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $404f90d4544da778$var$__typeError("Cannot " + msg);
var $404f90d4544da778$export$18a094aefa070634 = (obj, member, getter)=>($404f90d4544da778$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $404f90d4544da778$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $404f90d4544da778$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $404f90d4544da778$export$42432efe6614d3b4 = (obj, member, value, setter)=>($404f90d4544da778$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $404f90d4544da778$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $404f90d4544da778$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$404f90d4544da778$var$__knownSymbol("asyncIterator")], isAwait = false, method, it = {};
    if (obj == null) {
        obj = value[$404f90d4544da778$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $404f90d4544da778$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) $404f90d4544da778$var$__typeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$404f90d4544da778$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};




var $8b52307a307de42f$var$_hasRecordedInitialProperties;
var $8b52307a307de42f$export$6f25236e887097b = class extends (0, $23a6037be2405355$export$3f2f9f5909897157) {
    constructor(){
        super();
        (0, $404f90d4544da778$export$addf369becd23283)(this, $8b52307a307de42f$var$_hasRecordedInitialProperties, false);
        // Store the constructor value of all `static properties = {}`
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $404f90d4544da778$export$7de063a7aa429f6c)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options);
            } catch (_err) {
                customElements.define(name, class extends elementConstructor {
                }, options);
            }
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $404f90d4544da778$export$18a094aefa070634)(this, $8b52307a307de42f$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $404f90d4544da778$export$42432efe6614d3b4)(this, $8b52307a307de42f$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
};
$8b52307a307de42f$var$_hasRecordedInitialProperties = new WeakMap();
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$8b52307a307de42f$export$6f25236e887097b.version = "2.19.0";
$8b52307a307de42f$export$6f25236e887097b.dependencies = {};
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $8b52307a307de42f$export$6f25236e887097b.prototype, "dir", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $8b52307a307de42f$export$6f25236e887097b.prototype, "lang", 2);



var $2e8370cdb0d67f31$export$4e45ce56e46d2b00 = class extends (0, $8b52307a307de42f$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $ee8bab24ffe7842c$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$2e8370cdb0d67f31$export$4e45ce56e46d2b00.styles = [
    (0, $addc8cb295a9e492$export$e1ac0a3ec62d1269),
    (0, $421fcd489d4fd2e2$export$6a9ed4d91972acb3)
];



// src/internal/form.ts
var $d883bb20703c4ea2$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $d883bb20703c4ea2$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $d883bb20703c4ea2$var$checkValidityOverloads = /* @__PURE__ */ new WeakMap();
var $d883bb20703c4ea2$var$userInteractedControls = /* @__PURE__ */ new WeakSet();
var $d883bb20703c4ea2$var$interactions = /* @__PURE__ */ new WeakMap();
var $d883bb20703c4ea2$export$43da334182d34ab4 = class {
    constructor(host, options){
        this.handleFormData = (event)=>{
            const disabled = this.options.disabled(this.host);
            const name = this.options.name(this.host);
            const value = this.options.value(this.host);
            const isButton = this.host.tagName.toLowerCase() === "sl-button";
            if (this.host.isConnected && !disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
                if (Array.isArray(value)) value.forEach((val)=>{
                    event.formData.append(name, val.toString());
                });
                else event.formData.append(name, value.toString());
            }
        };
        this.handleFormSubmit = (event)=>{
            var _a;
            const disabled = this.options.disabled(this.host);
            const reportValidity = this.options.reportValidity;
            if (this.form && !this.form.noValidate) (_a = $d883bb20703c4ea2$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
                this.setUserInteracted(control, true);
            });
            if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleFormReset = ()=>{
            this.options.setValue(this.host, this.options.defaultValue(this.host));
            this.setUserInteracted(this.host, false);
            $d883bb20703c4ea2$var$interactions.set(this.host, []);
        };
        this.handleInteraction = (event)=>{
            const emittedEvents = $d883bb20703c4ea2$var$interactions.get(this.host);
            if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
            if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
        };
        this.checkFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.checkValidity === "function") {
                    if (!element.checkValidity()) return false;
                }
            }
            return true;
        };
        this.reportFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.reportValidity === "function") {
                    if (!element.reportValidity()) return false;
                }
            }
            return true;
        };
        (this.host = host).addController(this);
        this.options = (0, $404f90d4544da778$export$7de063a7aa429f6c)({
            form: (input)=>{
                const formId = input.form;
                if (formId) {
                    const root = input.getRootNode();
                    const form = root.querySelector(`#${formId}`);
                    if (form) return form;
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            checkValidity: (input)=>typeof input.checkValidity === "function" ? input.checkValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $d883bb20703c4ea2$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $d883bb20703c4ea2$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($d883bb20703c4ea2$export$61a522b559454891.has(this.form)) $d883bb20703c4ea2$export$61a522b559454891.get(this.form).add(this.host);
            else $d883bb20703c4ea2$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$d883bb20703c4ea2$var$reportValidityOverloads.has(this.form)) {
                $d883bb20703c4ea2$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
            if (!$d883bb20703c4ea2$var$checkValidityOverloads.has(this.form)) {
                $d883bb20703c4ea2$var$checkValidityOverloads.set(this.form, this.form.checkValidity);
                this.form.checkValidity = ()=>this.checkFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        if (!this.form) return;
        const formCollection = $d883bb20703c4ea2$export$61a522b559454891.get(this.form);
        if (!formCollection) return;
        formCollection.delete(this.host);
        if (formCollection.size <= 0) {
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($d883bb20703c4ea2$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $d883bb20703c4ea2$var$reportValidityOverloads.get(this.form);
                $d883bb20703c4ea2$var$reportValidityOverloads.delete(this.form);
            }
            if ($d883bb20703c4ea2$var$checkValidityOverloads.has(this.form)) {
                this.form.checkValidity = $d883bb20703c4ea2$var$checkValidityOverloads.get(this.form);
                $d883bb20703c4ea2$var$checkValidityOverloads.delete(this.form);
            }
            this.form = void 0;
        }
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $d883bb20703c4ea2$var$userInteractedControls.add(el);
        else $d883bb20703c4ea2$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, submitter) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (submitter) {
                button.name = submitter.name;
                button.value = submitter.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (submitter.hasAttribute(attr)) button.setAttribute(attr, submitter.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(submitter) {
        this.doAction("reset", submitter);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(submitter) {
        this.doAction("submit", submitter);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($d883bb20703c4ea2$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $d883bb20703c4ea2$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $d883bb20703c4ea2$export$bd584164a4d1886c = Object.freeze((0, $404f90d4544da778$export$f4da8f157c1253f7)((0, $404f90d4544da778$export$7de063a7aa429f6c)({}, $d883bb20703c4ea2$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $d883bb20703c4ea2$export$d17679f2bc5863d4 = Object.freeze((0, $404f90d4544da778$export$f4da8f157c1253f7)((0, $404f90d4544da778$export$7de063a7aa429f6c)({}, $d883bb20703c4ea2$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));


// src/components/button/button.styles.ts

var $cb5e66b85ec26f9c$export$172eea9c07ee1ffd = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host([data-sl-button-group__button--first]:not([data-sl-button-group__button--last])) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host([data-sl-button-group__button--inner]) .button {
    border-radius: 0;
  }

  :host([data-sl-button-group__button--last]:not([data-sl-button-group__button--first])) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host([data-sl-button-group__button]:not([data-sl-button-group__button--first])) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      [data-sl-button-group__button]:not(
          [data-sl-button-group__button--first],
          [data-sl-button-group__button--radio],
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host([data-sl-button-group__button--hover]) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host([data-sl-button-group__button--focus]),
  :host([data-sl-button-group__button][checked]) {
    z-index: 2;
  }
`;



// src/internal/slot.ts
var $33ad8e2983048465$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        this.handleSlotChange = (event)=>{
            const slot = event.target;
            if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
};
function $33ad8e2983048465$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}


// src/utilities/base-path.ts
var $db60d47e77a41b60$var$basePath = "";
function $db60d47e77a41b60$export$784ad41d332938c6(path) {
    $db60d47e77a41b60$var$basePath = path;
}
function $db60d47e77a41b60$export$9099264ed9b1c55a(subpath = "") {
    if (!$db60d47e77a41b60$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $db60d47e77a41b60$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>{
                return /shoelace(\.min)?\.js($|\?)/.test(s.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(s.src);
            });
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $db60d47e77a41b60$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $db60d47e77a41b60$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}


// src/components/icon/library.default.ts
var $882eb842db449ecd$var$library = {
    name: "default",
    resolver: (name)=>(0, $db60d47e77a41b60$export$9099264ed9b1c55a)(`assets/icons/${name}.svg`)
};
var $882eb842db449ecd$export$761783e099ce3526 = $882eb842db449ecd$var$library;


// src/components/icon/library.system.ts
var $ccdc8faf6a174717$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $ccdc8faf6a174717$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $ccdc8faf6a174717$var$icons) return `data:image/svg+xml,${encodeURIComponent($ccdc8faf6a174717$var$icons[name])}`;
        return "";
    }
};
var $ccdc8faf6a174717$export$3139252f9828970f = $ccdc8faf6a174717$var$systemLibrary;


// src/components/icon/library.ts
var $c45d14782a8c24c4$var$registry = [
    (0, $882eb842db449ecd$export$761783e099ce3526),
    (0, $ccdc8faf6a174717$export$3139252f9828970f)
];
var $c45d14782a8c24c4$var$watchedIcons = [];
function $c45d14782a8c24c4$export$da63f424a7208010(icon) {
    $c45d14782a8c24c4$var$watchedIcons.push(icon);
}
function $c45d14782a8c24c4$export$9e46b25ecab82f0b(icon) {
    $c45d14782a8c24c4$var$watchedIcons = $c45d14782a8c24c4$var$watchedIcons.filter((el)=>el !== icon);
}
function $c45d14782a8c24c4$export$be026de5111f322b(name) {
    return $c45d14782a8c24c4$var$registry.find((lib)=>lib.name === name);
}
function $c45d14782a8c24c4$export$a482e04ad60c9b11(name, options) {
    $c45d14782a8c24c4$export$8faa256e94012669(name);
    $c45d14782a8c24c4$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $c45d14782a8c24c4$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $c45d14782a8c24c4$export$8faa256e94012669(name) {
    $c45d14782a8c24c4$var$registry = $c45d14782a8c24c4$var$registry.filter((lib)=>lib.name !== name);
}


// src/components/icon/icon.styles.ts

var $620f87b7bb7f635a$export$f0b0874d64866432 = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;



// src/internal/watch.ts
function $19a36fe85b85ec36$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $404f90d4544da778$export$7de063a7aa429f6c)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}







/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $e68a8f59ab8a651d$var$t } = (0, $15085907dd60083a$export$8613d1ca9052b22e), $e68a8f59ab8a651d$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $e68a8f59ab8a651d$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $e68a8f59ab8a651d$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $e68a8f59ab8a651d$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $e68a8f59ab8a651d$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $e68a8f59ab8a651d$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $e68a8f59ab8a651d$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $e68a8f59ab8a651d$var$s = ()=>document.createComment(""), $e68a8f59ab8a651d$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($e68a8f59ab8a651d$var$s(), l), c = e.insertBefore($e68a8f59ab8a651d$var$s(), l);
        n = new $e68a8f59ab8a651d$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $e68a8f59ab8a651d$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $e68a8f59ab8a651d$var$u = {}, $e68a8f59ab8a651d$export$ea70d9dd5965b1c8 = (o, t = $e68a8f59ab8a651d$var$u)=>o._$AH = t, $e68a8f59ab8a651d$export$59e9bce518cde500 = (o)=>o._$AH, $e68a8f59ab8a651d$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $e68a8f59ab8a651d$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};





var $7e59a3db81a65dd5$var$CACHEABLE_ERROR = Symbol();
var $7e59a3db81a65dd5$var$RETRYABLE_ERROR = Symbol();
var $7e59a3db81a65dd5$var$parser;
var $7e59a3db81a65dd5$var$iconCache = /* @__PURE__ */ new Map();
var $7e59a3db81a65dd5$export$ef62a86bf282441 = class extends (0, $8b52307a307de42f$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.initialRender = false;
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        var _a;
        let fileData;
        if (library == null ? void 0 : library.spriteSheet) {
            this.svg = (0, $15085907dd60083a$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
            return this.svg;
        }
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $7e59a3db81a65dd5$var$CACHEABLE_ERROR : $7e59a3db81a65dd5$var$RETRYABLE_ERROR;
        } catch (e) {
            return $7e59a3db81a65dd5$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (((_a = svg == null ? void 0 : svg.tagName) == null ? void 0 : _a.toLowerCase()) !== "svg") return $7e59a3db81a65dd5$var$CACHEABLE_ERROR;
            if (!$7e59a3db81a65dd5$var$parser) $7e59a3db81a65dd5$var$parser = new DOMParser();
            const doc = $7e59a3db81a65dd5$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $7e59a3db81a65dd5$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch (e) {
            return $7e59a3db81a65dd5$var$CACHEABLE_ERROR;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $c45d14782a8c24c4$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.initialRender = true;
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $c45d14782a8c24c4$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $c45d14782a8c24c4$export$be026de5111f322b)(this.library);
        if (this.name && library) return {
            url: library.resolver(this.name),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $c45d14782a8c24c4$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $7e59a3db81a65dd5$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $7e59a3db81a65dd5$var$iconCache.set(url, iconResolver);
        }
        if (!this.initialRender) return;
        const svg = await iconResolver;
        if (svg === $7e59a3db81a65dd5$var$RETRYABLE_ERROR) $7e59a3db81a65dd5$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $e68a8f59ab8a651d$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            if (library) {
                await this.updateComplete;
                const shadowSVG = this.shadowRoot.querySelector("[part='svg']");
                if (typeof library.mutator === "function" && shadowSVG) library.mutator(shadowSVG);
            }
            return;
        }
        switch(svg){
            case $7e59a3db81a65dd5$var$RETRYABLE_ERROR:
            case $7e59a3db81a65dd5$var$CACHEABLE_ERROR:
                this.svg = null;
                this.emit("sl-error");
                break;
            default:
                this.svg = svg.cloneNode(true);
                (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, this.svg);
                this.emit("sl-load");
        }
    }
    render() {
        return this.svg;
    }
};
$7e59a3db81a65dd5$export$ef62a86bf282441.styles = [
    (0, $addc8cb295a9e492$export$e1ac0a3ec62d1269),
    (0, $620f87b7bb7f635a$export$f0b0874d64866432)
];
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6d01d14c9cac29de$export$ca000e230c0caa3e)()
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "svg", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        reflect: true
    })
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "name", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "src", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "label", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        reflect: true
    })
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "library", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $19a36fe85b85ec36$export$3db5d71bdb2d5499)("label")
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $19a36fe85b85ec36$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $7e59a3db81a65dd5$export$ef62a86bf282441.prototype, "setIcon", 1);







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ef5d551bac068455$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $ef5d551bac068455$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $ef5d551bac068455$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $00cc9ecb5a3946e1$export$56cc687933817664 = (0, $ef5d551bac068455$export$99b43ad1ed32e735)(class extends (0, $ef5d551bac068455$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $ef5d551bac068455$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $15085907dd60083a$export$9c068ae9cc5db4e8;
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a08159d5e759130e$var$a = Symbol.for(""), $a08159d5e759130e$var$o = (t)=>{
    if (t?.r === $a08159d5e759130e$var$a) return t?._$litStatic$;
}, $a08159d5e759130e$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $a08159d5e759130e$var$a
    }), $a08159d5e759130e$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, a)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[a + 1], t[0]),
        r: $a08159d5e759130e$var$a
    }), $a08159d5e759130e$var$l = new Map, $a08159d5e759130e$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const a = e.length;
        let s, i;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < a;){
            for(c = r[$]; $ < a && void 0 !== (i = e[$], s = $a08159d5e759130e$var$o(i));)c += s + r[++$], f = !0;
            $ !== a && u.push(i), n.push(c), $++;
        }
        if ($ === a && n.push(r[a]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $a08159d5e759130e$var$l.get(t)) && (n.raw = n, $a08159d5e759130e$var$l.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $a08159d5e759130e$export$c0bb0b647f701bb5 = $a08159d5e759130e$export$878791788f808fc0((0, $15085907dd60083a$export$c0bb0b647f701bb5)), $a08159d5e759130e$export$7ed1367e7fa1ad68 = $a08159d5e759130e$export$878791788f808fc0((0, $15085907dd60083a$export$7ed1367e7fa1ad68)), $a08159d5e759130e$export$47d5b44d225be5b4 = $a08159d5e759130e$export$878791788f808fc0((0, $15085907dd60083a$export$47d5b44d225be5b4));





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c3a3654b93baefbb$export$f68dd208b5df064d = (o)=>o ?? (0, $15085907dd60083a$export$45b790e32b2810ee);





var $a7528ec6dd003dd6$export$e56d306ebf763f31 = class extends (0, $8b52307a307de42f$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $d883bb20703c4ea2$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $33ad8e2983048465$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $ee8bab24ffe7842c$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $d883bb20703c4ea2$export$6c5960ddf0f5ff89;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $a08159d5e759130e$export$c8ec6e1ec9fefcb0)`a` : (0, $a08159d5e759130e$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $a08159d5e759130e$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $00cc9ecb5a3946e1$export$56cc687933817664)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : this.name)}
        value=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : this.value)}
        href=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink && !this.disabled ? this.href : void 0)}
        target=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? this.rel : void 0)}
        role=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $a08159d5e759130e$export$c0bb0b647f701bb5)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $a08159d5e759130e$export$c0bb0b647f701bb5)`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$a7528ec6dd003dd6$export$e56d306ebf763f31.styles = [
    (0, $addc8cb295a9e492$export$e1ac0a3ec62d1269),
    (0, $cb5e66b85ec26f9c$export$172eea9c07ee1ffd)
];
$a7528ec6dd003dd6$export$e56d306ebf763f31.dependencies = {
    "sl-icon": (0, $7e59a3db81a65dd5$export$ef62a86bf282441),
    "sl-spinner": (0, $2e8370cdb0d67f31$export$4e45ce56e46d2b00)
};
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $5cd9237fa003a3a1$export$2fa187e846a241c4)(".button")
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "button", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6d01d14c9cac29de$export$ca000e230c0caa3e)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6d01d14c9cac29de$export$ca000e230c0caa3e)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "title", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "size", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "type", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "name", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "value", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "href", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "target", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "download", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "form", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "formaction"
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "formenctype"
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "formmethod"
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "formtarget"
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $19a36fe85b85ec36$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $a7528ec6dd003dd6$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);


// src/components/button/button.ts
var $cf309e115e41d5be$export$11c362adf4e83e40 = (0, $a7528ec6dd003dd6$export$e56d306ebf763f31);
(0, $a7528ec6dd003dd6$export$e56d306ebf763f31).define("sl-button");






















// src/internal/tabbable.ts
var $4a5f849fcbf922be$var$computedStyleMap = /* @__PURE__ */ new WeakMap();
function $4a5f849fcbf922be$var$getCachedComputedStyle(el) {
    let computedStyle = $4a5f849fcbf922be$var$computedStyleMap.get(el);
    if (!computedStyle) {
        computedStyle = window.getComputedStyle(el, null);
        $4a5f849fcbf922be$var$computedStyleMap.set(el, computedStyle);
    }
    return computedStyle;
}
function $4a5f849fcbf922be$var$isVisible(el) {
    if (typeof el.checkVisibility === "function") return el.checkVisibility({
        checkOpacity: false,
        checkVisibilityCSS: true
    });
    const computedStyle = $4a5f849fcbf922be$var$getCachedComputedStyle(el);
    return computedStyle.visibility !== "hidden" && computedStyle.display !== "none";
}
function $4a5f849fcbf922be$var$isOverflowingAndTabbable(el) {
    const computedStyle = $4a5f849fcbf922be$var$getCachedComputedStyle(el);
    const { overflowY: overflowY, overflowX: overflowX } = computedStyle;
    if (overflowY === "scroll" || overflowX === "scroll") return true;
    if (overflowY !== "auto" || overflowX !== "auto") return false;
    const isOverflowingY = el.scrollHeight > el.clientHeight;
    if (isOverflowingY && overflowY === "auto") return true;
    const isOverflowingX = el.scrollWidth > el.clientWidth;
    if (isOverflowingX && overflowX === "auto") return true;
    return false;
}
function $4a5f849fcbf922be$var$isTabbable(el) {
    const tag = el.tagName.toLowerCase();
    const tabindex = Number(el.getAttribute("tabindex"));
    const hasTabindex = el.hasAttribute("tabindex");
    if (hasTabindex && (isNaN(tabindex) || tabindex <= -1)) return false;
    if (el.hasAttribute("disabled")) return false;
    if (el.closest("[inert]")) return false;
    if (tag === "input" && el.getAttribute("type") === "radio" && !el.hasAttribute("checked")) return false;
    if (!$4a5f849fcbf922be$var$isVisible(el)) return false;
    if ((tag === "audio" || tag === "video") && el.hasAttribute("controls")) return true;
    if (el.hasAttribute("tabindex")) return true;
    if (el.hasAttribute("contenteditable") && el.getAttribute("contenteditable") !== "false") return true;
    const isNativelyTabbable = [
        "button",
        "input",
        "select",
        "textarea",
        "a",
        "audio",
        "video",
        "summary",
        "iframe"
    ].includes(tag);
    if (isNativelyTabbable) return true;
    return $4a5f849fcbf922be$var$isOverflowingAndTabbable(el);
}
function $4a5f849fcbf922be$export$16b821ece3e89e24(root) {
    var _a, _b;
    const tabbableElements = $4a5f849fcbf922be$export$59a770a0e59b0dd2(root);
    const start = (_a = tabbableElements[0]) != null ? _a : null;
    const end = (_b = tabbableElements[tabbableElements.length - 1]) != null ? _b : null;
    return {
        start: start,
        end: end
    };
}
function $4a5f849fcbf922be$var$getSlottedChildrenOutsideRootElement(slotElement, root) {
    var _a;
    return ((_a = slotElement.getRootNode({
        composed: true
    })) == null ? void 0 : _a.host) !== root;
}
function $4a5f849fcbf922be$export$59a770a0e59b0dd2(root) {
    const walkedEls = /* @__PURE__ */ new WeakMap();
    const tabbableElements = [];
    function walk(el) {
        if (el instanceof Element) {
            if (el.hasAttribute("inert") || el.closest("[inert]")) return;
            if (walkedEls.has(el)) return;
            walkedEls.set(el, true);
            if (!tabbableElements.includes(el) && $4a5f849fcbf922be$var$isTabbable(el)) tabbableElements.push(el);
            if (el instanceof HTMLSlotElement && $4a5f849fcbf922be$var$getSlottedChildrenOutsideRootElement(el, root)) el.assignedElements({
                flatten: true
            }).forEach((assignedEl)=>{
                walk(assignedEl);
            });
            if (el.shadowRoot !== null && el.shadowRoot.mode === "open") walk(el.shadowRoot);
        }
        for (const e of el.children)walk(e);
    }
    walk(root);
    return tabbableElements.sort((a, b)=>{
        const aTabindex = Number(a.getAttribute("tabindex")) || 0;
        const bTabindex = Number(b.getAttribute("tabindex")) || 0;
        return bTabindex - aTabindex;
    });
}



// src/internal/active-elements.ts
function* $aff751edd9d999a9$var$activeElements(activeElement = document.activeElement) {
    if (activeElement === null || activeElement === void 0) return;
    yield activeElement;
    if ("shadowRoot" in activeElement && activeElement.shadowRoot && activeElement.shadowRoot.mode !== "closed") yield* (0, $404f90d4544da778$export$5590fd18e5672c2)($aff751edd9d999a9$var$activeElements(activeElement.shadowRoot.activeElement));
}
function $aff751edd9d999a9$var$getDeepestActiveElement() {
    return [
        ...$aff751edd9d999a9$var$activeElements()
    ].pop();
}
// src/internal/modal.ts
var $aff751edd9d999a9$var$activeModals = [];
var $aff751edd9d999a9$export$2b77a92f1a5ad772 = class {
    constructor(element){
        this.tabDirection = "forward";
        this.handleFocusIn = ()=>{
            if (!this.isActive()) return;
            this.checkFocus();
        };
        this.handleKeyDown = (event)=>{
            var _a;
            if (event.key !== "Tab" || this.isExternalActivated) return;
            if (!this.isActive()) return;
            const currentActiveElement = $aff751edd9d999a9$var$getDeepestActiveElement();
            this.previousFocus = currentActiveElement;
            if (this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus)) return;
            if (event.shiftKey) this.tabDirection = "backward";
            else this.tabDirection = "forward";
            const tabbableElements = (0, $4a5f849fcbf922be$export$59a770a0e59b0dd2)(this.element);
            let currentFocusIndex = tabbableElements.findIndex((el)=>el === currentActiveElement);
            this.previousFocus = this.currentFocus;
            const addition = this.tabDirection === "forward" ? 1 : -1;
            while(true){
                if (currentFocusIndex + addition >= tabbableElements.length) currentFocusIndex = 0;
                else if (currentFocusIndex + addition < 0) currentFocusIndex = tabbableElements.length - 1;
                else currentFocusIndex += addition;
                this.previousFocus = this.currentFocus;
                const nextFocus = /** @type {HTMLElement} */ tabbableElements[currentFocusIndex];
                if (this.tabDirection === "backward") {
                    if (this.previousFocus && this.possiblyHasTabbableChildren(this.previousFocus)) return;
                }
                if (nextFocus && this.possiblyHasTabbableChildren(nextFocus)) return;
                event.preventDefault();
                this.currentFocus = nextFocus;
                (_a = this.currentFocus) == null || _a.focus({
                    preventScroll: false
                });
                const allActiveElements = [
                    ...$aff751edd9d999a9$var$activeElements()
                ];
                if (allActiveElements.includes(this.currentFocus) || !allActiveElements.includes(this.previousFocus)) break;
            }
            setTimeout(()=>this.checkFocus());
        };
        this.handleKeyUp = ()=>{
            this.tabDirection = "forward";
        };
        this.element = element;
        this.elementsWithTabbableControls = [
            "iframe"
        ];
    }
    /** Activates focus trapping. */ activate() {
        $aff751edd9d999a9$var$activeModals.push(this.element);
        document.addEventListener("focusin", this.handleFocusIn);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("keyup", this.handleKeyUp);
    }
    /** Deactivates focus trapping. */ deactivate() {
        $aff751edd9d999a9$var$activeModals = $aff751edd9d999a9$var$activeModals.filter((modal)=>modal !== this.element);
        this.currentFocus = null;
        document.removeEventListener("focusin", this.handleFocusIn);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("keyup", this.handleKeyUp);
    }
    /** Determines if this modal element is currently active or not. */ isActive() {
        return $aff751edd9d999a9$var$activeModals[$aff751edd9d999a9$var$activeModals.length - 1] === this.element;
    }
    /** Activates external modal behavior and temporarily disables focus trapping. */ activateExternal() {
        this.isExternalActivated = true;
    }
    /** Deactivates external modal behavior and re-enables focus trapping. */ deactivateExternal() {
        this.isExternalActivated = false;
    }
    checkFocus() {
        if (this.isActive() && !this.isExternalActivated) {
            const tabbableElements = (0, $4a5f849fcbf922be$export$59a770a0e59b0dd2)(this.element);
            if (!this.element.matches(":focus-within")) {
                const start = tabbableElements[0];
                const end = tabbableElements[tabbableElements.length - 1];
                const target = this.tabDirection === "forward" ? start : end;
                if (typeof (target == null ? void 0 : target.focus) === "function") {
                    this.currentFocus = target;
                    target.focus({
                        preventScroll: false
                    });
                }
            }
        }
    }
    possiblyHasTabbableChildren(element) {
        return this.elementsWithTabbableControls.includes(element.tagName.toLowerCase()) || element.hasAttribute("controls");
    }
};


// src/internal/offset.ts
function $3ae6649e904c3d31$var$getOffset(element, parent) {
    return {
        top: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        left: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left)
    };
}
// src/internal/scroll.ts
var $3ae6649e904c3d31$var$locks = /* @__PURE__ */ new Set();
function $3ae6649e904c3d31$var$getScrollbarWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
function $3ae6649e904c3d31$var$getExistingBodyPadding() {
    const padding = Number(getComputedStyle(document.body).paddingRight.replace(/px/, ""));
    if (isNaN(padding) || !padding) return 0;
    return padding;
}
function $3ae6649e904c3d31$export$5f4bd35c67f2403d(lockingEl) {
    $3ae6649e904c3d31$var$locks.add(lockingEl);
    if (!document.documentElement.classList.contains("sl-scroll-lock")) {
        const scrollbarWidth = $3ae6649e904c3d31$var$getScrollbarWidth() + $3ae6649e904c3d31$var$getExistingBodyPadding();
        let scrollbarGutterProperty = getComputedStyle(document.documentElement).scrollbarGutter;
        if (!scrollbarGutterProperty || scrollbarGutterProperty === "auto") scrollbarGutterProperty = "stable";
        if (scrollbarWidth < 2) scrollbarGutterProperty = "";
        document.documentElement.style.setProperty("--sl-scroll-lock-gutter", scrollbarGutterProperty);
        document.documentElement.classList.add("sl-scroll-lock");
        document.documentElement.style.setProperty("--sl-scroll-lock-size", `${scrollbarWidth}px`);
    }
}
function $3ae6649e904c3d31$export$7475b4759872c980(lockingEl) {
    $3ae6649e904c3d31$var$locks.delete(lockingEl);
    if ($3ae6649e904c3d31$var$locks.size === 0) {
        document.documentElement.classList.remove("sl-scroll-lock");
        document.documentElement.style.removeProperty("--sl-scroll-lock-size");
    }
}
function $3ae6649e904c3d31$export$53a0910f038337bd(element, container, direction = "vertical", behavior = "smooth") {
    const offset = $3ae6649e904c3d31$var$getOffset(element, container);
    const offsetTop = offset.top + container.scrollTop;
    const offsetLeft = offset.left + container.scrollLeft;
    const minX = container.scrollLeft;
    const maxX = container.scrollLeft + container.offsetWidth;
    const minY = container.scrollTop;
    const maxY = container.scrollTop + container.offsetHeight;
    if (direction === "horizontal" || direction === "both") {
        if (offsetLeft < minX) container.scrollTo({
            left: offsetLeft,
            behavior: behavior
        });
        else if (offsetLeft + element.clientWidth > maxX) container.scrollTo({
            left: offsetLeft - container.offsetWidth + element.clientWidth,
            behavior: behavior
        });
    }
    if (direction === "vertical" || direction === "both") {
        if (offsetTop < minY) container.scrollTo({
            top: offsetTop,
            behavior: behavior
        });
        else if (offsetTop + element.clientHeight > maxY) container.scrollTo({
            top: offsetTop - container.offsetHeight + element.clientHeight,
            behavior: behavior
        });
    }
}


// src/components/dialog/dialog.styles.ts

var $125c3fa4f5423f77$export$b752f4490c3ab6b1 = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`;


// src/components/icon-button/icon-button.styles.ts

var $c063dd3c97535f65$export$e7174f10cedebf49 = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;










var $252bf9a6aa791ff8$export$302c9d29315a4659 = class extends (0, $8b52307a307de42f$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $a08159d5e759130e$export$c8ec6e1ec9fefcb0)`a` : (0, $a08159d5e759130e$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $a08159d5e759130e$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $00cc9ecb5a3946e1$export$56cc687933817664)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        href=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(this.name)}
          library=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(this.library)}
          src=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$252bf9a6aa791ff8$export$302c9d29315a4659.styles = [
    (0, $addc8cb295a9e492$export$e1ac0a3ec62d1269),
    (0, $c063dd3c97535f65$export$e7174f10cedebf49)
];
$252bf9a6aa791ff8$export$302c9d29315a4659.dependencies = {
    "sl-icon": (0, $7e59a3db81a65dd5$export$ef62a86bf282441)
};
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $5cd9237fa003a3a1$export$2fa187e846a241c4)(".icon-button")
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "button", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6d01d14c9cac29de$export$ca000e230c0caa3e)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "name", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "library", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "src", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "href", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "target", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "download", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "label", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $252bf9a6aa791ff8$export$302c9d29315a4659.prototype, "disabled", 2);



// src/utilities/animation-registry.ts
var $2ef78de296e47de8$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $2ef78de296e47de8$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $2ef78de296e47de8$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $2ef78de296e47de8$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $2ef78de296e47de8$export$6e92ecdbe15fda0b(animationName, animation) {
    $2ef78de296e47de8$var$defaultAnimationRegistry.set(animationName, $2ef78de296e47de8$var$ensureAnimation(animation));
}
function $2ef78de296e47de8$export$ea45326d94a48a31(el, animationName, animation) {
    $2ef78de296e47de8$var$customAnimationRegistry.set(el, (0, $404f90d4544da778$export$f4da8f157c1253f7)((0, $404f90d4544da778$export$7de063a7aa429f6c)({}, $2ef78de296e47de8$var$customAnimationRegistry.get(el)), {
        [animationName]: $2ef78de296e47de8$var$ensureAnimation(animation)
    }));
}
function $2ef78de296e47de8$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $2ef78de296e47de8$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $2ef78de296e47de8$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $2ef78de296e47de8$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $2ef78de296e47de8$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $98cbdc3aafa75846$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



// src/internal/animate.ts
function $5136dcd0d04e6de6$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $404f90d4544da778$export$f4da8f157c1253f7)((0, $404f90d4544da778$export$7de063a7aa429f6c)({}, options), {
            duration: $5136dcd0d04e6de6$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $5136dcd0d04e6de6$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $5136dcd0d04e6de6$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $5136dcd0d04e6de6$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            animation.cancel();
            requestAnimationFrame(resolve);
        });
    }));
}
function $5136dcd0d04e6de6$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $404f90d4544da778$export$f4da8f157c1253f7)((0, $404f90d4544da778$export$7de063a7aa429f6c)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}












var $c78f16b8b74ef4c3$export$2a86abe166e5892d = class extends (0, $8b52307a307de42f$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $33ad8e2983048465$export$34f6a5ffaa663541)(this, "footer");
        this.localize = new (0, $ee8bab24ffe7842c$export$b1a2fed5bb41b893)(this);
        this.modal = new (0, $aff751edd9d999a9$export$2b77a92f1a5ad772)(this);
        this.open = false;
        this.label = "";
        this.noHeader = false;
        this.handleDocumentKeyDown = (event)=>{
            if (event.key === "Escape" && this.modal.isActive() && this.open) {
                event.stopPropagation();
                this.requestClose("keyboard");
            }
        };
    }
    firstUpdated() {
        this.dialog.hidden = !this.open;
        if (this.open) {
            this.addOpenListeners();
            this.modal.activate();
            (0, $3ae6649e904c3d31$export$5f4bd35c67f2403d)(this);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.modal.deactivate();
        (0, $3ae6649e904c3d31$export$7475b4759872c980)(this);
        this.removeOpenListeners();
    }
    requestClose(source) {
        const slRequestClose = this.emit("sl-request-close", {
            cancelable: true,
            detail: {
                source: source
            }
        });
        if (slRequestClose.defaultPrevented) {
            const animation = (0, $2ef78de296e47de8$export$b1aed5dec0c2d368)(this, "dialog.denyClose", {
                dir: this.localize.dir()
            });
            (0, $5136dcd0d04e6de6$export$3b755839a54e1bb0)(this.panel, animation.keyframes, animation.options);
            return;
        }
        this.hide();
    }
    addOpenListeners() {
        var _a;
        if ("CloseWatcher" in window) {
            (_a = this.closeWatcher) == null || _a.destroy();
            this.closeWatcher = new CloseWatcher();
            this.closeWatcher.onclose = ()=>this.requestClose("keyboard");
        } else document.addEventListener("keydown", this.handleDocumentKeyDown);
    }
    removeOpenListeners() {
        var _a;
        (_a = this.closeWatcher) == null || _a.destroy();
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            this.addOpenListeners();
            this.originalTrigger = document.activeElement;
            this.modal.activate();
            (0, $3ae6649e904c3d31$export$5f4bd35c67f2403d)(this);
            const autoFocusTarget = this.querySelector("[autofocus]");
            if (autoFocusTarget) autoFocusTarget.removeAttribute("autofocus");
            await Promise.all([
                (0, $5136dcd0d04e6de6$export$ad12f740028ccbea)(this.dialog),
                (0, $5136dcd0d04e6de6$export$ad12f740028ccbea)(this.overlay)
            ]);
            this.dialog.hidden = false;
            requestAnimationFrame(()=>{
                const slInitialFocus = this.emit("sl-initial-focus", {
                    cancelable: true
                });
                if (!slInitialFocus.defaultPrevented) {
                    if (autoFocusTarget) autoFocusTarget.focus({
                        preventScroll: true
                    });
                    else this.panel.focus({
                        preventScroll: true
                    });
                }
                if (autoFocusTarget) autoFocusTarget.setAttribute("autofocus", "");
            });
            const panelAnimation = (0, $2ef78de296e47de8$export$b1aed5dec0c2d368)(this, "dialog.show", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $2ef78de296e47de8$export$b1aed5dec0c2d368)(this, "dialog.overlay.show", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $5136dcd0d04e6de6$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options),
                (0, $5136dcd0d04e6de6$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
            ]);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            this.modal.deactivate();
            await Promise.all([
                (0, $5136dcd0d04e6de6$export$ad12f740028ccbea)(this.dialog),
                (0, $5136dcd0d04e6de6$export$ad12f740028ccbea)(this.overlay)
            ]);
            const panelAnimation = (0, $2ef78de296e47de8$export$b1aed5dec0c2d368)(this, "dialog.hide", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $2ef78de296e47de8$export$b1aed5dec0c2d368)(this, "dialog.overlay.hide", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $5136dcd0d04e6de6$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options).then(()=>{
                    this.overlay.hidden = true;
                }),
                (0, $5136dcd0d04e6de6$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options).then(()=>{
                    this.panel.hidden = true;
                })
            ]);
            this.dialog.hidden = true;
            this.overlay.hidden = false;
            this.panel.hidden = false;
            (0, $3ae6649e904c3d31$export$7475b4759872c980)(this);
            const trigger = this.originalTrigger;
            if (typeof (trigger == null ? void 0 : trigger.focus) === "function") setTimeout(()=>trigger.focus());
            this.emit("sl-after-hide");
        }
    }
    /** Shows the dialog. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $98cbdc3aafa75846$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the dialog */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $98cbdc3aafa75846$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $00cc9ecb5a3946e1$export$56cc687933817664)({
            dialog: true,
            "dialog--open": this.open,
            "dialog--has-footer": this.hasSlotController.test("footer")
        })}
      >
        <div part="overlay" class="dialog__overlay" @click=${()=>this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(this.noHeader ? this.label : void 0)}
          aria-labelledby=${(0, $c3a3654b93baefbb$export$f68dd208b5df064d)(!this.noHeader ? "title" : void 0)}
          tabindex="-1"
        >
          ${!this.noHeader ? (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : String.fromCharCode(65279)} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${()=>this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              ` : ""}
          ${""}
          <div part="body" class="dialog__body" tabindex="-1"><slot></slot></div>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
    }
};
$c78f16b8b74ef4c3$export$2a86abe166e5892d.styles = [
    (0, $addc8cb295a9e492$export$e1ac0a3ec62d1269),
    (0, $125c3fa4f5423f77$export$b752f4490c3ab6b1)
];
$c78f16b8b74ef4c3$export$2a86abe166e5892d.dependencies = {
    "sl-icon-button": (0, $252bf9a6aa791ff8$export$302c9d29315a4659)
};
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $5cd9237fa003a3a1$export$2fa187e846a241c4)(".dialog")
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "dialog", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $5cd9237fa003a3a1$export$2fa187e846a241c4)(".dialog__panel")
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "panel", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $5cd9237fa003a3a1$export$2fa187e846a241c4)(".dialog__overlay")
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "overlay", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "open", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        reflect: true
    })
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "label", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "no-header",
        type: Boolean,
        reflect: true
    })
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "noHeader", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $19a36fe85b85ec36$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $c78f16b8b74ef4c3$export$2a86abe166e5892d.prototype, "handleOpenChange", 1);
(0, $2ef78de296e47de8$export$6e92ecdbe15fda0b)("dialog.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $2ef78de296e47de8$export$6e92ecdbe15fda0b)("dialog.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $2ef78de296e47de8$export$6e92ecdbe15fda0b)("dialog.denyClose", {
    keyframes: [
        {
            scale: 1
        },
        {
            scale: 1.02
        },
        {
            scale: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $2ef78de296e47de8$export$6e92ecdbe15fda0b)("dialog.overlay.show", {
    keyframes: [
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $2ef78de296e47de8$export$6e92ecdbe15fda0b)("dialog.overlay.hide", {
    keyframes: [
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ],
    options: {
        duration: 250
    }
});


// src/components/dialog/dialog.ts
var $6fcecd9817da7f84$export$585117cab3e12d3 = (0, $c78f16b8b74ef4c3$export$2a86abe166e5892d);
(0, $c78f16b8b74ef4c3$export$2a86abe166e5892d).define("sl-dialog");

































const $6d09782d66e5dd79$export$bd981449327f67c2 = (0, $1e7ce0890e6d6280$export$fd42f52fd3ae1109)(Symbol("config"));


let $b73bc2079f704ba1$export$be80149fc633bf3a = class FunidAuth extends (0, $23a6037be2405355$export$3f2f9f5909897157) {
    render() {
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      <sl-button class="auth-button">
        ${this.logo.url && (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
          <img
            class="auth-button--logo"
            src="${this.withCdnUrl(this.logo.url)}"
            alt="${this.logo.alt}"
          />
        `}

        <span class="auth-button--text">${this.text}</span>
      </sl-button>
    `;
    }
    withCdnUrl(url) {
        return `${this.config.getCdnUrl()}${url}`;
    }
};
$b73bc2079f704ba1$export$be80149fc633bf3a.styles = (0, $cf848438daf93422$export$dbf350e5966cf602)`
    .auth-button::part(base) {
      border: none;
    }

    .auth-button::part(label) {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--fid-auth-button-background-color);
      border-radius: 2px;
      padding: var(--fid-auth-button-padding);
      color: var(--fid-auth-button-text-color);
    }

    .auth-button--logo {
      display: block;
      width: 36px;
      height: 36px;
    }

    .auth-button--text {
      padding: var(--fid-auth-button-text-padding, 4px 16px);
    }
  `;
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String
    })
], $b73bc2079f704ba1$export$be80149fc633bf3a.prototype, "text", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Object
    })
], $b73bc2079f704ba1$export$be80149fc633bf3a.prototype, "logo", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $c6c3beae6ff56b37$export$e11e6a155c5c4d9d)({
        context: (0, $6d09782d66e5dd79$export$bd981449327f67c2)
    }),
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: false
    })
], $b73bc2079f704ba1$export$be80149fc633bf3a.prototype, "config", void 0);
$b73bc2079f704ba1$export$be80149fc633bf3a = (0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $887f7aa45b30e788$export$da64fc29f17f9d0e)("funid-auth-button")
], $b73bc2079f704ba1$export$be80149fc633bf3a);










// src/components/qr-code/qr-code.styles.ts

var $91722d1b190c0f02$export$1fdba7d6424133fe = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
  }
`;










/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $70553e23ee27b535$var$n = "important", $70553e23ee27b535$var$i = " !" + $70553e23ee27b535$var$n, $70553e23ee27b535$export$1e5b4ce2fa884e6a = (0, $ef5d551bac068455$export$99b43ad1ed32e735)(class extends (0, $ef5d551bac068455$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $ef5d551bac068455$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith($70553e23ee27b535$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $70553e23ee27b535$var$n : "") : s[t] = e;
            }
        }
        return 0, $15085907dd60083a$export$9c068ae9cc5db4e8;
    }
});




/*
 jquery-qrcode v0.14.0 - https://larsjung.de/jquery-qrcode/ */ "use strict";
let $4e9cc8dcad10fede$var$G = null;
class $4e9cc8dcad10fede$var$H {
}
$4e9cc8dcad10fede$var$H.render = function(w, B) {
    $4e9cc8dcad10fede$var$G(w, B);
};
self.QrCreator = $4e9cc8dcad10fede$var$H;
(function(w) {
    function B(t, c, a, e) {
        var b = {}, h = w(a, c);
        h.u(t);
        h.J();
        e = e || 0;
        var r = h.h(), d = h.h() + 2 * e;
        b.text = t;
        b.level = c;
        b.version = a;
        b.O = d;
        b.a = function(b, a) {
            b -= e;
            a -= e;
            return 0 > b || b >= r || 0 > a || a >= r ? !1 : h.a(b, a);
        };
        return b;
    }
    function C(t, c, a, e, b, h, r, d, g, x) {
        function u(b, a, f, c, d, r, g) {
            b ? (t.lineTo(a + r, f + g), t.arcTo(a, f, c, d, h)) : t.lineTo(a, f);
        }
        r ? t.moveTo(c + h, a) : t.moveTo(c, a);
        u(d, e, a, e, b, -h, 0);
        u(g, e, b, c, b, 0, -h);
        u(x, c, b, c, a, h, 0);
        u(r, c, a, e, a, 0, h);
    }
    function z(t, c, a, e, b, h, r, d, g, x) {
        function u(b, a, c, d) {
            t.moveTo(b + c, a);
            t.lineTo(b, a);
            t.lineTo(b, a + d);
            t.arcTo(b, a, b + c, a, h);
        }
        r && u(c, a, h, h);
        d && u(e, a, -h, h);
        g && u(e, b, -h, -h);
        x && u(c, b, h, -h);
    }
    function A(t, c) {
        var a = c.fill;
        if ("string" === typeof a) t.fillStyle = a;
        else {
            var e = a.type, b = a.colorStops;
            a = a.position.map((b)=>Math.round(b * c.size));
            if ("linear-gradient" === e) var h = t.createLinearGradient.apply(t, a);
            else if ("radial-gradient" === e) h = t.createRadialGradient.apply(t, a);
            else throw Error("Unsupported fill");
            b.forEach(([b, a])=>{
                h.addColorStop(b, a);
            });
            t.fillStyle = h;
        }
    }
    function y(t, c) {
        a: {
            var a = c.text, e = c.v, b = c.N, h = c.K, r = c.P;
            b = Math.max(1, b || 1);
            for(h = Math.min(40, h || 40); b <= h; b += 1)try {
                var d = B(a, e, b, r);
                break a;
            } catch (J) {}
            d = void 0;
        }
        if (!d) return null;
        a = t.getContext("2d");
        c.background && (a.fillStyle = c.background, a.fillRect(c.left, c.top, c.size, c.size));
        e = d.O;
        h = c.size / e;
        a.beginPath();
        for(r = 0; r < e; r += 1)for(b = 0; b < e; b += 1){
            var g = a, x = c.left + b * h, u = c.top + r * h, p = r, q = b, f = d.a, k = x + h, m = u + h, D = p - 1, E = p + 1, n = q - 1, l = q + 1, y = Math.floor(Math.min(.5, Math.max(0, c.R)) * h), v = f(p, q), I = f(D, n), w = f(D, q);
            D = f(D, l);
            var F = f(p, l);
            l = f(E, l);
            q = f(E, q);
            E = f(E, n);
            p = f(p, n);
            x = Math.round(x);
            u = Math.round(u);
            k = Math.round(k);
            m = Math.round(m);
            v ? C(g, x, u, k, m, y, !w && !p, !w && !F, !q && !F, !q && !p) : z(g, x, u, k, m, y, w && p && I, w && F && D, q && F && l, q && p && E);
        }
        A(a, c);
        a.fill();
        return t;
    }
    var v = {
        minVersion: 1,
        maxVersion: 40,
        ecLevel: "L",
        left: 0,
        top: 0,
        size: 200,
        fill: "#000",
        background: null,
        text: "no text",
        radius: .5,
        quiet: 0
    };
    $4e9cc8dcad10fede$var$G = function(t, c) {
        var a = {};
        Object.assign(a, v, t);
        a.N = a.minVersion;
        a.K = a.maxVersion;
        a.v = a.ecLevel;
        a.left = a.left;
        a.top = a.top;
        a.size = a.size;
        a.fill = a.fill;
        a.background = a.background;
        a.text = a.text;
        a.R = a.radius;
        a.P = a.quiet;
        if (c instanceof HTMLCanvasElement) {
            if (c.width !== a.size || c.height !== a.size) c.width = a.size, c.height = a.size;
            c.getContext("2d").clearRect(0, 0, c.width, c.height);
            y(c, a);
        } else t = document.createElement("canvas"), t.width = a.size, t.height = a.size, a = y(t, a), c.appendChild(a);
    };
})(function() {
    function w(c) {
        var a = C.s(c);
        return {
            S: function() {
                return 4;
            },
            b: function() {
                return a.length;
            },
            write: function(c) {
                for(var b = 0; b < a.length; b += 1)c.put(a[b], 8);
            }
        };
    }
    function B() {
        var c = [], a = 0, e = {
            B: function() {
                return c;
            },
            c: function(b) {
                return 1 == (c[Math.floor(b / 8)] >>> 7 - b % 8 & 1);
            },
            put: function(b, h) {
                for(var a = 0; a < h; a += 1)e.m(1 == (b >>> h - a - 1 & 1));
            },
            f: function() {
                return a;
            },
            m: function(b) {
                var h = Math.floor(a / 8);
                c.length <= h && c.push(0);
                b && (c[h] |= 128 >>> a % 8);
                a += 1;
            }
        };
        return e;
    }
    function C(c, a) {
        function e(b, h) {
            for(var a = -1; 7 >= a; a += 1)if (!(-1 >= b + a || d <= b + a)) for(var c = -1; 7 >= c; c += 1)-1 >= h + c || d <= h + c || (r[b + a][h + c] = 0 <= a && 6 >= a && (0 == c || 6 == c) || 0 <= c && 6 >= c && (0 == a || 6 == a) || 2 <= a && 4 >= a && 2 <= c && 4 >= c ? !0 : !1);
        }
        function b(b, a) {
            for(var f = d = 4 * c + 17, k = Array(f), m = 0; m < f; m += 1){
                k[m] = Array(f);
                for(var p = 0; p < f; p += 1)k[m][p] = null;
            }
            r = k;
            e(0, 0);
            e(d - 7, 0);
            e(0, d - 7);
            f = y.G(c);
            for(k = 0; k < f.length; k += 1)for(m = 0; m < f.length; m += 1){
                p = f[k];
                var q = f[m];
                if (null == r[p][q]) for(var n = -2; 2 >= n; n += 1)for(var l = -2; 2 >= l; l += 1)r[p + n][q + l] = -2 == n || 2 == n || -2 == l || 2 == l || 0 == n && 0 == l;
            }
            for(f = 8; f < d - 8; f += 1)null == r[f][6] && (r[f][6] = 0 == f % 2);
            for(f = 8; f < d - 8; f += 1)null == r[6][f] && (r[6][f] = 0 == f % 2);
            f = y.w(h << 3 | a);
            for(k = 0; 15 > k; k += 1)m = !b && 1 == (f >> k & 1), r[6 > k ? k : 8 > k ? k + 1 : d - 15 + k][8] = m, r[8][8 > k ? d - k - 1 : 9 > k ? 15 - k : 14 - k] = m;
            r[d - 8][8] = !b;
            if (7 <= c) {
                f = y.A(c);
                for(k = 0; 18 > k; k += 1)m = !b && 1 == (f >> k & 1), r[Math.floor(k / 3)][k % 3 + d - 8 - 3] = m;
                for(k = 0; 18 > k; k += 1)m = !b && 1 == (f >> k & 1), r[k % 3 + d - 8 - 3][Math.floor(k / 3)] = m;
            }
            if (null == g) {
                b = t.I(c, h);
                f = B();
                for(k = 0; k < x.length; k += 1)m = x[k], f.put(4, 4), f.put(m.b(), y.f(4, c)), m.write(f);
                for(k = m = 0; k < b.length; k += 1)m += b[k].j;
                if (f.f() > 8 * m) throw Error("code length overflow. (" + f.f() + ">" + 8 * m + ")");
                for(f.f() + 4 <= 8 * m && f.put(0, 4); 0 != f.f() % 8;)f.m(!1);
                for(; !(f.f() >= 8 * m);){
                    f.put(236, 8);
                    if (f.f() >= 8 * m) break;
                    f.put(17, 8);
                }
                var u = 0;
                m = k = 0;
                p = Array(b.length);
                q = Array(b.length);
                for(n = 0; n < b.length; n += 1){
                    var v = b[n].j, w = b[n].o - v;
                    k = Math.max(k, v);
                    m = Math.max(m, w);
                    p[n] = Array(v);
                    for(l = 0; l < p[n].length; l += 1)p[n][l] = 255 & f.B()[l + u];
                    u += v;
                    l = y.C(w);
                    v = z(p[n], l.b() - 1).l(l);
                    q[n] = Array(l.b() - 1);
                    for(l = 0; l < q[n].length; l += 1)w = l + v.b() - q[n].length, q[n][l] = 0 <= w ? v.c(w) : 0;
                }
                for(l = f = 0; l < b.length; l += 1)f += b[l].o;
                f = Array(f);
                for(l = u = 0; l < k; l += 1)for(n = 0; n < b.length; n += 1)l < p[n].length && (f[u] = p[n][l], u += 1);
                for(l = 0; l < m; l += 1)for(n = 0; n < b.length; n += 1)l < q[n].length && (f[u] = q[n][l], u += 1);
                g = f;
            }
            b = g;
            f = -1;
            k = d - 1;
            m = 7;
            p = 0;
            a = y.F(a);
            for(q = d - 1; 0 < q; q -= 2)for(6 == q && --q;;){
                for(n = 0; 2 > n; n += 1)null == r[k][q - n] && (l = !1, p < b.length && (l = 1 == (b[p] >>> m & 1)), a(k, q - n) && (l = !l), r[k][q - n] = l, --m, -1 == m && (p += 1, m = 7));
                k += f;
                if (0 > k || d <= k) {
                    k -= f;
                    f = -f;
                    break;
                }
            }
        }
        var h = A[a], r = null, d = 0, g = null, x = [], u = {
            u: function(b) {
                b = w(b);
                x.push(b);
                g = null;
            },
            a: function(b, a) {
                if (0 > b || d <= b || 0 > a || d <= a) throw Error(b + "," + a);
                return r[b][a];
            },
            h: function() {
                return d;
            },
            J: function() {
                for(var a = 0, h = 0, c = 0; 8 > c; c += 1){
                    b(!0, c);
                    var d = y.D(u);
                    if (0 == c || a > d) a = d, h = c;
                }
                b(!1, h);
            }
        };
        return u;
    }
    function z(c, a) {
        if ("undefined" == typeof c.length) throw Error(c.length + "/" + a);
        var e = function() {
            for(var b = 0; b < c.length && 0 == c[b];)b += 1;
            for(var r = Array(c.length - b + a), d = 0; d < c.length - b; d += 1)r[d] = c[d + b];
            return r;
        }(), b = {
            c: function(b) {
                return e[b];
            },
            b: function() {
                return e.length;
            },
            multiply: function(a) {
                for(var h = Array(b.b() + a.b() - 1), c = 0; c < b.b(); c += 1)for(var g = 0; g < a.b(); g += 1)h[c + g] ^= v.i(v.g(b.c(c)) + v.g(a.c(g)));
                return z(h, 0);
            },
            l: function(a) {
                if (0 > b.b() - a.b()) return b;
                for(var c = v.g(b.c(0)) - v.g(a.c(0)), h = Array(b.b()), g = 0; g < b.b(); g += 1)h[g] = b.c(g);
                for(g = 0; g < a.b(); g += 1)h[g] ^= v.i(v.g(a.c(g)) + c);
                return z(h, 0).l(a);
            }
        };
        return b;
    }
    C.s = function(c) {
        for(var a = [], e = 0; e < c.length; e++){
            var b = c.charCodeAt(e);
            128 > b ? a.push(b) : 2048 > b ? a.push(192 | b >> 6, 128 | b & 63) : 55296 > b || 57344 <= b ? a.push(224 | b >> 12, 128 | b >> 6 & 63, 128 | b & 63) : (e++, b = 65536 + ((b & 1023) << 10 | c.charCodeAt(e) & 1023), a.push(240 | b >> 18, 128 | b >> 12 & 63, 128 | b >> 6 & 63, 128 | b & 63));
        }
        return a;
    };
    var A = {
        L: 1,
        M: 0,
        Q: 3,
        H: 2
    }, y = function() {
        function c(b) {
            for(var a = 0; 0 != b;)a += 1, b >>>= 1;
            return a;
        }
        var a = [
            [],
            [
                6,
                18
            ],
            [
                6,
                22
            ],
            [
                6,
                26
            ],
            [
                6,
                30
            ],
            [
                6,
                34
            ],
            [
                6,
                22,
                38
            ],
            [
                6,
                24,
                42
            ],
            [
                6,
                26,
                46
            ],
            [
                6,
                28,
                50
            ],
            [
                6,
                30,
                54
            ],
            [
                6,
                32,
                58
            ],
            [
                6,
                34,
                62
            ],
            [
                6,
                26,
                46,
                66
            ],
            [
                6,
                26,
                48,
                70
            ],
            [
                6,
                26,
                50,
                74
            ],
            [
                6,
                30,
                54,
                78
            ],
            [
                6,
                30,
                56,
                82
            ],
            [
                6,
                30,
                58,
                86
            ],
            [
                6,
                34,
                62,
                90
            ],
            [
                6,
                28,
                50,
                72,
                94
            ],
            [
                6,
                26,
                50,
                74,
                98
            ],
            [
                6,
                30,
                54,
                78,
                102
            ],
            [
                6,
                28,
                54,
                80,
                106
            ],
            [
                6,
                32,
                58,
                84,
                110
            ],
            [
                6,
                30,
                58,
                86,
                114
            ],
            [
                6,
                34,
                62,
                90,
                118
            ],
            [
                6,
                26,
                50,
                74,
                98,
                122
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126
            ],
            [
                6,
                26,
                52,
                78,
                104,
                130
            ],
            [
                6,
                30,
                56,
                82,
                108,
                134
            ],
            [
                6,
                34,
                60,
                86,
                112,
                138
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142
            ],
            [
                6,
                34,
                62,
                90,
                118,
                146
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126,
                150
            ],
            [
                6,
                24,
                50,
                76,
                102,
                128,
                154
            ],
            [
                6,
                28,
                54,
                80,
                106,
                132,
                158
            ],
            [
                6,
                32,
                58,
                84,
                110,
                136,
                162
            ],
            [
                6,
                26,
                54,
                82,
                110,
                138,
                166
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142,
                170
            ]
        ], e = {
            w: function(b) {
                for(var a = b << 10; 0 <= c(a) - c(1335);)a ^= 1335 << c(a) - c(1335);
                return (b << 10 | a) ^ 21522;
            },
            A: function(b) {
                for(var a = b << 12; 0 <= c(a) - c(7973);)a ^= 7973 << c(a) - c(7973);
                return b << 12 | a;
            },
            G: function(b) {
                return a[b - 1];
            },
            F: function(b) {
                switch(b){
                    case 0:
                        return function(b, a) {
                            return 0 == (b + a) % 2;
                        };
                    case 1:
                        return function(b) {
                            return 0 == b % 2;
                        };
                    case 2:
                        return function(b, a) {
                            return 0 == a % 3;
                        };
                    case 3:
                        return function(b, a) {
                            return 0 == (b + a) % 3;
                        };
                    case 4:
                        return function(b, a) {
                            return 0 == (Math.floor(b / 2) + Math.floor(a / 3)) % 2;
                        };
                    case 5:
                        return function(b, a) {
                            return 0 == b * a % 2 + b * a % 3;
                        };
                    case 6:
                        return function(b, a) {
                            return 0 == (b * a % 2 + b * a % 3) % 2;
                        };
                    case 7:
                        return function(b, a) {
                            return 0 == (b * a % 3 + (b + a) % 2) % 2;
                        };
                    default:
                        throw Error("bad maskPattern:" + b);
                }
            },
            C: function(b) {
                for(var a = z([
                    1
                ], 0), c = 0; c < b; c += 1)a = a.multiply(z([
                    1,
                    v.i(c)
                ], 0));
                return a;
            },
            f: function(b, a) {
                if (4 != b || 1 > a || 40 < a) throw Error("mode: " + b + "; type: " + a);
                return 10 > a ? 8 : 16;
            },
            D: function(b) {
                for(var a = b.h(), c = 0, d = 0; d < a; d += 1)for(var g = 0; g < a; g += 1){
                    for(var e = 0, t = b.a(d, g), p = -1; 1 >= p; p += 1)if (!(0 > d + p || a <= d + p)) for(var q = -1; 1 >= q; q += 1)0 > g + q || a <= g + q || (0 != p || 0 != q) && t == b.a(d + p, g + q) && (e += 1);
                    5 < e && (c += 3 + e - 5);
                }
                for(d = 0; d < a - 1; d += 1)for(g = 0; g < a - 1; g += 1)if (e = 0, b.a(d, g) && (e += 1), b.a(d + 1, g) && (e += 1), b.a(d, g + 1) && (e += 1), b.a(d + 1, g + 1) && (e += 1), 0 == e || 4 == e) c += 3;
                for(d = 0; d < a; d += 1)for(g = 0; g < a - 6; g += 1)b.a(d, g) && !b.a(d, g + 1) && b.a(d, g + 2) && b.a(d, g + 3) && b.a(d, g + 4) && !b.a(d, g + 5) && b.a(d, g + 6) && (c += 40);
                for(g = 0; g < a; g += 1)for(d = 0; d < a - 6; d += 1)b.a(d, g) && !b.a(d + 1, g) && b.a(d + 2, g) && b.a(d + 3, g) && b.a(d + 4, g) && !b.a(d + 5, g) && b.a(d + 6, g) && (c += 40);
                for(g = e = 0; g < a; g += 1)for(d = 0; d < a; d += 1)b.a(d, g) && (e += 1);
                return c += Math.abs(100 * e / a / a - 50) / 5 * 10;
            }
        };
        return e;
    }(), v = function() {
        for(var c = Array(256), a = Array(256), e = 0; 8 > e; e += 1)c[e] = 1 << e;
        for(e = 8; 256 > e; e += 1)c[e] = c[e - 4] ^ c[e - 5] ^ c[e - 6] ^ c[e - 8];
        for(e = 0; 255 > e; e += 1)a[c[e]] = e;
        return {
            g: function(b) {
                if (1 > b) throw Error("glog(" + b + ")");
                return a[b];
            },
            i: function(b) {
                for(; 0 > b;)b += 255;
                for(; 256 <= b;)b -= 255;
                return c[b];
            }
        };
    }(), t = function() {
        function c(b, c) {
            switch(c){
                case A.L:
                    return a[4 * (b - 1)];
                case A.M:
                    return a[4 * (b - 1) + 1];
                case A.Q:
                    return a[4 * (b - 1) + 2];
                case A.H:
                    return a[4 * (b - 1) + 3];
            }
        }
        var a = [
            [
                1,
                26,
                19
            ],
            [
                1,
                26,
                16
            ],
            [
                1,
                26,
                13
            ],
            [
                1,
                26,
                9
            ],
            [
                1,
                44,
                34
            ],
            [
                1,
                44,
                28
            ],
            [
                1,
                44,
                22
            ],
            [
                1,
                44,
                16
            ],
            [
                1,
                70,
                55
            ],
            [
                1,
                70,
                44
            ],
            [
                2,
                35,
                17
            ],
            [
                2,
                35,
                13
            ],
            [
                1,
                100,
                80
            ],
            [
                2,
                50,
                32
            ],
            [
                2,
                50,
                24
            ],
            [
                4,
                25,
                9
            ],
            [
                1,
                134,
                108
            ],
            [
                2,
                67,
                43
            ],
            [
                2,
                33,
                15,
                2,
                34,
                16
            ],
            [
                2,
                33,
                11,
                2,
                34,
                12
            ],
            [
                2,
                86,
                68
            ],
            [
                4,
                43,
                27
            ],
            [
                4,
                43,
                19
            ],
            [
                4,
                43,
                15
            ],
            [
                2,
                98,
                78
            ],
            [
                4,
                49,
                31
            ],
            [
                2,
                32,
                14,
                4,
                33,
                15
            ],
            [
                4,
                39,
                13,
                1,
                40,
                14
            ],
            [
                2,
                121,
                97
            ],
            [
                2,
                60,
                38,
                2,
                61,
                39
            ],
            [
                4,
                40,
                18,
                2,
                41,
                19
            ],
            [
                4,
                40,
                14,
                2,
                41,
                15
            ],
            [
                2,
                146,
                116
            ],
            [
                3,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                36,
                16,
                4,
                37,
                17
            ],
            [
                4,
                36,
                12,
                4,
                37,
                13
            ],
            [
                2,
                86,
                68,
                2,
                87,
                69
            ],
            [
                4,
                69,
                43,
                1,
                70,
                44
            ],
            [
                6,
                43,
                19,
                2,
                44,
                20
            ],
            [
                6,
                43,
                15,
                2,
                44,
                16
            ],
            [
                4,
                101,
                81
            ],
            [
                1,
                80,
                50,
                4,
                81,
                51
            ],
            [
                4,
                50,
                22,
                4,
                51,
                23
            ],
            [
                3,
                36,
                12,
                8,
                37,
                13
            ],
            [
                2,
                116,
                92,
                2,
                117,
                93
            ],
            [
                6,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                46,
                20,
                6,
                47,
                21
            ],
            [
                7,
                42,
                14,
                4,
                43,
                15
            ],
            [
                4,
                133,
                107
            ],
            [
                8,
                59,
                37,
                1,
                60,
                38
            ],
            [
                8,
                44,
                20,
                4,
                45,
                21
            ],
            [
                12,
                33,
                11,
                4,
                34,
                12
            ],
            [
                3,
                145,
                115,
                1,
                146,
                116
            ],
            [
                4,
                64,
                40,
                5,
                65,
                41
            ],
            [
                11,
                36,
                16,
                5,
                37,
                17
            ],
            [
                11,
                36,
                12,
                5,
                37,
                13
            ],
            [
                5,
                109,
                87,
                1,
                110,
                88
            ],
            [
                5,
                65,
                41,
                5,
                66,
                42
            ],
            [
                5,
                54,
                24,
                7,
                55,
                25
            ],
            [
                11,
                36,
                12,
                7,
                37,
                13
            ],
            [
                5,
                122,
                98,
                1,
                123,
                99
            ],
            [
                7,
                73,
                45,
                3,
                74,
                46
            ],
            [
                15,
                43,
                19,
                2,
                44,
                20
            ],
            [
                3,
                45,
                15,
                13,
                46,
                16
            ],
            [
                1,
                135,
                107,
                5,
                136,
                108
            ],
            [
                10,
                74,
                46,
                1,
                75,
                47
            ],
            [
                1,
                50,
                22,
                15,
                51,
                23
            ],
            [
                2,
                42,
                14,
                17,
                43,
                15
            ],
            [
                5,
                150,
                120,
                1,
                151,
                121
            ],
            [
                9,
                69,
                43,
                4,
                70,
                44
            ],
            [
                17,
                50,
                22,
                1,
                51,
                23
            ],
            [
                2,
                42,
                14,
                19,
                43,
                15
            ],
            [
                3,
                141,
                113,
                4,
                142,
                114
            ],
            [
                3,
                70,
                44,
                11,
                71,
                45
            ],
            [
                17,
                47,
                21,
                4,
                48,
                22
            ],
            [
                9,
                39,
                13,
                16,
                40,
                14
            ],
            [
                3,
                135,
                107,
                5,
                136,
                108
            ],
            [
                3,
                67,
                41,
                13,
                68,
                42
            ],
            [
                15,
                54,
                24,
                5,
                55,
                25
            ],
            [
                15,
                43,
                15,
                10,
                44,
                16
            ],
            [
                4,
                144,
                116,
                4,
                145,
                117
            ],
            [
                17,
                68,
                42
            ],
            [
                17,
                50,
                22,
                6,
                51,
                23
            ],
            [
                19,
                46,
                16,
                6,
                47,
                17
            ],
            [
                2,
                139,
                111,
                7,
                140,
                112
            ],
            [
                17,
                74,
                46
            ],
            [
                7,
                54,
                24,
                16,
                55,
                25
            ],
            [
                34,
                37,
                13
            ],
            [
                4,
                151,
                121,
                5,
                152,
                122
            ],
            [
                4,
                75,
                47,
                14,
                76,
                48
            ],
            [
                11,
                54,
                24,
                14,
                55,
                25
            ],
            [
                16,
                45,
                15,
                14,
                46,
                16
            ],
            [
                6,
                147,
                117,
                4,
                148,
                118
            ],
            [
                6,
                73,
                45,
                14,
                74,
                46
            ],
            [
                11,
                54,
                24,
                16,
                55,
                25
            ],
            [
                30,
                46,
                16,
                2,
                47,
                17
            ],
            [
                8,
                132,
                106,
                4,
                133,
                107
            ],
            [
                8,
                75,
                47,
                13,
                76,
                48
            ],
            [
                7,
                54,
                24,
                22,
                55,
                25
            ],
            [
                22,
                45,
                15,
                13,
                46,
                16
            ],
            [
                10,
                142,
                114,
                2,
                143,
                115
            ],
            [
                19,
                74,
                46,
                4,
                75,
                47
            ],
            [
                28,
                50,
                22,
                6,
                51,
                23
            ],
            [
                33,
                46,
                16,
                4,
                47,
                17
            ],
            [
                8,
                152,
                122,
                4,
                153,
                123
            ],
            [
                22,
                73,
                45,
                3,
                74,
                46
            ],
            [
                8,
                53,
                23,
                26,
                54,
                24
            ],
            [
                12,
                45,
                15,
                28,
                46,
                16
            ],
            [
                3,
                147,
                117,
                10,
                148,
                118
            ],
            [
                3,
                73,
                45,
                23,
                74,
                46
            ],
            [
                4,
                54,
                24,
                31,
                55,
                25
            ],
            [
                11,
                45,
                15,
                31,
                46,
                16
            ],
            [
                7,
                146,
                116,
                7,
                147,
                117
            ],
            [
                21,
                73,
                45,
                7,
                74,
                46
            ],
            [
                1,
                53,
                23,
                37,
                54,
                24
            ],
            [
                19,
                45,
                15,
                26,
                46,
                16
            ],
            [
                5,
                145,
                115,
                10,
                146,
                116
            ],
            [
                19,
                75,
                47,
                10,
                76,
                48
            ],
            [
                15,
                54,
                24,
                25,
                55,
                25
            ],
            [
                23,
                45,
                15,
                25,
                46,
                16
            ],
            [
                13,
                145,
                115,
                3,
                146,
                116
            ],
            [
                2,
                74,
                46,
                29,
                75,
                47
            ],
            [
                42,
                54,
                24,
                1,
                55,
                25
            ],
            [
                23,
                45,
                15,
                28,
                46,
                16
            ],
            [
                17,
                145,
                115
            ],
            [
                10,
                74,
                46,
                23,
                75,
                47
            ],
            [
                10,
                54,
                24,
                35,
                55,
                25
            ],
            [
                19,
                45,
                15,
                35,
                46,
                16
            ],
            [
                17,
                145,
                115,
                1,
                146,
                116
            ],
            [
                14,
                74,
                46,
                21,
                75,
                47
            ],
            [
                29,
                54,
                24,
                19,
                55,
                25
            ],
            [
                11,
                45,
                15,
                46,
                46,
                16
            ],
            [
                13,
                145,
                115,
                6,
                146,
                116
            ],
            [
                14,
                74,
                46,
                23,
                75,
                47
            ],
            [
                44,
                54,
                24,
                7,
                55,
                25
            ],
            [
                59,
                46,
                16,
                1,
                47,
                17
            ],
            [
                12,
                151,
                121,
                7,
                152,
                122
            ],
            [
                12,
                75,
                47,
                26,
                76,
                48
            ],
            [
                39,
                54,
                24,
                14,
                55,
                25
            ],
            [
                22,
                45,
                15,
                41,
                46,
                16
            ],
            [
                6,
                151,
                121,
                14,
                152,
                122
            ],
            [
                6,
                75,
                47,
                34,
                76,
                48
            ],
            [
                46,
                54,
                24,
                10,
                55,
                25
            ],
            [
                2,
                45,
                15,
                64,
                46,
                16
            ],
            [
                17,
                152,
                122,
                4,
                153,
                123
            ],
            [
                29,
                74,
                46,
                14,
                75,
                47
            ],
            [
                49,
                54,
                24,
                10,
                55,
                25
            ],
            [
                24,
                45,
                15,
                46,
                46,
                16
            ],
            [
                4,
                152,
                122,
                18,
                153,
                123
            ],
            [
                13,
                74,
                46,
                32,
                75,
                47
            ],
            [
                48,
                54,
                24,
                14,
                55,
                25
            ],
            [
                42,
                45,
                15,
                32,
                46,
                16
            ],
            [
                20,
                147,
                117,
                4,
                148,
                118
            ],
            [
                40,
                75,
                47,
                7,
                76,
                48
            ],
            [
                43,
                54,
                24,
                22,
                55,
                25
            ],
            [
                10,
                45,
                15,
                67,
                46,
                16
            ],
            [
                19,
                148,
                118,
                6,
                149,
                119
            ],
            [
                18,
                75,
                47,
                31,
                76,
                48
            ],
            [
                34,
                54,
                24,
                34,
                55,
                25
            ],
            [
                20,
                45,
                15,
                61,
                46,
                16
            ]
        ], e = {
            I: function(b, a) {
                var e = c(b, a);
                if ("undefined" == typeof e) throw Error("bad rs block @ typeNumber:" + b + "/errorCorrectLevel:" + a);
                b = e.length / 3;
                a = [];
                for(var d = 0; d < b; d += 1)for(var g = e[3 * d], h = e[3 * d + 1], t = e[3 * d + 2], p = 0; p < g; p += 1){
                    var q = t, f = {};
                    f.o = h;
                    f.j = q;
                    a.push(f);
                }
                return a;
            }
        };
        return e;
    }();
    return C;
}());
var $4e9cc8dcad10fede$export$2e2bcd8739ae039 = QrCreator;


var $aa99776f4d9fb906$export$fc69c443e25d6d60 = class extends (0, $8b52307a307de42f$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.value = "";
        this.label = "";
        this.size = 128;
        this.fill = "black";
        this.background = "white";
        this.radius = 0;
        this.errorCorrection = "H";
    }
    firstUpdated() {
        this.generate();
    }
    generate() {
        if (!this.hasUpdated) return;
        (0, $4e9cc8dcad10fede$export$2e2bcd8739ae039).render({
            text: this.value,
            radius: this.radius,
            ecLevel: this.errorCorrection,
            fill: this.fill,
            background: this.background,
            // We draw the canvas larger and scale its container down to avoid blurring on high-density displays
            size: this.size * 2
        }, this.canvas);
    }
    render() {
        var _a;
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      <canvas
        part="base"
        class="qr-code"
        role="img"
        aria-label=${((_a = this.label) == null ? void 0 : _a.length) > 0 ? this.label : this.value}
        style=${(0, $70553e23ee27b535$export$1e5b4ce2fa884e6a)({
            width: `${this.size}px`,
            height: `${this.size}px`
        })}
      ></canvas>
    `;
    }
};
$aa99776f4d9fb906$export$fc69c443e25d6d60.styles = [
    (0, $addc8cb295a9e492$export$e1ac0a3ec62d1269),
    (0, $91722d1b190c0f02$export$1fdba7d6424133fe)
];
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $5cd9237fa003a3a1$export$2fa187e846a241c4)("canvas")
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "canvas", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "value", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "label", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Number
    })
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "size", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "fill", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)()
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "background", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Number
    })
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "radius", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: "error-correction"
    })
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "errorCorrection", 2);
(0, $404f90d4544da778$export$85c93885f16e8446)([
    (0, $19a36fe85b85ec36$export$3db5d71bdb2d5499)([
        "background",
        "errorCorrection",
        "fill",
        "radius",
        "size",
        "value"
    ])
], $aa99776f4d9fb906$export$fc69c443e25d6d60.prototype, "generate", 1);


// src/components/qr-code/qr-code.ts
var $887f6d0a4f8b92fa$export$b94d95a376c0825a = (0, $aa99776f4d9fb906$export$fc69c443e25d6d60);
(0, $aa99776f4d9fb906$export$fc69c443e25d6d60).define("sl-qr-code");










let $b24f811c139cf190$export$be80149fc633bf3a = class FunidAuth extends (0, $23a6037be2405355$export$3f2f9f5909897157) {
    render() {
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      <a href="${this.url}" target="_blank">
        <sl-qr-code
          .value="${this.url}"
          radius="0.2"
          error-correction="L"
          label="${this.description}"
        ></sl-qr-code>
      </a>
    `;
    }
};
$b24f811c139cf190$export$be80149fc633bf3a.styles = (0, $cf848438daf93422$export$dbf350e5966cf602)`
    sl-qr-code {
      display: block;
      width: 100%;
      height: 100%;
      fill: var(--fid-auth-dialog-qr-color);
    }

    sl-qr-code::part(base) {
      width: 100%;
      height: 100%;
    }
  `;
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String
    })
], $b24f811c139cf190$export$be80149fc633bf3a.prototype, "url", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String
    })
], $b24f811c139cf190$export$be80149fc633bf3a.prototype, "description", void 0);
$b24f811c139cf190$export$be80149fc633bf3a = (0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $887f7aa45b30e788$export$da64fc29f17f9d0e)("funid-auth-qr")
], $b24f811c139cf190$export$be80149fc633bf3a);





function $505e507d05fe2006$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}




function $f65da300366474aa$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $da384e971c7149c0$export$c9648b76fd580c34 = (0, $f65da300366474aa$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $34c6251161592b7f$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $cc5ac275fb82a62c$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $92b5ef3161639fdf$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $505e507d05fe2006$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $da384e971c7149c0$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $92b5ef3161639fdf$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $cc5ac275fb82a62c$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $da384e971c7149c0$export$c9648b76fd580c34)) errors = (0, $92b5ef3161639fdf$export$1216008129fb82ed)((0, $92b5ef3161639fdf$export$1216008129fb82ed)([], (0, $92b5ef3161639fdf$export$8d051b38c9118094)(errors)), (0, $92b5ef3161639fdf$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $da384e971c7149c0$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $cc5ac275fb82a62c$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $34c6251161592b7f$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $34c6251161592b7f$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $cc5ac275fb82a62c$export$610f9c3ca1a38dd8 = $cc5ac275fb82a62c$export$f55210826850c514.EMPTY;
function $cc5ac275fb82a62c$export$4f9221cbada3c4fc(value) {
    return value instanceof $cc5ac275fb82a62c$export$f55210826850c514 || value && "closed" in value && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value.remove) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value.add) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $cc5ac275fb82a62c$var$execFinalizer(finalizer) {
    if ((0, $505e507d05fe2006$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $d8bad35c181d420f$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $1c4b45455cd56827$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $1c4b45455cd56827$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $92b5ef3161639fdf$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $92b5ef3161639fdf$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $92b5ef3161639fdf$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $92b5ef3161639fdf$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $1c4b45455cd56827$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $4a9ecd6f976def28$export$ebf645db02d3e99f(err) {
    (0, $1c4b45455cd56827$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $d8bad35c181d420f$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $11595aed438b4cfb$export$8793edee2d425525() {}


var $54c387e4d6ee52d4$export$b7f97edb34bc1f87 = function() {
    return $54c387e4d6ee52d4$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $54c387e4d6ee52d4$export$dd472c3d8fe5a85a(error) {
    return $54c387e4d6ee52d4$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $54c387e4d6ee52d4$export$ff9346b0d1d30313(value) {
    return $54c387e4d6ee52d4$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $54c387e4d6ee52d4$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $b9dcc8a1903221e0$var$context = null;
function $b9dcc8a1903221e0$export$d974811edc77eafa(cb) {
    if ((0, $d8bad35c181d420f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$b9dcc8a1903221e0$var$context;
        if (isRoot) $b9dcc8a1903221e0$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $b9dcc8a1903221e0$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $b9dcc8a1903221e0$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $b9dcc8a1903221e0$export$3e205fbb5df021e0(err) {
    if ((0, $d8bad35c181d420f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $b9dcc8a1903221e0$var$context) {
        $b9dcc8a1903221e0$var$context.errorThrown = true;
        $b9dcc8a1903221e0$var$context.error = err;
    }
}


var $1bba964913810c42$export$60959659b2c22881 = function(_super) {
    (0, $92b5ef3161639fdf$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $cc5ac275fb82a62c$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $1bba964913810c42$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $1bba964913810c42$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $1bba964913810c42$var$handleStoppedNotification((0, $54c387e4d6ee52d4$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $1bba964913810c42$var$handleStoppedNotification((0, $54c387e4d6ee52d4$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $1bba964913810c42$var$handleStoppedNotification((0, $54c387e4d6ee52d4$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $cc5ac275fb82a62c$export$f55210826850c514));
var $1bba964913810c42$var$_bind = Function.prototype.bind;
function $1bba964913810c42$var$bind(fn, thisArg) {
    return $1bba964913810c42$var$_bind.call(fn, thisArg);
}
var $1bba964913810c42$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $1bba964913810c42$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $1bba964913810c42$var$handleUnhandledError(error);
        }
        else $1bba964913810c42$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $1bba964913810c42$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $1bba964913810c42$export$94eeb6a328cab6c7 = function(_super) {
    (0, $92b5ef3161639fdf$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $505e507d05fe2006$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $d8bad35c181d420f$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $1bba964913810c42$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $1bba964913810c42$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $1bba964913810c42$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $1bba964913810c42$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($1bba964913810c42$export$60959659b2c22881);
function $1bba964913810c42$var$handleUnhandledError(error) {
    if ((0, $d8bad35c181d420f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $b9dcc8a1903221e0$export$3e205fbb5df021e0)(error);
    else (0, $4a9ecd6f976def28$export$ebf645db02d3e99f)(error);
}
function $1bba964913810c42$var$defaultErrorHandler(err) {
    throw err;
}
function $1bba964913810c42$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $d8bad35c181d420f$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $1c4b45455cd56827$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $1bba964913810c42$export$88d395d20619a0af = {
    closed: true,
    next: (0, $11595aed438b4cfb$export$8793edee2d425525),
    error: $1bba964913810c42$var$defaultErrorHandler,
    complete: (0, $11595aed438b4cfb$export$8793edee2d425525)
};



var $8bf8f81b331e6156$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $7ff642ef57005d80$export$f0954fd7d5368655(x) {
    return x;
}


function $0dffc2595a0543d1$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0dffc2595a0543d1$export$71f88a61afaa14d7(fns);
}
function $0dffc2595a0543d1$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7ff642ef57005d80$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $3d3817496a9f78eb$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $3d3817496a9f78eb$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $1bba964913810c42$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $b9dcc8a1903221e0$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $3d3817496a9f78eb$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $1bba964913810c42$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $8bf8f81b331e6156$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0dffc2595a0543d1$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $3d3817496a9f78eb$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $3d3817496a9f78eb$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $d8bad35c181d420f$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $3d3817496a9f78eb$var$isObserver(value) {
    return value && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value.next) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value.error) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value.complete);
}
function $3d3817496a9f78eb$var$isSubscriber(value) {
    return value && value instanceof (0, $1bba964913810c42$export$60959659b2c22881) || $3d3817496a9f78eb$var$isObserver(value) && (0, $cc5ac275fb82a62c$export$4f9221cbada3c4fc)(value);
}




var $fa6b1c2960bbeb47$export$f708eee25634bc80 = (0, $f65da300366474aa$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $7b1200b9095992f8$export$b6bbab5a9b109038 = function(_super) {
    (0, $92b5ef3161639fdf$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $7b1200b9095992f8$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $fa6b1c2960bbeb47$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $b9dcc8a1903221e0$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $92b5ef3161639fdf$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $b9dcc8a1903221e0$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $b9dcc8a1903221e0$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $cc5ac275fb82a62c$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $cc5ac275fb82a62c$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $34c6251161592b7f$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $7b1200b9095992f8$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $3d3817496a9f78eb$export$77cea355fa80b5f4));
var $7b1200b9095992f8$export$155189cde295587d = function(_super) {
    (0, $92b5ef3161639fdf$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $cc5ac275fb82a62c$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($7b1200b9095992f8$export$b6bbab5a9b109038);


var $c1127b94a80f0c76$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $92b5ef3161639fdf$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $7b1200b9095992f8$export$b6bbab5a9b109038));



function $c91389cdfa3481d0$export$ebec8610810318c5(source) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $c91389cdfa3481d0$export$871731df685d7753(init) {
    return function(source) {
        if ($c91389cdfa3481d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}




function $767023113556ed69$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $767023113556ed69$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $767023113556ed69$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $92b5ef3161639fdf$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $1bba964913810c42$export$60959659b2c22881));


function $f44d99d3f19ba4c2$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $7ff642ef57005d80$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $f44d99d3f19ba4c2$var$defaultCompare;
    return (0, $c91389cdfa3481d0$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $f44d99d3f19ba4c2$var$defaultCompare(a, b) {
    return a === b;
}



function $7a579d6c3e7bdeaf$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $c91389cdfa3481d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}



var $4566da2ee3e225ca$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};



function $471188bef853744a$export$4369c812aac99591(value) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $43f069819951bf5e$export$48c0cddbc99c45c2(input) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(input[0, $8bf8f81b331e6156$export$5ab46cbf6120b33a]);
}



function $8bf803ddc9466576$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $2d02f66f83dc0fde$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $22f2e408ea807fd2$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $22f2e408ea807fd2$export$6f58e2338da23f4d = $22f2e408ea807fd2$export$aa9956be4ae4fe8();



function $3523e456261cbeaa$export$9652023d9040757(input) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $22f2e408ea807fd2$export$6f58e2338da23f4d]);
}




function $989991d95e13aa4d$export$cf4785e597badab3(readableStream) {
    return (0, $92b5ef3161639fdf$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $92b5ef3161639fdf$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $92b5ef3161639fdf$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $92b5ef3161639fdf$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $92b5ef3161639fdf$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $989991d95e13aa4d$export$c088ffafdba7405f(obj) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $69ec8fa6fdba8d6b$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $43f069819951bf5e$export$48c0cddbc99c45c2)(input)) return $69ec8fa6fdba8d6b$export$aa3d41784b3267fa(input);
        if ((0, $4566da2ee3e225ca$export$1e2f57719e155213)(input)) return $69ec8fa6fdba8d6b$export$4cb2acdbcda2c253(input);
        if ((0, $471188bef853744a$export$4369c812aac99591)(input)) return $69ec8fa6fdba8d6b$export$60f45028237c39d1(input);
        if ((0, $8bf803ddc9466576$export$edb10ab8dd75a915)(input)) return $69ec8fa6fdba8d6b$export$e073fccf36d78cc1(input);
        if ((0, $3523e456261cbeaa$export$9652023d9040757)(input)) return $69ec8fa6fdba8d6b$export$dcccc29c315dd646(input);
        if ((0, $989991d95e13aa4d$export$c088ffafdba7405f)(input)) return $69ec8fa6fdba8d6b$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $2d02f66f83dc0fde$export$7cbe71b9fa263484)(input);
}
function $69ec8fa6fdba8d6b$export$aa3d41784b3267fa(obj) {
    return new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $8bf8f81b331e6156$export$5ab46cbf6120b33a]();
        if ((0, $505e507d05fe2006$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $69ec8fa6fdba8d6b$export$4cb2acdbcda2c253(array) {
    return new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $69ec8fa6fdba8d6b$export$60f45028237c39d1(promise) {
    return new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $4a9ecd6f976def28$export$ebf645db02d3e99f));
    });
}
function $69ec8fa6fdba8d6b$export$dcccc29c315dd646(iterable) {
    return new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $92b5ef3161639fdf$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $69ec8fa6fdba8d6b$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)(function(subscriber) {
        $69ec8fa6fdba8d6b$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $69ec8fa6fdba8d6b$export$b2dcb11d46e7a4ad(readableStream) {
    return $69ec8fa6fdba8d6b$export$e073fccf36d78cc1((0, $989991d95e13aa4d$export$cf4785e597badab3)(readableStream));
}
function $69ec8fa6fdba8d6b$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $92b5ef3161639fdf$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $92b5ef3161639fdf$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $92b5ef3161639fdf$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}





function $5639b426bc6cbe95$export$871de8747c9eaa88(project, thisArg) {
    return (0, $c91389cdfa3481d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}





function $6705ea314faf1b44$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $eb0d921d2b5a1a94$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $69ec8fa6fdba8d6b$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $6705ea314faf1b44$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $c9ad45167f0d1f1b$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $505e507d05fe2006$export$f6e2535fb5126e54)(resultSelector)) return $c9ad45167f0d1f1b$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $5639b426bc6cbe95$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $69ec8fa6fdba8d6b$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $c91389cdfa3481d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $eb0d921d2b5a1a94$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}






var $c6cbd64e74493c79$var$isArray = Array.isArray;
function $c6cbd64e74493c79$var$callOrApply(fn, args) {
    return $c6cbd64e74493c79$var$isArray(args) ? fn.apply(void 0, (0, $92b5ef3161639fdf$export$1216008129fb82ed)([], (0, $92b5ef3161639fdf$export$8d051b38c9118094)(args))) : fn(args);
}
function $c6cbd64e74493c79$export$559affaa48f4288d(fn) {
    return (0, $5639b426bc6cbe95$export$871de8747c9eaa88)(function(args) {
        return $c6cbd64e74493c79$var$callOrApply(fn, args);
    });
}


var $81eebc0813c15e0c$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $81eebc0813c15e0c$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $81eebc0813c15e0c$var$jqueryMethods = [
    "on",
    "off"
];
function $81eebc0813c15e0c$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $505e507d05fe2006$export$f6e2535fb5126e54)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $81eebc0813c15e0c$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $c6cbd64e74493c79$export$559affaa48f4288d)(resultSelector));
    var _a = (0, $92b5ef3161639fdf$export$8d051b38c9118094)($81eebc0813c15e0c$var$isEventTarget(target) ? $81eebc0813c15e0c$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $81eebc0813c15e0c$var$isNodeStyleEventEmitter(target) ? $81eebc0813c15e0c$var$nodeEventEmitterMethods.map($81eebc0813c15e0c$var$toCommonHandlerRegistry(target, eventName)) : $81eebc0813c15e0c$var$isJQueryStyleEventEmitter(target) ? $81eebc0813c15e0c$var$jqueryMethods.map($81eebc0813c15e0c$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $4566da2ee3e225ca$export$1e2f57719e155213)(target)) return (0, $c9ad45167f0d1f1b$export$6b9f6c0d32c093f9)(function(subTarget) {
            return $81eebc0813c15e0c$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $69ec8fa6fdba8d6b$export$6a9cfa3ebc765910)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $3d3817496a9f78eb$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $81eebc0813c15e0c$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $81eebc0813c15e0c$var$isNodeStyleEventEmitter(target) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(target.addListener) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(target.removeListener);
}
function $81eebc0813c15e0c$var$isJQueryStyleEventEmitter(target) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(target.on) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(target.off);
}
function $81eebc0813c15e0c$var$isEventTarget(target) {
    return (0, $505e507d05fe2006$export$f6e2535fb5126e54)(target.addEventListener) && (0, $505e507d05fe2006$export$f6e2535fb5126e54)(target.removeEventListener);
}




function $1c55d460178c12b7$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $c91389cdfa3481d0$export$871731df685d7753)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $69ec8fa6fdba8d6b$export$6a9cfa3ebc765910)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}





function $4977177420e4de24$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $505e507d05fe2006$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $c91389cdfa3481d0$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $767023113556ed69$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $7ff642ef57005d80$export$f0954fd7d5368655);
}


const $1a18174621d06872$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$1a18174621d06872$export$c169aefb7330cccb["open"] = "0";
$1a18174621d06872$export$c169aefb7330cccb["close"] = "1";
$1a18174621d06872$export$c169aefb7330cccb["ping"] = "2";
$1a18174621d06872$export$c169aefb7330cccb["pong"] = "3";
$1a18174621d06872$export$c169aefb7330cccb["message"] = "4";
$1a18174621d06872$export$c169aefb7330cccb["upgrade"] = "5";
$1a18174621d06872$export$c169aefb7330cccb["noop"] = "6";
const $1a18174621d06872$export$47791e8004edd485 = Object.create(null);
Object.keys($1a18174621d06872$export$c169aefb7330cccb).forEach((key)=>{
    $1a18174621d06872$export$47791e8004edd485[$1a18174621d06872$export$c169aefb7330cccb[key]] = key;
});
const $1a18174621d06872$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $43e21616dd3e0665$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $43e21616dd3e0665$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $43e21616dd3e0665$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $43e21616dd3e0665$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($43e21616dd3e0665$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $43e21616dd3e0665$var$encodeBlobAsBase64(data, callback);
    } else if ($43e21616dd3e0665$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $43e21616dd3e0665$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $43e21616dd3e0665$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $1a18174621d06872$export$c169aefb7330cccb)[type] + (data || ""));
};
const $43e21616dd3e0665$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $43e21616dd3e0665$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $43e21616dd3e0665$var$TEXT_ENCODER;
function $43e21616dd3e0665$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($43e21616dd3e0665$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($43e21616dd3e0665$var$toArray).then(callback);
    else if ($43e21616dd3e0665$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $43e21616dd3e0665$var$isView(packet.data))) return callback($43e21616dd3e0665$var$toArray(packet.data));
    $43e21616dd3e0665$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$43e21616dd3e0665$var$TEXT_ENCODER) $43e21616dd3e0665$var$TEXT_ENCODER = new TextEncoder();
        callback($43e21616dd3e0665$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $5311340041508d93$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $5311340041508d93$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $5311340041508d93$var$chars.length; i++)$5311340041508d93$var$lookup[$5311340041508d93$var$chars.charCodeAt(i)] = i;
const $5311340041508d93$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $5311340041508d93$var$chars[bytes[i] >> 2];
        base64 += $5311340041508d93$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $5311340041508d93$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $5311340041508d93$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $5311340041508d93$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $5311340041508d93$var$lookup[base64.charCodeAt(i)];
        encoded2 = $5311340041508d93$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $5311340041508d93$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $5311340041508d93$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $fb5875ae01afe746$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $fb5875ae01afe746$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $fb5875ae01afe746$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $fb5875ae01afe746$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $1a18174621d06872$export$47791e8004edd485)[type];
    if (!packetType) return 0, $1a18174621d06872$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $1a18174621d06872$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $1a18174621d06872$export$47791e8004edd485)[type]
    };
};
const $fb5875ae01afe746$var$decodeBase64Packet = (data, binaryType)=>{
    if ($fb5875ae01afe746$var$withNativeArrayBuffer) {
        const decoded = (0, $5311340041508d93$export$2f872c0f2117be69)(data);
        return $fb5875ae01afe746$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $fb5875ae01afe746$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $7bc0b190edad50e2$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $7bc0b190edad50e2$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $43e21616dd3e0665$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($7bc0b190edad50e2$var$SEPARATOR));
        });
    });
};
const $7bc0b190edad50e2$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($7bc0b190edad50e2$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $fb5875ae01afe746$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $7bc0b190edad50e2$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $43e21616dd3e0665$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $7bc0b190edad50e2$var$TEXT_DECODER;
function $7bc0b190edad50e2$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $7bc0b190edad50e2$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $7bc0b190edad50e2$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$7bc0b190edad50e2$var$TEXT_DECODER) $7bc0b190edad50e2$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($7bc0b190edad50e2$var$totalLength(chunks) < 1) break;
                    const header = $7bc0b190edad50e2$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($7bc0b190edad50e2$var$totalLength(chunks) < 2) break;
                    const headerArray = $7bc0b190edad50e2$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($7bc0b190edad50e2$var$totalLength(chunks) < 8) break;
                    const headerArray = $7bc0b190edad50e2$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $1a18174621d06872$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($7bc0b190edad50e2$var$totalLength(chunks) < expectedLength) break;
                    const data = $7bc0b190edad50e2$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $fb5875ae01afe746$export$4647901878f33f31)(isBinary ? data : $7bc0b190edad50e2$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $1a18174621d06872$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $7bc0b190edad50e2$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $90f6e1d58cea2d83$export$4293555f241ae35a(obj) {
    if (obj) return $90f6e1d58cea2d83$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $90f6e1d58cea2d83$var$mixin(obj) {
    for(var key in $90f6e1d58cea2d83$export$4293555f241ae35a.prototype)obj[key] = $90f6e1d58cea2d83$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.on = $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.off = $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.removeListener = $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.removeAllListeners = $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$90f6e1d58cea2d83$export$4293555f241ae35a.prototype.emitReserved = $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $90f6e1d58cea2d83$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $dd4a6162392459cb$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $dd4a6162392459cb$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $dd4a6162392459cb$export$790dcbc41e2d75d5 = "arraybuffer";
function $dd4a6162392459cb$export$19413efcf2fac759() {}


function $783d2cb82420b41d$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $783d2cb82420b41d$var$NATIVE_SET_TIMEOUT = (0, $dd4a6162392459cb$export$394f9358f6231289).setTimeout;
const $783d2cb82420b41d$var$NATIVE_CLEAR_TIMEOUT = (0, $dd4a6162392459cb$export$394f9358f6231289).clearTimeout;
function $783d2cb82420b41d$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $783d2cb82420b41d$var$NATIVE_SET_TIMEOUT.bind((0, $dd4a6162392459cb$export$394f9358f6231289));
        obj.clearTimeoutFn = $783d2cb82420b41d$var$NATIVE_CLEAR_TIMEOUT.bind((0, $dd4a6162392459cb$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $dd4a6162392459cb$export$394f9358f6231289).setTimeout.bind((0, $dd4a6162392459cb$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $dd4a6162392459cb$export$394f9358f6231289).clearTimeout.bind((0, $dd4a6162392459cb$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $783d2cb82420b41d$var$BASE64_OVERHEAD = 1.33;
function $783d2cb82420b41d$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $783d2cb82420b41d$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $783d2cb82420b41d$var$BASE64_OVERHEAD);
}
function $783d2cb82420b41d$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $783d2cb82420b41d$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $7c5c985e3d42986d$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $7c5c985e3d42986d$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $fc7ae29a64cb05fd$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $fc7ae29a64cb05fd$export$86495b081fef8e52 extends (0, $90f6e1d58cea2d83$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $783d2cb82420b41d$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $fc7ae29a64cb05fd$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $fb5875ae01afe746$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $7c5c985e3d42986d$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $5992c28aeb142f08$export$265ee5eefd4c309b extends (0, $fc7ae29a64cb05fd$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $7bc0b190edad50e2$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $7bc0b190edad50e2$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $783d2cb82420b41d$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $a5811e16ec9eb86f$var$value = false;
try {
    $a5811e16ec9eb86f$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $a5811e16ec9eb86f$export$5235bbd4a1ef06e = $a5811e16ec9eb86f$var$value;


function $e6c0c882a6b03852$var$empty() {}
class $e6c0c882a6b03852$export$c959f2344155d309 extends (0, $5992c28aeb142f08$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $e6c0c882a6b03852$export$7fa6c5b6f8193917 extends (0, $90f6e1d58cea2d83$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $783d2cb82420b41d$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $783d2cb82420b41d$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $e6c0c882a6b03852$export$7fa6c5b6f8193917.requestsCount++;
            $e6c0c882a6b03852$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $e6c0c882a6b03852$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $e6c0c882a6b03852$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$e6c0c882a6b03852$export$7fa6c5b6f8193917.requestsCount = 0;
$e6c0c882a6b03852$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $e6c0c882a6b03852$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $dd4a6162392459cb$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $e6c0c882a6b03852$var$unloadHandler, false);
    }
}
function $e6c0c882a6b03852$var$unloadHandler() {
    for(let i in $e6c0c882a6b03852$export$7fa6c5b6f8193917.requests)if ($e6c0c882a6b03852$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $e6c0c882a6b03852$export$7fa6c5b6f8193917.requests[i].abort();
}
const $e6c0c882a6b03852$var$hasXHR2 = function() {
    const xhr = $e6c0c882a6b03852$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $e6c0c882a6b03852$export$a2d42eb087c10497 extends $e6c0c882a6b03852$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $e6c0c882a6b03852$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $e6c0c882a6b03852$export$7fa6c5b6f8193917($e6c0c882a6b03852$var$newRequest, this.uri(), opts);
    }
}
function $e6c0c882a6b03852$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $a5811e16ec9eb86f$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $dd4a6162392459cb$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $7304b6478d4c398c$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $7304b6478d4c398c$export$570bf71d2367e261 extends (0, $fc7ae29a64cb05fd$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $7304b6478d4c398c$var$isReactNative ? {} : (0, $783d2cb82420b41d$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $43e21616dd3e0665$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $dd4a6162392459cb$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $783d2cb82420b41d$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $7304b6478d4c398c$var$WebSocketCtor = (0, $dd4a6162392459cb$export$394f9358f6231289).WebSocket || (0, $dd4a6162392459cb$export$394f9358f6231289).MozWebSocket;
class $7304b6478d4c398c$export$911baa0677ac404c extends $7304b6478d4c398c$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$7304b6478d4c398c$var$isReactNative ? protocols ? new $7304b6478d4c398c$var$WebSocketCtor(uri, protocols) : new $7304b6478d4c398c$var$WebSocketCtor(uri) : new $7304b6478d4c398c$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $80fe461a3a7d77bb$export$961c930859384407 extends (0, $fc7ae29a64cb05fd$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $7bc0b190edad50e2$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $7bc0b190edad50e2$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $dd4a6162392459cb$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $e48a015949ec7a80$export$46dec00755c1153b = {
    websocket: (0, $7304b6478d4c398c$export$911baa0677ac404c),
    webtransport: (0, $80fe461a3a7d77bb$export$961c930859384407),
    polling: (0, $e6c0c882a6b03852$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $10a9c81594f94e13$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $10a9c81594f94e13$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $10a9c81594f94e13$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $10a9c81594f94e13$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$10a9c81594f94e13$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $10a9c81594f94e13$var$pathNames(uri, uri["path"]);
    uri.queryKey = $10a9c81594f94e13$var$queryKey(uri, uri["query"]);
    return uri;
}
function $10a9c81594f94e13$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $10a9c81594f94e13$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $56659e1600d33192$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $56659e1600d33192$var$OFFLINE_EVENT_LISTENERS = [];
if ($56659e1600d33192$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $56659e1600d33192$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $56659e1600d33192$export$3874118029a0ee0d extends (0, $90f6e1d58cea2d83$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $dd4a6162392459cb$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $10a9c81594f94e13$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $10a9c81594f94e13$export$98e6a39c04603d36)(opts.host).host;
        (0, $783d2cb82420b41d$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $7c5c985e3d42986d$export$2f872c0f2117be69)(this.opts.query);
        if ($56659e1600d33192$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $56659e1600d33192$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $dd4a6162392459cb$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $7bc0b190edad50e2$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $56659e1600d33192$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $56659e1600d33192$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $783d2cb82420b41d$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $dd4a6162392459cb$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $56659e1600d33192$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($56659e1600d33192$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $56659e1600d33192$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $56659e1600d33192$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$56659e1600d33192$export$3874118029a0ee0d.protocol = (0, $7bc0b190edad50e2$export$a51d6b395ff4c65a);
class $56659e1600d33192$export$cc521fcb1004e85c extends $56659e1600d33192$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $56659e1600d33192$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $56659e1600d33192$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $56659e1600d33192$export$4798917dbf149b79 extends $56659e1600d33192$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $e48a015949ec7a80$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $bbb63dff1cbcaef2$export$1e7deca84b429035 extends (0, $5992c28aeb142f08$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $8823d1af4f665e8c$export$a51d6b395ff4c65a = (0, $56659e1600d33192$export$4798917dbf149b79).protocol;


function $8c3eba40cd12827b$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $10a9c81594f94e13$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $aa49193852ed81ec$exports = {};

$parcel$export($aa49193852ed81ec$exports, "protocol", function () { return $aa49193852ed81ec$export$a51d6b395ff4c65a; });
$parcel$export($aa49193852ed81ec$exports, "PacketType", function () { return $aa49193852ed81ec$export$84d4095e16c6fc19; });
$parcel$export($aa49193852ed81ec$exports, "Encoder", function () { return $aa49193852ed81ec$export$a50aceb0e02a00aa; });
$parcel$export($aa49193852ed81ec$exports, "Decoder", function () { return $aa49193852ed81ec$export$f9de6ca0bc043724; });

const $0869f86665a93c60$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $0869f86665a93c60$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $0869f86665a93c60$var$toString = Object.prototype.toString;
const $0869f86665a93c60$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $0869f86665a93c60$var$toString.call(Blob) === "[object BlobConstructor]";
const $0869f86665a93c60$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $0869f86665a93c60$var$toString.call(File) === "[object FileConstructor]";
function $0869f86665a93c60$export$37488ff1135b1696(obj) {
    return $0869f86665a93c60$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $0869f86665a93c60$var$isView(obj)) || $0869f86665a93c60$var$withNativeBlob && obj instanceof Blob || $0869f86665a93c60$var$withNativeFile && obj instanceof File;
}
function $0869f86665a93c60$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($0869f86665a93c60$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($0869f86665a93c60$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $0869f86665a93c60$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $0869f86665a93c60$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $4393b7700d8504f9$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $4393b7700d8504f9$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $4393b7700d8504f9$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $0869f86665a93c60$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $4393b7700d8504f9$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $4393b7700d8504f9$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $4393b7700d8504f9$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $4393b7700d8504f9$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $4393b7700d8504f9$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $4393b7700d8504f9$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $4393b7700d8504f9$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $aa49193852ed81ec$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $aa49193852ed81ec$export$a51d6b395ff4c65a = 5;
var $aa49193852ed81ec$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($aa49193852ed81ec$export$84d4095e16c6fc19 || ($aa49193852ed81ec$export$84d4095e16c6fc19 = {}));
class $aa49193852ed81ec$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $aa49193852ed81ec$export$84d4095e16c6fc19.EVENT || obj.type === $aa49193852ed81ec$export$84d4095e16c6fc19.ACK) {
            if ((0, $0869f86665a93c60$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $aa49193852ed81ec$export$84d4095e16c6fc19.EVENT ? $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_EVENT : $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $4393b7700d8504f9$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $aa49193852ed81ec$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $aa49193852ed81ec$export$f9de6ca0bc043724 extends (0, $90f6e1d58cea2d83$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $aa49193852ed81ec$export$84d4095e16c6fc19.EVENT : $aa49193852ed81ec$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $aa49193852ed81ec$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $0869f86665a93c60$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($aa49193852ed81ec$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($aa49193852ed81ec$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $aa49193852ed81ec$export$84d4095e16c6fc19.CONNECT:
                return $aa49193852ed81ec$var$isObject(payload);
            case $aa49193852ed81ec$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $aa49193852ed81ec$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $aa49193852ed81ec$var$isObject(payload);
            case $aa49193852ed81ec$export$84d4095e16c6fc19.EVENT:
            case $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $aa49193852ed81ec$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $aa49193852ed81ec$export$84d4095e16c6fc19.ACK:
            case $aa49193852ed81ec$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $aa49193852ed81ec$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $4393b7700d8504f9$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $8c7f45adb58bc7a1$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $62797a1ecd7018f8$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $62797a1ecd7018f8$export$4798917dbf149b79 extends (0, $90f6e1d58cea2d83$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($62797a1ecd7018f8$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $aa49193852ed81ec$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $aa49193852ed81ec$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).EVENT:
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).ACK:
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $aa49193852ed81ec$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $aa49193852ed81ec$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $aa49193852ed81ec$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $c9239df9466dbedb$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $c9239df9466dbedb$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $c9239df9466dbedb$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $c9239df9466dbedb$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $c9239df9466dbedb$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $c9239df9466dbedb$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $dbe294a503cd578e$export$d0d38e7dec7a1a61 extends (0, $90f6e1d58cea2d83$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $783d2cb82420b41d$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $c9239df9466dbedb$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $aa49193852ed81ec$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $56659e1600d33192$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $8c7f45adb58bc7a1$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $8c7f45adb58bc7a1$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $dd4a6162392459cb$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $62797a1ecd7018f8$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $5d51686d3ed1cd94$var$cache = {};
function $5d51686d3ed1cd94$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $8c3eba40cd12827b$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $5d51686d3ed1cd94$var$cache[id] && path in $5d51686d3ed1cd94$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $dbe294a503cd578e$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$5d51686d3ed1cd94$var$cache[id]) $5d51686d3ed1cd94$var$cache[id] = new (0, $dbe294a503cd578e$export$d0d38e7dec7a1a61)(source, opts);
        io = $5d51686d3ed1cd94$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($5d51686d3ed1cd94$export$841407ceb083bd74, {
    Manager: $dbe294a503cd578e$export$d0d38e7dec7a1a61,
    Socket: $62797a1ecd7018f8$export$4798917dbf149b79,
    io: $5d51686d3ed1cd94$export$841407ceb083bd74,
    connect: $5d51686d3ed1cd94$export$841407ceb083bd74
});


var $3983f13df137da54$export$314193dd3636a61c;
(function(FunidAuthEvent) {
    FunidAuthEvent["Success"] = "funid-auth-success";
    FunidAuthEvent["Error"] = "funid-auth-error";
    FunidAuthEvent["AuthOpen"] = "funid-auth-open";
    FunidAuthEvent["AuthClose"] = "funid-auth-close";
})($3983f13df137da54$export$314193dd3636a61c || ($3983f13df137da54$export$314193dd3636a61c = {}));
var $3983f13df137da54$export$c1eff327b9b497f4;
(function(FunidAuthError) {
    FunidAuthError["EmailAlreadyInUse"] = "EMAIL_ALREADY_IN_USE";
    FunidAuthError["Fail"] = "FAIL";
})($3983f13df137da54$export$c1eff327b9b497f4 || ($3983f13df137da54$export$c1eff327b9b497f4 = {}));
var $3983f13df137da54$export$6d8156797d3409d0;
(function(FunidViewType) {
    FunidViewType["QrCode"] = "qrcode";
    FunidViewType["Info"] = "info";
})($3983f13df137da54$export$6d8156797d3409d0 || ($3983f13df137da54$export$6d8156797d3409d0 = {}));




const $0dea777ca5c7699b$export$a27ef4b2aa0375e = (0, $1e7ce0890e6d6280$export$fd42f52fd3ae1109)(Symbol("logger"));


let $9ea1f952a6815f7c$export$be80149fc633bf3a = class FunidAuth extends (0, $23a6037be2405355$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.showMore = false;
        this.socket = undefined;
        this.videoExtensions = [
            ".webm",
            ".mp4"
        ];
        this.dialogSubject$ = new (0, $c1127b94a80f0c76$export$cc3d42e6b2b9cf8b)(null);
        this.openSubject$ = new (0, $c1127b94a80f0c76$export$cc3d42e6b2b9cf8b)(false);
        this.subscription = null;
        this.dialogCloseSubscription = null;
    }
    render() {
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      <sl-dialog
        no-header="no-header"
        label="Dialog"
        class="dialog"
        langcode="${this.langCode}"
      >
        <div class="container">
          <sl-button
            class="close-button"
            @click=${this.close}
            variant="default"
            size="medium"
            circle
          >
            <svg
              width="22"
              height="20"
              viewBox="0 0 22 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.1674 14.5961C13.7532 15.1819 14.7029 15.1819 15.2887 14.5961C15.8745 14.0103 15.8745 13.0605 15.2887 12.4748L12.813 9.99903L15.2877 7.52427C15.8735 6.93848 15.8735 5.98873 15.2877 5.40295C14.7019 4.81716 13.7522 4.81716 13.1664 5.40295L10.6916 7.87771L8.21762 5.4037C7.63184 4.81791 6.68209 4.81791 6.0963 5.4037C5.51052 5.98948 5.51052 6.93923 6.0963 7.52502L8.57032 9.99903L6.09533 12.474C5.50955 13.0598 5.50955 14.0095 6.09533 14.5953C6.68112 15.1811 7.63087 15.1811 8.21665 14.5953L10.6916 12.1203L13.1674 14.5961Z"
                fill="#7E7BB4"
              />
            </svg>
          </sl-button>

          ${this.viewType === (0, $3983f13df137da54$export$6d8156797d3409d0).QrCode ? (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                <div class="main-state">
                  <img
                    class="dialog-image lang-${this.langCode}"
                    src="${this.withCdnUrl(this.data.background.url)}"
                    alt="${this.data.background.alt}"
                  />

                  <p class="title">${this.data.title}</p>

                  <p class="description">${this.data.description}</p>

                  <funid-auth-qr
                    class="qr-code"
                    .url="${this.url}"
                    .description="${this.data.description}"
                  ></funid-auth-qr>

                  <p class="downloads-text mobile-only">${this.data.text}</p>

                  <div class="steps">
                    ${this.data.steps.items.map((item)=>(0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                        <div class="steps--item">
                          <div class="steps--icon-wrapper">
                            <img
                              class="steps--icon"
                              src="${this.withCdnUrl(item.icon.url)}"
                              alt="${item.text}"
                            />
                          </div>

                          <p class="steps-item--text">${item.text}</p>
                        </div>
                      `)}
                  </div>

                  <div class="downloads mobile-only">
                    <a
                      href="${this.url}"
                      class="downloads-item"
                    >
                      <img
                        class="downloads-item--icon"
                        src="${this.withCdnUrl(this.data.logo.url)}"
                        alt="${this.data.logo.alt}"
                      >

                      <span class="downloads-item--text">${this.data.text}</span>
                    </a>
                  </div>

                  <button
                    class="show-more"
                    @click=${{
            handleEvent: ()=>this.toggleView((0, $3983f13df137da54$export$6d8156797d3409d0).Info)
        }}
                  >
                    <svg
                      class="show-more--icon"
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="1"
                        y="0.5"
                        width="15"
                        height="15"
                        rx="7.5"
                        stroke="#3F38DD"
                      />
                      <path
                        d="M7.61952 12.2958V6.4318C7.61952 6.1918 7.70752 5.9598 7.87552 5.7918C8.04352 5.6238 8.26752 5.5278 8.49952 5.5278C8.73952 5.5278 8.95552 5.6238 9.12352 5.7918C9.29152 5.9598 9.37952 6.1918 9.37952 6.4318V12.2878C9.37952 12.5278 9.28352 12.7598 9.12352 12.9278C8.96352 13.1038 8.73952 13.1998 8.49952 13.1998C8.25952 13.1998 8.04352 13.1038 7.87552 12.9358C7.70752 12.7598 7.61952 12.5358 7.61952 12.2958Z"
                        fill="#3F38DD"
                      />
                      <path
                        d="M7.60352 3.7198C7.60352 3.2158 8.00352 2.7998 8.49952 2.7998C8.99552 2.7998 9.39552 3.2158 9.39552 3.7198C9.39552 4.2318 8.99552 4.6398 8.49952 4.6398C8.00352 4.6478 7.60352 4.2318 7.60352 3.7198Z"
                        fill="#3F38DD"
                      />
                    </svg>

                    <span>${this.data.infoButtonText}</span>
                  </button>
                </div>
                </div>
              ` : ""}

          ${this.viewType === (0, $3983f13df137da54$export$6d8156797d3409d0).Info ? (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                  <div class="details-state">
                    <div class="details--heading">
                      <img
                        class="details--logo"
                        src="${this.withCdnUrl(this.data.logo.url)}"
                        alt="${this.data.info.title}"
                      />

                      <span class="details--title"
                        >${this.data.info.title}</span
                      >
                    </div>

                    <div class="details-body">
                      <div class="details-body--content">
                        ${this.data.info.guide.map((guide)=>(0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                            <article class="guide">
                              <h3 class="guide--title">${guide.title}</h3>

                              <p class="guide--description">
                                ${guide.description}
                              </p>

                              ${guide.media.url ? this.videoExtensions.includes(guide.media.ext) ? (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                                      <video
                                        class="guide--media"
                                        disableRemotePlayback
                                        muted
                                        autoplay
                                        playsinline
                                        loop
                                      >
                                        <source
                                          type="${guide.media.mime}"
                                          src="${this.withCdnUrl(guide.media.url)}"
                                        />
                                      </video>
                                    ` : (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
                                      <img
                                        class="guide--media"
                                        src="${this.withCdnUrl(guide.media.url)}"
                                        alt="${guide.media.alt}"
                                      />
                                    ` : ""}
                            </article>
                          `)}
                      </div>
                    </div>

                    <button
                      class="show-less"
                      @click=${{
            handleEvent: ()=>this.toggleView((0, $3983f13df137da54$export$6d8156797d3409d0).QrCode)
        }}
                    >
                      <img
                        class="show-less--image"
                        src="${this.withCdnUrl(this.data.logo.url)}"
                        alt="${this.data.info}"
                      />

                      <span class="show-less--text">
                        ${this.data.info.button}
                      </span>
                    </button>
                  </div>
                ` : ""}
      </sl-dialog>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        const dialog$ = this.dialogSubject$.asObservable().pipe((0, $f44d99d3f19ba4c2$export$779c5fb865a0172e)());
        const open$ = this.openSubject$.asObservable().pipe((0, $f44d99d3f19ba4c2$export$779c5fb865a0172e)());
        this.subscription = dialog$.pipe((0, $4977177420e4de24$export$3f23594af5f37336)((dialog)=>{
            if (!dialog) this.unSubscribeWS();
        }), (0, $7a579d6c3e7bdeaf$export$3dea766d36a8935f)(Boolean), (0, $1c55d460178c12b7$export$9f6ea8e48bc26eab)((dialog)=>open$.pipe((0, $5639b426bc6cbe95$export$871de8747c9eaa88)((open)=>({
                    dialog: dialog,
                    open: open
                }))))).subscribe(({ open: open, dialog: dialog })=>{
            if (open) {
                this.subscribeWS();
                dialog.show();
                this.logger.log("dialog.show()");
            } else {
                dialog.hide();
                this.unSubscribeWS();
                this.logger.log("dialog.hide()");
            }
        });
        this.dialogCloseSubscription = this.dialogSubject$.asObservable().pipe((0, $7a579d6c3e7bdeaf$export$3dea766d36a8935f)(Boolean), (0, $1c55d460178c12b7$export$9f6ea8e48bc26eab)((dialog)=>(0, $81eebc0813c15e0c$export$a36e16046ae8f1bb)(dialog, "sl-after-hide"))).subscribe(()=>{
            if (this.initialViewType !== (0, $3983f13df137da54$export$6d8156797d3409d0).Info) this.viewType = (0, $3983f13df137da54$export$6d8156797d3409d0).QrCode;
            this.close();
        });
    }
    firstUpdated(changedProperties) {
        var _a;
        super.firstUpdated(changedProperties);
        this.initialViewType = this.viewType;
        this.socket = (0, $5d51686d3ed1cd94$export$841407ceb083bd74)((_a = this.config) === null || _a === void 0 ? void 0 : _a.getWsApiUrl(), {
            autoConnect: false
        });
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this.subscription) === null || _a === void 0 || _a.unsubscribe();
        (_b = this.dialogCloseSubscription) === null || _b === void 0 || _b.unsubscribe();
    }
    attributeChangedCallback(name, oldValue, value) {
        super.attributeChangedCallback(name, oldValue, value);
        if (name !== "open" || oldValue === value) return;
        this.openSubject$.next(value === "true");
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        const dialog = this.renderRoot.querySelector("sl-dialog");
        if (dialog) this.dialogSubject$.next(dialog);
    }
    withCdnUrl(url) {
        return `${this.config.getCdnUrl()}${url}`;
    }
    toggleView(type) {
        this.viewType = type;
        this.logger.log(`${this.viewType} view`);
    }
    async subscribeWS() {
        var _a, _b, _c;
        if (!this.config.getTransactionId()) return;
        (_a = this.socket) === null || _a === void 0 || _a.connect();
        (_b = this.socket) === null || _b === void 0 || _b.emit("transaction:subscribe", {
            transactionId: this.config.getTransactionId()
        });
        (_c = this.socket) === null || _c === void 0 || _c.on("transaction:status", (data)=>{
            this.logger.log(`Transaction status:' ${data}`);
            if (data.error === (0, $3983f13df137da54$export$c1eff327b9b497f4).EmailAlreadyInUse) {
                this.logger.log(`do nothing on ${(0, $3983f13df137da54$export$c1eff327b9b497f4).EmailAlreadyInUse} now`);
                return;
            }
            if (data.error) {
                this.dispatchEvent(new CustomEvent((0, $3983f13df137da54$export$314193dd3636a61c).Error, {
                    detail: data.error,
                    bubbles: true,
                    composed: true
                }));
                this.logger.log(`"${(0, $3983f13df137da54$export$314193dd3636a61c).Error}" custom event dispatched`);
            }
            if (data.status === (0, $3983f13df137da54$export$c1eff327b9b497f4).Fail) {
                this.logger.log(`do nothing on ${(0, $3983f13df137da54$export$c1eff327b9b497f4).Fail} now`);
                return;
            }
            this.dispatchEvent(new CustomEvent((0, $3983f13df137da54$export$314193dd3636a61c).Success, {
                bubbles: true,
                composed: true
            }));
            this.logger.log(`"${(0, $3983f13df137da54$export$314193dd3636a61c).Success}" custom event dispatched`);
        });
        this.logger.log("WS connected");
    }
    unSubscribeWS() {
        var _a, _b, _c;
        if ((_a = this.socket) === null || _a === void 0 ? void 0 : _a.connected) {
            (_b = this.socket) === null || _b === void 0 || _b.removeAllListeners();
            (_c = this.socket) === null || _c === void 0 || _c.disconnect();
            this.logger.log("unSubscribeWS");
        }
    }
};
$9ea1f952a6815f7c$export$be80149fc633bf3a.styles = (0, $cf848438daf93422$export$dbf350e5966cf602)`
    .dialog {
      --width: 480px;

      position: relative;
      z-index: var(--fid-auth-dialog-z-index);
      font-family: 'Montserrat', sans-serif;
      font-optical-sizing: auto;
      font-weight: 600;
      font-style: normal;
    }

    [langcode='ar'] {
      direction: rtl;
    }

    .dialog::part(panel) {
      border-radius: 32px;
      overflow: hidden;
    }

    .dialog::part(body) {
      color: var(--text-main);
      padding: 0;
    }

    button,
    a {
      cursor: pointer;
    }

    .title {
      font-weight: 800;
      font-size: 28px;
      line-height: 32px;
    }

    .description {
      font-size: 14px;
      line-height: 16px;
    }

    .qr-code {
      display: block;
      width: var(--fid-auth-dialog-qr-width);
      margin: var(--fid-auth-dialog-qr-margin);
    }

    .mobile-only {
      @media screen and (min-width: 1280px) {
        display: none !important;
      }
    }

    .steps {
      display: flex;
      justify-content: center;
      gap: 6px;
      border-radius: 12px;
      padding: 8px;
      background-color: #f4f4f9;
      margin-bottom: 12px;

      @media screen and (min-width: 1280px) {
        background: 0;
      }
    }

    .steps--item {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 8px;
      border-radius: 12px;
      background: #fff;
      align-items: center;
      flex: 1 1 0;
    }

    @media screen and (min-width: 1280px) {
      .steps--item:not(:first-child):not(:last-child) {
        position: relative;
      }

      .steps--item:not(:first-child):not(:last-child)::before,
      .steps--item:not(:first-child):not(:last-child)::after {
        content: '';
        display: block;
        position: absolute;
        width: 36px;
        height: 1px;
        background-color: #e2e1f6;
        top: 36px;
      }

      .steps--item:not(:first-child):not(:last-child)::before {
        right: 88%;
      }

      .steps--item:not(:first-child):not(:last-child)::after {
        left: 88%;
      }
    }

    .steps--icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      width: 52px;
      height: 52px;
      background-color: #f4f4f9;
      border-radius: 8px;

      @media screen and (min-width: 1280px) {
        border: 1px solid #e5e0fc;
        background: 0;
        border-radius: 12px;
      }
    }

    .steps--icon {
      display: block;
      width: 28px;
      height: 28px;
    }

    .steps-item--text {
      font-weight: 500;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      margin: 0;
      color: var(--text-secondary);

      @media screen and (min-width: 1280px) {
        font-size: 12px;
        line-height: 16px;
      }
    }

    .downloads-text {
      font-size: 14px;
      line-height: 16px;
    }

    .downloads {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }

    .downloads-item {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 16px;
      border: 0;
      padding: 12px 30px;
      gap: 8px;
      background-color: var(--fid-auth-get-app-button-background-color);
      text-decoration: none;
    }

    .downloads-item--icon {
      display: block;
      width: 32px;
      height: 32px;
    }

    .downloads-item--text {
      color: var(--fid-auth-get-app-button-text-color);
      font-size: 16px;
      line-height: 20px;
    }

    .show-more {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      background: 0;
      border: 0;
      text-align: center;
      color: var(--fid-auth-show-more-button-color);
      margin: 0 auto;
      gap: 8px;
    }

    .show-more--icon circle {
      stroke: red;
    }

    .show-less {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 20px 4px 4px;
      padding-inline: 4px 20px;
      gap: 12px;
      border-radius: 100px;
      border: 2px solid #d7d5f8;
      background: 0;
      align-self: center;
    }

    .show-less--text {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }

    .show-less--image {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      background: #3f38dd; // TODO: image from cms doesn't fit
    }

    .dialog-image {
      display: block;
      height: 120px;
      width: calc(100% + 40px);
      margin: 0 -20px;
      object-fit: cover;
      object-position: left;
    }

    .dialog-image.lang-ar {
      transform: scale(-1, 1);
    }

    .main-state {
      display: block;
      text-align: center;
      padding: 0 20px 40px;
    }

    .details-state {
      background-color: var(--fid-auth-details-state-background-color);
      padding: 20px 20px 26px;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .details--heading {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 12px;
    }

    .details--logo {
      display: block;
      width: 72px;
      height: 72px;
    }

    .details--title {
      font-weight: 800;
      font-style: italic;
      font-size: 24px;
      line-height: 30px;
      color: var(--fid-auth-details-title-color);
    }

    .details-body {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow: scroll;
      min-height: 200px;
      max-height: calc(100vh - 368px);
    }

    .details-body--content {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .guide {
      background-color: var(--fid-auth-guide-background-color);
      border-radius: 16px;
      padding: 20px 20px 0;
      overflow: hidden;
    }

    .guide--title,
    .guide--description {
      color: var(--text-main);
    }

    .guide--title {
      font-weight: 700;
      font-size: 18px;
      line-height: 36px;
      margin-bottom: 12px;
    }

    .guide--description {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      margin-bottom: 20px;
    }

    .guide--media {
      display: block;
      width: calc(100% + 40px);
      height: 220px;
      margin: 0 -20px;
      object-fit: cover;
    }

    .close-button {
      position: absolute;
      top: 20px;
      z-index: 1;
      inset-inline-end: 20px;
    }

    .close-button::part(base) {
      border: 0;
    }

    .close-button::part(label) {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .container {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
    }
  `;
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "viewType", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "open", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "url", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "langCode", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Function
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "close", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: Object
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "data", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6d01d14c9cac29de$export$ca000e230c0caa3e)()
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "showMore", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $c6c3beae6ff56b37$export$e11e6a155c5c4d9d)({
        context: (0, $0dea777ca5c7699b$export$a27ef4b2aa0375e)
    }),
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: false
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "logger", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $c6c3beae6ff56b37$export$e11e6a155c5c4d9d)({
        context: (0, $6d09782d66e5dd79$export$bd981449327f67c2)
    }),
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        attribute: false
    })
], $9ea1f952a6815f7c$export$be80149fc633bf3a.prototype, "config", void 0);
$9ea1f952a6815f7c$export$be80149fc633bf3a = (0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $887f7aa45b30e788$export$da64fc29f17f9d0e)("funid-auth-modal")
], $9ea1f952a6815f7c$export$be80149fc633bf3a);



var $cb0ade0a370c071d$export$2e2bcd8739ae039 = (0, $cf848438daf93422$export$dbf350e5966cf602)`
  :root,
  :host,
  .sl-theme-light {
    color-scheme: light;

    --sl-color-gray-50: hsl(0 0% 97.5%);
    --sl-color-gray-100: hsl(240 4.8% 95.9%);
    --sl-color-gray-200: hsl(240 5.9% 90%);
    --sl-color-gray-300: hsl(240 4.9% 83.9%);
    --sl-color-gray-400: hsl(240 5% 64.9%);
    --sl-color-gray-500: hsl(240 3.8% 46.1%);
    --sl-color-gray-600: hsl(240 5.2% 33.9%);
    --sl-color-gray-700: hsl(240 5.3% 26.1%);
    --sl-color-gray-800: hsl(240 3.7% 15.9%);
    --sl-color-gray-900: hsl(240 5.9% 10%);
    --sl-color-gray-950: hsl(240 7.3% 8%);

    --sl-color-red-50: hsl(0 85.7% 97.3%);
    --sl-color-red-100: hsl(0 93.3% 94.1%);
    --sl-color-red-200: hsl(0 96.3% 89.4%);
    --sl-color-red-300: hsl(0 93.5% 81.8%);
    --sl-color-red-400: hsl(0 90.6% 70.8%);
    --sl-color-red-500: hsl(0 84.2% 60.2%);
    --sl-color-red-600: hsl(0 72.2% 50.6%);
    --sl-color-red-700: hsl(0 73.7% 41.8%);
    --sl-color-red-800: hsl(0 70% 35.3%);
    --sl-color-red-900: hsl(0 62.8% 30.6%);
    --sl-color-red-950: hsl(0 60% 19.6%);

    --sl-color-orange-50: hsl(33.3 100% 96.5%);
    --sl-color-orange-100: hsl(34.3 100% 91.8%);
    --sl-color-orange-200: hsl(32.1 97.7% 83.1%);
    --sl-color-orange-300: hsl(30.7 97.2% 72.4%);
    --sl-color-orange-400: hsl(27 96% 61%);
    --sl-color-orange-500: hsl(24.6 95% 53.1%);
    --sl-color-orange-600: hsl(20.5 90.2% 48.2%);
    --sl-color-orange-700: hsl(17.5 88.3% 40.4%);
    --sl-color-orange-800: hsl(15 79.1% 33.7%);
    --sl-color-orange-900: hsl(15.3 74.6% 27.8%);
    --sl-color-orange-950: hsl(15.2 69.1% 19%);

    --sl-color-amber-50: hsl(48 100% 96.1%);
    --sl-color-amber-100: hsl(48 96.5% 88.8%);
    --sl-color-amber-200: hsl(48 96.6% 76.7%);
    --sl-color-amber-300: hsl(45.9 96.7% 64.5%);
    --sl-color-amber-400: hsl(43.3 96.4% 56.3%);
    --sl-color-amber-500: hsl(37.7 92.1% 50.2%);
    --sl-color-amber-600: hsl(32.1 94.6% 43.7%);
    --sl-color-amber-700: hsl(26 90.5% 37.1%);
    --sl-color-amber-800: hsl(22.7 82.5% 31.4%);
    --sl-color-amber-900: hsl(21.7 77.8% 26.5%);
    --sl-color-amber-950: hsl(22.9 74.1% 16.7%);

    --sl-color-yellow-50: hsl(54.5 91.7% 95.3%);
    --sl-color-yellow-100: hsl(54.9 96.7% 88%);
    --sl-color-yellow-200: hsl(52.8 98.3% 76.9%);
    --sl-color-yellow-300: hsl(50.4 97.8% 63.5%);
    --sl-color-yellow-400: hsl(47.9 95.8% 53.1%);
    --sl-color-yellow-500: hsl(45.4 93.4% 47.5%);
    --sl-color-yellow-600: hsl(40.6 96.1% 40.4%);
    --sl-color-yellow-700: hsl(35.5 91.7% 32.9%);
    --sl-color-yellow-800: hsl(31.8 81% 28.8%);
    --sl-color-yellow-900: hsl(28.4 72.5% 25.7%);
    --sl-color-yellow-950: hsl(33.1 69% 13.9%);

    --sl-color-lime-50: hsl(78.3 92% 95.1%);
    --sl-color-lime-100: hsl(79.6 89.1% 89.2%);
    --sl-color-lime-200: hsl(80.9 88.5% 79.6%);
    --sl-color-lime-300: hsl(82 84.5% 67.1%);
    --sl-color-lime-400: hsl(82.7 78% 55.5%);
    --sl-color-lime-500: hsl(83.7 80.5% 44.3%);
    --sl-color-lime-600: hsl(84.8 85.2% 34.5%);
    --sl-color-lime-700: hsl(85.9 78.4% 27.3%);
    --sl-color-lime-800: hsl(86.3 69% 22.7%);
    --sl-color-lime-900: hsl(87.6 61.2% 20.2%);
    --sl-color-lime-950: hsl(86.5 60.6% 13.9%);

    --sl-color-green-50: hsl(138.5 76.5% 96.7%);
    --sl-color-green-100: hsl(140.6 84.2% 92.5%);
    --sl-color-green-200: hsl(141 78.9% 85.1%);
    --sl-color-green-300: hsl(141.7 76.6% 73.1%);
    --sl-color-green-400: hsl(141.9 69.2% 58%);
    --sl-color-green-500: hsl(142.1 70.6% 45.3%);
    --sl-color-green-600: hsl(142.1 76.2% 36.3%);
    --sl-color-green-700: hsl(142.4 71.8% 29.2%);
    --sl-color-green-800: hsl(142.8 64.2% 24.1%);
    --sl-color-green-900: hsl(143.8 61.2% 20.2%);
    --sl-color-green-950: hsl(144.3 60.7% 12%);

    --sl-color-emerald-50: hsl(151.8 81% 95.9%);
    --sl-color-emerald-100: hsl(149.3 80.4% 90%);
    --sl-color-emerald-200: hsl(152.4 76% 80.4%);
    --sl-color-emerald-300: hsl(156.2 71.6% 66.9%);
    --sl-color-emerald-400: hsl(158.1 64.4% 51.6%);
    --sl-color-emerald-500: hsl(160.1 84.1% 39.4%);
    --sl-color-emerald-600: hsl(161.4 93.5% 30.4%);
    --sl-color-emerald-700: hsl(162.9 93.5% 24.3%);
    --sl-color-emerald-800: hsl(163.1 88.1% 19.8%);
    --sl-color-emerald-900: hsl(164.2 85.7% 16.5%);
    --sl-color-emerald-950: hsl(164.3 87.5% 9.4%);

    --sl-color-teal-50: hsl(166.2 76.5% 96.7%);
    --sl-color-teal-100: hsl(167.2 85.5% 89.2%);
    --sl-color-teal-200: hsl(168.4 83.8% 78.2%);
    --sl-color-teal-300: hsl(170.6 76.9% 64.3%);
    --sl-color-teal-400: hsl(172.5 66% 50.4%);
    --sl-color-teal-500: hsl(173.4 80.4% 40%);
    --sl-color-teal-600: hsl(174.7 83.9% 31.6%);
    --sl-color-teal-700: hsl(175.3 77.4% 26.1%);
    --sl-color-teal-800: hsl(176.1 69.4% 21.8%);
    --sl-color-teal-900: hsl(175.9 60.8% 19%);
    --sl-color-teal-950: hsl(176.5 58.6% 11.4%);

    --sl-color-cyan-50: hsl(183.2 100% 96.3%);
    --sl-color-cyan-100: hsl(185.1 95.9% 90.4%);
    --sl-color-cyan-200: hsl(186.2 93.5% 81.8%);
    --sl-color-cyan-300: hsl(187 92.4% 69%);
    --sl-color-cyan-400: hsl(187.9 85.7% 53.3%);
    --sl-color-cyan-500: hsl(188.7 94.5% 42.7%);
    --sl-color-cyan-600: hsl(191.6 91.4% 36.5%);
    --sl-color-cyan-700: hsl(192.9 82.3% 31%);
    --sl-color-cyan-800: hsl(194.4 69.6% 27.1%);
    --sl-color-cyan-900: hsl(196.4 63.6% 23.7%);
    --sl-color-cyan-950: hsl(196.8 61% 16.1%);

    --sl-color-sky-50: hsl(204 100% 97.1%);
    --sl-color-sky-100: hsl(204 93.8% 93.7%);
    --sl-color-sky-200: hsl(200.6 94.4% 86.1%);
    --sl-color-sky-300: hsl(199.4 95.5% 73.9%);
    --sl-color-sky-400: hsl(198.4 93.2% 59.6%);
    --sl-color-sky-500: hsl(198.6 88.7% 48.4%);
    --sl-color-sky-600: hsl(200.4 98% 39.4%);
    --sl-color-sky-700: hsl(201.3 96.3% 32.2%);
    --sl-color-sky-800: hsl(201 90% 27.5%);
    --sl-color-sky-900: hsl(202 80.3% 23.9%);
    --sl-color-sky-950: hsl(202.3 73.8% 16.5%);

    --sl-color-blue-50: hsl(213.8 100% 96.9%);
    --sl-color-blue-100: hsl(214.3 94.6% 92.7%);
    --sl-color-blue-200: hsl(213.3 96.9% 87.3%);
    --sl-color-blue-300: hsl(211.7 96.4% 78.4%);
    --sl-color-blue-400: hsl(213.1 93.9% 67.8%);
    --sl-color-blue-500: hsl(217.2 91.2% 59.8%);
    --sl-color-blue-600: hsl(221.2 83.2% 53.3%);
    --sl-color-blue-700: hsl(224.3 76.3% 48%);
    --sl-color-blue-800: hsl(225.9 70.7% 40.2%);
    --sl-color-blue-900: hsl(224.4 64.3% 32.9%);
    --sl-color-blue-950: hsl(226.2 55.3% 18.4%);

    --sl-color-indigo-50: hsl(225.9 100% 96.7%);
    --sl-color-indigo-100: hsl(226.5 100% 93.9%);
    --sl-color-indigo-200: hsl(228 96.5% 88.8%);
    --sl-color-indigo-300: hsl(229.7 93.5% 81.8%);
    --sl-color-indigo-400: hsl(234.5 89.5% 73.9%);
    --sl-color-indigo-500: hsl(238.7 83.5% 66.7%);
    --sl-color-indigo-600: hsl(243.4 75.4% 58.6%);
    --sl-color-indigo-700: hsl(244.5 57.9% 50.6%);
    --sl-color-indigo-800: hsl(243.7 54.5% 41.4%);
    --sl-color-indigo-900: hsl(242.2 47.4% 34.3%);
    --sl-color-indigo-950: hsl(243.5 43.6% 22.9%);

    --sl-color-violet-50: hsl(250 100% 97.6%);
    --sl-color-violet-100: hsl(251.4 91.3% 95.5%);
    --sl-color-violet-200: hsl(250.5 95.2% 91.8%);
    --sl-color-violet-300: hsl(252.5 94.7% 85.1%);
    --sl-color-violet-400: hsl(255.1 91.7% 76.3%);
    --sl-color-violet-500: hsl(258.3 89.5% 66.3%);
    --sl-color-violet-600: hsl(262.1 83.3% 57.8%);
    --sl-color-violet-700: hsl(263.4 70% 50.4%);
    --sl-color-violet-800: hsl(263.4 69.3% 42.2%);
    --sl-color-violet-900: hsl(263.5 67.4% 34.9%);
    --sl-color-violet-950: hsl(265.1 61.5% 21.4%);

    --sl-color-purple-50: hsl(270 100% 98%);
    --sl-color-purple-100: hsl(268.7 100% 95.5%);
    --sl-color-purple-200: hsl(268.6 100% 91.8%);
    --sl-color-purple-300: hsl(269.2 97.4% 85.1%);
    --sl-color-purple-400: hsl(270 95.2% 75.3%);
    --sl-color-purple-500: hsl(270.7 91% 65.1%);
    --sl-color-purple-600: hsl(271.5 81.3% 55.9%);
    --sl-color-purple-700: hsl(272.1 71.7% 47.1%);
    --sl-color-purple-800: hsl(272.9 67.2% 39.4%);
    --sl-color-purple-900: hsl(273.6 65.6% 32%);
    --sl-color-purple-950: hsl(276 59.5% 16.5%);

    --sl-color-fuchsia-50: hsl(289.1 100% 97.8%);
    --sl-color-fuchsia-100: hsl(287 100% 95.5%);
    --sl-color-fuchsia-200: hsl(288.3 95.8% 90.6%);
    --sl-color-fuchsia-300: hsl(291.1 93.1% 82.9%);
    --sl-color-fuchsia-400: hsl(292 91.4% 72.5%);
    --sl-color-fuchsia-500: hsl(292.2 84.1% 60.6%);
    --sl-color-fuchsia-600: hsl(293.4 69.5% 48.8%);
    --sl-color-fuchsia-700: hsl(294.7 72.4% 39.8%);
    --sl-color-fuchsia-800: hsl(295.4 70.2% 32.9%);
    --sl-color-fuchsia-900: hsl(296.7 63.6% 28%);
    --sl-color-fuchsia-950: hsl(297.1 56.8% 14.5%);

    --sl-color-pink-50: hsl(327.3 73.3% 97.1%);
    --sl-color-pink-100: hsl(325.7 77.8% 94.7%);
    --sl-color-pink-200: hsl(325.9 84.6% 89.8%);
    --sl-color-pink-300: hsl(327.4 87.1% 81.8%);
    --sl-color-pink-400: hsl(328.6 85.5% 70.2%);
    --sl-color-pink-500: hsl(330.4 81.2% 60.4%);
    --sl-color-pink-600: hsl(333.3 71.4% 50.6%);
    --sl-color-pink-700: hsl(335.1 77.6% 42%);
    --sl-color-pink-800: hsl(335.8 74.4% 35.3%);
    --sl-color-pink-900: hsl(335.9 69% 30.4%);
    --sl-color-pink-950: hsl(336.2 65.4% 15.9%);

    --sl-color-rose-50: hsl(355.7 100% 97.3%);
    --sl-color-rose-100: hsl(355.6 100% 94.7%);
    --sl-color-rose-200: hsl(352.7 96.1% 90%);
    --sl-color-rose-300: hsl(352.6 95.7% 81.8%);
    --sl-color-rose-400: hsl(351.3 94.5% 71.4%);
    --sl-color-rose-500: hsl(349.7 89.2% 60.2%);
    --sl-color-rose-600: hsl(346.8 77.2% 49.8%);
    --sl-color-rose-700: hsl(345.3 82.7% 40.8%);
    --sl-color-rose-800: hsl(343.4 79.7% 34.7%);
    --sl-color-rose-900: hsl(341.5 75.5% 30.4%);
    --sl-color-rose-950: hsl(341.3 70.1% 17.1%);

    --sl-color-primary-50: var(--sl-color-sky-50);
    --sl-color-primary-100: var(--sl-color-sky-100);
    --sl-color-primary-200: var(--sl-color-sky-200);
    --sl-color-primary-300: var(--sl-color-sky-300);
    --sl-color-primary-400: var(--sl-color-sky-400);
    --sl-color-primary-500: var(--sl-color-sky-500);
    --sl-color-primary-600: var(--sl-color-sky-600);
    --sl-color-primary-700: var(--sl-color-sky-700);
    --sl-color-primary-800: var(--sl-color-sky-800);
    --sl-color-primary-900: var(--sl-color-sky-900);
    --sl-color-primary-950: var(--sl-color-sky-950);

    --sl-color-success-50: var(--sl-color-green-50);
    --sl-color-success-100: var(--sl-color-green-100);
    --sl-color-success-200: var(--sl-color-green-200);
    --sl-color-success-300: var(--sl-color-green-300);
    --sl-color-success-400: var(--sl-color-green-400);
    --sl-color-success-500: var(--sl-color-green-500);
    --sl-color-success-600: var(--sl-color-green-600);
    --sl-color-success-700: var(--sl-color-green-700);
    --sl-color-success-800: var(--sl-color-green-800);
    --sl-color-success-900: var(--sl-color-green-900);
    --sl-color-success-950: var(--sl-color-green-950);

    --sl-color-warning-50: var(--sl-color-amber-50);
    --sl-color-warning-100: var(--sl-color-amber-100);
    --sl-color-warning-200: var(--sl-color-amber-200);
    --sl-color-warning-300: var(--sl-color-amber-300);
    --sl-color-warning-400: var(--sl-color-amber-400);
    --sl-color-warning-500: var(--sl-color-amber-500);
    --sl-color-warning-600: var(--sl-color-amber-600);
    --sl-color-warning-700: var(--sl-color-amber-700);
    --sl-color-warning-800: var(--sl-color-amber-800);
    --sl-color-warning-900: var(--sl-color-amber-900);
    --sl-color-warning-950: var(--sl-color-amber-950);

    --sl-color-danger-50: var(--sl-color-red-50);
    --sl-color-danger-100: var(--sl-color-red-100);
    --sl-color-danger-200: var(--sl-color-red-200);
    --sl-color-danger-300: var(--sl-color-red-300);
    --sl-color-danger-400: var(--sl-color-red-400);
    --sl-color-danger-500: var(--sl-color-red-500);
    --sl-color-danger-600: var(--sl-color-red-600);
    --sl-color-danger-700: var(--sl-color-red-700);
    --sl-color-danger-800: var(--sl-color-red-800);
    --sl-color-danger-900: var(--sl-color-red-900);
    --sl-color-danger-950: var(--sl-color-red-950);

    --sl-color-neutral-50: var(--sl-color-gray-50);
    --sl-color-neutral-100: var(--sl-color-gray-100);
    --sl-color-neutral-200: var(--sl-color-gray-200);
    --sl-color-neutral-300: var(--sl-color-gray-300);
    --sl-color-neutral-400: var(--sl-color-gray-400);
    --sl-color-neutral-500: var(--sl-color-gray-500);
    --sl-color-neutral-600: var(--sl-color-gray-600);
    --sl-color-neutral-700: var(--sl-color-gray-700);
    --sl-color-neutral-800: var(--sl-color-gray-800);
    --sl-color-neutral-900: var(--sl-color-gray-900);
    --sl-color-neutral-950: var(--sl-color-gray-950);

    --sl-color-neutral-0: hsl(0, 0%, 100%);
    --sl-color-neutral-1000: hsl(0, 0%, 0%);

    --sl-border-radius-small: 0.1875rem;
    --sl-border-radius-medium: 0.25rem;
    --sl-border-radius-large: 0.5rem;
    --sl-border-radius-x-large: 1rem;

    --sl-border-radius-circle: 50%;
    --sl-border-radius-pill: 9999px;

    --sl-shadow-x-small: 0 1px 2px hsl(240 3.8% 46.1% / 6%);
    --sl-shadow-small: 0 1px 2px hsl(240 3.8% 46.1% / 12%);
    --sl-shadow-medium: 0 2px 4px hsl(240 3.8% 46.1% / 12%);
    --sl-shadow-large: 0 2px 8px hsl(240 3.8% 46.1% / 12%);
    --sl-shadow-x-large: 0 4px 16px hsl(240 3.8% 46.1% / 12%);

    --sl-spacing-3x-small: 0.125rem;
    --sl-spacing-2x-small: 0.25rem;
    --sl-spacing-x-small: 0.5rem;
    --sl-spacing-small: 0.75rem;
    --sl-spacing-medium: 1rem;
    --sl-spacing-large: 1.25rem;
    --sl-spacing-x-large: 1.75rem;
    --sl-spacing-2x-large: 2.25rem;
    --sl-spacing-3x-large: 3rem;
    --sl-spacing-4x-large: 4.5rem;

    --sl-transition-x-slow: 1000ms;
    --sl-transition-slow: 500ms;
    --sl-transition-medium: 250ms;
    --sl-transition-fast: 150ms;
    --sl-transition-x-fast: 50ms;

    --sl-font-mono: SFMono-Regular, Consolas, "Liberation Mono", Menlo,
      monospace;
    --sl-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    --sl-font-serif: Georgia, "Times New Roman", serif;

    --sl-font-size-2x-small: 0.625rem;
    --sl-font-size-x-small: 0.75rem;
    --sl-font-size-small: 0.875rem;
    --sl-font-size-medium: 1rem;
    --sl-font-size-large: 1.25rem;
    --sl-font-size-x-large: 1.5rem;
    --sl-font-size-2x-large: 2.25rem;
    --sl-font-size-3x-large: 3rem;
    --sl-font-size-4x-large: 4.5rem;

    --sl-font-weight-light: 300;
    --sl-font-weight-normal: 400;
    --sl-font-weight-semibold: 500;
    --sl-font-weight-bold: 700;

    --sl-letter-spacing-denser: -0.03em;
    --sl-letter-spacing-dense: -0.015em;
    --sl-letter-spacing-normal: normal;
    --sl-letter-spacing-loose: 0.075em;
    --sl-letter-spacing-looser: 0.15em;

    --sl-line-height-denser: 1;
    --sl-line-height-dense: 1.4;
    --sl-line-height-normal: 1.8;
    --sl-line-height-loose: 2.2;
    --sl-line-height-looser: 2.6;

    --sl-focus-ring-color: var(--sl-color-primary-600);
    --sl-focus-ring-style: solid;
    --sl-focus-ring-width: 3px;
    --sl-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width)
      var(--sl-focus-ring-color);
    --sl-focus-ring-offset: 1px;

    --sl-button-font-size-small: var(--sl-font-size-x-small);
    --sl-button-font-size-medium: var(--sl-font-size-small);
    --sl-button-font-size-large: var(--sl-font-size-medium);

    --sl-input-height-small: 1.875rem;
    --sl-input-height-medium: 2.5rem;
    --sl-input-height-large: 3.125rem;

    --sl-input-background-color: var(--sl-color-neutral-0);
    --sl-input-background-color-hover: var(--sl-input-background-color);
    --sl-input-background-color-focus: var(--sl-input-background-color);
    --sl-input-background-color-disabled: var(--sl-color-neutral-100);
    --sl-input-border-color: var(--sl-color-neutral-300);
    --sl-input-border-color-hover: var(--sl-color-neutral-400);
    --sl-input-border-color-focus: var(--sl-color-primary-500);
    --sl-input-border-color-disabled: var(--sl-color-neutral-300);
    --sl-input-border-width: 1px;
    --sl-input-required-content: "*";
    --sl-input-required-content-offset: -2px;
    --sl-input-required-content-color: var(--sl-input-label-color);

    --sl-input-border-radius-small: var(--sl-border-radius-medium);
    --sl-input-border-radius-medium: var(--sl-border-radius-medium);
    --sl-input-border-radius-large: var(--sl-border-radius-medium);

    --sl-input-font-family: var(--sl-font-sans);
    --sl-input-font-weight: var(--sl-font-weight-normal);
    --sl-input-font-size-small: var(--sl-font-size-small);
    --sl-input-font-size-medium: var(--sl-font-size-medium);
    --sl-input-font-size-large: var(--sl-font-size-large);
    --sl-input-letter-spacing: var(--sl-letter-spacing-normal);

    --sl-input-color: var(--sl-color-neutral-700);
    --sl-input-color-hover: var(--sl-color-neutral-700);
    --sl-input-color-focus: var(--sl-color-neutral-700);
    --sl-input-color-disabled: var(--sl-color-neutral-900);
    --sl-input-icon-color: var(--sl-color-neutral-500);
    --sl-input-icon-color-hover: var(--sl-color-neutral-600);
    --sl-input-icon-color-focus: var(--sl-color-neutral-600);
    --sl-input-placeholder-color: var(--sl-color-neutral-500);
    --sl-input-placeholder-color-disabled: var(--sl-color-neutral-600);
    --sl-input-spacing-small: var(--sl-spacing-small);
    --sl-input-spacing-medium: var(--sl-spacing-medium);
    --sl-input-spacing-large: var(--sl-spacing-large);

    --sl-input-focus-ring-color: hsl(198.6 88.7% 48.4% / 40%);
    --sl-input-focus-ring-offset: 0;

    --sl-input-filled-background-color: var(--sl-color-neutral-100);
    --sl-input-filled-background-color-hover: var(--sl-color-neutral-100);
    --sl-input-filled-background-color-focus: var(--sl-color-neutral-100);
    --sl-input-filled-background-color-disabled: var(--sl-color-neutral-100);
    --sl-input-filled-color: var(--sl-color-neutral-800);
    --sl-input-filled-color-hover: var(--sl-color-neutral-800);
    --sl-input-filled-color-focus: var(--sl-color-neutral-700);
    --sl-input-filled-color-disabled: var(--sl-color-neutral-800);

    --sl-input-label-font-size-small: var(--sl-font-size-small);
    --sl-input-label-font-size-medium: var(--sl-font-size-medium);
    --sl-input-label-font-size-large: var(--sl-font-size-large);
    --sl-input-label-color: inherit;

    --sl-input-help-text-font-size-small: var(--sl-font-size-x-small);
    --sl-input-help-text-font-size-medium: var(--sl-font-size-small);
    --sl-input-help-text-font-size-large: var(--sl-font-size-medium);
    --sl-input-help-text-color: var(--sl-color-neutral-500);

    --sl-toggle-size-small: 0.875rem;
    --sl-toggle-size-medium: 1.125rem;
    --sl-toggle-size-large: 1.375rem;

    --sl-overlay-background-color: hsl(240 3.8% 46.1% / 33%);

    --sl-panel-background-color: var(--sl-color-neutral-0);
    --sl-panel-border-color: var(--sl-color-neutral-200);
    --sl-panel-border-width: 1px;

    --sl-tooltip-border-radius: var(--sl-border-radius-medium);
    --sl-tooltip-background-color: var(--sl-color-neutral-800);
    --sl-tooltip-color: var(--sl-color-neutral-0);
    --sl-tooltip-font-family: var(--sl-font-sans);
    --sl-tooltip-font-weight: var(--sl-font-weight-normal);
    --sl-tooltip-font-size: var(--sl-font-size-small);
    --sl-tooltip-line-height: var(--sl-line-height-dense);
    --sl-tooltip-padding: var(--sl-spacing-2x-small) var(--sl-spacing-x-small);
    --sl-tooltip-arrow-size: 6px;

    --sl-z-index-drawer: 700;
    --sl-z-index-dialog: 800;
    --sl-z-index-dropdown: 900;
    --sl-z-index-toast: 950;
    --sl-z-index-tooltip: 1000;
  }

  @supports (scrollbar-gutter: stable) {
    .sl-scroll-lock {
      scrollbar-gutter: var(--sl-scroll-lock-gutter) !important;
    }

    .sl-scroll-lock body {
      overflow: hidden !important;
    }
  }

  @supports not (scrollbar-gutter: stable) {
    .sl-scroll-lock body {
      padding-right: var(--sl-scroll-lock-size) !important;
      overflow: hidden !important;
    }
  }

  .sl-toast-stack {
    position: fixed;
    top: 0;
    inset-inline-end: 0;
    z-index: var(--sl-z-index-toast);
    width: 28rem;
    max-width: 100%;
    max-height: 100%;
    overflow: auto;
  }

  .sl-toast-stack sl-alert {
    margin: var(--sl-spacing-medium);
  }

  .sl-toast-stack sl-alert::part(base) {
    box-shadow: var(--sl-shadow-large);
  }
`;




class $7371dbde8658f137$export$dbdf29b3edbf1161 {
    constructor(){
        this.storageKey = "funid_debug";
        this.debugEnabled = Boolean(localStorage.getItem(this.storageKey));
    }
    log(...value) {
        if (!this.debugEnabled) return;
        const css = "color: #6419E9";
        console.log("%c[FunId Auth]", css, ...value);
    }
}




const $023fcf6fda327e74$export$b9ad9f9dc47de58b = "https://api.funid.com";
const $023fcf6fda327e74$export$e17309bd66ff8de8 = "https://api-dev.funid.com";
const $023fcf6fda327e74$export$77bd2dbb419757da = "https://content.funid.com/api";
const $023fcf6fda327e74$export$23f8007511dc03bf = "https://cms-dev.funid.com/api";
const $023fcf6fda327e74$export$31adfacaf07ffe63 = "https://content.funid.com";
const $023fcf6fda327e74$export$e02c247f22c02971 = "https://cms-dev.funid.com";


var $7d4f00e65f7c5e65$export$c8099e04e768ee00;
(function(FunIdEnvType) {
    FunIdEnvType["Development"] = "dev";
    FunIdEnvType["Production"] = "prod";
})($7d4f00e65f7c5e65$export$c8099e04e768ee00 || ($7d4f00e65f7c5e65$export$c8099e04e768ee00 = {}));
class $7d4f00e65f7c5e65$export$47fc9cc6682fea7 {
    constructor(){
        this.storageKey = "funid_env";
    }
    getEnvType() {
        return localStorage.getItem(this.storageKey);
    }
    isValidEnv(name) {
        return name === $7d4f00e65f7c5e65$export$c8099e04e768ee00.Development || name === $7d4f00e65f7c5e65$export$c8099e04e768ee00.Production;
    }
    hasSpecifiedEnv() {
        return Boolean(localStorage.getItem(this.storageKey));
    }
}


class $5116e86639f7b186$export$5fc78cd05cd8a92a {
    constructor(){
        this.envService = new (0, $7d4f00e65f7c5e65$export$47fc9cc6682fea7)();
    }
    set(url, transactionId) {
        this.url = url;
        this.transactionId = transactionId;
    }
    getTransactionId() {
        return this.transactionId;
    }
    getQrUrl() {
        return this.url || `https://pay.funid.com/process/?transaction_id=${this.transactionId}&identify=true`;
    }
    getApiUrl() {
        return this.isDev() ? (0, $023fcf6fda327e74$export$23f8007511dc03bf) : (0, $023fcf6fda327e74$export$77bd2dbb419757da);
    }
    getWsApiUrl() {
        return this.isDev() ? (0, $023fcf6fda327e74$export$e17309bd66ff8de8) : (0, $023fcf6fda327e74$export$b9ad9f9dc47de58b);
    }
    isDev() {
        var _a;
        if (this.envService.hasSpecifiedEnv()) {
            const savedEnv = this.envService.getEnvType();
            if (this.envService.isValidEnv(savedEnv)) return savedEnv === (0, $7d4f00e65f7c5e65$export$c8099e04e768ee00).Development;
        }
        return Boolean((_a = this.url) === null || _a === void 0 ? void 0 : _a.includes("-dev.funid"));
    }
    getCdnUrl() {
        return this.isDev() ? (0, $023fcf6fda327e74$export$e02c247f22c02971) : (0, $023fcf6fda327e74$export$31adfacaf07ffe63);
    }
}


class $dd948d94b7a43f8c$export$578eac54095540b7 {
    static createNode(tagName, options) {
        const node = document.createElement(tagName);
        if (options === null || options === void 0 ? void 0 : options.className) node.className = options.className;
        if (options === null || options === void 0 ? void 0 : options.attrs) Object.entries(options.attrs).forEach(([key, value])=>{
            node.setAttribute(key, value);
        });
        return document.createElement(tagName);
    }
}


const $2dc3b963dbd6ea14$export$f7119adb0157103a = {
    data: {
        id: 1,
        attributes: {
            title: "Join with FunID",
            description: "Scan QR-code to login",
            text: "Get FunID app on your phone",
            infoButtonText: "More about FunID",
            steps: {
                id: 38,
                title: "title",
                items: [
                    {
                        id: 122,
                        text: "Download the app",
                        icon: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".svg",
                                    mime: "image/svg+xml",
                                    url: ""
                                }
                            }
                        },
                        link: ""
                    },
                    {
                        id: 123,
                        text: "Verify your identity",
                        icon: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".svg",
                                    mime: "image/svg+xml",
                                    url: ""
                                }
                            }
                        },
                        link: ""
                    },
                    {
                        id: 124,
                        text: "Get your FunID wallet",
                        icon: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".svg",
                                    mime: "image/svg+xml",
                                    url: ""
                                }
                            }
                        },
                        link: ""
                    }
                ]
            },
            downloads: {
                id: 39,
                title: "store-link",
                items: [
                    {
                        id: 125,
                        text: "ios",
                        link: "https://apps.apple.com/tr/app/funid/id1517272804",
                        icon: {
                            data: {
                                attributes: {
                                    alternativeText: "",
                                    ext: ".svg",
                                    mime: "image/svg+xml",
                                    url: ""
                                }
                            }
                        }
                    },
                    {
                        id: 126,
                        text: "android",
                        link: "https://play.google.com/store/apps/details?id=com.unteleported.casinoidApp",
                        icon: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".svg",
                                    mime: "image/svg+xml",
                                    url: ""
                                }
                            }
                        }
                    }
                ]
            },
            info: {
                id: 1,
                title: "FunID",
                button: "Join with FunID",
                guide: [
                    {
                        id: 9,
                        title: "One wallet - all casinos",
                        description: "FunID is your digital wallet wherever you go. Our fast, easy-to-use and secure app lets you pay or play online, send and receive money fast and make secure online payments whenever you need to.",
                        media: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".png",
                                    mime: "image/png",
                                    url: ""
                                }
                            }
                        }
                    },
                    {
                        id: 10,
                        title: "Sign up to casino in one click",
                        description: "Fun ID can be used for deposits and withdrawals - and instant casino sign-up as well. You can either choose an online casino from the list found on the Fun ID app or scan the QR code found on all Fun ID casinos. It does not really get easier than this!",
                        media: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".webm",
                                    mime: "video/webm",
                                    url: ""
                                }
                            }
                        }
                    },
                    {
                        id: 11,
                        title: "Fast deposits and withdrawals",
                        description: "You can combine all your casino accounts to the app which makes deposits even easier. The system is quite genius and extremely easy to use. The app even shows all Fun ID casinos in one list (with bonus details of course). So we are definitely talking about a true casino payment application.",
                        media: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".png",
                                    mime: "image/png",
                                    url: ""
                                }
                            }
                        }
                    },
                    {
                        id: 12,
                        title: "Choose the best games and casinos",
                        description: "At this point a lot of you might wonder \u201Dwhat the heck is Fun ID\u201D. No worries, we are here to answer that question and any other you might have about the interesting payment service. Fun ID is a completely new e-wallet that combines account registration and money transfers. This means that you only need one application for online gaming - instead of having to download multiple ones.",
                        media: {
                            data: {
                                attributes: {
                                    alternativeText: null,
                                    ext: ".png",
                                    mime: "image/png",
                                    url: ""
                                }
                            }
                        }
                    }
                ]
            },
            background: {
                data: {
                    attributes: {
                        alternativeText: null,
                        ext: ".png",
                        mime: "image/png",
                        url: ""
                    }
                }
            },
            logo: {
                data: {
                    attributes: {
                        alternativeText: null,
                        ext: ".png",
                        mime: "image/png",
                        url: ""
                    }
                }
            }
        }
    }
};


const $32bf911c7c864e9c$var$transformMedia = (response)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        alt: ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.alternativeText) || "",
        ext: ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.ext) || "",
        mime: ((_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f.mime) || "",
        url: ((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.attributes) === null || _h === void 0 ? void 0 : _h.url) || ""
    };
};
const $32bf911c7c864e9c$var$mapResponse = ({ data: { attributes: attributes } })=>({
        title: attributes.title,
        description: attributes.description,
        text: attributes.text,
        infoButtonText: attributes.infoButtonText,
        background: $32bf911c7c864e9c$var$transformMedia(attributes.background),
        logo: $32bf911c7c864e9c$var$transformMedia(attributes.logo),
        info: {
            title: attributes.info.title,
            button: attributes.info.button,
            guide: attributes.info.guide.map((infoItem)=>({
                    title: infoItem.title,
                    description: infoItem.description,
                    media: $32bf911c7c864e9c$var$transformMedia(infoItem.media)
                }))
        },
        steps: {
            title: attributes.steps.title,
            items: attributes.steps.items.map((stepItem)=>({
                    text: stepItem.text,
                    link: stepItem.link,
                    icon: $32bf911c7c864e9c$var$transformMedia(stepItem.icon)
                }))
        },
        downloads: {
            title: attributes.downloads.title,
            items: attributes.downloads.items.map((downloadItem)=>({
                    text: downloadItem.text,
                    link: downloadItem.link,
                    icon: $32bf911c7c864e9c$var$transformMedia(downloadItem.icon)
                }))
        }
    });
class $32bf911c7c864e9c$export$6ac6a2eeb799e543 {
    static getWidget(apiUrl, lang = "en") {
        return fetch(`${apiUrl}/auth-widget?populate=steps,steps.items,steps.items.icon,downloads,downloads.items,downloads.items.icon,info,info.guide,info.guide.media,background,logo&locale=${lang}`).then((res)=>res.json()).then($32bf911c7c864e9c$var$mapResponse).catch(()=>$32bf911c7c864e9c$var$mapResponse((0, $2dc3b963dbd6ea14$export$f7119adb0157103a)));
    }
    static getAvailableLangs(apiUrl) {
        return fetch(`${apiUrl}/auth-widget?populate[localizations][fields]=locale&fields=locale`).then((res)=>res.json()).then((response)=>{
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.localizations) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.map((data)=>{
                var _a;
                return (_a = data === null || data === void 0 ? void 0 : data.attributes) === null || _a === void 0 ? void 0 : _a.locale;
            });
        });
    }
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $75585ac6720b6d08$export$61db76a97f26b7e1 = {
    INITIAL: 0,
    PENDING: 1,
    COMPLETE: 2,
    ERROR: 3
}, $75585ac6720b6d08$export$d4c72bab9d6cc13a = Symbol();
class $75585ac6720b6d08$export$2dea7024bcdd7731 {
    get taskComplete() {
        return this.t || (1 === this.i ? this.t = new Promise((t, s)=>{
            this.o = t, this.h = s;
        }) : 3 === this.i ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
    }
    constructor(t, s, i){
        this.p = 0, this.i = 0, (this._ = t).addController(this);
        const h = "object" == typeof s ? s : {
            task: s,
            args: i
        };
        this.v = h.task, this.j = h.args, this.m = h.argsEqual ?? $75585ac6720b6d08$export$41b40a0c6412e2a2, this.k = h.onComplete, this.A = h.onError, this.autoRun = h.autoRun ?? !0, "initialValue" in h && (this.u = h.initialValue, this.i = 2, this.O = this.T?.());
    }
    hostUpdate() {
        !0 === this.autoRun && this.S();
    }
    hostUpdated() {
        "afterUpdate" === this.autoRun && this.S();
    }
    T() {
        if (void 0 === this.j) return;
        const t = this.j();
        if (!Array.isArray(t)) throw Error("The args function must return an array");
        return t;
    }
    async S() {
        const t = this.T(), s = this.O;
        this.O = t, t === s || void 0 === t || void 0 !== s && this.m(s, t) || await this.run(t);
    }
    async run(t) {
        let s, h;
        t ??= this.T(), this.O = t, 1 === this.i ? this.q?.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, "afterUpdate" === this.autoRun ? queueMicrotask(()=>this._.requestUpdate()) : this._.requestUpdate();
        const r = ++this.p;
        this.q = new AbortController;
        let e = !1;
        try {
            s = await this.v(t, {
                signal: this.q.signal
            });
        } catch (t) {
            e = !0, h = t;
        }
        if (this.p === r) {
            if (s === $75585ac6720b6d08$export$d4c72bab9d6cc13a) this.i = 0;
            else {
                if (!1 === e) {
                    try {
                        this.k?.(s);
                    } catch  {}
                    this.i = 2, this.o?.(s);
                } else {
                    try {
                        this.A?.(h);
                    } catch  {}
                    this.i = 3, this.h?.(h);
                }
                this.u = s, this.l = h;
            }
            this._.requestUpdate();
        }
    }
    abort(t) {
        1 === this.i && this.q?.abort(t);
    }
    get value() {
        return this.u;
    }
    get error() {
        return this.l;
    }
    get status() {
        return this.i;
    }
    render(t) {
        switch(this.i){
            case 0:
                return t.initial?.();
            case 1:
                return t.pending?.();
            case 2:
                return t.complete?.(this.value);
            case 3:
                return t.error?.(this.error);
            default:
                throw Error("Unexpected status: " + this.i);
        }
    }
}
const $75585ac6720b6d08$export$41b40a0c6412e2a2 = (s, i)=>s === i || s.length === i.length && s.every((s, h)=>!(0, $e4b86d4640103ab8$export$53a6892c50694894)(s, i[h]));




let $897b5b1a582f6d53$export$be80149fc633bf3a = class FunidAuth extends (0, $23a6037be2405355$export$3f2f9f5909897157) {
    render() {
        return (0, $15085907dd60083a$export$c0bb0b647f701bb5)`
      ${this.dataTask.render({
            complete: (data)=>(0, $15085907dd60083a$export$c0bb0b647f701bb5)`
          <funid-auth-modal
            .open="${this.popupOpened}"
            .viewType="${this.viewType}"
            .url="${this.config.getQrUrl()}"
            .data="${data}"
            .close="${this.closeDialog.bind(this)}"
            .langCode="${this.langCode}"
          ></funid-auth-modal>

          <slot>
            <funid-auth-button
              @click=${this.openDialogEvent}
              .text="${data.title}"
              .logo="${data.logo}"
            ></funid-auth-button>
          </slot>
        `,
            error: (error)=>(0, $15085907dd60083a$export$c0bb0b647f701bb5)`<p>Oops, something went wrong: ${error}</p>`
        })}
    `;
    }
    constructor(){
        super();
        this.logger = new (0, $7371dbde8658f137$export$dbdf29b3edbf1161)();
        this.config = new (0, $5116e86639f7b186$export$5fc78cd05cd8a92a)();
        this.viewType = (0, $3983f13df137da54$export$6d8156797d3409d0).QrCode;
        this.langCode = "en";
        this.transactionKey = "transaction_id";
        this.readySubject$ = new (0, $c1127b94a80f0c76$export$cc3d42e6b2b9cf8b)(false);
        this.readySubscription = null;
        this.popupOpened = false;
        this.dataTask = new (0, $75585ac6720b6d08$export$2dea7024bcdd7731)(this, {
            task: async ([apiUrl])=>{
                const langCode = await this.getLangCode(this.langCode);
                return (0, $32bf911c7c864e9c$export$6ac6a2eeb799e543).getWidget(apiUrl, langCode);
            },
            args: ()=>[
                    this.config.getApiUrl()
                ],
            autoRun: true
        });
        this.connectFonts();
    }
    connectedCallback() {
        super.connectedCallback();
        const root = new (0, $3250f013292a4786$export$a375903047a16407)();
        root.attach(document.body);
        if (this.qrcUrl) {
            const transactionId = this.getTransactionId(this.qrcUrl);
            this.config.set(this.qrcUrl, transactionId);
            this.logger.log("Config updated: ", {
                qrcUrl: this.qrcUrl,
                transactionId: transactionId
            });
        }
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        this.readySubject$.next(true);
    }
    attributeChangedCallback(name, oldValue, value) {
        super.attributeChangedCallback(name, oldValue, value);
        this.logger.log("Props changed:", {
            name: name,
            oldValue: oldValue,
            newValue: value
        });
        if (name === "langcode" && value !== oldValue) {
            this.logger.log(`langCode changed: ${value}`);
            this.dataTask.run([
                this.config.getApiUrl()
            ]);
        }
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.readySubscription) === null || _a === void 0 || _a.unsubscribe();
    }
    openDialogEvent() {
        if (typeof this.qrcUrl !== "undefined") {
            this.logger.log("openDialogEvent");
            this.openDialog();
        } else {
            this.dispatchEvent(new CustomEvent((0, $3983f13df137da54$export$314193dd3636a61c).AuthOpen, {
                detail: {
                    handler: this.openDialog.bind(this)
                },
                bubbles: true,
                composed: true
            }));
            this.logger.log(`"${(0, $3983f13df137da54$export$314193dd3636a61c).AuthOpen}" custom event dispatched`);
        }
    }
    openDialog(params) {
        this.readySubscription = this.readySubject$.asObservable().pipe((0, $7a579d6c3e7bdeaf$export$3dea766d36a8935f)(Boolean)).subscribe(()=>{
            if ((params === null || params === void 0 ? void 0 : params.viewType) && Object.values((0, $3983f13df137da54$export$6d8156797d3409d0)).includes(params.viewType)) this.viewType = params.viewType;
            if (params === null || params === void 0 ? void 0 : params.qrcUrl) {
                this.qrcUrl = params.qrcUrl;
                this.langCode = params.langCode;
                const transactionId = this.getTransactionId(this.qrcUrl);
                this.config.set(this.qrcUrl, transactionId);
                this.logger.log("Config updated: ", {
                    qrcUrl: this.qrcUrl,
                    transactionId: transactionId
                });
            }
            this.popupOpened = true;
            this.logger.log('"openDialog()" called');
            this.requestUpdate();
        });
    }
    closeDialog() {
        this.popupOpened = false;
        this.logger.log("Dialog closed");
        this.dispatchEvent(new CustomEvent((0, $3983f13df137da54$export$314193dd3636a61c).AuthClose, {
            bubbles: true,
            composed: true
        }));
    }
    connectFonts() {
        const font = (0, $dd948d94b7a43f8c$export$578eac54095540b7).createNode("link", {
            attrs: {
                rel: "stylesheet",
                href: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"
            }
        });
        document.head.appendChild(font);
        this.logger.log("Fonts connected");
    }
    getTransactionId(query) {
        const url = new URL(query);
        if (url.searchParams.has(this.transactionKey)) {
            const transactionId = url.searchParams.get("transaction_id");
            this.logger.log(`transactionId:  ${transactionId}`);
            return transactionId;
        } else {
            this.logger.log("transaction_id not found");
            throw new Error("'transaction_id' not found in options [funid-auth]");
        }
    }
    async getLangCode(code) {
        const langMap = {
            no: "nn",
            gr: "el"
        };
        const defaultLangCode = "en";
        const apiUrl = this.config.getApiUrl();
        let langCode = code;
        if (code in langMap) langCode = langMap[code];
        if (!apiUrl) return defaultLangCode;
        const availableLanguages = await (0, $32bf911c7c864e9c$export$6ac6a2eeb799e543).getAvailableLangs(apiUrl);
        const isValidLang = availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.includes(langCode);
        if (!isValidLang) return defaultLangCode;
        return langCode;
    }
};
$897b5b1a582f6d53$export$be80149fc633bf3a.styles = [
    (0, $cb0ade0a370c071d$export$2e2bcd8739ae039),
    (0, $cf848438daf93422$export$dbf350e5966cf602)`
      :host {
        --text-main: var(--fid-uth-text-main, #1b3063);
        --text-secondary: var(--fid-uth-text-secondary, #7e7bb4);
        --fid-auth-button-text-color: #fff;
        --fid-auth-button-background-color: #3f38dd;
        --fid-auth-button-padding: 6px;
        --fid-auth-dialog-z-index: 1;
        --fid-auth-dialog-qr-width: 200px;
        --fid-auth-dialog-qr-margin: 20px auto 20px;
        --fid-auth-dialog-qr-color: var(--text-main);
        --fid-auth-get-app-button-text-color: #fff;
        --fid-auth-get-app-button-background-color: #3f38dd;
        --fid-auth-show-more-button-color: #3f38dd;
        --fid-auth-details-state-background-color: #f1f3fb;
        --fid-auth-details-title-color: #3f38dd;
        --fid-auth-guide-background-color: #fff;
        --fud-auth-close-button-background-color: #fff;

        font-family: 'Montserrat', sans-serif;
        font-optical-sizing: auto;
        font-weight: 600;
        font-style: normal;
        display: block;
      }
    `
];
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $42872b8bf3f7039a$export$abe1e183e22e10ad)({
        context: (0, $0dea777ca5c7699b$export$a27ef4b2aa0375e)
    })
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "logger", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $42872b8bf3f7039a$export$abe1e183e22e10ad)({
        context: (0, $6d09782d66e5dd79$export$bd981449327f67c2)
    })
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "config", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "viewType", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "langCode", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "qrcUrl", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6e0e0f5559cb846e$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "transactionKey", void 0);
(0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $6d01d14c9cac29de$export$ca000e230c0caa3e)()
], $897b5b1a582f6d53$export$be80149fc633bf3a.prototype, "popupOpened", void 0);
$897b5b1a582f6d53$export$be80149fc633bf3a = (0, $92b5ef3161639fdf$export$29e00dfd3077644b)([
    (0, $887f7aa45b30e788$export$da64fc29f17f9d0e)("funid-auth")
], $897b5b1a582f6d53$export$be80149fc633bf3a);




const $419e084450e2b559$var$componentName = "funidAuthFlow";
class $419e084450e2b559$var$Funid {
    static $inject = [
        "$scope",
        "$window",
        "paynplay",
        "contentBuffer",
        "popup",
        "$element",
        "config"
    ];
    constructor($scope, $window, paynplay, contentBuffer, popup, $element, config){
        this.$scope = $scope;
        this.$window = $window;
        this.paynplay = paynplay;
        this.contentBuffer = contentBuffer;
        this.popup = popup;
        this.$element = $element;
        this.config = config;
        $scope.openCode = this.openCode;
    }
    funidConfig = {
        paymethod: "funid",
        amount: 0,
        currency: "EUR",
        trigger_codes: null,
        locale: "en_GB"
    };
    initCodeParams = ()=>{
        return this.paynplay.init(this.funidConfig).then(({ result: result })=>{
            this.orderData = result;
        });
    };
    callback = ()=>{
        const authParams = {
            order_id: this.orderData?.order_id,
            paymethod: "funid",
            pep: false,
            gdpr_data: false,
            accept: true,
            gdpr_marketing: false
        };
        this.paynplay.auth(authParams).then((data)=>{
            this.popup.close();
        });
    };
    openCode = ()=>{
        this.initCodeParams().then(()=>{
            this.funIdElement.openDialog({
                qrcUrl: this.orderData.url,
                transactionId: this.orderData.order_id,
                langCode: this.config.currentLang
            });
        }).then(()=>{
            this.funIdElement.addEventListener("funid-auth-success", this.callback);
        });
    };
    $onInit = ()=>{
        const wrapper = this.$element[0];
        this.funIdElement = wrapper.querySelector("funid-auth");
    };
    $onChanges = ()=>{
        this.funidConfig.trigger_codes = !this.promocode && this.triggerCode || null;
        this.funidConfig.code = this.promocode || null;
        this.funidConfig.avatar = this.avatar || null;
    };
    $onDestroy = ()=>{
        this.funIdElement.removeEventListener("funid-auth-success", this.callback);
    };
}
app.component($419e084450e2b559$var$componentName, {
    controller: $419e084450e2b559$var$Funid,
    template: app.getTU($419e084450e2b559$var$componentName),
    bindings: {
        triggerCode: "<",
        avatar: "<",
        promocode: "<"
    }
});


$290503861428cbd0$exports = {
    "funid": $419e084450e2b559$exports
};


var $ad8d1102f3e92ba0$exports = {};
var $db3e46afb3974c37$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaAchievementsPage"
    };
    controller.$inject = [
        "$scope",
        "helper"
    ];
    function controller($scope, _helper) {
        $scope.preloader = false;
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$ad8d1102f3e92ba0$exports = {
    "linda": {
        "achievements": $db3e46afb3974c37$exports
    }
};


var $bee175243835ffd2$exports = {};
var $b9f69bebf8d88038$exports = {};









(function() {
    "use strict";
    app.factory("ws", controller);
    controller.$inject = [
        "config",
        "$q",
        "user",
        "user$",
        "ws$",
        "splash$",
        "$state",
        "helper",
        "wsEvents",
        "system$"
    ];
    function controller(_config, $q, _user, _user$, _ws$, _splash$, $state, _helper, _wsEvents, _system$) {
        let _subscribed = false;
        let _subscriptionToken = null;
        const options = {
            socket: {},
            messages: [],
            construct: construct
        };
        _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message === "loaded"), (0, $94b8433012a062db$export$b7df5d561049483a)(1)).subscribe((i)=>{
            const wsScript = _config.production ? _config.wsScript : `${_config.domain}/${_config.wsScript}`;
            _helper.dom.addScript(wsScript, ()=>{
                options.construct({
                    lang: $state.params.lang
                });
            });
        });
        _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
            if (options.socket.disconnect) options.construct({
                lang: $state.params.lang
            });
        });
        _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "logout")).subscribe(()=>{
            options.socket.close();
        });
        function subscribe() {
            const _subscriptionNeeded = _user.status && (!_subscribed || _subscriptionToken !== _user.sessionToken) ? true : false;
            if (_subscriptionNeeded) {
                const params = {
                    authorization: "Basic " + _user.sessionToken
                };
                options.socket.emit("ws:account/subscribe", params, (answer)=>{
                    if (answer.status === 200) {
                        _subscribed = true;
                        _subscriptionToken = _user.sessionToken;
                    }
                });
                return;
            }
            _subscribed = false;
        }
        // in linda-app
        function construct(params) {
            const def = $q.defer();
            try {
                options.socket = io(_config.apiUrl, {
                    path: "/socket",
                    query: params,
                    transports: [
                        "websocket",
                        "polling"
                    ]
                });
                options.socket.on("connect", ()=>{
                    subscribe();
                    _user$.subscribe(subscribe);
                    def.resolve(true);
                });
                options.socket.on("error", (error)=>{
                    console.error("========================== O N   E R R O R ------------------------>", error);
                    _subscribed = false;
                    def.reject(error);
                });
                options.socket.on("disconnect", (message)=>{
                    console.error("========================== O N   D I S C O N N E C T ------------------------>", message);
                    _subscribed = false;
                });
                Object.values(_wsEvents).forEach((event)=>{
                    options.socket.on(event, (data)=>{
                        _ws$.next({
                            event: event,
                            data: data
                        });
                    });
                });
            } catch (error) {
                console.error("========================== T R Y      E R R O R ------------------------>", error);
                _subscribed = false;
            }
            return def.promise;
        }
        return options;
    }
})();























(function() {
    "use strict";
    controller.$inject = [
        "config"
    ];
    app.factory("jurisdictions", controller);
    function controller({ jurisdiction: jurisdiction, jurisdictions: jurisdictions }) {
        return {
            sw (cb) {
                if (jurisdiction === jurisdictions["sw"]) cb();
            },
            de (cb) {
                if (jurisdiction === jurisdictions["de"]) cb();
            }
        };
    }
})();



(function() {
    "use strict";
    controller.$inject = [
        "config",
        "$window",
        "$interval"
    ];
    function controller(_config, $window, $interval) {
        const events = _config.p161 || null;
        const collectedEvents = [];
        const interval = $interval(()=>{
            if ($window.p161 && angular.isFunction($window.p161.track) && angular.isFunction($window.p161.trackQueue)) {
                collectedEvents.forEach((event)=>{
                    $window.p161.track(event);
                    $window.p161.trackQueue();
                });
                collectedEvents.length = 0;
            }
        }, 2000);
        if (!events) $interval.cancel(interval);
        return {
            track (eventName) {
                if (events && events[eventName]) collectedEvents.push(events[eventName]);
            }
        };
    }
    app.factory("p161", controller);
})();



(function() {
    "use strict";
    removeHashFromURL.$inject = [
        "$window"
    ];
    function removeHashFromURL($window) {
        return function() {
            const noHashURL = $window.location.href.replace(/#.*$/, "");
            $window.history.replaceState("", "", noHashURL);
        };
    }
    app.factory("removeHashFromURL", removeHashFromURL);
})();



(function() {
    "use strict";
    controller.$inject = [
        "$q",
        "http"
    ];
    function controller($q, _http) {
        const activate = (options)=>{
            const defer = $q.defer();
            const alias = "promocodeActivate";
            const config = {
                params: options,
                cache: false,
                meta: {
                    type: "api",
                    alias: alias
                }
            };
            const data = {};
            _http.post(alias, data, config).then((answer)=>{
                defer.resolve(answer.data);
            }, (answer)=>{
                defer.reject(answer.data);
            });
            return defer.promise;
        };
        return {
            activate: activate
        };
    }
    app.factory("promocode", controller);
})();







(function() {
    "use strict";
    controller.$inject = [
        "$window",
        "http",
        "$q",
        "system$",
        "user"
    ];
    function controller($window, _http, $q, _system$, _user) {
        const globalCdn = "/joxi";
        const symplifyScriptId = "symplify-script";
        const stylesSrc = `${globalCdn}/js/symplify/webpush.css`;
        const scriptSrc = "https://d3mi6d1ao3fzsg.cloudfront.net/webpush/1/webpush.min.js";
        const serviceWorkerSrc = "/symplify_sw.js";
        const getUserHash = ()=>{
            const defer = $q.defer();
            const alias = "userSymplifyHash";
            const config = {
                meta: {
                    alias: alias
                }
            };
            _http.get(alias, config).then(({ data: data })=>{
                defer.resolve(data);
            }).catch((error)=>{
                defer.reject(error);
            });
            return defer.promise;
        };
        const createElement = (tag, config)=>{
            const element = document.createElement(tag);
            // eslint-disable-next-line guard-for-in
            for(const key in config)element.setAttribute(key, config[key]);
            return element;
        };
        const appendStylesLink = ()=>{
            const attrs = {
                rel: "stylesheet",
                type: "text/css",
                href: stylesSrc
            };
            const link = createElement("link", attrs);
            document.head.appendChild(link);
        };
        const appendScript = (userHash)=>{
            const attrs = {
                type: "application/javascript",
                id: symplifyScriptId,
                src: scriptSrc,
                "data-enable-api": "true",
                "data-notifications": "true",
                "data-service-worker": serviceWorkerSrc,
                "data-user-hash": userHash,
                async: "true"
            };
            const target = document.scripts[document.scripts.length - 1];
            const scriptSymplify = createElement("script", attrs);
            target.parentElement.insertBefore(scriptSymplify, target.nextSibling);
        };
        const removeScript = ()=>{
            const scriptSymplify = document.getElementById(symplifyScriptId);
            scriptSymplify?.remove();
        };
        const start = ()=>{
            getUserHash().then(({ result: result })=>{
                appendScript(result.userHash);
            }).catch(()=>{}).finally(()=>{});
        };
        const makeSubscriptions = ()=>{
            _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "login")).subscribe(()=>{
                start();
            });
            _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "logout")).subscribe(()=>{
                if ($window.Symplify) Symplify.WebPush.hide();
                removeScript();
            });
        };
        const init = ()=>{
            appendStylesLink();
            if (_user.status) start();
            makeSubscriptions();
        };
        return {
            init: init
        };
    }
    app.factory("symplify", controller);
})();



(function() {
    "use strict";
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("postMessage$", controller);
})();









(function() {
    controller.$inject = [
        "$q",
        "http"
    ];
    app.factory("pgwApi", controller);
    function controller($q, _http) {
        return {
            getData (options) {
                const defer = $q.defer();
                const alias = "pgwInit";
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.post(alias, {
                    paymethod: "pgw_widget"
                }, config).then(({ data: data })=>{
                    defer.resolve(data);
                }).catch(({ data: data })=>{
                    defer.reject(data);
                });
                return defer.promise;
            }
        };
    }
})();









const $7bb8649499230499$export$ae56a9e6a76a3395 = "affilate";
class $7bb8649499230499$var$Affilate {
    static $inject = [
        "http",
        "localStorage"
    ];
    constructor(http, localStorage){
        this.http = http;
        this.localStorage = localStorage;
    }
    storedData = {};
    getData() {
        if (!Object.keys(this.storedData).length) {
            const affParams = this.localStorage.getAffiliateData();
            return this.http.getData("affiliateInfo", affParams).then((data)=>{
                this.storedData = data;
                return this.storedData;
            });
        }
        return new Promise((resolve)=>resolve(this.storedData));
    }
}
app.factory($7bb8649499230499$export$ae56a9e6a76a3395, $7bb8649499230499$var$Affilate);


(function() {
    controller.$inject = [
        "user",
        "config",
        "state",
        "notification$",
        "system$",
        "popup",
        "pgwApi",
        "ws",
        "ws$",
        "wsEvents",
        "$translate",
        "$window",
        "$document",
        "affilate",
        "config"
    ];
    app.factory("pgw", controller);
    function controller(_user, _config, _state, _notification$, _system$, _popup, _pgwApi, _ws, _ws$, _wsEvents, $translate, $window, $document, _affilate, _configs) {
        const { langReplacements: langReplacements } = $window.$_DICT.pgw;
        let pgw;
        const login$ = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login"));
        const logout$ = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "logout"));
        const balanceUpdate$ = _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.balanceUpdate));
        const pgwInitialization$ = new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)(1);
        const pgwLoad$ = new (0, $c904b59ef7f02b4e$export$915d2682b0aa0991)(false);
        let pgwInitSubscribtion;
        const callbacks = {
            getAuthToken () {
                return _pgwApi.getData().then(({ result: result })=>result.jwtToken).catch((error)=>{
                    console.error(error);
                });
            },
            destroyComponent () {
                pgw.unmount();
                _popup.close();
            },
            redirectByAlias (alias, params) {
                _state.goto(alias, params);
                pgw.unmount();
                if (alias.page) _popup.close();
            },
            showNotification (data) {
                _notification$.next({
                    type: data.type,
                    text: data.message
                });
            },
            openChat () {
                _system$.next({
                    action: "open chat"
                });
            }
        };
        function initPgwLoader() {
            return _config.pgwConfig.scriptLoaderUrl ? pgwScriptLoader() : pgwUrlLoader();
        }
        const getPgwScriptContent = (pgwUrl)=>`
      (function (w, d, s, o, f, js, fjs) {
          w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
          js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
          js.id = o; js.src = f; js.async = 1;
          w[o].isLoaded = false;
          js.onload = function() { if (w[o]) { w[o].isLoaded = true; w[o].onLoad && w[o].onLoad(); } };
          js.onerror = function(err) { if (w[o] && w[o].onError) { w[o].onError(err); } };
          fjs.parentNode.insertBefore(js, fjs);
      }(window, document, 'script', 'pgw_widget', '${pgwUrl}'));
    `;
        const pgwUrlLoader = ()=>{
            const script = $document[0].createElement("script");
            script.innerHTML = getPgwScriptContent(_config.pgwConfig.scriptUrl);
            $document[0].body.append(script);
            pgw = $window.pgw_widget;
            pgw.onLoad = ()=>{
                pgwLoad$.next(true);
            };
            pgw.onError = ()=>{
                console.error(`Can't init PGW script`);
            };
        };
        const pgwScriptLoader = ()=>{
            const script = $document[0].createElement("script");
            script.src = _config.pgwConfig.scriptLoaderUrl;
            $window.onloadPgwWidgetCallback = ()=>{
                pgw = $window.pgw_widget;
                pgwLoad$.next(true);
            };
            $window.onerrorPgwWidgetCallback = ()=>{
                console.error(`Can't init PGW script`);
            };
            $document[0].body.append(script);
        };
        const init = ()=>{
            if (_config.pgw?.enabled) initPgwLoader();
            else return;
            logout$.subscribe(()=>{
                pgw.terminate();
                pgwInitialization$.next(false);
                login$.pipe((0, $94b8433012a062db$export$b7df5d561049483a)(1)).subscribe(()=>{
                    initPgw();
                });
            });
            if (!_user.status) {
                (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)([
                    login$.pipe((0, $94b8433012a062db$export$b7df5d561049483a)(1)),
                    pgwLoad$
                ]).subscribe(()=>{
                    initPgw();
                });
                return;
            }
            pgwLoad$.subscribe(()=>{
                initPgw();
            });
        };
        (0, $913d9ff860ca23ca$export$77fa7d86f5204e8a)([
            pgwInitialization$,
            balanceUpdate$
        ]).subscribe(([, message])=>{
            pgw.setRealBalance(message.data.balance);
        });
        const cashboxInit = (action, amount)=>{
            pgwInitSubscribtion?.unsubscribe();
            pgwInitSubscribtion = pgwInitialization$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((value)=>value), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(logout$)).subscribe(()=>{
                const options = {
                    action: action || "deposit",
                    hideCloseButton: _config.pgw?.hideCloseButton
                };
                if (amount) options.preselectedAmount = amount;
                pgw.mount(options);
                pgw.setRealBalance(_user.profile.balance);
                setBlockers();
            });
            return pgwInitialization$;
        };
        function setBlockers() {
            const messages = [];
            if (_user.profile.active_bonus) messages.push({
                title: $translate.instant(`g.active.bonus`),
                text: $translate.instant(`g.withdrawal.bonus`),
                disableTransactions: true,
                cb: ()=>callbacks.redirectByAlias("bonuses")
            });
            return pgw.setWithdrawBlockingMessages(messages);
        }
        function initPgw() {
            const initParams = {
                locale: langReplacements[_config.currentLang] || _config.currentLang,
                country: _user.profile.country,
                currency: _user.profile.currency,
                theme: _config.pgw?.theme || "light",
                layoutMode: _config.pgw?.layoutMode || "row"
            };
            pgw.init({
                auth: callbacks.getAuthToken,
                params: initParams,
                onClose: callbacks.destroyComponent,
                onDepositSucceed: callbacks.destroyComponent,
                onWithdrawalSucceed: callbacks.destroyComponent,
                onBalanceHistoryClick: (type)=>{
                    if (type === "withdraw") callbacks.redirectByAlias("history", {
                        type: "withdraw"
                    });
                    else callbacks.redirectByAlias("history", {
                        type: "deposit"
                    });
                },
                onNotification: callbacks.showNotification,
                onSupportClick: callbacks.openChat
            }).then(()=>{
                pgwInitialization$.next(true);
            }).catch((err)=>console.error(err));
        }
        const getPaymentMethods = (paymentData)=>{
            if (!_user.status) return _affilate.getData().then(({ result: result })=>{
                const config = Object.assign(paymentData, result);
                return pgw.getPaymentMethods(preparePaymentListConfig(config));
            });
            return pgw.getPaymentMethods(preparePaymentListConfig(paymentData));
        };
        const checkDeviceType = ()=>{
            return _config.device.mobile ? "mobile" : "desktop";
        };
        const preparePaymentListConfig = (data)=>{
            const config = {
                country: data.country,
                currency: data.currency,
                type: data.type || "deposit",
                merchantKey: _config.pgwConfig.merchantKey
            };
            const affConfig = {
                customerAccountIsAffiliate: data.is_affiliate,
                customerAffiliateRiskScore: data.risk_score,
                customerAccountDeviceType: checkDeviceType(),
                customerSuccessfulDepositCount: 0,
                customerAccountIsKYCVerified: false
            };
            if (angular.isNumber(affConfig.customerAffiliateRiskScore)) Object.assign(config, affConfig);
            return config;
        };
        return {
            init: init,
            cashboxInit: cashboxInit,
            pgwInitialization$: pgwInitialization$,
            getPaymentMethods: getPaymentMethods
        };
    }
})();







(function() {
    "use strict";
    controller.$inject = [
        "localStorage",
        "analyticsEvents",
        "$window",
        "analytics"
    ];
    function controller(localStorage, analyticsEvents, $window, analytics) {
        const redirectMessage = "swRedirectUrl";
        return {
            sendEventOnSuccessRedirect () {
                if ($window.$_GET[redirectMessage]) {
                    analytics.send(analyticsEvents.SwMirrorRedirect, "success", $window.location.search);
                    localStorage.remove(redirectMessage);
                }
            }
        };
    }
    app.factory("mirrorAnalytics", controller);
})();







(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q",
        "system$",
        "popup",
        "user"
    ];
    const notificationTypes = [
        "stage_one_teaser",
        "stage_two_starting_teaser",
        "stage_two_finishing_teaser"
    ];
    function controller(_http, $q, _system$, _popup, _user) {
        return {
            init () {
                _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
                    this.data().then(({ result: result })=>{
                        if (_user.profile.sessions_info.is_first_session === false && notificationTypes.includes(result.notification_type)) _popup.open({
                            name: "ferrari-campaign",
                            content: result.notification_type
                        });
                    });
                });
            },
            data () {
                const alias = "dataCarPromo";
                const defer = $q.defer();
                const config = {
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            },
            leaderBoard (options) {
                const alias = "leaderBoardCarPromo";
                const defer = $q.defer();
                const config = {
                    params: options,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
    }
    app.factory("carPromo", controller);
})();






const $e848a2e09b95b15b$export$4a65a988b6cd1e7e = "optIn";
class $e848a2e09b95b15b$var$OptIn {
    static $inject = [
        "http",
        "system$",
        "popup"
    ];
    constructor(_http, _system$, _popup){
        this.http = _http;
        this.system$ = _system$;
        this.popup = _popup;
    }
    init() {
        return this.system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
            this.newlyBonuses().then(({ result: result })=>{
                if (result.length !== 0) this.popup.open({
                    name: "newly-bonuses",
                    content: result
                });
            });
        });
    }
    newlyBonuses() {
        return this.http.getData("userNewlyBonuses");
    }
}
app.factory($e848a2e09b95b15b$export$4a65a988b6cd1e7e, $e848a2e09b95b15b$var$OptIn);






const $4fe1640bcdb56d45$export$de5cf0d3099491f1 = "missedData";
class $4fe1640bcdb56d45$var$MissedData {
    static $inject = [
        "user",
        "user$",
        "state"
    ];
    constructor(_user, _user$, _state){
        this.user = _user;
        this.state = _state;
        this.userStream = _user$;
    }
    checkOnMissedData() {
        return this.user.status && this.user.profile?.requiredFields?.length || this.user.profile?.profile?.is_profile_complete === false;
    }
    init() {
        this.userStream.subscribe(()=>{
            if (this.checkOnMissedData()) this.state.goto("missedData");
        });
    }
}
app.factory($4fe1640bcdb56d45$export$de5cf0d3099491f1, $4fe1640bcdb56d45$var$MissedData);







const $f7da967b7452c702$export$fa7e900de95311c1 = "cancelWithdrawal";
class $f7da967b7452c702$var$CancelWithdrawal {
    static $inject = [
        "ws$",
        "wsEvents",
        "popup"
    ];
    constructor(ws$, wsEvents, popup){
        this.ws$ = ws$;
        this.wsEvents = wsEvents;
        this.popup = popup;
        this.destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        this.$onDestroy = ()=>{
            this.destroy$.next();
            this.destroy$.unsubscribe();
        };
    }
    init() {
        this.ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === this.wsEvents.balanceThresholdReached), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(this.destroy$)).subscribe(({ data: data })=>{
            this.popup.open({
                name: "balance-alert",
                content: data
            });
        });
    }
}
app.factory($f7da967b7452c702$export$fa7e900de95311c1, $f7da967b7452c702$var$CancelWithdrawal);





var $264d6c0a179c2f15$exports = {};
$264d6c0a179c2f15$exports = new URL("_sprite.1d305b94.svg", import.meta.url).toString();


(function() {
    "use strict";
    const component = {
        name: "lindaApp"
    };
    controller.$inject = [
        "$scope",
        "$location",
        "$translate",
        "$state",
        "ws",
        "ws$",
        "account",
        "popup",
        "user",
        "state",
        "notification$",
        "system$",
        "bonus",
        "timer$",
        "modal",
        "splash$",
        "helper",
        "promo.config",
        "countryLayout",
        "$timeout",
        "user$",
        "config",
        "system",
        "analytics",
        "heatmap",
        "$rootScope",
        "wsEvents",
        "jurisdictions",
        "p161",
        "achievement",
        "removeHashFromURL",
        "promocode",
        "remembered",
        "symplify",
        "postMessage$",
        "pgw",
        "analyticsEvents",
        "holidayPromo",
        "mirrorAnalytics",
        "$window",
        "carPromo",
        "optIn",
        "sentry",
        "missedData",
        "cancelWithdrawal",
        "captcha"
    ];
    function controller($scope, $location, $translate, $state, _ws, _ws$, _account, _popup, _user, _state, _notification$, _system$, _bonus, _timer$, _modal, _splash$, _helper, _promo_config, _countryLayout, $timeout, _user$, _config, _system, analytics, heatmap, $rootScope, _wsEvents, _jurisdictions, _p161, _achievement, _removeHashFromURL, _promocode, _remembered, _symplify, _postMessage$, _pgw, _analyticsEvents, _holidayPromo, _mirrorAnalytics, $window, _carPromo, _optIn, sentry, missedData, _cancelWithdrawal, _captcha) {
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        let bonuscode = $window.$_GET["bonuscode"];
        $translate.use($state.params.lang);
        _p161.track("view");
        $window.$_QA = {
            popup: {
                open (name) {
                    $timeout(()=>{
                        _popup.open({
                            name: name
                        });
                    });
                }
            },
            modal: {
                open (name, params) {
                    $timeout(()=>{
                        _modal.open(name, params).then((a)=>{}).catch((e)=>{});
                    });
                }
            },
            state: {
                goto (alias, params) {
                    $timeout(()=>{
                        _state.goto(alias, params);
                    });
                }
            },
            socket: {
                ws$ (data) {
                    _ws$.next(data);
                }
            }
        };
        Object.keys(_promo_config).forEach((promoName)=>{
            document.querySelector("body")?.classList.add(`linda-is-${promoName}`);
            switch(promoName){
                case "halloween":
                    const nflags = ($window.localStorage.getItem("promo-notification-flag") || "").split(",");
                    const index = nflags.indexOf(promoName);
                    if (index < 0) _popup.open({
                        name: "promo-notification",
                        content: {
                            name: promoName
                        }
                    });
                    break;
            }
        });
        _holidayPromo.init();
        _carPromo.init();
        _countryLayout.init();
        _optIn.init();
        _captcha.init();
        _system.info().then(({ result: result })=>{
            _system$.next({
                action: "systemInfo",
                data: result
            });
            const FiLangModalWasShown = $window.localStorage.getItem("FiLangModalWasShown");
            if (FiLangModalWasShown) return;
            if (result.country.code === "FI" && $state.params.lang !== "fi") _modal.open("lang-version-notification", result).then(()=>{}).catch(()=>{}).finally(()=>{
                $window.localStorage.setItem("FiLangModalWasShown", "true");
            });
        }).catch(()=>{}).finally(()=>{});
        //        _popup.open({name:'account-status'});
        /*
            _modal.open( 'trustly-registration', {
                profile:{
                    name:'Ulpu',
                    surname:'Koskela',
                    city:'Mustasaari',
                    postcode:'65610',
                    address:'Karkkimalantie 82',
                    gender:'F',
                    birthday:'1970-09-20',
                    email:'',
                    phone:''
                }
            } );
    */ /*
            _timer$.bufferCount( 30 ).subscribe( x => {
                if( _user.status )
                    _account
                        .info();
            } );
    */ // -        _ws.construct( { lang: $state.params.lang } );
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event, data: data })=>event === _wsEvents.achieve && data.achieve?.category)).subscribe(async ({ data: { achieve: { achievement_id: id } } })=>{
            const { result: achieve } = await _achievement.item({
                id: id
            });
            if (achieve.type === "composite" && achieve.prize !== 0 && _popup.has("composite-achievement")) {
                _popup.open({
                    name: "composite-achievement",
                    content: achieve
                });
                return;
            }
            _popup.open({
                name: `achieve-${achieve.category}`,
                content: achieve
            });
        });
        // autobonus popup
        // TODO this is kostbllb
        // we dont do bonus filter now
        // we will rewrite it in Q4
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.bonusIssue), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ data: data })=>!data.result[0]?.is_promo_bonus)).subscribe((event)=>{
            _popup.open({
                name: "autobonus-action",
                content: event.data.result
            });
            if (event.data.result[0].status === "active") _account.info();
        });
        // low balance popup
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.messageOptimove)).subscribe((event)=>{
            const result = event.data.replace(/\\n/g, '"').replace(/\\/g, "");
            _popup.open({
                name: "low-balance",
                content: result
            });
        });
        const updateLastDepositDetails = ()=>{
            _account.balanceDetails().then(({ result: { last_deposit: last_deposit } })=>{
                _user.balance = {
                    ..._user.balance,
                    last_deposit: last_deposit
                };
            }).catch(()=>{});
        };
        const activatePromocode = (promocode)=>{
            _promocode.activate({
                code: promocode
            }).then(()=>{
                bonuscode = null;
                $window.history.replaceState(null, "", $window.location.pathname);
                delete $window.$_GET["bonuscode"];
            }).catch(()=>{});
        };
        if (_user.status) {
            _bonus.list();
            updateLastDepositDetails();
            if (bonuscode) activatePromocode(bonuscode);
        }
        if (!_user.status && bonuscode) {
            const alias = _remembered.login ? "login" : "registration";
            _state.goto(alias);
        }
        _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe((message)=>{
            _bonus.list();
            updateLastDepositDetails();
            if (bonuscode) activatePromocode(bonuscode);
            if (_user.profile.is_new_account === false && _user.profile.sessions_info.is_first_session === false) $timeout(()=>{
                _popup.open({
                    name: "account-status"
                });
            });
        });
        _system$.subscribe((message)=>{
            switch(message.action){
                case "forced logout":
                    _account.logout(true).catch(()=>{});
                    break;
            }
        });
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.balanceUpdate)).subscribe((message)=>{
            _user.profile.balance = parseFloat(message.data.balance);
            _user.profile.bonus.casino.sum = parseFloat(message.data.bonus);
            _user.profile.bonus.sport.sum = parseFloat(message.data.bonus_sport);
            _user.profile.pending_withdrawals = message.data.pending_withdrawals;
            _user.profile.coins = message.data.coins || 0;
            _user.profile.tokens = message.data.tokens;
            $scope.$apply();
        });
        // https://jira.gosystem.io/browse/FED-2575
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.balanceDetails)).subscribe(({ data: { last_deposit: last_deposit } })=>{
            _user.balance = {
                ..._user.balance,
                last_deposit: last_deposit
            };
            $scope.$apply();
        });
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.deposit)).subscribe(({ data: data })=>{
            if (!data || !data.result) return;
            const { amountEUR: amountEUR, isFtd: isFtd, transactionId: transactionId } = data.result;
            analytics.send(isFtd ? _analyticsEvents.balanceFTD : _analyticsEvents.balanceDeposit, amountEUR, transactionId);
            heatmap.sendEvent("event", isFtd ? "ftd" : "deposit");
            _p161.track("deposit");
        });
        _user$.pipe((0, $749718fcf90c147c$export$a4fe86229b0e9bdd)(_user), (0, $969807fecf2e057f$export$7843a4469d64c07e)(200)).subscribe((user)=>{
            if (user.status) heatmap.trigger("heatmap_for_authorized");
            else heatmap.trigger("heatmap_for_unauthorized");
        });
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.logout)).subscribe((event)=>{
            _notification$.next({
                type: "error",
                code: 0,
                text: event.data.message
            });
            sentry.sendMessage("logout", {
                level: "info",
                tags: {
                    event: "logout-ws",
                    type: "success",
                    side: "backend",
                    account_id: _user.profile.account_id
                },
                extra: {
                    message: JSON.stringify(event.data)
                }
            });
            _account.logout(true).catch(()=>{});
        });
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.coolOffGameInActivated)).subscribe(({ data: { until: until, info: info } })=>{
            const coolOffPopupName = "cool-off";
            const coolOff = {
                active_until: {
                    time: until
                },
                info: info
            };
            _user.profile = {
                ..._user.profile,
                cool_off_game_in: coolOff
            };
            _popup.open({
                name: coolOffPopupName
            });
        });
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.coolOffGameInDeactivated)).subscribe(()=>{
            const coolOffPopupName = "cool-off";
            _user.profile = {
                ..._user.profile,
                cool_off_game_in: {}
            };
            if (_popup.current && _popup.current.includes(coolOffPopupName)) _popup.close();
        });
        $window.$_startCoolOff = ()=>_ws$.next({
                event: _wsEvents.coolOffGameInActivated,
                data: {
                    until: Date.now() / 1000 + 10,
                    info: {
                        win: 100,
                        loss: 100,
                        bet: 100,
                        deposits: 100
                    }
                }
            });
        $window.$_endCoolOff = ()=>_ws$.next({
                event: _wsEvents.coolOffGameInDeactivated,
                data: {}
            });
        // popup by link
        switch($location.hash()){
            case "popup-reg":
                if (!_user.status) _popup.open({
                    name: "registration"
                });
                _removeHashFromURL();
                break;
            case "popup-login":
                if (!_user.status) _popup.open({
                    name: "login"
                });
                _removeHashFromURL();
                break;
            case "forgot-password-form":
                if (!_user.status) _popup.open({
                    name: "restoration"
                });
                break;
            case "deposit":
                if (_user.status) _state.goto("deposit");
                else _popup.open({
                    name: "login",
                    cb () {
                        _state.goto("deposit");
                    }
                });
                break;
            case "chat":
                _removeHashFromURL();
                _system$.next({
                    action: "open chat"
                });
                break;
        }
        if ($state.params.restore !== undefined) {
            if (!_user.status) _popup.open({
                name: "new-password"
            });
            $state.go(".", {
                restore: undefined
            }, {
                notify: false
            });
        }
        if ($state.params.activation !== undefined) {
            _account.activate({
                token: $state.params.activation
            }).then((answer)=>{
                _state.goto("deposit");
            }, (answer)=>{});
            $state.go(".", {
                activation: undefined
            }, {
                notify: false
            });
        }
        const importSprite = async ()=>{
            const url = new URL($264d6c0a179c2f15$exports);
            url.search = "";
            const response = await fetch(url);
            const svgText = await response.text();
            const div = document.createElement("div");
            div.style.display = "none";
            div.innerHTML = svgText;
            document.body.appendChild(div);
        };
        if (_config.useSvgSprite === true) importSprite();
        if (_config.insertCdnScripts === false) ;
        else _splash$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((m)=>m === "loaded"), (0, $94b8433012a062db$export$b7df5d561049483a)(1), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((i)=>{
            [
                "iban"
            ].forEach((item)=>{
                _helper.dom.addScript(`/joxi/js/v2/${item}.js`);
            });
        });
        missedData.init();
        // this code may be used for fake WS events
        // _ws$
        //   .next({event: 'deposit', data: {
        //       result: {isFtd: true, paymentName: "PaymentName", transactionId: 0000000},
        //       status: 200
        //     }})
        if (_config.symplify) _symplify.init();
        $window.addEventListener("message", (event)=>{
            _postMessage$.next(event.data);
        });
        _pgw.init();
        _mirrorAnalytics.sendEventOnSuccessRedirect();
        _cancelWithdrawal.init();
        this.$onDestroy = ()=>{
            destroy$.next();
            destroy$.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$bee175243835ffd2$exports = {
    "linda": $b9f69bebf8d88038$exports
};


var $40f289865e65b0e1$exports = {};
var $19a2ca688da6710e$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaArticleBox"
    };
    controller.$inject = [
        "$scope",
        "article"
    ];
    function controller($scope, _article) {
        $scope.article = {};
        $scope.preloader = false;
        this.$onChanges = function() {
            if (typeof this.name !== "undefined") {
                $scope.preloader = true;
                _article.item({
                    name: this.name
                }).then((answer)=>{
                    $scope.article = answer.result;
                    $scope.preloader = false;
                }, (answer)=>{
                    $scope.preloader = false;
                });
            }
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            name: "<"
        }
    });
})();


$40f289865e65b0e1$exports = {
    "linda": $19a2ca688da6710e$exports
};


var $1895f3e078b74cee$exports = {};
var $bd8fed307e920b44$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaAutobonusPopup"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$1895f3e078b74cee$exports = {
    "linda": $bd8fed307e920b44$exports
};


var $723e96e3dc90f738$exports = {};
var $626f6e61434ae2b6$exports = {};

const $626f6e61434ae2b6$var$componentName = "lindaBalanceAlertPopup";
class $626f6e61434ae2b6$var$balanceAlertPopup {
    static $inject = [
        "$scope",
        "contentBuffer"
    ];
    constructor($scope, contentBuffer){
        const data = contentBuffer.read("popup");
        $scope.balance = data.balance;
        if (data.max_pending_withdrawal) $scope.withdrawalData = data.max_pending_withdrawal;
    }
}
app.component($626f6e61434ae2b6$var$componentName, {
    controller: $626f6e61434ae2b6$var$balanceAlertPopup,
    template: app.getTU($626f6e61434ae2b6$var$componentName)
});


$723e96e3dc90f738$exports = {
    "linda": $626f6e61434ae2b6$exports
};


var $688c0ca89964b0ab$exports = {};
var $785ed6259a1fc980$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaBonusActivationModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$688c0ca89964b0ab$exports = {
    "linda": {
        "modal": $785ed6259a1fc980$exports
    }
};


var $e76ab8b2da876a0f$exports = {};
var $9d650abdf3efc9b9$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaBonusCancellationModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$e76ab8b2da876a0f$exports = {
    "linda": {
        "modal": $9d650abdf3efc9b9$exports
    }
};


var $f5cad2acb0ed0643$exports = {};
var $9a2cc0c95aed1db8$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaCallbackPage"
    };
    controller.$inject = [
        "$state",
        "$timeout",
        "$window"
    ];
    function controller($state, $timeout, $window) {
        const action = $state.params.name;
        $window.parent.postMessage(`${action}`, "*");
        $timeout(()=>{
            $window.history.back();
        }, 1000);
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$f5cad2acb0ed0643$exports = {
    "linda": {
        "callback": $9a2cc0c95aed1db8$exports
    }
};


var $76788a4e3b4bd15d$exports = {};
var $830f48407540d2b1$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaCancelPendingWithdrawalsModal"
    };
    controller.$inject = [
        "withdraw",
        "popup",
        "modal"
    ];
    function controller(_withdraw, _popup, _modal) {
        const subscription = _withdraw.cancelWithdrawal$.subscribe(()=>{
            _popup.close();
            _modal.answer = false;
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$76788a4e3b4bd15d$exports = {
    "linda": {
        "cashbox": $830f48407540d2b1$exports
    }
};


var $8129726f709eae39$exports = {};
var $38f8d169946ce738$exports = {};


(function() {
    "use strict";
    app.factory("balanceHistoryDatepicker", controller);
    controller.$inject = [
        "historyBalanceFlow"
    ];
    function controller(_historyBalanceFlow) {
        const todayDate = new Date().toISOString().split("T")[0];
        const checkIfSingleDay = ()=>!_historyBalanceFlow.maxDays;
        return {
            todayDate: todayDate,
            checkIfSingleDay: checkIfSingleDay
        };
    }
})();




(function() {
    "use strict";
    const component = {
        name: "lindaCashboxBalanceInformation"
    };
    controller.$inject = [
        "$scope",
        "history",
        "history$",
        "balanceHistoryDatepicker"
    ];
    function controller($scope, _history, _history$, _balanceHistoryDatepicker) {
        $scope.collection = [];
        $scope.formData = {
            type: [],
            status: [],
            date: {
                from: new Date().toISODate(),
                to: new Date().toISODate()
            }
        };
        $scope.isRange = false;
        $scope.datepickerOptions = {
            maxDate: _balanceHistoryDatepicker.todayDate
        };
        $scope.$watchGroup([
            "formData.date.from",
            "isRange"
        ], function(newValues) {
            $scope.minValue = newValues[0];
            if (!$scope.isRange) $scope.formData.date.to = newValues[0];
        });
        _history$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((i)=>i.action === "maxDays")).subscribe(()=>{
            $scope.isRange = _balanceHistoryDatepicker.checkIfSingleDay();
        });
        $scope.getBalanceFlow = ()=>{
            $scope.preloader = true;
            const params = {
                status: $scope.formData.status,
                type: $scope.formData.type,
                date_begin: $scope.formData.date.from,
                date_end: $scope.formData.date.to
            };
            _history.balanceFlow(params).then((a)=>{
                $scope.collection = a.result.map((item)=>{
                    item.date = item.date * 1000;
                    return item;
                });
            }).catch((a)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        $scope.getBalanceFlow();
        $scope.resetFilters = ()=>{
            $scope.formData = {
                type: [],
                status: [],
                date: {
                    from: new Date(),
                    to: new Date()
                }
            };
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$8129726f709eae39$exports = {
    "linda": {
        "cashbox": $38f8d169946ce738$exports
    }
};


var $001df98c02db94d3$exports = {};
var $7e503c38f8d35aed$exports = {};






(function() {
    const component = {
        name: "lindaCashboxDepositForm"
    };
    controller.$inject = [
        "$scope",
        "payment",
        "$element",
        "user",
        "config",
        "helper",
        "system$",
        "$window",
        "modal"
    ];
    function controller($scope, _payment, $element, _user, _config, _helper, _system$, $window, _modal) {
        const localBet = parseInt($window.localStorage.getItem("saveDepAmount"));
        let wnd = {};
        $scope.preloader = false;
        $scope.system = {};
        $scope.formData = {
            amount: 0
        };
        $scope.checkPendingWithdrawals = false;
        $scope.showMinMaxWarning = false;
        this.$onChanges = ()=>{
            if (typeof this.system !== "object") return;
            this.system.rules.showAmount = _payment.hasAmount(this.system.rules.system) && !this.system.hide_amount;
            $scope.system = this.system;
            $scope.formData.place = this.place || "cashbox";
            $scope.formData.paymethod = this.system.rules.system;
            $scope.formData.amount = this.amount || localBet || this.system.rules.default;
            $scope.formData.paysystem_id = this.system.id;
            if (this.amount && (this.system.min_amount > this.amount || this.system.max_amount < this.amount)) $scope.showMinMaxWarning = true;
        };
        function messageHandler({ data: data }) {
            if (data === "close") {
                wnd.close();
                wnd = {};
                return;
            }
            if (data === "open-chat") {
                wnd.close();
                wnd = {};
                _system$.next({
                    action: "open chat"
                });
                return;
            }
        }
        $window.onmessage = messageHandler;
        function submitForm() {
            if (wnd?.closed === false) return wnd.focus();
            const width = 800;
            const height = 500;
            const left = ($window.innerWidth - width) / 2;
            const top = ($window.innerHeight - height) / 2;
            const checker = setInterval(()=>{
                if (wnd.closed) {
                    wnd = {};
                    clearInterval(checker);
                }
            }, 100);
            wnd = _config.browser.webView ? $window : $window.open(`/preloader.html?login=${_user.profile.login}`, "depositWindow", `height=${height},width=${width},left=${left},top=${top}`);
            if (!_config.device.mobile) $scope.preloader = true;
            _payment.deposit($scope.formData).then(({ result: { url: url, post: post, method: method } })=>{
                if (method.toLowerCase() === "post") return _payment.makeForm(url, post, $element);
                wnd.document.location = url;
            }).catch(()=>{
                wnd.document.location = "/" + _config.currentLang + `/payment/fail?login=${_user.profile.login}`;
            }).finally(()=>{
                $scope.preloader = false;
            });
        }
        $scope.submit = _helper.form.validator(()=>{
            $scope.showMinMaxWarrning = false;
            if ($scope.checkPendingWithdrawals) {
                _modal.open("cancel-pending-withdrawals").then(()=>{
                    submitForm();
                }).catch(()=>{}).finally(()=>{});
                return;
            }
            submitForm();
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            system: "<",
            place: "<",
            amount: "<"
        }
    });
})();


$001df98c02db94d3$exports = {
    "linda": {
        "cashbox": $7e503c38f8d35aed$exports
    }
};


var $70c238f39cc80caf$exports = {};
$70c238f39cc80caf$exports = {};


var $2a7e45fff74e066f$exports = {};
var $6c5823b5347c99f9$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaCashboxPopup"
    };
    controller.$inject = [
        "$scope",
        "cashboxState",
        "contentBuffer"
    ];
    function controller($scope, _cashboxState, _contentBuffer) {
        $scope.showCryptoTab = _cashboxState.getValue().showCryptoTab;
        const params = _contentBuffer.read("popup");
        const cashboxState = params?.cashboxState;
        if (cashboxState) _cashboxState.setValue(cashboxState);
        this.$onDestroy = ()=>{
            _cashboxState.reset();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$2a7e45fff74e066f$exports = {
    "linda": {
        "cashbox": $6c5823b5347c99f9$exports
    }
};


var $b828c0992acda0e4$exports = {};
var $053f03b052595cf9$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaCashboxWithdraw"
    };
    controller.$inject = [
        "$scope",
        "paysystem",
        "$timeout"
    ];
    function controller($scope, _paysystem, $timeout) {
        $scope.preloader = false;
        $scope.collection = [];
        $scope.selected = undefined;
        $scope.selectedId = 0;
        $scope.changing = false;
        $scope.$watch("selected", (newVal)=>{
            $scope.changing = true;
            $timeout(()=>{
                $scope.changing = false;
            }, 0);
        });
        $scope.setSelected = (selected)=>$scope.selected = selected;
        $scope.preloader = true;
        _paysystem.collection({
            type: "withdraw"
        }).then((answer)=>{
            $scope.collection = answer.result;
            $scope.selected = $scope.collection[0];
            $scope.preloader = false;
        }, (answer)=>{
            $scope.preloader = false;
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$b828c0992acda0e4$exports = {
    "linda": {
        "cashbox": $053f03b052595cf9$exports
    }
};


var $2a2a516f1296b48f$exports = {};
var $3525c3802adb0575$exports = {};







(function() {
    "use strict";
    const component = {
        name: "lindaCashboxWithdrawForm"
    };
    controller.$inject = [
        "$rootScope",
        "$scope",
        "payment",
        "modal",
        "user",
        "helper",
        "bonus",
        "config",
        "system$",
        "$window"
    ];
    function controller($rootScope, $scope, _payment, _modal, _user, _helper, _bonus, _config, _system$, $window) {
        $scope.preloader = false;
        $scope.system = {};
        $scope.formData = {
            amount: 0,
            details: []
        };
        let wnd = {};
        this.$onChanges = ()=>{
            if (typeof this.system === "object") {
                $scope.system = this.system;
                $scope.formData.paymethod = this.system.rules.system;
                $scope.formData.paysystem_id = this.system.id;
            }
        };
        function close(message) {
            if (message.data === "close") {
                wnd.close();
                wnd = {};
            }
            if (message.data === "open-chat") {
                wnd.close();
                wnd = {};
                _system$.next({
                    action: "open chat"
                });
            // -alert( 'open chat from payment callback' );
            }
        }
        $window.onmessage = close;
        function withdraw() {
            if (!_config.device.mobile) $scope.preloader = true;
            if (wnd.focus) {
                if (wnd.closed) wnd = {};
                else {
                    wnd.focus();
                    return;
                }
            }
            const w = 800;
            const h = 500;
            const l = ($window.innerWidth - w) / 2;
            const t = ($window.innerHeight - h) / 2;
            const checker = setInterval(()=>{
                if (wnd.closed) {
                    wnd = {};
                    clearInterval(checker);
                }
            }, 100);
            wnd = _config.browser.webView ? $window : $window.open(`/preloader.html?login=${_user.profile.login}`, "withdrawalWindow", `height=${h},width=${w},left=${l},top=${t}`);
            _payment.withdraw($scope.formData).then((a)=>{
                if (a.result.url.length) wnd.document.location = a.result.url;
                $rootScope.$emit("withdraw-new");
            }).catch((e)=>{
                wnd.close();
            }).finally(()=>{
                $scope.preloader = false;
            });
        }
        function cancelBonus() {
            return _bonus.cancel({
                bonus_id: _user.activeBonus.bonus_id
            });
        }
        $scope.submit = _helper.form.validator((form)=>{
            if (_user.profile.active_bonus > 0) _modal.open("cashbox-withdraw").then((a)=>{
                cancelBonus().then(withdraw);
            }, (a)=>{});
            else withdraw();
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            system: "<"
        }
    });
})();


$2a2a516f1296b48f$exports = {
    "linda": {
        "cashbox": $3525c3802adb0575$exports
    }
};


var $a93163029ec3f611$exports = {};
$a93163029ec3f611$exports = {};


var $6976019d872e92e2$exports = {};
var $25686ba98a7324ff$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaCashboxWithdrawModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$6976019d872e92e2$exports = {
    "linda": {
        "cashbox": $25686ba98a7324ff$exports
    }
};


var $69414a7bf2578722$exports = {};
var $17810dc2744a2026$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaCasinoSection"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$69414a7bf2578722$exports = {
    "linda": $17810dc2744a2026$exports
};


var $2a0eac12fae59a27$exports = {};
var $9804a604389a0eb1$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaCookieBanner"
    };
    controller.$inject = [
        "$scope",
        "$element",
        "cookie$",
        "config",
        "$document",
        "$window"
    ];
    function controller($scope, $element, cookie$, _config, $document, $window) {
        const initCookieScriptViaGtag = _config.feature?.initCookieScriptViaGtag;
        if (!initCookieScriptViaGtag) initCookieScript();
        hideCookieBanner();
        let cookieScriptBtn;
        const hideBanner = ()=>{
            $element[0].style.display = "none";
        };
        const showBanner = ()=>{
            $element[0].style.display = "block";
        };
        hideBanner();
        const initBanner = ()=>{
            cookieScriptBtn = $document[0].getElementById("cookiescript_manage_wrap");
            if (cookieScriptBtn) {
                showBanner();
                return;
            }
            hideBanner();
        };
        const subscription = cookie$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((data)=>data.event === "banner_open")).subscribe((data)=>{
            showBanner();
            CookieScript.instance.show();
        });
        $window.addEventListener("CookieScriptLoaded", ()=>{
            initBanner();
        });
        $scope.acceptAll = ()=>{
            hideBanner();
            CookieScript.instance.acceptAllAction();
        };
        $scope.openCookieSettings = ()=>{
            $document[0].getElementById("cookiescript_manage_wrap").click();
            hideBanner();
            /* This block is a workaround for IOS safari scroll popup issue. ADV-12761 */ try {
                const languageScroller = $document[0].querySelector(".cookiescript_custom_select_items");
                const cookieDataScroller = $document[0].querySelector(".cookiescript_fsd_tabs_content");
                bodyScrollLock.disableBodyScroll(languageScroller, {
                    allowTouchMove: ()=>true
                });
                bodyScrollLock.disableBodyScroll(cookieDataScroller, {
                    allowTouchMove: ()=>true
                });
                const enableBodyScrollerForPopupElements = ()=>{
                    try {
                        bodyScrollLock.enableBodyScroll(languageScroller);
                        bodyScrollLock.enableBodyScroll(cookieDataScroller);
                    } catch (error) {
                    /* empty */ }
                };
                CookieScript.instance.onAccept = enableBodyScrollerForPopupElements;
                CookieScript.instance.onAcceptAll = enableBodyScrollerForPopupElements;
                CookieScript.instance.onReject = enableBodyScrollerForPopupElements;
            } catch (error) {
            /* empty */ }
        };
        function hideCookieBanner() {
            const styleElement = $document[0].createElement("style");
            styleElement.innerHTML = "#cookiescript_injected, #cookiescript_injected_wrapper{display: none !important;}";
            $document[0].body.append(styleElement);
        }
        function checkIfDevEnv() {
            const envsRegExp = new RegExp(/(^dev\..*|.*\.devv2.space|.fbarax.tech)$/);
            const { host: host } = $window.location;
            return envsRegExp.test(host);
        }
        function initCookieScript() {
            const cookieScript = $document[0].createElement("script");
            cookieScript.charset = "UTF-8";
            cookieScript.type = "text/javascript";
            const deviceType = _config.device.mobile ? "mobile" : "desktop";
            const isDevEnv = checkIfDevEnv();
            const idName = !_config.production ? `${deviceType}Dev` : _config.production && isDevEnv ? `${deviceType}Dev` : `${deviceType}`;
            cookieScript.src = $_CDN.cookieBanner.cdn + ($_CDN.cookieBanner[idName] ? $_CDN.cookieBanner[idName] : $_CDN.cookieBanner[deviceType]) + ".js";
            cookieScript.setAttribute("data-cs-lang", _config.currentLang);
            $document[0].getElementsByTagName("body")[0].append(cookieScript);
        }
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {}
    });
})();


$2a0eac12fae59a27$exports = {
    "linda": {
        "cookie-banner": $9804a604389a0eb1$exports
    }
};


var $0fcf7304182cec66$exports = {};
var $50b5ec3df03dbe6d$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaCupPage"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$0fcf7304182cec66$exports = {
    "linda": $50b5ec3df03dbe6d$exports
};


var $4080820fe9ebea1a$exports = {};
var $2144ed105dc4a38b$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaErrorModal"
    };
    controller.$inject = [
        "$scope",
        "$templateCache"
    ];
    function controller($scope, $templateCache) {
        $scope.getTemplate = (code)=>{
            const template = code ? `/error-${code}.html` : ``;
            return !$templateCache.get(template) ? `` : template;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$4080820fe9ebea1a$exports = {
    "linda": {
        "modal": $2144ed105dc4a38b$exports
    }
};


var $714e60ead28058b2$exports = {};
var $1a36c42b6a4134dc$exports = {};
const $1a36c42b6a4134dc$var$componentName = "lindaFooter";
class $1a36c42b6a4134dc$var$Footer {
    static $inject = [
        "$scope"
    ];
    constructor($scope){}
}
app.component($1a36c42b6a4134dc$var$componentName, {
    controller: $1a36c42b6a4134dc$var$Footer,
    template: app.getTU($1a36c42b6a4134dc$var$componentName)
});


$714e60ead28058b2$exports = {
    "linda": $1a36c42b6a4134dc$exports
};


var $f9893a310aa12487$exports = {};
var $96c7cc498d451efa$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaFormDateSelector"
    };
    controller.$inject = [
        "$scope",
        "birthdayDatepicker"
    ];
    function controller($scope, _birthdayDatepicker) {
        function daysInMonth(month, year) {
            return new Date(parseInt(year), parseInt(month), 0).getDate();
        }
        function dayList(month, year) {
            const count = daysInMonth(month, year);
            const days = [];
            for(let i = 1; i <= count; i++)days.push(i <= 9 ? `0${i}` : `${i}`);
            return days;
        }
        function yearList() {
            const years = [];
            const year = new Date().getYear() + 1900 - 18;
            for(let i = year; i >= 1900; i--)years.push(`${i}`);
            //            for( let i = 1900; i<= year; i++ ){
            //                years.push( `${i}` );
            //            }
            return years;
        }
        $scope.birthdate = {
            day: null,
            month: null,
            year: null
        };
        $scope.formField = {
            day: {
                disabled: false
            },
            month: {
                disabled: false
            },
            year: {
                disabled: false
            }
        };
        $scope.calendar = {
            set d (val){
                if (val.length) this._d = val;
            },
            get d () {
                return this._d;
            },
            _d: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31"
            ],
            m: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ],
            y: yearList()
        };
        $scope.minAgeError = false;
        function checkDate(birthdateModel) {
            if (!birthdateModel.includes("null")) $scope.minAgeError = birthdateModel > _birthdayDatepicker.maxDateValue ? true : false;
        }
        this.$onInit = ()=>{
            if (typeof this.ngDisabled === "boolean") {
                if (this.ngDisabled === true) $scope.formField = {
                    day: {
                        disabled: true
                    },
                    month: {
                        disabled: true
                    },
                    year: {
                        disabled: true
                    }
                };
                else if (this.ngDisabled === false) $scope.formField = {
                    day: {
                        disabled: false
                    },
                    month: {
                        disabled: false
                    },
                    year: {
                        disabled: false
                    }
                };
            }
            if (this.ngModel) {
                $scope.birthdate.day = this.ngModel.split("-")[2];
                $scope.birthdate.month = this.ngModel.split("-")[1];
                $scope.birthdate.year = this.ngModel.split("-")[0];
            }
            $scope.calendar.d = dayList($scope.birthdate.month, $scope.birthdate.year);
            $scope.$watch("birthdate.day", (newVal, oldVal)=>{
                this.ngModel = `${$scope.birthdate.year}-${$scope.birthdate.month}-${$scope.birthdate.day}`;
                checkDate(this.ngModel);
            });
            $scope.$watch("birthdate.month", (newVal, oldVal)=>{
                $scope.calendar.d = dayList($scope.birthdate.month, $scope.birthdate.year);
                if (parseInt($scope.birthdate.day) > parseInt($scope.calendar.d[$scope.calendar.d.length - 1])) $scope.birthdate.day = $scope.calendar.d[$scope.calendar.d.length - 1];
                this.ngModel = `${$scope.birthdate.year}-${$scope.birthdate.month}-${$scope.birthdate.day}`;
                checkDate(this.ngModel);
            });
            $scope.$watch("birthdate.year", (newVal, oldVal)=>{
                $scope.calendar.d = dayList($scope.birthdate.month, $scope.birthdate.year);
                if (parseInt($scope.birthdate.day) > parseInt($scope.calendar.d[$scope.calendar.d.length - 1])) $scope.birthdate.day = $scope.calendar.d[$scope.calendar.d.length - 1];
                this.ngModel = `${$scope.birthdate.year}-${$scope.birthdate.month}-${$scope.birthdate.day}`;
                checkDate(this.ngModel);
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            ngModel: "=",
            ngDisabled: "="
        }
    });
})();


$f9893a310aa12487$exports = {
    "linda": {
        "form": $96c7cc498d451efa$exports
    }
};


var $20a2ad07e6d12a9f$exports = {};
var $605de1f6e03f7454$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaFunidCode"
    };
    controller.$inject = [
        "$scope",
        "$window",
        "paynplay",
        "contentBuffer",
        "popup"
    ];
    function controller($scope, $window, _paynplay, _contentBuffer, _popup) {
        const params = {
            paymethod: "funid",
            amount: 0,
            currency: _contentBuffer.read("popup").currency || "EUR",
            trigger_codes: null,
            locale: "en_GB"
        };
        $scope.iframeUrl = "/preloader.html";
        $scope.iframeSanbox = "allow-forms allow-scripts allow-same-origin allow-popups";
        let orderData = null;
        function initFunId() {
            _paynplay.init(params).then((data)=>{
                orderData = data.result;
                $scope.iframeUrl = data.result.url;
            });
        }
        function authenticateByFunId(response) {
            if (response.data.message === "callback" && response.data.params.action === "success") {
                const authParams = {
                    order_id: orderData?.order_id,
                    paymethod: "funid",
                    pep: false,
                    gdpr_data: false,
                    accept: true,
                    gdpr_marketing: false
                };
                _paynplay.auth(authParams).then((data)=>{
                    _popup.close();
                });
            }
        }
        this.$onChanges = function() {
            params.trigger_codes = this.triggerCode;
            if (this.avatar) params.avatar = this.avatar;
            initFunId();
        };
        $window.addEventListener("message", authenticateByFunId);
        this.$onDestroy = ()=>{
            $window.removeEventListener("message", authenticateByFunId);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            triggerCode: "<",
            avatar: "<"
        }
    });
})();


$20a2ad07e6d12a9f$exports = {
    "linda": {
        "funid": $605de1f6e03f7454$exports
    }
};


var $75ef94b7b91e2805$exports = {};
var $621d6f06fac50929$exports = {};






(function() {
    "use strict";
    const component = {
        name: "lindaGameCashCrab"
    };
    controller.$inject = [
        "state",
        "popup",
        "user",
        "banner",
        "account",
        "config",
        "$window"
    ];
    function controller(_state, _popup, _user, _banner, _account, _config, $window) {
        if (_config.feature?.cash_crab?.visible === false) {
            _state.goto("home");
            return;
        }
        switch(true){
            case _user.profile.cash_crab && !_user.profile.cash_crab.cash_crab_attempts && !Boolean($window.localStorage.getItem("cash-crab-onboarding-viewed")):
                _popup.open({
                    name: "claw-need-first-deposit"
                });
                $window.localStorage.setItem("cash-crab-onboarding-viewed", "true");
                break;
            case _user.profile.cash_crab && !_user.profile.cash_crab.cash_crab_attempts && !_user.profile.cash_crab.assigned_today:
                _popup.open({
                    name: "claw-need-deposit"
                });
                break;
            case _user.profile.cash_crab && !_user.profile.cash_crab.cash_crab_attempts && _user.profile.cash_crab.assigned_today:
                _popup.open({
                    name: "claw-wait"
                });
                break;
            default:
                break;
        }
        if (_user.profile.cash_crab && _user.profile.cash_crab.cash_crab_attempts <= 0) {
            _state.goto("home");
            return;
        }
        let prizes = [];
        _banner.collection({
            place: "cash_crab",
            out: "images,text"
        }).then((data)=>{
            prizes = data.result;
        }).catch(()=>{}).finally(()=>{});
        const listener = (message)=>{
            switch(message.data.type){
                case "claw-result":
                    const win = message.data.data.game_result;
                    const alias = message.data.data.prize_id;
                    const prize = prizes.find((i)=>i.text[0] === alias);
                    if (prize && win) _popup.open({
                        name: "claw-win",
                        content: {
                            prize: prize
                        }
                    });
                    else _popup.open({
                        name: "claw-try-again"
                    });
                    _account.info({
                        nocache: true
                    });
                    break;
                case "claw-prizes":
                    _popup.open({
                        name: "claw-prizes",
                        content: {
                            prizes: prizes
                        }
                    });
                    break;
                case "claw-goto":
                    _state.goto(message.data.alias);
                    break;
                default:
                    break;
            }
        };
        $window.addEventListener("message", listener);
        this.$onDestroy = ()=>{
            $window.removeEventListener("message", listener);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$75ef94b7b91e2805$exports = {
    "game": $621d6f06fac50929$exports
};


var $23d7db4f680b6085$exports = {};
var $dec90d287e70d49d$exports = {};




(function() {
    "use strict";
    controller.$inject = [];
    function controller() {
        return new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    }
    app.factory("message$", controller);
})();










var $c0dbe5ea9ccb89de$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $33acc6e9f0229e40$exports = {};
// shim for using process in browser
var $33acc6e9f0229e40$var$process = $33acc6e9f0229e40$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $33acc6e9f0229e40$var$cachedSetTimeout;
var $33acc6e9f0229e40$var$cachedClearTimeout;
function $33acc6e9f0229e40$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $33acc6e9f0229e40$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $33acc6e9f0229e40$var$cachedSetTimeout = setTimeout;
        else $33acc6e9f0229e40$var$cachedSetTimeout = $33acc6e9f0229e40$var$defaultSetTimout;
    } catch (e) {
        $33acc6e9f0229e40$var$cachedSetTimeout = $33acc6e9f0229e40$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $33acc6e9f0229e40$var$cachedClearTimeout = clearTimeout;
        else $33acc6e9f0229e40$var$cachedClearTimeout = $33acc6e9f0229e40$var$defaultClearTimeout;
    } catch (e) {
        $33acc6e9f0229e40$var$cachedClearTimeout = $33acc6e9f0229e40$var$defaultClearTimeout;
    }
})();
function $33acc6e9f0229e40$var$runTimeout(fun) {
    if ($33acc6e9f0229e40$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($33acc6e9f0229e40$var$cachedSetTimeout === $33acc6e9f0229e40$var$defaultSetTimout || !$33acc6e9f0229e40$var$cachedSetTimeout) && setTimeout) {
        $33acc6e9f0229e40$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $33acc6e9f0229e40$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $33acc6e9f0229e40$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $33acc6e9f0229e40$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $33acc6e9f0229e40$var$runClearTimeout(marker) {
    if ($33acc6e9f0229e40$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($33acc6e9f0229e40$var$cachedClearTimeout === $33acc6e9f0229e40$var$defaultClearTimeout || !$33acc6e9f0229e40$var$cachedClearTimeout) && clearTimeout) {
        $33acc6e9f0229e40$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $33acc6e9f0229e40$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $33acc6e9f0229e40$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $33acc6e9f0229e40$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $33acc6e9f0229e40$var$queue = [];
var $33acc6e9f0229e40$var$draining = false;
var $33acc6e9f0229e40$var$currentQueue;
var $33acc6e9f0229e40$var$queueIndex = -1;
function $33acc6e9f0229e40$var$cleanUpNextTick() {
    if (!$33acc6e9f0229e40$var$draining || !$33acc6e9f0229e40$var$currentQueue) return;
    $33acc6e9f0229e40$var$draining = false;
    if ($33acc6e9f0229e40$var$currentQueue.length) $33acc6e9f0229e40$var$queue = $33acc6e9f0229e40$var$currentQueue.concat($33acc6e9f0229e40$var$queue);
    else $33acc6e9f0229e40$var$queueIndex = -1;
    if ($33acc6e9f0229e40$var$queue.length) $33acc6e9f0229e40$var$drainQueue();
}
function $33acc6e9f0229e40$var$drainQueue() {
    if ($33acc6e9f0229e40$var$draining) return;
    var timeout = $33acc6e9f0229e40$var$runTimeout($33acc6e9f0229e40$var$cleanUpNextTick);
    $33acc6e9f0229e40$var$draining = true;
    var len = $33acc6e9f0229e40$var$queue.length;
    while(len){
        $33acc6e9f0229e40$var$currentQueue = $33acc6e9f0229e40$var$queue;
        $33acc6e9f0229e40$var$queue = [];
        while(++$33acc6e9f0229e40$var$queueIndex < len)if ($33acc6e9f0229e40$var$currentQueue) $33acc6e9f0229e40$var$currentQueue[$33acc6e9f0229e40$var$queueIndex].run();
        $33acc6e9f0229e40$var$queueIndex = -1;
        len = $33acc6e9f0229e40$var$queue.length;
    }
    $33acc6e9f0229e40$var$currentQueue = null;
    $33acc6e9f0229e40$var$draining = false;
    $33acc6e9f0229e40$var$runClearTimeout(timeout);
}
$33acc6e9f0229e40$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $33acc6e9f0229e40$var$queue.push(new $33acc6e9f0229e40$var$Item(fun, args));
    if ($33acc6e9f0229e40$var$queue.length === 1 && !$33acc6e9f0229e40$var$draining) $33acc6e9f0229e40$var$runTimeout($33acc6e9f0229e40$var$drainQueue);
};
// v8 likes predictible objects
function $33acc6e9f0229e40$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$33acc6e9f0229e40$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$33acc6e9f0229e40$var$process.title = "browser";
$33acc6e9f0229e40$var$process.browser = true;
$33acc6e9f0229e40$var$process.env = {};
$33acc6e9f0229e40$var$process.argv = [];
$33acc6e9f0229e40$var$process.version = ""; // empty string to avoid regexp issues
$33acc6e9f0229e40$var$process.versions = {};
function $33acc6e9f0229e40$var$noop() {}
$33acc6e9f0229e40$var$process.on = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.addListener = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.once = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.off = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.removeListener = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.removeAllListeners = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.emit = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.prependListener = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.prependOnceListener = $33acc6e9f0229e40$var$noop;
$33acc6e9f0229e40$var$process.listeners = function(name) {
    return [];
};
$33acc6e9f0229e40$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$33acc6e9f0229e40$var$process.cwd = function() {
    return "/";
};
$33acc6e9f0229e40$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$33acc6e9f0229e40$var$process.umask = function() {
    return 0;
};


var $c0dbe5ea9ccb89de$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $c0dbe5ea9ccb89de$var$formatRegExp = /%[sdj%]/g;
$c0dbe5ea9ccb89de$exports.format = function(f) {
    if (!$c0dbe5ea9ccb89de$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($c0dbe5ea9ccb89de$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($c0dbe5ea9ccb89de$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($c0dbe5ea9ccb89de$var$isNull(x) || !$c0dbe5ea9ccb89de$var$isObject(x)) str += " " + x;
    else str += " " + $c0dbe5ea9ccb89de$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$c0dbe5ea9ccb89de$exports.deprecate = function(fn, msg) {
    if (typeof $33acc6e9f0229e40$exports !== "undefined" && $33acc6e9f0229e40$exports.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $33acc6e9f0229e40$exports === "undefined") return function() {
        return $c0dbe5ea9ccb89de$exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($33acc6e9f0229e40$exports.throwDeprecation) throw new Error(msg);
            else if ($33acc6e9f0229e40$exports.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $c0dbe5ea9ccb89de$var$debugs = {};
var $c0dbe5ea9ccb89de$var$debugEnvRegex = /^$/;
var $c0dbe5ea9ccb89de$var$debugEnv;
$c0dbe5ea9ccb89de$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$c0dbe5ea9ccb89de$var$debugs[set]) {
        if ($c0dbe5ea9ccb89de$var$debugEnvRegex.test(set)) {
            var pid = $33acc6e9f0229e40$exports.pid;
            $c0dbe5ea9ccb89de$var$debugs[set] = function() {
                var msg = $c0dbe5ea9ccb89de$exports.format.apply($c0dbe5ea9ccb89de$exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $c0dbe5ea9ccb89de$var$debugs[set] = function() {};
    }
    return $c0dbe5ea9ccb89de$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $c0dbe5ea9ccb89de$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $c0dbe5ea9ccb89de$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($c0dbe5ea9ccb89de$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $c0dbe5ea9ccb89de$exports._extend(ctx, opts);
    // set default options
    if ($c0dbe5ea9ccb89de$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($c0dbe5ea9ccb89de$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($c0dbe5ea9ccb89de$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($c0dbe5ea9ccb89de$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $c0dbe5ea9ccb89de$var$stylizeWithColor;
    return $c0dbe5ea9ccb89de$var$formatValue(ctx, obj, ctx.depth);
}
$c0dbe5ea9ccb89de$exports.inspect = $c0dbe5ea9ccb89de$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$c0dbe5ea9ccb89de$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$c0dbe5ea9ccb89de$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $c0dbe5ea9ccb89de$var$stylizeWithColor(str, styleType) {
    var style = $c0dbe5ea9ccb89de$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $c0dbe5ea9ccb89de$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $c0dbe5ea9ccb89de$var$inspect.colors[style][1] + "m";
    else return str;
}
function $c0dbe5ea9ccb89de$var$stylizeNoColor(str, styleType) {
    return str;
}
function $c0dbe5ea9ccb89de$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $c0dbe5ea9ccb89de$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $c0dbe5ea9ccb89de$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $c0dbe5ea9ccb89de$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$c0dbe5ea9ccb89de$var$isString(ret)) ret = $c0dbe5ea9ccb89de$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $c0dbe5ea9ccb89de$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $c0dbe5ea9ccb89de$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($c0dbe5ea9ccb89de$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $c0dbe5ea9ccb89de$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($c0dbe5ea9ccb89de$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($c0dbe5ea9ccb89de$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($c0dbe5ea9ccb89de$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($c0dbe5ea9ccb89de$var$isError(value)) return $c0dbe5ea9ccb89de$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($c0dbe5ea9ccb89de$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($c0dbe5ea9ccb89de$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($c0dbe5ea9ccb89de$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($c0dbe5ea9ccb89de$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($c0dbe5ea9ccb89de$var$isError(value)) base = " " + $c0dbe5ea9ccb89de$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($c0dbe5ea9ccb89de$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $c0dbe5ea9ccb89de$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $c0dbe5ea9ccb89de$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $c0dbe5ea9ccb89de$var$reduceToSingleString(output, base, braces);
}
function $c0dbe5ea9ccb89de$var$formatPrimitive(ctx, value) {
    if ($c0dbe5ea9ccb89de$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($c0dbe5ea9ccb89de$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($c0dbe5ea9ccb89de$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($c0dbe5ea9ccb89de$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($c0dbe5ea9ccb89de$var$isNull(value)) return ctx.stylize("null", "null");
}
function $c0dbe5ea9ccb89de$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $c0dbe5ea9ccb89de$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($c0dbe5ea9ccb89de$var$hasOwnProperty(value, String(i))) output.push($c0dbe5ea9ccb89de$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($c0dbe5ea9ccb89de$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $c0dbe5ea9ccb89de$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$c0dbe5ea9ccb89de$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($c0dbe5ea9ccb89de$var$isNull(recurseTimes)) str = $c0dbe5ea9ccb89de$var$formatValue(ctx, desc.value, null);
            else str = $c0dbe5ea9ccb89de$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($c0dbe5ea9ccb89de$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $c0dbe5ea9ccb89de$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$c0dbe5ea9ccb89de$exports.types = (parcelRequire("Ng9JZ"));
function $c0dbe5ea9ccb89de$var$isArray(ar) {
    return Array.isArray(ar);
}
$c0dbe5ea9ccb89de$exports.isArray = $c0dbe5ea9ccb89de$var$isArray;
function $c0dbe5ea9ccb89de$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$c0dbe5ea9ccb89de$exports.isBoolean = $c0dbe5ea9ccb89de$var$isBoolean;
function $c0dbe5ea9ccb89de$var$isNull(arg) {
    return arg === null;
}
$c0dbe5ea9ccb89de$exports.isNull = $c0dbe5ea9ccb89de$var$isNull;
function $c0dbe5ea9ccb89de$var$isNullOrUndefined(arg) {
    return arg == null;
}
$c0dbe5ea9ccb89de$exports.isNullOrUndefined = $c0dbe5ea9ccb89de$var$isNullOrUndefined;
function $c0dbe5ea9ccb89de$var$isNumber(arg) {
    return typeof arg === "number";
}
$c0dbe5ea9ccb89de$exports.isNumber = $c0dbe5ea9ccb89de$var$isNumber;
function $c0dbe5ea9ccb89de$var$isString(arg) {
    return typeof arg === "string";
}
$c0dbe5ea9ccb89de$exports.isString = $c0dbe5ea9ccb89de$var$isString;
function $c0dbe5ea9ccb89de$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$c0dbe5ea9ccb89de$exports.isSymbol = $c0dbe5ea9ccb89de$var$isSymbol;
function $c0dbe5ea9ccb89de$var$isUndefined(arg) {
    return arg === void 0;
}
$c0dbe5ea9ccb89de$exports.isUndefined = $c0dbe5ea9ccb89de$var$isUndefined;
function $c0dbe5ea9ccb89de$var$isRegExp(re) {
    return $c0dbe5ea9ccb89de$var$isObject(re) && $c0dbe5ea9ccb89de$var$objectToString(re) === "[object RegExp]";
}
$c0dbe5ea9ccb89de$exports.isRegExp = $c0dbe5ea9ccb89de$var$isRegExp;
$c0dbe5ea9ccb89de$exports.types.isRegExp = $c0dbe5ea9ccb89de$var$isRegExp;
function $c0dbe5ea9ccb89de$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$c0dbe5ea9ccb89de$exports.isObject = $c0dbe5ea9ccb89de$var$isObject;
function $c0dbe5ea9ccb89de$var$isDate(d) {
    return $c0dbe5ea9ccb89de$var$isObject(d) && $c0dbe5ea9ccb89de$var$objectToString(d) === "[object Date]";
}
$c0dbe5ea9ccb89de$exports.isDate = $c0dbe5ea9ccb89de$var$isDate;
$c0dbe5ea9ccb89de$exports.types.isDate = $c0dbe5ea9ccb89de$var$isDate;
function $c0dbe5ea9ccb89de$var$isError(e) {
    return $c0dbe5ea9ccb89de$var$isObject(e) && ($c0dbe5ea9ccb89de$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
$c0dbe5ea9ccb89de$exports.isError = $c0dbe5ea9ccb89de$var$isError;
$c0dbe5ea9ccb89de$exports.types.isNativeError = $c0dbe5ea9ccb89de$var$isError;
function $c0dbe5ea9ccb89de$var$isFunction(arg) {
    return typeof arg === "function";
}
$c0dbe5ea9ccb89de$exports.isFunction = $c0dbe5ea9ccb89de$var$isFunction;
function $c0dbe5ea9ccb89de$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$c0dbe5ea9ccb89de$exports.isPrimitive = $c0dbe5ea9ccb89de$var$isPrimitive;

$c0dbe5ea9ccb89de$exports.isBuffer = (parcelRequire("hpoz2"));
function $c0dbe5ea9ccb89de$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $c0dbe5ea9ccb89de$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $c0dbe5ea9ccb89de$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $c0dbe5ea9ccb89de$var$timestamp() {
    var d = new Date();
    var time = [
        $c0dbe5ea9ccb89de$var$pad(d.getHours()),
        $c0dbe5ea9ccb89de$var$pad(d.getMinutes()),
        $c0dbe5ea9ccb89de$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $c0dbe5ea9ccb89de$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
$c0dbe5ea9ccb89de$exports.log = function() {
    console.log("%s - %s", $c0dbe5ea9ccb89de$var$timestamp(), $c0dbe5ea9ccb89de$exports.format.apply($c0dbe5ea9ccb89de$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $c0dbe5ea9ccb89de$exports.inherits = (parcelRequire("13rFk"));
$c0dbe5ea9ccb89de$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$c0dbe5ea9ccb89de$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $c0dbe5ea9ccb89de$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
$c0dbe5ea9ccb89de$exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol && original[$c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol]) {
        var fn = original[$c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $c0dbe5ea9ccb89de$var$getOwnPropertyDescriptors(original));
};
$c0dbe5ea9ccb89de$exports.promisify.custom = $c0dbe5ea9ccb89de$var$kCustomPromisifiedSymbol;
function $c0dbe5ea9ccb89de$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $c0dbe5ea9ccb89de$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $33acc6e9f0229e40$exports.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $33acc6e9f0229e40$exports.nextTick($c0dbe5ea9ccb89de$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $c0dbe5ea9ccb89de$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$c0dbe5ea9ccb89de$exports.callbackify = $c0dbe5ea9ccb89de$var$callbackify;


const $4c3410c6d2fca2f3$export$a559a572f750db2e = "megaGameEvents";
class $4c3410c6d2fca2f3$var$MegaGameEvents {
    static $inject = [
        "state",
        "analytics"
    ];
    constructor(state, analytics){
        this.state = state;
        this.analytics = analytics;
    }
    handleEvent({ gameAction: gameAction, payload: payload }) {
        switch(gameAction){
            case "deposit":
            case "home":
            case "terms":
                this.state.goto(gameAction);
                break;
            case "gameHalls":
                this.state.goto("gameHall");
                break;
            case "pushToDataLayer":
                this.analytics.send(payload);
                break;
            default:
                console.warn("Unknown gameAction", gameAction);
        }
    }
}
app.factory($4c3410c6d2fca2f3$export$a559a572f750db2e, $4c3410c6d2fca2f3$var$MegaGameEvents);




(function() {
    "use strict";
    const component = {
        name: "lindaGameField"
    };
    controller.$inject = [
        "$scope",
        "game",
        "$timeout",
        "state",
        "timer$",
        "message$",
        "popup",
        "$window",
        "jurisdictions",
        "ws$",
        "modal",
        "wsEvents",
        "postMessage$",
        "megaGameEvents"
    ];
    function controller($scope, _game, $timeout, _state, _timer$, _message$, _popup, $window, _jurisdictions, _ws$, _modal, _wsEvents, _postMessage$, _megaGameEvents) {
        $scope.preloader = true;
        $scope.url = "";
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const modalNoSimultaneousPlayChoice = "no-simultaneous-play-choice";
        const modalNoSimultaneousPlayClosedSession = "no-simultaneous-play-closed-session";
        const modalNoSimultaneousPlayNewSession = "no-simultaneous-play-new-session";
        let session_id = null;
        let request = false;
        let code = null;
        let mode = null;
        const onMessage = (event)=>{
            if (event.data && event.data.command == "com.egt-bg.exit") _state.goto("home");
        };
        const launch = ()=>{
            if (this.game.alias && this.game.alias.length && this.mode.length) {
                $scope.preloader = true;
                mode = this.mode;
                code = this.game.alias;
                _game.launch({
                    code: code,
                    mode: mode
                }).then((a)=>{
                    $scope.url = a.result.url;
                    session_id = a.result.session_id;
                }).catch((e)=>{
                    if (e.messages[0].code === 2805 || e.messages[0].code === 5070) _state.goto("initialLimitPage");
                    if (e.messages[0].code === 2210) handleSimultaneousGame(e.messages[0].data.game_session_id);
                }).finally(()=>{
                    $timeout(()=>{
                        $scope.preloader = false;
                    }, 2000);
                });
            }
        };
        const startNewSession = (launchedGameSessionId)=>{
            _game.closeGameSession({
                game_session_id: launchedGameSessionId
            }).then(launch);
        };
        const continueLaunchedSession = ()=>{
            _modal.open(modalNoSimultaneousPlayNewSession).then(()=>{});
        };
        const handleSimultaneousGame = (launchedGameSessionId)=>{
            _modal.open(modalNoSimultaneousPlayChoice).then(()=>startNewSession(launchedGameSessionId)).catch(()=>continueLaunchedSession());
        };
        this.$onInit = ()=>{
            $window.addEventListener("message", onMessage, false);
        };
        this.$onChanges = launch;
        _postMessage$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((data)=>{
            if (data.message === "callback" && data.params?.gameAction) {
                _state.goto(data.params.gameAction);
                return;
            }
            if (data.initiator === "mega") _megaGameEvents.handleEvent(data);
        });
        this.$onDestroy = ()=>{
            destroy$.next();
            destroy$.unsubscribe();
            if (mode === "real") _popup.open({
                name: "game-session"
            });
            $window.removeEventListener("message", onMessage, false);
        };
        _jurisdictions.de(()=>{
            (0, $baeef3ef689dc439$export$4950aa0f605343fb)(destroy$, (0, $bf81f4e3d2f87f38$export$a36e16046ae8f1bb)(window, "beforeunload")).pipe((0, $cb278db83bf89940$export$43128fadae87b74a)()).subscribe(()=>{
                if (session_id) _game.closeGameSession({
                    game_session_id: session_id
                });
            });
            _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.closeGameSession), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe(({ data: data })=>{
                const sessionIdToClose = data[0].game_session_id;
                if (sessionIdToClose === session_id) $timeout(()=>{
                    $scope.url = null;
                    _modal.open(modalNoSimultaneousPlayClosedSession).then(()=>{}).catch(()=>{});
                });
            });
        });
        _jurisdictions.sw(()=>{
            _timer$.pipe((0, $0fcfe63c48d698bc$export$8916d2c8119541bb)(10), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe(()=>{
                if (mode === "real" && true && code !== null && !request) {
                    request = true;
                    _game.check({
                        session_id: session_id,
                        code: code
                    }).catch(({ messages: messages })=>{
                        if (messages[0].code === 2806) _state.goto("home");
                    }).finally(()=>request = false);
                }
            });
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            game: "<",
            mode: "<"
        }
    });
})();


$23d7db4f680b6085$exports = {
    "game": $dec90d287e70d49d$exports
};


var $97734111bd895cc2$exports = {};
var $a82b18341d966d12$exports = {};










(function() {
    "use strict";
    const component = {
        name: "lindaGamePage"
    };
    controller.$inject = [
        "$scope",
        "$state",
        "$transitions",
        "ws$",
        "game",
        "user",
        "state",
        "analytics",
        "favorites",
        "wsEvents",
        "system$",
        "analyticsEvents"
    ];
    function controller($scope, $state, $transitions, _ws$, _game, _user, _state, analytics, _favorites, _wsEvents, _system$, _analyticsEvents) {
        let subscription;
        $scope.preloader = false;
        $scope.game = {};
        $scope.mode = $state.params.mode;
        $scope.alias = $state.params.name;
        $scope.sideMenu = "";
        let lastBalance = _user.profile.balance;
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.balanceUpdate)).subscribe((message)=>{
            const newBalance = parseFloat(message.data.balance);
            const betAmount = Math.ceil((lastBalance - newBalance) * 100) / 100;
            lastBalance = newBalance;
        });
        const authorizationSubscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "login")).subscribe(()=>{
            getGame($scope.alias);
            _state.goto("realGame", {
                name: $scope.alias
            });
        });
        $scope.sendOpenReg = (area)=>{
            analytics.send(_analyticsEvents.createAccountButton, `game_page_${area}`);
        };
        $scope.toggleFavourites = ()=>{
            _favorites.toggle($scope.game);
        };
        $scope.$on("$locationChangeSuccess", ()=>{
            $scope.sideMenu = "";
        });
        $scope.toggleSideMenu = (menuName)=>{
            $scope.sideMenu = $scope.sideMenu === menuName ? "" : menuName;
        };
        getGame($scope.alias);
        listenFavorites();
        const routerListenerUnsubscribe = $transitions.onSuccess({}, function(transition) {
            if (transition.params().name !== $scope.alias) {
                $scope.alias = transition.params().name;
                getGame($scope.alias);
            }
            $scope.mode = transition.params().mode;
        });
        function listenFavorites() {
            subscription = _favorites.collection().subscribe((games)=>{
                if (_favorites.shouldSetFavorite(games, $scope.game)) $scope.game.favorites = true;
                if (_favorites.shouldRemoveFavorite(games, $scope.game)) $scope.game.favorites = false;
            });
        }
        function getGame(name) {
            $scope.preloader = true;
            _game.item({
                name: name
            }).then((answer)=>{
                $scope.game = answer.result;
                $scope.mode = $state.params.mode;
                $scope.preloader = false;
            }, (answer)=>{
                $scope.mode = $state.params.mode;
                $scope.preloader = false;
            });
        }
        this.$onDestroy = ()=>{
            routerListenerUnsubscribe();
            subscription?.unsubscribe();
            authorizationSubscription?.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            mode: "<"
        }
    });
})();


$97734111bd895cc2$exports = {
    "game": $a82b18341d966d12$exports
};


var $670dfbf4471e5465$exports = {};
var $97bd5f82db91c950$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaGdprRegistrationModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$670dfbf4471e5465$exports = {
    "linda": {
        "modal": $97bd5f82db91c950$exports
    }
};


var $2ec28b7ca8ce76ed$exports = {};
var $b0a5ae8850d0ecef$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaHeader"
    };
    controller.$inject = [
        "$scope",
        "analytics",
        "analyticsEvents"
    ];
    function controller($scope, analytics, _analyticsEvents) {
        $scope.sendOpenReg = (area)=>{
            analytics.send(_analyticsEvents.createAccountButton, `header_${area}`);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$2ec28b7ca8ce76ed$exports = {
    "linda": $b0a5ae8850d0ecef$exports
};


var $c47dac5dabff35c8$exports = {};
var $ec75000456be82f7$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaHomepage"
    };
    controller.$inject = [
        "$scope",
        "analytics",
        "analyticsEvents"
    ];
    function controller($scope, analytics, _analyticsEvents) {
        $scope.sendOpenReg = (area)=>{
            analytics.send(_analyticsEvents.createAccountButton, `homepage_${area}`);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$c47dac5dabff35c8$exports = {
    "linda": $ec75000456be82f7$exports
};


var $73378531cb3fda14$exports = {};
var $cfe631423eaaf620$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaImg"
    };
    controller.$inject = [
        "$scope",
        "$element"
    ];
    const createClasses = (baseClass)=>{
        const states = [
            "loading",
            "loaded",
            "error"
        ];
        return states.reduce((acc, state)=>{
            acc[state] = `${baseClass}_${state}`;
            return acc;
        }, {});
    };
    function controller(scope, element) {
        const rootElement = element[0];
        const imgElement = rootElement.querySelector("img");
        let classes = {};
        const unsubscribe = ()=>{
            imgElement.removeEventListener("load", loadHandler, false);
            imgElement.removeEventListener("error", errorHandler, false);
        };
        const loadHandler = ()=>{
            rootElement.classList.remove(classes.loading);
            rootElement.classList.add(classes.loaded);
            unsubscribe();
        };
        const errorHandler = ()=>{
            rootElement.classList.remove(classes.loading);
            rootElement.classList.remove(classes.loaded);
            rootElement.classList.add(classes.error);
            unsubscribe();
        };
        this.$onChanges = ()=>{
            scope.source = this.source;
            scope.type = this.source?.split(".").pop();
            scope.title = this.title || "";
            scope.height = this.height || 200;
            scope.loading = this.loading ? this.loading : "lazy";
            const baseClass = this.baseclass || "lazy-image";
            classes = createClasses(baseClass);
            rootElement.classList.add(classes.loading);
            imgElement.addEventListener("load", loadHandler, false);
            imgElement.addEventListener("error", errorHandler, false);
        };
        scope.$on("$destroy", unsubscribe);
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            height: "<",
            source: "<",
            title: "<",
            loading: "<",
            baseclass: "<"
        }
    });
})();


$73378531cb3fda14$exports = {
    "linda": $cfe631423eaaf620$exports
};


var $a24bed1cbcfa8098$exports = {};
var $8d679d1a6a7a6ee5$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaInfoPage"
    };
    controller.$inject = [
        "$scope",
        "$state",
        "page",
        "$sce"
    ];
    function controller($scope, $state, _page, $sce) {
        $scope.page = "";
        $scope.preloader = false;
        function getInfoPage(name) {
            $scope.preloader = true;
            _page.item({
                name: name
            }).then((answer)=>{
                $scope.page = $sce.trustAsHtml(answer.result.content);
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = function() {
            const name = this.name || $state.params.name || "";
            $scope.pageName = name;
            if (name !== "") getInfoPage(name);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            name: "<"
        }
    });
})();


$a24bed1cbcfa8098$exports = {
    "linda": $8d679d1a6a7a6ee5$exports
};


var $b2b0fa011ae30924$exports = {};
var $aa2f24d89ddcfd81$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaInfoPopup"
    };
    controller.$inject = [
        "$scope",
        "contentBuffer"
    ];
    function controller($scope, _contentBuffer) {
        $scope.content = _contentBuffer.read("popup");
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$b2b0fa011ae30924$exports = {
    "linda": $aa2f24d89ddcfd81$exports
};


var $5483b86071e64d0d$exports = {};
var $8092c5858fea34b2$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaLangList"
    };
    controller.$inject = [
        "$scope",
        "config"
    ];
    function controller($scope, _config) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$5483b86071e64d0d$exports = {
    "linda": $8092c5858fea34b2$exports
};


var $f5e58eeba6ba4b32$exports = {};
var $3d26c6236c8c9b84$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaLangPopup"
    };
    mobileController.$inject = [
        "$scope",
        "config"
    ];
    function mobileController($scope, _config) {
        $scope.changeLang = function(currentLang) {
            _config.currentLang = currentLang;
            document.location = `#/${currentLang}/`;
            localStorage.setItem("lang", currentLang);
        };
    }
    webController.$inject = [];
    function webController() {}
    app.component(component.name, {
        controller: app.getCC(mobileController, webController),
        template: app.getTU(component.name)
    });
})();


$f5e58eeba6ba4b32$exports = {
    "linda": $3d26c6236c8c9b84$exports
};


var $5511bfb879fa8637$exports = {};
var $6ff6bd25f241ec7a$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaLangVersionNotificationModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$5511bfb879fa8637$exports = {
    "linda": {
        "modal": $6ff6bd25f241ec7a$exports
    }
};


var $e250fbb481ef95b8$exports = {};
var $b500027014af9b55$exports = {};









(function() {
    "use strict";
    const component = {
        name: "lindaLoginForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "popup",
        "modal",
        "$state",
        "analytics",
        "helper",
        "state",
        "analyticsEvents",
        "$element"
    ];
    function controller($scope, _account, _popup, _modal, $state, analytics, _helper, _state, _analyticsEvents, $element) {
        const loginMode = "login";
        const emailMode = "email";
        const formSubmitSubject = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const destroySubject = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        $scope.rememberedLogin = localStorage.getItem("rememberedLogin") || "";
        $scope.rememberedAvatar = localStorage.getItem("rememberedAvatar") || "";
        $scope.rememberedName = localStorage.getItem("rememberedName") || "";
        $scope.preloader = false;
        $scope.isLoginSuccessful = false;
        $scope.mode = null;
        $scope.credentials = {
            login: $scope.rememberedLogin === "" ? undefined : $scope.rememberedLogin
        };
        $scope.sendOpenReg = (area)=>{
            analytics.send(_analyticsEvents.createAccountButton, `login_form_${area}`);
        };
        let successRedirectState = null;
        const loginByTwoFactor = ()=>{
            _modal.open("linda-two-factor-login").then((code)=>{
                $scope.preloader = true;
                $scope.credentials = {
                    ...$scope.credentials,
                    ...code
                };
                login();
            }).catch((err)=>console.error(err));
        };
        this.$onInit = function() {
            successRedirectState = this.successRedirectState;
        };
        this.$onChanges = function() {
            $scope.mode = $scope.rememberedName ? loginMode : this.mode;
        };
        $scope.changeMode = ()=>{
            $scope.mode = $scope.mode === loginMode ? emailMode : loginMode;
        };
        $scope.resetLoginCredentials = ()=>$scope.credentials.login = "";
        const login = ()=>{
            $scope.preloader = true;
            if ($scope.mode) $scope.mode === loginMode ? delete $scope.credentials.email : delete $scope.credentials.login;
            return _account.login($scope.credentials).then(()=>{
                _popup.close();
                $scope.isLoginSuccessful = true;
                if (angular.isFunction(_popup.cb)) {
                    _popup.cb();
                    _popup.cb = null;
                }
                if (successRedirectState && $state.get(successRedirectState)) $state.go(successRedirectState);
                if (!successRedirectState) _state.readyToRedirectAfterAuth$.next();
            }).catch((error)=>{
                $scope.preloader = false;
                if (error.messages[0].code === 2091) {
                    delete $scope.credentials.oneTimeCode;
                    delete $scope.credentials.backupCode;
                }
                if (error.messages[0].code === 1152) loginByTwoFactor();
            }).finally(()=>{
                $scope.preloader = false;
            });
        };
        formSubmitSubject.pipe((0, $47f686d3d2a0734e$export$d70d492cd31004c0)((event)=>{
            return (0, $c3f2ce8520f4fff9$export$6788812c4e6611e6)(login());
        }), (0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroySubject)).subscribe();
        const formValidatorCallback = ()=>{
            formSubmitSubject.next();
        };
        $scope.submit = _helper.form.validator(formValidatorCallback);
        $scope.$onDestroy = ()=>{
            destroySubject.next();
            destroySubject.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            successRedirectState: "<",
            mode: "<"
        }
    });
})();


$e250fbb481ef95b8$exports = {
    "linda": $b500027014af9b55$exports
};


var $7a32ae7c45f31aac$exports = {};
var $78f2199fccbfcd6c$exports = {};




(function() {
    "use strict";
    const component = {
        name: "lindaLoginPopup"
    };
    controller.$inject = [
        "$scope",
        "account",
        "popup",
        "modal",
        "analytics"
    ];
    function controller($scope, _account, _popup, _modal, analytics) {
        $scope.preloader = false;
        $scope.mode = null;
        $scope.credentials = {};
        this.$onChanges = function() {
            $scope.mode = this.mode;
        };
        $scope.submit = function(form) {
            if (form.$valid) {
                $scope.preloader = true;
                if ($scope.mode) $scope.mode === "login" ? delete $scope.credentials.email : delete $scope.credentials.login;
                _account.login($scope.credentials).then((answer)=>{
                    _popup.close();
                    if (angular.isFunction(_popup.cb)) {
                        _popup.cb();
                        _popup.cb = null;
                    }
                    $scope.preloader = false;
                }, (answer)=>{
                    $scope.preloader = false;
                });
            } else angular.forEach(form.$error, function(type) {
                angular.forEach(type, function(field) {
                    field.$setTouched();
                });
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            mode: "<"
        }
    });
})();


$7a32ae7c45f31aac$exports = {
    "linda": $78f2199fccbfcd6c$exports
};


var $7ae810ca293fe838$exports = {};
var $34768565767cd143$exports = {};




(function() {
    "use strict";
    const component = {
        name: "lindaMgaSessionLengthModal"
    };
    controller.$inject = [
        "$scope",
        "contentBuffer",
        "account",
        "modal",
        "state"
    ];
    function controller($scope, _contentBuffer, _account, _modal, _state) {
        const o = {};
        o.token = _contentBuffer.read("modal").data.token;
        $scope.refresh = ()=>{
            $scope.preloader = true;
            _account.refreshSession(o).then((a)=>{
                _modal.answer = true;
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        $scope.history = ()=>{
            $scope.preloader = true;
            _account.refreshSession(o).then((a)=>{
                _modal.answer = true;
                _state.goto("balanceHistory");
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        $scope.logOut = ()=>{
            $scope.preloader = true;
            _account.logout().then((a)=>{}).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
                _modal.answer = true;
                _state.goto("home");
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$7ae810ca293fe838$exports = {
    "linda": {
        "modal": $34768565767cd143$exports
    }
};


var $a1bda0ef6d37496c$exports = {};
var $1f45c427e4141845$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaMissedDataCancellationModal"
    };
    controller.$inject = [
        "$scope",
        "account",
        "modal",
        "state"
    ];
    function controller($scope, _account, _modal, _state) {
        $scope.preloader = false;
        $scope.reject = ()=>{
            _modal.answer = false;
        };
        $scope.resolve = ()=>{
            $scope.preloader = true;
            _account.logout().then(()=>_modal.answer = true).catch(()=>{}).finally(()=>$scope.preloader = false);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$a1bda0ef6d37496c$exports = {
    "linda": {
        "modal": $1f45c427e4141845$exports
    }
};


var $fbf1729aa43a1cb1$exports = {};
var $f9b1076fd987ef49$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "user",
        "paynplay"
    ];
    function controller(_user, _paynplay) {
        const formDataSchema = {
            limits_deposit_day: createSchema({
                type: "day",
                amount: 1000,
                group: "deposit"
            }, "array"),
            limits_deposit_week: createSchema({
                type: "week",
                amount: 1000,
                group: "deposit"
            }, "array"),
            limits_deposit_month: createSchema({
                type: "month",
                amount: 1000,
                group: "deposit"
            }, "array"),
            limits_deposit_day_sweden: createSchema({
                type: "day",
                amount: _user.profile.limits?.deposit?.day?.amount || "",
                group: "deposit"
            }, "array"),
            limits_deposit_week_sweden: createSchema({
                type: "week",
                amount: _user.profile.limits?.deposit?.week?.amount || "",
                group: "deposit"
            }, "array"),
            limits_deposit_month_sweden: createSchema({
                type: "month",
                amount: _user.profile.limits?.deposit?.month?.amount || "",
                group: "deposit"
            }, "array"),
            accept_terms_and_conditions: createSchema({
                value: true
            }, "string"),
            accept_migration_gdpr: createSchema({
                value: true
            }, "string"),
            accept_deposit_limit_change: createSchema({
                value: true
            }, "string"),
            profile_pep: createSchema({
                pep: true
            }, "object"),
            profile_birth_place: createSchema({
                birth_place: ""
            }, "object"),
            profile_nationality: createSchema({
                nationality: ""
            }, "object"),
            profile_birth_country: createSchema({
                birth_name: "",
                birth_country: ""
            }, "object"),
            limits_deposit: createSchema({
                group: "deposit",
                type: "",
                amount: ""
            }, "object")
        };
        const apiSchema = {
            limits_deposit: "update_limit",
            limits_deposit_day: "update_multi_limits",
            limits_deposit_week: "update_multi_limits",
            limits_deposit_month: "update_multi_limits",
            limits_deposit_day_sweden: "update_multi_limits",
            limits_deposit_week_sweden: "update_multi_limits",
            limits_deposit_month_sweden: "update_multi_limits",
            accept_terms_and_conditions: "accept_terms_and_conditions",
            accept_migration_gdpr: "accept_migration_gdpr",
            accept_deposit_limit_change: "accept_deposit_limit_change",
            profile_pep: "update",
            profile_birth_place: "update",
            profile_nationality: "update",
            profile_birth_country: "update"
        };
        function createSchema(obj, structure) {
            return Object.defineProperty(obj, "_structure", {
                value: structure
            });
        }
        function generateFormData() {
            const missedFields = _user.profile.requiredFields || [];
            const formData = {};
            missedFields.forEach((field)=>{
                const key = apiSchema[field];
                if (!key) return;
                if (formData[key]) switch(formDataSchema[field]._structure){
                    case "array":
                        formData[key].push({
                            ...formDataSchema[field]
                        });
                        break;
                    case "object":
                        Object.assign(formData[key], formDataSchema[field]);
                        break;
                    case "string":
                        formData[key] = formDataSchema[field].value;
                        break;
                    default:
                        break;
                }
                else switch(formDataSchema[field]._structure){
                    case "array":
                        formData[key] = [
                            {
                                ...formDataSchema[field]
                            }
                        ];
                        break;
                    case "object":
                        formData[key] = {};
                        Object.assign(formData[key], formDataSchema[field]);
                        break;
                    case "string":
                        formData[key] = formDataSchema[field].value;
                        break;
                    default:
                        break;
                }
            });
            return formData;
        }
        return {
            getFormData () {
                return generateFormData();
            }
        };
    }
    app.factory("dynamicForm", controller);
})();















const $e56adf02c7aa57fb$export$1a225ae290a0db9a = "survey";
class $e56adf02c7aa57fb$var$SurveyService {
    static $inject = [
        "http",
        "ws$",
        "wsEvents",
        "missedData"
    ];
    constructor(http, _ws$, _wsEvents, missedData){
        this.http = http;
        this.missedData = missedData;
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.surveyUpdated)).subscribe(()=>{
            this.missedData.init();
        });
    }
    getList() {
        return this.http.getData("surveyList", {}).then((answer)=>{
            return answer.result;
        }).catch((e)=>e);
    }
}
app.service($e56adf02c7aa57fb$export$1a225ae290a0db9a, $e56adf02c7aa57fb$var$SurveyService);



// Aliases for mga: profile_pep, accept_terms_and_conditions
// Aliases for de: limits_deposit_day, limits_deposit_week, limits_deposit_month, accept_terms_and_conditions, profile_birth_place, profile_nationality, profile_birth_country
// Aliases for sw: limits_deposit_day_sweden, limits_deposit_week_sweden, limits_deposit_month_sweden, accept_deposit_limit_change;
// formDataStructure:
// formData = {
//   accept_terms_and_conditions: true, // for accept_terms_and_conditions alias
//   accept_migration_gdpr: true,       // for accept_migration_gdpr alias
//   update: {
//     pep: true,                       // for profile_pep alias
//     birth_place: false,               // for profile_birth_place alias
//     birth_name: '',                   // for profile_birth_country alias
//     birth_country: '',                // for profile_birth_country alias
//     nationality: '',                  // for profile_nationality alias
//   },
//   update_limit: {
//     amount: '',
//     type: '',
//     group: 'deposit',
//   },
//   update_multi_limits: [
//     {
//       type: 'day',
//       amount: 1000,
//       group: 'deposit',
//     },                                // for limits_deposit_day alias
//     {
//       type: 'week',
//       amount: 1000,
//       group: 'deposit',
//     },                                // for limits_deposit_week alias
//     {
//       type: 'month',
//       amount: 1000,
//       group: 'deposit',
//     },                                // for limits_deposit_month alias
//   ],
// };
// !!! Each filed is optional, it means that formData can be like this:
// {
//   accept_terms_and_conditions: true,
//   update: {
//     pep: true,
//   }
// }
(function() {
    "use strict";
    const component = {
        name: "lindaMissedDataForm"
    };
    controller.$inject = [
        "$scope",
        "user",
        "dynamicForm",
        "helper",
        "system",
        "account",
        "state",
        "config",
        "modal",
        "ws$",
        "wsEvents",
        "survey",
        "$timeout"
    ];
    function controller($scope, _user, _dynamicForm, _helper, _system, _account, _state, _config, _modal, _ws$, _wsEvents, _survey, $timeout) {
        let missedFields = _user.profile.requiredFields || [];
        let stateChangeAccess = false;
        $scope.preloader = false;
        $scope.birth_countries = [];
        $scope.nationalities = [];
        const targetFields = [
            "limits_deposit_day_sweden",
            "limits_deposit_week_sweden",
            "limits_deposit_month_sweden",
            "accept_terms_and_conditions"
        ];
        $scope.hasMissedFields = missedFields.some((item)=>targetFields.includes(item));
        $scope.hasMandatorySurvey = missedFields.includes("mandatory_survey");
        $scope.formData = _dynamicForm.getFormData();
        $scope.missedFields = convertMissedFields();
        // for test uncomment below
        // $scope.missedFields = {
        //   profile_pep: true,
        //   accept_terms_and_conditions: true,
        // }
        getNationalities();
        $scope.cancelDepositLimitChange = (form)=>{
            $scope.formData.update_multi_limits = [
                {
                    type: "day",
                    amount: _user.profile.limits.deposit.day.amount,
                    group: "deposit"
                },
                {
                    type: "week",
                    amount: _user.profile.limits.deposit.week.amount,
                    group: "deposit"
                },
                {
                    type: "month",
                    amount: _user.profile.limits.deposit.month.amount,
                    group: "deposit"
                }
            ];
            $scope.submit(form);
        };
        $scope.submit = _helper.form.validator((form)=>{
            $scope.preloader = true;
            _account.missedFields($scope.formData).then(()=>{
                $scope.hasMissedFields = false;
                if ($scope.hasMandatorySurvey === false) goHome();
                if (_config.jurisdiction === "sweden") {
                    const swedenLimits = [
                        "limits_deposit_day_sweden",
                        "limits_deposit_week_sweden",
                        "limits_deposit_month_sweden"
                    ];
                    if (swedenLimits.some((el)=>missedFields.includes(el)) && !missedFields.includes("accept_deposit_limit_change")) _state.goto("deposit");
                }
                $timeout(()=>{
                    form.$setSuccessful();
                }, 0);
            }).catch(()=>{}).finally(()=>$scope.preloader = false);
        });
        this.$onInit = ()=>{
            if (!_user.profile.requiredFields?.length) // for test comment below
            goHome();
        };
        $scope.$on("$stateChangeStart", (event)=>{
            if (!stateChangeAccess && _user.status) event.preventDefault();
        });
        $scope.cancel = ()=>{
            _modal.open("missed-data-cancellation").then(()=>goHome()).catch(()=>{});
        };
        $scope.logout = ()=>{
            _account.logout().then(()=>goHome()).catch(()=>{});
        };
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.surveyUpdated)).subscribe(()=>{
            $scope.preloader = true;
            _account.info({
                nocache: true
            }).then(()=>{
                missedFields = _user.profile.requiredFields;
                if (!missedFields.length) goHome();
            }).finally(()=>{
                $scope.preloader = false;
            });
        });
        function getNationalities() {
            if ($scope.missedFields.profile_nationality || $scope.missedFields.profile_birth_place) {
                $scope.preloader = true;
                _system.nationality().then(({ result: result })=>{
                    $scope.nationalities = [];
                    $scope.birth_countries = [];
                    result.forEach(({ nationality: nationality, alpha_2_code: alpha_2_code, en_short_name: en_short_name })=>{
                        $scope.nationalities.push({
                            name: nationality,
                            code: alpha_2_code
                        });
                        $scope.birth_countries.push({
                            name: en_short_name,
                            code: alpha_2_code
                        });
                    });
                }).catch(()=>{}).finally(()=>$scope.preloader = false);
            }
        }
        function convertMissedFields() {
            return missedFields?.reduce((fieldsObj, field)=>{
                fieldsObj[field] = true;
                return fieldsObj;
            }, {});
        }
        function goHome() {
            stateChangeAccess = true;
            _state.goto("home");
        }
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$fbf1729aa43a1cb1$exports = {
    "linda": $f9b1076fd987ef49$exports
};


var $b8fb773a2cac4837$exports = {};
var $220a58f6c2188d53$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaModalBody"
    };
    controller.$inject = [
        "$scope",
        "modal"
    ];
    function controller($scope, _modal) {
        $scope.modal = _modal;
        $scope.$on("$includeContentLoaded", (e)=>{});
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$b8fb773a2cac4837$exports = {
    "linda": $220a58f6c2188d53$exports
};


var $d154ea415ed9535f$exports = {};
var $3d2f85fe64fff291$exports = {};

(function() {
    "use strict";
    controller.$inject = [
        "http",
        "$q"
    ];
    function controller(_http, $q) {
        const deposit = {
            collection (options) {
                const defer = $q.defer();
                const alias = "historyPaysystems";
                const config = {
                    params: options,
                    cache: false,
                    meta: {
                        type: "api",
                        alias: alias
                    }
                };
                _http.get(alias, config).then((answer)=>{
                    defer.resolve(answer.data);
                }, (answer)=>{
                    defer.reject(answer.data);
                });
                return defer.promise;
            }
        };
        return deposit;
    }
    app.factory("deposit", controller);
})();


(function() {
    "use strict";
    const component = {
        name: "lindaMultipleQuickDeposit"
    };
    controller.$inject = [
        "$scope",
        "deposit"
    ];
    function controller($scope, _deposit) {
        $scope.preloader = false;
        $scope.isQuickDeposit = false;
        $scope.paysystem = {};
        $scope.formData = {
            amount: 0,
            paymethod: "",
            paysystem_id: ""
        };
        $scope.selectCard = (cardIndex)=>{
            $scope.selectedDeposit = $scope.depositCollection[cardIndex];
            $scope.paysystem = {
                ...$scope.depositCollection[cardIndex].paysystem,
                amount: angular.isString($scope.formData.amount) ? $scope.formData.amount.split(".")[0] * 1 : $scope.formData.amount,
                depositIcon: $scope.depositCollection[cardIndex].icon
            };
        };
        this.$onInit = ()=>{
            $scope.preloader = true;
            _deposit.collection({}).then((a)=>{
                if (a.result.length) {
                    const amount = angular.isString(a.result[0].last_transaction.amount) ? a.result[0].last_transaction.amount.split(".")[0] * 1 : a.result[0].last_transaction.amount;
                    $scope.depositCollection = a.result;
                    $scope.selectCard(0);
                    $scope.paysystem = a.result[0].paysystem;
                    $scope.formData.amount = amount;
                    $scope.paysystem.amount = amount;
                    $scope.paysystem.depositIcon = a.result[0].icon;
                    $scope.isQuickDeposit = true;
                }
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$d154ea415ed9535f$exports = {
    "linda": {
        "quick-deposit": $3d2f85fe64fff291$exports
    }
};


var $201b6186f52ac28b$exports = {};
var $d4155c2afaf12e5c$exports = {};










(function() {
    "use strict";
    app.factory("notificationsEvents", controller);
    controller.$inject = [
        "p161",
        "popup",
        "state",
        "modal",
        "config",
        "system$",
        "account"
    ];
    function controller(_p161, _popup, _state, _modal, _config, _system$, _account) {
        const NOTIFICATION_TYPE_DEFAULT = "default";
        const NOTIFICATION_TYPE_ERROR = "error";
        return {
            // the event arrives after the first deposit is made (FED-403)
            20000001: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: ()=>{
                    _p161.track("firstDeposit");
                }
            },
            // the event arrives after the first deposit is made (FED-403)
            5097: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: ()=>{
                    _p161.track("firstDeposit");
                }
            },
            // migrations to other project (B2C-4056)
            6200: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _popup.close();
                    _state.goto("migrationPageToOtherProject", {
                        url: data.data.url
                    });
                }
            },
            // account frozen for sweden
            2808: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: ()=>{
                    _modal.open("sw-account-frozen");
                }
            },
            // session length sw license
            5031: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("session-length", data);
                }
            },
            // user will see a modal with a checkbox indicating acceptance of the new Rules and Conditions ( BAC-2010 )
            5042: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _popup.close();
                    _modal.open("terms-changed", data).then(()=>{}).catch(()=>{
                        _state.goto("home");
                    });
                }
            },
            // when the session has timed out
            117: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    if (_config.jurisdiction === "germany") _modal.open("de-session-length", data);
                    else _modal.open("mga-session-length", data);
                }
            },
            // mga. session limit exceeded
            5111: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("mga-exceeded-session-limit", data);
                }
            },
            // mga. deposit limit exceeded
            5110: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("mga-exceeded-deposit-limit", data);
                }
            },
            // Wager limit exceeded
            2320: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("mga-exceeded-wager-limit", data);
                }
            },
            // Losses limit exceeded
            2321: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("mga-exceeded-loss-limit", data);
                }
            },
            // Losses limit exceeded for Canada(only)
            5120: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("mga-exceeded-loss-limit", data);
                }
            },
            // When Player from Germany will log in at zulabet.com while their account is suspended (frozen) before migrations. (B2C-2716)
            2224: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    _modal.open("de-suspended-players", data);
                }
            },
            // cool off
            5114: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: ()=>{
                    _popup.open({
                        name: "cool-off"
                    });
                }
            },
            // user missed data popup for India market
            13000013: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    const content = data.data;
                    _popup.open({
                        name: "in-missed-data",
                        content: content
                    });
                }
            },
            // When user try login her get modal because make self-exclusion from https://www.spelpaus.se/ service.
            2802: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: ()=>{
                    _modal.open("spelpaus-self-exclusion").then(()=>{
                        _state.goto("home");
                    });
                }
            },
            // Show bonus activation rules modal and do not show notification
            6322: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: ()=>{
                    _popup.close();
                }
            },
            // the first login, a modal that informs the user that he can set dep limits (MGA)
            1332: {
                type: NOTIFICATION_TYPE_DEFAULT,
                callback: (data)=>{
                    if (_modal.current?.includes("registration")) _modal.answer = true;
                    _modal.open("error", data).then(()=>{
                        _popup.close();
                        _state.goto("home");
                        _state.goto("deposit");
                    }).catch(()=>{
                        _popup.close();
                        _state.goto("responsibleGaming");
                    });
                }
            },
            // Your account has been migrated to the new project. (B2C-614,B2C-647 )
            1334: {
                type: NOTIFICATION_TYPE_ERROR,
                resolveCallback: ()=>{
                    _popup.close();
                }
            },
            // logout
            5073: {
                type: NOTIFICATION_TYPE_ERROR,
                resolveCallback: ()=>{
                    _system$.next({
                        action: "forced logout"
                    });
                }
            },
            // set deposit limit (redirect to deposit init page)
            2805: {
                type: NOTIFICATION_TYPE_ERROR,
                resolveCallback: ()=>{
                    _state.goto("initialLimitPage");
                }
            },
            // set deposit limit before deposit (initial limits)
            5079: {
                type: NOTIFICATION_TYPE_ERROR,
                resolveCallback: ()=>{
                    _state.goto("initialLimitPage");
                }
            },
            // mga. user self excluded
            5112: {
                type: NOTIFICATION_TYPE_ERROR,
                resolveCallback: ()=>{
                    _state.goto("home");
                }
            },
            // the user tries to make a withdrawal, but the email is not confirmed (MGA)
            1333: {
                type: NOTIFICATION_TYPE_ERROR,
                rejectCallback: ()=>{
                    _account.activationCode({}).then(()=>{}).catch(()=>{});
                }
            },
            // reality check
            1350: {
                type: NOTIFICATION_TYPE_ERROR,
                rejectCallback: ()=>{
                    _account.logout().then(()=>{
                        _state.goto("home");
                    });
                }
            },
            // temporarily blocked (period specified)
            2205: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // permanently selfexcluded
            2281: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // blocked by admin
            2202: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // closed account
            2092: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // due to incorrect password entry
            2203: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // Bet limit exceeded
            1320: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // Loss limit exceeded
            1321: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // registration result for malta
            1330: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // Deposit limit exceeded
            2220: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // a minute before
            5030: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // mga. user self excluded permanently
            5109: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // Business request - to implement a pop-up notification, when withdrawals go to pending - B2C-1833
            5303: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // for the German project, when the user logs in later than 24 hours have passed since the last session (ger-134)
            5118: {
                type: NOTIFICATION_TYPE_ERROR
            },
            // if the user tries to log in after making a 24-hour self-exclusion using the panic button (FED-2065)
            5113: {
                type: NOTIFICATION_TYPE_ERROR
            },
            5555: {
                type: NOTIFICATION_TYPE_ERROR
            }
        };
    }
})();




(function() {
    "use strict";
    class Message {
        constructor(config){
            this.type = config.type || "info";
            this.code = config.code || null;
            this.text = config.text || "";
            this.delay = config.delay || 5000;
            this.index = config.index;
            this.show = true;
            this.data = config.data || {};
            this.event = config.event || "";
        }
    }
    const component = {
        name: "lindaNotification"
    };
    controller.$inject = [
        "$scope",
        "notification$",
        "$timeout",
        "ws$",
        "config",
        "wsEvents",
        "notificationsEvents",
        "modal"
    ];
    function controller($scope, _notification$, $timeout, _ws$, _config, _wsEvents, _notificationsEvents, _modal) {
        $scope.filter = {
            show: true
        };
        $scope.close = remove;
        $scope.list = [];
        function remove(index) {
            $scope.list[index].show = false;
        }
        function say(config) {
            config.index = $scope.list.length;
            const notification = new Message(config);
            $timeout(()=>{
                remove(config.index);
            }, notification.delay);
            $scope.list.splice(config.index, 0, notification);
        }
        /* ws = {
                    event: 'message',
                    data: [
                        { type: '', code: 0, text: '', data: {} },
                        { type: '', code: 0, text: '', data: {} },
                        { type: '', code: 0, text: '', data: {} },
                        ...
                        { type: '', code: 0, text: '', data: {} }
                    ]
                }

                message.type -> 'error' || 'warning' || 'info' || 'success' || 'silence'

     **/ _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.message)).subscribe((message)=>{
            $scope.$apply(()=>{
                _notification$.next(message.data[0]);
            });
        });
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.achieveComplete)).subscribe((message)=>{
            $scope.$apply(()=>{
                _notification$.next(message);
            });
        });
        _notification$.subscribe((data)=>{
            if (_notificationsEvents.hasOwnProperty(data?.code)) {
                const notificationCode = _notificationsEvents[data?.code];
                if (notificationCode.type === "default" && notificationCode.callback) {
                    notificationCode.callback(data);
                    return;
                }
                if (notificationCode.type === "error") _modal.open("error", data).then(()=>{
                    if (notificationCode.resolveCallback) notificationCode.resolveCallback();
                }).catch(()=>{
                    if (notificationCode.rejectCallback) notificationCode.rejectCallback();
                });
                return;
            }
            if (data.type !== "silence" && !_config.ignoreErrorCodes.includes(data.code)) say(data);
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$201b6186f52ac28b$exports = {
    "linda": $d4155c2afaf12e5c$exports
};


var $2f6f932734740358$exports = {};
var $ca8f342a5845af75$exports = {};





var $jTg1q = parcelRequire("jTg1q");
(function() {
    "use strict";
    const component = {
        name: "lindaPaymentCallback"
    };
    controller.$inject = [
        "$scope",
        "state",
        "$state",
        "$interval",
        "payment",
        "$location",
        "system$",
        "config",
        "$window"
    ];
    function controller($scope, _state, $state, $interval, _payment, $location, _system$, _config, $window) {
        let timerSeconds = 20;
        $scope.timer = `00:${timerSeconds}`;
        $scope.action = "preloader";
        const interId = $state.params.identifier;
        const action = $state.params.act || $state.params.status;
        const transactionAct = $state.params.act;
        const webView = _config.browser.webView;
        $scope.payment = null;
        $scope.action = action;
        makeTimer();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jTg1q))).isDefined(interId)) _payment.getDetails({
            identifier: interId
        }).then((answer)=>{
            $scope.payment = answer.result;
        }).catch(()=>{});
        if (isOpenedInFrame()) {
            $window.parent.postMessage(`transaction-${transactionAct}`, "*");
            $scope.close = function() {
                $window.top.postMessage("close", "*");
            };
            $scope.openChat = function() {
                $window.top.postMessage("open-chat", "*");
            };
            return;
        }
        if (!isWebView() || isOpenedInWindow()) {
            $window.parent.postMessage(`transaction-${transactionAct}`, "*");
            $window.opener?.parent.postMessage({
                action: "transaction",
                status: action,
                reason: $location.search().reason
            }, "*");
            $scope.close = function() {
                if ($window.opener && !$window.opener.closed && !webView) $window.opener.parent.postMessage("close", "*");
                _state.goto("home");
            };
            $scope.openChat = function() {
                if ($window.opener && !$window.opener.closed && !webView) $window.opener.parent.postMessage("open-chat", "*");
                _system$.next({
                    action: "open chat"
                });
            };
            return;
        }
        $scope.close = function() {
            _state.goto("home");
        };
        $scope.openChat = function() {
            _system$.next({
                action: "open chat"
            });
        };
        function makeTimer() {
            const timer = $interval(()=>{
                if (timerSeconds >= 0) {
                    const formattedTimeWithSeconds = timerSeconds.toString().padStart(2, "0");
                    $scope.timer = `00:${formattedTimeWithSeconds}`;
                    timerSeconds--;
                } else {
                    $interval.cancel(timer);
                    $scope.close();
                }
            }, 1000);
        }
        function isWebView() {
            return webView;
        }
        function isOpenedInWindow() {
            return $window.opener && !$window.opener.closed;
        }
        function isOpenedInFrame() {
            return $window.self !== $window.top;
        }
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$2f6f932734740358$exports = {
    "linda": $ca8f342a5845af75$exports
};


var $4f43b23990667cb3$exports = {};
var $1159deaa6e0b3752$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaPopupBody"
    };
    controller.$inject = [
        "$scope",
        "popup"
    ];
    function controller($scope, _popup) {
        $scope.popup = _popup;
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$4f43b23990667cb3$exports = {
    "linda": $1159deaa6e0b3752$exports
};


var $f4780872e3fd8d14$exports = {};
var $145c2b1526e09470$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaProfileBonusList"
    };
    controller.$inject = [
        "$scope",
        "bonus",
        "payment",
        "helper"
    ];
    function controller($scope, _bonus, _payment, _helper) {
        $scope.collection = [];
        $scope.formData = {
            code: ""
        };
        function listBonus() {
            $scope.preloader = true;
            _bonus.list().then(({ result: result })=>{
                $scope.collection = result;
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        listBonus();
        $scope.submit = _helper.form.validator(()=>{
            $scope.preloader = true;
            const o = {
                code: $scope.formData.code
            };
            _payment.promoCode(o).then((answer)=>{
                listBonus();
                $scope.preloader = false;
            }, (answer)=>{
                $scope.preloader = false;
            });
        });
        $scope.$on("renew_bonus_list", listBonus);
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$f4780872e3fd8d14$exports = {
    "linda": {
        "profile": $145c2b1526e09470$exports
    }
};


var $d74d9b0100e8b46b$exports = {};
var $e8f8b8edf1fb8f03$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaProfileChangePasswordForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "helper",
        "popup"
    ];
    function controller($scope, _account, _helper, _popup) {
        $scope.preloader = false;
        $scope.formData = {};
        $scope.submit = _helper.form.validator((form)=>{
            $scope.preloader = true;
            _account.changePassword($scope.formData).then(()=>{
                form.$setSuccessful();
                _popup.close();
            }).finally(()=>{
                $scope.preloader = false;
            });
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$d74d9b0100e8b46b$exports = {
    "linda": {
        "profile": $e8f8b8edf1fb8f03$exports
    }
};


var $9b50d7b53c948c20$exports = {};
var $b5ebc9f16502f9f9$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaProfilePage"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$9b50d7b53c948c20$exports = {
    "linda": {
        "profile": $b5ebc9f16502f9f9$exports
    }
};


var $5d9ce5f93acdfda7$exports = {};
var $9ee2657da3c22fd6$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaProfileSettings"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$5d9ce5f93acdfda7$exports = {
    "linda": {
        "profile": $9ee2657da3c22fd6$exports
    }
};


var $a2d3f1dd4dceacfc$exports = {};
var $b67f82f4f69fcac2$exports = {};









(function() {
    const component = {
        name: "lindaPromoPage"
    };
    controller.$inject = [
        "$scope",
        "promo",
        "$state",
        "analytics",
        "analyticsEvents",
        "system$",
        "platform",
        "ws$",
        "wsEvents"
    ];
    function controller($scope, _promo, $state, analytics, _analyticsEvents, _system$, _platform, _ws$, _wsEvents) {
        $scope.promo = {};
        $scope.sendOpenReg = (area)=>{
            analytics.send(_analyticsEvents.createAccountButton, `promo_page_${area}`);
        };
        const removeNoActionAlias = (steps)=>steps.map((step)=>{
                if (step.alias !== "no_action") return step;
                return {
                    ...step,
                    alias: null
                };
            });
        const updateStepsByPlatformVersion = (result)=>{
            _platform.version().then((version)=>{
                if (version === 2) $scope.promo.bonusSteps = removeNoActionAlias(result.bonusSteps);
                if (version === 3) $scope.promo.bonus_steps = removeNoActionAlias(result.bonus_steps);
            });
            getOptInData(result);
        };
        const getPromo = ()=>{
            $scope.preloader = true;
            _promo.item({
                name: $state.params.name
            }).then(({ result: result })=>{
                $scope.promo = result;
                updateStepsByPlatformVersion(result);
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        const getOptInData = (promo)=>{
            $scope.isDepositDone = promo.requiredActions?.some((item)=>item.type === "DEPOSIT" && item.isActionDone);
            const requiredAction = promo.requiredActions?.find((item)=>item.type !== "OPT_IN" && !item.isActionDone);
            if (requiredAction) {
                $scope.startDate = requiredAction.startDate || null;
                $scope.timerCounter = new Date(requiredAction.startDate).getTime() - Date.now();
                $scope.isPromoStartSoon = new Date(requiredAction.startDate) >= Date.now();
            }
        };
        const subscription = (0, $baeef3ef689dc439$export$4950aa0f605343fb)(_system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")), _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.bonusIssue))).subscribe(()=>{
            getPromo();
        });
        this.$onInit = ()=>{
            if (this.promo) {
                $scope.promo = this.promo;
                updateStepsByPlatformVersion(this.promo);
                return;
            }
            getPromo();
        };
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        bindings: {
            promo: "<"
        },
        template: app.getTU(component.name)
    });
})();


$a2d3f1dd4dceacfc$exports = {
    "linda": $b67f82f4f69fcac2$exports
};


var $c86a6f3d255862ba$exports = {};
var $c2f8bd563f570040$exports = {};







(function() {
    "use strict";
    const component = {
        name: "lindaPromos"
    };
    controller.$inject = [
        "$scope",
        "promo",
        "system$",
        "$state",
        "promo$",
        "ws$",
        "wsEvents"
    ];
    function controller($scope, _promo, _system$, $state, _promo$, _ws$, _wsEvents) {
        $scope.promos = [];
        $scope.preloader = true;
        $scope.filter = $state.params.filter;
        $scope.name = $state.params.name;
        function getPromo() {
            _promo.list().then(()=>{
                $scope.promos = _promo.result;
            }).finally(()=>{
                $scope.preloader = false;
            });
        }
        this.$onInit = ()=>{
            getPromo();
        };
        const subscription = (0, $baeef3ef689dc439$export$4950aa0f605343fb)(_promo$, _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")), _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.bonusIssue))).subscribe(()=>{
            getPromo();
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$c86a6f3d255862ba$exports = {
    "linda": $c2f8bd563f570040$exports
};


var $102bef2cc1e3a2b6$exports = {};
var $e6cb03e5c0d523bb$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaRegistrationPopup"
    };
    cmpCtrl.$inject = [
        "$scope"
    ];
    function cmpCtrl($scope) {}
    app.component(component.name, {
        controller: cmpCtrl,
        template: app.getTU(component.name)
    });
})();


$102bef2cc1e3a2b6$exports = {
    "linda": {
        "registration": $e6cb03e5c0d523bb$exports
    }
};


var $338cb32ef1013e5e$exports = {};
var $3940dff12d3ed582$exports = {};




(function() {
    "use strict";
    const component = {
        name: "lindaRestorationForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "popup",
        "analytics",
        "analyticsEvents"
    ];
    function controller($scope, _account, _popup, _analytics, _analyticsEvents) {
        $scope.preloader = false;
        $scope.email = "";
        $scope.restore = function(form) {
            if (form.$valid) {
                $scope.preloader = true;
                _account.restore({
                    email: $scope.email
                }).then((answer)=>{
                    _popup.close();
                    _analytics.send(_analyticsEvents.recoveryFormSuccess, "application_form");
                    $scope.preloader = false;
                }, (answer)=>{
                    _analytics.send(_analyticsEvents.recoveryFormFail, "application_form");
                    $scope.preloader = false;
                });
            } else angular.forEach(form.$error, (type)=>{
                angular.forEach(type, (field)=>{
                    field.$setTouched();
                });
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$338cb32ef1013e5e$exports = {
    "linda": $3940dff12d3ed582$exports
};


var $517856597826bbfb$exports = {};
var $6b0de9c5ed8c890a$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaRestorationNewPassForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "popup"
    ];
    function controller($scope, _account, _popup) {
        $scope.preloader = false;
        $scope.formData = {
            token: $_GET["restore"]
        };
        $scope.submit = function(form) {
            if (form.$valid) {
                $scope.preloader = true;
                _account.restorationChangePassword($scope.formData).then((answer)=>{
                    $scope.preloader = false;
                    _popup.open({
                        name: "login"
                    });
                }, (answer)=>{
                    $scope.preloader = false;
                });
            } else angular.forEach(form.$error, (type)=>{
                angular.forEach(type, (field)=>{
                    field.$setTouched();
                });
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$517856597826bbfb$exports = {
    "linda": $6b0de9c5ed8c890a$exports
};


var $098261837965beab$exports = {};
var $9bf51ed62d2f4fc7$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaRestorationPopup"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$098261837965beab$exports = {
    "linda": $9bf51ed62d2f4fc7$exports
};


var $bf68d2e4347b998b$exports = {};
var $542ee16ca53fa030$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaSearch"
    };
    const classLib = {
        full: "linda-has-games",
        empty: "linda-not-found"
    };
    controller.$inject = [
        "$scope",
        "game",
        "keyup$",
        "$element"
    ];
    function controller($scope, _game, _keyup$, $element) {
        $scope.result = [];
        $scope.preloader = false;
        $scope.showSearch = false;
        let count;
        _keyup$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((e)=>e.target.hasAttribute("search-input")), (0, $92a424c49fb9c529$export$3f23594af5f37336)((data)=>{
            data.target.value && data.target.value.length >= 2 ? $scope.preloader = true : $scope.preloader = false;
        }), (0, $969807fecf2e057f$export$7843a4469d64c07e)(300)).subscribe((data)=>{
            if (data.target.value && data.target.value.length >= 2) {
                $scope.preloader = true;
                const options = {
                    search: data.target.value,
                    count: count
                };
                _game.collection(options).then(function(answer) {
                    $scope.result = answer.result;
                    $element[0].classList.toggle(classLib.full, answer.result.length > 0);
                    $element[0].classList.toggle(classLib.empty, answer.result.length === 0);
                    $scope.preloader = false;
                }, function(answer) {
                    $scope.preloader = false;
                });
            } else {
                $element[0].classList.remove(classLib.full);
                $element[0].classList.remove(classLib.empty);
                $scope.result = [];
                $scope.$apply();
            }
        });
        this.$onInit = ()=>{
            count = this.count || 6;
            if (this.bindFocus) {
                const searchInput = $element[0].querySelector("input");
                searchInput.addEventListener("focus", ()=>{
                    $scope.showSearch = true;
                    $scope.$apply();
                });
            }
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            count: "<",
            bindFocus: "<"
        }
    });
})();


$bf68d2e4347b998b$exports = {
    "linda": $542ee16ca53fa030$exports
};


var $7efc053ffce11c81$exports = {};
var $722f6509b855f2c6$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSelfclosureModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$7efc053ffce11c81$exports = {
    "linda": {
        "modal": $722f6509b855f2c6$exports
    }
};


var $5b39d5fdd3ae50ef$exports = {};
var $2cec5d01e87309b2$exports = {};




(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolAccountclosure"
    };
    controller.$inject = [
        "$scope",
        "account",
        "state",
        "popup",
        "modal"
    ];
    function controller($scope, _account, _state, _popup, _modal) {
        $scope.preloader = false;
        $scope.formData = {
            reason: null,
            password: ""
        };
        $scope.submit = (form)=>{
            if (form.$valid) _modal.open("accountclosure").then((answer)=>{
                $scope.preloader = true;
                _account.close({
                    reason: $scope.formData.reason,
                    password: $scope.formData.password
                }).then((answer)=>{
                    // FET-3702
                    // _state.goto('home');
                    _popup.close(); /* FED-2167 */ 
                    $scope.preloader = false;
                }, (answer)=>{
                    $scope.preloader = false;
                });
            });
            else angular.forEach(form.$error, (type)=>{
                angular.forEach(type, (field)=>{
                    field.$setTouched();
                });
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$5b39d5fdd3ae50ef$exports = {
    "linda": {
        "selfcontrol": $2cec5d01e87309b2$exports
    }
};


var $5b2e66d7abeb72ad$exports = {};
var $72e4d5c44587f962$exports = {};


// linda-selfcontrol-deposit-item
(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolAddForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "popup"
    ];
    function controller($scope, _account, _popup) {
        $scope.showAddNewForm = false;
        $scope.type = $scope.$parent.type || "deposit";
        $scope.preloader = false;
        $scope.formData = {
            type: "31",
            amount: 1000
        };
        $scope.submit = (form)=>{
            if (form.$valid) {
                $scope.preloader = true;
                const o = {
                    group: $scope.type,
                    id: null,
                    type: $scope.formData.type,
                    amount: $scope.formData.amount
                };
                _account.limits(o).then(()=>{
                    $scope.showAddNewForm = false;
                    _popup.close();
                }).finally(()=>{
                    $scope.preloader = false;
                });
            } else angular.forEach(form.$error, (type)=>{
                angular.forEach(type, (field)=>{
                    field.$setTouched();
                });
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$5b2e66d7abeb72ad$exports = {
    "linda": {
        "selfcontrol": $72e4d5c44587f962$exports
    }
};


var $4a52b3dd0af67608$exports = {};
var $6fbfff38e0af3051$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolChangeExclusionForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "contentBuffer",
        "popup"
    ];
    function controller($scope, _account, _contentBuffer, _popup) {
        $scope.period = "5";
        $scope.count = 1;
        $scope.formData = {
            frozen_to: `${$scope.period}${$scope.count}`
        };
        $scope.$watchGroup([
            "period",
            "count"
        ], (newValues, oldValues, scope)=>{
            if (scope.period === "7") {
                $scope.formData.frozen_to = "71";
                return;
            }
            $scope.formData.frozen_to = `${scope.period}${scope.count}`;
        });
        $scope.submit = (form)=>{
            const token = _contentBuffer.read("modal").data.token || null;
            const excludeData = {
                frozen_to: $scope.formData.frozen_to,
                token: `${token}`
            };
            _account.exclude(excludeData).then((answer)=>{
                _popup.close();
            }, (answer)=>{});
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$4a52b3dd0af67608$exports = {
    "linda": {
        "selfcontrol": $6fbfff38e0af3051$exports
    }
};


var $30b571db07253a62$exports = {};
var $cb1e9eb29b828bad$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolChangeExclusionPopup"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$30b571db07253a62$exports = {
    "linda": {
        "selfcontrol": $cb1e9eb29b828bad$exports
    }
};


var $4bd3c10bca1cf880$exports = {};
var $65de07f2e989254e$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolDeposit"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        $scope.type = "deposit";
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$4bd3c10bca1cf880$exports = {
    "linda": {
        "selfcontrol": $65de07f2e989254e$exports
    }
};


var $ef06a894e42c5e8e$exports = {};
var $968495cc95ea591c$exports = {};



// linda-selfcontrol-deposit-item
(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolEditForm"
    };
    controller.$inject = [
        "$scope",
        "account",
        "user",
        "popup"
    ];
    function controller($scope, _account, _user, _popup) {
        $scope.limit = {};
        $scope.type = $scope.$parent.type;
        $scope.editmode = false;
        $scope.preloader = false;
        $scope.formData = {
            type: "31",
            amount: 0
        };
        $scope.cancel = ()=>{
            $scope.preloader = true;
            const o = {
                group: $scope.type,
                id: $scope.limit.id
            };
            _account.removeLimit(o).then((a)=>{
                _user.profile = a.data.result;
                _popup.close();
            }).finally(()=>$scope.preloader = false);
        };
        $scope.$watch("editmode", (newVal, oldVal)=>{
            if (newVal === false) {
                $scope.formData.type = `${this.limit.type}`;
                $scope.formData.amount = this.limit.amount;
            }
        });
        $scope.submit = (form)=>{
            if (form.$valid) {
                $scope.preloader = true;
                const o = {
                    group: $scope.type,
                    id: $scope.limit.id,
                    type: $scope.formData.type,
                    amount: $scope.formData.amount
                };
                _account.limits(o).then(()=>{
                    $scope.editmode = false;
                    _popup.close();
                }).catch(()=>{
                    $scope.formData.type = `${this.limit.type}`;
                    $scope.formData.amount = this.limit.amount;
                }).finally(()=>{
                    $scope.preloader = false;
                });
            } else angular.forEach(form.$error, (type)=>{
                angular.forEach(type, (field)=>{
                    field.$setTouched();
                });
            });
        };
        this.$onChanges = ()=>{
            $scope.limit = this.limit;
            $scope.formData.type = `${this.limit.type}`;
            $scope.formData.amount = this.limit.amount;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            limit: "<"
        }
    });
})();


$ef06a894e42c5e8e$exports = {
    "linda": {
        "selfcontrol": $968495cc95ea591c$exports
    }
};


var $1e305f526a33edf6$exports = {};
var $420e103740c99a2f$exports = {};





// 1 - minutes
// 2 - hours
// 3 - days
// 4 - weeks
// 5 - months
// 6 - years
// 7 - permanently
(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolSelfexclusion"
    };
    controller.$inject = [
        "$scope",
        "account",
        "state",
        "popup",
        "modal",
        "helper"
    ];
    function controller($scope, _account, _state, _popup, _modal, _helper) {
        $scope.preloader = false;
        $scope.period = "5";
        $scope.count = 1;
        $scope.formData = {
            frozen_to: `${$scope.period}${$scope.count}`
        };
        $scope.$watchGroup([
            "period",
            "count"
        ], (newValues, oldValues, scope)=>{
            if (scope.period === "7") {
                $scope.formData.frozen_to = "71";
                return;
            }
            $scope.formData.frozen_to = `${scope.period}${scope.count}`;
        });
        $scope.submit = _helper.form.validator((form)=>{
            _modal.open("selfexclude").then((answer)=>{
                $scope.preloader = true;
                _account.exclude({
                    ...$scope.formData
                }).then((answer)=>{
                    _popup.close();
                    _state.goto("home");
                    $scope.preloader = false;
                }, (answer)=>{
                    $scope.preloader = false;
                });
            });
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$1e305f526a33edf6$exports = {
    "linda": {
        "selfcontrol": $420e103740c99a2f$exports
    }
};


var $4ac3c413a264b751$exports = {};
var $d87a1e029e3ab17c$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolSession"
    };
    controller.$inject = [
        "$scope",
        "user",
        "account"
    ];
    function controller($scope, _user, _account) {
        $scope.preloader = false;
        $scope.editmode = false;
        const limits = [
            "130",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "210",
            "211",
            "212"
        ];
        function reset() {
            const userLimit = _user.profile.session_limit.value;
            let limit;
            if (userLimit && limits.indexOf(userLimit) > -1) limit = userLimit;
            else if (userLimit && limits.indexOf(userLimit) === -1) limit = "100";
            else limit = "212";
            $scope.formData = {
                // форма
                period: _user.profile.session_limit.value !== null ? _user.profile.session_limit.value[0] : "1",
                count: _user.profile.session_limit.value !== null ? parseInt(_user.profile.session_limit.value.substring(1), 10) : 10,
                limit: limit
            };
            $scope.setLimit = _user.profile.session_limit.value !== null; // флаг існування ліміту
        }
        function update(data) {
            $scope.preloader = true;
            _account.sessionLength(data).then((answer)=>{
                reset();
                $scope.editmode = false;
                $scope.preloader = false;
            }, (answer)=>{
                reset();
                $scope.preloader = false;
            });
        }
        reset();
        $scope.edit = ()=>{};
        $scope.back = ()=>{
            reset();
            $scope.editmode = false;
        };
        $scope.cancel = ()=>{
            const o = {
                group: "session_limit"
            };
            $scope.preloader = true;
            _account.removeLimit(o).then((a)=>{}).catch((err)=>{}).finally(()=>{
                $scope.preloader = false;
                reset();
            });
        };
        $scope.submit = (form)=>{
            if (form.$valid) {
                const session_limit = $scope.formData.limit === "100" ? `${$scope.formData.period}${$scope.formData.count}` : $scope.formData.limit;
                update({
                    session_limit: session_limit
                });
            } else angular.forEach(form.$error, (type)=>{
                angular.forEach(type, (field)=>{
                    field.$setTouched();
                });
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$4ac3c413a264b751$exports = {
    "linda": {
        "selfcontrol": $d87a1e029e3ab17c$exports
    }
};


var $b346689c5b6390ab$exports = {};
var $6f59e2348e4c9f8b$exports = {};





(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolTimeout"
    };
    controller.$inject = [
        "$scope",
        "account",
        "state",
        "popup",
        "modal",
        "helper"
    ];
    function controller($scope, _account, _state, _popup, _modal, _helper) {
        $scope.preloader = false;
        $scope.formData = {
            frozen_to: "224"
        };
        $scope.submit = _helper.form.validator((form)=>{
            _modal.open("selfexclude").then((a)=>{
                $scope.preloader = true;
                _account.exclude($scope.formData).then(()=>{
                    _popup.close();
                    _state.goto("home");
                }).catch(()=>{}).finally(()=>{
                    $scope.preloader = false;
                });
            });
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$b346689c5b6390ab$exports = {
    "linda": {
        "selfcontrol": $6f59e2348e4c9f8b$exports
    }
};


var $507b8aa77e4b781d$exports = {};
var $28eda4a9b0fe121a$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSelfcontrolWrapper"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$507b8aa77e4b781d$exports = {
    "linda": {
        "selfcontrol": $28eda4a9b0fe121a$exports
    }
};


var $bd8974786a2fb6f0$exports = {};
var $9ffda5606c5e91ba$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSelfexcludeModal"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$bd8974786a2fb6f0$exports = {
    "linda": {
        "modal": $9ffda5606c5e91ba$exports
    }
};


var $0be40509bfbe7832$exports = {};
var $0adbf55da6c1f837$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSidebar"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$0be40509bfbe7832$exports = {
    "linda": $0adbf55da6c1f837$exports
};


var $fcfa0ac47565e715$exports = {};
var $8db1e8d1519851ad$exports = {};



(function() {
    const component = {
        name: "lindaSitemap"
    };
    controller.$inject = [
        "$scope",
        "brand",
        "system$"
    ];
    function controller($scope, _brand, _system$) {
        $scope.preloader = false;
        $scope.providerList = [];
        $scope.preloader = true;
        function getCollection() {
            _brand.collection().then(({ result: result })=>{
                $scope.providerList = result;
            }).catch(()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        }
        getCollection();
        const subscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((message)=>message.action === "statusChanged")).subscribe(()=>{
            getCollection();
        });
        this.$onDestroy = ()=>{
            subscription.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$fcfa0ac47565e715$exports = {
    "linda": $8db1e8d1519851ad$exports
};


var $f6c0c5a20692e834$exports = {};
var $5c4c874ef5aebeb2$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaSportField"
    };
    controller.$inject = [
        "$scope",
        "sport",
        "popup",
        "config"
    ];
    function controller($scope, _sport, _popup, _config) {
        let BIA = {};
        let loaded = false;
        this.$onChanges = ()=>{
            if (loaded) BIA.setParam("page", this.vm);
            else launch(this.vm);
        };
        function launch(vm) {
            _sport.launch({
                code: "sport"
            }).then((answer)=>{
                const opt = answer.result.launch_options;
                opt.page = vm;
                opt.showLoginBoxCallback = showLoginBoxCallback;
                opt.loadCallback = loadCallback;
                opt.mobile = _config.device.mobile;
                opt.fixedBottom = 55;
                const ident = setInterval(function() {
                    if (typeof BetinactionAPI === "function") {
                        BIA = new BetinactionAPI("#BIAcc", opt);
                        loaded = true;
                        clearInterval(ident);
                    }
                    if (typeof AltenarSportsbook === "function") {
                        BIA = new AltenarSportsbook("#BIAcc", opt);
                        loaded = true;
                        clearInterval(ident);
                    }
                }, 250);
            }, (answer)=>{});
        }
        function loadCallback() {}
        function showLoginBoxCallback() {
            _popup.open({
                name: "login"
            });
        // --$scope.$apply();
        }
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            vm: "<"
        }
    });
})();


$f6c0c5a20692e834$exports = {
    "linda": {
        "sport": $5c4c874ef5aebeb2$exports
    }
};


var $52b0e0cc256a13cd$exports = {};
var $b0bafa47708720c7$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSportPage"
    };
    controller.$inject = [];
    function controller() {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$52b0e0cc256a13cd$exports = {
    "linda": {
        "sport": $b0bafa47708720c7$exports
    }
};


var $5d996b00d6e340f5$exports = {};
var $377ffafd012515ed$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaSportTeamPage"
    };
    controller.$inject = [
        "$scope",
        "$state"
    ];
    function controller($scope, $state) {
        $scope.name = $state.params.name;
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$5d996b00d6e340f5$exports = {
    "linda": {
        "collection": $377ffafd012515ed$exports
    }
};


var $dcb756f4bbf366a4$exports = {};
var $5eb1ed535ad91381$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaTournamentBigWidget"
    };
    controller.$inject = [
        "$scope",
        "tournament"
    ];
    function controller($scope, _tournament) {
        $scope.tournament = {};
        $scope.preloader = false;
        const options = {
            count: 1
        };
        function getCollection(opt) {
            $scope.preloader = true;
            _tournament.list(opt).then((answer)=>{
                $scope.tournament = answer.result[0];
                $scope.preloader = false;
            }, (answer)=>{
                $scope.preloader = false;
            });
        }
        this.$onChanges = ()=>{
            options.category = this.category;
            getCollection(options);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            category: "<"
        }
    });
})();


$dcb756f4bbf366a4$exports = {
    "linda": $5eb1ed535ad91381$exports
};


var $e575b8d715be8249$exports = {};
var $3093a822bff21122$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaTournamentPage"
    };
    controller.$inject = [
        "$scope",
        "$state"
    ];
    function controller($scope, $state) {
        $scope.name = $state.params.name;
        this.$onInit = ()=>{
            $scope.tournament = this.tournament;
        };
    }
    app.component(component.name, {
        controller: controller,
        bindings: {
            tournament: "<"
        },
        template: app.getTU(component.name)
    });
})();


$e575b8d715be8249$exports = {
    "linda": $3093a822bff21122$exports
};


var $8c4cbffd1876f141$exports = {};
var $1fdae39893eebeaf$exports = {};







(function() {
    "use strict";
    const component = {
        name: "lindaTrustlyPaynplayBanner"
    };
    controller.$inject = [
        "$scope",
        "paynplay",
        "config",
        "user",
        "state",
        "helper",
        "trustly$",
        "$timeout",
        "trustly.config"
    ];
    function controller($scope, _paynplay, _config, _user, _state, _helper, _trustly$, $timeout, _trustly_config) {
        $scope.amount = _paynplay.data.amount;
        $scope.paysystem = _trustly_config;
        $scope.submit = _helper.form.validator((form)=>{
            if ($scope.amount > 0) {
                _paynplay.data.amount = $scope.amount;
                _paynplay.data.step = 1;
                _state.goto("paynplay");
            }
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$8c4cbffd1876f141$exports = {
    "linda": {
        "trustly": $1fdae39893eebeaf$exports
    }
};


var $f2cea21f93bd7afd$exports = {};
var $360765435c07cf3e$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaTrustlyPaynplayLoginPopup"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$f2cea21f93bd7afd$exports = {
    "linda": {
        "trustly": $360765435c07cf3e$exports
    }
};


var $b15e9f75bbe6c4db$exports = {};
var $3a39a2482b863d69$exports = {};








(function() {
    "use strict";
    const component = {
        name: "lindaTrustlyPaynplayPage"
    };
    controller.$inject = [
        "$scope",
        "paynplay",
        "config",
        "user",
        "state",
        "helper",
        "trustly$",
        "$timeout",
        "trustly.config",
        "$window"
    ];
    function controller($scope, _paynplay, _config, _user, _state, _helper, _trustly$, $timeout, _trustly_config, $window) {
        const redirectToHomepage = ()=>_state.goto("home");
        if (!_trustly_config?.enabled || _user.status) {
            redirectToHomepage();
            return;
        }
        const loginSubscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "login")).subscribe(redirectToHomepage);
        $scope.amount = _paynplay.data.amount;
        $scope.step = _paynplay.data.step;
        $scope.flow = _paynplay.data.flow;
        $scope.paysystem = _trustly_config;
        let subscription;
        $scope.submit = _helper.form.validator((form)=>{
            if ($scope.amount > 0) {
                _paynplay.data.amount = $scope.amount;
                _paynplay.data.step = 1;
            }
        });
        function handler(event) {
            if (event.origin !== "https://trustly.com") return;
            const data = JSON.parse(event.data);
            if (data.method === "OPEN_APP") $window.location.assign(data.appURL);
        }
        this.$onInit = ()=>{
            subscription = _trustly$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.action === "step")).subscribe((item)=>{
                $timeout(()=>{
                    $scope.step = item.data;
                });
            });
            $window.addEventListener("message", handler, false);
        };
        this.$onDestroy = ()=>{
            _paynplay.data.reset();
            subscription.unsubscribe();
            loginSubscription?.unsubscribe();
            $window.removeEventListener("message", handler, false);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$b15e9f75bbe6c4db$exports = {
    "linda": {
        "trustly": $3a39a2482b863d69$exports
    }
};


var $ea503a6580d37808$exports = {};
var $0bdf58c0fb53ae90$exports = {};








(function() {
    "use strict";
    const component = {
        name: "lindaTrustlyRegistrationModal"
    };
    controller.$inject = [
        "$scope",
        "modal",
        "helper",
        "contentBuffer",
        "paynplay",
        "system",
        "config",
        "registration",
        "p161"
    ];
    function controller($scope, _modal, _helper, _contentBuffer, _paynplay, _system, _config, _registration, _p161) {
        function controller($scope, _modal, _helper, _contentBuffer, _paynplay, _system, _config, _registration, _p161) {
            const params = _contentBuffer.read("modal");
            const modalName = _modal.current;
            $scope.hide_bonuses = params.is_registration_bonuses_shown;
            $scope.person = params.profile;
            $scope.preloader = false;
            $scope.promotions = [];
            $scope.activePromotion = {};
            $scope.activePromotionIndex = null;
            $scope.formField = {
                name: {
                    disabled: Boolean($scope.person.name)
                },
                surname: {
                    disabled: Boolean($scope.person.surname)
                },
                email: {
                    disabled: Boolean($scope.person.email)
                },
                phone: {
                    disabled: Boolean($scope.person.phone)
                },
                city: {
                    disabled: Boolean($scope.person.city)
                },
                postcode: {
                    disabled: Boolean($scope.person.postcode)
                },
                address: {
                    disabled: Boolean($scope.person.address)
                },
                gender: {
                    disabled: Boolean($scope.person.gender)
                },
                birthday: {
                    disabled: Boolean($scope.person.birthday)
                }
            };
            $scope.formData = {
                name: $scope.person.name,
                surname: $scope.person.surname,
                email: $scope.person.email,
                phone: $scope.person.phone,
                city: $scope.person.city,
                postcode: $scope.person.postcode,
                address: $scope.person.address,
                gender: $scope.person.gender || "M",
                gdpr_data: false,
                accept: false,
                gdpr_marketing: false,
                birthday: $scope.person.birthday,
                enable_trigger_codes: true
            };
            _registration.addPromotionsToScope($scope);
            _registration.addAvatarsToScope($scope);
            if (_config.jurisdiction === "germany") {
                $scope.birth_countries = [];
                $scope.nationalities = [];
                $scope.formField.birth_country = {
                    disabled: Boolean($scope.person.birth_country)
                };
                $scope.formField.birth_name = {
                    disabled: Boolean($scope.person.birth_name)
                };
                $scope.formField.birth_place = {
                    disabled: Boolean($scope.person.birth_place)
                };
                $scope.formField.nationality = {
                    disabled: Boolean($scope.person.nationality)
                };
                $scope.formData.birth_country = $scope.person.birth_country;
                $scope.formData.birth_name = $scope.person.birth_name;
                $scope.formData.birth_place = $scope.person.birth_place;
                $scope.formData.nationality = $scope.person.nationality;
                $scope.preloader = true;
                _system.nationality().then((answer)=>{
                    const nationalities = [];
                    const birth_countries = [];
                    answer.result.forEach((obj)=>{
                        nationalities.push({
                            name: obj.nationality,
                            code: obj.alpha_2_code
                        });
                        birth_countries.push({
                            name: obj.en_short_name,
                            code: obj.alpha_2_code
                        });
                    });
                    $scope.nationalities = nationalities;
                    $scope.birth_countries = birth_countries;
                    $scope.preloader = false;
                }).catch((e)=>{}).finally(()=>$scope.preloader = false);
            }
            $scope.preloader = true;
            _system.countries().then((a)=>{
                const country = a.result.filter((item)=>item.code === a.default)[0] || {};
                if (!$scope.formData.phone && angular.isString(country.prefix)) $scope.formData.phone = `+${parseInt(country.prefix.replace(/\-/g, ""), 10)}`;
            }).catch((e)=>{}).finally(()=>{
                $scope.preloader = false;
            });
            $scope.submit = _helper.form.validator((form)=>{
                $scope.preloader = true;
                if ($scope.formData.enable_trigger_codes !== true || $scope.hide_bonuses) delete $scope.formData.trigger_codes;
                delete $scope.formData.enable_trigger_codes;
                _paynplay.auth($scope.formData).then((a)=>{
                    _p161.track("registration");
                    if (_modal.current === modalName) _modal.answer = true;
                }).catch(()=>{
                    if ($scope.formData.trigger_codes) $scope.formData.enable_trigger_codes = true;
                }).finally(()=>{
                    $scope.preloader = false;
                });
            });
        }
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$ea503a6580d37808$exports = {
    "linda": {
        "trustly": $0bdf58c0fb53ae90$exports
    }
};


var $5ded45212563366a$exports = {};
var $5502d23ec476db02$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerEight"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$5ded45212563366a$exports = {
    "linda": {
        "view-layer": $5502d23ec476db02$exports
    }
};


var $2fce8ff1974963b5$exports = {};
var $49d33f67c377eda0$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerFive"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$2fce8ff1974963b5$exports = {
    "linda": {
        "view-layer": $49d33f67c377eda0$exports
    }
};


var $89f0526fa68e5679$exports = {};
var $3f64f27c0b7aba7a$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerFour"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$89f0526fa68e5679$exports = {
    "linda": {
        "view-layer": $3f64f27c0b7aba7a$exports
    }
};


var $24047600b00b0200$exports = {};
var $d91a6bffd549d3e1$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerOne"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$24047600b00b0200$exports = {
    "linda": {
        "view-layer": $d91a6bffd549d3e1$exports
    }
};


var $6c8c1f14aabfa565$exports = {};
var $fea9b9dd2936aab8$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerSeven"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$6c8c1f14aabfa565$exports = {
    "linda": {
        "view-layer": $fea9b9dd2936aab8$exports
    }
};


var $b08d0f4a8f8cc1e2$exports = {};
var $99abce364df7270b$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerSix"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$b08d0f4a8f8cc1e2$exports = {
    "linda": {
        "view-layer": $99abce364df7270b$exports
    }
};


var $2751c05aa1d0885c$exports = {};
var $fede0767d2de1f2e$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerThree"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$2751c05aa1d0885c$exports = {
    "linda": {
        "view-layer": $fede0767d2de1f2e$exports
    }
};


var $e016804d23dcb372$exports = {};
var $4489e7b898245fa4$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaViewLayerTwo"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {
        this.$onChanges = ()=>{
            $scope.content = this.content;
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            content: "<"
        }
    });
})();


$e016804d23dcb372$exports = {
    "linda": {
        "view-layer": $4489e7b898245fa4$exports
    }
};


var $ba2aeef29ab5a885$exports = {};
var $4961301a642f19ad$exports = {};

(function() {
    "use strict";
    const component = {
        name: "lindaVip"
    };
    controller.$inject = [
        "$scope",
        "vip",
        "$timeout"
    ];
    function controller($scope, _vip, $timeout) {
        $scope.collection = [];
        $scope.preloader = false;
        $scope.loaded = false;
        $scope.preloader = true;
        _vip.collection().then((answer)=>{
            $scope.collection = answer.result;
            $scope.preloader = false;
            $scope.loaded = true;
        }).catch((e)=>{}).finally(()=>{
            $scope.preloader = false;
        });
        $scope.getCurrent = (event, slick, currentSlide, nextSlide)=>{
            $scope.current = nextSlide;
            $scope.transition = true;
            $timeout(()=>{
                $scope.transition = false;
            }, 600);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$ba2aeef29ab5a885$exports = {
    "linda": $4961301a642f19ad$exports
};


var $ad76929d99f4abe8$exports = {};
var $c41d6875a0b09264$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaWidgetEventList"
    };
    controller.$inject = [
        "$scope",
        "history",
        "ws$"
    ];
    function controller($scope, _history, _ws$) {
        $scope.collection = [];
        function prepare(arr) {
            return arr.map((item)=>{
                return {
                    avatar: item.avatar || "nopic",
                    level: item.level,
                    login: item.login,
                    type: item.type === "new_bonus" && item.bonus.type === "freespin" ? "new_freespin" : item.type,
                    data: item.bonus || {},
                    sum: item.sum || null,
                    currency: item.currency || null,
                    game: item.game || {},
                    achievement: item.achievement || {}
                };
            });
        }
        let events = [
            "-"
        ];
        this.$onChanges = ()=>{
            events = [].concat(events, this.events);
            $scope.preloader = true;
            _history.collection({
                params: {},
                endpoint: "event"
            }).then((answer)=>{
                if (answer.result.length > 0) $scope.collection = prepare(answer.result).filter((item)=>events.indexOf(item.type) >= 1);
            }, ()=>{}).finally(()=>{
                $scope.preloader = false;
            });
        };
        const subscription = _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>events.indexOf(item.event) >= 1)).subscribe((message)=>{
            $scope.collection.push({
                avatar: message.data.avatar || "nopic",
                level: message.data.level,
                login: message.data.login,
                type: message.event === "new_bonus" && message.data.bonus.type === "freespin" ? "new_freespin" : message.event,
                data: message.data.bonus || {},
                sum: message.data.sum || null,
                currency: message.data.currency || null,
                game: message.data.game || {}
            });
            if ($scope.collection.length >= 100) $scope.collection = $scope.collection.slice(-100);
        });
        $scope.$on("$destroy", ()=>{
            subscription.unsubscribe();
        });
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name),
        bindings: {
            events: "<"
        }
    });
})();


$ad76929d99f4abe8$exports = {
    "linda": {
        "widget": $c41d6875a0b09264$exports
    }
};


var $fbb011131e7f5c0f$exports = {};
var $0f22cf52e4875cff$exports = {};



(function() {
    "use strict";
    const component = {
        name: "lindaWithdrawalPaymentCallback"
    };
    controller.$inject = [
        "$scope",
        "$state",
        "$interval",
        "system$",
        "state",
        "config",
        "$window"
    ];
    function controller($scope, $state, $interval, _system$, _state, _config, $window) {
        let timerSeconds = 20;
        const webView = _config.browser.webView;
        $scope.timer = `00:${timerSeconds}`;
        $scope.action = $state.params.status;
        makeTimer();
        if (isOpenedInFrame()) {
            $window.parent.postMessage(`transaction-${$scope.action}`, "*");
            $scope.close = function() {
                $window.top.postMessage("close", "*");
            };
            $scope.openChat = function() {
                $window.top.postMessage("open-chat", "*");
            };
            return;
        }
        if (!isWebView() || isOpenedInWindow()) {
            $window.parent.postMessage(`transaction-${$scope.action}`, "*");
            $window.opener?.parent.postMessage({
                action: "transaction",
                status: $scope.action
            }, "*");
            $scope.close = function() {
                if ($window.opener && !$window.opener.closed && !webView) $window.opener.parent.postMessage("close", "*");
                else _state.goto("home");
            };
            $scope.openChat = function() {
                if ($window.opener && !$window.opener.closed && !webView) $window.opener.parent.postMessage("open-chat", "*");
                else _system$.next({
                    action: "open chat"
                });
            };
            return;
        }
        function makeTimer() {
            const timer = $interval(()=>{
                if (timerSeconds >= 0) {
                    const formattedTimeWithSeconds = timerSeconds.toString().padStart(2, "0");
                    $scope.timer = `00:${formattedTimeWithSeconds}`;
                    timerSeconds--;
                } else {
                    $interval.cancel(timer);
                    $scope.close();
                }
            }, 1000);
        }
        function isWebView() {
            return webView;
        }
        function isOpenedInWindow() {
            return $window.opener && !$window.opener.closed;
        }
        function isOpenedInFrame() {
            return $window.self !== $window.top;
        }
        $scope.close = function() {
            _state.goto("home");
        };
        $scope.openChat = function() {
            _system$.next({
                action: "open chat"
            });
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$fbb011131e7f5c0f$exports = {
    "linda": $0f22cf52e4875cff$exports
};


var $a42e3add2c5f19ed$exports = {};
var $153be03e805d9be2$exports = {};
(function() {
    "use strict";
    const component = {
        name: "lindaZimplerPaynplayLoginPopup"
    };
    controller.$inject = [
        "$scope"
    ];
    function controller($scope) {}
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$a42e3add2c5f19ed$exports = {
    "linda": {
        "zimpler": $153be03e805d9be2$exports
    }
};


var $19f710ceecd7a461$exports = {};
var $cd54bcf7ae0fa855$exports = {};









(function() {
    "use strict";
    const component = {
        name: "lindaZimplerPaynplayPage"
    };
    controller.$inject = [
        "$scope",
        "zimpler.paynplay",
        "config",
        "user",
        "state",
        "helper",
        "trustly$",
        "$timeout",
        "zimpler.config",
        "$window",
        "system$"
    ];
    function controller($scope, _zimpler_paynplay, _config, _user, _state, _helper, _trustly$, $timeout, _zimpler_config, $window, _system$) {
        let loginSubscription;
        const redirectToHomepage = ()=>_state.goto("home");
        if (_zimpler_paynplay.isDefaultJurisdiction) {
            if (_user.status || !_zimpler_config.enabled) {
                redirectToHomepage();
                return;
            }
            loginSubscription = _system$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "login")).subscribe(redirectToHomepage);
        }
        $scope.amount = _zimpler_paynplay.data.amount;
        $scope.step = _zimpler_paynplay.data.step;
        $scope.flow = _zimpler_paynplay.isDefaultJurisdiction ? "resume_play" : _zimpler_paynplay.data.flow;
        $scope.paysystem = _zimpler_config;
        let subscription;
        $scope.submit = _helper.form.validator((form)=>{
            if ($scope.amount > 0) {
                _zimpler_paynplay.data.amount = $scope.amount;
                _zimpler_paynplay.data.step = 1;
            }
        });
        function handler(event) {
            if (event.origin !== "https://trustly.com") return;
            const data = JSON.parse(event.data);
            if (data.method === "OPEN_APP") $window.location.assign(data.appURL);
        }
        this.$onInit = ()=>{
            subscription = _trustly$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.action === "step")).subscribe((item)=>{
                $timeout(()=>{
                    if (item.data === -1) {
                        redirectToHomepage();
                        return;
                    }
                    $scope.step = item.data;
                });
            });
            $window.addEventListener("message", handler, false);
        };
        this.$onDestroy = ()=>{
            _zimpler_paynplay.data.reset();
            subscription?.unsubscribe();
            loginSubscription?.unsubscribe();
            $window.removeEventListener("message", handler, false);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$19f710ceecd7a461$exports = {
    "linda": {
        "zimpler": $cd54bcf7ae0fa855$exports
    }
};


var $834d5fdfa3138c23$exports = {};
var $524cecffcda37353$exports = {};








const $55440e89a5e29d1a$var$otpVerificationApi = "otpVerificationApi";
class $55440e89a5e29d1a$var$Api {
    static $inject = [
        "http"
    ];
    constructor(http){
        this.http = http;
    }
    sendSms(data) {
        return this.http.postData("otpSmsVerify", null, data);
    }
    sendCode(data) {
        return this.http.postData("otpVerifyCode", null, data);
    }
}
app.factory($55440e89a5e29d1a$var$otpVerificationApi, $55440e89a5e29d1a$var$Api);



const $0f2bff0e03c3718a$var$otpVerification = "otpVerification";
class $0f2bff0e03c3718a$var$Verification {
    static $inject = [
        "otpVerificationApi"
    ];
    constructor(otpVerificationApi){
        this.otpVerificationApi = otpVerificationApi;
    }
    otpVerified$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
    phone_verification_hash = "";
    sendSms(phone) {
        return this.otpVerificationApi.sendSms({
            phone: phone
        }).then((answer)=>{
            this.phone_verification_hash = answer.result.phone_verification_hash;
            return answer;
        }).catch((error)=>{
            throw new Error();
        });
    }
    isOtpFlowNeeded(phoneHash) {
        return typeof phoneHash !== "undefined";
    }
    sendCode(code) {
        const optVerificationData = {
            otp_code: code,
            phone_verification_hash: this.phone_verification_hash
        };
        return this.otpVerificationApi.sendCode(optVerificationData);
    }
}
app.factory($0f2bff0e03c3718a$var$otpVerification, $0f2bff0e03c3718a$var$Verification);



(function() {
    "use strict";
    const component = {
        name: "lindaZimplerRegistrationModal"
    };
    controller.$inject = [
        "$scope",
        "modal",
        "helper",
        "contentBuffer",
        "zimpler.paynplay",
        "system",
        "registration",
        "p161",
        "otpVerification"
    ];
    function controller($scope, _modal, _helper, _contentBuffer, _zimpler_paynplay, _system, _registration, _p161, otpVerification) {
        const vm = this;
        const params = _contentBuffer.read("modal");
        $scope.hide_bonuses = params.is_registration_bonuses_shown;
        $scope.person = params.profile;
        $scope.showOtp = otpVerification.isOtpFlowNeeded($scope.person.phone_verification_hash);
        $scope.delay = 0;
        $scope.preloader = false;
        $scope.formField = {
            name: {
                disabled: Boolean($scope.person.name)
            },
            surname: {
                disabled: Boolean($scope.person.surname)
            },
            email: {
                disabled: Boolean($scope.person.email)
            },
            phone: {
                disabled: Boolean($scope.person.phone)
            },
            city: {
                disabled: Boolean($scope.person.city)
            },
            postcode: {
                disabled: Boolean($scope.person.postcode)
            },
            address: {
                disabled: Boolean($scope.person.address)
            },
            gender: {
                disabled: Boolean($scope.person.gender)
            },
            birthday: {
                disabled: Boolean($scope.person.birthday)
            }
        };
        $scope.formData = {
            name: $scope.person.name,
            surname: $scope.person.surname,
            email: $scope.person.email,
            phone: $scope.person.phone,
            city: $scope.person.city,
            postcode: $scope.person.postcode,
            address: $scope.person.address,
            gender: $scope.person.gender || "M",
            pep: false,
            gdpr_data: false,
            accept: false,
            gdpr_marketing: false,
            birthday: $scope.person.birthday,
            enable_trigger_codes: true
        };
        vm.$onInit = ()=>{
            preparePhoneField();
            _registration.addPromotionsToScope($scope);
            _registration.addAvatarsToScope($scope);
        };
        $scope.registrationStep = "firstStep";
        $scope.setStep = (step)=>{
            $scope.registrationStep = step;
        };
        $scope.sendSms = (phone)=>{
            $scope.preloader = true;
            otpVerification.sendSms(phone).then(({ result: result })=>{
                $scope.inputsCount = result.otp_code_size;
                if (!result.frozen_reason) {
                    $scope.delay = result.next_attempt_delay * 1000;
                    $scope.setStep("otpValidation");
                    return;
                }
                if (result.frozen_reason === 6351) $scope.inputsDisabled = true;
                $scope.delay = new Date(result.frozen_to).getTime() - new Date().getTime();
                $scope.setStep("otpValidation");
            }).finally(()=>{
                $scope.preloader = false;
            });
        };
        const subscription = otpVerification.otpVerified$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "codeVerified")).subscribe(({ data: data })=>{
            submitVerificationData(data.phone_verification_hash);
        });
        const subscriptionOnInputs = otpVerification.otpVerified$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "inputsAvailable")).subscribe(()=>{
            $scope.inputsDisabled = false;
        });
        const subscriptionVerification = otpVerification.otpVerified$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "verificationBlocked")).subscribe(({ data: data })=>{
            $scope.delay = new Date(data.frozen_to).getTime() - new Date().getTime();
            $scope.inputsDisabled = true;
        });
        $scope.timerCallback = ()=>{
            $scope.delay = 0;
            $scope.inputsDisabled = false;
        };
        function submitVerificationData(phone_verification_hash) {
            $scope.preloader = true;
            if (phone_verification_hash) Object.assign($scope.formData, {
                phone_verification_hash: phone_verification_hash
            });
            if ($scope.formData.enable_trigger_codes !== true || $scope.hide_bonuses) delete $scope.formData.trigger_codes;
            delete $scope.formData.enable_trigger_codes;
            _zimpler_paynplay.auth($scope.formData).then(()=>{
                _p161.track("registration");
                _modal.answer = true;
            }).catch(()=>{
                if ($scope.formData.trigger_codes) $scope.formData.enable_trigger_codes = true;
            }).finally(()=>{
                $scope.preloader = false;
                otpVerification.otpVerified$.next({
                    event: "preloader",
                    data: {
                        status: false
                    }
                });
            });
        }
        $scope.submit = _helper.form.validator((form)=>{
            submitVerificationData();
        });
        const preparePhoneField = ()=>{
            $scope.preloader = true;
            _system.countries().then((a)=>{
                const country = a.result.filter((item)=>item.code === a.default)[0] || {};
                if (!$scope.formData.phone && angular.isString(country.prefix)) $scope.formData.phone = `+${parseInt(country.prefix.replace(/\-/g, ""), 10)}`;
            }).catch((err)=>console.error(err)).finally(()=>$scope.preloader = false);
        };
        vm.$onDestroy = ()=>{
            subscription.unsubscribe();
            subscriptionOnInputs.unsubscribe();
            subscriptionVerification.unsubscribe();
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$834d5fdfa3138c23$exports = {
    "linda": {
        "zimpler": $524cecffcda37353$exports
    }
};


var $c2bae2bc590428cc$exports = {};
var $ca3801d7adbb1272$exports = {};
(function() {
    "use strict";
    const component = {
        name: "notFound"
    };
    function controller() {
        const seoPrerenderMeta = document.createElement("meta");
        seoPrerenderMeta.setAttribute("name", "prerender-status-code");
        seoPrerenderMeta.setAttribute("content", "404");
        this.$onInit = ()=>{
            document.head.appendChild(seoPrerenderMeta);
        };
        this.$onDestroy = ()=>{
            if (seoPrerenderMeta.parentNode instanceof Node) seoPrerenderMeta.parentNode.removeChild(seoPrerenderMeta);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$c2bae2bc590428cc$exports = {
    "v1": $ca3801d7adbb1272$exports
};


var $72fd724b8d713d01$exports = {};
$72fd724b8d713d01$exports = {};


var $82fb23863d138bcb$exports = {};
$82fb23863d138bcb$exports = {};


var $c3573bc8e0f7a142$exports = {};
$c3573bc8e0f7a142$exports = {};


var $e1021ecb968bb6fe$exports = {};
$e1021ecb968bb6fe$exports = {};


var $70fa5e0372d062bd$exports = {};
$70fa5e0372d062bd$exports = {};


var $16ed35aa07365d36$exports = {};
var $37c63f1a270207b8$exports = {};
(function() {
    controller.$inject = [
        "$scope",
        "holiday"
    ];
    function controller($scope, _holiday) {
        const subscription = _holiday.selectedBonus$.subscribe((bonus)=>{
            $scope.isTaken = bonus.isTaken;
        });
        $scope.takeBonus = (id, type)=>{
            _holiday.saveTakenBonus(id, type);
        };
        this.$onDestroy = function() {
            subscription.unsubscribe();
        };
    }
    new Controller("holidaysPopup", controller, {});
})();
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanHolidaysPopup${i}`, "holidaysPopup");
    });
})();


(function() {
    new Batman(`descEasterPromoPopup`, "holidaysPopup");
})();


$16ed35aa07365d36$exports = {
    "promo-easter": $37c63f1a270207b8$exports
};


var $234fa895a82e72ac$exports = {};
var $6e7b44cc37556b14$exports = {};




const $4f63628fa098e49f$export$8fb6e67ccc22ce48 = "verificationAlert";
class $4f63628fa098e49f$var$VerificationAlert {
    static $inject = [
        "system$",
        "verificationInfo$",
        "user",
        "localStorage"
    ];
    constructor(_system$, _verificationInfo$, _user, localStorage){
        this.system$ = _system$;
        this.verificationInfo$ = _verificationInfo$;
        this.user = _user;
        this.localStorage = localStorage;
    }
    shouldShowVerifiedAlert(verificationStatus, alertParams) {
        return verificationStatus === "VERIFIED" && this.localStorage.get(alertParams.localStorageKey);
    }
    updateActiveAlert(verificationStatus, hasOptionalSurvey, alertParams) {
        if (verificationStatus === "REQUIRES_VERIFICATION") {
            this.localStorage.set(alertParams.localStorageKey, true);
            return verificationStatus;
        }
        if (hasOptionalSurvey) return "SURVEY";
        if (this.shouldShowVerifiedAlert(verificationStatus, alertParams)) return verificationStatus;
        return null;
    }
    getActiveAlert(alertParams) {
        const verificationStatus = this.user.profile?.verificationStatus;
        const hasOptionalSurvey = this.user.profile?.surveys_status?.has_optional;
        return this.activeAlert = this.updateActiveAlert(verificationStatus, hasOptionalSurvey, alertParams);
    }
}
app.service($4f63628fa098e49f$export$8fb6e67ccc22ce48, $4f63628fa098e49f$var$VerificationAlert);








const $6e7b44cc37556b14$var$componentName = "dvsAlert";
class $6e7b44cc37556b14$var$DvsAlert {
    static $inject = [
        "$scope",
        "verificationAlert",
        "$document",
        "$element",
        "system$",
        "verificationInfo$",
        "user",
        "localStorage"
    ];
    constructor($scope, verificationAlert, $document, $element, _system$, _verificationInfo$, _user, _localStorage){
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const PARAMS = {
            localStorageKey: "show-verification-bar",
            bodyHasNotificationClass: "has-dvs-verification"
        };
        const bodyClassList = $document[0].body.classList;
        this.$onChanges = ()=>{
            changeStatus();
        };
        function changeStatus() {
            bodyClassList.remove(PARAMS.bodyHasNotificationClass);
            $scope.activeAlert = verificationAlert.getActiveAlert(PARAMS);
            $scope.isVerificationBlocked = !!_user.profile.groups?.length;
            if ($scope.activeAlert === "REQUIRES_VERIFICATION" || $scope.activeAlert === "VERIFIED") bodyClassList.add(PARAMS.bodyHasNotificationClass);
        }
        $scope.close = ()=>{
            bodyClassList.remove(PARAMS.bodyHasNotificationClass);
            _localStorage.remove(PARAMS.localStorageKey);
            $element.remove();
        };
        changeStatus();
        _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "statusChanged")).subscribe(changeStatus);
        _verificationInfo$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "verificationStatusUpdated")).subscribe(changeStatus);
        $scope.$onDestroy = ()=>{
            destroy$.next();
            destroy$.unsubscribe();
        };
    }
}
app.component($6e7b44cc37556b14$var$componentName, {
    controller: $6e7b44cc37556b14$var$DvsAlert,
    bindings: {
        localStorageKey: "<",
        bodyHasNotificationClass: "<"
    },
    template: app.getTU($6e7b44cc37556b14$var$componentName)
});


$234fa895a82e72ac$exports = {
    "dvs": $6e7b44cc37556b14$exports
};


var $a9da3c840357b230$exports = {};
var $f745057d1cceb8c2$exports = {};

(function() {
    controller.$inject = [
        "$scope",
        "verificationInfo$",
        "$timeout"
    ];
    function controller($scope, _verificationInfo$, $timeout) {
        $scope.item = {};
        $scope.itemid = null;
        $scope.itemError = false;
        $scope.documentInfo = {
            size: null,
            type: ""
        };
        const byteInKb = 1024;
        const byteInMb = Math.pow(byteInKb, 2);
        $scope.remove = ()=>{
            _verificationInfo$.next({
                event: "removeItem",
                data: $scope.itemid
            });
        };
        const checkFileSize = (sizeInBite)=>{
            if (sizeInBite >= byteInMb) {
                $scope.documentInfo.size = (sizeInBite / byteInMb).toFixed(1);
                $scope.documentInfo.type = "mb";
                return;
            }
            if (sizeInBite >= byteInKb) {
                $scope.documentInfo.size = (sizeInBite / byteInKb).toFixed(1);
                $scope.documentInfo.type = "kb";
                return;
            }
            $scope.documentInfo.size = sizeInBite;
            $scope.documentInfo.type = "b";
        };
        this.$onChanges = ()=>{
            $scope.item = this.item;
            checkFileSize(this.item.size);
            $scope.itemid = this.itemid;
            $scope.itemError = Object.keys(this.item.errors).length !== 0;
        };
    }
    new Controller("documentVerificationItem", controller, {
        item: "<",
        itemid: "<"
    });
})();


(function() {
    new Batman("dvsItem", "documentVerificationItem");
})();


$a9da3c840357b230$exports = {
    "dvs": $f745057d1cceb8c2$exports
};


var $77fa9236ed24c113$exports = {};
var $c1bb14bf1570329a$exports = {};






(function() {
    controller.$inject = [
        "$scope",
        "documentVerification",
        "popup",
        "verificationInfo$",
        "user",
        "postMessage$"
    ];
    function controller($scope, _documentVerification, _popup, _verificationInfo$, _user, _postMessage$) {
        $scope.preloader = false;
        $scope.documentList = [];
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        this.$onInit = ()=>{
            getStartedParams();
        };
        const subscription1 = _verificationInfo$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "onfidoResult")).subscribe((info)=>{
            callAboutResult(info.data);
        });
        const subscription2 = _verificationInfo$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "moveStatus")).subscribe((item)=>{
            moveStatus(item.data);
        });
        const subscriptionPreloader = _documentVerification.preloader$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((answer)=>answer.message === "onfidoPreloader")).subscribe((answer)=>{
            $scope.preloader = answer.preloader;
        });
        const documentList$ = _documentVerification.documentList$.subscribe((answer)=>{
            $scope.documentList = answer;
        });
        // to do: remove method 'verifyDocuments' after changing method to 'verify' on all projects
        $scope.verifyDocuments = (requestedDocumentId, verificationProvider, documentType, iframeUrl)=>{
            _documentVerification.selectVerificationFlow({
                requestedDocumentId: requestedDocumentId,
                verificationProvider: verificationProvider,
                documentType: documentType,
                iframeUrl: iframeUrl
            });
        };
        $scope.verify = (document)=>{
            _documentVerification.selectVerificationFlow(document);
        };
        _postMessage$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$)).subscribe((event)=>{
            try {
                const parsedData = JSON.parse(event);
                _documentVerification.handleEventByStatus(parsedData);
            } catch (error) {
                console.warn("Not Kreditz event", error);
            }
        });
        const moveStatus = (documentId)=>{
            $scope.documentList.forEach((item)=>{
                if (item.requestedDocumentId === documentId) return item.status = "PENDING";
                return;
            });
        };
        const callAboutResult = (data)=>{
            $scope.preloader = true;
            _documentVerification.setDocuments.upload.done(data).then(()=>{
                moveStatus(data.requestedDocumentId);
                $scope.preloader = false;
            });
        };
        const getStartedParams = ()=>{
            $scope.preloader = true;
            if (!_user.profile.verificationStatus) {
                $scope.preloader = false;
                return;
            }
            _documentVerification.getDocuments.list().then((answer)=>{
                $scope.documentList = answer.result;
            }).then(()=>{
                $scope.preloader = false;
            });
        };
        this.$onDestroy = ()=>{
            subscription1.unsubscribe();
            subscription2.unsubscribe();
            subscriptionPreloader.unsubscribe();
            documentList$.unsubscribe();
            destroy$.unsubscribe();
        };
    }
    new Controller("documentVerificationPage", controller);
})();


(function() {
    new Batman("dvsPage", "documentVerificationPage");
})();


$77fa9236ed24c113$exports = {
    "dvs": $c1bb14bf1570329a$exports
};


var $a8f2a3dfb59f4d49$exports = {};
var $4d16cb28b462e433$exports = {};



(function() {
    "use strict";
    controller.$inject = [
        "$scope",
        "documentVerification",
        "verificationInfo$",
        "kreditzAnalytics"
    ];
    function controller($scope, _documentVerification, _verificationInfo$, kreditzAnalytics) {
        $scope.files = [];
        $scope.preloader = false;
        $scope.disabledForm = false;
        $scope.success = false;
        $scope.errors = {};
        const fileTypes = [
            "image/png",
            "image/jpeg",
            "application/pdf"
        ];
        const maxFileSize = 5242880; // 5Mb
        const maxTotalFilesSize = 10485760; // 10Mb
        const maxFilesNumber = 5;
        $scope.addFiles = (files)=>{
            if ($scope.success) return;
            if (files?.length) {
                $scope.files.push(...files);
                $scope.$evalAsync();
                validateFiles();
            }
        };
        const validateFiles = ()=>{
            clearErrors();
            if (!isFilesNumberValid()) Object.assign($scope.errors, {
                filesNumberOverflow: true
            });
            if (!isTotalFilesSizeValid()) Object.assign($scope.errors, {
                filesSizeOverflow: true
            });
            $scope.files.forEach((file, index)=>validateFile(file, index));
            $scope.disabledForm = !areFilesValid();
        };
        const validateFile = (file, index)=>{
            if (!isFileTypeValid(file)) Object.assign(file.errors, {
                extension: true
            });
            if (!isFileSizeValid(file)) Object.assign(file.errors, {
                size: true
            });
            if (!isFileUnique(file)) Object.assign(file.errors, {
                duplicate: true
            });
            if (index + 1 > maxFilesNumber) Object.assign(file.errors, {
                filelistsize: true
            });
        };
        const clearErrors = ()=>{
            $scope.errors = {};
            $scope.files.forEach((file)=>file.errors = {});
        };
        const areFilesValid = ()=>{
            return Object.keys($scope.errors).length === 0 && $scope.files.every((file)=>Object.keys(file.errors).length === 0);
        };
        const isFilesNumberValid = ()=>{
            return maxFilesNumber >= $scope.files.length;
        };
        const isTotalFilesSizeValid = ()=>{
            return maxTotalFilesSize >= $scope.files.reduce((totalFilesSize, file)=>totalFilesSize + file.size, 0);
        };
        const isFileSizeValid = (file)=>{
            return maxFileSize >= file.size;
        };
        const isFileUnique = (currentFile)=>{
            return $scope.files.filter((file)=>currentFile.size === file.size && currentFile.name === file.name).length <= 1;
        };
        const isFileTypeValid = (file)=>{
            return fileTypes.includes(file.type);
        };
        const subscribe = _verificationInfo$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "removeItem")).subscribe((item)=>{
            removeFile(item.data);
            validateFiles();
        });
        const removeFile = (index)=>{
            $scope.files.splice(index, 1);
        };
        $scope.sendData = (id)=>{
            $scope.preloader = true;
            _documentVerification.setDocuments.upload.file($scope.files, id).then((answer)=>{
                if (answer === "true") {
                    $scope.success = true;
                    _verificationInfo$.next({
                        event: "moveStatus",
                        data: id
                    });
                }
            }).catch((error)=>{
                Object.assign($scope.errors, {
                    unknownError: true
                });
            }).finally(function() {
                $scope.preloader = false;
            });
        };
        $scope.$on("updateFile", function(event, data) {
            $scope.addFiles(data);
            $scope.$evalAsync();
        });
        $scope.onPopupClosed = (hasProviderKreditz)=>{
            if (hasProviderKreditz) kreditzAnalytics.onCloseButtonClicked();
        };
        this.$onChanges = ()=>{
            $scope.addFiles(this.files);
        };
        this.$onDestroy = ()=>{
            subscribe.unsubscribe();
        };
    }
    new Controller("documentVerificationPopup", controller, {
        files: "<"
    });
})();


(function() {
    new Batman("dvsPopup", "documentVerificationPopup");
})();


$a8f2a3dfb59f4d49$exports = {
    "dvs": $4d16cb28b462e433$exports
};


var $376dc8dee175f0a2$exports = {};
var $fbe1d182e19806d2$exports = {};

(function() {
    new Batman(`easterCountdown`, "countdown");
})();


$376dc8dee175f0a2$exports = {
    "promo-easter": $fbe1d182e19806d2$exports
};


var $56bfdc245f8ea688$exports = {};
var $869766cc204ba2be$exports = {};

(function() {
    new Batman(`easterPromo`, "holidaysCalendar");
})();


$56bfdc245f8ea688$exports = {
    "promo-easter": $869766cc204ba2be$exports
};


var $cb84da11a03355d9$exports = {};
var $c8554ba600c40d95$exports = {};

(function() {
    new Batman(`easterPromoMobile`, "holidaysCalendar");
})();


$cb84da11a03355d9$exports = {
    "promo-easter": $c8554ba600c40d95$exports
};


var $8dde195ecb17aad8$exports = {};
var $68b0cc224eeed0fb$exports = {};

(function() {
    new Batman(`easterPromoPopup`, "holidaysPopup");
})();


$8dde195ecb17aad8$exports = {
    "promo-easter": $68b0cc224eeed0fb$exports
};


var $ac6ffd7cacd327f2$exports = {};
var $623df7b272838ebb$exports = {};

const $623df7b272838ebb$var$componentName = "footerDefault";
class $623df7b272838ebb$var$Footer {
    static $inject = [];
    constructor($scope){}
}
app.component($623df7b272838ebb$var$componentName, {
    controller: $623df7b272838ebb$var$Footer,
    template: app.getTU($623df7b272838ebb$var$componentName)
});


$ac6ffd7cacd327f2$exports = {
    "template": $623df7b272838ebb$exports
};


var $d45ee19da87048cc$exports = {};
$d45ee19da87048cc$exports = {};


var $f4ccdf55e5358446$exports = {};
$f4ccdf55e5358446$exports = {};


var $cb3da4e84b793314$exports = {};
$cb3da4e84b793314$exports = {};


var $4e529722f14fdd4f$exports = {};
$4e529722f14fdd4f$exports = {};


var $fc2a7bdee530a921$exports = {};
var $02fcb2fda839fd13$exports = {};


(function() {
    const component = {
        name: "lindaOtpComponents"
    };
    class Otp {
        static $inject = [
            "$scope",
            "$timeout",
            "$document",
            "otpVerification"
        ];
        constructor($scope, $timeout, $document, otpVerification){
            const keys = {
                tab: "Tab",
                backSpace: "Backspace",
                letterV: "KeyV",
                space: "Space"
            };
            $scope.onPaste = function(index, event) {
                event.preventDefault();
                if (index !== 0) return;
                const pasteData = event.clipboardData?.getData("text");
                if (!pasteData || isNaN(+pasteData) || pasteData.length !== $scope.size) return;
                $scope.inputs = pasteData.split("");
                $document[0].getElementById("otp-input-" + ($scope.inputs.length - 1)).focus();
            };
            const focusCurrentInput = (inputIndex)=>{
                const currentInput = $document[0].getElementById(`otp-input-${inputIndex}`);
                currentInput.focus();
            };
            const checkOnBackSpace = (eventKey)=>{
                return eventKey === "Backspace" || eventKey === "Delete";
            };
            $scope.onKeyUp = (index, event)=>{
                const isDigit = !isNaN(+event.key);
                if (checkOnBackSpace(event.key) && index - 1 >= 0) {
                    $scope.inputs[index] = "";
                    focusCurrentInput(index - 1);
                    return;
                }
                if (!isDigit && event.key === "Unidentified") {
                    $scope.inputs[index] = "";
                    return;
                }
                if (isDigit) {
                    $scope.inputs[index] = event.key;
                    if (index + 1 <= $scope.size - 1) focusCurrentInput(index + 1);
                }
            };
            const handlePasteEvent = (code, metaKey, windowsCtrl)=>{
                return code === keys.letterV && metaKey || code === keys.letterV && windowsCtrl;
            };
            $scope.onKeyDown = function(index, event) {
                const { code: code, metaKey: metaKey, key: key } = event;
                const isDigit = !isNaN(+key);
                if (checkOnBackSpace(key) || handlePasteEvent(code, metaKey, event.ctrlKey)) return;
                if (!isDigit) {
                    focusCurrentInput(index);
                    event.preventDefault();
                }
            };
            this.$onInit = function() {
                $timeout(()=>{
                    focusCurrentInput(0);
                });
            };
            this.$onChanges = function() {
                $scope.size = this.size;
                $scope.inputsDisabled = this.inputsDisabled;
                $scope.inputs = new Array($scope.size).fill("");
            };
            const subscription = otpVerification.otpVerified$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)((item)=>item.event === "preloader")).subscribe(({ data: data })=>{
                $scope.preloader = data.status;
            });
            $scope.$watchCollection("inputs", function(newValue) {
                const otpInputValue = newValue.join("");
                if (otpInputValue.length === $scope.size) {
                    $scope.preloader = true;
                    otpVerification.sendCode(otpInputValue).then(({ result: result })=>{
                        otpVerification.otpVerified$.next({
                            event: "codeVerified",
                            data: result
                        });
                    }).catch((error)=>{
                        if (error.messages[0].code === 6347) $scope.showInvalidOtpError = true;
                        if (error.messages[0].code === 6351) {
                            otpVerification.otpVerified$.next({
                                event: "verificationBlocked",
                                data: error.messages[0].data
                            });
                            $scope.showBlockedOtpError = true;
                            $scope.showInvalidOtpError = false;
                        }
                        $scope.preloader = false;
                    });
                }
            });
            this.$onDestroy = ()=>{
                otpVerification.otpVerified$.next({
                    event: "inputsAvailable"
                });
                subscription.unsubscribe();
            };
        }
    }
    app.component(component.name, {
        controller: Otp,
        template: app.getTU(component.name),
        bindings: {
            size: "<",
            inputsDisabled: "<"
        }
    });
})();


$fc2a7bdee530a921$exports = {
    "linda": $02fcb2fda839fd13$exports
};


var $65fd3cd1ce21fa05$exports = {};
var $f75f9931c68d57f5$exports = {};


(function() {
    "use strict";
    const component = {
        name: "lindaPromoWrapper"
    };
    controller.$inject = [
        "$scope",
        "$state",
        "holiday",
        "config",
        "$element",
        "$compile"
    ];
    function controller($scope, $state, _holiday, _config, $element, $compile) {
        const componentName = "";
        $scope.name = null;
        this.$onInit = ()=>{
            $scope.name = $state.params.name;
            const componentName = `${$scope.name}-promo${_config.mobile ? "-mobile" : ""}`;
            const el = document.createElement(componentName);
            const compileEl = $compile(el)($scope)[0];
            $element[0].appendChild(compileEl);
        };
    }
    app.component(component.name, {
        controller: controller,
        template: app.getTU(component.name)
    });
})();


$65fd3cd1ce21fa05$exports = {
    "linda": $f75f9931c68d57f5$exports
};


var $be336b65bdcfa1df$exports = {};
$be336b65bdcfa1df$exports = {};


var $4120606852d9cd76$exports = {};
$4120606852d9cd76$exports = {};


var $2ed07de8d86ff3ca$exports = {};
$2ed07de8d86ff3ca$exports = {};


var $267f1def92e8feb0$exports = {};
$267f1def92e8feb0$exports = {};


var $203b18dca145936d$exports = {};
$203b18dca145936d$exports = {};


var $b8899f070bc9e2af$exports = {};
$b8899f070bc9e2af$exports = {};


var $6c55203ea4356c08$exports = {};
$6c55203ea4356c08$exports = {};


var $498ca1cedad71107$exports = {};
$498ca1cedad71107$exports = {};


var $0209b3e565a9f128$exports = {};
$0209b3e565a9f128$exports = {};


var $b4bfe9697ade8709$exports = {};
$b4bfe9697ade8709$exports = {};


var $1bc7dc79007a15f9$exports = {};
$1bc7dc79007a15f9$exports = {};


var $310183d12b373a43$exports = {};
$310183d12b373a43$exports = {};


var $b083365a31175e14$exports = {};
$b083365a31175e14$exports = {};


var $7ec2633868cd2e1c$exports = {};
$7ec2633868cd2e1c$exports = {};


var $5142ba05b790733a$exports = {};
$5142ba05b790733a$exports = {};


var $5097b3da16d20ca4$exports = {};
$5097b3da16d20ca4$exports = {};


var $8aac3c2ffbfff2cd$exports = {};
$8aac3c2ffbfff2cd$exports = {};


var $34710106212130b6$exports = {};
$34710106212130b6$exports = {};


var $6da04c35d29594be$exports = {};
var $4a01725d9a0b0103$exports = {};




const $4a01725d9a0b0103$var$componentName = "surveyAlert";
class $4a01725d9a0b0103$var$SurveyAlert {
    static $inject = [
        "$scope",
        "$document",
        "verificationAlert",
        "system$"
    ];
    constructor($scope, $document, verificationAlert, _system$){
        const destroy$ = new (0, $19fbb7818f827ed3$export$b6bbab5a9b109038)();
        const PARAMS = {
            localStorageKey: "show-verification-bar",
            bodyHasNotificationClass: "has-survey"
        };
        function changeStatus() {
            const bodyClassList = $document[0].body.classList;
            $scope.activeAlert = verificationAlert.getActiveAlert(PARAMS);
            bodyClassList.remove(PARAMS.bodyHasNotificationClass);
            if (hasActiveAlert()) {
                bodyClassList.add(PARAMS.bodyHasNotificationClass);
                $scope.activeAlert = "SURVEY";
            }
        }
        function hasActiveAlert() {
            return verificationAlert.getActiveAlert(PARAMS) === "SURVEY";
        }
        changeStatus();
        _system$.pipe((0, $14a4cad30b3540d6$export$ac8dfd3a7ad06e80)(destroy$), (0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ action: action })=>action === "statusChanged")).subscribe(changeStatus);
        $scope.$onDestroy = ()=>{
            destroy$.next();
            destroy$.unsubscribe();
        };
    }
}
app.component($4a01725d9a0b0103$var$componentName, {
    controller: $4a01725d9a0b0103$var$SurveyAlert,
    template: app.getTU($4a01725d9a0b0103$var$componentName)
});


$6da04c35d29594be$exports = {
    "survey": $4a01725d9a0b0103$exports
};


var $0f9e6e61c3d3bbc8$exports = {};
var $a6911d3c9665a874$exports = {};






class $f712aa874c36e2e1$var$SurveyList {
    static $inject = [
        "$scope",
        "survey",
        "missedData",
        "state",
        "ws$",
        "wsEvents"
    ];
    constructor($scope, _survey, missedData, _state, _ws$, _wsEvents){
        this.missedData = missedData;
        this.state = _state;
        const getSurveyCollection = ()=>{
            $scope.collection = [];
            $scope.preloader = true;
            _survey.getList().then((answer)=>{
                $scope.collection = answer;
            }).finally(()=>{
                $scope.preloader = false;
            });
        };
        this.$onChanges = ()=>getSurveyCollection();
        _ws$.pipe((0, $312ba4d39eb49e75$export$3dea766d36a8935f)(({ event: event })=>event === _wsEvents.surveyUpdated)).subscribe(()=>{
            getSurveyCollection();
        });
    }
}
new Controller("surveyList", $f712aa874c36e2e1$var$SurveyList, {});
(function() {
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].forEach((i)=>{
        new Batman(`batmanSurveyList${i}`, "surveyList");
    });
})();


(function() {
    new Batman("surveyList", "surveyList");
})();


$0f9e6e61c3d3bbc8$exports = {
    "survey": $a6911d3c9665a874$exports
};


var $6df5f0620abbc845$exports = {};
$6df5f0620abbc845$exports = {};


var $34e73caa80239f27$exports = {};
$34e73caa80239f27$exports = {};


var $f1b5c06bac697135$exports = {};
$f1b5c06bac697135$exports = {};


var $7b0aab4da7137761$exports = {};
$7b0aab4da7137761$exports = {};


var $510f51f7ef7b6ad2$exports = {};
$510f51f7ef7b6ad2$exports = {};


var $6fcbf0f9a0f3e644$exports = {};
$6fcbf0f9a0f3e644$exports = {};


var $f041ae19a1ea738e$exports = {};
$f041ae19a1ea738e$exports = {};


var $270f2f8c5da6fa3a$exports = {};
$270f2f8c5da6fa3a$exports = {};


var $672665dbdf71a49a$exports = {};
$672665dbdf71a49a$exports = {};


var $ea0d04bfae8743bc$exports = {};
$ea0d04bfae8743bc$exports = {};





//# sourceMappingURL=index.1222d9bd.js.map
